/*!
 *
 * Bryntum TaskBoard 4.3.6
 *
 * Copyright(c) 2022 Bryntum AB
 * https://bryntum.com/contact
 * https://bryntum.com/license
 *
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("taskboard", [], factory);
	else if(typeof exports === 'object')
		exports["taskboard"] = factory();
	else
		root["bryntum"] = root["bryntum"] || {}, root["bryntum"]["taskboard"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./webpack/webpack.entry.umd.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "../node_modules/process/browser.js":
/*!******************************************!*\
  !*** ../node_modules/process/browser.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "../node_modules/webpack/buildin/global.js":
/*!*************************************************!*\
  !*** ../node_modules/webpack/buildin/global.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./lib/ChronoGraph/class/Base.js":
/*!***************************************!*\
  !*** ./lib/ChronoGraph/class/Base.js ***!
  \***************************************/
/*! exports provided: Base */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Base", function() { return Base; });
var productName = 'taskboard'; //---------------------------------------------------------------------------------------------------------------------

/**
 * This is a base class, providing the type-safe static constructor [[new]]. This is very convenient when using
 * [[Mixin|mixins]], as mixins can not have types in the constructors.
 */

class Base {
  /**
   * This method applies its 1st argument (if any) to the current instance using `Object.assign()`.
   *
   * Supposed to be overridden in the subclasses to customize the instance creation process.
   *
   * @param props
   */
  initialize(props) {
    props && Object.assign(this, props);
  }
  /**
   * This is a type-safe static constructor method, accepting a single argument, with the object, corresponding to the
   * class properties. It will generate a compilation error, if unknown property is provided.
   *
   * For example:
   *
   * ```ts
   * class MyClass extends Base {
   *     prop     : string
   * }
   *
   * const instance : MyClass = MyClass.new({ prop : 'prop', wrong : 11 })
   * ```
   *
   * will produce:
   *
   * ```plaintext
   * TS2345: Argument of type '{ prop: string; wrong: number; }' is not assignable to parameter of type 'Partial<MyClass>'.
   * Object literal may only specify known properties, and 'wrong' does not exist in type 'Partial<MyClass>'
   * ```
   *
   * The only thing this constructor does is create an instance and call the [[initialize]] method on it, forwarding
   * the first argument. The customization of instance is supposed to be performed in that method.
   *
   * @param props
   */


  static new(props) {
    const instance = new this();
    instance.initialize(props);
    return instance;
  }

}

/***/ }),

/***/ "./lib/ChronoGraph/class/BetterMixin.js":
/*!**********************************************!*\
  !*** ./lib/ChronoGraph/class/BetterMixin.js ***!
  \**********************************************/
/*! exports provided: identity, ZeroBaseClass, isInstanceOf, Mixin, MixinAny, Base */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["identity"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ZeroBaseClass", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["ZeroBaseClass"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isInstanceOf", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mixin", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MixinAny", function() { return _Mixin_js__WEBPACK_IMPORTED_MODULE_0__["MixinAny"]; });

/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Base.js */ "./lib/ChronoGraph/class/Base.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Base", function() { return _Base_js__WEBPACK_IMPORTED_MODULE_1__["Base"]; });

var productName = 'taskboard'; // backward compat




/***/ }),

/***/ "./lib/ChronoGraph/class/Mixin.js":
/*!****************************************!*\
  !*** ./lib/ChronoGraph/class/Mixin.js ***!
  \****************************************/
/*! exports provided: identity, ZeroBaseClass, isInstanceOf, Mixin, MixinAny */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return identity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZeroBaseClass", function() { return ZeroBaseClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInstanceOf", function() { return isInstanceOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mixin", function() { return Mixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MixinAny", function() { return MixinAny; });
/* harmony import */ var _collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");
var productName = 'taskboard';
 //---------------------------------------------------------------------------------------------------------------------

const MixinInstanceOfProperty = Symbol('MixinIdentity');
const MixinStateProperty = Symbol('MixinStateProperty'); //---------------------------------------------------------------------------------------------------------------------

class MixinWalkDepthState {
  constructor() {
    this.baseEl = undefined;
    this.sourceEl = undefined;
    this.$elementsByTopoLevel = undefined;
    this.$topoLevels = undefined;
    this.linearizedByTopoLevelsSource = Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["MI"])(this.linearizedByTopoLevels());
  }

  static new(props) {
    const me = new this();
    props && Object.assign(me, props);
    return me;
  }

  get topoLevels() {
    if (this.$topoLevels !== undefined) return this.$topoLevels;
    return this.$topoLevels = this.buildTopoLevels();
  }

  buildTopoLevels() {
    return Array.from(this.elementsByTopoLevel.keys()).sort((level1, level2) => level1 - level2);
  }

  get elementsByTopoLevel() {
    if (this.$elementsByTopoLevel !== undefined) return this.$elementsByTopoLevel;
    return this.$elementsByTopoLevel = this.buildElementsByTopoLevel();
  }

  getOrCreateLevel(map, topoLevel) {
    let elementsAtLevel = map.get(topoLevel);

    if (!elementsAtLevel) {
      elementsAtLevel = [];
      map.set(topoLevel, elementsAtLevel);
    }

    return elementsAtLevel;
  }

  buildElementsByTopoLevel() {
    let maxTopoLevel = 0;
    const baseElements = this.baseEl ? Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(this.baseEl.walkDepthState.elementsByTopoLevel.values()).concat().toSet() : new Set();
    const map = Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(this.sourceEl.requirements).map(mixin => mixin.walkDepthState.elementsByTopoLevel).concat().reduce((elementsByTopoLevel, [topoLevel, mixins]) => {
      if (topoLevel > maxTopoLevel) maxTopoLevel = topoLevel;
      this.getOrCreateLevel(elementsByTopoLevel, topoLevel).push(mixins);
      return elementsByTopoLevel;
    }, new Map());
    this.getOrCreateLevel(map, maxTopoLevel + 1).push([this.sourceEl]);
    return Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(map).map(([level, elements]) => {
      return [level, Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(elements).concat().uniqueOnly().filter(mixin => !baseElements.has(mixin)).sort((mixin1, mixin2) => mixin1.id - mixin2.id)];
    }).toMap();
  }

  *linearizedByTopoLevels() {
    yield* Object(_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(this.topoLevels).map(level => this.elementsByTopoLevel.get(level)).concat();
  }

} // Note: 65535 mixins only, because of the hashing function implementation (String.fromCharCode)


let MIXIN_ID = 1; //---------------------------------------------------------------------------------------------------------------------

const identity = a => class extends a {}; // export type IdentityMixin<Base extends object>         = < T extends AnyConstructor<Base>>(base : T) => T
//
// export const IdentityMixin             = <Base extends object>() : IdentityMixin<Base> => identity
//---------------------------------------------------------------------------------------------------------------------

class ZeroBaseClass {} //---------------------------------------------------------------------------------------------------------------------

class MixinState {
  constructor() {
    this.id = MIXIN_ID++;
    this.requirements = [];
    this.baseClass = ZeroBaseClass;
    this.identitySymbol = undefined;
    this.mixinLambda = identity;
    this.walkDepthState = undefined; // private $hash               : MixinHash             = ''

    this.$minimalClass = undefined;
    this.name = '';
  }

  static new(props) {
    const me = new this();
    props && Object.assign(me, props);
    me.walkDepthState = MixinWalkDepthState.new({
      sourceEl: me,
      baseEl: getMixinState(me.baseClass)
    }); //------------------

    const mixinLambda = me.mixinLambda;
    const symbol = me.identitySymbol = Symbol(mixinLambda.name);
    const mixinLambdaWrapper = Object.assign(function (base) {
      const extendedClass = mixinLambda(base);
      extendedClass.prototype[symbol] = true;
      return extendedClass;
    }, {
      [MixinInstanceOfProperty]: symbol,
      [MixinStateProperty]: me
    });
    Object.defineProperty(mixinLambdaWrapper, Symbol.hasInstance, {
      value: isInstanceOfStatic
    });
    me.mixinLambda = mixinLambdaWrapper;
    return me;
  }

  get minimalClass() {
    if (this.$minimalClass !== undefined) return this.$minimalClass;
    return this.$minimalClass = this.buildMinimalClass();
  } // get hash () : MixinHash {
  //     if (this.$hash !== '') return this.$hash
  //
  //     return this.$hash = this.buildHash()
  // }
  // buildHash () : MixinHash {
  //     return String.fromCharCode(...this.walkDepthState.linearizedByTopoLevelsSource.map(mixin => mixin.id))
  // }


  getBaseClassMixinId(baseClass) {
    const constructor = this.constructor;
    const mixinId = constructor.baseClassesIds.get(baseClass);
    if (mixinId !== undefined) return mixinId;
    const newId = MIXIN_ID++;
    constructor.baseClassesIds.set(baseClass, newId);
    return newId;
  }

  buildMinimalClass() {
    const self = this.constructor;
    let baseCls = this.baseClass;
    const minimalClassConstructor = this.walkDepthState.linearizedByTopoLevelsSource.reduce((acc, mixin) => {
      const {
        cls,
        hash
      } = acc;
      const nextHash = hash + String.fromCharCode(mixin.id);
      let wrapperCls = self.minimalClassesByLinearHash.get(nextHash);

      if (!wrapperCls) {
        wrapperCls = mixin.mixinLambda(cls);
        mixin.name = wrapperCls.name;
        self.minimalClassesByLinearHash.set(nextHash, wrapperCls);
      }

      acc.cls = wrapperCls;
      acc.hash = nextHash;
      return acc;
    }, {
      cls: baseCls,
      hash: String.fromCharCode(this.getBaseClassMixinId(baseCls))
    }).cls;
    const minimalClass = Object.assign(minimalClassConstructor, {
      [MixinInstanceOfProperty]: this.identitySymbol,
      [MixinStateProperty]: this,
      mix: this.mixinLambda,
      derive: base => Mixin([minimalClass, base], base => class extends base {}),
      $: this,
      toString: this.toString.bind(this)
    });
    Object.defineProperty(minimalClass, Symbol.hasInstance, {
      value: isInstanceOfStatic
    });
    return minimalClass;
  }

  toString() {
    return this.walkDepthState.linearizedByTopoLevelsSource.reduce((acc, mixin) => `${mixin.name}(${acc})`, this.baseClass.name);
  }

}

MixinState.minimalClassesByLinearHash = new Map();
MixinState.baseClassesIds = new Map(); //endregion type helpers
//---------------------------------------------------------------------------------------------------------------------

const isMixinClass = func => {
  return Object.getPrototypeOf(func.prototype).constructor.hasOwnProperty(MixinStateProperty);
};

const getMixinState = func => {
  return Object.getPrototypeOf(func.prototype).constructor[MixinStateProperty];
}; //---------------------------------------------------------------------------------------------------------------------


const mixin = (required, mixinLambda) => {
  let baseClass;

  if (required.length > 0) {
    const lastRequirement = required[required.length - 1]; // absence of `[ MixinStateProperty ]` indicates its a regular class and not a mixin class
    // avoid assigning ZeroBaseClass - it will be applied as default at the end

    if (!isMixinClass(lastRequirement) && lastRequirement !== ZeroBaseClass) baseClass = lastRequirement;
  }

  const requirements = [];
  required.forEach((requirement, index) => {
    const mixinState = requirement[MixinStateProperty];

    if (mixinState !== undefined) {
      const currentBaseClass = mixinState.baseClass; // ignore ZeroBaseClass - since those are compatible with any other base class

      if (currentBaseClass !== ZeroBaseClass) {
        if (baseClass) {
          // already found a base class from requirements earlier
          if (baseClass !== currentBaseClass) {
            const currentIsSub = currentBaseClass.prototype.isPrototypeOf(baseClass.prototype);
            const currentIsSuper = baseClass.prototype.isPrototypeOf(currentBaseClass.prototype);
            if (!currentIsSub && !currentIsSuper) throw new Error("Base class mismatch");
            baseClass = currentIsSuper ? currentBaseClass : baseClass;
          }
        } else // first base class from requirements
          baseClass = currentBaseClass;
      }

      requirements.push(mixinState);
    } else {
      if (index !== required.length - 1) throw new Error("Base class should be provided as the last element of the requirements array");
    }
  }); //------------------

  const mixinState = MixinState.new({
    requirements,
    mixinLambda: mixinLambda,
    baseClass: baseClass || ZeroBaseClass
  });
  return mixinState.minimalClass;
}; //---------------------------------------------------------------------------------------------------------------------
// this function works both with default mixin class and mixin application function
// it supplied internally as [Symbol.hasInstance] for the default mixin class and mixin application function


const isInstanceOfStatic = function (instance) {
  return Boolean(instance && instance[this[MixinInstanceOfProperty]]);
}; //---------------------------------------------------------------------------------------------------------------------

/**
 * This is the `instanceof` analog for the classes created with [[Mixin]] helper. It also provides [typeguard](https://www.typescriptlang.org/docs/handbook/advanced-types.html#user-defined-type-guards).
 *
 * There's no strict need to use it, as the native `instanceof` is also supported for the mixins created with the [[Mixin]] helper and also provides
 * typeguarding.
 *
 * @param instance Any value, normally an instance of the mixin class
 * @param func The constructor function of the class, created with [[Mixin]]
 */


const isInstanceOf = (instance, func) => {
  return Boolean(instance && instance[func[MixinInstanceOfProperty]]);
}; //---------------------------------------------------------------------------------------

/**
 * This function allows you to create mixin classes. Mixin classes solves the well-known problem with "classical" single-class inheritance,
 * in which class hierarchy must form a tree. When using mixins, class hierarchy becomes an arbitrary acyclic graph.
 *
 * Another view on mixins is that, if "classical" class is a point (a vertice of the graph), mixin class is an arrow between the points
 * (an edge in the graph, or rather, a description of the edge).
 *
 * Some background information about the mixin pattern can be found [here](https://mariusschulz.com/blog/typescript-2-2-mixin-classes)
 * and [here](https://www.bryntum.com/blog/the-mixin-pattern-in-typescript-all-you-need-to-know/).
 *
 * The pattern, being described here, is the evolution of the previous work, and main advantage is that it solves the compilation error
 * for circular references.
 *
 * Mixin definition. Requirements
 * ------------------------------
 *
 * The pattern looks like:
 *
 *     class Mixin1 extends Mixin(
 *         [],
 *         (base : AnyConstructor) =>
 *
 *         class Mixin1 extends base {
 *             prop1        : string
 *             method1 () : string {
 *                 return this.prop1
 *             }
 *             static static1 : number
 *         }
 *     ){}
 *
 * The core of the definition above is the mixin lambda - a function which receives a base class as its argument and returns a class,
 * extending the base class with additional properties.
 *
 * The example above creates a mixin `Mixin1` which has no requirements. Requirements are the other mixins,
 * which needs to be included in the base class of this mixin.
 *
 * There's also a special type of the requirement,
 * called "base class requirement". It is optional and can only appear as the last argument of the requirements
 * array. It does not have to be a mixin, created with the `Mixin` function, but can be any JS class. This requirement
 * specifies, that the base class of this mixin should be a subclass of the given class (or that class itself).
 *
 * The requirements of the mixin needs to be listed 3 times:
 * - as an array of constructor functions, in the 1st argument of the `Mixin` function
 * - as an instance type intersection, in the 1st type argument for the [[AnyConstructor]] type
 * - as an static type intersection, in the 2nd type argument for the [[AnyConstructor]] type
 *
 * For example, `Mixin2` requires `Mixin1`:
 *
 *     class Mixin2 extends Mixin(
 *         [ Mixin1 ],
 *         (base : AnyConstructor<Mixin1, typeof Mixin1>) =>
 *
 *         class Mixin2 extends base {
 *         }
 *     ){}
 *
 * And `Mixin3` requires both `Mixin1` and `Mixin2` (even that its redundant, since `Mixin2` already requires `Mixin1`,
 * but suppose we don't know the implementation details of the `Mixin2`):
 *
 *     class Mixin3 extends Mixin(
 *         [ Mixin1, Mixin2 ],
 *         (base : AnyConstructor<Mixin1 & Mixin2, typeof Mixin1 & typeof Mixin2>) =>
 *
 *         class Mixin3 extends base {
 *         }
 *     ){}
 *
 * Now, `Mixin4` requires `Mixin3`, plus, it requires the base class to be `SomeBaseClass`:
 *
 *     class SomeBaseClass {}
 *
 *     class Mixin4 extends Mixin(
 *         [ Mixin3, SomeBaseClass ],
 *         (base : AnyConstructor<
 *             Mixin3 & SomeBaseClass, typeof Mixin3 & typeof SomeBaseClass
 *         >) =>
 *
 *         class Mixin4 extends base {
 *         }
 *     ){}
 *
 * As already briefly mentioned, the requirements are "scanned" deep and included only once. Also all minimal classes are cached -
 * for example the creation of the Mixin3 will reuse the minimal class of the Mixin2 instead of creating a new intermediate class.
 * This means that all edges of the mixin dependencies graph are created only once (up to the base class).
 *
 * Requirements can not form cycles - that will generate both compilation error and run-time stack overflow.
 *
 * The typing for the `Mixin` function will provide a compilation error, if the requirements don't match, e.g. some requirement is
 * listed in the array, but missed in the types. This protects you from trivial mistakes. However, the typing is done up to 10 requirements only.
 * If you need more than 10 requirements for the mixin, use the [[MixinAny]] function, which is an exact analog of `Mixin`, but without
 * this type-level protection for requirements mismatch.
 *
 * It is possible to simplify the type of the `base` argument a bit, by using the [[ClassUnion]] helper. However, it seems in certain edge cases
 * it may lead to compilation errors. If your scenarios are not so complex you should give it a try. Using the [[ClassUnion]] helper, the
 * `Mixin3` can be defined as:
 *
 *     class Mixin3 extends Mixin(
 *         [ Mixin1, Mixin2 ],
 *         (base : ClassUnion<typeof Mixin1, typeof Mixin2>) =>
 *
 *         class Mixin3 extends base {
 *         }
 *     ){}
 *
 * Note, that due to this [issue](https://github.com/Microsoft/TypeScript/issues/7342), if you use decorators in your mixin class,
 * the declaration needs to be slightly more verbose (can not use compact notation for the arrow functions):
 *
 *     class Mixin2 extends Mixin(
 *         [ Mixin1 ],
 *         (base : AnyConstructor<Mixin1, typeof Mixin1>) => {
 *             class Mixin2 extends base {
 *                 @decorator
 *                 prop2 : string
 *             }
 *             return Mixin2
 *         }
 *     ){}
 *
 * As you noticed, the repeating listing of the requirements is somewhat verbose. Suggestions how the pattern can be improved
 * are [very welcomed](mailto:nickolay8@gmail.com).
 *
 * Mixin instantiation. Mixin constructor. `instanceof`
 * --------------------------------
 *
 * You can instantiate any mixin class just by using its constructor:
 *
 *     const instance1 = new Mixin1()
 *     const instance2 = new Mixin2()
 *
 * As explained in details [here](https://mariusschulz.com/blog/typescript-2-2-mixin-classes), mixin constructor should accept variable number of arguments
 * with the `any` type. This is simply because the mixin is supposed to be applicable to any other base class, which may have its own type
 * of the constructor arguments.
 *
 *     class Mixin2 extends Mixin(
 *         [ Mixin1 ],
 *         (base : AnyConstructor<Mixin1, typeof Mixin1>) => {
 *             class Mixin2 extends base {
 *                 prop2 : string
 *
 *                 constructor (...args: any[]) {
 *                     super(...args)
 *                     this.prop2 = ''
 *                 }
 *             }
 *             return Mixin2
 *         }
 *     ){}
 *
 * In other words, its not possible to provide any type-safety for mixin instantiation using regular class constructor.
 *
 * However, if we change the way we create class instances a little, we can get the type-safety back. For that,
 * we need to use a "uniform" class constructor - a constructor which has the same form for all classes. The [[Base]] class
 * provides such constructor as its static [[Base.new|new]] method. The usage of `Base` class is not required - you can use
 * any other base class.
 *
 * The `instanceof` operator works as expected for instances of the mixin classes. It also takes into account all the requirements.
 * For example:
 *
 *     const instance2 = new Mixin2()
 *
 *     const isMixin2 = instance2 instanceof Mixin2 // true
 *     const isMixin1 = instance2 instanceof Mixin1 // true, since Mixin2 requires Mixin1
 *
 * See also [[isInstanceOf]].
 *
 * "Manual" class derivation
 * --------------------------------
 *
 * You have defined a mixin using the `Mixin` function. Now you want to apply it to some base class to get the "specific" class to be able
 * to instantiate it. As described above - you don't have to, you can instantiate it directly.
 *
 * Sometimes however, you still want to derive the class "manually". For that, you can use static methods `mix` and `derive`, available
 * on all mixins.
 *
 * The `mix` method provides a direct access to the mixin lambda. It does not take requirements into account - that's the implementor's responsibility.
 * The `derive` method is something like "accumulated" mixin lambda - mixin lambda with all requirements.
 *
 * Both `mix` and `derive` provide the reasonably typed outcome.
 *
 *     class Mixin1 extends Mixin(
 *         [],
 *         (base : AnyConstructor) =>
 *
 *         class Mixin1 extends base {
 *             prop1        : string
 *         }
 *     ){}
 *
 *     class Mixin2 extends Mixin(
 *         [ Mixin1 ],
 *         (base : AnyConstructor<Mixin1, typeof Mixin1>) =>
 *
 *         class Mixin2 extends base {
 *             prop2        : string
 *         }
 *     ){}
 *
 *     const ManualMixin1 = Mixin1.mix(Object)
 *     const ManualMixin2 = Mixin2.mix(Mixin1.mix(Object))
 *
 *     const AnotherManualMixin1 = Mixin1.derive(Object)
 *     const AnotherManualMixin2 = Mixin2.derive(Object)
 *
 * Generics
 * --------
 *
 * Using generics with mixins is tricky because TypeScript does not have higher-kinded types and type inference for generics. Still some form
 * of generic arguments is possible, using the interface merging trick.
 *
 * Here's the pattern:
 *
 * ```ts
 * class Duplicator<Element> extends Mixin(
 *     [],
 *     (base : AnyConstructor) =>
 *
 *     class Duplicator extends base {
 *         Element                 : any
 *
 *         duplicate (value : this[ 'Element' ]) : this[ 'Element' ][] {
 *             return [ value, value ]
 *         }
 *     }
 * ){}
 *
 * interface Duplicator<Element> {
 *     Element : Element
 * }
 *
 * const dup = new Duplicator<boolean>()
 *
 * dup.duplicate('foo') // TS2345: Argument of type '"foo"' is not assignable to parameter of type 'boolean'.
 * ```
 *
 * In the example above, we've defined a generic argument `Element` for the outer mixin class, but in fact, that argument is not used anywhere in the
 * nested class definition in the mixin lambda. Instead, in the nested class, we define a property `Element`, which plays the role of the
 * generic argument.
 *
 * Mixin class methods then can refer to the generic type as `this[ 'Element' ]`.
 *
 * The generic arguments of the outer and nested classes are tied together in the additional interface declaration, which, by TypeScript rules
 * is merged together with the class definition. In this declaration, we specify that property `Element` has type of the `Element` generic argument.
 *
 * Limitations
 * ---------
 *
 * The most important limitation we found (which affect the old pattern as well) is the compilation error, which will be issued for
 * the private/protected methods, when compiling with declarations emitting (*.d.ts files generation).
 *
 * This is a [well-known problem](https://github.com/microsoft/TypeScript/issues/35822) in the TypeScript world – the *.d.ts files do not represent
 * the internal data structures of the TypeScript compiler well. Instead they use some simplified syntax, optimized for human editing.
 * This is why the compiler may generate false positives in the incremental compilation mode – it uses *.d.ts files internally.
 *
 * This can be a show-stopper for the people that use declaration files (usually for publishing). Keep in mind though, that you can always
 * publish actual TypeScript sources along with the generated JavaScript files, instead of publishing JavaScript + declarations files.
 *
 */

const Mixin = mixin;
/**
 * This is an exact analog of the [[Mixin]] function, but without type-level protection for requirements mismatch.
 * It supports unlimited number of requirements.
 */

const MixinAny = mixin;

/***/ }),

/***/ "./lib/ChronoGraph/collection/Iterator.js":
/*!************************************************!*\
  !*** ./lib/ChronoGraph/collection/Iterator.js ***!
  \************************************************/
/*! exports provided: split, inBatchesBySize, filter, drop, every, some, map, reduce, uniqueOnly, uniqueOnlyBy, reverse, takeWhile, takeUntilIncluding, takeUntilExcluding, concat, concatIterable, ChainedIteratorClass, ChainedIterator, CI, MemoizedIteratorClass, MemoizedIterator, MI */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "split", function() { return split; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inBatchesBySize", function() { return inBatchesBySize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return drop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "every", function() { return every; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "some", function() { return some; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return reduce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uniqueOnly", function() { return uniqueOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uniqueOnlyBy", function() { return uniqueOnlyBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reverse", function() { return reverse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeWhile", function() { return takeWhile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeUntilIncluding", function() { return takeUntilIncluding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeUntilExcluding", function() { return takeUntilExcluding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return concat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concatIterable", function() { return concatIterable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChainedIteratorClass", function() { return ChainedIteratorClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChainedIterator", function() { return ChainedIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CI", function() { return CI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MemoizedIteratorClass", function() { return MemoizedIteratorClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MemoizedIterator", function() { return MemoizedIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MI", function() { return MI; });
var productName = 'taskboard'; //---------------------------------------------------------------------------------------------------------------------

/**
 * Given a single `Iterable`, returns an array of 2 iterables, mirroring the original one (which should not be used anymore).
 *
 * For example:
 *
 *     const gen = function* () { yield 1; yield 2; yield 3 }
 *
 *     const [ iterable1, iterable2 ] = split(gen())
 *     const [ iter1, iter2 ] = [
 *         iterable1[ Symbol.iterator ](),
 *         iterable2[ Symbol.iterator ]()
 *     ]
 *
 *     iter1.next() // 1
 *     iter2.next() // 1
 *     iter2.next() // 2
 *     iter2.next() // 3
 *     iter1.next() // 2
 *     iter1.next() // 3
 *     iter1.next() // done
 *     iter2.next() // done
 *
 * @param iterable
 */

function split(iterable) {
  const gen1Pending = [];
  const gen2Pending = [];
  let iterator;

  const gen1 = function* () {
    if (!iterator) iterator = iterable[Symbol.iterator]();

    while (true) {
      if (gen1Pending.length) {
        yield* gen1Pending;
        gen1Pending.length = 0;
      }

      if (!iterator) break;
      const {
        value,
        done
      } = iterator.next();

      if (done) {
        iterator = null;
        iterable = null;
        break;
      }

      gen2Pending.push(value);
      yield value;
    }
  };

  const gen2 = function* () {
    if (!iterator) iterator = iterable[Symbol.iterator]();

    while (true) {
      if (gen2Pending.length) {
        yield* gen2Pending;
        gen2Pending.length = 0;
      }

      if (!iterator) break;
      const {
        value,
        done
      } = iterator.next();

      if (done) {
        iterator = null;
        iterable = null;
        break;
      }

      gen1Pending.push(value);
      yield value;
    }
  };

  return [gen1(), gen2()];
} //---------------------------------------------------------------------------------------------------------------------

function* inBatchesBySize(iterator, batchSize) {
  if (batchSize < 0) throw new Error("Batch size needs to a natural number");
  batchSize = batchSize | 0;
  const runningBatch = [];

  for (const el of iterator) {
    if (runningBatch.length === batchSize) {
      yield runningBatch;
      runningBatch.length = 0;
    }

    runningBatch.push(el);
  }

  if (runningBatch.length > 0) yield runningBatch;
} //---------------------------------------------------------------------------------------------------------------------

function* filter(iterator, func) {
  let i = 0;

  for (const el of iterator) {
    if (func(el, i++)) yield el;
  }
} //---------------------------------------------------------------------------------------------------------------------

function* drop(iterator, howMany) {
  let i = 0;

  for (const el of iterator) {
    if (++i > howMany) yield el;
  }
} //---------------------------------------------------------------------------------------------------------------------

function every(iterator, func) {
  let i = 0;

  for (const el of iterator) {
    if (!func(el, i++)) return false;
  }

  return true;
} //---------------------------------------------------------------------------------------------------------------------

function some(iterator, func) {
  let i = 0;

  for (const el of iterator) {
    if (func(el, i++)) return true;
  }

  return false;
} //---------------------------------------------------------------------------------------------------------------------

function* map(iterator, func) {
  let i = 0;

  for (const el of iterator) yield func(el, i++);
} //---------------------------------------------------------------------------------------------------------------------

function reduce(iterator, func, initialAcc) {
  let i = 0;
  let acc = initialAcc;

  for (const el of iterator) {
    acc = func(acc, el, i++);
  }

  return acc;
} //---------------------------------------------------------------------------------------------------------------------

function* uniqueOnly(iterator) {
  const seen = new Set();

  for (const el of iterator) {
    if (!seen.has(el)) {
      seen.add(el);
      yield el;
    }
  }
} //---------------------------------------------------------------------------------------------------------------------

function* uniqueOnlyBy(iterator, func) {
  const seen = new Set();

  for (const el of iterator) {
    const uniqueBy = func(el);

    if (!seen.has(uniqueBy)) {
      seen.add(uniqueBy);
      yield el;
    }
  }
} //---------------------------------------------------------------------------------------------------------------------

function* reverse(iterator) {
  const all = Array.from(iterator);

  for (let i = all.length - 1; i >= 0; i--) yield all[i];
} //---------------------------------------------------------------------------------------------------------------------

function* takeWhile(iterator, func) {
  let i = 0;

  for (const el of iterator) {
    if (func(el, i++)) yield el;else return;
  }
} //---------------------------------------------------------------------------------------------------------------------

function* takeUntilIncluding(iterator, func) {
  let i = 0;

  for (const el of iterator) {
    yield el;
    if (func(el, i++)) return;
  }
} //---------------------------------------------------------------------------------------------------------------------

function* takeUntilExcluding(iterator, func) {
  let i = 0;

  for (const el of iterator) {
    if (func(el, i++)) return;
    yield el;
  }
} //---------------------------------------------------------------------------------------------------------------------

function* concat(...iterators) {
  for (let i = 0; i < iterators.length; i++) yield* iterators[i];
} //---------------------------------------------------------------------------------------------------------------------

function* concatIterable(iteratorsProducer) {
  for (const iterator of iteratorsProducer) yield* iterator;
} //---------------------------------------------------------------------------------------------------------------------
// just a chained syntax sugar class
// note, that we either use a combination of `this.derive()` + this.iterable (which will clear the `this.iterable`)
// or, use just `this` as iterable, which will also clear the iterator
//

class ChainedIteratorClass {
  constructor(iterable) {
    this.iterable = undefined;
    if (!iterable) throw new Error("Require an iterable instance for chaining");
    this.iterable = iterable;
  }

  derive(iterable) {
    this.iterable = undefined;
    return new ChainedIteratorClass(iterable);
  }

  copy() {
    const [iter1, iter2] = split(this.iterable);
    this.iterable = iter2;
    return new ChainedIteratorClass(iter1);
  }

  split() {
    const [iter1, iter2] = split(this.iterable);
    return [new ChainedIteratorClass(iter1), this.derive(iter2)];
  }

  inBatchesBySize(batchSize) {
    return this.derive(inBatchesBySize(this.iterable, batchSize));
  }

  filter(func) {
    return this.derive(filter(this.iterable, func));
  }

  drop(howMany) {
    return this.derive(drop(this.iterable, howMany));
  }

  map(func) {
    return this.derive(map(this.iterable, func));
  }

  reduce(func, initialAcc) {
    return reduce(this, func, initialAcc);
  }

  concat() {
    //@ts-ignore
    return this.derive(concatIterable(this.iterable));
  }

  uniqueOnly() {
    return this.derive(uniqueOnly(this.iterable));
  }

  uniqueOnlyBy(func) {
    return this.derive(uniqueOnlyBy(this.iterable, func));
  }

  every(func) {
    return every(this, func);
  }

  some(func) {
    return some(this, func);
  }

  takeWhile(func) {
    return this.derive(takeWhile(this.iterable, func));
  }

  *[Symbol.iterator]() {
    let iterable = this.iterable;
    if (!iterable) throw new Error("Chained iterator already exhausted or used to derive the new one"); // practice shows, that cleaning up the iterable after yourself helps garbage collector a lot

    this.iterable = undefined;
    yield* iterable; // yes, we really want to avoid memory leaks

    iterable = undefined;
  }

  toArray() {
    return Array.from(this);
  }

  sort(order) {
    return Array.from(this).sort(order);
  }

  toSet() {
    return new Set(this);
  }

  toMap() {
    //@ts-ignore
    return new Map(this);
  } // toMap<K, V> () : T extends [ K, V ] ? Map<K, V> : never  {
  //     return new Map<K, V>(this.iterable as (T extends [ K, V ] ? Iterable<T> : never)) as (T extends [ K, V ] ? Map<K, V> : never)
  // }


  flush() {
    for (const element of this) {}
  }

  memoize() {
    return new MemoizedIteratorClass(this);
  }

}
const ChainedIterator = iterator => new ChainedIteratorClass(iterator);
const CI = ChainedIterator; //---------------------------------------------------------------------------------------------------------------------

class MemoizedIteratorClass extends ChainedIteratorClass {
  constructor() {
    super(...arguments);
    this.elements = [];
    this.$iterator = undefined;
  }

  set iterable(iterable) {
    this.$iterable = iterable;
  }

  get iterable() {
    return this;
  }

  derive(iterable) {
    return new ChainedIteratorClass(iterable);
  }

  *[Symbol.iterator]() {
    const elements = this.elements;

    if (this.$iterable) {
      if (!this.$iterator) this.$iterator = this.$iterable[Symbol.iterator]();
      let iterator = this.$iterator;
      let alreadyConsumed = elements.length; // yield the 1st batch "efficiently"

      if (alreadyConsumed > 0) yield* elements;

      while (true) {
        if (elements.length > alreadyConsumed) {
          // wonder if `yield* elements.slice(alreadyConsumed)` is more performant or not
          for (let i = alreadyConsumed; i < elements.length; i++) yield elements[i];

          alreadyConsumed = elements.length;
        }

        if (!iterator) break;
        const {
          value,
          done
        } = iterator.next();

        if (done) {
          iterator = this.$iterator = null;
          this.$iterable = null;
        } else {
          elements.push(value);
          alreadyConsumed++;
          yield value;
        }
      }
    } else {
      yield* elements;
    }
  }

}
const MemoizedIterator = iterator => new MemoizedIteratorClass(iterator);
const MI = MemoizedIterator;

/***/ }),

/***/ "./lib/Core/Base.js":
/*!**************************!*\
  !*** ./lib/Core/Base.js ***!
  \**************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Base; });
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Config.js */ "./lib/Core/Config.js");
var productName = 'taskboard';
/**
* @module Core/Base
*/







class MetaClass {
  constructor(options) {
    options && Object.assign(this, options);
  }

  getInherited(name, create = true) {
    let ret = this[name]; // We use "in this" to allow the object to be set to null

    if (!(name in this)) {
      var _this$super;

      // If there is no object on this meta class, but there may be one on a super class. If create=false, the
      // idea is that a super class object will be "properly" inherited but otherwise no object will be created.
      ret = (_this$super = this.super) === null || _this$super === void 0 ? void 0 : _this$super.getInherited(name, create);

      if (ret || create) {
        this[name] = ret = Object.create(ret || null);
      }
    }

    return ret;
  }

}

const // Using Object.getPrototypeOf instead of Reflect.getPrototypeOf because:
// 1. The are almost the same, according to the MDN difference is handling getPrototypeOf('string')
// 2. It allows to pass security check in SalesForce environment
{
  getPrototypeOf
} = Object,
      {
  defineProperty
} = Reflect,
      {
  hasOwnProperty
} = Object.prototype,
      metaSymbol = Symbol('classMetaData'),
      mixinTagSymbol = Symbol('mixinTag'),
      originalConfigSymbol = Symbol('originalConfig'),
      createdAtSymbol = Symbol('createdAt'),
      configuringSymbol = _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].symbols.configuring,
      instancePropertiesSymbol = _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].symbols.instanceProperties,
      lazyConfigsSymbol = _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].symbols.lazyConfigs,
      defaultConfigOptions = {
  merge: 'replace',
  simple: true
},
      emptyFn = () => {},
      newMeta = o => new MetaClass(o),
      setupNames = {
  /* foo : 'setupFoo' */
},
      emptyObject = Object.freeze({}),
      emptyArray = Object.freeze([]);
/**
 * Base class for all configurable classes.
 *
 * Subclasses do not have to implement a constructor with its restriction of having to call super()
 * before there is a `this` reference. Subclasses instead implement a `construct` method which is
 * called by the `Base` constructor. This may call its `super` implementation at any time.
 *
 * The `Base` constructor applies all configs to properties of the new instance. The instance
 * will have been configured after the `super.construct(config)` is called.
 *
 * See the Class System documentation in the guides for more information.
 *
 * @abstract
 */


class Base {
  static get isBase() {
    return true;
  }

  get isBase() {
    return true;
  } // defaultConfig & properties made private to not spam all other classes

  /**
   * A class property getter to add additional, special class properties.
   *
   * For example, a class adds a `declarable` class property like so:
   * ```
   *  class Something extends Base {
   *      static get declarable() {
   *          return ['extra'];
   *      }
   *
   *      static setupExtra(cls, meta) {
   *          // use cls.extra
   *      }
   *  }
   * ```
   * A derived class can then specify this property like so:
   * ```
   *  class Derived extends Something {
   *      static get extra() {
   *          // return extra information
   *      }
   *  }
   * ```
   * When the `Derived` class is initialized, the `setupExtra()` method is called and `Derived` is passed as the
   * argument. It is also the `this` pointer, but the parameter is minifiable. The second argument passed is the
   * `$meta` object for the class.
   *
   * Classes are initialized at the first occurrence of the following:
   *
   * - An instance is created
   * - The class `$meta` property is accessed
   *
   * @member {String[]} declarable
   * @static
   * @category Configuration
   * @internal
   */


  static get declarable() {
    return ['declarable',
    /**
     * A class property getter for the configuration properties of the class, which can be overridden by
     * configurations passed at construction time.
     *
     * Unlike a normal `static` property, this property is only ever used for the class that defines it (as in,
     * `hasOwnProperty`). It is retrieved for all classes in a class hierarchy, to gather their configs
     * individually and then combine them with those of derived classes.
     *
     * For example, a `Label` might declare a `text` config like so:
     * ```javascript
     *  class Label extends Base {
     *      static get configurable() {
     *          return {
     *              text : null
     *          };
     *      }
     *  }
     * ```
     * The `text` config is automatically inherited by classes derived from Label. By implementing
     * `get configurable()`, derived classes can change the default value of inherited configs, or define new
     * configs, or both.
     *
     * When a config property is declared in this way, the class author can also implement either of two
     * special methods that will be called when the config property is assigned a new value:
     *
     *  - `changeText()`
     *  - `updateText()`
     *
     * In the example above, the `Label` class could implement a `changeText()` method, an `updateText()`
     * method, or both. The generated property setter ensures these methods will be called when the `text`
     * property is assigned.
     *
     * The generated setter (for `text` in this example) performs the following steps:
     *
     *  - If the class defines a `changeText()` method, call it passing the new value and the current value:
     *    `changeText(newText, oldText)`.<br>
     *    Then:
     *    * If `changeText()` exits without returning a value (i.e., `undefined`), exit and do nothing
     *      further. The assumption is that the changer method has done all that is required.
     *    * Otherwise, the return value of `changeText()` replaces the incoming value passed to the setter.
     *  - If the new value (or the value returned by `changeText()`) is `!==` to the current value:
     *    * Update the stored config value in `this._text`.
     *    * If the class defines an `updateText()` method, call it passing the new value and the previous value.
     *      `updateText(newText, oldText)`
     *
     * #### Resolving a value from an owner
     * By specifying a value starting with `'up.'` for a config, the config system will resolve that value by
     * examining the ownership hierarchy. It will walk up the hierarchy looking for a property matching the name
     * (or dot separated path) after 'up.'. If one is found, the value will be read and used as the initial
     * value.
     *
     * ```javascript
     * class Parent extends Base {
     *     static get configurable() {
     *         return [
     *           'importantValue'
     *         ]
     *     }
     * }
     *
     * class Child extends Base {
     *     static get configurable() {
     *         return [
     *           'value'
     *         ]
     *     }
     * }
     *
     * const parent = new Parent({
     *     importantValue : 123
     * });
     *
     * const child = new Child({
     *     owner : parent,
     *     // Will be resolved from the owner
     *     value : 'up.importantValue'
     * });
     *
     * console.log(child.value); // logs 123
     * ```
     * Please note that this is for now a one way one time binding, the value will only be read initially and
     * not kept up to date on later changes.
     *
     * #### Value Merging
     * When a config property value is an object, the value declared by the base class is merged with values
     * declared by derived classes and the value passed to the constructor.
     * ```javascript
     *  class Example extends Base {
     *      static get configurable() {
     *          return {
     *              config : {
     *                  foo : 1,
     *                  bar : 2
     *              }
     *          };
     *      }
     *  }
     *
     *  class Example2 extends Example {
     *      static get configurable() {
     *          return {
     *              config : {
     *                  bar : 42,
     *                  zip : 'abc'
     *              }
     *          };
     *      }
     *  }
     *
     *  let ex = new Example2({
     *      config : {
     *          zip : 'xyz'
     *      }
     *  });
     * ```
     * The result of the merge would set `config` to:
     * ```javascript
     *  ex.foo = {
     *      foo : 1,    // from Example
     *      bar : 42,   // from Example2
     *      zip : 'xyz' // from constructor
     *  }
     * ```
     *
     * #### Config Options
     * Some config properties require additional options such as declarative information about the config that
     * may be useful to automate some operation. Consider a `Button`. It could declare that its `text` config
     * affects the rendered HTML by applying a `render` property to the config definition. Its base class could
     * then examine the config definition to find this property.
     *
     * To support this, config options ca be declared like so:
     * ```javascript
     *  class Button extends Widget {
     *      static get configurable() {
     *          return {
     *              text : {
     *                  value   : null,
     *                  $config : {
     *                      render : true
     *                  }
     *              }
     *          };
     *      }
     *  }
     * ```
     * The `$config` property can alternatively be just the names of the options that should be enabled (set
     * to `true`).
     *
     * For example, the following is equivalent to the above:
     * ```javascript
     *  class Button extends Widget {
     *      static get configurable() {
     *          return {
     *              text : {
     *                  value   : null,
     *                  $config : 'render'
     *              }
     *          };
     *  }
     * ```
     *
     * #### Default Value
     * It is common to set a config to a `null` value to take advantage of internal optimizations for `null`
     * values. In most cases the fact that this produces `undefined` as the actual initial value of the config
     * is acceptable. When this is not acceptable, a config can be declared like so:
     * ```javascript
     *  class Widget {
     *      static get configurable() {
     *          return {
     *              disabled : {
     *                  $config : null,
     *                  value   : null,
     *                  default : false
     *              }
     *          };
     *  }
     * ```
     * The `default` property above determines the value of the config while still gaining the benefits of
     * minimal processing due to the `null` value of the `value` property.
     * @member {Object} configurable
     * @static
     * @category Configuration
     * @internal
     */
    'configurable',
    /**
     * A class property getter for the default configuration of the class, which can be overridden by
     * configurations passed at construction time.
     *
     * Unlike a normal `static` property, this property is only ever used for the class that defines it (as in,
     * `hasOwnProperty`). It is retrieved for all classes in a class hierarchy, to gather their configs
     * individually and then combine them with those of derived classes.
     *
     * For example, a `Store` might declare its `url` config like so:
     * ```
     *  class Store extends Base {
     *      static get defaultConfig() {
     *          return {
     *              url : null
     *          };
     *      }
     *  }
     * ```
     * The `url` config is automatically inherited by classes derived from Store. By implementing
     * `get defaultConfig()`, derived classes can change the default value of inherited configs, or define new
     * configs, or both. When defining new configs, however, `configurable` is preferred.
     *
     * Config properties introduced to a class by this declaration do not participate in value merging and do
     * not get a generated setter. Config properties introduced by a base class using `configurable` can be
     * set to a different value using `defaultConfig` and in doing so, the values will be merged as appropriate
     * for `configurable`.
     *
     * @member {Object} defaultConfig
     * @static
     * @category Configuration
     * @internal
     */
    'defaultConfig',
    /**
     * A class property getter for the default values of internal properties for this class.
     * @member {Object} properties
     * @static
     * @category Configuration
     * @internal
     */
    'properties',
    /**
     * A class property getter for properties that will be applied to the class prototype.
     * @member {Object} prototypeProperties
     * @static
     * @category Configuration
     * @internal
     */
    'prototypeProperties'];
  }
  /**
   * Base constructor, passes arguments to {@link #function-construct}.
   * @param {...Object} [args] Usually called with a config object, but accepts any params
   * @function constructor
   * @category Lifecycle
   */


  constructor(...args) {
    const me = this,
          C = me.constructor;

    if (me.$meta.class !== C) {
      // This will happen only once for each class. We need to call the C.$meta getter which puts $meta on our
      // prototype. Since that alone would be optimized away (and would generate IDE and lint warnings), we call
      // emptyFn and simply pass the value.
      emptyFn(C.$meta);
    } // Allow subclasses to have a pseudo constructor with "this" already set:


    me.construct(...args);
    me.afterConstruct();
  }
  /**
   * Factory version of the Base constructor. Merges all arguments to create a config object that is passed along to
   * the constructor.
   * @param {...Object} [configs] Allows passing multiple config objects
   * @returns {Core.Base} New instance
   * @private
   */


  static new(...configs) {
    return new this(_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].merge({}, ...configs));
  }
  /**
   * Base implementation applies configuration.
   *
   * Subclasses need only implement this if they have to initialize instance specific
   * properties required by the class. Often a `construct` method is
   * unnecessary. All initialization of incoming configuration properties can be
   * done in a `set propName` implementation.
   * @param {...Object} [args] Usually called with a config object, but accepts any params
   * @category Lifecycle
   */


  construct(...args) {
    // Passing null to base construct means bypass the config system and stack creation (to gain performance)
    if (args[0] !== null) {
      this.configure(...args);
    }

    this.afterConfigure();
  }
  /**
   * Destroys the provided objects by calling their {@link #function-destroy} method.
   * Skips empty values or objects that are already destroyed.
   *
   * ```javascript
   * Base.destroy(myButton, toolbar1, helloWorldMessageBox);
   * ```
   * @param {...Object} [args] Objects to be destroyed
   * @category Lifecycle
   */


  static destroy(...args) {
    const shredder = object => {
      if (object !== null && object !== void 0 && object.destroy) {
        object.destroy();
      } else if (Array.isArray(object)) {
        object.forEach(shredder);
      }
    };

    shredder(args);
  }
  /**
   * Destroys this object. This is primarily accomplished by calling {@link #function-doDestroy}, however, prior to
   * calling `doDestroy`, {@link #property-isDestroying} is set to `true`. After {@link #function-doDestroy} returns,
   * {@link #property-isDestroyed} is set to `true`.
   *
   * Do not override this method in subclasses. To provide class-specific cleanup, implement {@link #function-doDestroy}
   * instead.
   * @category Lifecycle
   */


  destroy() {
    const me = this,
          {
      id
    } = me; // Let everyone know the object is going inert:

    me.isDestroying = true; // Make calling destroy() harmless:

    me.destroy = emptyFn;
    me.doDestroy();
    Object.setPrototypeOf(me, null); // Clear all remaining instance properties.

    for (const key in me) {
      if (key !== 'destroy' && key !== 'isDestroying') {
        delete me[key];
      }
    }

    delete me[originalConfigSymbol]; // Let everyone know the object is inert:

    me.isDestroyed = true;
    me.id = id; // for diagnostic reasons
  }
  /**
   * This method is required to help `unused` getters to survive production build process. Some tools, like angular,
   * will remove `unused` code in production build, making our side-effected getters behind, breaking code heavily.
   * @internal
   * @param getter Getter to evaluate
   */


  _thisIsAUsedExpression(getter) {}

  static get $$name() {
    return hasOwnProperty.call(this, '$name') && this.$name || // _$name is filled by webpack for every class (cls._$name = '...')
    hasOwnProperty.call(this, '_$name') && this._$name || this.name;
  }

  get $$name() {
    return this.constructor.$$name;
  }
  /**
   * Base implementation so that all subclasses and mixins may safely call super.startConfigure.
   *
   * This is called by the Base class before setting configuration properties, but after
   * the active initial getters have been set, so all configurations are available.
   *
   * This method allows all classes in the hierarchy to force some configs to be evaluated before others.
   * @internal
   * @category Lifecycle
   * @params {Object} config The configuration object use to set the initial state.
   */


  startConfigure(config) {}
  /**
   * Base implementation so that all subclasses and mixins may safely call super.finishConfigure.
   *
   * This is called by the Base class before exiting the {@link #function-configure} method.
   *
   * At this point, all configs have been applied, but the `isConfiguring` property is still set.
   *
   * This method allows all classes in the hierarchy to inject functionality
   * into the config phase.
   * @internal
   * @category Lifecycle
   * @params {Object} config The configuration object use to set the initial state.
   */


  finishConfigure(config) {}
  /**
   * Base implementation so that all subclasses and mixins may safely call `super.afterConfigure`. This is called by the Base class after the {@link #function-configure} method has been
   * called. At this point, all configs have been applied.
   *
   * This method allows all classes in the hierarchy to inject functionality
   * either before or after the super.afterConstruct();
   * @internal
   * @category Lifecycle
   */


  afterConfigure() {}
  /**
   * Base implementation so that all subclasses and mixins may safely call super.afterConstruct.
   *
   * This is called by the Base class after the {@link #function-construct} method has been
   * called.
   *
   * At this point, all configs have been applied.
   *
   * This method allows all classes in the hierarchy to inject functionality
   * either before or after the super.afterConstruct();
   * @internal
   * @function afterConstructor
   * @category Lifecycle
   */


  afterConstruct() {}
  /**
   * Provides a way of calling callbacks which may have been specified as the _name_ of a function
   * and optionally adds scope resolution.
   *
   * For example, if the callback is specified as a string, then if it is prefixed with `'this.'`
   * then the function is resolved in this object. This is useful when configuring listeners
   * at the class level.
   *
   * If the callback name is prefixed with `'up.'` then the ownership hierarchy is queried
   * using the `owner` property until an object with the named function is present, then the
   * named function is called upon that object.
   *
   * If a named function is not found, an error is thrown. If the function should be only called when present,
   * and may not be present, add a `?` as a suffix.
   *
   * @param {String|Function} fn The function to call, or the name of the function to call.
   * @param {Object} thisObject The `this` object of the function.
   * @param {Object[]} args The argument list to pass.
   * @category Misc
   */


  callback(fn, thisObject, args = emptyArray) {
    // Maintainer: do not make args ...args. This method may acquire more arguments
    const {
      handler,
      thisObj
    } = this.resolveCallback(fn, thisObject === 'this' ? this : thisObject) || emptyObject;
    return handler === null || handler === void 0 ? void 0 : handler.apply(thisObj, args);
  }

  resolveProperty(propertyPath) {
    let thisObj = this;

    while (thisObj) {
      if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].hasPath(thisObj, propertyPath)) {
        return _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].getPath(thisObj, propertyPath);
      }

      thisObj = thisObj.owner;
    }

    return undefined;
  }
  /**
   * Provides a way of locating callbacks which may have been specified as the _name_ of a function
   * and optionally adds scope resolution.
   *
   * For example, if the callback is specified as a string, then if it is prefixed with `'this.'`
   * then the function is resolved in this object. This is useful when configuring listeners
   * at the class level.
   *
   * If the callback name is prefixed with `'up.'` then the ownership hierarchy is queried
   * using the `owner` property until an object with the named function is present, then the
   * named function is called upon that object.
   * @param {String|Function} handler The function to call, or the name of the function to call.
   * @param {Object} thisObj The `this` object of the function.
   * @param {Boolean} [enforceCallability = true] Pass `false` if the function may not exist, and a null return value is acceptable.
   * @returns {Object} `{ handler, thisObj }`
   * @category Misc
   */


  resolveCallback(handler, thisObj = this, enforceCallability = true) {
    // It's a string, we find it in its own thisObj
    if (handler.substring) {
      if (handler.endsWith('?')) {
        enforceCallability = false;
        handler = handler.substring(0, handler.length - 1);
      }

      if (handler.startsWith('up.')) {
        handler = handler.substring(3); // Empty loop until we find the function owner

        for (thisObj = this.owner; thisObj && !thisObj[handler]; thisObj = thisObj.owner);

        if (!thisObj) {
          return;
        }
      } else if (handler.startsWith('this.')) {
        handler = handler.substring(5);
        thisObj = this;
      }

      if (!thisObj || !(thisObj instanceof Object)) {
        return;
      }

      if (typeof thisObj[handler] !== 'function') {
        return;
      }

      handler = thisObj[handler];
    }

    return {
      handler,
      thisObj
    };
  }

  bindCallback(inHandler, inThisObj = this) {
    if (inHandler) {
      const {
        handler,
        thisObj
      } = this.resolveCallback(inHandler, inThisObj);

      if (handler) {
        return handler.bind(thisObj);
      }
    }
  }
  /**
   * Delays the execution of the passed function by the passed time quantum, or if the time is omitted
   * or not a number, delays until the next animation frame. Note that this will use
   * {@link Core.mixin.Delayable#function-setTimeout} || {@link Core.mixin.Delayable#function-requestAnimationFrame}
   * if this class mixes in `Delayable`, otherwise it uses the global methods. The function will
   * be called using `this` object as its execution scope.
   * @param {Function} fn The function to call on a delay.
   * @param {Number} [by] The number of milliseconds to delay.
   * @private
   */


  delay(fn, by) {
    // Force scope on the fn if we are not a Delayable
    fn = this.setTimeout ? fn : fn.bind(this);
    const invoker = this.setTimeout ? this : _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].global;
    invoker[typeof by === 'number' ? 'setTimeout' : 'requestAnimationFrame'](fn, by);
  }
  /**
   * Classes implement this method to provide custom cleanup logic before calling `super.doDestroy()`. The general
   * pattern is as follows:
   *
   * ```javascript
   *  class Foo extends Base {
   *      doDestroy() {
   *          // perform custom cleanup
   *
   *          super.doDestroy();
   *      }
   *  }
   * ```
   *
   * This method is called by {@link #function-destroy} which also prevents multiple calls from reaching `doDestroy`.
   * Prior to calling `doDestroy`, {@link #property-isDestroying} is set to `true`. Upon return, the object is fully
   * destructed and {@link #property-isDestroyed} is set to `true`.
   *
   * Do not call this method directly. Instead call {@link #function-destroy}.
   * @category Lifecycle
   */


  doDestroy() {
    const me = this,
          {
      nullify
    } = me.$meta;

    if (nullify) {
      for (let i = 0; i < nullify.length; ++i) {
        if (me[nullify[i].field] != null) {
          // if backing property is null/undefined then skip
          me[nullify[i].name] = null; // else, call setter to run through change/update
        }
      }
    }
  }
  /**
   * Destroys the named properties if they have been initialized, and if they have a `destroy` method.
   * Deletes the property from this object. For example:
   *
   *      this.destroyProperties('store', 'resourceStore', 'eventStore', 'dependencyStore', 'assignmentStore');
   *
   * @param {String} properties The names of the properties to destroy.
   * @internal
   * @category Lifecycle
   */


  destroyProperties(...properties) {
    const me = this;
    let key, propertyValue;

    for (key of properties) {
      // If the value has *not* been pulled in from the configuration object yet
      // we must not try to access it, as that will cause the property to be initialized.
      if (key in me && (!me[configuringSymbol] || !me[configuringSymbol][key])) {
        propertyValue = me[key];

        if (propertyValue && propertyValue.destroy) {
          propertyValue.destroy();
        }

        delete me[key];
      }
    }
  }
  /**
   * Called by the Base constructor to apply configs to this instance. This must not be called.
   * @param {Object} config The configuration object from which instance properties are initialized.
   * @private
   * @category Lifecycle
   */


  configure(config = {}) {
    const me = this,
          {
      beforeConfigure
    } = config,
          configs = me.$meta.configs,
          fullConfig = me.getDefaultConfiguration();
    let cfg, key, value;
    me.initialConfig = config; // Important flag for setters to know whether they are being called during
    // configuration when this object is not fully alive, or whether it's being reconfigured.

    me.isConfiguring = true; // Assign any instance properties declared by the class.

    Object.assign(me, me.getProperties()); // Apply configuration to default from class definition. This is safe because it's either chained from or a
    // fork of the class values.

    for (key in config) {
      value = config[key];
      cfg = configs[key];
      fullConfig[key] = cfg ? cfg.merge(value, fullConfig[key], null) : value;
    }

    if (beforeConfigure) {
      delete fullConfig.beforeConfigure; // noinspection JSValidateTypes

      beforeConfigure(me, fullConfig);
    } // Cache me.config for use by get config.


    me.setConfig(me[originalConfigSymbol] = fullConfig, true);
    me.isConfiguring = false;
  }
  /**
   * Returns the value of the specified config property. This is a method to allow
   * property getters to be explicitly called in a way that does not get optimized out.
   *
   * The following triggers the getter call, but optimizers will remove it:
   *
   *      inst.foo;   // also raises "expression has no side-effects" warning
   *
   * Instead, do the following to trigger a getter:
   *
   *      inst.getConfig('foo');
   *
   * @param {String} name
   * @internal
   * @category Configuration
   */


  getConfig(name) {
    return this[name];
  }
  /**
   * Sets configuration options this object with all the properties passed in the parameter object.
   * Timing is taken care of. If the setter of one config is called first, and references
   * the value of another config which has not yet been set, that config will be set just
   * in time, and the *new* value will be used.
   * @param {Object} config An object containing configurations to change.
   * @category Lifecycle
   */


  setConfig(config, isConstructing) {
    const me = this,
          wasConfiguring = me[configuringSymbol],
          configDone = wasConfiguring ? me.configDone : me.configDone = {},
          configs = me.$meta.configs;
    let cfg, key;
    me[instancePropertiesSymbol] = {}; // Cache configuration for use by injected property initializers.

    me[configuringSymbol] = wasConfiguring ? Object.setPrototypeOf(Object.assign({}, config), wasConfiguring) : config; // For each incoming non-null configuration, create a temporary getter which will
    // pull the value in from the initialConfig so that it doesn't matter in
    // which order properties are set. You can access any property at any time.

    for (key in config) {
      // Don't default null configs in unless it's a direct property of the
      // the passed configuration. When used at construct time, defaultConfigs
      // will be prototype-chained onto the config.
      if (config[key] != null || hasOwnProperty.call(config, key)) {
        cfg = configs[key] || _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].get(key);
        cfg.defineInitter(me, config[key]);

        if (!isConstructing) {
          configDone[key] = false;
        } else if (cfg.lazy) {
          configDone[key] = true;
        }
      } else {
        configDone[key] = true;
      }
    }

    if (isConstructing) {
      me.startConfigure(config);
    } // Set all our properties from the config object.
    // If one of the properties needs to access a property that has not
    // yet been set, the above temporary property will pull it through.
    // Can't use Object.assign because that only uses own properties.
    // config value blocks are prototype chained subclass->superclass


    for (key in config) {
      // Only push the value through if the property initializer is still present.
      // If it gets triggered to pull the configuration value in, it deleted itself.
      if (!configDone[key]) {
        me[key] = config[key];
      }
    }

    if (wasConfiguring) {
      me[configuringSymbol] = wasConfiguring;
    } else {
      delete me[configuringSymbol];
    }

    if (isConstructing) {
      me.finishConfigure(config);
    }

    return me;
  }
  /**
   * Returns `true` if this instance has a non-null value for the specified config. This will not activate a lazy
   * config.
   *
   * @param {String} name The name of the config property.
   * @returns {Boolean}
   * @internal
   */


  hasConfig(name) {
    const me = this,
          lazyConfig = me[lazyConfigsSymbol],
          config = me[configuringSymbol],
          hasValue = me['_' + name] != null,
          hasLazyValue = (lazyConfig === null || lazyConfig === void 0 ? void 0 : lazyConfig[name]) != null,
          hasConfigValue = Boolean(!me.configDone[name] && config && (config[name] != null || hasOwnProperty.call(config, name)));
    return hasValue || hasLazyValue || hasConfigValue;
  }
  /**
   * Ensures that the specified config is initialized if it is needed. If there is a config value specified, and it
   * was initialized by this call, this method returns `true`. If there was a config value specified, and it was
   * already initialized, this method returns `false`. If there was no value specified for the given config, this
   * method returns `null`.
   *
   * This is different than just reading the property because some property getters exist that do not actually just
   * read the config value back, but instead produce some result. Reading such properties to incidentally trigger a
   * possible config initializer can lead to incorrect results. For example, the Combo items config.
   *
   * @param {String} name The name of the config property.
   * @returns {Boolean}
   * @internal
   */


  triggerConfig(name) {
    const {
      configDone
    } = this,
          config = this[configuringSymbol],
          triggered = config && (config[name] != null || hasOwnProperty.call(config, name)) ? !configDone[name] : null;

    if (triggered) {
      this.getConfig(name);
    }

    return triggered;
  }

  onConfigChange() {} // declared above because lint/IDE get angry about not declaring the args...

  /**
   * This method is called when any config changes.
   * @param {Object} info Object containing information regarding the config change.
   * @param {String} info.name The name of the config that changed.
   * @param {*} info.value The new value of the config.
   * @param {*} info.was The previous value of the config.
   * @param {Core.Config} info.config The `Config` object for the changed config property.
   * @method onConfigChange
   * @internal
   * @category Configuration
   */

  /**
   * Returns a *copy* of the full configuration which was used to configure this object.
   * @property {Object}
   * @category Lifecycle
   * @readonly
   */


  get config() {
    const result = {},
          myConfig = this[originalConfigSymbol]; // The configuration was created as a prototype chain of the class hierarchy's
    // defaultConfig values hanging off a copy of the initialConfig object, so
    // we must loop and copy since Object.assign only copies own properties.

    for (const key in myConfig) {
      result[key] = myConfig[key];
    }

    return result;
  }
  /**
   * Registers this class type with its Factory
   */


  static initClass() {
    return this.$meta.class;
  }
  /**
   * The class's {@link #property-$meta-static meta} object.
   * @member {Object} $meta
   * @internal
   * @category Misc
   */

  /**
   * An object owned by this class that does not share properties with its super class.
   *
   * This object may contain other properties which are added as needed and are not documented here.
   *
   * @property {Object} $meta The class meta object.
   * @property {Function} $meta.class The class constructor that owns the meta object.
   * @property {Object} $meta.super The `$meta` object for the super class. This is `null` for `Base`.
   * @property {Object} $meta.config The object holding the default configuration values for this class.
   * @property {Object} $meta.configs An object keyed by config name that holds the defined configs for the class.
   * The value of each property is a {@link Core/Config} instance.
   * @property {Boolean} $meta.forkConfigs This will be `true` if the default configuration values for this class
   * (in the `config` property of the meta object) must be forked to avoid object sharing, or if the object can be
   * passed to `Object.create()` for efficiency.
   * @property {Function[]} $meta.hierarchy The array of classes in the ancestry of this class. This will start with
   * `Base` at index 0 and ends with this class.
   * @property {Function[]} $meta.properties The array of classes that define a "static get properties()" getter.
   * @internal
   * @static
   * @category Misc
   */


  static get $meta() {
    const me = this;
    let meta = me[metaSymbol];

    if (!hasOwnProperty.call(me, metaSymbol)) {
      me[metaSymbol] = meta = newMeta();
      meta.class = me;
      me.setupClass(meta);
    }

    return meta;
  }
  /**
   * This optional class method is called when a class is mixed in using the {@link #function-mixin-static mixin()}
   * method.
   * @internal
   */


  static onClassMixedIn() {// empty
  }
  /**
   * Returns the merge of the `baseConfig` and `config` config objects based on the configs defined by this class.
   * @param {Object} baseConfig The base config or defaults.
   * @param {...Object} configs One or more config objects that takes priority over `baseConfig`.
   * @returns {Object}
   * @internal
   */


  static mergeConfigs(baseConfig, ...configs) {
    const classConfigs = this.$meta.configs,
          result = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].clone(baseConfig) || {};
    let config, i, key, value;

    for (i = 0; i < configs.length; ++i) {
      config = configs[i];

      if (config) {
        for (key in config) {
          value = config[key];

          if (classConfigs[key]) {
            value = classConfigs[key].merge(value, result[key]);
          } else if (result[key] && value) {
            value = _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge(value, result[key]);
          }

          result[key] = value;
        }
      }
    }

    return result;
  }
  /**
   * Applies one or more `mixins` to this class and returns the produced class constructor.
   *
   * For example, instead of writing this:
   * ```
   *  class A extends Delayable(Events(Localizable(Base))) {
   *      // ...
   *  }
   * ```
   *
   * Using this method, one would write this:
   * ```
   *  class A extends Base.mixin(Localizable, Events, Delayable) {
   *      // ...
   *  }
   * ```
   * If one of the mixins specified has already been mixed into the class, it will be ignored and not mixed in a
   * second time.
   * @param {...Function} mixins
   * @returns {Function}
   */


  static mixin(...mixins) {
    // Starting w/the first class C = this
    let C = this,
        i; // wrap each class C using mixins[i] to produce the next class

    for (i = 0; i < mixins.length; ++i) {
      const mixin = mixins[i],
            // Grab or create a unique Symbol for this mixin so we can tell if we've already mixed it in
      tag = mixin[mixinTagSymbol] || (mixin[mixinTagSymbol] = Symbol('mixinTag'));

      if (C[tag]) {
        continue;
      }

      C = mixin(C);
      C[tag] = true; // properties on the constructor are inherited to subclass constructors...

      if (hasOwnProperty.call(C, 'onClassMixedIn')) {
        C.onClassMixedIn();
      }
    }

    return C;
  }
  /**
   * This method is called only once for any class. This can occur when the first instance is created or when the
   * `$meta` object is first requested.
   * @param {Object} meta The `$meta` object for the class.
   * @internal
   * @category Misc
   */


  static setupClass(meta) {
    var _base$nullify;

    const cls = meta.class,
          // Trigger setupClass on the super class (if it has yet to happen):
    base = getPrototypeOf(cls).$meta,
          name = cls.$$name,
          names = base.names,
          proto = cls.prototype;
    defineProperty(proto, '$meta', {
      value: meta
    });
    Object.assign(meta, {
      super: base,
      config: Object.create(base.config),
      configs: Object.create(base.configs),
      declarables: base.declarables,
      forkConfigs: base.forkConfigs,
      hierarchy: Object.freeze([...base.hierarchy, cls]),
      names: names.includes(name) ? names : Object.freeze([...names, name]),
      properties: base.properties,
      nullify: (_base$nullify = base.nullify) === null || _base$nullify === void 0 ? void 0 : _base$nullify.slice()
    });

    if (names !== meta.names) {
      const is = 'is' + name;

      if (!hasOwnProperty.call(proto, is)) {
        defineProperty(proto, is, {
          value: true
        });
      }

      if (!hasOwnProperty.call(cls, is)) {
        defineProperty(cls, is, {
          value: true
        });
      }
    } // NOTE: we always use meta.declarables because setupDeclarable() can replace the array on the meta object
    // when new declarable properties are added...


    for (let decl, setupName, i = 0; i < meta.declarables.length; ++i) {
      decl = meta.declarables[i];

      if (hasOwnProperty.call(cls, decl)) {
        setupName = setupNames[decl] || (setupNames[decl] = `setup${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(decl)}`);
        cls[setupName](cls, meta);
      }
    }
    /*  Add slash to the front of this line to enable the diagnostic block:
    /**/

  }
  /**
   * This method is called as part of `setupClass()`. It will process the `configurable()` return object and the
   * `defaultConfig` return object.
   * @param {Object} meta The `meta` object for this class.
   * @param {Object} configs The config definition object.
   * @param {Boolean} simple `true` when processing `defaultConfig` and `false` when processing `configurable`.
   * @private
   * @category Configuration
   */


  static setupConfigs(meta, configs, simple) {
    const classConfigValues = meta.config,
          classConfigs = meta.configs,
          cls = meta.class;
    let {
      nullify
    } = meta,
        cfg,
        defaultValue,
        options,
        setDefault,
        value,
        wasNullify;

    for (const name in configs) {
      value = configs[name];

      if (simple) {
        // Using "defaultConfig"
        if (!(cfg = classConfigs[name])) {
          cfg = _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].get(name, defaultConfigOptions);
        } else {
          // The property may be declared in a base class using configurable(), so it may have special
          // merge processing:
          value = cfg.merge(value, classConfigValues[name], meta);
        }
        /*  Add slash to the front of this line to enable the diagnostic block:
        /**/

      } else {
        // Using "configurable"
        defaultValue = options = setDefault = undefined;

        if (value && typeof value === 'object' && '$config' in value) {
          options = value.$config;

          if (options && !_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(options)) {
            options = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].createTruthyKeys(options);
          }

          setDefault = 'default' in value;
          defaultValue = setDefault ? value.default : defaultValue;
          value = value.value;
        }

        if (!(cfg = classConfigs[name])) {
          cfg = _Config_js__WEBPACK_IMPORTED_MODULE_4__["default"].get(name, options);
          cfg.define(cls.prototype);
          setDefault = !(cfg.field in cls.prototype); // reduce object shape changes (helps JIT)

          wasNullify = false;
        } else {
          wasNullify = cfg.nullify;

          if (options) {
            // Defined by a base class, but maybe being adjusted by derived.
            cfg = cfg.extend(options); // In the future, we may need to redefine the property here if options affect the descriptor (such
            // as event firing)
          }

          value = cfg.merge(value, classConfigValues[name], meta);
        }

        if (setDefault) {
          cfg.setDefault(cls, defaultValue);
        }

        if (cfg.nullify && !wasNullify) {
          (nullify || (nullify = meta.nullify || (meta.nullify = []))).push(cfg);
        }
      } // If any default properties are *mutable* Objects or Array we need to clone them.
      // so that instances do not share configured values.


      if (value && (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(value) || Array.isArray(value)) && !Object.isFrozen(value)) {
        meta.forkConfigs = true;
      }

      classConfigs[name] = cfg;
      classConfigValues[name] = value;
    }
  }

  static setupConfigurable(cls, meta) {
    cls.setupConfigs(meta, cls.configurable, false);
  }

  static setupDefaultConfig(cls, meta) {
    cls.setupConfigs(meta, cls.defaultConfig, true);
  }

  static setupDeclarable(cls, meta) {
    const declarable = cls.declarable;
    let all = meta.declarables,
        forked,
        i;

    for (i = 0; i < declarable.length; ++i) {
      if (!all.includes(declarable[i])) {
        if (!forked) {
          meta.declarables = forked = all = all.slice();
        }

        all.push(declarable[i]);
      }
    }
  }

  static setupProperties(cls, meta) {
    meta.properties = meta.super.properties.slice();
    meta.properties.push(cls);
    Object.freeze(meta.properties);
  }

  static setupPrototypeProperties(cls) {
    Object.assign(cls.prototype, cls.prototypeProperties);
  }
  /**
   * Gets the full {@link #property-defaultConfig-static} block for this object's entire inheritance chain
   * all the way up to but not including {@link Core.Base}
   * @return {Object} All default config values for this class.
   * @private
   * @category Configuration
   */


  getDefaultConfiguration() {
    return this.constructor.getDefaultConfiguration();
  }
  /**
   * Gets the full {@link #property-defaultConfig-static} block for the entire inheritance chain for this class
   * all the way up to but not including {@link Core.Base}
   * @return {Object} All default config values for this class.
   * @private
   * @category Configuration
   */


  static getDefaultConfiguration() {
    const meta = this.$meta,
          config = meta.forkConfigs ? Base.fork(meta.config) : Object.create(meta.config);

    if (_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isTestEnv && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isBrowserEnv && config.testConfig && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].global.__applyTestConfigs) {
      for (const o in config.testConfig) {
        config[o] = config.testConfig[o];
      }
    }

    return config;
  }

  static fork(obj) {
    let ret = obj,
        key,
        value;

    if (obj && _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(obj) && !Object.isFrozen(obj)) {
      ret = Object.create(obj);

      for (key in obj) {
        value = obj[key];

        if (value) {
          if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(value)) {
            ret[key] = Base.fork(value);
          } else if (Array.isArray(value)) {
            ret[key] = value.slice();
          }
        }
      }
    }

    return ret;
  }
  /**
   * Gets the full {@link #property-properties-static} block for this class's entire inheritance chain
   * all the way up to but not including {@link Core.Base}
   * @return {Object} All default config values for this class.
   * @private
   * @category Configuration
   */


  getProperties() {
    const // The meta.properties array is an array of classes that define "static get properties()"
    hierarchy = this.$meta.properties,
          result = {}; // TODO: if properties block does not change this could be cached? would speed up loading of big data sets
    //  into grid. The problem is that this call creates new (i.e., non-shared) instances of objects, arrays and
    //  Map objects that apply to each instance. These would all need to be cloned so it may be better to just
    //  call the properties getter each time and let it create new instances of whatever types.
    //for (cls of hierarchy) { // for-of transpiles badly and this is called a lot

    for (let i = 0; i < hierarchy.length; i++) {
      // Gather the class result in top-down order so that subclass properties override superclass properties
      Object.assign(result, hierarchy[i].properties);
    }

    return result;
  }

  static get superclass() {
    return getPrototypeOf(this);
  }
  /**
   * Used by the Widget and GridFeatureManager class internally. Returns the class hierarchy of this object
   * starting from the `topClass` class (which defaults to `Base`).
   *
   * For example `classHierarchy(Widget)` on a Combo would yield `[Widget, Field, TextField, PickerField, Combo]`
   * @param {Function} [topClass] The topmost class constructor to start from.
   * @returns {Function[]} The class hierarchy of this instance.
   * @private
   * @category Configuration
   */


  classHierarchy(topClass) {
    const hierarchy = this.$meta.hierarchy,
          index = topClass ? hierarchy.indexOf(topClass) : 0;
    return index > 0 ? hierarchy.slice(index) : hierarchy;
  }
  /**
   * Checks if an obj is of type using object's $$name property and doing string comparison of the property with the
   * type parameter.
   *
   * @param {String} type
   * @return {Boolean}
   */


  static isOfTypeName(type) {
    return this.$meta.names.includes(type);
  }
  /**
   * Removes all event listeners that were registered with the given `name`.
   * @param {String} name The name of the event listeners to be removed.
   * @category Events
   */


  detachListeners(name) {
    var _detachers;

    let detachers = this.$detachers;
    detachers = (_detachers = detachers) === null || _detachers === void 0 ? void 0 : _detachers[name];

    if (detachers) {
      while (detachers.length) {
        detachers.pop()();
      }
    }
  }
  /**
   * Tracks a detacher function for the specified listener name.
   * @param {String} name The name assigned to the associated listeners.
   * @param {Function} detacher The detacher function.
   * @private
   */


  trackDetacher(name, detacher) {
    const detachers = this.$detachers || (this.$detachers = {}),
          bucket = detachers[name] || (detachers[name] = []);
    bucket.push(detacher);
  }
  /**
   * Removes all detacher functions for the specified `Events` object. This is called
   * by the `removeAllListeners` method on that object which is typically called by its
   * `destroy` invocation.
   * @param {Core.mixin.Events} eventer The `Events` instance to untrack.
   * @private
   */


  untrackDetachers(eventer) {
    const detachers = this.$detachers;

    if (detachers) {
      for (const name in detachers) {
        const bucket = detachers[name];

        for (let i = bucket.length; i-- > 0;) {
          if (bucket[i].eventer === eventer) {
            bucket.splice(i, 1);
          }
        }
      }
    }
  }

}
const proto = Base.prototype; // Informs the standard config setter there is no need to call this fn:

proto.onConfigChange.$nullFn = true;
Base[metaSymbol] = proto.$meta = newMeta({
  class: Base,
  config: Object.freeze({}),
  configs: Object.create(null),
  declarables: Base.declarable,
  forkConfigs: false,
  hierarchy: Object.freeze([Base]),
  names: Object.freeze(['Base']),
  nullify: null,
  properties: Object.freeze([]),
  super: null
}); // Avoid some object shape changes:

Object.assign(proto, {
  $detachers: null,
  configObserver: null,

  /**
   * This property is set to `true` by {@link #function-destroy} after the {@link #function-doDestroy} method returns.
   * It is also one of the few properties that remains on the object after returning from `destroy()`. This property
   * is often checked in code paths that may encounter a destroyed object (like some event handlers) or in the
   * destruction path during cleanup.
   * @member {Boolean}
   * @readonly
   * @category Lifecycle
   */
  isDestroyed: false,

  /**
   * This property is set to `true` on entry to the {@link #function-destroy} method. It remains on the objects after
   * returning from `destroy()`. If {@link #property-isDestroyed} is `true`, this property will also be `true`, so
   * there is no need to test for both (for example, `comp.isDestroying || comp.isDestroyed`).
   * @member {Boolean}
   * @readonly
   * @category Lifecycle
   */
  isDestroying: false
});
_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setVersion('core', '4.3.6');
Base._$name = 'Base';

/***/ }),

/***/ "./lib/Core/Config.js":
/*!****************************!*\
  !*** ./lib/Core/Config.js ***!
  \****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Config; });
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
var productName = 'taskboard';
 // We cannot import ObjectHelper because of the import cycle:
//  ObjectHelper -> DateHelper -> LocaleManager -> Base -> us

/**
 * @module Core/Config
 */

const {
  defineProperty,
  getOwnPropertyDescriptor
} = Reflect,
      {
  hasOwnProperty,
  toString
} = Object.prototype,
      instancePropertiesSymbol = Symbol('instanceProperties'),
      configuringSymbol = Symbol('configuring'),
      lazyConfigValues = Symbol('lazyConfigValues'),
      DATE_TYPE = toString.call(new Date()),
      whitespace = /\s+/,
      createClsProps = (result, cls) => {
  result[cls] = 1;
  return result;
};
/**
 * This class holds the description of a config property. Only one instance of this class is needed for each config
 * name (e.g., "text"). If config options are supplied, however, they also contribute to the cached instance.
 *
 * Instances should always be retrieved by calling `Config.get()`.
 *
 * The **Configs** of this class correspond to `options` that can be supplied to the `get()` method. These affect the
 * behavior of the config property in some way, as descried by their respective documentation.
 *
 * This class is not used directly.
 *
 * ## The Setter
 * The primary functionality provided by `Config` is its standard setter. This setter function ensures consistent
 * behavior when modifying config properties.
 *
 * The standard setter algorithm is as follows (using the `'text'` config for illustration):
 *
 *  - If the class defines a `changeText()` method, call it passing the new value and the current value:
 *    `changeText(newText, oldText)`.<br>
 *    Then:
 *    * If `changeText()` exits without returning a value (i.e., `undefined`), exit and do nothing further. The
 *      assumption is that the changer method has done all that is required.
 *    * Otherwise, the return value of `changeText()` replaces the incoming value passed to the setter.
 *  - If the new value (or the value returned by `changeText()`) is `!==` to the current value:
 *    * Update the stored config value in `this._text`.
 *    * If the class defines an `updateText()` method, call it passing the new value and the previous value.
 *      `updateText(newText, oldText)`
 *    * If the class defines an `onConfigChange()` method, call it passing an object with the following properties:
 *        - `name` - The config's name
 *        - `value` - The new value
 *        - `was` - The previous value
 *        - `config` - The `Config` instance.
 *
 * NOTE: unlike `changeText()` and `updateText()`, the name of the `onConfigChange()` method is unaffected by the
 * config's name.
 *
 * @internal
 */


class Config {
  /**
   * Returns the `Config` instance for the given `name` and `options`.
   * @param {String} name The name of the config (e.g., 'text' for the text config).
   * @param {Object} [options] Config behavior options.
   * @returns {Core.Config}
   * @internal
   */
  static get(name, options) {
    const {
      cache
    } = this,
          baseCfg = cache[name] || (cache[name] = new Config(name));
    let cfg = baseCfg,
        key;

    if (options) {
      key = Config.makeCacheKey(name, options);

      if (!(cfg = key && cache[key])) {
        cfg = baseCfg.extend(options);

        if (key) {
          cache[key] = cfg;
        }
      }
    }

    return cfg;
  }

  constructor(name) {
    const me = this,
          cap = name[0].toUpperCase() + name.substr(1);
    me.base = me; // so extend()ed configs have a link to the base definition

    me.name = name;
    me.field = '_' + name;
    me.capName = cap;
    me.changer = 'change' + cap;
    me.initializing = 'initializing' + cap;
    me.updater = 'update' + cap;
  }
  /**
   * The descriptor to use with `Reflect.defineProperty()` for defining this config's getter and setter.
   * @property {Object}
   * @private
   */


  get descriptor() {
    let descriptor = this._descriptor;

    if (!descriptor || !hasOwnProperty.call(this, '_descriptor')) {
      // lazily make the descriptor
      this._descriptor = descriptor = this.makeDescriptor();
    }

    return descriptor;
  }
  /**
   * The descriptor to use with `Reflect.defineProperty()` for defining this config's initter.
   * @property {Object}
   * @private
   */


  get initDescriptor() {
    let descriptor = this._initDescriptor;

    if (!descriptor || !hasOwnProperty.call(this, '_initDescriptor')) {
      // lazily make the descriptor
      this._initDescriptor = descriptor = this.makeInitter();
    }

    return descriptor;
  }
  /**
   * This method compares two values for semantic equality. By default, this is based on the `===` operator. This
   * is often overridden for configs that accept `Date` or array values.
   * @param {*} value1
   * @param {*} value2
   * @returns {Boolean}
   * @internal
   */


  equal(value1, value2) {
    return value1 === value2;
  }
  /**
   * Extends this config with a given additional set of options. These objects are just prototype extensions of this
   * instance.
   * @param {Object} options
   * @returns {Core.Config}
   * @internal
   */


  extend(options) {
    const cfg = Object.assign(Object.create(this), options),
          {
      equal,
      merge
    } = options,
          {
      equalityMethods
    } = Config;

    if (typeof equal === 'string') {
      if (equal.endsWith('[]')) {
        cfg.equal = Config.makeArrayEquals(equalityMethods[equal.substr(0, equal.length - 2)]);
      } else {
        cfg.equal = equalityMethods[equal];
      }
    }

    if (typeof merge === 'string') {
      // Base uses { merge : 'replace' } for defaultConfig properties
      cfg.merge = Config.mergeMethods[merge];
    }

    return cfg;
  }
  /**
   * Defines the property on a given target object via `Reflect.defineProperty()`. If the object has its own getter,
   * it will be preserved. It is invalid to define a setter.
   * @param {Object} target
   * @internal
   */


  define(target) {
    const existing = getOwnPropertyDescriptor(target, this.name);
    let descriptor = this.descriptor;

    if (existing && existing.get) {
      descriptor = Object.assign({}, descriptor);
      descriptor.get = existing.get;
    }

    defineProperty(target, this.name, descriptor);
  }
  /**
   * Defines the property initter on the `target`. This is a property getter/setter that propagates the configured
   * value when the property is read.
   * @param {Object} target
   * @param {*} value
   * @internal
   */


  defineInitter(target, value) {
    const {
      name
    } = this,
          properties = target[instancePropertiesSymbol];
    let lazyValues, prop; // If there is an existing property with a getter/setter, *not* a value
    // defined on the object for this config we must call it in our injected getter/setter.

    if (!properties[name] && (
    /* assign */
    prop = getOwnPropertyDescriptor(target, name)) && !('value' in prop)) {
      properties[name] = prop;
    } // Set up a temporary instance property which will pull in the value from the initialConfig if the getter
    // is called first.


    defineProperty(target, name, this.initDescriptor);

    if (this.lazy) {
      lazyValues = target[lazyConfigValues] || (target[lazyConfigValues] = {
        $counter_: 0
      });
      lazyValues[name] = value;
      ++lazyValues.$counter_;
    }
  }
  /**
   * Returns an equality function for arrays of a base type, for example `'date'`.
   * @param {Function} [fn] The function to use to compare array elements. By default, operator `===` is used.
   * @returns {Function}
   * @private
   */


  static makeArrayEquals(fn) {
    return (value1, value2) => {
      let i,
          equal = value1 && value2 && value1.length === (i = value2.length);

      if (equal && Array.isArray(value1) && Array.isArray(value2)) {
        if (fn) {
          while (equal && i-- > 0) {
            equal = fn(value1[i], value2[i]);
          }
        } else {
          while (equal && i-- > 0) {
            equal = value1[i] === value2[i];
          }
        }
      } else {
        equal = fn ? fn(value1, value2) : value1 === value2;
      }

      return equal;
    };
  }
  /**
   * Returns the key to use in the Config `cache`.
   * @param {String} name The name of the config property.
   * @param {Object} options The config property options.
   * @returns {String}
   * @private
   */


  static makeCacheKey(name, options) {
    const keys = Object.keys(options).sort();

    for (let key, type, value, i = keys.length; i-- > 0;) {
      value = options[key = keys[i]];

      if (value == null && value === false) {
        keys.splice(i, 1);
      } else {
        type = typeof value;

        if (type === 'function') {
          return null;
        }

        if (type === 'string') {
          keys[i] = `${key}:"${value}"`;
        } else if (type === 'number') {
          keys[i] = `${key}:${value}`;
        } // that leaves bool and object, but there are no (valid) config options that are objects... so ignore

      }
    }

    return keys.length ? `${name}>${keys.join('|')}` : name; // eg: 'text>render|merge:v => v|bar'
  }
  /**
   * Creates and returns a property descriptor for this config suitable to be passed to `Reflect.defineProperty()`.
   * @returns {Object}
   * @private
   */


  makeDescriptor() {
    const config = this,
          {
      base,
      field,
      changer,
      updater,
      name
    } = config;

    if (base !== config && base.equal === config.equal) {
      // At present only the equal option affects the setter, so all configs can share the
      // descriptor of the base-most config definition unless their equality test fns differ.
      return base.descriptor;
    }

    return {
      get() {
        var _this$configObserver;

        // Allow folks like Widget.compose() to monitor getter calls
        (_this$configObserver = this.configObserver) === null || _this$configObserver === void 0 ? void 0 : _this$configObserver.get(name, this);
        return this[field];
      },

      set(value) {
        const me = this;
        let was = me[field],
            applied,
            newValue; // Resolve values starting with 'up.' by traversing owners to find it

        if (typeof value === 'string') {
          let resolvedValue = value;

          if (value.startsWith('up.')) {
            var _me$owner;

            resolvedValue = (_me$owner = me.owner) === null || _me$owner === void 0 ? void 0 : _me$owner.resolveProperty(value.substr(3));
          } else if (value.startsWith('this.')) {
            resolvedValue = me.resolveProperty(value.substr(5));
          } // TODO: Ignoring functions for now, we need to handle scope to make those work


          if (resolvedValue !== undefined && typeof resolvedValue !== 'function') {
            value = resolvedValue;
          }
        } // If the "changeTitle()" fellow falls off the end, it must have changed all the needful things.
        // Otherwise, it returned the final config value (it may have changed it instead, for example, making
        // an instance from a config object).


        if (me[changer]) {
          applied = (newValue = me[changer](value, was)) === undefined;

          if (!applied) {
            value = newValue;
            was = me[field]; // in case it was modified by the changer fn...
          }
        } // inline the default equal() for better perf:


        if (!applied && !(config.equal === equal ? was === value : config.equal(was, value))) {
          me[field] = value;
          applied = true; // Check for a "syncTitle()" method and call it if present.

          if (me[updater]) {
            me[updater](value, was);
          }
        }

        if (applied && !me.onConfigChange.$nullFn) {
          me.onConfigChange({
            name,
            value,
            was,
            config
          });
        }
      }

    };
  }
  /**
   * Creates and returns a property descriptor for this config's initter suitable to pass to
   * `Reflect.defineProperty()`.
   * @returns {Object}
   * @private
   */


  makeInitter() {
    const config = this;

    if (config !== config.base) {
      if (config.lazy) {
        return config.makeLazyInitter();
      } // At present no other options affect the setter, so all configs can share the descriptor of the base-most
      // config definition.


      return config.base.initDescriptor;
    }

    return config.makeBasicInitter();
  }

  makeBasicInitter() {
    const config = this,
          {
      initializing,
      name
    } = config;
    return {
      configurable: true,

      get() {
        const me = this;
        config.removeInitter(me); // Set the value from the configuration.

        me[initializing] = true;
        me[name] = me[configuringSymbol][name];
        me[initializing] = false; // The property has been *pulled* from the configuration.
        // Prevent the setting loop in configure from setting it again.

        me.configDone[name] = true; // Finally, allow the prototype getter to return the value.

        return me[name];
      },

      set(value) {
        config.removeInitter(this); // The config has been set (some internal code may have called the setter)
        // so prevent it from being called again and overwritten with data from initialConfig.

        this.configDone[name] = true; // Set the property normally (Any prototype setter will be invoked)

        this[name] = value;
      }

    };
  }

  makeLazyInitter() {
    const config = this,
          {
      initializing,
      name
    } = config;
    return {
      configurable: true,

      get() {
        const me = this,
              value = me[lazyConfigValues][name];
        config.removeInitter(me);

        if (!me.isDestroying) {
          // Set the value from the lazy config object.
          me[initializing] = true;
          me[name] = value;
          me[initializing] = false;
        } // Finally, allow the prototype getter to return the value.


        return me[name];
      },

      set(value) {
        config.removeInitter(this); // Set the property normally (Any prototype setter will be invoked)

        this[name] = value;
      }

    };
  }
  /**
   * Removes the property initter and restores the instance to its original form.
   * @param {Object} instance
   * @private
   */


  removeInitter(instance) {
    const {
      name
    } = this,
          instanceProperty = instance[instancePropertiesSymbol][name]; // If we took over from an instance property, replace it

    if (instanceProperty) {
      defineProperty(instance, name, instanceProperty);
    } // Otherwise just delete the instance property who's getter we are in.
    else {
      delete instance[name];
    }

    if (this.lazy) {
      if (! --instance[lazyConfigValues].$counter_) {
        delete instance[lazyConfigValues];
      }
    }
  }

  setDefault(cls, value) {
    defineProperty(cls.prototype, this.field, {
      configurable: true,
      writable: true,
      // or else "this._value = x" will fail
      value
    });
  }
  /**
   * This method combines (merges) two config values. This is called in two cases:
   *
   *  - When a derived class specifies the value of a config defined in a super class.
   *  - When a value is specified in the instance config object.
   *
   * @param {*} newValue In the case of derived classes, this is the config value of the derived class. In the case
   * of the instance config, this is the instance config value.
   * @param {*} currentValue In the case of derived classes, this is the config value of the super class. In the case
   * of the instance config, this is the class config value.
   * @param {Object} meta The class meta object from which the `newValue` is coming. This parameter is `null` if the
   * `newValue` is from an instance configuration.
   * @returns {*}
   * @internal
   */


  merge(newValue, currentValue) {
    if (currentValue && newValue && _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(currentValue) && _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(newValue)) {
      newValue = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].merge(_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].clone(currentValue), newValue);
    }

    return newValue;
  }

}
const {
  prototype
} = Config,
      {
  equal
} = prototype;
Config.symbols = {
  configuring: configuringSymbol,
  instanceProperties: instancePropertiesSymbol,
  lazyConfigs: lazyConfigValues
};
/**
 * This object holds `Config` instances keyed by their name. For example:
 * ```
 *  Config.cache = {
 *      disabled : Config.get('disabled'),
 *      text     : Config.get('text'),
 *      title    : Config.get('title')
 *  };
 * ```
 * @member {Object} cache
 * @static
 * @private
 */

Config.cache = Object.create(null); // object w/no properties not even inherited ones

/**
 * This object holds config value equality methods. By default, the `===` operator is used to compare config values for
 * semantic equality. When an `equal` option is specified as a string, that string is used as a key into this object.
 *
 * All equality methods in this object have the same signature as the {@link #function-equal equal()} method.
 *
 * This object has the following equality methods:
 *
 * - `array` : Compares arrays of values using `===` on each element.
 * - `date` : Compares values of `Date` type.
 * - `strict` : The default equal algorithm based on `===` operator.
 * @member {Object} equalityMethods
 * @static
 * @private
 */

Config.equalityMethods = {
  array: Config.makeArrayEquals(),

  date(value1, value2) {
    if (value1 === value2) {
      return true;
    } // see DateHelper.isDate() but cannot import due to circularity


    if (value1 && value2 && toString.call(value1) === DATE_TYPE && toString.call(value2) === DATE_TYPE) {
      // https://jsbench.me/ltkb3vk0ji/1 - getTime is >2x faster vs valueOf/Number/op+
      return value1.getTime() === value2.getTime();
    }

    return false;
  },

  strict: Config.equal = equal
};
/**
 * This object holds config value merge methods. By default, {@link Core.helper.ObjectHelper#function-merge-static} is
 * used to merge object's by their properties. Config merge methods are used to combine config values from derived
 * classes with config values from super classes, as well as instance config values with those of the class.
 *
 * All merge methods in this object have the same signature as the {@link #function-merge merge()} method.
 *
 * This object has the following merge methods:
 *
 * - `distinct`   : Combines arrays of values ensuring that no value is duplicated. When given an object, its truthy
 *   keys are included, while its falsy keys are removed from the result.
 * - `merge`      : The default merge algorithm for `configurable()` properties, based on
 *   {@link Core.helper.ObjectHelper#function-merge-static}.
 * - `items`      : Similar to `merge`, but allows reordering (see `Objects.mergeItems`).
 * - `objects`    : The same as to `merge` except this method promotes `true` to an empty object.
 * - 'classList'  : Incoming strings are converted to an object where the string is a property name with a truthy value.
 * - `replace`    : Always returns `newValue` to replace the super class value with the derived class value, or the
 *   class value with the instance value.
 * @member {Object} mergeMethods
 * @static
 * @private
 */

Config.mergeMethods = {
  distinct(newValue, oldValue) {
    let ret = oldValue ? oldValue.slice() : [];

    if (newValue != null) {
      if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(newValue)) {
        if (oldValue === undefined) {
          ret = newValue;
        } else {
          let key, index;

          for (key in newValue) {
            index = ret.indexOf(key);

            if (newValue[key]) {
              if (index < 0) {
                ret.push(key);
              }
            } else if (index > -1) {
              ret.splice(index, 1);
            }
          }
        }
      } else if (Array.isArray(newValue)) {
        newValue.forEach(v => !ret.includes(v) && ret.push(v));
      } else if (!ret.includes(newValue)) {
        ret.push(newValue);
      }
    }

    return ret;
  },

  merge: Config.merge = prototype.merge,

  classList(newValue, oldValue) {
    // 'foo bar' -> { foo : 1, bar : 1 }
    if (typeof newValue === 'string') {
      if (!newValue.length) {
        return oldValue;
      }

      newValue = newValue.split(whitespace).reduce(createClsProps, {});
    }

    return Config.merge(newValue, oldValue);
  },

  objects(newValue, oldValue) {
    return newValue === true ? oldValue || {} : Config.merge(newValue, oldValue);
  },

  replace(newValue) {
    return newValue;
  },

  items(newValue, oldValue) {
    return _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].mergeItems(oldValue, newValue, {
      merge: (oldValue, newValue) => prototype.merge(newValue, oldValue)
    });
  }

};
Object.assign(prototype, {
  _descriptor: null,
  _initDescriptor: null,

  /**
   * A function that compares values for equality. This test is used to determine if the `update` method should be
   * called when the setter is invoked.
   *
   * To handle `Date` values:
   * ```
   *  class Foo extends Base {
   *      static get configurable() {
   *          return {
   *              date : {
   *                  $config : {
   *                      equal : 'date'
   *                  },
   *
   *                  value : null
   *              }
   *          }
   *      }
   *
   *      updateDate(date) {
   *          // date has changed
   *      }
   *  }
   * ```
   *
   * Also useful for some configs:
   * ```
   *  class Foo extends Base {
   *      static get configurable() {
   *          return {
   *              bar : {
   *                  $config : {
   *                      equal : ObjectHelper.isEqual
   *                  },
   *
   *                  value : null
   *              }
   *          }
   *      }
   *
   *      updateBar(value) {
   *          // value has changed
   *      }
   *  }
   * ```
   * @config {Function} equal
   * @internal
   */

  /**
   * Indicates that this config property should not automatically initialize during construction, but instead should
   * wait for the first explicit use of the property getter.
   * @config {Boolean}
   * @default
   * @internal
   */
  lazy: false,

  /**
   * Indicates that this config property should automatically be set to `null` on destroy.
   * @config {Boolean}
   * @default
   * @internal
   */
  nullify: false,

  /**
   * Indicates that this config participates in rendering. This has does not affect the behavior of the property
   * directly, but allows classes that perform rendering to detect which config changes will affect the rendered
   * result.
   * @config {Boolean}
   * @default
   * @internal
   */
  render: false // TODO FUTURES
  // clear   (bool - set to null during cleanup)
  // destroy (bool - destroy value during cleanup)
  // evented (bool - fire event on change / after updater)

});
Config._$name = 'Config';

/***/ }),

/***/ "./lib/Core/GlobalEvents.js":
/*!**********************************!*\
  !*** ./lib/Core/GlobalEvents.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'taskboard';



/**
 * @module Core/GlobalEvents
 */

const isFloatingWidget = w => w.floating;

const GlobalEvents = new class extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  suspendFocusEvents() {
    focusEventsSuspended = true;
  }

  resumeFocusEvents() {
    focusEventsSuspended = false;
  }

  setupFocusListenersOnce(rootElement, EventHelper) {
    if (rootElement && !GlobalEvents.observedElements.has(rootElement)) {
      GlobalEvents.setupFocusListeners(rootElement, EventHelper);
      GlobalEvents.observedElements.add(rootElement);
    }
  } // This is imported by EventHelper and that makes the call to set up the listeners
  // `detach` argument is required to not setup more listeners than we need to. In case of salesforce we include floatroot
  // inside the webcomponent element and thus don't need default listeners on document. In regular webcomponents demo we
  // don't need to do it, because with multiple components on one page that would force us to make more complex lookups.


  setupFocusListeners(element = document, EventHelper, detach = false) {
    var _detacher;

    const listeners = {
      element,

      touchstart(touchstart) {
        if (!globaltouchStart && touchstart.changedTouches.length === 1) {
          globaltouchStart = touchstart.changedTouches[0];
        } else {
          globaltouchStart = null;
        }
      },

      // Just this one has to be passive: false so that we are allowed to preventDefault
      // if we are part of a contextmenu longpress emulation. Otherwise the gesture will
      // proceed to cause a mousedown event.
      touchend: {
        handler: event => {
          if (globaltouchStart) {
            // If the touchstart was used to synthesize a contextmenu event
            // stop the touch gesture processing right now.
            // Also prevent the conversion of the touch into  click.
            if (globaltouchStart.identifier === EventHelper.contextMenuTouchId) {
              event.stopImmediatePropagation();
              event.preventDefault();
            } else if (event.changedTouches.length === 1 && event.changedTouches[0].identifier === globaltouchStart.identifier) {
              GlobalEvents.trigger('globaltap', {
                event
              });
            }

            globaltouchStart = null;
          }
        },
        passive: false
      },
      mousedown: {
        handler: event => {
          lastInteractionType = 'mouse';

          if (!globaltouchStart) {
            GlobalEvents.trigger('globaltap', {
              event
            });
          }
        },
        passive: false
      },

      keydown() {
        lastInteractionType = 'key';
      },

      keypress() {
        lastInteractionType = 'key';
      },

      focusin(focusin) {
        const {
          Widget
        } = GlobalEvents; // https://app.assembla.com/spaces/bryntum/tickets/5503
        // Caused by the browser scrolling a focused element into view. The browser will do *whatever it takes*
        // to scroll a focused element so that as much of it is in view as possible. Its first point of scrolling will
        // be the float containing element. That must never scroll.
        // TODO: Remove when https://www.w3.org/TR/css-overflow-3/#valdef-overflow-clip is supported.

        Widget.resetFloatRootScroll();

        if (focusEventsSuspended) {
          return;
        }

        const fromElement = !focusin.relatedTarget ? null : focusin.relatedTarget instanceof HTMLElement ? focusin.relatedTarget : document.body,
              toElement = focusin.target || document.body,
              fromWidget = Widget.fromElement(fromElement),
              toWidget = Widget.fromElement(toElement),
              commonAncestor = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getCommonAncestor(fromWidget, toWidget),
              // Flag if the fromElement is DOCUMENT_POSITION_FOLLOWING toElement
        backwards = !!(fromElement && toElement.compareDocumentPosition(fromElement) & 4),
              topVisibleModal = Widget.query(isTopVisibleModal);
        let currentFocus = null;

        if (toElement && toElement !== document.body) {
          currentFocus = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getActiveElement(toElement);
        } else {
          currentFocus = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getActiveElement(document);
        } // If there is a topmost modal, and the focus is moving to somewhere *not* a descendant of that
        // modal, and that somewhere is not in a floater that us *above* that modal (the compareDocumentPosition call),
        // then we enforce modality and sweep focus back into the modal.
        // By default the Container class will yield the first focusable descendant widget's focusEl as its
        // focusEl, so that will be out of the box behaviour for Popups.


        if (topVisibleModal) {
          if (!toWidget || !topVisibleModal.owns(toWidget) && !(topVisibleModal.element.compareDocumentPosition(toWidget.element) & 4 && toWidget.up(isFloatingWidget))) {
            return topVisibleModal.focus();
          }
        }

        let event = createWidgetEvent('focusout', fromElement, focusin.target, fromWidget, toWidget, backwards); // Bubble focusout event up the "from" side of the tree

        for (let target = fromWidget; target && target !== commonAncestor; target = target.owner) {
          if (!target.isDestroying && target.onFocusOut) {
            target.onFocusOut(event); // It is possible for focusout handlers to refocus themselves (editor's invalidAction='block'), so
            // check if the focus is still where it was when we started unless we are in a document
            // loss of focus situation (no target)

            if (focusin.target && currentFocus !== _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getActiveElement(focusin.target)) {
              // If the focus has moved, that movement would have kicked off a nested sequence of focusin/out
              // notifications, so everyone has already been notified... no more to do here.
              return;
            }
          }
        } // Focus is moving upwards to the ancestor widget.
        // Its focus method might delegate focus to a focusable descendant.


        if (commonAncestor && focusin.target === commonAncestor.element) {
          // If one of the handlers above has not moved focus onwards
          // and the common ancestor is a container which delegates
          // focus inwards to a descendant, then give it the opportunity to do that.
          if (!commonAncestor.isDestroying && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getActiveElement(commonAncestor) === toElement && commonAncestor.focusElement && commonAncestor.focusElement !== commonAncestor.element) {
            // If focus is not inside, move focus inside
            if (!commonAncestor.element.contains(currentFocus)) {
              // Wait until out of the focusin handler to move focus on.
              commonAncestor.setTimeout(() => {
                var _commonAncestor$focus;

                return (_commonAncestor$focus = commonAncestor.focus) === null || _commonAncestor$focus === void 0 ? void 0 : _commonAncestor$focus.call(commonAncestor);
              }, 0);
            }
          }
        } // Focus is moving between two branches of a subtree.
        // Bubble focusin event up the "to" side of the tree
        else {
          event = createWidgetEvent('focusin', toElement, fromElement, fromWidget, toWidget, backwards);

          for (let target = toWidget; target && target !== commonAncestor; target = target.owner) {
            if (!target.isDestroying) {
              var _target$onFocusIn, _target;

              (_target$onFocusIn = (_target = target).onFocusIn) === null || _target$onFocusIn === void 0 ? void 0 : _target$onFocusIn.call(_target, event);
            }
          }
        } // Fire element focusmove event. Grid navigation will use  this when cells are focusable.


        const commonAncestorEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getCommonAncestor((fromElement === null || fromElement === void 0 ? void 0 : fromElement.nodeType) === Element.ELEMENT_NODE ? fromElement : null, toElement) || toElement.parentNode;
        event = createWidgetEvent('focusmove', toElement, fromElement, fromWidget, toWidget, backwards, {
          bubbles: true
        });
        commonAncestorEl.dispatchEvent(event);
      },

      focusout(focusout) {
        if (focusEventsSuspended) {
          return;
        }

        if (!focusout.relatedTarget || !GlobalEvents.Widget.fromElement(focusout.relatedTarget)) {
          // When switching between tabs in Salesforce app `relatedTarget` of the focusout event might be not an instance of
          // HTMLElement.
          const target = focusout.relatedTarget && focusout.relatedTarget instanceof HTMLElement ? focusout.relatedTarget : null;
          listeners.focusin({
            target,
            relatedTarget: focusout.target
          });
        }
      },

      capture: true,
      passive: true
    }; // detach previous listeners

    detach && ((_detacher = detacher) === null || _detacher === void 0 ? void 0 : _detacher());
    detacher = EventHelper.on(listeners);
  }

  get lastInteractionType() {
    return lastInteractionType;
  }

}(),
      isTopVisibleModal = w => w.isVisible && w.isTopModal;

GlobalEvents.observedElements = new Set();
/**
 * Fired after the theme is changed
 * @event theme
 * @param {Core.GlobalEvents} source
 * @param {String} theme The new theme name
 */

let globaltouchStart,
    focusEventsSuspended = false,
    lastInteractionType,
    detacher;

function createWidgetEvent(eventName, target, relatedTarget, fromWidget, toWidget, backwards, options) {
  const result = new CustomEvent(eventName, options); // Workaround for Salesforce. They use strict mode and define non-configurable property `target`. We use this
  // CustomEvent as a synthetic one, feels fine to use non-standard handle for target.

  Object.defineProperty(result, '_target', {
    get() {
      return target;
    }

  });
  Object.defineProperty(result, 'relatedTarget', {
    get() {
      return relatedTarget;
    }

  });
  result.fromWidget = fromWidget;
  result.toWidget = toWidget;
  result.backwards = backwards;
  return result;
}
/**
 * A singleton firing global application level events like 'theme'.
 *
 * ```javascript
 * GlobalEvents.on({
 *    theme() {
 *        // react to theme changes here
 *    }
 * });
 * ```
 *
 * @class
 * @singleton
 * @mixes Core/mixin/Events
 */


/* harmony default export */ __webpack_exports__["default"] = (GlobalEvents);

/***/ }),

/***/ "./lib/Core/customElements/WidgetTag.js":
/*!**********************************************!*\
  !*** ./lib/Core/customElements/WidgetTag.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetTag; });
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
var productName = 'taskboard';
/**
* @module Core/customElements/WidgetTag
*/





/**
 * A base class for a custom web component element wrapping one {@link Core.widget.Widget}.
 */

class WidgetTag extends (window.customElements ? HTMLElement : Object) {
  /**
   * The widget instance rendered in the shadow root
   * @member {Core.widget.Widget} widget
   */

  /**
   * Path to theme to use within the web component.
   *
   * ```html
   * <bryntum-grid stylesheet="resources/grid.stockholm.css">
   * </bryntum-grid>
   * ```
   *
   * @config {String} stylesheet
   */

  /**
   * Path to folder containing Font Awesome 5 Free.
   *
   * ```html
   * <bryntum-grid fa-path="resources/fonts">
   * </bryntum-grid>
   * ```
   *
   * @config {String} faPath
   */
  connectedCallback() {
    this.setup();
  }

  async setup() {
    const me = this; // Setup just once

    if (me.shadowRoot) {
      return;
    }

    let linkResolver, font;
    const product = me.tagName.substring('BRYNTUM-'.length).toLowerCase(),
          // Only load fa if not already on page, otherwise each instance will load it
    faPath = (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isChrome || !document.fonts.check(`normal 14px "Font Awesome 5 Free"`)) && me.getAttribute('fa-path'),
          themeLink = document.getElementById('bryntum-theme'),
          theme = me.getAttribute('theme') || 'stockholm',
          stylesheet = me.getAttribute('stylesheet') || (themeLink === null || themeLink === void 0 ? void 0 : themeLink.href) || `${product}.${theme}.css`,
          // Go over to the dark side
    shadowRoot = me.attachShadow({
      mode: 'open'
    }),
          // Include css and target div in shadow dom
    link = me.linkTag = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].createElement({
      tag: 'link',
      rel: 'stylesheet',
      href: stylesheet,
      parent: shadowRoot
    }),
          promises = [new Promise(resolve => {
      linkResolver = resolve;
    })],
          config = {
      appendTo: shadowRoot,
      features: {}
    };
    me.convertDatasetToConfigs(me.dataset, config);

    link.onload = () => linkResolver(); // Load FontAwesome if path was supplied


    if (faPath) {
      // FF cannot use the name "Font Awesome 5 Free", have if fixed in CSS to handle it also without spaces
      font = new FontFace(_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFirefox ? 'FontAwesome5Free' : 'Font Awesome 5 Free', `url("${faPath}/fa-solid-900.woff2")`);
      promises.push(font.load());
    }

    await Promise.all(promises);

    if (font) {
      document.fonts.add(font);
    } // Create columns, data and configure features


    for (const tag of me.children) {
      const tagName = tag.tagName;

      if (tagName === 'FEATURE') {
        const name = tag.dataset.name,
              featureConfig = me.convertDatasetToConfigs(tag.dataset);
        delete featureConfig.name;

        if (Object.keys(featureConfig).length) {
          config.features[name] = featureConfig.use === 'false' ? false : featureConfig;
        } else {
          config.features[name] = tag.textContent !== 'false';
        }
      } else if (tagName === 'TBAR' || tagName === 'BBAR') {
        config[tagName.toLowerCase()] = Array.from(tag.children).map(item => me.convertDatasetToConfigs(item.dataset));
      } else if (tagName === 'INLINESTYLE') {
        const style = document.createElement('style');
        style.innerHTML = tag.innerHTML;
        shadowRoot.appendChild(style);
      }
    }

    me.widget = me.createInstance(config);
  }

  convertDatasetToConfigs(dataset, config = {}, ignoreObjects = false) {
    for (const key in dataset) {
      let value = dataset[key];

      if (!ignoreObjects && typeof value === 'string' && value.startsWith('{')) {
        value = this.convertDatasetToConfigs(JSON.parse(value.replace(/'/g, '"')));
      } else {
        var _StringHelper$safeJso;

        value = (_StringHelper$safeJso = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].safeJsonParse(value)) !== null && _StringHelper$safeJso !== void 0 ? _StringHelper$safeJso : value;
      }

      config[key] = value;
    }

    return config;
  }
  /**
   * Destroys the inner widget instance and cleans up
   */


  destroy() {
    var _sharedTips$tooltip, _sharedTips$tooltip$g, _sharedTips$errorTool;

    const me = this;

    if (!me.widget) {
      // Removed before anything could be created
      return;
    }

    const {
      shadowRoot
    } = me,
          sharedTips = shadowRoot.bryntum,
          constructor = me.widget.constructor,
          floatRoot = shadowRoot.querySelector('.b-float-root');
    sharedTips === null || sharedTips === void 0 ? void 0 : (_sharedTips$tooltip = sharedTips.tooltip) === null || _sharedTips$tooltip === void 0 ? void 0 : (_sharedTips$tooltip$g = _sharedTips$tooltip.get(_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_3__["default"])) === null || _sharedTips$tooltip$g === void 0 ? void 0 : _sharedTips$tooltip$g.destroy();
    sharedTips === null || sharedTips === void 0 ? void 0 : (_sharedTips$errorTool = sharedTips.errorTooltip) === null || _sharedTips$errorTool === void 0 ? void 0 : _sharedTips$errorTool.destroy();
    me.widget.destroy();
    floatRoot === null || floatRoot === void 0 ? void 0 : floatRoot.remove();
    constructor.removeFloatRoot(floatRoot);
    me.linkTag.remove();
    me.widget = null;
  }

}
WidgetTag._$name = 'WidgetTag';

/***/ }),

/***/ "./lib/Core/data/AjaxStore.js":
/*!************************************!*\
  !*** ./lib/Core/data/AjaxStore.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AjaxStore; });
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';



/**
 * @module Core/data/AjaxStore
 */

const processParamEntry = (paramArray, entry) => {
  if (Array.isArray(entry[1])) {
    entry[1].forEach(value => paramArray.push(encodeURIComponent(entry[0]) + '=' + encodeURIComponent(value)));
  } else {
    paramArray.push(encodeURIComponent(entry[0]) + '=' + encodeURIComponent(entry[1]));
  }

  return paramArray;
},
      immediatePromise = Promise.resolve();
/**
 * Store that uses the Fetch API to read data from a remote server, and optionally sends synchronization
 * requests to the server containing information about locally created, modified and deleted records.
 *
 * ## Create
 * Posts array of JSON data for newly added records to {@link #config-createUrl}, expects response containing an array of JSON objects
 * in same order with id set (uses Model#idField as id).
 *
 * ## Read
 * Reads array of JSON data from the data packet returned from the {@link #config-readUrl}. Unique id for each row is required.
 * By default looks in field 'id' but can be configured by setting {@link Core.data.Model#property-idField-static}.
 *
 * ## Update
 * Posts array of JSON data containing modified records to {@link #config-updateUrl}. By default, only changed fields and
 * any fields configured with {@link Core.data.field.DataField#config-alwaysWrite} are sent.
 * If you want all fields to always be sent, please see {@link #config-writeAllFields}
 *
 * ## Delete
 * Posts to {@link #config-deleteUrl} with removed records ids (for example id=1,4,7).
 *
 * ```javascript
 * new AjaxStore({
 *   createUrl  : 'php/create',
 *   readUrl    : 'php/read',
 *   updateUrl  : 'php/update',
 *   deleteUrl  : 'php/delete',
 *   modelClass : Customer
 * });
 * ```
 *
 * ## Pagination
 * Configuring an `AjaxStore` with {@link #config-pageParamName} or {@link #config-pageStartParamName} means that the store requests **pages**
 * of data from the remote source, sending the configured {@link #config-pageParamName} or {@link #config-pageStartParamName} to request the page
 * along with the {@link #config-pageSizeParamName}.
 *
 * If `pageParamName` is set, that is passed with the requested page number **(one based)**, along with the {@link #config-pageSizeParamName}.
 *
 * If `pageStartParamName` is set, that is passed with the requested page starting record index **(zero based)**, along with the {@link #config-pageSizeParamName}.
 *
 * ## Remote filtering
 * To specify that filtering is the responsibility of the server, configure the store with
 * `{@link #config-filterParamName}: 'nameOfFilterParameter'`
 *
 * When this is set, any {@link Core.data.mixin.StoreFilter#function-filter} operation causes the store to
 * reload itself, encoding the filters as JSON representations in the {@link #config-filterParamName} HTTP
 * parameter.
 *
 * The filters will look like this:
 * ```javascript
 * {
 *     "field": "country",
 *     "operator": "=",
 *     "value": "sweden",
 *     "caseSensitive": false
 * }
 * ```
 *
 * The encoding may be overridden by configuring an implementation of {@link #function-encodeFilterParams}
 * into the store which returns the value for the {@link #config-filterParamName} when passed an _Iterable_ of filters.
 *
 * ## Remote sorting
 * To specify that sorting is the responsibility of the server, configure the store with
 * `{@link #config-sortParamName}: 'nameOfSortParameter'`
 *
 * When this is set, any {@link Core.data.mixin.StoreSort#function-sort} operation causes the store to
 * reload itself, encoding the sorters as JSON representations in the {@link #config-sortParamName} HTTP
 * parameter.
 *
 * The sorters will look like this:
 * ```javascript
 * {
 *     "field": "name",
 *     "ascending": true
 * }
 * ```
 *
 * The encoding may be overridden by configuring an implementation of {@link #function-encodeSorterParams}
 * into the store which returns the value for the {@link #config-sortParamName} when passed an _Iterable_ of sorters.
 *
 * @extends Core/data/Store
 */


class AjaxStore extends _Store_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // region Events

  /**
   * Fired when a remote request fails, either at the network level, or the server returns a failure, or an invalid response.
   *
   * Note that when a {@link #function-commit} fails, more than one exception event will be triggered. The individual operation,
   * `create`, `update` or `delete` will trigger their own `exception` event, but the encapsulating commit operation will also
   * trigger an `exception` event when all the operations have finished, so if exceptions are going to be handled gracefully,
   * the event's `action` property must be examined, and the constituent operations of the event must be examined.
   * @event exception
   * @param {Core.data.Store} source This Store
   * @param {Boolean} exception `true`
   * @param {String} action Action that failed, `'create'`, `'read'`, `'update'` or `'delete'`. May also be fired
   * with '`commit'` to indicate the failure of an aggregated `create`, `update` and `delete` operation. In this case,
   * the event will contain a property for each operation of the commit named `'create'`, `'update'` and `'delete'`,
   * each containing the individual `exception` events.
   * @param {String} exceptionType The type of failure, `'network'` or `'server'`
   * @param {Response} response the `Response` object
   * @param {Object} json The decoded response object *if the exceptionType is `'server'`*
   */

  /**
   * Fired after committing added records
   * @event commitAdded
   * @param {Core.data.Store} source This Store
   */

  /**
   * Fired after committing modified records
   * @event commitModified
   * @param {Core.data.Store} source This Store
   */

  /**
   * Fired on successful load
   * @event load
   * @param {Core.data.Store} source This Store
   * @param {Object[]} data Data loaded
   * @param {Response} response the `Response` object
   * @param {Object} json The decoded response object.
   */

  /**
   * Fired on successful load of remote child nodes for a tree node.
   * @event loadChildren
   * @param {Core.data.Store} source This Store
   * @param {Object[]} data Data loaded
   * @param {Object} json The decoded response object.
   */

  /**
   * Fired after committing removed records
   * @event commitRemoved
   * @param {Core.data.Store} source This Store
   */

  /**
   * Fired before loading starts. Allows altering parameters and is cancelable
   * @event beforeLoad
   * @preventable
   * @param {Core.data.Store} source This Store
   * @param {Object} params An object containing property/name pairs which are the parameters.
   * This may be mutated to affect the parameters used in the Ajax request.
   */

  /**
   * Fired before loading of remote child nodes of a tree node starts. Allows altering parameters and is cancelable
   * @event beforeLoadChildren
   * @preventable
   * @param {Core.data.Store} source This Store
   * @param {Object} params An object containing property/name pairs which are the parameters.
   * This may be mutated to affect the parameters used in the Ajax request.
   */

  /**
   * When the store {@link #property-isPaged is paged}, this is fired before loading a page and is cancelable
   * @event beforeLoadPage
   * @preventable
   * @param {Core.data.Store} source This Store
   * @param {Object} params An object containing property/name pairs which are the parameters.
   * This may be mutated to affect the parameters used in the Ajax request.
   */

  /**
   * Fired when loading is beginning. This is not cancelable. Parameters in the event may still be
   * mutated at this stage.
   * @event loadStart
   * @param {Core.data.Store} source This Store
   * @param {Object} params An object containing property/name pairs which are the parameters.
   * This may be mutated to affect the parameters used in the Ajax request.
   */

  /**
   * Fired when loading of remote child nodes into a tree node is beginning. This is not cancelable. Parameters in the event may still be
   * mutated at this stage.
   * @event loadChildrenStart
   * @param {Core.data.Store} source This Store
   * @param {Object} params An object containing property/name pairs which are the parameters.
   * This may be mutated to affect the parameters used in the Ajax request.
   */

  /**
   * Fired before any remote request is initiated.
   * @event beforeRequest
   * @param {Core.data.Store} source This Store
   * @param {Object} params An object containing key/value pairs that are passed on the request query string
   * @param {Object} body The body of the request to be posted to the server.
   * @param {String} action Action that is making the request, `'create'`, `'read'`, `'update'` or `'delete'`
   */

  /**
   * Fired after any remote request has finished whether successfully or unsuccessfully.
   * @event afterRequest
   * @param {Boolean} exception `true`. *Only present if the request triggered an exception.*
   * @param {String} action Action that has finished, `'create'`, `'read'`, `'update'` or `'delete'`
   * @param {String} exceptionType The type of failure, `'network'` or `'server'`. *Only present if the request triggered an exception.*
   * @param {Response} response The `Response` object
   * @param {Object} json The decoded response object if there was no `'network'` exception.
   */
  // endregion
  //region Config
  static get defaultConfig() {
    return {
      /**
       * An object containing the HTTP headers to add to each server request issued by this Store.
       * @config {Object}
       * @default
       * @category Remote
       */
      headers: null,

      /**
       * An object containing the Fetch options to pass to each server request issued by this Store. Use this to control if credentials are sent
       * and other options, read more at [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch).
       * @config {Object}
       * @default
       * @category Remote
       */
      fetchOptions: null,

      /**
       * Specify `true` to send payloads as form data, `false` to send as regular JSON.
       * @config {Boolean}
       * @default
       * @category Remote
       */
      sendAsFormData: false,

      /**
       * Specify `true` to send all model fields when committing modified records (as opposed to just the modified fields)
       * @config {Boolean}
       * @default
       * @category Remote
       */
      writeAllFields: null,

      /**
       * The name of the HTTP parameter passed to this Store's {@link #config-readUrl} to indicate the node `id` to
       * load when loading child nodes on demand if the node being expanded was created with data containing `children: true`.
       * @config {String}
       * @default
       * @category Remote
       */
      parentIdParamName: 'id',

      /**
       * The optional property name in JSON responses from the server that contains a boolean
       * success/fail status.
       * ```
       * {
       *   "responseMeta" : {
       *   {
       *     "success" : true,
       *     "count" : 100
       *   },
       *   // The property name used here should match that of 'responseDataProperty'
       *   "data" : [
       *     ...
       *   ]
       * }
       * ```
       *
       * The store would be configured with:
       * ```javascript
       *  {
       *      ...
       *      successDataProperty : 'responseMeta.success',
       *      responseTotalProperty : 'responseMeta.count'
       *      ...
       *  }
       *
       * ```
       * @config {String}
       * @default
       * @category Remote
       */
      responseSuccessProperty: 'success',

      /**
       * The property name in JSON responses from the server that contains the data for the records
       * ```
       * {
       *   "success" : true,
       *   // The property name used here should match that of 'responseDataProperty'
       *   "data" : [
       *     ...
       *   ]
       * }
       * ```
       * @config {String}
       * @default
       * @category Remote
       */
      responseDataProperty: 'data',

      /**
       * The property name in JSON responses from the server that contains the dataset total size
       * **when this store {@link #property-isPaged is paged}**
       * ```
       * {
       *   "success" : true,
       *   // The property name used here should match that of 'responseDataProperty'
       *   "data" : [
       *     ...
       *   ],
       *   // The property name used here should match that of 'responseTotalProperty'
       *   "total" : 65535
       * }
       * ```
       * @config {String}
       * @default
       * @category Remote
       */
      responseTotalProperty: 'total',

      /**
       * The name of the HTTP parameter to use to pass any encoded filters when loading data from the server and a filtered response is required.
       *
       * **Note:** When this is set, filters must be defined using a field name, an operator and a value
       * to compare, **not** a comparison function.
       * @config {String}
       * @category Remote
       */
      filterParamName: null,

      /**
       * Set this flag to true if you are filtering remote using restful URLs (e.g. https://nominatim.openstreetmap.org/search/paris?format=json)
       *
       * **Note:** When this is set, the filter string is appended to the readUrl.
       * @config {Boolean}
       * @category Remote
       */
      restfulFilter: false,

      /**
       * The name of the HTTP parameter to use to pass any encoded sorters when loading data from the server and a sorted response is required.
       *
       * **Note:** When this is set, sorters must be defined using a field name and an ascending flag,
       * **not** a sort function.
       * @config {String}
       * @category Remote
       */
      sortParamName: null,

      /**
       * The name of the HTTP parameter to use when requesting pages of data using the **one based** page number required.
       * @config {String}
       * @category Paging
       */
      pageParamName: null,

      /**
       * The name of the HTTP parameter to use when requesting pages of data using the **zero based** index of the required page's starting record.
       * @config {String}
       * @category Paging
       */
      pageStartParamName: null,

      /**
       * The name of the HTTP parameter to use when requesting pages of data using the **zero based** index of the required page's starting record.
       * @config {String}
       * @default
       * @category Paging
       */
      pageSizeParamName: 'pageSize',

      /**
       * When paging of data is requested by setting _either_ the {@link #config-pageParamName} _or_ the {@link #config-pageStartParamName},
       * this is the value to send in the {@link #config-pageSizeParamName}
       * @config {Number}
       * @default
       * @category Paging
       */
      pageSize: 50,

      /**
       * Set to ´true´ to use restful {@link #config-httpMethods}
       * @config {Boolean}
       * @default
       * @category Remote
       */
      useRestfulMethods: false,

      /**
       * The HTTP methods to use for CRUD requests when {@link #config-useRestfulMethods} is enabled.
       *
       * ```
       * new AjaxStore({
       *    useRestfulMethods : true,
       *    httpMethods : {
       *        create : 'POST',
       *        read : 'POST',
       *        update : 'PATCH',
       *        delete : 'DELETE'
       *    }
       * });
       *
       * ```
       * @config {Object}
       * @default
       * @category Remote
       */
      httpMethods: {
        create: 'POST',
        read: 'GET',
        update: 'PUT',
        delete: 'DELETE'
      }
    };
  }

  static get configurable() {
    return {
      /**
       * An object containing key/value pairs that are passed on the request query string.
       * @member {Object} params
       * @category Remote
       */

      /**
       * An object containing key/value pairs that are passed on the request query string.
       * @config {Object}
       * @category Remote
       */
      params: null
    };
  }
  /**
   * Url to post newly created records to.
   *
   * The response must be in the form:
   *
   *     {
   *         "success": true,
   *         "data": [{
   *             "id": 0, "name": "General Motors"
   *         }, {
   *             "id": 1, "name": "Apple"
   *         }]
   *     }
   *
   * Just the array of data may be returned, however that precludes the
   * orderly handling of errors encountered at the server.
   *
   * If the server encountered an error, the packet would look like this:
   *
   *     {
   *         "success": false,
   *         "message": "Some kind of database error"
   *     }
   *
   * And that packet would be available in the {@link #event-exception} handler
   * in the `response` property of the event.
   *
   * The `success` property may be omitted, it defaults to `true`.
   *
   * @config {String} createUrl
   * @category CRUD
   */

  /**
   * Url to read data from.
   *
   * The response must be in the form:
   *
   *     {
   *         "success": true,
   *         "data": [{
   *             "id": 0, "name": "General Motors"
   *         }, {
   *             "id": 1, "name": "Apple"
   *         }]
   *     }
   *
   * If the store {@link #property-isPaged is paged}, the total dataset size must be returned
   * in the {@link #config-responseTotalProperty} property:
   *
   *     {
   *         "success": true,
   *         "data": [{
   *             "id": 0, "name": "General Motors"
   *         }, {
   *             "id": 1, "name": "Apple"
   *         }],
   *         "total": 65535
   *     }
   *
   * Just the array of data may be returned, however that precludes the
   * orderly handling of errors encountered at the server.
   *
   * If the server encountered an error, the packet would look like this:
   *
   *     {
   *         "success": false,
   *         "message": "Some kind of database error"
   *     }
   *
   * And that packet would be available in the {@link #event-exception} handler
   * in the `response` property of the event.
   *
   * The `success` property may be omitted, it defaults to `true`.
   *
   * @config {String} readUrl
   * @category CRUD
   */

  /**
   * Url to post record modifications to.
   *
   * The response must be in the form:
   *
   *     {
   *         "success": true,
   *         "data": [{
   *             "id": 0, "name": "General Motors"
   *         }, {
   *             "id": 1, "name": "Apple"
   *         }]
   *     }
   *
   * Just the array of data may be returned, however that precludes the
   * orderly handling of errors encountered at the server.
   *
   * If the server encountered an error, the packet would look like this:
   *
   *     {
   *         "success": false,
   *         "message": "Some kind of database error"
   *     }
   *
   * And that packet would be available in the {@link #event-exception} handler
   * in the `response` property of the event.
   *
   * The `success` property may be omitted, it defaults to `true`.
   *
   * @config {String} updateUrl
   * @category CRUD
   */

  /**
   * Url for deleting records.
   *
   * The response must be in the form:
   *
   *     {
   *         "success": true
   *     }
   *
   * If the server encountered an error, the packet would look like this:
   *
   *     {
   *         "success": false,
   *         "message": "Some kind of database error"
   *     }
   *
   * And that packet would be available in the {@link #event-exception} handler
   * in the `response` property of the event.
   *
   * The `success` property may be omitted, it defaults to `true`.
   *
   * @config {String} deleteUrl
   * @category CRUD
   */

  /**
   * True to initiate a load when the store is instantiated
   * @config {Boolean} autoLoad
   * @category Common
   */
  //endregion


  afterConstruct(config) {
    super.afterConstruct(config);

    if (this.autoLoad) {
      this.load().catch(() => {});
    }
  }
  /**
   * Returns true if the Store is currently loading
   * @property {Boolean}
   * @readonly
   * @category CRUD
   */


  get isLoading() {
    return this._isLoading;
  }
  /**
   * Returns true if the Store is currently committing
   * @property {Boolean}
   * @readonly
   * @category CRUD
   */


  get isCommitting() {
    return Boolean(this.commitPromise);
  }

  set pageParamName(pageParamName) {
    if (this.tree) {
      throw new Error('Paging cannot be supported for tree stores');
    }

    if (this.pageStartParamName) {
      throw new Error('Configs pageStartParamName and pageParamName are mutually exclusive');
    }

    this._pageParamName = pageParamName;
  }

  get pageParamName() {
    return this._pageParamName;
  }

  set pageStartParamName(pageStartParamName) {
    if (this.tree) {
      throw new Error('Paging cannot be supported for tree stores');
    }

    if (this.pageParamName) {
      throw new Error('Configs pageParamName and pageStartParamName are mutually exclusive');
    }

    this._pageStartParamName = pageStartParamName;
  }

  get pageStartParamName() {
    return this._pageStartParamName;
  }
  /**
   * Yields true if this Store is loaded page by page. This yields `true` if either of the {@link #config-pageParamName}
   * of {@link #config-pageStartParamName} configs are set.
   * @property {Boolean}
   * @readonly
   * @category Paging
   */


  get isPaged() {
    return this.pageParamName || this.pageStartParamName;
  }
  /**
   * Yields the complete dataset size. If the store is {@link #property-isPaged is paged} this is the value
   * returned in the last loaded data block in the {@link #config-responseTotalProperty} property. Otherwise it is
   * the number of records in the store's underlying storage collection.
   * @property {Number}
   * @readonly
   * @category Paging
   */


  get allCount() {
    return 'remoteTotal' in this ? this.remoteTotal : super.allCount;
  }
  /**
   * **If the store {@link #property-isPaged is paged}**, yields the highest page number in the dataset as calculated from the {@link #config-responseTotalProperty}
   * returned in the last page data block loaded.
   * @property {Number}
   * @readonly
   * @category Paging
   */


  get lastPage() {
    if (this.isPaged) {
      return Math.floor((this.allCount + this.pageSize - 1) / this.pageSize);
    }
  }

  buildQueryString(url, ...paramObjects) {
    const hasParamsInUrl = url.includes('?'),
          queryString = Object.entries(Object.assign({}, ...paramObjects)).reduce(processParamEntry, []).join('&');
    return queryString ? (hasParamsInUrl ? '&' : '?') + queryString : '';
  }

  performSort(silent) {
    const me = this;

    if (me.sortParamName) {
      const {
        groupRecords
      } = me,
            // Current collapsed state for groups
      collapsed = {}; // Temporarily remove group headers, will be re-added after sort

      if (me.isGrouped && groupRecords !== null && groupRecords !== void 0 && groupRecords.length) {
        // TODO: Replace with same logic as used elsewhere
        groupRecords.forEach(r => {
          if (r.meta.collapsed) {
            me.includeGroupRecords(r);
            collapsed[r.id] = true;
          }
        });
      } // TODO: Should we cache lastParams from the load call and use them here?


      return me.internalLoad({}, '', event => {
        me.data = event.data;
        me.afterPerformSort(silent, collapsed);
      });
    } else {
      super.performSort(silent);
    }
  }

  performFilter(silent) {
    const me = this; // For remote filtering, the dataset cannot be preserved. The size may be completely different.
    // This is a reload operation.

    if (me.remoteFilter) {
      const oldCount = me.count,
            {
        filters
      } = me; // load should default to page 1

      me.currentPage = 1; // TODO: Should we cache lastParams from the load call and use them here?

      return me.internalLoad({}, '', event => {
        me.data = event.data;
        me.afterPerformFilter(silent ? null : {
          action: 'filter',
          filters,
          oldCount,
          records: me.storage.values
        });
      });
    } else {
      super.performFilter(silent);
    }
  }
  /**
   * A provided function which creates an array of values for the {@link #config-filterParamName} to pass
   * any filters to the server upon load.
   *
   * By default, this creates a JSON string containing the following properties:
   *
   * ```javascript
   *    [{
   *        field         : <theFieldName>
   *        operator      : May be: `'='`, `'!='`, `'>'`, `'>='`, `'<'`, `'<='`, `'*'`, `'startsWith'`, `'endsWith'`
   *        value         : The value to compare
   *        caseSensitive : true for case sensitive comparisons
   *    }]
   * ```
   * @param {Core.util.CollectionFilter[]} filters The filters to encode.
   */


  encodeFilterParams(filters) {
    const result = [];

    for (const {
      property,
      operator,
      value,
      caseSensitive
    } of filters) {
      result.push({
        field: property,
        operator,
        value,
        caseSensitive
      });
    }

    return JSON.stringify(result);
  }
  /**
   * A provided function which creates an array of values for the {#config-sortParamName} to pass
   * any sorters to the server upon load.
   *
   * By default, this creates a JSON string containing the following properties:
   *
   * ```javascript
   *    [{
   *        field     : <theFieldName>
   *        ascending : true/false
   *    }]
   * ```
   *
   * @param {Object[]} sorters The sorters to encode.
   */


  encodeSorterParams(sorters) {
    return JSON.stringify(sorters.filter(sorter => !sorter.sortFn).map(sorter => sorter));
  }

  buildReadUrl() {
    const {
      readUrl
    } = this;

    if (this.restfulFilter && this.filters.count) {
      const url = readUrl.endsWith('/') ? readUrl : readUrl + '/';
      return url + this.filters.first.value;
    } else {
      return readUrl;
    }
  }

  internalLoad(params, eventName, successFn) {
    const me = this,
          allParams = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, me.params, params),
          url = me.buildReadUrl(),
          event = {
      action: 'read' + eventName,
      params: allParams,
      url
    };
    return url ? new Promise((resolve, reject) => {
      if (me.trigger('beforeLoad' + eventName, event) === false) {
        return reject(false); // eslint-disable-line
      }

      me._isLoading = true; // This may look redundant, but it allows for two levels of event listening.
      // Granular, where the observer observes only the events of interest, and
      // catch-all, where the observer is interested in all requests.

      me.trigger(`load${eventName}Start`, event);
      me.trigger('beforeRequest', event); // Add filter information to the request parameters

      if (me.filterParamName && me.isFiltered) {
        allParams[me.filterParamName] = me.encodeFilterParams(me.filters.values);
      } // Add sorter information to the request parameters.
      // isSorted includes grouping in its evaluation.


      if (me.sortParamName && me.isSorted) {
        allParams[me.sortParamName] = me.encodeSorterParams(me.groupers ? me.groupers.concat(me.sorters) : me.sorters);
      } // Ensure our next page is passed to the server in the params if not already set.
      // Ensure our page size is always passed.


      if (me.isPaged) {
        if (!(me.pageParamName in allParams || me.pageStartParamName in allParams)) {
          const page = Math.min(me.currentPage || 1, me.allCount ? me.lastPage : Infinity);

          if (me.pageParamName) {
            allParams[me.pageParamName] = page;
          } else {
            allParams[me.pageStartParamName] = (page - 1) * me.pageSize;
          }
        }

        allParams[me.pageSizeParamName] = me.pageSize;
      }

      const options = {
        headers: me.headers,
        parseJson: true
      };

      if (me.useRestfulMethods) {
        options.method = me.httpMethods.read;
      }

      _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(event.url + me.buildQueryString(event.url, allParams), _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(options, me.fetchOptions)).then(async response => {
        const data = response.parsedJson,
              isArray = Array.isArray(data),
              success = isArray || data && _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, me.responseSuccessProperty) !== false,
              remoteTotal = isArray ? null : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, me.responseTotalProperty);
        me._isLoading = false;
        event.response = response;
        event.json = data;

        if (success) {
          if (remoteTotal != null) {
            me.remoteTotal = parseInt(remoteTotal, 10);
          } // If we are issuing paged requests, work out what page we are on based
          // on the requested page and the size of the dataset declared.


          if (me.isPaged) {
            if (me.remoteTotal >= 0) {
              const requestedPage = me.pageParamName ? allParams[me.pageParamName] : allParams[me.pageStartParamName] / me.pageSize + 1;
              me.currentPage = Math.min(requestedPage, me.lastPage);
            } else {
              throw new Error('A paged store must receive its responseTotalProperty in each data packet');
            }
          }

          event.data = isArray ? data : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, me.responseDataProperty);
          await successFn(event);
          me.trigger('load' + eventName, event);
          resolve(event);
        } else {
          event.exception = true;
          event.exceptionType = 'server';
          me.trigger('exception', event);
          reject(event);
        } // finally


        me.trigger('afterRequest', event);
      }).catch(responseOrError => {
        me._isLoading = false;
        event.exception = true;

        if (responseOrError instanceof Response) {
          event.exceptionType = responseOrError.ok ? 'server' : 'network';
          event.response = responseOrError;
          event.error = responseOrError.error;
        } else {
          event.exceptionType = 'server';
          event.error = responseOrError;
        }

        me.trigger('exception', event);
        reject(event); // finally

        me.trigger('afterRequest', event);
      });
    }) : null;
  }
  /**
   * Load data from the {@link #config-readUrl}.
   * @param {Object} [params] A hash of parameters to append to querystring (will also append Store#params)
   * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
   * vetoed by a {@link #event-beforeLoad} handler, or if an {@link #event-exception} is detected.
   * The resolved function is passed the event object passed to any event handlers.
   * The rejected function is passed the {@link #event-exception} event if an exception occurred,
   * or `false` if the load was vetoed by a {@link #event-beforeLoad} handler.
   * @fires beforeLoad
   * @fires loadStart
   * @fires beforeRequest
   * @fires load
   * @fires exception
   * @fires afterRequest
   * @category CRUD
   * @async
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   */


  async load(params) {
    const me = this;

    if (me.isPaged) {
      return me.loadPage(me.currentPage || 1, params);
    } else {
      return me.internalLoad(params, '', event => {
        // The set Data setter will trigger the refresh event with { action: 'dataset' }
        me.data = event.data;
      });
    }
  }
  /**
   * Loads children into specified parent record. Parent records id is sent as a param (param name configured with
   * {@link #config-parentIdParamName}.
   * @param {Core.data.Model} parentRecord Parent record
   * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
   * vetoed by a {@link #event-beforeLoadChildren} handler, or if an {@link #event-exception} is detected.
   * The resolved function is passed the event object passed to any event handlers.
   * The rejected function is passed the {@link #event-exception} event if an exception occurred,
   * or `false` if the load was vetoed by a {@link #event-beforeLoadChildren} handler.
   * @fires beforeLoadChildren
   * @fires loadChildrenStart
   * @fires beforeRequest
   * @fires loadChildren
   * @fires exception
   * @fires afterRequest
   * @category CRUD
   * @async
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   */


  async loadChildren(parentRecord) {
    return this.internalLoad({
      [this.parentIdParamName]: parentRecord.id
    }, 'Children', event => {
      event.parentRecord = parentRecord;

      if (parentRecord.children.length) {
        parentRecord.clearChildren(true);
      } // Append received children


      parentRecord.data[parentRecord.constructor.childrenField] = event.data;
      parentRecord.processChildren(parentRecord.stores);
    });
  }
  /**
   * Loads a page of data from the {@link #config-readUrl}.
   * @param {Number} page The *one based* page number to load.
   * @param {Object} params A hash of parameters to append to querystring (will also append Store#params)
   * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
   * vetoed by a {@link #event-beforeLoadPage} handler, or if an {@link #event-exception} is detected.
   * The resolved function is passed the event object passed to any event handlers.
   * The rejected function is passed the {@link #event-exception} event if an exception occurred,
   * or `false` if the load was vetoed by a {@link #event-beforeLoadPage} handler.
   * @fires beforeLoadPage
   * @fires loadPageStart
   * @fires beforeRequest
   * @fires loadPage
   * @fires exception
   * @fires afterRequest
   * @category CRUD
   * @async
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   */


  async loadPage(page, params) {
    if (this.allCount) {
      page = Math.min(page, this.lastPage);
    }

    const me = this,
          pageParam = me.pageParamName ? {
      [me.pageParamName]: page
    } : {
      [me.pageStartParamName]: (page - 1) * me.pageSize
    };
    pageParam[me.pageSizeParamName] = me.pageSize;
    return me.internalLoad(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(pageParam, params), 'Page', event => {
      // We go directly to loadPage because paging a tree store is unsupportable.
      // loadPage will trigger the refresh event with { action: 'pageLoad' }
      me.loadData(event.data, 'pageLoad');
    });
  }
  /**
   * If this store {@link #property-isPaged is paged}, and is not already at the {@link #property-lastPage}
   * then this will load the next page of data.
   * @fires beforeLoadPage
   * @fires loadPageStart
   * @fires beforeRequest
   * @fires loadPage
   * @fires exception
   * @fires afterRequest
   * @category CRUD
   * @async
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   */


  async nextPage(params) {
    return this.isPaged && this.currentPage !== this.lastPage ? this.loadPage(this.currentPage + 1, params) : immediatePromise;
  }
  /**
   * If this store {@link #property-isPaged is paged}, and is not already at the first page
   * then this will load the previous page of data.
   * @fires beforeLoadPage
   * @fires loadPageStart
   * @fires beforeRequest
   * @fires loadPage
   * @fires exception
   * @fires afterRequest
   * @category CRUD
   * @async
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   */


  async previousPage(params) {
    return this.isPaged && this.currentPage !== 1 ? this.loadPage(this.currentPage - 1, params) : immediatePromise;
  }
  /**
   * Commits all changes (added, modified and removed) using corresponding urls ({@link #config-createUrl},
   * {@link #config-updateUrl} and {@link #config-deleteUrl})
   * @fires beforeCommit
   * @returns {Promise} A Promise which is resolved only if all pending changes (Create, Update and Delete) successfully resolve.
   * Both the resolve and reject functions are passed a `commitState` object which is stored the {@link #event-afterRequest}
   * event for each request. Each event contains the `exception`, `request` and `response` properties eg:
   *
   * ```javascript
   * {
   *      // If *all* commits succeeded
   *      success: true,
   *      changes: {
   *          added: [records...],
   *          modified: [records...],
   *          removed: [records...],
   *      },
   *      added: {
   *          source: theStore,
   *
   *          // Only if the add request triggered an exception
   *          exception: true,
   *
   *          // Only if the add request triggered an exception
   *          exceptionType: 'server', // Or 'network'
   *
   *          response: Response,
   *          json: parsedResponseObject
   *      },
   *      // Same format as added
   *      modified: {},
   *      removed: {}
   * }
   * ```
   *
   * If there were no pending changes, the resolve and reject functions are passed no parameters.
   *
   * Returns `false` if a commit operation is already in progress.
   * The resolved function is passed the event object passed to any event handlers.
   * The rejected function is passed the {@link #event-exception} event if an exception occurred,
   * @category CRUD
   * @async
   * @returns {Promise} A promise which is resolved when all the Ajax requests complete and have been processed.
   */


  async commit() {
    const me = this,
          {
      changes
    } = me,
          allPromises = []; // not allowing additional commits while in progress
    // TODO: should queue

    if (me.commitPromise) {
      return false;
    } // No outstanding changes, return a Promise that resolves immediately.


    if (!changes) {
      // Special handling of modified. If only non-persistable fields have been modified, it wont count among
      // `changes`, but still needs to be cleared
      if (me.modified.count) {
        me.modified.forEach(record => record.clearChanges(false));
        me.modified.clear();
      }

      return immediatePromise;
    }

    if (me.trigger('beforeCommit', {
      changes
    }) !== false) {
      // Flag all affected records as being committed
      [...changes.added, ...changes.modified, ...changes.removed].forEach(record => record.meta.committing = true); // Commit was not prevented in beforeCommit listener, so we begin the commit

      me.trigger('commitStart', {
        changes
      });
      const commitState = {
        action: 'commit',
        exception: false,
        changes
      };
      let p = me.commitRemoved(commitState);

      if (p) {
        allPromises.push(p);
      }

      p = me.commitAdded(commitState);

      if (p) {
        allPromises.push(p);
      }

      p = me.commitModified(commitState);

      if (p) {
        allPromises.push(p);
      } // If there were no urls configured, behave as a local store


      if (!allPromises.length) {
        me.modified.forEach(r => r.clearChanges(false));
        me.modified.clear();
        me.added.forEach(r => r.clearChanges(false));
        me.added.clear();
        me.removed.clear();
        me.trigger('commit', {
          changes
        });
        return immediatePromise;
      } // The Promises from the commit methods all resolve whether the request
      // succeeded or not. They each contribute their afterrequest event to the
      // commitState which can be used to detect overall success or failure
      // and granular inspection of which operations succeeded or failed.
      // If there's only one operation, wait for it.
      // If there's more than one operation, we have to wait for allPromises to resolve.


      p = allPromises.length === 1 ? allPromises[0] : Promise.all(allPromises);
      return me.commitPromise = new Promise((resolve, reject) => {
        p.then(() => {
          me.commitPromise = null;

          if (commitState.exception) {
            me.trigger('exception', commitState);
            reject(commitState);
          } else {
            me.trigger('commit', {
              changes
            });
            resolve(commitState);
          }
        }).catch(() => {
          me.commitPromise = null;
          reject(commitState);
        });
      });
    }
  } // Performs background autocommit with reject checking


  doAutoCommit() {
    if (this.suspendCount <= 0) {
      this.commit().catch(commitState => {
        const {
          response
        } = commitState; // Skip throw if response is `ok` or `status` is 500 or 404 and request is successfully parsed
        // These errors are notified by API events

        if (!(response && (response.ok && response.parsedJson || [500, 404].includes(response.status)))) {
          throw commitState;
        }
      });
    }
  } // TODO: need a way to abort commits

  /**
   * Commits added records by posting to {@link #config-createUrl}.
   * Server should return a JSON object with a 'success' property indicating whether the operation was successful.
   * @param {Object} commitState An object into which is added a `delete` property being the {@link #event-afterRequest} event.
   * @returns {Promise} If there are added records, a Promise which will be resolved whether the commit
   * succeeds or fails. The resulting event is placed into the `add` property of the passed `commitState`
   * parameter. If there are no added records, `null` is returned.
   * The resolved function is passed the event object passed to any event handlers.
   * @private
   * @fires beforeRequest
   * @fires commitAdded
   * @fires refresh
   * @fires exception
   * @fires afterRequest
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   * @async
   */


  commitAdded(commitState) {
    const me = this,
          added = me.added,
          event = {
      action: 'create',
      params: me.params
    };
    return added.count && me.createUrl ? new Promise(resolve => {
      const toAdd = added.values.map(r => r.persistableData);
      commitState.create = event;
      let dataToSend = event.body = {
        data: toAdd
      };
      me.trigger('beforeRequest', event);

      if (me.sendAsFormData) {
        const formData = new FormData();
        formData.append('data', JSON.stringify(toAdd));
        dataToSend = formData;
      }

      const options = {
        headers: me.headers,
        parseJson: true
      };

      if (me.useRestfulMethods) {
        options.method = me.httpMethods.create;
      }

      _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].post(me.createUrl + me.buildQueryString(me.createUrl, me.params), dataToSend, _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(options, me.fetchOptions)).then(response => {
        const data = response.parsedJson,
              isArray = Array.isArray(data),
              success = isArray || data && data.success !== false;
        commitState.response = response;
        event.json = data;
        event.response = response;

        if (success) {
          // Copy updated fields and updated ID back into records.
          // This also calls clearChanges on each record.
          me.processReturnedData(added.values, isArray ? data : data[me.responseDataProperty]); // Clear down added records cache

          added.clear();
          me.trigger('commitAdded'); // We must signal a full refresh because any number of records could have received any number of field updates
          // back from the server, so a refresh is more efficient than picking through the received updates.

          me.trigger('refresh', event);
          resolve(commitState);
        } else {
          // Clear committing flag
          added.forEach(r => r.meta.committing = false);
          commitState.exception = event.exception = true;
          commitState.exceptionType = event.exceptionType = 'server';
          me.trigger('exception', event);
          resolve(commitState);
        } // finally


        me.trigger('afterRequest', event);
      }).catch(responseOrError => {
        // Clear committing flag
        added.forEach(r => r.meta.committing = false);
        commitState.exception = event.exception = true;

        if (responseOrError instanceof Response) {
          commitState.response = responseOrError;
          event.exceptionType = responseOrError.ok ? 'server' : 'network';
          event.response = responseOrError;
          event.error = responseOrError.error;
        } else {
          event.exceptionType = 'server';
          event.error = responseOrError;
        }

        me.trigger('exception', event);
        resolve(commitState); // finally

        me.trigger('afterRequest', event);
      });
    }) : null;
  }
  /**
   * Commits modified records by posting to {@link #config-updateUrl}.
   * Server should return a JSON object with a 'success' property indicating whether the operation was successful.
   * @param {Object} commitState An object into which is added a `delete` property being the {@link #event-afterRequest} event.
   * @returns {Promise} If there are added records, a Promise which will be resolved whether the commit
   * succeeds or fails. The resulting event is placed into the `update` property of the passed `commitState`
   * parameter. If there are no added records, `null` is returned.
   * The resolved function is passed the event object passed to any event handlers.
   * @private
   * @fires beforeRequest
   * @fires commitModified
   * @fires refresh
   * @fires exception
   * @fires afterRequest
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   * @async
   */


  commitModified(commitState) {
    const me = this,
          // Only include persistable changes
    {
      modified
    } = me.changes,
          event = {
      action: 'update',
      params: me.params
    },
          result = modified.length && me.updateUrl ? new Promise(resolve => {
      // Use the record's modificationData, not modifications.
      // modifications returns a map using *field names*
      // The server will expect a map using the original dataSource properties.
      const modifications = modified.map(record => {
        if (me.writeAllFields) {
          return record.persistableData;
        } else {
          return record.modificationDataToWrite;
        }
      }).filter(el => !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEmpty(el)); // Check if modifications are empty and don't make request

      if (modifications.length === 0) {
        me.modified.clear();
        modified.forEach(r => r.meta.committing = false);
        resolve();
        return;
      }

      commitState.update = event;
      let dataToSend = event.body = {
        data: modifications
      };
      me.trigger('beforeRequest', event);

      if (me.sendAsFormData) {
        const formData = new FormData();
        formData.append('data', JSON.stringify(modifications));
        dataToSend = formData;
      }

      const options = {
        headers: me.headers,
        parseJson: true
      };

      if (me.useRestfulMethods) {
        options.method = me.httpMethods.update;
      }

      _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].post(me.updateUrl + me.buildQueryString(me.updateUrl, me.params), dataToSend, _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(options, me.fetchOptions)).then(response => {
        const data = response.parsedJson,
              isArray = Array.isArray(data),
              success = isArray || data && data.success !== false;
        commitState.response = response;
        event.json = data;
        event.response = response;

        if (success) {
          // Copy updated fields and updated ID back into records.
          // This also calls clearChanges on each record.
          me.processReturnedData(modified, isArray ? data : data[me.responseDataProperty], true); // Clear down modified records cache

          me.modified.clear();
          me.trigger('commitModified'); // We must signal a full refresh because any number of records could have received any number of field updates
          // back from the server, so a refresh is more efficient than picking through the received updates.

          me.trigger('refresh', event);
          resolve(commitState);
        } else {
          // Clear committing flag
          modified.forEach(r => r.meta.committing = false);
          commitState.exception = event.exception = true;
          event.exceptionType = 'server';
          me.trigger('exception', event);
          resolve(commitState);
        } // finally


        me.trigger('afterRequest', event);
      }).catch(responseOrError => {
        // Clear committing flag
        modified.forEach(r => r.meta.committing = false);
        commitState.exception = event.exception = true;

        if (responseOrError instanceof Response) {
          commitState.response = responseOrError;
          event.exceptionType = responseOrError.ok ? 'server' : 'network';
          event.response = responseOrError;
          event.error = responseOrError.error;
        } else {
          event.exceptionType = 'server';
          event.error = responseOrError;
        }

        me.trigger('exception', event);
        resolve(commitState); // finally

        me.trigger('afterRequest', event);
      });
    }) : null; // Also clear non-persistable changes

    if (!modified.length && me.modified.count) {
      me.modified.clear();
    }

    return result;
  }

  processReturnedData(localRecords, returnedData, isUpdating = false) {
    const me = this,
          Model = me.modelClass,
          idDataSource = Model.fieldMap.id.dataSource;
    returnedData.forEach((recData, i) => {
      const record = localRecords[i]; // Must clear changed state before syncId goes through store.onModelChange

      record.clearChanges(false); // Using syncId to update record's id with no flagging the property as modified.

      record.syncId(recData[idDataSource]); // When updating, only want to apply the actual changes and not reapply defaults. When adding, also
      // apply the defaults

      Object.assign(localRecords[i].data, Model.processData(recData, isUpdating));
    });
  }
  /**
   * Commits removed records by posting to {@link #config-deleteUrl}.
   * Server should return a JSON object with a 'success' property indicating whether the operation was successful.
   * @param {Object} commitState An object into which is added a `delete` property being the {@link #event-afterRequest} event.
   * @returns {Promise} If there are added records, a Promise which will be resolved whether the commit
   * succeeds or fails. The resulting event is placed into the `delete` property of the passed `commitState`
   * parameter. If there are no added records, `null` is returned.
   * The resolved function is passed the event object passed to any event handlers.
   * @private
   * @fires beforerequest
   * @fires commitremoved
   * @fires refresh
   * @fires exception
   * @fires afterrequest
   * @returns {Promise} A promise which is resolved when the Ajax request completes and has been processed.
   * @async
   */


  commitRemoved(commitState) {
    const me = this,
          removed = me.removed,
          event = {
      action: 'delete',
      params: me.params
    };
    return removed.count && me.deleteUrl ? new Promise(resolve => {
      commitState.delete = event;
      let dataToSend = event.body = {
        ids: removed.map(r => r.id)
      };
      me.trigger('beforeRequest', event);

      if (me.sendAsFormData) {
        const formData = new FormData();
        formData.append('id', JSON.stringify(dataToSend.ids));
        dataToSend = formData;
      }

      const options = {
        headers: me.headers,
        parseJson: true
      };

      if (me.useRestfulMethods) {
        options.method = me.httpMethods.delete;
      }

      _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].post(me.deleteUrl + me.buildQueryString(me.deleteUrl, me.params), dataToSend, _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(options, me.fetchOptions)).then(response => {
        const data = response.parsedJson,
              isArray = Array.isArray(data),
              success = isArray || data && data.success !== false;
        commitState.response = response;
        event.json = data;
        event.response = response;

        if (success) {
          removed.forEach(record => record.meta.committing = false); // In case used by other store etc.

          removed.clear();
          me.trigger('commitRemoved');
          me.trigger('refresh', event);
          resolve(commitState);
        } else {
          // Clear committing flag
          removed.forEach(r => r.meta.committing = false);
          commitState.exception = event.exception = true;
          event.exceptionType = 'server';
          me.trigger('exception', event);
          resolve(commitState);
        } // finally


        me.trigger('afterRequest', event);
      }).catch(responseOrError => {
        // Clear committing flag
        removed.forEach(r => r.meta.committing = false);
        commitState.exception = event.exception = true;

        if (responseOrError instanceof Response) {
          commitState.response = responseOrError;
          event.exceptionType = responseOrError.ok ? 'server' : 'network';
          event.response = responseOrError;
          event.error = responseOrError.error;
        } else {
          event.exceptionType = 'server';
          event.error = responseOrError;
        }

        me.trigger('exception', event);
        resolve(commitState); // finally

        me.trigger('afterRequest', event);
      });
    }) : null;
  }

  get remoteFilter() {
    return Boolean(this.filterParamName || this.restfulFilter);
  }

}
AjaxStore._$name = 'AjaxStore';

/***/ }),

/***/ "./lib/Core/data/DomDataStore.js":
/*!***************************************!*\
  !*** ./lib/Core/data/DomDataStore.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DomDataStore; });
var productName = 'taskboard';
/**
* @module Core/data/DomDataStore
*/

/**
 * Stores data on a dom element (by setting element._domData).
 * Instead of using HTML5:s element.dataset, which turned out to be slow.
 * @internal
 */

class DomDataStore {
  /**
   * Get data that is connected to specified element.
   * @param {HTMLElement} element DOM element
   * @param {String} [key] The name of the property in the element data to return
   * @returns {Object} Data
   */
  static get(element, key) {
    const result = element._domData || (element._domData = {});
    return key != null ? result[key] : result;
  }
  /**
   * Remove data connected to specified element.
   * @param {HTMLElement} element DOM element
   * @param {String} key The name of the property in the element data to remove.
   */


  static remove(element, key) {
    const {
      _domData
    } = element,
          was = _domData === null || _domData === void 0 ? void 0 : _domData[key];
    _domData === null || _domData === void 0 ? true : delete _domData[key];
    return was;
  }
  /**
   * Set data connected to specified element (completely replacing any existing).
   * To update data, use DomDataStore#assign instead.
   * @param {HTMLElement} element DOM element
   * @param {Object|String} data Data object to set, or property name to set
   * @param {*} [value] If the previous parameter was a property name, this is the value to set.
   */


  static set(element, data, value) {
    if (arguments.length === 3) {
      (element._domData || (element._domData = {}))[data] = value;
    } else {
      element._domData = data;
    }
  }
  /**
   * Updates data connected to specified element.
   * @param {HTMLElement} element DOM element
   * @param {Object} data Data to assign
   */


  static assign(element, data) {
    Object.assign(element._domData || (element._domData = {}), data);
  }

}
DomDataStore._$name = 'DomDataStore';

/***/ }),

/***/ "./lib/Core/data/Duration.js":
/*!***********************************!*\
  !*** ./lib/Core/data/Duration.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Duration; });
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'taskboard';

/**
 * @module Core/data/Duration
 */

/**
 * Class which represents a duration object.
 * ```javascript
 * {
 *    unit      : String,
 *    magnitude : Number
 * }
 * ```
 */

class Duration {
  /**
   * Duration constructor.
   * @param {Number} magnitude Duration magnitude value
   * @param {String} unit Duration unit value
   */
  constructor(magnitude, unit) {
    if (typeof magnitude === 'number') {
      this._magnitude = magnitude;
      this._unit = unit;
    } else {
      if (typeof magnitude === 'string') {
        magnitude = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].parseDuration(magnitude);
      }

      if (typeof magnitude === 'object') {
        Object.assign(this, magnitude);
      }
    }
  }
  /**
   * Get/Set numeric magnitude `value`.
   * @property {Number}
   */


  get magnitude() {
    return this._magnitude;
  }

  set magnitude(value) {
    this._magnitude = typeof value === 'number' && value;
  }
  /**
   * Get/Set duration unit to use with the current magnitude value.
   * Valid values are:
   * - "millisecond" - Milliseconds
   * - "second" - Seconds
   * - "minute" - Minutes
   * - "hour" - Hours
   * - "day" - Days
   * - "week" - Weeks
   * - "month" - Months
   * - "quarter" - Quarters
   * - "year"- Years
   *
   * @property {String}
   */


  get unit() {
    return this._unit;
  }

  set unit(value) {
    this._unit = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].parseTimeUnit(value);
  }

  get isValid() {
    return this._magnitude != null && this._unit;
  }
  /**
   * The `milliseconds` property is a read only property which returns the number of milliseconds in this Duration
   * @property {Number}
   * @readonly
   */


  get milliseconds() {
    // There's no smaller time unit in the Date class than milliseconds, so round any divided values
    return this.isValid ? Math.round(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].asMilliseconds(this._magnitude, this._unit)) : 0;
  }
  /**
   * Returns truthy value if this Duration equals the passed value.
   * @param {Core.data.Duration} value
   * @return {Boolean}
   */


  isEqual(value) {
    return Boolean(value && this.milliseconds === value.milliseconds);
  }

  toString(useAbbreviation) {
    const me = this,
          abbreviationFn = useAbbreviation ? 'getShortNameOfUnit' : 'getLocalizedNameOfUnit';
    return me.isValid ? `${me._magnitude} ${_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"][abbreviationFn](me._unit, me._magnitude !== 1)}` : '';
  }

  toJSON() {
    return this.toString();
  }

  valueOf() {
    return this.milliseconds;
  }

}
;
Duration._$name = 'Duration';

/***/ }),

/***/ "./lib/Core/data/Model.js":
/*!********************************!*\
  !*** ./lib/Core/data/Model.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Model; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _stm_mixin_ModelStm_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./stm/mixin/ModelStm.js */ "./lib/Core/data/stm/mixin/ModelStm.js");
/* harmony import */ var _mixin_TreeNode_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixin/TreeNode.js */ "./lib/Core/data/mixin/TreeNode.js");
/* harmony import */ var _field_DataField_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./field/DataField.js */ "./lib/Core/data/field/DataField.js");
/* harmony import */ var _field_ArrayDataField_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./field/ArrayDataField.js */ "./lib/Core/data/field/ArrayDataField.js");
/* harmony import */ var _field_BooleanDataField_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./field/BooleanDataField.js */ "./lib/Core/data/field/BooleanDataField.js");
/* harmony import */ var _field_DateDataField_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./field/DateDataField.js */ "./lib/Core/data/field/DateDataField.js");
/* harmony import */ var _field_IntegerDataField_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./field/IntegerDataField.js */ "./lib/Core/data/field/IntegerDataField.js");
/* harmony import */ var _field_ModelDataField_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./field/ModelDataField.js */ "./lib/Core/data/field/ModelDataField.js");
/* harmony import */ var _field_NumberDataField_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./field/NumberDataField.js */ "./lib/Core/data/field/NumberDataField.js");
/* harmony import */ var _field_ObjectDataField_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./field/ObjectDataField.js */ "./lib/Core/data/field/ObjectDataField.js");
/* harmony import */ var _field_StringDataField_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./field/StringDataField.js */ "./lib/Core/data/field/StringDataField.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';






 // The built-in model field types:









const {
  defineProperty
} = Reflect,
      {
  hasOwnProperty
} = Object.prototype,
      _undefined = undefined,
      internalProps = {
  children: 1,
  data: 1,
  meta: 1
},
      abbreviationFields = ['name', 'title', 'text', 'label', 'description'],
      fieldDataTypes = {
  boolean: 1,
  number: 1,
  date: 1,
  object: 1
};
/**
 * @module Core/data/Model
 */

/**
 * A Model is the definition of a record which can be added to (or loaded into) a {@link Core.data.Store}. It defines
 * which fields the data contains and exposes an interface to access and manipulate that data. The Model data is
 * populated through simple a JSON object.
 *
 * By default a Model stores a shallow copy of its raw json, but for records in stores configured with
 * `useRawData: true` it stores the supplied json object as is.
 *
 * ## Defining fields
 *
 * A Model can either define its fields explicitly (see {@link #property-fields-static}) or have them created from its
 * data (see {@link #property-autoExposeFields-static}). This snippet shows a model with 4 fields defined explicitly:
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'birthday', type : 'date', format : 'YYYY-MM-DD' },
 *             { name : 'shoeSize', type : 'number', defaultValue : 11 },
 *             { name : 'age', readOnly : true }
 *         ];
 *     }
 * }
 * ```
 *
 * The first field (name) has an unspecified type, which means the field's value is held as received with no conversion
 * applied. The second field (birthday) is defined to be a date, which will make the model parse any supplied value into
 * an actual date. The parsing is handled by {@link Core/helper/DateHelper#function-parse-static DateHelper.parse()}
 * using the specified `format`, or if no format is specified using
 * {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat}.
 *
 * The set of standard field types is as follows:
 *
 *  - {@link Core.data.field.BooleanDataField `boolean`}
 *  - {@link Core.data.field.DateDataField `date`}
 *  - {@link Core.data.field.IntegerDataField `integer`}
 *  - {@link Core.data.field.ObjectDataField `object`}
 *  - {@link Core.data.field.NumberDataField `number`}
 *  - {@link Core.data.field.StringDataField `string`}
 *
 * You can also set a `defaultValue` that will be used if the data does not contain a value for the field:
 *
 * ```javascript
 * { name : 'shoeSize', type : 'number', defaultValue : 11 }
 * ```
 *
 * To create a record from a Model, supply data to its constructor:
 *
 * ```javascript
 * let guy = new Person({
 *     id       : 1,
 *     name     : 'Dude',
 *     birthday : '2014-09-01'
 * });
 * ```
 *
 * If no id is specified, a temporary id will be generated.
 *
 * Please avoid using reserved names for your fields (such as `parent`, `children` and others that are used as Model
 * properties) to avoid possible data collisions and bugs.
 *
 * ## Nested fields
 *
 * Model supports mapping fields to nested data structures using dot `.` separated paths as the `dataSource`. For
 * example given this JSON object:
 *
 * ```json
 * {
 *     name : 'Borje Salming',
 *     team : {
 *         name   : 'Toronto Maple Leafs',
 *         league : 'NHL
 *     }
 * }
 * ```
 *
 * A field can be mapped to the nested team name by using `dataSource : 'team.name'`:
 *
 * ```javascript
 * class Player extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             // Field mapped to a property on a nested object
 *             { name : 'teamName', dataSource : 'team.name' }
 *         ]
 *     }
 * }
 * ```
 *
 * Usage:
 *
 * ```javascript
 * const player = new Player(json);
 *
 * console.log(player.teamName); // > Toronto Maple Leafs
 * player.teamName = 'Detroit Red Wings'; // The name property of the team object is updated
 * ```
 *
 * ### Updating a nested object
 *
 * Note that directly altering a property of the nested object wont register as an update of the record, record does not
 * track changes deeply. If nested fields (as described above) is not enough for your usecase you can map a field
 * directly to the nested object and then assign a shallow copy of it to the record on changes:
 *
 * ```javascript
 * class Player extends Model {
 *     static get fields() {
 *         return [
 *             ...,
 *             // Field mapped directly to the nested object
 *             { name : 'team', type : 'object' }
 *         ]
 *     }
 * }
 *
 * // "External object" to nest
 * const team = {
 *     name   : 'Brynas',
 *     league : 'SHL'
 * }
 *
 * const player = new Player({
 *     name : 'Borje Salming',
 *     team
 * });
 *
 * // This will not flag player as dirty
 * team.league = 'CHL';
 *
 * // Instead you have to reassign the mapped field
 * player.team = { ...player.team };
 * ```
 *
 * ## Persisting fields
 *
 * By default all fields are persisted. If you don't want particular field to get saved to the server, configure it with
 * `persist: false`. In this case field will not be among changes which are sent by
 * {@link Core/data/AjaxStore#function-commit store.commit()}, otherwise its behavior doesn't change.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'age', persist : false }
 *         ];
 *     }
 * }
 * ```
 *
 * ## The `idField`
 * By default Model expects its id to be stored in a field named "id". The name of the field can be customized by
 * setting {@link #property-idField-static}:
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'age', persist : false },
 *             { name : 'personId' },
 *             { name : 'birthday', type : 'date' }
 *         ];
 *     }
 * }
 *
 * // Id drawn from 'id' property by default; use custom field here
 * Person.idField = 'personId';
 *
 * let girl = new Person({
 *     personId : 2,
 *     name     : 'Lady',
 *     birthday : '2011-11-05'
 * });
 * ```
 *
 * ## Getting and setting values
 *
 * Fields are used to generate getters and setters on the records. Use them to access or modify values (they are
 * reactive):
 *
 * ```javascript
 * console.log(guy.name);
 * girl.birthday = new Date(2011,10,6);
 * ```
 *
 * NOTE: In an application with multiple different models you should subclass Model, since the prototype is decorated
 * with getters and setters. Otherwise you might get unforeseen collisions.
 *
 * ## Field data mapping
 *
 * By default fields are mapped to data using their name. If you for example have a "name" field it expects data to be
 * `{ name: 'Some name' }`. If you need to map it to some other property, specify `dataSource` in your field definition:
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields {
 *         return [
 *             { name : 'name', dataSource : 'TheName' }
 *         ];
 *     }
 * }
 *
 * // This is now OK:
 * let dude = new Person({ TheName : 'Manfred' });
 * console.log(dude.name); // --> Manfred
 * ```
 * ## Field inheritance
 *
 * Fields declared in a derived model class are added to those from its superclass. If a field declared by a derived
 * class has also been declared by its super class, the field properties of the super class are merged with those of
 * the derived class.
 *
 * For example:
 * ```javascript
 *  class Person extends Model {
 *      static get fields() {
 *          return [
 *              'name',
 *              { name : 'birthday', type : 'date', format : 'YYYY-MM-DD' }
 *          ];
 *      }
 *  }
 *
 *  class User extends Person {
 *      static get fields() {
 *          return [
 *              { name : 'birthday', dataSource : 'dob' },
 *              { name : 'lastLogin', type : 'date' }
 *          ];
 *      }
 *  }
 * ```
 *
 * In the above, the `Person` model declares the `birthday` field as a `date` with a specified `format`. The `User`
 * model extends `Person` and also declares the `birthday` field. This redeclared field only specifies `dataSource`, so
 * all of the other fields are preserved from `Person`. The `User` model also adds a `lastLogin` field.
 *
 * The `User` from above could have been declared like so to achieve the same `fields`:
 *
 * ```javascript
 *  class User extends Model {
 *      static get fields() {
 *          return [
 *              'name',
 *              { name : 'birthday', type : 'date', format : 'YYYY-MM-DD', dataSource : 'dob' },
 *              { name : 'lastLogin', type : 'date' }
 *          ];
 *      }
 *  }
 * ```
 *
 * ## Override default values
 *
 * In case you need to define default value for a specific field, or override an existing default value, you can
 * define a new or re-define an existing field definition in {@link #property-fields-static} static getter:
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             { name : 'username', defaultValue : 'New person' },
 *             { name : 'birthdate', type : 'date' }
 *         ];
 *     }
 * }
 *
 * class Bot extends Person {
 *     static get fields() {
 *         return [
 *             { name : 'username', defaultValue : 'Bot' } // default value of 'username' field is overridden
 *         ];
 *     }
 * }
 * ```
 *
 * ## Tree API
 *
 * This class mixes in the {@link Core/data/mixin/TreeNode TreeNode} mixin which provides an API for tree related
 * functionality (only relevant if your store is configured to be a {@link Core/data/Store#config-tree tree}).
 *
 * @mixes Core/data/mixin/TreeNode
 * @mixes Core/data/stm/mixin/ModelStm
 */

class Model extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_stm_mixin_ModelStm_js__WEBPACK_IMPORTED_MODULE_4__["default"], _mixin_TreeNode_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {
  static get $name() {
    return 'Model';
  }

  static get declarable() {
    return [
    /**
     * Array of defined fields for this model class. Subclasses add new fields by implementing this static
     * getter:
     *
     * ```javascript
     * // Model defining two fields
     * class Person extends Model {
     *     static get fields() {
     *         return [
     *             { name : 'username', defaultValue : 'New person' },
     *             { name : 'birthdate', type : 'date' }
     *         ];
     *     }
     * }
     *
     * // Subclass overriding one of the fields
     * class Bot extends Person {
     *     static get fields() {
     *         return [
     *             // Default value of 'username' field is overridden, any other setting from the parents
     *             // definition is preserved
     *             { name : 'username', defaultValue : 'Bot' }
     *         ];
     *     }
     * }
     * ```
     *
     * Fields in a subclass are merged with those from the parent class, making it easy to override mappings,
     * formats etc.
     *
     * @member {String[]|Object[]|Core.data.field.DataField[]} fields
     * @readonly
     * @static
     * @category Fields
     */
    'fields'];
  }

  static get fields() {
    return [// The index of this item in its parent (respects filtering)
    {
      name: 'parentIndex',
      type: 'number',
      persist: false,
      internal: true
    }];
  }
  /**
   * Template static getter which is supposed to be overridden to define default field values for the Model class.
   * Overrides `defaultValue` config specified by the {@link #property-fields-static} getter.
   * Returns a named object where key is a field name and value is a default value for the field.
   *
   * NOTE: This is a legacy way of defining default values, we recommend using {@link #property-fields-static} moving
   * forward.
   *
   * ```javascript
   * class Person extends Model {
   *     static get fields() {
   *         return [
   *             { name : 'username', defaultValue : 'New person' }
   *         ];
   *     }
   * }
   *
   * class Bot extends Person {
   *     static get defaults() {
   *         return {
   *             username : 'Bot' // default value of 'username' field is overridden
   *         };
   *     }
   * }
   * ```
   *
   * @member {Object} defaults
   * @static
   * @category Fields
   */
  // TODO: deprecate in 5.0 in favor of static fields getter
  // static get defaults() {
  //     return {};
  // }

  /**
   * The name of the data field which provides the ID of instances of this Model.
   * @property {String}
   * @category Fields
   */


  static set idField(idField) {
    this._assignedIdField = true;
    this._idField = idField;
  }

  static get idField() {
    return this._idField;
  }
  /**
   * The name of the data field which holds children of this Model when used in a tree structure
   * ```javascript
   * MyModel.childrenField = 'kids';
   * const parent = new MyModel({
   *     name : 'Dad',
   *     kids : [
   *         { name : 'Daughter' },
   *         { name : 'Son' }
   *     ]
   * });
   * ```
   * @property {String}
   * @category Fields
   */


  static set childrenField(childrenField) {
    this._childrenField = childrenField;
  }

  static get childrenField() {
    if (!this._childrenField) {
      const dataField = this.fieldMap.children;
      this._childrenField = (dataField === null || dataField === void 0 ? void 0 : dataField.dataSource) || 'children';
    }

    return this._childrenField;
  }
  /**
   * Returns index path to this node. This is the index of each node in the node path
   * starting from the topmost parent. (only relevant when its part of a tree store).
   * @returns {Number[]} The index of each node in the path from the topmost parent to this node.
   * @category Parent & children
   * @private
   */


  get indexPath() {
    const indices = [];
    let node = this,
        depth = node.childLevel;

    for (node = this; node && !node.isRoot; node = node.parent) {
      indices[depth--] = node.parentIndex + 1;
    }

    return indices;
  }
  /**
   * Unique identifier for the record. Might be mapped to another dataSource using idField, but always exposed as
   * record.id. Will get a generated value if none is specified in records data.
   * @field {String|Number} id
   * @category Identification
   */
  //region Init

  /**
   * Constructs a new record from the supplied data.
   * @param {Object} [data] Raw data
   * @param {Core.data.Store} [store] Data store
   * @param {Object} [meta] Meta data
   * @privateparam {Boolean} [skipExpose] Skip exposing properties from data
   * @privateparam {Boolean} [forceUseRaw] Force using raw data, used by copy to not clone data twice
   * @function constructor
   * @category Lifecycle
   */


  construct(data = {}, store = null, meta = null, skipExpose = false, forceUseRaw = false) {
    const me = this,
          stores = store ? Array.isArray(store) ? store : [store] : [],
          {
      constructor,
      fieldMap
    } = me; // null passed to Base construct inhibits config processing.

    let configs = null;
    store = stores[0];
    me.meta = _objectSpread(_objectSpread({
      modified: {}
    }, constructor.metaConfig), meta); // Should apply configs?

    if (constructor.applyConfigs) {
      // Extract from data and combine with defaultConfigs
      for (const key in me.getDefaultConfiguration()) {
        if (!configs) {
          // if (first config)
          configs = {};

          if (!me.useRawData || !me.useRawData.enabled) {
            // Shallow copy of data to not mutate incoming object
            data = _objectSpread({}, data);
          }
        } // loop through configs excluding fields


        if (key in data) {
          // Use as config
          configs[key] = data[key]; // Remove from data

          delete data[key];
        }
      }
    }

    super.construct(configs); // make getters/setters for fields, needs to be done before processing data to make sure defaults are available

    if (!skipExpose) {
      constructor.exposeProperties(data);
    } // It's only valid to do this once, on construction of the first instance


    if (!hasOwnProperty.call(constructor, 'idFieldProcessed')) {
      // idField can be overridden from meta, or from the store if we have not had an idField set programmatically
      // and if we have not had an id field defined above the base Model class level.
      let overriddenIdField = me.meta.idField;

      if (!overriddenIdField) {
        // Might have been set to Model after construction but before load
        if (constructor._assignedIdField) {
          overriddenIdField = constructor.idField;
        } // idField on store was deprecated, but should still work to not break code
        // TODO: Remove in 3.0? Or reintroduce it...
        else if (store) {
          overriddenIdField = store.idField;
        }
      } // If it's overridden to something different than we already have, replace the 'id' field in the fieldMap


      if (overriddenIdField && overriddenIdField !== fieldMap.id.dataSource) {
        constructor.addField({
          name: 'id',
          dataSource: overriddenIdField,
          internal: true
        });
      }

      constructor.idFieldProcessed = true;
    } // assign internalId, unique among all records


    me._internalId = Model._internalIdCounter++; // relation code expects store to be available for relation lookup, but actual join done below

    me.stores = [];
    me.unjoinedStores = []; // Superclass constructors may set this in their own way before this is called.

    if (!me.originalData) {
      me.originalData = data;
    }

    me.data = constructor.processData(data, false, store, me, forceUseRaw); // Consider undefined and null as missing id and generate one

    if (me.id == null) {
      // Assign a generated id silently, record should not be considered modified
      me.setData('id', me.generateId(store));
    }

    if (me.data[constructor.childrenField]) {
      me.processChildren(stores);
    }

    me.generation = 0;
  }
  /**
   * Set this property to `true` when adding a record on a conditional basis, that is, it is yet
   * to be confirmed as an addition.
   *
   * When this is set, the {@link #property-isPersistable} value of the record is **false**, and upon being
   * added to a Store it will *not* be eligible to be synced with the server as an added record.
   *
   * Subsequently *clearing* this property means this record will become persistable and eligible
   * for syncing as an added record.
   * @property {Boolean}
   */


  set isCreating(isCreating) {
    const me = this; // A no-change must not have any effect.

    if (Boolean(me.meta.isCreating) !== isCreating) {
      // This flag contributes to the evaluation of isPersistable.
      // A record is not persistable if it isCreating.
      me.meta.isCreating = isCreating; // Owning Stores may have things to do at this lifecycle point

      me.stores.forEach(s => {
        s.onIsCreatingToggle(me, isCreating);
      });
    }
  }

  get isCreating() {
    return Boolean(this.meta.isCreating);
  }
  /**
   * Compares this Model instance to the passed instance. If they are of the same type, and all fields
   * (except, obviously, `id`) are equal, this returns `true`.
   * @param {Core.data.Model} other The record to compare this record with.
   * @returns {Boolean} `true` if the other is of the same class and has all fields equal.
   */


  equals(other) {
    if (other instanceof this.constructor) {
      for (let fields = this.$meta.fields.defs, i = 0, {
        length
      } = fields; i < length; i++) {
        const field = fields[i],
              {
          name
        } = field;

        if (name !== 'id' && !field.isEqual(this[name], other[name])) {
          return false;
        }
      }

      return true;
    }

    return false;
  }

  get subclass() {
    return new this.constructor(Object.setPrototypeOf({
      id: _undefined
    }, this.data), this.stores[0], null, true);
  }
  /**
   * Processes raw data, converting values and setting defaults.
   * @private
   * @param {Object} data Raw data
   * @param {Boolean} [ignoreDefaults] Ignore setting default values, used when updating
   * @returns {Object} Processed data
   * @category Fields
   */


  static processData(data, ignoreDefaults = false, store, record, forceUseRaw) {
    const {
      fieldMap,
      defaultValues
    } = this,
          {
      useRawData = {
        enabled: false
      }
    } = store || {},
          // Store configured with useRawData uses the supplied data object, polluting it. When not configured with
    // useRawData it instead makes a copy (intentionally deep, in case data has a prototype chain or contains
    // arrays or objects)
    processed = forceUseRaw || useRawData.enabled ? data : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(data);
    let fieldName;
    ignoreDefaults = ignoreDefaults || useRawData.disableDefaultValue || forceUseRaw;

    if (!ignoreDefaults) {
      for (fieldName in defaultValues) {
        if (processed[fieldName] === _undefined) {
          let defaultValue = defaultValues[fieldName]; // Avoid sharing arrays across instances

          if (Array.isArray(defaultValue)) {
            defaultValue = defaultValue.slice();
          }

          processed[fieldName] = defaultValue;
        }
      }
    }

    if (!useRawData.disableTypeConversion && !forceUseRaw) {
      // Convert field types which need converting
      for (fieldName in fieldMap) {
        const field = fieldMap[fieldName],
              {
          name,
          dataSource
        } = field,
              // Value might have been supplied either using mapped dataSource (when loading JSON etc. for example
        // event.myStartDate) or as field name (from internal code, for example event.startDate). If [name]
        // exists but not [dataSource], use it.
        hasSource = dataSource !== name,
              complex = field.complexMapping,
              sourceExists = hasSource && (complex ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].pathExists(data, dataSource) : dataSource in data),
              useNameForValue = name in data && (!hasSource || !sourceExists),
              convert = !useRawData.disableTypeConversion && field.convert; // Only action field definitions which have a convert function or remap data

        if (useNameForValue || convert) {
          // When ignoringDefaults, do not convert unspecified values
          if (!ignoreDefaults || useNameForValue || sourceExists) {
            const value = useNameForValue ? processed[name] : complex ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getPath(processed, dataSource) : processed[dataSource],
                  converted = convert ? field.convert(value, record) : value;

            if (complex) {
              _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(processed, dataSource, converted);
            } else {
              processed[dataSource] = converted;
            } // Remove [startDate] from internal data holder, only keeping [myStartDate]


            if (hasSource) {
              delete processed[name];
            }
          }
        }
      }
    }

    return processed;
  }

  static setupClass(meta) {
    super.setupClass(meta);

    if (!meta.fields) {
      // Normally setupFields will only run when a Model defines a fields getter, but we want to always run it:
      this.setupFields(this, meta);
    }
  }

  static setupFields(cls, meta) {
    var _base$defs$slice, _base$exposed, _base$ordinals, _base$map, _base$sources;

    const classFields = hasOwnProperty.call(cls, 'fields') && cls.fields,
          base = meta.super.fields,
          fieldsInfo = meta.fields = {
      defs: (_base$defs$slice = base === null || base === void 0 ? void 0 : base.defs.slice()) !== null && _base$defs$slice !== void 0 ? _base$defs$slice : [],
      // Set to true when an instance's data object is run through exposeProperties
      exposedData: false,
      // These objects are all keyed by field name:
      defaults: base ? _objectSpread({}, base.defaults) : {},
      // value=field.defaultValue
      exposed: Object.create((_base$exposed = base === null || base === void 0 ? void 0 : base.exposed) !== null && _base$exposed !== void 0 ? _base$exposed : null),
      // value=true if we've done defineProperty
      ordinals: Object.create((_base$ordinals = base === null || base === void 0 ? void 0 : base.ordinals) !== null && _base$ordinals !== void 0 ? _base$ordinals : null),
      // value=index in the defs array
      map: Object.create((_base$map = base === null || base === void 0 ? void 0 : base.map) !== null && _base$map !== void 0 ? _base$map : null),
      // value=definition object
      sources: Object.create((_base$sources = base === null || base === void 0 ? void 0 : base.sources) !== null && _base$sources !== void 0 ? _base$sources : null) // value=source definition object

    }; // We use Object.create(null) as the base for these maps because some models declare "constructor" as a field
    // NOTE: instead of chaining the defaults, we copy them so the defaults object can be used with Object.assign
    // in other contexts (since it does not copy inherited properties from the prototype chain)
    // Clone the superclass's defaults, and override that with our own defaults.
    // As we find fields with a defaultValue, more defaults may be added

    if (hasOwnProperty.call(cls, 'defaults')) {
      Object.assign(fieldsInfo.defaults, cls.defaults);
    } // Hook up our field maps with the class hierarchy's fieldMaps.
    // We need to be able to look up field definitions by the name, or by the dataSource property name
    // If the idField is overridden at this level, create a new field


    if (hasOwnProperty.call(cls, 'idField')) {
      cls.addField({
        name: 'id',
        dataSource: cls.idField,
        internal: true
      });
      fieldsInfo.exposed[cls.idField] = true;
    } // Process fields defined in the class definition


    if (classFields !== null && classFields !== void 0 && classFields.length) {
      classFields.map(cls.addField, cls);
    }

    cls.exposeRelations();
  }

  static get defaultValues() {
    return this.$meta.fields.defaults;
  }
  /**
   * An array containing all the _defined_ fields for this Model class. This will include all superclass's
   * defined fields.
   * @property {Core.data.field.DataField[]}
   * @static
   * @readonly
   * @category Fields
   */


  static get allFields() {
    return this.$meta.fields.defs;
  }
  /**
   * Same as {@link #property-allFields-static}.
   * @property {Core.data.field.DataField[]}
   * @readonly
   * @category Fields
   */


  get allFields() {
    return this.$meta.fields.defs;
  }
  /**
   * An object containing all the _defined_ fields for this Model class. This will include all superclass's
   * defined fields through its prototype chain. So be aware that `Object.keys` and `Object.entries` will only
   * access this class's defined fields.
   * @property {Object}
   * @static
   * @readonly
   * @category Fields
   */


  static get fieldMap() {
    return this.$meta.fields.map;
  }
  /**
   * Same as {@link #property-fieldMap-static}.
   * @property {Object}
   * @readonly
   * @category Fields
   */


  get fieldMap() {
    return this.$meta.fields.map;
  }

  static get fieldDataSourceMap() {
    return this.$meta.fields.sources;
  }
  /**
   * Makes getters and setters for fields (from definitions and data). Called once when class is defined and once when
   * data is loaded first time.
   * @internal
   * @param {Object} [data] Raw data
   * @category Fields
   */


  static exposeProperties(data) {
    const me = this,
          fieldsInfo = me.$meta.fields; // Process the raw data properties and expose them as fields unless the property name
    // has already been used by the "dataSource" of a defined field.

    if (data && me.autoExposeFields && !fieldsInfo.exposedData) {
      let dataProperty, fieldDef, type;

      for (dataProperty in data) {
        // We need to skip children field because it can be `true` and that would create boolean field.
        // See https://github.com/bryntum/support/issues/2705
        if (!fieldsInfo.exposed[dataProperty] && dataProperty !== me.childrenField) {
          type = Object(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["typeOf"])(data[dataProperty]); // Create a field definition in our fieldMap with the flag that it's from data

          fieldDef = {
            name: dataProperty,
            dataSource: dataProperty,
            fromData: true
          };

          if (fieldDataTypes[type]) {
            fieldDef.type = type;
          }

          me.addField(fieldDef);
        }
      }

      fieldsInfo.exposedData = true;
    }

    me.exposeRelations();
  }
  /**
   * Add a field definition in addition to those predefined in `fields`.
   * @param {String|Object} fieldDef A field name or definition
   * @category Fields
   */


  static addField(fieldDef) {
    if (fieldDef == null) {
      return;
    }

    if (typeof fieldDef === 'string') {
      fieldDef = {
        name: fieldDef
      };
    }

    const me = this.initClass(),
          fieldsInfo = me.$meta.fields,
          {
      ordinals
    } = fieldsInfo,
          propertiesExposed = fieldsInfo.exposed,
          {
      name
    } = fieldDef,
          existing = fieldsInfo.map[name],
          dataSource = fieldDef.dataSource || (fieldDef.dataSource = name);
    let field, key;

    if (!existing || fieldDef.type && fieldDef.type !== existing.type) {
      field = _field_DataField_js__WEBPACK_IMPORTED_MODULE_6__["default"].create(fieldDef);
      field.definedBy = existing ? existing.definedBy : me;
      field.ordinal = existing ? existing.ordinal : ordinals[name] = fieldsInfo.defs.length;
    } else {
      field = Object.create(existing);

      for (key in fieldDef) {
        if (key !== 'type') {
          field[key] = fieldDef[key];
        }
      }
    }

    field.owner = me;
    fieldsInfo.defs[field.ordinal] = field;
    fieldsInfo.map[name] = field;

    if (!fieldsInfo.sources[dataSource]) {
      fieldsInfo.sources[dataSource] = field;
    } // With complex mapping avoid exposing object as model field


    if (dataSource.includes('.')) {
      field.complexMapping = true;
    }

    if (field.complexMapping) {
      // model fields have this set on their prototype...
      propertiesExposed[dataSource.split('.')[0]] = true;
    } else {
      // When iterating through the raw data, if autoExposeFields is set
      // We do not need to create properties for raw property names we've processed here
      propertiesExposed[dataSource] = true;
    } // Maintain an object of defaultValues for fields.


    if ('defaultValue' in field) {
      fieldsInfo.defaults[dataSource] = field.defaultValue;
    } // Create a property on this Model's prototype, named for the defined field name
    // which reads the correct property out of the raw data object.


    if (!internalProps[name]) {
      // Either creates a new accessor or redefines an existing
      field.defineAccessor(me.prototype);
    }

    me._nonPersistableFields = null;
    me._alwaysWriteFields = null;
    return field;
  }
  /**
   * Remove a field definition by name.
   * @param {String} fieldName Field name
   * @category Fields
   */


  static removeField(fieldName) {
    const me = this.initClass(),
          fieldsInfo = me.$meta.fields,
          definition = fieldsInfo.map[fieldName],
          {
      ordinals
    } = fieldsInfo,
          index = ordinals[fieldName];

    if (definition) {
      fieldsInfo.defs.splice(index, 1);
      delete ordinals[fieldName];
      delete fieldsInfo.defaults[fieldName];
      delete fieldsInfo.exposed[fieldName];
      delete fieldsInfo.map[fieldName];
      delete fieldsInfo.sources[definition.dataSource];

      for (const name in ordinals) {
        if (ordinals[name] > index) {
          --ordinals[name];
        }
      } // Note: if field was exposed by superclass, this won't do anything...


      delete me.prototype[fieldName];
    }
  }
  /**
   * Makes getters and setters for related records. Populates a Model#relation array with the relations, to allow it
   * to be modified later when assigning stores.
   * @internal
   * @category Relations
   */


  static exposeRelations() {
    const me = this;

    if (hasOwnProperty.call(me, 'relationsExposed')) {
      return;
    }

    if (me.relationConfig) {
      me.relationsExposed = true;
      me.relations = [];
      me.relationConfig.forEach(relation => {
        me.relations.push(relation);
        const name = relation.relationName; // getter and setter for related object

        if (!Reflect.ownKeys(me.prototype).includes(name)) {
          defineProperty(me.prototype, name, {
            enumerable: true,
            get: function () {
              // noinspection JSPotentiallyInvalidUsageOfClassThis
              return this.getForeign(name);
            },
            set: function (value) {
              // noinspection JSPotentiallyInvalidUsageOfClassThis
              this.setForeign(name, value, relation);
            }
          });
        }
      });
    }
  } //endregion
  //region Fields

  /**
   * Flag checked from Store when loading data that determines if fields found in first records should be exposed in
   * same way as predefined fields.
   * @property {Boolean}
   * @category Fields
   */


  static get autoExposeFields() {
    return true;
  }
  /**
   * Convenience getter to get field definitions from class.
   * @property {Core.data.field.DataField[]}
   * @readonly
   * @category Fields
   */


  get fields() {
    return this.$meta.fields.defs;
  }
  /**
   * Convenience function to get the definition for a field from class.
   * @param {String} fieldName Field name
   * @returns {Core.data.field.DataField}
   * @category Fields
   */


  getFieldDefinition(fieldName) {
    return this.$meta.fields.map[fieldName];
  }

  getFieldDefinitionFromDataSource(dataSource) {
    return this.$meta.fields.sources[dataSource];
  }
  /**
   * Get the names of all fields in data.
   * @property {String[]}
   * @readonly
   * @category Fields
   */


  get fieldNames() {
    return Object.keys(this.data);
  }
  /**
   * Get the definition for a field by name. Caches results.
   * @param {String} fieldName Field name
   * @returns {Core.data.field.DataField} Field definition or null if none found
   * @category Fields
   */


  static getFieldDefinition(fieldName) {
    return this.$meta.fields.map[fieldName];
  }
  /**
   * Returns dataSource configuration for a given field name
   * @param {String} fieldName
   * @returns {String} Field `dataSource` mapping
   * @internal
   */


  static getFieldDataSource(fieldName) {
    return this.getFieldDefinition(fieldName).dataSource;
  }
  /**
   * Get the data source used by specified field. Returns the fieldName if no data source specified.
   * @param {String} fieldName Field name
   * @returns {String}
   * @category Fields
   */


  getDataSource(fieldName) {
    const def = this.constructor.getFieldDefinition(fieldName);
    return (def === null || def === void 0 ? void 0 : def.dataSource) || (def === null || def === void 0 ? void 0 : def.name);
  }
  /**
   * Processes input to a field, converting to expected type.
   * @param {String} fieldName Field dataSource
   * @param {*} value Value to process
   * @returns {*} Converted value
   * @category Fields
   */


  static processField(fieldName, value, record) {
    const field = this.fieldMap[fieldName];
    return field !== null && field !== void 0 && field.convert ? field.convert(value, record) : value;
  } //endregion
  //region Relations

  /**
   * Initializes model relations. Called from store when adding a record.
   * @private
   * @category Relations
   */


  initRelations() {
    const me = this,
          relations = me.constructor.relations;
    if (!relations) return; // TODO: feels strange to have to look at the store for relation config but didn't figure out anything better.
    // TODO: because other option would be to store it on each model instance, not better...

    me.stores.forEach(store => {
      var _store$modelRelations;

      if (!store.modelRelations) {
        store.initRelations();
      } // TODO: not at all tested for multiple stores, can't imagine it works as is


      const relatedRecords = [];
      (_store$modelRelations = store.modelRelations) === null || _store$modelRelations === void 0 ? void 0 : _store$modelRelations.forEach(config => {
        relatedRecords.push({
          related: me.initRelation(config),
          config
        });
      });
      store.updateRecordRelationCache(me, relatedRecords);
    });
  }
  /**
   * Initializes/updates a single relation.
   * @param config Relation config
   * @returns {Core.data.Model} Related record
   * @private
   * @category Relations
   */


  initRelation(config) {
    const me = this,
          keyValue = me.get(config.fieldName),
          foreign = keyValue !== _undefined && typeof config.store !== 'string' && config.store.getById(keyValue),
          placeHolder = {
      id: keyValue,
      placeHolder: true
    };

    if (!me.meta.relationCache) {
      me.meta.relationCache = {};
    } // apparently scheduler tests expect cache to work without matched related record, thus the placeholder


    me.meta.relationCache[config.relationName] = foreign || (keyValue != null ? placeHolder : null);
    return foreign;
  }

  removeRelation(config) {
    // (have to check for existence before deleting to work in Safari)
    if (this.meta.relationCache[config.relationName]) {
      delete this.meta.relationCache[config.relationName];

      if (config.nullFieldOnRemove) {
        // Setting to null silently, to not trigger additional relation behaviour
        this.setData(config.fieldName, null);
      }
    }
  }

  getForeign(name) {
    var _this$meta$relationCa;

    return (_this$meta$relationCa = this.meta.relationCache) === null || _this$meta$relationCa === void 0 ? void 0 : _this$meta$relationCa[name];
  }

  setForeign(name, value, config) {
    const id = Model.asId(value);
    return this.set(config.fieldName, id);
  } //endregion
  //region Get/set values, data handling


  flatGet(fieldName, dataSource) {
    var _this$data$dataSource;

    // NOTE: There is an inlined copy of this fn in DataField, when changing here make sure it is updated too
    // When changes are batched, they get stored by field name, not dataSource
    if (this.batching && fieldName in this.meta.batchChanges) {
      return this.meta.batchChanges[fieldName];
    }

    return (_this$data$dataSource = this.data[dataSource]) !== null && _this$data$dataSource !== void 0 ? _this$data$dataSource : this.data[fieldName];
  }

  complexGet(fieldName, dataSource) {
    // When changes are batched, they get stored by field name, not dataSource
    if (this.batching && fieldName in this.meta.batchChanges) {
      return this.meta.batchChanges[fieldName];
    }

    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getPath(this.data, dataSource);
  }
  /**
   * Get value for specified field name. You can also use the generated getters if loading through a Store.
   * If model is currently in batch operation this will return updated batch values which are not applied to Model
   * until endBatch() is called.
   * @param {String} fieldName Field name to get value from
   * @returns {*} Fields value
   * @category Fields
   */


  get(fieldName) {
    if (!fieldName) {
      return;
    }

    const field = this.fieldMap[fieldName]; // Getting property of nested record?

    if (!field && fieldName.includes('.')) {
      return this.complexGet(fieldName, fieldName);
    }

    if (field !== null && field !== void 0 && field.complexMapping) {
      return this.complexGet(fieldName, field.dataSource);
    }

    return this.flatGet(fieldName, (field === null || field === void 0 ? void 0 : field.dataSource) || fieldName);
  }
  /**
   * Internal function used to update a records underlying data block (record.data) while still respecting field
   * mappings. Needed in cases where a field needs setting without triggering any associated behaviour and it has a
   * dataSource with a different name.
   *
   * For example:
   * ```javascript
   * // startDate mapped to data.beginDate
   * { name : 'startDate', dataSource : 'beginDate' }
   *
   * // Some parts of our code needs to update the data block without triggering any of the behaviour associated with
   * // calling set. This would then not update "beginDate":
   * record.data.startDate = xx;
   *
   * // But this would
   * record.setData('startDate', xx);
   * ```
   * @internal
   * @category Editing
   */


  setData(toSet, value) {
    const {
      data,
      fieldMap
    } = this; // Two separate paths for performance reasons
    // setData('name', 'Quicksilver');

    if (typeof toSet === 'string') {
      var _field$dataSource;

      const field = fieldMap[toSet],
            dataSource = (_field$dataSource = field === null || field === void 0 ? void 0 : field.dataSource) !== null && _field$dataSource !== void 0 ? _field$dataSource : toSet;

      if (field !== null && field !== void 0 && field.complexMapping) {
        _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(data, dataSource, value);
      } else {
        data[dataSource] = value;
      }
    } // setData({ name : 'Magneto', power : 'Magnetism' });
    else {
      const keys = Object.keys(toSet);

      for (let i = 0; i < keys.length; i++) {
        var _field$dataSource2;

        const fieldName = keys[i],
              field = fieldMap[fieldName],
              dataSource = (_field$dataSource2 = field === null || field === void 0 ? void 0 : field.dataSource) !== null && _field$dataSource2 !== void 0 ? _field$dataSource2 : fieldName;

        if (dataSource) {
          if (field !== null && field !== void 0 && field.complexMapping) {
            _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(data, dataSource, toSet[fieldName]);
          } else {
            data[dataSource] = toSet[fieldName];
          }
        }
      }
    }
  }
  /**
   * Returns raw data from the encapsulated data object for the passed field name
   * @param {String} fieldName The field to get data for.
   * @returns {*} The raw data value for the field.
   */


  getData(fieldName) {
    var _field$dataSource3;

    const field = this.fieldMap[fieldName],
          dataSource = (_field$dataSource3 = field === null || field === void 0 ? void 0 : field.dataSource) !== null && _field$dataSource3 !== void 0 ? _field$dataSource3 : fieldName;

    if (dataSource) {
      if (field !== null && field !== void 0 && field.complexMapping) {
        return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getPath(this.data, dataSource);
      }

      return this.data[dataSource];
    }
  }
  /**
   * Silently updates record's id with no flagging the property as modified.
   * Triggers onModelChange event for changed id.
   * @param {String|Number} value id value
   * @private
   */


  syncId(value) {
    const oldValue = this.id;

    if (oldValue !== value) {
      this.setData('id', value);
      const data = {
        id: {
          value,
          oldValue
        }
      };
      this.afterChange(data, data);
    }
  }
  /**
   * Set value for the specified field. You can also use the generated setters if loading through a Store.
   *
   * Setting a single field, supplying name and value:
   *
   * ```javascript
   * record.set('name', 'Clark');
   * ```
   *
   * Setting multiple fields, supplying an object:
   *
   * ```javascript
   * record.set({
   *     name : 'Clark',
   *     city : 'Metropolis'
   * });
   * ```
   *
   * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
   * @param {*} [value] Value to set
   * @param {Boolean} [silent] Set to true to not trigger events. If event is recurring, occurrences won't be updated automatically.
   * @fires Store#idChange
   * @fires Store#update
   * @fires Store#change
   * @category Editing
   */


  set(field, value, silent = false, fromRelationUpdate = false, skipAccessors = false) {
    const me = this; // We use beforeSet/inSet/afterSet approach here because mixin interested in overriding set() method
    // like STM, for example, might be mixed before Model class or after. In general I have no control over this.
    // STM mixed before, so the only option to wrap set() method body is actually to call
    // beforeSet()/afterSet().

    if (me.isBatchUpdating) {
      me.inBatchSet(field, value, silent || me.$silenceBatch);
      return null;
    } else {
      var _me$afterSet;

      const preResult = me.beforeSet ? me.beforeSet(field, value, silent, fromRelationUpdate) : _undefined,
            wasSet = me.inSet(field, value, silent, fromRelationUpdate, skipAccessors);
      (_me$afterSet = me.afterSet) === null || _me$afterSet === void 0 ? void 0 : _me$afterSet.call(me, field, value, silent, fromRelationUpdate, preResult, wasSet);
      return wasSet;
    }
  }

  fieldToKeys(field, value) {
    if (typeof field !== 'string') {
      // will get in trouble when setting same field on multiple models without this
      return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({}, field);
    }

    return {
      [field]: value
    };
  }

  inBatchSet(field, value, silent) {
    const me = this,
          {
      meta,
      constructor,
      fieldMap
    } = me,
          wasSet = {};
    let cmp,
        changed = false;

    if (typeof field !== 'string') {
      Object.keys(me.fieldToKeys(field, value)).forEach(key => {
        cmp = fieldMap[key] || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"];
        value = constructor.processField(key, field[key], me); // Store batch changes

        if (!cmp.isEqual(meta.batchChanges[key], value)) {
          wasSet[key] = {
            value,
            oldValue: me.get(key)
          };
          meta.batchChanges[key] = value;
          changed = true;
        }
      });
    } else {
      cmp = fieldMap[field] || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"]; // Minor optimization for engine writing back a lot of changes

      if (!cmp.isEqual(meta.batchChanges[field], value)) {
        wasSet[field] = {
          value,
          oldValue: me.get(field)
        };
        meta.batchChanges[field] = value;
        changed = true;
      }
    } // Callers need to be able to detect changes


    if (changed) {
      me.generation++;

      if (!silent) {
        // Fire batched events for UIs which need to update themselves during batched updates.
        // An example is evenResize feature which batches the changes to the endDate
        // or startDate, but the UI must update during the drag.
        const event = {
          action: 'update',
          record: me,
          records: [me],
          changes: wasSet
        };
        me.stores.forEach(store => {
          store.trigger('batchedUpdate', event);
        });
      }
    }
  }

  inSet(field, value, silent, fromRelationUpdate, skipAccessors = false) {
    const me = this,
          {
      data,
      meta,
      fieldMap,
      constructor
    } = me,
          {
      prototype: myProto,
      childrenField
    } = constructor,
          wasSet = {},
          toSet = me.fieldToKeys(field, value),
          keys = Object.keys(toSet);
    let changed = false; // Give a chance to cancel action before records updated.

    if (!silent && !me.triggerBeforeUpdate(toSet)) {
      return null;
    }

    for (let i = 0; i < keys.length; i++) {
      var _field$dataSource4;

      const key = keys[i]; // Currently not allowed to set children in a TreeNode this way, will be ignored

      if (key === childrenField) {
        continue;
      }

      const field = fieldMap[key],
            cmp = field || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"],
            readOnly = field === null || field === void 0 ? void 0 : field.readOnly,
            mapping = (_field$dataSource4 = field === null || field === void 0 ? void 0 : field.dataSource) !== null && _field$dataSource4 !== void 0 ? _field$dataSource4 : key,
            useProp = !skipAccessors && !field && key in myProto,
            oldValue = useProp ? me[mapping] : field !== null && field !== void 0 && field.complexMapping ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getPath(data, mapping) : data[mapping],
            value = constructor.processField(key, toSet[key], me),
            val = toSet[key] = {
        value
      },
            relation = me.getRelationConfig(key);

      if (!readOnly && !cmp.isEqual(oldValue, value)) {
        // Indicate to observers that data has changed.
        me.generation++;
        val.oldValue = oldValue;
        changed = true; // Update `modified` state which is used in sync request

        if (cmp.isEqual(me.meta.modified[key], value)) {
          // Remove changes if values are the same
          Reflect.deleteProperty(meta.modified, key);
        } else if (!me.ignoreBag) {
          // Private flag in engine, speeds initial commit up by not recording changes
          // Cache its original value
          if (!(key in meta.modified)) {
            meta.modified[key] = oldValue;
          }

          if (val.oldValue === _undefined) {
            Reflect.deleteProperty(val, 'oldValue');
          }
        } // The wasSet object keys must be the field *name*, not its dataSource.


        wasSet[key] = val;
        me.applyValue(useProp, mapping, value, skipAccessors, field); // changing foreign key

        if (relation && !fromRelationUpdate) {
          me.initRelation(relation);
          me.stores.forEach(store => store.cacheRelatedRecord(me, value, relation.relationName, val.oldValue));
        }
      }
    }

    if (changed) {
      me.afterChange(toSet, wasSet, silent, fromRelationUpdate, skipAccessors);
    }

    return changed ? wasSet : null;
  } // Provided as a hook for SchedulingEngine to do what needs to be done which ever way a field value is changed


  applyValue(useProp, key, value, skipAccessors, field) {
    var _field;

    let complexMapping = (_field = field) === null || _field === void 0 ? void 0 : _field.complexMapping; // If we don't have a field, but we have a property defined
    // eg, the fullDuration property defined in TaskModel, then
    // use the property

    if (useProp) {
      this[key] = value;
      return;
    } // Might be setting value of nested object


    if (!field && key.includes('.')) {
      var _field2, _field3;

      const nestedName = key.split('.')[0];
      field = this.constructor.fieldMap[nestedName]; // We use complex mapping if the field's dataSource was defined as such,
      // OR if we are being asked to set using dot notation and field is of Object type.

      complexMapping = ((_field2 = field) === null || _field2 === void 0 ? void 0 : _field2.complexMapping) || ((_field3 = field) === null || _field3 === void 0 ? void 0 : _field3.type) === 'object';
    } // Use complex mapping?


    if (complexMapping) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(this.data, key, value);
    } // Otherwise, push the value through into the data.
    else {
      this.data[key] = value;
    }
  } // skipAccessors argument is used in the engine override


  afterChange(toSet, wasSet, silent, fromRelationUpdate, skipAccessors) {
    this.stores.forEach(store => {
      store.onModelChange(this, toSet, wasSet, silent, fromRelationUpdate);
    });
  }
  /**
   * This yields `true` if this record is eligible for syncing with the server.
   * It can yield `false` if the record is in the middle of a {@link #property-isBatchUpdating batched update},
   * or if it is a {@link #property-isCreating tentative record} yet to be confirmed as a new addition.
   * @property {Boolean}
   * @readonly
   */


  get isPersistable() {
    // Record is not persistable if the owning app is in the middle of a batch update
    // and the record is not flagged as being in the middle of a creation sequence.
    // This means that a "new" record can be added on a conditional basis with its
    // isCreating property set which means it is examplt from being synced until
    // the isCreating flag is cleared.
    return !this.isBatchUpdating && !this.isCreating;
  }
  /**
   * True if this model has any uncommitted changes.
   * @property {Boolean}
   * @readonly
   * @category Editing
   */


  get isModified() {
    return Boolean(this.meta.modified && Object.keys(this.meta.modified).length > 0);
  } // TODO: Make this the behaviour of isModified?


  get hasPersistableChanges() {
    return this.isPersistable && !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEmpty(this.rawModificationData);
  }
  /**
   * Returns true if this model has uncommitted changes for the provided field.
   * @param {String} fieldName Field name
   * @returns {Boolean} True if the field is changed
   * @category Editing
   */


  isFieldModified(fieldName) {
    return this.isModified && fieldName in this.meta.modified;
  }
  /**
   * Returns field value that should be persisted, or `undefined` if field is configured with `persist: false`.
   * @param {String|Core.data.field.DataField} nameOrField Name of the field to get value for, or its field definition
   * @private
   * @category Fields
   */


  getFieldPersistentValue(nameOrField) {
    const field = typeof nameOrField === 'string' ? this.getFieldDefinition(nameOrField) : nameOrField,
          name = (field === null || field === void 0 ? void 0 : field.name) || nameOrField;
    let result;

    if (!field || field.persist) {
      result = this[name]; // if serialize function is provided we use it to prepare the persistent value

      if (field !== null && field !== void 0 && field.serialize) {
        result = field.serialize(result, this);
      }
    }

    return result;
  }
  /**
   * Get a map of the modified fields in form of an object. The field *names* are used as the property names
   * in the returned object.
   * @property {Object}
   * @readonly
   * @category Editing
   */


  get modifications() {
    const data = this.rawModifications;

    if (data && Object.keys(data).length) {
      data[this.constructor.idField] = this.id;
    }

    return data;
  }

  get rawModifications() {
    const me = this,
          data = {};

    if (!me.isModified) {
      return null;
    }

    let keySet = false;
    Object.keys(me.meta.modified).forEach(key => {
      // TODO: isModified will report record as modified even if a modification won't be persisted here. Should it?
      const value = me.getFieldPersistentValue(key);

      if (value !== _undefined) {
        data[key] = value;
        keySet = true;
      }
    });
    return keySet ? data : null;
  }
  /**
   * Get a map of the modified fields in form of an object. The field´s {@link Core.data.field.DataField#config-dataSource}
   * is used as the property name in the returned object. The record´s id is always included.
   * @property {Object}
   * @readonly
   * @category Editing
   */


  get modificationData() {
    const data = this.rawModificationData; // If there are some persistable field changes, append record id

    if (data && Object.keys(data).length) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(data, this.constructor.getFieldDefinition(this.constructor.idField).dataSource, this.id);
    }

    return data;
  }
  /**
   * Returns a map of the modified persistable fields
   * @internal
   * @property {Object}
   * @category Editing
   */


  get rawModificationData() {
    const me = this,
          {
      fieldMap
    } = me.constructor,
          data = {};

    if (!me.isModified) {
      return null;
    }

    let keySet = false;
    Object.keys(me.meta.modified).forEach(fieldName => {
      // TODO: isModified will report record as modified even if a modification wont be persisted here. Should it?
      const field = fieldMap[fieldName]; // No field definition means there's no original dataSource to update

      if (field !== null && field !== void 0 && field.persist) {
        const value = me.getFieldPersistentValue(fieldName);

        if (value !== _undefined) {
          _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(data, field.dataSource, value);
          keySet = true;
        }
      }
    });
    return keySet ? data : null;
  }
  /**
   * Get a map of the modified data fields along with any {@link Core/data/field/DataField#config-alwaysWrite} fields, in
   * form of an object. The field´s *dataSource* is used as the property name in the returned object.
   * Used internally by AjaxStore / CrudManager when sending updates.
   * @property {Object}
   * @readonly
   * @category Editing
   */


  get modificationDataToWrite() {
    const alwaysWriteFields = this.constructor.alwaysWriteFields,
          recordData = this.modificationData;
    alwaysWriteFields.forEach(fieldName => {
      recordData[this.getFieldDefinition(fieldName).dataSource] = this.getFieldPersistentValue(fieldName);
    });
    return recordData;
  }
  /**
   * Returns data for **all** {@link Core.data.field.DataField#config-persist persistable} fields in form of an object, using dataSource if present.
   * @property {Object}
   * @internal
   * @readonly
   * @category Editing
   */


  get persistableData() {
    const me = this,
          data = {};
    me.fields.forEach(field => {
      const value = me.getFieldPersistentValue(field);

      if (value !== _undefined) {
        if (field !== null && field !== void 0 && field.complexMapping) {
          _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setPath(data, field.dataSource, value);
        } else {
          data[field.dataSource] = value;
        }
      }
    });
    return data;
  }
  /**
   * True if this models changes are currently being committed.
   * @property {Boolean}
   * @category Editing
   */


  get isCommitting() {
    return Boolean(this.meta.committing);
  }
  /**
   * Clear stored changes, used on commit. Does not revert changes.
   * @privateparam {Boolean} [removeFromStoreChanges] Update related stores modified collection or not
   * @privateparam {Boolean} [includeDescendants] Set true to clear store descendants
   * @category Editing
   */


  clearChanges(removeFromStoreChanges = true, includeDescendants = true) {
    const me = this,
          {
      meta
    } = me;
    meta.modified = {};
    meta.committing = false;

    if (removeFromStoreChanges) {
      me.stores.forEach(store => {
        store.modified.remove(me);
        store.added.remove(me);

        if (includeDescendants) {
          const descendants = store.collectDescendants(me).all;
          store.added.remove(descendants);
          store.modified.remove(descendants);
        }
      });
    }
  }
  /**
   * Reverts changes in this back to their original values.
   * @privateparam {Boolean} [silent] Specify `true` to not trigger events.
   * @category Editing
   */


  revertChanges(silent = false) {
    this.set(this.meta.modified, _undefined, silent);
  } //endregion
  //region Id

  /**
   * Gets the records internalId. It is assigned during creation, guaranteed to be globally unique among models.
   * @property {Number}
   * @category Identification
   */


  get internalId() {
    return this._internalId;
  }
  /**
   * Returns true if the record is new and has not been persisted (and received a proper id).
   * @property {Boolean}
   * @readonly
   * @category Identification
   */


  get isPhantom() {
    return this.id === '' || this.id == null || this.hasGeneratedId;
  }

  get isModel() {
    return true;
  }
  /**
   * Checks if record has a generated id. New records are assigned a generated id (starting with _generated), which should be
   * replaced on commit.
   * @property {Boolean}
   * @category Identification
   */


  get hasGeneratedId() {
    return typeof this.id === 'string' && this.id.startsWith('_generated');
  }

  static generateId(text = this.$$name) {
    return `_generated${text}${++Model._generatedIdIndex}`;
  }
  /**
   * Generates id for new record which starts with _generated.
   * @category Identification
   */


  generateId() {
    return this.constructor.generateId();
  }
  /**
   * Gets the id of specified model or the value if passed string/Number.
   * @param {Core.data.Model|String|Number} model
   * @returns {String|Number} id
   * @category Identification
   */


  static asId(model) {
    return model !== null && model !== void 0 && model.isModel ? model.id : model;
  } //endregion
  //region JSON

  /**
   * Get the records data as a json string.
   *
   * ```javascript
   * const record = new Model({
   *     title    : 'Hello',
   *     children : [
   *         ...
   *     ]
   * });
   *
   * const jsonString = record.json;
   *
   * //jsonString:
   * '{"title":"Hello","children":[...]}'
   * ```
   *
   * @member {String}
   * @category JSON
   */


  get json() {
    return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].safeJsonStringify(this); // calls our toJSON() method
  }
  /**
   * Used by `JSON.stringify()` to correctly convert this record to json.
   *
   * In most cases no point in calling it directly.
   *
   * ```
   * // This will call `toJSON()`
   * const json = JSON.stringify(record);
   * ```
   *
   * If called manually, the resulting object is a clone of `record.data` + the data of any children:
   *
   * ```
   * const record = new Model({
   *     title    : 'Hello',
   *     children : [
   *         ...
   *     ]
   * });
   *
   * const jsonObject = record.toJSON();
   *
   * // jsonObject:
   * {
   *     title : 'Hello',
   *     children : [
   *         ...
   *     ]
   * }
   * ```
   *
   * @returns {Object}
   * @category JSON
   */


  toJSON() {
    const {
      children
    } = this,
          jsonData = this.persistableData;

    if (children) {
      jsonData[this.constructor.childrenField] = children.map(c => c.toJSON());
    }

    return jsonData;
  }
  /**
   * Represent the record as a string, by default as a JSON string. Tries to use an abbreviated version of the objects
   * data, using id + name/title/text/label/description. If no such field exists, the full data is used.
   *
   * ```javascript
   * const record = new Model({ id : 1, name : 'Steve Rogers', alias : 'Captain America' });
   * console.log(record.toString()); // logs { "id" : 1, "name" : "Steve Rogers" }
   * ```
   *
   * @returns {String}
   */


  toString() {
    const me = this,
          nameField = abbreviationFields.find(field => field in me.constructor.fieldMap),
          data = nameField ? {
      [me.constructor.idField]: me.id,
      [nameField]: me[nameField]
    } : me.data;
    return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].safeJsonStringify(data);
  } //endregion
  //region Batch

  /**
   * True if this Model is currently batching its changes.
   * @property {Boolean}
   * @readonly
   * @category Editing
   */


  get isBatchUpdating() {
    return Boolean(this.batching);
  }
  /**
   * Returns `true` if this Model currently has outstanding batched changes for the specified field name.
   * @param {String} fieldName The field name to check for batched updates on.
   * @returns {Boolean}
   */


  hasBatchedChange(fieldName) {
    var _this$meta, _this$meta$batchChang;

    return (_this$meta = this.meta) === null || _this$meta === void 0 ? void 0 : (_this$meta$batchChang = _this$meta.batchChanges) === null || _this$meta$batchChang === void 0 ? void 0 : _this$meta$batchChang[fieldName];
  }
  /**
   * Begin a batch, which stores changes and commits them when the batch ends.
   * Prevents events from being fired during batch.
   *
   * ```javascript
   * record.beginBatch();
   * record.name = 'Mr Smith';
   * record.team = 'Golden Knights';
   * record.endBatch();
   * ```
   *
   * Please note that you can also set multiple fields in a single call using {@link #function-set}, which in many
   * cases can replace using a batch:
   *
   * ```javascript
   * record.set({
   *   name : 'Mr Smith',
   *   team : 'Golden Knights'
   * });
   * ```
   * @category Editing
   * @privateparam {Boolean} silentUpdates Suppress firing the `batchUpdatedEvent`
   */


  beginBatch(silentUpdates = false) {
    const me = this;

    if (!me.batching) {
      me.batching = 0;
      me.meta.batchChanges = {};
    }

    if (silentUpdates) {
      me.$silenceBatch = (me.$silenceBatch || 0) + 1;
    }

    me.batching++;
  }
  /**
   * End a batch, triggering events if data has changed.
   * @param {Boolean} [silent] Specify `true` to not trigger events. If event is recurring, occurrences won't be updated automatically.
   * @category Editing
  */


  endBatch(silent = false, skipAccessors = false) {
    const me = this,
          {
      parentIdField
    } = me.constructor;

    if (!me.batching) {
      return;
    }

    me.batching--; // Ideally we should track which batch was silenced, but that will complicate code more than what avoiding a few
    // triggered events is worth (this is private and we do not start batches while batches are ongoing in the
    // critical code path in engine)

    me.$silenceBatch && me.$silenceBatch--;

    if (me.batching > 0) {
      return;
    } // Set pending batch changes


    if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEmpty(me.meta.batchChanges)) {
      const batchChanges = _objectSpread({}, me.meta.batchChanges);

      me.meta.batchChanges = null; // Move to its new parent before applying the other changes.

      if (batchChanges[parentIdField]) {
        me.parentId = batchChanges[parentIdField];
        delete batchChanges[parentIdField];
      }

      me.set(batchChanges, _undefined, silent, false, skipAccessors);
    }
  }
  /**
   * Cancels current batch operation. Any changes during the batch are discarded.
   * @category Editing
   */


  cancelBatch() {
    if (this.batching) {
      const me = this,
            {
        batchChanges
      } = me.meta,
            wasSet = {};
      me.batching = null;
      me.meta.batchChanges = null;
      me.generation++;

      if (!me.$silenceBatch) {
        // Create a wasSet describing the revert back from the batched values to the real values.
        Object.entries(batchChanges).forEach(([key, oldValue]) => {
          wasSet[key] = {
            oldValue,
            value: me[key]
          };
        }); // Fire batched events for UIs which need to update themselves during batched updates.
        // An example is evenResize feature which batches the changes to the endDate
        // or startDate, but the UI must update during the drag.

        const event = {
          action: 'update',
          record: me,
          records: [me],
          changes: wasSet
        };
        me.stores.forEach(store => {
          store.trigger('batchedUpdate', event);
        });
      }

      me.$silenceBatch && me.$silenceBatch--;
    }
  } //endregion
  //region Events

  /**
   * Triggers beforeUpdate event for each store and checks if changes can be made from event return value.
   * @param {Object} changes Data changes
   * @returns {Boolean} returns true if data changes are accepted
   * @private
   */


  triggerBeforeUpdate(changes) {
    return !this.stores.some(s => {
      return s.trigger('beforeUpdate', {
        record: this,
        changes
      }) === false;
    });
  } //endregion
  //region Additional functionality

  /**
   * Makes a copy of this model, assigning the specified id or a generated id and also allowing you to pass field values to
   * the created copy.
   *
   * ```
   * const record = new Model({ name : 'Super model', hairColor : 'Brown' });
   * const clone = record.copy({ name : 'Super model clone' });
   * ```
   * @param {Number|String|Object} [newId] The id for the copied instance, or any field values to apply
   * (overriding the values from the source record). If no id provided, one will be auto-generated
   * @param {Number|String} [newId.id] DEPRECATED: Id to set, leave out to use generated id or specify false to also copy id
   * @param {Boolean} [newId.deep] DEPRECATED: true to also clone children (use separate argument)
   * @param {Boolean} [deep] True to also clone children
   * @returns {Core.data.Model} Copy of this model
   * @category Editing
   */


  copy(newId = null, params) {
    const me = this,
          data = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(me.data),
          idField = me.constructor.idField;
    let deep, id; // Chrono model is adding more logic to copy and that logic should be manageable from arguments. So there is
    // option to pass object as a last argument to switch method behavior. Used internally only, shouldn't be public.

    deep = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isObject(params) ? params.deep : params;

    if (newId && typeof newId === 'object') {
      id = newId[idField];

      if ('deep' in newId) {
        deep = newId.deep;
        _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].deprecate('Grid', '5.0.0', '`deep` attribute deprecated, in favor of a separate second parameter'); // Only use id once to avoid collisions

        delete newId[idField];
        delete newId.deep;
      } else {
        Object.assign(data, newId);
      }
    } else {
      id = newId;
    } // Iterate over instance children, because data may not reflect actual children state


    if (deep && me.children) {
      data.children = me.children.map(child => child.copy(undefined, params));
    } else {
      delete data.children;
      delete data.expanded;
    }

    if (newId !== false) {
      // We can use the value from the 'id' property, but as a fallback, generate the id.
      data[idField] = id || me.generateId(me.firstStore);
    } // Force using raw data when creating a copy, since data was cloned above anyway


    const copy = new me.constructor(data, null, null, false, true); // Store original record internal id to lookup from copy later

    copy.originalInternalId = me.internalId;
    return copy;
  }
  /**
   * Removes this record from all stores (and in a tree structure, also from its parent if it has one).
   * @param {Boolean} [silent] Specify `true` to not trigger events. If event is recurring, occurrences won't be updated automatically.
   * @category Editing
   */


  remove(silent = false) {
    const me = this,
          {
      parent
    } = this; // Remove from parent if we're in a tree structure.
    // This informs the owning store(s)

    if (parent) {
      parent.removeChild(me);
    } // Store handles remove
    else if (me.stores.length) {
      // Not sure what should happen if you try to remove a special row (group row for example), bailing out
      if (!me.isSpecialRow) {
        me.stores.forEach(s => s.remove(me, silent, false, true));
      }
    }
  }
  /**
   * Get the first store that this model is assigned to.
   * @property {Core.data.Store}
   * @readonly
   * @category Misc
   */


  get firstStore() {
    return this.stores.length > 0 && this.stores[0];
  }
  /**
   * Get a relation config by name, from the first store.
   * @param {String} name
   * @returns {Object}
   * @private
   * @category Relations
   */


  getRelationConfig(name) {
    var _this$firstStore, _this$firstStore$mode;

    // using first store for relations, might have to revise later..
    return (_this$firstStore = this.firstStore) === null || _this$firstStore === void 0 ? void 0 : (_this$firstStore$mode = _this$firstStore.modelRelations) === null || _this$firstStore$mode === void 0 ? void 0 : _this$firstStore$mode.find(r => r.fieldName === name);
  } //endregion
  //region Validation

  /**
   * Check if record has valid data. Default implementation returns true, override in your model to do actual validation.
   * @property {Boolean}
   * @category Editing
   */


  get isValid() {
    return true;
  } //endregion
  //region Store

  /**
   * Joins this record and any children to specified store, if not already joined.
   * @internal
   * @param {Core.data.Store} store Store to join
   * @category Misc
   */


  joinStore(store) {
    const me = this,
          {
      stores
    } = me;

    if (!stores.includes(store)) {
      const {
        unjoinedStores
      } = me;
      super.joinStore(store);
      store.register(me);
      stores.push(store);

      if (unjoinedStores.includes(store)) {
        unjoinedStores.splice(unjoinedStores.indexOf(store), 1);
      }

      me.isLoaded && me.children.forEach(child => child.joinStore(store));
      me.initRelations();

      if (store.tree && !me.isRoot) {
        me.instanceMeta(store.id).collapsed = !me.expanded;
      }
    }
  }
  /**
   * Unjoins this record and any children from specified store, if already joined.
   * @internal
   * @param {Core.data.Store} store Store to join
   * @param {Boolean} [isReplacing] `true` if this record is being replaced
   * @category Misc
   */


  unjoinStore(store, isReplacing = false) {
    const me = this,
          {
      stores,
      unjoinedStores
    } = me;

    if (stores.includes(store)) {
      var _ref, _ref$forEach;

      if (!store.isDestroying) {
        store.unregister(me);
        unjoinedStores.push(store);
      } // me.children may === true...
      // If filtered, *all* children must be unjoined when we are.


      (_ref = me.unfilteredChildren || me.children) === null || _ref === void 0 ? void 0 : (_ref$forEach = _ref.forEach) === null || _ref$forEach === void 0 ? void 0 : _ref$forEach.call(_ref, child => child.unjoinStore(store, isReplacing));
      stores.splice(stores.indexOf(store), 1); // keep the cord to allow removed records to reach the store when needed

      super.unjoinStore && super.unjoinStore(store, isReplacing); // remove from relation cache

      store.uncacheRelatedRecord(me);
    }
  }
  /**
   * Returns true if this record is contained in the specified store, or in any store if store param is omitted.
   * @internal
   * @param {Core.data.Store} store Store to join
   * @returns {Boolean}
   * @category Misc
   */


  isPartOfStore(store) {
    if (store) {
      return store.includes(this);
    }

    return this.stores.length > 0;
  }
  /**
   * Returns true if this record is not part of any store.
   * @property {Boolean}
   * @readonly
   * @internal
   */


  get isRemoved() {
    return !this.isPartOfStore();
  } //endregion
  //region Per instance meta

  /**
   * Used to set per external instance meta data. For example useful when using a record in multiple grids to store some state
   * per grid.
   * @param {String|Object} instanceOrId External instance id or the instance itself, if it has id property
   * @private
   * @category Misc
   */


  instanceMeta(instanceOrId) {
    const {
      meta
    } = this,
          id = instanceOrId.id || instanceOrId;

    if (!meta.map) {
      meta.map = {};
    }

    return meta.map[id] || (meta.map[id] = {});
  }

  get isGroupHeader() {
    return 'groupRowFor' in this.meta;
  }

  get isGroupFooter() {
    return 'groupFooterFor' in this.meta;
  }

  get isSpecialRow() {
    return this.meta.specialRow;
  } //endregion


  static get nonPersistableFields() {
    const me = this;

    if (!me._nonPersistableFields) {
      me._nonPersistableFields = {};
      me.allFields.forEach(field => {
        if (!field.persist || field.calculated) {
          me._nonPersistableFields[field.name] = 1;
        }
      });
    }

    return me._nonPersistableFields;
  }

  static get alwaysWriteFields() {
    const me = this;

    if (!me._alwaysWriteFields) {
      me._alwaysWriteFields = [];
      me.allFields.forEach(field => {
        if (field.alwaysWrite) {
          me._alwaysWriteFields.push(field.name);
        }
      });
    }

    return me._alwaysWriteFields;
  }

}
Model._idField = 'id';
Model._internalIdCounter = 1;
Model._assignedIdField = false;
Model._generatedIdIndex = 0;
Model.exposeProperties();
Model._$name = 'Model';

/***/ }),

/***/ "./lib/Core/data/Store.js":
/*!********************************!*\
  !*** ./lib/Core/data/Store.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Store; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Pluggable.js */ "./lib/Core/mixin/Pluggable.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _mixin_State_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mixin/State.js */ "./lib/Core/mixin/State.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony import */ var _Model_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _StoreBag_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./StoreBag.js */ "./lib/Core/data/StoreBag.js");
/* harmony import */ var _util_Collection_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _mixin_StoreCRUD_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixin/StoreCRUD.js */ "./lib/Core/data/mixin/StoreCRUD.js");
/* harmony import */ var _mixin_StoreFilter_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./mixin/StoreFilter.js */ "./lib/Core/data/mixin/StoreFilter.js");
/* harmony import */ var _mixin_StoreGroup_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./mixin/StoreGroup.js */ "./lib/Core/data/mixin/StoreGroup.js");
/* harmony import */ var _mixin_StoreProxy_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./mixin/StoreProxy.js */ "./lib/Core/data/mixin/StoreProxy.js");
/* harmony import */ var _mixin_StoreRelation_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./mixin/StoreRelation.js */ "./lib/Core/data/mixin/StoreRelation.js");
/* harmony import */ var _mixin_StoreSum_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./mixin/StoreSum.js */ "./lib/Core/data/mixin/StoreSum.js");
/* harmony import */ var _mixin_StoreSearch_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./mixin/StoreSearch.js */ "./lib/Core/data/mixin/StoreSearch.js");
/* harmony import */ var _mixin_StoreSort_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./mixin/StoreSort.js */ "./lib/Core/data/mixin/StoreSort.js");
/* harmony import */ var _mixin_StoreChained_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./mixin/StoreChained.js */ "./lib/Core/data/mixin/StoreChained.js");
/* harmony import */ var _mixin_StoreState_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./mixin/StoreState.js */ "./lib/Core/data/mixin/StoreState.js");
/* harmony import */ var _mixin_StoreTree_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./mixin/StoreTree.js */ "./lib/Core/data/mixin/StoreTree.js");
/* harmony import */ var _mixin_StoreSync_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./mixin/StoreSync.js */ "./lib/Core/data/mixin/StoreSync.js");
/* harmony import */ var _stm_mixin_StoreStm_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./stm/mixin/StoreStm.js */ "./lib/Core/data/stm/mixin/StoreStm.js");
var productName = 'taskboard';
/* eslint-disable no-unused-expressions */

























/**
 * @module Core/data/Store
 */

/**
 * The Store represents a data container which holds flat data or tree structures. An item in the Store is often called
 * a ´record´ and it is simply an instance of the {@link Core.data.Model} (or any subclass thereof).
 *
 * Typically you load data into a store to display it in a Grid or a ComboBox. The Store is the backing data component
 * for any component that is showing data in a list style UI.
 *
 * ## Data format
 * Data is store in a JSON array the Store offers an API to edit, filter, group and sort the records.
 *
 * ## Store with flat data
 * To create a flat store simply provide an array of objects that describe your records
 *
 * ```javascript
 * const store = new Store({
 *   data : [
 *     { id : 1, name : 'ABBA', country : 'Sweden' },
 *     { id : 2, name : 'Beatles', country : 'UK' }
 *   ]
 * });
 *
 * // retrieve record by id
 * const beatles = store.getById(2);
 * ```
 *
 * ## Store with tree data
 * To create a tree store use `children` property for descendant records
 *
 * ```javascript
 * const store = new Store({
 *   tree: true,
 *   data : [
 *     { id : 1, name : 'ABBA', country : 'Sweden', children: [
 *       { id: 2, name: 'Agnetha' },
 *       { id: 3, name: 'Bjorn' },
 *       { id: 4, name: 'Benny' },
 *       { id: 5, name: 'Anni-Frid' }
 *     ]},
 *   ]
 * });
 *
 * // retrieve record by id
 * let benny = store.getById(4);
 * ```
 *
 * Optionally a tree store can consume a flat dataset with nodes that have a `parentId` property. By configuring the
 * store with `tree : true` and `transformFlatData : true`, the flat data is transformed into tree data:
 *
 * ```javascript
 * const store = new Store({
 *   tree              : true,
 *   transformFlatData : true,
 *   data              : [
 *     { id : 1, name : 'ABBA', country : 'Sweden' },
 *     { id : 2, name: 'Agnetha', parentId : 1 },
 *     { id : 3, name: 'Bjorn', parentId : 1 },
 *     { id : 4, name: 'Benny', parentId : 1 },
 *     { id : 5, name: 'Anni-Frid', parentId : 1 }
 *   ]
 * });
 * ```
 *
 * ### Retrieving and consuming JSON
 * For both flat stores or tree stores it is possible to retrieve the data of all records in JSON format:
 *
 * ```javascript
 * const jsonString = store.json;
 *
 * // or
 *
 * const jsonArray = store.toJSON();
 * ```
 *
 * To plug the JSON data back in later:
 *
 * ```javascript
 * store.data = JSON.parse(jsonString);
 *
 * // or
 *
 * store.data = jsonArray;
 * ```
 *
 * ## Sharing stores
 * You cannot directly share a Store between widgets, but the data in a Store can be shared. There are two different
 * approaches depending on your needs, sharing data and chaining stores:
 *
 * ### Shared data
 * To create 2 widgets that share data, you can create 2 separate stores and pass records of the first store as the
 * dataset of the second store.
 *
 * ```javascript
 * let combo1 = new Combo({
 *     appendTo : document.body,
 *     store    : new Store({
 *         data : [
 *             { id : 1, name : 'ABBA', country : 'Sweden' },
 *             { id : 2, name : 'Beatles', country : 'UK' }
 *         ]
 *     }),
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *
 * let combo2 = new Combo({
 *     appendTo : document.body,
 *     store    : new Store({
 *         data : combo1.store.records
 *     }),
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *
 * combo1.store.first.name = 'foo';
 * combo2.store.first.name; // "foo"
 * ```
 *
 * ### Chained stores
 * Another more powerful option to share data between widgets is to create {@link Core.data.mixin.StoreChained chained}
 * stores. The easiest way to create a chained store is to call {@link #function-chain} function.
 *
 * ```javascript
 * let combo1 = new Combo({
 *     appendTo : document.body,
 *     store    : new Store({
 *         data : [
 *             { id : 1, name : 'ABBA', country : 'Sweden' },
 *             { id : 2, name : 'Beatles', country : 'UK' }
 *         ]
 *     }),
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *
 * let combo2 = new Combo({
 *     appendTo : document.body,
 *     store    : combo1.store.chain(),
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *
 * combo1.store.first.name = 'foo';
 * combo2.store.first.name; // "foo"
 * ```
 *
 * A chained store can optionally be created with a filtering function, to only contain a subset of the records from
 * the main store. In addition, the chained store will reflect record removals/additions to the master store, something
 * the shared data approach will not.
 *
 * @mixes Core/mixin/Events
 * @mixes Core/data/mixin/StoreFilter
 * @mixes Core/data/mixin/StoreCRUD
 * @mixes Core/data/mixin/StoreSum
 * @mixes Core/data/mixin/StoreSearch
 * @mixes Core/data/mixin/StoreSort
 * @mixes Core/data/mixin/StoreGroup
 * @mixes Core/data/mixin/StoreChained
 * @mixes Core/data/mixin/StoreState
 * @mixes Core/data/mixin/StoreTree
 * @mixes Core/data/stm/mixin/StoreStm
 * @mixes Core/data/mixin/StoreSync
 *
 * @extends Core/Base
 */

class Store extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_4__["default"], _mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__["default"], _mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_1__["default"], _mixin_State_js__WEBPACK_IMPORTED_MODULE_3__["default"], _mixin_StoreFilter_js__WEBPACK_IMPORTED_MODULE_12__["default"], _mixin_StoreCRUD_js__WEBPACK_IMPORTED_MODULE_11__["default"], _mixin_StoreRelation_js__WEBPACK_IMPORTED_MODULE_15__["default"], // Private
_mixin_StoreSum_js__WEBPACK_IMPORTED_MODULE_16__["default"], _mixin_StoreSearch_js__WEBPACK_IMPORTED_MODULE_17__["default"], _mixin_StoreSort_js__WEBPACK_IMPORTED_MODULE_18__["default"], _mixin_StoreGroup_js__WEBPACK_IMPORTED_MODULE_13__["default"], _mixin_StoreChained_js__WEBPACK_IMPORTED_MODULE_19__["default"], _mixin_StoreState_js__WEBPACK_IMPORTED_MODULE_20__["default"], _mixin_StoreTree_js__WEBPACK_IMPORTED_MODULE_21__["default"], _stm_mixin_StoreStm_js__WEBPACK_IMPORTED_MODULE_23__["default"], _mixin_StoreSync_js__WEBPACK_IMPORTED_MODULE_22__["default"], _mixin_StoreProxy_js__WEBPACK_IMPORTED_MODULE_14__["default"] // Private for now, thus not mentioned in @mixes block above
) {
  //region Config & properties
  static get $name() {
    return 'Store';
  }

  static get properties() {
    return {
      relationCache: {},
      dependentStoreConfigs: new Map()
    };
  }

  static get configurable() {
    return {
      /**
       * Store's unique identifier.
       *
       * @member {String|Number} id
       * @readonly
       * @category Common
       */

      /**
       * Store's unique identifier. When set the store is added to a store map accessible through
       * `Store.getStore(id)`.
       *
       * @config {String|Number}
       * @category Common
       */
      id: true,

      /**
       * Class used to represent records, should be a subclass of {@link Core.data.Model}.
       *
       * ```javascript
       * class MyModel extends Model {
       *     static get fields() {
       *         return [
       *             'name',
       *             'city',
       *             'company'
       *         ]
       *     }
       * }
       *
       * const store = new Store({
       *     modelClass : MyModel,
       *     data : [
       *         { id : 1, name : 'Mark', city : 'London', company : 'Cool inc' },
       *         ...
       *     ]
       * });
       * ```
       *
       * @config {Core.data.Model}
       * @default
       * @typings {typeof Model}
       * @category Common
       */
      modelClass: _Model_js__WEBPACK_IMPORTED_MODULE_5__["default"]
    };
  }

  static get defaultConfig() {
    return {
      /**
       * An array of field definitions used to create a {@link Core.data.Model} (modelClass) subclass. Optional.
       * If the Model already has fields defined, these fields will extend those.
       *
       * ```javascript
       * const store = new Store({
       *     fields : ['name', 'city', 'company'],
       *     data   : [
       *         { id : 1, name : 'Mark', city : 'London', company : 'Cool inc' },
       *         ...
       *     ]
       * });
       * ```
       *
       * See {@link Core.data.Model} for more info on defining fields, changing data source and mapping fields to
       * nested objects.
       *
       * @config {String[]|Object[]|Core.data.field.DataField[]}
       * @category Common
       */
      fields: null,

      /**
       * Automatically detect from set data if used as tree store or flat store
       * @config {Boolean}
       * @default
       * @category Tree
       */
      autoTree: true,

      /**
       * Raw data to load initially.
       *
       * Expects an array of JavaScript objects, with properties matching store's fields (defined on its
       * {@link #config-modelClass model} or in the {@link #config-fields} config).
       *
       * ```javascript
       * const store = new Store({
       *   data : [
       *     { id : 1, name : 'Linda', city : 'NY' },
       *     { id : 2, name : 'Olivia', city : 'Paris' },
       *     ...
       *   ]
       * });
       * ```
       *
       * @config {Object[]|Core.data.Model[]}
       * @category Common
       */
      data: null,

      /**
       * `true` to act as a tree store.
       * @config {Boolean}
       * @category Tree
       */
      tree: false,
      callOnFunctions: true,

      /**
       * A {@link Core.util.Collection Collection}, or Collection config object
       * to use to contain this Store's constituent records.
       * @config {Core.util.Collection|Object}
       * @category Advanced
       */
      storage: null,

      /**
       * Retools the loaded data objects instead of making shallow copies of them. This increases performance but
       * pollutes the incoming data and does not allow remapping of fields (dataSource).
       *
       * Also allows disabling certain steps in data loading, to further improve performance. Either accepts an
       * object with the params described below or `true` which equals `disableDuplicateIdCheck` and
       * `disableTypeConversion`.
       *
       * ```javascript
       * // No duplicate id checking, no type conversions
       * new Store({ useRawData : true });
       *
       * new Store({
       *   // No type conversions only
       *   useRawData : {
       *     disableTypeConversion : true
       *   }
       * });
       * ```
       *
       * @config {Boolean|Object}
       * @param {Boolean} [disableDuplicateIdCheck] Data must not contain duplicate ids, check is bypassed.
       * @param {Boolean} [disableDefaultValue] Default values will not be applied to record fields.
       * @param {Boolean} [disableTypeConversion] No type conversions will be performed on record data.
       * @category Advanced
       */
      useRawData: false,

      /**
       * Specify `false` to prevent loading records without ids, a good practise to enforce when syncing with a
       * backend.
       *
       * By default Store allows loading records without ids, in which case a generated id will be assigned.
       *
       * @config {Boolean}
       * @default true
       * @category Advanced
       */
      allowNoId: true,

      /**
       * Prevent dynamically subclassing the modelClass. It does so by default to not pollute it when exposing
       * properties. Should rarely need to be used.
       * @config {Boolean}
       * @default false
       * @private
       * @category Advanced
       */
      preventSubClassingModel: null
    };
  }

  static get identifiable() {
    return {
      registerGeneratedId: false
    };
  }
  /**
   * Class used to represent records. Defaults to class Model.
   * @member {Core.data.Model} modelClass
   * @typings {typeof Model}
   * @category Records
   */
  //endregion
  //region Events

  /**
   * Fired when the id of a record has changed
   * @event idChange
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model} record Modified record
   * @param {String|Number} oldValue Old id
   * @param {String|Number} value New id
   */

  /**
   * Fired before record is modified in this store.
   * Modification may be vetoed by returning `false` from a handler.
   * @event beforeUpdate
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model} record Modified record
   * @param {Object} changes Modification data
   */

  /**
   * Fired when a record is modified
   * @event update
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model} record Modified record
   * @param {Object} changes Modification data
   */

  /**
   * Fired when one of this Store's constituent records is modified while in
   * {@link Core.data.Model#function-beginBatch batched} state. This may be used to keep
   * UIs up to date while "tentative" changes are made to a record which must not be synced with a server.
   * @event batchedUpdate
   * @private
   */

  /**
   * Fired when the root node is set
   * @event rootChange
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model} oldRoot The old root node.
   * @param {Core.data.Model} rootNode The new root node.
   */

  /**
   * Data in the store was changed. This is a catch-all event which is fired for all changes
   * which take place to the store's data.
   *
   * This includes mutation of individual records, adding and removal of records, as well as
   * setting a new data payload using the {@link #property-data} property, sorting, filtering,
   * and calling {@link Core.data.mixin.StoreCRUD#function-removeAll}.
   *
   * Simple databound widgets may use to the `change` event to refresh their UI without having to add multiple
   * listeners to the {@link #event-update}, {@link Core.data.mixin.StoreCRUD#event-add},
   * {@link Core.data.mixin.StoreCRUD#event-remove}, {@link #event-refresh} and
   * {@link Core.data.mixin.StoreCRUD#event-removeAll} events.
   *
   * A more complex databound widget such as a grid may use the more granular events to perform less
   * destructive updates more appropriate to each type of change. The properties will depend upon the value of the
   * `action` property.
   *
   * @event change
   * @param {Core.data.Store} source This Store.
   * @param {String} action Name of action which triggered the change. May be one of:
   * * `'remove'`
   * * `'removeAll'`
   * * `'add'`
   * * `'updatemultiple'`
   * * `'clearchanges'`
   * * `'filter'`
   * * `'update'`
   * * `'dataset'`
   * * `'replace'`
   * @param {Core.data.Model} record Changed record, for actions that affects exactly one record (`'update'`)
   * @param {Core.data.Model[]} records Changed records, passed for all actions except `'removeAll'`
   * @param {Object} changes Passed for the `'update'` action, info on which record fields changed
   */
  // NOTE: When updating params above, also update change event in ProjectModelMixin and dataChange in ProjectConsumer

  /**
   * Data in the store has completely changed, such as by a filter, or sort or load operation.
   * @event refresh
   * @param {Core.data.Store} source This Store.
   * @param {Boolean} batch Flag set to `true` when the refresh is triggered by ending a batch
   * @param {String} action Name of action which triggered the change. May be one of:
   * * `'dataset'`
   * * `'sort'`
   * * `'clearchanges'`
   * * `'filter'`
   * * `'create'`
   * * `'update'`
   * * `'delete'`
   * * `'group'`.
   */
  //endregion

  /* break doc comment from next method */
  //region Init


  constructor(...args) {
    super(...args); // When using a Proxy, the Proxy is returned instead of the actual Store

    if (this.objectify) {
      return this.initProxy();
    }
  }

  construct(config = {}) {
    const me = this;
    Object.assign(me, {
      added: new _StoreBag_js__WEBPACK_IMPORTED_MODULE_9__["default"](),
      removed: new _StoreBag_js__WEBPACK_IMPORTED_MODULE_9__["default"](),
      modified: new _StoreBag_js__WEBPACK_IMPORTED_MODULE_9__["default"](),
      idRegister: {},
      internalIdRegister: {}
    });

    if (config.storeId) {
      // avoid changing id when setting storeId:
      config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].assign({
        id: config.storeId
      }, config); // We cannot remove storeId since it can also be inherited and if so, it will override the id above:
      // delete config.storeId;
    }

    super.construct(config);
    me.initRelations();
  }
  /**
   * Retrieves/creates a store based on the passed config.
   *
   * | Type              | Result                                                                 |
   * |-------------------|------------------------------------------------------------------------|
   * | Core.data.Store   | Returns supplied store as is                                           |
   * | String            | Retrieves an existing store by id                                      |
   * | Object            | Creates a new store using supplied config object                       |
   * | Object[]          | Creates a new store, populated with records created from supplied data |
   * | Core.data.Model[] | Creates a new store, populated with supplied records                   |
   *
   *
   * @param {Core.data.Store|Object|String|Object[]|Core.data.Model[]} config
   * @param {Object} [defaults] Config object to apply when creating a new store for passed data
   * @param {Function} [converterFn] Function called for each data object prior to creating a record from it. The
   * return value is used to create a record.
   * @private
   */


  static from(config, defaults = {}, converterFn = null) {
    // null and store instances pass through
    if (config && !config.isStore) {
      // Passed a string, get store by id
      if (typeof config === 'string') {
        config = Store.getStore(config);
      } // Passed something else, create a store using the input as its data
      else {
        // Array of records or data, pass to converterFn if one is supplied
        if (Array.isArray(config)) {
          if (converterFn) {
            config = config.map(data => data.isModel ? data : converterFn(data));
          }

          config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].assign({}, defaults, {
            data: config
          });
        }

        config = new Store(config);
      }
    }

    return config;
  }

  doDestroy() {
    var _me$_storage, _me$stm, _me$stm$removeStore;

    const me = this,
          allRecords = me.registeredRecords;

    for (let i = allRecords.length - 1, rec; i >= 0; i--) {
      var _rec;

      rec = allRecords[i];

      if (!((_rec = rec) !== null && _rec !== void 0 && _rec.isDestroyed)) {
        rec.unjoinStore(me);
      }
    }

    (_me$_storage = me._storage) === null || _me$_storage === void 0 ? void 0 : _me$_storage.destroy(); // Remove from STM if added there (STM might also have gotten destroyed before us)

    (_me$stm = me.stm) === null || _me$stm === void 0 ? void 0 : (_me$stm$removeStore = _me$stm.removeStore) === null || _me$stm$removeStore === void 0 ? void 0 : _me$stm$removeStore.call(_me$stm, me);

    if (!me.isChained) {
      var _me$rootNode;

      (_me$rootNode = me.rootNode) === null || _me$rootNode === void 0 ? void 0 : _me$rootNode.destroy();
    } // Events superclass fires destroy event.


    super.doDestroy(); //TODO abort any ongoing loads
  }
  /**
   * Stops this store from firing events until {@link #function-endBatch} is called. Multiple calls to `beginBatch`
   * stack up, and will require an equal number of `endBatch` calls to resume events.
   *
   * Upon call of {@link #function-endBatch}, a {@link #event-refresh} event is triggered to allow UIs to
   * update themselves based upon the new state of the store.
   *
   * This is extremely useful when making a large number of changes to a store. It is important not to trigger
   * too many UI updates for performance reasons. Batching the changes ensures that UIs attached to this
   * store are only updated once at the end of the updates.
   */


  beginBatch() {
    this.suspendEvents();
  }
  /**
   * Ends event suspension started by {@link #function-beginBatch}. Multiple calls to {@link #function-beginBatch}
   * stack up, and will require an equal number of `endBatch` calls to resume events.
   *
   * Upon call of `endBatch`, a {@link #event-refresh} event with `action: batch` is triggered to allow UIs to update
   * themselves based upon the new state of the store.
   *
   * This is extremely useful when making a large number of changes to a store. It is important not to trigger
   * too many UI updates for performance reasons. Batching the changes ensures that UIs attached to this
   * store are only updated once at the end of the updates.
   */


  endBatch() {
    if (this.resumeEvents()) {
      this.trigger('refresh', {
        action: 'batch',
        data: this.storage.values,
        records: this.storage.values
      });
    }
  }

  set storage(storage) {
    const me = this;

    if (storage !== null && storage !== void 0 && storage.isCollection) {
      me._storage = storage;
    } else {
      me._storage = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_10__["default"](storage);
    }

    me._storage.autoFilter = me.reapplyFilterOnAdd;
    me._storage.autoSort = me.reapplySortersOnAdd; // Join all the constituent records to this Store

    for (const r of me._storage) {
      r.joinStore(me);
    }

    me._storage.on({
      change: 'onDataChange',
      thisObj: me
    });
  }

  get storage() {
    if (!this._storage) {
      this.storage = {};
    }

    return this._storage;
  }
  /**
   * Returns all records (not filtered) from the store.
   * @property {Core.data.Model[]}
   * @readonly
   * @category Records
   */


  get allRecords() {
    const me = this;

    if (me.isTree) {
      const result = me.collectDescendants(me.rootNode, undefined, undefined, {
        unfiltered: true
      }).all;

      if (me.rootVisible) {
        result.unshift(me.rootNode);
      }

      return result;
    } else {
      return me.isGrouped ? me.collectGroupRecords() : me.storage.allValues;
    }
  }
  /**
   * Called by owned record when the record has its {@link Core.data.Model#property-isCreating}
   * property toggled.
   * @param {Core.data.Model} record The record that is being changed.
   * @param {Boolean} isCreating The new value of the {@link Core.data.Model#property-isCreating} property.
   * @internal
   */


  onIsCreatingToggle(record, isCreating) {
    const me = this,
          newlyPersistable = record.isPersistable && !isCreating; // If it's a transient "isCreating" record, waiting to be confirmed as a new entry
    // into the store, then it should *not* be in the added Bag as a syncable record.
    // If we are upgrading it to a permanent record, it *should* be in the added Bag.

    me.added[newlyPersistable ? 'add' : 'remove'](record); // If the record is newly persistable...

    if (newlyPersistable) {
      /**
       * Fired when a temporary record with the {@link Core.data.Model#property-isCreating} property set
       * has been confirmed as a part of this store by having its {@link Core.data.Model#property-isCreating}
       * property cleared.
       * @event addConfirmed
       * @param {Core.data.Store} source This Store.
       * @param {Core.data.Model} record The record confirmed as added.
       */
      me.trigger('addConfirmed', {
        record
      }); // AjaxStore to commit confirmed new record

      if (me.autoCommit) {
        me.doAutoCommit();
      }
    }
  }

  joinRecordsToStore(records) {
    records.forEach(record => {
      record.joinStore(this);
    });
  }
  /**
   * Responds to mutations of the underlying storage Collection
   * @param {Object} event
   * @protected
   */


  onDataChange({
    source: storage,
    action,
    added,
    removed,
    replaced,
    oldCount,
    items,
    from,
    to
  }) {
    const me = this,
          addedCount = added === null || added === void 0 ? void 0 : added.length,
          removedCount = removed === null || removed === void 0 ? void 0 : removed.length;
    let filtersWereReapplied, sortersWereReapplied;
    me._idMap = null;

    if (addedCount) {
      me.joinRecordsToStore(added);
    }

    replaced === null || replaced === void 0 ? void 0 : replaced.forEach(([oldRecord, newRecord]) => {
      oldRecord.unjoinStore(me, true);
      newRecord.joinStore(me);
    }); // Allow mixins to mutate the storage before firing events.
    // StoreGroup does this to introduce group records into the mix.

    super.onDataChange(...arguments); // Join/unjoin incoming/outgoing records unless its as a result of TreeNode operations.
    // If we are a tree, joining is done when nodes are added/removed
    // as child nodes of a joined parent.

    if (!me.isTree) {
      if (addedCount) {
        for (const record of added) {
          // If was removed, remove from `removed` list
          if (me.removed.includes(record)) {
            me.removed.remove(record);
          } // Else add to `added` list
          else {
            me.added.add(record);
          }
        } // Re-evaluate the current *local* filter set silently so that the
        // information we are broadcasting below is up to date.


        filtersWereReapplied = !me.remoteFilter && me.filtered && me.reapplyFilterOnAdd;

        if (filtersWereReapplied) {
          me.filter({
            silent: true
          });
        } // if sortParamName not defined, is not remote sort


        sortersWereReapplied = !me.sortParamName && me.isSorted && me.reapplySortersOnAdd;

        if (sortersWereReapplied) {
          me.sort(null, null, false, true);
        }
      }

      if (removedCount) {
        for (const record of removed) {
          // If app was in the middle of a batched update, cancel the update.
          record.cancelBatch();
          record.unjoinStore(me); // If was newly added, remove from `added` list

          if (me.added.includes(record)) {
            me.added.remove(record);
          } // Else add to `removed` list
          // Unless it's StateTrackingManager reverting the record insertion.
          // Also unless it's a record which was a transient record created by the UI
          // and then the create was canceled at the edit stage.
          else if (!record._undoingInsertion && !record.meta.isCreating) {
            me.removed.add(record);
          }
        }

        me.modified.remove(removed); // Re-evaluate the current *local* filter set silently so that the
        // information we are broadcasting below is up to date.

        filtersWereReapplied = !me.remoteFilter && me.filtered;

        if (filtersWereReapplied) {
          me.filter({
            silent: true
          });
        }
      }
    }

    switch (action) {
      case 'clear':
        // Clear our own relationCache, since we will be empty
        me.relationCache = {}; // Signal to stores that depend on us

        me.updateDependentStores('removeall');
        me.trigger('removeAll');
        me.trigger('change', {
          action: 'removeall'
        });
        break;

      case 'splice':
        if (addedCount) {
          me.updateDependentStores('add', added);
          const // Collection does not handle moves, figure out if and where a record was moved from by checking
          // previous index value stored in meta
          oldIndex = added.reduce((lowest, record) => {
            const {
              previousIndex
            } = record.meta;
            if (previousIndex > -1 && previousIndex < lowest) lowest = previousIndex;
            return lowest;
          }, added[0].meta.previousIndex),
                index = storage.indexOf(added[0], !storage.autoFilter),
                params = {
            records: added,
            index
          }; // Only include param oldIndex when used

          if (oldIndex > -1) {
            params.oldIndex = oldIndex;
          }

          me.trigger('add', params);
          me.trigger('change', Object.assign({
            action: 'add'
          }, params));

          if (filtersWereReapplied) {
            me.triggerFilterEvent({
              action: 'filter',
              filters: me.filters,
              oldCount,
              records: me.storage.allValues
            });
          }

          if (sortersWereReapplied) {
            me.trigger('sort', {
              action: 'sort',
              sorters: me.sorters,
              records: me.storage.allValues
            });
          }
        }

        if (removed.length) {
          me.updateDependentStores('remove', removed);
          me.trigger('remove', {
            records: removed
          });
          me.trigger('change', {
            action: 'remove',
            records: removed
          });
        }

        if (replaced.length) {
          me.trigger('replace', {
            records: replaced,
            all: me.records.length === replaced.length
          });
          me.trigger('change', {
            action: 'replace',
            replaced,
            all: me.records.length === replaced.length
          });
        }

        break;

      case 'filter':
        // Reapply grouping/sorting to make sure unfiltered records get sorted correctly
        if (me.isGrouped || me.isSorted) {
          me.performSort(true);
        }

        break;

      case 'move':
        // silently update parentIndex of records affected
        for (let allRecords = me.storage.allValues, i = Math.min(from, to); i <= Math.max(from, to); i++) {
          allRecords[i].setData('parentIndex', i);
        }
        /**
         * Fired when a block of records has been moved within this Store
         * @event move
         * @param {Core.data.Store} source This Store
         * @param {Core.data.Model} record (DEPRECATED) The first record moved (The
         * {@link Core.data.mixin.StoreCRUD#function-move} API now accepts an array of records to move).
         * @param {Core.data.Model[]} records The records moved.
         * @param {Number} from The index from which the record was removed (applicable only for flat store).
         * @param {Number} to The index at which the record was inserted (applicable only for flat store).
         * @param {Core.data.Model} newParent The new parent record for the dragged records (applicable only for tree stores)
         */


        me.trigger('move', {
          record: items[0],
          records: items,
          from,
          to
        }); // The move was in real data. If we are filtered, the
        // filtered set has to be refreshed.

        if (me.isFiltered) {
          me.performFilter();
        }

        me.trigger('change', {
          action,
          record: items[0],
          records: items,
          from,
          to
        });
        break;
    }
  }

  onDataReplaced(action, data) {
    var _me$afterLoadData;

    const me = this,
          all = me.storage.allValues;

    for (let i = 0; i < all.length; i++) {
      all[i].joinStore(me);
    } // Need to update group records info (headers and footers)


    me.prepareGroupRecords(); // The three operations below, filter, store and sort, all are passed
    // the "silent" parameter meaning they do not fire their own events.
    // The 'refresh' and 'change' events after are used to update UIs.

    if (!me.remoteFilter && me.isFiltered) {
      me.filter({
        silent: true
      });
    } // TODO: groupers must just be promoted to be the primary sorters.


    if (me.isGrouped) {
      me.group(null, null, false, !me.sorters.length, true);
    }

    if (!me.sortParamName && me.sorters.length) {
      me.sort(null, null, false, true);
    } // Check for duplicate ids, unless user guarantees data validity


    if (!me.useRawData.disableDuplicateIdCheck) {
      const idMap = me.idMap;

      if (Object.keys(idMap).length < me.storage.values.length) {
        // idMap has fewer entries than expected, a duplicate id was used. pick idMap apart to find out which
        const collisions = [];
        me.storage.values.forEach(r => idMap[r.id] ? delete idMap[r.id] : collisions.push(r));
        throw new Error(`Id collision on ${collisions.map(r => r.id)}`);
      }
    }

    const event = {
      action,
      data,
      records: me.storage.values
    };
    me.updateDependentStores(action, event.records); // Allow subclasses to postprocess a new dataset

    (_me$afterLoadData = me.afterLoadData) === null || _me$afterLoadData === void 0 ? void 0 : _me$afterLoadData.call(me);
    me.trigger('refresh', event);
    me.trigger('change', event);
  }
  /**
   * This is called from Model after mutating any fields so that Stores can take any actions necessary at that point,
   * and distribute mutation event information through events.
   * @param {Core.data.Model} record The record which has just changed
   * @param {Object} toSet A map of the field names and values that were passed to be set
   * @param {Object} wasSet A map of the fields that were set. Each property is a field name, and
   * the property value is an object containing two properties: `oldValue` and `value` eg:
   * ```javascript
   *     {
   *         name {
   *             oldValue : 'Rigel',
   *             value : 'Nigel'
   *         }
   *     }
   *
   * @param {Boolean} silent Do not trigger events
   * @param {Boolean} fromRelationUpdate Update caused by a change in related model
   * @private
   */


  onModelChange(record, toSet, wasSet, silent, fromRelationUpdate) {
    const me = this,
          idField = record.constructor.idField,
          event = {
      record,
      records: [record],
      changes: wasSet,
      // Cannot use isBatching, since change is triggered when batching has reached 0
      // (but before it is set to null)
      batch: record.batching != null,
      fromRelationUpdate
    },
          committable = record.ignoreBag ? false : me.updateModifiedBagForRecord(record); // Inform underlying collection of the changes, allowing it to keep any indices up to date

    me.storage.onItemMutation(record, wasSet);

    if (!silent) {
      if (idField in wasSet) {
        const {
          oldValue,
          value
        } = toSet[idField];
        me.updateDependentRecordIds(oldValue, value);
        me.onRecordIdChange({
          record,
          oldValue,
          value
        });
        me.trigger('idChange', {
          store: me,
          record,
          oldValue,
          value
        });
      }

      me.onUpdateRecord(record, wasSet);
      me.trigger('update', event);
      me.trigger('change', Object.assign({
        action: 'update'
      }, event));
    }

    if (me.autoCommit && committable) {
      me.doAutoCommit();
    }
  }

  updateModifiedBagForRecord(record) {
    const me = this;
    let addedToBag = false; // Add or remove from our modified Bag

    if (record.isModified) {
      if (!me.modified.includes(record) && !me.added.includes(record) && record.isPartOfStore(me) && !record.isAutoRoot) {
        // When we add a new model first time and the model is not persistable (for example when the model is not valid),
        // it is not added to the "added" collection (StoreBag), but only joined to the store.
        // So if the record is not added neither to "modified" nor "added",
        // need to check if this record is phantom. If so, add it to the "added", otherwise to the "modified".
        if (record.isPhantom) {
          me.added.add(record);
        } else {
          me.modified.add(record);
        }

        addedToBag = true;
      }
    } else {
      me.modified.remove(record);
    }

    return addedToBag;
  }

  get idMap() {
    const me = this,
          processedRecords = me.storage.values,
          needsRebuild = !me._idMap,
          idMap = me._idMap || (me._idMap = {});

    if (needsRebuild) {
      for (let record, index = 0, visibleIndex = 0; index < processedRecords.length; index++) {
        record = processedRecords[index];
        idMap[record.id] = {
          index,
          visibleIndex,
          record
        };

        if (!record.isSpecialRow) {
          visibleIndex++;
        }
      }
    }

    return idMap;
  }

  changeModelClass(ClassDef) {
    const fields = this.fields; // noinspection JSRedeclarationOfBlockScope

    let ClassDefEx = null; // Ensure our modelClass is exchanged for an extended of modelClass decorated with any configured fields.

    if (fields !== null && fields !== void 0 && fields.length) {
      ClassDefEx = class extends ClassDef {
        static get fields() {
          return fields;
        }

      };
    } // If we expose properties on Model we will pollute all other models, use internal subclass instead
    else if (!this.preventSubClassingModel) {
      ClassDefEx = class extends ClassDef {};
    } else {
      ClassDefEx = ClassDef;
    } // Need to properly expose relations on this new subclass


    ClassDefEx.initClass();
    return ClassDefEx;
  } //endregion
  //region Store id & map
  // Deprecated.
  // TODO: Remove in 2.0 when all references have been removed from Scheduler and Gantt


  set storeId(storeId) {
    this.id = storeId;
  }

  get storeId() {
    return this.id;
  }

  changeId(id, oldId) {
    return super.changeId(id !== true && id, oldId);
  }

  updateId(id, oldId) {
    // Store code always did just evict any other instance by that ID.
    // TODO: Should we tighten this up?
    const duplicate = Store.getById(id);
    duplicate && Store.unregisterInstance(duplicate);
    super.updateId(id, oldId);
  }

  generateAutoId() {
    return Store.generateId(`store-`);
  }

  get tree() {
    return this._tree;
  }

  set tree(tree) {
    this._tree = tree;

    if (tree && !this.rootNode) {
      this.rootNode = this.buildRootNode();
      this.rootNode.isAutoRoot = true;
    }
  } // a hook to build a customized root node


  buildRootNode() {
    return {};
  }
  /**
   * Get a store from the store map by id.
   * @param {String|Number|Object[]} id The id of the store to retrieve, or an array of objects
   * from which to create the contents of a new Store.
   * @returns {Core.data.Store} The store with the specified id
   */


  static getStore(id, storeClass) {
    if (id instanceof Store) {
      return id;
    }

    if (this.getById(id)) {
      return this.getById(id);
    }

    if (Array.isArray(id)) {
      let storeModel;
      const storeData = id.map(item => {
        if (item instanceof _Model_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {
          storeModel = item.constructor;
        } else if (typeof item === 'string') {
          item = {
            text: item
          };
        } else {}

        return item;
      });
      id = {
        autoCreated: true,
        data: storeData,
        modelClass: storeModel || class extends _Model_js__WEBPACK_IMPORTED_MODULE_5__["default"] {},
        allowNoId: true // String items have no id and are not guaranteed to be unique

      };

      if (!storeClass) {
        storeClass = Store;
      }
    }

    if (storeClass) {
      return new storeClass(id);
    }
  }
  /**
   * Get all registered stores
   * @property {Core.data.Store[]}
   */


  static get stores() {
    return Store.registeredInstances;
  } //endregion
  //region Data

  /**
   * The invisible root node of this tree.
   * @property {Core.data.Model}
   * @readonly
   * @category Tree
   */


  get rootNode() {
    return this.masterStore ? this.masterStore.rootNode : this._rootNode;
  }

  set rootNode(rootNode) {
    var _rootNode$children;

    const me = this,
          oldRoot = me._rootNode; // No change

    if (rootNode === oldRoot) {
      return;
    }

    if (oldRoot) {
      me.clear(true);
    }

    if (rootNode instanceof _Model_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {
      // We insist that the rootNode is expanded otherwise no children will be added
      rootNode.instanceMeta(me).collapsed = false;
      me._rootNode = rootNode;
    } else {
      me._rootNode = rootNode = new me.modelClass(Object.assign({
        expanded: true,
        [me.modelClass.idField]: `${me.id}-rootNode`
      }, rootNode), me, null, true);
    }

    me._tree = true;
    rootNode.isRoot = true;
    rootNode.joinStore(me); // If there are nodes to be inserted into the flat storage
    // then onNodeAddChild knows how to do that and what events
    // to fire based upon rootNode.isLoading.

    if ((_rootNode$children = rootNode.children) !== null && _rootNode$children !== void 0 && _rootNode$children.length || me.rootVisible) {
      rootNode.isLoading = true;
      me.onNodeAddChild(rootNode, rootNode.children || [], 0);
      rootNode.isLoading = false;
    }

    me.trigger('rootChange', {
      oldRoot,
      rootNode
    });
  }
  /**
   * Sets data in the store.
   *
   * Expects an array of JavaScript objects, with properties matching store's fields (defined on its
   * {@link #config-modelClass model} or in the {@link #config-fields} config).
   *
   * Called on initialization if data is in config otherwise call it yourself after ajax call etc. Can also be used to
   * get the raw original data.
   *
   * ```javascript
   * store.data = [
   *   { id : 1, name : 'Linda', city : 'NY' },
   *   { id : 2, name : 'Olivia', city : 'Paris' },
   *   ...
   * ];
   * ```
   *
   * @property {Object[]}
   * @fires refresh
   * @fires change
   * @category Records
   */


  set data(data) {
    this.setStoreData(data);
  } // For overridability in engine


  setStoreData(data) {
    var _data;

    const me = this,
          {
      idField,
      childrenField
    } = me.modelClass; // Make sure that if the plugins have not been processed yet, we call
    // the temporary property getter which configuration injects to
    // process plugins at this point. Some plugins are required to
    // operate on incoming data.

    me.getConfig('plugins'); // In case data is loaded during configuration before configuredListeners have been processed

    me.processConfiguredListeners(); // Allow data as a "named object", using keys as ids

    if (data && !Array.isArray(data)) {
      data = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].transformNamedObjectToArray(data, idField);
    } // Convert to being a tree store if any of the new rows have a children property


    me.tree = !me.isChained && (me.tree || Boolean(me.autoTree && ((_data = data) === null || _data === void 0 ? void 0 : _data.some(r => r[childrenField])))); // Always load a new dataset initially

    if (!me.syncDataOnLoad || !me._data) {
      me._data = data; // This means load the root node

      if (me.tree) {
        if (me.transformFlatData) {
          data = me.treeifyFlatData(data);
        }

        const root = me.rootNode;
        root.isLoading = true; // clear silently without marking as removed

        me.clear(true); // Append child will detect that this is a dataset operation and trigger sort + events needed

        root.appendChild(data);
        me.updateDependentStores('dataset', [root]);
        root.isLoading = false;

        if (data.length === 0) {
          const event = {
            action: 'dataset',
            data: [],
            records: []
          };
          me.trigger('refresh', event);
          me.trigger('change', event);
        } // we must re-apply filters for the filtered tree store
        else if (me.isFiltered) {
          me.filter();
        }
      } else {
        me.loadData(data);
      } // loading the store discards all tracked changes


      me.added.clear();
      me.removed.clear();
      me.modified.clear();
    } // Sync dataset if configured to do so
    else {
      me.syncDataset(data);
    }
  }

  loadData(data, action = 'dataset') {
    const me = this,
          {
      storage,
      allowNoId
    } = me,
          idField = me.modelClass.fieldMap.id.dataSource; // Need to unregister all groups

    me.removeHeadersAndFooters(me.storage.values);
    me._idMap = null;

    if (data) {
      const isRaw = !(data[0] instanceof _Model_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

      if (isRaw) {
        me.modelClass.exposeProperties(data[0]);
        const count = data.length,
              records = new Array(count);

        for (let i = 0; i < count; i++) {
          const recordData = data[i];

          if (!allowNoId && recordData[idField] == null) {
            throw new Error(`Id required but not found on row ${i}`);
          }

          records[i] = me.processRecord(me.createRecord(recordData, true), true);
          records[i].setData('parentIndex', i);
        } // clear without marking as removed


        me.clear(true); // Allow Collection's own filters to work on the Collection by
        // passing the isNewDataset param as true.
        // The storage Collection may have been set up with its own filters
        // while we are doing remote filtering. An example is ComboBox
        // with filterSelected: true. Records which are in the selection are
        // filtered out of visibility using a filter directly in the Combobox's
        // Store's Collection.

        storage.replaceValues({
          values: records,
          isNewDataset: true,
          silent: true
        });
      } else {
        // clear without marking as removed
        me.clear(true);
        storage.replaceValues({
          values: data.slice(),
          isNewDataset: true,
          silent: true
        });
      }

      me.onDataReplaced(action, data);
    } else {
      // clear without marking as removed
      me.clear(true);
      me._data = null;
    }
  }

  get data() {
    return this._data;
  }
  /**
   * Creates an array of records from this store from the `start` to the `end' - 1
   * @param {Number} [start] The index of the first record to return
   * @param {Number} [end] The index *after* the last record to return `(start + length)`
   * @return {Core.data.Model[]} The requested records.
   * @category Records
   */


  getRange(start, end, all = true) {
    return (all ? this.storage.allValues : this.storage.values).slice(start, end);
  }
  /**
   * Creates a model instance, used internally when data is set/added. Override this in a subclass to do your own custom
   * conversion from data to record.
   * @param {Object} data Json data
   * @param {Boolean} [skipExpose] Supply true when batch setting to not expose properties multiple times
   * @category Records
   */


  createRecord(data, skipExpose = false) {
    return new this.modelClass(data, this, null, skipExpose);
  }

  processRecord(record, isDataset = false) {
    return record;
  }

  refreshData() {
    this.filter();
    this.sort();
  }

  onRecordIdChange({
    record,
    oldValue,
    value
  }) {
    const me = this,
          idMap = me._idMap,
          {
      idRegister
    } = me;
    me.storage._indicesInvalid = true;

    if (idMap) {
      delete idMap[oldValue];
      idMap[value] = record;
    }

    me.added.changeId(oldValue, value);
    me.removed.changeId(oldValue, value);
    me.modified.changeId(oldValue, value);
    delete idRegister[oldValue];
    idRegister[value] = record;
    record.index = me.storage.indexOf(record);
  }

  onUpdateRecord(record, changes) {
    const {
      internalId
    } = changes,
          {
      internalIdRegister
    } = this;

    if (internalId) {
      this.storage._indicesInvalid = true;
      delete internalIdRegister[internalId.oldValue];
      internalIdRegister[internalId.value] = record;
    } // Reapply filters when records change?


    if (this.reapplyFilterOnUpdate && this.isFiltered) {
      this.filter();
    }
  }

  get useRawData() {
    return this._useRawData;
  }

  set useRawData(options) {
    if (options === true) {
      this._useRawData = {
        enabled: true,
        disableDuplicateIdCheck: true,
        disableTypeConversion: true,
        disableDefaultValue: false
      };
    } else {
      this._useRawData = options ? Object.assign(options, {
        enabled: true
      }) : {
        enabled: false
      };
    }
  } //endregion
  //region Count

  /**
   * Number of records in the store
   * @param {Boolean} [countProcessed] Count processed (true) or real records (false)
   * @returns {Number} Record count
   * @category Records
   */


  getCount(countProcessed = true) {
    return countProcessed ? this.count : this.originalCount;
  }
  /**
   * Record count, for data records. Not including records added for group headers etc.
   * @property {Number}
   * @readonly
   * @category Records
   */


  get originalCount() {
    var _this$groupRecords;

    return this.storage.totalCount - (((_this$groupRecords = this.groupRecords) === null || _this$groupRecords === void 0 ? void 0 : _this$groupRecords.length) || 0);
  }
  /**
   * Record count, including records added for group headers etc.
   * @property {Number}
   * @readonly
   * @category Records
   */


  get count() {
    return this.storage.count;
  }
  /**
   * Returns the complete dataset size regardless of tree node collapsing or filtering
   * @property {Number}
   * @readonly
   * @category Records
   */


  get allCount() {
    return this.isTree ? this.rootNode.descendantCount : this.storage.totalCount;
  } //endregion
  //region Get record(s)
  // TODO: Implement immutable tag for docs #1206

  /**
   * Returns all "visible" records.
   * **Note:** The returned value **may not** be mutated!
   * @property {Core.data.Model[]}
   * @readonly
   * @immutable
   * @category Records
   */


  get records() {
    return this.storage.values;
  }
  /**
   * Get the first record in the store.
   * @property {Core.data.Model}
   * @readonly
   * @category Records
   */


  get first() {
    return this.storage.values[0];
  }
  /**
   * Get the last record in the store.
   * @property {Core.data.Model}
   * @readonly
   * @category Records
   */


  get last() {
    return this.storage.values[this.storage.values.length - 1];
  }
  /**
   * Get the record at the specified index
   * @param {Number} index Index for the record
   * @returns {Core.data.Model} Record at the specified index
   * @category Records
   */


  getAt(index, all = false) {
    // all means include filtered out records
    return this.storage.getAt(index, all);
  } // These are called by Model#join and Model#unjoin
  // register a record as a findable member keyed by id and internalId


  register(record) {
    const me = this,
          // Test for duplicate IDs on register only when a tree store.
    // loadData does it in the case of a non-tree
    existingRec = me.isTree && me.idRegister[record.id];

    if (existingRec && existingRec !== record) {
      throw new Error(`Id collision on ${record.id}`);
    }

    me.idRegister[record.id] = record;
    me.internalIdRegister[record.internalId] = record;
  }

  unregister(record) {
    delete this.idRegister[record.id];
    delete this.internalIdRegister[record.internalId];
  }

  get registeredRecords() {
    return Object.values(this.idRegister);
  }
  /**
   * Get a record by id. Find the record even if filtered out, part of collapsed group or collapsed node
   * @param {Core.data.Model|String|Number} id Id of record to return.
   * @returns {Core.data.Model} A record with the specified id
   * @category Records
   */


  getById(id) {
    // In case `id` is a record, we use its ID to try to find the record in the store,
    // because if the record is removed from the store it shouldn't be found.
    // if (id instanceof Model) {
    //     id = id.id;
    // }
    if (id !== null && id !== void 0 && id.isModel) {
      return id;
    } //return this.tree ? this.idRegister[id] : this.storage.get(id);


    return this.idRegister[id];
  }
  /**
   * Checks if a record is available, in the sense that it is not filtered out,
   * hidden in a collapsed group or in a collapsed node.
   * @param {Core.data.Model|String|Number} recordOrId Record to check
   * @returns {Boolean}
   * @category Records
   */


  isAvailable(recordOrId) {
    const record = this.getById(recordOrId);
    return record && this.storage.includes(record) || false;
  }
  /**
   * Get a record by internalId.
   * @param {Number} internalId The internalId of the record to return
   * @returns {Core.data.Model} A record with the specified internalId
   * @category Records
   */


  getByInternalId(internalId) {
    return this.internalIdRegister[internalId];
  }
  /**
   * Checks if the specified record is contained in the store
   * @param {Core.data.Model|String|Number} recordOrId Record, or `id` of record
   * @returns {Boolean}
   * @category Records
   */


  includes(recordOrId) {
    if (this.isTree) {
      return this.idRegister[_Model_js__WEBPACK_IMPORTED_MODULE_5__["default"].asId(recordOrId)] != null;
    }

    return this.indexOf(recordOrId) > -1;
  } //endregion
  //region Get index

  /**
   * Returns the index of the specified record/id, or `-1` if not found.
   * @param {Core.data.Model|String|Number} recordOrId Record, or `id` of record to return the index of.
   * @param {Boolean} [visibleRecords] Pass `true` to find the visible index.
   * as opposed to the dataset index. This omits group header records.
   * @returns {Number} Index for the record/id, or `-1` if not found.
   * @category Records
   */


  indexOf(recordOrId, visibleRecords = false) {
    // Only check records actually in the store ($store is for objectify scenario)
    if (recordOrId !== null && recordOrId !== void 0 && recordOrId.isModel && !recordOrId.stores.includes(this.$store || this)) {
      return -1;
    }

    const id = _Model_js__WEBPACK_IMPORTED_MODULE_5__["default"].asId(recordOrId);

    if (id == null) {
      return -1;
    } // When a tree, indexOf is always in the visible records - filtering is different in trees.


    if (this.isTree) {
      return this.storage.indexOf(id);
    }

    const found = this.idMap[id];
    return found ? found[visibleRecords ? 'visibleIndex' : 'index'] : -1;
  }

  allIndexOf(recordOrId) {
    if (this.isTree) {
      const record = this.getById(recordOrId);
      let result = -1; // Use the tree structure to get the index in tree walk order

      if (record) {
        record.bubble(n => {
          if (n.parent) {
            result += n.parentIndex + 1;
          } else if (n === this.rootNode && this.rootVisible) {
            result += 1;
          }
        });
      }

      return result;
    } else {
      return this.storage.indexOf(recordOrId, true);
    }
  } //endregion
  //region Get values

  /**
   * Returns an array of distinct values for the specified field.
   *
   * ```javascript
   * store.getDistinctValues('age'); // Returns an array of the unique age values
   * ```
   *
   * @param {String} field Field to extract values for
   * @param {Boolean} [searchAllRecords] True to ignore any applied filters
   * @returns {Array} Array of values
   * @category Values
   */


  getDistinctValues(field, searchAllRecords = false) {
    const me = this,
          values = [],
          keys = {};
    let value;
    me.forEach(r => {
      if (!r.isSpecialRow && !r.isRoot) {
        value = r.get(field);
        const primitiveValue = value instanceof Date ? value.getTime() : value;

        if (!keys[primitiveValue]) {
          values.push(value);
          keys[primitiveValue] = 1;
        }
      }
    }, me, searchAllRecords);
    return values;
  }
  /**
   * Counts how many times specified value appears in the store
   * @param {String} field Field to look in
   * @param {*} value Value to look for
   * @returns {Number} Found count
   * @category Values
   */


  getValueCount(field, value) {
    let count = 0;
    this.forEach(r => {
      if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isEqual(r.get(field), value)) count++;
    });
    return count;
  } //endregion
  //region JSON & console

  /**
   * Retrieve or set the data of all records as a JSON string
   *
   * ```javascript
   * const store = new Store({
   *     data : [
   *         { id : 1, name : 'Superman' },
   *         { id : 2, name : 'Batman' }
   *     ]
   * });
   *
   * const jsonString = store.json;
   *
   * //jsonString:
   * '[{"id":1,"name":"Superman"},{"id":2,"name":"Batman"}]
   * ```
   *
   * @property {String}
   */


  set json(json) {
    if (typeof json === 'string') {
      json = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].safeJsonParse(json);
    }

    this.data = json;
  }

  get json() {
    return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].safeJsonStringify(this);
  }
  /**
   * Pretty printed version of {@link #property-json}
   * @readonly
   * @property {String}
   */


  get formattedJSON() {
    return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].safeJsonStringify(this, null, 4);
  }
  /**
   * Retrieve the data of all records as an array of JSON objects
   *
   * ```javascript
   * const store = new Store({
   *     data : [
   *         { id : 1, name : 'Superman' },
   *         { id : 2, name : 'Batman' }
   *     ]
   * });
   *
   * const jsonArray = store.toJSON();
   *
   * //jsonArray:
   * [{id:1,name:"Superman"},{id:2,name:"Batman"}]
   * ```
   *
   * @returns {Object[]}
   */


  toJSON() {
    // extract entire structure.
    // If we're a tree, then that consists of the payload of the rootNode.
    return (this.isTree ? this.rootNode.children || [] : this).map(record => record.toJSON());
  } //endregion
  //region Iteration & traversing

  /**
   * Iterates over all normal records in store. Omits group header and footer records
   * if this store is grouped.
   * @param {Function} fn A function that is called for each record. Returning false from that function cancels iteration
   * @param {Object} [thisObj] `this` reference for the function
   * @param {Object|Boolean} [options] A boolean for includeFilteredOutRecords, or detailed options for exclude/include records
   * @param {Boolean} [options.includeFilteredOutRecords] True to also include filtered out records
   * @param {Boolean} [options.includeCollapsedGroupRecords] True to also include records from collapsed groups of grouped store
   * @category Iteration
   */


  forEach(fn, thisObj = this, options) {
    // backward compatibility to support includeFilteredOutRecords parameter instead of options
    options = options === undefined ? false : options; // TODO clean up and remove boolean option

    if (typeof options === 'boolean') {
      options = {
        includeFilteredOutRecords: options,
        includeCollapsedGroupRecords: false
      };
    }

    const callback = (r, i) => {
      if (!r.isRoot && !r.isSpecialRow) {
        return fn.call(thisObj, r, i);
      }
    };

    if (this.isTree) {
      this.rootNode.traverseWhile(callback, false, options.includeFilteredOutRecords);
    } else {
      // native forEach cannot be aborted by returning false, have to loop "manually"
      const records = options.includeFilteredOutRecords ? this.storage.allValues : this.storage.values; // grouped store has own tree-like structure, but cannot be handled like a regular tree

      if (this.isGrouped && options.includeCollapsedGroupRecords) {
        for (let i = 0; i < records.length; i++) {
          const record = records[i];

          if (record.groupChildren && record.meta.collapsed === true) {
            for (let j = 0; j < record.groupChildren.length; j++) {
              const rec = record.groupChildren[j];

              if (callback(rec, j) === false) {
                return;
              }
            }
          } else if (callback(record, i) === false) {
            return;
          }
        }
      } else {
        for (let i = 0; i < records.length; i++) {
          if (callback(records[i], i) === false) {
            return;
          }
        }
      }
    }
  }
  /**
   * Equivalent to Array.map(). Creates a new array with the results of calling a provided function on every record
   * @param {Function} fn
   * @returns {Array}
   * @category Iteration
   */


  map(fn, thisObj = this) {
    return this.storage.values.map(fn, thisObj);
  }
  /**
   * Equivalent to Array.reduce(). Applies a function against an accumulator and each record (from left to right) to
   * reduce it to a single value.
   * @param {Function} fn
   * @param {*} initialValue
   * @returns {*}
   * @category Iteration
   */


  reduce(fn, initialValue = [], thisObj = this) {
    if (thisObj !== this) {
      fn = fn.bind(thisObj);
    }

    return this.storage.values.reduce(fn, initialValue, thisObj);
  }
  /**
   * Iterator that allows you to do for (let record of store)
   * @category Iteration
   */


  [Symbol.iterator]() {
    return this.storage.values[Symbol.iterator]();
  }
  /**
   * Traverse all tree nodes (only applicable for Tree Store)
   * @param {Function} fn The function to call on visiting each node.
   * @param {Core.data.Model} [topNode=this.rootNode] The top node to start the traverse at.
   * @param {Boolean} [skipTopNode] Pass true to not call `fn` on the top node, but proceed directly to its children.
   * @param {Object|Boolean} [options] A boolean for includeFilteredOutRecords, or detailed options for exclude/include records
   * @param {Boolean} [options.includeFilteredOutRecords] True to also include filtered out records
   * @param {Boolean} [options.includeCollapsedGroupRecords] True to also include records from collapsed groups of grouped store
   * @category Traverse
   */


  traverse(fn, topNode = this.rootNode, skipTopNode = topNode === this.rootNode, options) {
    // backward compatibility to support includeFilteredOutRecords parameter instead of options
    options = options === undefined ? false : options; // TODO remove boolean option

    if (typeof options === 'boolean') {
      options = {
        includeFilteredOutRecords: options,
        includeCollapsedGroupRecords: false
      };
    }

    const me = this;

    if (me.isTree) {
      // Allow store.traverse(fn, true) to start from rootNode
      if (typeof topNode === 'boolean') {
        skipTopNode = topNode;
        topNode = me.rootNode;
      }

      if (me.isChained) {
        const passedFn = fn;

        fn = node => {
          if (me.chainedFilterFn(node)) {
            passedFn(node);
          }
        };
      }

      topNode.traverse(fn, skipTopNode, options.includeFilteredOutRecords);
    } else {
      me.forEach(rec => rec.traverse(fn, false, options.includeFilteredOutRecords), me, options);
    }
  }
  /**
   * Traverse all tree nodes while the passed `fn` returns true
   * @param {Function} fn The function to call on visiting each node. Returning `false` from it stops the traverse.
   * @param {Core.data.Model} [topNode=this.rootNode] The top node to start the traverse at.
   * @param {Boolean} [skipTopNode] Pass true to not call `fn` on the top node, but proceed directly to its children.
   * @category Traverse
   */


  traverseWhile(fn, topNode = this.rootNode, skipTopNode = topNode === this.rootNode) {
    const me = this;

    if (me.isTree) {
      // Allow store.traverse(fn, true) to start from rootNode
      if (typeof topNode === 'boolean') {
        skipTopNode = topNode;
        topNode = me.rootNode;
      }

      if (me.isChained) {
        const passedFn = fn;

        fn = node => {
          if (me.chainedFilterFn(node)) {
            passedFn(node);
          }
        };
      }

      topNode.traverseWhile(fn, skipTopNode);
    } else {
      for (const record of me.storage) {
        if (record.traverse(fn) === false) {
          break;
        }
      }
    }
  }
  /**
   * Finds the next record.
   * @param {Core.data.Model|String|Number} recordOrId Current record or its id
   * @param {Boolean} [wrap=false] Wrap at start/end or stop there
   * @param {Boolean} [skipSpecialRows=false] True to not return specialRows like group headers
   * @returns {Core.data.Model} Next record or null if current is the last one
   * @category Traverse
   */


  getNext(recordOrId, wrap = false, skipSpecialRows = false) {
    const me = this,
          records = me.storage.values;
    let idx = me.indexOf(recordOrId);

    if (idx >= records.length - 1) {
      if (wrap) {
        idx = -1;
      } else {
        return null;
      }
    }

    const record = records[idx + 1]; // Skip the result if it's a specialRow and we are told to skip them

    if (skipSpecialRows && record && record.isSpecialRow) {
      return me.getNext(records[idx + 1], wrap, true);
    }

    return record;
  }
  /**
   * Finds the previous record.
   * @param {Core.data.Model|String|Number} recordOrId Current record or its id
   * @param {Boolean} [wrap=false] Wrap at start/end or stop there
   * @param {Boolean} [skipSpecialRows=false] True to not return specialRows like group headers
   * @returns {Core.data.Model} Previous record or null if current is the last one
   * @category Traverse
   */


  getPrev(recordOrId, wrap = false, skipSpecialRows = false) {
    const me = this,
          records = me.storage.values;
    let idx = me.indexOf(recordOrId);

    if (idx === 0) {
      if (wrap) {
        idx = records.length;
      } else {
        return null;
      }
    }

    const record = records[idx - 1]; // Skip the result if it's a specialRow and we are told to skip them

    if (skipSpecialRows && record && record.isSpecialRow && idx > 0) {
      return me.getPrev(records[idx - 1], wrap, true);
    }

    return record;
  }
  /**
   * Gets the next or the previous record. Optionally wraps from first -> last and vice versa
   * @param {String|Core.data.Model} recordOrId Record or records id
   * @param {Boolean} next Next (true) or previous (false)
   * @param {Boolean} wrap Wrap at start/end or stop there
   * @param {Boolean} [skipSpecialRows=false] True to not return specialRows like group headers
   * @returns {Core.data.Model}
   * @category Traverse
   * @internal
   */


  getAdjacent(recordOrId, next = true, wrap = false, skipSpecialRows = false) {
    return next ? this.getNext(recordOrId, wrap, skipSpecialRows) : this.getPrev(recordOrId, wrap, skipSpecialRows);
  }
  /**
   * Finds the next record among leaves (in a tree structure)
   * @param {Core.data.Model|String|Number} recordOrId Current record or its id
   * @param {Boolean} [wrap] Wrap at start/end or stop there
   * @returns {Core.data.Model} Next record or null if current is the last one
   * @category Traverse
   * @internal
   */


  getNextLeaf(recordOrId, wrap = false) {
    const me = this,
          records = me.leaves,
          record = me.getById(recordOrId);
    let idx = records.indexOf(record);

    if (idx >= records.length - 1) {
      if (wrap) {
        idx = -1;
      } else {
        return null;
      }
    }

    return records[idx + 1];
  }
  /**
   * Finds the previous record among leaves (in a tree structure)
   * @param {Core.data.Model|String|Number} recordOrId Current record or its id
   * @param {Boolean} [wrap] Wrap at start/end or stop there
   * @returns {Core.data.Model} Previous record or null if current is the last one
   * @category Traverse
   * @internal
   */


  getPrevLeaf(recordOrId, wrap = false) {
    const me = this,
          records = me.leaves,
          record = me.getById(recordOrId);
    let idx = records.indexOf(record);

    if (idx === 0) {
      if (wrap) {
        idx = records.length;
      } else {
        return null;
      }
    }

    return records[idx - 1];
  }
  /**
   * Gets the next or the previous record among leaves (in a tree structure). Optionally wraps from first -> last and
   * vice versa
   * @param {String|Core.data.Model} recordOrId Record or record id
   * @param {Boolean} [next] Next (true) or previous (false)
   * @param {Boolean} [wrap] Wrap at start/end or stop there
   * @returns {Core.data.Model}
   * @category Traverse
   * @internal
   */


  getAdjacentLeaf(recordOrId, next = true, wrap = false) {
    return next ? this.getNextLeaf(recordOrId, wrap) : this.getPrevLeaf(recordOrId, wrap);
  } //endregion


}
Store.initClass();
Store._$name = 'Store';

/***/ }),

/***/ "./lib/Core/data/StoreBag.js":
/*!***********************************!*\
  !*** ./lib/Core/data/StoreBag.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StoreBag; });
/* harmony import */ var _util_Bag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/Bag.js */ "./lib/Core/util/Bag.js");
var productName = 'taskboard';

/**
 * @module Core/data/StoreBag
 */

class StoreBag extends _util_Bag_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  add(...toAdd) {
    if (toAdd.length === 1 && Array.isArray(toAdd[0])) {
      toAdd = toAdd[0];
    } // ignore unpersistable records


    return super.add(...toAdd.filter(record => record.isPersistable));
  }

}
;
StoreBag._$name = 'StoreBag';

/***/ }),

/***/ "./lib/Core/data/field/ArrayDataField.js":
/*!***********************************************!*\
  !*** ./lib/Core/data/field/ArrayDataField.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ArrayDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'taskboard';

/**
 * @module Core/data/field/ArrayDataField
 */

/**
 * This field class handles fields that hold an array. For the field to count as modified, the whole array has to be
 * replaced:
 *
 * ```javascript
 * class Task extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'todo', type : 'array' }
 *         ];
 *     }
 * }
 *
 * const task = new Task({
 *     name : 'Task 1',
 *     todo : [
 *         { text : 'Something', done : false },
 *         { text : 'Some other thing', done : true }
 *     ]
 * };
 *
 * // This wont be detected as a modification
 * task.todo[0].done = true;
 * // task.isModified === false
 *
 * // But this will
 * const todo = task.todo.slice(); // Create a new array with same contents
 * todo[0].done = true;
 * task.todo = todo;
 * // task.isModified === true
 * ```
 *
 * @extends Core/data/field/DataField
 * @classtype array
 */

class ArrayDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ArrayDataField';
  }

  static get type() {
    return 'array';
  }

  isEqual(a, b) {
    return a === b;
  }

}
ArrayDataField.initClass();
ArrayDataField._$name = 'ArrayDataField';

/***/ }),

/***/ "./lib/Core/data/field/BooleanDataField.js":
/*!*************************************************!*\
  !*** ./lib/Core/data/field/BooleanDataField.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BooleanDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'taskboard';

/**
 * @module Core/data/field/BooleanDataField
 */

/**
 * This field class handles field of type `Boolean`.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'active', type : 'boolean' }
 *         ];
 *     }
 * }
 * ```
 *
 * When a field is declared as a `'boolean'`, non-null values are promoted to `Boolean` type. This is seldom required,
 * but can be useful if a field value is received as a number but should be treated as a boolean.
 *
 * @extends Core/data/field/DataField
 * @classtype boolean
 */

class BooleanDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'BooleanDataField';
  }

  static get type() {
    return 'boolean';
  }

  static get alias() {
    return 'bool';
  }

  static get prototypeProperties() {
    return {
      /**
       * The value to replace `null` when the field is not `nullable`.
       * @config {Boolean}
       * @default
       */
      nullValue: false
    };
  }

  convert(value) {
    return value == null ? this.nullable ? value : this.nullValue : Boolean(value);
  }

}
BooleanDataField.initClass();
BooleanDataField._$name = 'BooleanDataField';

/***/ }),

/***/ "./lib/Core/data/field/DataField.js":
/*!******************************************!*\
  !*** ./lib/Core/data/field/DataField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DataField; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';



/**
 * @module Core/data/field/DataField
 */

const {
  getOwnPropertyDescriptor
} = Reflect;
/**
 * This is the base class for Model field classes. A field class defines how to handle the data for a particular type
 * of field. Many of these behaviors can be configured on individual field instances.
 *
 * @extends Core/Base
 */

class DataField extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get $name() {
    return 'DataField';
  }

  static get type() {
    return 'auto';
  }

  static get factoryable() {
    return {
      defaultType: 'auto'
    };
  }

  static get prototypeProperties() {
    return {
      /**
       * The name of the field.
       * @config {String} name
       */

      /**
       * The label text for a form item generated for this field. This is also used to create
       * a column header for a {@link #config-column} for this field.
       * @config {String} label
       */

      /**
       * A column config object for a column to display this field in a grid. For simple, atomic
       * data types, such as `date`, `string`, `boolean`, `number` and `integer`, this is optional
       * and the appropriate column type can be inferred.
       *
       * This also provides default values for column configuration if a configured column definition
       * for a grid lacks a property.
       *
       * For complex fields, such as identifiers which link to other records, a more capable
       * column type may be specified, for example a `type : `number'` field may be configured
       * with
       *
       * ```javascript
       * column : 'percent'
       * ```
       * or
       * ```javascript
       * column : {
       *     type : 'percent',
       *     width : 100
       * }
       * ```
       * if it represents a percentage vaue and needs appropriate rendering and editing.
       * @config {String|Object} column
       */

      /**
       * A config object for a widget to edit this field in a form. For simple, atomic
       * data types, such as `date`, `string`, `boolean`, `number` and `integer`, this is optional
       * and the appropriate input widget type can be inferred.
       *
       * For complex fields, such as identifiers which link to other records, a more capable
       * widget may be specified.
       * @config {String|Object} editor
       * @private
       */

      /**
       * A function that compares two values and returns a value < 0 if the first is less than the second, or 0
       * if the values are equal, or a value > 0 if the first is greater than the second.
       * @config {Function}
       * @default
       */
      compare: null,

      /**
       * A function that compares two objects or records using the `compare` function on the properties of each
       * objects based on the `name` of this field.
       * @config {Function}
       * @default
       * @internal
       */
      compareItems: null,

      /**
       * The property in a record's data object that contains the field's value.
       * Defaults to the field's `name`.
       * @config {String}
       * @default
       */
      dataSource: null,

      /**
       * The default value to assign to this field in a record if no value is provided.
       * @config {*} defaultValue
       */

      /**
       * Setting to `true` will ensure this field is included in any update/insert request payload
       * when a Store / Project / CrudManager performs a request.
       * @config {Boolean}
       * @default
       */
      alwaysWrite: false,

      /**
       * Setting to `false` indicates that `null` is not a valid value.
       * @config {Boolean}
       * @default
       */
      nullable: true,

      /**
       * The value to return from {@link #function-print} for a `null` or `undefined` value.
       * @config {String}
       * @default
       */
      nullText: null,

      /**
       * The value to replace `null` when the field is not `nullable`.
       * @config {*}
       * @default
       */
      nullValue: undefined,

      /**
       * Set to `false` to exclude this field when saving records to a server.
       * @config {Boolean}
       * @default
       */
      persist: true,

      /**
       * Set to `true` for the field's set accessor to ignore attempts to set this field.
       * @config {Boolean}
       * @default
       */
      readOnly: false,

      /**
       * By default, defined {@link Core.data.Model} fields may be used to create a grid column
       * suitable for diplaying that field in a grid cell. Some fields may not be suitable for
       * features which automatically generate columns for view. These fields are created using
       * `internal : true`. Some examples are the `expanded` and `rowHeight` fields which are used
       * internally.
       * @config {Boolean}
       * @default
       */
      internal: false
    };
  }
  /**
   * The class that first defined this field. Derived classes that override a field do not change this property.
   * @member {Core.data.Model} definedBy
   * @private
   * @readonly
   */

  /**
   * The class that most specifically defined this field. Derived classes that override a field set this property to
   * themselves.
   * @member {Core.data.Model} owner
   * @private
   * @readonly
   */
  // NOTE: Since we create lots of instances, they have no life cycle (they are not destroyed) and are readonly after
  // creation, this class does not use configurable.


  construct(config) {
    const me = this;

    if (config) {
      me.name = config.name; // assign name first for diagnostic reasons

      Object.assign(me, config);
    }

    if (me.compare) {
      // We wrap in this way to allow compareItems() to be used as an array sorter fn (which gets no "this"):
      me.compareItems = (itemA, itemB) => me.compare(itemA === null || itemA === void 0 ? void 0 : itemA[me.name], itemB === null || itemB === void 0 ? void 0 : itemB[me.name]);
    }
  }
  /**
   * This method transforms a data value into the desired form for storage in the record's data object.
   * @method convert
   * @param {*} value The value to convert for storage in a record.
   * @returns {*} The converted value.
   */

  /**
   * This method transforms a data value into the desired form for transmitting to a server.
   * @method serialize
   * @param {*} value The value to serialize
   * @param {Core.data.Model} record The record that contains the value being serialized.
   * @returns {*} The serialized value.
   */

  /**
   * Create getter and setter functions for the specified field name under the specified key.
   * @internal
   */


  defineAccessor(target, force) {
    const {
      name,
      dataSource
    } = this; // Bail out if trying to override a explicitly defined accessor

    if (!force && name in target && target.$meta.hierarchy.some(current => {
      var _getOwnPropertyDescri;

      return ((_getOwnPropertyDescri = getOwnPropertyDescriptor(current.prototype, name)) === null || _getOwnPropertyDescri === void 0 ? void 0 : _getOwnPropertyDescri.enumerable) === false;
    })) {
      return;
    }

    Reflect.defineProperty(target, name, {
      configurable: true,
      // To allow removing it later
      enumerable: true,
      // no arrow functions here, need `this` to change to instance
      get: this.complexMapping ? function () {
        return this.complexGet(name, dataSource);
      } : function () {
        var _this$data$dataSource;

        // Inlined copy of Model#flatGet, to save a fn call since this is hit very often
        // When changes are batched, they get stored by field name, not dataSource
        if (this.batching && name in this.meta.batchChanges) {
          return this.meta.batchChanges[name];
        }

        return (_this$data$dataSource = this.data[dataSource]) !== null && _this$data$dataSource !== void 0 ? _this$data$dataSource : this.data[name];
      },

      // no arrow functions here, need `this` to change to instance
      set(value) {
        // Since the accessor is defined on a base class, we dip into the fields map for the actual
        // calling class to get the correct field definition
        const field = this.$meta.fields.map[name]; // Only set if field is read/write. Privately, we use setData to set its value

        if (!(field && field.readOnly)) {
          this.set(name, value);
        }
      }

    });
  }
  /**
   * Compares two values for this field and returns `true` if they are equal, and `false` if not.
   * @param {*} first The first value to compare for equality.
   * @param {*} second The second value to compare for equality.
   * @returns {Boolean} `true` if `first` and `second` are equal.
   */


  isEqual(first, second) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(first, second);
  }
  /**
   * Returns the given field value as a `String`. If `value` is `null` or `undefined`, the value specified by
   * {@link #config-nullText} is returned.
   * @param {*} value The value to convert to a string.
   * @returns {String}
   */


  print(value) {
    return value == null ? this.nullText : this.printValue(value);
  }
  /**
   * Returns the given, non-null field value as a `String`.
   * @param {*} value The value to convert to a string (will not be `null` or `undefined`).
   * @returns {String}
   * @protected
   */


  printValue(value) {
    return String(value);
  }

}
DataField._$name = 'DataField';

/***/ }),

/***/ "./lib/Core/data/field/DateDataField.js":
/*!**********************************************!*\
  !*** ./lib/Core/data/field/DateDataField.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'taskboard';



/**
 * @module Core/data/field/DateDataField
 */

/**
 * This field class handles field of type `Date`.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'birthday', type : 'date', format : 'YYYY-MM-DD' },
 *             { name : 'age', readOnly : true }
 *         ];
 *     }
 * }
 * ```
 *
 * When a field is declared as a `'date'`, non-null values are promoted to `Date` type. This is frequently needed due
 * to how date types are serialized to JSON strings.
 *
 * Date fields can have a special `defaultValue` of `'now'` which will convert to the current date/time.
 *
 * @extends Core/data/field/DataField
 * @classtype date
 */

class DateDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'DateDataField';
  }

  static get type() {
    return 'date';
  }

  static get prototypeProperties() {
    return {
      /**
       * The format of the date field. *Deprecated*: use {@link #config-format} instead.
       *
       * @config {String} dateFormat
       * @deprecated Use {@link #config-format} instead.
       */

      /**
       * The format of the date field.
       *
       * See {@link Core.helper.DateHelper DateHelper} for details.
       * @config {String} format
       * @default DateHelper.defaultFormat
       */
      format: null
    };
  }

  get dateFormat() {
    return this.format;
  }

  set dateFormat(v) {
    _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].deprecate('Core', '5.0.0', `DateDataField "${this.name}": dateFormat config has been renamed to "format"`);
    this.format = v;
  }

  convert(value) {
    if (value == null) {
      if (!this.nullable) {
        value = this.nullValue;
      }
    } else if (value === 'now') {
      value = new Date();
    } else if (!(value instanceof Date)) {
      // Use configured format, if null/undefined use DateHelpers default format
      value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parse(value, this.format || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].defaultParseFormat); // if parsing has failed, we would like to return `undefined` to indicate the "absence" of data
      // instead of `null` (presence of "empty" data)

      value = value || undefined;
    }

    return value;
  }

  serialize(value) {
    if (value instanceof Date) {
      // Use configured format or DateHelpers default one
      value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(value, this.format || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].defaultFormat);
    }

    return value;
  }

  printValue(value) {
    return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(value, this.format || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].defaultFormat);
  }

}
DateDataField.initClass();
DateDataField._$name = 'DateDataField';

/***/ }),

/***/ "./lib/Core/data/field/IntegerDataField.js":
/*!*************************************************!*\
  !*** ./lib/Core/data/field/IntegerDataField.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return IntegerDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'taskboard';

/**
 * @module Core/data/field/IntegerDataField
 */

/**
 * This field class handles field of type `Number` with no decimal digits.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'age', type : 'int' }
 *         ];
 *     }
 * }
 * ```
 *
 * When a field is declared as a `'int'`, non-null values are promoted to `Number` type and decimals are removed using
 * a specified `rounding`. This field type can be useful if a field value is received as a string but should be stored
 * as a number or has a fractional component that must be rounded or truncated.
 *
 * @extends Core/data/field/DataField
 * @classtype integer
 */

class IntegerDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'IntegerDataField';
  }

  static get type() {
    return 'integer';
  }

  static get alias() {
    return 'int';
  }

  static get prototypeProperties() {
    return {
      /**
       * The value to replace `null` when the field is not `nullable`.
       * @config {Number}
       * @default
       */
      nullValue: 0,

      /**
       * The `Math` method to use to ensure fractional component is removed.
       * This can be `'round'` (the default value), `'floor'` or `'ceil'`.
       * @config {String}
       * @default
       */
      rounding: 'round'
    };
  }

  convert(value) {
    return value == null ? this.nullable ? value : this.nullValue : Math[this.rounding](Number(value));
  }

}
IntegerDataField.initClass();
IntegerDataField._$name = 'IntegerDataField';

/***/ }),

/***/ "./lib/Core/data/field/ModelDataField.js":
/*!***********************************************!*\
  !*** ./lib/Core/data/field/ModelDataField.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ModelDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'taskboard';

/**
 * @module Core/data/field/ModelDataField
 */

/**
 * This field class handles fields that hold other records.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'address', type : 'model' }
 *         ];
 *     }
 * }
 * ```
 *
 * @internal
 * @extends Core/data/field/DataField
 * @classtype model
 */

class ModelDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ModelDataField';
  }

  static get type() {
    return 'model';
  }

  static get prototypeProperties() {
    return {
      complexMapping: true
    };
  }

  isEqual(first, second) {
    // Check for semantic equality. An instance of the same Model class of the same ID is equal.
    return first && second && second instanceof first.constructor && second.id == first.id;
  }

}
ModelDataField.initClass();
ModelDataField._$name = 'ModelDataField';

/***/ }),

/***/ "./lib/Core/data/field/NumberDataField.js":
/*!************************************************!*\
  !*** ./lib/Core/data/field/NumberDataField.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NumberDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'taskboard';

/**
 * @module Core/data/field/NumberDataField
 */

/**
 * This field class handles field of type `Number`.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'age', type : 'number' }
 *         ];
 *     }
 * }
 * ```
 *
 * When a field is declared as a `'number'`, non-null values are promoted to `Number` type. This is seldom required, but
 * can be useful if a field value is received as a string but should be treated as a number.
 *
 * @extends Core/data/field/DataField
 * @classtype number
 */

class NumberDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'NumberDataField';
  }

  static get type() {
    return 'number';
  }

  static get alias() {
    return 'float';
  }

  static get prototypeProperties() {
    return {
      /**
       * The value to replace `null` when the field is not `nullable`.
       * @config {Number}
       * @default
       */
      nullValue: 0,

      /**
       * The numeric precision of this field. Values are rounded to the specified number of digits. If `null`,
       * the default, no rounding is performed.
       * @config {Number}
       * @default
       */
      precision: null
    };
  }

  convert(value) {
    if (value == null) {
      return this.nullable ? value : this.nullValue;
    }

    value = Number(value);
    let scale = this.precision;

    if (scale) {
      scale = 10 ** scale;
      value = Math.round(value * scale) / scale;
    } else if (scale === 0) {
      value = Math.round(value);
    }

    return value;
  }

}
NumberDataField.initClass();
NumberDataField._$name = 'NumberDataField';

/***/ }),

/***/ "./lib/Core/data/field/ObjectDataField.js":
/*!************************************************!*\
  !*** ./lib/Core/data/field/ObjectDataField.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ObjectDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'taskboard';

/**
 * @module Core/data/field/ObjectDataField
 */

/**
 * This field class handles fields that hold an object.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             'name',
 *             { name : 'address', type : 'object' }
 *         ];
 *     }
 * }
 * ```
 *
 * For the field to count as modified, the whole object has to be replaced:
 *
 * ```javascript
 * person.address = { ...address };
 * ```
 *
 * @extends Core/data/field/DataField
 * @classtype object
 */

class ObjectDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ObjectDataField';
  }

  static get type() {
    return 'object';
  }

  static get prototypeProperties() {
    return {
      complexMapping: true
    };
  }

}
ObjectDataField.initClass();
ObjectDataField._$name = 'ObjectDataField';

/***/ }),

/***/ "./lib/Core/data/field/StringDataField.js":
/*!************************************************!*\
  !*** ./lib/Core/data/field/StringDataField.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StringDataField; });
/* harmony import */ var _DataField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataField.js */ "./lib/Core/data/field/DataField.js");
var productName = 'taskboard';

/**
 * @module Core/data/field/StringDataField
 */

/**
 * This field class handles field of type `String`.
 *
 * ```javascript
 * class Person extends Model {
 *     static get fields() {
 *         return [
 *             { name : 'name', type : 'string' }
 *         ];
 *     }
 * }
 * ```
 *
 * When a field is declared as a `'string'`, non-null values are promoted to `String` type. This is seldom required, but
 * can be useful if a field value is received as a number but should be treated as a string.
 *
 * @extends Core/data/field/DataField
 * @classtype string
 */

class StringDataField extends _DataField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'StringDataField';
  }

  static get type() {
    return 'string';
  }

  static get prototypeProperties() {
    return {
      /**
       * The value to replace `null` when the field is not `nullable`.
       * @config {String}
       * @default
       */
      nullValue: ''
    };
  }

  convert(value) {
    return value == null ? this.nullable ? value : this.nullValue : String(value);
  }

}
StringDataField.initClass();
StringDataField._$name = 'StringDataField';

/***/ }),

/***/ "./lib/Core/data/mixin/StoreCRUD.js":
/*!******************************************!*\
  !*** ./lib/Core/data/mixin/StoreCRUD.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
var productName = 'taskboard';


/**
 * @module Core/data/mixin/StoreCRUD
 */

/**
 * Mixin for Store that handles modifying records (add, remove etc).
 *
 * @example
 * // add new record to store
 * store.add({ id: 1, team: 'FC Krasnodar' });
 *
 * // remove a record from store, using id
 * store.remove(1);
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreCRUD extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreCRUD';
  } //region Config


  static get defaultConfig() {
    return {
      /**
       * Commit changes automatically
       * @config {Boolean}
       * @default
       * @category Common
       */
      autoCommit: false
    };
  }

  static get properties() {
    return {
      isRemoving: false,
      suspendCount: 0
    };
  } //endregion
  //region Events

  /**
   * Fired after removing all records
   * @event removeAll
   * @param {Core.data.Store} source This Store
   */

  /**
   * Fired before committing changes. Return false from handler to abort commit
   * @event beforeCommit
   * @param {Core.data.Store} source This Store
   * @param {Object} changes Modification data
   */

  /**
   * Fired after committing changes
   * @event commit
   * @param {Core.data.Store} source This Store
   * @param {Object} changes Modification data
   */

  /**
   * Fired before records are removed from this store by the {@link #function-remove} or {@link #function-removeAll}.
   * Also fired when removing a child record in a tree store using {@link Core.data.mixin.TreeNode#function-removeChild}.
   * The remove may be vetoed by returning `false` from a handler.
   * @event beforeRemove
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model[]} records The records which are to be removed.
   * @param {Core.data.Model} parent The record from which children are being removed when using a tree store
   * @param {Boolean} isMove Set to `true` if the child node is being removed by
   * {@link Core.data.mixin.TreeNode#function-appendChild appendChild} to be moved
   * _within the same tree_.
   * @param {Boolean} removingAll Set to `true` if the operation is removing the store's entire data set.
   */

  /**
   * Fired before records are added to this store by the {@link #function-add} or {@link #function-insert}. In a tree
   * store, also fired by {@link Core.data.mixin.TreeNode#function-appendChild} and
   * {@link Core.data.mixin.TreeNode#function-insertChild}. The add or insert may be vetoed by returning `false`
   * from a handler.
   * @event beforeAdd
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model[]} records The records which are to be added
   * @param {Core.data.Model} parent The parent node when using a tree store
   * @preventable
   */

  /**
   * Fired after adding/inserting record(s). If the record was added to a parent, the `isChild` flag is set on the
   * event. If it was inserted, event contains `index`
   * @event add
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model[]} records Added records. In case of tree store, if branch is added, only branch root
   * is returned
   * @param {Core.data.Model[]} [allRecords] Flat list of all added records. In case of tree store, if branch is
   * added, all new records are returned, not only branch root
   * @param {Core.data.Model} [parent] If due to an {@link Core.data.mixin.TreeNode#function-appendChild appendChild}
   * call, this is the parent node added to.
   * @param {Number} [index] Insertion point in the store's {@link Core.data.Store#config-storage Collection}.
   * @param {Number} [oldIndex] Not used for tree stores. The index of the first record moved.
   * @param {Boolean} [isChild] Flag which is set to true if the records are added to a parent record
   * @param {Boolean} [isExpand] Flag which is set to true if records are added to the store by expanding parent
   * @param {Object} [isMove] An object keyed by the ids of the records which were moved from another
   * position in the store, or from another parent node in the store. The ids of moved records will be
   * property names with a value `true`.
   */

  /**
   * Fired when a record has been removed
   * @event remove
   * @param {Core.data.Store} source This Store
   * @param {Core.data.Model[]} records Removed records. In case of tree store, if branch is removed, only branch root
   * is returned
   * @param {Core.data.Model[]} [allRecords] Flat list of all removed records. In case of tree store, if branch is
   * removed, all removed records are returned, not only branch root
   * @param {Core.data.Model} [parent] If due to a {@link Core.data.mixin.TreeNode#function-removeChild removeChild}
   * call, this is the parent node removed from.
   * @param {Number} [index] Visible index at which record was removed. In case record is removed from the collapsed
   * branch -1 is returned.
   * @param {Boolean} [isChild] Flag which is set to true if the record is added to a parent record
   * @param {Boolean} [isCollapse] Flag which is set to true if records are removed from the store by collapsing parent
   * @param {Boolean} [isMove] Passed as `true` if the remove was part of a move operation within this Store.
   */
  //endregion
  //region Add, insert & remove

  /**
   * Removes a record from this store.
   * @param {String|String[]|Number|Number[]|Core.data.Model|Core.data.Model[]} records Record/array of records (or record ids) to remove
   * @param {Boolean} [silent] Specify `true` to suppress events/autoCommit
   * @returns {Core.data.Model[]} Removed records
   * @fires beforeRemove
   * @fires remove
   * @fires change
   * @category CRUD
   */


  remove(records, silent = false) {
    const me = this,
          {
      storage
    } = me;

    if (records instanceof Set) {
      records = Array.from(records);
    } // Ensure we have an array of records in case we are passed IDs


    records = (Array.isArray(records) ? records : [records]).reduce((result, r) => {
      r = me.getById(r);

      if (r) {
        result.push(r);
      }

      return result;
    }, []);

    if (records.length) {
      // Flag that can be checked in linked store to determine if removal is ongoing
      me.isRemoving = true;

      if (me.tree) {
        // In case it's a set of records from different parents, group them by parent
        const removeChildArgs = records.reduce((result, child) => {
          const parent = child.parent;

          if (parent) {
            if (!result[parent.id]) {
              result[parent.id] = [parent, []];
            }

            result[parent.id][1].push(child);
          }

          return result;
        }, {}); // Remove the records each from their correct parent

        for (const argBlock of Object.values(removeChildArgs)) {
          argBlock[0].removeChild(argBlock[1], false, silent);
        }

        me.isRemoving = false;
        return records;
      } // Ensure that records in collapsed groups are removed and events fired.
      else if (me.isGrouped) {
        const oldCount = storage.count,
              recordsInCollapsedGroups = [],
              changedGroupParents = new Set(); // Collect any records which are in collapsed groups which will not be in the storage
        // Collection, and so will not cause a store change.
        // If we find some, we must fire the event which the store will react to and update itself.

        for (const rec of records) {
          const {
            groupParent
          } = rec.instanceMeta(me);

          if (groupParent && groupParent.meta.collapsed) {
            recordsInCollapsedGroups.push(rec);
          } // Collect group header records which change so they can announce this to cause UI updates.


          _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].remove(groupParent.groupChildren, rec);
          groupParent.meta.childCount--;
          changedGroupParents.add(groupParent);
        } // The changed group parents must announce their changes, otherwise the group headers
        // in a UI will not refresh to reflect the change.


        for (const groupParent of changedGroupParents) {
          if (groupParent.groupChildren.length > 0) {
            me.onModelChange(groupParent, {}, {});
          }
        } // The store must react as if these records in collapsed groups have been removed from storage


        if (recordsInCollapsedGroups.length) {
          storage.trigger('change', {
            action: 'splice',
            removed: recordsInCollapsedGroups,
            added: [],
            replaced: [],
            oldCount
          });
        }
      } // Give chance to veto or take action before records disappear.


      if (!records.length || !silent && me.trigger('beforeRemove', {
        records
      }) === false) {
        me.isRemoving = false;
        return null;
      }

      if (silent) {
        me.suspendEvents();
      }

      storage.remove(records);

      if (silent) {
        me.resumeEvents();
      }

      if (me.autoCommit) {
        me.doAutoCommit();
      }

      me.isRemoving = false;
    }

    return records;
  }
  /**
   * Clears store data. Used by removeAll, separate function for using with chained stores.
   * @private
   * @category CRUD
   */


  clear(isLoading = false) {
    var _me$rootNode, _me$rootNode$unfilter;

    const me = this,
          {
      storage
    } = me; // For tree store, we have to check unfilteredChildren to see if store has contents

    if (me.storage.totalCount || (_me$rootNode = me.rootNode) !== null && _me$rootNode !== void 0 && (_me$rootNode$unfilter = _me$rootNode.unfilteredChildren) !== null && _me$rootNode$unfilter !== void 0 && _me$rootNode$unfilter.length) {
      // Give chance to veto or take action before records disappear.
      if (!isLoading && me.trigger('beforeRemove', {
        records: storage.allValues,
        removingAll: true
      }) === false) {
        return null;
      } // For tree scenario, clean up root node too


      if (me.rootNode) {
        // A chained tree store shares root node with its master store
        if (!me.isChained) {
          me.rootNode.clearChildren(isLoading);
        }
      } else if (isLoading) {
        // If we are loading, we suspend events, and Store#onDataChange won't get to
        // do all this stuff.
        const allRecords = me.registeredRecords;

        for (let i = allRecords.length - 1, rec; i >= 0; i--) {
          rec = allRecords[i];

          if (rec && !rec.isDestroyed) {
            rec.unjoinStore(me);
          }
        }
      }

      if (isLoading) {
        me.removed.clear();
        storage.suspendEvents();
      } // Clearing the storage will trigger 'removeAll' and 'change' if `removing`


      storage.clear();

      if (isLoading) {
        storage.resumeEvents();
      }

      me.added.clear();
      me.modified.clear();
    }
  }
  /**
   * Removes all records from the store.
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Boolean} `true` unless the action was prevented, in which case it returns `false`
   * @fires beforeRemove
   * @fires removeAll
   * @fires change
   * @category CRUD
   */


  removeAll(silent = false) {
    const me = this,
          storage = me.storage;
    let result;
    me.isRemoving = true; // No reaction to the storage Collection's change event.

    if (silent) {
      storage.suspendEvents(); // If silent, the storage Collection won't fire the event we react to
      // to unjoin, and we allow the removing flag in remove() to be true,
      // so *it* will not do the unJoin, so if silent, so do it here.

      const allRecords = me.registeredRecords;

      for (let i = allRecords.length - 1, rec; i >= 0; i--) {
        rec = allRecords[i];

        if (rec && !rec.isDestroyed && !rec.isRoot) {
          rec.unjoinStore(me);
        }
      }
    }

    if (me.tree) {
      result = me.rootNode.clear() !== false;
    } else {
      result = me.clear() !== null;
    }

    if (silent) {
      storage.resumeEvents();
    }

    me.isRemoving = false;
    return result;
  }
  /**
   * Add records to store.
   * @param {Core.data.Model|Core.data.Model[]|Object|Object[]} records Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Core.data.Model[]} Added records
   * @fires add
   * @fires change
   * @category CRUD
   */


  add(records, silent = false) {
    const me = this,
          storage = me.storage;

    if (!Array.isArray(records)) {
      records = [records];
    } else if (!records.length) {
      // Adding zero records, bail out
      return;
    }

    me.tree = me.tree || Boolean(me.autoTree && records[0].children);

    if (me.tree) {
      const // Map and not Object to allow keys to keep their type
      parentIdMap = new Map(),
            added = [];
      records.forEach(node => {
        const parentId = node[me.modelClass.parentIdField];

        if (!parentIdMap.has(parentId)) {
          parentIdMap.set(parentId, []);
        }

        parentIdMap.get(parentId).push(node);
      });
      parentIdMap.forEach((nodes, parentId) => {
        const parentNode = parentId == null ? me.rootNode : me.getById(parentId);

        if (!parentNode) {
          throw new Error(`Parent node with id ${parentId} not found, cannot add children.`);
        }

        added.push(...parentNode.appendChild(nodes, silent));
      });
      return added;
    } // Give chance to cancel action before records added.


    if (!silent) {
      if (me.trigger('beforeAdd', {
        records
      }) === false) {
        return null;
      }
    }

    me.tree = me.tree || Boolean(me.autoTree && records[0].children);

    if (me.tree) {
      return me.rootNode.appendChild(records);
    }

    const added = me.processRecords(records);

    if (silent) {
      me.suspendEvents();
    }

    storage.add(added);

    if (silent) {
      me.resumeEvents();
    }

    if (me.autoCommit) {
      me.doAutoCommit();
    }

    return added;
  }

  processRecords(records, onRecordCreated) {
    return records.map(data => {
      const record = this.processRecord(data.isModel ? data : this.createRecord(data));
      onRecordCreated === null || onRecordCreated === void 0 ? void 0 : onRecordCreated.call(this, record);
      return record;
    });
  }
  /**
   * Insert records to store.
   * @param {Number} index Index to insert at
   * @param {Core.data.Model|Core.data.Model[]|Object|Object[]} records Array of records/data or a single record/data to insert to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Core.data.Model[]} Inserted records
   * @fires add
   * @fires change
   * @category CRUD
   */


  insert(index, records, silent = false) {
    const me = this,
          storage = me.storage,
          insertBefore = me.getAt(index),
          _records = storage.values,
          removeIndices = [];
    if (!Array.isArray(records)) records = [records]; // Give chance to cancel action before records added.

    if (!silent && me.trigger('beforeAdd', {
      records
    }) === false) {
      return null;
    }

    let isNoop, start, i; // If the records starting at index or (index - 1), are the same sequence
    // that we are being asked to add, this is a no-op.

    if (_records[start = index] === records[0] || _records[start = index - 1] === records[0]) {
      for (isNoop = true, i = 0; isNoop && i < records.length; i++) {
        if (records[i] !== _records[start + i]) {
          isNoop = false;
        }
      }
    }

    if (isNoop) {
      return null;
    }

    const added = me.processRecords(records, record => {
      const removedAtIndex = storage.indexOf(record);

      if (record.children && record.children.length && me.autoTree) {
        me.tree = true;
      } // already in store, do some cleanup


      if (removedAtIndex > -1) {
        if (removedAtIndex < index && insertBefore) index--;
        removeIndices.push(removedAtIndex);
      } // Store previous index to be able to determine that it is a move, since Collection does not handle that


      record.meta.previousIndex = removedAtIndex;
    });

    if (me.tree) {
      const root = me.rootNode;
      return root.insertChild(records, root.children && root.children[index], silent);
    } // Silently remove them, so that they will be inserted into place.
    // Collection is stable by default, and inserting an existing item
    // is a no-op.


    me.suspendEvents();
    me.storage.remove(removeIndices);
    me.resumeEvents();

    if (silent) {
      me.suspendEvents();
    }

    storage.splice(index, 0, ...added);

    if (silent) {
      me.resumeEvents();
    }

    if (me.autoCommit) {
      me.doAutoCommit();
    }

    return added;
  }
  /**
   * Moves a record, or block of records to another location.
   * @param {Core.data.Model|Core.data.Model[]} records The record(s) to move.
   * @param {Core.data.Model} beforeRecord the record to insert the first record(s) before.
   * @fires change
   * @category CRUD
   */


  move(records, beforeRecord) {
    if (this.isTree) {
      beforeRecord.parent.insertChild(records, beforeRecord);
    } else {
      this.storage.move(records, beforeRecord);
    }
  } //endregion
  //region Update multiple


  setMultiple(filterFn, field, value) {
    const me = this,
          records = [],
          changes = [];
    me.forEach(r => {
      if (filterFn(r)) {
        changes.push(r.set(field, value, true));
        records.push(r);
      }
    }); // TODO: should consolidate with update, make it take an array instead? to only have to listen for one event outside of store?

    me.trigger('updateMultiple', {
      records,
      all: me.records.length === records.length
    });
    me.trigger('change', {
      action: 'updatemultiple',
      records,
      all: me.records.length === records.length
    });
    if (me.reapplyFilterOnUpdate && me.isFiltered) me.filter();
  }

  setAll(field, value) {
    const me = this,
          changes = [];
    me.forEach(r => {
      changes.push(r.set(field, value, true));
    });
    me.trigger('updateMultiple', {
      records: me.records,
      all: true
    });
    me.trigger('change', {
      action: 'updatemultiple',
      records: me.records,
      all: true
    });
    if (me.reapplyFilterOnUpdate && me.isFiltered) me.filter();
  } //endregion
  //region Commit

  /**
   * Accepts all changes, resets the modification tracking:
   * * Clears change tracking for all records
   * * Clears added
   * * Clears modified
   * * Clears removed
   * Leaves the store in an "unmodified" state.
   * @internal
   */


  acceptChanges() {
    const me = this; // Clear record change tracking

    me.added.forEach(r => r.clearChanges(false));
    me.modified.forEach(r => r.clearChanges(false)); // Clear store change tracking

    me.added.clear();
    me.modified.clear();
    me.removed.clear();
  }
  /**
   * Commits changes, per default only returns changes and resets tracking.
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Object} Changes, see {@link #property-changes}
   * @fires beforeCommit
   * @fires commit
   * @category CRUD
   */


  commit(silent = false) {
    // resets stores tracking of changed records, doesn't store changes, only returns them
    const {
      changes
    } = this;

    if (!silent && this.trigger('beforeCommit', {
      changes
    }) === false) {
      return false;
    }

    this.acceptChanges();

    if (!silent) {
      this.trigger('commit', {
        changes
      });
    }

    return changes;
  }
  /**
   * Reverts all changes in the store (adds removed records back, and removes newly added records).
   * @fires change
   * @fires refresh
   * @category CRUD
   */


  revertChanges() {
    const me = this,
          {
      changes
    } = me;

    if (changes) {
      const event = {
        action: 'clearchanges',
        changes
      };
      me.add(me.removed.values, true);
      me.remove(me.added.values, true);
      me.modified.forEach(r => r.revertChanges(true));
      me.added.clear();
      me.modified.clear();
      me.removed.clear();
      me.trigger('change', event);
      me.trigger('refresh', event);
    }
  }
  /**
   * Get uncommitted changes as an object of added/modified/removed arrays of records.
   *
   * ```javascript
   * // Format:
   * {
   *      added: [], // array of Core.data.Model
   *      modified: [], // array of Core.data.Model
   *      removed: [] // array of Core.data.Model
   * }
   * ```
   *
   * @type {Object}
   * @property {Object} changes
   * @property {Core.data.Model[]} changes.added Records that have been added
   * @property {Core.data.Model[]} changes.modified Records that have changes to persistable fields
   * @property {Core.data.Model[]} changes.removed Records that have been removed
   * @readonly
   * @category Records
   */


  get changes() {
    const me = this,
          // Only include modified records that have persistable changes
    modified = me.modified.values.filter(r => r.rawModifications);
    return me.added.count || modified.length || me.removed.count ? {
      // Slicing to have changes intact when triggering commit
      added: me.added.values.slice(),
      modified,
      removed: me.removed.values.slice()
    } : null;
  }
  /**
   * Setting autoCommit to true automatically commits changes to records.
   * @property {Boolean}
   * @category Records
   */


  get autoCommit() {
    return this._autoCommit;
  }

  set autoCommit(auto) {
    this._autoCommit = auto;

    if (auto && this.changes) {
      this.commit();
    }
  }
  /**
   * Suspends automatic commits upon store changes. Can be called multiple times (it uses an internal counter).
   * @category Records
   */


  suspendAutoCommit() {
    this.suspendCount++;
  }
  /**
   * Resumes automatic commits upon store changes. Will trigger commit if the internal counter is 0.
   * @category Records
   */


  resumeAutoCommit(doCommit = true) {
    this.suspendCount--;

    if (this.autoCommit && doCommit) {
      this.doAutoCommit();
    }
  }

  doAutoCommit() {
    if (this.suspendCount <= 0) {
      this.commit();
    }
  } //endregion
  //region Changes from other store

  /**
   * Applies changes from another store to this store. Useful if cloning records in one store to display in a
   * grid in a popup etc. to reflect back changes.
   * @param {Core.data.Store} otherStore
   * @category CRUD
   */


  applyChangesFromStore(otherStore) {
    const me = this,
          changes = otherStore.changes;
    if (!changes) return;

    if (changes.added) {
      me.add(changes.added);
    }

    if (changes.removed) {
      // Remove using id, otherwise indexOf in remove fn won't yield correct result
      me.remove(changes.removed.map(r => r.id));
    }

    if (changes.modified) {
      changes.modified.forEach(record => {
        const localRecord = me.getById(record.id);
        localRecord.set(record.modifications);
      });
    }
  } //endregion


});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreChained.js":
/*!*********************************************!*\
  !*** ./lib/Core/data/mixin/StoreChained.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';

 // TODO: turn into plugin instead?

/**
 * @module Core/data/mixin/StoreChained
 */
// Intentionally using one param since we check function.length, don't remove

const returnTrue = rec => true;
/**
 * A chained Store contains a subset of records from a master store. Which records to include is determined by a
 * filtering function, {@link #config-chainedFilterFn}.
 *
 * @example
 * masterStore.makeChained(record => record.percent < 10);
 *
 * // or
 *
 * new Store({
 *   masterStore     : masterStore,
 *   chainedFilterFn : record => record.percent < 10
 * });
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreChained extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreChained';
  } //region Config


  static get defaultConfig() {
    return {
      /**
       * Function used to filter records in the masterStore into a chained store. If not provided,
       * all records from the masterStore will be included in the chained store.
       * @config {Function}
       * @category Chained store
       */
      chainedFilterFn: null,

      /**
       * Array of fields that should trigger filtering of chained store when the fields are updated.
       * @config {String[]}
       * @category Chained store
       */
      chainedFields: null,

      /**
       * Master store that a chained store gets its records from.
       * @config {Core.data.Store}
       * @category Chained store
       */
      masterStore: null,

      /**
       * Method names calls to which should be relayed to master store.
       * @config {String[]}
       * @category Chained store
       */
      doRelayToMaster: ['add', 'remove', 'insert'],

      /**
       * Method names calls to which shouldn't be relayed to master store.
       * @config {String}
       * @category Chained store
       */
      dontRelayToMaster: [],

      /**
       * Flag showing whether to keep added/removed uncommitted records when filling the store from master.
       * @config {Boolean}
       * @category Chained store
       */
      keepUncommittedChanges: false,

      /**
       * If true, collapsed records in original tree will be excluded from the chained store.
       * @config {Boolean}
       * @category Chained store
       * @internal
       */
      excludeCollapsedRecords: true
    };
  } // All props should be predefined to work properly with objectified stores


  static get properties() {
    return {
      chainedStores: null
    };
  } //endregion


  construct(config) {
    super.construct(config);
    const me = this,
          {
      masterStore
    } = me,
          sort = me.syncOrder ? 'sort' : '';

    if (masterStore) {
      me.methodNamesToRelay.forEach(fnName => me[fnName] = (...params) => me.relayToMaster(fnName, params));

      me.removeAll = (...params) => {
        masterStore.remove(me.getRange(), ...params);
      }; // TODO: prevent other functions?


      masterStore.on({
        // HACK to have chained stores react early in a async events scenario (with engine). Could be turned
        // into a config, but this way one does not have to think about it
        changePreCommit: me.onMasterDataChangedPreCommit,
        change: me.onMasterDataChanged,
        [sort]: me.onMasterDataChanged,
        prio: 1,
        thisObj: me
      });

      if (!masterStore.chainedStores) {
        masterStore.chainedStores = [];
      }

      masterStore.chainedStores.push(me);
      me.fillFromMaster();
    }
  } //region Properties

  /**
   * Is this a chained store?
   * @property {Boolean}
   * @readonly
   * @category Store
   */


  get isChained() {
    return Boolean(this.masterStore);
  }

  set chainedFilterFn(chainedFilterFn) {
    this._chainedFilterFn = this.thisObj ? chainedFilterFn.bind(this.thisObj) : chainedFilterFn;
  }

  get chainedFilterFn() {
    return this._chainedFilterFn || returnTrue;
  }

  get methodNamesToRelay() {
    const doIsArray = Array.isArray(this.doRelayToMaster),
          dontIsArray = Array.isArray(this.dontRelayToMaster);
    return doIsArray && this.doRelayToMaster.filter(name => !dontIsArray || !this.dontRelayToMaster.includes(name)) || [];
  } //endregion
  //region Internal


  updateChainedStores() {
    if (this.chainedStores) {
      this.chainedStores.forEach(store => store.fillFromMaster());
    }
  }
  /**
   * Updates records available in a chained store by filtering the master store records using
   * {@link #config-chainedFilterFn}
   * @category Chained store
   */


  fillFromMaster() {
    const me = this,
          {
      masterStore,
      isTree
    } = me,
          // the || is for BW compat since we had public demos using store.chain(() => true)
    isRecordFilter = me.chainedFilterFn.length > 0 || me.chainedFilterFn.toString().length <= 10;
    let records;

    if (!me.isChained) {
      throw new Error('fillFromMaster only allowed on chained store');
    }

    if (me.keepUncommittedChanges) {
      if (isTree) {
        throw new Error('Cannot use keepUncommittedChanges on a chained tree store');
      }

      if (isRecordFilter) {
        records = masterStore.allRecords.filter(r => !me.removed.includes(r) && !me.added.includes(r) && me.chainedFilterFn(r));
      } else {
        records = me.chainedFilterFn().filter(r => !me.removed.includes(r) && !me.added.includes(r));
      }

      records = me.added.values.filter(r => !me.removed.includes(r)).concat(records);
    } else {
      if (isRecordFilter) {
        records = masterStore.allRecords.filter(me.chainedFilterFn);
      } else {
        records = me.chainedFilterFn();
      }

      if (isTree) {
        // All nodes will be registered
        me.idRegister = {};
        me.internalIdRegister = {}; // *all* owned records have to join, as they would have done if they'd all gone through
        // the appendChild route for this store.

        records.forEach(r => {
          if (r.stores.includes(me)) {
            me.register(r);
          } else {
            r.joinStore(me);
          }
        }); // We exclude collapsed records by default. It's used in Columns Store.
        // Because grid columns is a tree store when subgrid columns is just a chained store of the columns store.
        // And we don't need to include collapsed column.
        // If we need to show collapsed nodes in Combo we need to chain tree store and set `excludeCollapsedRecords` to `false`.

        if (me.excludeCollapsedRecords) {
          const children = me.getChildren(me.rootNode);
          records = me.doIncludeExclude(children, true);
        }
      }
    }

    me.data = records;
  }
  /**
   * Commits changes back to master.
   * - the records deleted from chained store and present in master will be deleted from master
   * - the records added to chained store and missing in master will added to master
   * Internally calls {Store#function-commit commit()}.
   * @returns {Object} Changes, see Store#changes
   * @internal
   */


  commitToMaster() {
    const me = this,
          master = me.masterStore;

    if (!me.isChained) {
      throw new Error('commitToMaster only allowed on chained store');
    }

    master.beginBatch();
    master.remove(me.removed.values);
    master.add(me.added.values);
    master.endBatch();
    return me.commit();
  }
  /**
   * Relays some function calls to the master store
   * @private
   */


  relayToMaster(fnName, params) {
    return this.masterStore[fnName](...params);
  } // HACK, when used with engine the chained store will catch events early (sync) and prevent late (async) listeners


  onMasterDataChangedPreCommit(event) {
    this.onMasterDataChanged(event);
    this.$masterEventhandled = true;
  }
  /**
   * Handles changes in master stores data. Updates the chained store accordingly
   * @private
   */


  onMasterDataChanged({
    action,
    changes,
    $handled,
    isMove
  }) {
    var _this$chainedFields;

    // Handled early in engine store (above), bail out
    if (this.$masterEventhandled) {
      this.$masterEventhandled = false;
      return;
    } // 'move' action triggers a remove event first, we wait for the 'add' - no need to fill twice


    if (isMove && action === 'remove') {
      return;
    } // if a field not defined in chainedFields is changed, ignore the change.
    // there is no need to refilter the store in such cases, the change will be available anyhow since data is
    // shared


    if (action !== 'update' || (_this$chainedFields = this.chainedFields) !== null && _this$chainedFields !== void 0 && _this$chainedFields.some(field => field in changes)) {
      this.fillFromMaster();
    }
  } //endregion
  //region public API

  /**
   * Creates a chained store, a new Store instance that contains a subset of the records from current store.
   * Which records is determined by a filtering function, which is reapplied when data in the base store changes.
   *
   * If this store is a {@link Core.data.mixin.StoreTree#property-isTree tree} store, then the resulting
   * chained store will be a tree store sharing the same root node, but only child nodes which pass
   * the `chainedFilterFn` will be considered when iterating the tree through the methods such as
   * {@link Core.data.Store#function-traverse} or {@link Core.data.Store#function-forEach}.
   *
   * @param {Function} chainedFilterFn Either a filter function called for every record to determine if it should be included
   * (return true / false), or a query function called with no arguments (see example below). Defaults to including all records (fn always returning true)
   * @param {String[]} [chainedFields] Array of fields that trigger filtering when they are updated
   * @param {Object} [config] Additional chained store configuration
   * @returns {Core.data.Store}
   * @example
   * const oldies = store.makeChained(record => record.age > 50);
   * // or use a simple query
   * const ages = store.makeChained(() => store.allRecords.distinct('age')));
   */


  makeChained(chainedFilterFn = returnTrue, chainedFields, config) {
    return new this.constructor(Object.assign(config || {}, {
      tree: false,
      autoTree: false,
      masterStore: this,
      modelClass: this.modelClass,
      chainedFilterFn,
      chainedFields
    }));
  }
  /**
   * Alias for {@link Core.data.Store#function-makeChained}
   * @param {Function} chainedFilterFn Function called for each records that determines if it should be included
   * (return true) or not (return false). Defaults to including all records (fn always returning true)
   * @param {String[]} chainedFields Array of fields that trigger filtering when they are updated
   * @param {Object} config Additional chained store configuration
   * @returns {Core.data.Store}
   */


  chain() {
    return this.makeChained(...arguments);
  } //endregion


  doDestroy() {
    var _this$chainedStores;

    // Destroy chained store on master store destroy
    (_this$chainedStores = this.chainedStores) === null || _this$chainedStores === void 0 ? void 0 : _this$chainedStores.forEach(chainedStore => chainedStore.destroy()); // Events superclass fires destroy event.

    super.doDestroy();
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreFilter.js":
/*!********************************************!*\
  !*** ./lib/Core/data/mixin/StoreFilter.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _util_Collection_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/Collection.js */ "./lib/Core/util/Collection.js");
var productName = 'taskboard';




/**
 * @module Core/data/mixin/StoreFilter
 */

/**
 * Mixin for Store that handles filtering.
 * Filters are instances of {@link Core.util.CollectionFilter CollectionFilter} class.
 *
 * - Adding a filter for the same property will replace the current one (unless a unique {@link Core.util.CollectionFilter#config-id Id} is specified),
 * but will not clear any other filters.
 * - Adding a filter through the {@link #function-filterBy} function is ultimate.
 * It will clear all the property based filters and replace the current filterBy function if present.
 * - Removing records from the store does not remove filters!
 * The filters will be reapplied if {@link #config-reapplyFilterOnAdd}/{@link #config-reapplyFilterOnUpdate} are true and you add new records or update current.
 *
 * ```
 * // Add a filter
 * store.filter({
 *     property : 'score',
 *     value    : 10,
 *     operator : '>'
 * });
 *
 * // Add filter as a function
 * store.filter(record => record.score > 10);
 *
 * // Add named filter as a function
 * store.filter({
 *     id : 'my filter',
 *     filterBy : record => record.score > 10
 * });
 *
 * // Replace any filter set with new filters
 * store.filter({
 *     filters : {
 *         property : 'score',
 *         value    : 10,
 *         operator : '>'
 *     },
 *     replace : true
 * });
 *
 * // Remove this one specific filter, leaving any possible others in place.
 * // A filter's id defaults to the property name that it's filtering on.
 * store.removeFilter('score');
 *
 * // Reapply filters without firing an event.
 * // Use if making multiple data mutations with the
 * // intention of updating UIs when all finished.
 * store.filter({
 *     silent : true
 * });
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreFilter extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreFilter';
  } //region Config


  static get defaultConfig() {
    return {
      /**
       * Specify one or more {@link Core.util.CollectionFilter CollectionFilter} config object to apply initially
       * @config {Object|Object[]}
       * @category Filtering
       */
      filters: null,

      /**
       * Specify true to reapply filters when a record is added to the store.
       * @config {Boolean}
       * @default
       * @category Filtering
       */
      reapplyFilterOnAdd: false,

      /**
       * Specify true to reapply filters when a record is updated in the store.
       * @config {Boolean}
       * @default
       * @category Filtering
       */
      reapplyFilterOnUpdate: false
    };
  } //endregion
  //region Events

  /**
   * Fired after applying filters to the store
   * @event filter
   * @param {Core.data.Store} source This Store
   * @param {Core.util.Collection} filters Filters used by this Store
   * @param {Core.data.Model[]} records Filtered records
   */
  //endregion
  //region Properties


  set reapplyFilterOnAdd(enable) {
    this.storage.autoFilter = enable;
  }

  get reapplyFilterOnAdd() {
    return this.storage.autoFilter;
  }
  /**
   * Currently applied filters. A collection of {@link Core.util.CollectionFilter} instances.
   * @type {Core.util.Collection}
   * @readonly
   * @category Sort, group & filter
   */


  set filters(filters) {
    const me = this,
          collection = me.filters;
    collection.clear(); // Invalidate the filtersFunction so that it has to be recalculated upon next access

    me._filtersFunction = null; // If we are being asked to filter, parse the filters.

    if (filters) {
      if (filters.constructor.name === 'Object') {
        for (const f of Object.entries(filters)) {
          // Entry keys are either a field name with its value being the filter value
          // or, there may be one filterBy property which specifies a filering function.
          if (f[0] === 'filterBy' && typeof f[1] === 'function') {
            collection.add(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
              filterBy: f[1]
            }));
          } else {
            collection.add(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"](f[1].constructor.name === 'Object' ? Object.assign({
              property: f[0]
            }, f[1]) : {
              property: f[0],
              value: f[1]
            }));
          }
        }
      } else if (Array.isArray(filters)) {
        // Make sure we are adding CollectionFilters
        collection.add(...filters.map(filterConfig => {
          if (filterConfig instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
            return filterConfig;
          }

          return new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"](filterConfig);
        }));
      } else if (filters.isCollection) {
        // Use supplied collection? Opting to use items from it currently
        collection.add(...filters.values);
      } else {
        collection.add(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
          filterBy: filters
        }));
      }

      collection.forEach(item => item.owner = me);
    }
  }

  get filters() {
    return this._filters || (this._filters = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
      extraKeys: ['property']
    }));
  }

  set filtersFunction(filtersFunction) {
    this._filtersFunction = filtersFunction;
  }

  get filtersFunction() {
    const me = this,
          {
      filters,
      isGrouped
    } = me;

    if (!me._filtersFunction) {
      if (filters.count) {
        const generatedFilterFunction = _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"].generateFiltersFunction(filters);

        me._filtersFunction = candidate => {
          // A group record is filtered in if it has passing groupChildren.
          if (isGrouped && candidate.isSpecialRow) {
            return candidate.groupChildren.some(generatedFilterFunction);
          } else {
            return generatedFilterFunction(candidate);
          }
        };
      } else {
        me._filtersFunction = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].returnTrue;
      }
    }

    return me._filtersFunction;
  }
  /**
   * Check if store is filtered
   * @property {Boolean}
   * @readonly
   * @category Sort, group & filter
   */


  get isFiltered() {
    return this.filters.values.some(filter => !filter.disabled);
  } //endregion


  traverseFilter(record) {
    const me = this,
          hitsCurrent = !record.isRoot && me.filtersFunction(record),
          children = record.unfilteredChildren || record.children; // leaf, bail out

    if (!children || !children.length) {
      return hitsCurrent;
    }

    if (!record.unfilteredChildren) {
      record.unfilteredChildren = record.children.slice();
    }

    record.children = record.unfilteredChildren.filter(r => {
      return me.traverseFilter(r);
    }); // unfilteredIndex must be set for child elements

    record.updateChildrenIndices(record.unfilteredChildren, true, true); // parentIndex must be set for visible child elements

    record.updateChildrenIndices(record.children, false, true);
    return hitsCurrent || Boolean(record.children.length);
  }

  traverseClearFilter(record) {
    const me = this;

    if (record.unfilteredChildren) {
      record.children = record.unfilteredChildren.slice();
      record.unfilteredChildren = null;
    }

    if (record.children) {
      record.children.forEach(r => me.traverseClearFilter(r));
      record.updateChildrenIndices(record.children, false, true);
    }
  } // TODO: Get rid of this.
  // The Filter feature of a Grid pokes around in the Store to ask this question.


  get latestFilterField() {
    return this.filters.last ? this.filters.last.property : null;
  }
  /**
   * Adds a single filter to the {@link #config-filters} collection. By default, filters are reevaluated
   * and a Store change event fired.
   *
   * If the `silent` parameter is passed as `true`, multiple filters can be added without causing data changes.
   *
   * When the filters are as required, call {@link #function-filter} with no parameters
   * to apply the filters to the store.
   *
   * @param {Object|Function} newFilters A {@link Core.util.CollectionFilter filter} config,
   * or a function to use for filtering.
   * @param {Boolean} [silent] Pass `true` to *not* refilter the store immediately. Such as when
   * adding multiple filters.
   * @returns {Core.util.CollectionFilter} The Filter instance that was added.
   * @category Sort, group & filter
   */


  addFilter(filter, silent = false) {
    filter = filter instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? filter : new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"](filter); // We want notification upon change of field, value or operator

    filter.owner = this; // Collection will replace any already existing filter on the field, unless it has id specified

    this.filters.add(filter);

    if (!silent) {
      this.filter();
    }

    return filter;
  }
  /**
   * Filters the store by **adding** the specified filter(s) to the existing filters collection applied to this Store.
   * If a filter has an {@link Core.util.CollectionFilter#config-id id} specified,
   * or a {@link Core.util.CollectionFilter#config-property property} specified,
   * it will search for corresponding filter(s) in the existing filters first and replace it with a new filter.
   * **It will not remove other filters applied to the store!**
   *
   * To **add** a new filter:
   * ```
   * // Filter using simple object
   * store.filter({
   *     property : 'age',
   *     operator : '>',
   *     value    : 90
   * });
   *
   * // Filter using function
   * store.filter(r => r.age < 90);
   *
   * // Filter using a named filter as a function
   * store.filter({
   *     id : 'my-filter',
   *     filterBy : record => record.score > 10
   * });
   * ```
   *
   * To **remove** a specific filter, but keep other filters applied
   * ```
   * // Remove by filter `id` or `property`. Filter `id` defaults to the `property` name.
   * store.removeFilter('age');
   * store.removeFilter('my-filter');
   * ```
   *
   * To **replace** all existing filters with a new filter
   * ```
   * // Remove all filters and filter using simple object
   * store.filter({
   *     filters : {
   *         property : 'age',
   *         operator : '<',
   *         value    : 90
   *     },
   *     replace : true
   * });
   *
   * // Remove all filters and filter using function
   * store.filter({
   *     filters : r => r.age > 90,
   *     replace : true
   * });
   *
   * // Remove all filters and filter using a named filter as a function
   * store.filter({
   *     filters : {
   *         id : 'my-filter',
   *         filterBy : record => record.score > 10
   *     },
   *     replace : true
   * });
   * ```
   *
   * Basically filters replacing is an equivalent of having two sequenced calls:
   * {@link #function-clearFilters clearFilters} and {@link #function-filter filter}.
   *
   * Call without arguments to reapply filters.
   * ```
   * // Re-filter the store
   * store.filter();
   * ```
   *
   * @param {Object|Object[]|Function} newFilters
   *        A {@link Core.util.CollectionFilter filter} config,
   *        or an array of {@link Core.util.CollectionFilter filter} configs,
   *        or a function to use for filtering,
   *        or a special object like: ```{ replace : true, filters : newFilters }```
   * @param {Boolean} [newFilters.replace]
   *        A flag, indicating whether or not the previous filters should be removed.
   * @param {Boolean} [newFilters.silent]
   *        Set as true to not fire events. UI will not be informed about the changes.
   * @param {Object|Object[]|Function} [newFilters.filters]
   *        If `newFilters` is an object and `replace` property is defined in the `newFilters`,
   *        it means that special object is used and real filter configuration must be nested down to this `filters` property.
   *        It can be:
   *        A {@link Core.util.CollectionFilter filter} config,
   *        or an array of {@link Core.util.CollectionFilter filter} configs,
   *        or a function to use for filtering.
   * @fires filter
   * @fires change
   * @category Sort, group & filter
   */


  filter(newFilters) {
    const me = this,
          {
      filters
    } = me;
    let silent = false;

    if (newFilters) {
      let fieldType = typeof newFilters;

      if (fieldType === 'object') {
        if ('silent' in newFilters || 'replace' in newFilters || newFilters.filters) {
          silent = newFilters.silent;

          if (newFilters.replace) {
            filters.clear();
          }

          newFilters = newFilters.filters;
          fieldType = typeof newFilters;
        }
      } // If it was just a config object containing no filters, this will be null


      if (newFilters) {
        // We will not be informed about Filter mutations while configuring.
        me.isConfiguring = true; // If we provide array of objects looking like :
        //  {
        //      property  : 'fieldName',
        //      value     : 'someValue',
        //      [operator : '>']
        //  }
        //  or ...
        //  {
        //      property : 'fieldName',
        //      filterBy : function (value, record) {
        //          return value > 50;
        //      }
        //  }

        if (Array.isArray(newFilters)) {
          newFilters.forEach(f => me.addFilter(f, true), me);
        } else if (fieldType === 'function') {
          me.addFilter(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"](newFilters), true);
        } // Old signature of field name, value with implicit equality test.
        // Not documented, but still tested.
        else if (fieldType === 'string') {
          me.addFilter({
            property: newFilters,
            value: arguments[1]
          }, true);
        } // An object-based filter definition
        else {
          me.addFilter(newFilters, true);
        } // Open up to receiving Filter mutation notifications again


        me.isConfiguring = false; // We added a disabled filter to either no filters, or all disabled filters, so no change.

        if (!me.isFiltered) {
          return;
        }
      }
    } // Invalidate the filtersFunction so that it has to be recalculated upon next access


    me.filtersFunction = null; // Implemented here for local filtering.
    // AjaxStore implements for remote and returns a Promise, so MUST returh the call value.

    return me.performFilter(silent);
  }
  /**
   * Perform filtering according to the {@link #property-filters} Collection.
   * This is the internal implementation which is overridden in {@link Core.data.AjaxStore} and
   * must not be overridden.
   * @private
   */


  performFilter(silent) {
    const me = this,
          {
      storage,
      filters,
      rootNode
    } = me,
          oldCount = me.count; // Private event, did not need it documented or preventable right now

    me.trigger('beforeFilter', {
      filters
    });

    if (me.tree) {
      if (me.isFiltered) {
        me.traverseFilter(rootNode);
      } else {
        me.traverseClearFilter(rootNode);
      }

      storage.replaceValues({
        values: me.collectDescendants(rootNode).visible,
        silent: true
      });
    } else {
      if (me.isFiltered) {
        // Bring collapsed away records in, to be considered in filtering
        me.isGrouped && me.includeCollapsed();
        storage.addFilter({
          id: 'primary-filter',
          // no-sanity
          filterBy: me.filtersFunction
        }); // Take them back out again after filtering

        me.isGrouped && me.excludeCollapsed();
      } else {
        storage.filters.clear();
      }
    }

    me.afterPerformFilter(silent ? null : {
      action: 'filter',
      filters,
      oldCount,
      records: me.storage.values
    });
  }

  afterPerformFilter(event) {
    this.resetRelationCache();

    if (event) {
      this.triggerFilterEvent(event);
    }
  }

  get filtered() {
    return this.storage.isFiltered;
  } // Used from filter() and StoreCRUD when reapplying filters


  triggerFilterEvent(event) {
    this.trigger('filter', event); // Only fire these events if it's a local filter.
    // If we are configured with filterParamName, the loadData will fire them.

    if (!this.remoteFilter) {
      this.trigger('refresh', event);
      this.trigger('change', event);
    }
  }
  /**
   * *Adds* a function used to filter the store. Alias for calling `filter(fn)`. Return `true` from the function to
   * include record in filtered set
   *
   * ```javascript
   * store.filterBy(record => record.age > 25 && record.name.startsWith('A'));
   * ```
   *
   * @param {Function} fn Function used to test records
   * @category Sort, group & filter
   */


  filterBy(fn) {
    this.filter(fn);
  }
  /**
   * Removes the passed filter, or the filter by the passed ID from the {@link #config-filters} collection.
   * By default, filters are reevaluated and a Store change event fired.
   *
   * If the `silent` parameter is passed as `true`, multiple filters can be removed without causing data changes.
   *
   * When the filters are as required, call {@link #function-filter} with no parameters
   * to apply the filters to the store.
   *
   * ```javascript
   * // Only view top priority events
   * myEventStore.filter({
   *     id       : 'priorityFilter',
   *     property : 'priority',
   *     value    : 1,
   *     operator : '='
   * });
   *
   * // That individual filter can be removed like this
   * myEventStore.removeFilter('priorityFilter');
   *
   * // Add named filter as a function
   * store.filter({
   *     id : 'my filter',
   *     filterBy : record => record.score > 10
   * });
   *
   * // Remove named filter function
   * store.removeFilter('my filter');
   * ```
   *
   * @param {String|Core.util.CollectionFilter} idOrInstance Filter to remove, or ID of the filter to remove. By default,
   * filters are reevaluated and a change event fired.
   * @param {Boolean} [silent] Pass `true` to *not* refilter the store immediately. Such as when
   * removing multiple filters.
   * @returns {Core.util.CollectionFilter} The Filter instance that was removed.
   * @category Sort, group & filter
   */


  removeFilter(idOrInstance, silent = false) {
    const me = this,
          filter = idOrInstance instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? idOrInstance : me.filters.get(idOrInstance); // If we have such a filter, remove it.

    if (filter) {
      me.filters.remove(filter); // Invalidate the filtersFunction so that it has to be recalculated upon next access

      me._filtersFunction = null;

      if (!silent) {
        me.filter();
      }

      return filter;
    }
  }
  /**
   * Removes all filters from the store.
   * @category Sort, group & filter
   */


  clearFilters() {
    this.filters.clear();
    this.filter();
  }

  convertFilterToString(field) {
    const filter = this.filters.getBy('property', field);
    return filter && !filter.filterBy ? String(filter) : '';
  }

  doDestroy() {
    var _this$_filters;

    (_this$_filters = this._filters) === null || _this$_filters === void 0 ? void 0 : _this$_filters.destroy();
    super.doDestroy();
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreGroup.js":
/*!*******************************************!*\
  !*** ./lib/Core/data/mixin/StoreGroup.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'taskboard';



/**
 * @module Core/data/mixin/StoreGroup
 */

const resortActions = {
  add: 1,
  replace: 1
};
/**
 * Mixin for Store that handles grouping.
 *
 * ```javascript
 * // simple grouper
 * store.group('city');
 *
 * // grouper as object, descending order
 * store.group({ field : 'city', ascending : false });
 *
 * // using custom sorting function
 * store.group({
 *     field : 'city',
 *     fn : (recordA, recordB) => {
 *         // apply custom logic, for example:
 *         return recordA.city.length < recordB.city.length ? -1 : 1;
 *     }
 * });
 * ```
 *
 * Currently grouping is not supported when using pagination, the underlying store cannot group data that is split into pages.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreGroup extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreGroup';
  } //region Config


  static get defaultConfig() {
    return {
      /**
       * Initial groupers, specify to have store grouped automatically after initially setting data
       * @config {Object[]}
       * @category Common
       */
      groupers: null
    };
  }

  static get properties() {
    return {
      collapsedGroups: new Set()
    };
  } //endregion
  //region Init


  construct(config) {
    super.construct(config); // For handling record mutation, *not* add/remove of records.
    // Sorts dataset if necessary.

    this.on('change', this.onDataChanged, this);
  }
  /**
   * Currently used groupers
   * @property {Object[]}
   * @category Sort, group & filter
   */


  get groupers() {
    return this._groupers;
  }

  set groupers(groupers) {
    const me = this,
          {
      storage
    } = me;

    if (groupers !== null && groupers !== void 0 && groupers.length) {
      me._groupers = groupers;
    } else if (me.groupers) {
      delete me._groupers;
      me.includeCollapsed();
      storage.replaceValues({
        values: me.removeHeadersAndFooters(storage._values),
        filteredValues: storage.isFiltered ? me.removeHeadersAndFooters(storage._filteredValues) : null,
        silent: true
      });
      me.group(null, null, null, false);
    } // Need to clear the id map so it gets rebuilt next time its accessed


    me._idMap = null;
  } // Collects group headers/footers on the fly. Not used in any performance sensitive code, but if that need arises
  // it should be cached and invalidated on record remove, add, update, grouping changes, filter and sorting...


  get groupRecords() {
    const groupRecords = [];

    if (this.isGrouped) {
      for (const record of this) {
        if (record.isSpecialRow) {
          groupRecords.push(record);
        }
      }
    }

    return groupRecords;
  } // Temporarily include records from collapsed groups, for example prior to filtering


  includeCollapsed() {
    for (const groupId of this.collapsedGroups) {
      this.expand(this.getById(groupId), false);
    }
  } // Exclude records in collapsed groups, intended to be used after a call to includeCollapsed()


  excludeCollapsed() {
    for (const groupId of this.collapsedGroups) {
      this.collapse(this.getById(groupId));
    }
  }

  onDataChange({
    source: storage,
    action,
    removed
  }) {
    var _super$onDataChange;

    const me = this,
          {
      groupers
    } = me; // Only do grouping transformations if we have groupers to apply.
    // In stores which never use grouping, this code is superfluous and will reduce performance.
    // The else side will simply replace the ungrouped data with itself.

    if (groupers) {
      // When records are added or removed, re-evaluate the group records
      // so that when the events are fired by the super call, the group
      // records are in place.
      if (groupers.length) {
        if (action === 'splice' && removed !== null && removed !== void 0 && removed.length) {
          storage.replaceValues({
            values: me.prepareGroupRecords(),
            silent: true
          });
        }
      } // Remove all group headers and footers
      else {
        storage.replaceValues({
          values: me.removeHeadersAndFooters(storage.values),
          silent: true
        });
      }
    }

    (_super$onDataChange = super.onDataChange) === null || _super$onDataChange === void 0 ? void 0 : _super$onDataChange.call(this, ...arguments);
  } // private function that collapses on the data level
  // TODO: make public and trigger events for grid to react to?


  collapse(groupRecord) {
    if (groupRecord && !groupRecord.meta.collapsed) {
      this.excludeGroupRecords(groupRecord);
      groupRecord.meta.collapsed = true; // Track which groups are collapsed

      this.collapsedGroups.add(groupRecord.id);
      return true;
    }

    return false;
  } // private function that expands on the data level
  // TODO: make public and trigger events for grid to react to?


  expand(groupRecord, updateMap = true) {
    if (groupRecord !== null && groupRecord !== void 0 && groupRecord.meta.collapsed) {
      this.includeGroupRecords(groupRecord);
      groupRecord.meta.collapsed = false; // Optionally track which groups are collapsed (not done when expanding temporarily prior to filtering etc)

      updateMap && this.collapsedGroups.delete(groupRecord.id);
      return true;
    }

    return false;
  }

  removeHeadersAndFooters(records) {
    return records.filter(r => {
      if (r.isSpecialRow) {
        this.unregister(r);
        return false;
      } else {
        return true;
      }
    });
  }

  prepareGroupRecords(sorter) {
    const me = this,
          toCollapse = me.collapsedGroups,
          toExpand = [];
    let records = me.storage.values;

    for (const record of records) {
      if (record.isGroupHeader && (record.meta.collapsed || toCollapse.has(record.id))) {
        toCollapse.add(record.id); // TODO - This line should no longer be needed, try without it when tests pass

        toExpand.push(record);
      }
    }

    for (const record of toExpand) {
      me.includeGroupRecords(record);
    }

    records = me.removeHeadersAndFooters(me.storage.values);

    if (sorter) {
      records = records.sort(sorter);
    }

    if (!me.isGrouped) {
      return records;
    }

    const groupedRecords = [],
          field = me.groupers[0].field;
    let curGroup = null,
        curGroupRecord = null,
        childCount = 0;

    function addFooter() {
      const val = curGroupRecord.meta.groupRowFor,
            id = `group-footer-${typeof val === 'number' ? val : _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createId(val)}`,
            footer = me.getById(id) || new me.modelClass({
        id
      }, me, {
        specialRow: true,
        groupFooterFor: val,
        groupRecord: curGroupRecord
      }); // Used by indexOf to determine if part of store

      footer.stores = [me];
      me.register(footer);
      footer.groupChildren = curGroupRecord.groupChildren;

      if (!curGroupRecord.meta.collapsed) {
        groupedRecords.push(footer);
      }

      me.allRecords.push(footer);
      curGroupRecord.groupChildren.push(footer);
      childCount++;
      return footer;
    }

    records.forEach(record => {
      var _record$groupChildren;

      const val = record[field] == undefined ? '__novalue__' : record[field],
            id = `group-header-${typeof val === 'number' ? val : _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createId(val)}`; // A group header or footer record of an empty group.
      // Remove from the data

      if (((_record$groupChildren = record.groupChildren) === null || _record$groupChildren === void 0 ? void 0 : _record$groupChildren.length) === 0) {
        me.unregister(record);
        return;
      }

      if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(val, curGroup)) {
        if (curGroupRecord) {
          // also add group footer? used by GroupSummary feature
          if (me.useGroupFooters) {
            addFooter(curGroupRecord);
          }

          curGroupRecord.meta.childCount = childCount;
        }

        curGroupRecord = me.getById(id) || new me.modelClass({
          id
        }, me, {
          specialRow: true,
          groupRowFor: val,
          groupField: field,
          collapsed: toCollapse.has(id)
        }); // Used by indexOf to determine if part of store

        curGroupRecord.stores = [me];
        me.register(curGroupRecord);
        curGroupRecord.groupChildren = [];
        groupedRecords.push(curGroupRecord);
        me.allRecords.push(curGroupRecord);
        curGroup = val;
        childCount = 0;
      }

      record.instanceMeta(me.id).groupParent = curGroupRecord; // Collapse groups that was collapsed earlier

      if (!toCollapse.has(id)) {
        groupedRecords.push(record);
      }

      curGroupRecord.groupChildren.push(record);
      childCount++;
    }); // misses for last group without this

    if (curGroupRecord) {
      // footer for last group
      if (me.useGroupFooters) {
        addFooter();
      }

      curGroupRecord.meta.childCount = childCount;
    }

    return groupedRecords;
  } //endregion
  //region Group and ungroup

  /**
   * Is store currently grouped?
   * @property {Boolean}
   * @readonly
   * @category Sort, group & filter
   */


  get isGrouped() {
    var _this$groupers;

    return Boolean((_this$groupers = this.groupers) === null || _this$groupers === void 0 ? void 0 : _this$groupers.length);
  }
  /**
   * Group records, either by replacing current sorters or by adding to them.
   * A grouper can specify a **_custom sorting function_** which will be called with arguments (recordA, recordB).
   * Works in the same way as a standard array sorter, except that returning `null` triggers the stores
   * normal sorting routine. Grouped store **must** always be sorted by the same field.
   *
   * ```javascript
   * // simple grouper
   * store.group('city');
   *
   * // grouper as object, descending order
   * store.group({ field : 'city', ascending : false });
   *
   * // using custom sorting function
   * store.group({
   *     field : 'city',
   *     fn : (recordA, recordB) => {
   *         // apply custom logic, for example:
   *         return recordA.city.length < recordB.city.length ? -1 : 1;
   *     }
   * });
   * ```
   *
   * @param {String|Object} field Field to group by.
   * Can also be a config containing a field to group by and a custom sorting function called `fn`.
   * @param {Boolean} [ascending] Sort order of the group titles
   * @param {Boolean} [add] Add a grouper (true) or use only this grouper (false)
   * @param {Boolean} [performSort] Trigger sort directly, which does the actual grouping
   * @param {Boolean} [silent] Set as true to not fire events
   * @category Sort, group & filter
   * @fires group
   * @fires refresh
   */


  group(field, ascending, add = false, performSort = true, silent = false) {
    const me = this;
    let newGrouper, fn;

    if (field && typeof field === 'object') {
      ascending = field.ascending;
      fn = field.fn;
      field = field.field;
    }

    if (add) {
      me.groupers.push(newGrouper = {
        field,
        ascending,
        complexMapping: field.includes('.')
      });
    } else if (field) {
      if (ascending == null) {
        var _me$groupInfo, _me$groupInfo2;

        ascending = ((_me$groupInfo = me.groupInfo) === null || _me$groupInfo === void 0 ? void 0 : _me$groupInfo.field) === field && ((_me$groupInfo2 = me.groupInfo) === null || _me$groupInfo2 === void 0 ? void 0 : _me$groupInfo2.fn) === fn ? !me.groupInfo.ascending : true;
      }

      me.groupInfo = newGrouper = {
        field,
        ascending,
        fn,
        complexMapping: field.includes('.')
      };
      me.groupers = [me.groupInfo];
    }

    if (newGrouper) {
      const {
        prototype
      } = me.modelClass; // Create a getter for complex field names like "get resource.city"

      if (newGrouper.complexMapping && !Object.prototype.hasOwnProperty.call(prototype, field)) {
        Object.defineProperty(prototype, field, {
          get() {
            return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getPath(this, field);
          }

        });
      }
    } // as far as the store is concerned, grouping is just more sorting. so trigger sort


    if (performSort !== false) {
      me.sort(null, null, false, true);
    }

    if (!silent) {
      /**
       * Fired when grouping changes
       * @event group
       * @param {Core.data.Store} source This Store
       * @param {Object[]} groupers Applied groupers
       * @param {Core.data.Model[]} records Grouped records
       */
      me.trigger('group', {
        isGrouped: me.isGrouped,
        groupers: me.groupers,
        records: me.storage.values
      });
      me.trigger('refresh', {
        action: 'group',
        isGrouped: me.isGrouped,
        groupers: me.groupers,
        records: me.storage.values
      });
    }
  } // Internal since UI does not support multi grouping yet

  /**
   * Add a grouping level (a grouper).
   * @param {String} field Field to group by
   * @param {Boolean} ascending Group direction
   * @category Sort, group & filter
   * @internal
   */


  addGrouper(field, ascending = true) {
    this.group(field, ascending, true);
  } // Internal since UI does not support multi grouping yet

  /**
   * Removes a grouping level (a grouper)
   * @param {String} field Grouper to remove
   * @category Sort, group & filter
   * @internal
   */


  removeGrouper(field) {
    const me = this,
          {
      groupers
    } = me,
          index = groupers.findIndex(grouper => grouper.field === field);

    if (index > -1) {
      groupers.splice(index, 1);

      if (!groupers.length) {
        me.clearGroupers();
      } else {
        me.group();
      }
    }
  }
  /**
   * Removes all groupers, turning store grouping off.
   * @category Sort, group & filter
   */


  clearGroupers() {
    this.groupers = null;
  } //endregion
  //region Get and check

  /**
   * Check if a record belongs to a certain group (only for the first grouping level)
   * @param {Core.data.Model} record The Record
   * @param {*} groupValue The group value
   * @returns {Boolean} True if the record belongs to the group, otherwise false
   * @category Sort, group & filter
   */


  isRecordInGroup(record, groupValue) {
    var _this$groupers$;

    if (!this.isGrouped) {
      return null;
    }

    const groupField = (_this$groupers$ = this.groupers[0]) === null || _this$groupers$ === void 0 ? void 0 : _this$groupers$.field;
    return record[groupField] === groupValue && !record.isSpecialRow;
  }

  isInCollapsedGroup(record) {
    const parentGroupRec = record.instanceMeta(this).groupParent;
    return parentGroupRec === null || parentGroupRec === void 0 ? void 0 : parentGroupRec.meta.collapsed;
  }
  /**
   * Returns all records in the group with specified groupValue.
   * @param {*} groupValue
   * @returns {Core.data.Model[]} Records in specified group or null if store not grouped
   * @category Sort, group & filter
   */


  getGroupRecords(groupValue) {
    if (!this.isGrouped) {
      return null;
    }

    return this.storage.values.filter(record => this.isRecordInGroup(record, groupValue));
  }
  /**
   * Get all group titles.
   * @returns {String[]} Group titles
   * @category Sort, group & filter
   */


  getGroupTitles() {
    if (!this.isGrouped) {
      return null;
    }

    return this.getDistinctValues(this.groupers[0].field);
  } //endregion


  onDataChanged({
    changes,
    action
  }) {
    if (this.isGrouped && ( // If an action flagged as requiring resort is performed...
    !changes && resortActions[action] || // ...or if the group field has changes...
    changes && this.groupers.some(grouper => grouper.field in changes))) {
      // ...then re-sort
      this.sort();
    }
  }
  /**
   * Adds or removes records in a group from storage. Used when expanding/collapsing groups.
   * @private
   * @param {Core.data.Model} groupRecord Group which records should be added or removed
   * @param {Boolean} include Include (true) or exclude (false) records
   * @category Grouping
   */


  internalIncludeExcludeGroupRecords(groupRecord, include) {
    const me = this,
          index = me.indexOf(groupRecord),
          {
      id: mapId,
      storage
    } = me,
          {
      meta,
      groupChildren
    } = groupRecord; // Skip if group record is not found, otherwise it removes records from wrong position.
    // Also prevent removing from already collapsed and vice versa

    if (index === -1 || meta.collapsed && !include || !meta.collapsed && include) {
      return;
    }

    groupChildren.forEach(child => child.instanceMeta(mapId).hiddenByCollapse = !include);

    if (include) {
      // Avoid adding record duplicates which may already have been reinserted by clearing filters
      const includeChildren = groupChildren.filter(r => !me.isAvailable(r));
      storage.values.splice(index + 1, 0, ...includeChildren);
    } else {
      storage.values.splice(index + 1, groupChildren.length);
    }

    storage._indicesInvalid = true;
    me._idMap = null;
  }
  /**
   * Removes records in a group from storage. Used when collapsing a group.
   * @private
   * @param groupRecord Group which records should be removed
   * @category Grouping
   */


  excludeGroupRecords(groupRecord) {
    this.internalIncludeExcludeGroupRecords(groupRecord, false);
  }
  /**
   * Adds records in a group to storage. Used when expanding a group.
   * @private
   * @param groupRecord Group which records should be added
   * @category Grouping
   */


  includeGroupRecords(groupRecord) {
    this.internalIncludeExcludeGroupRecords(groupRecord, true);
  }
  /**
   * Collects all group headers + children, whether expanded or not
   * @private
   * @param {Boolean} allRecords True to include filtered out records
   * @param {Boolean} includeHeaders True to also include group headers
   * @returns {Core.data.Model[]}
   */


  collectGroupRecords(allRecords, includeHeaders = true) {
    const records = allRecords ? this.storage.allValues : this.storage.values;
    return records.reduce((records, record) => {
      if (record.isSpecialRow) {
        if (includeHeaders) {
          records.push(record);
        }

        if (record.isGroupHeader) {
          records.push.apply(records, record.groupChildren);
        }
      }

      return records;
    }, []);
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreProxy.js":
/*!*******************************************!*\
  !*** ./lib/Core/data/mixin/StoreProxy.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



/**
 * @module Core/data/mixin/StoreProxy
 */

/**
 * Object-like interaction with a Store by using a Proxy. To enable, configure the store with `objectify : true`.
 *
 * ```javascript
 * const store = new Store({
 *    objectify : true,
 *    data      : [
 *        { id : 'batman', name : 'Bruce' }
 *    ]
 * });
 * ```
 *
 * Access records using their ids as Store properties:
 * ```javascript
 * console.log(store.batman.name); // logs Bruce
 * ```
 *
 * Add records by assigning properties to the Store:
 * ```javascript
 * store.superman = { name : 'Clark' }; // Id will be 'superman'
 * ```
 *
 * Remove records by removing their property:
 * ```javascript
 * delete store.batman;
 * ```
 *
 * Check if a certain id existing in the store by using `in`:
 * ```javascript
 * console.log('superman' in store): // logs true
 * ```
 *
 * Please note that this approach:
 * * Will affect performance slightly, not recommended for larger datasets.
 * * Uses native Proxy, which cannot be polyfilled. Not possible to get it working in IE11.
 * * Preserves predefined Store properties, records cannot use ids that match those.
 * * Might have other limitations preventing the use of it in some scenarios where a normal Store can be used.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreProxy extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get configurable() {
    return {
      /**
       * Allow object like interaction with the Store. For example:
       *
       * ```javascript
       * const store = new Store({
       *    objectify : true,
       *    data      : [
       *        { id : 'batman', name : 'Bruce' }
       *    ]
       * });
       *
       * // retrieve using id as property
       * const record = store.batman;
       *
       * // add as property
       * store.superman = { name : 'Clark' };
       *
       * // delete to remove
       * delete store.batman;
       * ``
       *
       * @config {Boolean}
       * @default false
       */
      objectify: null
    };
  }

  initProxy() {
    if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].global.Proxy) {
      throw new Error('Proxy not supported');
    }

    const proxy = new Proxy(this, {
      // Support getting records using `store[id/index]
      get(target, property) {
        // Stores own properties take precedence
        if (property in target) {
          return target[property];
        } // To allow accessing the underlying store


        if (property === '$store') {
          return target;
        } // Then ids


        let record = target.getById(property); // And finally index

        if (!record && !isNaN(parseInt(property))) {
          record = target.getAt(parseInt(property));
        }

        return record;
      },

      // Support adding/replacing records using `store.id = { ...data }`
      set(target, property, value) {
        // Pass through when using names of existing properties or when destroyed/ing
        if (property in target || target.isDestroying) {
          target[property] = value;
        } // Otherwise add/replace a record
        else {
          target.add(_objectSpread({
            [target.modelClass.idField]: property
          }, value));
        }

        return true;
      },

      // Support deleting records using `delete store.id`
      deleteProperty(target, property) {
        // Properties are deleted on destroy
        if (target.isDestroying) {
          delete target[property];
          return true;
        }

        return Boolean(target.remove(property).length);
      },

      // Support `id in store`
      has(target, property) {
        // Actual property
        if (property in target) {
          return true;
        } // Threat { ... } as JSON representation of a record (likely from toString())


        if (property.startsWith('{') && property.endsWith('}')) {
          const data = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].safeJsonParse(property);
          property = data === null || data === void 0 ? void 0 : data.id;
        }

        return target.includes(property);
      }

    });
    return proxy;
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreRelation.js":
/*!**********************************************!*\
  !*** ./lib/Core/data/mixin/StoreRelation.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Model_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Model.js */ "./lib/Core/data/Model.js");
var productName = 'taskboard';




/**
 * @module Core/data/mixin/StoreRelation
 */

/**
 * Mixin for Store that handles relations with other stores (actually defined on model).
 *
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreRelation extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreRelation';
  } //region Init

  /**
   * Initialized relations, called from constructor
   * @private
   */


  initRelations(reset) {
    const me = this,
          relations = me.modelClass.relations;

    if (reset && me.modelRelations) {
      // reset will reinit all relations, stop listening for store events on existing ones
      me.modelRelations.forEach(relation => {
        relation.storeDetacher && relation.storeDetacher();
      });
    }

    if ((!me.modelRelations || me.modelRelations.length === 0 || reset) && relations) {
      me.modelRelations = []; // foreignKeys is filled when model exposes its properties

      relations && relations.forEach(modelRelationConfig => {
        const config = Object.assign({}, modelRelationConfig),
              relatedStore = typeof config.store === 'string' ? me[config.store] : config.store;
        config.dependentStore = me;
        me.modelRelations.push(config);

        if (relatedStore) {
          config.storeProperty = config.store;
          config.store = relatedStore; // repeated from initRelationStores, needed if stored is assigned late

          const dependentStoreConfigs = relatedStore.dependentStoreConfigs; // Add link to dependent store

          if (dependentStoreConfigs.has(me)) {
            const dependentConfigs = dependentStoreConfigs.get(me); // Remove existing config on reset

            if (reset) {
              const existingConfig = dependentConfigs.find(c => c.relationName === config.relationName);

              if (existingConfig) {
                _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].remove(dependentConfigs, existingConfig);
              }
            }

            dependentConfigs.push(config);
          } else {
            dependentStoreConfigs.set(me, [config]);
          } // if foreign key specifies collectionName the related store should also be configured


          if (config.collectionName) {
            relatedStore.initRelationCollection(config, me);
          }

          if (relatedStore.count > 0) {
            relatedStore.updateDependentStores('dataset', relatedStore.records);
          }
        }
      });
    }
  }
  /**
   * Called from other end of an relation when this store should hold a collection of related records.
   * @private
   * @param config
   * @param collectionStore
   */


  initRelationCollection(config, collectionStore) {
    // TODO: parts of this should move to model?
    const me = this,
          name = config.collectionName;

    if (!me.collectionStores) {
      me.collectionStores = {};
    }

    me.collectionStores[name] = {
      store: collectionStore,
      config: config
    };

    if (!me[name + 'Store']) {
      me[name + 'Store'] = collectionStore;
    }

    if (me.count > 0) {
      me.initModelRelationCollection(name, me.records);
    }
  }

  initModelRelationCollection(name, records) {
    const me = this; // add collection getter to each model

    records.forEach(record => {
      // Needs to work in trees also, if not a tree traverse just calls fn on self
      record.traverse(node => {
        // Add/replace $relatedAssignments (or similar) if assignments already exists on target
        const useName = name in node ? `$related${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].capitalize(name)}` : name;
        Object.defineProperty(node, useName, {
          enumerable: true,
          configurable: true,
          get: function () {
            return me.getCollection(this, name);
          },
          set: function (value) {
            return me.setCollection(this, name, value);
          }
        });
      });
    });
  } //TODO: Do diff update, this is called on filtering and will be heavy with lots of records

  /**
   * Updates relationCache for all records.
   * @private
   */


  resetRelationCache() {
    this.relationCache = {};
    this.forEach(record => record.initRelations());
  }
  /**
   * Caches related records from related store on the local store.
   * @private
   * @param record Local record
   * @param relations Relations to related store
   */


  updateRecordRelationCache(record, relations) {
    const me = this;
    relations && relations.forEach(relation => {
      // use related records id, or if called before "binding" is complete use foreign key
      const foreignId = relation.related ? relation.related.id : record.get(relation.config.fieldName); // cache on that id, removing previously cached value if any

      foreignId !== undefined && me.cacheRelatedRecord(record, foreignId, relation.config.relationName, foreignId);
    });
  } //endregion
  //region Getters

  /**
   * Returns records the relation cache. Same result as if retrieving the collection on the dependent store, but
   * without the need of accessing that store.
   * @internal
   * @param {String} name
   * @param {Core.data.Model|String|Number} recordOrId
   * @returns {Array}
   */


  getRelationCollection(name, recordOrId) {
    const id = _Model_js__WEBPACK_IMPORTED_MODULE_3__["default"].asId(recordOrId);
    return this.relationCache[name] && this.relationCache[name][id] || [];
  }
  /**
   * Returns records from a collection of related records. Not to be called directly, called from Model getter.
   * TODO: Move to Model?
   * @private
   * @param {Core.data.Model} record
   * @param {String} name
   * @returns {Array}
   */


  getCollection(record, name) {
    const {
      config,
      store
    } = this.collectionStores[name];
    return store.relationCache[config.relationName] && store.relationCache[config.relationName][record.id] || [];
  }
  /**
   * Sets a collection of related records. Will updated the related store and trigger events from it. Not to be called
   * directly, called from Model setter.
   * @private
   */


  setCollection(model, name, records) {
    const {
      config,
      store
    } = this.collectionStores[name];
    if (!store.relationCache[config.relationName]) store.relationCache[config.relationName] = {};
    const old = (store.relationCache[config.relationName][model.id] || []).slice(),
          added = [],
          removed = [];
    store.suspendEvents(); // Remove any related records not in the new collection

    old.forEach(record => {
      if (!records.includes(record)) {
        record[config.fieldName] = null;
        store.remove(record);
        removed.push(record);
      }
    }); // Add records from the new collection not already in store

    records.forEach(record => {
      if (record instanceof _Model_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
        if (!record.stores.includes(store)) {
          store.add(record);
          added.push(record);
        }
      } else {
        [record] = store.add(record);
        added.push(record);
      } // Init relation


      record[config.fieldName] = model.id;
    });
    store.resumeEvents();

    if (removed.length) {
      store.trigger('remove', {
        records: removed
      });
      store.trigger('change', {
        action: 'remove',
        records: removed
      });
    }

    if (added.length) {
      store.trigger('add', {
        records: added
      });
      store.trigger('change', {
        action: 'add',
        records: added
      });
    }
  } //endregion
  //region Caching

  /**
   * Adds a record to relation cache, optionally removing it if already there.
   * @private
   * @param record
   * @param id
   * @param name
   * @param uncacheId
   */


  cacheRelatedRecord(record, id, name, uncacheId = null) {
    const me = this,
          cache = me.relationCache[name] || (me.relationCache[name] = {});

    if (uncacheId !== null) {
      me.uncacheRelatedRecord(record, name, uncacheId);
    }

    if (id != null) {
      // Only include of not already in relation cache, which might happen when removing and re-adding the same instance
      _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].include(cache[id] || (cache[id] = []), record);
    }
  }
  /**
   * Removes a record from relation cache, for a specific relation (specify relation name and id) or for all relations
   * @private
   * @param record Record to remove from cache
   * @param name Optional, relation name
   * @param id Optional, id
   */


  uncacheRelatedRecord(record, name = null, id = null) {
    const me = this;

    function remove(relationName, relatedId) {
      const cache = me.relationCache[relationName],
            oldCache = cache && cache[relatedId]; // When unjoining a record from a filtered store the relationCache will also be filtered
      // and might give us nothing, in which case we have nothing to clean up and bail out

      if (oldCache) {
        const uncacheIndex = oldCache.indexOf(record);
        uncacheIndex >= 0 && oldCache.splice(uncacheIndex, 1);

        if (oldCache.length === 0) {
          delete cache[relatedId];
        }
      }
    }

    if (id != null) {
      remove(name, id);
    } else {
      if (record.meta.relationCache) {
        Object.entries(record.meta.relationCache).forEach(([relationName, relatedRecord]) => {
          const relatedId = relatedRecord && relatedRecord.id;
          remove(relationName, relatedId);
        });
      }
    }
  }
  /**
   * Updates related stores when store is cleared, a record is removed or added.
   * @private
   * @param {String} action
   * @param {Core.data.Model[]} records
   */


  updateDependentStores(action, records) {
    this.dependentStoreConfigs.forEach(configs => {
      configs.forEach(config => {
        const dependentStore = config.dependentStore,
              cache = dependentStore.relationCache[config.relationName];

        if (action === 'dataset') {
          config.collectionName && this.initModelRelationCollection(config.collectionName, records);
          dependentStore.forEach(record => {
            const foreign = record.initRelation(config);
            foreign && dependentStore.cacheRelatedRecord(record, foreign.id, config.relationName, foreign.id);
          });
          return;
        }

        if (action === 'removeall') {
          dependentStore.forEach(record => {
            record.removeRelation(config);
          });
          delete dependentStore.relationCache[config.relationName];
          return;
        }

        if (action === 'add') {
          config.collectionName && this.initModelRelationCollection(config.collectionName, records);
        }

        if (action === 'add' || action === 'remove') {
          records.forEach(record => {
            const dependentRecords = cache && cache[record.id];

            switch (action) {
              case 'remove':
                // removing related record removes from cache on model and store
                if (dependentRecords) {
                  dependentRecords.forEach(dependentRecord => dependentRecord.removeRelation(config)); // Altered to not delete on self, simplifies taking actions on related records after remove if relation still lives
                  //delete cache[relatedRecord.id];
                } // TODO: Should removing related set foreign key to null? (removing Team sets Player.teamId to null)


                break;

              case 'add':
                // adding a new record in related store checks if any foreign keys match the new id,
                // and if so it sets up the relation
                dependentStore.forEach(dependentRecord => {
                  if (dependentRecord.get(config.fieldName) == record.id) {
                    dependentRecord.initRelation(config);
                    dependentStore.cacheRelatedRecord(dependentRecord, record.id, config.relationName);
                  }
                });
                break;
            }
          });
        }
      });
    });
  }
  /**
   * Updates relation cache and foreign key value when a related objects id is changed.
   * @private
   */


  updateDependentRecordIds(oldValue, value) {
    this.dependentStoreConfigs && this.dependentStoreConfigs.forEach(configs => {
      configs.forEach(config => {
        const dependentStore = config.dependentStore,
              cache = dependentStore.relationCache[config.relationName],
              localRecords = cache && cache[oldValue] && cache[oldValue].slice();
        localRecords && localRecords.forEach(localRecord => {
          // First update cache
          dependentStore.cacheRelatedRecord(localRecord, value, config.relationName, oldValue); // Then update & announce, otherwise relations wont be up to date in listeners

          localRecord.set(config.fieldName, value, false, true);
        });
      });
    });
  } //endregion


});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreSearch.js":
/*!********************************************!*\
  !*** ./lib/Core/data/mixin/StoreSearch.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';


/**
 * @module Core/data/mixin/StoreSearch
 */

const stringFound = (value, find) => String(value).toLowerCase().indexOf(find) !== -1,
      comparisons = {
  string: stringFound,
  number: stringFound,
  boolean: stringFound,
  date: (value, find) => {
    if (value instanceof Date && find instanceof Date) {
      return String(value) === String(find);
    }

    return String(value.getMonth() + 1).indexOf(find) !== -1 || String(value.getDate()).indexOf(find) !== -1 || String(value.getFullYear()).indexOf(find) !== -1;
  },
  object: (value, find) => value === find,
  // typeof null === object
  undefined: (value, find) => value === find
};
/**
 * Mixin for Store that handles searching (multiple records) and finding (single record).
 *
 * @example
 * // find all records that has a field containing the string john
 * let hits = store.search('john');
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreSearch extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreSearch';
  } //region Search (multiple hits)

  /**
   * Find all hits matching the specified input
   * @param {String} find Value to search for
   * @param {Object[]} fields Fields to search value in
   * @returns {Object[]} Array of hits, in the format { index: x, data: record }
   * @category Search
   */


  search(find, fields = null) {
    const records = this.storage.values,
          len = records.length,
          found = [];

    if (find == null) {
      return null;
    }

    if (typeof find === 'string') {
      find = find.toLowerCase();
    }

    let i, record, value, valueType, comparison;

    for (i = 0; i < len; i++) {
      record = records[i];

      for (const key of fields || record.fieldNames) {
        var _comparison;

        value = record[key];
        valueType = value instanceof Date ? 'date' : typeof value;
        comparison = comparisons[valueType];

        if (value && (_comparison = comparison) !== null && _comparison !== void 0 && _comparison(value, find)) {
          found.push({
            index: i,
            data: record,
            field: key,
            id: record.id
          });
        }
      }
    }

    return found;
  }
  /**
   * Find occurrences of the specified `value` in the specified `field` on all records in the store
   * @param {String} field The record field to search in
   * @param {*} value Value to search for
   * @returns {Object[]} Array of hits, in the format { index: x, data: record }
   * @category Search
   */


  findByField(field, value, distinct = false) {
    const records = this.storage.values,
          len = records.length,
          usedValues = new Set(),
          found = [];
    let i, record, fieldValue;

    if (value != null) {
      value = String(value).toLowerCase();
    }

    for (i = 0; i < len; i++) {
      record = records[i];
      fieldValue = record[field];

      if (!distinct || !usedValues.has(fieldValue)) {
        const type = fieldValue instanceof Date ? 'date' : typeof fieldValue,
              comparison = comparisons[type];

        if (value == null && fieldValue === value || value && comparison(fieldValue, value)) {
          found.push({
            id: record.id,
            index: i,
            data: record
          });

          if (distinct) {
            usedValues.add(fieldValue);
          }
        }
      }
    }

    return found;
  } //endregion
  //region Find (single hit)

  /**
   * Finds the first record for which the specified function returns true
   * @param {Function} fn Comparison function, called with record as parameter
   * @param {Boolean} [searchAllRecords] True to ignore any applied filters when searching
   * @returns {Core.data.Model} Record or undefined if none found
   *
   * @example
   * store.find(record => record.color === 'blue');
   * @category Search
   */


  find(fn, searchAllRecords = false) {
    let records = searchAllRecords ? this.storage.allValues : this.storage.values;

    if (this.isGrouped) {
      records = this.collectGroupRecords(searchAllRecords, false);
    }

    return records.find(fn);
  }
  /**
   * Finds the first record for which the specified field has the specified value
   * @param {String} fieldName Field name
   * @param {*} value Value to find
   * @param {Boolean} [searchAllRecords] True to ignore any applied filters when searching
   * @returns {Core.data.Model} Record or undefined if none found
   * @category Search
   */


  findRecord(fieldName, value, searchAllRecords = false) {
    const matchFn = r => _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(r[fieldName], value);

    if (this.isTree) {
      return this.query(matchFn, searchAllRecords)[0];
    }

    return (searchAllRecords ? this.storage.allValues : this.storage.values).find(matchFn);
  }
  /**
   * Searches the Store records using the passed function.
   * @param {Function} fn A function that is called for each record. Return true to indicate a match
   * @param {Boolean} [searchAllRecords] True to ignore any applied filters when searching
   * @returns {Core.data.Model[]} An array of the matching Records
   * @category Search
   */


  query(fn, searchAllRecords = false) {
    let records = searchAllRecords ? this.storage.allValues : this.storage.values;

    if (this.isTree) {
      const matches = [];
      this.traverse(node => {
        if (fn(node)) {
          matches.push(node);
        }
      }, undefined, undefined, searchAllRecords);
      return matches;
    } else if (this.isGrouped) {
      records = this.collectGroupRecords(searchAllRecords, false);
    }

    return records.filter(fn);
  } //endregion
  //region Others

  /**
   * Returns true if the supplied function returns true for any record in the store
   * @param {Function} fn A function that should return true to indicate a match
   * @param {Boolean} [searchAllRecords] True to ignore any applied filters when searching
   * @returns {Boolean}
   *
   * @example
   * store.some(record => record.age > 95); // true if any record has age > 95
   * @category Search
   */


  some(fn, searchAllRecords = false) {
    let records = searchAllRecords ? this.storage.allValues : this.storage.values;

    if (this.isGrouped) {
      records = this.collectGroupRecords(searchAllRecords, false);
    }

    return records.some(fn);
  } //endregion


});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreSort.js":
/*!******************************************!*\
  !*** ./lib/Core/data/mixin/StoreSort.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';


/**
 * @module Core/data/mixin/StoreSort
 */

const nestedRe = /\./;
/**
 * Mixin for Store that handles simple sorting as well as multi-level sorting.
 *
 * ```javascript
 * // single sorter
 * store.sort('age');
 *
 * // single sorter as object, descending order
 * store.sort({ field : 'age', ascending : false });
 *
 * // multiple sorters
 * store.sort(['age', 'name']);
 *
 * // using custom sorting function
 * store.sort({
 *     fn : (recordA, recordB) => {
 *         // apply custom logic, for example:
 *         return recordA.name.length < recordB.name.length ? -1 : 1;
 *     }
 * });
 *
 * // using locale specific sort (slow)
 * store.sort({ field : 'name', useLocaleSort : 'sv-SE' });
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreSort extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreSort';
  } //region Config


  static get defaultConfig() {
    return {
      /**
       * Initial sorters, format is [{ field: 'name', ascending: false }, ...]
       * @config {Object[]|String[]}
       * @category Common
       */
      sorters: [],

      /**
       * Use `localeCompare()` when sorting, which lets the browser sort in a locale specific order. Set to `true`,
       * a locale string or a locale config to enable.
       *
       * Enabling this has big negative impact on sorting
       * performance. For more info on `localeCompare()`, see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare).
       *
       * Examples:
       *
       * ```javascript
       * const store = new Store({
       *     // Swedish sorting
       *     useLocaleSort : 'sv-SE'
       * });
       *
       * const store = new Store({
       *     // Swedish sorting with custom casing order
       *     useLocaleSort : {
       *         locale    : 'sv-SE',
       *         caseFirst : 'upper'
       *     }
       * });
       * ```
       *
       * Can also be configured on a per sorter basis:
       *
       * ```javascript
       * store.sort({ field: 'name', useLocaleSort : 'sv-SE' });
       * ```
       *
       * @config {Boolean|String|Object}
       * @default false
       * @category Advanced
       */
      useLocaleSort: null
    };
  }

  static get configurable() {
    return {
      /**
       * Specify true to sort this store after records are added.
       * @config {Boolean}
       * @default
       * @category Sortering
       */
      reapplySortersOnAdd: false
    };
  } //endregion
  //region Events

  /**
   * Fired before sorting
   * @event beforeSort
   * @param {Core.data.Store} source This Store
   * @param {Object[]} sorters Sorter configs
   * @param {Core.data.Model[]} records Records to sort
   */

  /**
   * Fired after sorting
   * @event sort
   * @param {Core.data.Store} source This Store
   * @param {Object[]} sorters Sorter configs
   * @param {Core.data.Model[]} records Sorted records
   */
  //endregion
  //region Properties

  /**
   * Currently applied sorters
   * @member {Object[]} sorters
   * @readonly
   * @category Sort, group & filter
   */

  /**
   * Is store sorted?
   * @property {Boolean}
   * @readonly
   * @category Sort, group & filter
   */


  get isSorted() {
    return Boolean(this.sorters.length) || this.isGrouped;
  }

  updateReapplySortersOnAdd(enable) {
    this.storage.autoSort = enable;
  } //endregion
  //region Add & remove sorters

  /**
   * Sort records, either by replacing current sorters or by adding to them.
   * A sorter can specify a **_custom sorting function_** which will be called with arguments (recordA, recordB).
   * Works in the same way as a standard array sorter, except that returning `null` triggers the stores
   * normal sorting routine.
   *
   * ```javascript
   * // single sorter
   * store.sort('age');
   *
   * // single sorter as object, descending order
   * store.sort({ field : 'age', ascending : false });
   *
   * // multiple sorters
   * store.sort(['age', 'name']);
   *
   * // using custom sorting function
   * store.sort((recordA, recordB) => {
   *     // apply custom logic, for example:
   *     return recordA.name.length < recordB.name.length ? -1 : 1;
   * });
   *
   * // using locale specific sort (slow)
   * store.sort({ field : 'name', useLocaleSort : 'sv-SE' });
   * ```
   *
   * @param {String|Object[]|Object|Function} field Field to sort by.
   * Can also be an array of {@link Core.util.CollectionSorter sorter} config objects, or a sorting function, or a {@link Core.util.CollectionSorter sorter} config.
   * @param {Boolean} [ascending] Sort order.
   * Applicable when the `field` is a string (if not specified and already sorted by the field, reverts direction),
   * or an object and `ascending` property is not specified for the object. `true` by default.
   * Not applicable when `field` is a function. `ascending` is always `true` in this case.
   * @param {Boolean} [add] If `true`, adds a sorter to the sorters collection.
   * Not applicable when `field` is an array. In this case always replaces active sorters.
   * @param {Boolean} [silent] Set as true to not fire events. UI will not be informed about the changes.
   * @category Sort, group & filter
   * @fires beforeSort
   * @fires sort
   * @fires refresh
   */


  sort(field, ascending, add = false, silent = false) {
    const me = this,
          records = me.allRecords,
          currentSorters = me.sorters ? me.sorters.slice() : [];
    let currentDir = null,
        curSort;

    if (field) {
      if (Array.isArray(field)) {
        // array of strings make fields always be sorted ascending
        me.sorters = field.map(sorter => me.normalizeSorterConfig(sorter, typeof sorter === 'string' ? true : ascending));
      } else {
        const sorter = me.normalizeSorterConfig(field, ascending);

        if (add) {
          curSort = me.getCurrentSorterByField(sorter.field); // Field already among sorters? change sort direction instead of adding new sorter

          if (curSort) {
            currentDir = curSort.ascending;
            curSort.ascending = sorter.ascending;
          } else {
            me.sorters.push(sorter);
          }
        } else {
          me.sorters = [sorter];
        }
      }
    }

    if (!silent && me.trigger('beforeSort', {
      sorters: me.sorters,
      records,
      currentSorters
    }) === false) {
      // Restore sorters
      me.sorters = currentSorters; // Restore sorting direction if toggled

      if (currentDir !== null) {
        curSort.ascending = currentDir;
      }

      return;
    }

    return me.performSort(silent);
  }

  normalizeSorterConfig(field, ascending) {
    const me = this,
          sorter = {
      ascending
    };

    if (typeof field === 'object') {
      var _field$ascending;

      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign(sorter, field);

      if (field.fn) {
        delete sorter.fn;
        sorter.sortFn = field.fn;
      }

      sorter.ascending = (_field$ascending = field.ascending) !== null && _field$ascending !== void 0 ? _field$ascending : ascending;
    } else if (typeof field === 'function') {
      sorter.sortFn = field;
    } else {
      sorter.field = field;
    } // sort in opposite direction if not specified and already sorted, default to sorting ascending


    if (sorter.ascending == null) {
      const curSort = me.getCurrentSorterByField(sorter.field);
      sorter.ascending = curSort ? !curSort.ascending : true;
    }

    if (sorter.sortFn == null) {
      var _me$modelClass, _me$modelClass$$meta$;

      const compareItems = (_me$modelClass = me.modelClass) === null || _me$modelClass === void 0 ? void 0 : (_me$modelClass$$meta$ = _me$modelClass.$meta.fields.map[sorter.field]) === null || _me$modelClass$$meta$ === void 0 ? void 0 : _me$modelClass$$meta$.compareItems;

      if (compareItems) {
        // These sorters will be ignored by AjaxStore when remoting...
        sorter.sortFn = compareItems;
      }
    }

    return sorter;
  }

  getCurrentSorterByField(field) {
    return typeof field === 'string' && this.sorters.find(s => s.field === field) || null;
  }
  /**
   * Add a sorting level (a sorter).
   * @param {String|Object[]|Object|Function} field Field to sort by. Can also be an array of sorters, or a sorting
   * function, or a {@link Core.util.CollectionSorter sorter} config.
   * @param {Boolean} [ascending] Sort order (used only if field specified as string)
   * @category Sort, group & filter
   */


  addSorter(field, ascending = true) {
    this.sort(field, ascending, true);
  }
  /**
   * Remove a sorting level (a sorter)
   * @param {String|Function} field Stop sorting by this field (or sorter function)
   * @category Sort, group & filter
   */


  removeSorter(field) {
    const sorterIndex = this.sorters.findIndex(sorter => sorter.field === field || sorter.sortFn === field);

    if (sorterIndex > -1) {
      this.sorters.splice(sorterIndex, 1);
      this.sort();
    }
  }
  /**
   * Removes all sorters, turning store sorting off.
   * @category Sort, group & filter
   */


  clearSorters() {
    if (this.sorters.length) {
      this.sorters.length = 0;
      this.sort();
    }
  } //region
  //region Sorting logic

  /**
   * Creates a function used with Array#sort when sorting the store. Override to use your own custom sorting logic.
   * @param {Object[]} sorters An array of sorter config objects
   * @returns {Function}
   * @category Sort, group & filter
   */


  createSorterFn(sorters) {
    const storeLocaleSort = this.useLocaleSort;
    return (lhs, rhs) => {
      // Cannot use `for ... of` here, breaks a test in IE11 were this fn is called from transpiled test code
      // which leads to iterator symbol mismatch
      for (let i = 0; i < sorters.length; i++) {
        const sorter = sorters[i],
              {
          field,
          ascending = true,
          useLocaleSort = storeLocaleSort
        } = sorter,
              fn = sorter.fn || sorter.sortFn,
              direction = ascending ? 1 : -1;

        if (fn) {
          const val = fn(lhs, rhs);

          if (val !== null) {
            return val * direction;
          }
        }

        const nested = nestedRe.test(field),
              lhsValue = nested ? lhs.get(field) : lhs[field],
              rhsValue = nested ? rhs.get(field) : rhs[field];

        if (lhsValue === rhsValue) {
          continue;
        }

        if (lhsValue == null) {
          return -direction;
        }

        if (rhsValue == null) {
          return direction;
        }

        if (useLocaleSort) {
          // Use systems locale
          if (useLocaleSort === true) {
            return String(lhsValue).localeCompare(rhsValue) * direction;
          } // Use specified locale


          if (typeof useLocaleSort === 'string') {
            return String(lhsValue).localeCompare(rhsValue, useLocaleSort) * direction;
          } // Use locale config


          if (typeof useLocaleSort === 'object') {
            return String(lhsValue).localeCompare(rhsValue, useLocaleSort.locale, useLocaleSort) * direction;
          }
        }

        if (lhsValue > rhsValue) {
          return direction;
        }

        if (lhsValue < rhsValue) {
          return -direction;
        }
      }

      return 0;
    };
  }
  /**
   * Perform sorting according to the {@link #config-sorters} configured.
   * This is the internal implementation which is overridden in {@link Core.data.AjaxStore} and
   * must not be overridden.
   * @private
   * @category Sort, group & filter
   */


  performSort(silent) {
    const me = this,
          {
      rootNode,
      storage,
      sorters
    } = me,
          sorter = me.createSorterFn(me.isGrouped ? me.groupers.concat(sorters) : sorters);

    if (me.tree) {
      rootNode.traverse(node => {
        if (node.isLoaded && node.isParent) {
          node.children.sort(sorter); // Since child nodes change order their parentIndex needs to be updated.
          // Update is silent, records wont be considered modified because of the sort

          node.updateChildrenIndices(node.children, false, true);
        }
      });
      storage.replaceValues({
        values: me.collectDescendants(rootNode).visible,
        silent: true
      });
    } else if (me.isGrouped) {
      storage.replaceValues({
        values: me.prepareGroupRecords(sorter),
        silent: true
      });
    } else {
      storage.replaceValues({
        values: storage.values.sort(sorter),
        silent: true
      });
    }

    me.afterPerformSort(silent);
  }

  afterPerformSort(silent) {
    const me = this;
    me._idMap = null;

    if (!silent) {
      const event = {
        action: 'sort',
        sorters: me.sorters,
        records: me.allRecords
      };
      me.trigger('sort', event); // Only fire this event if it's a local sort.
      // If we are configured with sortParamName, the loadData will fire it.

      if (!me.sortParamName) {
        me.trigger('refresh', event);
      }
    }
  } //endregion


});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreState.js":
/*!*******************************************!*\
  !*** ./lib/Core/data/mixin/StoreState.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';


/**
 * @module Core/data/mixin/StoreState
 */

/**
 * A Mixin for Store that manages its state.
 *  * **sorters**
 *  * **groupers**
 *  * **filters**: Only serializable filters are saved (filters defined with `property` and `value`).
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreState extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreState';
  }
  /**
   * Get store state. Used by State-plugin to serialize state
   * @private
   * @returns {{ sorters, groupers }}
   */


  getState() {
    const {
      sorters,
      groupers,
      filters
    } = this,
          state = {};

    if (sorters !== null && sorters !== void 0 && sorters.length) {
      state.sorters = sorters.map(sorter => {
        const clone = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].cleanupProperties(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(sorter)); // Remove sorting fns

        delete clone.fn;
        delete clone.sortFn;
        return clone;
      });
    }

    if (groupers !== null && groupers !== void 0 && groupers.length) {
      state.groupers = groupers.slice();
    }

    if (filters !== null && filters !== void 0 && filters.values.length) {
      state.filters = filters.values.map(filter => {
        const clone = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].cleanupProperties(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(filter.config)); // Apply value, needed because of filterable fn reusing instance (so not in config)

        clone.value = filter.value; // Remove default value, no need to store that in state

        if (clone.caseSensitive) {
          delete clone.caseSensitive;
        } // Remove filtering fns
        // delete clone.filterBy; // Cannot remove it, required by export feature


        return clone;
      });
    }

    return state;
  }
  /**
   * Apply store state. Used by State-plugin to restore a previously serialized state
   * @private
   * @param {{ sorters, groupers }} state
   */


  applyState(state) {
    const me = this,
          {
      sorters = [],
      groupers = [],
      filters = []
    } = state;
    me.sorters = sorters.slice();
    me.groupers = groupers.slice();
    me.sort();
    me.filters = filters.filter(filter => filter.property || filter.filterBy);
    me.filter();
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreSum.js":
/*!*****************************************!*\
  !*** ./lib/Core/data/mixin/StoreSum.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';

/**
 * @module Core/data/mixin/StoreSum
 */

/**
 * Mixin for Store that handles summaries.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreSum extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreSum';
  }
  /**
   * Returns sum calculated by adding value of specified field for specified records. Defaults to using all records
   * in store
   * @param {String} field Field to summarize by
   * @param {Core.data.Model[]} records Records to summarize, uses all records if unspecified.
   * @returns {Number}
   * @category Sum
   */


  sum(field, records = this.storage.values) {
    if (!records) return 0;
    return records.reduce((sum, record) => {
      if (record.isSpecialRow) return sum;
      const v = Number(record[field]);
      return isNaN(v) ? sum : sum + v;
    }, 0);
  }
  /**
   * Returns min value for the specified field, can be used with Date or Number values. Defaults to look through all records in store
   * @param {String} field Field to find min value for
   * @param {Core.data.Model[]} records Records to process, uses all records if unspecified
   * @returns {Number|Date}
   * @category Sum
   */


  min(field, records = this.storage.values) {
    if (!records || !records.length) return 0;
    return records.reduce((min, record) => {
      var _record$field;

      const type = typeof ((_record$field = record[field]) === null || _record$field === void 0 ? void 0 : _record$field.valueOf());
      if (type === 'number' && record[field] < min) min = record[field];
      return min;
    }, records[0][field]);
  }
  /**
   * Returns max value for the specified field, can be used with Date or Number values. Defaults to look through all records in store
   * @param {String} field Field to find max value for
   * @param {Core.data.Model[]} records Records to process, uses all records if unspecified
   * @returns {Number|Date}
   * @category Sum
   */


  max(field, records = this.storage.values) {
    if (!records || !records.length) return 0;
    return records.reduce((max, record) => {
      var _record$field2;

      const type = typeof ((_record$field2 = record[field]) === null || _record$field2 === void 0 ? void 0 : _record$field2.valueOf());
      if (type === 'number' && record[field] > max) max = record[field];
      return max;
    }, records[0][field]);
  }
  /**
   * Returns the average value for the specified field. Defaults to look through all records in store
   * @param {String} field Field to calculate average value for
   * @param {Core.data.Model[]} records Records to process, uses all records if unspecified
   * @returns {Number}
   * @category Sum
   */


  average(field, records = this.storage.values) {
    if (!records || !records.length) return 0;
    let count = 0;
    const sum = records.reduce((sum, record) => {
      if (record.isSpecialRow) return sum;
      const v = parseFloat(record[field]);

      if (!isNaN(v)) {
        count++;
        return sum + v;
      } else {
        return sum;
      }
    }, 0);
    return count > 0 ? sum / count : 0;
  }
  /**
   * Returns sum by adding value of specified field for records in the group with the specified groupValue.
   * @param {*} groupValue The group to summarize
   * @param {String} field Field to summarize by
   * @returns {Number} Sum or null if store not grouped
   * @category Sum
   */


  groupSum(groupValue, field) {
    return this.sum(field, this.getGroupRecords(groupValue));
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreSync.js":
/*!******************************************!*\
  !*** ./lib/Core/data/mixin/StoreSync.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_WalkHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/WalkHelper.js */ "./lib/Core/helper/WalkHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module Core/data/mixin/StoreSync
 */

/**
 * Mixin that allows Store to sync a new dataset with its existing records, instead of fully replacing everything.
 * Configure Store with `syncDataOnLoad: true` to activate the functionality. Sync is performed when a new dataset
 * is loaded, either by directly assigning it to `store.data` or by loading it using Ajax (if using an AjaxStore).
 *
 * ```javascript
 * const store = new Store({
 *   syncDataOnLoad : true,
 *   data           : [
 *     { id : 1, name : 'Saitama' },
 *     { id : 2, name : 'Genos' },
 *     { id : 3, name : 'Mumen Rider' }
 *   ]
 * });
 *
 * // Sync a new dataset by assigning to data:
 * store.data = [
 *   { id : 1, name : 'Caped Baldy' },
 *   { id : 4, name : 'Horse-Bone' }
 * ];
 *
 *  // Result : Record 1 updated, record 2 & 3 removed, record 4 added
 * ```
 *
 * For more details, please see {@link #config-syncDataOnLoad}.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreSync extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreSync';
  }

  static get defaultConfig() {
    return {
      /**
       * Configure with `true` to sync loaded data instead of replacing existing with a new dataset.
       *
       * By default (or when configured with `false`) assigning to `store.data` replaces the entire dataset
       * with a new one, creating all new records:
       *
       * ```javascript
       * store.data = [ { id : 1, name : 'Saitama' } ];
       *
       * const first = store.first;
       *
       * store.data = [ { id : 1, name : 'One-Punch man' } ];
       *
       * store.first !== first;
       * ```
       *
       * When configured with `true` the new dataset is instead synced against the old, figuring out what was
       * added, removed and updated:
       *
       * ```javascript
       * store.data = [ { id : 1, name : 'Saitama' } ];
       *
       * const first = store.first;
       *
       * store.data = [ { id : 1, name : 'One-Punch man' } ];
       *
       * store.first === first;
       * ```
       *
       * After the sync, any configured sorters, groupers and filters will be reapplied.
       *
       * The sync operation has a configurable threshold, above which the operation will be treated as a
       * batch/refresh and only trigger a single `refresh` event. If threshold is not reached, individual events
       * will be triggered (single `add`, `remove` and possible multiple `update`). To enable the threshold,
       * supply a config object with a `threshold` property instead of `true`:
       *
       * ```javascript
       * const store = new Store({
       *     syncDataOnLoad : {
       *         threshold : '20%'
       *     }
       * });
       * ```
       *
       * `threshold` accepts numbers or strings. A numeric threshold means number of affected records, while a
       * string is used as a percentage of the whole dataset (appending `%` is optional). By default no threshold
       * is used.
       *
       * @config {Boolean|Object}
       * @default false
       * @category Common
       */
      syncDataOnLoad: null
    };
  }
  /**
   * Syncs a new dataset against the already loaded one, only applying changes.
   * Not intended to be called directly, please configure store with `syncDataOnLoad: true` and assign to
   * `store.data` as usual instead.
   *
   * ```
   * const store = new Store({
   *    syncDataOnLoad : true,
   *    data : [
   *        // initial data
   *    ]
   * });
   *
   * store.data = [ // new data ]; //  Difference between initial data and new data will be applied
   * ```
   *
   * @param {Object[]|Core.data.Model[]} data New dataset, an array of records or data objects
   * @private
   */


  syncDataset(data) {
    const me = this,
          {
      storage
    } = me,
          {
      toAdd,
      toRemove,
      updated
    } = me.tree ? me.syncTreeDataset(data) : me.syncFlatDataset(data);
    let {
      threshold
    } = me.syncDataOnLoad,
        surpassed = false; // Check if threshold is surpassed

    if (threshold) {
      // Any string is treated as a percentage
      if (typeof threshold === 'string') {
        threshold = parseInt(threshold, 10) / 100 * me.count;
      }

      surpassed = toAdd.length + toRemove.length + updated.length > threshold;
    }

    if (me.tree) {
      // Flat data is spliced into/out of the collection, but in a tree it has to be added/removed from store
      // to end up on correct parents
      if (toAdd.length) {
        // Add all new nodes in one go, will be added to correct parent using `parentId`. Triggering multiple times
        const added = me.add(toAdd, surpassed); // parentId was tucked on in syncTreeDataset() to allow the single flat add above, clean it out

        added.forEach(node => node.clearParentId());
      } // Remove in one go, removing from each parent. Triggering multiple times


      me.remove(toRemove, surpassed);
    } else {
      if (surpassed) {
        me.suspendEvents();
      } // Add and remove, will trigger if below threshold/no threshold
      // We cannot simply splice into our Collection because of the extra
      // processing various Store mixins do in add and remove implementations


      me.remove(toRemove);
      me.add(toAdd);

      if (surpassed) {
        me.resumeEvents();
      }
    } // Trigger updates if using threshold, but have not surpassed it. If threshold is not used, the updates
    // are triggered when data is set (avoiding another iteration)


    if (threshold && !surpassed) {
      updated.forEach(({
        record,
        toSet,
        wasSet
      }) => me.onModelChange(record, toSet, wasSet));
    } // Clear change-tracking


    me.acceptChanges();
    const event = {
      added: toAdd,
      removed: toRemove,
      updated,
      thresholdSurpassed: surpassed
    }; // Trigger `batch` if threshold is surpassed, more similar to a batch than a full `dataset`

    if (surpassed) {
      this.trigger('refresh', {
        action: 'batch',
        data: data,
        records: storage.values,
        syncInfo: event
      });
    }

    if (me.isFiltered) {
      // Announced filter
      me.filter();
    }

    if (me.isGrouped) {
      // Announced sort
      me.group();
    } else if (me.isSorted) {
      // Announced sort
      me.sort();
    }

    me.trigger('loadSync', event);
  } // Used by syncDataset()


  syncFlatDataset(data) {
    if (!data) {
      return;
    }

    const me = this,
          idField = me.modelClass.idField,
          toRemove = [],
          toAdd = [],
          updated = [],
          usedIds = {};
    const {
      threshold
    } = me.syncDataOnLoad;
    let hitCount = 0;
    data.forEach(rawData => {
      rawData = rawData.isModel ? rawData.data : rawData;
      const id = rawData[idField],
            record = me.getById(id); // Record exists, might be an update

      if (record) {
        // Update silently if using threshold, otherwise trigger away
        const wasSet = record.set(rawData, null, Boolean(threshold));

        if (wasSet) {
          updated.push({
            record,
            wasSet,
            toSet: rawData
          });
        }

        hitCount++;
      } // Does not exist, add
      else {
        toAdd.push(me.processRecord(me.createRecord(rawData)));
      }

      usedIds[id] = 1;
    }); // Check removals, unless all records were visited above

    if (hitCount < me.allCount) {
      me.forEach(record => {
        if (!usedIds[record.id]) {
          toRemove.push(record);
        }
      });
    }

    return {
      toAdd,
      toRemove,
      updated
    };
  } // Used by syncDataset()


  syncTreeDataset(data) {
    if (!data) {
      return;
    }

    const me = this,
          {
      idField,
      parentIdField
    } = me.modelClass,
          toRemove = [],
          toAdd = [],
          updated = [],
          usedIds = {};

    if (me.transformFlatData) {
      data = me.treeifyFlatData(data);
    }

    const {
      threshold
    } = me.syncDataOnLoad;
    _helper_WalkHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].preWalkWithParent({
      isRoot: true,
      children: data
    }, n => n.children, (parent, rawData) => {
      if (parent) {
        const id = rawData[idField],
              node = me.getById(id); // Record exists, might be an update

        if (node) {
          // Update silently if using threshold, otherwise trigger away
          const wasSet = node.set(rawData, null, Boolean(threshold));

          if (wasSet) {
            updated.push({
              record: node,
              wasSet,
              toSet: rawData
            });
          }
        } // Does not exist, add
        else {
          rawData[parentIdField] = parent[idField]; // clear children since they will be pushed separately with preWalkWithParent

          toAdd.push(_objectSpread(_objectSpread({}, rawData), {}, {
            children: []
          }));
        }

        usedIds[id] = 1;
      }
    });
    me.traverse(node => {
      if (!usedIds[node.id]) {
        toRemove.push(node);
      }
    });
    return {
      toAdd,
      toRemove,
      updated
    };
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/StoreTree.js":
/*!******************************************!*\
  !*** ./lib/Core/data/mixin/StoreTree.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';

/**
 * @module Core/data/mixin/StoreTree
 */

const emptyArray = Object.freeze([]);
/**
 * Mixin for store with tree related functionality. To learn more about working with tree nodes please see the
 * {@link Core/data/mixin/TreeNode} class and [this guide](#Core/guides/data/treedata.md).
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreTree extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreTree';
  }

  static get configurable() {
    return {
      /**
       * Set to `true` to on load transform a flat dataset with raw objects containing `parentId` into the format
       * expected for tree data.
       *
       * Example input format:
       *
       * ```javascript
       * [
       *   { id : 1, name : 'Parent' },
       *   { id : 2, name : 'Child', parentId : 1 }
       * ]
       * ```
       *
       * Will be transformed into:
       *
       * ```javascript
       * [
       *   {
       *     id : 1,
       *     name : 'Parent',
       *     children : [
       *       { id : 2, name : 'Child', parentId : 1 }
       *     ]
       *   }
       * ]
       * ```
       *
       * @config {Boolean}
       * @category Tree
       */
      transformFlatData: null
    };
  } //region Getters

  /**
   * True if this Store is configured to handle tree data (with `tree : true`) or if this is a
   * {@link Core.data.Store#function-makeChained chained store} and the master store is a tree store.
   * @property {Boolean}
   * @readonly
   * @category Tree
   */


  get isTree() {
    return this.tree || this.masterStore && this.masterStore.tree;
  }
  /**
   * Returns all leaf records in a tree store
   * @property {Core.data.Model[]}
   * @category Tree
   */


  get leaves() {
    const me = this,
          result = [];

    if (me.isTree) {
      me.traverse(record => {
        if (record.isLeaf) {
          result.push(record);
        }
      });
      return result;
    } else {
      me.allRecords.forEach(r => {
        if (r.isLeaf) {
          result.push(r);
        }

        r.traverse(record => {
          if (record.isLeaf) {
            result.push(record);
          }
        }, true);
      });
    }

    return result;
  } //endregion
  //region Children

  /**
   * Loads children for a parent node that uses load on demand (when expanding it). Base implementation does nothing,
   * either use AjaxStore which implements it, create your own subclass with an implementation or listen for
   * `toggleNode` and insert records when you have them available.
   * @param {Core.data.Model} parentRecord
   * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
   * @category Tree
   */


  async loadChildren(parentRecord) {}
  /**
   * Called from Model when adding children. Not to be called directly, use Model#appendChild() instead.
   * @internal
   * @param {Core.data.mixin.TreeNode} parent
   * @param {Core.data.mixin.TreeNode[]} children
   * @param {Number} index
   * @param {Object} isMove
   * @param {Boolean} [silent]
   * @fires add
   * @fires change
   * @category Tree
   */


  onNodeAddChild(parent, children, index, isMove, silent = false) {
    const me = this,
          isRootLoad = parent === me.rootNode && parent.isLoading,
          {
      storage
    } = me,
          toAddToUI = [],
          toAdd = [],
          previousSibling = children[0].previousSibling;
    let storeInsertionPoint;
    me.collectDescendants(children, toAddToUI, toAdd, {
      inCollapsedBranch: !(parent.isExpanded(me) && parent.ancestorsExpanded(me))
    }); // Keep CRUD caches up to date unless it's a root load

    if (!isRootLoad && toAdd.length) {
      for (const record of toAdd) {
        // Only considered an add if not modified or moved
        if (!me.modified.includes(record) && !isMove[record.id]) {
          // If was removed, remove from `removed` list
          if (me.removed.includes(record)) {
            me.removed.remove(record);
          } // Else add to `added` list
          else {
            me.added.add(record);
          }
        }
      }
    } // Root node inserted first


    if (isRootLoad && me.rootVisible) {
      toAddToUI.unshift(parent);
      toAdd.unshift(parent);
    }

    if (toAddToUI.length) {
      // Calculate the insertion point into the flat store.
      // If the new node is the first, then it goes after the parent node.
      if (index === 0 || !previousSibling) {
        storeInsertionPoint = storage.indexOf(parent);
      } // Otherwise it has to go after the previous visible node which has
      // to be calculated. See indexOfPreviousVisibleNode for explanation.
      else {
        storeInsertionPoint = storage.indexOf(previousSibling) + previousSibling.getDescendantCount(true, me);
      } // Insert added child nodes at correct location in storage.
      // We must not react to change - we fire the events here.


      storage.suspendEvents();
      me.storage.splice(++storeInsertionPoint, 0, toAddToUI);
      storage.resumeEvents();
    } // Since we do not pass through Store#onDataChange we have to handle relations manually here. And since they are
    // not tied to flat part of store, use all children


    me.updateDependentStores('add', children); // If it's a root level set data op, then signal 'dataset'

    if (isRootLoad && toAddToUI.length) {
      var _me$afterLoadData;

      // If we have initial sorters, perform a silent sort before triggering `dataset`
      // NOTE: Records in toAddToUI will be in the original order, not affected by the sort
      if (me.sorters.length) {
        me.sort(null, null, false, true);
      }

      (_me$afterLoadData = me.afterLoadData) === null || _me$afterLoadData === void 0 ? void 0 : _me$afterLoadData.call(me);

      if (!silent) {
        const event = {
          action: 'dataset',
          data: me._data,
          records: toAddToUI
        };
        me.trigger('refresh', event);
        me.trigger('change', event);
      }
    } // Else, continue as before to signal an "isChild" add.
    else if (!silent) {
      const event = {
        action: 'add',
        parent,
        isChild: true,
        isMove,
        records: children,
        allRecords: toAdd,
        index: storeInsertionPoint
      };
      me.trigger('add', event);
      me.trigger('change', event); // Check if any add is actually a move

      if (Object.values(isMove).some(wasMoved => wasMoved)) {
        const event = {
          newParent: parent,
          records: children.filter(record => isMove[record.id])
        };
        me.trigger('move', event);
      }
    }
  }

  onNodeRemoveChild(parent, children, index, flags = {
    isMove: false,
    silent: false,
    unfiltered: false
  }) {
    const me = this,
          {
      storage
    } = me,
          toRemoveFromUI = [],
          toRemove = [],
          {
      isMove,
      silent,
      unfiltered
    } = flags,
          removeUnfiltered = unfiltered && me.isFiltered,
          childrenToRemove = removeUnfiltered && parent.unfilteredChildren ? parent.unfilteredChildren : children;
    me.collectDescendants(childrenToRemove, toRemoveFromUI, toRemove, {
      inCollapsedBranch: !(parent.isExpanded(me) && parent.ancestorsExpanded(me)),
      unfiltered: removeUnfiltered
    }); // test StoreTree.t.js should fail if the next line replaces the above line
    // me.collectDescendants(children, toRemoveFromUI, toRemove, { inCollapsedBranch : !(parent.isExpanded(me) && parent.ancestorsExpanded(me)) });

    if (!isMove) {
      // Unjoin is recursive, use flat children array
      for (const record of children) {
        record.unjoinStore(me);
      } // Keep CRUD caches up to date


      if (toRemove.length) {
        for (const record of toRemove) {
          if (record.stores.includes(me)) {
            record.unjoinStore(me);
          } // If was newly added, remove from `added` list


          if (me.added.includes(record)) {
            me.added.remove(record);
          } // Else add to `removed` list
          else {
            me.removed.add(record);
          }
        }

        me.modified.remove(toRemove);
      }
    } // Remove removed child nodes at correct location in storage


    if (toRemoveFromUI.length) {
      index = storage.indexOf(toRemoveFromUI[0]); // We must not react to change - we fire the events here.

      if (index > -1) {
        storage.suspendEvents();
        storage.splice(index, toRemoveFromUI.length);
        storage.resumeEvents();
      }
    } else {
      // If nothing is removed from UI (storage) return -1, showing that removed node was in a collapsed branch
      index = -1;
    }

    if (!silent) {
      const event = {
        action: 'remove',
        parent,
        isChild: true,
        isMove,
        records: children,
        allRecords: toRemove,
        index
      };
      me.trigger('remove', event);
      me.trigger('change', event);
    }
  }

  collectDescendants(node, visible = [], all = [], flags = {
    inCollapsedBranch: false,
    unfiltered: false
  }) {
    const me = this,
          {
      inCollapsedBranch,
      unfiltered
    } = flags,
          children = Array.isArray(node) ? node : me.getChildren(node, unfiltered);

    if (children) {
      for (let i = 0, len = children.length, child; i < len; i++) {
        child = children[i];

        if (!inCollapsedBranch) {
          visible.push(child);
        }

        all.push(child);
        me.collectDescendants(child, visible, all, {
          inCollapsedBranch: inCollapsedBranch || !child.isExpanded(me),
          unfiltered
        });
      }
    }

    return {
      visible,
      all
    };
  }
  /**
   * Returns the children of the passed branch node which this store owns. By default, this
   * is the entire `children` array.
   *
   * **If this store {@link Core.data.mixin.StoreChained#property-isChained isChained}**, then
   * this returns only the subset of children which are filtered into this store by the
   * {@link Core.data.mixin.StoreChained#config-chainedFilterFn chainedFilterFn}.
   * @param {Core.data.Model} parent The node to return the children of.
   * @returns {Core.data.Model[]}
   * @category Tree
   */


  getChildren(parent, unfiltered = false) {
    // In case of chained store we need to apply chainedFilterFn to all records
    const children = (unfiltered || this.isChained) && parent.unfilteredChildren || parent.children;
    return children && children.length ? this.isChained ? children.filter(this.chainedFilterFn) : children : emptyArray;
  }
  /**
   * Includes or excludes all records beneath parentRecord in storage. Used when expanding or collapsing
   * nodes.
   * @private
   * @param parentRecord Parent record
   * @param include Include (true) or exclude (false)
   * @category Tree
   */


  internalToggleTreeSubRecords(parentRecord, include) {
    const me = this,
          {
      storage
    } = me,
          index = storage.indexOf(parentRecord),
          children = me.doIncludeExclude(me.getChildren(parentRecord), include); // When expanded a parent node while being filtered, need to update the hidden flag of its children

    if (me.isFiltered && include && parentRecord.unfilteredChildren) {
      me.updateChildrenHiddenState(parentRecord);
    } // If we expanded a node which is yet to load children, the collected children
    // array will be empty, so do not broadcast any change event.
    // If we are collapsing a record which isn't visible (because parent is collapsed) we won't get an index,
    // which is fine since it is already removed from processedRecords


    if (children.length && index !== false) {
      // We must not react to change - we fire the events here with a flag
      // to tell responders that it's due to an expand or collapse.
      storage.suspendEvents();

      if (include) {
        storage.splice(index + 1, 0, ...children);
        const event = {
          action: 'add',
          isExpand: true,
          records: children,
          index: index + 1
        };
        me.trigger('add', event);
        me.trigger('change', event);
      } else {
        storage.splice(index + 1, children.length);
        const event = {
          action: 'remove',
          isCollapse: true,
          records: children,
          index: index + 1
        };
        me.trigger('remove', event);
        me.trigger('change', event);
      }

      storage.resumeEvents();
    }
  } // Updates the hidden flag of its children while store is filtered


  updateChildrenHiddenState(parentRecord) {
    var _parentRecord$unfilte;

    (_parentRecord$unfilte = parentRecord.unfilteredChildren) === null || _parentRecord$unfilte === void 0 ? void 0 : _parentRecord$unfilte.forEach(child => {
      child.instanceMeta(this.id).hidden = false;

      if (!child.isLeaf) {
        this.updateChildrenHiddenState(child);
      }
    });
  }

  doIncludeExclude(children, include, result = []) {
    const me = this,
          childCount = (children === null || children === void 0 ? void 0 : children.length) || 0;

    for (let i = 0; i < childCount; i++) {
      const child = children[i]; // Only consider child nodes who we own.
      // If we are a chained store, skip nodes that are not ours.

      if (!me.isChained || me.chainedFilterFn(child)) {
        const mapMeta = child.instanceMeta(me.id);

        if (include || !mapMeta.hidden) {
          // if including sub-records, add those who are not hidden by a collapsed sub parent
          result.push(child);
        }

        mapMeta.hidden = !include;

        if (child.isExpanded(me)) {
          me.doIncludeExclude(me.getChildren(child), include, result);
        }
      }
    }

    return result;
  }
  /**
   * Collapse an expanded record or expand a collapsed. Optionally forcing a certain state.
   * @param {String|Number|Core.data.Model} idOrRecord Record (the record itself) or id of a record to toggle
   * @param {Boolean} [collapse] Force collapse (true) or expand (false)
   * @returns {Promise}
   * @async
   * @category Tree
   */


  async toggleCollapse(idOrRecord, collapse) {
    const me = this,
          record = me.getById(idOrRecord),
          meta = record.instanceMeta(me);

    if (collapse === undefined) {
      collapse = !meta.collapsed;
    } // Reject if we're in the middle of loading children, or it's a leaf, or it's a no-op


    if (!meta.isLoadingChildren && !record.isLeaf && record.isExpanded(me) === collapse) {
      me.trigger('beforeToggleNode', {
        record,
        collapse
      });
      meta.collapsed = collapse;

      if (meta.collapsed) {
        me.onNodeCollapse(record);
        return true;
      } else {
        me.onNodeExpand(record);
        let success = true; // Children not yet loaded, ask store for them.
        // It will append them. Appending to a node which
        // is expanded will insert the children into the UI.

        if (!record.isLoaded) {
          meta.isLoadingChildren = true;

          try {
            await me.loadChildren(record);
          } catch (exception) {
            // Revert to being collapsed
            meta.collapsed = true;
            success = false;
            me.trigger('loadChildrenException', {
              record,
              exception
            });
          } finally {
            meta.isLoadingChildren = false;
          }
        }

        return success;
      }
    }
  }
  /**
   * Remove all records beneath parentRecord from storage.
   * @private
   * @param parentRecord Parent record
   * @category Tree
   */


  onNodeCollapse(parentRecord) {
    // We don't care about collapse if it's inside a collapsed subtree
    if (parentRecord.ancestorsExpanded(this)) {
      return this.internalToggleTreeSubRecords(parentRecord, false);
    }
  }
  /**
   * Add all records beneath parentRecord from storage.
   * @private
   * @param parentRecord Parent record
   * @category Tree
   */


  onNodeExpand(parentRecord) {
    // We don't care about expand if it's inside a collapsed subtree
    if (parentRecord.ancestorsExpanded(this)) {
      return this.internalToggleTreeSubRecords(parentRecord, true);
    }
  } //endregion
  //region Transform flat data

  /**
   * Transforms flat data containing parent ids into tree data
   * @param {Object[]} data Flat raw data
   * @returns {Object[]} Tree data
   * @private
   */


  transformToTree(data) {
    const {
      parentIdField,
      idField,
      childrenField
    } = this.modelClass,
          parents = new Map(),
          transformed = [];

    for (const node of data) {
      const parentId = node[parentIdField]; // Child, find parent

      if (parentId != null) {
        // Detected parents are kept in a map to no have to iterate to find them each time
        let parent = parents.get(parentId); // Parent not in map, find it and add it (also adds unmatched parents, to not search for
        // them again)

        if (parent === undefined) {
          var _data$find;

          parent = (_data$find = data.find(node => node[idField] === parentId)) !== null && _data$find !== void 0 ? _data$find : null;
          parents.set(parentId, parent);
        } // Parent found, add node as child of it


        if (parent) {
          if (!parent[childrenField]) {
            parent[childrenField] = [];
          }

          parent[childrenField].push(node);
        }
      } // Parent, keep
      else {
        transformed.push(node);
      }
    }

    return transformed;
  } //endregion


  treeifyFlatData(data) {
    const {
      childrenField,
      parentIdField
    } = this.modelClass;
    let hasParentId = false,
        shouldTransform = true; // Configured to transform flat data into tree data, make sure that we have:
    // - raw data without children defined
    // - parentIds

    for (const node of data) {
      if (node.isModel || node[childrenField]) {
        shouldTransform = false;
        break;
      }

      if (node[parentIdField] != null) {
        hasParentId = true;
      }
    }

    if (shouldTransform && hasParentId) {
      data = this.transformToTree(data);
    }

    return data;
  }

});

/***/ }),

/***/ "./lib/Core/data/mixin/TreeNode.js":
/*!*****************************************!*\
  !*** ./lib/Core/data/mixin/TreeNode.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';

/**
 * @module Core/data/mixin/TreeNode
 */

/**
 * Mixin for Model with tree node related functionality. This class is mixed into the {@link Core/data/Model} class.
 *
 * ## Adding and removing child nodes
 *
 * ```javascript
 * const parent = store.getById(1),
 *
 * firstBorn = parent.insertChild({
 *     name : 'Child node'
 * }, parent.children[0]); // Insert a child at a specific place in the children array
 *
 * parent.removeChild(parent.children[0]); // Removes a child node
 * parent.appendChild({ name : 'New child node' }); // Appends a child node
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class TreeNode extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'TreeNode';
  }
  /**
   * This static configuration option allows you to control whether an empty parent task should be converted into a
   * leaf. Enable/disable it for a whole class:
   *
   * ```javascript
   * Model.convertEmptyParentToLeaf = false;
   * ```
   *
   * By specifying `true`, all empty parents will be considered leafs. Can also be assigned a configuration object
   * with with the following Boolean properties to customize the behaviour:
   *
   * * `onLoad` - Apply the transformation on load to any parents without children (`children : []`)
   * * `onRemove` - Apply the transformation when all children have been removed from a parent
   *
   * ```javascript
   * Model.convertEmptyParentToLeaf = {
   *     onLoad   : false,
   *     onRemove : true
   * }
   * ```
   *
   * @property {Boolean|Object}
   * @default false
   * @category Parent & children
   */


  static set convertEmptyParentToLeaf(value) {
    if (value === true) {
      value = {
        onLoad: true,
        onRemove: true
      };
    } else if (value === false) {
      value = {
        onLoad: false,
        onRemove: false
      };
    }

    this._convertEmptyParentToLeaf = value;
  }

  static get convertEmptyParentToLeaf() {
    return this._convertEmptyParentToLeaf || {
      onLoad: false,
      onRemove: false
    };
  }
  /**
   * This is a read-only property providing access to the parent node.
   * @member {Core.data.Model} parent
   * @readonly
   * @category Parent & children
   */

  /**
   * This is a read-only field provided in server synchronization packets to specify
   * which record id is the parent of the record.
   * @readonly
   * @field {String|Number|null} parentId
   * @category Tree
   */

  /**
   * This is a read-only field provided in server synchronization packets to specify
   * which position the node takes in the parent's children array.
   * This index is set on load and gets updated automatically after row reordering, sorting, etc.
   * To save the order, need to persist the field on the server and when data is fetched to be loaded,
   * need to sort by this field.
   * @readonly
   * @field {Number} parentIndex
   * @category Tree
   */


  ingestChildren(childRecord, stores = this.stores) {
    const {
      inProcessChildren,
      constructor: MyClass
    } = this,
          store = stores[0];

    if (childRecord === true) {
      if (inProcessChildren) {
        return true;
      }

      return [];
    }

    if (childRecord) {
      if (!Array.isArray(childRecord)) {
        childRecord = [childRecord];
      }

      const len = childRecord.length,
            result = [];

      for (let i = 0, child; i < len; i++) {
        child = childRecord[i];
        child = child.isModel ? child : store ? store.createRecord(child) : new MyClass(child, null, null, true);
        child = store ? store.processRecord(child) : child;
        result.push(child);
      }

      if (this.children === true && store) {
        const sorter = store.createSorterFn(store.sorters);
        result.sort(sorter);
      }

      return result;
    }
  }
  /**
   * Child nodes. To allow loading children on demand, specify `children : true` in your data. Omit the field for leaf tasks.
   *
   * Note, if the tree store loads data from a remote origin, make sure {@link Core/data/AjaxStore#config-readUrl}
   * is specified, and optionally {@link Core/data/AjaxStore#config-parentIdParamName} is set, otherwise
   * {@link Core/data/Store#function-loadChildren} has to be implemented.
   *
   * @field {Boolean|Object[]|Core.data.Model[]} children
   * @category Parent & children
   */

  /**
   * Called during creation to also turn any children into Models joined to the same stores as this model
   * @internal
   * @category Parent & children
   */


  processChildren(stores = this.stores) {
    const me = this,
          {
      meta
    } = me;
    me.inProcessChildren = true;
    const children = me.ingestChildren(me.data[me.constructor.childrenField], stores);

    if (children) {
      const {
        convertEmptyParentToLeaf
      } = me.constructor,
            shouldConvert = convertEmptyParentToLeaf === true || convertEmptyParentToLeaf.onLoad;

      if (shouldConvert ? children.length : Array.isArray(children)) {
        meta.isLeaf = false; // We are processing a remote load

        if (me.children === true) {
          me.children = [];
        } else if (children.length === 0) {
          me.children = children;
          return;
        }

        me.appendChild(children, false, true);
      } // Flagged for load on demand
      else if (children === true) {
        meta.isLeaf = false;
        me.children = true;
      } // Empty child array, flag is leaf if configured to do so
      else if (!me.isRoot) {
        meta.isLeaf = me.constructor.convertEmptyParentToLeaf.onLoad;
      }
    }

    me.inProcessChildren = false;
  }
  /**
   * This method returns `true` if this record has all expanded ancestors and is therefore
   * eligible for inclusion in a UI.
   * @param {Core.data.Store} [store] Optional store, defaults to nodes first store
   * @returns {Boolean}
   * @readonly
   * @category Parent & children
   * @returns {Boolean}
   */


  ancestorsExpanded(store = this.firstStore) {
    const {
      parent
    } = this;
    return !parent || parent.isExpanded(store) && parent.ancestorsExpanded(store);
  }
  /**
   * Used by stores to assess the record's collapsed/expanded state in that store.
   * @param {Core.data.Store} store
   * @category Parent & children
   * @returns {Boolean}
   */


  isExpanded(store = this.firstStore) {
    const mapMeta = this.instanceMeta(store.id); // Default initial expanded/collapsed state when in the store
    // to the record's original expanded property.

    if (!Object.prototype.hasOwnProperty.call(mapMeta, 'collapsed')) {
      mapMeta.collapsed = !this.expanded;
    }

    return !mapMeta.collapsed;
  } // A read-only property. It provides the initial state upon load
  // The UI's expanded/collapsed state is in the store's meta map.


  get expanded() {
    return this.data.expanded;
  }
  /**
   * Depth in the tree at which this node exists. First visual level of nodes are at level 0, their direct children at
   * level 1 and so on.
   * @property {Number}
   * @readonly
   * @category Parent & children
   */


  get childLevel() {
    let node = this,
        ret = -1;

    while (node && !node.isRoot) {
      ++ret;
      node = node.parent;
    }

    return ret;
  }
  /**
   * Is a leaf node in a tree structure?
   * @property {Boolean}
   * @readonly
   * @category Parent & children
   */


  get isLeaf() {
    return this.meta.isLeaf !== false && !this.isRoot;
  }
  /**
   * Is a parent node in a tree structure?
   * @property {Boolean}
   * @readonly
   * @category Parent & children
   */


  get isParent() {
    return !this.isLeaf;
  }
  /**
   * Returns true for parent nodes with children loaded (there might still be no children)
   * @property {Boolean}
   * @readonly
   * @category Parent & children
   */


  get isLoaded() {
    return this.isParent && Array.isArray(this.children);
  }
  /**
   * Count all children (including sub-children) for a node (in its `firstStore´)
   * @member {Number}
   * @category Parent & children
   */


  get descendantCount() {
    return this.getDescendantCount();
  }
  /**
   * Count visible (expanded) children (including sub-children) for a node (in its `firstStore`)
   * @member {Number}
   * @category Parent & children
   */


  get visibleDescendantCount() {
    return this.getDescendantCount(true);
  }
  /**
   * Count visible (expanded)/all children for this node, optionally specifying for which store.
   * @param {Boolean} [onlyVisible] Specify `true` to only count visible (expanded) children.
   * @param {Core.data.Store} [store] A Store to which this node belongs
   * @returns {Number}
   * @category Parent & children
   */


  getDescendantCount(onlyVisible = false, store = this.firstStore) {
    const children = this.children;

    if (!children || !Array.isArray(children) || onlyVisible && !this.isExpanded(store)) {
      return 0;
    }

    return children.reduce((count, child) => count + child.getDescendantCount(onlyVisible), children.length);
  }
  /**
   * Retrieve all children (by traversing sub nodes)
   * @property {Core.data.Model[]}
   * @category Parent & children
   */


  get allChildren() {
    const children = this.children;
    if (!children) return [];
    return children.reduce((all, child) => {
      all.push(child); // push.apply is faster than push with array spread:
      // https://jsperf.com/push-apply-vs-push-with-array-spread/1

      all.push.apply(all, child.allChildren);
      return all;
    }, []);
  }
  /**
   * Get the first child of this node
   * @property {Core.data.Model}
   * @readonly
   * @category Parent & children
   */


  get firstChild() {
    const children = this.children;
    return (children === null || children === void 0 ? void 0 : children.length) && children[0] || null;
  }
  /**
   * Get the last child of this node
   * @property {Core.data.Model}
   * @readonly
   * @category Parent & children
   */


  get lastChild() {
    const children = this.children;
    return (children === null || children === void 0 ? void 0 : children.length) && children[children.length - 1] || null;
  }
  /**
   * Returns count of all preceding sibling nodes (including their children).
   * @property {Number}
   * @category Parent & children
   */


  get previousSiblingsTotalCount() {
    let task = this.previousSibling,
        count = this.parentIndex;

    while (task) {
      count += task.descendantCount;
      task = task.previousSibling;
    }

    return count;
  }

  get root() {
    var _this$parent;

    return ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.root) || this;
  }
  /**
   * Reading this property returns the id of the parent node, if this record is a child of a node.
   *
   * Setting this property appends this record to the record with the passed
   * id **in the same store that this record is already in**.
   *
   * Note that setting this property is **only valid if this record is already
   * part of a tree store**.
   *
   * This is not intended for general use. This is for when a server responds to a record
   * mutation and the server decides to move a record to a new parent. If a `parentId` property
   * is passed in the response data for a record, that record will be moved.
   * @property {Number|String|null}
   * @category Parent & children
   */


  get parentId() {
    return this.parent && !this.parent.isAutoRoot ? this.parent.id : null;
  }

  set parentId(parentId) {
    const me = this,
          {
      parent
    } = me,
          newParent = parentId && me.firstStore.getById(parentId); // Handle exact equality of parent.
    // Also handle one being null and the other being undefined meaning no change.

    if (!(newParent === parent || !parent && !newParent)) {
      // If we are batching, we do not trigger a change immediately.
      // endBatch will set the field which will set the property again.
      if (me.isBatchUpdating) {
        me.meta.batchChanges.parentId = parentId;
      } else {
        if (newParent) {
          newParent.appendChild(me);
        } else {
          me.parent.removeChild(me);
        }
      }
    }
  }

  static set parentIdField(parentIdField) {
    // Maintainer: the "this" references in here reference two different contexts.
    // Outside of the property definition, it's the Model Class.
    // In the getter and setter, it's the record instance.
    this._parentIdField = parentIdField;
    Object.defineProperty(this.prototype, parentIdField, {
      set: function (parentId) {
        // no arrow functions here, need `this` to change to instance
        // noinspection JSPotentiallyInvalidUsageOfClassThis
        this.parentId = parentId;
      },
      get: function () {
        // no arrow functions here, need `this` to change to instance
        // noinspection JSPotentiallyInvalidUsageOfClassThis
        return this.parentId;
      }
    });
  }

  static get parentIdField() {
    return this._parentIdField || 'parentId';
  }
  /**
   * Traverses all child nodes recursively calling the passed function
   * on a target node **before** iterating the child nodes.
   * @param {Function} fn The function to call
   * @param {Boolean} [skipSelf=false] True to ignore self
   * @param {Boolean} [includeFilteredOutRecords=false] True to also traverse filtered out records
   * @category Parent & children
   */


  traverse(fn, skipSelf = false, includeFilteredOutRecords = false) {
    const children = (includeFilteredOutRecords ? this.unfilteredChildren : this.children) || this.children;

    if (!skipSelf) {
      fn.call(this, this);
    } // Simply testing whether there is non-zero children length
    // is 10x faster than using this.isLoaded


    for (let i = 0, l = children === null || children === void 0 ? void 0 : children.length; i < l; i++) {
      children[i].traverse(fn, false, includeFilteredOutRecords);
    }
  }
  /**
   * Traverses all child nodes recursively calling the passed function
   * on child nodes of a target **before** calling it it on the node.
   * @param {Function} fn
   * @param {Boolean} [skipSelf] True to skip this node in the traversal
   * @param {Boolean} [includeFilteredOutRecords=false] True to also traverse filtered out records
   * @category Parent & children
   */


  traverseBefore(fn, skipSelf = false, includeFilteredOutRecords = false) {
    const children = (includeFilteredOutRecords ? this.unfilteredChildren : this.children) || this.children; // Simply testing whether there is non-zero children length
    // is 10x faster than using this.isLoaded

    for (let i = 0, l = children === null || children === void 0 ? void 0 : children.length; i < l; i++) {
      children[i].traverse(fn, false, includeFilteredOutRecords);
    }

    if (!skipSelf) {
      fn.call(this, this);
    }
  }
  /**
   * Traverses child nodes recursively while fn returns true
   * @param {Function} fn
   * @param {Boolean} [skipSelf] True to skip this node in the traversal
   * @param {Boolean} [includeFilteredOutRecords=false] True to also traverse filtered out records
   * @category Parent & children
   * @returns {Boolean}
   */


  traverseWhile(fn, skipSelf = false, includeFilteredOutRecords = false) {
    const me = this;
    let goOn = true;

    if (!skipSelf) {
      goOn = fn.call(me, me) !== false;
    }

    if (goOn && me.isLoaded) {
      const children = (includeFilteredOutRecords ? me.unfilteredChildren : me.children) || this.children;
      goOn = children.every(child => child.traverseWhile(fn, false, includeFilteredOutRecords));
    }

    return goOn;
  }
  /**
   * Bubbles up from this node, calling the specified function with each node.
   *
   * @param {Function} fn The function to call for each node
   * @param {Boolean} [skipSelf] True to skip this node in the traversal
   * @category Parent & children
   */


  bubble(fn, skipSelf = false) {
    let me = this;

    if (!skipSelf) {
      fn.call(me, me);
    }

    while (me.parent) {
      me = me.parent;
      fn.call(me, me);
    }
  }
  /**
   * Bubbles up from this node, calling the specified function with each node,
   * while the function returns true.
   *
   * @param {Function} fn The function to call for each node
   * @param {Boolean} [skipSelf] True to skip this node in the traversal
   * @category Parent & children
   * @return {Boolean}
   */


  bubbleWhile(fn, skipSelf = false) {
    let me = this,
        goOn = true;

    if (!skipSelf) {
      goOn = fn.call(me, me);
    }

    while (goOn && me.parent) {
      me = me.parent;
      goOn = fn.call(me, me);
    }

    return goOn;
  }
  /**
   * Checks if this model contain another model as one of it's descendants
   *
   * @param {Core.data.Model|String|Number} childOrId child node or id
   * @category Parent & children
   * @returns {Boolean}
   */


  contains(childOrId) {
    if (childOrId && typeof childOrId === 'object') {
      childOrId = childOrId.id;
    }

    return !this.traverseWhile(node => node.id != childOrId);
  }

  getTopParent(all) {
    let result;

    if (all) {
      result = [];
      this.bubbleWhile(t => {
        result.push(t);
        return t.parent && !t.parent.isRoot;
      });
    } else {
      result = null;
      this.bubbleWhile(t => {
        if (!t.parent) {
          result = t;
        }

        return t.parent && !t.parent.isRoot;
      });
    }

    return result;
  }
  /**
   * Append a child record(s) to any current children.
   * @param {Core.data.Model|Core.data.Model[]|Object|Object[]} childRecord Array of records/data or a single
   * record/data to append
   * @param {Boolean} [silent] Pass `true` to not trigger events during append
   * @returns {Core.data.Model|Core.data.Model[]|null}
   * @category Parent & children
   */


  appendChild(childRecord, silent = false) {
    return this.insertChild(childRecord, null, silent);
  }
  /**
   * Insert a child record(s) before an existing child record.
   * @param {Core.data.Model|Core.data.Model[]|Object|Object[]} childRecord Array of records/data or a single
   * record/data to insert
   * @param {Core.data.Model} [before] Optional record to insert before, leave out to append to the end
   * @param {Boolean} [silent] Pass `true` to not trigger events during append
   * @returns {Core.data.Model|Core.data.Model[]|null}
   * @category Parent & children
   */


  insertChild(childRecord, before = null, silent = false) {
    var _ref, _before$parentIndex, _before, _me$children, _me$beforeInsertChild, _me$afterInsertChild;

    // Handle deprecated signature
    if (typeof childRecord === 'number') {
      const index = childRecord;
      childRecord = before;
      before = this.children[index];
    }

    const me = this,
          wasLeaf = me.isLeaf,
          returnArray = Array.isArray(childRecord);
    if (!Array.isArray(childRecord)) childRecord = [childRecord];

    if (!silent) {
      if (!me.stores.every(s => s.trigger('beforeAdd', {
        records: childRecord,
        parent: me
      }) !== false)) {
        return null;
      }
    } // This call makes child record an array containing Models


    childRecord = me.ingestChildren(childRecord); // NOTE: see comment in Model::set() about before/in/after calls approach.

    const index = (_ref = (_before$parentIndex = (_before = before) === null || _before === void 0 ? void 0 : _before.parentIndex) !== null && _before$parentIndex !== void 0 ? _before$parentIndex : (_me$children = me.children) === null || _me$children === void 0 ? void 0 : _me$children.length) !== null && _ref !== void 0 ? _ref : 0,
          preResult = (_me$beforeInsertChild = me.beforeInsertChild) === null || _me$beforeInsertChild === void 0 ? void 0 : _me$beforeInsertChild.call(me, childRecord),
          inserted = me.internalAppendInsert(childRecord, before, silent); // Turn into a parent if not already one

    if (wasLeaf && inserted.length) {
      me.meta.isLeaf = false;
    } // If we've transitioned to being a branch node, signal a change event
    // so that the UI updates.
    // Not if it's due to root node loading. StoreTree#onNodeAddChild
    // for the rootNode will fire a store refresh.


    if (me.isLeaf !== wasLeaf && !me.root.isLoading && !silent) {
      me.stores.forEach(s => {
        const changes = {
          isLeaf: {
            value: false,
            oldValue: true
          }
        };
        s.trigger('update', {
          record: me,
          changes
        });
        s.trigger('change', {
          action: 'update',
          record: me,
          changes
        });
      });
    }

    (_me$afterInsertChild = me.afterInsertChild) === null || _me$afterInsertChild === void 0 ? void 0 : _me$afterInsertChild.call(me, index, childRecord, preResult, inserted);
    return returnArray || !inserted ? inserted : inserted[0];
  }

  tryInsertChild() {
    return this.insertChild(...arguments);
  }

  internalAppendInsert(recordsToInsert, beforeRecord, silent) {
    const me = this,
          {
      stores,
      root
    } = me,
          {
      firstStore: rootStore
    } = root,
          {
      parentIdField
    } = me.constructor,
          parentId = me.isAutoRoot ? null : me.id,
          isMove = {};
    let isNoop, start, i, newRecordsCloned; // The reference node must be one of our children. If not, fall back to an append.

    if (beforeRecord && beforeRecord.parent !== me) {
      beforeRecord = null;
    } // If the records starting at insertAt or (insertAt - 1), are the same sequence
    // that we are being asked to add, this is a no-op.


    if (me.children) {
      const children = me.children,
            insertAt = beforeRecord ? beforeRecord.parentIndex : children.length;

      if (children[start = insertAt] === recordsToInsert[0] || children[start = insertAt - 1] === recordsToInsert[0]) {
        for (isNoop = true, i = 0; isNoop && i < recordsToInsert.length; i++) {
          if (recordsToInsert[i] !== children[start + i]) {
            isNoop = false;
          }
        }
      }
    } // Fulfill the contract of appendChild/insertChild even if we did not have to do anything.
    // Callers must be able to correctly postprocess the returned value as an array.


    if (isNoop) {
      return recordsToInsert;
    } // Remove incoming child nodes from any current parent.


    for (i = 0; i < recordsToInsert.length; i++) {
      const newRecord = recordsToInsert[i],
            oldParent = newRecord.parent; // Store added should not be modified for adds
      // caused by moving.

      isMove[newRecord.id] = newRecord.root === root; // Check if any descendants of the added node are moves.

      if (rootStore && !root.isLoading) {
        newRecord.traverse(r => {
          if (r.root === root) {
            isMove[r.id] = true;
          }
        });
      } // If the new record has a parent, remove from that parent.
      // This operation may be vetoed by listeners.
      // If it is vetoed, then remove from the newRecords and do not
      // set the parent property


      if ((oldParent === null || oldParent === void 0 ? void 0 : oldParent.removeChild(newRecord, isMove[newRecord.id], silent)) === false) {
        if (!newRecordsCloned) {
          recordsToInsert = recordsToInsert.slice();
          newRecordsCloned = true;
        }

        recordsToInsert.splice(i--, 1);
      } else {
        newRecord.parent = me; // Set parentId directly to data, record.parentId uses a getter to return record.parent.id

        newRecord.data[parentIdField] = parentId;

        if (oldParent) {
          newRecord.meta.oldParentId = oldParent.id;
        }
      }
    } // Still records to insert after beforeRemove listeners may have vetoed some


    if (recordsToInsert.length) {
      if (!Array.isArray(me.children)) {
        me.children = [];
      } // Add to the children


      const insertAt = me.addToChildren(me.children, beforeRecord, recordsToInsert); // When filter is used add to the unfiltered children

      me.addToChildren(me.unfilteredChildren, beforeRecord, recordsToInsert, true);
      stores.forEach(store => {
        if (!store.isChained) {
          recordsToInsert.forEach(record => {
            // Initialize context for newly added records
            record.joinStore(store);
          }); // Add to store (will also add any child records and trigger events)

          store.onNodeAddChild(me, recordsToInsert, insertAt, isMove, silent);
          recordsToInsert.forEach(record => {
            // If we are in the recursive inclusion of children at construction
            // time, or in a store load, that must not be a data modification.
            // Otherwise, we have to signal a change
            if (record.meta.oldParentId != null && !(me.inProcessChildren || me.isLoading)) {
              const toSet = {
                [parentIdField]: parentId,
                [me.getDataSource('parentIndex')]: record.parentIndex
              },
                    wasSet = {},
                    {
                modified,
                oldParentId
              } = record.meta,
                    oldParentIndex = modified.parentIndex;
              delete record.meta.oldParentId;

              if (me.id !== oldParentId) {
                wasSet[parentIdField] = {
                  value: parentId,
                  oldValue: oldParentId
                };
              }

              if (record.parentIndex !== oldParentIndex) {
                wasSet.parentIndex = {
                  value: record.parentIndex,
                  oldValue: oldParentIndex
                };
              } // Changing back to its original value


              if (modified[parentIdField] === me.id) {
                Reflect.deleteProperty(modified, parentIdField);
              } // Cache its original value
              else if (!(parentIdField in modified)) {
                modified[parentIdField] = oldParentId;
              }

              record.afterChange(toSet, wasSet);
            }
          });
        }
      });
    }

    return recordsToInsert;
  }
  /**
   * Remove a child record. Only direct children of this node can be removed, others are ignored.
   * @param {Core.data.Model|Core.data.Model[]} childRecords The record(s) to remove.
   * @param {Boolean} [isMove] Pass `true` if the record is being moved within the same store.
   * @param {Boolean} [silent] Pass `true` to not trigger events during remove.
   * @category Parent & children
   */


  removeChild(childRecords, isMove = false, silent = false) {
    var _me$afterRemoveChild;

    const me = this,
          wasLeaf = me.isLeaf,
          {
      children,
      stores
    } = me;

    if (!Array.isArray(childRecords)) {
      childRecords = [childRecords];
    }

    childRecords = childRecords.filter(r => r.parent === me);

    if (!silent) {
      // Allow store listeners to veto the beforeRemove event
      for (const store of stores) {
        if (!store.isChained) {
          if (store.trigger('beforeRemove', {
            parent: me,
            records: childRecords,
            isMove
          }) === false) {
            return false;
          }
        }
      }
    }

    const preResult = me.beforeRemoveChild ? me.beforeRemoveChild(childRecords, isMove) : undefined;

    for (const childRecord of childRecords) {
      const {
        parentIdField
      } = childRecord.constructor,
            {
        modified
      } = childRecord.meta,
            oldParentId = childRecord.parent ? childRecord.parent.id : null; // Cache its original value

      if (!(parentIdField in modified)) {
        modified[parentIdField] = oldParentId;
      }

      const index = me.removeFromChildren(children, childRecord);
      me.removeFromChildren(me.unfilteredChildren, childRecord, true);
      stores.forEach(store => {
        if (!store.isChained) {
          store.onNodeRemoveChild(me, [childRecord], index, {
            isMove,
            silent
          });
        }
      }); // No need to clean up the node parent info and other meta data in case it is "move" operation. The info will be updated after "insert" operation.

      if (!isMove) {
        childRecord.parent = childRecord.parentIndex = childRecord.unfilteredIndex = childRecord.nextSibling = childRecord.previousSibling = null; // Reset parentId in data, record.parentId uses a getter to return record.parent.id

        childRecord.data[parentIdField] = null;
      }
    } // Convert emptied parent into leaf if configured to do so


    if ((me.unfilteredChildren || children).length === 0 && me.constructor.convertEmptyParentToLeaf.onRemove && !me.isRoot) {
      me.meta.isLeaf = true;
    } // If we've transitioned to being a leaf node, signal a change event
    // so that the UI updates


    if (me.isLeaf !== wasLeaf && !silent) {
      me.stores.forEach(s => {
        const changes = {
          isLeaf: {
            value: true,
            oldValue: false
          }
        };
        s.trigger('update', {
          record: me,
          changes
        });
        s.trigger('change', {
          action: 'update',
          record: me,
          changes
        });
      });
    }

    (_me$afterRemoveChild = me.afterRemoveChild) === null || _me$afterRemoveChild === void 0 ? void 0 : _me$afterRemoveChild.call(me, childRecords, preResult, isMove);
  }

  clearParentId() {
    const me = this;
    Reflect.deleteProperty(me.data, me.parentIdField);
    Reflect.deleteProperty(me.originalData, me.parentIdField);

    if (me.meta.modified) {
      Reflect.deleteProperty(me.meta.modified, me.parentIdField);
    }
  }
  /**
   * Replaces all child nodes with the new node set.
   * @param {Core.data.Model|Core.data.Model[]} childRecords The new child record set.
   * @returns {Core.data.Model[]}
   */


  replaceChildren(newChildren) {
    this.clearChildren();
    this.data[this.constructor.childrenField] = newChildren;
    this.processChildren();
    return this.children;
  }
  /**
   * Removes all child nodes from this node.
   * @param {Boolean} [silent=false] Pass `true` to not fire Store events during the remove.
   * @returns {Core.data.Model[]}
   */


  clearChildren(silent = false) {
    const me = this,
          {
      stores
    } = me,
          children = me.unfilteredChildren || me.children;
    me.children = [];

    if (children && children !== true) {
      stores.forEach(store => {
        if (!store.isChained) {
          // unfiltered:true to unregister children on filtered stores
          store.onNodeRemoveChild(me, children, 0, {
            unfiltered: true,
            silent
          });
        }
      }); // clear unfilteredChildren (must be after the above loop)

      if (me.unfilteredChildren) {
        me.unfilteredChildren = [];
      }
    }
  }
  /**
   * Removes all records from the rootNode
   * @private
   */


  clear() {
    var _me$children2;

    const me = this,
          {
      stores
    } = me,
          children = (_me$children2 = me.children) === null || _me$children2 === void 0 ? void 0 : _me$children2.slice(); // Only allow for root node and if data is present

    if (!me.isRoot || !children) {
      return;
    }

    for (const store of stores) {
      if (!store.isChained) {
        if (store.trigger('beforeRemove', {
          parent: me,
          records: children,
          isMove: false,
          removingAll: true
        }) === false) {
          return false;
        }
      }
    }

    me.children.length = 0;

    if (me.unfilteredChildren) {
      me.unfilteredChildren.length = 0;
    }

    stores.forEach(store => {
      children.forEach(child => {
        if (child.stores.includes(store)) {
          // this will drill down the child, unregistering whole branch
          child.unjoinStore(store);
        }

        child.parent = child.parentIndex = child.nextSibling = child.previousSibling = null;
      });
      store.storage.suspendEvents();
      store.storage.clear();
      store.storage.resumeEvents();
      store.added.clear();
      store.modified.clear();
      store.trigger('removeAll');
      store.trigger('change', {
        action: 'removeall'
      });
    });
  }

  updateChildrenIndices(children, unfiltered = false, silent = false) {
    const indexName = unfiltered ? 'unfilteredIndex' : 'parentIndex';
    let previousSibling = null;

    for (let i = 0; i < children.length; i++) {
      const child = children[i],
            oldValue = child[indexName];

      if (indexName === 'parentIndex') {
        // Record should not be considered modified by initial assignment of parentIndex
        if (oldValue === undefined || silent) {
          child.setData('parentIndex', i);
        } // Check to avoid pointless beforeUpdates from inSet
        else if (oldValue !== i) {
          // Silent set, do not want to trigger events from updated indices
          child.set('parentIndex', i, true);
        }
      } else {
        child[indexName] = i;
      }

      if (!unfiltered) {
        child.previousSibling = previousSibling;

        if (previousSibling) {
          previousSibling.nextSibling = child;
        } // Last child never has a nextSibling


        if (i === children.length - 1) {
          child.nextSibling = null;
        }

        previousSibling = child;
      }
    }
  }

  addToChildren(children, beforeRecord, newRecords, unfiltered = false) {
    if (children) {
      const indexName = unfiltered ? 'unfilteredIndex' : 'parentIndex',
            index = beforeRecord ? beforeRecord[indexName] : children.length;
      children.splice(index, 0, ...newRecords);
      this.updateChildrenIndices(children, unfiltered);
      return index;
    }
  }

  removeFromChildren(children, childRecord, unfiltered = false) {
    if (children) {
      const indexName = unfiltered ? 'unfilteredIndex' : 'parentIndex',
            index = childRecord[indexName];

      if (index > -1) {
        children.splice(index, 1);
        this.updateChildrenIndices(children, unfiltered);
      }

      return index;
    }
  }

});

/***/ }),

/***/ "./lib/Core/data/stm/Helpers.js":
/*!**************************************!*\
  !*** ./lib/Core/data/stm/Helpers.js ***!
  \**************************************/
/*! exports provided: resetQueue */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetQueue", function() { return resetQueue; });
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Props.js */ "./lib/Core/data/stm/Props.js");
var productName = 'taskboard';

const resetQueue = (stm, options) => {
  const {
    undo,
    redo
  } = options;
  let newProps;

  if (undo && !redo) {
    newProps = {
      [_Props_js__WEBPACK_IMPORTED_MODULE_0__["QUEUE_PROP"]]: stm[_Props_js__WEBPACK_IMPORTED_MODULE_0__["QUEUE_PROP"]].slice(stm.position),
      [_Props_js__WEBPACK_IMPORTED_MODULE_0__["POS_PROP"]]: 0
    };
  } else if (redo && !undo) {
    newProps = {
      [_Props_js__WEBPACK_IMPORTED_MODULE_0__["QUEUE_PROP"]]: stm[_Props_js__WEBPACK_IMPORTED_MODULE_0__["QUEUE_PROP"]].slice(0, stm.position)
    };
  } else {
    newProps = {
      [_Props_js__WEBPACK_IMPORTED_MODULE_0__["QUEUE_PROP"]]: [],
      [_Props_js__WEBPACK_IMPORTED_MODULE_0__["POS_PROP"]]: 0
    };
  }

  ;
  return [newProps, () => {
    stm.notifyStoresAboutQueueReset(options);
  }];
};

/***/ }),

/***/ "./lib/Core/data/stm/Props.js":
/*!************************************!*\
  !*** ./lib/Core/data/stm/Props.js ***!
  \************************************/
/*! exports provided: STATE_PROP, STORES_PROP, QUEUE_PROP, POS_PROP, TRANSACTION_PROP, TRANSACTION_TIMER_PROP, AUTO_RECORD_PROP, PROPS */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATE_PROP", function() { return STATE_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORES_PROP", function() { return STORES_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QUEUE_PROP", function() { return QUEUE_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POS_PROP", function() { return POS_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSACTION_PROP", function() { return TRANSACTION_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSACTION_TIMER_PROP", function() { return TRANSACTION_TIMER_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTO_RECORD_PROP", function() { return AUTO_RECORD_PROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROPS", function() { return PROPS; });
var productName = 'taskboard';
/**
* @module Core/data/stm/Props.js
* @internal
*/

const STATE_PROP = Symbol('STATE_PROP');
const STORES_PROP = Symbol('STORES_PROP');
const QUEUE_PROP = Symbol('QUEUE_PROP');
const POS_PROP = Symbol('POS_PROP');
const TRANSACTION_PROP = Symbol('TRANSACTION_PROP');
const TRANSACTION_TIMER_PROP = Symbol('TRANSACTION_TIMER_PROP');
const AUTO_RECORD_PROP = Symbol('AUTO_RECORD_PROP');
const PROPS = Object.freeze([STATE_PROP, STORES_PROP, QUEUE_PROP, POS_PROP, TRANSACTION_PROP, TRANSACTION_TIMER_PROP, AUTO_RECORD_PROP]);

/***/ }),

/***/ "./lib/Core/data/stm/StateTrackingManager.js":
/*!***************************************************!*\
  !*** ./lib/Core/data/stm/StateTrackingManager.js ***!
  \***************************************************/
/*! exports provided: makeModelUpdateAction, makeModelInsertChildAction, makeModelRemoveChildAction, makeStoreModelAddAction, makeStoreModelInsertAction, makeStoreModelRemoveAction, makeStoreRemoveAllAction, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeModelUpdateAction", function() { return makeModelUpdateAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeModelInsertChildAction", function() { return makeModelInsertChildAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeModelRemoveChildAction", function() { return makeModelRemoveChildAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStoreModelAddAction", function() { return makeStoreModelAddAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStoreModelInsertAction", function() { return makeStoreModelInsertAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStoreModelRemoveAction", function() { return makeStoreModelRemoveAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStoreRemoveAllAction", function() { return makeStoreRemoveAllAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StateTrackingManager; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _state_StateBase_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./state/StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _state_DisabledState_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./state/DisabledState.js */ "./lib/Core/data/stm/state/DisabledState.js");
/* harmony import */ var _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./state/ReadyState.js */ "./lib/Core/data/stm/state/ReadyState.js");
/* harmony import */ var _state_RecordingState_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./state/RecordingState.js */ "./lib/Core/data/stm/state/RecordingState.js");
/* harmony import */ var _state_RestoringState_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./state/RestoringState.js */ "./lib/Core/data/stm/state/RestoringState.js");
/* harmony import */ var _state_AutoReadyState_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./state/AutoReadyState.js */ "./lib/Core/data/stm/state/AutoReadyState.js");
/* harmony import */ var _state_AutoRecordingState_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./state/AutoRecordingState.js */ "./lib/Core/data/stm/state/AutoRecordingState.js");
/* harmony import */ var _state_Registry_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./state/Registry.js */ "./lib/Core/data/stm/state/Registry.js");
/* harmony import */ var _action_UpdateAction_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./action/UpdateAction.js */ "./lib/Core/data/stm/action/UpdateAction.js");
/* harmony import */ var _action_InsertChildAction_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./action/InsertChildAction.js */ "./lib/Core/data/stm/action/InsertChildAction.js");
/* harmony import */ var _action_RemoveChildAction_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./action/RemoveChildAction.js */ "./lib/Core/data/stm/action/RemoveChildAction.js");
/* harmony import */ var _action_AddAction_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./action/AddAction.js */ "./lib/Core/data/stm/action/AddAction.js");
/* harmony import */ var _action_InsertAction_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./action/InsertAction.js */ "./lib/Core/data/stm/action/InsertAction.js");
/* harmony import */ var _action_RemoveAction_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./action/RemoveAction.js */ "./lib/Core/data/stm/action/RemoveAction.js");
/* harmony import */ var _action_RemoveAllAction_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./action/RemoveAllAction.js */ "./lib/Core/data/stm/action/RemoveAllAction.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./Props.js */ "./lib/Core/data/stm/Props.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/StateTrackingManager
*/



















const makeModelUpdateAction = (model, newData, oldData) => {
  return new _action_UpdateAction_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
    model,
    newData,
    oldData
  });
};
const makeModelInsertChildAction = (parentModel, insertIndex, childModels, context) => {
  return new _action_InsertChildAction_js__WEBPACK_IMPORTED_MODULE_11__["default"]({
    parentModel,
    childModels,
    insertIndex,
    context
  });
};
const makeModelRemoveChildAction = (parentModel, childModels, context) => {
  return new _action_RemoveChildAction_js__WEBPACK_IMPORTED_MODULE_12__["default"]({
    parentModel,
    childModels,
    context
  });
};
const makeStoreModelAddAction = (store, modelList, silent) => {
  return new _action_AddAction_js__WEBPACK_IMPORTED_MODULE_13__["default"]({
    store,
    modelList,
    silent
  });
};
const makeStoreModelInsertAction = (store, insertIndex, modelList, context, silent) => {
  return new _action_InsertAction_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
    store,
    insertIndex,
    modelList,
    context,
    silent
  });
};
const makeStoreModelRemoveAction = (store, modelList, context, silent) => {
  return new _action_RemoveAction_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
    store,
    modelList,
    context,
    silent
  });
};
const makeStoreRemoveAllAction = (store, allRecords, silent) => {
  return new _action_RemoveAllAction_js__WEBPACK_IMPORTED_MODULE_16__["default"]({
    store,
    allRecords,
    silent
  });
};

const stateTransition = (stm, event, ...args) => {
  const oldState = stm.state,
        newState = event.call(stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]], stm, ...args);

  if (typeof newState === 'string') {
    stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_9__["default"].resolveStmState(newState);
  } else if (newState instanceof _state_StateBase_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
    stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]] = newState;
  } else if (Array.isArray(newState)) {
    const [state, next] = newState;

    if (typeof state === 'string') {
      stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_9__["default"].resolveStmState(state);
    } else if (state instanceof _state_StateBase_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
      stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]] = state;
    } else if (state && typeof state === 'object') {
      stm = Object.assign(stm, state);
      stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_9__["default"].resolveStmState(stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]]);
    }

    if (typeof next === 'function') {
      stateTransition(stm, next, ...args);
    }
  } else if (newState && typeof newState === 'object') {
    stm = Object.assign(stm, newState);
    stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_9__["default"].resolveStmState(stm[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]]);
  }

  if (oldState !== _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_4__["default"] && oldState !== _state_AutoReadyState_js__WEBPACK_IMPORTED_MODULE_7__["default"] && newState !== _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_4__["default"] && newState !== _state_AutoReadyState_js__WEBPACK_IMPORTED_MODULE_7__["default"]) {
    stm.trigger('ready');
  }
};
/**
 * Tracks the state of every store registered via {@link #function-addStore}. It is {@link #config-disabled} by default
 * so remember to call {@link #function-enable} when your stores are registered and initial dataset is loaded.
 * Use {@link #function-undo} / {@link #function-redo} method calls to restore state to a particular
 * point in time
 *
 * ```javascript
 * stm = new StateTrackingManager({
 *     autoRecord : true,
 *     listeners  : {
 *        'recordingstop' : () => {
 *            // your custom code to update undo/redo GUI controls
 *            updateUndoRedoControls();
 *        },
 *        'restoringstop' : ({ stm }) => {
 *            // your custom code to update undo/redo GUI controls
 *            updateUndoRedoControls();
 *        }
 *    },
 *    getTransactionTitle : (transaction) => {
 *        // your custom code to analyze the transaction and return custom transaction title
 *        const lastAction = transaction.queue[transaction.queue.length - 1];
 *
 *        if (lastAction instanceof AddAction) {
 *            let title = 'Add new record';
 *        }
 *
 *        return title;
 *    }
 * });
 *
 * stm.addStore(userStore);
 * stm.addStore(companyStore);
 * stm.addStore(otherStore);
 *
 * stm.enable();
 * ```
 *
 * **Note:** STM currently does not support undoing server side added and saved records.
 * Therefore it's recommended to {@link #function-resetQueue reset the queue}
 * each time a tracked store(s) loads from or saves its changes to the server.
 * If Crud Manager is used it can be done like this:
 * ```javascript
 * crudManager.on({
 *     requestDone() {
 *         stm.resetQueue();
 *     }
 * });
 * ```
 * and in case individual stores are used:
 * ```javascript
 * ajaxStore.on({
 *     afterRequest({ exception }) {
 *         if (!exception) {
 *             stm.resetQueue();
 *         }
 *     }
 * });
 * ```
 *
 * @mixes Core/mixin/Events
 * @extends Core/Base
 */


class StateTrackingManager extends Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get defaultConfig() {
    return {
      /**
       * Default manager disabled state
       *
       * @config {Boolean}
       * @default
       */
      disabled: true,

      /**
       * Whether to start transaction recording automatically in case the Manager is enabled.
       *
       * In the auto recording mode, the manager waits for the first change in any store being managed and starts a transaction, i.e.
       * records any changes in its monitored stores. The transaction lasts for {@link #config-autoRecordTransactionStopTimeout} and
       * afterwards creates one undo/redo step, including all changes in the stores during that period of time.
       *
       * In non auto recording mode you have to call {@link #function-startTransaction} / {@link #function-stopTransaction} to start and end
       * a transaction.
       *
       * @config {Boolean}
       * @default
       */
      autoRecord: false,

      /**
       * The transaction duration (in ms) for the auto recording mode {@link #config-autoRecord}
       *
       * @config {Number}
       * @default
       */
      autoRecordTransactionStopTimeout: 100,

      /**
       * Store model update action factory
       *
       * @config {Function}
       * @default
       * @private
       */
      makeModelUpdateAction: makeModelUpdateAction,

      /**
       * Store insert child model action factory.
       *
       * @config {Function}
       * @default
       * @private
       */
      makeModelInsertChildAction: makeModelInsertChildAction,

      /**
       * Store remove child model action factory.
       *
       * @config {Function}
       * @default
       * @private
       */
      makeModelRemoveChildAction: makeModelRemoveChildAction,

      /**
       * Store add model action factory.
       *
       * @config {Function}
       * @default
       * @private
       */
      makeStoreModelAddAction: makeStoreModelAddAction,

      /**
       * Store insert model action factory.
       *
       * @config {Function}
       * @default
       * @private
       */
      makeStoreModelInsertAction: makeStoreModelInsertAction,

      /**
       * Store remove model action factory.
       *
       * @config {Function}
       * @default
       * @private
       */
      makeStoreModelRemoveAction: makeStoreModelRemoveAction,

      /**
       * Store remove all models action factory.
       *
       * @config {Function}
       * @default
       * @private
       */
      makeStoreRemoveAllAction: makeStoreRemoveAllAction,

      /**
       * Function to create a transaction title if none is provided.
       *
       * The function receives a transaction and should return a title.
       *
       * @config {Function}
       * @default
       */
      getTransactionTitle: null
    };
  }

  construct(...args) {
    const me = this;
    Object.assign(me, {
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]]: _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_4__["default"],
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]]: [],
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["QUEUE_PROP"]]: [],
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["POS_PROP"]]: 0,
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["TRANSACTION_PROP"]]: null,
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["TRANSACTION_TIMER_PROP"]]: null,
      [_Props_js__WEBPACK_IMPORTED_MODULE_17__["AUTO_RECORD_PROP"]]: false
    });
    super.construct(...args);
  } // TODO: This destroys the current state, which makes successive tests fail. Not sure what should be done
  // doDestroy() {
  //     super.doDestroy();
  //     this.destroyProperties(STATE_PROP);
  // }

  /**
   * Gets current state of the manager
   *
   * @property {Core.data.stm.state.StateBase}
   */


  get state() {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STATE_PROP"]];
  }
  /**
   * Gets current undo/redo queue position
   *
   * @property {Number}
   */


  get position() {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["POS_PROP"]];
  }
  /**
   * Gets current undo/redo queue length
   *
   * @property {Number}
   */


  get length() {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["QUEUE_PROP"]].length;
  }
  /**
   * Gets all the stores registered in STM
   *
   * @property {Core.data.Store[]}
   */


  get stores() {
    return Array.from(this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]]);
  }
  /**
   * Checks if a store has been added to the manager
   *
   * @param  {Core.data.Store} store
   * @return {Boolean}
   */


  hasStore(store) {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]].includes(store);
  }
  /**
   * Adds a store to the manager
   *
   * @param {Core.data.Store} store
   */


  addStore(store) {
    if (!this.hasStore(store)) {
      this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]].push(store);
      store.stm = this;
    }
  }
  /**
   * Removes a store from the manager
   *
   * @param {Core.data.Store} store
   */


  removeStore(store) {
    if (this.hasStore(store)) {
      this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]] = this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]].filter(s => s !== store);
      store.stm = null;
    }
  }
  /**
   * Calls `fn` for each store registered in STM.
   *
   * @param {Function} fn (store, id) => ...
   */


  forEachStore(fn) {
    this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["STORES_PROP"]].forEach(s => fn(s, s.id));
  }
  /**
   * Get/set manager disabled state
   *
   * @property {Boolean}
   */


  get disabled() {
    return this.state === _state_DisabledState_js__WEBPACK_IMPORTED_MODULE_3__["default"];
  }

  set disabled(val) {
    const me = this;

    if (me.disabled != val) {
      if (val) {
        stateTransition(me, me.state.onDisable, me);
      } else {
        stateTransition(me, me.state.onEnable, me);
      }

      me.trigger('stmDisabled', {
        disabled: val
      });
      /**
       * Fired when the disabled state of the STM changes
       *
       * @event disabled
       * @param {Core.data.stm.StateTrackingManager} source
       * @param {Boolean} disabled The current disabled state of the STM
       */

      me.trigger('disabled', {
        disabled: val
      });
    }
  }
  /**
   * Enables manager
   */


  enable() {
    this.disabled = false;
  }
  /**
   * Disables manager
   */


  disable() {
    this.disabled = true;
  }
  /**
   * Checks manager ready state
   * @readonly
   * @property {Boolean}
   */


  get isReady() {
    return this.state === _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_4__["default"] || this.state === _state_AutoReadyState_js__WEBPACK_IMPORTED_MODULE_7__["default"];
  }

  waitForReadiness() {
    return this.await('ready', false);
  }
  /**
   * Checks manager recording state
   * @readonly
   * @property {Boolean}
   */


  get isRecording() {
    return this.state === _state_RecordingState_js__WEBPACK_IMPORTED_MODULE_5__["default"] || this.state === _state_AutoRecordingState_js__WEBPACK_IMPORTED_MODULE_8__["default"];
  }
  /**
   * Gets/sets manager auto record option
   *
   * @property {Boolean}
   */


  get autoRecord() {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["AUTO_RECORD_PROP"]];
  }

  set autoRecord(value) {
    const me = this;

    if (me.autoRecord != value) {
      if (value) {
        stateTransition(me, me.state.onAutoRecordOn, me);
      } else {
        stateTransition(me, me.state.onAutoRecordOff, me);
      }
    }
  }
  /**
   * Starts undo/redo recording transaction.
   *
   * @param {String} [title=nul]
   */


  startTransaction(title = null) {
    stateTransition(this, this.state.onStartTransaction, title);
  }
  /**
   * Stops undo/redo recording transaction
   *
   * @param {String} [title=null]
   */


  stopTransaction(title = null) {
    stateTransition(this, this.state.onStopTransaction, title);
  }
  /**
   * Stops undo/redo recording transaction after {@link #config-autoRecordTransactionStopTimeout} delay.
   *
   * @private
   */


  stopTransactionDelayed() {
    stateTransition(this, this.state.onStopTransactionDelayed);
  }
  /**
   * Rejects currently recorded transaction.
   */


  rejectTransaction() {
    stateTransition(this, this.state.onRejectTransaction);
  }
  /**
   * Gets currently recording STM transaction.
   * @readonly
   * @property {Core.data.stm.Transaction}
   */


  get transaction() {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["TRANSACTION_PROP"]];
  }
  /**
   * Gets titles of all recorded undo/redo transactions
   * @readonly
   * @property {String[]}
   */


  get queue() {
    return this[_Props_js__WEBPACK_IMPORTED_MODULE_17__["QUEUE_PROP"]].map(t => t.title);
  }
  /**
   * Gets manager restoring state.
   * @readonly
   * @property {Boolean}
   */


  get isRestoring() {
    return this.state === _state_RestoringState_js__WEBPACK_IMPORTED_MODULE_6__["default"];
  }
  /**
   * Checks if the manager can undo.
   *
   * @property {Boolean}
   */


  get canUndo() {
    return this.state.canUndo(this);
  }
  /**
   * Checks if the manager can redo.
   *
   * @property {Boolean}
   */


  get canRedo() {
    return this.state.canRedo(this);
  }
  /**
   * Undoes current undo/redo transaction.
   * @param {Number} [steps=1]
   * @returns {Promise} A promise which is resolved when undo action has been performed
   */


  async undo(steps = 1) {
    if (!this.isReady) {
      await this.waitForReadiness();
    }

    stateTransition(this, this.state.onUndo, steps);
  }
  /**
   * Undoes all transactions.
   * @returns {Promise} A promise which is resolved when undo actions has been performed
   */


  async undoAll() {
    if (!this.isReady) {
      await this.waitForReadiness();
    }

    this.undo(this.length);
  }
  /**
   * Redoes current undo/redo transaction.
   *
   * @param {Number} [steps=1]
   * @returns {Promise} A promise which is resolved when redo action has been performed
   */


  async redo(steps = 1) {
    if (!this.isReady) {
      await this.waitForReadiness();
    }

    stateTransition(this, this.state.onRedo, steps);
  }
  /**
   * Redoes all transactions.
   * @returns {Promise} A promise which is resolved when redo actions has been performed
   */


  async redoAll() {
    if (!this.isReady) {
      await this.waitForReadiness();
    }

    this.redo(this.length);
  }
  /**
   * Resets undo/redo queue.
   */


  resetQueue(
  /* private */
  options = {
    undo: true,
    redo: true
  }) {
    stateTransition(this, this.state.onResetQueue, options);
  }
  /**
   * Resets undo queue.
   */


  resetUndoQueue() {
    this.resetQueue({
      undo: true
    });
  }
  /**
   * Resets redo queue.
   */


  resetRedoQueue() {
    this.resetQueue({
      redo: true
    });
  }

  notifyStoresAboutStateRecordingStart(transaction) {
    this.forEachStore(store => {
      store.onStmRecordingStart && store.onStmRecordingStart(this, transaction);
    });
    /**
     * Fired upon state recording operation starts.
     *
     * @event recordingStart
     * @param {Core.data.stm.StateTrackingManager} stm
     * @param {Core.data.stm.Transaction} transaction
     */

    this.trigger('recordingStart', {
      stm: this,
      transaction
    });
  }

  notifyStoresAboutStateRecordingStop(transaction, reason) {
    this.forEachStore(store => {
      store.onStmRecordingStop && store.onStmRecordingStop(this, transaction, reason);
    });
    /**
     * Fired upon state recording operation stops.
     *
     * @event recordingStop
     * @param {Core.data.stm.StateTrackingManager} stm
     * @param {Core.data.stm.Transaction} transaction
     * @param {Object} reason Transaction stop reason
     * @param {Boolean} reason.stop Transaction recording has been stopped in a normal way.
     * @param {Boolean} reason.disabled Transaction recording has been stopped due to STM has been disabled.
     * @param {Boolean} reason.rejected Transaction recording has been stopped due to transaction has been rejected.
     */

    this.trigger('recordingStop', {
      stm: this,
      transaction,
      reason
    });
  }

  notifyStoresAboutStateRestoringStart() {
    this.forEachStore(store => {
      store.onStmRestoringStart && store.onStmRestoringStart(this);
    });
    /**
     * Fired upon state restoration operation starts.
     *
     * @event restoringStart
     * @param {Core.data.stm.StateTrackingManager} stm
     */

    this.trigger('restoringStart', {
      stm: this
    });
  }

  notifyStoresAboutStateRestoringStop() {
    this.forEachStore(store => {
      store.onStmRestoringStop && store.onStmRestoringStop(this);
    });
    /**
     * Fired upon state restoration operation stops.
     *
     * @event restoringStop
     * @param {Core.data.stm.StateTrackingManager} stm
     */

    this.trigger('restoringStop', {
      stm: this
    });
  }

  notifyStoresAboutQueueReset(options) {
    this.forEachStore(store => {
      store.onStmQueueReset && store.onStmQueueReset(this, options);
    });
    /**
     * Fired upon state undo/redo queue reset.
     *
     * @event queueReset
     * @param {Core.data.stm.StateTrackingManager} stm
     */

    this.trigger('queueReset', {
      stm: this,
      options
    });
  }
  /**
   * Method to call from model STM mixin upon model update
   *
   * @param {Core.data.Model} model
   * @param {Object} newData
   * @param {Object} oldData
   *
   * @private
   */


  onModelUpdate(model, newData, oldData) {
    stateTransition(this, this.state.onModelUpdate, model, newData, oldData);
  }
  /**
   * Method to call from model STM mixin upon tree model child insertion
   *
   * @param {Core.data.Model} parentModel Parent model
   * @param {Number} index Insertion index
   * @param {Core.data.Model[]} childModels Array of models inserted
   * @param {Map} context Map with inserted models as keys and objects with previous parent,
   *                      and index at previous parent.
   *
   * @private
   */


  onModelInsertChild(parentModel, index, childModels, context) {
    stateTransition(this, this.state.onModelInsertChild, parentModel, index, childModels, context);
  }
  /**
   * Method to call from model STM mixin upon tree model child removal
   *
   * @param {Core.data.Model} parentModel
   * @param {Core.data.Model[]} childModels
   * @param {Map} context
   *
   * @private
   */


  onModelRemoveChild(parentModel, childModels, context) {
    stateTransition(this, this.state.onModelRemoveChild, parentModel, childModels, context);
  }
  /**
   * Method to call from store STM mixin upon store models adding
   *
   * @param {Core.data.Store} store
   * @param {Core.data.Model[]} models
   * @param {Boolean} silent
   *
   * @private
   */


  onStoreModelAdd(store, models, silent) {
    stateTransition(this, this.state.onStoreModelAdd, store, models, silent);
  }
  /**
   * Method to call from store STM mixin upon store models insertion
   *
   * @param {Core.data.Store} store
   * @param {Number} index
   * @param {Core.data.Model[]} models
   * @param {Map} context
   * @param {Boolean} silent
   *
   * @private
   */


  onStoreModelInsert(store, index, models, context, silent) {
    stateTransition(this, this.state.onStoreModelInsert, store, index, models, context, silent);
  }
  /**
   * Method to call from store STM mixin upon store models removal
   *
   * @param {Core.data.Store} store
   * @param {Core.data.Model[]} models
   * @param {Object} context
   * @param {Boolean} silent
   *
   * @private
   */


  onStoreModelRemove(store, models, context, silent) {
    stateTransition(this, this.state.onStoreModelRemove, store, models, context, silent);
  }
  /**
   * Method to call from store STM mixin upon store clear
   *
   * @param {Core.data.Store} store
   * @param {Core.data.Model[]} allRecords
   * @param {Boolean} silent
   *
   * @private
   */


  onStoreRemoveAll(store, allRecords, silent) {
    stateTransition(this, this.state.onStoreRemoveAll, store, allRecords, silent);
  } // UI key event handling


  onUndoKeyPress(event) {
    if (!this.disabled) {
      if (event.shiftKey) {
        if (this.canRedo) {
          event.preventDefault();
          this.redo();
        }
      } else if (this.canUndo) {
        event.preventDefault();
        this.undo();
      }
    }
  }

}
StateTrackingManager._$name = 'StateTrackingManager';

/***/ }),

/***/ "./lib/Core/data/stm/Transaction.js":
/*!******************************************!*\
  !*** ./lib/Core/data/stm/Transaction.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Transaction; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/Transaction
*/


const ACTION_QUEUE_PROP = Symbol('ACTION_QUEUE_PROP');
/**
 * STM transaction class, holds list of actions constituting a transaction.
 *
 * A transaction can be undone and redone. Upon undo all the actions being held
 * are undone in reverse order. Upon redo all the actions being held are redone
 * in forward order.
 */

class Transaction extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  get defaultConfig() {
    return {
      /**
       * Transaction title
       *
       * @config {String}
       * @default
       */
      title: null
    };
  }

  construct(...args) {
    this[ACTION_QUEUE_PROP] = [];
    super.construct(...args);
  }
  /**
   * Gets transaction's actions queue
   *
   * @property {Core.data.stm.action.ActionBase[]}
   */


  get queue() {
    return this[ACTION_QUEUE_PROP].slice(0);
  }
  /**
   * Gets transaction's actions queue length
   *
   * @property {Number}
   */


  get length() {
    return this[ACTION_QUEUE_PROP].length;
  }
  /**
   * Adds an action to the transaction.
   *
   * @param {Core.data.stm.action.ActionBase|Object} action
   */


  addAction(action) {
    this[ACTION_QUEUE_PROP].push(action);
  }
  /**
   * Undoes actions held
   */


  undo() {
    const queue = this[ACTION_QUEUE_PROP];

    for (let i = queue.length - 1; i >= 0; --i) {
      queue[i].undo();
    }
  }
  /**
   * Redoes actions held
   */


  redo() {
    const queue = this[ACTION_QUEUE_PROP];

    for (let i = 0, len = queue.length; i < len; ++i) {
      queue[i].redo();
    }
  }

}
Transaction._$name = 'Transaction';

/***/ }),

/***/ "./lib/Core/data/stm/action/ActionBase.js":
/*!************************************************!*\
  !*** ./lib/Core/data/stm/action/ActionBase.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ActionBase; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/action/ActionBase
*/



const throwAbstractMethodCall = () => {
  throw new Error('Abstract method call!');
};
/**
 * Base class for STM actions.
 *
 * @abstract
 */


class ActionBase extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * Gets the type of the action (stringified class name).
   * @readonly
   * @property {String}
   */
  get type() {
    return this.constructor.name;
  }
  /**
   * Undoes an action
   */


  undo() {
    throwAbstractMethodCall();
  }
  /**
   * Redoes an action
   */


  redo() {
    throwAbstractMethodCall();
  }

}
ActionBase._$name = 'ActionBase';

/***/ }),

/***/ "./lib/Core/data/stm/action/AddAction.js":
/*!***********************************************!*\
  !*** ./lib/Core/data/stm/action/AddAction.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AddAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Store.js */ "./lib/Core/data/Store.js");
var productName = 'taskboard';


/**
 * @module Core/data/stm/action/AddAction
 */

const STORE_PROP = Symbol('STORE_PROP');
const MODEL_LIST_PROP = Symbol('MODEL_LIST_PROP');
/**
 * Action to record the fact of models adding to a store.
 * @extends Core/data/stm/action/ActionBase
 */

class AddAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a store models have been added into.
       *
       * @config {Core.data.Store}
       * @default
       */
      store: undefined,

      /**
       * List of models added into the store.
       *
       * @config {Core.data.Model[]}
       * @default
       */
      modelList: undefined,

      /**
       * Flag showing if undo/redo should be done silently i.e. with events suppressed
       *
       * @config {Boolean}
       * @default
       */
      silent: false
    };
  }

  get type() {
    return 'AddAction';
  }

  get store() {
    return this[STORE_PROP];
  }

  set store(store) {
    this[STORE_PROP] = store;
  }

  get modelList() {
    return this[MODEL_LIST_PROP];
  }

  set modelList(list) {
    this[MODEL_LIST_PROP] = list.slice(0);
  }

  undo() {
    const me = this;
    me.store.remove(me.modelList, me.silent);
  }

  redo() {
    const me = this;
    me.store.add(me.modelList, me.silent);
  }

}
AddAction._$name = 'AddAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/InsertAction.js":
/*!**************************************************!*\
  !*** ./lib/Core/data/stm/action/InsertAction.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return InsertAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Store.js */ "./lib/Core/data/Store.js");
var productName = 'taskboard';


/**
 * @module Core/data/stm/action/InsertAction
 */

const STORE_PROP = Symbol('STORE_PROP');
const MODEL_LIST_PROP = Symbol('MODEL_LIST_PROP');
const INSERT_INDEX_PROP = Symbol('INSERT_INDEX_PROP');
const CONTEXT_PROP = Symbol('CONTEXT_PROP');
/**
 * Action to record the fact of models inserting into a store.
 * @extends Core/data/stm/action/ActionBase
 */

class InsertAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a store models have been inserted into.
       *
       * @config {Core.data.Store}
       * @default
       */
      store: undefined,

      /**
       * List of models inserted into the store.
       *
       * @config {Core.data.Model[]}
       * @default
       */
      modelList: undefined,

      /**
       * Index the models have been inserted at.
       *
       * @config {Number}
       * @default
       */
      insertIndex: undefined,

      /**
       * Models move context (if models has been moved), if any.
       * Map this {@link Core/data/Model} instances as keys and their
       * previous index as values
       *
       * @config {Map}
       * @default
       */
      context: undefined,

      /**
       * Flag showing if undo/redo should be done silently i.e. with events suppressed
       *
       * @config {Boolean}
       * @default
       */
      silent: false
    };
  }

  get type() {
    return 'InsertAction';
  }

  get store() {
    return this[STORE_PROP];
  }

  set store(store) {
    this[STORE_PROP] = store;
  }

  get modelList() {
    return this[MODEL_LIST_PROP];
  }

  set modelList(list) {
    this[MODEL_LIST_PROP] = list.slice(0);
  }

  get insertIndex() {
    return this[INSERT_INDEX_PROP];
  }

  set insertIndex(index) {
    this[INSERT_INDEX_PROP] = index;
  }

  get context() {
    return this[CONTEXT_PROP];
  }

  set context(context) {
    this[CONTEXT_PROP] = context;
  }

  undo() {
    const {
      store,
      modelList,
      context,
      silent
    } = this; // Let's sort models by index such that models with lesser index
    // were inserted back first, thus making valid index of models following.

    modelList.sort((lhs, rhs) => {
      const lhsIndex = context.get(lhs),
            rhsIndex = context.get(rhs);
      return lhsIndex !== undefined && rhsIndex !== undefined ? lhsIndex - rhsIndex : 0;
    });
    modelList.forEach(m => {
      const index = context.get(m); // Flag the inserted record that we undo to skip adding it to "store.removed"

      m._undoingInsertion = true;

      if (index !== undefined) {
        // Insert at previous index
        store.insert(index, m, silent);
      } else {
        // Just remove
        store.remove(m, silent);
      }

      m._undoingInsertion = false;
    });
  }

  redo() {
    const me = this;
    me.store.insert(me.insertIndex, me.modelList, me.silent);
  }

}
InsertAction._$name = 'InsertAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/InsertChildAction.js":
/*!*******************************************************!*\
  !*** ./lib/Core/data/stm/action/InsertChildAction.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return InsertChildAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/action/InsertChildAction
*/


const PARENT_MODEL_PROP = Symbol('PARENT_MODEL_PROP');
const CHILD_MODELS_PROP = Symbol('CHILD_MODELS_PROP');
const INSERT_INDEX_PROP = Symbol('INSERT_INDEX_PROP');
const CONTEXT_PROP = Symbol('CONTEXT_PROP');
/**
 * Action to record the fact of adding a children models into a parent model.
 * @extends Core/data/stm/action/ActionBase
 */

class InsertChildAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a parent model a child model has been added to.
       *
       * @config {Core.data.Model}
       * @default
       */
      parentModel: undefined,

      /**
       * Children models inserted.
       *
       * @config {Core.data.Model[]}
       * @default
       */
      childModels: undefined,

      /**
       * Index a children models are inserted at
       *
       * @config {Number}
       * @default
       */
      insertIndex: undefined,

      /**
       * Map having children models as keys and values containing previous parent
       * of each model and index at the previous parent.
       *
       * @config {Object}
       * @default
       */
      context: undefined
    };
  }

  get type() {
    return 'InsertChildAction';
  }

  get parentModel() {
    return this[PARENT_MODEL_PROP];
  }

  set parentModel(model) {
    this[PARENT_MODEL_PROP] = model;
  }

  get childModels() {
    return this[CHILD_MODELS_PROP];
  }

  set childModels(models) {
    this[CHILD_MODELS_PROP] = models.slice(0);
  }

  get insertIndex() {
    return this[INSERT_INDEX_PROP];
  }

  set insertIndex(index) {
    this[INSERT_INDEX_PROP] = index;
  }

  get context() {
    return this[CONTEXT_PROP];
  }

  set context(ctx) {
    this[CONTEXT_PROP] = ctx;
  }

  undo() {
    const {
      parentModel,
      context,
      childModels
    } = this; // Let's sort models by parent index such that models with lesser index
    // were inserted back first, thus making valid parent index of models following.

    childModels.sort((lhs, rhs) => {
      const {
        lhsParent,
        lhsIndex
      } = context.get(lhs) || {},
            {
        rhsParent,
        rhsIndex
      } = context.get(rhs) || {};
      return lhsParent && lhsParent === rhsParent ? lhsIndex - rhsIndex : 0;
    }); // Now let's re-insert records back to where they were or remove them
    // if they weren't anywhere

    childModels.forEach(m => {
      const {
        parent,
        index
      } = context.get(m) || {};

      if (parent) {
        // If we move within same parent then index must be adjusted
        if (parent === parentModel) {
          let adjustedIndex; // we need to increment index if the node was moved up

          adjustedIndex = index > m.parentIndex ? index + 1 : index; // null index if we need to move to the end

          adjustedIndex = index === parent.children.length - 1 ? null : adjustedIndex; // if insertBefore is undefined the node will be appended to the end

          const insertBefore = parent.children[adjustedIndex];
          parent.insertChild(m, insertBefore);
        } else {
          // Insert at previous index
          parent.insertChild(m, parent.children[index]);
        }
      } else {
        // Just remove
        parentModel.removeChild(m);
      }
    });
  }

  redo() {
    const {
      parentModel,
      insertIndex,
      childModels
    } = this,
          insertBefore = parentModel.children[insertIndex];
    parentModel.insertChild(childModels, insertBefore);
  }

}
InsertChildAction._$name = 'InsertChildAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/RemoveAction.js":
/*!**************************************************!*\
  !*** ./lib/Core/data/stm/action/RemoveAction.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RemoveAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Store.js */ "./lib/Core/data/Store.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/action/RemoveAction
*/



const STORE_PROP = Symbol('STORE_PROP');
const MODEL_LIST_PROP = Symbol('MODEL_LIST_PROP');
const CONTEXT_PROP = Symbol('CONTEXT_PROP');
/**
 * Action to record the fact of models removed from a store.
 * @extends Core/data/stm/action/ActionBase
 */

class RemoveAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a store models have been removed from.
       *
       * @config {Core.data.Store}
       * @default
       */
      store: undefined,

      /**
       * List of models removed from the store.
       *
       * @config {Core.data.Model[]}
       * @default
       */
      modelList: undefined,

      /**
       * Models removing context.
       *
       * @config {Object}
       * @default
       */
      context: undefined,

      /**
       * Flag showing if undo/redo should be done silently i.e. with events suppressed
       *
       * @config {Boolean}
       * @default
       */
      silent: false
    };
  }

  get type() {
    return 'RemoveAction';
  }

  get store() {
    return this[STORE_PROP];
  }

  set store(store) {
    this[STORE_PROP] = store;
  }

  get modelList() {
    return this[MODEL_LIST_PROP];
  }

  set modelList(list) {
    this[MODEL_LIST_PROP] = list.slice(0);
  }

  get context() {
    return this[CONTEXT_PROP];
  }

  set context(context) {
    this[CONTEXT_PROP] = context;
  }

  undo() {
    const {
      store,
      context,
      modelList,
      silent
    } = this; // Let's sort models by index such that models with lesser index
    // were inserted back first, thus making valid index of models following.

    modelList.sort((lhs, rhs) => {
      const lhsIndex = context.get(lhs),
            rhsIndex = context.get(rhs); // Here, in contrast to InsertAction, index is always present

      return lhsIndex - rhsIndex;
    });
    modelList.forEach(m => {
      const index = context.get(m); // Insert at previous index

      store.insert(index, m, silent);
    });
  }

  redo() {
    const me = this;
    me.store.remove(me.modelList, me.silent);
  }

}
RemoveAction._$name = 'RemoveAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/RemoveAllAction.js":
/*!*****************************************************!*\
  !*** ./lib/Core/data/stm/action/RemoveAllAction.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RemoveAllAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony import */ var _Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Store.js */ "./lib/Core/data/Store.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/action/RemoveAllAction
*/



const STORE_PROP = Symbol('STORE_PROP');
const ALL_RECORDS_PROP = Symbol('ALL_RECORDS_PROP');
/**
 * Action to record store remove all operation.
 * @extends Core/data/stm/action/ActionBase
 */

class RemoveAllAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a store cleared.
       *
       * @config {Core.data.Store}
       * @default
       */
      store: undefined,

      /**
       * All store records removed
       *
       * @config {Core.data.Model[]}
       * @default
       */
      allRecords: undefined,

      /**
       * Flag showing if undo/redo should be done silently i.e. with events suppressed
       *
       * @config {Boolean}
       * @default
       */
      silent: false
    };
  }

  get type() {
    return 'RemoveAllAction';
  }

  get store() {
    return this[STORE_PROP];
  }

  set store(store) {
    this[STORE_PROP] = store;
  }

  get allRecords() {
    return this[ALL_RECORDS_PROP];
  }

  set allRecords(records) {
    this[ALL_RECORDS_PROP] = records.slice(0);
  }

  undo() {
    const {
      store,
      allRecords,
      silent
    } = this;
    store.add(allRecords, silent);
  }

  redo() {
    const me = this;
    me.store.removeAll(me.silent);
  }

}
RemoveAllAction._$name = 'RemoveAllAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/RemoveChildAction.js":
/*!*******************************************************!*\
  !*** ./lib/Core/data/stm/action/RemoveChildAction.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RemoveChildAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/action/RemoveChildAction
*/


const PARENT_MODEL_PROP = Symbol('PARENT_MODEL_PROP');
const CHILD_MODELS_PROP = Symbol('CHILD_MODELS_PROP');
const CONTEXT_PROP = Symbol('CONTEXT_PROP');
/**
 * Action to record store remove child operation.
 * @extends Core/data/stm/action/ActionBase
 */

class RemoveChildAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a parent model a child model has been removed to.
       *
       * @config {Core.data.Model}
       * @default
       */
      parentModel: undefined,

      /**
       * Children models removed.
       *
       * @config {Core.data.Model[]}
       * @default
       */
      childModels: undefined,

      /**
       * Map having children models as keys and values containing previous parent
       * index at the parent.
       *
       * @config {Object}
       * @default
       */
      context: undefined
    };
  }

  get type() {
    return 'RemoveChildAction';
  }

  get parentModel() {
    return this[PARENT_MODEL_PROP];
  }

  set parentModel(model) {
    this[PARENT_MODEL_PROP] = model;
  }

  get childModels() {
    return this[CHILD_MODELS_PROP];
  }

  set childModels(models) {
    this[CHILD_MODELS_PROP] = models.slice(0);
  }

  get context() {
    return this[CONTEXT_PROP];
  }

  set context(ctx) {
    this[CONTEXT_PROP] = ctx;
  }

  undo() {
    const {
      parentModel,
      context,
      childModels
    } = this; // Let's sort models by parent index such that models with lesser index
    // were inserted back first, thus making valid parent index of models following.

    childModels.sort((lhs, rhs) => {
      const lhsIndex = context.get(lhs),
            rhsIndex = context.get(rhs);
      return lhsIndex - rhsIndex;
    }); // Now let's re-insert records back to where they were

    childModels.forEach(m => {
      parentModel.insertChild(context.get(m), m);
    });
  }

  redo() {
    this.parentModel.removeChild(this.childModels);
  }

}
RemoveChildAction._$name = 'RemoveChildAction';

/***/ }),

/***/ "./lib/Core/data/stm/action/UpdateAction.js":
/*!**************************************************!*\
  !*** ./lib/Core/data/stm/action/UpdateAction.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UpdateAction; });
/* harmony import */ var _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/action/UpdateAction
*/


const MODEL_PROP = Symbol('MODEL_PROP');
const NEW_DATA_PROP = Symbol('NEW_DATA_PROP');
const OLD_DATA_PROP = Symbol('OLD_DATA_PROP');
/**
 * Action to record the fact that a model has been updated.
 * @extends Core/data/stm/action/ActionBase
 */

class UpdateAction extends _ActionBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * Reference to a model which has been updated.
       *
       * @config {Core.data.Model}
       * @default
       */
      model: undefined,

      /**
       * Map of updated properties with new values.
       *
       * @config {Object}
       * @default
       */
      newData: undefined,

      /**
       * Map of updated properties with old values.
       *
       * @config {Object}
       * @default
       */
      oldData: undefined
    };
  }

  get type() {
    return 'UpdateAction';
  }

  get model() {
    return this[MODEL_PROP];
  }

  set model(value) {
    this[MODEL_PROP] = value;
  }

  get newData() {
    return this[NEW_DATA_PROP];
  }

  set newData(value) {
    this[NEW_DATA_PROP] = Object.assign({}, value);
  }

  get oldData() {
    return this[OLD_DATA_PROP];
  }

  set oldData(value) {
    this[OLD_DATA_PROP] = Object.assign({}, value);
  }

  undo() {
    // it seems STM has to use `model.set()` because of `model.inSet` overrides or smth
    // w/o this call, just with `Object.assign()` below, the view is not refreshed
    // Since invoking accessor will just forward change to the engine, we need to pass `skipAccessors = true`
    // to this call to make this change on data level. Engine will be updated below.
    // Covered by TaskEdit.t `autoSync` subtest
    this.model.set(this.oldData, null, null, null, true); // in the same time, engine needs the setters to be activated, since there's some
    // additional logic (for example, invalidate dispatcher)
    // This will make change in the engine

    if (this.model.$) {
      Object.assign(this.model, this.oldData);
    }
  }

  redo() {
    this.model.set(this.newData, null, null, null, true); // see comments above

    if (this.model.$) {
      Object.assign(this.model, this.newData);
    }
  }

}
UpdateAction._$name = 'UpdateAction';

/***/ }),

/***/ "./lib/Core/data/stm/mixin/ModelStm.js":
/*!*********************************************!*\
  !*** ./lib/Core/data/stm/mixin/ModelStm.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/mixin/ModelStm
*/


const STM_PROP = Symbol('STM_PROP'),
      unrecordedFields = {
  // This field's value is a by product of node insertion and must not be recorded here.
  // It's the node insertion operation which is recorded by STM.
  parentIndex: 1
};
/**
 * Mixin making a model compatible with {@link Core/data/stm/StateTrackingManager}
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class ModelStm extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'ModelStm';
  }

  static get defaultConfig() {
    return {
      stm: null
    };
  }

  joinStore(store) {
    // No super on purpose, micro optimization of critical perf path
    // super.joinStore && super.joinStore(store);
    if (!this.stm) {
      this.stm = store.stm;
    }
  }

  unjoinStore(store) {
    if (this.stm === store.stm) {
      this.stm = null;
    }

    super.unjoinStore && super.unjoinStore(store);
  }
  /**
   * Reference to STM manager, if used
   * @member {Core.data.stm.StateTrackingManager}
   * @category Misc
   */


  get stm() {
    return this[STM_PROP];
  }

  set stm(stm) {
    this[STM_PROP] = stm;
  }
  /**
   * Overridden to collect initial data for the fields about to be changed.
   * The method is called from within {@link Core/data/Model#function-set} method.
   *
   * @private
   */


  beforeSet(field, value, silent, fromRelationUpdate) {
    const stm = this.stm;

    if (stm && !stm.disabled && !unrecordedFields[field] && !this.constructor.nonPersistableFields[field]) {
      var _super$beforeSet;

      const preResult = ((_super$beforeSet = super.beforeSet) === null || _super$beforeSet === void 0 ? void 0 : _super$beforeSet.call(this, field, value, silent, fromRelationUpdate)) || [];
      let newDataCandidate, oldDataCandidate;

      if (typeof field == 'object') {
        [newDataCandidate, oldDataCandidate] = Object.keys(field).reduce((data, fName) => {
          data[0][fName] = field[fName];
          data[1][fName] = this.get(fName);
          return data;
        }, [{}, {}]);
      } else {
        newDataCandidate = {
          [field]: value
        };
        oldDataCandidate = {
          [field]: this.get(field)
        };
      }

      preResult.push([newDataCandidate, oldDataCandidate]);
      return preResult;
    }

    return [];
  }
  /**
   * Overridden to store initial data of the changed fields and to notify STM
   * manager about the change action if anything has been changed in result.
   *
   * The method is called from within {@link Core/data/Model#function-set} method.
   *
   * @private
   */


  afterSet(field, value, silent, fromRelationUpdate, beforeResult, wasSet) {
    const stm = this.stm,
          nonPersistableFields = this.constructor.nonPersistableFields;

    if (stm && !stm.disabled && !unrecordedFields[field] && !nonPersistableFields[field]) {
      const preResult = beforeResult.pop();

      if (wasSet) {
        let shouldRecord;
        const [newDataCandidate, oldDataCandidate] = preResult,
              [newData, oldData] = Object.keys(wasSet).reduce((data, fieldName) => {
          if (!nonPersistableFields[fieldName]) {
            shouldRecord = true;
          }

          data[0][fieldName] = newDataCandidate[fieldName];
          data[1][fieldName] = oldDataCandidate[fieldName];
          return data;
        }, [{}, {}]);

        if (shouldRecord) {
          stm.onModelUpdate(this, newData, oldData);
        }
      }
    } // No super on purpose, micro optimization of critical perf path
    // super.afterSet && super.afterSet(field, value, silent, fromRelationUpdate, beforeResult, wasSet);

  }
  /**
   * Called from {@link Core/data/mixin/TreeNode#function-insertChild} to obtain inserted
   * records initial parents and parent index, to be able to restore the state back upon undo.
   *
   * @param {Core.data.Model[]} childRecords
   * @return {Array} Array of results from this call and any of super calls if any.
   *               This result is consumed by {@link #function-afterInsertChild} which pops
   *               from the result array to take only results of this method call and leave
   *               results from super calls untouched.
   *
   * @private
   */


  beforeInsertChild(childRecords) {
    const preResult = super.beforeInsertChild ? super.beforeInsertChild(childRecords) : [];
    const stm = this.stm;

    if (stm && !stm.disabled) {
      preResult.push(childRecords.reduce((result, childRecord) => {
        // We are interested only in records from the same root node.
        // Removing (which is done before insertion) of the records
        // from another root (and store) should
        // be handled by that store STM instance.
        if (childRecord.root === this.root) {
          result.set(childRecord, {
            parent: childRecord.parent,
            index: childRecord.parent ? childRecord.parentIndex : undefined
          });
        }

        return result;
      }, new Map()));
    }

    return preResult;
  }
  /**
   * Called from {@link Core/data/mixin/TreeNode#function-insertChild} to notify {@link Core/data/stm/StateTrackingManager}
   * about children insertion. Provides it with all necessary context information collected
   * in {@link #function-beforeInsertChild} required to undo/redo the action.
   *
   * @private
   */


  afterInsertChild(index, childRecords, beforeResult, inserted) {
    const stm = this.stm;

    if (stm && !stm.disabled) {
      const context = beforeResult.pop();

      if (inserted) {
        stm.onModelInsertChild(this, index, inserted, context);
      }
    }

    super.afterInsertChild && super.afterInsertChild(index, childRecords, beforeResult, inserted);
  }
  /**
   * Called from {@link Core/data/mixin/TreeNode#function-removeChild} to obtain removed
   * records initial parent index, to be able to restore the state back upon undo.
   *
   * @param {Core.data.Model[]} childRecords
   * @param {Boolean} isMove
   * @return {Array} Array of results from this call and any of super calls if any.
   *               This result is consumed by {@link #function-afterRemoveChild} which pops
   *               from the result array to take only results of this method call and leave
   *               results from super calls untouched.
   *
   * @private
   */


  beforeRemoveChild(childRecords, isMove) {
    const preResult = super.beforeRemoveChild ? super.beforeRemoveChild(childRecords, isMove) : [];
    const stm = this.stm; // If it's move then InsertChildAction will handle this case

    if (stm && !stm.disabled && !isMove) {
      // Child records we receive are guaranteed to be direct children
      // of this node, see Core/data/mixin/TreeNode#removeChild method
      // Here we interested in the original index for each child removed,
      // we collect it and store for future use in RemoveChildAction
      preResult.push(childRecords.reduce((result, childRecord) => {
        result.set(childRecord, childRecord.parentIndex);
        return result;
      }, new Map()));
    }

    return preResult;
  }
  /**
   * Called from {@link Core/data/mixin/TreeNode#function-removeChild} to notify {@link Core/data/stm/StateTrackingManager}
   * about children removing. Provides it with all necessary context information collected
   * in {@link #function-beforeRemoveChild} required to undo/redo the action.
   *
   * @private
   */


  afterRemoveChild(childRecords, beforeResult, isMove) {
    const stm = this.stm; // If it's move then InsertChildAction will handle this case

    if (stm && !stm.disabled && !isMove) {
      const context = beforeResult.pop();

      if (childRecords && childRecords.length) {
        stm.onModelRemoveChild(this, childRecords, context);
      }
    }

    super.afterRemoveChild && super.afterRemoveChild(childRecords, beforeResult, isMove);
  }

});

/***/ }),

/***/ "./lib/Core/data/stm/mixin/StoreStm.js":
/*!*********************************************!*\
  !*** ./lib/Core/data/stm/mixin/StoreStm.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _data_Model_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../data/Model.js */ "./lib/Core/data/Model.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/mixin/StoreStm
*/



const STM_PROP = Symbol('STM_PROP');
/**
 * Store mixin to make it compatible with {@link Core.data.stm.StateTrackingManager}.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class StoreStm extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'StoreStm';
  }

  static get defaultConfig() {
    return {
      /**
       * Reference to STM manager
       *
       * @config {Core.data.stm.StateTrackingManager}
       * @default
       * @category Advanced
       */
      stm: null
    };
  }

  get stm() {
    return this[STM_PROP];
  }

  set stm(stm) {
    const me = this;

    if (me.stm != stm) {
      if (me.stm && me.stm.hasStore(me)) {
        me.stm.removeStore(me);
      }

      me[STM_PROP] = stm;

      if (me.stm && !me.stm.hasStore(me)) {
        me.stm.addStore(me);
      }
    }
  } // Overridden to notify STM about flat add action


  add(records, silent = false) {
    let result;
    const stm = this.stm; // Tree adding is routed via rootNode.appendChild() it has it's own
    // STM override thus if the store is tree we ignore the action

    if (!this.tree && stm && !stm.disabled) {
      // Flat adding here only, the only data needed to undo/redo the action
      // is the list of records added.
      result = super.add(records, silent); // If adding wasn't vetoed and something has been added then
      // notifying the STM about the fact.

      if (result && result.length) {
        stm.onStoreModelAdd(this, result, silent);
      }
    } else {
      result = super.add(records, silent);
    }

    return result;
  } // Overridden to notify STM about flat insert action


  insert(index, records, silent = false) {
    let result;
    const stm = this.stm; // Tree inserting is routed via rootNode.insertChild() it has it's own
    // STM override thus if the store is tree we ignore the action

    if (!this.tree && stm && !stm.disabled) {
      // Flat inserting here only, the only data needed to undo/redo the action is:
      // - the list of record inserted
      // - index they are inserted at
      // - index they have been at if they are part of this store already and are moved
      // Here we are getting indices of records which are in this store already
      // not all records might be from this store, some might be new or from another store
      const context = (Array.isArray(records) ? records : [records]).reduce((context, r) => {
        const index = r instanceof _data_Model_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? this.indexOf(r) : undefined;

        if (index !== undefined && index !== -1) {
          context.set(r, index);
        }

        return context;
      }, new Map()); // Result here is the array of Models inserted or undefined,
      // and it might be different from `records` we received as argument.

      result = super.insert(index, records); // Here we check if anything has been actually inserted.
      // The insertion action might be vetoed by event handler or something

      if (result && result.length) {
        // We can't rely on `index` we've got as argument since `result` might
        // differ from records.
        index = this.indexOf(result[0]); // Notifying STM manager about the insertion action providing all
        // the required data to undo/redo.

        stm.onStoreModelInsert(this, index, result, context, silent);
      }
    } else {
      result = super.insert(index, records, silent);
    }

    return result;
  } // Overridden to notify STM about flat removing action


  remove(recordsOrIds, silent = false, fromRemoveChild) {
    let result;
    const stm = this.stm; // Tree removing is routed via rootNode.removeChild() it has it's own
    // STM override thus if the store is tree we ignore the action

    if (!this.tree && stm && !stm.disabled) {
      // Flat removing here only, the only date needed to undo/redo the actions is:
      // - the list of records removed
      // - their original index to re-insert them back correctly
      const recordsOrIdsNormalized = (Array.isArray(recordsOrIds) ? recordsOrIds : [recordsOrIds]).map(r => this.getById(r)).filter(r => !!r);
      const context = recordsOrIdsNormalized.reduce((context, r) => {
        const index = this.indexOf(r);

        if (index !== undefined && index != -1) {
          context.set(r, index);
        }

        return context;
      }, new Map()); // Calling original store method

      result = super.remove(recordsOrIds, silent, fromRemoveChild); // Here we check if anything has been actually removed.
      // The removing action might be vetoed by event handler or something

      if (result && result.length) {
        stm.onStoreModelRemove(this, result, context, silent);
      }
    } else {
      result = super.remove(recordsOrIds, silent, fromRemoveChild);
    }

    return result;
  } // Overridden to notify STM about flat clear action


  removeAll(silent) {
    const stm = this.stm;
    let result;

    if (stm && !stm.disabled) {
      // Here we are to detect if anything has been removed
      // the only way is to check if store has anything before removing all
      // and has nothing after.
      const {
        tree,
        rootNode,
        allRecords
      } = this,
            wasNotEmpty = allRecords.length,
            // need to store children/records before super method call, otherwise those would report empty list
      records = tree ? rootNode.children.slice() : allRecords.slice();
      result = super.removeAll(silent); // The trick here is to distinguish tree and flat case
      // For the flat case it's simple we just store all records
      // For the tree we are to store root node children only
      // Upon restoring store.add() will do the right thing for the flat case and tree case regardless.

      if (wasNotEmpty && this.count === 0) {
        stm.onStoreRemoveAll(this, records, silent);
      }
    } else {
      result = super.removeAll(silent);
    }

    return result;
  }

});

/***/ }),

/***/ "./lib/Core/data/stm/state/AutoReadyState.js":
/*!***************************************************!*\
  !*** ./lib/Core/data/stm/state/AutoReadyState.js ***!
  \***************************************************/
/*! exports provided: AutoReadyStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AutoReadyStateClass", function() { return AutoReadyStateClass; });
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Transaction_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Transaction.js */ "./lib/Core/data/stm/Transaction.js");
/* harmony import */ var _ReadyState_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ReadyState.js */ "./lib/Core/data/stm/state/ReadyState.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/state/AutoReadyState
*/






/**
 * STM transaction autostart ready state class.
 *
 * @internal
 */

class AutoReadyStateClass extends _ReadyState_js__WEBPACK_IMPORTED_MODULE_2__["ReadyStateClass"] {
  onAutoRecordOn() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onAutoRecordOff() {
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: 'readystate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["AUTO_RECORD_PROP"]]: false
    };
  }

  onStartTransaction(stm, title) {
    const transaction = new _Transaction_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
      title: title
    });
    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: 'autorecordingstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]]: transaction
    }, () => {
      stm.notifyStoresAboutStateRecordingStart(transaction);
      stm.stopTransactionDelayed();
    }];
  }

  onModelUpdate(stm, model, newData, oldData) {
    stm.startTransaction();
    stm.onModelUpdate(model, newData, oldData);
  }

  onModelInsertChild(stm, parentModel, index, childModels, context) {
    stm.startTransaction();
    stm.onModelInsertChild(parentModel, index, childModels, context);
  }

  onModelRemoveChild(stm, parentModel, childModels, context) {
    stm.startTransaction();
    stm.onModelRemoveChild(parentModel, childModels, context);
  }

  onStoreModelAdd(stm, store, models, silent) {
    stm.startTransaction();
    stm.onStoreModelAdd(store, models, silent);
  }

  onStoreModelInsert(stm, store, index, models, context, silent) {
    stm.startTransaction();
    stm.onStoreModelInsert(store, index, models, silent);
  }

  onStoreModelRemove(stm, store, models, context, silent) {
    stm.startTransaction();
    stm.onStoreModelRemove(store, models, context, silent);
  }

  onStoreRemoveAll(stm, store, allRecords, silent) {
    stm.startTransaction();
    stm.onStoreRemoveAll(store, allRecords, silent);
  }

}
/**
 * STM transaction autostart ready state.
 *
 * @internal
 */

const AutoReadyState = new AutoReadyStateClass();
/* harmony default export */ __webpack_exports__["default"] = (AutoReadyState);
_Registry_js__WEBPACK_IMPORTED_MODULE_4__["default"].registerStmState('autoreadystate', AutoReadyState);

/***/ }),

/***/ "./lib/Core/data/stm/state/AutoRecordingState.js":
/*!*******************************************************!*\
  !*** ./lib/Core/data/stm/state/AutoRecordingState.js ***!
  \*******************************************************/
/*! exports provided: AutoRecordingStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AutoRecordingStateClass", function() { return AutoRecordingStateClass; });
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _RecordingState_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./RecordingState.js */ "./lib/Core/data/stm/state/RecordingState.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
/* harmony import */ var _Helpers_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Helpers.js */ "./lib/Core/data/stm/Helpers.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/state/AutoRecordingState
*/







/**
 * STM recording state class.
 *
 * @internal
 */

class AutoRecordingStateClass extends _RecordingState_js__WEBPACK_IMPORTED_MODULE_2__["RecordingStateClass"].mixin(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  onDisable(stm) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]];
    const timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]];

    if (timer) {
      this.clearTimeout(timer);
    }

    stm.notifyStoresAboutStateRecordingStop(transaction, {
      disabled: true
    });
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: 'disabledstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]]: null,
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]]: null
    };
  }

  onAutoRecordOn(stm) {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_1__["throwInvalidMethodCall"])();
  }

  onAutoRecordOff(stm) {
    const timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]];

    if (timer) {
      this.clearTimeout(timer);
    }

    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: 'recordingstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["AUTO_RECORD_PROP"]]: false,
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]]: null
    };
  }

  onStopTransaction(stm, title) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]];
    const timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]];
    let position = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["POS_PROP"]];
    const queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["QUEUE_PROP"]];

    if (timer) {
      this.clearTimeout(timer);
    }

    if (transaction.length) {
      if (!transaction.title && !title && stm.getTransactionTitle) {
        transaction.title = stm.getTransactionTitle(transaction);
      } else if (title) {
        transaction.title = title;
      }

      queue[position] = transaction;
      queue.length = ++position;
    }

    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: 'autoreadystate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["POS_PROP"]]: position,
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]]: null,
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]]: null
    }, () => {
      stm.notifyStoresAboutStateRecordingStop(transaction, {
        stop: true
      });
    }];
  }

  onStopTransactionDelayed(stm) {
    let timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]];

    if (timer) {
      this.clearTimeout(timer);
    }

    timer = this.setTimeout(() => {
      stm.stopTransaction();
    }, stm.autoRecordTransactionStopTimeout);
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: AutoRecordingState,
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]]: timer
    };
  }

  onResetQueue(stm, options) {
    return Object(_Helpers_js__WEBPACK_IMPORTED_MODULE_5__["resetQueue"])(stm, options);
  }

  onRejectTransaction(stm) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]],
          timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]];

    if (timer) {
      this.clearTimeout(timer);
    }

    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["STATE_PROP"]]: 'restoringstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_PROP"]]: null,
      [_Props_js__WEBPACK_IMPORTED_MODULE_3__["TRANSACTION_TIMER_PROP"]]: null
    }, () => {
      if (transaction.length) {
        transaction.undo();
      }

      return ['autoreadystate', () => {
        stm.notifyStoresAboutStateRecordingStop(transaction, {
          rejected: true
        });
      }];
    }];
  }

  onModelUpdate(stm, ...rest) {
    super.onModelUpdate(stm, ...rest);
    stm.stopTransactionDelayed();
  }

  onModelInsertChild(stm, ...rest) {
    super.onModelInsertChild(stm, ...rest);
    stm.stopTransactionDelayed();
  }

  onModelRemoveChild(stm, ...rest) {
    super.onModelRemoveChild(stm, ...rest);
    stm.stopTransactionDelayed();
  }

  onStoreModelAdd(stm, ...rest) {
    super.onStoreModelAdd(stm, ...rest);
    stm.stopTransactionDelayed();
  }

  onStoreModelInsert(stm, ...rest) {
    super.onStoreModelInsert(stm, ...rest);
    stm.stopTransactionDelayed();
  }

  onStoreModelRemove(stm, ...rest) {
    super.onStoreModelRemove(stm, ...rest);
    stm.stopTransactionDelayed();
  }

  onStoreRemoveAll(stm, ...rest) {
    super.onStoreRemoveAll(stm, ...rest);
    stm.stopTransactionDelayed();
  }

}
/**
 * STM recording state.
 *
 * @internal
 */

const AutoRecordingState = new AutoRecordingStateClass();
/* harmony default export */ __webpack_exports__["default"] = (AutoRecordingState);
_Registry_js__WEBPACK_IMPORTED_MODULE_4__["default"].registerStmState('autorecordingstate', AutoRecordingState);

/***/ }),

/***/ "./lib/Core/data/stm/state/DisabledState.js":
/*!**************************************************!*\
  !*** ./lib/Core/data/stm/state/DisabledState.js ***!
  \**************************************************/
/*! exports provided: DisabledStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DisabledStateClass", function() { return DisabledStateClass; });
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
/* harmony import */ var _Helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Helpers.js */ "./lib/Core/data/stm/Helpers.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/state/DisabledState
*/





/**
 * STM disabled state class.
 *
 * @internal
 */

class DisabledStateClass extends _StateBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  canUndo() {
    return false;
  }

  canRedo() {
    return false;
  }

  onUndo() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onRedo() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onEnable(stm) {
    return stm.autoRecord ? 'autoreadystate' : 'readystate';
  }

  onDisable() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onAutoRecordOn() {
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["AUTO_RECORD_PROP"]]: true
    };
  }

  onAutoRecordOff() {
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["AUTO_RECORD_PROP"]]: false
    };
  }

  onStartTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStopTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStopTransactionDelayed() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onRejectTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onResetQueue(stm, options) {
    return Object(_Helpers_js__WEBPACK_IMPORTED_MODULE_3__["resetQueue"])(stm, options);
  }

  onModelUpdate() {}

  onModelInsertChild() {}

  onModelRemoveChild() {}

  onStoreModelAdd() {}

  onStoreModelInsert() {}

  onStoreModelRemove() {}

  onStoreRemoveAll() {}

}
/**
 * STM disabled state.
 *
 * @internal
 */

const DisabledState = new DisabledStateClass();
/* harmony default export */ __webpack_exports__["default"] = (DisabledState);
_Registry_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerStmState('disabledstate', DisabledState);

/***/ }),

/***/ "./lib/Core/data/stm/state/ReadyState.js":
/*!***********************************************!*\
  !*** ./lib/Core/data/stm/state/ReadyState.js ***!
  \***********************************************/
/*! exports provided: ReadyStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReadyStateClass", function() { return ReadyStateClass; });
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Transaction_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Transaction.js */ "./lib/Core/data/stm/Transaction.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
/* harmony import */ var _Helpers_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Helpers.js */ "./lib/Core/data/stm/Helpers.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/state/ReadyState
*/






/**
 * STM ready state class.
 *
 * @internal
 */

class ReadyStateClass extends _StateBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  canUndo(stm) {
    //      v
    // |*|*|
    return 0 < stm.position && stm.position <= stm.length;
  }

  canRedo(stm) {
    //  v
    // |*|*|
    return 0 <= stm.position && stm.position < stm.length;
  }

  onUndo(stm, steps) {
    const queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_2__["QUEUE_PROP"]];
    let curPos = stm.position,
        newPos = Math.max(0, curPos - steps);

    const next = () => {
      stm.notifyStoresAboutStateRestoringStart();

      while (curPos != newPos) {
        queue[--curPos].undo();
      }

      return [stm.autoRecord ? 'autoreadystate' : 'readystate', () => {
        stm.notifyStoresAboutStateRestoringStop();
      }];
    };

    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["STATE_PROP"]]: 'restoringstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["POS_PROP"]]: newPos
    }, next];
  }

  onRedo(stm, steps) {
    const queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_2__["QUEUE_PROP"]];
    let curPos = stm.position,
        newPos = Math.min(queue.length, curPos + steps);

    const next = () => {
      stm.notifyStoresAboutStateRestoringStart();

      do {
        queue[curPos++].redo();
      } while (curPos != newPos);

      return [stm.autoRecord ? 'autoreadystate' : 'readystate', () => {
        stm.notifyStoresAboutStateRestoringStop();
      }];
    };

    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["STATE_PROP"]]: 'restoringstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["POS_PROP"]]: newPos
    }, next];
  }

  onEnable() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onDisable() {
    return 'disabledstate';
  }

  onAutoRecordOn() {
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["STATE_PROP"]]: 'autoreadystate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["AUTO_RECORD_PROP"]]: true
    };
  }

  onAutoRecordOff() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStartTransaction(stm, title) {
    const transaction = new _Transaction_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
      title: title
    });
    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["STATE_PROP"]]: 'recordingstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_2__["TRANSACTION_PROP"]]: transaction
    }, () => {
      stm.notifyStoresAboutStateRecordingStart(transaction);
    }];
  }

  onStopTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStopTransactionDelayed() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onRejectTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onResetQueue(stm, options) {
    return Object(_Helpers_js__WEBPACK_IMPORTED_MODULE_4__["resetQueue"])(stm, options);
  }

  onModelUpdate() {}

  onModelInsertChild() {}

  onModelRemoveChild() {}

  onStoreModelAdd() {}

  onStoreModelInsert() {}

  onStoreModelRemove() {}

  onStoreRemoveAll() {}

}
/**
 * STM ready state.
 *
 * @internal
 */

let ReadyState = new ReadyStateClass();
/* harmony default export */ __webpack_exports__["default"] = (ReadyState);
_Registry_js__WEBPACK_IMPORTED_MODULE_3__["default"].registerStmState('readystate', ReadyState);

/***/ }),

/***/ "./lib/Core/data/stm/state/RecordingState.js":
/*!***************************************************!*\
  !*** ./lib/Core/data/stm/state/RecordingState.js ***!
  \***************************************************/
/*! exports provided: RecordingStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RecordingStateClass", function() { return RecordingStateClass; });
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
/* harmony import */ var _Helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Helpers.js */ "./lib/Core/data/stm/Helpers.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/state/RecordingState
*/





/**
 * STM recording state class.
 *
 * @internal
 */

class RecordingStateClass extends _StateBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  canUndo() {
    return false;
  }

  canRedo() {
    return false;
  }

  onEnable() {}

  onDisable(stm) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    stm.notifyStoresAboutStateRecordingStop(transaction, {
      disabled: true
    });
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["STATE_PROP"]]: 'disabledstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]]: null
    };
  }

  onAutoRecordOn(stm) {
    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["STATE_PROP"]]: 'autorecordingstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["AUTO_RECORD_PROP"]]: true
    }, () => {
      stm.stopTransactionDelayed();
    }];
  }

  onAutoRecordOff() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStartTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStopTransaction(stm, title) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    let position = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["POS_PROP"]];
    const queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["QUEUE_PROP"]];

    if (transaction.length) {
      if (!transaction.title && !title && stm.getTransactionTitle) {
        transaction.title = stm.getTransactionTitle(transaction);
      } else if (title) {
        transaction.title = title;
      }

      queue[position] = transaction;
      queue.length = ++position;
    }

    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["STATE_PROP"]]: 'readystate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["POS_PROP"]]: position,
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]]: null
    }, () => {
      stm.notifyStoresAboutStateRecordingStop(transaction, {
        stop: true
      });
    }];
  }

  onRejectTransaction(stm) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    return [{
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["STATE_PROP"]]: 'restoringstate',
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]]: null
    }, () => {
      if (transaction.length) {
        transaction.undo();
      }

      return ['readystate', () => {
        stm.notifyStoresAboutStateRecordingStop(transaction, {
          rejected: true
        });
      }];
    }];
  }

  onStopTransactionDelayed() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onResetQueue(stm, options) {
    return Object(_Helpers_js__WEBPACK_IMPORTED_MODULE_3__["resetQueue"])(stm, options);
  }

  onModelUpdate(stm, model, newData, oldData) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeModelUpdateAction(model, newData, oldData));
  }

  onModelInsertChild(stm, parentModel, index, childModel, previousParent, previousIndex) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeModelInsertChildAction(parentModel, index, childModel, previousParent, previousIndex));
  }

  onModelRemoveChild(stm, parentModel, childModels, context) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeModelRemoveChildAction(parentModel, childModels, context));
  }

  onStoreModelAdd(stm, store, models, silent) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeStoreModelAddAction(store, models, silent));
  }

  onStoreModelInsert(stm, store, index, models, context, silent) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeStoreModelInsertAction(store, index, models, context, silent));
  }

  onStoreModelRemove(stm, store, models, context, silent) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeStoreModelRemoveAction(store, models, context, silent));
  }

  onStoreRemoveAll(stm, store, allRecords, silent) {
    const transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["TRANSACTION_PROP"]];
    transaction.addAction(stm.makeStoreRemoveAllAction(store, allRecords, silent));
  }

}
/**
 * STM recording state.
 *
 * @internal
 */

const RecordingState = new RecordingStateClass();
/* harmony default export */ __webpack_exports__["default"] = (RecordingState);
_Registry_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerStmState('recordingstate', RecordingState);

/***/ }),

/***/ "./lib/Core/data/stm/state/Registry.js":
/*!*********************************************!*\
  !*** ./lib/Core/data/stm/state/Registry.js ***!
  \*********************************************/
/*! exports provided: registerStmState, resolveStmState, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerStmState", function() { return registerStmState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolveStmState", function() { return resolveStmState; });
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
var productName = 'taskboard';

/**
 * @module Core/data/stm/state/Registry
 *
 * Provides map of registered STM states.
 *
 * Needed to remove states circular dependency.
 *
 * @internal
 */

const registry = new Map();
/**
 * Registers STM state class with the given name.
 *
 * @private
 *
 * @param {String} name
 * @param {Core.data.stm.state.StateBase} state
 */

const registerStmState = (name, state) => {
  registry.set(name, state);
};
/**
 * Resolves STM state class with the given name.
 *
 * @private
 *
 * @param {String} name
 * @return {Core.data.stm.state.StateBase} state
 */

const resolveStmState = state => {
  if (typeof state === 'string') {
    state = registry.get(state);
  }

  return state;
}; // UMD/module compatible export
// NOTE: the most compatible way of exporting is:
//       import registry from './Registry.js';
//       { registerStmState, resolveStmState } = registry;
//          or
//       registry.registerStmState(...);

/* harmony default export */ __webpack_exports__["default"] = ({
  registerStmState,
  resolveStmState
});

/***/ }),

/***/ "./lib/Core/data/stm/state/RestoringState.js":
/*!***************************************************!*\
  !*** ./lib/Core/data/stm/state/RestoringState.js ***!
  \***************************************************/
/*! exports provided: RestoringStateClass, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RestoringStateClass", function() { return RestoringStateClass; });
/* harmony import */ var _StateBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony import */ var _Props_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Props.js */ "./lib/Core/data/stm/Props.js");
/* harmony import */ var _Registry_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Registry.js */ "./lib/Core/data/stm/state/Registry.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/state/RestoringState
*/




/**
 * STM restoring state class.
 *
 * @internal
 */

class RestoringStateClass extends _StateBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  canUndo() {
    return false;
  }

  canRedo() {
    return false;
  }

  onUndo() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onRedo() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onEnable() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onDisable() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onAutoRecordOn() {
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["AUTO_RECORD_PROP"]]: true
    };
  }

  onAutoRecordOff() {
    return {
      [_Props_js__WEBPACK_IMPORTED_MODULE_1__["AUTO_RECORD_PROP"]]: false
    };
  }

  onStartTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStopTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onStopTransactionDelayed() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onRejectTransaction() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onQueueReset() {
    Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_0__["throwInvalidMethodCall"])();
  }

  onModelUpdate() {}

  onModelInsertChild() {}

  onModelRemoveChild() {}

  onStoreModelAdd() {}

  onStoreModelInsert() {}

  onStoreModelRemove() {}

  onStoreRemoveAll() {}

}
/**
 * STM restoring state.
 *
 * @internal
 */

const RestoringState = new RestoringStateClass();
/* harmony default export */ __webpack_exports__["default"] = (RestoringState);
_Registry_js__WEBPACK_IMPORTED_MODULE_2__["default"].registerStmState('restoringstate', RestoringState);

/***/ }),

/***/ "./lib/Core/data/stm/state/StateBase.js":
/*!**********************************************!*\
  !*** ./lib/Core/data/stm/state/StateBase.js ***!
  \**********************************************/
/*! exports provided: throwAbstractMethodCall, throwInvalidMethodCall, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwAbstractMethodCall", function() { return throwAbstractMethodCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwInvalidMethodCall", function() { return throwInvalidMethodCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StateBase; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';
/**
* @module Core/data/stm/state/StateBase
*/


const throwAbstractMethodCall = () => {
  throw new Error('Abstract method call!');
};
const throwInvalidMethodCall = () => {
  throw new Error('Method cannot be called at this state!');
};
/**
 * Abstract class for STM states
 *
 * Every on* method should return a state for the STM which it should switch to
 * or throw an exception that this call at this state is illegal.
 *
 * Interface of this class mirrors interface of {@link Core.data.stm.StateTrackingManager}.
 *
 * @abstract
 */

class StateBase extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  canUndo(stm) {
    throwAbstractMethodCall();
  }

  canRedo(stm) {
    throwAbstractMethodCall();
  }

  onUndo(stm) {
    throwAbstractMethodCall();
  }

  onRedo(stm) {
    throwAbstractMethodCall();
  }

  onStartTransaction(stm) {
    throwAbstractMethodCall();
  }

  onStopTransaction(stm) {
    throwAbstractMethodCall();
  }

  onStopTransactionDelayed(stm) {
    throwAbstractMethodCall();
  }

  onRejectTransaction(stm) {
    throwAbstractMethodCall();
  }

  onEnable(stm) {
    throwAbstractMethodCall();
  }

  onDisable(stm) {
    throwAbstractMethodCall();
  }

  onAutoRecordOn(stm) {
    throwAbstractMethodCall();
  }

  onAutoRecordOff(stm) {
    throwAbstractMethodCall();
  }

  onResetQueue(stm) {
    throwAbstractMethodCall();
  }

  onModelUpdate(stm) {
    throwAbstractMethodCall();
  }

  onStoreModelAdd(stm) {
    throwAbstractMethodCall();
  }

  onStoreModelInsert(stm) {
    throwAbstractMethodCall();
  }

  onStoreModelRemove(stm) {
    throwAbstractMethodCall();
  }

  onStoreModelRemoveAll(stm) {
    throwAbstractMethodCall();
  }

  onModelInsertChild(stm) {
    throwAbstractMethodCall();
  }

  onModelRemoveChild(stm) {
    throwAbstractMethodCall();
  }

}
StateBase._$name = 'StateBase';

/***/ }),

/***/ "./lib/Core/feature/base/ContextMenuBase.js":
/*!**************************************************!*\
  !*** ./lib/Core/feature/base/ContextMenuBase.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ContextMenuBase; });
/* harmony import */ var _mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _widget_Menu_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../widget/Menu.js */ "./lib/Core/widget/Menu.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
var productName = 'taskboard';








/**
 * @module Core/feature/base/ContextMenuBase
 */

/**
 * Abstract base class used by other context menu features.
 * @extends Core/mixin/InstancePlugin
 * @abstract
 */

class ContextMenuBase extends _mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ContextMenuBase';
  } //region Config


  static get configurable() {
    return {
      /**
       * This is a type of the context menu used to generate correct names for methods and events.
       * Should be in camel case. Required to be set in subclass.
       * @config {String}
       * @readonly
       */
      type: null,

      /**
       * Gets the Menu instance that this feature is using.
       * @member {Core.widget.Menu} menu
       * @readonly
       */

      /**
       * A config which will be applied when creating the Menu component.
       * @config {Object}
       */
      menu: {
        $config: ['lazy', 'nullify'],
        value: {
          type: 'menu',
          autoShow: false,
          closeAction: 'hide',
          scrollAction: 'hide',
          constrainTo: window
        }
      },

      /**
       * A config which will be applied when creating the Menu component.
       * @config {Object}
       * @deprecated 4.0.5 Use {@link #config-menu} instead.
       */
      menuConfig: null,

      /**
       * {@link Core.widget.Menu Menu} items object containing named child menu items to apply to the feature's
       * provided context menu.
       *
       * This may add extra items as below, but may also remove any of the default items by configuring the name
       * of the item as `false`
       *
       * ```javascript
       * features : {
       *     cellMenu : {
       *         // This object is applied to the Feature's predefined default items
       *         items : {
       *             switchToDog : {
       *                 text : 'Dog',
       *                 icon : 'b-fa b-fa-fw b-fa-dog',
       *                 onItem({contextRecord}) {
       *                     contextRecord.dog = true;
       *                     contextRecord.cat = false;
       *                 },
       *                 weight : 500     // Make this second from end
       *             },
       *             switchToCat : {
       *                 text : 'Cat',
       *                 icon : 'b-fa b-fa-fw b-fa-cat',
       *                 onItem({contextRecord}) {
       *                     contextRecord.dog = false;
       *                     contextRecord.cat = true;
       *                 },
       *                 weight : 510     // Make this sink to end
       *             },
       *             add : false // We do not want the "Add" submenu to be available
       *         }
       *     }
       * }
       * ```
       *
       * @config {Object}
       */
      items: {},

      /**
       * Event which is used to show context menu.
       * Available options are: 'contextmenu', 'click', 'dblclick' or `false` to disable.
       * Default value is used from {@link Grid/view/GridBase#config-contextMenuTriggerEvent}
       * @config {String|Boolean}
       */
      triggerEvent: false
    };
  } // Plugin configuration. This plugin chains some of the functions in Grid.
  // The contextmenu event is emulated from a taphold gesture on touch platforms.


  static get pluginConfig() {
    return {
      assign: ['showContextMenu'],
      chain: ['onElementContextMenu', 'onElementClick', 'onElementDblClick', 'onElementKeyDown']
    };
  } //endregion
  //region Init


  construct(...args) {
    var _this$type;

    const config = args[args.length === 1 ? 0 : 1]; // Copy deprecated config into its correct place.

    if (config && 'menuConfig' in config) {
      _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].deprecate('Grid', '5.0.0', '`menuConfig` attribute deprecated, in favour of `menu`');
      config.menu = config.menuConfig;
    }

    super.construct(...args);

    if (!((_this$type = this.type) !== null && _this$type !== void 0 && _this$type.length)) {
      throw new Error(`Config 'type' is required to be specified for context menu`);
    }
  } //endregion
  //region Events

  /**
   * This event fires on the owning widget when an item is selected in the context menu.
   * @event contextMenuItem
   * @on-owner
   * @param {Core.widget.Widget} source The owning widget
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} item Selected menu item
   */

  /**
   * This event fires on the owning widget when a check item is toggled in the context menu.
   * @event contextMenuToggleItem
   * @on-owner
   * @param {Core.widget.Widget} source The owning widget
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} item Selected menu item
   * @param {Boolean} checked Checked or not
   */


  onElementContextMenu(event) {
    this.onElementEvent(event);
  }

  onElementClick(event) {
    this.onElementEvent(event);
  }

  onElementDblClick(event) {
    this.onElementEvent(event);
  }

  onElementEvent(event) {
    this.triggerEvent === event.type && this.internalShowContextMenu(event);
  }

  onElementKeyDown(event) {} //endregion
  //region Menu handlers


  internalShowContextMenu(event) {
    const me = this;

    if (me.disabled) {
      return;
    }

    const data = me.getDataFromEvent(event);

    if (me.shouldShowMenu(data)) {
      me.showContextMenu(data);
    }
  }

  getDataFromEvent(event) {
    return {
      event,
      targetElement: this.getTargetElementFromEvent(event)
    };
  }

  getTargetElementFromEvent(event) {
    return event.target;
  }
  /**
   * Shows the context menu.
   * @param {Event} event The initiating event.
   * @param {Object|HTMLElement} [alignSpec] Menu alignment specification, or an element to align to
   * @param {HTMLElement|Core.helper.util.Rectangle} alignSpec.target The Element or Rectangle to align to.
   * @param {Boolean} [alignSpec.anchor] True to show a pointer arrow connecting to the target. Defaults to false.
   * @param {Boolean} [alignSpec.overlap] True to allow this to overlap the target.
   * @param {String} alignSpec.align The alignment specification string, `[trbl]n-[trbl]n`.
   * @on-owner
   */


  showContextMenu(domEvent, alignSpec) {
    var _me$_menu;

    const me = this,
          menuContext = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isDOMEvent(domEvent) ? me.getDataFromEvent(domEvent) : domEvent; // If our menu was visible from last invocation, hide it.
    // Apps may need the ${type}MenuShow event which is triggered in onShow.

    (_me$_menu = me._menu) === null || _me$_menu === void 0 ? void 0 : _me$_menu.hide();

    if (me.disabled) {
      return;
    }
    /**
     * @member {Object} menuContext
     * An informational object containing contextual information about the last activation
     * of the context menu. The base properties are listed below. Some subclasses may add extra
     * contextual information such as `eventRecord` and `resourceRecord` to the block.
     * @property {Event} menuContext.event The initiating event.
     * @property {Number[]} menuContext.point The client `X` and `Y` position of the initiating event.
     * @property {HTMLElement} menuContext.targetElement The target to which the menu is being applied.
     * @property {Object} menuContext.items The context menu **configuration** items.
     * @property {Core.data.Model[]} menuContext.selection The record selection in the client (Grid, Scheduler, Gantt or Calendar).
     * @readonly
     */


    me.menuContext = menuContext;
    const {
      type,
      client,
      processItems
    } = me,
          {
      event
    } = menuContext,
          elCenter = event !== null && event !== void 0 ? event : _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(menuContext.targetElement).center;
    _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(menuContext, {
      point: event ? [event.clientX + 1, event.clientY + 1] : [elCenter.x, elCenter.y],
      menu: me,
      items: {},
      selection: me.client.selectedRecords
    }); // Call the chainable method which other features use to add or remove their own menu items.

    me.callChainablePopulateMenuMethod(menuContext); // Merge with user defined items

    _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(menuContext.items, me.baseItems); // Allow user a chance at processing the items and preventing the menu from showing

    if ((!processItems || processItems(menuContext) !== false) && me.hasActiveMenuItems(menuContext)) {
      me.populateItemsWithData(menuContext);
      me.preventDefaultEvent(menuContext); // beforeContextMenuShow is a lifecycle method which may be implemented in subclasses to preprocess the event.

      if (me.beforeContextMenuShow(menuContext) !== false) {
        // Trigger event that allows preventing menu or manipulating its items
        if (client.trigger(`${type}MenuBeforeShow`, menuContext) !== false && // TODO: cellContextMenuBeforeShow and headerContextMenuBeforeShow events are deprecated in ContextMenu feature
        client.trigger(`${type}ContextMenuBeforeShow`, menuContext) !== false) {
          var _me$touchMoveDetacher;

          me.menu.items = menuContext.items;

          if (alignSpec) {
            me.menu.showBy(alignSpec);
          } else {
            me.menu.showByPoint(menuContext.point);
          } // Any drag drop type action should hide the menu


          (_me$touchMoveDetacher = me.touchMoveDetacher) === null || _me$touchMoveDetacher === void 0 ? void 0 : _me$touchMoveDetacher.call(me);
          me.touchMoveDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].on({
            element: client.element,
            touchmove: () => me.menu.hide(),
            once: true
          });
        }
      }
    }
  }
  /**
   * Returns the base, configured-in menu items set from the configured items, taking into
   * account the namedItems the feature offers.
   * @property {Object[]}
   * @readonly
   * @internal
   */


  get baseItems() {
    if (!this._baseItems) {
      const me = this,
            {
        namedItems
      } = me,
            baseItems = me._baseItems = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, me.items); // Substitute any named items into any of our items that reference them.

      for (const ref in baseItems) {
        const item = baseItems[ref];

        if (item) {
          // If this class or instance has a "namedItems" object
          // named by this ref, then use it as the basis for the item
          if (namedItems && ref in namedItems) {
            baseItems[ref] = typeof item === 'object' ? _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(namedItems[ref]), item) : namedItems[ref];
          } else if (item === true) {
            delete baseItems[ref];
          }
        }
      }
    }

    return this._baseItems;
  }
  /**
   * Hides the context menu
   * @internal
   */


  hideContextMenu(animate) {
    var _this$menu;

    (_this$menu = this.menu) === null || _this$menu === void 0 ? void 0 : _this$menu.hide(animate);
  }

  callChainablePopulateMenuMethod(eventParams) {
    var _this$client$, _this$client;

    // For example `populateCellMenu`
    (_this$client$ = (_this$client = this.client)[`populate${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].capitalize(this.type)}Menu`]) === null || _this$client$ === void 0 ? void 0 : _this$client$.call(_this$client, eventParams);
  }

  createContextMenuEventForElement(targetElement) {
    const targetPoint = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(targetElement).center,
          contextmenuEvent = new MouseEvent(this.triggerEvent, {
      clientX: targetPoint.x,
      clientY: targetPoint.y
    });
    Object.defineProperty(contextmenuEvent, 'target', {
      get() {
        return targetElement;
      }

    });
    return contextmenuEvent;
  }

  hasActiveMenuItems(eventParams) {
    return Object.values(eventParams.items).some(item => item);
  }
  /**
   * Override this function and return `false` to prevent the context menu from being shown. Returns `true` by default.
   * @return {Boolean}
   * @internal
   */


  shouldShowMenu() {
    return true;
  }

  beforeContextMenuShow(eventParams) {}

  populateItemsWithData(eventParams) {}

  preventDefaultEvent(eventParams) {
    var _eventParams$event;

    (_eventParams$event = eventParams.event) === null || _eventParams$event === void 0 ? void 0 : _eventParams$event.preventDefault();
  } //endregion
  //region Configurables


  changeTriggerEvent(triggerEvent) {
    return triggerEvent || this.client.contextMenuTriggerEvent;
  }

  changeMenu(menu, oldMenu) {
    const me = this,
          {
      client,
      type
    } = me;

    if (menu) {
      return _widget_Menu_js__WEBPACK_IMPORTED_MODULE_1__["default"].reconfigure(oldMenu, menu ? _widget_Menu_js__WEBPACK_IMPORTED_MODULE_1__["default"].mergeConfigs({
        owner: client,
        rootElement: client.rootElement,

        onItem(itemEvent) {
          client.trigger(`${type}MenuItem`, itemEvent); // TODO: contextMenuItem event is deprecated in ContextMenu feature

          client.trigger('contextMenuItem', itemEvent); // TODO: eventContextMenuItem event and schedulerContextMenuItem event are deprecated

          client.trigger(`${type}ContextMenuItem`, itemEvent);
        },

        onToggle(itemEvent) {
          client.trigger(`${type}MenuToggleItem`, itemEvent); // TODO: contextMenuToggleItem event is deprecated in ContextMenu feature

          client.trigger('contextMenuToggleItem', itemEvent);
        },

        onDestroy() {
          me.menu = null;
        },

        // Load up the item event with the contextual info
        onBeforeItem(itemEvent) {
          Object.assign(itemEvent, me.menuContext);
        },

        onShow({
          source: menu
        }) {
          me.menuContext.menu = menu;
          client.trigger(`${type}MenuShow`, me.menuContext); // TODO: cellContextMenuShow and headerContextMenuShow events are deprecated in ContextMenu feature

          client.trigger(`${type}ContextMenuShow`, me.menuContext);
        }

      }, menu) : null, me);
    } else if (oldMenu !== null && oldMenu !== void 0 && oldMenu.isWidget) {
      oldMenu.destroy();
    }
  } //endregion


}
ContextMenuBase._$name = 'ContextMenuBase';

/***/ }),

/***/ "./lib/Core/helper/AjaxHelper.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/AjaxHelper.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AjaxHelper; });
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var _BrowserHelper$queryS;

var productName = 'taskboard';
/**
* @module Core/helper/AjaxHelper
*/



const paramValueRegExp = /^(\w+)=(.*)$/,
      // For CodePens, adjust URLs to be absolute
resourceRoot = ((_BrowserHelper$queryS = _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].queryString) === null || _BrowserHelper$queryS === void 0 ? void 0 : _BrowserHelper$queryS.__resourceRoot) || '',
      parseParams = function (paramString) {
  const result = {},
        params = paramString.split('&'); // loop through each 'filter={"field":"name","operator":"=","value":"Sweden","caseSensitive":true}' string
  // So we cannot use .split('=')

  for (const nameValuePair of params) {
    const [match, name, value] = paramValueRegExp.exec(nameValuePair),
          decodedName = decodeURIComponent(name),
          decodedValue = decodeURIComponent(value);

    if (match) {
      let paramValue = result[decodedName];

      if (paramValue) {
        if (!Array.isArray(paramValue)) {
          paramValue = result[decodedName] = [paramValue];
        }

        paramValue.push(decodedValue);
      } else {
        result[decodedName] = decodedValue;
      }
    }
  }

  return result;
};
/**
 * Simplifies Ajax requests. Uses fetch & promises.
 *
 * ```javascript
 * AjaxHelper.get('some-url').then(response => {
 *     // process request response here
 * });
 * ```
 *
 * Uploading file to server via FormData interface.
 * Please visit [FormData](https://developer.mozilla.org/en-US/docs/Web/API/FormData) for details.
 *
 * ```javascript
 * const formData = new FormData();
 * formData.append('file', 'fileNameToUpload');
 * AjaxHelper.post('file-upload-url', formData).then(response => {
 *     // process request response here
 * });
 * ```
 *
 */


class AjaxHelper {
  /**
   * Make a request (using GET) to the specified url.
   * @param {String} url Url
   * @param {Object} [options] The options for the `fetch` API. Please see [fetch API](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch) for details
   * @param {Object} [options.queryParams] A key-value pair Object containing the params to add to the query string
   * @param {Object} [options.headers] Any headers you want to add to your request, contained within a `Headers object or an object literal with ByteString values
   * @param {Object} [options.body] Any body that you want to add to your request: this can be a Blob, BufferSource, FormData, URLSearchParams, or USVString object. Note that a request using the GET or HEAD method cannot have a body.
   * @param {Object} [options.mode] The mode you want to use for the request, e.g., cors, no-cors, or same-origin.
   * @param {Object} [options.credentials] The request credentials you want to use for the request: omit, same-origin, or include. To automatically send cookies for the current domain, this option must be provided
   * @param {Object} [options.parseJson] Specify `true` to parses the response and attach the resulting object to the `Response` object as `parsedJson`
   * @returns {Promise} The fetch Promise, which can be aborted by calling a special `abort` method
   */
  static get(url, options) {
    return this.fetch(url, options);
  }
  /**
   * POST data to the specified URL.
   * @param {String} url The URL
   * @param {String|Object|FormData} payload The data to post. If an object is supplied, it will be stringified
   * @param {Object} options The options for the `fetch` API. Please see [fetch API](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch) for details
   * @param {Object} [options.queryParams] A key-value pair Object containing the params to add to the query string
   * @param {Object} [options.headers] Any headers you want to add to your request, contained within a `Headers object or an object literal with ByteString values
   * @param {Object} [options.body] Any body that you want to add to your request: this can be a Blob, BufferSource, FormData, URLSearchParams, or USVString object. Note that a request using the GET or HEAD method cannot have a body.
   * @param {Object} [options.mode] The mode you want to use for the request, e.g., cors, no-cors, or same-origin.
   * @param {Object} [options.credentials] The request credentials you want to use for the request: omit, same-origin, or include. To automatically send cookies for the current domain, this option must be provided
   * @param {Object} [options.parseJson] Specify `true` to parses the response and attach the resulting object to the `Response` object as `parsedJson`
   * @returns {Promise} The fetch Promise, which can be aborted by calling a special `abort` method
   */


  static post(url, payload, options = {}) {
    if (!(payload instanceof FormData) && !(typeof payload === 'string')) {
      payload = JSON.stringify(payload);
      options.headers = options.headers || {};
      options.headers['Content-Type'] = options.headers['Content-Type'] || 'application/json';
    }

    return this.fetch(url, Object.assign({
      method: 'POST',
      body: payload
    }, options));
  }
  /**
   * Fetch the specified resource using the `fetch` API.
   * @param {String} url object to fetch
   * @param {Object} options The options for the `fetch` API. Please see [fetch API](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch) for details
   * @param {Object} [options.method] The request method, e.g., GET, POST
   * @param {Object} [options.queryParams] A key-value pair Object containing the params to add to the query string
   * @param {Object} [options.headers] Any headers you want to add to your request, contained within a `Headers object or an object literal with ByteString values
   * @param {Object} [options.body] Any body that you want to add to your request: this can be a Blob, BufferSource, FormData, URLSearchParams, or USVString object. Note that a request using the GET or HEAD method cannot have a body.
   * @param {Object} [options.mode] The mode you want to use for the request, e.g., cors, no-cors, or same-origin.
   * @param {Object} [options.credentials] The request credentials you want to use for the request: omit, same-origin, or include. To automatically send cookies for the current domain, this option must be provided
   * @param {Object} [options.parseJson] Specify `true` to parses the response and attach the resulting object to the `Response` object as `parsedJson`
   * @returns {Promise} The fetch Promise, which can be aborted by calling a special `abort` method
   */


  static fetch(url, options = {}) {
    let controller; // AbortController is not supported by LockerService
    // https://github.com/bryntum/support/issues/3689

    if (typeof AbortController !== 'undefined') {
      controller = new AbortController(); // Need to assign AbortController individually, because IE11 polyfill of the Fetch API deletes 'signal' property on fetchOptions object

      Object.assign(options, {
        abortController: controller,
        signal: controller.signal
      });
    }

    if (!('credentials' in options)) {
      options.credentials = 'include';
    }

    if (options.queryParams) {
      const params = Object.entries(options.queryParams);

      if (params.length) {
        url += (url.includes('?') ? '&' : '?') + params.map(([param, value]) => `${param}=${encodeURIComponent(value)}`).join('&');
      }
    } // Promise that will be resolved either when network request is finished or when json is parsed


    const promise = new Promise((resolve, reject) => {
      fetch(resourceRoot + url, options).then(response => {
        if (options.parseJson) {
          response.json().then(json => {
            response.parsedJson = json;
            resolve(response);
          }).catch(error => {
            response.parsedJson = null;
            response.error = error;
            reject(response);
          });
        } else {
          resolve(response);
        }
      }).catch(error => {
        error.stack = promise.stack; // Unless calling code aborted the request, reject this operation

        if (error.name !== 'AbortError') {
          reject(error);
        }
      });
    });
    promise.stack = new Error().stack;

    promise.abort = function () {
      var _controller;

      (_controller = controller) === null || _controller === void 0 ? void 0 : _controller.abort();
    };

    return promise;
  }
  /**
   * Registers the passed URL to return the passed mocked up Fetch Response object to the
   * AjaxHelper's promise resolve function.
   * @param {String} url The url to return mock data for
   * @param {Object|Function} response A mocked up Fetch Response object which must contain
   * at least a `responseText` property, or a function to which the `url` and a `params` object
   * and the `Fetch` `options` object is passed which returns that.
   * @param {String} response.responseText The data to return.
   * @param {Boolean} [response.synchronous] resolve the Promise immediately
   * @param {Number} [response.delay=100] resolve the Promise after this number of milliseconds.
   */


  static mockUrl(url, response) {
    const me = this;
    (me.mockAjaxMap || (me.mockAjaxMap = {}))[url] = response; // Inject the override into the AjaxHelper instance

    if (!AjaxHelper.originalFetch) {
      AjaxHelper.originalFetch = AjaxHelper.fetch;
    }

    AjaxHelper.fetch = me.mockAjaxFetch.bind(me);
  }

  static mockAjaxFetch(url, options) {
    let urlAndParams = url.split('?'),
        result = this.mockAjaxMap[urlAndParams[0]],
        parsedJson = null;

    if (result) {
      if (typeof result === 'function') {
        result = result(urlAndParams[0], urlAndParams[1] && parseParams(urlAndParams[1]), options);
      }

      try {
        parsedJson = options.parseJson && JSON.parse(result.responseText);
      } catch (error) {
        parsedJson = null;
        result.error = error;
      }

      result = Object.assign({
        status: 200,
        ok: true,
        headers: new Headers(),
        statusText: 'OK',
        url: url,
        parsedJson: parsedJson,
        text: () => new Promise(resolve => {
          resolve(result.responseText);
        }),
        json: () => new Promise(resolve => {
          resolve(parsedJson);
        })
      }, result);
      return new Promise(function (resolve, reject) {
        if (result.synchronous) {
          resolve(result);
        } else {
          setTimeout(function () {
            resolve(result);
          }, 'delay' in result ? result.delay : 100);
        }
      });
    } else {
      return AjaxHelper.originalFetch(url, options);
    }
  }

}
AjaxHelper._$name = 'AjaxHelper';

/***/ }),

/***/ "./lib/Core/helper/ArrayHelper.js":
/*!****************************************!*\
  !*** ./lib/Core/helper/ArrayHelper.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ArrayHelper; });
var productName = 'taskboard';
/**
* @module Core/helper/ArrayHelper
*/

/**
 * Helper with useful functions for handling Arrays
 * @internal
 */

class ArrayHelper {
  static clean(array) {
    return array.reduce((res, item) => {
      if (item !== null && item !== undefined && !(Array.isArray(item) && item.length === 0) && item !== '') res.push(item);
      return res;
    }, []);
  }
  /**
   * Similar to [`Array.from()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from)
   * this method creates an array from an `iterable` object. Where `Array.from()` accepts a mapper function as the
   * second argument, this method accepts a `filter` function as its second argment. If a mapper function is also
   * needed, it can be passed as the third argument. Unlike `Array.from()`, if this method is passed `null`, it will
   * return an empty array.
   * @param {Array} iterable The iterable object to convert (must support `for-of` loop iteration).
   * @param {Function} [filter] A function to apply to each item of the `iterable` which must return a truthy value
   * to include that item in the resulting array.
   * @param {Function} [map] A function to apply to each item of the `iterable` that returns the actual value to put
   * into the returned array. If a `filter` is also supplied, this method is only called for those items that pass
   * the filter test.
   * @returns {Array}
   */


  static from(iterable, filter, map) {
    const array = [];

    if (iterable) {
      for (const it of iterable) {
        if (!filter || filter(it)) {
          array.push(map ? map(it) : it);
        }
      }
    }

    return array;
  }
  /**
   * Remove one or more items from an array
   * @param {Array} array Array to remove from
   * @param {Object} items One or more items to remove
   * @returns {Boolean} Returns true if any item was removed
   */


  static remove(array, ...items) {
    let index,
        item,
        removed = false;

    for (let i = 0; i < items.length; i++) {
      item = items[i];

      if ((index = array.indexOf(item)) !== -1) {
        array.splice(index, 1);
        removed = true;
      }
    }

    return removed;
  }
  /*
   * Calculates the insertion index of a passed object into the passed Array according
   * to the passed comparator function. Note that the passed Array *MUST* already be ordered.
   * @param {Object} item The item to calculate the insertion index for.
   * @param {Array} The array into which the item is to be inserted.
   * @param {Function} comparatorFn The comparison function. Must return -1 or 0 or 1.
   * @param {Object} comparatorFn.lhs The left object to compare.
   * @param {Object} comparatorFn.rhs The right object to compare.
   * @param {Number} index The possible correct index to try first before a binary
   * search is instigated.
   */


  static findInsertionIndex(item, array, comparatorFn = this.lexicalCompare, index) {
    const len = array.length;
    let beforeCheck, afterCheck;

    if (index < len) {
      beforeCheck = index > 0 ? comparatorFn(array[index - 1], item) : 0;
      afterCheck = index < len - 1 ? comparatorFn(item, array[index]) : 0;

      if (beforeCheck < 1 && afterCheck < 1) {
        return index;
      }
    }

    return this.binarySearch(array, item, comparatorFn);
  }
  /**
   * Similar to the native Array.find call, but this finds the *last* element in the array for which
   * the passed function returns a truthy value.
   * @param {Object[]} array The array to find in.
   * @param {Function} fn The testing function.
   * @param {Object} [thisObj] The scope (`this` reference) in which to call the function.
   */


  static findLast(array, fn, thisObj) {
    for (let {
      length
    } = array, i = length - 1; i >= 0; i--) {
      if (fn.call(thisObj, array[i], i, array)) {
        return array[i];
      }
    }
  }
  /**
   * This method returns the index that a given item would be inserted into the
   * given (sorted) `array`. Note that the given `item` may or may not be in the
   * array. This method will return the index of where the item *should* be.
   *
   * For example:
   *
   *      var array = [ 'A', 'D', 'G', 'K', 'O', 'R', 'X' ];
   *      var index = ArrayHelper.binarySearch(array, 'E');
   *
   *      console.log('index: ' + index);
   *      // logs "index: 2"
   *
   *      array.splice(index, 0, 'E');
   *
   *      console.log('array : ' + array.join(''));
   *      // logs "array: ADEGKORX"
   *
   * @param {Object[]} array The array to search.
   * @param {Object} item The item that you want to insert into the `array`.
   * @param {Number} [begin=0] The first index in the `array` to consider.
   * @param {Number} [end=array.length] The index that marks the end of the range
   * to consider. The item at this index is *not* considered.
   * @param {Function} [compareFn] The comparison function that matches the sort
   * order of the `array`. The default `compareFn` compares items using less-than
   * and greater-than operators.
   * @return {Number} The index for the given item in the given array based on
   * the passed `compareFn`.
   */


  static binarySearch(array, item, begin = 0, end = array.length, compareFn = this.lexicalCompare) {
    const length = array.length;
    let middle, comparison;

    if (begin instanceof Function) {
      compareFn = begin;
      begin = 0;
    } else if (end instanceof Function) {
      compareFn = end;
      end = length;
    }

    --end;

    while (begin <= end) {
      middle = begin + end >> 1;
      comparison = compareFn(item, array[middle]);

      if (comparison >= 0) {
        begin = middle + 1;
      } else if (comparison < 0) {
        end = middle - 1;
      }
    }

    return begin;
  }

  magnitudeCompare(lhs, rhs) {
    return lhs < rhs ? -1 : lhs > rhs ? 1 : 0;
  }

  lexicalCompare(lhs, rhs) {
    lhs = String(lhs);
    rhs = String(rhs);
    return lhs < rhs ? -1 : lhs > rhs ? 1 : 0;
  }
  /**
   * Similar to Array.prototype.fill(), but constructs a new array with the specified item count and fills it with
   * clones of the supplied item.
   * @param {Number} count Number of entries to create
   * @param {Object|Array} itemOrArray Item or array of items to clone (uses object spread to create shallow clone)
   * @param {Function} [fn] An optional function that is called for each item added, to allow processing
   * @returns {Array} A new populated array
   */


  static fill(count, itemOrArray = {}, fn = null) {
    const result = [],
          items = Array.isArray(itemOrArray) ? itemOrArray : [itemOrArray];

    for (let i = 0; i < count; i++) {
      for (const item of items) {
        // Using object spread here forces us to use more babel plugins and will make
        // react_typescript demo very difficult to setup
        const processedItem = Object.assign({}, item);

        if (fn) {
          fn(processedItem, i);
        }

        result.push(processedItem);
      }
    }

    return result;
  }
  /**
   * Populates an array with the return value from `fn`.
   * @param {Number} count Number of entries to create
   * @param {Function} fn A function that is called `count` times, return value is added to array
   * @param {Number} fn.index Current index in the array
   * @privateparam {Boolean} [oneBased] Add 1 to the index before calling the fn (making it 1 based)
   * @returns {Array} A new populated array
   */


  static populate(count, fn, oneBased = false) {
    const items = [];

    for (let i = 0; i < count; i++) {
      items.push(fn(i + (oneBased ? 1 : 0)));
    }

    return items;
  }
  /**
   * Pushes `item` on to the `array` if not already included
   * @param {Array}  array Array to push to
   * @param {Object} item Item to push if not already included
   */


  static include(array, item) {
    if (!array.includes(item)) {
      array.push(item);
    }
  }
  /**
   * Returns a new array with the unique items from the supplied array.
   * @param {Array} array Input array
   * @returns {Array} New array with unique items
   */


  static unique(array) {
    return [...new Set(array)];
  } // Wanted to create an indexer on Stores, based on this. But turns out Proxy cannot be transpiled/polyfill for IE11
  // Keeping it for future reference


  static allowNegative(array) {
    // From https://github.com/sindresorhus/negative-array
    return new Proxy(array, {
      get(target, name, receiver) {
        if (typeof name !== 'string') {
          return Reflect.get(target, name, receiver);
        }

        const index = Number(name);

        if (Number.isNaN(index)) {
          return Reflect.get(target, name, receiver);
        }

        return target[index < 0 ? target.length + index : index];
      },

      set(target, name, value, receiver) {
        if (typeof name !== 'string') {
          return Reflect.set(target, name, value, receiver);
        }

        const index = Number(name);

        if (Number.isNaN(index)) {
          return Reflect.set(target, name, value, receiver);
        }

        target[index < 0 ? target.length + index : index] = value;
        return true;
      }

    });
  }

  static delta(a, b, useRelativeNaming = false) {
    // Nicer syntax but about 40% slower (an extra iteration)
    // const
    //     onlyInA = a.filter(item => !b.includes(item)),
    //     onlyInB = b.filter(item => !a.includes(item)),
    //     inBoth  = a.filter(item => b.includes(item));
    // Quick bailout for nonexisting target array
    if (!b) {
      return useRelativeNaming ? {
        toAdd: a,
        toRemove: [],
        toKeep: []
      } : {
        onlyInA: a,
        onlyInB: [],
        inBoth: []
      };
    }

    const onlyInA = [],
          onlyInB = [],
          inBoth = [];

    for (let i = 0; i < a.length; i++) {
      const item = a[i];

      if (b.includes(item)) {
        inBoth.push(item);
      } else {
        onlyInA.push(item);
      }
    }

    for (let i = 0; i < b.length; i++) {
      const item = b[i];

      if (!inBoth.includes(item)) {
        onlyInB.push(item);
      }
    }

    if (useRelativeNaming) {
      return {
        toAdd: onlyInA,
        toRemove: onlyInB,
        toKeep: inBoth
      };
    }

    return {
      onlyInA,
      onlyInB,
      inBoth
    };
  }

} // This has been tested on IE11 but not pre-webkit Edge

(count => {
  const array = new Array(count),
        buckets = {};
  let i, k, unstable, v;

  for (i = 0; i < count; ++i) {
    array[i] = [Math.floor(Math.random() * 3) + 1, i + 1]; // [1..3, 1..count]
  }

  array.sort((a, b) => a[0] - b[0]);

  for (i = 0; i < count && !unstable; ++i) {
    [k, v] = array[i];
    unstable = buckets[k] > v;
    buckets[k] = v;
  }

  if (unstable) {
    const {
      prototype
    } = Array,
          {
      sort: nativeSort
    } = prototype,
          compare = (a, b) => a < b ? -1 : b < a ? 1 : 0,
          sort = function sort(compareFn) {
      const me = this,
            len = me.length;
      let i, temp;

      if (len > 1) {
        temp = new Array(len);

        for (i = len; i-- > 0;) {
          temp[i] = i;
        }

        compareFn = compareFn || compare;
        nativeSort.call(temp, (i1, i2) => compareFn(me[i1], me[i2]) || i1 - i2); // we cannot do this directly into array since we may overwrite an element before putting it into
        // the correct spot:

        for (i = len; i-- > 0;) {
          temp[i] = me[temp[i]];
        }

        for (i = len; i-- > 0;) {
          me[i] = temp[i];
        }
      }

      return me;
    };

    Object.defineProperty(prototype, 'sort', {
      configurable: true,
      value: sort
    });
  } // Edge's JS engine (pre-webkit) has a threshold of 512 before it goes unstable, so use a number beyond that:

})(600);

ArrayHelper._$name = 'ArrayHelper';

/***/ }),

/***/ "./lib/Core/helper/AsyncHelper.js":
/*!****************************************!*\
  !*** ./lib/Core/helper/AsyncHelper.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AsyncHelper; });
var productName = 'taskboard';
/**
* @module Core/helper/AsyncHelper
*/

/**
 * A helper class to make asynchronous tasks `await` friendly.
 */

class AsyncHelper {
  /**
   * Returns a promise that resolves on next animation frame.
   * ```
   *  async method() {
   *      // do work
   *      await AsyncHelper.animationFrame();
   *      // do more work
   *  }
   * ```
   * @async
   * @returns {Promise}
   */
  static animationFrame() {
    return new Promise(resolve => {
      requestAnimationFrame(resolve);
    });
  }
  /**
   * Returns a promise that resolves after a specified number of milliseconds.
   * ```
   *  async method() {
   *      await AsyncHelper.sleep(10);
   *      // ...
   *  }
   * ```
   * @async
   * @param {Number} millis The number of milliseconds to sleep.
   * @returns {Promise}
   */


  static sleep(millis) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, millis);
    });
  }
  /**
   * Returns a promise that resolves as soon as possible, allowing the browser to minimally process other messages.
   * This is the shortest possible delay the browser offers, so be aware that it does not necessarily allow the
   * browser to paint or reflow if used in a long loop. It does, however, allow other async methods to execute.
   * ```
   *  async method() {
   *      await AsyncHelper.yield();
   *      // ...
   *  }
   * ```
   * @returns {Promise}
   */


  static yield() {
    return Promise.resolve();
  }

}
AsyncHelper._$name = 'AsyncHelper';

/***/ }),

/***/ "./lib/Core/helper/BrowserHelper.js":
/*!******************************************!*\
  !*** ./lib/Core/helper/BrowserHelper.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BrowserHelper; });
var productName = 'taskboard';
/**
* @module Core/helper/BrowserHelper
*/

/**
 * Static helper class that does browser or platform detection and provides other helper functions.
 */

class BrowserHelper {
  //region Init
  static cacheFlags(platform = navigator.platform, userAgent = navigator.userAgent) {
    const me = this; // os

    me._isLinux = Boolean(platform.match(/Linux/));
    me._isMac = Boolean(platform.match(/Mac/));
    me._isWindows = Boolean(platform.match(/Win32/)); // browser

    me._isIE11 = Boolean(userAgent.match(/rv:11/));
    me._edgeVersion = me.getVersion(userAgent, /Edge?\/(\d+)\./);
    me._isEdge = me._edgeVersion > 0 && me._edgeVersion < 80;

    if (!me._isEdge) {
      me._edgeVersion = 0;
    } // Edge user agent contain webkit too


    me._isWebkit = Boolean(userAgent.match(/WebKit/)) && !me._isEdge;
    me._firefoxVersion = me.getVersion(userAgent, /Firefox\/(\d+)\./);
    me._isFirefox = me._firefoxVersion > 0;
    me._chromeVersion = !me._isEdge ? me.getVersion(userAgent, /Chrom(?:e|ium)\/(\d+)\./) : 0;
    me._isChrome = me._chromeVersion > 0;
    me._isSafari = Boolean(userAgent.match(/Safari/)) && !me._isChrome && !me._isEdge;
    me._isMobileSafari = Boolean(userAgent.match(/Mobile.*Safari/));
    me._isAndroid = Boolean(userAgent.match(/Android/g));

    try {
      document.querySelector(':scope'); // Scoped queries are not supported for custom element polyfill in firefox
      // https://app.assembla.com/spaces/bryntum/tickets/6781

      me.supportsQueryScope = !me._isFirefox;
    } catch (e) {
      me.supportsQueryScope = false;
    }

    me._supportsPassive = false;

    try {
      // If the browser asks the options object to yield its passive
      // property, we know it supports the object form options object
      // and passive listeners.
      document.addEventListener('__notvalid__', null, {
        get passive() {
          me._supportsPassive = true;
        }

      });
    } catch (e) {}
  } //endregion
  //region Device

  /**
   * Yields `true` if the current browser supports CSS style `overflow:clip`.
   * @property {Boolean}
   * @readonly
   * @internal
   */


  static get supportsOverflowClip() {
    if (this._supportsOverflowClip == null) {
      const div = document.createElement('div');
      div.style.overflow = 'clip';
      div.style.display = 'none'; // If we're called before DOMContentLoaded, body won't be available.
      // HTML element works for style calcs.

      document.documentElement.appendChild(div);
      this._supportsOverflowClip = div.ownerDocument.defaultView.getComputedStyle(div).getPropertyValue('overflow') === 'clip';
      div.remove();
    }

    return this._supportsOverflowClip;
  }
  /**
   * Yields `true` if the current browser supports CSS style `position:sticky`.
   * @property {Boolean}
   * @readonly
   * @internal
   */


  static get supportsSticky() {
    // TODO: remove this when IE11 support is dropped. That's the only non-compliant browser.
    return !this._isIE11;
  }
  /**
   * Returns matched version for userAgent.
   * @param {String} versionRe version match regular expression
   * @returns {Number} matched version
   * @readonly
   * @internal
   */


  static getVersion(userAgent, versionRe) {
    const match = userAgent.match(versionRe);
    return match ? parseInt(match[1]) : 0;
  }
  /**
   * Tries to determine if the user is using a touch device.
   * @property {Boolean}
   * @readonly
   * @internal
   */


  static get isTouchDevice() {
    if ('_isTouchDevice' in this) return this._isTouchDevice;
    return 'ontouchstart' in window || // edge tends to always have this with a value 2
    !this.isEdge && navigator.maxTouchPoints > 0 || // but if env is actually touchable, then window has this class present
    this.isEdge && window.TouchEvent || navigator.msMaxTouchPoints > 0;
  } // Since touch screen detection is unreliable we should allow client to configure it, or detect first touch


  static set isTouchDevice(value) {
    this._isTouchDevice = value;
  }

  static get supportsPointerEvents() {
    return Boolean(window.PointerEvent || window.MSPointerEvent);
  } // Reports true by default for our tests


  static get isHoverableDevice() {
    if (this._isHoverableDevice === undefined) {
      this._isHoverableDevice = window.matchMedia('(any-hover: hover)').matches;
    }

    return this._isHoverableDevice;
  } //endregion
  //region Platform


  static get isBrowserEnv() {
    return typeof window !== 'undefined';
  }
  /**
   * Checks if platform is Mac.
   * @property {Boolean}
   * @readonly
   * @category Platform
   */


  static get isMac() {
    return this._isMac;
  }
  /**
   * Checks if platform is Windows.
   * @property {Boolean}
   * @readonly
   * @category Platform
   */


  static get isWindows() {
    return this._isWindows;
  }
  /**
   * Checks if platform is Linux.
   * @property {Boolean}
   * @readonly
   * @category Platform
   */


  static get isLinux() {
    return this._isLinux;
  }
  /**
   * Checks if platform is Android.
   * @property {Boolean}
   * @readonly
   * @category Platform
   */


  static get isAndroid() {
    return this._isAndroid;
  } //endregion
  //region Browser

  /**
   * Checks if browser is IE11.
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isIE11() {
    return this._isIE11;
  }
  /**
   * Checks if browser is legacy Edge (version <= 18).
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isEdge() {
    return this._isEdge;
  }
  /**
   * Returns the major legacy Edge version or 0 for other browsers.
   * @property {Number}
   * @readonly
   * @category Browser
   */


  static get edgeVersion() {
    return this._edgeVersion;
  }
  /**
   * Checks if browser is Webkit.
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isWebkit() {
    return this._isWebkit;
  }
  /**
   * Checks if browser is Chrome or Chromium based browser.
   * Returns truthy value for Edge Chromium.
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isChrome() {
    return this._isChrome;
  }
  /**
   * Returns the major Chrome version or 0 for other browsers.
   * @property {Number}
   * @readonly
   * @category Browser
   */


  static get chromeVersion() {
    return this._chromeVersion;
  }
  /**
   * Checks if browser is Firefox.
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isFirefox() {
    return this._isFirefox;
  }
  /**
   * Returns the major Firefox version or 0 for other browsers.
   * @property {Number}
   * @readonly
   * @category Browser
   */


  static get firefoxVersion() {
    return this._firefoxVersion;
  }
  /**
   * Checks if browser is Safari.
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isSafari() {
    return this._isSafari;
  }
  /**
   * Checks if browser is mobile Safari
   * @property {Boolean}
   * @readonly
   * @category Browser
   */


  static get isMobileSafari() {
    return this._isMobileSafari;
  }
  /**
   * Returns `true` if the browser supports passive event listeners.
   * @property {Boolean}
   * @internal
   * @category Browser
   */


  static get supportsPassive() {
    return this._supportsPassive;
  } //endregion
  //region Storage
  // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API


  static get storageAvailable() {
    let storage, x;

    try {
      storage = localStorage;
      x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return e instanceof DOMException && ( // everything except Firefox
      e.code === 22 || // Firefox
      e.code === 1014 || // test name field too, because code might not be present
      // everything except Firefox
      e.name === 'QuotaExceededError' || // Firefox
      e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
      storage.length !== 0;
    }
  }

  static setLocalStorageItem(key, value) {
    this.storageAvailable && localStorage.setItem(key, value);
  }

  static getLocalStorageItem(key) {
    return this.storageAvailable && localStorage.getItem(key);
  }

  static removeLocalStorageItem(key) {
    this.storageAvailable && localStorage.removeItem(key);
  } //endregion
  //region Helpers

  /**
   * Returns parameter value from search string by parameter name.
   * @param {String} paramName search parameter name
   * @param {*} [defaultValue] default value if parameter not found
   * @param {String} [search] search string. Defaults to `document.location.search`
   * @category Helper
   */


  static searchParam(paramName, defaultValue = null, search = document.location.search) {
    const re = new RegExp(`[?&]${paramName}=?([^&]*)`),
          match = search.match(re);
    return match && match[1] || defaultValue;
  }
  /**
   * Returns cookie by name.
   * @param {String} name cookie name
   * @return {String} cookie string value
   * @category Helper
   */


  static getCookie(name) {
    const nameEq = encodeURIComponent(name) + '=',
          cookieItems = document.cookie.split(';');

    for (let i = 0; i < cookieItems.length; i++) {
      let c = cookieItems[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEq) === 0) {
        return decodeURIComponent(c.substring(nameEq.length, c.length));
      }
    }

    return '';
  }
  /**
   * Triggers a download of a file with the specified name / URL.
   * @param {String} filename The filename of the file to be downloaded
   * @param {String} [url] The URL where the file is to be downloaded from
   * @internal
   * @category Download
   */


  static download(filename, url) {
    const a = document.createElement('a');
    a.download = filename;
    a.href = url || filename;
    a.style.cssText = 'display:none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  /**
   * Triggers a download of a Blob with the specified name.
   * @param {Blob} blob The Blob to be downloaded
   * @param {String} filename The filename of the file to be downloaded
   * @internal
   * @category Download
   */


  static downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    this.download(filename, url);
    window.URL.revokeObjectURL(url);
  }

  static get queryString() {
    // Code could be executed in the Node context
    if (this.isBrowserEnv) {
      var _Object$fromEntries;

      // new URLSearchParams throws in salesforce
      // https://github.com/salesforce/lwc/issues/1812
      const params = new URL(window.location.href).searchParams; // ?. to be nice to users with Chrome versions < 73

      return (_Object$fromEntries = Object.fromEntries) === null || _Object$fromEntries === void 0 ? void 0 : _Object$fromEntries.call(Object, params.entries());
    }
  }

  static get global() {
    return this.isBrowserEnv ? window // eslint-disable-next-line no-undef
    : typeof global !== 'undefined' ? global : globalThis || {};
  }

  static copyToClipboard(code) {
    let success = true;
    const textArea = document.createElement('textarea');
    textArea.value = code;
    textArea.style.height = textArea.style.width = 0;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      document.execCommand('copy');
    } catch (e) {
      success = false;
    }

    textArea.remove();
    return success;
  }

  static isBryntumOnline(searchStrings) {
    var _searchStrings;

    searchStrings = Array.isArray(searchStrings) ? searchStrings : [searchStrings];
    return Boolean(/^(www\.)?bryntum\.com/.test(window.location.host) || ((_searchStrings = searchStrings) === null || _searchStrings === void 0 ? void 0 : _searchStrings.some(str => this.queryString[str] != null)));
  } //endregion


}

if (BrowserHelper.isBrowserEnv) {
  BrowserHelper.cacheFlags();
}

BrowserHelper._$name = 'BrowserHelper';
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../node_modules/webpack/buildin/global.js */ "../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./lib/Core/helper/CSSHelper.js":
/*!**************************************!*\
  !*** ./lib/Core/helper/CSSHelper.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CSSHelper; });
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'taskboard';

/**
 * @module Core/helper/CSSHelper
 */

/**
 * Provides methods to add and manipulate CSS style rules.
 *
 * Note that this class is incompatible with [CSP](https://developer.mozilla.org/en-US/docs/Web/HTTP/CSP)
 *
 * ```
 * this.criticalRule = CSSHelper.insertRule(`#${this.id} .b-sch-event.critical {background-color:${this.criticalColor}}`);
 * ```
 */

class CSSHelper {
  /**
   * Inserts a CSS style rule based upon the passed text
   * @param {String} cssText The text of the rule including selector and rule body just as it would
   * be specified in a CSS file.
   * @returns {CSSRule} The resulting CSS Rule object if the add was successful.
   */
  static insertRule(cssText) {
    const styleSheet = this.getStyleSheet(document.head),
          oldCount = styleSheet.cssRules.length;
    styleSheet.insertRule(cssText, 0); // Only return element zero if the add was successful.

    if (styleSheet.cssRules.length > oldCount) {
      return styleSheet.cssRules[0];
    }
  }
  /**
   * Looks up the first rule which matched the passed selector.
   * @param {String|Function} selector Either the selector string to exactly match or a function which
   * when passed a required selector, returns `true`.
   * @returns {CSSRule} The first matching CSS Rule object if any found.
   */


  static findRule(selector) {
    let result,
        isFn = typeof selector === 'function'; // Array#find will stop when the function returns true, stop when the inner
    // find call yields a value from the search string.
    // Array#find better: to http://www.andygup.net/fastest-way-to-find-an-item-in-a-javascript-array/

    Array.prototype.find.call(document.head.querySelectorAll('link[rel=stylesheet],style[type*=css]'), element => {
      result = Array.prototype.find.call(element.sheet.rules || element.sheet.cssRules, r => {
        return isFn ? selector(r) : r.selectorText === selector;
      });

      if (result) {
        return true;
      }
    });
    return result;
  }

  static getStyleSheet(parentElement = document.head) {
    if (!parentElement.$bryntumStylesheet) {
      parentElement.$bryntumStylesheet = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
        tag: 'style',
        id: 'bryntum-private-styles',
        // no-sanity
        type: 'text/css',
        parent: parentElement
      }).sheet;
    }

    return parentElement.$bryntumStylesheet;
  }

}
CSSHelper._$name = 'CSSHelper';

/***/ }),

/***/ "./lib/Core/helper/DateHelper.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/DateHelper.js ***!
  \***************************************/
/*! exports provided: unitMagnitudes, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unitMagnitudes", function() { return unitMagnitudes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateHelper; });
/* harmony import */ var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _util_Objects_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/Objects.js */ "./lib/Core/helper/util/Objects.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';






const {
  toString
} = Object.prototype,
      DATE_TYPE = toString.call(new Date()),
      // Left-to-right unicode mark (https://www.codetable.net/decimal/8206)
LTRSymbolRegexp = new RegExp('\u200E', 'g'),
      tempDate = new Date(),
      MS_PER_HOUR = 1000 * 60 * 60,
      defaultValue = (value, defValue) => isNaN(value) || value == null ? defValue : value,
      enOrdinalSuffix = number => {
  const hasSpecialCase = ['11', '12', '13'].find(n => number.endsWith(n));
  let suffix = 'th';

  if (!hasSpecialCase) {
    const lastDigit = number[number.length - 1];
    suffix = {
      1: 'st',
      2: 'nd',
      3: 'rd'
    }[lastDigit] || 'th';
  }

  return number + suffix;
},
      useIntlFormat = (name, options, date) => {
  const formatter = intlFormatterCache[name] || (intlFormatterCache[name] = new Intl.DateTimeFormat(locale, options));
  let result = formatter.format(date); // IE11 inserts direction control characters to the string
  // This removes the characters

  if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) {
    result = result.replace(LTRSymbolRegexp, '');
  }

  return result;
},
      formatTime = (name, options, date, isShort = false) => {
  let strTime = useIntlFormat(name, options, date); // remove "0" from time when has AM/PM (from 01:00 PM to 1:00 PM): https://github.com/bryntum/support/issues/1483

  if (/am|pm/i.test(strTime)) {
    // remove first character only if is 0
    strTime = strTime.replace(/^0/, ''); // if isShort is true, remove minutes if is :00

    if (isShort) {
      strTime = strTime.replace(/:00/, '');
    }
  }

  return strTime;
},
      getDayDiff = (end, start) => Math.floor((end.getTime() - start.getTime() - (end.getTimezoneOffset() - start.getTimezoneOffset()) * validConversions.minute.millisecond) / validConversions.day.millisecond) + 1,
      normalizeDay = day => day >= 0 ? day : day + 7; // These vars are set when changing locale


let locale = 'en-US',
    ordinalSuffix = enOrdinalSuffix,
    // Used to cache used formats, to not have to parse format string each time
formatCache = {},
    intlFormatterCache = {},
    parserCache = {};

const DEFAULT_YEAR = 2020,
      // 2020 is the year that has no issues in Safari and Edge, see: https://github.com/bryntum/support/issues/554
DEFAULT_MONTH = 0,
      DEFAULT_DAY = 1,
      formats = {
  // 1, 2, ... 11, 12
  M: date => date.getMonth() + 1,
  //date.toLocaleDateString(locale, { month : 'numeric' }),
  // 1st, 2nd, 3rd, 4th, ... 11th, 12th
  Mo: date => ordinalSuffix(formats.M(date).toString()),
  // 01, 02, ...
  MM: date => (date.getMonth() + 1).toString().padStart(2, '0'),
  //date.toLocaleDateString(locale, { month : '2-digit' }),
  // Jan, Feb, ...
  MMM: date => useIntlFormat('MMM', {
    month: 'short'
  }, date),
  // January, February, ...
  MMMM: date => useIntlFormat('MMMM', {
    month: 'long'
  }, date),
  // 1, 2, ...
  Q: date => Math.ceil((date.getMonth() + 1) / 3),
  // 1st, 2nd, ...
  Qo: date => ordinalSuffix(formats.Q(date).toString()),
  // 1, 2, ...
  D: date => date.getDate(),
  //date.toLocaleDateString(locale, { day : 'numeric' }),
  // 1st, 2nd, ...
  Do: date => ordinalSuffix(formats.D(date).toString()),
  // 01, 02, ...
  DD: date => date.getDate().toString().padStart(2, '0'),
  //date.toLocaleDateString(locale, { day : '2-digit' }),
  // 1, 2, ..., 365, 365
  DDD: date => Math.ceil((new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0) - new Date(date.getFullYear(), 0, 0, 12, 0, 0)) / validConversions.day.millisecond),
  // 1st, 2nd, ...
  DDDo: date => ordinalSuffix(formats.DDD(date).toString()),
  // 001, 002, ...
  DDDD: date => formats.DDD(date).toString().padStart(3, '0'),
  // 0, 1, ..., 6
  d: date => date.getDay(),
  // 0th, 1st, ...
  do: date => ordinalSuffix(date.getDay().toString()),
  // S, M, ...
  d1: date => useIntlFormat('d1', {
    weekday: 'narrow'
  }, date).substr(0, 1),
  // Su, Mo, ...
  dd: date => formats.ddd(date).substring(0, 2),
  // Sun, Mon, ...
  ddd: date => useIntlFormat('ddd', {
    weekday: 'short'
  }, date),
  // Sunday, Monday, ...
  dddd: date => useIntlFormat('dddd', {
    weekday: 'long'
  }, date),
  e: date => date.getDay(),
  E: date => date.getDay() + 1,
  // ISO week, 1, 2, ...
  W: date => DateHelper.getWeekNumber(date)[1],
  Wo: date => ordinalSuffix(formats.W(date).toString()),
  WW: date => formats.W(date).toString().padStart(2, '0'),
  // 1979, 2018
  Y: date => date.getFullYear(),
  //date.toLocaleDateString(locale, { year : 'numeric' }),
  // 79, 18
  YY: date => date.getFullYear() % 100,
  //date.toLocaleDateString(locale, { year : '2-digit' }),
  // 1979, 2018
  YYYY: date => date.getFullYear(),
  //date.toLocaleDateString(locale, { year : 'numeric' }),
  // AM, PM
  A: date => date.getHours() < 12 ? 'AM' : 'PM',
  a: date => date.getHours() < 12 ? 'am' : 'pm',
  // 0, 1, ... 23
  H: date => date.getHours(),
  // 00, 01, ...
  HH: date => date.getHours().toString().padStart(2, '0'),
  // 1, 2, ... 12
  h: date => date.getHours() % 12 || 12,
  // 01, 02, ...
  hh: date => formats.h(date).toString().padStart(2, '0'),
  // 1, 2, ... 24
  k: date => date.getHours() || 24,
  // 01, 02, ...
  kk: date => formats.k(date).toString().padStart(2, '0'),
  // Locale specific (0 -> 24 or 1 AM -> 12 PM)
  K: date => formatTime('K', {
    hour: 'numeric'
  }, date),
  // Locale specific (00 -> 24 or 1 AM -> 12 PM)
  KK: date => formatTime('KK', {
    hour: '2-digit'
  }, date),
  // 0, 1, ... 59
  m: date => date.getMinutes(),
  //date.toLocaleTimeString(locale, { minute : 'numeric' }),
  // 00, 01, ...
  mm: date => formats.m(date).toString().padStart(2, '0'),
  // 0, 1, ... 59
  s: date => date.getSeconds(),
  //date.toLocaleTimeString(locale, { second : 'numeric' }),
  // 00, 01, ...
  ss: date => formats.s(date).toString().padStart(2, '0'),
  // 0, 1, ... 9 which are 000, 100, 200 ... 900 in milliseconds
  S: date => Math.floor(date.getMilliseconds() / 100).toString(),
  // 00, 01, ... 99 which are 000, 010, 020 ... 990 in milliseconds
  SS: date => Math.floor(date.getMilliseconds() / 10).toString().padStart(2, '0'),
  // 000, 001, ... 999 in milliseconds
  SSS: date => date.getMilliseconds().toString().padStart(3, '0'),
  z: date => useIntlFormat('z', {
    timeZoneName: 'short'
  }, date),
  zz: date => useIntlFormat('zz', {
    timeZoneName: 'long'
  }, date),
  Z: date => DH.getGMTOffset(date),
  LT: date => formatTime('LT', {
    hour: '2-digit',
    minute: '2-digit'
  }, date),
  // if minutes is 0, doesn't show it
  LST: date => formatTime('LST', {
    hour: 'numeric',
    minute: '2-digit'
  }, date, true),
  LTS: date => formatTime('LTS', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }, date),
  L: date => useIntlFormat('L', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }, date),
  l: date => useIntlFormat('l', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  }, date),
  LL: date => useIntlFormat('LL', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }, date),
  ll: date => useIntlFormat('ll', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }, date),
  LLL: date => useIntlFormat('LLL', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  }, date),
  lll: date => useIntlFormat('lll', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  }, date),
  LLLL: date => useIntlFormat('LLLL', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    weekday: 'long'
  }, date),
  llll: date => useIntlFormat('llll', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    weekday: 'short'
  }, date)
},
      // Want longest keys first, to not stop match at L of LTS etc.
formatKeys = Object.keys(formats).sort((a, b) => b.length - a.length),
      formatRegexp = `^(?:${formatKeys.join('|')})`,
      // return empty object, meaning value cannot be processed to a valuable date part
emptyFn = () => ({}),
      isNumber = str => numberRegex.test(str),
      parseMilliseconds = str => isNumber(str) && {
  milliseconds: parseInt(str.padEnd(3, '0').substring(0, 3))
},
      parsers = {
  YYYY: str => ({
    year: parseInt(str)
  }),
  Y: str => ({
    year: parseInt(str)
  }),
  YY: str => {
    const year = parseInt(str);
    return {
      year: year + (year > 1968 ? 1900 : 2000)
    };
  },
  MM: str => ({
    month: parseInt(str) - 1
  }),
  Mo: str => ({
    month: parseInt(str) - 1
  }),
  DD: str => ({
    date: parseInt(str)
  }),
  M: str => ({
    month: parseInt(str) - 1
  }),
  D: str => ({
    date: parseInt(str)
  }),
  Do: str => ({
    date: parseInt(str)
  }),
  DDD: emptyFn,
  MMM: emptyFn,
  MMMM: emptyFn,
  DDDo: emptyFn,
  DDDD: emptyFn,
  d: emptyFn,
  do: emptyFn,
  d1: emptyFn,
  dd: emptyFn,
  ddd: emptyFn,
  dddd: emptyFn,
  Q: emptyFn,
  Qo: emptyFn,
  W: emptyFn,
  Wo: emptyFn,
  WW: emptyFn,
  e: emptyFn,
  E: emptyFn,
  HH: str => ({
    hours: parseInt(str)
  }),
  hh: str => ({
    hours: parseInt(str)
  }),
  mm: str => ({
    minutes: parseInt(str)
  }),
  H: str => ({
    hours: parseInt(str)
  }),
  m: str => ({
    minutes: parseInt(str)
  }),
  ss: str => ({
    seconds: parseInt(str)
  }),
  s: str => ({
    seconds: parseInt(str)
  }),
  S: parseMilliseconds,
  SS: parseMilliseconds,
  SSS: parseMilliseconds,
  A: str => ({
    amPm: str.toLowerCase()
  }),
  a: str => ({
    amPm: str.toLowerCase()
  }),
  L: 'MM/DD/YYYY',
  LT: 'HH:mm A',
  // Can either be Z (=UTC, 0) or +-HH:MM
  Z: str => {
    if (!str || !timeZoneRegEx.test(str) && str !== 'Z') {
      return null;
    }

    let timeZone = 0; // If string being parsed is more "detailed" than the format specified we can have more chars left,
    // thus check the last (for example HH:mmZ with input HH:mm:ssZ -> ssZ)

    if (str !== 'Z') {
      const matches = timeZoneRegEx.exec(str); // If timezone regexp matches, sting has time zone offset like '+02:00'

      if (matches) {
        const sign = matches[1] === '+' ? 1 : -1,
              hours = parseInt(matches[2]) || 0,
              minutes = parseInt(matches[3]) || 0;
        timeZone = sign * (hours * 60 + minutes);
      } // otherwise we just return current time zone, because there's a Z key in the input
      else {
        timeZone = -1 * new Date().getTimezoneOffset();
      }
    }

    return {
      timeZone
    };
  }
},
      parserKeys = Object.keys(parsers).sort((a, b) => b.length - a.length),
      parserRegexp = new RegExp(`(${parserKeys.join('|')})`),
      // Following regexp includes all formats that should be handled by Date class
localeStrRegExp = new RegExp('(l|LL|ll|LLL|lll|LLLL|llll)'),
      //    ISODateRegExp             = new RegExp('YYYY-MM-DD[T ]HH:mm:ss(.s+)?Z'),
// Some validConversions are negative to show that it's not an exact conversion, just an estimate.
validConversions = {
  // The units below assume:
  // 30 days in a month, 91 days for a quarter and 365 for a year
  // 52 weeks per year, 4 per month, 13 per quarter
  // 3652 days per decade (assuming two of the years will be leap with 366 days)
  decade: {
    decade: 1,
    year: 10,
    quarter: 40,
    month: 120,
    week: 520,
    day: 3652,
    hour: 24 * 3652,
    minute: 1440 * 3652,
    second: 86400 * 3652,
    millisecond: 86400000 * 3652
  },
  year: {
    decade: 0.1,
    year: 1,
    quarter: 4,
    month: 12,
    week: 52,
    day: 365,
    hour: 24 * 365,
    minute: 1440 * 365,
    second: 86400 * 365,
    millisecond: 86400000 * 365
  },
  quarter: {
    decade: 1 / 40,
    year: 1 / 4,
    quarter: 1,
    month: 3,
    week: 4,
    day: 91,
    hour: 24 * 91,
    minute: 1440 * 91,
    second: 86400 * 91,
    millisecond: 86400000 * 91
  },
  month: {
    decade: 1 / 120,
    year: 1 / 12,
    quarter: 1 / 3,
    month: 1,
    week: 4,
    day: -30,
    hour: -24 * 30,
    minute: -1440 * 30,
    second: -86400 * 30,
    millisecond: -86400000 * 30
  },
  week: {
    decade: -1 / 520,
    year: -1 / 52,
    quarter: -1 / 13,
    month: -1 / 4,
    day: 7,
    hour: 168,
    minute: 10080,
    second: 604800,
    millisecond: 604800000
  },
  day: {
    decade: -1 / 3652,
    year: -1 / 365,
    quarter: -1 / 91,
    month: -1 / 30,
    week: 1 / 7,
    hour: 24,
    minute: 1440,
    second: 86400,
    millisecond: 86400000
  },
  hour: {
    decade: -1 / (3652 * 24),
    year: -1 / (365 * 24),
    quarter: -1 / (91 * 24),
    month: -1 / (30 * 24),
    week: 1 / 168,
    day: 1 / 24,
    minute: 60,
    second: 3600,
    millisecond: 3600000
  },
  minute: {
    decade: -1 / (3652 * 1440),
    year: -1 / (365 * 1440),
    quarter: -1 / (91 * 1440),
    month: -1 / (30 * 1440),
    week: 1 / 10080,
    day: 1 / 1440,
    hour: 1 / 60,
    second: 60,
    millisecond: 60000
  },
  second: {
    decade: -1 / (3652 * 86400),
    year: -1 / (365 * 86400),
    quarter: -1 / (91 * 86400),
    month: -1 / (30 * 86400),
    week: 1 / 604800,
    day: 1 / 86400,
    hour: 1 / 3600,
    minute: 1 / 60,
    millisecond: 1000
  },
  millisecond: {
    decade: -1 / (3652 * 86400000),
    year: -1 / (365 * 86400000),
    quarter: -1 / (91 * 86400000),
    month: -1 / (30 * 86400000),
    week: 1 / 604800000,
    day: 1 / 86400000,
    hour: 1 / 3600000,
    minute: 1 / 60000,
    second: 1 / 1000
  }
},
      normalizedUnits = {
  ms: 'millisecond',
  milliseconds: 'millisecond',
  s: 'second',
  seconds: 'second',
  m: 'minute',
  mi: 'minute',
  min: 'minute',
  minutes: 'minute',
  h: 'hour',
  hours: 'hour',
  d: 'day',
  days: 'day',
  w: 'week',
  weeks: 'week',
  M: 'month',
  mo: 'month',
  mon: 'month',
  months: 'month',
  q: 'quarter',
  quarters: 'quarter',
  y: 'year',
  years: 'year',
  dec: 'decade',
  decades: 'decade'
},
      withDecimalsDurationRegex = /^\s*([-+]?\d+(?:[.,]\d*)?|[-+]?(?:[.,]\d+))\s*([^\s]+)?/i,
      noDecimalsDurationRegex = /^\s*([-+]?\d+)(?![.,])\s*([^\s]+)?/i,
      canonicalUnitNames = ['millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year', 'decade'],
      canonicalUnitAbbreviations = [['mil'], ['s', 'sec'], ['m', 'min'], ['h', 'hr'], ['d'], ['w', 'wk'], ['mo', 'mon', 'mnt'], ['q', 'quar', 'qrt'], ['y', 'yr'], ['dec']],
      deltaUnits = ['decade', 'year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'],
      // Used when creating a date from an object, to fill in any blanks
dateProperties = ['milliseconds', 'seconds', 'minutes', 'hours', 'date', 'month', 'year'],
      // TODO: Should we provide special number parsing?
parseNumber = n => {
  const result = parseFloat(n);
  return isNaN(result) ? null : result;
},
      numberRegex = /^[0-9]+$/,
      timeZoneRegEx = /([+-])(\d\d):*(\d\d)*$/,
      unitMagnitudes = {
  millisecond: 0,
  second: 1,
  minute: 2,
  hour: 3,
  day: 4,
  week: 5,
  month: 6,
  quarter: 7,
  year: 8,
  decade: 9
},
      snapFns = {
  round(number, step = 1) {
    return Math.round(number / step) * step;
  },

  floor(number, step = 1) {
    return Math.floor(number / step) * step;
  },

  ceil(number, step = 1) {
    return Math.ceil(number / step) * step;
  }

},
      keyCache = {};


/**
 * @module Core/helper/DateHelper
 */

/**
 * Helps with date manipulation, comparison, parsing, formatting etc.
 *
 * ## Parsing strings
 * Use `DateHelper.parse()` to parse strings into dates. It accepts a date string and a format specifier.
 * The format specifier is string built up using the following tokens:
 *
 * | Unit        | Token | Description                       |
 * |-------------|-------|-----------------------------------|
 * | Year        | YYYY  | 2018                              |
 * |             | YY    | < 68 -> 2000, > 68 -> 1900        |
 * | Month       | MM    | 01 - 12                           |
 * | Date        | DD    | 01 - 31                           |
 * | Hour        | HH    | 00 - 23 or 1 - 12                 |
 * | Minute      | mm    | 00 - 59                           |
 * | Second      | ss    | 00 - 59                           |
 * | Millisecond | S     | 0 - 9 [000, 100, 200 .. 900 ]     |
 * |             | SS    | 00 - 99 [000, 010, 020 .. 990 ]   |
 * |             | SSS   | 000 - 999 [000, 001, 002 .. 999 ] |
 * | AM/PM       | A     | AM or PM                          |
 * |             | a     | am or pm                          |
 * | TimeZone    | Z     | Z for UTC or +-HH:mm              |
 * | Predefined  | L     | Long date, MM/DD/YYYY             |
 * |             | LT    | Long time, HH:mm A                |
 *
 * Default parse format is: `'YYYY-MM-DDTHH:mm:ss.SSSZ'` see {@link #property-defaultParseFormat-static}
 *
 * For example:
 * ```
 * DateHelper.parse('2018-11-06', 'YYYY-MM-DD');
 * DateHelper.parse('13:14', 'HH:mm');
 * DateHelper.parse('6/11/18', 'DD/MM/YY');
 * ```
 *
 * ## Formatting dates
 * Use `DateHelper.format()` to create a string from a date using a format specifier. The format specifier is similar to
 * that used when parsing strings. It can use the following tokens (input used for output below is
 * `new Date(2018,8,9,18,7,8,145)`):
 *
 * | Unit                  | Token | Description & output                  |
 * |-----------------------|-------|---------------------------------------|
 * | Year                  | YYYY  | 2018                                  |
 * |                       | YY    | 18                                    |
 * |                       | Y     | 2018                                  |
 * | Quarter               | Q     | 3                                     |
 * |                       | Qo    | 3rd                                   |
 * | Month                 | MMMM  | September                             |
 * |                       | MMM   | Sep                                   |
 * |                       | MM    | 09                                    |
 * |                       | Mo    | 9th                                   |
 * |                       | M     | 9                                     |
 * | Week (iso)            | WW    | 36 (2 digit)                          |
 * |                       | Wo    | 36th                                  |
 * |                       | W     | 36                                    |
 * | Date                  | DDDD  | Day of year, 3 digits                 |
 * |                       | DDDo  | Day of year, ordinal                  |
 * |                       | DDD   | Day of year                           |
 * |                       | DD    | 09                                    |
 * |                       | Do    | 9th                                   |
 * |                       | D     | 9                                     |
 * | Weekday               | dddd  | Sunday                                |
 * |                       | ddd   | Sun                                   |
 * |                       | dd    | Su                                    |
 * |                       | d1    | S                                     |
 * |                       | do    | 0th                                   |
 * |                       | d     | 0                                     |
 * | Hour                  | HH    | 18 (00 - 23)                          |
 * |                       | H     | 18 (0 - 23)                           |
 * |                       | hh    | 06 (00 - 12)                          |
 * |                       | h     | 6 (0 - 12)                            |
 * |                       | KK    | 19 (01 - 24)                          |
 * |                       | K     | 19 (1 - 24)                           |
 * |                       | kk    | 06 or 18, locale determines           |
 * |                       | k     | 6 or 18, locale determines            |
 * | Minute                | mm    | 07                                    |
 * |                       | m     | 7                                     |
 * | Second                | ss    | 08                                    |
 * |                       | s     | 8                                     |
 * | Millisecond           | S     | 1 (100ms)                             |
 * |                       | SS    | 14 (140ms)                            |
 * |                       | SSS   | 145 (145ms)                           |
 * | AM/PM                 | A     | AM or PM                              |
 * |                       | a     | am or pm                              |
 * | Predefined            | LT    | H: 2-digit (2d), m: 2d                |
 * | (uses browser locale) | LTS   | H: 2d, m: 2d, s : 2d                  |
 * |                       | LST   | Depends on 12 or 24 hour clock        |
 * |                       |       | 12h, H : 1d, m : 0 or 2d              |
 * |                       |       | 24h, H : 2d, m : 2d                   |
 * |                       | L     | Y: numeric (n), M : 2d, D : 2d        |
 * |                       | l     | Y: n, M : n, D : n                    |
 * |                       | LL    | Y: n, M : long (l), D : n             |
 * |                       | ll    | Y: n, M : short (s), D : n            |
 * |                       | LLL   | Y: n, M : l, D : n, H: n, m: 2d       |
 * |                       | lll   | Y: n, M : s, D : n, H: n, m: 2d       |
 * |                       | LLLL  | Y: n, M : l, D : n, H: n, m: 2d, d: l |
 * |                       | llll  | Y: n, M : s, D : n, H: n, m: 2d, d: s |
 *
 *
 * Default format is: `'YYYY-MM-DDTHH:mm:ssZ'` see {@link #property-defaultFormat-static}
 *
 * For example:
 *
 * ```javascript
 * DateHelper.format(new Date(2018,10,6), 'YYYY-MM-DD'); // 2018-11-06
 * DateHelper.format(new Date(2018,10,6), 'M/D/YY'); // 11/6/18
 * ```
 *
 * Arbitrary text can be embedded in the format string by wrapping it with {}:
 *
 * ```javascript
 * DateHelper.format(new Date(2019, 7, 16), '{It is }dddd{, yay!}') -> It is Friday, yay!
 * ```
 *
 * ## Unit names
 * Many DateHelper functions (for example add, as, set) accepts a unit among their params. The following units are
 * available:
 *
 * | Unit        | Aliases                       |
 * |-------------|-------------------------------|
 * | millisecond | millisecond, milliseconds, ms |
 * | second      | second, seconds, s            |
 * | minute      | minute, minutes, m            |
 * | hour        | hour, hours, h                |
 * | day         | day, days, d                  |
 * | week        | week, weeks, w                |
 * | month       | month, months, mon, mo, M     |
 * | quarter     | quarter, quarters, q          |
 * | year        | year, years, y                |
 * | decade      | decade, decades, dec          |
 *
 * For example:
 * ```javascript
 * DateHelper.add(date, 2, 'days');
 * DateHelper.as('hour', 7200, 'seconds');
 * ```
 */

class DateHelper extends Object(_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_0__["default"])() {
  static get $name() {
    return 'DateHelper';
  } //region Parse & format

  /**
   * Get/set the default format used by `format()` and `parse()`. Defaults to `'YYYY-MM-DDTHH:mm:ssZ'`
   * (~ISO 8601 Date and time, `'1962-06-17T09:21:34Z'`).
   * @member {String}
   */


  static set defaultFormat(format) {
    DH._defaultFormat = format;
  }

  static get defaultFormat() {
    return DH._defaultFormat || 'YYYY-MM-DDTHH:mm:ssZ';
  }
  /**
   * Get/set the default format used by `parse()`. Defaults to `'YYYY-MM-DDTHH:mm:ss.SSSZ'` or {@link #property-defaultFormat-static}
   * (~ISO 8601 Date and time, `'1962-06-17T09:21:34.123Z'`).
   * @member {String}
   */


  static set defaultParseFormat(parseFormat) {
    this._defaultParseFormat = parseFormat;
  }

  static get defaultParseFormat() {
    return this._defaultParseFormat || this._defaultFormat || 'YYYY-MM-DDTHH:mm:ss.SSSZ';
  }

  static buildParser(format) {
    // Split input format by regexp, which includes predefined patterns. Normally format would have some
    // splitters, like 'YYYY-MM-DD' or 'D/M YYYY' so output will contain matched patterns as well as splitters
    // which would serve as anchors. E.g. provided format is 'D/M!YYYY' and input is `11/6!2019` algorithm would work like:
    // 1. split format by regexp                // ['', 'D', '/', 'M', '!', 'YYYY', '']
    // 2. find splitters                        // ['/', '!']
    // 3. split input by seps, step by step     // ['11', ['6', ['2019']]]
    // Inputs like 'YYYYY' (5*Y) means 'YYYY' + 'Y', because it matches patterns from longer to shorter,
    // but if few patterns describe same unit the last one is applied, for example
    // DH.parse('20182015', 'YYYYY') equals to new Date(2015, 0, 0)
    const parts = format.split(parserRegexp),
          parser = []; // if length of the parts array is 1 - there are no regexps in the input string. thus - no parsers
    // do same if there are patterns matching locale strings (l, ll, LLLL etc.)
    // returning empty array to use new Date() as parser

    if (parts.length === 1 || localeStrRegExp.test(format)) {
      return [];
    } else {
      parts.reduce((prev, curr, index, array) => {
        // ignore first and last empty string
        if (index !== 0 || curr !== '') {
          // if current element matches parser regexp store it as a parser
          if (parserRegexp.test(curr)) {
            const localeParsers = this.localize('L{parsers}') || {},
                  fn = localeParsers[curr] || parsers[curr]; // Z should be last element in the string that matches regexp. Last array element is always either
            // an empty string (if format ends with Z) or splitter (everything that doesn't match regexp after Z)
            // If there is a pattern after Z, then Z index will be lower than length - 2

            if (curr === 'Z' && index < array.length - 2) {
              throw new Error(`Invalid format ${format} TimeZone (Z) must be last token`);
            } // If fn is a string, we found an alias (L, LLL, l etc.).
            // Need to build parsers from mapped format and merge with existing


            if (typeof fn === 'string') {
              // we are going to merge nested parsers with current, some cleanup required:
              // 1. last element is no longer last
              // 2. need to pass last parser to the next step
              const nestedParsers = DH.buildParser(fn),
                    lastItem = nestedParsers.pop();
              delete lastItem.last; // elevate nested parsers

              parser.push(...nestedParsers);
              prev = lastItem;
            } else {
              prev.pattern = curr;
              prev.fn = parsers[curr];
            }
          } // if it doesn't match - we've found a splitter
          else {
            prev.splitter = curr;
            parser.push(prev);
            prev = {};
          }
        } else if (Object.prototype.hasOwnProperty.call(prev, 'pattern')) {
          parser.push(prev);
        }

        return prev;
      }, {});
    }

    parser[parser.length - 1].last = true;
    return parser;
  }
  /**
   * A utility function to create a sortable string key for the passed date or ms timestamp using the `'YYYY-MM-DD'`
   * format.
   * @param {Number|Date} ms The Date instance or ms timestamp to generate a key for
   * @returns {String} Date/timestamp as a string with `'YYYY-M-D'` format
   * @internal
   */


  static makeKey(ms) {
    // Convert Date to ms timestamp
    if (ms.getTime) {
      ms = ms.getTime();
    } // Cache holds ms -> YYYY-MM-DD


    const cached = keyCache[Math.trunc(ms / MS_PER_HOUR)];

    if (cached) {
      return cached;
    }

    tempDate.setTime(ms);
    const month = tempDate.getMonth() + 1,
          date = tempDate.getDate(); // Not using DateHelper.format to save some cycles, hit a lot

    return keyCache[Math.trunc(ms / MS_PER_HOUR)] = `${tempDate.getFullYear()}-${month < 10 ? '0' + month : month}-${date < 10 ? '0' + date : date}`;
  }
  /**
   * A utility function to parse a sortable string to a date date using the `'YYYY-MM-DD'` format.
   * @param {String} key The string to return a date for.
   * @returns {Date} new Date instance
   * @internal
   */


  static parseKey(key) {
    return DH.parse(key, 'YYYY-MM-DD');
  }
  /**
   * Returns a date created from the supplied string using the specified format. Will try to create even if format
   * is left out, by first using the default format (see {@link #property-defaultFormat-static}, by default
   * `YYYY-MM-DDTHH:mm:ssZ`) and then using `new Date(dateString)`.
   * Supported tokens:
   *
   * | Unit        | Token | Description                       |
   * |-------------|-------|-----------------------------------|
   * | Year        | YYYY  | 2018                              |
   * |             | YY    | < 68 -> 2000, > 68 -> 1900        |
   * | Month       | MM    | 01 - 12                           |
   * | Date        | DD    | 01 - 31                           |
   * | Hour        | HH    | 00 - 23 or 1 - 12                 |
   * | Minute      | mm    | 00 - 59                           |
   * | Second      | ss    | 00 - 59                           |
   * | Millisecond | S     | 0 - 9 [000, 100, 200 .. 900 ]     |
   * |             | SS    | 00 - 99 [000, 010, 020 .. 990 ]   |
   * |             | SSS   | 000 - 999 [000, 001, 002 .. 999 ] |
   * | AM/PM       | A     | AM or PM                          |
   * |             | a     | am or pm                          |
   * | TimeZone    | Z     | Z for UTC or +-HH:mm              |
   * | Predefined  | L     | Long date, MM/DD/YYYY             |
   * |             | LT    | Long time, HH:mm A                |
   *
   * Predefined formats and functions used to parse tokens can be localized, see for example the swedish locale SvSE.js
   *
   * NOTE: If no date parameters are provided then `Jan 01 2020` is used as a default date
   *
   * @param {String} dateString Date string
   * @param {String} format Date format (or {@link #property-defaultParseFormat-static} if left out)
   * @returns {Date} new Date instance parsed from the string
   * @category Parse & format
   */


  static parse(dateString, format = DH.defaultParseFormat) {
    if (dateString instanceof Date) {
      return dateString;
    }

    if (typeof dateString !== 'string' || !dateString) {
      return null;
    } // // For ISO 8601 native is faster, but not very forgiving
    // if (format === defaultFormat) {
    //     const dt = new Date(dateString);
    //     if (!isNaN(dt)) {
    //         return dt;
    //     }
    // }


    const config = {
      year: null,
      month: null,
      date: null,
      hours: null,
      minutes: null,
      seconds: null,
      milliseconds: null
    }; // Milliseconds parser is the same for S, SS, SSS

    format = format.replace(/S+/gm, 'SSS');
    let parser = parserCache[format],
        result;

    if (!parser) {
      parser = parserCache[format] = DH.buildParser(format);
    } // Each parser knows its pattern and splitter. It looks for splitter in the
    // input string, takes first substring and tries to process it. Remaining string
    // is passed to the next parser.


    parser.reduce((dateString, parser) => {
      if (parser.last) {
        Object.assign(config, parser.fn(dateString));
      } else {
        let splitAt; // ISO 8601 says that T symbol can be replaced with a space

        if (parser.splitter === 'T' && dateString.indexOf('T') === -1) {
          splitAt = dateString.indexOf(' ');
        } else {
          // If splitter specified find its position, otherwise try to determine pattern length
          splitAt = parser.splitter !== '' ? dateString.indexOf(parser.splitter) : parser.pattern && parser.pattern.length || -1;
        }

        let part, rest; // If splitter is not found in the current string we may be dealing with
        // 1. partial input - in that case we just feed all string to current parser and move on
        // 2. time zone (ssZ - splitter is empty string) and pattern is not specified, see comment below
        // 3. parse milliseconds before Z

        if (splitAt === -1 || parser.pattern === 'SSS' && dateString.match(/^\d+Z$/)) {
          // NOTE: parentheses are required here as + and - signs hold valuable information
          // with parentheses we get array like ['00','+','01:00'], omitting them we won't get
          // regexp match in result, loosing information
          const chunks = dateString.split(/([Z\-+])/); // If splitter is not found in the string, we may be dealing with string that contains info about TZ.
          // For instance, if format contains Z as last arg which is not separated (normally it is not indeed),
          // like 'YYYY-MM-DD HH:mm:ssZ', then second to last parser will have string that it cannot just parse, like
          // '2010-01-01 10:00:00'        -> '00'
          // '2010-01-01 10:00:00Z'       -> '00Z'
          // '2010-01-01 10:00:00-01'     -> '00-01'
          // '2010-01-01 10:00:00+01:30'  -> '00+01:30'
          // this cannot be processed by date parsers, so we need to process that additionally. So we
          // split string by symbols that can be found around timezone info: Z,-,+

          if (chunks.length === 1) {
            part = dateString;
            rest = '';
          } else {
            part = chunks[0];
            rest = `${chunks[1]}${chunks[2]}`;
          }
        } else {
          part = dateString.substring(0, splitAt) || dateString;
          rest = dateString.substring(splitAt + parser.splitter.length);
        }

        if (parser.fn) {
          // Run parser and add result to config on successful parse otherwise continue parsing
          const res = parser.fn(part);

          if (res) {
            Object.assign(config, res);
          } else {
            rest = part + rest;
          }
        }

        return rest;
      }
    }, dateString); // If year is specified date has to be greater than 0

    if (config.year && !config.date) {
      config.date = 1;
    }

    const date = DH.create(config);

    if (date) {
      result = date;
    } else {
      // Last resort, try if native passing can do it
      result = new Date(dateString);
    }

    return result;
  }
  /**
   * Creates a date from a date definition object. The object can have the following properties:
   * - year
   * - month
   * - date (day in month)
   * - hours
   * - minutes
   * - seconds
   * - milliseconds
   * - amPm : 'am' or 'pm', implies 12 hour clock
   * - timeZone : offset from UTC in minutes
   * @param {Object} definition
   * @returns {Date} new Date instance
   * @category Parse & format
   */


  static create(definition) {
    // Shallow clone to not alter input
    const def = _objectSpread({}, definition);

    let invalid = isNaN(def.year),
        useUTC = false; // Not much validation yet, only considered invalid if all properties are null

    if (!invalid) {
      let allNull = true;
      dateProperties.forEach(property => {
        if (!(property in def) || isNaN(def[property])) {
          def[property] = 0;
        }

        allNull = allNull && def[property] === null;
      });
      invalid = allNull;
    }

    if (def.amPm === 'pm') {
      def.hours = def.hours % 12 + 12;
    }

    if ('timeZone' in def) {
      useUTC = true;
      def.minutes -= def.timeZone;
    }

    if (invalid) {
      return null;
    }

    const args = [defaultValue(def.year, DEFAULT_YEAR), defaultValue(def.month, DEFAULT_MONTH), defaultValue(def.date, DEFAULT_DAY), def.hours, def.minutes, def.seconds, def.milliseconds];
    return useUTC ? new Date(Date.UTC(...args)) : new Date(...args);
  }

  static toUTC(date) {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds()));
  }
  /**
   * Converts a date to string with the specified format. Formats heavily inspired by https://momentjs.com.
   * Available formats (input used for output below is `new Date(2018,8,9,18,7,8,145)`):
   *
   * | Unit                  | Token | Description & output                  |
   * |-----------------------|-------|---------------------------------------|
   * | Year                  | YYYY  | 2018                                  |
   * |                       | YY    | 18                                    |
   * |                       | Y     | 2018                                  |
   * | Quarter               | Q     | 3                                     |
   * |                       | Qo    | 3rd                                   |
   * | Month                 | MMMM  | September                             |
   * |                       | MMM   | Sep                                   |
   * |                       | MM    | 09                                    |
   * |                       | Mo    | 9th                                   |
   * |                       | M     | 9                                     |
   * | Week (iso)            | WW    | 36 (2 digit)                          |
   * |                       | Wo    | 36th                                  |
   * |                       | W     | 36                                    |
   * | Date                  | DDDD  | Day of year, 3 digits                 |
   * |                       | DDDo  | Day of year, ordinal                  |
   * |                       | DDD   | Day of year                           |
   * |                       | DD    | 09                                    |
   * |                       | Do    | 9th                                   |
   * |                       | D     | 9                                     |
   * | Weekday               | dddd  | Sunday                                |
   * |                       | ddd   | Sun                                   |
   * |                       | dd    | Su                                    |
   * |                       | d1    | S                                     |
   * |                       | do    | 0th                                   |
   * |                       | d     | 0                                     |
   * | Hour                  | HH    | 18 (00 - 23)                          |
   * |                       | H     | 18 (0 - 23)                           |
   * |                       | hh    | 06 (00 - 12)                          |
   * |                       | h     | 6 (0 - 12)                            |
   * |                       | KK    | 19 (01 - 24)                          |
   * |                       | K     | 19 (1 - 24)                           |
   * |                       | kk    | 06 or 18, locale determines           |
   * |                       | k     | 6 or 18, locale determines            |
   * | Minute                | mm    | 07                                    |
   * |                       | m     | 7                                     |
   * | Second                | ss    | 08                                    |
   * |                       | s     | 8                                     |
   * | Millisecond           | S     | 1 (100ms)                             |
   * |                       | SS    | 14 (140ms)                            |
   * |                       | SSS   | 145 (145ms)                           |
   * | AM/PM                 | A     | AM or PM                              |
   * |                       | a     | am or pm                              |
   * | Predefined            | LT    | H: 2-digit (2d), m: 2d                |
   * | (uses browser locale) | LTS   | H: 2d, m: 2d, s : 2d                  |
   * |                       | LST   | Depends on 12 or 24 hour clock        |
   * |                       |       | 12h, H : 1d, m : 0 or 2d              |
   * |                       |       | 24h, H : 2d, m : 2d                   |
   * |                       | L     | Y: numeric (n), M : 2d, D : 2d        |
   * |                       | l     | Y: n, M : n, D : n                    |
   * |                       | LL    | Y: n, M : long (l), D : n             |
   * |                       | ll    | Y: n, M : short (s), D : n            |
   * |                       | LLL   | Y: n, M : l, D : n, H: n, m: 2d       |
   * |                       | lll   | Y: n, M : s, D : n, H: n, m: 2d       |
   * |                       | LLLL  | Y: n, M : l, D : n, H: n, m: 2d, d: l |
   * |                       | llll  | Y: n, M : s, D : n, H: n, m: 2d, d: s |
   *
   * Some examples:
   *
   * ```
   * DateHelper.format(new Date(2019, 7, 16), 'dddd') -> Friday
   * DateHelper.format(new Date(2019, 7, 16, 14, 27), 'HH:mm') --> 14:27
   * DateHelper.format(new Date(2019, 7, 16, 14, 27), 'L HH') --> 2019-07-16 14
   * ```
   *
   * Arbitrary text can be embedded in the format string by wrapping it with {}:
   *
   * ```
   * DateHelper.format(new Date(2019, 7, 16), '{It is }dddd{, yay!}') -> It is Friday, yay!
   * ```
   *
   * @param {Date} date Date
   * @param {String} format Desired format (uses `defaultFormat` if left out)
   * @returns {String} Formatted string
   * @category Parse & format
   */


  static format(date, format = DH.defaultFormat) {
    // Bail out if no date or invalid date
    if (!date || isNaN(date)) {
      return null;
    }

    let formatter = formatCache[format],
        output = '';

    if (!formatter) {
      formatter = formatCache[format] = []; // Build formatter array with the steps needed to format the date

      for (let i = 0; i < format.length; i++) {
        // Matches a predefined format?
        const formatMatch = format.substr(i).match(formatRegexp),
              predefined = formatMatch === null || formatMatch === void 0 ? void 0 : formatMatch[0];

        if (predefined) {
          const localeFormats = this.localize('L{formats}') || {},
                fn = localeFormats[predefined] || formats[predefined];
          formatter.push(fn);
          i += predefined.length - 1;
        } // Start of text block? Append it
        else if (format[i] === '{') {
          // Find closing brace
          const index = format.indexOf('}', i + 1); // No closing brace, grab rest of string

          if (index === -1) {
            formatter.push(format.substr(i + 1));
            i = format.length;
          } // Closing brace found
          else {
            formatter.push(format.substring(i + 1, index)); // Carry on after closing brace

            i = index;
          }
        } // Otherwise append to output (for example - / : etc)
        else {
          formatter.push(format[i]);
        }
      }
    }

    formatter.forEach(step => {
      if (typeof step === 'string') {
        output += step;
      } else {
        output += step(date);
      }
    }); // MS inserts a Left-to-right control char between localized date parts, remove it to have the expected string
    // output. Otherwise comparison with typed strings will fail

    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) {
      output = output.replace(/\u200E/g, '');
    }

    return output;
  }
  /**
   * Converts the specified amount of desired unit into milliseconds. Can be called by only specifying a unit as the
   * first argument, it then uses amount = 1. For example: asMilliseconds('hour') == asMilliseconds(1, 'hour')
   * @param {Number|String} amount Amount, what of is decided by specifying unit (also takes a unit which implies an amount of 1)
   * @param {String} unit Time unit (s, hour, months etc.)
   * @returns {Number}
   * @category Parse & format
   */


  static asMilliseconds(amount, unit = null) {
    if (typeof amount === 'string') {
      unit = amount;
      amount = 1;
    }

    return DH.as('millisecond', amount, unit);
  }
  /**
   * Converts the passed Date to an accurate number of months passed since the epoch start.
   * @param {Date} time The Date to find the month value of.
   * @returns {Number} The number of months since the system time epoch start. May be a fractional value.
   */


  static asMonths(time) {
    const monthLength = DH.as('ms', DH.daysInMonth(time), 'day'),
          fraction = (time.valueOf() - DH.startOf(time, 'month').valueOf()) / monthLength;
    return time.getYear() * 12 + time.getMonth() + fraction;
  }

  static monthsToDate(months) {
    const intMonths = Math.floor(months),
          fraction = months - intMonths,
          result = new Date(0, intMonths),
          msInMonth = DH.as('ms', DH.daysInMonth(result), 'days');
    result.setTime(result.getTime() + fraction * msInMonth);
    return result;
  }
  /**
   * Converts a millisecond time delta to a human readable form. For example `1000 * 60 * 60 * 50`
   * milliseconds would be rendered as "2 days, 2 hours"
   * @param {Number} delta The millisecond delta value.
   * @param {Object} [options] Formatting options.
   * @param {Boolean} [options.abbrev] Pass `true` to use abbreviated unit names, eg "2d, 2h" for the above example.
   * @param {String} [options.precision] The minimum precision unit.
   * @param {String} [options.separator] The separator to use
   * @param {Boolean} [options.asString] Pass `false` to return the result as an array, eg ['2d', '2h'] for the above example.
   * @returns {String} Formatted string
   * @category Parse & format
   */


  static formatDelta(delta, options) {
    let abbrev, unitName;

    if (typeof options === 'boolean') {
      abbrev = options;
    } else if (options) {
      abbrev = options.abbrev;
    }

    const deltaObj = this.getDelta(delta, options),
          result = [],
          sep = (options === null || options === void 0 ? void 0 : options.separator) || (abbrev ? '' : ' ');

    for (unitName in deltaObj) {
      result.push(`${deltaObj[unitName]}${sep}${unitName}`);
    }

    return (options === null || options === void 0 ? void 0 : options.asString) === false ? result : result.join(', ');
  }
  /**
   * Converts a millisecond time delta to an object structure. For example `1000 * 60 * 60 * 50`
   * milliseconds the result would be as:
   * {
   *     day: 2,
   *     hour: 2
   * }
   *
   * @param {Number} delta The millisecond delta value.
   * @param {Object} [options] Formatting options.
   * @param {Boolean} [options.abbrev] Pass `true` to use abbreviated unit names, eg "{ d: 2, h: 2 }" for the above example.
   * @param {String} [options.precision] The minimum precision unit.
   * @returns {Object} The object with the values for each unit.
   */


  static getDelta(delta, options) {
    let abbrev, d, done, precision, unitName;

    if (typeof options === 'boolean') {
      abbrev = options;
    } else if (options) {
      abbrev = options.abbrev;
      precision = DH.normalizeUnit(options.precision);
    }

    const result = {},
          getUnit = abbrev ? DH.getShortNameOfUnit : DH.getLocalizedNameOfUnit; // Loop downwards through the magnitude of units from year -> ms

    for (unitName of deltaUnits) {
      d = DH.as(unitName, delta);
      done = precision === unitName;
      d = Math[done ? 'round' : 'floor'](d); // If there's a non-zero integer quantity of this unit, add it to result
      // and subtract from the delta, then go round to next unit down.

      if (d || done && !result.length) {
        result[getUnit.call(DH, unitName, d !== 1)] = d; // TODO 0 is plural in EN but...?

        delta -= DH.as('ms', d, unitName);
      }

      if (done || !delta) {
        break;
      }
    }

    return result;
  }
  /**
   * Converts the specified amount of one unit (fromUnit) into an amount of another unit (toUnit)
   * @param {String} toUnit The name of units to convert to, eg: `'ms'`
   * @param {Number|String} amount The time to convert. Either the magnitude number form
   * or a duration string such as '2d'.
   * @param {String} [fromUnit] If the amount was passed as a number, the units to use to convert from.
   * @returns {Number}
   * @category Parse & format
   */


  static as(toUnit, amount, fromUnit = 'ms') {
    // Allow DH.as('ms', '2d')
    if (typeof amount === 'string') {
      amount = DH.parseDuration(amount);
    } // Allow DH.as('ms', myDurationObject)


    if (typeof amount === 'object') {
      fromUnit = amount.unit;
      amount = amount.magnitude;
    }

    if (toUnit === fromUnit) {
      return amount;
    }

    toUnit = DH.normalizeUnit(toUnit);
    fromUnit = DH.normalizeUnit(fromUnit);

    if (toUnit === fromUnit) {
      return amount;
    } // validConversions[][] can be negative to signal that conversion is not exact, ignore sign here
    else if (unitMagnitudes[fromUnit] > unitMagnitudes[toUnit]) {
      return amount * Math.abs(validConversions[fromUnit][toUnit]);
    } else {
      return amount / Math.abs(validConversions[toUnit][fromUnit]);
    }
  }

  static formatContainsHourInfo(format) {
    const stripEscapeRe = /(\\.)/g,
          hourInfoRe = /([HhKkmSsAa]|LT|L{3,}|l{3,})/;
    return hourInfoRe.test(format.replace(stripEscapeRe, ''));
  }
  /**
   * Returns true for 24 hour format.
   * @param {String} format Date format
   * @returns {Boolean}
   * @category Parse & format
   */


  static is24HourFormat(format) {
    return DH.format(DH.getTime(13, 0, 0), format).includes('13');
  } //endregion
  //region Manipulate

  /**
   * Add days, hours etc. to a date. Always clones the date, original will be left unaffected.
   * @param {Date|String} date Original date
   * @param {Number} amount Amount of days, hours etc
   * @param {String} unit Unit for amount
   * @privateparam {Boolean} [clone] Affect the original
   * @returns {Date} New calculated date
   * @category Manipulate
   */


  static add(date, amount, unit = 'ms', clone = true) {
    let d;

    if (typeof date === 'string') {
      d = DH.parse(date);
    } else if (clone) {
      d = new Date(date.getTime());
    } else {
      d = date;
    }

    if (!unit || amount === 0) {
      return d;
    }

    unit = DH.normalizeUnit(unit);

    switch (unit) {
      case 'millisecond':
        d.setTime(d.getTime() + amount);
        break;

      case 'second':
        d.setTime(d.getTime() + amount * 1000);
        break;

      case 'minute':
        d.setTime(d.getTime() + amount * 60000);
        break;

      case 'hour':
        d.setTime(d.getTime() + amount * 3600000);
        break;

      case 'day':
        // Integer value added, do calendar calculation to correctly handle DST etc.
        if (amount % 1 === 0) {
          d.setDate(d.getDate() + amount);
        } // No browsers support fractional values for dates any longer, do time based calculation
        else {
          d.setTime(d.getTime() + amount * 86400000);
        } // When crossing DST in Brazil, we expect hours to end up the same


        if (d.getHours() === 23 && date.getHours() === 0) {
          d.setHours(d.getHours() + 1);
        }

        break;

      case 'week':
        d.setDate(d.getDate() + amount * 7);
        break;

      case 'month':
        {
          let day = d.getDate();

          if (day > 28) {
            day = Math.min(day, DH.getLastDateOfMonth(DH.add(DH.getFirstDateOfMonth(d), amount, 'month')).getDate());
          }

          d.setDate(day);
          d.setMonth(d.getMonth() + amount);
          break;
        }

      case 'quarter':
        DH.add(d, amount * 3, 'month', false);
        break;

      case 'year':
        d.setFullYear(d.getFullYear() + amount);
        break;

      case 'decade':
        d.setFullYear(d.getFullYear() + amount * 10);
        break;
    }

    return d;
  }
  /**
   * Calculates the difference between two dates, in the specified unit.
   * @param {Date} start First date
   * @param {Date} end Second date
   * @param {String} unit Unit to calculate difference in
   * @param {Boolean} fractional Specify false to round result
   * @returns {Number} Difference in the specified unit
   * @category Manipulate
   */


  static diff(start, end, unit = 'ms', fractional = true) {
    unit = DH.normalizeUnit(unit);
    if (!start || !end) return 0;
    let amount;

    switch (unit) {
      case 'year':
        amount = DH.diff(start, end, 'month') / 12;
        break;

      case 'quarter':
        amount = DH.diff(start, end, 'month') / 3;
        break;

      case 'month':
        amount = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
        break;

      case 'week':
        amount = DH.diff(start, end, 'day') / 7;
        break;

      case 'day':
        {
          const dstDiff = start.getTimezoneOffset() - end.getTimezoneOffset();
          amount = (end - start + dstDiff * 60 * 1000) / 86400000;
          break;
        }

      case 'hour':
        amount = (end - start) / 3600000;
        break;

      case 'minute':
        amount = (end - start) / 60000;
        break;

      case 'second':
        amount = (end - start) / 1000;
        break;

      case 'millisecond':
        amount = end - start;
        break;
    }

    return fractional ? amount : Math.round(amount);
  }
  /**
   * Sets the date to the start of the specified unit, by default returning a clone of the date instead of changing it
   * inplace.
   * @param {Date} date Original date
   * @param {String} unit Start of this unit, 'day', 'month' etc.
   * @param {Boolean} clone Manipulate a copy of the date
   * @returns {Date} Manipulated date
   * @category Manipulate
   */


  static startOf(date, unit = 'day', clone = true) {
    if (!date) {
      return null;
    }

    unit = DH.normalizeUnit(unit);

    if (clone) {
      date = DH.clone(date);
    }

    switch (unit) {
      case 'year':
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
        return date;

      case 'quarter':
        date.setMonth((DH.get(date, 'quarter') - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;

      case 'month':
        date.setDate(1);
        date.setHours(0, 0, 0, 0);
        return date;

      case 'week':
        {
          const delta = date.getDay() - DH.weekStartDay;
          date.setDate(date.getDate() - delta);
          date.setHours(0, 0, 0, 0);
          return date;
        }

      case 'day':
        date.setHours(0, 0, 0, 0);
        return date;
      // Cant use setMinutes(0, 0, 0) etc for DST transitions

      case 'hour':
        date.getMinutes() > 0 && date.setMinutes(0);
      // eslint-disable-next-line no-fallthrough

      case 'minute':
        date.getSeconds() > 0 && date.setSeconds(0);
      // eslint-disable-next-line no-fallthrough

      case 'second':
        date.getMilliseconds() > 0 && date.setMilliseconds(0);
      // eslint-disable-next-line no-fallthrough

      case 'millisecond':
        return date;
    }
  }
  /**
   * Returns the end point of the passed date, that is 00:00:00 of the day after the passed date.
   * @param {Date} date The date to return the end point of.
   */


  static endOf(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
  }
  /**
   * Creates a clone of the specified date
   * @param {Date} date Original date
   * @returns {Date} Cloned date
   * @category Manipulate
   */


  static clone(date) {
    return new Date(date.getTime());
  }
  /**
   * Removes time from a date (same as calling #startOf(date, 'day'))
   * @param {Date} date Date to remove time from
   * @param {Boolean} clone Manipulate a copy of the date
   * @returns {Date} Manipulated date
   * @category Manipulate
   */


  static clearTime(date, clone = true) {
    if (!date) {
      return null;
    }

    if (clone) {
      date = new Date(date.getTime());
    }

    date.setHours(0, 0, 0, 0);
    return date;
  }

  static midnight(date, inclusive) {
    let ret = DH.clearTime(date);

    if (inclusive && ret < date) {
      ret = DH.add(ret, 1, 'd');
    }

    return ret;
  }
  /**
   * Returns the elapsed milliseconds from the start of the specified date.
   * @param {Date} date Date to remove date from.
   * @param {String} [as] The time unit to return.
   * @returns {Number} The elapsed milliseconds from the start of the specified date
   * @category Manipulate
   */


  static getTimeOfDay(date, as = 'ms') {
    const t = date.getHours() * validConversions.hour.millisecond + date.getMinutes() * validConversions.minute.millisecond + date.getSeconds() * validConversions.second.millisecond + date.getMilliseconds();
    return as === 'ms' ? t : DH.as(as, t, 'ms');
  }
  /**
   * Sets a part of a date (in place)
   * @param {Date} date Date to manipulate
   * @param {String|Object} unit Part of date to set, for example 'minute'. Or an object like { second: 1, minute: 1 }
   * @param {Number} amount Value to set
   * @returns {Date} Passed date instance modified according to the arguments
   * @category Manipulate
   */


  static set(date, unit, amount) {
    if (!unit) {
      return date;
    }

    if (typeof unit === 'string') {
      switch (DH.normalizeUnit(unit)) {
        case 'millisecond':
          // Setting value to 0 when it is 0 at DST crossing messes it up
          if (amount !== 0 || date.getMilliseconds() > 0) {
            date.setMilliseconds(amount);
          }

          break;

        case 'second':
          // Setting value to 0 when it is 0 at DST crossing messes it up
          if (amount !== 0 || date.getSeconds() > 0) {
            date.setSeconds(amount);
          }

          break;

        case 'minute':
          // Setting value to 0 when it is 0 at DST crossing messes it up
          if (amount !== 0 || date.getMinutes() > 0) {
            date.setMinutes(amount);
          }

          break;

        case 'hour':
          date.setHours(amount);
          break;

        case 'day':
        case 'date':
          date.setDate(amount);
          break;

        case 'week':
          throw new Error('week not implemented');

        case 'month':
          date.setMonth(amount);
          break;

        case 'quarter':
          // Setting quarter = first day of first month of that quarter
          date.setDate(1);
          date.setMonth((amount - 1) * 3);
          break;

        case 'year':
          date.setFullYear(amount);
          break;
      }
    } else {
      Object.entries(unit) // Make sure smallest unit goes first, to not change month before changing day
      .sort((a, b) => unitMagnitudes[a[0]] - unitMagnitudes[b[0]]).forEach(([unit, amount]) => {
        DH.set(date, unit, amount);
      });
    }

    return date;
  }

  static setDateToMidday(date, clone = true) {
    return DH.set(DH.clearTime(date, clone), 'hour', 12);
  }
  /**
   * Constrains the date within a min and a max date
   * @param {Date} date The date to constrain
   * @param {Date} [min] Min date
   * @param {Date} [max] Max date
   * @return {Date} The constrained date
   * @category Manipulate
   */


  static constrain(date, min, max) {
    if (min != null) {
      date = DH.max(date, min);
    }

    return max == null ? date : DH.min(date, max);
  }
  /**
   * Returns time with default year, month, and day (Jan 1, 2020)
   * @param {Number|Date} hours Hours value or the full date to extract the time of.
   * @param {Number} minutes Minutes value
   * @param {Number} seconds Seconds value
   * @param {Number} ms Milliseconds value
   * @returns {Date} A new default date with the time extracted from the given date or from the time values provided individually.
   * @category Manipulate
   */


  static getTime(hours, minutes = 0, seconds = 0, ms = 0) {
    if (hours instanceof Date) {
      ms = hours.getMilliseconds();
      seconds = hours.getSeconds();
      minutes = hours.getMinutes();
      hours = hours.getHours();
    }

    return new Date(DEFAULT_YEAR, DEFAULT_MONTH, DEFAULT_DAY, hours, minutes, seconds, ms);
  }
  /**
   * Copies hours, minutes, seconds, milliseconds from one date to another
   *
   * @param {Date} targetDate The target date
   * @param {Date} sourceDate The source date
   * @return {Date} The adjusted target date
   * @category Manipulate
   * @static
   */


  static copyTimeValues(targetDate, sourceDate) {
    targetDate.setHours(sourceDate.getHours());
    targetDate.setMinutes(sourceDate.getMinutes());
    targetDate.setSeconds(sourceDate.getSeconds());
    targetDate.setMilliseconds(sourceDate.getMilliseconds());
    return targetDate;
  } //endregion
  //region Comparison


  static isDST(date) {
    const year = date.getFullYear(),
          jan = new Date(year, 0, 1),
          jul = new Date(year, 6, 1);
    return date.getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  }
  /**
   * Determines if a date precedes another.
   * @param {Date} first First date
   * @param {Date} second Second date
   * @returns {Boolean} true if first precedes second, otherwise false
   * @category Comparison
   */


  static isBefore(first, second) {
    return first < second;
  }
  /**
   * Determines if a date succeeds another.
   * @param {Date} first First date
   * @param {Date} second Second date
   * @returns {Boolean} true if first succeeds second, otherwise false
   * @category Comparison
   */


  static isAfter(first, second) {
    return first > second;
  }
  /**
   * Checks if two dates are equal.
   * @param {Date} first First date
   * @param {Date} second Second date
   * @param {String} unit If not given, the comparison will be done up to a millisecond
   * @returns {Boolean} true if the dates are equal
   * @category Comparison
   */


  static isEqual(first, second, unit = null) {
    if (unit === null) {
      // https://jsbench.me/3jk2bom2r3/1
      // https://jsbench.me/ltkb3vk0ji/1 (more flavors) - getTime is >2x faster vs valueOf/Number/op+
      return first && second && first.getTime() === second.getTime();
    }

    return DH.startOf(first, unit) - DH.startOf(second, unit) === 0;
  }
  /**
   * Compares two dates using the specified precision
   * @param {Date} first
   * @param {Date} second
   * @param {String} unit
   * @returns {Number} 0 = equal, -1 first before second, 1 first after second
   * @category Comparison
   */


  static compare(first, second, unit = null) {
    // Unit specified, cut the rest out
    if (unit) {
      first = DH.startOf(first, unit);
      second = DH.startOf(second, unit);
    } // Comparison on ms level


    if (first < second) return -1;
    if (first > second) return 1;
    return 0;
  }

  static isSameDate(first, second) {
    return DH.compare(first, second, 'd') === 0;
  }
  /**
   * Checks if date is the start of specified unit
   * @param {Date} date
   * @param {String} unit
   * @returns {Boolean}
   * @category Comparison
   */


  static isStartOf(date, unit) {
    return DH.isEqual(date, DH.startOf(date, unit));
  }
  /**
   * Checks if this date is >= start and < end.
   * @param {Date} date The source date
   * @param {Date} start Start date
   * @param {Date} end End date
   * @return {Boolean} true if this date falls on or between the given start and end dates.
   * @category Comparison
   */


  static betweenLesser(date, start, end) {
    //return start <= date && date < end;
    return start.getTime() <= date.getTime() && date.getTime() < end.getTime();
  }
  /**
   * Checks if this date is >= start and <= end.
   * @param {Date} date The source date
   * @param {Date} start Start date
   * @param {Date} end End date
   * @return {Boolean} true if this date falls on or between the given start and end dates.
   * @category Comparison
   */


  static betweenLesserEqual(date, start, end) {
    return start.getTime() <= date.getTime() && date.getTime() <= end.getTime();
  }
  /**
   * Returns true if dates intersect
   * @param {Date} date1Start
   * @param {Date} date1End
   * @param {Date} date2Start
   * @param {Date} date2End
   * @return {Boolean} Returns true if dates intersect
   * @category Comparison
   */


  static intersectSpans(date1Start, date1End, date2Start, date2End) {
    return DH.betweenLesser(date1Start, date2Start, date2End) || DH.betweenLesser(date2Start, date1Start, date1End);
  }
  /**
   * Compare two units. Returns 1 if first param is a greater unit than second param, -1 if the opposite is true or 0 if they're equal
   * @param {String} unit1 The 1st unit
   * @param {String} unit2 The 2nd unit
   * @returns {Number} Returns 1 if first param is a greater unit than second param, -1 if the opposite is true or 0 if they're equal
   * @category Comparison
   */


  static compareUnits(unit1, unit2) {
    return Math.sign(unitMagnitudes[unit1] - unitMagnitudes[unit2]);
  }
  /**
   * Returns true if the first time span completely 'covers' the second time span.
   * @example
   * DateHelper.timeSpanContains(new Date(2010, 1, 2), new Date(2010, 1, 5), new Date(2010, 1, 3), new Date(2010, 1, 4)) ==> true
   * DateHelper.timeSpanContains(new Date(2010, 1, 2), new Date(2010, 1, 5), new Date(2010, 1, 3), new Date(2010, 1, 6)) ==> false
   * @param {Date} spanStart The start date for initial time span
   * @param {Date} spanEnd The end date for initial time span
   * @param {Date} otherSpanStart The start date for the 2nd time span
   * @param {Date} otherSpanEnd The end date for the 2nd time span
   * @return {Boolean}
   * @category Comparison
   */


  static timeSpanContains(spanStart, spanEnd, otherSpanStart, otherSpanEnd) {
    return otherSpanStart - spanStart >= 0 && spanEnd - otherSpanEnd >= 0;
  } //endregion
  //region Query

  /**
   * Get the first day of week, 0-6 (Sunday-Saturday).
   * This is determined by the current locale's `DateHelper.weekStartDay` parameter.
   * @property {Number}
   * @readonly
   */


  static get weekStartDay() {
    // Cache is reset in applyLocale
    if (DH._weekStartDay == null) {
      // Defaults to 0, should not need to happen in real world scenarios when a locale is always loaded
      DH._weekStartDay = this.localize('L{weekStartDay}') || 0;
    }

    return DH._weekStartDay;
  }
  /**
   * Get non-working days as an object where keys are day indices, 0-6 (Sunday-Saturday), and the value is `true`.
   * This is determined by the current locale's `DateHelper.nonWorkingDays` parameter.
   *
   * For example:
   * ```
   * {
   *     0 : true, // Sunday
   *     6 : true  // Saturday
   * }
   * ```
   * @property {Object}
   * @readonly
   */


  static get nonWorkingDays() {
    return _objectSpread({}, this.localize('L{nonWorkingDays}'));
  }
  /**
   * Get non-working days as an array of day indices, 0-6 (Sunday-Saturday).
   * This is determined by the current locale's `DateHelper.nonWorkingDays` parameter.
   *
   * For example:
   * ```
   * [ 0, 6 ] // Sunday & Saturday
   * ```
   * @property {Number[]}
   * @readonly
   * @internal
   */


  static get nonWorkingDaysAsArray() {
    // transform string keys to integers
    return Object.keys(this.nonWorkingDays).map(Number);
  }
  /**
   * Get weekend days as an object where keys are day indices, 0-6 (Sunday-Saturday), and the value is `true`.
   * Weekends are days which are declared as weekend days by the selected country and defined by the current locale's `DateHelper.weekends` parameter.
   * To get non-working days see {@link #property-nonWorkingDays-static}.
   *
   * For example:
   * ```
   * {
   *     0 : true, // Sunday
   *     6 : true  // Saturday
   * }
   * ```
   * @property {Object}
   * @readonly
   * @internal
   */


  static get weekends() {
    return _objectSpread({}, this.localize('L{weekends}'));
  }
  /**
   * Get the specified part of a date
   * @param {Date} date
   * @param {String} unit Part of date, hour, minute etc.
   * @returns {Number} The requested part of the specified date
   * @category Query
   */


  static get(date, unit) {
    switch (DH.normalizeUnit(unit)) {
      case 'millisecond':
        return date.getMilliseconds();

      case 'second':
        return date.getSeconds();

      case 'minute':
        return date.getMinutes();

      case 'hour':
        return date.getHours();

      case 'date':
      case 'day':
        // Scheduler has a lot of calculations expecting this to work
        return date.getDate();

      case 'week':
        return formats.W(date);

      case 'month':
        return date.getMonth();

      case 'quarter':
        return Math.floor(date.getMonth() / 3) + 1;

      case 'year':
        return date.getFullYear();
    }

    return null;
  }
  /**
   * Get number of days in the current year for the supplied date.
   * @param {Date} date Date to check
   * @return {Number} Days in year
   * @category Query
   * @internal
   */


  static daysInYear(date) {
    const fullYear = date.getFullYear(),
          duration = new Date(fullYear + 1, 0, 1) - new Date(fullYear, 0, 1);
    return this.as('day', duration);
  }
  /**
   * Get number of days in the current month for the supplied date
   * @param {Date} date Date which month should be checked
   * @returns {Number} Days in month
   * @category Query
   */


  static daysInMonth(date) {
    const d = DH.clone(date);
    d.setDate(1);
    d.setMonth(date.getMonth() + 1);
    d.setDate(0);
    return d.getDate();
  }
  /**
   * Get number of hours in the current day for the supplied date.
   * @param {Date} date Date to check
   * @return {Number} Hours in day
   * @category Query
   * @internal
   */


  static hoursInDay(date) {
    const fullYear = date.getFullYear(),
          month = date.getMonth(),
          day = date.getDate(),
          duration = new Date(fullYear, month, day + 1) - new Date(fullYear, month, day);
    return this.as('hour', duration);
  }
  /**
   * Converts unit related to the date to actual amount of milliseconds in it. Takes into account leap years and
   * different duration of months.
   * @param {Date} date
   * @param {String} unit
   * @return {Number} Returns amount of milliseconds
   * @internal
   */


  static getNormalizedUnitDuration(date, unit) {
    let result;

    switch (unit) {
      case 'month':
        result = DH.asMilliseconds(DH.daysInMonth(date), 'day');
        break;

      case 'year':
        result = DH.asMilliseconds(DH.daysInYear(date), 'day');
        break;

      case 'day':
        result = DH.asMilliseconds(DH.hoursInDay(date), 'hour');
        break;

      default:
        result = DH.asMilliseconds(unit);
    }

    return result;
  }
  /**
   * Get the first date of the month for the supplied date
   * @param {Date} date
   * @returns {Date} New Date instance
   * @category Query
   */


  static getFirstDateOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }
  /**
   * Get the last date of the month for the supplied date
   * @param {Date} date
   * @returns {Date} New Date instance
   * @category Query
   */


  static getLastDateOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }
  /**
   * Get the earliest of two dates
   * @param {Date} first
   * @param {Date} second
   * @returns {Date} Earliest date
   * @category Query
   */


  static min(first, second) {
    return first.getTime() < second.getTime() ? first : second;
  }
  /**
   * Get the latest of two dates
   * @param {Date} first
   * @param {Date} second
   * @returns {Date} Latest date
   * @category Query
   */


  static max(first, second) {
    return first.getTime() > second.getTime() ? first : second;
  }
  /**
   * Get an incremented date. Incrementation based on specified unit and optional amount
   * @param {Date} date
   * @param {String} unit
   * @param {Number} [increment]
   * @param {Number} [weekStartDay] Will default to what is set in locale
   * @returns {Date} New Date instance
   * @category Query
   */


  static getNext(date, unit, increment = 1, weekStartDay = DH.weekStartDay) {
    if (unit === 'week') {
      const dt = DH.clone(date),
            day = dt.getDay();
      DH.startOf(dt, 'day', false);
      DH.add(dt, weekStartDay - day + 7 * (increment - (weekStartDay <= day ? 0 : 1)), 'day', false); // For south american timezones, midnight does not exist on DST transitions, adjust...

      if (dt.getDay() !== weekStartDay) {
        DH.add(dt, 1, 'hour');
      }

      return dt;
    }

    return DH.startOf(DH.add(date, increment, unit), unit, false);
  }
  /**
   * Checks if date object is valid.
   *
   * For example:
   *
   * ```javascript
   * date = new Date('foo')
   * date instanceof Date // true
   * date.toString() // "Invalid Date"
   * isNaN(date) // true
   * DateHelper.isValidDate(date) // false
   *
   * date = new Date()
   * date instanceof Date // true
   * date.toString() // "Mon Jan 13 2020 18:27:38 GMT+0300 (GMT+03:00)"
   * isNaN(date) // false
   * DateHelper.isValidDate(date) // true
   * ```
   *
   * @param {Date} date
   * @returns {Boolean}
   */


  static isValidDate(date) {
    return DH.isDate(date) && !isNaN(date);
  }
  /**
   * Checks if value is a date object. Allows to recognize date object even from another context,
   * like the top frame when used in an iframe.
   *
   * @param {*} value
   * @returns {Boolean}
   */


  static isDate(value) {
    // see https://jsbench.me/s7kb49w83j/1 (cannot use instanceof cross-frame):
    return value && toString.call(value) === DATE_TYPE;
  }
  /**
   * Get the start of the next day
   * @param {Date} date
   * @param {Boolean} [clone]
   * @param {Boolean} [noNeedToClearTime=false]
   * @returns {Date} Passed Date or new Date instance, depending on the `clone` flag
   * @category Query
   */


  static getStartOfNextDay(date, clone, noNeedToClearTime) {
    let nextDay = DH.add(noNeedToClearTime ? date : DH.clearTime(date, clone), 1, 'day'); // DST case

    if (nextDay.getDate() === date.getDate()) {
      const offsetNextDay = DH.add(DH.clearTime(date, clone), 2, 'day').getTimezoneOffset(),
            offsetDate = date.getTimezoneOffset();
      nextDay = DH.add(nextDay, offsetDate - offsetNextDay, 'minute');
    }

    return nextDay;
  }
  /**
   * Get the end of previous day
   * @param {Date} date
   * @param {Boolean} noNeedToClearTime
   * @returns {Date} New Date instance
   * @category Query
   */


  static getEndOfPreviousDay(date, noNeedToClearTime) {
    const dateOnly = noNeedToClearTime ? date : DH.clearTime(date, true); // dates are different

    if (dateOnly - date) {
      return dateOnly;
    } else {
      return DH.add(dateOnly, -1, 'day');
    }
  }
  /**
   * Returns a string describing the specified week. For example, "39, September 2020" or "40, Sep - Oct 2020".
   * @param {Date} startDate
   * @param {Date} [endDate]
   * @returns {String}
   * @internal
   */


  static getWeekDescription(startDate, endDate = startDate) {
    const monthDesc = startDate.getMonth() === endDate.getMonth() ? DateHelper.format(startDate, 'MMMM') : `${DateHelper.format(startDate, 'MMM')} - ${DateHelper.format(endDate, 'MMM')}`,
          week = DateHelper.getWeekNumber(startDate);
    return `${week[1]}, ${monthDesc} ${week[0]}`;
  }
  /**
   * Get week number for the date.
   * @param {Date} date date
   * @param {Number} weekStartDay first day of week, 0-6 (Sunday-Saturday). Defaults to the {@link #property-weekStartDay-static}.
   * @returns {Number[]} year and week number
   * @category Query
   */


  static getWeekNumber(date, weekStartDay = DateHelper.weekStartDay) {
    const jan01 = new Date(date.getFullYear(), 0, 1),
          dec31 = new Date(date.getFullYear(), 11, 31),
          firstDay = normalizeDay(jan01.getDay() - weekStartDay),
          lastDay = normalizeDay(dec31.getDay() - weekStartDay),
          dayNumber = getDayDiff(date, jan01);
    let weekNumber; // Check if the year starts before the middle of a week

    if (firstDay < 4) {
      weekNumber = Math.floor((dayNumber + firstDay - 1) / 7) + 1;
    } else {
      weekNumber = Math.floor((dayNumber + firstDay - 1) / 7);
    }

    if (weekNumber) {
      let year = date.getFullYear(); // Might be week 1 of next year if the year ends before day 3 (0 based)

      if (weekNumber === 53 && lastDay < 3) {
        year++;
        weekNumber = 1;
      }

      return [year, weekNumber];
    } // We're in week zero which is the last week of the previous year, so ask what
    // week encapsulates 31 Dec in the previous year.


    const lastWeekOfLastYear = DateHelper.getWeekNumber(new Date(date.getFullYear() - 1, 11, 31))[1];
    return [date.getFullYear() - 1, lastWeekOfLastYear];
  } //endregion
  //region Unit helpers

  /**
   * Turns (10, 'day') into '10 days' etc.
   * @param {Number} count Amount of unit
   * @param {String} unit Unit, will be normalizes (days, d -> day etc.)
   * @returns {String}
   * @category Unit helpers
   */


  static formatCount(count, unit) {
    unit = DH.normalizeUnit(unit);
    if (count !== 1) unit += 's';
    return count + ' ' + unit;
  }
  /**
   * Get the ratio between two units ( year, month -> 1/12 )
   * @param {String} baseUnit
   * @param {String} unit
   * @param {Boolean} acceptEstimate If true, process negative values of validConversions. Defaults to false.
   * @returns {Number} Ratio
   * @category Unit helpers
   */


  static getUnitToBaseUnitRatio(baseUnit, unit, acceptEstimate = false) {
    baseUnit = DH.normalizeUnit(baseUnit);
    unit = DH.normalizeUnit(unit);
    if (baseUnit === unit) return 1; // Some validConversions have negative sign to signal that it is not an exact conversion.
    // Ignore those here unless acceptEstimate is provided.

    if (validConversions[baseUnit] && validConversions[baseUnit][unit] && (acceptEstimate || validConversions[baseUnit][unit] > 0)) {
      return 1 / DH.as(unit, 1, baseUnit);
    }

    if (validConversions[unit] && validConversions[unit][baseUnit] && (acceptEstimate || validConversions[unit][baseUnit] > 0)) {
      return DH.as(baseUnit, 1, unit);
    }

    return -1;
  }
  /**
   * Returns a localized abbreviated form of the name of the duration unit.
   * For example in the `EN` locale, for `"qrt"` it will return `"q"`.
   * @param {String} unit Duration unit
   * @return {String}
   * @category Unit helpers
   */


  static getShortNameOfUnit(unit) {
    // Convert abbreviations to the canonical name.
    // See locale file and the applyLocale method below.
    unit = DH.parseTimeUnit(unit); // unitLookup is keyed by eg 'DAY', 'day', 'MILLISECOND', 'millisecond' etc

    return DH.unitLookup[unit].abbrev;
  }
  /**
   * Returns a localized full name of the duration unit.
   *
   * For for example in the `EN` locale, for `"d"` it will return either
   * `"day"` or `"days"`, depending from the `plural` argument
   *
   * Preserves casing of first letter.
   *
   * @static
   * @param {String} unit Time unit
   * @param {Boolean} [plural] Whether to return a plural name or singular
   * @return {String}
   * @category Unit helpers
   */


  static getLocalizedNameOfUnit(unit, plural = false) {
    const capitalize = unit.charAt(0) === unit.charAt(0).toUpperCase(); // Normalize to not have to have translations for each variation used in code

    unit = DH.normalizeUnit(unit); // Convert abbreviations to the canonical name.
    // See locale file and the applyLocale method below.

    unit = DH.parseTimeUnit(unit); // Translate
    // unitLookup is keyed by eg 'DAY', 'day', 'MILLISECOND', 'millisecond' etc

    unit = DH.unitLookup[unit][plural ? 'plural' : 'single']; // Preserve casing of first letter

    if (capitalize) {
      unit = _StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].capitalize(unit);
    }

    return unit;
  }
  /**
   * Normalizes a unit for easier usage in conditionals. For example year, years, y -> year
   * @param {String} unit
   * @returns {String}
   * @category Unit helpers
   */


  static normalizeUnit(unit) {
    if (!unit) {
      return null;
    }

    const unitLower = unit.toLowerCase();

    if (unitLower === 'date') {
      return unitLower;
    }

    return canonicalUnitNames.includes(unitLower) // Already valid
    ? unitLower // Trying specified case first, since we have both "M" for month and "m" for minute
    : normalizedUnits[unit] || normalizedUnits[unitLower];
  }

  static getUnitByName(name) {
    // Allow either a canonical name to be passed, or, if that fails, parse it as a localized name or abbreviation.
    return DH.normalizeUnit(name) || DH.normalizeUnit(DH.parseTimeUnit(name));
  }
  /**
   * Returns a duration of the timeframe in the given unit.
   * @param {Date} start The start date of the timeframe
   * @param {Date} end The end date of the timeframe
   * @param {String} unit Duration unit
   * @return {Number} The duration in the units
   * @category Unit helpers
   * @ignore
   */


  static getDurationInUnit(start, end, unit, doNotRound) {
    return DH.diff(start, end, unit, doNotRound);
  }
  /**
   * Checks if two date units align
   * @private
   * @param {String} majorUnit
   * @param {String} minorUnit
   * @returns {Boolean}
   * @category Unit helpers
   */


  static doesUnitsAlign(majorUnit, minorUnit) {
    // TODO: probably needs some fleshing out to be generally useful, otherwise move to TimeAxisViewModel?
    // Maybe also use getUnitToBaseUnitRatio() for assertion?
    return !(majorUnit !== minorUnit && minorUnit === 'week');
  }

  static getSmallerUnit(unit) {
    return canonicalUnitNames[unitMagnitudes[DH.normalizeUnit(unit)] - 1] || null;
  }

  static getLargerUnit(unit) {
    return canonicalUnitNames[unitMagnitudes[DH.normalizeUnit(unit)] + 1] || null;
  }
  /**
   *
   * Rounds the passed Date value to the nearest `increment` value.
   *
   * Optionally may round relative to a certain base time point.
   *
   * For example `DH.round(new Date('2020-01-01T09:35'), '30 min', new Date('2020-01-01T09:15'))`
   * would round to 9:45 because that's the nearest integer number of 30 minute increments
   * from the base.
   *
   * Note that `base` is ignored when rounding to weeks. The configured {@link #property-weekStartDay-static}
   * dictates what the base of a week is.
   *
   * @param {Date} time The time to round
   * @param {String|Number} increment A millisecond value by which to round the time.
   * May be specified in string form eg: `'15 minutes'`
   * @param {Date} [base] The "start" from which to apply the rounding.
   * @param {Number} [weekStartDay] Will default to what is set in locale
   * @returns {Date} New Date instance
   */


  static round(time, increment, base, weekStartDay) {
    return DH.snap('round', time, increment, base, weekStartDay);
  }
  /**
   *
   * Floor the passed Date value to the nearest `increment` value.
   *
   * Optionally may floor relative to a certain base time point.
   *
   * For example `DH.floor(new Date('2020-01-01T09:35'), '30 min', new Date('2020-01-01T09:15'))`
   * would floor to 9:15 because that's the closest lower integer number of 30 minute increments
   * from the base.
   *
   * Note that `base` is ignored when flooring to weeks. The configured {@link #property-weekStartDay-static}
   * dictates what the base of a week is.
   *
   * @param {Date} time The time to floor
   * @param {String|Number} increment A millisecond value by which to floor the time.
   * May be specified in string form eg: `'15 minutes'`
   * @param {Date} [base] The "start" from which to apply the flooring.
   * @param {Number} [weekStartDay] Will default to what is set in locale
   * @returns {Date} New Date instance
   */


  static floor(time, increment, base, weekStartDay) {
    return DH.snap('floor', time, increment, base, weekStartDay);
  }
  /**
   *
   * Ceils the passed Date value to the nearest `increment` value.
   *
   * Optionally may ceil relative to a certain base time point.
   *
   * For example `DH.ceil(new Date('2020-01-01T09:35'), '30 min', new Date('2020-01-01T09:15'))`
   * would ceil to 9:45 because that's the closest higher integer number of 30 minute increments
   * from the base.
   *
   * Note that `base` is ignored when ceiling to weeks. Use weekStartDay argument which default to the configured
   * {@link #property-weekStartDay-static} dictates what the base of a week is
   *
   * @param {Date} time The time to ceil
   * @param {String|Number|Object} increment A numeric millisecond value by which to ceil the time.
   * or a duration in string form eg `'30 min'` or object form : `{unit: "minute", magnitude: 30}`
   * or `{unit: "minute", increment: 30}`
   * May be specified in string form eg: `'15 minutes'`
   * @param {Date} [base] The "start" from which to apply the ceiling.
   * @param {Number} [weekStartDay] Will default to what is set in locale
   * @returns {Date} New Date instance
   */


  static ceil(time, increment, base, weekStartDay) {
    return DH.snap('ceil', time, increment, base, weekStartDay);
  }
  /**
   * Implementation for round, floor and ceil.
   * @internal
   */


  static snap(operation, time, increment, base, weekStartDay = DH.weekStartDay) {
    const snapFn = snapFns[operation];

    if (typeof increment === 'string') {
      increment = DH.parseDuration(increment);
    }

    if (_util_Objects_js__WEBPACK_IMPORTED_MODULE_4__["default"].isObject(increment)) {
      // Allow {unit: "minute", increment: 30} or {unit: "minute", magnitude: 30}
      // parseDuration produces "magnitude". The Scheduler's TimeAxis uses "increment"
      // in its resolution object, so we allow that too.
      const magnitude = increment.magnitude || increment.increment; // increment is in weeks, months, quarters or years, then it can't be handled
      // using millisecond arithmetic.

      switch (increment.unit) {
        case 'week':
          {
            const weekDay = time.getDay(); // weekStartDay gives our base
            // Our base is the start of the week

            base = DH.add(DH.clearTime(time), weekDay >= weekStartDay ? weekStartDay - weekDay : -(weekDay - weekStartDay + 7), 'day');
            return DH[operation](time, `${magnitude * 7} days`, base);
          }

        case 'month':
          {
            // Express the time as a number of months from epoch start.
            // May be a fraction, eg the 15th will be 0.5 through a month.
            time = DH.asMonths(time);
            let resultMonths; // Snap the month count in the way requested

            if (base) {
              base = DH.asMonths(base);
              resultMonths = time + snapFn(time - base, magnitude);
            } else {
              resultMonths = snapFn(time, magnitude);
            } // Convert resulting month value back to a date


            return DH.monthsToDate(resultMonths);
          }

        case 'quarter':
          return DH[operation](time, `${magnitude * 3} months`, base);

        case 'year':
          return DH[operation](time, `${magnitude * 12} months`, base);

        case 'decade':
          // We assume that decades begin with a year divisible by 10
          return DH[operation](time, `${magnitude * 10} years`, base);
      } // Convert to a millisecond value


      increment = DH.as('ms', magnitude, increment.unit);
    } // It's a simple round to milliseconds


    if (base) {
      const tzChange = DH.as('ms', base.getTimezoneOffset() - time.getTimezoneOffset(), 'ms');
      return new Date(base.valueOf() + snapFn(DH.diff(base, time, 'ms') + tzChange, increment));
    } else {
      const offset = time.getTimezoneOffset() * 60 * 1000; // Assuming current TZ is GMT+3
      // new Date(2000, 0, 1) / 86400000      -> 10956.875
      // new Date(2000, 0, 1, 3) / 86400000   -> 10957
      // Before calculation we need to align time value of the current timezone to GMT+0
      // And after calculate we need to adjust time back

      return new Date(snapFn(time.valueOf() - offset, increment) + offset);
    }
  } //endregion
  //region Date picker format

  /**
   * Parses a typed duration value according to locale rules.
   *
   * The value is taken to be a string consisting of the numeric magnitude and the units:
   * - The numeric magnitude can be either an integer or a float value. Both "," and "." are valid decimal separators.
   * - The units may be a recognised unit abbreviation of this locale or the full local unit name.
   *
   * For example:
   * "2d", "2 d", "2 day", "2 days" will be turned into `{ magnitude : 2, unit : "day" }`
   * "2.5d", "2,5 d", "2.5 day", "2,5 days" will be turned into `{ magnitude : 2.5, unit : "day" }`
   *
   * **NOTE:** Doesn't work with complex values like "2 days, 2 hours"
   *
   * @param {String} value The value to parse.
   * @param {Boolean} [allowDecimals=true] Decimals are allowed in the magnitude.
   * @param {String} [defaultUnit] Default unit to use if only magnitude passed.
   * @returns {Object} If successfully parsed, the result contains two properties,
   * `magnitude` being a number, and `unit` being the canonical unit name, *NOT*
   * a localized name. If parsing was unsuccessful, `null` is returned.
   * @category Parse & format
   */


  static parseDuration(value, allowDecimals = true, defaultUnit) {
    var _match$;

    const durationRegEx = allowDecimals ? withDecimalsDurationRegex : noDecimalsDurationRegex,
          match = durationRegEx.exec(value);

    if (value == null || !match) {
      return null;
    }

    const magnitude = parseNumber((_match$ = match[1]) === null || _match$ === void 0 ? void 0 : _match$.replace(',', '.')),
          unit = DH.parseTimeUnit(match[2]) || defaultUnit;

    if (!unit) {
      return null;
    }

    return {
      magnitude,
      unit
    };
  }
  /**
   * Parses a typed unit name, for example `"ms"` or `"hr"` or `"yr"` into the
   * canonical form of the unit name which may be passed to {@link #function-add-static}
   * or {@link #function-diff-static}
   * @param {*} unitName
   * @category Parse & format
   */


  static parseTimeUnit(unitName) {
    // NOTE: In case you get a crash here when running tests, it is caused by missing locale. Build locales
    // using `scripts/build.js locales` to resolve.
    const unitMatch = unitName == null ? null : DH.durationRegEx.exec(unitName.toLowerCase());

    if (!unitMatch) {
      return null;
    } // See which group in the unitAbbrRegEx matched match[2]


    for (let unitOrdinal = 0; unitOrdinal < canonicalUnitNames.length; unitOrdinal++) {
      if (unitMatch[unitOrdinal + 1]) {
        return canonicalUnitNames[unitOrdinal];
      }
    }
  } //endregion
  //region Internal


  static getGMTOffset(date = new Date()) {
    if (!date) {
      return;
    }

    const offsetInMinutes = date.getTimezoneOffset(); // return 'Z' for UTC

    if (!offsetInMinutes) return 'Z';
    return (offsetInMinutes > 0 ? '-' : '+') + Math.abs(Math.trunc(offsetInMinutes / 60)).toString().padStart(2, '0') + ':' + Math.abs(offsetInMinutes % 60).toString().padStart(2, '0');
  }

  static fillDayNames() {
    const tempDate = new Date('2000-01-01T12:00:00'),
          dayNames = DH._dayNames || [],
          dayShortNames = DH._dayShortNames || [];
    dayNames.length = 0;
    dayShortNames.length = 0;

    for (let day = 2; day < 9; day++) {
      tempDate.setDate(day);
      dayNames.push(DH.format(tempDate, 'dddd'));
      dayShortNames.push(DH.format(tempDate, 'ddd'));
    }

    DH._dayNames = dayNames;
    DH._dayShortNames = dayShortNames;
  }

  static getDayNames() {
    return DH._dayNames;
  }

  static getDayName(day) {
    return DH._dayNames[day];
  }

  static getDayShortNames() {
    return DH._dayShortNames;
  }

  static getDayShortName(day) {
    return DH._dayShortNames[day];
  }

  static fillMonthNames() {
    const tempDate = new Date('2000-01-15T12:00:00'),
          monthNames = DH._monthNames || [],
          monthShortNames = DH._monthShortNames || [];
    monthNames.length = 0;
    monthShortNames.length = 0;

    for (let month = 0; month < 12; month++) {
      tempDate.setMonth(month);
      monthNames.push(DH.format(tempDate, 'MMMM'));
      monthShortNames.push(DH.format(tempDate, 'MMM'));
    }

    DH._monthNames = monthNames;
    DH._monthShortNames = monthShortNames;
  }

  static getMonthShortNames() {
    return DH._monthShortNames;
  }

  static getMonthShortName(month) {
    return DH._monthShortNames[month];
  }

  static getMonthNames() {
    return DH._monthNames;
  }

  static getMonthName(month) {
    return DH._monthNames[month];
  }

  static set locale(name) {
    locale = name;
    intlFormatterCache = {};
    formatCache = {};
  }

  static get locale() {
    return locale;
  }

  static setupDurationRegEx(unitNames = [], unitAbbreviations = []) {
    const me = this,
          unitLookup = {};
    let unitAbbrRegEx = '';

    for (let i = 0; i < unitAbbreviations.length; i++) {
      const // for example ['s', 'sec']
      abbreviations = unitAbbreviations[i],
            // for example { single : 'second', plural : 'seconds', abbrev : 's' }
      unitNamesCfg = unitNames[i];
      unitNamesCfg.canonicalUnitName = canonicalUnitNames[i]; // Create a unitLookup object keyed by unit full names
      // both lower and upper case to be able to look up plurals or abbreviations
      // also always include english names, since those are used in sources

      unitLookup[unitNamesCfg.single] = unitLookup[unitNamesCfg.single.toUpperCase()] = unitLookup[unitNamesCfg.canonicalUnitName] = unitLookup[unitNamesCfg.canonicalUnitName.toUpperCase()] = unitNamesCfg;
      unitAbbrRegEx += `${i ? '|' : ''}(`;

      for (let j = 0; j < abbreviations.length; j++) {
        unitAbbrRegEx += `${abbreviations[j]}|`;
      }

      locale = me.localize('L{locale}') || 'en-US';

      if (locale !== 'en-US') {
        // Add canonical values to be able to parse durations specified in configs
        const canonicalAbbreviations = canonicalUnitAbbreviations[i];

        for (let j = 0; j < canonicalAbbreviations.length; j++) {
          unitAbbrRegEx += `${canonicalAbbreviations[j]}|`;
        }
      }

      unitAbbrRegEx += `${unitNamesCfg.single}|${unitNamesCfg.plural}|${unitNamesCfg.canonicalUnitName}|${unitNamesCfg.canonicalUnitName}s)`;
    }

    me.unitLookup = unitLookup;
    me.durationRegEx = new RegExp(`^(?:${unitAbbrRegEx})$`);
  }

  static applyLocale() {
    const me = this,
          unitAbbreviations = me.localize('L{unitAbbreviations}') || [],
          unitNames = me.unitNames = me.localize('L{unitNames}'); // This happens when applying an incomplete locale, as done in Localizable.t.js.
    // Invalid usecase, but return to prevent a crash in that test.

    if (unitNames === 'unitNames') {
      return;
    }

    locale = me.localize('L{locale}') || 'en-US';

    if (locale === 'en-US') {
      // TODO: Include in En locale instead?
      ordinalSuffix = enOrdinalSuffix;
    } else {
      ordinalSuffix = me.localize('L{ordinalSuffix}') || ordinalSuffix;
    }

    formatCache = {};
    parserCache = {};
    intlFormatterCache = {};
    DH._weekStartDay = null;
    DH.setupDurationRegEx(unitNames, unitAbbreviations); // rebuild day/month names cache

    DH.fillDayNames();
    DH.fillMonthNames();
  } //endregion


}
const DH = DateHelper;
DH.useIntlFormat = useIntlFormat; // to use on tests
// Update when changing locale

_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].on({
  locale: 'applyLocale',
  prio: 1000,
  thisObj: DH
}); // Apply default locale

if (_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].locale) {
  DH.applyLocale();
}

DateHelper._$name = 'DateHelper';

/***/ }),

/***/ "./lib/Core/helper/DomHelper.js":
/*!**************************************!*\
  !*** ./lib/Core/helper/DomHelper.js ***!
  \**************************************/
/*! exports provided: hasLayout, isVisible, isInDocument, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasLayout", function() { return hasLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isVisible", function() { return isVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInDocument", function() { return isInDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DomHelper; });
/* harmony import */ var _AsyncHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AsyncHelper.js */ "./lib/Core/helper/AsyncHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';






 // Point must be imported because it needs to inject itself into the Rectangle class
//import './util/Point.js';
// TODO import VersionHelper from './VersionHelper.js';
// https://app.assembla.com/spaces/bryntum/tickets/7903-rendering-fails
// HACK: this value is required to calculate width if it was configured relative to font size (em) but no element is set

const DEFAULT_FONT_SIZE = 14,
      t0t0 = {
  align: 't0-t0'
},
      // eslint-disable-next-line no-undef
ELEMENT_NODE = Node.ELEMENT_NODE,
      // eslint-disable-next-line no-undef
TEXT_NODE = Node.TEXT_NODE,
      {
  isObject
} = _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"],
      // Transform matrix parse Regex. CSS transform computed style looks like this:
// matrix(scaleX(), skewY(), skewX(), scaleY(), translateX(), translateY())
// or
// matrix3d(scaleX(), skewY(), 0, 0, skewX(), scaleY(), 0, 0, 0, 0, 1, 0, translateX(), translateY())
// This is more reliable than using the style literal which may include
// relative styles such as "translateX(-20em)", or not include the translation at all if it's from a CSS rule.
// Use a const so as to only compile RexExp once
// Extract repeating number regexp to simplify next expressions. Available values are: https://developer.mozilla.org/en-US/docs/Web/CSS/number
numberRe = /[+-]?\d*\.?\d+[eE]?-?\d*/g,
      // -2.4492935982947064e-16 should be supported
numberReSrc = numberRe.source,
      translateMatrix2dRe = new RegExp(`matrix\\((?:${numberReSrc}),\\s?(?:${numberReSrc}),\\s?(?:${numberReSrc}),\\s?(?:${numberReSrc}),\\s?(${numberReSrc}),\\s?(${numberReSrc})`),
      translateMatrix3dRe = new RegExp(`matrix3d\\((?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(?:-?\\d*),\\s?(-?\\d*),\\s?(-?\\d*)`),
      translateMatrixRe = new RegExp(`(?:${translateMatrix2dRe.source})|(?:${translateMatrix3dRe.source})`),
      pxTtranslateXRe = new RegExp(`translate(3d|X)?\\((${numberReSrc})px(?:,\\s?(${numberReSrc})px)?`),
      pxTtranslateYRe = new RegExp(`translate(3d|Y)?\\((${numberReSrc})px(?:,\\s?(${numberReSrc})px)?`),
      domIdRe = /^[^a-z]+|[^\w:.-]+/gi,
      whiteSpaceRe = /\s+/,
      semicolonRe = /\s*;\s*/,
      colonRe = /\s*:\s*/,
      digitsRe = /^-?((\d+(\.\d*)?)|(\.?\d+))$/,
      elementPropKey = '$bryntum',
      // A blank value means the expando name is the same as the key in this object, otherwise the key in this object is
// the name of the domConfig property and the value is the name of the DOM element expando property.
elementCreateExpandos = {
  elementData: '',
  for: 'htmlFor',
  retainElement: ''
},
      // DomHelper#createElement properties which require special processing.
// All other configs such as id and type are applied directly to the element.
elementCreateProperties = {
  // these two are handled by being in elementCreateExpands:
  // elementData  : 1,
  // for          : 1,
  tag: 1,
  html: 1,
  text: 1,
  children: 1,
  tooltip: 1,
  style: 1,
  dataset: 1,
  parent: 1,
  nextSibling: 1,
  ns: 1,
  reference: 1,
  class: 1,
  className: 1,
  unmatched: 1,
  // Used by syncId approach
  onlyChildren: 1,
  // Used by sync to not touch the target element itself,
  listeners: 1,
  compareHtml: 1,
  // Sync,
  syncOptions: 1 // Sync

},
      styleIgnoreProperties = {
  length: 1,
  parentRule: 1,
  style: 1
},
      nativeFocusableTags = {
  BUTTON: 1,
  IFRAME: 1,
  EMBED: 1,
  INPUT: 1,
  OBJECT: 1,
  SELECT: 1,
  TEXTAREA: 1,
  HTML: _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11 ? 1 : 0,
  BODY: _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11 ? 0 : 1
},
      win = window,
      doc = document,
      emptyObject = {},
      emptyArray = [],
      arraySlice = Array.prototype.slice,
      immediatePromise = Promise.resolve(),
      fontProps = ['font-size', 'font-size-adjust', 'font-style', 'font-weight', 'font-family', 'font-kerning', 'font-stretch', 'line-height', 'text-transform', 'text-decoration', 'letter-spacing', 'word-break'],
      isHiddenWidget = e => e._hidden,
      parentNode = el => el.parentNode || el.host,
      mergeChildren = (dest, src, options) => {
  if (options.key === 'children') {
    // Normally "children" is an array (for which we won't be here, due to isObject check in caller). To
    // maintain declarative order of children as an object, we need some special sauce:
    return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].mergeItems(dest, src, options);
  }

  return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].blend(dest, src, options);
},
      isVisible = e => {
  const style = e.ownerDocument.defaultView.getComputedStyle(e);
  return style.getPropertyValue('display') !== 'none' && style.getPropertyValue('visibility') !== 'hidden';
},
      getRootNode = doc.documentElement.getRootNode ? el => el.getRootNode() : el => {
  while (el.parentNode) el = el.parentNode;

  return el;
},
      // Both Shadow Root Element and Anchor <a> Element have `host` property.
// https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/host
// https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/host
// Need make sure `host` is an Element.
isShadowRoot = el => el.host && el.host instanceof Element,
      // Check whether the element has an offsetParent.
// Nodes such as SVG which do not expose such a property must have an ancestor which has an offsetParent.
hasLayout = el => el && (el === doc.body || ('offsetParent' in el ? el.offsetParent : hasLayout(el.parentNode))),
      // Check for node being in document.
// If part of shadow DOM, see if the root's host is in the DOM
isInDocument = el => el && (doc.body.contains(el) || (root = getRootNode(el)) && isShadowRoot(root) && isInDocument(root.host)),
      elementOrConfigToElement = elementOrConfig => {
  if (elementOrConfig instanceof Node) {
    return elementOrConfig;
  }

  if (typeof elementOrConfig === 'string') {
    return DH.createElementFromTemplate(elementOrConfig);
  }

  return DH.createElement(elementOrConfig);
},
      canonicalStyles = Object.create(null),
      canonicalizeStyle = (name, hasUnit) => {
  const entry = canonicalStyles[name] || [_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].hyphenate(name), hasUnit];

  if (!canonicalStyles[name]) {
    canonicalStyles[entry[0]] = canonicalStyles[name] = entry;
  }

  return entry;
},
      getOffsetParent = node => node.ownerSVGElement ? node.ownerSVGElement.parentNode : node.offsetParent;

 // Push the styles that have units into the map:

['top', 'right', 'bottom', 'left', 'width', 'height', 'maxWidth', 'maxHeight', 'minWidth', 'minHeight', 'borderSpacing', 'borderWidth', 'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'fontSize', 'letterSpacing', 'lineHeight', 'outlineWidth', 'textIndent', 'wordSpacing'].forEach(name => canonicalizeStyle(name, true)); // We only do the measurement once, if the value is null

let scrollBarWidth = null,
    idCounter = 0,
    themeInfo = null,
    root,
    templateElement,
    htmlParser;
/**
 * @module Core/helper/DomHelper
 */

/**
 * An object that describes a DOM element. Used for example by {@link #function-createElement-static createElement()}
 * and by {@link Core.helper.DomSync#function-sync-static DomSync.sync()}.
 *
 * ```javascript
 * DomHelper.createElement({
 *    class : {
 *        big   : true,
 *        small : false
 *    },
 *    children : [
 *        { tag : 'img', src : 'img.png' },
 *        { html : '<b style="color: red">Red text</b>' }
 *    ]
 * });
 * ```
 *
 * @typedef {Object} DomConfig
 * @property {String} [tag='div'] Tag name, for example 'span'
 * @property {HTMLElement} [parent] Parent element
 * @property {HTMLElement} [nextSibling] Element's next sibling in the parent element
 * @property {String|Object} [class] CSS classes, as a string or an object (truthy keys will be applied)
 * @property {String|Object} [className] Alias for `class`
 * @property {String|Object} [style] Style, as a string or an object (keys will be hyphenated)
 * @property {Object} [elementData] Data object stored as an expando on the resulting element
 * @property {Object} [dataset] Dataset applied to the resulting element
 * @property {DomConfig[]|DomConfig|String} [children] Child elements, as an array of DomConfigs or an object map thereof or a simple string value to create a text node
 * @property {String} [html] Html string, used as the resulting elements `innerHTML`. Mutually exclusive with the `children` property
 * @property {Object} [tooltip] Tooltip config applied to the resulting element
 * @property {String} [text] Text content, XSS safe when you want to display text in the element. Mutually exclusive with the `children` property
 * @property {String} [id] Element's `id`
 * @property {String} [href] Element's `href`
 * @property {String} [ns] Element's namespace
 * @property {String} [src] Element's `src`
 */

/**
 * Helps with dom querying and manipulation.
 *
 * ```javascript
 * DomHelper.createElement({
 *   tag: 'div',
 *   className: 'parent',
 *   style: 'background: red',
 *   children: [
 *      { tag: 'div', className: 'child' },
 *      { tag: 'div', className: 'child' }
 *   ]
 * });
 * ```
 */

class DomHelper {
  /**
   * Returns `true` if the passed element is focusable either programmatically or through pointer gestures.
   * @param {HTMLElement} element The element to test.
   * @return {Boolean} Returns `true` if the passed element is focusable
   */
  static isFocusable(element, skipAccessibilityCheck = false) {
    if (!skipAccessibilityCheck) {
      // If element is hidden or in a hidden Widget, it's not focusable.
      if (!DH.isVisible(element) || DH.Widget.fromElement(element, isHiddenWidget)) {
        return false;
      }
    }

    const nodeName = element.nodeName;
    /*
     * An element is focusable if:
     *   - It is natively focusable, or
     *   - It is an anchor or link with href attribute, or
     *   - It has a tabIndex, or
     *   - It is an editing host (contenteditable="true")
     */

    return nativeFocusableTags[nodeName] || (nodeName === 'A' || nodeName === 'LINK') && !!element.href || element.getAttribute('tabIndex') != null || element.contentEditable === 'true';
  }
  /**
   * Returns the rectangle of the element which is currently visible in the browser viewport, i.e. user can find it on
   * screen, or `false` if it is scrolled out of view.
   * @param {HTMLElement} target The element to test.
   * @param {Boolean} [whole=false] Whether to check that whole element is visible, not just part of it.
   * If this is passed as true, the result will be a boolean, `true` or `false`.
   * @return {Core.helper.util.Rectangle|Boolean} Returns the rectangle of the element which is currently visible in
   * the browser viewport, or `false` if it is out of view.
   */


  static isInView(target, whole = false, positioned) {
    const top = target.ownerDocument,
          method = whole ? 'contains' : 'intersect',
          offsetParent = getOffsetParent(target),
          opR = positioned && _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(offsetParent);

    if (target === top.body) {
      return _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(top);
    }

    let result = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(target, null, true);

    for (let viewport = offsetParent; result && viewport !== top; viewport = viewport.parentNode) {
      // Skip shadow root node.
      if (viewport.nodeType === Node.DOCUMENT_FRAGMENT_NODE && viewport.host) {
        viewport = viewport.host.parentNode;
      } // When we get to document.body, pass document to Rectangle.inner so that it produces
      // the *viewport* rectangle, not the whole scroll height of the document.


      result = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].inner(viewport === top.body ? top : viewport)[method](result, false, true);
    } // We must use the *viewport* coordinate system to ascertain viewability


    if (result && positioned) {
      result.translate(document.scrollingElement.scrollLeft, document.scrollingElement.scrollTop);
    } // Return rectangle to its positioned coordinate system


    return positioned ? result.translate(-opR.x, -opR.y) : result;
  }
  /**
   * Returns `true` if the passed element is deeply visible. Meaning it is not hidden using `display`
   * or `visibility` and no ancestor node is hidden.
   * @param {HTMLElement} element The element to test.
   * @returns {Boolean} `true` if deeply visible.
   */


  static isVisible(element) {
    const document = element.ownerDocument; // Use the parentNode function so that we can traverse upwards through shadow DOM
    // to correctly ascertain visibility of nodes in web components.

    for (; element; element = parentNode(element)) {
      // Visible if we've reached top of the owning document without finding a hidden Element.
      if (element === document) {
        return true;
      } // Must not evaluate a shadow DOM's root fragment.


      if (element.nodeType === element.ELEMENT_NODE && !isVisible(element)) {
        return false;
      }
    } // We get here if the node is detached.


    return false;
  }
  /**
   * Returns true if DOM Event instance is passed. It is handy to override to support Locker Service.
   * @param event
   * @internal
   * @returns {Boolean}
   */


  static isDOMEvent(event) {
    return event instanceof Event;
  }
  /**
   * Merges specified source DOM config objects into a `dest` object.
   * @param {Object} dest The destination DOM config object.
   * @param {...Object} sources The DOM config objects to merge into `dest`.
   * @returns {Object} The `dest` object.
   * @internal
   */


  static merge(dest, ...sources) {
    return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].blend(dest, sources, {
      merge: mergeChildren
    });
  }
  /**
   * Updates in-place a DOM config object whose `children` property may be an object instead of the typical array.
   * The keys of such objects become the `reference` property upon conversion.
   *
   * @param {DomConfig} domConfig
   * @param {Function} [namedChildren] A function to call for each named child element.
   * @privateparam {Boolean} [ignoreRefs] Not meant to be manually set, used when recursing.
   * @returns {Object} Returns the altered DOM config
   * @internal
   */


  static normalizeChildren(domConfig, namedChildren, ignoreRefs) {
    var _domConfig$syncOption;

    let children = domConfig === null || domConfig === void 0 ? void 0 : domConfig.children,
        child,
        i,
        name,
        kids,
        ref; // Allow redirecting/opting out of ref ownership in a hierarchy

    if (domConfig !== null && domConfig !== void 0 && (_domConfig$syncOption = domConfig.syncOptions) !== null && _domConfig$syncOption !== void 0 && _domConfig$syncOption.ignoreRefs) {
      ignoreRefs = true;
    }

    if (children && !(domConfig instanceof Node)) {
      if (Array.isArray(children)) {
        for (i = 0; i < children.length; ++i) {
          DomHelper.normalizeChildren(children[i], namedChildren, ignoreRefs);
        }
      } else {
        kids = children;
        domConfig.children = children = [];

        for (name in kids) {
          var _child;

          child = kids[name];

          if ((_child = child) !== null && _child !== void 0 && _child.isWidget) {
            child = child.element;
          } // $ prefix indicates element is not a reference:


          ref = !name.startsWith('$') && !DomHelper.isElement(child);
          ref && (namedChildren === null || namedChildren === void 0 ? void 0 : namedChildren(name,
          /* hoist = */
          !ignoreRefs));

          if (child) {
            if (!(child instanceof Node)) {
              if (child.reference === false) {
                delete child.reference;
              } else if (ref && typeof child !== 'string') {
                child.reference = name;
              }

              DomHelper.normalizeChildren(child, namedChildren, ignoreRefs);
            }

            children.push(child);
          }
        }
      }
    }

    return domConfig;
  }

  static roundPx(px, devicePixelRatio = window.devicePixelRatio || 1) {
    const multiplier = 1 / devicePixelRatio;
    return Math.round(px / multiplier) * multiplier;
  }
  /**
   * Returns true if element has opened shadow root
   * @param {HTMLElement} element Element to check
   * @returns {Boolean}
   */


  static isCustomElement(element) {
    return Boolean(element === null || element === void 0 ? void 0 : element.shadowRoot);
  }
  /**
   * Resolves element from point, checking shadow DOM if required
   * @param {Number} x
   * @param {Number} y
   * @returns {HTMLElement}
   */


  static elementFromPoint(x, y) {
    let el = document.elementFromPoint(x, y); // Try to check shadow dom if it exists

    if (DH.isCustomElement(el)) {
      el = el.shadowRoot.elementFromPoint(x, y) || el;
    }

    return el;
  }
  /**
   * Resolves child element from point __in the passed element's coordinate space__.
   * @param {HTMLElement} parent The element to find the occupying element in.
   * @param {Number|Core.helper.util.Point} x Either the `X` part of a point, or the point to find.
   * @param {Number} [y] The `Y` part of the point.
   * @returns {HTMLElement}
   * @internal
   */


  static childFromPoint(el, x, y,
  /* internal */
  parent = el) {
    const p = y == null ? x : new _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"](x, y, 0, 0);
    let result = null;
    Array.from(el.children).some(el => {
      if (_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(el, parent).contains(p)) {
        // All rectangles must be relative to the topmost el, so that must be
        // passed down as the "parent" of all Rectangles.
        result = el.children.length && DH.childFromPoint(el, p, null, parent) || el;
        return true;
      }
    });
    return result;
  }
  /**
   * Converts a name/value pair of a style name and its value into the canonical (hyphenated) name of the style
   * property and a value with the `defaultUnit` suffix appended if no unit is already present in the `value`.
   *
   * For example:
   * ```javascript
   *  const [property, value] = DomHelper.unitize('marginLeft', 50);
   *  console.log(property, value);
   * ```
   *
   * ```
   *  > margin-left 50px
   * ```
   * @param {String} name
   * @param {String|Number} value
   * @param {String} [defaultUnit]
   * @returns {String[]}
   * @internal
   */


  static unitize(name, value, defaultUnit = 'px') {
    const [trueName, hasUnits] = canonicalizeStyle(name);

    if (value != null) {
      value = String(value);
      value = hasUnits && digitsRe.test(value) ? value + defaultUnit : value;
    }

    return [trueName, value];
  }
  /**
   * Returns active element checking shadow dom too
   * @readonly
   * @property {HTMLElement}
   */


  static get activeElement() {
    let el = document.activeElement;

    while (el.shadowRoot) {
      el = el.shadowRoot.activeElement;
    }

    return el;
  } // returns active element for DOM tree / shadow DOM tree to which element belongs


  static getActiveElement(element) {
    var _element, _element2, _element2$getRootNode;

    if ((_element = element) !== null && _element !== void 0 && _element.isWidget) {
      element = element.element;
    } // IE11 doesn't support `getRootNode`, so in this case we just fallback to document


    let el = (((_element2 = element) === null || _element2 === void 0 ? void 0 : (_element2$getRootNode = _element2.getRootNode) === null || _element2$getRootNode === void 0 ? void 0 : _element2$getRootNode.call(_element2)) || document).activeElement;

    while ((_el = el) !== null && _el !== void 0 && _el.shadowRoot) {
      var _el;

      el = el.shadowRoot.activeElement;
    }

    return el;
  } // Returns the visible root (either document.body or a web component shadow root)


  static getRootElement(element) {
    var _element$getRootNode;

    const root = (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
    return (root === null || root === void 0 ? void 0 : root.body) || root || element.ownerDocument.body;
  }

  static isValidFloatRootParent(target) {
    return target === document.body || target.constructor.name === 'ShadowRoot';
  }
  /**
   * Returns the `id` of the passed element. Generates a unique `id` if the element does not have one.
   * @param {HTMLElement} element The element to return the `id` of.
   */


  static getId(element) {
    return element.id || (element.id = 'b-element-' + ++idCounter);
  }
  /**
   * Returns common widget/node ancestor for from/to arguments
   * @param {Core.widget.Widget|HTMLElement} from
   * @param {Core.widget.Widget|HTMLElement} to
   * @returns {Core.widget.Widget|HTMLElement}
   * @internal
   */


  static getCommonAncestor(from, to) {
    if (from === to) {
      return from;
    }

    while (from && !((_from = (_from2 = from)[from.isWidget ? 'owns' : 'contains']) !== null && _from !== void 0 && _from.call(_from2, to) || from === to)) {
      var _from, _from2;

      from = from.owner || from.parentNode;
    }

    return from;
  } //region Internal

  /**
   * Internal convenience fn to allow specifying either an element or a CSS selector to retrieve one
   * @private
   * @param {String|HTMLElement} elementOrSelector element or selector to lookup in DOM
   * @returns {HTMLElement}
   */


  static getElement(elementOrSelector) {
    // also used for SVG elements, so need to use more basic class, that is also returned by querySelector
    if (elementOrSelector instanceof Element) {
      return elementOrSelector;
    }

    return doc.querySelector(elementOrSelector);
  }
  /**
   * Sets attributes passed as object to given element
   * @param {String|Element} elementOrSelector
   * @param {Object} attributes
   * @internal
   */


  static setAttributes(elementOrSelector, attributes) {
    const element = DH.getElement(elementOrSelector);

    if (element && attributes) {
      for (const key in attributes) {
        if (attributes[key] != null) {
          element.setAttribute(key, attributes[key]);
        }
      }
    }
  }
  /**
   * Sets a CSS [length](https://developer.mozilla.org/en-US/docs/Web/CSS/length) style value.
   * @param {String|HTMLElement} element The element to set the style in, or, if just the result is required,
   * the style magnitude to return with units added. If a nullish value is passed, an empty string
   * is returned.
   * @param {String} [style] The name of a style property which specifies a [length](https://developer.mozilla.org/en-US/docs/Web/CSS/length)
   * @param {Number|String} [value] The magnitude. If a number is used, the value will be set in `px` units.
   * @returns {String} The style value string.
   */


  static setLength(element, style, value) {
    if (arguments.length === 1) {
      var _element3;

      value = typeof element === 'number' ? `${element}px` : (_element3 = element) !== null && _element3 !== void 0 ? _element3 : '';
    } else {
      var _value;

      element = DH.getElement(element);
      value = element.style[style] = typeof value === 'number' ? `${value}px` : (_value = value) !== null && _value !== void 0 ? _value : '';
    }

    return value;
  }
  /**
   * Returns string percentified and rounded value for setting element's height, width etc.
   * @param {String|Number} value percent value
   * @param {Number} digits number of decimal digits for rounding
   * @return {string} percentified value or empty string if value can not be parsed
   * @internal
   */


  static percentify(value, digits = 2) {
    const mult = Math.pow(10, digits);
    return value == null || value === '' || isNaN(value) ? '' : `${Math.round(value * mult) / mult}%`;
  } //endregion
  //region Children, going down...

  /**
   * Gets the first direct child of `element` that matches `selector`.
   * @param {HTMLElement} element Parent element
   * @param {String} selector CSS selector
   * @returns {HTMLElement}
   * @category Query children
   */


  static getChild(element, selector) {
    // TODO: Only IE11 doesn't support :scope
    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].supportsQueryScope) {
      selector = ':scope>' + selector;
    } else {
      const elId = element.id || (element.id = 'b-element-' + ++idCounter);
      selector = `#${elId} > ${selector}`;
    }

    return element.querySelector(selector);
  }
  /**
   * Checks if `element` has any child that matches `selector`.
   * @param {HTMLElement} element Parent element
   * @param {String} selector CSS selector
   * @returns {Boolean} true if any child matches selector
   * @category Query children
   */


  static hasChild(element, selector) {
    return DH.getChild(element, selector) != null;
  }
  /**
   * Returns all child elements (not necessarily direct children) that matches `selector`.
   *
   * If `selector` starts with `'>'` or `'# '`, then all components of the `selector` must match inside of `element`.
   * Where supported, `:scope` is prepended to the selector (and if `#` was used, it is removed). In other cases,
   * the `id` of the `element` is used to restrict the `selector`. If necessary, the `element` may be assigned a
   * generated `id` to enable this.
   *
   * These are equivalent:
   *
   *      DomHelper.children(el, '# .foo .bar');
   *
   *      el.querySelectorAll(':scope .foo .bar');
   *
   * These are also equivalent:
   *
   *      DomHelper.children(el, '> .foo .bar');
   *
   *      el.querySelectorAll(':scope > .foo .bar');
   *
   * @param {HTMLElement} element The parent element
   * @param {String} selector The CSS selector
   * @returns {HTMLElement[]} Matched elements, somewhere below `element`
   * @category Query children
   */


  static children(element, selector) {
    // a '#' could be '#id' but '# ' (hash and space) is not a valid selector...
    if (selector[0] === '>' || selector.startsWith('# ')) {
      if (selector[0] === '#') {
        selector = selector.substr(2);
      }

      if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].supportsQueryScope) {
        selector = ':scope ' + selector;
      } else {
        const elId = element.id || (element.id = 'b-element-' + ++idCounter);
        selector = `#${elId} ${selector}`;
      }
    }

    return Array.from(element.querySelectorAll(selector));
  } // Salesforce doesn't yet support childElementCount. So we relace all native usages with this wrapper and
  // override it for salesforce environment.
  // https://github.com/bryntum/support/issues/3008


  static getChildElementCount(element) {
    return element.childElementCount;
  }
  /**
   * Looks at the specified `element` and all of its children for the one that first matches `selector.
   * @param {HTMLElement} element Parent element
   * @param {String} selector CSS selector
   * @returns {HTMLElement} Matched element, either element or an element below it
   * @category Query children
   */


  static down(element, selector) {
    if (!element) {
      return null;
    }

    if (element.matches && element.matches(selector)) {
      return element;
    }

    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].supportsQueryScope) {
      selector = ':scope ' + selector;
    } else {
      const elId = element.id || (element.id = 'b-element-' + ++idCounter);
      selector = `#${elId} ${selector}`;
    }

    return element.querySelector(selector);
  }
  /**
   * Checks if childElement is a descendant of parentElement (contained in it or a sub element)
   * @param {HTMLElement} parentElement Parent element
   * @param {HTMLElement} childElement Child element, at any level below parent (includes nested shadow roots)
   * @returns {Boolean}
   * @category Query children
   */


  static isDescendant(parentElement, childElement) {
    // In case of IE11 and parentElement is <html>, HTMLDocument#contains is not supported - fallback to body
    if (!parentElement.contains) {
      parentElement = parentElement.body;
    }

    const parentRoot = DH.getRootElement(parentElement),
          childRoot = DH.getRootElement(childElement);

    if (parentRoot !== childRoot && childRoot.host) {
      return DH.isDescendant(parentRoot, childRoot.host);
    }

    return parentElement.contains(childElement);
  }
  /**
   * Returns the specified element of the given `event`. If the `event` is an `Element`, it is returned. Otherwise,
   * the `eventName` argument is used to retrieve the desired element property from `event` (this defaults to the
   * `'target'` property).
   * @param {Event|Element} event
   * @param {String} [elementName]
   * @returns {Element}
   */


  static getEventElement(event, elementName = 'target') {
    return !event || DH.isElement(event) ? event : event[elementName];
  }
  /**
   * Returns `true` if the provided value is _likely_ a DOM element. If the element can be assured to be from the
   * same document, `instanceof Element` is more reliable.
   * @param {*} value
   * @returns {Boolean}
   */


  static isElement(value) {
    return (value === null || value === void 0 ? void 0 : value.nodeType) === document.ELEMENT_NODE && DH.isNode(value);
  }
  /**
   * Returns `true` if the provided value is _likely_ a DOM node. If the node can be assured to be from the same
   * document, `instanceof Node` is more reliable.
   * @param {*} value
   * @returns {Boolean}
   */


  static isNode(value) {
    // cannot use instanceof across frames. Using it here won't help since we'd need the same logic if it were
    // false... meaning we'd have the same chances of a false-positive.
    return Boolean(value) && typeof value.nodeType === 'number' && !isObject(value);
  }
  /**
   * Iterates over each result returned from `element.querySelectorAll(selector)`. First turns it into an array to
   * work in IE. Can also be called with only two arguments, in which case the first argument is used as selector and
   * document is used as the element.
   * @param {HTMLElement} element Parent element
   * @param {String} selector CSS selector
   * @param {Function} fn Function called for each found element
   * @category Query children
   */


  static forEachSelector(element, selector, fn) {
    if (typeof element === 'string') {
      // Legacy internal API, no longer valid
      throw new Error('DomHelper.forEachSelector must provide a root element context (for shadow root scenario)');
    }

    DH.children(element, selector).forEach(fn);
  }
  /**
   * Iterates over the direct child elements of the specified element. First turns it into an array to
   * work in IE.
   * @param {HTMLElement} element Parent element
   * @param {Function} fn Function called for each child element
   * @category Query children
   */


  static forEachChild(element, fn) {
    Array.from(element.children).forEach(fn);
  }
  /**
   * Removes each element returned from `element.querySelectorAll(selector)`.
   * @param {HTMLElement} element
   * @param {String} selector
   * @category Query children
   */


  static removeEachSelector(element, selector) {
    DH.forEachSelector(element, selector, child => child.remove());
  }

  static removeClsGlobally(element, ...classes) {
    classes.forEach(cls => DH.forEachSelector(element, '.' + cls, child => child.classList.remove(cls)));
  } //endregion
  //region Parents, going up...


  static isOrphaned(element) {
    return !isInDocument(element);
  }
  /**
   * Looks at the specified element and all of its parents for the one that first matches selector.
   * @param {HTMLElement} element Element
   * @param {String} selector CSS selector
   * @returns {HTMLElement} Matched element, either the passed in element or an element above it
   * @category Query parents
   */


  static up(element, selector) {
    return element && element.closest(selector);
  }

  static getAncestor(element, possibleAncestorParents, outerElement = null) {
    let found = false,
        ancestor,
        parent = element;
    if (!Array.isArray(possibleAncestorParents)) possibleAncestorParents = [possibleAncestorParents];

    while (parent = parent.parentElement) {
      if (possibleAncestorParents.includes(parent)) {
        found = true;
        break;
      }

      if (outerElement && parent === outerElement) break;
      ancestor = parent;
    }

    if (!found) return null;
    return ancestor || element;
  }
  /**
   * Retrieves all parents to the specified element.
   * @param {HTMLElement} element Element
   * @returns {HTMLElement[]} All parent elements, bottom up
   * @category Query parents
   */


  static getParents(element) {
    const parents = [];

    while (element.parentElement) {
      parents.push(element.parentElement);
      element = element.parentElement;
    }

    return parents;
  } //endregion
  //region Creation

  /**
   * Converts the passed id to an id valid for usage as id on a DOM element.
   * @param {String} id
   * @returns {String}
   */


  static makeValidId(id, replaceValue = '') {
    if (id == null) return null;
    return String(id).replace(domIdRe, replaceValue);
  }
  /**
   * Creates an Element, accepts a {@link #typedef-DomConfig} object. Example usage:
   *
   * ```javascript
   * DomHelper.createElement({
   *   tag         : 'table', // defaults to 'div'
   *   className   : 'nacho',
   *   html        : 'I am a nacho',
   *   children    : [ { tag: 'tr', ... }, myDomElement ],
   *   parent      : myExistingElement // Or its id
   *   style       : 'font-weight: bold;color: red',
   *   dataset     : { index: 0, size: 10 },
   *   tooltip     : 'Yay!',
   *   ns          : 'http://www.w3.org/1999/xhtml'
   * });
   * ```
   *
   * @param {DomConfig} config Element config object
   * @param {Boolean|Object} [options] An object specifying creation options. If this is a boolean value, it is
   * understood to be the `returnAll` option. Passing a boolean is deprecated in favor of the `options` object.
   * @param {Boolean} options.ignoreRefs Pass `true` to ignore element references.
   * @param {Boolean} options.returnAll Specify true to return all elements & child elements
   * created as an array.
   * @returns {HTMLElement|HTMLElement[]|Object} Single element or array of elements `returnAll` was set to true.
   * If any elements had a `reference` property, this will be an object containing a reference to
   * all those elements, keyed by the reference name.
   * @category Creation
   */


  static createElement(config = {}, options, ...args) {
    var _options, _options$callback, _config$dataset;

    let returnAll = options,
        element,
        i,
        ignoreChildRefs,
        ignoreRefOption,
        ignoreRefs,
        key,
        name,
        value,
        refOwner,
        refs,
        syncIdField;

    if (typeof returnAll === 'boolean') {
      refs = args[0];
      syncIdField = args[1]; // TODO There are many internal calls that will need refactoring to the object form before we can do this:
      // VersionHelper.deprecate('Core', '4.0.0',
      //     'DH.createElement should be given an options object not the returnAll boolean');

      options = {
        returnAll,
        refs,
        syncIdField
      };
    } else if (options) {
      ignoreRefs = options.ignoreRefs;
      refOwner = options.refOwner;
      refs = options.refs;
      returnAll = options.returnAll;
      syncIdField = options.syncIdField;

      if (ignoreRefs) {
        ignoreChildRefs = true;
        ignoreRefs = ignoreRefs !== 'children';
      }
    }

    if (typeof config.parent === 'string') {
      config.parent = document.getElementById(config.parent);
    } // nextSibling implies a parent


    const parent = config.parent || config.nextSibling && config.nextSibling.parentNode,
          {
      dataset,
      html,
      reference,
      syncOptions,
      text
    } = config;

    if (syncOptions) {
      syncIdField = syncOptions.syncIdField || syncIdField;
      ignoreRefOption = syncOptions.ignoreRefs;

      if (ignoreRefOption) {
        ignoreChildRefs = true;
        ignoreRefs = ignoreRefOption !== 'children';
        options = _objectSpread(_objectSpread({}, options), {}, {
          ignoreRefs: true
        });
      }
    }

    if (ignoreRefs) {
      refOwner = null;
    }

    if (config.ns) {
      element = doc.createElementNS(config.ns, config.tag || 'svg');
    } else {
      element = doc.createElement(config.tag || 'div');
    }

    if (text != null) {
      DH.setInnerText(element, text);
    } else if (html != null) {
      if (html instanceof DocumentFragment) {
        element.appendChild(html);
      } else {
        element.innerHTML = html;
      }
    }

    if (config.tooltip) {
      DH.Widget.attachTooltip(element, config.tooltip);
    }

    if (config.style) {
      DH.applyStyle(element, config.style);
    }

    if (dataset) {
      for (name in dataset) {
        value = dataset[name];

        if (value != null) {
          element.dataset[name] = value;
        }
      }
    }

    if (parent) {
      parent.insertBefore(element, config.nextSibling);
    }

    if (refOwner) {
      // Tag each element created by the refOwner's id to enable DomSync
      element.$refOwnerId = refOwner.id;
    }

    if (reference && !ignoreRefs) {
      // SalesForce platform does not allow custom attributes, but existing code
      // uses querySelector('[reference]'), so bypass it when we can:
      if (refOwner) {
        element.$reference = reference;
        refOwner.attachRef(reference, element, config);
      } else {
        // TODO fixup callers to do the above
        if (!refs) {
          options = Object.assign({}, options);
          options.refs = refs = {};
        }

        refs[reference] = element;
        element.setAttribute('data-reference', reference);
      }
    }

    const className = config.className || config.class,
          // matches DomSync
    keys = Object.keys(config);

    if (className) {
      element.setAttribute('class', _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_5__["default"].normalize(className));
    }

    for (i = 0; i < keys.length; ++i) {
      name = keys[i];
      value = config[name]; // We have to use setAttribute() for custom attributes to work and this is inline with how DomSync
      // handles attributes. For "expando" properties, however, we have to simply assign them.

      if ((key = elementCreateExpandos[name]) != null) {
        element[key || name] = value;
      } else if (!elementCreateProperties[name] && name && value != null) {
        // if (config.ns) {
        //     element.setAttributeNS(config.ns, name, value);
        // }
        // else {
        //     element.setAttribute(name, value);
        // }
        element.setAttribute(name, value);
      }
    } // Mimic the way DomSync issues callbacks as elements are created (needed by TaskBoard to trigger custom
    // taskRenderer calls as elements get produced).


    (_options = options) === null || _options === void 0 ? void 0 : (_options$callback = _options.callback) === null || _options$callback === void 0 ? void 0 : _options$callback.call(_options, {
      action: 'newElement',
      domConfig: config,
      targetElement: element,
      syncId: refOwner ? reference : options.syncIdField && ((_config$dataset = config.dataset) === null || _config$dataset === void 0 ? void 0 : _config$dataset[options.syncIdField])
    }); // if returnAll is true, use array

    if (returnAll === true) {
      options.returnAll = returnAll = [element];
    } // if it already is an array, add to it (we are probably a child)
    else if (Array.isArray(returnAll)) {
      returnAll.push(element);
    }

    if (config.children) {
      if (syncIdField) {
        // Map syncId -> child element to avoid querying dom later on
        element.syncIdMap = {};
      }

      config.children.forEach(child => {
        // Skip null children, convenient to allow those for usage with Array.map()
        if (child) {
          // Append string children as text nodes
          if (typeof child === 'string') {
            const textNode = document.createTextNode(child);

            if (refOwner) {
              textNode.$refOwnerId = refOwner.id;
            }

            element.appendChild(textNode);
          } // Just append Elements directly.
          else if (isNaN(child.nodeType)) {
            var _config$syncOptions$i, _config$syncOptions, _child$dataset;

            child.parent = element;

            if (!child.ns && config.ns) {
              child.ns = config.ns;
            }

            const childElement = DH.createElement(child, _objectSpread(_objectSpread({}, options), {}, {
              ignoreRefs: (_config$syncOptions$i = (_config$syncOptions = config.syncOptions) === null || _config$syncOptions === void 0 ? void 0 : _config$syncOptions.ignoreRef) !== null && _config$syncOptions$i !== void 0 ? _config$syncOptions$i : ignoreChildRefs
            })),
                  syncId = (_child$dataset = child.dataset) === null || _child$dataset === void 0 ? void 0 : _child$dataset[syncIdField]; // syncId is used with DomHelper.sync to match elements. Populate a map here to make finding them faster

            if (syncId != null) {
              element.syncIdMap[syncId] = childElement;
            } // Do not want to alter the initial config


            delete child.parent;
          } else {
            element.appendChild(child);
          }
        }
      });
    } // Store used config, to be able to compare on sync to determine if changed without hitting dom


    element.lastDomConfig = config; // If references were used, return them in an object
    // If returnAll was specified, return the array
    // By default, return the root element

    return refs || returnAll || element;
  }
  /**
   * Create element(s) from a template (html string). Note that
   * `textNode`s are discarded unless the `raw` option is passed
   * as `true`.
   *
   * If the template has a single root element, then the single element will be returned
   * unless the `array` option is passed as `true`.
   *
   * If there are multiple elements, then an Array will be returned.
   *
   * @param {String} template The HTML string from which to create DOM content
   * @param {Object} [options] An object containing properties to modify how the DOM is created and returned.
   * @param {Boolean} [options.array] `true` to return an array even if there's only one resulting element.
   * @param {Boolean} [options.raw] Return all child nodes, including text nodes.
   * @param {Boolean} [options.fragment] Return a DocumentFragment.
   * @private
   */


  static createElementFromTemplate(template, options = emptyObject) {
    const {
      array,
      raw,
      fragment
    } = options;
    let result; // Use template by preference if it exists. It's faster on most supported platforms
    // https://jsperf.com/domparser-vs-template/

    if (DH.supportsTemplate) {
      (templateElement || (templateElement = doc.createElement('template'))).innerHTML = template;
      result = templateElement.content;

      if (fragment) {
        // The template is reused, so therefore is its fragment.
        // If we release the fragment to a caller, it must be a clone.
        return result.cloneNode(true);
      }
    } else {
      (htmlParser || (htmlParser = new DOMParser())).parseFromString(template, 'text/html');
      result = htmlParser.parseFromString(template, 'text/html').body; // We must return a DocumentFragment.
      // myElement.append(fragment) inserts the contents of the fragment, not the fragment itself.

      if (fragment) {
        // Empty string results in *no document.body* on IE!
        const nodes = result ? result.childNodes : emptyArray;
        result = document.createDocumentFragment();

        while (nodes.length) {
          result.appendChild(nodes[0]);
        }

        return result;
      } // Happens with empty template in IE11
      else if (!result) {
        result = {
          children: [],
          childNodes: []
        };
      }
    } // Raw means all child nodes are returned


    if (raw) {
      result = result.childNodes;
    } // Otherwise, only element nodes
    else {
      result = result.children;
    }

    return result.length === 1 && !array ? result[0] : arraySlice.call(result);
  }
  /**
   * Inserts an `element` at first position in `into`.
   * @param {HTMLElement} into Parent element
   * @param {HTMLElement} element Element to insert, or an element config passed on to createElement()
   * @returns {HTMLElement}
   * @category Creation
   */


  static insertFirst(into, element) {
    if (element && element.nodeType !== ELEMENT_NODE && element.tag) {
      element = DH.createElement(element);
    }

    return into.insertBefore(element, into.firstElementChild);
  }
  /**
   * Inserts a `element` before `beforeElement` in `into`.
   * @param {HTMLElement} into Parent element
   * @param {HTMLElement} element Element to insert, or an element config passed on to createElement()
   * @param {HTMLElement} beforeElement Element before which passed element should be inserted
   * @returns {HTMLElement}
   * @category Creation
   */


  static insertBefore(into, element, beforeElement) {
    if (element && element.nodeType !== ELEMENT_NODE && element.tag) {
      element = DH.createElement(element);
    }

    return beforeElement ? into.insertBefore(element, beforeElement) : DH.insertFirst(into, element);
  }

  static insertAt(parentElement, newElement, index) {
    const siblings = Array.from(parentElement.children);

    if (index >= siblings.length) {
      return DH.append(parentElement, newElement);
    }

    const beforeElement = siblings[index];
    return DH.insertBefore(parentElement, newElement, beforeElement);
  }
  /**
   * Appends element to parentElement.
   * @param {HTMLElement} parentElement Parent element
   * @param {HTMLElement|Object|String} elementOrConfig Element to insert, or an element config passed on to createElement(), or an html string passed to createElementFromTemplate
   * @returns {HTMLElement}
   * @category Creation
   */


  static append(parentElement, elementOrConfig) {
    if (elementOrConfig.forEach) {
      // Ensure all elements of an Array are HTMLElements.
      // The other implementor of forEach is a NodeList which needs no conversion.
      if (Array.isArray(elementOrConfig)) {
        elementOrConfig = elementOrConfig.map(elementOrConfig => elementOrConfigToElement(elementOrConfig));
      }

      if (parentElement.append) {
        parentElement.append(...elementOrConfig);
      } else {
        const docFrag = document.createDocumentFragment();
        elementOrConfig.forEach(function (child) {
          docFrag.appendChild(child);
        });
        parentElement.appendChild(docFrag);
      }

      return elementOrConfig;
    } else {
      return parentElement.appendChild(elementOrConfigToElement(elementOrConfig));
    }
  } //endregion
  //region Get position

  /**
   * Returns the element's `transform translateX` value in pixels.
   * @param {HTMLElement} element
   * @returns {Number} X transform
   * @category Position, get
   */


  static getTranslateX(element) {
    const transformStyle = element.style.transform;
    let matches = pxTtranslateXRe.exec(transformStyle); // Use inline transform style if it contains "translate(npx, npx" or "translate3d(npx, npx" or "translateX(npx"

    if (matches) {
      return parseFloat(matches[2]);
    } else {
      // If the inline style is the matrix() form, then use that, otherwise, use computedStyle
      matches = translateMatrixRe.exec(transformStyle) || translateMatrixRe.exec(DH.getStyleValue(element, 'transform'));
      return matches ? parseFloat(matches[1] || matches[3]) : 0;
    }
  }
  /**
   * Returns the element's `transform translateY` value in pixels.
   * @param {HTMLElement} element
   * @returns {Number} Y coordinate
   * @category Position, get
   */


  static getTranslateY(element) {
    const transformStyle = element.style.transform;
    let matches = pxTtranslateYRe.exec(transformStyle); // Use inline transform style if it contains "translate(npx, npx" or "translate3d(npx, npx" or "translateY(npx"

    if (matches) {
      // If it was translateY(npx), use first item in the parens.
      const y = parseFloat(matches[matches[1] === 'Y' ? 2 : 3]); // FF will strip `translate(x, 0)` -> `translate(x)`, so need to check for isNaN also

      return isNaN(y) ? 0 : y;
    } else {
      // If the inline style is the matrix() form, then use that, otherwise, use computedStyle
      matches = translateMatrixRe.exec(transformStyle) || translateMatrixRe.exec(DH.getStyleValue(element, 'transform'));
      return matches ? parseFloat(matches[2] || matches[4]) : 0;
    }
  }
  /**
   * Gets both X and Y coordinates as an array [x, y]
   * @param {HTMLElement} element
   * @returns {Number[]} [x, y]
   * @category Position, get
   */


  static getTranslateXY(element) {
    return [DH.getTranslateX(element), DH.getTranslateY(element)];
  }
  /**
   * Get elements X offset within a containing element
   * @param {HTMLElement} element
   * @param {HTMLElement} container
   * @returns {Number} X offset
   * @category Position, get
   */


  static getOffsetX(element, container = null) {
    return container ? element.getBoundingClientRect().left - container.getBoundingClientRect().left : element.offsetLeft;
  }
  /**
   * Get elements Y offset within a containing element
   * @param {HTMLElement} element
   * @param {HTMLElement} container
   * @returns {Number} Y offset
   * @category Position, get
   */


  static getOffsetY(element, container = null) {
    return container ? element.getBoundingClientRect().top - container.getBoundingClientRect().top : element.offsetTop;
  }
  /**
   * Gets elements X and Y offset within containing element as an array [x, y]
   * @param {HTMLElement} element
   * @param {HTMLElement} container
   * @returns {Number[]} [x, y]
   * @category Position, get
   */


  static getOffsetXY(element, container = null) {
    return [DH.getOffsetX(element, container), DH.getOffsetY(element, container)];
  }
  /**
   * Focus element without scrolling the element into view.
   * @param {HTMLElement} element
   */


  static focusWithoutScrolling(element) {
    function resetScroll(scrollHierarchy) {
      scrollHierarchy.forEach(({
        element,
        scrollLeft,
        scrollTop
      }) => {
        // Check first to avoid triggering unnecessary `scroll` events
        if (element.scrollLeft !== scrollLeft) {
          element.scrollLeft = scrollLeft;
        }

        if (element.scrollTop !== scrollTop) {
          element.scrollTop = scrollTop;
        }
      });
    } // Check browsers which do support focusOptions
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus


    const preventScrollSupported = _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].chromeVersion >= 64 || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].firefoxVersion >= 68;

    if (preventScrollSupported) {
      element.focus({
        preventScroll: true
      });
    } else {
      // Examine every parentNode of the target and cache the scrollLeft and scrollTop,
      // and restore all values after the focus has taken place
      const parents = DH.getParents(element),
            scrollHierarchy = parents.map(parent => ({
        element: parent,
        scrollLeft: parent.scrollLeft,
        scrollTop: parent.scrollTop
      }));
      element.focus(); // Reset in sync on IE, async in others

      if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11) {
        resetScroll(scrollHierarchy);
      } else {
        setTimeout(() => resetScroll(scrollHierarchy), 0);
      }
    }
  }
  /**
   * Get elements X position on page
   * @param {HTMLElement} element
   * @returns {Number}
   * @category Position, get
   */


  static getPageX(element) {
    return element.getBoundingClientRect().left + win.pageXOffset; // no window.scrollX in IE11
  }
  /**
   * Get elements Y position on page
   * @param {HTMLElement} element
   * @returns {Number}
   * @category Position, get
   */


  static getPageY(element) {
    return element.getBoundingClientRect().top + win.pageYOffset; // no window.scrollY in IE11
  }
  /**
   * Returns extremal (min/max) size (height/width) of the element in pixels
   * @param {HTMLElement} element
   * @param {String} style minWidth/minHeight/maxWidth/maxHeight
   * @returns {Number}
   * @internal
   */


  static getExtremalSizePX(element, style) {
    const prop = _StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].hyphenate(style),
          measure = prop.split('-')[1];
    let value = DH.getStyleValue(element, prop);

    if (/%/.test(value)) {
      // Element might be detached from DOM
      if (element.parentElement) {
        value = parseInt(DH.getStyleValue(element.parentElement, measure), 10);
      } else {
        value = NaN;
      }
    } else {
      value = parseInt(value, 10);
    }

    return value;
  } //endregion
  //region Set position

  /**
   * Set element's `scale`.
   * @param {HTMLElement} element
   * @param {Number} scaleX The value by which the element should be scaled in the X axis (0 to 1)
   * @param {Number} [scaleY] The value by which the element should be scaled in the Y axis (0 to 1).
   * Defaults to `scaleX`
   * @category Position, set
   * @internal
   */


  static setScale(element, scaleX, scaleY = scaleX) {
    const t = DH.getStyleValue(element, 'transform').split(/,\s*/);

    if (t.length > 1) {
      if (t[0].startsWith('matrix3d')) {
        t[0] = `matrix3d(${scaleX}`;
        t[5] = scaleY;
      } else {
        t[0] = `matrix(${scaleX}`;
        t[3] = scaleY;
      }

      element.style.transform = t.join(',');
    } else {
      element.style.transform = `scale(${scaleX}, ${scaleY})`;
    }
  }
  /**
   * Set element's `X` translation in pixels.
   * @param {HTMLElement} element
   * @param {Number} x The value by which the element should be translated from its default position.
   * @category Position, set
   */


  static setTranslateX(element, x) {
    const t = DH.getStyleValue(element, 'transform').split(/,\s*/); // Avoid blurry text on non-retina displays

    x = DH.roundPx(x);

    if (t.length > 1) {
      t[t[0].startsWith('matrix3d') ? 12 : 4] = x;
      element.style.transform = t.join(',');
    } else {
      element.style.transform = `translateX(${x}px)`;
    }
  }
  /**
   * Set element's `Y` translation in pixels.
   * @param {HTMLElement} element
   * @param {Number} y  The value by which the element should be translated from its default position.
   * @category Position, set
   */


  static setTranslateY(element, y) {
    const t = DH.getStyleValue(element, 'transform').split(/,\s*/); // Avoid blurry text on non-retina displays

    y = DH.roundPx(y);

    if (t.length > 1) {
      t[t[0].startsWith('matrix3d') ? 13 : 5] = y;
      element.style.transform = t.join(',') + ')';
    } else {
      element.style.transform = `translateY(${y}px)`;
    }
  }
  /**
   * Set element's style `top`.
   * @param {HTMLElement} element
   * @param {Number|String} y The top position. If numeric, `'px'` is used as the unit.
   * @category Position, set
   */


  static setTop(element, y) {
    DH.setLength(element, 'top', y);
  }
  /**
   * Set element's style `left`.
   * @param {HTMLElement} element
   * @param {Number|String} x The top position. If numeric, `'px'` is used as the unit.
   * @category Position, set
   */


  static setLeft(element, x) {
    DH.setLength(element, 'left', x);
  }
  /**
   * Set elements `X` and `Y` translation in pixels.
   * @param {HTMLElement} element
   * @param {Number} [x] The `X translation.
   * @param {Number} [y] The `Y translation.
   * @category Position, set
   */


  static setTranslateXY(element, x, y) {
    if (x == null) {
      return DH.setTranslateY(element, y);
    }

    if (y == null) {
      return DH.setTranslateX(element, x);
    } // Avoid blurry text on non-retina displays


    x = DH.roundPx(x);
    y = DH.roundPx(y);
    const t = DH.getStyleValue(element, 'transform').split(/,\s*/),
          is3d = t[0].startsWith('matrix3d');

    if (t.length > 1) {
      t[is3d ? 12 : 4] = x;
      t[is3d ? 13 : 5] = y;
      element.style.transform = t.join(',') + ')';
    } else {
      element.style.transform = `translate(${x}px, ${y}px)`;
    }
  }
  /**
   * Increase `X` translation
   * @param {HTMLElement} element
   * @param {Number} x The number of pixels by which to increase the element's `X` translation.
   * @category Position, set
   */


  static addTranslateX(element, x) {
    DH.setTranslateX(element, DH.getTranslateX(element) + x);
  }
  /**
   * Increase `Y` position
   * @param {HTMLElement} element
   * @param {Number} y The number of pixels by which to increase the element's `Y` translation.
   * @category Position, set
   */


  static addTranslateY(element, y) {
    DH.setTranslateY(element, DH.getTranslateY(element) + y);
  }
  /**
   * Increase X position
   * @param {HTMLElement} element
   * @param {Number} x
   * @category Position, set
   */


  static addLeft(element, x) {
    DH.setLeft(element, DH.getOffsetX(element) + x);
  }
  /**
   * Increase Y position
   * @param {HTMLElement} element
   * @param {Number} y
   * @category Position, set
   */


  static addTop(element, y) {
    DH.setTop(element, DH.getOffsetY(element) + y);
  }
  /**
   * Align the passed element with the passed target according to the align spec.
   * @param {HTMLElement} element The element to align.
   * @param {HTMLElement|Core.helper.util.Rectangle} target The target element or rectangle to align to
   * @param {Object} alignSpec See {@link Core.helper.util.Rectangle#function-alignTo} Defaults to `{ align : 't0-t0' }`
   * @param {Boolean} [round] Round the calculated Rectangles (for example if dealing with scrolling which
   * is integer based).
   */


  static alignTo(element, target, alignSpec = t0t0, round) {
    target = target instanceof _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"] ? target : _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(target, true);
    const elXY = DH.getTranslateXY(element),
          elRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(element, true);

    if (round) {
      elRect.roundPx();
      target.roundPx();
    }

    const targetRect = elRect.alignTo(Object.assign(alignSpec, {
      target
    }));
    DH.setTranslateXY(element, elXY[0] + targetRect.x - elRect.x, elXY[1] + targetRect.y - elRect.y);
  } //endregion
  //region Styles & CSS

  /**
   * Returns a style value or values for the passed element.
   * @param {HTMLElement} element The element to read styles from
   * @param {String|String[]} propName The property or properties to read
   * @param {Boolean} [inline=false] Pass as `true` to read the element's inline style.
   * Note that this could return inaccurate results if CSS rules apply to this element.
   * @return {String|Object} The value or an object containing the values keyed by the requested property name.
   * @category CSS
   */


  static getStyleValue(element, propName, inline, pseudo) {
    const styles = inline ? element.style : element.ownerDocument.defaultView.getComputedStyle(element, pseudo);

    if (Array.isArray(propName)) {
      const result = {};

      for (const prop of propName) {
        result[prop] = styles.getPropertyValue(_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].hyphenate(prop));
      }

      return result;
    } // Use the elements owning view to get the computed style.
    // Ensure the property name asked for is hyphenated.
    // getPropertyValue doesn't work with camelCase


    return styles.getPropertyValue(_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].hyphenate(propName));
  }
  /**
   * Returns an object with the parse style values for the top, right, bottom, and left
   * components of the given edge style.
   *
   * The return value is an object with `top`, `right`, `bottom`, and `left` properties
   * for the respective components of the edge style, as well as `width` (the sum of
   * `left` and `right`) and `height` (the sum of `top` and `bottom`).
   *
   * @param {HTMLElement} element
   * @param {String} edgeStyle The element's desired edge style such as 'padding', 'margin',
   * or 'border'.
   * @param {String} [edges='trbl'] A string with one character codes for each edge. Only
   * those edges will be populated in the returned object. By default, all edges will be
   * populated.
   * @returns {Object}
   */


  static getEdgeSize(element, edgeStyle, edges) {
    const suffix = edgeStyle === 'border' ? '-width' : '',
          ret = {
      raw: {}
    };

    for (const edge of ['top', 'right', 'bottom', 'left']) {
      if (!edges || edges.includes(edge[0])) {
        // This produces px units even if the provided style is em or other (i.e.,
        // getComputedStyle normalizes this):
        ret[edge] = parseFloat(ret.raw[edge] = DH.getStyleValue(element, `${edgeStyle}-${edge}${suffix}`));
      }
    } // These may not even be requested (based on "edges") but conditional code here
    // would be wasted since the caller would still need to know not to use them...
    // Replace NaN with 0 to keep calculations correct if they only asked for one side.


    ret.width = (ret.left || 0) + (ret.right || 0);
    ret.height = (ret.top || 0) + (ret.bottom || 0);
    return ret;
  }
  /**
   * Splits a style string up into object form. For example `'font-weight:bold;font-size:150%'`
   * would convert to
   *
   * ```javascript
   * {
   *     font-weight : 'bold',
   *     font-size : '150%'
   * }
   * ```
   * @param {String} style A DOM style string
   * @returns {Object} the style declaration in object form.
   */


  static parseStyle(style) {
    if (typeof style === 'string') {
      const styles = style.split(semicolonRe);
      style = {};

      for (let i = 0, {
        length
      } = styles; i < length; i++) {
        const propVal = styles[i].split(colonRe);
        style[propVal[0]] = propVal[1];
      }
    }

    return style || {};
  }
  /**
   * Applies specified style to the passed element. Style can be an object or a string.
   * @param {HTMLElement} element Target element
   * @param {String|Object} style Style to apply, 'border: 1px solid black' or { border: '1px solid black' }
   * @param {Boolean} [overwrite] Specify `true` to replace style instead of applying changes
   * @category CSS
   */


  static applyStyle(element, style, overwrite = false) {
    if (typeof style === 'string') {
      if (overwrite) {
        // Only assign if either end has any styles, do not want to add empty `style` tag on element
        if (style.length || element.style.cssText.length) {
          element.style.cssText = style;
        }
      } else {
        // Add style so as not to delete configs in style such as width, height, flex etc.
        // If a style is already there, the newest, appended one will take precedence.
        element.style.cssText += style;
      }
    } else if (style) {
      if (overwrite) {
        element.style.cssText = ''; //element.removeAttribute('style');
      } // Has a sub-style block?


      if (style.style) {
        if (typeof style.style === 'string') {
          element.style.cssText = style.style;
        } else {
          style = Object.assign({}, style.style, style);
        }
      }

      let key, value; // Prototype chained objects may be passed, so use direct loop.

      for (key in style) {
        // Ignore readonly properties of the CSSStyleDeclaration object:
        // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration
        // Also ignores sub-style blocks, which are applied above
        if (!styleIgnoreProperties[key]) {
          [key, value] = DomHelper.unitize(key, style[key]); // Cannot use element.style[key], wont work with CSS vars

          element.style.setProperty(key, value);
        }
      }
    }
  }

  static getCSSText(style) {
    if (typeof style === 'string') {
      return style;
    }

    let cssText = '';

    for (const key in style) {
      // Ignore readonly properties of the CSSStyleDeclaration object:
      // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration
      if (!styleIgnoreProperties[key]) {
        cssText += `${_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].hyphenate(key)}:${style[key]};`;
      }
    }

    return cssText;
  } // For IE11, it doesn't support adding/removing multiple classes at once

  /**
   * Add multiple classes to elements classList. Helper for IE11 which does not support it directly
   * @param {HTMLElement} element
   * @param {String[]} classes
   * @category CSS
   */


  static addClasses(element, classes) {
    for (let i = 0; i < classes.length; i++) {
      element.classList.add(classes[i]);
    }
  }
  /**
   * Remove multiple classes from elements classList. Helper for IE11 which does not support it directly
   * @param {HTMLElement} element
   * @param {String[]} classes
   * @category CSS
   */


  static removeClasses(element, classes) {
    for (let i = 0; i < classes.length; i++) {
      element.classList.remove(classes[i]);
    }
  }
  /**
   * Toggle multiple classes in elements classList. Helper for IE11 which does not support toggling with force or for
   * multiple classes at once.
   * @param {HTMLElement} element
   * @param {String[]} classes
   * @param {Boolean} [force] Specify true to add classes, false to remove. Leave blank to toggle
   * @category CSS
   */


  static toggleClasses(element, classes, force = null) {
    if (!Array.isArray(classes)) {
      classes = [classes];
    }

    if (force === true) {
      DH.addClasses(element, classes);
    } else if (force === false) {
      DH.removeClasses(element, classes);
    } else {
      classes.forEach(cls => element.classList.toggle(cls));
    }
  }
  /**
   * Adds a CSS class to an element during the specified duration
   * @param {HTMLElement} element Target element
   * @param {String} cls CSS class to add temporarily
   * @param {Number} duration Duration in ms, 0 means cls will not be applied
   * @param {Core.mixin.Delayable} delayable The delayable to tie the setTimeout call to
   * @typings delayable -> {typeof Delayable}
   * @category CSS
   */


  static addTemporaryClass(element, cls, duration, delayable = window) {
    if (duration > 0) {
      element.classList.add(cls);
      delayable.setTimeout(() => element.classList.remove(cls), duration);
    }
  }
  /**
   * Reads computed style from the element and returns transition duration for a given property in milliseconds
   * @param {HTMLElement} element Target DOM element
   * @param {String} property Animated property name
   * @returns {Number} Duration in ms
   * @internal
   */


  static getPropertyTransitionDuration(element, property) {
    const style = window.getComputedStyle(element),
          properties = style.transitionProperty.split(', '),
          durations = style.transitionDuration.split(', '),
          index = properties.indexOf(_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].hyphenate(property));
    let result;

    if (index !== -1) {
      // get floating value of transition duration in seconds and convert into milliseconds
      result = parseFloat(durations[index]) * 1000;
    }

    return result;
  }
  /**
   * Reads computed style from the element and returns the animation duration for any
   * attached animation in milliseconds
   * @param {HTMLElement} element Target DOM element
   * @returns {Number} Duration in ms
   * @internal
   */


  static getAnimationDuration(element) {
    return parseFloat(DH.getStyleValue(element, 'animation-duration')) * 1000;
  } //endregion
  //region Effects

  /**
   * Highlights the passed element or Rectangle according to the theme's highlighting rules.
   * Usually an animated framing effect.
   * @param {HTMLElement|Core.helper.util.Rectangle} element The element or Rectangle to highlight.
   */


  static highlight(element, delayable = window) {
    if (element instanceof _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
      return element.highlight();
    }

    return new Promise(resolve => {
      delayable.setTimeout(() => {
        element.classList.add('b-fx-highlight');
        delayable.setTimeout(() => {
          element.classList.remove('b-fx-highlight');
          resolve();
        }, 1000);
      }, 0);
    });
  } //endregion
  //region Measuring / Scrollbar

  /**
   * Measures the scrollbar width using a hidden div. Caches result
   * @property {Number}
   * @readonly
   */


  static get scrollBarWidth() {
    // Ensure the measurement is only done once, when the value is null and body is available
    if (scrollBarWidth === null && doc.body) {
      const element = DH.createElement({
        parent: doc.body,
        style: 'position:absolute;top:-999px;width:100px;height:100px;overflow:scroll'
      });
      scrollBarWidth = element.offsetWidth - element.clientWidth;
      element.remove();
    }

    return scrollBarWidth;
  }

  static get scrollBarPadElement() {
    return {
      className: 'b-yscroll-pad',
      children: [{
        className: 'b-yscroll-pad-sizer'
      }]
    };
  }
  /**
   * Resets DomHelper.scrollBarWidth cache, triggering a new measurement next time it is read
   */


  static resetScrollBarWidth() {
    scrollBarWidth = null;
  }
  /**
   * Measures the text width using a hidden div
   * @param {String} text
   * @param {HTMLElement} sourceElement
   * @returns {Number} width
   * @category Measure
   */


  static measureText(text, sourceElement, useHTML = false, parentElement = undefined) {
    const offScreenDiv = DH.getMeasureElement(sourceElement, parentElement);
    offScreenDiv[useHTML ? 'innerHTML' : 'innerText'] = text;
    const result = offScreenDiv.clientWidth;
    offScreenDiv.className = '';
    return result;
  }
  /**
   * Measures a relative size, such as a size specified in `em` units for the passed element.
   * @param {String} size The CSS size value to measure.
   * @param {HTMLElement} sourceElement
   * @param {Boolean} [round] Pass true to return exact width, not rounded value
   * @returns {Number} size The size in pixels of the passed relative measurement.
   * @category Measure
   */


  static measureSize(size, sourceElement, round = true) {
    if (!size) {
      return 0;
    }

    if (typeof size === 'number') {
      return size;
    }

    if (!size.length) {
      return 0;
    }

    if (/^\d+(px)?$/.test(size)) {
      return parseInt(size);
    }

    if (sourceElement) {
      const offScreenDiv = DH.getMeasureElement(sourceElement);
      offScreenDiv.innerHTML = '';
      offScreenDiv.style.width = DH.setLength(size); //const result = BrowserHelper.isIE11 ?  offScreenDiv.offsetWidth : offScreenDiv.clientWidth;

      const result = round ? offScreenDiv.offsetWidth : offScreenDiv.getBoundingClientRect().width;
      offScreenDiv.style.width = offScreenDiv.className = '';
      return result;
    }

    if (/^\d+em$/.test(size)) {
      return parseInt(size) * DEFAULT_FONT_SIZE;
    }

    return isNaN(size) ? 0 : parseInt(size);
  } // parentElement allows measurement to happen inside a specific element, allowing scoped css rules to match


  static getMeasureElement(sourceElement, parentElement = doc.body) {
    const sourceElementStyle = win.getComputedStyle(sourceElement),
          offScreenDiv = parentElement.offScreenDiv = parentElement.offScreenDiv || DH.createElement({
      parent: parentElement,
      style: 'position:fixed;top:-10000px;left:-10000px;visibility:hidden;contain:strict',
      className: 'b-measure-element',
      children: [{
        style: 'white-space:nowrap;display:inline-block;will-change:contents;width:auto;contain:none'
      }]
    }, true)[1];
    fontProps.forEach(prop => {
      if (offScreenDiv.style[prop] !== sourceElementStyle[prop]) {
        offScreenDiv.style[prop] = sourceElementStyle[prop];
      }
    });
    offScreenDiv.className = sourceElement.className; // In case the measure element was moved/removed, re-add it

    if (offScreenDiv.parentElement.parentElement !== parentElement) {
      parentElement.appendChild(offScreenDiv.parentElement);
    }

    return offScreenDiv;
  }
  /**
   * Strips the tags from a html string, returning text content.
   *
   * ```javascript
   * DomHelper.stripTags('<div class="custom"><b>Bold</b><i>Italic</i></div>'); // -> BoldItalic
   * ```
   *
   * @internal
   * @param {String} htmlString HTML string
   * @returns {String} Text content
   */


  static stripTags(htmlString) {
    const // we need to avoid any kind of evaluation of embedded XSS scripts or "web bugs" (img tags that issue
    // GET requests)
    parser = DH.$domParser || (DH.$domParser = new DOMParser()),
          doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body.textContent;
  } //endregion
  //region Sync

  /**
   * Sync one source element attributes, children etc. to a target element. Source element can be specified as a html
   * string or an actual HTMLElement.
   *
   * NOTE: This function is superseded by {@link Core/helper/DomSync#function-sync-static DomSync.sync()}, which works
   * with DOM configs. For most usecases, use it instead.
   *
   * @param {String|HTMLElement} sourceElement Source "element" to copy from
   * @param {HTMLElement} targetElement Target element to apply to, can also be specified as part of the config object
   * @returns {HTMLElement} Returns the updated targetElement (which is also updated in place)
   */


  static sync(sourceElement, targetElement) {
    if (typeof sourceElement === 'string') {
      if (sourceElement === '') {
        targetElement.innerHTML = '';
        return;
      } else {
        sourceElement = DH.createElementFromTemplate(sourceElement);
      }
    }

    DH.performSync(sourceElement, targetElement);
    return targetElement;
  } // Internal helper used for recursive syncing


  static performSync(sourceElement, targetElement) {
    // Syncing identical elements is a no-op
    if (sourceElement.outerHTML !== targetElement.outerHTML) {
      DH.syncAttributes(sourceElement, targetElement);
      DH.syncContent(sourceElement, targetElement);
      DH.syncChildren(sourceElement, targetElement);
      return true;
    }

    return false;
  } // Attributes as map { attr : value, ... }, either from an html element or from a config


  static getSyncAttributes(element) {
    const attributes = {},
          // Attribute names, simplifies comparisons and calls to set/removeAttribute
    names = []; // Extract from element

    for (let i = 0; i < element.attributes.length; i++) {
      const attr = element.attributes[i];

      if (attr.specified) {
        const name = attr.name.toLowerCase();
        attributes[name] = attr.value;
        names.push(name);
      }
    }

    return {
      attributes,
      names
    };
  }
  /**
   * Syncs attributes from sourceElement to targetElement.
   * @private
   * @param {HTMLElement} sourceElement
   * @param {HTMLElement} targetElement
   */


  static syncAttributes(sourceElement, targetElement) {
    const // Extract attributes from elements (sourceElement might be a config)
    {
      attributes: sourceAttributes,
      names: sourceNames
    } = DH.getSyncAttributes(sourceElement),
          {
      attributes: targetAttributes,
      names: targetNames
    } = DH.getSyncAttributes(targetElement),
          // Used to ignore data-xx attributes when we will be setting entire dataset
    hasDataset = sourceNames.includes('dataset'),
          // Intersect arrays to determine what needs adding, removing and syncing
    toAdd = sourceNames.filter(attr => !targetNames.includes(attr)),
          toRemove = targetNames.filter(attr => !sourceNames.includes(attr) && (!hasDataset || !attr.startsWith('data-'))),
          toSync = sourceNames.filter(attr => targetNames.includes(attr));

    if (toAdd.length > 0) {
      for (let i = 0; i < toAdd.length; i++) {
        const attr = toAdd[i]; // Style requires special handling

        if (attr === 'style') {
          DH.applyStyle(targetElement, sourceAttributes.style, true);
        } // So does dataset
        else if (attr === 'dataset') {
          Object.assign(targetElement.dataset, sourceAttributes.dataset);
        } // Other attributes are set using setAttribute (since it calls toString() DomClassList works fine)
        else {
          targetElement.setAttribute(attr, sourceAttributes[attr]);
        }
      }
    }

    if (toRemove.length > 0) {
      for (let i = 0; i < toRemove.length; i++) {
        targetElement.removeAttribute(toRemove[i]);
      }
    }

    if (toSync.length > 0) {
      for (let i = 0; i < toSync.length; i++) {
        const attr = toSync[i]; // Set all attributes that has changed, with special handling for style

        if (attr === 'style') {
          // TODO: Check for changes?
          DH.applyStyle(targetElement, sourceAttributes.style, true);
        } // And dataset
        else if (attr === 'dataset') {
          // TODO: Any cost to assigning same values?
          Object.assign(targetElement.dataset, sourceAttributes.dataset);
        } // And class, which might be a DomClassList or an config for a DomClassList
        else if (attr === 'class' && (sourceAttributes.class.isDomClassList || typeof sourceAttributes.class === 'object')) {
          let classList;

          if (sourceAttributes.class.isDomClassList) {
            classList = sourceAttributes.class;
          } else {
            // TODO : Reuse a single DomClassList?
            classList = new _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_5__["default"](sourceAttributes.class);
          }

          if (!classList.isEqual(targetAttributes.class)) {
            targetElement.setAttribute('class', classList);
          }
        } else if (targetAttributes[attr] !== sourceAttributes[attr]) {
          targetElement.setAttribute(attr, sourceAttributes[attr]);
        }
      }
    }
  }
  /**
   * Sync content (innerText) from sourceElement to targetElement
   * @private
   * @param {HTMLElement} sourceElement
   * @param {HTMLElement} targetElement
   */


  static syncContent(sourceElement, targetElement) {
    if (DH.getChildElementCount(sourceElement) === 0) {
      targetElement.innerText = sourceElement.innerText;
    }
  }

  static setInnerText(targetElement, text) {
    // setting firstChild.data is faster than innerText (and innerHTML),
    // but in some cases the inner node is lost and needs to be recreated
    const firstChild = targetElement.firstChild; // If there's only one text node, just update its value

    if ((firstChild === null || firstChild === void 0 ? void 0 : firstChild.nodeType) === Element.TEXT_NODE && targetElement.childNodes.length === 1) {
      firstChild.data = text;
    } else {
      // textContent is supposed to be faster than innerText, since it does not trigger layout
      targetElement.textContent = text;
    }
  }
  /**
   * Sync traversing children
   * @private
   * @param {HTMLElement} sourceElement Source element
   * @param {HTMLElement} targetElement Target element
   */


  static syncChildren(sourceElement, targetElement) {
    const me = this,
          sourceNodes = arraySlice.call(sourceElement.childNodes),
          targetNodes = arraySlice.call(targetElement.childNodes);

    while (sourceNodes.length) {
      const sourceNode = sourceNodes.shift(),
            targetNode = targetNodes.shift(); // only textNodes and elements allowed (no comments)

      if (sourceNode && sourceNode.nodeType !== TEXT_NODE && sourceNode.nodeType !== ELEMENT_NODE) {
        throw new Error(`Source node type ${sourceNode.nodeType} not supported by DomHelper.sync()`);
      }

      if (targetNode && targetNode.nodeType !== TEXT_NODE && targetNode.nodeType !== ELEMENT_NODE) {
        throw new Error(`Target node type ${targetNode.nodeType} not supported by DomHelper.sync()`);
      }

      if (!targetNode) {
        // out of target nodes, add to target
        targetElement.appendChild(sourceNode);
      } else {
        // match node
        if (sourceNode.nodeType === targetNode.nodeType) {
          // same type of node, take action depending on which type
          if (sourceNode.nodeType === TEXT_NODE) {
            // text
            targetNode.data = sourceNode.data;
          } else {
            if (sourceNode.tagName === targetNode.tagName) {
              me.performSync(sourceNode, targetNode);
            } else {
              // new tag, remove targetNode and insert new element
              targetElement.insertBefore(sourceNode, targetNode);
              targetNode.remove();
            }
          }
        } // Trying to set text node as element, use it as innerText
        // (we get this in FF with store mutations and List)
        else if (sourceNode.nodeType === TEXT_NODE && targetNode.nodeType === ELEMENT_NODE) {
          targetElement.innerText = sourceNode.data.trim();
        } else {
          const logElement = sourceNode.parentElement || sourceNode;
          throw new Error(`Currently no support for transforming nodeType.\n${logElement.outerHTML}`);
        }
      }
    } // Out of source nodes, remove remaining target nodes


    targetNodes.forEach(targetNode => {
      targetNode.remove();
    });
  }
  /**
   * Replaces the passed element's `className` with the class names
   * passed in either Array or String format or Object.
   *
   * This method compares the existing class set with the incoming class set and
   * avoids mutating the element's class name set if possible.
   *
   * This can avoid browser style invalidations.
   * @param {HTMLElement} element The element whose class list to synchronize.
   * @param {String[]|String|Object} newClasses The incoming class names to set on the element.
   * @returns {Boolean} `true` if the DOM class list was changed.
   * @category CSS
   */


  static syncClassList(element, newClasses) {
    const classList = element.classList,
          isString = typeof newClasses === 'string',
          newClsArray = isString ? newClasses.trim().split(whiteSpaceRe) : Array.isArray(newClasses) ? newClasses : _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTruthyKeys(newClasses),
          classCount = newClsArray.length;
    let changed = classList.length !== classCount,
        i; // If the incoming and existing class lists are the same length
    // then check that each contains the same names. As soon as
    // we find a non-matching name, we know we have to update the
    // className.

    for (i = 0; !changed && i < classCount; i++) {
      changed = !classList.contains(newClsArray[i]);
    }

    if (changed) {
      element.className = isString ? newClasses : newClsArray.join(' ');
    }

    return changed;
  }
  /**
   * Applies the key state of the passed object or DomClassList to the passed element.
   *
   * Properties with a falsy value mean that property name is *removed* as a class name.
   *
   * Properties with a truthy value mean that property name is *added* as a class name.
   *
   * This is different from {@link #function-syncClassList-static}. That sets the `className` of the element to the
   * sum of all its truthy keys, regardless of what the pre-existing value of the `className` was, and ignoring falsy
   * keys.
   *
   * This _selectively_ updates the classes in the `className`. If there is a truthy key, the name is added. If there
   * is a falsy key, the name is removed.
   * @param {HTMLElement} element The element to apply the class list to .
   * @param {Object|Core.helper.util.DomClassList} classes The classes to add or remove.
   * @returns {Boolean} `true` if the DOM class list was changed.
   * @category CSS
   */


  static updateClassList(element, classes) {
    const {
      classList
    } = element;
    let cls,
        add,
        changed = false;

    for (cls in classes) {
      add = Boolean(classes[cls]);

      if (classList.contains(cls) !== add) {
        classList[add ? 'add' : 'remove'](cls);
        changed = true;
      }
    }

    return changed;
  }
  /**
   * Changes the theme to the passed theme name if possible.
   *
   * Theme names are case insensitive. The `href` used is all lower case.
   *
   * To use this method, the `<link rel="stylesheet">` _must_ use the default,
   * Bryntum-supplied CSS files where the `href` end with `<themeName>.css`, so that
   * it can be found in the document, and switched out for a new link with
   * the a modified `href`. The new `href` will use the same path, just
   * with the `themeName` portion substituted for the new name.
   *
   * If no `<link>` with that name pattern can be found, an error will be thrown.
   *
   * If you use this method, you  must ensure that the theme files are
   * all accessible on your server.
   *
   * Because this is an asynchronous operation, a `Promise` is returned.
   * The theme change event is passed to the success function. If the
   * theme was not changed, because the theme name passed is the current theme,
   * nothing is passed to the success function.
   *
   * The theme change event contains two properties:
   *
   *  - `prev` The previous Theme name.
   *  - `theme` The new Theme name.
   *
   * @param {String} newThemeName the name of the theme that should be applied
   * @privateparam {String} [defaultTheme] Optional, the name of the theme that should be used in case of fail
   * @returns {Promise} A promise who's success callback receives the theme change
   * event if the theme in fact changed. If the theme `href` could not be loaded,
   * the failure callback is called, passing the error event caught.
   */


  static setTheme(newThemeName, defaultTheme) {
    newThemeName = newThemeName.toLowerCase();
    const oldThemeName = DH.getThemeInfo(defaultTheme).name.toLowerCase(),
          oldThemeLink = document.head.querySelector('#bryntum-theme:not([data-loading])') || document.head.querySelector(`[href*="${oldThemeName}.css"]:not([data-loading])`); // Remove any links currently loading

    DH.removeEachSelector(document.head, '#bryntum-theme[data-loading]'); // Theme link href ends with <themeName>.css also there could be a query - css?11111...

    if (!(oldThemeLink !== null && oldThemeLink !== void 0 && oldThemeLink.href.includes(`${oldThemeName}.css`))) {
      throw new Error(`Theme link for ${oldThemeName} not found`);
    } // Do not reapply same theme


    if (oldThemeLink.href.includes(`${newThemeName}.css`)) {
      return immediatePromise;
    }

    return new Promise((resolve, reject) => {
      const newThemeLink = document.createElement('link'),
            nextSibling = oldThemeLink.nextSibling,
            oldThemeName = DH.getThemeInfo(defaultTheme).name.toLowerCase(),
            themeEvent = {
        theme: newThemeName,
        prev: oldThemeName
      },
            onThemeLoad = () => {
        delete newThemeLink.dataset.loading;
        themeInfo = null;
        oldThemeLink.remove();
        _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__["default"].trigger('theme', themeEvent);
        resolve(themeEvent);
      },
            onThemeLoadError = e => {
        delete newThemeLink.dataset.loading;
        reject(e);
      };

      newThemeLink.rel = 'stylesheet';
      newThemeLink.id = 'bryntum-theme';
      newThemeLink.addEventListener('load', onThemeLoad);
      newThemeLink.addEventListener('error', onThemeLoadError);
      newThemeLink.dataset.loading = 'true';
      newThemeLink.href = oldThemeLink.href.replace(oldThemeName, newThemeName);
      nextSibling.parentNode.insertBefore(newThemeLink, nextSibling);
    });
  }
  /**
   * A theme information object about the current theme.
   *
   * Currently this has only one property:
   *
   *   - `name` The current theme name.
   * @property {Object}
   * @readonly
   */


  static get themeInfo() {
    return DomHelper.getThemeInfo();
  }
  /**
   * A theme information object about the current theme.
   *
   * Currently this has only one property:
   *
   *   - `name` The current theme name.
   * @param {String} defaultTheme the name of the theme used as backup value in case of fail
   * @returns {Object} info, currently it contains only one property - 'name'.
   * @private
   */


  static getThemeInfo(defaultTheme) {
    if (!themeInfo) {
      const // The content it creates for 'b-theme-info' is described in corresponding theme in Core/resources/sass/themes
      // for example in Core/resources/sass/themes/material.scss
      // ```
      // .b-theme-info:before {
      //     content : '{"name":"Material"}';
      // }
      // ```
      testDiv = DH.createElement({
        parent: document.body,
        className: 'b-theme-info'
      }),
            // Need to be a pseudo element for Edge to report content correctly
      themeData = DH.getStyleValue(testDiv, 'content', false, ':before');

      if (themeData) {
        // themeData could be invalid JSON string in case there is no content rule
        try {
          themeInfo = JSON.parse(themeData.replace(/^["']|["']$|\\/g, ''));
        } catch (e) {
          themeInfo = null;
        }
      } // CSS file has to be loaded to make the themeInfo available, so fallback to the default theme name


      themeInfo = themeInfo || (defaultTheme ? {
        name: defaultTheme
      } : null);
      testDiv.remove();
    }

    return themeInfo;
  } //endregion
  //region Transition


  static async transition({
    element: outerElement,
    selector = '[data-dom-transition]',
    duration,
    action,
    thisObj = this,
    addTransition = {},
    removeTransition = {}
  }) {
    const scrollers = new Set(),
          beforeElements = Array.from(outerElement.querySelectorAll(selector)),
          beforeMap = new Map(beforeElements.map(element => {
      let depth = 0,
          parent = element.parentElement;

      while (parent && parent !== outerElement) {
        depth++;
        parent = parent.parentElement;
      }

      element.$depth = depth; // Store scrolling elements and their current scroll pos, for restoring later

      if (element.scrollHeight > element.offsetHeight && getComputedStyle(element).overflow === 'auto') {
        element.$scrollTop = element.scrollTop;
        scrollers.add(element);
      } // Intersect our bounds with parents, to trim away overflow


      const {
        parentElement
      } = element,
            globalBounds = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(element, outerElement),
            localBounds = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(element, parentElement),
            style = getComputedStyle(parentElement),
            borderLeftWidth = parseFloat(style.borderLeftWidth);

      if (borderLeftWidth) {
        globalBounds.left -= borderLeftWidth;
        localBounds.left -= borderLeftWidth;
      }

      return [element.id, {
        element,
        globalBounds,
        localBounds,
        depth,
        parentElement
      }];
    }));
    action.call(thisObj);
    const afterElements = Array.from(outerElement.querySelectorAll(selector)),
          afterMap = new Map(afterElements.map(element => {
      const globalBounds = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(element, outerElement),
            localBounds = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(element, element.parentElement),
            style = window.getComputedStyle(element.parentElement),
            borderLeftWidth = parseFloat(style.borderLeftWidth);

      if (borderLeftWidth) {
        globalBounds.left -= borderLeftWidth;
        localBounds.left -= borderLeftWidth;
      }

      return [element.id, {
        element,
        globalBounds,
        localBounds
      }];
    })),
          styleProps = ['position', 'top', 'left', 'width', 'height', 'padding', 'margin', 'zIndex', 'minWidth', 'minHeight', 'opacity', 'overflow']; // Convert to absolute layout, iterating elements remaining after action

    for (const [id, before] of beforeMap) {
      // We match before vs after on id and not actual element, allowing adding a new element with the same id to
      // transition from the old (which was removed or released). To match what will happen when DomSyncing with
      // multiple containing elements (columns in TaskBoard)
      const after = afterMap.get(id);

      if (after) {
        const {
          element
        } = after,
              {
          style,
          parentElement
        } = element,
              // Need to keep explicit zIndex to keep above other stuff
        zIndex = parseInt(DomHelper.getStyleValue(element, 'zIndex')),
              {
          globalBounds,
          localBounds,
          depth,
          parentElement: beforeParent
        } = before,
              parentChanged = beforeParent !== parentElement; // Store initial state, in case element has a style prop we need to restore later

        _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].copyProperties(element.$initial = {
          parentElement
        }, style, styleProps); // Prevent transition during the process, forced further down instead
        // element.remove();

        let bounds; // Action moved element to another parent, move it to the outer element to allow transitioning to the
        // new parent. Also use coordinates relative to that element

        if (parentChanged) {
          after.bounds = after.globalBounds;
          bounds = globalBounds;
          outerElement.appendChild(element);
        } // Keep element in current parent if it was not moved during the action call above.
        // Need to use coords relative to the parent
        else {
          after.bounds = after.localBounds;
          bounds = localBounds;
          beforeParent.appendChild(element);
        }

        let overflow = 'hidden'; // Looks weird with content sticking out if height is transitioned

        if (scrollers.has(element)) {
          element.$scrollPlaceholder = DomHelper.createElement({
            parent: element,
            style: {
              height: element.scrollHeight
            }
          });
          overflow = 'auto';
        } // Move element back to where it started


        Object.assign(style, {
          position: 'absolute',
          top: `${bounds.top}px`,
          left: `${bounds.left}px`,
          width: `${bounds.width}px`,
          height: `${bounds.height}px`,
          minWidth: 0,
          minHeight: 0,
          padding: 0,
          margin: 0,
          zIndex: depth + (zIndex || 0),
          overflow
        });
        after.processed = true;
      } // Existed before but not after = removed
      else {
        const {
          element,
          localBounds: bounds,
          depth,
          parentElement
        } = before;
        element.$initial = {
          removed: true
        };
        Object.assign(element.style, {
          position: 'absolute',
          top: `${bounds.top}px`,
          left: `${bounds.left}px`,
          width: `${bounds.width}px`,
          height: `${bounds.height}px`,
          minWidth: 0,
          minHeight: 0,
          padding: 0,
          margin: 0,
          zIndex: depth,
          overflow: 'hidden' // Looks weird with content sticking out if height is transitioned

        });
        parentElement.appendChild(element); // Inject among non-removed elements to have it transition away

        afterMap.set(id, {
          element,
          bounds,
          removed: true,
          processed: true
        });
        afterElements.push(element);
      }
    } // Handle new elements


    for (const [, after] of afterMap) {
      if (!after.processed) {
        const {
          element
        } = after,
              {
          style,
          parentElement
        } = element,
              bounds = after.bounds = after.localBounds;
        element.classList.add('b-dom-transition-adding');
        _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].copyProperties(element.$initial = {
          parentElement
        }, style, styleProps); // Props in `addTransition` will be transitioned

        Object.assign(style, {
          position: 'absolute',
          top: addTransition.top ? 0 : `${bounds.top}px`,
          left: addTransition.left ? 0 : `${bounds.left}px`,
          width: addTransition.width ? 0 : `${bounds.width}px`,
          height: addTransition.height ? 0 : `${bounds.height}px`,
          opacity: addTransition.opacity ? 0 : null,
          zIndex: parentElement.$depth + 1,
          overflow: 'hidden' // Looks weird with content sticking out if height is transitioned

        });
      }
    } // Restore scroll after modifying layout


    for (const element of scrollers) {
      element.scrollTop = element.$scrollTop;
    } // Enable transitions


    outerElement.classList.add('b-dom-transition'); // Trigger layout, to be able to transition below

    outerElement.firstElementChild.offsetWidth; // Transition to new layout

    for (const [, {
      element,
      bounds: afterBounds,
      removed
    }] of afterMap) {
      if (removed) {
        Object.assign(element.style, {
          top: removeTransition.top ? 0 : `${afterBounds.top}px`,
          left: removeTransition.left ? 0 : `${afterBounds.left}px`,
          width: removeTransition.width ? 0 : `${afterBounds.width}px`,
          height: removeTransition.height ? 0 : `${afterBounds.height}px`,
          opacity: removeTransition.opacity ? 0 : element.$initial.opacity
        });
      } else {
        Object.assign(element.style, {
          top: `${afterBounds.top}px`,
          left: `${afterBounds.left}px`,
          width: `${afterBounds.width}px`,
          height: `${afterBounds.height}px`,
          opacity: element.$initial.opacity
        });
      }
    } // Wait for transition to finish


    await _AsyncHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].sleep(duration);
    outerElement.classList.remove('b-dom-transition'); // Restore layout after transition

    for (const element of afterElements) {
      if (element.$initial) {
        if (element.$initial.removed) {
          element.remove();
        } else {
          _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].copyProperties(element.style, element.$initial, styleProps);

          if (element.$scrollPlaceholder) {
            element.$scrollPlaceholder.remove();
            delete element.$scrollPlaceholder;
          }

          element.classList.remove('b-dom-transition-adding');
          element.$initial.parentElement.appendChild(element);
        }
      }
    } // Restore scroll positions last when all layout is restored


    for (const element of scrollers) {
      element.scrollTop = element.$scrollTop;
      delete element.$scrollTop;
    }
  } //endregion


  static async loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  static isNamedColor(color) {
    return color && !/^(#|hsl|rgb)/.test(color);
  }

}
const DH = DomHelper;
let clearTouchTimer;

const clearTouchEvent = () => DH.isTouchEvent = false,
      setTouchEvent = () => {
  DH.isTouchEvent = true; // Jump round the click delay

  clearTimeout(clearTouchTimer);
  clearTouchTimer = setTimeout(clearTouchEvent, 400);
}; // Set event type flags so that mousedown and click handlers can know whether a touch gesture was used.
// This is used. This must stay until we have a unified DOM event system which handles both touch and mouse events.


doc.addEventListener('touchstart', setTouchEvent, true);
doc.addEventListener('touchend', setTouchEvent, true);
DH.canonicalStyles = canonicalStyles;
DH.supportsTemplate = 'content' in doc.createElement('template');
DH.elementPropKey = elementPropKey;
DH.numberRe = numberRe; //region Polyfills
// TODO: include babels polyfills instead of keeping own?

if (!('children' in Node.prototype)) {
  const elementFilter = node => node.nodeType === node.ELEMENT_NODE;

  Object.defineProperty(Node.prototype, 'children', {
    get: function () {
      return Array.prototype.filter.call(this.childNodes, elementFilter);
    }
  });
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
    const matches = (this.document || this.ownerDocument).querySelectorAll(s);
    let i = matches.length; // eslint-disable-next-line no-empty

    while (--i >= 0 && matches.item(i) !== this) {}

    return i > -1;
  };
}

if (win.Element && !Element.prototype.closest) {
  Node.prototype.closest = Element.prototype.closest = function (s) {
    let el = this;
    if (!doc.documentElement.contains(el)) return null;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === el.ELEMENT_NODE);

    return null;
  };
} else {
  // It's crazy that closest is not already on the Node interface!
  // Note that some Node types (eg DocumentFragment) do not have a parentNode.
  Node.prototype.closest = function (selector) {
    var _this$parentNode;

    return (_this$parentNode = this.parentNode) === null || _this$parentNode === void 0 ? void 0 : _this$parentNode.closest(selector);
  };
} // from MDN (public domain): https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove


(function (arr) {
  arr.forEach(function (item) {
    if (Object.prototype.hasOwnProperty.call(item, 'remove')) {
      return;
    }

    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode && this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]); // IE11 polyfill


if (!SVGElement.prototype.contains) {
  SVGElement.prototype.contains = function (node) {
    do {
      if (this === node) {
        return true;
      }

      node = node.parentNode;
    } while (node);

    return false;
  };
} // IE11 polyfill for Event constructors


if (typeof win.CustomEvent !== 'function') {
  let evt, constructor;

  win.CustomEvent = constructor = function (event, params = {
    bubbles: false,
    cancelable: false,
    detail: undefined
  }) {
    evt = doc.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  constructor.prototype = win.Event.prototype;

  win.MouseEvent = constructor = function (event, params = {
    bubbles: false,
    cancelable: false,
    detail: undefined
  }) {
    evt = doc.createEvent('MouseEvents');
    evt.initMouseEvent(event, params.bubbles, params.cancelable, doc.defaultView || win, params.detail, params.screenX, params.screenY, params.clientX, params.clientY, false, false, false, false, 0, document);
    return evt;
  };

  constructor.prototype = win.Event.prototype;

  win.KeyboardEvent = constructor = function (event, params = {
    bubbles: false,
    cancelable: false,
    detail: undefined
  }) {
    const modifiers = `${params.shiftKey ? 'Shift ' : ''}${params.ctrlKey ? 'Control' : ''}`;
    evt = doc.createEvent('KeyboardEvent');
    evt.initKeyboardEvent(event, params.bubbles, params.cancelable, doc.defaultView || win, params.key, params.location, modifiers, false, '');
    return evt;
  };

  constructor.prototype = win.Event.prototype;
} //endregion
// https://gist.github.com/brettz9/4093766


if (!Object.getOwnPropertyDescriptor(SVGElement.prototype, 'dataset') || !Object.getOwnPropertyDescriptor(SVGElement.prototype, 'dataset').get) {
  const propDescriptor = {
    enumerable: true,
    get: function () {
      'use strict';

      let i,
          that = this,
          map = {},
          attrVal,
          attrName,
          propName,
          attribute,
          attributes = this.attributes,
          attsLength = attributes.length,
          toUpperCase = function (n0) {
        return n0.charAt(1).toUpperCase();
      },
          getter = function () {
        return this;
      },
          setter = function (attrName, value) {
        return typeof value !== 'undefined' ? this.setAttribute(attrName, value) : this.removeAttribute(attrName);
      };

      for (i = 0; i < attsLength; i++) {
        var _attribute;

        attribute = attributes[i]; // Fix: This test really should allow any XML Name without
        //         colons (and non-uppercase for XHTML)

        if ((_attribute = attribute) !== null && _attribute !== void 0 && _attribute.name && /^data-\w[\w-]*$/.test(attribute.name)) {
          attrVal = attribute.value;
          attrName = attribute.name; // Change to CamelCase

          propName = attrName.substr(5).replace(/-./g, toUpperCase);
          Object.defineProperty(map, propName, {
            enumerable: this.enumerable,
            get: getter.bind(attrVal || ''),
            set: setter.bind(that, attrName)
          });
        }
      }

      return map;
    }
  }; // FF enumerates over element's dataset, but not
  // SVGElement.prototype.dataset; IE9 iterates over both

  Object.defineProperty(SVGElement.prototype, 'dataset', propDescriptor);
} // Polyfill to allow an array to be passed to classList.add/remove


const {
  add: nativeAdd,
  remove: nativeRemove
} = DOMTokenList.prototype;

DOMTokenList.prototype.add = function (cls) {
  if (Array.isArray(cls)) {
    cls.forEach(c => nativeAdd.call(this, c));
  } else {
    nativeAdd.call(this, ...arguments);
  }
};

DOMTokenList.prototype.remove = function (cls) {
  if (Array.isArray(cls)) {
    cls.forEach(c => nativeRemove.call(this, c));
  } else {
    nativeRemove.call(this, ...arguments);
  }
}; // CTRL/+ and  CTRL/- zoom gestures must invalidate the scrollbar width.
// Window resize is triggered by this operation on Blink (Chrome & Edge), Firefox and Safari.


window.addEventListener('resize', () => scrollBarWidth = null);
DomHelper._$name = 'DomHelper';

/***/ }),

/***/ "./lib/Core/helper/DomSync.js":
/*!************************************!*\
  !*** ./lib/Core/helper/DomSync.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DomSync; });
/* harmony import */ var _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';





/**
 * @module Core/helper/DomSync
 */

const arraySlice = Array.prototype.slice,
      emptyArray = Object.freeze([]),
      emptyObject = Object.freeze({}),
      htmlRe = /[&<]/,
      // tests if setInnerText is equivalent to innerHTML
{
  getPrototypeOf
} = Object,
      {
  toString
} = Object.prototype,
      {
  isEqual,
  isObject
} = _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"],
      // Attributes used during creation that should not be compared
checkEqualityIgnore = {
  parent: 1,
  elementData: 1,
  ns: 1,
  syncOptions: 1
},
      makeCheckEqualityOptions = () => ({
  ignore: checkEqualityIgnore,
  refsFound: new Set()
}),
      isClass = {
  class: 1,
  className: 1,
  classname: 1
},
      simpleTypes = {
  bigint: 1,
  boolean: 1,
  function: 1,
  number: 1,
  // object
  string: 1,
  symbol: 1 // undefined

},
      // Attributes to ignore on sync
syncIgnoreAttributes = {
  tag: 1,
  html: 1,
  text: 1,
  children: 1,
  tooltip: 1,
  parent: 1,
  nextSibling: 1,
  ns: 1,
  reference: 1,
  elementData: 1,
  retainElement: 1,
  compareHtml: 1,
  syncOptions: 1,
  listeners: 1,
  isReleased: 1,
  null: 1,
  '': 1
};

const addAndCacheCls = (cls, lastDomConfig) => {
  const propertyName = 'className' in lastDomConfig ? 'className' : 'class',
        propertyValue = lastDomConfig[propertyName];

  if (propertyValue) {
    if (typeof propertyValue === 'string') {
      const value = propertyValue.split(' ');

      if (!value.includes(cls)) {
        value.push(cls);
        lastDomConfig[propertyName] = value.join(' ');
      }
    } else if (Array.isArray(propertyValue)) {
      if (!propertyValue.includes(cls)) {
        propertyValue.push(cls);
      }
    } else if (propertyValue.isDomClassList) {
      propertyValue.add(cls);
    } else if (_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isObject(propertyValue)) {
      propertyValue[cls] = 1;
    }
  }
};

const removeAndUncacheCls = (cls, lastDomConfig) => {
  const propertyName = 'className' in lastDomConfig ? 'className' : 'class',
        propertyValue = lastDomConfig[propertyName];

  if (propertyValue) {
    if (typeof propertyValue === 'string') {
      const value = propertyValue.split(' ');

      if (value.includes(cls)) {
        value.splice(value.indexOf(cls), 1);
        lastDomConfig[propertyName] = value.join(' ');
      }
    } else if (Array.isArray(propertyValue)) {
      if (propertyValue.includes(cls)) {
        propertyValue.splice(propertyValue.indexOf(cls), 1);
      }
    } else if (propertyValue.isDomClassList) {
      propertyValue.remove(cls);
    } else if (_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isObject(propertyValue)) {
      delete propertyValue[cls];
    }
  }
};
/**
 * A utility class for syncing DOM config objects to DOM elements. Syncing compares the new config with the previously
 * used for that element, only applying the difference. Very much like a virtual DOM approach on a per element basis
 * (element + its children).
 *
 * Usage example:
 *
 * ```javascript
 * DomSync.sync({
 *     domConfig: {
 *         className : 'b-outer',
 *         children : [
 *             {
 *                 className : 'b-child',
 *                 html      : 'Child 1',
 *                 dataset   : {
 *                     custom : true
 *                 }
 *             },
 *             {
 *                 className : 'b-child',
 *                 html      : 'Child 2',
 *                 style     : {
 *                     fontWeight : 'bold',
 *                     color      : 'blue'
 *                 }
 *             }
 *         ]
 *     },
 *     targetElement : target
 * });
 * ```
 */


class DomSync {
  /**
   * Compares two DOM configs or properties of such objects for equality.
   * @param {Object} is The new value.
   * @param {Object} was The old value.
   * @param {Object} options An object with various options to control the comparison.
   * @param {Object} options.ignore An object containing names of attributes to ignore having `true` value.
   * @param {Map} options.equalityCache A map that can be used to record equality results for objects to avoid
   * recomputing the result for the same objects.
   * @param {Set} options.refsFound A Set that must be populated with the values of any `reference` properties found.
   * @param {Boolean|String} [ignoreRefs] Pass `true` to ignore `reference` properties on domConfigs. Pass `'children'`
   * to ignore `reference` properties only on child element configs.
   * @returns {Boolean}
   * @private
   */
  static checkEquality(is, was, options, ignoreRefs) {
    if (is === was) {
      return true;
    } // For purposes of DomSync, null and undefined are equivalent


    if (is == null) {
      return was == null;
    }

    if (!is || !was) {
      return false; // false since is !== was and is != null (we get here if was == null)
    }

    const typeA = typeof is,
          typeB = typeof was;

    if (typeA !== typeB || simpleTypes[typeA]) {
      // only test simpleTypes[typeA] since typeA === typeB
      return false;
    } // a and b are distinct objects or maybe arrays


    let cache = options.equalityCache || (options.equalityCache = new Map()),
        ignoreChildRefs = Boolean(ignoreRefs),
        equal,
        i,
        ignore,
        ignoreRefOpt,
        key,
        syncOptions,
        val; // We must cache results based on both sides of the comparison. If we only cache the result of "is" vs
    // any other value, we get failures in SchedulerWithAutoCommitStore.t.js

    cache = cache.get(is) || cache.set(is, new Map()).get(is);
    equal = cache.get(was);

    if (equal === undefined) {
      equal = true;

      if (getPrototypeOf(is) !== getPrototypeOf(was) || is instanceof Node) {
        // Two Nodes are not equal since they are !==
        equal = false;
      } else if (Array.isArray(is)) {
        // Since we have === prototypes, we know that "was" is also an array
        i = is.length;

        if (i !== was.length) {
          equal = false;
        } else {
          while (i-- > 0) {
            if (!DomSync.checkEquality(is[i], was[i], options, ignoreChildRefs)) {
              equal = false;
              break;
            }
          }
        }
      } else {
        var _syncOptions;

        syncOptions = is.syncOptions;
        ignoreRefOpt = (_syncOptions = syncOptions) === null || _syncOptions === void 0 ? void 0 : _syncOptions.ignoreRefs;

        if (ignoreRefOpt) {
          ignoreChildRefs = true;
          ignoreRefs = ignoreRefOpt !== 'children';
        }

        ignore = options.ignore || emptyObject; // We have 2 objects w/same prototype and that are not HTML nodes
        // https://jsbench.me/n2kgfre1r5/1 - profiles for-in-object loops vs for loop over keys array
        // fwiw, the smaller the object, the greater the benefit of for-in loop

        for (key in was) {
          if (!ignore[key] && !(key in is) && !(ignoreRefs && key === 'reference')) {
            equal = false;
            break;
          }
        }

        if (equal) {
          if (toString.call(was) === '[object Date]') {
            // Since we have === prototypes, we know that "was" is also a Date
            equal = is.getTime() === was.getTime();
          } else {
            for (key in is) {
              if (!ignore[key] && !(ignoreRefs && key === 'reference')) {
                if (!(key in was)) {
                  equal = false;
                  break;
                }

                val = is[key]; // Per Johan:
                //  Not sure we still use DocumentFragment. Used to be part of event rendering earlier,
                //  but I think I have refactored it away. Worth checking
                //  ...
                //  Not finding any usages
                //
                // DocumentFragment, compare separately supplied html
                // if (key === 'html' && typeof val !== 'string' && `compareHtml` in is) {
                //     if (is.compareHtml === was.compareHtml) {
                //         continue;
                //     }
                // }

                if (!DomSync.checkEquality(val, was[key], options, ignoreChildRefs)) {
                  equal = false;
                  break;
                }
              }
            }
          }
        }
      }

      if (!ignoreRefs && isObject(is) && is.reference) {
        var _options$refsFound;

        // We need to track object w/reference properties to know what reference elements may have
        // been removed since we may skip synchronizing them.
        (_options$refsFound = options.refsFound) === null || _options$refsFound === void 0 ? void 0 : _options$refsFound.add(is.reference);
      }

      cache.set(was, equal);
    }

    return equal;
  }
  /**
   * Sync a DOM config to a target element
   * @param {Object} options Options object
   * @param {DomConfig} options.domConfig A DOM config object
   * @param {HTMLElement} options.targetElement Target element to apply to
   * @param {Boolean} [options.strict=false] Specify `true` to limit synchronization to only the values set by
   * previous calls. Styles and classes placed directly on the DOM elements by other means will not be affected.
   * @param {String} [options.syncIdField] Field in dataset to use to match elements for re-usage
   * @param {String|String[]} [options.affected] The references affected by a partial sync.
   * @param {Function} [options.callback] A function that will be called on element re-usage, creation and similar
   * @param {Boolean} [options.configEquality] A function that will be called to compare an incoming config to
   * the last config applied to the `targetElement`. This function returns `true` if the passed values are equal and
   * `false` otherwise.
   * @returns {HTMLElement} Returns the updated target element (which is also updated in place)
   */


  static sync(options) {
    const optionsIn = options,
          {
      refOwner
    } = options,
          refsWas = refOwner === null || refOwner === void 0 ? void 0 : refOwner.byRef,
          checkEqualityOptions = makeCheckEqualityOptions();
    let affected = options.affected,
        i,
        ref,
        targetNode,
        lastDomConfig;

    if (typeof affected === 'string') {
      affected = [affected];
    } // NOTE: it is possible to reenter this method in at least the following way:
    //   - sync() causes a focus change by manipulating the activeElement.
    //   - a focus/blur/focusin/out event causes a widget config to initiate a recompose.
    //   - the event also triggers code that forces the recompose to flush (e.g., by using a reference el).


    options = _objectSpread(_objectSpread({}, options), {}, {
      checkEqualityOptions
    });

    if (refOwner) {
      // We always rebuild the byRef map on each call
      refOwner.byRef = {};

      if (affected) {
        // We need to preserve all previously rendered refs that are not going to be affected by this partial
        // update...
        for (ref in refsWas) {
          if (!affected.includes(ref)) {
            refOwner.byRef[ref] = refsWas[ref];
          }
        }
      }

      options.refsWas = refsWas;
    } // performSync() returns false if nothing was done because the configs were equal... we bend the rules on
    // modifying input objects so we can return this potentially important detail to our caller:


    optionsIn.changed = DomSync.performSync(options, options.targetElement);

    if (refOwner) {
      if (!affected) {
        affected = Object.keys(refsWas);
      }

      for (i = 0; i < affected.length; ++i) {
        ref = affected[i];
        targetNode = refsWas[ref];

        if (checkEqualityOptions.refsFound.has(ref) || targetNode.retainElement) {
          refOwner.byRef[ref] = targetNode;
        } else {
          lastDomConfig = targetNode.lastDomConfig;
          targetNode.remove();
          refOwner.detachRef(ref, targetNode, lastDomConfig);
        }
      }
    }

    return options.targetElement;
  }

  static performSync(options, targetElement) {
    const {
      domConfig,
      callback
    } = options,
          {
      lastDomConfig
    } = targetElement,
          configIsEqual = options.configEquality || DomSync.checkEquality;

    if (!configIsEqual(domConfig, lastDomConfig, options.checkEqualityOptions, options.ignoreRefs)) {
      if (domConfig) {
        // Sync without affecting the containing element?
        if (!domConfig.onlyChildren) {
          DomSync.syncAttributes(domConfig, targetElement, options);
          DomSync.syncContent(domConfig, targetElement);
        }

        DomSync.syncChildren(options, targetElement);
      } // Allow null to clear html
      else {
        targetElement.innerHTML = null;
        targetElement.syncIdMap = null;
      } // Cache the config on the target for future comparison


      targetElement.lastDomConfig = !(domConfig !== null && domConfig !== void 0 && domConfig.onlyChildren && lastDomConfig) ? domConfig : _objectSpread(_objectSpread({}, lastDomConfig), {}, {
        children: domConfig.children
      });
      return true;
    } else {
      // Sync took no action, notify the world
      callback === null || callback === void 0 ? void 0 : callback({
        action: 'none',
        domConfig,
        targetElement
      });
    }

    return false;
  } //region Attributes


  static syncDataset(domConfig, targetElement) {
    const {
      lastDomConfig
    } = targetElement,
          sameConfig = domConfig === lastDomConfig,
          source = Object.keys(domConfig.dataset),
          target = lastDomConfig && lastDomConfig.dataset && Object.keys(lastDomConfig.dataset),
          delta = _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].delta(source, target);
    let attr, i, name, value; // New attributes in dataset

    for (i = 0; i < delta.onlyInA.length; i++) {
      attr = delta.onlyInA[i];
      value = domConfig.dataset[attr]; // Prevent data-property="null" or data-property="undefined"

      if (value != null) {
        targetElement.setAttribute(`data-${_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].hyphenate(attr)}`, value);
      }
    } // Might have changed


    for (i = 0; i < delta.inBoth.length; i++) {
      attr = delta.inBoth[i];
      value = domConfig.dataset[attr]; // Intentional != since dataset is always string but want numbers to match
      // noinspection EqualityComparisonWithCoercionJS

      if (sameConfig || value != lastDomConfig.dataset[attr]) {
        name = `data-${_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].hyphenate(attr)}`;

        if (value == null) {
          targetElement.removeAttribute(name);
        } else {
          targetElement.setAttribute(name, value);
        }
      }
    } // Removed


    for (i = 0; i < delta.onlyInB.length; i++) {
      targetElement.removeAttribute(`data-${_StringHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].hyphenate(delta.onlyInB[i])}`);
    }
  }
  /**
   * Adds CSS classes to the element and to the cache.
   * @param {Core.helper.util.DomClassList|String|String[]|Object} cls
   * @param {HTMLElement} targetElement A previously DomSynced element
   * @internal
   */


  static addCls(cls, targetElement) {
    const {
      lastDomConfig
    } = targetElement;
    cls = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalize(cls, 'array');
    cls.forEach(cls => {
      targetElement.classList.add(cls);
      addAndCacheCls(cls, lastDomConfig);
    });
  }
  /**
   * Adds CSS classes from the element and from the cache.
   * @param {Core.helper.util.DomClassList|String|String[]|Object} cls
   * @param {HTMLElement} targetElement A previously DomSynced element
   * @internal
   */


  static removeCls(cls, targetElement) {
    const {
      lastDomConfig
    } = targetElement;
    cls = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalize(cls, 'array');
    cls.forEach(cls => {
      targetElement.classList.remove(cls);
      removeAndUncacheCls(cls, lastDomConfig);
    });
  }

  static syncClassList(domConfig, targetElement, lastDomConfig) {
    let cls = domConfig.className || domConfig.class,
        c,
        currentClasses,
        i,
        k,
        keep,
        last;

    if (lastDomConfig) {
      // NOTE: The following reads the DOM to determine classes that may have been added by other means. This
      //  diff is only enabled when "strict" is used (see our callers)
      currentClasses = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalize(targetElement, 'array');
      cls = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalize(cls, 'object');
      last = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalize(lastDomConfig.className || lastDomConfig.class, 'object');
      keep = [];

      for (i = 0, k = currentClasses.length; i < k; ++i) {
        c = currentClasses[i]; // We want to keep classes not in cls if we didn't add them last time

        if (cls[c] || !(c in last)) {
          last[c] = 1;
          keep.push(c);
        }
      }

      for (c in cls) {
        if (!last[c]) {
          keep.push(c);
        }
      }

      cls = keep.join(' ');
    } else {
      cls = _util_DomClassList_js__WEBPACK_IMPORTED_MODULE_2__["default"].normalize(cls); // to string
    }

    targetElement.setAttribute('class', cls);
  } // Attributes as map { attr : value, ... }


  static getSyncAttributes(domConfig) {
    const attributes = {},
          // Attribute names, simplifies comparisons and calls to set/removeAttribute
    names = []; // On a first sync, there are no domConfig on the target element yet

    if (domConfig) {
      Object.keys(domConfig).forEach(attr => {
        if (!syncIgnoreAttributes[attr]) {
          const name = attr.toLowerCase();
          attributes[name] = domConfig[attr];
          names.push(name);
        }
      });
    }

    return {
      attributes,
      names
    };
  }

  static syncAttributes(domConfig, targetElement, options) {
    const {
      lastDomConfig
    } = targetElement,
          // If the same config has come through, due to configEquality, we must update all attrs.
    sameConfig = domConfig === lastDomConfig,
          sourceSyncAttrs = DomSync.getSyncAttributes(domConfig),
          // Extract attributes from elements (sourceElement might be a config)
    {
      attributes: sourceAttributes,
      names: sourceNames
    } = sourceSyncAttrs,
          {
      attributes: targetAttributes,
      names: targetNames
    } = sameConfig ? sourceSyncAttrs : DomSync.getSyncAttributes(lastDomConfig),
          // Intersect arrays to determine what needs adding, removing and syncing
    {
      onlyInA: toAdd,
      onlyInB: toRemove,
      inBoth: toSync
    } = sameConfig ? {
      onlyInA: emptyArray,
      onlyInB: emptyArray,
      inBoth: sourceNames
    } : _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].delta(sourceNames, targetNames);
    let attr, i; // Add new attributes

    for (i = 0; i < toAdd.length; i++) {
      attr = toAdd[i];
      const sourceAttr = sourceAttributes[attr]; // Style requires special handling

      if (attr === 'style' && sourceAttr != null) {
        // TODO: Do diff style apply also instead of this replace
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].applyStyle(targetElement, sourceAttr, true);
      } // So does dataset
      else if (attr === 'dataset') {
        DomSync.syncDataset(domConfig, targetElement);
      } // And class, which might be an object
      else if (isClass[attr]) {
        DomSync.syncClassList(domConfig, targetElement);
      } // Other attributes are set using setAttribute (since it calls toString() DomClassList works fine),
      // unless they are undefined in which case they are ignored to not get `href="undefined"` etc
      else if (sourceAttr != null) {
        targetElement.setAttribute(attr, sourceAttr);
      }
    } // Removed no longer used attributes


    for (i = 0; i < toRemove.length; i++) {
      targetElement.removeAttribute(toRemove[i]);
    } // TODO: toAdd and toSync are growing very alike, consider merging
    // Sync values for all other attributes


    for (i = 0; i < toSync.length; i++) {
      attr = toSync[i];
      const sourceAttr = sourceAttributes[attr],
            targetAttr = targetAttributes[attr]; // Attribute value null means remove attribute

      if (sourceAttr == null) {
        targetElement.removeAttribute(attr);
      } // Set all attributes that has changed, with special handling for style.
      else if (attr === 'style') {
        if (options.strict) {
          if (sameConfig) {
            DomSync.syncStyles(targetElement, sourceAttr);
          } else if (!isEqual(sourceAttr, targetAttr, true)) {
            DomSync.syncStyles(targetElement, sourceAttr, targetAttr);
          }
        } else if (sameConfig || !isEqual(sourceAttr, targetAttr, true)) {
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].applyStyle(targetElement, sourceAttr, true);
        }
      } // And dataset
      else if (attr === 'dataset') {
        DomSync.syncDataset(domConfig, targetElement);
      } // And class, which might be an object
      else if (isClass[attr]) {
        DomSync.syncClassList(domConfig, targetElement, options.strict && targetElement.lastDomConfig);
      } else if (sameConfig || sourceAttr !== targetAttr) {
        targetElement.setAttribute(attr, sourceAttr);
      }
    }
  }

  static syncStyles(targetElement, sourceAttr, targetAttr) {
    let styles, key, value;

    if (!targetAttr) {
      styles = sourceAttr;
    } else {
      styles = {}; // Style could be a string so we parse it to object to iterate over it's properties correctly

      sourceAttr = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parseStyle(sourceAttr);
      targetAttr = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parseStyle(targetAttr);

      if (sourceAttr) {
        for (key in sourceAttr) {
          value = sourceAttr[key];

          if (targetAttr[key] !== value) {
            styles[key] = value;
          }
        }
      }

      for (key in targetAttr) {
        if (!(key in sourceAttr)) {
          styles[key] = '';
        }
      }
    }

    _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].applyStyle(targetElement, styles);
  } //endregion
  //region Content


  static syncContent(domConfig, targetElement) {
    const {
      html,
      text
    } = domConfig,
          content = text !== null && text !== void 0 ? text : html; // elementData holds custom data that we want to attach to the element (not visible in dom)

    if (domConfig.elementData) {
      targetElement.elementData = domConfig.elementData;
    } // Apply html from config


    if (content instanceof DocumentFragment) {
      // If given a DocumentFragment, replace content with it
      if (targetElement.childNodes.length === 1 && _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getChildElementCount(targetElement) === 0 && content.childNodes.length === 1 && _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getChildElementCount(content) === 0) {
        // Syncing a textNode to a textNode? Use shortcut
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setInnerText(targetElement, content.firstChild.data);
      } else {
        targetElement.innerHTML = '';
        targetElement.appendChild(content);
      }
    } // If content is likely html we set innerHTML
    else if (html != null && htmlRe.test(html)) {
      targetElement.innerHTML = String(html); // convert numbers to strings
    } else if (content != null) {
      var _lastDomConfig$childr;

      const {
        lastDomConfig
      } = targetElement; // If element had children or actual html content in last sync we force innerHTML to get rid of them

      if (lastDomConfig !== null && lastDomConfig !== void 0 && (_lastDomConfig$childr = lastDomConfig.children) !== null && _lastDomConfig$childr !== void 0 && _lastDomConfig$childr.length || lastDomConfig !== null && lastDomConfig !== void 0 && lastDomConfig.html && htmlRe.test(targetElement.lastDomConfig.html)) {
        targetElement.innerHTML = content;
      } // Otherwise we try to update the text as cheaply as possible (node data if possible)
      else {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setInnerText(targetElement, String(content));
      }
    }
  }

  static insertTextNode(text, targetElement, callback, refOwner, beforeElement = null) {
    const newNode = document.createTextNode(text);
    targetElement.insertBefore(newNode, beforeElement);

    if (refOwner) {
      newNode.$refOwnerId = refOwner.id;
    }

    callback === null || callback === void 0 ? void 0 : callback({
      action: 'newNode',
      domConfig: text,
      targetElement: newNode
    });
  }

  static insertElement(domConfig, targetElement, targetNode, refOwner, syncIdMap, syncId, options) {
    var _options$callback;

    // Create a new element
    const newElement = options.ns ? document.createElementNS(options.ns, domConfig.tag || 'svg') : document.createElement(domConfig.tag || 'div'); // Insert (or append if no targetNode)

    targetElement.insertBefore(newElement, targetNode); // Sync to it

    DomSync.performSync(options, newElement);

    if (syncId != null) {
      syncIdMap[syncId] = newElement;
    }

    if (refOwner) {
      newElement.$refOwnerId = refOwner.id;

      if (syncId) {
        newElement.$reference = syncId;
        refOwner.attachRef(syncId, newElement, domConfig);
      }
    }

    (_options$callback = options.callback) === null || _options$callback === void 0 ? void 0 : _options$callback.call(options, {
      action: 'newElement',
      domConfig,
      targetElement: newElement,
      syncId
    });
  } //endregion
  //region Children


  static syncChildren(options, targetElement) {
    var _domConfig$html, _syncOptions$ignoreRe;

    let {
      // eslint-disable-next-line prefer-const
      domConfig,
      syncIdField,
      callback,
      releaseThreshold,
      configEquality,
      ns,
      refOwner,
      refsWas,
      strict,
      checkEqualityOptions,
      ignoreRefs
    } = options,
        syncOptions = domConfig.syncOptions || {},
        // eslint-disable-line prefer-const
    cleanupNodes = null,
        index,
        nextNode,
        syncId; // Having specified html or text replaces all inner content, no point in syncing

    if ((_domConfig$html = domConfig.html) !== null && _domConfig$html !== void 0 ? _domConfig$html : domConfig.text) {
      return;
    } // This will affect the whole subtree since this goes into syncChildOptions (we convert 'children' to true
    // here because we are only processing the children):


    ignoreRefs = Boolean((_syncOptions$ignoreRe = syncOptions.ignoreRefs) !== null && _syncOptions$ignoreRe !== void 0 ? _syncOptions$ignoreRe : ignoreRefs);

    if (ignoreRefs) {
      refOwner = refsWas = null;
    }

    if ('strict' in syncOptions) {
      strict = syncOptions.strict;
    }

    const // Always repopulate the map, since elements might get used by other syncId below
    newSyncIdMap = refOwner ? refOwner.byRef : {},
          sourceConfigs = arraySlice.call(domConfig.children || []),
          targetNodes = arraySlice.call(targetElement.childNodes),
          syncIdMap = refsWas || targetElement.syncIdMap || {},
          releasedIdMap = targetElement.releasedIdMap || {},
          nextTarget = remove => {
      // Recursive calls to performSync can teleport elements around the DOM tree (when we are given
      // the DOM nodes in the domConfig), so be sure to skip over any elements that are no longer children
      // of our targetElement
      while (targetNodes.length && targetNodes[0].parentNode !== targetElement) {
        targetNodes.shift();
      }

      return (remove ? targetNodes.shift() : targetNodes[0]) || null;
    }; // Each level can optionally specify its own syncIdField, strict and callback, if left out parent levels will be used


    syncIdField = syncOptions.syncIdField || syncIdField;
    strict = syncOptions.strict || strict;
    callback = syncOptions.callback || callback;
    configEquality = syncOptions.configEquality || configEquality; // Make sure releaseThreshold 0 is respected...

    releaseThreshold = 'releaseThreshold' in syncOptions ? syncOptions.releaseThreshold : releaseThreshold;

    if (syncIdField) {
      targetElement.syncIdMap = newSyncIdMap;
    } // Settings to use in all syncs below


    const syncChildOptions = {
      checkEqualityOptions: checkEqualityOptions || makeCheckEqualityOptions(),
      ignoreRefs,
      refOwner,
      refsWas,
      strict,
      syncIdField,
      releaseThreshold,
      callback,
      configEquality
    };

    while (sourceConfigs.length) {
      const sourceConfig = sourceConfigs.shift();
      syncId = null; // Allowing null, convenient when using Array.map() to generate children

      if (!sourceConfig) {
        continue;
      }

      if (sourceConfig instanceof Node) {
        nextNode = nextTarget(); // Widgets may supply the element of another widget in their rendering... just insert it and move on

        if (sourceConfig !== nextNode) {
          targetElement.insertBefore(sourceConfig, nextNode);
        }

        index = targetNodes.indexOf(sourceConfig);

        if (index > -1) {
          targetNodes.splice(index, 1);
        }

        continue;
      }

      const isTextNode = typeof sourceConfig === 'string'; // Used in all syncs

      syncChildOptions.domConfig = sourceConfig;
      syncChildOptions.ns = sourceConfig.ns || ns;

      if (!isTextNode) {
        // If syncIdField was supplied, we should first try to reuse element with
        // matching "id"
        if (refOwner) {
          syncId = sourceConfig.reference;
        } else if (syncIdField && sourceConfig.dataset) {
          syncId = sourceConfig.dataset[syncIdField];
        } // We have an id to look for


        if (syncId != null && !sourceConfig.unmatched) {
          // Find any matching element, either in use or previously released
          const syncTargetElement = syncIdMap[syncId] || releasedIdMap[syncId];

          if (syncTargetElement) {
            const {
              lastDomConfig
            } = syncTargetElement; // Just relink if flagged with `retainElement` (for example during dragging)

            if (syncTargetElement.retainElement) {// DomSync.relinkElements(syncChildOptions.domConfig, syncTargetElement);
            } // Otherwise sync with the matched element
            else if (DomSync.performSync(syncChildOptions, syncTargetElement)) {
              var _callback;

              // Sync took some action, notify the world
              (_callback = callback) === null || _callback === void 0 ? void 0 : _callback({
                action: 'reuseOwnElement',
                domConfig: sourceConfig,
                targetElement: syncTargetElement,
                lastDomConfig,
                syncId
              });
            } // Since it wont sync above when flagged to be retained, we need to apply the flag here


            if (sourceConfig.retainElement) {
              syncTargetElement.retainElement = true;
            } // Cache the element on the syncIdMap for faster retrieval later


            newSyncIdMap[syncId] = syncTargetElement; // Remove target from targetElements & release tracking, no-one else is allowed to sync with it

            _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].remove(targetNodes, syncTargetElement);
            delete releasedIdMap[syncId];
            syncTargetElement.isReleased = false;
            nextNode = nextTarget();

            if (syncTargetElement.parentNode !== targetElement || strict && syncTargetElement.nextSibling !== nextNode) {
              targetElement.insertBefore(syncTargetElement, nextNode);
            }
          } else if (strict) {
            DomSync.insertElement(sourceConfig, targetElement, nextTarget(), refOwner, newSyncIdMap, syncId, syncChildOptions);
          } else {
            // No match, move to end of queue to not steal some one else's element
            sourceConfigs.push(sourceConfig); // Also flag as unmatched to know that when we reach this element again

            sourceConfig.unmatched = true;
          } // Node handled, carry on with next one


          continue;
        } // Avoid polluting the config object when done


        if (sourceConfig.unmatched) {
          delete sourceConfig.unmatched;
        }
      } // Skip over any retained elements


      let beforeNode = null,
          targetNode = null,
          cleanupNode;

      while (!targetNode && (cleanupNode = nextTarget(true))) {
        if (refOwner) {
          // When syncing for a refOwner, foreign elements are skipped.
          if (cleanupNode.$refOwnerId !== refOwner.id) {
            continue;
          }

          if (cleanupNode.$reference) {
            // In refOwner mode we always pass strict:true, so this won't happen... but if it did, the
            // idea is that ref els do not get cleaned up until the end of the sync process.
            if (!strict) {
              continue;
            } // Since we want to maintain DOM order, this ref el marks the spot where to insert. We also
            // don't want to put it into cleanupNodes (see above). We cannot reuse ref els.


            beforeNode = cleanupNode;
            break;
          } // The element is owned by this refOwner and not assigned a reference...
          // We can reuse it


          targetNode = cleanupNode;
        } else if (!cleanupNode.retainElement) {
          targetNode = cleanupNode;
        }

        if (!targetNode) {
          (cleanupNodes || (cleanupNodes = [])).push(cleanupNode);
        }
      }

      if (beforeNode || !targetNode) {
        if (isTextNode) {
          DomSync.insertTextNode(sourceConfig, targetElement, callback, refOwner, beforeNode);
        } else {
          // Will append if beforeNode === null
          DomSync.insertElement(sourceConfig, targetElement, beforeNode, refOwner, newSyncIdMap, syncId, syncChildOptions);
        }
      } // We have targets left
      else {
        // Matching element tag, sync it
        if (!isTextNode && targetNode.nodeType === Node.ELEMENT_NODE && (sourceConfig.tag || 'div').toLowerCase() === targetNode.tagName.toLowerCase()) {
          var _lastDomConfig$datase, _callback2;

          const {
            lastDomConfig
          } = targetNode,
                result = DomSync.performSync(syncChildOptions, targetNode); // Remove reused element from release tracking

          if (syncIdField && (lastDomConfig === null || lastDomConfig === void 0 ? void 0 : (_lastDomConfig$datase = lastDomConfig.dataset) === null || _lastDomConfig$datase === void 0 ? void 0 : _lastDomConfig$datase[syncIdField]) != null) {
            delete releasedIdMap[lastDomConfig.dataset[syncIdField]];
          }

          if (syncId != null) {
            newSyncIdMap[syncId] = targetNode;
          }

          targetNode.isReleased = false; // Only use callback if sync succeeded (anything changed)

          result && ((_callback2 = callback) === null || _callback2 === void 0 ? void 0 : _callback2({
            action: 'reuseElement',
            domConfig: sourceConfig,
            targetElement: targetNode,
            lastDomConfig,
            syncId
          }));
        } // Text node to text node, change text :)
        else if (isTextNode && targetNode.nodeType === Node.TEXT_NODE) {
          targetNode.data = sourceConfig; // Not using callback for updating text of node, have no usecase for it currently
        } // Not matching, replace it
        else {
          if (isTextNode) {
            DomSync.insertTextNode(sourceConfig, targetElement, callback, refOwner, targetNode);
          } else {
            // Will insert
            DomSync.insertElement(sourceConfig, targetElement, targetNode, refOwner, newSyncIdMap, syncId, syncChildOptions);
          }

          targetNode.remove();
        }
      }
    } // while (sourceConfigs.length)
    // Out of source nodes, remove remaining target nodes


    while (nextNode = nextTarget(true)) {
      // Any remaining nodes that belong to this refOwner need to be cleaned up. If
      // they have an assigned reference, however, they will be handled at the very
      // end of the sync process since those elements can move in the node hierarchy.
      if (!refOwner || nextNode.$refOwnerId === refOwner.id && !nextNode.$reference) {
        (cleanupNodes || (cleanupNodes = [])).push(nextNode);
      }
    }

    if (cleanupNodes) {
      DomSync.syncChildrenCleanup(targetElement, cleanupNodes, newSyncIdMap, callback, refOwner, releaseThreshold, syncIdField);
    }
  }

  static syncChildrenCleanup(targetElement, cleanupNodes, newSyncIdMap, callback, refOwner, releaseThreshold, syncIdField) {
    let releaseCount = 0,
        ref;

    for (const targetNode of cleanupNodes) {
      const {
        lastDomConfig
      } = targetNode; // Element might be retained, hands off (for example while dragging)

      if (!targetNode.retainElement) {
        // When using syncId to reuse elements, "release" left over elements instead of removing them, up to a
        // limit specified as releaseThreshold, above which elements are removed instead
        if (!refOwner && syncIdField && (releaseThreshold == null || releaseCount < releaseThreshold)) {
          // Prevent releasing already released element
          if (!targetNode.isReleased) {
            targetNode.className = 'b-released';
            targetNode.isReleased = true; // Store released element in syncIdMap, to facilitate reusing it for self later

            if (lastDomConfig !== null && lastDomConfig !== void 0 && lastDomConfig.dataset) {
              if (!targetElement.releasedIdMap) {
                targetElement.releasedIdMap = {};
              }

              targetElement.releasedIdMap[lastDomConfig.dataset[syncIdField]] = targetNode;
            }

            callback === null || callback === void 0 ? void 0 : callback({
              action: 'releaseElement',
              domConfig: lastDomConfig,
              lastDomConfig,
              targetElement: targetNode
            }); // Done after callback on purpose, to allow checking old className

            if (lastDomConfig) {
              // Make sure lastDomConfig differs even from the same domConfig applied again
              // Do not want to discard it completely since it is needed for diff when reused later
              lastDomConfig.isReleased = true; // To force reapply of classes on reuse

              if (lastDomConfig.className) {
                lastDomConfig.className = 'b-released';
              }

              if (lastDomConfig.class) {
                lastDomConfig.class = 'b-released';
              } // Same for style
              // (for elements positioned using style, when moved in a non DomSync way, aka EventDrag)


              if (lastDomConfig.style) {
                lastDomConfig.style = null;
              }
            }
          }

          releaseCount++;
        } // In normal sync mode, remove left overs
        else {
          targetNode.remove();

          if (refOwner) {
            ref = targetNode.$reference;

            if (ref) {
              refOwner.detachRef(ref, targetNode, lastDomConfig);
            }
          } // Remove from "release tracking"


          if (targetElement.releasedIdMap && syncIdField && lastDomConfig !== null && lastDomConfig !== void 0 && lastDomConfig.dataset) {
            delete targetElement.releasedIdMap[lastDomConfig.dataset[syncIdField]];
          }

          callback === null || callback === void 0 ? void 0 : callback({
            action: 'removeElement',
            domConfig: targetNode.lastDomConfig,
            lastDomConfig: targetNode.lastDomConfig,
            targetElement: targetNode
          });
        }
      } else if (syncIdField) {
        // Keep retained element in map
        if (lastDomConfig) {
          newSyncIdMap[targetNode.dataset[syncIdField]] = targetNode;
        }
      }
    }
  }
  /**
   * Remove a child element without syncing, for example when dragging an element to some other parent.
   * Removes it both from DOM and the parent elements syncMap
   * @param {HTMLElement} parentElement
   * @param {HTMLElement} childElement
   */


  static removeChild(parentElement, childElement) {
    if (parentElement.contains(childElement)) {
      const syncIdMap = parentElement.syncIdMap;

      if (syncIdMap) {
        const index = Object.values(syncIdMap).indexOf(childElement);

        if (index > -1) {
          delete syncIdMap[Object.keys(syncIdMap)[index]];
        }
      }

      parentElement.removeChild(childElement);
    }
  }
  /**
   * Adds a child element without syncing, making it properly available for later syncs. Useful for example
   * when dragging and dropping an element from some other parent.
   * @param {HTMLElement} parentElement
   * @param {HTMLElement} childElement
   * @param {String|Number} syncId
   */


  static addChild(parentElement, childElement, syncId) {
    parentElement.appendChild(childElement);
    parentElement.syncIdMap[syncId] = childElement;
  }
  /**
   * Get a child element using a dot separated syncIdMap path.
   *
   * ```javascript
   * DomSync.getChild(eventWrap, 'event.percentBar');
   * ```
   *
   * @param {HTMLElement} element "root" element, under which the path starts
   * @param {String} path Dot '.' separated path of syncIdMap entries
   * @returns {HTMLElement} Child element or `null` if path did not match any element
   */


  static getChild(element, path) {
    const syncIds = String(path).split('.');

    for (const id of syncIds) {
      var _element, _element$syncIdMap;

      element = (_element = element) === null || _element === void 0 ? void 0 : (_element$syncIdMap = _element.syncIdMap) === null || _element$syncIdMap === void 0 ? void 0 : _element$syncIdMap[id];

      if (!element) {
        return null;
      }
    }

    return element;
  } //endregion


}
DomSync._$name = 'DomSync';

/***/ }),

/***/ "./lib/Core/helper/DragHelper.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/DragHelper.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragHelper; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _mixin_DragHelperContainer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/DragHelperContainer.js */ "./lib/Core/helper/mixin/DragHelperContainer.js");
/* harmony import */ var _mixin_DragHelperTranslate_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/DragHelperTranslate.js */ "./lib/Core/helper/mixin/DragHelperTranslate.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _EventHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';








 //TODO: add touch support
//TODO: add pointer events support

/**
 * @module Core/helper/DragHelper
 */

const rootElementListeners = {
  down: 'onMouseDown',
  move: 'onMouseMove',
  up: 'onMouseUp',
  docclick: 'onDocumentClick',
  touchstart: 'onTouchStart',
  touchmove: 'onTouchMove',
  touchend: 'onTouchEnd',
  keydown: 'onKeyDown'
};
/**
 * Helps with drag and drop. Supports two modes of dragging:
 * * `container` - moving/rearranging elements within and between specified containers
 * * `translateXY` - repositioning an element withing its container
 *
 * Usage examples:
 * ```
 * // dragging element between containers
 * let dragHelper = new DragHelper({
 *   mode       : 'container',
 *   containers : [ container1, container2 ]
 * });
 *
 * // dragging element within container
 * let dragHelper = new DragHelper({
 *   mode    : 'translateXY',
 *   targetSelector: 'div.movable'
 * });
 * ```
 * In the various Drag event handlers, you will have access to the raw DOM event and some useful `context` of the drag operation:
 *
 * ```
 *  myDrag.on({
 *      drag : ({event , context}) {
 *            // The element which we're moving, could be a cloned version of grabbed, or the grabbed element itself
 *           const element = context.element;
 *
 *           // The original mousedown element upon which triggered the drag operation
 *           const grabbed = context.grabbed;
 *
 *           // The target under the current mouse / pointer / touch position
 *           const target = context.target;
 *       }
 *  });
 * ```
 *
 * Simple drag drop with a drop target specified:
 * ```javascript
 * export default class MyDrag extends DragHelper {
 *      static get defaultConfig() {
 *          return {
 *              // Don't drag the actual cell element, clone it
 *              cloneTarget        : true,
 *              mode               : 'translateXY',
 *              // Only allow drops on DOM elements with 'yourDropTarget' CSS class specified
 *              dropTargetSelector : '.yourDropTarget',
 *
 *              // Only allow dragging elements with the 'draggable' CSS class
 *              targetSelector : '.draggable'
 *          };
 *      }
 *
 *      construct(config) {
 *          const me = this;
 *
 *          super.construct(config);
 *
 *          me.on({
 *              dragstart : me.onDragStart
 *          });
 *      }
 *
 *      onDragStart({ event, context }) {
 *          const target = context.target;
 *
 *          // Here you identify what you are dragging (an image of a user, grid row in an order table etc) and map it to something in your
 *          // data model. You can store your data on the context object which is available to you in all drag-related events
 *          context.userId = target.dataset.userId;
 *      }
 *
 *      onEquipmentDrop({ context, event }) {
 *          const me = this;
 *
 *          if (context.valid) {
 *              const userId   = context.userId,
 *                    droppedOnTarget = context.target;
 *
 *              console.log(`You dropped user ${userStore.getById(userId).name} on ${droppedOnTarget}`, droppedOnTarget);
 *
 *              // Dropped on a scheduled event, display toast
 *              WidgetHelper.toast(`You dropped user ${userStore.getById(userId).name} on ${droppedOnTarget}`);
 *
 *              // tell the drag helper the operation is finished
 *              me.context.finalize();
 *          }
 *      }
 *  };
 * ```
 *
 * @mixes Core/mixin/Events
 * @extends Core/Base
 */

class DragHelper extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"], _mixin_DragHelperContainer_js__WEBPACK_IMPORTED_MODULE_2__["default"], _mixin_DragHelperTranslate_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  //region Config
  static get defaultConfig() {
    return {
      /**
       * Drag proxy CSS class
       * @config {String}
       * @default
       * @private
       */
      dragProxyCls: 'b-drag-proxy',

      /**
       * CSS class added when drag is invalid
       * @config {String}
       * @default
       */
      invalidCls: 'b-drag-invalid',

      /**
       * CSS class added to the source element in Container drag
       * @config {String}
       * @default
       * @private
       */
      draggingCls: 'b-dragging',

      /**
       * CSS class added to the source element in Container drag
       * @config {String}
       * @default
       * @private
       */
      dropPlaceholderCls: 'b-drop-placeholder',

      /**
       * The amount of pixels to move mouse before it counts as a drag operation
       * @config {Number}
       * @default
       */
      dragThreshold: 5,

      /**
       * The outer element where the drag helper will operate (attach events to it and use as outer limit when looking for ancestors)
       * @config {HTMLElement}
       * @default
       */
      outerElement: document.body,

      /**
       * Outer element that limits where element can be dragged
       * @config {HTMLElement}
       * @default
       */
      dragWithin: null,
      monitoringConfig: null,

      /**
       * Constrain translate drag to dragWithin elements bounds (set to false to allow it to "overlap" edges)
       * @config {Boolean}
       * @default
       */
      constrain: true,

      /**
       * Smallest allowed x when dragging horizontally.
       * @config {Number}
       * @default
       */
      minX: null,

      /**
       * Largest allowed x when dragging horizontally.
       * @config {Number}
       * @default
       */
      maxX: null,

      /**
       * Smallest allowed y when dragging horizontally.
       * @config {Number}
       * @default
       */
      minY: null,

      /**
       * Largest allowed y when dragging horizontally.
       * @config {Number}
       * @default
       */
      maxY: null,

      /**
       * Enabled dragging, specify mode:
       * <table>
       * <tr><td>container<td>Allows reordering elements within one and/or between multiple containers
       * <tr><td>translateXY<td>Allows dragging within a parent container
       * </table>
       * @config {String}
       * @default
       */
      mode: null,

      /**
       * A function that determines if dragging an element is allowed. Gets called with the element as argument,
       * return true to allow dragging or false to prevent.
       * @config {Function}
       * @default
       */
      isElementDraggable: null,

      /**
       * A CSS selector used to determine if dragging an element is allowed.
       * @config {String}
       * @default
       */
      targetSelector: null,

      /**
       * A CSS selector used to determine if a drop is allowed at the current position.
       * @config {String}
       * @default
       */
      dropTargetSelector: null,

      /**
       * Set to true to clone the dragged target, and not move the actual target DOM node.
       * @config {Boolean}
       * @default
       */
      cloneTarget: false,

      /**
       * Set to true to hide the original element while dragging (applicable when `cloneTarget` is true).
       * @config {Boolean}
       * @default
       */
      hideOriginalElement: false,

      /**
       * Containers whose elements can be rearranged (and moved between the containers). Used when
       * mode is set to "container".
       * @config {HTMLElement[]}
       * @default
       */
      containers: null,

      /**
       * A CSS selector used to exclude elements when using container mode
       * @config {String}
       * @default
       */
      ignoreSelector: null,
      startEvent: null,

      /**
       * Configure as `true` to disallow dragging in the `X` axis. The dragged element will only move vertically.
       * @config {Boolean}
       * @default
       */
      lockX: false,

      /**
       * Configure as `true` to disallow dragging in the `Y` axis. The dragged element will only move horizontally.
       * @config {Boolean}
       * @default
       */
      lockY: false,

      /**
       * The amount of milliseconds to wait after a touchstart, before a drag gesture will be allowed to start.
       * @config {Number}
       * @default
       */
      touchStartDelay: 300,

      /**
       * Scroll manager of the target. If specified, scrolling while dragging is supported.
       * @config {Core.util.ScrollManager}
       */
      scrollManager: null,

      /**
       * A method provided to snap coordinates to fixed points as you drag
       * @config {Function}
       * @internal
       */
      snapCoordinates: null,
      // For the abort animation
      transitionDuration: 300,
      clickSwallowDuration: 50,
      ignoreSamePositionDrop: true,
      // for container mode
      floatRootOwner: null,
      testConfig: {
        transitionDuration: 10,
        // In Edge synthetic click events are fired asynchronously and can take considerable
        // amount of time. Setting larger click swallow timeout to make sure Edge has time to fire click event.
        // Caught by test EventDrag4.t in Edge
        clickSwallowDuration: _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isEdge ? 300 : 50
      }
    };
  } //endregion
  //region Events

  /**
   * Fired before dragging starts, return false to prevent the drag operation.
   * @preventable
   * @event beforeDragStart
   * @param {Core.helper.DragHelper} source
   * @param {Object} context
   * @param {HTMLElement} context.element The original element upon which the mousedown event triggered a drag operation
   * @param {MouseEvent|TouchEvent} event
   */

  /**
   * Fired when dragging starts.
   * @event dragStart
   * @param {Core.helper.DragHelper} source
   * @param {Object} context
   * @param {HTMLElement} context.element The element which we're moving, could be a cloned version of grabbed, or the grabbed element itself
   * @param {HTMLElement} context.grabbed The original element upon which the mousedown event triggered a drag operation
   * @param {MouseEvent|TouchEvent} event
   */

  /**
   * Fired while dragging, you can signal that the drop is valid or invalid by setting `context.valid = false;`
   * @event drag
   * @param {Core.helper.DragHelper} source
   * @param {Object} context
   * @param {HTMLElement} context.element The element which we're moving, could be a cloned version of grabbed, or the grabbed element itself
   * @param {HTMLElement} context.grabbed The original element upon which the mousedown event triggered a drag operation
   * @param {Boolean} context.valid Set this to true or false to indicate whether the drop position is valid.
   * @param {MouseEvent} event
   */
  //endregion
  //region Init

  /**
   * Initializes a new DragHelper.
   * @param {Object} config Configuration object, accepts options specified under Configs above
   * @example
   * new DragHelper({
   *   containers: [div1, div2],
   *   isElementDraggable: element => element.className.contains('handle'),
   *   outerElement: topParent,
   *   listeners: {
   *     drop: onDrop,
   *     thisObj: this
   *   }
   * });
   * @function constructor
   */


  construct(config) {
    const me = this;
    super.construct(config);
    me.initListeners();

    if (me.mode === 'container') {
      me.initContainerDrag();
    } else if (me.mode.startsWith('translate')) {
      me.initTranslateDrag();
    }

    me.onScrollManagerScrollCallback = me.onScrollManagerScrollCallback.bind(this);
    me.initialMode = me.mode;
  }

  doDestroy() {
    // Abort dragging
    this.abort(true);
    super.doDestroy();
  }
  /**
   * Initialize listener
   * @private
   */


  initListeners() {
    const dragStartListeners = {
      element: this.outerElement,
      mousedown: rootElementListeners.down,
      thisObj: this
    };

    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isTouchDevice) {
      dragStartListeners.touchstart = rootElementListeners.touchstart;
    } // These will be autoDetached upon destroy


    _EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on(dragStartListeners);
    _EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on({
      element: window,
      blur: 'onWindowBlur',
      thisObj: this
    });
  } //endregion
  //region Events

  /**
   * Fires after drop. For valid drops, it exposes `context.async` which you can set to true to signal that additional
   * processing is needed before finalizing the drop (such as showing some dialog). When that operation is done, call
   * `context.finalize(true/false)` with a boolean that determines the outcome of the drop.
   * @event drop
   * @param {Core.helper.DragHelper} dragHelper
   * @param {Object} context
   */


  onPointerDown(event) {
    const me = this; // Visibility check is needed because mousedown on a just-created event element
    // will cause the EventEdit to cancel the add, remove the record and hide the element
    // *but* the mousedown event still bubbles to here and that will throw an error.

    if (!_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].isVisible(event.target)) {
      return;
    } // If a drag is ongoing already, finalize it and don't proceed with new drag (happens if pointerup happened
    // when current window wasn't focused - tab switch or window switch). Also handles the edge case of trying to
    // start a new drag while previous is awaiting finalization, in which case it just bails out.


    if (me.context) {
      return;
    }

    if (me.isElementDraggable && !me.isElementDraggable(event.target, event)) return;
    me.startEvent = event;
    const handled = me.mode === 'container' ? me.grabContainerDrag(event) : me.mode.startsWith('translate') ? me.grabTranslateDrag(event) : false;

    if (handled) {
      const dragListeners = {
        element: document,
        thisObj: me,
        keydown: rootElementListeners.keydown
      };

      if ('touches' in event) {
        dragListeners.touchmove = {
          handler: rootElementListeners.touchmove,
          passive: false // We need to be able to preventDefault on the touchmove

        }; // Touch desktops don't fire touchend event when touch has ended, instead pointerup is fired
        // iOS do fire touchend

        dragListeners.touchend = dragListeners.pointerup = rootElementListeners.touchend;
      } else {
        dragListeners.mousemove = rootElementListeners.move;
        dragListeners.mouseup = rootElementListeners.up;
      } // A listener detacher is returned;


      me.removeListeners = _EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on(dragListeners);

      if (me.dragWithin && me.dragWithin !== me.outerElement && me.outerElement.contains(me.dragWithin)) {
        const box = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_7__["default"].from(me.dragWithin, me.outerElement);
        me.minY = box.top;
        me.maxY = box.bottom;
        me.minX = box.left;
        me.maxX = box.right;
      }
    }
  }
  /**
   * @param event
   * @private
   */


  onTouchStart(event) {
    const me = this; // only allowing one finger for now...

    if (event.touches.length === 1) {
      me.touchStartTimer = me.setTimeout(() => {
        me.touchStartTimer = null;
      }, me.touchStartDelay, 'touchStartDelay');
      me.onPointerDown(event);
    }
  }
  /**
   * Grab draggable element on mouse down.
   * @private
   * @param event
   */


  onMouseDown(event) {
    // only dragging with left mouse button
    if (event.button === 0) {
      this.onPointerDown(event);
    }
  }

  internalMove(event) {
    const me = this,
          {
      context
    } = me,
          distance = _EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].getDistanceBetween(me.startEvent, event),
          abortTouchDrag = me.touchStartTimer && distance > me.dragThreshold;

    if (abortTouchDrag) {
      me.abort(true);
      return;
    }

    if (!me.touchStartTimer && context && context.element && // Only target Elements, not text nodes
    event.target && event.target.nodeType === Node.ELEMENT_NODE && (context.started || distance >= me.dragThreshold)) {
      if (!context.started) {
        var _me$scrollManager;

        if (me.trigger('beforeDragStart', {
          context,
          event
        }) === false) {
          return me.abort();
        }

        if (me.mode !== 'container') {
          if (me.lockY) {
            me.mode = 'translateX';
          } else if (me.lockX) {
            me.mode = 'translateY';
          } else {
            me.mode = me.initialMode;
          }
        }

        if (context.action.startsWith('translate')) {
          me.startTranslateDrag(event);
        } else if (context.action === 'container') {
          me.startContainerDrag(event);
        }

        context.started = true; // Now that the drag drop is confirmed to be starting, activate the configured scrollManager if present

        (_me$scrollManager = me.scrollManager) === null || _me$scrollManager === void 0 ? void 0 : _me$scrollManager.startMonitoring(_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].merge({
          scrollables: [{
            element: me.dragWithin || me.outerElement
          }],
          callback: me.onScrollManagerScrollCallback
        }, me.monitoringConfig)); // Global informational class for when DragHelper is dragging

        context.outermostEl = event.target.closest('.b-outer') || document.body;
        context.outermostEl.classList.add('b-draghelper-active');
        me.trigger('dragStart', {
          context,
          event
        });
      } // to prevent view drag (scroll) on ipad


      if (event.type === 'touchmove') {
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      me.update(event);
    }
  }

  onScrollManagerScrollCallback(config) {
    var _this$context;

    const {
      lastMouseMoveEvent
    } = this;

    if ((_this$context = this.context) !== null && _this$context !== void 0 && _this$context.element && lastMouseMoveEvent) {
      // Indicate that this is a 'fake' mousemove event as a result of the scrolling
      lastMouseMoveEvent.isScroll = true;
      this.update(lastMouseMoveEvent, config);
    }
  }

  onTouchMove(event) {
    this.internalMove(event);
  }
  /**
   * Move drag element with mouse.
   * @param event
   * @fires beforeDragStart
   * @fires dragStart
   * @private
   */


  onMouseMove(event) {
    this.internalMove(event);
  }
  /**
   * Updates drag, called when an element is grabbed and mouse moves
   * @private
   * @fires drag
   */


  update(event, scrollManagerConfig) {
    const me = this,
          {
      context
    } = me,
          draggingElement = context.dragProxy || context.element,
          scrollingPageElement = document.scrollingElement || document.body; // two different modes used
    // In case of scrolling need to update target element based on [X, Y] of the mouse event

    let target = !event.isScroll ? event.target : _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].elementFromPoint(event.clientX, event.clientY); // "pointer-events:none" touchmove has no effect for the touchmove event target, meaning we cannot know
    // what's under the cursor as easily in touch devices

    if (event.type === 'touchmove') {
      const touch = event.changedTouches[0];
      target = _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].elementFromPoint(touch.clientX + scrollingPageElement.scrollLeft, touch.clientY + scrollingPageElement.scrollTop);
    }

    context.target = target;

    if (me.dropTargetSelector) {
      var _target;

      context.valid = Boolean((_target = target) === null || _target === void 0 ? void 0 : _target.closest(me.dropTargetSelector));
    } else {
      // assume valid drop location
      context.valid = true;
    } // Move the drag proxy or dragged element before triggering the drag event


    if (context.action) {
      if (context.action === 'container') {
        me.updateContainerProxy(event, scrollManagerConfig);
      }

      if (context.action.startsWith('translate')) {
        // Note, if you drag an element from Container A to Container B which is scrollable (handled by ScrollManager),
        // and you notice that the proxy element follows the scroll and goes away from the cursor,
        // make sure you set `outerElement` to the container of the source element (Container A)
        // and set `constrain` to `false`.
        me.updateTranslateProxy(event, scrollManagerConfig);
      }
    } // Allow external code to validate the context before updating a container drag


    me.trigger('drag', {
      context,
      event
    }); // Move the placeholder element into its new place.
    // This will see the new state of context if mutated by a drag listener.

    if (context.action === 'container') {
      me.updateContainerDrag(event, scrollManagerConfig);
    } // change to toggle with force when not supporting IE11 any longer


    draggingElement.classList[context.valid ? 'remove' : 'add'](me.invalidCls);
    if (event) me.lastMouseMoveEvent = event;
  }
  /**
   * Abort dragging
   * @fires abort
   */


  abort(silent = false) {
    var _me$scrollManager2, _me$scrollManager2$st;

    const me = this,
          context = me.context;
    (_me$scrollManager2 = me.scrollManager) === null || _me$scrollManager2 === void 0 ? void 0 : (_me$scrollManager2$st = _me$scrollManager2.stopMonitoring) === null || _me$scrollManager2$st === void 0 ? void 0 : _me$scrollManager2$st.call(_me$scrollManager2);

    if (context) {
      // Force a synchronous layout so that transitions from this point will work.
      context.element.getBoundingClientRect(); // Aborted drag not considered valid

      context.valid = false;

      if (context.action === 'container') {
        me.abortContainerDrag(undefined, undefined, silent);
      } else {
        me.abortTranslateDrag(undefined, undefined, silent);
      }
    }

    me.reset();
  } // Empty class implementation. If listeners *are* added, the detacher is added
  // as an instance property. So this is always callable.


  removeListeners() {} // Called when a drag operation is completed, or aborted
  // Removes DOM listeners and resets context


  reset(silent) {
    const me = this,
          context = me.context;

    if (context !== null && context !== void 0 && context.started) {
      context.outermostEl.classList.remove('b-draghelper-active');
    }

    me.removeListeners();
    /**
     * Fired after a drag operation is completed or aborted
     * @event reset
     * @private
     * @param {Core.helper.DragHelper} dragHelper
     */

    if (!silent) {
      me.trigger('reset');
    }

    me.context = me.lastMouseMoveEvent = null;
  }

  onTouchEnd(event) {
    this.onMouseUp(event);
  }
  /**
   * This is a capture listener, only added during drag, which prevents a click gesture
   * propagating from the terminating mouseup gesture
   * @param {MouseEvent} event
   * @private
   */


  onDocumentClick(event) {
    event.stopPropagation();
  }
  /**
   * Drop on mouse up (if dropped on valid target).
   * @param event
   * @private
   */


  onMouseUp(event) {
    const me = this,
          context = me.context;
    me.removeListeners();

    if (context) {
      var _me$scrollManager3;

      (_me$scrollManager3 = me.scrollManager) === null || _me$scrollManager3 === void 0 ? void 0 : _me$scrollManager3.stopMonitoring();

      if (context.action === 'container') {
        me.finishContainerDrag(event);
      } else if (context.started && context.action.startsWith('translate')) {
        me.finishTranslateDrag(event);
      }

      if (context.started) {
        // Prevent the impending document click from the mouseup event from propagating
        // into a click on our element.
        _EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on({
          element: document,
          thisObj: me,
          click: rootElementListeners.docclick,
          capture: true,
          expires: me.clickSwallowDuration,
          // In case a click did not ensue, remove the listener
          once: true
        });
      } else {
        me.reset(true);
      }
    }
  }
  /**
   * Cancel on ESC key
   * @param event
   * @private
   */


  onKeyDown(event) {
    if (event.key === 'Escape') this.abort();
  }

  onWindowBlur() {
    // If window blur occurs while we are dragging (tab is switched, another window steals focus from browser)
    // pointer might be released and current window will not know about that. Thus allowing to pointerdown again
    // when focus comes back. In this case we want to let drag helper know that next pointerdown should be ignored.
    if (this.context) {
      this.abort();
    }
  }
  /**
   * Creates the proxy element to be dragged, when using {@link #config-cloneTarget}. Clones the original element by default
   */


  createProxy(element) {
    const clone = element.cloneNode(true);
    clone.removeAttribute('id');
    return clone;
  } //endregion


}
DragHelper._$name = 'DragHelper';

/***/ }),

/***/ "./lib/Core/helper/EventHelper.js":
/*!****************************************!*\
  !*** ./lib/Core/helper/EventHelper.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventHelper; });
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _util_Point_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'taskboard';







/**
 * @module Core/helper/EventHelper
 */

const touchProperties = ['clientX', 'clientY', 'pageX', 'pageY', 'screenX', 'screenY'],
      isOption = {
  element: 1,
  thisObj: 1,
  once: 1,
  delegate: 1,
  delay: 1,
  capture: 1,
  passive: 1,
  throttled: 1,
  autoDetach: 1,
  expires: 1
},
      ctrlKeyProp = {
  get: () => true
},
      normalizedKeyNames = {
  Spacebar: 'Space',
  Del: 'Delete',
  Esc: 'Escape',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown'
},
      ignoreModifierKeys = {
  Meta: 1,
  Control: 1,
  Alt: 1
},
      // Allow an unsteady finger to jiggle by this much
longpressMoveThreshold = 5;

function getAccessorFromPrototype(target, property) {
  let descriptor, accessor;

  while ((target = Object.getPrototypeOf(target)) && !accessor) {
    descriptor = Object.getOwnPropertyDescriptor(target, property);
    accessor = descriptor && descriptor.get;
  }

  return accessor;
}
/**
 * Utility methods for dealing with Events, normalizing Touch/Pointer/Mouse events.
 */


class EventHelper {
  static normalizeEvent(event) {
    return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyPropertiesIf(event, event.changedTouches[0] || event.touches[0], touchProperties);
  }
  /**
   * Returns the `[x, y]` coordinates of the event in the viewport coordinate system.
   * @param {Event} event The event
   * @return {Number[]} The coordinate.
   */


  static getXY(event) {
    if (event.touches) {
      event = event.touches[0];
    }

    return [event.clientX, event.clientY];
  }
  /**
   * Returns the pixel distance between two mouse/touch/pointer events.
   * @param {Event} event1 The first event.
   * @param {Event} event2 The second event.
   * @return {Number} The distance in pixels between the two events.
   */


  static getDistanceBetween(event1, event2) {
    const xy1 = EH.getXY(event1),
          xy2 = EH.getXY(event2); // No point in moving this to Point. We are dealing only with number values here.

    return Math.sqrt(Math.pow(xy1[0] - xy2[0], 2) + Math.pow(xy1[1] - xy2[1], 2));
  }
  /**
   * Returns a {@link Core.helper.util.Point} which encapsulates the `pageX/Y` position of the event.
   * May be used in {@link Core.helper.util.Rectangle} events.
   * @param {Event} event A browser mouse/touch/pointer event.
   * @return {Core.helper.util.Point} The page point.
   */


  static getPagePoint(event) {
    return new _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].Point(event.pageX, event.pageY);
  }
  /**
   * Returns a {@link Core.helper.util.Point} which encapsulates the `clientX/Y` position of the event.
   * May be used in {@link Core.helper.util.Rectangle} events.
   * @param {Event} event A browser mouse/touch/pointer event.
   * @return {Core.helper.util.Point} The page point.
   */


  static getClientPoint(event) {
    return new _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].Point(event.clientX, event.clientY);
  }
  /**
   * Add a listener or listeners to an element
   * @param {HTMLElement} element The element to add a listener/listeners to.
   * @param {String|Object} eventName Either a string, being the name of the event to listen for,
   * or an options object containing event names and options as keys. See the options parameter
   * for details, or the {@link #function-on-static} method for details.
   * @param {Function} [handler] If the second parameter is a string event name, this is the handler function.
   * @param {Object} [options] If the second parameter is a string event name, this is the options.
   * @param {HTMLElement} options.element The element to add the listener to.
   * @param {Object} options.thisObj The default `this` reference for all handlers added in this call.
   * @param {Boolean} [options.autoDetach=true] The listeners are automatically removed when the `thisObj` is destroyed.
   * @param {String} [options.delegate] A CSS selector string which only fires the handler when the event takes place in a matching element.
   * @param {Boolean} [options.once] Specify as `true` to have the listener(s) removed upon first invocation.
   * @param {Number} [options.delay] The number of milliseconds to delay the handler call after the event fires:
   * @param {Number|Object} [options.expires] The listener only waits for a specified time before
   * being removed. The value may be a number or an object containing an expiry handler.
   * @param {Number} [options.expires.delay] How long to wait for the event for.
   * @param {String|Function} [options.expires.alt] The function to call when the listener expires
   * **without having been triggered**.
   * @returns {Function} A detacher function which removes all the listeners when called.
   */


  static addListener(element, eventName, handler, options) {
    if (element.nodeType) {
      // All separate params, element, eventName and handler
      if (typeof eventName === 'string') {
        options = Object.assign({
          element,
          [eventName]: handler
        }, options);
      } // element, options
      else {
        options = Object.assign({
          element
        }, eventName);
      }
    } // Just an options object passed
    else {
      options = element;
    }

    return EH.on(options);
  }
  /**
   * Adds a listener or listeners to an element.
   * all property names other than the options listed below are taken to be event names,
   * and the values as handler specs.
   *
   * A handler spec is usually a function reference or the name of a function in the `thisObj`
   * option.
   *
   * But a handler spec may also be an options object containing a `handler` property which is
   * the function or function name, and local options, including `element` and `thisObj`
   * which override the top level options.
   *
   *  Usage example
   *
   * ```javascript
   * construct(config) {
   *     super.construct(config);
   *
   *     // Add auto detaching event handlers to this Widget's reference elements
   *     EventHelper.on({
   *         element : this.iconElement,
   *         click   : '_handleIconClick',
   *         thisObj : this,
   *         contextmenu : {
   *             element : document,
   *             handler : '_handleDocumentContextMenu'
   *         }
   *     });
   * }
   *```
   *
   * The `click` handler on the `iconElement` calls `this._handleIconClick`.
   *
   * The `contextmenu` handler is added to the `document` element, but the `thisObj`
   * is defaulted in from the top `options` and calls `this._handleDocumentContextMenu`.
   *
   * Note that on touch devices, `dblclick` and `contextmenu` events are synthesized.
   * Synthesized events contain a `browserEvent` property containing the final triggering
   * event of the gesture. For example a synthesized `dblclick` event would contain a
   * `browserEvent` property which is the last `touchend` event. A synthetic `contextmenu`
   * event will contain a `browserEvent` property which the longstanding `touchstart` event.
   *
   * @param {Object} options The full listener specification.
   * @param {HTMLElement} options.element The element to add the listener to.
   * @param {Object} options.thisObj The default `this` reference for all handlers added in this call.
   * @param {Boolean} [options.autoDetach=true] The listeners are automatically removed when the `thisObj` is destroyed.
   * @param {String} [options.delegate] A CSS selector string which only fires the handler when the event takes place in a matching element.
   * @param {Boolean} [options.once] Specify as `true` to have the listener(s) removed upon first invocation.
   * @param {Number} [options.delay] The number of milliseconds to delay the handler call after the event fires.
   * @param {Number} [options.throttled] For rapidly repeating events (Such as `wheel` or `scroll` or `mousemove`)
   * this is the number of milliseconds to delay subsequent handler calls after first invocation which happens immediately.
   * @param {Number|Object} [options.expires] The listener only waits for a specified time before
   * being removed. The value may be a number or an object containing an expiry handler.
   * @param {Number} [options.expires.delay] How long to wait for the event for.
   * @param {String|Function} [options.expires.alt] The function to call when the listener expires
   * **without having been triggered**.
   * @returns {Function} A detacher function which removes all the listeners when called.
   */


  static on(options) {
    const element = options.element,
          thisObj = options.thisObj,
          handlerDetails = [];

    for (const eventName in options) {
      // Only treat it as an event name if it's not a supported option
      if (!isOption[eventName]) {
        let handlerSpec = options[eventName];

        if (typeof handlerSpec !== 'object') {
          handlerSpec = {
            handler: handlerSpec
          };
        }

        const targetElement = handlerSpec.element || element; // If we need to convert taphold to an emulated contextmenu, add a wrapping function
        // in addition to the contextmenu listener. Platforms may support mouse *and* touch.

        if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isTouchDevice && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isAndroid) {
          if (eventName === 'contextmenu') {
            handlerDetails.push(EH.addElementListener(targetElement, 'touchstart', {
              handler: EH.createContextMenuWrapper(handlerSpec.handler, handlerSpec.thisObj || thisObj)
            }, options));
          }
        } // Keep track of the real handlers added.
        // addElementLister returns [ element, eventName, addedFunction, capture ]


        handlerDetails.push(EH.addElementListener(targetElement, eventName, handlerSpec, options));
      }
    }

    const detacher = () => {
      for (let handlerSpec, i = 0; i < handlerDetails.length; i++) {
        handlerSpec = handlerDetails[i];
        EH.removeEventListener(handlerSpec[0], handlerSpec[1], handlerSpec[2]);
      }

      handlerDetails.length = 0;
    }; // { autoDetach : true, thisObj : scheduler } means remove all listeners when the scheduler dies.


    if (thisObj && options.autoDetach !== false) {
      thisObj.doDestroy = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createInterceptor(thisObj.doDestroy, detacher, thisObj);
    }

    return detacher;
  }
  /**
   * Used internally to add a single event handler to an element.
   * @param {HTMLElement} element The element to add the handler to.
   * @param {String} eventName The name of the event to add a handler for.
   * @param {Function|String|Object} handlerSpec Either a function to call, or
   * the name of a function to call in the `thisObj`, or an object containing
   * the handler local options.
   * @param {Function|String} [handlerSpec.handler] Either a function to call, or
   * the name of a function to call in the `thisObj`.
   * @param {HTMLElement} [handlerSpec.element] Optionally a local element for the listener.
   * @param {Object} [handlerSpec.thisObj] A local `this` specification for the handler.
   * @param {Object} defaults The `options` parameter from the {@link #function-addListener-static} call.
   * @private
   */


  static addElementListener(element, eventName, handlerSpec, defaults) {
    const handler = EH.createHandler(element, eventName, handlerSpec, defaults),
          handlerHasPassive = ('passive' in handlerSpec),
          expires = handlerSpec.expires || defaults.expires;
    let options = handlerSpec.capture || defaults.capture; // If we are passed the passive option and the browser supports it, then convert
    // The capture option into the object options form.

    if ((handlerHasPassive || 'passive' in defaults) && _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].supportsPassive) {
      options = {
        capture: !!options,
        passive: handlerHasPassive ? handlerSpec.passive : defaults.passive
      };
    }

    element.addEventListener(eventName, handler, options);

    if (expires) {
      // Extract expires : { delay : 100, alt : 'onExpireFn' }
      const thisObj = handlerSpec.thisObj || defaults.thisObj,
            delayable = thisObj !== null && thisObj !== void 0 && thisObj.isDelayable ? thisObj : window,
            {
        alt
      } = expires,
            delay = alt ? expires.delay : expires,
            {
        spec
      } = handler; // expires is not applied with other options in createHandler(), store it here

      spec.expires = expires;
      spec.timerId = delayable[typeof delay === 'number' ? 'setTimeout' : 'requestAnimationFrame'](() => {
        spec.timerId = null;
        EH.removeEventListener(element, eventName, handler); // If we make it here and the handler has not been called, invoke the alt handler

        if (alt && !handler.called) {
          (typeof alt === 'string' ? thisObj[alt] : alt).call(thisObj);
        }
      }, delay, `listener-timer-${performance.now()}`);
    }

    return [element, eventName, handler, options];
  }

  static fixEvent(event) {
    var _event$target, _event$target2, _event$target3, _event$relatedTarget;

    const {
      type
    } = event; // Normalize key names

    if (type.startsWith('key')) {
      const normalizedKeyName = normalizedKeyNames[event.key];

      if (normalizedKeyName) {
        Object.defineProperty(event, 'key', {
          get: () => normalizedKeyName
        });
      } // Polyfill the code property for SPACE because it is not set for synthetic events.


      if (event.key === ' ' && !event.code) {
        Object.defineProperty(event, 'code', {
          get: () => 'Space'
        });
      }
    } // Sync OSX's meta key with the ctrl key. This will only happen on Mac platform.
    // It's read-only, so define a local property to return true for ctrlKey.


    if (event.metaKey && !event.ctrlKey) {
      Object.defineProperty(event, 'ctrlKey', ctrlKeyProp);
    } // When we listen to event on document and get event which bubbled from shadow dom, reading its target would
    // return shadow root element. We need actual element which started the event


    if ((_event$target = event.target) !== null && _event$target !== void 0 && _event$target.shadowRoot && event.composedPath && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11 && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isEdge) {
      const targetElement = event.composedPath()[0],
            originalTarget = event.target; // Can there be an event which actually originated from custom element, not its shadow dom?

      if (event.target !== targetElement) {
        Object.defineProperty(event, 'target', {
          get: () => targetElement,
          configurable: true
        }); // Save original target just in case

        Object.defineProperty(event, 'originalTarget', {
          get: () => originalTarget,
          configurable: true
        });
      }
    } // Chrome 78 has a bug where moving out of the left edge of an element can report a mousemove
    // with that element as the target, but offsetX as -1 and moving out the right edge can report
    // that the element is the target but an offset of the offsetWidth. Patch the event until they fix it.
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1010528
    // Tested in EventHelper.js


    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isChrome && event.target && 'offsetX' in event) {
      // Wrap reading `offsetX/Y` until this property is actually accessed in the code to avoid forced reflow.
      // To avoid getting infinite loop, property descriptor is looked up in the prototype chain. Should be
      // better than forcing DOM reflow on every single event.
      if (!Object.getOwnPropertyDescriptor(event, 'offsetX')) {
        Object.defineProperty(event, 'offsetX', {
          get: () => {
            const accessor = getAccessorFromPrototype(event, 'offsetX'),
                  offsetX = accessor.call(event),
                  {
              target
            } = event,
                  {
              offsetWidth
            } = target,
                  x = Math.min(Math.max(offsetX, 0), offsetWidth - 1);

            if (offsetX < 0 || offsetX >= offsetWidth) {
              return x;
            }

            return offsetX;
          }
        });
      }

      if (!Object.getOwnPropertyDescriptor(event, 'offsetY')) {
        Object.defineProperty(event, 'offsetY', {
          get: () => {
            const accessor = getAccessorFromPrototype(event, 'offsetY'),
                  offsetY = accessor.call(event),
                  {
              target
            } = event,
                  {
              offsetHeight
            } = target,
                  y = Math.min(Math.max(offsetY, 0), offsetHeight - 1);

            if (offsetY < 0 || offsetY >= offsetHeight) {
              return y;
            }

            return offsetY;
          }
        });
      }
    } // Firefox has a bug where it can report that the target is the #document when mouse is over a pseudo element


    if (((_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.nodeType) === Element.DOCUMENT_NODE && 'clientX' in event) {
      const targetElement = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].elementFromPoint(event.clientX, event.clientY);
      Object.defineProperty(event, 'target', {
        get: () => targetElement
      });
    } // Firefox has a bug where it can report a textNode as an event target/relatedTarget.
    // We standardize this to report the parentElement.


    if (((_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.nodeType) === Element.TEXT_NODE) {
      const targetElement = event.target.parentElement;
      Object.defineProperty(event, 'target', {
        get: () => targetElement
      });
    }

    if (((_event$relatedTarget = event.relatedTarget) === null || _event$relatedTarget === void 0 ? void 0 : _event$relatedTarget.nodeType) === Element.TEXT_NODE) {
      const relatedTargetElement = event.target.parentElement;
      Object.defineProperty(event, 'relatedTarget', {
        get: () => relatedTargetElement
      });
    } // If it's a touch event, move the positional details
    // of touches[0] up to the event.


    if (type.startsWith('touch') && event.touches.length) {
      this.normalizeEvent(event);
    }

    return event;
  }

  static createHandler(element, eventName, handlerSpec, defaults) {
    const delay = handlerSpec.delay || defaults.delay,
          throttled = handlerSpec.throttled || defaults.throttled,
          block = handlerSpec.block || defaults.block,
          once = handlerSpec.once || defaults.once,
          thisObj = handlerSpec.thisObj || defaults.thisObj,
          capture = handlerSpec.capture || defaults.capture,
          delegate = handlerSpec.delegate || defaults.delegate,
          wrappedFn = handlerSpec.handler; //Capture initial conditions in case of destruction of thisObj.
    // Destruction completely wipes the object.
    // Innermost level of wrapping which calls the user's handler.
    // Normalize the event cross-browser, and attempt to normalize touch events.

    let handler = (event, ...args) => {
      // Flag for the expiry timer
      handler.called = true; // When playing a demo using DemoBot, only handle synthetic events

      if (EH.playingDemo && event.isTrusted) {
        return;
      } // If the thisObj is already destroyed, we cannot call the function.
      // If in dev mode, warn the developer with a JS error.


      if (thisObj && thisObj.isDestroyed) {
        // eslint-disable-next-line
        return;
      } // Fix up events to handle various browser inconsistencies


      event = EH.fixEvent(event); // delegate: '.b-field-trigger' only fires when click is in a matching el.
      // currentTarget becomes the delegate.

      if (delegate) {
        var _event$target$closest;

        // Maintainer: In Edge event.target can be an empty object for transitionend events
        const delegatedTarget = ((_event$target$closest = event.target.closest) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.call) && event.target.closest(delegate);

        if (!delegatedTarget) {
          return;
        } // Allow this to be redefined as it bubbles through listeners up the parentNode axis
        // which might have their own delegate settings.


        Object.defineProperty(event, 'currentTarget', {
          get: () => delegatedTarget,
          configurable: true
        });
      }

      (typeof wrappedFn === 'string' ? thisObj[wrappedFn] : wrappedFn).call(thisObj, event, ...args);
    }; // Allow events to be blocked for a certain time


    if (block) {
      const wrappedFn = handler;
      let lastCallTime, lastTarget;

      handler = (e, ...args) => {
        const now = performance.now();

        if (!lastCallTime || e.target !== lastTarget || now - lastCallTime > block) {
          lastTarget = e.target;
          lastCallTime = now;
          wrappedFn(e, ...args);
        }
      };
    } // Go through options, each creates a new handler by wrapping the previous handler to implement the options.
    // Right now, we have delay. Note that it may be zero, so test != null


    if (delay != null) {
      const wrappedFn = handler,
            delayable = thisObj && thisObj.setTimeout ? thisObj : window;

      handler = (...args) => {
        delayable.setTimeout(() => {
          wrappedFn(...args);
        }, delay);
      };
    } // If they specified the throttled option, wrap the handler in a createdThrottled
    // version. Allow the called to specify an alt function to call when the event
    // fires before the buffer time has expired.


    if (throttled != null) {
      let alt,
          buffer = throttled;

      if (throttled.buffer) {
        alt = e => throttled.alt.call(EH, EH.fixEvent(e));

        buffer = throttled.buffer;
      }

      if (thisObj && thisObj.isDelayable) {
        handler = thisObj.throttle(handler, {
          delay: buffer,
          throttled: alt
        });
      } else {
        handler = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createThrottled(handler, buffer, thisObj, null, alt);
      }
    } // This must always be the last option processed so that it is the outermost handler
    // which is the one added to the element and is called immediately so that the
    // handler is removed immediately.
    // TODO: Use the native once option when all browsers support it. Only IE11 doesn't.


    if (once) {
      const wrappedFn = handler;

      handler = (...args) => {
        //element.removeEventListener(eventName, handler, capture);
        EH.removeEventListener(element, eventName, handler);
        wrappedFn(...args);
      };
    } // Only autoDetach here if there's a local thisObj is in the handlerSpec for this one listener.
    // If it's in the defaults, then the "on" method will handle it.


    if (handlerSpec.thisObj && handlerSpec.autoDetach !== false) {
      thisObj.doDestroy = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createInterceptor(thisObj.doDestroy, () => EH.removeEventListener(element, eventName, handler), thisObj);
    }

    handler.spec = {
      delay,
      throttled,
      block,
      once,
      thisObj,
      capture,
      delegate
    };
    return handler;
  }

  static removeEventListener(element, eventName, handler) {
    const {
      expires,
      timerId,
      thisObj,
      capture
    } = handler.spec; // Cancel outstanding expires.alt() call when removing the listener

    if (expires !== null && expires !== void 0 && expires.alt && timerId) {
      const delayable = thisObj !== null && thisObj !== void 0 && thisObj.isDelayable ? thisObj : window;
      delayable[typeof expires.delay === 'number' ? 'clearTimeout' : 'cancelAnimationFrame'](timerId);
    }

    element.removeEventListener(eventName, handler, capture);
  }

  static onTransitionEnd({
    element,
    property,
    handler,
    mode = 'transition',
    duration = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"][`get${mode === 'transition' ? 'Property' : ''}${_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].capitalize(mode)}Duration`](element, property),
    thisObj = window,
    args = []
  }) {
    let timerId;

    const callbackArgs = [element, property, ...args],
          timerSource = thisObj.isDelayable ? thisObj : window,
          doCallback = () => {
      detacher();

      if (!thisObj.isDestroyed) {
        if (thisObj.callback) {
          thisObj.callback(handler, thisObj, callbackArgs);
        } else {
          handler.apply(thisObj, callbackArgs);
        }
      }
    },
          detacher = EH.on({
      element,

      [`${mode}end`]({
        propertyName,
        target
      }) {
        if (propertyName === property && target === element) {
          if (timerId) {
            timerSource.clearTimeout(timerId);
            timerId = null;
          }

          doCallback();
        }
      }

    }); // If the transition has not signalled its end within duration + 50 milliseconds
    // then give up on it. Remove the listener and call the handler.


    if (duration != null) {
      timerId = timerSource.setTimeout(doCallback, duration + 50);
    }

    return detacher;
  }

  static async waitForTransitionEnd(config) {
    return new Promise(resolve => {
      config.handler = resolve;
      EventHelper.onTransitionEnd(config);
    });
  }
  /**
   * Private function to wrap the passed function. The returned wrapper function to be used as
   * a `touchstart` handler which will call the passed function passing a fabricated `contextmenu`
   * event if there's no `touchend` or `touchmove` after a default of 400ms.
   * @param {String|Function} handler The handler to call.
   * @param {Object} thisObj The owner of the function.
   * @private
   */


  static createContextMenuWrapper(handler, me) {
    return event => {
      // Only attempt conversion to contextmenu if it's a single touch start.
      if (event.touches.length === 1) {
        const tapholdStartTouch = event.touches[0],
              // Dispatch a synthetic "contextmenu" event from the touchpoint in <longPressTime> milliseconds.
        tapholdTimer = setTimeout(() => {
          // Remove the gesture cancelling listeners
          touchMoveRemover();
          const contextmenuEvent = new MouseEvent('contextmenu', tapholdStartTouch);
          Object.defineProperty(contextmenuEvent, 'target', {
            get() {
              return tapholdStartTouch.target;
            }

          });

          if (typeof handler === 'string') {
            handler = me[handler];
          }

          contextmenuEvent.browserEvent = event; // Call the wrapped handler passing the fabricated contextmenu event

          handler.call(me, contextmenuEvent);
          EH.contextMenuTouchId = tapholdStartTouch.identifier;
        }, EH.longPressTime),
              // This is what gets called if the user moves their touchpoint,
        // or releases the touch before <longPressTime>ms is up
        onMoveOrPointerUp = ({
          clientX,
          clientY,
          type
        }) => {
          let cancel = type === 'touchend' || type === 'pointerup'; // for move events, check if we only moved a little

          if (!cancel) {
            const deltaX = Math.abs(clientX - tapholdStartTouch.clientX),
                  deltaY = Math.abs(clientY - tapholdStartTouch.clientY);
            cancel = deltaX >= longpressMoveThreshold || deltaY >= longpressMoveThreshold;
          }

          if (cancel) {
            EH.contextMenuTouchId = null;
            touchMoveRemover();
            clearTimeout(tapholdTimer);
          }
        },
              // Touchmove or touchend before that timer fires cancels the timer and removes these listeners.
        touchMoveRemover = EH.on({
          element: document,
          touchmove: onMoveOrPointerUp,
          touchend: onMoveOrPointerUp,
          pointermove: onMoveOrPointerUp,
          pointerup: onMoveOrPointerUp,
          capture: true
        });
      }
    };
  }
  /**
   * Private function to wrap the passed function. The returned wrapper function to be used as
   * a `touchend` handler which will call the passed function passing a fabricated `dblclick`
   * event if there is a `click` within 300ms.
   * @param {String|Function} handler The handler to call.
   * @param {Object} thisObj The owner of the function.
   * @private
   */


  static createDblClickWrapper(element, handler, me) {
    let startId, secondListenerDetacher, tapholdTimer;
    return () => {
      if (!secondListenerDetacher) {
        secondListenerDetacher = EH.on({
          element,
          // We only get here if a touchstart arrives within 300ms of a click
          touchstart: secondStart => {
            startId = secondStart.changedTouches[0].identifier; // Prevent zoom

            secondStart.preventDefault();
          },
          touchend: secondClick => {
            if (secondClick.changedTouches[0].identifier === startId) {
              secondClick.preventDefault();
              clearTimeout(tapholdTimer);
              startId = secondListenerDetacher = null;
              const targetRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(secondClick.changedTouches[0].target, null, true),
                    offsetX = secondClick.changedTouches[0].pageX - targetRect.x,
                    offsetY = secondClick.changedTouches[0].pageY - targetRect.y,
                    dblclickEventConfig = Object.assign({
                browserEvent: secondClick
              }, secondClick),
                    dblclickEvent = new MouseEvent('dblclick', dblclickEventConfig);
              Object.defineProperty(dblclickEvent, 'target', {
                get() {
                  return secondClick.target;
                }

              });
              Object.defineProperty(dblclickEvent, 'offsetX', {
                get() {
                  return offsetX;
                }

              });
              Object.defineProperty(dblclickEvent, 'offsetY', {
                get() {
                  return offsetY;
                }

              });

              if (typeof handler === 'string') {
                handler = me[handler];
              } // Call the wrapped handler passing the fabricated dblclick event


              handler.call(me, dblclickEvent);
            }
          },
          once: true
        }); // Cancel the second listener is there's no second click within <dblClickTime> milliseconds.

        tapholdTimer = setTimeout(() => {
          secondListenerDetacher();
          startId = secondListenerDetacher = null;
        }, EH.dblClickTime);
      }
    };
  }

}
const EH = EventHelper;
/**
 * The time in milliseconds for a `taphold` gesture to trigger a `contextmenu` event.
 * @member {Number} [longPressTime=500]
 * @readonly
 * @static
 */

EH.longPressTime = 500;
/**
 * The time in milliseconds within which a second touch tap event triggers a `dblclick` event.
 * @member {Number} [dblClickTime=300]
 * @readonly
 * @static
 */

EH.dblClickTime = 300; // Flag body if last user action used keyboard, used for focus styling etc.

EH.on({
  element: document,

  mousedown({
    target
  }) {
    if (!_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isTouchEvent) {
      var _rootEl$classList;

      const rootEl = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getRootElement(target);
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].usingKeyboard = false;
      (_rootEl$classList = rootEl.classList) === null || _rootEl$classList === void 0 ? void 0 : _rootEl$classList.remove('b-using-keyboard');
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].removeClsGlobally(rootEl, 'b-using-keyboard');
    }
  },

  touchmove({
    changedTouches
  }) {
    var _rootEl$classList2;

    const target = changedTouches[0].target,
          rootEl = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getRootElement(target);
    _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].usingKeyboard = false;
    (_rootEl$classList2 = rootEl.classList) === null || _rootEl$classList2 === void 0 ? void 0 : _rootEl$classList2.remove('b-using-keyboard');
    _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].removeClsGlobally(rootEl, 'b-using-keyboard');
  },

  keydown({
    target,
    key
  }) {
    if (!ignoreModifierKeys[key]) {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].usingKeyboard = true;
      const rootElement = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getRootElement(target); // if shadow root, add to outer children (shadow root itself lacks a classList :( )

      if (rootElement.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        Array.from(rootElement.children).forEach(node => {
          if (node.matches('.b-outer')) {
            node.classList.add('b-using-keyboard');
          }
        });
      } else {
        // document.body
        rootElement.classList.add('b-using-keyboard');
      }
    }
  }

}); // When dragging on a touch device, we need to prevent scrolling from happening.
// Dragging only starts on a touchmove event, by which time it's too late to preventDefault
// on the touchstart event which started it.
// To do this we need a capturing, non-passive touchmove listener at the document level so we can preventDefault.
// This is in lieu of a functioning touch-action style on iOS Safari. When that's fixed, this will not be needed.

if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isTouchDevice) {
  EH.on({
    element: document,
    touchmove: event => {
      // If we're touching a b-dragging event, then stop any panning by preventing default.
      if (event.target.closest('.b-dragging')) {
        event.preventDefault();
      }
    },
    passive: false,
    capture: true
  });
}

EventHelper._$name = 'EventHelper';

/***/ }),

/***/ "./lib/Core/helper/FunctionHelper.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/FunctionHelper.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FunctionHelper; });
var productName = 'taskboard';
/**
* @module Core/helper/FunctionHelper
*/

const {
  hasOwnProperty
} = Object.prototype;
/**
 * Provides functionality for working with functions
 * @internal
 */

class FunctionHelper {
  /**
   * Inserts a function after the specified `method` is called on an `object`. To remove this hook, invoke the
   * function returned by this method.
   * ```
   *  class A {
   *      method() {
   *          console.log('method');
   *      }
   *  }
   *
   *  let instance = new A();
   *
   *  let detach = FunctionHelper.after(instance, 'method', () => { console.log('after') });
   *
   *  instance.method();
   *  > method
   *  > after
   *
   *  detach();
   *  instance.method();
   *  > method
   * ```
   * The value returned by the original method is passed as the first argument to `fn` followed by all the arguments
   * passed by the caller.
   *
   * If `fn` returns a value (not `undefined`), that value is returned from the method call instead of the value
   * returned by the original method.
   * ```
   *  class A {
   *      method(x) {
   *          console.log('method', x);
   *          return x * 2
   *      }
   *  }
   *
   *  let instance = new A();
   *
   *  let detach = FunctionHelper.after(instance, 'method', (ret, x) => {
   *      console.log('after', ret, x);
   *      return x / 2;
   *  });
   *
   *  console.log(instance.method(50));
   *  > method 50
   *  > after 100 50
   *  > 25
   *
   *  detach();
   *  console.log(instance.method(50));
   *  > method 50
   *  > 100
   * ```
   *
   * @param {Object} object The object to hook.
   * @param {String} method The name of the method on `object` to hook.
   * @param {Function|String} fn The function or method name (on `thisObj`) to call after `method`.
   * @param {Object} [thisObj] The `this` pointer value for calling `fn`.
   * @param {Object} [options] Additional options
   * @param {Boolean} [options.return=true] Specify `false` to not include the return value of the hooked method as
   * the first argument to `fn`.
   * @returns {Function} The function to call to remove the hook.
   */
  static after(object, method, fn, thisObj, options) {
    const named = typeof fn === 'string',
          withReturn = (options === null || options === void 0 ? void 0 : options.return) !== false,
          hook = (...args) => {
      const // if object.destroy() occurs, our hook will be removed, so this fn won't be called in that case
      origResult = hook.$nextHook.call(object, ...args),
            hookResult = thisObj !== null && thisObj !== void 0 && thisObj.isDestroyed ? undefined : withReturn ? named ? thisObj[fn](origResult, ...args) : fn.call(thisObj, origResult, ...args) : named ? thisObj[fn](...args) : fn.call(thisObj, ...args);
      return hookResult === undefined ? origResult : hookResult;
    };

    return FunctionHelper.hookMethod(object, method, hook);
  }
  /**
   * Inserts a function before the specified `method` is called on an `object`. To remove this hook, invoke the
   * function returned by this method.
   * ```
   *  class A {
   *      method() {
   *          console.log('method');
   *      }
   *  }
   *
   *  let instance = new A();
   *
   *  let detach = FunctionHelper.before(instance, 'method', () => { console.log('before') });
   *
   *  instance.method();
   *  > before
   *  > method
   *
   *  detach();
   *  instance.method();
   *  > method
   * ```
   * If `fn` returns `false`, the original method is not invoked and `false` is returned to the caller.
   * ```
   *  class A {
   *      method(x) {
   *          console.log('method', x);
   *          return x * 2;
   *      }
   *  }
   *
   *  let instance = new A();
   *
   *  let detach = FunctionHelper.before(instance, 'method', x => {
   *      console.log('before', x);
   *      return false;
   *  });
   *
   *  console.log(instance.method(50));
   *  > before 50
   *  > false
   *
   *  detach();
   *  console.log(instance.method(50));
   *  > method 50
   *  > 100
   * ```
   *
   * @param {Object} object The object to hook.
   * @param {String} method The name of the method on `object` to hook.
   * @param {Function|String} fn The function or method name (on `thisObj`) to call before `method`.
   * @param {Object} [thisObj] The `this` pointer value for calling `fn`.
   * @returns {Function} The function to call to remove the hook.
   */


  static before(object, method, fn, thisObj) {
    const named = typeof fn === 'string',
          hook = (...args) => {
      const ret = thisObj !== null && thisObj !== void 0 && thisObj.isDestroyed ? 0 : named ? thisObj[fn](...args) : fn.call(thisObj, ...args);
      return ret === false ? ret : hook.$nextHook.call(object, ...args);
    };

    return FunctionHelper.hookMethod(object, method, hook);
  }

  static curry(func) {
    return function curried(...args) {
      if (args.length >= func.length) {
        return func.apply(this, args);
      } else {
        return function (...args2) {
          return curried.apply(this, args.concat(args2));
        };
      }
    };
  }

  static bindAll(obj) {
    for (const key in obj) {
      if (typeof obj[key] === 'function') {
        obj[key] = obj[key].bind(obj);
      }
    }
  }
  /**
   * Returns a function which calls the passed `interceptor` function first, and the passed `original` after
   * as long as the `interceptor` does not return `false`.
   * @param {Function} original The function to call second.
   * @param {Function} interceptor The function to call first.
   * @param {Object} [thisObj] The `this` reference when the functions are called.
   * @returns The return value from the `original` function **if it was called**, else `false`.
   */


  static createInterceptor(original, interceptor, thisObj) {
    return (...args) => {
      if (interceptor.call(thisObj, ...args) !== false) {
        return original.call(thisObj, ...args);
      }

      return false;
    };
  }
  /**
   * Returns a function which calls the passed `sequence` function after calling
   * the passed `original`.
   * @param {Function} original The function to call first.
   * @param {Function} sequence The function to call second.
   * @param {Object} [thisObj] The `this` reference when the functions are called.
   * @returns The value returned from the sequence if it returned a value, else the return
   * value from the original function.
   */


  static createSequence(original, sequence, thisObj) {
    return (...args) => {
      const origResult = original.call(thisObj, ...args),
            sequenceResult = sequence.call(thisObj, ...args);
      return sequenceResult === undefined ? origResult : sequenceResult;
    };
  }
  /**
   * Create a "debounced" function which will call on the "leading edge" of a timer period.
   * When first invoked will call immediately, but invocations after that inside its buffer
   * period will be rejected, and *one* invocation will be made after the buffer period has expired.
   *
   * This is useful for responding immediately to a first mousemove, but from then on, only
   * calling the action function on a regular timer while the mouse continues to move.
   *
   * @param {Function} fn The function to call.
   * @param {Number} buffer The milliseconds to wait after each execution before another execution takes place.
   * @param {Object} [thisObj] `this` reference for the function.
   * @param {Array} [extraArgs] The argument list to append to those passed to the function.
   * @param {Function} [alt] A function to call when the invocation is rejected due to buffer time not having expired.
   */


  static createThrottled(fn, buffer, thisObj, extraArgs, alt) {
    let lastCallTime = -Number.MAX_VALUE,
        callArgs,
        timerId;

    const invoke = () => {
      timerId = 0;
      lastCallTime = performance.now();
      callArgs.push.apply(callArgs, extraArgs);
      fn.apply(thisObj, callArgs);
    },
          result = function (...args) {
      const elapsed = performance.now() - lastCallTime;
      callArgs = args; // If it's been more then the buffer period since we invoked, we can call it now

      if (elapsed >= buffer) {
        clearTimeout(timerId);
        invoke();
      } // Otherwise, kick off a timer for the requested period.
      else {
        if (!timerId) {
          timerId = setTimeout(invoke, buffer - elapsed);
        }

        if (alt) {
          callArgs.push.apply(callArgs, extraArgs);
          alt.apply(thisObj, callArgs);
        }
      }
    };

    result.cancel = () => clearTimeout(timerId);

    return result;
  }
  /**
   * Create a "debounced" function which will call on the "trailing edge" of a timer period.
   * When first invoked will wait until the buffer period has expired to call the function, and
   * more calls within that time will restart the timer.
   *
   * This is useful for responding to keystrokes, but deferring action until the user pauses typing.
   *
   * @param {Function} fn The function to call.
   * @param {Number} buffer The milliseconds to wait after each execution before another execution takes place.
   * @param {Object} [thisObj] `this` reference for the function.
   * @param {Array} [args] The argument list to append to those passed to the function.
   */


  static createBuffered(fn, buffer, thisObj, args) {
    let callArgs, timerId;

    const invoke = () => {
      timerId = 0;
      result.isPending = false;
      callArgs.push.apply(callArgs, args);
      fn.apply(thisObj, callArgs);
    },
          result = function (...args) {
      callArgs = args; // Cancel any impending invocation. It's pushed out for <buffer> ms from each call

      if (timerId) {
        clearTimeout(timerId);
      }

      result.isPending = true;
      timerId = setTimeout(invoke, buffer);
    };

    result.cancel = () => {
      result.isPending = false;
      clearTimeout(timerId);
    };

    return result;
  }

  static hookMethod(object, method, hook) {
    hook.$nextHook = object[method];
    object[method] = hook;
    return () => {
      // Object will have no hooks on the instance if it is destroyed (perhaps other reasons too)
      if (hasOwnProperty.call(object, method)) {
        let f = object[method],
            next;

        if (f === hook) {
          var _Object$getPrototypeO;

          // When this is the outermost hook, we may be the last hook. If $nextHook is found on the object's
          // prototype, simply delete the slot to expose it. Otherwise, there's another hook, so make it the
          // outermost.
          if (((_Object$getPrototypeO = Object.getPrototypeOf(object)) === null || _Object$getPrototypeO === void 0 ? void 0 : _Object$getPrototypeO[method]) === hook.$nextHook) {
            delete object[method];
          } else {
            object[method] = hook.$nextHook;
          }
        } else {
          // Not being the outermost hook means we have outer hooks that should chain to the one we want to
          // remove. Be cautious because the object could be destroyed.
          for (; next = (_f = f) === null || _f === void 0 ? void 0 : _f.$nextHook; f = next) {
            var _f;

            if (next === hook) {
              f.$nextHook = hook.$nextHook;
              break;
            }
          }
        }
      }
    };
  }
  /**
   * Protects the specified `method` on a given `object` such that calling it will not throw exceptions.
   * @param {Object} object The object whose method is to be protected.
   * @param {String} method The name of the method to protect.
   * @param {Function} [handler] An optional function to call for any thrown exceptions.
   * @internal
   */


  static noThrow(object, method, handler) {
    const fn = object[method];

    object[method] = (...args) => {
      try {
        return fn.apply(object, args);
      } catch (e) {
        return handler === null || handler === void 0 ? void 0 : handler(e);
      }
    };
  }

  static returnTrue() {
    return true;
  }

  static animate(duration, fn, thisObj, easing = 'linear') {
    let cancel = false;
    const result = new Promise(resolve => {
      const start = performance.now(),
            iterate = () => {
        const progress = Math.min((performance.now() - start) / duration, 1),
              delayable = thisObj && thisObj.setTimeout ? thisObj : window;

        if (!cancel) {
          if (fn.call(thisObj, this.easingFunctions[easing](progress)) === false) {
            resolve();
          }
        }

        if (cancel || progress === 1) {
          // Push resolution into the next animation frame so that
          // this frame completes before the resolution handler runs.
          delayable.requestAnimationFrame(() => resolve());
        } else {
          delayable.requestAnimationFrame(iterate);
        }
      };

      iterate();
    });

    result.cancel = () => {
      cancel = true;
      return false;
    };

    return result;
  }

}
/* eslint-disable */

const half = 0.5,
      e1 = 1.70158,
      e2 = 7.5625,
      e3 = 1.525,
      e4 = 2 / 2.75,
      e5 = 2.25 / 2.75,
      e6 = 1 / 2.75,
      e7 = 1.5 / 2.75,
      e8 = 2.5 / 2.75,
      e9 = 2.625 / 2.75,
      e10 = 0.75,
      e11 = 0.9375,
      e12 = 0.984375,
      s1 = 1.70158,
      s2 = 1.70158;
FunctionHelper.easingFunctions = {
  linear: t => t,
  easeInQuad: t => Math.pow(t, 2),
  easeOutQuad: t => -(Math.pow(t - 1, 2) - 1),
  easeInOutQuad: t => (t /= half) < 1 ? half * Math.pow(t, 2) : -half * ((t -= 2) * t - 2),
  easeInCubic: t => Math.pow(t, 3),
  easeOutCubic: t => Math.pow(t - 1, 3) + 1,
  easeInOutCubic: t => (t /= half) < 1 ? half * Math.pow(t, 3) : half * (Math.pow(t - 2, 3) + 2),
  easeInQuart: t => Math.pow(t, 4),
  easeOutQuart: t => -(Math.pow(t - 1, 4) - 1),
  easeInOutQuart: t => (t /= half) < 1 ? half * Math.pow(t, 4) : -half * ((t -= 2) * Math.pow(t, 3) - 2),
  easeInQuint: t => Math.pow(t, 5),
  easeOutQuint: t => Math.pow(t - 1, 5) + 1,
  easeInOutQuint: t => (t /= half) < 1 ? half * Math.pow(t, 5) : half * (Math.pow(t - 2, 5) + 2),
  easeInSine: t => -Math.cos(t * (Math.PI / 2)) + 1,
  easeOutSine: t => Math.sin(t * (Math.PI / 2)),
  easeInOutSine: t => -half * (Math.cos(Math.PI * t) - 1),
  easeInExpo: t => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: t => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: t => t === 0 ? 0 : t === 1 ? 1 : (t /= half) < 1 ? half * Math.pow(2, 10 * (t - 1)) : half * (-Math.pow(2, -10 * --t) + 2),
  easeInCirc: t => -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: t => Math.sqrt(1 - Math.pow(t - 1, 2)),
  easeInOutCirc: t => (t /= half) < 1 ? -half * (Math.sqrt(1 - t * t) - 1) : half * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeOutBounce: t => t < e6 ? e2 * t * t : t < e4 ? e2 * (t -= e7) * t + e10 : t < e8 ? e2 * (t -= e5) * t + e11 : e2 * (t -= e9) * t + e12,
  easeInBack: t => t * t * ((e1 + 1) * t - e1),
  easeOutBack: t => (t = t - 1) * t * ((e1 + 1) * t + e1) + 1,
  easeInOutBack: t => {
    let v1 = s1;
    return (t /= half) < 1 ? half * (t * t * (((v1 *= e3) + 1) * t - v1)) : half * ((t -= 2) * t * (((v1 *= e3) + 1) * t + v1) + 2);
  },
  elastic: t => -1 * Math.pow(4, -8 * t) * Math.sin((t * 6 - 1) * (2 * Math.PI) / 2) + 1,
  swingFromTo: t => {
    let v2 = s2;
    return (t /= half) < 1 ? half * (t * t * (((v2 *= e3) + 1) * t - v2)) : half * ((t -= 2) * t * (((v2 *= e3) + 1) * t + v2) + 2);
  },
  swingFrom: t => t * t * ((e1 + 1) * t - e1),
  swingTo: t => (t -= 1) * t * ((e1 + 1) * t + e1) + 1,
  bounce: t => t < e6 ? e2 * t * t : t < e4 ? e2 * (t -= e7) * t + e10 : t < e8 ? e2 * (t -= e5) * t + e11 : e2 * (t -= e9) * t + e12,
  bouncePast: t => t < e6 ? e2 * t * t : t < e4 ? 2 - (e2 * (t -= e7) * t + e10) : t < e8 ? 2 - (e2 * (t -= e5) * t + e11) : 2 - (e2 * (t -= e9) * t + e12),
  easeFromTo: t => (t /= half) < 1 ? half * Math.pow(t, 4) : -half * ((t -= 2) * Math.pow(t, 3) - 2),
  easeFrom: t => Math.pow(t, 4),
  easeTo: t => Math.pow(t, 0.25)
};
FunctionHelper._$name = 'FunctionHelper';

/***/ }),

/***/ "./lib/Core/helper/IdHelper.js":
/*!*************************************!*\
  !*** ./lib/Core/helper/IdHelper.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return IdHelper; });
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'taskboard';


/**
 * @module Core/helper/IdHelper
 */
// Id generation should be on a per page basis, not per module

const idCounts = _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getPathDefault(_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].global, 'bryntum.idCounts', Object.create(null));
/**
 * IdHelper provides unique ID generation.
 *
 * This class is not intended for application use, it is used internally by the Bryntum infrastructure.
 * @internal
 */

class IdHelper {
  /**
   * Generate a new id, using IdHelpers internal counter and a prefix
   * @param {String} prefix Id prefix
   * @returns {String} Generated id
   */
  static generateId(prefix = 'generatedId') {
    // This produces "b-foo-1, b-foo-2, ..." for each prefix independently of the others. In other words, it makes
    // id's more stable since the counter is on a per-class basis.
    return prefix + (idCounts[prefix] = (idCounts[prefix] || 0) + 1);
  }

}
IdHelper._$name = 'IdHelper';

/***/ }),

/***/ "./lib/Core/helper/ObjectHelper.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/ObjectHelper.js ***!
  \*****************************************/
/*! exports provided: typeOf, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "typeOf", function() { return typeOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ObjectHelper; });
/* harmony import */ var _util_Objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'taskboard';

 // NOTE: This import prevents this module from being imported by Base (or anything Base imports):


const {
  hasOwnProperty
} = Object.prototype;
/**
 * @module Core/helper/ObjectHelper
 */

const typeOf = value => {
  const baseType = typeof value; // If not atomic type, we handle date or null

  if (baseType === 'object') {
    if (value === null) {
      return 'null';
    }

    if (Array.isArray(value)) {
      return 'array';
    }

    if (Object.prototype.toString.call(value) === '[object Date]') {
      return 'date';
    }

    if (value.isBase) {
      return 'instance';
    }
  }

  if (baseType === 'function') {
    if (value.isBase) {
      return 'class';
    }
  }

  return baseType;
};

 // Detect if browser has bad implementation of toFixed()

const toFixedFix = 1.005.toFixed(2) === '1.01' ? null : function (number, fractionDigits) {
  const split = number.toString().split('.'),
        newNumber = +(!split[1] ? split[0] : split.join('.') + '1');
  return number.toFixed.call(newNumber, fractionDigits);
};
/**
 * Helper for Object manipulation.
 */

class ObjectHelper extends _util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // These methods are inherited from Objects (an internal class) but need to be documented here for public use.
  // This is primarily because static methods, while inherited by JavaScript classes, are not displayed in derived
  // classes in the docs.

  /**
   * Copies all enumerable properties from the supplied source objects to `dest`. Unlike `Object.assign`, this copy
   * also includes inherited properties.
   * @param {Object} dest The destination object.
   * @param {...Object} sources The source objects.
   * @returns {Object} The `dest` object.
   * @method assign
   * @static
   */

  /**
   * Copies all enumerable properties from the supplied source objects to `dest`, only including properties that does
   * not already exist on `dest`. Unlike `Object.assign`, this copy also includes inherited properties.
   * @param {Object} dest The destination object.
   * @param {...Object} sources The source objects.
   * @returns {Object} The `dest` object.
   * @method assignIf
   * @static
   */

  /**
   * Creates a deep copy of the `value`. Simple objects ({@link #function-isObject-static}, arrays and `Date` objects
   * are cloned. The enumerable properties of simple objects and the elements of arrays are cloned recursively.
   * @param {*} value The value to clone.
   * @param {Function} [handler] An optional function to call for values of types other than simple object, array or
   * `Date`. This function should return the clone of the `value` passed to it. It is only called for truthy values
   * whose `typeof` equals `'object'`.
   * @param {*} handler.value The value to clone.
   * @returns {*} The cloned value.
   * @method clone
   * @static
   */

  /**
   * Converts a list of names (either a space separated string or an array), into an object with those properties
   * assigned truthy values. The converse of {@link #function-getTruthyKeys-static}.
   * @param {String|String[]} source The list of names to convert to object form.
   * @method createTruthyKeys
   * @static
   */

  /**
   * Gathers the names of properties which have truthy values into an array.
   *
   * This is useful when gathering CSS class names for complex element production.
   * Instead of appending to an array or string which may already contain the
   * name, and instead of contending with space separation and concatenation
   * and conditional execution, just set the properties of an object:
   *
   *     cls = {
   *         [this.selectedCls] : this.isSelected(thing),
   *         [this.dirtyCls] : this.isDirty(thing)
   *     };
   *
   * @param {Object} source Source of keys to gather into an array.
   * @returns {String[]} The keys which had a truthy value.
   * @method getTruthyKeys
   * @static
   */

  /**
   * Gathers the values of properties which are truthy into an array.
   * @param {Object} source Source of values to gather into an array.
   * @returns {String[]} The truthy values from the passed object.
   * @method getTruthyValues
   * @static
   */

  /**
   * Tests whether a passed object has any enumerable properties.
   * @param {Object} object
   * @returns {Boolean} `true` if the passed object has no enumerable properties.
   * @method isEmpty
   * @static
   */

  /**
   * Returns `true` if the `value` is a simple `Object`.
   * @param {Object} value
   * @returns {Boolean} `true` if the `value` is a simple `Object`.
   * @method isObject
   * @static
   */

  /**
   * Copies all enumerable properties from the supplied source objects to `dest`, recursing when the properties of
   * both the source and `dest` are objects.
   * ```
   *  const o = {
   *      a : 1,
   *      b : {
   *          c : 2
   *      }
   *  };
   *  const o2 = {
   *      b : {
   *          d : 3
   *      }
   *  }
   *
   *  console.log(merge(o, o2));
   *
   *  > { a : 1, b : { c : 2, d : 3 } }
   * ```
   * @param {Object} dest The destination object.
   * @param {...Object} sources The source objects.
   * @returns {Object} The `dest` object.
   * @method merge
   * @static
   */

  /**
   * Returns the specific type of the given `value`. Unlike the `typeof` operator, this function returns the text
   * from the `Object.prototype.toString` result allowing `Date`, `Array`, `RegExp`, and others to be differentiated.
   * ```
   *  console.log(typeOf(null));
   *  > null
   *
   *  console.log(typeOf({}));
   *  > object
   *
   *  console.log(typeOf([]));
   *  > array
   *
   *  console.log(typeOf(new Date()));
   *  > date
   *
   *  console.log(typeOf(NaN));
   *  > nan
   *
   *  console.log(typeOf(/a/));
   *  > regexp
   * ```
   * @param {*} value
   * @returns {String}
   * @method typeOf
   * @static
   */

  /**
   * Returns value for a given path in the object
   * @param {Object} object Object to check path on
   * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
   * @returns {*} Value associated with passed key
   * @method getPath
   * @static
   */

  /**
   * Sets value for a given path in the object
   * @param {Object} object Target object
   * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
   * @param {*} value Value for a given path
   * @returns {Object} Returns passed object
   * @method setPath
   * @static
   */

  /**
   * Creates a new object where key is a property in array item (`ref` by default) or index in the array and value is array item.
   *
   * From:
   * ```
   * [
   *     {
   *          text : 'foo',
   *          ref : 'fooItem'
   *     },
   *     {
   *          text : 'bar'
   *     }
   * ]
   * ```
   *
   * To:
   * ```
   * {
   *     fooItem : {
   *         text : 'foo',
   *         ref  : 'fooItem'
   *     },
   *     1 : {
   *         text : 'bar'
   *     }
   * }
   * ```
   *
   * @param {Object[]} arrayOfItems Array to transform.
   * @param {String} [prop] Property to read the key from. `ref` by default.
   * @returns {Object} namedItems
   */
  static transformArrayToNamedObject(arrayOfItems, prop = 'ref') {
    const namedItems = {};
    arrayOfItems.forEach((item, index) => {
      const // 0 is valid value, but empty string in not valid
      key = item[prop] != null && item[prop].toString().length ? item[prop] : index;
      namedItems[key] = item;
    });
    return namedItems;
  }
  /**
   * Creates a new array from object values and saves key in a property (`ref` by default) of each item.
   *
   * From:
   * ```
   * {
   *     fooItem : {
   *         text : 'foo'
   *     },
   *     1 : {
   *         text : 'bar'
   *     },
   *     barItem : false // will be ignored
   * }
   * ```
   *
   * To:
   * ```
   * [
   *     {
   *          text : 'foo',
   *          ref : 'fooItem'
   *     },
   *     {
   *          text : 'bar',
   *          ref : 1
   *     }
   * ]
   * ```
   *
   * @param {Object} namedItems Object to transform.
   * @param {String} [prop] Property to save the key to. `ref` by default.
   * @returns {Object[]} arrayOfItems
   */


  static transformNamedObjectToArray(namedItems, prop = 'ref') {
    return Object.keys(namedItems).filter(key => namedItems[key]).map(key => {
      const item = namedItems[key];
      item[prop] = key;
      return item;
    });
  }
  /**
   * Checks if two values are equal. Basically === but special handling of dates.
   * @param {*} a First value
   * @param {*} b Second value
   * @returns {*} true if values are equal, otherwise false
   */


  static isEqual(a, b, useIsDeeply = false) {
    // Eliminate null vs undefined mismatch
    if (a === null && b !== null || a === undefined && b !== undefined || b === null && a !== null || b === undefined && a !== undefined) {
      return false;
    } // Covers undefined === undefined and null === null, since mismatches are eliminated above


    if (a == null && b == null) {
      return true;
    } // The same instance should equal itself.


    if (a === b) {
      return true;
    }

    const typeA = typeof a,
          typeB = typeof b;

    if (typeA === typeB) {
      switch (typeA) {
        case 'number':
        case 'string':
        case 'boolean':
          return a === b;
      }

      switch (true) {
        case a instanceof Date && b instanceof Date:
          // faster than calling DateHelper.isEqual
          // https://jsbench.me/3jk2bom2r3/1
          return a.getTime() === b.getTime();

        case Array.isArray(a) && Array.isArray(b):
          return a.length === b.length ? a.every((v, idx) => OH.isEqual(v, b[idx], useIsDeeply)) : false;

        case typeA === 'object' && a.constructor.prototype === b.constructor.prototype:
          return useIsDeeply ? OH.isDeeplyEqual(a, b, useIsDeeply) : JSON.stringify(a) === JSON.stringify(b);
      }
    }

    return String(a) === String(b);
  }
  /**
   * Checks if two objects are deeply equal
   * @param {Object} a
   * @param {Object} b
   * @param {Object} [options] Additional comparison options
   * @param {Object} [options.ignore] Map of property names to ignore when comparing
   * @param {Function} [options.shouldEvaluate] Function used to evaluate if a property should be compared or not.
   * Return false to prevent comparison
   * @param {Function} [options.evaluate] Function used to evaluate equality. Return `true`/`false` as evaluation
   * result or anything else to let `isEqual` handle the comparison
   * @returns {Boolean}
   */


  static isDeeplyEqual(a, b, options = {}) {
    // Same object, equal :)
    if (a === b) {
      return true;
    } // Nothing to compare, not equal


    if (!a || !b) {
      return false;
    } // Property names excluding ignored


    const aKeys = OH.keys(a, options.ignore),
          bKeys = OH.keys(b, options.ignore); // Property count differs, not equal

    if (aKeys.length !== bKeys.length) {
      return false;
    }

    for (let i = 0; i < aKeys.length; i++) {
      const aKey = aKeys[i],
            bKey = bKeys[i]; // Property name differs, not equal

      if (aKey !== bKey) {
        return false;
      }

      const aVal = a[aKey],
            bVal = b[bKey]; // Allow caller to determine if property values should be evaluated or not
      // TODO: Not currently used

      if (options.shouldEvaluate) {
        if (options.shouldEvaluate(aKey, {
          value: aVal,
          object: a
        }, {
          value: bVal,
          object: b
        }) === false) {
          continue;
        }
      } // Allow caller to determine equality of properties


      if (options.evaluate) {
        const result = options.evaluate(aKey, {
          value: aVal,
          object: a
        }, {
          value: bVal,
          object: b
        }); // Not equal

        if (result === false) {
          return false;
        } // Equal, skip isEqual call below


        if (result === true) {
          continue;
        }
      } // Values differ, not equal (also digs deeper)


      if (!OH.isEqual(aVal, bVal, options)) {
        return false;
      }
    } // Found to be equal


    return true;
  }
  /**
   * Checks if value B is partially equal to value A.
   * @param {*} a First value
   * @param {*} b Second value
   * @returns {Boolean} true if values are partially equal, false otherwise
   */


  static isPartial(a, b) {
    a = String(a).toLowerCase();
    b = String(b).toLowerCase();
    return a.indexOf(b) !== -1;
  }
  /**
   * Checks if value a is smaller than value b.
   * @param {*} a First value
   * @param {*} b Second value
   * @returns {Boolean} true if a < b
   */


  static isLessThan(a, b) {
    if (a instanceof Date && b instanceof Date) {
      return _DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isBefore(a, b);
    }

    return a < b;
  }
  /**
   * Checks if value a is bigger than value b.
   * @param {*} a First value
   * @param {*} b Second value
   * @returns {Boolean} true if a > b
   */


  static isMoreThan(a, b) {
    if (a instanceof Date && b instanceof Date) {
      return _DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isAfter(a, b);
    }

    return a > b;
  }
  /**
   * Used by the Base class to make deep copies of defaultConfig blocks
   * @private
   */


  static fork(obj) {
    let ret, key, value;

    if (obj && obj.constructor === Object) {
      ret = Object.setPrototypeOf({}, obj);

      for (key in obj) {
        value = obj[key];

        if (value) {
          if (value.constructor === Object) {
            ret[key] = OH.fork(value);
          } else if (value instanceof Array) {
            ret[key] = value.slice();
          }
        }
      }
    } else {
      ret = obj;
    }

    return ret;
  }
  /**
   * Copies the named properties from the `source` parameter into the `dest` parameter.
   * @param {Object} dest The destination into which properties are copied.
   * @param {Object} source The source from which properties are copied.
   * @param {String[]} props The list of property names.
   * @returns The `dest` object.
   */


  static copyProperties(dest, source, props) {
    let prop, i;

    for (i = 0; i < props.length; i++) {
      prop = props[i];

      if (prop in source) {
        dest[prop] = source[prop];
      }
    }

    return dest;
  }
  /**
   * Copies the named properties from the `source` parameter into the `dest` parameter
   * unless the property already exists in the `dest`.
   * @param {Object} dest The destination into which properties are copied.
   * @param {Object} source The source from which properties are copied.
   * @param {String[]} props The list of property names.
   * @returns The `dest` object.
   */


  static copyPropertiesIf(dest, source, props) {
    if (source) {
      for (const prop of props) {
        if (!(prop in dest)) {
          dest[prop] = source[prop];
        }
      }
    }

    return dest;
  }
  /**
   * Returns an array containing the keys and values of all enumerable properties from every prototype level for the
   * object. If `object` is `null`, this method returns an empty array.
   * @param {Object} object Object from which to retrieve entries.
   * @param {Object|Function} [ignore] Optional object of names to ignore or a function accepting the name and value
   * which returns `true` to ignore the item.
   * @returns {Array}
   * @internal
   */


  static entries(object, ignore) {
    const result = [],
          call = typeof ignore === 'function';

    if (object) {
      for (const p in object) {
        if (call ? !ignore(p, object[p]) : !(ignore !== null && ignore !== void 0 && ignore[p])) {
          result.push([p, object[p]]);
        }
      }
    }

    return result;
  }
  /**
   * Populates an `object` with the provided `entries`.
   * @param {Array} entries The key/value pairs (2-element arrays).
   * @param {Object} [object={}] The object onto which to add `entries`.
   * @returns {Object} The passed `object` (by default, a newly created object).
   * @internal
   */


  static fromEntries(entries, object) {
    object = object || {};

    if (entries) {
      for (let i = 0; i < entries.length; ++i) {
        object[entries[i][0]] = entries[i][1];
      }
    }

    return object;
  }
  /**
   * Returns an array containing all enumerable property names from every prototype level for the object. If `object`
   * is `null`, this method returns an empty array.
   * @param {Object} object Object from which to retrieve property names.
   * @param {Object|Function} [ignore] Optional object of names to ignore or a function accepting the name and value
   * which returns `true` to ignore the item.
   * @param {Function} [mapper] Optional function to call for each non-ignored item. If provided, the result of this
   * function is stored in the returned array. It is called with the array element as the first parameter, and the
   * index in the result array as the second argument (0 for the first, non-ignored element, 1 for the second and so
   * on).
   * @returns {String[]}
   */


  static keys(object, ignore, mapper) {
    const result = [],
          call = typeof ignore === 'function';

    if (object) {
      let index = 0;

      for (const p in object) {
        if (call ? !ignore(p, object[p]) : !(ignore !== null && ignore !== void 0 && ignore[p])) {
          result.push(mapper ? mapper(p, index) : p);
          ++index;
        }
      }
    }

    return result;
  }
  /**
   * Returns an array containing the values of all enumerable properties from every prototype level for the object.
   * If `object` is `null`, this method returns an empty array.
   * @param {Object} object Object from which to retrieve values.
   * @param {Object|Function} [ignore] Optional object of names to ignore or a function accepting the name and value
   * which returns `true` to ignore the item.
   * @param {Function} [mapper] Optional function to call for each non-ignored item. If provided, the result of this
   * function is stored in the returned array. It is called with the array element as the first parameter, and the
   * index in the result array as the second argument (0 for the first, non-ignored element, 1 for the second and so
   * on).
   * @returns {Array}
   * @internal
   */


  static values(object, ignore, mapper) {
    const result = [],
          call = typeof ignore === 'function';

    if (object) {
      let index = 0;

      for (const p in object) {
        if (call ? !ignore(p, object[p]) : !(ignore !== null && ignore !== void 0 && ignore[p])) {
          result.push(mapper ? mapper(object[p], index) : object[p]);
          ++index;
        }
      }
    }

    return result;
  }
  /**
   * Returns an array of a given object's properties names including properties in
   * all superclasses, in the same order as we get with a normal loop.
   * @param {Object} object An object which may have properties in a prototype
   * chain, such as a configuration (These are chained because of inheritance).
   * @returns {String[]} The property names.
   * @deprecated 4.1.0 Use {@link #function-keys-static} instead.
   */


  static allKeys(object) {
    _VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].deprecate('Core', '5.0.0', 'Deprecated in favor of `keys()`; will be removed in 5.0');
    return ObjectHelper.keys(object);
  } //region Path

  /**
   * Checks if a given path exists in an object
   * @param {Object} object Object to check path on
   * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
   * @returns {Boolean} Returns `true` if path exists or `false` if it does not
   */


  static pathExists(object, path) {
    const properties = path.split('.');
    return properties.every(property => {
      if (!object || !(property in object)) {
        return false;
      }

      object = object[property];
      return true;
    });
  }
  /**
   * Creates a simple single level key-value object from complex deep object.
   * @param {Object} object Object to extract path and values from
   * @returns {Object} Key-value object where key is a path to the corresponding value
   * @internal
   *
   * ```javascript
   * // converts deep object
   * {
   *     foo : {
   *         bar : {
   *             test : 1
   *         }
   *     }
   * }
   * // into a single level object
   * {
   *     'foo.bar.test' : 1
   * }
   * ```
   */


  static pathifyKeys(object) {
    const result = {};

    for (const key in object) {
      if (hasOwnProperty.call(object, key)) {
        if (object[key] instanceof Object) {
          const paths = this.pathifyKeys(object[key]);

          for (const path in paths) {
            result[`${key}.${path}`] = paths[path];
          }
        } else {
          result[key] = object[key];
        }
      }
    }

    return result;
  }
  /**
   * Removes value for a given path in the object. Doesn't cleanup empty objects.
   * @param {Object} object
   * @param {String} path Dot-separated path, e.g. `obj.child.someKey`
   * @internal
   */


  static deletePath(object, path) {
    path.split('.').reduce((result, key, index, array) => {
      if (result == null) {
        return null;
      } else if (hasOwnProperty.call(result, key)) {
        if (index === array.length - 1) {
          delete result[key];
        } else {
          return result[key];
        }
      }
    }, object);
  } //endregion


  static coerce(from, to) {
    const fromType = typeOf(from),
          toType = typeOf(to),
          isString = typeof from === 'string';

    if (fromType !== toType) {
      switch (toType) {
        case 'string':
          return String(from);

        case 'number':
          return Number(from);

        case 'boolean':
          // See http://ecma262-5.com/ELS5_HTML.htm#Section_11.9.3 as to why '0'.
          // TL;DR => ('0' == 0), so if given string '0', we must return boolean false.
          return isString && (!from || from === 'false' || from === '0') ? false : Boolean(from);

        case 'null':
          return isString && (!from || from === 'null') ? null : false;

        case 'undefined':
          return isString && (!from || from === 'undefined') ? undefined : false;

        case 'date':
          return isString && isNaN(from) ? _DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(from) : Date(Number(from));
      }
    }

    return from;
  }

  static wrapProperty(object, propertyName, newGetter, newSetter, deep = true) {
    const newProperty = {};
    let proto = Object.getPrototypeOf(object),
        existingProperty = Object.getOwnPropertyDescriptor(proto, propertyName);

    while (!existingProperty && proto && deep) {
      proto = Object.getPrototypeOf(proto);

      if (proto) {
        existingProperty = Object.getOwnPropertyDescriptor(proto, propertyName);
      }
    }

    if (existingProperty) {
      if (existingProperty.set) {
        newProperty.set = v => {
          existingProperty.set.call(object, v); // Must invoke the getter in case "v" has been transformed.

          newSetter && newSetter.call(object, existingProperty.get.call(object));
        };
      } else {
        newProperty.set = newSetter;
      }

      if (existingProperty.get) {
        newProperty.get = () => {
          let result = existingProperty.get.call(object);

          if (newGetter) {
            result = newGetter.call(object, result);
          }

          return result;
        };
      } else {
        newProperty.get = newGetter;
      }
    } else {
      newProperty.set = v => {
        object[`_${propertyName}`] = v;
        newSetter && newSetter.call(object, v);
      };

      newProperty.get = () => {
        let result = object[`_${propertyName}`];

        if (newGetter) {
          result = newGetter.call(object, result);
        }

        return result;
      };
    }

    Object.defineProperty(object, propertyName, newProperty);
  }
  /**
   * Finds a property descriptor for the passed object from all inheritance levels.
   * @param {Object} object The Object whose property to find.
   * @param {String} propertyName The name of the property to find.
   * @returns {Object} An ECMA property descriptor is the property was found, otherwise `null`
   */


  static getPropertyDescriptor(object, propertyName) {
    let result = null;

    for (let o = object; o && !result && !hasOwnProperty.call(o, 'isBase'); o = Object.getPrototypeOf(o)) {
      result = Object.getOwnPropertyDescriptor(o, propertyName);
    }

    return result;
  }
  /**
   * Return `true` if the given `object` defines the specified `property` as defined by
   * [Object.hasOwnProperty](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwnProperty).
   * @param {Object} object
   * @param {String} property
   * @returns {Boolean}
   * @internal
   */


  static hasOwn(object, property) {
    // Benefits:
    // - Better compression over direct call to Object.prototype.hasOwnProperty.call(object, property)
    // - Almost as compact as "object.hasOwnProperty()" but still works with Object.create(null) objects
    // - Does not throw if object is null/undefined unlike all forms of hasOwnProperty
    //
    // Even given above, if needed often in a module it is probably still better to use:
    //  const { hasOwnProperty } = Object.prototype;
    // and
    //  hasOwnProperty.call()
    return object ? hasOwnProperty.call(object, property) : false;
  }
  /**
   * Changes the passed object and removes all null and undefined properties from it
   * @param {Object} object Target object
   * @param {Boolean} [keepNull] Pass true to only remove undefined properties
   * @returns {Object} Passed object
   */


  static cleanupProperties(object, keepNull = false) {
    Object.entries(object).forEach(([key, value]) => {
      if (keepNull) {
        value === undefined && delete object[key];
      } else {
        value == null && delete object[key];
      }
    });
    return object;
  }
  /**
   * Changes the passed object and removes all properties from it.
   * Used while mutating when need to keep reference to the object but replace its properties.
   * @param {Object} object Target object
   * @returns {Object} Passed object
   */


  static removeAllProperties(obj) {
    Object.keys(obj).forEach(key => delete obj[key]);
    return obj;
  } //region Assert type

  /**
   * Checks that the supplied value is of the specified type.Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} type Expected type
   * @param {String} name Name of the value, used in error message
   * @param {Boolean} [allowNull] Accept `null` without throwing
   */


  static assertType(value, type, name) {
    const valueType = typeOf(value);

    if (value != null && valueType !== type) {
      throw new Error(`Incorrect type "${valueType}" for ${name}, expected "${type}"`);
    }
  }
  /**
   * Checks that the supplied value is a plain object. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertObject(value, name) {
    OH.assertType(value, 'object', name);
  }
  /**
   * Checks that the supplied value is an instance of a Bryntum class. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertInstance(value, name) {
    OH.assertType(value, 'instance', name);
  }
  /**
   * Checks that the supplied value is a Bryntum class. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertClass(value, name) {
    OH.assertType(value, 'class', name);
  }
  /**
   * Checks that the supplied value is a function. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertFunction(value, name) {
    if (typeof value !== 'function' || value.isBase || value.$$name) {
      throw new Error(`Incorrect type for ${name}, got "${value}" (expected a function)`);
    }
  }
  /**
   * Checks that the supplied value is a number. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertNumber(value, name) {
    const asNumber = Number(value);

    if (typeof value !== 'number' || isNaN(asNumber)) {
      throw new Error(`Incorrect type for ${name}, got "${value}" (expected a Number)`);
    }
  }
  /**
   * Checks that the supplied value is a boolean. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertBoolean(value, name) {
    OH.assertType(value, 'boolean', name);
  }
  /**
   * Checks that the supplied value is a string. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertString(value, name) {
    OH.assertType(value, 'string', name);
  }
  /**
   * Checks that the supplied value is an array. Throws if it is not
   * @param {Object} value Value to check type of
   * @param {String} name Name of the value, used in error message
   */


  static assertArray(value, name) {
    OH.assertType(value, 'array', name);
  } //endregion

  /**
   * Number.toFixed(), with polyfill for browsers that needs it
   * @param {Number} number
   * @param {Number} digits
   * @returns {String} A fixed point string representation of the passed number.
   */


  static toFixed(number, digits) {
    if (toFixedFix) {
      return toFixedFix(number, digits);
    }

    return number.toFixed(digits);
  }
  /**
   * Round the passed number to closest passed step value.
   * @param {Number} number The number to round.
   * @param {Number} [step] The step value to round to.
   * @returns {Number} The number rounded to the closest step.
   */


  static roundTo(number, step = 1) {
    return Math.round(number / step) * step;
  }
  /**
   * Round the passed number to the passed number of decimals.
   * @param {Number} number The number to round.
   * @param {Number} digits The number of decimal places to round to.
   * @returns {Number} The number rounded to the passed number of decimal places.
   */


  static round(number, digits) {
    // Undefined or null means do not round. NOT round to no decimals.
    if (digits == null) {
      return number;
    }

    const factor = 10 ** digits;
    return Math.round(number * factor) / factor;
  }
  /**
   * Returns a non-null entry from a Map for a given key path. This enables a specified defaultValue to be added "just
   * in time" which is returned if the key is not already present.
   * @param {Map} map The Map to find the key in (and potentially add to).
   * @param {String|Number|String[]|Number[]} path Dot-separated path, e.g. 'firstChild.childObject.someKey',
   * or the key path as an array, e.g. ['firstChild', 'childObject', 'someKey'].
   * @param {Object} [defaultValue] Optionally the value to insert if the key is not found.
   */


  static getMapPath(map, path, defaultValue) {
    const keyPath = Array.isArray(path) ? path : typeof path === 'string' ? path.split('.') : [path],
          simpleKey = keyPath.length === 1,
          topKey = keyPath[0],
          topValue = map.has(topKey) ? map.get(topKey) : map.set(topKey, simpleKey ? defaultValue : {}).get(topKey); // If it was a simple key, we are done.

    if (simpleKey) {
      return topValue;
    } // Go down the property path on the top Object, filling entries in until the leaf.


    return OH.getPathDefault(topValue, keyPath.slice(1), defaultValue);
  }

}
const OH = ObjectHelper;
ObjectHelper._$name = 'ObjectHelper';

/***/ }),

/***/ "./lib/Core/helper/ResizeHelper.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/ResizeHelper.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResizeHelper; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _EventHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
var productName = 'taskboard';






 //TODO: add pointer events support

const documentListeners = {
  down: 'onMouseDown',
  move: 'onMouseMove',
  up: 'onMouseUp',
  docclick: 'onDocumentClick',
  touchstart: {
    handler: 'onTouchStart',
    // We preventDefault touchstart so as not to scroll. Must not be passive.
    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
    passive: false
  },
  touchmove: 'onTouchMove',
  touchend: 'onTouchEnd',
  keydown: 'onKeyDown'
};
/**
 * @module Core/helper/ResizeHelper
 */

/**
 * Handles resizing of elements using handles. Handles can be actual elements or virtual handles specified as a border
 * area on elements left and right edges.
 *
 * ```
 * // enable resizing all elements with class 'resizable'
 * let resizer = new ResizeHelper({
 *   targetSelector: '.resizable'
 * });
 * ```
 *
 * @mixes Core/mixin/Events
 * @internal
 */

class ResizeHelper extends Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  //region Config
  static get defaultConfig() {
    return {
      /**
       * CSS class added when resizing
       * @config {String}
       * @default
       */
      resizingCls: 'b-resizing',

      /**
       * The amount of pixels to move mouse before it counts as a drag operation
       * @config {Number}
       * @default
       */
      dragThreshold: 5,

      /**
       * Resizing handle size
       * @config {Number}
       * @default
       */
      handleSize: 10,

      /**
       * Automatically shrink virtual handles when available space < handleSize. The virtual handles will
       * decrease towards width/height 1, reserving space between opposite handles to for example leave room for
       * dragging. To configure reserved space, see {@link #config-reservedSpace}.
       * @config {Boolean}
       * @default false
       */
      dynamicHandleSize: null,
      //

      /**
       * Room in px to leave unoccupied by handles when shrinking them dynamically (see
       * {@link #config-dynamicHandleSize}).
       * @config {Number}
       * @default
       */
      reservedSpace: 10,

      /**
       * Resizing handle size on touch devices
       * @config {Number}
       * @default
       */
      touchHandleSize: 30,

      /**
       * Minimum width when resizing
       * @config {Number}
       * @default
       */
      minWidth: 1,

      /**
       * Max width when resizing.
       * @config {Number}
       * @default
       */
      maxWidth: 0,

      /**
       * Minimum height when resizing
       * @config {Number}
       * @default
       */
      minHeight: 1,

      /**
       * Max height when resizing
       * @config {Number}
       * @default
       */
      maxHeight: 0,
      // outerElement, attach events to it and use as outer limit when looking for ancestors
      outerElement: document.body,

      /**
       * Optional scroller used to read scroll position. If unspecified, the outer element will be used.
       * @config {Core.helper.util.Scroller}
       */
      scroller: null,

      /**
       * Assign a function to determine if a hovered element can be resized or not
       * @config {Function}
       * @default
       */
      allowResize: null,

      /**
       * Outer element that limits where element can be dragged
       * @config {HTMLElement}
       * @default
       */
      dragWithin: null,

      /**
       * A function that determines if dragging an element is allowed. Gets called with the element as argument,
       * return true to allow dragging or false to prevent.
       * @config {Function}
       * @default
       */
      isElementResizable: null,

      /**
       * A CSS selector used to determine if resizing an element is allowed.
       * @config {String}
       * @default
       */
      targetSelector: null,

      /**
       * Use left handle when resizing. Only applies when `direction` is 'horizontal'
       * @config {Boolean}
       * @default
       */
      leftHandle: true,

      /**
       * Use right handle when resizing. Only applies when `direction` is 'horizontal'
       * @config {Boolean}
       * @default
       */
      rightHandle: true,

      /**
       * Use top handle when resizing. Only applies when `direction` is 'vertical'
       * @config {Boolean}
       * @default
       */
      topHandle: true,

      /**
       * Use bottom handle when resizing. Only applies when `direction` is 'vertical'
       * @config {Boolean}
       * @default
       */
      bottomHandle: true,

      /**
       * A CSS selector used to determine where handles should be "displayed" when resizing. Defaults to
       * targetSelector if unspecified
       * @config {String}
       * @default
       */
      handleSelector: null,

      /**
       * A CSS selector used to determine which inner element contains handles.
       * @config {String}
       * @default
       */
      handleContainerSelector: null,
      startEvent: null,

      /*
       * Optional config object, used by EventResize feature: it appends proxy and has to start resizing immediately
       * @config {Object}
       * @private
       */
      grab: null,

      /**
       * CSS class added when the resize state is invalid
       * @config {String}
       * @default
       */
      invalidCls: 'b-resize-invalid',
      // A number that controls whether or not the element is wide enough for it to make sense to show resize handles
      // e.g. handle width is 10px, so doesn't make sense to show them unless handles on both sides fit
      handleVisibilityThreshold: null,
      // Private config that disables translation when resizing left edge. Useful for example in cases when element
      // being resized is part of a flex layout
      skipTranslate: false,

      /**
       * Direction to resize in, either 'horizontal' or 'vertical'
       * @config {String}
       * @default
       */
      direction: 'horizontal',
      clickSwallowDuration: 50
    };
  } //endregion
  //region Events

  /**
   * Fired while dragging
   * @event resizing
   * @param {Core.helper.ResizeHelper} source
   * @param {Object} context Resize context
   * @param {MouseEvent} event Browser event
   */

  /**
   * Fired when dragging starts.
   * @event resizeStart
   * @param {Core.helper.ResizeHelper} source
   * @param {Object} context Resize context
   * @param {MouseEvent|TouchEvent} event Browser event
   */

  /**
   * Fires after resize, and allows for asynchronous finalization by setting 'async' to `true` on the context object.
   * @event resize
   * @param {Core.helper.ResizeHelper} source
   * @param {Object} context Context about the resize operation. Set 'async' to `true` to indicate asynchronous validation of the resize flow (for showing a confirmation dialog etc)
   */

  /**
   * Fires when a resize is canceled (width is unchanged)
   * @event cancel
   * @param {Core.helper.ResizeHelper} source
   * @param {Object} context Resize context
   * @param {MouseEvent|TouchEvent} event Browser event
   */
  //endregion
  //region Init


  construct(config) {
    const me = this;
    super.construct(config); // Larger draggable zones on pure touch devices with no mouse

    if (!me.handleSelector && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isHoverableDevice) {
      me.handleSize = me.touchHandleSize;
    }

    me.handleVisibilityThreshold = me.handleVisibilityThreshold || 2 * me.handleSize;
    me.initListeners();
    me.initResize();
  }

  doDestroy() {
    this.abort(true);
    super.doDestroy();
  }
  /**
   * Initializes resizing
   * @private
   */


  initResize() {
    const me = this;

    if (!me.isElementResizable && me.targetSelector) {
      me.isElementResizable = element => _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(element, me.targetSelector);
    }

    if (me.grab) {
      const {
        edge,
        element,
        event
      } = me.grab;
      me.startEvent = event;
      const cursorOffset = me.getCursorOffsetToElementEdge(event, element, edge); // emulates mousedown & grabResize

      me.context = {
        element,
        edge,
        valid: true,
        async: false,
        elementStartX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateX(element) || element.offsetLeft,
        // extract x from translate
        elementStartY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateY(element) || element.offsetTop,
        // extract x from translate
        newX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateX(element) || element.offsetLeft,
        // No change yet on start, but info must be present
        newY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateY(element) || element.offsetTop,
        // No change yet on start, but info must be present
        elementWidth: element.offsetWidth,
        elementHeight: element.offsetHeight,
        cursorOffset,
        startX: event.clientX + cursorOffset.x + me.scrollLeft,
        startY: event.clientY + cursorOffset.y + me.scrollTop,
        finalize: () => {
          var _me$reset;

          return (_me$reset = me.reset) === null || _me$reset === void 0 ? void 0 : _me$reset.call(me);
        }
      };
      element.classList.add(me.resizingCls);
      me.internalStartResize(me.isTouch);
    }
  }
  /**
   * Initialize listeners
   * @private
   */


  initListeners() {
    const me = this,
          dragStartListeners = {
      element: me.outerElement,
      mousedown: documentListeners.down,
      touchstart: documentListeners.touchstart,
      thisObj: me
    };

    if (!me.handleSelector && _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isHoverableDevice) {
      dragStartListeners.mousemove = {
        handler: documentListeners.move,
        // Filter events for checkResizeHandles so we only get called if the mouse
        // is over one of our targets.
        delegate: me.targetSelector
      }; // We need to clean up when we exit one of our targets

      dragStartListeners.mouseleave = {
        handler: 'onMouseLeaveTarget',
        delegate: me.targetSelector,
        capture: true
      };
    } // These will be autoDetached upon destroy


    me.removeListeners = _EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on(dragStartListeners);
  }

  removeListeners() {} //endregion
  //region Scroll helpers


  get scrollLeft() {
    if (this.scroller) {
      return this.scroller.x;
    }

    return this.outerElement.scrollLeft;
  }

  get scrollTop() {
    if (this.scroller) {
      return this.scroller.y;
    }

    return this.outerElement.scrollTop;
  } //endregion
  //region Events


  internalStartResize(isTouch) {
    const me = this,
          dragListeners = {
      element: document,
      keydown: documentListeners.keydown,
      thisObj: me
    };

    if (isTouch) {
      dragListeners.touchmove = documentListeners.touchmove; // Touch desktops don't fire touchend event when touch has ended, instead pointerup is fired
      // iOS do fire touchend

      dragListeners.touchend = dragListeners.pointerup = documentListeners.touchend;
    } else {
      dragListeners.mousemove = documentListeners.move;
      dragListeners.mouseup = documentListeners.up;
    } // A listener detacher is returned;


    me.removeDragListeners = _EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on(dragListeners);
  } // Empty class implementation. If listeners *are* added, the detacher is added
  // as an instance property. So this is always callable.


  removeDragListeners() {}

  reset() {
    var _this$removeDragListe;

    (_this$removeDragListe = this.removeDragListeners) === null || _this$removeDragListe === void 0 ? void 0 : _this$removeDragListe.call(this);
    this.context = null;
  }

  onPointerDown(isTouch, event) {
    const me = this;
    me.startEvent = event;

    if (!me.isElementResizable || me.isElementResizable(event.target, event)) {
      if (me.grabResizeHandle(isTouch, event)) {
        // Stop event if resize handle was grabbed (resize started)
        event.stopImmediatePropagation();

        if (event.type === 'touchstart') {
          event.preventDefault();
        }

        me.internalStartResize(isTouch);
      }
    }
  }

  onTouchStart(event) {
    // only allowing one finger for now...
    if (event.touches.length > 1) {
      return;
    }

    this.onPointerDown(true, event);
  }
  /**
   * Grab draggable element on mouse down.
   * @private
   * @param {MouseEvent|PointerEvent} event
   */


  onMouseDown(event) {
    // only dragging with left mouse button
    if (event.button !== 0) {
      return;
    }

    this.onPointerDown(false, event);
  }

  internalMove(isTouch, event) {
    const me = this,
          {
      context,
      direction
    } = me;

    if (context !== null && context !== void 0 && context.element && (context.started || _EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getDistanceBetween(me.startEvent, event) >= me.dragThreshold)) {
      if (!context.started) {
        var _me$scrollManager;

        (_me$scrollManager = me.scrollManager) === null || _me$scrollManager === void 0 ? void 0 : _me$scrollManager.startMonitoring(_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].merge({
          scrollables: [{
            element: me.dragWithin || me.outerElement,
            // TODO Update this then when we add support for resizing in both directions simultaneously
            direction
          }],
          callback: config => {
            var _me$context;

            return ((_me$context = me.context) === null || _me$context === void 0 ? void 0 : _me$context.element) && me.lastMouseMoveEvent && me.update(me.lastMouseMoveEvent, config);
          }
        }, me.monitoringConfig));
        me.trigger('resizeStart', {
          context,
          event
        });
        context.started = true;
      }

      me.update(event);
    } // If a mousemove, and we are using zones, and not handles, we have to
    // programmatically check whether we are over a handle, and add/remove
    // classes to change the mouse cursor to resize.
    // If we are using handles, their CSS will set the mouse cursor.
    else if (!isTouch && !me.handleSelector) {
      me.checkResizeHandles(event);
    }
  }

  onTouchMove(event) {
    this.internalMove(true, event);
  }
  /**
   * Move grabbed element with mouse.
   * @param {MouseEvent|PointerEvent} event
   * @fires resizestart
   * @private
   */


  onMouseMove(event) {
    this.internalMove(false, event);
  }

  onPointerUp(isTouch, event) {
    var _me$removeDragListene;

    const me = this,
          context = me.context;
    (_me$removeDragListene = me.removeDragListeners) === null || _me$removeDragListene === void 0 ? void 0 : _me$removeDragListene.call(me);

    if (context) {
      var _me$scrollManager2;

      (_me$scrollManager2 = me.scrollManager) === null || _me$scrollManager2 === void 0 ? void 0 : _me$scrollManager2.stopMonitoring();

      if (context.started) {
        // Prevent the impending document click from the mouseup event from propagating
        // into a click on our element.
        _EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on({
          element: document,
          thisObj: me,
          click: documentListeners.docclick,
          expires: me.clickSwallowDuration,
          // In case a click did not ensue, remove the listener
          capture: true,
          once: true
        });
      }

      me.finishResize(event);
    } else {
      var _me$reset2;

      (_me$reset2 = me.reset) === null || _me$reset2 === void 0 ? void 0 : _me$reset2.call(me);
    }
  }

  onTouchEnd(event) {
    this.onPointerUp(true, event);
  }
  /**
   * Drop on mouse up (if dropped on valid target).
   * @param {MouseEvent|PointerEvent} event
   * @private
   */


  onMouseUp(event) {
    this.onPointerUp(false, event);
  }
  /**
   * This is a capture listener, only added during drag, which prevents a click gesture
   * propagating from the terminating mouseup gesture
   * @param {MouseEvent} event
   * @private
   */


  onDocumentClick(event) {
    event.stopPropagation();
  }
  /**
   * Cancel on ESC key
   * @param {KeyboardEvent} event
   * @private
   */


  onKeyDown(event) {
    if (event.key === 'Escape') {
      this.abort();
    }
  } //endregion
  //region Grab, update, finish

  /**
   * Updates resize, called when an element is grabbed and mouse moves
   * @private
   * @fires resizing
   */


  update(event) {
    const me = this,
          context = me.context,
          parentRectangle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(me.outerElement); // Calculate the current pointer X. Do not allow overflowing either edge

    context.currentX = Math.max(Math.min(event.clientX + context.cursorOffset.x, parentRectangle.right), parentRectangle.x) + me.scrollLeft;
    context.currentY = Math.max(Math.min(event.clientY + context.cursorOffset.y, parentRectangle.bottom), parentRectangle.y) + me.scrollTop;
    me.updateResize(event);
    me.trigger('resizing', {
      context,
      event
    });
    context.element.classList[context.valid === false ? 'add' : 'remove'](me.invalidCls); // When IE11 support is dropped
    // context.grabbed.classList.toggle(me.invalidCls, context.valid === false);

    if (event) {
      me.lastMouseMoveEvent = event;
    }
  }
  /**
   * Abort dragging
   */


  abort(silent = false) {
    var _me$scrollManager3, _me$scrollManager3$st;

    const me = this;
    (_me$scrollManager3 = me.scrollManager) === null || _me$scrollManager3 === void 0 ? void 0 : (_me$scrollManager3$st = _me$scrollManager3.stopMonitoring) === null || _me$scrollManager3$st === void 0 ? void 0 : _me$scrollManager3$st.call(_me$scrollManager3);

    if (me.context) {
      me.abortResize(null, silent);
    } else if (!me.isDestroyed) {
      me.reset();
    }
  }
  /**
   * Starts resizing, updates ResizeHelper#context with relevant info.
   * @private
   * @param {Boolean} isTouch
   * @param {MouseEvent} event
   * @returns {Boolean} True if handled, false if not
   */


  grabResizeHandle(isTouch, event) {
    const me = this;

    if (me.allowResize && !me.allowResize(event.target, event)) {
      return false;
    }

    const handleSelector = me.handleSelector,
          coordsFrom = event.type === 'touchstart' ? event.changedTouches[0] : event,
          clientX = coordsFrom.clientX,
          clientY = coordsFrom.clientY,
          // go up from "handle" to resizable element
    element = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(event.target, me.targetSelector) : event.target;

    if (element) {
      let edge; // Calculate which edge to resize
      // If there's a handle selector, see if it's anchored on the left or the right

      if (handleSelector) {
        if (event.target.matches(handleSelector)) {
          if (me.direction === 'horizontal') {
            if (event.pageX < _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getPageX(element) + element.offsetWidth / 2) {
              edge = 'left';
            } else {
              edge = 'right';
            }
          } else {
            if (event.pageY < _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getPageY(element) + element.offsetHeight / 2) {
              edge = 'top';
            } else {
              edge = 'bottom';
            }
          }
        } else {
          return false;
        }
      } // If we're not using handles, but just active zones
      // then test whether the event position is in an active resize zone.
      else {
        if (me.direction === 'horizontal') {
          if (me.overLeftHandle(event, element)) {
            edge = 'left';
          } else if (me.overRightHandle(event, element)) {
            edge = 'right';
          }
        } else {
          if (me.overTopHandle(event, element)) {
            edge = 'top';
          } else if (me.overBottomHandle(event, element)) {
            edge = 'bottom';
          }
        }

        if (!edge) {
          me.context = null; // not over an edge, abort

          return false;
        }
      } // If resizing is initiated by a touch, we must preventDefault on the touchstart
      // so that scrolling is not invoked when dragging. This is in lieu of a functioning
      // touch-action style on iOS Safari. When that's fixed, this will not be needed.


      if (event.type === 'touchstart') {
        event.preventDefault();
      }

      const cursorOffset = me.getCursorOffsetToElementEdge(coordsFrom, element, edge);

      if (me.trigger('beforeResizeStart', {
        element,
        event
      }) !== false) {
        // store initial size
        me.context = {
          element,
          edge,
          isTouch,
          valid: true,
          async: false,
          direction: me.direction,
          elementStartX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateX(element) || element.offsetLeft,
          // extract x from translate
          elementStartY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateY(element) || element.offsetTop,
          // extract y from translate
          newX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateX(element) || element.offsetLeft,
          // No change yet on start, but info must be present
          newY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateY(element) || element.offsetTop,
          // No change yet on start, but info must be present
          elementWidth: element.offsetWidth,
          elementHeight: element.offsetHeight,
          cursorOffset,
          startX: clientX + cursorOffset.x + me.scrollLeft,
          startY: clientY + cursorOffset.y + me.scrollTop,
          finalize: () => {
            var _me$reset3;

            return (_me$reset3 = me.reset) === null || _me$reset3 === void 0 ? void 0 : _me$reset3.call(me);
          }
        };
        element.classList.add(me.resizingCls);
        return true;
      }
    }

    return false;
  }

  getCursorOffsetToElementEdge(event, element, edge) {
    const rectEl = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(element);
    let x = 0,
        y = 0;

    switch (edge) {
      case 'left':
        x = rectEl.x - event.clientX; // negative

        break;

      case 'right':
        x = rectEl.x + rectEl.width - event.clientX; // positive

        break;

      case 'top':
        y = rectEl.y - event.clientY; // negative

        break;

      case 'bottom':
        y = rectEl.y + rectEl.height - event.clientY; // positive

        break;
    }

    return {
      x,
      y
    };
  }
  /**
   * Check if mouse is over a resize handle (virtual). If so, highlight.
   * @private
   * @param {MouseEvent} event
   */


  checkResizeHandles(event) {
    const me = this,
          target = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(event.target, me.targetSelector) : event.target; // mouse over a target element and allowed to resize?

    if (target && (!me.allowResize || me.allowResize(event.target, event))) {
      me.currentElement = me.handleContainerSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(event.target, me.handleContainerSelector) : event.target;

      if (me.currentElement) {
        let over = false;

        if (me.direction === 'horizontal') {
          over = me.overLeftHandle(event, target) || me.overRightHandle(event, target);
        } else {
          over = me.overTopHandle(event, target) || me.overBottomHandle(event, target);
        }

        if (over) {
          me.highlightHandle(); // over handle
        } else {
          me.unHighlightHandle(); // not over handle
        }
      }
    } else if (me.currentElement) {
      me.unHighlightHandle(); // outside element
    }
  }

  onMouseLeaveTarget(event) {
    const me = this;
    me.currentElement = me.handleContainerSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(event.target, me.handleContainerSelector) : event.target;

    if (me.currentElement) {
      me.unHighlightHandle();
    }
  }
  /**
   * Updates size of target (on mouse move).
   * @private
   * @param {MouseEvent|PointerEvent} event
   */


  updateResize(event) {
    const me = this,
          context = me.context; // flip which edge is being dragged depending on whether we're to the right or left of the mousedown

    if (me.allowEdgeSwitch) {
      if (me.direction === 'horizontal') {
        context.edge = context.currentX > context.startX ? 'right' : 'left';
      } else {
        context.edge = context.currentY > context.startY ? 'bottom' : 'top';
      }
    }

    const // limit to outerElement if set
    deltaX = context.currentX - context.startX,
          deltaY = context.currentY - context.startY,
          minWidth = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getExtremalSizePX(context.element, 'minWidth') || me.minWidth,
          maxWidth = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getExtremalSizePX(context.element, 'maxWidth') || me.maxWidth,
          minHeight = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getExtremalSizePX(context.element, 'minHeight') || me.minHeight,
          maxHeight = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getExtremalSizePX(context.element, 'maxHeight') || me.maxHeight,
          // dragging right edge right increases width, dragging left edge right decreases width
    sign = context.edge === 'right' || context.edge === 'bottom' ? 1 : -1,
          // new width, not allowed to go below minWidth
    newWidth = context.elementWidth + deltaX * sign,
          newHeight = context.elementHeight + deltaY * sign;
    let width = Math.max(minWidth, newWidth),
        height = Math.max(minHeight, newHeight);

    if (maxWidth > 0) {
      width = Math.min(width, maxWidth);
    }

    if (maxHeight > 0) {
      height = Math.min(height, maxHeight);
    } // remove flex when resizing


    if (context.element.style.flex) {
      context.element.style.flex = '';
    }

    if (me.direction === 'horizontal') {
      context.element.style.width = Math.abs(width) + 'px';
      context.newWidth = width; // when dragging left edge, also update position (so that right edge remains in place)

      if (context.edge === 'left' || width < 0) {
        context.newX = Math.max(Math.min(context.elementStartX + context.elementWidth - me.minWidth, context.elementStartX + deltaX), 0);

        if (!me.skipTranslate) {
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateX(context.element, context.newX);
        }
      } // When dragging the right edge and we're allowed to flip the drag from left to right
      // through the start point (eg drag event creation) the element must be at its initial X position
      else if (context.edge === 'right' && me.allowEdgeSwitch && !me.skipTranslate) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateX(context.element, context.elementStartX);
      }
    } else {
      context.element.style.height = Math.abs(height) + 'px';
      context.newHeight = height; // when dragging top edge, also update position (so that bottom edge remains in place)

      if (context.edge === 'top' || height < 0) {
        context.newY = Math.max(Math.min(context.elementStartY + context.elementHeight - me.minHeight, context.elementStartY + deltaY), 0);

        if (!me.skipTranslate) {
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateY(context.element, context.newY);
        }
      } // When dragging the bottom edge and we're allowed to flip the drag from top to bottom
      // through the start point (eg drag event creation) the element must be at its initial Y position
      else if (context.edge === 'bottom' && me.allowEdgeSwitch && !me.skipTranslate) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateY(context.element, context.elementStartY);
      }
    }
  }
  /**
   * Finalizes resize, fires drop.
   * @private
   * @param {MouseEvent|PointerEvent} event
   * @fires resize
   * @fires cancel
   */


  finishResize(event) {
    const me = this,
          context = me.context,
          eventObject = {
      context,
      event
    };
    context.element.classList.remove(me.resizingCls);

    if (context.started) {
      let changed = false;

      if (me.direction === 'horizontal') {
        changed = context.newWidth && context.newWidth !== context.elementWidth;
      } else {
        changed = context.newHeight && context.newHeight !== context.elementHeight;
      }

      me.trigger(changed ? 'resize' : 'cancel', eventObject);

      if (!context.async) {
        context.finalize();
      }
    } else {
      var _me$reset4;

      (_me$reset4 = me.reset) === null || _me$reset4 === void 0 ? void 0 : _me$reset4.call(me);
    }
  }
  /**
   * Abort resizing
   * @private
   * @fires cancel
   */


  abortResize(event = null, silent = false) {
    const me = this,
          context = me.context;
    context.element.classList.remove(me.resizingCls);

    if (me.direction === 'horizontal') {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateX(context.element, context.elementStartX);
      context.element.style.width = context.elementWidth + 'px';
    } else {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateY(context.element, context.elementStartY);
      context.element.style.height = context.elementHeight + 'px';
    }

    !silent && me.trigger('cancel', {
      context,
      event
    });

    if (!me.isDestroyed) {
      me.reset();
    }
  } //endregion
  //region Handles
  // /**
  //  * Constrain resize to outerElements bounds
  //  * @private
  //  * @param x
  //  * @returns {*}
  //  */
  // constrainResize(x) {
  //     const me = this;
  //
  //     if (me.outerElement) {
  //         const box = me.outerElement.getBoundingClientRect();
  //         if (x < box.left) x = box.left;
  //         if (x > box.right) x = box.right;
  //     }
  //
  //     return x;
  // }

  /**
   * Highlights handles (applies css that changes cursor).
   * @private
   */


  highlightHandle() {
    const me = this,
          target = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(me.currentElement, me.targetSelector) : me.currentElement; // over a handle, add cls to change cursor

    me.currentElement.classList.add('b-resize-handle');
    target.classList.add('b-over-resize-handle');
  }
  /**
   * Unhighlight handles (removes css).
   * @private
   */


  unHighlightHandle() {
    const me = this,
          target = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(me.currentElement, me.targetSelector) : me.currentElement;
    target && target.classList.remove('b-over-resize-handle');
    me.currentElement.classList.remove('b-resize-handle');
    me.currentElement = null;
  }

  overAnyHandle(event, target) {
    return this.overStartHandle(event, target) || this.overEndHandle(event, target);
  }

  overStartHandle(event, target) {
    return this.direction === 'horizontal' ? this.overLeftHandle(event, target) : this.overTopHandle(event, target);
  }

  overEndHandle(event, target) {
    return this.direction === 'horizontal' ? this.overRightHandle(event, target) : this.overBottomHandle(event, target);
  }

  getDynamicHandleSize(opposite, offsetWidth) {
    const handleCount = opposite ? 2 : 1,
          {
      handleSize
    } = this; // Shrink handle size when configured to do so, preserving reserved space between handles

    if (this.dynamicHandleSize && handleSize * handleCount > offsetWidth - this.reservedSpace) {
      return Math.max(Math.floor((offsetWidth - this.reservedSpace) / handleCount), 0);
    }

    return handleSize;
  }
  /**
   * Check if over left handle (virtual).
   * @private
   * @param {MouseEvent} event MouseEvent
   * @param {HTMLElement} target The current target element
   * @returns {Boolean} Returns true if mouse is over left handle, otherwise false
   */


  overLeftHandle(event, target) {
    const me = this,
          {
      offsetWidth
    } = target;

    if (me.leftHandle && (offsetWidth >= me.handleVisibilityThreshold || me.dynamicHandleSize)) {
      const leftHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(target);
      leftHandle.width = me.getDynamicHandleSize(me.rightHandle, offsetWidth);
      return leftHandle.width > 0 && leftHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getPagePoint(event));
    }

    return false;
  }
  /**
   * Check if over right handle (virtual).
   * @private
   * @param {MouseEvent} event MouseEvent
   * @param {HTMLElement} target The current target element
   * @returns {Boolean} Returns true if mouse is over left handle, otherwise false
   */


  overRightHandle(event, target) {
    const me = this,
          {
      offsetWidth
    } = target;

    if (me.rightHandle && (offsetWidth >= me.handleVisibilityThreshold || me.dynamicHandleSize)) {
      const rightHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(target);
      rightHandle.x = rightHandle.right - me.getDynamicHandleSize(me.leftHandle, offsetWidth);
      return rightHandle.width > 0 && rightHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getPagePoint(event));
    }

    return false;
  }
  /**
   * Check if over top handle (virtual).
   * @private
   * @param {MouseEvent} event MouseEvent
   * @param {HTMLElement} target The current target element
   * @returns {Boolean} Returns true if mouse is over top handle, otherwise false
   */


  overTopHandle(event, target) {
    const me = this,
          {
      offsetHeight
    } = target;

    if (me.topHandle && (offsetHeight >= me.handleVisibilityThreshold || me.dynamicHandleSize)) {
      const topHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(target);
      topHandle.height = me.getDynamicHandleSize(me.bottomHandle, offsetHeight);
      return topHandle.height > 0 && topHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getPagePoint(event));
    }

    return false;
  }
  /**
   * Check if over bottom handle (virtual).
   * @private
   * @param {MouseEvent} event MouseEvent
   * @param {HTMLElement} target The current target element
   * @returns {Boolean} Returns true if mouse is over bottom handle, otherwise false
   */


  overBottomHandle(event, target) {
    const me = this,
          {
      offsetHeight
    } = target;

    if (me.bottomHandle && (offsetHeight >= me.handleVisibilityThreshold || me.dynamicHandleSize)) {
      const bottomHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(target);
      bottomHandle.y = bottomHandle.bottom - me.getDynamicHandleSize(me.bottomHandle, offsetHeight);
      return bottomHandle.height > 0 && bottomHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getPagePoint(event));
    }

    return false;
  } //endregion


}
ResizeHelper._$name = 'ResizeHelper';

/***/ }),

/***/ "./lib/Core/helper/ResizeMonitor.js":
/*!******************************************!*\
  !*** ./lib/Core/helper/ResizeMonitor.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResizeMonitor; });
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'taskboard';
/* globals ResizeObserver: true */




let resizeFireTimer = null;

const resizedQueue = [],
      isAbsolutelyPositioned = n => {
  var _n$ownerDocument$defa;

  return n.nodeType === n.ELEMENT_NODE && ((_n$ownerDocument$defa = n.ownerDocument.defaultView) === null || _n$ownerDocument$defa === void 0 ? void 0 : _n$ownerDocument$defa.getComputedStyle(n).getPropertyValue('position')) === 'absolute';
};
/**
 * @module Core/helper/ResizeMonitor
 */

/**
 * Allows size monitoring of elements (or optionally a Window instance).
 *
 * ```
 * ResizeMonitor.addResizeListener(
 *   myElement,
 *   element => {
 *      console.log(element, ' changed size');
 *   }
 * );
 * ```
 *
 * @internal
 */


class ResizeMonitor {
  /**
   * Adds a resize listener to the passed element which is called when the element
   * is resized by layout.
   * @param {HTMLElement} element The element to listen for resizing.
   * @param {Function} handler The handling function. Will be passed the element.
   */
  static addResizeListener(element, handler) {
    const me = this;

    if (element === document || element === window) {
      element = document.body;
    }

    if (element.nodeType === element.DOCUMENT_FRAGMENT_NODE) {
      element = element.host;
    }

    if (!element.classList.contains('b-resize-monitored')) {
      element.classList.add('b-resize-monitored');
      element._bResizemonitor = {
        handlers: []
      };
    } // If we're looking at the document, or body, use a window resize listener.


    if (element === document.body) {
      if (!me.hasWindowResizeListener) {
        // Throttle the reaction to window resize to only fire once every 100ms
        window.addEventListener('resize', me.onWindowResize);
        me.hasWindowResizeListener = true;
      }
    } // Regular element - use ResizeObserver by preference
    else if (window.ResizeObserver) {
      if (!me.resizeObserver) {
        me.resizeObserver = new ResizeObserver(me.onElementResize);
      }

      me.resizeObserver.observe(element);
    } // Polyfill ResizeObserver
    else {
      element.classList.add('b-no-resizeobserver');
      const [monitors, expand, shrink] = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
        parent: element,
        className: 'b-resize-monitors',
        children: [{
          className: 'b-resize-monitor-expand'
        }, {
          className: 'b-resize-monitor-shrink'
        }]
      }, true);
      expand.scrollLeft = expand.scrollTop = shrink.scrollLeft = shrink.scrollTop = 1000000;
      expand.addEventListener('scroll', me.onSizeMonitorScroll, true);
      shrink.addEventListener('scroll', me.onSizeMonitorScroll, true); // Also need to fake a resize-scroll on DOM mutation

      (handler.targetMutationMonitor = new MutationObserver(m => {
        const changedNodes = [];

        for (const mr of m) {
          if (mr.type === 'childList') {
            changedNodes.push.apply(changedNodes, mr.removedNodes);
            changedNodes.push.apply(changedNodes, mr.addedNodes);
          }
        } // If the changed nodes were absolutely positioned, then they won't
        // cause a resize, so return


        if (changedNodes.length > 0 && changedNodes.every(isAbsolutelyPositioned)) {
          return;
        } // HACK!
        // Although expand should be `b-resize-monitor-expand` element, id Edge 18 it might not be the case.
        // SimpleEventEditor.t.js in Scheduler shows this when you dragcreate event. At some point real expand element
        // get removed from DOM and we get smth like `b-sch-event-content` here, which is totally different element.
        // Reference is the same, it passes === check! So this is a sanity check to not trigger resizes when element
        // is incorrect.


        if ((_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) && !expand.classList.contains('b-resize-monitor-expand')) {
          return;
        } // We only want the size monitor listener to trigger, so this event must NOT bubble
        // to any application or other framework listeners.


        expand.dispatchEvent(new CustomEvent('scroll', {
          bubbles: false
        }));
      })).observe(element, {
        childList: true,
        subtree: true
      }); // store reference for easier cleanup later

      handler.monitorElement = monitors;
    }

    element._bResizemonitor.handlers.push(handler);
  }
  /**
   * Removes a resize listener from the passed element.
   * @param {HTMLElement} element The element to listen for resizing.
   * @param {Function} handler The handling function to remove.
   */


  static removeResizeListener(element, handler) {
    if (element) {
      if (element === document || element === window) {
        element = document.body;
      }

      const resizeMonitor = element._bResizemonitor;
      let listenerCount = 0;

      if (resizeMonitor && resizeMonitor.handlers) {
        _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].remove(resizeMonitor.handlers, handler); // See if we should unobserve the element

        listenerCount = resizeMonitor.handlers.length;
      } // Down to no listeners.


      if (!listenerCount) {
        element.classList.remove('b-resize-monitored');

        if (this.resizeObserver) {
          this.resizeObserver.unobserve(element);
        } // Remove the polyfill resize listeners
        else {
          // remove any added elements
          if (handler.monitorElement) {
            handler.monitorElement.remove();
            handler.monitorElement = null;
          } // remove the DOM mutation observer


          if (handler.targetMutationMonitor) {
            handler.targetMutationMonitor.disconnect();
          }
        }
      }
    }
  }

  static onElementResize(entries) {
    for (const resizeObserverEntry of entries) {
      const resizedElement = resizeObserverEntry.target,
            resizeMonitor = resizedElement._bResizemonitor,
            newRect = resizeObserverEntry.contentRect || resizedElement.getBoundingClientRect();

      if (resizedElement.offsetParent) {
        if (!resizeMonitor.rectangle || newRect.width !== resizeMonitor.rectangle.width || newRect.height !== resizeMonitor.rectangle.height) {
          const oldRect = resizeMonitor.rectangle;
          resizeMonitor.rectangle = newRect;

          for (const resizeHandler of resizeMonitor.handlers) {
            resizeHandler(resizedElement, oldRect, newRect);
          }
        }
      }
    }
  }

  static onSizeMonitorScroll(e) {
    var _document$body;

    // If no body exists or the element has gone, ignore the event; the listener will be removed automatically.
    if ((_document$body = document.body) !== null && _document$body !== void 0 && _document$body.contains(e.target)) {
      e.stopImmediatePropagation();
      const monitorNode = e.target.parentNode,
            resizedElement = monitorNode.parentNode,
            resizeMonitor = resizedElement._bResizemonitor,
            newRect = resizedElement.getBoundingClientRect();

      if (!resizeMonitor.rectangle || newRect.width !== resizeMonitor.rectangle.width || newRect.height !== resizeMonitor.rectangle.height) {
        resizedQueue.push([resizedElement, resizeMonitor.rectangle, newRect]);
        resizeMonitor.rectangle = newRect;

        if (!resizeFireTimer) {
          resizeFireTimer = requestAnimationFrame(ResizeMonitor.fireResizeEvents);
        }
      }

      monitorNode.firstChild.scrollLeft = monitorNode.firstChild.scrollTop = monitorNode.childNodes[1].scrollTop = monitorNode.childNodes[1].scrollLeft = 1000000;
    }
  }

  static onWindowResize(e) {
    const resizedElement = document.body,
          resizeMonitor = resizedElement._bResizemonitor,
          oldRect = resizeMonitor.rectangle;
    resizeMonitor.rectangle = document.documentElement.getBoundingClientRect();

    for (const resizeHandler of resizeMonitor.handlers) {
      resizeHandler(resizedElement, oldRect, resizeMonitor.rectangle);
    }
  }

  static fireResizeEvents() {
    for (const resizedEntry of resizedQueue) {
      for (const resizeHandler of resizedEntry[0]._bResizemonitor.handlers) {
        // Checking offsetParent to avoid resizing of elements which are not visible or exist in DOM
        if (resizedEntry[0].offsetParent) {
          resizeHandler.apply(this, resizedEntry);
        }
      }
    }

    resizeFireTimer = null;
    resizedQueue.length = 0;
  }

}
ResizeMonitor._$name = 'ResizeMonitor';

/***/ }),

/***/ "./lib/Core/helper/StringHelper.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/StringHelper.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StringHelper; });
/* harmony import */ var _VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'taskboard'; // IMPORTANT - adding imports here can create problems for Base class


/**
 * @module Core/helper/StringHelper
 */

let charsToEncode, entitiesToDecode, htmlEncodeRe, htmlDecodeRe;

const camelLettersRe = /([a-z])([A-Z])/g,
      crlfRe = /[\n\r]/g,
      escapeRegExpRe = /[.*+?^${}()|[\]\\]/g,
      // same as NPM escape-string-regexp
htmlRe = /[&<]/,
      idRe = /(^[^a-z]+[^\w]+)/gi,
      whiteSpaceRe = /\s+/,
      htmlDecoder = (m, captured) => entitiesToDecode[captured.toLowerCase()] || String.fromCharCode(parseInt(captured.substr(2), 10)),
      htmlEncoder = (m, captured) => charsToEncode[captured],
      hyphenateCamelLetters = (all, g1, g2) => {
  return `${g1}-${g2.toLowerCase()}`;
},
      separateCamelLetters = (all, g1, g2) => {
  return `${g1} ${g2.toLowerCase()}`;
},
      replaceNonIdChar = c => {
  if (c) {
    return `_x${[...c].map(ch => ch.charCodeAt(0).toString(16)).join('')}`;
  }

  return '__blank__';
},
      hyphenateCache = {},
      separatedCache = {};
/**
 * Helper for string manipulation.
 */


class StringHelper {
  //region Transform

  /**
   * Capitalizes the first letter of a string, "myString" -> "MyString".
   * @param {String} string The string to capitalize
   * @returns {String} The capitalized string or the value of `string` if falsy.
   * @category String formatting
   */
  static capitalize(string) {
    return string && string[0].toUpperCase() + string.substr(1);
  }
  /**
   * Capitalizes the first letter of a string, "myString" -> "MyString".
   * If the parameter is falsy, `null` is returned.
   * @param {String} string The string to capitalize
   * @returns {String} The capitalized string or `null` if `string` is falsy.
   * @deprecated 4.0 Use {@link #function-capitalize} instead.
   * @category String formatting
   */


  static capitalizeFirstLetter(string) {
    _VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].deprecate('Core', '5.0.0', 'Deprecated in favor of `capitalize()`, will be removed in 5.0');
    return string ? string[0].toUpperCase() + string.substr(1) : null;
  }
  /**
   * Makes the first letter of a string lowercase, "MyString" -> "myString".
   * If the parameter is falsy, `null` is returned.
   * @param {String} string The string to lowercase.
   * @returns {String} The lowercased string or `null` if `string` is falsy.
   * @deprecated 4.0 Use {@link #function-uncapitalize} instead.
   * @category String formatting
   */


  static lowercaseFirstLetter(string) {
    _VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].deprecate('Core', '5.0.0', 'Deprecated in favor of `uncapitalize()`, will be removed in 5.0');

    if (!string) {
      return null;
    }

    return string[0].toLowerCase() + string.substr(1);
  }
  /**
   * Makes the first letter of a string lowercase, "MyString" -> "myString".
   * @param {String} string The string to un-capitalize.
   * @returns {String} The un-capitalized string or the value of `string` if falsy.
   * @category String formatting
   */


  static uncapitalize(string) {
    return string && string[0].toLowerCase() + string.substr(1);
  }
  /**
   * Converts the passed camelCased string to a hyphen-separated string. eg "minWidth" -> "min-width"
   * @param {String} string The string to convert.
   * @return {String} The string with adjoining lower and upper case letters
   * separated by hyphens and converted to lower case.
   * @category String formatting
   * @internal
   */


  static hyphenate(string) {
    // Cached since it is used heavily with DomHelper.sync()
    const cached = hyphenateCache[string];

    if (cached) {
      return cached;
    }

    return hyphenateCache[string] = string.replace(camelLettersRe, hyphenateCamelLetters);
  }
  /**
   * Converts the passed camelCased string to a capitalized, space-separated string. eg "startDate" -> "Start date".
   * @param {String} string The string to convert.
   * @return {String} The string with spaces separating words.
   * @category String formatting
   * @internal
   */


  static separate(string) {
    // Cached since it may be used heavily
    const cached = separatedCache[string];

    if (cached) {
      return cached;
    }

    return separatedCache[string] = this.capitalize(string.replace(camelLettersRe, separateCamelLetters));
  }
  /**
   * Creates an alphanumeric identifier from any passed string. Encodes spaces and non-alpha characters.
   * @param {String} inString The string from which to strip non-identifier characters.
   * @return {String}
   * @category Misc
   * @internal
   */


  static createId(inString) {
    return String(inString).replace(idRe, replaceNonIdChar);
  } //endregion
  //region Html


  static escapeRegExp(string, flags) {
    // $& means the whole matched string
    let ret = string.replace(escapeRegExpRe, '\\$&');

    if (flags !== undefined) {
      ret = new RegExp(ret, flags);
    }

    return ret;
  }
  /**
   * This method decodes HTML entities and returns the original HTML.
   *
   * See also {@link #function-encodeHtml-static}.
   * @param {String} str
   * @returns {String}
   * @category HTML
   */


  static decodeHtml(str) {
    return str && String(str).replace(htmlDecodeRe, htmlDecoder);
  }
  /**
   * This method encodes HTML entities and returns a string that can be placed in the document and produce the
   * original text rather than be interpreted as HTML. Using this method with user-entered values prevents those
   * values from executing as HTML (i.e., a cross-site scripting or "XSS" security issue).
   *
   * See also {@link #function-decodeHtml-static}.
   * @param {String} str
   * @returns {String}
   * @category HTML
   */


  static encodeHtml(str) {
    return str && String(str).replace(htmlEncodeRe, htmlEncoder);
  }
  /**
   * This method is similar to {@link #function-encodeHtml-static} except that `\n` and `\r` characters in the
   * given `str` are replaced by `<br>` tags _after_ first being encoded by {@link #function-encodeHtml-static}.
   * @param {String} str
   * @returns {String}
   * @category HTML
   * @internal
   */


  static encodeHtmlBR(str) {
    var _StringHelper$encodeH;

    return (_StringHelper$encodeH = StringHelper.encodeHtml(str)) === null || _StringHelper$encodeH === void 0 ? void 0 : _StringHelper$encodeH.replace(crlfRe, '<br>');
  }
  /**
   * Returns `true` if the provided `text` contains special HTML characters.
   * @param {String} text
   * @returns {Boolean}
   * @category HTML
   * @internal
   */


  static isHtml(text) {
    return typeof text === 'string' && htmlRe.test(text || '');
  }
  /**
   * Initializes HTML entities used by {@link #function-encodeHtml-static} and {@link #function-decodeHtml-static}.
   * @param {Object} [mappings] An object whose keys are characters that should be encoded and values are the HTML
   * entity for the character.
   * @private
   */


  static initHtmlEntities(mappings) {
    mappings = mappings || {
      '&': '&amp;',
      '>': '&gt;',
      '<': '&lt;',
      '"': '&quot;',
      "'": '&#39;'
    };
    const chars = Object.keys(mappings); // Maps '<' to '&lt;'

    charsToEncode = mappings; // Inverts the mapping so we can convert '&lt;' to '<'

    entitiesToDecode = chars.reduce((prev, val) => {
      prev[mappings[val]] = val;
      return prev;
    }, {}); // Creates a regex char set like /([<&>])/g to match the characters that need to be encoded (escaping any of
    // the regex charset special chars '[', ']' and '-'):

    htmlEncodeRe = new RegExp(`([${chars.map(c => '[-]'.includes(c) ? '\\' + c : c).join('')}])`, 'g'); // Creates a regex like /(&lt;|&amp;|&gt;)/ig to match encoded entities... good news is that (valid) HTML
    // entities do not contain any regex special characters:

    htmlDecodeRe = new RegExp(`(${Object.values(mappings).join('|')}|&#[0-9]+;)`, 'ig');
  } //endregion
  //region JSON

  /**
   * Parses JSON inside a try-catch block. Returns null if the string could not be parsed.
   *
   * @param {String} string String to parse
   * @returns {Object} Resulting object or null if parse failed
   * @category JSON
   */


  static safeJsonParse(string) {
    let parsed = null;

    try {
      parsed = JSON.parse(string);
    } catch (e) {}

    return parsed;
  }
  /**
   * Stringifies an object inside a try-catch block. Returns null if an exception is encountered.
   *
   * See [JSON.stringify on MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify)
   * for more information on the arguments.
   *
   * @param {Object} object The object to stringify
   * @param {Function|String[]|Number[]} [replacer] A function or array of string/number used to determine properties
   * to include in the JSON string
   * @param {String|Number} [space] Number of spaces to indent or string used as whitespace
   * @returns {Object} Resulting object or null if stringify failed
   * @category JSON
   */


  static safeJsonStringify(object, replacer = null, space = null) {
    let result = null;

    try {
      result = JSON.stringify(object, replacer, space);
    } catch (e) {}

    return result;
  } //endregion
  //region Split & join

  /**
   * Joins all given paths together using the separator as a delimiter and normalizes the resulting path.
   * @param paths {Array} array of paths to join
   * @param pathSeparator [{String}] path separator. Default value is '/'
   * @return {String}
   * @category Misc
   * @internal
   */


  static joinPaths(paths, pathSeparator = '/') {
    return paths.join(pathSeparator).replace(new RegExp('\\' + pathSeparator + '+', 'g'), pathSeparator);
  }
  /**
   * Returns the provided string split on whitespace. If the string is empty or consists of only whitespace, the
   * returned array will be empty. If `str` is not a string, it is simply returned. This allows `null` or already
   * split strings (arrays) to be passed through.
   *
   * For example:
   * ```
   *  console.log(StringHelper.split(' abc def xyz   '));
   *  > ['abc', 'def', 'xyz']
   *  console.log(StringHelper.split(''));
   *  > []
   * ```
   * Compare to the standard `split()` method:
   * ```
   *  console.log(' abc def xyz   '.split(/\s+/));
   *  > ['', 'abc', 'def', 'xyz', '']
   *  console.log(''.split(/\s+/));
   *  > ['']
   * ```
   * @param {String} str
   * @param {String|RegExp} delimiter
   * @returns {String[]}
   * @category Misc
   * @internal
   */


  static split(str, delimiter = whiteSpaceRe) {
    let ret = str;

    if (typeof ret === 'string') {
      ret = str.trim(); // w/o trim() whitespace on the ends will give us '' in the array

      ret = ret ? ret.split(delimiter) : []; // also ''.split() = ['']
    }

    return ret;
  } //endregion
  //region XSS

  /**
   * This is a tagged template function that performs HTML encoding on replacement values to avoid XSS (Cross-Site
   * Scripting) attacks.
   *
   * For example:
   *
   * ```javascript
   *  eventRenderer(eventRecord) {
   *      return StringHelper.xss`<span class="${eventRecord.attrib}">${eventRecord.name}</span>`;
   *  }
   * ```
   *
   * See {@link Core.helper.StringHelper#function-encodeHtml-static}.
   */


  static xss(strings, ...values) {
    const buf = [];
    let i = values.length;
    buf[i] = strings[i];

    while (i-- > 0) {
      buf[i] = strings[i] + StringHelper.encodeHtml(values[i]);
    }

    return buf.join('');
  }
  /**
   * This is a tagged template function that performs HTML encoding on replacement values to avoid XSS (Cross-Site
   * Scripting) attacks. Unlike {@link Core.helper.StringHelper#function-xss-static}, this method converts `\n` and
   * `\r` characters into `<br>` tags.
   *
   * For example:
   *
   * ```javascript
   *  eventRenderer(eventRecord) {
   *      return StringHelper.xssBR`<span class="${eventRecord.attrib}">${eventRecord.name}</span>`;
   *  }
   * ```
   *
   * See {@link Core.helper.StringHelper#function-encodeHtmlBR-static}.
   * @internal
   */


  static xssBR(strings, ...values) {
    const buf = [];
    let i = values.length;
    buf[i] = strings[i];

    while (i-- > 0) {
      buf[i] = strings[i] + StringHelper.encodeHtmlBR(values[i]);
    }

    return buf.join('');
  } //endregion


}
StringHelper.initHtmlEntities();
StringHelper._$name = 'StringHelper';

/***/ }),

/***/ "./lib/Core/helper/TemplateHelper.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/TemplateHelper.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TemplateHelper; });
var productName = 'taskboard';
/**
* @module Core/helper/TemplateHelper
*/

const tagSpaceRe = />[ \t\r\n]+</g,
      multiSpaceRe = /\s\s+/g;
/**
 * Helper for template strings, use as tag function
 * @example
 * TemplateHelper.tpl`...`
 * @internal
 */

class TemplateHelper {
  /**
   * Tag function for template literals that does some basic cleanup
   * @private
   */
  static tpl(strings, ...values) {
    let count = 0,
        output = values.map((val, i) => {
      // TODO: pad output nicely instead of just trimming away
      let ret = strings[i];

      if (Array.isArray(val)) {
        ret += val.reduce((ack, item) => ack += (typeof item === 'string' ? item.trim() : item) + '\n', '');
      } else {
        if (val === undefined) {
          val = '';
        }

        ret += typeof val === 'string' ? val.trim() : val;
      }

      count++;
      return ret;
    }).join('');

    if (count <= strings.length) {
      output += strings[strings.length - 1];
    } // Excise unnecessary *soft* whitespace textNodes. We cannot use \s because that
    // matches non-breaking spaces which need to be preserved.
    // Also reduce any usage of multiple spaces to single, since they have no value in html


    return output.replace(tagSpaceRe, '><').replace(multiSpaceRe, ' ').trim();
  }
  /**
   * Tag function for template literals that does some basic cleanup. Version for docs that do not remove blank space,
   * to keep code snippets formatting intact.
   * @private
   */


  static docsTpl(strings, ...values) {
    let count = 0,
        output = values.map((val, i) => {
      // TODO: pad output nicely instead of just trimming away
      let str = strings[i],
          ret = str;

      if (Array.isArray(val)) {
        ret += val.reduce((ack, item) => ack += (typeof item === 'string' ? item.trim() : item) + '\n', '');
      } else {
        if (val === undefined) {
          val = '';
        }

        ret += typeof val === 'string' ? val.trim() : val;
      }

      count++;
      return ret;
    }).join('');

    if (count <= strings.length) {
      output += strings[strings.length - 1];
    } // Excise unnecessary *soft* whitespace textNodes. We cannot use \s because that
    // matches non-breaking spaces which need to be preserved.


    return output.replace(tagSpaceRe, '><').trim();
  }

  static repeat(times) {
    return function (...args) {
      return TemplateHelper.tpl(...args).repeat(times);
    };
  }

  static loop(times) {}

}
TemplateHelper._$name = 'TemplateHelper';

/***/ }),

/***/ "./lib/Core/helper/VersionHelper.js":
/*!******************************************!*\
  !*** ./lib/Core/helper/VersionHelper.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VersionHelper; });
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'taskboard';

/**
 * @module Core/helper/VersionHelper
 */

let isSiesta = false;

try {
  isSiesta = Boolean(_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].global.parent && _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].global.parent.Siesta || typeof process !== 'undefined' && (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].global.StartTest || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].global.Siesta));
} catch (e) {} // Set Default to hoverable device for our tests to run reliably


if (isSiesta) {
  _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"]._isHoverableDevice = true;
}
/**
 * Helper for version handling
 * @private
 * @example
 *
 * VersionHelper.setVersion('grid', '1.5');
 *
 * if (VersionHelper.getVersion('grid').isNewerThan('1.0')) {
 *   ...
 * }
 */


class VersionHelper {
  /**
   * Set version for specified product
   * @private
   * @param {String} product
   * @param {String} version
   */
  static setVersion(product, version) {
    product = product.toLowerCase();
    VH[product] = {
      version,

      isNewerThan(otherVersion) {
        return otherVersion < version;
      },

      isOlderThan(otherVersion) {
        return otherVersion > version;
      }

    };
    let bundleFor = ''; // Var productName is only defined in bundles, it is internal to bundle so not available on window. Used to
    // tell importing combinations of grid/scheduler/gantt bundles apart from loading same bundle twice
    // eslint-disable-next-line no-undef

    if (typeof productName !== 'undefined') {
      // eslint-disable-next-line no-undef
      bundleFor = productName;
    } // Set "global" flag to detect bundle being loaded twice


    const globalKey = `${bundleFor}.${product}${version.replace(/\./g, '-')}`;

    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBrowserEnv && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].global.bryntum.silenceBundleException) {
      if (window.bryntum[globalKey] === true) {
        if (isSiesta) {
          window.BUNDLE_EXCEPTION = true;
        } else {
          throw new Error('Bryntum bundle included twice, check cache-busters and file types (.js).\n' + 'Simultaneous imports from "*.module.js" and "*.umd.js" bundles are not allowed.');
        }
      } else {
        window.bryntum[globalKey] = true;
      }
    }
  }
  /**
   * Get (previously set) version for specified product
   * @private
   * @param {String} product
   */


  static getVersion(product) {
    product = product.toLowerCase();

    if (!VH[product]) {
      throw new Error('No version specified! Please check that you import VersionHelper right into the class from where you call `deprecate` function.');
    }

    return VH[product].version;
  }
  /**
   * Checks the passed product against the passed version using the passed test.
   * @param {String} product The name of the product to test the version of
   * @param {String} version The version to test against
   * @param {String} test The test operator, `<=`, `<`, `=`, `>` or `>=`.
   * @returns {Boolean} `true` if the test passes.
   * @internal
   */


  static checkVersion(product, version, test) {
    const productVersion = VH.getVersion(product);
    let result;

    switch (test) {
      case '<':
        result = productVersion < version;
        break;

      case '<=':
        result = productVersion <= version;
        break;

      case '=':
        result = productVersion === version;
        break;

      case '>=':
        result = productVersion >= version;
        break;

      case '>':
        result = productVersion > version;
        break;
    }

    return result;
  }
  /**
   * Based on a comparison of current product version and the passed version this method either outputs a console.warn
   * or throws an error.
   * @param {String} product The name of the product
   * @param {String} invalidAsOfVersion The version where the offending code is invalid (when any compatibility layer
   * is actually removed).
   * @param {String} message Required! A helpful warning message to show to the developer using a deprecated API.
   * @internal
   */


  static deprecate(product, invalidAsOfVersion, message) {
    const justWarn = VH.checkVersion(product, invalidAsOfVersion, '<');

    if (justWarn) {
      // During the grace period (until the next major release following the deprecated code), just show a console warning
      console.warn(`Deprecation warning: You are using a deprecated API which will change in v${invalidAsOfVersion}. ${message}`);
    } else {
      throw new Error(`Deprecated API use. ${message}`);
    }
  }
  /**
   * Returns truthy value if environment is in testing mode.
   * @returns {Boolean}
   * @internal
   **/


  static get isTestEnv() {
    return isSiesta;
  }

  static get isDebug() {
    let result = false;
    return result;
  }

}
const VH = VersionHelper;

if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBrowserEnv) {
  (window.bryntum || (window.bryntum = {})).getVersion = VH.getVersion.bind(VH);
  window.bryntum.checkVersion = VH.checkVersion.bind(VH);
  window.bryntum.deprecate = VH.deprecate.bind(VH);
  window.bryntum.isTestEnv = VH.isTestEnv;
}

VersionHelper._$name = 'VersionHelper';
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../node_modules/process/browser.js */ "../node_modules/process/browser.js")))

/***/ }),

/***/ "./lib/Core/helper/WalkHelper.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/WalkHelper.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WalkHelper; });
var productName = 'taskboard';
/**
* @module Core/helper/WalkHelper
*/

/**
 * Tree walking helper
 * @internal
 */

class WalkHelper {
  /**
   * Pre-walks any hierarchical data structure
   *
   * @param data Walking starting point
   * @param {Function} childrenFn Function to return `data` children entries in an array
   *                   or null if no children exists for the entry
   * @param {Function} fn Function to call on each entry
   */
  static preWalk(data, childrenFn, fn) {
    const walkStack = [data];
    let node, children;

    while (walkStack.length) {
      node = walkStack.pop();
      fn(node);
      children = childrenFn(node);

      if (children) {
        walkStack.push.apply(walkStack, children.slice().reverse());
      }
    }
  }
  /**
   * Pre-walks any hierarchical data structure, passing along a link to the parent node
   *
   * @param data Walking starting point
   * @param {Function} childrenFn Function to return `data` children entries in an array
   *                   or null if no children exists for the entry
   * @param {Function} fn Function to call on each entry, called with `parent` and `node`
   */


  static preWalkWithParent(data, childrenFn, fn) {
    const walkStack = [{
      node: data,
      parent: null
    }];

    while (walkStack.length) {
      const {
        parent,
        node
      } = walkStack.pop();
      fn(parent, node);
      const children = childrenFn(node);

      if (Array.isArray(children)) {
        walkStack.push(...children.slice().reverse().map(child => ({
          node: child,
          parent: node
        })));
      }
    }
  }
  /**
   * Pre-walk unordered.
   *
   * Like {@link #function-preWalk-static preWalk} but doesn't reverses children before walk,
   * thus children will be walked last child first - first child last
   *
   * @param data Walking starting point
   * @param {Function} childrenFn Function to return `data` children entries in an array
   *                   or null if no children exists for the entry
   * @param {Function} fn Function to call on each entry
   */


  static preWalkUnordered(data, childrenFn, fn) {
    let walkStack = [data],
        node,
        children;

    while (walkStack.length) {
      node = walkStack[walkStack.length - 1];
      fn(node);
      children = childrenFn(node);

      if (children) {
        walkStack.splice(walkStack.length - 1, 1, ...children);
      } else {
        walkStack.length = walkStack.length - 1;
      }
    }
  }
  /**
   * Post-walks any hierarchical data structure
   *
   * @param data Walking starting point
   * @param {Function} childrenFn Function to return `data` children entries in an array
   *                   or null if no children exists for the entry
   * @param {Function} fn Function to call on each entry
   */


  static postWalk(data, childrenFn, fn) {
    let visited = new Map(),
        walkStack = [data],
        node,
        children;

    while (walkStack.length) {
      node = walkStack[walkStack.length - 1];

      if (visited.has(node)) {
        fn(node);
        walkStack.pop();
      } else {
        children = childrenFn(node);

        if (children) {
          walkStack = walkStack.concat(children.slice().reverse());
        }

        visited.set(node, node);
      }
    }
  }
  /**
   * Pre/Post-walks any hierarchical data structure calling inFn each node when it walks in,
   * and outFn when it walks out.
   *
   * @param data Walking starting point
   * @param {Function} childrenFn Function to return `data` children entries in an array
   *                   or null if no children exists for the entry
   * @param {Function} inFn  Function to call on each entry upon enter
   * @param {Function} outFn Function to call on each entry upon exit
   */


  static prePostWalk(data, childrenFn, inFn, outFn) {
    let visited = new Map(),
        walkStack = [data],
        node,
        children;

    while (walkStack.length) {
      node = walkStack[walkStack.length - 1];

      if (visited.has(node)) {
        outFn(node);
        walkStack.pop();
      } else {
        inFn(node);
        children = childrenFn(node);

        if (children) {
          walkStack = walkStack.concat(children.slice().reverse());
        }

        visited.set(node, node);
      }
    }
  }

}
WalkHelper._$name = 'WalkHelper';

/***/ }),

/***/ "./lib/Core/helper/WidgetHelper.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/WidgetHelper.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetHelper; });
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _widget_Toast_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../widget/Toast.js */ "./lib/Core/widget/Toast.js");
/* harmony import */ var _widget_Mask_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../widget/Mask.js */ "./lib/Core/widget/Mask.js");
/* harmony import */ var _util_Point_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/Point.js */ "./lib/Core/helper/util/Point.js");
var productName = 'taskboard';





/**
 * @module Core/helper/WidgetHelper
 */

/**
 * Helper for creating widgets.
 */

class WidgetHelper {
  //region Querying

  /**
   * Returns the widget with the specified id.
   * @param {String} Id of widget to find
   * @returns {Core.widget.Widget} The widget if any
   * @category Querying
   */
  static getById(id) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].getById(id);
  }
  /**
   * Returns the Widget which owns the passed element (or event).
   * @param {HTMLElement|Event} element The element or event to start from
   * @param {String|Function} [type] The type of Widget to scan upwards for. The lowercase
   * class name. Or a filter function which returns `true` for the required Widget.
   * @param {HTMLElement|Number} [limit] The number of components to traverse upwards to find a
   * match of the type parameter, or the element to stop at.
   * @returns {Core.widget.Widget} The found Widget or null.
   * @category Querying
   */


  static fromElement(element, type, limit) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].fromElement(element, type, limit);
  } //endregion
  //region Widgets

  /**
   * Create a widget.
   * @example
   * WidgetHelper.createWidget({
   *   type: 'button',
   *   icon: 'user',
   *   text: 'Edit user'
   * });
   * @param {Object} config Widget config
   * @returns {Object} The widget
   * @category Widgets
   */


  static createWidget(config = {}) {
    return config.isWidget ? config : _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].create(config);
  }
  /**
   * Appends a widget (array of widgets) to the DOM tree. If config is empty, widgets are appended to the DOM. To
   * append widget to certain position you can pass HTMLElement or its id as config, or as a config, that will be
   * applied to all passed widgets.
   *
   * Usage:
   *
   * ```javascript
   * // Will append button as last item to element with id 'container'
   * let [button] = WidgetHelper.append({ type : 'button' }, 'container');
   *
   * // Same as above, but will add two buttons
   * let [button1, button2] = WidgetHelper.append([
   *     { type : 'button' },
   *     { type : 'button' }
   *     ], { appendTo : 'container' });
   *
   * // Will append two buttons before element with id 'someElement'. Order will be preserved and all widgets will have
   * // additional class 'my-cls'
   * let [button1, button2] = WidgetHelper.append([
   *     { type : 'button' },
   *     { type : 'button' }
   *     ], {
   *         insertBefore : 'someElement',
   *         cls          : 'my-cls'
   *     });
   * ```
   *
   * @param {Object|Object[]} widget Widget config or array of such configs
   * @param {HTMLElement|String|Object} [config] Element (or element id) to which to append the widget or config to apply to all passed widgets
   * @returns {Core.widget.Widget[]} Array or widgets
   * @category Widgets
   */


  static append(widget, config) {
    widget = Array.isArray(widget) && widget || [widget];

    if (config instanceof HTMLElement || typeof config === 'string') {
      config = {
        appendTo: config
      };
    } // We want to fix position to insert into to keep order of passed widgets


    if (config.insertFirst) {
      const target = typeof config.insertFirst === 'string' ? document.getElementById(config.insertFirst) : config.insertFirst;

      if (target.firstChild) {
        config.insertBefore = target.firstChild;
      } else {
        config.appendTo = target;
      }
    }

    return widget.map(item => _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].create(_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assign({}, config || {}, item)));
  } //endregion
  //region Popups

  /**
   * Shows a popup (~tooltip) containing widgets connected to specified element.
   * @example
   * WidgetHelper.openPopup(element, {
   *   position: 'bottom center',
   *   items: [
   *      { widgetConfig }
   *   ]
   * });
   * @param {HTMLElement} element Element to connect popup to
   * @param {Object} config Config object, or string to use as html in popup
   * @returns {*|{close, widgets}}
   * @category Popups
   */


  static openPopup(element, config) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].create(_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assign({
      forElement: element
    }, typeof config === 'string' ? {
      html: config
    } : config), 'popup');
  }
  /**
   * Shows a context menu connected to the specified element.
   * @example
   * WidgetHelper.showContextMenu(element, {
   *   items: [
   *      { id: 'addItem', icon: 'add', text: 'Add' },
   *      ...
   *   ],
   *   onItem: item => alert('Clicked ' + item.text)
   * });
   * @param {HTMLElement|Number[]} element Element (or a coordinate) to show the context menu for
   * @param {Object} config Context menu config, see example
   * @returns {*|{close}}
   * @category Popups
   */


  static showContextMenu(element, config) {
    const me = this;

    if (me.currentContextMenu) {
      me.currentContextMenu.destroy();
    }

    if (element instanceof HTMLElement) {
      config.forElement = element;
    } else if (Array.isArray(element)) {
      config.forElement = {
        target: new _util_Point_js__WEBPACK_IMPORTED_MODULE_4__["default"](...element)
      };
    } else if (element instanceof _util_Point_js__WEBPACK_IMPORTED_MODULE_4__["default"]) {
      config.forElement = {
        target: element
      };
    }

    me.currentContextMenu = _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].create(config, 'menu');
    me.currentContextMenu.on('destroy', () => {
      me.currentContextMenu = null;
    });
    return me.currentContextMenu;
  }
  /**
   * Attached a tooltip to the specified element.
   * @example
   * WidgetHelper.attachTooltip(element, {
   *   text: 'Useful information goes here'
   * });
   * @param {HTMLElement} element Element to attach tooltip for
   * @param {String|Object} configOrText Tooltip config or tooltip string, see example and source
   * @returns {Object}
   * @category Popups
   */


  static attachTooltip(element, configOrText) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].attachTooltip(element, configOrText);
  }
  /**
   * Checks if element has tooltip attached
   *
   * @param {HTMLElement} element Element to check
   * @return {Boolean}
   * @category Popups
   */


  static hasTooltipAttached(element) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].resolveType('tooltip').hasTooltipAttached(element);
  }
  /**
   * Destroys any tooltip attached to an element, removes it from the DOM and unregisters any tip related listeners
   * on the element.
   *
   * @param {HTMLElement} element Element to remove tooltip from
   * @category Popups
   */


  static destroyTooltipAttached(element) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].resolveType('tooltip').destroyTooltipAttached(element);
  } //endregion
  //region Mask

  /**
   * Masks the specified element, showing a message in the mask.
   * @param {HTMLElement} element Element to mask
   * @param {String} msg Message to show in the mask
   * @category Mask
   */


  static mask(element, msg = 'Loading') {
    if (element) {
      // Config object normalization
      if (element instanceof HTMLElement) {
        element = {
          target: element,
          text: msg
        };
      }

      return _widget_Mask_js__WEBPACK_IMPORTED_MODULE_3__["default"].mask(element, element.target);
    }
  }
  /**
   * Unmask the specified element.
   * @param {HTMLElement} element
   * @category Mask
   */


  static unmask(element, close = true) {
    if (element.mask) {
      if (close) {
        element.mask.close();
      } else {
        element.mask.hide();
      }
    }
  } //endregion
  //region Toast

  /**
   * Show a toast
   * @param {String} msg message to show in the toast
   * @category Mask
   */


  static toast(msg) {
    return _widget_Toast_js__WEBPACK_IMPORTED_MODULE_2__["default"].show(msg);
  } //endregion


}
WidgetHelper._$name = 'WidgetHelper';

/***/ }),

/***/ "./lib/Core/helper/XMLHelper.js":
/*!**************************************!*\
  !*** ./lib/Core/helper/XMLHelper.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return XMLHelper; });
/* harmony import */ var _util_Objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'taskboard';


/**
 * @module Core/helper/XMLHelper
 */

/**
 * Helper for XML manipulation.
 */

class XMLHelper {
  /**
   * Convert an javascript object to a XML string.
   *
   * From:
   * ```javascript
   * {
   *     name : 'Task 1',
   *     data : [
   *         {
   *             text : 'foo 1',
   *             ref  : 'fooItem 1'
   *         },
   *         {
   *             text : 'foo 2',
   *             ref  : 'fooItem 2'
   *         }
   *     ]
   * }
   * ```
   *
   * To:
   * ```xml
   * <?xml version="1.0" encoding="UTF-8" standalone="yes"?>
   * <root>
   *     <name>Task 1</name>
   *     <data>
   *         <element>
   *             <text>foo 1</text>
   *             <ref>fooItem 1</ref>
   *         </element>
   *         <element>
   *             <text>foo 2</text>
   *             <ref>fooItem 2</ref>
   *         </element>
   *     </data>
   * </root>
   * ```
   *
   * @param {Object} obj Object to convert.
   * @param {Object} [options] Convert options.
   * @param {String} [options.rootName] Root name for the XML. `root` by default.
   * @param {String} [options.elementName] Element name for each node of the XML. `element` by default.
   * @param {String} [options.xmlns] Add value for xmlns property for the root tag of the XML.
   * @param {Boolean} [options.includeHeader] `false` to not include the header `<?xml version="1.0" encoding="UTF-8"?>` on top of the XML.
   * @param {Boolean} [options.rootElementForArray] `false` to not include a root element for array of items. e.g. for the above example:
   * ```xml
   * <?xml version="1.0" encoding="UTF-8" standalone="yes"?>
   * <root>
   *     <name>Task 1</name>
   *     <element>
   *         <text>foo 1</text>
   *         <ref>fooItem 1</ref>
   *     </element>
   *     <element>
   *         <text>foo 2</text>
   *         <ref>fooItem 2</ref>
   *     </element>
   * </root>
   * ```
   * @returns {String} the XML
   */
  static convertFromObject(obj, options = {}) {
    // override default values
    _util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].assignIf(options, {
      rootName: 'root',
      elementName: 'element',
      includeHeader: true,
      rootElementForArray: true
    });
    const {
      rootName,
      elementName,
      includeHeader,
      rootElementForArray
    } = options;
    let {
      xmlns
    } = options;
    xmlns = xmlns ? ` xmlns="${xmlns}"` : '';
    const header = includeHeader ? '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' : '';

    const converter = o => {
      const xmlItems = [];

      for (const key in o) {
        const item = o[key];

        if (Array.isArray(item)) {
          if (rootElementForArray) {
            xmlItems.push(`<${key}>`);
          }

          for (const subItem of item) {
            if (elementName.length) {
              xmlItems.push(`<${elementName}>`);
            } else {
              xmlItems.push(`<${key}>`);
            }

            xmlItems.push(converter(subItem));

            if (elementName.length) {
              xmlItems.push(`</${elementName}>`);
            } else {
              xmlItems.push(`</${key}>`);
            }
          }

          if (rootElementForArray) {
            xmlItems.push(`</${key}>`);
          }
        } else if (_util_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(item)) {
          xmlItems.push(`<${key}>${converter(item)}</${key}>`);
        } else {
          if (item == null) {
            xmlItems.push(`<${key}/>`);
          } else {
            xmlItems.push(`<${key}>${_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].encodeHtml(item)}</${key}>`);
          }
        }
      }

      return xmlItems.join('');
    };

    return `${header}<${rootName}${xmlns}>${converter(obj)}</${rootName}>`;
  }

}
XMLHelper._$name = 'XMLHelper';

/***/ }),

/***/ "./lib/Core/helper/mixin/DragHelperContainer.js":
/*!******************************************************!*\
  !*** ./lib/Core/helper/mixin/DragHelperContainer.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'taskboard';


 // TODO: Use mousedown pos and not center too reposition

/**
 * @module Core/helper/mixin/DragHelperContainer
 */

/**
 * Mixin for DragHelper that handles dragging elements between containers (or rearranging within)
 *
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class DragHelperContainer extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'DragHelperContainer';
  } //region Init

  /**
   * Initialize container drag mode.
   * @private
   */


  initContainerDrag() {
    const me = this; //use container drag as default mode

    if (!me.mode) me.mode = 'container';
    if (me.mode === 'container' && !me.containers) throw new Error('Container drag mode must specify containers');
  } //endregion
  //region Grab, update, finish

  /**
   * Grab an element which can be dragged between containers.
   * @private
   * @param event
   * @returns {Boolean}
   */


  grabContainerDrag(event) {
    const me = this; // allow specified selectors to prevent drag

    if (!me.ignoreSelector || !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].up(event.target, me.ignoreSelector)) {
      // go up from "handle" to draggable element
      const element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getAncestor(event.target, me.containers, me.outerElement);

      if (element) {
        const box = element.getBoundingClientRect();
        me.context = {
          element,
          valid: true,
          action: 'container',
          offsetX: event.pageX - box.left,
          offsetY: event.pageY - box.top,
          originalPosition: {
            parent: element.parentElement,
            prev: element.previousElementSibling,
            next: element.nextElementSibling
          }
        };
      }

      return true;
    }

    return false;
  }
  /**
   * Starts dragging, called when mouse moves first time after grabbing
   * @private
   * @param event
   */


  startContainerDrag(event) {
    var _outerWidgetEl$parent;

    const {
      context,
      floatRootOwner
    } = this,
          {
      element: dragElement
    } = context,
          clonedNode = dragElement.cloneNode(true),
          box = dragElement.getBoundingClientRect(),
          outerWidgetEl = floatRootOwner === null || floatRootOwner === void 0 ? void 0 : floatRootOwner.element.closest('.b-outer'); // init drag proxy

    clonedNode.classList.add(this.dragProxyCls);
    clonedNode.classList.add(this.draggingCls); // Append drag proxy to float root, fall back to root context node

    ((floatRootOwner === null || floatRootOwner === void 0 ? void 0 : floatRootOwner.floatRoot) || _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getRootElement(dragElement)).appendChild(clonedNode);
    context.dragProxy = clonedNode; // Always set the proxy element width manually, drag target could be sized with flex or % width

    clonedNode.style.width = box.width + 'px';
    clonedNode.style.height = box.height + 'px';
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setTranslateXY(context.dragProxy, box.left, box.top); // style dragged element

    context.dragging = dragElement;
    dragElement.classList.add(this.dropPlaceholderCls); // If element being dragged is also a child of the float root, add +1 to the cloned node z-index

    if (outerWidgetEl !== null && outerWidgetEl !== void 0 && (_outerWidgetEl$parent = outerWidgetEl.parentElement) !== null && _outerWidgetEl$parent !== void 0 && _outerWidgetEl$parent.matches('.b-float-root')) {
      clonedNode.style.zIndex = floatRootOwner.floatRootMaxZIndex + 1;
    }
  }
  /**
   * Move the placeholder element into its new position on valid drag.
   * @private
   * @param event
   */


  updateContainerDrag(event) {
    const me = this,
          context = me.context;
    if (!context.started || !context.targetElement) return;
    const containerElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getAncestor(context.targetElement, me.containers, 'b-gridbase'),
          willLoseFocus = context.dragging && context.dragging.contains(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getActiveElement(context.dragging));

    if (containerElement && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isDescendant(context.element, containerElement)) {
      // dragging over part of self, do nothing
      return;
    } // The dragging element contains focus, and moving it within the DOM
    // will cause focus loss which might affect an encapsulating autoClose Popup.
    // Prevent focus loss handling during the DOM move.


    if (willLoseFocus) {
      _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__["default"].suspendFocusEvents();
    }

    if (containerElement && context.valid) {
      me.moveNextTo(containerElement, event);
    } else {
      // dragged outside of containers, revert position
      me.revertPosition();
    }

    if (willLoseFocus) {
      _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__["default"].resumeFocusEvents();
    }

    event.preventDefault();
  }
  /**
   * Finalize drag, fire drop.
   * @private
   * @param event
   * @fires drop
   */


  finishContainerDrag(event) {
    const me = this,
          context = me.context,
          // extracting variables to make code more readable
    {
      dragging,
      dragProxy,
      valid,
      draggedTo,
      insertBefore,
      originalPosition
    } = context;

    if (dragging) {
      // needs to have a valid target
      context.valid = valid && draggedTo && ( // no drop on self or parent
      dragging !== insertBefore || originalPosition.parent !== draggedTo);

      context.finalize = (valid = context.valid) => {
        // revert if invalid (and context still exists, might have been aborted from outside)
        if (!valid && this.context) {
          me.revertPosition();
        }

        dragging.classList.remove(me.dropPlaceholderCls);
        dragProxy.remove();
        me.reset();
      }; // allow async finalization by setting async to true on context in drop handler,
      // requires implementer to call context.finalize later to finish the drop


      context.async = false;
      me.trigger('drop', {
        context,
        event
      });

      if (!context.async) {
        // finalize immediately
        context.finalize();
      } else {
        context.awaitingFinalization = true;
      }
    }
  }
  /**
   * Aborts a drag operation.
   * @private
   * @param {Boolean} [invalid]
   * @param {Object} [event]
   * @param {Boolean} [silent]
   */


  abortContainerDrag(invalid = false, event = null, silent = false) {
    const me = this,
          context = me.context;

    if (context.dragging) {
      context.dragging.classList.remove(me.dropPlaceholderCls);
      context.dragProxy.remove();
      me.revertPosition();
      me.context = {};
    }

    if (!silent) {
      me.trigger(invalid ? 'drop' : 'abort', {
        context,
        event
      });
    }
  } //endregion
  //region Helpers

  /**
   * Starts a drag operation by creating a proxy and storing which element is being dragged.
   * @private
   */
  // startDrag() {
  //     const context = this.context,
  //           div      = context.element.cloneNode(true);
  //
  //     // init drag proxy
  //     div.classList.add('b-drag-proxy');
  //     document.body.appendChild(div);
  //     context.dragProxy = div;
  //
  //     // style dragged element
  //     context.dragging = context.element;
  //     context.dragging.classList.add('myClass');
  // }

  /**
   * Updates the drag proxy position.
   * @private
   * @param event
   */


  updateContainerProxy(event) {
    const me = this,
          context = me.context,
          proxy = context.dragProxy;
    let newX = event.pageX - context.offsetX,
        newY = event.pageY - context.offsetY;

    if (typeof me.minX === 'number') {
      newX = Math.max(me.minX, newX);
    }

    if (typeof me.maxX === 'number') {
      newX = Math.min(me.maxX - proxy.offsetWidth, newX);
    }

    if (typeof me.minY === 'number') {
      newY = Math.max(me.minY, newY);
    }

    if (typeof me.maxY === 'number') {
      newY = Math.min(me.maxY - proxy.offsetHeight, newY);
    }

    if (me.lockX) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setTranslateY(proxy, newY);
    } else if (me.lockY) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setTranslateX(proxy, newX);
    } else {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setTranslateXY(proxy, newX, newY);
    }

    let targetElement;

    if (event.type === 'touchmove') {
      const touch = event.changedTouches[0];
      targetElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].elementFromPoint(touch.clientX, touch.clientY);
    } else {
      targetElement = event.target;
    }

    context.targetElement = targetElement;
  }
  /**
   * Positions element being dragged in relation to targetElement.
   * @private
   * @param targetElement
   * @param event
   */


  moveNextTo(targetElement, event) {
    const context = this.context,
          dragElement = context.dragging,
          parent = targetElement.parentElement;

    if (targetElement !== dragElement) {
      // dragged over a container and not over self, calculate where to insert
      const centerX = targetElement.getBoundingClientRect().left + targetElement.offsetWidth / 2;

      if (event.pageX < centerX) {
        // dragged left of target center, insert before
        parent.insertBefore(dragElement, targetElement);
        context.insertBefore = targetElement;
      } else {
        // dragged right of target center, insert after
        if (targetElement.nextElementSibling) {
          // check that not dragged to the immediate left of self. in such case, position should not change
          if (targetElement.nextElementSibling !== dragElement) {
            context.insertBefore = targetElement.nextElementSibling;
            parent.insertBefore(dragElement, targetElement.nextElementSibling);
          } else if (!context.insertBefore && dragElement.parentElement.lastElementChild !== dragElement) {
            // dragged left initially, should stay in place (checked in finishContainerDrag)
            // TODO: or flag as invalid drag? since no change...
            context.insertBefore = targetElement.nextElementSibling;
          }
        } else {
          parent.appendChild(dragElement);
          context.insertBefore = null;
        }
      }

      context.draggedTo = parent;
    }
  }
  /**
   * Moves element being dragged back to its original position.
   * @private
   */


  revertPosition() {
    const context = this.context,
          original = context.originalPosition; // revert to correct location

    if (original.next) {
      const isNoop = original.next && original.next.previousSibling === context.dragging || !original.next && context.dragging === original.parent.lastChild;

      if (!isNoop) {
        original.parent.insertBefore(context.dragging, original.next);
      }
    } else {
      original.parent.appendChild(context.dragging);
    } // no target container


    context.draggedTo = null;
  } //endregion


});

/***/ }),

/***/ "./lib/Core/helper/mixin/DragHelperTranslate.js":
/*!******************************************************!*\
  !*** ./lib/Core/helper/mixin/DragHelperTranslate.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
var productName = 'taskboard';




/**
 * @module Core/helper/mixin/DragHelperTranslate
 */

const noScroll = {
  pageXOffset: 0,
  pageYOffset: 0
};
/**
 * Mixin for DragHelper that handles repositioning (translating) an element within its container
 *
 * @mixin
 * @private
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class DragHelperTranslate extends Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__["default"])(Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'DragHelperTranslate';
  } //region Init

  /**
   * Initialize translation drag mode.
   * @private
   */


  initTranslateDrag() {
    const me = this;
    me.mode = me.mode || 'translateXY';

    if (!me.isElementDraggable && me.targetSelector) {
      me.isElementDraggable = element => _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(element, me.targetSelector);
    }
  } //endregion
  //region Grab, update, finish

  /**
   * Grab an element which can be moved using translation.
   * @private
   * @param event
   * @returns {Boolean}
   */


  grabTranslateDrag(event) {
    const me = this,
          element = me.getTarget(event);

    if (element) {
      me.context = {
        valid: true,
        action: me.mode,
        // translateX or translateXY...
        element,
        startPageX: event.pageX,
        startPageY: event.pageY,
        startClientX: event.clientX,
        startClientY: event.clientY
      };
      return true;
    }

    return false;
  }

  getTarget(event) {
    return _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(event.target, this.targetSelector);
  }
  /**
   * Start translating, called on first mouse move after dragging
   * @private
   * @param event
   */


  startTranslateDrag(event) {
    const me = this,
          context = me.context,
          {
      relatedElements
    } = context;
    let element = context.dragProxy || context.element;

    if (element && !context.started) {
      const grabbed = element,
            grabbedParent = element.parentElement,
            // When cloning an element to be dragged, we place it in BODY by default
      dragWithin = me.dragWithin = me.dragWithin || me.cloneTarget && document.body,
            outerElement = me.outerElement;

      if (me.cloneTarget) {
        const offsetX = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getOffsetX(element, dragWithin),
              offsetY = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getOffsetY(element, dragWithin),
              offsetWidth = element.offsetWidth,
              offsetheight = element.offsetHeight;
        element = me.createProxy(element); // Match the grabbed element's size and position.

        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateXY(element, offsetX, offsetY);
        element.style.width = `${offsetWidth}px`;
        element.style.height = `${offsetheight}px`;
        element.classList.add(me.dragProxyCls);
        dragWithin.appendChild(element);
        grabbed.classList.add('b-drag-original');

        if (me.hideOriginalElement) {
          grabbed.classList.add('b-hidden');
        }
      }

      Object.assign(me.context, {
        // The element which we're moving, could be a cloned version of grabbed, or the grabbed element itself
        element,
        // The original element upon which the mousedown event triggered a drag operation
        grabbed,
        // The parent of the original element where the pointerdown was detected - to be able to restore after an invalid drop
        grabbedParent,
        // The next sibling of the original element where the pointerdown was detected - to be able to restore after an invalid drop
        grabbedNextSibling: element.nextElementSibling,
        // elements position within parent element
        elementStartX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getTranslateX(element),
        elementStartY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getTranslateY(element),
        elementX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getOffsetX(element, dragWithin || outerElement),
        elementY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getOffsetY(element, dragWithin || outerElement),
        scrollX: 0,
        scrollY: 0,
        scrollManagerElementContainsDragProxy: !me.cloneTarget || dragWithin === outerElement
      });
      element.classList.add(me.draggingCls);

      if (dragWithin) {
        context.parentElement = element.parentElement;

        if (dragWithin !== element.parentElement) {
          dragWithin.appendChild(element);
        }

        me.updateTranslateProxy(event);
      }

      if (relatedElements) {
        relatedElements.forEach(r => {
          r.classList.add(me.draggingCls);
        });
      }
    }
  }
  /**
   * Limit translation to outer bounds and specified constraints
   * @private
   * @param element
   * @param x
   * @param y
   * @returns {{constrainedX: *, constrainedY: *}}
   */


  applyConstraints(element, x, y) {
    const me = this,
          dragWithin = me.dragWithin,
          {
      pageXOffset,
      pageYOffset
    } = dragWithin === document.body ? window : noScroll; // limit to outer elements edges

    if (dragWithin && me.constrain) {
      if (x < 0) x = 0;
      if (x + element.offsetWidth > dragWithin.scrollWidth) x = dragWithin.scrollWidth - element.offsetWidth;
      if (y < 0) y = 0;
      if (y + element.offsetHeight > dragWithin.scrollHeight) y = dragWithin.scrollHeight - element.offsetHeight;
    } // limit horizontally


    if (typeof me.minX === 'number') {
      x = Math.max(me.minX + pageXOffset, x);
    }

    if (typeof me.maxX === 'number') {
      x = Math.min(me.maxX + pageXOffset, x);
    } // limit vertically


    if (typeof me.minY === 'number') {
      y = Math.max(me.minY + pageYOffset, y);
    }

    if (typeof me.maxY === 'number') {
      y = Math.min(me.maxY + pageYOffset, y);
    }

    return {
      constrainedX: x,
      constrainedY: y
    };
  }
  /**
   * Update elements translation on mouse move.
   * @private
   * @param {MouseEvent} event
   * @param {Object} scrollManagerConfig
   */


  updateTranslateProxy(event, scrollManagerConfig) {
    const me = this,
          {
      mode,
      lockX,
      lockY
    } = me,
          context = me.context,
          element = context.dragProxy || context.element,
          {
      relatedElements,
      relatedElDragFromPos
    } = context; // If we are cloning the dragged element outside of the element(s) monitored by the ScrollManager, then no need
    // to take the scrollManager scroll values into account since it is only relevant when dragProxy is inside
    // the Grid (where scroll manager operates).

    if (context.scrollManagerElementContainsDragProxy && scrollManagerConfig) {
      context.scrollX = scrollManagerConfig.getRelativeLeftScroll(element);
      context.scrollY = scrollManagerConfig.getRelativeTopScroll(element);
    }

    context.pageX = event.pageX;
    context.pageY = event.pageY;
    context.clientX = event.clientX;
    context.clientY = event.clientY;
    let newX = context.elementStartX + event.pageX - context.startPageX + context.scrollX,
        newY = context.elementStartY + event.pageY - context.startPageY + context.scrollY; // First let outside world apply snapping

    if (me.snapCoordinates) {
      const snapped = me.snapCoordinates({
        element,
        newX,
        newY
      });
      newX = snapped.x;
      newY = snapped.y;
    } // Now constrain coordinates


    const {
      constrainedX,
      constrainedY
    } = me.applyConstraints(element, newX, newY);

    if (mode === 'translateXY' && !(lockX || lockY)) {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateXY(element, constrainedX, constrainedY);
    } else if (mode === 'translateX' || lockY) {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateX(element, constrainedX);
    } else if (mode === 'translateY' || lockX) {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateY(element, constrainedY);
    }

    if (relatedElements) {
      const deltaX = !lockX && mode !== 'translateY' ? constrainedX - context.elementStartX : 0,
            deltaY = !lockY && mode !== 'translateX' ? constrainedY - context.elementStartY : 0;
      relatedElements.forEach((r, i) => {
        const [x, y] = relatedElDragFromPos[i];
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateXY(r, x + deltaX, y + deltaY);
      });
    }

    context.newX = constrainedX;
    context.newY = constrainedY;
  }
  /**
   * Finalize drag, fire drop.
   * @private
   * @param event
   * @fires drop
   */


  finishTranslateDrag(event) {
    const me = this,
          context = me.context,
          xChanged = Math.round(context.newX) !== Math.round(context.elementStartX),
          yChanged = Math.round(context.newY) !== Math.round(context.elementStartY),
          element = context.dragProxy || context.element,
          {
      relatedElements
    } = context;

    function cleanUp() {
      element.classList.remove(me.invalidCls);
      element.classList.remove(me.draggingCls);

      if (relatedElements) {
        relatedElements.forEach(r => {
          r.classList.remove(me.invalidCls);
          r.classList.remove(me.draggingCls);
        });
      } // If we're currently aborting, the b-hidden CSS class will be removed after animation is complete


      if (!element.classList.contains('b-aborting')) {
        if (me.hideOriginalElement) {
          context.grabbed.classList.remove('b-hidden');
        }

        context.grabbed.classList.remove('b-drag-original');
      }
    }

    if (!me.ignoreSamePositionDrop || me.mode !== 'translateY' && xChanged || me.mode !== 'translateX' && yChanged) {
      if (context.valid === false) {
        me.abortTranslateDrag(true, event);
      } else {
        const targetRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(me.dragWithin || me.outerElement);

        if (!me.minX && event.pageX < targetRect.left || !me.maxX && event.pageX > targetRect.right || !me.minY && event.pageY < targetRect.top || !me.maxY && event.pageY > targetRect.bottom) {
          // revert location when dropped outside allowed element
          context.valid = false;
          me.abortTranslateDrag(true, event);
        } else {
          context.finalize = (valid = context.valid) => {
            if (context.asyncCleanup) {
              cleanUp();
            } // abort if invalid (and context still exists, might have been aborted from outside)


            if (!valid && me.context) {
              // abort if flagged as invalid, without triggering abort or drop again
              me.abortTranslateDrag(true, null, true);
            } else if (me.cloneTarget || context.dragProxy) {
              element.remove();
            }

            me.reset();
          }; // allow async finalization by setting async to true on context in drop handler,
          // requires implementer to call context.finalize later to finish the drop


          context.async = false;
          me.trigger('drop', {
            context,
            event
          });

          if (!context.async) {
            // finalize immediately
            context.finalize();
          } else {
            context.awaitingFinalization = true;
          }
        }
      }

      if (!context.asyncCleanup) {
        cleanUp();
      }
    } else {
      // no change, abort but not as invalid
      me.abortTranslateDrag(false, event);
    }
  }
  /**
   * Abort translation
   * @private
   * @param invalid
   * @fires abort
   */


  abortTranslateDrag(invalid = false, event = null, silent = false) {
    const me = this,
          context = me.context,
          {
      relatedElements,
      relatedElStartPos,
      grabbed
    } = context,
          element = context.dragProxy || context.element,
          resetEl = me.cloneTarget && me.hideOriginalElement ? grabbed : element;
    let {
      elementStartX,
      elementStartY
    } = context;

    if (element && context.started) {
      // Put the dragged element back where it was
      if (!me.cloneTarget && me.dragWithin && me.dragWithin !== context.grabbedParent) {
        context.grabbedParent.insertBefore(element, context.grabbedNextSibling);
      }

      grabbed.classList.remove('b-hidden'); // Align the now visible grabbed element with the clone, so that it looks like it's
      // sliding back into place when the clone is removed

      if (me.cloneTarget) {
        if (me.hideOriginalElement) {
          [elementStartX, elementStartY] = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getTranslateXY(grabbed);
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].alignTo(grabbed, element); // The getBoundingClientRect is important. The aligning above must be processed
          // by a forced synchronous layout *before* the b-aborting class is added below.

          resetEl.getBoundingClientRect();
        }

        element.remove();
      } // animated restore of position.


      resetEl.classList.add('b-aborting'); // Move the elements back to their original positions.

      if (me.mode === 'translateXY' && !(me.lockX || me.lockY)) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateXY(resetEl, elementStartX, elementStartY);
        relatedElements && relatedElements.forEach((element, i) => {
          element.classList.add('b-aborting');
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateXY(element, relatedElStartPos[i][0], relatedElStartPos[i][1]);
        });
      }

      if (me.mode === 'translateX' || me.lockY) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateX(resetEl, elementStartX);
        relatedElements && relatedElements.forEach((element, i) => {
          element.classList.add('b-aborting');
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateX(element, relatedElStartPos[i][0]);
        });
      }

      if (me.mode === 'translateY' || me.lockX) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateY(resetEl, elementStartY);
        relatedElements && relatedElements.forEach((element, i) => {
          element.classList.add('b-aborting');
          _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].setTranslateY(element, relatedElStartPos[i][1]);
        });
      } // TODO change to EventHelper.onTransitionEnd


      me.setTimeout(() => {
        resetEl.classList.remove('b-aborting');
        grabbed.classList.remove('b-dragging');
        grabbed.classList.remove('b-drag-original');

        if (!me.cloneTarget) {
          relatedElements && relatedElements.forEach((element, i) => {
            element.classList.remove('b-aborting');
          });
          element.classList.remove('b-aborting');
          element.classList.remove(me.draggingCls);
          element.classList.remove(me.invalidCls);
        }
      }, me.transitionDuration, undefined, true);

      if (!silent) {
        me.trigger(invalid ? 'drop' : 'abort', {
          context,
          event
        });
      }
    }

    me.reset();
  } //endregion


});

/***/ }),

/***/ "./lib/Core/helper/util/DataGenerator.js":
/*!***********************************************!*\
  !*** ./lib/Core/helper/util/DataGenerator.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DataGenerator; });
/* harmony import */ var _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./RandomGenerator.js */ "./lib/Core/helper/util/RandomGenerator.js");
/* harmony import */ var _DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'taskboard';


/**
 * @module Core/helper/util/DataGenerator
 */

const lorem = ['Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.', 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.', 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.', 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui atione voluptatem sequi nesciunt.', 'Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.', 'Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?', 'Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?'];
/**
 * Generates a pseudo random data for Grid records.
 * Used to provide data in examples.
 */

class DataGenerator {
  //region Random
  static reset() {
    this.rnd.reset();
    this.rndTime.reset();
    this.rndRating.reset();
  } //endregion
  //region Generate data


  static *generate(count, randomHeight = false, initialId = 1) {
    const me = this,
          rnd = me.rnd,
          rndTime = me.rndTime,
          rndRating = me.rndRating,
          rndText = me.rndText,
          firstNames = me.firstNames,
          surNames = me.surNames,
          teams = me.teams,
          foods = me.foods,
          colors = me.colors,
          cities = me.cities;

    for (let i = 0; i < count; i++) {
      const firstName = rnd.fromArray(firstNames),
            surName = rnd.fromArray(surNames),
            name = `${firstName} ${String.fromCharCode(65 + i % 25)} ${surName}`,
            startDay = rnd.nextRandom(60) + 1,
            start = new Date(2019, 0, startDay),
            finish = new Date(2019, 0, startDay + rnd.nextRandom(30) + 2),
            row = {
        id: initialId > -1 ? i + initialId : undefined,
        title: 'Row ' + i,
        name: name,
        firstName: firstName,
        surName: surName,
        city: rnd.fromArray(cities),
        team: rnd.fromArray(cities) + ' ' + rnd.fromArray(teams),
        age: 10 + rnd.nextRandom(80),
        food: rnd.fromArray(foods),
        color: rnd.fromArray(colors),
        score: rnd.nextRandom(100) * 10,
        rank: rnd.nextRandom(100) + 1,
        start: start,
        finish: finish,
        time: _DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getTime(rndTime.nextRandom(24), rndTime.nextRandom(12) * 5),
        percent: rnd.nextRandom(100),
        done: rnd.nextRandom(100) < 50,
        rating: rndRating.nextRandom(5),
        relatedTo: Math.min(count - 1, i + initialId + rnd.nextRandom(10)),
        notes: lorem[rndText.nextRandom(7) + 1]
      };

      if (randomHeight) {
        row.rowHeight = rnd.nextRandom(randomHeight === true ? 20 : randomHeight) * 5 + 20;
      }

      yield row;
    }
  }
  /**
   * Generates a pseudo random data for Grid records.
   * @param {Number} count number of records
   * @param {Boolean} randomHeight generate random row height
   * @param {Number} initialId row initial id. Set -1 to disable Id generation. Defaults to 1.
   * @param {Boolean} reset set true to ensure we get the same dataset on consecutive calls. Defaults to true
   * @return {Object[]} generated rows array
   */


  static generateData(count, randomHeight = false, initialId = 1, reset = true) {
    if (reset) this.reset();
    const rows = [],
          number = DataGenerator.overrideRowCount ? DataGenerator.overrideRowCount : count,
          generator = this.generate(number, randomHeight, initialId);

    for (let i = 0; i < number; i++) {
      rows.push(generator.next().value);
    }

    return rows;
  }
  /**
   * Generates a pseudo random data for Grid row.
   * @return {Object} generated row
   */


  static generateRow() {
    return DataGenerator.generateData(1, false, -1, false)[0];
  } //endregion


}
Object.assign(DataGenerator, {
  rnd: new _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_0__["default"](),
  rndTime: new _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_0__["default"](),
  rndRating: new _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_0__["default"](),
  rndText: new _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_0__["default"](),
  cities: ['Stockholm', 'Barcelona', 'Paris', 'Dubai', 'New York', 'San Francisco', 'Washington', 'Moscow'],
  firstNames: ['Mike', 'Linda', 'Don', 'Karen', 'Doug', 'Jenny', 'Daniel', 'Melissa', 'John', 'Jane', 'Theo', 'Lisa', 'Adam', 'Mary', 'Barbara', 'James', 'David'],
  surNames: ['McGregor', 'Ewans', 'Scott', 'Smith', 'Johnson', 'Adams', 'Williams', 'Brown', 'Jones', 'Miller', 'Davis', 'More', 'Wilson', 'Taylor', 'Anderson', 'Thomas', 'Jackson'],
  teams: ['Lions', 'Eagles', 'Tigers', 'Horses', 'Dogs', 'Cats', 'Panthers', 'Rats', 'Ducks', 'Cougars', 'Hens', 'Roosters'],
  foods: ['Pancake', 'Burger', 'Fish n chips', 'Carbonara', 'Taco', 'Salad', 'Bolognese', 'Mac n cheese', 'Waffles'],
  colors: ['Blue', 'Green', 'Red', 'Yellow', 'Pink', 'Purple', 'Orange', 'Teal', 'Black']
});
DataGenerator._$name = 'DataGenerator';

/***/ }),

/***/ "./lib/Core/helper/util/DemoBot.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/util/DemoBot.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DemoBot; });
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _widget_Widget_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
var productName = 'taskboard';






const knownProps = ['action', 'target', 'to', 'deltaX', 'deltaY', 'x', 'y', 'text'];
class DemoBot extends Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__["default"])(Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__["default"])()) {
  static get defaultConfig() {
    return {
      repeat: true,
      outerElement: document.body,
      callOnFunctions: true
    };
  } // expects an outer element (grid.element/scheduler.element) and an array of steps similar to chain steps in siesta


  construct(config) {
    super.construct(config);
    const me = this;

    if (me.widget) {
      me.outerElement = me.widget.element;
      me.widget.playingDemo = true;
    }

    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].playingDemo = true;
    Object.assign(me, {
      prevTarget: null,
      currentStep: 0,
      mouse: _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
        parent: me.outerElement,
        tag: 'div',
        className: 'simulated-mouse'
      }),
      timeoutId: null,
      innerIntervalId: null,
      mouseOutElements: []
    });
    me.intervalId = me.setInterval(me.nextStep.bind(me), 1000);
    me.outerElement.classList.add('b-playing-demo');
    me.outerElement.addEventListener('click', event => {
      if (event.isTrusted) {
        me.abort();
      }
    });
  }

  doDestroy() {
    this.abort();
  } // stops the bot


  abort(atEnd = false) {
    const me = this;
    me.mouse.style.top = '-100px';
    me.clearInterval(me.intervalId);
    me.timeoutId && me.clearTimeout(me.timeoutId);
    me.innerIntervalId && me.clearInterval(me.innerIntervalId);
    me.outerElement.classList.remove('b-playing-demo');

    if (me.widget) {
      me.widget.playingDemo = false;
    }

    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].playingDemo = false;
    me.trigger(atEnd ? 'done' : 'abort');
  } // triggers a synthetic event


  triggerEvent(element, type, data) {
    if (!element) return null;
    let event;

    if (type.startsWith('mouse')) {
      const box = this.mouse.getBoundingClientRect();
      event = new MouseEvent(type, Object.assign({
        view: window,
        bubbles: true,
        cancelable: true,
        clientX: box.left,
        clientY: box.top
      }, data || {}));
    } else {
      event = document.createEvent('Event');
      event.initEvent(type, true, false);
    }

    element.dispatchEvent(event);
    return event;
  } // moves mouse to target in 10 steps, with animated transition between steps


  handleMouseMove(step, target) {
    const me = this,
          mouse = me.mouse;
    mouse.classList.add('quick');
    if (me.mouseDown) mouse.classList.add('drag');
    const mouseBox = _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(mouse, me.outerElement),
          x = mouseBox.x,
          y = mouseBox.y;
    let deltaX = 0,
        deltaY = 0;

    if (step.to) {
      if (typeof step.to === 'string') {
        const toElement = me.outerElement.querySelector(step.to);

        if (toElement) {
          const rect = _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(toElement, me.outerElement),
                toX = rect.x + rect.width / 2,
                toY = rect.y + rect.height / 2;
          deltaX = (toX - x) / 10;
          deltaY = (toY - y) / 10;
        }
      } else if (step.to.x) {
        deltaX = (step.to.x - x) / 10;
      } else {
        deltaX = step.to[0] / 10;
        deltaY = step.to[1] / 10;
      }
    } else if (step.deltaX) {
      deltaX = step.deltaX / 10;
    } else if (step.x) {
      deltaX = (step.x - x) / 10;
    }

    if (step.deltaY) {
      deltaY = step.deltaY / 10;
    }

    let i = 0;
    me.innerIntervalId = me.setInterval(() => {
      // Only move mouse if in view and not scrolling
      if (me.shouldPause) {
        return;
      }

      if (i++ === 9) {
        clearInterval(me.innerIntervalId);

        if (step.then) {
          step.then();
        }
      }

      const mouseX = x + deltaX * i,
            mouseY = y + deltaY * i; // Move mouse there also

      mouse.style.left = mouseX + 'px';
      mouse.style.top = mouseY + 'px';
      const mouseBounds = mouse.getBoundingClientRect(),
            clientX = mouseBounds.left,
            clientY = mouseBounds.top,
            eventTarget = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].elementFromPoint(clientX, clientY);

      if (eventTarget !== me.prevTarget) {
        if (me.prevTarget) {
          me.mouseOutElements.push(me.prevTarget);

          if (!_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isDescendant(me.mouseOutElements[0], eventTarget)) {
            me.mouseOutElements.forEach(element => me.triggerEvent(element, 'mouseout'));
            me.mouseOutElements.length = 0;
          }
        }

        me.prevTarget = eventTarget;
        me.triggerEvent(eventTarget, 'mouseover');
      }

      me.triggerEvent(eventTarget, step.action, {
        clientX,
        clientY
      });
    }, 50);
  } // target can be a string selector, a function or blank to use last target or outerElement if first time


  getTarget(step) {
    const me = this,
          target = step.target;

    if (!target) {
      return me.prevTarget || me.outerElement;
    }

    if (typeof target === 'function') {
      return target(step);
    }

    return document.querySelector(target);
  } // action can be a function, a string or extracted from a property by scanning for unknown names


  normalizeStep(step) {
    if (step.action) {
      if (typeof step.action === 'function') {
        return step.action(step);
      }

      return step;
    }

    if (typeof step === 'function') {
      step();
      return step;
    } // try to find action among properties


    for (const prop in step) {
      if (Object.hasOwnProperty.call(step, prop) && !knownProps.includes(prop)) {
        step.action = prop.toLowerCase();
        step.to = step[prop];
      }
    }

    if (!step.target && (typeof step.to === 'string' || typeof step.to === 'function')) step.target = step.to;
    return step;
  }

  get isScrolling() {
    const me = this,
          box = me.outerElement.getBoundingClientRect(),
          scrolled = me.lastTop && box.top !== me.lastTop;
    me.lastTop = box.top;
    return scrolled;
  }

  get isInView() {
    const box = this.outerElement.getBoundingClientRect();
    return box.top < window.innerHeight && box.bottom > 0;
  }

  get shouldPause() {
    return !this.isInView || this.isScrolling || document.hidden || !document.hasFocus();
  } // process the next step


  nextStep() {
    const me = this; // Only perform step if in view and not scrolling

    if (me.shouldPause) {
      return;
    }

    if (me.currentStep === me.steps.length) {
      if (me.repeat) {
        me.currentStep = 0;
      } else {
        return me.abort(true);
      }
    } // First step, signal to let demo initialize stuff


    if (me.currentStep === 0) {
      me.trigger('initialize');
    }

    const mouse = me.mouse,
          step = me.normalizeStep(me.steps[me.currentStep++]),
          target = me.getTarget(step),
          action = step.action;

    if (target && action) {
      mouse.className = 'simulated-mouse';

      if (action === 'mousemove') {
        me.handleMouseMove(step, target);
      } else {
        // First move mouse into position
        if (target !== me.prevTarget) {
          const rect = _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(target, me.outerElement);
          mouse.style.left = rect.x + rect.width / 2 + 'px';
          mouse.style.top = rect.y + rect.height / 2 + 'px';
        }

        if (action === 'mousedown') {
          me.mouseDown = true;
        }

        if (action === 'mouseup') {
          me.mouseDown = false;
        } // Then trigger action


        me.timeoutId = me.setTimeout(() => {
          me.prevTarget = target; // Animate click etc.

          mouse.classList.add(action);

          if (action === 'type') {
            const field = _widget_Widget_js__WEBPACK_IMPORTED_MODULE_2__["default"].fromElement(target),
                  parts = step.text.split('|');
            field.value = parts[parts.length === 1 || field.value != parts[0] ? 0 : 1];
          } else {
            me.triggerEvent(target, action);
          }
        }, action === 'type' ? 100 : 550);
      }
    }
  }

}
DemoBot._$name = 'DemoBot';

/***/ }),

/***/ "./lib/Core/helper/util/DomClassList.js":
/*!**********************************************!*\
  !*** ./lib/Core/helper/util/DomClassList.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DomClassList; });
/* harmony import */ var _Objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'taskboard';


/**
 * @module Core/helper/util/DomClassList
 */

const // Presence of '[' is likely an "[object Object]" or other bogus stringification
invalidClsRe = /\[|undefined|null/,
      valueSymbol = Symbol('value'),
      lengthSymbol = Symbol('length');
/**
 * This class encapsulates a list of CSS classes which can be set as the `className`
 * on an `HTMLElement`.
 *
 * Properties names set on this class equate to *adding* a class if the property's value
 * is _truthy_, or removing a class if the value is _falsy_.
 *
 * ```javascript
 * const myClassList = new DomClassList('b-test-button');
 *
 * myClassList.add('test-class');
 * myClassList.important = 1;
 *
 * myHtmlElement.className = myClassList; // Sets it to "b-test-button test-class important"
 * ```
 */

class DomClassList {
  static change(cls, add, remove, as = 'string') {
    remove = DomClassList.normalize(remove, 'object');
    const after = DomClassList.normalize(cls, 'array').filter(c => !remove[c]);

    if (add) {
      add = DomClassList.normalize(add, 'array');

      for (let i = 0; i < add.length; ++i) {
        if (!after.includes(add[i])) {
          after.push(add[i]);
        }
      }
    }

    return DomClassList.normalize(after, as);
  }

  static from(classes, returnEmpty) {
    if (classes) {
      if (!classes.isDomClassList) {
        classes = new DomClassList(classes);
      }

      if (!classes.value && !returnEmpty) {
        classes = null;
      }
    }

    return classes || (returnEmpty ? new DomClassList() : null);
  }
  /**
   * Converts a class name of any understood type to a desired form.
   * @param {String|String[]|Object|Set|Map|HTMLElement} cls
   * @param {String} as Pass `'object'` to return an object with the class names as its keys (all keys will have a
   * value of `true`), or pass `'array'` to return an array of class names, or pass `'string'` (the default) to
   * return a space-separated string of class names.
   * @returns {String|String[]|Object}
   * @internal
   */


  static normalize(cls, as = 'string') {
    cls = cls || ''; // promote null to '' to avoid typeof snag

    const type = typeof cls,
          asArray = as === 'array',
          asObject = as === 'object',
          asString = !asArray && !asObject;
    let isString = type === 'string',
        c,
        i,
        ret;

    if (type === 'object') {
      var _cls;

      if (cls.nodeType === Element.ELEMENT_NODE && typeof cls.getAttribute === 'function') {
        cls = cls.getAttribute('class') || ''; // cannot use className for SVG el's

        isString = true;
      } else if ((_cls = cls) !== null && _cls !== void 0 && _cls.isDomClassList) {
        cls = cls.values;
      } else if (cls instanceof DOMTokenList) {
        cls = Array.from(cls);
      } else if (cls instanceof Map) {
        cls = Array.from(cls.keys()).filter(k => cls.get(k));
      } else if (cls instanceof Set) {
        cls = Array.from(cls.values());
      } else if (!Array.isArray(cls)) {
        cls = _Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTruthyKeys(cls);
      }
    }

    if (isString) {
      // Pass through Set to ensure only unique class names
      cls = [...new Set(_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].split(cls))];
    } // cls is now an array


    for (i = cls.length; i-- > 0;) {
      c = cls[i];

      if (!c.length) {
        cls.splice(i, 1);
      } else if (c.includes(' ')) {
        cls.splice(i, 1, ..._StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].split(c));
      }
    }

    if (asArray) {
      ret = cls;
    } else if (asString) {
      ret = cls.join(' ');
    } else {
      ret = Object.create(null);

      for (i = 0; i < cls.length; ++i) {
        ret[cls[i]] = true;
      }
    }

    return ret;
  }
  /**
   * Initializes a new DomClassList.
   * @param {...String|Object} classes The CSS classes as strings or objects.
   * @function constructor
   */


  constructor(...classes) {
    this.process(1, classes);
  } // To gain some speed in DomHelper.sync(), faster than instanceof etc


  get isDomClassList() {
    return true;
  }
  /**
   * Returns a clone of this DomClassList with all the same keys set.
   * @returns {Core.helper.util.DomClassList} A clone of this DomClassList.
   */


  clone() {
    return new DomClassList(this);
  }
  /**
   * Returns a Boolean value, indicating whether this ClassList has the specified CSS class name.
   * @param {String} className CSS class name to check
   * @return {Boolean} true if this ClassList contains the passed CSS class name, false otherwise
   */


  contains(className) {
    if (typeof className === 'string' && className) {
      return Boolean(this[className]);
    }

    return false;
  } // An instance of this class may be assigned directly to an element's className
  // it will be coerced to a string value using this method.


  toString() {
    // Adding space at the end if there is content to make concatenation code simpler in renderers.
    return this.length ? `${this.value} ` : '';
  }

  toJSON() {
    return this.toString();
  }
  /**
   * Analogous to string.trim, returns the string value of this `DomClassList` with no trailing space.
   * @returns {String} A concatenated string value of all the class names in this `DomClassList`
   * separated by spaces.
   */


  trim() {
    return this.value;
  }
  /**
   * Compares this DomClassList to another DomClassList (or class name string of space separated classes).
   * If the same class names (regardless of order) are present, the two are considered equal.
   *
   * So `new DomClassList('foo bar bletch').isEqual('bletch bar foo')` would return `true`
   * @param {Core.helper.util.DomClassList|String} other The `DomClassList` or string of classes to compare to.
   * @returns {Boolean} `true` if the two contain the same class names.
   */


  isEqual(other) {
    const otherClasses = DomClassList.normalize(other, 'array'),
          len = otherClasses.length;

    if (this.length === len) {
      for (let i = 0; i < len; i++) {
        if (!this[otherClasses[i]]) {
          return false;
        }
      }

      return true;
    }

    return false;
  }
  /**
   * Get/set string value.
   * Class names separated with space.
   * @property {String}
   */


  get value() {
    let value = this[valueSymbol],
        keys;

    if (value == null) {
      keys = _Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTruthyKeys(this);
      this[lengthSymbol] = keys.length;
      this[valueSymbol] = value = keys.join(' ');
    }

    return value;
  }

  set value(value) {
    const me = this,
          keys = Object.keys(me),
          len = keys.length;

    for (let i = 0; i < len; i++) {
      delete me[keys[i]];
    }

    if (value) {
      me.process(1, [value]);
    } else {
      // String value needs recalculating
      delete me[valueSymbol];
    }
  }
  /**
   * Returns string values as an array.
   * @readonly
   * @property {String[]}
   */


  get values() {
    return _Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTruthyKeys(this);
  }

  get length() {
    // Maintainer: We MUST access the value getter to force
    // the value to be calculated if it's currently dirty.
    return this.value ? this[lengthSymbol] : 0;
  }

  process(value, classes) {
    for (let cls, k, i = 0; i < classes.length; i++) {
      if (classes[i]) {
        cls = classes[i];

        if (_Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(cls)) {
          // preserve all keys, even falsy ones
          for (k in cls) {
            this[k] = value ? cls[k] : !cls[k];
          }
        } else {
          cls = DomClassList.normalize(classes[i], 'array');

          for (k = 0; k < cls.length; ++k) {
            this[cls[k]] = value;
          }
        }
      }
    } // String value needs recalculating


    delete this[valueSymbol];
    return this;
  }
  /**
   * Adds/removes class names according to the passed object's properties.
   *
   * Properties with truthy values are added.
   * Properties with false values are removed.
   * @param {Object} classList Object containing properties to set/clear
   */


  assign(classList) {
    for (const cls in classList) {
      if (!this[cls] !== !classList[cls]) {
        this[cls] = classList[cls]; // String value needs recalculating

        delete this[valueSymbol];
      }
    }

    return this;
  }
  /**
   * Add CSS class(es)
   * ```
   * myClassList.add('bold', 'small');
   * ```javascript
   * @param {String|String[]|Object} classes CSS classes to add
   */


  add(...classes) {
    return this.process(1, classes);
  }
  /**
   * Remove CSS class(es)
   * ```javascript
   * myClassList.remove('bold', 'small');
   * ```
   * @param {String} classes CSS classes to remove
   */


  remove(...classes) {
    return this.process(0, classes);
  }
  /**
   * Toggles the passed CSS class name.
   * 
   * If the `force` parameter is passed, `true` means add the class name, `false` means remove it.
   *
   * ```javascript
   * myClassList.toggle('bold', isImportant);
   * ```
   * @param {String} className CSS class to toggle
   * @param {Boolean} [force] `true` to add the class, `false` to remove it.
   * @returns {Boolean} `true` if the operation changed the value.
   */


  toggle(className, flag = Boolean(!this[className])) {
    flag = Boolean(flag); // Only disturb the set classwes if we need to.

    if (Boolean(this[className]) !== flag) {
      this[className] = flag; // String value needs recalculating

      delete this[valueSymbol];
      return true;
    }
  }
  /**
   * Analogous to the `String#split` method, but with no delimiter
   * parameter. This method returns an array containing the individual
   * CSS class names set.
   * @returns {String[]} The individual class names in this `DomClassList`
   */


  split() {
    return _Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTruthyKeys(this);
  }

  forEach(fn) {
    return _Objects_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTruthyKeys(this).forEach(fn);
  }

}
; // We put this on the prototype and delete it from instances to mark dirty state. This maintains the same shape for
// the instance to help the JIT

DomClassList.prototype[valueSymbol] = null;
DomClassList._$name = 'DomClassList';

/***/ }),

/***/ "./lib/Core/helper/util/Formatter.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/util/Formatter.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Formatter; });
var productName = 'taskboard';
const hasOwnProperty = Object.prototype.hasOwnProperty;
let cacheKey = null;

function setParser(me, parser) {
  Object.defineProperty(me, 'parser', {
    value: parser
  });
  return parser;
}

class Default {
  constructor(formatter) {
    this.formatter = formatter;
  }

  format(value) {
    return this.formatter.defaultFormat(value);
  }

  parse(value, strict) {
    return this.formatter.defaultParse(value, strict);
  }

  resolvedOptions() {
    return null;
  }

} // This class does not extend Core.Base because instances are not reconfigurable (making
// setConfig harmful) nor destroyable. Instead, they get frozen and cached according to
// their "config" definition.

/**
 * Abstract base class for formatters.
 * @private
 */


class Formatter {
  static get(format) {
    if (format == null) {
      return this.NULL;
    }

    const key = typeof format === 'string' ? format : JSON.stringify(format),
          cache = this.cache;
    let fmt = cache.get(key);

    if (!fmt) {
      cacheKey = key; // this is grabbed by our constructor below...

      fmt = new this(format);
      cache.set(key, fmt);
    }

    return fmt;
  }

  static get cache() {
    return hasOwnProperty.call(this, '_cache') && this._cache || (this._cache = new Map());
  }

  static get NULL() {
    return hasOwnProperty.call(this, '_null') ? this._null : this._null = new this(null);
  }

  constructor(config) {
    const me = this; // This is done in a funny way so as not to complicate the derived constructor's
    // desire to maintain a single argument signature, as well as it's calling of
    // Object.freeze() to ensure immutability in dev mode.

    me.cacheKey = cacheKey;
    cacheKey = null;
    me.initialize();

    if (config === null) {
      me.formatter = new Default(me);
    } else {
      me.configure(config); // Bring locale and other defaulted options back onto this object:

      for (const [key, value] of Object.entries(me.resolvedOptions())) {
        // For some reason (locale-specific perhaps), resolvedOptions returns
        // with 'undefined' in some keys (e.g., min/maximumFractionDigits) when
        // we specified 0.
        //
        // The second check is to only bring back values that we understand.
        if (value != null && key in me.defaults) {
          me[key] = value;
        }
      }
    }
  }

  get parser() {
    // Replace this property w/the actual instance:
    return setParser(this, new this.constructor.Parser(this));
  }

  defaultFormat(value) {
    return value == null ? value : String(value);
  }

  defaultParse(value) {
    return value;
  }

  format(value) {
    return value == null ? value : this.formatter.format(value);
  }

  parse(value, strict) {
    return value == null ? value : this.parser.parse(value, strict);
  }

  parseStrict(value) {
    return this.parse(value, true);
  }

  resolvedOptions() {
    return this.formatter.resolvedOptions();
  }

}
Formatter._$name = 'Formatter';

/***/ }),

/***/ "./lib/Core/helper/util/Fullscreen.js":
/*!********************************************!*\
  !*** ./lib/Core/helper/util/Fullscreen.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Fullscreen; });
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'taskboard';

/**
 * @module Core/helper/util/Fullscreen
 */

/**
 * Encapsulates the functionality related to switching cross-browser to full screen view and back.
 */

class Fullscreen {
  static init() {
    const fnNames = ['fullscreenEnabled', 'requestFullscreen', 'exitFullscreen', 'fullscreenElement'],
          // turns fnNames into function calls to prefixed functions, fullscreenEnabled -> document.mozFullscreenEnabled
    prefixFn = prefix => fnNames.map(fn => {
      let result = prefix + _StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].capitalize(fn); // fullscreenEnabled in Firefox is called fullScreenEnabled

      if (prefix === 'moz') {
        result = result.replace('screen', 'Screen'); // #6555 - Crash when clicking full screen button twice
        // firefox doesn't support exitFullScreen method

        if ('mozCancelFullScreen' in document && fn === 'exitFullscreen') {
          result = 'mozCancelFullScreen';
        }
      }

      return result;
    });

    this.functions = 'fullscreenEnabled' in document && fnNames || 'webkitFullscreenEnabled' in document && prefixFn('webkit') || 'mozFullScreenEnabled' in document && prefixFn('moz') || 'msFullscreenEnabled' in document && prefixFn('ms') || [];

    const eventNames = ['fullscreenchange', 'fullscreenerror'],
          msEventNames = ['MSFullscreenChange', 'MSFullscreenError'],
          prefixEvt = prefix => eventNames.map(eventName => prefix + _StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].capitalize(eventName));

    this.events = 'fullscreenEnabled' in document && eventNames || 'webkitFullscreenEnabled' in document && prefixEvt('webkit') || 'mozFullscreenEnabled' in document && prefixEvt('moz') || 'msFullscreenEnabled' in document && msEventNames || [];
  }
  /**
   * True if the fullscreen mode is supported and enabled, false otherwise
   * @property {Boolean}
   */


  static get enabled() {
    return document[this.functions[0]];
  }
  /**
   * Request entering the fullscreen mode.
   * @param {HTMLElement} element Element to be displayed fullscreen
   * @returns {Promise} A Promise which is resolved with a value of undefined when the transition to full screen is complete.
   */


  static request(element) {
    return element[this.functions[1]]();
  }
  /**
   * Exit the previously entered fullscreen mode.
   * @returns {Promise} A Promise which is resolved once the user agent has finished exiting full-screen mode
   */


  static exit() {
    return document[this.functions[2]]();
  }
  /**
   * True if fullscreen mode is currently active, false otherwise
   * @property {Boolean}
   */


  static get isFullscreen() {
    return !!this.element;
  }

  static get element() {
    return document[this.functions[3]];
  }
  /**
   * Installs the passed listener to fullscreenchange event
   * @param {Function} fn The listener to install
   */


  static onFullscreenChange(fn) {
    document.addEventListener(this.events[0], fn);
  }
  /**
   * Uninstalls the passed listener from fullscreenchange event
   * @param {Function} fn
   */


  static unFullscreenChange(fn) {
    document.removeEventListener(this.events[0], fn);
  }

}
Fullscreen.init();
Fullscreen._$name = 'Fullscreen';

/***/ }),

/***/ "./lib/Core/helper/util/Navigator.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/util/Navigator.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Navigator; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _widget_Widget_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../widget/Widget.js */ "./lib/Core/widget/Widget.js");
var productName = 'taskboard';





/**
 * @module Core/helper/util/Navigator
 */

/**
 * A helper class which allows keyboard navigation within the {@link #config-target} element.
 * @private
 */

class Navigator extends Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get configurable() {
    return {
      /**
       * The owning Widget which is using this Navigator.
       * @config {Core.widget.Widget}
       */
      ownerCmp: null,

      /**
       * The encapsulating element in which navigation takes place.
       * @config {HTMLElement}
       */
      target: null,

      /**
       * The element which provides key events for navigation. Optional. Defaults to the {@link #config-target} element.
       * @config {HTMLElement}
       */
      keyEventTarget: null,

      /**
       * An optional key event processor which may preprocess the key event. Returning `null` prevents processing of the event.
       * @config {Function}
       */
      processEvent: null,

      /**
       * A query selector which identifies descendant elements within the {@link #config-target} which are navigable.
       * @config {String}
       */
      itemSelector: null,

      /**
       * The currently focused element within the {@link #config-target}.
       * @config {HTMLElement}
       */
      activeItem: null,

      /**
       * A CSS class name to add to focused elements.
       * @config {String}
       * @default
       */
      focusCls: 'b-active',

      /**
       * An object containing key definitions keys by the key name eg:
       *
       * ```javascript
       *  keys : {
       *      "CTRL+SPACE" : 'onCtrlSpace',
       *      ENTER        : 'onEnterKey'
       *  }```
       *
       * The {@link #config-ownerCmp} is used as the `this` reference and to resolve string method names.
       *
       * Modified key names must be created prepending one or more `'CTRL+'`, `'SHIFT+'`, `'ALT+'`
       * in that order, for example `"CTRL+SHIFT+ENTER" : 'showMenu'`
       * @config {Object}
       * @default
       */
      keys: null,

      /**
       * Configure as `true` to also navigate when the `CTRL` modifier key is used along with
       * navigation keys.
       * @config {Boolean}
       * @default false
       */
      allowCtrlKey: null,

      /**
       * Configure as `true` to also navigate when the `SHIFT` modifier key is used along with
       * navigation keys.
       * @config {Boolean}
       * @default false
       */
      allowShiftKey: null,
      scrollDuration: 50,

      /**
       * Configure as, or set to `true` to disable the processing of keys.
       * @config {Boolean}
       */
      disabled: null,
      testConfig: {
        scrollDuration: 1
      }
    };
  }

  updateOwnerCmp(ownerCmp) {
    if (!this.itemSelector) {
      this.itemSelector = `.${this.ownerCmp.itemCls}`;
    }
  }

  onKeyDown(keyEvent) {
    const me = this,
          {
      ownerCmp,
      itemSelector,
      activeItem,
      itemsTabbable
    } = me,
          {
      target
    } = keyEvent,
          firstItem = me.target.querySelector(itemSelector),
          // Not all key events have 'key'
    keyName = (keyEvent.key || '').trim() || keyEvent.code,
          composedKeyName = `${keyEvent.ctrlKey ? 'CTRL+' : ''}${keyEvent.shiftKey ? 'SHIFT+' : ''}${keyEvent.altKey ? 'ALT+' : ''}${keyName}`,
          validTarget = target.matches(itemSelector) || target === me.keyEventTarget; // Process the key gesture if there are items and we are visible.
    // Also, if key emanated from a valid target element (Not an owned positioned Widget).

    if (!me.disabled && firstItem && me.target.offsetParent && validTarget) {
      // Only set navigation key names if we are *not* using tabbing.
      if (!itemsTabbable) {
        // Detect whether the navigable items flow inline or downwards.
        if (me.inlineFlow == null) {
          const itemContainer = firstItem.parentNode,
                itemPositionStyle = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(firstItem, 'position'),
                itemDisplayStyle = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(firstItem, 'display'),
                itemFloatStyle = _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(firstItem, 'float'); // This is how we know that RIGHT and LEFT arrow should be used for next and previous.
          // If inlineFlow is false, we use UP and DOWN. Consider tabs in a tab bar.

          me.inlineFlow = itemPositionStyle === 'absolute' || itemDisplayStyle === 'inline' || itemDisplayStyle === 'inline-block' || itemFloatStyle === 'left' || itemFloatStyle === 'right' || _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(itemContainer, 'display') === 'flex' && _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(itemContainer, 'flex-direction') === 'row';
        }

        if (!me.prevKey) {
          if (me.inlineFlow) {
            me.prevKey = 'ArrowLeft';
            me.nextKey = 'ArrowRight';
          } else {
            me.prevKey = 'ArrowUp';
            me.nextKey = 'ArrowDown';
          }
        }
      } // Feed the key event through our configured processor, process the event that returns if any.


      if (me.processEvent) {
        keyEvent = me.processEvent.call(ownerCmp, keyEvent);

        if (!keyEvent) {
          return;
        }
      }

      if (activeItem) {
        switch (keyName) {
          case me.prevKey:
            if (me.disabled || keyEvent.ctrlKey && !me.allowCtrlKey) {
              return;
            }

            if (keyEvent.shiftKey && !me.allowShiftKey) {
              return;
            }

            keyEvent.preventDefault();
            me.navigatePrevious(keyEvent);
            break;

          case me.nextKey:
            if (me.disabled || keyEvent.ctrlKey && !me.allowCtrlKey) {
              return;
            }

            if (keyEvent.shiftKey && !me.allowShiftKey) {
              return;
            }

            keyEvent.preventDefault();
            me.navigateNext(keyEvent);
            break;

          default:
            {
              const keyHandler = me.keys && me.keys[composedKeyName];

              if (keyHandler && !me.disabled) {
                me.callback(keyHandler, me.thisObj || ownerCmp, [keyEvent]);
              } // Note that even if this.disabled, the ownerCmp will expect
              // to have its key down handler invoked.
              else if (ownerCmp.onInternalKeyDown) {
                ownerCmp.onInternalKeyDown(keyEvent);
              } // One of the handlers moved focus.
              // This KeyDown should not act upon the new target.
              // For example popped up a Popup and focused its "close" Tool.


              if (_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(target) !== target) {
                keyEvent.preventDefault();
              } // No navigation must take place when items are tabbable.


              if (itemsTabbable) {
                return;
              }
            }
        }
      } else {
        if (itemsTabbable) {
          return;
        }

        me.activeItem = me.previousActiveItem || me.getDefaultNavigationItem(keyEvent);
      }

      if (me.activeItem !== activeItem) {
        /**
         * Fired when a user gesture causes the active item to change _or become `null`_.
         * @event navigate
         * @param {Event} event The browser event which instigated navigation. May be a click or key or focus move event.
         * @param {HTMLElement} item The newly active item, or `null` if focus moved out.
         * @param {HTMLElement} oldItem The previously active item, or `null` if focus is moving in.
         */
        me.triggerNavigate(keyEvent);
      }
    }
  }

  getDefaultNavigationItem(keyEvent) {
    const {
      target,
      itemSelector,
      prevKey,
      nextKey
    } = this; // Navigating backwards from after the component, we default to last item

    if (target.compareDocumentPosition(keyEvent.target) & 4 && keyEvent.key === prevKey) {
      return target.querySelector(`${itemSelector}:last-of-type`);
    } // Navigating forwards from before the component we default to the first item


    if (target.compareDocumentPosition(keyEvent.target) & 2 && keyEvent.key === nextKey) {
      return target.querySelector(`${itemSelector}`);
    }
  }

  navigatePrevious(keyEvent) {
    const me = this,
          previous = me.previous;
    keyEvent.preventDefault();

    if (previous) {
      me.ownerCmp.scrollable.scrollIntoView(previous, {
        animate: me.scrollDuration
      }).then(() => {
        me.activeItem = previous;
        me.triggerNavigate(keyEvent);
      });
    }
  }

  navigateNext(keyEvent) {
    const me = this,
          next = me.next;
    keyEvent.preventDefault();

    if (next) {
      me.ownerCmp.scrollable.scrollIntoView(next, {
        animate: me.scrollDuration
      }).then(() => {
        me.activeItem = next;
        me.triggerNavigate(keyEvent);
      });
    }
  }

  get owner() {
    return this.ownerCmp;
  }

  get previous() {
    return this.getAdjacent(-1);
  }

  get next() {
    return this.getAdjacent(1);
  }
  /**
   * Returns the next or previous navigable element starting from the passed `from` element,
   * navigating in the passed direction.
   * @param {HTMLElement} [from] The start point. Defaults to the current {@link #config-activeItem}
   * @param {Number} [direction=1] The direction. -1 for backwards, else forwards.
   */


  getAdjacent(direction = 1, from = this.activeItem) {
    const treeWalker = this.treeWalker;
    treeWalker.currentNode = from;
    treeWalker[direction < 0 ? 'previousNode' : 'nextNode']();

    if (treeWalker.currentNode !== this.activeItem) {
      return treeWalker.currentNode;
    }
  }

  onTargetFocusIn(focusInEvent) {
    const me = this,
          {
      target
    } = focusInEvent,
          {
      itemsTabbable,
      skipScrollIntoView
    } = me; // Ignore navigating to a focus trap. It will bounce back in

    if (!target.matches('.b-focus-trap')) {
      if (target.matches(me.itemSelector)) {
        // We may need to know this in downstream code.
        // for example set activeItem must not scrollIntoView on click
        me.skipScrollIntoView = true;
        me.activeItem = target;
        me.skipScrollIntoView = skipScrollIntoView; // If we are using natural, TAB based navigation, trigger the navigate event after it really happens.

        if (me.activeItem && itemsTabbable) {
          me.triggerNavigate(focusInEvent);
        }
      } // Upward focusing from within means a SHIFT+TAB, so go to previous sibling
      // PATCH: IE11 may receive event which related target is not an instance of HTMLElement
      else {
        const toWidget = _widget_Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].fromElement(focusInEvent.target); // If we are focusing into an owned widget (such as an Editor), ignore. It will revert focus
        // when it hides.

        if (!toWidget || !me.owner.owns(toWidget)) {
          var _focusInEvent$related, _focusInEvent$related2;

          if (!itemsTabbable && (_focusInEvent$related = focusInEvent.relatedTarget) !== null && _focusInEvent$related !== void 0 && (_focusInEvent$related2 = _focusInEvent$related.matches) !== null && _focusInEvent$related2 !== void 0 && _focusInEvent$related2.call(_focusInEvent$related, me.itemSelector)) {
            var _me$owner$previousSib;

            (_me$owner$previousSib = me.owner.previousSibling) === null || _me$owner$previousSib === void 0 ? void 0 : _me$owner$previousSib.focus();
          }
        }
      }
    }
  }

  onTargetFocusOut(focusOutEvent) {
    const me = this,
          {
      relatedTarget
    } = focusOutEvent; // Ignore navigating to a focus trap. It will bounce back in

    if (!(relatedTarget !== null && relatedTarget !== void 0 && relatedTarget.matches('.b-focus-trap'))) {
      if (!relatedTarget || !me.target.contains(relatedTarget) || !relatedTarget.matches(me.itemSelector)) {
        if (me.activeItem) {
          me.activeItem = null; // If we are using natural, TAB based navigation, trigger the navigate event after it really happens.

          if (me.itemsTabbable) {
            me.triggerNavigate(focusOutEvent);
          }
        }
      }
    }
  }

  onTargetMouseDown(mouseDownEvent) {
    const me = this,
          target = mouseDownEvent.target.closest(me.itemSelector);
    me.mouseDownEvent = mouseDownEvent; // Mousedown is the focus gesture.
    // This holds true even on touch platforms
    // where the mousedown event is synthesized -
    // preventing default prevents focus on the upcoming touchend.

    if (me.ownerCmp.itemsFocusable === false) {
      me.onFocusGesture(mouseDownEvent);
    } else if (target) {
      mouseDownEvent.preventDefault();
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].focusWithoutScrolling(target);
    }
  }

  onTargetClick(clickEvent) {
    var _me$mouseDownEvent;

    const me = this,
          {
      skipScrollIntoView
    } = me;

    if (me.skipNextClick || (_me$mouseDownEvent = me.mouseDownEvent) !== null && _me$mouseDownEvent !== void 0 && _me$mouseDownEvent.ignoreNavigation) {
      me.skipNextClick = false;
      return;
    }

    if (me.disabled) {
      return;
    } // We may need to know this in downstream code.
    // for example set activeItem must not scrollIntoView on click


    me.skipScrollIntoView = true; // ownerCmp's preprocessing of any navigate event.

    if (me.processEvent) {
      clickEvent = me.processEvent.call(me.ownerCmp, clickEvent);
    }

    if (clickEvent) {
      me.activeItem = clickEvent.target.closest(me.itemSelector);
      me.triggerNavigate(clickEvent);
    }

    me.skipScrollIntoView = skipScrollIntoView;
  } // We have to prevent focus moving from eg, an input field when we mousedown
  // or touchtap a non focusable item when ownerCmp has itemsFocusable: false.
  // If the event was not on an item, we must allow it through to allow Lists
  // to contain other widgets.


  onFocusGesture(event) {
    if (event.target === this.ownerCmp.contentElement || event.target.closest(this.itemSelector) && this.ownerCmp.itemsFocusable === false) {
      event.preventDefault();
    }
  }

  acceptNode(node) {
    return node.offsetParent && node.matches && node.matches(this.itemSelector) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
  }

  changeActiveItem(activeItem) {
    if (activeItem != null) {
      // List and Menu's getItem API allows number, or node or record or record id to be passed
      if (this.ownerCmp.getItem) {
        activeItem = this.ownerCmp.getItem(activeItem);
      }
    }

    return activeItem;
  }

  updateActiveItem(activeItem, oldActiveItem) {
    const me = this,
          {
      ownerCmp
    } = me,
          isActive = oldActiveItem && me.target.contains(oldActiveItem);

    if (isActive) {
      me.previousActiveItem = oldActiveItem;
    } // This may be set to null on focusout of the target element.
    // Cannot use truthiness test because index zero may be passed.


    if (activeItem != null) {
      // If the user was able to click the event, they will not expect it to attempt to scroll.
      if (!me.skipScrollIntoView) {
        var _ownerCmp$scrollable;

        (_ownerCmp$scrollable = ownerCmp.scrollable) === null || _ownerCmp$scrollable === void 0 ? void 0 : _ownerCmp$scrollable.scrollIntoView(activeItem, {
          block: 'nearest',
          // If we are being called in response to focus movement, it will already be the document.activeElement
          // so in that case, behave is if we were in non-focusing mode, and just add the focused class.
          focus: _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isFocusable(activeItem) && activeItem !== _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(activeItem),
          silent: me.scrollSilently
        });
      } // No change in active item, do nothing after we've ensured it's fully in view.


      if (activeItem === oldActiveItem && isActive) {
        return;
      }

      if (oldActiveItem) {
        oldActiveItem.classList.remove(me.focusCls);
      }

      activeItem.classList.add(me.focusCls);
      me._activeItem = activeItem;
    } else {
      if (oldActiveItem) {
        oldActiveItem.classList.remove(me.focusCls); // If we are clearing the activeItem, and it's focused, keep focus
        // close by actively reverting it.

        if (oldActiveItem === _DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(oldActiveItem)) {
          ownerCmp.revertFocus();
        }
      }

      me._activeItem = null;
    }
  }

  updateTarget(target, oldTarget) {
    const me = this,
          listeners = {
      element: target,
      thisObj: me,
      focusin: 'onTargetFocusIn',
      focusout: 'onTargetFocusOut'
    };

    if (!me.itemsTabbable) {
      // We don't need pointer events if items are tabbable
      listeners.mousedown = 'onTargetMouseDown';
      listeners.click = 'onTargetClick';
    }

    if (!Object.prototype.hasOwnProperty.call(me, 'acceptNode')) {
      me.acceptNode = me.acceptNode.bind(me); // https://github.com/webcomponents/webcomponentsjs/issues/556
      // Work around Internet Explorer wanting a function instead of an object.
      // IE also *requires* this argument where other browsers don't.

      me.acceptNode.acceptNode = me.acceptNode;
    }

    _EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on(listeners); // This Navigator object acts as the filter for the TreeWalker. We must implement acceptNode(node)

    me.treeWalker = me.setupTreeWalker(target, NodeFilter.SHOW_ELEMENT, me.acceptNode, false); // If we were not configured with an outside key event provider (think the input field providing UP/DOWN keys for the dropdown)
    // then use the target element as the source.

    if (!me.keyEventTarget) {
      me.keyEventTarget = target;
    } // If the activeItem gets removed, we must know, and deactivate.


    (me.targetMutationMonitor = new MutationObserver(me.onTargetChildListChange.bind(me))).observe(target, {
      childList: true,
      subtree: true
    });
  }

  setupTreeWalker(root, whatToShow, filter, entityReferenceExpansion) {
    // This Navigator object acts as the filter for the TreeWalker. We must implement acceptNode(node)
    return document.createTreeWalker(root, whatToShow, filter, entityReferenceExpansion);
  }

  onTargetChildListChange() {
    const activeItem = this.activeItem; // On DOM mutation, if the activeItem got changed, pull the one with the same ID out again.

    if (activeItem) {
      if (this.target.contains(activeItem)) {
        activeItem.classList.add(this.focusCls);
      } else {
        // Passing undefined results in the config setter assuming no-change
        // So we must use null to clear.
        this.activeItem = this.target.querySelector(`${this.itemSelector}[data-id="${activeItem.dataset.id}"]`) || null;
      }
    }
  }

  changeKeyEventTarget(keyEventTarget) {
    this._keyEventTarget = keyEventTarget;
    _EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: keyEventTarget,
      keydown: 'onKeyDown',
      thisObj: this
    });
  }

  triggerNavigate(event, item = this.activeItem) {
    var _this$ownerCmp;

    const navEvent = {
      event,
      item,
      oldItem: this.previousActiveItem
    };
    this.trigger('navigate', navEvent);
    (_this$ownerCmp = this.ownerCmp) === null || _this$ownerCmp === void 0 ? void 0 : _this$ownerCmp.trigger('navigate', navEvent);
  }

}
Navigator._$name = 'Navigator';

/***/ }),

/***/ "./lib/Core/helper/util/NumberFormat.js":
/*!**********************************************!*\
  !*** ./lib/Core/helper/util/NumberFormat.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NumberFormat; });
/* harmony import */ var _Formatter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Formatter.js */ "./lib/Core/helper/util/Formatter.js");
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../localization/En.js */ "./lib/Core/localization/En.js");
var productName = 'taskboard';




/**
 * @module Core/helper/util/NumberFormat
 */

const escapeRegExp = _StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].escapeRegExp,
      digitsRe = /[\d+-]/g,
      // We cannot pass locale=null:
newFormatter = (locale, config) => new Intl.NumberFormat(locale || undefined, config),
      numFormatRe = /^(?:([$])\s*)?(?:(\d+)>)?\d+(,\d+)?(?:\.((\d*)(?:#*)|[*]))?(?:\s*([%])?)?$/;

class NumberParser {
  constructor(formatter) {
    const me = this,
          locale = formatter.locale,
          // We need a formatter for this locale that has decimals and grouping:
    numFmt = newFormatter(locale, {
      maximumFractionDigits: 3
    }),
          currency = formatter.is.currency ? me._decodeStyle(locale, {
      style: 'currency',
      currency: formatter.currency,
      currencyDisplay: formatter.currencyDisplay
    }) : null,
          percent = formatter.is.percent ? me._decodeStyle(locale, {
      style: 'percent'
    }) : null,
          decimal = numFmt.format(1.2).replace(digitsRe, '')[0],
          grouper = numFmt.format(1e9).replace(digitsRe, '')[0] || '';
    Object.assign(me, {
      currency,
      decimal,
      formatter,
      grouper,
      percent
    });
    me.decimal = decimal;
    me.decimalRe = escapeRegExp(decimal, 'g');
    me.grouper = grouper; // The stripRe removes whitespace, currency text, percent text and grouping chars:

    me.stripRe = new RegExp(`(?:\\s+|${escapeRegExp(grouper)})` + (currency ? `|(?:${escapeRegExp(currency.text)})` : '') + (percent ? `|(?:${escapeRegExp(percent.text)})` : ''), 'g');
  }

  decimalPlaces(value) {
    value = value.replace(this.stripRe, '');
    const dot = value.indexOf(this.decimal) + 1;
    return dot && value.length - dot;
  }

  parse(value, strict) {
    if (typeof value === 'string') {
      value = value.replace(this.stripRe, '').replace(this.decimalRe, '.');
      value = strict ? Number(value) : parseFloat(value);

      if (this.formatter.is.percent) {
        value /= 100;
      }
    } // else, a number is already parsed but could be null...


    return value;
  }

  _decodeStyle(locale, fmtDef) {
    const fmt = newFormatter(locale, fmtDef),
          decFmt = newFormatter(locale, Object.assign(fmt.resolvedOptions(), {
      style: 'decimal'
    })),
          zero = fmt.format(0),
          // = '0%' or '$0.00' in en-US
    zeroDec = decFmt.format(0); // = '0' or '0.00' in en-US

    return {
      suffix: zero.startsWith(zeroDec),
      text: zero.replace(zeroDec, '').trim()
    };
  }

}
/**
 * This class is an enhancement to `Intl.NumberFormat` that has a more flexible
 * constructor as well as other features such as `parse()`.
 *
 * All constructor forms take a single argument. The most common is to pass a format
 * {@link #config-template} string:
 *```
 *  const formatter = new NumberFormat('9,999.99##');
 *```
 * The above is equivalent to:
 *```
 *  const formatter = new Intl.NumberFormat({
 *      useGrouping           : true,
 *      minimumFractionDigits : 2,
 *      maximumFractionDigits : 4
 *  });
 *```
 * The `formatter` created above is used as follows (in the `en-US` locale):
 *```
 *  console.log(formatter.format(12345.54321));
 *  console.log(formatter.format(42));
 *
 *  // 12,345.5432
 *  // 42.00
 *```
 * When a format template is insufficient, a config object can be provided, similar to
 * `Intl.NumberFormat`'s `options` parameter. While all options from `Intl.NumberFormat`
 * are valid properties for this class's config object, additional properties are
 * supported.
 *
 * For example:
 *```
 *  new NumberFormat({
 *      locale      : 'en-US',
 *      template    : '$9,999',
 *      currency    : 'USD',
 *      significant : 5
 *  });
 *```
 * The `locale` option takes the place of the first positional parameter to the
 * `Intl.NumberFormat` constructor. The `template` config is the same string that can be
 * passed by itself.
 *
 * The shorthand properties `fraction`, `integer`, and `significant` set the standard
 * options `minimumFractionDigits`, `maximumFractionDigits`, `minimumIntegerDigits`,
 * `minimumSignificantDigits`, and `maximumSignificantDigits`.
 *
 * NOTE: Instances of `NumberFormat` are immutable after construction.
 *
 * For details about `Intl.NumberFormat` see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat).
 */


class NumberFormat extends _Formatter_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'NumberFormat';
  }

  initialize() {
    this._as = {// cacheKey : cachedInstance
    };
    this.is = {
      decimal: false,
      currency: false,
      percent: false,
      null: true,
      from: null
    };
  }

  get truncator() {
    const scale = this.maximumFractionDigits;
    return scale == null ? null : this.as({
      style: 'decimal',
      maximumFractionDigits: Math.min(20, scale + 1)
    }, 'truncator');
  }

  configure(options) {
    const me = this;

    if (typeof options !== 'string') {
      Object.assign(me, options);
    } else {
      me.template = options;
    } // Do not remove. Assertion strings for Localization sanity check.
    // 'L{locale}'
    // 'L{currency}'


    const config = {},
          loc = me.locale ? _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].locales[me.locale] : _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].locale,
          defaults = loc && loc.NumberFormat,
          template = me.template;

    if (defaults) {
      for (const key in defaults) {
        if (me[key] == null && typeof defaults[key] !== 'function') {
          me[key] = defaults[key];
        }
      }
    }

    if (template) {
      const match = numFormatRe.exec(template),
            m2 = match[2],
            m4 = match[4];
      me.useGrouping = !!match[3];
      me.style = match[1] ? 'currency' : match[6] ? 'percent' : 'decimal';

      if (m2) {
        me.integer = +m2;
      }

      if (m4 === '*') {
        me.fraction = [0, 20];
      } else if (m4 != null) {
        me.fraction = [match[5].length, m4.length];
      }
    }

    me._minMax('fraction', true, true);

    me._minMax('integer', true, false);

    me._minMax('significant', false, true);

    for (const key in me.defaults) {
      if (me[key] != null) {
        config[key] = me[key];
      }
    }

    me.is.from = me.from && me.from.is;
    me.is[me.style] = !(me.is.null = false);
    me.formatter = newFormatter(me.locale, config);
  }
  /**
   * Creates a derived `NumberFormat` from this instance, with a different `style`. This is useful for processing
   * currency and percentage styles without the symbols being injected in the formatting.
   *
   * @param {String|Object} change The new style (if a string) or a set of properties to update.
   * @param {String} [cacheAs] A key by which to cache this derived formatter.
   * @returns {Core.helper.util.NumberFormat}
   */


  as(change, cacheAs = null) {
    const config = this.resolvedOptions() || {
      template: '9.*'
    },
          cache = this._as;
    let ret = cacheAs && cache[cacheAs];

    if (!ret) {
      if (typeof change === 'string') {
        config.style = change;
      } else {
        Object.assign(config, change);
      }

      config.from = this;
      ret = new NumberFormat(config);
    }

    if (cacheAs) {
      cache[cacheAs] = ret;
    }

    return ret;
  }

  defaultParse(value, strict) {
    return value == null ? value : strict ? Number(value) : parseFloat(value);
  }
  /**
   * Returns the given `value` formatted in accordance with the specified locale and
   * formatting options.
   *
   * @param {Number} value
   * @returns {String}
   */


  format(value) {
    if (typeof value === 'string') {
      const v = Number(value);
      value = isNaN(v) ? this.parse(value) : v;
    }

    return super.format(value);
  } // The parse() method is inherited but the base class implementation
  // cannot properly document the parameter and return types:

  /**
   * Returns a `Number` parsed from the given, formatted `value`, in accordance with the
   * specified locale and formatting options.
   *
   * If the `value` cannot be parsed, `NaN` is returned.
   *
   * Pass `strict` as `true` to require all text to convert. In essence, the default is
   * in line with JavaScript's `parseFloat` while `strict=true` behaves like the `Number`
   * constructor:
   *```
   *  parseFloat('1.2xx');  // = 1.2
   *  Number('1.2xx')       // = NaN
   *```
   * @method parse
   * @param {String} value
   * @param {Boolean} [strict=false]
   * @returns {Number}
   */

  /**
   * Returns a `Number` parsed from the given, formatted `value`, in accordance with the
   * specified locale and formatting options.
   *
   * If the `value` cannot be parsed, `NaN` is returned.
   *
   * This method simply passes the `value` to `parse()` and passes `true` for the second
   * argument.
   *
   * @method parseStrict
   * @param {String} value
   * @returns {Number}
   */

  /**
   * Returns the given `Number` rounded in accordance with the specified locale and
   * formatting options.
   *
   * @param {Number|String} value
   * @returns {Number}
   */


  round(value) {
    return this.parse(this.format(value));
  }
  /**
   * Returns the given `Number` truncated to the `maximumFractionDigits` in accordance
   * with the specified locale and formatting options.
   *
   * @param {Number|String} value
   * @returns {Number}
   */


  truncate(value) {
    const me = this,
          scale = me.maximumFractionDigits,
          {
      truncator
    } = me;
    let v = me.parse(value),
        dot;

    if (truncator) {
      v = truncator.format(v);
      dot = v.indexOf(truncator.parser.decimal);

      if (dot > -1 && v.length - dot - 1 > scale) {
        v = v.substr(0, dot + scale + 1);
      }

      v = truncator.parse(v);
    }

    return v;
  }

  resolvedOptions() {
    const options = super.resolvedOptions();

    for (const key in options) {
      // For some reason, on TeamCity, tests get undefined for some properties...
      // maybe a locale issue?
      if (options[key] === undefined) {
        options[key] = this[key];
      }
    }

    return options;
  }
  /**
   * Expands the provided shorthand into the "minimum*Digits" and "maximum*Digits".
   * @param {String} name
   * @param {Boolean} setMin
   * @param {Boolean} setMax
   * @private
   */


  _minMax(name, setMin, setMax) {
    const me = this,
          value = me[name];

    if (value != null) {
      const capName = _StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(name),
            max = `maximum${capName}Digits`,
            min = `minimum${capName}Digits`;

      if (typeof value === 'number') {
        if (setMin) {
          me[min] = value;
        }

        if (setMax) {
          me[max] = value;
        }
      } else {
        me[min] = value[0];
        me[max] = value[1];
      }
    }
  }

}
NumberFormat.Parser = NumberParser;
Object.assign(NumberFormat.prototype, {
  // This object holds only those properties that Intl.NumberFormat accepts in its
  // "options" parameter. Only these options will be copied from the NumberFormat
  // and passed to the Intl.NumberFormat constructor and only these will be copied
  // back from its resolvedOptions:
  defaults: {
    /**
     * The formatting style.
     *
     * Valid values are: `'decimal'` (the default), `'currency'`, and `'percent'`.
     * @config {String}
     * @default
     */
    style: 'decimal',

    /**
     * The currency to use when using `style: 'currency'`. For example, `'USD'` (US dollar)
     * or `'EUR'` for the euro.
     *
     * If not provided, the {@link Core.localization.LocaleManager} default will be used.
     * @config {Boolean}
     */
    currency: null,

    /**
     * The format in which to display the currency value when using `style: 'currency'`.
     *
     * Valid values are: `'symbol'` (the default), `'code'`, and `'name'`.
     * @config {String}
     * @default
     */
    currencyDisplay: 'symbol',

    /**
     * The name of the locale. For example, `'en-US'`. This config is the same as the
     * first argument to the `Intl.NumberFormat` constructor.
     *
     * Defaults to the browser's default locale.
     * @config {String}
     */
    locale: null,

    /**
     * The maximum number of digits following the decimal.
     *
     * This is more convenient to specify using the {@link #config-fraction} config.
     * @config {Number}
     */
    maximumFractionDigits: null,

    /**
     * The minimum number of digits following the decimal.
     *
     * This is more convenient to specify using the {@link #config-fraction} config.
     * @config {Number}
     */
    minimumFractionDigits: null,

    /**
     * The minimum number of digits preceding the decimal.
     *
     * This is more convenient to specify using the {@link #config-integer} config.
     * @config {Number}
     */
    minimumIntegerDigits: null,

    /**
     * The maximum number of significant digits.
     *
     * This is more convenient to specify using the {@link #config-significant} config.
     * @config {Number}
     */
    maximumSignificantDigits: null,

    /**
     * The minimum number of significant digits.
     *
     * This is more convenient to specify using the {@link #config-significant} config.
     * @config {Number}
     */
    minimumSignificantDigits: null,

    /**
     * Specify `false` to disable thousands separators.
     * @config {Boolean}
     * @default
     */
    useGrouping: true
  },

  /**
   * Specifies the `minimumFractionDigits` and `minimumFractionDigits` in a compact
   * way. If this value is a `Number`, it sets both the minimum and maximum to that
   * value. If this value is an array, `[0]` sets the minimum and `[1]` sets the
   * maximum.
   * @config {Number|Number[]}
   */
  fraction: null,
  from: null,

  /**
   * An alias for `minimumIntegerDigits`.
   * @config {Number}
   */
  integer: null,

  /**
   * Specifies the `minimumSignificantDigits` and `minimumSignificantDigits` in a compact
   * format. If this value is a `Number`, it sets only the maximum to that value. If this
   * value is an array, `[0]` sets the minimum and `[1]` sets the maximum.
   *
   * If this value (or `minimumSignificantDigits` or `minimumSignificantDigits`) is set,
   * `integer` (and `minimumIntegerDigits`) and `fraction` (and `minimumFractionDigits`
   * and `minimumFractionDigits`) are ignored.
   *
   * @config {Number|Number[]}
   */
  significant: null,

  /**
   * A format template consisting of the following parts:
   *```
   *  [$] [\d+:] \d+ [,\d+] [.\d* [#*] | *] [%]
   *```
   * If the template begins with a `'$'`, the formatter's `style` option is set to
   * `'currency'`. If the template ends with `'%'`, `style` is set to `'percent'`.
   * It is invalid to include both characters. When using `'$'`, the `currency` symbol
   * defaults to what is provided by the {@link Core.localization.LocaleManager}.
   *
   * To set the `minimumIntegerDigits`, the desired minimum comes before the first
   * digits in the template and is followed by a `'>'` (greater-than). For example:
   *```
   *  5>9,999.00
   *```
   * The above sets `minimumIntegerDigits` to 5.
   *
   * The `useGrouping` option is enabled if there is a `','` (comma) present and is
   * disabled otherwise.
   *
   * If there is a `'.'` (decimal) present, it may be followed by either of:
   *
   *  - Zero or more digits which may then be followed by zero or more `'#'` characters.
   *    The number of digits determines the `minimumFractionDigits`, while the total
   *    number of digits and `'#'`s determines the `maximumFractionDigits`.
   *  - A single `'*'` (asterisk) indicating any number of fractional digits (no minimum
   *    or maximum).
   *
   * @config {String}
   */
  template: null
});
Object.assign(NumberFormat.prototype, NumberFormat.prototype.defaults); // TODO is this the "right" way to do this?

_Formatter_js__WEBPACK_IMPORTED_MODULE_0__["default"].number = (format, value) => NumberFormat.format(format, value);

NumberFormat._$name = 'NumberFormat';

/***/ }),

/***/ "./lib/Core/helper/util/Objects.js":
/*!*****************************************!*\
  !*** ./lib/Core/helper/util/Objects.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Objects; });
/* harmony import */ var _StringHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'taskboard'; // IMPORTANT - adding imports here can create problems for Base class
//  That is why this file was split from ObjectHelper


const {
  toString
} = Object.prototype,
      {
  isFrozen
} = Object,
      afterRe = /\s*<\s*/,
      beforeRe = /\s*>\s*/,
      blendOptions = {},
      typeNameRe = /\[object ([^\]]+)]/,
      typeCache = {},
      emptyObject = Object.freeze({});
/**
 * @module Core/helper/util/Objects
 */
// Static methods are not displayed in derived class documentation. Therefore, since this is an internal class, the
// work around is to copy method documentation to ObjectHelper (the public interface). Also tried making ObjectHelper
// a singleton.

/**
 * Helper for low-level Object manipulation.
 *
 * While documented on {@link Core.helper.ObjectHelper}, the following static methods are implemented by this class:
 *
 * - `{@link Core.helper.ObjectHelper#function-assign-static}`
 * - `{@link Core.helper.ObjectHelper#function-assignIf-static}`
 * - `{@link Core.helper.ObjectHelper#function-clone-static}`
 * - `{@link Core.helper.ObjectHelper#function-createTruthyKeys-static}`
 * - `{@link Core.helper.ObjectHelper#function-getPath-static}`
 * - `{@link Core.helper.ObjectHelper#function-getTruthyKeys-static}`
 * - `{@link Core.helper.ObjectHelper#function-getTruthyValues-static}`
 * - `{@link Core.helper.ObjectHelper#function-isEmpty-static}`
 * - `{@link Core.helper.ObjectHelper#function-isObject-static}`
 * - `{@link Core.helper.ObjectHelper#function-merge-static}`
 * - `{@link Core.helper.ObjectHelper#function-setPath-static}`
 * - `{@link Core.helper.ObjectHelper#function-typeOf-static}`
 * @internal
 */

class Objects {
  static assign(dest, ...sources) {
    for (let source, key, i = 0; i < sources.length; i++) {
      source = sources[i];

      if (source) {
        for (key in source) {
          dest[key] = source[key];
        }
      }
    }

    return dest;
  }

  static assignIf(dest, ...sources) {
    for (let source, key, i = 0; i < sources.length; i++) {
      source = sources[i];

      if (source) {
        for (key in source) {
          if (!(key in dest) || dest[key] === undefined) {
            dest[key] = source[key];
          }
        }
      }
    }

    return dest;
  }

  static blend(dest, source, options) {
    options = options || blendOptions;
    dest = dest || {};
    const {
      clone = Objects.clone,
      merge = Objects.blend
    } = options;

    if (Array.isArray(source)) {
      if (source.length > 1) {
        source.forEach(s => {
          dest = Objects.blend(dest, s, options);
        });
        return dest;
      }

      source = source[0];
    }

    if (source) {
      let destValue, key, value;

      for (key in source) {
        value = source[key];

        if (value && O.isObject(value)) {
          destValue = dest[key];
          options.key = key;

          if (destValue && O.isObject(destValue)) {
            if (isFrozen(destValue)) {
              dest[key] = destValue = clone(destValue, options);
            }

            value = merge(destValue, value, options);
          } else {
            // We don't need to clone frozen objects, but we do clone mutable objects as they get
            // applied to the dest.
            value = isFrozen(value) ? value : clone(value, options);
          }
        }

        dest[key] = value;
      }
    }

    return dest;
  }

  static clone(value, handler) {
    let cloned = value,
        key;

    if (value && typeof value === 'object') {
      const options = handler && typeof handler === 'object' && handler;

      if (options) {
        // When using blend(), the 2nd argument is the options object, so ignore that case
        handler = null;
      }

      if (O.isObject(value)) {
        cloned = {};

        for (key in value) {
          cloned[key] = O.clone(value[key]);
        }
      } else if (Array.isArray(value)) {
        cloned = []; // Loop backwards to:
        //  1. read source.length once
        //  2. get result array sized on first pass (avoid growing)

        for (key = value.length; key-- > 0;) {
          cloned[key] = O.clone(value[key]);
        }
      } else if (O.isDate(value)) {
        cloned = new Date(value.getTime());
      } else if (handler) {
        // Allow other types to be handled (e.g., DOM nodes).
        cloned = handler(value);
      }
    }

    return cloned;
  }

  static createTruthyKeys(source) {
    const keys = _StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].split(source),
          result = keys && {};

    if (keys) {
      for (const key of keys) {
        // StringHelper.split won't return empty keys if passed a string, but we
        // could have been passed a String[]
        if (key) {
          result[key] = true;
        }
      }
    }

    return result;
  }
  /**
   * Returns value for a given path in the object
   * @param {Object} object Object to check path on
   * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
   * @returns {*} Value associated with passed key
   */


  static getPath(object, path) {
    return path.split('.').reduce((result, key) => {
      return (result || emptyObject)[key];
    }, object);
  }
  /**
   * Returns value for a given path in the object, placing a passed default value in at the
   * leaf property and filling in undefined properties all the way down.
   * @param {Object} object Object to get path value for.
   * @param {String|Number|String[]|Number[]} path Dot-separated path, e.g. 'firstChild.childObject.someKey',
   * or the key path as an array, e.g. ['firstChild', 'childObject', 'someKey'].
   * @param {*} [defaultValue] Optionally the value to put in as the `someKey` property.
   * @returns {*} Value at the leaf position of the path.
   */


  static getPathDefault(object, path, defaultValue) {
    const keys = Array.isArray(path) ? path : typeof path === 'string' ? path.split('.') : [path],
          length = keys.length - 1;
    return keys.reduce((result, key, index) => {
      if (defaultValue && !(key in result)) {
        // Can't use emptyObject here, we are creating a node in the object tree
        result[key] = index === length ? defaultValue : {};
      }

      return (result || emptyObject)[key];
    }, object);
  }
  /**
   * Determines if the specified path exists
   * @param {Object} object Object to check path on
   * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
   * @returns {Boolean}
   */


  static hasPath(object, path) {
    return path.split('.').every(key => {
      if (key in object) {
        object = object[key];
        return true;
      }

      return false;
    });
  }

  static getTruthyKeys(source) {
    const keys = [];

    for (const key in source) {
      if (source[key]) {
        keys.push(key);
      }
    }

    return keys;
  }

  static getTruthyValues(source) {
    const values = [];

    for (const key in source) {
      if (source[key]) {
        values.push(source[key]);
      }
    }

    return values;
  }

  static isClass(object) {
    var _object$prototype;

    if (typeof object === 'function' && ((_object$prototype = object.prototype) === null || _object$prototype === void 0 ? void 0 : _object$prototype.constructor) === object) {
      // TODO find a way to differentiate function(){} from class{}
      return true;
    }

    return false;
  }

  static isDate(object) {
    // A couple quick rejections but only sure way is typeOf:
    return Boolean(object && object.getUTCDate) && O.typeOf(object) === 'date';
  }
  /**
   * Check if passed object is a Promise or contains `then` method.
   * Used to fix problems with detecting promises in code with `instance of Promise` when
   * Promise class is replaced with any other implementation like `ZoneAwarePromise` in Angular.
   * Related to these issues:
   * https://github.com/bryntum/support/issues/791
   * https://github.com/bryntum/support/issues/2990
   *
   * @param {Object} object object to check
   * @returns {Boolean} truthy value if object is a Promise
   * @internal
   */


  static isPromise(object) {
    if (Promise && Promise.resolve) {
      return Promise.resolve(object) === object || typeof (object === null || object === void 0 ? void 0 : object.then) === 'function';
    }

    throw new Error('Promise not supported in your environment');
  }

  static isEmpty(object) {
    if (object && typeof object === 'object') {
      // eslint-disable-next-line no-unreachable-loop
      for (const p in object) {
        // eslint-disable-line no-unused-vars
        return false;
      }
    }

    return true;
  }

  static isObject(value) {
    const C = value === null || value === void 0 ? void 0 : value.constructor;
    return Boolean(C // Most things have a .constructor property
    ? // An in-frame instance of Object
    C === Object || // Detect cross-frame objects, but exclude instance of custom classes named Object. typeOf(value) is
    // "object" even for instances of a class and typeOf(C) is "function" for all constructors. We'll have
    // to settle for relying on the fact that getPrototypeOf(Object.prototype) === null.
    // NOTE: this issue does come up in Scheduler unit tests at least.
    // NOTE: IE11 does not have C.name === 'Object' for cross-frame objects! So instead of that check we
    //  do a presence check for a method unlikely to be found elsewhere.
    C.getPrototypeOf && C.prototype && !Object.getPrototypeOf(C.prototype) // Since all classes have a constructor property, an object w/o one is likely from Object.create(null). Of
    // course, primitive types do not have ".constructor"
    : value && typeof value === 'object');
  }

  static isInstantiated(object) {
    return object ? typeof object === 'object' && !Objects.isObject(object) : false;
  }

  static merge(dest, ...sources) {
    return Objects.blend(dest, sources);
  }
  /**
   * Merges two "items" objects. An items object is a simple object whose keys act as identifiers and whose values
   * are "item" objects. An item can be any object type. This method is used to merge such objects while maintaining
   * their property order. Special key syntax is used to allow a source object to insert a key before or after a key
   * in the `dest` object.
   *
   * For example:
   * ```javascript
   *  let dest = {
   *      foo : {},
   *      bar : {},
   *      fiz : {}
   *  }
   *
   *  console.log(Object.keys(dest));
   *  > ["foo", "bar", "fiz"]
   *
   *  dest = mergeItems(dest, {
   *      'zip > bar' : {}    // insert "zip" before "bar"
   *      'bar < zap' : {}    // insert "zap" after "bar"
   *  });
   *
   *  console.log(Object.keys(dest));
   *  > ["foo", "zip", "bar", "zap", "fiz"]
   * ```
   *
   * @param {Object} dest The destination object.
   * @param {Object|Object[]} src The source object or array of source objects to merge into `dest`.
   * @param {Object} [options] The function to use to merge items.
   * @param {Function} [options.merge] The function to use to merge items.
   * @returns {Object} The merged object. On ES6 standard browsers, this will be the `dest` object. On IE11 it will
   * be a new object.
   * @internal
   */


  static mergeItems(dest, src, options) {
    options = options || blendOptions;
    let anchor, delta, index, indexMap, key, shuffle, srcVal;
    const {
      merge = Objects.blend,
      rebuild = !Objects.ES6_OBJECT_ORDER
    } = options;
    dest = dest || {};

    if (Array.isArray(src)) {
      src.forEach(s => {
        dest = Objects.mergeItems(dest, s, options);
      });
    } else if (src) {
      // https://2ality.com/2015/10/property-traversal-order-es6.html
      // Bottom line: Object keys are iterated in declared/insertion order... unless the key is an integer or
      // Symbol, but we don't care about those generally.
      for (key in src) {
        srcVal = src[key];
        anchor = null; // Allow a key to be added before or after another:
        //
        //  {
        //      'foo > bar' : {
        //          ...
        //      },
        //      'bar < derp' : {
        //          ...
        //      }
        //  }
        //
        // The goal above is to add a 'foo' key before the existing 'bar' key while adding a 'derp' key after
        // 'bar'.

        if (key.includes('>')) {
          [key, anchor] = key.split(beforeRe);
          delta = 0;
        } else if (key.includes('<')) {
          [anchor, key] = key.split(afterRe);
          delta = 1;
        }

        if (key in dest) {
          // Changing the value of a key does not change its iteration order. Since "key in dest" we can do
          // what we need directly.
          if (srcVal && dest[key] && merge) {
            options.key = key;
            srcVal = merge(dest[key], srcVal, options);
          }

          dest[key] = srcVal;
        } else if (!anchor) {
          var _indexMap;

          dest[key] = srcVal;
          (_indexMap = indexMap) === null || _indexMap === void 0 ? void 0 : _indexMap.set(key, indexMap.size);
        } else {
          // Lazily sprout the item index map. When we first merge an item into an items object, we create this
          // Map to control the ordering. This is because any keys we add would necessarily be iterated after
          // the original properties.
          if (!indexMap) {
            indexMap = new Map();
            index = 0;

            for (const k in dest) {
              indexMap.set(k, index++);
            }
          }

          index = indexMap.get(anchor);
          dest[key] = srcVal;

          if (index == null && delta) {
            index = indexMap.size;
          } else {
            shuffle = !rebuild && (shuffle || []);
            index = (index || 0) + delta; // Adjust all key indices >= index up by 1 to maintain integer indices (required by the above
            // use case).

            for (const item of indexMap) {
              const [k, v] = item;

              if (index <= v) {
                /*
                Consider object w/the following order:
                    {
                        foo : {}',
                        bar : {},
                        baz : {},
                        zip : {},
                        goo : {},
                        fiz : {}
                    }
                The indexMap is:
                    foo : 0
                    bar : 1
                    baz : 2
                    zip : 3
                    goo : 4
                    fiz : 5
                To insert before goo, we populate shuffle thusly (to set up for popping):
                    +-----+-----+
                    | fiz | goo |
                    +-----+-----+
                      0        1
                      =6-5-1   =6-4-1
                */
                shuffle && (shuffle[indexMap.size - v - 1] = k);
                indexMap.set(k, v + 1);
              }
            } // Delete and re-add the keys that should follow the new key to establish the iteration order
            // we need:


            if (shuffle) {
              while (shuffle.length) {
                const k = shuffle.pop(),
                      v = dest[k];
                delete dest[k];
                dest[k] = v;
              }
            }
          }

          indexMap.set(key, index);
        }
      } // IE11 does not fully support the ES6 object order standard. Fortunately, it does support the most
      // basic form of building an object from key/values in the desired order. The behavior observed for IE11
      // is that when a key is deleted and put back, it retains its original position instead of becoming the
      // last key.


      if (rebuild && indexMap) {
        const entries = Array.from(indexMap.entries()).sort((a, b) => a[1] - b[1]),
              old = dest;
        dest = {};

        for (let k, i = 0; i < entries.length; ++i) {
          k = entries[i][0];
          dest[k] = old[k];
        }
      }
    }

    return dest;
  }
  /**
   * Sets value for a given path in the object
   * @param {Object} object Target object
   * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
   * @param {*} value Value for a given path
   * @returns {Object} Returns passed object
   */


  static setPath(object, path, value) {
    path.split('.').reduce((result, key, index, array) => {
      const isLast = index === array.length - 1;

      if (isLast) {
        return result[key] = value;
      } else if (!(result[key] instanceof Object)) {
        result[key] = {};
      }

      return result[key];
    }, object);
    return object;
  }

  static typeOf(value) {
    let type = typeof value,
        match,
        trueType; // If not atomic type, we handle date or null

    if (type === 'object') {
      if (value === null) {
        type = 'null';
      } else {
        trueType = toString.call(value);

        if (!(type = typeCache[trueType])) {
          match = typeNameRe.exec(trueType);
          typeCache[trueType] = type = match ? match[1].toLowerCase() : trueType;
        }
      }
    } // NaN is the only value that is !== to itself
    else if (value !== value) {
      // eslint-disable-line no-self-compare
      type = 'nan';
    }

    return type;
  }

}
const O = Objects;

O.ES6_OBJECT_ORDER = (() => {
  const o = {
    a: 1,
    b: 2
  };
  o.c = 3; // silly IE! keys should go to the end even if previously present...

  delete o.b;
  o.b = 20;
  const keys = Object.keys(o);
  return keys[1] === 'c';
})();

Objects._$name = 'Objects';

/***/ }),

/***/ "./lib/Core/helper/util/Point.js":
/*!***************************************!*\
  !*** ./lib/Core/helper/util/Point.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Point; });
/* harmony import */ var _Rectangle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
var productName = 'taskboard';

/**
 * @module Core/helper/util/Point
 */

/**
 * Encapsulates an X,Y coordinate point.
 * @extends Core/helper/util/Rectangle
 */

class Point extends _Rectangle_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * Creates a new Point encapsulating the event's page position.
   * @param {Event} event
   * @return {Core.helper.util.Point}
   * @typings ignore
   */
  static from(event) {
    const touchPoints = event.changedTouches;
    return new Point(touchPoints ? touchPoints[0].screenX : event.screenX, touchPoints ? touchPoints[0].screenY : event.pageY);
  }
  /**
   * Constructs a Point
   * @param x The X coordinate
   * @param y The Y coordinate
   */


  constructor(x, y) {
    super(x, y, 0, 0);
  }
  /**
   * Coerces this Point to be within the passed Rectangle. Translates it into the bounds.
   * @param {Core.helper.util.Rectangle} into The Rectangle into which to coerce this Point.
   */


  constrain(into) {
    this.x = Math.min(Math.max(this.x, into.x), into.right - 1);
    this.y = Math.min(Math.max(this.y, into.y), into.bottom - 1);
    return this;
  }

  toArray() {
    return [this.x, this.y];
  }

} // The Rectangle class uses the Point class, but cannot import it.
// TODO: find a better way of getting a reference to the Point class in Rectangle.
// #8224 - Gantt angular demo doesn't work in production

Object.getPrototypeOf(Point).Point = Point;
Point._$name = 'Point';

/***/ }),

/***/ "./lib/Core/helper/util/Promissory.js":
/*!********************************************!*\
  !*** ./lib/Core/helper/util/Promissory.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Promissory; });
var productName = 'taskboard';
/**
* @module Core/helper/util/Promissory
*/

/**
 * Encapsulates a Promise and provides `resolve()` and `reject()` methods.
 *
 * For example:
 * ```
 *  load() {
 *      this.loading = new Promissory();
 *      this.store.load();
 *
 *      return this.loading.promise;
 *  }
 *
 *  onStoreLoad(store, err) {
 *      if (err) {
 *          this.loading.resolve(this);
 *      }
 *      else {
 *          this.loading.reject(err);
 *      }
 *  }
 *
 * ```
 * @internal
 */

class Promissory {
  constructor(fn) {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });

    if (fn) {
      fn(this);
    }
  }

}
Promissory._$name = 'Promissory';

/***/ }),

/***/ "./lib/Core/helper/util/RandomGenerator.js":
/*!*************************************************!*\
  !*** ./lib/Core/helper/util/RandomGenerator.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RandomGenerator; });
var productName = 'taskboard';
/**
* @module Core/helper/util/RandomGenerator
*/

/**
 * Generates pseudo random numbers from predefined sequence of 100 numbers
 */

class RandomGenerator {
  constructor() {
    this.random100 = [46, 2, 36, 46, 54, 59, 18, 20, 71, 55, 88, 98, 13, 61, 61, 40, 2, 15, 3, 32, 51, 45, 64, 25, 81, 85, 54, 13, 57, 49, 64, 22, 81, 94, 0, 62, 17, 7, 11, 2, 33, 99, 85, 26, 83, 83, 96, 26, 20, 89, 91, 38, 26, 13, 11, 79, 32, 30, 5, 51, 70, 7, 5, 56, 58, 77, 37, 89, 40, 80, 78, 59, 26, 36, 8, 51, 60, 23, 86, 5, 11, 96, 64, 94, 87, 64, 4, 78, 17, 85, 35, 0, 90, 86, 23, 55, 53, 9, 35, 59, 29, 2, 64, 42, 8, 49, 43, 73, 6, 53, 38, 9, 39, 31, 32, 40, 49, 13, 78, 68, 20, 99, 24, 78, 35, 91, 73, 46, 67, 76, 89, 69, 30, 69, 25, 3, 4, 55, 1, 65, 66, 76, 83, 19, 67, 1, 95, 24, 54, 45, 56, 40, 67, 92, 72, 4, 69, 8, 47, 50, 27, 2, 38, 9, 14, 83, 12, 14, 62, 95, 22, 47, 35, 18, 38, 14, 86, 64, 68, 61, 52, 69, 39, 93, 20, 73, 32, 52, 74, 6, 56, 68, 99, 29, 24, 92, 40, 67, 6, 72, 31, 41, 91, 53, 80, 55, 33, 97, 97, 99, 18, 20, 5, 27, 82, 84, 61, 78, 27, 67, 7, 42, 75, 95, 91, 25, 63, 21, 70, 36, 46, 0, 1, 45, 84, 6, 86, 15, 10, 62, 96, 94, 10, 23, 93, 83, 94, 47, 5, 29, 29, 52, 51, 37, 77, 96, 43, 72, 43, 14, 54, 14, 72, 52, 4, 39, 15, 26, 68, 28, 25, 76, 60, 50, 22, 40, 72, 74, 68, 58, 8, 48, 40, 62, 52, 24, 9, 26, 47, 44, 49, 96, 7, 77, 90, 45, 76, 47, 5, 86, 1, 36, 18, 42, 19, 90, 34, 23, 70, 32, 69, 79, 0, 99, 57, 80, 72, 21, 19, 72, 85, 68, 4, 40, 86, 62, 0, 63, 4, 11, 69, 31, 78, 31, 21, 78, 29, 84, 13, 53, 57, 10, 26, 50, 24, 30, 90, 42, 51, 96, 93, 21, 99, 23, 81, 0, 89, 43, 86, 63, 93, 19, 54, 71, 92, 36, 4, 95, 37, 99, 60, 29, 23, 50, 68, 95, 57, 95, 77, 53, 99, 78, 75, 12, 92, 47, 23, 14, 0, 41, 98, 11, 34, 64, 26, 90, 50, 23, 38, 31, 74, 76, 16, 76, 66, 23, 22, 72, 48, 50, 20, 36, 37, 58, 5, 43, 49, 64, 81, 30, 8, 21, 98, 75, 60, 17, 50, 42, 27, 38, 90, 74, 45, 68, 67, 27, 31, 15, 58, 76, 41, 99, 23, 98, 53, 98, 56, 19, 79, 2, 4, 38, 96, 24, 65, 51, 43, 42, 41, 60, 46, 7, 90, 65, 3, 27, 63, 99, 51, 44, 86, 1, 54, 40, 15, 74, 3, 81, 51, 63, 87, 79, 84, 72, 22, 38, 96, 95, 33, 41, 21, 99, 21, 69, 7, 49, 40, 52, 41, 6, 91, 19, 76, 40, 54, 17, 33, 11, 11, 0, 1, 32, 94, 33, 13, 18, 45, 7, 85, 61, 42, 54, 45, 72, 78, 96, 17, 9, 80, 87, 41, 96, 66, 0, 8, 59, 18, 21, 2, 28, 64, 75, 97, 32, 80, 86, 97, 97, 55, 2, 73, 75, 11, 89, 67, 58, 70, 76, 12, 46, 64, 17, 22, 97, 25, 35, 93, 57, 82, 46, 57, 61, 31, 74, 27, 4, 32, 85, 53, 86, 53, 53, 42, 5, 28, 50, 65, 63, 70, 61, 73, 37, 13, 80, 7, 34, 22, 3, 26, 6, 62, 78, 12, 56, 87, 41, 58, 64, 31, 27, 45, 35, 18, 66, 62, 43, 89, 69, 94, 93, 33, 74, 2, 43, 85, 37, 82, 41, 74, 9, 15, 44, 33, 42, 65, 19, 1, 49, 78, 12, 29, 9, 78, 7, 55, 12, 45, 40, 33, 16, 86, 14, 52, 16, 73, 76, 0, 98, 75, 91, 78, 46, 99, 95, 90, 69, 78, 45, 62, 55, 37, 88, 49, 77, 27, 83, 38, 73, 39, 1, 75, 40, 65, 83, 54, 95, 7, 73, 4, 30, 26, 36, 89, 21, 5, 95, 11, 14, 87, 45, 36, 21, 77, 55, 5, 66, 51, 98, 48, 62, 74, 58, 23, 82, 30, 28, 19, 53, 89, 76, 98, 8, 34, 70, 28, 54, 16, 52, 35, 93, 54, 54, 72, 49, 18, 93, 72, 90, 71, 73, 15, 60, 38, 80, 76, 53, 70, 39, 69, 25, 5, 31, 61, 46, 6, 54, 34, 31, 52, 33, 36, 79, 76, 44, 29, 28, 38, 1, 66, 2, 90, 91, 1, 76, 78, 31, 55, 37, 71, 2, 3, 38, 85, 0, 95, 42, 2, 39, 57, 87, 61, 77, 98, 2, 24, 80, 48, 27, 47, 71, 15, 7, 49, 60, 86, 3, 2, 29, 38, 54, 36, 59, 83, 27, 47, 9, 36, 42, 8, 73, 85, 9, 16, 73, 60, 39, 12, 43, 25, 23, 29, 28, 47, 40, 77, 20, 89, 22, 30, 41, 59, 96, 19, 56, 20, 76, 73, 39, 46, 72, 40, 47, 37, 52, 29, 79, 37, 39, 50, 41, 87, 66, 17, 75, 31, 45, 26, 88, 70, 11, 90, 40, 74, 9, 32, 65, 72, 61, 6, 93, 54, 15, 84, 22, 99, 47, 10, 96, 4, 84, 19, 85, 73, 45, 25, 16, 8, 94, 99, 39, 28, 26, 68, 87, 48, 1, 65, 86, 46, 86, 7, 60, 82, 45, 75, 38, 56, 41, 35, 30, 86, 91, 97, 85, 45, 5, 14, 69, 85, 96, 37, 18, 26, 16, 38, 16, 1, 44, 94, 85, 58, 60, 20, 5, 47, 52, 41, 50, 71, 43, 42, 67, 64, 38, 65, 83, 99, 78, 96, 33, 20, 98, 24, 6, 2, 25, 16, 16, 44, 63, 24, 68, 56, 49, 91, 15, 59, 99, 27, 43, 34, 28, 36, 45, 1, 10, 19, 54, 26, 75, 17, 88, 96, 63, 24, 71, 93, 72, 97, 66, 87, 18, 86];
    this.randomCache = {};
    this.rndIndex = 0;
  }
  /**
   * Returns next pseudo random integer number from sequence between 0 and max parameter value (99 is maximum value)
   * @param {Number} max max value
   * @returns {Number}
   */


  nextRandom(max) {
    let randomCache = this.randomCache,
        randomNumbers;

    if (randomCache[max]) {
      randomNumbers = randomCache[max];
    } else {
      randomNumbers = this.random100.filter(num => num < max);
      randomCache[max] = randomNumbers;
    }

    return randomNumbers[this.rndIndex++ % randomNumbers.length];
  }
  /**
   * Resets sequence to initial number
   */


  reset() {
    this.rndIndex = 0;
  }
  /**
   * Returns pseudo random array element
   * @param {Array} array input array
   * @returns {*}
   */


  fromArray(array) {
    return array[this.nextRandom(array.length)];
  }

}
RandomGenerator._$name = 'RandomGenerator';

/***/ }),

/***/ "./lib/Core/helper/util/Rectangle.js":
/*!*******************************************!*\
  !*** ./lib/Core/helper/util/Rectangle.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Rectangle; });
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';
/**
* @module Core/helper/util/Rectangle
*/





const allBorders = ['border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width'],
      allMargins = ['margin-top', 'margin-right', 'margin-bottom', 'margin-left'],
      allPaddings = ['padding-top', 'padding-right', 'padding-bottom', 'padding-left'],
      borderNames = {
  t: 'border-top-width',
  r: 'border-right-width',
  b: 'border-bottom-width',
  l: 'border-left-width'
},
      paddingNames = {
  t: 'padding-top',
  r: 'padding-right',
  b: 'padding-bottom',
  l: 'padding-left'
},
      zeroBased = Object.freeze({
  x: 0,
  y: 0
}),
      alignSpecRe = /^([trblc])(\d*)-([trblc])(\d*)$/i,
      alignPointRe = /^([trblc])(\d*)$/i,
      edgeNames = ['top', 'right', 'bottom', 'left'],
      edgeIndices = {
  t: 0,
  r: 1,
  b: 2,
  l: 3
},
      defaultAlignments = ['b-t', 'l-r', 't-b', 'r-l'],
      edgeAligments = {
  bt: 1,
  tb: 1,
  lr: 1,
  rl: 1
},
      zeroOffsets = Object.freeze([0, 0]),
      matchDimensions = ['width', 'height'],
      parseEdges = (top, right = top, bottom = top, left = right) => {
  return Array.isArray(top) ? parseEdges.apply(null, top) : [top, right, bottom, left];
}; // Parse a l0-r0 (That's how Menus align to their owning MenuItem) align spec.


function parseAlign(alignSpec) {
  const parts = alignSpecRe.exec(alignSpec),
        myOffset = parseInt(parts[2] || 50),
        targetOffset = parseInt(parts[4] || 50),
        myEdge = parts[1],
        targetEdge = parts[3],
        edgeAligned = edgeAligments[myEdge + targetEdge]; // Comments assume the Menu's alignSpec of l0-r0 is used.

  return {
    myAlignmentPoint: myEdge + myOffset,
    // l0
    myEdge,
    // l
    myOffset,
    // 0
    targetAlignmentPoint: targetEdge + targetOffset,
    // r0
    targetEdge,
    // r
    targetOffset,
    // 0
    startZone: edgeIndices[targetEdge],
    // 1 - start trying zone 1 in TRBL order
    edgeAligned // Edge-to-edge align requested

  };
} // Takes a result from the above function and flips edges for the axisLock config


function flipAlign(align) {
  return `${edgeNames[(edgeIndices[align.myEdge] + 2) % 4][0]}${align.myOffset}-${edgeNames[(edgeIndices[align.targetEdge] + 2) % 4][0]}${align.targetOffset}`;
}

function createOffsets(offset) {
  if (offset == null) {
    return zeroOffsets;
  } else if (typeof offset === 'number') {
    return [offset, offset];
  }

  return offset;
}
/**
 * Encapsulates rectangular areas for comparison, intersection etc.
 *
 * Note that the `right` and `bottom` properties are *exclusive*.
 *
 */


class Rectangle {
  // Class does not extend Base, so we need to define this
  get isRectangle() {
    return true;
  }
  /**
   * Returns the Rectangle in document based coordinates of the passed element.
   *
   * *Note:* If the element passed is the `document` or `window` the `window`'s
   * rectangle is returned which is always at `[0, 0]` and encompasses the
   * browser's entire document viewport.
   * @param {HTMLElement} element The element to calculate the Rectangle for.
   * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
   * @param {Boolean} [ignorePageScroll=false] Use browser viewport based coordinates.
   * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
   */


  static from(element, relativeTo, ignorePageScroll) {
    var _element$namespaceURI;

    if (element.isRectangle) {
      return element;
    }

    if (ignorePageScroll === undefined && typeof relativeTo === 'boolean') {
      ignorePageScroll = relativeTo;
      relativeTo = null;
    }

    if (relativeTo) {
      // TODO: nige should figure out if there is a better solution
      let {
        scrollLeft,
        scrollTop
      } = relativeTo;

      if ((_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEdge || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isSafari) && relativeTo === document.body) {
        scrollLeft = scrollTop = 0;
      }

      relativeTo = Rectangle.from(relativeTo).translate(-scrollLeft, -scrollTop);
    } else {
      relativeTo = zeroBased;
    } // Viewport is denoted by requesting window or document.
    // document.body may overflow the viewport, so this must not be evaluated as the viewport.


    const // If body is 0 height we should treat this case as a viewport
    isViewport = element === document || element === window,
          isSFViewport = element === document.body && document.body.offsetHeight === 0,
          sfElRect = isSFViewport && element.getBoundingClientRect(),
          viewRect = isSFViewport // In Salesforce body and html have 0 height so to get correct viewport vertical size we have to use
    // scrollHeight on html element.
    ? new Rectangle(sfElRect.left, sfElRect.top, sfElRect.width, document.body.parentElement.scrollHeight) : isViewport ? new Rectangle(0, 0, window.innerWidth, window.innerHeight) : element.getBoundingClientRect(),
          scrollOffset = ignorePageScroll || isViewport ? [0, 0] : [window.pageXOffset, window.pageYOffset];
    let scaleX = 0,
        scaleY = 0; // scaleX/Y is required to adjust scaled SVG element bounding rect

    if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11 || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEdge && (_element$namespaceURI = element.namespaceURI) !== null && _element$namespaceURI !== void 0 && _element$namespaceURI.match(/svg/)) {
      var _element$dataset, _element$dataset2;

      scaleX = ((_element$dataset = element.dataset) === null || _element$dataset === void 0 ? void 0 : _element$dataset.scaleX) || 0;
      scaleY = ((_element$dataset2 = element.dataset) === null || _element$dataset2 === void 0 ? void 0 : _element$dataset2.scaleY) || 0;
    }

    return new Rectangle(viewRect.left + scrollOffset[0] - relativeTo.x + scaleX / 2, viewRect.top + scrollOffset[1] - relativeTo.y + scaleY / 2, viewRect.width - scaleX, viewRect.height - scaleY);
  }
  /**
   * Returns the Rectangle in viewport coordinates of the passed element.
   *
   * *Note:* If the element passed is the `document` or `window` the `window`'s rectangle is returned which is always
   * at `[0, 0]` and encompasses the browser's entire document viewport.
   * @param {HTMLElement} element The element to calculate the Rectangle for.
   * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
   * @return {Core.helper.util.Rectangle} The Rectangle in viewport based coordinates. Relative to the _relativeTo_
   * parameter if provided.
   */


  static fromScreen(element, relativeTo) {
    return Rectangle.from(element, relativeTo,
    /* ignorePageScroll = */
    true);
  }
  /**
   * Returns the inner Rectangle (within border) in document based coordinates of the passed element.
   * @param {HTMLElement} element The element to calculate the Rectangle for.
   * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
   * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
   * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
   */


  static inner(element, relativeTo, ignorePageScroll = false) {
    const result = this.from(element, relativeTo, ignorePageScroll); // Can only ask for the following styles if element is in the document.

    if (document.body.contains(element)) {
      const borders = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, allBorders);
      result.x += parseFloat(borders[borderNames.l]);
      result.y += parseFloat(borders[borderNames.t]);
      result.right -= parseFloat(borders[borderNames.r]);
      result.bottom -= parseFloat(borders[borderNames.b]);
    }

    return result;
  }
  /**
   * Returns the content Rectangle (within border and padding) in document based coordinates of the passed element.
   * @param {HTMLElement} element The element to calculate the Rectangle for.
   * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
   * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
   * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
   */


  static content(element, relativeTo, ignorePageScroll = false) {
    const result = this.from(element, relativeTo, ignorePageScroll); // Can only ask for the following styles if element is in the document.

    if (document.body.contains(element)) {
      const borders = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, allBorders),
            padding = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, allPaddings);
      result.x += parseFloat(borders[borderNames.l]) + parseFloat(padding[paddingNames.l]);
      result.y += parseFloat(borders[borderNames.t]) + parseFloat(padding[paddingNames.t]);
      result.right -= parseFloat(borders[borderNames.r]) + parseFloat(padding[paddingNames.r]);
      result.bottom -= parseFloat(borders[borderNames.b]) + parseFloat(padding[paddingNames.b]);
    }

    return result;
  }
  /**
   * Returns the client Rectangle (within border and padding and scrollbars) in document based coordinates of the
   * passed element.
   * @param {HTMLElement} element The element to calculate the Rectangle for.
   * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
   * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
   * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
   */


  static client(element, relativeTo, ignorePageScroll = false) {
    const result = this.content(element, relativeTo, ignorePageScroll),
          scrollbarWidth = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].scrollBarWidth;
    let padding;

    if (scrollbarWidth) {
      // Capture width taken by any vertical scrollbar.
      // If there is a vertical scrollbar, shrink the box.
      // TODO: We may have to shrink from the left in RTL mode.
      if (element.scrollHeight > element.clientHeight && _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, 'overflow-y') !== 'hidden') {
        padding = parseFloat(_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, 'padding-right'));
        result.right += padding - Math.max(padding, scrollbarWidth);
      } // Capture height taken by any horizontal scrollbar.
      // If there is a horizontal scrollbar, shrink the box.


      if (element.scrollWidth > element.clientWidth && _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, 'overflow-x') !== 'hidden') {
        padding = parseFloat(_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, 'padding-bottom'));
        result.bottom += padding - Math.max(padding, scrollbarWidth);
      }
    } // The client region excluding any scrollbars.


    return result;
  }
  /**
   * Returns the outer Rectangle (including margin) in document based coordinates of the passed element.
   * @param {HTMLElement} element The element to calculate the Rectangle for.
   * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
   * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
   * @return {Core.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates.
   * Relative to the _relativeTo_ parameter if passed.
   * @internal
   */


  static outer(element, relativeTo, ignorePageScroll = false) {
    const result = this.from(element, relativeTo, ignorePageScroll); // Can only ask for the following styles if element is in the document.

    if (document.body.contains(element)) {
      const margin = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStyleValue(element, allMargins);
      result.x -= parseFloat(margin['margin-left']);
      result.y -= parseFloat(margin['margin-top']);
      result.right += parseFloat(margin['margin-right']);
      result.bottom += parseFloat(margin['margin-bottom']);
    }

    return result;
  }
  /**
   * Returns a new rectangle created as the union of all supplied rectangles.
   * @param {Core.helper.util.Rectangle[]} rectangles
   * @return {Core.helper.util.Rectangle}
   */


  static union(...rectangles) {
    let {
      x,
      y,
      right,
      bottom
    } = rectangles[0],
        current;

    if (rectangles.length > 1) {
      for (let i = 1; i < rectangles.length; i++) {
        current = rectangles[i];

        if (current.x < x) {
          x = current.x;
        }

        if (current.y < y) {
          y = current.y;
        }

        if (current.right > right) {
          right = current.right;
        }

        if (current.bottom > bottom) {
          bottom = current.bottom;
        }
      }
    }

    return new Rectangle(x, y, right - x, bottom - y);
  }
  /**
   * Rounds this Rectangle to the pixel resolution of the current display or to the nearest
   * passed unit which defaults to the current display's [`devicePixelRatio`](https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio).
   * @param {Number} [devicePixelRatio] device pixel ratio which defaults to `window.devicePixelRatio`
   */


  roundPx(devicePixelRatio = window.devicePixelRatio || 1) {
    const me = this;
    me._x = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].roundPx(me._x, devicePixelRatio);
    me._y = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].roundPx(me._y, devicePixelRatio);
    me._width = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].roundPx(me._width, devicePixelRatio);
    me._height = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].roundPx(me._height, devicePixelRatio);
    return me;
  } // This class doesn't extend Base and extending doesn't seem to be
  // the way to go. Instead we duplicate smallest piece of logic here


  static get $$name() {
    return hasOwnProperty.call(this, '$name') && this.$name || // _$name is filled by webpack for every class (cls._$name = '...')
    hasOwnProperty.call(this, '_$name') && this._$name || this.name;
  }

  get $$name() {
    return this.constructor.$$name;
  }
  /**
   * Constructs a Rectangle
   * @param {Number} x The X coordinate
   * @param {Number} y The Y coordinate
   * @param {Number} width The width
   * @param {Number} height The height
   */


  constructor(x, y, width, height) {
    _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertNumber(x, 'Rectangle.x');
    _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertNumber(y, 'Rectangle.y');
    _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertNumber(width, 'Rectangle.width');
    _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertNumber(height, 'Rectangle.height');
    const me = this;
    me._x = x;
    me._y = y;
    me._width = width;
    me._height = height;
  }
  /**
   * Creates a copy of this Rectangle.
   */


  clone() {
    const me = this,
          result = new Rectangle(me.x, me.y, me.width, me.height);
    result.isAlignRectangle = me.isAlignRectangle;
    result.minHeight = me.minHeight;
    result.minWidth = me.minWidth;
    return result;
  }
  /**
   * Returns `true` if this Rectangle wholly contains the passed rectangle.
   *
   * Note that a {@link Core.helper.util.Point} may be passed.
   * @param {Core.helper.util.Rectangle} other The Rectangle to test for containment within this Rectangle
   * @return {Boolean} `true` if the other Rectangle is wholly contained within this Rectangle
   */


  contains(other) {
    const me = this;

    if (other.isRectangle) {
      return other._x >= me._x && other._y >= me._y && other.right <= me.right && other.bottom <= me.bottom;
    } else {
      return false;
    }
  }
  /**
   * Checks if this Rectangle intersects the passed Rectangle
   * @param {Core.helper.util.Rectangle} other The Rectangle to intersect with this.
   * @param {Boolean} [useBoolean] Specify `true` to return a boolean value instead of constructing a new Rectangle
   * @param {Boolean} [allowZeroDimensions] `true` to consider zero-width or zero-hight rectangles as intersecting if coordinates indicate the intersection
   * @return {Core.helper.util.Rectangle|Boolean} Returns the intersection Rectangle or `false` if there is no intersection.
   */


  intersect(other, useBoolean = false, allowZeroDimensions = false) {
    const me = this,
          y = Math.max(me.y, other.y),
          r = Math.min(me.right, other.right),
          b = Math.min(me.bottom, other.bottom),
          x = Math.max(me.x, other.x),
          intersect = allowZeroDimensions ? b >= y && r >= x : b > y && r > x;

    if (intersect) {
      return useBoolean ? true : new Rectangle(x, y, r - x, b - y);
    } else {
      return false;
    }
  }

  equals(other, round = false) {
    const processor = round ? x => Math.round(x) : x => x;
    return other.isRectangle && processor(other.x) === processor(this.x) && processor(other.y) === processor(this.y) && processor(other.width) === processor(this.width) && processor(other.height) === processor(this.height);
  }
  /**
   * Translates this Rectangle by the passed vector. Size is maintained.
   * @param {Number} x The X translation vector.
   * @param {Number} y The Y translation vector.
   * @returns This Rectangle;
   */


  translate(x, y) {
    this._x += x || 0;
    this._y += y || 0;
    return this;
  }
  /**
   * Moves this Rectangle to the passed `x`, `y` position. Size is maintained.
   * @param {Number} x The new X position.
   * @param {Number} y The new Y position.
   * @returns This Rectangle;
   */


  moveTo(x, y) {
    if (x != null) {
      this._x = x;
    }

    if (y != null) {
      this._y = y;
    }

    return this;
  }
  /**
   * Returns the vector which would translate this Rectangle (or Point) to the same position as the other Rectangle (or point)
   * @param {Core.helper.util.Rectangle|Core.helper.util.Point} other The Rectangle or Point to calculate the delta to.
   * @returns {Array} Returns a vector using format `[deltaX, deltaY]`
   * @internal
   */


  getDelta(other) {
    return [other.x - this.x, other.y - this.y];
  }
  /**
   * The center point of this rectangle.
   * @property {Core.helper.util.Point}
   */


  get center() {
    return new Rectangle.Point(this.x + this.width / 2, this.y + this.height / 2);
  }
  /**
   * Get/sets the X coordinate of the Rectangle. Note that this does *not* translate the
   * Rectangle. The requested {@link #property-width} will change.
   * @property {Number}
   */


  set x(x) {
    const xDelta = x - this._x;
    this._x = x;
    this._width -= xDelta;
  }

  get x() {
    return this._x;
  }
  /**
   * Alias for x. To match DOMRect.
   * @property {Number}
   */


  set left(x) {
    this.x = x;
  }

  get left() {
    return this.x;
  }
  /**
   * Alias for y. To match DOMRect.
   * @property {Number}
   */


  set top(y) {
    this.y = y;
  }

  get top() {
    return this.y;
  }
  /**
   * Get/sets the Y coordinate of the Rectangle. Note that this does *not* translate the
   * Rectangle. The requested {@link #property-height} will change.
   * @property {Number}
   */


  set y(y) {
    const yDelta = y - this._y;
    this._y = y;
    this._height -= yDelta;
  }

  get y() {
    return this._y;
  }
  /**
   * Get/sets the width of the Rectangle. Note that the requested {@link #property-right} will change.
   * @property {Number}
   */


  set width(width) {
    this._width = width;
  }

  get width() {
    return this._width;
  }
  /**
   * Get/sets the height of the Rectangle. Note that the requested {@link #property-bottom} will change.
   * @property {Number}
   */


  set height(height) {
    this._height = height;
  }

  get height() {
    return this._height;
  }
  /**
   * Get/sets the right edge of the Rectangle. Note that the requested {@link #property-width} will change.
   *
   * The right edge value is exclusive of the calculated rectangle width. So x=0 and right=10
   * means a width of 10.
   * @property {Number}
   */


  set right(right) {
    this._width = right - this._x;
  }

  get right() {
    return this._x + this._width;
  }
  /**
   * Get/sets the bottom edge of the Rectangle. Note that the requested {@link #property-height} will change.
   *
   * The bottom edge value is exclusive of the calculated rectangle height. So y=0 and bottom=10
   * means a height of 10.
   * @property {Number}
   */


  set bottom(bottom) {
    this._height = bottom - this._y;
  }

  get bottom() {
    return this._y + this._height;
  }

  get area() {
    return this.width * this.height;
  }

  set minWidth(minWidth) {
    const me = this;

    if (isNaN(minWidth)) {
      me._minWidth = null;
    } else {
      me._minWidth = Number(minWidth); // If this is being used as an alignment calculation rectangle, minWidth has a different meaning.
      // It does not mean that the width has to be at least this value. It means that under constraint,
      // it is willing to shrink down to that value before falling back to another align position.

      if (!me.isAlignRectangle) {
        me.width = Math.max(me.width, me._minWidth);
      }
    }
  }

  get minWidth() {
    return this._minWidth;
  }

  set minHeight(minHeight) {
    const me = this;

    if (isNaN(minHeight)) {
      me._minHeight = null;
    } else {
      me._minHeight = Number(minHeight); // If this is being used as an alignment calculation rectangle, minHeight has a different meaning.
      // It does not mean that the height has to be at least this value. It means that under constraint,
      // it is willing to shrink down to that value before falling back to another align position.

      if (!me.isAlignRectangle) {
        me.height = Math.max(me.height, me._minHeight);
      }
    }
  }

  get minHeight() {
    return this._minHeight;
  }
  /**
   * Modifies the bounds of this Rectangle by the specified deltas.
   * @param {Number} x How much to *add* to the x position.
   * @param {Number} y  How much to *add* to the y position.
   * @param {Number} width  How much to add to the width.
   * @param {Number} height  How much to add to the height.
   * @returns This Rectangle
   */


  adjust(x, y, width, height) {
    const me = this;
    me.x += x;
    me.y += y;
    me.width += width;
    me.height += height;
    return me;
  }
  /**
   * Modifies the bounds of this rectangle by expanding them by the specified amount in all directions.
   * The parameters are read the same way as CSS margin values.
   *
   * - If one value is passed, all edges are inflated by that value.
   * - If two values are passed they are top/bottom inflation and left/right inflation.
   * - If four values are passed, that's top, right, bottom, left.
   * @param {Number} amount How much to inflate, or the top value if more than one values passed.
   * @param {Number} right How much to inflate the right side, or both left and right is only two values passed.
   * @param {Number} bottom How much to inflate the bottom side.
   * @param {Number} left How much to inflate the left side.
   * @returns {Core.helper.util.Rectangle} This Rectangle
   * @internal
   */


  inflate(top, right = top, bottom = top, left = right) {
    if (Array.isArray(top)) {
      [top, right, bottom, left] = parseEdges(top);
    }

    return this.adjust(-left, -top, right, bottom);
  }
  /**
   * Modifies the bounds of this rectangle by reducing them by the specified amount in all directions.
   * The parameters are read the same way as CSS margin values.
   *
   * - If one value is passed, all edges are deflated by that value.
   * - If two values are passed they are top/bottom deflation and left/right deflation.
   * - If four values are passed, that's top, right, bottom, left.
   * @param {Number} amount How much to deflate, or the top value if more than one values passed.
   * @param {Number} right How much to deflate the right side, or both left and right is only two values passed.
   * @param {Number} bottom How much to deflate the bottom side.
   * @param {Number} left How much to deflate the left side.
   * @returns {Core.helper.util.Rectangle} This Rectangle
   * @internal
   */


  deflate(top, right = top, bottom = top, left = right) {
    if (Array.isArray(top)) {
      [top, right, bottom, left] = parseEdges(top);
    }

    return this.adjust(left, top, -right, -bottom);
  }
  /**
   * Attempts constrain this Rectangle into the passed Rectangle. If the `strict` parameter is `true`
   * then this method will return `false` if constraint could not be achieved.
   *
   * If this Rectangle has a `minHeight` or `minWidth` property, size will be adjusted while attempting to constrain.
   *
   * Right and bottom are adjusted first leaving the top and bottom sides to "win" in the case that this Rectangle overflows
   * the constrainTo Rectangle.
   * @param {Core.helper.util.Rectangle} constrainTo The Rectangle to constrain this Rectangle into if possible.
   * @param {Boolean} strict Pass `true` to return false, and leave this Rectangle unchanged if constraint
   * could not be achieved.
   * @returns This Rectangle. If `strict` is true, and constraining was not successful, `false`.
   */


  constrainTo(constrainTo, strict) {
    const me = this,
          originalHeight = me.height,
          originalY = me.y,
          minWidth = me.minWidth || me.width,
          minHeight = me.minHeight || me.height;

    if (me.height >= constrainTo.height) {
      // If we're strict, fail if we could *never* fit into available height.
      if (strict && minHeight > constrainTo.height) {
        return false;
      } // If we are >= constrain height, we will have to be at top edge of constrainTo


      me._y = constrainTo.y;
      me.height = constrainTo.height;
    }

    if (me.width >= constrainTo.width) {
      // If we're strict, fail if we could *never* fit into available width.
      if (strict && minWidth > constrainTo.width) {
        // Could not be constrained; undo any previous attempt with height
        me.y = originalY;
        me.height = originalHeight;
        return false;
      } // If we are >= constrain width, we will have to be at left edge of constrainTo


      me._x = constrainTo.x;
      me.width = constrainTo.width;
    }

    let overflow = me.bottom - constrainTo.bottom; // Overflowing the bottom side, translate upwards.

    if (overflow > 0) {
      me.translate(0, -overflow);
    }

    overflow = me.right - constrainTo.right; // Overflowing the right side, translate leftwards.

    if (overflow > 0) {
      me.translate(-overflow);
    }

    overflow = constrainTo.y - me.y; // Now, after possible translation upwards, we overflow the top, translate downwards.

    if (overflow > 0) {
      me.translate(0, overflow);
    }

    overflow = constrainTo.x - me.x; // Now, after possible translation leftwards, we overflow the left, translate rightwards.

    if (overflow > 0) {
      me.translate(overflow);
    }

    return me;
  }
  /**
   * Returns a cloned version of this Rectangle aligned to a target Rectangle, or element or {@link Core.widget.Widget}.
   * @param {Object} spec Alignment specification.
   * @param {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle} spec.target The Widget or element or Rectangle to align to.
   * @param {Number[]} [spec.anchorSize] The `[width, height]` of the anchor pointer when in `top` position. The
   * width is the baseline length, and the height is the height of the arrow. If passed, the anchor position
   * will be calculated to be at the centre of the overlap of the two aligned edges and returned in the `anchor`
   * property of the resulting Rectangle:
   *
   *     {
   *         edge: 'top',         // or 'right' or 'bottom' or 'left'
   *         x/y: offset          // dimension to translate and value to translate by.
   *     }
   *
   * @param {Object} [spec.anchorPosition] an `{ x: n, y: n }` anchor translation to be used *if the requested alignment
   * succeeds without violating constraints*. If a fallback alignment is used, the anchor will be centered in the
   * overlap of the aligned edges as usual.
   * @param {Boolean} [spec.overlap] True to allow this to overlap the target.
   * @param {String} spec.align The edge alignment specification string, specifying two points to bring together.
   * The form is `[trblc][n]-[trblc][n]. The `n` is a percentage offset
   * along that edge which defines the alignment point. This is not valid for alignment point `c`.
   * For example `t0-b0' would align this Rectangle's top left corner with the bottom left corner of the `target`.
   * @param {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle} [spec.constrainTo] The Widget or Element or Rectangle to constrain to.
   * If the requested alignment cannot be constrained (it will first shrink the resulting Rectangle according
   * to the `minWidth` and `minHeight` properties of this rectangle), then it will try aligning at other edges
   * (honouring the `axisLock` option), and pick the fallback alignment which results in the shortest translation.
   * @param {Boolean} [spec.axisLock] Specify as a truthy value to fall back to aligning against the opposite
   * edge first if the requested alignment cannot be constrained into the `constrainTo` option. If specified
   * as `'flexible'`, then fallback will continue searching for solutions on the remaining two sides.
   * @param {Boolean} [spec.matchSize] When aligning edge-to-edge, match the length of the aligned-to
   * edge of the target. This is only honored when `axisLock` is enabled and alignment succeeds on the requested axis.
   * If __not__ aligning edge-to-edge, `matchSize` matches both dimensions of the target.
   * @param {Number|Number[]} [spec.offset] The 'x' and 'y' offset values to create an extra margin round the target
   * to offset the aligned widget further from the target. May be configured as -ve to move the aligned widget
   * towards the target - for example producing the effect of the anchor pointer piercing the target.
   * @param {Number|Number[]} [spec.constrainPadding] The amount of pixels to pad from the `constrainTo` target,
   * either a single value, or an array of values in CSS edge order.
   * @returns {Core.helper.util.Rectangle} A new Rectangle aligned as requested if possible, but if the requested position violates
   * the `constrainTo` Rectangle, the shortest translation from the requested position which obeys constraints will be used.
   */


  alignTo(spec) {
    // The target and constrainTo may be passed as HtmlElements or Widgets.
    // If so, extract the Rectangles without mutating the incoming spec.
    let result = this.clone(),
        {
      target,
      constrainTo,
      constrainPadding,
      matchSize
    } = spec,
        calculatedAnchorPosition,
        zone,
        resultZone,
        constrainingToViewport;

    if (target && !target.isRectangle) {
      target = Rectangle.from(target.element ? target.element : target);
    }

    if (constrainTo) {
      if (!constrainTo.isRectangle) {
        // Viewport is denoted by requesting window or document.
        // document.body may overflow the viewport, so this must not be evaluated as the viewport.
        constrainingToViewport = constrainTo === window || constrainTo === document; // When rectangle is constrained to some element on the page other than window/document, page scroll
        // should not be taken into account

        const ignorePageScroll = 'ignorePageScroll' in spec ? spec.ignorePageScroll : !constrainingToViewport;
        constrainTo = Rectangle.from(constrainTo.element ? constrainTo.element : constrainTo, null, ignorePageScroll);
      } // Shrink the constrainTo Rectangle to account for the constrainPadding


      if (constrainPadding) {
        // An array may be used to specify sides in the CSS standard order.
        // One value means all sides reduce by the same amount.
        constrainPadding = parseEdges(constrainPadding); // If we are aligning to an element which is closer to an edge than the
        // constrainPadding value for that edge, override the constrainPadding so that
        // the visual alignment is maintained.

        constrainPadding[0] = Math.min(constrainPadding[0], target.top);
        constrainPadding[1] = Math.min(constrainPadding[1], constrainTo.right - target.right);
        constrainPadding[2] = Math.min(constrainPadding[0], constrainTo.bottom - target.bottom);
        constrainPadding[3] = Math.min(constrainPadding[0], target.left); // Must clone a passed Rectangle so as not to mutate objects passed in.

        constrainTo = constrainTo.deflate.apply(constrainTo.clone(), constrainPadding);
      }
    }

    const me = this,
          targetOffsets = createOffsets(spec.offset),
          {
      align,
      axisLock,
      anchorSize,
      anchorPosition
    } = spec,
          alignSpec = parseAlign(align),
          position = spec.position || (target && target.$$name === 'Point' ? target : null),
          targetConstrainRect = constrainTo && constrainTo.clone(),
          constraintZones = [],
          zoneOrder = [{
      zone: zone = alignSpec.startZone,
      align
    }],
          matchDimension = matchSize && matchDimensions[alignSpec.startZone & 1],
          originalSize = me[matchDimension]; // Match the size of the edge we are aligning against

    if (matchDimension && axisLock) {
      result[matchDimension] = target[matchDimension];
    } // If we are not aligning to an edge, match both diensions.
    else if (!alignSpec.edgeAligned && matchSize) {
      result.width = target.width;
      result.height = target.height;
    } // Ensure we will fit before trying


    if (constrainTo) {
      result.constrainTo(constrainTo);
    } // If we are aligning edge-to-edge, then plan our fallback strategy when we are constrained.


    if (constrainTo && alignSpec.startZone != null) {
      // Create the list of zone numbers and alignments to try in the preferred order.
      //
      // In the case of axisLock, go through the zones by each axis.
      // So if they asked for t-b, which is zone 2,
      // the array will be [2, 0, 3, 1] (t-b, b-t, r-l, l-r)
      if (axisLock) {
        // First axis flip has to maintain the offset along that axis.
        // so align: l0-r0 has to flip to align: r0-l0. See submenu flipping when
        // constrained to the edge. It flips sides but maintains vertical position.
        zoneOrder.push({
          zone: zone = (zone + 2) % 4,
          align: flipAlign(alignSpec)
        }); // Only try the other axis is axisLock is 'flexible'

        if (axisLock === 'flexible') {
          zoneOrder.push({
            zone: zone = (alignSpec.startZone + 1) % 4,
            align: defaultAlignments[zone]
          });
          zoneOrder.push({
            zone: zone = (zone + 2) % 4,
            align: defaultAlignments[zone]
          });
        }
      } // Go through the zones in order from the requested start.
      // So if they asked for t-b, which is zone 2,
      // the array will be [2, 3, 0, 1] (t-b, r-l, b-t, l-r)
      else {
        for (let i = 1; i < 4; i++) {
          zoneOrder.push({
            zone: zone = (zone + 1) % 4,
            align: defaultAlignments[zone]
          });
        }
      }
    } // Allow them to pass anchorPosition: {x: 10} to indicate that after a fully successful,
    // unconstrained align, the anchor should be 10px from the start.


    if (anchorPosition) {
      const pos = alignSpec.startZone & 1 ? 'y' : 'x';
      calculatedAnchorPosition = {
        [pos]: anchorPosition[pos],
        edge: edgeNames[(alignSpec.startZone + 2) % 4]
      };
    } // Keep the target within reach. If it's way outside, pull it back so that it's only just outside);


    if (targetConstrainRect && target) {
      targetConstrainRect.adjust(-target.width, -target.height, target.width, target.height);
      target.constrainTo(targetConstrainRect);
    } // As part of fallback process when fitting within constraints, result may shrink to our minima


    result.minWidth = me.minWidth;
    result.minHeight = me.minHeight; // We're being commanded to try to align at a position

    if (position) {
      result.moveTo(position.x, position.y);

      if (constrainTo) {
        result.constrainTo(constrainTo);
      }
    } // We're aligning to a Target Rectangle within a ConstrainTo Rectangle, taking into account
    // a possible anchor pointer, or x/y offsets. Here's the situation:
    //
    //                             <-- ConstrainTo Rectangle -->
    //  +-----------------------------------+--------------------+-------------------------+
    //  |                                   |                    |                         |
    //  |                                   |                    |                         |
    //  |                                   |                    |                         |
    //  |-----------------------------------+--------------------+-------------------------+
    //  |                                   |          ▼         |                         |
    //  |                                   | +----------------+ |                         |
    //  |                                   | |                | |                         |
    //  |                                   | |                | |                         |
    //  |                                   |▶|     Target     |◀|                         |
    //  |                                   | |                | |                         |
    //  |                                   | |                | |                         |
    //  |                                   | +----------------+ |                         |
    //  |                                   |          ▲         |                         |
    //  +-----------------------------------+--------------------+-------------------------|
    //  |                                   |                    |                         |
    //  |                                   |                    |                         |
    //  |                                   |                    |                         |
    //  +-----------------------------------+--------------------+-------------------------+
    //
    // Which results in the four possible constraint zones above, which we index in standard CSS order.
    //
    // Top    = 0
    // Right  = 1
    // Bottom = 2
    // Left   = 3
    //
    // If the initially requested alignment is not within the constrainTo rectangle
    // then, calculate these four, and then loop through them, beginning at the requested one,
    // quitting when we find a position which does not violate constraints. This includes
    // shrinking the aligning Rectangle towards its minima to attempt a fit.
    //
    // The final fallback, if there is no position which does not violate constraints
    // is to position in whichever of the four rectangles has the largest area shrinking overflowing
    // dimensions down to minima if specified.
    //
    else {
      // Offsets: If we are using an anchor to move away from the target, use anchor height in both dimensions.
      // It's rotated so that "height" always has the same meaning. It's the height of the arrow.
      const centerAligned = alignSpec.myEdge === 'c' || alignSpec.targetEdge === 'c',
            offsets = anchorSize && !centerAligned ? [anchorSize[1] + targetOffsets[0], anchorSize[1] + targetOffsets[1]] : targetOffsets,
            targetPoint = target.getAlignmentPoint(alignSpec.targetAlignmentPoint, offsets),
            myPoint = result.getAlignmentPoint(alignSpec.myAlignmentPoint);
      result.translate(targetPoint[0] - myPoint[0], targetPoint[1] - myPoint[1]); // If an overlapping position was requested, then we are *not* trying out those four zones.
      // We just respect constraint, and that's it.

      let overlap = result.intersect(target, true); // If we are aligned over our target, we just obey that within any constraint.
      // No complex edge alignment attempts to fall back to.

      if (overlap) {
        if (constrainTo) {
          result.constrainTo(constrainTo);
        }

        resultZone = alignSpec.startZone;
        result.translate(...offsets);
      } // Aligned to outside of our target, and we need to be constrained
      else if (constrainTo && !constrainTo.contains(result)) {
        let requestedResult = result.clone(),
            solutions = [],
            zone,
            largestZone; // Any configured anchorPosition becomes invalid now that we're having to move the resulting zone
        // to some unpredictable new place where it fits. It will have to be calculated based upon where
        // we end up aligning.

        calculatedAnchorPosition = null; // Calculate the four constraint zones illustrated above.
        // Top

        constraintZones[0] = zone = constrainTo.clone();
        zone.bottom = target.y - offsets[1]; // Right

        constraintZones[1] = zone = constrainTo.clone();
        zone.x = target.right + offsets[0]; // Bottom

        constraintZones[2] = zone = constrainTo.clone();
        zone.y = target.bottom + offsets[1]; // Left

        constraintZones[3] = zone = constrainTo.clone();
        zone.right = target.x - offsets[0]; // Start from the preferred edge and see if we are able to constrain to within each rectangle

        for (let i = 0; i < zoneOrder.length; i++) {
          // Revert to incoming dimension for fallback out of axisLock
          if (matchDimension && i == 2) {
            result[matchDimension] = originalSize;
          }

          zone = constraintZones[resultZone = zoneOrder[i].zone]; // Perform unconstrained alignment at the calculated alignment for the zone

          result = result.alignTo({
            target: target,
            offsets: offsets,
            align: zoneOrder[i].align
          }); // If we are able to strictly constrain into this area, then it's one of the possible solutions.
          // We choose the solution which result in the shortest translation from the initial position.

          if (result.constrainTo(zone, true)) {
            solutions.push({
              result: result,
              zone: resultZone
            }); // If this successful constraint is at the requested alignment, or at a fallback
            // alignment which has used min size constraints, then that's the correct solution.
            // If there's no size compromising, we have to pick the shortest translation.

            if (!largestZone || result.width < me.width || result.height < me.height) {
              result.align = zoneOrder[i].align;
              break;
            }
          } // Cache the largest zone we find in case we need the final fallback.


          if (!largestZone || zone.area > largestZone.area) {
            const r = result.clone(); // And just move the result clone into the edge zone

            switch (resultZone) {
              // Top
              case 0:
                r.moveTo(null, zone.bottom - r.height);
                break;
              // Right

              case 1:
                r.moveTo(zone.left);
                break;
              // Bottom

              case 2:
                r.moveTo(null, zone.top);
                break;
              // Left

              case 3:
                r.moveTo(zone.right - r.width);
                break;
            }

            largestZone = {
              area: zone.area,
              result: r,
              zone: resultZone
            };
          }
        } // The loop found at least one solution


        if (solutions.length) {
          // Multiple fallbacks with no axisLock.
          // Use the solution which resulted in the shortest translation distance from the requested alignment.
          if (solutions.length > 1 && !axisLock) {
            solutions.sort((s1, s2) => {
              const s1TranslationDistance = Math.sqrt((requestedResult.x - s1.result.x) ** 2 + (requestedResult.y - s1.result.y) ** 2),
                    s2TranslationDistance = Math.sqrt((requestedResult.x - s2.result.x) ** 2 + (requestedResult.y - s2.result.y) ** 2);
              return s1TranslationDistance - s2TranslationDistance;
            });
          } // Initial success, or axisLock. Use first successful solution.


          result = solutions[0].result;
          resultZone = solutions[0].zone;
        } // No solutions found - use the largest rectangle.
        else {
          result = largestZone.result;
          resultZone = largestZone.zone; // When we are constraining to the viewport, we must still must be constrained,
          // even after we've given up making it align *and* constrain.

          if (constrainingToViewport) {
            result.constrainTo(constrainTo);
          }
        }
      } else {
        resultZone = alignSpec.startZone;
      }

      result.zone = resultZone;
      result.overlap = overlap = result.intersect(target, true); // If they included an anchor, calculate its position along its edge.
      // TODO: Handle the edge overlap being less than anchor width.

      if (anchorSize && !overlap) {
        // If we were passed an anchorPosition, and it has remained valid (meaning the requested
        // alignment succeeded with no constraint), then anchorPosition will be set. If not,
        // we have to calculate it based upon the aligned edge.
        if (!calculatedAnchorPosition) {
          let isLeftOrRight = resultZone & 1,
              start = isLeftOrRight ? 'y' : 'x',
              end = isLeftOrRight ? 'bottom' : 'right',
              startValue = Math.max(target[start], result[start]),
              endValue = Math.min(target[end], result[end]),
              anchorStart = startValue + (endValue - startValue) / 2 - anchorSize[0] / 2,
              anchorEnd = anchorStart + anchorSize[0];

          if (anchorEnd > result[end]) {
            anchorStart -= anchorEnd - result[end];
          }

          if (anchorStart < result[start]) {
            anchorStart += result[start] - anchorStart;
          } // Return an anchor property which will have an x or y property and an edge name onto which the
          // arrow should be aligned.


          calculatedAnchorPosition = {
            [start]: anchorStart - result[start],
            edge: edgeNames[(resultZone + 2) % 4]
          };
        }

        result.anchor = calculatedAnchorPosition;
      }
    }

    return result;
  }
  /**
   * Returns the `[x, y]` position of the specified anchor point of this Rectangle in <edge><offset> format.
   * for example passing "t50" will return the centre point of the top edge, passing "r0" will return the start
   * position of the right edge (the top right corner).
   *
   * Note that the offset defaults to 50, so "t" means the centre of the top edge.
   * @param {String} alignmentPoint The alignment point to calculate. Must match the RegExp `[trbl]\d*`
   * @param {Number[]} margins The `[x, y]` margins to add from the left/right, top/bottom edge.
   * @internal
   */


  getAlignmentPoint(alignmentPoint, margins = zeroOffsets) {
    const me = this,
          parts = alignPointRe.exec(alignmentPoint),
          edge = parts[1].toLowerCase(),
          edgeOffset = Math.min(Math.max(parseInt(parts[2] || 50), 0), 100) / 100;

    switch (edge) {
      case 't':
        return [me.x + me.width * edgeOffset, me.y - margins[1]];

      case 'r':
        return [me.right + margins[0], me.y + me.height * edgeOffset];

      case 'b':
        return [me.x + me.width * edgeOffset, me.bottom + margins[1]];

      case 'l':
        return [me.x - margins[0], me.y + me.height * edgeOffset];

      case 'c':
        {
          return [me.x + me.width / 2, me.y + me.height / 2];
        }
    }
  }
  /**
   * Highlights this Rectangle using the highlighting effect of {@link Core.helper.DomHelper}
   * on a transient element which encapsulates the region's area.
   */


  highlight() {
    const me = this,
          highlightElement = _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
      parent: document.body,
      style: `position:absolute;z-index:9999999;pointer-events:none;
                            left:${me.x}px;top:${me.y}px;width:${me.width}px;height:${me.height}px`
    });
    return _DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].highlight(highlightElement).then(() => highlightElement.remove());
  }

  toString(delimiter = ',') {
    return [`${this.top}px`, `${this.right}px`, `${this.bottom}px`, `${this.left}px`].join(delimiter);
  }

}
Rectangle._$name = 'Rectangle';

/***/ }),

/***/ "./lib/Core/helper/util/Scroller.js":
/*!******************************************!*\
  !*** ./lib/Core/helper/util/Scroller.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Scroller; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _IdHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../IdHelper.js */ "./lib/Core/helper/IdHelper.js");
/* harmony import */ var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _EventHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../ResizeMonitor.js */ "./lib/Core/helper/ResizeMonitor.js");
/* harmony import */ var _Point_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony import */ var _DomClassList_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
var productName = 'taskboard';












/**
 * @module Core/helper/util/Scroller
 */

const scrollLiterals = {
  true: 'auto',
  false: 'hidden',
  'hidden-scroll': 'auto',
  clip: _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].supportsOverflowClip ? 'clip' : 'hidden'
},
      scrollerCls = 'b-widget-scroller',
      defaultScrollOptions = {
  block: 'nearest'
},
      immediatePromise = Promise.resolve(),
      scrollPromise = element => new Promise(resolve => _EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].on({
  element,
  scroll: resolve,
  once: true
})),
      xAxis = {
  x: 1
},
      isScrollable = {
  auto: 1,
  scroll: 1
},
      allScroll = {
  overflowX: 'auto',
  overflowY: 'auto'
};
/**
 * Encapsulates scroll functionality for a Widget. All requests for scrolling and scrolling information
 * must go through a Widget's {@link Core.widget.Widget#config-scrollable} property.
 * @mixes Core/mixin/Events
 * @mixes Core/mixin/Delayable
 * @extends Core/Base
 */


class Scroller extends Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__["default"])(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_3__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
  static get configurable() {
    return {
      /**
       * The widget which is to scroll.
       * @config {HTMLElement}
       */
      widget: null,

      /**
       * The element which is to scroll. Defaults to the
       * {@link Core.widget.Widget#property-overflowElement} of the configured
       * {@link #config-widget}
       * @config {HTMLElement}
       */
      element: {
        $config: {
          nullify: true
        },
        value: null
      },

      /**
       * How to handle overflowing in the `X` axis.
       * May be:
       * * `'auto'`
       * * `'visible'`
       * * `'hidden'`
       * * `'scroll'`
       * * `'hidden-scroll'` Meaning scrollable from the UI but with no scrollbar,
       * for example a grid header. Only on platforms which support this feature.
       * * `true` - meaning `'auto'`
       * * `false` - meaning `'hidden'`
       * * `clip` - Uses `clip` where supported. Where not supported it uses
       * `hidden` and rolls back any detected scrolls in this dimension.
       * @config {String|Boolean}
       */
      overflowX: null,

      /**
       * How to handle overflowing in the `Y` axis.
       * May be:
       * * `'auto'`
       * * `'visible'`
       * * `'hidden'`
       * * `'scroll'`
       * * `'hidden-scroll'` Meaning scrollable from the UI but with no scrollbar.
       * Only on platforms which support this feature.
       * * `true` - meaning `'auto'`
       * * `false` - meaning `'hidden'`
       * * `clip` - Uses `clip` where supported. Where not supported it uses
       * `hidden` and rolls back any detected scrolls in this dimension.
       * @config {String|Boolean}
       */
      overflowY: null,

      /**
       * If configured as `true`, the {@link #config-element} is not scrolled
       * but is translated using CSS transform when controlled by this class's API.
       * Scroll events are fired when the element is translated.
       * @default
       * @config {Boolean}
       */
      translate: null,
      x: 0,
      y: 0
    };
  }

  static get delayable() {
    return {
      onScrollEnd: {
        type: 'buffer',
        delay: 100
      }
    };
  }
  /**
   * Fired when scrolling happens on this Scroller's element. The event object is a native `scroll` event
   * with the described extra properties injected.
   * @event scroll
   * @param {Core.widget.Widget} widget The owning Widget which has been scrolled.
   * @param {Core.helper.util.Scroller} source This Scroller
   */

  /**
   * Fired when scrolling finished on this Scroller's element. The event object is the last native `scroll` event
   * fires by the element with the described extra properties injected.
   * @event scrollend
   * @param {Core.widget.Widget} widget The owning Widget which has been scrolled.
   * @param {Core.helper.util.Scroller} source This Scroller
   */

  /**
   * The `overflow-x` setting for the widget. `true` means `'auto'`.
   * @member {Boolean|String} overflowX
   */

  /**
   * The `overflow-y` setting for the widget. `true` means `'auto'`.
   * @member {Boolean|String} overflowY
   */


  syncOverflowState() {
    const {
      element
    } = this,
          classList = new _DomClassList_js__WEBPACK_IMPORTED_MODULE_11__["default"](element.classList),
          x = this.hasOverflowX = element.scrollWidth > element.clientWidth,
          y = this.hasOverflowY = element.scrollHeight > element.clientHeight;
    classList.value = element.classList; // We use classes to indicate presence of overflow. This carries no rules by default.
    // Widget SASS may or may not attach rules or use these to select elements.

    const changed = classList.toggle('b-horizontal-overflow', x) || classList.toggle('b-vertical-overflow', y);

    if (changed) {
      _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].syncClassList(element, classList);

      if (!this.isConfiguring) {
        /**
         * Fired when either the X or the Y axis changes from not showing a space-consuming scrollbar
         * to showing a space-consuming scrollbar or vice-versa.
         *
         * *_Does not fire on platforms which show overlayed scrollbars_*
         * @event overflowChange
         * @param {Boolean} x `true` if the X axis overflow, `false` otherwise.
         * @param {Boolean} y `true` if the Y axis overflow, `false` otherwise.
         * @internal
         */
        this.trigger('overflowChange', {
          x,
          y
        });
      }
    }
  }
  /**
   * Returns `true` if there is overflow in the specified axis.
   * @param {String} [axis='y'] The axis to check scrollbar for. Note that this is subtly different to asking
   * whether an axis is showing a space-consuming scrollbar, see {@link #function-hasScrollbar}.
   * @internal
   */


  hasOverflow(axis = 'y') {
    // If there are no space-consuming scrollbars, we will not be recording overflow
    // state on change of scrollbars (There will be no resize event when overflow state changes).
    // Also, work around Firefox ResizeObserver bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1733042
    // We don't get to update our scroll status when content size causes scrollbar change
    // so FF has to measure each time we're asked about overflow.
    if (!_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].scrollBarWidth || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isFirefox) {
      const dimension = axis === 'y' ? 'Height' : 'Width';
      return this[`scroll${dimension}`] > this[`client${dimension}`];
    } else {
      return this[`hasOverflow${axis.toUpperCase()}`];
    }
  }
  /**
   * Returns `true` if there is a *space-consuming* scrollbar controlling scroll in the specified axis.
   * @param {String} [axis='y'] The axis to check scrollbar for. Note that this is subtly different to asking
   * whether an axis *has any* overflow, see {@link #function-hasOverflow}.
   * @internal
   */


  hasScrollbar(axis = 'y') {
    const {
      element
    } = this;

    if (element && _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].scrollBarWidth) {
      const vertical = axis === 'y',
            dimension = vertical ? 'Width' : 'Height',
            clientSize = element[`client${dimension}`],
            borderSize = parseInt(_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, `border${vertical ? 'Left' : 'Top'}Width`)) + parseInt(_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, `border${vertical ? 'Right' : 'Bottom'}Width`)),
            difference = element[`offset${dimension}`] - borderSize - clientSize; // If the difference between the content width and the client width is
      // scrollBarWidth, then we have a scrollbar

      return Math.abs(difference - _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].scrollBarWidth) < 2;
    }
  }
  /**
   * Partners this Scroller with the passed scroller in order to sync the scrolling position in the passed axes
   * @param {Core.helper.util.Scroller} otherScroller
   * @param {String|Object} [axes='x'] `'x'` or `'y'` or `{x: true/false, y: true/false}` axes to sync
   */


  addPartner(otherScroller, axes = xAxis) {
    const me = this;

    if (typeof axes === 'string') {
      axes = {
        [axes]: 1
      };
    }

    if (!me.partners) {
      me.partners = {};
    }

    me.partners[otherScroller.id] = {
      scroller: otherScroller,
      axes
    }; // Initial sync of the other axis to match our current state

    if (axes.x) {
      otherScroller.x = me.x;
    }

    if (axes.y) {
      otherScroller.y = me.y;
    } // It's a mutual relationship - the other scroller partners with us.


    if (!otherScroller.isPartneredWith(me)) {
      otherScroller.addPartner(me, axes);
    }
  }

  eachPartner(fn) {
    const {
      partners
    } = this;

    if (partners) {
      Object.values(partners).forEach(fn);
    }
  }
  /**
   * Breaks the link between this Scroller and the passed Scroller set up by the
   * {@link #function-addPartner} method.
   * @param {Core.helper.util.Scroller} otherScroller The Scroller to unlink from.
   */


  removePartner(otherScroller) {
    if (this.isPartneredWith(otherScroller)) {
      delete this.partners[otherScroller.id];
      otherScroller.removePartner(this);
    }
  }

  isPartneredWith(otherScroller) {
    return Boolean(this.partners && this.partners[otherScroller.id]);
  }
  /**
   * Breaks the link between this Scroller and all other Scrollers set up by the
   * {@link #function-addPartner} method.
   * @internal
   */


  clearPartners() {
    if (this.partners) {
      Object.values(this.partners).forEach(otherScroller => otherScroller.scroller.removePartner(this));
    }
  }
  /**
   * Scrolls the passed element or {@link Core.helper.util.Rectangle} into view according to the passed options.
   * @param {HTMLElement|Core.helper.util.Rectangle} element The element or a Rectangle in document space to scroll into view.
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
   * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
   * or the number of milliseconds to animate over, or an animation config object.
   * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
   * @param {String} [options.animate.easing] The name of an easing function.
   * @param {Boolean|Function} [options.highlight] Set to `true` to highlight the element when it is in view.
   * May be a function which is called passing the element, to provide customized highlighting.
   * @param {Boolean} [options.focus] Set to `true` to focus the element when it is in view.
   * @param {Boolean} [options.x] Pass as `false` to disable scrolling in the `X` axis.
   * @param {Boolean} [options.y] Pass as `false` to disable scrolling in the `Y` axis.
   * @returns {Promise} A promise which is resolved when the element has been scrolled into view.
   */


  async scrollIntoView(element, options = defaultScrollOptions) {
    const me = this,
          {
      isRectangle
    } = element,
          originalRect = isRectangle ? element : _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(element),
          {
      xDelta,
      yDelta
    } = me.getDeltaTo(element, options),
          result = me.scrollBy(xDelta, yDelta, options);

    if (options.highlight || options.focus) {
      result.then(() => {
        if (isRectangle) {
          element = originalRect.translate(-xDelta, -yDelta);
        }

        if (options.highlight) {
          // Not coercible to a number means its a function or name of a function
          if (isNaN(options.highlight)) {
            (me.widget || me).callback(options.highlight, null, [element]);
          } // Otherwise, it's truthy or falsy
          else {
            _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].highlight(element, me);
          }
        }

        if (options.focus) {
          element.focus();
        }
      });
    }

    return result;
  }
  /**
   * Scrolls the passed element into view according to the passed options.
   * @param {HTMLElement} element The element in document space to scroll into view.
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
   * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
   * or the number of milliseconds to animate over, or an animation config object.
   * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
   * @param {String} [options.animate.easing] The name of an easing function.
   * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
   * @param {Boolean} [options.focus] Set to `true` to focus the element when it is in view.
   * @param {Boolean} [options.x] Pass as `false` to disable scrolling in the `X` axis.
   * @param {Boolean} [options.y] Pass as `false` to disable scrolling in the `Y` axis.
   * @returns {Promise} A promise which is resolved when the element has been scrolled into view.
   */


  static async scrollIntoView(element, options = defaultScrollOptions) {
    const target = _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(element),
          animate = typeof options === 'object' ? options.animate : options,
          scrollable = Scroller._globalScroller || (Scroller._globalScroller = new Scroller()),
          deltas = [];
    let totalX = 0,
        totalY = 0,
        result; // Build up all the scroll deltas necessary to bring the requested element into view

    for (let ancestor = element.parentNode; ancestor.nodeType === Node.ELEMENT_NODE; ancestor = ancestor.parentNode) {
      if (ancestor === document.body && ancestor !== document.scrollingElement) {
        continue;
      } // The <html> element, althouhgh it scrolls is overflow:visioble by default.


      const style = ancestor === document.scrollingElement ? allScroll : ancestor.ownerDocument.defaultView.getComputedStyle(ancestor); // If the ancestor overflows and scrolls in a dimension we are being asked to scroll in
      // Accumulate a scroll command for the ancestor.

      if (options.y !== false && isScrollable[style.overflowY] && ancestor.scrollHeight > ancestor.clientHeight || options.x !== false && isScrollable[style.overflowX] && ancestor.scrollWidth > ancestor.clientWidth) {
        // Global Scrollable
        scrollable.element = ancestor; // See if the target is outside of this ancestor

        const {
          xDelta,
          yDelta
        } = scrollable.getDeltaTo(target, options);

        if (xDelta || yDelta) {
          deltas.push({
            element: ancestor,
            x: ancestor.scrollLeft,
            y: ancestor.scrollTop,
            xDelta,
            yDelta
          });
          target.translate(-xDelta, -yDelta);
          totalX += xDelta;
          totalY += yDelta;
        }
      }
    } // If scrolling was found to be necessary


    if (deltas.length) {
      const absX = Math.abs(totalX),
            absY = Math.abs(totalY);
      let duration = animate && (typeof animate === 'number' ? animate : typeof animate.duration === 'number' ? animate.duration : 300); // Only go through animation if there is significant scrolling to do.

      if (duration && (absX > 10 || absY > 10)) {
        // For small distances, constrain duration
        if (Math.max(absX, absY) < 50) {
          duration = Math.min(duration, 500);
        }

        result = scrollable.scrollAnimation = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].animate(duration, progress => {
          const isEnd = progress === 1;

          for (const {
            element,
            x,
            y,
            xDelta,
            yDelta
          } of deltas) {
            scrollable.element = element;

            if (xDelta) {
              scrollable.x = Math.max(x + (isEnd ? xDelta : Math.round(xDelta * progress)), 0);
            }

            if (yDelta) {
              scrollable.y = Math.max(y + (isEnd ? yDelta : Math.round(yDelta * progress)), 0);
            }
          }
        }, null, animate.easing);
        result.then(() => {
          scrollable.scrollAnimation = null;
        });
      } // No animation
      else {
        for (const {
          element,
          xDelta,
          yDelta
        } of deltas) {
          element.scrollTop += yDelta;
          element.scrollLeft += xDelta;
        }

        result = scrollPromise(deltas[deltas.length - 1].element);
      }
    } else {
      result = immediatePromise;
    } // Postprocess element after scroll.


    if (options.highlight || options.focus) {
      result.then(() => {
        if (options.highlight) {
          // Not coercible to a number means its a function or name of a function
          if (isNaN(options.highlight)) {
            scrollable.callback(options.highlight, null, [element]);
          } // Otherwise, it's truthy or falsy
          else {
            _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].highlight(element, scrollable);
          }
        }

        if (options.focus) {
          element.focus();
        }
      });
    }

    return result;
  }
  /**
   * Scrolls by the passed deltas according to the passed options.
   * @param {Number} [xDelta=0] How far to scroll in the X axis.
   * @param {Number} [yDelta=0] How far to scroll in the Y axis.
   * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
   * @param {Boolean} [options.silent] Set to `true` to suspend `scroll` events during scrolling.
   * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
   * or the number of milliseconds to animate over, or an animation config object.
   * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
   * @param {String} [options.animate.easing] The name of an easing function.
   * @returns {Promise} A promise which is resolved when the scrolling has finished.
   */


  async scrollBy(xDelta = 0, yDelta = 0, options = defaultScrollOptions) {
    const me = this,
          animate = typeof options === 'object' ? options.animate : options,
          absX = Math.abs(xDelta),
          absY = Math.abs(yDelta);

    if (me.scrollAnimation) {
      me.scrollAnimation.cancel();
      me.scrollAnimation = null;
    } // Only set the flag if there is going to be scrolling done.
    // It is cleared by the scrollEnd handler, so there must be scrolling.


    if (xDelta || yDelta) {
      me.silent = options.silent;
    }

    let duration = animate && (typeof animate === 'number' ? animate : typeof animate.duration === 'number' ? animate.duration : 300); // Only go through animation if there is significant scrolling to do.

    if (duration && (absX > 10 || absY > 10)) {
      const {
        x,
        y
      } = me;
      let lastX = x,
          lastY = y; // For small distances, constrain duration

      if (Math.max(absX, absY) < 50) {
        duration = Math.min(duration, 500);
      }

      me.scrollAnimation = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].animate(duration, progress => {
        const isEnd = progress === 1;

        if (xDelta) {
          // If the user, or another process has changed the position since last time, abort.
          // Unless called with the force option to proceed regardless.
          if (me.x !== lastX && !options.force) {
            return me.scrollAnimation && me.scrollAnimation.cancel();
          }

          me.x = Math.max(x + (isEnd ? xDelta : Math.round(xDelta * progress)), 0);
        }

        if (yDelta) {
          // If the user, or another process has changed the position since last time, abort.
          // Unless called with the force option to proceed regardless.
          if (me.y !== lastY && !options.force) {
            return me.scrollAnimation && me.scrollAnimation.cancel();
          }

          me.y = Math.max(y + (isEnd ? yDelta : Math.round(yDelta * progress)), 0);
        } // Store actual position from DOM


        lastX = me.x;
        lastY = me.y;
      }, me, animate.easing);
      me.element.classList.add('b-scrolling');
      me.scrollAnimation.then(() => {
        if (!me.isDestroyed) {
          me.element.classList.remove('b-scrolling');
          me.scrollAnimation = null;
        }
      });
      return me.scrollAnimation;
    } else {
      if (xDelta | yDelta) {
        me.x += xDelta;
        me.y += yDelta;
        return scrollPromise(me.element);
      }

      return immediatePromise;
    }
  }
  /**
   * Scrolls to the passed position according to the passed options.
   * @param {Number} [toX=0] Where to scroll to in the X axis.
   * @param {Number} [toY=0] Where to scroll to in the Y axis.
   * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
   * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
   * or the number of milliseconds to animate over, or an animation config object.
   * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
   * @param {String} [options.animate.easing] The name of an easing function.
   * @returns {Promise} A promise which is resolved when the scrolling has finished.
   */


  async scrollTo(toX, toY, options) {
    const {
      x,
      y
    } = this,
          xDelta = toX == null ? 0 : toX - x,
          yDelta = toY == null ? 0 : toY - y;
    return this.scrollBy(xDelta, yDelta, options);
  }

  doDestroy() {
    const me = this;

    if (me._element) {
      me._element.removeEventListener('scroll', me.scrollHandler);

      me.wheelListenerRemover && me.wheelListenerRemover();
    }

    if (me.scrollAnimation) {
      me.scrollAnimation.cancel();
    }

    Object.values(me.partners || {}).forEach(({
      scroller
    }) => scroller.removePartner(me));
    super.doDestroy();
  }
  /**
   * Respond to style changes to monitor scroll *when this Scroller is in `translate: true` mode.*
   * @param {Object[]} mutations The ElementMutation records.
   * @private
   */


  onElMutation(mutations) {
    const me = this,
          [x, y] = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateXY(me.element); // If the mutation was due to a change in the translateX/Y styles, this is
    // a scroll event, so inform observers and partners

    if (me._x !== -x || me.y !== -y) {
      const scrollEvent = new CustomEvent('scroll', {
        bubbles: true
      });
      Object.defineProperty(scrollEvent, 'target', {
        get: () => me.element
      });
      me.onScroll(scrollEvent);
    }
  }

  onElResize() {
    var _this$owner;

    if ((_this$owner = this.owner) !== null && _this$owner !== void 0 && _this$owner.isAnimating) {
      this.owner.on({
        animationEnd: 'onElResize',
        thisObj: this,
        once: true
      });
    } else {
      this.syncOverflowState();
    }
  }

  onScroll(e) {
    const me = this,
          {
      _x,
      _y,
      element
    } = me;
    let vetoed = 0; // Until overflow:clip is 100% supported just veto (and rollback) scrolls in clipped axes

    if (me.overflowX === 'clip' && element.scrollLeft !== _x) {
      element.scrollLeft = _x;
      ++vetoed;
    }

    if (me.overflowY === 'clip' && element.scrollTop !== _y) {
      element.scrollTop = _y;
      ++vetoed;
    }

    if (vetoed === 2) {
      return;
    }

    if (!me.widget || !me.widget.isDestroyed) {
      // Don't read the value until we have to. The x & y getters will check this flag
      me.positionDirty = true;

      if (!me.element.classList.contains('b-scrolling')) {
        me.element.classList.add('b-scrolling');
      }

      e.widget = me.widget; // If we have the scroll silent flag, do not fire the event.

      if (!me.silent) {
        me.trigger('scroll', e);
      } // Keep partners in sync


      me.syncPartners(); // If this scroll impulse was from a controlling partner, clear that now

      me.controllingPartner = null; // Buffered method will fire in 100ms, unless another scroll event comes round.
      // In which case execution will be pushed out by another 100ms.

      me.onScrollEnd(e);
    }
  }

  syncPartners(force) {
    const me = this; // Keep partners in sync

    if (me.partners) {
      Object.values(me.partners).forEach(({
        axes,
        scroller
      }) => {
        // Don't feed back to the one who's just told us to scroll here.
        // Unless we have assumed command. For example Scheduler timeline infinite scrolling
        // has reset the scroll position and the partner who thinks it's controlling
        // must stay in sync with that reset.
        if (scroller !== me.controllingPartner || force) {
          scroller.sync(me, axes);
        }
      });
    }
  }

  onScrollEnd(e) {
    const me = this;

    if (me.silent) {
      me.silent = false;
    }

    me.trigger('scrollEnd', e); // Controlling partner is required for scrollable not to change its partners on scroll. This method is buffered
    // and landing here essentially means that no scrolling has occurred during the onScrollEnd buffer
    // time. We can safely cleanup controlling partner here.
    // https://github.com/bryntum/support/issues/1095

    me.controllingPartner = null;
    me.element.classList.remove('b-scrolling');
  }
  /**
   * Returns the xDelta and yDelta values in an object from the current scroll position to the
   * passed element or Rectangle.
   * @param {HTMLElement|Core.helper.util.Rectangle} element The element or a Rectangle to calculate deltas for.
   * @param {Object} [options] How to scroll.
   * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
   * @param {Number} [options.edgeOffset] A margin around the element or rectangle to bring into view.
   * @param {Boolean} [options.x] Pass as `false` to disable scrolling in the `X` axis.
   * @param {Boolean} [options.y] Pass as `false` to disable scrolling in the `Y` axis.
   * @returns {Object} `{ xDelta, yDelta }`
   * @internal
   */


  getDeltaTo(element, options) {
    const me = this; // scroller may belong to a collapsed subgrid widget

    if (!me.viewport) {
      return {
        xDelta: 0,
        yDelta: 0
      };
    }

    const elementRect = element instanceof _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"] ? element : _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(element),
          block = options.block || 'nearest',
          scrollerRect = me.viewport,
          edgeOffset = options.edgeOffset || 0,
          // Only include the offset round the target is the viewport is big enough to accommodate it.
    xOffset = scrollerRect.width >= elementRect.width + edgeOffset * 2 ? edgeOffset : 0,
          yOffset = scrollerRect.height >= elementRect.height + edgeOffset * 2 ? edgeOffset : 0,
          elRect = elementRect.clone().adjust(-xOffset, -yOffset, xOffset, yOffset).constrainTo(new _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"](scrollerRect.x - me.x, scrollerRect.y - me.y, me.scrollWidth, me.scrollHeight)),
          targetRect = elRect.clone();
    let xDelta = 0,
        yDelta = 0;

    if (block === 'start') {
      targetRect.moveTo(scrollerRect.x, scrollerRect.y);
      xDelta = elRect.x - targetRect.x;
      yDelta = elRect.y - targetRect.y;
    } else if (block === 'end') {
      targetRect.translate(scrollerRect.right - targetRect.right, scrollerRect.bottom - targetRect.bottom);
      xDelta = elRect.x - targetRect.x;
      yDelta = elRect.y - targetRect.y;
    } else {
      // Calculate deltas unless the above has done that for non-fitting target
      if (block === 'center') {
        const center = scrollerRect.center;
        targetRect.moveTo(center.x - targetRect.width / 2, center.y - targetRect.height / 2);
        xDelta = xDelta || elRect.x - targetRect.x;
        yDelta = yDelta || elRect.y - targetRect.y;
      } // Use "nearest"
      else {
        // Can't fit width in, scroll what is possible into view so that start is visible.
        if (targetRect.width > scrollerRect.width) {
          xDelta = targetRect.x - scrollerRect.x;
        } // If it's *possible* to scroll to nearest x, calculate the delta
        else {
          if (targetRect.right > scrollerRect.right) {
            xDelta = targetRect.right - scrollerRect.right;
          } else if (targetRect.x < scrollerRect.x) {
            xDelta = targetRect.x - scrollerRect.x;
          }
        } // Can't fit height in, scroll what is possible into view so that start is visible.


        if (targetRect.height > scrollerRect.height) {
          yDelta = targetRect.y - scrollerRect.y;
        } // If it's *possible* to scroll to nearest y, calculate the delta
        else {
          if (targetRect.bottom > scrollerRect.bottom) {
            yDelta = targetRect.bottom - scrollerRect.bottom;
          } else if (targetRect.y < scrollerRect.y) {
            yDelta = targetRect.y - scrollerRect.y;
          }
        }
      }
    } // Do not allow deltas which would produce -ve scrolling or scrolling past the maxX/Y


    return {
      // When calculating how much delta is necessary to scroll the targetRect to the center
      // constrain that to what is *possible*. If what you are trying to scroll into the
      // center is hard against the right edge of the scroll range, then it cannot scroll
      // to the center, and the result must reflect that even though scroll is self limiting.
      // This is because highlighting the requested "element", if that element is in fact
      // a Rectangle, uses a temporary element placed at the requested region which
      // MUST match where the actual scroll has moved the requested region.
      xDelta: options.x === false ? 0 : Math.max(Math.min(Math.round(xDelta), me.maxX - me.x), -me.x),
      yDelta: options.y === false ? 0 : Math.max(Math.min(Math.round(yDelta), me.maxY - me.y), -me.y)
    };
  }
  /**
   * A {@link Core.helper.util.Rectangle Rectangle} describing the bounds of the scrolling viewport.
   * @property {Core.helper.util.Rectangle}
   */


  get viewport() {
    return _Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].client(this.element);
  }

  updateElement(element, oldElement) {
    const me = this; // The global Scroller doesn't monitor its element.
    // It's only used for *commanding* scrolls.

    if (me === Scroller._globalScroller) {
      me._element = element;
      me.positionDirty = true;
      return;
    }

    const scrollHandler = me.scrollHandler || (me.scrollHandler = me.onScroll.bind(me)),
          resizeHandler = me.resizeHandler || (me.resizeHandler = me.onElResize.bind(me));

    if (oldElement) {
      if (me.translate) {
        var _me$mutationObserver;

        (_me$mutationObserver = me.mutationObserver) === null || _me$mutationObserver === void 0 ? void 0 : _me$mutationObserver.disconnect(oldElement);
      } else {
        oldElement.removeEventListener('scroll', scrollHandler);
        oldElement.classList.remove(scrollerCls);
        oldElement.style.overflowX = oldElement.style.overflowY = '';
      }

      _ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(oldElement, resizeHandler);
    }

    if (element) {
      if (me.translate) {
        if (!me.mutationObserver) {
          me.mutationObserver = new MutationObserver(me.mutationHandler || (me.mutationHandler = me.onElMutation.bind(me)));
        }

        me._x = me._y = 0;

        if (document.contains(element)) {
          const [x, y] = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateXY(element);
          me._x = -x;
          me._y = -y;
        }

        me.mutationObserver.observe(element, {
          attributes: true
        });
      } else {
        element.addEventListener('scroll', scrollHandler);
        element.classList.add(scrollerCls);
      }

      _ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].addResizeListener(element, resizeHandler); // Ensure the overflow configs, which are unable to process themselves
      // in the absence of the element get applied to the newly arrived element.

      if (me.positionDirty) {
        me.updateOverflowX(me.overflowX);
        me.updateOverflowY(me.overflowY);
      } // Keep flags synced fro the start


      me.syncOverflowState(); // Apply initially configured scroll position if we have non-zero positions

      if (me.isConfiguring) {
        me._x && me.updateX(me._x);
        me._y && me.updateY(me._y);
      }
    }

    me.positionDirty = true;
  }
  /**
   * The horizontal scroll position of the widget.
   * @property {Number}
   */


  get x() {
    const me = this,
          {
      element
    } = me;

    if (element && me.positionDirty) {
      if (me.translate) {
        const [x, y] = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateXY(element);
        me._x = -x;
        me._y = -y;
      } else {
        me._x = element.scrollLeft;
        me._y = element.scrollTop;
      }

      me.positionDirty = false;
    }

    return me._x;
  }

  changeX(x) {
    // Only process initial X if we were configured to start at non-zero
    if (!this.isConfiguring || x) {
      return x;
    }

    this._x = x;
  }

  updateX(x) {
    const {
      element,
      widget
    } = this; // When element is outside of DOM, this can have no effect

    if (element && !(widget !== null && widget !== void 0 && widget.isConfiguring)) {
      this.trigger('scrollStart', {
        x
      });

      if (this.translate) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateX(element, -x);
      } else {
        element.scrollLeft = x;
      }
    } // The scroll position will need to be read before we can return it.
    // Do not read it back now, we may not have our element, or if we do,
    // that would cause a forced synchronous layout.


    this.positionDirty = true;
  }

  sync(controllingPartner, axes) {
    const {
      x,
      y
    } = axes;

    if (x != null) {
      if (this.x !== controllingPartner.x) {
        // Only set controlling partner when scroll will actually change. This helps to increase stability of
        // state restoring API.
        this.controllingPartner = controllingPartner;
        this.x = controllingPartner.x;
      }
    }

    if (y != null) {
      if (this.y !== controllingPartner.y) {
        this.controllingPartner = controllingPartner;
        this.y = controllingPartner.y;
      }
    }
  }
  /**
   * The vertical scroll position of the widget.
   * @property {Number}
   */


  get y() {
    const me = this,
          {
      element
    } = me;

    if (element && me.positionDirty) {
      if (me.translate) {
        const [x, y] = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateXY(element);
        me._x = -x;
        me._y = -y;
      } else {
        me._x = element.scrollLeft;
        me._y = element.scrollTop;
      }

      me.positionDirty = false;
    }

    return me._y;
  }

  changeY(y) {
    // Only process initial Y if we were configured to start at non-zero
    if (!this.isConfiguring || y) {
      return y;
    }

    this._y = y;
  }

  updateY(y) {
    const {
      element,
      widget
    } = this; // When element is outside of DOM, this can have no effect

    if (element && !(widget !== null && widget !== void 0 && widget.isConfiguring)) {
      this.trigger('scrollStart', {
        y
      });

      if (this.translate) {
        _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateY(element, -y);
      } else {
        element.scrollTop = y;
      }
    } // The scroll position will need to be read before we can return it.
    // Do not read it back now, we may not have our element, or if we do,
    // that would cause a forced synchronous layout.


    this.positionDirty = true;
  }
  /**
   * The maximum `X` scrollable position of the widget.
   * @property {Number}
   * @readonly
   */


  get maxX() {
    return this.scrollWidth - this.clientWidth;
  }
  /**
   * The maximum `Y` scrollable position of the widget.
   * @property {Number}
   * @readonly
   */


  get maxY() {
    return this.scrollHeight - this.clientHeight;
  }

  updateOverflowX(overflowX, oldOverflowX) {
    const {
      element,
      translate
    } = this,
          {
      style,
      classList
    } = element;

    if (oldOverflowX === 'hidden-scroll') {
      classList.remove('b-hide-scroll');
    } // Scroll, but without showing scrollbars.
    // For example a grid header. Only works on platforms which
    // support suppression of scrollbars through CSS.


    if (overflowX === 'hidden-scroll' && !translate) {
      const otherAxisScrollable = isScrollable[style.overflowY]; // Can't do one axis hidden-scroll, and the other scrollable because the b-hide-scroll
      // class hides "all" scrollbars, so we have to make this axis hidden and use a wheel
      // listener to scroll the content.

      if (otherAxisScrollable) {
        overflowX = 'hidden'; // Adds a wheel listener if we don't already have one.

        this.enableWheel();
      } else {
        classList.add('b-hide-scroll');
      }
    }

    if (!translate) {
      style.overflowX = scrollLiterals[overflowX] || overflowX;
    }

    this.positionDirty = !this.isConfiguring;
  }

  updateOverflowY(overflowY, oldOverflowY) {
    const {
      element,
      translate
    } = this,
          {
      style,
      classList
    } = element;

    if (oldOverflowY === 'hidden-scroll') {
      classList.remove('b-hide-scroll');
    } // Scroll, but without showing scrollbars.
    // For example a grid header.
    // On platforms which show space-consuming scrollbars we hide scrollbars
    // and add a 'wheel' listener.


    if (overflowY === 'hidden-scroll' && !translate) {
      const otherAxisScrollable = isScrollable[style.overflowX]; // Can't do one axis hidden-scroll, and the other scrollable because the b-hide-scroll
      // class hides "all" scrollbars, so we have to make this axis hidden and use a wheel
      // listener to scroll the content.

      if (otherAxisScrollable) {
        overflowY = 'hidden'; // Adds a wheel listener if we don't already have one.

        this.enableWheel();
      } else {
        classList.add('b-hide-scroll');
      }
    }

    if (!translate) {
      style.overflowY = scrollLiterals[overflowY] || overflowY;
    }

    this.positionDirty = !this.isConfiguring;
  }

  enableWheel() {
    if (!this.wheelListenerRemover) {
      this.wheelListenerRemover = _EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].on({
        element: this.element,
        wheel: 'onWheel',
        thisObj: this
      });
    }
  }

  onWheel(e) {
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && this.overflowX === 'hidden-scroll') {
      this.x += e.deltaX;
    } else if (this.overflowY === 'hidden-scroll') {
      this.y += e.deltaY;
    }
  }
  /**
   * The horizontal scroll range of the widget.
   * @property {Number}
   * @readonly
   */


  get scrollWidth() {
    var _this$element$scrollW, _this$element;

    return (_this$element$scrollW = (_this$element = this.element) === null || _this$element === void 0 ? void 0 : _this$element.scrollWidth) !== null && _this$element$scrollW !== void 0 ? _this$element$scrollW : 0;
  }

  set scrollWidth(scrollWidth) {
    const me = this,
          {
      element
    } = me;
    let stretcher = me.widthStretcher; // "Unsetting" scrollWidth removes the stretcher

    if (stretcher && scrollWidth == null) {
      stretcher.remove();
      me.widthStretcher = null;
    } else if (scrollWidth) {
      if (!stretcher) {
        stretcher = me.widthStretcher = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement({
          className: 'b-scroller-stretcher b-horizontal-stretcher',
          // Should survive its surroundings being DomSynced
          retainElement: true
        });
      }

      stretcher.style.transform = `translateX(${scrollWidth - 1}px)`;

      if (element && !element.contains(stretcher)) {
        element.insertBefore(stretcher, element.firstElementChild);
      }
    } // Propagate call to partners so they will establish own scroller stretcher


    if (me.propagate !== false) {
      me.eachPartner(({
        scroller
      }) => {
        // Raise a flag on partner to not propagate changes from it further
        scroller.propagate = false;
        scroller.scrollWidth = scrollWidth;
        delete scroller.propagate;
      });
    }

    me.positionDirty = true;
    me.syncOverflowState();
  }

  get scrollHeight() {
    var _this$element$scrollH, _this$element2;

    return (_this$element$scrollH = (_this$element2 = this.element) === null || _this$element2 === void 0 ? void 0 : _this$element2.scrollHeight) !== null && _this$element$scrollH !== void 0 ? _this$element$scrollH : 0;
  }
  /**
   * The vertical scroll range of the widget. May be set to larger than the actual data
   * height to enable virtual scrolling. This is how the grid extends its scroll range
   * while only rendering a small subset of the dataset.
   * @property {Number}
   */


  set scrollHeight(scrollHeight) {
    const me = this,
          stretcher = me.stretcher || (me.stretcher = _DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement({
      className: 'b-scroller-stretcher'
    }));
    stretcher.style.transform = `translateY(${scrollHeight - 1}px)`;

    if (me.element && me.element.lastChild !== stretcher) {
      me.element.appendChild(stretcher);
    }

    me.positionDirty = true;
    me.syncOverflowState();
  }
  /**
   * The client width of the widget.
   * @property {Number}
   * @readonly
   */


  get clientWidth() {
    var _this$element3;

    return ((_this$element3 = this.element) === null || _this$element3 === void 0 ? void 0 : _this$element3.clientWidth) || 0;
  }
  /**
   * The client height of the widget.
   * @property {Number}
   * @readonly
   */


  get clientHeight() {
    var _this$element4;

    return ((_this$element4 = this.element) === null || _this$element4 === void 0 ? void 0 : _this$element4.clientHeight) || 0;
  }
  /**
   * The unique ID of this Scroller
   * @property {String}
   * @readonly
   */


  get id() {
    if (!this._id) {
      if (this.widget) {
        this._id = `${this.widget.id}-scroller`;
      } else {
        this._id = _IdHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].generateId('scroller-');
      }
    }

    return this._id;
  }

}
Scroller._$name = 'Scroller';

/***/ }),

/***/ "./lib/Core/localization/En.js":
/*!*************************************!*\
  !*** ./lib/Core/localization/En.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
var productName = 'taskboard';
 //<umd>

const localeName = 'En',
      localeDesc = 'English',
      locale = {
  localeName,
  localeDesc,
  // Translations for common words and phrases which are used by all classes.
  Object: {
    Yes: 'Yes',
    No: 'No',
    Cancel: 'Cancel',
    Ok: 'OK'
  },
  //region Widgets
  Combo: {
    noResults: 'No results',
    recordNotCommitted: 'Record could not be addded',
    addNewValue: value => `Add ${value}`
  },
  FilePicker: {
    file: 'File'
  },
  Field: {
    // native input ValidityState statuses
    badInput: 'Invalid field value',
    patternMismatch: 'Value should match a specific pattern',
    rangeOverflow: value => `Value must be less than or equal to ${value.max}`,
    rangeUnderflow: value => `Value must be greater than or equal to ${value.min}`,
    stepMismatch: 'Value should fit the step',
    tooLong: 'Value should be shorter',
    tooShort: 'Value should be longer',
    typeMismatch: 'Value is required to be in a special format',
    valueMissing: 'This field is required',
    invalidValue: 'Invalid field value',
    minimumValueViolation: 'Minimum value violation',
    maximumValueViolation: 'Maximum value violation',
    fieldRequired: 'This field is required',
    validateFilter: 'Value must be selected from the list'
  },
  DateField: {
    invalidDate: 'Invalid date input'
  },
  NumberFormat: {
    locale: 'en-US',
    currency: 'USD'
  },
  DurationField: {
    invalidUnit: 'Invalid unit'
  },
  TimeField: {
    invalidTime: 'Invalid time input'
  },
  List: {
    loading: 'Loading...'
  },
  // needed here due to LoadMaskable
  GridBase: {
    loadMask: 'Loading...',
    syncMask: 'Saving changes, please wait...'
  },
  PagingToolbar: {
    firstPage: 'Go to first page',
    prevPage: 'Go to previous page',
    page: 'Page',
    nextPage: 'Go to next page',
    lastPage: 'Go to last page',
    reload: 'Reload current page',
    noRecords: 'No records to display',
    pageCountTemplate: data => `of ${data.lastPage}`,
    summaryTemplate: data => `Displaying records ${data.start} - ${data.end} of ${data.allCount}`
  },
  PanelCollapser: {
    Collapse: 'Collapse',
    Expand: 'Expand'
  },
  UndoRedo: {
    Undo: 'Undo',
    Redo: 'Redo',
    UndoLastAction: 'Undo last action',
    RedoLastAction: 'Redo last undone action'
  },
  //endregion
  //region Others
  DateHelper: {
    locale: 'en-US',
    weekStartDay: 0,
    // Non-working days which match weekends by default, but can be changed according to schedule needs
    nonWorkingDays: {
      0: true,
      6: true
    },
    // Days considered as weekends by the selected country, but could be working days in the schedule
    weekends: {
      0: true,
      6: true
    },
    unitNames: [{
      single: 'millisecond',
      plural: 'ms',
      abbrev: 'ms'
    }, {
      single: 'second',
      plural: 'seconds',
      abbrev: 's'
    }, {
      single: 'minute',
      plural: 'minutes',
      abbrev: 'min'
    }, {
      single: 'hour',
      plural: 'hours',
      abbrev: 'h'
    }, {
      single: 'day',
      plural: 'days',
      abbrev: 'd'
    }, {
      single: 'week',
      plural: 'weeks',
      abbrev: 'w'
    }, {
      single: 'month',
      plural: 'months',
      abbrev: 'mon'
    }, {
      single: 'quarter',
      plural: 'quarters',
      abbrev: 'q'
    }, {
      single: 'year',
      plural: 'years',
      abbrev: 'yr'
    }, {
      single: 'decade',
      plural: 'decades',
      abbrev: 'dec'
    }],
    // Used to build a RegExp for parsing time units.
    // The full names from above are added into the generated Regexp.
    // So you may type "2 w" or "2 wk" or "2 week" or "2 weeks" into a DurationField.
    // When generating its display value though, it uses the full localized names above.
    unitAbbreviations: [['mil'], ['s', 'sec'], ['m', 'min'], ['h', 'hr'], ['d'], ['w', 'wk'], ['mo', 'mon', 'mnt'], ['q', 'quar', 'qrt'], ['y', 'yr'], ['dec']],
    parsers: {
      L: 'MM/DD/YYYY',
      LT: 'HH:mm A'
    },
    ordinalSuffix: number => {
      const hasSpecialCase = ['11', '12', '13'].find(n => number.endsWith(n));
      let suffix = 'th';

      if (!hasSpecialCase) {
        const lastDigit = number[number.length - 1];
        suffix = {
          1: 'st',
          2: 'nd',
          3: 'rd'
        }[lastDigit] || 'th';
      }

      return number + suffix;
    }
  },
  //endregion
  //region Trial
  TrialButton: {
    downloadTrial: 'Download trial'
  },
  TrialPanel: {
    title: 'Please complete fields',
    name: 'Name',
    email: 'Email',
    company: 'Company',
    product: 'Product',
    cancel: 'Cancel',
    submit: 'Submit',
    downloadStarting: 'Download starting, please wait...'
  } //endregion

};
/* harmony default export */ __webpack_exports__["default"] = (locale); //</umd>

_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerLocale(localeName, {
  desc: localeDesc,
  locale: locale
});

/***/ }),

/***/ "./lib/Core/localization/LocaleHelper.js":
/*!***********************************************!*\
  !*** ./lib/Core/localization/LocaleHelper.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LocaleHelper; });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';
/**
* @module Core/localization/LocaleHelper
*/

/**
 * Provides locale management methods.
 */

class LocaleHelper {
  /**
   * Merges all properties of provided locales into new locale.
   * Locales are merged in order they provided and locales which go later replace same properties of previous locales.
   * @param {...Object} locales Locales to merge
   * @return {Object} Merged locale
   */
  static mergeLocales(...locales) {
    const result = {};
    locales.forEach(locale => {
      Object.keys(locale).forEach(key => {
        if (typeof locale[key] === 'object') {
          result[key] = _objectSpread(_objectSpread({}, result[key]), locale[key]);
        } else {
          result[key] = locale[key];
        }
      });
    });
    return result;
  }
  /**
   * Removes all properties from `locale` that are present in the provided `trimLocale`.
   * @param {Object} locale locales to merge
   * @param {Object} trimLocale locales to merge
   */


  static trimLocale(locale, trimLocale) {
    const remove = (key, subKey) => {
      if (locale[key]) {
        if (subKey) {
          if (locale[key][subKey]) {
            delete locale[key][subKey];
          }
        } else {
          delete locale[key];
        }
      }
    };

    Object.keys(trimLocale).forEach(key => {
      if (Object.keys(trimLocale[key]).length > 0) {
        Object.keys(trimLocale[key]).forEach(subKey => remove(key, subKey));
      } else {
        remove(key);
      }
    });
  }
  /**
   * Put the locale under `window.bryntum.locales` to make sure it can be discovered automatically
   * @param {String} localeName Locale name
   * @param {Object} config Locale config
   */


  static publishLocale(localeName, config) {
    const bryntum = window.bryntum = window.bryntum || {},
          locales = bryntum.locales = bryntum.locales || {}; // Avoid registering locales twice

    locales[localeName] = !locales[localeName] ? config : this.mergeLocales(locales[localeName], config);
  }

}
LocaleHelper._$name = 'LocaleHelper';

/***/ }),

/***/ "./lib/Core/localization/LocaleManager.js":
/*!************************************************!*\
  !*** ./lib/Core/localization/LocaleManager.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../localization/LocaleHelper.js */ "./lib/Core/localization/LocaleHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'taskboard';






/**
 * @module Core/localization/LocaleManager
 */
// Documented at the export below, to work for singleton

class LocaleManager extends Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get defaultConfig() {
    return {
      locales: {},
      // Enable strict locale checking by default for tests
      throwOnMissingLocale: _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isTestEnv
    };
  }

  construct(...args) {
    const me = this;
    super.construct(...args);

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isBrowserEnv) {
      const scriptTag = document.querySelector('script[data-default-locale]'),
            {
        locales
      } = window.bryntum || {};

      if (scriptTag) {
        me.defaultLocaleName = scriptTag.dataset.defaultLocale;
      }

      if (locales) {
        Object.keys(locales).forEach(localeName => {
          // keeping this check in case some client tries to use an old locale
          if (!localeName.startsWith('moment')) {
            const locale = locales[localeName];

            if (locale.extends) {
              me.extendLocale(locale.extends, locale);
            } else if (locale.localeName) {
              me.registerLocale(locale.localeName, {
                desc: locale.localeDesc,
                locale: locale
              });
            }
          }
        });

        if (!me.locale) {
          // English locale is built in, no need to apply it here since it will be applied anyway
          if (me.defaultLocaleName !== 'En') {
            // No locale applied, use default or first found
            me.applyLocale(me.defaultLocaleName || Object.keys(me.locales)[0]);
          }
        }
      }
    }
  }

  set locales(localeConfigs) {
    this._locales = localeConfigs;
  }
  /**
   * Get currently registered locales.
   * Returns an object with locale names (`localeName`) as properties.
   *
   * Example:
   * ```
   * const englishLocale = LocaleManager.locales.En;
   * ```
   *
   * this returns registered English locale object.
   * ```
   * {
   *   "desc": "English",
   *   "locale": {
   *     "localeName": "En",
   *     "localeDesc": "English",
   *
   *     ... (localization goes here)
   *
   *   }
   * }
   * ```
   * @readonly
   * @member {Object} locales
   */


  get locales() {
    return this._locales;
  }
  /**
   * Get/set currently used locale. Set a name of a locale to have it applied, or give a locale configuration to
   * have it registered and then applied
   * @member {Object} locale
   * @accepts {String|Object}
   */


  set locale(locale) {
    if (typeof locale === 'string') {
      this.applyLocale(locale);
    } else {
      if (!locale.locale) {
        locale = {
          locale,
          localeName: locale.localeName || 'custom'
        };
      }

      this.registerLocale(locale.localeName, locale);
      this.applyLocale(locale.localeName);
    }
  }

  get locale() {
    return this._locale;
  }
  /**
   * Register a locale to make it available for applying.
   * Registered locales are available in {@link Core.localization.LocaleManager#property-locales}.
   * @param {String} name Name of locale (for example `En` or `SvSE`)
   * @param {Object} config Object with localized properties
   * @function registerLocale
   */


  registerLocale(name, config) {
    var _me$locale;

    const me = this,
          isDefault = me.defaultLocaleName === name,
          isCurrent = ((_me$locale = me.locale) === null || _me$locale === void 0 ? void 0 : _me$locale.localeName) === name,
          isFirst = Object.keys(me.locales).length === 0;
    let currentLocale = me.locales[name]; // Avoid registering the same locale twice and merge configs

    if (!currentLocale) {
      me.locales[name] = config;
      currentLocale = me.locales[name];
    } else {
      if (config.exclude) {
        currentLocale.exclude = _localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].mergeLocales(currentLocale.exclude || {}, config.exclude);
      }

      currentLocale.locale = _localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].mergeLocales(currentLocale.locale, config.locale);
    } // If we have exclude in locale config we remove excluded on registering locale to avoid merging unwanted locale keys


    if (currentLocale.exclude) {
      _localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].trimLocale(currentLocale.locale, currentLocale.exclude);
    } // If no default locale specified, use the first one. otherwise apply the default when it is registered
    // also reapply if current locale is registered again (first grid, then scheduler etc).


    if (isDefault || !me.defaultLocaleName && (isFirst || isCurrent)) {
      me.internalApplyLocale(currentLocale);
    }
  }
  /**
   * Extend an already loaded locale to add additional translations.
   * @param {String} name Name of locale (for example `En` or `SvSE`)
   * @param {Object} config Object with localized properties
   * @function extendLocale
   */


  extendLocale(name, config) {
    var _this$locale;

    const locale = this.locales[name];

    if (!locale) {
      return false;
    }

    locale.locale = _localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].mergeLocales(locale.locale, config);
    delete locale.locale.extends; // If current loaded locale is the same then apply to reflect changes

    if (((_this$locale = this.locale) === null || _this$locale === void 0 ? void 0 : _this$locale.localeName) === name) {
      this.applyLocale(name);
    }

    return true;
  }

  internalApplyLocale(localeConfig) {
    this._locale = localeConfig.locale;
    /**
     * Fires when a locale is applied
     * @event locale
     * @param {Core.localization.LocaleManager} source The Locale manager instance.
     * @param {Object} locale Locale configuration
     */

    this.trigger('locale', localeConfig);
  }
  /**
   * Apply a locale. Locale must be defined in {@link Core.localization.LocaleManager#property-locales}.
   * If it is not loaded it will be loaded using AjaxHelper {@link Core.helper.AjaxHelper#function-get-static} request and then applied.
   * @param {String} name Name of locale to apply (for example `En` or `SvSE`)
   * @returns {Boolean|Promise}
   * @fires locale
   * @function applyLocale
   */


  applyLocale(name, forceApply = false, ignoreError = false) {
    const me = this,
          localeConfig = me.locales[name];

    if (localeConfig !== null && localeConfig !== void 0 && localeConfig.locale && me._locale === localeConfig.locale && !forceApply) {
      // no need to apply same locale again
      return true;
    } // ignoreError is used in examples where one example might have defined a locale not available in another


    if (!localeConfig) {
      if (ignoreError) {
        return true;
      }

      throw new Error(`Locale ${name} not registered`);
    }

    function internalApply() {
      me.internalApplyLocale(localeConfig);
    }

    if (!localeConfig.locale) {
      return new Promise((resolve, reject) => {
        me.loadLocale(localeConfig.path).then(response => {
          response.text().then(text => {
            // eslint-disable-next-line no-new-func
            const parseLocale = new Function(text);
            parseLocale();

            if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isBrowserEnv) {
              localeConfig.locale = window.bryntum.locales[name];
            }

            internalApply();
            resolve(localeConfig);
          });
        }).catch(response => reject(response));
      });
    }

    internalApply();
    return true;
  }
  /**
   * Loads a locale using AjaxHelper {@link Core.helper.AjaxHelper#function-get-static} request.
   * @private
   * @param {String} path Path to locale file
   * @returns {Promise}
   * @function loadLocale
   */


  loadLocale(path) {
    return _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(path);
  }
  /**
   * Specifies if {@link Core.localization.Localizable#function-L-static Localizable.L()} function would throw error if no localization found in runtime
   * @member {Boolean} throwOnMissingLocale
   * @default false
   */


  set throwOnMissingLocale(value) {
    this._throwOnMissingLocale = value;
  }

  get throwOnMissingLocale() {
    return this._throwOnMissingLocale;
  }

}

const LocaleManagerSingleton = new LocaleManager();
/**
 * Singleton that handles switching locale. Locales can be included on page with `<script type="module">` tags or
 * loaded using ajax. When using script tags the first locale loaded is used per default, if another should be used as
 * default specify it on the script tag for the grid (see example below).
 *
 * ```
 * // Using Ecma 6 modules
 * <script type="module" src="./Core/localization/SvSE.js">
 *
 * // Specify default when using scripts
 * <script src="build/locales/grid.locale.SvSE.js">
 * <script data-default-locale="En" src="build/grid-all.js">
 *
 * import LocaleManager from 'Core/localization/LocaleManager.js';
 * // Set locale using method
 * LocaleManager.applyLocale('SvSE');
 * // Or set locale using property
 * LocaleManager.locale = LocaleManager.locales.SvSE;
 * ```
 *
 * @demo Grid/localization
 * @class
 * @singleton
 */

/* harmony default export */ __webpack_exports__["default"] = (LocaleManagerSingleton);

/***/ }),

/***/ "./lib/Core/localization/Localizable.js":
/*!**********************************************!*\
  !*** ./lib/Core/localization/Localizable.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
var productName = 'taskboard';



/**
 * @module Core/localization/Localizable
 */

const ObjectProto = Object.getPrototypeOf(Object),
      localeRe = /L{.*?}/g,
      escape = txt => txt.replace(/{(\d+)}/gm, '[[$1]]'),
      unescape = txt => txt.replace(/\[\[(\d+)]]/gm, '{$1}');
/**
 * Mixin that provides localization functionality to a class.
 *
 * ```
 * // Get localized string
 * grid.L('foo');
 * grid.L('L{foo}');
 * ```
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class Localizable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Localizable';
  }

  static get configurable() {
    return {
      /**
       * A class translations of which are used for translating this entity.
       * This is often used when translations of an item are defined on its container class.
       * For example:
       *
       * ```js
       * // Toolbar class that has some predefined items
       * class MyToolbar extends Toolbar {
       *
       *     static get $name() {
       *         return 'MyToolbar';
       *     }
       *
       *     static get defaultConfig() {
       *         return {
       *             // this specifies default configs for the items
       *             defaults : {
       *                 // will tell items to use the toolbar locale
       *                 localeClass : this
       *             },
       *
       *             items : [
       *                 // The toolbar has 2 buttons and translation for their texts will be searched in
       *                 // the toolbar locales
       *                 { text : 'Agree' },
       *                 { text : 'Disagree' }
       *             ]
       *         };
       *     }
       *
       *    ...
       * }
       * ```
       * So if one makes a locale for the `MyToolbar` class that will include `Agree` and `Disagree` string translations:
       * ```js
       *     ...
       *     MyToolbar : {
       *         Agree    : 'Yes, I agree',
       *         Disagree : 'No, I do not agree'
       *     }
       * ```
       * They will be used for the toolbar buttons and the button captions will say `Yes, I agree` and `No, I do not agree`.
       *
       * @config {Core.Base}
       * @typings {typeof Base}
       */
      localeClass: null,

      /**
       * List of properties which values should be translated automatically upon a locale applying.
       * In case there is a need to localize not typical value (not a String value or a field with re-defined setter/getter),
       * you could use 'localeKey' meta configuration.
       * Example:
       * ```js
       *  static get configurable() {
       *     return {
       *          localizableProperties : ['width'],
       *
       *          width : {
       *              value   : '54em', // default value here
       *              $config : {
       *                  localeKey : 'L{editorWidth}' // name of the property that will be used in localization file
       *              }
       *          }
       *      };
       *  }
       * ```
       * @config {String[]}
       */
      localizableProperties: {
        value: [],
        $config: {
          merge: 'distinct'
        }
      }
    };
  }

  static clsName(cls) {
    var _cls$prototype, _cls$prototype2;

    return typeof cls === 'string' ? cls : cls === ObjectProto ? 'Object' : cls.$$name || cls.name || ((_cls$prototype = cls.prototype) === null || _cls$prototype === void 0 ? void 0 : _cls$prototype.$$name) || ((_cls$prototype2 = cls.prototype) === null || _cls$prototype2 === void 0 ? void 0 : _cls$prototype2.name);
  }

  static parseLocaleString(text) {
    var _text;

    const matches = [];
    let m; // Parse locale text in case it's wrapped with L{foo}

    if ((_text = text) !== null && _text !== void 0 && _text.includes('L{')) {
      const re = /L{(.*?)}/g; // Escape fix for {1}, {2} etc. in locale str

      text = escape(text);

      while ((m = re.exec(text)) != null) {
        // Support for parsing class namespace L{Class.foo}
        const classMatch = /((.*?)\.)?(.+)/g.exec(m[1]);
        matches.push({
          match: unescape(m[0]),
          localeKey: unescape(classMatch[3]),
          localeClass: classMatch[2]
        });
      }
    }

    return matches.length > 0 ? matches : [{
      match: text,
      localeKey: text,
      localeClass: undefined
    }];
  }

  construct(config = {}, ...args) {
    // Base class applies configs.
    super.construct(config, ...args);
    _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].on('locale', this.updateLocalization, this);
    this.updateLocalization();
  }

  get localeClass() {
    return this._localeClass || null;
  }

  localizeProperty(property) {
    var _me$$meta$configs$pro;

    const me = this,
          currentValue = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(me, property),
          localeKey = (_me$$meta$configs$pro = me.$meta.configs[property]) === null || _me$$meta$configs$pro === void 0 ? void 0 : _me$$meta$configs$pro.localeKey; // check if localeKey is defined and try to translate it

    if (localeKey) {
      const localizedValue = Localizable.localize(localeKey, null, me.localeClass || me); // if a user set value directly in class definition, his value has a prio

      if (localizedValue && !(property in me.initialConfig)) {
        _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].setPath(me, property, localizedValue);
      }
    } else if (typeof currentValue === 'string') {
      me.originalLocales = me.originalLocales || {};
      let propertyValue = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(me.originalLocales, property); // If we haven't saved original values yet let's do that

      if (propertyValue === undefined) {
        _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].setPath(me.originalLocales, property, currentValue);
        propertyValue = currentValue;
      } // Doing localization from the original values


      if (propertyValue) {
        _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].setPath(me, property, me.optionalL(propertyValue));
      }
    }
  }
  /**
   * Method that is triggered when applying a locale to the instance
   * (happens on the instance construction steps and when switching to another locale).
   *
   * The method can be overridden to dynamically translate the instance when locale is switched.
   * When overriding the method please make sure you call `super.updateLocalization()`.
   * @category Misc
   */


  updateLocalization() {
    var _this$localizableProp;

    (_this$localizableProp = this.localizableProperties) === null || _this$localizableProp === void 0 ? void 0 : _this$localizableProp.forEach(this.localizeProperty, this);
  }

  static getTranslation(text, templateData, localeCls) {
    const {
      locale
    } = _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"];
    let result = null,
        clsName,
        cls;

    if (locale) {
      // Iterate over all found localization entries
      for (const {
        match,
        localeKey,
        localeClass
      } of this.parseLocaleString(text)) {
        const translate = clsName => {
          var _locale$clsName;

          const translation = (_locale$clsName = locale[clsName]) === null || _locale$clsName === void 0 ? void 0 : _locale$clsName[localeKey];

          if (translation) {
            if (typeof translation === 'function') {
              result = templateData != null ? translation(templateData) : translation;
            } else if (typeof translation === 'object' || text === match) {
              result = translation;
            } // Likely string
            else {
              result = (result || text).replace(match, translation);
            } // Might have nested L{, recurse


            if (typeof translation === 'string' && translation.includes('L{')) {
              result = this.getTranslation(translation, templateData, localeCls);
            }
          }

          return translation;
        }; // Translate order
        // 1. Try to translate for current class
        // 2. Try to translate by Class hierarchy traversing prototypes
        // 3. Try to translate if Class is in {Class.foo} format


        let success = false;

        for (cls = localeCls; cls && (clsName = Localizable.clsName(cls)); cls = Object.getPrototypeOf(cls)) {
          if (success = translate(clsName)) {
            break;
          } else if (typeof cls === 'string') {
            break;
          }
        }

        if (!success && localeClass) {
          translate(localeClass);
        }
      }
    }

    return result;
  }
  /**
   * Get localized string, returns `null` if no localized string found.
   * @param {String} text String key
   * @param {Object} [templateData] Data to supply to template if localized string is a function
   * @returns {String}
   * @internal
   */


  static localize(text, templateData = undefined, ...localeClasses) {
    var _localeClasses;

    // In case this static method is called directly third argument is not provided
    // just fallback to searching locales for the class itself
    if (((_localeClasses = localeClasses) === null || _localeClasses === void 0 ? void 0 : _localeClasses.length) === 0) {
      localeClasses = [this];
    }

    let translation = null;
    localeClasses.some(cls => {
      translation = Localizable.getTranslation(text, templateData, cls);
      return translation != null;
    });
    return translation;
  }
  /**
   * Get localized string, returns value of `text` if no localized string found.
   *
   * If {@link Core.localization.LocaleManager#property-throwOnMissingLocale LocaleManager.throwOnMissingLocale}
   * is `true` then calls to `L()` will throw `Localization is not found for 'text' in 'ClassName'` exception when no
   * localization is found.
   *
   * @param {String} text String key
   * @param {Object} [templateData] Data to supply to template if localized string is a function
   * @static
   * @returns {String}
   */


  static L(text, templateData = undefined, ...localeClasses) {
    var _localeClasses2;

    // In case this static method is called directly third argument is not provided
    // just fallback to searching locales for the class itself
    if (((_localeClasses2 = localeClasses) === null || _localeClasses2 === void 0 ? void 0 : _localeClasses2.length) === 0) {
      localeClasses = [this];
    }

    const translation = this.localize(text, templateData, ...localeClasses); // Throw error if not localized and text matches `L{foo}`

    if (translation == null && _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale && _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].locale && text.includes('L{')) {
      throw new Error(`Localization is not found for '${text}' in '${localeClasses.map(cls => Localizable.clsName(cls)).join(', ')}'. ${_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].locale.localeName ? `Locale : ${_LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].locale.localeName}` : ''}`);
    }

    return translation !== null && translation !== void 0 ? translation : text;
  }
  /**
   * Convenience function that can be called directly on the class that mixes Localizable in
   *
   * ```javascript
   * button.text = grid.L('L{group}');
   * ```
   *
   * @param {String} text String key
   * @param {Object} [templateData] Data to supply to template if localized string is a function
   * @returns {String}
   * @category Misc
   */


  L(text, templateData) {
    const {
      localeClass,
      constructor
    } = this; // If we have a different class set as translations provider
    // pass it first and use the class being translated as a fallback provider

    if (localeClass && Localizable.clsName(localeClass) !== Localizable.clsName(constructor)) {
      return Localizable.L(text, templateData, localeClass, constructor);
    } else {
      return Localizable.L(text, templateData, constructor);
    }
  }
  /**
   * Convenience function to get an optional translation. The difference compared to `L()` is that it wont throw
   * an error when the translation is missing even if configured with `throwOnMissingLocale`
   *
   * ```javascript
   * button.text = grid.optionalL('L{group}');
   * ```
   *
   * @param {String} text String key
   * @param {Object} [templateData] Data to supply to template if localized string is a function
   * @returns {String}
   * @static
   * @category Misc
   */


  static optionalL(text, templateData = undefined, ...localeClasses) {
    var _localeClasses3;

    const shouldThrow = _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale;
    _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale = shouldThrow && localeRe.test(text); // In case this static method is called directly third argument is not provided
    // just fallback to searching locales for the class itself

    if (((_localeClasses3 = localeClasses) === null || _localeClasses3 === void 0 ? void 0 : _localeClasses3.length) === 0) {
      localeClasses = [this];
    }

    const result = Localizable.L(text, templateData, ...localeClasses);
    _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale = shouldThrow;
    return result;
  }
  /**
   * Convenience function to get an optional translation. The difference compared to `L()` is that it wont throw
   * an error when the translation is missing even if configured with `throwOnMissingLocale`
   *
   * ```javascript
   * button.text = grid.optionalL('L{group}');
   * ```
   *
   * @param {String} text String key
   * @param {Object} [templateData] Data to supply to template if localized string is a function
   * @returns {String}
   * @category Misc
   * @internal
   */


  optionalL(text, templateData) {
    const shouldThrow = _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale;
    _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale = shouldThrow && localeRe.test(text);
    const result = this.L(text, templateData);
    _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"].throwOnMissingLocale = shouldThrow;
    return result;
  }
  /**
   * Get the global LocaleManager
   * @property {Core.localization.LocaleManager}
   * @typings { typeof LocaleManager }
   * @category Misc
   * @readonly
   */


  get localeManager() {
    return _LocaleManager_js__WEBPACK_IMPORTED_MODULE_1__["default"];
  }

});

/***/ }),

/***/ "./lib/Core/mixin/Delayable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Delayable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'taskboard';



const {
  defineProperty
} = Reflect;
let performance;

if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isBrowserEnv) {
  performance = window.performance;
} else {
  performance = {
    now() {
      return new Date().getTime();
    }

  };
}
/**
 * @module Core/mixin/Delayable
 */
// Global timeout collections for tests


let globalDelays = null;

if (_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isTestEnv) {
  const bryntum = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].global.bryntum || (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].global.bryntum = {});
  globalDelays = bryntum.globalDelays = {
    timeouts: new Map(),
    intervals: new Map(),
    animationFrames: new Map(),

    isEmpty(includeIntervals = false) {
      return globalDelays.timeouts.size + globalDelays.animationFrames.size + (includeIntervals ? globalDelays.intervals.size : 0) === 0;
    }

  };
}

const
/**
 * Creates and returns a function that will call the user-supplied `fn`.
 *
 * @param {Core.mixin.Delayable} me
 * @param {Function} fn The user function to call when the timer fires.
 * @param {Function} wrapFn The function the user will call to start the timer.
 * @param {Object} options The invoke options.
 * @param {Array} [options.appendArgs] The argument list to append to those passed to the function.
 * @param {Object} [options.thisObj] The `this` reference for `fn`.
 * @returns {Function}
 * @private
 */
makeInvoker = (me, fn, wrapFn, options) => {
  const named = typeof fn === 'string',
        appendArgs = options && options.appendArgs || [],
        // The invoker fn is intended to be wired directly to native setTimeout/requestAnimationFrame/etc and so
  // it does not receive any arguments worth passing on to the user's fn. Those come from the original call
  // to the wrapFn.
  invoker = () => {
    wrapFn.timerId = null;
    wrapFn.lastCallTime = performance.now(); // Grab args now and null the stored args out (to avoid leaks):

    const args = wrapFn.args;
    wrapFn.args = null;

    if (named) {
      me[fn](...args, ...appendArgs);
    } else {
      fn.call(me, ...args, ...appendArgs);
    }

    wrapFn.called = true;
    ++wrapFn.calls;
  };

  if (options) {
    me = options.thisObj || me;
  } // We put most everything as properties on the wrapFn so that it can all be inspected in the debugger (unlike
  // closure variables) and expected in tests.


  wrapFn.lastCallTime = -9e9; // performance.now() = 0 at start...

  wrapFn.calls = 0;
  wrapFn.invoker = invoker;
  invoker.wrapFn = wrapFn;
  return invoker;
},

/**
 * Decorates the supported `wrapFn` with additional methods and an `isPending` readonly
 * property. These decorations are available to user code to help manage the scheduling
 * behavior of the buffered function.
 *
 * @param {Core.mixin.Delayable} me
 * @param {Function} wrapFn The function the user will call to start the timer.
 * @param {String} cancelFn The name of the function that will cancel a timer.
 * @returns {Function} The `wrapFn` is returned.
 * @private
 */
decorateWrapFn = (me, wrapFn, cancelFn = 'clearTimeout') => {
  wrapFn.cancel = () => {
    if (wrapFn.isPending) {
      me[cancelFn](wrapFn.timerId); // avoid leaks and cleanup:

      wrapFn.args = wrapFn.timerId = null;
    }
  };

  wrapFn.flush = () => {
    if (wrapFn.isPending) {
      me[cancelFn](wrapFn.timerId);
      wrapFn.timerId = null; // we don't call cancel() since it also sets args=null

      wrapFn.invoker();
    }
  };

  wrapFn.now = (...args) => {
    wrapFn.cancel();
    wrapFn.args = args;
    wrapFn.invoker();
  };

  wrapFn.resume = all => {
    const n = wrapFn.suspended;
    wrapFn.suspended = all || n < 1 ? 0 : n - 1;
  };

  wrapFn.suspend = () => {
    ++wrapFn.suspended;
  };

  wrapFn.immediate = false;
  wrapFn.suspended = 0;
  wrapFn.timerId = null;
  defineProperty(wrapFn, 'isPending', {
    get() {
      return wrapFn.timerId !== null;
    }

  });
  return wrapFn;
};
/**
 * Tracks setTimeout, setInterval and requestAnimationFrame calls and clears them on destroy.
 *
 * @example
 * someClass.setTimeout(() => console.log('hi'), 200);
 * someClass.setInterval(() => console.log('annoy'), 100);
 * // can also use named timeouts for easier tracking
 * someClass.setTimeout(() => console.log('named'), 300, 'named');
 * someClass.clearTimeout('named');
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class Delayable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Delayable';
  }

  static get declarable() {
    return [
    /**
     * This class property returns an object that specifies methods to wrap with configurable timer behaviors.
     *
     * It is used like so:
     * ```
     *  class Foo extends Delayable() {
     *      static get delayable() {
     *          return {
     *              expensiveMethod : 500
     *          };
     *      }
     *
     *      expensiveMethod() {
     *          this.things();
     *          this.moreThings();
     *          this.evenMoreThings();
     *      }
     *  }
     * ```
     * With the above in place, consider:
     * ```
     *  let instance = new Foo();
     *
     *  instance.expensiveMethod();
     * ```
     * Instead of the above code immediately calling the `expensiveMethod()`, it will start a timer that will
     * invoke the method 500ms later. Because `expensiveMethod()` is an instance method, each instance of `Foo`
     * will have its own timer.
     *
     * NOTE: Only instance methods are currently supported (i.e., only non-`static` methods).
     *
     * #### Options
     * The value of each key configures how the method will be scheduled. If the value is a number, it is
     * promoted to a config object of `type='buffer'` as in the following:
     * ```
     *  class Foo extends Delayable() {
     *      static get delayable() {
     *          return {
     *              expensiveMethod : {
     *                  type  : 'buffer',
     *                  delay : 500
     *              }
     *          };
     *      }
     *  });
     * ```
     * The `type` property of the config object must be one of three values. Other options can be provided
     * depending on the `type`:
     *
     *  - `buffer`<br>
     *    Other options:
     *     - `delay` (Number) : The number of milliseconds to wait before calling the underlying method. A
     *       value of 0 is equivalent to setting `immediate: true`.
     *     - `immediate` (Boolean) : Set to `true` to call immediately (effectively disabling the buffer).
     *  - `raf` (short for "request animation frame")<br>
     *    Other options:
     *     - `cancelOutstanding` (Boolean) : Set to `true` to cancel any pending animation frame requests and
     *       schedule a new one on each call.
     *     - `immediate` (Boolean) : Set to `true` to call immediately.
     *  - `throttle`<br>
     *    Other options:
     *     - `delay` (Number) : The number of milliseconds to wait after each execution before another
     *       execution takes place. A value of 0 is equivalent to setting `immediate: true`.
     *     - `immediate` (Boolean) : Set to `true` to call immediately (effectively disabling the throttle).
     *
     * While `immediate: true` can be specified at the class level, it is more typical to set it on the
     * instance's method as described below.
     *
     * #### Delayable Method API
     * Delayable methods have a consistent API to manage their scheduling. This API is added to the methods
     * themselves.
     *
     * For example:
     * ```
     *  let instance = new Foo();
     *
     *  instance.expensiveMethod();         // schedule a call in 500ms
     *  instance.expensiveMethod.isPending; // true
     *  instance.expensiveMethod.cancel();
     *  instance.expensiveMethod.flush();
     *  instance.expensiveMethod.now();
     *
     *  instance.expensiveMethod.delay = 10;
     *  instance.expensiveMethod();         // schedule a call in 10ms
     * ```
     *
     * ##### `isPending` (Boolean, readonly)
     * This boolean property will be `true` if a call has been scheduled, and false otherwise.
     *
     * ##### `cancel()`
     * Cancels a pending call if one has been scheduled. Otherwise this method does nothing.
     *
     * ##### `flush()`
     * Cancels the timer and causes the pending call to execute immediately. If there is no pending call, this
     * method does nothing.
     *
     * ##### `now()`
     * Cancels the timer (if one is pending) and executes the method immediately. If there is no pending call,
     * this method will still call the underlying method.
     *
     * @static
     * @member {Object} delayable
     * @internal
     */
    'delayable'];
  }

  doDestroy() {
    const me = this; // Normally one would expect this call at the end of this method... but in this case we need to run cleanup
    // of this stuff after config nullification since those can trigger delayable method calls.

    super.doDestroy();

    if (me.timeoutIds) {
      me.timeoutIds.forEach((fn, id) => {
        if (typeof fn === 'function') {
          fn();
        }

        clearTimeout(id);

        if (globalDelays) {
          globalDelays.timeouts.delete(id);
        }
      });
      me.timeoutIds = null;
    }

    if (me.timeoutMap) {
      me.timeoutMap.forEach((name, id) => clearTimeout(id));
      me.timeoutMap = null;
    }

    if (me.intervalIds) {
      me.intervalIds.forEach(id => {
        clearInterval(id);

        if (globalDelays) {
          globalDelays.intervals.delete(id);
        }
      });
      me.intervalIds = null;
    }

    if (me.animationFrameIds) {
      me.animationFrameIds.forEach(id => {
        cancelAnimationFrame(id);

        if (globalDelays) {
          globalDelays.animationFrames.delete(id);
        }
      });
      me.animationFrameIds = null;
    }
  }
  /**
   * Check if a named timeout is active
   * @param name
   * @internal
   */


  hasTimeout(name) {
    return !!(this.timeoutMap && this.timeoutMap.has(name));
  }
  /**
   * Same as native setTimeout, but will be cleared automatically on destroy. If a propertyName is supplied it will
   * be used to store the timeout id.
   * @param {Object} timeoutSpec An object containing the details about that function, and the time delay.
   * @param {Function|String} timeoutSpec.fn The function to call, or name of function in this object to call. Used as the `name` parameter if a string.
   * @param {Number} timeoutSpec.delay The milliseconds to delay the call by.
   * @param {Object[]} timeoutSpec.args The arguments to pass.
   * @param {String} [timeoutSpec.name] The name under which to register the timer. Defaults to `fn.name`.
   * @param {Boolean} [timeoutSpec.runOnDestroy] Pass `true` if this function should be executed if the Delayable instance is destroyed while function is scheduled.
   * @param {Boolean} [timeoutSpec.cancelOutstanding] Pass `true` to cancel any outstanding invocation of the passed function.
   * @returns {Number}
   * @internal
   */


  setTimeout({
    fn,
    delay,
    name,
    runOnDestroy,
    cancelOutstanding,
    args
  }) {
    if (arguments.length > 1 || typeof arguments[0] === 'function') {
      [fn, delay, name, runOnDestroy] = arguments;
    }

    if (typeof fn === 'string') {
      name = fn;
    } else if (!name) {
      name = fn.name;
    }

    if (cancelOutstanding) {
      this.clearTimeout(name);
    }

    const me = this,
          timeoutIds = me.timeoutIds || (me.timeoutIds = new Map()),
          timeoutMap = me.timeoutMap || (me.timeoutMap = new Map()),
          timeoutId = setTimeout(() => {
      if (typeof fn === 'string') {
        fn = me[name];
      } // Cleanup before invocation in case fn throws


      timeoutIds && timeoutIds.delete(timeoutId);
      timeoutMap && timeoutMap.delete(name);
      globalDelays && globalDelays.timeouts.delete(timeoutId);
      fn.apply(me, args);
    }, delay);
    timeoutIds.set(timeoutId, runOnDestroy ? fn : true);

    if (globalDelays) {
      globalDelays.timeouts.set(timeoutId, {
        fn,
        delay,
        name
      });
    }

    if (name) {
      timeoutMap.set(name, timeoutId);
    }

    return timeoutId;
  }
  /**
   * clearTimeout wrapper, either call with timeout id as normal clearTimeout or with timeout name (if you specified
   * a name to setTimeout())
   * property to null.
   * @param {Number|String} idOrName timeout id or name
   * @internal
   */


  clearTimeout(idOrName) {
    let id = idOrName;

    if (typeof id === 'string') {
      if (this.timeoutMap) {
        id = this.timeoutMap.get(idOrName);
        this.timeoutMap.delete(idOrName);
      } else {
        return;
      }
    }

    clearTimeout(id);
    this.timeoutIds && this.timeoutIds.delete(id);
    globalDelays && globalDelays.timeouts.delete(id);
  }
  /**
   * clearInterval wrapper
   * @param {Number} id
   * @internal
   */


  clearInterval(id) {
    clearInterval(id);
    this.intervalIds && this.intervalIds.delete(id);
    globalDelays && globalDelays.intervals.delete(id);
  }
  /**
   * Same as native setInterval, but will be cleared automatically on destroy
   * @param fn
   * @param delay
   * @returns {Number}
   * @internal
   */


  setInterval(fn, delay) {
    const intervalId = setInterval(fn, delay);
    (this.intervalIds || (this.intervalIds = new Set())).add(intervalId);
    globalDelays && globalDelays.intervals.set(intervalId, {
      fn,
      delay
    });
    return intervalId;
  }
  /**
   * Relays to native requestAnimationFrame and adds to tracking to have call automatically canceled on destroy.
   * @param {Function} fn
   * @param {Object[]} [extraArgs] The argument list to append to those passed to the function.
   * @param {Object} [thisObj] `this` reference for the function.
   * @returns {Number}
   * @internal
   */


  requestAnimationFrame(fn, extraArgs = [], thisObj = this) {
    const animationFrameIds = this.animationFrameIds || (this.animationFrameIds = new Set()),
          frameId = requestAnimationFrame(() => {
      globalDelays && globalDelays.animationFrames.delete(frameId);
      animationFrameIds.delete(frameId);
      return fn.apply(thisObj, extraArgs);
    });
    animationFrameIds.add(frameId);
    globalDelays && globalDelays.animationFrames.set(frameId, {
      fn,
      extraArgs,
      thisObj
    });
    return frameId;
  }
  /**
   * Creates a function which will execute once, on the next animation frame. However many time it is
   * called in one event run, it will only be scheduled to run once.
   * @param {Function|String} fn The function to call, or name of function in this object to call.
   * @param {Object[]} [args] The argument list to append to those passed to the function.
   * @param {Object} [thisObj] `this` reference for the function.
   * @param {Boolean} [cancelOutstanding] Cancel any outstanding queued invocation upon call.
   * @internal
   */


  createOnFrame(fn, args = [], thisObj = this, cancelOutstanding) {
    let rafId;

    const result = (...callArgs) => {
      // Cancel if outstanding if requested
      if (rafId && cancelOutstanding) {
        this.cancelAnimationFrame(rafId);
        rafId = null;
      }

      if (!rafId) {
        rafId = this.requestAnimationFrame(() => {
          if (typeof fn === 'string') {
            fn = thisObj[fn];
          }

          rafId = null;
          callArgs.push(...args);
          fn.apply(thisObj, callArgs);
        });
      }
    };

    result.cancel = () => this.cancelAnimationFrame(rafId);

    return result;
  }
  /**
   * Relays to native cancelAnimationFrame and removes from tracking.
   * @param {Number} handle
   * @internal
   */


  cancelAnimationFrame(handle) {
    cancelAnimationFrame(handle);
    this.animationFrameIds && this.animationFrameIds.delete(handle);
    globalDelays && globalDelays.animationFrames.delete(handle);
  }

  async nextAnimationFrame() {
    return new Promise(resolve => this.requestAnimationFrame(resolve));
  }
  /**
   * Wraps a function with another function that delays it specified amount of time, repeated calls to the wrapper
   * resets delay.
   * @param {Function|String} fn The function to call. If this is a string, it is looked up as a method on `this`
   * instance (or `options.thisObj` instead, if provided).
   * @param {Object|Number} options The delay in milliseconds or an options object.
   * @param {Number} options.delay The delay in milliseconds.
   * @param {Array} [options.appendArgs] The argument list to append to those passed to the function.
   * @param {Object} [options.thisObj] The `this` reference for the function.
   * @returns {Function} Wrapped function to call.
   * @internal
   */


  buffer(fn, options) {
    let delay = options;

    if (options && typeof options !== 'number') {
      // if (config object)
      delay = options.delay;
    } else {
      options = null;
    }

    const bufferWrapFn = (...params) => {
      if (bufferWrapFn.suspended) {
        return;
      }

      const {
        delay
      } = bufferWrapFn;
      bufferWrapFn.cancel();
      bufferWrapFn.called = false;
      bufferWrapFn.args = params; // If delay=0, the buffer has been disabled so always call immediately.

      if (bufferWrapFn.immediate || !delay) {
        invoker();
      } else {
        bufferWrapFn.timerId = this.setTimeout(invoker, delay);
      }
    },
          invoker = makeInvoker(this, fn, bufferWrapFn, options);

    bufferWrapFn.delay = delay;
    return decorateWrapFn(this, bufferWrapFn);
  }
  /**
   * Returns a function that when called will schedule a call to `fn` on the next animation frame.
   *
   * @param {Function|String} fn The function to call. If this is a string, it is looked up as a method on `this`
   * instance (or `options.thisObj` instead, if provided).
   * @param {Boolean|Object} [options] An options object or the `cancelOutstanding` boolean property of it.
   * @param {Boolean} [options.cancelOutstanding] Pass `true` to cancel any pending animation frame requests and
   * schedule a new one on each call to the returned function.
   * @param {Array} [options.appendArgs] The argument list to append to those passed to the function.
   * @param {Object} [options.thisObj] The `this` reference for the function.
   * @returns {Function}
   * @internal
   */


  raf(fn, options) {
    // NOTE: This method is only intended for use with `delayable`. It has a signature that is compatible
    // with `buffer()` and `throttle()`. The name is 'raf' to make the following aesthetically pleasing:
    //
    //  class Foo extends Delayable() {
    //      static get delayable() {
    //          return {
    //              bar : 'raf'
    //          };
    //      }
    //  }
    let cancelOutstanding = options;

    if (options && typeof options !== 'boolean') {
      // if (config object)
      cancelOutstanding = options.cancelOutstanding;
    } else {
      options = null;
    }

    const rafWrapFn = (...params) => {
      if (rafWrapFn.suspended) {
        return;
      } // Reschedule the frame on each call if requested


      if (rafWrapFn.cancelOutstanding) {
        rafWrapFn.cancel();
      }

      rafWrapFn.called = false;
      rafWrapFn.args = params;

      if (rafWrapFn.immediate) {
        invoker();
      } else if (!rafWrapFn.isPending) {
        rafWrapFn.timerId = this.requestAnimationFrame(invoker);
      }
    },
          invoker = makeInvoker(this, fn, rafWrapFn, options);

    rafWrapFn.cancelOutstanding = cancelOutstanding;
    return decorateWrapFn(this, rafWrapFn, 'cancelAnimationFrame');
  }
  /**
   * Create a "debounced" function which will call on the "leading edge" of a timer period.
   * When first invoked will call immediately, but invocations after that inside its buffer
   * period will be rejected, and *one* invocation will be made after the buffer period has expired.
   *
   * This is useful for responding immediately to a first mousemove, but from then on, only
   * calling the action function on a regular timer while the mouse continues to move.
   *
   * @param {Function|String} fn The function to call. If this is a string, it is looked up as a method on `this`
   * instance (or `options.thisObj` instead, if provided).
   * @param {Number|Object} options The milliseconds to wait after each execution before another execution takes place
   * or a object containing options.
   * @param {Object} [options.thisObj] `this` reference for the function.
   * @param {Array} [options.appendArgs] The argument list to append to those passed to the function.
   * @param {Function|String} [options.throttled] A function to call when the invocation is delayed due to buffer
   * time not having expired. If this is a string, it is looked up as a method on `this` instance (or `options.thisObj`
   * instead, if provided). When called, the same arguments are passed as would have been passed to `fn`, including
   * any `options.appendArgs`.
   * @internal
   */


  throttle(fn, options) {
    let delay = options,
        throttled;

    if (options && typeof options !== 'number') {
      // if (config object)
      delay = options.delay;
      throttled = options.throttled;
    } else {
      options = null;
    }

    const me = this,
          throttleWrapFn = (...args) => {
      if (throttleWrapFn.suspended) {
        return;
      }

      const {
        delay
      } = throttleWrapFn,
            elapsed = performance.now() - throttleWrapFn.lastCallTime;
      throttleWrapFn.args = args; // If it's been more then the delay period since we invoked, we can call it now.
      // Setting delay=0 effectively disables the throttle (which is the goal)

      if (throttleWrapFn.immediate || elapsed >= delay) {
        me.clearTimeout(throttleWrapFn.timerId);
        invoker();
      } else {
        // Kick off a timer for the requested period.
        if (!throttleWrapFn.isPending) {
          throttleWrapFn.timerId = me.setTimeout(invoker, delay - elapsed);
          throttleWrapFn.called = false;
        }

        if (throttled) {
          // Args have to be stored on the wrapFn for the invoker to pick them up:
          throttled.wrapFn.args = args;
          throttled();
        }
      }
    },
          invoker = makeInvoker(me, fn, throttleWrapFn, options);

    throttleWrapFn.delay = delay;

    if (throttled) {
      // Make an invoker for this callback to handle thisObj and typeof=string etc (pass a dud wrapFn):
      throttled = makeInvoker(me, throttled, () => {}, options);
    }

    return decorateWrapFn(me, throttleWrapFn);
  }

  static setupDelayable(cls) {
    cls.setupDelayableMethods(cls.delayable);
  }
  /**
   * This method initializes the `delayable` methods on this class.
   * @param {Object} delayable The `delayable` property.
   * @param {Function} [cls] This parameter will be used internally to process static methods.
   * @private
   */


  static setupDelayableMethods(delayable, cls = null) {
    const me = this,
          statics = delayable.static,
          target = cls || me.prototype;

    if (statics) {
      // TODO me.setupDelayableMethods(statics, me);
      delete delayable.static;
    }

    for (const name in delayable) {
      let options = delayable[name];
      const implName = name + 'Now',
            type = typeof options;
      target[implName] = target[name];

      if (type === 'number') {
        options = {
          type: 'buffer',
          delay: options
        };
      } else if (type === 'string') {
        options = {
          type: options
        };
      } // For instance methods, we place a getter on the prototype. When the method is first accessed from the
      // prototype, we create an instance-specific version by calling this.buffer()/throttle() (based on the type
      // desired) and set that as the instance-level property.


      defineProperty(target, name, {
        get() {
          const value = this[options.type]((...params) => {
            this[implName](...params);
          }, options);
          defineProperty(this, name, {
            value
          });
          return value;
        }

      });
    }
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Core/mixin/Draggable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Draggable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _util_drag_DragContext_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/drag/DragContext.js */ "./lib/Core/util/drag/DragContext.js");
/* harmony import */ var _util_drag_DragProxy_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/drag/DragProxy.js */ "./lib/Core/util/drag/DragProxy.js");
var productName = 'taskboard';






/**
 * @module Core/mixin/Draggable
 */

/**
 * Mix this into another class to enable drag/drop support.
 *
 * To use a draggable, it must be associated with an element that contains draggable content:
 *
 * ```javascript
 *  let draggable = new MyDraggable({
 *      dragRootElement : someElement
 *  });
 * ```
 *
 * Once the `dragRootElement` is assigned, any element inside that root is a candidate for dragging. To limit the
 * allowed element, set the {@link #config-dragSelector} config.
 *
 * ```javascript
 *  let draggable = new MyDraggable({
 *      dragRootElement : someElement,
 *      dragSelector    : '.drag-this'
 *  });
 * ```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Draggable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Draggable';
  } //region Configs


  static get configurable() {
    return {
      /**
       * The current `DragContext`. This is created immediately on pointerdown but does not become active until
       * some movement occurs. This {@link #config-dragThreshold threshold} is configurable.
       * @member {Core.util.drag.DragContext}
       * @readonly
       */
      dragging: {
        $config: 'nullify',
        value: null
      },

      /**
       * A CSS selector to use to ascend from the {@link #config-dragRootElement} to find the element that will
       * gain the {@link #property-draggingCls} and {@link #property-draggingStartedCls} CSS classes.
       * @config {String}
       */
      draggingClsSelector: null,

      /**
       * The listeners to add to the `document` during a drag.
       * @config {Object}
       * @private
       */
      dragDocumentListeners: {
        element: document,
        keydown: 'onDragKeyDown',
        keyup: 'onDragKeyUp',
        // On mobile, a long-press will (sometimes) trigger a context menu, so we suppress it:
        contextmenu: 'onDragContextMenu',
        // We don't use pointermove/up because they get snared in the "touch-action" vs "pan-x/y" trap and we
        // cannot prevent panning (aka scrolling) in response to move events if we go that way:
        mousemove: 'onDragPointerMove',
        mouseup: 'onDragPointerUp',
        // Touch desktops don't fire touchend event when touch has ended, instead pointerup is fired. iOS does
        // fire touchend:
        pointerup: 'onDragPointerUp',
        touchend: 'onDragPointerUp',
        touchmove: {
          handler: 'onDragPointerMove',
          passive: false // We need to be able to preventDefault on the touchmove

        }
      },

      /**
       * A CSS selector to use to ascend from the drag element to find the element that will gain the
       * {@link #property-draggingItemCls} CSS class. If not supplied, the drag element will gain this CSS
       * class.
       * @config {String}
       */
      dragItemSelector: null,

      /**
       * A CSS class to add to items identified by the {@link #config-dragItemSelector} when the mouse
       * enters.
       * @config {String}
       */
      dragItemOverCls: null,

      /**
       * A function to call when the pointer enters a {@link #config-dragItemSelector}.
       * @config {Function} onDragItemMouseEnter
       */

      /**
       * A function to call when the pointer moves inside a {@link #config-dragItemSelector}.
       * @config {Function} onDragItemMouseMove
       */

      /**
       * A function to call when the pointer leaves a {@link #config-dragItemSelector}.
       * @config {Function} onDragItemMouseLeave
       */

      /**
       * Configure as `'x'` to lock dragging to the `X` axis (the drag will only move horizontally) or `'y'`
       * to lock dragging to the `Y` axis (the drag will only move vertically).
       * @config {String}
       */
      dragLock: null,

      /**
       * The minimum distance a drag must move to be considered a drop and not
       * {@link Core.util.drag.DragContext#property-aborted aborted}.
       * @config {Number}
       * @default
       */
      dragMinDistance: 1,

      /**
       * The {@link Core.util.drag.DragProxy drag proxy} is a helper object that can be used to display feedback
       * during a drag.
       * @config {Object|Core.util.drag.DragProxy}
       */
      dragProxy: {
        $config: ['lazy', 'nullify'],
        value: null
      },

      /**
       * The outer element where dragging will operate (attach events to it and use as root limit when looking
       * for ancestors).
       * @config {HTMLElement}
       */
      dragRootElement: {
        $config: 'nullify',
        value: null
      },

      /**
       * Set to `true` to allow a drag to drop on to the same element from which the drag started.
       * @config {Boolean}
       * @default
       */
      dragSameTargetDrop: false,

      /**
       * A CSS selector used to determine which element(s) can be dragged.
       * @config {String}
       * @default
       */
      dragSelector: null,

      /**
       * The number of milliseconds after a pointerup to ignore click events on the document. This
       * is used to avoid the "up" event itself generating a `click` on the target.
       * @config {Number}
       * @default
       */
      dragSwallowClickTime: 50,

      /**
       * The amount of pixels to move pointer/mouse before it counts as a drag operation.
       * @config {Number}
       * @default
       */
      dragThreshold: 5,

      /**
       * The number of milliseconds that must elapse after a `touchstart` event before it is considered a drag. If
       * movement occurs before this time, the drag is aborted. This is to allow touch swipes and scroll gestures.
       * @config {Number}
       * @default
       */
      dragTouchStartDelay: 300,

      /**
       * The CSS selector to use to identify the closest valid target from the event target.
       * @config {String}
       */
      dropTargetSelector: null,

      /**
       * The {@link #config-dragSelector} item the mouse is currently over.
       * @member {HTMLElement} overItem
       * @readonly
       */
      overItem: null,
      testConfig: {
        // In Edge synthetic click events are fired asynchronously and can take considerable
        // amount of time. Setting larger click swallow timeout to make sure Edge has time to fire click event.
        // Caught by test EventDrag4.t in Edge
        dragSwallowClickTime: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge ? 300 : 50
      }
    };
  }

  static get properties() {
    return {
      /**
       * The CSS class to add to the {@link #config-dragRootElement} (or {@link #config-draggingClsSelector} from
       * there) as soon as the pointerdown event occurs.
       * @member {String}
       * @readonly
       */
      draggingCls: 'b-draggable-active',

      /**
       * The CSS class to add to the `body` element as soon as the {@link #config-dragThreshold} is reached and
       * an actual drag is in progress.
       * @member {String}
       * @readonly
       */
      draggingBodyCls: 'b-draghelper-active',
      // match DragHelper since we need the same treatment

      /**
       * The CSS class to add to the element being dragged as soon as the pointerdown event occurs.
       * @member {String}
       * @readonly
       */
      draggingItemCls: 'b-dragging-item',

      /**
       * The CSS class to add to the {@link #config-dragRootElement} (or {@link #config-draggingClsSelector} from
       * there) as soon as the {@link #config-dragThreshold} is reached and an actual drag is in progress.
       * @member {String}
       * @readonly
       */
      draggingStartedCls: 'b-draggable-started',

      /**
       * The CSS class that is added to the {@link #config-dragRootElement}, i.e., `'b-draggable'`.
       * @property {String}
       * @readonly
       */
      draggableCls: 'b-draggable'
    };
  } //endregion
  //region Drag Processing
  // These template methods are implemented by derived classes as desired. There is only one overlap with Droppable's
  // template methods (dragDrop) so that a class can easily mixin both Draggable and Droppable and always distinguish
  // whether it is acting as the source, the target, or both.

  /**
   * This template method is called when the mousedown of a potential drag operation occurs. This happens before the
   * gesture is known to be a drag, meaning the {@link #config-dragThreshold} has not been reached. This method
   * should initialize the {@link Core.util.drag.DragContext} using the {@link Core.util.drag.DragContext#function-set}
   * method. Alternatively, this method may return `false` to prevent the drag operation.
   *
   * *Important:* Because no drag has occurred at the time this method is called, only minimal processing should be
   * done (such as initializing the {@link Core.util.drag.DragContext}). Anything more should be done in the
   * {@link #function-dragStart} method or in response to the {@link #event-dragStart} event which happen only if
   * the user drags the mouse before releasing the mouse button.
   * @param {Core.util.drag.DragContext} drag
   */


  beforeDrag(drag) {
    const {
      dragRootElement,
      dragSelector
    } = this,
          target = dragSelector && drag.element.closest(dragSelector);
    return !dragSelector || Boolean(target && target === dragRootElement || dragRootElement.contains(target));
  }
  /**
   * This template method is called when the drag operation starts. This occurs when the {@link #config-dragThreshold}
   * has been reached.
   * Your implementation may return `false` to prevent the startup of the drag operation.
   * @param {Core.util.drag.DragContext} drag
   */


  dragStart(drag) {// template
  }
  /**
   * This template method is called as the drag moves. This occurs on each mouse/pointer/touchmove event.
   * @param {Core.util.drag.DragContext} drag
   */


  dragOver(drag) {// template
  }
  /**
   * This template method is called when the drag enters a {@link Core.mixin.Droppable target}.
   * @param {Core.util.drag.DragContext} drag
   */


  dragEnterTarget(drag) {// template
  }
  /**
   * This template method is called when the drag leaves a {@link Core.mixin.Droppable target}.
   * @param {Core.util.drag.DragContext} drag
   * @param {Core.mixin.Droppable} oldTarget The previous value of `drag.target`.
   */


  dragLeaveTarget(drag, oldTarget) {// template
  }
  /**
   * This template method is called when the drag operation completes. This occurs on the pointerup event.
   *
   * This method is not called if the drag is {@link Core.util.drag.DragContext#property-aborted aborted}.
   * @param {Core.util.drag.DragContext} drag
   */


  dragDrop(drag) {// template
  }
  /**
   * This template method is called when the drag operation completes. This occurs on the pointerup event or perhaps
   * a keypress event.
   *
   * This method is always called, even if the drag is {@link Core.util.drag.DragContext#property-aborted aborted}.
   * @param {Core.util.drag.DragContext} drag
   */


  dragEnd(drag) {// template
  } //endregion
  //region Drag Management
  // These methods are called by the DragContext and generally manage element updates (adding/removing classes) or
  // event firing. In most cases these methods then call a corresponding Drag Processing template method intended
  // for derived classes to implement.


  get activeDrag() {
    const {
      dragging: drag
    } = this;
    return drag !== null && drag !== void 0 && drag.started && !drag.completed ? drag : null;
  }
  /**
   * Return the `Events` instance from which drag events are fired.
   * @internal
   * @property {Core.mixin.Events}
   */


  get dragEventer() {
    return this.trigger ? this : null; // simple Events feature detector
  }

  get draggingClassElement() {
    const {
      draggingClsSelector,
      dragRootElement
    } = this;
    return draggingClsSelector ? dragRootElement === null || dragRootElement === void 0 ? void 0 : dragRootElement.closest(draggingClsSelector) : dragRootElement;
  }

  beginDrag(drag) {
    const {
      draggingCls,
      draggingClassElement
    } = this;

    if (draggingCls && draggingClassElement) {
      draggingClassElement.classList.add(draggingCls);
      drag.cleaners.push(() => draggingClassElement.classList.remove(draggingCls));
    }
  }

  async endDrag(drag) {
    const me = this,
          {
      dragEventer,
      dragProxy
    } = me;

    if (drag.valid) {
      // The implementation may be async. If so, any Promise must always be
      // propagated back to a point which may have to await it
      await me.dragDrop(drag);
    }

    if (me.isDestroyed) {
      return;
    }

    if (drag.pending) {
      drag.destroy();
    } else {
      me.dragEnd(drag);
      dragProxy === null || dragProxy === void 0 ? void 0 : dragProxy.dragEnd(drag);
      /**
       * This event is fired when a drag gesture is completed due to the user aborting it (with the `ESC` key) or
       * if the {@link Core.util.drag.DragContext#function-abort} method was called.
       * @event dragCancel
       * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
       * @param {Core.util.drag.DragContext} drag The drag context.
       * @param {Event} event The browser event.
       */

      /**
       * This event is fired when a drag gesture is completed successfully.
       *
       * This event is **not** fired if the drag was aborted by the user pressing the `ESC` key or if the
       * {@link Core.util.drag.DragContext#function-abort} method was called.
       * @event drop
       * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
       * @param {Core.util.drag.DragContext} drag The drag context.
       * @param {Event} event The browser event.
       */

      dragEventer === null || dragEventer === void 0 ? void 0 : dragEventer.trigger(drag.valid ? 'drop' : 'dragCancel', {
        drag,
        event: drag.event
      }); // The drag context could have registered finalizers added by the above methods or event. If so, we need to
      // wait for finalization of the drag before we clear our "dragging" config.

      me.finalizeDrag(drag);
    }
  }

  async finalizeDrag(drag) {
    await drag.finalize(); // The doFinalize() method of DragContext is called by the above await... which nulls our "dragging" config
  }

  moveDrag(drag) {
    if (this.dragOver(drag) !== false) {
      const {
        dragEventer,
        dragProxy
      } = this;
      dragProxy === null || dragProxy === void 0 ? void 0 : dragProxy.dragMove(drag);
      /**
       * This event is fired as a drag gesture progresses due to cursor movement.
       * @event drag
       * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
       * @param {Core.util.drag.DragContext} drag The drag context.
       * @param {Event} event The browser event.
       */

      dragEventer === null || dragEventer === void 0 ? void 0 : dragEventer.trigger('drag', {
        drag,
        event: drag.event
      });
    }
  }

  setupDragContext(event) {
    const me = this,
          {
      dragItemSelector,
      id
    } = me,
          {
      target
    } = event;
    return {
      event,
      id: id ? `${id}-drag-${me._nextDragId = (me._nextDragId || 0) + 1}` : null,
      itemElement: dragItemSelector ? target.closest(dragItemSelector) : target,
      touchStartDelay: me.dragTouchStartDelay,
      source: me,
      threshold: me.dragThreshold
    };
  }

  startDrag(drag) {
    const {
      draggingStartedCls,
      draggingClassElement,
      draggingItemCls,
      dragEventer,
      dragProxy
    } = this,
          {
      itemElement
    } = drag;
    /**
     * This event is fired prior to starting a drag gesture. This does not occur immediately after the user
     * performs the pointer/mousedown/touchstart but only after the {@link #config-dragThreshold} amount of
     * movement has taken place.
     *
     * The drag is canceled if a listener returns `false`.
     * @event beforeDragStart
     * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
     * @param {Core.util.drag.DragContext} drag The drag context.
     * @param {Event} event The browser event.
     * @preventable
     */

    if ((dragEventer === null || dragEventer === void 0 ? void 0 : dragEventer.trigger('beforeDragStart', {
      drag,
      event: drag.event
    })) === false) {
      return false;
    }

    if (draggingStartedCls && draggingClassElement) {
      draggingClassElement.classList.add(draggingStartedCls);
      drag.cleaners.push(() => draggingClassElement.classList.remove(draggingStartedCls));
    }

    if (draggingItemCls && itemElement) {
      itemElement.classList.add(draggingItemCls);
      drag.cleaners.push(() => itemElement.classList.remove(draggingItemCls));
    }

    dragProxy === null || dragProxy === void 0 ? void 0 : dragProxy.dragStart(drag);
    const result = this.dragStart(drag);

    if (result !== false) {
      /**
       * This event is fired when a drag gesture has started. This does not occur immediately after the user
       * performs the pointer/mousedown/touchstart but only after the {@link #config-dragThreshold} amount of
       * movement has taken place.
       * @event dragStart
       * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
       * @param {Core.util.drag.DragContext} drag The drag context.
       * @param {Event} event The browser event.
       */
      dragEventer === null || dragEventer === void 0 ? void 0 : dragEventer.trigger('dragStart', {
        drag,
        event: drag.event
      });
    }

    return result;
  }

  trackDrag(drag) {
    var _drag$targetElement;

    const {
      dropTargetSelector
    } = this;
    drag.valid = !(dropTargetSelector && !((_drag$targetElement = drag.targetElement) !== null && _drag$targetElement !== void 0 && _drag$targetElement.closest(dropTargetSelector)));
    this.moveDrag(drag);
  } //endregion
  //region Configs


  configureListeners(drag) {
    const me = this,
          listeners = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assign({
      thisObj: me
    }, me.dragDocumentListeners); // Only listen for the events related to how the drag was initiated:

    if ('touches' in drag.startEvent) {
      delete listeners.mousemove;
      delete listeners.mouseup;
    } else {
      delete listeners.contextmenu;
      delete listeners.touchmove;
      delete listeners.touchend;
      delete listeners.pointerup;
    }

    return listeners;
  } //endregion
  //region Configs


  updateDragging(drag) {
    const me = this;

    if (drag) {
      const listeners = me.configureListeners(drag);
      drag.cleaners.push(_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].on(listeners));
      me.beginDrag(drag);
    }
  }

  changeDragProxy(config, existing) {
    return _util_drag_DragProxy_js__WEBPACK_IMPORTED_MODULE_5__["default"].reconfigure(existing, config, {
      owner: this,
      defaults: {
        owner: this
      }
    });
  }

  updateDragRootElement(rootEl, was) {
    var _me$_dragRootDetacher;

    const me = this,
          {
      draggableCls,
      dragItemSelector,
      onDragItemMouseMove
    } = me;
    was === null || was === void 0 ? void 0 : was.classList.remove(draggableCls);
    (_me$_dragRootDetacher = me._dragRootDetacher) === null || _me$_dragRootDetacher === void 0 ? void 0 : _me$_dragRootDetacher.call(me);

    if (rootEl) {
      const listeners = {
        thisObj: me,
        element: rootEl,
        mousedown: 'onDragMouseDown',
        // We have touchstart listener in place since Siesta/Chrome can send these events even on non-touch
        // devices:
        touchstart: 'onDragTouchStart'
      };

      if (onDragItemMouseMove) {
        listeners.mousemove = {
          delegate: dragItemSelector,
          handler: 'onDragItemMouseMove'
        };
      }

      if (me.dragItemOverCls || onDragItemMouseMove || me.onDragItemMouseEnter || me.onDragItemMouseLeave) {
        Object.assign(listeners, {
          mouseover: {
            delegate: dragItemSelector,
            handler: 'onDragItemMouseOver'
          },
          mouseout: {
            delegate: dragItemSelector,
            handler: 'onDragItemMouseOut'
          }
        });
      }

      rootEl.classList.add(draggableCls);
      me._dragRootDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].on(listeners);
    }
  } //endregion
  //region Events


  onDragItemMouseOver(event) {
    this.overItem = event;
  }

  onDragItemMouseOut(event) {
    if (!this.dragging) {
      this.overItem = event;
    }
  }

  changeOverItem(event) {
    this.enterLeaveEvent = event;

    if (event.type === 'mouseout') {
      var _event$relatedTarget;

      // Must return null, not undefined to unset the overItem property
      return ((_event$relatedTarget = event.relatedTarget) === null || _event$relatedTarget === void 0 ? void 0 : _event$relatedTarget.closest(this.dragItemSelector)) || null;
    } else {
      return event.target.closest(this.dragItemSelector);
    }
  }

  updateOverItem(overItem, oldOverItem) {
    const me = this,
          {
      dragItemOverCls
    } = me;

    if (oldOverItem) {
      var _me$onDragItemMouseLe;

      dragItemOverCls && oldOverItem.classList.remove(dragItemOverCls);
      (_me$onDragItemMouseLe = me.onDragItemMouseLeave) === null || _me$onDragItemMouseLe === void 0 ? void 0 : _me$onDragItemMouseLe.call(me, me.enterLeaveEvent, oldOverItem);
    }

    if (overItem) {
      var _me$onDragItemMouseEn;

      dragItemOverCls && overItem.classList.add(dragItemOverCls);
      (_me$onDragItemMouseEn = me.onDragItemMouseEnter) === null || _me$onDragItemMouseEn === void 0 ? void 0 : _me$onDragItemMouseEn.call(me, me.enterLeaveEvent, overItem);
    }
  }

  onDragContextMenu(event) {
    event.preventDefault();
  }

  onDragKeyDown(event) {
    this.dragging.keyDown(event);
  }

  onDragKeyUp(event) {
    this.dragging.keyUp(event);
  }
  /**
   * Grab draggable element on mouse down.
   * @param {Event} event
   * @private
   */


  onDragMouseDown(event) {
    // only dragging with left mouse button
    if (event.button === 0) {
      this.onDragPointerDown(event);
    }
  }
  /**
   * Grab draggable element on pointerdown.
   * @param {Event} event
   * @private
   */


  onDragPointerDown(event) {
    let {
      dragging: drag
    } = this; // If a drag is ongoing already, finalize it and don't proceed with new drag (happens if user does pointerup
    // outside browser window). Also handles the edge case of trying to start a new drag while previous is awaiting
    // finalization, in which case it just bails out.

    if (!drag) {
      drag = this.setupDragContext(event); // The DragContext consults our beforeDrag handler, and if that succeeds, the Context injects itself into
      // this instance as our draggable ("this.dragging").
      // NOTE: This is not yet an actual drag. At this stage, the context is used to detect movement prior to
      // mouseup (aka "a drag"). Should the requisite amount of movement occur, the drag will be started.

      if (drag) {
        drag = new _util_drag_DragContext_js__WEBPACK_IMPORTED_MODULE_4__["default"](drag);

        if (drag.begin() === false) {
          drag.destroy();
        }
      }
    } else if (!drag.isFinalizing) {
      drag.abort();
    }
  } // Set by the DragContext in its begin method, and auto-nullified at destruction.


  changeDragging(value, was) {
    was === null || was === void 0 ? void 0 : was.destroy();
    return value;
  }

  onDragPointerMove(event) {
    const {
      dragging: drag
    } = this;

    if (drag && !drag.completed) {
      drag === null || drag === void 0 ? void 0 : drag.move(event);
    }
  }

  onDragPointerUp(event) {
    const {
      dragging: drag
    } = this;

    if (drag && !drag.completed) {
      drag.end(event);
      this.endDrag(drag);
    }
  }
  /**
   * @param {Event} event
   * @private
   */


  onDragTouchStart(event) {
    // only allowing one finger for now...
    if (event.touches.length === 1) {
      this.onDragPointerDown(event);
    }
  } //endregion


});

/***/ }),

/***/ "./lib/Core/mixin/Droppable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Droppable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
var productName = 'taskboard';


/**
 * @module Core/mixin/Droppable
 */

/**
 * Mix this into another class to enable drop support and receive drops from {@link Core.mixin.Draggable draggables}.
 *
 * There are 4 basic methods that a droppable implements. These methods are called as drag operations occur:
 *
 * ```javascript
 *  class MyDroppable extends Base.mixin(Droppable) {
 *      dragEnter(drag) {
 *          // a drag has entered the drop zone... create some type of drop indicator perhaps
 *      }
 *
 *      dragMove(drag) {
 *          // a drag has changed position... update drop indicators
 *      }
 *
 *      dragDrop(drag) {
 *          // drop has occurred... process data from the drag context
 *      }
 *
 *      dragLeave(drag) {
 *          // the drag has left the drop zone... cleanup indicators
 *      }
 *  }
 * ```
 *
 * Instances of `Droppable` are associated with an element to receive drag operations:
 *
 * ```javascript
 *  let target = new MyDroppable({
 *      dropRootElement : someElement
 *  });
 * ```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Droppable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Droppable';
  } //region Configs


  static get configurable() {
    return {
      /**
       * A selector, which, if specified, narrows the dropability to child elements of the
       * {@link #config-dropRootElement} which match this selector.
       * @config {String}
       */
      droppableSelector: null,

      /**
       * The current `DragContext`. This is set when a drag enters this target. Changing this config causes the
       * {@link #function-dragEnter} and {@link #function-dragLeave} methods to be called. If `dragEnter` returns
       * `false` for a drag, this value will be set to `null`.
       * @member {Core.util.drag.DragContext}
       * @readonly
       */
      dropping: null,

      /**
       * Set this config to the element where drops should be received. When set, the `b-droppable` CSS class is
       * added to the element and the `Droppable` instance is associated with that element so that it can be
       * found by {@link Core.mixin.Draggable draggables}.
       * @config {HTMLElement}
       */
      dropRootElement: {
        $config: 'nullify',
        value: null
      }
    };
  }
  /**
   * Return the `Events` instance from which drop events are fired.
   * @internal
   * @property {Core.mixin.Events}
   */


  get dropEventer() {
    return this.trigger ? this : null; // simple Events feature detector
  }
  /**
   * Returns the CSS class that is added to the {@link #config-dropRootElement}, i.e., `'b-droppable'`.
   * @property {String}
   * @readonly
   */


  get droppableCls() {
    return 'b-droppable';
  } //endregion
  //region Drop Management

  /**
   * This method is called when a drag enters this droppable's `dropRootElement`. In many cases, this method is used
   * to create some sort of drop indicator to provide user feedback.
   *
   * If this method does not return `false`, the {@link #property-dropping} config will retain the given `drag` context
   * which was set prior to this method being called.
   *
   * If this method returns `false`, the drop will not be accepted. Neither {@link #function-dragDrop} nor
   * {@link #function-dragLeave} will be called for this drop. If the drag leaves this target and re-enters, this
   * method will be called again. While `dropping` will already be updated before this method is called, it will be
   * reset to `null` in this case.
   *
   * The base class implementation of this method fires the {@link #event-dragEnter} event.
   * @param {Core.util.drag.DragContext} drag
   * @returns {Boolean}
   */


  dragEnter(drag) {
    var _this$dropEventer;

    /**
     * This event is fired when a drag enters this droppable's `dropRootElement`. It is fired by the droppable's
     * {@link #function-dragEnter} method.
     * @event dragEnter
     * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
     * @param {Core.util.drag.DragContext} drag The drag context.
     * @param {Event} event The browser event.
     */
    return (_this$dropEventer = this.dropEventer) === null || _this$dropEventer === void 0 ? void 0 : _this$dropEventer.trigger('dragEnter', {
      drag,
      event: drag.event
    });
  }
  /**
   * This method is called when the drag that was previously announced via {@link #function-dragEnter} moves to a new
   * position. This is typically where drop indicators are updated to reflect the new position.
   *
   * The base class implementation of this method fires the {@link #event-dragMove} event.
   * @param {Core.util.drag.DragContext} drag
   */


  dragMove(drag) {
    var _this$dropEventer2;

    /**
     * This event is fired when the drag that was previously announced via {@link #event-dragEnter} moves to a new
     * position. It is fired by the droppable's {@link #function-dragMove} method.
     * @event dragMove
     * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
     * @param {Core.util.drag.DragContext} drag The drag context.
     * @param {Event} event The browser event.
     */
    return (_this$dropEventer2 = this.dropEventer) === null || _this$dropEventer2 === void 0 ? void 0 : _this$dropEventer2.trigger('dragMove', {
      drag,
      event: drag.event
    });
  }
  /**
   * This method is called when the drag that was previously announced via {@link #function-dragEnter} has ended with
   * a drop. In addition to any cleanup (since {@link #function-dragLeave} will not be called), this method handles
   * any updates associated with the data from the drag context and the position of the drop.
   *
   * The base class implementation of this method fires the {@link #event-drop} event.
   * @param {Core.util.drag.DragContext} drag
   */


  dragDrop(drag) {
    var _this$dropEventer3;

    /**
     * This event is fired when the drag that was previously announced via {@link #event-dragEnter} has ended with
     * a drop. It is fired by the droppable's {@link #function-dragDrop} method.
     *
     * This event is **not** fired when a drag gesture is aborted by the user pressing the `ESC` key or if the
     * {@link Core.util.drag.DragContext#function-abort} method is called.
     * @event drop
     * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
     * @param {Core.util.drag.DragContext} drag The drag context.
     * @param {Event} event The browser event.
     */
    return (_this$dropEventer3 = this.dropEventer) === null || _this$dropEventer3 === void 0 ? void 0 : _this$dropEventer3.trigger('drop', {
      drag,
      event: drag.event
    });
  }
  /**
   * This method is called when the drag that was previously announced via {@link #function-dragEnter} leaves this
   * droppable's `dropRootElement`, or the drag is {@link Core.util.drag.DragContext#property-aborted} by the user
   * pressing the `ESC` key, or the {@link Core.util.drag.DragContext#function-abort} method is called.
   *
   * This is the time to cleanup anything created by `dragEnter`.
   *
   * The base class implementation of this method fires the {@link #event-dragLeave} event.
   * @param {Core.util.drag.DragContext} drag
   */


  dragLeave(drag) {
    var _this$dropEventer4;

    /**
     * This event is fired when the drag that was previously announced via {@link #event-dragEnter} leaves this
     * droppable's `dropRootElement`. It is fired by the droppable's {@link #function-dragLeave} method.
     * @event dragLeave
     * @param {Core.mixin.Draggable} source The draggable instance that fired the event.
     * @param {Core.util.drag.DragContext} drag The drag context.
     * @param {Event} event The browser event.
     */
    return (_this$dropEventer4 = this.dropEventer) === null || _this$dropEventer4 === void 0 ? void 0 : _this$dropEventer4.trigger('dragLeave', {
      drag,
      event: drag.event
    });
  } //endregion
  //region Configs


  changeDropping(dropping, was) {
    if (dropping !== was) {
      const me = this;

      if (was) {
        if (was.aborted || !was.completed) {
          me.dragLeave(was);
        }
      }

      if (dropping) {
        me._dropping = dropping; // update config value early in case dragEnter et al refer to it

        if (me.dragEnter(dropping) === false) {
          dropping = null;
        }

        me._dropping = was; // restore the value so that updateDropping is called as it should be
      }
    }

    return dropping;
  }

  updateDropRootElement(rootEl, was) {
    const me = this,
          {
      droppableCls
    } = me;
    let droppables, i, removeCls;

    if (was) {
      droppables = _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(was, 'droppables');
      removeCls = true;

      if (Array.isArray(droppables) && (i = droppables.indexOf(me)) > -1) {
        if (droppables.length < 2) {
          _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].remove(was, 'droppables');
        } else {
          droppables.splice(i, 1);
          droppables.forEach(d => {
            if (droppableCls === d.droppableCls) {
              removeCls = false; // our droppableCls may need to stay
            }
          });
        }
      }

      removeCls && was.classList.remove(droppableCls);
    }

    if (rootEl) {
      droppables = _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(rootEl, 'droppables');

      if (droppables) {
        droppables.push(me);
      } else {
        _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_1__["default"].set(rootEl, 'droppables', [me]);
      }

      rootEl.classList.add(droppableCls);
    }
  } //endregion


});

/***/ }),

/***/ "./lib/Core/mixin/Events.js":
/*!**********************************!*\
  !*** ./lib/Core/mixin/Events.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';







/**
 * @module Core/mixin/Events
 */

const // Used by the config system to flatten configs from the class hierarchy.
// In this case, a pure merge is not wanted. Listener definitions from
// every class level are collected up into an array.
// addListener iterates any passed array, adding each element.
{
  isArray
} = Array,
      {
  hasOwnProperty
} = Object.prototype,
      // Used to distinguish event names from listener options in addListener object config.
specialProperties = {
  thisObj: 1,
  detachable: 1,
  once: 1,
  detacher: 1,
  prio: 1,
  args: 1,
  expires: 1,
  buffer: 1,
  throttle: 1,
  name: 1
},
      priorityComparator = (a, b) => b.prio - a.prio;
/**
 * Mix this into another class to enable event handling.
 *
 * ## Basic usage
 * Listeners can be added either through config:
 *
 * ```javascript
 * let button = new Button({
 *   listeners: {
 *     click: () => {},
 *     press: () => {},
 *     ...
 *   }
 * });
 * ```
 *
 * *NOTE*: Do not reuse listeners config object, use new every time:
 * ```javascript
 * // wrong
 * let config = { click : () => {} }
 * new Button({
 *     listeners : config
 * })
 * new Button({
 *     listeners : config
 * })
 * // right
 * new Button({
 *     listeners : { click : () => {} }
 * })
 * new Button({
 *     listeners : { click : () => {} }
 * })
 * ```
 *
 * Or by calling on()/addListener():
 *
 * ```javascript
 * let button = new Button();
 *
 * button.addListener('press', () => {});
 * // on is an alias for addListener
 * button.on('click', () => {});
 * ```
 *
 * This style also accepts multiple listeners in same way as when using config:
 *
 * ```javascript
 * button.on({
 *   click: () => {},
 *   press: () => {},
 *   ...
 * });
 * ```
 *
 * ## Options
 * ### Once
 * Listeners can be configured to automatically deregister after first trigger by specifying config option `once`:
 *
 * ```javascript
 * button.on({
 *   click: () => {},
 *   once: true
 * });
 * ```
 *
 * ### Priority
 * Specifying priority affects the order in which listeners are called when triggering an event. Higher priorities will be
 * called before lower. Default value is 0.
 *
 * ```javascript
 * button.on({
 *   click: this.onClick,
 *   prio: 1
 * });
 * ```
 *
 * ### This reference
 * If desired, you can specify thisObj when configuring listeners. There is no need if you are using arrow functions as
 * listeners, but might be handy in other cases. Of course, you can also use bind to set `this` reference.
 *
 * ```javascript
 * button.on({
 *   click: this.onClick,
 *   thisObj: this
 * });
 *
 * // or
 *
 * button.on({
 *   click: this.onClick.bind(this)
 * });
 * ```
 *
 * ### Buffering
 * By specifying a `buffer` events that fire frequently can be grouped together and delayed. A handler for the event will be called once only, when no new event has been fired during the specified buffer time:
 *
 * ```javascript
 * button.on({
 *   click  : this.onClick,
 *   buffer : 200 // in milliseconds
 * });
 * ```
 * In this example, if a user clicked the button 6 times very fast (<200ms between each click),
 * the `this.onClick` handler would be called only once 200 milliseconds after the last click.
 *
 * ### Throttling
 * Create a "debounced" function which will call on the "leading edge" of a timer period.
 * When first invoked will call immediately, but invocations after that inside its buffer
 * period will be rejected, and *one* invocation will be made after the buffer period has expired.
 *
 * This is useful for responding immediately to a first mousemove, but from then on, only
 * calling the action function on a regular timer while the mouse continues to move.
 * ```javascript
 * button.on({
 *   click    : this.onClick,
 *   throttle : 200 // in milliseconds
 * });
 * ```
 * In this example, if a user clicked the button 6 times very fast, the `this.onClick` handler would be called once immediately on the first click and a second time 200 milliseconds after the **first** click.
 * So in reality the `click` event handler will be called every 200ms independent of amount of click in a middle, if the event was triggered at least once during the `throttle` timeout.
 *
 * ### Detacher
 * A convenient way of unregistering events is to use a detacher, a function returned when adding listeners that you
 * call later to deregister them. As of version 1.0, detachable defaults to true.
 *
 * ```javascript
 * let detacher = button.on({
 *   click: () => {},
 *   press: () => {},
 *   detachable: true
 * });
 *
 * // when you want to detach, for example in destroy()
 * detacher();
 * ```
 *
 * ### Auto detaching
 * When listeners are bound to a class instance using `thisObj`, the `thisObj`'s `doDestroy` method
 * is overridden to remove the listeners before calling the overridden doDestroy.
 *
 * ```javascript
 * class MyClass extends Base {
 *   construct() {
 *     let button = new Button({
 *       listeners: {
 *         click: () => {},
 *         thisObj: this
 *       }
 *     });
 *   }
 *
 *   doDestroy() {
 *     // clean up stuff
 *   }
 * }
 *
 * let myObj = new MyClass();
 * // clean up, also removes listeners
 * myObj.destroy();
 * ```
 *
 * ### On-functions
 * When mixing Events into another class it can be configured to call on-functions when events are triggered.
 * On-functions are functions named 'onEventName', for example 'onClick', 'onPress' declared on the class triggering
 * the event.
 *
 * ```javascript
 * // mix Events in with on-functions activated
 * let button = new Button({
 *   callOnFunctions: true,
 *
 *   onClick: () => {}
 * });
 *
 * // or add a getter in class declaration
 * ```
 *
 * Returning `false` from an on-function will prevent triggering listeners for the event.
 *
 * ### Catching all events
 * By specifying a listener for {@link #event-catchAll catchAll} a function can be notified when any event is triggered:
 *
 * ```javascript
 * const button = new Button({
 *    listeners : {
 *        catchAll(event) {
 *            // All events on the button will pass through here
 *        }
 *    }
 * });
 * ```
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class Events extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Events';
  } //region Events

  /**
   * Fires before an object is destroyed.
   * @event beforeDestroy
   * @param {Object} source The Object that is being destroyed.
   */

  /**
   * Fires when an object is destroyed.
   * @event destroy
   * @param {Object} source The Object that is being destroyed.
   */

  /**
   * Fires when any other event is fired from the object.
   *
   * **Note**: `catchAll` is fired for both public and private events. Please rely on the public events only.
   * @event catchAll
   * @param {Object} event The Object that contains event details
   * @param {String} event.type The type of the event which is caught by the listener
   */
  //endregion


  static get declarable() {
    return [
    /**
     * The list of deprecated events as an object, where `key` is an event name which is deprecated and
     * `value` is an object which contains values for
     * {@link Core.helper.VersionHelper#function-deprecate-static VersionHelper}:
     * - product {String} The name of the product;
     * - invalidAsOfVersion {String} The version where the offending code is invalid (when any compatibility
     *   layer is actually removed);
     * - message {String} Warning message to show to the developer using a deprecated API;
     *
     * For example:
     *
     * ```javascript
     * return {
     *     click : {
     *         product            : 'Grid',
     *         invalidAsOfVersion : '1.0.0',
     *         message            : 'click is deprecated!'
     *     }
     * }
     * ```
     *
     * @name deprecatedEvents
     * @returns {Object}
     * @static
     * @internal
     */
    'deprecatedEvents'];
  }

  static setupDeprecatedEvents(cls, meta) {
    const all = meta.getInherited('deprecatedEvents'),
          add = cls.deprecatedEvents;

    for (const eventName in add) {
      // Event names are case-insensitive so build our map using toLowerCased names (but keep true case too):
      all[eventName.toLowerCase()] = all[eventName] = add[eventName];
    }
  } //region Config


  static get configurable() {
    return {
      /**
       * The listener set for this object.
       *
       * Listeners can be specified in target class config and they will be merged with any listeners specified in
       * the instantiation config. Class listeners will be fired first:
       *
       * ```javascript
       * class MyStore extends Store({
       *     static get configurable() {
       *         return {
       *             listeners : {
       *                 myCustomEvent() {
       *                 },
       *                 load : {
       *                     prio : 10000,
       *                     fn() { // this load listener handles things first }
       *                 }
       *             }
       *         }
       *     }
       * });
       *
       * let store = new MyStore({
       *   listeners: {
       *     load: () => { // This load listener runs after the class's },
       *     ...
       *   }
       * });
       * ```
       *
       * @config {Object}
       * @category Common
       */
      listeners: {
        value: null,
        $config: {
          merge(newValue, currentValue) {
            if (newValue !== null) {
              if (!newValue) {
                return currentValue;
              }

              if (currentValue) {
                newValue = newValue ? [newValue] : [];
                newValue.push[isArray(currentValue) ? 'apply' : 'call'](newValue, currentValue);
              }
            }

            return newValue;
          }

        }
      },

      /**
       * An object where property names with a truthy value indicate which events should bubble up the ownership
       * hierarchy when triggered.
       *
       * ```javascript
       * const container = new Container({
       *     items : [
       *        { type : 'text', bubbleEvents : { change : true }}
       *     ],
       *
       *     listeners : {
       *         change() {
       *             // Will catch change event from the text field
       *         }
       *     }
       * });
       * ```
       *
       * @config {Object}
       */
      bubbleEvents: null
    };
  }

  destroy() {
    this.trigger('beforeDestroy');
    super.destroy();
  } //endregion
  //region Init


  construct(config, ...args) {
    var _config;

    // Configured listeners use this as the thisObj
    if (this.configuredListeners
    /* assignment */
    = (_config = config) === null || _config === void 0 ? void 0 : _config.listeners) {
      config = _objectSpread({}, config);
      delete config.listeners;
    }

    super.construct(config, ...args); // Apply configured listeners after construction.
    // Note that some classes invoke this during parts of their construction.
    // Store invokes this prior to setting data so that observers are notified of data load.

    this.processConfiguredListeners();
  }

  processConfiguredListeners() {
    // This can only happen once
    if (this.configuredListeners) {
      const me = this,
            {
        isConfiguring
      } = me; // If called from config ingestion during configuration, listeners must be added
      // so temporarily clear the isConfiguring flag.

      me.isConfiguring = false;
      me.listeners = me.configuredListeners;
      me.configuredListeners = null;
      me.isConfiguring = isConfiguring;
    }
  }
  /**
   * Auto detaches listeners registered from start, if set as detachable
   * @internal
   */


  doDestroy() {
    this.trigger('destroy');
    this.removeAllListeners();
    super.doDestroy();
  }

  static setupClass(meta) {
    super.setupClass(meta);
    Events.prototype.onListen.$nullFn = true;
    Events.prototype.onUnlisten.$nullFn = true;
  } //endregion
  //region Listeners

  /**
   * Adds an event listener. This method accepts parameters in the following format:
   *
   * ```javascript
   *  myObject.addListener({
   *      thisObj    : this,          // The this reference for the handlers
   *      eventname2 : 'functionName' // Resolved at invocation time using the thisObj,
   *      otherevent : {
   *          fn      : 'handlerFnName',
   *          once    : true          // Just this handler is auto-removed on fire
   *      },
   *      yetanother  : {
   *          fn      : 'yetAnotherHandler',
   *          args    : [ currentState1, currentState2 ] // Capture info to be passed to handler
   *      },
   *      prio        : 100           // Higher prio listeners are called before lower
   *  });
   * ```
   *
   * When listeners have a `thisObj` option, they are linked to the lifecycle of that object.
   * When it is destroyed, those listeners are removed.
   *
   * A simpler signature may be used when only adding a listener for one event and no extra options
   * (such as `once` or `delay`) are required:
   *
   * ```javascript
   * myObject.addListener('click', myController.handleClicks, myController);
   * ```
   *
   * The args in this simple case are `eventName`, `handler` and `thisObj`
   *
   * @param {Object|String} config An object containing listener definitions, or the event name to listen for
   * @param {Object} [config.thisObj] The `this` reference for all listeners.
   * (May be overridden if a handler is specified in object form)
   * @param {Boolean} [config.once] Specify as `true` to remove the listener as soon as it is invoked.
   * @param {Number|Object} [config.expires] The listener only waits for a specified time before
   * being removed. The value may be a number or an object containing an expiry handler.
   * @param {Number} [config.expires.delay] How long to wait for the event for.
   * @param {String|Function} [config.expires.alt] The function to call when the listener expires
   * **without having been triggered**.
   * @param {Object[]} [config.args] An array of arguments to be passed to the handler before the event object.
   * @param {Number} [config.prio] The priority for all listeners; higher priority listeners are called before lower.
   * @param {Number} [config.buffer] A buffer time in milliseconds to wait after last event trigger to call the handler, to reduce the amount of handler calls for frequent events.
   * @param {Number} [config.throttle] A millisecond timeout value to throttle event triggering. With it specified a handler
   * will be called once immediately and then all following calls during the timeout period will be grouped together into one call once per throttle period.
   * @param {Object|Function} [thisObj] Default `this` reference for all listeners in the config object, or the handler
   * function to call if providing a string as the first arg.
   * @param {Object} [oldThisObj] The `this` reference if the old signature starting with a string event name is used..
   * @returns {Function} Returns a detacher function unless configured with `detachable: false`. Call detacher to remove listeners
   */


  addListener(config, thisObj, oldThisObj) {
    if (isArray(config)) {
      for (let i = 0, {
        length
      } = config; i < length; i++) {
        this.addListener(config[i], thisObj);
      }

      return;
    }

    const me = this,
          deprecatedEvents = me.$meta.getInherited('deprecatedEvents');

    if (typeof config === 'string') {
      // arguments[2] is thisObj if (eventname, handler, thisObj) form called.
      // Note that the other side of the if compares to undefined, so this will work.
      return me.addListener({
        [config]: thisObj,
        detachable: thisObj.detachable !== false,
        thisObj: oldThisObj
      });
    } else {
      // Capture the default thisObj.
      thisObj = config.thisObj = config.thisObj !== undefined ? config.thisObj : thisObj;

      for (const key in config) {
        if (!specialProperties[key]) {
          // comparing should be case insensitive
          const // comparing should be case insensitive
          eventName = key.toLowerCase(),
                deprecatedEvent = deprecatedEvents === null || deprecatedEvents === void 0 ? void 0 : deprecatedEvents[eventName],
                events = me.eventListeners || (me.eventListeners = {}),
                listenerSpec = config[key],
                expires = listenerSpec.expires || config.expires,
                listener = {
            fn: typeof listenerSpec === 'object' ? listenerSpec.fn : listenerSpec,
            thisObj: listenerSpec.thisObj !== undefined ? listenerSpec.thisObj : thisObj,
            args: listenerSpec.args || config.args,
            prio: listenerSpec.prio !== undefined ? listenerSpec.prio : config.prio !== undefined ? config.prio : 0,
            once: listenerSpec.once !== undefined ? listenerSpec.once : config.once !== undefined ? config.once : false,
            buffer: listenerSpec.buffer || config.buffer,
            throttle: listenerSpec.throttle || config.throttle,
            catchAll: key === 'catchAll'
          };

          if (deprecatedEvent) {
            const {
              product,
              invalidAsOfVersion,
              message
            } = deprecatedEvent;
            _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].deprecate(product, invalidAsOfVersion, message);
          }

          if (expires) {
            // Extract expires : { delay : 100, alt : 'onExpireFn' }
            const delayable = me.isDelayable ? me : _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].global,
                  {
              alt
            } = expires,
                  delay = alt ? expires.delay : expires;
            delayable.setTimeout(() => {
              me.un(eventName, listener); // If we make it here and the handler has not been called, invoke the alt handler

              if (alt && !listener.called) {
                me.callback(alt, thisObj);
              }
            }, delay);
          }

          let listeners = events[eventName] || (events[eventName] = []);

          if (listeners.$firing) {
            events[eventName] = listeners = listeners.slice();
          } // Insert listener directly in prio order


          listeners.splice(_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].findInsertionIndex(listener, listeners, priorityComparator, listeners.length), 0, listener);

          if (!me.onListen.$nullFn && listeners.length < 2) {
            me.onListen(eventName);
          }
        }
      }

      if (config.relayAll) {
        me.relayAll(config.relayAll);
      } // Hook into the thisObj's destruction sequence to remove these listeners.
      // Pass the default thisObj in for use when it comes to destruction time.


      if (thisObj && thisObj !== me) {
        me.attachAutoDetacher(config, thisObj);
      }

      const detachable = config.detachable !== false,
            name = config.name,
            destroy = config.expires || detachable || name ? () => {
        // drop listeners if not destroyed yet
        if (!me.isDestroyed) {
          me.removeListener(config, thisObj);
        }
      } : null;

      if (destroy) {
        var _thisObj;

        destroy.eventer = me;
        destroy.listenerName = name;

        if (name && (_thisObj = thisObj) !== null && _thisObj !== void 0 && _thisObj.trackDetacher) {
          thisObj.trackDetacher(name, destroy);
        }

        if (config.expires) {
          me.delay(destroy, config.expires);
        }

        if (detachable) {
          return destroy;
        }
      }
    }
  }
  /**
   * Alias for {@link #function-addListener}. Adds an event listener. This method accepts parameters in the following format:
   *
   * ```javascript
   *  myObject.on({
   *      thisObj    : this,          // The this reference for the handlers
   *      eventname2 : 'functionName' // Resolved at invocation time using the thisObj,
   *      otherevent : {
   *          fn      : 'handlerFnName',
   *          once    : true          // Just this handler is auto-removed on fire
   *      },
   *      yetanother  : {
   *          fn      : 'yetAnotherHandler',
   *          args    : [ currentState1, currentState2 ] // Capture info to be passed to handler
   *      },
   *      prio        : 100           // Higher prio listeners are called before lower
   *  });
   * ```
   *
   * When listeners have a `thisObj` option, they are linked to the lifecycle of that object.
   * When it is destroyed, those listeners are removed.
   *
   * A simpler signature may be used when only adding a listener for one event and no extra options
   * (such as `once` or `delay`) are required:
   *
   * ```javascript
   * myObject.on('click', myController.handleClicks, myController);
   * ```
   *
   * The args in this simple case are `eventName`, `handler` and `thisObj`
   *
   * @param {Object|String} config An object containing listener definitions.
   * @param {Object} [config.thisObj] The `this` reference for all listeners.
   * (May be overridden if a handler is specified in object form)
   * @param {Boolean} [config.once] Specify as `true` to remove the listener as soon as it is invoked.
   * @param {Number|Object} [config.expires] The listener only waits for a specified time before
   * being removed. The value may be a number or an object containing an expiry handler.
   * @param {Number} [config.expires.delay] How long to wait for the event for.
   * @param {String|Function} [config.expires.alt] The function to call when the listener expires
   * **without having been triggered**.
   * @param {Object[]} [config.args] An array of arguments to be passed to the handler before the event object.
   * @param {Object|Function} [thisObj] Default `this` reference for all listeners in the config object.
   * @param {Object} [oldThisObj] The `this` reference if the old signature starting with a string event name is used..
   * @returns {Function} Returns a detacher function unless configured with `detachable: false`. Call detacher to remove listeners
   */


  on(...args) {
    return this.addListener(...args);
  }
  /**
   * Shorthand for {@link #function-removeListener}
   * @param {Object|String} config A config object or the event name
   * @param {Object|Function} thisObj `this` reference for all listeners, or the listener function
   * @param {Object} oldThisObj `this` The this object for the legacy way of adding listeners
   */


  un(...args) {
    this.removeListener(...args);
  }

  get listeners() {
    return this.eventListeners;
  }

  changeListeners(listeners) {
    // If we are receiving class listeners, add them early, and they do not become
    // the configured listeners, and are not removed by setting listeners during the lifecycle.
    if (this.isConfiguring) {
      if (listeners) {
        this.on(listeners, this);
      }
    } // Setting listeners after config time clears the old set and adds the new.
    // This will initially happen at the tail end of the constructor when config
    // listeners are set.
    else {
      // Configured listeners use this as the thisObj by default.
      // Flatten using Objects.assign because it may have been part of
      // a prototype chained default configuration of another object.
      // eg: the tooltip config of a Widget.
      // listener object blocks from multiple configuration levels are pushed
      // onto an array (see listeners merge function in configurable block above).
      // If this has happened, each entry must be processed like this.
      if (Array.isArray(listeners)) {
        for (let i = 0, l = listeners[0], {
          length
        } = listeners; i < length; l = listeners[++i]) {
          if (!('thisObj' in l)) {
            listeners[i] = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
              thisObj: this
            }, l);
          }
        }
      } else if (listeners && !('thisObj' in listeners)) {
        listeners = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
          thisObj: this
        }, listeners);
      }

      return listeners;
    }
  }

  updateListeners(listeners, oldListeners) {
    // Only configured listeners get here. Class listeners are added by changeListeners.
    oldListeners && this.un(oldListeners);
    listeners && this.on(listeners);
  }
  /**
   * Removes an event listener. Same API signature as {@link #function-addListener}
   * @param {Object|String} config A config object or the event name
   * @param {Object|Function} thisObj `this` reference for all listeners, or the listener function
   * @param {Object} oldThisObj `this` The this object for the legacy way of adding listeners
   */


  removeListener(config, thisObj = config.thisObj, oldThisObj) {
    const me = this;

    if (typeof config === 'string') {
      return me.removeListener({
        [config]: thisObj
      }, oldThisObj);
    }

    Object.entries(config).forEach(([eventName, listenerToRemove]) => {
      if (!specialProperties[eventName]) {
        eventName = eventName.toLowerCase();
        const eventListeners = me.eventListeners,
              index = me.findListener(eventName, listenerToRemove, thisObj);

        if (index >= 0) {
          let listeners = eventListeners[eventName];

          if (listeners.length > 1) {
            if (listeners.$firing) {
              eventListeners[eventName] = listeners = listeners.slice();
            } // NOTE: we cannot untrack any detachers here because we may only be
            // removing some of its listeners


            listeners.splice(index, 1);
          } else {
            delete eventListeners[eventName];

            if (!me.onUnlisten.$nullFn) {
              me.onUnlisten(eventName);
            }
          }
        }
      }
    });

    if (config.thisObj && !config.thisObj.isDestroyed) {
      me.detachAutoDetacher(config);
    }
  }
  /**
   * Finds the index of a particular listener to the named event. Returns `-1` if the passed
   * function/thisObj listener is not present.
   * @param {String} eventName The name of an event to find a listener for.
   * @param {String|Function} listenerToFind The handler function to find.
   * @param {Object} defaultThisObj The `thisObj` for the required listener.
   * @internal
   */


  findListener(eventName, listenerToFind, defaultThisObj) {
    var _this$eventListeners;

    const eventListeners = (_this$eventListeners = this.eventListeners) === null || _this$eventListeners === void 0 ? void 0 : _this$eventListeners[eventName],
          fn = listenerToFind.fn || listenerToFind,
          thisObj = listenerToFind.thisObj || defaultThisObj;

    if (eventListeners) {
      for (let listenerEntry, i = 0, {
        length
      } = eventListeners; i < length; i++) {
        listenerEntry = eventListeners[i];

        if (listenerEntry.fn === fn && listenerEntry.thisObj === thisObj) {
          return i;
        }
      }
    }

    return -1;
  }
  /**
   * Check if any listener is registered for the specified eventName
   * @param {String} eventName
   * @returns {Boolean} `true` if listener is registered, otherwise `false`
   */


  hasListener(eventName) {
    var _this$eventListeners2;

    return Boolean((_this$eventListeners2 = this.eventListeners) === null || _this$eventListeners2 === void 0 ? void 0 : _this$eventListeners2[eventName === null || eventName === void 0 ? void 0 : eventName.toLowerCase()]);
  }
  /**
   * Relays all events through another object that also implements Events mixin. Adds a prefix to the event name
   * before relaying, for example add -> storeAdd
   * ```
   * // Relay all events from store through grid, will make it possible to listen for store events prefixed on grid:
   * 'storeLoad', 'storeChange', 'storeRemoveAll' etc.
   * store.relayAll(grid, 'store');
   *
   * grid.on('storeLoad', () => console.log('Store loaded');
   * ```
   * @param {Core.mixin.Events} through Object to relay the events through, needs to mix Events mixin in
   * @param {String} prefix Prefix to add to event name
   * @param {Boolean} [transformCase] Specify false to prevent making first letter of event name uppercase
   */


  relayAll(through, prefix, transformCase = true) {
    if (!this.relayAllTargets) {
      this.relayAllTargets = [];
    }

    const relayAllTargets = this.relayAllTargets;
    through.on('beforeDestroy', ({
      source
    }) => {
      if (source === through) {
        const configs = relayAllTargets.filter(r => r.through === through);
        configs.forEach(config => _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].remove(relayAllTargets, config));
      }
    });
    relayAllTargets.push({
      through,
      prefix,
      transformCase
    });
  }
  /**
   * Removes all listeners registered to this object
   */


  removeAllListeners() {
    const listeners = this.eventListeners;
    let i, thisObj;

    for (const event in listeners) {
      const bucket = listeners[event]; // We iterate backwards since we call removeListener which will splice out of
      // this array as we go...

      for (i = bucket.length; i-- > 0;) {
        var _thisObj2;

        const cfg = bucket[i];
        this.removeListener(event, cfg);
        thisObj = cfg.thisObj;

        if ((_thisObj2 = thisObj) !== null && _thisObj2 !== void 0 && _thisObj2.untrackDetachers) {
          thisObj.untrackDetachers(this);
        }
      }
    }
  }

  relayEvents(source, eventNames, prefix = '') {
    const listenerConfig = {
      detachable: true
    };
    eventNames.forEach(eventName => {
      listenerConfig[eventName] = (event, ...params) => {
        return this.trigger(prefix + event.type, event, ...params);
      };
    });
    return source.on(listenerConfig);
  }
  /**
   * This method is called when the first listener for an event is added.
   * @param {String} eventName
   * @internal
   */


  onListen() {}
  /**
   * This method is called when the last listener for an event is removed.
   * @param {String} eventName
   * @internal
   */


  onUnlisten() {}

  destructorInterceptor() {
    const {
      autoDetachers,
      target,
      oldDestructor
    } = this; // Remove listeners first, so that they do not fire during destruction.
    // The observable being listened to by the thisObj may already have
    // been destroyed in a clean up sequence

    for (let i = 0; i < autoDetachers.length; i++) {
      const {
        dispatcher,
        config
      } = autoDetachers[i];

      if (!dispatcher.isDestroyed) {
        dispatcher.removeListener(config, target);
      }
    }

    oldDestructor.call(target);
  }
  /**
   * Internal function used to hook destroy() calls when using thisObj
   * @private
   */


  attachAutoDetacher(config, thisObj) {
    const target = config.thisObj || thisObj,
          // If it's a Bryntum Base subclass, hook doDestroy, otherwise, destroy
    destructorName = 'doDestroy' in target ? 'doDestroy' : 'destroy';

    if (destructorName in target) {
      let {
        $autoDetachers
      } = target;

      if (!$autoDetachers) {
        target.$autoDetachers = $autoDetachers = [];
      }

      if (!target.$oldDestructor) {
        target.$oldDestructor = target[destructorName]; // Binding instead of using closure (used to use FunctionHelper.createInterceptor) to not retain target
        // when detaching manually

        target[destructorName] = this.destructorInterceptor.bind({
          autoDetachers: $autoDetachers,
          oldDestructor: target.$oldDestructor,
          target
        });
      }

      $autoDetachers.push({
        config,
        dispatcher: this
      });
    } else {
      target[destructorName] = () => {
        this.removeListener(config);
      };
    }
  }
  /**
   * Internal function used restore hooked destroy() calls when using thisObj
   * @private
   */


  detachAutoDetacher(config) {
    const target = config.thisObj; // Restore old destructor and remove from auto detachers only if we are not called as part of destruction.
    // (Altering $autoDetachers affects destruction iterating over them, breaking it. It is pointless to clean up
    // during destruction anyway, since everything gets removed)

    if (target.$oldDestructor && !target.isDestroying) {
      _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].remove(target.$autoDetachers, target.$autoDetachers.find(detacher => detacher.config === config && detacher.dispatcher === this));

      if (!target.$autoDetachers.length) {
        target['doDestroy' in target ? 'doDestroy' : 'destroy'] = target.$oldDestructor;
        target.$oldDestructor = null;
      }
    }
  } //endregion
  //region Promise based workflow
  // experimental, used in tests to support async/await workflow


  await(eventName, options = {
    checkLog: true,
    resetLog: true,
    args: null
  }) {
    const me = this;

    if (options === false) {
      options = {
        checkLog: false
      };
    }

    const {
      args
    } = options;
    return new Promise(resolve => {
      var _me$_triggered;

      // check if previously triggered?
      if (options.checkLog && (_me$_triggered = me._triggered) !== null && _me$_triggered !== void 0 && _me$_triggered[eventName]) {
        // resolve immediately, no params though...
        resolve(); // reset log to be able to await again

        if (options.resetLog) {
          me.clearLog(eventName);
        }
      } // This branch will listen for events until catches one with specific arguments


      if (args) {
        const detacher = me.on({
          [eventName]: (...params) => {
            const argsOk = Object.keys(args).every(key => {
              return key in params[0] && params[0][key] === args[key];
            });

            if (argsOk) {
              // resolve when event is fired with required arguments
              resolve(...params); // reset log to be able to await again

              if (options.resetLog) {
                me.clearLog(eventName);
              }

              detacher();
            }
          },
          prio: -10000 // Let others do their stuff first

        });
      } else {
        me.on({
          [eventName]: (...params) => {
            // resolve when event is caught
            resolve(...params); // reset log to be able to await again

            if (options.resetLog) {
              me.clearLog(eventName);
            }
          },
          prio: -10000,
          // Let others do their stuff first
          once: true // promises can only be resolved once anyway

        });
      }
    });
  }

  clearLog(eventName) {
    if (this._triggered) {
      if (eventName) {
        delete this._triggered[eventName];
      } else {
        this._triggered = {};
      }
    }
  } //endregion
  //region Trigger

  /**
   * Triggers an event, calling all registered listeners with the supplied arguments. Returning false from any listener
   * makes function return false.
   * @param {String} eventName Event name for which to trigger listeners
   * @param {Object} [param] Single parameter passed on to listeners, source property will be added to it (this)
   * @param {Boolean} [param.bubbles] Pass as `true` to indicate that the event will bubble up the widget
   * ownership hierarchy. For example up a Menu->parent Menu tree, or a Field->Container tree.
   * @returns {Boolean|Promise} Returns false if any listener returned false, or a Promise yielding
   * true / false based on what is returned from the async listener functions, otherwise true
   */


  trigger(eventName, param) {
    var _me$eventListeners, _me$eventListeners2, _me$bubbleEvents, _handlerPromises;

    // TODO: should returning false from a listener really prevent other listeners from executing?
    const me = this,
          name = eventName.toLowerCase(),
          {
      eventsSuspended,
      relayAllTargets,
      callOnFunctions
    } = me;
    let listeners = (_me$eventListeners = me.eventListeners) === null || _me$eventListeners === void 0 ? void 0 : _me$eventListeners[name],
        handlerPromises; // log trigger, used by experimental promise support to resolve immediately when needed

    if (!me._triggered) {
      me._triggered = {};
    }

    me._triggered[eventName] = true;

    if (eventsSuspended) {
      if (eventsSuspended.shouldQueue) {
        eventsSuspended.queue.push(arguments);
      }

      return true;
    } // Include catchall listener for all events.
    // Do not push the catchAll listeners onto the events own listener array.


    if ((_me$eventListeners2 = me.eventListeners) !== null && _me$eventListeners2 !== void 0 && _me$eventListeners2.catchall) {
      (listeners = listeners ? listeners.slice() : []).push(...me.eventListeners.catchall); // The catchAll listeners must honour their prio settings.

      listeners.sort(priorityComparator);
    }

    if (!listeners && !relayAllTargets && !callOnFunctions) {
      return true;
    } // default to include source : this in param


    if (param) {
      if (!('source' in param)) {
        if (Object.isExtensible(param)) {
          param.source = me;
        } else {
          param = Object.setPrototypeOf({
            source: me
          }, param);
        }
      }
    } else {
      param = {
        source: me
      };
    } // Lowercased event name should be the "type" property in keeping with DOM events.


    if (param.type !== name) {
      // Create instance property because "type" is read only
      if (param.constructor !== Object) {
        Reflect.defineProperty(param, 'type', {
          get: () => name
        });
      } else {
        param.type = name;
      }
    } // Bubble according to `bubbleEvents` config if `bubbles` is not explicitly set


    if (!('bubbles' in param) && (_me$bubbleEvents = me.bubbleEvents) !== null && _me$bubbleEvents !== void 0 && _me$bubbleEvents[eventName]) {
      param.bubbles = me.bubbleEvents[eventName];
    }

    if (callOnFunctions) {
      const fnName = 'on' + _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].capitalize(eventName);

      if (fnName in me) {
        var _me$pluginFunctionCha;

        let inhibit = me.callback(me[fnName], me, [param]) === false; // See if the called function was injected into the instance
        // masking an implementation in the prototype.
        // we must call the class's implementation after the injected one.
        // unless it's an injected chained function, in which case it will have been called above.
        // Note: The handler may have resulted in destruction.

        if (!me.isDestroyed && hasOwnProperty.call(me, fnName) && !((_me$pluginFunctionCha = me.pluginFunctionChain) !== null && _me$pluginFunctionCha !== void 0 && _me$pluginFunctionCha[fnName])) {
          const myProto = Object.getPrototypeOf(me);

          if (fnName in myProto) {
            inhibit = myProto[fnName].call(me, param) === false || inhibit; // A handler may have resulted in destruction.

            if (me.isDestroyed) {
              return;
            }
          }
        } // Returning false from an on-function prevents further triggering


        if (inhibit) {
          return false;
        }
      }
    }

    if (listeners) {
      let i = 0,
          ret; // Let add/removeListener know that we're using the array to protect against a situation where an event
      // listener changes the listeners when triggering the event.

      listeners.$firing = true; // If any listener resulted in our destruction, abort.

      for (i; i < listeners.length && !me.isDestroyed && ret !== false; i++) {
        const listener = listeners[i];
        let handler,
            thisObj = listener.thisObj; // Listeners that have thisObj are auto removed when thisObj is destroyed. If thisObj is destroyed from
        // a listener we might still end up here, since listeners are sliced and not affected by the removal

        if (!thisObj || !thisObj.isDestroyed) {
          // Flag for the expiry timer
          listener.called = true;

          if (listener.once) {
            me.removeListener(name, listener);
          } // prepare handler function


          if (typeof listener.fn === 'string') {
            if (thisObj) {
              handler = thisObj[listener.fn];
            } // keep looking for the callback in the hierarchy


            if (!handler) {
              const result = me.resolveCallback(listener.fn);
              handler = result.handler;
              thisObj = result.thisObj;
            }
          } else {
            handler = listener.fn;
          } // if `buffer` option is provided, the handler will be wrapped into buffer function,
          // but only once on the first call


          if (listener.buffer) {
            if (!listener.bufferFn) {
              const buffer = Number(listener.buffer);

              if (typeof buffer !== 'number' || isNaN(buffer)) {
                throw new Error(`Incorrect type for buffer, got "${buffer}" (expected a Number)`);
              }

              listener.bufferFn = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].createBuffered(handler, buffer, listener.thisObj, listener.args);
            }

            handler = listener.bufferFn;
          } // if `throttle` option is provided, the handler will be called immediately, but all the rest calls
          // that happened during time specified in `throttle`, will be delayed and glued into 1 call


          if (listener.throttle) {
            const throttle = Number(listener.throttle);

            if (typeof throttle !== 'number' || isNaN(throttle)) {
              throw new Error(`Incorrect type for throttle, got "${throttle}" (expected a Number)`);
            }

            if (!listener.throttledFn) {
              listener.throttledFn = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].createThrottled(handler, throttle, listener.thisObj, listener.args);
            }

            handler = listener.throttledFn;
          }

          ret = handler.call(thisObj || me, ...(listener.args || []), param);

          if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_6__["default"].isPromise(ret)) {
            // If a handler is async (returns a Promise), then collect all Promises.
            // At the end we return a Promise which encapsulates all returned Promises
            // or, if only one handler was async, *the* Promise.
            // Don't allocate an Array until we have to.
            (handlerPromises || (handlerPromises = [])).push(ret);
          }
        }
      }

      listeners.$firing = false;

      if (ret === false) {
        return ret;
      }
    } // relay all?


    if (relayAllTargets) {
      relayAllTargets.forEach(config => {
        let name = eventName;
        if (config.transformCase) name = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].capitalize(name);
        if (config.prefix) name = config.prefix + name;
        if (config.through.trigger(name, param) === false) return false;
      });
    } // Use DOM standard event property name to indicate that the event
    // bubbles up the owner axis.
    // False from any handler cancels the bubble.
    // Must also avoid owner if any handlers destroyed the owner.


    if (param.bubbles && me.owner && !me.owner.isDestroyed) {
      return me.owner.trigger(eventName, param);
    } // If any handlers were async functions (returned a Promise), then return a Promise
    // which resolves when they all resolve.


    if ((_handlerPromises = handlerPromises) !== null && _handlerPromises !== void 0 && _handlerPromises.length) {
      return new Promise(resolve => {
        Promise.all(handlerPromises).then(promiseResults => {
          const finalResult = !promiseResults.some(result => result === false);
          resolve(finalResult);
        });
      });
    }

    return true;
  }
  /**
   * Prevents events from being triggered until {@link #function-resumeEvents()} is called. Optionally queues events that are triggered while
   * suspended. Multiple calls stack to require matching calls to `resumeEvents()` before actually resuming.
   * @param {Boolean} queue Specify true to queue events triggered while suspended
   */


  suspendEvents(queue = false) {
    const eventsSuspended = this.eventsSuspended || (this.eventsSuspended = {
      shouldQueue: queue,
      queue: [],
      count: 0
    });
    eventsSuspended.count++;
  }
  /**
   * Resume event triggering after a call to {@link #function-suspendEvents()}. If any triggered events were queued they will be triggered.
   * @returns `true` if events have been resumed (multiple calls to suspend require an equal number of resume calls to resume).
   */


  resumeEvents() {
    const suspended = this.eventsSuspended;

    if (suspended) {
      if (--suspended.count === 0) {
        this.eventsSuspended = null;

        if (suspended.shouldQueue) {
          for (const queued of suspended.queue) {
            this.trigger(...queued);
          }
        }
      }
    }

    return !Boolean(this.eventsSuspended);
  } //endregion


});

/***/ }),

/***/ "./lib/Core/mixin/Factoryable.js":
/*!***************************************!*\
  !*** ./lib/Core/mixin/Factoryable.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';




/**
 * @module Core/mixin/Factoryable
 */

const {
  defineProperty
} = Reflect,
      ownerSymbol = Symbol('owner'),
      typeSplitRe = /[\s,]+/;
/**
 * This mixin is applied to base classes of a type that will be dynamically created by type name aliases.
 * ```
 *  class Layout extends Base.mixin(Factoryable) {
 *      static get factoryable() {
 *          return {
 *              defaultType : 'default'
 *          };
 *      }
 *
 *      static get type() {
 *          return 'default';
 *      }
 *  }
 *
 *  class Fit extends Layout {
 *      static get type() {
 *          return 'fit';
 *      }
 *  }
 * ```
 *
 * Once a family of classes has been defined, instances are created using the `create()` method:
 * ```
 *  const layout = Layout.create(config);
 * ```
 *
 * In the above example, `config` can be a type name (such as "fit") or a config object with a `type` property that
 * holds the type name.
 *
 * Factories can also extend other factories. For example, one factory creates objects that are useful across a wide
 * range of consumers, and a second factory creates objects for a more specialized consumer. If that specialized
 * consumer can also consume objects from the first factory, then the second factory can specify this relationship:
 * ```
 *  class General extends Base.mixin(Factoryable) {
 *      ...
 *  }
 *
 *  class Specialized extends Base.mixin(Factoryable) {
 *      static get factoryable() {
 *          return {
 *              extends : General,
 *              ...
 *          };
 *      }
 *  }
 * ```
 * The `extends` factoryable option can be either a class that mixes in `Factoryable` or an array of such classes.
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Factoryable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Factoryable';
  }

  static get declarable() {
    return [
    /**
     * This property getter returns options that control the factory process. This property getter must be
     * defined by the class that mixes in `Factoryable` in order to initialize the factory properly.
     * ```
     *  static get factoryable() {
     *      return {
     *          defaultType : 'default'
     *      };
     *  }
     * ```
     * If there are no special options to provide, this method can return nothing (`undefined`):
     * ```
     *  static get factoryable() {
     *      // initialize the factory with all default options
     *  }
     * ```
     * @static
     * @member {Object} factoryable
     * @property {Boolean} [factoryable.caseless=true] Specify `false` to use case-sensitive type names. The
     * default is to ignore case.
     * @property {String} [factoryable.defaultType=null] The default type to create when a config object has
     * no `typeKey` property.
     * @property {Function|Function[]} [factoryable.extends] One or more classes that mix in `Factoryable` to
     * use for resolving type names when a type name is not found in this factory.
     * @property {String} [factoryable.typeKey='type'] The name of the property in a config object that holds
     * the type name.
     * @internal
     */
    'factoryable',
    /**
     * One or more additional type name aliases for this class. This can be useful for renaming and maintaining
     * a previous type name.
     * ```
     *  class Fit extends Layout {
     *      static get type() {
     *          return 'fit';
     *      }
     *
     *      static get alias() {
     *          return 'fill';  // deprecated type name (now known as 'fit')
     *      }
     *  }
     * ```
     * @static
     * @member {String|String[]} alias
     * @internal
     */
    'alias',
    /**
     * The (canonical) type name for this class by which instances can be created using the static
     * {@link #function-create-static create()} method.
     * @static
     * @member {String} type
     */
    'type'];
  }
  /**
   * Registers a class (`cls`) associated with the given `type`.
   * @param {String|String[]} type A string, array of strings or a comma-separated string containing the type names
   * for the specified `cls` class.
   * @param {Function} cls The class (constructor function)
   * @param {Boolean} [replace] Pass `true` to overwrite existing registered types. Otherwise, this method will throw
   * an exception if the `type` is already registered with this factory.
   * @internal
   */


  static register(type, cls, replace = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].global.__BRYNTUM_EXAMPLE) {
    // `replace` default value is set to true while we are run inside a bryntum demo where code editor changes might
    // lead to same widget class being registered over and over.
    const {
      factoryable
    } = this.initClass(),
          {
      caseless,
      registry
    } = factoryable,
          types = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].split(type, typeSplitRe); // if type is a string[] it will just be returned

    for (let lower, name, i = 0; i < types.length; ++i) {
      name = types[i];
      lower = caseless ? name.toLowerCase() : name;

      if (!replace && lower in registry) {
        throw new Error(`Type "${name}" already registered with ${factoryable.class.name} factory`);
      } // Ensure class being registered is initialized. (initClass returns the class)


      registry[name] = registry[lower] = cls.initClass();
    }
  }
  /**
   * Returns 'true` if the passed instance is of the passed type or of a derived class.
   * @param {Object} instance The object to test.
   * @param {String} type The type to test against
   */


  static isA(instance, type) {
    return this.isType(instance, type, true);
  }
  /**
   * Returns 'true` if the passed instance is of the passed type.
   * @param {Object} instance The object to test.
   * @param {String} type The type to test against
   * @param {Boolean} [deep] Pass `true` to return `true` if the class is a subclass of the passed type.
   */


  static isType(instance, type, deep) {
    const {
      factoryable
    } = this,
          {
      caseless,
      registry
    } = factoryable,
          typeCls = registry[caseless ? type.toLowerCase() : type]; // If the type to be tested against maps to a class, see if the instance is an instanceof that

    if (typeCls) {
      if (deep) {
        return instance instanceof typeCls;
      }

      return instance.constructor === typeCls;
    }

    return false;
  }

  static setupAlias(cls) {
    cls.register(cls.alias, cls);
  }

  static setupFactoryable(cls, meta) {
    const superClass = meta.super.class;
    let {
      factoryable
    } = cls;
    factoryable = _objectSpread({
      caseless: true,
      defaultType: null,
      extends: superClass.factoryable ? [superClass] : null,
      typeKey: 'type'
    }, factoryable);
    factoryable.class = cls;
    factoryable.registry = Object.create(null);

    if (factoryable.extends && !Array.isArray(factoryable.extends)) {
      factoryable.extends = [factoryable.extends];
    } // Replace the class/static getter with a new one that returns the complete factoryable object:


    defineProperty(cls, 'factoryable', {
      get() {
        return factoryable;
      }

    });
  }

  static setupType(cls) {
    const {
      type
    } = cls;
    cls.register(type, cls); // Copy the static type property onto the prototype as a readonly property:

    defineProperty(cls.prototype, 'type', {
      value: type
    });
  }
  /**
   * Creates an instance from this factory, given the type name or a config object.
   * @param {String|Object} config The type name string or config object.
   * @param {String|Function|Object} [options] Creation options (for details see {@link #function-reconfigure-static}).
   * @returns {Object}
   */


  static create(config, options) {
    return this.reconfigure(null, config, options);
  }
  /**
   * Reconfigures an optional existing instance based on the provided config and returns the correctly configured
   * instance. This will be the `existingInstance` if the `config` does not specify a different type.
   *
   * If `config` is `null` (or simply falsy), this method will destroy the `existingInstance` (if any) and return
   * `null`.
   *
   * If there is no `existingInstance`, the config must specify a type. That is, it must be a string (the type name)
   * or an object containing a `type` property, the `defaultType` must be provided or the factory itself must have
   * a `defaultType` specified (see {@link #property-factoryable-static}).
   *
   * When an `existingInstance` is provided and a type is specified, the instance will be reconfigured via `setConfig`
   * if it is of that type. Otherwise, the `existingInstance` is destroyed (if it is owned by the `options.owner`)
   * and a new instance of the correct type is created.
   *
   * @param {Object} existingInstance The instance to reconfigure. This can be `null`.
   *
   * @param {String|Object} config The type name string or config object.
   *
   * @param {String|Function|Object} [options] Additional options to control the reconfiguration process. If this
   * value is a string or a class constructor, it treated as `options.type`. If this value is an class instance, it
   * is used as the `options.owner`. If this is a function, it is treated as `options.setup`. NOTE: functions declared
   * using the `function` keyword are equivalent to class constructors. Use an arrow function or a class method to
   * avoid this when a `setup` function is intended.
   *
   * @param {String|Function} [options.type] The default type to use if the `config` object does not specify a type.
   *
   * @param {Object} [options.owner] The owner of any created instances. If the `existingInstance` is being replaced,
   * this value determines if the instance will be destroyed.
   *
   * @param {Object} [options.defaults] A config object of default values to use when creating a new instance.
   *
   * @param {Function|String} [options.setup] A function or the name of a method (on the `options.owner`) to call
   * prior to creating a new instance. It is passed the config object that will be used to create the instance. If a
   * truthy value is returned, that value is passed to the constructor instead of the provided config object.
   *
   * @param {Function|String} [options.transform] A function or the name of a method (on the `options.owner`) to call
   * with the raw config object prior to processing and the value it returns replaces the raw value. This function is
   * used to transform strings or arrays (for example) into proper config objects.
   *
   * @param {Function|String} [options.cleanup] A function or the name of a method (on the `options.owner`) to call
   * prior to destroying the `existingInstance`. The `existingInstance` is passed as the sole argument.
   *
   * @returns {Object} The reconfigured instance (either `existingInstance` or a new instance of the desired type)
   */


  static reconfigure(existingInstance, config, options) {
    const me = this,
          {
      factoryable
    } = me,
          {
      typeKey
    } = factoryable;
    let defaultType = options,
        cleanup,
        defaults,
        mergeType,
        owner,
        prepared,
        setup,
        t,
        transform,
        type; // Pick apart the options and set the vars accordingly

    if (options && !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isClass(options)) {
      // if (options is not the defaultType)
      defaultType = null;
      t = typeof options;

      if (t === 'function') {
        setup = options;
      } else if (t === 'string') {
        defaultType = options;
      } else if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isObject(options)) {
        // TODO revert to
        //  ({ cleanup, defaults, owner, setup, type : defaultType } = options);
        //  after this issue is fixed https://github.com/bryntum/bryntum-suite/issues/1457
        cleanup = options.cleanup;
        defaults = options.defaults;
        owner = options.owner;
        setup = options.setup;
        defaultType = options.type;
        transform = options.transform;
      } else {
        owner = options;
      }
    }

    if (transform) {
      config = typeof transform === 'string' ? owner[transform](config) : transform(config);
    }

    type = config; // Figure out config... it's either a type (string), a config object or the actual instance.

    if (typeof type === 'string') {
      config = {};
    } else if (config) {
      if (config === true) {
        config = {};
      }

      if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isObject(config)) {
        // If we are being given an instance (not a config object), discard or destroy the existingInstance
        if (owner && config !== existingInstance && (existingInstance === null || existingInstance === void 0 ? void 0 : existingInstance[ownerSymbol]) === owner) {
          var _cleanup;

          typeof cleanup === 'string' ? owner[cleanup](existingInstance) : (_cleanup = cleanup) === null || _cleanup === void 0 ? void 0 : _cleanup(existingInstance);
          existingInstance.destroy();
        }

        return config;
      }

      type = config[typeKey];
    }

    type = type && me.resolveType(type); // We've got our orders... make it so...

    if (existingInstance) {
      // We can have a type-less config object when reconfiguring an existing instance, but if we have a type,
      // the existingInstance must be of that type. If !config that means we are nulling out.
      if (config && (!type || existingInstance.constructor === type)) {
        if (typeKey in config) {
          config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, config);
          delete config[typeKey]; // so "type" won't be processed as a config property
        }

        existingInstance.setConfig(config);
        return existingInstance;
      }

      if (owner && existingInstance[ownerSymbol] === owner) {
        var _cleanup2;

        typeof cleanup === 'string' ? owner[cleanup](existingInstance) : (_cleanup2 = cleanup) === null || _cleanup2 === void 0 ? void 0 : _cleanup2(existingInstance);
        existingInstance.destroy();
      }
    }

    if (config) {
      if (defaults) {
        if (!(mergeType = type)) {
          if (!(mergeType = defaults[typeKey] || defaultType || factoryable.defaultType)) {
            throw new Error(`No default mergeType defined for ${factoryable.class.name} factory`);
          }

          mergeType = me.resolveType(mergeType);
        }

        if (mergeType) {
          // Allow the merge fn of each config to perform the task:
          config = mergeType.mergeConfigs(defaults, config);
        }
      }

      if (setup) {
        prepared = typeof setup === 'string' ? owner[setup](config, type, defaults) : setup(config, type, defaults);

        if (prepared === null) {
          return prepared;
        }

        config = prepared || config;
      }

      if (!type) {
        // One more check on config[typeKey] since the setup() function may have added it...
        if (!(type = config[typeKey] || defaultType || factoryable.defaultType)) {
          throw new Error(`No default type defined for ${factoryable.class.name} factory`);
        }

        type = me.resolveType(type);
      }

      if (defaults && !mergeType) {
        config = type.mergeConfigs(defaults, config);
      }

      if (typeKey in config) {
        config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, config);
        delete config[typeKey]; // so "type" won't be processed as a config property
      }

      config = new type(config);

      if (owner) {
        config[ownerSymbol] = owner;
      }
    }

    return config || null;
  }
  /**
   * This method returns the constructor of the class registered for the given type name.
   * @param {String} type The type name to look up.
   * @param {Boolean} [optional] Pass `true` to return `null` if `type` is not found instead of throwing an exception.
   * @returns {Function}
   * @private
   */


  static resolveType(type, optional) {
    if (typeof type !== 'string') {
      return type;
    }

    const {
      factoryable
    } = this,
          bases = factoryable.extends;
    let result = factoryable.registry[factoryable.caseless ? type.toLowerCase() : type],
        i;

    for (i = 0; !result && bases && i < bases.length; ++i) {
      // Pass optional=true to base factory so the error is our own should the lookup fail:
      result = bases[i].resolveType(type,
      /* optional = */
      true);
    }

    if (!result && !optional) {
      throw new Error(`Invalid type name "${type}" passed to ${factoryable.class.name} factory`);
    }

    return result;
  }

});

/***/ }),

/***/ "./lib/Core/mixin/Featureable.js":
/*!***************************************!*\
  !*** ./lib/Core/mixin/Featureable.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/DynamicObject.js */ "./lib/Core/util/DynamicObject.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module Core/mixin/Featureable
 */

/**
 * This mixin provides management of a set of features that can be manipulated via the `features` config.
 *
 * The first step in using `Featureable` is to define the family of features using `Factoryable` to declare a base
 * class for features to extend:
 * ```
 *  class SuperWidgetFeature extends InstancePlugin.mixin(Factoryable) {
 *      static get factoryable() {
 *          //
 *      }
 *  }
 * ```
 *
 * The various feature classes extend the `SuperWidgetFeature` base class and call `initClass()` to register themselves:
 * ```
 *  export default class AmazingSuperWidgetFeature extends SuperWidgetFeature {
 *      static get type() {
 *          return 'amazing';
 *      }
 *  }
 *
 *  AmazingSuperWidgetFeature.initClass();
 * ```
 *
 * A class that supports these features via `Featureable` is declared like so:
 * ```
 *  class SuperWidget extends Widget.mixin(Featureable) {
 *      static get featureable() {
 *          return {
 *              factory : SuperWidgetFeature
 *          };
 *      }
 *
 *      static get configurable() {
 *          return {
 *              // Declare the default features. These can be disabled by setting them to a falsy value. Using
 *              // configurable(), the value defined by this class is merged with values defined by derived classes
 *              // and ultimately the instance.
 *              features : {
 *                  amazing : {
 *                      ...
 *                  }
 *              }
 *          };
 *      }
 *  }
 *```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Featureable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Featureable';
  }

  static get configurable() {
    return {
      /**
       * Specifies the features to create and associated with the instance. The keys of this object are the names
       * of features. The values are config objects for those feature instances.
       *
       * After construction, this property can be used to access the feature instances and even reconfigure them.
       *
       * For example:
       * ```
       *  instance.features.amazing = {
       *      // reconfigure this feature
       *  }
       * ```
       * This can also be done in bulk:
       * ```
       *  instance.features = {
       *      amazing : {
       *          // reconfigure this feature
       *      },
       *      // reconfigure other features
       *  }
       * ```
       * @config {Object}
       */
      features: null
    };
  }

  static get declarable() {
    return [
    /**
     * This property getter returns options that control feature management for the derived class. This
     * property getter must be defined by the class that mixes in `Featureable` in order to initialize the
     * class properly.
     * ```
     *  class SuperWidget extends Widget.mixin(Featureable) {
     *      static get featureable() {
     *          return {
     *              factory : SuperWidgetFeature
     *          };
     *      }
     *      ...
     *  }
     * ```
     * @static
     * @member {Object} featureable
     * @property {Core.mixin.Factoryable} featureable.factory The factoryable class (not one of its instances)
     * that will be used to create feature instances.
     * @property {String} [featureable.ownerName='client'] The config or property to assign on each feature as
     * a reference to its creator, the `Featureable` instance.
     * @internal
     */
    'featureable'];
  }

  static setupFeatureable(cls) {
    const featureable = _objectSpread({
      ownerName: 'client'
    }, cls.featureable);

    featureable.factory.initClass(); // Replace the class/static getter with a new one that returns the complete featureable object:

    Reflect.defineProperty(cls, 'featureable', {
      get() {
        return featureable;
      }

    });
  }

  doDestroy() {
    const features = this.features;
    super.doDestroy();

    for (const name in features) {
      var _feature$destroy;

      const feature = features[name]; // Feature might be false or destroyed already by Grid (EventList mixes in CalendarMixin which has this mixin)

      (_feature$destroy = feature.destroy) === null || _feature$destroy === void 0 ? void 0 : _feature$destroy.call(feature);
    }
  }
  /**
   * Returns `true` if the specified feature is active for this instance and `false` otherwise.
   * @param {String} name The feature name
   * @returns {Boolean}
   */


  hasFeature(name) {
    var _this$features;

    return Boolean((_this$features = this.features) === null || _this$features === void 0 ? void 0 : _this$features[name]);
  }

  changeFeatures(features, was) {
    if (this.isDestroying) {
      return;
    }

    const me = this,
          {
      featureable
    } = me.constructor,
          manager = me.$features || (me.$features = new _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
      configName: 'features',
      factory: featureable.factory,
      owner: me,
      ownerName: featureable.ownerName
    }));
    manager.update(features);

    if (!was) {
      // Only return the target once. Further calls are processed above so we need to return undefined to ensure
      // onConfigChange is called. By returning the same target on 2nd+ call, it passes the === test and won't
      // trigger onConfigChange.
      return manager.target;
    }
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Core/mixin/Finalizable.js":
/*!***************************************!*\
  !*** ./lib/Core/mixin/Finalizable.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';

/**
 * @module Core/mixin/Finalizable
 */

/**
 * This mixin provides an asynchronous completion mechanism. This allows a process to coordinate its async actions
 * (such as Ajax requests or user interaction) with cleanup.
 *
 * Consider a context tracking helper class, for example:
 * ```
 *  class Context extends Base.mixin(Finalizable) {
 *      // ...
 *
 *      async finish() {
 *          this.owner.trigger('finish', {
 *              context : this
 *          });
 *
 *          // Wait for any scheduled finalizer to run...
 *          await this.finalize();
 *      }
 *
 *      doFinalize() {
 *          this.destroy();
 *      }
 *  }
 * ```
 *
 * When the `finish` event is processed, the receiver can register a promise for whatever processing it would like to
 * perform:
 * ```
 *  class Foo {
 *      onFinish({ context }) {
 *          context.finalizer = this.askUser(context);
 *      }
 *
 *      async askUser(context) {
 *          //
 *      }
 *  }
 * ```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Finalizable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Finalizable';
  }

  construct(...args) {
    super.construct(...args);
    /**
     * This property can be set any time prior to calling {@link #function-finalize} (i.e., when the
     * {@link #property-isFinalizing} property goes to `true`). When set, this instance will `await` this
     * promise before completing the finalization process by calling {@link #function-doFinalize}.
     * @member {Promise} finalizer
     */

    this.finalizer = null;
    /**
     * This property holds the `Promise` that will resolve when {@link #function-finalize} has completed. It is
     * set when {@link #function-finalize} is called and cleared on return.
     * @member {Boolean} finalizing
     * @readonly
     * @private
     */

    this.finalizing = null;
    /**
     * This property is `true` once the instance completes the {@link #function-finalize} method.
     * @member {Boolean} isFinalized
     * @readonly
     */

    this.isFinalized = false;
    /**
     * This property is set to `true` when {@link #function-finalize} is called.
     * @member {Boolean} isFinalizing
     * @readonly
     */

    this.isFinalizing = false;
  }
  /**
   * This template method is called at the end of {@link #function-finalize}. By default it calls `destroy()`, but
   * can be replaced by the derived class. This can be useful if it is not the `Finalizable` instance that awaits
   * the {@link #function-finalize} method.
   */


  doFinalize() {
    this.destroy();
  }
  /**
   * This method is called (typically by this instance or its owner) to cleanup this instance while possibly first
   * waiting for the {@link #property-finalizer} promise to settle. Once settled, the {@link #function-doFinalize}
   * method is called.
   * @async
   */


  finalize() {
    const me = this;
    let ret = me.finalizing;

    if (!ret && !me.isFinalized) {
      me.isFinalizing = true; // note: we never clear this flag (use isFinalized to know if we're done)
      // If we are called during finalization, we want to return the same promise, so we cache it away.

      me.finalizing = ret = me._awaitFinalizer();
    }

    return ret;
  }

  async _awaitFinalizer() {
    const me = this;

    try {
      await me.finalizer;
    } finally {
      // be sure we clean up even if an exception is thrown by the finalizer...
      me.finalizing = null;
      me.isFinalized = true;
      me.doFinalize();
    }
  }

});

/***/ }),

/***/ "./lib/Core/mixin/Hoverable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Hoverable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Delayable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
var productName = 'taskboard';



/**
 * @module Core/mixin/Hoverable
 */

const EDGES = {
  e: 'b-hover-edge',
  t: 'b-hover-top',
  r: 'b-hover-right',
  b: 'b-hover-bottom',
  l: 'b-hover-left'
},
      EDGE_CLASSES = {
  [EDGES.e]: 1,
  [EDGES.t]: 1,
  [EDGES.r]: 1,
  [EDGES.b]: 1,
  [EDGES.l]: 1
},
      ZONES = {
  t: [EDGES.e, EDGES.t],
  r: [EDGES.e, EDGES.r],
  b: [EDGES.e, EDGES.b],
  l: [EDGES.e, EDGES.l],
  tr: [EDGES.e, EDGES.t, EDGES.r],
  bl: [EDGES.e, EDGES.b, EDGES.l],
  tl: [EDGES.e, EDGES.t, EDGES.l],
  br: [EDGES.e, EDGES.b, EDGES.r]
};
/**
 * This mixin provides mouse hover tracking.
 * ```
 *  class Tracker extends Base.mixin(Hoverable) {
 *      hoverEnter(leaving) {
 *          // this.hoverTarget has been entered from "leaving"
 *          // this.hoverTarget will never be null, but leaving may be null
 *      }
 *
 *      hoverLeave(leaving) {
 *          // this.hoverTarget has been entered from "leaving"
 *          // this.hoverTarget may be null, but leaving will never be null
 *      }
 *
 *      hoverMove(event) {
 *          // called when a mousemove is made within a hover target
 *          // this.hoverTarget will never be null
 *      }
 *  }
 *
 *  let tracker = new Tracker({
 *      hoverRootElement : document.body,
 *      hoverSelector    : '.hoverable'
 *  });
 * ```
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Hoverable extends Target.mixin(_Delayable_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Hoverable';
  } //region Configs


  static get configurable() {
    return {
      /**
       * A CSS class to add to the {@link #config-hoverTarget target} element.
       * @config {String}
       */
      hoverCls: null,

      /**
       * A CSS class to add to the {@link #config-hoverTarget target} element to enable CSS animations. This class
       * is added after calling {@link #function-hoverEnter}.
       * @config {String}
       */
      hoverAnimationCls: null,

      /**
       * A CSS class to add to the {@link #config-hoverRootElement root} element.
       * @config {String}
       */
      hoverRootCls: null,

      /**
       * A CSS class to add to the {@link #config-hoverRootElement root} element when there is an active
       * {@link #config-hoverTarget target}.
       * @config {String}
       */
      hoverRootActiveCls: null,

      /**
       * The number of milliseconds to delay notification of changes in the {@link #config-hoverTarget}.
       * @config {Number}
       */
      hoverDelay: null,

      /**
       * The current element that the cursor is inside as determined by `mouseover` and `mouseout`. Changes in
       * this config trigger re-evaluation of the {@link #config-hoverSelector} to determine if there is a
       * {@link #config-hoverTarget}.
       * @config {HTMLElement}
       * @private
       */
      hoverElement: null,

      /**
       * An element to ignore. Mouse entry into this element will not trigger a change in either of the
       * {@link #config-hoverElement} or {@link #config-hoverTarget} values.
       * @config {HTMLElement}
       */
      hoverIgnoreElement: null,

      /**
       * This property is a string containing one character for each edge that is hoverable. For example, a
       * value of "tb" indicates that the top and bottom edges are hoverable.
       * @config {String}
       */
      hoverEdges: null,

      /**
       * When {@link #config-hoverEdges} is used, this value determines the size (in pixels) of the edge. When
       * the cursor is within this number of pixels of an edge listed in `hoverEdges`, the appropriate CSS class
       * is added to the {@link #config-hoverTarget}:
       *
       *  - `b-hover-top`
       *  - `b-hover-right`
       *  - `b-hover-bottom`
       *  - `b-hover-left`
       *
       * Depending on the values of `hoverEdges`, it is possible to have at most two of these classes present at
       * any one time (when the cursor is in a corner).
       * @config {Number}
       * @default
       */
      hoverEdgeSize: 10,

      /**
       * The outer element where hover tracking will operate (attach events to it and use as root limit when
       * looking for ancestors).
       *
       * A common choice for this will be `document.body`.
       * @config {HTMLElement}
       */
      hoverRootElement: {
        $config: 'nullify',
        value: null
      },

      /**
       * A selector for the [closest](https://developer.mozilla.org/en-US/docs/Web/API/Element/closest) API to
       * determine the actual element of interest. This selector is used to process changes to the
       * {@link #config-hoverElement} to determine the {@link #config-hoverTarget}.
       * @config {String}
       */
      hoverSelector: null,

      /**
       * The currently active hover target. This will be the same as {@link #config-hoverElement} unless there is
       * a {@link #config-hoverSelector}.
       * @config {HTMLElement}
       */
      hoverTarget: {
        $config: 'nullify',
        value: null
      },

      /**
       * Set to `true` to include tracking of `mousemove` events for the active {@link #config-hoverTarget}. This
       * is required for the {@link #function-hoverMove} method to be called.
       * @config {Boolean}
       * @default false
       */
      hoverTrack: null,

      /**
       * A string value containing one character per active edge (e.g., "tr").
       * @config {String}
       * @private
       */
      hoverZone: null
    };
  }

  static get delayable() {
    return {
      setHoverTarget: 0
    };
  } //endregion
  //region State Handling

  /**
   * This method is called when the cursor enters the {@link #config-hoverTarget}. The `hoverTarget` will not be
   * `null`.
   * @param {HTMLElement} leaving The element that was previously the `hoverTarget`. This value may be null.
   */


  hoverEnter(leaving) {// template
  }
  /**
   * This method should return true if the given `element` should be ignored. By default, this is `true` if the
   * `element` is contained inside the {@link #config-hoverIgnoreElement}.
   * @param {HTMLElement} element
   * @returns {Boolean}
   * @protected
   */


  hoverIgnore(element) {
    var _this$hoverIgnoreElem;

    return (_this$hoverIgnoreElem = this.hoverIgnoreElement) === null || _this$hoverIgnoreElem === void 0 ? void 0 : _this$hoverIgnoreElem.contains(element);
  }
  /**
   * This method is called when the cursor leaves the {@link #config-hoverTarget}. The `hoverTarget` may be `null`
   * or refer to the new `hoverTarget`
   * @param {HTMLElement} leaving The element that was previously the `hoverTarget`. This value will not be null.
   */


  hoverLeave(leaving) {// template
  }
  /**
   * This method is called when the mouse moves within a {@link #config-hoverTarget}, but only if enabled by the
   * {@link #config-hoverTrack} config.
   * @param {Event} event
   */


  hoverMove(event) {// template
  } //endregion
  //region Events


  onHoverMouseMove(event) {
    const me = this,
          {
      hoverEdges,
      hoverEdgeSize,
      hoverTarget
    } = me;

    if (hoverTarget) {
      if (hoverEdges) {
        const {
          top,
          left,
          width,
          height,
          right,
          bottom
        } = hoverTarget.getBoundingClientRect(),
              {
          clientX,
          clientY
        } = event,
              centerX = left + width / 2,
              centerY = top + height / 2,
              t = clientY < (hoverEdgeSize ? top + hoverEdgeSize : centerY),
              r = clientX >= (hoverEdgeSize ? right - hoverEdgeSize : centerX),
              b = clientY >= (hoverEdgeSize ? bottom - hoverEdgeSize : centerY),
              l = clientX < (hoverEdgeSize ? left + hoverEdgeSize : centerX),
              tb = t || b ? t ? 't' : 'b' : '',
              rl = r || l ? r ? 'r' : 'l' : '';
        me.hoverZone = (hoverEdges.includes(tb) ? tb : '') + (hoverEdges.includes(rl) ? rl : '');
      }

      me.hoverEvent = event;
      me.hoverTrack && me.hoverMove(event);
    }
  }

  onHoverMouseOver(event) {
    this.hoverEvent = event;
    this.hoverElement = event.target;
  }

  onHoverMouseOut(event) {
    this.hoverEvent = event;
    this.hoverElement = event.relatedTarget;
  } //endregion
  //region Configs
  // hoverDelay


  updateHoverDelay(delay) {
    this.setHoverTarget.delay = delay;
  } // hoverEdges


  changeHoverEdges(edges) {
    return edges === true ? 'trbl' : (edges || '').replace('v', 'tb').replace('h', 'lr');
  }

  updateHoverEdges() {
    this.syncHoverListeners();
  } // hoverElement


  changeHoverElement(element) {
    if (!this.hoverIgnore(element)) {
      return element;
    }
  }

  updateHoverElement(hoverEl) {
    const {
      hoverSelector
    } = this;

    if (hoverSelector) {
      var _hoverEl;

      hoverEl = (_hoverEl = hoverEl) === null || _hoverEl === void 0 ? void 0 : _hoverEl.closest(hoverSelector);
    }

    this.setHoverTarget(hoverEl); // this may be delayed
  } // hoverRootElement


  updateHoverRootElement(rootEl, was) {
    const {
      hoverRootCls
    } = this;

    if (hoverRootCls) {
      was === null || was === void 0 ? void 0 : was.classList.remove(hoverRootCls);
      rootEl === null || rootEl === void 0 ? void 0 : rootEl.classList.add(hoverRootCls);
    }

    this.syncHoverListeners();
  } // hoverTarget


  changeHoverTarget(hoverEl, was) {
    if (was) {
      this.hoverZone = null;
    }

    return hoverEl;
  }

  updateHoverTarget(hoverEl, was) {
    const me = this,
          {
      hoverCls,
      hoverAnimationCls,
      hoverRootActiveCls,
      hoverRootElement
    } = me;

    if (hoverRootActiveCls) {
      hoverRootElement === null || hoverRootElement === void 0 ? void 0 : hoverRootElement.classList[hoverEl ? 'add' : 'remove'](hoverRootActiveCls);
    }

    if (was) {
      hoverCls && was.classList.remove(hoverCls);
      hoverAnimationCls && was.classList.remove(hoverAnimationCls);
      me.hoverLeave(was);
    }

    if (hoverEl) {
      hoverCls && hoverEl.classList.add(hoverCls);
      me.hoverEnter(was);

      if (me.hoverTrack) {
        me.hoverMove(me.hoverEvent);
      }

      if (hoverAnimationCls) {
        hoverEl.getBoundingClientRect(); // force layout so next change starts animation

        hoverEl.classList.add(hoverAnimationCls);
      }
    }
  } // hoverTrack


  updateHoverTrack() {
    this.syncHoverListeners();
  } // hoverZone


  updateHoverZone(zone) {
    const {
      hoverAnimationCls,
      hoverTarget
    } = this;

    if (hoverTarget) {
      const {
        className
      } = hoverTarget,
            cls = _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"].change(className,
      /* add= */
      zone ? ZONES[zone] : null,
      /* remove= */
      EDGE_CLASSES);

      if (className !== cls) {
        hoverTarget.className = cls;

        if (zone && hoverAnimationCls) {
          hoverTarget.classList.remove(hoverAnimationCls);
          hoverTarget.getBoundingClientRect(); // force layout so next change starts animation

          hoverTarget.classList.add(hoverAnimationCls);
        }
      }
    }
  } //endregion
  //region Misc


  setHoverTarget(target) {
    // this method runs later based on the hoverDelay
    this.hoverTarget = target;
  }

  syncHoverListeners() {
    var _me$_hoverRootDetache;

    const me = this,
          element = me.hoverRootElement,
          listeners = {
      element,
      thisObj: me,
      mouseover: 'onHoverMouseOver',
      mouseout: 'onHoverMouseOut'
    };

    if (me.hoverTrack || me.hoverEdges) {
      listeners.mousemove = 'onHoverMouseMove';
    }

    (_me$_hoverRootDetache = me._hoverRootDetacher) === null || _me$_hoverRootDetache === void 0 ? void 0 : _me$_hoverRootDetache.call(me);
    me._hoverRootDetacher = element && _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on(listeners);
  } //endregion


});

/***/ }),

/***/ "./lib/Core/mixin/Identifiable.js":
/*!****************************************!*\
  !*** ./lib/Core/mixin/Identifiable.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
var productName = 'taskboard';



/**
 * @module Core/mixin/Identifiable
 */

const // Id generation should be on a per page basis, not per module
idCounts = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getPathDefault(_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].global, 'bryntum.idCounts', Object.create(null)),
      idTypes = {
  string: 1,
  number: 1
};
/**
 * A mixin which provides identifier services such as auto-creation of `id`s and registration and
 * lookup of instances by `id`.
 *
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Identifiable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Identifiable';
  }

  static get declarable() {
    return ['identifiable'];
  }

  static get configurable() {
    return {
      /**
       * The id of this object.  If not specified one will be generated. Also used for lookups through the
       * static `getById` of the class which mixes this in. An example being {@link Core.widget.Widget}.
       *
       * For a {@link Core.widget.Widget Widget}, this is assigned as the `id` of the DOM
       * {@link Core.widget.Widget#config-element element} and must be unique across all elements
       * in the page's `document`.
       * @config {String}
       * @category Common
       */
      id: ''
    };
  }

  static setupIdentifiable(cls, meta) {
    const {
      identifiable
    } = cls;
    identifiable.idMap = Object.create(null);
    Reflect.defineProperty(cls, 'identifiable', {
      get() {
        return identifiable;
      }

    });
  }

  doDestroy() {
    this.constructor.unregisterInstance(this);
    super.doDestroy();
  }

  changeId(id) {
    return (this.hasGeneratedId
    /* assignment */
    = !id) ? this.generateAutoId() : id;
  }

  updateId(id, oldId) {
    const me = this,
          C = me.constructor;
    oldId && C.unregisterInstance(me, oldId);

    if (!me.hasGeneratedId || C.identifiable.registerGeneratedId !== false) {
      C.registerInstance(me, id);
    }
  }
  /**
   * This method generates an id for this instance.
   * @returns {String}
   * @internal
   */


  generateAutoId() {
    return this.constructor.generateId(`b-${this.$$name.toLowerCase()}-`);
  }

  static get all() {
    // not documented here since type of array is not knowable... documented at mixin target class
    return Object.values(this.identifiable.idMap);
  }
  /**
   * Generate a new id, using an internal counter and a prefix.
   * @param {String} prefix Id prefix
   * @returns {String} Generated id
   */


  static generateId(prefix = 'generatedId') {
    // This produces "b-foo-1, b-foo-2, ..." for each prefix independently of the others. In other words, it makes
    // id's more stable since the counter is on a per-class basis.
    return prefix + (idCounts[prefix] = (idCounts[prefix] || 0) + 1);
  }

  static registerInstance(instance, instanceId = instance.id) {
    const {
      idMap
    } = this.identifiable; // Code editor sets `disableThrow` to not get conflicts when loading the same module again

    if (instanceId in idMap && !this.disableThrow) {
      throw new Error('Id ' + instanceId + ' already in use');
    }

    idMap[instanceId] = instance;
  }
  /**
   * Unregister Identifiable instance, normally done on destruction
   * @param {Object} instance Object to unregister
   * @param {String} id The id of the instance to unregister.
   */


  static unregisterInstance(instance, id = instance.id) {
    const {
      idMap
    } = this.identifiable; // ID may be passed, for example if the instance is destroyed and can no longer yield an id.

    if (idTypes[typeof instance]) {
      delete idMap[instance];
    } // Have to check for identity in case another instance by the same id has been created.
    // Allow that to be overridden. Stores have always just evicted the previous owner of their IDs
    else if (idMap[id] === instance) {
      delete idMap[id];
    }
  }

  static getById(id) {
    const idMap = this.identifiable.idMap;

    if (idMap) {
      return idMap[id];
    }
  }

  static get registeredInstances() {
    const idMap = this.identifiable.idMap;
    return idMap ? Object.values(idMap) : [];
  }

});

/***/ }),

/***/ "./lib/Core/mixin/InstancePlugin.js":
/*!******************************************!*\
  !*** ./lib/Core/mixin/InstancePlugin.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return InstancePlugin; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
var productName = 'taskboard';




/**
 * @module Core/mixin/InstancePlugin
 */

function getDescriptor(me, fnName) {
  const property = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(me), fnName);
  return property && (property.get || property.set) ? property : null;
}
/**
 * Base class for plugins. Published functions will be available from the other class. `this` in published functions is
 * referenced to the plugin, access the other class using `this.client`.
 *
 * Observe that plugin doesn't apply itself on class level but instead on instance level. Plugin is its own instance
 * that can have own functions and data that is not exposed to target class.
 *
 * Functions can be published in four ways:
 *
 * * `assign` (when function is not already available on target)
 * * `before` (when function is already available on target, will be called before original function)
 * * `after` (when function is already available on target, will be called after original function)
 * * `override` (replaces function on target, but old function can be reached)
 *
 * To configure which functions get published and in what way, specify `pluginConfig` getter on plugin:
 *
 * ```
 * class Sort extends InstancePlugin {
 *   static get pluginConfig {
 *      return {
 *          before   : ['init'],
 *          after    : ['destroy', 'onElementClick'],
 *          override : ['render']
 *      };
 *   }
 * }
 * ```
 * @extends Core/Base
 * @mixes Core/localization/Localizable
 * @mixes Core/mixin/Events
 */


class InstancePlugin extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"], _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  //region Config
  static get configurable() {
    return {
      clientListeners: null,

      /**
       * Get/set the plugin/feature `disabled` state.
       * @member {Boolean} disabled
       * @category Common
       */

      /**
       * The plugin/feature `disabled` state.
       *
       * For a feature that is **off** by default that you want to enable later during runtime,
       * configure it with `disabled : true`.
       * ```javascript
       * const grid = new Grid({
       *      features : {
       *          featureName : {
       *              disabled : true // on and disabled, can be enabled later
       *          }
       *      }
       * });
       *
       * // enable the feature
       * grid.features.featureName.disabled = false;
       * ```
       *
       * If the feature is **off** by default, and you want to include and enable the feature, configure it as `true`:
       * ```javascript
       * const grid = new Grid({
       *      features : {
       *          featureName : true // on and enabled, can be disabled later
       *      }
       * });
       *
       * // disable the feature
       * grid.features.featureName.disabled = true;
       * ```
       *
       * If the feature is **on** by default, but you want to turn it **off**, configure it as `false`:
       * ```javascript
       * const grid = new Grid({
       *      features : {
       *          featureName : false // turned off, not included at all
       *      }
       * });
       * ```
       *
       * If the feature is **enabled** by default and you have no need of reconfiguring it,
       * you can omit the feature configuration.
       *
       * @config {Boolean}
       * @default
       * @category Common
       */
      disabled: false
    };
  } //endregion
  //region Init

  /**
   * Call from another instance to add plugins to it.
   * @example
   * InstancePlugin.initPlugins(this, Search, Stripe);
   * @param plugInto Instance to mix into (usually this)
   * @param plugins Classes to plug in
   * @internal
   */


  static initPlugins(plugInto, ...plugins) {
    const property = plugInto.plugins || (plugInto.plugins = {});

    for (const PluginClass of plugins) {
      property[PluginClass.$$name] = new PluginClass(plugInto);
    }
  }
  /**
   * The Widget which was passed into the constructor,
   * which is the Widget we are providing extra services for.
   * @property {Core.widget.Widget}
   * @readonly
   * @category Misc
   */


  get client() {
    return this._client;
  }

  set client(client) {
    this._client = client;
  } // We can act as an owner of a widget, so must be able to participate in focus reversion


  getFocusRevertTarget() {
    var _this$client;

    return (_this$client = this.client) === null || _this$client === void 0 ? void 0 : _this$client.getFocusRevertTarget();
  }

  construct(...args) {
    const me = this;
    let [plugInto, config] = args,
        listeners; // When called with one argument (a config object), grab the "client" from the config object.

    if (args.length === 1) {
      if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isObject(plugInto)) {
        config = plugInto;
        plugInto = config.client;
      }
    } // Two args, so client is the first. Ensure the config doesn't contain a client property.
    else {
      config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, config);
      delete config.client;
    }

    me.client = plugInto;
    super.construct(config);
    me.applyPluginConfig(plugInto);
    listeners = me.clientListeners;

    if (listeners) {
      listeners = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, listeners);
      listeners.thisObj = me;
      plugInto.on(listeners);
    }
  }
  /**
   * Applies config as found in plugInto.pluginConfig, or published all if no config found.
   * @private
   * @param plugInto Target instance to plug into
   */


  applyPluginConfig(plugInto) {
    const me = this,
          config = me.pluginConfig || me.constructor.pluginConfig;

    if (config) {
      const {
        assign,
        chain,
        after,
        before,
        override
      } = config;
      assign && me.applyAssign(plugInto, assign);
      (chain || after) && me.applyChain(plugInto, chain || after);
      before && me.applyChain(plugInto, before, false);
      override && me.applyOverride(plugInto, override);
    }
  }
  /**
   * Applies assigning for specified functions.
   * @private
   * @param plugInto
   * @param fnNames
   */


  applyAssign(plugInto, fnNames) {
    fnNames.forEach(fnName => this.assign(plugInto, fnName));
  }
  /**
   * Applies chaining for specified functions.
   * @private
   * @param plugInto
   * @param functions
   * @param after
   */


  applyChain(plugInto, functions, after = true) {
    if (Array.isArray(functions)) {
      for (const fnName of functions) {
        this.chain(plugInto, fnName, fnName, after);
      }
    } else {
      for (const intoName in functions) {
        this.chain(plugInto, intoName, functions[intoName], after);
      }
    }
  }
  /**
   * Applies override for specified functions.
   * @private
   * @param plugInto
   * @param fnNames
   */


  applyOverride(plugInto, fnNames) {
    const me = this;

    if (!me.overridden) {
      me.overridden = {};
    }

    fnNames.forEach(fnName => {
      if (!me[fnName]) {
        throw new Error(`Trying to chain fn ${plugInto.$$name}#${fnName}, but plugin fn ${me.$$name}#${fnName} does not exist`);
      } // override


      if (typeof plugInto[fnName] === 'function') {
        me.overridden[fnName] = plugInto[fnName].bind(plugInto);
      }

      plugInto[fnName] = me[fnName].bind(me);
    });
  }
  /**
   * Assigns specified functions.
   * @private
   * @param plugInto
   * @param fnName
   */


  assign(plugInto, fnName) {
    const me = this,
          property = getDescriptor(me, fnName);

    if (property) {
      // getter/setter, define corresponding property on target
      Object.defineProperty(plugInto, fnName, {
        configurable: true,
        enumerable: true,
        get: property.get && property.get.bind(me),
        set: property.set && property.set.bind(me)
      });
    } else {
      plugInto[fnName] = me[fnName].bind(me);
    }
  } //endregion
  //region Chaining

  /**
   * Chains functions. When the function is called on the target class all functions in the chain will be called in
   * the order they where added.
   * @private
   * @param plugInto
   * @param intoName
   * @param hookName
   * @param after
   */


  chain(plugInto, intoName, hookName, after = true) {
    const me = this,
          chains = plugInto.pluginFunctionChain || (plugInto.pluginFunctionChain = {}),
          hookFn = me[hookName] && me[hookName].bind(me),
          // Grab the fn so that we won't need our this pointer to call it. This is due
    // to this instance possibly being destroyed by the time a chain call is made.
    functionChainRunner = me.functionChainRunner;

    if (!hookFn) {
      throw new Error(`Trying to chain fn ${plugInto.$$name}#${hookName}, but plugin fn ${me.$$name}#${hookName} does not exist`);
    }

    if (!chains[intoName]) {
      let intoFn = plugInto[intoName];

      if (intoFn) {
        intoFn = intoFn.bind(plugInto);
        intoFn.$this = plugInto;
      }

      chains[intoName] = intoFn ? [intoFn] : [];

      plugInto[intoName] = (...params) => functionChainRunner(chains[intoName], params);
    }

    hookFn.$this = me;
    chains[intoName][after ? 'push' : 'unshift'](hookFn);
  }
  /**
   * Used to run multiple plugged in functions with the same name, see chain above. Returning false from a
   * function will abort chain.
   * @private
   * @param {Array} chain
   * @param {Array} params
   * @returns value returned from last function in chain (or false if any returns false)
   */


  functionChainRunner(chain, params) {
    // NOTE: even though we are an instance method, we must not use our "this" pointer
    // since our instance may be destroyed. We cope with that by receiving parameters
    // for everything we need (so we're just a pure function).
    let fn, i, returnValue; // changed from for..of to try and fix Edge problems

    for (i = 0; i < chain.length; i++) {
      fn = chain[i]; // Feature hooks remain in place even after GridBase loops and destroys its
      // features, so skip over any destroyed features on the chain. In particular,
      // bindStore hooks will be called when GridBase sets store to null.

      if (!fn.$this.isDestroyed) {
        returnValue = fn(...params);

        if (returnValue === false) {
          break;
        }
      }
    }

    return returnValue;
  } //endregion

  /**
   * Called when disabling/enabling the plugin/feature, not intended to be called directly. To enable or disable a
   * plugin/feature, see {@link #property-disabled}.
   *
   * By default removes the cls of the plugin from its client. Override in subclasses to take any other actions necessary.
   */


  doDisable(disable) {
    const me = this,
          {
      constructor
    } = me,
          cls = 'featureClass' in constructor ? constructor.featureClass : `b-${constructor.$$name.toLowerCase()}`; // Some features do not use a cls

    if (cls) {
      var _me$client, _me$client$element;

      (_me$client = me.client) === null || _me$client === void 0 ? void 0 : (_me$client$element = _me$client.element) === null || _me$client$element === void 0 ? void 0 : _me$client$element.classList[disable ? 'remove' : 'add'](cls);
    }

    if (!me.isConfiguring) {
      if (disable) {
        /**
         * Fired when the plugin/feature is disabled.
         * @event disable
         * @param {Core.mixin.InstancePlugin} source
         */
        me.trigger('disable');
      } else {
        /**
         * Fired when the plugin/feature is enabled.
         * @event enable
         * @param {Core.mixin.InstancePlugin} source
         */
        me.trigger('enable');
      }
    }
  }

  updateDisabled(disabled) {
    this.doDisable(disabled);
  }

  throwOverrideIsMissing(data) {
    throw new Error(`Trying to override fn ${data.plugIntoName}#${data.fnName}, but plugin fn ${data.pluginName}#${data.fnName} does not exist`);
  } // Convenience method to read the rootElement from the owner widget


  get rootElement() {
    return this.client.rootElement;
  }

}
InstancePlugin._$name = 'InstancePlugin';

/***/ }),

/***/ "./lib/Core/mixin/LoadMaskable.js":
/*!****************************************!*\
  !*** ./lib/Core/mixin/LoadMaskable.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _widget_Mask_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../widget/Mask.js */ "./lib/Core/widget/Mask.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';


/**
 * @module Core/mixin/LoadMaskable
 */

/**
 * Simple mixin for load masking configs and helper methods.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class LoadMaskable extends Target {
  static get $name() {
    return 'LoadMaskable';
  }

  static get configurable() {
    return {
      /**
       * A {@link Core.widget.Mask} config object to adjust the {@link Core.widget.Widget#config-maskDefaults}
       * when data is loading. The message and optional configuration from the
       * {@link Core.mixin.LoadMaskable#config-loadMask} config take priority over these options, just as they do
       * for `maskDefaults`, respectively.
       *
       * The final mask configuration for a load mask is as if the following were applied:
       *
       * ```
       *  Object.assign({},
       *      widget.maskDefaults,
       *      widget.loadMaskDefaults,
       *      widget.loadMask);
       * ```
       * @config {Object|Core.widget.Mask}
       * @category Masking
       */
      loadMaskDefaults: {
        useTransition: true,
        showDelay: 1000
      },

      /**
       * A {@link Core.widget.Mask} config object to adjust the {@link Core.widget.Widget#config-maskDefaults}
       * when an error occurs loading data.
       *
       * The final mask configuration for an error mask is as if the following were applied:
       *
       * ```
       *  Object.assign({},
       *      widget.maskDefaults,
       *      widget.loadMaskDefaults,
       *      widget.loadMaskError,
       *      errorMessage);
       * ```
       * @config {Object|Core.widget.Mask}
       * @category Masking
       */
      loadMaskError: {
        icon: 'b-icon b-icon-warning',
        autoClose: 3000,
        showDelay: 0
      },

      /**
       * A {@link Core.widget.Mask} config object, or a message to be shown when a store is performing a remote operation,
       * or Crud Manager is loading data from the sever. Set to `null` to disable default load mask.
       *
       * @config {String|Object|null}
       * @default "Loading..."
       * @category Masking
       */
      loadMask: {
        text: 'L{GridBase.loadMask}'
      },

      /**
       * A {@link Core.widget.Mask} config object, or a message to be shown when Crud Manager
       * is persisting changes on the server. Set to `null` to disable default sync mask.
       *
       * This config is similar to {@link Core.mixin.LoadMaskable#config-loadMask} but designed for saving data.
       *
       * To create a custom sync mask need to subscribe to the Crud Manager events and show
       * {@link Core.widget.Mask Mask} on `beforeSend` and hide it on `requestDone` and `requestFail`.
       *
       * To create a custom sync mask, set this config to `null` and subscribe to the CrudManager's events to
       * show or hide the {@link Core.widget.Widget#config-masked mask} as desired.
       *
       * ```javascript
       *  widget.crudManager.on({
       *      loadStart() {
       *          widget.masked = {
       *              text : 'Data is loading...'
       *          };
       *      },
       *      load() {
       *          widget.masked = null;
       *      },
       *      loadCanceled() {
       *          widget.masked = null;
       *      },
       *      syncStart() {
       *          widget.masked = null;
       *      },
       *      sync() {
       *          widget.masked = null;
       *      },
       *      syncCanceled() {
       *          widget.masked = null;
       *      },
       *      requestFail({ response }) {
       *          widget.masked.error = response.message || 'Sync failed';
       *      }
       *  });
       *
       *  store.load();
       * ```
       *
       * @config {String|Object|null}
       * @default "Saving changes, please wait..."
       * @category Masking
       */
      syncMask: {
        text: 'L{GridBase.syncMask}'
      },
      localizableProperties: ['loadMask.text', 'syncMask.text']
    };
  }
  /**
   * Applies the {@link Core.mixin.LoadMaskable#config-loadMask} as the {@link Core.widget.Widget#config-masked mask}
   * for this widget.
   * @internal
   */


  applyLoadMask() {
    const me = this,
          {
      loadMask
    } = me;

    if (loadMask) {
      me.masked = _widget_Mask_js__WEBPACK_IMPORTED_MODULE_0__["default"].mergeConfigs(me.loadMaskDefaults, loadMask);
    }
  }
  /**
   * Updates the current {@link Core.widget.Widget#config-masked mask} for this widget to present the specified
   * `error`.
   * @param {String} error The error message to display in the mask.
   * @internal
   */


  applyMaskError(error) {
    const {
      loadMaskError,
      masked
    } = this;

    if (masked) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign(masked.errorDefaults, loadMaskError);
      masked.error = error;
    }
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Core/mixin/Override.js":
/*!************************************!*\
  !*** ./lib/Core/mixin/Override.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Override; });
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'taskboard';

/**
 * @module Core/mixin/Override
 */

const excludedPropNames = {
  constructor: 1,
  prototype: 1,
  name: 1,
  length: 1,
  arguments: 1,
  caller: 1,
  callee: 1,
  __proto__: 1
};
/**
 * Simplifies overriding class methods by allowing methods from another class to be used as overrides.
 * Overrides are defined as own classes. They must at a minimum contain a static getter named targetClass, which
 * should return the class to override. Apply the override by calling {@link #function-apply-static apply()}.
 *
 * @example
 * class TemplateColumnOverride {
 *   static get target() {
 *     return {
 *             class: TemplateColumn,
 *             product: 'grid',
 *             minVersion: '1.0',
 *             maxVersion: '1.5'
 *     }
 *   }
 *
 *   renderer(renderData) {
 *       // call overridden function (optional)
 *       const value = this._overridden.renderer.call(this, renderData);
 *
 *       return 'HELLO' + value;
 *   }
 * }
 * Override.apply(TemplateColumnOverride);
 */

class Override {
  /**
   * Apply override. We strongly suggest that you at least specify a maxVersion for your overrides.
   * ```
   * class OriginalOverride {
   *     static get target() {
   *         return {
   *             class: Original,
   *             product: 'grid',
   *             minVersion: '1.0',
   *             maxVersion: '1.5'
   *         }
   *     }
   * }
   * ```
   * @param {Object} override An override class definition
   */
  static apply(override) {
    if (!override.target) throw new Error('Override must specify what it overrides, using static getter target');
    if (!override.target.class) throw new Error('Override must specify which class it overrides, using target.class');
    if (!this.shouldApplyOverride(override)) return false;
    const staticKeys = Object.getOwnPropertyNames(override),
          instanceKeys = Object.getOwnPropertyNames(override.prototype);
    staticKeys.splice(staticKeys.indexOf('target'), 1);
    this.internalOverrideAll(override.target.class, staticKeys, override);
    this.internalOverrideAll(override.target.class.prototype, instanceKeys, override.prototype);
    return true;
  }

  static internalOverrideAll(targetClass, properties, overrideDefinition) {
    Reflect.ownKeys(overrideDefinition).forEach(key => {
      if (properties.includes(key) && !excludedPropNames[key]) {
        const desc = Object.getOwnPropertyDescriptor(overrideDefinition, key);
        let currentTargetClass = targetClass;
        let targetProperty = null; // Walk up the prototype chain to find fn, needed for mixin overrides applied to class that has them
        // mixed in

        while (!targetProperty && currentTargetClass) {
          targetProperty = Object.getOwnPropertyDescriptor(currentTargetClass, key);

          if (!targetProperty) {
            currentTargetClass = Object.getPrototypeOf(currentTargetClass);
          }
        }

        if (targetProperty) {
          this.internalOverride(currentTargetClass, key, desc, targetProperty);
        }
      }
    });
  }

  static internalOverride(target, key, desc, targetDesc) {
    const overrides = target._overridden = target._overridden || {};
    overrides[key] = target[key];

    if (targetDesc.get) {
      Object.defineProperty(target, key, {
        enumerable: false,
        configurable: true,
        get: desc.get
      });
    } else {
      target[key] = desc.value;
    }
  }
  /**
   * Checks versions if an override should be applied. Specify version in your overrides target config
   * @param override
   * @returns {Boolean}
   * @example
   * class OriginalOverride {
   *     static get target() {
   *         return {
   *             class: Original,
   *             product: 'grid',
   *             minVersion: '1.0',
   *             maxVersion: '1.5'
   *         }
   *     }
   * }
   * @private
   */


  static shouldApplyOverride(override) {
    const config = override.target; // not using versioning, allow override

    if (!config.maxVersion && !config.minVersion) return true; // must specify product to be able to lookup versions

    if (!config.product) throw new Error('Override must specify product when using versioning'); // override is for older version, disallow

    if (config.maxVersion && _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"][config.product].isNewerThan(config.maxVersion)) {
      return false;
    } // override is for newer version, disallow


    if (config.minVersion && _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"][config.product].isOlderThan(config.minVersion)) {
      return false;
    } // override is for current version, allow


    return true;
  }

}
Override._$name = 'Override';

/***/ }),

/***/ "./lib/Core/mixin/Pluggable.js":
/*!*************************************!*\
  !*** ./lib/Core/mixin/Pluggable.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
var productName = 'taskboard';


/**
 * @module Core/mixin/Pluggable
 */

/**
 * Enables using plugins for a class by specifying property plugins as an array of plugin classes. If only a single plugin
 * is used, just give the plugin class instead of an array. This class isn't required for using plugins, just makes it
 * easier. Without mixin you can otherwise use `InstancePlugin.initPlugins(this, PluginClass)`.
 *
 * @example
 * new Store({
 *   plugins: [PluginClass, ...]
 * });
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Pluggable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Pluggable';
  }
  /**
   * Specify plugins (an array of classes) in config
   * @config {Function[]} plugins
   * @category Misc
   */

  /**
   * Map of applied plugins
   * @property {Object}
   * @readonly
   * @category Misc
   */


  get plugins() {
    if (!this._plugins) {
      this._plugins = {};
    }

    return this._plugins;
  }

  set plugins(plugins) {
    if (plugins) {
      if (!Array.isArray(plugins)) plugins = [plugins];
      _InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"].initPlugins(this, ...plugins);
    }

    this.initPlugins();
  }
  /**
   * Template method which may be implemented in subclasses to initialize any plugins.
   * This method is empty in the `Pluggable` base class.
   * @internal
   */


  initPlugins() {}
  /**
   * Adds plugins to an instance.
   * @param {Function[]} plugins The plugins to add
   */


  addPlugins(...plugins) {
    _InstancePlugin_js__WEBPACK_IMPORTED_MODULE_1__["default"].initPlugins(this, ...plugins);
  }
  /**
   * Checks if instance has plugin.
   * @param {String|Function} pluginClassOrName Plugin or name to check for
   * @returns {Boolean}
   */


  hasPlugin(pluginClassOrName) {
    return this.getPlugin(pluginClassOrName) != null;
  }
  /**
   * Get a plugin instance.
   * @param {String|Function} pluginClassOrName
   * @returns {Object}
   */


  getPlugin(pluginClassOrName) {
    if (typeof pluginClassOrName === 'function') pluginClassOrName = pluginClassOrName.$$name;
    return this.plugins && this.plugins[pluginClassOrName];
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Core/mixin/State.js":
/*!*********************************!*\
  !*** ./lib/Core/mixin/State.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';

/**
 * @module Core/mixin/State
 */

/**
 * Mixin that simplifies handling state for an ui component. Classes that uses this mixin must implement `getState()` and
 * `applyState(state)`.
 *
 * ```
 * class MyUIComponent extends State() {
 *   getState() {
 *     return {
 *       this.text,
 *       this.size
 *     }
 *   }
 *
 *   applyState(state) {
 *      this.text = state.text;
 *      this.size = state.size;
 *   }
 * }
 * ```
 *
 * @demo Grid/state
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class State extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'State';
  } //getState() {}
  //applyState(State) {}

  /**
   * Gets or sets a component's state
   * @property {Object}
   * @category Misc
   */


  get state() {
    this._state = this.getState();
    return this._state;
  }

  set state(state) {
    this._state = state;
    this.applyState(state);
  } // This does not need a className on Widgets.
  // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
  // to the Widget it's mixed in to should implement thus.


  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Core/util/Animator.js":
/*!***********************************!*\
  !*** ./lib/Core/util/Animator.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Animator; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/util/Promissory.js */ "./lib/Core/helper/util/Promissory.js");
var productName = 'taskboard';





/**
 * @module Core/util/Animator
 */

const {
  assign
} = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"],
      now = () => performance.now(),
      nostart = {
  start: false
},
      unitRe = /^[.\d]+([^\d].*)?$/,
      getTransitions = element => {
  const $bryntum = element.$bryntum || (element.$bryntum = {});
  return $bryntum.transitions || ($bryntum.transitions = Object.create(null));
},
      milliseconds = (duration, unit) => {
  if (typeof duration === 'string') {
    var _unitRe$exec;

    unit = (_unitRe$exec = unitRe.exec(duration)) === null || _unitRe$exec === void 0 ? void 0 : _unitRe$exec[1];
    duration = parseFloat(duration);
  } // a number could be sec or ms so guess sec if duration is small


  return duration && duration * (unit === 's' || !unit && duration < 10 ? 1000 : 1);
},
      syncTransitions = element => {
  const all = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].values(getTransitions(element)).filter(a => a.completed == null).map(a => a.toString());
  element.style.transition = all.join(', ');
},
      Anim = Target => class Anim extends Target {
  static get prototypeProperties() {
    return {
      _delay: null,
      _duration: null,
      _retain: null,
      _timing: null,
      _unit: null,
      owner: null,
      reverting: null
    };
  }

  constructor(...args) {
    super(...args);
    this.id = ++idSeed;
  }

  start() {
    this.startTime = now();
  }

  get delay() {
    var _ref, _this$_delay, _this$owner;

    return milliseconds((_ref = (_this$_delay = this._delay) !== null && _this$_delay !== void 0 ? _this$_delay : (_this$owner = this.owner) === null || _this$owner === void 0 ? void 0 : _this$owner.delay) !== null && _ref !== void 0 ? _ref : 0, this.unit);
  }

  set delay(v) {
    this._delay = v;
  }

  get duration() {
    var _this$_duration;

    const {
      owner,
      unit
    } = this;
    return milliseconds((_this$_duration = this._duration) !== null && _this$_duration !== void 0 ? _this$_duration : owner ? owner.duration : Animator.defaultDuration, unit);
  }

  set duration(v) {
    this._duration = v;
  }

  get elapsed() {
    return now() - this.startTime;
  }

  get remaining() {
    return this.duration - this.elapsed;
  }

  get retain() {
    var _this$_retain, _this$owner2;

    return (_this$_retain = this._retain) !== null && _this$_retain !== void 0 ? _this$_retain : (_this$owner2 = this.owner) === null || _this$owner2 === void 0 ? void 0 : _this$owner2.retain;
  }

  set retain(v) {
    this._retain = v;
  }

  get timing() {
    var _this$_timing, _this$owner3;

    return (_this$_timing = this._timing) !== null && _this$_timing !== void 0 ? _this$_timing : (_this$owner3 = this.owner) === null || _this$owner3 === void 0 ? void 0 : _this$owner3.timing;
  }

  set timing(v) {
    this._timing = v;
  }

  get unit() {
    var _this$_unit, _this$owner4;

    return (_this$_unit = this._unit) !== null && _this$_unit !== void 0 ? _this$_unit : (_this$owner4 = this.owner) === null || _this$owner4 === void 0 ? void 0 : _this$owner4.unit;
  }

  set unit(v) {
    this._unit = v;
  }

};

let idSeed = 0;
/**
 * These objects are passed as values in the config object of an `Animator`. The `property` name is the key in the
 * config object.
 *
 * For example:
 * ```javascript
 *  const anim = Animator.run({
 *      element,
 *      opacity : {
 *          // AnimatorTransition properties
 *      }
 *  });
 * ```
 * The {@link Core.util.Animator#config-items anim.items} array will contain a single `AnimatorTransition` instance.
 *
 * @typedef {Object} AnimatorTransition
 * @property {Number|String} property The name of the style property from the key in the `Animator` config object (in
 * the above example, this will be `'opacity'`).
 * @property {Boolean} completed This readonly property is set to `true` when the transition completes.
 * @property {Number|String} [delay=0] The delay before starting the transition. Numbers less than 10 are assumed to be
 * seconds (instead of milliseconds) unless the `unit` property is specified.
 * @property {Number|String} [duration=200] The duration of the transition. Numbers less than 10 are assumed to be
 * seconds (instead of milliseconds) unless the `unit` property is specified.
 * @property {Number|String} [from] The value from which to start the transition.
 * @property {Boolean} [retain] Set to `true` to retain the style property value after the transition. This defaults to
 * `true` if a {@link Core.util.Animator#config-finalize} function is not specified.
 * @property {String} [timing='ease-in-out'] The transition
 * [timing function](https://developer.mozilla.org/en-US/docs/Web/CSS/transition-timing-function).
 * @property {Number|String} to The final value to which the transition will animate.
 * @property {String} [unit] The duration/delay unit (either `'s'` or `'ms'`).
 * @internal
 */

class AnimatorTransition extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(Anim) {
  static get $name() {
    return 'AnimatorTransition';
  }

  static get prototypeProperties() {
    return {
      element: null,
      property: null,
      from: null,
      to: null,
      completed: null,
      promissory: null,
      reverting: null
    };
  }

  afterConstruct() {
    super.afterConstruct();
    const me = this,
          {
      element,
      transitions
    } = me;
    let {
      property
    } = me;
    [property, me.to] = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].unitize(property, me.to);
    me.from = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].unitize(property, me.from)[1];
    me.promissory = new _helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_4__["default"]();
    me.property = property;
    const was = transitions[property];
    transitions[property] = me;
    let {
      from
    } = me;

    if (was) {
      // Remember where we come from. If there was an animation running, its "to" value is where we would have
      // been had it completed.
      me.from = was.to;
      from = null;
      was.destroy();
    }

    if (from === null) {
      from = me.getCurrentStyleValue();

      if (!was) {
        me.from = from;
      }
    } // Set transitioning style's initial value


    element.style[property] = from; // then read the style to ensure transition will animate

    me.getCurrentStyleValue();
  }

  doDestroy() {
    const me = this;
    me.finish(false);

    if (me.completed && !me.retain) {
      me.clearStyle();
    }

    super.doDestroy();
  }

  get promise() {
    var _this$promissory;

    return (_this$promissory = this.promissory) === null || _this$promissory === void 0 ? void 0 : _this$promissory.promise;
  }

  get transitions() {
    return getTransitions(this.element);
  }

  clearStyle() {
    this.setStyle('');
  }

  finish(complete) {
    const me = this,
          {
      transitions,
      promissory,
      property
    } = me;

    if (promissory) {
      me.completed = complete;
      me.promissory = null;
      promissory.resolve(complete);

      if (transitions[property] === me) {
        delete transitions[property];

        if (!complete) {
          // if we are the current transition, this destroy is a cancellation of the animation (not a
          // revert), so remove our transition and clear the style to reset the element.
          syncTransitions(me.element);
          me.clearStyle();
        }
      } else {
        me.completed = false; // this can most likely never happen, but better to be safe
      }
    }
  }

  getCurrentStyleValue() {
    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(this.element, this.property);
  }

  revert() {
    const {
      duration,
      elapsed,
      element,
      from,
      property,
      _retain: retain,
      _timing: timing
    } = this;
    return new AnimatorTransition({
      element,
      property,
      retain,
      timing,
      duration: Math.round(Math.min(duration, elapsed)),
      reverting: this,
      to: from,
      unit: 'ms'
    });
  }

  setStyle(value) {
    this.element.style[this.property] = value;
  }

  start() {
    const me = this,
          {
      delay,
      duration,
      element,
      property
    } = me;
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].onTransitionEnd({
      element,
      property,
      duration: delay + duration + 20,
      thisObj: me.owner,
      handler: () => {
        var _me$finish;

        return (_me$finish = me.finish) === null || _me$finish === void 0 ? void 0 : _me$finish.call(me, true);
      } // finish() is gone if destroyed

    });
    super.start();
    me.setStyle(me.to);
  }

  toString() {
    const {
      delay,
      duration,
      property,
      timing
    } = this;
    return `${property} ${duration}ms ${timing || 'ease-in-out'}${delay ? ` ${delay}ms` : ''}`;
  }

}

AnimatorTransition.initClass();
/**
 * Manages one or more {@link AnimatorTransition style transitions} or other `Animator` instances. Unlike typical
 * config objects, the config object for this class is a mixture of config properties and style names that define
 * {@link AnimatorTransition style transitions}.
 *
 * For example:
 * ```javascript
 *  const anim = Animator.run({
 *      element,
 *      duration : 500,
 *
 *      // style transitions:
 *      opacity : 0
 *  });
 *
 *  await anim.done();
 * ```
 *
 * The static {@link #function-run-static} method is typically used (as above) instead of the `new Animator()` style for
 * brevity (since a manually created `Animator` must also be manually {@link #function-start started}).
 *
 * An `Animator` can be {@link #function-done awaited} and will resolve once all of its transitions and/or child
 * animations complete or are aborted (via `destroy()`).
 *
 * ## Compound Transitions
 * The following custom transitions can present in the `Animator` config object as if they were normal style transitions:
 *
 * - {@link #function-puff-static}
 *
 * For example:
 * ```javascript
 *  const anim = Animator.run({
 *      element,
 *      marginLeft : -200,
 *      puff       : true   // true for default scale, a number, or config object
 *  });
 * ```
 * @extends Core/Base
 * @internal
 */

class Animator extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(Anim) {
  static get $name() {
    return 'Animator';
  }

  static get prototypeProperties() {
    return {
      /**
       * The optional delay before starting the animation. Numbers less than 10 are assumed to be seconds
       * (instead of milliseconds) unless the `unit` property is specified.
       * @config {Number|String} delay
       */

      /**
       * The duration of the animation. Numbers less than 10 are assumed to be seconds (instead of milliseconds)
       * unless the `unit` property is specified.
       * @config {Number|String} duration
       * @default
       */

      /**
       * The element to animate.
       * @config {HTMLElement} element
       */
      element: null,

      /**
       * A callback function called when the animation completes. This is called after restoring styles to the
       * original values (based on {@link #config-retain}). When this function is provided, `retain` defaults to
       * `false`. By implementing this function, a CSS class can be applied to the {@link #config-element} to
       * give the proper style, while the inline styles are removed (e.g., a hide animation based on opacity).
       *
       * For example:
       * ```javascript
       *  const anim = Animator.run({
       *      element,
       *      duration : 500,
       *      opacity  : 0,
       *
       *      finalize() {
       *          element.classList.add('hidden');
       *      }
       *  });
       *
       *  await anim.done();
       * ```
       * @config {Function} finalize
       */
      finalize: null,

      /**
       * A callback function called when the animation completes. This is called prior to restoring styles to the
       * original values (based on {@link #config-retain}).
       * @config {Function} prefinalize
       * @internal
       */
      prefinalize: null,

      /**
       * Set to `true` to retain the style property values after the animation. This defaults to `true` if a
       * {@link #config-finalize} function is not specified, and `false` otherwise. When a `finalize` function
       * is provided, it is typically to apply a CSS class to achieve the desired styling so that inline styles
       * can be removed.
       * @config {Boolean} retain
       */

      /**
       * The [timing function](https://developer.mozilla.org/en-US/docs/Web/CSS/transition-timing-function) for
       * the animation.
       * @config {String} timing
       * @default 'ease-in-out'
       */

      /**
       * The duration/delay unit (either `'s'` or `'ms'`).
       * @config {String} unit
       */

      /**
       * This readonly property is set to `true` when the animation completes or `false` if the animation is
       * aborted (by calling the `destroy()` method).
       * @member {Boolean} completed
       * @readonly
       */
      completed: null,

      /**
       * An array containing a mixture of `Animator` and/or `AnimatorTransition` objects, depending on what was
       * specified at construction time.
       * @member {Core.util.Animator[]|AnimatorTransition[]} items
       * @readonly
       */

      /**
       * When passed at construction time, `items` can be an array of other `Animator` config objects. This can be
       * used to animate multiple elements and wait for this instance to be {@link #function-done done}.
       * @config {Core.util.Animator[]} items
       */
      items: null
    };
  }

  static register(name, fn) {
    if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isObject(name)) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].entries(name).forEach(entry => Animator.register(...entry));
      return;
    }

    Animator.fx[name] = fn;

    Animator[name] = options => {
      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isElement(options)) {
        options = {
          element: options,
          [name]: {}
        };
      } else {
        options = {
          element: options.element,
          [name]: options
        };
        delete options[name].element;
      }

      return Animator.run(options);
    };
  }
  /**
   * A short-hand way to create an `Animator` instance and call its {@link #function-start} method.
   *
   * ```javascript
   *  const anim = Animator.run({
   *      element,
   *      duration : 500,
   *
   *      // style transitions:
   *      opacity : 0
   *  });
   *
   *  await anim.done();
   * ```
   * @param {Core.util.Animator|Object} options A config object for an `Animator` instance.
   * @returns {Core.util.Animator}
   */


  static run(options) {
    return new Animator(options).start();
  }

  constructor(options) {
    var _me$items;

    super(null); // our options is not like a normal config object since is has styles mixed in w/configs

    const me = this,
          items = [],
          properties = {};
    let anim, fx, key, t;

    if (Array.isArray(options)) {
      me.items = options;
    } else {
      for (key in options) {
        (Animator.specialPropsRe.test(key) ? me : properties)[key] = options[key];
      }
    }

    _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].keys(properties).forEach(property => {
      t = properties[property]; // ignore values of null, undefined, false and NaN (NaN !== NaN)

      if (t != null && t !== false && t === t) {
        // eslint-disable-line no-self-compare
        if (!(fx = Animator.fx[property])) {
          t = assign(me.defaults, typeof t === 'object' ? t : {
            to: t
          });
          t.owner = me;
          t.property = property;
          anim = new AnimatorTransition(t);
        } else {
          t = assign(me.defaults, fx(t, me, property));
          t.owner = me;
          anim = new Animator(t);
        }

        items.push(anim);
      }
    }); // me.items can be set if options was an array or if options.items was passed.

    (_me$items = me.items) === null || _me$items === void 0 ? void 0 : _me$items.forEach(item => {
      if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isInstantiated(item)) {
        item.owner = me;
      } else {
        item = assign(me.defaults, item);
        item.owner = me;
        item = new Animator(item);
      }

      items.push(item);
    });
    me.items = items;
    me.promise = (items.length === 1 ? items[0].promise : Promise.all(items.map(it => it.promise))).then(res => {
      var _me$finish2;

      (_me$finish2 = me.finish) === null || _me$finish2 === void 0 ? void 0 : _me$finish2.call(me, res);
      return me.completed || false;
    });
  }

  doDestroy() {
    this.items.forEach(a => a.destroy());
    super.doDestroy();
  }

  get defaults() {
    return {
      element: this.element
    };
  }

  get retain() {
    const {
      _retain,
      finalize,
      owner
    } = this;
    return _retain !== null && _retain !== void 0 ? _retain : finalize ? false : owner ? owner.retain : true;
  }

  set retain(v) {
    super.retain = v;
  }
  /**
   * Returns a `Promise` that resolves to a `Boolean` when this animation completes. The resolved value is that of
   * this instance's {@link #property-completed} property.
   * @returns {Promise}
   * @async
   */


  done() {
    return this.promise;
  }

  finish(complete) {
    var _me$prefinalize, _me$finalize;

    const me = this,
          {
      items
    } = me;
    syncTransitions(me.element);
    me.completed = typeof complete === 'boolean' ? complete : !complete.some(a => !a);
    (_me$prefinalize = me.prefinalize) === null || _me$prefinalize === void 0 ? void 0 : _me$prefinalize.call(me, me.completed, me);

    while (items.length) {
      items.pop().destroy();
    }

    (_me$finalize = me.finalize) === null || _me$finalize === void 0 ? void 0 : _me$finalize.call(me, me.completed, me);
  }

  revert(options) {
    var _options$start;

    const me = this,
          {
      reverting
    } = me,
          start = !options || ((_options$start = options.start) !== null && _options$start !== void 0 ? _options$start : true);
    let anim = me.defaults;

    if (reverting) {
      // If this anim is a revert of some previous anim and that anim had a finalizer, then reverting us should
      // (by default) carry forward the original finalizer:
      if (reverting.finalize) {
        anim.finalize = reverting.finalize;
      }

      if (reverting.prefinalize) {
        anim.prefinalize = reverting.prefinalize;
      }

      anim.retain = reverting._retain;
    }

    anim = assign(anim, options, {
      items: me.items.map(it => it.revert(nostart)),
      reverting: me
    });
    anim = new Animator(anim);
    start && anim.start();
    return anim;
  }
  /**
   * Starts this animation and returns a reference to itself. This method is called automatically by the
   * {@link #function-run-static} method.
   * @returns {Core.util.Animator}
   */


  start() {
    const {
      element,
      items
    } = this;
    super.start();

    if (items.length) {
      syncTransitions(element);
      items.forEach(a => a.start());
    }

    return this;
  }

}
Animator.initClass().Transition = AnimatorTransition;
Animator.specialPropsRe = new RegExp(`^(?:${Object.keys(Animator.prototypeProperties).concat(Object.keys(Animator.superclass.prototypeProperties)).map(s => s[0] === '_' ? s.substr(1) : s).join('|')})$`);
Animator.defaultDuration = 200;
Animator.fx = {};
Animator.register({
  /**
   * A compound animation to achieve `transform: scale()` and `opacity: 0`. The `scale` defaults to 8 but can be set
   * in the `anim` config object.
   *
   * For example
   * ```javascript
   *  const puff = Animator.puff(element);
   *
   *  const puff = Animator.puff({
   *      element,
   *      scale : 12
   *  });
   * ```
   *
   * This compound animation can also be specified in an `Animator` config object along with other style transitions:
   * ```javascript
   *  const anim = Animator.run({
   *      element,
   *      marginLeft : -200,
   *      puff       : true   // true for default scale, a number, or config object
   *  });
   * ```
   * @param {Element|Object|Core.util.Animator} anim The element to animate or the config object containing at least
   * the `element` property. This config object can contain an optional `scale` property to adjust the animation's
   * `transform: scale()` value.
   * @param {Number} [anim.scale=8] The scale value for the `transform:scale()` transition.
   * @returns {Core.util.Animator}
   * @static
   */
  puff(anim) {
    if (anim === true) {
      anim = {};
    } else if (typeof anim !== 'object') {
      // string || number
      anim = {
        transform: `scale(${anim})`
      };
    } else if (anim.scale) {
      anim = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].clone(anim);
      anim.transform = `scale(${anim.scale})`;
      delete anim.scale;
    }

    return assign({
      opacity: 0,
      transform: 'scale(8)'
    }, anim);
  }

});
Animator._$name = 'Animator';

/***/ }),

/***/ "./lib/Core/util/Bag.js":
/*!******************************!*\
  !*** ./lib/Core/util/Bag.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Bag; });
/* harmony import */ var _Collection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Collection.js */ "./lib/Core/util/Collection.js");
var productName = 'taskboard';


const nonPrimitives = new WeakMap(),
      safeIndexKey = value => {
  if (value && typeof value === 'object') {
    let substitute = nonPrimitives.get(value);

    if (substitute === undefined) {
      substitute = Symbol('bscik'); // Bryntum safe collection index key

      nonPrimitives.set(value, substitute);
    }

    value = substitute;
  }

  return value;
};
/**
 * @module Core/util/Bag
 */

/**
 * A simple collection class to contain unique, keyed items.
 * @internal
 */


class Bag {
  constructor(config) {
    const me = this;
    me.generation = 0;
    me.items = new Set();
    me.idMap = {};
    me.idProperty = 'id';

    if (config) {
      if (config.idProperty) {
        me.idProperty = config.idProperty;
      }

      if (config.values) {
        me.values = config.values;
      }
    }
  }
  /**
   * Returns the item with the passed `id`.
   *
   * @param {*} id The `id` to find.
   * @returns {Object} The found item, or `undefined`.
   */


  get(key) {
    return this.idMap[safeIndexKey(key)];
  }
  /**
   * The number of items in this Bag.
   * @property {Number}
   * @readonly
   */


  get count() {
    return this.items.size;
  }
  /**
   * Adds the passed item(s) to this Bag. Existing items with the same ID
   * will be replaced.
   * @param {Object|Object[]} toAdd Item(s) to add.
   */


  add(...toAdd) {
    if (toAdd.length === 1 && Array.isArray(toAdd[0])) {
      toAdd = toAdd[0];
    }

    const me = this,
          {
      items,
      idMap,
      idProperty
    } = me,
          len = toAdd.length;

    for (let i = 0; i < len; i++) {
      const item = toAdd[i],
            key = _Collection_js__WEBPACK_IMPORTED_MODULE_0__["keyTypes"][typeof item] ? item : safeIndexKey(item[idProperty]),
            existingItem = idMap[key]; // Not already present

      if (existingItem == null) {
        idMap[key] = item;
        items.add(item);
        me.generation++;
      } // Already present, replace it if different. No generational change.
      // IDs rule.
      else if (existingItem !== item) {
        idMap[key] = item;
        items.delete(existingItem);
        items.add(item);
      }
    }
  }
  /**
   * Removes the passed item(s) from this Bag.
   * @param {Object|Object[]} toRemove Item(s) to remove.
   */


  remove(toRemove) {
    if (!Array.isArray(toRemove)) {
      toRemove = [toRemove];
    }

    const {
      items,
      idMap,
      idProperty
    } = this,
          len = toRemove.length;

    for (let i = 0; i < len; i++) {
      const item = toRemove[i],
            key = _Collection_js__WEBPACK_IMPORTED_MODULE_0__["keyTypes"][typeof item] ? item : safeIndexKey(item[idProperty]),
            existingItem = idMap[key]; // Found natch, so delete it

      if (existingItem != null) {
        items.delete(existingItem);
        delete idMap[key];
        this.generation++;
      }
    }
  }

  clear() {
    this.items.clear();
    this.idMap = {};
    this.generation++;
  }
  /**
   * Returns the number of items in this Bag which elicits a truthy return value from the passed function.
   * @param {Function} fn A function, which, when passed an item, returns `true` to select it as the item to return.
   * @returns {Number} The number of matched items.
   */


  countOf(fn) {
    let ret = 0,
        item;

    for (item of this.items) {
      if (fn(item)) {
        ++ret;
      }
    }

    return ret;
  }
  /**
   * Change the id of an existing member by mutating its idProperty.
   * @param {String|Number|Object} item The item or id of the item to change.
   * @param {String|Number} newId The id to set in the existing member.
   */


  changeId(item, newId) {
    const me = this,
          {
      idMap,
      idProperty
    } = me,
          oldId = _Collection_js__WEBPACK_IMPORTED_MODULE_0__["keyTypes"][typeof item] ? item : safeIndexKey(item[idProperty]),
          member = me.get(oldId);

    if (member) {
      const existingMember = me.get(newId);

      if (existingMember && member !== existingMember) {
        throw new Error(`Attempt to set item ${oldId} to already existing member's id ${newId}`);
      }

      member[idProperty] = newId;
      delete idMap[oldId];
      idMap[newId] = member;
    }
  }
  /**
   * Returns `true` if this Collection includes an item with the same `id` as the passed item.
   *
   * @param {Object|String|Number} item The item to find, or an `id` to find.
   * @returns {Boolean} True if the passed item is found.
   */


  includes(item) {
    const key = _Collection_js__WEBPACK_IMPORTED_MODULE_0__["keyTypes"][typeof item] ? item : safeIndexKey(item[this.idProperty]);
    return Boolean(this.idMap[key]);
  }
  /**
   * Extracts the content of this Bag into an array based upon the passed
   * value extraction function.
   * @param {Function} fn A function, which, when passed an item, returns a value to place into the resulting array.
   * @param {Object} [thisObj] The `this` reference when the function is called.
   * @returns {Object[]} An array of values extracted from this Bag.
   */


  map(fn, thisObj) {
    const {
      items
    } = this,
          result = new Array(items.size); // Set has no map

    let i = 0;
    items.forEach(item => {
      result[i] = fn.call(thisObj, item, i++, items);
    });
    return result;
  }
  /**
   * Executes the passed function for each item in this Bag, passing in the item.
   * @param {Function} fn The function to execute.
   * @param {Object} [thisObj] The `this` reference when the function is called.
   */


  forEach(fn, thisObj) {
    return this.items.forEach(fn, thisObj);
  }
  /**
   * Returns `nth` item in this Bag which elicits a truthy return value from the provided matcher function `fn`.
   * @param {Function} fn A function which, when passed an item, returns `true` to select the item as a match.
   * @param {Number} [nth=0] The index of the matching item. By default, 0 returns the first item that matches
   * according to `fn`. Negative numbers index for the last item. For example, -1 returns the last matching item,
   * -2 the 2nd to last matching item etc..
   * @returns {Object} The matched item, or `undefined`.
   */


  find(fn, nth = 0) {
    let item, ret;

    if (nth < 0) {
      nth = this.countOf(fn) + nth; // ex: count=10 ... -1 -> 9, -2 -> 8, -3 -> 7, ... -9 -> 1, -10 -> 0
    }

    for (item of this.items) {
      if (fn(item) && !nth--) {
        ret = item;
        break;
      }
    }

    return ret;
  }
  /**
   * Iterator that allows you to do for (let item of bag)
   */


  [Symbol.iterator]() {
    return this.items[Symbol.iterator]();
  }

  indexOf(item, matchFn) {
    let index = -1,
        it;

    for (it of this.items) {
      if (!matchFn || matchFn(it)) {
        ++index;

        if (it === item) {
          return index;
        }
      }
    }

    return -1;
  }
  /**
   * The set of values of this Bag.
   *
   * Setting this property replaces the data set.
   * @property {Object[]}
   */


  get values() {
    return [...this.items];
  }

  set values(values) {
    if (!Array.isArray(values)) {
      values = [values];
    }

    this.clear();
    this.add.apply(this, values);
    this.generation++;
  }
  /**
   * Sort the values of this Bag using the passed comparison function.
   *
   * Setting this property replaces the data set.
   * @param {Function} fn Comparison function which returns -ve, 0, or +ve
   */


  sort(fn) {
    this.values = this.values.sort(fn);
  }

  some(fn, thisObj) {
    return this.values.some(fn, thisObj);
  }

}
Bag._$name = 'Bag';

/***/ }),

/***/ "./lib/Core/util/ClickRepeater.js":
/*!****************************************!*\
  !*** ./lib/Core/util/ClickRepeater.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ClickRepeater; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
var productName = 'taskboard';




/**
 * @module Core/util/ClickRepeater
 */

/**
 * A helper class, which, when applied to an {@link #config-element} means that a mousedown
 * and hold on that element will, after a configured {@link #config-delay}, begin
 * autorepeating `click` events on that element, starting at a rate of
 * {@link #config-startRate} clicks per second, and over {@link #config-accelerateDuration}
 * milliseconds, accelerate to firing clicks at {@link #config-endRate} times per second.
 *
 * An example of this is used by the {@link Core.widget.NumberField NumberField}'s
 * spinner triggers.
 */

class ClickRepeater extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get configurable() {
    return {
      /**
       * The element on which to fire autorepeating `click` events when the mouse is held down.
       * @config {HTMLElement}
       */
      element: null,

      /**
       * A query selector which specifies subtargets of this ClickRepeater's {@link #config-element}
       * which act as the click auto repeat event targets.
       * @config {String}
       * @default
       */
      delegate: null,

      /**
       * How long in milliSeconds to pause before starting the click repeats.
       * @config {Number}
       * @default
       */
      delay: 500,

      /**
       * Clicks per second to start firing after the initial {@link #config-delay}
       * @config {Number}
       * @default
       */
      startRate: 2,

      /**
       * Clicks per second to fire at top speed, after accelerating over the {@link #config-accelerateDuration}
       * @config {Number}
       * @default
       */
      endRate: 20,

      /**
       * How long in milliseconds to accelerate from the
       * {@link #config-startRate} to the {@link #config-startRate}.
       * @config {Number}
       * @default
       */
      accelerateDuration: 4000,
      pressedCls: 'b-pressed'
    };
  }

  doDestroy() {
    var _this$mousedownRemove;

    (_this$mousedownRemove = this.mousedownRemover) === null || _this$mousedownRemove === void 0 ? void 0 : _this$mousedownRemove.call(this);
    super.doDestroy();
  }

  cancel() {
    var _me$activeElement, _me$acceleration, _me$activeListenerRem;

    const me = this;
    (_me$activeElement = me.activeElement) === null || _me$activeElement === void 0 ? void 0 : _me$activeElement.classList.remove(me.pressedCls);
    me.activeElement = null;
    (_me$acceleration = me.acceleration) === null || _me$acceleration === void 0 ? void 0 : _me$acceleration.cancel();
    me.activeListenerRemover = (_me$activeListenerRem = me.activeListenerRemover) === null || _me$activeListenerRem === void 0 ? void 0 : _me$activeListenerRem.call(me);
    me.clearTimeout('startAutoRepeat');
    me.clearTimeout(me.repeatTimer);
  }

  updateElement(element) {
    var _this$mousedownRemove2;

    (_this$mousedownRemove2 = this.mousedownRemover) === null || _this$mousedownRemove2 === void 0 ? void 0 : _this$mousedownRemove2.call(this);
    this.mousedownRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on({
      element,
      mousedown: 'onMouseDown',
      thisObj: this
    });
  }

  onMouseDown(e) {
    const me = this,
          target = me.delegate ? e.target.closest(me.delegate) : me.element;
    me.cancel();

    if (target) {
      me.activeElement = target;
      me.triggerEvent = e;
      target.classList.add(me.pressedCls);
      me.activeListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on({
        mouseup: {
          element: document,
          handler: 'onMouseUp'
        },
        mousemove: {
          element: target,
          handler: 'onTargetMouseMove'
        },
        mouseleave: {
          element: target,
          handler: 'onTargetMouseLeave'
        },
        mouseenter: {
          element: target,
          handler: 'onTargetMouseEnter'
        },
        thisObj: me
      });
      me.setTimeout('startAutoRepeat', me.delay);
    }
  }

  onMouseUp() {
    this.cancel();
  }

  onTargetMouseLeave() {
    this.activeElement.classList.remove(this.pressedCls);
    this.clearTimeout(this.repeatTimer);
  }

  onTargetMouseEnter(e) {
    const me = this;

    if (!e.buttons) {
      // mostly seen due to breakpoints in click handling, but easy to detect if mouse was released...
      me.cancel();
    } else {
      me.activeElement.classList.add(me.pressedCls);
      me.triggerEvent = e;
      me.fireClick();
    }
  }

  onTargetMouseMove(e) {
    this.triggerEvent = e;
  }

  startAutoRepeat() {
    const me = this;
    me.interval = me.startInterval = 1000 / me.startRate;
    me.accelerationDelta = me.startInterval - 1000 / me.endRate; // Begin animating the interval from 1000/me.startRate to 1000/me.endRate

    me.fireClick();
    me.acceleration = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].animate(me.accelerateDuration, me.nextTick, me, 'easeOutQuad');
  }

  nextTick(progress) {
    this.interval = this.startInterval - this.accelerationDelta * progress;
  }

  fireClick() {
    const me = this,
          clickEvent = new MouseEvent('click', me.triggerEvent);
    me.triggerEvent.target.dispatchEvent(clickEvent);
    me.repeatTimer = me.setTimeout(me.fireClick, me.interval);
  }

}
ClickRepeater._$name = 'ClickRepeater';

/***/ }),

/***/ "./lib/Core/util/Collection.js":
/*!*************************************!*\
  !*** ./lib/Core/util/Collection.js ***!
  \*************************************/
/*! exports provided: default, keyTypes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Collection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyTypes", function() { return keyTypes; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
/* harmony import */ var _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CollectionSorter.js */ "./lib/Core/util/CollectionSorter.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
var productName = 'taskboard';





/**
 * @module Core/util/Collection
 */

const return0 = () => 0,
      reverseNumericSortFn = (a, b) => b - a,
      filteredIndicesProperty = Symbol('filteredIndicesProperty'),
      emptyArray = Object.freeze([]),
      sortEvent = Object.freeze({
  action: 'sort',
  added: emptyArray,
  removed: emptyArray,
  replaced: emptyArray
}),
      filterEvent = Object.freeze({
  action: 'filter',
  added: emptyArray,
  removed: emptyArray,
  replaced: emptyArray
}),
      keyTypes = {
  string: 1,
  number: 1
}; // Adds a single item to a single index using the specified key


function addItemToIndex(item, index, key) {
  // Unique holds a single entry
  if (index.unique !== false) {
    index.set(key, item);
  } // Non-unique index holds a Set
  else {
    let set = index.get(key); // Add a set if this is the first entry

    if (!set) {
      set = new Set();
      index.set(key, set);
    } // Add entry to the set


    set.add(item);
  }
} // Removes a single item from a single index using the specified key


function removeItemFromIndex(item, index, key) {
  // Unique holds single entry, remove it
  if (index.unique !== false) {
    index.delete(key);
  } else if (index.has(key)) {
    // Remove from set
    index.get(key).delete(item); // Remove turned empty set

    if (!index.get(key).size) {
      index.delete(key);
    }
  }
} // Used to fully build the indices, normal and filtered (if used). Better to do full builds for performance reasons
// when assigning new datasets. For other CRUD operations, indices are kept up to date elsewhere


function doRebuildIndices(values, indices, keyProps, indexCount) {
  for (let i = 0; i < values.length; i++) {
    const item = values[i];

    for (let j = 0; j < indexCount; j++) {
      const keyProp = keyProps[j],
            key = item[keyProp],
            index = indices[keyProp];
      addItemToIndex(item, index, key);
    }
  }
}
/**
 * A class which encapsulates a {@link #function-get keyed},
 * {@link #function-addFilter filterable}, {@link #function-addSorter sortable}
 * collection of objects. Entries may not be atomic data types such as `string` or `number`.
 *
 * The entries are keyed by their `id` which is determined by interrogating the {@link #config-idProperty}.
 *
 * To filter a Collection, add a {@link Core.util.CollectionFilter CollectionFilter}
 * using the {@link #function-addFilter} method. A Filter config object may be specified here
 * which will be promoted to a CollectionFilter instance.
 *
 * To sort a Collection, add a {@link Core.util.CollectionSorter CollectionSorter}
 * using the {@link #function-addSorter} method. A Sorter config object may be specified here
 * which will be promoted to a CollectionSorter instance.
 */


class Collection extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  //region Config
  static get configurable() {
    return {
      /**
       * Specify the name of the property of added objects which provides the lookup key
       * @config {String}
       * @default
       */
      idProperty: 'id',

      /**
       * Specify the names or index configs of properties which are to be indexed for fast lookup.
       *
       * Index configs use the format `{ property : string, unique : boolean }`. Unique indices stores one index
       * per entry, non-unique stores a `Set`. If left out, `unique` defaults to `true`
       *
       * @config {String[]|Object[]}
       */
      extraKeys: null,

      /**
       * Automatically apply filters on item add.
       * @config {Boolean}
       * @default
       */
      autoFilter: true,

      /**
       * Automatically apply sorters on item add.
       * @config {Boolean}
       * @default
       */
      autoSort: true,

      /**
       * A {@link Core.util.CollectionSorter Sorter}, or Sorter config object, or
       * an array of these, to use to sort this Collection.
       * @config {Object[]}
       * @default
       */
      sorters: {
        $config: ['lazy'],
        value: []
      }
    };
  }

  get isCollection() {
    return true;
  } //endregion
  //region Init & destroy


  construct(config) {
    /**
     * A counter which is incremented whenever the Collection is mutated in a meaningful way.
     *
     * If a {@link #function-splice} call results in no net replacement, removal or addition,
     * then the `generation` will not be incremented.
     * @property {Number}
     * @readonly
     */
    this.generation = 0;
    this._values = [];
    super.construct(config);
  }

  doDestroy() {
    var _me$_sorters;

    super.doDestroy();
    const me = this;
    me._values.length = 0;

    if (me.isFiltered) {
      me._filteredValues.length = 0;
      me.filters.destroy();
    } // eslint-disable-next-line no-unused-expressions


    (_me$_sorters = me._sorters) === null || _me$_sorters === void 0 ? void 0 : _me$_sorters.destroy();
  } //endregion
  //region "CRUD"

  /**
   * Clears this collection.
   */


  clear() {
    const me = this,
          removed = me._values.slice();

    if (me.totalCount) {
      me._values.length = 0;

      if (me._filteredValues) {
        me._filteredValues.length = 0;
      }

      me._indicesInvalid = true; // Indicate to observers that data has changed.

      me.generation++;
      me.trigger('change', {
        action: 'clear',
        removed
      });
    }
  }
  /**
   * Replaces the internal `values` array with the passed `values`, or `filteredValues` array with the passed `filteredValues`.
   * If `filteredValues` are not passed explicitly, but storage is filtered, decides internally `values` or `filteredValues` should
   * be replaced by passed `values`.
   *
   * Note that this takes ownership of the array, and the array must not be mutated by outside code.
   *
   * This is an internal utility method, not designed for use by application code.
   *
   * @param {Object} params Values and parameters to replace
   * @param {Object[]} params.values The new `values` array
   * @param {Object[]} [params.filteredValues] The new `filteredValues` array. Applicable only when storage is filtered.
   * @param {Boolean} [params.silent=false] If true, `change` event will not be fired
   * @param {Boolean} [params.isNewDataset=false] If true, `values` is a new dataset
   * @fires change
   * @internal
   */


  replaceValues({
    values,
    filteredValues,
    silent = false,
    isNewDataset = false
  }) {
    const me = this;
    let replacedValues, replacedFilteredValues; // The isNewDataset flag is passed by store#loadData to indicate that it's
    // a new data load, and that local filters can be applied.
    // Other use cases are for purely local updates of an existing dataset such as
    // refreshing the visible data with a values array containing group headers.

    if (me.isFiltered && !isNewDataset) {
      const filteredPassed = Boolean(filteredValues); // If `filteredValues` are missing, take `values` as a source of filtered values

      if (!filteredPassed) {
        filteredValues = values.slice();
        values = null;
      } // otherwise check if non-filtered values are passed together with filtered, and replace them too
      else if (values) {
        replacedValues = me._values;
        me._values = values.slice();
      }

      replacedFilteredValues = me._filteredValues;
      me._filteredValues = filteredValues.slice();
    } else {
      replacedValues = me._values;
      me._values = values.slice();
      filteredValues = null;

      if (me.isFiltered && isNewDataset && me.autoFilter) {
        me._filterFunction = null;
        me._filteredValues = me._values.filter(me.filterFunction);
      } else if (me._filteredValues) {
        me._filteredValues.length = 0;
      }
    }

    me._indicesInvalid = true; // Indicate to observers that data has changed.

    me.generation++;

    if (!silent) {
      me.trigger('change', {
        action: 'replaceValues',
        replacedValues,
        replacedFilteredValues,
        values,
        filteredValues
      });
    }
  }

  set values(values) {
    // Want a full rebuild for new dataset, less costly than doing it per item
    this.invalidateIndices();
    this.splice(0, this._values.length, values);
  }
  /**
   * The set of values of this Collection. If this Collection {@link #property-isFiltered},
   * this yields the filtered data set.
   *
   * Setting this property replaces the data set.
   * @property {Object[]}
   */


  get values() {
    return this.isFiltered ? this._filteredValues : this._values;
  }
  /**
   * Iterator that allows you to do `for (const item of collection)`
   */


  [Symbol.iterator]() {
    return this.values[Symbol.iterator]();
  }
  /**
   * Executes the passed function for each item in this Collection, passing in the item,
   * ths index, and the full item array.
   * @param {Function} fn The function to execute.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to include all items, bypassing filters.
   */


  forEach(fn, ignoreFilters = false) {
    (this.isFiltered && !ignoreFilters ? this._filteredValues : this._values).forEach(fn);
  }
  /**
   * Extracts ths content of this Collection into an array based upon the passed
   * value extraction function.
   * @param {Function} fn A function, which, when passed an item, returns a value to place into the resulting array.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to process an item even if it is filtered out.
   * @returns {Object[]} An array of values extracted from this Collection.
   */


  map(fn, ignoreFilters = false) {
    return (this.isFiltered && !ignoreFilters ? this._filteredValues : this._values).map(fn);
  }
  /**
   * Returns the first item in this Collection which elicits a *truthy* return value from the passed function.
   * @param {Function} fn A function, which, when passed an item, returns `true` to select it as the item to return.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to include filtered out items.
   * @returns {Object} The matched item, or `undefined`.
   */


  find(fn, ignoreFilters = false) {
    return (this.isFiltered && !ignoreFilters ? this._filteredValues : this._values).find(fn);
  }

  get first() {
    return this.values[0];
  }

  get last() {
    return this.values[this.count - 1];
  }
  /**
   * The set of all values of this Collection regardless of filters applied.
   * @readonly
   * @property {Object[]}
   */


  get allValues() {
    return this._values;
  }
  /**
   * Adds items to this Collection. Multiple new items may be passed.
   *
   * By default, new items are appended to the existing values.
   *
   * Any {@link #property-sorters} {@link #property-sorters} present are re-run.
   *
   * Any {@link #property-filters} {@link #property-filters} present are re-run.
   *
   * *Note that if application functionality requires add and remove, the
   * {@link #function-splice} operation is preferred as it performs both
   * operations in an atomic manner*
   * @param  {...Object} items The item(s) to add.
   */


  add(...items) {
    if (items.length === 1) {
      this.splice(this._values.length, null, ...items);
    } else {
      this.splice(this._values.length, null, items);
    }
  }
  /**
   * Removes items from this Collection. Multiple items may be passed.
   *
   * Any {@link #property-sorters} {@link #property-sorters} present are re-run.
   *
   * Any {@link #property-filters} {@link #property-filters} present are re-run.
   *
   * *Note that if application functionality requires add and remove, the
   * {@link #function-splice} operation is preferred as it performs both
   * operations in an atomic manner*
   * @param  {...Object} items The item(s) to remove.
   */


  remove(...items) {
    if (items.length === 1) {
      this.splice(0, ...items);
    } else {
      this.splice(0, items);
    }
  }
  /**
   * Moves an individual item, or a block of items to another location.
   * @param {Object|Object[]} items The item/items to move.
   * @param {Object} [beforeItem] the item to insert the first item before. If omitted, the `item`
   * is moved to the end of the Collection.
   * @returns {Number} The new index of the `item`.
   */


  move(items, beforeItem) {
    if (!Array.isArray(items)) {
      items = [items];
    } // Handle the case of move(myItem, myItem). It's a no-op


    while (items.length && items[0] === beforeItem) {
      items.shift();
    }

    if (!items.length) {
      return;
    }

    const me = this,
          {
      _values
    } = me,
          itemIndex = me.indexOf(items[0], true); // move(record, followingrecord) is a no-op

    if (items.length === 1 && _values[itemIndex + 1] === beforeItem) {
      return;
    } // Silently remove the items that are to be inserted before the "beforeItem".


    me.suspendEvents();
    me.remove(items);
    me.resumeEvents();
    const beforeIndex = beforeItem ? me.indexOf(beforeItem, true) : _values.length;

    if (beforeIndex === -1) {
      throw new Error('Collection move beforeItem parameter must be present in Collection');
    }

    _values.splice(beforeIndex, 0, ...items);

    me._indicesInvalid = 1;
    me.trigger('change', {
      action: 'move',
      items,
      from: itemIndex,
      to: beforeIndex
    });
    return beforeIndex;
  }
  /**
   * The core data set mutation method. Removes and adds at the same time. Analogous
   * to the `Array` `splice` method.
   *
   * Note that if items that are specified for removal are also in the `toAdd` array,
   * then those items are *not* removed then appended. They remain in the same position
   * relative to all remaining items.
   *
   * @param {Number} index Index at which to remove a block of items. Only valid if the
   * second, `toRemove` argument is a number.
   * @param {Object[]|Number} [toRemove] Either the number of items to remove starting
   * at the passed `index`, or an array of items to remove (If an array is passed, the `index` is ignored).
   * @param  {Object[]|Object} [toAdd] An item, or an array of items to add.
   */


  splice(index = 0, toRemove, ...toAdd) {
    const me = this,
          idProperty = me.idProperty,
          values = me._values,
          newIds = {},
          removed = [],
          replaced = [],
          oldCount = me.totalCount;
    let added, mutated; // Create an "newIds" map of the new items so remove ops know if it's really a replace
    // {
    //     1234 : true
    // }
    // And an "added" array of the items that need adding (there was not already an entry for the id)
    //

    if (toAdd) {
      if (toAdd.length === 1 && Array.isArray(toAdd[0])) {
        toAdd = toAdd[0];
      } // Check for replacements if we contain any data


      if (oldCount && toAdd.length) {
        // Only risk rebuilding the indices if we are adding
        const idIndex = me.indices[idProperty];
        added = [];

        for (let i = 0; i < toAdd.length; i++) {
          const newItem = toAdd[i],
                id = newItem[idProperty],
                existingItem = idIndex.get(id),
                existingIndex = existingItem ? values.indexOf(existingItem) : -1; // Register incoming id so that removal leaves it be

          newIds[id] = true; // Incoming id is already present.
          // Replace it in place.

          if (existingIndex !== -1) {
            // If incoming is the same object, it's a no-op
            if (values[existingIndex] !== newItem) {
              replaced.push([values[existingIndex], newItem]);
              values[existingIndex] = newItem;
            }
          } else {
            added.push(newItem);
          }
        }
      } // Empty Collection, we simply add what we're passed
      else {
        added = toAdd;
      }
    }

    if (toRemove) {
      // We're removing a chunk starting at index
      if (typeof toRemove === 'number') {
        // Ensure we don't walk off the end if the toRemove count exceeds what we contain
        toRemove = Math.min(toRemove, values.length - index);

        for (let removeIndex = index; toRemove; --toRemove) {
          const id = values[removeIndex][idProperty]; // If the entry here is being replaced, skip the insertion index past it

          if (newIds[id]) {
            index++;
            removeIndex++;
          } // If the id is not among incoming items, remove it
          else {
            removed.push(values[removeIndex]);
            values.splice(removeIndex, 1);
            mutated = true;
          }
        }
      } // We are removing an item/items
      else {
        let contiguous = added.length === 0,
            lastIdx;

        if (!Array.isArray(toRemove)) {
          toRemove = [toRemove];
        } // Create array of index points to remove.
        // They must be in reverse order so that removal leaves following remove indices stable


        const removeIndices = toRemove.reduce((result, item) => {
          const isNumeric = typeof item === 'number',
                idx = isNumeric ? item : me.indexOf(item, true); // Drop out of contiguous mode if we find a non-contiguous record, or a remove *index*

          if (contiguous && (lastIdx != null && idx !== lastIdx + 1 || isNumeric)) {
            contiguous = false;
          } // Do not include indices out of range in our removeIndices


          if (idx >= 0 && idx < oldCount) {
            result.push(idx);
          }

          lastIdx = idx;
          return result;
        }, []).sort(reverseNumericSortFn); // If it's a pure remove of contiguous items with no adds, fast track it.

        if (contiguous) {
          // If reduced to zero by being asked to remove items we do not contain
          // then this is a no-op
          if (removeIndices.length) {
            removed.push.apply(removed, toRemove);
            values.splice(removeIndices[removeIndices.length - 1], removeIndices.length);
            mutated = true;
          }
        } else {
          // Loop through removeIndices splicing each index out of the values
          // unless there's an incoming identical id.
          for (let i = 0; i < removeIndices.length; i++) {
            const removeIndex = removeIndices[i];

            if (removeIndex !== -1) {
              const id = values[removeIndex][idProperty]; // If the id is not among incoming items, remove it

              if (!newIds[id]) {
                removed.unshift(values[removeIndex]);
                values.splice(removeIndex, 1);
                mutated = true;
              }
            }
          }
        }
      } // Update indices only if they have been used


      if (removed.length && !me._indicesInvalid) {
        removed.forEach(me.removeFromIndices, me);
      }
    } // If we collected genuinely new entries, insert them at the splice index


    if (added.length) {
      values.splice(Math.min(index, values.length), 0, ...added);
      mutated = true; // Update indices only if they have been used

      if (!me._indicesInvalid) {
        added.forEach(me.addToIndices, me);
      }
    } // Update indices only if they have been used


    if (replaced.length && !me._indicesInvalid) {
      replaced.forEach(rep => {
        me.removeFromIndices(rep[0]);
        me.addToIndices(rep[1]);
      });
    } // If we either added or removed items, or we did an in-place replace operation
    // then inform all interested parties.


    if (mutated || replaced.length) {
      // Ensure order of values matches the sorters
      if (me.isSorted) {
        me.onSortersChanged();
      } // The sort will also recreate the filteredValues so that it can be in correct sort order
      else if (me.isFiltered) {
        if (me.autoFilter) {
          me.onFiltersChanged();
        } else {
          me._filteredValues.push(...added);
        }
      } // Indicate to observers that data has changed.


      me.generation++;
      /**
       * Fired when items are added, replace or removed
       * @event change
       * @param {String} action The underlying operation which caused data change.
       * May be `'splice'` (meaning an atomic add/remove operation, `'sort'` or `'filter'`)
       * @param {Core.util.Collection} source This Collection.
       * @param {Object[]} removed An array of removed items.
       * @param {Object[]} added An array of added items.
       * @param {Object[]} replaced An array of replacements, each entry of which contains `[oldValue, newValue]`.
       * @param {Number} oldCount The number of items in the full, unfiltered collection prior to the splice operation.
       */

      me.trigger('change', {
        action: 'splice',
        removed,
        added,
        replaced,
        oldCount
      });
    } else {
      /**
       * Fired when a {@link #function-splice} operation is requested but the operation
       * is a no-op and has caused no change to this Collection's dataset. The splice
       * method's parameters are passed for reference.
       * @event noChange
       * @param {Number} index Index at which to remove a block of items.
       * @param {Object[]|Number} [toRemove] Either the number of items to remove starting
       * at the passed `index`, or an array of items to remove (If an array is passed, the `index` is ignored).
       * @param  {Object[]|Object} [toAdd] An item, or an array of items to add.
       */
      me.trigger('noChange', {
        index,
        toRemove,
        toAdd
      });
    }
  }
  /**
   * Change the id of an existing member by mutating its {@link #config-idProperty}.
   * @param {String|Number|Object} item The item or id of the item to change.
   * @param {String|Number} newId The id to set in the existing member.
   */


  changeId(item, newId) {
    const me = this,
          {
      idProperty
    } = me,
          oldId = keyTypes[typeof item] ? item : item[idProperty],
          member = me.get(oldId);

    if (member) {
      const existingMember = me.get(newId);

      if (existingMember && member !== existingMember) {
        throw new Error(`Attempt to set item ${oldId} to already existing member's id ${newId}`);
      }

      me.removeIndexEntry(item, idProperty, oldId);
      me.addIndexEntry(item, idProperty, newId); // Last on purpose, onItemMutation would fail to find the item if its id was changed prior to the call

      member[idProperty] = newId;
    }
  }
  /**
   * Returns the item with the passed `id`. By default, filtered are honoured, and
   * if the item with the requested `id` is filtered out, nothing will be returned.
   *
   * To return the item even if it has been filtered out, pass the second parameter as `true`.
   * @param {*} id The `id` to find.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to return an item even if it is filtered out.
   * @returns {Object} The found item, or `undefined`.
   */


  get(id, ignoreFilters = false) {
    return this.getBy(this.idProperty, id, ignoreFilters);
  }

  getAt(index, ignoreFilters = false) {
    if (this.isFiltered && !ignoreFilters) {
      return this._filteredValues[index];
    } else {
      return this._values[index];
    }
  }
  /**
   * Returns the item with passed property name equal to the passed value. By default,
   * filtered are honoured, and if the item with the requested `id` is filtered out,
   * nothing will be returned.
   *
   * To return the item even if it has been filtered out, pass the third parameter as `true`.
   * @param {String} propertyName The property to test.
   * @param {*} value The value to find.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to return an item even if it is filtered out.
   * @returns {Object} The found item, or `undefined`.
   */


  getBy(propertyName, value, ignoreFilters = false) {
    return this.findItem(propertyName, value, this.isFiltered && ignoreFilters);
  }
  /**
   * The number of items in this collection. Note that this honours filtering.
   * See {@link #property-totalCount};
   * @property {Number}
   * @readonly
   */


  get count() {
    return this.values.length;
  }
  /**
   * The number of items in this collection regardless of filtering.
   * @property {Number}
   * @readonly
   */


  get totalCount() {
    return this._values.length;
  }
  /**
   * The property name used to extract item `id`s from added objects.
   * @member {String} idProperty
   */


  updateIdProperty(idProperty) {
    this.addIndex({
      property: idProperty,
      unique: true
    });
  } //endregion
  //region Sorting

  /**
   * The Collection of {@link Core.util.CollectionSorter Sorters} for this Collection.
   * @member {Core.util.Collection} sorters
   */


  changeSorters(sorters) {
    return new Collection({
      values: Array.isArray(sorters) ? sorters : [sorters],
      listeners: {
        change: 'onSortersChanged',
        thisObj: this
      }
    });
  }
  /**
   * Adds a Sorter to the Collection of Sorters which are operating on this Collection.
   *
   * A Sorter may be an specified as an instantiated {@link Core.util.CollectionSorter
   * CollectionSorter}, or a config object for a CollectionSorter of the form
   *
   *     {
   *         property  : 'age',
   *         direction : 'desc'
   *     }
   *
   * Note that by default, a Sorter *replaces* a Sorter with the same `property` to make
   * it easy to change existing Sorters. A Sorter's `id` is its `property` by default. You
   * can avoid this and add multiple Sorters for one property by configuring Sorters with `id`s.
   *
   * A Sorter may also be specified as a function which compares two objects eg:
   *
   *     (lhs, rhs) => lhs.customerDetails.age - rhs.customerDetails.age
   *
   * @param {Object} sorter A Sorter of Sorter configuration object to add to the Collection
   * of Sorters operating on this Collection.
   * @returns {Core.util.CollectionSorter} The resulting Sorter to make it easy to remove Sorters.
   */


  addSorter(sorter) {
    const result = sorter instanceof _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_3__["default"] ? sorter : new _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_3__["default"](sorter);
    this.sorters.add(result);
    return result;
  }
  /**
   * A flag which is `true` if this Collection has active {@link #property-sorters}.
   * @property {Boolean}
   * @readonly
   */


  get isSorted() {
    var _this$_sorters;

    return Boolean((_this$_sorters = this._sorters) === null || _this$_sorters === void 0 ? void 0 : _this$_sorters.count);
  }

  onSortersChanged() {
    const me = this;
    delete me._sortFunction;

    me._values.sort(me.sortFunction);

    me.trigger('change', sortEvent);
  }
  /**
   * A sorter function which encapsulates the {@link Core.util.CollectionSorter Sorters}
   * for this Collection.
   * @property {Function}
   * @readonly
   */


  get sortFunction() {
    if (!this._sortFunction) {
      if (this.isSorted) {
        this._sortFunction = _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_3__["default"].generateSortFunction(this.sorters.values);
      } else {
        this._sortFunction = return0;
      }
    }

    return this._sortFunction;
  } //endregion
  //region Filtering

  /**
   * The Collection of {@link Core.util.CollectionFilter Filters} for this Collection.
   * @property {Core.util.Collection}
   * @readonly
   */


  get filters() {
    if (!this._filters) {
      this._filters = new Collection({
        listeners: {
          change: 'onFiltersChanged',
          thisObj: this
        }
      });
    }

    return this._filters;
  }
  /**
   * Adds a Filter to the Collection of Filters which are operating on this Collection.
   *
   * A Filter may be an specified as an instantiated {@link Core.util.CollectionFilter
   * CollectionFilter}, or a config object for a CollectionFilter of the form
   *
   *     {
   *         property : 'age',
   *         operator : '>=',
   *         value    : 21
   *     }
   *
   * Note that by default, a Filter *replaces* a Filter with the same `property` to make
   * it easy to change existing Filters. A Filter's `id` is its `property` by default. You
   * can avoid this and add multiple Filters for one property by configuring Filters with `id`s.
   *
   * A Filter may also be specified as a function which filters candidate objects eg:
   *
   *     candidate => candidate.customerDetails.age >= 21
   *
   * @param {Object} filter A Filter or Filter configuration object to add to the Collection
   * of Filters operating on this Collection.
   * @returns {Core.util.CollectionFilter} The resulting Filter to make it easy to remove Filters.
   */


  addFilter(filter) {
    const result = filter instanceof _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_2__["default"] ? filter : new _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_2__["default"](filter);
    this.filters.add(result);
    return result;
  }
  /**
   * A flag which is `true` if this Collection has active {@link #property-filters}.
   * @property {Boolean}
   * @readonly
   */


  get isFiltered() {
    return Boolean(this._filters && this._filters.count);
  }

  onFiltersChanged() {
    const me = this;
    me._filterFunction = null;
    me._filteredValues = me._values.filter(me.filterFunction);
    me._indicesInvalid = true;
    me.trigger('change', filterEvent);
  }
  /**
   * A filter function which encapsulates the {@link Core.util.CollectionFilter Filters}
   * for this Collection.
   * @property {Function}
   * @readonly
   */


  get filterFunction() {
    if (!this._filterFunction) {
      if (this.isFiltered) {
        this._filterFunction = _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_2__["default"].generateFiltersFunction(this.filters.values);
      } else {
        this._filterFunction = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].returnTrue;
      }
    }

    return this._filterFunction;
  } //endregion
  //region Indexing


  changeExtraKeys(extraKeys) {
    const keys = !Array.isArray(extraKeys) ? [extraKeys] : extraKeys; // Normalize to always be an array of index configs

    return keys.map(config => {
      if (typeof config === 'string') {
        return {
          property: config,
          unique: true
        };
      }

      return config;
    });
  }

  updateExtraKeys(extraKeys) {
    for (let i = 0; i < extraKeys.length; i++) {
      this.addIndex(extraKeys[i]);
    }
  }
  /**
   * Adds a lookup index for the passed property name or index config. The index is built lazily when an index is
   * searched
   * @internal
   * @param {Object} indexConfig An index config
   * @param {String} indexConfig.property The property name to add an index for
   * @param {Boolean} [indexConfig.unique] Specify `false` to allow multiple entries of the same index, turning
   *   entries into sets
   */


  addIndex(indexConfig) {
    // Combo without valueField used in some tests -> addIndex(undefined). Safeguarding here
    if (indexConfig) {
      (this._indices || (this._indices = {}))[indexConfig.property] = new Map(); // Piggyback the index config

      Object.assign(this._indices[indexConfig.property], indexConfig); // Indices need a rebuild now.

      this.invalidateIndices();
      /**
       * this.indices is keyed by the property name, and contains the keys linked to an item in the _values array.
       * So collection.add({id : foo, name : 'Nige'}, {id : 'bar', name : 'Faye'}) where collection has had an index
       * added for the "name" property would result in:
       *
       * {
       *     id : Map({
       *         foo : nige,
       *         bar : faye
       *     }),
       *     name : Map({
       *         Nige : nige,
       *         Faye : faye
       *     })
       * }
       */
    }
  }
  /**
   * Return the index of the item with the specified key having the specified value.
   *
   * By default, filtering is taken into account and this returns the index in the filtered dataset if present. To
   * bypass this, pass the third parameter as `true`.
   *
   * Only useful for indices configured with `unique: true`.
   *
   * @param {String} propertyName The name of the property to test.
   * @param {*} value The value to test for.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to return the index in
   * the original data set if the item is filtered out.
   * @returns {Number} The index of the item or `-1` if not found for unique indices
   */


  findIndex(propertyName, value, ignoreFilters = false) {
    const item = this.findItem(propertyName, value, ignoreFilters);

    if (!item) {
      return -1;
    }

    const values = this.isFiltered && !ignoreFilters ? this._filteredValues : this._values;
    return values.indexOf(item);
  }
  /**
   * Return the item with the specified key having the specified value.
   *
   * By default, filtering is taken into account. To bypass this, pass the third parameter as `true`.
   *
   * For indices configured with `unique: false`, a Set of items will be returned.
   *
   * @param {String} propertyName The name of the property to test.
   * @param {*} value The value to test for.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to return the index in
   * the original data set if the item is filtered out.
   * @returns {Object|Set} The found item or Set of items or null
   */


  findItem(propertyName, value, ignoreFilters = false) {
    const me = this,
          {
      isFiltered
    } = me,
          index = isFiltered && !ignoreFilters ? me.indices[filteredIndicesProperty][propertyName] : me.indices[propertyName];

    if (index) {
      var _index$get;

      // If the key is a numeric string, cast it to a number and find.
      // Store's idRegister is an object which treats numeric keys as strings
      // but Maps are more picky, so we have to work round that.
      const item = (_index$get = index.get(value)) !== null && _index$get !== void 0 ? _index$get : typeof value === 'string' && value.length && !isNaN(value) && index.get(Number(value)) || null;

      if (item != null) {
        return item;
      }
    } else {
      // Search the filtered values if we are filtered and not ignoring filters
      const values = isFiltered && !ignoreFilters ? me._filteredValues : me._values,
            count = values.length;

      for (let i = 0; i < count; i++) {
        const item = values[i];

        if (item[propertyName] == value) {
          return item;
        }
      }
    }

    return null;
  }

  removeIndex(propertyName) {
    delete this._indices[propertyName];
  }
  /**
   * Returns the index of the item with the same `id` as the passed item.
   *
   * By default, filtering is honoured, so if the item in question has been added, but is currently filtered out of
   * visibility, `-1` will be returned.
   *
   * To find the index in the master, unfiltered dataset, pass the second parameter as `true`;
   * @param {Object|String|Number} item The item to find, or an `id` to find.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to find the index in the master, unfiltered data set.
   * @returns {Number} The index of the item, or `-1` if not found.
   */


  indexOf(item, ignoreFilters = false) {
    return this.findIndex(this.idProperty, keyTypes[typeof item] ? item : item[this.idProperty], ignoreFilters);
  }
  /**
   * Returns `true` if this Collection includes an item with the same `id` as the passed item.
   *
   * By default, filtering is honoured, so if the item in question has been added,
   * but is currently filtered out of visibility, `false` will be returned.
   *
   * To query inclusion in the master, unfiltered dataset, pass the second parameter as `true`;
   * @param {Object|String|Number} item The item to find, or an `id` to find.
   * @param {Boolean} [ignoreFilters=false] Pass `true` to find the index in the master, unfiltered data set.
   * @returns {Boolean} True if the passed item is found.
   */


  includes(item, ignoreFilters = false) {
    if (Array.isArray(item)) {
      return item.some(item => this.includes(item));
    }

    return Boolean(this.findItem(this.idProperty, keyTypes[typeof item] ? item : item[this.idProperty], ignoreFilters));
  }

  get indices() {
    if (this._indicesInvalid) {
      this.rebuildIndices();
    }

    return this._indices;
  }

  invalidateIndices() {
    this._indicesInvalid = true;
  }
  /**
   * Called when the Collection is mutated and the indices have been flagged as invalid.
   *
   * Rebuilds the indices object to allow lookup by keys.
   * @internal
   */


  rebuildIndices() {
    const me = this,
          isFiltered = me.isFiltered,
          indices = me._indices || (me._indices = {}),
          keyProps = Object.keys(indices),
          indexCount = keyProps.length,
          values = me._values;
    let filteredIndices;

    if (isFiltered) {
      filteredIndices = indices[filteredIndicesProperty] = {};
    } // First, clear indices.


    for (let i = 0; i < indexCount; i++) {
      const index = indices[keyProps[i]];
      index.clear();

      if (isFiltered) {
        let filteredIndex = filteredIndices[keyProps[i]];

        if (filteredIndex) {
          filteredIndex.clear();
        } else {
          filteredIndex = filteredIndices[keyProps[i]] = new Map(); // Piggyback config

          filteredIndex.unique = index.unique;
        }
      }
    }

    doRebuildIndices(values, indices, keyProps, indexCount); // Create a parallel lookup structure into the _filteredValues

    if (isFiltered) {
      doRebuildIndices(me._filteredValues, filteredIndices, keyProps, indexCount);
    }

    me._indicesInvalid = false;
  } // Returns an array with [indices] or [indices, filteredIndices] if filtering is used


  getIndices(propertyName) {
    const indices = [this.indices[propertyName]];

    if (this.isFiltered) {
      indices.push(this.indices[filteredIndicesProperty][propertyName]);
    }

    return indices;
  }
  /**
   * Add an item to all indices
   * @param {*} item Item already available in the Collection
   * @private
   */


  addToIndices(item) {
    Object.keys(this.indices).forEach(propertyName => {
      this.addIndexEntry(item, propertyName, item[propertyName]);
    });
  }
  /**
   * Remove an item from all indices
   * @param {*} item Item already available in the Collection
   * @private
   */


  removeFromIndices(item) {
    Object.keys(this.indices).forEach(propertyName => {
      this.removeIndexEntry(item, propertyName, item[propertyName]);
    });
  }
  /**
   * Remove an entry from an index, and if filtering is used also from the filtered index.
   * @param {*} item Item already available in the Collection
   * @param {String} propertyName Property of the item, will be matched with configured indices
   * @param {*} oldValue Value to remove
   * @private
   */


  removeIndexEntry(item, propertyName, oldValue) {
    this.getIndices(propertyName).forEach(index => removeItemFromIndex(item, index, oldValue));
  }
  /**
   * Add a new entry to an index, and if filtering is used also to the filtered index.
   * @param {*} item Item already available in the Collection
   * @param {String} propertyName Property of the item, will be matched with configured indices
   * @param {*} value Value to store
   * @private
   */


  addIndexEntry(item, propertyName, value) {
    this.getIndices(propertyName).forEach(index => addItemToIndex(item, index, value));
  }
  /**
   * Call externally to update indices on item mutation (from Store)
   * @param {*} item Item already available in the Collection
   * @param {Object} wasSet Uses the `wasSet` format from Store, `{ field : { oldValue, newValue } }`
   * @internal
   */


  onItemMutation(item, wasSet) {
    // Iterate over changes if we have extra indices defined, keeping those indices up to date
    if (!this._indicesInvalid && Object.keys(this.indices).length > 1) {
      Object.keys(wasSet).forEach(propertyName => {
        if (this.indices[propertyName]) {
          const {
            value,
            oldValue
          } = wasSet[propertyName];
          this.removeIndexEntry(item, propertyName, oldValue);
          this.addIndexEntry(item, propertyName, value);
        }
      });
    }
  } //endregion


} // These are used by Bag for the same purpose


Collection._$name = 'Collection';

/***/ }),

/***/ "./lib/Core/util/CollectionFilter.js":
/*!*******************************************!*\
  !*** ./lib/Core/util/CollectionFilter.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CollectionFilter; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony import */ var _data_Duration_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../data/Duration.js */ "./lib/Core/data/Duration.js");
var productName = 'taskboard';






/**
 * @module Core/util/CollectionFilter
 */

const nestedValueReducer = (object, path) => object === null || object === void 0 ? void 0 : object[path];
/**
 * A class which encapsulates a single filter operation which may be applied to any object to decide whether to
 * include or exclude it from a set.
 *
 * A CollectionFilter generally has at least three main properties:
 *
 * * `property` - The name of a property in candidate objects from which to extract the value to test
 * * `value` - The value which  this filter uses to test against.
 * * `operator` - The comparison operator, eg: `'='` or `'>'` etc.
 *
 * Given these three essential values, further configurations may affect how the filter is applied:
 *
 * * `caseSensitive` - If configured as `false`, string comparisons are case insensitive.
 * * `convert` - A function which, when passed the extracted value from the candidate object, returns the value to test.
 *
 * A filter may also be configured with a single `filterBy` property. This function is just passed the raw
 * candidate object and must return `true` or `false`.
 *
 * A CollectionFilter may be configured to encapsulate a single filtering function by passing that function as the sole
 * parameter to the constructor:
 *
 *     new CollectionFilter(candidate => candidate.title.contains('search string'));
 *
 */


class CollectionFilter extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_4__["default"]) {
  static get defaultConfig() {
    return {
      /**
       * The value against which to compare the {@link #config-property} of candidate objects.
       * @config {*}
       */
      value: null,

      /**
       * The operator to use when comparing a candidate object's {@link #config-property} with this CollectionFilter's {@link #config-value}.
       * May be: `'='`, `'!='`, `'>'`, `'>='`, `'<'`, `'<='`, `'*'`, `'startsWith'`, `'endsWith'`, `'isIncludedIn'`
       * @config {String}
       */
      operator: null,

      /**
       * May be used in place of the {@link #config-property}, {@link #config-value} and {@link #config-property} configs. A function which
       * accepts a candidate object and returns `true` or `false`
       * @config {Function}
       */
      filterBy: null,

      /**
       * A function which accepts a value extracted from a candidate object using the {@link #config-property} name, and
       * returns the value which the filter should use to compare against its {@link #config-value}.
       * @config {Function}
       */
      convert: null,

      /**
       * Configure as `false` to have string comparisons case insensitive.
       * @config {Boolean}
       */
      caseSensitive: true,

      /**
       * The `id` of this Filter for when used by a {@link Core.util.Collection} Collection.
       * By default the `id` is the {@link #config-property} value.
       * @config {String}
       */
      id: null,
      // Type is required to process the Date value in State API. Store doesn't always know about field type to
      // process filter value, when it applies it from the state, e.g. when you don't declare model field as `date`
      // type but provide a Date instance there. When DateColumn is used to shows this field, it could add date
      // filters to the store. When store is applying state it cannot just infer type, because model doesn't
      // declare it. Only column knows. So to properly process the Date instance for the filter State API would
      // have to process the field additionally, checking model field type and column type. So it is simpler to
      // make Filter to put this information. That way when filter is instantiated by the store, it can gracefully
      // handle value processing, converting date string to the Date instance.
      // Date is the only known value type so far which requires this processing.
      type: null
    };
  }

  static get configurable() {
    return {
      /**
       * The name of a property of candidate objects which yields the value to compare against this CollectionFilter's {@link #config-value}.
       * @member {String} property
       */

      /**
       * The name of a property of candidate objects which yields the value to compare against this CollectionFilter's {@link #config-value}.
       * @config {String}
       */
      property: null
    };
  }

  construct(config) {
    if (typeof config === 'function') {
      config = {
        filterBy: config
      };
    } // If Filter is created without a type (yet everything except applying state) create one


    if (!config.type) {
      if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isDate(config.value)) {
        config.type = 'date';
      } else if (config.value instanceof _data_Duration_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {
        config.type = 'duration';
      }
    } // If type already exist, it means we are applying state and should process value
    else {
      if (config.type === 'date') {
        config.value = new Date(config.value);
      } else if (config.type === 'duration') {
        config.value = new _data_Duration_js__WEBPACK_IMPORTED_MODULE_5__["default"](config.value);
      }
    }

    super.construct(config);
  }
  /**
   * When in a Collection (A Collection holds its Filters in a Collection), we need an id.
   * @property {String}
   * @private
   */


  get id() {
    return this._id || (this._id = this.property || CollectionFilter.generateId('b-filter'));
  }

  set id(id) {
    this._id = id;
  }

  onChange(propertyChanged) {
    const me = this; // Inform any owner (eg a Store), that it has to reassess its CollectionFilters

    if (!me.isConfiguring && me.owner && !me.owner.isConfiguring && me.owner.onFilterChanged) {
      me.owner.onFilterChanged(me, propertyChanged);
    }
  }

  get filterBy() {
    return this._filterBy || this.defaultFilterBy;
  }
  /**
   * May be used in place of the {@link #config-property}, {@link #config-value} and {@link #config-property} configs. A function which
   * accepts a candidate object and returns `true` or `false`
   * @type {Function}
   */


  set filterBy(filterBy) {
    this._filterBy = filterBy;
  }

  defaultFilterBy(candidate) {
    const me = this;
    let candidateValue; // check if is nested property

    if (me._propertyItems.length > 1) {
      // support nested props (https://github.com/bryntum/support/issues/1861)
      candidateValue = me._propertyItems.reduce(nestedValueReducer, candidate);
    } else {
      candidateValue = candidate[me.property];
    }

    return me[me.operator](me.convert(candidateValue));
  }

  updateProperty(property) {
    this._propertyItems = property.split('.'); // Signal to owner about filter change

    this.onChange('property');
  }
  /**
   * The value against which to compare the {@link #config-property} of candidate objects.
   * @type {*}
   */


  set value(value) {
    var _value$valueOf, _value;

    this._value = value;
    value = (_value$valueOf = (_value = value) === null || _value === void 0 ? void 0 : _value.valueOf()) !== null && _value$valueOf !== void 0 ? _value$valueOf : value; // Filter value is a processed value to be used by the comparators. Useful when value is object, like Duration field

    this._filterValue = !this.caseSensitive && typeof value === 'string' ? value.toLowerCase() : value; // Signal to owner about filter change

    this.onChange('value');
  }

  get value() {
    return this._value;
  }

  get filterValue() {
    return this._filterValue;
  }
  /**
   * The operator to use when comparing a candidate object's {@link #config-property} with this CollectionFilter's {@link #config-value}.
   * May be: `'='`, `'!='`, `'>'`, `'>='`, `'<'`, `'<='`, `'*'`, `'startsWith'`, `'endsWith'`, `'isIncludedIn'`
   * @type {String}
   */


  set operator(operator) {
    this._operator = operator; // Signal to owner about filter change

    this.onChange('operator');
  }

  get operator() {
    if (this._operator) {
      return this._operator;
    }

    if (Array.isArray(this.filterValue)) {
      return 'isIncludedIn';
    }

    return typeof this.filterValue === 'string' ? '*' : '=';
  }

  convert(value) {
    // This is a workaround for filterbar feature: it always converts input value to string. When date is typed,
    // it is converted into string, and Date.valueOf() would return number. So if we are matching date against string
    // type, we should not convert it.
    if (!(typeof this.filterValue === 'string' && value instanceof Date)) {
      var _value$valueOf2, _value2;

      // if value is a complex type, try to access `value` property to get primitive value
      value = (_value$valueOf2 = (_value2 = value) === null || _value2 === void 0 ? void 0 : _value2.valueOf()) !== null && _value$valueOf2 !== void 0 ? _value$valueOf2 : value;
    }

    value = !this.caseSensitive && typeof value === 'string' ? value.toLowerCase() : value;
    return value;
  }

  filter(candidate) {
    return this.filterBy(candidate);
  }

  startsWith(v) {
    return String(v).startsWith(this.filterValue);
  }

  endsWith(v) {
    return String(v).endsWith(this.filterValue);
  }

  isIncludedIn(v) {
    return this.filterValue.length === 0 || this.filterValue.includes(v);
  }

  '='(v) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(v, this.filterValue);
  }

  '!='(v) {
    return !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(v, this.filterValue);
  }

  '>'(v) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isMoreThan(v, this.filterValue);
  }

  '>='(v) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isMoreThan(v, this.filterValue) || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(v, this.filterValue);
  }

  '<'(v) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isLessThan(v, this.filterValue);
  }

  '<='(v) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isLessThan(v, this.filterValue) || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(v, this.filterValue);
  }

  '*'(v) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isPartial(v, this.filterValue);
  } // Accepts an array or a Collection


  static generateFiltersFunction(filters) {
    if (!filters || !filters.length && !filters.count) {
      return _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].returnTrue;
    }

    return function (candidate) {
      let match = true;

      for (const filter of filters) {
        // Skip disabled filters
        if (!filter.disabled) {
          match = filter.filter(candidate);
        }

        if (!match) {
          break;
        }
      }

      return match;
    };
  }

}
CollectionFilter._$name = 'CollectionFilter';

/***/ }),

/***/ "./lib/Core/util/CollectionSorter.js":
/*!*******************************************!*\
  !*** ./lib/Core/util/CollectionSorter.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CollectionSorter; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/IdHelper.js */ "./lib/Core/helper/IdHelper.js");
var productName = 'taskboard';


/**
 * @module Core/util/CollectionSorter
 */

/**
 * A class which encapsulates a single sorter operation which may be applied to any object to decide whether to
 * include or exclude it from a set.
 *
 * A CollectionSorter generally has two properties:
 *
 * * `property` - The name of a property in collection objects by which to sort
 * * `direction` - The sort direction, `'ASC'` or `'DESC'`.
 *
 * It may also be configured with just a {@link #config-sortFn} function which returns the desired comparison
 * result when passed two objects to compare. Note that this does *not* require or use the
 * {@link #config-property} config. Two collection items are passed for comparison.
 *
 * Further configurations may affect how the sorter is applied:
 *
 * * `convert` - A function which, when passed the {@link #config-property} value from
 * a collection object, returns the value to sort by.
 *
 * A CollectionSorter may be configured to encapsulate a {@link #config-sortFn} by passing that function as the sole
 * parameter to the constructor:
 *
 *     new CollectionSorter((lhs, rhs) => {
 *         lhs = lhs.customerDetails.companyName.toLowerCase();
 *         rhs = rhs.customerDetails.companyName.toLowerCase();
 *
 *         if (lhs < rhs) {
 *             return -1;
 *         }
 *         else if (lhs > rhs) {
 *             return 1;
 *         }
 *         else {
 *             return 0;
 *         }
 *     });
 *
 */

class CollectionSorter extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * The name of a property of collection objects which yields the value to sort by.
       * @config {String}
       */
      property: null,

      /**
       * The direction to sort in, `'ASC'` or `'DESC'`
       * @config {String}
       * @default
       */
      direction: 'ASC',

      /**
       * A function which takes the place of using {@link #config-property} and {@link #config-direction}.
       * The function is passed two objects from the collection to compare and must return the comparison result.
       * @config {Function}
       */
      sortFn: null,

      /**
       * When using {@link #config-property}, this may be specified as a function which takes the raw
       * property value and returns the value to actually sort by.
       * @config {Function}
       */
      convert: null,

      /**
       * The `id` of this Sorter for when used by a {@link Core.util.Collection} Collection.
       * By default the `id` is the {@link #config-property} value.
       * @config {String}
       */
      id: null,

      /**
       * Use `localeCompare()` when sorting, which lets the browser sort in a locale specific order. Set to `true`,
       * a locale string or a locale config to enable.
       *
       * Enabling this has big negative impact on sorting
       * performance. For more info on `localeCompare()`, see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare).
       *
       * ```javascript
       * collection.addSorter({ field: 'name', useLocaleSort : 'sv-SE' });
       * ```
       *
       * @config {Boolean|String|Object}
       * @default false
       */
      useLocaleSort: null
    };
  }

  construct(config) {
    if (typeof config === 'function') {
      config = {
        sortFn: config
      };
    }

    super.construct(config);
  }
  /**
   * When in a Collection (A Collection holds its Sorters in a Collection), we need an id.
   * @property {String}
   * @private
   */


  get id() {
    return this._id || (this._id = this.property || _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].generateId('b-sorter'));
  }

  set id(id) {
    this._id = id;
  }

  set sortFn(sortFn) {
    this._sortFn = sortFn;
  }

  get sortFn() {
    if (this._sortFn) {
      return this._sortFn;
    }

    return this.defaultSortFn;
  }
  /**
   * Default sortFn used when no sortFn specified. Uses the {@link #config-property},
   * {@link #config-direction}, and {@link #config-convert}.
   * @private
  */


  defaultSortFn(lhs, rhs) {
    const me = this,
          {
      convert,
      property,
      useLocaleSort
    } = me,
          multiplier = me.direction.toLowerCase() === 'desc' ? -1 : 1;
    lhs = lhs[property];
    rhs = rhs[property];

    if (convert) {
      lhs = convert(lhs);
      rhs = convert(rhs);
    }

    if (useLocaleSort && lhs != null && rhs != null) {
      // Use systems locale
      if (useLocaleSort === true) {
        return String(lhs).localeCompare(rhs);
      } // Use specified locale


      if (typeof useLocaleSort === 'string') {
        return String(lhs).localeCompare(rhs, useLocaleSort);
      } // Use locale config


      if (typeof useLocaleSort === 'object') {
        return String(lhs).localeCompare(rhs, useLocaleSort.locale, useLocaleSort);
      }
    }

    return (lhs > rhs ? 1 : lhs < rhs ? -1 : 0) * multiplier;
  }

  static generateSortFunction(sorters, tieBreaker) {
    const items = sorters.isCollection ? sorters.values : sorters,
          n = items.length;
    return (lhs, rhs) => {
      let comp, i;

      for (i = 0; i < n; ++i) {
        comp = items[i].sortFn(lhs, rhs);

        if (comp) {
          return comp;
        }
      }

      return tieBreaker ? tieBreaker(lhs, rhs) : 0;
    };
  }

}
CollectionSorter._$name = 'CollectionSorter';

/***/ }),

/***/ "./lib/Core/util/DayTime.js":
/*!**********************************!*\
  !*** ./lib/Core/util/DayTime.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DayTime; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'taskboard';

/**
 * @module Core/util/DayTime
 */

const MILLIS_PER_MINUTE = 60 * 1000,
      MILLIS_PER_HOUR = 60 * MILLIS_PER_MINUTE,
      MILLIS_PER_DAY = 24 * MILLIS_PER_HOUR,
      timeRe = /(\d+)?:?(\d*)/;
/**
 * This class encapsulates time of day calculations.
 *
 * The goal is to describe a "day" (a 24-hour period) that starts at a specific time (other than midnight). In a
 * calendar day view, this would look like this:
 * ```
 *              startShift=0                          startShift='12:00'
 *       00:00  +-------+                      12:00  +-------+
 *              |       |                             |       |
 *       01:00  |- - - -|                      13:00  |- - - -|
 *                 ...                                   ...
 *              |       |                             |       |
 *       08:00  |- - - -|   <-- timeStart -->  20:00  |- - - -|
 *              |       |                             |       |
 *       09:00  |- - - -|                      21:00  |- - - -|
 *              |       |                             |       |
 *       10:00  |- - - -|                      22:00  |- - - -|
 *              |       |                             |       |
 *       11:00  |- - - -|                      23:00  |- - - -|
 *              |       |                             |       |
 *       12:00  |- - - -|                      00:00  |- - - -|
 *              |       |                             |       |
 *       13:00  |- - - -|                      01:00  |- - - -|
 *              |       |                             |       |
 *       14:00  |- - - -|                      02:00  |- - - -|
 *              |       |                             |       |
 *       15:00  |- - - -|                      03:00  |- - - -|
 *              |       |                             |       |
 *       16:00  |- - - -|                      04:00  |- - - -|
 *              |       |                             |       |
 *       17:00  |- - - -|    <-- timeEnd -->   05:00  |- - - -|
 *              |       |                             |       |
 *                 ...                                   ...
 *              |       |                             |       |
 *       23:00  |- - - -|                      11:00  |- - - -|
 *              |       |                             |       |
 *       00:00  +-------+                      12:00  +-------+
 * ```
 * In a horizontal format with X for times to render:
 * ```
 *  startShift = 0
 *
 *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
 *      |   |   |  ...  |   |XXX|XXX|  ...  |XXX|XXX|   |  ...  |   |
 *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
 *      00  01  02      07  08  09  10      15  16  17  18      23  00
 *                          ^                       ^
 *                      timeStart               timeEnd
 *
 *  startShift = '12:00'
 *
 *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
 *      |   |   |  ...  |   |XXX|XXX|X ... X|XXX|XXX|   |  ...  |   |
 *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
 *      12  13  14      19  20  21  22      03  04  05  06      11  12
 *                          ^                       ^
 *                      timeStart               timeEnd
 * ```
 * When the day wraps over midnight, it is describing this (note timeEnd < timeStart):
 * ```
 *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
 *      |XXX|XXX|X ... X|XXX|   |   |  ...  |   |   |XXX|X ... X|XXX|
 *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
 *      00  01  02      04  05  06  07      18  19  20  21      23  00
 *                          ^                       ^
 *                      timeEnd                 timeStart
 * ```
 * @internal
 */

class DayTime {
  /**
   * Returns a string of "HH:MM" for a given time of day in milliseconds.
   * @param {Number} timeOfDay The time of day in milliseconds.
   * @returns {String}
   * @private
   */
  static format(timeOfDay) {
    const h = Math.floor(timeOfDay / MILLIS_PER_HOUR),
          m = Math.floor(timeOfDay / MILLIS_PER_MINUTE) % 60;
    return `${h}:${m < 10 ? '0' : ''}${m}`;
  }
  /**
   * Parses a time of day which may be a number (0-24 for the hour of the day) or a string in "H:MM" format and
   * returns the time of day as a number of milliseconds.
   *
   * If `time` is a `Date` instance, its time of day is returned.
   * @param {Date|Number|String} time
   * @returns {Number}
   * @private
   */


  static parse(time) {
    const type = typeof time;

    if (type === 'string') {
      const match = timeRe.exec(time);
      time = Number(match[1] || 0) * MILLIS_PER_HOUR + Number(match[2] || 0) * MILLIS_PER_MINUTE;
    } else if (type !== 'number') {
      time = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTimeOfDay(time);
    } else if (time <= 24) {
      // if number of hours (as provided during config)
      time *= MILLIS_PER_HOUR;
    }

    return Math.min(Math.max(Math.floor(time), 0), MILLIS_PER_DAY);
  }

  constructor(config) {
    let startShift = 0,
        startTime,
        endTime;

    if (config !== null && config !== void 0 && config.isDayView) {
      // These are raw configs in hrs or 'HH:MM' on construction and millis after:
      startShift = config.dayStartShift;
      startTime = config.dayStartTime;
      endTime = config.dayEndTime;
    } else if (typeof config === 'number') {
      startShift = startTime = endTime = config;
    } else if (config) {
      /**
       * Either the hour number or a *24 hour* `HH:MM` string denoting the start time for the day. This is
       * midnight by default.
       * @config {Number|String} startShift
       * @default 0
       */
      startShift = config.startShift;
      /**
       * Either the hour number or a *24 hour* `HH:MM` string denoting the first visible time of day. You can also
       * set this value to a ms timestamp representing time from midnight.
       * @config {Number|String} timeStart
       * @default 0
       */

      startTime = config.timeStart;
      /**
       * Either the hour number or a *24 hour* `HH:MM` string denoting the last visible time of day. You can also
       * set this value to a ms timestamp representing time from midnight.
       * @config {Number|String} timeEnd
       * @default 24
       */

      endTime = config.timeEnd;
    }

    this.startShift = startShift = DayTime.parse(startShift || 0);
    this.timeEnd = (endTime == null ? (startShift + MILLIS_PER_DAY) % MILLIS_PER_DAY : DayTime.parse(endTime)) || MILLIS_PER_DAY;
    this.timeStart = startTime == null ? startShift : DayTime.parse(startTime);
  }

  get startHour() {
    return Math.floor(this.timeStart / MILLIS_PER_HOUR);
  }
  /**
   * The number of milliseconds from the day's `startShift` to its `timeStart`.
   * @member {Number}
   */


  get startTimeOffsetMs() {
    const {
      startShift,
      timeStart
    } = this;
    return timeStart < startShift ? MILLIS_PER_DAY - startShift + timeStart : timeStart - startShift;
  }
  /**
   * The `Date` object for the most recently started, shifted day. The time of this `Date` will be the `startShift`.
   * It is possible for this date to be yesterday on a midnight-based calendar. For example, if the `startShift` is
   * 6PM and the current time is 6AM on May 20, this value will be 6PM of May 19 (the most recently started day).
   * @member {Date}
   */


  get today() {
    return this.startOfDay(new Date());
  }
  /**
   * Returns `Date` object for the nearest (shifted) day ending after the given `date`. The time of this `Date` will
   * be the `startShift`.
   *
   * It is possible for this date to be in the next day on a midnight-based calendar. For example, if the `startShift`
   * is 6PM and `date` is 7PM on May 20, this method will return 6PM of May 21 (the nearest day ending).
   * @param {Date} date The date for which to find the nearest day ending.
   * @returns {Date}
   */


  ceil(date) {
    const ret = this.startOfDay(date);

    if (ret < date) {
      ret.setDate(ret.getDate() + 1);
    }

    return ret;
  }
  /**
   * Returns `true` if the time of day for the given `date` is between `timeStart` and `timeEnd`.
   * @param {Date|Number|String} date The hour number, 'HH:MM' time or a `Date` instance to test.
   * @returns {Boolean}
   */


  contains(date) {
    return !this.outside(date);
  }
  /**
   * Returns a "YYYY-MM-DD" string for the given `date`. This value will match the `date` if the time of day is at or
   * after `startShift`, but will be the prior date otherwise.
   * @param {Date|Number} date The date from which to compute the 'YYYY-MM-DD' key.
   * @returns {String}
   */


  dateKey(date) {
    date = this.shiftDate(date, -1);
    return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].makeKey(date);
  }
  /**
   * Returns a `Date` instance with `startShift` as the time of day and the Y/M/D of the given `date`.
   * @param {Date} date The date's year, month, and day values.
   * @returns {Date}
   */


  dayOfDate(date) {
    return this.shiftDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(date)); // return the Date w/the matching YYYY-MM-DD value
  }
  /**
   * Returns the day of week (0-8) for the given `date`. This value will match the `date` if the time of day is at or
   * after `startShift`, but will be the prior day otherwise.
   * @param {Date|Number} date The date from which to compute the day of week.
   * @returns {Number}
   */


  dayOfWeek(date) {
    date = this.shiftDate(date, -1);
    return date.getDay();
  }
  /**
   * Returns the difference between the time of day of the given `date` and `timeStart` in the specified time `unit`.
   * @param {Date|Number|String} date The hour number, 'HH:MM' time or a `Date` instance.
   * @param {String} unit The desired unit of time to return (see {@link Core.helper.DateHelper#function-as-static}).
   * @returns {Number}
   */


  delta(date, unit = 'ms') {
    const {
      timeStart
    } = this,
          time = DayTime.parse(date),
          t = (this.startShift && time < timeStart ? time + MILLIS_PER_DAY : time) - timeStart;
    return unit === 'ms' ? t : _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].as(unit, t, 'ms');
  }
  /**
   * Returns the duration of the visible day (between `timeStart` and `timeEnd`) in the specified time `unit`.
   * @param {String} unit The desired unit of time to return (see {@link Core.helper.DateHelper#function-as-static}).
   * @returns {Number}
   */


  duration(unit = 'ms') {
    const {
      timeStart,
      timeEnd
    } = this,
          millis = timeStart < timeEnd ? timeEnd - timeStart : MILLIS_PER_DAY - timeStart + timeEnd;
    return unit === 'ms' ? millis : _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].as(unit, millis, 'ms');
  }
  /**
   * Returns `true` if this instance describes the same day as the `other`.
   * @param {Core.util.DayTime} other The other instance to which `this` instance should be tested for equality.
   * @returns {Boolean}
   */


  equals(other) {
    // we only need on "?." operator since we short-circuit
    return this.startShift === (other === null || other === void 0 ? void 0 : other.startShift) && this.timeStart === other.timeStart && this.timeEnd === other.timeEnd;
  }
  /**
   * Returns `true` if the times of day described by `startDate` and `endDate` intersect the visible time of this day.
   * @param {Date} startDate The start date of the date range or an event record containing both startDate and endDate
   * fields.
   * @param {Date} [endDate] The end date if `startDate` is not an event record.
   * @returns {Boolean}
   */


  intersects(startDate, endDate) {
    const me = this,
          {
      timeStart,
      timeEnd
    } = me,
          [date0, date1] = me._dateRangeArgs(startDate, endDate),
          [start, end] = me.timeRange(date0, date1);

    if (timeStart < timeEnd) {
      if (start < end) {
        return start < timeEnd && timeStart <= end;
      }

      return start < timeEnd || timeStart <= end;
    }

    return !(start < end) || start < timeEnd || timeStart <= end;
  }
  /**
   * Returns `true` if the given date range is contained within one day.
   * @param {Date} startDate The start date of the date range or an event record containing both startDate and endDate
   * fields.
   * @param {Date} [endDate] The end date if `startDate` is not an event record.
   * @returns {Boolean}
   */


  isIntraDay(startDate, endDate) {
    const me = this,
          [date0, date1] = me._dateRangeArgs(startDate, endDate),
          dayStart = me.startOfDay(date0),
          diff = MILLIS_PER_DAY - _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].diff(dayStart, date1, 'ms'); // Not <= to match isInterDay


    if (diff < 0) {
      return false;
    } // diff > 0 means less than 24hrs, so intraDay... diff==0 means date1 was EOD so we are intraDay if date0 is not
    // also at EOD.


    return diff > 0 || dayStart < date0;
  }
  /**
   * Returns -1, 0, or 1 based on whether the time of day for the given `date` is before `timeStart` (-1), or after
   * `timeEnd` (1), or between these times (0).
   * @param {Date|Number|String} date The hour number, 'HH:MM' time or a `Date` instance to test.
   * @returns {Number}
   */


  outside(date) {
    const {
      startShift,
      timeStart,
      timeEnd
    } = this,
          time = DayTime.parse(date);

    if (timeStart < timeEnd) {
      /*
       *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
       *      |   |   |  ...  |   |XXX|XXX|  ...  |XXX|XXX|   |  ...  |   |
       *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
       *      00  01  02      07  08  09  10      15  16  17  18      23  00
       *                          ^                       ^
       *                      timeStart               timeEnd
       */
      if (time < timeStart) {
        return time < startShift ? 1 : -1;
      }

      if (time < timeEnd) {
        return 0;
      }

      return time < startShift ? -1 : 1;
    }
    /*
     *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
     *      |XXX|XXX|X ... X|XXX|   |   |  ...  |   |   |XXX|X ... X|XXX|
     *      +---+---+---  --+---+---+---+--   --+---+---+---+--   --+---+
     *      00  01  02      04  05  06  07      18  19  20  21      23  00
     *                          ^                       ^
     *                      timeEnd                 timeStart
     */


    if (time < timeEnd || time >= timeStart) {
      return 0;
    }

    return time < startShift ? 1 : -1;
  }
  /**
   * Returns the given `date` shifted forward (`direction` > 0) or backward (`direction` < 0) by the `startShift`.
   * @param {Number|Date} date The date as a `Date` or the millisecond UTC epoch.
   * @param {Number} direction A value > 0 to shift `date` forward, or < 0 to shift it backwards.
   * @returns {Date}
   */


  shiftDate(date, direction = 1) {
    const {
      startShift
    } = this,
          type = typeof date;
    date = type === 'number' ? new Date(date) : type === 'string' ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].parse(date) : new Date(date.getTime()); // Not this:
    // return (direction && startShift) ? DH.add(date, (direction > 0) ? startShift : -startShift, 'ms') : date;
    // the DH.add() goes via UTC timestamp and so will not end on the correct time of day when DST is hit

    if (direction && startShift) {
      date.setMilliseconds(direction > 0 ? startShift : -startShift);
    }

    return date;
  }
  /**
   * Returns `Date` object for the nearest started (shifted) day prior to the given `date`. The time of this `Date`
   * will be the `startShift`.
   *
   * It is possible for this date to be in the prior day on a midnight-based calendar. For example, if the `startShift`
   * is 6PM and `date` is 6AM on May 20, this method will return 6PM of May 19 (the nearest started day).
   * @param {Date} date The date for which to find the nearest started day.
   * @returns {Date}
   */


  startOfDay(date) {
    date = this.shiftDate(date, -1);
    date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(date);
    date = this.shiftDate(date);
    return date;
  }
  /**
   * TODO
   * @param {Date} startDate The start date of the date range or an event record containing both startDate and endDate
   * fields.
   * @param {Date} [endDate] The end date if `startDate` is not an event record.
   * @returns {Number[]}
   */


  timeRange(startDate, endDate) {
    const [start, end] = this._dateRangeArgs(startDate, endDate);

    return [_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTimeOfDay(start), _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTimeOfDay(end)];
  }

  toString() {
    const {
      startShift,
      timeEnd,
      timeStart
    } = this,
          suffix = startShift ? `@${DayTime.format(startShift)}` : '',
          prefix = DayTime.format(timeStart);

    if (timeStart === timeEnd) {
      return startShift ? suffix : prefix;
    }

    return `${prefix}-${DayTime.format(timeEnd)}${suffix}`;
  }

  /**
   * Decodes the arguments and returns a pair of `Date` objects for the start and end of the date range.
   * @param {Date} startDate The start date of the date range or an event record containing both startDate and endDate
   * fields.
   * @param {Date} [endDate] The end date if `startDate` is not an event record.
   * @returns {Date[]}
   * @private
   */
  _dateRangeArgs(startDate, endDate) {
    return startDate.isModel ? [startDate.startDate, startDate.endingDate] : [startDate, endDate];
  }

}
/**
 * The `DayTime` instance representing a canonical calendar day (starting at midnight).
 * @member {Core.util.DayTime} MIDNIGHT
 * @static
 * @readonly
 */

DayTime.MIDNIGHT = new DayTime({
  startShift: 0,
  timeStart: 0,
  timeEnd: 24
});
DayTime.MILLIS_PER_MINUTE = MILLIS_PER_MINUTE;
DayTime.MILLIS_PER_HOUR = MILLIS_PER_HOUR;
DayTime.MILLIS_PER_DAY = MILLIS_PER_DAY;
DayTime._$name = 'DayTime';

/***/ }),

/***/ "./lib/Core/util/DynamicObject.js":
/*!****************************************!*\
  !*** ./lib/Core/util/DynamicObject.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DynamicObject; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



/**
 * @module Core/util/DynamicObject
 */

const PENDING = Symbol('pendingCreate');
/**
 * This class is used to manage dynamic creation and configuration of individual properties of an object. This pattern
 * is used to allow the names of an object to each represent a dynamically instantiated object. For example, the
 * `features` config of Calendar is defined like so:
 *
 * ```javascript
 *  class Calendar extends ... {
 *      static get configurable() {
 *          return {
 *              features : {
 *                  drag : {
 *                      // configs for Drag feature
 *                  }
 *              }
 *          }
 *      }
 *  }
 * ```
 * This class is used to manage the `features` objects in the above case. The `drag` property value is promoted from
 * the config object defined by the class and user instance on first request. Like config properties themselves, these
 * features may access other features during their initialization. These accesses are trapped by this class to ensure
 * the config object is promoted to an instantiated instance.
 *
 * A {@link #config-factory} is provided to this object to allow it to create instances from names like `'drag'`.
 * @internal
 */

class DynamicObject extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get prototypeProperties() {
    return {
      /**
       * Optional function that will be passed an instance prior to destroying it.
       * @param {String} name The property name in the Dynamic object by which the new instance may be referenced.
       * @param {Object} instance The value of the property.
       * @config {Function}
       */
      cleanup: null,

      /**
       * Optional name of the config property managed by this instance. If changes are made directly, this
       * property is used to run the `onConfigChange` method of the `owner`.
       * @config {String}
       */
      configName: null,

      /**
       * Optional function to call as instances are created. Each new instance is passed to this function.
       * @param {Object} instance The newly created instance.
       * @param {String} key The property name in the dynamic object by which the new instance may be referenced.
       * @config {Function}
       */
      created: null,

      /**
       * The {@link Core.mixin.Factoryable factory} to use to create instances.
       * @config {Object}
       */
      factory: null,

      /**
       * By default, the name of the member is used for the type. Set this config to `true` to also allow the
       * config object for a property to contain a `type` property. Set this to `false` to ignore the name of the
       * member and rely on the {@link #config-factory} to process the config object.
       * @config {Boolean|String}
       * @default
       */
      inferType: 'name',

      /**
       * The owning object to pass along to the instances as the `ownerName` property.
       * @config {Object}
       */
      owner: null,

      /**
       * The property name by which to store the `owner` on each instance.
       * @config {String}
       */
      ownerName: null,

      /**
       * Set to `false` to prevent using a `Proxy` even if that JavaScript platform feature is available. Using
       * a `Proxy` is ideal because it allows for all forms of access to the dynamic properties to be handled
       * instead of only those that have predefined configuration values.
       * @config {Boolean}
       * @private
       */
      proxyable: typeof Proxy !== 'undefined',

      /**
       * Optional function that will be passed a config object prior to instantiating an object. This function
       * can either modify the passed object or return a new object.
       * @param {Object} config The config object used to create the object
       * @param {String} name The property name in the Dynamic object by which the new instance may be referenced.
       * @config {Function}
       */
      setup: null,

      /**
       * Optional function that will be passed a raw config object prior to processing and the value it returns
       * replaces the raw value. This function is used to transform strings or arrays (for example) into proper
       * config objects.
       * @param {*} config The original value of the config object parameter
       * @config {Function}
       */
      transform: null
    };
  }

  static get properties() {
    return {
      /**
       * Holds config objects for each defined object. These are used to hold class and instance config values
       * and use them to create instances on first request, or when `flush()` is called. Further, if the instance
       * is initially assigned instead of retrieved, these values act as the defaults for the instance and are
       * combined with those provided in the assignment.
       * @member {Object} defaults
       * @private
       */
      defaults: {},

      /**
       * This object holds the actual instances that are retrieved by the dynamic accessor or `Proxy`.
       * @member {Object} instances
       * @private
       */
      instances: {},

      /**
       * The object that contains the dynamic accessors for each instance. This object is not used when using a
       * `Proxy`.
       * @member {Object} object
       * @private
       */
      object: Object.create({})
    };
  }
  /**
   * Returns the `Proxy` instance used to manage dynamic assignments. If the JavaScript platform does not support the
   * `Proxy` class, this will be `null`.
   * @property {Proxy}
   * @private
   */


  get proxy() {
    const me = this;
    let proxy = null;

    if (me.proxyable) {
      proxy = new Proxy(me.instances, {
        get(o, name) {
          return me.get(name);
        },

        set(o, name, value) {
          me.set(name, value);
          return true;
        },

        deleteProperty(o, name) {
          me.set(name, null);
          return true;
        }

      });
    } // Replace our getter with the result for quicker future use.


    Reflect.defineProperty(me, 'proxy', {
      configurable: true,
      // allow destroy() to delete it
      value: proxy
    });
    return proxy;
  }
  /**
   * Returns the object that contains the dynamic properties. This may be a `Proxy` instance or an object with getter
   * and setter accessors.
   * @property {Object}
   * @internal
   */


  get target() {
    return this.proxy || this.object;
  }
  /**
   * This method establishes the initial definition of a dynamic property. When using a `Proxy`, this method simply
   * needs to cache away the initial config for use by the getter. When `Proxy` is unavailable, this method will
   * also defined a getter/setter to intercept access to the dynamic property.
   * @param {String} name The name of the dynamic property.
   * @param {Object} config The initial config object for the dynamic property.
   * @private
   */


  define(name, config) {
    const me = this,
          {
      transform
    } = me,
          transformed = transform ? transform(config, name) : config,
          instantiated = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isInstantiated(transformed);
    me.instances[name] = PENDING;

    if (!instantiated) {
      me.setDefaults(name, transformed);
    } // We provide get/set accessors on our `object` so that we can create the instance on first use and provide
    // the correct defaults. The setter also handles reassignment and reconfiguration. These accessors are
    // placed on the prototype of `object` so that we can add/remove the same accessors from `object` itself.
    // This allows users of the object to see the correct number of "own" keys for enumeration.


    me.defineProp(name, true);

    if (instantiated) {
      me.set(name, transformed);
    }
  }
  /**
   * Define the get/set accessors for `name` on our `object` or its prototype.
   * @param {String} name
   * @param {Boolean} [base] Pass `true` to indicate the property should be defined on the prototype.
   * @private
   */


  defineProp(name, base) {
    const me = this,
          {
      object
    } = me;

    if (!me.proxy) {
      Reflect.defineProperty(base ? Object.getPrototypeOf(object) : object, name, {
        configurable: !base,
        enumerable: true,

        get() {
          return me.get(name);
        },

        set(value) {
          return me.set(name, value);
        }

      });
    }
  }
  /**
   * Ensures that all defined members are touched to trigger their creation.
   * @internal
   */


  flush() {
    const me = this; // Iterate the defaults object to loop over all the defined items:

    try {
      var _me$afterConfigureOwn;

      me.updating = true;

      for (const name in me.defaults) {
        me.get(name);
      }

      me.afterConfigureOwner = (_me$afterConfigureOwn = me.afterConfigureOwner) === null || _me$afterConfigureOwn === void 0 ? void 0 : _me$afterConfigureOwn.call(me);
    } finally {
      me.updating = false;
    }
  }
  /**
   * Returns (lazily creating as necessary) the value of a dynamic property given its name.
   * @param {String} name
   * @returns {Object}
   * @private
   */


  get(name) {
    const {
      defaults,
      instances
    } = this;

    if (instances[name] === PENDING) {
      this.set(name, PENDING);
    } // Return null for defined instances that have been nulled out and undefined otherwise:


    return instances[name] || defaults[name] && null;
  }
  /**
   * Sets the value of a dynamic property given its name and value.
   * @param {String} name
   * @param {Object} value
   * @private
   */


  set(name, value) {
    const me = this,
          {
      cleanup,
      configName,
      defaults,
      factory,
      instances,
      owner,
      setup,
      transform,
      updating
    } = me,
          inform = owner && configName && !updating,
          was = instances[name] === PENDING ? null : instances[name],
          instance = factory.reconfigure(was, value === PENDING ? {} : value || null, {
      cleanup: cleanup && (instance => cleanup(instance, name)),
      defaults: defaults[name] || me.setDefaults(name, {}),
      owner: me.owner,
      setup: setup && ((config, type, defaults) => setup(config, name, type, defaults)),
      transform: transform && (config => transform(config, name))
    });

    if (instance !== was) {
      const before = inform && _objectSpread({}, instances);

      instances[name] = instance;

      if (instance) {
        var _me$created;

        me.defineProp(name);
        (_me$created = me.created) === null || _me$created === void 0 ? void 0 : _me$created.call(me, instance, name);
      } else {
        delete me.object[name];
        delete instances[name];
      }

      if (inform) {
        owner.onConfigChange({
          name: configName,
          config: owner.$meta.configs[configName],
          value: me.target,
          was: before
        });
      }
    }
  }
  /**
   * Stores the default config values for use in the factory reconfiguration process.
   * @param {String} name The name and default type of the dynamic property. Depending on {@link #config-inferType},
   * this may not be overridden by a type property in the config object.
   * @param {Object} config The config object.
   * @returns {Object}
   * @private
   */


  setDefaults(name, config) {
    const {
      defaults,
      factory,
      inferType,
      instances,
      owner,
      ownerName
    } = this,
          {
      typeKey
    } = factory.factoryable;
    config = config === true ? {} : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, config); // copy props even from prototype

    if (inferType === 'name' || inferType === true && !config[typeKey]) {
      config[typeKey] = name;
    } // Store this object as the "owner" on the config object so instances can access their creating object:


    if (ownerName) {
      config[ownerName] = owner;
    }

    config.beforeConfigure = instance => {
      // Ensure the feature is injected into the features object before initialization so that it is
      // available to call chains from its initialization.
      instances[name] = instance;
    };

    return defaults[name] = config;
  }
  /**
   * Updates the members of `object` based on the provided configuration.
   * @param {Object} members The configuration for the instances of `object`.
   * @internal
   */


  update(members) {
    const me = this,
          {
      owner
    } = me;
    let name, config;

    try {
      me.updating = true;

      if (members) {
        // We prime the features so that if any configuration code accesses a feature, it will self initialize,
        // but if not, they will remain in a primed state until afterConfigure.
        for (name in members) {
          config = members[name];

          if (me.defaults[name]) {
            // if (already defined)
            me.set(name, config);
          } else if (config) {
            me.define(name, config);
          }
        } // NOTE: we leave alone any existing features that were not present in the given object. To remove a
        // feature, you must set it to null or set all features to null.

      } else {
        for (name in me.instances) {
          me.set(name, null);
        }
      }
    } finally {
      me.updating = false;
    }

    if (owner) {
      // Normally we wait for afterConfigure to create all the objects, but if we are being called after that
      // point in the life cycle, we need to flush them out now. We still use the same delay technique in case
      // the user adds multiple properties dynamically.
      if (!owner.isConfiguring) {
        me.flush();
      } else if (!me.afterConfigureOwner) {
        // Since we are being called while the owner isConfiguring, set a hook on owner.afterConfigure() so
        // that we can make good on creating the child objects.
        me.afterConfigureOwner = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].before(owner, 'afterConfigure', 'flush', me);
      }
    }
  }

}
DynamicObject.initClass();
DynamicObject._$name = 'DynamicObject';

/***/ }),

/***/ "./lib/Core/util/Month.js":
/*!********************************!*\
  !*** ./lib/Core/util/Month.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Month; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _DayTime_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DayTime.js */ "./lib/Core/util/DayTime.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';





/**
 * @module Core/util/Month
 */

/**
 * A class which encapsulates a calendar view of a month, and offers information about
 * the weeks and days within that calendar view.
 * ```
 *   // December 2018 using Monday as week start
 *   const m = new Month({
 *       date         : '2018-12-01',
 *       weekStartDay : 1
 *   });
 *
 *   m.eachWeek((week, dates) => console.log(dates.map(d => d.getDate())))
 * ```
 */

class Month extends Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get configurable() {
    return {
      /**
       * The date which the month should encapsulate. May be a `Date` object, or a
       * `YYYY-MM-DD` format string.
       *
       * Mutating a passed `Date` after initializing a `Month` object has no effect on
       * the `Month` object.
       * @config {Date|String}
       */
      date: {
        $config: {
          equal: 'date'
        },
        value: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].clearTime(new Date())
      },
      month: null,
      year: null,

      /**
       * The week start day, 0 meaning Sunday, 6 meaning Saturday.
       * Defaults to {@link Core.helper.DateHelper#property-weekStartDay-static}.
       * @config {Number}
       */
      weekStartDay: null,

      /**
       * Configure as `true` to have the visibleDayColumnIndex and visibleColumnCount properties
       * respect the configured {@link #config-nonWorkingDays}.
       * @config {Boolean}
       */
      hideNonWorkingDays: null,

      /**
       * Non-working days as an object where keys are day indices, 0-6 (Sunday-Saturday), and the value is `true`.
       * Defaults to {@link Core.helper.DateHelper#property-nonWorkingDays-static}.
       * @config {Object}
       */
      nonWorkingDays: null,

      /**
       * Configure as `true` to always have the month encapsulate six weeks.
       * This is useful for UIs which must be a fixed height.
       * @config {Boolean}
       */
      sixWeeks: null
    };
  } //region events

  /**
   * Fired when setting the {@link #config-date} property causes the encapsulated date to change
   * in **any** way, date, week, month or year.
   * @event dateChange
   * @param {Core.util.Month} source The Month which triggered the event.
   * @param {Date} newDate The new encapsulated date value.
   * @param {Date} oldDate The previous encapsulated date value.
   * @param {Number} changes An object which contains properties which indicate what part of the date changed.
   * @param {Boolean} changes.d True if the date changed in any way.
   * @param {Boolean} changes.w True if the week changed (including same week in a different year).
   * @param {Boolean} changes.m True if the month changed (including same month in a different year).
   * @param {Boolean} changes.y True if the year changed.
   */

  /**
   * Fired when setting the {@link #config-date} property causes a change of week. Note that
   * weeks are calculated in the ISO standard form such that if there are fewer than four
   * days in the first week of a year, then that week is owned by the previous year.
   *
   * The {@link #config-weekStartDay} is honoured when making this calculation and this is a
   * locale-specific value which defaults to the ISO standard of 1 (Monday) in provided European
   * locales and 0 (Sunday) in the provided US English locale.
   * @event weekChange
   * @param {Core.util.Month} source The Month which triggered the event.
   * @param {Date} newDate The new encapsulated date value.
   * @param {Date} oldDate The previous encapsulated date value.
   * @param {Number} changes An object which contains properties which indicate what part of the date changed.
   * @param {Boolean} changes.d True if the date changed in any way.
   * @param {Boolean} changes.w True if the week changed (including same week in a different year).
   * @param {Boolean} changes.m True if the month changed (including same month in a different year).
   * @param {Boolean} changes.y True if the year changed.
   */

  /**
   * Fired when setting the {@link #config-date} property causes a change of month. This
   * will fire when changing to the same month in a different year.
   * @event monthChange
   * @param {Core.util.Month} source The Month which triggered the event.
   * @param {Date} newDate The new encapsulated date value.
   * @param {Date} oldDate The previous encapsulated date value.
   * @param {Number} changes An object which contains properties which indicate what part of the date changed.
   * @param {Boolean} changes.d True if the date changed in any way.
   * @param {Boolean} changes.w True if the week changed (including same week in a different year).
   * @param {Boolean} changes.m True if the month changed (including same month in a different year).
   * @param {Boolean} changes.y True if the year changed.
  */

  /**
   * Fired when setting the {@link #config-date} property causes a change of year.
   * @event yearChange
   * @param {Core.util.Month} source The Month which triggered the event.
   * @param {Date} newDate The new encapsulated date value.
   * @param {Date} oldDate The previous encapsulated date value.
   * @param {Number} changes An object which contains properties which indicate what part of the date changed.
   * @param {Boolean} changes.d True if the date changed in any way.
   * @param {Boolean} changes.w True if the week changed (including same week in a different year).
   * @param {Boolean} changes.m True if the month changed (including same month in a different year).
   * @param {Boolean} changes.y True if the year changed.
   */
  //endRegion

  /**
   * For use when this Month's `weekStartDay` is non-zero.
   *
   * An array to map the days of the week 0-6 of this Calendar to the canonical day numbers
   * used by the Javascript [Date](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) object.
   * @member {Number[]} canonicalDayNumbers
   * @readonly
   */

  /**
   * An array to map a canonical day number to a *visible* column index.
   * For example, if we have `weekStartDay` as Monday which is 1, and non working days as
   * Wednesday, and `hideNonWorkingDays : true`, then the calendar would look like
   *
   *```
   * ┌────┬────┬────┬────┬────┬────┐
   * | Mo | Tu | Th | Fr | Sa | Su |
   * └────┴────┴────┴────┴────┴────┘
   *```
   *
   * So we'd need this array: `[ 5, 0, 1, undefined, 2, 3, 4]`
   * @member {Number[]} visibleDayColumnIndex
   * @readonly
   */

  /**
   * An array to map a canonical day number to a 0-6 column index.
   * For example, if we have `weekStartDay` as Monday which is 1, then the calendar would look like
   *
   *```
   * ┌────┬────┬────┬────┬────┬────┬────┐
   * | Mo | Tu | We | Th | Fr | Sa | Su |
   * └────┴────┴────┴────┴────┴────┴────┘
   *```
   *
   * So we'd need this array: `[ 6, 0, 1, 2, 3, 4, 5]`
   * @member {Number[]} dayColumnIndex
   * @readonly
   */

  /**
   * The number of visible days in the week as defined by the `nonWorkingDays` and
   * `hideNonWorkingDays` options.
   * @member {Number} weekLength
   * @readonly
   */


  configure(config) {
    super.configure(config);
    this.updateDayNumbers(); // The set is rejected during configuration because everything else has to be set up.

    if (config.date) {
      this.date = config.date;
    }
  }

  changeDate(date) {
    // Date has to be set after we know everything else
    if (this.isConfiguring) {
      return;
    }

    date = typeof date === 'string' ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].parse(date, 'YYYY-MM-DD') : new Date(date);

    if (isNaN(date)) {
      throw new Error('Month date ingestion must be passed a Date, or a valid YYYY-MM-DD date string');
    }

    return date;
  }

  updateDate(newDate, oldDate) {
    const me = this,
          {
      dayColumnIndex
    } = me,
          monthStart = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getFirstDateOfMonth(newDate),
          monthEnd = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getLastDateOfMonth(monthStart),
          startWeekDay = dayColumnIndex[monthStart.getDay()],
          endWeekDay = dayColumnIndex[monthEnd.getDay()],
          yearChanged = !oldDate || newDate.getFullYear() !== oldDate.getFullYear(),
          // Collect changes as bitwise flags if we have any listeners:
    // 0001 = date has changed.
    // 0010 = week has changed.
    // 0100 = month has changed.
    // 1000 = year has changed.
    // We need this because 10/1/2010 -> 10/1/2011 must fire a dateChange
    // and a monthChange in addition to the yearChange.
    // And 10/1/2010 -> 10/2/2010 must fire a dateChange in addition to the monthChange.
    changes = me.eventListeners && (oldDate ? newDate.getDate() !== oldDate.getDate() | (me.getWeekId(newDate) !== me.getWeekId(oldDate)) << 1 | (newDate.getMonth() !== oldDate.getMonth()) << 2 | yearChanged << 3 : 15); // Keep our properties in sync with reality.
    // Access the private properties directly to avoid recursion.

    me._year = newDate.getFullYear();
    me._month = newDate.getMonth(); // These comments assume ISO standard of Monday as week start day.
    //
    // This is the date of month that is the beginning of the first week row.
    // So this may be -ve. Eg: for Dec 2018, Monday 26th Nov is the first
    // cell on the calendar which is the -4th of December. Note that the 0th
    // of December was 31st of November, so needs -4 to get back to the 26th.

    me.startDayOfMonth = 1 - startWeekDay; // This is the date of month that is the end of the last week row.
    // So this may be > month end. Eg: for Dec 2018, Sunday 6th Jan is the last
    // cell on the calendar which is the 37th of December.

    me.endDayOfMonth = monthEnd.getDate() + (6 - endWeekDay);

    if (me.sixWeeks) {
      me.endDayOfMonth += (6 - me.weekCount) * 7;
    } // Calculate the start point of where we calculate weeks from if we need to.
    // It's either the first "weekStartDay" in this year if this year's
    // first week is last year's, and so should work out as zero,
    // or the "weekStartDay" of the week before, so that dates in the first week
    // the Math.floor(DH.diff(weekBase, date, 'day') / 7) calculates as 1.


    if (!me.weekBase || yearChanged) {
      me.calculateWeekBase();
    }

    if (changes) {
      const event = {
        newDate,
        oldDate,
        changes: {
          d: true,
          w: Boolean(changes & 2),
          m: Boolean(changes & 12),
          y: Boolean(changes & 8)
        }
      }; // If either date, month or year changes, we fire a dateChange

      me.trigger('dateChange', event); // If the week has changed, fire a weekChange

      if (changes & 2) {
        me.trigger('weekChange', event);
      } // If month or year changed, we fire a monthChange


      if (changes & 12) {
        me.trigger('monthChange', event);
      } // If the year has changed, fire a yearChange


      if (changes & 8) {
        me.trigger('yearChange', event);
      }
    }
  }

  calculateWeekBase() {
    const me = this,
          {
      dayColumnIndex
    } = me,
          jan1 = new Date(me.year, 0, 1),
          dec31 = new Date(me.year, 11, 31),
          january = me.month ? me.getOtherMonth(jan1) : me; // First 7 days are in last week of previous year if the year
    // starts after our 4th day of week.

    if (me.dayColumnIndex[jan1.getDay()] > 3) {
      // Week base is calculated from the year start
      me.weekBase = january.startDate;
    } // First 7 days are in week 1 of this year
    else {
      // Week base is the start of week before
      me.weekBase = new Date(me.year, 0, january.startDayOfMonth - 7);
    }

    const dec31Week = Math.floor(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].diff(me.weekBase, dec31, 'day') / 7); // Our year only has a 53rd week if 53rd week ends after our week's 3rd day

    me.has53weeks = dec31Week === 53 && dayColumnIndex[dec31.getDay()] > 2;
  }
  /**
   * Returns the week start date, based on the configured {@link #config-weekStartDay} of the
   * passed week.
   * @param {Number| Number[]} week The week number in the current year, or an array containing
   * `[year, weekOfYear]` for any year.
   *
   * Week numbers greater than the number of weeks in the year just wrap into the following year.
   */


  getWeekStart(week) {
    // Week number n of current year
    if (typeof week === 'number') {
      return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].add(this.weekBase, Math.max(week, 1) * 7, 'day');
    } // Week n of year nnnn


    const me = this,
          [year, weekOfYear] = week; // nnnn is our year, so we know it

    if (year === me.year) {
      return me.getWeekStart(weekOfYear);
    }

    return me.getOtherMonth(new Date(year, 0, 1)).getWeekStart(weekOfYear);
  }

  getOtherMonth(date) {
    const me = this,
          result = me === otherMonth ? new Month(null) : otherMonth;
    result.configure({
      weekBase: null,
      weekStartDay: me.weekStartDay,
      nonWorkingDays: me.nonWorkingDays,
      hideNonWorkingDays: me.hideNonWorkingDays,
      sixWeeks: me.sixWeeks,
      date: new Date(date.getFullYear(), 0, 1) // Make it easy to calculate its own weekBase

    });
    result.date = date; // in this case, the date config ignores changes w/=== getTime so we have to force the update because we
    // also cleared weekBase above

    result.updateDate(result.date, result.date);
    return result;
  }

  changeYear(year) {
    const newDate = new Date(this.date);
    newDate.setFullYear(year); // changeDate rejects non-changes, otherwise a change event will be emitted

    this.date = newDate;
  }

  changeMonth(month) {
    const newDate = new Date(this.date);
    newDate.setMonth(month); // changeDate rejects non-changes, otherwise a change event will be emitted

    this.date = newDate;
  }

  get weekStartDay() {
    // This trick allows our weekStartDay to float w/the locale even if the locale changes
    return typeof this._weekStartDay === 'number' ? this._weekStartDay : _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].weekStartDay;
  }

  updateWeekStartDay() {
    const me = this;
    me.updateDayNumbers();

    if (!me.isConfiguring && me.date) {
      me.weekBase = null; // force a calculateWeekBase

      me.updateDate(me.date, me.date);
    } // else date will be set soon and weekBase is null so calculateWeekBase will be called by updateDate

  }

  get nonWorkingDays() {
    return this._nonWorkingDays || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].nonWorkingDays;
  }

  changeNonWorkingDays(nonWorkingDays) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].assign({}, nonWorkingDays);
  }

  updateNonWorkingDays() {
    this.updateDayNumbers();
  }

  updateHideNonWorkingDays() {
    this.updateDayNumbers();
  }

  updateSixWeeks() {
    if (!this.isConfiguring) {
      this.updateDate(this.date);
    }
  }
  /**
   * The number of days in the calendar for this month. This will always be
   * a multiple of 7, because this represents the number of calendar cells
   * occupied by this month.
   * @property {Number}
   * @readonly
   */


  get dayCount() {
    // So for the example month, Dec 2018 has 42 days, from Mon 26th Nov (-4th Dec) 2018
    // to Sun 6th Jan (37th Dec) 2019
    return this.endDayOfMonth + 1 - this.startDayOfMonth;
  }
  /**
   * The number of weeks in the calendar for this month.
   * @property {Number}
   * @readonly
   */


  get weekCount() {
    return this.dayCount / 7;
  }
  /**
   * The date of the first cell in the calendar view of this month.
   * @property {Date}
   * @readonly
   */


  get startDate() {
    const me = this;

    if (me.year != null && me.month != null && me.startDayOfMonth != null) {
      return new Date(me.year, me.month, me.startDayOfMonth);
    }
  }
  /**
   * The date of the last cell in the calendar view of this month.
   * @property {Date}
   * @readonly
   */


  get endDate() {
    const me = this;

    if (me.year != null && me.month != null && me.startDayOfMonth != null) {
      return new Date(me.year, me.month, me.endDayOfMonth);
    }
  }
  /**
   * Iterates through all calendar cells in this month, calling the passed function for each date.
   * @param {Function} fn The function to call.
   * @param {Date} fn.date The date for the cell.
   */


  eachDay(fn) {
    for (let dayOfMonth = this.startDayOfMonth; dayOfMonth <= this.endDayOfMonth; dayOfMonth++) {
      fn(new Date(this.year, this.month, dayOfMonth));
    }
  }
  /**
   * Iterates through all weeks in this month, calling the passed function
   * for each week.
   * @param {Function} fn The function to call.
   * @param {Number[]} fn.week An array containing `[year, weekNumber]`
   * @param {Date[]} fn.dates The dates for the week.
   */


  eachWeek(fn) {
    const me = this,
          {
      weekCount
    } = me;

    for (let dayOfMonth = me.startDayOfMonth, week = 0; week < weekCount; week++) {
      const weekDates = [],
            weekOfYear = me.getWeekNumber(new Date(me.year, me.month, dayOfMonth));

      for (let day = 0; day < 7; day++, dayOfMonth++) {
        weekDates.push(new Date(me.year, me.month, dayOfMonth));
      }

      fn(weekOfYear, weekDates);
    }
  }
  /**
   * Returns the week of the year for the passed date. This returns an array containing *two* values,
   * the year **and** the week number are returned.
   *
   * The week number is calculated according to ISO rules, meaning that if the first week of the year
   * contains less than four days, it is considered to be the last week of the preceding year.
   *
   * The configured {@link #config-weekStartDay} is honoured in this calculation. So if the weekStartDay
   * is **NOT** the ISO standard of `1`, (Monday), then the weeks do not coincide with ISO weeks.
   * @param {Date} date The date to calculate the week for.
   * @returns {Number[]} A numeric array: `[year, week]`
   */


  getWeekNumber(date) {
    const me = this;
    date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].clearTime(date); // If it's a date in another year, use our otherMonth to find the answer.

    if (date.getFullYear() !== me.year) {
      return me.getOtherMonth(new Date(date.getFullYear(), 0, 1)).getWeekNumber(date);
    }

    let weekNo = Math.floor(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].diff(me.weekBase, date, 'day') / 7),
        year = date.getFullYear(); // No week 0. It's the last week of last year

    if (!weekNo) {
      // Week is the week of last year's 31st Dec
      return me.getOtherMonth(new Date(me.year - 1, 0, 1)).getWeekNumber(new Date(me.year, 0, 0));
    } // Only week 53 if year ends before our week's 5th day
    else if (weekNo === 53 && !me.has53weeks) {
      weekNo = 1;
      year++;
    } // 54 wraps round to 2 of next year
    else if (weekNo > 53) {
      weekNo = weekNo % 52;
    } // Return array of year and week number


    return [year, weekNo];
  }

  getWeekId(date) {
    const week = this.getWeekNumber(date);
    return week[0] * 100 + week[1];
  }

  getCellData(date, ownerMonth, dayTime = _DayTime_js__WEBPACK_IMPORTED_MODULE_1__["default"].MIDNIGHT) {
    const me = this,
          day = date.getDay(),
          visibleColumnIndex = me.visibleDayColumnIndex[day],
          isNonWorking = me.nonWorkingDays[day],
          isHiddenDay = me.hideNonWorkingDays && isNonWorking; // Automatically move to required month

    if (date < me.startDate || date > me.endDate) {
      me.month = date.getMonth();
    }

    return {
      day,
      dayTime,
      visibleColumnIndex,
      isNonWorking,
      week: me.getOtherMonth(date).getWeekNumber(date),
      key: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].format(date, 'YYYY-MM-DD'),
      columnIndex: me.dayColumnIndex[day],
      date: new Date(date),
      // These two properties are only significant when used by a CalendarPanel which encapsulates
      // a single month.
      isOtherMonth: Math.sign(date.getMonth() + date.getFullYear() * 12 - (ownerMonth.month + ownerMonth.year * 12)),
      visible: !isHiddenDay && date >= ownerMonth.startDate && date < _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].add(ownerMonth.endDate, 1, 'day'),
      tomorrow: dayTime.dayOfDate(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].add(date, 1, 'day')),
      isRowStart: visibleColumnIndex === 0,
      isRowEnd: visibleColumnIndex === me.visibleColumnCount - 1
    };
  }

  updateDayNumbers() {
    const me = this,
          {
      weekStartDay,
      nonWorkingDays,
      hideNonWorkingDays
    } = me,
          dayColumnIndex = me.dayColumnIndex = [],
          canonicalDayNumbers = me.canonicalDayNumbers = [],
          visibleDayColumnIndex = me.visibleDayColumnIndex = []; // So, if they set weekStartDay to 1 meaning Monday which is ISO standard, we will
    // have mapping of internal day number to canonical day number (as used by Date class)
    // and to abbreviated day name like this:
    // canonicalDayNumbers = [1, 2, 3, 4, 5, 6, 0] // Use for translation from our day number to Date class's day number
    //
    // Also, we need a map from canonical day number to *visible* cell index.
    // for example, if we have weekStartDay as Monday which is 1, and non working days as
    // Wednesday, and hideNonWorkingDays:true, then the calendar would look like
    // +----+----+----+----+----+----+
    // | Mo | Tu | Th | Fr | Sa | Su |
    // +----+----+----+----+----+----+
    //
    // So we'd need this array
    // [ 5, 0, 1, undefined, 2, 3, 4]
    // Or think of it as this map:
    // {
    //      1 : 0,
    //      2 : 1,
    //      4 : 2,
    //      5 : 3,
    //      6 : 4,
    //      0 : 5
    // }
    // To be able to ascertain the cell index directly from the canonical day number.
    //
    // We also need a logical column map which would be
    // +----+----+----+----+----+----+----+
    // | Mo | Tu | We | Th | Fr | Sa | Su |
    // +----+----+----+----+----+----+----+
    //
    // So we'd need this array
    // [ 6, 0, 1, 2, 3, 4, 5]
    // Or think of it as this map:
    // {
    //      1 : 0,
    //      2 : 1,
    //      3 : 2
    //      4 : 3,
    //      5 : 4,
    //      6 : 5,
    //      0 : 6
    // }
    // We use this to cache the number of visible columns so that cell renderers can tell whether
    // they are on the last visible column.

    let visibleColumnIndex = 0;

    for (let columnIndex = 0; columnIndex < 7; columnIndex++) {
      const canonicalDay = (weekStartDay + columnIndex) % 7;
      canonicalDayNumbers[columnIndex] = canonicalDay;
      dayColumnIndex[canonicalDay] = columnIndex; // If this day is going to have visible representation, we need to
      // map it to a columnIndex;

      if (!hideNonWorkingDays || !nonWorkingDays[canonicalDay]) {
        visibleDayColumnIndex[canonicalDay] = visibleColumnIndex++;
      }
    }

    me.visibleColumnCount = visibleColumnIndex;
    me.weekLength = hideNonWorkingDays ? 7 - _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].keys(nonWorkingDays).length : 7;
  }

} // Instance needed for internal tasks

const otherMonth = new Month(null);
Month._$name = 'Month';

/***/ }),

/***/ "./lib/Core/util/Parser.js":
/*!*********************************!*\
  !*** ./lib/Core/util/Parser.js ***!
  \*********************************/
/*! exports provided: memo, memoCps, success, failure, isSuccess, resolveParser, succeed, string, bind, seq, alt, regexp, red, runParser, defineParser, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "memo", function() { return memo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "memoCps", function() { return memoCps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "success", function() { return success; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "failure", function() { return failure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSuccess", function() { return isSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolveParser", function() { return resolveParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "succeed", function() { return succeed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "string", function() { return string; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return bind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "seq", function() { return seq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alt", function() { return alt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "regexp", function() { return regexp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runParser", function() { return runParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineParser", function() { return defineParser; });
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';
 // The code is based on https://epsil.github.io/gll/ article (MIT license).

/**
 * @module Core/util/Parser
 */
// Tools. Maybe move it to memoization module.

let nextObjectIdentity = 0;
const objectIdentityMap = new WeakMap();

const argsToCacheKey = (...args) => args.map(arg => {
  let result;

  if (arg && typeof arg == 'object' || typeof arg == 'function') {
    result = objectIdentityMap.get(arg);

    if (result === undefined) {
      result = ++nextObjectIdentity;
      objectIdentityMap.set(arg, result);
    }
  } else {
    result = String(arg);
  }

  return result;
}).join('-');
/**
 * Generic memoization function. Wraps `fn` into higher order function which caches `fn` result
 * using stringified arguments as the cache key.
 *
 * @param {Function} fn function to memoize
 */


const memo = fn => {
  const mlist = new Map();
  return (...args) => {
    const mkey = argsToCacheKey(args);
    let result = mlist.get(mkey);

    if (result === undefined) {
      result = fn(...args);
      mlist.set(mkey, result);
    }

    return result;
  };
};
/**
 * Specific memoization function caches `fn` calls. `fn` should receive 2 arguments, the first one
 * is a string, and the second one is a callback which should be called by `fn` with some result.
 * The function returned wraps `fn` and it's callback such that `fn` would be called only once
 * with a particular first argument, other time callback will be called instantly with the result cached.
 *
 * @param {Function} fn function to memoize
 */

const memoCps = fn => {
  const table = new Map(),
        entryContinuations = entry => entry[0],
        entryResults = entry => entry[1],
        pushContinuation = (entry, cont) => entryContinuations(entry).push(cont),
        pushResult = (entry, result) => entryResults(entry).push(result),
        isResultSubsumed = (entry, result) => entryResults(entry).some(r => _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isEqual(r, result)),
        makeEntry = () => [[], []],
        isEmptyEntry = entry => !entryResults(entry).length && !entryContinuations(entry).length,
        tableRef = str => {
    let entry = table.get(str);

    if (entry === undefined) {
      entry = makeEntry();
      table.set(str, entry);
    }

    return entry;
  };

  return (str, cont) => {
    const entry = tableRef(str);

    if (isEmptyEntry(entry)) {
      pushContinuation(entry, cont);
      fn(str, result => {
        if (!isResultSubsumed(entry, result)) {
          pushResult(entry, result);
          entryContinuations(entry).forEach(cont => cont(result));
        }
      });
    } else {
      pushContinuation(entry, cont);
      entryResults(entry).forEach(result => cont(result));
    }
  };
}; // End of tools

const SUCCESS = Symbol('success');
const FAILURE = Symbol('failure');
/**
 * Successful parsing result. Represented as array with 3 items:
 * - SUCCESS symbol which can be checked with {@link #function-isSuccess} function.
 * - Parsed payload
 * - Rest string left to parse
 *
 * @typedef {Array} SuccessResult
 */

/**
 * Creates successful parsing result with parsed `val` and unparsed `rest`
 *
 * @param {String} val Parsed value
 * @param {String} rest Unparsed rest
 * @return {SuccessResult}
 */

const success = (val, rest) => [SUCCESS, val, rest];
/**
 * Failure parsing result. Represented as array with 2 items:
 * - FAILURE symbol which can be checked with {@link #function-isSuccess} function
 * - Rest string left to parse
 *
 * @typedef {Array} FailureResult
 */

/**
 * Creates failed parsing result with unparsed `rest`
 *
 * @param {String} rest Unparsed rest
 * @return {FailureResult}
 */

const failure = rest => [FAILURE, rest];
/**
 * Checks if the given parsing `result` is successful
 *
 * @param {SuccessfulResult|FailureResult} result
 */

const isSuccess = result => result.length && result[0] === SUCCESS;
/**
 * Resolves parser when needed. Parser should be resolved if it's defined as a function
 * with no arguments which returns the actual parser function with more then one argument.
 *
 * @param {Function} p Parser factory
 * @return {Function} Combinable parser function
 */

const resolveParser = p => typeof p === 'function' && !p.length ? p() : p;
/**
 * Returns combinable parser which always return successful parsing result with `val`
 * as parsed result and string parsed as `rest`.
 *
 * @param {*} val Successful parsing result parsed payload
 * @return {Function} Combinable parser function
 *
 * @example
 * const sp = succeed('Ok');
 * sp('My string', (r) => console.dir(r)) // Will output successful parsing result with `Ok` payload and `My string` rest.
 */

const succeed = memo(val => memoCps((str, cont) => cont(success(val, str))));
/**
 * Returns combinable parser which succeeds if string parsed starts with `match`. The parsing
 * result will contain `match` as parsed result and rest of the string characters,
 * the ones after `match` as the unparsed rest.
 *
 * @param {String} match String to match
 * @return {Function} Combinable parser function
 *
 * @example
 * const mp = string('My');
 * mp('My string', (r) => console.dir(r)); // Will output successful parsing result with `My` payload and `string` rest.
 */

const string = memo(match => memoCps((str, cont) => {
  const len = Math.min(match.length, str.length),
        head = str.substr(0, len),
        tail = str.substr(len);
  cont(head === match ? success(head, tail) : failure(tail));
}));
/**
 * Binds parser or parser factory with a `fn` function which should receive one string argument
 * and return a combinable parser function.
 *
 * @param {Function} p Combinable parser function or combinable parser factory which can be
 *                     resolved using with {@link #function-resolveParser}.
 * @param {Function} fn A function receiving one string argument and returning combinable parser function.
 *
 * @internal
 */

const bind = (p, fn) => (str, cont) => resolveParser(p)(str, result => {
  if (isSuccess(result)) {
    const [, val, rest] = result;
    fn(val)(rest, cont);
  } else {
    cont(result);
  }
});
/**
 * Combines several combined parser functions or combinable parser factories in sequence such that second starts after first succeeds
 * third after second etc, if first fails then second will not be called and so on.
 *
 * @param {...Function} parsers Combinable parser function or combinable parser factory which can be
 *                      resolved using with {@link #function-resolveParser}.
 * @returns {Function} Combinable parser function
 *
 * @example
 * const ab = seq(string('a'), string('b'));
 * ab('abc', (r) => console.dir(r)); // Will output successful parsing result with `ab` as parsed payload and `c` as the rest.
 */

const seq = memo((...parsers) => {
  const seq2 = memo((a, b) => memoCps(bind(a, x => bind(b, y => succeed([].concat(x, y))))));
  return parsers.reduce(seq2, succeed([]));
});
/**
 * Combines several combined parser functions or combinable parser factories in alteration such that successful parsing result will be passed into
 * a callback if one of those parsers succeeds.
 *
 * @param {...Function} parsers Combinable parser function or combinable parser factory which can be
 *                      resolved using with {@link #function-resolveParser}.
 * @returns {Function} Combinable parser function
 *
 * @example
 * const aorb = alt(string('a'), string('b'));
 * aorb('abc', (r) => console.dir(r)); // Will output successful parsing result with `a` as parsed payload and `bc` as the rest.
 * aorb('bbc', (r) => console.dir(r)); // Will output successfull parsing result with `b` as parsed payload and `bc` as the rest.
 */

const alt = memo((...parsers) => memoCps((str, cont) => parsers.forEach(p => resolveParser(p)(str, cont))));
/**
 * Creates combinable parser which succeeds if string to parse starts from a substring which succeeds for the regular expression
 * `pattern` the parser is created with.
 *
 * @param {String} pattern Regular expression pattern
 * @return {Function} Combinable parser function
 *
 * @example
 * const rp = regexp('a+');
 * rp('aaabb', (r) => console.dir(r)); // Will output successful parsing result with `aaa` as parsed payload and `bb` as the rest.
 */

const regexp = memo(pattern => (str, cont) => {
  const rexp = new RegExp(`^${pattern}`),
        match = rexp.exec(str);

  if (match) {
    const head = match[0],
          tail = str.substr(head.length);
    cont(success(head, tail));
  } else {
    cont(failure(str));
  }
});
/**
 * Creates reducing combinable parser function which should be used to create semantic actions
 * on parsed results.
 *
 * @param {Function} p Combinable parser function or combinable parser factory which can be
 *                     resolved using with {@link #function-resolveParser}.
 * @param {Function} fn Semantic action function should be the same arity as the successful result arity
 *                      of `p` parser.
 * @return {Function} Combinable parser function
 *
 * @example
 * const nump = red(
 *     regexp('\d'),
 *     Number
 * );
 *
 * const plusp = string('+');
 *
 * const sump = red(
 *     seq(nump, plusp, nump),
 *     (a, _, b) => a + b
 * );
 *
 * sump('7+8', (r) => console.dir(r)); // Will return successful parsing result with `15` as parsing payload and `` as rest.
 */

const red = memo((p, fn) => bind(p, (...val) => succeed(fn(...[].concat.apply([], val)))));
/**
 * Runs combinable parsing function returning totally parsed results only, i.e. such results which have
 * parsed the `str` string completely.
 *
 * @param {Function} body Combinable parser function
 * @param {String} str String to parse
 * @return {SuccessfulResult[]} All totally parsed results possible for the given parsing function.
 */

const runParser = (body, str) => {
  const results = [];
  body(str, result => {
    if (isSuccess(result)) {
      const [,, left] = result;

      if (left === '') {
        results.push(result);
      }
    }
  });
  return results;
};
/**
 * Helper function for combinable parser definition supplements combinable parser function
 * returning a higher order function which when called with 2 arguments (string to parse and
 * a callback function) behaves exactly like parser function, but when called with 1 argument
 * it wraps call to parser function with {@link function-runParser} thus returning array of
 * totally parsed results.
 *
 * @param {Function} body Combinable parser function
 */

const defineParser = body => (str, cont) => cont ? resolveParser(body)(str, cont) : runParser(resolveParser(body), str); //Combines exports in an object such that it was possible to export parser utilities
// in UMD/module bundles.

/* harmony default export */ __webpack_exports__["default"] = ({
  memo,
  memoCps,
  success,
  failure,
  isSuccess,
  resolveParser,
  succeed,
  string,
  bind,
  seq,
  alt,
  regexp,
  red,
  runParser,
  defineParser
});

/***/ }),

/***/ "./lib/Core/util/ScrollManager.js":
/*!****************************************!*\
  !*** ./lib/Core/util/ScrollManager.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScrollManager; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'taskboard';





/**
 * @module Core/util/ScrollManager
 */

/**
 * Monitors the mouse position over an element and scrolls the element if the cursor is close to edges. This is used by
 * various features to scroll the grid section element, for example dragging elements close to edges.
 *
 * ```javascript
 * // Instantiate manager for the container element having overflowing content
 * const manager = new ScrollManager({ element : document.querySelector('.container') });
 *
 * // Start monitoring. When pointer approaches 50px region within monitored element edge, scrolling begins
 * manager.startMonitoring();
 *
 * // Stop monitoring.
 * manager.stopMonitoring();
 * ```
 */

class ScrollManager extends Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  //region Default config
  static get configurable() {
    return {
      /**
       * Default element to use for scrolling. Can be overridden in calls to `startMonitoring()`.
       * @config {HTMLElement}
       */
      element: null,

      /**
       * Width in pixels of the area at the edges of an element where scrolling should be triggered
       * @config {Number}
       * @default
       */
      zoneWidth: 50,

      /**
       * Scroll speed, higher number is slower. Calculated as "distance from zone edge / scrollSpeed"
       * @config {Number}
       * @default
       */
      scrollSpeed: 5,

      /**
       * The direction(s) to scroll ('horizontal', 'vertical' or 'both')
       * @config {String}
       */
      direction: 'both',

      /**
       * Number of milliseconds to wait before scroll starts when the mouse is moved close to an edge monitored by this scroll manager
       * @config {Number}
       * @default
       */
      startScrollDelay: 500,

      /**
       * Set to true to stop scrolling when pointing device leaves the scrollable element.
       * @config {Boolean}
       * @default
       */
      // https://github.com/bryntum/support/issues/394
      stopScrollWhenPointerOut: false,
      testConfig: {
        scrollSpeed: 2,
        startScrollDelay: 0
      },
      activeScroll: {
        $config: ['lazy'],
        value: {}
      },
      monitoring: {
        $config: ['lazy', 'nullify'],
        value: true
      }
    };
  }

  changeMonitoring(value, was) {
    was === null || was === void 0 ? void 0 : was.clear();
    return new Map();
  } //endregion


  doDestroy() {
    this.stopMonitoring();
    super.doDestroy();
  }
  /**
   * Returns true if some of the monitored elements is being scrolled at the moment.
   * @property {Boolean}
   * @readonly
   */


  get isScrolling() {
    return Object.keys(this.activeScroll).length !== 0;
  } //region Start/stop monitoring

  /**
   * Starts monitoring an element. It will be scrolled if mouse is pressed and within `zoneWidth` pixels from element
   * edge. Supports monitoring multiple elements using `scrollables` option:
   *
   * ```javascript
   * new ScrollManager({ element : '.item' }).startMonitoring({
   *     scrollables : [
   *         {
   *             // Applies config to all elements matching `.item .child-item`
   *             // selector
   *             element : '.child-item',
   *             // Only manage vertical scroll
   *             direction : 'vertical',
   *             // Specific callback for this scrollable. Shared callback is
   *             // ignored.
   *             callback : () => console.log('Specific callback')
   *         },
   *         {
   *             // Instance can be used
   *             element : document.querySelector('.item .child2')
   *             // Direction and callback are not provided, so element will
   *             // be scrollable in horizontal direction and will use shared
   *             // callback
   *         }
   *     ],
   *     direction : 'horizontal',
   *     callback  : () => console.log('Shared callback')
   * })
   * ```
   *
   * @param {Object} config Element which might be scrolled or config { element, callback, thisObj }
   * @param {HTMLElement|String} [config.element] Element or selector. Overrides default element. **Deprecated**: use
   * `scrollables` instead
   * @param {String} [config.direction] Direction to scroll. Overrides default scroll direction
   * @param {Function} [config.callback] Callback to execute on every scroll of the target element.
   *
   * ```javascript
   * startMonitoring({
   *     callback(monitor) {
   *         // Current left and top scroll of the monitored element
   *         console.log(monitor.scrollLeft)
   *         console.log(monitor.scrollTop)
   *         // Scroll position relative to the initial position
   *         console.log(monitor.relativeScrollLeft)
   *         console.log(monitor.relativeScrollTop)
   *     }
   * })
   * ```
   *
   * @param {Object} [config.thisObj] Scope for the callback.
   * @param {Object[]} [config.scrollables] Array of configs if multiple elements should be monitored.
   * @param {HTMLElement|String} [config.scrollables.0.element] Element or selector.
   * @param {String} [config.scrollables.0.direction] Direction to scroll. Overrides upper config object direction.
   * @param {Function} [config.scrollables.0.callback] Callback to execute on every scroll of the target element.
   * Overrides upper config object callback.
   * @returns {Function} Returns function to cleanup instantiated monitors
   * ```javascript
   * const detacher = new ScrollManager({ element }).startMonitoring({ ... });
   * detacher(); // All monitors setup by the previous call are removed
   * ```
   */


  startMonitoring(config = {}) {
    const me = this,
          {
      element,
      direction: defaultDirection
    } = me,
          {
      scrollables = [],
      direction = defaultDirection,
      callback
    } = config,
          attachedElements = [];

    if (config.element) {
      _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].deprecate('core', '5.0.0', '`element` config is deprecated, please use `scrollables` instead.');
      scrollables.push({
        element: config.element
      });
    }

    if (!scrollables.length) {
      scrollables.push({
        element
      });
    }

    scrollables.forEach(scrollable => {
      const target = scrollable.element;

      if (typeof target === 'string') {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEachSelector(element, target, element => {
          me.createMonitor(element, scrollable.direction || direction, scrollable.callback || callback);
          attachedElements.push(element);
        });
      } else {
        me.createMonitor(target, scrollable.direction || direction, scrollable.callback || callback);
        attachedElements.push(target);
      }
    });
    return function detacher() {
      var _me$stopMonitoring;

      // May have been destroyed when DragContext cleaner is called.
      (_me$stopMonitoring = me.stopMonitoring) === null || _me$stopMonitoring === void 0 ? void 0 : _me$stopMonitoring.call(me, attachedElements);
    };
  }

  createMonitor(element, direction, callback) {
    const {
      monitoring
    } = this;

    if (!monitoring.has(element)) {
      monitoring.set(element, new ScrollManagerMonitor({
        scrollManager: this,
        element,
        direction,
        callback
      }));
    }
  }
  /**
   * Stops monitoring an element. If no particular element is given, stop monitoring everything.
   * @param {HTMLElement|HTMLElement[]} [element] Element or array of elements for which monitoring is not desired any
   * more and should stop as soon as possible.
   */


  stopMonitoring(element) {
    const me = this,
          {
      monitoring
    } = me;

    if (element && !Array.isArray(element)) {
      element = [element];
    }

    if (monitoring) {
      // Stop all if no element given
      if (!element) {
        monitoring.forEach(monitor => me.stopMonitoring(monitor.element));
        return;
      }

      element.forEach(element => {
        const monitor = monitoring.get(element); // cant stop nothing...

        if (monitor) {
          monitor.destroy();
          monitoring.delete(element);
        }
      });
    }
  } //endregion

  /*
   * Attempts to reserve given scrolling direction for the given monitor.
   * @param {String} direction 'horizontal' or 'vertical'
   * @param {Object} monitor
   * @returns {Boolean} Returns true in case scroll direction was reserved for given monitor. False otherwise.
   * @private
   */


  requestScroll(direction, monitor) {
    const {
      activeScroll
    } = this;

    if (direction in activeScroll && activeScroll[direction] !== monitor) {
      return false;
    } else {
      activeScroll[direction] = monitor;
      return true;
    }
  }
  /*
   * Releases all scroll directions, blocked by given monitor
   * @param {Object} monitor
   * @private
   */


  releaseScroll(monitor) {
    const {
      activeScroll = {}
    } = this;
    Object.keys(activeScroll).forEach(key => {
      if (activeScroll[key] === monitor) {
        delete activeScroll[key];
      }
    });
  } //#region Scroll position


  getRelativeScroll(element, direction = 'left') {
    let result = 0;
    this.monitoring.forEach((monitor, monitoredElement) => {
      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isDescendant(monitoredElement, element)) {
        result += direction === 'left' ? monitor.scrollRelativeLeft : monitor.scrollRelativeTop;
      }
    });
    return result;
  } //#endregion


}

class ScrollManagerMonitor extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  construct(config) {
    const me = this,
          {
      element
    } = config,
          startScrollLeft = element.scrollLeft,
          startScrollTop = element.scrollTop;
    Object.assign(config, {
      startScrollLeft,
      startScrollTop
    });
    super.construct(config); // listen to mousemove to determine if scroll needed or not

    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element,
      scroll: 'onElementScroll',
      mousemove: 'onMouseMove',
      touchmove: 'onMouseMove',
      // Capture pointermove events early to start scrolling from top elements
      capture: true,
      thisObj: me
    }); // `pointerleave` should have `capture: false`, otherwise it works much like `pointerout`

    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element,
      pointerleave: 'onPointerLeave',
      thisObj: me
    });
  }

  doDestroy() {
    this.stopScroll();
    super.doDestroy();
  }
  /**
   * Starts scrolling (see #performScroll). Called from onMouseMove.
   * @private
   */


  startScroll() {
    this.scrolling = true;
    this.performScroll();
  }
  /**
   * Stops scrolling. Called from onMouseMove.
   * @private
   */


  stopScroll() {
    const me = this;
    me.scrolling = false;

    if (me.scrollRequested) {
      me.scrollManager.cancelAnimationFrame(me.frameId);
      me.scrollRequested = false;
    }

    me.scrollManager.clearTimeout(me.scrollTimeout);
    me.scrollManager.releaseScroll(me);
    me.scrollTimeout = null;
  }

  onPointerLeave() {
    this.scrollManager.stopScrollWhenPointerOut && this.stopScroll();
  }
  /**
   * Listener for mouse move on monitored element. Determines if scrolling is needed, and if so how fast to scroll.
   * See #zoneWidth & #scrollSpeed configs.
   * @private
   * @param {MouseEvent} event
   */


  onMouseMove(event) {
    const me = this,
          {
      scrollManager
    } = me,
          box = me.element.getBoundingClientRect(),
          width = scrollManager.zoneWidth,
          speed = scrollManager.scrollSpeed; // scroll left, right, up or down?

    me.scrollDeltaX = me.scrollDeltaY = 0;

    if (me.direction !== 'vertical') {
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = me.element; // Only start scrolling if it is possible

      if (event.clientX > box.right - width && scrollWidth - scrollLeft - clientWidth >= 1) {
        me.scrollDeltaX = Math.round((width - (box.right - event.clientX)) / speed) + 1;
      } else if (event.clientX < box.left + width && scrollLeft > 0) {
        me.scrollDeltaX = -Math.round((width + (box.left - event.clientX)) / speed) - 1;
      }
    }

    if (me.direction !== 'horizontal') {
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = me.element; // Only start scrolling if it is possible

      if (event.clientY > box.bottom - width && scrollHeight - scrollTop - clientHeight >= 1) {
        me.scrollDeltaY = Math.round((width - (box.bottom - event.clientY)) / speed) + 1;
      } else if (event.clientY < box.top + width && scrollTop > 0) {
        me.scrollDeltaY = -Math.round((width + (box.top - event.clientY)) / speed) - 1;
      }
    }

    if (me.scrollDeltaX !== 0 && !scrollManager.requestScroll('horizontal', me)) {
      me.scrollDeltaX = 0;
    }

    if (me.scrollDeltaY !== 0 && !scrollManager.requestScroll('vertical', me)) {
      me.scrollDeltaY = 0;
    }

    if (me.scrollDeltaX === 0 && me.scrollDeltaY === 0) {
      me.stopScroll();
    } else if (!me.scrollTimeout) {
      me.scrollTimeout = scrollManager.setTimeout(() => me.startScroll(), scrollManager.startScrollDelay);
    }
  }
  /**
   * Scrolls by an amount determined by config.scrollDeltaX/Y on each frame. Start/stop by calling #startScroll and
   * #stopScroll.
   * @private
   */


  performScroll() {
    const me = this,
          {
      element
    } = me; // this function is called repeatedly on each frame for as long as scrolling is needed
    // check that scrolling is needed

    if (me.scrolling && !me.scrollRequested) {
      // Scroll the determined amount of pixels if possible
      if (me.scrollDeltaX !== 0) {
        const oldScrollLeft = element.scrollLeft,
              newScrollLeft = Math.min(oldScrollLeft + me.scrollDeltaX, element.scrollWidth - element.clientWidth);

        if (newScrollLeft !== oldScrollLeft) {
          element.scrollLeft = newScrollLeft;
        }
      }

      if (me.scrollDeltaY !== 0) {
        const oldScrollTop = element.scrollTop,
              newScrollTop = Math.min(oldScrollTop + me.scrollDeltaY, element.scrollHeight - element.clientHeight);

        if (newScrollTop !== oldScrollTop) {
          element.scrollTop = newScrollTop;
        }
      } // scroll some more on next frame


      me.scrollRequested = true;
      me.frameId = me.scrollManager.requestAnimationFrame(() => {
        me.scrollRequested = false;
        me.performScroll(me);
      });
    }
  }

  onElementScroll() {
    var _this$config, _this$config$callback;

    (_this$config = this.config) === null || _this$config === void 0 ? void 0 : (_this$config$callback = _this$config.callback) === null || _this$config$callback === void 0 ? void 0 : _this$config$callback.call(this.thisObj || this.scrollManager, this);
  }

  get scrollLeft() {
    return this.element.scrollLeft;
  }

  get scrollTop() {
    return this.verticalElement ? this.verticalElement.scrollTop : this.element.scrollTop;
  }

  get scrollRelativeLeft() {
    return this.scrollLeft - this.startScrollLeft;
  }

  get scrollRelativeTop() {
    return this.scrollTop - this.startScrollTop;
  } // There could be several scrollables controlling different axes. If we want to calculate combined scroll from all
  // those monitors (e.g. for the case when we drag scheduler event in both directions), we should ask scroll manager
  // to iterate over monitored elements and aggregate scroll.


  getRelativeLeftScroll(element) {
    return this.scrollManager.getRelativeScroll(element, 'left');
  }

  getRelativeTopScroll(element) {
    return this.scrollManager.getRelativeScroll(element, 'top');
  }

}

ScrollManager._$name = 'ScrollManager';

/***/ }),

/***/ "./lib/Core/util/drag/DragContext.js":
/*!*******************************************!*\
  !*** ./lib/Core/util/drag/DragContext.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragContext; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _mixin_Finalizable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixin/Finalizable.js */ "./lib/Core/mixin/Finalizable.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony import */ var _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
var productName = 'taskboard';








/**
 * @module Core/util/drag/DragContext
 */

const ABORTED = Symbol('dragAbort'),
      // Drag has been aborted
INIT = Symbol('dragInit'),
      // Button is down but insufficient movement to start the drag
DRAGGING = Symbol('dragDrag'),
      // Button is down and movement has started a drag
DROPPED = Symbol('dragDrop'),
      // Button has been released and drop has occurred
lockDirections = {
  x: 'horizontal',
  y: 'vertical'
};
/**
 * This class is created during drag operations of {@link Core/mixin/Draggable}. It holds the state of an ongoing drag
 * operation.
 * @extends Core/Base
 * @internal
 */

class DragContext extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Finalizable_js__WEBPACK_IMPORTED_MODULE_4__["default"], _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_3__["default"], _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {
  static get configurable() {
    return {
      /**
       * The element that will have the {@link Core.mixin.Draggable#property-draggingItemCls}. This element is
       * determined by the {@link Core.mixin.Draggable#config-dragItemSelector}.
       * @config {HTMLElement}
       */
      itemElement: null,

      /**
       * The `ScrollManager` instance to use for scrolling while dragging.
       * @config {Core.util.ScrollManager}
       * @private
       */
      scrollManager: null,

      /**
       * Config for `startMonitoring` call.
       * @config {Object}
       * @private
       */
      monitoringConfig: null,

      /**
       * The source of the drag operation.
       * @config {Core.mixin.Draggable}
       * @default
       * @readonly
       */
      source: null,

      /**
       * The current target of the drag.
       * @member {Core.mixin.Droppable}
       * @readonly
       */
      target: null,

      /**
       * The current target element of the drag.
       * @member {HTMLElement}
       * @private
       */
      targetElement: null,

      /**
       * The minimum distance from the touchstart/mousedown/pointerdown that must be moved to actually start a
       * drag operation.
       * @config {Number}
       * @default
       * @readonly
       */
      threshold: 5,

      /**
       * The minimum amount of time a touch must be maintained before it will initiate a drag. Movement prior to
       * this time will cancel the drag in order to allow touch scrolling.
       * @config {Number}
       * @default
       */
      touchStartDelay: 300
    };
  }

  static get identifiable() {
    return {};
  }
  /**
   * The current DOM event being processed.
   * @member {Event} event
   * @readonly
   */


  construct(...args) {
    super.construct(...args);
    const me = this,
          {
      event
    } = me;
    Object.assign(me, {
      /**
       * This property holds the `altKey` state of the most recent event.
       * @member {Boolean}
       */
      altKey: null,

      /**
       * An array of functions to call when cleaning up the context instance.
       * @member {Function[]}
       * @private
       */
      cleaners: [],

      /**
       * This property holds the `ctrlKey` state of the most recent event.
       * @member {Boolean}
       */
      ctrlKey: null,

      /**
       * Container for data associated with the drag. Data items are added by the {@link Core.mixin.Draggable}
       * when the drag starts.
       * @member {Map}
       * @private
       */
      data: new Map(),

      /**
       * The element from which the drag operation started.
       * @member {HTMLElement}
       * @readonly
       */
      element: event.target,

      /**
       * The event that completed the drag (a `mouseup`, `pointerup` or `touchend`).
       * @member {Event}
       * @readonly
       */
      endEvent: null,

      /**
       * The most recent `mousemove`, `pointermove` or `touchmove` event.
       * @member {Event}
       * @private
       */
      lastMoveEvent: null,

      /**
       * This property holds the `metaKey` state of the most recent event.
       * @member {Boolean}
       */
      metaKey: null,

      /**
       * The previous {@link #property-target} of the drag.
       * @member {Core.mixin.Droppable}
       * @readonly
       */
      previousTarget: null,

      /**
       * The scroll actions reported by the {@link #config-scrollManager}.
       * @member {Object}
       * @private
       */
      scrollerAction: null,

      /**
       * This property holds the `shiftKey` state of the most recent event.
       * @member {Boolean}
       */
      shiftKey: null,

      /**
       * This property holds the current state of the drag process.
       *
       * This will be one of the following values:
       *
       *  - `DragContext.STATE.INIT` - The button is down but there is insufficient movement to start the drag.
       *  - `DragContext.STATE.DRAGGING` - The button is down and movement has started the drag.
       *  - `DragContext.STATE.DROPPED` - The button has been released and drop has occurred.
       *  - `DragContext.STATE.ABORTED` - The drag has been aborted (this happens if the user presses the `ESC`
       *    key or if the {@link #function-abort} method is called).
       *
       * @member {Symbol}
       * @readonly
       * @internal
       */
      state: INIT,

      /**
       * The event that started the drag operation.
       * @member {Event}
       * @readonly
       */
      startEvent: event,

      /**
       * The timer that fires when a touch pointermove is allowed to start the drag. A touch pointermove event
       * prior to this will `abort()` the drag to allow touch scrolling.
       * @member {Number}
       * @private
       */
      touchStartTimer: null,

      /**
       * Stores the value from writes to the {@link #property-valid} property.
       * @member {Boolean}
       * @private
       */
      _valid: true
    });

    if ('touches' in event && me.touchStartDelay) {
      me.touchStartTimer = me.setTimeout(() => me.touchStartTimer = null, me.touchStartDelay, 'touchStartDelay');
    }

    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: window,
      blur: 'onWindowBlur',
      thisObj: me
    });
  }

  doDestroy() {
    const me = this,
          {
      source,
      target
    } = me;
    me.cleanup();

    if ((target === null || target === void 0 ? void 0 : target.dropping) === me) {
      target.dropping = null;
    }

    if ((source === null || source === void 0 ? void 0 : source.dragging) === me) {
      source.dragging = null;
    }

    super.doDestroy();
  }

  onWindowBlur() {
    if (this.started) {
      this.abort();
    }
  }
  /**
   * This property is `true` if the {@link #function-abort} method was called and `false` otherwise. This
   * is typically because the user pressed the ESC key, however, a drag can be aborted for other reasons.
   * @property {Boolean}
   * @readonly
   */


  get aborted() {
    return this.state === ABORTED;
  }
  /**
   * Returns `true` if the drag has completed either by mouse/pointerup or the {@link #function-abort} method.
   * @property {Boolean}
   * @readonly
   */


  get completed() {
    return this.isDestroying || this.aborted || this.endEvent !== null;
  }
  /**
   * This property is `true` if the drag {@link #config-threshold} has not yet been reached.
   * @property {Boolean}
   * @readonly
   */


  get pending() {
    return this.state === INIT;
  }
  /**
   * This property is `true` if the drag {@link #config-threshold} has been reached and the drag operation is active.
   * @property {Boolean}
   * @readonly
   */


  get started() {
    return this.state !== INIT && !this.aborted;
  }
  /**
   * This property is `true` when the drag is in a valid drop state. This can be set to `false` to indicate the drop
   * is invalid. Setting to `true` does not ensure that the property will be `true` when next read due to other factors
   * that are required to make the drop valid. For example, setting `valid = true` will still return `false` if called
   * before the drag {@link #config-threshold} has not been reached or if the {@link #function-abort} method has been
   * called.
   * @property {Boolean}
   */


  get valid() {
    return this.started && this.targetElement != null && this._valid;
  }

  set valid(v) {
    this._valid = v;
  } //region Data Access

  /**
   * Retrieves a data item from the drag source. This method can only be called after the drag has completed.
   * @param {String|String[]} name The name of the data item.
   * @returns {*}
   * @async
   */


  async get(name) {
    if (this.aborted) {
      throw new Error('Data is not available on aborted drag');
    }

    if (!this.completed) {
      throw new Error('Data is not available until drag completion');
    }

    if (Array.isArray(name)) {
      return Promise.all(name.map(s => this.get(s)));
    }

    let value = this.data.get(name);

    if (typeof value === 'function') {
      value = await value();
      this.data.set(name, value);
    }

    return value;
  }
  /**
   * Returns `true` if the named data item is present.
   * @param {String} name The name of the data item.
   * @returns {Boolean}
   */


  has(name) {
    return this.data.has(name);
  }
  /**
   * Retrieves a data item from the drag source if it is available. This will return `true` for an item that was
   * {@link #function-set} using a renderer function.
   * @param {String|String[]} name The name of the data item.
   * @returns {*}
   */


  peek(name) {
    if (this.aborted) {
      throw new Error('Data is not available on aborted drag');
    }

    if (Array.isArray(name)) {
      return name.map(s => this.peek(s));
    }

    let value = this.data.get(name);

    if (typeof value === 'function') {
      value = true;
    }

    return value;
  }
  /**
   * Sets a data item for the drag. If a function is passed, it is called to render the data only if that data is
   * actually requested via the {@link #function-get} method. A data renderer function can be `async`.
   * @param {String} name The name of the data item.
   * @param {*} value The value of the data item.
   */


  set(name, value) {
    this.data.set(name, value);
  } //endregion
  //region Configs


  changeTarget(target, was) {
    if (target !== was) {
      const me = this;
      me._target = target;
      me.previousTarget = was;

      if (was) {
        was.dropping = null;
      }

      if (target) {
        target.dropping = me; // calls dragEnter/Leave on the target

        if (target.dropping !== me) {
          // if (target did not accept us)
          target = null;
          me.valid = false;
        }
      }

      me._target = was;
    }

    return target;
  }

  updateTarget(target, was) {
    const me = this;

    if (was) {
      me.source.dragLeaveTarget(me, was);
    }

    if (target) {
      me.valid = true; // Always give the target an initial dragMove since feedback/indicators will need to update on move and
      // the lack of a move on entry will just make that a special case.

      target.dragMove(me);
      me.source.dragEnterTarget(me);
    }
  }

  updateTargetElement(targetElement) {
    let droppable, droppables, droppableSelector, i, t; // We interrogate all encapsulating DOM elements to see if we are in a Droppable's element.
    // If we find an element which has Droppables registered for it, we attempt to set each as
    // our target, and go with the first one that accepts us.
    // changeTarget sets target.dropping to this Context, and the target's dragEnter implementation
    // may reject it by returning false.

    for (t = targetElement; t; t = t.parentElement) {
      droppables = _data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_6__["default"].get(t, 'droppables');

      if (droppables) {
        for (i = 0; i < droppables.length; ++i) {
          droppable = droppables[i]; // If the event target is *inside* the Droppable's root, we can ask the Droppable
          // to accept this DragContext.
          // Otherwise we can get a hit on borders.

          if (droppable.dropRootElement.contains(targetElement)) {
            droppableSelector = droppable.droppableSelector; // If the target element is not inside the Droppable's selector, give up.

            if (!droppableSelector || targetElement.closest(`#${_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getId(droppable.dropRootElement)} ${droppableSelector}`)) {
              this.target = droppable; // The found Droppable accepted this DragContext, so we're done -
              // we are using this Droppable.

              if (this.target === droppable) {
                return;
              }
            }
          }
        }
      }
    }
  } //endregion
  //region Operations

  /**
   * Aborts the drag. After calling this method, {@link #property-aborted} will be `true`, {@link #property-valid}
   * will be `false` and {@link #property-completed} will be `true`.
   */


  abort() {
    const me = this,
          {
      element,
      source
    } = me; // Force a synchronous layout so that transitions from this point will work.

    element === null || element === void 0 ? void 0 : element.getBoundingClientRect();

    if (me.state !== DROPPED) {
      me.state = ABORTED;
      me.cleanup();
    }

    source === null || source === void 0 ? void 0 : source.endDrag(me);
  }

  begin() {
    const me = this,
          {
      source
    } = me,
          ret = source.beforeDrag(me);

    if (ret !== false) {
      source.dragging = me;
    }

    return ret;
  }

  cleanup() {
    let cleaner;

    while (cleaner = this.cleaners.pop()) {
      cleaner();
    }
  }

  end(event) {
    const me = this,
          {
      lastMoveEvent: lastEvent,
      target
    } = me,
          {
      dragSwallowClickTime
    } = me.source;
    me.event = me.endEvent = event;
    me.syncFlags();

    if (me.started) {
      if ((lastEvent === null || lastEvent === void 0 ? void 0 : lastEvent.clientX) !== event.clientX || (lastEvent === null || lastEvent === void 0 ? void 0 : lastEvent.clientY) !== event.clientY || (lastEvent === null || lastEvent === void 0 ? void 0 : lastEvent.target) !== event.target) {
        // Make sure the drop event is preceded by a move to the final position...
        me.track();
      }

      if (dragSwallowClickTime) {
        // Prevent the impending document click from the mouseup event from propagating
        // into a click on our element.
        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
          element: document,
          capture: true,
          expires: dragSwallowClickTime,
          // In case a click did not ensue, remove the listener
          once: true,

          click(event) {
            event.stopPropagation();
          }

        });
      }

      me.state = DROPPED;

      if (target !== me.source) {
        // If we are the target and not also the source, we need to call dragDrop() now. If we are
        // the source, dragDrop() will be called by Draggable.
        target === null || target === void 0 ? void 0 : target.dragDrop(me);
      }
    }
  }

  fakeKey(event, down) {
    const me = this,
          {
      lastMoveEvent
    } = me;

    if (lastMoveEvent && me.element) {
      let changed; // Indicate that this is a 'fake' mousemove event as a result of the keydown

      lastMoveEvent.isKey = true;

      if (event.key === 'Alt') {
        if (me.altKey !== down) {
          me.altKey = down;
          changed = true;
        }
      } else if (event.key === 'Control') {
        if (me.ctrlKey !== down) {
          me.ctrlKey = down;
          changed = true;
        }
      }

      if (changed) {
        me.event = lastMoveEvent;
        me.track();
      }
    }
  }

  keyDown(event) {
    if (!this.completed) {
      if (event.key === 'Escape') {
        this.abort();
      } else if (this.isDragToggleKey(event.key)) {
        this.fakeKey(event, true);
      }
    }
  }

  keyUp(event) {
    if (!this.completed && this.isDragToggleKey(event.key)) {
      this.fakeKey(event, false);
    }
  }

  getDistance(event) {
    return _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getDistanceBetween(this.startEvent, event);
  }

  isDragToggleKey(key) {
    return key === 'Control' || key === 'Alt';
  }

  move(event) {
    const me = this,
          {
      target
    } = event,
          distance = me.getDistance(event),
          significant = distance >= me.threshold;
    me.syncFlags();

    if (me.touchStartTimer) {
      if (significant) {
        me.abort();
      }

      return;
    }

    if (target && target.nodeType === Node.ELEMENT_NODE) {
      if (significant && !me.started) {
        me.event = event; // triggers beforeDragStart, dragStart. returning false from beforeDragStart aborts drag

        if (me.start() === false) {
          me.abort();
          return;
        }
      }

      if (me.started) {
        me.lastMoveEvent = me.event = event; // to prevent view drag (scroll) on ipad

        if (event.type === 'touchmove') {
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        me.track();
      }
    }
  }

  start() {
    const me = this,
          {
      scrollManager,
      monitoringConfig,
      source
    } = me,
          {
      draggingBodyCls: activeCls,
      dragLock
    } = source,
          element =
    /* source.dragWithin || */
    source.dragRootElement;
    me.state = DRAGGING; // Now that the drag drop is confirmed to be starting, activate the configured scrollManager if present

    if (scrollManager) {
      const detacher = scrollManager.startMonitoring(_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__["default"].merge({
        scrollables: [{
          element
        }],
        direction: lockDirections[dragLock] || dragLock || 'both',

        callback(scrollerAction) {
          const {
            lastMoveEvent
          } = me;

          if (lastMoveEvent && me.element) {
            // Indicate that this is a 'fake' mousemove event as a result of the scrolling
            lastMoveEvent.isScroll = true;
            me.event = lastMoveEvent;
            me.scrollerAction = scrollerAction;
            me.track();
            me.scrollerAction = null;
          }
        }

      }, monitoringConfig));
      me.cleaners.push(detacher);
    } // Global informational class for when DragHelper is dragging


    const rootEl = source.dragRootElement.closest('.b-outer') || document.body;
    rootEl.classList.add(activeCls);
    me.cleaners.push(() => rootEl.classList.remove(activeCls));

    if (source.startDrag(me) === false) {
      me.cleanup();
      return false;
    }
  }

  syncFlags() {
    const me = this,
          {
      event
    } = me;
    me.altKey = event.altKey;
    me.ctrlKey = event.ctrlKey;
    me.metaKey = event.metaKey;
    me.shiftKey = event.shiftKey;
  }

  track() {
    const me = this,
          {
      event,
      source,
      target
    } = me;
    let targetElement = event.target,
        touch; // NOTE: we cannot syncFlags here since we are called to pass along keydown events as movement updates
    // "pointer-events:none" touchmove has no effect for the touchmove event target, meaning we cannot know
    // what's under the cursor as easily in touch devices

    if (event.type === 'touchmove') {
      touch = event.changedTouches[0]; // From MDN:
      //  * clientX/Y - the coordinates of the touch point relative to the left/top edge of the browser viewport,
      //    not including any scroll offset.
      //  * The elementFromPoint() method returns the topmost Element at the specified coordinates (relative to
      //    the viewport).

      targetElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].elementFromPoint(touch.clientX, touch.clientY);
    }

    me.targetElement = targetElement; // when we change elements, update me.target

    if (target === me.target) {
      // if we have a target and that did not change due to setting targetElement, we need to inform the target
      // of the drag move
      target === null || target === void 0 ? void 0 : target.dragMove(me);
    }

    source.trackDrag(me);
  } //endregion


}
DragContext.prototype.STATE = DragContext.STATE = Object.freeze({
  ABORTED,
  INIT,
  DRAGGING,
  DROPPED
});
DragContext._$name = 'DragContext';

/***/ }),

/***/ "./lib/Core/util/drag/DragProxy.js":
/*!*****************************************!*\
  !*** ./lib/Core/util/drag/DragProxy.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragProxy; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
var productName = 'taskboard';


/**
 * @module Core/util/drag/DragProxy
 */

/**
 * Drag proxies are helper classes that represent the object being dragged in some visual way. This is an abstract
 * base with which particular drag proxy classes (such as, {@link Core.util.drag.DragTipProxy} are registered.
 *
 * Derived classes the various template methods of this class to manage their particular form of visual feedback.
 * @extends Core/Base
 * @internal
 */

class DragProxy extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get type() {
    return 'default';
  }

  static get configurable() {
    return {
      /**
       * The currently active `DragContext`. This context will be active prior to be passed to the proxy. This
       * config is set by {@link #function-dragStart} and cleared by {@link #function-dragEnd}.
       * @config {Core.util.drag.DragContext}
       */
      dragging: null
    };
  }

  static get factoryable() {
    return {
      defaultType: DragProxy
    };
  }
  /**
   * The `Draggable` instance that owns this drag proxy.
   * @member {Core.mixin.Draggable} owner
   * @readonly
   */
  //region Configs


  updateDragging(drag, was) {
    if (was) {
      this.close(was);
    }

    if (drag) {
      this.open(drag);
    }
  } //endregion
  //region Operations

  /**
   * This template method is called when {@link #config-dragging} is reset to `null`.
   * @param {Core.util.drag.DragContext} drag The drag instance.
   */


  close(drag) {// template
  }
  /**
   * This template method is called when {@link #config-dragging} is set to a non-`null` value.
   * @param {Core.util.drag.DragContext} drag The drag instance.
   */


  open(drag) {// template
  } //endregion
  //region Drag Processing

  /**
   * This template method is called by the `Draggable` instance when the drag officially starts.
   * This sets the {@link #config-dragging} config to `drag`, which triggers the call to {@link #function-open}.
   * @param {Core.util.drag.DragContext} drag The drag instance.
   */


  dragStart(drag) {
    this.dragging = drag;
  }
  /**
   * This template method is called by the `Draggable` instance as drag movement occurs.
   * @param {Core.util.drag.DragContext} drag The drag instance.
   */


  dragMove(drag) {// template
  }
  /**
   * This template method is called by the `Draggable` instance when the drag completes.
   *
   * This sets the {@link #config-dragging} config to `null`, which triggers the call to {@link #function-close}.
   * @param {Core.util.drag.DragContext} drag The drag instance.
   */


  dragEnd(drag) {
    this.dragging = null;
  } //endregion


}
DragProxy.initClass();
DragProxy._$name = 'DragProxy';

/***/ }),

/***/ "./lib/Core/util/drag/DragTipProxy.js":
/*!********************************************!*\
  !*** ./lib/Core/util/drag/DragTipProxy.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DragTipProxy; });
/* harmony import */ var _DragProxy_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DragProxy.js */ "./lib/Core/util/drag/DragProxy.js");
/* harmony import */ var _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
var productName = 'taskboard';




/**
 * @module Core/util/drag/DragTipProxy
 */

/**
 * This drag proxy manages a {@link #config-tooltip} (or derived class) and aligns the tooltip to the current drag
 * position adjusted by the {@link #config-align} config.
 * @extends Core/util/drag/DragProxy
 * @classtype tip
 * @internal
 */

class DragTipProxy extends _DragProxy_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get type() {
    return 'tip';
  }

  static get configurable() {
    return {
      /**
       * Controls how the tooltip will be aligned to the current drag position.
       *
       * See {@link Core.helper.util.Rectangle#function-alignTo} for details.
       * @config {String}
       * @default
       */
      align: 't10-b50',

      /**
       * The number of pixels to offset from the drag position.
       * @config {Number}
       * @default
       */
      offset: 20,

      /**
       * The tooltip to be shown, hidden and repositioned to track the drag position.
       * @config {Core.widget.Tooltip}
       */
      tooltip: {
        $config: ['lazy', 'nullify'],
        value: {
          type: 'tooltip'
        }
      }
    };
  }

  open() {
    this.getConfig('tooltip'); // trigger creation
  }

  close() {
    var _this$tooltip;

    (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 ? void 0 : _this$tooltip.hide();
  }

  dragMove(drag) {
    const {
      offset,
      tooltip
    } = this,
          {
      event
    } = drag;

    if (tooltip) {
      if (!tooltip.isVisible) {
        tooltip.show();
      }

      tooltip.alignTo({
        align: this.align,
        target: new _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_2__["default"](event.clientX - offset, event.clientY - offset, offset * 2, offset * 2)
      });
    }
  }

  changeTooltip(config, existing) {
    return _widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].reconfigure(existing, config,
    /* owner = */
    this);
  }

}
DragTipProxy.initClass();
DragTipProxy._$name = 'DragTipProxy';

/***/ }),

/***/ "./lib/Core/widget/BooleanCombo.js":
/*!*****************************************!*\
  !*** ./lib/Core/widget/BooleanCombo.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BooleanCombo; });
/* harmony import */ var _Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/Store.js */ "./lib/Core/data/Store.js");
var productName = 'taskboard';


/**
 * @module Core/widget/BooleanCombo
 * Boolean combo, a combo box with two options corresponding to true or false.
 *
 * This field can be used as an {@link Grid/column/Column#config-editor} for the {@link Grid/column/Column}.
 *
 * @classType booleancombo
 * @extends Core/widget/Combo
 */

class BooleanCombo extends _Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'BooleanCombo';
  }

  static get type() {
    return 'booleancombo';
  } //region Config


  static get configurable() {
    return {
      /**
       * Positive option value
       *
       * @config {*}
       */
      positiveValue: true,

      /**
       * Positive option display value
       *
       * @config {String}
       */
      positiveText: null,

      /**
       * Negative option value
       *
       * @config {*}
       */
      negativeValue: false,

      /**
       * False option display value
       *
       * @config {String}
       */
      negativeText: null,
      store: {
        value: [],
        $config: 'lazy'
      },

      /**
       * Default value
       *
       * @config {*}
       */
      value: false
    };
  } //endregion


  changeStore(store, oldStore) {
    const me = this; // We must call super.changeStore() in order to deduce valueField. We also cannot just pass an array since it
    // will convert to a store and call back here (infinite recursion).

    return super.changeStore(new _data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
      data: [{
        id: me.positiveValue,
        text: me.positiveText || me.L('L{Object.Yes}')
      }, {
        id: me.negativeValue,
        text: me.negativeText || me.L('L{Object.No}')
      }]
    }), oldStore);
  }

} // Register this widget type with its Factory

BooleanCombo.initClass();
BooleanCombo._$name = 'BooleanCombo';

/***/ }),

/***/ "./lib/Core/widget/Button.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Button.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Button; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _mixin_Badge_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/Badge.js */ "./lib/Core/widget/mixin/Badge.js");
/* harmony import */ var _mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/Rotatable.js */ "./lib/Core/widget/mixin/Rotatable.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';






 //TODO: should togglebutton be own class implemented as input type=checkbox?
//TODO: A toggling widget's focusElement should be an opacity:0 input type=checkbox which covers the clickable area.

/**
 * @module Core/widget/Button
 */

const bIcon = /(?:^|\s)b-icon-/,
      bFa = /(?:^|\s)b-fa-/,
      defaultToggleable = Symbol('defaultToggleable'),
      fullConfigKeys = ['items', 'type', 'widgets', 'html', 'listeners'];
/**
 * Button widget, wraps and styles a regular <code>&lt;button&gt;</code> element. Can display text and icon and also
 * allows specifying button {@link #config-color}. Supports different appearances, by setting {@link #config-cls} to one
 * of:
 *
 * * 'b-raised' - Raised buttons
 * * 'b-rounded' - Round buttons
 * * 'b-transparent' - Buttons without border or background
 *
 * ## Default appearance
 *
 * By default buttons uses a flat look in all themes:
 *
 * {@inlineexample Core/widget/ButtonDefault.js}
 *
 * ```javascript
 * // Green button with text and icon
 * const button = new Button({
 *     appendTo : document.body,
 *     icon    : 'b-fa-plus-circle',
 *     text    : 'Add',
 *     color   : 'green',
 *     onClick : () => {}
 * });
 * ```
 *
 * ## Raised appearance
 *
 * By configuring a button with `cls : 'b-raised'` its appearance change. In Material the button appears raised, in the
 * other themes it is instead filled:
 *
 * {@inlineexample Core/widget/ButtonRaised.js}
 *
 * ```javascript
 * // Raised green button with text and icon
 * const button = new Button({
 *     appendTo : document.body,
 *     cls     : 'b-raised',
 *     icon    : 'b-fa-plus-circle',
 *     text    : 'Add',
 *     color   : 'green',
 *     onClick : () => {}
 * });
 * ```
 *
 * ## Rounded appearance
 *
 * Configure a button with `cls : 'b-rounded'` to make it round. Works best for icon only buttons or buttons with very
 * short texts:
 *
 * {@inlineexample Core/widget/ButtonRounded.js}
 *
 * ```javascript
 * // Rounded button with icon
 * const button = new Button({
 *     appendTo : document.body,
 *     cls     : 'b-raised b-rounded',
 *     icon    : 'b-fa-plus-circle',
 *     color   : 'green',
 *     onClick : () => {}
 * });
 * ```
 *
 * ## Transparent appearance
 *
 * Configure a button with `cls : 'b-transparent'` to display it without border or background:
 *
 * {@inlineexample Core/widget/ButtonTransparent.js}
 * ```javascript
 * // Transparent green button with text and icon
 * const button = new Button({
 *     appendTo : document.body,
 *     cls     : 'b-transparent',
 *     icon    : 'b-fa-plus-circle',
 *     text    : 'Add',
 *     color   : 'green',
 *     onClick : () => {}
 * });
 * ```
 *
 * ## Button with menu
 *
 * Buttons can also have a menu that is shown on click:
 *
 * {@inlineexample Core/widget/ButtonWithMenu.js}
 *
 * ```javascript
 * // Transparent green button with text and icon
 * const button = new Button({
 *     appendTo : document.body,
 *     icon    : 'b-fa-chart',
 *     menu    : {
 *         items : [
 *             {
 *                 text : 'Click me',
 *                 onItem : () => console.log('I was clicked')
 *             }
 *         ]
 *     }
 * });
 * ```
 * @classType button
 * @extends Core/widget/Widget
 * @mixes Core/widget/mixin/Badge
 */

class Button extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_1__["default"], _mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  //region Config
  static get $name() {
    return 'Button';
  } // Factoryable type name


  static get type() {
    return 'button';
  }

  static get configurable() {
    return {
      /**
       * Get/set the Button icon
       * @member {String} icon
       */

      /**
       * Button icon class.
       *
       * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
       *
       * Otherwise this is a developer-defined CSS class string which results in the desired icon.
       * @config {String}
       */
      icon: null,

      /**
       * The menu icon class to show when the button has a menu. Set to `null` to not show a menu icon.
       *
       * @config {String}
       * @deprecated 4.3.0 Use {@link #config-menuIcon} instead.
       * @default
       */
      menuIconCls: null,

      /**
       * The menu icon class to show when the button has a menu. Set to `null` to not show a menu icon.
       *
       * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
       *
       * @config {String}
       * @default
       */
      menuIcon: 'b-icon-picker',

      /**
       * Get/set the Button pressed icon
       * @member {String} pressedIcon
       */

      /**
       * Icon class for the buttons pressed state. Only applies to toggle buttons
       *
       * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
       *
       * Otherwise this is a developer-defined CSS class string which results in the desired icon.
       *
       * ```
       * new Button({
       *    // Icon for unpressed button
       *    icon        : 'b-fa-wine-glass',
       *
       *    // Icon for pressed button
       *    pressedIcon : 'b-fa-wine-glass-alt',
       *
       *    // Only applies to toggle buttons
       *    toggleable  : true
       * });
       * ```
       *
       * @config {String}
       */
      pressedIcon: null,

      /**
       * Get/Set the Button icon alignment.
       * May be `'start'` or `'end'`. Defaults to `'start'`
       * @member {String} iconAlign
       */

      /**
       * Button icon alignment. May be `'start'` or `'end'`. Defaults to `'start'`
       * @config {String}
       */
      iconAlign: 'start',

      /**
       * Get/set text displayed on the button.
       * @member {String} text
       */

      /**
       * The button's text.
       * @config {String}
       */
      text: {
        value: null,
        $config: null,
        default: ''
      },

      /**
       * Button color (should have match in button.scss or your custom styling). Valid values in Bryntum themes
       * are:
       * * b-amber
       * * b-blue
       * * b-dark-gray
       * * b-deep-orange
       * * b-gray
       * * b-green
       * * b-indigo
       * * b-lime
       * * b-light-gray
       * * b-light-green
       * * b-orange
       * * b-purple
       * * b-red
       * * b-teal
       * * b-white
       * * b-yellow
       * Combine with specifying `b-raised` for raised/filled style (theme dependent).
       *
       * ```
       * new Button({
       *    color : 'b-teal b-raised'
       * });
       * ```
       *
       * @config {String}
       */
      color: null,

      /**
       * Enabled toggling of the button (stays pressed when pressed).
       * @config {Boolean}
       * @default false
       */
      toggleable: defaultToggleable,

      /**
       * Get/set button pressed state
       * @member {Boolean} pressed
       */

      /**
       * Initially pressed or not. Only applies with `toggleable = true`.
       * ```
       * const toggleButton = new Button({
       *    toggleable : true,
       *    text : 'Enable cool action'
       * });
       * ```
       * @config {Boolean}
       * @default
       */
      pressed: false,

      /**
       * Indicates that this button is part of a group where only one button can be pressed. Assigning a value
       * also sets `toggleable` to `true`.
       *
       * When part of a {@link Core.widget.ButtonGroup}, you can set {@link Core.widget.ButtonGroup#config-toggleGroup}
       * on it as an alternative to on each button. This config can then be used to override that value if needed.
       *
       * ```javascript
       * const yesButton = new Button({
       *    toggleGroup : 'yesno',
       *    text        : 'Yes'
       * });
       *
       * const noButton = new Button({
       *    toggleGroup : 'yesno',
       *    text        : 'No'
       * });
       * ```
       * @config {String}
       */
      toggleGroup: null,
      ripple: {
        radius: 75
      },
      localizableProperties: ['text'],

      /**
       * Returns the instantiated menu widget as configured by {@link #config-menu}.
       * @member {Core.widget.Widget} menu
       */

      /**
       * A submenu configuration object, or an array of MenuItem configuration
       * objects from which to create a submenu which is shown when this button is pressed.
       *
       * Note that this does not have to be a Menu. The `type` config can be used
       * to specify any widget as the submenu.
       *
       * May also be specified as a fully instantiated {@link Core.widget.Widget#config-floating floating Widget}
       * such as a {@link Core/widget/Popup}.
       * @config {Object|Object[]|Core.widget.Widget}
       */
      menu: {
        $config: ['lazy', 'nullify'],
        value: null
      },
      menuDefaults: {
        type: 'menu',
        autoShow: false,
        autoClose: true,
        floating: true,
        scrollAction: 'realign',
        align: 't0-b0'
      },

      /**
       * If provided, turns the button into a link
       * @config {String}
       */
      href: null,

      /**
       * The `target` attribute for the {@link #config-href} config
       * @config {String}
       */
      target: null
    };
  }

  compose() {
    const {
      color,
      href,
      icon,
      iconAlign,
      pressed,
      pressedIcon,
      target,
      text,
      toggleable,
      toggleGroup,
      menuIcon
    } = this,
          hasMenu = this.hasConfig('menu'),
          iconCls = pressed && pressedIcon ? pressedIcon : icon;
    return {
      tag: href ? 'a' : 'button',
      href,
      target,
      class: {
        [`b-icon-align-${iconAlign}`]: icon,
        [color]: Boolean(color),
        'b-pressed': pressed && toggleable,
        'b-text': Boolean(text),
        'b-has-menu': hasMenu
      },
      dataset: {
        group: toggleGroup
      },
      listeners: {
        click: 'onInternalClick'
      },
      children: {
        iconElement: (icon || pressedIcon) && {
          tag: 'i',
          class: _objectSpread(_objectSpread({}, _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].normalize(iconCls, 'object')), {}, {
            'b-icon': bIcon.test(iconCls),
            'b-fa': bFa.test(iconCls)
          })
        },
        label: text && {
          tag: 'label',
          text
        },
        menuIconElement: hasMenu && menuIcon && {
          tag: 'i',
          class: {
            'b-icon': bIcon.test(menuIcon),
            'b-fa': bFa.test(menuIcon),
            'b-button-menu-icon': 1,
            [menuIcon]: 1
          }
        }
      }
    };
  } //endregion


  onHide() {
    var _this$_menu;

    // Stop a menu from being visually orphaned if this button is hidden while its menu is visible
    (_this$_menu = this._menu) === null || _this$_menu === void 0 ? void 0 : _this$_menu.hide();
  }
  /**
   * Iterate over all widgets owned by this widget and any descendants.
   *
   * *Note*: Due to this method aborting when the function returns `false`, beware of using short form arrow
   * functions. If the expression executed evaluates to `false`, iteration will terminate.
   *
   * _Due to the {@link #config-menu} config being a lazy config and only being converted to be a
   * `Menu` instance just before it's shown, the menu will not be part of the iteration before
   * it has been shown once_.
   * @function eachWidget
   * @param {Function} fn A function to execute upon all descendant widgets.
   * Iteration terminates if this function returns `false`.
   * @param {Boolean} [deep=true] Pass as `false` to only consider immediate child widgets.
   * @returns {Boolean} Returns `true` if iteration was not aborted by a step returning `false`
   */


  get childItems() {
    return this._menu && [this.menu];
  }

  onFocusOut(e) {
    var _this$menu;

    super.onFocusOut(e);
    (_this$menu = this.menu) === null || _this$menu === void 0 ? void 0 : _this$menu.hide();
  } //region Getters/Setters


  get focusElement() {
    return this.element;
  }

  changeText(text) {
    return text == null ? '' : text;
  }

  changeToggleable(toggleable) {
    if (toggleable === defaultToggleable) {
      return this.toggleGroup || this.config.menu;
    }

    return toggleable;
  }

  changeMenu(menu, oldMenu) {
    const me = this,
          {
      element: forElement
    } = me;

    if (menu) {
      if (menu.isWidget) {
        menu.forElement = forElement;
        menu.owner = me;
      } else {
        // This covers both Array and Object which are valid items config formats.
        // menu could be { itemRef : { text : 'sub item 1 } }. But if it has
        // child items or html property in it, it's the main config
        if (typeof menu === 'object' && !fullConfigKeys.some(key => key in menu)) {
          menu = {
            lazyItems: menu
          };
        }

        menu = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].reconfigure(oldMenu, menu ? _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].merge({
          owner: me,
          constrainTo: me.rootElement,
          forElement
        }, me.menuDefaults, menu) : null, me);
      } // We must react to its state change to hidden by becoming unpressed.
      // If we just hid it in the toggle method, this will be a no-op.


      menu.on('hide', () => {
        var _me$toggle;

        return (_me$toggle = me.toggle) === null || _me$toggle === void 0 ? void 0 : _me$toggle.call(me, false);
      });
    } else {
      oldMenu === null || oldMenu === void 0 ? void 0 : oldMenu.destroy();
    }

    return menu;
  }

  updateMenu(menu) {
    // We are toggleable if there's a menu.
    // Pressed means menu visible, not pressed means menu hidden.
    this.toggleable = Boolean(menu);
  }

  updatePressed(pressed) {
    const me = this;

    if (!me.isConfiguring && pressed && me.toggleGroup) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].forEachSelector(me.rootElement, `button[data-group=${me.toggleGroup}]`, btnEl => {
        if (btnEl !== me.element) {
          _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].getById(btnEl.id).toggle(false);
        }
      });
    }
  }

  updateMenuIconCls(cls) {
    _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].deprecate('Core', '5.0.0', 'Deprecated in favor of `menuIcon`');
    this.menuIcon = cls;
  } //endregion
  //region Events

  /**
   * Triggers events when user clicks button
   * @fires click
   * @fires action
   * @internal
   */


  onInternalClick(event) {
    const me = this,
          bryntumEvent = {
      event
    };

    if (me.toggleable) {
      // Clicking the pressed button in a toggle group should do nothing
      if (me.toggleGroup && me.pressed) {
        return;
      }

      me.toggle(!me.pressed); // Edge case in dragfromgrid demo, where toggling mode destroys the Scheduler and thus destroys the toolbar
      // and the button in it

      if (me.isDestroyed) {
        return;
      }
    }
    /**
     * Fires when the button is clicked
     * @event click
     * @param {Core.widget.Button} source The button
     * @param {Event} event DOM event
     */


    me.trigger('click', bryntumEvent);
    /**
     * Fires when the default action is performed (the button is clicked)
     * @event action
     * @param {Core.widget.Button} source The button
     * @param {Event} event DOM event
     */
    // A handler may have resulted in destruction.

    if (!me.isDestroyed) {
      me.trigger('action', bryntumEvent);
    } // since Widget has Events mixed in configured with 'callOnFunctions' this will also call onClick and onAction


    if (!me.href) {
      // stop the event since it has been handled
      event.preventDefault();
      event.stopPropagation();
    }
  } //endregion
  //region Misc

  /**
   * Toggle button state (only use with toggleable = true)
   * @param {Boolean} pressed Specify to force a certain toggle state
   * @fires toggle
   */


  toggle(pressed = null) {
    const me = this,
          {
      menu
    } = me;

    if (!me.toggleable) {
      return;
    }

    if (pressed === null) {
      pressed = !me.pressed;
    } // The pressed state is not going to be changed, ignore toggling


    if (me.pressed === pressed) {
      return;
    } // For handlers from the code below to detect and avoid recursion


    me.toggling = true;
    me.pressed = pressed;

    if (menu) {
      var _menu$_minHeight, _menu$_minWidth;

      if (!menu.initialConfig.minWidth) {
        menu.minWidth = me.width;
      } // Menu will shrink and fit inside a 10px inset of viewport.
      // Rectangle.alignTo prioritizes alignment if the target edge is closer to
      // the constrainTo edge than this in order to produce visually correct results.


      menu.align.constrainTo = window;
      menu.align.constrainPadding = 10; // The presence of a number indicates to the align constraining algorithm
      // that it is *willing* to shrink in that dimension. It will never end up this small.
      // Use the properties because the getter will return 0 if not set.

      menu.align.minHeight = (_menu$_minHeight = menu._minHeight) !== null && _menu$_minHeight !== void 0 ? _menu$_minHeight : 100;
      menu.align.minWidth = (_menu$_minWidth = menu._minWidth) !== null && _menu$_minWidth !== void 0 ? _menu$_minWidth : 100;
      menu[pressed ? 'show' : 'hide']();
    }
    /**
     * Fires when the button is toggled (the {@link #property-pressed} state is changed). If the button is part of a
     * {@link #config-toggleGroup} and you need to process the pressed button only, consider using
     * {@link #event-click} event or {@link #event-action} event.
     * @event toggle
     * @param {Core.widget.Button} source Toggled button
     * @param {Boolean} pressed New pressed state
     * @param {Event} event DOM event
     */


    me.trigger('toggle', {
      pressed
    });
    me.toggling = false;
  } //endregion


} // Register this widget type with its Factory

Button.initClass();
Button._$name = 'Button';

/***/ }),

/***/ "./lib/Core/widget/ButtonGroup.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/ButtonGroup.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ButtonGroup; });
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/Rotatable.js */ "./lib/Core/widget/mixin/Rotatable.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");
var productName = 'taskboard';



/**
 * @module Core/widget/ButtonGroup
 */

/**
 * A specialized container that holds buttons, displaying them in a horizontal group with borders adjusted to make them
 * stick together.
 *
 * Trying to add other widgets than buttons will throw an exception.
 *
 * ```javascript
 * new ButtonGroup({
 *     items : [
 *         { icon : 'b-fa b-fa-kiwi-bird' },
 *         { icon : 'b-fa b-fa-kiwi-otter' },
 *         { icon : 'b-fa b-fa-kiwi-rabbit' },
 *         ...
 *     ]
 * });
 * ```
 *
 * @inlineexample Core/widget/ButtonGroup.js
 * @classType buttonGroup
 * @extends Core/widget/Container
 */

class ButtonGroup extends _Container_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  /**
   * Fires when a button in the group is clicked
   * @event click
   * @param {Core.widget.Button} source Clicked button
   * @param {Event} event DOM event
   */

  /**
   * Fires when the default action is performed on a button in the group (the button is clicked)
   * @event action
   * @param {Core.widget.Button} source Clicked button
   * @param {Event} event DOM event
   */

  /**
   * Fires when a button in the group is toggled (the {@link Core.widget.Button#property-pressed} state is changed).
   * If you need to process the pressed button only, consider using {@link #event-click} event or {@link #event-action} event.
   * @event toggle
   * @param {Core.widget.Button} source Toggled button
   * @param {Boolean} pressed New pressed state
   * @param {Event} event DOM event
   */
  static get $name() {
    return 'ButtonGroup';
  } // Factoryable type name


  static get type() {
    return 'buttongroup';
  }

  static get configurable() {
    return {
      defaultType: 'button',

      /**
       * Custom CSS class to add to element. When using raised buttons (cls 'b-raised' on the buttons), the group
       * will look nicer if you also set that cls on the group.
       *
       * ```
       * new ButtonGroup({
       *   cls : 'b-raised,
       *   items : [
       *       { icon : 'b-fa b-fa-unicorn', cls : 'b-raised' },
       *       ...
       *   ]
       * });
       * ```
       *
       * @config {String}
       * @category CSS
       */
      cls: null,

      /**
       * An array of Buttons or typed Button config objects.
       * @config {Object[]|Core.widget.Button[]}
       */
      items: null,

      /**
       * Default color to apply to all contained buttons, see {@link Core.widget.Button#config-color Button#color}.
       * Individual buttons can override the default.
       * @config {String}
       */
      color: null,

      /**
       * Set to `true` to turn the ButtonGroup into a toggle group, assigning a generated value to each contained
       * buttons {@link Core.widget.Button#config-toggleGroup toggleGroup config}. Individual buttons can
       * override the default.
       * @config {Boolean}
       */
      toggleGroup: null,
      valueSeparator: ',',
      columns: null,
      hideWhenEmpty: true
    };
  }

  onChildAdd(item) {
    super.onChildAdd(item);
    item.on({
      click: 'onItemClick',
      thisObj: this,
      // This needs to run before the 'click' event is relayed by this button group, in such listener
      // the `value` must already be updated
      prio: 10000
    });
  }

  onChildRemove(item) {
    item.un({
      click: 'onItemClick',
      thisObj: this
    });
    super.onChildRemove(item);
  }

  onItemClick() {
    // reset cached value to revalidate next time it's requested
    this._value = null;
  }

  createWidget(widget) {
    const me = this,
          type = me.constructor.resolveType(widget.type || 'button');

    if (type.isButton) {
      if (me.color && !widget.color) {
        widget.color = me.color;
      }

      if (me.toggleGroup && !widget.toggleGroup) {
        if (typeof me.toggleGroup === 'boolean') {
          me.toggleGroup = ButtonGroup.generateId('toggleGroup');
        }

        widget.toggleGroup = me.toggleGroup;
      }
    }

    if (me.columns) {
      widget.width = `${100 / me.columns}%`;
    }

    widget = super.createWidget(widget);
    me.relayEvents(widget, ['click', 'action', 'toggle']);
    return widget;
  }

  updateRotate(rotate) {
    this.eachWidget(btn => {
      if (btn.rotate !== false) {
        btn.rotate = rotate;
      }
    });
  }

  get value() {
    // if we don't have cached value
    // let's calculate it based on item values
    if (!this._value) {
      const values = []; // collect pressed item values

      this.items.forEach(w => {
        if (w.pressed && w.value !== undefined) values.push(w.value);
      }); // build a string

      this._value = values.join(this.valueSeparator);
    }

    return this._value;
  }

  set value(value) {
    if (!Array.isArray(value)) {
      if (value === undefined || value === null) {
        value = [];
      } else if (typeof value == 'string') {
        value = value.split(this.valueSeparator);
      } else {
        value = [value];
      }
    }

    this._value = value; // reflect value on items

    this.items.forEach(w => {
      if (w.value !== undefined) {
        w.pressed = value.indexOf(w.value) > -1;
      }
    });
  }

  get disabled() {
    return super.disabled;
  }

  set disabled(state) {
    super.disabled = state;
    this.items.forEach(w => w.disabled = state);
  }

  get widgetClassList() {
    const classList = super.widgetClassList; // if the buttons should be shown in rows

    this.columns && classList.push('b-columned');
    return classList;
  }

} // Register this widget type with its Factory

ButtonGroup.initClass();
ButtonGroup._$name = 'ButtonGroup';

/***/ }),

/***/ "./lib/Core/widget/CalendarPanel.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/CalendarPanel.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CalendarPanel; });
/* harmony import */ var _Panel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _util_Month_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/Month.js */ "./lib/Core/util/Month.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'taskboard';







/**
 * @module Core/widget/CalendarPanel
 */

/**
 * A Panel which displays a month of date cells.
 *
 * This is a base class for UI widgets like {@link Core.widget.DatePicker} which need to display a calendar layout
 * and should not be used directly.
 * @extends Core/widget/Panel
 */

class CalendarPanel extends _Panel_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'CalendarPanel';
  } // Factoryable type name


  static get type() {
    return 'calendarpanel';
  }

  static get configurable() {
    return {
      textContent: false,

      /**
       * Gets or sets the date that orientates the panel to display a particular month.
       * Changing this causes the content to be refreshed.
       * @member {Date} date
       */

      /**
       * The date which this CalendarPanel encapsulates.
       * @config {Date|String}
       */
      date: {
        $config: {
          equal: 'date'
        },
        value: null
      },

      /**
       * A {@link Core.util.Month} Month utility object which encapsulates this Panel's month
       * and provides contextual information and navigation services.
       * @config {Core.util.Month|Object}
       */
      month: {},
      year: null,

      /**
       * The week start day, 0 meaning Sunday, 6 meaning Saturday.
       * Defaults to {@link Core.helper.DateHelper#property-weekStartDay-static}.
       * @config {Number}
       */
      weekStartDay: null,

      /**
       * Configure as `true` to always show a six week calendar.
       * @config {Boolean}
       * @default
       */
      sixWeeks: true,

      /**
       * Configure as `true` to show a week number column at the start of the calendar block.
       * @deprecated 4.0.0 Use {@link #config-showWeekColumn} instead.
       * @config {Boolean}
       */
      showWeekNumber: null,

      /**
       * Configure as `true` to show a week number column at the start of the calendar block.
       * @config {Boolean}
       */
      showWeekColumn: null,

      /**
       * Either an array of `Date` objects which are to be disabled, or
       * a function (or the name of a function), which, when passed a `Date` returns `true` if the
       * date is disabled.
       * @config {Function|Date[]|String}
       */
      disabledDates: null,

      /**
       * A function (or the name of a function) which creates content in, and may mutate a day header element.
       * The following parameters are passed:
       *  - cell [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The header element.
       *  - day [Number](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The day number conforming to the specified {@link #config-weekStartDay}. Will be in the range 0 to 6.
       *  - weekDay [Number](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The canonical day number where Monday is 0 and Sunday is.
       * @config {Function|String}
       */
      headerRenderer: null,

      /**
       * A function (or the name of a function) which creates content in, and may mutate the week cell element at the start of a week row.
       * The following parameters are passed:
       *  - cell [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The header element.
       *  - week [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) An array containing `[year, weekNumber]`.
       * @config {Function|String}
       */
      weekRenderer: null,

      /**
       * A function (or the name of a function) which creates content in, and may mutate a day cell element.
       * The following parameters are passed:
       *  - cell [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The header element.
       *  - date [Date](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) The date for the cell.
       *  - day [Number](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The day for the cell (0 to 6 for Sunday to Saturday).
       *  - rowIndex [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The row index, 0 to month row count (6 if {@link #config-sixWeeks} is `true`).
       *  _ row [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The row element encapsulating the week which the cell is a part of.
       *  - cellIndex [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The cell index in the whole panel. May be from 0 to up to 42.
       *  - columnIndex [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The column index, 0 to 6.
       *  - visibleColumnIndex [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The visible column index taking hidden non working days into account.
       * @config {Function|String}
       */
      cellRenderer: null,

      /**
       * Configure as `true` to render weekends as {@link #config-disabledDates}.
       * @config {Boolean}
       */
      disableWeekends: null,
      hideNonWorkingDays: null,
      hideNonWorkingDaysCls: 'b-hide-nonworking-days',

      /**
       * Non-working days as an object where keys are day indices, 0-6 (Sunday-Saturday), and the value is `true`.
       * Defaults to {@link Core.helper.DateHelper#property-nonWorkingDays-static}.
       * @config {Object}
       */
      nonWorkingDays: null,

      /**
       * A config object to create a tooltip which will show on hover of a date cell
       * including disabled, weekend, and "other month" cells.
       *
       * It is the developer's responsibility to hook the `beforeshow` event
       * to either veto the show by returning `false` or provide contextual
       * content for the date.
       *
       * The tip instance will be primed with a `date` property.
       * @config {Object}
       */
      tip: null,
      dayCellCls: 'b-calendar-cell',
      dayHeaderCls: 'b-calendar-day-header',

      /**
       * The class name to add to disabled calendar cells.
       * @config {String}
       * @private
       */
      disabledCls: 'b-disabled-date',

      /**
       * The class name to add to calendar cells which are in the previous or next month.
       * @config {String}
       * @private
       */
      otherMonthCls: 'b-other-month',

      /**
       * The class name to add to calendar cells which are weekend dates.
       * @config {String}
       * @private
       */
      weekendCls: 'b-weekend',

      /**
       * The class name to add to the calendar cell which contains today's date.
       * @config {String}
       * @private
       */
      todayCls: 'b-today',

      /**
       * The class name to add to calendar cells which are {@link #config-nonWorkingDays}.
       * @config {String}
       * @private
       */
      nonWorkingDayCls: 'b-nonworking-day',

      /**
       * The {@link Core.helper.DateHelper DateHelper} format string to format the day names.
       * @config {String}
       * @default
       */
      dayNameFormat: 'ddd',

      /**
       * By default, week rows flex to share available Panel height equally.
       *
       * Set this config if the available height is too small, and the cell height needs
       * to be larger to show events.
       *
       * Setting this config causes the month grid to become scrollable in the `Y` axis.
       *
       * May be specified as a number in which case it will be taken to mean pixels,
       * or a length in standard CSS units.
       * @config {Number|String}
       */
      minRowHeight: {
        $config: ['lazy'],
        value: null
      },

      /**
       * By default, day cells flex to share available Panel width equally.
       *
       * Set this config if the available width is too small, and the cell width needs
       * to be larger to show events.
       *
       * Setting this config causes the month grid to become scrollable in the `X` axis.
       * @config {Number}
       */
      minColumnWidth: {
        $config: ['lazy'],
        value: null
      }
    };
  }

  construct(config) {
    super.construct(config);

    if (!this.refreshCount) {
      this.refresh();
    }
  }

  onPaint({
    firstPaint
  }) {
    var _super$onPaint;

    (_super$onPaint = super.onPaint) === null || _super$onPaint === void 0 ? void 0 : _super$onPaint.call(this, ...arguments); // Invoke the lazy configs when we first hit the visible DOM

    if (firstPaint) {
      // The cell structure must exist for the configs to apply to.
      if (!this.refreshCount) {
        this.refresh();
      }

      this.getConfig('minColumnWidth');
      this.getConfig('minRowHeight');
    }
  }

  get overflowElement() {
    return this.weeksElement;
  }

  doDestroy() {
    var _this$tip;

    (_this$tip = this.tip) === null || _this$tip === void 0 ? void 0 : _this$tip.destroy();
    super.doDestroy();
  }

  changeMinRowHeight(minRowHeight) {
    // Fall back to 75 on platforms that do not support CSS vars
    const minValue = parseInt(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getStyleValue(this.element, '--min-row-height'), 10) || 75;
    return isNaN(minRowHeight) ? minRowHeight : Math.max(parseInt(minRowHeight) || 0, minValue);
  }

  updateMinRowHeight(minRowHeight) {
    this.weekElements.forEach(w => _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setLength(w, 'minHeight', minRowHeight));
    this.scrollable = {
      overflowY: minRowHeight ? 'auto' : false
    };
  }

  changeMinColumnWidth(minColumnWidth) {
    // Fall back to 75 on platforms that do not support CSS vars
    const minValue = parseInt(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getStyleValue(this.element, '--min-column-width'), 10) || 75;
    return minColumnWidth == null ? minColumnWidth : Math.max(parseInt(minColumnWidth) || 0, minValue);
  }

  updateMinColumnWidth(minColumnWidth) {
    const me = this;
    me.weekdayCells.forEach(c => _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setLength(c, 'minWidth', minColumnWidth));
    me.cellElements.forEach(c => c.matches(`.${me.dayCellCls}`) && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setLength(c, 'minWidth', minColumnWidth));
    me.scrollable = {
      overflowX: minColumnWidth ? 'auto' : false
    };
    me.overflowElement.classList[minColumnWidth ? 'add' : 'remove']('b-min-columnwidth');
  }

  getDateFromEvent(domEvent) {
    const element = (domEvent.nodeType === Element.ELEMENT_NODE ? domEvent : domEvent.target).closest(`#${this.id} [data-date]`);

    if (element) {
      return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseKey(element.dataset.date);
    }
  }

  changeTip(tip, existingTip) {
    const me = this;
    return _Tooltip_js__WEBPACK_IMPORTED_MODULE_4__["default"].reconfigure(existingTip, tip, {
      owner: me,
      defaults: {
        type: 'tooltip',
        owner: me,
        id: `${me.id}-cell-tip`,
        forElement: me.bodyElement,
        forSelector: `.${me.dayCellCls}`
      }
    });
  }

  updateTip(tip) {
    this.detachListeners('tip');
    tip === null || tip === void 0 ? void 0 : tip.on({
      pointerOver: 'onTipOverCell',
      name: 'tip',
      thisObj: this
    });
  }

  updateElement(element, was) {
    const me = this;
    super.updateElement(element, was);
    me.updateHideNonWorkingDays(me.hideNonWorkingDays);
    me.weekdayCells = Array.from(element.querySelectorAll('.b-calendar-day-header'));
    me.weekElements = Array.from(element.querySelectorAll('.b-calendar-week'));
    me.weekDayElements = Array.from(element.querySelectorAll('.b-calendar-days'));
    me.cellElements = [];

    for (let i = 0, {
      length
    } = me.weekDayElements; i < length; i++) {
      me.cellElements.push(me.weekDayElements[i].previousSibling, ...me.weekDayElements[i].children);
    }
  }

  changeDate(date) {
    date = typeof date === 'string' ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(date) : new Date(date);

    if (isNaN(date)) {
      throw new Error('CalendarPanel date ingestion must be passed a Date, or a YYYY-MM-DD date string');
    }

    return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(date);
  }
  /**
   * The date which this CalendarPanel encapsulates. Setting this causes the
   * content to be refreshed.
   * @property {Date}
   */


  updateDate(value) {
    // We respond to Month change events to update the UI
    this.month.date = value;
  }

  updateDayNameFormat() {
    // 4th June 2000 was a Sunday
    const d = new Date('2000-06-04T12:00:00');
    this.shortDayNames = []; // Collect local shortDayNames in default order.

    for (let date = 4; date < 11; date++) {
      d.setDate(date);
      this.shortDayNames.push(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(d, this.dayNameFormat));
    }
  }

  get weekStartDay() {
    // This trick allows our weekStartDay to float w/the locale even if the locale changes
    return typeof this._weekStartDay === 'number' ? this._weekStartDay : _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].weekStartDay;
  }
  /**
   * Set to 0 for Sunday (the default), 1 for Monday etc.
   *
   * Set to `null` to use the default value from {@link Core/helper/DateHelper}.
   */


  updateWeekStartDay(weekStartDay) {
    const me = this;

    if (me._month) {
      me.month.weekStartDay = weekStartDay;
      me.dayNames = []; // So, if they set weekStartDay to 1 meaning Monday which is ISO standard, we will
      // dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

      for (let i = 0; i < 7; i++) {
        me.dayNames[i] = me.shortDayNames[me.canonicalDayNumbers[i]];
      }

      if (me.refreshCount) {
        me.refresh();
      }
    }
  }

  updateHideNonWorkingDays(hideNonWorkingDays) {
    var _this$scrollable;

    this.contentElement.classList[hideNonWorkingDays ? 'add' : 'remove'](this.hideNonWorkingDaysCls);
    (_this$scrollable = this.scrollable) === null || _this$scrollable === void 0 ? void 0 : _this$scrollable.syncOverflowState();

    if (this._month) {
      this.month.hideNonWorkingDays = hideNonWorkingDays;
    }
  }

  get nonWorkingDays() {
    return this._nonWorkingDays || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].nonWorkingDays;
  }

  changeNonWorkingDays(nonWorkingDays) {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({}, nonWorkingDays);
  }

  updateNonWorkingDays(nonWorkingDays) {
    if (this._month) {
      var _this$scrollable2;

      this.month.nonWorkingDays = nonWorkingDays;
      this.refresh();
      (_this$scrollable2 = this.scrollable) === null || _this$scrollable2 === void 0 ? void 0 : _this$scrollable2.syncOverflowState();
    }
  }

  get visibleDayColumnIndex() {
    return this.month.visibleDayColumnIndex;
  }

  get dayColumnIndex() {
    return this.month.dayColumnIndex;
  }

  get canonicalDayNumbers() {
    return this.month.canonicalDayNumbers;
  }

  get visibleColumnCount() {
    return this.month.visibleColumnCount;
  }

  get weekLength() {
    return this.month.weekLength;
  }
  /**
   * The date of the first day cell in this panel.
   * Note that this may *not* be the first of this panel's current month.
   * @property {Date}
   * @readonly
   */


  get startDate() {
    return this.month.startDate;
  }

  get duration() {
    // The endDate is "exclusive" because it means 00:00:00 of that day.
    return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(this.month.startDate, this.month.endDate, 'day') + 1;
  }
  /**
   * The end date of this view. Note that in terms of full days, this is exclusive,
   * ie: 2020-01-012 to 2020-01-08 is *seven* days. The end is 00:00:00 on the 8th.
   *
   * Note that this may *not* be the last date of this panel's current month.
   * @property {Date}
   * @readonly
   */


  get endDate() {
    const {
      endDate
    } = this.month;

    if (endDate) {
      return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(endDate, 1, 'day');
    }
  }

  changeMonth(month, currentMonth) {
    const me = this;

    if (!(month instanceof _util_Month_js__WEBPACK_IMPORTED_MODULE_3__["default"])) {
      // Setting month to a number when we already have a Month means
      // just updating the month number of our Month
      if (typeof month === 'number') {
        if (currentMonth) {
          currentMonth.month = month;
          return;
        }

        const date = me.date || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(new Date());
        date.setMonth(month);
        month = {
          date
        };
      }

      month = _util_Month_js__WEBPACK_IMPORTED_MODULE_3__["default"].new({
        weekStartDay: me.weekStartDay,
        nonWorkingDays: me.nonWorkingDays,
        hideNonWorkingDays: me.hideNonWorkingDays,
        sixWeeks: me.sixWeeks
      }, month);
    }

    month.on({
      dateChange: 'onMonthDateChange',
      thisObj: me
    });
    return month;
  }

  onMonthDateChange({
    source: month,
    newDate,
    oldDate,
    changes
  }) {
    const me = this; // Ensure we're always in sync with the data our Month holds

    me.year = month.year;

    if (!me.isConfiguring) {
      // Only refresh if we are in another month
      if (changes.m || changes.y) {
        me.refresh();
      }
      /**
       * Fires when the date of this CalendarPanel is set.
       * @event dateChange
       * @param {Date} value The new date.
       * @param {Date} oldValue The old date.
       * @param {Object} changes An object which contains properties which indicate what part of the date changed.
       * @param {Boolean} changes.d True if the date changed in any way.
       * @param {Boolean} changes.w True if the week changed (including same week in a different year).
       * @param {Boolean} changes.m True if the month changed (including same month in a different year).
       * @param {Boolean} changes.y True if the year changed.
       */


      me.trigger('dateChange', {
        changes,
        value: newDate,
        oldValue: oldDate
      });
    }
  }

  updateYear(year) {
    this.month.year = year;
  }

  updateShowWeekNumber(showWeekNumber) {
    this.updateShowWeekColumn(showWeekNumber);
  }

  updateShowWeekColumn(showWeekColumn) {
    const me = this;
    me.element.classList[showWeekColumn ? 'add' : 'remove']('b-show-week-column');

    if (me.floating) {
      // Must realign because content change might change dimensions
      if (!me.isAligning) {
        me.realign();
      }
    }
  }

  updateSixWeeks(sixWeeks) {
    if (this.month) {
      this.month.sixWeeks = sixWeeks;
      this.refresh();
    }
  }
  /**
   * Refreshes the UI after changing a config that would affect the UI.
   */


  refresh() {
    // This method may be overridden by subclasses to add things like refresh scheduling.
    this.doRefresh();
  }
  /**
   * Implementation of the UI refresh.
   * @private
   */


  doRefresh() {
    // Ensure sub elements are all present
    this.getConfig('element');
    const me = this,
          today = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(new Date()),
          {
      weekElements,
      weekDayElements,
      date,
      month,
      dayCellCls,
      dayHeaderCls,
      disabledCls,
      otherMonthCls,
      weekendCls,
      todayCls,
      nonWorkingDayCls,
      nonWorkingDays,
      canonicalDayNumbers
    } = me; // If we have not been initialized with a current date, use today

    if (!date) {
      me.date = today;
    } // Make sure we've calculated our shortDayNames


    me.getConfig('dayNameFormat');

    for (let columnIndex = 0; columnIndex < 7; columnIndex++) {
      const cell = me.weekdayCells[columnIndex],
            cellDay = me.canonicalDayNumbers[columnIndex],
            cellClassList = {
        [dayHeaderCls]: 1,
        [weekendCls]: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].weekends[cellDay],
        [nonWorkingDayCls]: nonWorkingDays[cellDay]
      };

      if (me.headerRenderer) {
        cell.innerHTML = '';
        me.callback(me.headerRenderer, me, [cell, columnIndex, cellDay]);
      } else {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setInnerText(cell, me.shortDayNames[cellDay]);
      } // Sync day name cell classes with its calculated status


      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].syncClassList(cell, cellClassList);
      cell.dataset.columnIndex = columnIndex;
      cell.dataset.cellDay = cellDay;
    } // Create cell content


    let rowIndex = 0,
        cellIndex = 0,
        lastWorkingColumn = 6; // Which column is the last working day so it can be tagged with an identifying class

    for (let columnIndex = 6; columnIndex >= 0; columnIndex--) {
      if (!nonWorkingDays[canonicalDayNumbers[columnIndex]]) {
        lastWorkingColumn = columnIndex;
        break;
      }
    }

    month.eachWeek((week, dates) => {
      const weekDayElement = weekDayElements[rowIndex],
            weekCells = [weekDayElement.previousSibling, ...weekDayElement.children]; // Stamp week into week row's dataset

      weekElements[rowIndex].dataset.week = `${week[0]},${week[1]}`; // If we are sixWeeks: false, some trailing rows could have been hidden.

      weekElements[rowIndex].classList.remove('b-hide-display');

      if (me.weekRenderer) {
        me.callback(me.weekRenderer, me, [weekCells[0], week]);
      } else {
        weekCells[0].innerHTML = week[1];
      }

      for (let columnIndex = 0; columnIndex < 7; columnIndex++) {
        const date = dates[columnIndex],
              day = date.getDay(),
              cell = weekCells[columnIndex + 1],
              cellClassList = {
          [dayCellCls]: 1,
          [disabledCls]: me.isDisabledDate(date),
          [otherMonthCls]: date.getMonth() !== month.month,
          [weekendCls]: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].weekends[day],
          [todayCls]: date.getTime() === today.getTime(),
          [nonWorkingDayCls]: nonWorkingDays[day],
          'b-last-working-day': columnIndex === lastWorkingColumn
        }; // Sync day cell classes with its calculated status

        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].syncClassList(cell, cellClassList);
        cell.dataset.date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(date);
        cell.dataset.cellIndex = cellIndex;
        cell.dataset.columnIndex = columnIndex; // Since we manipulate the classList/Name directly, we need to trick DomSync's config comparison logic or it
        // may think the class has not changed.

        if (cell.lastDomConfig) {
          delete cell.lastDomConfig.class;
          delete cell.lastDomConfig.className;
        }

        if (me.cellRenderer) {
          me.callback(me.cellRenderer, me, [{
            cell,
            date,
            day,
            row: weekElements[rowIndex],
            rowIndex,
            cellIndex,
            columnIndex,
            visibleColumnIndex: me.visibleDayColumnIndex[day],
            week
          }]);
        } else {
          cell.innerHTML = date.getDate();
        }

        cellIndex++;
      }

      rowIndex++;
    });
    /**
     * The number of rows displayed in this month. If {@link #config-sixWeeks} is not set,
     * this may be from 4 to 6.
     * @member {Number} visibleWeekCount
     * @readonly
     */

    me.visibleWeekCount = rowIndex; // Hide/show trailing week rows depending on our sixWeeks setting

    for (; rowIndex < 6; rowIndex++) {
      weekElements[rowIndex].classList[me.sixWeeks ? 'remove' : 'add']('b-hide-display');
    }

    if (me.floating) {
      // Must realign because content change might change dimensions
      if (!me.isAligning) {
        me.realign();
      }
    }

    me.refreshCount = (me.refreshCount || 0) + 1;
    /**
     * Fires when this CalendarPanel refreshes.
     * @event refresh
     */

    me.trigger('refresh');
  }

  isDisabledDate(date) {
    const day = date.getDay(),
          {
      disabledDates,
      nonWorkingDays
    } = this;

    if (this.disableWeekends && nonWorkingDays[day]) {
      return true;
    }

    if (disabledDates) {
      if (Array.isArray(disabledDates)) {
        date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(date, true);
        return disabledDates.some(d => !(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(d, true) - date));
      } else {
        return this.callback(this.disabledDates, this, [date]);
      }
    }
  }

  get bodyConfig() {
    const result = super.bodyConfig,
          weeksContainerChildren = [];
    result.children = [{
      tag: 'div',
      className: 'b-calendar-row b-calendar-weekdays',
      reference: 'weekdaysHeader',
      children: [{
        class: 'b-week-number-cell'
      }, ..._helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].fill(7, {
        class: this.dayHeaderCls
      }), _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].scrollBarPadElement]
    }, {
      // `notranslate` prevents google translate messing up the DOM, https://github.com/facebook/react/issues/11538
      className: 'b-weeks-container notranslate',
      reference: 'weeksElement',
      children: weeksContainerChildren
    }];

    for (let i = 0; i < 6; i++) {
      const weekRow = {
        className: 'b-calendar-row b-calendar-week',
        children: [{
          className: 'b-week-number-cell'
        }, {
          className: 'b-calendar-days',
          children: [{}, {}, {}, {}, {}, {}, {}],
          syncOptions: {
            ignoreRefs: true,
            strict: false // allow complete replacement of classes w/o matching lastDomConfig

          }
        }]
      };
      weeksContainerChildren.push(weekRow);
    }

    return result;
  }

  get firstVisibleDate() {
    for (const me = this, date = me.month.startDate;; date.setDate(date.getDate() + 1)) {
      if (!me.hideNonWorkingDays || !me.nonWorkingDays[date.getDay()]) {
        return date;
      }
    }
  }

  getCell(date) {
    if (!(typeof date === 'string')) {
      date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(date);
    }

    return this.weeksElement.querySelector(`[data-date="${date}"]`);
  }

  onTipOverCell({
    source: tip,
    target
  }) {
    tip.date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseKey(target.dataset.date);
  }

  updateLocalization() {
    this.updateDayNameFormat();
    this.updateWeekStartDay(this.weekStartDay);
    super.updateLocalization();
  }

} // Register this widget type with its Factory

CalendarPanel.initClass();
CalendarPanel._$name = 'CalendarPanel';

/***/ }),

/***/ "./lib/Core/widget/Checkbox.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/Checkbox.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Checkbox; });
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';




/**
 * @module Core/widget/Checkbox
 */

/**
 * Checkbox field, wraps <code>&lt;input type="checkbox"&gt;</code>.
 * Color can be specified and you can optionally configure {@link #config-text}
 * to display in a label to the right of the checkbox in addition to a standard
 * field {@link #config-label}.
 *
 * {@inlineexample Core/widget/Checkbox.js vertical}
 *
 * This field can be used as an {@link Grid.column.Column#config-editor} for the {@link Grid.column.Column}.
 *
 * @extends Core/widget/Field
 * @classType checkbox
 */

class Checkbox extends _Field_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Checkbox';
  } // Factoryable type name


  static get type() {
    return 'checkbox';
  } // Factoryable type alias


  static get alias() {
    return 'check';
  }

  static get configurable() {
    return {
      inputType: 'checkbox',

      /**
       * Get/set label
       * @member {String} name
       */

      /**
       * Text to display on checkbox label
       * @config {String}
       */
      text: '',

      /**
       * The checked state. The same as `value`.
       * @config {Boolean} checked
       */

      /**
       * Checkbox color, must have match in CSS
       * @config {String}
       */
      color: null,

      /**
       * Get/set value
       * @member {String} value
       */

      /**
       * Sets input fields value attribute
       * @config {String}
       */
      value: '',
      toggleGroup: null,
      localizableProperties: ['label', 'text']
    };
  } //endregion
  //region Init


  construct(config) {
    // Convert checked to value so that initializing getter can read it if requested prior to trying to set it.
    if ('checked' in config) {
      config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assign({}, config); // copy inherited properties unlike Object.assign()

      config.value = config.checked;
      delete config.checked;
    }

    super.construct(config);
    this.syncHasText();
  } // Implementation needed at this level because it has two inner elements in its inputWrap


  get innerElements() {
    return [this.inputElement, {
      tag: 'label',
      class: 'b-checkbox-label',
      for: `${this.id}-input`,
      reference: 'textLabel',
      html: this.text || ''
    }];
  }

  get inputElement() {
    const me = this,
          config = super.inputElement;

    if (me.readOnly) {
      config.disabled = true;
    }

    if (me.toggleGroup) {
      config.dataset = {
        group: me.toggleGroup
      };
    }

    return config;
  } //endregion
  //region Toggle

  /**
   * Get/set checked state. Equivalent to `value` config.
   * @property {Boolean}
   */


  get checked() {
    return this.value;
  }

  set checked(value) {
    this.value = value;
  }

  syncHasText() {
    this.element.classList[this.text ? 'add' : 'remove']('b-text');
  }

  updateText(value) {
    if (this.textLabel) {
      this.syncHasText();
      this.textLabel.innerHTML = value;
    }
  }

  changeValue(value) {
    return value === 'false' ? false : Boolean(value);
  }

  updateValue(value) {
    const me = this,
          changed = me.input.checked !== value;
    me.input.checked = value;

    if (changed && !me.inputting) {
      me.uncheckToggleGroupMembers(); // The change event does not fire on programmatic change of input.

      if (!me.isConfiguring) {
        me.triggerChange(false);
      }
    }
  }

  get inputValueAttr() {
    return 'checked';
  }

  updateColor(value, was) {
    const classes = this.element.classList;

    if (was) {
      classes.remove(was);
    }

    if (value) {
      classes.add(value);
    }
  }

  getToggleGroupMembers() {
    const me = this,
          {
      checked,
      toggleGroup,
      input: checkedElement
    } = me,
          result = [];

    if (checked && toggleGroup) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEachSelector(me.rootElement, `input[type=checkbox][data-group=${toggleGroup}]`, inputEl => {
        if (inputEl !== checkedElement) {
          const partnerCheckbox = _Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].fromElement(inputEl);
          partnerCheckbox && result.push(partnerCheckbox);
        }
      });
    }

    return result;
  }

  uncheckToggleGroupMembers() {
    if (this.checked && this.toggleGroup) {
      this.getToggleGroupMembers().forEach(widget => widget.checked = false);
    }
  }

  updateReadOnly(readOnly) {
    if (this.input) {
      this.input.disabled = readOnly;
    } // Field and Widget have a say too. Widget adds the class and fires the event


    super.updateReadOnly(readOnly);
  }
  /**
   * Check the box
   */


  check() {
    this.checked = true;
  }
  /**
   * Uncheck the box
   */


  uncheck() {
    this.checked = false;
  }
  /**
   * Toggle checked state. If you want to force a certain state, assign to {@link #property-checked} instead.
   */


  toggle() {
    this.checked = !this.checked;
  } //endregion
  //region Events

  /**
   * Triggers events when user toggles the checkbox
   * @fires beforeChange
   * @fires change
   * @fires action
   * @private
   */


  internalOnChange(event) {
    const me = this;
    me.value = me.input.checked;

    if (!me.inputting) {
      me.inputting = true;
      me.triggerChange(true);
      me.inputting = false;
    }
  }
  /**
   * Triggers events when checked state is changed
   * @fires beforeChange
   * @fires change
   * @fires action
   * @private
   */


  triggerChange(userAction) {
    const me = this,
          {
      checked
    } = me.input;
    /**
     * Fired before checkbox is toggled. Returning false from a listener prevents the checkbox from being toggled.
     * @event beforeChange
     * @preventable
     * @param {Core.widget.Checkbox} source Checkbox
     * @param {Boolean} checked Checked or not
     */

    /**
     * Fired when checkbox is toggled
     * @event change
     * @param {Core.widget.Checkbox} source Checkbox
     * @param {Boolean} checked Checked or not
     */
    // Prevent uncheck if this checkbox is part of a toggleGroup (radio-button mode) ..also ensure the group has
    // visible active members

    const eventObject = {
      checked,
      value: checked,
      userAction,
      valid: true
    },
          prevented = !checked && userAction && me.toggleGroup && me.getToggleGroupMembers().filter(widget => widget.isVisible && !widget.disabled).length || // Since Widget has Events mixed in configured with 'callOnFunctions' this will also call onBeforeChange,
    // onChange and onAction
    me.trigger('beforeChange', eventObject) === false; // If prevented need to rollback the checkbox input

    if (prevented) {
      // Input change is not preventable, so need to revert the changes
      // The change event does not fire on programmatic change of input, so no need to suspend
      me.input.checked = me._value = !checked;
    } else {
      me.triggerFieldChange(eventObject, false);

      if (userAction) {
        me.uncheckToggleGroupMembers();
      }
      /**
       * User performed the default action (toggled the checkbox)
       * @event action
       * @param {Core.widget.Checkbox} source Checkbox
       * @param {Boolean} checked Checked or not
       */


      me.trigger('action', eventObject);
      me.trigger('change', eventObject) === false;
      return true;
    }
  } //endregion


} // Register this widget type with its Factory

Checkbox.initClass();
Checkbox._$name = 'Checkbox';

/***/ }),

/***/ "./lib/Core/widget/ChipView.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/ChipView.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ChipView; });
/* harmony import */ var _List_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./List.js */ "./lib/Core/widget/List.js");
/* harmony import */ var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
var productName = 'taskboard';


/**
 * @module Core/widget/ChipView
 */

/**
 * Displays an inline series of Chips which may be navigated to, selected and deleted.
 * @extends Core/widget/List
 *
 * @classType chipview
 */

class ChipView extends _List_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'ChipView';
  } // Factoryable type name


  static get type() {
    return 'chipview';
  }

  static get configurable() {
    return {
      itemCls: 'b-chip',

      /**
       * Configure as `true` to display a clickable close icon after the {@link Core.widget.List#config-itemTpl}.
       * When tapped, the configured {@link #config-closeHandler} is called passing the
       * associated record.
       *
       * Chips may also be selected using the `LEFT` and `RIGHT` arrows (And the `Shift` key to
       * do multiple, contiguous election). Pressing the `DELETE` or `BACKSPACE` key passes the
       * selected records to the {@link #config-closeHandler}
       * @config {Boolean}
       * @default
       */
      closable: true,

      /**
       * A template function, which, when passed a record, returns the markup which
       * encapsulates a chip's icon to be placed before the {@link Core.widget.List#config-itemTpl}.
       * @config {Function}
       */
      iconTpl: null,

      /**
       * If {@link #config-closable} is `true`, this is the name of a callback function
       * to handle what the "close" action means.
       * @config {String|Function}
       */
      closeHandler: null
    };
  }

  itemContentTpl(record, i) {
    const me = this;
    return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].tpl`${me.iconTpl ? this.iconTpl(record) : ''}
            ${me.itemTpl(record, i)}
            ${me.closable ? '<div class="b-icon b-close-icon b-icon-clear" data-noselect></div>' : ''}`;
  }

  onInternalKeyDown(event) {
    if (this.closable && this.selected.count && (event.key === 'Delete' || event.key === 'Backspace')) {
      this.callback(this.closeHandler, this.owner, [this.selected.values, {
        isKeyEvent: true
      }]);
    } else {
      super.onInternalKeyDown(event);
    }
  }

  updateClosable(closable) {
    this.element.classList[closable ? 'add' : 'remove']('b-chips-closable');
    this.navigator.disabled = !closable;

    if (!this.isConfiguring) {
      this.refresh();
    }
  }

  onClick(event) {
    const me = this,
          item = event.target.closest(`.${me.itemCls}`);

    if (me.closable && event.target.classList.contains('b-close-icon')) {
      const record = me.store.getAt(parseInt(item.dataset.index));
      me.callback(me.closeHandler, me.owner, [[record]]);
    } else {
      super.onClick(event);
    }
  }

} // Register this widget type with its Factory

ChipView.initClass();
ChipView._$name = 'ChipView';

/***/ }),

/***/ "./lib/Core/widget/Combo.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Combo.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Combo; });
/* harmony import */ var _data_Store_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _data_Model_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
/* harmony import */ var _PickerField_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony import */ var _ChipView_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ChipView.js */ "./lib/Core/widget/ChipView.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _util_Collection_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/util/Navigator.js */ "./lib/Core/helper/util/Navigator.js");
/* harmony import */ var _List_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./List.js */ "./lib/Core/widget/List.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';















const errorFieldRequired = 'L{Field.fieldRequired}',
      errorValidateFilter = 'L{Field.validateFilter}',
      errorRecordNotCommitted = 'L{Combo.recordNotCommitted}';
/**
 * @module Core/widget/Combo
 */

/**
 * Combo (dropdown) widget. Consists of a text field with a trigger icon, which displays a List. Can be
 * populated from a Store.
 *
 * This field can be used as an {@link Grid/column/Column#config-editor} for the {@link Grid/column/Column}.
 *
 * Please be aware that when populating the Combo with objects or records you have to configure {@link #config-valueField} and {@link #config-displayField}
 * to point to the correct field names in your data.
 *
 * ### Basic scenarios
 * {@inlineexample Core/widget/Combo.js vertical}
 *
 * ### Multiselect + grouped list
 *
 * {@inlineexample Core/widget/ComboMultiselect.js}
 *
 * ## Snippet: Loading data from simple string array
 * ```javascript
 * const combo = new Combo({
 *     items       : ['Small', 'Smaller', 'Really small', 'Tiny'],
 *     placeholder : 'Pick size of diamond for ring'
 * });
 *```
 *
 * ## Snippet: Loading data from array with item configs
 * ```javascript
 * const combo = new Combo({
 *     items : [{ value: 'a', text: 'First' }, { value: 'z', text: 'Last' }]
 * });
 *```
 *
 * ## Snippet: Loading data from store
 * ```javascript
 * const combo = new Combo({
 *     store        : memberStore,
 *     valueField   : 'id',
 *     displayField : 'name'
 * });
 *```
 *
 * ## Snippet: Grouped list
 * To group the list contents, simply group your store using {@link Core.data.mixin.StoreGroup#config-groupers}. You
 * can decide if clicking a header should toggle all group children (or if it should do nothing) with the
 * {@link Core.widget.List#config-allowGroupSelect} flag.
 * ```javascript
 * const combo = new Combo({
 *     width            : 400,
 *     displayField     : 'name',
 *     valueField       : 'id',
 *     multiSelect      : true,
 *     picker : {
 *         allowGroupSelect : false,
 *         // Show icon based on group name
 *         groupHeaderTpl   : (record, groupName) => `
 *             <i class="icon-${groupName}"></i>${groupName}
 *         `
 *     },
 *     value : [1, 4],
 *     store : new Store({
 *         fields : [
 *             'type'
 *         ],
 *         groupers : [
 *             { field : 'type', ascending : true }
 *         ],
 *         data : [
 *             { id : 1, name : 'pizza', type : 'food' },
 *             { id : 2, name : 'bacon', type : 'food' },
 *             { id : 3, name : 'egg', type : 'food' },
 *             { id : 4, name : 'Gin tonic', type : 'drinks' },
 *             { id : 5, name : 'Wine', type : 'drinks' },
 *             { id : 6, name : 'Beer', type : 'drinks' }
 *         ]
 *     })
 * });
 *```
 *
 * @extends Core/widget/PickerField
 * @classType combo
 */

class Combo extends _PickerField_js__WEBPACK_IMPORTED_MODULE_4__["default"] {
  // Do not remove. Assertion strings for Localization sanity check.
  // 'L{Field.fieldRequired}'
  // 'L{Field.validateFilter}'
  // 'L{recordNotCommitted}
  //region Config
  static get $name() {
    return 'Combo';
  } // Factoryable type name


  static get type() {
    return 'combo';
  } // Factoryable type aliases


  static get alias() {
    return 'combobox,dropdown';
  }

  static get configurable() {
    return {
      /**
       * Optionally a {@link Core.util.CollectionFilter Filter} config object which
       * the combo should use for filtering using the typed value.
       * This may use a `filterBy` property to test its `value` against any field
       * in the passed record.
       * ```javascript
       * {
       *     type          : 'combo',
       *     store         : myStore,
       *     primaryFilter : {
       *         filterBy(record) {
       *             if (this.value == null) {
       *                 return true;
       *             }
       *             const value = this.value.toLowerCase();
       *
       *             // Match typed value with forename or surname
       *             return record.forename.toLowerCase().startsWith(value) || record.surname.toLowerCase().startsWith(value);
       *         }
       *     }
       * }
       * ```
       * @config {Object}
       */
      primaryFilter: {},
      picker: {
        type: 'list',
        floating: true,
        scrollAction: 'realign',
        itemsFocusable: false,
        activateOnMouseover: true,
        align: {
          align: 't0-b0',
          axisLock: true
        },
        maxHeight: 324,
        scrollable: {
          overflowY: true
        },
        autoShow: false,
        focusOnHover: false
      },

      /**
       * Configure as `true` to allow selection of multiple values from the dropdown list.
       *
       * Each value is displayed as a "Chip" to the left of the input area. Chips may be
       * selected using the `LEFT` and `RIGHT` arrow keys and deleted using the `DELETE` key
       * to remove values from the field. There is also a clickable close icon in each chip.
       *
       * Use {@link Core.widget.List#config-toggleAllIfCtrlPressed} to implement "select all" behaviour.
       *
       * ```javascript
       * {
       *     type   : 'combo',
       *     store  : myStore,
       *     picker : {
       *         toggleAllIfCtrlPressed : true
       *     }
       * }
       * ```
       *
       * @config {Boolean}
       * @default false
       */
      multiSelect: null,

      /**
       * Rows to display in the dropdown (list items).
       *
       * If an object, the property names provide the {@link #config-value} for the Combo, and
       * the property values provide the displayed test in the list and input area eg:
       *
       *     items : {
       *         small  : 'Small',
       *         medium : 'Medium',
       *         large  : 'Large'
       *     }
       *
       * If an array, each entry may be
       *  - an object containing properties which must include
       * the {@link #config-valueField} and {@link #config-displayField} which populates the dropdown
       * with text and provides the corresponding field value.
       *  - An array whose first value provides the {@link #config-value} for the Combo and whose
       * second value provides the displayed test in the list and input area.
       *  - An array of values where the {@link #config-valueField} and {@link #config-displayField} are the same.
       *
       * eg:
       *
       *     items : [
       *         {value : 'small',  text : 'Small'},
       *         {value : 'medium', text : 'Medium'},
       *         {value : 'large',  text : 'Large'},
       *     ]
       *
       * or
       *
       *     items : [
       *         ['small',  'Small'],
       *         ['medium', 'Medium'],
       *         ['large',  'Large'],
       *     ]
       *
       * or
       *
       *     items : [ 'Small', 'Medium', 'Large' ]
       *
       * @config {Object[]|String[]|Object}
       */
      items: null,

      /**
       * Get/set store to display items from. Also accepts a Store config object.
       * @member {Core.data.Store} store
       * @accepts {Core.data.Store|Object}
       */

      /**
       * A store used to populate items.
       * @config {Core.data.Store}
       */
      store: null,

      /**
       * Field used for item value when populating from store. Setting this to `null` will
       * yield the selected record as the Combo's {@link #property-value}.
       * @config {String|null}
       */
      valueField: undefined,

      /**
       * Field used for item text when populating from store
       * @config {String}
       */
      displayField: 'text',

      /**
       * Width of picker, defaults to this combo's {@link #config-pickerAlignElement} width
       * @config {Number}
       */
      pickerWidth: null,

      /**
       * The minimum string length to trigger the filtering, only relevant when {@link #config-editable} is `true`.
       *
       * This defaults to `1` in the case of local filtering, but `4` if the
       * {@link #config-filterParamName} is set to cause remote dropdown loading.
       *
       * @config {Number}
       * @default
       */
      minChars: null,
      selected: null,

      /**
       * Template string used to render the list items in the dropdown list
       *
       * ```javascript
       * new Combo({
       *     listItemTpl : ({ text }) => `<div class="combo-color-box ${text}"></div>${text}`,
       *     editable    : false,
       *     items       : [
       *         'Black',
       *         'Green',
       *         'Orange',
       *         'Pink',
       *         'Purple',
       *         'Red',
       *         'Teal'
       *     ]
       * });
       * ```
       *
       * @config {Function}
       * @param {Core.data.Model} record The record representing the item being rendered
       * @returns {String}
       */
      listItemTpl: null,

      /**
       * Template function that can be used to customize the displayed value
       * @param {Core.data.Model} record The record to provide a textual value for.
       * @param {Core.widget.Combo} combo A reference to this Combo.
       * @config {Function}
       * @returns {String}
       */
      displayValueRenderer: null,

      /**
       * CSS class to add to picker
       * @config {String}
       */
      listCls: null,
      triggers: {
        expand: {
          cls: 'b-icon-picker',
          handler: 'onTriggerClick'
        }
      },

      /**
       * If the dropdown is to be populated with a filtered query to a remote server, specify the
       * name of the parameter to pass the typed string here. By default, the string is simply sent
       * as the value of the parameter. For special encoding, configure the combo with {@link #config-encodeFilterParams}
       * @config {String}
       */
      filterParamName: null,

      /**
       * A function which creates an array of values for the {#config-filterParamName} to pass
       * any filters to the server upon load.
       *
       * The default behaviour is just to set the parameter value to the filter's `value`,
       * but the filter can be fully encoded for example:
       *
       * ```javascript
       *    {
       *        encodeFilterParams(filters) {
       *            const result = [];
       *
       *            for (const { property, operator, value, caseSensitive } of filters) {
       *                result.push(JSON.stringify({
       *                    field : property,
       *                    operator,
       *                    value,
       *                    caseSensitive
       *                }));
       *           }
       *        return result;
       *    }
       * ```
       * @config {Function}
       */
      encodeFilterParams: filters => filters.map(f => f.value),

      /**
       * If `false`, filtering will be triggered once you exceed {@link #config-minChars}. To filter only when
       * hitting Enter key, set this to `true`;
       * @config {Boolean}
       */
      filterOnEnter: false,

      /**
       * Configure as `true` to hide the expand trigger. This is automatically set to `true` if
       * remote filtering is enabled by setting the {@link #config-filterParamName} config.
       * @config {Boolean}
       * @default false
       */
      hideTrigger: null,

      /**
       * This implies that the picker will display an anchor pointer, but also means that the picker will align closer
       * to the input field so that the pointer pierces the {@link #config-pickerAlignElement}
       * @config {Boolean}
       * @default false
       */
      overlayAnchor: null,

      /**
       * The delay in milliseconds to wait after the last keystroke before filtering the list.
       *
       * This is a minimum of 300ms for remote filtering to keep network requests manageable, and
       * defaults to 10ms for locally filtered stores.
       * @config {Number}
       * @default
       */
      keyStrokeFilterDelay: null,
      defaultAction: 'select',

      /**
       * How to query the store upon click of the expand trigger. Specify one of these values:
       *
       *  - `'all'` - Clear the filter and display the whole dataset in the dropdown.
       *  - `'last'` - Filter the dataset using the last filter value.
       *  - `null`/any other - Use the value in the input field to filter the dataset.
       *
       * @config {String}
       * @default
       */
      triggerAction: 'all',

      /**
       * Get/sets of the operator type for the combo primary filter.
       *
       * @member {String} filterOperator
       */

      /**
       * The name of an operator type as implemented in {@link Core.util.CollectionFilter#config-operator}
       * to use when filtering the dropdown list based upon the typed value.
       *
       * This defaults to `'startsWith'`, but the `'*'` operator may be used to match all
       * values which _contain_ the typed value.
       *
       * Not used when {@link #config-filterParamName} is set to cause remote dropdown loading.
       * The exact filtering operation is up to the server.
       *
       * @config {String}
       */
      filterOperator: 'startsWith',

      /**
       * Configure as `true` to force case matching when filtering the dropdown list based upon the typed value.
       *
       * @config {Boolean}
       * @default false
       */
      caseSensitive: false,

      /**
       * By default, the picker is hidden on selection in single select mode, and
       * remains to allow more selections when {@link #config-multiSelect} is `true`.
       * Setting this to a `Boolean` value can override that default.
       * @config {Boolean}
       */
      hidePickerOnSelect: null,

      /**
       * A config object to configure the {@link Core.widget.ChipView} to display the
       * selected value set when {@link #config-multiSelect} is `true`.
       *
       * For example the {@link Core.widget.List#config-itemTpl} or
       * {@link Core.widget.ChipView#config-iconTpl} might be configured to display
       * richer chips for selected items.
       * @config {Object}
       */
      chipView: {
        $config: ['lazy', 'nullify'],
        value: {
          type: 'combochipview'
        }
      },
      chipStore: {
        $config: ['lazy', 'nullify'],
        value: {}
      },

      /**
       * When {@link #config-multiSelect} is `true`, you may configure `filterSelected` as
       * `true` to hide items in the dropdown when they are added to the selection.
       * It will appear as if the requested item has "moved" into the field's
       * {@link #config-chipView ChipView}.
       *
       * @config {Boolean}
       * @default false
       */
      filterSelected: null,

      /**
       * Text to display in the drop down when there are no items in the underlying store
       * @config {String}
       * @default
       */
      emptyText: null,

      /**
       * Get/sets combo value, selects corresponding item in the list
       * Setting null clears the field.
       *
       * If {@link #config-multiSelect} is `true`, then multiple values may be passed as an array.
       * If the values are records, these become the selected record set held by {@link #property-valueCollection},
       * and the `value` yielded by this field is an array of all the {@link #config-valueField}s from the records.
       * @fires select
       * @fires action
       * @member {Object} value
       */

      /**
       * The initial value of this Combo box. In single select mode (default) it's a simple string value, for
       * {@link #config-multiSelect} mode, it should be an array of record ids.
       * @config {String|Number[]|String[]}
       * @default
       */
      value: null,
      valueCollection: {
        $config: ['nullify', 'lazy'],
        value: {}
      },

      /**
       * `true` to cause the field to be in an invalid state while the typed filter string does not match a record in the store.
       * @config {Boolean}
       * @default
       */
      validateFilter: true,

      /**
       * `true` to clear value typed to a multiselect combo when picker is collapsed
       * @config {Boolean}
       * @default
       */
      clearTextOnPickerHide: true,
      // set to true to destroy the old combo store when it is replaced with a new store
      destroyStore: false,

      /**
       * A key value which, when typed in a {@link #config-multiSelect} Combo, selects the
       * currently active item in the picker, and clears the input field ready for another
       * match to be typed.
       * @config {String}
       * @default
       */
      multiValueSeparator: ',',

      /**
       * If configured as `true`, this means that when an unmatched string is typed into the
       * combo's input field, and `ENTER`, or the {@link #config-multiValueSeparator} is typed,
       * a new record will be created using the typed string as the {@link #config-displayField}.
       *
       * If configured as a function, or the *name* of a function in the owning component
       * hierarchy, the function will be called passing the string and should return the record
       * to add (if any).
       *
       * The new record will be appended to the store, and the value selected.
       *
       * If the Store is an {@link Core.data.AjaxStore}, the new record will be eiligible for
       * syncing to the database through its {@link Core.data.AjaxStore#config-createUrl createUrl}.
       *
       * If the `AjaxStore` is configured to {@link Core.data.AjaxStore#config-autoCommit autoCommit},
       * the record will be synced immediately. If the server does not accept the new addition,
       * the field is placed temporarily into an invalid state with a message that explains this.
       *
       * For example:
       *
       * ```javascript
       *     new Combo({
       *         label : 'Employee name',
       *         store : employees,
       *         createOnUnmatched(name, combo) {
       *             name = validateEmployeeName(name);
       *
       *             if (name) {
       *                 return new Employee({
       *                     name,
       *                     email : generateEmployeeEmail(name)
       *                 });
       *             }
       *             else {
       *                 combo.setError('Invalid new employee name');
       *             }
       *         }
       *     });
       * ```
       * @config {Function|String|Boolean}
       */
      createOnUnmatched: null,

      /**
       * Configure this as `true` to render the dropdown list as a permanently visible list
       * in the document flow immediately below the input area instead of as a popup.
       *
       * This also hides the expand trigger since it is not needed.
       * @config {Boolean}
       * @default false
       */
      inlinePicker: null,
      testConfig: {
        // So that locally filtered tests do not have to wait after type gestures.
        // Note that for remote filtering, we set a min of 300ms
        keyStrokeFilterDelay: 0
      }
    };
  }
  /**
   * A constant value for the {@link #config-triggerAction} config to indicate that clicking the trigger should
   * filter the dataset using the last filter query string, *not* the input field value.
   * @member {String} queryLast
   * @readonly
   * @static
   */


  static get queryLast() {
    return 'last';
  } //endregion


  construct(config) {
    super.construct(...arguments); // Ensure there will always be a store created if Combo is created without items/store

    if (!this.store) {
      this.items = [];
    }

    if (this.filterOnEnter) {
      this.hideTrigger = true;
    }
  }

  startConfigure(config) {
    this.usingRecordAsValue = config.valueField === null;
    super.startConfigure(...arguments);
  }

  afterConfigure() {
    super.afterConfigure();
    const me = this;

    if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].hasOwn(me, '_value')) {
      me._value = me.valueField === me.displayField ? '' : null; // _lastValue should stay keeping an initial value if any

      me._lastValue = me._lastValue || me._value;
    }
  }

  get childItems() {
    const {
      _chipView,
      _picker
    } = this,
          result = [];

    if (_chipView) {
      result.push(_chipView);
    }

    if (_picker) {
      result.push(_picker);
    }

    return result;
  }

  get innerElements() {
    var _this$_chipView;

    const chipViewElement = (_this$_chipView = this._chipView) === null || _this$_chipView === void 0 ? void 0 : _this$_chipView.element,
          // don't trigger chipView create on first compose()
    {
      input,
      inputElement
    } = this;

    if (chipViewElement) {
      // Once the input el is transplanted inside the chipView, normal compose() calls won't sync it, so we
      // have to do so now:
      _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_10__["default"].sync({
        targetElement: input,
        domConfig: inputElement
      });
    }

    return [chipViewElement || inputElement];
  }

  updateInlinePicker(inlinePicker) {
    if (inlinePicker) {
      this.element.classList.add('b-inline-picker'); // Force eager ingestion of picker

      this.getConfig('picker'); // No expand trigger

      this.triggers.expand = null;
      this.pickerVisible = true;
    }
  }

  hidePicker() {
    if (!this.inlinePicker) {
      return super.hidePicker(...arguments);
    }
  }

  changeChipStore(chipStore) {
    if (chipStore && !(chipStore instanceof _data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
      chipStore = new _data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"](_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"].mergeConfigs({
        storage: this.valueCollection
      }, chipStore));
    }

    return chipStore;
  }

  updateChipStore(store, was) {
    was === null || was === void 0 ? void 0 : was.destroy();
  }

  changeChipView(chipView, oldChipView) {
    const me = this;
    me.element.classList[chipView ? 'add' : 'remove']('b-uses-chipview');

    if (chipView) {
      const {
        input
      } = me;

      if (!me.chipStore) {
        me.chipStore = {};
      }

      return ComboChipView.reconfigure(oldChipView, chipView, {
        defaults: {
          parent: me,
          insertBefore: input,
          store: me.chipStore,
          closable: !me.readOnly,
          navigator: {
            class: ComboChipNavigator,
            keyEventTarget: input
          }
        }
      });
    }

    oldChipView === null || oldChipView === void 0 ? void 0 : oldChipView.destroy();
  }

  updateChipView(chipView) {
    var _me$_chipViewEventDet;

    const me = this;
    me._chipViewEventDetacher = (_me$_chipViewEventDet = me._chipViewEventDetacher) === null || _me$_chipViewEventDet === void 0 ? void 0 : _me$_chipViewEventDet.call(me);
    me.chipStore = chipView === null || chipView === void 0 ? void 0 : chipView.store;

    if (chipView) {
      // Insert the input field
      chipView.element.appendChild(me.input); // Focus must flow into our field from the ChipView

      me._chipViewEventDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].on({
        element: chipView.element,
        mousedown: 'onChipViewMousedown',
        thisObj: me
      });
    }
  }

  updateMultiSelect(multiSelect, oldMultiSelect) {
    const me = this,
          {
      input,
      element
    } = me,
          fixValue = !me.isConfiguring;
    let {
      value
    } = me;
    element.classList[multiSelect ? 'add' : 'remove']('b-multiselect');

    if (multiSelect) {
      const {
        chipView
      } = me,
            {
        parentNode
      } = input,
            chipViewEl = chipView === null || chipView === void 0 ? void 0 : chipView.element; // If the input's parentNode is not the chipView's element, we need to restore that DOM arrangement

      if (chipViewEl && chipViewEl !== parentNode) {
        // This is where the chipView is created in the DOM but it may have been removed.
        parentNode.insertBefore(chipViewEl, input);
        chipViewEl.appendChild(input);
        me.chipView.refresh();
      }

      input.value = '';

      if (fixValue && !Array.isArray(value)) {
        value = value ? [value] : null;
      }
    } // else when !multiSelect, if the input's parentNode is the chipView's element, we need to put things back the
    // other way
    else {
      // avoid triggering lazy config if !multiSelect
      const chipView = me._chipView,
            {
        parentNode
      } = input,
            chipViewEl = chipView === null || chipView === void 0 ? void 0 : chipView.element;

      if (chipViewEl === parentNode) {
        // Put the input back in its proper place
        chipViewEl.parentNode.insertBefore(input, chipViewEl); // When no longer multiSelect, remove the chipView from the DOM. We do not destroy it because derived
        // classes or the instance config may have specified chipView config options. If we destroyed it, we could
        // not then properly recreate it.

        chipViewEl.remove();
        element.classList.remove('b-uses-chipview');
      }

      if (fixValue && typeof value !== 'string') {
        value = value && value.length ? value[0] : null;
      }
    }

    if (fixValue) {
      me.value = value;
    }
  }

  onChipViewMousedown(mousedownEvent) {
    mousedownEvent.preventDefault();

    if (!this.containsFocus) {
      this.focus();
    }
  }

  onChipClose(records, options = {}) {
    // Do not clean value collection if input field is not empty - probably text is selected
    // and user just wants to remove it, not the picked values
    if (options.isKeyEvent && this.input.value === '' || !options.isKeyEvent) {
      this._isUserAction = true;
      this.valueCollection.remove(records);
      this._isUserAction = false;
    }
  }

  updateFilterParamName(filterParamName) {
    if (this.hideTrigger !== false) {
      this.hideTrigger = Boolean(filterParamName);
    }
  }

  updateHideTrigger(hideTrigger) {
    this.element.classList[hideTrigger ? 'add' : 'remove']('b-hide-trigger');
  } //region Getters/setters


  updateKeyStrokeFilterDelay(delay) {
    const me = this;

    if (delay) {
      me.filterList = me.buffer(me.doFilter, delay);
    }
  }

  updateReadOnly(readOnly) {
    super.updateReadOnly(...arguments); // Disable closing (removing) chips when we are read-only.

    this._chipView && (this._chipView.closable = !readOnly);
  }

  updateFilterOperator(filterOperator) {
    if (this.primaryFilter) {
      this.primaryFilter.operator = filterOperator;
    }
  }

  get minChars() {
    const minChars = this._minChars;

    if (minChars != null) {
      return minChars;
    } // If it's not actually set, default differently for remote filtering.


    return this.remoteFilter ? 4 : 1;
  }

  get validateFilter() {
    // Do not show the error if the user has the opportunity to add the typed filter string
    return this._validateFilter && !this.createOnUnmatched;
  }

  get items() {
    return this.store.allRecords;
  }
  /**
   * Prepares items to work in attached menu (converts strings to items)
   * @private
   */


  changeItems(items) {
    const me = this;

    if (items == null) {
      if (me.store && !me.store.isItemStore) {
        return;
      }

      items = [];
    }

    if (items instanceof _data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
      me.store = items;
      return;
    }

    const displayField = me.displayField;
    let itemModel,
        valueField = me.valueField,
        storeData;

    if (Array.isArray(items)) {
      storeData = items.map(item => {
        let result = item;

        if (item instanceof _data_Model_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
          itemModel = item.constructor;

          if (!valueField) {
            me.valueField = valueField = itemModel.idField;
          }
        } else {
          if (typeof item === 'string' || typeof item === 'number') {
            if (!valueField) {
              me.valueField = valueField = me.displayField;
            }

            result = {
              [valueField]: item,
              [displayField]: item
            };
          } else {
            if (!valueField) {
              me.valueField = valueField = 'value';
            }

            if (Array.isArray(item)) {
              result = {
                [valueField]: item[0],
                [displayField]: item[1]
              };
            }
          }
        }

        if (item.selected) {
          me.value = result;
        }

        return result;
      });
    } // Must be a value -> text map
    else {
      if (!valueField) {
        me.valueField = valueField = 'value';
      }

      storeData = [];
      Object.entries(items).forEach(([key, value]) => {
        storeData.push({
          [valueField]: key,
          [displayField]: value
        });
      });
    } // Allow reconfiguring with a new set of items


    if (me.store) {
      me.store.data = storeData;
    } else {
      const valueFieldDefinition = valueField === displayField ? {
        name: 'value',
        dataSource: displayField
      } : valueField;
      me.store = new _data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"]({
        isItemStore: true,
        data: storeData,
        idField: valueField,
        modelClass: itemModel || class extends _data_Model_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
          static get idField() {
            // Need to use instance var and not rely on closure for cases where valueField changes
            // (like first assigning [] and then ['a'] without configured valueField
            return me.valueField;
          }

          static set idField(idField) {
            super.idField = idField;
          }

          static get fields() {
            return [valueFieldDefinition, displayField];
          }

        }
      });
    }
  }

  get value() {
    const me = this,
          {
      valueCollection,
      valueField
    } = me;

    if (valueField == null) {
      return me.multiSelect ? valueCollection.values.slice() : valueCollection.first;
    }

    let value;

    if (me.multiSelect) {
      value = valueCollection.count ? valueCollection.map(r => r[valueField]) : me._lastValue || [];
    } else {
      value = valueCollection.count ? valueCollection.first[valueField] : me._lastValue;
    }

    return value;
  }

  set value(value) {
    super.value = value;
  }

  changeValue(value, oldValue) {
    var _me$hidePickerOnSelec;

    const me = this;

    if (value === oldValue) {
      // Sync without highlight
      me.syncInputFieldValue(true);
      return;
    }

    if (!me.multiSelect && Array.isArray(value) && value.length > 1) {
      throw new Error('Multiple values cannot be set to a non-multiSelect Combo');
    } // This forces promotion of the items config into a Store if it has not already been injected


    me.triggerConfig('items'); // Set an empty items array if no data or store was given

    if (!me.store) {
      me.items = [];
    }

    const {
      valueField,
      displayField,
      store,
      valueCollection,
      _picker
    } = me,
          {
      storage
    } = store,
          hidePicker = (_me$hidePickerOnSelec = me.hidePickerOnSelect) !== null && _me$hidePickerOnSelec !== void 0 ? _me$hidePickerOnSelec : !me.multiSelect,
          isUserAction = me._isUserAction || (_picker === null || _picker === void 0 ? void 0 : _picker._isUserAction) || hidePicker && me.pickerVisible || false; // if not remoteFilter mode and AjaxStore has been used, try again to set a value after first store loading

    if (!me.remoteFilter && store.isAjaxStore && !store.count) {
      store.on('load', () => me.value = value, {
        once: true,
        thisObj: me
      }); // save value to make sure getter returns the correct data fot multiSelect while data loading

      me._lastValue = value;
      return;
    } // It's a remote filter store, so we have to do a filter down to just match(es)
    // and add the result to the valueCollection


    if (me.remoteFilter) {
      // The null case will drop through and be processed as for local just by clearing the valueCollection
      if (value != null) {
        if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__["default"].isObject(value) || value.isModel) {
          this.store.data = [value];
          this.valueCollection.splice(0, this.valueCollection.count, this.store.first);
        } else {
          const wasConfiguring = me.isConfiguring;
          me.primaryFilter.setConfig({
            value,
            disabled: false
          });
          store.performFilter(true).then(() => {
            const {
              isConfiguring
            } = me; // Carry the wasConfiguring flag from the set value call frame so that
            // if it's the configuring set value, we do not now fire the change event.

            me.isConfiguring = wasConfiguring;
            valueCollection.splice(0, valueCollection.count, store.allRecords);
            me.isConfiguring = isConfiguring;
          });
        }

        return;
      }
    } // Else, if it's a *locally* filtered store, then
    // unfilter it so we can do the value lookup.
    else if (store.filtered) {
      me.primaryFilter.disabled = true;
      store.filter();
    }

    let record;

    if (value != null) {
      // If value is set as an array, make sure to slice it to not mutate original array below
      const arrayPassed = Array.isArray(value),
            values = arrayPassed ? value.slice() : [value];

      for (let i = 0, len = values.length; i < len; i++) {
        let currentValue = values[i];

        if (currentValue instanceof _data_Model_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
          // The required record value may not yet be in the store. Add it if not.
          if (!storage.includes(currentValue)) {
            store.add(currentValue);
          }
        } else {
          const isObject = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].isObject(currentValue); // If they passed a data object, match the valueField

          if (isObject) {
            currentValue = currentValue[valueField];
          } // Use the Store Collection's extra indices to quickly find a match.
          // They may not be found if the current valueCollection state and
          // filterSelected mean that some are filtered out, so check in
          // valueCollection if not found in the Store.


          record = storage.getBy(displayField, currentValue) || storage.getBy(valueField, currentValue) || valueCollection.getBy(displayField, currentValue) || valueCollection.getBy(valueField, currentValue); // If it's a potentially non-unique index (such as the by-displayField index)
          // then key lookups yield a Set. Use the first entry as the match.

          if (record instanceof Set) {
            record = [...record][0];
          }

          if (record) {
            // If the incoming value was a matched object, use it to update the record
            if (isObject) {
              record.set(values[i]);
            }

            values[i] = record;
          } else {
            values.splice(i, 1);
            len--;
            i--;
          }
        }
      }

      const noMatches = !values.length; // Remove all old values, add new values in one shot.

      const vcGen = valueCollection.generation;
      valueCollection.splice(0, valueCollection.count, values); // If we got no matches, onValueCollectionChange will set the _value to null.
      // Tests specify that the _value should be set to the incoming unmatched value.
      // Handle the case that an array was passed.

      if (noMatches) {
        me._value = arrayPassed && value.length === 0 ? null : value; // _lastValue has to be updated here to have an actual value for syncInputFieldValue() and syncEmpty() below

        me._lastValue = me._value;
      } // If no change has fed through to onValueCollectionChange, just ensure the input matches.
      // Must be done last so that the fallback of using this._value if the passed value did
      // not match a record can be used.


      if (noMatches || valueCollection.generation === vcGen) {
        me.syncInputFieldValue();
      }

      me.syncEmpty(); // If there were matches, onValueCollectionChange would have triggered the change event.
      // If not, we trigger it here.

      if (noMatches && !me.isConfiguring) {
        me.triggerFieldChange({
          value,
          oldValue,
          userAction: isUserAction,
          valid: me.isValid
        });
      }
    } else {
      if (valueCollection.count) {
        valueCollection.clear();
      } else {
        const oldValue = me._value; // Cache the value for use by our change handler next time, and also so that
        // when get value yields null, the fallback to ._value will be correct

        me._value = null;
        me.syncInputFieldValue();
        me.syncEmpty();

        if (!me.isConfiguring) {
          me.triggerFieldChange({
            value,
            oldValue,
            userAction: isUserAction,
            valid: me.isValid
          });
        }
      }
    }

    me._lastValue = me._value;
  }

  hasChanged(oldValue, newValue) {
    if (this.multiSelect) {
      return !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].isEqual(oldValue, newValue);
    }

    return super.hasChanged(...arguments);
  }

  onComboStoreChange({
    action
  }) {
    // Local filter-on-type is happening, do not sync the input value.
    if (action !== 'filter') {
      this.syncInputFieldValue(true);
    }
  }

  syncInputFieldValue(skipHighlight) {
    // We only sync the input's value if we are not using the chip view (DependencyField).
    // If we are multiselecting, our value is represented by a ChipView.
    // The ChipView automatically syncs itself with our valueCollection.
    if (!this.usesChipView) {
      super.syncInputFieldValue(skipHighlight);
    }
  }

  get usesChipView() {
    return Boolean(this.multiSelect && this._chipView);
  }
  /**
   * Returns `true` if this field has no selected records.
   * @property {Boolean}
   * @readonly
   */


  get isEmpty() {
    return this.valueCollection.count === 0;
  }

  get inputValue() {
    // This must be evaluated first, and NOT moved to be directly used as the
    // second expression in the ternary. If called during configuration, this
    // will import the configured value from the config object and ensure the
    // value is matched against the store, and that the "selected" property is set.
    const me = this;
    let result = me.selected ? me.selected[me.displayField] : me.value;

    if (me.displayValueRenderer) {
      result = me.callback(me.displayValueRenderer, me, [me.selected, me]);
    }

    return result == null ? '' : result;
  }
  /**
   * A {@link Core/util/Collection} which holds the currently selected records
   * from the store which dictates this field's value.
   *
   * Usually, this will contain one record, the record selected.
   *
   * When {@link #config-multiSelect} is `true`, there may be several records selected.
   * @member {Core.util.Collection} valueCollection
   * @readonly
   */


  changeValueCollection(valueCollection, oldValueCollection) {
    oldValueCollection === null || oldValueCollection === void 0 ? void 0 : oldValueCollection.destroy();

    if (valueCollection) {
      if (!valueCollection.isCollection) {
        valueCollection = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_8__["default"]({
          listeners: {
            noChange: 'onValueCollectionNoChange',
            change: 'onValueCollectionChange',
            prio: -1000,
            // The ChipView must react to changes first.
            thisObj: this
          }
        });
      }

      return valueCollection;
    }
  }

  changePrimaryFilter(primaryFilter) {
    if (!(primaryFilter instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_3__["default"])) {
      if (typeof primaryFilter === 'function') {
        primaryFilter = {
          filterBy: primaryFilter
        };
      } // This is the filter that performs filtering on typing.


      primaryFilter = new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_3__["default"](_objectSpread({
        // Need an id to replace any existing combo filter on the store.
        // Dodge pre-commit hook by quoting property:
        'id': 'primary',
        // eslint-disable-line quote-props
        disabled: true,
        property: this.displayField,
        operator: this.filterOperator,
        caseSensitive: this.caseSensitive
      }, primaryFilter));
    }

    return primaryFilter;
  }

  changeStore(store) {
    if (Array.isArray(store)) {
      this.items = store;
      return;
    }

    if (store) {
      if (typeof store === 'string') {
        store = _data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStore(store);
      } else if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].isObject(store)) {
        store = new (store.readUrl ? _data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_1__["default"] : _data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"])(store);
        this.destroyStore = true;
      }

      const me = this,
            remoteFilter = me.remoteFilter || store.restfulFilter,
            {
        filterParamName,
        valueCollection,
        keyStrokeFilterDelay
      } = me,
            storeFilters = [];

      if (remoteFilter && filterParamName) {
        store.filterParamName = filterParamName;

        if (me.encodeFilterParams) {
          store.encodeFilterParams = me.encodeFilterParams;
        }
      } // If no value field provided, read it off of the Store's modelClass
      // Unless we want to use full record as the value


      if (!me.valueField && !me.usingRecordAsValue) {
        me.valueField = store.modelClass.idField;
      }

      storeFilters.push(me.primaryFilter);

      if (remoteFilter) {
        if (me.filterSelected) {
          store.storage.autoFilter = true;
          store.storage.addFilter({
            id: `${me.id}-selected-filter`,
            filterBy: r => !valueCollection.includes(r)
          });
        }
      } else if (me.filterSelected) {
        me.selectedItemsFilter = r => !valueCollection.includes(r);

        storeFilters.push(me.selectedItemsFilter);
        store.reapplyFilterOnAdd = true;
      } // Allow fast lookup in the valueCollection by value or displayed value.
      // We add these now because we are now guaranteed to have inferred
      // displayField and startField from any passed items array items is
      // promoted to a Store.


      valueCollection.addIndex({
        property: me.displayField,
        unique: false
      });
      valueCollection.addIndex({
        property: me.valueField,
        unique: true
      });
      store.filter(storeFilters); // If there's no configured delay, use sensible defaults.
      // AjaxStore, we don't want a network request fired off on every single keystroke.
      // Local store, delay it just a little to save data and DOM churn.

      if (remoteFilter) {
        // We enforce at least a 300ms delay when firing off network requests
        me.keyStrokeFilterDelay = Math.max(300, keyStrokeFilterDelay || 0);
      } else {
        me.keyStrokeFilterDelay = keyStrokeFilterDelay !== null && keyStrokeFilterDelay !== void 0 ? keyStrokeFilterDelay : 10;
      }
    }

    return store;
  }

  updateStore(store, oldStore) {
    const me = this,
          {
      _picker
    } = me;
    let storeListeners;

    if (this.destroyStore && oldStore) {
      oldStore.destroy();
    }

    if (_picker) {
      _picker.store = store;
    } // Allow fast lookup by value or displayed value


    store.storage.addIndex({
      property: me.displayField,
      unique: false
    });
    store.storage.addIndex({
      property: me.valueField,
      unique: true
    });
    storeListeners = {
      filter: 'onStoreFilter'
    };

    if (me.displayValueRenderer) {
      (storeListeners || (storeListeners = {})).change = 'onComboStoreChange';
      me.syncInputFieldValue();
    }

    me.detachListeners('store'); // Make sure we don't hold on to old records when store is changed
    // + update value collection with records from new store

    if (oldStore) {
      const oldValue = me.value;
      me.isConfiguring = true;
      me.value = null;
      me.isConfiguring = false;
      me.value = oldValue;
    }

    if (storeListeners) {
      storeListeners.name = 'store';
      storeListeners.thisObj = me;
      store.on(storeListeners);
    }
  }

  get remoteFilter() {
    var _this$_store;

    // Don't use "this.store" since we need to run during changeStore()
    return Boolean(this.filterParamName || ((_this$_store = this._store) === null || _this$_store === void 0 ? void 0 : _this$_store.restfulFilter));
  }
  /**
   * Get selected record.
   * @property {Core.data.Model[]}
   * @readonly
   */


  get record() {
    return this.selected;
  }
  /**
   * Get the selected record(s).
   * @property {Core.data.Model[]}
   * @readonly
   */


  get records() {
    return this.valueCollection.values.slice();
  }

  get selected() {
    return this.valueCollection.first;
  } //endregion
  //region Value handling

  /**
   * Check if field value is valid
   * @internal
   */


  onEditComplete() {
    const me = this,
          selectionCount = me.valueCollection.count;
    super.onEditComplete(); // Ensure the input area matches the selected value

    if (selectionCount) {
      me.clearError(errorValidateFilter);
      me.syncInputFieldValue();
    }

    if (me.required && !selectionCount) {
      me.setError(errorFieldRequired);
    }
  } //endregion
  //region Events

  /**
   * User clicked trigger icon, toggle list.
   * @private
   */


  onTriggerClick() {
    var _me$triggerAction;

    const me = this; // Bail out if enter key is required to trigger a filter

    if (me.remoteFilter && me.filterOnEnter) {
      return;
    }

    if (me.pickerVisible) {
      me.hidePicker();
    } else {
      if (!me.readOnly && !me.disabled) {
        switch ((_me$triggerAction = me.triggerAction) === null || _me$triggerAction === void 0 ? void 0 : _me$triggerAction.toLowerCase()) {
          case 'all':
            me.doFilter(null);
            break;

          case 'last':
            me.doFilter(me.lastQuery);
            break;

          default:
            me.doFilter(me.input.value);
        }
      }
    }
  }
  /**
   * User types into input field in editable combo, show list and filter it.
   * @private
   */


  internalOnInput(event) {
    const me = this,
          value = me.input.value,
          inputLen = value.length; // IE11 triggers input event on focus for some reason, ignoring it if not editable

    if (!me.editable) {
      return;
    }

    me.syncEmpty();
    me.syncInputWidth();
    me.inputting = true;

    if (me.inlinePicker || inputLen >= me.minChars && !me.filterOnEnter) {
      me.filterList(value);
    } else {
      // During typing, the field is invalid
      if (me.validateFilter && !me.remoteFilter) {
        me[inputLen ? 'setError' : 'clearError'](errorValidateFilter);
      }

      me.hidePicker();
    }

    me.inputting = false;
    /**
     * User typed into the field. Please note that the value attached to this event is the raw input field value and
     * not the combos value
     * @event input
     * @param {Core.widget.Combo} source The combo
     * @param {String} value Raw input value
     */

    me.trigger('input', {
      value,
      event
    });
  }

  syncInputWidth() {
    const me = this;

    if (me.usesChipView) {
      const input = me.input,
            // padding on the input el won't change, so cache the measurement:
      inputPadding = me._inputPadding || (me._inputPadding = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getEdgeSize(input, 'padding', 'lr')),
            value = input.value || '',
            width = // +'W' to avoid text getting clipped or horizontal scrolling
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].measureText(value + 'W', input, false, me.element) + inputPadding.width; // Normally the input is given "flex: 1 1 0px" so it will fill the space
      // so we just need to adjust the flex-basis to ensure the input is at least
      // as long as the text. Since it is also flex-shrink, it will not become
      // any larger than one "row".

      input.style.flex = `1 1 ${Math.ceil(width)}px`;
    }
  } // This is potentially a buffered function to respond to keystrokes in a buffered manner.
  // This only becomes useful as a saving when using remote querying where each filter is an Ajax request.


  filterList(queryString) {
    this.doFilter(queryString);
  }

  doFilter(queryString) {
    var _me$filterPromise;

    const me = this,
          {
      store,
      // Force the lazy config to create picker since the List needs to add its beforeLoad listener
      picker
    } = me,
          disableFilter = queryString == null || queryString === '';
    me.lastQuery = queryString;
    me.primaryFilter.setConfig({
      value: queryString,
      disabled: disableFilter
    });

    if (me.remoteFilter) {
      store.clear(true);
    } // We have the property 'filterPromise' while a filter operation is in flight.


    (_me$filterPromise = me.filterPromise = store.filter()) === null || _me$filterPromise === void 0 ? void 0 : _me$filterPromise.then(() => me.filterPromise = null);

    if (!me.inlinePicker) {
      if (picker !== null && picker !== void 0 && picker.isVisible) {
        // If aligned above, filtering will change its height so will need realigning
        if (picker.lastAlignSpec.zone === 0) {
          picker.realign();
        }
      } else {
        me.showPicker();
      }
    }

    if (store.count) {
      // If we are filtering, activate the first match
      if (!disableFilter) {
        me.picker.navigator.activeItem = 0;
      }
    } // If we were actively *locally* filtering on a string but there were no matches
    // and we are validateFilter: true, then mark as invalid even though we
    // may have an underlying valid selected value.
    else if (!me.remoteFilter && !disableFilter && me.validateFilter) {
      me.setError(errorValidateFilter);
    }
  }

  onStoreFilter({
    source: store
  }) {
    const me = this,
          picker = me._picker,
          dataset = picker === null || picker === void 0 ? void 0 : picker.element.dataset,
          {
      count
    } = store;

    if (me.remoteFilter) {
      // If we are filtering, activate the first match
      if (count) {
        if (picker) {
          picker.navigator.activeItem = 0;
        }
      } // Invalid if no matches after filtering
      else {
        if (me.validateFilter) {
          me.setError(errorValidateFilter);
        }
      } // If we have selection, evict selected items from the newly remote-filtered list


      if (me.filterSelected && me.valueCollection.count) {
        store.storage.onFiltersChanged(); // Store does not react to Collection filtering yet because it does its own filtering and
        // then fires its own event. So we have to refresh the picker to hide the selected items.

        if (picker) {
          picker.refresh();
        }
      }
    } // If createOnUnmatched, we add a hint to add the value


    if (me.createOnUnmatched && !count) {
      dataset.addNewValue = me.L('L{addNewValue}')(me.primaryFilter.value);
    } else {
      dataset === null || dataset === void 0 ? true : delete dataset.addNewValue;
    }
  }
  /**
   * This reacts to our {@link #property-valueCollection} being mutated in any way.
   * The `change`, `select` and `action` events are fired here.
   *
   * This could happen in four ways:
   *
   *  - User selected or deselected an item in the dropdown list.
   *  - `set value` changes the content.
   *  - The {@link #config-multiSelect} Chip view (which uses this in its store) deletes a record.
   *  - The application programmatically mutates the {@link #property-valueCollection}.
   *
   * @private
   */


  onValueCollectionChange({
    source: valueCollection
  }) {
    var _me$hidePickerOnSelec2;

    const me = this,
          {
      multiSelect,
      _picker
    } = me,
          hidePicker = (_me$hidePickerOnSelec2 = me.hidePickerOnSelect) !== null && _me$hidePickerOnSelec2 !== void 0 ? _me$hidePickerOnSelec2 : !multiSelect,
          record = multiSelect ? valueCollection.values.slice() : valueCollection.first,
          records = valueCollection.values.slice(),
          isUserAction = me._isUserAction || (_picker === null || _picker === void 0 ? void 0 : _picker._isUserAction) || hidePicker && me.pickerVisible || false,
          oldValue = me._value;

    if (hidePicker) {
      me.hidePicker();
    }

    if (!valueCollection.count && me.required) {
      me.setError(errorFieldRequired);
    } else {
      me.clearError(errorFieldRequired);
      me.clearError(errorValidateFilter);
    }

    if (me.validateFilter && record) {
      me.clearError(errorValidateFilter);
    } // Re-evaluate *local* filtering so that selected items are filtered out of the dropdown.
    // For remote filtering, we programmatically add a filter to the store's storage


    if (me.filterSelected) {
      if (me.remoteFilter) {
        me.store.storage.onFiltersChanged(); // Store does not react to Collection filtering yet because it does its own filtering and
        // then fires its own event. So we have to refresh the picker to hide the selected items.

        if (me._picker) {
          me._picker.refresh();
        }
      } else {
        me.store.filter();
      }
    } // Clear the cached value so that there's no fallback when we read back the value below


    me._value = null;
    me._lastValue = null; // Cache the value for use by our change handler next time, and also so that
    // if we just cleared the valueCollection, the fallback to ._value will be correct

    const value = me.cacheCurrentValue(me.value);
    me.syncInputFieldValue();
    me.syncEmpty();

    if (!me.isConfiguring) {
      me.triggerFieldChange({
        value,
        oldValue,
        userAction: isUserAction,
        valid: me.isValid
      });
      /**
       * An item in the list was selected
       * @event select
       * @param {Core.widget.Combo} source The combo
       * @param {Core.data.Model} record Selected record
       * @param {Core.data.Model[]} records Selected records as an array if {@link #config-multiSelect} is `true`
       * @param {Boolean} userAction `true` if the value change is due to user interaction.
       */

      me.trigger('select', {
        record,
        records,
        userAction: isUserAction
      });
      /**
       * Th default action was performed (an item in the list was selected)
       * @event action
       * @param {Core.widget.Combo} source The combo
       * @param {*} value The {@link #config-valueField value} of the selected record
       * @param {Core.data.Model} record Selected record
       * @param {Core.data.Model[]} records Selected records as an array if {@link #config-multiSelect} is `true`
       * @param {Boolean} userAction `true` if the value change is due to user interaction.
       */

      if (me.defaultAction === 'select') {
        me.trigger('action', {
          value,
          record,
          records,
          userAction: isUserAction
        });
      }
    }
  } // Caching a copy of current value, which can be changed by subclasses (see AssignmentField for reference)


  cacheCurrentValue(v) {
    return this._value = v;
  }
  /**
   * This listens for when a record from the list is selected, but is already part of
   * the selection and so the {@link #property-valueCollection} rejects that as a no-op.
   * At this point, the user will still expect the picker to hide.
   * @param {Object} event The noChange event containing the splice parameters
   * @private
   */


  onValueCollectionNoChange({
    toAdd
  }) {
    if (!this.inlinePicker && !this.multiSelect && toAdd.length && this.pickerVisible) {
      this.picker.hide();
    }
  } //endregion
  //region Picker


  showPicker() {
    const me = this,
          {
      picker
    } = me;

    if (me.readOnly || me.inlinePicker) {
      return;
    }

    picker.multiSelect = me.multiSelect;
    super.showPicker(); // Once we have access to the anchor size, overlay the anchor pointer over the target if configured to do so.

    if (me.overlayAnchor && !picker.align.offset) {
      picker.align.offset = -picker.anchorSize[1];
      picker.realign();
    } // Activate and make visible the *single* selected item.
    // Not valid if multiselect because the user's interest will not be focused on any one item.


    if (!me.multiSelect && me.selected) {
      picker.restoreActiveItem(me.selected, true);
    }

    me.input.focus();
  }
  /**
   * Creates default picker widget
   *
   * @internal
   */


  changePicker(picker, oldPicker) {
    var _picker2;

    const me = this,
          pickerWidth = me.pickerWidth || ((_picker2 = picker) === null || _picker2 === void 0 ? void 0 : _picker2.width),
          config = _List_js__WEBPACK_IMPORTED_MODULE_13__["default"].mergeConfigs({
      owner: me,
      store: me.store,
      selected: me.valueCollection,
      multiSelect: me.multiSelect,
      cls: me.listCls,
      displayField: me.displayField,
      forElement: me[me.pickerAlignElement],
      align: {
        matchSize: pickerWidth == null,
        anchor: me.overlayAnchor,
        target: me[me.pickerAlignElement],
        // Reasonable minimal height to fit few combo items below the combo.
        // When height is not enough, list will appear on top. That works for windows higher than 280px,
        // worrying about shorter windows sounds overkill.
        // We cannot use relative measures here, each combo list item is ~40px high
        minHeight: me.inlinePicker ? null : Math.min(3, me.store.count) * 40
      },
      [me.listItemTpl ? 'itemTpl' : undefined]: me.listItemTpl,
      width: pickerWidth,
      navigator: {
        keyEventTarget: me.input
      }
    }, picker);

    if (me.inlinePicker) {
      Object.assign(config, {
        floating: false,
        align: null,
        activateOnMouseover: false,
        maxHeight: null,
        appendTo: me.element
      });
    }

    picker = _List_js__WEBPACK_IMPORTED_MODULE_13__["default"].reconfigure(oldPicker, picker ? config : null, me);

    if (picker) {
      picker.element.classList.add('b-combo-picker');
      picker.element.dataset.emptyText = me.emptyText || me.L('L{noResults}'); // We have to handle the click on "Add new value" when createOnUnmatched is set
      // because it's not a real list item, it's a repurposing of the .b-empty:after pseudo el.

      picker.on({
        navigate: 'onPickerNavigate',
        thisObj: me
      });
    }

    return picker;
  }

  onPickerNavigate({
    event
  }) {
    // It's a click on the "Add new value" prompt
    if (event.target.matches('[data-add-new-value]')) {
      this.addNewRecord(this.primaryFilter.value);
    }
  }

  onPickerHide() {
    const me = this;
    super.onPickerHide(); // https://app.assembla.com/spaces/bryntum/tickets/7736

    if (me.multiSelect && me.clearTextOnPickerHide) {
      me.input.value = '';
    }
  } //endregion


  async internalOnKeyEvent(keyEvent) {
    const me = this,
          value = me.input.value,
          inputLen = value.length,
          {
      key
    } = keyEvent,
          {
      store,
      _picker: picker,
      multiSelect
    } = me; // Typing the multiValueSeparator character selects the active list item, or
    // if there is no active item, and we are creating new records, creates the selected item.
    // The picker may not be a List with a Navigator.
    // We can only honour this functionality for normal, unoverridden List Pickers.
    // Some subclasses use Grids as pickers.

    if (keyEvent.type === 'keydown' && picker !== null && picker !== void 0 && picker.isVisible && picker.navigator) {
      const {
        activeItem
      } = picker.navigator; // If they type `,` in a multiSelect, it means add the active matched item if any

      if (activeItem && multiSelect && key === me.multiValueSeparator) {
        me.input.value = '';
        me.primaryFilter.setConfig({
          value: '',
          disabled: true
        });
        store.filter();
        picker.onItemClick(activeItem, keyEvent);
        picker.hide();
        keyEvent.preventDefault();
        return;
      } // Else, if there's no matched item and we are creating new records for unmatched keys
      // then `,` and Enter add a new record with the string as the displayField


      if (!activeItem && me.createOnUnmatched && (multiSelect && key === me.multiValueSeparator || key === 'Enter')) {
        keyEvent.preventDefault();
        await me.addNewRecord(value);
        return;
      }
    }

    super.internalOnKeyEvent(...arguments);

    if (keyEvent.type === 'keydown' && key === 'Enter' && me.filterOnEnter && inputLen >= me.minChars) {
      keyEvent.stopPropagation();
      me.filterList(value);
    }
  }

  async addNewRecord(value) {
    const me = this,
          {
      store,
      _picker: picker,
      valueCollection,
      multiSelect,
      primaryFilter
    } = me,
          remoteAutoCommit = store.remoteFilter && store.autoCommit; // We have to wait for remote filtering to finish before we add a new record to the added Bag
    // because store load (filter is a load) clears added records, and if the load returned during
    // the create commit that would invalidate the upcoming create return values by leaving no added
    // records to update with correct new IDs, and so the new record would appear to still
    // be a phantom, and therefore we would throw an error that the server has not accepted the addition..

    if (me.filterPromise) {
      await me.filterPromise;
    } // We can do this early if it's *NOT* a remote filtered, auto-committing AjaxStore.
    // If remote filtered and autoCommit, this will instigate a load which cannot be
    // concurrent with the upcoming auto commit.


    if (!remoteAutoCommit) {
      primaryFilter.setConfig({
        value: '',
        disabled: true
      });
      store.filter();
    }

    const [newRecord] = store.add(me.callback(me.createOnUnmatched, me, [value])); // It's an AjaxStore which is autoCommitting the new record to its createUrl
    // We wait to see if it's successful.

    if (store.isCommitting) {
      let error;

      try {
        await store.commitPromise;
      } catch (exception) {
        var _exception$response, _exception$response$p;

        error = (_exception$response = exception.response) === null || _exception$response === void 0 ? void 0 : (_exception$response$p = _exception$response.parsedJson) === null || _exception$response$p === void 0 ? void 0 : _exception$response$p.error;
      } // If the sync from the server did not return a concrete id, the record gets
      // left as phantom, so we have to remove it.


      if (newRecord.isPhantom) {
        me.clearError();
        me.setError(error || errorRecordNotCommitted, false, true);
        store.remove(newRecord); // AjaxStore adds to its removed Bag here because it clears down the addded Bag even
        // if not all added records were successfully synced, and remove adds to removed Bag
        // if the  record is *not* in the added Bag.

        store.removed.remove(newRecord);
      }
    } // Have to wait until now if its a remote filtered, auto-committing AjaxStore.


    if (remoteAutoCommit) {
      primaryFilter.setConfig({
        value: '',
        disabled: true
      });
      store.filter();
    }

    me.input.value = ''; // If an AjaxStore's sync of the add failed, do not select the new record

    if (store.includes(newRecord)) {
      // Append for multiSelect, or replace for non-multiSelect
      valueCollection.splice(multiSelect ? valueCollection.count : 0, multiSelect ? 0 : valueCollection.count, newRecord);
    }

    picker === null || picker === void 0 ? void 0 : picker.hide();
  }

  changeCreateOnUnmatched(createOnUnmatched) {
    if (createOnUnmatched === true) {
      createOnUnmatched = this.defaultRecordCreater;
    }

    return createOnUnmatched;
  }

  defaultRecordCreater(value) {
    return this.store.createRecord({
      [this.displayField]: value
    });
  }

}

class ComboChipView extends _ChipView_js__WEBPACK_IMPORTED_MODULE_5__["default"] {
  static get $name() {
    return 'ComboChipView';
  }

  static get type() {
    return 'combochipview';
  }

  static get defaultConfig() {
    return {
      closeHandler: 'up.onChipClose',
      itemsFocusable: false,
      multiSelect: true,

      itemTpl(record) {
        return _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].encodeHtml(record[this.owner.displayField]);
      },

      scrollable: {
        overflowY: 'auto'
      }
    };
  }

}

class ComboChipNavigator extends _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_12__["default"] {
  static get defaultConfig() {
    return {
      allowShiftKey: true
    };
  }

  onTargetClick(clickEvent) {
    const me = this,
          item = clickEvent.target.closest(me.itemSelector);

    if (item && !clickEvent.shiftKey && !item.contains(clickEvent.target.closest('[data-noselect]'))) {
      me.ownerCmp.selected.clear();
    } // Our own updateActiveItem also selects because on superclass *key* navigation
    // (which is async on scroll end), it sets activeItem, and we select at that time.
    // So set a flag which disables this.


    me.inClickHandler = true;
    me.activeItem = item;
    me.inClickHandler = false;
  }

  onKeyDown(keyEvent) {
    // ENTER does not toggle selectedness in a ChipView.
    // ChipView's selection is bound to navigation.
    if (keyEvent.key !== 'Enter') {
      super.onKeyDown(keyEvent);
    }
  }

  updateActiveItem(activeItem, oldActiveItem) {
    const chipView = this.ownerCmp;
    super.updateActiveItem(activeItem, oldActiveItem); // Selection simply follows navigation in a ChipView

    if (activeItem && !this.inClickHandler) {
      chipView.selected.add(chipView.getRecord(activeItem));
    }
  }

  navigatePrevious(keyEvent) {
    const chipView = this.ownerCmp;

    if (chipView.navigator.activeItem && !keyEvent.shiftKey) {
      chipView.selected.clear();
    }

    if (this.previous) {
      super.navigatePrevious(keyEvent);
    } else {
      this.activeItem = null;
    }
  }

  navigateNext(keyEvent) {
    const chipView = this.ownerCmp; // SHIFT+navigate preserves selection

    if (chipView.navigator.activeItem && !keyEvent.shiftKey) {
      chipView.selected.clear();
    }

    if (this.next) {
      super.navigateNext(keyEvent);
    } else {
      this.activeItem = null;
    }
  }

} // Register this widget type with its Factory


Combo.initClass();
ComboChipView.initClass();
Combo._$name = 'Combo';

/***/ }),

/***/ "./lib/Core/widget/Container.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/Container.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Container; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _layout_Layout_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./layout/Layout.js */ "./lib/Core/widget/layout/Layout.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _Ripple_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Ripple.js */ "./lib/Core/widget/Ripple.js");
/* harmony import */ var _util_Bag_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../util/Bag.js */ "./lib/Core/util/Bag.js");
var productName = 'taskboard';








/**
 * @module Core/widget/Container
 */

const emptyObject = Object.freeze({}),
      {
  isArray
} = Array,
      returnWeight = i => i.weight,
      // Allowing string weights (used by subgrids for backwards compatibility)
sortByWeight = ({
  weight: a
}, {
  weight: b
}) => {
  if (typeof a === 'string' || typeof b === 'string') {
    return String(a).localeCompare(String(b));
  } // Items without weight sort last


  return (a !== null && a !== void 0 ? a : Number.MAX_SAFE_INTEGER) - (b !== null && b !== void 0 ? b : Number.MAX_SAFE_INTEGER);
},
      isNotHidden = w => w && !w.hidden,
      stylesToCheck = ['display', 'flex-direction'];
/**
 * Widget that can contain other widgets. Layout is flexbox by default, see the {@link #config-layout} config.
 *
 * ```javascript
 * // create a container with two widgets
 * let container = new Container({
 *     items : [
 *         { type : 'text', label : 'Name' },
 *         { type : 'number', label : 'Score' }
 *     ]
 * });
 * ```
 *
 * Containers can have child widgets added, or removed during their lifecycle to accommodate business needs.
 *
 * For example:
 *
 *  ```javascript
 *  myTaskPopup.on({
 *      beforeShow() {
 *          if (task.type === task.MASTER) {
 *              // Insert the childTask multiselect before the masterTask field
 *              myPopup.insert(childTaskMultiselect, masterTaskField)
 *
 *              // We don't need this for master tasks
 *              myPopup.remove(masterTaskField);
 *          }
 *          else {
 *              // Insert the masterTask combo before the childTask multiselect
 *              myPopup.insert(masterTaskField, childTaskMultiselect)
 *
 *              // We don't need this for child tasks
 *              myPopup.remove(childTaskMultiselect);
 *          }
 *      }
 *  });
 * ```
 *
 * @extends Core/widget/Widget
 * @classType container
 * @inlineexample Core/widget/Container.js
 */


class Container extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Container';
  } // Factoryable type name


  static get type() {
    return 'container';
  }

  static get configurable() {
    return {
      /**
       * An object containing typed child widget config objects or Widgets. May also be specified
       * as an array.
       *
       * If configured as an Object, the property names are used as the child component's
       * {@link Core.widget.Widget#config-ref ref} name, and the value is the child component's config object.
       *
       * ```javascript
       *
       *  class MyContainer extends Container {
       *      static get configurable() {
       *          return {
       *              items : {
       *                  details : {
       *                      type : 'panel',
       *                      ....
       *                  },
       *                  button : {
       *                      type : 'button',
       *                      text : 'Save'
       *                  }
       *              }
       *          }
       *      }
       *  }
       *
       *  new MyContainer({
       *      title    : 'Test Container',
       *      floating : true,
       *      centered : true,
       *      width    : 600,
       *      height   : 400,
       *      layout   : 'fit',
       *      items    : {
       *          button : {
       *              disabled : true
       *          },
       *          details : {
       *              title : 'More coolness',
       *              html  : 'Details content'
       *      }
       *  }).show();
       * ```
       *
       * The order of the child widgets is determined by the order they are defined in `items`, but can also be
       * affected by configuring a {@link Core.widget.Widget#config-weight} on one or more widgets.
       *
       * If you want to customize child items of an existing class, you can do this using the child widget
       * 'ref' identifier (useful for reconfiguring Event Editor in Scheduler / Gantt):
       *
       * ```javascript
       *  new MyCustomTabPanel({
       *      items    : {
       *          // Reconfigure tabs
       *          firstTab : {
       *              title : 'My custom title'
       *          },
       *          secretTab : null // hide this tab
       *      }
       *  }).show();
       * ```
       *
       * @config {Object|Object[]|Core.widget.Widget[]}
       * @category Content
       */
      items: null,

      /**
       * An array of {@link #config-items child item} _config objects_ which is to be converted into
       * instances only when this Container is rendered, rather than eagerly at construct time.
       *
       * _This is mutually exclusive with the {@link #config-items} config._
       *
       * @config {Object|Object[]|Core.widget.Widget[]}
       * @category Content
       */
      lazyItems: {
        $config: ['lazy'],
        value: null
      },

      /**
       * A config object containing default settings to apply to all child widgets.
       * @config {Object}
       * @category Content
       */
      defaults: null,
      defaultType: 'widget',

      /**
       * The CSS style properties to apply to the {@link Core.widget.Widget#property-contentElement}.
       *
       * By default, a Container's {@link Core.widget.Widget#property-contentElement} uses flexbox layout, so this
       * config may contain the following properties:
       *
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction">flexDirection</a> default '`row`'
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-wrap">flexWrap</a>
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-flow">flexFlow</a>
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content">justifyContent</a>
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-items">alignItems</a>
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-content">alignContent</a>
       * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/place-content">placeContent</a>
       * @config {Object}
       * @category Layout
       */
      layoutStyle: null,

      /**
       * An optional CSS class to add to child items of this container.
       * @config {String}
       * @category CSS
       */
      itemCls: null,

      /**
       * The {@link #config-layout} as an instance of {@link Core.widget.layout.Layout}.
       * This is a helper class which adds and removes child widgets to this Container's
       * DOM and applies CSS classes based upon its requirements.
       *
       * The {@link Core.widget.layout.Card card} layout provides for showing one child
       * widget at a time, and provides a switching API to change which child widget is
       * currently active.
       * @member {Core.widget.layout.Layout} layout
       */

      /**
       * The short name of a helper class which manages rendering and styling of child items.
       *
       * Or a config object which includes a `type` property which specifies which type
       * of layout to use, and how to configure that layout.
       *
       * By default, the only special processing that is applied is that the Container class's
       * {@link #config-itemCls} is added to child items.
       *
       * Containers use CSS flexbox in its default configuration to arrange child items. You may either use the
       * {@link #config-layoutStyle} configuration to tune how child items are layed out, or use one of the built
       * in helper classes which include:
       *
       *  - `fit` A single child item is displayed fitting exactly into the
       *  {@link Core.widget.Widget#property-contentElement}.
       *  - `card` Child items are displayed one at a time, size to fit the
       *  {@link Core.widget.Widget#property-contentElement} and are slid in from the side when activated.
       *  - `box` Child items are layed out using flexbox.
       *
       * For example:
       * ```javascript
       * {
       *     id     : 'myContainer',
       *     // Our child items flow downwards and are stretched to fill our width
       *     layout : {
       *         type       : 'box',
       *         direction  : 'column'
       *         align      : 'stretch'
       *     }
       * }
       * @config {String|Object}
       * @category Layout
       */
      layout: {
        type: 'default'
      },
      // TODO: deprecate namedItems, use items instead

      /**
       * An object containing named config objects which may be referenced by name in any {@link #config-items}
       * object. For example, a specialized {@link Core.widget.Menu Menu} subclass may have a `namedItems` default
       * value defined like this:
       *
       * ```javascript
       *  namedItems : {
       *      removeRow : {
       *          text : 'Remove row',
       *          onItem() {
       *              this.ownerGrid.remove(this.ownerGrid.selectedRecord);
       *          }
       *      }
       *  }
       * ```
       *
       * Then whenever that subclass is instantiated and configured with an {@link #config-items} object, the
       * items may be configured like this:
       *
       * ```javascript
       *  items : {
       *      removeRow : true,   // The referenced namedItem will be applied to this
       *      otherItemRef : {
       *          text : 'Option 2',
       *          onItem() {
       *          }
       *      }
       * }
       * ```
       * @config {Object}
       * @category Content
       */
      namedItems: null,

      /**
       * When set to `true`, this widget is considered as a whole when processing {@link Core.widget.Toolbar}
       * overflow. When `false`, this widget's child items are considered instead.
       * @config {Boolean}
       * @default false
       * @category Layout
       * @internal
       */
      overflowable: {
        value: null,
        default: false,
        $config: null
      },

      /**
       * Specify `true` for a container used to show text markup. It will apply the CSS class `b-text-content`
       * which specifies a default max-width that makes long text more readable.
       *
       * This CSS class is automatically removed if the container adds/defines child Widgets.
       * @config {Boolean}
       * @default
       * @category Content
       */
      textContent: true,

      /**
       * Record whose values will be used to populate fields in the container.
       * @config {Object}
       * @internal
       */
      record: null,
      // NOTE: internal since record is not documented

      /**
       * Update assigned {@link #config-record} automatically on field changes
       * @config {Boolean}
       * @internal
       */
      autoUpdateRecord: null,

      /**
       * Specify `true` to make this container hide when it has no visible children (Either empty
       * or all children hidden).
       *
       * Container will show itself when there are visible children, ie: hidden children are
       * shown, or new visible children are added.
       * @config {Boolean}
       * @default
       * @category Layout
       */
      hideWhenEmpty: null,
      contentElMutationObserver: {
        $config: ['lazy', 'nullify'],
        value: true
      },

      /**
       * Specify `true` to isolate record changes to this container and its ancestors. Prevents record
       * updates from propagating up from here and also prevents record updates from parent from
       * propagating down to us.
       *
       * @config {Boolean}
       * @default false
       * @internal
       */
      isolateFields: false
    };
  }

  static get prototypeProperties() {
    return {
      /**
       * @member {Boolean} initialItems
       * This property is `true` until the container's initial `items` config has been processed. This property
       * is set to `false` by the `updateItems` method.
       * @readonly
       * @internal
       */
      initialItems: true
    };
  }
  /**
   * Sets multiple flexbox settings which affect how child widgets are arranged.
   *
   * By default, Containers use flexbox layout, so this property may contain the following properties:
   *
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction">flexDirection</a> default '`row`'
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-wrap">flexWrap</a>
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-flow">flexFlow</a>
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content">justifyContent</a>
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-items">alignItems</a>
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-content">alignContent</a>
   * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/place-content">placeContent</a>
   * @member {Object} layoutStyle
   * @category Layout
   */

  /**
   * The {@link Core.data.Model record} to be applied to the fields contained in this Container. Any descendant
   * widgets of this Container with a `name` property will have its value set to the value of that named property of
   * the record. If no record is passed, the widget has its value set to `null`.
   * @member {Core.data.Model} record
   */


  startConfigure(config) {
    // Set a flag so that code can test for presence of items.
    // Widgets which render child widgets outside of the Container scheme
    // can set this flag (eg Panels with tools and tbar).
    const items = config.items || config.lazyItems;

    if (!(this.hasItems = Boolean(items && (isArray(items) ? items : Object.keys(items)).length))) {
      this.initialItems = false; // we won't be running updateItems, so clear this flag now
    }

    super.startConfigure(config);
  }
  /**
   * Removes the passed child/children from this Container.
   * @param  {...Core.widget.Widget} toRemove The child or children to remove.
   * @returns {Core.widget.Widget|Core.widget.Widget[]} All the removed items. An array if multiple items
   * were removed, otherwise, just the item removed.
   */


  remove(...toRemove) {
    let returnArray = true;

    if (toRemove.length === 1) {
      if (isArray(toRemove[0])) {
        toRemove = toRemove[0];
      } else {
        returnArray = false;
      }
    }

    const me = this,
          {
      _items
    } = me,
          result = [];

    for (let i = 0; i < toRemove.length; i++) {
      const childToRemove = toRemove[i];

      if (_items.includes(childToRemove)) {
        _items.remove(childToRemove);

        me.layout.removeChild(childToRemove);
        result.push(childToRemove);
        me.onChildRemove(childToRemove);
      }
    }

    return returnArray ? result : result[0];
  }
  /**
   * Removes all children from this Container.
   * @returns {Core.widget.Widget[]} All the removed items.
   */


  removeAll() {
    return this.remove(this.items);
  }
  /**
   * Appends the passed widget / widgets or config(s) describing widgets to this Container.
   *
   * If the widgets specify a `weight`, they are inserted at the correct index compared to the existing items weights.
   *
   * @param {Object|Object[]|Core.widget.Widget|Core.widget.Widget[]} toAdd The child or children instances (or config objects) to add.
   * @returns {Core.widget.Widget|Core.widget.Widget[]} All the added widgets. An array if multiple items
   * were added, otherwise just the item added.
   */


  add(...toAdd) {
    const me = this,
          result = [];
    let {
      _items
    } = me,
        returnArray = true,
        childToAdd,
        i,
        index;

    if (toAdd.length === 1) {
      if (isArray(toAdd[0])) {
        toAdd = toAdd[0];
      } else {
        returnArray = false;
      }
    } // Force creation of our items Bag


    if (!_items) {
      me.items = [];
      _items = me._items;
    }

    for (i = 0; i < toAdd.length; i++) {
      var _childToAdd;

      childToAdd = toAdd[i]; // Items with weight are inserted at correct index

      if (((_childToAdd = childToAdd) === null || _childToAdd === void 0 ? void 0 : _childToAdd.weight) != null) {
        // Cannot use cached _items, weights might be unordered in set being added
        index = _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].findInsertionIndex(childToAdd, _items.values, sortByWeight);
        result.push(me.insert(childToAdd, index));
      } // Those without are appended
      else if (childToAdd) {
        if (childToAdd.isWidget) {
          childToAdd.parent = me;
        } else {
          childToAdd = me.createWidget(childToAdd);
        }

        if (!_items.includes(childToAdd)) {
          _items.add(childToAdd);

          me.onChildAdd(childToAdd);
          me.layout.appendChild(childToAdd);
          result.push(childToAdd);
        }
      }
    }

    return returnArray ? result : result[0];
  }
  /**
   * Inserts the passed widget into this Container at the specified position.
   * @param  {Core.widget.Widget} toAdd The child to insert.
   * @param {Number|Core.widget.Widget} index The index to insert at or the existing child to insert before.
   * @returns {Core.widget.Widget} The added widget.
   */


  insert(toAdd, index) {
    // Force creation of our items Bag
    if (!this.items) {
      this.items = [];
    }

    const me = this,
          {
      _items
    } = me;

    if (toAdd instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
      toAdd.parent = me;
    } else {
      toAdd = me.createWidget(toAdd);
    }

    if (_items.includes(index)) {
      index = me.indexOfChild(index);
    }

    index = Math.min(index, _items.count);
    const newValues = _items.values;
    newValues.splice(index, 0, toAdd);
    _items.values = newValues; // Register inserted item

    me.onChildAdd(toAdd);
    me.layout.insertChild(toAdd, index);
    return toAdd;
  }

  indexOfChild(child) {
    return this.items.indexOf(child);
  }

  changeLazyItems(lazyItems) {
    this.items = lazyItems;
    this.layout.renderChildren();
  }

  changeItems(items, oldItems) {
    const me = this,
          newItems = [],
          result = new _util_Bag_js__WEBPACK_IMPORTED_MODULE_7__["default"]();

    if (isArray(items)) {
      me.processItemsArray(items, newItems);
    } else if (items) {
      me.processItemsObject(items, me.namedItems, newItems);
    } // Allow child items to have a weight to establish their order


    if (newItems.some(returnWeight)) {
      newItems.sort(sortByWeight);
    }

    result.add(newItems); // Remove previous child payload if any

    if (oldItems) {
      oldItems.forEach(w => {
        me.remove(w); // Destroy outgoing-only widgets which we created.

        if (!result.includes(w) && w._createdBy === me) {
          w.destroy();
        }
      });
    }

    return result;
  }

  updateItems(items, oldItems) {
    let index = 0;
    items.forEach(item => {
      // no "index" argument from Bag
      this.onChildAdd(item); // If this is *change* to items from actual old items, when the old items is not a placeholder inserted
      // from very early items access

      if (oldItems && !oldItems.temporary) {
        this.layout.insertChild(item, index);
      }

      ++index;
    });
    this.initialItems = false;
  }

  updateHideWhenEmpty() {
    this.syncChildCount(this.rendered);
  }
  /**
   * A property, which, when *read*, yields an array of the child items of this container in rendered order.
   *
   * This property may also be *set* to change the child items of the container. Just as in the
   * {@link #config-items initial items configuration}, the new value may either be an array of
   * Widgets/Widget configs or an object.
   *
   * If specified as an Object, the property names are used as the child Widget's
   * {@link Core.widget.Widget#config-ref ref} name, and the value is the child Widget/Widget config.
   *
   * When setting this, any items which are *only* in the outgoing child items which were created
   * by this container from raw config objects are destroyed.
   *
   * Usage patterns:
   *
   * ```javascript
   * myContainer.items = {
   *     name : {
   *         type  : 'textfield',
   *         label : 'User name'
   *     },
   *     age : {
   *         type  : 'numberfield',
   *         label : 'User age'
   *     }
   * };
   * ```
   *
   * or
   *
   * ```javascript
   * myContainer.items = [{
   *     ref   : 'name',
   *     type  : 'textfield',
   *     label : 'User name'
   * },
   *     ref   : 'age',
   *     type  : 'numberfield',
   *     label : 'User age'
   * }];
   * ```
   * @property {Core.widget.Widget[]}
   * @accepts {Core.widget.Widget[]|Object}
   */


  get items() {
    const me = this; // If we are being asked for items, ingest lazyItems.

    me.getConfig('lazyItems'); // The documented API for items is an Array.
    // Internal code should access _items

    if (!me._items) {
      // Currently initializing items, flag set by the config system
      if (me.initializingItems) {
        // This is a created array. User may mutate it.
        return [];
      } // Accessing items very early, not set up yet. Need a placeholder


      me._items = new _util_Bag_js__WEBPACK_IMPORTED_MODULE_7__["default"]();
      me._items.temporary = true;
    } // This is the Collection's array. User may not mutate it.


    return me._items.values;
  }

  processItemsArray(items, result) {
    const len = items.length;
    let i, item;

    for (i = 0; i < len; i++) {
      item = items[i];

      if (item instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
        item.parent = this;
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].removeClasses(item.element, _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].outerCls);
      } else {
        item = this.createWidget(item);
      } // If the widget creation function returns null, nothing to add


      if (item) {
        if (item.ref || item.id) {
          // Add early to widgetMap, to allow using 'up.widgetMap.ref' in later siblings configs
          this.addDescendant(item);
        }

        result.push(item);
      }
    }
  }

  processItemsObject(items, namedItems, result) {
    let item, ref;

    for (ref in items) {
      item = items[ref]; // It might come in as itemRef : false

      if (item) {
        // If this class or instance has a "namedItems" object
        // named by this ref, then use it as the basis for the item
        if (namedItems && ref in namedItems) {
          item = typeof item === 'object' ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(namedItems[ref]), item) : namedItems[ref];
        } // Allow namedItems to be overridden with itemKey : false to indicate unavailability of an item


        if (item) {
          if (item instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
            item.parent = this;
          } else {
            if (item instanceof Object) {
              item.ref = ref;
            }

            item = this.createWidget(item);
          } // If the widget creation function returns null, nothing to add


          if (item) {
            item.ref = ref; // Add early to widgetMap, to allow later siblings to use 'up.'

            this.addDescendant(item);
            result.push(item);
          }
        }
      }
    }
  }

  onChildAdd(item) {
    // Don't just assign the property across since the default value is undefined
    // which means false. Only set to true if we are readOnly
    if (item.innerItem && this.readOnly) {
      item.readOnly = true;
    }

    this.onChildAddLayout(item);

    if (item.ref || item.id) {
      for (let current = this; current; current = current.parent) {
        // Silently add the descendant to the ancestor's widgetMap without kicking off
        // the ancestor's items processing by directly accessing the widgetMap property.
        current.addDescendant(item);
      }
    }

    this.syncChildCount(true);
  }

  onChildAddLayout(item) {
    // Set innerItem=false on an item that should not be managed by the layout...
    if (item.innerItem) {
      // Keep layout informed of child item state
      this.layout.onChildAdd(item);
    }
  }

  onChildHide() {
    this.syncChildCount(true);
  }

  onChildShow() {
    this.syncChildCount(true);
  }

  syncChildCount(enforceHideWhenEmpty) {
    // If called during configuration, the element may not be available because
    // some non-item widgets (eg, Tools) instantiate and declare themselves through
    // onChildAdd before the element is set.
    // But also there may be no items because of     lazyItems.
    // So do the initial sync at render time.
    if (!this.isConfiguring) {
      const me = this,
            {
        childItems,
        hasItems
      } = me,
            {
        length
      } = childItems,
            visibleItems = childItems.filter(isNotHidden),
            {
        length: visibleLength
      } = visibleItems; // Do not toggle visibility on render - we're just here to sync class names.
      // hiding and showing must only depend upon children being dynamically
      // hidden or shown.

      if (me.hideWhenEmpty && enforceHideWhenEmpty) {
        const shouldHide = Boolean(!visibleLength);

        if (Boolean(me._hidden) !== shouldHide) {
          me.hidden = shouldHide;
        }
      }

      for (let i = 0; i < length; i++) {
        childItems[i].element.classList.remove('b-last-visible-child');
        childItems[i].element.classList.remove('b-first-visible-child');
      }

      if (visibleLength) {
        visibleItems[0].element.classList.add('b-first-visible-child');
        visibleItems[visibleLength - 1].element.classList.add('b-last-visible-child');
      } // Keep hasItems property up to date. It's used by the isFocusable getter.


      me.hasItems = Boolean(length);
      me.contentElement.classList[visibleLength ? 'remove' : 'add']('b-no-visible-children'); // Reevaluate whether we should have the b-text-content class

      if (!me.isComposable) {
        me.updateTextContent(me._textContent);
      } else if (hasItems !== me.hasItems) {
        me.recompose();
      }
    }
  }

  syncFlexDirection() {
    const me = this,
          {
      contentElement
    } = me,
          classList = new _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_5__["default"](contentElement.className),
          styles = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(contentElement, stylesToCheck); // We might not be flexing at all any more.

    classList['b-flex-row'] = classList['b-flex-column'] = 0; // If we are, add a flag class to indicate direction

    if (styles.display === 'flex') {
      classList[`b-flex-${styles['flex-direction']}`] = 1;
    } // Will only mutate the DOM if there are changes to apply.
    // We don't want to cause an infinite loop through our MutationObserver.


    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].syncClassList(contentElement, classList);
  }

  addDescendant(item) {
    const ref = item.ref || item.id,
          widgetMap = this._widgetMap || (this._widgetMap = {});

    if (!widgetMap[ref]) {
      widgetMap[ref] = item;
    }
  }

  onChildRemove(item) {
    const ref = item.ref || item.id;

    if (ref) {
      for (let current = this; current; current = current.parent) {
        if (current.widgetMap[ref] === item) {
          delete current.widgetMap[ref];
        }
      }
    } // Keep layout informed of child item state


    this.layout.onChildRemove(item);
    this.syncChildCount(true);
  }
  /**
   * An object which contains a map of descendant widgets keyed by their {@link Core.widget.Widget#config-ref ref}.
   * All descendant widgets will be available in the `widgetMap`.
   * @property {Object}
   * @readonly
   * @category Content
   */


  get widgetMap() {
    if (!this._widgetMap) {
      this._widgetMap = {};
    } // Force evaluation of the configured items by the getter
    // so that configs are promoted to widgets and the widgetMap
    // is created, and if there are widgets, populated.


    if (!this.initializingItems) {
      this.getConfig('items');
    }

    return this._widgetMap;
  }

  changeRecord(record) {
    // The config system's non-change vetoing must be bypassed.
    // The record might have changed, or the destination fields may be out of sync.
    this._record = record == null ? emptyObject : null;
    return record;
  }

  updateRecord(record) {
    /**
     * Fired before this container will load record values into its child fields. This is useful if you
     * want to modify the UI before data is loaded (e.g. set some input field to be readonly)
     * @event beforeSetRecord
     * @param {Core.widget.Container} source The container
     * @param {Core.data.Model} record The record
     */
    this.trigger('beforeSetRecord', {
      record
    });
    this.setValues(record, true, !this.$highlight);
  }

  setRecord(record, highlightChanges) {
    this.$highlight = highlightChanges;
    this.record = record;
    this.$highlight = false;
  }
  /**
   * A function called by descendant widgets after they trigger their 'change' event, in reaction to field changes.
   * By default implements the functionality for the `autoUpdateRecord` config.
   *
   * @param {Object} params Normally the event params used when triggering the 'change' event
   * @internal
   */


  onFieldChange({
    source,
    userAction
  }) {
    // When configured with `autoUpdateRecord`, changes from descendant fields/widgets are applied to the loaded
    // record using the fields `name`. Only changes from valid fields will be applied
    if (this.autoUpdateRecord) {
      const {
        record
      } = this,
            {
        name,
        isValid,
        value
      } = source;

      if (record && userAction && name && isValid) {
        record[name] = value;
      }
    }
  }

  getValues(filterFn) {
    const values = {};
    this.eachWidget((widget, control) => {
      // Do not drill down when reaching a container that isolates its fields
      if (widget.isolateFields) {
        control.down = false;
      } else if ('name' in widget && (!filterFn || filterFn(widget))) {
        values[widget.name] = widget.value;
      }
    }, true);
    return values;
  }

  get hasNoChildren() {
    // If we have *uningested* lazyItems, use them to find our items length.
    // In that case we must not cause ingestion of the lazyItems by referencing this.items.
    // If we have items, then only those that are visible have any bearing.
    // Popup also has to consult this property to decide on its CSS classes.
    const me = this,
          {
      items,
      lazyItems
    } = me.initialConfig,
          itemsArray = items && (isArray(items) ? items : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].values(items)),
          lazyItemsArray = lazyItems && (isArray(lazyItems) ? lazyItems : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].values(lazyItems)),
          // avoid triggering items initialization
    whichItems = me.isConfiguring ? lazyItemsArray || itemsArray : me.items;
    return !(whichItems !== null && whichItems !== void 0 && whichItems.filter(isNotHidden).length);
  }

  afterRecompose() {
    this.realign();
  }

  updateTextContent(textContent) {
    const me = this; // Add the text content class if we have no visible immediate item children.

    if (!me.isComposable) {
      me.contentElement.classList[textContent && me.hasNoChildren ? 'add' : 'remove']('b-text-content'); // Depending on CSS settings around how this widget handles text content and widthing
      // we *may* have to realign. Realign only goes ahead if we're visible and floating.

      if (me.rendered) {
        me.realign();
      }
    }
  }

  updateLayoutStyle(layoutStyle) {
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].applyStyle(this.contentElement, layoutStyle);
  }

  onPaint() {
    var _super$onPaint;

    (_super$onPaint = super.onPaint) === null || _super$onPaint === void 0 ? void 0 : _super$onPaint.call(this, ...arguments); // Bring the lazy config into existence now that we have a layout.

    this.getConfig('contentElMutationObserver');
  }

  changeContentElMutationObserver(contentElMutationObserver, oldContentElMutationObserver) {
    if (oldContentElMutationObserver) {
      // Clear the queue. Any remaining notifications will be undeliverable.
      oldContentElMutationObserver.takeRecords();
      oldContentElMutationObserver.disconnect();
    } // We need to monitor our contentElement for attribute changes.
    // Changes to the inline style, or the classList/className will trigger this.
    // At that point we can sync our layout flag classes.


    if (contentElMutationObserver) {
      // NOTE: Do not hoist the vars, that will pull things in during destruction
      const me = this,
            {
        element,
        contentElement
      } = me;
      contentElMutationObserver = new MutationObserver(mutations => me.onContentElMutation(mutations));
      contentElMutationObserver.observe(contentElement, {
        attributes: true
      }); // If our contentElement is an inner element (eg Panel, Toolbar)
      // then styling might apply from classes on the outer element
      // so monitor that too.

      if (contentElement !== element) {
        contentElMutationObserver.observe(element, {
          attributes: true
        });
      }

      me.syncFlexDirection();
    }

    return contentElMutationObserver;
  }

  onContentElMutation() {
    // We can only do it if we are visible, otherwise the computed style won't work
    // and the classes will be removed.
    if (this.isVisible) {
      this.syncFlexDirection();
    }
  }

  changeLayout(config, existingLayout) {
    return _layout_Layout_js__WEBPACK_IMPORTED_MODULE_3__["default"].reconfigure(existingLayout, config, {
      owner: this,
      defaults: {
        owner: this
      }
    });
  } // Items to iterate over


  get childItems() {
    return this.items;
  }
  /**
   * Returns a directly contained widget by id
   * @param {String} id The widget id
   * @returns {Core.widget.Widget}
   */


  getWidgetById(id) {
    return this.widgetMap[id];
  }
  /**
   * This function is called prior to creating widgets, override it in subclasses to allow containers to modify the
   * configuration of each widget. When adding a widget to a container hierarchy each parent containers
   * `processWidgetConfig` will be called. Returning false from the function prevents the widget from being added at
   * all.
   */


  processWidgetConfig(widget) {}
  /**
   * This method combines container {@link #config-defaults}
   * @param {Object} widgetConfig
   * @param {String|Function} [type] The type of widget described by `widgetConfig`.
   * @returns {Object}
   * @internal
   */


  setupWidgetConfig(widgetConfig, type) {
    const me = this; // A string becomes the defaultType (see below) with the html set to the string.

    if (typeof widgetConfig === 'string') {
      widgetConfig = {
        html: widgetConfig
      };
    } // An element is encapsulated by a Widget
    else if (widgetConfig.nodeType === Element.ELEMENT_NODE) {
      widgetConfig = {
        element: widgetConfig,
        id: widgetConfig.id
      };
    }

    if (typeof type === 'string' || !type && (type
    /* assignment */
    = widgetConfig.type)) {
      type = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].resolveType(type, true);
    } // widgetConfig = ObjectHelper.assign({}, me.defaults, widgetConfig, { parent : me });


    widgetConfig = (type || _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"]).mergeConfigs(me.defaults, widgetConfig, {
      parent: me
    });

    for (let ancestor = widgetConfig.parent; ancestor; ancestor = ancestor.parent) {
      if (ancestor.processWidgetConfig(widgetConfig) === false) {
        return null;
      }
    }

    if (me.trigger('beforeWidgetCreate', {
      widgetConfig
    }) === false) {
      return null;
    }

    return widgetConfig;
  }
  /**
   * This function converts a Widget config object into a Widget.
   * @param {Object} widget A Widget config object.
   * @internal
   */


  createWidget(widget) {
    const result = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].create(this.setupWidgetConfig(widget), this.defaultType); // If we created a widget from a config object, then upon items replacement
    // we must destroy outgoing widgets.

    result && (result._createdBy = this);
    return result;
  } // Reapply defaults, not used during config


  updateDefaults(defaults, oldDefaults) {
    if (!this.isConfiguring) {
      const entries = Object.entries(defaults);
      this.eachWidget(widget => {
        entries.forEach(([prop, value]) => {
          // Apply defaults only if current value matches the old default
          if (widget[prop] === oldDefaults[prop]) {
            widget[prop] = value;
          }
        });
      }, false);
    }
  }

  render() {
    // Pull in lazyItems at last second
    this.getConfig('lazyItems');
    this.layout.renderChildren(); // If called during configuration, the element may not have been available because
    // some non-item widgets (eg, Tools) instantiate and declare themselves through
    // onChildAdd before the element is set.
    // But also there may have been no items because of lazyItems.
    // So do the initial sync at render time.

    this.syncChildCount();
    super.render(...arguments);
  }

  get focusElement() {
    // Find first focusable descendant widget that is not our close tool.
    const firstFocusable = this.query(this.defaultFocus || (w => w.isFocusable && w.ref !== 'close'));

    if (firstFocusable) {
      return firstFocusable.focusElement;
    }

    return super.focusElement;
  }

  doDestroy() {
    var _this$_items;

    (_this$_items = this._items) === null || _this$_items === void 0 ? void 0 : _this$_items.forEach(widget => {
      var _widget$destroy;

      return (_widget$destroy = widget.destroy) === null || _widget$destroy === void 0 ? void 0 : _widget$destroy.call(widget);
    });
    this.layout.destroy();
    super.doDestroy();
  }
  /**
   * Returns `true` if all contained fields are valid, otherwise `false`
   * @property {Boolean}
   */


  get isValid() {
    let valid = true;
    this.eachWidget(widget => {
      // Touch each widget so that they all update their invalid state. This is important for required fields
      // since they don't initially complain if they start as empty.
      if (widget.isVisible && 'isValid' in widget && !widget.isValid) {
        valid = false;
      }
    }, true);
    return valid;
  }
  /**
   * Retrieves or sets all values from/to contained fields.
   * Accepts and returns a map, using {@link Core.widget.Field#config-name name},
   * {@link Core.widget.Widget#config-ref ref} or {@link Core.widget.Widget#config-id id} (in that order) as keys.
   *
   * ```javascript
   * container.values = {
   *     firstName : 'Clark',
   *     surname : 'Kent'
   * };
   * ```
   *
   * @property {Object}
   */


  get values() {
    const values = {};
    this.eachWidget((widget, control) => {
      // Do not drill down when reaching a container that isolates its fields
      if (widget.isolateFields) {
        control.down = false;
      } else if ('value' in widget) {
        values[widget.name || widget.ref || widget.id] = widget.value;
      }
    }, true);
    return values;
  }

  set values(values) {
    this.setValues(values);
  }
  /**
   * Returns `true` if currently setting values. Allows fields change highlighting to distinguishing between initially
   * setting values and later on changing values.
   * @property {Boolean}
   */


  get isSettingValues() {
    var _this$parent;

    // Fields query their parent, pass the question up in case containers are nested
    return Boolean(this._isSettingValues || ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.isSettingValues));
  }

  setValues(values, onlyName = false, preventHighlight = true) {
    // Flag checked by Field to determine if it should highlight change or not
    this._isSettingValues = {
      preventHighlight
    };
    this.eachWidget((widget, control) => {
      const hec = widget.highlightExternalChange,
            key = onlyName ? widget.name : widget.name || widget.ref || widget.id;

      if ('value' in widget && key) {
        if (preventHighlight) {
          // Don't want a field highlight on mass change
          widget.highlightExternalChange = false;
        } // Setting to null when value not matched clears field


        widget.value = values && key in values ? values[key] : null;
        widget.highlightExternalChange = hec;
      } // Dont drill down when reaching a container that isolates its fields


      if (widget.isolateFields) {
        control.down = false;
      }
    }, true);
    this._isSettingValues = false;
  }

} // Register this widget type with its Factory

Container.initClass();
Container._$name = 'Container';

/***/ }),

/***/ "./lib/Core/widget/DateField.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/DateField.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateField; });
/* harmony import */ var _PickerField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony import */ var _DatePicker_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DatePicker.js */ "./lib/Core/widget/DatePicker.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'taskboard'; //TODO: picker icon (calendar) should show day number




/**
 * @module Core/widget/DateField
 */

/**
 * Date field widget (text field + date picker).
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the {@link Grid.column.DateColumn DateColumn}.
 *
 * @extends Core/widget/PickerField
 *
 * @example
 * // minimal DateField config with date format specified
 * let dateField = new DateField({
 *   format: 'YYMMDD'
 * });
 *
 * @classType datefield
 * @inlineexample Core/widget/DateField.js
 */

class DateField extends _PickerField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'DateField';
  } // Factoryable type name


  static get type() {
    return 'datefield';
  } // Factoryable type alias


  static get alias() {
    return 'date';
  }

  static get configurable() {
    return {
      /**
       * Get / set format for date displayed in field (see {@link Core.helper.DateHelper#function-format-static}
       * for formatting options).
       * @member {String} format
       */

      /**
       * Format for date displayed in field. Defaults to using long date format, as defined by current locale (`L`)
       * @config {String}
       * @default
       */
      format: 'L',
      // same for all languages
      fallbackFormat: 'YYYY-MM-DD',
      timeFormat: 'HH:mm:ss:SSS',

      /**
       * A flag which indicates what time should be used for selected date.
       * `false` by default which means time is reset to midnight.
       *
       * Possible options are:
       * - `false` to reset time to midnight
       * - `true` to keep original time value
       * - `'17:00'` a string which is parsed automatically
       * - `new Date(2020, 0, 1, 17)` a date object to copy time from
       * - `'entered'` to keep time value entered by user (in case {@link #config-format} includes time info)
       *
       * @config {Boolean|Date|String}
       * @default
       */
      keepTime: false,

      /**
       * Format for date in the {@link #config-picker}. Uses localized format per default
       * @config {String}
       */
      pickerFormat: null,

      /**
       * Set to true to first clear time of the field's value before comparing it to the max value
       * @internal
       * @config {Boolean}
       */
      validateDateOnly: null,
      triggers: {
        expand: {
          cls: 'b-icon-calendar',
          handler: 'onTriggerClick',
          weight: 200
        },
        back: {
          cls: 'b-icon b-icon-angle-left b-step-trigger',
          handler: 'onBackClick',
          align: 'start',
          weight: 100
        },
        forward: {
          cls: 'b-icon b-icon-angle-right b-step-trigger',
          handler: 'onForwardClick',
          align: 'end',
          weight: 100
        }
      },
      // An optional extra CSS class to add to the picker container element
      calendarContainerCls: '',

      /**
       * Get/set min value, which can be a Date or a string. If a string is specified, it will be converted using
       * the specified {@link #config-format}.
       * @member {Date} min
       * @accepts {String|Date}
       */

      /**
       * Min value
       * @config {String|Date}
       */
      min: null,

      /**
       * Get/set max value, which can be a Date or a string. If a string is specified, it will be converted using
       * the specified {@link #config-format}.
       * @member {Date} max
       * @accepts {String|Date}
       */

      /**
       * Max value
       * @config {String|Date}
       */
      max: null,

      /**
       * The `step` property may be set in object form specifying two properties, `magnitude`, a Number, and
       * `unit`, a String.
       *
       * If a Number is passed, the steps's current unit is used (or `day` if no current step set) and just the
       * magnitude is changed.
       *
       * If a String is passed, it is parsed by {@link Core.helper.DateHelper#function-parseDuration-static}, for
       * example `'1d'`, `'1 d'`, `'1 day'`, or `'1 day'`.
       *
       * Upon read, the value is always returned in object form containing `magnitude` and `unit`.
       * @member {Object} step
       * @accepts {String|Number|Object}
       */

      /**
       * Time increment duration value. If specified, `forward` and `back` triggers are displayed.
       * The value is taken to be a string consisting of the numeric magnitude and the units.
       * The units may be a recognised unit abbreviation of this locale or the full local unit name.
       * For example `'1d'` or `'1w'` or `'1 week'`. This may be specified as an object containing
       * two properties: `magnitude`, a Number, and `unit`, a String
       * @config {String|Number|Object}
       */
      step: false,
      stepTriggers: null,

      /**
       * The week start day in the {@link #config-picker}, 0 meaning Sunday, 6 meaning Saturday.
       * Uses localized value per default.
       * @config {Number}
       */
      weekStartDay: null,

      /**
       * A config object used to configure the {@link Core.widget.DatePicker datePicker}.
       * ```javascript
       * dateField = new DateField({
       *      picker    : {
       *          multiSelect : true
       *      }
       *  });
       * ```
       * @config {Object}
       */
      picker: {
        type: 'datepicker',
        floating: true,
        scrollAction: 'realign',
        align: {
          align: 't0-b0',
          axisLock: true
        }
      },

      /**
       * Get/set value, which can be set as a Date or a string but always returns a Date. If a string is
       * specified, it will be converted using the specified {@link #config-format}
       * @member {Date} value
       * @accepts {String|Date}
       */

      /**
       * Value, which can be a Date or a string. If a string is specified, it will be converted using the
       * specified {@link #config-format}
       * @config {String|Date}
       */
      value: null
    };
  } //endregion
  //region Init & destroy

  /**
   * Creates default picker widget
   *
   * @internal
   */


  changePicker(picker, oldPicker) {
    const me = this,
          defaults = {
      owner: me,
      forElement: me[me.pickerAlignElement],
      minDate: me.min,
      maxDate: me.max,
      weekStartDay: me._weekStartDay,
      // need to pass the raw value to let the component to use its default value
      align: {
        anchor: me.overlayAnchor,
        target: me[me.pickerAlignElement]
      },
      onSelectionChange: ({
        selection,
        source: picker
      }) => {
        // We only care about what DatePicker does if it has been opened
        if (picker.isVisible) {
          me._isUserAction = true;
          me._isPickerInput = true;
          me.value = selection[0];
          me._isPickerInput = false;
          me._isUserAction = false;
          picker.hide();
        }
      }
    };

    if (me.calendarContainerCls) {
      defaults.cls = me.calendarContainerCls;
    }

    if (me.value) {
      defaults.value = me.value;
    } else {
      defaults.date = new Date();
    }

    return _DatePicker_js__WEBPACK_IMPORTED_MODULE_1__["default"].reconfigure(oldPicker, picker, {
      owner: me,
      defaults
    });
  } //endregion
  //region Click listeners


  get backShiftDate() {
    return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(this.value, -1 * this._step.magnitude, this._step.unit);
  }

  onBackClick() {
    const me = this,
          {
      min
    } = me;

    if (!me.readOnly && me.value) {
      const newValue = me.backShiftDate;

      if (!min || min.getTime() <= newValue) {
        me._isUserAction = true;
        me.value = newValue;
        me._isUserAction = false;
      }
    }
  }

  get forwardShiftDate() {
    return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(this.value, this._step.magnitude, this._step.unit);
  }

  onForwardClick() {
    const me = this,
          {
      max
    } = me;

    if (!me.readOnly && me.value) {
      const newValue = me.forwardShiftDate;

      if (!max || max.getTime() >= newValue) {
        me._isUserAction = true;
        me.value = newValue;
        me._isUserAction = false;
      }
    }
  } //endregion
  //region Toggle picker


  showPicker(focusPicker) {
    if (this.readOnly) {
      return;
    }

    const {
      _picker
    } = this; // If it's already instanced, move it.
    // It will be initialized correctly if not.

    if (_picker) {
      _picker.value = this.value; // In case a subclass uses a min getter (which does not update our min value) - ensure picker is correctly configured,

      _picker.minDate = this.min;
      _picker.maxDate = this.max;
    }

    super.showPicker(focusPicker);
  }

  focusPicker() {
    this.picker.focus();
  } //endregion
  // region Validation


  get isValid() {
    const me = this;
    me.clearError('L{Field.minimumValueViolation}', true);
    me.clearError('L{Field.maximumValueViolation}', true);
    let value = me.value;

    if (value) {
      const {
        min,
        max,
        validateDateOnly
      } = me; // Validation of the date should only care about the date part

      if (validateDateOnly) {
        value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(value, false);
      }

      if (min && value < min) {
        me.setError('L{Field.minimumValueViolation}', true);
        return false;
      }

      if (max && value > max) {
        me.setError('L{Field.maximumValueViolation}', true);
        return false;
      }
    }

    return super.isValid;
  } //endregion
  //region Getters/setters


  transformDateValue(value) {
    if (value != null) {
      if (!_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isDate(value)) {
        if (typeof value === 'string') {
          // If date cannot be parsed with set format, try fallback - the more general one
          value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(value, this.format) || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(value, this.fallbackFormat);
        } else {
          value = new Date(value);
        }
      } // We insist on a *valid* Date as the value


      if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isValidDate(value)) {
        return this.transformTimeValue(value);
      }
    }

    return null;
  }

  transformTimeValue(value) {
    const me = this,
          {
      keepTime
    } = me;
    value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(value);

    if (!keepTime) {
      _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(value, false);
    } // change time if keepTime !== 'entered'
    else if (keepTime !== 'entered') {
      const timeValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(keepTime, me.timeFormat); // if this.keepTime is a valid date or a string describing valid time copy from it

      if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isValidDate(timeValue)) {
        _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].copyTimeValues(value, timeValue);
      } // otherwise try to copy from the current value
      else if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isValidDate(me.value)) {
        _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].copyTimeValues(value, me.value);
      }
    } // if keepTime === 'entered' and picker is used apply current value time
    else if (me._isPickerInput && _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isValidDate(me.value)) {
      _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].copyTimeValues(value, me.value);
    } // else don't change time


    return value;
  }

  changeMin(value) {
    return this.transformDateValue(value);
  }

  updateMin(min) {
    const {
      input,
      _picker
    } = this;

    if (input) {
      if (min == null) {
        input.removeAttribute('min');
      } else {
        input.min = min;
      }
    } // See if our lazy config has been realized...


    if (_picker) {
      _picker.minDate = min;
    }

    this.syncInvalid();
  }

  changeMax(value) {
    return this.transformDateValue(value);
  }

  updateMax(max) {
    const {
      input,
      _picker
    } = this;

    if (input) {
      if (max == null) {
        input.removeAttribute('max');
      } else {
        input.max = max;
      }
    }

    if (_picker) {
      _picker.maxDate = max;
    }

    this.syncInvalid();
  }

  get weekStartDay() {
    // This trick allows our weekStartDay to float w/the locale even if the locale changes
    return typeof this._weekStartDay === 'number' ? this._weekStartDay : _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].weekStartDay;
  }

  updateWeekStartDay(weekStartDay) {
    if (this._picker) {
      this._picker.weekStartDay = weekStartDay;
    }
  }

  changeValue(value, oldValue) {
    const me = this,
          newValue = me.transformDateValue(value); // A value we could not parse

    if (value && !newValue) {
      // setError uses localization
      me.setError('L{invalidDate}');
      return;
    }

    me.clearError('L{invalidDate}'); // Reject non-change

    if (me.hasChanged(oldValue, newValue)) {
      return super.changeValue(newValue, oldValue);
    } // But we must fix up the display in case it was an unparseable string
    // and the value therefore did not change.


    if (!me.inputting) {
      me.syncInputFieldValue();
    }
  }

  updateValue(value, oldValue) {
    const picker = this._picker;

    if (picker && !this.inputting) {
      picker.value = value;
    }

    super.updateValue(value, oldValue);
  }

  changeStep(value, was) {
    const type = typeof value;

    if (!value) {
      return null;
    }

    if (type === 'number') {
      value = {
        magnitude: Math.abs(value),
        unit: was ? was.unit : 'day'
      };
    } else if (type === 'string') {
      value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseDuration(value);
    }

    if (value && value.unit && value.magnitude) {
      if (value.magnitude < 0) {
        value = {
          magnitude: -value.magnitude,
          // Math.abs
          unit: value.unit
        };
      }

      return value;
    }
  }

  updateStep(value) {
    // If a step is configured, show the steppers
    this.element.classList[value ? 'remove' : 'add']('b-no-steppers');
    this.syncInvalid();
  }

  hasChanged(oldValue, newValue) {
    // if both dates are provided and the field does not has time info in its format
    if (oldValue !== null && oldValue !== void 0 && oldValue.getTime && newValue !== null && newValue !== void 0 && newValue.getTime && this.keepTime !== 'entered') {
      // Only compare date part
      return !_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(oldValue), _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(newValue));
    }

    return super.hasChanged(oldValue && oldValue.getTime(), newValue && newValue.getTime());
  }

  get inputValue() {
    // Do not use the _value property. If called during configuration, this
    // will import the configured value from the config object.
    const date = this.value;
    return date ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(date, this.format) : '';
  }

  updateFormat() {
    this.syncInputFieldValue(true);
  } //endregion
  //region Localization


  updateLocalization() {
    super.updateLocalization();
    this.syncInputFieldValue(true);
  } //endregion
  //region Other


  internalOnKeyEvent(event) {
    super.internalOnKeyEvent(event);

    if (event.key === 'Enter' && this.isValid) {
      this.picker.hide();
    }
  } //endregion


} // Register this widget type with its Factory

DateField.initClass();
DateField._$name = 'DateField';

/***/ }),

/***/ "./lib/Core/widget/DatePicker.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/DatePicker.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DatePicker; });
/* harmony import */ var _CalendarPanel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CalendarPanel.js */ "./lib/Core/widget/CalendarPanel.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Combo_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'taskboard';







const generateMonthNames = () => _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getMonthNames().map((m, i) => [i, m]),
      yearItems = [],
      middle = new Date().getFullYear();

for (let y = middle - 20; y < middle + 21; y++) {
  yearItems.push(y);
}

class ReadOnlyCombo extends _Combo_js__WEBPACK_IMPORTED_MODULE_3__["default"] {
  static get $name() {
    return 'ReadOnlyCombo';
  }

  static get type() {
    return 'readonlycombo';
  }

  static get configurable() {
    return {
      editable: false,
      inputAttributes: {
        tag: 'div',
        tabIndex: -1
      },
      highlightExternalChange: false,
      triggers: {
        expand: false
      },
      picker: {
        align: {
          align: 't-b',
          axisLock: true,
          matchSize: false
        },
        cls: 'b-readonly-combo-list',
        scrollable: {
          overflowX: false
        }
      }
    };
  }

  onSelect({
    record
  }) {
    this.value = record.value;
  }

  set value(value) {
    const {
      store
    } = this,
          toAdd = []; // the store must contain the value being set.
    // Fill in any gap.

    if (value < store.first.id) {
      for (let y = value; y < store.first.id; y++) {
        toAdd.push({
          text: y
        });
      }
    }

    if (value > store.last.id) {
      for (let y = store.last.id + 1; y <= value; y++) {
        toAdd.push({
          text: y
        });
      }
    }

    store.add(toAdd);
    super.value = value;
    this.input.innerHTML = this.input.value;
  }

  get value() {
    return super.value;
  }

}

ReadOnlyCombo.initClass();
/**
 * @module Core/widget/DatePicker
 */

/**
 * A Panel which can display a month of date cells, which navigates between the cells,
 * fires events upon user selection actions, optionally navigates to other months
 * in response to UI gestures, and optionally displays information about each date cell.
 *
 * This class is used by the {@link Core.widget.DateField} class.
 *
 * {@inlineexample Core/widget/DatePicker.js}
 *
 * ## Custom cell rendering
 * You can easily control the content of each date cell using the {@link #config-cellRenderer}. The example below shows a view
 * typically seen when booking hotel rooms or apartments.
 *
 * {@inlineexample Core/widget/DatePickerCellRenderer.js}
 *
 * @classtype datepicker
 * @extends Core/widget/CalendarPanel
 */

class DatePicker extends _CalendarPanel_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'DatePicker';
  } // Factoryable type name


  static get type() {
    return 'datepicker';
  }

  static get delayable() {
    return {
      refresh: 'raf'
    };
  }

  static get configurable() {
    return {
      /**
       * The date that the user has navigated to using the UI *prior* to setting the widget's
       * value by selecting.
       *
       * This may be changed using keyboard navigation. The {@link Core.widget.CalendarPanel#property-date} is set
       * by pressing `ENTER` when the desired date is reached.
       *
       * Programmatically setting the {@link Core.widget.CalendarPanel#config-date}, or using the UI to select the date
       * by clicking it also sets the `activeDate`
       * @config {Date}
       */
      activeDate: {
        value: null,
        $config: {
          equal: 'date'
        }
      },
      focusable: true,
      textContent: false,
      tbar: {
        overflow: null,
        items: [{
          ref: 'prevMonth',
          cls: 'b-icon b-icon-prev',
          onAction: 'up.gotoPrevMonth'
        }, {
          type: 'container',
          flex: 1,
          defaultType: 'readonlycombo',
          cls: 'b-datepicker-title',
          items: [{
            ref: 'monthField',
            cls: 'b-datepicker-monthfield',
            items: generateMonthNames(),
            listeners: {
              select: 'up.onMonthPicked'
            }
          }, {
            ref: 'yearField',
            cls: 'b-datepicker-yearfield',
            items: yearItems,
            listeners: {
              select: 'up.onYearPicked'
            }
          }]
        }, {
          ref: 'nextMonth',
          cls: 'b-icon b-icon-next',
          onAction: 'up.gotoNextMonth'
        }]
      },

      /**
       * The initially selected date.
       * @config {Date}
       * @default
       */
      date: new Date(),

      /**
       * The minimum selectable date. Selection of and navigation to dates prior
       * to this date will not be possible.
       * @config {Date}
       */
      minDate: {
        value: null,
        $config: {
          equal: 'date'
        }
      },

      /**
       * The maximum selectable date. Selection of and navigation to dates after
       * this date will not be possible.
       * @config {Date}
       */
      maxDate: {
        value: null,
        $config: {
          equal: 'date'
        }
      },

      /**
       * By default, disabled dates cannot be navigated to, and they are skipped over
       * during keyboard navigation. Configure this as `true` to enable navigation to
       * disabled dates.
       * @config {Boolean}
       * @default
       */
      focusDisabledDates: null,

      /**
       * Configure as `true` to enable selecting a single date range by selecting a
       * start and end date. Hold "SHIFT" button to select date range.
       * @config {Boolean}
       * @default
       */
      multiSelect: false,

      /**
       * DEPRECATED - This config is no longer used
       * @deprecated 5.0.0
       * @config {Boolean}
       * @default
       */
      editOnHover: true,

      /**
       * By default, the month and year are editable. Configure this as `false` to prevent that.
       * @config {Boolean}
       * @default
       */
      editMonth: true,

      /**
       * The {@link Core.helper.DateHelper DateHelper} format string to format the day names.
       * @config {String}
       * @default
       */
      dayNameFormat: 'dd'
    };
  }

  static get prototypeProperties() {
    return {
      /**
       * The class name to add to the calendar cell whose date which is outside of the
       * {@link #config-minDate}/{@link #config-maxDate} range.
       * @config {String}
       * @private
       */
      outOfRangeCls: 'b-out-of-range',

      /**
       * The class name to add to the currently focused calendar cell.
       * @config {String}
       * @private
       */
      activeCls: 'b-active-date',

      /**
       * The class name to add to selected calendar cells.
       * @config {String}
       * @private
       */
      selectedCls: 'b-selected-date'
    };
  }
  /**
   * Fires when a date is selected. If {@link #config-multiSelect} is specified, this
   * will fire upon deselection and selection of dates.
   * @event selectionChange
   * @param {Date[]} selection The selected date. If {@link #config-multiSelect} is specified
   * this may be a two element array specifying start and end dates.
   * @param {Boolean} userAction This will be `true` if the change was caused by user interaction
   * as opposed to programmatic setting.
   */

  /* ...disconnect doc comment above from method below... */
  // region Init


  construct(config) {
    const me = this;

    if (config.editOnHover) {
      _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].deprecate('Grid', '5.0.0', '`editOnHover` config deprecated, it now has no effect and will be removed in 5.0');
    }

    me.selection = config.date ? [config.date] : [];
    super.construct(config);
    me.externalCellRenderer = me.cellRenderer;
    me.cellRenderer = me.internalCellRenderer;
    me.element.setAttribute('aria-activedescendant', `${me.id}-active-day`);
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: me.weeksElement,
      click: 'onCellClick',
      delegate: `.${me.dayCellCls}:not(.${me.disabledCls}):not(.${me.outOfRangeCls})`,
      thisObj: me
    });
    me.widgetMap.monthField.readOnly = me.widgetMap.yearField.readOnly = !me.editMonth;
  }

  doDestroy() {
    var _this$yearField, _this$monthField;

    (_this$yearField = this.yearField) === null || _this$yearField === void 0 ? void 0 : _this$yearField.destroy();
    (_this$monthField = this.monthField) === null || _this$monthField === void 0 ? void 0 : _this$monthField.destroy();
    super.doDestroy();
  } // endregion


  get focusElement() {
    return this.element;
  }

  internalCellRenderer({
    cell,
    date
  }) {
    var _me$externalCellRende;

    const me = this,
          {
      activeCls,
      selectedCls
    } = me,
          cellClassList = {
      [activeCls]: me.isActiveDate(date),
      [selectedCls]: me.isSelectedDate(date),
      [me.outOfRangeCls]: me.minDate && date < me.minDate || me.maxDate && date > me.maxDate
    };
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].updateClassList(cell, cellClassList);
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].setInnerText(cell, date.getDate());
    cell.setAttribute('aria-label', _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(date, 'MMMM D, YYYY'));

    if (me.isActiveDate(date)) {
      cell.id = `${me.id}-active-day`;
    } else {
      cell.removeAttribute('id');
    }

    (_me$externalCellRende = me.externalCellRenderer) === null || _me$externalCellRende === void 0 ? void 0 : _me$externalCellRende.call(me, ...arguments);
  }

  onCellClick(event) {
    const cell = event.target.closest('[data-date]');
    this.onUIDateSelect(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parseKey(cell.dataset.date), event);
  }
  /**
   * Called when the user uses the UI to select the current activeDate. So ENTER when focused
   * or clicking a date cell.
   * @param {Date} date The active date to select
   * @param {Event} event the instigating event, either a `click` event or a `keydown` event.
   * @internal
   */


  onUIDateSelect(date, event) {
    const me = this,
          {
      lastClickedDate,
      selection
    } = me;
    me.activeDate = date;
    me.lastClickedDate = date;

    if (!me.isDisabledDate(date)) {
      me.activatingEvent = event; // Handle multi selecting.
      // * single contiguous date range, eg: an event start and end
      // * multiple discontiguous ranges

      if (me.multiSelect) {
        if (me.multiRange) {// TODO: multiple date ranges
        } else if (!lastClickedDate || !_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isSameDate(date, lastClickedDate)) {
          if (lastClickedDate && event.shiftKey) {
            selection[1] = date;
            selection.sort();
          } else {
            selection.length = 0;
            selection[0] = date;
          }

          me.trigger('selectionChange', {
            selection,
            userAction: Boolean(event)
          });
        }
      } else {
        if (!me.value || me.value.getTime() !== date.getTime()) {
          me.value = date;
        } else if (me.floating) {
          me.hide();
        }
      }

      me.activatingEvent = null;
    }
  }

  onInternalKeyDown(keyEvent) {
    const me = this,
          keyName = keyEvent.key.trim() || keyEvent.code,
          activeDate = me.activeDate;
    let newDate = new Date(activeDate);

    if (keyName === 'Escape' && me.floating) {
      return me.hide();
    } // Only navigate if not focused on one of our child widgets.
    // We have a prevMonth and nextMonth tool and possibly month and year pickers.


    if (activeDate && keyEvent.target === me.focusElement) {
      do {
        switch (keyName) {
          case 'ArrowLeft':
            // Disable browser use of this key.
            // Ctrl+ArrowLeft navigates back.
            // ArrowLeft scrolls if there is horizontal scroll.
            keyEvent.preventDefault();

            if (keyEvent.ctrlKey) {
              newDate = me.gotoPrevMonth();
            } else {
              newDate.setDate(newDate.getDate() - 1);
            }

            break;

          case 'ArrowUp':
            // Disable browser use of this key.
            // ArrowUp scrolls if there is vertical scroll.
            keyEvent.preventDefault();
            newDate.setDate(newDate.getDate() - 7);
            break;

          case 'ArrowRight':
            // Disable browser use of this key.
            // Ctrl+ArrowRight navigates forwards.
            // ArrowRight scrolls if there is horizontal scroll.
            keyEvent.preventDefault();

            if (keyEvent.ctrlKey) {
              newDate = me.gotoNextMonth();
            } else {
              newDate.setDate(newDate.getDate() + 1);
            }

            break;

          case 'ArrowDown':
            // Disable browser use of this key.
            // ArrowDown scrolls if there is vertical scroll.
            keyEvent.preventDefault();
            newDate.setDate(newDate.getDate() + 7);
            break;

          case 'Enter':
            return me.onUIDateSelect(activeDate, keyEvent);
        }
      } while (me.isDisabledDate(newDate) && !me.focusDisabledDates); // Don't allow navigation to outside of date bounds.


      if (me.minDate && newDate < me.minDate) {
        return;
      }

      if (me.maxDate && newDate > me.maxDate) {
        return;
      }

      me.activeDate = newDate;
    }
  }

  changeMinDate(minDate) {
    return minDate ? this.changeDate(minDate) : null;
  }

  updateMinDate() {
    this.refresh();
  }

  changeMaxDate(maxDate) {
    return maxDate ? this.changeDate(maxDate) : null;
  }

  updateMaxDate() {
    this.refresh();
  }

  updateDate(date) {
    super.updateDate(date);
    this.activeDate = date;
  }

  changeActiveDate(activeDate) {
    activeDate = activeDate ? this.changeDate(activeDate) : this.date || (this.date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].clearTime(new Date()));

    if (isNaN(activeDate)) {
      throw new Error('DatePicker date ingestion must be passed a Date, or a YYYY-MM-DD date string');
    }

    return activeDate;
  }

  updateActiveDate(activeDate) {
    // Month's date setter protects it from non-changes.
    this.month.date = activeDate;
    this.widgetMap.monthField.value = activeDate.getMonth();
    this.widgetMap.yearField.value = activeDate.getFullYear();

    if (!this.isConfiguring) {
      // Must refresh so that the active cell gets a refresh.
      this.refresh();
    }
  }

  set value(value) {
    const me = this,
          {
      selection
    } = me;
    let changed;

    if (value) {
      value = me.changeDate(value, me.value); // Undefined return value means no change

      if (value === undefined) {
        return;
      }

      if (!me.value || value.getTime() !== me.value.getTime()) {
        selection.length = 0;
        selection[0] = value;
        changed = true;
      }

      me.date = value;
    } else {
      changed = selection.length;
      selection.length = 0; // Clearing the value - go to today's calendar

      me.date = new Date();
    }

    if (changed) {
      me.trigger('selectionChange', {
        selection,
        userAction: Boolean(me.activatingEvent)
      });
    }
  }

  get value() {
    return this.selection[this.selection.length - 1];
  }

  gotoPrevMonth() {
    const me = this,
          {
      activeDate
    } = me,
          // Navigate from the activeDate if the activeDate is in the UI.
    baseDate = activeDate && me.getCell(activeDate) ? activeDate : me.date,
          newDate = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(baseDate, -1, 'month'),
          lastDateOfPrevMonth = new Date(baseDate).setDate(0);

    if (!me.minDate || lastDateOfPrevMonth >= me.minDate) {
      return me.date = newDate;
    }
  }

  gotoNextMonth() {
    const me = this,
          {
      activeDate
    } = me,
          // Navigate from the activeDate if the activeDate is in the UI.
    baseDate = activeDate && me.getCell(activeDate) ? activeDate : me.date,
          newDate = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(baseDate, 1, 'month'),
          firstDateOfNextMonth = new Date(newDate).setDate(1);

    if (!me.maxDate || firstDateOfNextMonth <= me.maxDate) {
      return me.date = newDate;
    }
  }

  isActiveDate(date) {
    return this.activeDate && this.changeDate(date).getTime() === this.activeDate.getTime();
  }

  isSelectedDate(date) {
    return this.selection.some(d => _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isEqual(d, date, 'day'));
  }

  onMonthPicked({
    record,
    userAction
  }) {
    this.activeDate = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(this.activeDate, record.value - this.activeDate.getMonth(), 'month');

    if (userAction) {
      var _this$focusElement;

      (_this$focusElement = this.focusElement) === null || _this$focusElement === void 0 ? void 0 : _this$focusElement.focus();
    }
  }

  onYearPicked({
    record,
    userAction
  }) {
    const newDate = new Date(this.activeDate);
    newDate.setFullYear(record.value);
    this.activeDate = newDate;

    if (userAction) {
      var _this$focusElement2;

      (_this$focusElement2 = this.focusElement) === null || _this$focusElement2 === void 0 ? void 0 : _this$focusElement2.focus();
    }
  }

  get yearItems() {
    const result = [],
          middle = new Date().getFullYear();

    for (let y = middle - 20; y < middle + 21; y++) {
      result.push(y);
    }

    return result;
  }

  updateLocalization() {
    const monthField = this.widgetMap.monthField,
          newData = generateMonthNames();
    newData[monthField.value].selected = true;
    monthField.items = newData;
    super.updateLocalization();
  }

} // Register this widget type with its Factory

DatePicker.initClass();
DatePicker._$name = 'DatePicker';

/***/ }),

/***/ "./lib/Core/widget/DateTimeField.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/DateTimeField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DateTimeField; });
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _TimeField_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TimeField.js */ "./lib/Core/widget/TimeField.js");
/* harmony import */ var _DateField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
var productName = 'taskboard';







/**
 * @module Core/widget/DateTimeField
 */

/**
 * A field combining a {@link Core.widget.DateField} and a {@link Core.widget.TimeField}.
 *
 * @extends Core/widget/Field
 * @classtype datetimefield
 * @inlineexample Core/widget/DateTimeField.js
 */

class DateTimeField extends _Field_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get configurable() {
    return {
      /**
       * Returns the TimeField instance
       * @readonly
       * @member {Core.widget.TimeField} timeField
       */

      /**
       * Configuration for {@link Core.widget.TimeField}
       * @config {Object}
       */
      timeField: {},

      /**
       * Returns the DateField instance
       * @readonly
       * @member {Core.widget.DateField} dateField
       */

      /**
       * Configuration for {@link Core.widget.DateField}
       * @config {Object}
       */
      dateField: {
        // To be able to use transformDateValue for parsing without loosing time, a bit of a hack
        keepTime: true,
        step: '1 d'
      },

      /**
       * The week start day in the {@link Core.widget.DateField#config-picker}, 0 meaning Sunday, 6 meaning Saturday.
       * Uses localized value per default.
       *
       * @config {Number}
       */
      weekStartDay: null,
      inputTemplate: () => ''
    };
  }

  static get $name() {
    return 'DateTimeField';
  }

  static get type() {
    return 'datetimefield';
  } // Factoryable type alias


  static get alias() {
    return 'datetime';
  }

  get focusElement() {
    return this.dateField.input;
  } // Implementation needed at this level because it has two inner elements in its inputWrap


  get innerElements() {
    return [this.dateField.element, this.timeField.element];
  } // Each subfield handles its own keystrokes


  internalOnKeyEvent() {} // CellEdit sets this dynamically on its editor field


  updateRevertOnEscape(revertOnEscape) {
    this.timeField.revertOnEscape = revertOnEscape;
    this.dateField.revertOnEscape = revertOnEscape;
  } // Converts the timeField config into a TimeField


  changeTimeField(config) {
    const me = this,
          result = _TimeField_js__WEBPACK_IMPORTED_MODULE_1__["default"].new({
      revertOnEscape: me.revertOnEscape,

      syncInvalid(...args) {
        const updatingInvalid = me.updatingInvalid;
        _TimeField_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.syncInvalid.apply(this, args);
        me.timeField && !updatingInvalid && me.syncInvalid();
      }

    }, config);
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
      element: result.element,
      keydown: 'onTimeFieldKeyDown',
      thisObj: me
    }); // Must set *after* construction, otherwise it becomes the default state
    // to reset readOnly back to

    if (me.readOnly) {
      result.readOnly = true;
    }

    return result;
  } // Set up change listener when TimeField is available. Not in timeField config to enable users to supply their own
  // listeners block there


  updateTimeField(timeField) {
    const me = this;
    timeField.on({
      change({
        userAction,
        value
      }) {
        if (userAction && !me.$settingValue) {
          const dateAndTime = me.dateField.value;
          me._isUserAction = true;
          me.value = dateAndTime ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].copyTimeValues(dateAndTime, value) : null;
          me._isUserAction = false;
        }
      },

      thisObj: me
    });
  } // Converts the dateField config into a class based on { type : "..." } provided (DateField by default)


  changeDateField(config) {
    const me = this,
          type = (config === null || config === void 0 ? void 0 : config.type) || 'datefield',
          cls = _Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"].resolveType(config.type || 'datefield'),
          result = _Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"].create(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({
      type,
      revertOnEscape: me.revertOnEscape,

      syncInvalid(...args) {
        const updatingInvalid = me.updatingInvalid;
        cls.prototype.syncInvalid.apply(this, args);
        me.dateField && !updatingInvalid && me.syncInvalid();
      }

    }, config));
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
      element: result.element,
      keydown: 'onDateFieldKeyDown',
      thisObj: me
    }); // Must set *after* construction, otherwise it becomes the default state
    // to reset readOnly back to

    if (me.readOnly) {
      result.readOnly = true;
    }

    result.on({
      keydown: ({
        event
      }) => {
        var _this$timeField;

        if (event.key === 'Tab' && !event.shiftKey && (_this$timeField = this.timeField) !== null && _this$timeField !== void 0 && _this$timeField.isVisible) {
          event.stopPropagation();
          event.cancelBubble = true;
        }
      }
    });
    return result;
  }

  get childItems() {
    return [this.dateField, this.timeField];
  } // Set up change listener when DateField is available. Not in dateField config to enable users to supply their own
  // listeners block there


  updateDateField(dateField) {
    const me = this;
    dateField.on({
      change({
        userAction,
        value
      }) {
        if (userAction && !me.$isInternalChange) {
          me._isUserAction = true;
          me.value = value;
          me._isUserAction = false;
        }
      },

      thisObj: me
    });
  }

  updateWeekStartDay(weekStartDay) {
    if (this.dateField) {
      this.dateField.weekStartDay = weekStartDay;
    }
  }

  changeWeekStartDay(value) {
    var _this$dateField$weekS, _this$dateField;

    return typeof value === 'number' ? value : (_this$dateField$weekS = (_this$dateField = this.dateField) === null || _this$dateField === void 0 ? void 0 : _this$dateField.weekStartDay) !== null && _this$dateField$weekS !== void 0 ? _this$dateField$weekS : _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].weekStartDay;
  } // Apply our value to our underlying fields


  syncInputFieldValue(skipHighlight = this.isConfiguring) {
    super.syncInputFieldValue(true);

    if (!skipHighlight && !this.highlightExternalChange) {
      skipHighlight = true;
    }

    const me = this,
          highlightDate = me.dateField.highlightExternalChange,
          highlightTime = me.timeField.highlightExternalChange;
    me.$isInternalChange = true;
    me.dateField.highlightExternalChange = false; // Prevent dateField from keeping its time value
    // TODO: Should be doable without this hack

    me.dateField.value = null;
    me.dateField.highlightExternalChange = highlightDate;

    if (skipHighlight) {
      me.timeField.highlightExternalChange = me.dateField.highlightExternalChange = false;
    }

    me.timeField.value = me.dateField.value = me.inputValue;
    me.dateField.highlightExternalChange = highlightDate;
    me.timeField.highlightExternalChange = highlightTime;
    me.$isInternalChange = false; // Must evaluate after child fields have been updated since our validity state depends on theirs.

    me.syncInvalid();
  }

  onTimeFieldKeyDown(e) {
    const me = this; // we need to handle keydown for composed field manually and before it's done by cellEdit feature

    if (e.key === 'Enter' || e.key === 'Tab') {
      const dateAndTime = me.dateField.value;
      me._isUserAction = true;
      me.value = dateAndTime ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].copyTimeValues(dateAndTime, me.timeField.value) : null;
      me._isUserAction = false;
    }
  }

  onDateFieldKeyDown(e) {
    const me = this;

    if (e.key === 'Tab') {
      e.stopPropagation();
      e.preventDefault();
      me.timeField.focus();
    } // we need to handle keydown for composed field manually and before it's done by cellEdit feature


    if (e.key === 'Enter') {
      me.value = me.dateField.value;
    }
  } // Make us and our underlying fields required


  updateRequired(required, was) {
    this.timeField.required = this.dateField.required = required;
  }

  updateReadOnly(readOnly, was) {
    super.updateReadOnly(readOnly, was);

    if (!this.isConfiguring) {
      this.timeField.readOnly = this.dateField.readOnly = readOnly;
    }
  } // Make us and our underlying fields disabled


  onDisabled(value) {
    this.timeField.disabled = this.dateField.disabled = value;
  }

  focus() {
    this.dateField.focus();
  }

  hasChanged(oldValue, newValue) {
    return !_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isEqual(oldValue, newValue);
  }

  get isValid() {
    return this.timeField.isValid && this.dateField.isValid;
  }

  setError(error, silent) {
    [this.dateField, this.timeField].forEach(f => f.setError(error, silent));
  }

  getErrors() {
    const errors = [...(this.dateField.getErrors() || []), ...(this.timeField.getErrors() || [])];
    return errors.length ? errors : null;
  }

  clearError(error, silent) {
    [this.dateField, this.timeField].forEach(f => f.clearError(error, silent));
  }

  updateInvalid() {
    // use this flag in this level to avoid looping
    this.updatingInvalid = true;
    [this.dateField, this.timeField].forEach(f => f.updateInvalid());
    this.updatingInvalid = false;
  }

}
DateTimeField.initClass();
DateTimeField._$name = 'DateTimeField';

/***/ }),

/***/ "./lib/Core/widget/DisplayField.js":
/*!*****************************************!*\
  !*** ./lib/Core/widget/DisplayField.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DisplayField; });
/* harmony import */ var _TextField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'taskboard';


/**
 * @module Core/widget/DisplayField
 */

/**
 * A widget used to show a read only value. Can also use a {@link #config-template template string} to show custom
 * markup inside a Container.
 *
 * @extends Core/widget/Field
 *
 * @example
 * let displayField = new DisplayField({
 *   appendTo : document.body,
 *   label: 'name',
 *   value : 'John Doe',
 *   // or use a template
 *   // template : name => `${name} is the name`
 * });
 *
 * @classType displayField
 * @inlineexample Core/widget/DisplayField.js
 */

class DisplayField extends _TextField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'DisplayField';
  } // Factoryable type name


  static get type() {
    return 'displayfield';
  } // Factoryable type alias


  static get alias() {
    return 'display';
  }

  static get configurable() {
    return {
      readOnly: true,
      editable: false,
      cls: 'b-display-field',

      /**
       * A template string used to render the value of this field. Please note you are responsible for encoding
       * any strings protecting against XSS.
       *
       * ```javascript
       * new DisplayField({
       *     appendTo : document.body,
       *     name     : 'age',
       *     label    : 'Age',
       *     template : data => `${data.value} years old`
       * })
       * ```
       * @config {Function}
       */
      template: null
    };
  }

  get focusElement() {// we're not focusable.
  }

  changeReadOnly() {
    return true;
  }

  changeEditable() {
    return false;
  }

  get inputElement() {
    return {
      tag: 'span',
      html: this.template ? this.template(this.value) : _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].encodeHtml(this.value)
    };
  }

} // Register this widget type with its Factory

DisplayField.initClass();
DisplayField._$name = 'DisplayField';

/***/ }),

/***/ "./lib/Core/widget/DurationField.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/DurationField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DurationField; });
/* harmony import */ var _TextField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _data_Duration_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/Duration.js */ "./lib/Core/data/Duration.js");
var productName = 'taskboard';




/**
 * @module Core/widget/DurationField
 */

/**
 * A specialized field allowing a user to also specify duration unit when editing the duration value.
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the `DurationColumn`.
 *
 * @extends Core/widget/TextField
 * @classType durationfield
 * @inlineexample Core/widget/DurationField.js
 */

class DurationField extends _TextField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'DurationField';
  } // Factoryable type name


  static get type() {
    return 'durationfield';
  } // Factoryable type alias


  static get alias() {
    return 'duration';
  }

  static get defaultConfig() {
    return {
      /**
       * The `value` config may be set in Object form specifying two properties,
       * `magnitude`, a Number, and `unit`, a String.
       *
       * If a String is passed, it is parsed in accordance with current locale rules.
       * The string is taken to be the numeric magnitude, followed by whitespace, then an abbreviation, or name of
       * the unit.
       * @config {Object|String}
       * @category Common
       */
      value: null,

      /**
       * Step size for spin button clicks.
       * @config {Number}
       * @default
       * @category Common
       */
      step: 1,

      /**
       * The duration unit to use with the current magnitude value.
       * @config {String}
       * @category Common
       */
      unit: null,
      defaultUnit: 'day',

      /**
       * The duration magnitude to use with the current unit value. Can be either an integer or a float value.
       * Both "," and "." are valid decimal separators.
       * @config {Number}
       * @category Common
       */
      magnitude: null,

      /**
       * When set to `true` the field will use short names of unit durations
       * (as returned by {@link Core.helper.DateHelper#function-getShortNameOfUnit-static}) when creating the
       * input field's display value.
       * @config {Boolean}
       * @category Common
       */
      useAbbreviation: false,

      /**
       * Set to `true` to allow negative duration
       * @config {Boolean}
       * @category Common
       */
      allowNegative: false,

      /**
       * The number of decimal places to allow. Defaults to no constraint.
       * @config {Number}
       * @default
       * @category Common
       */
      decimalPrecision: null,
      triggers: {
        spin: {
          type: 'spintrigger'
        }
      },
      nullValue: null
    };
  }
  /**
   * Fired when this field's value changes.
   * @event change
   * @param {Core.data.Duration} value - This field's value
   * @param {Core.data.Duration} oldValue - This field's previous value
   * @param {Boolean} valid - True if this field is in a valid state.
   * @param {Event} [event] - The triggering DOM event if any.
   * @param {Boolean} userAction - Triggered by user taking an action (`true`) or by setting a value (`false`)
   * @param {Core.widget.DurationField} source - This field
   */

  /**
   * User performed default action (typed into this field or hit the triggers).
   * @event action
   * @param {Core.data.Duration} value - This field's value
   * @param {Core.data.Duration} oldValue - This field's previous value
   * @param {Boolean} valid - True if this field is in a valid state.
   * @param {Event} [event] - The triggering DOM event if any.
   * @param {Boolean} userAction - Triggered by user taking an action (`true`) or by setting a value (`false`)
   * @param {Core.widget.DurationField} source - This field
   */


  static get configurable() {
    return {
      /**
       * Minimum duration value (e.g. 1d)
       * @config {String}
       * @category Common
       */
      min: null,

      /**
       * Max duration value (e.g. 10d)
       * @config {String}
       * @category Common
       */
      max: null,

      /**
       * Comma-separated list of units to allow in this field, e.g. "day,hour,year". Leave blank to allow all
       * valid units (the default)
       * @config {String}
       * @category Common
       */
      allowedUnits: null
    };
  }

  changeMin(value) {
    return typeof value === 'string' ? new _data_Duration_js__WEBPACK_IMPORTED_MODULE_3__["default"](value) : value;
  }

  changeMax(value) {
    return typeof value === 'string' ? new _data_Duration_js__WEBPACK_IMPORTED_MODULE_3__["default"](value) : value;
  }

  changeAllowedUnits(units) {
    if (typeof units === 'string') {
      units = units.split(',');
    }

    return units;
  }

  updateAllowedUnits(units) {
    this.allowedUnitsRe = new RegExp(`(${units.join('|')})`, 'i');
  }

  get inputValue() {
    // Do not use the _value property. If called during configuration, this
    // will import the configured value from the config object.
    return this.value == null ? '' : this.calcValue(true).toString(this.useAbbreviation);
  }
  /**
   * Get/Set duration unit to use with the current magnitude value.
   * Valid values are:
   * - "millisecond" - Milliseconds
   * - "second" - Seconds
   * - "minute" - Minutes
   * - "hour" - Hours
   * - "day" - Days
   * - "week" - Weeks
   * - "month" - Months
   * - "quarter" - Quarters
   * - "year"- Years
   *
   * @property {String}
   * @category Common
   */


  set unit(unit) {
    this._unit = unit;
    this.value = this.calcValue();
  }

  get unit() {
    return this._unit;
  }

  get unitWithDefault() {
    return this._unit || DurationField.defaultConfig.defaultUnit;
  }
  /**
   * Get/Set numeric magnitude `value` to use with the current unit value.
   * @property {Number}
   * @category Common
   */


  set magnitude(magnitude) {
    this.clearError('L{invalidUnit}');
    this._magnitude = magnitude;
    super.value = this.calcValue();
  }

  get magnitude() {
    return this._magnitude;
  }

  roundMagnitude(value) {
    return value && this.decimalPrecision != null ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].round(value, this.decimalPrecision) : value;
  }

  get allowDecimals() {
    return this.decimalPrecision !== 0;
  }

  get isValid() {
    const me = this,
          isEmpty = me.value == null || me.value && me.value.magnitude == null;
    return super.isValid && (isEmpty && !me.required || !isEmpty && (me.allowNegative || me.value.magnitude >= 0));
  }

  internalOnChange(event) {
    const me = this,
          value = me.value,
          oldVal = me._lastValue;

    if (me.hasChanged(oldVal, value)) {
      me._lastValue = value;
      me.triggerFieldChange({
        value,
        event,
        userAction: true,
        valid: me.isValid
      });
    }
  }

  onFocusOut(e) {
    this.syncInputFieldValue(true);
    return super.onFocusOut(e);
  }
  /**
   * The `value` property may be set in Object form specifying two properties, `magnitude`, a Number, and `unit`, a
   * String.
   *
   * If a Number is passed, the field's current unit is used and just the magnitude is changed.
   *
   * If a String is passed, it is parsed in accordance with current locale rules. The string is taken to be the
   * numeric magnitude, followed by whitespace, then an abbreviation, or name of the unit.
   *
   * Upon read, the value is always a {@link Core.data.Duration Duration} object containing `magnitude` and `unit`.
   *
   * @property {Core.data.Duration}
   * @accepts {String|Number|Object|Core.data.Duration}
   * @category Common
   */


  set value(value) {
    const me = this;
    let newMagnitude, newUnit;
    this.clearError('L{invalidUnit}');

    if (typeof value === 'number') {
      // A number means preserving existing unit value
      newMagnitude = value;
      newUnit = me._unit;
    } else if (typeof value === 'string') {
      // Parse as a string
      const parsedDuration = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parseDuration(value, me.allowDecimals, me.unitWithDefault);

      if (parsedDuration) {
        if (!me.allowedUnitsRe || me.allowedUnitsRe.test(parsedDuration.unit)) {
          newUnit = parsedDuration.unit;
          newMagnitude = parsedDuration.magnitude;
        } else {
          me.setError('L{invalidUnit}');
        }
      }
    } else {
      // Using value object with unit and magnitude
      if (value && 'unit' in value && 'magnitude' in value) {
        newUnit = value.unit;
        newMagnitude = value.magnitude;
      } else {
        newUnit = null;
        newMagnitude = null;
      }
    }

    if (me._magnitude !== newMagnitude || me._unit !== newUnit) {
      me._magnitude = newMagnitude;
      me._unit = newUnit;
      super.value = me.calcValue();
    }
  }

  okMax(value) {
    if (typeof value === 'number') {
      value = new _data_Duration_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
        unit: this.unitWithDefault,
        magnitude: value
      });
    }

    return this.max == null || value <= this.max;
  }

  okMin(value) {
    if (typeof value === 'number') {
      value = new _data_Duration_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
        unit: this.unitWithDefault,
        magnitude: value
      });
    }

    return this.min == null || value >= this.min;
  }

  get validity() {
    const value = this.value,
          validity = {}; // Assert range for non-empty fields, empty fields will turn invalid if `required: true`

    if (value != null) {
      validity.rangeUnderflow = !this.okMin(value);
      validity.rangeOverflow = !this.okMax(value);
    }

    validity.valid = !validity.rangeUnderflow && !validity.rangeOverflow;
    return validity;
  }

  get value() {
    return super.value;
  }

  calcValue(round = false) {
    const me = this;

    if ((!me._unit || me._magnitude == null) && me.clearable) {
      return null;
    } else {
      return new _data_Duration_js__WEBPACK_IMPORTED_MODULE_3__["default"](round ? this.roundMagnitude(me._magnitude) : this._magnitude, me.unitWithDefault);
    }
  }

  hasChanged(oldValue, newValue) {
    return newValue && !oldValue || !newValue && oldValue || newValue && oldValue && !oldValue.isEqual(newValue);
  }
  /**
   * The `milliseconds` property is a read only property which returns the number of milliseconds in this field's
   * value
   * @member {Number} milliseconds
   * @readonly
   */


  get milliseconds() {
    // For reasons unknown documenting as @property did not work
    return this.value ? this.value.milliseconds : 0;
  }

  onInternalKeyDown(keyEvent) {
    if (keyEvent.key === 'ArrowUp') {
      this.doSpinUp();
    } else if (keyEvent.key === 'ArrowDown') {
      this.doSpinDown();
    }
  }

  doSpinUp() {
    const me = this;
    let newValue = (me.magnitude || 0) + me.step;
    me._isUserAction = true;

    if (!me.okMin(newValue)) {
      newValue = me.min;
    }

    if (me.okMax(newValue)) {
      me.value = newValue;
    }

    me._isUserAction = false;
  }

  doSpinDown() {
    const me = this;
    let newValue = (me.magnitude || 0) - me.step;

    if (!me.okMax(newValue)) {
      newValue = me.max;
    }

    if (me.okMin(newValue) && (me.allowNegative || (me.magnitude || 0) > 0)) {
      me._isUserAction = true;
      me.value = newValue;
      me._isUserAction = false;
    }
  }

} // Register this widget type with its Factory

DurationField.initClass();
DurationField._$name = 'DurationField';

/***/ }),

/***/ "./lib/Core/widget/Editor.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Editor.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Editor; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/widget/Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _layout_Fit_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./layout/Fit.js */ "./lib/Core/widget/layout/Fit.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../helper/ResizeMonitor.js */ "./lib/Core/helper/ResizeMonitor.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';










/**
 * @module Core/widget/Editor
 */

/**
 * Displays an input field, optionally editing a field of a record at a particular position.
 *
 * Offers events to signal edit completion upon `ENTER` or focus loss (if configured to do so),
 * or edit cancellation on `ESC`, or focus loss if configured that way.
 * @extends Core/widget/Container
 *
 * @classType Editor
 */

class Editor extends _Container_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'Editor';
  } // Factoryable type name


  static get type() {
    return 'editor';
  }

  static get configurable() {
    return {
      positioned: true,
      hidden: true,
      layout: 'fit',
      align: {
        align: 't0-t0',
        offset: [0, 0]
      },

      /**
       * A config object, or the `type` string of the widget (usually a {@link Core.widget.Field Field} subclass,
       * i.e. {@link Core.widget.TextField TextField}) which this editor will encapsulate.
       * @config {Object|String}
       * @default
       */
      inputField: 'textfield',

      /**
       * What action should be taken when focus moves out of the editor, either by `TAB` or clicking outside.
       * May be `'complete'` or `'cancel`'. Any other value results in no action being taken upon focus leaving the editor
       * leaving the application to listen for the {@link #event-focusOut focusOut} event.
       * @config {String}
       * @default
       */
      blurAction: 'complete',

      /**
       * The name of the `key` which completes the edit.
       *
       * See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values for key names.
       * @config {String}
       * @default
       */
      completeKey: 'Enter',

      /**
       * The name of the `key` which cancels the edit.
       *
       * See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values for key names.
       * @config {String}
       * @default
       */
      cancelKey: 'Escape',

      /**
       * How to handle a request to complete the edit if the field is invalid. There are three choices:
       *  - `block` The default. The edit is not exited, the field remains focused.
       *  - `allow` Allow the edit to be completed.
       *  - `revert` The field value is reverted and the edit is completed.
       * @config {String}
       * @default
       */
      invalidAction: 'block',

      /**
       * Configure as `true` to have editing complete as soon as the field fires its `change` event.
       * @config {Boolean}
       * @default false
       */
      completeOnChange: null,
      isolateFields: true
    };
  } //endregion
  //region Events

  /**
   * Fired before the editor is shown to start an edit operation. Returning `false` from a handler vetoes the edit operation.
   * @event beforeStart
   * @param {Object} value - The value to be edited.
   * @preventable
   */

  /**
   * Fired when an edit operation has begun.
   * @event start
   * @param {Object} value - The starting value of the field.
   * @param {Core.widget.Editor} source - The Editor that triggered the event.
   */

  /**
   * Fired when an edit completion has been requested, either by `ENTER`, or focus loss (if configured to complete on blur).
   * The completion may be vetoed, in which case, focus is moved back into the editor.
   * @event beforeComplete
   * @param {Object} oldValue - The original value.
   * @param {Object} value - The new value.
   * @param {Core.widget.Editor} source - The Editor that triggered the event.
   * @param {Function} [finalize] An async function may be injected into this property
   * which performs asynchronous finalization tasks such as complex validation of confirmation. The
   * value `true` or `false` must be returned.
   * @param {Object} [finalize.context] An object describing the editing context upon requested completion of the edit.
   * @preventable
   */

  /**
   * Edit has been completed, and any associated record or element has been updated.
   * @event complete
   * @param {Object} oldValue - The original value.
   * @param {Object} value - The new value.
   * @param {Core.widget.Editor} source - The Editor that triggered the event.
   */

  /**
   * Fired when cancellation has been requested, either by `ESC`, or focus loss (if configured to cancel on blur).
   * The cancellation may be vetoed, in which case, focus is moved back into the editor.
   * @event beforeCancel
   * @param {Object} oldValue - The original value.
   * @param {Object} value - The new value.
   * @param {Event} event - Included if the cancellation was triggered by a DOM event
   * @param {Core.widget.Editor} source - The Editor that triggered the event.
   * @preventable
   */

  /**
   * Edit has been canceled without updating the associated record or element.
   * @event cancel
   * @param {Object} oldValue - The original value.
   * @param {Object} value - The value of the field.
   * @param {Event} event - Included if the cancellation was triggered by a DOM event
   * @param {Core.widget.Editor} source - The Editor that triggered the event.
   */

  /**
   * Fire to relay a `keypress` event from the field.
   * @event keypress
   * @param {Event} event - The key event.
   */
  //endregion


  afterConfigure() {
    const me = this;
    super.afterConfigure();
    me.onTargetSizeChange = me.onTargetSizeChange.bind(me);
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on({
      element: me.element,
      keydown: 'onKeyDown',
      thisObj: me
    });
    me.on({
      hide: 'afterEditorHide',
      thisObj: me
    });
    _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
      locale: 'onLocaleChange',
      thisObj: me
    });
  }

  onLocaleChange() {
    const {
      inputField
    } = this;

    if (inputField && !inputField.isDestroyed) {
      // All Field subclasses have this method, but if `inputField` is a custom widget,
      // `syncInputFieldValue` has to be implemented
      if (inputField.syncInputFieldValue) {
        inputField.syncInputFieldValue(true);
      } else if (!(inputField instanceof _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_5__["default"])) {}
    }
  }
  /**
   * Start editing
   * @param {Object} editObject An object containing details about what to edit.
   * @param {HTMLElement|Core.helper.util.Rectangle} editObject.target the element or Rectangle to align to.
   * @param {String} [editObject.align=t0-t0] How to align to the target.
   * @param {Boolean} [editObject.matchSize=true] Match editor size to target size.
   * @param {Boolean} [editObject.matchFont=true] Match editor's font-size size to target's font-size.
   * @param {Core.data.Model} [editObject.record] The record to edit.
   * @param {String} [editObject.field] The field name in the record to edit. This defaults to the `name` of the {@link #config-inputField}.
   * Also if record has method set + capitalized field, method will be called, e.g. if record has method named
   * `setFoobar` and this config is `foobar`, then instead of `record.foobar = value`, `record.setFoobar(value)` will be called.
   * @param {Object} [editObject.value] The value to edit.
   * @param {Boolean} [editObject.focus=true] Focus the field.
   * @param {Boolean} [editObject.fitTargetContent] Pass `true` to allow the Editor to expand beyond the
   * width of its target element if its content overflows horizontally. This is useful if the editor has
   * triggers to display, such as a combo.
   */


  startEdit({
    target,
    align = this.align,
    hideTarget = false,
    matchSize = true,
    matchFont = true,
    fitTargetContent = false,
    value,
    record,
    field = this.inputField.name,
    focus = true
  }) {
    const me = this,
          {
      inputField
    } = me,
          targetFontSize = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getStyleValue(target, 'font-size'),
          targetFontFamily = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getStyleValue(target, 'font-family');

    if (me.trigger('beforeStart', {
      value
    }) !== false) {
      var _inputField$value$;

      if (record && field) {
        me.record = record;
        me.dataField = field;

        if (value === undefined) {
          value = record[field];
        }
      }

      if (matchSize) {
        if (target instanceof HTMLElement) {
          me.updateSize(target);
        } // If we are editing and sizing based on an element,
        // we need to update editor size if grid cell size changes
        // Removed in 'hide' listener


        if (target instanceof HTMLElement) {
          _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].addResizeListener(target, me.onTargetSizeChange);
        }
      }

      if (inputField.input) {
        if (matchFont) {
          inputField.input.style.fontSize = targetFontSize;
          inputField.input.style.fontFamily = targetFontFamily;
        } else {
          inputField.input.style.fontSize = inputField.input.style.fontFamily = '';
        }
      }

      me._isSettingValues = true; // In case our finalize code set it to invalid, start it clear of errors.

      if (inputField.clearError) {
        inputField.clearError();
      }

      inputField.value = value;
      me._isSettingValues = false; // Simplest form is 't0-t0', but may be passed as full object spec.
      // It gets expanded below so must be an object.

      if (typeof align === 'string') {
        align = {
          align
        };
      }

      me.showBy(_objectSpread({
        target
      }, align));

      if (fitTargetContent) {
        // Input doesn't fit, so widen it
        const overflow = inputField.input.scrollWidth - inputField.input.clientWidth;

        if (overflow > 0) {
          me.width += overflow + _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].scrollBarWidth;
        }
      }

      if (focus && me.inputField.focus) {
        me.inputField.focus();
      }

      if (target.nodeType === Element.ELEMENT_NODE) {
        target.classList.add('b-editing');

        if (hideTarget) {
          target.classList.add('b-hide-visibility');
        }
      }

      me.editing = true; // Passed value may have been '10/06/2019', send the live field value to startedit

      me.trigger('start', {
        value: inputField.value
      });

      if (Array.isArray(inputField.value) && inputField.editingRecords && (_inputField$value$ = inputField.value[0]) !== null && _inputField$value$ !== void 0 && _inputField$value$.isModel) {
        // If this editor is editing model instances, save a cloned copy in case fields
        // are changed
        me.oldValue = inputField.value.map(record => record.copy(record.id));
      } else {
        me.oldValue = inputField.value; // If the value from the value getter is an array, we must clone it because
        // if it's the same *instance*, the ObjectHelper.isEqual test in completeEdit
        // will find that there are no changes.

        if (Array.isArray(me.oldValue)) {
          me.oldValue = me.oldValue.slice();
        }
      } // The initialValue is what the revertOnEscape uses by preference before it uses its valueOnFocus.
      // In an Editor, it can focus in and out but still need that correct initial value.


      inputField.initialValue = me.oldValue;
      return true;
    }

    return false;
  }

  refreshEdit() {
    if (this.isVisible) {
      const {
        record,
        dataField,
        inputField
      } = this;

      if (record && dataField) {
        const value = record[dataField]; // Only update the field if the value has changed

        if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(inputField.value, value)) {
          inputField.value = value;
        }
      }
    }
  }

  finishEdit() {
    const {
      target,
      aligningToElement
    } = this.lastAlignSpec;

    if (aligningToElement) {
      target.classList.remove('b-editing');
      target.classList.remove('b-hide-visibility');
    }

    this.editing = false; // Internal event, to be able to destroy etc no matter if completed or cancelled

    this.trigger('finishEdit');
  }

  onKeyDown(event) {
    var _me$trigger;

    const me = this;

    switch (event.key) {
      case me.completeKey:
        me.completeEdit(null, event);
        event.stopImmediatePropagation();
        break;

      case me.cancelKey:
        me.cancelEdit(event);
        event.stopImmediatePropagation();
        break;
    } // In case destroyed by complete or cancel


    (_me$trigger = me.trigger) === null || _me$trigger === void 0 ? void 0 : _me$trigger.call(me, 'keydown', {
      event
    });
  }

  onFocusOut(event) {
    super.onFocusOut(event);
    const me = this;

    if (!me.isFinishing && me.editing) {
      const method = me[`${me.blurAction}Edit`];
      method === null || method === void 0 ? void 0 : method.call(me);
    }
  }
  /**
   * Complete the edit, and, if associated with a record, update the record if possible.
   * If editing is completed, the editor is hidden.
   *
   * If the field is invalid, the `{@link #config-invalidAction}` config is used to decide
   * upon the course of action.
   *
   * If a {@link #event-beforeComplete} handler returns `false` then editing is not completed.
   *
   * If the field's values has not been changed, then editing is terminated through {@link #function-cancelEdit}.
   *
   * @returns `true` if editing ceased, `false` if the editor is still active.
   * @async
   */


  async completeEdit(finalize, triggeredByEvent) {
    const me = this,
          {
      inputField,
      oldValue,
      record
    } = me,
          invalidAction = inputField.invalidAction || (inputField.allowInvalid === false ? 'block' : me.invalidAction),
          {
      value
    } = inputField; // If we are not editing, we should manipulated the field or not fire any events

    if (!me.isVisible) {
      return;
    } // If we're configured not to allow invalid values, refocus the field in case complete was triggered by focusout.


    if (!inputField.isValid && invalidAction !== 'allow') {
      if (invalidAction === 'block') {
        inputField.focus && inputField.focus();
        return false;
      } else if (invalidAction === 'revert') {
        me.cancelEdit(triggeredByEvent);
        return true;
      }
    } // No change means a cancel.
    else if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(value, oldValue)) {
      me.cancelEdit(triggeredByEvent);
      return true;
    } // Allow veto of the completion
    else {
      const context = {
        inputField,
        record,
        value,
        oldValue
      };

      if (me.trigger('beforeComplete', context) === false) {
        inputField.focus && inputField.focus();
      } else {
        // CellEdit#onEditorBeforeComplete injects editorContext into the basic context
        if (!finalize) {
          finalize = context.finalize || context.editorContext && context.editorContext.finalize;
        } // Allow async finalization of the editing, implementer may want to show a confirmation popup etc


        if (finalize) {
          let result = await finalize(context);

          if (result === true) {
            me.onEditComplete();
          } else {
            if (inputField.setError) {
              const error = result || inputField.invalidValueError,
                    clearError = () => {
                listeners();
                inputField.clearError(error);
              },
                    listeners = inputField.on({
                change: clearError,
                input: clearError
              }); // Mark as invalid. Because this is decided upon without the knowledge
              // of the field, this state will be rescinded upon the next change of
              // input field.


              inputField.setError(error);
            }

            if (invalidAction === 'block') {
              inputField.focus && inputField.focus();
            } else if (invalidAction === 'revert') {
              inputField.value = oldValue;
              result = true;
            }

            result = false;
          }

          return result;
        } // Successful completion
        else {
          me.onEditComplete();
          return true;
        }
      }
    }

    return false;
  }
  /**
   * Cancel the edit and hide the editor.
   */


  cancelEdit(triggeredByEvent) {
    const me = this,
          {
      inputField,
      oldValue
    } = me,
          {
      value
    } = inputField;

    if (me.editing && !me.isFinishing && me.trigger('beforeCancel', {
      value,
      oldValue,
      event: triggeredByEvent
    }) !== false) {
      // Hiding must not trigger our blurAction
      me.isFinishing = true;
      me.hide();
      me.trigger('cancel', {
        value,
        oldValue,
        event: triggeredByEvent
      });
      me.finishEdit();
      me.isFinishing = false;
    }
  } // Handle updating what needs to be updated.


  onEditComplete() {
    const me = this,
          {
      record,
      dataField,
      inputField,
      oldValue
    } = me,
          {
      value
    } = inputField;

    if (!me.isFinishing) {
      // Hiding must not trigger our blurAction
      me.isFinishing = true;
      me.hide();

      if (record) {
        const setterName = `set${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].capitalize(dataField)}`;

        if (record[setterName]) {
          record[setterName](value);
        } else if (dataField.includes('.')) {
          record.set(dataField, value);
        } else {
          record[dataField] = value;
        }
      }

      me.trigger('complete', {
        value,
        oldValue
      });
      me.finishEdit();
      me.isFinishing = false;
    }
  }

  doDestroy() {
    if (this.createdInputField) {
      this.inputField.destroy();
    }

    super.doDestroy();
  }

  set owner(owner) {
    this._owner = owner;
  } // This is a positioned widget appended to a Widget's contentElement. It may have no owner link.
  // Grab the owner by finding what widget it is inside.


  get owner() {
    return this._owner || _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromElement(this.element.parentNode);
  }

  changeInputField(inputField, oldInputField) {
    const me = this;

    if (oldInputField) {
      oldInputField.destroy();
    }

    if (typeof inputField === 'string') {
      inputField = {
        type: inputField
      };
    }

    if (!(inputField instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
      inputField = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].create(inputField);
      me.createdInputField = true; // So we know we can destroy it
    }

    if (me.completeOnChange) {
      inputField.on({
        change: 'onInputFieldChange',
        thisObj: me
      });
    }

    inputField.parent = me;
    return inputField;
  }

  updateInputField(inputField) {
    this.removeAll();
    this.add(inputField);
  }

  get inputField() {
    return this.items[0];
  }

  onInputFieldChange() {
    if (this.containsFocus) {
      this.completeEdit();
    }
  }

  onTargetSizeChange(resizedElement, oldRect, newRect) {
    if (oldRect && newRect) {
      this.updateSize(resizedElement);
    }
  }

  updateSize(targetEl) {
    const rect = targetEl.getBoundingClientRect();
    this.width = rect.width - this.align.offset[0];
    this.height = rect.height;
  }

  afterEditorHide() {
    _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(this.lastAlignSpec.target, this.onTargetSizeChange);
  }

} // Register this widget type with its Factory

Editor.initClass();
Editor._$name = 'Editor';

/***/ }),

/***/ "./lib/Core/widget/Field.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Field.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Field; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _mixin_Badge_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/Badge.js */ "./lib/Core/widget/mixin/Badge.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../util/ClickRepeater.js */ "./lib/Core/util/ClickRepeater.js");
/* harmony import */ var _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../util/DynamicObject.js */ "./lib/Core/util/DynamicObject.js");
var productName = 'taskboard';










/**
 * @module Core/widget/Field
 */

const byWeight = (l, r) => (l.weight || 0) - (r.weight || 0),
      byWeightReverse = (l, r) => (r.weight || 0) - (l.weight || 0),
      emptyArray = [],
      triggerConfigs = {
  align: true,
  weight: true
};
/**
 * Base class for {@link Core.widget.TextField TextField} and {@link Core.widget.NumberField NumberField}. Not to be used directly.
 * All subclasses can be used as editors for the {@link Grid.column.Column Column}. The most popular are:
 * - {@link Core.widget.TextField TextField}
 * - {@link Core.widget.NumberField NumberField}
 * - {@link Core.widget.DateField DateField}
 * - {@link Core.widget.TimeField TimeField}
 * - {@link Core.widget.Combo Combo}
 *
 * @extends Core/widget/Widget
 * @mixes Core/widget/mixin/Badge
 * @abstract
 */


class Field extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  //region Config
  static get $name() {
    return 'Field';
  } // Factoryable type name


  static get type() {
    return 'field';
  }

  static get configurable() {
    return {
      defaultBindProperty: 'value',

      /**
       * @hideconfigs htmlCls, content, tag, scrollable, html
       */

      /**
       * Text to display in empty field.
       * @config {String} placeholder
       */
      placeholder: null,

      /**
       * Gets or sets the value. The returned type will depend upon the Field subclass.
       *
       * `TextField` returns a `String`.
       *
       * `NumberField` returns a `Number`.
       *
       * `DateField` and `TimeField` return a `Date` object, and `null` if the field is empty.
       *
       * `Combo` will return a `String` if configured with `items` as a simple string array.
       * Otherwise it will return the {@link Core.widget.Combo#config-valueField} value from the
       * selected record, or `null` if no selection has been made.
       * @member {*} value
       */

      /**
       * Default value
       * @config {String}
       */
      value: '',

      /**
       * Name of the field which is used as a key to get/set values from/to the field.
       * Used prior to {@link Core.widget.Widget#config-ref ref} and {@link Core.widget.Widget#config-id id} in
       * {@link Core.widget.Container#property-values Container.values}.
       *
       * The config is useful when the field is used in EventEditor or TaskEditor to load/save values automatically.
       * @config {String}
       */
      name: null,

      /**
       * Get/set fields label. Please note that the Field needs to have a label specified from start for this to
       * work, otherwise no element is created.
       * @member {String} label
       */

      /**
       * Label, prepended to field
       * @config {String}
       * @category Label
       */
      label: null,

      /**
       * Label position, either 'before' the field or or 'above' the field
       * @config {String}
       * @default
       * @category Label
       */
      labelPosition: 'before',

      /**
       * CSS class name or class names to add to any configured {@link #config-label}
       * @config {String|Object}
       * @category Label
       */
      labelCls: null,

      /**
       * The labels to add either before or after the input field.
       * Each label may have the following properties:
       * * `html` The label text.
       * * `align` `'start'` or `'end'` which end of the field the label should go.
       * @config {Object}
       * @category Label
       */
      labels: null,

      /**
       * The width to apply to the `<label>` element. If a number is specified, `px` will be used.
       * @config {String|Number}
       * @localizable
       * @category Label
       */
      labelWidth: {
        value: null,
        $config: {
          localeKey: 'L{labelWidth}'
        }
      },

      /**
       * Configure as `true` to indicate that a `null` field value is to be marked as invalid.
       * @config {Boolean}
       * @default false
       */
      required: null,

      /**
       * Show a trigger to clear field, and allow `ESC` key to clear field if this field is
       * not {@link #config-readOnly}. The trigger is available in the {@link #property-triggers} object
       * under the name `clear`. May also be an object which configures the `clear` {@link #property-triggers trigger}.
       * @config {Boolean|Object}
       * @default false
       */
      clearable: null,

      /**
       * If this field is not {@link #config-readOnly}, then setting this option means that pressing
       * the `ESCAPE` key after editing the field will revert the field to the value it had when
       * the user focused the field. If the field is _not_ changed from when focused, the {@link #config-clearable}
       * behaviour will be activated.
       * @config {Boolean}
       * @default false
       */
      revertOnEscape: null,

      /**
       * An optional string to display inside the input field as an overlay. This can be useful for displaying
       * a field's units.
       *
       * This config is ignored if {@link #config-hintHtml} is set.
       *
       * For example:
       * ```javascript
       *  {
       *      type  : 'numberfield',
       *      label : 'Temperature',
       *      hint  : '°C'
       *  }
       * ```
       *
       * This config can be set to a function to dynamically generate the `hint` text:
       * ```javascript
       *  {
       *      type  : 'numberfield',
       *      label : 'Duration',
       *      hint  : ({ value }) => (value === 1) ? 'Day' : 'Days'
       *  }
       * ```
       *
       * The function is passed an object with the following properties:
       *
       *  - `source` A reference to the field instance.
       *  - `value` The current value of the field.
       *
       * A `hint` function will be called when the field changes value.
       *
       * @config {String|Function}
       * @category Label
       */
      hint: null,

      /**
       * This config is similar to {@link #config-hint} except that this config is used to display HTML content.
       * Since this can allow malicious content to be executed, be sure not to include user-entered data or to
       * encode such data (see {@link Core.helper.StringHelper#function-encodeHtml-static}).
       *
       * If this config is set, {@link #config-hint} is ignored.
       *
       * For example:
       * ```javascript
       *  {
       *      type     : 'numberfield',
       *      label    : 'Temperature',
       *      hintHtml : '<i>°C</i>'
       *  }
       * ```
       *
       * This config can be set to a function to dynamically generate the `hintHtml` text:
       * ```javascript
       *  {
       *      type     : 'numberfield',
       *      label    : 'Duration',
       *      hintHtml : ({ value }) => (value === 1) ? '<i>Day</i>' : '<i>Days</i>'
       *  }
       * ```
       *
       * The function is passed an object with the following properties:
       *
       *  - `source` A reference to the field instance.
       *  - `value` The current value of the field.
       *
       * A `hintHtml` function will be called when the field changes value.
       *
       * @config {String|Function}
       * @category Label
       */
      hintHtml: null,

      /**
       * The width to apply to the `<input>` element. If a number is specified, `px` will be used.
       * @config {String|Number}
       * @category Input element
       */
      inputWidth: null,

      /**
       * The delay in milliseconds to wait after the last keystroke before triggering a change event.
       * Set to 0 to not trigger change events from keystrokes (listen for input event instead to have
       * immediate feedback, change will still be triggered on blur)
       * @config {Number}
       * @default
       */
      keyStrokeChangeDelay: 0,

      /**
       * Makes the field unmodifiable by user action. The input area is not editable, and triggers
       * are unresponsive.
       *
       * This is a wider-acting setting than {@link #config-editable} which *only* sets the
       * `readOnly` attribute of the `<input>` field.
       *
       * PickerFields such as `Combo` and `DateField` can be `editable : false`, but still
       * modifiable through the UI.
       * @config {Boolean}
       */
      readOnly: null,

      /**
       * Set to false to prevent user from editing the field. For TextFields it is basically the same as setting
       * {@link #config-readOnly}, but for PickerFields there is a distinction where it allows you to pick a value
       * but not to type one in the field.
       *
       * PickerFields such as `Combo` and `DateField` can be `editable : false`, but still
       * modifiable through the UI.
       * @config {Boolean}
       * @default true
       */
      editable: true,
      defaultAction: 'change',

      /**
       * The trigger Widgets as specified by the {@link #config-triggers} configuration and the
       * {@link #config-clearable} configuration. Each is a {@link Core.widget.Widget Widget} instance which may
       * be hidden, shown and observed and styled just like any other widget.
       * @member {Object} triggers
       */

      /**
       * The triggers to add either before or after the input field. Each property name is the reference by which
       * an instantiated Trigger Widget may be retrieved from the live `{@link #property-triggers}` property.
       *
       * Each trigger may have the following properties:
       * * `cls` The CSS class to apply.
       * * `handler` A method in the field to call upon click
       * * `align` `'start'` or `'end'` which end of the field the trigger should go.
       * * `weight` (Optional) Higher weighted triggers gravitate towards the input field.
       *
       * ```javascript
       * const textField = new TextField({
       *   triggers : {
       *       check : {
       *           cls : 'b-fa b-fa-check',
       *           handler() {
       *               ...
       *           }
       *       },
       *       ...
       *   }
       * })
       * ```
       *
       * @config {Object}
       */
      triggers: null,

      /**
       * Specify `false` to prevent field from being highlighted when on external value changes
       * @config {Boolean}
       */
      highlightExternalChange: true,
      localizableProperties: ['label', 'title', 'placeholder', 'labelWidth'],

      /**
       * Specify `true` to auto select field contents on focus
       * @config {Boolean}
       * @default
       */
      autoSelect: false,

      /**
       * Sets the native `autocomplete` property of the underlying input element. For more information, please refer to
       * [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete)
       * @config {String}
       * @default
       * @category Input element
       */
      autoComplete: 'off',

      /**
       * Sets the native `spellcheck` property of the underlying input element. For more information, please refer to
       * [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck)
       * @config {Boolean}
       * @category Input element
       */
      spellCheck: null,

      /**
       * Sets custom attributes of the underlying input element. For more information, please refer to
       * [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes)
       * @config {Object}
       * @default
       * @category Input element
       */
      inputAttributes: null,

      /**
       * Sets the `type` attribute of the underlying input element (password, hidden, date, color, etc).
       * @config {String}
       * @category Input element
       */
      inputType: 'text',

      /**
       * Text alignment for the input field.
       * @config {String}
       * @category Input element
       */
      inputAlign: null,

      /**
       * A list of property names to be set in the underlying input element from properties
       * by the same name in this Field object if the value is not `== null`.
       * @private
       * @category Input element
       */
      attributes: {
        value: ['placeholder', 'autoComplete', 'spellCheck', 'minLength', 'maxLength', 'pattern', 'tabIndex', 'min', 'max'],
        $config: {
          merge: 'distinct'
        }
      },
      nullValue: {
        $config: null,
        value: null,
        default: null // store _value=null on prototype

      },
      updatedClsDuration: 500,
      inputReadOnly: false,
      testConfig: {
        updatedClsDuration: 10
      }
    };
  }

  static get delayable() {
    return {
      highlightChanged: 'raf'
    };
  }

  doDestroy() {
    var _me$inputListenerRemo, _me$keyListenerRemove;

    const me = this,
          {
      triggers
    } = me,
          errorTip = me.isPainted && Field.getSharedErrorTooltip(me.rootElement, true);
    (_me$inputListenerRemo = me.inputListenerRemover) === null || _me$inputListenerRemo === void 0 ? void 0 : _me$inputListenerRemo.call(me);
    (_me$keyListenerRemove = me.keyListenerRemover) === null || _me$keyListenerRemove === void 0 ? void 0 : _me$keyListenerRemove.call(me);
    super.doDestroy();

    if (triggers) {
      for (const t of Object.values(triggers)) {
        t.destroy();
      }
    } // The errorTip references this field, hide it when we die.


    if ((errorTip === null || errorTip === void 0 ? void 0 : errorTip.field) === me) {
      errorTip.hide();
    }
  }

  get invalidValueError() {
    return 'L{invalidValue}';
  }
  /**
   * A singleton error tooltip which activates on hover of invalid fields.
   * before show, it gets a reference to the field and interrogates its
   * active error list to display as the tip content.
   * @member {Core.widget.Tooltip}
   * @readonly
   */


  get errorTip() {
    return this.constructor.getSharedErrorTooltip(this.rootElement);
  }

  static getSharedErrorTooltip(rootElement, doNotCreate) {
    var _rootElement$bryntum;

    let sharedErrorTooltip = (_rootElement$bryntum = rootElement.bryntum) === null || _rootElement$bryntum === void 0 ? void 0 : _rootElement$bryntum.errorTooltip;

    if (!sharedErrorTooltip && !doNotCreate) {
      rootElement.bryntum = rootElement.bryntum || {};
      sharedErrorTooltip = new _Tooltip_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
        cls: 'b-field-error-tip',
        forSelector: '.b-field.b-invalid .b-field-inner',
        align: 'l-r',
        scrollAction: 'realign',
        trapFocus: false,
        rootElement,

        onBeforeShow() {
          const tip = this,
                field = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromElement(tip.activeTarget);

          if (field) {
            const errors = field.getErrors();

            if (errors) {
              tip.html = errors.join('<br>');
              tip.field = field;
              return true;
            }
          } // Veto show


          return false;
        }

      });
      rootElement.bryntum.errorTooltip = sharedErrorTooltip;
    }

    return sharedErrorTooltip;
  }
  /**
   * A singleton error tooltip which activates on hover of invalid fields.
   * before show, it gets a reference to the field and interrogates its
   * active error list to display as the tip content.
   *
   * Please note: Not applicable when using widgets inside a shadow root
   * @member {Core.widget.Tooltip}
   * @readonly
   * @static
   */


  static get errorTip() {
    return this.getSharedErrorTooltip(document.body);
  } //endregion
  //region Event

  /**
   * Fired when the user types into this field.
   * @event input
   * @param {Core.widget.Field} source This field.
   * @param {String} value - This field's value
   * @param {Event} event - The triggering DOM event.
   */

  /**
   * Fired when this field's value changes.
   * @event change
   * @param {String} value - This field's value
   * @param {String} oldValue - This field's previous value
   * @param {Boolean} valid - True if this field is in a valid state.
   * @param {Event} [event] - The triggering DOM event if any.
   * @param {Boolean} userAction - Triggered by user taking an action (`true`) or by setting a value (`false`)
   * @param {Core.widget.Field} source - This Field
   */

  /**
   * User performed default action (typed into this field).
   * @event action
   * @param {String} value - This field's value
   * @param {String} oldValue - This field's previous value
   * @param {Boolean} valid - True if this field is in a valid state.
   * @param {Event} [event] - The triggering DOM event if any.
   * @param {Boolean} userAction - Triggered by user taking an action (`true`) or by setting a value (`false`)
   * @param {Core.widget.Field} source - This Field
   */

  /**
   * Fired when this field is {@link #function-clear cleared}.
   *
   * This will be triggered when a user clicks this field's clear {@link #property-triggers trigger}
   * @event clear
   * @param {Core.widget.Field} source - This Field
   */

  /**
   * User clicked one of this field's {@link #property-triggers}
   * @event trigger
   * @param {Core.widget.Field} source This field
   * @param {Core.widget.Widget} trigger The trigger activated by click or touch tap.
   */
  //endregion
  //region Init


  construct(config) {
    super.construct(config);
    const me = this;

    if (me.keyStrokeChangeDelay) {
      me.changeOnKeyStroke = me.buffer(me.internalOnChange, me.keyStrokeChangeDelay);
    }
  }

  onFocusIn(e) {
    const me = this;
    me.valueOnFocus = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].clone(me.value);
    me.validOnFocus = !(me.errors && Object.keys(me.errors).length);
    super.onFocusIn(e);
  }

  onFocusOut(e) {
    super.onFocusOut(e); // Required field not flagged with error initially, flag on blur instead for better appearance

    this.syncRequired(); // Check field consistency on blur

    this.onEditComplete();
  }
  /**
   * Template function which may be implemented by subclasses to synchronize
   * input state and validity state upon completion of the edit.
   * @internal
   */


  onEditComplete() {}

  get rootUiClass() {
    return Field;
  }

  compose() {
    // Force evaluation of clearable so triggers include the clearable trigger. We can't bury this inside
    // changeTriggers since there may be no other triggers defined (which would mean changeTriggers would never
    // be run)
    this.getConfig('clearable');

    const {
      id,
      innerElements,
      label,
      labels,
      labelCls,
      readOnly,
      triggers
    } = this,
          triggerInstances = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].values(triggers, (k, v) => !v),
          // The triggers at each end are sorted "gravitationally".
    // Higher weight sorts towards the center which is the input element.
    startTriggers = triggerInstances.filter(t => t.align === 'start').sort(byWeight),
          endTriggers = triggerInstances.filter(t => t.align !== 'start').sort(byWeightReverse),
          setupLabel = lbl => _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
      tag: 'label',
      for: `${id}-input`,
      class: `b-label b-align-${lbl.align || 'start'}`
    }, lbl);

    return {
      class: {
        'b-has-label': Boolean(label) || (labels === null || labels === void 0 ? void 0 : labels.length),
        'b-has-start-trigger': startTriggers.length,
        'b-readonly': readOnly
      },
      children: [...(labels || emptyArray).filter(t => t && t.align !== 'end').map(setupLabel), (label || null) && setupLabel({
        reference: 'labelElement',
        class: `b-label b-align-start ${labelCls || ''}`,
        html: label
      }), {
        class: 'b-field-inner',
        reference: 'inputWrap',
        children: [...startTriggers.map(t => t.element), ...innerElements, ...endTriggers.map(t => t.element)]
      }, ...(labels || emptyArray).filter(t => (t === null || t === void 0 ? void 0 : t.align) === 'end').map(setupLabel)]
    };
  }

  updateElement(element, was) {
    var _me$keyListenerRemove2;

    const me = this,
          value = me.initialConfig.value,
          {
      input
    } = me;
    super.updateElement(element, was); // Value must be injected into the input element after it has been constructed, not in the
    // initial template, otherwise the caret position will not be as expected.

    if (value != null) {
      me.value = value;
    }

    me.syncEmpty();
    me.updateInputReadOnly(me.inputReadOnly);
    me.syncInvalid();
    const keyEventElement = input || me.focusElement;
    (_me$keyListenerRemove2 = me.keyListenerRemover) === null || _me$keyListenerRemove2 === void 0 ? void 0 : _me$keyListenerRemove2.call(me);
    me.keyListenerRemover = keyEventElement && _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
      element: keyEventElement,
      thisObj: me,
      keydown: 'internalOnKeyEvent',
      keypress: 'internalOnKeyEvent',
      keyup: 'internalOnKeyEvent'
    });
  } // Subclasses may implement this.
  // Needed because Checkbox produces an array of two elements as its innerElements


  get innerElements() {
    return [this.inputElement];
  }

  get inputElement() {
    const {
      attributes,
      inputAttributes,
      id,
      inputCls,
      inputType,
      name
    } = this,
          domConfig = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
      reference: 'input',
      tag: 'input',
      type: inputType,
      name: name || id,
      id: `${id}-input`,
      retainElement: true // allow the input to be transplanted as in combo/chipView

    }, inputAttributes);

    if (inputCls) {
      domConfig.class = inputCls;
    }

    for (let key, value, i = attributes.length; i-- > 0;) {
      key = attributes[i];
      value = this[key];

      if (value != null) {
        // don't smash properties already in domConfig w/null values...
        domConfig[key] = value;
      }
    }

    return domConfig;
  } //endregion
  //region Focus & select


  get caretPos() {
    return this.textSelection[0];
  }

  set caretPos(value) {
    this.textSelection = value;
  }

  get focusElement() {
    return this.input;
  }

  get textSelection() {
    const input = this.input;
    let ret;

    try {
      ret = [input.selectionStart, input.selectionEnd, input.selectionDirection];
    } catch (e) {
      var _input$value;

      // ignore (some input types cannot do this)
      ret = ((_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.length) || 0;
      ret = [ret, ret];
    }

    return ret;
  }

  set textSelection(value) {
    if (typeof value === 'number') {
      this.select(value, value);
    } else {
      this.select(...value);
    }
  }

  get hasTextSelection() {
    const [selectionStart, selectionEnd] = this.textSelection;
    return selectionStart && selectionEnd - selectionStart > 0;
  }
  /**
   * Returns the input value for this field's input element that will be present if
   * the event carrying the given text is allowed to proceed.
   * @param {String} text
   * @returns {String}
   * @private
   */


  getAfterValue(text) {
    const [begin, end] = this.textSelection,
          value = this.input.value;
    return `${value.substr(0, begin)}${text}${value.substr(end || begin)}`;
  }
  /**
   * Selects the field contents. Optionally may be passed a start and end.
   * NOTE: This method is async for IE11
   * @param {Number} [start] The start index from which to select the input.
   * @param {Number} [end] The index at which to end the selection of the input.
   */


  select(start, end) {
    // Use focusElement which is the input field in this class
    // but allows subclasses to use other elements.
    // See, for example, TextAreaField
    const input = this.focusElement;

    if (input.value.length) {
      if (arguments.length === 0) {
        this.selectAll();
        return;
      } // Only allowed to select range in certain element / input types


      if (!this.supportsTextSelection) {
        return; // throw new Error('Trying to select text on an invalid element type');
      }

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11) {
        // this.clearTimeout(this.selectTimeout);
        // HACK: IE focus processing is async and we can't select text until field is focused
        // Getting flaky exception in IE, something timing related. Found no way to detect it so using this
        // workaround for now
        input.focus();
        input.setSelectionRange(start, end); //
        // this.selectTimeout = this.setTimeout(() => {
        //     input && input.setSelectionRange(start, end);
        // }, 10);
      } else {
        input.setSelectionRange(start, end);
      }
    }
  }

  moveCaretToEnd() {
    const input = this.input;

    if (input.createTextRange) {
      const range = input.createTextRange();
      range.collapse(false);
      range.select();
    } else if (this.supportsTextSelection) {
      // Move caret to the end if possible
      this.select(input.value.length, input.value.length);
    }
  }

  selectAll() {
    this.focusElement.select();
  } // called on value changes to update styling of empty vs non-empty field


  syncEmpty() {
    const {
      isEmptyInput,
      isEmpty,
      element,
      clearIcon
    } = this,
          empty = isEmptyInput && isEmpty;

    if (element) {
      if (clearIcon) {
        // IE11...
        clearIcon.classList[empty ? 'add' : 'remove']('b-icon-hidden');
      } // IE11...


      element.classList[empty ? 'add' : 'remove']('b-empty');
    }
  }

  updateHint() {
    this.syncHint();
  }

  updateHintHtml() {
    this.syncHint();
  }

  syncHint() {
    const me = this,
          {
      input,
      hint,
      hintHtml
    } = me,
          parent = input === null || input === void 0 ? void 0 : input.parentElement;

    if (input) {
      let hintValue = hintHtml || hint;
      const hintElement = me.hintElement || hintValue && (me.hintElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].createElement({
        parent,
        className: 'b-field-hint',
        nextSibling: input.nextSibling,
        children: [{
          className: 'b-field-hint-content'
        }]
      }));

      if (hintElement) {
        if (typeof hintValue === 'function') {
          hintValue = hintValue({
            source: me,
            value: me.value
          });
        }

        hintElement.firstChild[hintHtml ? 'innerHTML' : 'textContent'] = hintValue || '';
      }

      me.element.classList[hintValue ? 'remove' : 'add']('b-field-no-hint');
    }
  }

  syncInvalid() {
    this.updatingInvalid = true;
    const {
      isPainted
    } = this;

    if (isPainted) {
      const {
        isValid,
        element,
        inputWrap
      } = this; // errorTip needs Tooltip.listenersTarget to be there
      // otherwise it doesn't setup listeners and cannot notice we mouseover an invalid field

      const errorTip = this.errorTip;
      element.classList[isValid ? 'remove' : 'add']('b-invalid'); // We achieved validity, so ensure the error tip is hidden

      if (isValid) {
        if (errorTip !== null && errorTip !== void 0 && errorTip.isVisible && errorTip.field === this) {
          errorTip.hide();
        }
      } // If the mouse is over, the tip should spring into view
      else if (errorTip && inputWrap.contains(_Tooltip_js__WEBPACK_IMPORTED_MODULE_1__["default"].currentOverElement)) {
        // Already shown by this field's inputWrap, just update content.
        if (errorTip.activeTarget === inputWrap && errorTip.isVisible) {
          errorTip.onBeforeShow();
        } else {
          errorTip.activeTarget = inputWrap;
          errorTip.showBy(inputWrap);
        }
      }
    }

    this.updatingInvalid = false;
  } //endregion
  //region Getters/setters


  updateEditable() {
    this.syncInputReadOnly();
  }

  syncInputReadOnly() {
    this.getConfig('readOnly'); // make sure our config is initialized...
    // but since the readOnly getter conflates disabled into it, we ultimately have to look at _readOnly:

    this.inputReadOnly = this._readOnly || this.editable === false;
  }

  updateInputReadOnly(readOnly) {
    const me = this,
          {
      input,
      inputListenerRemover
    } = me; // Editable refers *ONLY* to the readOnly state of the <input> field within the field.
    // It does *NOT* imply that the field is not modifiable by user interaction.
    // For example, a Combo or DateField may be not editable, but may still be set through the UI.
    // It is the readOnly config which disables user interaction from modifying the field.

    if (input) {
      input.readOnly = readOnly ? 'readOnly' : null;

      if (readOnly) {
        me.inputListenerRemover = inputListenerRemover === null || inputListenerRemover === void 0 ? void 0 : inputListenerRemover();
      } else if (!inputListenerRemover) {
        me.inputListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
          element: input,
          thisObj: me,
          focus: 'internalOnInputFocus',
          change: 'internalOnChange',
          input: 'internalOnInput'
        });
      }
    }
  }

  changeReadOnly(value) {
    return Boolean(value);
  }

  updateReadOnly(readOnly) {
    this.syncInputReadOnly();
  }

  updateClearable(clearable) {
    const me = this;
    me.getConfig('triggers');
    me.triggers = {
      clear: clearable && _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({
        cls: 'b-icon-remove',
        weight: 1000,

        handler() {
          me._isUserAction = true;
          me.clear();
          me._isUserAction = false;
        }

      }, clearable) || null
    };
  }

  changeTriggers(triggers, was) {
    const me = this,
          manager = me.$triggers || (me.$triggers = new _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_9__["default"]({
      configName: 'triggers',
      factory: Field.Trigger,
      inferType: false,
      // the name of a trigger in the triggers object is not its type
      owner: me,

      created(instance) {
        _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].after(instance, 'onConfigChange', (ret, {
          name
        }) => {
          if (triggerConfigs[name]) {
            me.onConfigChange({
              name: 'triggers',
              value: manager.target
            });
          }
        });
      },

      setup(config, name) {
        config.reference = config.ref = name;
        config.parent = me;
      }

    }));

    if (me.stepTriggers === false && (triggers.back || triggers.forward)) {
      triggers = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assign({}, triggers);
      delete triggers.back;
      delete triggers.forward;
    }

    manager.update(triggers);

    if (!was) {
      // Only return the target once. Further calls are processed above so we need to return undefined to ensure
      // onConfigChange is called. By returning the same target on 2nd+ call, it passes the === test and won't
      // trigger onConfigChange.
      return manager.target;
    }
  }

  updateLabelWidth(newValue) {
    if (this.labelElement) {
      this.labelElement.style.flex = `0 0 ${_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].setLength(newValue)}`; // If there's a label width, the input must conform with it, and not try to expand to 100%

      this.inputWrap.style.flexBasis = newValue == null ? '' : 0;
    }
  }

  updateInputWidth(newValue) {
    this.input.style.width = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].setLength(newValue); // requires to make "Should support inputWidth with label" test green

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11) {
      this.input.parentElement.style.flexBasis = this.input.style.width;
    }

    this.element.classList.add('b-has-width');
  }

  updateInputAlign(newValue) {
    this.input.style.textAlign = newValue;
  }

  changeLabel(label) {
    return label == null ? '' : label;
  }

  updateLabel(label) {
    // since value is used in template it is not certain that element is available
    // TODO: move the code from template here instead
    if (this.labelElement) {
      // using innerHTML since we sometimes use icons as label
      this.labelElement.innerHTML = label;
    }
  }

  updateLabelPosition(position, oldPosition) {
    const {
      classList
    } = this.element;
    classList.remove(`b-label-${oldPosition}`);
    classList.add(`b-label-${position}`);
  }
  /**
   * Returns true if the field value is valid
   * @type {Boolean}
   * @readonly
   */


  get isValid() {
    const me = this; // Disabled fields are considered valid

    if (!me.disabled) {
      me.syncRequired();

      if (me.errors && Object.keys(me.errors).length) {
        return false;
      }

      const validity = me.validity;

      if (validity) {
        return validity.valid;
      }
    }

    return true;
  }
  /**
   * Returns `true` if this field is empty. That is, if it would violate the {@link #config-required}
   * setting.
   *
   * This may have different definitions in subclasses from simple text fields.
   * @type {Boolean}
   * @readonly
   */


  get isEmpty() {
    return this.value == null || this.value === '';
  }
  /**
   * Returns true if the field's input is empty
   * @type {Boolean}
   * @readonly
   */


  get isEmptyInput() {
    return !this.input || this.input.value == null || this.input.value === '';
  }
  /**
   * Returns the DOM `ValidityState` for this widget's input element, or `null` if there
   * isn't one.
   * @returns {ValidityState}
   * @private
   */


  get validity() {
    const input = this.input;
    return input && input.validity;
  }

  changeValue(value, was) {
    if (value == null) {
      value = this.nullValue;
    } // In cases of arrays, for example, we need to return "was" to pass the === check in the setter to convince
    // the config that, in fact, no change has occurred.


    if (this.hasChanged(was, value)) {
      return value;
    } // When loading a record into a form, an empty value might be loaded into a field, which is not detected as a
    // change. In this scenario it should still be flagged as invalid


    if (value === '') {
      this.syncRequired();
    }

    return was;
  }

  updateValue(value, oldValue) {
    const me = this; // Do not flag with error if configured empty, looks ugly to have fields start red

    if (!me.isConfiguring) {
      me.syncRequired(); // Do not trigger change event during configuration phase
      // or during keyboard input

      if (!me.inputting) {
        // trigger change event, signaling that origin is from set operation,
        // makes it easier to ignore such events in applications that set value on load etc
        me.triggerChange();
      }
    } // lastValue is used for IE to check if a change event should be triggered when pressing ENTER


    if (!me.inputting) {
      me._lastValue = value;
    }

    me.syncInputFieldValue();
  }
  /**
   * Compares this field's value with its previous value. May be overridden in subclasses
   * which have more complex value types. See, for example, {@link Core.widget.DurationField}.
   * @param {*} oldValue
   * @param {*} newValue
   * @private
   */


  hasChanged(oldValue, newValue) {
    return newValue !== oldValue;
  }
  /**
   * Called by the base Field class's `set value` to sync the state of the UI with the field's value.
   *
   * Relies upon the class implementation of `get inputValue` to return a string representation of
   * the value for user consumption and editing.
   * @private
   */


  syncInputFieldValue(skipHighlight = false) {
    const me = this,
          {
      input,
      parent,
      inputValueAttr,
      inputValue
    } = me; // If we are updating from internalOnInput, we must not update the input field

    if (input && !me.inputting && input[inputValueAttr] !== inputValue) {
      // Subclasses may implement their own read only inputValue property.
      input[inputValueAttr] = inputValue; // TODO : This highlighting logic needs extracting/clarifying
      // If it's being manipulated from the outside, highlight it

      if (!me.isConfiguring && !me.containsFocus && me.highlightExternalChange) {
        var _parent$_isSettingVal;

        input.classList.remove('b-field-updated');
        me.clearTimeout('removeUpdatedCls');

        if (!skipHighlight && (!parent || !(parent.isSettingValues || (_parent$_isSettingVal = parent._isSettingValues) !== null && _parent$_isSettingVal !== void 0 && _parent$_isSettingVal.preventHighlight))) {
          me.highlightChanged();
        }
      }
    }

    me.syncEmpty();
    me.syncInvalid();
  }

  highlightChanged() {
    this.input.classList.add('b-field-updated');
    this.setTimeout('removeUpdatedCls', this.updatedClsDuration);
  }

  removeUpdatedCls() {
    this.input.classList.remove('b-field-updated');
  }
  /**
   * A String representation of the value of this field for {@link #function-syncInputFieldValue} to use
   * as the input element's value.
   *
   * Subclasses may override this to create string representations.
   *
   * For example, {@link Core.widget.DateField}'s implementation will format the field date
   * value according to its configured {@link Core.widget.DateField#config-format}. And {@link Core.widget.Combo}'s
   * implementation will return the {@link Core.widget.Combo#config-displayField} of the selected record.
   * @internal
   * @readOnly
   */


  get inputValue() {
    // Do not use the _value property. If called during configuration, this
    // will import the configured value from the config object.
    return this.value == null ? '' : this.value;
  }

  get inputValueAttr() {
    return 'value';
  }

  get supportsTextSelection() {
    const input = this.focusElement; // Text selection using setSelectionRange is allowed in Chrome for certain elements. Edge supports it even for input[type=number]

    return input && (input.tagName.toLowerCase() === 'textarea' || input.type && (/text|search|password|tel|url/.test(input.type) || _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isEdge));
  } //endregion
  //region Events


  internalOnInputFocus() {
    const me = this,
          length = me.input.value.length; // Help IE to set caret at the end like the other browsers

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11 && length && !me.autoSelect) {
      me.select(length, length);
    }

    if (me.autoSelect) {
      me.selectAll();
    }
  }
  /**
   * Trigger event when fields input changes
   * @fires change
   * @private
   */


  internalOnChange(event) {
    const me = this; // Don't trigger change if we enter invalid value or if value has not changed (for IE when pressing ENTER)

    if (me.isValid && me.hasChanged(me._lastValue, me.value)) {
      me.triggerChange(event, true);
      me._lastValue = me.value;
    }
  }

  triggerChange(event, userAction = Boolean(this._isUserAction)) {
    const me = this,
          {
      value,
      _lastValue: oldValue,
      // TODO: The `internalOnChange`-path excludes invalid changes, while the `set value`-path includes them
      isValid: valid
    } = me;
    me.syncHint(); // trigger change event, signaling that origin is from user

    me.triggerFieldChange({
      value,
      oldValue,
      event,
      userAction,
      valid
    }); // per default Field triggers action event on change, but might be reconfigured in subclasses (such as Combo)

    if (me.defaultAction === 'change') {
      me.trigger('action', {
        value,
        oldValue,
        event,
        userAction,
        valid
      });
    } // since Widget has Events mixed in configured with 'callOnFunctions' this will also call onClick and onAction

  }
  /**
   * Trigger event when user inputs into field
   * @fires input
   * @param event
   * @private
   */


  internalOnInput(event) {
    var _me$changeOnKeyStroke;

    const me = this; // Keep the value synced with the inputValue at all times.

    me.inputting = true;
    me.value = me.input.value;
    me.inputting = false;
    me.trigger('input', {
      value: me.value,
      event
    });
    (_me$changeOnKeyStroke = me.changeOnKeyStroke) === null || _me$changeOnKeyStroke === void 0 ? void 0 : _me$changeOnKeyStroke.call(me, event); // since Widget has Events mixed in configured with 'callOnFunctions' this will also call onInput
  }

  internalOnKeyEvent(event) {
    const me = this,
          {
      value
    } = me;
    let stopEvent = false;

    if (event.type === 'keydown') {
      if (event.key === 'Escape' && !(me.readOnly || me.disabled)) {
        // We can be started with an initialValue which takes precedence over the valueOnFocus.
        // Because in some situations focus can move out and back in after a change which needs
        // to be revertable. For example in cell editing.
        const wasValid = me.isValid,
              initialValue = 'initialValue' in me ? me.initialValue : me.valueOnFocus,
              valueChanged = me.hasChanged(initialValue, value),
              needsInputSync = me.input.value !== String(me.inputValue); // We revert on escape if we are configured to do so AND:
        // We are in an invalid state, or the value has changed, or the displayed value doesn't match the field value.

        if (me.revertOnEscape && (!wasValid || valueChanged || needsInputSync)) {
          if (valueChanged) {
            me.value = initialValue;
          }

          if (needsInputSync) {
            me.syncInputFieldValue(true);
          }

          me.clearError(); // If this processing changed the value back to valid, or
          // the validity state was different to that upon focus
          // then this was a revert operation, so prevent further ESC processing.

          stopEvent = valueChanged && me.isValid || wasValid !== me.validOnFocus;
        } else if (me.clearable && (value || me.input.value)) {
          me.clear();
        }
      } // #5730 - IE11 doesn't trigger "change" event by Enter click
      else if (event.key === 'Enter' && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11) {
        me.internalOnChange(event);
      }
    } // The above processing might have destructive consequences.


    if (!me.isDestroyed) {
      // If the keystroke had the effect of changing the field, prevent other handlers
      // which may mask that effect. Such as ESC exiting some UI context. Keep it contained.
      if (stopEvent) {
        event.stopImmediatePropagation();
      }

      me.trigger(event.type, {
        event
      });
    }
  }
  /**
   * Clears the value of this Field, and triggers the {@link #event-clear} event.
   */


  clear() {
    this.value = this.nullValue;
    this.trigger('clear');
  }
  /**
   * Called when disabled state is changed.
   * Used to add or remove 'b-invalid' class for the invalid field based on current disabled state.
   * @private
   */


  onDisabled() {
    this.syncInvalid();
  } //endregion
  //region Error


  syncRequired() {
    var _me$parent;

    const me = this; // Empty valid if any ancestor Container is setting values

    if (!me.isConfiguring && me.required && me.isEmpty && !((_me$parent = me.parent) !== null && _me$parent !== void 0 && _me$parent.isSettingValues)) {
      me.setError('L{fieldRequired}', me.updatingInvalid);
    } else {
      me.clearError('L{fieldRequired}', me.updatingInvalid);
    }
  }
  /**
   * Adds an error message to the list of errors on this field.
   * By default the field's valid/invalid state is updated; pass
   * `false` as the second parameter to disable that if multiple
   * changes are being made to the error state.
   * @param {String} error A locale string, or message to use as an error message.
   * @param {Boolean} [silent=false] Pass as `true` to skip updating the field's valid/invalid state.
   * @privateparam {Boolean} [temporary=false] Pass as `true` to remove the error upon the next user interaction.
   */


  setError(error, silent, temporary) {
    const me = this; // Error messages are deduplicated by using them as the property names in an object.

    (me.errors || (me.errors = {}))[me.optionalL(error)] = 1;

    if (!silent) {
      me.syncInvalid();
    }

    if (temporary) {
      const clearError = () => {
        me.clearError(error);
        remover();
      },
            remover = me.on({
        keydown: clearError,
        focusOut: clearError
      });
    }
  }
  /**
   * Removes an error message from the list of errors on this field.
   * By default the field's valid/invalid state is updated; pass
   * `false` as the second parameter to disable that if multiple
   * changes are being made to the error state.
   * @param {String} [error] A locale string, or message to remove. If not passed, all errors are cleared.
   * @param {Boolean} [silent=false] Pass as `true` to skip updating the field's valid/invalid state.
   */


  clearError(error, silent) {
    const me = this;

    if (me.errors) {
      if (error) {
        delete this.errors[this.optionalL(error)];
      } else {
        me.errors = {};
      }

      if (!silent) {
        me.syncInvalid();
      }
    }
  }
  /**
   * Returns an array of error messages as set by {@link #function-setError}, or
   * `undefined` if there are currently no errors.
   * @return {String[]} The errors for this field, or `undefined` if there are no errors.
   */


  getErrors() {
    const me = this;

    if (!me.isValid) {
      const validity = me.validity,
            // See possible state names: https://developer.mozilla.org/en-US/docs/Web/API/ValidityState
      stateName = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].keys(validity).find(key => key !== 'valid' && key !== 'customError' && validity[key]),
            errorKeys = me.errors && Object.keys(me.errors);
      let errors;

      if (errorKeys !== null && errorKeys !== void 0 && errorKeys.length) {
        errors = errorKeys;
      } // If custom error message was set using https://developer.mozilla.org/en-US/docs/Web/API/HTMLObjectElement/setCustomValidity
      else if (validity.customError) {
        errors = [me.input.validationMessage];
      } // If invalid state found, translate it
      else if (stateName) {
        // Do not remove. Assertion strings for Localization sanity check.
        // 'L{foo}'
        // 'L{badInput}'
        // 'L{patternMismatch}'
        // 'L{rangeOverflow}'
        // 'L{rangeUnderflow}'
        // 'L{stepMismatch}'
        // 'L{tooLong}'
        // 'L{tooShort}'
        // 'L{typeMismatch}'
        // 'L{valueMissing}'
        errors = [me.L(stateName, {
          // In case min/max limits are present they will be used in the translation
          min: me.min,
          max: me.max
        })];
      } // If built-in state is 'valid' but me.isValid is false, show our invalid message
      else {
        errors = [me.L(me.invalidValueError)];
      }

      if (errors && errors.length > 0) {
        return errors;
      }
    }
  } //endregion


}
/**
 * Base class for field triggers May be configured with a `cls` and a `handler` which is a function (or name of a function)
 * in the owning Field.
 * @classtype trigger
 * @extends Core/widget/Widget
 */

Field.Trigger = class FieldTrigger extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'FieldTrigger';
  }

  static get factoryable() {
    return {
      defaultType: Field.Trigger,
      extends: null
    };
  } // Factoryable type name


  static get type() {
    return 'trigger';
  } // Align is a simple string at this level


  static get configurable() {
    return {
      align: null,
      weight: null
    };
  }

  get field() {
    return this.parent;
  }

  compose() {
    return {
      class: {
        [`b-align-${this.align || 'end'}`]: 1,
        'b-icon': 1
      },
      listeners: {
        click: 'onClick',
        mousedown: 'onMousedown'
      }
    };
  }

  changeAlign(align) {
    return align; // Widget base class converts to an object
  }

  onClick(e) {
    const me = this,
          {
      field
    } = me,
          handler = typeof me.handler === 'function' ? me.handler : field[me.handler];

    if (!(field.disabled || field.readOnly)) {
      if (field.trigger('trigger', {
        trigger: me
      }) !== false) {
        handler === null || handler === void 0 ? void 0 : handler.call(field, e);
      }
    }
  }

  onMousedown(e) {
    const field = this.field,
          isKeyEvent = ('key' in e); // If it's a touch tap on the trigger of an editable, then
    // avoid the keyboard by setting the field to not be editable
    // before focusing the field. Reset to be editable after focusing
    // has happened. Keyboard will not appear.

    if (!isKeyEvent && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isTouchEvent) {
      if (field.editable) {
        field.editable = false;
        field.setTimeout(() => field.editable = true, 500);
      }
    }

    e.preventDefault();

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].getActiveElement(field.input) !== field.input) {
      field.focus();
    }
  }

};
Field.SpinTrigger = class SpinTrigger extends Field.Trigger {
  static get $name() {
    return 'SpinTrigger';
  } // Factoryable type name


  static get type() {
    return 'spintrigger';
  }

  static get configurable() {
    return {
      repeat: {
        $config: ['nullify'],
        value: true
      }
    };
  }

  compose() {
    return {
      children: {
        upButton: {
          class: {
            'b-icon': 1,
            'b-spin-up': 1
          }
        },
        downButton: {
          class: {
            'b-icon': 1,
            'b-spin-down': 1
          }
        }
      }
    };
  }

  updateRepeat(repeat) {
    var _this$clickRepeater;

    (_this$clickRepeater = this.clickRepeater) === null || _this$clickRepeater === void 0 ? void 0 : _this$clickRepeater.destroy();
    this.clickRepeater = repeat ? _util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_8__["default"].new({
      element: this.element
    }, repeat) : null;
  }

  onClick(e) {
    const me = this,
          {
      field
    } = me;

    if (!(field.disabled || field.readOnly)) {
      if (e.target === me.upButton) {
        field.doSpinUp(e.shiftKey);
      } else if (e.target === me.downButton) {
        field.doSpinDown(e.shiftKey);
      }
    }
  }

}; // Register trigger widgets type with their Factory

Field.Trigger.initClass();
Field.SpinTrigger.initClass();
_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].register(Field.Trigger, 'trigger');
_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].register(Field.SpinTrigger, 'spintrigger');
Field._$name = 'Field';

/***/ }),

/***/ "./lib/Core/widget/FileField.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/FileField.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FileField; });
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
var productName = 'taskboard';

/**
 * @module Core/widget/FileField
 */

/**
 * FileField widget. Wraps native &lt;input type="file"&gt;.
 *
 * {@inlineexample Core/widget/FileField.js vertical}
 *
 * There is a nicer styled wrapper for this field, see {@link Core/widget/FilePicker}
 *
 * @extends Core/widget/Field
 * @classType filefield
 */

class FileField extends _Field_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'FileField';
  } // Factoryable type name


  static get type() {
    return 'filefield';
  }

  internalOnChange(event) {
    // Event order is not consistent across browsers:
    //
    //  Chrome/Firefox:             IE11:                       Edge:
    //      internalOnInput             internalOnChange            internalOnChange
    //      internalOnChange            internalOnInput
    //
    // The problem this creates is that the onChange logic expects value != lastValue which is ensured by the
    // onInput handler. In the IE11/Edge sequence, the first change event is ignored, but with a file input that
    // is the only one you get and so the component's change event does not fire. The user has to make a second
    // file selection to get the event to fire.
    //
    // Fortunately, the event sequence for a file input is simple, so we can just force that order here:
    super.internalOnInput(event);
    super.internalOnChange(event);
  }

  internalOnInput() {// ignore -- see internalOnChange above
  }

  static get configurable() {
    return {
      /**
       * Set to true to allow picking multiple files. Note that when set to a truthy value,
       * the field is set to accept multiple files, but the value returned will be
       * an empty string since this is what is rendered into the HTML.
       * @config {Boolean}
       * @default
       */
      multiple: null,

      /**
       * Comma-separated list of file extensions or MIME type to to accept. E.g.
       * ".jpg,.png,.doc" or "image/*". Null by default, allowing all files.
       * @config {String}
       */
      accept: null,
      inputType: 'file',
      attributes: ['multiple', 'accept']
    };
  }
  /**
   * Returns list of selected files
   * @property {FileList}
   * @readonly
   */


  get files() {
    return this.input.files;
  }
  /**
   * Opens browser file picker
   * @internal
   */


  pickFile() {
    this.input.click();
  }

  get multiple() {
    return this._multiple ? '' : null;
  }
  /**
   * Clears field value
   */


  clear() {
    this.input.value = null;
  }

  triggerChange(event) {
    this.triggerFieldChange({
      event,
      value: this.input.value,
      oldValue: this._lastValue,
      userAction: true,
      valid: true
    });
  }

} // Register this widget type with its Factory

FileField.initClass();
FileField._$name = 'FileField';

/***/ }),

/***/ "./lib/Core/widget/FilePicker.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/FilePicker.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FilePicker; });
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _FileField_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./FileField.js */ "./lib/Core/widget/FileField.js");
var productName = 'taskboard';




/**
 * @module Core/widget/FilePicker
 */

/**
 * File input field wrapped into {@link Core/widget/Button button}. Clicking button opens browser file picker window.
 * When files are chosen, badge appears showing amount of files. Hovering the button shows tip with file names.
 *
 * By default only single file allowed.
 *
 * @extends Core/widget/Container
 * @example
 *
 * let fileField = new FilePicker({
 *   fileFieldConfig : {
 *      multiple : true,
 *      accept   : "image/*"
 *   },
 *   buttonConfig : {
 *       text : 'Pick file...'
 *   }
 * });
 *
 * @classType filepicker
 * @inlineexample Core/widget/FilePicker.js
 */

class FilePicker extends _Container_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'FilePicker';
  } // Factoryable type name


  static get type() {
    return 'filepicker';
  }

  static get defaultConfig() {
    return {
      /**
       * The name of the property to set when a single value is to be applied to this FilePicker. Such as when used
       * in a grid WidgetColumn, this is the property to which the column's `field` is applied.
       * @config {String}
       * @default
       * @category Misc
       */
      defaultBindProperty: 'value',

      /**
       * Fires after user closes file picker dialog.
       * @event change
       * @param {FileList} files List of picked files
       */

      /**
       * Fires when field is cleared with {@link #function-clear} method
       * @event clear
       */

      /**
       * Wrapper button config object. See {@link Core/widget/Button} for list of available configs.
       * @config {Object}
       */
      buttonConfig: null,

      /**
       * Underlying field config object. See {@link Core/widget/FileField} for list of available configs.
       * @config {Object}
       */
      fileFieldConfig: null
    };
  }

  construct(config = {}) {
    const me = this;
    config.items = [Object.assign({
      type: 'button',
      ref: 'fileButton',
      text: 'L{FilePicker.file}',
      localeClass: this
    }, config.buttonConfig), Object.assign({
      type: 'filefield',
      ref: 'fileField',
      style: 'display: none'
    }, config.fileFieldConfig)].concat(config.items || []);
    super.construct(config);
    me.button.on({
      click: me.onButtonClick,
      thisObj: me
    });
    me.fileField.on({
      change: me.onFileFieldChange,
      thisObj: me
    });

    me._thisIsAUsedExpression(me.fileTip);
  }

  get button() {
    return this.widgetMap.fileButton;
  }

  get fileField() {
    return this.widgetMap.fileField;
  }
  /**
   * List of selected files
   * @property {FileList}
   * @readonly
   */


  get files() {
    return this.fileField.files;
  }

  get fileTip() {
    const me = this;
    return me._fileTip || (me._fileTip = new _Tooltip_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
      cls: 'b-file-tip',
      forElement: me.button.element,
      showOnHover: true,
      align: 'b-t',
      scrollAction: 'realign',
      listeners: {
        beforeshow() {
          const tip = this,
                files = me.files;

          if (files && files.length) {
            tip.html = `${Array.from(files).map(file => file.name).join('<br>')}`;
            return true;
          } // Veto show


          return false;
        }

      }
    }));
  }
  /**
   * Clears field
   */


  clear() {
    const me = this;
    me.fileField.clear();
    me.button.badge = '';
    me.trigger('clear');
  }

  onButtonClick({
    event
  }) {
    const me = this; // forward click to the file input to open browser file picker
    // me.fileField.input.click();

    me.fileField.pickFile();
    event.preventDefault();
  }

  onFileFieldChange({
    valid
  }) {
    const me = this;
    me.button.badge = me.files.length || '';
    me.triggerFieldChange({
      files: me.files,
      valid
    });
  }

} // Register this widget type with its Factory

FilePicker.initClass();
FilePicker._$name = 'FilePicker';

/***/ }),

/***/ "./lib/Core/widget/FilterField.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/FilterField.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FilterField; });
/* harmony import */ var _Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/TextField.js */ "./lib/Core/widget/TextField.js");
var productName = 'taskboard';

/**
 * @module Core/widget/FilterField
 */

/**
 * A simple text field for filtering a store.
 *
 * Allows filtering by {@link #config-field field}:
 *
 * ```javascript
 * const filterField = new FilterField({
 *    store : eventStore,
 *    field : 'name'
 * });
 * ```
 *
 * Or by using a {@link #config-filterFunction filter function} for greater control/custom logic:
 *
 * ```javascript
 * const filterField = new FilterField({
 *    store          : eventStore,
 *    filterFunction : (record, value) => record.name.includes(value)
 * });
 * ```
 *
 * @extends Core/widget/TextField
 * @classType filterfield
 */

class FilterField extends _Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'FilterField';
  } // Factoryable type name


  static get type() {
    return 'filterfield';
  }

  static get configurable() {
    return {
      /**
       * The model field name to filter by. Can optionally be replaced by {@link #config-filterFunction}
       * @config {String}
       * @category Filtering
       */
      field: null,

      /**
       * The store to filter.
       * @config {Core.data.Store}
       * @category Filtering
       */
      store: null,

      /**
       * Optional filter function to be called with record and value as parameters for store filtering.
       * ```javascript
       * {
       *     type           : 'filterfield',
       *     store          : myStore,
       *     filterFunction : (record, value)  => {
       *        return record.text.includes(value);
       *     }
       * }
       * ```
       * @param {Core.data.Model} record Record for comparison
       * @param {String} value Value to compare with
       * @return {Boolean} Return true if record matches comparison requirements
       * @config {Function}
       * @category Filtering
       */
      filterFunction: null,
      clearable: true,
      keyStrokeChangeDelay: 100,

      onChange({
        value
      }) {
        const {
          store,
          field,
          filterFunction
        } = this;

        if (store) {
          const filterId = `${field || this.id}-Filter`;

          if (value.length === 0) {
            store.removeFilter(filterId);
          } else {
            let filterBy;

            if (filterFunction) {
              filterBy = record => filterFunction(record, value);
            } else {
              // We filter using a RegExp, so quote significant characters
              value = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

              filterBy = record => record.get(field).match(new RegExp(value, 'i'));
            } // A filter with an id replaces any previous filter with that id.
            // Leave any other filters which may be in use in place.


            store.filter({
              id: filterId,
              filterBy
            });
          }
        }
      }

    };
  }

  updateValue(value, old) {
    super.updateValue(value, old); // Initial value, apply it

    if (value && this.isConfiguring) {
      this.onChange({
        value
      });
    }
  }

}
;
FilterField.initClass();
FilterField._$name = 'FilterField';

/***/ }),

/***/ "./lib/Core/widget/Label.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Label.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Label; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

class Label extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  compose() {
    const {
      text,
      html
    } = this;
    return {
      tag: 'label',
      text,
      html
    };
  }

}

_defineProperty(Label, "$name", 'Label');

_defineProperty(Label, "type", 'label');

_defineProperty(Label, "configurable", {
  text: null
});

Label.initClass();
Label._$name = 'Label';

/***/ }),

/***/ "./lib/Core/widget/List.js":
/*!*********************************!*\
  !*** ./lib/Core/widget/List.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return List; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _util_Collection_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony import */ var _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/util/Navigator.js */ "./lib/Core/helper/util/Navigator.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'taskboard';








/**
 * @module Core/widget/List
 */

const itemRange = document.createRange();
/**
 * Displays a list of items which the user can navigate using the keyboard and select using either pointer gestures or the keyboard.
 * @extends Core/widget/Widget
 *
 * @classType list
 * @inlineexample Core/widget/List.js
 */

class List extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'List';
  } // Factoryable type name


  static get type() {
    return 'list';
  }

  static get configurable() {
    return {
      itemCls: 'b-list-item',
      selectedCls: 'b-selected',
      selectIconCls: 'b-icon-check',

      /**
       * An array of Objects which are converted into records and used to create this
       * List's {@link #config-store}
       * @config {Object[]}
       */
      items: null,

      /**
       * The model field to render into each list item
       * @config {String}
       * @default
       */
      displayField: 'text',

      /**
       * A {@link Core.data.Store} which provides the records which map to List items. Each record is passed through the
       * {@link #config-itemTpl} to produce the DOM structure of the List. May be generated from an array of {@link #config-items}.
       * @config {Object|Core.data.Store}
       */
      store: null,
      navigator: true,
      scrollable: {
        overflowX: false,
        overflowY: true
      },
      itemsFocusable: true,

      /**
       * Configure as `true` to allow multi select and add checkboxes to the items
       * @config {Boolean}
       * @default
       */
      multiSelect: false,

      /**
       * Select/deselect all if `CMD`/`CTRL` is pressed when clicking
       * @config {Boolean}
       * @default false
       */
      toggleAllIfCtrlPressed: false,

      /**
       * Set to `true` to add a "Select all" item to the list to select/unselect all items at once.
       * Only applies when {@link #config-multiSelect} mode is enabled.
       * @config {Boolean|String}
       * @default false
       */
      selectAllItem: false,

      /**
       * Template function which, when passed a record, returns the textual HTML for that item. Defaults to a
       * function returning the value of the record´s {@link #config-displayField}
       * @config {Function} itemTpl
       * @param {Core.data.Model} record The record
       */
      itemTpl(record) {
        let text = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].encodeHtml(record[this.displayField]);

        if (text == null || text === '') {
          // Make sure we have some content to fill the item element and have equal height for all items
          text = '&nbsp;';
        }

        return text;
      },

      /**
       * Template function which is passed a group record and the uppercased group field name. The text returned
       * will be rendered as the group header.
       * @config {Function} groupHeaderTpl
       * @param {Core.data.Model} record The record
       * @param {String} groupName The current group name
       */
      groupHeaderTpl: (record, groupName) => {
        let name = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].encodeHtml(groupName);

        if (name == null || name === '') {
          // Make sure we have some content to fill the item element and have equal height for all items
          name = '&nbsp;';
        }

        return name;
      },

      /**
       * Configure as `true` to allow selecting groups (all the group child records will be toggled). Only
       * applicable when the store is grouped.
       * @config {Boolean}
       * @default
       */
      allowGroupSelect: true,

      /**
       * A {@link Core.util.Collection Collection}, or Collection config object
       * to use to contain this List's selected records.
       * @config {Core.util.Collection|Object}
       */
      selected: {},

      /**
       * Configure as `true` to activate items on mouseover. This is used by the Combo
       * field when using a List as its dropdown.
       * @config {Boolean}
       */
      activateOnMouseover: null
    };
  } //endregion
  //region Events

  /**
   * User activated an item in the list either by pointer or keyboard.
   * The active record, list item index, and the triggering event are passed.
   * @event item
   * @param {Object} record Activated record
   * @param {Number} index List item index
   * @param {Event} event Triggering event
   */
  //endregion


  construct(config, ...args) {
    var _me$store;

    const me = this; // We can be created from a raw array. It becomes our items which we translate to a Store.

    if (Array.isArray(config)) {
      config = {
        items: config
      };
    }

    super.construct(config, ...args);
    const {
      element
    } = me,
          {
      classList
    } = element;

    if (me.multiSelect) {
      classList.add('b-multiselect');
    }

    if ((_me$store = me.store) !== null && _me$store !== void 0 && _me$store.count) {
      me.refresh();
    } else {
      classList.add('b-empty');
    }

    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
      element,
      delegate: me.itemSelector,
      mouseover: 'onMouseOver',
      click: 'onClick',
      thisObj: me
    });
  }

  doDestroy() {
    var _this$navigator;

    this.detachListeners('store');
    (_this$navigator = this.navigator) === null || _this$navigator === void 0 ? void 0 : _this$navigator.destroy();
    super.doDestroy();
  }

  onFocusIn(e) {
    const listItem = e._target.classList.contains(this.itemCls) ? e._target.dataset.id : 0;
    this.restoreActiveItem(this.navigator.previousActiveItem || this.getItem(listItem));
    super.onFocusIn(e);
  }

  contentTpl() {
    const me = this,
          allRecordsTpl = me.store.records.map((record, i) => me.itemWrapperTpl(record, i));

    if (me.multiSelect && me.selectAllItem !== false) {
      allRecordsTpl.unshift(me.selectAllItemTpl());
    }

    return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].tpl`${allRecordsTpl}`;
  }

  itemWrapperTpl(record, i) {
    return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].tpl`<div class="${this.getItemClasses(record, i)}" data-index="${i}" data-id="${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].encodeHtml(record.id)}" ${this.itemsFocusable ? 'tabindex="-1"' : ''}>
            ${this.itemContentTpl(record, i)}</div>`;
  }

  itemContentTpl(record, i) {
    if ('groupRowFor' in record.meta) {
      return this.groupHeaderTpl(record, _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].capitalize(record.groupChildren[0][record.meta.groupField]));
    }

    return `${this.itemIconTpl(record, i)}${this.itemTpl(record, i)}`;
  }

  itemIconTpl(record, i) {
    return this.multiSelect ? `<div class="b-selected-icon b-icon ${this.selectIconCls}"></div>` : '';
  }

  selectAllItemTpl() {
    return `<div class="${this.itemCls} b-select-all-item" data-noselect data-select-all data-id="select-all">${this.itemIconTpl()}<div>${this.optionalL('Select All')}</div></div>`;
  }

  getItemClasses(record) {
    var _me$_navigator;

    const me = this,
          activeItem = (_me$_navigator = me._navigator) === null || _me$_navigator === void 0 ? void 0 : _me$_navigator.activeItem,
          isActive = (activeItem === null || activeItem === void 0 ? void 0 : activeItem.dataset.id) == record.id,
          groupHeaderCls = 'groupRowFor' in record.meta ? 'b-list-item-group-header' : '',
          isSelected = me.selected.includes(record);
    return `${me.itemCls} ${record.cls || ''} ${isSelected ? me.selectedCls : ''} ${isActive ? me.navigator.focusCls : ''} ${groupHeaderCls}`;
  }

  onBeforeStoreLoad() {
    this.mask(this.L('L{loading}'));
  }

  onAfterStoreRequest() {
    this.unmask();
  }

  onStoreChange({
    source: store,
    action,
    records,
    record,
    changes
  }) {
    const me = this;

    switch (action) {
      // Our refresh listener will pick this up
      case 'dataset':
        return;

      case 'remove':
        me.selected.remove(records);
        break;

      case 'clear':
        me.selected.clear();
        break;

      case 'update':
        {
          const {
            id
          } = changes; // update elements data-id when changing id, to allow refreshItem to find correct element

          if (id) {
            _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].setAttributes(me.contentElement.querySelector(`[data-id="${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].encodeHtml(id.oldValue)}"]`), {
              'data-id': id.value
            });
          }

          me.refreshItem(record);
          return;
        }
    }

    me.refresh();
  }

  onStoreRefresh() {
    this.refresh();
  }

  refresh() {
    const me = this;

    if (me.isVisible) {
      const {
        activeItem
      } = me.navigator; // Ensure that the next call to refresh when not visible queues a refresh

      me.paintListener = null; // IMPORTANT! DO NOT INLINE!
      // This is a fix for issue: https://github.com/bryntum/support/issues/2171
      // Long story short: DomHelper returns document-fragment and first time we insert node, nothing is actually
      // inserted if (and only) fragment is not stored as a variable.

      const node = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElementFromTemplate(me.contentTpl(), {
        fragment: true
      });
      me.clearItems().insertNode(node); // The item elements will be all new, so restore the active item.
      // Navigator will reacquire it by its id.

      if (activeItem) {
        me.restoreActiveItem(activeItem);
      }

      me.refreshCount = (me.refreshCount || 0) + 1;
      me.element.classList[me.store.count > 0 ? 'remove' : 'add']('b-empty');
    } // Only queue a refresh if not already queued
    else if (!me.paintListener) {
      me.paintListener = me.on({
        paint: 'refresh',
        thisObj: me,
        once: true
      });
    }
  }

  clearItems() {
    const me = this,
          firstItem = me.contentElement.querySelector(me.itemSelector),
          lastChild = me.contentElement.lastChild;

    if (firstItem) {
      // Can't use :last-of-type when other elements of same type may be present.
      // Have to pluck the last element of the NodeList.
      const items = me.contentElement.querySelectorAll(`${me.itemSelector}:not(.b-mask)`);
      itemRange.setStartBefore(firstItem);
      itemRange.setEndAfter(items[items.length - 1]);
      itemRange.deleteContents();
    } else {
      // Allow a static set of elements to be at the top of the list
      if (lastChild) {
        itemRange.setStartAfter(lastChild);
        itemRange.setEndAfter(lastChild);
      } else {
        itemRange.setStart(me.contentElement, 0);
        itemRange.setEnd(me.contentElement, 0);
      }
    }

    return itemRange;
  }

  refreshItem(...records) {
    for (const record of records) {
      const item = this.getItem(record); // Maybe a record which is filtered out announces a change.
      // There will be no item.

      if (item) {
        const index = this.store.indexOf(record),
              newItem = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElementFromTemplate(this.itemWrapperTpl(record, index));
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].sync(newItem, item);
      }
    }
  }

  getItem(recordOrId) {
    // Cannot use truthiness test because index zero may be passed.
    if (recordOrId != null) {
      var _recordOrId;

      if (typeof recordOrId === 'number') {
        return this.contentElement.querySelector(`[data-index="${recordOrId}"]`);
      } else if (recordOrId.nodeType === Element.ELEMENT_NODE) {
        recordOrId = recordOrId.dataset.id;
      } // TODO: make navigator works for select all list item


      if (((_recordOrId = recordOrId) === null || _recordOrId === void 0 ? void 0 : _recordOrId.id) != null) {
        recordOrId = recordOrId.id;
      }

      return this.contentElement.querySelector(`[data-id="${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].encodeHtml(recordOrId)}"]`);
    }
  }

  getRecord(dom) {
    if (dom.target) {
      dom = dom.target;
    }

    dom = dom.closest(this.itemSelector);
    return this.store.getAt(parseInt(dom.dataset.index));
  } //region getters/setters

  /**
   * May be *set* as an array of Objects which are converted into records and used to create this
   * List's {@link #config-store}
   * @member {Object[]} items
   */


  updateItems(items) {
    const me = this;

    if (me.store && me.store.autoCreated) {
      me.store.destroy();
    }

    me.store = _data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStore(items);
  }

  updateSelected(selected) {
    if (!(selected && selected instanceof _util_Collection_js__WEBPACK_IMPORTED_MODULE_5__["default"])) {
      selected = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_5__["default"](selected);
    }

    this._selected = selected;
    selected.on({
      change: 'onSelectionChange',
      thisObj: this
    });
  }

  get itemSelector() {
    return `.${this.itemCls}`;
  }
  /**
   * Get the collection of selected records
   * @property {Core.util.Collection}
   * @readonly
   */


  get selected() {
    return this._selected;
  }
  /**
   * Get the backing store, a {@link Core.data.Store} holding the records used to generate list items
   * @property {Core.data.Store}
   * @readonly
   */


  get store() {
    // Ensure any configured items is processed into a store before we try to return it.
    this._thisIsAUsedExpression(this.items);

    return this._store;
  }

  changeStore(store) {
    const me = this;

    if (!(store instanceof _data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"])) {
      store = new _data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"](store);
    }

    me.detachListeners('store');

    if (store) {
      const storeListeners = {
        name: 'store',
        change: 'onStoreChange',
        refresh: 'onStoreRefresh',
        thisObj: me
      };

      if (store.readUrl) {
        storeListeners.beforeLoad = 'onBeforeStoreLoad';
        storeListeners.afterRequest = 'onAfterStoreRequest';
      }

      if (store.isGrouped) {
        me.element.classList.add('b-grouped');
        storeListeners.groupchange = 'onStoreRefresh';
      }

      store.on(storeListeners);
    }

    return store;
  }

  updateStore() {
    this.refresh();
  }

  changeNavigator(navigator) {
    const me = this,
          {
      element
    } = me;

    if (element) {
      navigator = (navigator.class || _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_6__["default"]).new({
        ownerCmp: me,
        target: element,
        keyEventTarget: element
      }, navigator); // This widget is responsible for relaying keyboard events into the navigator
      // So it must be able to receive focus.

      if (navigator.keyEventTarget === element) {
        element.tabIndex = 0;
      }
    }

    return navigator;
  }

  get minAlignHeight() {
    const lastItem = this.element.lastElementChild,
          minHeight = this.minHeight; // No minHeight specified, always defer to the items height

    if (minHeight != null) {
      return this.store.count ? Math.min(lastItem.offsetTop + lastItem.offsetHeight, minHeight) : 0;
    }
  } //endregion
  //region Hide/Show


  alignTo(...args) {
    // When aligning, if the items total height is less than minHeight, use that.
    super.minHeight = this.minAlignHeight;
    super.alignTo(...args);
  }

  hide(...args) {
    this.navigator.activeItem = null;
    return super.hide(...args);
  }

  show() {
    const {
      refreshCount
    } = this,
          {
      previousActiveItem
    } = this.navigator; // Restore the configured minHeight

    super.minHeight = this._minHeight;
    const retVal = super.show(); // If no refresh on paint took place, we need to restore the activeItem.
    // Refresh does that itself.

    if (this.refreshCount === refreshCount) {
      this.restoreActiveItem(previousActiveItem, true);
    }

    return retVal;
  }
  /**
   * Sets the passed record as the current focused record for keyboard navigation and selection purposes.
   * @param {Core.data.Model} activeItem The item to highlight as the active ("focused") item.
   * @param {String|Boolean} [block='nearest'] The block scroll specification to scroll
   * the item into view. Defaults to `'nearest'` which means a minimal scroll, only if
   * the item is actually out of view. Passing `true` is for when the List is aligned
   * to a picker and the selected item should be scrolled to be close to the picker,
   * however that is aligned. See `Combo.showPicker` for usage.
   * @internal
   */


  restoreActiveItem(activeItem = this.navigator.previousActiveItem, block = 'nearest') {
    const me = this,
          {
      navigator,
      lastAlignSpec
    } = me; // Zero may be passed to select first item, so cannot use truthiness.
    // This won't mean *clear* the active item if any. Falsy means
    // nothing to restore so leave it as is.

    if (activeItem != null) {
      if (typeof block !== 'string') {
        const alignZone = lastAlignSpec ? lastAlignSpec.zone : 1; // Scroll item into view appropriately, meaning closest to any align target.
        // Align zones are T,R,B,L => 0,1,2,3
        // If 1 or 3 (right or left), align nearest.
        // if 0 (above) align end.
        // else, we're below so align start.

        block = alignZone & 1 ? 'nearest' : alignZone ? 'start' : 'end';
      }

      activeItem = me.getItem(activeItem);

      if (activeItem) {
        // If we are aligned to a target, first, scroll the required item to the optimal
        // position to avoid Navigator's default minimal scroll to block: 'nearest'.
        // If we are aligned below a combo, move the point of interest to the top.
        // If we are aligned above a combo, move the point of interest to the bottom.
        me.scrollable.scrollIntoView(activeItem, {
          block
        });
        navigator.activeItem = activeItem;
      }
    }
  } //endregion
  //region Events

  /**
   * Focuses list items on hover.
   * @private
   */


  onMouseOver(event) {
    const me = this,
          itemElement = event.currentTarget; // Activate soon in case they're moving fast over items.

    if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isTouchEvent && itemElement && me.navigator && me.activateOnMouseover) {
      me.setTimeout({
        fn: 'handleMouseOver',
        delay: 30,
        args: [itemElement],
        cancelOutstanding: true
      });
    }
  }

  handleMouseOver(itemElement) {
    this.navigator.activeItem = itemElement;
  }
  /**
   * Selects list items on click.
   * @private
   */


  onClick(event) {
    const itemElement = event.target.closest(this.itemSelector);

    if (itemElement) {
      this.onItemClick(itemElement, event);
    }
  }
  /**
   * Key events which are not navigation are delegated up to here by the Navigator
   * @private
   */


  onInternalKeyDown(event) {
    const me = this,
          active = me.navigator.activeItem;

    switch (event.key) {
      case ' ':
        // If it's an input field that's providing events, allow it to process space.
        // Otherwise, it falls through and is processed the same as ENTER to make a click.
        if (event.target.nodeName.toUpperCase() === 'INPUT' && !event.target.readOnly) {
          break; // eslint-disable-line
        }

      case 'Enter':
        // eslint-disable-line
        if (active) {
          this.onItemClick(active, event); // Stop the keydown from bubbling.
          // And stop it from creating a keypress event.
          // No further action should be taken after item selection.

          event.stopImmediatePropagation();
          event.preventDefault();
        }

    }
  } //endregion


  onItemClick(item, event) {
    const me = this,
          index = parseInt(item.dataset.index);
    let record = me.store.getAt(index);
    me._isUserAction = true;

    if (me.allowGroupSelect || record && !record.isSpecialRow) {
      // Clicking on any element with the data-noselect attribute means no selection
      if (!item.contains(event.target.closest('[data-noselect]'))) {
        const selected = me.selected;
        let isSelected = selected.includes(record);

        if (me.multiSelect) {
          if (me.toggleAllIfCtrlPressed && event.ctrlKey) {
            record = me.store.getRange();
          } else if (me.allowGroupSelect && record.isSpecialRow) {
            isSelected = !record.groupChildren.some(rec => !selected.includes(rec));
            record = record.groupChildren;
          }

          selected[isSelected ? 'remove' : 'add'](record);
        } else {
          selected.splice(0, selected.count, record);
        }
      } else if (item.contains(event.target.closest('[data-select-all]'))) {
        me.onSelectAllClick(item, event);
      }
    }

    me.lastClicked = record;
    me.trigger('item', {
      item,
      record,
      index,
      event,
      userAction: true
    });
    me._isUserAction = false;
  }
  /**
   * Handles items being added or removed from the selected Collection
   * @param {Object} changeEvent
   * @private
   */


  onSelectionChange({
    action,
    removed,
    added,
    replaced
  }) {
    const me = this,
          {
      selectedCls,
      unselectedCls
    } = me;
    let record, item;

    if (action === 'clear') {
      for (item of me.element.querySelectorAll(`.${selectedCls}`)) {
        item.classList.remove(selectedCls);
        unselectedCls && item.classList.remove(unselectedCls);
      }
    } else {
      for (record of removed) {
        item = me.getItem(record);
        item && item.classList.remove(selectedCls);
      }

      for (record of added) {
        item = me.getItem(record);
        item && item.classList.add(selectedCls);
      }
    }

    me.selectAllItem && me.updateSelectAllState();
  }

  onSelectAllClick(item, event) {
    const me = this,
          checked = item.classList.contains(me.selectedCls);
    me.selected[checked ? 'remove' : 'add'](me.store.getRange());
  }

  updateSelectAllState() {
    const me = this,
          selectAllEl = me.element.querySelector('.b-select-all-item'),
          allRecordsSelected = me.selected.count === me.store.count,
          action = allRecordsSelected ? 'add' : 'remove';
    selectAllEl.classList[action](me.selectedCls);
  }

} // Register this widget type with its Factory

List.initClass();
List.prototype.navigatorClass = _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_6__["default"];
List._$name = 'List';

/***/ }),

/***/ "./lib/Core/widget/Mask.js":
/*!*********************************!*\
  !*** ./lib/Core/widget/Mask.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Mask; });
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/util/Promissory.js */ "./lib/Core/helper/util/Promissory.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Renderable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Renderable.js */ "./lib/Core/widget/Renderable.js");
var productName = 'taskboard';




 //TODO: add loader

/**
 * @module Core/widget/Mask
 */

/**
 * Masks a target element (document.body if none is specified). Call static methods for ease of use or make instance
 * for reusability.
 *
 * @example
 * Mask.mask('hello');
 * Mask.unmask();
 *
 * @inlineexample Core/widget/Mask.js
 *
  * @example
 * // Using progress by calling static method
 * let mask = Mask.mask({
 *   text:'The task is in progress',
 *   progress: 0,
 *   maxProgress: 100
 * }, document.body);
 * let timer = setInterval(()=>{
 *   mask.progress += 5;
 *   if(mask.progress >= mask.maxProgress) {
 *     Mask.unmask();
 *     clearInterval(timer)
 *   }
 * },100)
 *
 * @example
 * // Using progress to mask a Bryntum component
 * scheduler.mask({
 *  text:'Loading in progress',
 *   progress: 0,
 *   maxProgress: 100
 * })
 * let timer = setInterval(()=>{
 *   scheduler.masked.progress += 5;
 *   if(scheduler.masked.progress >= scheduler.masked.maxProgress) {
 *     scheduler.unmask();
 *     clearInterval(timer)
 *   }
 * },100)
 *
 */

class Mask extends _Renderable_js__WEBPACK_IMPORTED_MODULE_4__["default"] {
  //region Config
  static get $name() {
    return 'Mask';
  } // Factoryable type name


  static get type() {
    return 'mask';
  }

  static get configurable() {
    return {
      /**
       * Set this config to trigger an automatic close after the desired delay:
       * ```
       *  mask.autoClose = 2000;
       * ```
       * If the mask has an `owner`, its `onMaskAutoClosing` method is called when the close starts and its
       * `onMaskAutoClose` method is called when the close finishes.
       * @config {Number}
       * @private
       */
      autoClose: null,

      /**
       * The portion of the {@link #config-target} element to be covered by this mask. By default, the mask fully
       * covers the `target`. In some cases, however, it may be desired to only cover the `'body'` (for example,
       * in a grid).
       *
       * This config is set in conjunction with `owner` which implements the method `syncMaskCover`.
       *
       * @config {String}
       * @private
       */
      cover: null,

      /**
       * The icon to show next to the text. Defaults to showing a spinner
       * @config {String}
       * @default
       */
      icon: 'b-icon b-icon-spinner',
      errorDefaults: {
        icon: 'b-icon b-icon-warning',
        autoClose: 3000,
        showDelay: 0
      },

      /**
       * The maximum value of the progress indicator
       * @property {Number}
       */
      maxProgress: null,

      /**
       * Mode: bright, bright-blur, dark or dark-blur
       * @config {String}
       * @default
       */
      mode: 'dark',

      /**
       * Number expressing the progress
       * @property {Number}
       */
      progress: null,
      // The owner is involved in the following features:
      //
      // - The `autoClose` timer calls `onMaskAutoClose`.
      // - The `cover` config calls `syncMaskCover`.
      // - If the `target` is a string, that string names the property of the `owner` that holds the
      //   `HTMLElement` reference.

      /**
       * The owning widget of this mask. This is required if `target` is a string.
       *
       * @config {Object|Core.widget.Widget}
       */
      owner: null,

      /**
       * The element to be masked. If this config is a string, that string is the name of the property of the
       * `owner` that holds the `HTMLElement` that is the actual target of the mask.
       *
       * NOTE: In prior releases, this used to be specified as the `element` config, but that is now, as with
       * `Widget`, the primary element of the mask.
       *
       * @config {String|HTMLElement}
       */
      target: null,

      /**
       * The text (or HTML) to show in mask
       * @config {String}
       */
      text: null,
      // TODO - perhaps a better way to deal w/multiple reasons to mask something would be a mask FIFO behind
      //  the scenes so that only one mask is visible at a time. That would take a bit of tinkering in the
      //  hide/show mechanism but feels like a more natural way to go. In which case, this config would go away
      //  and multiple masks would simply cooperate. https://github.com/bryntum/support/issues/190
      // This property is used to block trial mask removal
      // https://github.com/bryntum/support/issues/2604
      type: null,

      /**
       * The number of milliseconds to delay before making the mask visible. If set, the mask will have an
       * initial `opacity` of 0 but will function in all other ways as a normal mask. Setting this delay can
       * reduce flicker in cases where load operations are typically short (for example, a second or less).
       *
       * @config {Number}
       */
      showDelay: null,
      useTransition: false
    };
  }

  static get delayable() {
    return {
      deferredClose: 0,
      delayedShow: 0
    };
  } //endregion
  //region Init


  construct(config) {
    if (config) {
      let el = config.element,
          cfg; // Upgrade config -> cfg
      // Treat config as readonly, cfg is lazily copied and writable

      if (el) {
        _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].deprecate('Core', '4.0.0', 'Mask "element" config has been renamed to "target"');
        config = cfg = Object.assign({}, config);
        delete cfg.element;
        cfg.target = el;
      }

      el = config.target;

      if (typeof el === 'string') {
        config = cfg = cfg || Object.assign({}, config);
        cfg.target = config.owner[el]; // must supply "owner" in this case
      }
    }

    super.construct(config);

    if (!this.target) {
      this.target = document.body;
    }

    this.show();
  }

  doDestroy() {
    const me = this,
          {
      element
    } = me; // Do not destroy a trial mask

    if (me.type === 'trial') {
      return false;
    }

    if (element) {
      me.element = null;

      if (me.mode.endsWith('blur')) {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEachChild(element, child => {
          child.classList.remove(`b-masked-${me.mode}`);
        });
      }

      me.target.classList.remove('b-masked');
      me.target[me.maskName] = null;
    }

    super.doDestroy();
  }

  get maskElement() {
    // TODO log on use of deprecated property?
    return this.element;
  }

  get maskName() {
    const type = this.type;
    return `mask${typeof type === 'string' ? type.trim() : ''}`;
  }

  set error(value) {
    this.setConfig(this.errorDefaults);
    this.text = value;
  }

  renderDom() {
    const me = this,
          {
      maxProgress
    } = me;
    return {
      class: {
        'b-mask': 1,
        'b-delayed-show': me.showDelay,
        'b-widget': 1,
        [`b-mask-${me.mode}`]: 1,
        'b-progress': maxProgress,
        'b-prevent-transitions': !me.useTransition
      },
      children: [{
        reference: 'maskContent',
        class: 'b-mask-content b-drawable',
        children: [maxProgress ? {
          reference: 'progressElement',
          class: 'b-mask-progress-bar',
          style: {
            width: `${Math.max(0, Math.min(100, Math.round(me.progress / maxProgress * 100)))}%`
          }
        } : null, {
          reference: 'maskText',
          class: 'b-mask-text',
          html: (me.icon ? `<i class="b-mask-icon ${me.icon}"></i>` : '') + me.text
        }]
      }]
    };
  } //endregion
  //region Static


  static mergeConfigs(...sources) {
    const ret = {};

    for (const src of sources) {
      if (typeof src === 'string') {
        ret.text = src;
      } else {
        _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(ret, src); // not Object.assign!
      }
    }

    return ret;
  }
  /**
   * Shows a mask with the specified message
   * @param {String|Object} text Message
   * @param {HTMLElement} target The element to mask
   * @returns {Core.widget.Mask}
   */


  static mask(text, target = document.body) {
    return new Mask(typeof text !== 'string' ? Object.assign({
      target
    }, text) : {
      target,
      text
    });
  }
  /**
   * Unmask
   * @param {HTMLElement} element Element to unmask
   * @returns {Promise} A promise which is resolved when the mask is gone
   */


  static unmask(element = document.body) {
    return element.mask && element.mask.close();
  } //endregion
  //region Config


  updateAutoClose(delay) {
    const me = this;
    me.deferredClose.cancel();

    if (delay) {
      me.deferredClose.delay = delay;
      me.deferredClose();
    }
  }

  updateCover() {
    const owner = this.owner;

    if (owner && owner.syncMaskCover) {
      owner.syncMaskCover(this);
    }
  }

  updateShowDelay(delay) {
    const delayedShow = this.delayedShow;
    delayedShow.delay = delay;

    if (!delay) {
      delayedShow.flush();
    }
  } //endregion
  //region Show & hide


  deferredClose() {
    const owner = this.owner;
    this.close().then(() => {
      if (owner && owner.onMaskAutoClose) {
        owner.onMaskAutoClose(this);
      }
    });

    if (owner && owner.onMaskAutoClosing) {
      owner.onMaskAutoClosing(this);
    }
  }

  delayedShow() {
    this.classes.remove('b-delayed-show');
  }
  /**
   * Show mask
   */


  show() {
    const me = this,
          {
      element,
      target,
      hiding,
      maskName
    } = me; // We don't do this because we may want to show but automatically close after a
    // brief delay. The order of applying those configs should not be an issue. In
    // other words, to stop the deferredClose, you must set autoClose to falsy.
    // me.deferredClose.cancel();

    if (hiding) {
      // Resolving seems much better than the only other options:
      //  1. Never settling
      //  2. Rejecting
      hiding.resolve(); // This will be nulled out as the promise resolves but that is a race condition
      // compared to the next hide() call.

      me.hiding = null;
      me.clearTimeout('hide');
    }

    if (me.showDelay) {
      element.classList.add('b-delayed-show');
      me.delayedShow();
    }

    element.classList.add('b-visible');
    element.classList.remove('b-hidden');
    target.classList.add('b-masked');

    if (!target[maskName]) {
      target[maskName] = me;
      target.appendChild(element);
    }

    me.shown = true;
    me.trigger('show'); // blur has to blur child elements

    if (me.mode.endsWith('blur')) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEachChild(target, child => {
        if (child !== element) {
          child.classList.add(`b-masked-${me.mode}`);
        }
      });
    }
  }
  /**
   * Hide mask
   * @returns {Promise} A promise which is resolved when the mask is hidden, or immediately if already hidden
   */


  hide() {
    const me = this,
          {
      target,
      element
    } = me;
    let hiding = me.hiding;

    if (!hiding) {
      if (!me.shown) {
        return Promise.resolve();
      }

      me.hiding = hiding = new _helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_1__["default"]();
      me.shown = false;
      element.classList.remove('b-visible');
      element.classList.add('b-hidden');
      target.classList.remove('b-masked');

      if (me.mode.endsWith('blur')) {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEachChild(target, child => {
          if (child !== element) {
            child.classList.remove(`b-masked-${me.mode}`);
          }
        });
      }

      hiding.promise = hiding.promise.then(() => {
        if (me.hiding === hiding) {
          me.hiding = null;
        }
      }); // TODO: use AnimationHelper when available

      me.setTimeout(() => hiding.resolve(), 500, 'hide');
    }

    return hiding.promise;
  }
  /**
   * Close mask (removes it)
   * @returns {Promise} A promise which is resolved when the mask is closed
   */


  close() {
    return this.hide().then(() => {
      this.destroy();
    });
  } //endregion


}
Mask._$name = 'Mask';

/***/ }),

/***/ "./lib/Core/widget/Menu.js":
/*!*********************************!*\
  !*** ./lib/Core/widget/Menu.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Menu; });
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _MenuItem_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./MenuItem.js */ "./lib/Core/widget/MenuItem.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
var productName = 'taskboard';





const validKeys = {
  ArrowUp: 1,
  ArrowDown: 1,
  ArrowRight: 1,
  ArrowLeft: 1,
  Enter: 1,
  Escape: 1
};
/**
 * @module Core/widget/Menu
 */

/**
 * Menu widget, displays a list of items which the user can select from using mouse or keyboard. Can have submenus.
 *
 * @example
 * let menu = new Menu({
 *     forElement : btn.element,
 *     items      : [
 *         {
 *             icon : 'b-icon b-icon-add',
 *             text : 'Add'
 *         },
 *         {
 *             icon : 'b-icon b-icon-trash',
 *             text : 'Remove'
 *         },
 *         {
 *             icon     : 'b-icon b-icon-lock',
 *             disabled : true,
 *             text     : 'I am disabled'
 *         },
 *         {
 *             text : 'Sub menu',
 *             menu : [{
 *                 icon : 'b-icon b-fa-play',
 *                 text : 'Play'
 *             }]
 *         }
 *     ],
 *     // Method is called for all ancestor levels
 *     onItem({ item }) {
 *         Toast.show('You clicked ' + item.text);
 *     }
 * });
 *
 * @classType menu
 * @inlineexample Core/widget/Menu.js
 *
 * @extends Core/widget/Popup
 */

class Menu extends _Popup_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Menu';
  } // Factoryable type name


  static get type() {
    return 'menu';
  }

  static get configurable() {
    return {
      focusable: true,
      align: 't-b',
      scrollAction: 'hide',

      /**
       * Specify false to prevent the menu from getting focus when hovering items
       * @default
       * @config {Boolean}
       */
      focusOnHover: null,
      // We do need a Scroller so that we can use its API to scroll around.
      // But the overflow flags default to false.
      scrollable: false,
      defaultType: 'menuitem',
      tools: {
        // To get rid of the close tool from Popup
        close: false
      }
    };
  }
  /**
   * Currently open sub menu, if any
   * @member {Core.widget.Menu} currentSubMenu
   * @readonly
   */
  //endregion

  /**
   * A descendant menu item has been activated.
   *
   * Note that this event bubbles up through parents and can be
   * listened for on a top level {@link Core.widget.Menu Menu} for convenience.
   * @event item
   * @param {Core.widget.MenuItem} item - The menu item which is being actioned.
   * @param {Core.widget.Menu} menu - Menu containing the menu item
   */

  /**
   * The checked state of a descendant menu item has changed.
   *
   * Note that this event bubbles up through parents and can be
   * listened for on a top level {@link Core.widget.Menu Menu} for convenience.
   * @event toggle
   * @param {Core.widget.MenuItem} item - The menu item whose checked state changed.
   * @param {Core.widget.Menu} menu - Menu containing the menu item
   * @param {Boolean} checked - The _new_ checked state.
   */

  /* break doc comment */
  //region Init


  construct(config) {
    if (Array.isArray(config)) {
      config = {
        lazyItems: config
      };
    }

    super.construct(config);
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: this.element,
      click: 'onMouseClick',
      mouseover: 'onMouseOver',
      mouseleave: 'onMouseLeave',
      thisObj: this
    });
  }

  afterShow(resolveFn) {
    // Don't instantiate all our items' subMenus right now.
    // Use our private _menu property which will still be a config item.
    const me = this,
          hasSubmenu = me.items.some(item => Boolean(item._menu)); // afterShow is called before alignment, so this is the correct time
    // to mutate things which will change this Widget's size.

    if (hasSubmenu) {
      me.element.classList.add('b-menu-with-submenu');
    } // Add CSS class to menu if any item has an icon, to allow aligning icon-less items


    const hasIcon = me.items.some(item => item.icon);

    if (hasIcon) {
      me.element.classList.add('b-menu-with-icon');
    }

    super.afterShow(resolveFn);
  }

  createWidget(item) {
    if (typeof item === 'string') {
      item = {
        text: item
      };
    }

    return super.createWidget(item);
  }

  get focusElement() {
    var _me$parentMenu;

    const me = this,
          fromParentMenu = (_me$parentMenu = me.parentMenu) === null || _me$parentMenu === void 0 ? void 0 : _me$parentMenu.element.contains(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(me.parentMenu)),
          firstWidget = me.items[0];

    if (fromParentMenu || !(firstWidget instanceof _MenuItem_js__WEBPACK_IMPORTED_MODULE_3__["default"])) {
      return super.focusElement;
    }

    return me.element;
  } //endregion


  onDocumentMouseDown({
    event
  }) {
    // It's not a click outside if its a click on our owner Menu
    if (!this.parentMenu || !this.parentMenu.owns(event.target)) {
      return super.onDocumentMouseDown(...arguments);
    }
  } //region Show


  hide(animate) {
    const me = this; // We need to be _hidden when any focused descendants try to revertFocus
    // so that they continue to fall back through the getFocusRevertTarget upward chain.

    super.hide(animate);

    if (!me.isVisible) {
      var _me$currentSubMenu, _me$currentSubMenu$hi;

      // Will have no hide method if destroyed
      (_me$currentSubMenu = me.currentSubMenu) === null || _me$currentSubMenu === void 0 ? void 0 : (_me$currentSubMenu$hi = _me$currentSubMenu.hide) === null || _me$currentSubMenu$hi === void 0 ? void 0 : _me$currentSubMenu$hi.call(_me$currentSubMenu, animate);

      if (me.parentMenu) {
        me.parentMenu.currentSubMenu = null;
      }
    }
  }

  show() {
    super.show(...arguments);
    const {
      parentMenu
    } = this;

    if (this.isVisible && parentMenu) {
      parentMenu.currentSubMenu = this;
    }
  } //endregion
  //region Events

  /**
   * Activates a menu item if user clicks on it
   * @private
   */


  onMouseClick(event) {
    const menuItem = event.target.closest('.b-menuitem');

    if (menuItem) {
      this.triggerElement(menuItem, event); // IE / Edge still triggers event listeners that were removed in a listener - prevent this

      event.stopImmediatePropagation();
    }
  }
  /**
   * Activates menu items on hover. On real mouse hover, not on a touchstart.
   * @private
   */


  onMouseOver(event) {
    if (this.focusOnHover !== false) {
      const fromItemElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(event.relatedTarget, '.b-widget'),
            toItemElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(event.target, '.b-widget'),
            overItem = _Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].fromElement(toItemElement); // Activate soon in case they're moving fast over items.

      if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isTouchEvent && toItemElement && toItemElement !== fromItemElement && overItem.parent === this) {
        this.setTimeout({
          fn: 'handleMouseOver',
          delay: 30,
          args: [overItem],
          cancelOutstanding: true
        });
      }
    }
  }

  handleMouseOver(overItem) {
    overItem.focus();
  } // unselect any menu item if mouse leaves the menu element (unless it enters a child menu)


  onMouseLeave(event) {
    const me = this,
          {
      relatedTarget
    } = event,
          leavingToChild = relatedTarget && me.owns(relatedTarget);
    let targetCmp = relatedTarget && relatedTarget instanceof HTMLElement && _Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].fromElement(relatedTarget),
        shouldHideMenu = !leavingToChild;

    if (targetCmp) {
      while (targetCmp.ownerCmp) {
        targetCmp = targetCmp.ownerCmp;
      } // Or was found and does not belong to current menu DOM tree
      // This condition will not allow possibly existing picker to hide
      // Covered by Menu.t.js


      shouldHideMenu &= !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getAncestor(targetCmp.element, [event.target]);
    }

    if (!leavingToChild && shouldHideMenu) {
      var _me$currentSubMenu2;

      (_me$currentSubMenu2 = me.currentSubMenu) === null || _me$currentSubMenu2 === void 0 ? void 0 : _me$currentSubMenu2.hide(); // Deactivate currently active *menu items* on mouseleave

      if (me.element.contains(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(me)) && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(me).matches('.b-menuitem')) {
        me.focusElement.focus();
      }
    }
  }
  /**
   * Keyboard navigation. Up/down, close with esc, activate with enter
   * @private
   */


  onInternalKeyDown(event) {
    const sourceWidget = _Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].fromElement(event),
          isFromWidget = sourceWidget && sourceWidget !== this && !(sourceWidget instanceof _MenuItem_js__WEBPACK_IMPORTED_MODULE_3__["default"]);

    if (event.key === 'Escape') {
      // Only close this menu if the ESC was in a child input Widget
      (isFromWidget ? this : this.rootMenu).close();
      return;
    }

    super.onInternalKeyDown(event); // Do not process keys from certain elements

    if (isFromWidget) {
      return;
    }

    if (validKeys[event.key]) {
      event.preventDefault();
    }

    const el = this.element,
          active = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getActiveElement(el);
    this.navigateFrom(active !== el && el.contains(active) ? active : null, event.key, event);
  }

  navigateFrom(active, key, event) {
    const me = this,
          treeWalker = me.treeWalker,
          item = active && me.getItem(active);
    let toActivate;

    switch (key) {
      case 'ArrowUp':
        treeWalker.currentNode = active || (active = me.bottomFocusTrap);
        treeWalker.previousNode();
        toActivate = treeWalker.currentNode;
        break;

      case 'ArrowDown':
        treeWalker.currentNode = active || (active = me.topFocusTrap);
        treeWalker.nextNode();
        toActivate = treeWalker.currentNode;
        break;

      case ' ':
        if (active && !active.classList.contains('b-disabled')) {
          if (item && item.menu) {
            me.openSubMenu(active, item);
          } else {
            me.triggerElement(active, event);
          }
        }

        break;

      case 'ArrowRight':
        if (active && item && item.menu && !active.classList.contains('b-disabled')) {
          // opening with arrow keys highlights first item (as in menus on mac)
          const openedMenu = me.openSubMenu(active, item); // If show hs not been vetoed, ask it to focus.
          // Container will delegate focus inward if possible.

          if (openedMenu) {
            openedMenu.focus();
          }
        } else {
          treeWalker.currentNode = active || (active = me.topFocusTrap);
          treeWalker.nextNode();
          toActivate = treeWalker.currentNode;
        }

        break;

      case 'ArrowLeft':
        if (me.isSubMenu) {
          me.hide();
        } else if (!active) {
          treeWalker.currentNode = active || (active = me.topFocusTrap);
          treeWalker.nextNode();
          toActivate = treeWalker.currentNode;
        }

        break;

      case 'Enter':
        if (active && !active.classList.contains('b-disabled')) {
          me.triggerElement(active, event);
        }

        break;
    } // Move focus to wherever we have calculated


    if (toActivate) {
      // Previous moved to encapsulating element; wrap from end
      if (toActivate === me.element) {
        me.navigateFrom(me.bottomFocusTrap, 'ArrowUp', event);
      } // Next could not move because we're at the end; wrap from top
      else if (toActivate === active) {
        me.navigateFrom(me.topFocusTrap, 'ArrowDown', event);
      } else {
        toActivate.focus();
      }
    }
  } //endregion
  //region Activate menu item


  getItem(item) {
    // Cannot use truthiness test because index zero may be passed.
    if (item != null) {
      // Access by index
      if (typeof item === 'number') {
        return this.items[item];
      } // Access by element


      if (item.nodeType === Element.ELEMENT_NODE) {
        return _Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].fromElement(item, 'menuitem', this.contentElement);
      } // Access by id


      return this.items.find(c => c.id == item);
    }
  }
  /**
   * Activate a menu item (from its element)
   * @private
   * @fires item
   * @param menuItemElement
   */


  triggerElement(menuItemElement, event) {
    const item = this.getItem(menuItemElement); // If the trigger gesture happened on a non-MenuItem
    // item will be undefined. Do not action on a non-MenuItem
    // or a disabled MenuItem

    if (item && !item.disabled) {
      item.doAction(event);
    }
  }
  /**
   * Returns true if this menu is a sub menu.
   * To find out which menu is the parent, check {@link #property-parentMenu}.
   * @type {Boolean}
   * @readonly
   */


  get isSubMenu() {
    var _this$owner;

    return this === ((_this$owner = this.owner) === null || _this$owner === void 0 ? void 0 : _this$owner.menu);
  }
  /**
   * Opens a submenu anchored to a menu item
   * @private
   * @param element
   * @param item
   */


  openSubMenu(element, item) {
    const me = this,
          subMenu = item.menu;

    if (subMenu) {
      if (!subMenu.isVisible) {
        const event = {
          item,
          element
        };

        if (me.trigger('beforeSubMenu', event) === false) {
          return;
        }

        if (item.onBeforeSubMenu && item.onBeforeSubMenu(event) === false) {
          return;
        }

        subMenu.show();
      }

      return me.currentSubMenu = subMenu;
    }
  }
  /**
   * Get/set focused menu item.
   * Shows submenu if newly focused item has a menu and is not disabled.
   * @property {HTMLElement}
   */


  set selectedElement(element) {
    const me = this,
          lastSelected = me._selectedElement;

    if (lastSelected) {
      const lastItem = me.getItem(lastSelected),
            lastItemMenu = lastItem && lastItem.menu;

      if (lastItemMenu) {
        lastItemMenu.hide();
      }

      lastSelected.classList.remove('b-active');
    }

    me._selectedElement = element; // might set to null to deselect

    if (element) {
      const doFocus = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isFocusable(element);
      element.classList.add('b-active');
      me.scrollable.scrollIntoView(element, {
        animate: !doFocus,
        focus: doFocus
      });
    }
  }

  get selectedElement() {
    return this._selectedElement;
  }

  selectFirst() {
    const treeWalker = this.treeWalker;
    treeWalker.currentNode = this.topFocusTrap;
    treeWalker.nextNode(); // If we are under keyboard control, this must happen in the next
    // animation frame so that the keydown event doesn't fire on the
    // newly focused node.

    this.requestAnimationFrame(() => treeWalker.currentNode.focus());
  } //endregion
  //region Close

  /**
   * Gets the parent Menu if this Menu is a submenu, or `undefined`.
   * @property {Core.widget.Menu}
   */


  get parentMenu() {
    var _result$up;

    const result = this.owner;
    return result && (result.isMenu ? result : (_result$up = result.up) === null || _result$up === void 0 ? void 0 : _result$up.call(result, 'menu'));
  }
  /**
   * Gets this menus root menu, the very first menu shown in a sub menu hierarchy
   * @property {Core.widget.Menu}
   * @private
   */


  get rootMenu() {
    let menu = this;

    while (menu.parentMenu && menu.parentMenu instanceof this.constructor) {
      menu = menu.parentMenu;
    }

    return menu;
  } //endregion


} // Register this widget type with its Factory

Menu.initClass();
Menu._$name = 'Menu';

/***/ }),

/***/ "./lib/Core/widget/MenuItem.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/MenuItem.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MenuItem; });
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _Menu_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Menu.js */ "./lib/Core/widget/Menu.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';




/**
 * @module Core/widget/MenuItem
 */

const bIcon = /^b-icon-/,
      bFa = /^b-fa-/;
/**
 * A widget representing a single menu item in a {@link Core.widget.Menu}. May be configured with a
 * {@link #config-checked} state which creates a checkbox which may be toggled. Can also be
 * {@link Core.widget.Widget#config-disabled}, which affects item appearance and blocks interactions.
 *
 * Fires events when activated which bubble up through the parent hierarchy
 * and may be listened for on an ancestor. See {@link Core.widget.Menu Menu}
 * for more details on usage.
 *
 * To add a border below a menuitem, you can set the item´s {@link #config-cls} to `b-separator`.
 *
 * @extends Core/widget/Widget
 * @classType menuitem
 */

class MenuItem extends _Widget_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
  //region Config
  static get $name() {
    return 'MenuItem';
  } // Factoryable type name


  static get type() {
    return 'menuitem';
  }

  static get configurable() {
    return {
      /**
       * If configured with a `Boolean` value, a checkbox is displayed
       * as the start icon, and the {@link #event-toggle} event is fired
       * when the checked state changes.
       * @config {Boolean}
       */
      checked: null,

      /**
       * Indicates that this menu item is part of a group where only one can be checked. Assigning a value
       * also sets `toggleable` to `true`.
       * ```
       * const yesButton = new Button({
       *    toggleGroup : 'yesno',
       *    text        : 'Yes'
       * });
       *
       * const noButton = new Button({
       *    toggleGroup : 'yesno',
       *    text        : 'No'
       * });
       * ```
       * @config {String}
       */
      toggleGroup: null,

      /**
       * Returns the instantiated menu widget as configured by {@link #config-menu}.
       * @member {Core.widget.Widget} menu
       * @readonly
       */

      /**
       * A submenu configuration object, or an array of MenuItem configuration
       * objects from which to create a submenu.
       *
       * Configuration object example:
       * ```javascript
       * new Menu({
       *     // Menu items
       *     items : {
       *         move : {
       *             text : 'Main item',
       *             menu : {
       *                 // Submenu items
       *                 firstItem : {
       *                     text : 'Sub-item 1',
       *                     onItem({ eventRecord }) {}
       *                 },
       *                 secondItem : {
       *                     text : 'Sub-item 2',
       *                     onItem({ eventRecord }) {}
       *                 }
       *             }
       *         }
       *     }
       * });
       * ```
       *
       * Array of items example:
       * ```javascript
       * new Menu({
       *     // Menu items
       *     items : {
       *         move : {
       *             text : 'Main item',
       *             // Submenu items
       *             menu : [
       *                 {
       *                     text : 'Sub-item 1',
       *                     onItem({ eventRecord }) {}
       *                 },
       *                 {
       *                     text : 'Sub-item 2',
       *                     onItem({ eventRecord }) {}
       *                 }
       *             ]
       *         }
       *     }
       * });
       * ```
       *
       * Note that this does not have to be a Menu. The `type` config can be used to specify any widget as the submenu.
       * ```javascript
       * new Menu({
       *     // Menu items
       *     items : {
       *         move : {
       *             text : 'Main item',
       *             // Submenu items
       *             menu : [
       *                 {
       *                     type  : 'textfield',
       *                     label : 'Type here'
       *                 },
       *                 {
       *                     type : 'button',
       *                     text : 'Confirm'
       *                 }
       *             ]
       *         }
       *     }
       * });
       * ```
       *
       * @config {Object|Object[]}
       */
      menu: {
        value: null,
        $config: ['lazy', 'nullify']
      },

      /**
       * Item icon class.
       *
       * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
       *
       * Otherwise this is a developer-defined CSS class string which results in the desired icon.
       * @config {String}
       */
      icon: null,

      /**
       * The text to be displayed in the item
       * @config {String} text
       */

      /**
       * By default, upon activate, non-checkbox menu items will collapse
       * the owning menu hierarchy.
       *
       * Configure this as `false` to cause the menu to persist after
       * activating an item
       * @config {Boolean}
       */
      closeParent: null,

      /**
       * If provided, turns the menu item into a link
       * @config {String}
       */
      href: null,

      /**
       * The `target` attribute for the {@link #config-href} config
       * @config {String}
       */
      target: null,
      localizableProperties: ['text']
    };
  }

  compose() {
    const {
      checked,
      href,
      hasMenu,
      target,
      text
    } = this,
          icon = this.icon || (typeof checked === 'boolean' ? 'b-fw-icon' : '');
    return {
      tag: href ? 'a' : 'div',
      tabIndex: -1,
      href,
      target,
      class: {
        'b-has-submenu': hasMenu
      },
      dataset: {
        group: this.toggleGroup
      },
      children: {
        iconElement: icon && {
          tag: 'i',
          class: _objectSpread({
            'b-fa': bFa.test(icon),
            'b-icon': bIcon.test(icon),
            'b-icon-checked': checked === true,
            'b-icon-unchecked': checked === false,
            'b-menuitem-icon': 1
          }, _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_0__["default"].normalize(icon, 'object'))
        },
        textElement: {
          tag: 'span',
          html: text,
          class: {
            'b-menu-text': 1
          }
        },
        subMenuIcon: hasMenu && {
          tag: 'i',
          class: {
            'b-fw-icon': 1,
            'b-icon-sub-menu': 1
          }
        }
      }
    };
  }
  /**
   * Actions this item. Fires the {@link #event-item} event, and if this
   * if a {@link #config-checked} item, toggles the checked state, firing
   * the {@link #event-toggle} event.
   */


  doAction(event) {
    const item = this,
          menu = this.parent,
          itemEvent = {
      menu,
      item,
      element: item.element,
      bubbles: true
    };

    if (typeof item.checked === 'boolean') {
      const newCheckedState = !item.checked; // Do not allow uncheck in a toggleGroup.
      // A toggleGroup means that one member must always be checked.

      if (!item.toggleGroup || newCheckedState) {
        item.checked = !item.checked;
      }
    } // Give internal handlers a chance to inject extra information before
    // user-supplied "item" handlers see the event.
    // Grid's CellMenu feature, HeaderMenu feature and other context menu features do this.


    item.trigger('beforeItem', itemEvent);
    /**
     * This menu item has been activated.
     *
     * Note that this event bubbles up through parents and can be
     * listened for on a top level {@link Core.widget.Menu Menu} for convenience.
     * @event item
     * @param {Core.widget.MenuItem} item - The menu item which is being actioned.
     * @param {Core.widget.Menu} menu - Menu containing the menu item
     */

    item.trigger('item', itemEvent); // Collapse the owning menu hierarchy if configured to do so

    if (item.closeParent && menu) {
      menu.rootMenu.close(); // Don't prevent links doing their thing

      if (event && !item.href) {
        event.preventDefault();
      }
    }
  }

  get focusElement() {
    return this.element;
  }

  get contentElement() {
    return this.textElement;
  }

  get isFocusable() {
    const focusElement = this.focusElement; // We are only focusable if the focusEl is deeply visible, that means
    // it must have layout - an offsetParent. Body does not have offsetParent.
    // Disabled menu items are focusable but cannot be activated.
    // https://www.w3.org/TR/wai-aria-practices/#h-note-17

    return focusElement && this.isVisible && (focusElement === document.body || focusElement.offsetParent);
  }

  get hasMenu() {
    return this.hasConfig('menu');
  }

  get childItems() {
    const {
      menu
    } = this;
    return menu ? [menu] : [];
  }

  get text() {
    return this.html;
  }

  set text(text) {
    this.html = text;
  }

  onFocusIn(e) {
    super.onFocusIn(e);

    if (!this.disabled && this.menu) {
      this.openMenu();
    }
  }

  onFocusOut(e) {
    super.onFocusOut(e);
    this.closeMenu();
  }

  openMenu(andFocus) {
    const menu = this.menu;

    if (!this.disabled && menu) {
      menu.focusOnToFront = andFocus;
      menu.show();
    }
  }

  closeMenu() {
    if (this._menu instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
      this.menu.close();
    }
  }

  changeToggleGroup(toggleGroup) {
    if (toggleGroup && typeof this.checked !== 'boolean') {
      this.checked = false;
    }

    return toggleGroup;
  }
  /**
   * Get/sets the checked state of this `MenuItem` and fires the {@link #event-toggle}
   * event upon change.
   *
   * Note that this must be configured as a `Boolean` to enable the checkbox UI.
   * @member {Boolean} checked
   */


  changeChecked(checked, old) {
    if (this.isConfiguring || typeof old === 'boolean') {
      return Boolean(checked);
    }
  }

  updateChecked(checked) {
    const me = this;

    if (!me.isConfiguring) {
      if (me.toggleGroup) {
        me.uncheckToggleGroupMembers();
      }
      /**
       * The checked state of this menu item has changed.
       *
       * Note that this event bubbles up through parents and can be listened for on a top level
       * {@link Core.widget.Menu Menu} for convenience.
       * @event toggle
       * @param {Core.widget.MenuItem} item - The menu item whose checked state changed.
       * @param {Core.widget.Menu} menu - Menu containing the menu item
       * @param {Boolean} checked - The _new_ checked state.
       */


      me.trigger('toggle', {
        menu: me.owner,
        item: me,
        element: me.element,
        bubbles: true,
        checked
      });
    }
  }

  getToggleGroupMembers() {
    const me = this,
          {
      checked,
      toggleGroup,
      element
    } = me,
          result = [];

    if (checked && toggleGroup) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEachSelector(me.rootElement, `[data-group=${toggleGroup}]`, otherElement => {
        if (otherElement !== element) {
          const partnerCheckItem = _Widget_js__WEBPACK_IMPORTED_MODULE_2__["default"].fromElement(otherElement);
          partnerCheckItem && result.push(partnerCheckItem);
        }
      });
    }

    return result;
  }

  uncheckToggleGroupMembers() {
    if (this.checked && this.toggleGroup) {
      this.getToggleGroupMembers().forEach(widget => widget.checked = false);
    }
  }

  get closeParent() {
    const result = typeof this.checked === 'boolean' ? this._closeParent : this._closeParent !== false;
    return result && !this.hasMenu;
  }

  changeMenu(config, existingMenu) {
    const me = this,
          {
      constrainTo,
      scrollAction
    } = me.owner; // This covers both Array and Object which are valid items config formats.
    // menu could be { itemRef : { text : 'sub item 1 } }. But if it has
    // child items or html property in it, it's the main config

    if (config && typeof config === 'object' && !('items' in config) && !('widgets' in config) && !('html' in config)) {
      config = {
        lazyItems: config
      };
    }

    return _Menu_js__WEBPACK_IMPORTED_MODULE_1__["default"].reconfigure(existingMenu, config, {
      owner: me,
      defaults: {
        type: 'menu',
        align: 'l0-r0',
        anchor: true,
        autoClose: true,
        autoShow: false,
        cls: 'b-sub-menu',
        // Makes the anchor hoverable to avoid mouseleave
        forElement: me.element,
        owner: me,
        constrainTo,
        scrollAction
      }
    });
  }

} // Register this widget type with its Factory

MenuItem.initClass();
MenuItem._$name = 'MenuItem';

/***/ }),

/***/ "./lib/Core/widget/MessageDialog.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/MessageDialog.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _TextField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'taskboard';






/**
 * @module Core/widget/MessageDialog
 */

const items = [{
  ref: 'cancelButton',
  cls: 'b-messagedialog-cancelbutton b-gray',
  text: 'L{Object.Cancel}',
  onClick: 'up.onCancelClick'
}, {
  ref: 'okButton',
  cls: 'b-messagedialog-okbutton b-raised b-blue',
  text: 'L{Object.Ok}',
  onClick: 'up.onOkClick'
}]; // Windows has OK button to the left, Mac / Ubuntu to the right

if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isWindows) {
  items.reverse();
}

class MessageDialogConstructor extends _Popup_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'MessageDialog';
  } // Factoryable type name


  static get type() {
    return 'messagedialog';
  }

  static get configurable() {
    return {
      centered: true,
      modal: true,
      hidden: true,
      autoShow: false,
      closeAction: 'hide',
      title: '\xa0',
      lazyItems: {
        $config: ['lazy'],
        value: [{
          cls: 'b-messagedialog-message',
          ref: 'message'
        }, {
          type: 'textfield',
          cls: 'b-messagedialog-input',
          ref: 'input'
        }]
      },
      showClass: null,
      // Do not remove. Assertion strings for Localization sanity check.
      // 'L{Object.Cancel}'
      // 'L{Object.Ok}'
      bbar: {
        overflow: null,
        items
      }
    };
  }

  construct() {
    /**
     * The enum value for the OK button
     * @member {Number} okButton
     * @readOnly
     */
    this.okButton = this.yesButton = 1;
    /**
     * The enum value for the Cancel button
     * @member {Number} cancelButton
     * @readOnly
     */

    this.cancelButton = 3;
    super.construct(...arguments);
  }
  /**
   * Shows a confirm dialog with "Ok" and "Cancel" buttons. The returned promise resolves passing the button identifier
   * of the button that was pressed ({@link #property-okButton} or {@link #property-cancelButton}).
   * @function confirm
   * @async
   * @param {Object} options An options object for what to show.
   * @param {String} [options.title] The title to show in the dialog header.
   * @param {String} [options.message] The message to show in the dialog body.
   * @param {String} [options.rootElement] The root element of this widget, defaults to document.body. Use this
   * if you use the MessageDialog inside a web component ShadowRoot
   * @param {String|Object} [options.cancelButton] A text or a config object to apply to the Cancel button.
   * @param {String|Object} [options.okButton] A text or config object to apply to the OK button.
   * @returns {Promise} A promise which is resolved when the dialog is closed
   */


  async confirm() {
    return this.showDialog('confirm', ...arguments);
  }
  /**
   * Shows an alert popup with a message. The returned promise resolves when the button is clicked.
   * @function alert
   * @async
   * @param {Object} options An options object for what to show.
   * @param {String} [options.title] The title to show in the dialog header.
   * @param {String} [options.message] The message to show in the dialog body.
   * @param {String} [options.rootElement] The root element of this widget, defaults to document.body. Use this
   * if you use the MessageDialog inside a web component ShadowRoot
   * @param {String|Object} [options.okButton] A text or config object to apply to the OK button.
   * @returns {Promise} A promise which is resolved when the dialog is closed
   */


  async alert() {
    return this.showDialog('alert', ...arguments);
  }
  /**
   * Shows a popup with a basic {@link Core.widget.TextField} along with a message. The returned promise resolves when
   * the dialog is closed and yields an Object with a `button` ({@link #property-okButton} or {@link #property-cancelButton})
   * and a `text` property with the text the user provided
   * @function prompt
   * @async
   * @param {Object} options An options object for what to show.
   * @param {String} [options.title] The title to show in the dialog header.
   * @param {String} [options.message] The message to show in the dialog body.
   * @param {String} [options.rootElement] The root element of this widget, defaults to document.body. Use this
   * if you use the MessageDialog inside a web component ShadowRoot
   * @param {Object} [options.textField] A config object to apply to the TextField.
   * @param {String|Object} [options.cancelButton] A text or a config object to apply to the Cancel button.
   * @param {String|Object} [options.okButton] A text or config object to apply to the OK button.
   * @returns {Promise} A promise which is resolved when the dialog is closed. The promise yields an Object with
   * a `button` ({@link #property-okButton} or {@link #property-cancelButton}) and a `text` property with the text the
   * user provided
   */


  async prompt({
    textField
  }) {
    const field = this.widgetMap.input;
    _Widget_js__WEBPACK_IMPORTED_MODULE_3__["default"].reconfigure(field, textField);
    field.value = '';
    return this.showDialog('prompt', ...arguments);
  }

  showDialog(mode, {
    message = '',
    title = '\xa0',
    cancelButton,
    okButton,
    rootElement = document.body
  }) {
    const me = this;
    me.rootElement = rootElement; // Ensure our child items are instanced

    me.getConfig('lazyItems');
    me.title = me.optionalL(title);
    me.widgetMap.message.html = me.optionalL(message);
    me.showClass = `b-messagedialog-${mode}`; // Normalize string input to config object

    if (okButton) {
      okButton = typeof okButton === 'string' ? {
        text: okButton
      } : okButton;
    }

    if (cancelButton) {
      cancelButton = typeof cancelButton === 'string' ? {
        text: cancelButton
      } : cancelButton;
    } // Ensure default configs are applied


    okButton = Object.assign({}, me.widgetMap.okButton.initialConfig, okButton);
    cancelButton = Object.assign({}, me.widgetMap.cancelButton.initialConfig, cancelButton); // Ensure strings are localized

    okButton.text = me.optionalL(okButton.text);
    cancelButton.text = me.optionalL(cancelButton.text);
    _Widget_js__WEBPACK_IMPORTED_MODULE_3__["default"].reconfigure(me.widgetMap.okButton, okButton);
    _Widget_js__WEBPACK_IMPORTED_MODULE_3__["default"].reconfigure(me.widgetMap.cancelButton, cancelButton);
    me.show();
    return me.promise = new Promise(resolve => {
      me.resolve = resolve;
    });
  }

  show() {
    const activeElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].getActiveElement(this.element); // So that when we focus, we don't close an autoClose popup, but temporarily become
    // part of its ownership tree.

    this.owner = this.element.contains(activeElement) ? null : MessageDialogConstructor.fromElement(document.activeElement);
    return super.show(...arguments);
  }

  updateShowClass(showClass, oldShowClass) {
    const {
      classList
    } = this.element;

    if (oldShowClass) {
      classList.remove(oldShowClass);
    }

    if (showClass) {
      classList.add(showClass);
    }
  }

  doResolve(value) {
    const me = this,
          {
      resolve
    } = me;

    if (resolve) {
      const isPrompt = me.showClass === 'b-messagedialog-prompt';

      if (isPrompt && value === me.okButton && !me.widgetMap.input.isValid) {
        return;
      }

      me.resolve = me.reject = me.promise = null;
      resolve(isPrompt ? {
        button: value,
        text: me.widgetMap.input.value
      } : value);
      me.hide();
    }
  }

  onInternalKeyDown(event) {
    // Cancel on escape key
    if (event.key === 'Escape') {
      event.stopImmediatePropagation();
      this.onCancelClick();
    }

    if (event.key === 'Enter') {
      event.stopImmediatePropagation();
      event.preventDefault(); // Needed to not spill over into next MessageDialog if closing this opens another

      this.onOkClick();
    }

    super.onInternalKeyDown(event);
  }

  onOkClick() {
    this.doResolve(MessageDialog.okButton);
  }

  onCancelClick() {
    this.doResolve(MessageDialog.cancelButton);
  }

} // Register this widget type with its Factory


MessageDialogConstructor.initClass();
const MessageDialog = new MessageDialogConstructor();
/**
 * A singleton class which shows common dialogs, similar to the native browser APIs (though these methods do not block the UI thread):
 * - {@link Core.widget.MessageDialog#function-confirm} shows a confirmation dialog with Ok / Cancel buttons
 * - {@link Core.widget.MessageDialog#function-alert} shows an dialog with a message
 * - {@link Core.widget.MessageDialog#function-prompt} shows a dialog with a text input field
 *
 * @class
 * @singleton
 * @inlineexample Core/widget/MessageDialog.js
 * @extends Core/widget/Popup
 */

/* harmony default export */ __webpack_exports__["default"] = (MessageDialog);

/***/ }),

/***/ "./lib/Core/widget/NumberField.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/NumberField.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NumberField; });
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/util/NumberFormat.js */ "./lib/Core/helper/util/NumberFormat.js");
var productName = 'taskboard';


/**
 * @module Core/widget/NumberField
 */

/**
 * Number field widget. Similar to native `<input type="number">`, but implemented as `<input type="text">` to support
 * formatting.
 *
 * This field can be used as an {@link Grid/column/Column#config-editor} for the {@link Grid/column/Column}.
 * It is used as the default editor for the {@link Grid/column/NumberColumn},
 * {@link Grid/column/PercentColumn}, {@link Grid/column/AggregateColumn}.
 *
 * ```javascript
 * const number = new NumberField({
 *     min   : 1,
 *     max   : 5,
 *     value : 3
 * });
 * ```
 *
 * @extends Core/widget/Field
 * @classType numberfield
 * @inlineexample Core/widget/NumberField.js
 */

class NumberField extends _Field_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'NumberField';
  } // Factoryable type name


  static get type() {
    return 'numberfield';
  } // Factoryable type alias


  static get alias() {
    return 'number';
  }

  static get configurable() {
    return {
      /**
       * Min value
       * @config {Number}
       */
      min: null,

      /**
       * Max value
       * @config {Number}
       */
      max: null,

      /**
       * Step size for spin button clicks.
       * @member {Number} step
       */

      /**
       * Step size for spin button clicks. Also used when pressing up/down keys in the field.
       * @config {Number}
       * @default
       */
      step: 1,

      /**
       * Large step size, defaults to 10 * `step`. Applied when pressing SHIFT and stepping either by click or
       * using keyboard.
       * @config {Number}
       * @default 10
       */
      largeStep: 0,

      /**
       * Initial value
       * @config {Number}
       */
      value: null,

      /**
       * The format to use for rendering numbers.
       *
       * For example:
       * ```
       *  format: '9,999.00##'
       * ```
       * The above enables digit grouping and will display at least 2 (but no more than 4) fractional digits.
       * @config {String|Object|Core.helper.util.NumberFormat}
       * @default
       */
      format: '',

      /**
       * The number of decimal places to allow. Defaults to no constraint.
       *
       * This config has been replaced by {@link #config-format}. Instead of this:
       *```
       *  decimalPrecision : 3
       *```
       * Use `format`:
       *```
       *  format : '9.###'
       *```
       * To set both `decimalPrecision` and `leadingZeroes` (say to `3`), do this:
       *```
       *  format : '3>9.###'
       *```
       * @config {Number}
       * @default
       * @deprecated 3.1 Use {@link #config-format} instead.
       */
      decimalPrecision: null,

      /**
       * The maximum number of leading zeroes to show. Defaults to no constraint.
       *
       * This config has been replaced by {@link #config-format}. Instead of this:
       *```
       *  leadingZeros : 3
       *```
       * Use `format`:
       *```
       *  format : '3>9'
       *```
       * To set both `leadingZeroes` and `decimalPrecision` (say to `2`), do this:
       *```
       *  format : '3>9.##'
       *```
       * @config {Number}
       * @default
       * @deprecated 3.1 Use {@link #config-format} instead.
       */
      leadingZeroes: null,
      triggers: {
        spin: {
          type: 'spintrigger'
        }
      },

      /**
       * Controls how change events are triggered when stepping the value up or down using either spinners or
       * arrow keys.
       *
       * Configure with:
       * * `true` to trigger a change event per step
       * * `false` to not trigger change while stepping. Will trigger on blur/Enter
       * * A number of milliseconds to buffer the change event, triggering when no steps are performed during that
       *   period of time.
       *
       * @config {Boolean|Number}
       * @default
       */
      changeOnSpin: true,
      // NOTE: using type="number" has several trade-offs:
      //
      // Negatives:
      //   - No access to caretPos/textSelection. This causes anomalies when replacing
      //     the input value with a formatted version of that value (the caret moves to
      //     the end of the input el on each character typed).
      //   - The above also prevents Siesta/synthetic events from mimicking typing.
      //   - Thousand separators cannot be displayed (input.value = '1,000' throws an
      //     exception).
      // Positives:
      //   - On mobile, the virtual keyboard only shows digits et al.
      //   - validity property on DOM node that handles min/max checks.
      //
      // The above may not be exhaustive, but there is not a compelling reason to
      // use type="number" except on mobile.

      /**
       * This can be set to `'number'` to enable the numeric virtual keyboard on
       * mobile devices. Doing so limits this component's ability to handle keystrokes
       * and format properly as the user types, so this is not recommended for
       * desktop applications. This will also limit similar features of automated
       * testing tools that mimic user input.
       * @config {String}
       * @default text
       */
      inputType: null
    };
  } //endregion
  //region Init


  construct(config) {
    super.construct(config);
    const me = this; // Support for selecting all by double click in empty input area
    // Browsers work differently at this case

    me.input.addEventListener('dblclick', () => {
      me.select();
    });

    if (typeof me.changeOnSpin === 'number') {
      me.bufferedSpinChange = me.buffer(me.triggerChange, me.changeOnSpin);
    }
  } //endregion
  //region Internal functions


  acceptValue(value, rawValue) {
    let accept = !isNaN(value); // https://github.com/bryntum/support/issues/1349
    // Pass through if there is a text selection in the field. This fixes the case when
    // valid value is typed already and we are replacing it by selecting complete string and typing over it.
    // Cannot be tested in siesta, see ticket for more info.

    if (accept && !this.hasTextSelection) {
      accept = false;
      const raw = this.input.value,
            current = parseFloat(raw);

      if (raw !== rawValue) {
        // The new value is out of range, but we accept it if the current value
        // is also problematic. Consider the case where the input is empty and the
        // minimum value is 100. The user must first type "1" and we must accept it
        // if they are to get the opportunity to type the "0"s.
        accept = !this.acceptValue(current, raw); // Also, if we are checking the current value, be sure not to infinitely
        // recurse here.
      }
    }

    return accept;
  }

  okMax(value) {
    return isNaN(this.max) || value <= this.max;
  }

  okMin(value) {
    return isNaN(this.min) || value >= this.min;
  }

  internalOnKeyEvent(e) {
    if (e.type === 'keydown') {
      const me = this,
            key = e.key;
      let block; // Native arrow key spin behaviour differs between browsers, so we replace
      // the native spinners w/our own triggers and handle arrows keys as well.

      if (key === 'ArrowUp') {
        me.doSpinUp(e.shiftKey);
        block = true;
      } else if (key === 'ArrowDown') {
        me.doSpinDown(e.shiftKey);
        block = true;
      } else if (!e.altKey && !e.ctrlKey && key && key.length === 1) {
        // The key property contains the character or key name... so ignore
        // keys that aren't a single character.
        const after = me.getAfterValue(key),
              afterValue = me.formatter.parseStrict(after),
              // no need to check if typing same value or - if negative numbers are allowed
        accepted = afterValue === me.value || after === '-' && (isNaN(me.min) || me.min < 0);
        block = !accepted && !me.acceptValue(afterValue, after);
      }

      if (key === 'Enter' && me._changedBySilentSpin) {
        me.triggerChange(e, true); // reset the flag

        me._changedBySilentSpin = false;
      }

      if (block) {
        e.preventDefault();
      }
    }

    super.internalOnKeyEvent(e);
  }

  doSpinUp(largeStep = false) {
    const me = this;
    let newValue = (me.value || 0) + (largeStep ? me.largeStep : me.step);

    if (!me.okMin(newValue)) {
      newValue = me.min;
    }

    if (me.okMax(newValue)) {
      me.applySpinChange(newValue);
    }
  }

  doSpinDown(largeStep = false) {
    const me = this;
    let newValue = (me.value || 0) - (largeStep ? me.largeStep : me.step);

    if (!me.okMax(newValue)) {
      newValue = me.max;
    }

    if (me.okMin(newValue)) {
      me.applySpinChange(newValue);
    }
  }

  applySpinChange(newValue) {
    const me = this;
    me._isUserAction = true; // Should not trigger change immediately?

    if (me.changeOnSpin !== true) {
      me._changedBySilentSpin = true; // Silence the change

      me.silenceChange = true; // Optionally buffer the change

      me.bufferedSpinChange && me.bufferedSpinChange(null, true);
    }

    me.value = newValue;
    me._isUserAction = false;
    me.silenceChange = false;
  }

  triggerChange() {
    if (!this.silenceChange) {
      super.triggerChange(...arguments);
    }
  }

  onFocusOut(e) {
    super.onFocusOut(...arguments);
    const me = this,
          {
      input
    } = me,
          raw = input.value,
          value = me.formatter.truncate(raw),
          formatted = isNaN(value) ? raw : me.formatValue(value);

    if (raw !== formatted) {
      input.value = formatted;
    }

    if (me._changedBySilentSpin) {
      me.triggerChange(e, true); // reset the flag

      me._changedBySilentSpin = false;
    }
  }

  internalOnInput(event) {
    const me = this,
          {
      formatter,
      input
    } = me,
          {
      parser
    } = formatter,
          raw = input.value,
          decimals = parser.decimalPlaces(raw);

    if (formatter.truncator && decimals) {
      let value = raw;
      const trunc = formatter.truncate(raw);

      if (!isNaN(trunc)) {
        value = me.formatValue(trunc);

        if (parser.decimalPlaces(value) < decimals) {
          // If typing has caused truncation or rounding, reset. To best preserve
          // the caret pos (which is reset by assigning input.value), we grab and
          // restore the distance from the end. This allows special things to format
          // into the string (such as thousands separators) since they always go to
          // the front of the input.
          const pos = raw.length - me.caretPos;
          input.value = value;
          me.caretPos = value.length - pos;
        }
      }
    }

    super.internalOnInput(event);
  }

  formatValue(value) {
    return this.formatter.format(value);
  }

  changeFormat(format) {
    const me = this;

    if (format === '') {
      const {
        leadingZeroes,
        decimalPrecision
      } = me;
      format = leadingZeroes ? `${leadingZeroes}>9` : null;

      if (decimalPrecision != null) {
        format = `${format || ''}9.${'#'.repeat(decimalPrecision)}`;
      } else if (format) {
        // When we only have leadingZeroes, we'll have a format like "4>9", but
        // that will default to 3 decimal digits. Prior behavior implied no limit
        // on decimal digits unless decimalPrecision was specified.
        format += '.*';
      }
    }

    return format;
  }

  get formatter() {
    const me = this,
          format = me.format;
    let formatter = me._formatter;

    if (!formatter || me._lastFormat !== format) {
      formatter = _helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_1__["default"].get(me._lastFormat = format); // TODO use this.formatter.is.from.currency/percent visually...
      // if (!formatter.is.decimal) {
      //     formatter = formatter.as('decimal');
      // }

      me._formatter = formatter;
    }

    return formatter;
  } //endregion
  //region Getters/Setters


  updateStep(step) {
    this.element.classList[step ? 'remove' : 'add']('b-hide-spinner');
    this._step = step;
  }

  changeLargeStep(largeStep) {
    return largeStep || this.step * 10;
  }

  get validity() {
    const value = this.value,
          validity = {}; // Assert range for non-empty fields, empty fields will turn invalid if `required: true`

    if (value != null) {
      validity.rangeUnderflow = !this.okMin(value);
      validity.rangeOverflow = !this.okMax(value);
    }

    validity.valid = !validity.rangeUnderflow && !validity.rangeOverflow;
    return validity;
  }
  /**
   * Get/set the NumberField's value, or `undefined` if the input field is empty
   * @property {Number}
   */


  changeValue(value, was) {
    const me = this;

    if (value || value === 0) {
      let valueIsNaN; // We insist on a number as the value

      if (typeof value !== 'number') {
        value = typeof value === 'string' ? me.formatter.parse(value) : Number(value);
        valueIsNaN = isNaN(value);

        if (valueIsNaN) {
          value = '';
        }
      }

      if (!valueIsNaN && me.format) {
        value = me.formatter.round(value);
      }
    } else {
      value = undefined;
    }

    return super.changeValue(value, was);
  }

  get inputValue() {
    let value = this.value;

    if (value != null && this.format) {
      value = this.formatValue(value);
    }

    return value;
  } //endregion


} // Register this widget type with its Factory

NumberField.initClass();
NumberField._$name = 'NumberField';

/***/ }),

/***/ "./lib/Core/widget/PagingToolbar.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/PagingToolbar.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PagingToolbar; });
/* harmony import */ var _Toolbar_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Toolbar.js */ "./lib/Core/widget/Toolbar.js");
var productName = 'taskboard';

/**
 * @module Core/widget/PagingToolbar
 */

/**
 * A special Toolbar class, which, when attached to an {@link Core.data.AjaxStore AjaxStore}, which has been configured
 * to be {@link Core.data.AjaxStore#property-isPaged paged}, controls the loading of that store to page through the data
 * set.
 *
 * ```javascript
 * new Grid({
 *      bbar : {
 *          type  : 'pagingtoolbar'
 *      }
 * });
 * ```
 *
 * ### Default toolbar items
 *
 * The toolbar provides some default buttons and other items as described below:
 *
 * | Reference              | Weight  Description                                              |
 * |------------------------|--------|---------------------------------------------------------|
 * | `firstPageButton`      | 100    | Go to first page                                        |
 * | `previousPageButton`   | 110    | Go to previous page                                     |
 * | `pageNumber`           | 120    | TextCurrent page number                                 |
 * | `pageCount`            | 130    | Label showing number of pages                           |
 * | `nextPageButton`       | 140    | Go to next page                                         |
 * | `lastPageButton`       | 150    | Go to last page                                         |
 * | `reloadButton`         | 160    | Reload data                                             |
 * | `dataSummary`          | 170    | Summary text                                            |
 *
 * ### Customizing the toolbar items
 *
 * The toolbar items can be customized, existing items can be changed or removed,
 * and new items can be added. This is handled using the {@link #config-items} config.
 *
 * Adding additional buttons or widgets to the paging toolbar can be done like so:
 *
 * ```javascript
 * bbar : {
 *     type  : 'pagingtoolbar',
 *     items : {
 *         click : {
 *             type : 'button',
 *             text : 'Click me',
 *             weight : 175 // Add after last item
 *         }
 *     }
 * }
 * ```
 *
 * @extends Core/widget/Toolbar
 * @classType toolbar
 */

class PagingToolbar extends _Toolbar_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'PagingToolbar';
  } // Factoryable type name


  static get type() {
    return 'pagingtoolbar';
  }

  static get defaultConfig() {
    return {
      /**
       * The {@link Core.data.AjaxStore AjaxStore} that this PagingToolbar is to control.
       * @config {Core.data.AjaxStore}
       */
      store: null,
      defaults: {
        localeClass: this
      },
      items: {
        firstPageButton: {
          onClick: 'up.onFirstPageClick',
          icon: 'b-icon-first',
          weight: 100
        },
        previousPageButton: {
          onClick: 'up.onPreviousPageClick',
          icon: 'b-icon-previous',
          weight: 110
        },
        pageNumber: {
          type: 'numberfield',
          label: 'L{page}',
          min: 1,
          max: 1,
          triggers: null,
          onChange: 'up.onPageNumberChange',
          highlightExternalChange: false,
          weight: 120
        },
        pageCount: {
          type: 'widget',
          cls: 'b-pagecount b-toolbar-text',
          weight: 130
        },
        nextPageButton: {
          onClick: 'up.onNextPageClick',
          icon: 'b-icon-next',
          weight: 140
        },
        lastPageButton: {
          onClick: 'up.onLastPageClick',
          icon: 'b-icon-last',
          weight: 150
        },
        separator: {
          type: 'widget',
          cls: 'b-toolbar-separator',
          weight: 151
        },
        reloadButton: {
          onClick: 'up.onReloadClick',
          icon: 'b-icon-reload',
          weight: 160
        },
        spacer: {
          type: 'widget',
          cls: 'b-toolbar-fill',
          weight: 161
        },
        dataSummary: {
          type: 'widget',
          cls: 'b-toolbar-text',
          weight: 170
        }
      }
    };
  } // Retrieve store from grid when "assigned" to it


  set parent(parent) {
    super.parent = parent;

    if (!this.store) {
      this.store = parent.store;
    }
  }

  get parent() {
    return super.parent;
  }

  set store(store) {
    const me = this,
          listener = {
      beforerequest: 'onStoreBeforeRequest',
      afterrequest: 'onStoreChange',
      change: 'onStoreChange',
      thisObj: me
    };

    if (me.store) {
      me.store.un(listener);
    }

    me._store = store;

    if (store) {
      store.on(listener);

      if (store.isLoading) {
        me.onStoreBeforeRequest();
      }
    }
  }

  get store() {
    return this._store;
  }

  onStoreBeforeRequest() {
    this.eachWidget(w => w.disable());
  }

  updateLocalization() {
    const me = this,
          {
      reloadButton,
      firstPageButton,
      previousPageButton,
      nextPageButton,
      lastPageButton
    } = me.widgetMap;
    firstPageButton.tooltip = me.L('L{firstPage}');
    previousPageButton.tooltip = me.L('L{prevPage}');
    nextPageButton.tooltip = me.L('L{nextPage}');
    lastPageButton.tooltip = me.L('L{lastPage}');
    reloadButton.tooltip = me.L('L{reload}');
    me.updateSummary();
    super.updateLocalization();
  }

  updateSummary() {
    const me = this,
          {
      pageCount,
      dataSummary
    } = me.widgetMap;
    let count, lastPage, start, end, allCount;
    count = lastPage = start = end = allCount = 0;

    if (me.store) {
      const {
        store
      } = me,
            {
        pageSize,
        currentPage
      } = store;
      count = store.count;
      lastPage = store.lastPage;
      allCount = store.allCount;
      start = Math.max(0, (currentPage - 1) * pageSize + 1);
      end = Math.min(allCount, start + pageSize - 1);
    }

    pageCount.html = me.L('L{pageCountTemplate}')({
      lastPage
    });
    dataSummary.html = count ? me.L('L{summaryTemplate}')({
      start,
      end,
      allCount
    }) : me.L('L{noRecords}');
  }

  onStoreChange() {
    const me = this,
          {
      widgetMap,
      store
    } = me,
          {
      count,
      lastPage,
      currentPage
    } = store,
          {
      pageNumber,
      pageCount,
      firstPageButton,
      previousPageButton,
      nextPageButton,
      lastPageButton,
      dataSummary
    } = widgetMap;
    me.eachWidget(w => w.enable());
    pageNumber.value = currentPage;
    pageNumber.max = lastPage;
    dataSummary.disabled = pageNumber.disabled = pageCount.disabled = !count;
    firstPageButton.disabled = previousPageButton.disabled = currentPage <= 1 || !count;
    nextPageButton.disabled = lastPageButton.disabled = currentPage >= lastPage || !count;
    me.updateSummary();
  }

  onPageNumberChange({
    value
  }) {
    if (this.store.currentPage !== value) {
      this.store.loadPage(value);
    }
  }

  onFirstPageClick() {
    this.store.loadPage(1);
  }

  onPreviousPageClick() {
    this.store.previousPage();
  }

  onNextPageClick() {
    this.store.nextPage();
  }

  onLastPageClick() {
    this.store.loadPage(this.store.lastPage);
  }

  onReloadClick() {
    this.store.loadPage(this.store.currentPage);
  }

} // Register this widget type with its Factory

PagingToolbar.initClass();
PagingToolbar._$name = 'PagingToolbar';

/***/ }),

/***/ "./lib/Core/widget/Panel.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Panel.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Panel; });
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _panel_PanelCollapser_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./panel/PanelCollapser.js */ "./lib/Core/widget/panel/PanelCollapser.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../util/DynamicObject.js */ "./lib/Core/util/DynamicObject.js");
/* harmony import */ var _mixin_Toolable_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixin/Toolable.js */ "./lib/Core/widget/mixin/Toolable.js");
/* harmony import */ var _Toolbar_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Toolbar.js */ "./lib/Core/widget/Toolbar.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';













/**
 * @module Core/widget/Panel
 */

/**
 * An object that describes a Panel's header.
 *
 * @typedef {Object} PanelHeader
 * @property {String|Object} [cls] Additional CSS class or classes to add to the header element.
 * @property {String} [dock="top"] Specify "left", "bottom", or "right" to control panel edge to which the header docks.
 * @property {String} title
 * @property {String} [titleAlign="start"] Specify "center" or "end" to align the panel's title differently.
 */

const acceptNode = e => !e.classList.contains('b-focus-trap') && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isFocusable(e) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP,
      emptyArray = [],
      emptyObject = {},
      emptySplit = [emptyArray, emptyArray],
      finishBodyWrap = (config, classes, final) => ({
  children: config.children,
  class: _objectSpread(_objectSpread({}, classes), {}, {
    [`b-${config.vertical ? 'v' : 'h'}box`]: 1,
    'b-box-center': 1,
    'b-panel-bar-wrap': !final
  })
}),
      wrapBody = (inner, vertical = false) => ({
  vertical,
  children: inner ? [inner] : []
}),
      barConfigs = {
  dock: 1,
  hidden: 1,
  weight: 1
},
      dockDirection = {
  //       [vertical, before]
  top: [true, true],
  bottom: [true, false],
  left: [false, true],
  right: [false, false]
},
      headerDock = {
  header: 1,
  'pre-header': 1
}; // https://github.com/webcomponents/webcomponentsjs/issues/556
// Work around Internet Explorer wanting a function instead of an object.
// IE also *requires* this argument where other browsers don't.


acceptNode.acceptNode = acceptNode;
/**
 * Panel widget. A general purpose container which may be used to contain child {@link Core.widget.Container#config-items}
 * or {@link Core.widget.Widget#config-html}.
 *
 * Also may dock a {@link #config-header} and {@link #config-footer} either at top/bottom or left/right
 *
 *
 * @example
 * let panel = new Panel({
 *   title   : 'A Test Panel',
 *   items : [
 *     { type : 'text', placeholder: 'Text' },
 *   ],
 *   bbar : [{
 *     text : 'Proceed',
 *     onClick : () => {
 *       alert('Proceeding!');
 *     }
 *   }]
 * });
 *
 * @classType panel
 *
 * @extends Core/widget/Container
 * @inlineexample Core/widget/Panel.js
 */

class Panel extends _Container_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Toolable_js__WEBPACK_IMPORTED_MODULE_11__["default"]) {
  //region Config
  static get $name() {
    return 'Panel';
  } // Factoryable type name


  static get type() {
    return 'panel';
  }

  static get configurable() {
    return {
      localizableProperties: ['title'],

      /**
       * Controls whether the panel is collapsed (the body of the panel is hidden while only the header is
       * visible). Only valid if the panel is {@link #config-collapsible}.
       * @config {Boolean}
       */
      collapsed: {
        value: null,
        $config: null,
        default: false
      },

      /**
       * This config enables collapsibility for the panel. See {@link #config-collapsed}.
       *
       * For example:
       * ```javascript
       *      {
       *          type        : 'panel',
       *          collapsible : true
       *      }
       * ```
       * This is managed by an instance of {@link Core.widget.panel.PanelCollapser} which can be configured if an
       * object is passed for this config property:
       * ```javascript
       *      {
       *          type        : 'panel',
       *          collapsible : {
       *              direction : 'left'
       *          }
       *      }
       * ```
       * @config {Boolean|Core.widget.panel.PanelCollapser}
       */
      collapsible: {
        value: null,
        $config: 'nullify'
      },

      /**
       * Custom CSS classes to add to the panel's body element.
       *
       * May be specified as a space separated string, or as an object in which property names
       * with truthy values are used as the class names:
       *
       * ```javascript
       *  bodyCls : {
       *      'b-my-class'     : 1,
       *      [this.extraCls]  : 1,
       *      [this.activeCls] : this.isActive
       *  }
       *  ```
       *
       * @config {String|Object}
       * @category CSS
       */
      bodyCls: {
        $config: {
          merge: 'classList'
        },
        value: null
      },

      /**
       * By default, tabbing within a Panel is not contained, ie you can TAB out of the Panel
       * forwards or backwards.
       * Configure this as `true` to disallow tabbing out of the Panel, and make tabbing circular within this Panel.
       * @config {Boolean}
       * @default false
       * @category Content
       */
      trapFocus: null,

      /**
       * A title to display in the header. Causes creation and docking of a header
       * to the top if no header is configured.
       *
       * If specified, overrides any title configured within the {@link #config-header} configuration.
       * @default
       * @config {String}
       * @category Content
       */
      title: null,

      /**
       * A config {@link PanelHeader object} for the panel's header or a string in place of a `title`.
       *
       * Configuring this as `false` explicitly removes the header bar, overriding any
       * {@link #config-tools} or {@link #config-title} configs.
       * @default
       * @config {String|Boolean|PanelHeader}
       * @category Content
       */
      header: null,

      /**
       * An object containing config defaults for corresponding {@link #config-strips} objects with a matching name.
       *
       * By default, this object contains the keys `'bbar'` and `'tbar'` to provide default config values for the
       * {@link #config-bbar} and {@link #config-tbar} configs.
       *
       * This object also contains a key named `'*'` with default config properties to apply to all strips. This
       * object provides the default `type` (`'toolbar') and {@link Core.widget.Widget#config-dock} (`'top'`)
       * property for strips.
       * @config {Object} stripDefaults
       * @internal
       * @category Content
       */
      stripDefaults: {
        '*': {
          type: 'toolbar',
          dock: 'top'
        },
        bbar: {
          dock: 'bottom',
          weight: -1000
        },
        tbar: {
          weight: -1000
        }
      },

      /**
       * An object containing widgets keyed by name. By default (when no `type` is given), strips are
       * {@link Core.widget.Toolbar toolbars}. If the value assigned to a strip is an array, it is converted to
       * the toolbar's {@link Core.widget.Container#config-items}.
       *
       * The {@link #config-bbar} and {@link #config-tbar} configs are shortcuts for adding toolbars to the
       * panel's `strips`.
       *
       * Strips are arranged based on their {@link Core.widget.Widget#config-dock} and
       * {@link Core.widget.Widget#config-weight} configs.
       *
       * For widgets using a `dock` of `'top'`, `'bottom'`, `'left'`, or `'right'` (an "edge strip"), the higher
       * the `weight` assigned to a widget, the closer that widget will be to the panel body.
       *
       * For widgets with `'header'` or `'pre-header'` for `dock` (a "header strip"), higher `weight` values
       * cause the widget to be placed closer to the panel's title.
       *
       * ```javascript
       *  new Panel({
       *      title : 'Test',
       *      html  : 'Panel strip test',
       *      strips : {
       *          left : [{
       *              text : 'Go'
       *          }]
       *      }
       *  });
       * ```
       * @config {Object} strips
       * @category Content
       */
      strips: {
        value: null,
        $config: 'nullify'
      },
      toolDefaults: {
        close: {
          weight: -1000
        },
        collapse: {
          weight: -990
        }
      },

      /**
       * Config object of a footer. May contain a `dock`, `html` and a `cls` property. A footer is not a widget,
       * but rather plain HTML that follows the last element of the panel's body and {@link #config-strips}.
       *
       * The `dock` property may be `top`, `right`, `bottom` or `left`.
       * @config {Object|String}
       * @default
       * @category Content
       */
      footer: null,

      /**
       * This config is used with {@link Core.widget.panel.PanelCollapserOverlay} to programmatically control the
       * visibility of the panel's body. In this mode of collapse, the body of a collapsed panel is a floating
       * overlay. Setting this config to `true` will show this element, while `false` will hide it.
       * @config {Boolean}
       * @private
       */
      revealed: null,

      /**
       * The tool Widgets as specified by the {@link #config-tools} configuration
       * (and the {@link Core.widget.Popup#config-closable} configuration in the Popup subclass).
       * Each is a {@link Core.widget.Widget Widget} instance which may be hidden, shown and observed and styled
       * just like any other widget.
       * @member {Object} tools
       */

      /**
       * The {@link Core.widget.Tool tools} to add either before or after the `title` in the Panel header. Each
       * property name is the reference by which an instantiated tool may be retrieved from the live
       * `{@link Core.widget.mixin.Toolable#property-tools}` property.
       * @config {Object} tools
       * @category Content
       */

      /**
       * Get toolbar {@link Core.widget.Toolbar} docked to the top of the panel
       * @member {Core.widget.Toolbar} tbar
       * @readonly
       */

      /**
       * A Config object representing the configuration of a {@link Core.widget.Toolbar},
       * or array of config objects representing the child items of a Toolbar.
       *
       * This creates a toolbar docked to the top of the panel immediately below the header.
       * @config {Object[]|Object}
       * @category Content
       */
      tbar: null,

      /**
       * Get toolbar {@link Core.widget.Toolbar} docked to the bottom of the panel
       * @member {Core.widget.Toolbar} bbar
       * @readonly
       */

      /**
       * A Config object representing the configuration of a {@link Core.widget.Toolbar},
       * or array of config objects representing the child items of a Toolbar.
       *
       * This creates a toolbar docked to the bottom of the panel immediately above the footer.
       * @config {Object[]|Object}
       * @category Content
       */
      bbar: null
    };
  } //endregion

  /**
   * A header {@link #config-tools tool} has been clicked.
   * @event toolClick
   * @param {Core.widget.Tool} source - This Panel.
   * @param {Core.widget.Tool} tool - The tool which is being clicked.
   */
  //region Composition


  compose() {
    const me = this,
          {
      collapsible,
      focusable,
      hasItems,
      revealed
    } = me,
          header = me.composeHeader(),
          horz = (header === null || header === void 0 ? void 0 : header.class['b-dock-left']) || (header === null || header === void 0 ? void 0 : header.class['b-dock-right']);
    let body = me.composeBody(),
        key = 'bodyWrapElement';

    if (collapsible) {
      [key, body] = collapsible.wrapCollapser(key, body);
    }

    return {
      tabIndex: hasItems && focusable !== false || focusable ? 0 : null,
      class: {
        [`b-panel-collapsible-${collapsible === null || collapsible === void 0 ? void 0 : collapsible.type}`]: collapsible,
        [`b-panel-collapse-${collapsible === null || collapsible === void 0 ? void 0 : collapsible.collapseDir}`]: collapsible,
        [`b-${horz ? 'h' : 'v'}box`]: 1,
        'b-panel-collapsible': collapsible,
        'b-panel-has-header': header,
        'b-panel-overlay-revealed': revealed
      },
      children: {
        topFocusTrap: {
          tabIndex: 0,
          class: {
            'b-focus-trap': 1
          }
        },
        // Note: we always put header before bodyWrap since it is likely (though untested) to be better for
        // a11y. We use flexbox order to make the right/bottom docking appear correct but it is likely that
        // the DOM order of the <header> element vs (optional) <footer> is important to screen readers.
        headerElement: header,
        [key]: body,
        bottomFocusTrap: {
          tabIndex: 0,
          class: {
            'b-focus-trap': 1
          }
        }
      }
    };
  }

  composeBody() {
    const me = this,
          {
      bodyCls,
      bodyConfig,
      footer,
      uiClassList
    } = me,
          strips = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].values(me.strips, (k, v) => !dockDirection[v === null || v === void 0 ? void 0 : v.dock]).sort(me.byWeightSortFn);
    let bar, before, dock, i, name, vertical, wrap;

    if (footer) {
      dock = footer.dock || 'bottom';
      strips.unshift({
        dock,
        element: {
          tag: 'footer',
          reference: 'footerElement',
          html: typeof footer === 'string' ? footer : footer.html,
          class: _objectSpread(_objectSpread({}, uiClassList), {}, {
            [`b-dock-${dock}`]: 1,
            [`${footer.cls || ''}`]: 1
          })
        }
      });
    }

    if (bodyCls) {
      if (!bodyConfig[name = 'className']) {
        name = 'class';
      }

      bodyConfig[name] = new _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_6__["default"](bodyConfig[name]).assign(bodyCls);
    }
    /*
        The higher the weight, the closer to the center we place the toolbar. Consider:
            {
                tbar : ...,
                bbar :...,
                strips : {
                    lbar1 : { weight : 10, ... },
                    tbar2 : { weight : 20, ... },
                    lbar2 : { weight : 30, ... },
                    rbar  : { weight : 40, ... }
                }
            }
            +---------------------------------------------------+
            | tbar                                              |
            +---------+-----------------------------------------+
            |         | tbar2                                   |
            |         +---------+----------------------+--------+
            |         |         |                      |        |
            |  lbar1  |         |                      |        |
            |         |  lbar2  |                      |  rbar  |
            |         |         |                      |        |
            |         |         |                      |        |
            +---------+---------+----------------------+--------+
            | bbar                                              |
            +---------------------------------------------------+
     */


    for (i = strips.length; i-- > 0;) {
      bar = strips[i];
      [vertical, before] = dockDirection[bar.dock];

      if (!wrap) {
        wrap = wrapBody(bodyConfig, vertical);
      } else if (wrap.vertical !== vertical) {
        wrap = wrapBody(finishBodyWrap(wrap, uiClassList), vertical);
      }

      wrap.children[before ? 'unshift' : 'push'](bar.element);
    }

    const body = finishBodyWrap(wrap || wrapBody(bodyConfig), uiClassList, true);
    body.class['b-panel-body-wrap'] = 1;
    body.class[`b-${me.$$name.toLowerCase()}-body-wrap`] = 1;
    return body;
  }

  get hasHeader() {
    const {
      header,
      title,
      tools,
      parent
    } = this,
          hasVisibleTools = Object.values(tools || {}).some(tool => !tool.hidden); // Explicitly declared header should always be shown.
    // Implicitly created from title or tools can be suppressed by parent.
    // Explicitly disabled header using false should mean no header at all.

    return header !== false && (header || !(parent !== null && parent !== void 0 && parent.suppressChildHeaders) && (title || hasVisibleTools));
  }

  get rootUiClass() {
    return Panel;
  }

  composeHeader(force) {
    var _me$collapsible;

    const me = this; // Dont add a header unless we have one configured, have a title or have visible tools (or are forced to)

    if (!force && !me.hasHeader) {
      return;
    }

    const header = me.header || {},
          dock = header.dock || 'top',
          [before, after] = me.splitHeaderItems({
      dock,
      as: 'element'
    }),
          classes = me.$meta.hierarchy,
          title = me.composeTitle(header),
          cls = new _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_6__["default"](_objectSpread({
      [`b-dock-${dock}`]: 1
    }, me.uiClassList), header.cls);
    let i, name;

    for (i = classes.indexOf(Panel); i < classes.length; ++i) {
      name = classes[i].$$name;

      if (name !== 'Grid') {
        cls[`b-${name.toLowerCase()}-header`] = 1;
      }
    }

    const headerConfig = {
      tag: 'header',
      class: cls,
      children: [...before, title, ...after]
    };
    return ((_me$collapsible = me.collapsible) === null || _me$collapsible === void 0 ? void 0 : _me$collapsible.composeHeader(headerConfig)) || headerConfig;
  }

  composeTitle(header) {
    var _this$collapsible;

    const title = typeof header === 'string' ? header : this.title || header.title,
          titleConfig = {
      reference: 'titleElement',
      html: title !== null && title !== void 0 ? title : '\xA0',
      class: _objectSpread({
        [`b-align-${header.titleAlign || 'start'}`]: 1,
        'b-header-title': 1
      }, this.uiClassList)
    };

    if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isObject(title)) {
      delete titleConfig.html;
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge(titleConfig, title);
    }

    return ((_this$collapsible = this.collapsible) === null || _this$collapsible === void 0 ? void 0 : _this$collapsible.composeTitle(titleConfig)) || titleConfig;
  }

  afterRecompose() {
    var _me$_headerClickDetac;

    super.afterRecompose();
    const me = this,
          {
      headerElement
    } = me;
    (_me$_headerClickDetac = me._headerClickDetacher) === null || _me$_headerClickDetac === void 0 ? void 0 : _me$_headerClickDetac.call(me);
    me._headerClickDetacher = headerElement && _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on({
      element: headerElement,
      // Click might have lead to panel being destroyed (clicking close tool with `hideAction : 'destroy'`)
      click: ev => {
        var _me$trigger;

        return (_me$trigger = me.trigger) === null || _me$trigger === void 0 ? void 0 : _me$trigger.call(me, 'headerClick', {
          event: ev
        });
      }
    });
  }

  onHeaderClick(info) {
    var _this$collapsible2;

    (_this$collapsible2 = this.collapsible) === null || _this$collapsible2 === void 0 ? void 0 : _this$collapsible2.onHeaderClick(info);
  }

  onPaint() {
    var _this$collapsible3;

    super.onPaint();
    (_this$collapsible3 = this.collapsible) === null || _this$collapsible3 === void 0 ? void 0 : _this$collapsible3.onPanelPaint(this);
  }

  splitHeaderItems({
    as,
    overlay,
    dock
  } = emptyObject) {
    const me = this,
          asElement = as === 'element',
          {
      collapsed
    } = me,
          endTools = me.getEndTools({
      overlay
    }),
          startTools = me.getStartTools({
      overlay
    }),
          strips = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].values(me.strips, (k, v) => !headerDock[v === null || v === void 0 ? void 0 : v.dock] && v.isCollapsified(collapsed, overlay));
    let ret = emptySplit,
        after,
        before,
        i;

    if (strips.length + endTools.length + startTools.length) {
      // The "natural" order of equal weight tools/strips is: tool -> strip -> header <- strip <- tool
      ret = [// the problem w/mixing tools and strips is the strip weight needs to do two jobs (one when docked
      // in the body and one when docked in the header)
      before = [...startTools, ...strips.filter(e => e.dock === 'pre-header').sort(me.byWeightSortFn)], after = [...strips.filter(e => e.dock === 'header').sort(me.byWeightReverseSortFn), ...endTools]];

      for (i = 0; i < before.length; ++i) {
        var _before$i$syncRotatio, _before$i;

        dock && ((_before$i$syncRotatio = (_before$i = before[i]).syncRotationToDock) === null || _before$i$syncRotatio === void 0 ? void 0 : _before$i$syncRotatio.call(_before$i, dock));

        if (asElement) {
          before[i] = before[i].element;
        }
      }

      for (i = 0; i < after.length; ++i) {
        var _after$i$syncRotation, _after$i;

        dock && ((_after$i$syncRotation = (_after$i = after[i]).syncRotationToDock) === null || _after$i$syncRotation === void 0 ? void 0 : _after$i$syncRotation.call(_after$i, dock));

        if (asElement) {
          after[i] = after[i].element;
        }
      }
    }

    return ret;
  }

  set bodyConfig(bodyConfig) {
    this._bodyConfig = bodyConfig;
  }

  get bodyConfig() {
    const me = this,
          result = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge({
      reference: 'bodyElement',
      className: _objectSpread(_objectSpread({}, me.getStaticWidgetClasses(Panel, '-content')), {}, {
        'b-box-center': 1,
        'b-text-content': me.textContent && me.hasNoChildren
      })
    }, me._bodyConfig);

    if (me.initializingElement || !me._element) {
      // we cannot use the html config since a getter reads innerHTML
      result.html = me.content || me._html;
    }

    return result;
  } //endregion
  //region Configs


  changeBodyCls(cls) {
    return _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(cls);
  }

  changeTbar(bar) {
    this.getConfig('strips');
    this.strips = {
      tbar: bar
    };
    return this.strips.tbar;
  }

  changeBbar(bar) {
    this.getConfig('strips');
    this.strips = {
      bbar: bar
    };
    return this.strips.bbar;
  } // Override to iterate docked Toolbars in the correct order around contained widgets.


  get childItems() {
    var _me$collapsible2;

    const me = this,
          strips = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].values(me.strips, (k, v) => !dockDirection[v === null || v === void 0 ? void 0 : v.dock]).sort(me.byWeightSortFn),
          [before, after] = me.splitHeaderItems(),
          // tools and header strips
    [before2, after2] = ((_me$collapsible2 = me.collapsible) === null || _me$collapsible2 === void 0 ? void 0 : _me$collapsible2.splitHeaderItems()) || emptySplit;
    return [...before, ...before2, ...after, ...after2, ...strips.filter(b => dockDirection[b.dock][1]), // the "before" strips come before the items
    ...(me._items || emptyArray), ...strips.filter(b => !dockDirection[b.dock][1]).reverse()];
  }

  changeStrips(strips, oldStrips) {
    const me = this,
          manager = me.$strips || (me.$strips = new _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
      configName: 'strips',
      factory: _Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"],
      inferType: false,
      // the name of a bar in the strips object is not its type
      owner: me,

      created(instance) {
        var _instance$layout;

        const {
          dock
        } = instance;

        if (!headerDock[dock] && !dockDirection[dock]) {
          throw new Error(`Invalid dock value "${dock}"; must be: top, left, right, bottom, header, or pre-header`);
        }

        _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].after(instance, 'onConfigChange', (ret, {
          name
        }) => {
          if (barConfigs[name]) {
            me.onConfigChange({
              name: 'strips',
              value: manager.target
            });
          }
        });
        instance.innerItem = false;
        me.onChildAdd(instance);
        instance.parent = me; // in case we are given an instanced widget

        (_instance$layout = instance.layout) === null || _instance$layout === void 0 ? void 0 : _instance$layout.renderChildren();

        if (instance.hasItems) {
          me.hasItems = true;
        }
      },

      setup(config, name) {
        config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].clone(me.stripDefaults['*']), me.stripDefaults[name], config);
        config.parent = me; // so parent can be accessed during construction

        config.ref = name;
        return config;
      },

      transform(config) {
        if (Array.isArray(config)) {
          config = {
            items: config
          };
        }

        return config || null;
      }

    }));
    manager.update(strips);

    if (!oldStrips) {
      // Only return the target once. Further calls are processed above so we need to return undefined to ensure
      // onConfigChange is called. By returning the same target on 2nd+ call, it passes the === test and won't
      // trigger onConfigChange.
      return manager.target;
    }
  } //endregion
  //region Collapse/Expand


  get collapsing() {
    var _this$collapsible4;

    return (_this$collapsible4 = this.collapsible) === null || _this$collapsible4 === void 0 ? void 0 : _this$collapsible4.collapsing;
  }

  get collapsingExpanding() {
    var _this$collapsible5;

    return (_this$collapsible5 = this.collapsible) === null || _this$collapsible5 === void 0 ? void 0 : _this$collapsible5.collapsingExpanding;
  }

  get expanding() {
    var _this$collapsible6;

    return (_this$collapsible6 = this.collapsible) === null || _this$collapsible6 === void 0 ? void 0 : _this$collapsible6.expanding;
  }

  changeCollapsed(value) {
    const me = this,
          {
      collapsible
    } = me;
    value = Boolean(value);

    if (!collapsible || me.changingCollapse) {
      // if (the collapser is asking...)
      return value;
    }

    if (me.isPainted) {
      collapsible === null || collapsible === void 0 ? void 0 : collapsible.collapse({
        animation: null,
        collapsed: value
      });
    }
  }

  changeCollapsible(collapsible, was) {
    this.getConfig('tools');

    if (collapsible) {
      if (collapsible === true) {
        collapsible = {};
      } else if (typeof collapsible === 'string') {
        collapsible = {
          [dockDirection[collapsible] ? 'direction' : 'type']: collapsible
        };
      }
    }

    return _panel_PanelCollapser_js__WEBPACK_IMPORTED_MODULE_2__["default"].reconfigure(was, collapsible, {
      owner: this,
      defaults: {
        panel: this
      }
    });
  }

  updateCollapsible(collapsible) {
    const me = this,
          tools = collapsible === null || collapsible === void 0 ? void 0 : collapsible.toolsConfig;
    me.tools = {
      collapse: (tools === null || tools === void 0 ? void 0 : tools.collapse) || null,
      recollapse: (tools === null || tools === void 0 ? void 0 : tools.recollapse) || null
    };

    if (me.isPainted && me.collapsed) {
      me._collapsed = 1;
      me.collapsed = true;
    }
  }

  _collapse(collapsed, options) {
    var _this$collapsible7;

    if (options !== true && options !== undefined) {
      // allow expand(false) to be equivalent to collapse(true)
      // or collapse(false) to be equivalent to expand(true)
      if (options === false) {
        collapsed.collapsed = !collapsed.collapsed;
      } else if (typeof options === 'number') {
        collapsed.animation = {
          duration: options
        };
      } else if (options === null) {
        collapsed.animation = options;
      } else if (options === true) {// ignore
      } // Must be an options object...
      else if ('animation' in options) {
        _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge(collapsed, options);
      } else {
        collapsed.animation = options;
      }
    }

    return (_this$collapsible7 = this.collapsible) === null || _this$collapsible7 === void 0 ? void 0 : _this$collapsible7.collapse(collapsed);
  }

  collapse(options) {
    return this._collapse({
      collapsed: true
    }, options);
  }

  expand(options) {
    return this._collapse({
      collapsed: false
    }, options);
  }

  toggleCollapsed(options) {
    return this.collapsed ? this.expand(options) : this.collapse(options);
  } //endregion
  //region Misc


  get expandedHeaderDock() {
    var _ref, _this$_expandedHeader, _this$initialConfig$h;

    return (_ref = (_this$_expandedHeader = this._expandedHeaderDock) !== null && _this$_expandedHeader !== void 0 ? _this$_expandedHeader : (_this$initialConfig$h = this.initialConfig.header) === null || _this$initialConfig$h === void 0 ? void 0 : _this$initialConfig$h.dock) !== null && _ref !== void 0 ? _ref : 'top';
  }

  set expandedHeaderDock(v) {
    this._expandedHeaderDock = v === null || v === void 0 ? void 0 : v.toLowerCase();
  }

  updateHeader(header) {
    if (!this.changingCollapse) {
      this.expandedHeaderDock = header === null || header === void 0 ? void 0 : header.dock;
    }
  }

  updateTrapFocus(trapFocus) {
    var _me$focusTrapListener;

    const me = this;
    me.element.classList[trapFocus ? 'add' : 'remove']('b-focus-trapped');
    me.focusTrapListener = (_me$focusTrapListener = me.focusTrapListener) === null || _me$focusTrapListener === void 0 ? void 0 : _me$focusTrapListener.call(me);

    if (trapFocus) {
      me.focusTrapListener = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].on({
        element: me.element,
        focusin: 'onFocusTrapped',
        delegate: '.b-focus-trap',
        thisObj: me
      }); // Create a TreeWalker which visits focusable elements.

      if (!me.treeWalker) {
        me.treeWalker = this.setupTreeWalker(me.element, NodeFilter.SHOW_ELEMENT, acceptNode, false);
      }
    }
  } //#region Max height


  updateMaxHeight(maxHeight) {
    super.updateMaxHeight(maxHeight);

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11) {
      this.bodyWrapElement.style.flex = `1 1 ${maxHeight}px`;
    }
  }

  fixIEMaxHeightBug() {
    const {
      element,
      contentElement,
      bodyWrapElement
    } = this; // If this widget is flexed vertically, the maxHeight of the encapsulating element must be
    // propagated onto the contentElement.

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getStyleValue(element, 'flex-direction') === 'column') {
      // Release previous height constraint
      contentElement.style.maxHeight = '';
      let availableHeight = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_7__["default"].client(element).height;
      const siblings = element.childNodes,
            len = siblings.length; // In case there are height-consuming siblings of the contentElement.
      // For example a header/footer. The heights of these must be subtracted.

      for (let i = 0; i < len; i++) {
        const sibling = siblings[i];

        if (sibling !== contentElement && sibling !== bodyWrapElement && !sibling.classList.contains('b-resize-monitors')) {
          availableHeight -= sibling.offsetHeight;
        }
      } // Apply the adjusted height constraint to the contentElement


      this.contentElement.style.maxHeight = `${availableHeight}px`;
    }
  } //#endregion


  setupTreeWalker(root, whatToShow, filter, entityReferenceExpansion) {
    return document.createTreeWalker(root, whatToShow, filter, entityReferenceExpansion);
  }

  onFocusTrapped(e) {
    const me = this,
          treeWalker = me.treeWalker; // The only way of focusing these invisible elements is by TAB-ing to them.
    // If we hit the bottom one, wrap to the top.

    if (e.target === me.bottomFocusTrap) {
      treeWalker.currentNode = me.topFocusTrap;
      treeWalker.nextNode();
    } // If we hit the top one, wrap to the bottom.
    else {
      treeWalker.currentNode = me.bottomFocusTrap;
      treeWalker.previousNode();
    }

    me.requestAnimationFrame(() => treeWalker.currentNode.focus());
  }

  get focusElement() {
    // Either use our Containerness to yield the focus element of
    // a descendant or fall back to the encapsulating element.
    return this.hasItems && (super.focusElement || this.element);
  }

  get contentElement() {
    return this.element && this.bodyElement;
  }

  get widgetClassList() {
    const me = this,
          result = super.widgetClassList;

    if (me.hasHeader) {
      var _me$header;

      result.push('b-panel-has-header', `b-header-dock-${((_me$header = me.header) === null || _me$header === void 0 ? void 0 : _me$header.dock) || 'top'}`);
    }

    if (me.tbar) {
      result.push('b-panel-has-top-toolbar');
    }

    if (me.bbar) {
      result.push('b-panel-has-bottom-toolbar');
    }

    return result;
  } //endregion


} // Register this widget type with its Factory

Panel.initClass();
Panel._$name = 'Panel';

/***/ }),

/***/ "./lib/Core/widget/PasswordField.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/PasswordField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PasswordField; });
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
var productName = 'taskboard';

/**
 * @module Core/widget/PasswordField
 */

/**
 * Password field widget. Wraps native &lt;input type="password"&gt;
 *
 * ```javascript
 * let textField = new PasswordField({
 *     placeholder : 'Enter password'
 * });
 * ```
 *
 * {@inlineexample Core/widget/PasswordField.js}
 * @classType passwordfield
 * @extends Core/widget/Field
 */

class PasswordField extends _Field_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // Factoryable type name
  static get type() {
    return 'passwordfield';
  } // Factoryable type alias


  static get alias() {
    return 'password';
  }

  static get $name() {
    return 'PasswordField';
  }

  construct(config = {}) {
    config.inputType = 'password';
    super.construct(...arguments);
    this.element.classList.add('b-textfield');
  }

} // Register this widget type with its Factory

PasswordField.initClass();
PasswordField._$name = 'PasswordField';

/***/ }),

/***/ "./lib/Core/widget/PickerField.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/PickerField.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PickerField; });
/* harmony import */ var _TextField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'taskboard';




/**
 * @module Core/widget/PickerField
 */

/**
 * Base class used for {@link Core.widget.Combo Combo}, {@link Core.widget.DateField DateField}, and {@link Core.widget.TimeField TimeField}.
 * Displays a picker ({@link Core.widget.List List}, {@link Core.widget.DatePicker DatePicker}) anchored to the field.
 * Not intended to be used directly.
 *
 * This field's subclasses can be used as editors for the {@link Grid.column.Column Column}.
 *
 * When focused by means of *touch* tapping on the trigger element (eg, the down arrow on a Combo)
 * on a tablet, the keyboard will not be shown by default to allow for interaction with the dropdown.
 *
 * A second tap on the input area will then show the keyboard if required.
 *
 * @extends Core/widget/TextField
 * @abstract
 */

class PickerField extends _TextField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'PickerField';
  } // Factoryable type name


  static get type() {
    return 'pickerfield';
  }

  static get configurable() {
    return {
      /**
       * User can edit text in text field (otherwise only pick from attached picker)
       * @config {Boolean}
       * @default
       */
      editable: true,

      /**
       * The name of the element property to which the picker should size and align itself.
       * @config {String}
       * @default element
       */
      pickerAlignElement: 'inputWrap',
      // Does not get set, but prevents PickerFields inheriting value:'' from Field.
      value: null,
      triggers: {
        expand: {
          cls: 'bars'
        }
      },

      /**
       * By default PickerField's picker is transient, and will {@link #function-hidePicker} when the user clicks or
       * taps outside or when focus moves outside picker.
       *
       * Configure as `false` to make picker non-transient.
       * @config {Boolean}
       * @default
       */
      autoClose: true,

      /**
       * Configure as `true` to have the picker expand upon focus enter.
       * @config {Boolean}
       */
      autoExpand: null,

      /**
       * Returns the instantiated picker widget as configured by {@link #config-picker}.
       * @readonly
       * @member {Core.widget.Widget} picker
       */

      /**
       * A config object which is merged into the generated picker configuration to allow specific use cases
       * to override behaviour. For example:
       *
       *     picker: {
       *         align: {
       *             anchor: true
       *         }
       *     }
       *
       * @config {Object}
       */
      picker: {
        value: {
          floating: true
        },
        $config: ['lazy', 'nullify']
      },
      inputType: 'text',
      // We need to realign the picker if we resize (eg a multiSelect Combo's ChipView wrapping)
      monitorResize: true,
      nullValue: null
    };
  } //endregion
  //region Init & destroy


  doDestroy() {
    var _this$globalTapListen;

    // Remove touch keyboard showing listener if we added it
    (_this$globalTapListen = this.globalTapListener) === null || _this$globalTapListen === void 0 ? void 0 : _this$globalTapListen.call(this);
    super.doDestroy();
  }

  updateEditable(editable) {
    const me = this,
          element = me.element;
    super.updateEditable(...arguments);

    if (editable === false) {
      var _me$globalTapListener;

      (_me$globalTapListener = me.globalTapListener) === null || _me$globalTapListener === void 0 ? void 0 : _me$globalTapListener.call(me);
      element.classList.add('b-not-editable');
      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
        element: me.input,
        click: 'onTriggerClick',
        thisObj: me
      });
    } else {
      // In case the field was temporarily set to readOnly="true" to prevent
      // the intrusive keyboard (This happens when tapping the trigger
      // and when focused by the container in response to a touch tap),
      // allow a subsequent touch tap to show the keyboard.
      me.globalTapListener = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__["default"].on({
        globaltap: 'showKeyboard',
        thisObj: me
      });
    }
  } //endregion
  //region Picker

  /* TODO
  changePicker(picker, was) {
      if (was) {
          was.hide();
          was.destroy();
      }
      if (picker && !(picker instanceof Widget)) {
          picker = this.createPicker(picker);
      }
      return picker;
  }
  createPicker() {
      throw new Error('createPicker must be implemented in PickerField subclass implementations');
  }
  */


  changePicker(picker, oldPicker) {
    throw new Error('changePicker(oldPicker, newPicker) must be implemented in PickerField subclass implementations');
  }
  /**
   * Iterate over all widgets owned by this widget and any descendants.
   *
   * *Note*: Due to this method aborting when the function returns `false`, beware of using short form arrow
   * functions. If the expression executed evaluates to `false`, iteration will terminate.
   *
   * _Due to the {@link #config-picker} config being a lazy config and only being converted to be a
   * `List` instance just before it's shown, the picker will not be part of the iteration before
   * it has been shown once_.
   * @function eachWidget
   * @param {Function} fn A function to execute upon all descendant widgets.
   * Iteration terminates if this function returns `false`.
   * @param {Boolean} [deep=true] Pass as `false` to only consider immediate child widgets.
   * @returns {Boolean} Returns `true` if iteration was not aborted by a step returning `false`
   */


  get childItems() {
    if (this._picker) {
      return [this.picker];
    }
  } //endregion
  //region Events

  /**
   * Check if field value is valid
   * @internal
   */


  onEditComplete() {
    super.onEditComplete();
    this.autoClosePicker();
  }

  onElementResize(resizedElement) {
    const me = this; // If the field changes size while the picker is visible, the picker
    // must be kept in alignment. For example a multiSelect: true
    // ComboBox with a wrapped ChipView.

    if (me.pickerVisible) {
      // Push realignment out to the next AF, because this picker itself may move in
      // response to the element resize, and the picker must realign *after* that happens.
      // For example a multiSelect: true ComboBox with a wrapped ChipView inside
      // a Popup that is aligned *above* an element. When the ChipView gains or
      // loses height, the Popup must realign first, and then the List must align to the
      // new position of the ComboBox.
      me.picker.requestAnimationFrame(me.picker.realign, null, me.picker);
    }

    super.onElementResize(resizedElement);
  }
  /**
   * Allows using arrow keys to open/close list. Relays other keypresses to list if open.
   * @private
   */


  internalOnKeyEvent(event) {
    const me = this;
    let callSuper = true;

    if (event.type === 'keydown' && !me.disabled) {
      if (me.pickerVisible) {
        const {
          picker
        } = me;

        if (event.key === 'Escape') {
          event.stopImmediatePropagation();
          me.hidePicker(); // EC has multiple effects. First stage is hide the picker.
          // If we do this, then the superclass's ESC handling must
          // not be called.

          callSuper = false;
        } else if (picker.onInternalKeyDown) {
          // if picker is visible, give it a shot at the event
          picker.onInternalKeyDown(event);
        } else if (event.key === 'ArrowDown') {
          if (picker.focusable) {
            picker.focus();
          }
        }
      } else if (event.key === 'ArrowDown') {
        // navigator should not react to initial DOWN keypress that triggers the List to show
        event.stopImmediatePropagation(); // If we not prevent default handler page might scroll. Siesta cannot reproduce this behavior, have to
        // leave it untested.
        // https://github.com/bryntum/support/issues/885

        event.preventDefault();
        me.onTriggerClick(event);
      }
    }

    if (callSuper) {
      super.internalOnKeyEvent(event);
    }
  }

  onFocusIn(e) {
    super.onFocusIn(e);

    if (this.autoExpand) {
      // IE triggers an input event on focus.
      // If expand is configured for focus, minChars should be zero.
      this.minChars = 0;
      this.onTriggerClick(e);
    }
  }

  onFocusOut(e) {
    this.autoClosePicker();
    super.onFocusOut(e);
  }
  /**
   * User clicked trigger icon, toggle list.
   * @private
   */


  onTriggerClick(event) {
    if (!this.disabled) {
      // Pass focus flag as true if invoked by a key event
      this.togglePicker('key' in event);
    }
  }
  /**
   * User clicked on an editable input field. If it's a touch event
   * ensure that the keyboard is shown.
   * @private
   */


  showKeyboard({
    event
  }) {
    const input = this.input;

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isTouchEvent && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getActiveElement(input) === input && event.target === input) {
      _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__["default"].suspendFocusEvents();
      input.blur();
      input.focus();
      _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__["default"].resumeFocusEvents();
    }
  } //endregion
  //region Toggle picker

  /**
   * Toggle the {@link #property-picker} visibility
   * @privateparam {Boolean} [focus] Pass `true` to focus the picker when it gets shown.
   */


  togglePicker(focus) {
    if (this.pickerVisible) {
      this.hidePicker();
    } else {
      this.showPicker(focus);
    }
  }
  /**
   * Show the {@link #property-picker}
   * @privateparam {Boolean} [focus] Pass `true` to focus the picker when it gets shown.
   */


  showPicker(focus) {
    const me = this,
          {
      picker
    } = me;

    if (!me.pickerHideShowListenersAdded) {
      picker.on({
        show: 'onPickerShow',
        hide: 'onPickerHide',
        thisObj: me
      });
      me.pickerHideShowListenersAdded = true;
    }

    picker.autoClose = me.autoClose;
    picker.show(); // Not been vetoed

    if (picker.isVisible) {
      if (focus) {
        me.focusPicker();
      }
    }
  }

  onPickerShow() {
    const me = this;
    me.pickerVisible = true;
    me.element.classList.add('b-open');
    me.trigger('togglePicker', {
      show: true
    });
    me.pickerTapOutRemover = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_1__["default"].on({
      globaltap: 'onPickerTapOut',
      thisObj: me
    });
    me.pickerKeyDownRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: me.picker.element,
      keydown: 'onPickerKeyDown',
      thisObj: me
    });
  }

  onPickerHide() {
    const me = this;
    me.pickerVisible = false;
    me.element.classList.remove('b-open');
    me.trigger('togglePicker', {
      show: false
    });
    me.pickerTapOutRemover && me.pickerTapOutRemover();
    me.pickerKeyDownRemover && me.pickerKeyDownRemover();
  }

  onPickerTapOut({
    event
  }) {
    if (!this.owns(event.target)) {
      this.autoClosePicker();
    }
  }

  onPickerKeyDown(event) {
    if (event.key === 'Tab') {
      const activeEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getActiveElement(this.input),
            forwardedEvent = new KeyboardEvent('keydown', event); // Offer our own element a shot at the TAB event.
      // Some widgets or plugins may actively navigate.

      this.input.dispatchEvent(forwardedEvent); // Somebody might preventDefault on the synthesized event. We must honour that.
      // For example if we are the field for a cell Editor, and it started an edit on the adjacent cell.

      if (forwardedEvent.defaultPrevented) {
        event.preventDefault();
      } // No listener intervened, point the TAB event at the input,
      // and user agent default navigation will proceed.


      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getActiveElement(this.input) === activeEl) {
        this.input.focus();
      } // Some listener *did* navigate, prevent user agent default.
      else {
        event.preventDefault();
      } // If listeners have not destroyed us, close our picker.


      if (!this.isDestroyed) {
        this.hidePicker();
      }
    }
  } //endregion
  //region Visibility


  autoClosePicker() {
    if (this.autoClose) {
      this.hidePicker();
    }
  }
  /**
   * Hide picker
   */


  hidePicker() {
    if (this.pickerVisible) {
      this.picker.hide();
    }
  }

  focusPicker() {}

  focus() {
    const input = this.input; // If we are focusing an editable PickerField from a touch event, temporarily
    // set it to readOnly to prevent the showing of the intrusive keyboard.
    // It's more likely that a user on a touch device will interact with the picker
    // rather than the input field.
    // A second touch tap on an already focused input will show the keyboard;
    // see the showKeyboard method.

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isTouchEvent && this.editable) {
      input.readOnly = true;
      this.setTimeout(() => input.readOnly = false, 500);
    }

    super.focus();
  } //endregion


}
PickerField._$name = 'PickerField';

/***/ }),

/***/ "./lib/Core/widget/Popup.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Popup.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Popup; });
/* harmony import */ var _Panel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'taskboard';





/**
 * @module Core/widget/Popup
 */

/**
 * A floating Popup widget, which can contain child {@link Core.widget.Container#config-items widgets} or plain html. Serves as the base class
 * for Menu / Tooltip.
 *
 * @example
 * let popup = new Popup({
 *   forElement : document.querySelector('button'),
 *   items      : [
 *     { type : 'text', placeholder: 'Text' },
 *     { type: 'button', text: 'Okay', style: 'width: 100%', color: 'b-orange'}
 *   ]
 * });
 *
 * @classType popup
 * @inlineexample Core/widget/Popup.js
 *
 * @extends Core/widget/Panel
 */

class Popup extends _Panel_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Popup';
  } // Factoryable type name


  static get type() {
    return 'popup';
  }

  static get configurable() {
    return {
      /**
       * Auto show flag for Popup.
       * If truthy then Popup is shown automatically upon hover.
       * @config {Boolean}
       * @default
       */
      autoShow: true,

      /**
       * By default a Popup is transient, and will {@link #function-close} when the user clicks or
       * taps outside its owned widgets and when focus moves outside its owned widgets.
       *
       * **Note**: {@link #config-modal Modal} popups won't {@link #function-close} when focus moves outside even if autoClose is `true`.
       *
       * Configure as `false` to make a Popup non-transient.
       * @config {Boolean}
       * @default
       */
      autoClose: true,

      /**
       * Show popup when user clicks the element that it is anchored to. Cannot be combined with showOnHover
       * @config {Boolean}
       * @default
       */
      showOnClick: false,

      /**
       * DOM element to attach popup.
       * @config {HTMLElement}
       */
      forElement: null,
      monitorResize: true,
      floating: true,
      hidden: true,
      axisLock: true,
      // Flip edges if align violates constrainTo
      hideAnimation: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11 ? null : {
        opacity: {
          from: 1,
          to: 0,
          duration: '.3s',
          delay: '0s'
        }
      },
      showAnimation: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isIE11 ? null : {
        opacity: {
          from: 0,
          to: 1,
          duration: '.4s',
          delay: '0s'
        }
      },
      stripDefaults: {
        bbar: {
          layout: {
            justify: 'flex-end'
          }
        }
      },
      testConfig: {
        hideAnimation: null,
        showAnimation: null
      },

      /**
       * The action to take when calling the {@link #function-close} method.
       * By default, the popup is hidden.
       *
       * This may be set to `'destroy'` to destroy the popup upon close.
       * @config {String}
       * @default
       */
      closeAction: 'hide',

      /**
       * By default, tabbing within a Popup is circular - that is it does not exit.
       * Configure this as `false` to allow tabbing out of the Popup.
       * @config {Boolean}
       * @default
       */
      trapFocus: true,

      /**
       * By default a Popup is focused when it is shown.
       * Configure this as `false` to prevent automatic focus on show.
       * @config {Boolean}
       * @default
       */
      focusOnToFront: true,

      /**
       * Show a tool in the header to close this Popup, and allow `ESC` close it.
       * The tool is available in the {@link Core.widget.mixin.Toolable#property-tools} object
       * under the name `close`. It uses the CSS class `b-popup-close` to apply a
       * default close icon. This may be customized with your own CSS rules.
       * @default false
       * @config {Boolean}
       */
      closable: null,

      /**
       * Show a tool in the header to maximize this popup
       * @config {Boolean}
       * @default false
       */
      maximizable: null,

      /**
       * Optionally show an opaque mask below this Popup when shown.
       * Configure this as `true` to show the mask.
       *
       * When a Popup is modal, it defaults to being {@link Core.widget.Widget#config-centered centered}.
       * Also it won't {@link #function-close} when focus moves outside even if {@link #config-autoClose} is `true`.
       *
       * May also be an object containing the following properties:
       * * `closeOnMaskTap` Specify as `true` to {@link #function-close} when mask is tapped.
       * The default action is to focus the popup.
       *
       * Usage:
       * ```javascript
       * new Popup({
       *     title  : 'I am modal',
       *     modal  : {
       *         closeOnMaskTap : true
       *     },
       *     height : 100,
       *     width  : 200
       * });
       * ```
       *
       * @default false
       * @config {Boolean}
       */
      modal: null,

      /**
       * Set to `true` to make this widget take all available space in the visible viewport.
       * @member {Boolean} maximized
       * @category Float & align
       */

      /**
       * Set to `true` to make this widget take all available space in the visible viewport.
       * @config {Boolean}
       * @default false
       * @category Float & align
       */
      maximized: null,
      tools: {
        close: {
          cls: 'b-popup-close',
          handler: 'close',
          weight: -1000,
          hidden: true // shown when closable set to true

        },
        maximize: {
          cls: 'b-popup-expand',
          handler: 'toggleMaximized',
          weight: -999,
          hidden: true // shown when maximizable set to true

        }
      },
      highlightReturnedFocus: true
    };
  } //endregion
  //region Init & destroy


  finalizeInit() {
    const me = this;
    me.anchoredTo = me.forElement;
    me.initialAnchor = me.anchor;

    if (me.forElement && me.showOnClick) {
      // disable autoShow if not enabled by config
      if (!me.initialConfig.autoShow) {
        me.autoShow = false;
      }

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
        element: me.forElement,
        click: 'onElementUserAction',
        thisObj: me
      });
    }

    super.finalizeInit();

    if (me.autoShow) {
      if (me.autoShow === true) {
        me.show();
      } else {
        me.setTimeout(() => me.show(), me.autoShow);
      }
    }
  }

  onPaint({
    firstPaint
  }) {
    var _super$onPaint;

    (_super$onPaint = super.onPaint) === null || _super$onPaint === void 0 ? void 0 : _super$onPaint.call(this, ...arguments);
    const me = this;

    if (me.maximizable && me.headerElement) {
      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
        element: me.headerElement,
        dblclick: me.onHeaderDblClick,
        thisObj: me
      });
    }
  }

  doDestroy() {
    this.syncModalMask();
    super.doDestroy();
  } //endregion


  compose() {
    const {
      hasNoChildren,
      textContent
    } = this;
    return {
      class: {
        // Popup has extra CSS responsibilities at the top level.
        // The CSS needs to know whether it should impose a max-width.
        'b-text-popup': Boolean(textContent && hasNoChildren)
      }
    };
  } //region Show/hide

  /**
   * Performs the configured {@link #config-closeAction} upon this popup.
   * By default, the popup hides. The {@link #config-closeAction} may be
   * configured as `'destroy'`.
   * @fires beforeclose If popup is not hidden
   */


  close() {
    const me = this;
    /**
     * Fired when the {@link #function-close} method is called and the popup is not hidden.
     * May be vetoed by returning `false` from a handler.
     * @event beforeClose
     * @param {Core.widget.Popup} source - This Popup
     */

    if (!me._hidden && me.trigger('beforeClose') !== false || // we should destroy it even if it's hidden just omit beforeclose event
    me._hidden && me.closeAction === 'destroy') {
      // Focus moves unrelated to where the user's attention is upon this gesture.
      // Go into the keyboard mode where the focused widget gets a rendition so that
      // it is obvious where focus now is.
      // Must jump over EventHelper's global mousedown listener which will remove this class.
      if (me.containsFocus && me.highlightReturnedFocus) {
        me.setTimeout(() => me.element.classList.add('b-using-keyboard'), 0);
      }

      return me[me.closeAction]();
    }
  }

  toggleMaximized() {
    this.maximized = !this.maximized;
  }

  updateMaximized(value) {
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].toggleClasses(this.element, ['b-maximized'], value);
  } //endregion
  //region Events


  onInternalKeyDown(event) {
    // close on escape key
    if (event.key === 'Escape') {
      event.stopImmediatePropagation();
      this.close(true);
    }
  }

  onDocumentMouseDown({
    event
  }) {
    const me = this,
          {
      owner
    } = me,
          {
      target
    } = event; // If mousedown was on our owning Button, it is that button's responsibility to
    // toggle its pressed state thereby hiding its menu, so prevent the focus move of the mousedown.

    if (event.type !== 'touchend' && owner !== null && owner !== void 0 && owner.isButton && owner._menu === me && owner.element.contains(target)) {
      event.preventDefault();
      return false;
    }

    if (me.modal && target === Popup.modalMask) {
      event.preventDefault();

      if (me.modal.closeOnMaskTap) {
        me.close();
      } else if (!me.containsFocus) {
        me.focus();
      }
    } // in case of outside click and if popup is focused, focusout will trigger closing
    else if (!me.owns(target) && me.autoClose && !me.containsFocus) {
      me.close();
    }
  }

  get isTopModal() {
    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isVisible(Popup.modalMask) && this.element.previousElementSibling === Popup.modalMask;
  }

  onFocusIn(e) {
    const activeEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(this);
    super.onFocusIn(e); // No event handler has moved focus, and target is outermost el
    // then delegate to the focusElement which for a Container
    // is found by finding the first visible, focusable descendant widget.

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(this) === activeEl && e.target === this.element) {
      this.focus();
    }
  }

  onFocusOut(e) {
    // For mobile browsers with virtual keyboard, when pressing Done key, focus should move back to the popup
    // https://github.com/bryntum/support/issues/2903
    const usingVirtualKeyboard = window.visualViewport && window.visualViewport.height < document.documentElement.clientHeight;

    if (!usingVirtualKeyboard && !this.modal && this.autoClose) {
      this.close();
    }

    super.onFocusOut(e);
  }

  onShow() {
    const me = this;

    if (me.autoClose) {
      me.addDocumentMouseDownListener();
    } // TODO: It's the floating "toFront" operation that should handle
    // focusing based on config focusOnToFront.


    if (me.focusOnToFront) {
      me.focus();
    }

    super.onShow && super.onShow(); // Insert the modal mask below this Popup if needed

    me.syncModalMask();
  }

  addDocumentMouseDownListener() {
    if (!this.mouseDownRemover) {
      this.mouseDownRemover = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_3__["default"].on({
        globaltap: 'onDocumentMouseDown',
        thisObj: this
      });
    }
  }

  updateModal(modal) {
    // Modal implies that this is floating. Theres no ability for positioned widgets
    // to acquire a modal mask.
    if (modal) {
      this.floating = true;
    }
  }

  syncModalMask() {
    const me = this,
          {
      modal
    } = me; // Note the difference between Popup.modalMask and this.modalMask.
    // this.modalMask syncs the position of the element in the DOM
    // to be below this element. Popup.modalMask just returns the element.

    if (modal && me.isVisible) {
      // If we have not been explicitly positioned, a modal is centered.
      if (typeof me._x !== 'number' && typeof me._y !== 'number') {
        me.centered = true;
      }

      me.modalMask.classList.remove('b-hide-display');
      me.element.classList.add('b-modal');
    } else if (me.isPainted) {
      me.element.classList.remove('b-modal');
      const remainingModals = me.floatRoot.querySelectorAll('.b-modal'),
            topModal = remainingModals.length ? Popup.fromElement(remainingModals[remainingModals.length - 1], 'popup') : null; // If there are any other visible modals, drop the mask to just below the new topmost

      if (topModal) {
        topModal.syncModalMask();
      } else {
        Popup.modalMask.classList.add('b-hide-display');
      }
    }
  }

  onHide() {
    const me = this;

    if (me.mouseDownRemover) {
      me.mouseDownRemover();
      me.mouseDownRemover = null;
    }

    super.onHide && super.onHide(); // Insert the modal mask below the topmost Popup if needed, else hide it

    me.syncModalMask();
  }

  onElementUserAction() {
    this.show();
  }

  onHeaderDblClick() {
    if (this.maximizable) {
      this.toggleMaximized();
    }
  } //endregion


  updateClosable(closable) {
    this.tools.close.hidden = !closable;
  }

  updateMaximizable(maximizable) {
    this.tools.maximize.hidden = !maximizable;
  }
  /**
   * Returns the modal mask element for this Popup correctly positioned just below this Popup.
   * @internal
   */


  get modalMask() {
    const {
      modalMask
    } = Popup;

    if (modalMask.nextElementSibling !== this.element) {
      this.floatRoot.insertBefore(modalMask, this.element);
    }

    return modalMask;
  }
  /**
   * Returns the modal mask element. It does NOT guarantee its placement in the DOM relative
   * to any Popup. To get the modal mask for a particular Popup, use the instance property.
   * @internal
   */


  static get modalMask() {
    if (!this._modalMask) {
      this._modalMask = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement({
        className: 'b-modal-mask b-hide-display'
      }); // Mousewheel should not scroll the body "through" a modal mask.

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
        element: this._modalMask,
        wheel: e => e.preventDefault()
      });
    }

    return this._modalMask;
  }

} // Register this widget type with its Factory

Popup.initClass();
Popup._$name = 'Popup';

/***/ }),

/***/ "./lib/Core/widget/Renderable.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/Renderable.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Renderable; });
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';








const {
  defineProperty
} = Reflect;
/**
 * @module Core/widget/Renderable
 */

/**
 * This class provides element rendering and automatic synchronization based on config property changes.
 *```
 *  class Label extends Renderable {
 *      static get configurable() {
 *          return {
 *              text : {
 *                  value: null,
 *
 *                  $config : 'render'
 *              }
 *          };
 *      }
 *
 *      renderDom() {
 *          return {
 *              tag: 'label',
 *              children: [
 *                  this.text
 *              ]
 *          };
 *      }
 *  }
 *```
 * A class can opt to not specify its render configs. In this case, these will be determined automatically, but with
 * some additional cost. This may not be worth considering if only a few instances are ever likely.
 *
 * @private
 */

class Renderable extends _Base_js__WEBPACK_IMPORTED_MODULE_7__["default"].mixin(_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_5__["default"], _mixin_Events_js__WEBPACK_IMPORTED_MODULE_4__["default"], _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_0__["default"], _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_6__["default"]) {
  static get configurable() {
    return {
      /**
       * The top-level DOM element for this object. This element is produced from the {@link #function-renderDom}
       * method of the derived class. As configs used by `renderDom` change, a synchronization of the DOM is
       * scheduled by calling {@link #function-refreshDom}. This call is made automatically by this class, making
       * it rarely necessary to call `refreshDom` directly.
       * @config {HTMLElement}
       * @category DOM
       */
      element: null
    };
  }

  static get delayable() {
    return {
      refreshDom: 'raf'
    };
  }

  static get identifiable() {
    return {};
  }
  /**
   * Returns the Set of configs defined as `render: true`, that is, the configs that determine the rendering (via
   * `renderDom`). If no such configs are defined, this method returns `null`.
   *
   * @returns {Set}
   * @private
   */


  static get renderConfigs() {
    const me = this,
          meta = me.$meta;
    let renderConfigs = meta.renderConfigs,
        configs,
        name;

    if (renderConfigs === undefined) {
      // if (first time for this class)
      renderConfigs = null;
      configs = meta.configs;

      for (name in configs) {
        if (configs[name].render) {
          (renderConfigs || (renderConfigs = new Set())).add(name);
        }
      } // Put $renderConfigs on the prototype so that onConfigChange is as simple as possible:


      meta.renderConfigs = me.prototype.$renderConfigs = renderConfigs;
    }

    return renderConfigs;
  } //region Init


  construct(...args) {
    this.$iid = ++Renderable.$idSeed;
    this.byRef = {};
    super.construct(...args);

    if (this.onDraw !== Renderable.prototype.onDraw) {
      this.initDrawable();
    }
  }

  startConfigure(config) {
    this.element = this.renderContext.renderDom(); // calls changeElement()

    super.startConfigure(config);
  } //endregion
  //region Configs


  get element() {
    // NOTE: We can replace the getter of a config property
    // Asking for the primary el is a good sign that we need to sync the DOM:
    this.refreshDom.flush();
    return this._element;
  }
  /**
   * This is called when the `element` config is assigned (via the setter).
   * @param {HTMLElement} element The new element being assigned.
   * @param {HTMLElement|null} oldElement The old element (previously assigned) or `null`.
   * @returns {HTMLElement}
   * @private
   */


  changeElement(element, oldElement) {
    const me = this;

    if (oldElement) {
      oldElement.remove();
    }

    if (element) {
      element.id = me.id;
      element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].createElement(element, {
        refOwner: me
      });
    }

    return element;
  }

  updateId(id, oldId) {
    const me = this;

    if (oldId) {
      const element = me.element;
      element.id = id;
      me.fixRefOwnerId(element, id, oldId);
    }
  } //endregion
  //region Misc

  /**
   * Returns the `classList` of this instance's `element`.
   * @property {DOMTokenList}
   */


  get classes() {
    return this.element.classList;
  }
  /**
   * This method fixes the element's `$refOwnerId` when this instance's `id` is changing.
   * @param {HTMLElement} el The element to fix.
   * @param {String} id The new id being assigned.
   * @param {String} oldId The old id (previously assigned).
   * @private
   */


  fixRefOwnerId(el, id, oldId) {
    if (el.$refOwnerId === oldId) {
      el.$refOwnerId = id;
      const ref = el.$reference;

      if (ref) {
        el.id = `${id}-${ref}`;
      }

      for (const c of el.childNodes) {
        this.fixRefOwnerId(c, id, oldId);
      }
    }
  }

  onConfigChange({
    name
  }) {
    // The $renderConfigs Set is either on our prototype (due to renderConfigs getter) or on our instance (due to
    // renderContext getter):
    if (!this.isConfiguring && this.$renderConfigs.has(name)) {
      this.refreshDom();
    }
  } //endregion
  //region Rendering

  /**
   * This method is called by `DomHelper.createElement` and `DomSync.sync` as new reference elements are created.
   * @param {String} name The name of the element, i.e., the value of its `reference` attribute.
   * @param {HTMLElement} el The element instance
   * @param {Object} domConfig The DOM config object.
   * @private
   */


  attachRef(name, el, domConfig) {
    const me = this,
          key = '_' + name,
          {
      listeners
    } = domConfig;

    if (!(key in me)) {
      defineProperty(me, name, {
        get() {
          // Asking for a ref el is a good sign that we need to sync the DOM:
          me.refreshDom.flush();
          return me[key];
        },

        set(el) {
          me[key] = el; // Key elements contain owner pointer (Not supported on IE SVG).
          // if (el && el.dataset) {
          //     el.dataset.ownerCmp = me.id;
          // }
        }

      });
    }

    el.id = `${me.id}-${name}`;
    me.byRef[name] = el;
    me[name] = el;

    if (listeners) {
      domConfig.listeners = {
        on: listeners,
        un: _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on(Object.assign({
          element: el,
          thisObj: me
        }, listeners))
      };
    }
  }
  /**
   * This method is called by `DomSync.sync` as reference elements are removed from the DOM.
   * @param {String} name The name of the element, i.e., the value of its `reference` attribute.
   * @param {HTMLElement} el The element instance
   * @param {Object} domConfig The DOM config object.
   * @private
   */


  detachRef(name, el, domConfig) {
    if (domConfig.listeners) {
      domConfig.listeners.un();
      domConfig.listeners = null;
    }

    this[name] = null;
    delete this.byRef[name];
  }
  /**
   * This method returns a {@link Core.helper.DomHelper#function-createElement-static} config object that describes
   * the desired elements for this instance.
   *
   * This method is called to produce the initial DOM structure and again as necessary to generate the DOM for the
   * current state. The DOM produced by these subsequent calls is then passed through
   * {@link Core.helper.DomSync#function-sync-static DomSync.sync()} to update the DOM.
   * @returns {Object}
   */


  renderDom() {
    // abstract method provided by derived class
    return {};
  }
  /**
   * This property is the object to use when calling the `renderDom` method. It may evaluate to this instance (if
   * the class declares its render configs) or a helper object to track config usage during the `renderDom` call.
   * @property {Object}
   * @private
   */


  get renderContext() {
    const me = this,
          meta = me.$meta,
          C = me.constructor;
    let renderConfigs = meta.renderConfigs || C.renderConfigs,
        context = me; // If the class author did not declare any configs as render:true, then we make a proxy-like object that can
    // detect getter calls to build that Set. Since the getters may not all trigger on any given rendering, we
    // cannot share this work across instances since they may take different control paths.

    if (!renderConfigs) {
      context = Object.create(me);
      renderConfigs = new Set();

      for (const name in meta.configs) {
        defineProperty(context, name, {
          get() {
            renderConfigs.add(name);
            return me[name];
          }

        });
      } // In order to be substitutable for the Renderable, we need the same method name... we just need to run
      // renderDom w/ our context as "this":


      context.renderDom = () => {
        return me.renderDom.call(context);
      };

      me.$renderConfigs = renderConfigs;
    } // Replace this getter with the actual context so we don't get called again:


    defineProperty(me, 'renderContext', {
      value: context
    });
    return context;
  }
  /**
   * This method synchronized the DOM produced by {@link #function-renderDom} with what was previously produced and
   * updates the elements accordingly.
   *
   * This method is buffered such that calls to it do not immediately execute. To perform the refresh immediately,
   * do this:
   *```
   *  instance.refreshDom.now();
   *```
   * To flush any potential updates to the DOM (and do nothing if there are none), do this:
   *```
   *  instance.refreshDom.flush();
   *```
   * To determine if there are updates to the DOM pending, do this:
   *```
   *  if (instance.refreshDom.isPending) {
   *      ...
   *  }
   *```
   */


  refreshDom() {
    _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__["default"].sync({
      targetElement: this.element,
      domConfig: this.renderContext.renderDom(),
      refOwner: this,
      // This limits the sync() to only removing the classes and styles added by previous renderings. This
      // allows dynamically added styles and classes to be preserved:
      strict: true
    });
  } //endregion


  onListen(eventName) {
    // Only add the b-drawable-el when someone first listens for the draw event since it may never happen...
    if (eventName === 'draw') {
      this.initDrawable();
    }
  }

  initDrawable() {
    const me = this;

    if (!me.intersector) {
      let el = Object.values(me.byRef).find(el => el.classList.contains('b-drawable'));

      if (!el) {
        el = me.element;
        el.classList.add('b-drawable');
      } // TODO Not supported in IE11 even w/polyfills at the moment


      me.intersector = true; // me.intersector = new IntersectionObserver(entries => {
      //     if (!me.isDestroyed) {
      //         entries.forEach(ent => {
      //             if (ent.isIntersecting) {
      //                 me.onDraw({
      //                     count : ++me.drawCounter
      //                 });
      //             }
      //         });
      //     }
      // });
      //
      // me.intersector.observe(el);

      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].on({
        element: _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].createElement({
          parent: el,
          class: 'b-drawable-el'
        }),

        animationend({
          animationName
        }) {
          if (animationName === 'b-drawable-anim') {
            me.onDraw({
              count: ++me.drawCounter
            });
          }
        }

      });
    }
  }

  onDraw(ev) {
    this.trigger('draw', ev);
  }

}
Renderable.$idSeed = 0;
Object.assign(Renderable.prototype, {
  drawCounter: 0,
  hasGeneratedId: false,
  intersector: null
});
Renderable._$name = 'Renderable';

/***/ }),

/***/ "./lib/Core/widget/Ripple.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Ripple.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Ripple; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';






let lastTouchTime = 0;

const hasRipple = w => w.ripple;

class Ripple extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      old_element: {
        children: [{
          className: 'b-ripple-inner',
          reference: 'rippleElement'
        }]
      },
      element: {
        children: [{
          tag: 'svg',
          class: 'b-ripple-inner',
          reference: 'rippleElement',
          ns: 'http://www.w3.org/2000/svg',
          version: '1.1',
          viewBox: '0 0 100 100',
          children: [{
            reference: 'circleElement',
            tag: 'circle',
            cx: '0',
            cy: '0',
            r: 10
          }]
        }]
      },
      floating: true,
      hideAnimation: false,
      showAnimation: false,
      scrollAction: 'realign',
      color: 'rgba(0,0,0,.3)',
      startRadius: 10,
      radius: 100
    };
  }

  static get $name() {
    return 'Ripple';
  }

  afterConstruct() {
    super.afterConstruct();
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: this.rootElement,
      mousedown: 'onRippleControllingEvent',
      thisObj: this,
      capture: true,
      once: true
    });
  }

  onRippleControllingEvent(event) {
    var _me$listenerDetacher;

    const me = this;
    me.show();
    const rippleAnimation = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getStyleValue(me.circleElement, 'animationName');
    me.hide();
    (_me$listenerDetacher = me.listenerDetacher) === null || _me$listenerDetacher === void 0 ? void 0 : _me$listenerDetacher.call(me); // If our theme supports ripples, add our listeners

    if (rippleAnimation && rippleAnimation !== 'none') {
      me.listenerDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
        // Trap all mousedowns and see if the encapsulating Component is configured to ripple
        mousedown: {
          element: me.rootElement,
          capture: true,
          handler: 'onMousedown'
        },
        touchstart: {
          element: me.rootElement,
          capture: true,
          handler: 'onTouchStart'
        },
        // Hide at the end of the ripple
        animationend: {
          element: me.circleElement,
          handler: 'onAnimationEnd'
        },
        thisObj: me
      }); // If this is the first mousedown, start listening to theme changes and trigger ripple manually

      if (event.type === 'mousedown') {
        me.onMousedown(event);
        _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
          theme: 'onRippleControllingEvent',
          thisObj: this
        });
      }
    }
  }

  onTouchStart(event) {
    lastTouchTime = performance.now();
    this.handleTriggerEvent(event);
  }

  onMousedown(event) {
    // We need to prevent a touchend->mousedown simulated mousedown from triggering a ripple.
    // https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent
    if (performance.now() - lastTouchTime > 200) {
      this.handleTriggerEvent(event);
    }
  }

  handleTriggerEvent(event) {
    const targetWidget = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromElement(event.target, hasRipple);

    if (targetWidget) {
      const rippleCfg = targetWidget.ripple,
            target = rippleCfg.delegate ? event.target.closest(rippleCfg.delegate) : targetWidget.focusElement || targetWidget.element;

      if (target) {
        const ripple = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({
          event,
          target,
          radius: this.radius
        }, rippleCfg); // The clip option is specified as a string property name or delegate

        if (typeof ripple.clip === 'string') {
          ripple.clip = targetWidget[ripple.clip] || event.target.closest(ripple.clip); // Not inside an instance of the clip delegate, then no ripple

          if (!ripple.clip) {
            return;
          }
        }

        this.ripple(ripple);
      }
    }
  }

  ripple({
    event,
    point = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getClientPoint(event),
    target = event.target,
    clip = target,
    radius = this.radius,
    color = this.color
  }) {
    this.clip = clip;
    clip = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(clip, null, true);
    const me = this,
          centreDelta = clip.getDelta(point),
          rippleStyle = me.rippleElement.style,
          circleElement = me.circleElement,
          borderRadius = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getStyleValue(target, 'border-radius');
    me.hide();
    rippleStyle.transform = `translateX(${centreDelta[0]}px) translateY(${centreDelta[1]}px)`;
    rippleStyle.height = rippleStyle.width = `${radius}px`;
    me.element.style.borderRadius = borderRadius;
    circleElement.setAttribute('r', radius);
    circleElement.setAttribute('fill', color); // Show aligned center to center with our clipping region.

    me.showBy({
      target: clip,
      align: 'c-c',
      matchSize: true
    });
  } // When fully expanded, it's all over.


  onAnimationEnd(event) {
    if (event.animationName === 'b-ripple-expand') {
      this.hide();
    }
  }

}
_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].RippleClass = Ripple;
Ripple._$name = 'Ripple';

/***/ }),

/***/ "./lib/Core/widget/SlideToggle.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/SlideToggle.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SlideToggle; });
/* harmony import */ var _Checkbox_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Checkbox.js */ "./lib/Core/widget/Checkbox.js");
var productName = 'taskboard';

/**
 * @module Core/widget/SlideToggle
 */

/**
 * SlideToggle field is a variation of {@link Core.widget.Checkbox} with a sliding toggle instead of box with check mark.
 * It wraps <code>&lt;input type="checkbox"&gt;</code>.
 * Color can be specified and you can optionally configure {@link #config-text} to display in a label to the right of
 * the toggle in addition to a standard field {@link #config-label}.
 *
 * {@inlineexample Core/widget/SlideToggle.js vertical}
 *
 * This field can be used as an {@link Grid.column.Column#config-editor} for the {@link Grid.column.Column}.
 *
 * @extends Core/widget/Checkbox
 * @classType slidetoggle
 */

class SlideToggle extends _Checkbox_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'SlideToggle';
  }

  static get type() {
    return 'slidetoggle';
  }

  static get properties() {
    return {
      toggledCls: 'b-slidetoggle-checked'
    };
  }

  construct(config) {
    if (config !== null && config !== void 0 && config.checked) {
      config.cls = (config.cls || '') + ' ' + this.constructor.properties.toggledCls;
    }

    super.construct(config);
  }

  get innerElements() {
    const innerEls = super.innerElements;
    innerEls.splice(1, 0, this.toggleElement);

    if (this.text) {
      innerEls[innerEls.length - 1].class = 'b-slidetoggle-label';
    } else {
      // Remove label, not used
      innerEls.pop();
    }

    return innerEls;
  }

  get toggleElement() {
    return {
      class: 'b-slidetoggle-toggle',
      reference: 'slideToggle',
      children: [{
        class: 'b-slidetoggle-thumb',
        reference: 'slideThumb'
      }]
    };
  }

  internalOnChange() {
    super.internalOnChange();
    this.element.classList[this.value ? 'add' : 'remove'](this.toggledCls);
  }

}
SlideToggle.initClass();
SlideToggle._$name = 'SlideToggle';

/***/ }),

/***/ "./lib/Core/widget/Slider.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Slider.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Slider; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
var productName = 'taskboard';



/**
 * @module Core/widget/Slider
 */

/**
 * Wraps native &lt;input type="range"&gt;
 *
 * @extends Core/widget/Widget
 *
 * @example
 * let slider = new Slider({
 *   text: 'Choose value'
 * });
 *
 * @classType slider
 * @inlineexample Core/widget/Slider.js
 */

class Slider extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Slider';
  } // Factoryable type name


  static get type() {
    return 'slider';
  }

  static get configurable() {
    return {
      /**
       * Get/set text. Appends value if Slider.showValue is true
       * @member {String} text
       */

      /**
       * Slider label text
       * @config {String}
       */
      text: null,

      /**
       * Show value in label (appends in () if text is set)
       * @config {Boolean}
       * @default
       */
      showValue: true,

      /**
       * Show the slider value in a tooltip
       * @config {Boolean}
       * @default
       */
      showTooltip: false,

      /**
       * Get/set min value
       * @member {Number} min
       */

      /**
       * Minimum value
       * @config {Number}
       * @default
       */
      min: 0,

      /**
       * Get/set max value
       * @member {Number} max
       */

      /**
       * Maximum value
       * @config {Number}
       * @default
       */
      max: 100,

      /**
       * Get/set step size
       * @member {Number} step
       */

      /**
       * Step size
       * @config {Number}
       * @default
       */
      step: 1,

      /**
       * Get/set value
       * @member {Number} value
       */

      /**
       * Initial value
       * @config {Number}
       */
      value: 50,

      /**
       * Unit to display next to the value, when configured with `showValue : true`
       * @config {String}
       * @default
       */
      unit: null,
      // The value is set in the Light theme. The Material theme will have different value.
      thumbSize: 20,
      tooltip: {
        $config: ['lazy', 'nullify'],
        value: {
          type: 'tooltip',
          align: 'b-t',
          anchor: false,
          // No anchor displayed since thumbSize is different for different themes
          axisLock: true
        }
      },
      localizableProperties: ['text']
    };
  } //endregion
  //region Init


  compose() {
    const {
      id,
      min,
      max,
      showValue,
      step,
      text,
      value,
      unit = ''
    } = this,
          inputId = `${id}-input`,
          hasText = Boolean(text || showValue);
    return {
      class: {
        'b-has-label': hasText,
        'b-text': hasText
      },
      children: {
        input: {
          tag: 'input',
          type: 'range',
          id: inputId,
          reference: 'input',
          min,
          max,
          step,
          value,
          listeners: {
            input: 'onInternalInput',
            change: 'onInternalChange',
            mouseover: 'onInternalMouseOver',
            mouseout: 'onInternalMouseOut'
          }
        },
        label: {
          tag: 'label',
          for: inputId,
          html: showValue ? text ? `${text} (${value}${unit})` : value + unit : text
        }
      }
    };
  }

  get focusElement() {
    return this.input;
  }

  get percentProgress() {
    return (this.value - this.min) / (this.max - this.min) * 100;
  } //endregion
  //region Events

  /**
   * Fired while slider thumb is being dragged.
   * @event input
   * @param {Core.widget.Slider} source The slider
   * @param {String} value The value
   */

  /**
   * Fired after the slider value changes (on mouse up following slider interaction).
   * @event change
   * @param {String} value The value
   * @param {Boolean} userAction Triggered by user taking an action (`true`) or by setting a value (`false`)
   * @param {Core.widget.Slider} source The slider
   */

  /* break from doc comment */


  onInternalChange() {
    this.updateUI();
    this.triggerChange(true);
    this.trigger('action', {
      value: this.value
    });
  }

  onInternalInput() {
    this.value = parseInt(this.input.value, 10);
    this.trigger('input', {
      value: this.value
    });
  }

  onInternalMouseOver() {
    var _this$tooltip;

    (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 ? void 0 : _this$tooltip.showBy({
      target: _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_2__["default"].from(this.input).inflate(this.thumbSize / 2, -this.thumbSize / 2),
      align: `b-t${Math.round(this.percentProgress)}`
    });
  }

  onInternalMouseOut() {
    var _this$tooltip2;

    (_this$tooltip2 = this.tooltip) === null || _this$tooltip2 === void 0 ? void 0 : _this$tooltip2.hide();
  }

  triggerChange(userAction) {
    this.triggerFieldChange({
      value: this.value,
      valid: true,
      userAction
    });
  } //endregion
  //region Config Handling
  // max


  updateMax(max) {
    const me = this;

    if (me.input && me._value > max) {
      me.value = max;
      me.trigger('input', {
        value: me.value
      });
    }
  } // min


  updateMin(min) {
    const me = this;

    if (me.input && me._value < min) {
      me.value = min;
      me.trigger('input', {
        value: me.value
      });
    }
  } // tooltip


  changeTooltip(config, existingTooltip) {
    var _this$unit;

    if (config) {
      config.owner = this;
    }

    return this.showTooltip ? _Tooltip_js__WEBPACK_IMPORTED_MODULE_1__["default"].reconfigure(existingTooltip, config, {
      owner: this,
      defaults: {
        forElement: this.input,
        html: String(this.value) + ((_this$unit = this.unit) !== null && _this$unit !== void 0 ? _this$unit : '')
      }
    }) : null;
  }

  updateValue(value) {
    const me = this,
          {
      input,
      _tooltip
    } = me;

    if (_tooltip) {
      var _me$unit;

      _tooltip.html = me.value + ((_me$unit = me.unit) !== null && _me$unit !== void 0 ? _me$unit : '');
    }

    if (input && input.value !== String(value)) {
      input.value = value;
      me.triggerChange(false);
    }

    me.updateUI();
  } //endregion
  //region Util


  updateUI() {
    var _me$_tooltip, _me$_tooltip2;

    const me = this; // Don't measure the UI unless we need to

    ((_me$_tooltip = me._tooltip) === null || _me$_tooltip === void 0 ? void 0 : _me$_tooltip.isVisible) && ((_me$_tooltip2 = me._tooltip) === null || _me$_tooltip2 === void 0 ? void 0 : _me$_tooltip2.alignTo({
      target: _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_2__["default"].from(me.input).inflate(me.thumbSize / 2, -me.thumbSize / 2),
      align: `b-t${Math.round(me.percentProgress)}`
    }));
  } //endregion


} // Register this widget type with its Factory

Slider.initClass();
Slider._$name = 'Slider';

/***/ }),

/***/ "./lib/Core/widget/Splitter.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/Splitter.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Splitter; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';




/**
 * @module Core/widget/Splitter
 */

const classesHV = ['b-horizontal', 'b-vertical'],
      hasFlex = el => _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(el.parentElement, 'display') === 'flex' && (parseInt(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(el, 'flex-basis'), 10) || parseInt(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(el, 'flex-grow'), 10)),
      verticality = {
  horizontal: false,
  vertical: true
};
/**
 * A simple splitter widget that resizes the elements next to it or above/below it depending on orientation.
 *
 * @extends Core/widget/Widget
 * @classType splitter
 * @inlineexample Core/widget/Splitter.js
 */


class Splitter extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'Splitter';
  } // Factoryable type name


  static get type() {
    return 'splitter';
  }

  static get configurable() {
    return {
      /**
       * Splitter orientation, see {@link #config-orientation}. When set to 'auto' then actually used orientation
       * can be retrieved using {@link #property-currentOrientation}.
       * @member {String} orientation
       * @readonly
       */

      /**
       * The splitters orientation, configurable with 'auto', 'horizontal' or 'vertical'.
       *
       * 'auto' tries to determine the orientation by either checking the `flex-direction` of the parent element
       * or by comparing the positions of the closest sibling elements to the splitter. If they are above and
       * below 'horizontal' is used, if not it uses 'vertical'.
       *
       * ```
       * new Splitter({
       *    orientation : 'horizontal'
       * });
       * ```
       *
       * To receive the actually used orientation when configured with 'auto', see
       * {@link #property-currentOrientation}.
       *
       * @config {String}
       * @default
       */
      orientation: 'auto',
      vertical: null,
      containerElement: {
        $config: 'nullify',
        value: null
      },
      nextNeighbor: {
        $config: 'nullify',
        value: null
      },
      previousNeighbor: {
        $config: 'nullify',
        value: null
      }
    };
  }

  static get delayable() {
    return {
      syncState: 'raf'
    };
  } //endregion
  //region Init & destroy


  doDestroy() {
    var _this$mouseDetacher;

    (_this$mouseDetacher = this.mouseDetacher) === null || _this$mouseDetacher === void 0 ? void 0 : _this$mouseDetacher.call(this);
    super.doDestroy();
  } //endregion
  //region Template & element


  compose() {
    return {
      class: {
        'b-splitter': 1
      },
      listeners: _objectSpread({
        pointerdown: 'onMouseDown',
        mouseenter: 'syncState'
      }, !_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].supportsPointerEvents && {
        mousedown: 'onMouseDown',
        touchstart: 'onMouseDown'
      })
    };
  } //endregion
  //region Orientation

  /**
   * Get actually used orientation, which is either the configured value for `orientation` or if configured with
   * 'auto' the currently used orientation.
   * @property {String}
   * @readonly
   */


  get currentOrientation() {
    return this.vertical ? 'vertical' : 'horizontal';
  }

  get nextWidget() {
    return _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromElement(this.element.nextElementSibling, 1);
  }

  get previousWidget() {
    return _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].fromElement(this.element.previousElementSibling, 1);
  }

  updateContainerElement(containerElement) {
    var _me$stateDetector;

    const me = this;
    me.stateDetector = (_me$stateDetector = me.stateDetector) === null || _me$stateDetector === void 0 ? void 0 : _me$stateDetector.disconnect();

    if (containerElement) {
      me.stateDetector = new MutationObserver(() => me.syncState()); // syncState runs on next raf

      me.stateDetector.observe(containerElement, {
        attributes: true,
        // in case style changes flip our orientation (when == 'auto')
        childList: true // watch for our neighbors to render (so we can disable on hidden/collapsed state)

      });
    }
  }

  updateNextNeighbor(next) {
    this.watchNeighbor(next, 'next');
  }

  updatePreviousNeighbor(previous) {
    this.watchNeighbor(previous, 'previous');
  }

  watchNeighbor(neighbor, name) {
    this.detachListeners(name);
    neighbor === null || neighbor === void 0 ? void 0 : neighbor.on({
      name,
      thisObj: this,
      // beforeUpdateDisabled : 'syncState',  // ?
      collapse: 'syncState',
      expand: 'syncState',
      hide: 'syncState',
      show: 'syncState'
    });
  }

  updateOrientation() {
    this.syncState.now();
  }

  updateVertical(vertical) {
    var _this$element;

    const classList = (_this$element = this.element) === null || _this$element === void 0 ? void 0 : _this$element.classList;
    classList === null || classList === void 0 ? void 0 : classList.add(classesHV[vertical ? 1 : 0]);
    classList === null || classList === void 0 ? void 0 : classList.remove(classesHV[vertical ? 0 : 1]);
  }
  /**
   * Determine orientation when set to `'auto'` and detects neighboring widgets to monitor their hidden/collapsed
   * states.
   * @private
   */


  syncState() {
    var _verticality$me$orien;

    const me = this,
          {
      element,
      nextWidget,
      previousWidget
    } = me;
    let vertical = (_verticality$me$orien = verticality[me.orientation]) !== null && _verticality$me$orien !== void 0 ? _verticality$me$orien : null;
    me.nextNeighbor = nextWidget;
    me.previousNeighbor = previousWidget;
    me.disabled = nextWidget && (nextWidget.collapsible && nextWidget.collapsed || nextWidget.hidden) || previousWidget && (previousWidget.collapsible && previousWidget.collapsed || previousWidget.hidden);

    if (vertical !== null && nextWidget && previousWidget) {
      me.containerElement = null;
    } else {
      // we'll need to monitor parent element child list changes until our neighbors are added to the DOM
      me.containerElement = element.parentElement; // Orientation auto and already rendered, determine orientation to use

      if (me.rendered && element.offsetParent) {
        const flexDirection = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getStyleValue(element.parentElement, 'flex-direction'); // If used in a flex layout, determine orientation from flex-direction

        if (flexDirection) {
          vertical = !flexDirection.startsWith('column');
        } // If used in some other layout, try to determine from sibling elements position
        else {
          const previous = element.previousElementSibling,
                next = element.nextElementSibling;

          if (!previous || !next) {
            // To early in rendering, next sibling not rendered yet
            return;
          }

          const prevRect = previous.getBoundingClientRect(),
                nextRect = next.getBoundingClientRect(),
                topMost = prevRect.top < nextRect.top ? prevRect : nextRect,
                bottomMost = topMost === nextRect ? prevRect : nextRect; // orientation = topMost.top !== bottomMost.top ? 'horizontal' : 'vertical';

          vertical = topMost.top === bottomMost.top;
        }
      }
    }

    me.vertical = vertical;
  } //endregion
  //region Events


  onMouseDown(event) {
    event.preventDefault();

    if (event.touches) {
      event = event.touches[0];
    }

    const me = this,
          {
      element
    } = me,
          prev = element.previousElementSibling,
          next = element.nextElementSibling,
          prevHasFlex = hasFlex(prev),
          nextHasFlex = hasFlex(next),
          flexed = []; // First stop any ongoing drag operation, since we cannot trust that we always get the mouseup event

    me.mouseDetacher && me.mouseDetacher(); // Remember flexed children, to enable maintaining their proportions on resize

    for (const child of element.parentElement.children) {
      if (hasFlex(child) && child !== element) {
        flexed.push({
          element: child,
          width: child.offsetWidth,
          height: child.offsetHeight
        });
      }
    }

    me.context = {
      startX: event.pageX,
      startY: event.pageY,
      prevWidth: prev.offsetWidth,
      prevHeight: prev.offsetHeight,
      nextWidth: next.offsetWidth,
      nextHeight: next.offsetHeight,
      prevHasFlex,
      nextHasFlex,
      flexed,
      prev,
      next
    };
    const events = {
      element: document,
      pointermove: 'onMouseMove',
      pointerup: 'onMouseUp',
      thisObj: me
    };

    if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].supportsPointerEvents) {
      events.mousemove = 'onMouseMove';
      events.touchmove = 'onMouseMove';
      events.mouseup = events.touchend = 'onMouseUp';
    }

    me.mouseDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on(events);
  }

  onMouseMove(event) {
    const me = this,
          {
      context,
      nextWidget,
      previousWidget
    } = me,
          {
      next,
      prev
    } = context,
          deltaX = event.pageX - context.startX,
          deltaY = event.pageY - context.startY;
    event.preventDefault();
    Object.assign(context, {
      deltaX,
      deltaY
    });

    if (!context.started) {
      context.started = true;
      me.trigger('start', {
        context,
        event
      }); // Convert heights/widths to flex for flexed elements to maintain proportions
      // 100px high -> flex-grow 100

      context.flexed.forEach(flexed => {
        flexed.element.style.flexGrow = me.vertical ? flexed.width : flexed.height; //Remove flex-basis, since it interferes with resizing

        flexed.element.style.flexBasis = '0';
      });
    } // Adjust flex-grow or width/height for splitters closest siblings


    if (me.vertical) {
      const newPrevWidth = context.prevWidth + deltaX,
            newNextWidth = context.nextWidth - deltaX;

      if (context.prevHasFlex) {
        prev.style.flexGrow = newPrevWidth;
      } else if (previousWidget) {
        previousWidget.width = newPrevWidth;
      } else {
        prev.style.width = `${newPrevWidth}px`;
      }

      if (context.nextHasFlex) {
        next.style.flexGrow = newNextWidth;
      } else if (nextWidget) {
        nextWidget.width = newNextWidth;
      } else {
        next.style.width = `${newNextWidth}px`;
      }
    } else {
      const newPrevHeight = context.prevHeight + deltaY,
            newNextHeight = context.nextHeight - deltaY;

      if (context.prevHasFlex) {
        prev.style.flexGrow = newPrevHeight;
      } else if (previousWidget) {
        previousWidget.height = newPrevHeight;
      } else {
        prev.style.height = `${newPrevHeight}px`;
      }

      if (context.nextHasFlex) {
        next.style.flexGrow = newNextHeight;
      } else if (nextWidget) {
        nextWidget.height = newNextHeight;
      } else {
        next.style.height = `${newNextHeight}px`;
      }
    }

    me.trigger('move', {
      context,
      event
    });
  }

  onMouseUp(event) {
    const me = this;
    me.mouseDetacher && me.mouseDetacher();
    me.mouseDetacher = null;

    if (me.context.started) {
      me.trigger('end', {
        context: me.context,
        event
      });
    }

    me.context = null;
  } //endregion


  render() {
    super.render(...arguments);
    this.syncState.now();

    if (this.vertical === null) {
      this.syncState(); // try again on next raf
    }
  }

} // Register this widget type with its Factory

Splitter.initClass();
Splitter._$name = 'Splitter';

/***/ }),

/***/ "./lib/Core/widget/Tab.js":
/*!********************************!*\
  !*** ./lib/Core/widget/Tab.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Tab; });
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



/**
 * @module Core/widget/Tab
 */

/**
 * This widget class is used to present items in a {@link Core.widget.TabPanel} on its {@link Core.widget.TabBar tabBar}.
 * A reference to this widget is stored via the {@link Core.widget.Widget#config-tab} config on the tab panel's items.
 *
 * ```javascript
 * let tabPanel = new TabPanel({
 *  items: [
 *      {
 *          title: 'Settings',
 *          // Tab configs
 *          tab : {
 *              // Show an icon in the tab
 *              icon : 'b-fa b-fa-cog'
 *          },
 *          items: [
 *              ...
 *          ]
 *      }
 *  ]
 * });
 * ```
 * @extends Core/widget/Button
 * @classType tab
 */

class Tab extends _Button_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
  //region Config
  static get $name() {
    return 'Tab';
  } // Factoryable type name


  static get type() {
    return 'tab';
  }

  static get configurable() {
    return {
      /**
       * This config is set to `true` when this tab represents the `activeTab` of a {@link Core.widget.TabPanel}. It
       * is managed by the tab panel is not set directly.
       * @config {Boolean} active
       * @default false
       */
      active: null,

      /**
       * This config is set to the ordinal position of this tab in the {@link Core.widget.TabPanel}. It is managed
       * by the tab panel is not set directly.
       * @config {Number} index
       */
      index: null,

      /**
       * This config is set to `true` when this tab represents the first tab of a {@link Core.widget.TabPanel}. It
       * is managed by the tab panel is not set directly.
       * @config {Boolean} isFirst
       */
      isFirst: null,

      /**
       * This config is set to `true` when this tab represents the last tab of a {@link Core.widget.TabPanel}. It
       * is managed by the tab panel is not set directly.
       * @config {Boolean} isLast
       */
      isLast: null,

      /**
       * The {@link Core.widget.Widget} in the {@link Core.widget.TabPanel} corresponding to this tab. This is
       * managed by the tab panel is not set directly.
       * @config {Core.widget.Widget} item
       */
      item: {
        value: null,
        $config: 'nullify'
      },
      itemCls: null,

      /**
       * The tab panel that owns this tab.
       * @config {Core.widget.TabPanel} tabPanel
       */
      tabPanel: null,

      /**
       * The config property on this tab that will be set to the value of the {@link #config-titleSource} property
       * of this tab's {@link #config-item}.
       *
       * By default, the {@link #config-text} property of the tab is set to the {@link Core.widget.Widget#config-title}
       * property of its {@link #config-item}.
       * @config {String} titleProperty
       * @default
       */
      titleProperty: 'text',

      /**
       * The config property on this tab's {@link #config-item} that is used to set the value of the
       * {@link #config-titleProperty} of this tab.
       *
       * By default, the {@link #config-text} property of the tab is set to the {@link Core.widget.Widget#config-title}
       * property of its {@link #config-item}.
       * @config {String} titleSource
       * @default
       */
      titleSource: 'title'
    };
  }

  compose() {
    const {
      active,
      cls,
      index,
      isFirst,
      isLast
    } = this;
    return {
      tabindex: -1,
      class: _objectSpread({
        'b-tabpanel-tab': 1,
        'b-active': active,
        'b-tab-first': isFirst,
        'b-tab-last': isLast
      }, cls),
      dataset: {
        index
      }
    };
  } //endregion


  updateIndex(index) {
    this.isFirst = !index;
  }

  updateItem(item, was) {
    var _me$itemChangeDetache, _me$itemHideDetacher;

    const me = this;

    if ((was === null || was === void 0 ? void 0 : was.tab) === me) {
      was.tab = null;
    }

    if (item) {
      item.tab = me;
      me[me.titleProperty] = item[me.titleSource];
      me.itemCls = item.cls;
    }

    (_me$itemChangeDetache = me.itemChangeDetacher) === null || _me$itemChangeDetache === void 0 ? void 0 : _me$itemChangeDetache.call(me);
    me.itemChangeDetacher = item && _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].after(item, 'onConfigChange', 'onItemConfigChange', me, {
      return: false
    });
    (_me$itemHideDetacher = me.itemHideDetacher) === null || _me$itemHideDetacher === void 0 ? void 0 : _me$itemHideDetacher.call(me);
    me.itemHideDetacher = item === null || item === void 0 ? void 0 : item.on({
      beforeChangeHidden: 'onItemBeforeChangeHidden',
      beforeHide: 'onItemBeforeHide',
      beforeUpdateDisabled: 'onItemBeforeUpdateDisabled',
      thisObj: me,
      prio: 1000 // We must know before the layout intercepts and activates a sibling

    });
    me.syncMinMax();
  }

  updateItemCls(cls, was) {
    const {
      element
    } = this,
          classList = element && _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_0__["default"].from(element === null || element === void 0 ? void 0 : element.classList,
    /* returnEmpty= */
    true);

    if (element) {
      classList.remove(was).add(cls);
      element.className = classList.value;
    }
  }

  updateRotate(rotate, was) {
    if (!rotate !== !was) {
      this.syncMinMax();
    }
  }

  syncMinMax() {
    const me = this,
          {
      rotate,
      tabPanel
    } = me; // We have to read the configs directly since there are getters that read the DOM styles:

    let {
      _minWidth: minWidth,
      _minHeight: minHeight,
      _maxWidth: maxWidth,
      _maxHeight: maxHeight
    } = me; // When a tab rotation changes, we need to pivot the min/max width values with the height values

    if (tabPanel) {
      const {
        tabMinWidth,
        tabMaxWidth
      } = tabPanel;

      if (tabMinWidth != null) {
        if (rotate) {
          // if we were previously not rotated, the tabMinWidth may be effecting our minWidth:
          if (minWidth === tabMinWidth) {
            minWidth = null;
          } // noinspection JSSuspiciousNameCombination


          minHeight = tabMinWidth;
        } else {
          // if we were previously rotated, the tabMinWidth may be effecting our minHeight:
          if (minHeight === tabMinWidth) {
            minHeight = null;
          }

          minWidth = tabMinWidth;
        }
      }

      if (tabMaxWidth != null) {
        if (rotate) {
          if (maxWidth === tabMaxWidth) {
            maxWidth = null;
          } // noinspection JSSuspiciousNameCombination


          maxHeight = tabMaxWidth;
        } else {
          if (maxHeight === tabMaxWidth) {
            maxHeight = null;
          }

          maxWidth = tabMaxWidth;
        }
      }

      me.minWidth = minWidth;
      me.minHeight = minHeight;
      me.maxWidth = maxWidth;
      me.maxHeight = maxHeight;
    }
  }

  onItemBeforeChangeHidden({
    source: hidingChild,
    hidden
  }) {
    // If it's a hide/show that is not part of the layout's deactivating/activating, we must hide/show the tab
    if (!hidingChild.$isDeactivating && !hidingChild.$isActivating) {
      const {
        tabPanel
      } = this;
      this.hidden = hidden; // if tab to hide is active, let's active previous visible and enabled tab

      if (hidden && hidingChild === tabPanel.activeItem) {
        tabPanel.activateAvailableTab(hidingChild);
      }
    }
  }

  onItemBeforeHide() {
    // If it's a hide that is not part of the layout's deactivating, we hide the tab
    if (!this.item.$isDeactivating) {
      this.hide();
    }
  }

  onItemBeforeUpdateDisabled({
    source: disablingChild,
    disabled
  }) {
    const {
      tabPanel
    } = this;
    this.disabled = disabled; // if tab to disable is active, let's active previous visible and enabled tab

    if (disablingChild === tabPanel.activeItem) {
      tabPanel.activateAvailableTab(disablingChild);
    }
  }

  onItemConfigChange({
    name,
    value
  }) {
    if (name === this.titleSource) {
      this[this.titleProperty] = value;
    }
  }

} // Register this widget type with its Factory

Tab.initClass();
Tab._$name = 'Tab';

/***/ }),

/***/ "./lib/Core/widget/TabBar.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/TabBar.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TabBar; });
/* harmony import */ var _Toolbar_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Toolbar.js */ "./lib/Core/widget/Toolbar.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _Tab_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Tab.js */ "./lib/Core/widget/Tab.js");
var productName = 'taskboard';



/**
 * @module Core/widget/TabBar
 */

const isTab = t => t.isTab;
/**
 * A special toolbar used by {@link Core.widget.TabPanel} to present {@link Core.widget.Tab tabs} for the container's
 * items.
 *
 * The {@link Core.widget.Container#config-items} of a tab bar are typically managed by the tab panel, however,
 * items can be added that do not correspond to items in the tab panel. The {@link Core.widget.Widget#config-weight}
 * config of each tab defaults to 0 or the weight of its corresponding item.
 *
 * @extends Core/widget/Toolbar
 * @classType tabbar
 */


class TabBar extends _Toolbar_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'TabBar';
  } // Factoryable type name


  static get type() {
    return 'tabbar';
  }

  static get configurable() {
    return {
      defaultType: 'tab',
      overflow: 'scroll'
    };
  }

  get firstTab() {
    return this.tabAt(0);
  }

  get lastTab() {
    return this.tabAt(-1);
  }

  get tabCount() {
    return this._items.countOf(isTab);
  }

  get tabs() {
    return _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(this._items, isTab);
  }

  compose() {
    return {
      children: {
        toolbarContent: {
          class: {
            'b-tabpanel-tabs': 1
          }
        }
      }
    };
  }

  indexOfTab(tab) {
    return this._items.indexOf(tab, isTab);
  }

  onChildAdd(child) {
    super.onChildAdd(child);

    if (child.index == null) {
      this.syncTabs();
    }
  }

  onChildRemove(child) {
    super.onChildRemove(child);
    this.syncTabs();
  }

  syncTabs() {
    const {
      tabs
    } = this;

    for (let i = 0, n = tabs.length; i < n; ++i) {
      tabs[i].index = i;
      tabs[i].isFirst = !i;
      tabs[i].isLast = i === n - 1;
    }
  }

  tabAt(index) {
    return this._items.find(isTab, index) || null;
  }

} // Register this widget type with its Factory

TabBar.initClass();
TabBar._$name = 'TabBar';

/***/ }),

/***/ "./lib/Core/widget/TabPanel.js":
/*!*************************************!*\
  !*** ./lib/Core/widget/TabPanel.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TabPanel; });
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Panel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony import */ var _Tab_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Tab.js */ "./lib/Core/widget/Tab.js");
/* harmony import */ var _TabBar_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TabBar.js */ "./lib/Core/widget/TabBar.js");
/* harmony import */ var _layout_Card_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./layout/Card.js */ "./lib/Core/widget/layout/Card.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
var productName = 'taskboard';







/**
 * @module Core/widget/TabPanel
 */

/**
 * A tab panel widget which displays a collection of tabs, each of which can contain other widgets (or simple HTML). This
 * widget has a {@link Core.widget.TabBar tab bar} on top of its contents, and each {@link Core.widget.Tab tab} can be
 * customized using the {@link Core.widget.Tab#config-tab} config.
 *
 * @extends Core/widget/Container
 * @example
 * let tabPanel = new TabPanel({
 *  items: [
 *      {
 *          title: 'First',
 *          items: [
 *              { type: 'textfield', label: 'Name' },
 *              ...
 *          ]
 *      }, {
 *          title: 'Settings',
 *          tab : {
 *              // Show an icon in the tab
 *              icon : 'b-fa b-fa-cog'
 *          },
 *          items: [
 *              ...
 *          ]
 *      }
 *  ]
 * });
 *
 * @classType tabpanel
 * @inlineexample Core/widget/TabPanel.js
 */

class TabPanel extends _Panel_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
  //region Config
  static get $name() {
    return 'TabPanel';
  } // Factoryable type name


  static get type() {
    return 'tabpanel';
  } // Factoryable type alias


  static get alias() {
    return 'tabs';
  }

  static get configurable() {
    return {
      /**
       * The index of the initially active tab.
       * @member {Number} activeTab
       */

      /**
       * The index of the initially active tab.
       * @config {Number}
       * @default
       */
      activeTab: 0,

      /**
       * Specifies whether to slide tabs in and out of visibility.
       * @config {Boolean}
       * @default
       */
      animateTabChange: true,

      /**
       * Set the height of all tabs to match the tab with the highest content.
       * @config {Boolean}
       * @default
       */
      autoHeight: false,
      defaultType: 'container',
      itemCls: 'b-tabpanel-item',
      layout: {
        type: 'card'
      },
      // Prevent child panels from displaying a header unless explicitly configured with one
      suppressChildHeaders: true,
      tabBar: {
        type: 'tabbar',
        weight: -2000
      },

      /**
       * Min width of a tab title. 0 means no minimum width. This is default.
       * @config {Number}
       * @default
       */
      tabMinWidth: null,

      /**
       * Max width of a tab title. 0 means no maximum width. This is default.
       * @config {Number}
       * @default
       */
      tabMaxWidth: null
    };
  } //endregion
  //region Init

  /**
   * The active tab index. Setting must be done through {@link #property-activeTab}
   * @property {Number}
   * @readonly
   */


  get activeIndex() {
    return this.layout.activeIndex;
  }
  /**
   * The active child widget. Setting must be done through {@link #property-activeTab}
   * @property {Core.widget.Widget}
   * @readonly
   */


  get activeItem() {
    return this.layout.activeItem;
  }

  get activeTabItemIndex() {
    var _tabBar$tabs$activeTa;

    const {
      activeTab,
      items,
      tabBar
    } = this;
    return items.indexOf((_tabBar$tabs$activeTa = tabBar.tabs[activeTab]) === null || _tabBar$tabs$activeTa === void 0 ? void 0 : _tabBar$tabs$activeTa.item);
  }

  get bodyConfig() {
    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge({
      className: {
        'b-tabpanel-body': 1
      }
    }, super.bodyConfig);
  }

  get focusElement() {
    var _activeTab$tab;

    const activeTab = this.items[this.activeTab || 0];
    return (activeTab === null || activeTab === void 0 ? void 0 : activeTab.focusElement) || (activeTab === null || activeTab === void 0 ? void 0 : (_activeTab$tab = activeTab.tab) === null || _activeTab$tab === void 0 ? void 0 : _activeTab$tab.focusElement);
  }

  get tabPanelBody() {
    return this.bodyElement;
  }

  finalizeInit() {
    super.finalizeInit();
    const me = this,
          {
      activeTab,
      layout
    } = me,
          tabs = me.tabBar.tabs;

    if (activeTab >= 0 && activeTab < tabs.length) {
      layout.activeIndex = me.items.indexOf(tabs[activeTab].item);
    } else {
      throw new Error(`Invalid activeTab ${activeTab} (${tabs.length} tabs)`);
    }

    layout.animateCardChange = me.animateTabChange;
  }

  onChildAdd(child) {
    // The layout will hide inactive new items.
    // And we must add our beforeHide listener *after* call super.
    super.onChildAdd(child);

    if (!this.initialItems) {
      const me = this,
            {
        tabBar
      } = me,
            config = me.makeTabConfig(child),
            // if child.tab === false, config will be null... no tab for this one
      firstTab = config && tabBar.firstTab,
            // if there are no tabs yet, this will be the first so we can skip all the indexing...
      tabBarItems = firstTab && tabBar._items,
            // not all items have tabs but the new child won't have one yet:
      tabItems = firstTab && _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].from(me._items, it => it.tab || it === child),
            // non-tabs could be in the tabBar, but the tabs must be contiguous:
      index = firstTab ? tabItems.indexOf(child) + tabBarItems.indexOf(firstTab) : 0;

      if (config) {
        if (firstTab && child.weight == null && index < tabBarItems.count - 1) {
          tabBar.insert(config, index);
        } else {
          tabBar.add(config);
        }
      }
    }
  }

  onChildRemove(child) {
    var _child$tab, _child$tab$destroy;

    (_child$tab = child.tab) === null || _child$tab === void 0 ? void 0 : (_child$tab$destroy = _child$tab.destroy) === null || _child$tab$destroy === void 0 ? void 0 : _child$tab$destroy.call(_child$tab); // tab can be false... so child.tab?.destroy() is not enough

    super.onChildRemove(child);
  } //endregion
  //region Tabs


  isDisabledOrHiddenTab(tabIndex) {
    const {
      tabs
    } = this.tabBar,
          tab = tabs === null || tabs === void 0 ? void 0 : tabs[tabIndex];
    return tab && (tab.disabled || tab.hidden);
  }

  findAvailableTab(item, delta = 1) {
    const {
      tabs
    } = this.tabBar,
          tabCount = tabs.length,
          itemIndex = Math.max(0, tabs.indexOf(item.tab));

    if (itemIndex) {
      delta = -delta;
    }

    let activeTab;

    for (let n = 1; n <= tabCount; ++n) {
      //  itemIndex=2, tabCount=5:
      //               n : 1, 2, 3, 4, 5
      //      delta =  1 : 3, 4, 0, 1, 2
      //      delta = -1 : 1, 0, 4, 3, 2
      activeTab = (itemIndex + (delta < 0 ? tabCount : 0) + n * delta) % tabCount;

      if (!this.isDisabledOrHiddenTab(activeTab)) {
        break;
      }
    }

    return activeTab;
  }

  activateAvailableTab(item, delta = 1) {
    this.activeTab = this.findAvailableTab(item, delta);
  }

  changeActiveTab(activeTab) {
    const me = this,
          {
      tabBar
    } = me,
          {
      tabCount
    } = tabBar;

    if (activeTab.isWidget || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isObject(activeTab)) {
      // Must be a child widget, so add if it's not already in our items.
      if (me.items.indexOf(activeTab) === -1) {
        activeTab = me.add(activeTab);
      }

      activeTab = tabBar.indexOfTab(activeTab.tab);
    } else {
      activeTab = parseInt(activeTab, 10);
    }

    if (!me.initialItems && (activeTab < -1 || activeTab >= tabCount)) {
      throw new Error(`Invalid activeTab ${activeTab} (${tabCount} tabs)`);
    }

    if (me.isDisabledOrHiddenTab(activeTab)) {
      activeTab = me.findAvailableTab(activeTab);
    }

    return activeTab;
  }

  updateActiveTab() {
    if (!this.initialItems) {
      const {
        activeTabItemIndex
      } = this;

      if (activeTabItemIndex > -1) {
        this.layout.activeIndex = activeTabItemIndex;
      }
    }
  }

  changeTabBar(bar) {
    this.getConfig('strips');
    this.strips = {
      tabBar: bar
    };
    return this.strips.tabBar;
  }

  makeTabConfig(item) {
    const {
      tab
    } = item,
          config = {
      item,
      type: 'tab',
      tabPanel: this,
      disabled: Boolean(item.disabled),
      hidden: item.initialConfig.hidden,
      weight: item.weight || 0,
      listeners: {
        click: 'onTabClick',
        thisObj: this
      },
      localizableProperties: {
        // our tabs copy their text from the item's title and so are not directly localized
        text: false
      }
    };

    if (tab === false) {
      return null;
    }

    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isObject(tab) ? _Tab_js__WEBPACK_IMPORTED_MODULE_3__["default"].mergeConfigs(config, tab) : config;
  }

  updateItems(items, was) {
    const me = this,
          {
      activeTab,
      initialItems
    } = me;
    let index = 0,
        tabs;
    super.updateItems(items, was);

    if (initialItems) {
      tabs = Array.from(items, it => me.makeTabConfig(it)).filter(it => {
        if (it) {
          it.index = index++;
          return true;
        }
      });

      if (index) {
        tabs[0].isFirst = true;
        tabs[index - 1].isLast = true;
        tabs[activeTab].active = true;
        me.tabBar.add(tabs);
        me.activeTab = activeTab; // now we can validate the activeTab value
      }
    }
  }

  updateTabMinWidth(tabMinWidth) {
    var _this$tabBar;

    (_this$tabBar = this.tabBar) === null || _this$tabBar === void 0 ? void 0 : _this$tabBar.items.forEach(tab => {
      if (tab.isTab) {
        tab.minWidth = tabMinWidth;
      }
    });
  }

  updateTabMaxWidth(tabMaxWidth) {
    var _this$tabBar2;

    (_this$tabBar2 = this.tabBar) === null || _this$tabBar2 === void 0 ? void 0 : _this$tabBar2.items.forEach(tab => {
      if (tab.isTab) {
        tab.maxWidth = tabMaxWidth;
      }
    });
  } //endregion
  //region Auto height


  updateAutoHeight(autoHeight) {
    this.detachListeners('themeAutoHeight');
    autoHeight && _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__["default"].on({
      name: 'themeAutoHeight',
      theme: 'internalOnThemeChange',
      thisObj: this
    });
    this.$measureHeight = autoHeight;
  }

  applyAutoHeight() {
    const me = this,
          {
      layout,
      activeTab,
      element
    } = me,
          {
      animateCardChange
    } = layout; // stop animate to change tabs on back stage.

    layout.animateCardChange = false; // override any previously applied height when measuring

    me.height = null; // get the max height comparing all tabs and apply to the tab

    me.height = Math.max(...me.items.map(tab => {
      me.activeTab = tab;
      return element.clientHeight;
    })) + 1; // Go back to initial configs

    me.activeTab = activeTab;
    layout.animateCardChange = animateCardChange;
    me.$measureHeight = false;
  }

  internalOnThemeChange() {
    if (this.isVisible) {
      this.applyAutoHeight();
    } else {
      this.$measureHeight = true;
    }
  } //endregion
  //region Events
  // Called after beforeActiveItemChange has fired and not been vetoed before animation and activeItemChange


  onBeginActiveItemChange(activeItemChangeEvent) {
    const tabs = this.tabBar.tabs,
          {
      activeItem,
      prevActiveItem
    } = activeItemChangeEvent; // Our UI changes immediately, our state must be accurate

    this.activeTab = tabs.indexOf(activeItem === null || activeItem === void 0 ? void 0 : activeItem.tab); // Deactivate previous active tab

    if (prevActiveItem !== null && prevActiveItem !== void 0 && prevActiveItem.tab) {
      prevActiveItem.tab.active = false;
    }

    if (activeItem !== null && activeItem !== void 0 && activeItem.tab) {
      activeItem.tab.active = true;
      activeItem.tab.show();
    }
  } // Auto called because Card layout triggers the beforeActiveItemChange on its owner


  onBeforeActiveItemChange(activeItemChangeEvent) {
    /**
     * The active tab is about to be changed. Return `false` to prevent this.
     * @event beforeTabChange
     * @preventable
     * @param {Number} activeIndex - The new active index.
     * @param {Core.widget.Widget} activeItem - The new active child widget.
     * @param {Number} prevActiveIndex - The previous active index.
     * @param {Core.widget.Widget} prevActiveItem - The previous active child widget.
     */
    return this.trigger('beforeTabChange', activeItemChangeEvent);
  } // Auto called because Card layout triggers the activeItemChange on its owner


  onActiveItemChange(activeItemChangeEvent) {
    /**
     * The active tab has changed.
     * @event tabChange
     * @param {Number} activeIndex - The new active index.
     * @param {Core.widget.Widget} activeItem - The new active child widget.
     * @param {Number} prevActiveIndex - The previous active index.
     * @param {Core.widget.Widget} prevActiveItem - The previous active child widget.
     */
    this.trigger('tabChange', activeItemChangeEvent);
  }

  onTabClick(event) {
    this.activeTab = event.source.item;
  }

  onPaint() {
    super.onPaint(...arguments); // Measure tabs on first paint if configured to do so

    if (this.$measureHeight) {
      this.applyAutoHeight();
    }
  } //endregion


} // Register this widget type with its Factory

TabPanel.initClass();
TabPanel._$name = 'TabPanel';

/***/ }),

/***/ "./lib/Core/widget/TextAreaField.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/TextAreaField.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextAreaField; });
/* harmony import */ var _PickerField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
var productName = 'taskboard';



/**
 * @module Core/widget/TextAreaField
 */

/**
 * TextAreaField widget for multiline text input. Wraps a native &lt;textarea&gt;
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 *
 * @extends Core/widget/Field
 *
 * @example
 * let textAreaField = new TextAreaField({
 *   placeholder: 'Enter some text'
 * });
 *
 * @classType textareafield
 * @inlineexample Core/widget/TextAreaField.js
 */

class TextAreaField extends _PickerField_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'TextAreaField';
  } // Factoryable type name


  static get type() {
    return 'textareafield';
  } // Factoryable type alias


  static get alias() {
    return 'textarea';
  }

  static get configurable() {
    return {
      picker: {
        type: 'widget',
        cls: 'b-textareafield-picker',
        floating: true,
        scrollAction: 'realign',
        align: {
          align: 't-b',
          axisLock: true
        },
        autoShow: false
      },
      triggers: null,
      // Override PickerField. We don't have a trigger by default

      /**
       * Configure as `false` to have the field render as a non-editable picker field which
       * shows a `<textarea>` input when expanded.
       * @config {Boolean}
       * @default
       */
      inline: true,

      /**
       * The resize style to apply to the `<textarea>` element.
       * @config {String}
       * @default
       */
      resize: 'none',
      inputType: null
    };
  }

  startConfigure(config) {
    // Read the inline config which will force evaluation of triggers.
    this.getConfig('inline');
    super.startConfigure(config);
  }

  get inputElement() {
    const result = super.inputElement,
          {
      inline,
      resize
    } = this;

    if (inline) {
      result.tag = 'textarea';
      result.style = (result.style || '') + `;resize:${resize}`;
    } else {
      result.readOnly = 'readonly';
      result.reference = 'displayElement';
    }

    return result;
  }

  get focusElement() {
    return this.inline || this._picker && this._picker.isVisible ? this.input : this.displayElement;
  }

  showPicker() {
    const me = this,
          {
      picker
    } = me; // Block picker if inline

    if (!me.inline) {
      picker.width = me.pickerWidth || me[me.pickerAlignElement].offsetWidth; // Always focus the picker.

      super.showPicker(true);
    }
  }

  focusPicker() {
    this.input.focus();
  }

  onPickerKeyDown(keyEvent) {
    const me = this,
          realInput = me.input;

    switch (keyEvent.key.trim() || keyEvent.code) {
      case 'Escape':
        // TODO: revert value?
        me.picker.hide();
        return;

      case 'Enter':
        if (keyEvent.ctrlKey) {
          me.syncInputFieldValue();
          me.picker.hide();
        }

        break;
    } // Super's onPickerKeyDown fires through this.input, so avoid infinite recursion
    // by redirecting it through the displayElement.


    me.input = me.displayElement;
    const result = super.onPickerKeyDown(keyEvent);
    me.input = realInput;
    return result;
  }

  syncInputFieldValue(skipHighlight) {
    if (this.displayElement) {
      this.displayElement.value = this.inputValue;
    }

    super.syncInputFieldValue(skipHighlight);
  }

  changeValue(value) {
    return value == null ? '' : value;
  }

  updateInline(inline) {
    if (!inline && !this.triggers) {
      this.triggers = {};
    }
  }

  changeTriggers(triggers, was) {
    if (!this.inline) {
      (triggers || (triggers = {})).expand = {
        cls: 'b-icon-picker',
        handler: 'onTriggerClick'
      };
    }

    return super.changeTriggers(triggers, was);
  }

  changePicker(picker, oldPicker) {
    var _picker;

    const me = this,
          pickerWidth = me.pickerWidth || ((_picker = picker) === null || _picker === void 0 ? void 0 : _picker.width);
    picker = TextAreaField.reconfigure(oldPicker, picker ? _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge({
      owner: me,
      forElement: me[me.pickerAlignElement],
      align: {
        matchSize: pickerWidth == null,
        anchor: me.overlayAnchor,
        target: me[me.pickerAlignElement]
      },
      html: `<textarea id="${me.id + '-input'}" style="resize:${me.resize}">${me.value}</textarea>`
    }, picker) : null, me); // May have been set to null (destroyed)

    if (picker) {
      const input = me.input = picker.element.querySelector(`#${me.id}-input`);
      me.inputListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
        element: input,
        thisObj: me,
        focus: 'internalOnInputFocus',
        change: 'internalOnChange',
        input: 'internalOnInput',
        keydown: 'internalOnKeyEvent',
        keypress: 'internalOnKeyEvent',
        keyup: 'internalOnKeyEvent'
      });
    }

    return picker;
  }

} // Register this widget type with its Factory

TextAreaField.initClass();
TextAreaField._$name = 'TextAreaField';

/***/ }),

/***/ "./lib/Core/widget/TextField.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/TextField.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextField; });
/* harmony import */ var _Field_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Field.js */ "./lib/Core/widget/Field.js");
var productName = 'taskboard';
 //TODO: label should be own element

/**
 * @module Core/widget/TextField
 */

/**
 * Textfield widget. Wraps native &lt;input type="text"&gt;
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the {@link Grid.column.Column Column}, {@link Grid.column.TemplateColumn TemplateColumn},
 * {@link Grid.column.TreeColumn TreeColumn}, and for other columns if another editor is not specified explicitly,
 * or disabled by setting `false` value.
 *
 * @extends Core/widget/Field
 *
 * @example
 * let textField = new TextField({
 *   placeholder: 'Enter some text'
 * });
 *
 * @classType textfield
 * @inlineexample Core/widget/TextField.js
 */

class TextField extends _Field_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // Factoryable type name
  static get type() {
    return 'textfield';
  } // Factoryable type alias


  static get alias() {
    return 'text';
  }

  static get configurable() {
    return {
      /**
       * The tab index of the input field
       * @config {Number} tabIndex
       * @category Input element
       */

      /**
       * The min number of characters for the input field
       * @config {Number} minLength
       * @category Field
       */

      /**
       * The max number of characters for the input field
       * @config {Number} maxLength
       * @category Field
       */
      nullValue: ''
    };
  }

  static get $name() {
    return 'TextField';
  }

  construct(config) {
    if ((config === null || config === void 0 ? void 0 : config.inputType) === 'hidden') {
      config.hidden = true;
    }

    super.construct(...arguments);
  }

} // Register this widget type with its Factory

TextField.initClass();
TextField._$name = 'TextField';

/***/ }),

/***/ "./lib/Core/widget/TimeField.js":
/*!**************************************!*\
  !*** ./lib/Core/widget/TimeField.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeField; });
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _PickerField_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony import */ var _TimePicker_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TimePicker.js */ "./lib/Core/widget/TimePicker.js");
var productName = 'taskboard'; //TODO: picker icon (clock) should be clock that shows actual time




/**
 * @module Core/widget/TimeField
 */

/**
 * The time field widget is a text input field with a time picker drop down. It shows left/right arrows to increase or
 * decrease time by the {@link #config-step step value}.
 *
 * This field can be used as an {@link Grid.column.Column#config-editor editor} for the {@link Grid.column.Column Column}.
 * It is used as the default editor for the {@link Grid.column.TimeColumn TimeColumn}.
 *
 * ## Configuring the picker hour / minute fields
 *
 * You can easily configure the fields in the drop down picker, to control the increment of the up/down step arrows:
 *
 * ```javascript
 * new TimeField({
 *     label     : 'Time field',
 *     appendTo  : document.body,
 *     picker    : {
 *         items : {
 *             minute : {
 *                 step : 5
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * @extends Core/widget/PickerField
 *
 * @example
 * let field = new TimeField({
 *   format: 'HH'
 * });
 *
 * @classType timefield
 * @inlineexample Core/widget/TimeField.js
 */

class TimeField extends _PickerField_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Config
  static get $name() {
    return 'TimeField';
  } // Factoryable type name


  static get type() {
    return 'timefield';
  } // Factoryable type alias


  static get alias() {
    return 'time';
  }

  static get configurable() {
    return {
      picker: {
        type: 'timepicker',
        floating: true,
        align: {
          align: 't0-b0',
          axisLock: true
        }
      },

      /**
       * Get/Set format for time displayed in field (see {@link Core.helper.DateHelper#function-format-static}
       * for formatting options).
       * @member {String} format
       */

      /**
       * Format for date displayed in field (see Core.helper.DateHelper#function-format-static for formatting
       * options).
       * @config {String}
       * @default
       */
      format: 'LT',
      triggers: {
        expand: {
          align: 'end',
          handler: 'onTriggerClick',
          compose: () => ({
            children: [{
              class: {
                'b-icon-clock-live': 1
              }
            }]
          })
        },
        back: {
          align: 'start',
          cls: 'b-icon b-icon-angle-left b-step-trigger',
          handler: 'onBackClick'
        },
        forward: {
          align: 'end',
          cls: 'b-icon b-icon-angle-right b-step-trigger',
          handler: 'onForwardClick'
        }
      },

      /**
       * Get/set min value, which can be a Date or a string. If a string is specified, it will be converted using
       * the specified {@link #config-format}.
       * @member {Date} min
       * @accepts {String|Date}
       */

      /**
       * Min time value
       * @config {String|Date}
       */
      min: null,

      /**
       * Get/set max value, which can be a Date or a string. If a string is specified, it will be converted using
       * the specified {@link #config-format}.
       * @member {Date} max
       * @accepts {String|Date}
       */

      /**
       * Max time value
       * @config {String|Date}
       */
      max: null,

      /**
       * The `step` property may be set in Object form specifying two properties, `magnitude`, a Number, and
       * `unit`, a String.
       *
       * If a Number is passed, the steps's current unit is used and just the magnitude is changed.
       *
       * If a String is passed, it is parsed by {@link Core.helper.DateHelper#function-parseDuration-static}, for
       * example `'5m'`, `'5 m'`, `'5 min'`, `'5 minutes'`.
       *
       * Upon read, the value is always returned in object form containing `magnitude` and `unit`.
       * @member {Object} step
       * @accepts {String|Number|Object}
       */

      /**
       * Time increment duration value. Defaults to 5 minutes.
       * The value is taken to be a string consisting of the numeric magnitude and the units.
       * The units may be a recognised unit abbreviation of this locale or the full local unit name.
       * For example `"10m"` or `"5min"` or `"2 hours"`
       * @config {String}
       */
      step: '5m',
      stepTriggers: null,

      /**
       * Get/set value, which can be a Date or a string. If a string is specified, it will be converted using the
       * specified {@link #config-format}.
       * @member {Date} value
       * @accepts {String|Date}
       */

      /**
       * Value, which can be a Date or a string. If a string is specified, it will be converted using the
       * specified {@link #config-format}
       * @config {String|Date}
       */
      value: null
    };
  } //endregion
  //region Init & destroy


  changePicker(picker, oldPicker) {
    const me = this;
    return _TimePicker_js__WEBPACK_IMPORTED_MODULE_2__["default"].reconfigure(oldPicker, picker, {
      owner: me,
      defaults: {
        forElement: me[me.pickerAlignElement],
        owner: me,
        align: {
          anchor: me.overlayAnchor,
          target: me[me.pickerAlignElement]
        },

        onTimeChange({
          time
        }) {
          me._isUserAction = true;
          me.value = time;
          me._isUserAction = false;
        }

      }
    });
  } //endregion
  //region Click listeners


  onBackClick() {
    const me = this,
          {
      min
    } = me;

    if (!me.readOnly && me.value) {
      const newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(me.value, -1 * me.step.magnitude, me.step.unit);

      if (!min || min.getTime() <= newValue) {
        me._isUserAction = true;
        me.value = newValue;
        me._isUserAction = false;
      }
    }
  }

  onForwardClick() {
    const me = this,
          {
      max
    } = me;

    if (!me.readOnly && me.value) {
      const newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(me.value, me.step.magnitude, me.step.unit);

      if (!max || max.getTime() >= newValue) {
        me._isUserAction = true;
        me.value = newValue;
        me._isUserAction = false;
      }
    }
  } //endregion
  // region Validation


  get isValid() {
    const me = this;
    me.clearError('L{Field.minimumValueViolation}', true);
    me.clearError('L{Field.maximumValueViolation}', true);
    let value = me.value;

    if (value) {
      value = value.getTime();

      if (me._min && me._min.getTime() > value) {
        me.setError('L{Field.minimumValueViolation}', true);
        return false;
      }

      if (me._max && me._max.getTime() < value) {
        me.setError('L{Field.maximumValueViolation}', true);
        return false;
      }
    }

    return super.isValid;
  }

  hasChanged(oldValue, newValue) {
    if (oldValue && oldValue.getTime && newValue && newValue.getTime) {
      // Only care about the time part
      return oldValue.getHours() !== newValue.getHours() || oldValue.getMinutes() !== newValue.getMinutes() || oldValue.getSeconds() !== newValue.getSeconds() || oldValue.getMilliseconds() !== newValue.getMilliseconds();
    }

    return super.hasChanged(oldValue, newValue);
  } //endregion
  //region Toggle picker

  /**
   * Show picker
   */


  showPicker(focusPicker) {
    const me = this,
          {
      picker
    } = me;

    if (me.readOnly) {
      return;
    }

    picker.initialValue = me.value;
    picker.format = me.format;
    picker.maxTime = me.max;
    picker.minTime = me.min; // Show valid time from picker while editor has undefined value

    me.value = picker.value;
    super.showPicker(focusPicker);
  }

  onPickerShow() {
    var _this$pickerKeyDownRe;

    super.onPickerShow(); // Remove PickerField key listener

    this.pickerKeyDownRemover = (_this$pickerKeyDownRe = this.pickerKeyDownRemover) === null || _this$pickerKeyDownRe === void 0 ? void 0 : _this$pickerKeyDownRe.call(this);
  }
  /**
   * Focus time picker
   */


  focusPicker() {
    this.picker.focus();
  } //endregion
  //region Getters/setters


  transformTimeValue(value) {
    if (value != null) {
      if (!_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isDate(value)) {
        if (typeof value === 'string') {
          value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].parse(value, this.format);
        } else {
          value = new Date(value);
        }
      } // We insist on a *valid* Time as the value


      if (_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isValidDate(value)) {
        // Clear date part back to zero so that all we have is the time part of the epoch.
        return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getTime(value);
      }
    }

    return null;
  }

  changeMin(value) {
    return this.transformTimeValue(value);
  }

  updateMin(value) {
    const {
      input
    } = this;

    if (input) {
      if (value == null) {
        input.removeAttribute('min');
      } else {
        input.min = value;
      }
    }

    this.syncInvalid();
  }

  changeMax(value) {
    return this.transformTimeValue(value);
  }

  updateMax(value) {
    const {
      input
    } = this;

    if (input) {
      if (value == null) {
        input.removeAttribute('max');
      } else {
        input.max = value;
      }
    }

    this.syncInvalid();
  }

  changeValue(value, was) {
    const me = this,
          newValue = me.transformTimeValue(value); // A value we could not parse

    if (value && !newValue || me.isRequired && value === '') {
      // setError uses localization
      me.setError('L{invalidTime}');
      return;
    }

    me.clearError('L{invalidTime}'); // Reject non-change

    if (me.hasChanged(was, newValue)) {
      return super.changeValue(newValue, was);
    } // But we must fix up the display in case it was an unparseable string
    // and the value therefore did not change.


    if (!me.inputting) {
      me.syncInputFieldValue(true);
    }
  }

  updateValue(value, was) {
    const {
      expand
    } = this.triggers; // This makes to clock icon show correct time

    if (expand && value) {
      expand.element.firstElementChild.style.animationDelay = -((value.getHours() * 60 + value.getMinutes()) / 10) + 's';
    }

    super.updateValue(value, was);
  }

  changeStep(value, was) {
    const type = typeof value;

    if (!value) {
      return null;
    }

    if (type === 'number') {
      value = {
        magnitude: Math.abs(value),
        unit: was ? was.unit : 'hour'
      };
    } else if (type === 'string') {
      value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].parseDuration(value);
    }

    if (value && value.unit && value.magnitude) {
      if (value.magnitude < 0) {
        value = {
          magnitude: -value.magnitude,
          // Math.abs
          unit: value.unit
        };
      }

      return value;
    }
  }

  updateStep(value) {
    // If a step is configured, show the steppers
    this.element.classList[value ? 'remove' : 'add']('b-no-steppers');
    this.syncInvalid();
  }

  updateFormat() {
    this.syncInputFieldValue(true);
  }

  get inputValue() {
    return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].format(this.value, this.format);
  } //endregion
  //region Localization


  updateLocalization() {
    super.updateLocalization();
    this.syncInputFieldValue(true);
  } //endregion


} // Register this widget type with its Factory

TimeField.initClass();
TimeField._$name = 'TimeField';

/***/ }),

/***/ "./lib/Core/widget/TimePicker.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/TimePicker.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimePicker; });
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _NumberField_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./NumberField.js */ "./lib/Core/widget/NumberField.js");
var productName = 'taskboard';




/**
 * @module Core/widget/TimePicker
 */

/**
 * A Popup which displays hour and minute number fields and AM/PM switcher buttons for 12 hour time format.
 *
 * ```javascript
 * new TimeField({
 *     label     : 'Time field',
 *     appendTo  : document.body,
 *     // Configure the time picker
 *     picker    : {
 *         items : {
 *             minute : {
 *                 step : 5
 *             }
 *         }
 *     }
 * });
 * ```
 * ## Contained widgets
 *
 * The default widgets contained in this picker are:
 *
 * | Widget ref             | Type                                                                            | Description                                                    |
 * |------------------------|---------------------------------------------------------------------------------|----------------------------------------------------------------|
 * | `hour`                 | {@link Core.widget.NumberField NumberField}                                     | The hour field                                                  |
 * | `minute`               | {@link Core.widget.NumberField NumberField}                                     | The minute field                                                  |
 * | `amButton`             | {@link Core.widget.Button Button}                                               | The am button                                                  |
 * | `pmButton`             | {@link Core.widget.Button Button}                                               | The pm button                                                  |
 *
 * Used internally by the {@link Core.widget.TimeField} class.
 *
 * @classType timepicker
 * @extends Core/widget/Popup
 */

class TimePicker extends _Popup_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get $name() {
    return 'TimePicker';
  } // Factoryable type name


  static get type() {
    return 'timepicker';
  }

  static get defaultConfig() {
    return {
      items: {
        hour: {
          type: 'number',
          min: 0,
          max: 23,
          highlightExternalChange: false,
          format: '2>9'
        },
        label: {
          html: '<label>:</label>'
        },
        minute: {
          type: 'number',
          min: 0,
          max: 59,
          highlightExternalChange: false,
          format: '2>9'
        },
        amButton: {
          type: 'button',
          text: 'AM',
          toggleGroup: 'am-pm',
          cls: 'b-blue'
        },
        pmButton: {
          type: 'button',
          text: 'PM',
          toggleGroup: 'am-pm',
          cls: 'b-blue'
        }
      },
      float: '1',
      autoShow: false,
      trapFocus: true,

      /**
       * Default time value
       * @config {Date}
       */
      value: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getTime(0),

      /**
       * Time format. Used to set appropriate 12/24 hour format to display.
       * See Core.helper.DateHelper#format for formatting options.
       * @config {String}
       */
      format: null
    };
  } //endregion
  //region Init

  /**
   * Fires when a time is changed.
   * @event timeChange
   * @param {Date} time The selected time.
   */


  construct(config) {
    super.construct(config);
    const me = this,
          {
      hour,
      minute,
      amButton,
      pmButton
    } = me.widgetMap;
    me._pm = false;
    hour.on('change', me.onFieldChange, me);
    minute.on('change', me.onFieldChange, me);
    amButton.on('click', me.onAmButtonClick, me);
    pmButton.on('click', me.onPmButtonClick, me);
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element: me.element,
      keydown: 'onPickerKeyDown',
      thisObj: me,
      capture: true
    });
    me.refresh();
  } //endregion
  //region Event listeners


  onFieldChange() {
    const me = this;

    if (me._time) {
      me.value = me.pickerToTime();
    }
  }

  onAmButtonClick() {
    const me = this;
    me._pm = false;

    if (me._time) {
      me.value = me.pickerToTime();
    }
  }

  onPmButtonClick() {
    const me = this;
    me._pm = true;

    if (me._time) {
      me.value = me.pickerToTime();
    }
  }

  onPickerKeyDown(keyEvent) {
    const me = this,
          keyName = keyEvent.key && keyEvent.key.trim() || keyEvent.code;

    switch (keyName) {
      case 'Escape':
        // Support for undefined initial time
        me.triggerTimeChange(me._initialValue);
        me.hide();
        keyEvent.preventDefault();
        break;

      case 'Enter':
        me.value = me.pickerToTime();
        me.hide();
        keyEvent.preventDefault();
        break;
    }
  } //endregion
  //region Internal functions


  pickerToTime() {
    const me = this,
          pm = me._pm,
          {
      hour,
      minute
    } = me.widgetMap;
    hour.format = me._is24Hour ? '2>9' : null;
    let hours = hour.value,
        newValue = new Date(me._time);

    if (!me._is24Hour) {
      if (pm && hours < 12) hours = hours + 12;
      if (!pm && hours === 12) hours = 0;
    }

    newValue.setHours(hours);
    newValue.setMinutes(minute.value);

    if (me._min) {
      newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].max(me._min, newValue);
    }

    if (me._max) {
      newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].min(me._max, newValue);
    }

    return newValue;
  }

  triggerTimeChange(time) {
    this.trigger('timeChange', {
      time
    });
  } //endregion
  //region Getters / Setters

  /**
   * Get/set value, which can be a Date or a string. If a string is specified, it will be converted using the
   * specified {@link #config-format}
   * @property {Date}
   * @accepts {Date|String}
   */


  set value(newTime) {
    const me = this;
    let changed = false;

    if (!newTime || !me._time) {
      me._time = TimePicker.defaultConfig.value;
      changed = true;
    } else if (newTime.getTime() !== me._time.getTime()) {
      me._time = newTime;
      changed = true;
    }

    if (changed) {
      if (me.isVisible) {
        me.triggerTimeChange(me.value);
      }

      me.refresh();
    }
  }

  get value() {
    return this._time;
  }
  /**
   * Get/Set format for time displayed in field (see Core.helper.DateHelper#format for formatting options)
   * @property {String}
   */


  set format(value) {
    const me = this;
    me._format = value;
    me._is24Hour = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].is24HourFormat(me._format);
    me.refresh();
  }

  get format() {
    return this._format;
  }
  /**
   * Get/set max value, which can be a Date or a string. If a string is specified, it will be converted using the
   * specified {@link #config-format}
   * @property {Date}
   * @accepts {Date|String}
   */


  set min(value) {
    this._min = value;
  }

  get min() {
    return this._min;
  }
  /**
   * Get/set min value, which can be a Date or a string. If a string is specified, it will be converted using the
   * specified {@link #config-format}
   * @property {Date}
   * @accepts {Date|String}
   */


  set max(value) {
    this._max = value;
  }

  get max() {
    return this._max;
  }
  /**
   * Get/set initial value and value, which can be a Date or a string. If a string is specified,
   * it will be converted using the specified {@link #config-format}. Initial value is restored on Escape click
   * @property {Date}
   * @accepts {Date|String}
   */


  set initialValue(value) {
    this.value = value;
    this._initialValue = value;
  }

  get initialValue() {
    return this._initialValue;
  } //endregion
  //region Display


  refresh() {
    const me = this;

    if (!me.isConfiguring) {
      const {
        hour,
        minute,
        amButton,
        pmButton
      } = me.widgetMap,
            time = me._time,
            is24 = me._is24Hour,
            hours = time.getHours(),
            pm = me._pm = hours >= 12;
      me.element.classList[is24 ? 'add' : 'remove']('b-24h');
      hour.min = is24 ? 0 : 1;
      hour.max = is24 ? 23 : 12;
      hour.value = is24 ? hours : hours % 12 || 12;
      minute.value = time.getMinutes();
      amButton.pressed = !pm;
      pmButton.pressed = pm;
      amButton.hidden = pmButton.hidden = is24;
    }
  } //endregion


} // Register this widget type with its Factory

TimePicker.initClass();
TimePicker._$name = 'TimePicker';

/***/ }),

/***/ "./lib/Core/widget/Toast.js":
/*!**********************************!*\
  !*** ./lib/Core/widget/Toast.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Toast; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module Core/widget/Toast
 */

/**
 * Basic toast. Toasts are stacked on top of each other
 * @example
 * // simplest possible
 * Toast.show('Just toasting');
 *
 * // with config
 * Toast.show({
 *   html: 'Well toasted',
 *   showProgress: false
 * });
 *
 * // as instance (instance is also returned from Toast.show()
 * let toast = new Toast({
 *   html: 'Not going away',
 *   timeout: 0
 * });
 *
 * toast.show();
 *
 * @classType toast
 * @inlineexample Core/widget/Toast.js
 */

class Toast extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Toast';
  } // Factoryable type name


  static get type() {
    return 'toast';
  }

  static get configurable() {
    return {
      testConfig: {
        destroyTimeout: 1,
        timeout: 100
      },
      floating: true,

      /**
       * Timeout (in ms) until the toast is automatically dismissed. Set to 0 to never hide.
       * @config {Number}
       * @default
       */
      timeout: 2500,
      autoDestroy: null,
      // How long to wait after hide before destruction
      destroyTimeout: 200,

      /**
       * Show a progress bar indicating the time remaining until the toast is dismissed.
       * @config {Boolean}
       * @default
       */
      showProgress: true,

      /**
       * Toast color (should have match in toast.scss or your custom styling).
       * Valid values in Bryntum themes are:
       * * b-amber
       * * b-blue
       * * b-dark-gray
       * * b-deep-orange
       * * b-gray
       * * b-green
       * * b-indigo
       * * b-lime
       * * b-light-gray
       * * b-light-green
       * * b-orange
       * * b-purple
       * * b-red
       * * b-teal
       * * b-white
       * * b-yellow
       *
       * ```
       * new Toast({
       *    color : 'b-blue'
       * });
       * ```
       *
       * @config {String}
       */
      color: null,
      bottomMargin: 20
    };
  }

  compose() {
    const {
      appendTo,
      color,
      html,
      showProgress,
      style,
      timeout
    } = this;
    return {
      parent: appendTo || this.floatRoot,
      class: _objectSpread(_objectSpread({}, _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"].normalize(color, 'object')), {}, {
        'b-toast-hide': 1 // toasts start hidden so we can animate them into view

      }),
      html,
      style,
      children: {
        progressElement: showProgress && {
          style: `animation-duration:${timeout / 1000}s;`,
          class: {
            'b-toast-progress': 1
          }
        }
      },
      listeners: {
        click: 'hide'
      }
    };
  }

  doDestroy() {
    this.untoast();
    super.doDestroy();
  }

  get nextBottom() {
    const {
      bottomMargin,
      element
    } = this;
    return parseInt(element.style.bottom, 10) + element.offsetHeight + bottomMargin;
  }
  /**
   * Show the toast
   */


  show() {
    super.show();
    const me = this,
          {
      element
    } = me,
          {
      toasts
    } = Toast;

    if (!toasts.includes(me)) {
      var _toasts$0$nextBottom, _toasts$;

      element.style.bottom = ((_toasts$0$nextBottom = (_toasts$ = toasts[0]) === null || _toasts$ === void 0 ? void 0 : _toasts$.nextBottom) !== null && _toasts$0$nextBottom !== void 0 ? _toasts$0$nextBottom : me.bottomMargin) + 'px';
      toasts.unshift(me);
      element.getBoundingClientRect(); // force layout so that removing b-toast-hide runs our transition

      element.classList.remove('b-toast-hide');

      if (me.timeout > 0) {
        me.hideTimeout = me.setTimeout('hide', me.timeout);
      }
    }
  }
  /**
   * Hide the toast
   */


  hide() {
    const me = this;
    me.untoast();
    me.element.classList.add('b-toast-hide');

    if (me.autoDestroy && !me.destroyTimer) {
      me.destroyTimer = me.setTimeout('destroy', me.destroyTimeout);
    }
  }

  untoast() {
    const {
      toasts
    } = Toast;

    if (toasts.includes(this)) {
      toasts.splice(toasts.indexOf(this), 1);
    }
  }
  /**
   * Hide all visible toasts
   */


  static hideAll() {
    Toast.toasts.slice().reverse().forEach(toast => toast.hide());
  }
  /**
   * Easiest way to show a toast
   * @example
   * Toast.show('Hi');
   * @example
   * Toast.show({
   *   html   : 'Read quickly, please',
   *   timeout: 1000
   * });
   * @param {String|Object} config Message or toast config object
   * @returns {Core.widget.Toast}
   */


  static show(config) {
    const toast = Toast.new({
      autoDestroy: true,
      rootElement: document.body
    }, typeof config === 'string' ? {
      html: config
    } : config);
    toast.show();
    return toast;
  }

}
Toast.toasts = []; // Register this widget type with its Factory

Toast.initClass();
Toast._$name = 'Toast';

/***/ }),

/***/ "./lib/Core/widget/Tool.js":
/*!*********************************!*\
  !*** ./lib/Core/widget/Tool.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Tool; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/ClickRepeater.js */ "./lib/Core/util/ClickRepeater.js");
/* harmony import */ var _mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/Rotatable.js */ "./lib/Core/widget/mixin/Rotatable.js");
var productName = 'taskboard';



/**
 * @module Core/widget/Tool
 */

/**
 * Base class for tools.
 *
 * May be configured with a `cls` and a `handler` which is a function (or name of a function)
 * in the owning Panel.
 * @extends Core/widget/Widget
 *
 * @classType tool
 */

class Tool extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  static get $name() {
    return 'Tool';
  } // Factoryable type name


  static get type() {
    return 'tool';
  }

  static get configurable() {
    return {
      /**
       * Specify `'start'` to place the tool before the owner's central element (e.g., the `title` of the panel).
       * @config {String}
       * @default 'end'
       * @category Float & align
       */
      align: {
        value: null,
        $config: {
          merge: 'replace'
        }
      },

      /**
       * The function to call when this tool is clicked. May be a function or function name
       * prepended by `"up."` that is resolvable in an ancestor component (such as an owning
       * Grid, Scheduler, Calendar, Gantt or TaskBoard)
       * @param {Event} handler.event The DOM event which activated the tool.
       * @param {Core.widget.Panel} handler.panel The owning Panel of the tool.
       * @param {Core.widget.Tool} handler.tool The clicked Tool.
       * @config {Function|String} handler
       */

      /**
       * A {@link Core.util.ClickRepeater ClickRepeater} config object to specify how
       * click-and-hold gestures repeat the click action.
       * @config {Object}
       */
      repeat: null,
      ariaLabel: null
    };
  }

  compose() {
    const {
      align,
      ariaLabel
    } = this;
    return {
      tag: 'button',
      class: {
        [`b-align-${align || 'end'}`]: 1,
        'b-icon': 1
      },
      'aria-label': ariaLabel,
      listeners: {
        click: 'onClick'
      }
    };
  }

  get focusElement() {
    return this.element;
  }

  get panel() {
    return this.parent;
  }

  changeAlign(align) {
    return align; // replace Widget.changeAlign
  }

  onClick(e) {
    const {
      handler,
      panel
    } = this; // Safari && FF trigger click on disabled button, Chrome does not. Handling it here

    if (!this.disabled && (panel === null || panel === void 0 ? void 0 : panel.trigger('toolclick', {
      domEvent: e,
      tool: this
    })) !== false) {
      handler && this.callback(handler, panel, [e, panel, this]);
    }
  }

  onInternalKeyDown(keyEvent) {
    const keyName = keyEvent.key.trim() || keyEvent.code; // Don't allow key invocations to bubble and trigger owning
    // widget's key handlers.

    if (keyName === 'Enter') {
      keyEvent.cancelBubble = true;
      keyEvent.stopPropagation();
    }
  }

  updateDisabled(disabled, was) {
    var _this$repeat;

    super.updateDisabled(disabled, was);
    disabled && ((_this$repeat = this.repeat) === null || _this$repeat === void 0 ? void 0 : _this$repeat.cancel());
  }

  changeRepeat(repeat, oldRepeat) {
    oldRepeat === null || oldRepeat === void 0 ? void 0 : oldRepeat.destroy();
    return repeat && _util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_1__["default"].new({
      element: this.element
    }, repeat);
  }

} // Register this widget type with its Factory

Tool.initClass();
Tool._$name = 'Tool';

/***/ }),

/***/ "./lib/Core/widget/Toolbar.js":
/*!************************************!*\
  !*** ./lib/Core/widget/Toolbar.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Toolbar; });
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _mixin_Toolable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/Toolable.js */ "./lib/Core/widget/mixin/Toolable.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./mixin/Rotatable.js */ "./lib/Core/widget/mixin/Rotatable.js");
/* harmony import */ var _layout_VBox_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./layout/VBox.js */ "./lib/Core/widget/layout/VBox.js");
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Button.js */ "./lib/Core/widget/Button.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';









/**
 * @module Core/widget/Toolbar
 */

const asElementRefs = {
  refs: 'element'
},
      isToolbar = w => w.isToolbar,
      _axisProps = [{
  box: 'hbox',
  clientSizeProp: 'clientWidth',
  edgeProp: 'right',
  flexDir: 'row',
  horizontal: true,
  max: 'maxX',
  overflow: 'overflowX',
  pos: 'x',
  scrollSize: 'scrollWidth',
  sizeProp: 'width'
}, {
  box: 'vbox',
  clientSizeProp: 'clientHeight',
  edgeProp: 'bottom',
  flexDir: 'column',
  horizontal: false,
  max: 'maxY',
  overflow: 'overflowY',
  pos: 'y',
  scrollSize: 'scrollHeight',
  sizeProp: 'height'
}],
      defaultRepeat = {
  delay: 0,
  startRate: 40,
  endRate: 200,
  accelerateDuration: 500
};
/**
 * A container widget that can contain Buttons or other widgets, and is docked to the bottom or top of
 * a {@link Core.widget.Panel Panel}.
 *
 * @extends Core/widget/Container
 * @classType toolbar
 * @inlineexample Core/widget/Toolbar.js
 */


class Toolbar extends _Container_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Toolable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get $name() {
    return 'Toolbar';
  } // Factoryable type name


  static get type() {
    return 'toolbar';
  }

  static get delayable() {
    return {
      syncOverflowVisibility: {
        type: 'raf',
        cancelOutstanding: true
      } // && 50   // restore the "&& 50" here to help when debugging syncOverflowVisibility

    };
  }

  static get configurable() {
    return {
      defaultType: 'button',
      dock: 'top',
      layout: {
        type: 'box'
      },

      /**
       * The {@link Core.widget.Tool tools} to add either before or after the content element (the element in
       * which {@link #config-overflow} occurs). Each property name is the reference by which an instantiated
       * tool may be retrieved from the live `{@link Core.widget.mixin.Toolable#property-tools}` property.
       * @config {Object} tools
       */

      /**
       * How this Toolbar should deal with items that overflow its main axis.
       *
       * Values may be:
       * - `'menu'` A button with a menu is shown and the menu contains the overflowing items.
       * - `'scroll'` The items overflow and mey be scrolled into view using the mouse or scroll buttons.
       * - `null` Disable overflow handling
       *
       * When mode is `'menu'`, clones of overflowing toolbar item are created and added to a Menu. Any config
       * changes to the original toolbar item are propagated to the menu's clone, so disabling a toolbar
       * item will make the clone in the menu disabled.
       *
       * The clone of an input field will propagate its `value` changes back to the original. The
       * overflow button, its menu, and the clones should not be accessed or manipulated by application code.
       *
       * Note that cloned items will be allocated a unique, generated ID because all IDs must be unique,
       * so CSS targeting an element ID will not apply to a clone in the overflow menu.
       *
       * Values may also be specified in object form containing the following properties:
       * @config {String|Object|null} overflow
       * @property {String} overflow.type `'scroll'` or `'menu'`
       * @property {Object} overflow.repeat A config object to reconfigure the {@link Core.util.ClickRepeater ClickRepeater}
       * which controls auto repeat speed when holding down the scroll buttons when `type` is `'scroll'`
       * @property {Function} overflow.filter A filter function which may return a falsy value to prevent toolbar
       * items from being cloned into the overflow menu.
       * @default 'menu'
       */
      overflow: {
        // Wait until first paint to evaluate so that we can read our CSS style.
        // Set to null on destroy which destroys the overflow Tools and Scroller.
        $config: ['lazy', 'nullify'],
        value: {
          type: 'menu'
        }
      },
      toolDefaults: {
        overflowMenuButton: {
          type: 'button',
          hidden: true,
          icon: 'b-icon-menu',
          menuIcon: null,
          defaultCls: {
            'b-overflow-button': 1
          }
        },
        overflowScrollEnd: {
          handler: 'up.onEndScrollClick',
          hidden: true,
          defaultCls: {
            'b-icon-angle-right': 1,
            'b-overflow-button': 1,
            'b-icon': 1
          }
        },
        overflowScrollStart: {
          align: 'start',
          handler: 'up.onStartScrollClick',
          hidden: true,
          defaultCls: {
            'b-icon-angle-left': 1,
            'b-overflow-button': 1,
            'b-icon': 1
          }
        }
      },

      /**
       * Custom CSS class to add to toolbar widgets
       * @config {String}
       * @category CSS
       */
      widgetCls: null
    };
  }

  compose() {
    const me = this,
          {
      axisProps,
      dock
    } = me,
          endToolElementRefs = me.getEndTools(asElementRefs),
          startToolElementRefs = me.getStartTools(asElementRefs);
    return {
      class: {
        [`b-dock-${dock}`]: 1,
        [`b-${dock}-toolbar`]: 1,
        [`b-${axisProps.box}`]: 1
      },
      children: _objectSpread(_objectSpread({}, startToolElementRefs), {}, {
        toolbarContent: {
          class: {
            'b-box-center': 1,
            'b-toolbar-content': 1
          }
        }
      }, endToolElementRefs)
    };
  }

  get axisProps() {
    return _axisProps[this.layout.horizontal ? 0 : 1];
  }

  get contentElement() {
    return this.toolbarContent;
  }

  get overflowMenuButton() {
    var _this$tools;

    return (_this$tools = this.tools) === null || _this$tools === void 0 ? void 0 : _this$tools.overflowMenuButton;
  }

  get overflowType() {
    const {
      overflow
    } = this;
    return typeof overflow === 'string' ? overflow : overflow === null || overflow === void 0 ? void 0 : overflow.type;
  }

  onChildAdd(item) {
    var _item$syncRotationToD;

    super.onChildAdd(item);
    this.processAddedLeafItem(item);
    (_item$syncRotationToD = item.syncRotationToDock) === null || _item$syncRotationToD === void 0 ? void 0 : _item$syncRotationToD.call(item, this.dock);
  }

  processAddedLeafItem(item) {
    // Any configurable config changes in the original are propagated to a possible clone.
    // Also a reevaluation of scroll state may be necessary. Any part of the UI may have changed,
    _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].after(item, 'onConfigChange', this.onLeafItemConfigChange, item); // And all the way down. Eg, hiding a ButtonGroup must schedule a syncOverflowVisibility
    // but also hiding any of its children must also schedule a syncOverflowVisibility

    if (item.isContainer) {
      item.eachWidget(w => this.processAddedLeafItem(w));
    }
  }

  onPaint({
    firstPaint
  }) {
    var _super$onPaint;

    (_super$onPaint = super.onPaint) === null || _super$onPaint === void 0 ? void 0 : _super$onPaint.call(this, ...arguments); // Evaluate the overflow late so that we have access to styles and measurements.

    if (firstPaint) {
      this.getConfig('overflow');
    }
  }

  updateDock(dock) {
    const me = this,
          {
      layout
    } = me,
          {
      vertical
    } = layout;
    layout.vertical = Object(_mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_6__["canonicalDock"])(dock)[1];

    if (!me.initialItems) {
      if (vertical !== layout.vertical) {
        me.updateOverflow(me.overflow);
      }

      for (const item of me.childItems) {
        var _item$syncRotationToD2;

        (_item$syncRotationToD2 = item.syncRotationToDock) === null || _item$syncRotationToD2 === void 0 ? void 0 : _item$syncRotationToD2.call(item, dock);
      }
    }
  }

  updateOverflow(overflow, oldOverflow) {
    var _me$overflowMenuButto;

    const me = this,
          {
      axisProps,
      contentElement,
      overflowType
    } = me,
          {
      flexDir
    } = axisProps,
          overflowMenu = (_me$overflowMenuButto = me.overflowMenuButton) === null || _me$overflowMenuButto === void 0 ? void 0 : _me$overflowMenuButto._menu,
          overflowTools = {};

    if (overflowMenu) {
      // Save any clones from destruction
      if (overflow) {
        overflowMenu === null || overflowMenu === void 0 ? void 0 : overflowMenu.removeAll();
      } // Break link between original and clone
      else {
        overflowMenu.eachWidget(clone => {
          clone._toolbarOverflowOriginal._toolbarOverflowClone = null;
        });
      }
    }

    if (oldOverflow === 'menu') {
      overflowTools.overflowMenuButton = null;
    } else if (oldOverflow === 'scroll') {
      overflowTools.overflowScrollStart = overflowTools.overflowScrollEnd = null;
    }

    if (overflowType === 'menu') {
      var _me$scrollable;

      // Not needed for menu type overflowing
      (_me$scrollable = me.scrollable) === null || _me$scrollable === void 0 ? void 0 : _me$scrollable.destroy(); // Must allow things like Badges to escape the bounds.

      contentElement.style.overflow = contentElement.style.overflowX = contentElement.style.overflowY = '';
      overflowTools.overflowMenuButton = {
        cls: {
          [`b-${flexDir}-menu`]: 1
        }
      };
    } else if (overflowType === 'scroll') {
      const repeat = typeof overflow === 'object' && (overflow === null || overflow === void 0 ? void 0 : overflow.repeat) || defaultRepeat; // We need a scroller.

      me.scrollable = {
        [axisProps.overflow]: 'hidden-scroll',
        element: contentElement,
        listeners: {
          scroll: 'onContentScroll',
          thisObj: me
        }
      };
      overflowTools.overflowScrollStart = {
        repeat,
        invertRotate: true,
        cls: {
          [`b-${flexDir}-start-scroller`]: 1
        }
      };
      overflowTools.overflowScrollEnd = {
        repeat,
        invertRotate: true,
        cls: {
          [`b-${flexDir}-end-scroller`]: 1
        }
      };
    }

    me.tools = overflowTools;

    if (overflowType) {
      // Stops items from flex-shrinking down now that we have a way of showing them in full.
      contentElement.classList.add('b-overflow'); // Need to hide/show overflow buttons when necessary

      me.monitorResize = true;
      me.syncOverflowVisibility();
    } else {
      contentElement.classList.remove('b-overflow');
      me.monitorResize = false;
    }
  }

  onContentScroll() {
    this.syncScrollerState();
  }

  onStartScrollClick() {
    this.scrollable[this.axisProps.pos] -= 2;
  }

  onEndScrollClick() {
    this.scrollable[this.axisProps.pos] += 2;
  } // Only called when monitorResize is true, which is only set when we have an overflow mode


  onInternalResize() {
    super.onInternalResize(...arguments); // If it's not the initial undefined->first size from the initial paint, reevaluate overflow

    if (this.isPainted) {
      this.syncOverflowVisibility();
    }
  }

  syncOverflowVisibility() {
    const me = this,
          {
      overflowType,
      contentElement,
      isVisible
    } = me,
          {
      clientSizeProp,
      edgeProp,
      sizeProp
    } = me.axisProps,
          {
      overflowMenuButton,
      overflowScrollStart,
      overflowScrollEnd
    } = me.tools,
          menuOverflow = overflowType === 'menu'; // Method can be called for hidden toolbar (e.g. after event editor is hidden), bail out early in such case

    if (!isVisible || !overflowType) {
      return;
    } // Prevent recursion


    me.inSyncOverflowVisibility = true; // Give the contents a chance to lay out with no scroll tools taking space.

    overflowMenuButton === null || overflowMenuButton === void 0 ? void 0 : overflowMenuButton.hide(); // NOTE: if we hide the scroller buttons that will affect the scroll range and can trigger a scroll. The scroll
    // does not fire synchronously (at least in Chrome) so it cannot be swallowed here.

    let overflowIndex = 0,
        availableSpace,
        itemRect,
        overflowable,
        visibleItems; // Iterate all leaf widgets.
    // Restore only the ones that we hid to visibility so that we can accurately ascertain overflow.
    // Collect all visible leaf widgets. These are what we are interested in hiding and showing.
    // Anything may have changed. Text inside buttons, label of fields, visibility or
    // disabled status. The only way to ascertain overflow is to show them all, and
    // force a synchronous layout by measuring the resulting scrollWidth/Height

    me.eachWidget((item, control) => {
      if (item.floating) {
        control.down = false;
        return;
      } // We want to descend into containers (esp ButtonGroup) but don't want to descend into normal widgets (like
      // button's which may have menus).


      control.down = !(overflowable = item.overflowable);

      if (overflowable && item.innerItem) {
        if (item._toolbarOverflow) {
          // Order is important here. _toolbarOverflow must be set first
          // so that onLeafItemConfigChange doesn't recurse infinitely.
          item.hidden = item._toolbarOverflow = false;
        }

        if (item.isVisible) {
          (visibleItems || (visibleItems = [])).push(item);
          ++overflowIndex;
        }
      }
    });

    if (visibleItems) {
      // Firefox doesn't calculate scrollWidth correctly if overflow is hidden which it has to be.
      itemRect = visibleItems[--overflowIndex].rectangle(contentElement);
      availableSpace = Math.ceil(contentElement[clientSizeProp] + ( // Since we cannot simply hide these to remove their influence, we need to add their width/height to
      // the availableSpace here:
      !overflowScrollStart || overflowScrollStart.hidden ? 0 : overflowScrollStart.rectangle('outer')[sizeProp]) + (!overflowScrollEnd || overflowScrollEnd.hidden ? 0 : overflowScrollEnd.rectangle('outer')[sizeProp]));
    }

    if (visibleItems && Math.floor(itemRect[edgeProp]) > availableSpace) {
      if (menuOverflow) {
        overflowMenuButton.show();
        availableSpace = contentElement[clientSizeProp]; // get the new size of the content area
        // We know the last item's edgeProp overflows, so skip that one and start at the prior item:

        while (overflowIndex-- > 0) {
          itemRect = visibleItems[overflowIndex].rectangle(contentElement);

          if (Math.floor(itemRect[edgeProp]) <= availableSpace) {
            break;
          }
        } // overflowIndex is the index of the item that did not overflow (or -1 if all items overflow)


        me.syncOverflowMenuButton(visibleItems.slice(overflowIndex + 1));
      } else {
        overflowScrollEnd.show();
        overflowScrollStart.show();
        me.syncScrollerState();
      }
    } else if (!menuOverflow) {
      overflowScrollEnd === null || overflowScrollEnd === void 0 ? void 0 : overflowScrollEnd.hide();
      overflowScrollStart === null || overflowScrollStart === void 0 ? void 0 : overflowScrollStart.hide();
    }

    me.inSyncOverflowVisibility = false;
  }

  syncOverflowMenuButton(overflowItems) {
    var _overflowMenuButton$_;

    const me = this,
          {
      axisProps,
      overflowMenuButton
    } = me,
          menu = {
      cls: 'b-toolbar-overflow-menu',
      minWidth: 280,
      items: [],
      align: {
        align: axisProps.horizontal ? 't100-b100' : 'r100-l100',
        axisLock: 'flexible'
      }
    }; // Hide the things that overflow

    for (let overflowingItem, i = 0, {
      length
    } = overflowItems; i < length; i++) {
      overflowingItem = overflowItems[i]; // Cache the width so that we can make it look right in the menu

      overflowingItem._toolbarOverflowWidth = overflowingItem.width; // Order is important here. _toolbarOverflow must be set first
      // so that onLeafItemConfigChange doesn't recurse infinitely.

      overflowingItem._toolbarOverflow = true;
      overflowingItem.hidden = true;
    } // Add clones, or surrogates of the overflowing things to the menu.
    // Input fields will be cloned, buttons will result in a MenuItem.
    // Any Containers


    me.addToMenu(menu, overflowItems.filter(item => me.overflowItemFilter(item)));

    if ((_overflowMenuButton$_ = overflowMenuButton._menu) !== null && _overflowMenuButton$_ !== void 0 && _overflowMenuButton$_.isMenu) {
      const existingMenu = overflowMenuButton.menu,
            {
        toAdd,
        toRemove
      } = _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].delta(menu.items, existingMenu.items, 1);
      existingMenu.remove(toRemove);

      if (existingMenu.items.length) {
        // Insert the ones which we just got too narrow to show at the top of the menu
        for (let i = toAdd.length - 1; i >= 0; i--) {
          existingMenu.insert(toAdd[i], 0);
        }
      } else {
        existingMenu.add(toAdd);
      }
    } else {
      overflowMenuButton.menu = menu;
    }
  }

  syncScrollerState() {
    const me = this,
          {
      axisProps,
      scrollable
    } = me,
          {
      overflowScrollStart,
      overflowScrollEnd
    } = me.tools,
          scrollPos = scrollable[axisProps.pos],
          maxScrollPos = scrollable[axisProps.max];
    overflowScrollStart.disabled = !scrollPos;
    overflowScrollEnd.disabled = Math.ceil(scrollPos) >= maxScrollPos;
  }

  overflowItemFilter(item) {
    const {
      filter
    } = this.overflow;
    return Boolean(filter // Allow user-defined filter
    ? filter.call(this, item) // If no Elements, for example displaying text which will have a Node type 3
    // or a toolbar spacer or separator, then omit it from the menu
    : _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].getChildElementCount(item.element));
  }

  addToMenu(menu, overflowingItems) {
    const {
      horizontal
    } = this;

    for (let i = 0, {
      length
    } = overflowingItems; i < length; i++) {
      const item = overflowingItems[i];
      let clone = item._toolbarOverflowClone,
          type = item.constructor;

      if (!clone) {
        const config = _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(item.initialConfig); // Must not duplicate IDs

        delete config.id; // If the initialConfig was hidden, we must override that

        config.hidden = false; // Item must obey menu's align-items : stretch style.
        // CSS unset not supported on IE11.

        config.width = ''; // Don't allow horizontal flex styles to apply in the vertical
        // layout of the Menu.

        if (horizontal) {
          config.flex = '';
        }

        config.minWidth = item._toolbarOverflowWidth;
        config.type = item.type;
        config._toolbarOverflowOriginal = item; // These properties are things that may be changed frequently from the initialConfig state.

        config.disabled = item.disabled;

        if ('value' in item) {
          config.value = item.value;
        } // Icon-only buttons are not useful in a menu.
        // Use any tooltip text as the button text.


        if (config.type === 'button') {
          // TODO - will look better but need be clever - https://github.com/bryntum/support/issues/2298
          // config.type = type = type.resolveType('menuitem');
          if (!config.text) {
            config.text = item.tooltipText;
          }
        }

        item._toolbarOverflowClone = clone = type.create(config);
        clone.element.style.margin = ''; // Clone's changes must propagate to original.

        if (item.isField) {
          clone.on({
            change: this.onFieldCloneChange
          });
        }
      }

      menu.items.push(clone);
    }
  }

  onFieldCloneChange({
    source,
    value
  }) {
    source._toolbarOverflowOriginal.value = value;
  } // Note that this is called with the thisObj of the tbar item being reconfigured.
  // It propagates the new setting into its toolbar overflow clone.


  onLeafItemConfigChange(origResult, {
    name,
    value
  }) {
    const me = this,
          toolbar = me.up(isToolbar),
          {
      _toolbarOverflowClone
    } = me; // If it's a hide/show, and its in sync with its _toolbarOverflow state, do nothing

    if (toolbar !== null && toolbar !== void 0 && toolbar.inSyncOverflowVisibility || name === 'hidden' && value === me._toolbarOverflow) {
      return;
    } // If the changed item has a clone in the overflow menu, sync the clone


    if (_toolbarOverflowClone) {
      _toolbarOverflowClone[name] = value;
    } // Any part of the UI might have changed shape, so we must reevaluate scroll state.


    if (toolbar !== null && toolbar !== void 0 && toolbar.isPainted && me.ref !== 'overflowMenuButton') {
      if (!(me.isTextField && name === 'value' && (me.containsFocus || _toolbarOverflowClone !== null && _toolbarOverflowClone !== void 0 && _toolbarOverflowClone.containsFocus))) {
        toolbar.syncOverflowVisibility();
      }
    }
  }

  createWidget(widget) {
    if (widget === '->') {
      widget = {
        type: 'widget',
        cls: 'b-toolbar-fill'
      };
    } else if (widget === '|') {
      widget = {
        type: 'widget',
        cls: 'b-toolbar-separator'
      };
    } else if (typeof widget === 'string') {
      widget = {
        type: 'widget',
        cls: 'b-toolbar-text',
        html: widget
      };
    }

    const result = super.createWidget(widget);

    if (this.widgetCls) {
      result.element.classList.add(this.widgetCls);
    }

    return result;
  }

} // Register this widget type with its Factory

Toolbar.initClass();
Toolbar._$name = 'Toolbar';

/***/ }),

/***/ "./lib/Core/widget/Tooltip.js":
/*!************************************!*\
  !*** ./lib/Core/widget/Tooltip.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Tooltip; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/util/Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
var productName = 'taskboard';










const realignTransitions = {
  left: true,
  right: true,
  top: true,
  bottom: true,
  transform: true
},
      isBoolean = {
  true: 1,
  false: 1
},
      immediatePromise = Promise.resolve();
/**
 * @module Core/widget/Tooltip
 */

/**
 * Tooltip. Easiest way of assigning a tooltip to a widget is by setting {@link Core.widget.Widget#config-tooltip}, see example below.
 *
 * ```javascript
 * new Button {
 *     text    : 'Hover me',
 *     tooltip : 'Click me and you wont believe what happens next'
 * });
 * ```
 *
 * By default, tooltips of widgets use a singleton Tooltip instance which may be accessed from the
 * `{@link Core.widget.Widget Widget}` class under the name `Widget.tooltip`.
 * This is configured according to the config object on pointer over.
 *
 * To request a separate instance be created just for this widget, add `newInstance : true`
 * to the configuration:
 *
 * ```javascript
 * new Button {
 *     text    : 'Hover me',
 *     tooltip : {
 *         html        : 'Click me and you wont believe what happens next',
 *         newInstance : true
 *     }
 * });
 * ```
 *
 * You can ask for the singleton instance to display configured tips for your own DOM structure using
 * `data-btip` element attributes:
 *
 * ```html
 * <button class="my-button" data-btip="Contextual help for my button" data-btip-scroll-action="realign">Hover me</button>
 * ```
 *
 * ## Showing async content
 * To load remote content into a simple tooltip, just load your data in the `beforeShow` listener (but ensure that the {@link #property-activeTarget} is the same when the data arrives)
 *
 * ```javascript
 * new Tooltip({
 *     listeners : {
 *         beforeShow : ({ source : tip }) => tip.html = AjaxHelper.get('someurl').then(response => response.text());
 *     }
 * });
 * ```
 *
 * If you have multiple targets that should show a tooltip when hovered over, look at {@link #config-forSelector} and {@link #config-getHtml}.
 *
 * ```javascript
 * new Tooltip({
 *     forSelector : '.myCssClass',
 *     getHtml     : ({ source : tip }) => AjaxHelper.fetch('data').then(response => response.text())
 * });
 * ```
 *
 * @extends Core/widget/Popup
 * @classType tooltip
 * @inlineexample Core/widget/Tooltip.js
 */

class Tooltip extends _Popup_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  //region Default config
  static get $name() {
    return 'Tooltip';
  } // Factoryable type name


  static get type() {
    return 'tooltip';
  }
  /**
   * Triggered before tooltip widget is shown. Return `false` to prevent the action.
   * @preventable
   * @event beforeShow
   * @param {Core.widget.Tooltip} source The Tooltip
   * @param {Event} source.triggeredByEvent The event that triggered this Tooltip to show.
   */


  static get configurable() {
    return {
      /**
       * Horizontal offset from mouse when {@link #config-anchorToTarget} is `false`
       * @config {Number}
       * @default
       */
      mouseOffsetX: 15,

      /**
       * Vertical offset from mouse when {@link #config-anchorToTarget} is `false`
       * @config {Number}
       * @default
       */
      mouseOffsetY: 15,
      floating: true,

      /**
       * A method, or the *name* of a method called to update the tooltip's content when the
       * cursor is moved over a target. It receives one argument containing context about the
       * tooltip and show operation. The function should return a string, or a Promise yielding
       * a string.
       *
       * ```javascript
       * new Grid({
       *     title    : 'Client list',
       *     appendTo : myElement,
       *     store    : myStore,
       *     columns  : myColumns,
       *     tbar     : {
       *         items : {
       *             text : 'Reload,
       *             tooltip : {
       *                 // Will look in ownership hierarchy for the method
       *                 // which will be found on the grid.
       *                 getHtml : 'up.getReloadButtonTip'
       *             }
       *         }
       *     },
       *     getReloadButtonTip() {
       *         return `Reload ${this.title}`;
       *     }
       * });
       * ```
       * @param {Object} context
       * @param {Core.widget.Tooltip} context.tip The tooltip instance
       * @param {HTMLElement} context.element The Element for which the Tooltip is monitoring mouse movement
       * @param {HTMLElement} context.activeTarget The target element that triggered the show
       * @param {Event} context.event The raw DOM event
       * @return {String|Promise}
       * @config {Function|String}
       */
      getHtml: null,

      /**
       * DOM element to attach tooltip to. By default, the mouse entering this element will kick off a timer
       * (see {@link #config-hoverDelay}) to show itself.
       *
       * If the {@link #config-forSelector} is specified, then mouse entering matching elements within the `forElement`
       * will trigger the show timer to start.
       *
       * Note that when moving from matching element to matching element within the `forElement`, the tooltip
       * will remain visible for {@link #config-hideDelay} milliseconds after exiting one element, so that rapidly
       * entering another matching element will not cause hide+show flicker. To prevent this behaviour configure
       * with `hideDelay: 0`.
       * @config {HTMLElement}
       */
      forElement: null,

      /**
       * By default, once a tooltip is shown aligned as requested, it stays put.
       *
       * Setting this to `true` causes the tooltip to be aligned by the mouse,
       * offset by `[{@link #config-mouseOffsetX}, {@link #config-mouseOffsetY}]` and
       * keeps the tooltip aligned to the mouse maintaining the configured offsets
       * as the mouse moves within its activating element.
       * @config {Boolean}
       * @default false
       */
      trackMouse: null,

      /**
       * By default, a tooltip displays static content. In the Scheduler however, there are
       * plenty of uses cases when the tip content is based on the current mouse position (dragging events, resizing events, schedule hover tip, drag creation of events etc). Set
       * to `true` to update contents on mouse movement.
       * @config {Boolean}
       * @private
       */
      updateContentOnMouseMove: false,

      /**
       * A CSS selector which targets child elements of the {@link #config-forElement} that should produce a tooltip when hovered over.
       * @config {String}
       */
      forSelector: null,

      /**
       * By default, when moving rapidly from target to target, if, when mouseovering
       * a new target, the tip is still visible, the tooltip does not hide, it remains
       * visible, but updates its content however it is configured to do so.
       *
       * Configure `hideOnDelegateChange : true` to have the tip hide, and then trigger
       * a new show delay upon entry of a new target while still visible.
       * @config {Boolean}
       * @default false
       */
      hideOnDelegateChange: null,

      /**
       * Set to true to anchor tooltip to the triggering target. If set to `false`, the tooltip
       * will align to the mouse position. When set to `false`, it will also set `anchor: false`
       * to hide anchor arrow.
       * @config {Boolean}
       * @default true
       */
      anchorToTarget: true,

      /**
       * Show on hover
       * @config {Boolean}
       * @default
       */
      showOnHover: false,

      /**
       * The amount of time to hover before showing
       * @config {Number}
       * @default
       */
      hoverDelay: 500,

      /**
       * Show immediately when created
       * @config {Boolean}
       * @default
       */
      autoShow: false,

      /**
       * The time (in milliseconds) that the Tooltip should stay visible for when it shows over its
       * target. If the tooltip is anchored to its target, then moving the mouse during this time
       * resets the timer so that the tooltip will remain visible.
       *
       * Defaults to `0` which means the Tooltip will persist until the mouse leaves the target.
       * @config {Number}
       * @default
       */
      dismissDelay: 0,

      /**
       * The time (in milliseconds) for which the Tooltip remains visible when the mouse leaves the target.
       *
       * May be configured as `false` to persist visible after the mouse exits the target element. Configure it
       * as 0 to always retrigger `hoverDelay` even when moving mouse inside `fromElement`
       * @config {Number}
       * @default
       */
      hideDelay: 500,

      /**
       * The message to show while an async tooltip is fetching its content.
       * @config {String}
       * @default
       */
      loadingMsg: 'Loading...',

      /**
       * Keep the tooltip open if user hovers it
       * @config {Boolean}
       * @default
       */
      allowOver: false,
      anchor: true,
      align: {
        align: 'b-t',
        // This signals to the align code that this widget is prepared to shrink
        // in height in order to comply with alignTo specifications.
        // Without a minHeight, it is assumed that the height of the widget
        // is inviolable.
        minHeight: 300
      },
      axisLock: true,
      testConfig: {
        hideDelay: 100,
        hoverDelay: 100,
        showAnimation: null,
        hideAnimation: null
      }
    };
  } //endregion
  //region Events

  /**
   * Triggered when a mouseover event is detected on a potential target element.
   * Return false to prevent the action
   * @event pointerOver
   * @param {Core.widget.Tooltip} sourceThe tooltip instance.
   * @param {Event} event The mouseover event.
   */
  //endregion
  //region Properties

  /**
   * The HTML element that triggered this Tooltip to show
   * @readonly
   * @member {HTMLElement} activeTarget
   */
  //endregion
  //region Init & destroy


  afterConfigure() {
    const me = this,
          {
      forSelector
    } = me;

    if (forSelector) {
      me.showOnHover = true;

      if (!me.forElement) {
        if (!me.anchorToTarget) {
          me.trackMouse = true;
        }

        me.forElement = me.rootElement.host || me.rootElement;
      }
    }

    super.afterConfigure(); // There's a triggering element, and we're showing on hover, add the mouse listeners

    if (me.forElement && me.showOnHover) {
      me.pointerOverOutDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
        element: me.forElement,
        // Using pointerover/pointerout since mouseover events are not fired in Chrome when the native `disabled`
        // attribute is present https://github.com/bryntum/support/issues/3179
        pointerover: 'internalOnPointerOver',
        pointerout: 'internalOnPointerOut',
        thisObj: me
      });
    }

    if (me.allowOver) {
      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
        element: me.element,
        mouseenter: 'onOwnElementMouseEnter',
        mouseleave: 'internalOnPointerOut',
        thisObj: me
      });
    }
  }

  doDestroy() {
    this.pointerOverOutDetacher && this.pointerOverOutDetacher();
    super.doDestroy();
  }

  set focusOnToFront(focusOnToFront) {
    super.focusOnToFront = focusOnToFront;
  }

  get focusOnToFront() {
    // Transient things like tooltips should not focus when invoked by pointer events
    return super.focusOnToFront && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].usingKeyboard;
  }

  get focusElement() {
    const result = super.focusElement;

    if (result !== this.element) {
      return result;
    }
  }

  get anchorToTarget() {
    // We do not anchor to the target if we are tracking the mouse
    return this._anchorToTarget && !this.trackMouse;
  }

  get anchor() {
    // We do not anchor to the target if we are tracking the mouse
    return super.anchor && !this.trackMouse;
  }

  set anchor(anchor) {
    super.anchor = anchor;
  } //endregion
  //region Hovering, show and hide


  onDocumentMouseDown({
    event
  }) {
    const me = this,
          {
      triggeredByEvent
    } = me; // If it's a tap that is caused by the touch that was converted into a mouseover we should not hide.
    // That is if it's a touch and at the same place and within 500ms

    if (triggeredByEvent && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isTouchEvent) {
      if (event.pageX === triggeredByEvent.pageX && event.pageY === triggeredByEvent.pageY && me.activeTarget.contains(event.target) && performance.now() - triggeredByEvent.timeStamp < 500) {
        return;
      }
    }

    me.abortDelayedShow();
    super.onDocumentMouseDown({
      event
    });
  }

  internalOnPointerOver(event) {
    const me = this,
          forElement = me.forElement,
          forSelector = me.forSelector,
          activeTarget = me.activeTarget;
    let newTarget; // Respect our owner's wish to not show when it's disabled

    if (me.disabled || me.owner && !me.owner.showTooltipWhenDisabled && me.owner.disabled) {
      return;
    } // If the mouse moves over this tooltip, it is theoretically a mouseout of its
    // forElement, but allowOver lets us tolerate this ane remain visible.


    if (me.allowOver && me.element.contains(event.target)) {
      return;
    } // There's been a mouseover. If we have a forSelector, we have to check
    // if it's an enter of a matching child


    if (forSelector) {
      // Moving inside a forSelector matching element
      if (activeTarget && activeTarget.contains(event.target) && activeTarget.contains(event.relatedTarget)) {
        return;
      }

      newTarget = event.target.closest(forSelector); // Mouseovers while within a target do nothing

      if (newTarget && event.relatedTarget && event.relatedTarget.closest(forSelector) === newTarget) {
        return;
      }
    } // There's no forSelector, so check if we moved from outside the target
    else if (!forElement.contains(event.relatedTarget)) {
      newTarget = forElement;
    } // Mouseover caused by moving from child to child inside the target
    else {
      return;
    } // If pointer entered the target or a forSelector child, then show.


    if (newTarget) {
      me.handleForElementOver(event, newTarget);
    } // If over a non-forSelector child, behave as in forElement out
    else if (activeTarget) {
      me.handleForElementOut();
    }
  } // Handle a transitioned reposition when the activeTarget moved beneath the pointer.
  // When it comes to an end, if the mouseout has not hidden, then realign at the new position
  // if the activeTarget is still beneath the pointer.


  onTransitionEnd(event) {
    const me = this,
          currOver = Tooltip.currentOverElement;

    if (realignTransitions[event.propertyName]) {
      // Don't realign if the mouse is over this, and is allowed to be over this
      // If user is interacting with this Tooltip, they won't expect it to move.
      if (me.allowOver && me.element.contains(currOver)) {
        return;
      } // If we are still visible, and mouse is still over the activeTarget, realign


      if (me.activeTarget && me.activeTarget.contains(currOver) && !me.trackMouse) {
        me.realign();
      }
    }
  }

  async handleForElementOver(event, newTarget) {
    const me = this; // Vetoed, then behave as is a targetout

    if (me.trigger('pointerOver', {
      event,
      target: newTarget
    }) === false) {
      me.internalOnPointerOut(event);
    } else {
      let abortedHide;
      me.triggeredByEvent = event;
      me.abortDelayedHide(); // Abort any in-flight animated hide, and show immediately.
      // This is needed when allowOver is false (which is the default), and mouseovering
      // hides, but that immediately causes the mouse to be over another delegate
      // which jumps right in here.

      if (!me.hideOnDelegateChange && me.element.classList.contains('b-hiding')) {
        me.element.classList.remove('b-hiding');
        abortedHide = true;
      } // We are over a new target. If we are still visible, we
      // do not want to hide to avoid flickering. But if there is a
      // beforeshow listener which may mutate us, we still have to
      // consult it. If it returns a veto, then we do in fact hide.
      // Under normal circumstances we just alignTo the new target.
      // We must handle the post show tasks like starting the dismiss timer etc.


      if ((abortedHide || me.isVisible) && !me.hideOnDelegateChange) {
        me.updateActiveTarget(newTarget);

        if (me.trigger('beforeShow') === false) {
          return me.hide();
        }

        if (abortedHide) {
          me.show(false);
        }

        const result = me.updateContent(); // Edge case, we have no loadingMsg meaning we're not visible until content has arrived

        if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].isPromise(result) && !me.loadingMsg) {
          await result;
        } // updateContent may have yielded empty content which hides us


        if (!me.hidden) {
          me.alignTo({
            target: me.anchorToTarget ? newTarget : new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_2__["default"](me.triggeredByEvent.pageX - window.pageXOffset + me.mouseOffsetX, me.triggeredByEvent.pageY - window.pageYOffset + me.mouseOffsetY),
            overlap: !(me.anchorToTarget && me.anchor)
          });
          me.trigger('show');
          me.afterShowByTarget();
        }
      } else {
        if (me.hideOnDelegateChange) {
          // Hide with no animation if we are configured to hide between delegates
          me.hide(false);
        }

        me.updateActiveTarget(newTarget);
        me.delayShow(newTarget);
      }
    }
  }

  async delayShow(target) {
    var _me$currentAnimation;

    const me = this; // Caught in a show animation - cancel it,
    // If we're fading away, that's fine.

    if ((_me$currentAnimation = me.currentAnimation) !== null && _me$currentAnimation !== void 0 && _me$currentAnimation.showing) {
      me.cancelHideShowAnimation();
    }

    if (!me.isVisible && !me.hasTimeout('show')) {
      // Allow hoverDelay:0 or rapid movement from delegate to delegate to show immediately
      if (!me.hoverDelay || me.forSelector && Date.now() - me.lastHidden < me.quickShowInterval) {
        const result = me.updateContent(); // Edge case, we have no loadingMsg meaning we're not visible until content has arrived

        if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].isPromise(result) && !me.loadingMsg) {
          await result;
        }

        me.showByTarget(target);
      } else {
        // If a mouse down happens during the delay period, we cancel the show
        me.addDocumentMouseDownListener(); // If we're not going to anchor to the hovered element, then we need to keep track
        // of mousemoves until the show happens so we can show where the mouse currently is.

        if (!me.listeningForMouseMove && !me.anchorToTarget) {
          me.mouseMoveRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
            element: me.rootElement,
            mousemove: 'onMouseMove',
            thisObj: me
          });
        } // If a tap event triggered, do not wait. Show immediately.


        me.setTimeout(async () => {
          if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isOrphaned(target)) {
            const result = me.updateContent(); // Edge case, we have no loadingMsg meaning we're not visible until content has arrived

            if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].isPromise(result) && !me.loadingMsg) {
              await result;
            }

            me.showByTarget(target);
          }
        }, !me.triggeredByEvent || me.triggeredByEvent.type === 'pointerover' ? me.hoverDelay : 0, 'show');
      }
    } else if (me.isVisible) {
      me.showByTarget(target);
    }
  }

  updateContent() {
    const me = this;

    if (me.getHtml) {
      const result = me.callback(me.getHtml, me, [{
        tip: me,
        element: me.element,
        activeTarget: me.activeTarget,
        event: me.triggeredByEvent
      }]);
      me.html = result;
      return result;
    }
  } // There are 3 possible scenarios:
  // - Static content
  // - Remote content being loaded (meaning we (possibly) set a loading message as the `html`
  // - Tooltip acts as a Container


  get hasContent() {
    return Boolean(this._html !== '' && typeof this.html === 'string' && this.html.length || this.items.length);
  }

  internalBeforeShow() {
    // In case we update content on mouse move, need to show empty tooltip first
    return (this.updateContentOnMouseMove || this.hasContent) && !this.disabled;
  }
  /**
   * Shows a spinner and a message to indicate an async flow is ongoing
   * @param {String} message The message, defaults to {@link #config-loadingMsg}
   */


  showAsyncMessage(message = this.optionalL(this.loadingMsg)) {
    // TODO: Load masking should ideally use a general Widget ability.
    if (message) {
      this.html = `
                <div class="b-tooltip-loading">
                    <i class="b-icon b-icon-spinner"></i>
                    ${message}
                </div>
            `;
    }
  }

  showByTarget(target) {
    const me = this;

    if (me.mouseMoveRemover) {
      me.mouseMoveRemover();
      me.mouseMoveRemover = null;
    } // Show by the correct thing.
    // If we are not anchored to the target, then it's the current pointer event.
    // Otherwise it's the activeTarget.


    me.showBy({
      target: me.anchorToTarget ? target : new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_2__["default"](me.triggeredByEvent.pageX - window.pageXOffset + me.mouseOffsetX, me.triggeredByEvent.pageY - window.pageYOffset + me.mouseOffsetY),
      overlap: !(me.anchorToTarget && me.anchor)
    });
  }

  afterShowByTarget() {
    const me = this,
          dismissDelay = me.dismissDelay;
    me.abortDelayedShow();

    if (dismissDelay) {
      me.setTimeout('hide', dismissDelay);
    }

    me.toFront();
  }

  updateActiveTarget(newTarget) {
    const me = this,
          lastTarget = me.activeTarget;
    me.activeTarget = newTarget;

    if (!me.isConfiguring) {
      me.trigger('overtarget', {
        newTarget,
        lastTarget
      });
    }
  }

  internalOnPointerOut(event) {
    const me = this,
          toElement = event.relatedTarget; // Edge case: If there is no space to fit the tooltip, and as a result of showing the tooltip - the mouse is over the tooltip
    // Make sure we don't end up in an infinite hide/show loop

    if (me.allowOver && me.element.contains(toElement)) {
      return;
    } // If we were in an allowOver situation and exited
    // into the activeTarget, do nothing; in this situation
    // the tip is treated as if it were part of the target.


    if (me.element.contains(event.target) && me.activeTarget && me.activeTarget.contains(toElement)) {
      return;
    } // We have exited the active target


    if (me.activeTarget && !me.activeTarget.contains(toElement)) {
      me.handleForElementOut();
    }
  }

  handleForElementOut() {
    // Separated from onTargetOut so that subclasses can handle target out in any way.
    const me = this,
          {
      hideDelay
    } = me; // Allow outside world to veto the hide

    if (me.trigger('pointerOut') === false) {
      me.activeTarget = null;
      return;
    }

    me.abortDelayedShow(); // Even if there is a hide timer, it's a *dismiss* timer which hides the tip
    // after a hover time. We begin a new delay on target out.

    if (me.isVisible && hideDelay !== false) {
      me.abortDelayedHide();

      if (hideDelay > 0) {
        me.setTimeout('hide', hideDelay);
      } else {
        // Hide immediately when configured with `hideDelay: 0`. Used by async cell tooltips that always should
        // retrigger `hoverDelay`, to not spam the backend
        me.hide();
      }
    }
  }

  show() {
    const me = this; // If we know what element to show it by, and we are anchoring to it
    // and there's no ambiguity with a selector for sub elements,
    // then show it by our forElement (Unless we're being called from showBy)

    if (me.forElement && me.anchorToTarget && !me.forSelector && !me.inShowBy) {
      me.showByTarget(me.forElement);
    } // All we can do is the basic Widget show.
    else {
      if (me.inShowBy) {
        me.y = -10000;
      }

      super.show();
    }

    me.afterShowByTarget(); // If we've shown, and are tracking the mouse and not anchored to (aligned to) the target, track the mouse

    if (!me.mouseMoveRemover && !me._hidden && (me.trackMouse || me.updateContentOnMouseMove)) {
      me.mouseMoveRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
        element: me.rootElement,
        [_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].supportsPointerEvents ? 'pointermove' : 'touchmove']: 'onMouseMove',
        thisObj: me
      });
    }

    if (me.forElement && !me.transitionEndDetacher && !me._hidden) {
      me.transitionEndDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
        element: me.forElement,
        transitionend: 'onTransitionEnd',
        thisObj: me
      });
    }
  }

  hide(...args) {
    const me = this; // If we are asked to hide, we must always abort any impending show.

    me.abortDelayedShow(); // But if we are in fact visible, go ahead and hide

    if (me.isVisible) {
      me.abortDelayedHide();
      const result = super.hide(...args);
      me.lastHidden = Date.now();
      me.activeTarget = null;

      if (me.mouseMoveRemover) {
        me.mouseMoveRemover();
        me.mouseMoveRemover = null;
      }

      if (me.transitionEndDetacher) {
        me.transitionEndDetacher();
        me.transitionEndDetacher = null;
      }

      me.listeningForMouseMove = false;
      return result;
    } else {
      return immediatePromise;
    }
  }

  abortDelayedShow() {
    const me = this;

    if (me.hasTimeout('show')) {
      // This listener is added in delayShow to make a mousedown abort,
      // So we must remove it here because it's only removed in onHide.
      if (me.mouseDownRemover) {
        me.mouseDownRemover();
        me.mouseDownRemover = null;
      }

      me.clearTimeout('show');

      if (me.mouseMoveRemover) {
        me.mouseMoveRemover();
        me.mouseMoveRemover = null;
      }

      if (me.transitionEndDetacher) {
        me.transitionEndDetacher();
        me.transitionEndDetacher = null;
      }
    }
  }
  /**
   * Stops both timers which may hide this tooltip, the one which counts down from mouseout
   * and the one which counts down from mouseover show for dismissDelay ms
   * @private
   */


  abortDelayedHide() {
    this.clearTimeout('hide');
  }

  realign() {
    const me = this,
          spec = me.lastAlignSpec; // If we are hidden because our align target scrolled, or otherwise
    // moved out of its clipping boundaries, then check if it's moved back in.
    // For example EventDrag might move the element outside of the scheduler
    // SubGrid, which will cause the tip to hide, but then moving it back in
    // must reshow it.

    if (!me.isConfiguring && !me.isVisible && spec !== null && spec !== void 0 && spec.targetOutOfView) {
      // If there is an intersecting Rectangle with the forElement, align
      if (spec.allowTargetOut || _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isInView(spec.target, false, me.positioned && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getStyleValue(me.element, 'position') !== 'fixed')) {
        me.show();
        spec.targetOutOfView = false;
      }
    }

    super.realign();
  }

  alignTo(spec) {
    const me = this;

    if (!me.isVisible) {
      return;
    } // If mouse pointer is over this, do not attempt
    // to call the getHtml method.


    if (spec && !(me.triggeredByEvent && me.element.contains(me.triggeredByEvent.target))) {
      if (spec.nodeType === Node.ELEMENT_NODE) {
        spec = {
          target: spec
        };
      }
    }

    super.alignTo(spec);
  } //endregion
  //region Tooltip contents

  /**
   * Get/set the HTML to display. When specifying HTML, this widget's element will also have `b-html` added to its
   * classList, to allow targeted styling. To create async tooltip and show the {@link #config-loadingMsg}, see code below:
   * For example:
   *
   * ```javascript
   * new Tooltip({
   *     listeners : {
   *         beforeShow : ({ source : tip }) => {
   *             tip.showAsyncMessage();
   *             AjaxHelper.get('someurl').then(response => tip.html = 'Done!');
   *         }
   *     }
   * });
   * ```
   *
   * @member {String} html
   * @category DOM
   */


  changeHtml(htmlOrPromise) {
    const me = this;

    if (htmlOrPromise === false) {
      _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].deprecate('Grid', '5.0.0', 'Setting false to indicate loading is deprecated, in favor of `showAsyncMessage`. Please see https://bryntum.com/docs/grid/guide/Grid/upgrades/3.0.1 for more information');
      this.showAsyncMessage();
      return;
    }

    if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].isPromise(htmlOrPromise)) {
      me.showAsyncMessage();
      htmlOrPromise.target = me.activeTarget;
      htmlOrPromise.then(html => {
        // Cursor might have exited the element while loading
        if (htmlOrPromise.target === me.activeTarget) {
          me.html = html;
        }
      });
      return;
    } // Allow objects to pass through, to be used with DomSync


    if (typeof htmlOrPromise !== 'object') {
      // Stringify in case a number was passed in
      htmlOrPromise = htmlOrPromise != null ? me.optionalL(String(htmlOrPromise)) : '';
    }

    return htmlOrPromise;
  }

  updateHtml(value, was) {
    const me = this;
    let empty = value === ''; // As setting empty string as content should hide the tooltip, we don't want to actually update the
    // element innerHTML with blank space during the hide transition, we check _html for emptiness in hasContent

    if (!empty) {
      super.updateHtml(value, was);

      if (me.hasContent) {
        if (me.isVisible) {
          me.realign();
        }

        if (!_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].isPromise(value)) {
          me.trigger('innerHtmlUpdate');
        }
      } else {
        empty = true;
      }
    }

    if (empty) {
      // Hide empty tooltips
      me.hide();
    }
  } //endregion
  //region Events

  /**
   * Mouse move event listener which updates tooltip
   * @private
   */


  onMouseMove(event) {
    const me = this,
          {
      forElement,
      activeTarget
    } = me,
          x = event.pageX - window.pageXOffset + me.mouseOffsetX,
          y = event.pageY - window.pageYOffset + me.mouseOffsetY,
          // If we are trackMouse: true
    // we must keep out of the way of the mouse by continuing
    // to track if we are on the way out due to a hide timer.
    isHiding = me.hasTimeout('hide'),
          target = event.target; // MouseMove is listened for during the hover show timer wait phase if anchorToTarget is false
    // so that when the timer fires, it can show near the most recent pointer position.
    // It's also listened for after show when we are not anchored to the target and so tracking the mouse.

    /**
     * The DOM event that triggered this tooltip to show
     * @member {Event} triggeredByEvent
     * @readonly
     */

    me.triggeredByEvent = event; // Check that we are still valid to be visible, and if so, track the mouse.

    if (!me._hidden) {
      let hideVetoed;
      const // It's a move within our target
      isWithinTarget = activeTarget === null || activeTarget === void 0 ? void 0 : activeTarget.contains(target),
            // Work out whether we have just exited our target.
      // If we are still *inside* the target, do not test the selector.
      isElementOut = !isWithinTarget && me.forSelector && activeTarget && !isHiding && target.nodeType === Node.ELEMENT_NODE && !target.matches(me.forSelector) && !(me.allowOver && me.element.contains(target)),
            // We need an element we can ask the "contains" question about our target.
      // If we are using window, we need to step down to the documentElement.
      containingElement = forElement !== null && forElement !== void 0 && forElement.document ? forElement.document.documentElement : forElement,
            // If the forElement is a ShadowRoot, it won't implement contains
      // but it does implement compareDocumentPosition.
      forElementContainsTarget = containingElement && (containingElement.contains ? containingElement.contains(target) : containingElement.compareDocumentPosition(target) & 16); // Check whether the element we are over is still a valid delegate matching the forSelector,
      // or it's the tip element, and we're allowOver. If not, we have to hide.
      // nodeType check is for FF on Linux, event.target is sometimes a text node

      if (isElementOut) {
        hideVetoed = me.handleForElementOut();
      } // If we are not hiding due to moving mouse outside our forElement (or hide being vetoed), tooltip stays visible and optionally realigns based on trackMouse setting.


      if (hideVetoed || !isHiding || forElementContainsTarget) {
        // Mousemoves restart the dismiss timer.
        if (me.dismissDelay && !isHiding) {
          me.setTimeout('hide', me.dismissDelay);
        }

        if (me.updateContentOnMouseMove && me.getHtml) {
          me.html = me.callback(me.getHtml, me, [{
            tip: me,
            element: me.element,
            forElement: activeTarget,
            event: event
          }]);

          if (!me.html) {
            // Nothing to display, hide
            me.hide();
            return;
          }
        } // If we're not anchoring to the target, track the mouse


        if (me.trackMouse) {
          me.alignTo({
            position: new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_2__["default"](x, y),
            ignorePageScroll: true
          });
        }
      }
    }
  }

  onOwnElementMouseEnter(event) {
    this.abortDelayedHide();
  } //endregion


  static getSharedTooltip(rootElement, skipCreating) {
    var _rootElement$bryntum, _rootElement$bryntum$;

    let sharedTooltip = (_rootElement$bryntum = rootElement.bryntum) === null || _rootElement$bryntum === void 0 ? void 0 : (_rootElement$bryntum$ = _rootElement$bryntum.tooltip) === null || _rootElement$bryntum$ === void 0 ? void 0 : _rootElement$bryntum$.get(Tooltip);

    if (!sharedTooltip && !skipCreating) {
      var _rootElement$bryntum2;

      // Store shared tooltips in a map on root element,
      // keyed by the class to work with multiple bundles on page
      if (!((_rootElement$bryntum2 = rootElement.bryntum) !== null && _rootElement$bryntum2 !== void 0 && _rootElement$bryntum2.tooltip)) {
        _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].setPath(rootElement, 'bryntum.tooltip', new Map());
      }

      const map = rootElement.bryntum.tooltip; // Avoid infinite loop as the Tooltip gets created with rootElement too

      map.set(Tooltip, true);
      sharedTooltip = new Tooltip({
        forElement: rootElement,
        rootElement,
        forSelector: '[data-btip]',
        resetCfg: {},
        isShared: true,
        cls: 'b-tooltip-shared',
        listeners: {
          // Reconfigure on pointerOver
          pointerOver({
            source: me,
            target
          }) {
            // Revert last pointerOver config set to initial setting.
            for (const key in me.resetCfg) {
              if (key === 'listeners') {
                me.un(me.resetCfg[key].set);
              } // Do not reset HTML to "". It causes an unwanted inter-delegate hide.
              // hideOnDelegateChange defaults to false.
              else if (key !== 'html') {
                me[key] = me.resetCfg[key].was;
              }
            }

            me.resetCfg = {};
            const forComponent = _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].getById(target.id),
                  // If it's a component's tooltip, configure from the component,
            // Otherwise gather from the dataset
            config = (forComponent === null || forComponent === void 0 ? void 0 : forComponent.tipConfig) || me.gatherDataConfigs(target.dataset); // getById might find an entry with same id in different context, or element might belong to a
            // widget that could not be resolved since it is in another context -> ignore

            if (forComponent && forComponent.element !== target || !forComponent && target.matches('.b-widget') || // Respect our forComponent's wish to not show when it's disabled
            forComponent !== null && forComponent !== void 0 && forComponent.disabled && !forComponent.showTooltipWhenDisabled) {
              return false;
            } // Tooltip must be linked to an activating owner before it shows
            // so that configs which use 'up.propName' will be work as expected.


            me.owner = forComponent;

            for (const key in config) {
              me.resetCfg[key] = {
                set: config[key],
                was: me[key]
              };

              if (key === 'listeners') {
                me.on(config[key]);
              } else {
                me[key] = config[key];
              }
            }
          },

          hide({
            source: me
          }) {
            me.owner = null;
          }

        },

        gatherDataConfigs(dataset) {
          const me = this,
                config = {};

          for (const key in dataset) {
            if (key.startsWith('btip')) {
              if (key.length > 4) {
                const configProp = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].uncapitalize(key.substr(4)); // Snip off "btip" prefix to convert to property name
                // If we have a config by the name, set it

                if (configProp in me.getDefaultConfiguration()) {
                  const value = dataset[key]; // gather the found config value

                  config[configProp] = isBoolean[value] ? value === 'true' : isNaN(value) ? value : parseInt(value, 10);
                }
              } else {
                config.html = dataset[key];
              }
            }
          }

          return config;
        }

      });
      _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
        element: rootElement,
        mouseenter: event => Tooltip.currentOverElement = event.target,
        capture: true
      });
      map.set(Tooltip, sharedTooltip);
    }

    return sharedTooltip;
  }

} // Register this widget type with its Factory

Tooltip.initClass();
Object.defineProperty(_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"], 'tooltip', {
  get() {
    return Tooltip.getSharedTooltip(document.body);
  }

});
/**
 * Updated dynamically with the current element that the mouse is over. For use when showing a Tooltip
 * from code which is not triggered by a pointer event so that a tooltip can be positioned.
 * @member {HTMLElement} currentOverElement
 * @readonly
 * @static
 */
// Register this widget type with its Factory

_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].Tooltip = Tooltip;
Tooltip._$name = 'Tooltip';

/***/ }),

/***/ "./lib/Core/widget/Widget.js":
/*!***********************************!*\
  !*** ./lib/Core/widget/Widget.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Widget; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Config.js */ "./lib/Core/Config.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helper/util/Fullscreen.js */ "./lib/Core/helper/util/Fullscreen.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../helper/ResizeMonitor.js */ "./lib/Core/helper/ResizeMonitor.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helper/util/Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony import */ var _helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../localization/En.js */ "./lib/Core/localization/En.js");
/* harmony import */ var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
/* harmony import */ var _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony import */ var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony import */ var _Mask_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./Mask.js */ "./lib/Core/widget/Mask.js");
var productName = 'taskboard';






















 // TODO: Needs more docs

/**
 * @module Core/widget/Widget
 */

const floatRoots = [],
      isTransparent = /transparent|rgba\(0,\s*0,\s*0,\s*0\)/,
      textInputTypes = {
  INPUT: 1,
  TEXTAREA: 1
},
      addElementListeners = (me, element, domConfig, refName) => {
  var _listeners;

  let listeners = domConfig === null || domConfig === void 0 ? void 0 : domConfig.listeners;
  listeners = ((_listeners = listeners) === null || _listeners === void 0 ? void 0 : _listeners.on) || listeners;

  if (listeners) {
    const un = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].assign({
      element,
      thisObj: me
    }, listeners));

    if (refName) {
      // The domConfig for refs gets regenerated on each compose() so we cannot use them to store the un
      // functions.
      (me._refListeners || (me._refListeners = Object.create(null)))[refName] = un;
    } else {
      domConfig.listeners = {
        on: listeners,
        un
      };
    }
  }
},
      mergeAnim = (value, was) => {
  // The show/hideAnimation objects can only have one animation property, but it is fine to merge if they have
  // the same property.
  return value && was && was[_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].keys(value)[0]] ? _Config_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge(value, was) : value;
},
      // Need braces here. MUST NOT return false
widgetTriggerPaint = w => {
  w.isVisible && w.triggerPaint();
},
      negationPseudo = /^:not\((.+)\)$/,
      nonFlowedPositions = /absolute|fixed/i,
      isScaled = w => w.scale != null,
      {
  hasOwnProperty
} = Object.prototype,
      {
  defineProperty
} = Reflect,
      parseDuration = d => parseFloat(d) * (d.endsWith('ms') ? 1 : 1000),
      immediatePromise = Promise.resolve(),
      alignedClass = ['b-aligned-above', 'b-aligned-right', 'b-aligned-below', 'b-aligned-left'],
      returnFalseProp = {
  configurable: true,

  get() {
    return false;
  }

};
/**
 * Base class for other widgets. The Widget base class simply encapsulates an element, and may optionally contain some
 * specified {@link #config-html}.
 *
 * ## Rendering
 *
 * Subclasses should override the {@link #function-compose} method to return their encapsulating element and internal
 * DOM structure. The `compose()` method returns a {@link Core.helper.DomHelper#function-createElement-static} config
 * object that is* used to create the DOM structure, based on its {@link Core.Base#property-configurable-static}
 * properties:
 *
 * ```javascript
 *  class Button extends Widget {
 *      static get configurable() {
 *          return {
 *              cls  : null,
 *              text : null
 *          };
 *      }
 *
 *      compose() {
 *          const { cls, text } = this;  // collect all relevant configs properties (for auto-detection)
 *
 *          return {
 *              tag   : 'button',
 *              class : cls,
 *              text
 *          };
 *      }
 *  }
 * ```
 *
 * The config properties used by the `compose()` method are auto-detected when the method is first called for a class.
 * All relevant properties must be read, even if they end up not being used so that future changes to these properties
 * will mark the rendering as dirty.
 *
 * When a config property used by `compose()` is modified, the {@link #function-recompose} method is called. Since
 * `recompose()` is a {@link Core.mixin.Delayable#property-delayable-static delayable} method, calling it schedules a
 * delayed call to `compose()` and a DOM update. Accessing the Widget's primary `element` or any reference element
 * property will force the DOM update to occur immediately.
 *
 * ### Child Elements
 *
 * Unlike typical {@link Core.helper.DomHelper#function-createElement-static DOM config} objects, the object returned
 * by `compose()` can use an object to simplify naming:
 *
 * ```javascript
 *  class Button extends Widget {
 *      ...
 *
 *      compose() {
 *          const { cls, iconCls, text } = this;  // collect all relevant configs properties (for auto-detection)
 *
 *          return {
 *              tag   : 'button',
 *              class : cls,
 *
 *              children : {
 *                  iconElement : iconCls && {
 *                      class : {
 *                          'button-icon' : 1,
 *                          [iconCls]     : 1
 *                      }
 *                  },
 *
 *                  textElement : {
 *                      text
 *                  }
 *              }
 *          };
 *      }
 *  }
 * ```
 *
 * The keys of the `children` are [iterated](https://2ality.com/2015/10/property-traversal-order-es6.html) to convert
 * the values into the array required by {@link Core.helper.DomHelper#function-createElement-static}. The names of the
 * properties becomes the `reference` of the element.
 *
 * For example, the above is equivalent to the following:
 *
 * ```javascript
 *  class Button extends Widget {
 *      ...
 *
 *      compose() {
 *          const { cls, iconCls, text } = this;  // collect all relevant configs properties (for auto-detection)
 *
 *          return {
 *              tag   : 'button',
 *              class : cls,
 *
 *              children : [iconCls && {
 *                  reference : 'iconElement',
 *                  class : {
 *                      'button-icon' : 1,
 *                      [iconCls]     : 1
 *                  }
 *              }, {
 *                  reference : 'textElement',
 *                  text
 *              }]
 *          };
 *      }
 *  }
 * ```
 *
 * The object form of `children` is preferred for clarity but also because it facilitates inheritance.
 *
 * ### Inheritance
 *
 * When a derived class implements `compose()`, the object it returns is automatically merged with the object returned
 * by the base class.
 *
 * For example, the following class adds a new child element:
 *
 * ```javascript
 *  class MenuButton extends Button {
 *      ...
 *
 *      compose() {
 *          const { menuCls } = this;  // collect all relevant configs properties (for auto-detection)
 *
 *          return {
 *              children : {
 *                  menuElement : {
 *                      class : {
 *                          'button-menu' : 1,
 *                          [menuCls]     : 1
 *                      }
 *                  }
 *              }
 *          };
 *      }
 *  }
 * ```
 *
 * ### Listeners
 *
 * Reference elements may also define event `listeners` in the `compose()` method:
 *
 * ```javascript
 *  class Button extends Widget {
 *      compose() {
 *          const { cls, text } = this;
 *
 *          return {
 *              tag   : 'button',
 *              class : cls,
 *              text,
 *
 *              listeners : {
 *                  click : 'onClick'
 *              }
 *          };
 *      }
 *
 *      onClick(event) {
 *          // handle click event
 *      }
 *  }
 * ```
 *
 * ## Resolving properties
 *
 * Values for a Widgets properties can be resolved from the ownership hierarchy. For example a text field in a toolbar
 * can get its initial value from a property on the container owning the toolbar. This is achieved by prefixing the
 * desired property name with 'up.':
 *
 * ```javascript
 *  const grid = new Grid((
 *      tbar : [{
 *          type  : 'numberfield',
 *          // Fields value will be retrieved from the grids rowHeight property
 *          value : 'up.rowHeight'
 *      }]
 *  });
 * ```
 *
 * NOTE: this is for now a one way one time binding, the value will only be read initially and not kept up to date on
 * later changes.
 *
 * @mixes Core/mixin/Events
 * @mixes Core/localization/Localizable
 * @extends Core/Base
 * @classType widget
 */


class Widget extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_16__["default"], _mixin_Events_js__WEBPACK_IMPORTED_MODULE_17__["default"], _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_18__["default"], _mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_20__["default"], _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_19__["default"]) {
  //region Config

  /**
   * Class name getter.
   * Used when original ES6 class name is minified or mangled during production build.
   * Should be overriden in each class which extends Widget or it descendants.
   *
   * ```javascript
   * class MyNewClass extends Widget {
   *     static get $name() {
   *        return 'MyNewClass';
   *     }
   * }
   * ```
   *
   * @static
   * @member {String} $name
   */
  static get $name() {
    return 'Widget';
  } // Factoryable type name


  static get type() {
    return 'widget';
  }

  static get configurable() {
    return {
      /**
       * Get this widget's encapsulating HTMLElement, which is created along with the widget but added to DOM at
       * render time.
       * @member {HTMLElement} element
       * @readonly
       * @category DOM
       */

      /**
       * A {@link Core.helper.DomHelper#function-createElement-static} config object or HTML string from which to
       * create the Widget's element.
       * @private
       * @config {Object|String}
       * @category DOM
       */
      element: true,
      callOnFunctions: true,

      /**
       * Get/set widgets id
       * @member {String} id
       * @category DOM
       */

      /**
       * Widget id, if not specified one will be generated. Also used for lookups through Widget.getById
       * @config {String}
       * @category DOM
       */
      id: '',

      /**
       * The HTML to display initially or a function returning the markup (called at widget construction time)
       * @config {String|Function}
       * @category DOM
       */
      html: null,

      /**
       * Set HTML content safely, without disturbing sibling elements which may have been
       * added to the {@link #property-contentElement} by plugins and features.
       * When specifying html, this widget's element will also have the {@link #config-htmlCls}
       * added to its classList, to allow targeted styling.
       * @member {String} content
       * @category DOM
       */

      /**
       * The HTML content that coexists with sibling elements which may have been added to the
       * {@link #property-contentElement} by plugins and features.
       * When specifying html, this widget's element will also have the {@link #config-htmlCls}
       * class added to its classList, to allow targeted styling.
       * @config {String} content
       * @category DOM
       */
      content: null,

      /**
       * Custom CSS classes to add to element.
       * May be specified as a space separated string, or as an object in which property names
       * with truthy values are used as the class names:
       * ```javascript
       *  cls : {
       *      'b-my-class'     : 1,
       *      [this.extraCls]  : 1,
       *      [this.activeCls] : this.isActive
       *  }
       *  ```
       *
       * @config {String|Object}
       * @category CSS
       */
      cls: {
        $config: {
          merge: 'classList'
        },
        value: null
      },

      /**
       * Custom CSS class name suffixes to apply to the elements rendered by this widget. This may be specified
       * as a space separated string, an array of strings, or as an object in which property names with truthy
       * values are used as the class names.
       *
       * For example, consider a `Panel` with a `ui` config like so:
       *
       * ```javascript
       *  new Panel({
       *      text : 'OK',
       *      ui   : 'light'
       *  });
       * ```
       * This will apply the CSS class `'b-panel-ui-light'` to the main element of the panel as well as its many
       * child elements. This allows simpler CSS selectors to match the child elements of this particular panel
       * UI:
       *
       * ```
       *  .b-panel-content.b-panel-ui-light {
       *      background-color : #eee;
       *  }
       * ```
       * Using the {@link #config-cls cls config} would make matching the content element more complex, and in
       * the presence of {@link Core.widget.Panel#config-strips docked items} and nested panels, impossible to
       * target accurately.
       *
       * @config {String|Object}
       * @category CSS
       */
      ui: {
        $config: {
          merge: 'classList'
        },
        value: null
      },

      /**
       * Determines how a {@link Core.widget.Panel#config-collapsed} panel will treat this widget if it resides
       * within the panel's header (for example, as one of its {@link Core.widget.Panel#config-strips} or
       * {@link Core.widget.Panel#config-tools}).
       *
       * Valid options are:
       *  - `null` : The widget will be moved to the overlay when collapsed (the default).
       *  - `false` : The widget will be unaffected when the panel is collapsed.
       *  - `'hide'` : The widget will be hidden when the panel is collapsed.
       *  - `'overlay'` : The widget will only appear in the collapsed panel's overlay header.
       *
       * @config {Boolean|String}
       * @private
       */
      collapsify: null,

      /**
       * Custom CSS classes to add to the {@link #property-contentElement}.
       * May be specified as a space separated string, or as an object in which property names
       * with truthy values are used as the class names:
       * ```javascript
       *  cls : {
       *      'b-my-class'     : 1,
       *      [this.extraCls]  : 1,
       *      [this.activeCls] : this.isActive
       *  }
       *  ```
       *
       * @config {String|Object}
       * @category CSS
       */
      contentElementCls: {
        $config: {
          merge: 'classList'
        },
        value: null
      },

      /**
       * Custom CSS classes to add to this widget's `element`. This property is typically used internally to
       * assign default CSS classes while allowing `cls` to alter these defaults. It is not recommended that
       * client code set this config but instead should set `cls`.
       *
       * For example, to remove a class defined by `defaultCls` using `cls`, declare the class name as a key with
       * a falsy value:
       *
       * ```javascript
       *  cls : {
       *      'default-class' : false
       *  }
       * ```
       * @config {String|Object|String[]}
       * @internal
       */
      defaultCls: {
        $config: {
          merge: 'classList'
        },
        value: null
      },

      /**
       * Controls the placement of this widget when it is added to a {@link Core.widget.Panel panel's}
       *  {@link Core.widget.Panel#config-strips strips collection}. Typical values for this config are `'top'`,
       * `'bottom'`, `'left'`, or `'right'`, which cause the widget to be placed on that side of the panel's
       * body. Such widgets are called "edge strips".
       *
       * If this config is set to `'header'`, the widget is placed in the panel's header, following the title. If
       * this config is set to `'pre-header'`, the widget is placed before the title. Such widgets are called
       * "header strips".
       *
       * @config {String} dock
       * @category Layout
       */
      dock: null,
      parent: null,

      /**
       * The {@link Core.widget.Tab tab} created for this widget when it is placed in a
       * {@link Core.widget.TabPanel}.
       * @member {Core.widget.Tab} tab
       * @readonly
       * @category Misc
       */

      /**
       * A configuration for the {@link Core.widget.Tab tab} created for this widget when it is placed in a
       * {@link Core.widget.TabPanel}. For example, this config can be used to control the icon of the `tab` for
       * this widget:
       *
       * ```javascript
       *  items : [{
       *      type : 'panel',
       *      // other configs...
       *
       *      tab : {
       *          icon : 'b-fa-wrench'
       *      }
       *  }, ... ]
       * ```
       *
       * Another use for this config is to set the tab's {@link Core.widget.mixin.Rotatable#config-rotate} value
       * differently than the default managed by the `TabPanel`:
       *
       * ```javascript
       *  items : [{
       *      type : 'panel',
       *      // other configs...
       *
       *      tab : {
       *          rotate : false   // don't rotate even if tabBar is docked left or right
       *      }
       *  }, ... ]
       * ```
       *
       * Set this to `false` to prevent the creation of a `tab` for this widget. In this case, this widget must
       * be {@link #function-show shown} explicitly. The {@link Core.widget.TabPanel#config-activeTab} for the
       * tab panel will be -1 in this situation.
       *
       * ```javascript
       *  items : [{
       *      type : 'panel',
       *      tab  : false,    // no tab for this item
       *
       *      // other configs...
       *  }, ... ]
       * ```
       *
       * @config {Boolean|Object} tab
       * @category Misc
       */
      tab: null,

      /**
       * An object specifying attributes to assign to the root element of this widget
       * @internal
       * @config {Object}
       * @category Misc
       */
      elementAttributes: null,

      /**
       * The CSS class(es) to add when HTML content is being applied to this widget.
       * @config {String|Object}
       * @category CSS
       */
      htmlCls: {
        $config: {
          merge: 'classList'
        },
        value: {
          'b-html': 1
        }
      },

      /**
       * Custom style spec to add to element
       * @config {String}
       * @category CSS
       */
      style: null,

      /**
       * Get/set element's disabled state
       * @member {Boolean} disabled
       * @category Misc
       */

      /**
       * Disable or enable the widget. It is similar to {@link #config-readOnly} except a disabled widget
       * cannot be focused, uses a different rendition (usually greyish) and does not allow selecting its value.
       * @default false
       * @config {Boolean}
       * @category Misc
       */
      disabled: null,

      /**
       * Get/set element's readOnly state. This is only valid if the widget is an input
       * field, __or contains input fields at any depth__. Updating this property will trigger
       * a {@link #event-readOnly} event.
       *
       * All descendant input fields follow the widget's setting. If a descendant
       * widget has a readOnly config, that is set.
       * @member {Boolean} readOnly
       * @category Misc
       */

      /**
       * Whether this widget is read-only.  This is only valid if the widget is an input
       * field, __or contains input fields at any depth__.
       *
       * All descendant input fields follow the widget's setting. If a descendant
       * widget has a readOnly config, that is set.
       * @default false
       * @config {Boolean}
       * @category Misc
       */
      readOnly: {
        value: null,
        default: false,
        $config: null
      },

      /**
       * Element (or element id) to adopt as this Widget's encapsulating element. The widget's
       * content will be placed inside this element.
       *
       * If this widget has not been configured with an id, it will adopt the id of the element
       * in order to preserve CSS rules which may apply to the id.
       * @config {HTMLElement|String}
       * @default
       * @category DOM
       */
      adopt: null,

      /**
       * Element (or element id) to append this widgets element to
       * @config {HTMLElement|String}
       * @default
       * @category DOM
       */
      appendTo: null,

      /**
       * Element (or element id) to insert this widget before. If provided, {@link #config-appendTo} config is ignored.
       * @config {HTMLElement|String}
       * @category DOM
       */
      insertBefore: null,

      /**
       * Element (or element id) to append this widget element to, as a first child. If provided, {@link #config-appendTo} config is ignored.
       * @config {HTMLElement|String}
       * @category DOM
       */
      insertFirst: null,

      /**
       * Object to apply to elements dataset (each key will be used as a data-attribute on the element)
       * @config {Object}
       * @category DOM
       */
      dataset: null,

      /**
       * Tooltip for the widget, either as a string or as a Tooltip config object.
       *
       * By default, the Widget will use a single, shared instance to display its tooltip as configured,
       * reconfiguring it to the specification before showing it. Therefore, it may not be permanently
       * mutated by doing things such as adding fixed event listeners.
       *
       * To have this Widget *own* its own `Tooltip` instance, add the property `newInstance : true`
       * to the configuration. In this case, the tooltip's {@link #property-owner} will be this Widget.
       * @config {String|Object}
       * @category Misc
       */
      tooltip: {
        $config: ['lazy', 'nullify'],
        value: null
      },

      /**
       * Set to false to not show the tooltip when this widget is {@link #property-disabled}
       * @config {Boolean}
       * @default
       */
      showTooltipWhenDisabled: true,

      /**
       * Prevent tooltip from being displayed on touch devices. Useful for example for buttons that display a
       * menu on click etc, since the tooltip would be displayed at the same time.
       * @config {Boolean}
       * @default false
       * @category Misc
       */
      preventTooltipOnTouch: null,

      /**
       * Specify true to have widget monitoring its own resize.
       * @config {Boolean}
       * @default false
       * @category Misc
       */
      monitorResize: {
        $config: ['lazy', 'nullify'],
        value: null
      },

      /**
       * Set to `true` to apply the default mask to the widget. Alternatively, this can be the mask message or a
       * {@link Core.widget.Mask} config object.
       * @config {Boolean|String|Object|Core.widget.Mask}
       * @category Misc
       */
      masked: null,

      /**
       * This config object contains the defaults for the {@link Core.widget.Mask} created for the
       * {@link #config-masked} config. Any properties specified in the `masked` config will override these
       * values.
       * @config {Object|Core.widget.Mask}
       * @default
       * @category Misc
       */
      maskDefaults: {
        target: 'element'
      },
      cache: {},

      /**
       * Set to `true` to move the widget out of the document flow and position it
       * absolutely in browser viewport space.
       * @config {Boolean}
       * @default
       * @category Float & align
       */
      floating: null,

      /**
       * Set to `true` when a widget is rendered into another widget's  {@link #property-contentElement}, but must not
       * participate in the standard layout of that widget, and must be positioned relatively to that
       * widget's {@link #property-contentElement}.
       *
       * {@link Core.widget.Editor Editor}s are positioned widgets.
       * @config {Boolean}
       * @default
       * @category Float & align
       */
      positioned: null,

      /**
       * Only valid if this Widget is {@link #config-floating}
       * Set to `true` to be able to drag a widget freely on the page. Or set to an object with a ´handleSelector´ property which controls when a drag
       * should start.
       *
       * ```javascript
       *
       * draggable : {
       *     handleSelector : ':not(button)'
       * }
       *
       * ```
       *
       * @config {Boolean|Object}
       * @default false
       * @category Float & align
       */
      draggable: null,

      /**
       * _Only valid if this Widget is {@link #config-floating}._
       *
       * How to align this element with its target when {@link #function-showBy} is called
       * passing a simple element as an align target.
       *
       * Either a full alignment config object as passed to {@link #function-showBy}, or for simple
       * cases, the edge alignment string to use.
       *
       * When using a simple string, the format is `'[trblc]n-[trblc]n'` and it specifies our edge and
       * the target edge plus optional offsets from 0 to 100 along the edges to align to.
       *
       * See the {@link #function-showBy} function for more details about using the object form.
       *
       * Once set, this is stored internally in object form.
       * @config {Object|String}
       * @category Float & align
       */
      align: 't-b',
      // NOTE: this config changes meaning in tools and grid columns, so we don't get too clever here (such as
      //  config merge fn that promotes strings to objects)

      /**
       * Only valid if this Widget is {@link #config-floating}
       * Set to `true` to centre the Widget in browser viewport space.
       * @config {Boolean}
       * @default
       * @category Float & align
       */
      centered: null,

      /**
       * Only valid if this Widget is {@link #config-floating} and being shown through {@link #function-showBy}.
       * Element, Widget or Rectangle to which this Widget is constrained.
       * @config {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle}
       * @default document.body
       * @category Float & align
       */
      constrainTo: undefined,

      /**
       * Only valid if this Widget is {@link #config-floating} and being shown through {@link #function-showBy}.
       * `true` to show a connector arrow pointing to the align target.
       * @config {Boolean}
       * @default false
       * @category Float & align
       */
      anchor: null,

      /**
       * The owning Widget of this Widget. If this Widget is directly contained, this will be the containing Widget.
       * If there is a `forElement`, this config will be that element's encapsulating Widget.
       *
       * If this Widget is floating, this config must be specified by the developer.
       * @config {Core.widget.Widget}
       * @category Float & align
       */
      owner: null,

      /**
       * Defines what to do if document is scrolled while Widget is visible (only relevant when floating is set to true).
       * Valid values: ´null´: do nothing, ´hide´: hide the widget or ´realign´: realign to the target if possible.
       * @config {String}
       * @default
       * @category Float & align
       */
      scrollAction: null,

      /**
       * Only valid if this Widget is {@link #config-floating}. An object which defined which CSS style
       * property should be animated upon hide, and how it should be animated eg:
       *
       * ```javascript
       * {
       *    opacity: {
       *        to : 0,
       *        duration: '10s',
       *        delay: '0s'
       *    }
       * }
       * ```
       *
       * Set to `'false'` to disable animation.
       *
       * @config {Boolean|Object}
       * @category Float & align
       */
      hideAnimation: {
        $config: {
          merge: mergeAnim
        },
        value: null
      },

      /**
       * Only valid if this Widget is {@link #config-floating}. An object which defined which CSS style
       * property should be animated upon show, and how it should be animated eg:
       *
       * ```javascript
       * {
       *    opacity: {
       *        to : 1,
       *        duration: '10s',
       *        delay: '0s'
       *    }
       * }
       * ```
       *
       * Set to `'false'` to disable animation.
       *
       * @config {Boolean|Object}
       * @category Float & align
       */
      showAnimation: {
        $config: {
          merge: mergeAnim
        },
        value: null
      },

      /**
       * The x position for the widget.
       *
       * Only valid if this Widget is {@link #config-floating} and not aligned or anchored to an element.
       *
       * @config {Number}
       * @default
       * @category Float & align
       */
      x: null,

      /**
       * The y position for the widget.
       *
       * Only valid if this Widget is {@link #config-floating} and not aligned or anchored to an element.
       *
       * @config {Number}
       * @default
       * @category Float & align
       */
      y: null,

      /**
       * Accessor to the {@link Core.helper.util.Scroller} which can be used
       * to both set and read scroll information.
       * @member {Core.helper.util.Scroller} scrollable
       * @category Layout
       */

      /**
       * Specifies whether (and optionally in which axes) a Widget may scroll. `true` means this widget
       * may scroll in both axes. May be an object containing boolean `overflowX` and `overflowY` properties which are applied
       * to CSS style properties `overflowX` and `overflowY`. If they are boolean, they are translated
       * to CSS overflow properties thus:
       *
       * *`true` -> `'auto'`
       * *`false` -> `'hidden'`
       *
       * After initialization, this property yields a {@link Core.helper.util.Scroller} which may be used
       * to both set and read scroll information.
       *
       * A Widget uses its `get overflowElement` property to select which element is to be scrollable.
       * By default, in the base `Widget` class, this is the Widget's encapsulating element. Subclasses
       * may implement `get overflowElement` to scroll inner elements.
       * @config {Boolean|Object|Core.helper.util.Scroller}
       * @default false
       * @category Scrolling
       */
      scrollable: {
        $config: ['nullify'],
        value: null
      },

      /**
       * The class to instantiate to use as the {@link #config-scrollable}. Defaults to {@link Core.helper.util.Scroller}.
       * @internal
       * @config {Core.helper.util.Scroller}
       * @typings {typeof Scroller}
       * @category Scrolling
       */
      scrollerClass: _helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_14__["default"],

      /**
       * The name of the property to set when a single value is to be applied to this Widget. Such as when used
       * in a grid WidgetColumn, this is the property to which the column's `field` is applied.
       * @config {String}
       * @default 'html'
       * @category Misc
       */
      defaultBindProperty: 'html',

      /**
       * Event that should be considered the default action of the widget. When that event is triggered the
       * widget is also expected to trigger an `action` event. Purpose is to allow reacting to most widgets in
       * a coherent way.
       * @private
       * @config {String}
       * @category Misc
       */
      defaultAction: null,

      /**
       * When set to `true`, this widget is considered as a whole when processing {@link Core.widget.Toolbar}
       * overflow. When `false`, this widget's child items are considered instead.
       * @config {Boolean}
       * @default true
       * @category Layout
       * @internal
       */
      overflowable: {
        value: null,
        default: true,
        $config: null
      },

      /**
       * Widget's width, used to set element style.width. Either specify a valid width string or a number, which
       * will get 'px' appended. We recommend using CSS as the primary way to control width, but in some cases
       * this config is convenient.
       * @config {String|Number}
       * @category Layout
       */
      width: null,

      /**
       * Widget's height, used to set element style.height. Either specify a valid height string or a number, which
       * will get 'px' appended. We recommend using CSS as the primary way to control height, but in some cases
       * this config is convenient.
       * @config {String|Number}
       * @category Layout
       */
      height: null,

      /**
       * The element's maxHeight. Can be either a String or a Number (which will have 'px' appended). Note that
       * like {@link #config-height}, _reading_ the value will return the numeric value in pixels.
       * @config {String|Number}
       * @category Layout
       */
      maxHeight: null,

      /**
       * The elements maxWidth. Can be either a String or a Number (which will have 'px' appended). Note that
       * like {@link #config-width}, _reading_ the value will return the numeric value in pixels.
       * @config {String|Number}
       * @category Layout
       */
      maxWidth: null,

      /**
       * The elements minWidth. Can be either a String or a Number (which will have 'px' appended). Note that
       * like {@link #config-width}, _reading_ the value will return the numeric value in pixels.
       * @config {String|Number}
       * @category Layout
       */
      minWidth: null,

      /**
       * The element's minHeight. Can be either a String or a Number (which will have 'px' appended). Note that
       * like {@link #config-height}, _reading_ the value will return the numeric value in pixels.
       * @config {String|Number}
       * @category Layout
       */
      minHeight: null,
      // not public, only used by us in docs
      scaleToFitWidth: null,
      allowGrowWidth: true,
      // only used if scaleToFitWidth is true

      /**
       * Get element's margin property. This may be configured as a single number or a `TRBL` format string.
       * numeric-only values are interpreted as pixels.
       * @member {Number|String} margin
       * @category Layout
       */

      /**
       * Widget's margin. This may be configured as a single number or a `TRBL` format string.
       * numeric-only values are interpreted as pixels.
       * @config {Number|String}
       * @category Layout
       */
      margin: null,

      /**
       * Get element's flex property. This may be configured as a single number or a format string:
       *
       *      <flex-grow> <flex-shrink> <flex-basis>
       *
       * Numeric-only values are interpreted as the `flex-grow` value.
       * @member {Number|String} flex
       * @category Layout
       */

      /**
       * When this widget is a child of a {@link Core.widget.Container}, it will by default be participating in a
       * flexbox layout. This config allows you to set this widget's
       * <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex">flex</a> style.
       * This may be configured as a single number or a `<flex-grow> <flex-shrink> <flex-basis>` format string.
       * numeric-only values are interpreted as the `flex-grow` value.
       * @config {Number|String}
       * @category Layout
       */
      flex: null,

      /**
       * A widgets weight determines its position among siblings when added to a {@link Core.widget.Container}.
       * Higher weights go further down.
       * @config {Number}
       * @category Layout
       */
      weight: null,

      /**
       * Get/set this widget's `align-self` flexbox setting. This may be set to modify how this widget is aligned
       * within the cross axis of a flexbox layout container.
       * @member {String} alignSelf
       * @category Layout
       */

      /**
       * When this widget is a child of a {@link Core.widget.Container}, it will by default be participating in a
       * flexbox layout. This config allows you to set this widget's
       * <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-self">align-self</a> style.
       * @config {String}
       * @category Layout
       */
      alignSelf: null,

      /**
       * Configure as `true` to have the component display a translucent ripple when its
       * {@link #property-focusElement}, or {@link #property-element} is tapped *if the
       * current theme supports ripples*. Out of the box, only the Material theme supports ripples.
       *
       * This may also be a config object containing the following properties:
       *
       *  - `delegate  ` Optional. A CSS selector to filter which child elements trigger ripples. By default
       * the ripple is clipped to the triggering element.
       *  - `color     ` Optional, default = `#000`. A CSS color name or specification.
       *  - `radius    ` Optional, default is 100. The ending radius of the ripple.
       * Note that it will be clipped by the target element by default.
       *  - `clip      ` A string which describes how to clip the ripple if it is not to be clipped to the default
       * element. Either the property of the widget to use as the clipping element, or a selector to
       * allow clipping to the closest matching ancestor to the target element.
       *
       * eg:
       *```
       *    columns  : [{}...],
       *    ripple   : {
       *        color : 'red',
       *        clip  : '.b-grid-row'
       *    },
       *    ...
       *```
       * @config {Boolean|Object}
       * @category Misc
       */
      ripple: null,

      /**
       * A title to display for the widget. Only in effect when inside a container that uses it (such as TabPanel)
       * @default
       * @config {String}
       * @category DOM
       */
      title: null,
      localizableProperties: ['title'],
      // Set this flag to require element to have a size to be considered visible
      requireSize: false,

      /**
       * An identifier by which this widget will be registered in the {@link Core.widget.Container#property-widgetMap}
       * of all ancestor containers.
       *
       * If omitted, this widget will be registered using its {@link #config-id}. In most cases `ref` is
       * preferable over `id` since `id` is required to be globally unique while `ref` is not.
       *
       * The `ref` value is also added to the elements dataset, to allow targeting it using CSS etc.
       * @default
       * @config {String}
       * @category Misc
       */
      ref: null,

      /**
       * Get/set the widget hidden state.
       *
       * Note: `hidden : false` does *not* mean that this widget is definitely visible.
       * To ascertain visibility, use the {@link #property-isVisible} property.
       * @member {Boolean} hidden
       * @category Visibility
       */

      /**
       * Configure with true to make widget initially hidden.
       * @default false
       * @config {Boolean}
       * @category Layout
       */
      hidden: null,

      /**
       * Text alignment: 'left', 'center' or 'right'. Applied by adding a `b-text-align-xx` class to the widgets
       * element. Blank by default, which does not add any alignment class.
       * @config {String}
       * @category Layout
       */
      textAlign: null,
      // When adding our scroll listeners to hide/realign, we ignore events
      // happening too quickly as a result of the show/align action
      ignoreScrollDuration: 500,

      /**
       * The tag name of this Widget's root element
       * @config {String}
       * @default
       * @category DOM
       */
      tag: 'div',

      /**
       * Set this config to `false` to disable batching DOM updates on animation frames for this widget. This
       * has the effect of synchronously updating the DOM when configs affecting the rendered DOM are modified.
       * Depending on the situation, this could simplify code while increasing time spent updating the DOM.
       * @config {Boolean}
       * @default true
       * @internal
       */
      recomposeAsync: null,

      /**
       * If you are rendering this widget to a shadow root inside a web component, set this config to the shadowRoot
       * @config {ShadowRoot}
       * @default
       * @category Misc
       */
      rootElement: null,
      htmlMutationObserver: {
        $config: ['lazy', 'nullify'],
        value: {
          childList: true,
          subtree: true
        }
      }
    };
  }

  static get prototypeProperties() {
    return {
      /**
       * true if no id was set, will use generated id instead (widget1, ...). Toggle automatically on creation
       * @member {Boolean} hasGeneratedId
       * @private
       * @category Misc
       */
      hasGeneratedId: false,

      /**
       * This readonly property is `true` for normal widgets in the {@link Core.widget.Container#config-items} of
       * a container. It is `false` for special widgets such as a {@link Core.widget.Panel#config-tbar}.
       * @member {Boolean} innerItem
       * @internal
       * @category Misc
       */
      innerItem: true
    };
  }

  static get declarable() {
    return [
    /**
     * This property declares the set of config properties that affect a Widget's rendering, i.e., the configs
     * used by the {@link #function-compose} method.
     *
     * For example:
     * ```javascript
     *  class Button extends Widget {
     *      static get renderConfigs() {
     *          return [ 'cls', 'iconCls', 'text' ];
     *      }
     *  }
     * ```
     *
     * Alternatively this can be an object:
     *
     * ```javascript
     *  class Button extends Widget {
     *      static get renderConfigs() {
     *          return {
     *              cls     : true,
     *              iconCls : true,
     *              text    : true
     *          };
     *      }
     *  }
     * ```
     * @member {Object|String[]} renderConfigs
     * @static
     * @category Configuration
     * @internal
     */
    'renderConfigs'];
  }
  /**
   * An object providing the `record` and `column` for a widget embedded inside a {@link Grid.column.WidgetColumn}
   *
   * ```javascript
   * columns : [
   *    {
   *        type   : 'widget',
   *        widgets: [{
   *            type     : 'button',
   *            icon     : 'b-fa b-fa-trash',
   *            onAction : ({ source : btn }) => btn.cellInfo.record.remove()
   *        }]
   *    }
   * ]
   * ```
   * @readonly
   * @member {Object} cellInfo
   * @property {Core.data.Model} cellInfo.record
   * @property {Grid.column.Column} cellInfo.column
   * @category Misc
   */


  static get delayable() {
    return {
      recompose: 'raf',
      doHideOrRealign: 'raf'
    };
  }

  static get factoryable() {
    return {
      defaultType: 'widget'
    };
  }

  static get identifiable() {
    return {};
  }
  /**
   * Returns an array containing all existing Widgets. The returned array is generated by this call and is not an
   * internal structure.
   * @property {Core.widget.Widget[]}
   * @readonly
   * @internal
   */


  static get all() {
    return super.all;
  }
  /**
   * Get/set the {@link #config-recomposeAsync} config for all widgets. Setting this value will set the config for
   * all existing widgets and will be the default value for newly created widgets. Set this value to `null` to disable
   * the default setting for new widgets while leaving existing widgets unaffected.
   * @property {Boolean}
   * @internal
   */


  static get recomposeAsync() {
    return Widget._recomposeAsync;
  }

  static set recomposeAsync(value) {
    Widget._recomposeAsync = value;

    if (value != null) {
      const {
        all
      } = Widget;

      for (let i = 0; i < all.length; ++i) {
        if (all[i].isComposable) {
          all[i].recomposeAsync = value;
        }
      }
    }
  }

  isType(type, deep) {
    return Widget.isType(this, type, deep);
  }

  static setupRenderConfigs(cls, meta) {
    let {
      renderConfigs
    } = cls,
        i;

    if (renderConfigs) {
      const obj = // Once a class declares renderConfigs, those are inherited and augmented:
      meta.getInherited('renderConfigs',
      /* create = */
      false) || // Otherwise, since renderConfigs are declared on this class, we need to create them:
      Object.create(null);

      if (Array.isArray(renderConfigs)) {
        // Ex: renderConfigs: ['cls', 'text']
        for (i = 0; i < renderConfigs.length; ++i) {
          obj[renderConfigs[i]] = true;
        }

        renderConfigs = obj;
      } else {
        // Ex: renderConfigs: { cls : true, text : true }
        renderConfigs = Object.assign(obj, renderConfigs);
      }
    } // else a class may declare renderConfigs=null to re-enable auto detection


    meta.renderConfigs = renderConfigs;
  }
  /**
   * Call once per class for custom widgets to have them register with the `Widget` class, allowing them to be created
   * by type.
   *
   * For example:
   * ```javascript
   * class MyWidget extends Widget {
   *   static get type() {
   *     return 'mywidget';
   *   }
   * }
   * MyWidget.initClass();
   * ```
   * @method initClass
   * @static
   * @category Lifecycle
   */
  //endregion
  //region Init & destroy


  construct(config = {}, ...args) {
    const me = this,
          {
      domSyncCallback
    } = me;
    me._isAnimatingCounter = 0; // Flag so we know when our dimensions have been constrained during alignment

    me.alignConstrained = 0;
    me.byRef = Object.create(null);
    me.callRealign = me.realign.bind(me);
    me.onFullscreenChange = me.onFullscreenChange.bind(me);
    me.domSyncCallback = domSyncCallback.$nullFn ? null : domSyncCallback.bind(me);
    me._isUserAction = false; // Base class applies configs.

    super.construct(config, ...args);
    const {
      recomposeAsync
    } = Widget;

    if (recomposeAsync != null && me.recomposeAsync == null) {
      me.recomposeAsync = recomposeAsync;
    }

    me.finalizeInit();
  }

  startConfigure(config) {
    const me = this,
          // This will run the element change/update process if it was not kicked off by a derived class impl of
    // this method:
    {
      adopt,
      element
    } = me;

    if (adopt) {
      // Adopt the preexisting element as our element before configuration proceeds.
      me.adoptElement(element, adopt, config.id);
      me.updateElement(me._element, element);
    }

    super.startConfigure(config);
  }
  /**
   * Called by the Base constructor after all configs have been applied.
   * @internal
   * @category Lifecycle
   */


  finalizeInit() {
    if (this.insertBefore || this.appendTo || this.insertFirst || this.adopt) {
      this.render();
    }
  }

  doDestroy() {
    const me = this,
          {
      preExistingElements,
      element,
      _refListeners
    } = me;

    if (_refListeners) {
      Object.values(_refListeners, un => un());
      me._refListeners = null;
    }

    if (element) {
      var _Widget$Tooltip, _me$dragEventDetacher, _me$dragOverEventDeta;

      const sharedTooltip = !me._tooltip && me._rootElement && ((_Widget$Tooltip = Widget.Tooltip) === null || _Widget$Tooltip === void 0 ? void 0 : _Widget$Tooltip.getSharedTooltip(me._rootElement, true)); // If we are current user of the shared tooltip, hide it

      if ((sharedTooltip === null || sharedTooltip === void 0 ? void 0 : sharedTooltip.owner) === me) {
        sharedTooltip.owner = null;
        sharedTooltip.hide();
      }

      me.onExitFullscreen(); // If we get destroyed very quickly after a call to show,
      // we must kill the timers which add the realign listeners.

      me.clearTimeout(me.scrollListenerTimeout);
      me.clearTimeout(me.resizeListenerTimeout); // Remove listeners which are only added during the visible phase.
      // In its own method because it's called on hide and destroy.

      me.removeTransientListeners();

      if (me.floating || me.positioned) {
        // Hide without animation, destruction is sync
        me.hide(false);
      } else {
        me.revertFocus();
      }

      _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(element.parentElement, me.onParentElementResize);
      _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(element, me.onElementResize); // Remove elements *which we own* on destroy,

      if (me.adopt) {
        for (let nodes = Array.from(element.childNodes), i = 0, {
          length
        } = nodes; i < length; i++) {
          const el = nodes[i]; // If it's not preexisting, and not the floatRoot, remove it

          if (!preExistingElements.includes(el) && el !== me.floatRoot) {
            el.remove();
          }
        }

        element.className = me.adoptedElementClassName;
        element.style.cssText = me.adoptedElementCssText;
      } else {
        element.remove();
      }

      (_me$dragEventDetacher = me.dragEventDetacher) === null || _me$dragEventDetacher === void 0 ? void 0 : _me$dragEventDetacher.call(me);
      (_me$dragOverEventDeta = me.dragOverEventDetacher) === null || _me$dragOverEventDeta === void 0 ? void 0 : _me$dragOverEventDeta.call(me);
      me.dragGhost.remove();
    }

    super.doDestroy();
  } //endregion
  //---------------------------------------------------------------------------------------------------------
  //region Render

  /**
   * Returns `true` if this class uses `compose()` to render itself.
   * @returns {Boolean}
   * @internal
   */


  get isComposable() {
    return !this.compose.$nullFn;
  }

  adoptElement(element, adopt, id) {
    const me = this,
          adoptElement = typeof adopt === 'string' ? document.getElementById(adopt) : adopt,
          previousHolder = Widget.fromElement(adoptElement); // If we are taking it over from a previous iteration, destroy the previous holder. This is not officially
    // supported, but CodeEditor relies on it working

    if (previousHolder && previousHolder.adopt && previousHolder !== me) {
      const previousHolderAdopt = typeof previousHolder.adopt === 'string' ? document.getElementById(previousHolder.adopt) : previousHolder.adopt;

      if (previousHolderAdopt === adoptElement) {
        previousHolder.destroy();
      }
    } // On destroy, leave these


    me.preExistingElements = Array.from(adoptElement.childNodes);
    me.adoptedElementClassName = adoptElement.className;
    me.adoptedElementCssText = adoptElement.style.cssText; // Adopt the host element's id if we don't have one so that we do not override
    // it and invalidate any ad-based CSS rules.

    if (adoptElement.id && !id) {
      me.id = element.id = adoptElement.id;
    }

    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].syncAttributes(element, adoptElement);

    for (let i = 0, {
      length
    } = element.childNodes; i < length; i++) {
      adoptElement.appendChild(element.childNodes[0]);
    }

    delete me._contentRange; // Silently update our element config (do not re-run change/update cycle):

    me._element = adoptElement;
    const domConfig = element.lastDomConfig,
          listeners = domConfig === null || domConfig === void 0 ? void 0 : domConfig.listeners;

    if (listeners && me.isComposable) {
      var _listeners$un;

      (_listeners$un = listeners.un) === null || _listeners$un === void 0 ? void 0 : _listeners$un.call(listeners);
      addElementListeners(me, adoptElement, domConfig);
    } // Maintain DomSync internal state from our original element:


    adoptElement.lastDomConfig = domConfig || adoptElement.lastDomConfig;
    adoptElement.$refOwnerId = me.id;

    if (!me.scaleToFitWidth) {
      me.getConfig('monitorResize');
    }
  }
  /**
   * Defines an element reference accessor on the class prototype. This accessor is used to flush any pending DOM
   * changes prior to accessing such elements.
   * @param {String} name
   * @param {String} key
   * @private
   */


  addRefAccessor(name, key) {
    const {
      prototype
    } = this.constructor;
    defineProperty(prototype, key, {
      writable: true,
      value: null
    });
    defineProperty(prototype, name, {
      get() {
        // Asking for a ref el is a good sign that we need to sync the DOM:
        this.recompose.flush();
        return this[key];
      },

      set(el) {
        this[key] = el;
      }

    });
  }
  /**
   * This method is called by `DomHelper.createElement` and `DomSync.sync` as new reference elements are created.
   * @param {String} name The name of the element, i.e., the value of its `reference` attribute.
   * @param {HTMLElement} el The element instance
   * @param {Object} [domConfig] The DOM config object.
   * @internal
   */


  attachRef(name, el, domConfig) {
    const me = this,
          key = '_' + name; // Key elements contain owner pointer if data is supported (Not on IE SVG).

    el.dataset && (el.dataset.ownerCmp = me.id);

    if (me.isComposable) {
      if (!(key in me)) {
        me.addRefAccessor(name, key);
      }

      addElementListeners(me, el, domConfig, name);
    }

    me.byRef[name] = el;
    me[name] = el;
  }
  /**
   * This method is called by `DomSync.sync` as reference elements are removed from the DOM.
   * @param {String} name The name of the element, i.e., the value of its `reference` attribute.
   * @param {HTMLElement} el The element instance
   * @param {Object} domConfig The DOM config object.
   * @internal
   */


  detachRef(name, el, domConfig) {
    const me = this,
          listeners = me._refListeners;

    if (listeners !== null && listeners !== void 0 && listeners[name]) {
      listeners[name]();
      delete listeners[name];
    }

    me[name] = null;
    delete me.byRef[name];
  }
  /**
   * This method is called following an update to the widget's rendered DOM.
   * @internal
   */


  afterRecompose() {// empty
  }
  /**
   * Returns a {@link Core.helper.DomHelper#function-createElement-static} config object that defines this widget's
   * DOM structure. This object should be determined using {@link Core.Base#property-configurable-static} properties
   * to ensure this method is called again if these properties are modified.
   *
   * For more information see {@link Core.widget.Widget class documentation}.
   * @returns {Object}
   */


  compose() {
    const classes = _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].normalize(this.widgetClassList, 'object');
    return {
      class: classes
    };
  }
  /**
   * This method iterates the class hierarchy from Widget down to the class of this instance and calls any `compose`
   * methods implemented by derived classes.
   * @returns {Object}
   * @private
   */


  doCompose() {
    const me = this,
          {
      $meta: meta
    } = me,
          classes = meta.hierarchy;
    let {
      composers
    } = meta,
        domConfig = null,
        c,
        key,
        firstTime,
        i,
        proto,
        renderConfigs;
    me.recompose.suspend();

    if (!composers) {
      firstTime = true;
      meta.composers = composers = []; // Widget starts the process w/the widgetClassList

      for (i = classes.indexOf(Widget); i < classes.length; ++i) {
        proto = classes[i].prototype;

        if (hasOwnProperty.call(proto, 'compose')) {
          composers.push(proto);
        }
      } // See if the class (or a super class) has declared its `renderConfigs`. If so, we use them.


      if (!(renderConfigs = meta.getInherited('renderConfigs',
      /* create = */
      false))) {
        // If not, we create a Proxy or proxy-like object that can detect getter calls to determine them. While
        // technically the getters may not all trigger on any given rendering, we ignore this due to the high
        // cost of supporting such arbitrary compose() methods. By convention, compose() must read configs
        // consistently.
        renderConfigs = Object.create(null); // On the first composition for this class, watch the config properties that are read to auto populate
        // the renderConfigs:

        me.configObserver = {
          get(name) {
            renderConfigs[name] = true;
          }

        };
      }

      meta.$renderConfigs = renderConfigs;
    } // This loop always runs at least once due to Widget base class, so ret will be assigned here:


    for (i = 0; i < composers.length; ++i) {
      c = composers[i].compose.call(me, domConfig);
      domConfig = domConfig ? _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge(domConfig, c) : c;
    }

    if (hasOwnProperty.call(me, 'compose') && (c = me.compose)) {
      c = c.call(me, domConfig);
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].merge(domConfig, c);
    }

    firstTime && delete me.configObserver; // When converting a children:{} into an array, we take a moment to ensure we have an accessor defined for
    // the element. This is needed if the element is initially unrendered since we need the accessor to flush a
    // pending recompose through just in time via the reference element getter.

    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].normalizeChildren(domConfig, (childName, hoist) => {
      // Only care about refs that should be hoisted up to us
      if (hoist) {
        key = '_' + childName;

        if (!(key in me)) {
          me.addRefAccessor(childName, key);
        }
      }
    });
  }

  get element() {
    // NOTE: We can replace the getter of a config property
    if (this.isComposable && !this.isDestroying) {
      // Asking for the primary el is a good sign that we need to sync the DOM:
      this.recompose.flush();
    }

    return this._element;
  }
  /**
   * Template method called during DOM updates. See {@link Core.helper.DomSync#function-sync-static DomSync.sync()}.
   * @param {Object} info Properties describing the sync action taken.
   * @internal
   */


  domSyncCallback(info) {// bound in construct. Override in subclass
  }

  changeElement(element) {
    const me = this,
          compose = me.isComposable;

    if (compose) {
      element = me.doCompose();
    }

    if (typeof element === 'string') {
      element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElementFromTemplate(element);
    } else if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isObject(element)) {
      element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement(element, {
        refOwner: me,
        callback: me.domSyncCallback // mimic DomSync callbacks (needed by TaskBoard)

      });
      me.recompose.resume();
      compose && addElementListeners(me, element, element.lastDomConfig);
    } else if (element.nodeType !== 1) {
      element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElementFromTemplate(me.template(me));
    }

    element.id = me.id;

    if (me.elementAttributes) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setAttributes(element, me.elementAttributes);
    }

    return element;
  }

  updateElement(element) {
    const me = this,
          {
      className
    } = element,
          {
      contentElement,
      contentElementCls,
      isComposable
    } = me,
          hasChildContent = contentElement !== element,
          namedElements = !isComposable && element.querySelectorAll('[data-reference]'),
          // Start with the hierarchy classes, eg ['b-combo b-pickerfield b-textfield b-widget']
    classes = isComposable ? [] : me.widgetClassList; // a dynamic array that we can safely modify
    // The ui classes need to put on the content element even if isComposable, but widgetClassList contains the
    // ui classes, so we don't need to do that if the main element is the contentElement

    let uiClasses = (hasChildContent || !isComposable) && me.uiClasses;
    className && classes.unshift(className);
    me._hidden && classes.push('b-hidden');
    me._readOnly && classes.push('b-readonly'); // Calling element.remove() when we have the focus can result in a DOMException (notably when a blur/focusout
    // handler reentrancy results in a remove):
    //  DOMException: Failed to execute 'remove' on 'Element': The node to be removed is no longer a child
    //  of this node. Perhaps it was moved in a 'blur' event handler?

    _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].noThrow(element, 'remove'
    /*, () => { debugger; } /**/
    ); // delete "/*" to break on exception

    if (uiClasses) {
      if (contentElementCls !== null && contentElementCls !== void 0 && contentElementCls.value) {
        uiClasses = uiClasses.slice(); // clone cached array

        uiClasses.push(contentElementCls.value);
      }

      uiClasses = uiClasses.join(' ');
    } else {
      uiClasses = contentElementCls === null || contentElementCls === void 0 ? void 0 : contentElementCls.value;
    }

    if (uiClasses) {
      if (hasChildContent) {
        contentElement.className += ' ' + uiClasses;
      } else {
        classes.push(uiClasses);
      }
    } // The environmental classes only need to be added to outermost Widgets.
    // If we have a parent container, that will have them.


    if (!me.parent) {
      const {
        defaultCls
      } = me,
            {
        outerCls
      } = Widget;
      classes.push(...(defaultCls ? outerCls.filter(c => !(c in defaultCls) || defaultCls[c]) : outerCls));
    }

    element.className = classes.join(' ');

    if (namedElements) {
      for (let el, i = 0; i < namedElements.length; ++i) {
        el = namedElements[i];
        me.attachRef(el.getAttribute('data-reference'), el);
        el.removeAttribute('data-reference');
      }
    } // Mutually exclusive with scaleToFitWidth.
    // Observe container element before the cascade down to descendants.
    // Outer elements are expected to fire resize first.
    // It's a lazy config, so this is the time to flush it through to begin monitoring.


    if (!me.adopt && !me.scaleToFitWidth) {
      me.getConfig('monitorResize');
    } // Ensure our content mutation observer keeps us informed of changes by third parties
    // so that our config system can keep up to date.


    if (me._html) {
      me.getConfig('htmlMutationObserver');
    }
  }

  isCollapsified(collapsed, overlay) {
    const {
      collapsify
    } = this; // false => widget is unaffected when the panel is collapsed (always in main header)
    // 'hide' => widget is hidden when the panel is collapsed (but still in main header)

    let ret = !overlay;

    if (collapsify == null) {
      // widget is moved to the overlay when collapsed
      ret = overlay ? collapsed : !collapsed;
    } else if (collapsify === 'overlay') {
      // widget always appears in the overlay
      ret = overlay;
    }

    return Boolean(ret);
  }
  /**
   * Calling this {@link Core.mixin.Delayable#property-delayable-static} method marks this widget as dirty. The DOM
   * will be updated on the next animation frame:
   *
   * ```javascript
   *  widget.recompose();
   *
   *  console.log(widget.recompose.isPending);
   *  > true
   * ```
   *
   * A pending update can be flushed by calling `flush()` (this does nothing if no update is pending):
   *
   * ```javascript
   *  widget.recompose.flush();
   * ```
   *
   * This can be combined in one call to force a DOM update without first scheduling one:
   *
   * ```javascript
   *  widget.recompose.now();
   * ```
   */


  async recompose() {
    const me = this,
          options = {
      targetElement: me.element,
      domConfig: me.doCompose(),
      refOwner: me,
      callback: me.domSyncCallback,
      // This limits the sync() to only removing the classes and styles added by previous renderings. This
      // allows dynamically added styles and classes to be preserved:
      strict: true
    };

    if (me.transitionRecompose) {
      me.isTransitioningDom = true;
      await _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].transition(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].assign({
        element: me.element,

        action() {
          _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_5__["default"].sync(options);
        }

      }, me.transitionRecompose));

      if (me.isDestroyed) {
        return;
      }

      me.isTransitioningDom = false;
      me.trigger('transitionedRecompose');
    } else {
      _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_5__["default"].sync(options);
    }

    if (options.changed) {
      me.afterRecompose();
    }

    me.recompose.resume();
  }

  render(parentElement = this.appendTo, triggerPaint = true) {
    const me = this,
          {
      element
    } = me;
    me.emptyCache();

    if (me.syncElement && me.currentElement) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].sync(element, me.currentElement);
    } else {
      var _parentElement;

      let insertBefore = me.insertBefore;

      if (me.insertFirst) {
        parentElement = me.insertFirst;
        insertBefore = parentElement.firstChild;
      }

      if (typeof parentElement === 'string') {
        const id = parentElement;
        parentElement = document.getElementById(parentElement);

        if (!parentElement) {
          throw new Error(`No element found with id '${id}'`);
        }

        if (me.insertFirst) {
          insertBefore = parentElement.firstChild;
        }
      }

      if (insertBefore) {
        if (typeof insertBefore === 'string') {
          const id = insertBefore;
          insertBefore = document.getElementById(insertBefore);

          if (!insertBefore) {
            throw new Error(`No element found with id '${id}'`);
          }
        }

        if (!parentElement) {
          parentElement = insertBefore.parentElement;
        }
      }

      (_parentElement = parentElement) === null || _parentElement === void 0 ? void 0 : _parentElement.insertBefore(element, insertBefore);
      me.currentElement = element;
    } // The environmental classes only need to be added to a naked Widget.
    // If we are inside a Widget's element, that will have them.


    if (Widget.fromElement(element.parentElement)) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].removeClasses(element, Widget.outerCls);
    }

    me.rendered = true;

    if (triggerPaint) {
      me.getConfig('contentRange');
      me.triggerPaint();
    }

    me.setupFocusListeners();
  }
  /**
   * A function which, when passed an instance of this Widget, produces a valid HTML string which is compiled
   * to create the encapsulating element for this Widget, and its own internal DOM structure.
   *
   * Note that this just creates the DOM structure that *this* Widget owns. If it contains child widgets
   * (Such as for example a grid), this is not included. The template creates own structure.
   *
   * Certain elements within the generated element can be identified as special elements with a `reference="name"`
   * property. These will be extracted from the element upon creation and injected as the named property into
   * the Widget. For example, a {@link Core.widget.TextField} will have an `input` property which is its
   * `<input>` element.
   * @param {Core.widget.Widget} me The widget for which to produce the initial HTML structure.
   * @internal
   */


  template({
    tag,
    html,
    htmlCls,
    name
  }) {
    const content = html !== null && html !== void 0 && html.call ? html.call(this) : html;
    return `<${tag} class="${content ? htmlCls : ''}" ${name ? `data-name="${name}"` : ''}>${content || ''}</${tag}>`;
  }

  updateRecomposeAsync(async) {
    this.recompose.immediate = !async;
  } //endregion
  //---------------------------------------------------------------------------------------------------------


  onConfigChange({
    name
  }) {
    var _this$$meta$$renderCo;

    // The $renderConfigs object is either on our prototype (due to renderConfigs getter) or on our instance (due
    // to "get composer") unless we are not using compose(), in which case it will be null:
    if (this._element && !this.isDestroying && (_this$$meta$$renderCo = this.$meta.$renderConfigs) !== null && _this$$meta$$renderCo !== void 0 && _this$$meta$$renderCo[name]) {
      this.recompose();
    }
  }
  /**
   * Get widgets elements dataset or assign to it
   * @property {Object}
   * @category DOM
   */


  get dataset() {
    return this.element.dataset;
  }

  changeDataset(dataset) {
    Object.assign(this.dataset, dataset);
  }

  get dragGhost() {
    return this.constructor._dragGhost || (this.constructor._dragGhost = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement({
      // Safari won't allow dragging an empty node
      html: '\xa0',
      style: 'position:absolute;top:-10000em;left:-10000em'
    }));
  }

  updateParent(parent) {
    const {
      _element: element
    } = this;

    if (element) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"][parent ? 'removeClasses' : 'addClasses'](element, Widget.outerCls);
    }
  }

  get constrainTo() {
    const ret = this._constrainTo;
    return ret === undefined ? window : ret;
  }

  updateCentered(value) {
    const {
      element,
      _anchorElement
    } = this;

    if (value && !this.floating && !this.positioned) {
      throw new Error('`centered` is only relevant when a Widget is `floating` or `positioned`');
    }

    if (value) {
      element.classList.add('b-centered');
      element.style.transform = element.style.left = element.style.top = '';
      _anchorElement === null || _anchorElement === void 0 ? void 0 : _anchorElement.classList.add('b-hide-display');
      element.classList.remove('b-anchored');
    } else {
      element.classList.remove('b-centered');
    }
  }
  /**
   * The child element into which content should be placed. This means where {@link #config-html} should be put,
   * or, for {@link Core.widget.Container Container}s, where child items should be rendered.
   * @property {HTMLElement}
   * @readonly
   * @category DOM
   */


  get contentElement() {
    return this.element;
  }

  get contentRange() {
    const me = this,
          {
      contentElement
    } = me,
          contentRange = me._contentRange || (me._contentRange = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11 ? document.createRange() : new Range()); // Initialize the contentRange if it's collapsed.
    // It gets collapsed if the widget's element is removed from the DOM.

    if (contentRange.collapsed) {
      contentRange.setStart(contentElement, me.contentRangeStartOffset || 0);
      contentRange.setEnd(contentElement, me.contentRangeEndOffset || contentElement.childNodes.length);
    }

    return contentRange;
  }
  /**
   * This method fixes the element's `$refOwnerId` when this instance's `id` is changing.
   * @param {Node} el The element or DOM node to fix.
   * @param {String} id The new id being assigned.
   * @param {String} oldId The old id (previously assigned).
   * @private
   */


  fixRefOwnerId(el, id, oldId) {
    if (el.$refOwnerId === oldId) {
      el.$refOwnerId = id;

      for (let {
        childNodes
      } = el, i = childNodes.length; i-- > 0;) {
        this.fixRefOwnerId(childNodes[i], id, oldId);
      }
    }
  }

  get placement() {
    const me = this,
          {
      element
    } = me;
    let adjRect, placement, rect;

    if (element !== null && element !== void 0 && element.offsetParent && !nonFlowedPositions.test(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, 'position'))) {
      const next = element.nextElementSibling,
            previous = element.previousElementSibling,
            last = !next && previous;
      placement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element.parentElement, 'flex-direction'); // If used in a flex layout, determine orientation from flex-direction

      if (placement) {
        placement = placement.startsWith('row') ? 'h' : 'v';
      } else {
        var _ref;

        adjRect = (_ref = next || previous) === null || _ref === void 0 ? void 0 : _ref.getBoundingClientRect();
        rect = adjRect && element.getBoundingClientRect();
        placement = adjRect && Math.abs(adjRect.top - rect.top) < Math.abs(adjRect.left - rect.left) ? 'h' : 'v'; // if there is another item, check for more horz delta than vert and if so, call it a horz container
      }

      placement += placement === 'h' ? last ? 'r' : 'l' : last ? 'b' : 't';
    }

    return placement;
  }

  updateId(id, oldId) {
    super.updateId(id, oldId);

    if (oldId) {
      // NOTE this happens when we adopt an element w/an assigned id...
      const {
        byRef,
        element
      } = this;

      for (const ref in byRef) {
        byRef[ref].dataset && (byRef[ref].dataset.ownerCmp = id); // SVG elements have no dataset
      }

      element.id = id;
      this.fixRefOwnerId(element, id, oldId);
    }
  }
  /**
   * Get/set widgets elements style. The setter accepts a cssText string or a style config object, the getter always
   * returns a CSSStyleDeclaration
   * @property {CSSStyleDeclaration}
   * @accepts {String|Object|CSSStyleDeclaration}
   * @category DOM
   */


  get style() {
    const {
      element
    } = this;
    return (element === null || element === void 0 ? void 0 : element.ownerDocument.defaultView.getComputedStyle(element)) || this._style;
  }

  updateStyle(style) {
    this.element && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].applyStyle(this.element, style);
  }

  updateTitle(title) {
    if (this.titleElement) {
      this.titleElement.innerHTML = title;
    }
  } //region floating

  /**
   * If this Widget is {@link #config-floating} or {@link #config-positioned}, and visible,
   * aligns the widget according to the passed specification. To stop aligning, call this method without arguments.
   * For details, see the {@link #function-showBy} method.
   * @param {Object} [spec] Alignment options. May be an object as processed by the {@link #function-showBy} method,
   * or an `HTMLElement` to align to using this Widget's {@link #config-align} configuration.
   * @category Float & align
   */


  alignTo(spec) {
    var _anchor;

    const me = this,
          {
      lastAlignSpec,
      element
    } = me,
          {
      offsetParent,
      style,
      classList
    } = element;

    if (lastAlignSpec) {
      // Remove intersection observation from our previous align target element.
      lastAlignSpec.monitorIntersection && me.intersectionObserver.unobserve(lastAlignSpec.target); // Ensure marker class of previous alignment side is removed.

      if (isFinite(lastAlignSpec.zone)) {
        element.classList.remove(alignedClass[lastAlignSpec.zone]);
      }
    }

    if (!spec) {
      me.removeTransientListeners();
      me.anchor = me.lastAlignSpec = null;
      return;
    } // You can "alignTo" an element or a Widget or a Point, and allow our align config.
    // property to specify how.


    if (spec.nodeType === Element.ELEMENT_NODE || spec instanceof Widget || spec.$$name === 'Point') {
      spec = {
        target: spec
      };
    } // Release size constraints so we can align from scratch each time.


    me.releaseSizeConstraints();
    const {
      scrollable,
      constrainTo
    } = me,
          positioned = me.positioned && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, 'position') !== 'fixed',
          scale = me.scale || 1,
          passedTarget = spec.target,
          target = passedTarget && (passedTarget.isRectangle ? passedTarget : passedTarget.element || passedTarget),
          myPosition = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(element, positioned ? offsetParent : null, true),
          {
      width: startWidth,
      height: startHeight
    } = myPosition,
          aligningToElement = target && target.nodeType === Element.ELEMENT_NODE;
    spec = spec.realignTarget ? spec : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].assign({
      aligningToElement,
      constrainTo,
      align: 'b-t',
      // we can end up w/o a value for this if an object replaces a string
      axisLock: me.axisLock,
      anchor: me.anchor
    }, me.align, spec); // As part of fallback process when fitting within constraints, this may shrink to minima specified
    // either on the align spec or the widget itself.

    const minWidth = spec.minWidth || me.minWidth,
          minHeight = spec.minHeight || me.minHeight; // Minima have a different meaning in an alignRectangle.
    // It means that the rectangle is willing to shrink down
    // to that size during constraint, *not* that it can never
    // be smaller than that size.

    myPosition.isAlignRectangle = true;
    minWidth && (myPosition.minWidth = minWidth * scale);
    minHeight && (myPosition.minHeight = minHeight * scale); // This is used by the realign call which may be called either when a global scroll is detected
    // or the constraining element is resized.

    me.lastAlignSpec = spec;

    if (aligningToElement && Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["hasLayout"])(target.offsetParent)) {
      // Don't destroy the spec which was cached above with the element in it.
      spec = Object.setPrototypeOf({}, spec); // If we are being called from realign, there will be a realignTarget present which is
      // a viewport-based *visible* rectangle. Otherwise translate the element into a browser
      // viewport based Rectangle. Rectangle doesn't have the knowledge that we do to make this
      // decision. Floating alignment all takes place within browser viewport space, not document
      // space.

      spec.target = spec.realignTarget || _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(target, positioned ? offsetParent : null, !positioned); // Force the target to have an area so that intersect works.

      spec.target.height = Math.max(spec.target.height, 1);
      spec.target.width = Math.max(spec.target.width, 1); // This is the element which determines our position.
      // This is used in doHideOrRealign to see if a scroll event
      // will have affected our position.

      me.anchoredTo = target;
    } else {
      me.anchoredTo = null;
    }

    if (spec.anchor) {
      spec.anchorSize = me.anchorSize;

      if (!element.contains(me.anchorPathElement)) {
        element.appendChild(me.anchorElement);
      }
    } // If we're positioned, any constrainTo must be a Rectangle in our offsetParent's coordinate space


    if (positioned) {
      // We can't be seen outside our offsetParent, so that's the de-facto costrainTo
      // regardless of what is passed.
      if (offsetParent && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(offsetParent, 'overflow') === 'hidden') {
        spec.constrainTo = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(offsetParent).moveTo(0, 0);
      } else if (constrainTo && !constrainTo.isRectangle) {
        const isViewport = constrainTo === document || constrainTo === window;
        spec.constrainTo = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(spec.constrainTo, offsetParent);

        if (isViewport) {
          spec.constrainTo.translate(window.pageXOffset, window.pageYOffset);
        }
      }
    } // Flag to prevent infinite loop when setting html from a beforeAlign listener


    me.isAligning = true; // Allow outside world to modify the suggested position

    me.trigger('beforeAlign', spec);
    me.isAligning = false; // Calculate the best position WRT target rectangle, our rectangle, a constrainTo rectangle
    // and the rectangle of an anchor pointer.

    const result = myPosition.alignTo(spec); // May change if constraint changes our shape, and we have to go round again

    let {
      align,
      anchor,
      x,
      y,
      width,
      height,
      overlap
    } = result; // Which zone, T=0, R=1, B=2, L=3 the result is in

    me.lastAlignSpec.zone = result.zone; // If the alignment specified that we must constrain a dimension in order to
    // fit within our constrainTo, then obey that. If we own a Scroller, then
    // inform it that we do now need to scroll that dimension.
    // These conditions are released upon each alignment call because conditions may change.

    if (height != startHeight) {
      if (!('configuredHeight' in me)) {
        me.configuredHeight = style.height;
      }

      me.height = height / scale;
      me.alignConstrained = me.alignConstrained | 1;

      if (scrollable) {
        scrollable.overflowY = true;
      }
    }

    if (width != startWidth) {
      if (!('configuredWidth' in me)) {
        me.configuredWidth = style.width;
      }

      me.width = width / scale;
      me.alignConstrained = me.alignConstrained | 2;

      if (scrollable) {
        scrollable.overflowX = scrollable.clientWidth > scrollable.scrollWidth;
      }
    } // If either dimension has been constrained, we may have changed shape
    // due to text wrapping/overflowing, so we have to realign at the
    // successful align setting.


    if (align && me.alignConstrained) {
      spec.align = align;
      const newResult = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(element, positioned ? offsetParent : null, true).alignTo(spec);
      anchor = newResult.anchor;
      x = newResult.x;
      y = newResult.y;
      width = newResult.width;
      height = newResult.height;
    }

    me.setXY(x, y); // Class indicates which edge of the target this is aligned to: 0, 1, 2, or 3 (TRBL)

    if (!result.overlap && isFinite(result.zone)) {
      classList.add(alignedClass[result.zone]);
    } // If we asked it to also calculate our anchor position, position our anchor.
    // If we're not edge-to-edge aligned with our target, we cannot anchor.


    if ((_anchor = anchor) !== null && _anchor !== void 0 && _anchor.edge) {
      const {
        edge
      } = anchor,
            {
        anchorElement
      } = me,
            elRect = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(element),
            colorMatchPoint = []; // Make the anchor color match the color of the closest adjacent element

      if (edge === 'top' || edge === 'bottom') {
        colorMatchPoint[0] = anchor.x;
        colorMatchPoint[1] = edge === 'top' ? 1 : elRect.height - 1;
      } else {
        colorMatchPoint[0] = edge === 'left' ? 1 : elRect.width - 1;
        colorMatchPoint[1] = anchor.y;
      }

      let colourSource = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].childFromPoint(element, ...colorMatchPoint);

      if (colourSource) {
        let fillColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(colourSource, 'background-color');

        while (fillColour.match(isTransparent) && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(colourSource, 'position') !== 'absolute') {
          colourSource = colourSource.parentNode;
          fillColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(colourSource, 'background-color');
        }

        if (fillColour.match(isTransparent)) {
          me.anchorPathElement.setAttribute('fill', me.defaultAnchorBackgroundColor);
        } else {
          me.anchorPathElement.setAttribute('fill', fillColour);
        }
      }

      anchorElement.classList.remove('b-hide-display');
      anchorElement.style.transform = '';
      anchorElement.className = `b-anchor b-anchor-${edge}`; // Anchor's position needs boosting if we are scaled down

      anchor.x && (anchor.x /= scale);
      anchor.y && (anchor.y /= scale);
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateXY(anchorElement, anchor.x, anchor.y);
      classList.add('b-anchored');
    } else if (me._anchorElement) {
      me.anchorElement.classList.add('b-hide-display');
      classList.remove('b-anchored');
    } // If we are to hide on scroll, we still need to know if the element we are
    // aligned to moves. If we have not been *explicitly* aligned to an element,
    // Use the element at our display position. For example, when a context menu
    // is shown on a grid header, then is the grid header is moved by a scroll
    // event, then we must hide.


    if (me.scrollAction === 'hide' && !aligningToElement) {
      // Our element is over the X, Y point now,
      // elementFromPoint must "see through" it.
      style.pointerEvents = 'none';
      const el = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].elementFromPoint(x, y); // If we own the element at the point, it means we are already visible
      // and have visible descendants, so we must not update the anchoredTo

      if (!me.owns(el)) {
        me.anchoredTo = el;
      }

      style.pointerEvents = '';
    } // If we're aligning to an element, then listen for scrolls so that we can remain aligned.
    // Scrolls can be instigated with no mousedown, so transient floating Widgets can be put
    // out of alignment by scrolls.


    if ((me.scrollAction === 'realign' && aligningToElement || me.scrollAction === 'hide') && !me.documentScrollListener) {
      // Firefox requires a longer timeout to not autohide as the result of a scroll event firing during Menu show
      me.clearTimeout(me.scrollListenerTimeout);
      me.scrollListenerTimeout = me.setTimeout(() => {
        var _target$getRootNode;

        const targetRoot = target === null || target === void 0 ? void 0 : (_target$getRootNode = target.getRootNode) === null || _target$getRootNode === void 0 ? void 0 : _target$getRootNode.call(target); // Realign if the main document detects a scroll.
        // On raf to avoid scroll syncing other elements causing multiple realigns (grids body and header etc)

        me.documentScrollListener = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].addListener(document, 'scroll', 'doHideOrRealign', {
          capture: true,
          thisObj: me
        }); // In case the align target is in a WC, also capture scrolls scoped with in its shadow root

        if (targetRoot && targetRoot !== document) {
          me.targetRootScrollListener = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].addListener(targetRoot, 'scroll', 'doHideOrRealign', {
            capture: true,
            thisObj: me
          });
        }
      }, me.scrollAction === 'hide' ? me.ignoreScrollDuration : 0);
    } // If alignment specified monitorResize add a resize listener to the target so we can stay aligned.


    if (aligningToElement) {
      if (spec.monitorResize && !me.targetResizeListener) {
        _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].addResizeListener(target, me.callRealign);
        me.targetResizeListener = true;
      } // If configured to monitor intersection, and we are not potentially obscuring
      // it ourselves, and it's not an SVG element, observe its intersection changes.
      // Bug with IntersectionObserver and SVG elements, so omit them:
      // https://bugs.chromium.org/p/chromium/issues/detail?id=1159196


      if (spec.monitorIntersection && !(overlap || target.contains(element) || target.ownerSVGElement)) {
        me.intersectionObserver.observe(target);
      }
    } // Don't try to listen for window resizes to try realigning on Android.
    // That just means the keyboard has been shown.


    if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isAndroid) {
      if (!me.constrainListeners && !(constrainTo instanceof _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"])) {
        // Always observe for changes to window size since aligned things
        // will possibly be out of place after a window resize
        me.clearTimeout(me.resizeListenerTimeout);
        me.resizeListenerTimeout = me.setTimeout(() => {
          me.constrainListeners = true;
          _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].addResizeListener(constrainTo || window, me.callRealign);
        }, me.ignoreScrollDuration);
      }
    }
  }

  get intersectionObserver() {
    return this._intersectionObserver || (this._intersectionObserver = new IntersectionObserver(this.onTargetIntersectionchange.bind(this), {
      root: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isSafari ? this.rootElement : this.rootElement.ownerDocument
    }));
  }

  onTargetIntersectionchange(entries) {
    if (!this.isDestroyed) {
      // It may go through several states. Only interrogate the latest.
      const e = entries[entries.length - 1];

      if (!e.isIntersecting) {
        this.onAlignTargetOutOfView(e.target);
      }
    }
  }
  /**
   * This method is called when the {@link #function-alignTo} target element loses intersection with the
   * visible viewport. That means it has been scrolled out of view, or becomes zero size, or hidden or
   * is removed from the DOM.
   *
   * The base class implementation hides by default.
   * @param {HTMLElement} target The alignTo target that is no longer in view.
   * @internal
   */


  onAlignTargetOutOfView(target) {
    this.hide();
    this.lastAlignSpec && (this.lastAlignSpec.targetOutOfView = true);
  }
  /**
   * Called when an element which affects the position of this Widget's
   * {@link #function-alignTo align target} scrolls so that this can realign.
   *
   * If the target has scrolled out of view, then this Widget is hidden.
   * @internal
   */


  realign() {
    const me = this,
          {
      lastAlignSpec
    } = me;

    if (me.isVisible && (me.floating || me.positioned) && lastAlignSpec) {
      if (lastAlignSpec.aligningToElement) {
        const positioned = me.positioned && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(me.element, 'position') !== 'fixed',
              realignTarget = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isInView(lastAlignSpec.target, false, positioned); // If the target that we are realigning to is not in view, we hide, and set the
        // flag in the lastAlignSpec to explain why

        if (!lastAlignSpec.allowTargetOut && (!Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["hasLayout"])(lastAlignSpec.target) || !realignTarget)) {
          me.hide(); // Hiding *might* destroy if autoClose is set.

          if (!me.isDestroyed) {
            me.lastAlignSpec.targetOutOfView = true;
          }

          return;
        } // We use a different align target when *re*aligning. It's the *visible* rectangle.


        lastAlignSpec.realignTarget = realignTarget;
      }

      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].addTemporaryClass(me.element, 'b-realigning', 300);
      me.alignTo(lastAlignSpec);
    }
  }
  /**
   * Returns the specified bounding rectangle of this widget.
   * @param {String} [which] By default, the rectangle returned is the bounding rectangle that contains the `element`
   * border. Pass any of these values to retrieve various rectangle:
   *  - `'border'` to get the {@link Core.helper.util.Rectangle#function-from-static border rectangle} (the default).
   *  - `'client'` to get the {@link Core.helper.util.Rectangle#function-client-static client rectangle}.
   *  - `'content'` to get the {@link Core.helper.util.Rectangle#function-content-static content rectangle}.
   *  - `'inner'` to get the {@link Core.helper.util.Rectangle#function-inner-static inner rectangle}.
   *  - `'outer'` to get the {@link Core.helper.util.Rectangle#function-outer-static outer rectangle}.
   * @param {HTMLElement|Core.widget.Widget} [relativeTo] Optionally, a parent element or widget in whose space to
   * calculate the Rectangle.
   * @param {Boolean} [ignorePageScroll=false] Use browser viewport based coordinates.
   * @returns {Core.helper.util.Rectangle}
   * @internal
   */


  rectangle(which, relativeTo, ignorePageScroll) {
    return this.rectangleOf('element', which, relativeTo, ignorePageScroll);
  }
  /**
   * Returns the specified bounding rectangle of the specified child `element` of this widget.
   * @param {String} [element] The child element name.
   * @param {String} [which] By default, the rectangle returned is the bounding rectangle that contains the `element`
   * border. Pass any of these values to retrieve various rectangle:
   *  - `'border'` to get the {@link Core.helper.util.Rectangle#function-from-static border rectangle} (the default).
   *  - `'client'` to get the {@link Core.helper.util.Rectangle#function-client-static client rectangle}.
   *  - `'content'` to get the {@link Core.helper.util.Rectangle#function-content-static content rectangle}.
   *  - `'inner'` to get the {@link Core.helper.util.Rectangle#function-inner-static inner rectangle}.
   *  - `'outer'` to get the {@link Core.helper.util.Rectangle#function-outer-static outer rectangle}.
   * @param {HTMLElement|Core.widget.Widget} [relativeTo] Optionally, a parent element or widget in whose space to
   * calculate the Rectangle. If `element` is not `'element'`, then this defaults to the widget's primary element.
   * @param {Boolean} [ignorePageScroll=false] Use browser viewport based coordinates.
   * @returns {Core.helper.util.Rectangle}
   * @internal
   */


  rectangleOf(element, which, relativeTo, ignorePageScroll) {
    var _relativeTo;

    if (typeof which !== 'string') {
      ignorePageScroll = relativeTo;
      relativeTo = which;
      which = '';
    } else if (which === 'border') {
      which = '';
    } // which is locked in


    if (typeof relativeTo === 'boolean') {
      ignorePageScroll = relativeTo;
      relativeTo = undefined;
    }

    if (element !== 'element' && relativeTo === undefined) {
      relativeTo = this.element;
    }

    relativeTo = (_relativeTo = relativeTo) !== null && _relativeTo !== void 0 && _relativeTo.isWidget ? relativeTo.element : relativeTo;
    return _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"][which || 'from'](this[element], relativeTo, ignorePageScroll);
  }

  releaseSizeConstraints() {
    const me = this,
          scroller = me.scrollable; // Release constraints so we can align from scratch each time.

    if (me.alignConstrained & 1) {
      me.height = me.configuredHeight;

      if (scroller) {
        scroller.overflowY = scroller.config.overflowY;
      }
    }

    if (me.alignConstrained & 2) {
      me.width = me.configuredWidth;

      if (scroller) {
        scroller.overflowX = scroller.config.overflowX;
      }
    }

    me.alignConstrained = 0;
  }
  /**
   * Only valid for {@link #config-floating} Widgets. Moves to the front of the visual stacking order.
   * @category Float & align
   */


  toFront() {
    const {
      element
    } = this,
          parent = this.floating ? this.floatRoot : this.positioned ? element === null || element === void 0 ? void 0 : element.parentNode : null;

    if (element !== null && element !== void 0 && element.nextSibling) {
      const r = this._toFrontRange || (this._toFrontRange = document.createRange()); // Instead of moving this element (which may contain focus and therefore should not be moved),
      // Lasso all following nodes using a range and insert them before this.
      // If it contained focus, appending it triggers a focusOut event which will not be expected.

      r.setStartBefore(element.nextSibling);
      r.setEndAfter(parent.lastElementChild);
      parent.insertBefore(r.extractContents(), element);
    }
  } //endregion
  //region Getters/setters


  updateRef(ref) {
    this.element.dataset.ref = ref;
  }
  /**
   * The child element which scrolls if any. This means the element used by the {@link #config-scrollable}.
   * @property {HTMLElement}
   * @readonly
   * @category DOM
   */


  get overflowElement() {
    return this.contentElement;
  }

  get maxHeightElement() {
    return this.element;
  }

  changeAlign(align) {
    return typeof align === 'string' ? {
      align
    } : align;
  }

  changeScrollable(scrollable, oldScrollable) {
    if (typeof scrollable === 'boolean') {
      scrollable = {
        overflowX: scrollable,
        overflowY: scrollable
      };
    }

    if (scrollable) {
      scrollable.element = this.overflowElement;
      scrollable.widget = this;

      if (!scrollable.isScroller) {
        scrollable = oldScrollable ? oldScrollable.setConfig(scrollable) : new this.scrollerClass(scrollable);
      } // Keep overflow indicator classes in sync


      scrollable.syncOverflowState();
    } // Destroy the old scroller if the scroller is being nulled.
    else {
      oldScrollable === null || oldScrollable === void 0 ? void 0 : oldScrollable.destroy();
    }

    return scrollable;
  }
  /**
   * Get/set HTML to display. When specifying HTML, this widget's element will also have the
   * {@link #config-htmlCls} added to its classList, to allow targeted styling.
   * @property {String}
   * @category DOM
   */


  get html() {
    // Maintainer, we cannot use a ternary here, we need the this.initializingElement test to shortcut
    // to the true case to return the _html property to avoid infinite loops.
    if (this.initializingElement || !this.element) {
      return this.content || this._html;
    }

    return this.contentElement.innerHTML;
  }

  updateHtml(html) {
    const me = this,
          isClearing = html == null,
          {
      element,
      contentElement,
      htmlCls
    } = me;

    if (element) {
      // So that our contentElement MutationObserver doesn't react
      me.updatingHtml = true;
      const anchorEl = contentElement === element && me._anchorElement; // Flag class that we are an HTML carrying element

      if (htmlCls) {
        // IE11 doesn't support multiple arguments
        // Salesforce doesn't support passing array
        htmlCls.values.forEach(value => element.classList[isClearing ? 'remove' : 'add'](value));
      } // Setting innerHTML destroys the anchorElement in some browsers
      // so we must temporarily remove it to preserve it.
      // Only if the contentElement is the main element.


      if (anchorEl) {
        me.element.removeChild(anchorEl);
      }

      if (html && typeof html === 'object') {
        _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_5__["default"].sync({
          domConfig: html,
          targetElement: me.contentElement,
          onlyChildren: true
        });
      } else {
        me.contentElement.innerHTML = isClearing ? '' : html;
      } // Ensure our content mutation observer keeps us informed of changes by third parties
      // so that our config system can keep up to date.


      me.getConfig('htmlMutationObserver');

      if (anchorEl) {
        element.appendChild(anchorEl);
      }

      if (me.isComposable) {
        me.recompose();
      } else if (me.floating || me.positioned) {
        // Must realign because content change might change dimensions
        if (!me.isAligning) {
          me.realign();
        }
      }
    }
  }

  changeHtmlMutationObserver(htmlMutationObserver, was) {
    const me = this,
          {
      contentElement
    } = me; // Clean up old one

    was === null || was === void 0 ? void 0 : was.disconnect(contentElement); // Create MutationObserver

    if (htmlMutationObserver) {
      const result = new MutationObserver(() => {
        if (me.updatingHtml) {
          me.updatingHtml = false;
        } else {
          me._html = contentElement.innerHTML;
        }
      });
      result.observe(contentElement, htmlMutationObserver);
      return result;
    }
  }

  updateContent(html) {
    const me = this,
          isClearing = html == null,
          {
      element,
      htmlCls
    } = me;

    if (element) {
      const {
        contentRange
      } = me; // Flag class that we are an HTML carrying element

      if (htmlCls) {
        // IE11 doesn't support multiple arguments
        // Salesforce doesn't support passing array
        htmlCls.values.forEach(value => element.classList[isClearing ? 'remove' : 'add'](value));
      } // Only works if we are in the DOM


      if (Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["isInDocument"])(element)) {
        // Replace the contents of our content range with the new content
        contentRange.deleteContents();

        if (!isClearing) {
          contentRange.insertNode(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElementFromTemplate(html, {
            fragment: true
          }));
        }
      } else {
        me.contentElement.innerHTML = html;
      } // Cache in case it gets collapsed


      me.contentRangeStartOffset = contentRange.startOffset;
      me.contentRangeEndOffset = contentRange.endOffset; // Must realign because content change might change dimensions

      if ((me.floating || me.positioned) && !me.isAligning) {
        me.realign();
      }
    }
  }

  onThemeChange() {
    var _this$anchorElement;

    // If we have a *visible* anchor element, then a theme change may
    // invalidate it's size or this.defaultAnchorBackgroundColor, so a
    // run through realign (and get anchorSize) will fix that.
    if ((_this$anchorElement = this.anchorElement) !== null && _this$anchorElement !== void 0 && _this$anchorElement.offsetParent) {
      this._anchorSize = null;
      this.realign();
    }
  }
  /**
   * Returns an `[x, y]` array containing the width and height of the anchor arrow used when
   * aligning this Widget to another Widget or element.
   *
   * The height is the height of the arrow when pointing upwards, the width is the width
   * of the baseline.
   * @property {Number[]}
   * @category Float & align
   */


  get anchorSize() {
    const me = this;
    let result = this._anchorSize;

    if (!result) {
      // TODO: Move the anchoring scheme to the Panel class when we have it.
      // These values will be in the SASS and styled into the SVG through the Panel's theme.
      const borderWidth = parseFloat(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(me.element, 'border-top-width')),
            borderColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(me.element, 'border-top-color'),
            anchorElement = me.anchorElement,
            {
        className
      } = anchorElement,
            svgEl = anchorElement.firstElementChild,
            pathElement = me.anchorPathElement = svgEl.lastElementChild,
            hidden = me._hidden; // In case we are measuring after the size has been invalidated (such as via theme change)
      // and the widget is shown and aligned left or right. We must measure it in top alignment
      // so as to get the dimensions the right way round.

      anchorElement.className = 'b-anchor b-anchor-top';
      let backgroundColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(me.contentElement, 'background-color'); // If the background colour comes through from the outer element, use that.

      if (backgroundColour.match(isTransparent)) {
        backgroundColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(me.element, 'background-color');
      }

      me.defaultAnchorBackgroundColor = backgroundColour;
      result = anchorElement.getBoundingClientRect();
      const [width, height] = result = me._anchorSize = [result.width, result.height]; // Restore orientation

      anchorElement.className = className;
      svgEl.setAttribute('height', height + borderWidth);
      svgEl.setAttribute('width', width);
      pathElement.setAttribute('d', `M0,${height}L${width / 2},0.5L${width},${height}`);

      if (borderWidth) {
        pathElement.setAttribute('stroke-width', borderWidth);
        pathElement.setAttribute('stroke', borderColour);
      }

      result[1] -= borderWidth;

      if (hidden) {
        me.element.classList.add('b-hidden');
      }

      if (!me.themeChangeListener) {
        me.themeChangeListener = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_21__["default"].on({
          theme: 'onThemeChange',
          thisObj: me
        });
      } // Reset to default in case it has been positioned by a coloured header


      me.anchorPathElement.setAttribute('fill', me.defaultAnchorBackgroundColor);
    }

    return result;
  }

  get anchorElement() {
    const me = this;

    if (!me._anchorElement) {
      const useFilter = me.floating && !(_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11 || _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge),
            filterId = `${me.id}-shadow-filter`;
      me._anchorElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement({
        parent: me.element,
        className: 'b-anchor b-anchor-top',
        children: [{
          tag: 'svg',
          ns: 'http://www.w3.org/2000/svg',
          version: '1.1',
          class: 'b-pointer-el',
          children: [useFilter ? {
            tag: 'defs',
            children: [{
              tag: 'filter',
              id: filterId,
              children: [{
                tag: 'feDropShadow',
                dx: 0,
                dy: -1,
                stdDeviation: 1,
                'flood-opacity': 0.2
              }]
            }]
          } : null, {
            tag: 'path',
            [useFilter ? 'filter' : '']: `url(#${filterId})`
          }]
        }]
      });
    }

    return me._anchorElement;
  }

  updateAnchor(anchor) {
    if (this._anchorElement) {
      this._anchorElement.classList[anchor ? 'remove' : 'add']('b-hide-display');
    }
  }

  updateDraggable(draggable) {
    const me = this,
          {
      element
    } = me;

    if (draggable) {
      me.dragEventDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].addListener({
        element,
        dragstart: 'onWidgetDragStart',
        dragend: 'onWidgetDragEnd',
        thisObj: me
      });
      me.dragDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
        element,

        mousedown(event) {
          const {
            target
          } = event,
                closestWidget = Widget.fromElement(target); // Fix for FF draggable bug https://bugzilla.mozilla.org/show_bug.cgi?id=1189486

          if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].up(event.target, '.b-field-inner') && // Only allow drag to start when the action originates from the widget element itself,
          // or one of its toolbars. https://github.com/bryntum/support/issues/3214
          closestWidget === this || this.strips && Object.values(this.strips).includes(closestWidget)) {
            element.setAttribute('draggable', 'true');
          }
        },

        // Only needed for automatic listener removal on the destroy of the thisObj
        thisObj: me
      });
    } else {
      var _me$dragEventDetacher2, _me$dragOverEventDeta2, _me$dragDetacher;

      (_me$dragEventDetacher2 = me.dragEventDetacher) === null || _me$dragEventDetacher2 === void 0 ? void 0 : _me$dragEventDetacher2.call(me);
      (_me$dragOverEventDeta2 = me.dragOverEventDetacher) === null || _me$dragOverEventDeta2 === void 0 ? void 0 : _me$dragOverEventDeta2.call(me);
      (_me$dragDetacher = me.dragDetacher) === null || _me$dragDetacher === void 0 ? void 0 : _me$dragDetacher.call(me);
    }
  }

  onWidgetDragStart(e) {
    var _ref2;

    const me = this;

    if (!me.validateDragStartEvent(e)) {
      return;
    } // Opt out of auto-alignment on scroll or DOM mutation.


    me.removeTransientListeners();
    const {
      element,
      align,
      constrainTo
    } = me,
          positioned = me.positioned && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, 'position') !== 'fixed',
          parentElement = positioned ? element.parentElement : me.rootElement,
          myRect = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(element, positioned ? parentElement : null),
          dragStartX = e.clientX,
          dragStartY = e.clientY,
          scrollingPageElement = document.scrollingElement || document.body,
          [widgetX, widgetY] = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getOffsetXY(element, parentElement),
          constrainRect = (_ref2 = positioned ? _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].content(parentElement).moveTo(0, 0) : constrainTo && (constrainTo !== null && constrainTo !== void 0 && constrainTo.isRectangle ? constrainTo : _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(constrainTo))) === null || _ref2 === void 0 ? void 0 : _ref2.deflate(align.constrainPadding || 0),
          dragListeners = {
      element: parentElement,
      dragover: event => {
        // Centered adds positioning rules, it can't be centered during drag.
        element.classList.remove('b-centered'); // Shift our rectangle to the desired point.

        myRect.moveTo(widgetX + event.clientX - dragStartX - (positioned ? 0 : scrollingPageElement.scrollLeft), widgetY + event.clientY - dragStartY - (positioned ? 0 : scrollingPageElement.scrollTop)); // Constrain it if we are configured to be constrained

        if (constrainRect) {
          myRect.constrainTo(constrainRect);
        } // Position using direct DOM access, do not go though the setXY method which clears
        // any centered config. User dragging only moves this show of the widget. Upon next
        // neutral show (with no extra positioning info), a centered widget will show centered again.


        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateXY(element, myRect.x, myRect.y);
      }
    }; // Stop viewport panning on drag on touch devices

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isTouchDevice) {
      dragListeners.touchmove = e => e.preventDefault();
    }

    me.floatRoot.appendChild(me.dragGhost);
    me.setDragImage(e); // Prevent special cursor from being shown

    e.dataTransfer.effectAllowed = 'none';
    me.dragOverEventDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].addListener(dragListeners); // Various app events (Such as resize or visible child count change) can
    // cause a request to realign, so opt out of anchoring and alignedness
    // until we are next hidden.

    me.alignTo();
  }
  /**
   * Validates a `dragstart` event with respect to the target element. Dragging is not normally
   * initiated when the target is interactive such as an input field or its label, or a button.
   * This may be overridden to provide custom drag start validation.
   * @param {DragEvent} e The `dragstart` event to validate.
   * @returns {Boolean} Return `true` if the drag is to be allowed.
   * @internal
   */


  validateDragStartEvent(e) {
    const me = this,
          {
      element
    } = me,
          actualTarget = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].elementFromPoint(e.clientX, e.clientY),
          // Can't be resolved from the event :/
    {
      handleSelector
    } = me.draggable;

    if (handleSelector) {
      const blacklist = negationPseudo.exec(handleSelector)[1]; // Extract the content of :not()
      // If the selector was :not(), then if we are a descendant of a matching element, it's a no-drag

      if (blacklist) {
        if (actualTarget.closest(`#${element.id} ${blacklist}`)) {
          e.preventDefault();
          return false;
        }
      } // If we are not the descendant of a matching element, it's a no-drag
      else if (!actualTarget.closest(`#${element.id} ${handleSelector}`)) {
        e.preventDefault();
        return false;
      }
    }

    return true;
  }

  setDragImage(e) {
    if (e.dataTransfer.setDragImage) {
      // Firefox requires this to be called before setDragImage
      e.dataTransfer.setData('application/node type', ''); // Override the default HTML5 drag ghost and just drag an empty node.
      // The large offset will cause it to be displayed offscreen on platforms
      // which will not hide drag images (iOS)

      e.dataTransfer.setDragImage(this.dragGhost, -9999, -9999);
    }
  }

  onWidgetDragEnd() {
    this.dragGhost.remove();
    this.dragOverEventDetacher();
    this.element.removeAttribute('draggable');
  }

  changeFloating(value) {
    // Coerce all to boolean so that we have a true/false value
    return Boolean(value);
  }

  changePositioned(value) {
    // Coerce all to boolean so that we have a true/false value
    return Boolean(value);
  }

  updatePositioned(positioned) {
    this.element.classList[positioned ? 'add' : 'remove']('b-positioned');
  }

  getXY() {
    return [_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getPageX(this.element), _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getPageY(this.element)];
  }
  /**
   * Moves this Widget to the x,y position. Both arguments can be omitted to just set one value.
   *
   * *For {@link #config-floating} Widgets, this is a position in the browser viewport.*
   * *For {@link #config-positioned} Widgets, this is a position in the element it was rendered into.*
   *
   * @param {Number} [x]
   * @param {Number} [y]
   * @category Float & align
   */


  setXY(x, y) {
    const me = this,
          {
      element
    } = me;

    if (me.floating || me.positioned) {
      if (x != null) {
        me._x = x;
        me.centered = false;
      }

      if (y != null) {
        me._y = y;
        me.centered = false;
      } // If we're position:fixed then it is positioned relative to either the viewport
      // or an ancestor which has a transform, perspective of filter property.
      // See https://developer.mozilla.org/en-US/docs/Web/CSS/position.
      // So translate it *relative* to its actual position/


      if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, 'position') === 'fixed') {
        const r = element.getBoundingClientRect(),
              [cx, cy] = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getTranslateXY(element),
              xDelta = x - r.x,
              yDelta = y - r.y;
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateXY(element, cx + xDelta, cy + yDelta);
      } else {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setTranslateXY(element, me._x || 0, me._y || 0);
      }
    }
  }
  /**
   * Moves this Widget to the desired x position.
   *
   * Only valid if this Widget is {@link #config-floating} and not aligned or anchored to an element.
   * @property {Number}
   * @category Float & align
   */


  get x() {
    return this.getXY()[0];
  }

  changeX(x) {
    this.setXY(x);
  }
  /**
   * Moves this Widget to the desired y position.
   *
   * Only valid if this Widget is {@link #config-floating} and not aligned or anchored to an element.
   * @property {Number}
   * @category Float & align
   */


  get y() {
    return this.getXY()[1];
  }

  changeY(y) {
    this.setXY(null, y);
  }
  /**
   * Get elements offsetWidth or sets its style.width, or specified width if element not created yet.
   * @property {Number}
   * @accepts {Number|String}
   * @category Layout
   */


  get width() {
    const me = this,
          element = me.element;

    if (me.monitorResize) {
      // If the width is invalid, read it now.
      if (me._width == null) {
        me._width = element.offsetWidth;
      } // Usually this will be set in onInternalResize


      return me._width;
    } // No monitoring, we have to measure;


    return element.offsetWidth;
  }

  changeWidth(width) {
    const me = this;
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setLength(me.element, 'width', width);
    me._lastWidth = width; // Invalidate the width, so it will be read from the DOM if a read is requested before the resize event

    me._width = null; // Setting width explicitly should reset flex, since it's not flexed anymore

    me._flex = null;
    me.element.style.flex = '';
  }
  /**
   * Get/set elements maxWidth. Getter returns max-width from elements style, which is always a string. Setter accepts
   * either a String or a Number (which will have 'px' appended). Note that like {@link #config-width},
   * _reading_ the value will return the numeric value in pixels.
   * @property {String}
   * @accepts {String|Number}
   * @category Layout
   */


  get maxWidth() {
    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].measureSize(this.element.style.maxWidth, this.element);
  }

  updateMaxWidth(maxWidth) {
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setLength(this.element, 'maxWidth', maxWidth);
  }
  /**
   * Get/set elements minWidth. Getter returns min-width from elements style, which is always a string. Setter accepts
   * either a String or a Number (which will have 'px' appended). Note that like {@link #config-width},
   * _reading_ the value will return the numeric value in pixels.
   * @property {String}
   * @accepts {String|Number}
   * @category Layout
   */


  get minWidth() {
    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].measureSize(this.element.style.minWidth, this.element);
  }

  updateMinWidth(minWidth) {
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setLength(this.element, 'minWidth', minWidth);
  }

  updateFlex(flex) {
    // Width must be processed first, because its changer clears flex because flex wins over width;
    // The assumption that the containing element's flex-direction is 'row'
    // seems dodgy.
    this.getConfig('width'); // Default grow to the same as flex and basis to 0.

    if (typeof flex === 'number' || !isNaN(flex)) {
      flex = `${flex} ${flex}`;
    }

    this.element.style.flex = flex;
    this.element.style.width = '';
  }

  updateAlignSelf(alignSelf) {
    this.element.style.alignSelf = alignSelf;
  }

  updateMargin(margin) {
    // Convert eg 1 to "1px 1px 1px 1px" or "0 8px" to "0px 8px 0px 8px"
    this.element.style.margin = this.parseTRBL(margin).join(' ');
  }

  updateTextAlign(align, oldAlign) {
    oldAlign && this.element.classList.remove(`b-text-align-${oldAlign}`);
    this.element.classList.add(`b-text-align-${align}`);
  }

  updatePlaceholder(placeholder) {
    if (this.input) {
      if (placeholder == null) {
        this.input.removeAttribute('placeholder');
      } else {
        this.input.placeholder = placeholder;
      }
    }
  }
  /**
   * Get element's offsetHeight or sets its style.height, or specified height if element no created yet.
   * @property {Number}
   * @accepts {Number|String}
   * @category Layout
   */


  get height() {
    const me = this,
          element = me.element;

    if (me.monitorResize) {
      // If the height is invalid, read it now.
      if (me._height == null) {
        me._height = element.offsetHeight;
      } // Usually this will be set in onInternalResize


      return me._height;
    } // No monitoring, we have to measure;


    return element.offsetHeight;
  }

  changeHeight(height) {
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setLength(this.element, 'height', height);
    this._lastHeight = height; // Invalidate the height, so it will be read from the DOM if a read is requested before the resize event

    this._height = null;
  }
  /**
   * Get/set element's maxHeight. Getter returns max-height from elements style, which is always a string. Setter
   * accepts either a String or a Number (which will have 'px' appended). Note that like {@link #config-height},
   * _reading_ the value will return the numeric value in pixels.
   * @property {String}
   * @accepts {String|Number}
   * @category Layout
   */


  get maxHeight() {
    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].measureSize(this.maxHeightElement.style.maxHeight, this.element);
  }

  updateMaxHeight(maxHeight) {
    const me = this,
          {
      element
    } = me;
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setLength(me.maxHeightElement, 'maxHeight', maxHeight); // Flexbox does not handle overflow correctly when a vertically
    // flexed item is constrained by the maxHeight of its containing el.
    // So we have to propagate the maxHeight from the encapsulating element
    // onto the contentElement.

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11 && me.contentElement !== element) {
      if (maxHeight == null) {
        _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(element, me.boundMaxHeightBugHandler);
      } else {
        _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].addResizeListener(element, me.boundMaxHeightBugHandler || (me.boundMaxHeightBugHandler = me.fixIEMaxHeightBug.bind(me)));

        if (document.body.contains(element)) {
          me.fixIEMaxHeightBug();
        }
      }
    }
  }

  fixIEMaxHeightBug() {
    const {
      element,
      contentElement
    } = this; // If this widget is flexed vertically, the maxHeight of the encapsulating element must be
    // propagated onto the contentElement.

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, 'flex-direction') === 'column') {
      // Release previous height constraint
      contentElement.style.maxHeight = '';
      let availableHeight = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].client(element).height;
      const siblings = element.childNodes,
            len = siblings.length; // In case there are height-consuming siblings of the contentElement.
      // For example a header/footer. The heights of these must be subtracted.

      for (let i = 0; i < len; i++) {
        const sibling = siblings[i];

        if (sibling !== contentElement && !sibling.classList.contains('b-resize-monitors')) {
          availableHeight -= sibling.offsetHeight;
        }
      } // Apply the adjusted height constraint to the contentElement


      this.contentElement.style.maxHeight = `${availableHeight}px`;
    }
  }
  /**
   * Get/set element's minHeight. Getter returns min-height from elements style, which is always a string. Setter
   * accepts either a String or a Number (which will have 'px' appended). Note that like {@link #config-height},
   * _reading_ the value will return the numeric value in pixels.
   * @property {String}
   * @accepts {String|Number}
   * @category Layout
   */


  get minHeight() {
    return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].measureSize(this.element.style.minHeight, this.element);
  }

  updateMinHeight(minHeight) {
    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].setLength(this.element, 'minHeight', minHeight);
  }

  updateDisabled(disabled) {
    const me = this,
          el = me.element,
          focusEl = me.focusElement;
    me.trigger('beforeUpdateDisabled', {
      disabled
    });
    disabled && me.revertFocus();

    if (el) {
      el.classList[disabled ? 'add' : 'remove']('b-disabled');

      if (focusEl) {
        focusEl.disabled = disabled;
      }
    }

    me.onDisabled(disabled);
  }
  /**
   * Called when disabled state is changed.
   * Override in subclass that needs special handling when being disabled.
   * @param {Boolean} disabled current state
   * @private
   */


  onDisabled(disabled) {}
  /**
   * Disable the widget
   */


  disable() {
    this.disabled = true;
  }
  /**
   * Enable the widget
   */


  enable() {
    this.disabled = false;
  }
  /**
   * Requests fullscreen display for this widget
   * @returns {Promise} A Promise which is resolved with a value of undefined when the transition to full screen is complete.
   */


  requestFullscreen() {
    const me = this,
          // If we are floating, target the float root as the fullscreen element
    result = _helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_7__["default"].request(me.floating ? me.floatRoot : me.element);
    _helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_7__["default"].onFullscreenChange(me.onFullscreenChange);

    if (!me.floating) {
      me.floatRoot._oldParent = me.floatRoot.parentElement;
      me.element.appendChild(me.floatRoot);
    }

    me.element.classList.add('b-fullscreen');
    return result;
  }
  /**
   * Exits fullscreen mode
   * @returns {Promise} A Promise which is resolved once the user agent has finished exiting full-screen mode
   */


  exitFullscreen() {
    return _helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_7__["default"].exit();
  }

  onFullscreenChange() {
    if (!_helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_7__["default"].isFullscreen) {
      this.onExitFullscreen();
    }
  }

  onExitFullscreen() {
    var _me$_rootElement;

    const me = this,
          floatRoot = (_me$_rootElement = me._rootElement) === null || _me$_rootElement === void 0 ? void 0 : _me$_rootElement.floatRoot;
    _helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_7__["default"].unFullscreenChange(me.onFullscreenChange);
    me.element.classList.remove('b-fullscreen'); // When exiting fullscreen mode or when this widget is destroyed, move floatRoot back to its old parent

    if (me.element.contains(floatRoot) && floatRoot !== null && floatRoot !== void 0 && floatRoot._oldParent) {
      floatRoot._oldParent.appendChild(floatRoot);

      floatRoot._oldParent = null;
    }
  }
  /**
   * Get/set a tooltip on the widget. Accepts a string or tooltip config (specify true (or 'true') to use placeholder
   * as tooltip). When using a string it will configure the tooltip with `textContent: true` which enforces a default
   * max width.
   *
   * By default, this uses a singleton Tooltip instance which may be accessed from the
   * `{@link Core.widget.Widget Widget}` class under the name `Widget.tooltip`.
   * This is configured according to the config object on pointer over.
   *
   * To request a separate instance be created just for this widget, add `newInstance : true`
   * to the configuration.
   *
   * @property {String|Object}
   * @category Misc
   */


  get tooltip() {
    if (this._tooltip) {
      return this._tooltip;
    } else {
      var _Widget$Tooltip2;

      const tooltip = (_Widget$Tooltip2 = Widget.Tooltip) === null || _Widget$Tooltip2 === void 0 ? void 0 : _Widget$Tooltip2.getSharedTooltip(this.rootElement); // If the shared tooltip is currently in use by us, return it.
      // If it's not in use by us, we don't have a tooltip.

      if (tooltip && tooltip.activeTarget === this._element && tooltip.isVisible) {
        return tooltip;
      }
    }
  } //noinspection JSAnnotator


  changeTooltip(tooltip, oldTooltip) {
    const me = this;

    if (tooltip) {
      if (!(me.preventTooltipOnTouch && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isTouchDevice)) {
        if (!tooltip.isTooltip && tooltip.constructor.name !== 'Object') {
          tooltip = {
            html: typeof tooltip === 'string' ? tooltip : me.placeholder,
            textContent: true
          };
        } // We have to explicitly request a new instance to avoid spam Tooltip instances.
        // If there is an incoming oldTooltip, then we own a newInstance.
        // TODO verify .isTooltip check is needed


        if (oldTooltip !== null && oldTooltip !== void 0 && oldTooltip.isTooltip || tooltip.newInstance) {
          tooltip.type = 'tooltip';
          if (!tooltip.forElement) tooltip.forElement = me.element;
          if (!('showOnHover' in tooltip) && !tooltip.forSelector) tooltip.showOnHover = true;
          if (!('autoClose' in tooltip)) tooltip.autoClose = true;
          tooltip = Widget.reconfigure(oldTooltip, tooltip, me);
        } // The default is that tooltip content and configs from tipConfig
        else {
          me.element.dataset.btip = true;
          me.tipConfig = tooltip; // We do not set our property if we are sharing the singleton

          return;
        }
      }
    } else {
      // If there is an incoming oldTooltip, then we own a newInstance.
      // Only destroy it if it's being set to null. Empty string
      // just means clear its content.
      if (oldTooltip) {
        if (tooltip == null && oldTooltip.isTooltip) {
          oldTooltip.destroy();
        } else {
          // We do not update the property if we are just clearing its content
          oldTooltip.html = null;
          return;
        }
      } // We are sharing, so just clear the btip
      else {
        delete me.element.dataset.btip;
      }
    }

    return tooltip;
  }

  get tooltipText() {
    const tooltip = this._tooltip;

    if (tooltip) {
      return tooltip.isTooltip ? tooltip.contentElement.innerText : typeof tooltip === 'string' ? tooltip : tooltip.html;
    } else if (this.tipConfig) {
      return this.tipConfig.html;
    }
  }
  /**
   * Determines visibility by checking if the Widget is hidden, or any ancestor is hidden and that it has an
   * element which is visible in the DOM
   * @property {Boolean}
   * @category Visibility
   * @readonly
   */


  get isVisible() {
    const me = this,
          {
      element
    } = me; // Added so that we only acquire owner once. `get owner()` *may* have to search DOM

    let owner; // If we are hidden, or destroying, or any ancestors are hidden, we're not visible

    return Boolean(element && !me._hidden && !me.isDestroying && Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["isInDocument"])(element) && (!me.requireSize || Object(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["hasLayout"])(element)) && (!(owner = me.containingWidget) || owner.isVisible));
  }
  /**
   * Focuses this widget if it has a focusable element.
   */


  focus() {
    if (this.isFocusable) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].focusWithoutScrolling(this.focusElement);
    }
  }
  /**
   * Get this widget's primary focus holding element if this widget is itself focusable, or contains focusable widgets.
   * @property {HTMLElement}
   * @readonly
   * @category DOM
   */


  get focusElement() {// Override in widgets which are focusable.
  }

  get isFocusable() {
    const focusElement = this.focusElement; // We are only focusable if the focusEl is deeply visible, that means
    // it must have layout - an offsetParent. Body does not have offsetParent.

    return focusElement && this.isVisible && !this.disabled && (focusElement === document.body || focusElement.offsetParent);
  }
  /**
   * Shows this widget
   * @category Visibility
   * @async
   * @returns {Promise} A promise which is resolved when the widget is shown
   */


  async show() {
    const me = this,
          {
      showAnimation,
      element,
      floating
    } = me,
          {
      style
    } = element;
    let styleProp, animProps, trigger;

    if (trigger = !me.isVisible) {
      /**
       * Triggered before a widget is shown. Return `false` to prevent the action.
       * @preventable
       * @async
       * @event beforeShow
       * @param {Core.widget.Widget} source The widget being shown.
       */
      trigger = me.trigger('beforeShow');

      if (_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_13__["default"].isPromise(trigger)) {
        trigger = await trigger;
      }
    }

    if (trigger !== false && (!me.internalBeforeShow || me.internalBeforeShow() !== false)) {
      return new Promise(resolve => {
        // Cancel any current hide/show animation
        me.cancelHideShowAnimation(); // Centered config value takes precedence over x and y configs.
        // This also ensures that widgets configured with centered: true
        // and draggable : true will show in the center on next show after
        // being dragged by the user which is the intuitive UX.

        me.updateCentered(me._centered);

        if (floating) {
          const floatRoot = me.floatRoot;

          if (!floatRoot.contains(element)) {
            // Replace this Widget's DOM into the container if it's already rendered
            if (me.rendered) {
              floatRoot.appendChild(me.element);
            } else {
              // Pass triggerPaint as false. The calls will not propagate
              // anyway since we are still hidden.
              me.render(floatRoot, false);
            }
          } // Because we are outside of any owner's element, we need to see if they're scaled so
          // that we match. See scaled examples with tooltips in API docs guides section.


          if (style.transform.includes('scale')) {
            me.scale = null;
            style.transform = style.transformOrigin = '';
          }

          const scaledAncestor = me.closest(isScaled);

          if (scaledAncestor) {
            const {
              scale
            } = scaledAncestor; // Our scale is the same while we are visible and owned by that scaled ancestor.
            // Now floating descendants will follow suit.

            me.scale = scale;
            style.transform = `scale(${scale})`;
            style.transformOrigin = `0 0`;
          }
        }

        me._hidden = false;
        element.classList.remove('b-hidden'); // The changer vetoes the config change and routes here, so we must call this.

        me.onConfigChange({
          name: 'hidden',
          value: false,
          was: true,
          config: me.$meta.configs.hidden
        });

        if (showAnimation) {
          styleProp = Object.keys(showAnimation)[0];
          animProps = showAnimation[styleProp];
          const currentAnimation = me.currentAnimation = {
            showing: true,
            styleProp,
            resolve
          };
          me.isAnimating = true; // afterHideShowAnimate will always be called even if the transition aborts

          me.currentAnimation.detacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].onTransitionEnd({
            element,
            property: styleProp,
            duration: parseDuration(animProps.duration) + 20,
            handler: () => me.afterHideShowAnimate(currentAnimation),
            thisObj: me
          }); // Setting transition style initial value before showing,
          // then reading the style to ensure transition will animate

          style[styleProp] = animProps.from;
          _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, styleProp);
          style.transition = `${styleProp} ${animProps.duration} ease ${animProps.delay}`;
          style[styleProp] = animProps.to;
        }

        me.afterShow(!showAnimation && resolve); // Note: popups can be dismissed in the process of focusin/out if an editor has invalidAction='block',
        // so we may be hidden at this point...
        // If we're not being called from showBy, do default aligning unless its centered

        if (!me.inShowBy && (floating || me.positioned) && me.forElement && !me.centered && !me.hidden) {
          me.alignTo(me.forElement);
        }
      });
    } else {
      return Promise.resolve();
    }
  }
  /**
   * Show aligned to another target element or {@link Core.widget.Widget} or {@link Core.helper.util.Rectangle}
   * @param {Object|HTMLElement} spec Alignment specification, or the element to align to using the configured
   * {@link #config-align}.
   * @param {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle} spec.target The Widget or Element or Rectangle to align to.
   * @param {Boolean} [spec.anchor] True to show a pointer arrow connecting to the target. Defaults to false.
   * @param {Boolean} [spec.overlap] True to allow this to overlap the target.
   * @param {String} spec.align The alignment specification string, `[trblc]n-[trblc]n`. Defaults to this instance's
   * {@link #config-align} setting.
   * @param {HTMLElement|Core.widget.Widget|Core.helper.util.Rectangle} [spec.constrainTo] The Widget or Element or Rectangle to constrain to.
   * If the requested alignment cannot be constrained (it will first shrink the resulting Rectangle according
   * to the `minWidth` and `minHeight` properties of this spec, or the Widget), then it will try aligning at other edges
   * (honouring the `axisLock` option), and pick the fallback alignment which results in the shortest translation.
   * @param {Number|Number[]} [spec.constrainPadding] The amount of pixels to pad from the `constrainTo` target,
   * either a single value, or an array of values in CSS edge order.
   * @param {Number} [spec.minHeight] The minimum height this widget may be compressed to when constraining within the `constrainTo` option.
   * @param {Number} [spec.minWidth] The minimum width this widget may be compressed to when constraining within the `constrainTo` option.
   * @param {Boolean} [spec.axisLock] Specify as `true` to fall back to aligning against the opposite
   * edge if the requested alignment cannot be constrained into the `constrainTo` option. Specify as
   * `'flexible'` to allow continuation to try the other edges if a solution cannot be found on the originally requested axis.
   * @param {Boolean} [spec.matchSize] When aligning edge-to-edge, match the length of the aligned-to
   * edge of the target. This is only honored when `axisLock` is enabled and alignment succeeds on the requested axis.
   * If __not__ aligning edge-to-edge, `matchSize` matches both dimensions of the target.
   * Specify as `true` to have this widget's size along the aligned edge match the size of the target's edge.
   * For example, a combobox's dropdown should match the width of the combobox.
   * @param {Number|Number[]} [spec.offset] The offset to create an extra margin round the target
   * to offset the aligned widget further from the target. May be configured as -ve to move the aligned widget
   * towards the target - for example producing the effect of the anchor pointer piercing the target.
   * @param {Boolean} [spec.monitorResize] Configure as `true` to monitor the element being aligned to for
   * resizing while visible to correct alignment.
   * @category Float & align
   * @async
   * @returns {Promise} A promise which is resolved when the widget is shown
   */


  async showBy(spec) {
    const me = this;
    let result;

    if (me.isVisible) {
      _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].addTemporaryClass(me.element, 'b-realigning', 300);
    } else {
      // Prevent show from rerouting here.
      me.inShowBy = true;
      result = me.show();
      me.inShowBy = false;
    }

    if (me.isVisible) {
      me.alignTo(spec);
    }

    return result || immediatePromise;
  }
  /**
   * Show this widget anchored to a coordinate
   * @param {Number|Number[]} x The x position (or an array with [x,y] values) to show by
   * @param {Number} [y] The y position to show by
   * @param {Object} [options] See {@link #function-showBy} for reference
   * @category Float & align
   * @async
   * @returns {Promise} A promise which is resolved when the widget is shown
   */


  async showByPoint(x, y, options) {
    const xy = arguments.length === 1 ? x : [x, y];
    return this.showBy(Object.assign({
      position: new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_12__["default"](xy[0] + 1, xy[1] + 1),
      // Override any matchSize that we might have in our align config.
      // Otherwise we are going to be 1px wide/high
      matchSize: false,
      align: 't-b'
    }, options));
  }

  afterShow(resolveFn) {
    var _me$parent, _me$parent$onChildSho;

    const me = this; // This method is injected when maxHeight is set on IE11.
    // Flexbox does not handle overflow correctly when a vertically
    // flexed item is constrained by the maxHeight of its containing el.
    // So we have to propagate the maxHeight from the encapsulating element
    // onto the contentElement.

    if (me.boundMaxHeightBugHandler) {
      me.boundMaxHeightBugHandler();
    }
    /**
     * Triggered after a widget is shown.
     * @event show
     * @param {Core.widget.Widget} source The widget
     */


    me.trigger('show'); // Cache our preferred anchoredness in case it's overridden by a drag.

    me._configuredAnchorState = me.anchor; // Keep any owning container informed about visibility state.
    // It may not be a Container. SubGrid class is still a Widget
    // which contains grid headers.

    (_me$parent = me.parent) === null || _me$parent === void 0 ? void 0 : (_me$parent$onChildSho = _me$parent.onChildShow) === null || _me$parent$onChildSho === void 0 ? void 0 : _me$parent$onChildSho.call(_me$parent);
    me.triggerPaint();
    resolveFn && resolveFn();
  }

  triggerPaint() {
    const me = this,
          {
      element
    } = me,
          firstPaint = !me.isPainted;

    if (me.isVisible) {
      if (firstPaint) {
        // Not for public use, only used in docs
        if (me.scaleToFitWidth && !me.monitorResize) {
          me.onParentElementResize = me.onParentElementResize.bind(me);
          _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].addResizeListener(element.parentElement, me.onParentElementResize);
          me.updateScale();
        } // Add a comment to state this is made by Bryntum


        if (!me.hideBryntumDomMessage && (me.isTaskBoardBase || me.isGridBase || me.isCalendar)) {
          element.insertBefore(new Comment('POWERED BY BRYNTUM (https://bryntum.com)'), element.firstChild);
        }
      } // Trigger paint only on immediate children.
      // Each one will call this recursively.
      // paint is triggered in a bottom up manner.


      me.eachWidget(widgetTriggerPaint, false);

      if (firstPaint && me.isVisible) {
        me.rootElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getRootElement(element); // Make sure the shared tooltip is initialized

        me.getConfig('tooltip'); // Late setup of Ripple

        if (!Widget.Ripple && Widget.RippleClass) {
          Widget.Ripple = new Widget.RippleClass({
            rootElement: me.rootElement
          });
        }
      }
      /**
       * Triggered when a widget which had been in a non-visible state for any reason
       * achieves visibility.
       *
       * A non-visible state *might* mean the widget is hidden and has just been shown.
       *
       * But this event will also fire on widgets when a non-visible (unrendered, or hidden)
       * ancestor achieves visibility, for example a {@link Core.widget.Popup Popup} being shown.
       *
       * TLDR: __This event can fire multiple times__
       * @event paint
       * @param {Core.widget.Widget} source The widget being painted.
       * @param {Boolean} firstPaint `true` if this is the first paint.
       */


      me.isPainted = true;
      me.trigger('paint', {
        firstPaint
      });

      if (firstPaint) {
        // On first paint, we should announce our size immediately.
        // When the real event comes along, onElementResize will reject it because the size will be the same.
        if (me.monitorResize && !me.scaleToFitWidth) {
          _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].onElementResize([{
            target: element
          }]);
        }
      }
    }
  }

  cancelHideShowAnimation() {
    const me = this,
          {
      currentAnimation,
      element
    } = me;

    if (currentAnimation) {
      me.isAnimating = false; // If it is an animated hide that we are aborting, reverse the set of the hidden flag
      // If hide is animated, we only get genuinely hidden at animation end.

      if (element.classList.contains('b-hiding')) {
        element.classList.remove('b-hiding');
        me._hidden = false;
      }

      currentAnimation.detacher();
      currentAnimation.resolve();
      element.style.transition = element.style[currentAnimation.styleProp] = '';
      me.currentAnimation = null;
    }
  }

  afterHideShowAnimate(currentAnimation) {
    // We receive the currentAnimation as understood by the party starting the animation... if that is not the
    // current value of "this.currentAnimation" we can ignore this call.
    const me = this; // If menu is destroyed too soon in Edge, this method will be invoked for destroyed element. Since all of our
    // properties are cleared on destroy, this check will prevent undesired reactions:

    if (currentAnimation === me.currentAnimation) {
      // Ensure cancelHideShowAnimation doesn't think we're aborting before the end.
      me.element.classList.remove('b-hiding');
      me.cancelHideShowAnimation(); // Element must be fully hidden after the animation effect finishes

      if (me._hidden) {
        me.afterHideAnimation();
      }
    }
  }
  /**
   * Temporarily changes the {@link #property-isVisible} to yield `false` regardless of this
   * Widget's true visibility state. This can be useful for suspending operations which rely on
   * the {@link #property-isVisible} property.
   *
   * This increments a counter which {@link #function-resumeVisibility} decrements.
   * @internal
   */


  suspendVisibility() {
    this._visibilitySuspended = (this._visibilitySuspended || 0) + 1;
    Object.defineProperty(this, 'isVisible', returnFalseProp);
  }
  /**
   * Resumes visibility. If the suspension counter is returned to zero by this, then the
   * {@link #event-paint} event is triggered, causing a cascade of `paint` events on all
   * descendants. This can be prevented by passing `false` as the only parameter.
   * @param {Boolean} [triggerPaint=true] Trigger the {@link #event-paint} event.
   * @internal
   */


  resumeVisibility(triggerPaint = true) {
    if (! --this._visibilitySuspended) {
      delete this.isVisible;

      if (triggerPaint) {
        this.triggerPaint();
      }
    }
  }
  /**
   * Hide widget
   * @param {Boolean} animate Pass `true` (default) to animate the hide action
   * @category Visibility
   * @returns {Promise} A promise which is resolved when the widget has been hidden
   */


  hide(animate = true) {
    return new Promise(resolve => {
      const me = this,
            {
        element,
        lastAlignSpec
      } = me,
            {
        style
      } = element,
            hideAnimation = animate && me.hideAnimation; // If we get hidden very quickly after a call to show,
      // we must kill the timers which add the realign listeners.

      me.clearTimeout(me.scrollListenerTimeout);
      me.clearTimeout(me.resizeListenerTimeout);
      /**
       * Triggered before a widget is hidden. Return `false` to prevent the action.
       * @preventable
       * @event beforeHide
       * @param {Core.widget.Widget} source The widget being hidden.
       */
      // replaced check for isVisible with _hidden, need to hide a component not yet in view in EventEditor

      if (!me._hidden && me.trigger('beforeHide') !== false) {
        me._hidden = true; // The flag must be cleared on a normal hide.
        // It's set if we hide due to the target being scrolled out of view.

        if (lastAlignSpec) {
          lastAlignSpec.targetOutOfView = null;

          if (lastAlignSpec.monitorIntersection) {
            me.intersectionObserver.takeRecords();
            me.intersectionObserver.unobserve(lastAlignSpec.target);
          }
        } // The changer vetoes the config change and routes here, so we must call this.


        me.onConfigChange({
          name: 'hidden',
          value: true,
          was: false,
          config: me.$meta.configs.hidden
        });

        if (!element) {
          resolve();
          return;
        }

        if (element.contains(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(element))) {
          me.revertFocus(true);
        } // Focus exit causes close if autoClose: true, and if closeAction: 'hide'
        // that might destroy us, so exit now if that happens.


        if (me.isDestroyed) {
          resolve();
          return;
        } // Cancel any current hide/show animation


        me.cancelHideShowAnimation();

        if (hideAnimation) {
          const styleProp = Object.keys(hideAnimation)[0],
                animProps = hideAnimation[styleProp]; // Make sure we are not already at the final value of the hide animation (i.e. calling hide() directly after show())

          if (Number(getComputedStyle(me.element)[styleProp]) !== animProps.to) {
            const currentAnimation = me.currentAnimation = {
              hiding: true,
              styleProp,
              resolve
            }; // Element must behave as though it were not there during
            // the animated hide. This means pointer-events:none

            element.classList.add('b-hiding');
            me.isAnimating = true; // afterHideShowAnimate will always be called even if the transition aborts

            me.currentAnimation.detacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].onTransitionEnd({
              element,
              property: styleProp,
              duration: parseDuration(animProps.duration) + 20,
              handler: () => me.afterHideShowAnimate(currentAnimation),
              thisObj: me
            }); // Setting transition style initial value before showing,
            // then reading the style to ensure transition will animate

            style[styleProp] = animProps.from;
            _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStyleValue(element, styleProp);
            style.transition = `${styleProp} ${animProps.duration} ease ${animProps.delay}`;
            style[styleProp] = animProps.to;
          } else {
            element.classList.add('b-hidden');
          }
        } else {
          element.classList.add('b-hidden');
        } // only supply resolve function if not using animation


        me.afterHide(!hideAnimation && resolve, hideAnimation);
      }
    });
  }

  doHideOrRealign({
    target,
    isTrusted
  }) {
    const me = this,
          {
      anchoredTo,
      lastAlignSpec,
      element
    } = me,
          lastTarget = lastAlignSpec === null || lastAlignSpec === void 0 ? void 0 : lastAlignSpec.target,
          position = lastAlignSpec === null || lastAlignSpec === void 0 ? void 0 : lastAlignSpec.position,
          activeEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(me); // If it's a synthesized scroll event (such as from our ResizeMonitor polyfill), ignore it
    // If we're scrolling because a focused textual input field which we contain is being shifted into view,
    // we must not reposition - we'll just move with the document content.
    // event.target might be missing with LockerService enabled

    if (!isTrusted || !target || target.nodeType === Element.DOCUMENT_NODE && element.contains(activeEl) && textInputTypes[activeEl] && window.innerHeight < document.body.offsetHeight) {
      return;
    } // Scroll is inside this widget, or owned by this widget: no action


    if (target.nodeType === Node.ELEMENT_NODE && (element.contains(target) || me.owns(target))) {
      return;
    } // An element that is not document and does not contain the element we are anchored to was scrolled,
    // probably by scroll syncing header / body of Grid or similar. Ignore


    if ((lastTarget === null || lastTarget === void 0 ? void 0 : lastTarget.nodeType) === Node.ELEMENT_NODE && !target.contains(lastTarget) && target.nodeType !== Element.DOCUMENT_NODE) {
      return;
    } // Store current position if we are to hide on scroll below,
    // used to determine if realigning did actually move us and thus should hide


    const xy = me.scrollAction === 'hide' && me.getXY(); // Perform the realignment

    me.realign(); // Might destroy on hide in realign, so check for isDestroyed.

    if (!me.isDestroyed && me.scrollAction === 'hide') {
      const [newX, newY] = me.getXY(),
            moved = newX !== xy[0] || newY !== xy[1]; // If the scroll caused our position to become invalid, and we either don't know what element
      // we're anchored to (or not anchored to one at all), or the element we're anchored to has been
      // affected by the scroll, we must hide.
      // target might be missing with LockerService enabled

      if ((moved || (lastTarget === null || lastTarget === void 0 ? void 0 : lastTarget.$$name) === 'Point' || position) && (!anchoredTo || target && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isDescendant(target, anchoredTo))) {
        me.hide();
      }
    }
  }

  afterHide(resolveFn = null, hideAnimation = this.hideAnimation) {
    var _me$parent2, _me$parent2$onChildHi;

    const me = this; // If a drag caused us to lose our anchor, restore it upon hide.

    me._anchor = me._configuredAnchorState; // Remove listeners which are only added during the visible phase.
    // In its own method because it's called on hide and destroy.

    me.removeTransientListeners(); // Postprocessing to be done after the hideAnimation finishes.
    // If there's no animation, we call it immediately.
    // We set the element to be hidden here, after any animation completes.
    // We also remove floating Widgets from the DOM when they are hidden.

    if (!hideAnimation) {
      me.afterHideAnimation();
    }
    /**
     * Triggered after a widget was hidden
     * @event hide
     * @param {Core.widget.Widget} source The widget
     */


    me.trigger('hide'); // Keep any owning container informed about visibility state.
    // It may not be a Container. SubGrid class is still a Widget
    // which contains grid headers.

    (_me$parent2 = me.parent) === null || _me$parent2 === void 0 ? void 0 : (_me$parent2$onChildHi = _me$parent2.onChildHide) === null || _me$parent2$onChildHi === void 0 ? void 0 : _me$parent2$onChildHi.call(_me$parent2);
    resolveFn && resolveFn(); // cannot do resolveFn?.() since resolveFn can be false
  }

  removeTransientListeners() {
    const me = this;
    me.clearTimeout(me.resizeListenerTimeout);
    me.clearTimeout(me.scrollListenerTimeout);

    if (me.documentScrollListener) {
      me.documentScrollListener();
      me.documentScrollListener = false;
    }

    if (me.rootScrollListener) {
      me.rootScrollListener();
      me.rootScrollListener = false;
    }

    if (me.targetResizeListener) {
      _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(me.lastAlignSpec.target, me.callRealign);
      me.targetResizeListener = false;
    }

    if (me.constrainListeners) {
      _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeResizeListener(me.lastAlignSpec.constrainTo || window, me.callRealign);
      me.constrainMutationMonitor && me.constrainMutationMonitor.disconnect();
      me.constrainListeners = false;
    }
  }

  afterHideAnimation() {
    const me = this,
          {
      element
    } = me;

    if (me.floating && me.floatRoot.contains(element)) {
      element.remove();
    } else {
      element.classList.add('b-hidden');
    } // Reset anchor to its default colour after hide


    if (me.defaultAnchorBackgroundColor) {
      // Reset to default in case it has been positioned by a coloured header
      me.anchorPathElement.setAttribute('fill', me.defaultAnchorBackgroundColor);
    }
  }

  changeHidden(value) {
    const me = this;
    let ret;

    if (me.isConfiguring) {
      ret = Boolean(value);
      me.element.classList[value ? 'add' : 'remove']('b-hidden');
    } else {
      // These methods are async but set _hidden when they get past the before event, so don't set ret and
      // the setter won't set _hidden automatically.
      me.trigger('beforeChangeHidden', {
        hidden: value
      });

      if (value) {
        me.hide();
      } else {
        me.show();
      }
    }

    return ret;
  }
  /**
   * Get id assigned by user (not generated id)
   * @returns {String}
   * @readonly
   * @private
   * @category Misc
   */


  get assignedId() {
    return this.hasGeneratedId ? null : this.id;
  }
  /**
   * Get the owning Widget of this Widget. If this Widget is directly contained, then the containing
   * Widget is returned. If this Widget is floating, the configured `owner` property is returned.
   * If there is a `forElement`, that element's encapsulating Widget is returned.
   * @property {Core.widget.Widget}
   * @readonly
   * @category Widget hierarchy
   */


  get owner() {
    return this.parent || this._owner || this.containingWidget;
  }

  get containingWidget() {
    let result = this.parent;

    if (!result) {
      var _this$forElement, _this$element;

      const owningEl = ((_this$forElement = this.forElement) === null || _this$forElement === void 0 ? void 0 : _this$forElement.nodeType) === Element.ELEMENT_NODE ? this.forElement : (_this$element = this.element) === null || _this$element === void 0 ? void 0 : _this$element.parentNode;
      result = (owningEl === null || owningEl === void 0 ? void 0 : owningEl.closest('.b-widget')) && Widget.fromElement(owningEl);
    }

    return result;
  }
  /**
   * Get this Widget's previous sibling in the parent {@link Core.widget.Container Container}, or, if not
   * in a Container, the previous sibling widget in the same _parentElement_.
   * @property {Core.widget.Widget}
   * @readonly
   * @category Widget hierarchy
   */


  get previousSibling() {
    return this.getSibling(-1);
  }
  /**
   * Get this Widget's next sibling in the parent {@link Core.widget.Container Container}, or, if not
   * in a Container, the next sibling widget in the same _parentElement_.
   * @property {Core.widget.Widget}
   * @readonly
   * @category Widget hierarchy
   */


  get nextSibling() {
    return this.getSibling(1);
  }

  getSibling(increment) {
    const me = this,
          {
      parent
    } = me,
          siblings = parent ? parent.childItems : Array.from(me.element.parentElement.querySelectorAll('.b-widget'));
    return parent ? siblings[siblings.indexOf(me) + increment] : Widget.fromElement(siblings[siblings.indexOf(me.element) + increment]);
  }
  /**
   * Looks up the {@link #property-owner} axis to find an ancestor which matches the passed selector.
   * The selector may be a widget type identifier, such as `'grid'`, or a function which will return
   * `true` when passed the desired ancestor.
   * @param {String|Function} selector A Type identifier or selection function.
   * @param {Boolean} [deep] When using a string identifier, pass `true` if all superclasses should be included, ie if a `Grid` should match `'widget'`.
   * @param {Number|String|Core.widget.Widget} [limit] how many steps to step up before aborting the search, or a selector to stop at or the topmost ancestor to consider.
   * @category Widget hierarchy
   */


  up() {
    const {
      owner
    } = this;

    if (owner) {
      return owner.closest(...arguments);
    }
  }
  /**
   * Starts with this Widget, then Looks up the {@link #property-owner} axis to find an ancestor which matches the passed selector.
   * The selector may be a widget type identifier, such as `'grid'`, or a function which will return
   * `true` when passed the desired ancestor.
   * @param {String|Function} selector A Type identifier or selection function.
   * @param {Boolean} [deep] When using a string identifier, pass `true` if all superclasses should be included, ie if a `Grid` should match `'widget'`.
   * @param {Number|String|Core.widget.Widget} [limit] how many steps to step up before aborting the search, or a selector to stop at or the topmost ancestor to consider.
   * @category Widget hierarchy
   */


  closest(selector, deep, limit) {
    const limitType = typeof limit,
          numericLimit = limitType === 'number',
          selectorLimit = limitType === 'string';

    for (let result = this, steps = 1; result; result = result.owner, steps++) {
      if (Widget.widgetMatches(result, selector, deep)) {
        return result;
      }

      if (numericLimit && steps >= limit) {
        return;
      } else if (selectorLimit && Widget.widgetMatches(result, limit, deep)) {
        return;
      } else if (result === limit) {
        return;
      }
    }
  }
  /**
   * Returns `true` if this Widget owns the passed Element, Event or Widget. This is based on the widget hierarchy,
   * not DOM containment. So an element in a `Combo`'s dropdown list will be owned by the `Combo`.
   * @param {HTMLElement|Event|Core.widget.Widget} target The element event or Widget to test for being
   * within the ownership tree of this Widget.
   * @category Widget hierarchy
   */


  owns(target) {
    if (target) {
      // Passed an event, grab its target
      if (target.eventPhase) {
        target = target.target;
      } // We were passed an HTMLElement


      if (target.nodeType === Element.ELEMENT_NODE) {
        if (this.element.contains(target)) {
          return true;
        }

        target = Widget.fromElement(target);
      }

      while (target) {
        if (target === this) {
          return true;
        }

        target = target.owner;
      }
    }

    return false;
  }
  /**
   * Iterate over all ancestors of this widget.
   *
   * *Note*: Due to this method aborting when the function returns `false`, beware of using short form arrow
   * functions. If the expression executed evaluates to `false`, iteration will terminate.
   * @param {Function} fn Function to execute for all ancestors. Terminate iteration by returning `false`.
   * @returns {Boolean} Returns `true` if iteration was not aborted by a step returning `false`
   * @category Widget hierarchy
   */


  eachAncestor(fn) {
    let ancestor = this.owner;

    while (ancestor) {
      if (fn(ancestor) === false) {
        return false;
      }

      ancestor = ancestor.owner;
    }

    return true;
  }

  changeMonitorResize(monitorResize, oldMonitorResize) {
    // They are mutually exclusive. scaleToFitWidth disables monitorResize
    const result = this.scaleToFitWidth ? false : Boolean(monitorResize); // null and undefined both mean false. Avoid going through the updater if no change.

    if (result !== Boolean(oldMonitorResize)) {
      return result;
    }
  }

  updateMonitorResize(monitorResize) {
    const me = this;

    if (!hasOwnProperty.call(me, 'onElementResize')) {
      me.onElementResize = me.onElementResize.bind(me);
    }

    _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_9__["default"][monitorResize ? 'addResizeListener' : 'removeResizeListener'](me.element, me.onElementResize);
  }

  changeReadOnly(readOnly) {
    readOnly = Boolean(readOnly); // It starts as undefined, so if false is passed, that's a no-change.

    if (Boolean(this._readOnly) !== readOnly) {
      return readOnly;
    }
  }

  updateReadOnly(readOnly) {
    var _this$element2;

    // Can be called from the element initialization because of the way Panel is set up.
    // tbar and bbar are instantiated, and their elements added to the gathered element
    // config object, but that can have consequences which can lead here.
    // eslint-disable-next-line no-unused-expressions
    (_this$element2 = this.element) === null || _this$element2 === void 0 ? void 0 : _this$element2.classList[readOnly ? 'add' : 'remove']('b-readonly'); // Do not update  children at configure time.
    // Container will sync its items.

    if (!this.isConfiguring) {
      // Implemented at this level because Widgets can own a descendant tree without being
      // a Container. For example Combos own a ChipView and a List. Buttons own a Menu etc.
      this.eachWidget(widget => {
        if (!('_originalReadOnly' in widget)) {
          // Store initial readOnly/disabled value.
          // the config getter copies the properties in a loop
          // so execute once and cache the value.
          widget._originalReadOnly = widget.config.readOnly || false;
        } // Set if truthy, otherwise reset to initial value


        widget.readOnly = readOnly || widget._originalReadOnly;
      }, false);
      /**
       * Fired when a Widget's read only state is toggled
       * @event readOnly
       * @param {Boolean} readOnly Read only or not
       */

      this.trigger('readOnly', {
        readOnly
      });
    }
  }
  /**
   * Iterate over all widgets owned by this widget and any descendants.
   *
   * *Note*: Due to this method aborting when the function returns `false`, beware of using short form arrow
   * functions. If the expression executed evaluates to `false`, iteration will terminate.
   * @param {Function} fn A function to execute upon each descendant widget.
   * Iteration terminates if this function returns `false`.
   * @param {Core.widget.Widget} fn.widget The current descendant widget.
   * @param {Object} fn.control An object containing recursion control options.
   * @param {Boolean} fn.control.down A copy of the `deep` parameter. This can be adjusted by `fn` to decide which
   * widgets should be recursed. This value will always be the value of `deep` on entry and the value of `control.down`
   * upon return determines the recursion into the current widget.
   * @param {Boolean} [deep=true] Pass as `false` to only consider immediate child widgets.
   * @returns {Boolean} Returns `true` if iteration was not aborted by a step returning `false`
   * @category Widget hierarchy
   */


  eachWidget(fn, deep = true) {
    const widgets = this.childItems,
          length = (widgets === null || widgets === void 0 ? void 0 : widgets.length) || 0,
          control = {};

    for (let i = 0; i < length; i++) {
      const widget = widgets[i];
      control.down = deep; // Abort if a call returns false

      if (fn(widget, control) === false) {
        return false;
      }

      if (control.down && widget.eachWidget) {
        // Abort if a deep call returns false
        if (widget.eachWidget(fn, deep) === false) {
          return false;
        }
      }
    }

    return true;
  }
  /**
   * Returns an array of all descendant widgets which the passed
   * filter function returns `true` for.
   * @param {Function} filter A function which, when passed a widget,
   * returns `true` to include the widget in the results.
   * @returns {Core.widget.Widget[]} All matching descendant widgets.
   * @category Widget hierarchy
   */


  queryAll(filter) {
    const result = [];
    this.eachWidget(w => {
      if (filter(w)) {
        result.push(w);
      }
    });
    return result;
  }
  /**
   * Returns the first descendant widgets which the passed
   * filter function returns `true` for.
   * @param {Function} filter A function which, when passed a widget,
   * returns `true` to return the widget as the sole result.
   * @returns {Core.widget.Widget} The first matching descendant widget.
   * @category Widget hierarchy
   */


  query(filter) {
    let result = null;
    this.eachWidget(w => {
      if (filter(w)) {
        result = w;
        return false;
      }
    });
    return result;
  }
  /**
   * Get a widget by ref, starts on self and traverses up the owner hierarchy checking `widgetMap` at each level.
   * Not checking the top level widgetMap right away to have some acceptance for duplicate refs.
   * @param {String} ref ref to find
   * @returns {Core.widget.Widget}
   * @internal
   * @category Widget hierarchy
   */


  getWidgetByRef(ref) {
    var _this$widgetMap, _this$owner;

    if (ref instanceof Widget) {
      return ref;
    }

    return (this === null || this === void 0 ? void 0 : (_this$widgetMap = this.widgetMap) === null || _this$widgetMap === void 0 ? void 0 : _this$widgetMap[ref]) || (this === null || this === void 0 ? void 0 : (_this$owner = this.owner) === null || _this$owner === void 0 ? void 0 : _this$owner.getWidgetByRef(ref));
  }

  onFocusIn(e) {
    const me = this,
          {
      element
    } = me;
    me.containsFocus = true;
    me.focusInEvent = e;
    element.classList.add('b-contains-focus');

    if (element.contains(e._target) && me.onInternalKeyDown && !me.keyDownListenerRemover) {
      me.keyDownListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
        element,
        keydown: 'onInternalKeyDown',
        thisObj: me
      });
    }
    /**
     * Fired when focus enters this Widget.
     * @event focusIn
     * @param {Core.widget.Widget} source - This Widget
     * @param {HTMLElement} fromElement The element which lost focus.
     * @param {HTMLElement} toElement The element which gained focus.
     * @param {Core.widget.Widget} fromWidget The widget which lost focus.
     * @param {Core.widget.Widget} toWidget The widget which gained focus.
     * @param {Boolean} backwards `true` if the `toElement` is before the `fromElement` in document order.
     */


    me.trigger('focusin', e);
  }

  onFocusOut(e) {
    const me = this;

    if (me.keyDownListenerRemover) {
      me.keyDownListenerRemover();
      me.keyDownListenerRemover = null;
    }

    if (!me.isDestroyed) {
      // Focus to nowhere, focus a close relation
      if (!e.relatedTarget) {
        me.revertFocus(!me.isVisible);
      }

      me.containsFocus = false;
      me.element.classList.remove('b-contains-focus');
      /**
       * Fired when focus exits this Widget's ownership tree. This is different from a `blur` event.
       * focus moving from within this Widget's ownership tree, even if there are floating widgets
       * will not trigger this event. This is when focus exits this widget completely.
       * @event focusOut
       * @param {Core.widget.Widget} source - This Widget
       * @param {HTMLElement} fromElement The element which lost focus.
       * @param {HTMLElement} toElement The element which gained focus.
       * @param {Core.widget.Widget} fromWidget The widget which lost focus.
       * @param {Core.widget.Widget} toWidget The widget which gained focus.
       * @param {Boolean} backwards `true` if the `toElement` is before the `fromElement` in document order.
       */

      me.trigger('focusout', e);
    }
  }
  /**
   * Returns a function that will set the focus (`document.activeElement`) to the most consistent element possible
   * based on the focus state at the time this method was called. Derived classes can implement `captureFocusItem()`
   * to refine this process to include logical items (e.g., a grid cell) that would be more stable than DOM element
   * references.
   *
   * If this widget does not contain the focus, the returned function will do nothing.
   * @returns {Function}
   * @internal
   */


  captureFocus() {
    const me = this,
          activeElementWas = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(me),
          restore = me.contains(activeElementWas) && me.captureFocusItem(activeElementWas);
    return scrollIntoView => {
      if (restore && !me.isDestroying) {
        const activeElementNow = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(me);

        if (activeElementNow !== activeElementWas) {
          restore(scrollIntoView);
        }
      }
    };
  }
  /**
   * This method is called by `captureFocus()` when this widget contains the focus and it returns a function that
   * restores the focus to the correct internal element. The returned function is only called if the current
   * `document.activeElement` is different from the passed `activeElement`.
   *
   * This method can be replaced by derived classes to capture stable identifiers for the currently focused, logical
   * item (for example, a cell of a grid).
   *
   * @param {HTMLElement} activeElement The current `document.activeElement`.
   * @returns {Function} Returns a function that accepts a boolean argument. Defaults to `true`, `false` attempts to
   * focus without scrolling.
   * @internal
   */


  captureFocusItem(activeElement) {
    return (scrollIntoView = true) => {
      if (this.contains(activeElement)) {
        scrollIntoView ? activeElement.focus() : _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].focusWithoutScrolling(activeElement);
      }
    };
  }
  /**
   * Returns `true` if this widget is or contains the specified element or widget.
   * @param {HTMLElement|Core.widget.Widget} elementOrWidget The element or widget
   * @param {Boolean} [strict] Pass `true` to test for strict containment (if `elementOrWidget` is this widget, the
   * return value will be `false`).
   * @returns {Boolean}
   */


  contains(elementOrWidget, strict) {
    const {
      element
    } = this;

    if (elementOrWidget && element) {
      if (elementOrWidget.isWidget) {
        elementOrWidget = elementOrWidget.element;
      } // el.contains(el) === true


      return element.contains(elementOrWidget) && (!strict || element !== elementOrWidget);
    }
  }
  /**
   * If this Widget contains focus, focus is reverted to the source from which it entered if possible,
   * or to a close relative if not.
   * @param {Boolean} [force] Pass as `true` to move focus to the previously focused item, or the
   * closest possible relative even if this widget does not contain focus.
   */


  revertFocus(force) {
    var _me$focusInEvent, _target;

    const me = this,
          activeElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getActiveElement(me);
    let target = (_me$focusInEvent = me.focusInEvent) === null || _me$focusInEvent === void 0 ? void 0 : _me$focusInEvent.relatedTarget;

    if (force || me.containsFocus && ((_target = target) === null || _target === void 0 ? void 0 : _target.nodeType) === Element.ELEMENT_NODE && me.element.contains(activeElement)) {
      if (!target || !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isFocusable(target)) {
        target = me.getFocusRevertTarget();
      }

      if (target && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isFocusable(target)) {
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].focusWithoutScrolling(target);
      } else {
        // If we could not find a suitable target to receive focus, we still need to not be focused. Oddly,
        // one cannot do "document.body.focus()" but explicitly calling blur() has that effect. If we do not
        // do this, and we retain the focus, we can have issue w/closeAction=destroy which can cause the blur
        // in afterHideAnimation which then causes that element.remove() to throw DOM exceptions.
        activeElement === null || activeElement === void 0 ? void 0 : activeElement.blur();
      }
    }
  }
  /**
   * This method finds a close sibling (or parent, or parent's sibling etc recursively) to which focus
   * can be directed in the case of revertFocus not having a focusable element from our focusInEvent.
   *
   * This can happen when the "from" component is destroyed or hidden. We should endeavour to prevent
   * focus escaping to `document.body` for accessibility and ease of use, and keep focus close.
   * @internal
   */


  getFocusRevertTarget() {
    const me = this,
          {
      owner,
      focusInEvent
    } = me,
          searchDirection = focusInEvent ? focusInEvent.backwards ? 1 : -1 : -1;
    let target = focusInEvent && focusInEvent.relatedTarget;
    const toComponent = target && Widget.fromElement(target); // If the from element is now not focusable, for example an Editor which hid
    // itself on focus leave, then we have to find a sibling/parent/parent's sibling
    // to take focus. Anything is better than flipping to document.body.

    if (owner && !owner.isDestroyed && (!target || !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isFocusable(target) || toComponent && !toComponent.isFocusable)) {
      target = null; // If this widget can have siblings, then find the closest
      // (in the direction focus arrived from) focusable sibling.

      if (owner.eachWidget) {
        const siblings = []; // Collect focusable siblings.
        // With this included so we can find ourselves.

        owner.eachWidget(w => {
          if (w === me || w.isFocusable) {
            siblings.push(w);
          }
        }, false);

        if (siblings.length > 1) {
          const myIndex = siblings.indexOf(me);
          target = siblings[myIndex + searchDirection] || siblings[myIndex - searchDirection];
        }
      } // No focusable siblings found to take focus, try the owner


      if (!target && owner.isFocusable) {
        target = owner;
      } // If non of the above found any related focusable widget,
      // Go through these steps for the owner.


      target = target ? target.focusElement : owner.getFocusRevertTarget();
    }

    return target;
  }
  /**
   * Returns a `DomClassList` computed from the `topMostBase` (e.g., `Widget` or `Panel`) with the given `suffix`
   * appended to each `widgetClass`.
   * @param {Function} topMostBase The top-most base class constructor at which to start gathering classes.
   * @param {String} [suffix] An optional suffix to apply to all widget classes.
   * @returns {Core.helper.util.DomClassList}
   * @internal
   * @category DOM
   */


  getStaticWidgetClasses(topMostBase, suffix) {
    const classList = new _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"](),
          hierarchy = this.$meta.hierarchy;
    let cls, i, name, widgetClass, widgetClassProperty;

    for (i = hierarchy.indexOf(topMostBase); i < hierarchy.length; ++i) {
      var _widgetClassProperty;

      cls = hierarchy[i];
      widgetClassProperty = Reflect.getOwnPropertyDescriptor(cls.prototype, 'widgetClass'); // If the Class has its own get widgetClass, call it upon this instance.

      if ((_widgetClassProperty = widgetClassProperty) !== null && _widgetClassProperty !== void 0 && _widgetClassProperty.get) {
        widgetClass = widgetClassProperty.get.call(this);
      } else {
        // All built in widgets should define $name to be safer from minification/obfuscation, but user
        // created might not so fall back to actual name. UMD files use a _$name property
        // which the Base $$name getter uses as a fallback.
        name = hasOwnProperty.call(cls, '$$name') || hasOwnProperty.call(cls, '$name') || hasOwnProperty.call(cls, '_$name') ? cls.$$name : cls.name; // Throw error in case of an obfuscated name or an autogenerated name.
        // These should never be released without a meaningful $name getter.

        if (name.length < 3 || name.includes('$')) {
          // class.$name comes from parent API class which has it
          console.warn(`Class "${name}" extending "${cls.$name}" should have "$name" static getter with no less than 3 chars.`);
        }

        widgetClass = `b-${name.toLowerCase()}`;
      }

      if (widgetClass) {
        classList.add(suffix ? widgetClass + suffix : widgetClass);
      }
    }

    return classList;
  }

  get rootUiClass() {
    return Widget;
  }
  /**
   * Returns the `DomClassList` for this widget's class. This object should not be mutated.
   * @returns {Core.helper.util.DomClassList}
   * @internal
   * @category DOM
   */


  get staticClassList() {
    const {
      $meta: meta
    } = this;
    let classList = meta.staticClassList;

    if (!classList) {
      // Compute the class part of the widgetList just once per class (cache it on the $meta object):
      meta.staticClassList = classList = this.getStaticWidgetClasses(Widget); // TODO this should probably be only for outer-most widgets

      _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isTouchDevice && classList.add('b-touch');
    }

    return classList;
  }
  /**
   * Returns the cross-product of the classes `staticClassList` with each `ui` as an array of strings.
   *
   * For example, a Combo with a `ui: 'foo bar'` would produce:
   *
   *      [
   *          'b-widget-foo', 'b-field-foo', 'b-textfield-foo', 'b-pickerfield-foo', 'b-combo-foo',
   *          'b-widget-bar', 'b-field-bar', 'b-textfield-bar', 'b-pickerfield-bar', 'b-combo-bar'
   *      ]
   *
   * @returns {String[]}
   * @internal
   * @category DOM
   */


  get uiClasses() {
    // our result is maintained by updateUi so ensure the ui config has been evaluated:
    this.getConfig('ui');
    return this._uiClasses;
  }
  /**
   * Returns the cross-product of the classes `staticClassList` with each `ui` as a `DomClassList` instance.
   *
   * For example, a Combo with a `ui: 'foo bar'` would produce:
   *
   * ```javascript
   *      new DomClassList({
   *          'b-field-ui-foo'       : 1,
   *          'b-textfield-ui-foo'   : 1,
   *          'b-pickerfield-ui-foo' : 1,
   *          'b-combo-ui-foo'       : 1,
   *
   *          'b-field-ui-bar'       : 1,
   *          'b-textfield-ui-bar'   : 1,
   *          'b-pickerfield-ui-bar' : 1,
   *          'b-combo-ui-bar'       : 1
   *      });
   * ```
   *
   * A Panel with a `ui: 'foo bar'` would produce:
   *
   * ```javascript
   *      new DomClassList({
   *          'b-panel-ui-foo' : 1,
   *          'b-panel-ui-bar' : 1
   *      });
   * ```
   * @returns {Core.helper.util.DomClassList}
   * @internal
   * @category DOM
   */


  get uiClassList() {
    // our result is maintained by updateUi so ensure the ui config has been evaluated:
    this.getConfig('ui');
    return this._uiClassList;
  }
  /**
   * Used by the Widget class internally to create CSS classes based on this Widget's
   * inheritance chain to allow styling from each level to apply.
   *
   * For example Combo would yield `"["b-widget", "b-field", "b-textfield", "b-pickerfield", "b-combo"]"`
   *
   * May be implemented in subclasses to add or remove classes from the super.widgetClassList
   * @returns {String[]} The css class list named using the class name.
   * @internal
   * @category DOM
   */


  get widgetClassList() {
    const me = this,
          {
      cls,
      defaultCls,
      uiClasses
    } = me;
    let {
      staticClassList
    } = me,
        classList;

    if (defaultCls || cls) {
      // clone the class-level classList before instance stuff goes on...
      staticClassList = staticClassList.clone();
      defaultCls && staticClassList.assign(defaultCls); // note: these can be falsy keys

      cls && staticClassList.assign(cls);
    }

    classList = staticClassList.values; // a new array of truthy keys...

    uiClasses && classList.push(...uiClasses);
    me.floating && classList.push('b-floating');

    if (me.collapsify === 'hide') {
      classList.push('b-collapsify-hide');
    }

    return classList;
  }

  changeCls(cls) {
    return _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(cls);
  }

  changeContentElementCls(cls) {
    return _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(cls);
  }

  changeHtmlCls(cls) {
    return _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(cls);
  }

  changeDefaultCls(cls) {
    return _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(cls,
    /* returnEmpty */
    true);
  }

  changeUi(ui) {
    return _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(ui);
  }

  updateUi(ui) {
    var _uiClassList;

    let uiClassList = null,
        cls,
        suffix;

    if (ui) {
      const staticClassList = this.getStaticWidgetClasses(this.rootUiClass);

      for (suffix in ui) {
        if (ui[suffix]) {
          for (cls in staticClassList) {
            if (staticClassList[cls]) {
              (uiClassList || (uiClassList = new _helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_3__["default"]()))[`${cls}-ui-${suffix}`] = 1;
            }
          }
        }
      }
    }

    this._uiClasses = (_uiClassList = uiClassList) === null || _uiClassList === void 0 ? void 0 : _uiClassList.values; // an array of each value

    this._uiClassList = uiClassList;
  } //endregion
  //region Cache

  /**
   * Gets dom elements in the view. Caches the results for faster future calls.
   * @param {String} query CSS selector
   * @param {Boolean} children true to fetch multiple elements
   * @param {HTMLElement} element Element to use as root for the query, defaults to the views outermost element
   * @returns {HTMLElement|HTMLElement[]|null} A single element or an array of elements (if parameter children is set to true)
   * @internal
   * @category DOM
   */


  fromCache(query, children = false, element = this.element) {
    if (!element) return null;
    const me = this;

    if (!me.cache[query]) {
      me.cache[query] = children ? _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].children(element, query) : _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].down(element, query);
    }

    return me.cache[query];
  }
  /**
   * Clear caches, forces all calls to fromCache to requery dom. Called on render/rerender.
   * @internal
   * @category DOM
   */


  emptyCache() {
    this.cache = {};
  } //endregion
  //region Mask


  changeMasked(mask, maskInstance) {
    if (mask === true || mask === '') {
      // empty string don't render well, so promote it to an &nbsp; as well
      mask = '\xA0'; // nbsp
    }

    if (maskInstance) {
      if (typeof mask === 'string') {
        maskInstance.text = mask;
        mask = maskInstance;
      } else if (mask) {
        maskInstance.setConfig(mask);
        mask = maskInstance;
      } else {
        maskInstance.destroy();
      }
    } else if (mask) {
      const Mask = Widget.resolveType('mask');
      mask = Mask.mergeConfigs(this.maskDefaults, mask);
      mask.owner = this;
      mask = Mask.mask(mask);
    }

    return mask || null;
  }

  onMaskAutoClose(mask) {
    if (mask.isDestroyed && mask === this.masked) {
      this.masked = null;
    }
  }
  /**
   * Mask the widget, showing the specified message
   * @param {String|Object} msg Mask message (or a {@link Core.widget.Mask} config object
   * @returns {Core.widget.Mask}
   */


  mask(msg) {
    this.masked = msg;
    return this.masked;
  }
  /**
   * Unmask the widget
   */


  unmask() {
    this.masked = null;
  } //endregion
  //region Monitor resize


  onInternalResize(element, width, height, oldWidth, oldHeight) {
    this._width = element.offsetWidth;
    this._height = element.offsetHeight;
  }

  onElementResize(resizedElement) {
    const me = this,
          {
      element
    } = me,
          oldWidth = me._width,
          oldHeight = me._height,
          newWidth = element.offsetWidth,
          newHeight = element.offsetHeight;

    if (me.floating) {
      me.onFloatingWidgetResize(...arguments);
    }

    if (!me.suspendResizeMonitor && (oldWidth !== newWidth || oldHeight !== newHeight)) {
      me.onInternalResize(element, newWidth, newHeight, oldWidth, oldHeight);
      /**
       * Fired when the encapsulating element of a Widget resizes *only when {@link #config-monitorResize} is `true`*.
       * @event resize
       * @param {Core.widget.Widget} source - This Widget
       * @param {Number} width The new width
       * @param {Number} height The new height
       * @param {Number} oldWidth The old width
       * @param {Number} oldHeight The old height
       */

      me.trigger('resize', {
        width: newWidth,
        height: newHeight,
        oldWidth,
        oldHeight
      });
    }
  }

  onFloatingWidgetResize(resizedElement, lastRect, myRect) {
    const me = this,
          {
      lastAlignSpec,
      constrainTo
    } = me; // If this Popup changes size while we are aligned and we are aligned to
    // a target (not a position), then we might need to realign.

    if (me.isVisible && lastAlignSpec && lastAlignSpec.target) {
      const heightChange = !lastRect || myRect.height !== lastRect.height,
            widthChange = !lastRect || myRect.width !== lastRect.width,
            failsConstraint = constrainTo && !_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(constrainTo).contains(_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(me.element, null, true)); // Only realign if:
      // the height has changed and we are not aligned below, or
      // the width has changed and we are not aligned to the right.

      if (heightChange && lastAlignSpec.zone !== 2 || widthChange && lastAlignSpec.zone !== 1 || failsConstraint) {
        // Must move to next AF because in Chrome, the resize monitor might fire
        // before the element is painted and the anchor color matching
        // scheme cannot work in that case.
        me.requestAnimationFrame(() => me.realign());
      }
    }
  }

  updateScale() {
    const me = this,
          element = me.element,
          parentElement = element.parentElement; // this could be placed elsewhere but want to keep it contained to not spam other code,
    // since this is a very specific use case in our docs

    if (!me.configuredWidth) {
      me.configuredWidth = me.width;
    } // TODO: handle autoHeight, but seems it assigns height to late with current setup
    // We are scaling to fit inside the width, so ensure that we are not the cause of a scrollbar
    // in our current, unscaled state by hiding while we measure the parent's offsetWidth which
    // we are going to scale to.


    element.style.display = 'none';
    const rect = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].client(parentElement),
          scale = rect.width / me.configuredWidth,
          adjustedScale = me.scale = me.allowGrowWidth ? Math.min(scale, 1) : scale;
    element.style.transform = `scale(${adjustedScale})`;
    element.style.transformOrigin = 'top left';
    element.style.display = '';

    if (me.allowGrowWidth && scale > 1) {
      // increase width
      me.width = me.configuredWidth * scale;
    }
  }

  onParentElementResize(event) {
    this.updateScale();
  } //endregion

  /**
   * Returns a `TRBL` array of values parse from the passed specification. This can be used to parse`
   * a value list for `margin` or `padding` or `border-width` etc - any CSS value which takes a `TRBL` value.
   * @param {Number|String|String[]} values The `TRBL` value
   * @param {String} [units=px] The units to add to values which are specified as numeric.
   * @internal
   */


  parseTRBL(values, units = 'px') {
    values = values || 0;

    if (typeof values === 'number') {
      return [`${values}${units}`, `${values}${units}`, `${values}${units}`, `${values}${units}`];
    }

    const parts = values.split(' '),
          len = parts.length;

    if (len === 1) {
      parts[1] = parts[2] = parts[3] = parts[0];
    } else if (len === 2) {
      parts[2] = parts[0];
      parts[3] = parts[1];
    } else if (len === 3) {
      parts[3] = parts[1];
    }

    return [isFinite(parts[0]) ? `${parts[0]}${units}` : parts[0], isFinite(parts[1]) ? `${parts[1]}${units}` : parts[2], isFinite(parts[2]) ? `${parts[2]}${units}` : parts[3], isFinite(parts[3]) ? `${parts[3]}${units}` : parts[4]];
  } // Returns root node for this widget, either a document or a shadowRoot


  get documentRoot() {
    var _this$owner2;

    return ((_this$owner2 = this.owner) === null || _this$owner2 === void 0 ? void 0 : _this$owner2.documentRoot) || this.element.getRootNode();
  } // Returns top most DOM element of the visible DOM tree for this widget element, either document.body or a shadowRoot


  get rootElement() {
    const me = this;

    if (!me._rootElement) {
      var _me$owner;

      let root = ((_me$owner = me.owner) === null || _me$owner === void 0 ? void 0 : _me$owner.rootElement) || me.forElement instanceof HTMLElement && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getRootElement(me.forElement); // Check element, we may be in the DOM just not visible

      if (!root) {
        const elRoot = me.element instanceof HTMLElement && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getRootElement(me.element); // Make sure we got a proper root

        if (elRoot === document.body || elRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
          root = elRoot;
        }
      }

      if (!root) {
        root = document.body;
      }

      me._rootElement = root;
    }

    return me._rootElement;
  }

  get floatRoot() {
    var _me$owner2;

    const me = this,
          rootElement = me.rootElement || ((_me$owner2 = me.owner) === null || _me$owner2 === void 0 ? void 0 : _me$owner2.rootElement);
    let {
      floatRoot
    } = rootElement;

    if (!floatRoot) {
      var _DomHelper$themeInfo;

      const {
        outerCls
      } = Widget,
            themeName = (_DomHelper$themeInfo = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].themeInfo) === null || _DomHelper$themeInfo === void 0 ? void 0 : _DomHelper$themeInfo.name;

      if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].isValidFloatRootParent(rootElement)) {
        throw new Error('Attaching float root to wrong root');
      } // When outside of our examples, the body element doesn't get the theme class.
      // The floatRoot must carry it for floating items to be themed.


      if (themeName) {
        outerCls.push(`b-theme-${themeName.toLowerCase()}`);
      }

      floatRoot = rootElement.floatRoot = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].createElement({
        className: `b-float-root ${outerCls.join(' ')}`,
        parent: rootElement
      });
      floatRoots.push(floatRoot); // Make float root immune to keyboard-caused size changes

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isAndroid) {
        floatRoot.style.height = `${screen.height}px`;
        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
          element: window,
          orientationchange: () => floatRoot.style.height = `${screen.height}px`
        });
      } // Resize float root upon keyboard-caused visual viewport size change
      // https://developer.mozilla.org/en-US/docs/Web/API/Visual_Viewport_API


      if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isHoverableDevice && window.visualViewport) {
        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
          element: window.visualViewport,
          resize: ({
            target: viewport
          }) => floatRoot.style.height = `${viewport.height}px`
        });
      } // Keep floatRoot up to date with the theme


      _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_21__["default"].on({
        theme: ({
          theme,
          prev
        }) => {
          // TODO handle for all roots
          floatRoot.classList.add(`b-theme-${theme.toLowerCase()}`);
          floatRoot.classList.remove(`b-theme-${prev.toLowerCase()}`);
        }
      });
    } // Angular might shuffle elements around so we have to ensure floatRoot is a child of the right parent
    else if (!rootElement.contains(floatRoot)) {
      // Reattach floatRoot if it was detached
      rootElement.appendChild(floatRoot);
    }

    return floatRoot;
  }

  get floatRootMaxZIndex() {
    let max = 1;
    Array.from(this.floatRoot.children).forEach(child => {
      const zIndex = parseInt(getComputedStyle(child).zIndex || 0, 10);

      if (zIndex > max) {
        max = zIndex;
      }
    });
    return max;
  }

  static resetFloatRootScroll() {
    floatRoots.forEach(floatRoot => floatRoot.scrollTop = floatRoot.scrollLeft = 0);
  }

  static get floatRoots() {
    return floatRoots;
  }

  static removeFloatRoot(floatRoot) {
    floatRoots.splice(floatRoots.indexOf(floatRoot), 1);
  } // CSS classes describing outer-most Widgets to provide styling / behavioral CSS style rules


  static get outerCls() {
    const result = ['b-outer'];

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isTouchDevice) {
      result.push('b-touch-events');
    }

    if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].scrollBarWidth) {
      result.push('b-visible-scrollbar');
    } else {
      result.push('b-overlay-scrollbar');
    }

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isChrome) {
      result.push('b-chrome');
    } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isSafari) {
      result.push('b-safari');
    } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isFirefox) {
      result.push('b-firefox');
    } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) {
      result.push('b-ie');
    } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge) {
      result.push('b-edge');
    } // So that we don't get the polyfill styles applied if we have ResizeMonitor available.
    // The polyfill styles can break certain elements styling.


    if (!window.ResizeObserver) {
      result.push('b-no-resizeobserver');
    }

    return result;
  }

  get isAnimating() {
    return this._isAnimatingCounter > 0;
  }

  set isAnimating(value) {
    const me = this;

    if (me._isAnimatingCounter === 0 && value) {
      me.element.classList.add('b-animating');
      me.trigger('animationStart');
    } else if (me._isAnimatingCounter === 1 && !value) {
      me.element.classList.remove('b-animating');
      me.trigger('animationEnd');
    }

    me._isAnimatingCounter += value ? 1 : -1;
    me._isAnimatingCounter = Math.max(0, me._isAnimatingCounter);
  } // Waits until all transitions are completed


  async waitForAnimations() {
    if (this.isAnimating) {
      await this.await('animationend', {
        checkLog: false
      });
    }
  }
  /**
   * Analogous to document.querySelector, finds the first Bryntum widget matching the passed
   * selector. Right now, only class name (lowercased) selector strings, or
   * a filter function which returns `true` for required object are allowed:
   * ```
   * bryntum.query('grid').destroy();
   * ```
   * @param {String|Function} selector A lowercased class name, or a filter function.
   * @param {Boolean} [deep] Specify `true` to search the prototype chain (requires supplying a string `selector`). For
   *   example 'widget' would then find a Grid
   * @return {Core.widget.Widget} The first matched widget if any.
   * @category Widget hierarchy
   */


  static query(selector, deep = false) {
    const {
      idMap
    } = Widget.identifiable;

    for (const id in idMap) {
      if (Widget.widgetMatches(idMap[id], selector, deep)) {
        return idMap[id];
      }
    }

    return null;
  }
  /**
   * Analogous to document.querySelectorAll, finds all Bryntum widgets matching the passed
   * selector. Right now, only registered widget `type` strings, or a filter function which
   * returns `true` for required object are allowed:
   * ```
   * let allFields = bryntum.queryAll('field', true);
   * ```
   * @param {String|Function} selector A lowercased class name, or a filter function.
   * @param {Boolean} [deep] Specify `true` to search the prototype chain (requires supplying a string `selector`). For
   *   example 'widget' would then find a Grid
   * @return {Core.widget.Widget[]} The first matched widgets if any - an empty array will be returned
   * if no matches are found.
   * @category Widget hierarchy
   */


  static queryAll(selector, deep = false) {
    const {
      idMap
    } = Widget.identifiable,
          result = [];

    for (const id in idMap) {
      if (Widget.widgetMatches(idMap[id], selector, deep)) {
        result.push(idMap[id]);
      }
    }

    return result;
  }
  /**
   * Returns the Widget which owns the passed element (or event).
   * @param {HTMLElement|Event} element The element or event to start from
   * @param {String|Function} [type] The type of Widget to scan upwards for. The lowercase
   * class name. Or a filter function which returns `true` for the required Widget.
   * @param {HTMLElement|Number} [limit] The number of components to traverse upwards to find a
   * match of the type parameter, or the element to stop at.
   * @return {Core.widget.Widget} The found Widget or null.
   * @category Misc
   */


  static fromElement(element, type, limit) {
    const typeOfType = typeof type; // Check if an event was passed

    if (element && !element.nodeType) {
      element = element.target;
    }

    if (typeOfType === 'number' || type && type.nodeType === Element.ELEMENT_NODE) {
      limit = type;
      type = null;
    }

    let target = element,
        depth = 0,
        topmost,
        cmpId,
        cmp;

    if (typeof limit !== 'number') {
      topmost = limit;
      limit = Number.MAX_VALUE;
    }

    if (typeOfType === 'string') {
      type = type.toLowerCase();
    }

    while (target && target.nodeType === Element.ELEMENT_NODE && depth < limit && target !== topmost) {
      cmpId = target.dataset && target.dataset.ownerCmp || target.id;

      if (cmpId) {
        cmp = Widget.getById(cmpId);

        if (cmp) {
          if (type) {
            if (typeOfType === 'function') {
              if (type(cmp)) {
                return cmp;
              }
            } else if (Widget.widgetMatches(cmp, type, true)) {
              return cmp;
            }
          } else {
            return cmp;
          }
        } // Increment depth on every *Widget* found


        depth++;
      }

      target = target.parentNode;
    }

    return null;
  } // NOTE: Not named `triggerChange` to not conflict with existing fn on Field

  /**
   * Triggers a 'change' event with the supplied params. After triggering it also calls `onFieldChange()` on each
   * ancestor the implements that function, supplying the same set of params.
   * @param {Object} params Event params, used both for triggering and notifying ancestors
   * @param {Boolean} [trigger] `false` to not trigger, only notifying ancestors
   * @internal
   */


  triggerFieldChange(params, trigger = true) {
    if (trigger) {
      this.trigger('change', params);
    }

    this.eachAncestor(ancestor => {
      if (ancestor.onFieldChange) {
        ancestor.onFieldChange(params);
      } // Stop going up when reaching an ancestor that isolates its fields


      if (ancestor.isolateFields) {
        return false;
      }
    });
  } // Sets up the focus listeners, one set for every document root (shadow root or document)


  setupFocusListeners() {
    // Listen to focus events on shadow root to handle focus inside the shadow dom
    _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_21__["default"].setupFocusListenersOnce(this._rootElement, _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"]);
  }

  static widgetMatches(candidate, selector, deep) {
    if (selector === '*') {
      return true;
    }

    if (typeof selector === 'function') {
      return selector(candidate);
    }

    return Widget.isType(candidate, selector, deep);
  }
  /**
   * Attached a tooltip to the specified element.
   * @example
   * Widget.attachTooltip(element, {
   *   text: 'Useful information goes here'
   * });
   * @param {HTMLElement} element Element to attach tooltip for
   * @param {Object|String} configOrText Tooltip config or tooltip string, see example and source
   * @returns {HTMLElement}
   * @category Misc
   */


  static attachTooltip(element, configOrText) {
    if (typeof configOrText === 'string') configOrText = {
      html: configOrText
    }; // TODO: refactor this
    // eslint-disable-next-line no-new

    Widget.create(Object.assign({
      forElement: element
    }, configOrText), 'tooltip');
    return element;
  }

}
const proto = Widget.prototype;
['compose', 'domSyncCallback'].forEach(fn => proto[fn].$nullFn = true); // Register this widget type with its Factory

Widget.initClass();
Widget.register('mask', _Mask_js__WEBPACK_IMPORTED_MODULE_22__["default"]); // These low level classes must not import Widget because that would cause circularity.
// Instead Widget injects a reference to itself into them.

_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].Widget = Widget;
_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_21__["default"].Widget = Widget; // We use the same map to track instances by ID

_Mask_js__WEBPACK_IMPORTED_MODULE_22__["default"].identifiable.idMap = Widget.identifiable.idMap; // Simplify querying widgets by exposing fns in bryntum ns

Object.assign(window.bryntum || (window.bryntum = {}), {
  get: Widget.getById.bind(Widget),
  query: Widget.query,
  queryAll: Widget.queryAll,
  fromElement: Widget.fromElement
});
Widget._$name = 'Widget';

/***/ }),

/***/ "./lib/Core/widget/base/UndoRedoBase.js":
/*!**********************************************!*\
  !*** ./lib/Core/widget/base/UndoRedoBase.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UndoRedoBase; });
/* harmony import */ var _Container_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Container.js */ "./lib/Core/widget/Container.js");
/* harmony import */ var _Combo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Combo.js */ "./lib/Core/widget/Combo.js");
var productName = 'taskboard';


/**
 * @module Core/widget/base/UndoRedoBase
 */

/**
 * Abstract base class used by UndoRedo widgets in Scheduler and TaskBoard.
 *
 * @extends Core/widget/Container
 * @abstract
 */

class UndoRedoBase extends _Container_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'UndoRedoBase';
  }

  static get type() {
    return 'undoredobase';
  }

  static get configurable() {
    return {
      // Documented on subclasses
      project: null,
      stm: null,

      /**
       * Configure as `true` to show "Undo" and "Redo" as button texts. The buttons always have a tooltip
       * as a hint to the user as to their purpose.
       * @config {Boolean}
       */
      text: null,

      /**
       * Button color for the undo and redo buttons. See {@link Core.widget.Button#config-color}.
       * @config {String}
       */
      color: null,

      /**
       * Configure as `true` to show "0" badge on the undo and redo buttons when they have no actions
       * left to perform. By default when there are no actions, no badge is displayed.
       * @config {Boolean}
       */
      showZeroActionBadge: null,
      cls: 'b-undo-controls b-toolbar',
      layoutStyle: {
        alignItems: 'stretch',
        flexFlow: 'row nowrap',
        overflow: 'visible'
      },
      items: {
        undoBtn: {
          type: 'button',
          icon: 'b-icon-undo',
          tooltip: 'L{UndoRedo.UndoLastAction}',
          onAction: 'up.onUndo' // 'up.' means method is on a parent Widget.

        },
        transactionsCombo: {
          type: 'combo',
          valueField: 'idx',
          editable: false,
          store: {},
          emptyText: 'No items in the undo queue',
          onAction: 'up.onTransactionSelected',
          displayValueRenderer: 'up.transactionsDisplayValueRenderer'
        },
        redoBtn: {
          type: 'button',
          icon: 'b-icon-redo',
          tooltip: 'L{UndoRedo.RedoLastAction}',
          onAction: 'up.onRedo'
        }
      }
    };
  }

  afterConstruct() {
    this.updateUndoRedoControls();
  }

  changeStm(stm) {
    stm.on({
      recordingstop: 'updateUndoRedoControls',
      restoringstop: 'updateUndoRedoControls',
      queueReset: 'updateUndoRedoControls',
      disabled: 'updateUndoRedoControls',
      thisObj: this
    });
    return stm;
  }

  changeItems(items) {
    const {
      undoBtn,
      redoBtn
    } = items;

    if (this.color) {
      undoBtn && (undoBtn.color = this.color);
      redoBtn && (redoBtn.color = this.color);
    }

    if (this.text) {
      undoBtn && (undoBtn.text = 'L{UndoRedo.Undo}');
      redoBtn && (redoBtn.text = 'L{UndoRedo.Redo}');
    }

    return super.changeItems(items);
  }

  updateProject(project) {
    this.stm = project.stm;
  }

  fillUndoRedoCombo() {
    const {
      transactionsCombo
    } = this.widgetMap; // The transactionsCombo may be configured away if only undo and redo buttons are wanted

    transactionsCombo && (transactionsCombo.items = this.stm.queue.map((title, idx) => [idx, title || `Transaction ${idx}`]));
  }

  updateUndoRedoControls() {
    const {
      stm,
      showZeroActionBadge
    } = this,
          {
      undoBtn,
      redoBtn
    } = this.widgetMap;
    undoBtn.badge = stm.position || (showZeroActionBadge ? '0' : '');
    redoBtn.badge = stm.length - stm.position || (showZeroActionBadge ? '0' : '');
    undoBtn.disabled = !stm.canUndo;
    redoBtn.disabled = !stm.canRedo;
    this.fillUndoRedoCombo();
  }

  transactionsDisplayValueRenderer(record, combo) {
    var _this$stm;

    const stmPos = ((_this$stm = this.stm) === null || _this$stm === void 0 ? void 0 : _this$stm.position) || 0;
    return `${stmPos} undo actions / ${combo.store.count - stmPos} redo actions`;
  }

  onUndo() {
    this.stm.canUndo && this.stm.undo();
  }

  onRedo() {
    this.stm.canRedo && this.stm.redo();
  }

  onTransactionSelected(combo) {
    const stm = this.stm,
          value = combo.value;

    if (value >= 0) {
      if (stm.canUndo && value < stm.position) {
        stm.undo(stm.position - value);
      } else if (stm.canRedo && value >= stm.position) {
        stm.redo(value - stm.position + 1);
      }
    }
  }

}
UndoRedoBase._$name = 'UndoRedoBase';

/***/ }),

/***/ "./lib/Core/widget/graph/Histogram.js":
/*!********************************************!*\
  !*** ./lib/Core/widget/graph/Histogram.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Histogram; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Tooltip_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Tooltip.js */ "./lib/Core/widget/Tooltip.js");
var productName = 'taskboard';





/**
 * @module Core/widget/graph/Histogram
 */

const ns = 'http://www.w3.org/2000/svg',
      // Outline series must overlay bars
typePrio = {
  bar: 1,
  outline: 2,
  text: 3
},
      byDatasetOrder = (l, r) => parseInt(l.dataset.order, 10) - parseInt(r.dataset.order, 10),
      getField = s => s.field,
      returnFalse = () => false;
/**
 * Displays a simple bar histogram based upon an array of data objects passed in the {@link #config-data} config.
 * @extends Core/widget/Widget
 * @classtype histogram
 */


class Histogram extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get type() {
    return 'histogram';
  }

  static get $name() {
    return 'Histogram';
  }

  static get defaultConfig() {
    return {
      /**
       * An array of data objects used to drive the histogram. The property/properties used
       * are defined in the {@link #config-series} option.
       * @config {Object[]}
       * @default
       */
      data: null,

      /**
       * The values to represent in bar form.
       * @config {Number[]}
       */
      values: null,

      /**
       * Each item in the array must contain two properties:
       *  - `type` A String, either `'bar'` or `'outline'`
       *  - `field` A String, the name of the property to use from the data objects in the {@link #config-data} option.
       * @config {Object[]}
       */
      series: null,

      /**
       * By default, the bars are scaled based upon the detected max value across all the series.
       * A specific top value to represent the 100% height may be configured.
       * @config {Number}
       */
      topValue: null,
      element: {
        children: [{
          ns,
          tag: 'svg',
          reference: 'svgElement',
          width: '100%',
          height: '100%',
          preserveAspectRatio: 'none',
          children: [{
            ns,
            tag: 'g',
            reference: 'scaledSvgGroup'
          }, {
            ns,
            tag: 'g',
            reference: 'unscaledSvgGroup'
          }]
        }]
      },

      /**
       * By default, all bars are rendered, even those with zero height. Configure this as `true`
       * to omit zero height bars.
       * @config {Number}
       */
      omitZeroHeightBars: null,
      monitorResize: true,

      /**
       * A Function which returns a CSS class name to add to a rectangle element.
       * The following parameters are passed:
       * @param {Object} series - The series being rendered
       * @param {Object} rectConfig - The rectangle configuration object
       * @param {Object} datum - The datum being rendered
       * @param {Number} index - The index of the datum being rendered
       * @config {Function}
       */
      getRectClass: null,

      /**
       * A Function which returns the tooltip text to display when hovering a bar.
       * The following parameters are passed:
       * @param {Object} series - The series being rendered
       * @param {Object} rectConfig - The rectangle configuration object
       * @param {Object} datum - The datum being rendered
       * @param {Number} index - The index of the datum being rendered
       * @config {Function}
       */
      getBarTip: null,

      /**
       * A Function which returns the text to render inside a bar.
       * The following parameters are passed:
       * @param {Object} datum - The datum being rendered
       * @param {Number} index - The index of the datum being rendered
       * @config {Function}
       */
      getBarText: null
    };
  } //endregion
  //region Init


  construct(config) {
    super.construct(config);
    this.scheduleRefresh = this.createOnFrame(this.refresh, [], this, true);
    this.refresh();
  }

  set tip(tip) {
    var _me$tip;

    const me = this;
    (_me$tip = me.tip) === null || _me$tip === void 0 ? void 0 : _me$tip.destroy();

    if (tip) {
      me._tip = _Tooltip_js__WEBPACK_IMPORTED_MODULE_4__["default"].new({
        owner: me,
        forElement: me.svgElement,
        forSelector: 'rect',
        listeners: {
          beforeShow: 'up.onBeforeTipShow'
        }
      }, tip);
    } else {
      me._tip = null;
    }
  }

  onElementResize() {
    super.onElementResize(...arguments);
    const svgRect = this.svgElement.getBoundingClientRect();
    this.scaledSvgGroup.setAttribute('transform', `scale(${svgRect.width} ${svgRect.height})`);
  }

  onBeforeTipShow({
    source: tip
  }) {
    const index = parseInt(tip.activeTarget.dataset.index);
    tip.html = tip.contentTemplate({
      histogram: this,
      index
    });
  }

  set series(value) {
    const me = this,
          series = me._series = {};

    for (const id in value) {
      // Providing
      //
      // "series" : {
      //     "foo" : false
      //     ...
      //
      // disables the "foo" serie (that could be defined on a prototype level for example)
      if (value[id] !== false) {
        const data = series[id] = Object.assign({}, value[id]); // support type & field provided on config prototype level

        if (!data.type && value[id].type) {
          data.type = value[id].type;
        }

        if (!data.field && value[id].field) {
          data.field = value[id].field;
        }

        if (!('order' in series)) {
          data.order = typePrio[data.type];
        }

        data.id = id;
      }
    }

    me.scheduleRefresh();
  }

  get series() {
    return this._series;
  }

  set data(data) {
    const me = this; // TODO:
    // me.topValue = undefined;

    me._data = data; // Calculate the top value from all the series

    if (!me.topValue) {
      const fields = Object.values(me.series).map(getField);

      for (let i = 0, {
        length
      } = data; i < length; i++) {
        for (let j = 0, {
          length
        } = fields; j < length; j++) {
          me.topValue = Math.max(me.topValue || 0, data[i][fields[j]]);
        }
      }
    }

    me.scheduleRefresh();
  }

  get data() {
    return this._data;
  }

  set topValue(value) {
    this._topValue = value;
    this.scheduleRefresh();
  }

  get topValue() {
    return this._topValue;
  } // Must exist from the start because configuration setters call it.
  // Once configured, will be replaced with a function which schedules a refresh for the next animation frame.


  scheduleRefresh() {}

  refresh() {
    const me = this,
          {
      series,
      _tip
    } = me,
          histogramElements = [];

    for (const id in series) {
      const data = series[id],
            elConfig = me[`draw${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(data.type)}`](data);

      if (Array.isArray(elConfig)) {
        histogramElements.push.apply(histogramElements, elConfig);
      } else {
        histogramElements.push(elConfig);
      }
    }

    histogramElements.sort(byDatasetOrder);
    _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_3__["default"].syncChildren({
      domConfig: {
        children: histogramElements
      },
      configEquality: returnFalse
    }, me.scaledSvgGroup);
    _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_3__["default"].syncChildren({
      domConfig: {
        children: me.drawText()
      }
    }, me.unscaledSvgGroup);

    if (_tip && _tip.isVisible) {
      me.onBeforeTipShow({
        source: _tip
      });
    }
  }

  drawBar(series) {
    const me = this,
          {
      topValue,
      data,
      omitZeroHeightBars,
      barStyle
    } = me,
          {
      field,
      order
    } = series,
          defaultWidth = 1 / data.length,
          children = [];
    let width;

    for (let index = 0, x = 0, {
      length
    } = data; index < length; index++, x += width) {
      const datum = data[index],
            value = datum[field],
            // limit height with topValue otherwise the histogram looks fine
      // yet the bar tooltip picks wrong Y-coordinate and there is an empty space between it and the bar
      height = (value > topValue ? topValue : value) / topValue,
            y = 1 - height,
            rectConfig = datum.rectConfig = {
        ns,
        tag: 'rect',
        dataset: {}
      }; // use either provided width or the calculated value

      width = datum.width || defaultWidth;

      if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge || _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) {
        // Apparently in Edge height is calculated differently for scaled SVG content, height of the bounding client rect is calculated by formula
        // (height + 1) * scale. So visible height would be getBoundingClientRect().height - verticalScaleValue. In our case
        // verticalScaleValue is same as svgElement height.
        const svgRect = me.svgElement.getBoundingClientRect();
        rectConfig.dataset.scaleX = svgRect.width;
        rectConfig.dataset.scaleY = svgRect.height;
      }

      if (barStyle) {
        rectConfig.style = barStyle;
      } else {
        delete rectConfig.style;
      }

      Object.assign(rectConfig.dataset, {
        index,
        order
      });
      Object.assign(rectConfig, {
        x,
        y,
        width,
        height,
        class: me.callback('getRectClass', me, [series, rectConfig, datum, index])
      });
      const barTip = me.callback('getBarTip', me, [series, rectConfig, datum, index]);

      if (barTip) {
        rectConfig.dataset.btip = barTip;
      } else {
        delete rectConfig.dataset.btip;
      }

      if (height || !omitZeroHeightBars) {
        children.push(rectConfig);
      }
    }

    return children;
  }

  drawOutline(series) {
    const me = this,
          {
      topValue,
      data
    } = me,
          {
      field,
      order
    } = series,
          defaultWidth = 1 / data.length,
          coords = ['M 0,1'],
          result = series.outlineElement || (series.outlineElement = {
      ns,
      tag: 'path',
      dataset: {
        order
      }
    });

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEdge || _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isIE11) {
      const svgRect = me.svgElement.getBoundingClientRect(); // Edge doesn't support `vector-effect` style and scales stroke-width too

      result.style = `stroke-width: ${1 / Math.min(svgRect.width, svgRect.height)}px`;
    }

    let barWidth,
        command1 = 'M',
        command2 = 'L';

    for (let i = 0, x = 0, {
      length
    } = data; i < length; i++) {
      const barHeight = 1 - data[i][field] / topValue; // use either provided with or the calculated value

      barWidth = data[i].width || defaultWidth;
      coords.push(`${command1} ${x},${barHeight} ${command2} ${x += barWidth},${barHeight}`);
      command1 = command2 = '';
    } // coords.push('1,1');


    result.d = coords.join(' ');
    return result;
  }

  drawText() {
    const me = this,
          {
      data
    } = me,
          defaultWidth = 1 / data.length,
          y = '100%',
          unscaledSvgGroups = [];

    for (let index = 0, width, x = 0, {
      length
    } = data; index < length; index++, x += width) {
      width = data[index].width || defaultWidth;
      const barText = me.callback('getBarText', me, [data[index], index]);

      if (barText) {
        unscaledSvgGroups.push({
          ns,
          tag: 'text',
          className: 'b-bar-legend',
          html: me.callback('getBarText', me, [data[index], index]),
          x: `${(x + width / 2) * 100}%`,
          y,
          dataset: {
            index
          }
        });
      }
    }

    return unscaledSvgGroups;
  } //endregion
  // Injectable method


  getBarText(datum, index) {
    return '';
  } // Injectable method


  getBarTip(series, rectConfig, datum, index) {} // Injectable method


  getRectClass(series, rectConfig, datum, index) {
    return '';
  }

}
Histogram.initClass();
Histogram._$name = 'Histogram';

/***/ }),

/***/ "./lib/Core/widget/graph/Scale.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/graph/Scale.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Scale; });
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
var productName = 'taskboard';


/**
 * @module Core/widget/graph/Scale
 */

const ns = 'http://www.w3.org/2000/svg';
/**
 * Displays a scale with ticks and labels.
 * @extends Core/widget/Widget
 * @classtype scale
 */

class Scale extends _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  //region Config
  static get type() {
    return 'scale';
  }

  static get $name() {
    return 'Scale';
  }

  static get configurable() {
    return {
      scalePoints: null,
      // Padding after the max scale point.
      // Expressed as the share of the height.
      scaleMaxPadding: 0.1,

      /**
       * Configure as `true` to create a horizontal scale. Scales are vertical by default.
       * @config {Boolean}
       */
      horizontal: false,

      /**
       * Side to align the scale to. Defaults to `bottom` for {@link #config-horizontal} Scales
       * and `right` for vertical Scales.
       * @config {String}
       */
      align: {
        value: false,
        $config: {
          merge: 'replace'
        }
      },
      element: {
        children: [{
          ns,
          tag: 'svg',
          reference: 'svgElement',
          width: '100%',
          height: '100%',
          preserveAspectRatio: 'none',
          children: [{
            ns,
            tag: 'g',
            reference: 'scaledSvgGroup',
            children: [{
              ns,
              tag: 'path',
              reference: 'pathElement'
            }]
          }, {
            ns,
            tag: 'g',
            reference: 'unscaledSvgGroup'
          }]
        }]
      },
      monitorResize: true
    };
  } //endregion
  //region Init


  construct(config) {
    super.construct(config);
    this.scheduleRefresh = this.createOnFrame(this.refresh, [], this, true);
    this.refresh();
  }

  changeAlign(align) {
    if (!align) {
      align = this.horizontal ? 'bottom' : 'right';
    }

    return align;
  }

  updateAlign(align, oldAlign) {
    this.element.classList.remove(`b-align-${oldAlign}`);
    this.element.classList.add(`b-align-${align}`);
  }

  updateHorizontal(horizontal, oldHorizontal) {
    this.element.classList.remove(`b-scale-${oldHorizontal ? 'horizontal' : 'vertical'}`);
    this.element.classList.add(`b-scale-${horizontal ? 'horizontal' : 'vertical'}`);
  }

  onElementResize() {
    super.onElementResize(...arguments);
    this.scheduleRefresh();
  } // Must exist from the start because configuration setters call it.
  // Once configured, will be replaced with a function which schedules a refresh for the next animation frame.


  scheduleRefresh() {}

  refresh() {
    const me = this,
          {
      horizontal,
      width,
      height,
      align,
      scalePoints,
      scaleMaxPadding
    } = me,
          scaleMax = scalePoints[scalePoints.length - 1].value,
          path = [],
          labels = [];
    const posFactor = 1 / (scaleMax + scaleMaxPadding * scaleMax);
    me.scaledSvgGroup.setAttribute('transform', `scale(${horizontal ? width : 1} ${horizontal ? 1 : height})`);

    for (const point of scalePoints) {
      const isLabelStep = Boolean(point.text),
            pos = posFactor * point.value;

      if (isLabelStep) {
        const label = {
          ns,
          tag: 'text',
          className: 'b-scale-tick-label',
          html: point.text,
          dataset: {
            tick: point.value
          }
        };

        if (horizontal) {
          label.x = `${pos * 100}%`;
          label.y = align === 'top' ? '1.6em' : height - 12;
        } else {
          label.x = align === 'left' ? '12' : `${width - 12}`;
          label.y = `${(1 - pos) * 100}%`;
        }

        labels.push(label);
      }

      if (horizontal) {
        if (align === 'top') {
          path.push(`M${pos},0 L${pos},${isLabelStep ? 10 : 5}`);
        } else {
          path.push(`M${pos},${height} L${pos},${height - (isLabelStep ? 10 : 5)}`);
        }
      } else {
        if (align === 'left') {
          path.push(`M0,${1 - pos} L${isLabelStep ? 10 : 5},${1 - pos}`);
        } else {
          path.push(`M${width},${1 - pos} L${width - (isLabelStep ? 10 : 5)},${1 - pos}`);
        }
      }
    }

    me.pathElement.setAttribute('d', path.join(''));
    _helper_DomSync_js__WEBPACK_IMPORTED_MODULE_1__["default"].syncChildren({
      domConfig: {
        children: labels
      }
    }, me.unscaledSvgGroup);
  } //endregion


}
Scale.initClass();
Scale._$name = 'Scale';

/***/ }),

/***/ "./lib/Core/widget/layout/Box.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/layout/Box.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Box; });
/* harmony import */ var _Layout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Layout.js */ "./lib/Core/widget/layout/Layout.js");
var productName = 'taskboard';

/**
 * @module Core/widget/layout/Box
 */

const directionCls = ['b-hbox', 'b-vbox'],
      wrapMap = {
  false: 'nowrap',
  true: 'wrap',
  reverse: 'wrap-reverse'
};
/**
 * A layout that applies `display: flex` to the {@link Core.widget.Widget#property-contentElement contentElement} of
 * its container to layout child items. This defaults to a horizontal layout of items, also known as an `'hbox'`.
 * ```javascript
 *  layout : {
 *      type : 'box'   // or equivalently, 'hbox'
 *  }
 * ```
 * @extends Core/widget/layout/Layout
 */

class Box extends _Layout_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Box';
  }

  static get type() {
    return 'box';
  }

  static get alias() {
    return 'hbox';
  }

  static get configurable() {
    return {
      itemCls: 'b-box-item',

      /**
       * Sets the [align-items](https://developer.mozilla.org/en-US/docs/Web/CSS/align-items) style of the
       * {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}.
       * @config {String} align
       * @default 'stretch'
       */
      align: null,

      /**
       * Sets the [align-content](https://developer.mozilla.org/en-US/docs/Web/CSS/align-content) style of the
       * {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}.
       * @config {String} contentAlign
       * @default 'normal'
       */
      contentAlign: null,

      /**
       * Sets the [direction](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction) style of the
       * {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}.
       * This config is not set directly. Set {@link #config-horizontal}, {@link #config-vertical}, and/or
       * {@link #config-reverse} instead.
       * @config {String} direction
       * @private
       */
      direction: null,

      /**
       * Set this value to `false` to set the [flex-direction](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction)
       * style of the {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}
       * to `column`. Or alternatively, set {@link #config-vertical} to `true`.
       * @config {Boolean} horizontal
       * @default
       */
      horizontal: true,

      /**
       * Sets the [justify-content](https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content) style of the
       * {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}.
       * @config {String} justify
       * @default 'flex-start'
       */
      justify: null,

      /**
       * Set this value to `true` to add `'-reverse'` to the [flex-direction](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction)
       * style of the {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}.
       * This config combines with {@link #config-horizontal} or {@link #config-vertical} to set the `flex-direction`
       * style.
       * @config {Boolean} reverse
       * @default false
       */
      reverse: null,

      /**
       * Sets the [flex-wrap](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-wrap) style of the
       * {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}.
       *
       * The value of `true` is equivalent to `'wrap'`, `false` is equivalent to `'nowrap'`, and `'reverse'` is
       * equivalent to `'wrap-reverse'`.
       *
       * ```javascript
       *  layout : {
       *      type : 'box',
       *      wrap : false        // equivalent to 'nowrap'
       *      wrap : true         // equivalent to 'wrap'
       *      wrap : 'reverse'    // equivalent to 'wrap-reverse'
       *  }
       * ```
       * @config {String|Boolean} wrap
       * @default false
       */
      wrap: null
    };
  }
  /**
   * Set this value to `true` to set the [flex-direction](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction)
   * style of the {@link #property-owner owner's} {@link Core.widget.Widget#property-contentElement contentElement}
   * to `column`. Or alternatively, set {@link #config-horizontal} to `false`.
   * @config {Boolean} vertical
   * @default false
   */


  get vertical() {
    return this.horizontal === false;
  }

  set vertical(v) {
    return this.horizontal = !v;
  }

  updateAlign() {
    this.syncConfigStyle('align', 'alignItems');
  }

  updateContentAlign() {
    this.syncConfigStyle('contentAlign', 'alignContent');
  }

  updateDirection() {
    this.syncConfigStyle('direction', 'flexDirection');
  }

  updateHorizontal() {
    var _me$contentElement;

    const me = this,
          classList = (_me$contentElement = me.contentElement) === null || _me$contentElement === void 0 ? void 0 : _me$contentElement.classList,
          vertical = Number(me.vertical);

    if (classList) {
      classList.remove(directionCls[1 - vertical]);
      classList.add(directionCls[vertical]);
    } else {
      me.syncConfigLater('horizontal');
    }

    me.syncDirection();
  }

  updateJustify() {
    this.syncConfigStyle('justify', 'justifyContent');
  }

  updateReverse() {
    this.syncDirection();
  }

  updateWrap() {
    this.syncConfigStyle('wrap', 'flexWrap', wrapMap);
  }

  syncDirection() {
    const me = this,
          {
      reverse
    } = me;
    me.direction = reverse ? `${me.vertical ? 'column' : 'row'}${reverse ? '-reverse' : ''}` : null;
  }

} // Layouts must register themselves so that the static layout instantiation
// in Layout knows what to do with layout type names

Box.initClass();
Box._$name = 'Box';

/***/ }),

/***/ "./lib/Core/widget/layout/Card.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/layout/Card.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Card; });
/* harmony import */ var _Layout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Layout.js */ "./lib/Core/widget/layout/Layout.js");
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'taskboard';





/**
 * @module Core/widget/layout/Card
 */

const animationClasses = ['b-slide-out-left', 'b-slide-out-right', 'b-slide-in-left', 'b-slide-in-right'];
/**
 * A helper class for containers which must manage multiple child widgets, of which only one may be visible at once such
 * as a {@link Core.widget.TabPanel}. This class offers an active widget switching API, and optional slide-in,
 * slide-out animations from child to child.
 * @extends Core/widget/layout/Layout
 */

class Card extends _Layout_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Card';
  }

  static get type() {
    return 'card';
  }

  static get configurable() {
    return {
      containerCls: 'b-card-container',
      itemCls: 'b-card-item',
      hideChildHeaderCls: 'b-hide-child-headers',

      /**
       * Specifies whether to slide tabs in and out of visibility.
       * @config {Boolean}
       * @default
       */
      animateCardChange: true,

      /**
       * The active child item.
       * @config {Core.widget.Widget}
       */
      activeItem: null,

      /**
       * The active child index.
       * @config {Number}
       */
      activeIndex: null
    };
  }

  onChildAdd(item) {
    super.onChildAdd(item);
    const me = this,
          {
      activeItem,
      owner
    } = me,
          activeIndex = owner.activeIndex != null ? owner.activeIndex : me.activeIndex || 0,
          itemIndex = owner.items.indexOf(item),
          isActive = activeItem != null ? item === activeItem : itemIndex === activeIndex;
    item.on({
      beforeHide: 'onBeforeChildHide',
      beforeShow: 'onBeforeChildShow',
      thisObj: me
    }); // Ensure inactive child items start hidden, and the active one starts shown.
    // Sync our active indicators with reality ready for render.

    if (isActive) {
      item.show();
      me._activeIndex = itemIndex;
      me._activeItem = item;
    } else {
      item.$isDeactivating = true;
      item.hide();
      item.$isDeactivating = false;
    }
  }

  onChildRemove(item) {
    super.onChildRemove(item); // Active child has been removed without setting another child to be active.
    // Choose an immediate sibling to be the new active item

    if (this._activeItem === item) {
      this.activateSiblingOf(item);
    }

    item.un({
      beforeHide: 'onBeforeChildHide',
      beforeShow: 'onBeforeChildShow',
      thisObj: this
    });
  }
  /**
   * Detect external code showing a child. We veto that show and activate it through the API.
   * @internal
   */


  onBeforeChildShow({
    source: showingChild
  }) {
    // Some outside code is showing a child.
    // We must control this, so veto it and activate it in the standard way.
    if (!this.owner.isConfiguring && !showingChild.$isActivating) {
      this.activeItem = showingChild;
      return false;
    }
  }
  /**
   * Detect external code hiding a child. We veto that show and activate an immediate sibling through the API.
   * @internal
   */


  onBeforeChildHide({
    source: hidingChild
  }) {
    // Some outside code is hiding a child.
    // We must control this, so veto it and activate a sibling in the standard way.
    if (!this.owner.isConfiguring && !hidingChild.$isDeactivating) {
      this.activateSiblingOf(hidingChild);
      return false;
    }
  }

  activateSiblingOf(item) {
    const {
      owner
    } = this,
          items = owner.items.slice(),
          removeAt = items.indexOf(item);
    items.splice(removeAt, 1);
    this.activeIndex = Math.min(removeAt, items.length - 1);
  }
  /**
   * Get/set active item, using index or the Widget to activate
   * @param {Core.widget.Widget|Number} activeIndex
   * @param {Number} [prevActiveIndex]
   * @returns {Object} An object describing the card change containing the following properties:
   *
   *  - `prevActiveIndex` The previously active index.
   *  - `prevActiveItem ` The previously active child item.
   *  - `activeIndex    ` The newly active index.
   *  - `activeItem     ` The newly active child item.
   *  - `promise        ` A promise which completes when the slide-in animation finishes and the child item contains
   * focus if it is focusable.
   * @internal
   */


  setActiveItem(activeIndex, prevActiveIndex = this.activeIndex) {
    const me = this,
          {
      owner
    } = me,
          {
      items
    } = owner,
          widgetPassed = activeIndex instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"],
          prevActiveItem = items[prevActiveIndex],
          newActiveItem = owner.items[activeIndex = widgetPassed ? activeIndex = items.indexOf(activeIndex) : parseInt(activeIndex)],
          event = {
      prevActiveIndex,
      prevActiveItem
    }; // There's a child widget at that index to activate and we're not already activating it.

    if (newActiveItem && !newActiveItem.$isActivating && newActiveItem !== prevActiveItem) {
      var _owner$onBeginActiveI;

      const prevItemElement = prevActiveItem && prevActiveItem.element,
            newActiveElement = newActiveItem && newActiveItem.element; // A previous card change is in progress, abort it and clean the items it was operating upon

      if (me.animateDetacher) {
        const abortedEvent = me.animateDetacher.event;
        me.animateDetacher();
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].removeClasses(abortedEvent.prevActiveItem.element, animationClasses);
        _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].removeClasses(abortedEvent.activeItem.element, animationClasses);
        me.animateDetacher = null;
      }

      event.activeIndex = activeIndex;
      event.activeItem = newActiveItem;
      /**
       * The active item is about to be changed. Return `false` to prevent this.
       * @event beforeActiveItemChange
       * @preventable
       * @on-owner
       * @param {Number} activeIndex - The new active index.
       * @param {Core.widget.Widget} activeItem - The new active child widget.
       * @param {Number} prevActiveIndex - The previous active index.
       * @param {Core.widget.Widget} prevActiveItem - The previous active child widget.
       */

      if (owner.trigger('beforeActiveItemChange', event) === false) {
        return null;
      } // Since onBeforeActiveItemChange happens before event handlers run, the activation could be cancelled by
      // a listener, so we do a special hook once we are sure things are going down.
      // We pretend that we have already switched active index so that the owner
      // does not attempt to initiate the change.


      const reset = this._activeIndex !== event.activeIndex;

      if (reset) {
        this._activeIndex = event.activeIndex;
      }

      (_owner$onBeginActiveI = owner.onBeginActiveItemChange) === null || _owner$onBeginActiveI === void 0 ? void 0 : _owner$onBeginActiveI.call(owner, event);

      if (reset) {
        this._activeIndex = event.prevActiveIndex;
      }

      event.promise = new Promise((resolve, reject) => {
        // If there's something to slide out, slide it out, and slide the new item in
        if (prevItemElement && owner.isVisible && me.animateCardChange) {
          // During the card sliding trick, we don't want resize notifications.
          // The outgoing card should be as inert as if it were hidden.
          const wasMonitoringSize = prevActiveItem.monitorResize;
          prevActiveItem.monitorResize = false;
          me.contentElement.style.overflowX = 'hidden'; // The outgoing card must report its isVisible property as false from now on
          // even before we officially hide it.

          prevActiveItem._hidden = true; // Show the item so that it can be slid in.
          // Events will ensue, UIs can react to the show event.
          // The flag is so that our onBeforeChildShow listener can
          // tell if it's part of our orderly activate operation.

          newActiveItem.$isActivating = true;
          newActiveItem.show();
          newActiveItem.$isActivating = false;
          prevItemElement.classList.add(activeIndex > prevActiveIndex ? 'b-slide-out-left' : 'b-slide-out-right');
          newActiveElement.classList.add(activeIndex < prevActiveIndex ? 'b-slide-in-left' : 'b-slide-in-right');
          owner.isAnimating = true; // When the new widget is in place, clean up

          me.animateDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].onTransitionEnd({
            mode: 'animation',
            element: newActiveElement,
            // onTransitionEnd protects us from being called
            // after the thisObj is destroyed.
            thisObj: prevActiveItem,

            handler() {
              // Calendar got stuck with `b-animating` in some monkey scenarios, hoisted this to make
              // sure it was not left behind
              owner.isAnimating = false; // if animateDetacher variable has been cleared before this callback,
              // this means race-condition call happened. active item should be called again to
              // prevent unexpected layout behaviour

              if (!me.animateDetacher) {
                me.setActiveItem(activeIndex, prevActiveIndex);
                return;
              }

              me.animateDetacher = null; // Clean incoming widget's animation classes

              _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].removeClasses(newActiveElement, animationClasses); // If there's an outgoing item, clean its animation classes and hide it

              if (prevItemElement) {
                _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].removeClasses(prevItemElement, animationClasses); // The flag is so that our onBeforeChildHide listener can
                // tell if it's part of our orderly activate operation.

                prevActiveItem.$isDeactivating = true;
                prevActiveItem._hidden = false;
                prevActiveItem.hide();
                prevActiveItem.monitorResize = wasMonitoringSize;
                prevActiveItem.$isDeactivating = false;
              }

              me.contentElement.style.overflowX = '';
              me.onActiveItemChange(event, resolve);
            }

          });
          me.animateDetacher.reject = reject;
          me.animateDetacher.event = event;
        } // Nothing to slide out or we are not animating.
        else {
          // Show the new active items first, so that the hide listener doesn't
          // automatically set a new active item based on active item being hidden.
          // The flag is so that our onBeforeChildShow listener can
          // tell if it's part of our orderly activate operation.
          newActiveItem.$isActivating = true;
          newActiveItem.show(); // focus the new item before lost the component focus when hide the old one
          // (because losing focus closes owner if it is floatable)

          newActiveItem.focus();
          newActiveItem.$isActivating = false;

          if (prevActiveItem) {
            // The flag is so that our onBeforeChildHide listener can
            // tell if it's part of our orderly activate operation.
            prevActiveItem.$isDeactivating = true;
            prevActiveItem.hide();
            prevActiveItem.$isDeactivating = false;
          }

          me.onActiveItemChange(event, resolve);
        }
      });
    }

    return event;
  }

  onActiveItemChange(event, resolve) {
    const me = this;
    me._activeItem = event.activeItem;
    me._activeIndex = event.activeIndex;
    /**
     * The active item has changed.
     * @event activeItemChange
     * @on-owner
     * @param {Number} activeIndex - The new active index.
     * @param {Core.widget.Widget} activeItem - The new active child widget.
     * @param {Number} prevActiveIndex - The previous active index.
     * @param {Core.widget.Widget} prevActiveItem - The previous active child widget.
     */

    me.owner.trigger('activeItemChange', event); // Note that we have to call focus *after* the element is in its new position
    // because focus({preventScroll:true}) is not supported everywhere
    // and crazy browser scrolling behaviour on focus breaks the animation.

    event.activeItem.focus();
    resolve(event);
  }

  renderChildren() {
    const {
      owner
    } = this; // The usual; not working on IE11

    if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].isIE11) {
      this.animateCardChange = false;
    }

    owner.contentElement.classList[owner.suppressChildHeaders ? 'add' : 'remove'](this.hideChildHeaderCls);
    super.renderChildren();
  }

  changeActiveIndex(activeIndex) {
    const {
      owner
    } = this; // Sanitize it if possible

    return owner.isConfiguring && !owner._items ? activeIndex : Math.min(activeIndex, owner.items.length - 1);
  }

  updateActiveIndex(activeIndex, oldActiveIndex) {
    if (!this.owner.isConfiguring) {
      this.setActiveItem(activeIndex, oldActiveIndex);
    }
  }

  updateActiveItem(activeItem) {
    if (!this.owner.isConfiguring) {
      this.setActiveItem(activeItem, this.activeIndex);
    }
  }

} // Layouts must register themselves so that the static layout instantiation
// in Layout knows what to do with layout type names

Card.initClass();
Card._$name = 'Card';

/***/ }),

/***/ "./lib/Core/widget/layout/Fit.js":
/*!***************************************!*\
  !*** ./lib/Core/widget/layout/Fit.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Fit; });
/* harmony import */ var _Layout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Layout.js */ "./lib/Core/widget/layout/Layout.js");
var productName = 'taskboard';

/**
 * @module Core/widget/layout/Fit
 */

/**
 * A helper class for containers which must manage a single child widget which must fit the container's
 * {@link Core.widget.Widget#property-contentElement contentElement}.
 */

class Fit extends _Layout_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'Fit';
  }

  static get type() {
    return 'fit';
  }

  static get configurable() {
    return {
      containerCls: 'b-fit-container',
      itemCls: 'b-fit-item'
    };
  }

} // Layouts must register themselves so that the static layout instantiation
// in Layout knows what to do with layout type names

Fit.initClass();
Fit._$name = 'Fit';

/***/ }),

/***/ "./lib/Core/widget/layout/Layout.js":
/*!******************************************!*\
  !*** ./lib/Core/widget/layout/Layout.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Layout; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
var productName = 'taskboard';




/**
 * @module Core/widget/layout/Layout
 */

/**
  * A helper class used by {@link Core.widget.Container Container}s which renders child widgets to their
  * {@link Core.widget.Widget#property-contentElement}. It also adds the Container's
  * {@link Core.widget.Container#config-itemCls} class to child items.
  *
  * Subclasses may modify the way child widgets are rendered, or may offer APIs for manipulating the child widgets.
  *
  * The {@link Core.widget.layout.Card Card} layout class offers slide-in, slide-out animation of multiple
  * child widgets. {@link Core.widget.TabPanel} uses Card layout.
  */

class Layout extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_1__["default"], _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  static get type() {
    return 'default';
  }

  static get configurable() {
    return {
      /**
       * The owning Widget.
       * @member {Core.widget.Widget} owner
       * @readonly
       */

      /**
       * @config {Core.widget.Widget} owner
       * @private
       */
      owner: null,

      /**
       * The CSS class which should be added to the owning {@link Core.widget.Container}'s.
       * {@link Core.widget.Widget#property-contentElement}.
       * @config {String}
       */
      containerCls: 'b-auto-container',

      /**
       * The CSS class which should be added to the encapsulating element of child items.
       * @config {String}
       */
      itemCls: null
    };
  }

  static get factoryable() {
    // establish this class as the Factoryable base
    return {
      defaultType: 'default'
    };
  }

  get contentElement() {
    var _this$owner;

    return (_this$owner = this.owner) === null || _this$owner === void 0 ? void 0 : _this$owner.contentElement;
  }

  onChildAdd(item) {}

  onChildRemove(item) {}

  renderChildren() {
    const me = this,
          {
      owner,
      containerCls,
      itemCls
    } = me,
          {
      contentElement,
      items
    } = owner,
          ownerItemCls = owner.itemCls,
          itemCount = items === null || items === void 0 ? void 0 : items.length;
    contentElement.classList.add('b-content-element');

    if (containerCls) {
      contentElement.classList.add(containerCls);
    } // Need to check that container has widgets, for example TabPanel can have no tabs


    if (itemCount) {
      owner.textContent = false;

      for (let i = 0; i < itemCount; i++) {
        const item = items[i],
              {
          element
        } = item;
        element.dataset.itemIndex = i;

        if (itemCls) {
          element.classList.add(itemCls);
        }

        if (ownerItemCls) {
          element.classList.add(ownerItemCls);
        } // If instantiated by the app developer, external to Container#createWidget
        // a widget will have the b-outer class. Remove that if it' contained.


        element.classList.remove('b-outer'); // Only trigger paint if the owner is itself painted, otherwise
        // the outermost Container will cascade the paint signal down.

        item.render(contentElement, Boolean(owner.isPainted));
      }
    }

    me.syncPendingConfigs();
    me.syncChildCount();
  }

  removeChild(child) {
    const me = this,
          {
      element
    } = child,
          {
      owner,
      itemCls
    } = me,
          {
      contentElement
    } = owner,
          ownerItemCls = owner.itemCls; // Chrome has turned very fussy recently.
    // If the parent does not contain the child to be removed, it throws.

    if (contentElement.contains(element)) {
      element.remove();
    }

    delete element.dataset.itemIndex;

    if (itemCls) {
      element.classList.remove(itemCls);
    }

    if (ownerItemCls) {
      element.classList.remove(ownerItemCls);
    }

    me.fixChildIndices();
    me.syncChildCount();
  }

  appendChild(child) {
    const {
      element
    } = child,
          {
      owner,
      itemCls
    } = this,
          {
      contentElement
    } = owner,
          ownerItemCls = owner.itemCls;
    element.dataset.itemIndex = owner.indexOfChild(child);
    owner.textContent = false;

    if (itemCls) {
      element.classList.add(itemCls);
    }

    if (ownerItemCls) {
      element.classList.add(ownerItemCls);
    }

    child.render(contentElement, Boolean(owner.isPainted));
    this.syncChildCount();
  }

  insertChild(toAdd, childIndex) {
    const me = this,
          {
      element
    } = toAdd,
          {
      owner,
      itemCls
    } = me,
          {
      contentElement
    } = owner,
          nextSibling = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getChild(contentElement, `[data-item-index="${childIndex}"]`),
          ownerItemCls = owner.itemCls;
    owner.textContent = false;

    if (itemCls) {
      element.classList.add(itemCls);
    }

    if (ownerItemCls) {
      element.classList.add(ownerItemCls);
    }

    contentElement.insertBefore(element, nextSibling);
    toAdd.render(null, Boolean(owner.isPainted));
    me.fixChildIndices();
    me.syncChildCount();
  }

  fixChildIndices() {
    this.owner.items.forEach((child, index) => {
      child.element.dataset.itemIndex = index;
    });
  }

  syncChildCount() {
    var _owner$contentElement;

    const {
      owner
    } = this,
          {
      length
    } = owner.items; // Special CSS conditions may apply if there's only a single child.

    (_owner$contentElement = owner.contentElement) === null || _owner$contentElement === void 0 ? void 0 : _owner$contentElement.classList[length === 1 ? 'add' : 'remove']('b-single-child');
  }
  /**
   * Registers a layout `config` property that cannot be acted upon at this time but must wait for the `owner` to
   * fully render its elements (in particular the `contentElement`).
   * @param {String} config The name of the config to sync later.
   * @internal
   */


  syncConfigLater(config) {
    const pendingConfigs = this.pendingConfigs || (this.pendingConfigs = []);

    if (!pendingConfigs.includes(config)) {
      pendingConfigs.push(config);
    }
  }
  /**
   * Sets the specified `style` to the value of the config given its `name`.
   * @param {String} name The name of the config with the value to apply to the given `style`.
   * @param {String} style The style property to set on the `contentElement`.
   * @param {Object} [map] An option object to convert the config's value to the `style` value.
   * @internal
   */


  syncConfigStyle(name, style, map) {
    const me = this,
          {
      contentElement
    } = me,
          value = me[name];

    if (contentElement) {
      contentElement.style[style] = (map === null || map === void 0 ? void 0 : map[value]) || value;
    } else {
      me.syncConfigLater(name);
    }
  }

  syncPendingConfigs() {
    const me = this,
          {
      pendingConfigs
    } = me;
    let name;

    if (pendingConfigs) {
      me.pendingConfigs = null;

      while (name
      /* assignment */
      = pendingConfigs.pop()) {
        me[me.$meta.configs[name].updater](me[name]);
      }
    }
  }

}
Layout.initClass();
Layout._$name = 'Layout';

/***/ }),

/***/ "./lib/Core/widget/layout/VBox.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/layout/VBox.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VBox; });
/* harmony import */ var _Box_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Box.js */ "./lib/Core/widget/layout/Box.js");
var productName = 'taskboard';

/**
 * @module Core/widget/layout/VBox
 */

/**
 * A {@link Core.widget.layout.Box} layout that defaults to `horizontal : false`.
 *
 * The following:
 * ```javascript
 *  layout : {
 *      type : 'vbox'
 *  }
 * ```
 * Is equivalent to:
 * ```javascript
 *  layout : {
 *      type       : 'box',
 *      horizontal : false
 *  }
 * ```
 * @extends Core/widget/layout/Box
 */

class VBox extends _Box_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'VBox';
  }

  static get type() {
    return 'vbox';
  }

  static get configurable() {
    return {
      horizontal: false
    };
  }

} // Layouts must register themselves so that the static layout instantiation
// in Layout knows what to do with layout type names

VBox.initClass();
VBox._$name = 'VBox';

/***/ }),

/***/ "./lib/Core/widget/mixin/Badge.js":
/*!****************************************!*\
  !*** ./lib/Core/widget/mixin/Badge.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';

/**
 * @module Core/widget/mixin/Badge
 */

/**
 * Mixin that allows a widget to display a badge (mostly done as css)
 *
 * ```javascript
 * // show badge
 * button.badge = 5;
 *
 * // hide badge
 * button.badge = null;
 * ```
 *
 * @inlineexample Core/widget/Badge.js
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Badge extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Badge';
  }

  static get configurable() {
    return {
      /**
       * Get/sets and display badge, set to null or empty string to hide.
       * @member {String} badge
       * @category Misc
       */

      /**
       * Initial text to show in badge.
       * @config {String} badge
       * @category Misc
       */
      badge: null
    };
  }

  compose() {
    const {
      badge
    } = this;
    return {
      dataset: {
        badge
      },
      class: {
        'b-badge': badge != null && badge !== ''
      }
    };
  }

});

/***/ }),

/***/ "./lib/Core/widget/mixin/KeyMap.js":
/*!*****************************************!*\
  !*** ./lib/Core/widget/mixin/KeyMap.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class KeyMap extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    get widgetClass() {}

    performKeyMapAction(keyEvent, bryntumEvent) {
      const {
        keyMap
      } = this;

      if (keyMap) {
        const // Match a defined key combination, such as `Ctrl + Enter`
        keyCombination = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].keys(keyMap).find(keyString => {
          const keys = keyString.split('+'),
                requireShift = keys.includes('Shift'),
                requireCtrl = keys.includes('Ctrl'); // Last key should be the actual key, modifiers in any order before it

          return keys[keys.length - 1].toLowerCase() === keyEvent.key.toLowerCase() && (!keyEvent.ctrlKey && !requireCtrl || requireCtrl) && (!keyEvent.shiftKey && !requireShift || requireShift);
        }),
              // Get the action (fn to call) for that key combination
        action = keyMap[keyCombination];

        if (action) {
          if (typeof action === 'string') {
            this[action](bryntumEvent || keyEvent);
          } else {
            action.call(this);
          }

          return true;
        }
      }

      return false;
    }

  }, _defineProperty(_class, "$name", 'KeyMap'), _defineProperty(_class, "configurable", {
    keyMap: {
      value: null,
      $config: {
        merge: 'objects'
      }
    }
  }), _temp;
});

/***/ }),

/***/ "./lib/Core/widget/mixin/Responsive.js":
/*!*********************************************!*\
  !*** ./lib/Core/widget/mixin/Responsive.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module Core/widget/mixin/Responsive
 */

/**
 * A breakpoint definition. Used when defining breakpoints, see {@link #config-breakpoints}.
 *
 * ```javascript
 * {
 *     name    : 'Small',
 *     configs : {
 *         text  : null,
 *         color : 'b-blue'
 *     },
 *     callback() {
 *         console.log('Applied small');
 *     }
 * }
 * ```
 *
 * @typedef Breakpoint
 * @property {String} name Name of the breakpoint
 * @property {Object} [configs] An optional configuration object to apply to the widget when the breakpoint is activated
 * @property {Function} [callback] An optional callback, called when the breakpoint is activated
 */

/**
 * Mixin that simplifies adding responsive behaviour to widgets, by allowing them to define responsive
 * {@link #config-breakpoints} based on max-width/max-height.
 *
 * Each {@link #typedef-Breakpoint brekpoint} can contain configs that are applied to the widget and a callback called
 * when the breakpoint is activated.
 *
 * The mixin triggers an event when switching breakpoints, allowing the application to define its own behaviour. It also
 * uses the name of a breakpoint to apply a CSS class to Widget, for example `small` -> `b-breakpoint-small`.
 *
 * ```javascript
 * class ResponsiveButton extends Button.mixin(Responsive) {}
 *
 * const button = new ResponsiveButton({
 *     breakpoints : {
 *         width : {
 *             // When width drops to 50 or below, hide text and show icon
 *             50 : {
 *                 name    : 'small',
 *                 configs : { text : null, icon : 'b-fa b-fa-plus' },
 *                 callback() {
 *                     console.log('Applied small');
 *                 }
 *             },
 *             // When width is above 50, hide icon and show text
 *             '*' : {
 *                  name    : 'large',
 *                  configs : { text : 'Add', icon : null }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class Responsive extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    changeBreakpoints(breakpoints) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertObject(breakpoints, 'breakpoints'); // Normalize breakpoints

      if (breakpoints !== null && breakpoints !== void 0 && breakpoints.width) {
        Object.keys(breakpoints.width).forEach(key => {
          breakpoints.width[key].maxWidth = key;
        });
      }

      if (breakpoints !== null && breakpoints !== void 0 && breakpoints.height) {
        Object.keys(breakpoints.height).forEach(key => {
          breakpoints.height[key].maxHeight = key;
        });
      }

      return breakpoints;
    }

    updateBreakpoints(breakpoints) {
      if (breakpoints) {
        this.monitorResize = true;
      }
    } // Get a width/height breakpoint for the supplied dimension


    getBreakpoint(levels, dimension) {
      const // Breakpoints as reverse sorted array of numerical widths [NaN for *, 50, 100]
      ascendingLevels = Object.keys(levels).map(l => parseInt(l)).sort(),
            // Find first one larger than current width
      breakpoint = ascendingLevels.find(bp => dimension <= bp); // Return matched breakpoint or * if available and none matched

      return levels[breakpoint !== null && breakpoint !== void 0 ? breakpoint : levels['*'] && '*'];
    } // Apply a breakpoints configs, trigger event and call any callback


    activateBreakpoint(orientation, breakpoint) {
      const me = this,
            prevBreakpoint = me[`current${orientation}Breakpoint`];

      if (breakpoint !== prevBreakpoint) {
        var _breakpoint$callback, _me$recompose;

        me[`current${orientation}Breakpoint`] = breakpoint;
        me.setConfig(breakpoint.configs);
        prevBreakpoint && me.element.classList.remove(`b-breakpoint-${prevBreakpoint.name.toLowerCase()}`);
        me.element.classList.add(`b-breakpoint-${breakpoint.name.toLowerCase()}`);
        /**
         * Triggered when a new max-width based breakpoint is applied.
         * @event responsiveWidthChange
         * @param {Core.widget.Widget} source The widget
         * @param {Breakpoint} breakpoint The applied breakpoint
         * @param {Breakpoint} prevBreakpoint The previously applied breakpoint
         */

        /**
         * Triggered when a new max-height based breakpoint is applied.
         * @event responsiveHeightChange
         * @param {Core.widget.Widget} source The widget
         * @param {Breakpoint} breakpoint The applied breakpoint
         * @param {Breakpoint} prevBreakpoint The previously applied breakpoint
         */

        me.trigger(`responsive${orientation}Change`, {
          breakpoint,
          prevBreakpoint
        });
        (_breakpoint$callback = breakpoint.callback) === null || _breakpoint$callback === void 0 ? void 0 : _breakpoint$callback.call(breakpoint, {
          source: me,
          breakpoint,
          prevBreakpoint
        });
        (_me$recompose = me.recompose) === null || _me$recompose === void 0 ? void 0 : _me$recompose.call(me);
      }
    } // Called on resize to pick and apply a breakpoint, if size changed enough


    applyResponsiveness(width, height) {
      var _me$breakpoints;

      const me = this,
            {
        width: widths,
        height: heights
      } = (_me$breakpoints = me.breakpoints) !== null && _me$breakpoints !== void 0 ? _me$breakpoints : {};

      if (widths) {
        const breakpoint = me.getBreakpoint(widths, width);
        me.activateBreakpoint('Width', breakpoint);
      }

      if (heights) {
        const breakpoint = me.getBreakpoint(heights, height);
        me.activateBreakpoint('Height', breakpoint);
      }
    }

    onInternalResize(element, width, height, oldWidth, oldHeight) {
      super.onInternalResize(element, width, height, oldWidth, oldHeight);
      this.applyResponsiveness(width, height);
    }

  }, _defineProperty(_class, "$name", 'Responsive'), _defineProperty(_class, "configurable", {
    /**
     * Defines responsive breakpoints, based on max-width or max-height.
     *
     * When the widget is resized, the defined breakpoints are queried to find the closest larger or equal
     * breakpoint for both width and height. If the found breakpoint differs from the currently applied, it is
     * applied.
     *
     * Applying a breakpoint triggers an event that applications can catch to react to the change. It also
     * optionally applies a set of configs and calls a configured callback.
     *
     * ```javascript
     * breakpoints : {
     *     width : {
     *         50 : { name : 'small', configs : { text : 'Small', ... } }
     *         100 : { name : 'medium', configs : { text : 'Medium', ... } },
     *         '*' : { name : 'largem', configs : { text : 'Large', ... } }
     *     }
     * }
     * ```
     *
     * @config {Object}
     * @param {Object} width Max-width breakpoints, with keys as numerical widths (or '*' for larger widths than the
     * largest defined one) and the value as a {@link #typedef-Breakpoint breakpoint definition}
     * @param {Object} height Max-height breakpoints, with keys as numerical heights (or '*' for larger widths than
     * the largest defined one) and the value as a {@link #typedef-Breakpoint breakpoint definition}
     */
    breakpoints: null
  }), _temp;
});

/***/ }),

/***/ "./lib/Core/widget/mixin/Rotatable.js":
/*!********************************************!*\
  !*** ./lib/Core/widget/mixin/Rotatable.js ***!
  \********************************************/
/*! exports provided: canonicalDock, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canonicalDock", function() { return canonicalDock; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';

/**
 * @module Core/widget/mixin/Rotatable
 */
// we set rotate to 'LEFT' or 'RIGHT' when we auto rotate so we can tell it was (most likely) us:

const autoRotateRe = /^(?:undefined|null|LEFT|RIGHT)$/,
      inverted = {
  TOP: 'BOTTOM',
  RIGHT: 'LEFT',
  BOTTOM: 'TOP',
  LEFT: 'RIGHT'
};
const canonicalDock = dock => {
  const DOCK = dock === null || dock === void 0 ? void 0 : dock.toUpperCase();
  return [DOCK, DOCK === 'LEFT' || DOCK === 'RIGHT'];
};
/**
 * A mixin that provides support for rotating a widget's primary element.
 * @mixin
 * @internal
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Rotatable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Rotatable';
  }

  static get configurable() {
    return {
      /**
       * Set to `'left'` to rotate the button content 90 degrees counter-clockwise or `'right'` for clockwise.
       * @member {String} rotate
       */

      /**
       * Specify `'left'` to rotate the button content 90 degrees counter-clockwise or `'right'` for clockwise.
       * @config {String} rotate
       */
      rotate: null,
      invertRotate: null
    };
  }

  compose() {
    const {
      rotate
    } = this;
    return {
      class: {
        [`b-rotate-${(rotate || '').toLowerCase()}`]: rotate,
        'b-rotate-vertical': rotate
      }
    };
  }

  syncRotationToDock(dock) {
    if (autoRotateRe.test(String(this.rotate))) {
      const [DOCK, vertical] = canonicalDock(dock);
      this.rotate = vertical ? this.invertRotate ? inverted[DOCK] : DOCK : null;
    }
  }

  get widgetClass() {
    return null;
  }

});

/***/ }),

/***/ "./lib/Core/widget/mixin/Styleable.js":
/*!********************************************!*\
  !*** ./lib/Core/widget/mixin/Styleable.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';




/**
 * @module Core/widget/mixin/Styleable
 */

/**
 * Mixin for widgets that allows manipulating CSS variables. Works by setting style properties of the target widgets
 * element.
 *
 * As part of configuration:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *    css : {
 *        cardBorderTop    : '5px solid currentColor',
 *        columnBackground : '#ddd'
 *    }
 * });
 * ```
 *
 * And/or at runtime:
 *
 * ```javascript
 * taskBoard.css.cardBackground = '#333';
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class Styleable extends (Target || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    changeCssVarPrefix(prefix) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertString(prefix, 'prefix');

      if (prefix && !prefix.endsWith('-')) {
        prefix = prefix + '-';
      }

      return prefix || '';
    }

    changeCss(css) {
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertObject(css, 'css');
      const me = this;

      if (!_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].global.Proxy) {
        throw new Error('Proxy not supported');
      }

      const proxy = new Proxy({}, {
        get(target, property) {
          var _styles$getPropertyVa;

          // TODO: Worth keeping the live css object? Or just overhead if not often used?
          const styles = getComputedStyle(me.element || document.documentElement);
          return (_styles$getPropertyVa = styles.getPropertyValue(`--${me.cssVarPrefix}${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].hyphenate(property)}`)) === null || _styles$getPropertyVa === void 0 ? void 0 : _styles$getPropertyVa.trim();
        },

        set(target, property, value) {
          const element = me.element || document.documentElement;
          element.style.setProperty(`--${me.cssVarPrefix}${_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].hyphenate(property)}`, value);
          return true;
        }

      });

      if (css) {
        if (me._element) {
          _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(proxy, css);
        } else {
          me.$initialCSS = css;
        }
      }

      return proxy;
    } // Apply any initially supplied CSS when we have an element


    updateElement(element, ...args) {
      super.updateElement(element, ...args);

      if (this.$initialCSS) {
        _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(this.css, this.$initialCSS);
      }
    }

    get widgetClass() {}

  }, _defineProperty(_class, "$name", 'Styleable'), _defineProperty(_class, "configurable", {
    /**
     * CSS variable prefix, appended to the keys used in {@link #config-css}.
     *
     * For example:
     *
     * ```javascript
     * {
     *    cssVarPrefix : 'taskboard',
     *
     *    css : {
     *        cardBackground : '#333'
     *    }
     * }
     * ```
     *
     * Results in the css var `--taskboard-card-background` being set to `#333`.
     * @config {String}
     * @category CSS
     */
    cssVarPrefix: '',

    /**
     * Allows runtime manipulating of CSS variables.
     *
     * See {@link #config-css} for more information.
     *
     * ```javascript
     * taskBoard.css.columnBackground = '#ccc';
     *
     * // Will set "--taskboard-column-background : #ccc"
     * ```
     *
     * @member {Proxy} css
     * @category DOM
     */

    /**
     * Initial CSS variables to set.
     *
     * Each key will be applied as a CSS variable to the target elements style. Key names are hyphenated and
     * prefixed with {@link #config-cssVarPrefix} in the process. For example:
     *
     * ```javascript
     * {
     *    cssVarPrefix : 'taskboard',
     *
     *    css : {
     *        cardBackground : '#333'
     *    }
     * }
     * ```
     *
     * Results in the css var `--taskboard-card-background` being set to `#333`.
     *
     * @config {Object}
     * @category CSS
     */
    css: {}
  }), _temp;
});

/***/ }),

/***/ "./lib/Core/widget/mixin/Toolable.js":
/*!*******************************************!*\
  !*** ./lib/Core/widget/mixin/Toolable.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/DynamicObject.js */ "./lib/Core/util/DynamicObject.js");
/* harmony import */ var _Tool_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Tool.js */ "./lib/Core/widget/Tool.js");
var productName = 'taskboard';





/**
 * @module Core/widget/mixin/Toolable
 */

const emptyArray = [],
      emptyObject = {},
      toolConfigs = {
  align: 1,
  // hidden : 1,
  weight: 1
};
/**
 * A mixin that manages {@link #config-tools}.
 *
 * @mixin
 * @mixinbase Widget
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class Toolable extends (Target || _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'Toolable';
  }

  static get configurable() {
    return {
      /**
       * The {@link Core.widget.Tool tools} as specified by the {@link #config-tools} configuration. Each is a
       * {@link Core.widget.Tool} instance which may be hidden, shown and observed and styled just like any other
       * widget.
       * @member {Object} tools
       */

      /**
       * The {@link Core.widget.Tool tools} to add either before or after the `title` in the Panel header. Each
       * property name is the reference by which an instantiated tool may be retrieved from the live
       * `{@link #property-tools}` property.
       * @config {Object}
       */
      tools: {
        value: null,
        $config: {
          nullify: true
        }
      },

      /**
       * An object containing config defaults for corresponding {@link #config-tools} objects with a matching name.
       *
       * This object contains a key named `'*'` with default config properties to apply to all tools. This
       * object provides the default `type` (`'tool').
       * @config {Object} toolDefaults
       * @private
       */
      toolDefaults: {
        '*': {
          type: 'tool',
          align: 'end'
        }
      }
    };
  }

  byWeightSortFn(a, b) {
    return (a.weight || 0) - (b.weight || 0);
  }

  byWeightReverseSortFn(a, b) {
    return (b.weight || 0) - (a.weight || 0);
  }

  gatherTools({
    align,
    overlay,
    refs
  } = emptyObject) {
    const {
      collapsed,
      tools
    } = this;
    let ret = [],
        alignment,
        key,
        i,
        item,
        tool;

    for (key in tools) {
      var _ref, _tool$align$align, _tool, _tool$align, _tool2;

      tool = tools[key]; // Tools redefine "align" config to be a simple string, but other widgets promote align config to an align
      // spec object

      alignment = (_ref = (_tool$align$align = (_tool = tool) === null || _tool === void 0 ? void 0 : (_tool$align = _tool.align) === null || _tool$align === void 0 ? void 0 : _tool$align.align) !== null && _tool$align$align !== void 0 ? _tool$align$align : (_tool2 = tool) === null || _tool2 === void 0 ? void 0 : _tool2.align) !== null && _ref !== void 0 ? _ref : 'end';

      if (alignment === align && tool.isCollapsified(collapsed, overlay)) {
        ret.push(tool);
      }
    }

    ret.sort(this[align === 'end' ? 'byWeightReverseSortFn' : 'byWeightSortFn']);

    if (refs) {
      const asWidget = refs === 'widget',
            asRefs = {};

      for (i = 0; i < ret.length; ++i) {
        item = ret[i];
        asRefs[item.ref] = asWidget ? item : item.element;
      }

      ret = asRefs;
    }

    return ret;
  }

  getEndTools({
    overlay,
    refs
  } = emptyObject) {
    return this.gatherTools({
      align: 'end',
      overlay,
      refs
    });
  }

  getStartTools({
    overlay,
    refs
  } = emptyObject) {
    return this.gatherTools({
      align: 'start',
      overlay,
      refs
    });
  }

  get childItems() {
    return [...this.getStartTools(), ...(this._items || emptyArray), ...this.getEndTools()];
  }

  changeTools(tools, oldTools) {
    const me = this,
          manager = me.$tools || (me.$tools = new _util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
      configName: 'tools',
      factory: _Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"],
      inferType: false,
      // the name of a tool in the tools object is not its type
      owner: me,

      created(instance) {
        var _instance$syncRotatio, _me$header;

        instance.innerItem = false;
        (_instance$syncRotatio = instance.syncRotationToDock) === null || _instance$syncRotatio === void 0 ? void 0 : _instance$syncRotatio.call(instance, (_me$header = me.header) === null || _me$header === void 0 ? void 0 : _me$header.dock);
        _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].after(instance, 'onConfigChange', (ret, {
          name
        }) => {
          if (toolConfigs[name]) {
            me.onConfigChange({
              name: 'tools',
              value: manager.target
            });
          }
        });
        me.onChildAdd(instance);
      },

      setup(config, name) {
        config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge({}, me.toolDefaults['*'], me.toolDefaults[name], config);
        config.parent = me; // so parent can be accessed during construction

        config.ref = name;
        return config;
      }

    }));
    manager.update(tools);

    if (!oldTools) {
      // Only return the target once. Further calls are processed above so we need to return undefined to ensure
      // onConfigChange is called. By returning the same target on 2nd+ call, it passes the === test and won't
      // trigger onConfigChange.
      return manager.target;
    }
  }

});

/***/ }),

/***/ "./lib/Core/widget/panel/CollapseTool.js":
/*!***********************************************!*\
  !*** ./lib/Core/widget/panel/CollapseTool.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CollapseTool; });
/* harmony import */ var _Tool_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Tool.js */ "./lib/Core/widget/Tool.js");
var productName = 'taskboard';

/**
 * @module Core/widget/panel/CollapseTool
 */

const autoAlign = panel => panel.collapsed && panel.collapsible.direction === 'right' ? 'start' : 'end';
/**
 * This ensures the correct icon is used to represent the {@link Core.widget.Panel panel's}
 * {@link Core.widget.Panel#config-collapsed} state.
 * @extends Core/widget/Tool
 *
 * @classType collapsetool
 * @internal
 */


class CollapseTool extends _Tool_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'CollapseTool';
  } // Factoryable type name


  static get type() {
    return 'collapsetool';
  }

  static get configurable() {
    return {
      /**
       * Set to `false` to disable automatic adjustment of the {@link #config-align} config based on the state
       * of the panel's {@link Core.widget.Panel#config-collapsed} config and the
       * {@link Core.widget.panel.PanelCollapser#config-direction}.
       *
       * If this is set to a function, that function is called passing the owning `Panel` instance and its
       * return value is assigned to the {@link #config-align} config.
       * @config {Boolean|Function}
       * @default
       */
      autoAlign: true,
      collapsed: null,
      collapsify: false,
      // ...unaffected when the panel is collapsed
      direction: 'up'
    };
  }

  compose() {
    const {
      collapsed,
      direction
    } = this;
    return {
      class: {
        [`b-icon-collapse-${direction}`]: 1,
        'b-collapsed': collapsed
      }
    };
  }

  changeAutoAlign(v) {
    return v === true ? autoAlign : v;
  }

  syncAutoAlign() {
    const {
      autoAlign
    } = this;

    if (autoAlign) {
      this.align = autoAlign(this.owner);
    }
  }

  updateAutoAlign() {
    this.syncAutoAlign();
  }

  updateCollapsed() {
    this.syncAutoAlign();
  }

  updateDirection() {
    this.syncAutoAlign();
  }

} // Register this widget type with its Factory

CollapseTool.initClass();
CollapseTool._$name = 'CollapseTool';

/***/ }),

/***/ "./lib/Core/widget/panel/PanelCollapser.js":
/*!*************************************************!*\
  !*** ./lib/Core/widget/panel/PanelCollapser.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PanelCollapser; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _util_Animator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/Animator.js */ "./lib/Core/util/Animator.js");
/* harmony import */ var _mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _CollapseTool_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CollapseTool.js */ "./lib/Core/widget/panel/CollapseTool.js");
var productName = 'taskboard';








/**
 * @module Core/widget/panel/PanelCollapser
 */

const defaultedDirectionRe = /^(?:UP|DOWN|LEFT|RIGHT)$/,
      emptyArray = [],
      emptySplit = [emptyArray, emptyArray],
      revealerCls = 'b-panel-collapse-revealer',
      sideDockRe = /^(?:left|right)$/i,
      {
  round
} = Math,
      canonicalDirection = ['up', 'down', 'left', 'right'].reduce((o, v) => {
  o[v.toUpperCase()] = o[v] = v;
  return o;
}, {}),
      clipByDock = {
  top: ['top', 'bottom'],
  right: ['right', 'left'],
  bottom: ['bottom', 'top'],
  left: ['left', 'right']
},
      collapseDirectionByPlacement = {
  hl: 'LEFT',
  hr: 'RIGHT',
  vb: 'DOWN',
  vt: 'UP'
},
      crossAxis = {
  h: 'w',
  w: 'h'
},
      dockByDirection = {
  up: 'top',
  right: 'right',
  down: 'bottom',
  left: 'left'
},
      dockIsHorz = {
  top: false,
  right: true,
  bottom: false,
  left: true
},
      directionByDock = {
  top: 'UP',
  right: 'RIGHT',
  bottom: 'DOWN',
  left: 'LEFT'
};
let idSeed = 0;
/**
 * Instances of this class are used to implement the {@link Core.widget.Panel#config-collapsible} config.
 *
 * For example, the following creates an instance of this class:
 *
 * ```javascript
 *      {
 *          type        : 'panel',
 *          collapsible : true
 *      }
 * ```
 * In this mode, a panel will collapse inline, within its container.
 * @classtype inline
 */

class PanelCollapser extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  static get $name() {
    return 'PanelCollapser';
  } // Factoryable type name


  static get type() {
    return 'inline';
  }

  static get configurable() {
    return {
      /**
       * An animation config object.
       * @config {Object} animation
       * @property {Number} [animation.duration=200] The duration of the animation (in milliseconds).
       */
      animation: {
        duration: 200
      },

      /**
       * Tracks whether or not the panel is collapsed.
       * @config {Boolean}
       * @private
       */
      collapsed: {
        value: null,
        $config: null,
        default: false
      },

      /**
       * Specifies the direction of panel collapse. The default value for this config is determined dynamically
       * based on the {@link Core.widget.Panel#config-header header's} `dock` property and the containing layout's
       * flex direction and, therefore, often does not need to be explicitly specified.
       *
       * This config can be any of the following:
       * - `'up'`
       * - `'down'`
       * - `'left'`
       * - `'right'`
       *
       * @config {String}
       */
      direction: null,

      /**
       * The tooltip to use for the collapse tool when the panel is expanded.
       * @config {String}
       */
      collapseTooltip: 'L{Collapse}',

      /**
       * The tooltip to use for the expand tool when the panel is collapsed.
       * @config {String}
       */
      expandTooltip: 'L{Expand}',
      panel: {
        value: null,
        $config: 'nullify'
      },

      /**
       * To support the panel's collapsed size, a minimum width and height may be assigned to the panel's header,
       * based on this config and the panel's positioning style.
       *
       * When a panel is collapsed it may need to retain the pre-collapse dimension perpendicular to the collapse
       * {@link #config-direction}. For example, the height of a panel that collapses to the left. The dimension
       * parallel to the collapse (the width in this example) may also need to be supported using the pre-collapse
       * size of the panel's header.
       *
       * When this config is set to `true`, or by default when the owning panel is `position: absolute`, both
       * axes are given a minimum size based on the panel's pre-collapse size. When this config is `false`, no
       * minimum sizes will be assigned.
       *
       * This config can also be a string containing the single letters 'w' and/or 'h' indicating which axis/axes
       * of the panel header should be assigned a minimum size. That is, 'w' to assign only a minimum width, 'h'
       * for only a minimum height, or 'wh' to assign both.
       *
       * @config {String|Boolean}
       * @internal
       */
      supportAxis: null,

      /**
       * The collapse/expand tool. The `type` of this instance should not be changed but the tool instance can be
       * configured in other ways via this config property.
       * @config {Object|Core.widget.Tool}
       */
      tool: {
        type: 'collapsetool',

        handler(ev) {
          var _this$collapsible;

          // NOTE: As a tool, our this pointer is the Panel so we use it to access the current collapser
          (_this$collapsible = this.collapsible) === null || _this$collapsible === void 0 ? void 0 : _this$collapsible.onCollapseClick(ev);
        }

      }
    };
  }

  static get factoryable() {
    return {
      defaultType: 'inline'
    };
  }

  get collapsing() {
    return this.collapsingExpanding === 'collapsing';
  }

  get collapsingExpanding() {
    var _this$currentOperatio;

    const state = (_this$currentOperatio = this.currentOperation) === null || _this$currentOperatio === void 0 ? void 0 : _this$currentOperatio.collapsing;
    return state == null ? null : state ? 'collapsing' : 'expanding';
  }

  get currentDock() {
    var _this$panel$header$do, _this$panel, _this$panel$header, _this$panel$header$do2;

    return (_this$panel$header$do = (_this$panel = this.panel) === null || _this$panel === void 0 ? void 0 : (_this$panel$header = _this$panel.header) === null || _this$panel$header === void 0 ? void 0 : (_this$panel$header$do2 = _this$panel$header.dock) === null || _this$panel$header$do2 === void 0 ? void 0 : _this$panel$header$do2.toLowerCase()) !== null && _this$panel$header$do !== void 0 ? _this$panel$header$do : 'top';
  }

  get expanding() {
    return this.collapsingExpanding === 'expanding';
  }

  get collapseTool() {
    var _this$panel2, _this$panel2$tools;

    return (_this$panel2 = this.panel) === null || _this$panel2 === void 0 ? void 0 : (_this$panel2$tools = _this$panel2.tools) === null || _this$panel2$tools === void 0 ? void 0 : _this$panel2$tools.collapse;
  }

  get collapseDim() {
    return sideDockRe.test(this.collapseDir) ? 'width' : 'height';
  }

  getCollapseDir(canonical) {
    let {
      direction,
      panel
    } = this;

    if (!direction || defaultedDirectionRe.test(direction)) {
      const placement = panel === null || panel === void 0 ? void 0 : panel.placement;

      if (placement) {
        direction = collapseDirectionByPlacement[placement];
      } else {
        var _panel$header;

        direction = directionByDock[(panel === null || panel === void 0 ? void 0 : (_panel$header = panel.header) === null || _panel$header === void 0 ? void 0 : _panel$header.dock) || 'top'];
      } // direction in this case will be uppercase so that we can tell later that it was a default value vs a
      // user-defined one

    }

    return canonical ? canonicalDirection[direction] : direction;
  }

  get collapseDir() {
    return this.getCollapseDir(true);
  }

  get collapseDock() {
    const {
      panel
    } = this,
          headerDock = panel.hasHeader && panel.expandedHeaderDock,
          dock = dockByDirection[this.collapseDir];
    return headerDock && dockIsHorz[dock] === dockIsHorz[headerDock] ? headerDock : dock;
  }

  get toolsConfig() {
    const {
      direction,
      tool
    } = this;
    return tool && {
      collapse: _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({
        direction: direction.toLowerCase()
      }, tool)
    };
  }

  beforeCollapse(operation) {// TODO
  }

  changeTool(tool) {
    const me = this,
          {
      panel
    } = me;

    if (me.isConfiguring || me.isDestroying || !panel || panel.isDestroying) {
      return tool;
    }

    panel.tools = {
      collapse: tool
    };
  }

  collapse(collapsed) {
    var _collapsed, _currentOperation, _currentOperation$ani, _currentOperation2, _currentOperation2$an;

    const me = this,
          {
      panel
    } = me,
          operation = {
      id: ++idSeed,
      completed: false,
      panel
    };
    let {
      currentOperation
    } = me;
    collapsed = (_collapsed = collapsed) !== null && _collapsed !== void 0 ? _collapsed : true;

    if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isObject(collapsed)) {
      operation.collapsed = true;
      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign(operation, collapsed);
      collapsed = operation.collapsed;
      delete operation.collapsed;
    }

    operation.collapsing = collapsed;
    operation.previous = (_currentOperation = currentOperation) !== null && _currentOperation !== void 0 ? _currentOperation : null;

    if (collapsed !== me.collapsed) {
      // We aren't in the desired state (yet)
      if (currentOperation) {
        if (currentOperation.collapsing !== collapsed) {
          // we are not heading to the desired state, so revert it:
          operation.animation = currentOperation.animation.revert({
            finalize() {
              var _me$collapseFinalize;

              (_me$collapseFinalize = me.collapseFinalize) === null || _me$collapseFinalize === void 0 ? void 0 : _me$collapseFinalize.call(me, operation, true); // ?. in case we are destroyed
            }

          });
          operation.collapsing = collapsed;
          currentOperation = operation;
        }
      } else {
        // No currentOperation, so this is the first request to change state.
        // don't mutate our parameter or config object
        operation.animation = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].clone(('animation' in operation ? operation : me).animation);

        if (me.beforeCollapse(operation) !== false) {
          if (operation.animation) {
            operation.animation.finalize = complete => {
              var _me$collapseFinalize2;

              return (_me$collapseFinalize2 = me.collapseFinalize) === null || _me$collapseFinalize2 === void 0 ? void 0 : _me$collapseFinalize2.call(me, operation, complete);
            };
          }

          panel.changingCollapse = true;
          me[collapsed ? 'collapseBegin' : 'expandBegin'](operation);

          if (operation.animation) {
            currentOperation = operation;
          } else {
            operation.completed = true;
            me[collapsed ? 'collapseEnd' : 'expandEnd'](operation);
          }

          panel.changingCollapse = false;

          if (!operation.animation) {
            me.onComplete(collapsed ? 'collapse' : 'expand');
          }
        }
      }
    } else if (currentOperation && currentOperation.collapsing !== collapsed) {
      // We are still in the desired state but we are animating to the now undesired state...
      me[collapsed ? 'expandRevert' : 'collapseRevert'](operation); // revert the animation and clear it when done

      operation.animation = currentOperation.animation.revert({
        finalize() {
          var _me$collapseFinalize3;

          (_me$collapseFinalize3 = me.collapseFinalize) === null || _me$collapseFinalize3 === void 0 ? void 0 : _me$collapseFinalize3.call(me, operation, false); // ?. in case we are destroyed
        }

      });
      currentOperation = operation;
    } // else if (currentOperation) we are already reverting


    me.currentOperation = currentOperation;
    return (_currentOperation$ani = (_currentOperation2 = currentOperation) === null || _currentOperation2 === void 0 ? void 0 : (_currentOperation2$an = _currentOperation2.animation) === null || _currentOperation2$an === void 0 ? void 0 : _currentOperation2$an.done()) !== null && _currentOperation$ani !== void 0 ? _currentOperation$ani : Promise.resolve(collapsed === me.collapsed);
  }

  collapseFinalize(operation, complete) {
    const me = this,
          {
      currentOperation,
      panel
    } = me,
          action = panel.collapsed ? 'expand' : 'collapse';

    if (currentOperation === operation) {
      me.currentOperation = null;
      operation.completed = complete;
      panel.changingCollapse = true;
      me[action + 'End'](operation);
      panel.changingCollapse = false;
      complete && me.onComplete(action);
    }
  }

  applyHeaderDock(collapsed, flush = true) {
    const me = this,
          {
      currentDock,
      panel
    } = me,
          dock = collapsed ? me.collapseDock : panel.expandedHeaderDock;

    if (dock !== currentDock && panel.hasHeader) {
      panel.header = {
        dock
      };
      flush && panel.recompose.flush();
    }
  }

  composeHeader(header) {
    header.class[revealerCls] = 1;
    return header;
  }

  composeTitle(title) {
    title.class[revealerCls] = 1;
    return title;
  }

  collapseBegin(operation) {
    const me = this,
          {
      animation
    } = operation,
          {
      collapseDim,
      collapseTool,
      panel
    } = me,
          {
      element
    } = panel,
          collapseToolClasses = collapseTool === null || collapseTool === void 0 ? void 0 : collapseTool.element.classList;
    me.configuredWidth = panel._lastWidth;
    me.configuredHeight = panel._lastHeight;
    me.applyHeaderDock(true); // Lock the bodyWrap to its current size while we animate the height of the outer element and clip it. We
    // also leave the bodyWrap locked to its expanded size to avoid crushing the content while collapsed since
    // that could cause virtual rendering widgets to have 0 height to work with and explode or at least waste
    // time adjusting back and forth.

    const panelRect = panel.rectangle(),
          bodyWrapRect = me.lockInnerSize().moveTo(0, 0),
          // we must lockInnerSize even if !animation
    bodyWrapClipRect = bodyWrapRect.clone(),
          clipDir = clipByDock[me.collapseDock];

    if (animation) {
      var _panel$headerElement;

      bodyWrapClipRect[clipDir[0]] = bodyWrapClipRect[clipDir[1]];
      element.classList.add('b-collapsing'); // Flip to collapsed while skipping the animation (via b-collapsing)

      collapseToolClasses === null || collapseToolClasses === void 0 ? void 0 : collapseToolClasses.add('b-collapsed', 'b-collapsing');
      const headerRect = (_panel$headerElement = panel.headerElement) === null || _panel$headerElement === void 0 ? void 0 : _panel$headerElement.getBoundingClientRect();

      if (collapseToolClasses) {
        collapseToolClasses.remove('b-collapsed'); // put the tool back to pre-collapse state

        panel.rectangle(); // force a layout to allow us to enable transitions

        collapseToolClasses.remove('b-collapsing'); // enable transitions

        collapseToolClasses.add('b-collapsed'); // start the tool's transition
      }

      animation.element = element;
      animation.retain = true;
      animation[collapseDim] = {
        from: round(panelRect[collapseDim]),
        to: round((headerRect === null || headerRect === void 0 ? void 0 : headerRect[collapseDim]) || 0)
      }; // While we animate the panel, we also need to clip the bodyWrap or it would be exposed on cases where
      // overflow=visible (like a tooltip w/anchor element)... doubtful we'd collapse such a panel but perhaps
      // there are  (or will be) other reasons to set overflow=visible on the panel.

      animation.items = [{
        element: panel.bodyWrapElement,
        retain: false,
        clip: {
          from: `rect(${bodyWrapRect})`,
          to: `rect(${bodyWrapClipRect})`
        }
      }];
      operation.animation = _util_Animator_js__WEBPACK_IMPORTED_MODULE_1__["default"].run(animation);
    }
  }

  collapseEnd(operation) {
    const me = this;
    me.panel.element.classList.remove('b-collapsing');

    if (operation.completed) {
      me.collapsed = true;
    } else {
      me.applyHeaderDock(false);
      me.restoreConfiguredSize();
      me.lockInnerSize(false);
    }
  }

  collapseRevert(operation) {
    var _this$collapseTool;

    (_this$collapseTool = this.collapseTool) === null || _this$collapseTool === void 0 ? void 0 : _this$collapseTool.element.classList.remove('b-collapsed');
  }

  expandBegin(operation) {
    const me = this,
          {
      animation
    } = operation,
          {
      collapseDim,
      collapseTool,
      panel
    } = me,
          {
      element
    } = panel,
          fromRect = panel.rectangle();
    element.classList.remove('b-collapsed', 'b-collapsing'); // This style is retained by the collapse animation and must be cleared to get a right measurement of the
    // expanded panel

    panel.element.style[collapseDim] = '';
    me.restoreConfiguredSize();
    me.lockInnerSize(false); // unlock the bodyWrap size

    const toRect = panel.rectangle(),
          // Lock the bodyWrap to its current size while we animate the height of the outer element and unclip it:
    bodyWrapRect = me.lockInnerSize().moveTo(0, 0),
          bodyWrapClipRect = bodyWrapRect.clone(),
          clipDir = clipByDock[me.collapseDock];
    collapseTool === null || collapseTool === void 0 ? void 0 : collapseTool.element.classList.remove('b-collapsed');

    if (animation) {
      bodyWrapClipRect[clipDir[0]] = bodyWrapClipRect[clipDir[1]];
      element.classList.add('b-collapsed', 'b-expanding');
      animation.element = element;
      animation[collapseDim] = {
        from: round(fromRect[collapseDim]),
        to: round(toRect[collapseDim])
      };
      animation.items = [{
        element: panel.bodyWrapElement,
        retain: false,
        clip: {
          from: `rect(${bodyWrapClipRect})`,
          to: `rect(${bodyWrapRect})`
        }
      }];
      operation.animation = _util_Animator_js__WEBPACK_IMPORTED_MODULE_1__["default"].run(animation);
    }
  }

  expandEnd(operation) {
    const me = this;
    me.panel.element.classList.remove('b-expanding');

    if (operation.completed) {
      me.collapsed = false;
      me.applyHeaderDock(false);
      me.restoreConfiguredSize();
      me.lockInnerSize(false);
    }
  }

  expandRevert(operation) {
    var _this$collapseTool2;

    (_this$collapseTool2 = this.collapseTool) === null || _this$collapseTool2 === void 0 ? void 0 : _this$collapseTool2.element.classList.add('b-collapsed');
  }

  get innerElement() {
    return this.panel.bodyWrapElement;
  }

  get innerSizeElement() {
    return this.innerElement;
  }

  get supportAxis() {
    let {
      _supportAxis
    } = this;
    const fullSupport = _supportAxis === true;

    if (fullSupport || _supportAxis == null) {
      _supportAxis = this.collapseDim[0]; // 'w' or 'h'

      if (fullSupport || _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getStyleValue(this.panel.element, 'position') === 'absolute') {
        _supportAxis += crossAxis[_supportAxis];
      }
    }

    return _supportAxis || '';
  }

  lockInnerSize(lock = true) {
    const me = this,
          {
      innerElement,
      panel
    } = me,
          supportAxis = lock ? me.supportAxis : '',
          panelEl = panel.element,
          headerEl = panel.headerElement,
          headerRect = lock && headerEl && _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(headerEl, panelEl),
          innerRect = lock && _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(me.innerSizeElement, panelEl),
          innerStyle = innerElement.style; // We have to prop up the cross-axis of the panel header in cases where the panel is not receiving a size from
    // its container (an auto layout). Otherwise, the header may shrink in width (when docked top) once the bodyWrap
    // flips to position:absolute... it will not longer be providing a natural size to prop up the panel so we
    // shift that responsibility to the header element while we are collapsed.

    if (headerEl) {
      headerEl.style.minWidth = supportAxis.includes('w') ? `${headerRect.width}px` : '';
      headerEl.style.minHeight = supportAxis.includes('h') ? `${headerRect.height}px` : '';
    } // We must set w/h on the inner element before we flip it to position:absolute to avoid layout changes on items
    // in the panel (like grids)


    innerStyle.width = lock ? `${innerRect.width}px` : '';
    innerStyle.height = lock ? `${innerRect.height}px` : '';
    innerElement.classList[lock ? 'add' : 'remove']('b-panel-collapse-size-locker');
    return innerRect;
  }

  onCollapseClick(e) {
    let collapsed = this.collapsing ? false : this.expanding ? true : !this.collapsed;

    if (e.altKey) {
      collapsed = {
        animation: null,
        collapsed
      };
    }

    this.collapse(collapsed);
  }

  onComplete(action) {
    var _this$panel3;

    (_this$panel3 = this.panel) === null || _this$panel3 === void 0 ? void 0 : _this$panel3.trigger(action);
  }

  onHeaderClick({
    event
  }) {
    if (event.button === 0 && this.panel.collapsed && event.target.classList.contains(revealerCls)) {
      this.onRevealerClick();
    }
  }

  onPanelConfigChange({
    name,
    value
  }) {
    const me = this,
          {
      panel
    } = me;

    if (name === 'collapsed') {
      if (!(value && panel.isConfiguring)) {
        me.collapsed = value;
      }
    } else if (name === 'header' && !panel.changingCollapse) {
      me.syncDirection();
    }
  }

  onPanelPaint() {
    this.syncDirection();
  }

  onRevealerClick() {
    this.panel.expand();
  }

  restoreConfiguredSize(which) {
    var _which;

    const {
      configuredHeight,
      configuredWidth,
      panel
    } = this;
    which = (_which = which) !== null && _which !== void 0 ? _which : 'wh';

    if (configuredWidth != null && which.includes('w')) {
      panel.width = configuredWidth;
    }

    if (configuredHeight != null && which.includes('h')) {
      panel.height = configuredHeight;
    }
  }

  splitHeaderItems() {
    return emptySplit;
  }

  syncDirection() {
    const me = this,
          {
      direction
    } = me;

    if (!direction || defaultedDirectionRe.test(direction)) {
      // getCollapseDir() returns uppercase values when they are being defaulted, so we can tell if the value
      // is from the user (which must be lowercase)
      me.direction = me.getCollapseDir();
    }
  }

  updateCollapsed(collapsed) {
    const {
      collapseTool,
      panel
    } = this;

    if (panel) {
      panel.collapsed = collapsed;
      panel.element.classList[collapsed ? 'add' : 'remove']('b-collapsed');
    }

    if (collapseTool) {
      collapseTool.collapsed = collapsed;
    }
  }

  updateDirection(direction) {
    const {
      collapseTool,
      panel
    } = this;

    if (collapseTool) {
      collapseTool.direction = canonicalDirection[direction];
    }

    if (panel !== null && panel !== void 0 && panel.rendered) {
      panel.recompose();
    }
  }

  updatePanel(panel) {
    var _me$panelChangeDetach, _me$panelListeners;

    const me = this;
    me.syncDirection();
    (_me$panelChangeDetach = me.panelChangeDetacher) === null || _me$panelChangeDetach === void 0 ? void 0 : _me$panelChangeDetach.call(me);
    me.panelChangeDetacher = panel && _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].after(panel, 'onConfigChange', 'onPanelConfigChange', me, {
      return: false
    });
    (_me$panelListeners = me.panelListeners) === null || _me$panelListeners === void 0 ? void 0 : _me$panelListeners.call(me);
    me.panelListeners = panel && !panel.isPainted ? panel.on({
      once: true,

      paint() {
        if (panel.initialConfig.collapsed) {
          panel.collapsed = true;
        }
      }

    }) : null;
  }

  wrapCollapser(key, body) {
    return [key, body];
  }

}
PanelCollapser.maps = {
  clipByDock,
  dockByDirection,
  dockIsHorz
}; // Register this widget type with its Factory

PanelCollapser.initClass();
PanelCollapser._$name = 'PanelCollapser';

/***/ }),

/***/ "./lib/Core/widget/panel/PanelCollapserOverlay.js":
/*!********************************************************!*\
  !*** ./lib/Core/widget/panel/PanelCollapserOverlay.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PanelCollapserOverlay; });
/* harmony import */ var _util_Animator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/Animator.js */ "./lib/Core/util/Animator.js");
/* harmony import */ var _PanelCollapser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PanelCollapser.js */ "./lib/Core/widget/panel/PanelCollapser.js");
/* harmony import */ var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';






/**
 * @module Core/widget/panel/PanelCollapserOverlay
 */

const {
  dockIsHorz
} = _PanelCollapser_js__WEBPACK_IMPORTED_MODULE_1__["default"].maps,
      clipByDir = {
  up: ['top', 'bottom'],
  right: ['right', 'left'],
  down: ['bottom', 'top'],
  left: ['left', 'right']
},
      collapseExposeEdge = {
  top: 0,
  down: 0,
  left: 1,
  bottom: 2,
  up: 2,
  right: 3
},
      emptyObject = {},
      translateByDir = {
  up: {
    from: `translate(0,0)`,
    to: 'translate(0,-100%)'
  },
  down: {
    from: `translate(0,0)`,
    to: 'translate(0,100%)'
  },
  left: {
    from: `translate(0,0)`,
    to: 'translate(-100%,0)'
  },
  right: {
    from: `translate(0,0)`,
    to: 'translate(100%,0)'
  }
};
/**
 * A panel collapse implementation that adds the ability to reveal the collapsed panel as a floating overlay.
 * @extends Core/widget/panel/PanelCollapser
 * @classtype overlay
 */

class PanelCollapserOverlay extends _PanelCollapser_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  static get $name() {
    return 'PanelCollapserOverlay';
  }

  static get type() {
    return 'overlay';
  }

  static get configurable() {
    return {
      /**
       * The number of milliseconds to wait once the mouse leaves a {@link Core.widget.Panel#config-revealed}
       * panel before returning to an unrevealed state. Clicking outside the revealed panel will immediately
       * return the panel to its collapsed state.
       *
       * This may be disabled by configuring {@link #config-autoClose} as `null`.
       *
       * If this value is negative, the panel will not automatically recollapse due to the mouse leaving, however,
       * clicks outside the panel will still recollapse it.
       *
       * If this value is `null`, the panel will not automatically recollapse for either outside clicks or if
       * the mouse leaves the panel.
       * @config {Number}
       * @default
       */
      autoCloseDelay: 1000,

      /**
       * By default, clicking outside the revealed overlay hides the revealed overlay.
       *
       * If the revealed overlay was shown using the {@link #property-recollapseTool}
       * then moving the mouse outside of the revealed overlay hides the revealed overlay.
       *
       * Configure this as `false` to disable auto hiding, making overlayed
       * state permanent, and changeable using the {@link #function-toggleReveal} method.
       * @config {Boolean}
       * @default
       */
      autoClose: true,
      revealing: {
        value: null,
        $config: null,
        default: false
      },

      /**
       * The reveal/hide tool which slides the collapsed panel over the top of the UI.
       * @member {Core.widget.Tool} recollapseTool
       */

      /**
       * The reveal/hide tool which slides the collapsed panel over the top of the UI.
       * 
       * The `type` of this instance should not be changed but the tool instance can be
       * configured in other ways via this config property.
       * @config {Object|Core.widget.Tool}
       */
      recollapseTool: {
        type: 'collapsetool',
        cls: 'b-recollapse',
        collapsify: 'overlay',

        handler() {
          var _this$collapsible;

          // NOTE: As a tool, our this pointer is the Panel so we use it to access the current collapser
          (_this$collapsible = this.collapsible) === null || _this$collapsible === void 0 ? void 0 : _this$collapsible.toggleReveal();
        }

      }
    };
  }

  static get delayable() {
    return {
      doAutoClose: 0
    };
  }

  doAutoClose() {
    this.toggleReveal(false);
  }

  updateAutoCloseDelay(delay) {
    const {
      doAutoClose
    } = this;

    if (!(doAutoClose.suspended = delay == null || delay < 0)) {
      doAutoClose.delay = delay;
      doAutoClose.immediate = !delay;
    }
  }

  changeRecollapseTool(tool) {
    const me = this,
          {
      panel
    } = me;

    if (me.isConfiguring || me.isDestroying || !panel || panel.isDestroying) {
      return tool;
    }

    panel.tools = {
      recollapse: tool
    };
  }

  beforeCollapse(operation) {
    if (super.beforeCollapse(operation) === false) {
      return false;
    }

    if (this.panel.revealed) {
      operation.animation = null;
    }
  }

  applyHeaderDock(collapsed, flush = true) {
    var _this$panel;

    (_this$panel = this.panel) === null || _this$panel === void 0 ? void 0 : _this$panel.recompose();
    super.applyHeaderDock(collapsed, flush);
  }

  collapseBegin(operation) {
    const me = this,
          {
      collapseDir,
      innerElement
    } = me,
          {
      animation
    } = operation,
          {
      collapseTool,
      panel
    } = me;
    me.configuredWidth = panel._lastWidth;
    me.configuredHeight = panel._lastHeight;
    me.applyHeaderDock(true);
    const innerElementRect = me.lockInnerSize();
    collapseTool === null || collapseTool === void 0 ? void 0 : collapseTool.element.classList.add('b-collapsed');

    if (animation) {
      panel.element.classList.add('b-collapsing');
      innerElementRect.moveTo(0, 0);
      const innerElementClipRect = innerElementRect.clone(),
            clipDir = clipByDir[collapseDir];
      innerElementClipRect[clipDir[0]] = innerElementClipRect[clipDir[1]];
      animation.element = me.innerElement;
      animation.transform = translateByDir[collapseDir];
      animation.items = [{
        element: innerElement,
        clip: {
          from: `rect(${innerElementRect})`,
          to: `rect(${innerElementClipRect})`
        }
      }];
      operation.animation = _util_Animator_js__WEBPACK_IMPORTED_MODULE_0__["default"].run(animation);
    }
  }

  onComplete(action) {
    var _me$autoCloseLeaveDet, _me$autoCloseClickDet;

    super.onComplete(action);
    const me = this,
          {
      panel
    } = me,
          {
      element
    } = panel;
    me.autoCloseLeaveDetacher = (_me$autoCloseLeaveDet = me.autoCloseLeaveDetacher) === null || _me$autoCloseLeaveDet === void 0 ? void 0 : _me$autoCloseLeaveDet.call(me);
    me.autoCloseClickDetacher = (_me$autoCloseClickDet = me.autoCloseClickDetacher) === null || _me$autoCloseClickDet === void 0 ? void 0 : _me$autoCloseClickDet.call(me); // The act of hiding the revealed panel ("unrevealing") causes a mouseleave event (once the panel slides out
    // from under the cursor) and that starts the autoClose timer. If the user then reveals the panel again within
    // the 1sec delay (by default), the autoClose timer will still fire and unreveal the panel.

    me.doAutoClose.cancel();

    if (action === 'reveal' && me.autoClose) {
      // Only listen for mouseleave to close if we contain focus.
      // If we do not, then we have been revealed using the API from some other
      // part of the UI, so mouseleave closing would not be appropriate.
      if (panel.containsFocus) {
        me.autoCloseLeaveDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
          element,
          mouseenter: ev => {
            me.doAutoClose.cancel();
          },
          mouseleave: ev => {
            me.doAutoClose();
          }
        });
      }

      me.autoCloseClickDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].on({
        element: document.body,
        mousedown: ev => {
          if (ev.target !== element && !element.contains(ev.target) && me.autoCloseDelay != null) {
            var _panel$focusInEvent;

            // Detect the UI element which invoked the reveal.
            // If the panel contains focus, use the "from" element.
            // If not, then the focus is still on the invoking element.
            const invokingElement = panel.containsFocus ? (_panel$focusInEvent = panel.focusInEvent) === null || _panel$focusInEvent === void 0 ? void 0 : _panel$focusInEvent.relatedTarget : _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].getActiveElement(element);

            if (!invokingElement.contains(ev.target)) {
              me.doAutoClose.now();
            }
          }
        }
      });
    }
  }

  expandBegin(operation) {
    const me = this,
          {
      animation
    } = operation,
          {
      collapseDir,
      collapseTool,
      innerElement,
      panel
    } = me,
          {
      element
    } = panel;
    element.classList.remove('b-collapsed', 'b-collapsing');
    me.restoreConfiguredSize();
    me.lockInnerSize(false); // unlock the bodyWrap size

    const toRect = me.lockInnerSize().moveTo(0, 0),
          clipRect = toRect.clone(),
          clipDir = clipByDir[collapseDir];
    collapseTool === null || collapseTool === void 0 ? void 0 : collapseTool.element.classList.remove('b-collapsed');

    if (animation) {
      element.classList.add('b-collapsed', 'b-expanding');
      clipRect[clipDir[0]] = clipRect[clipDir[1]];
      animation.element = innerElement;
      animation.transform = {
        from: translateByDir[collapseDir].to,
        to: translateByDir[collapseDir].from
      };
      animation.clip = {
        from: `rect(${clipRect})`,
        to: `rect(${toRect})`
      };
      operation.animation = _util_Animator_js__WEBPACK_IMPORTED_MODULE_0__["default"].run(animation);
    }
  }

  expandEnd(operation) {
    super.expandEnd(operation);
    const {
      panel
    } = this;

    if (operation.completed) {
      panel.revealed = false;
    }

    panel.element.classList.remove('b-expanding');
  }

  expandRevert(operation) {
    super.expandRevert(operation);
    this.panel.element.classList.add('b-expanding');
  }

  get innerElement() {
    return this.panel.overlayElement;
  }

  get innerSizeElement() {
    return this.panel.element;
  }

  get toolsConfig() {
    const me = this,
          {
      direction
    } = me,
          config = super.toolsConfig,
          tool = me.recollapseTool;

    if (tool) {
      return _objectSpread(_objectSpread({}, config), {}, {
        recollapse: tool && _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assign({
          direction: direction.toLowerCase()
        }, tool)
      });
    }

    return config;
  }

  lockInnerSize(lock = true) {
    const me = this,
          {
      panel
    } = me,
          panelRect = lock && panel.rectangle(),
          // must read this before we call super
    inset = lock ? [0, 0, 0, 0] : '',
          // now we can call super:
    innerRect = super.lockInnerSize(lock); // The panel overlay is visible because we switch to "overflow:visible" in collapsed state. By doing this,
    // however, the header animation undesirably escapes as well. Fortunately, we can use the clip-path to hide
    // this by only allowing the desired side to escape while all other sides remain clipped. Even more fortunate
    // for us is that clip-path is expressed as an inset from the normal rectangle of the element (so we don't
    // need to adjust it if the collapsed panel is resized), and further, unlike CSS path style, clip-path works
    // for all elements not only absolutely positioned ones.

    if (lock) {
      // TODO see if there's a way to read the box-shadow style to pick up the right value (10 is the default)
      inset[collapseExposeEdge[me.collapseDir]] = `-${panelRect[me.collapseDim] + 10}px`;
    }

    panel.element.style.clipPath = lock ? `inset(${inset.join(' ')}` : '';
    return innerRect;
  }

  onOverlayTransitionDone(ev) {
    const me = this,
          {
      panel
    } = me;

    if (ev.srcElement === panel.overlayElement && me.revealing) {
      me.revealing = false;
      me.onComplete(panel.revealed ? 'reveal' : 'unreveal');
    }
  }

  onRevealerClick() {
    this.toggleReveal();
  }

  splitHeaderItems({
    as,
    dock
  } = emptyObject) {
    var _this$panel2;

    return (_this$panel2 = this.panel) === null || _this$panel2 === void 0 ? void 0 : _this$panel2.splitHeaderItems({
      as,
      dock,
      overlay: true
    });
  }
  /**
   * Toggles the revealed state of the Panel to match the passed boolean flag.
   * @param {Boolean} state `true` to reveal the overlay, `false` to hide it.
   */


  toggleReveal(state) {
    const {
      panel
    } = this;

    if (panel.collapsed) {
      if (state == null) {
        state = !panel.revealed;
      }

      if (panel.revealed !== state) {
        this.revealing = true;
        panel.revealed = !panel.revealed;
      }
    }
  }

  updateRevealing(value) {
    const me = this,
          horzDirRe = /left|right/i,
          {
      panel
    } = me,
          dim = horzDirRe.test(me.collapseDir) ? 'height' : 'width';

    if (panel) {
      me.innerElement.style[dim] = panel.rectangle()[dim] + 'px';
      panel.element.classList[value ? 'add' : 'remove']('b-panel-overlay-revealing');
    }
  }

  wrapCollapser(key, body) {
    var _panel$tools;

    const me = this,
          {
      collapseDir,
      panel
    } = me,
          {
      expandedHeaderDock,
      header,
      uiClassList
    } = panel,
          recollapse = (_panel$tools = panel.tools) === null || _panel$tools === void 0 ? void 0 : _panel$tools.recollapse,
          [before, after] = me.splitHeaderItems({
      dock: me.collapseDock,
      as: 'element'
    }),
          horz = dockIsHorz[expandedHeaderDock],
          title = panel.hasHeader ? panel.title || (header === null || header === void 0 ? void 0 : header.title) || '\xA0' : null;

    if (recollapse) {
      recollapse.direction = collapseDir;
    }

    return ['overlayElement', {
      class: _objectSpread(_objectSpread({}, uiClassList), {}, {
        [`b-panel-overlay-header-${expandedHeaderDock}`]: 1,
        [`b-panel-overlay-${collapseDir}`]: 1,
        [`b-${horz ? 'h' : 'v'}box`]: 1,
        'b-panel-overlay': 1,
        'b-box-center': 1
      }),
      listeners: {
        transitionend: ev => me.onOverlayTransitionDone(ev)
      },
      children: {
        overlayHeaderElement: title && {
          tag: 'header',
          class: _objectSpread(_objectSpread({}, uiClassList), {}, {
            [`b-dock-${expandedHeaderDock}`]: 1,
            'b-panel-header': 1,
            'b-panel-overlay-header': 1
          }),
          children: [...before, {
            reference: 'overlayTitleElement',
            html: title,
            class: _objectSpread(_objectSpread({}, uiClassList), {}, {
              [`b-align-${(header === null || header === void 0 ? void 0 : header.titleAlign) || 'start'}`]: 1,
              'b-header-title': 1
            })
          }, ...after]
        },
        [key]: body
      }
    }];
  }

} // Register this widget type with its Factory

PanelCollapserOverlay.initClass();
PanelCollapserOverlay._$name = 'PanelCollapserOverlay';

/***/ }),

/***/ "./lib/Core/widget/trial/TrialButton.js":
/*!**********************************************!*\
  !*** ./lib/Core/widget/trial/TrialButton.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TrialButton; });
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _widget_Button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _TrialPanel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TrialPanel.js */ "./lib/Core/widget/trial/TrialPanel.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



/**
 * @module Core/widget/trial/TrialButton
 */

/**
 * Download trial button.
 *
 * @classType trialbutton
 * @extends Core/widget/Button
 * @internal
 */

class TrialButton extends _widget_Button_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  static get configurable() {
    return {
      /**
       * Product identifier.
       * @config {String}
       */
      productId: null,

      /**
       * Store emails using aweber mail list posting.
       * @config {Boolean}
       */
      storeEmail: false,
      hidden: !_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBryntumOnline(['online', 'test']),
      cls: 'b-raised b-green',
      ref: 'downloadTrial',
      icon: 'b-fa-download',
      text: 'L{downloadTrial}',
      menuIcon: null
    };
  }

  construct(...args) {
    super.construct(...args);
    this.menu = new _TrialPanel_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
      autoShow: false,
      productId: this.productId,
      storeEmail: this.storeEmail
    });
  }

}

_defineProperty(TrialButton, "$name", 'TrialButton');

_defineProperty(TrialButton, "type", 'trialbutton');

TrialButton.initClass();
TrialButton._$name = 'TrialButton';

/***/ }),

/***/ "./lib/Core/widget/trial/TrialPanel.js":
/*!*********************************************!*\
  !*** ./lib/Core/widget/trial/TrialPanel.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TrialPanel; });
/* harmony import */ var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Popup_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _Toast_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Toast.js */ "./lib/Core/widget/Toast.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';





/**
 * @module Core/widget/trial/TrialPanel
 */

/**
 * Download trial panel.
 *
 * @classType trialpanel
 * @extends Core/widget/Popup
 * @internal
 */

class TrialPanel extends _Popup_js__WEBPACK_IMPORTED_MODULE_3__["default"] {
  static get configurable() {
    return {
      productId: null,
      storeEmail: false,
      width: 400,
      anchor: true,
      title: 'L{title}',
      align: {
        align: 't-b',
        constrainPadding: 20
      },
      defaults: {
        labelWidth: 100
      },
      items: [{
        type: 'textfield',
        localeClass: this,
        label: 'L{name} <sup>*</sup>',
        name: 'name',
        ref: 'nameField',
        required: true
      }, {
        type: 'textfield',
        inputType: 'email',
        localeClass: this,
        label: 'L{email} <sup>*</sup>',
        name: 'email',
        ref: 'emailField',
        required: true
      }, {
        type: 'textfield',
        localeClass: this,
        label: 'L{company} <sup>*</sup>',
        name: 'company',
        ref: 'companyField',
        required: true
      }, {
        type: 'combo',
        localeClass: this,
        label: 'L{product}',
        editable: false,
        ref: 'productField',
        name: 'productId',
        style: 'margin-bottom : 0',
        items: [{
          id: 'calendar',
          // no-sanity
          downloadId: 'calendar-vanilla',
          text: 'Bryntum Calendar'
        }, {
          id: 'gantt',
          // no-sanity
          downloadId: 'gantt-vanilla',
          text: 'Bryntum Gantt'
        }, {
          id: 'grid',
          // no-sanity
          downloadId: 'grid',
          text: 'Bryntum Grid'
        }, {
          id: 'scheduler',
          // no-sanity
          downloadId: 'scheduler-vanilla',
          text: 'Bryntum Scheduler'
        }, {
          id: 'schedulerpro',
          // no-sanity
          downloadId: 'schedulerpro',
          text: 'Bryntum Scheduler Pro'
        }, {
          id: 'taskboard',
          // no-sanity
          downloadId: 'taskboard-vanilla',
          text: 'Bryntum TaskBoard'
        }],
        required: true
      }, {
        type: 'textfield',
        inputType: 'hidden',
        ref: 'listNameField',
        name: 'listname'
      }, {
        type: 'textfield',
        inputType: 'hidden',
        ref: 'trackingField',
        name: 'custom meta_adtracking'
      }, {
        type: 'textfield',
        inputType: 'hidden',
        ref: 'redirectField',
        name: 'redirect'
      }, {
        type: 'textfield',
        inputType: 'hidden',
        name: 'meta_message',
        value: '1'
      }, {
        type: 'textfield',
        inputType: 'hidden',
        name: 'meta_required',
        value: 'name,email,custom company'
      }, {
        type: 'textfield',
        inputType: 'hidden',
        name: 'meta_forward_vars',
        value: '0'
      }],
      bbar: [{
        localeClass: this,
        text: 'L{cancel}',
        width: '12em',
        onClick: 'up.onCancelClick'
      }, {
        localeClass: this,
        text: 'L{submit}',
        width: '12em',
        cls: 'b-blue b-raised',
        onClick: 'up.onSubmitClick'
      }]
    };
  }

  get bodyConfig() {
    return this.storeEmail ? Object.assign(super.bodyConfig, {
      tag: 'form',
      method: 'post',
      target: 'aweberFrame',
      action: 'https://www.aweber.com/scripts/addlead.pl'
    }) : super.bodyConfig;
  }

  changeProductId(value) {
    this.widgetMap.productField.value = value;
  }

  async onSubmitClick() {
    const me = this;

    if (!me.isValid) {
      return;
    }

    if (me.storeEmail) {
      me.addToMailList();
    }

    await me.triggerDownload();
  }

  addToMailList() {
    const {
      trackingField,
      redirectField,
      listNameField,
      companyField
    } = this.widgetMap,
          {
      productId
    } = this.values;
    trackingField.value = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getCookie('aw');
    redirectField.value = window.location.href;
    companyField.input.name = 'custom company';

    switch (productId) {
      case 'gantt':
        listNameField.value = 'awlist5314739';
        break;

      case 'scheduler':
      case 'schedulerpro':
        listNameField.value = 'awlist5074881';
        break;

      case 'grid':
        listNameField.value = 'awlist5074883';
        break;

      case 'calendar':
        listNameField.value = 'awlist4475287';
        break;
    }

    this.bodyElement.submit();
  }

  async onCancelClick() {
    await this.hide();
  }

  async triggerDownload() {
    const me = this,
          {
      name,
      email,
      company
    } = me.values;
    let productId = me.values.productId;

    switch (productId) {
      case 'gantt':
      case 'scheduler':
      case 'taskboard':
      case 'calendar':
        productId = `${productId}-vanilla`;
        break;
    }

    const a = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement({
      parent: document.body,
      tag: 'a',
      download: `bryntum-${productId}-trial.zip`,
      href: `/do_download.php?product_id=${productId}&thename=${name}&email=${email}&company=${company}`
    });
    a.click();
    a.parentElement.removeChild(a);
    await me.hide();
    _Toast_js__WEBPACK_IMPORTED_MODULE_4__["default"].show({
      html: me.L('L{downloadStarting}'),
      timeout: 15000
    });

    if (!me.gaScript && !_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isTestEnv) {
      me.gaScript = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement({
        parent: document.head,
        tag: 'script',
        src: 'https://www.googletagmanager.com/gtag/js?id=UA-11046863-1'
      });
      me.gaScript.addEventListener('load', me.trackDownload.bind(me));
    }
  } // Google Analytics


  trackDownload() {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
      window.dataLayer.push(arguments);
    } // gtag('consent', 'default', {
    //     ad_storage        : 'denied',
    //     analytics_storage : 'denied'
    // });


    gtag('event', 'conversion', {
      send_to: 'AW-1042491458/eweSCPibpAEQwtCM8QM',
      value: 1.0,
      currency: 'USD'
    });
    gtag('event', 'Trial download started', {
      value: 1.0,
      currency: 'USD'
    });
  }

} // Register this widget type with its Factory

_defineProperty(TrialPanel, "$name", 'TrialPanel');

_defineProperty(TrialPanel, "type", 'trialpanel');

TrialPanel.initClass();
TrialPanel._$name = 'TrialPanel';

/***/ }),

/***/ "./lib/Core/widget/util/AvatarRendering.js":
/*!*************************************************!*\
  !*** ./lib/Core/widget/util/AvatarRendering.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AvatarRendering; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
var productName = 'taskboard';





/**
 * @module Core/widget/util/AvatarRendering
 */

/**
 * Internal utility class providing rendering of avatars / resource initials.
 *
 * @internal
 * @extends Core/Base
 */

class AvatarRendering extends _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'AvatarRendering';
  }

  static get configurable() {
    return {
      /**
       * Element used to listen for load errors on. Normally the owning widgets own element.
       * @config {HTMLElement}
       */
      element: null,

      /**
       * Prefix prepended to a supplied color to create a CSS class applied when showing initials.
       * @config {String}
       * @default
       */
      colorPrefix: 'b-sch-',

      /**
       * A tooltip config object to enable using a custom tooltip for the avatars. Listen for `beforeShow` and set
       * your html there.
       * @config {Object}
       */
      tooltip: null
    };
  }

  doDestroy() {
    var _this$tooltip;

    (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 ? void 0 : _this$tooltip.destroy();
    super.doDestroy();
  }

  updateElement(element) {
    // Error listener
    _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
      element,
      delegate: '.b-resource-image',
      error: 'onImageErrorEvent',
      thisObj: this,
      capture: true
    });
  }

  changeTooltip(config) {
    return _widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_4__["default"].new({
      forElement: this.element,
      forSelector: '.b-resource-avatar',
      cls: 'b-resource-avatar-tooltip'
    }, config);
  }

  get failedUrls() {
    if (!this._failedUrls) {
      this._failedUrls = new Set();
    }

    return this._failedUrls;
  }
  /**
   * Returns a DOM config object containing a resource avatar, icon or resource initials. Display priority in that
   * order.
   * @param {Object} options Avatar options
   * @param {String} options.initials Resource initials
   * @param {String} options.color Background color for initials
   * @param {String} options.iconCls Icon cls
   * @param {String} options.imageUrl Image url
   * @param {String} options.defaultImageUrl Default image url, fallback if image fails to load or there is none
   * specified. Leave out to show initials instead.
   * @param {Object} [options.dataset] Dataset to apply to the resulting element
   * @param {String} [options.alt] Image description
   * @returns {Object}
   * @internal
   */


  getResourceAvatar({
    initials,
    color,
    iconCls,
    imageUrl,
    defaultImageUrl,
    dataset = {},
    alt
  }) {
    return this.getImageConfig(initials, color, imageUrl, defaultImageUrl, dataset, alt) || this.getIconConfig(iconCls, dataset) || this.getResourceInitialsConfig(initials, color, dataset);
  }

  getImageConfig(initials, color, imageUrl, defaultImageUrl, dataset, alt) {
    // Fall back to defaultImageUrl if imageUrl is known to fail
    imageUrl = this.failedUrls.has(imageUrl) ? defaultImageUrl : imageUrl || defaultImageUrl;

    if (imageUrl) {
      return {
        tag: 'img',
        draggable: 'false',
        class: {
          'b-resource-avatar': 1,
          'b-resource-image': 1
        },
        // Prevent iOS from zooming and showing image full screen
        ontouchstart: 'return false',
        alt,
        elementData: {
          defaultImageUrl,
          imageUrl,
          initials,
          color,
          dataset
        },
        src: imageUrl,
        dataset
      };
    }
  }

  getIconConfig(iconCls, dataset) {
    if (iconCls) {
      return iconCls && {
        tag: 'i',
        class: {
          'b-resource-avatar': 1,
          'b-resource-icon': 1,
          [iconCls]: 1
        },
        dataset
      };
    }
  }

  getResourceInitialsConfig(initials, color, dataset) {
    const // eventColor = #FF5555, apply as background-color
    namedColor = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isNamedColor(color) && color,
          // eventColor = red, add b-sch-red cls
    hexColor = !namedColor && color;
    return {
      tag: 'div',
      class: {
        'b-resource-avatar': 1,
        'b-resource-initials': 1,
        [`${this.colorPrefix}${namedColor}`]: namedColor
      },
      style: {
        backgroundColor: hexColor || null
      },
      children: [_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].encodeHtml(initials)],
      dataset
    };
  }

  onImageErrorEvent({
    target
  }) {
    if (!target.matches('.b-resource-avatar')) {
      return;
    }

    const {
      defaultImageUrl,
      initials,
      color,
      imageUrl,
      dataset
    } = target.elementData;

    if (defaultImageUrl && !target.src.endsWith(defaultImageUrl.replace(/^[./]*/gm, ''))) {
      target.src = defaultImageUrl;
    } else {
      const initialsEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].createElement(this.getResourceInitialsConfig(initials, color, dataset));
      target.parentElement.replaceChild(initialsEl, target);
    } // Remember failed urls, to avoid trying to load them again next time


    this.failedUrls.add(imageUrl);
  }

}
AvatarRendering._$name = 'AvatarRendering';

/***/ }),

/***/ "./lib/Engine/calendar/CalendarCache.js":
/*!**********************************************!*\
  !*** ./lib/Engine/calendar/CalendarCache.js ***!
  \**********************************************/
/*! exports provided: CalendarIteratorResult, CalendarCache */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarIteratorResult", function() { return CalendarIteratorResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarCache", function() { return CalendarCache; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/Constants.js */ "./lib/Engine/util/Constants.js");
/* harmony import */ var _util_Types_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/Types.js */ "./lib/Engine/util/Types.js");
var productName = 'taskboard';




/**
 * The enum type for result of [[forEachAvailabilityInterval]].
 */

var CalendarIteratorResult;

(function (CalendarIteratorResult) {
  /**
   * Indicates the iteration has completed by iterating the whole given timespan or has reached the MAX_DATE or MIN_DATE.
   */
  CalendarIteratorResult[CalendarIteratorResult["FullRangeIterated"] = 0] = "FullRangeIterated";
  /**
   * Indicates the iteration has been stopped by returning `false` from the iterator.
   */

  CalendarIteratorResult[CalendarIteratorResult["StoppedByIterator"] = 1] = "StoppedByIterator";
  /**
   * Indicates the iteration has exceeded the `maxRange` option
   */

  CalendarIteratorResult[CalendarIteratorResult["MaxCacheExtendCyclesReached"] = 2] = "MaxCacheExtendCyclesReached";
  /**
   * Indicates the iteration has exceeded the `maxRange` option
   */

  CalendarIteratorResult[CalendarIteratorResult["MaxRangeReached"] = 3] = "MaxRangeReached";
})(CalendarIteratorResult || (CalendarIteratorResult = {}));
/**
 * Calendar cache.
 */


class CalendarCache {
  constructor(config) {
    this.cacheFilledStartDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MAX_DATE"];
    this.cacheFilledEndDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MIN_DATE"];
    this.intervalsCachingChunkDuration = 30;
    this.intervalsCachingChunkUnit = _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_1__["TimeUnit"].Day;
    this.maxCacheExtendCycles = 100; // max range for the iteration - 5 years

    this.maxRange = 5 * 12 * 30 * 24 * 60 * 60 * 1000;
    config && Object.assign(this, config);
  }

  includeWrappingRangeFrom(cache, startDate, endDate) {
    cache.ensureCacheFilledForInterval(startDate, endDate);
    this.intervalCache.includeWrappingRange(cache.intervalCache, startDate, endDate);
  } // after this method, we guarantee, that for every point between `startDate` and `endDate` (_inclusive_)
  // we'll have a final representation of the cache, that is, we'll be able to get an interval to which this point belongs
  // _both_ for forward and backward directions


  ensureCacheFilledForInterval(startDate, endDate) {
    const cacheFilledStartDateN = this.cacheFilledStartDate.getTime();
    const cacheFilledEndDateN = this.cacheFilledEndDate.getTime();

    if (cacheFilledStartDateN !== _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MAX_DATE"].getTime()) {
      const startDateN = startDate.getTime();
      const endDateN = endDate.getTime();
      if (cacheFilledStartDateN <= startDateN && endDateN <= cacheFilledEndDateN) return; // asked to cache an interval which is to the left from the cached area - extend to the right

      if (endDateN <= cacheFilledStartDateN) {
        endDate = new Date(cacheFilledStartDateN - 1);
      } else if (startDateN >= cacheFilledEndDateN) {
        startDate = new Date(cacheFilledEndDateN + 1);
      } else if (cacheFilledStartDateN <= startDateN && startDateN <= cacheFilledEndDateN) {
        startDate = new Date(cacheFilledEndDateN + 1);
      } else if (cacheFilledStartDateN <= endDateN && endDateN <= cacheFilledEndDateN) {
        endDate = new Date(cacheFilledStartDateN - 1);
      } else {
        this.ensureCacheFilledForInterval(startDate, new Date(cacheFilledStartDateN - 1));
        this.ensureCacheFilledForInterval(new Date(cacheFilledEndDateN + 1), endDate);
        return;
      }
    }

    if (cacheFilledStartDateN === _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MAX_DATE"].getTime() || startDate.getTime() < cacheFilledEndDateN) {
      this.cacheFilledStartDate = startDate;
    }

    if (cacheFilledEndDateN === _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MIN_DATE"].getTime() || cacheFilledEndDateN < endDate.getTime()) {
      this.cacheFilledEndDate = endDate;
    }

    this.fillCache(startDate, endDate);
  }

  fillCache(_1
  /* startDate */
  , _2
  /* endDate */
  ) {
    throw new Error("Abstract method");
  }

  clear() {
    this.cacheFilledStartDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MAX_DATE"];
    this.cacheFilledEndDate = _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MIN_DATE"];
    this.intervalCache.clear();
  }
  /**
   * The core iterator method of the calendar cache.
   *
   * @param options The options for iterator. Should contain at least one of the `startDate`/`endDate` properties
   * which indicates what timespan to examine for availability intervals. If one of boundaries is not provided
   * iterator function should return `false` at some point, to avoid infinite loops.
   *
   * Another recognized option is `isForward`, which indicates the direction in which to iterate through the timespan.
   *
   * Another recognized option is `maxRange`, which indicates the maximum timespan for this iterator (in milliseconds). When iterator
   * exceeds this timespan, the iteration is stopped and [[CalendarIteratorResult.MaxRangeReached]] value is returned.
   * Default value is 5 years.
   *
   * @param func The iterator function to call. It will be called for every distinct set of availability intervals, found
   * in the given timespan. All the intervals, which are "active" for current interval are collected in the 3rd argument
   * for this function. If iterator returns `false` (checked with `===`) the iteration stops.
   *
   * @param scope The scope (`this` value) to execute the iterator in.
   */


  forEachAvailabilityInterval(options, func, scope) {
    var _a;

    scope = scope || this;
    const startDate = options.startDate;
    const endDate = options.endDate;
    const startDateN = startDate && startDate.getTime();
    const endDateN = endDate && endDate.getTime();
    const maxRange = (_a = options.maxRange) !== null && _a !== void 0 ? _a : this.maxRange; // `isForward = true` by default

    const isForward = options.isForward !== false;

    if (isForward ? !startDate : !endDate) {
      throw new Error("At least `startDate` or `endDate` is required, depending from the `isForward` option");
    }

    const intervalCache = this.intervalCache;
    let cacheCursorDate = isForward ? startDate : endDate;
    let cursorDate = isForward ? startDate : endDate;
    const rangeStart = cursorDate.getTime(); // this is generally an endless loop, but we artificially limit it to `maxCacheExtendCycles` iterations
    // to avoid freezing in unforeseen edge cases

    for (let cycle = 1; cycle < this.maxCacheExtendCycles; cycle++) {
      if (isForward) {
        this.ensureCacheFilledForInterval(cacheCursorDate, endDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(cacheCursorDate, this.intervalsCachingChunkDuration, this.intervalsCachingChunkUnit));
      } else {
        this.ensureCacheFilledForInterval(startDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(cacheCursorDate, -this.intervalsCachingChunkDuration, this.intervalsCachingChunkUnit), cacheCursorDate);
      }

      let interval = intervalCache.getIntervalOf(cursorDate, isForward ? _util_Types_js__WEBPACK_IMPORTED_MODULE_3__["EdgeInclusion"].Left : _util_Types_js__WEBPACK_IMPORTED_MODULE_3__["EdgeInclusion"].Right);

      while (interval) {
        const intervalStartDate = interval.startDate;
        const intervalEndDate = interval.endDate; // out of requested range - all done

        if (isForward && endDateN && intervalStartDate.getTime() >= endDateN || !isForward && startDateN && intervalEndDate.getTime() <= startDateN) {
          return CalendarIteratorResult.FullRangeIterated;
        }

        if (isForward && intervalStartDate.getTime() - rangeStart >= maxRange || !isForward && rangeStart - intervalEndDate.getTime() >= maxRange) {
          return CalendarIteratorResult.MaxRangeReached;
        } // we are out of cached area, need to extend the cache


        if (isForward && intervalStartDate.getTime() > this.cacheFilledEndDate.getTime() || !isForward && intervalEndDate.getTime() < this.cacheFilledStartDate.getTime()) {
          break;
        } // save the last processed point, from which we should start after cache will be extended


        cursorDate = isForward ? intervalEndDate : intervalStartDate; // adjust to start / end date limits in iterator

        const countFrom = startDateN && intervalStartDate.getTime() < startDateN ? startDate : intervalStartDate;
        const countTill = endDateN && intervalEndDate.getTime() > endDateN ? endDate : intervalEndDate;

        if (func.call(scope, countFrom, countTill, interval.cacheInterval) === false) {
          // indicates premature exit if iterator returns `false`
          return CalendarIteratorResult.StoppedByIterator;
        }

        interval = isForward ? intervalCache.getNextInterval(interval) : intervalCache.getPrevInterval(interval);
      }

      if (isForward && cursorDate.getTime() === _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MAX_DATE"].getTime() || !isForward && cursorDate.getTime() === _util_Constants_js__WEBPACK_IMPORTED_MODULE_2__["MIN_DATE"].getTime()) {
        return CalendarIteratorResult.FullRangeIterated;
      }

      cacheCursorDate = isForward ? this.cacheFilledEndDate : this.cacheFilledStartDate;
    }

    return CalendarIteratorResult.MaxCacheExtendCyclesReached;
  }

}

/***/ }),

/***/ "./lib/Engine/calendar/CalendarCacheInterval.js":
/*!******************************************************!*\
  !*** ./lib/Engine/calendar/CalendarCacheInterval.js ***!
  \******************************************************/
/*! exports provided: CalendarCacheInterval */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheInterval", function() { return CalendarCacheInterval; });
/* harmony import */ var _util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/StripDuplicates.js */ "./lib/Engine/util/StripDuplicates.js");
var productName = 'taskboard';

/**
 * A class, that represent a cached set of availability intervals. One can use the [[getIsWorking]] method
 * to determine if this set intervals represents working time or non-working.
 */

class CalendarCacheInterval {
  constructor(config) {
    this.intervals = [];
    config && Object.assign(this, config);
    if (!this.calendar) throw new Error("Required attribute `calendar` is missing");
  }

  includeInterval(interval) {
    if (this.intervals.indexOf(interval) == -1) {
      const copy = this.intervals.slice();
      copy.push(interval);
      return new CalendarCacheInterval({
        intervals: copy,
        calendar: this.calendar
      });
    } else return this;
  }

  combineWith(interval) {
    return new CalendarCacheInterval({
      intervals: this.intervals.concat(interval.intervals),
      calendar: this.calendar
    });
  }
  /**
   * Returns the working status of this intervals set. It is determined as a working status
   * of the most prioritized interval (intervals are prioritized from child to parent)
   */


  getIsWorking() {
    if (this.isWorking != null) return this.isWorking;
    const intervals = this.intervals = this.normalizeIntervals(this.intervals); // return the value of the interval with the highest priority

    return this.isWorking = intervals[0].isWorking;
  }

  normalizeIntervals(intervals) {
    const filtered = Object(_util_StripDuplicates_js__WEBPACK_IMPORTED_MODULE_0__["stripDuplicates"])(intervals); // sort in decreasing order

    filtered.sort((interval1, interval2) => interval2.getPriorityField() - interval1.getPriorityField());
    return filtered;
  }

}

/***/ }),

/***/ "./lib/Engine/calendar/CalendarCacheSingle.js":
/*!****************************************************!*\
  !*** ./lib/Engine/calendar/CalendarCacheSingle.js ***!
  \****************************************************/
/*! exports provided: CalendarCacheSingle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarCacheSingle", function() { return CalendarCacheSingle; });
/* harmony import */ var _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../vendor/later/later.js */ "./lib/Engine/vendor/later/later.js");
/* harmony import */ var _CalendarCache_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CalendarCache.js */ "./lib/Engine/calendar/CalendarCache.js");
/* harmony import */ var _CalendarCacheInterval_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CalendarCacheInterval.js */ "./lib/Engine/calendar/CalendarCacheInterval.js");
/* harmony import */ var _IntervalCache_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./IntervalCache.js */ "./lib/Engine/calendar/IntervalCache.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'taskboard';





class CalendarCacheSingle extends _CalendarCache_js__WEBPACK_IMPORTED_MODULE_1__["CalendarCache"] {
  constructor(config) {
    super(config);
    this.staticIntervalsCached = false;
    if (!this.unspecifiedTimeInterval) throw new Error("Required attribute `unspecifiedTimeInterval` is missing");
    this.intervalCache = new _IntervalCache_js__WEBPACK_IMPORTED_MODULE_3__["IntervalCache"]({
      emptyInterval: new _CalendarCacheInterval_js__WEBPACK_IMPORTED_MODULE_2__["CalendarCacheInterval"]({
        intervals: [this.unspecifiedTimeInterval],
        calendar: this.calendar
      }),
      combineIntervalsFn: (interval1, interval2) => {
        return interval1.combineWith(interval2);
      }
    });
  }

  fillCache(startDate, endDate) {
    if (!this.staticIntervalsCached) {
      this.cacheStaticIntervals();
      this.staticIntervalsCached = true;
    }

    if (this.parentCache) this.includeWrappingRangeFrom(this.parentCache, startDate, endDate);
    const startDateN = startDate.getTime();
    const endDateN = endDate.getTime();
    if (startDateN > endDateN) throw new Error("Invalid cache fill interval");
    this.forEachRecurrentInterval(interval => {
      const startSchedule = interval.getStartDateSchedule();
      const endSchedule = interval.getEndDateSchedule();
      let wrappingStartDate = startSchedule.prev(1, startDate); // TODO clear time EOD

      let wrappingEndDate = endSchedule === 'EOD' ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStartOfNextDay(startSchedule.next(1, endDate), true) : endSchedule.next(1, endDate); // if the `startDate` is an occurrence in the interval's schedule, we need to advance one point prior
      // this is to provide the backward-scheduling information for the `startDate` point

      if (wrappingStartDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER && wrappingStartDate.getTime() === startDateN) {
        const wrappingStartDates = startSchedule.prev(2, startDate);
        if (wrappingStartDates !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER && wrappingStartDates.length === 2) wrappingStartDate = wrappingStartDates[1];
      }

      if (wrappingEndDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER && wrappingEndDate.getTime() === endDateN) {
        const wrappingEndDates = endSchedule.next(2, endDate);
        if (wrappingEndDates !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER && wrappingEndDates.length === 2) wrappingEndDate = wrappingEndDates[1];
      }

      const startDates = startSchedule.next(Infinity, wrappingStartDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER ? wrappingStartDate : startDate, wrappingEndDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER ? new Date(wrappingEndDate.getTime() - 1) : endDate); // schedule is empty for the interval of interest, do nothing

      if (startDates === _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER) return; // at this point `startDates` is a non-empty array

      const endDates = endSchedule === 'EOD' ? startDates.map(date => _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStartOfNextDay(date, true)) : endSchedule.next(Infinity, new Date(startDates[0].getTime() + 1), wrappingEndDate !== _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER ? wrappingEndDate : endDate);
      if (endDates === _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_0__["default"].NEVER) return;

      if (endDates.length > startDates.length) {
        // safe to ignore "extra" end dates
        endDates.length = startDates.length;
      } else if (endDates.length < startDates.length) {
        // monkey patch
        startDates.length = endDates.length; // throw new Error("Recurrent interval inconsistency: " + interval + ", caching startDate: " + startDate + ", caching endDate: " + endDate)
      }

      startDates.forEach((startDate, index) => {
        const recStartDate = startDate;
        const recEndDate = endDates[index]; // if (recStartDate.getTime() > recEndDate.getTime())
        //     throw new Error("Recurrent interval inconsistency: " + interval + ", startDate: " + startDate + ", endDate: " + endDates[ index ])

        this.intervalCache.addInterval(recStartDate, recEndDate, existingCacheInterval => existingCacheInterval.includeInterval(interval));
      });
    });
  }

  clear() {
    this.staticIntervalsCached = false;
    super.clear();
  }

  cacheStaticIntervals() {
    this.forEachStaticInterval(interval => {
      this.intervalCache.addInterval(interval.startDate, interval.endDate, existingCacheInterval => existingCacheInterval.includeInterval(interval));
    });
  }

  forEachStaticInterval(func) {
    this.intervalStore.forEach(interval => {
      if (interval.isStatic()) func(interval);
    });
  }

  forEachRecurrentInterval(func) {
    this.intervalStore.forEach(interval => {
      if (interval.isRecurrent()) func(interval);
    });
  }

}

/***/ }),

/***/ "./lib/Engine/calendar/CalendarIntervalMixin.js":
/*!******************************************************!*\
  !*** ./lib/Engine/calendar/CalendarIntervalMixin.js ***!
  \******************************************************/
/*! exports provided: CalendarIntervalMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarIntervalMixin", function() { return CalendarIntervalMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../vendor/later/later.js */ "./lib/Engine/vendor/later/later.js");
/* harmony import */ var _quark_model_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../quark/model/mixin/AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");
var productName = 'taskboard';



/**
 * This is a calendar interval mixin.
 *
 * Can be either a static time interval (if [[startDate]]/[[endDate]] are specified) or recurrent time interval
 * ([[recurrentStartDate]]/[[recurrentEndDate]]).
 *
 * By default it defines a non-working period ([[isWorking]] field has default value `false`),
 * but can also define an explicit working time, for example to override some previous period.
 *
 * You probably don't need to create instances of this mixin directly, instead you pass its configuration object to the [[AbstractCalendarMixin.addInterval]]
 */

class CalendarIntervalMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_quark_model_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_2__["AbstractPartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CalendarIntervalMixin extends base {
    static get fields() {
      return ['name', {
        name: 'startDate',
        type: 'date',
        format: 'YYYY-MM-DDTHH:mm:ssZ'
      }, {
        name: 'endDate',
        type: 'date',
        format: 'YYYY-MM-DDTHH:mm:ssZ'
      }, 'recurrentStartDate', 'recurrentEndDate', {
        name: 'isWorking',
        type: 'boolean',
        defaultValue: false
      }, {
        name: 'priority',
        type: 'number'
      }];
    }

    getCalendar() {
      return this.stores[0].calendar;
    }

    resetPriority() {
      this.priorityField = null;
      this.getCalendar().getDepth();
    } // not just `getPriority` to avoid clash with auto-generated getter in the subclasses


    getPriorityField() {
      if (this.priorityField != null) return this.priorityField; // 0 - 10000 interval is reserved for "unspecified time" intervals
      // then 10000 - 10100, 10100-10200, ... etc intervals are for the calendars at depth 0, 1, ... etc

      let base = 10000 + this.getCalendar().getDepth() * 100;
      let priority = this.priority;

      if (priority == null) {
        // recurrent intervals are considered "base" and have lower priority
        // static intervals are considered special case overrides and have higher priority
        priority = this.isRecurrent() ? 20 : 30;
      } // intervals from parent calendars will have lower priority


      return this.priorityField = base + priority;
    }
    /**
     * Whether this interval is recurrent (both `recurrentStartDate` and `recurrentEndDate` are present and parsed correctly
     * by the `later` library)
     */


    isRecurrent() {
      return Boolean(this.recurrentStartDate && this.recurrentEndDate && this.getStartDateSchedule() && this.getEndDateSchedule());
    }
    /**
     * Whether this interval is static - both `startDate` and `endDate` are present.
     */


    isStatic() {
      return Boolean(this.startDate && this.endDate);
    }
    /**
     * Helper method to parse recurrentStartDate and recurrentEndDate field values.
     * @param {Object|String} schedule Recurrence schedule
     * @returns {Object} Processed schedule ready to be used by later.schedule() method.
     * @private
     */


    parseDateSchedule(value) {
      let schedule = value;

      if (value && value !== Object(value)) {
        schedule = _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_1__["default"].parse.text(value);

        if (schedule !== Object(schedule) || schedule.error >= 0) {
          // can be provided as JSON text
          try {
            schedule = JSON.parse(value);
          } catch (e) {
            return null;
          }
        }
      }

      return schedule;
    }

    getStartDateSchedule() {
      if (this.startDateSchedule) return this.startDateSchedule;
      const schedule = this.parseDateSchedule(this.recurrentStartDate);
      return this.startDateSchedule = _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_1__["default"].schedule(schedule);
    }

    getEndDateSchedule() {
      if (this.endDateSchedule) return this.endDateSchedule;
      if (this.recurrentEndDate === 'EOD') return 'EOD';
      const schedule = this.parseDateSchedule(this.recurrentEndDate);
      return this.endDateSchedule = _vendor_later_later_js__WEBPACK_IMPORTED_MODULE_1__["default"].schedule(schedule);
    }

  }

  return CalendarIntervalMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/calendar/CalendarIntervalStore.js":
/*!******************************************************!*\
  !*** ./lib/Engine/calendar/CalendarIntervalStore.js ***!
  \******************************************************/
/*! exports provided: CalendarIntervalStore */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarIntervalStore", function() { return CalendarIntervalStore; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CalendarIntervalMixin.js */ "./lib/Engine/calendar/CalendarIntervalMixin.js");
/* harmony import */ var _quark_store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../quark/store/mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
var productName = 'taskboard';



/*
 * This a collection of {@link #CalendarIntervalMixin} items. Its a dumb collection though, the "real" calendar
 * is a [[AbstractCalendarMixin]] model, which is part of the [[AbstractCalendarManagerStoreMixin]].
 *
 */

class CalendarIntervalStore extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_quark_store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["AbstractPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class CalendarIntervalStore extends base {
    static get defaultConfig() {
      return {
        modelClass: _CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_1__["CalendarIntervalMixin"]
      };
    }

  }

  return CalendarIntervalStore;
}) {}

/***/ }),

/***/ "./lib/Engine/calendar/IntervalCache.js":
/*!**********************************************!*\
  !*** ./lib/Engine/calendar/IntervalCache.js ***!
  \**********************************************/
/*! exports provided: IntervalCache */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalCache", function() { return IntervalCache; });
/* harmony import */ var _util_Constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/Constants.js */ "./lib/Engine/util/Constants.js");
/* harmony import */ var _util_Types_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/Types.js */ "./lib/Engine/util/Types.js");
/* harmony import */ var _SortedMap_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./SortedMap.js */ "./lib/Engine/calendar/SortedMap.js");
var productName = 'taskboard';



class IntervalCache {
  constructor(config) {
    this.points = new _SortedMap_js__WEBPACK_IMPORTED_MODULE_2__["SortedMap"]((a, b) => a.getTime() - b.getTime());
    this.leftInfinityKey = _util_Constants_js__WEBPACK_IMPORTED_MODULE_0__["MIN_DATE"];
    this.rightInfinityKey = _util_Constants_js__WEBPACK_IMPORTED_MODULE_0__["MAX_DATE"];
    Object.assign(this, config);
    if (this.emptyInterval === undefined || !this.combineIntervalsFn) throw new Error("All of `emptyPoint`, `combineIntervalsFn` are required");
    this.points.set(this.leftInfinityKey, this.emptyInterval);
  }

  size() {
    return this.points.size();
  }

  indexOf(date) {
    return this.points.indexOfKey(date);
  }

  getDateAt(index) {
    return this.points.getKeyAt(index);
  }

  getPointAt(index) {
    return this.points.getValueAt(index);
  }

  getIntervalOf(date, edgeInclusion = _util_Types_js__WEBPACK_IMPORTED_MODULE_1__["EdgeInclusion"].Left) {
    // the `index` here is guaranteed to be > 0, because at index 0 there's a `emptyPoint`
    let {
      found,
      index
    } = this.indexOf(date);
    let startDateIndex;

    if (edgeInclusion === _util_Types_js__WEBPACK_IMPORTED_MODULE_1__["EdgeInclusion"].Left) {
      startDateIndex = found === _SortedMap_js__WEBPACK_IMPORTED_MODULE_2__["IndexPosition"].Exact ? index : index - 1;
    } else {
      startDateIndex = index - 1;
    }

    return this.getIntervalWithStartDateIndex(startDateIndex);
  }

  getPrevInterval(interval) {
    if (interval.startDateIndex === 0) return null;
    return this.getIntervalWithStartDateIndex(interval.startDateIndex - 1);
  }

  getNextInterval(interval) {
    if (interval.startDateIndex >= this.size() - 1) return null;
    return this.getIntervalWithStartDateIndex(interval.startDateIndex + 1);
  }

  getIntervalWithStartDateIndex(startDateIndex) {
    return {
      startDateIndex: startDateIndex,
      startDate: this.getDateAt(startDateIndex),
      endDate: startDateIndex + 1 < this.size() ? this.getDateAt(startDateIndex + 1) : this.rightInfinityKey,
      cacheInterval: this.getPointAt(startDateIndex)
    };
  }

  addInterval(startDate, endDate, extendInterval) {
    const points = this.points; // there is always "leftInfinityKey" empty point, so `index >= 0`

    const {
      found,
      index
    } = points.indexOfKey(startDate);
    let curIndex;
    let lastUpdatedPoint;

    if (found == _SortedMap_js__WEBPACK_IMPORTED_MODULE_2__["IndexPosition"].Exact) {
      const inclusion = extendInterval(lastUpdatedPoint = points.getValueAt(index));
      points.setValueAt(index, inclusion);
      curIndex = index + 1;
    } else {
      const inclusion = extendInterval(lastUpdatedPoint = points.getValueAt(index - 1));
      points.insertAt(index, startDate, inclusion);
      curIndex = index + 1;
    }

    while (curIndex < points.size()) {
      const curDate = points.getKeyAt(curIndex);
      if (curDate.getTime() >= endDate.getTime()) break;
      const inclusion = extendInterval(lastUpdatedPoint = points.getValueAt(curIndex));
      points.setValueAt(curIndex, inclusion);
      curIndex++;
    }

    if (curIndex === points.size()) {
      points.insertAt(points.size(), endDate, this.emptyInterval);
    } else {
      const curDate = points.getKeyAt(curIndex);

      if (curDate.getTime() === endDate.getTime()) {// we advanced till some point, which matches `endDate` config
        // this point will setup a new label, no need to add an explicit end date point,
        // we are done, do nothing
      } else {
        points.insertAt(curIndex, endDate, lastUpdatedPoint);
      }
    }
  }

  includeWrappingRange(intervalCache, startDate, endDate) {
    let interval = intervalCache.getIntervalOf(startDate);

    while (interval) {
      this.addInterval(interval.startDate, interval.endDate, existingInterval => this.combineIntervalsFn(existingInterval, interval.cacheInterval));
      if (interval.endDate.getTime() > endDate.getTime()) break;
      interval = intervalCache.getNextInterval(interval);
    }
  }

  getSummary() {
    return this.points.map((label, date) => {
      return {
        label,
        date
      };
    });
  }

  clear() {
    this.points.clear();
    this.points.set(this.leftInfinityKey, this.emptyInterval);
  }

}

/***/ }),

/***/ "./lib/Engine/calendar/SortedMap.js":
/*!******************************************!*\
  !*** ./lib/Engine/calendar/SortedMap.js ***!
  \******************************************/
/*! exports provided: IndexPosition, SortedMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IndexPosition", function() { return IndexPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortedMap", function() { return SortedMap; });
/* harmony import */ var _util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/BinarySearch.js */ "./lib/Engine/util/BinarySearch.js");
var productName = 'taskboard';

var IndexPosition;

(function (IndexPosition) {
  IndexPosition[IndexPosition["Exact"] = 0] = "Exact";
  IndexPosition[IndexPosition["Next"] = 1] = "Next";
})(IndexPosition || (IndexPosition = {})); // TODO store keys and values in a single array of "entries"? less memory movement during insert/delete in theory


class SortedMap {
  constructor(comparator) {
    this.keys = [];
    this.values = [];

    this.comparator = comparator || ((a, b) => a - b);
  }

  set(key, value) {
    const search = Object(_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_0__["binarySearch"])(key, this.keys, this.comparator);

    if (search.found) {
      this.values[search.index] = value;
    } else {
      this.keys.splice(search.index, 0, key);
      this.values.splice(search.index, 0, value);
    }

    return search.index;
  } // you need to know what you are doing when using this method


  insertAt(index, key, value) {
    this.keys.splice(index, 0, key);
    this.values.splice(index, 0, value);
  }

  setValueAt(index, value) {
    this.values[index] = value;
  }

  get(key) {
    const search = Object(_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_0__["binarySearch"])(key, this.keys, this.comparator);
    return search.found ? this.values[search.index] : undefined;
  }

  getEntryAt(index) {
    return index < this.keys.length ? {
      key: this.keys[index],
      value: this.values[index]
    } : undefined;
  }

  getKeyAt(index) {
    return this.keys[index];
  }

  getValueAt(index) {
    return this.values[index];
  }

  delete(key) {
    const search = Object(_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_0__["binarySearch"])(key, this.keys, this.comparator);
    if (search.found) this.deleteAt(search.index);
  }

  size() {
    return this.keys.length;
  }

  deleteAt(index) {
    this.keys.splice(index, 1);
    this.values.splice(index, 1);
  }

  indexOfKey(key) {
    const search = Object(_util_BinarySearch_js__WEBPACK_IMPORTED_MODULE_0__["binarySearch"])(key, this.keys, this.comparator);
    return {
      found: search.found ? IndexPosition.Exact : IndexPosition.Next,
      index: search.index
    };
  }

  map(func) {
    const keys = this.keys;
    const values = this.values;
    const result = [];

    for (let i = 0; i < keys.length; i++) result.push(func(values[i], keys[i], i));

    return result;
  }

  getAllEntries() {
    return this.map((value, key) => {
      return {
        value,
        key
      };
    });
  }

  clear() {
    this.keys.length = 0;
    this.values.length = 0;
  }

}

/***/ }),

/***/ "./lib/Engine/calendar/UnspecifiedTimeIntervalModel.js":
/*!*************************************************************!*\
  !*** ./lib/Engine/calendar/UnspecifiedTimeIntervalModel.js ***!
  \*************************************************************/
/*! exports provided: UnspecifiedTimeIntervalModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnspecifiedTimeIntervalModel", function() { return UnspecifiedTimeIntervalModel; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CalendarIntervalMixin.js */ "./lib/Engine/calendar/CalendarIntervalMixin.js");
var productName = 'taskboard';

 // TODO if we would be doing just:
//      export class UnspecifiedTimeIntervalModel extends CalendarIntervalMixin ...
// then an instance of the `CalendarIntervalMixin` `c` would : `c instanceof UnspecifiedTimeIntervalModel`,
// because it inherit the `hasInstance` symbol
// need to figure out how it can be handled
// Calendar interval model denoting unspecified interval

class UnspecifiedTimeIntervalModel extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_CalendarIntervalMixin_js__WEBPACK_IMPORTED_MODULE_1__["CalendarIntervalMixin"]], base => {
  const superProto = base.prototype;

  class UnspecifiedTimeIntervalModel extends base {
    // TODO: why it overrides the method, is it configured with calendar instance directly?
    getCalendar() {
      return this.calendar;
    } // NOTE: See parent class implementation for further comments


    getPriorityField() {
      if (this.priorityField != null) return this.priorityField;
      return this.priorityField = this.getCalendar().getDepth();
    }

  }

  return UnspecifiedTimeIntervalModel;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js":
/*!***************************************************************!*\
  !*** ./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js ***!
  \***************************************************************/
/*! exports provided: AbstractPartOfProjectGenericMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractPartOfProjectGenericMixin", function() { return AbstractPartOfProjectGenericMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
var productName = 'taskboard';

/**
 * This a base generic mixin for every class, that belongs to a project.
 *
 * It just provides getter/setter for the `project` property, along with some convenience methods
 * to access the project's stores.
 */

class AbstractPartOfProjectGenericMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([], base => {
  const superProto = base.prototype;

  class AbstractPartOfProjectGenericMixin extends base {
    async commitAsync() {
      return this.project.commitAsync();
    }

    set project(project) {
      this.$project = project;
    }

    get project() {
      return this.$project;
    }

    calculateProject() {
      throw new Error("Implement me");
    }
    /**
     * The method to set the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    setProject(project) {
      return this.project = project;
    }
    /**
     * The method to get the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    getProject() {
      if (this.project) return this.project;
      return this.setProject(this.calculateProject());
    }
    /**
     * Convenience method to get the instance of the assignment store in the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    getAssignmentStore() {
      const project = this.getProject();
      return project === null || project === void 0 ? void 0 : project.assignmentStore;
    }
    /**
     * Convenience method to get the instance of the dependency store in the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    getDependencyStore() {
      const project = this.getProject();
      return project === null || project === void 0 ? void 0 : project.dependencyStore;
    }
    /**
     * Convenience method to get the instance of the event store in the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    getEventStore() {
      const project = this.getProject();
      return project === null || project === void 0 ? void 0 : project.eventStore;
    }
    /**
     * Convenience method to get the instance of the resource store in the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    getResourceStore() {
      const project = this.getProject();
      return project === null || project === void 0 ? void 0 : project.resourceStore;
    }
    /**
     * Convenience method to get the instance of the calendar manager store in the [[AbstractProjectMixin|project]] instance, this entity belongs to.
     */


    getCalendarManagerStore() {
      const project = this.getProject();
      return project === null || project === void 0 ? void 0 : project.calendarManagerStore;
    }

  }

  return AbstractPartOfProjectGenericMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/CorePartOfProjectGenericMixin.js":
/*!***********************************************************!*\
  !*** ./lib/Engine/quark/CorePartOfProjectGenericMixin.js ***!
  \***********************************************************/
/*! exports provided: CorePartOfProjectGenericMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CorePartOfProjectGenericMixin", function() { return CorePartOfProjectGenericMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AbstractPartOfProjectGenericMixin.js */ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js");
var productName = 'taskboard';


/**
 * This a base generic mixin for every class, that belongs to a scheduler_core project.
 *
 * It just provides getter/setter for the `project` property, along with some convenience methods
 * to access the project's stores.
 */

class CorePartOfProjectGenericMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectGenericMixin"]], base => {
  const superProto = base.prototype;

  class CorePartOfProjectGenericMixin extends base {
    //region Store getters
    get eventStore() {
      var _a;

      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.eventStore;
    }

    get resourceStore() {
      var _a;

      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.resourceStore;
    }

    get assignmentStore() {
      var _a;

      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.assignmentStore;
    }

    get dependencyStore() {
      var _a;

      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.dependencyStore;
    }

    get calendarManagerStore() {
      var _a;

      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.calendarManagerStore;
    } //endregion
    //region Entity getters

    /**
     * Convenience method to get the instance of event by its id.
     */


    getEventById(id) {
      var _a;

      return (_a = this.eventStore) === null || _a === void 0 ? void 0 : _a.getById(id);
    }
    /**
     * Convenience method to get the instance of dependency by its id.
     */


    getDependencyById(id) {
      var _a;

      return (_a = this.dependencyStore) === null || _a === void 0 ? void 0 : _a.getById(id);
    }
    /**
     * Convenience method to get the instance of resource by its id.
     */


    getResourceById(id) {
      var _a;

      return (_a = this.resourceStore) === null || _a === void 0 ? void 0 : _a.getById(id);
    }
    /**
     * Convenience method to get the instance of assignment by its id.
     */


    getAssignmentById(id) {
      var _a;

      return (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.getById(id);
    }
    /**
     * Convenience method to get the instance of calendar by its id.
     */


    getCalendarById(id) {
      var _a;

      return (_a = this.calendarManagerStore) === null || _a === void 0 ? void 0 : _a.getById(id);
    }

  }

  return CorePartOfProjectGenericMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/AbstractCalendarMixin.js":
/*!*********************************************************!*\
  !*** ./lib/Engine/quark/model/AbstractCalendarMixin.js ***!
  \*********************************************************/
/*! exports provided: AbstractCalendarMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractCalendarMixin", function() { return AbstractCalendarMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _calendar_CalendarIntervalStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../calendar/CalendarIntervalStore.js */ "./lib/Engine/calendar/CalendarIntervalStore.js");
/* harmony import */ var _calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../calendar/CalendarCache.js */ "./lib/Engine/calendar/CalendarCache.js");
/* harmony import */ var _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../scheduling/Types.js */ "./lib/Engine/scheduling/Types.js");
/* harmony import */ var _calendar_CalendarCacheSingle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../calendar/CalendarCacheSingle.js */ "./lib/Engine/calendar/CalendarCacheSingle.js");
/* harmony import */ var _calendar_UnspecifiedTimeIntervalModel_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../calendar/UnspecifiedTimeIntervalModel.js */ "./lib/Engine/calendar/UnspecifiedTimeIntervalModel.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");
var productName = 'taskboard';








/**
 * Calendar for project scheduling, mixed by CoreCalendarMixin and BaseCalendarMixin. It is used to mark certain time
 * intervals as "non-working" and ignore them during scheduling.
 *
 * The calendar consists from several [[CalendarIntervalMixin|intervals]]. The intervals can be either static or recurrent.
 */

class AbstractCalendarMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_7__["AbstractPartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CalendarMixin extends base {
    constructor() {
      super(...arguments);
      this.version = 1;
    }

    static get fields() {
      return [{
        name: 'version',
        type: 'number'
      }, 'name', {
        name: 'unspecifiedTimeIsWorking',
        type: 'boolean',
        defaultValue: true
      }, 'intervals'];
    }

    get intervalStoreClass() {
      return _calendar_CalendarIntervalStore_js__WEBPACK_IMPORTED_MODULE_1__["CalendarIntervalStore"];
    }

    afterConstruct() {
      superProto.afterConstruct.call(this); // @ts-ignore

      const modelClass = this.getDefaultConfiguration().calendarIntervalModelClass || this.intervalStoreClass.defaultConfig.modelClass;
      this.intervalStore = new this.intervalStoreClass({
        calendar: this,
        modelClass
      }); // if intervals are provided add them to the this.intervalStore

      if (this.intervals && this.intervals.length) {
        this.addIntervals(this.intervals);
      }
    }

    isDefault() {
      const project = this.getProject();

      if (project) {
        return this === project.defaultCalendar;
      }

      return false;
    } // TODO: move to Model?


    getDepth() {
      return this.childLevel + 1;
    }
    /**
     * The core iterator method of the calendar.
     *
     * @param options The options for iterator. Should contain at least one of the `startDate`/`endDate` properties
     * which indicates what timespan to examine for availability intervals. If one of boundaries is not provided
     * iterator function should return `false` at some point, to avoid infinite loops.
     *
     * Another recognized option is `isForward`, which indicates the direction in which to iterate through the timespan.
     *
     * @param func The iterator function to call. It will be called for every distinct set of availability intervals, found
     * in the given timespan. All the intervals, which are "active" for current interval are collected in the 3rd argument
     * for this function - [[CalendarCacheInterval|calendarCacheInterval]]. If iterator returns `false` (checked with `===`)
     * the iteration stops.
     *
     * @param scope The scope (`this` value) to execute the iterator in.
     */


    forEachAvailabilityInterval(options, func, scope) {
      return this.calendarCache.forEachAvailabilityInterval(options, func, scope);
    }
    /**
     * This method starts at the given `date` and moves forward or backward in time, depending on `isForward`.
     * It stops moving as soon as it accumulates the `durationMs` milliseconds of working time and returns the date
     * at which it has stopped and remaining duration - the [[AccumulateWorkingTimeResult]] object.
     *
     * Normally, the remaining duration will be 0, indicating the full `durationMs` has been accumulated.
     * However, sometimes, calendar might not be able to accumulate enough working time due to various reasons,
     * like if it does not contain enough working time - this case will be indicated with remaining duration bigger than 0.
     *
     * @param date
     * @param durationMs
     * @param isForward
     */


    accumulateWorkingTime(date, durationMs, isForward) {
      // if duration is 0 - return the same date
      if (durationMs === 0) return {
        finalDate: new Date(date),
        remainingDurationInMs: 0
      };
      if (isNaN(durationMs)) throw new Error("Invalid duration");
      let finalDate = date;
      this.forEachAvailabilityInterval(isForward ? {
        startDate: date,
        isForward: true
      } : {
        endDate: date,
        isForward: false
      }, (intervalStartDate, intervalEndDate, calendarCacheInterval) => {
        let result = true;

        if (calendarCacheInterval.getIsWorking()) {
          let diff = intervalEndDate.getTime() - intervalStartDate.getTime();

          if (this.getProject().adjustDurationToDST) {
            const dstDiff = intervalStartDate.getTimezoneOffset() - intervalEndDate.getTimezoneOffset();
            diff += dstDiff * 60 * 1000;
          }

          if (durationMs <= diff) {
            finalDate = isForward ? new Date(intervalStartDate.getTime() + durationMs) : new Date(intervalEndDate.getTime() - durationMs);
            durationMs = 0;
            result = false;
          } else {
            finalDate = isForward ? intervalEndDate : intervalStartDate;
            durationMs -= diff;
          }
        }

        return result;
      });
      return {
        finalDate: new Date(finalDate),
        remainingDurationInMs: durationMs
      };
    }
    /**
     * Calculate the working time duration between the 2 dates, in milliseconds.
     *
     * @param startDate
     * @param endDate
     */


    calculateDurationMs(startDate, endDate) {
      let duration = 0;
      this.forEachAvailabilityInterval({
        startDate: startDate,
        endDate: endDate
      }, (intervalStartDate, intervalEndDate, calendarCacheInterval) => {
        if (calendarCacheInterval.getIsWorking()) {
          duration += intervalEndDate.getTime() - intervalStartDate.getTime();

          if (this.getProject().adjustDurationToDST) {
            const dstDiff = intervalStartDate.getTimezoneOffset() - intervalEndDate.getTimezoneOffset();
            duration += dstDiff * 60 * 1000;
          }
        }
      });
      return duration;
    }
    /**
     * Calculate the end date of the time interval which starts at `startDate` and has `durationMs` working time duration
     * (in milliseconds).
     *
     * @param startDate
     * @param durationMs
     */


    calculateEndDate(startDate, durationMs) {
      // the method goes forward by default ..unless a negative duration provided
      const isForward = durationMs >= 0;
      const res = this.accumulateWorkingTime(startDate, Math.abs(durationMs), isForward);
      return res.remainingDurationInMs === 0 ? res.finalDate : null;
    }
    /**
     * Calculate the start date of the time interval which ends at `endDate` and has `durationMs` working time duration
     * (in milliseconds).
     *
     * @param endDate
     * @param durationMs
     */


    calculateStartDate(endDate, durationMs) {
      // the method goes backwards by default ..unless a negative duration provided
      const isForward = durationMs <= 0;
      const res = this.accumulateWorkingTime(endDate, Math.abs(durationMs), isForward);
      return res.remainingDurationInMs === 0 ? res.finalDate : null;
    }
    /**
     * Returns the earliest point at which a working period of time starts, following the given date.
     * Can be the date itself, if it comes on the working time.
     *
     * @param date The date after which to skip the non-working time.
     * @param isForward Whether the "following" means forward in time or backward.
     */


    skipNonWorkingTime(date, isForward = true) {
      let workingDate;
      const res = this.forEachAvailabilityInterval(isForward ? {
        startDate: date,
        isForward: true
      } : {
        endDate: date,
        isForward: false
      }, (intervalStartDate, intervalEndDate, calendarCacheInterval) => {
        if (calendarCacheInterval.getIsWorking()) {
          workingDate = isForward ? intervalStartDate : intervalEndDate;
          return false;
        }
      });
      if (res === _calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_2__["CalendarIteratorResult"].MaxRangeReached || res === _calendar_CalendarCache_js__WEBPACK_IMPORTED_MODULE_2__["CalendarIteratorResult"].FullRangeIterated) return 'empty_calendar';
      return workingDate ? new Date(workingDate) : new Date(date);
    }
    /**
     * This method adds a single [[CalendarIntervalMixin]] to the internal collection of the calendar
     */


    addInterval(interval) {
      return this.addIntervals([interval]);
    }
    /**
     * This method adds an array of [[CalendarIntervalMixin]] to the internal collection of the calendar
     */


    addIntervals(intervals) {
      this.bumpVersion();
      return this.intervalStore.add(intervals);
    }
    /**
     * This method removes all intervals from the internal collection of the calendar
     */


    clearIntervals(silent) {
      if (!silent) {
        this.bumpVersion();
      }

      return this.intervalStore.removeAll(silent);
    }

    bumpVersion() {
      this.clearCache();
      this.version++;
    }

    get calendarCache() {
      if (this.$calendarCache !== undefined) return this.$calendarCache;
      const unspecifiedTimeInterval = new _calendar_UnspecifiedTimeIntervalModel_js__WEBPACK_IMPORTED_MODULE_5__["UnspecifiedTimeIntervalModel"]({
        isWorking: this.unspecifiedTimeIsWorking
      });
      unspecifiedTimeInterval.calendar = this;
      return this.$calendarCache = new _calendar_CalendarCacheSingle_js__WEBPACK_IMPORTED_MODULE_4__["CalendarCacheSingle"]({
        calendar: this,
        unspecifiedTimeInterval: unspecifiedTimeInterval,
        intervalStore: this.intervalStore,
        parentCache: this.parent && !this.parent.isRoot ? this.parent.calendarCache : null
      });
    }

    clearCache() {
      // not strictly needed, we just help garbage collector
      this.$calendarCache && this.$calendarCache.clear();
      this.$calendarCache = undefined;
    }

    resetPriorityOfAllIntervals() {
      this.traverse(calendar => {
        calendar.intervalStore.forEach(interval => interval.resetPriority());
      });
    }

    insertChild(child, before, silent) {
      let res = superProto.insertChild.call(this, ...arguments);

      if (!Array.isArray(res)) {
        res = [res];
      } // invalidate cache of the child record, since now it should take parent into account


      res.forEach(r => {
        r.bumpVersion();
        r.resetPriorityOfAllIntervals();
      });
      return res;
    }

    joinProject() {
      superProto.joinProject.call(this);
      this.intervalStore.setProject(this.getProject());
    }

    leaveProject() {
      superProto.leaveProject.call(this);
      this.intervalStore.setProject(null);
      this.intervalStore.destroy();
      this.clearCache();
    }

    doDestroy() {
      this.leaveProject();
      super.doDestroy();
    }

    isDayHoliday(day) {
      const startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].clearTime(day),
            endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getNext(day, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_3__["TimeUnit"].Day);
      let hasWorkingTime = false;
      this.forEachAvailabilityInterval({
        startDate,
        endDate,
        isForward: true
      }, (_intervalStartDate, _intervalEndDate, calendarCacheInterval) => {
        hasWorkingTime = calendarCacheInterval.getIsWorking();
        return !hasWorkingTime;
      });
      return !hasWorkingTime;
    } // TODO: tests


    getDailyHolidaysRanges(startDate, endDate) {
      const result = [];
      startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].clearTime(startDate);

      while (startDate < endDate) {
        if (this.isDayHoliday(startDate)) {
          result.push({
            startDate,
            endDate: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getStartOfNextDay(startDate, true, true)
          });
        }

        startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getNext(startDate, _scheduling_Types_js__WEBPACK_IMPORTED_MODULE_3__["TimeUnit"].Day);
      }

      return result;
    }

    getNonWorkingTimeRanges(startDate, endDate) {
      const result = [];
      this.forEachAvailabilityInterval({
        startDate,
        endDate,
        isForward: true
      }, (intervalStartDate, intervalEndDate, calendarCacheInterval) => {
        if (!calendarCacheInterval.getIsWorking()) {
          const entry = calendarCacheInterval.intervals[0];
          result.push({
            name: entry.name,
            startDate: intervalStartDate,
            endDate: intervalEndDate
          });
        }
      });
      return result;
    }
    /**
     * Checks if there is a working time interval in the provided time range (or when just startDate is provided,
     * checks if the date is contained inside a working time interval in this calendar)
     * @param startDate
     * @param [endDate]
     */


    isWorkingTime(startDate, endDate) {
      // Can be Date | null | 'empty_calendar'
      const workingTimeStart = this.skipNonWorkingTime(startDate);
      return workingTimeStart && workingTimeStart !== 'empty_calendar' ? endDate ? workingTimeStart < endDate : workingTimeStart.getTime() === startDate.getTime() : false;
    }

  }

  return CalendarMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/AbstractHasAssignmentsMixin.js":
/*!***************************************************************!*\
  !*** ./lib/Engine/quark/model/AbstractHasAssignmentsMixin.js ***!
  \***************************************************************/
/*! exports provided: AbstractHasAssignmentsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractHasAssignmentsMixin", function() { return AbstractHasAssignmentsMixin; });
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");
var productName = 'taskboard';


/**
 * This is a mixin enabling events to handle assignments. It is mixed by CoreHasAssignmentsMixin and
 * BaseHasAssignmentsMixin. It provides a collection of all assignments, which reference this event.
 *
 * Doesn't affect scheduling.
 */

class AbstractHasAssignmentsMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class HasAssignmentsMixin extends base {
    /**
     * If a given resource is assigned to this task, returns a [[BaseAssignmentMixin]] instance for it.
     * Otherwise returns `null`
     */
    getAssignmentFor(resource) {
      for (const assignment of this.assigned) {
        if (assignment.resource === resource) return assignment;
      }

      return null;
    }

    isAssignedTo(resource) {
      return Boolean(this.getAssignmentFor(resource));
    }
    /**
     * A method which assigns a resource to the current event
     */


    async assign(resource) {
      const assignmentCls = this.project.assignmentStore.modelClass;
      this.addAssignment(new assignmentCls({
        event: this,
        resource: resource
      }));
      return this.commitAsync();
    }
    /**
     * A method which unassigns a resource from the current event
     */


    async unassign(resource) {
      const assignment = this.getAssignmentFor(resource);
      this.removeAssignment(assignment);
      return this.commitAsync();
    }

    leaveProject() {
      // `this.assigned` will be empty if model is added to project and then removed immediately
      // w/o any propagations
      if (this.assigned) {
        const eventStore = this.getEventStore(); // to batch the assignments removal, we don't remove the assignments right away, but instead
        // add them for the batched removal to the `assignmentsForRemoval` property of the event store

        this.assigned.forEach(assignment => eventStore.assignmentsForRemoval.add(assignment));
      }

      superProto.leaveProject.call(this, ...arguments);
    }

    remove() {
      if (this.parent) {
        // need to get the event store in advance, because after removal the project reference will be cleared (all that is what provide
        // references to all stores
        const eventStore = this.getEventStore();
        superProto.remove.call(this);
        eventStore && eventStore.afterEventRemoval();
      } else {
        return superProto.remove.call(this);
      }
    } // template methods, overridden in scheduling modes mixins
    // should probably be named something like "onEventAssignmentAdded"
    // should be a listener for the `add` event of the assignment store instead


    addAssignment(assignment) {
      this.getProject().assignmentStore.add(assignment);
      return assignment;
    } // should be a listener for the `remove` event of the assignment store instead


    removeAssignment(assignment) {
      this.getProject().assignmentStore.remove(assignment);
      return assignment;
    }

  }

  return HasAssignmentsMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/AbstractProjectMixin.js":
/*!********************************************************!*\
  !*** ./lib/Engine/quark/model/AbstractProjectMixin.js ***!
  \********************************************************/
/*! exports provided: EventsWrapper, DelayableWrapper, AbstractProjectMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventsWrapper", function() { return EventsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DelayableWrapper", function() { return DelayableWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractProjectMixin", function() { return AbstractProjectMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
var productName = 'taskboard';




class EventsWrapper extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([], _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {}
class DelayableWrapper extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([], _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {}
/**
 * This is an abstract project, which just lists the available stores.
 *
 * The actual project classes are [[SchedulerCoreProjectMixin]], [[SchedulerBasicProjectMixin]],
 * [[SchedulerProProjectMixin]], [[GanttProjectMixin]].
 */

class AbstractProjectMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([EventsWrapper, DelayableWrapper, _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_3__["default"]], base => {
  const superProto = base.prototype;

  class AbstractProjectMixin extends base {
    get isRepopulatingStores() {
      return false;
    }

    get isInitialCommit() {
      return !this.isInitialCommitPerformed || this.hasLoadedDataToCommit;
    }

    construct(config = {}) {
      // Define default values for these flags here
      // if defined where declared then TS compiles them this way:
      // constructor() {
      //     super(...arguments)
      //     this.isInitialCommitPerformed   = false
      //     this.isLoadingInlineData        = false
      //     this.isWritingData              = false
      //
      // }
      // which messes the flags values for inline data loading (since it's async)
      this.isInitialCommitPerformed = false;
      this.isLoadingInlineData = false;
      this.isWritingData = false;
      this.hasLoadedDataToCommit = false;
      superProto.construct.call(this, config);
      this.silenceInitialCommit = 'silenceInitialCommit' in config ? config.silenceInitialCommit : true;
      this.adjustDurationToDST = 'adjustDurationToDST' in config ? config.adjustDurationToDST : false;
    } // Template method called when a stores dataset is replaced. Implemented in SchedulerBasicProjectMixin


    repopulateStore(store) {} // Template method called when replica should be repopulated. Implemented in SchedulerBasicProjectMixin


    repopulateReplica() {} // Template method called when a store is attached to the project


    attachStore(store) {} // Template method called when a store is detached to the project


    detachStore(store) {}

    async commitAsync() {
      throw new Error("Abstract method called");
    } // Different implementations for Core and Basic engines


    isEngineReady() {
      throw new Error("Abstract method called");
    }

  }

  return AbstractProjectMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js":
/*!*************************************************************************!*\
  !*** ./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js ***!
  \*************************************************************************/
/*! exports provided: AbstractPartOfProjectModelMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractPartOfProjectModelMixin", function() { return AbstractPartOfProjectModelMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../store/mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../AbstractPartOfProjectGenericMixin.js */ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
var productName = 'taskboard';





/**
 * This an abstract mixin for every Model that belongs to a project.
 *
 * The model with this mixin, supposes that it will be "joining" a store that is already part of a project,
 * so that such model can take a reference to the project from it.
 *
 * It provides 2 template methods [[joinProject]] and [[leaveProject]], which can be overridden in other mixins.
 */

class AbstractPartOfProjectModelMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_2__["AbstractPartOfProjectGenericMixin"], _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_3__["default"]], base => {
  const superProto = base.prototype;

  class AbstractPartOfProjectModelMixin extends base {
    joinStore(store) {
      let joinedProject = false; // Joining a store that is not part of project (for example a chained store) should not affect engine

      if (Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(store, _store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"])) {
        const project = store.getProject(); // Join directly only if not repopulating the store, in which case we will be joined later after
        // graph has been recreated

        if (project && !project.isRepopulatingStores && !this.getProject()) {
          this.setProject(project);
          joinedProject = true;
        }
      }

      superProto.joinStore.call(this, store);
      if (joinedProject) this.joinProject();
    }

    unjoinStore(store, isReplacing = false) {
      superProto.unjoinStore.call(this, store, isReplacing);
      const project = this.getProject();
      const isLeavingProjectStore = Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(store, _store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]) && project === store.getProject(); // Leave project when unjoining from store, but do not bother if the project is being destroyed or if
      // the dataset is being replaced

      if (project && !project.isDestroying && !project.isRepopulatingStores && isLeavingProjectStore) {
        this.leaveProject(isReplacing);
        this.setProject(null);
      } // @ts-ignore


      if (isLeavingProjectStore) this.graph = null;
    }
    /**
     * Template method, which is called when model is joining the project (through joining some store that
     * has already joined the project)
     */


    joinProject() {}
    /**
     * Template method, which is called when model is leaving the project (through leaving some store usually)
     */


    leaveProject(isReplacing = false) {}

    calculateProject() {
      const store = this.stores.find(s => Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(s, _store_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]) && !!s.getProject());
      return store === null || store === void 0 ? void 0 : store.getProject();
    }

    async setAsync(fieldName, value, silent) {
      var _a;

      const result = this.set(fieldName, value, silent);
      await ((_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync());
      return result;
    }

    async getAsync(fieldName) {
      var _a;

      await ((_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync());
      return this.get(fieldName);
    }

  }

  return AbstractPartOfProjectModelMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js ***!
  \*********************************************************************/
/*! exports provided: CorePartOfProjectModelMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CorePartOfProjectModelMixin", function() { return CorePartOfProjectModelMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../CorePartOfProjectGenericMixin.js */ "./lib/Engine/quark/CorePartOfProjectGenericMixin.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractPartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/AbstractPartOfProjectModelMixin.js");
var productName = 'taskboard';




/**
 * This a mixin for every Model that belongs to a scheduler_core project.
 *
 * It adds functions needed to calculate invalidated fields on project commit.
 */

class CorePartOfProjectModelMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractPartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractPartOfProjectModelMixin"], _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectGenericMixin"], _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_2__["default"]], base => {
  const superProto = base.prototype;

  class CorePartOfProjectModelMixin extends base {
    constructor() {
      super(...arguments); // Flag set during calculation

      this.$isCalculating = false; // Proposed changes

      this.$changed = {}; // Value before proposed change, for buckets that need to update data early

      this.$beforeChange = {};
    } // Invalidate record upon joining project, leads to a buffered commit


    joinProject() {
      this.invalidate();
    } // Trigger a buffered commit when leaving the project


    leaveProject(isReplacing = false) {
      var _a;

      superProto.leaveProject.call(this, isReplacing);
      (_a = this.project) === null || _a === void 0 ? void 0 : _a.bufferedCommitAsync();
    }
    /**
     * Invalidates this record, queueing it for calculation on project commit.
     */


    invalidate() {
      var _a;

      (_a = this.project) === null || _a === void 0 ? void 0 : _a.invalidate(this);
    }
    /**
     * Used to retrieve the proposed (before 'dataReady') or current (after 'dataReady') value for a field.
     * If there is no proposed change, it is functionally equal to a normal `record.get()` call.
     */


    getCurrentOrProposed(fieldName) {
      var _a;

      if (fieldName in this.$changed) {
        return this.$changed[fieldName];
      }

      return (_a = this.get(fieldName)) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Determines if the specified field has a value or not, value can be either current or proposed.
     */


    hasCurrentOrProposed(fieldName) {
      return this.$changed[fieldName] != null || this.get(fieldName) != null;
    }
    /**
     * Propose changes, to be considered during calculation. Also invalidates the record.
     */


    propose(changes) {
      const keys = Object.keys(changes);

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        this.$changed[key] = changes[key];
      }

      this.invalidate();
    }
    /**
     * Similar to propose, but with more options. Mostly used by buckets, since they need data to update early.
     */


    setChanged(field, value, invalidate = true, setData = false) {
      const me = this;
      me.$changed[field] = value; // Buckets need to keep data up to date immediately

      if (setData) {
        if (!(field in me.$beforeChange)) {
          me.$beforeChange[field] = me.get(field);
        }

        me.setData(field, value);
      }

      invalidate && me.invalidate();
    }
    /**
     * Hook called before project refresh, override and calculate required changes in subclasses
     */


    calculateInvalidated() {}
    /**
     * Called after project refresh, before dataReady. Announce updated data
     */


    finalizeInvalidated(silent = false) {
      const me = this;
      me.$isCalculating = true;

      if (!silent) {
        // First silently revert any data change (used by buckets), otherwise it wont be detected by `set()`
        me.setData(me.$beforeChange); // Then do a proper set

        me.set(me.$changed);
      } else {
        me.setData(me.$changed);
      }

      me.$changed = {};
      me.$beforeChange = {};
      me.$isCalculating = false;
    }

  }

  return CorePartOfProjectModelMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js":
/*!**********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js ***!
  \**********************************************************************/
/*! exports provided: CoreAssignmentMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreAssignmentMixin", function() { return CoreAssignmentMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
/* harmony import */ var _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CoreResourceMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js");
var productName = 'taskboard';




/**
 * Core assignment model class. It just contains references to the [[CoreEventMixin|event]] and [[CoreResourceMixin|resource]] being assigned.
 */

class CoreAssignmentMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CoreAssignmentMixin extends base {
    // Fields declared in the Model way, existing decorators all assume ChronoGraph is used
    static get fields() {
      return [// isEqual required to properly detect changed resource / event
      {
        name: 'resource',
        isEqual: (a, b) => a === b,
        persist: false
      }, {
        name: 'event',
        isEqual: (a, b) => a === b,
        persist: false
      }];
    } // Resolve early + update indices to have buckets ready before commit


    setChanged(field, value, invalidate) {
      const {
        assignmentStore,
        eventStore,
        resourceStore,
        project
      } = this;
      let update = false;

      if (field === 'event') {
        const event = Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(value, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"]) ? value : eventStore === null || eventStore === void 0 ? void 0 : eventStore.getById(value);
        if (event) update = true;
        value = event || value;
      }

      if (field === 'resource') {
        const resource = Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(value, _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_3__["CoreResourceMixin"]) ? value : resourceStore === null || resourceStore === void 0 ? void 0 : resourceStore.getById(value);
        if (resource) update = true;
        value = resource || value;
      } // Passing true as last arg, bucket expected to work before commit


      superProto.setChanged.call(this, field, value, invalidate, true); // Update on resolve, if this is a single operation and record is part of project (might be standalone record)

      if (assignmentStore && update && !project.isPerformingCommit && !assignmentStore.isLoadingData && !resourceStore.isLoadingData && !assignmentStore.skipInvalidateIndices) {
        assignmentStore.invalidateIndices();
      }
    } // Resolve event and resource when joining project


    joinProject() {
      superProto.joinProject.call(this);
      this.setChanged('event', this.get('event'));
      this.setChanged('resource', this.get('resource'));
    } // Resolved resource & event as part of commit
    // Normally done earlier in setChanged, but stores might not have been available yet at that point


    calculateInvalidated() {
      var _a, _b; // Changed values, should be used instead of current where available


      let {
        event = this.event,
        resource = this.resource
      } = this.$changed;

      if (event !== null && !Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(event, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"])) {
        const resolved = (_a = this.eventStore) === null || _a === void 0 ? void 0 : _a.getById(event);
        if (resolved) this.setChanged('event', resolved, false);
      }

      if (resource !== null && !Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(resource, _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_3__["CoreResourceMixin"])) {
        const resolved = (_b = this.resourceStore) === null || _b === void 0 ? void 0 : _b.getById(resource);
        if (resolved) this.setChanged('resource', resolved, false);
      }
    } // resourceId and eventId required to be available for new datasets


    finalizeInvalidated(silent) {
      var _a, _b;

      if ((_a = this.$changed.resource) === null || _a === void 0 ? void 0 : _a.isModel) this.$changed.resourceId = this.$changed.resource.id;
      if ((_b = this.$changed.event) === null || _b === void 0 ? void 0 : _b.isModel) this.$changed.eventId = this.$changed.event.id;
      superProto.finalizeInvalidated.call(this, silent);
    } //region Event


    set event(event) {
      this.setChanged('event', event);
    }

    get event() {
      const event = this.get('event'); // Engine returns null instead of id when unresolved

      return Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(event, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"]) ? event : null;
    } //endregion
    //region Resource


    set resource(resource) {
      this.setChanged('resource', resource);
    }

    get resource() {
      const resource = this.get('resource'); // Engine returns null instead of id when unresolved

      return Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["isInstanceOf"])(resource, _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_3__["CoreResourceMixin"]) ? resource : null;
    }

  }

  return CoreAssignmentMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreCalendarMixin.js":
/*!********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreCalendarMixin.js ***!
  \********************************************************************/
/*! exports provided: CoreCalendarMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreCalendarMixin", function() { return CoreCalendarMixin; });
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _AbstractCalendarMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../AbstractCalendarMixin.js */ "./lib/Engine/quark/model/AbstractCalendarMixin.js");
var productName = 'taskboard';



/**
 * The calendar for project scheduling, it is used to mark certain time intervals as "non-working" and ignore them during scheduling.
 *
 * The calendar consists from several [[CalendarIntervalMixin|intervals]]. The intervals can be either static or recurrent.
 */

class CoreCalendarMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_AbstractCalendarMixin_js__WEBPACK_IMPORTED_MODULE_2__["AbstractCalendarMixin"], _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_0__["CorePartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CoreCalendarMixin extends base {}

  return CoreCalendarMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js":
/*!**********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js ***!
  \**********************************************************************/
/*! exports provided: CoreDependencyMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreDependencyMixin", function() { return CoreDependencyMixin; });
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
var productName = 'taskboard';




class CoreDependencyMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_0__["CorePartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CoreDependencyMixin extends base {
    static get fields() {
      return [{
        name: 'fromEvent',
        isEqual: (a, b) => a === b,
        persist: false
      }, {
        name: 'toEvent',
        isEqual: (a, b) => a === b,
        persist: false
      }];
    } // Resolve early + update indices to have buckets ready before commit


    setChanged(field, value, invalidate) {
      var _a, _b, _c;

      let update = false;

      if (field === 'fromEvent' || field === 'toEvent') {
        const event = Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_3__["isInstanceOf"])(value, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"]) ? value : (_a = this.eventStore) === null || _a === void 0 ? void 0 : _a.getById(value);
        if (event) update = true;
        value = event || value;
      }

      superProto.setChanged.call(this, field, value, invalidate, true);

      if (update && !this.project.isPerformingCommit && !((_b = this.dependencyStore) === null || _b === void 0 ? void 0 : _b.isLoadingData)) {
        // TODO: Improve Collection indexing to handle smaller updates
        (_c = this.dependencyStore) === null || _c === void 0 ? void 0 : _c.invalidateIndices();
      }
    } // Resolve events when joining project


    joinProject() {
      superProto.joinProject.call(this); // Initial values should be considered changed, to be normalized
      // (needs to pass through setChanged for early normalization expected for buckets)

      this.setChanged('fromEvent', this.get('fromEvent'));
      this.setChanged('toEvent', this.get('toEvent'));
    } // Resolved events as part of commit
    // Normally done earlier in setChanged, but stores might not have been available yet at that point


    calculateInvalidated() {
      var _a, _b; // Changed values, should be used instead of current where available


      let {
        fromEvent,
        toEvent
      } = this.$changed;

      if (fromEvent !== null && !Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_3__["isInstanceOf"])(fromEvent, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"])) {
        const resolved = (_a = this.eventStore) === null || _a === void 0 ? void 0 : _a.getById(fromEvent);
        if (resolved) this.$changed.fromEvent = resolved;
      }

      if (toEvent !== null && !Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_3__["isInstanceOf"])(toEvent, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"])) {
        const resolved = (_b = this.eventStore) === null || _b === void 0 ? void 0 : _b.getById(toEvent);
        if (resolved) this.$changed.toEvent = resolved;
      }
    } //region Events
    // Not using "propose" mechanism from CoreEventMixin, because buckets are expected to be up to date right away


    set fromEvent(fromEvent) {
      this.setChanged('fromEvent', fromEvent);
    }

    get fromEvent() {
      const fromEvent = this.get('fromEvent'); // Engine returns null instead of id when unresolved

      return Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_3__["isInstanceOf"])(fromEvent, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"]) ? fromEvent : null;
    }

    set toEvent(toEvent) {
      this.setChanged('toEvent', toEvent);
    }

    get toEvent() {
      const toEvent = this.get('toEvent'); // Engine returns null instead of id when unresolved

      return Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_3__["isInstanceOf"])(toEvent, _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreEventMixin"]) ? toEvent : null;
    }

  }

  return CoreDependencyMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js":
/*!*****************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js ***!
  \*****************************************************************/
/*! exports provided: CoreEventMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreEventMixin", function() { return CoreEventMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'taskboard';



/**
 * Core event entity mixin type.
 *
 * At this level event is only aware about its dates
 * The functionality, related to the assignments etc is provided in other mixins.
 */

class CoreEventMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CoreEventMixin extends base {
    constructor() {
      super(...arguments);
      this._startDate = null;
      this._endDate = null;
      this._duration = null;
    } // Proper engine defines these fields since they enter graph, thus we need them


    static get fields() {
      return [{
        name: 'startDate',
        type: 'date'
      }, {
        name: 'endDate',
        type: 'date'
      }, {
        name: 'duration',
        type: 'number'
      }, {
        name: 'durationUnit',
        type: 'string',
        defaultValue: 'day'
      }];
    } // Getters return current or proposed value


    get startDate() {
      var _a, _b;

      return (_b = (_a = this._startDate) !== null && _a !== void 0 ? _a : this.get('startDate')) !== null && _b !== void 0 ? _b : null;
    }

    get endDate() {
      var _a, _b;

      return (_b = (_a = this._endDate) !== null && _a !== void 0 ? _a : this.get('endDate')) !== null && _b !== void 0 ? _b : null;
    }

    get duration() {
      var _a, _b;

      return (_b = (_a = this._duration) !== null && _a !== void 0 ? _a : this.get('duration')) !== null && _b !== void 0 ? _b : null;
    } // Route all setting through applyXX (setStartDate, startDate = , set('startDate'), batching)


    set startDate(value) {
      this.proposeStartDate(value);
    }

    set endDate(value) {
      this.proposeEndDate(value);
    }

    set duration(value) {
      this.proposeDuration(value);
    } //region Edge case normalization


    inSet(field, ...args) {
      var _a, _b, _c;

      const me = this;

      if (typeof field !== 'string') {
        const setStartDate = ('startDate' in field);
        const setEndDate = ('endDate' in field);
        const setDuration = ('duration' in field); // When given a start and end date but no duration we expect the duration to be calculated, but if
        // the supplied end date equals the current end date it will be considered a no-op and it will
        // erroneously keep the duration

        if (setStartDate && setEndDate && !setDuration) {
          // @ts-ignore
          const startDate = CoreEventMixin.processField('startDate', field.startDate, me); // @ts-ignore

          const endDate = CoreEventMixin.processField('endDate', field.endDate, me);

          if ((startDate === null || startDate === void 0 ? void 0 : startDate.getTime()) !== ((_a = me.startDate) === null || _a === void 0 ? void 0 : _a.getTime()) && (endDate === null || endDate === void 0 ? void 0 : endDate.getTime()) === ((_b = me.endDate) === null || _b === void 0 ? void 0 : _b.getTime())) {
            me.proposeDuration(null);
            me.proposeEndDate(field.endDate);
          }
        } // When given a duration and end date but no start we expect the duration to be calculated, but if
        // the supplied end date equals the current end date it will be considered a no-op and it will
        // erroneously keep the start date


        if (!setStartDate && setEndDate && setDuration) {
          // @ts-ignore
          const endDate = CoreEventMixin.processField('endDate', field.endDate, me);

          if (field.duration !== me.duration && (endDate === null || endDate === void 0 ? void 0 : endDate.getTime()) === ((_c = me.endDate) === null || _c === void 0 ? void 0 : _c.getTime())) {
            me.proposeStartDate(null);
            me.proposeEndDate(field.endDate);
          }
        }
      } // @ts-ignore


      return superProto.inSet.call(me, field, ...args);
    } //endregion
    //region StartDate


    getStartDate() {
      return this.startDate;
    }

    proposeStartDate(startDate, keepDuration = true) {
      this._startDate = startDate;
      this.propose({
        startDate,
        keepDuration
      });
    }

    async setStartDate(startDate, keepDuration = true) {
      var _a;

      this.proposeStartDate(startDate, keepDuration);
      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync();
    } //endregion
    //region EndDate


    getEndDate() {
      return this.endDate;
    }

    proposeEndDate(endDate, keepDuration = false) {
      this._endDate = endDate;
      this.propose({
        endDate,
        keepDuration
      });
    }

    async setEndDate(endDate, keepDuration = false) {
      var _a;

      this.proposeEndDate(endDate, keepDuration);
      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync();
    } //endregion
    //region Duration


    getDuration() {
      return this.duration;
    }

    proposeDuration(duration, unit, keepStart = true) {
      this._duration = duration;
      this.propose({
        duration,
        keepStart
      });
      if (unit) this.propose({
        durationUnit: unit
      });
    }

    async setDuration(duration, unit, keepStart = true) {
      var _a;

      this.proposeDuration(duration, unit, keepStart);
      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.commitAsync();
    }

    getDurationUnit() {
      return this.durationUnit;
    } //endregion
    // When joining as part of inline data, store is available. If joining through load, it is passed


    joinProject() {
      var _a, _b;

      const me = this;
      const changed = me.$changed;
      const startDate = me.getCurrentOrProposed('startDate');
      const endDate = me.getCurrentOrProposed('endDate');
      const duration = me.getCurrentOrProposed('duration'); // Initial values should be considered changed, to be normalized

      if (startDate != null) changed.startDate = me._startDate = startDate;
      if (endDate != null) changed.endDate = me._endDate = endDate;
      if (duration != null) changed.duration = me._duration = duration; // Resolve assignments when event joins project after load

      if (me.eventStore && !me.eventStore.isLoadingData) {
        const unresolved = (_a = me.assignmentStore) === null || _a === void 0 ? void 0 : _a.storage.findItem('event', null);

        if (unresolved) {
          // To avoid n² iterations over raw assignments we cache them by raw eventId, which saves us
          // some iterations over the storage
          // https://github.com/bryntum/support/issues/3141
          const cachedAssignments = (_b = me.assignmentStore) === null || _b === void 0 ? void 0 : _b.storage.findItem('eventId', me.id);

          if (cachedAssignments) {
            for (const assignment of cachedAssignments) {
              assignment.setChanged('event', me);
            }
          } else {
            for (const assignment of unresolved) {
              if (assignment.getCurrentOrProposed('event') === me.id) {
                assignment.setChanged('event', me);
              }
            }
          }
        }
      }

      superProto.joinProject.call(me);
    } // Mimic how proper engine applies values


    applyValue(useProp, key, value, skipAccessors, field) {
      if (key === 'startDate' || key == 'duration' || key === 'endDate') {
        useProp = true; // Update cached value

        this['_' + key] = value;
      }

      if (skipAccessors) {
        useProp = false;
      }

      superProto.applyValue.call(this, useProp, key, value, skipAccessors, field);
    } // Catch changes from batches etc. In which case it is sometimes expected for data to be available directly


    afterChange(toSet, wasSet, silent, fromRelationUpdate, skipAccessors) {
      if (!this.$isCalculating && !skipAccessors) {
        // In certain scenarios data is expected to be available of the bat, messy!
        this.setData(this.$changed);
      }

      superProto.afterChange.call(this, toSet, wasSet, silent, fromRelationUpdate, skipAccessors);
    } // Normalizes dates & duration


    calculateInvalidated() {
      const me = this;
      const changed = me.$changed;
      const changedStart = ('startDate' in changed);
      const changedEnd = ('endDate' in changed);
      const changedDuration = ('duration' in changed);
      const {
        startDate,
        endDate,
        duration,
        keepDuration,
        keepStart
      } = changed;
      let calculate = null; // Only start changed

      if (changedStart && !changedEnd && !changedDuration) {
        // Also null end when nulling start (keeping duration)
        if (startDate === null) {
          changed.endDate = null;
        } // Start after end without keeping duration -> move end to start
        else if (me.hasCurrentOrProposed('endDate') && startDate > me.getCurrentOrProposed('endDate') && !keepDuration) {
          changed.endDate = startDate;
          changed.duration = 0;
        } // Start changed and we either have a duration that we want to keep or no end -> calculate end
        else if (me.hasCurrentOrProposed('duration') && (keepDuration || !me.hasCurrentOrProposed('endDate'))) {
          calculate = 'endDate';
        } // Start change and we have an end already -> calculate duration
        else if (me.hasCurrentOrProposed('endDate')) {
          calculate = 'duration';
        }
      } // Only end changed
      else if (!changedStart && changedEnd && !changedDuration) {
        // Also null start when nulling end (keeping duration)
        if (endDate === null) {
          changed.startDate = null;
        } // End before start without keeping duration -> move start to end
        else if (me.hasCurrentOrProposed('startDate') && endDate < me.getCurrentOrProposed('startDate') && !keepDuration) {
          changed.startDate = endDate;
          changed.duration = 0;
        } // End changed and we either have a duration that we want to keep or no start -> calculate start
        else if (me.hasCurrentOrProposed('duration') && (keepDuration || !me.hasCurrentOrProposed('startDate'))) {
          calculate = 'startDate';
        } // End changed and we have a start already -> calculate duration
        else if (me.hasCurrentOrProposed('startDate')) {
          calculate = 'duration';
        }
      } // Only duration changed
      else if (!changedStart && !changedEnd && changedDuration) {
        // Also null end when nulling duration (keeping start)
        if (duration === null) {
          changed.endDate = null;
        } // Duration changed and we either have a start that we want to keep or no end -> calculate end
        else if (me.hasCurrentOrProposed('startDate') && (keepStart || !me.hasCurrentOrProposed('endDate'))) {
          if (keepStart && changed.duration < 0) {
            changed.duration = 0;
          }

          calculate = 'endDate';
        } // Duration changed and we have an end already -> calculate start
        else if (me.hasCurrentOrProposed('endDate')) {
          calculate = 'startDate';
        }
      } // Start and end change, affect duration
      else if (changedStart && changedEnd && !changedDuration) {
        // Both nulled, null duration
        if (startDate === null && endDate === null) {
          changed.duration = null;
        } // Other cases -> calculate duration
        else {
          calculate = 'duration';
        }
      } // Start and duration change -> calculate end
      else if (changedStart && !changedEnd && changedDuration) {
        calculate = 'endDate';
      } // End and duration changed -> calculate start
      else if (!changedStart && changedEnd && changedDuration) {
        calculate = 'startDate';
      } // All changed -> calculate whichever is null or by default end to be sure things add up
      else if (changedStart && changedEnd && changedDuration) {
        if (duration == null) {
          calculate = 'duration';
        } else if (startDate == null) {
          calculate = 'startDate';
        } else {
          calculate = 'endDate';
        }
      } // Normalize if needed


      const currentOrProposedStartDate = me.getCurrentOrProposed('startDate');
      const currentOrProposedEndDate = me.getCurrentOrProposed('endDate');
      const currentOrProposedDuration = me.getCurrentOrProposed('duration');
      const currentOrProposedDurationUnit = me.getCurrentOrProposed('durationUnit');
      let hourDuration, targetDuration;

      switch (calculate) {
        case 'startDate':
          changed.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(currentOrProposedEndDate, -currentOrProposedDuration, currentOrProposedDurationUnit);
          break;

        case 'endDate':
          // convert proposed duration to hours to safely add over DST
          hourDuration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].as('hour', currentOrProposedDuration, currentOrProposedDurationUnit); // convert calculated duration to task duration in task duration unit

          targetDuration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].as(currentOrProposedDurationUnit, hourDuration, 'h');
          changed.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(currentOrProposedStartDate, targetDuration, currentOrProposedDurationUnit);
          break;

        case 'duration':
          // convert proposed duration to hours to safely add over DST
          hourDuration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(currentOrProposedStartDate, currentOrProposedEndDate, 'h'); // convert calculated duration to task duration in task duration unit

          changed.duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].as(currentOrProposedDurationUnit, hourDuration, 'h');
          break;
      }

      if (changed.startDate !== undefined) this._startDate = changed.startDate;
      if (changed.endDate !== undefined) this._endDate = changed.endDate;
      if (changed.duration !== undefined) this._duration = changed.duration;
      delete changed.keepDuration;
      delete changed.keepStart;
    }

  }

  return CoreEventMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreHasAssignmentsMixin.js":
/*!**************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreHasAssignmentsMixin.js ***!
  \**************************************************************************/
/*! exports provided: CoreHasAssignmentsMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreHasAssignmentsMixin", function() { return CoreHasAssignmentsMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _AbstractHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../AbstractHasAssignmentsMixin.js */ "./lib/Engine/quark/model/AbstractHasAssignmentsMixin.js");
var productName = 'taskboard';




/**
 * This is a mixin, which can be applied to the [[CoreEventMixin]]. It provides the collection of all assignments,
 * which reference this event.
 *
 * Doesn't affect scheduling.
 */

class CoreHasAssignmentsMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_1__["CoreEventMixin"], _AbstractHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractHasAssignmentsMixin"]], base => {
  const superProto = base.prototype;

  class CoreHasAssignmentsMixin extends base {
    get assigned() {
      var _a;

      const assignments = (_a = this.project) === null || _a === void 0 ? void 0 : _a.assignmentStore.getEventsAssignments(this); // Expected to still be able to return assignments when removed from project

      if (!assignments) {
        return this.$cachedAssignments;
      }

      return this.$cachedAssignments = assignments;
    }

    applyValue(useProp, key, value, skipAccessor, field) {
      var _a; // Changing id on an event should update resourceId on its assignments


      if (key === 'id') {
        (_a = this.assigned) === null || _a === void 0 ? void 0 : _a.forEach(assignment => assignment.set('eventId', value));
      }

      superProto.applyValue.call(this, useProp, key, value, skipAccessor, field);
    }

    copy(newId = null, deep = null) {
      const copy = superProto.copy.call(this, newId, deep); // If deep is everything but object - use default behavior, which is to invoke accessors
      // If deep is an object, check if it has certain field disabled

      if (_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isObject(deep) && !deep.skipFieldIdentifiers || !_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isObject(deep)) {
        // Copy current assignments, used for occurrences
        copy.$cachedAssignments = this.assigned;
      }

      return copy;
    }

  }

  return CoreHasAssignmentsMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreHasDependenciesMixin.js":
/*!***************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreHasDependenciesMixin.js ***!
  \***************************************************************************/
/*! exports provided: CoreHasDependenciesMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreHasDependenciesMixin", function() { return CoreHasDependenciesMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
var productName = 'taskboard';


/**
 * This is a mixin, which can be applied to the [[CoreEventMixin]]. It provides the collection of all dependencies,
 * which reference this event.
 *
 * Doesn't affect scheduling.
 */

class CoreHasDependenciesMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_1__["CoreEventMixin"]], base => {
  const superProto = base.prototype;

  class CoreHasDependenciesMixin extends base {
    get outgoingDeps() {
      return this.project.dependencyStore.getOutgoingDepsForEvent(this);
    }

    get incomingDeps() {
      return this.project.dependencyStore.getIncomingDepsForEvent(this);
    }

    leaveProject() {
      const eventStore = this.eventStore; // the buckets may be empty if a model is removed from the project immediately after adding
      // (without propagation)

      if (this.outgoingDeps) {
        this.outgoingDeps.forEach(dependency => eventStore.dependenciesForRemoval.add(dependency));
      }

      if (this.incomingDeps) {
        this.incomingDeps.forEach(dependency => eventStore.dependenciesForRemoval.add(dependency));
      }

      superProto.leaveProject.call(this);
    }

  }

  return CoreHasDependenciesMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js":
/*!********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js ***!
  \********************************************************************/
/*! exports provided: CoreResourceMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreResourceMixin", function() { return CoreResourceMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mixin/CorePartOfProjectModelMixin.js */ "./lib/Engine/quark/model/mixin/CorePartOfProjectModelMixin.js");
var productName = 'taskboard';


/**
 * Core resource model class.
 */

class CoreResourceMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_CorePartOfProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectModelMixin"]], base => {
  const superProto = base.prototype;

  class CoreResourceMixin extends base {
    get assigned() {
      var _a;

      return (_a = this.project) === null || _a === void 0 ? void 0 : _a.assignmentStore.getResourcesAssignments(this);
    }

    joinProject() {
      var _a; // Set up assignment -> resource mapping when joining store after assignment (skip during load)
      // (note that there is no resourceStore yet when loading inline data, thus the first part of the condition)


      if (this.resourceStore && !this.resourceStore.isLoadingData) {
        (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.query(a => a.get('resource') === this.id).forEach(unresolved => unresolved.setChanged('resource', this));
      }

      superProto.joinProject.call(this);
    }

    leaveProject(isReplacing = false) {
      // `this.assigned` will be empty if model is added to project and then removed immediately
      // w/o any propagations
      // when replacing a resource, the assignments should be left intact
      if (this.assigned && !isReplacing) {
        const resourceStore = this.resourceStore; // to batch the assignments removal, we don't remove the assignments right away, but instead
        // add them for the batched removal to the `assignmentsForRemoval` property of the event store

        this.assigned.forEach(assignment => resourceStore.assignmentsForRemoval.add(assignment));
      }

      superProto.leaveProject.call(this);
    }

    applyValue(useProp, key, value, skipAccessor, field) {
      // Changing id on a resource should update resourceId on its assignments
      // (note that field might not exist, if user supplies data for undefined fields)
      if ((field === null || field === void 0 ? void 0 : field.name) === 'id') {
        this.assigned.forEach(assignment => {
          assignment.set('resourceId', value);
        });
      }

      superProto.applyValue.call(this, useProp, key, value, skipAccessor, field);
    }

  }

  return CoreResourceMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js ***!
  \*********************************************************************/
/*! exports provided: SchedulerCoreEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerCoreEvent", function() { return SchedulerCoreEvent; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CoreEventMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreEventMixin.js");
/* harmony import */ var _CoreHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CoreHasAssignmentsMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreHasAssignmentsMixin.js");
/* harmony import */ var _CoreHasDependenciesMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CoreHasDependenciesMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreHasDependenciesMixin.js");
var productName = 'taskboard';




/**
 * This is an event class, [[SchedulerCoreProjectMixin]] is working with.
 * It is constructed as [[CoreEventMixin]], enhanced with [[CoreHasAssignmentsMixin]] and [[CoreHasDependenciesMixin]]
 */

class SchedulerCoreEvent extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_CoreEventMixin_js__WEBPACK_IMPORTED_MODULE_1__["CoreEventMixin"], _CoreHasAssignmentsMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreHasAssignmentsMixin"], _CoreHasDependenciesMixin_js__WEBPACK_IMPORTED_MODULE_3__["CoreHasDependenciesMixin"]], base => {
  const superProto = base.prototype;

  class SchedulerCoreEvent extends base {}

  return SchedulerCoreEvent;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreProjectMixin.js":
/*!****************************************************************************!*\
  !*** ./lib/Engine/quark/model/scheduler_core/SchedulerCoreProjectMixin.js ***!
  \****************************************************************************/
/*! exports provided: EventsWrapper, DelayableWrapper, SchedulerCoreProjectMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventsWrapper", function() { return EventsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DelayableWrapper", function() { return DelayableWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulerCoreProjectMixin", function() { return SchedulerCoreProjectMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./SchedulerCoreEvent.js */ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../store/CoreEventStoreMixin.js */ "./lib/Engine/quark/store/CoreEventStoreMixin.js");
/* harmony import */ var _CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CoreAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js");
/* harmony import */ var _store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../store/CoreAssignmentStoreMixin.js */ "./lib/Engine/quark/store/CoreAssignmentStoreMixin.js");
/* harmony import */ var _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./CoreResourceMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js");
/* harmony import */ var _store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../store/CoreResourceStoreMixin.js */ "./lib/Engine/quark/store/CoreResourceStoreMixin.js");
/* harmony import */ var _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../CorePartOfProjectGenericMixin.js */ "./lib/Engine/quark/CorePartOfProjectGenericMixin.js");
/* harmony import */ var _store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../store/CoreDependencyStoreMixin.js */ "./lib/Engine/quark/store/CoreDependencyStoreMixin.js");
/* harmony import */ var _CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./CoreDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js");
/* harmony import */ var _CoreCalendarMixin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./CoreCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreCalendarMixin.js");
/* harmony import */ var _store_CoreCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../store/CoreCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/CoreCalendarManagerStoreMixin.js");
/* harmony import */ var _util_Functions_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../util/Functions.js */ "./lib/Engine/util/Functions.js");
/* harmony import */ var _Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../../Core/data/stm/StateTrackingManager.js */ "./lib/Core/data/stm/StateTrackingManager.js");
/* harmony import */ var _AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../AbstractProjectMixin.js */ "./lib/Engine/quark/model/AbstractProjectMixin.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';




















class EventsWrapper extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([], _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_4__["default"]) {}
class DelayableWrapper extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([], _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {}
/**
 * This is a project, implementing _basic scheduling_ as [[SchedulerBasicProjectMixin]] does.
 * Yet this class does not use _chronograph_ based engine.
 */

class SchedulerCoreProjectMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractProjectMixin_js__WEBPACK_IMPORTED_MODULE_18__["AbstractProjectMixin"], _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_11__["CorePartOfProjectGenericMixin"], EventsWrapper, DelayableWrapper, _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_3__["default"]], base => {
  const superProto = base.prototype;

  class SchedulerCoreProjectMixin extends base {
    static get defaultConfig() {
      return {
        stm: {},
        eventStore: {},
        assignmentStore: {},
        resourceStore: {},
        dependencyStore: {},
        calendarManagerStore: {},
        eventModelClass: _SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_1__["SchedulerCoreEvent"],
        assignmentModelClass: _CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_7__["CoreAssignmentMixin"],
        resourceModelClass: _CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_9__["CoreResourceMixin"],
        dependencyModelClass: _CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_13__["CoreDependencyMixin"],
        calendarModelClass: _CoreCalendarMixin_js__WEBPACK_IMPORTED_MODULE_14__["CoreCalendarMixin"],
        eventStoreClass: _store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_6__["CoreEventStoreMixin"],
        assignmentStoreClass: _store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_8__["CoreAssignmentStoreMixin"],
        resourceStoreClass: _store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_10__["CoreResourceStoreMixin"],
        dependencyStoreClass: _store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_12__["CoreDependencyStoreMixin"],
        calendarManagerStoreClass: _store_CoreCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_15__["CoreCalendarManagerStoreMixin"],
        assignmentsData: null,
        calendarsData: null,
        dependenciesData: null,
        eventsData: null,
        resourcesData: null
      };
    } //endregion
    //region Init


    construct(config = {}) {
      // Cannot be created with declaration, because of how TS is compiled to JS. Ends up after `construct()`
      this.$invalidated = new Set(); // Define default values for these flags here
      // if defined where declared then TS compiles them this way:
      // constructor() {
      //     super(...arguments)
      //     this.isPerformingCommit   = false
      //     this.silenceInitialCommit = true
      //     this.ongoing              = Promise.resolve()
      // }
      // which messes the flags values for inline data loading (since it's async)

      this.isPerformingCommit = false;
      this.silenceInitialCommit = true;
      this.ongoing = Promise.resolve();
      superProto.construct.call(this, config); // not part of the CalendarManagerStore intentionally, not persisted

      this.defaultCalendar = new this.calendarManagerStore.modelClass({
        unspecifiedTimeIsWorking: this.unspecifiedTimeIsWorking
      });
      this.defaultCalendar.project = this;
      const {
        calendarsData,
        eventsData,
        dependenciesData,
        resourcesData,
        assignmentsData
      } = this;
      const hasInlineData = Boolean(calendarsData || eventsData || dependenciesData || resourcesData || assignmentsData);

      if (hasInlineData) {
        this.loadInlineData({
          calendarsData,
          eventsData,
          dependenciesData,
          resourcesData,
          assignmentsData
        });
        delete this.calendarsData;
        delete this.eventsData;
        delete this.dependenciesData;
        delete this.resourcesData;
        delete this.assignmentsData;
      } else {
        // Trigger initial commit
        this.bufferedCommitAsync();
      }
    }

    doDestroy() {
      var _a, _b, _c, _d, _e, _f;

      const me = this;
      (_a = me.eventStore) === null || _a === void 0 ? void 0 : _a.destroy();
      (_b = me.dependencyStore) === null || _b === void 0 ? void 0 : _b.destroy();
      (_c = me.assignmentStore) === null || _c === void 0 ? void 0 : _c.destroy();
      (_d = me.resourceStore) === null || _d === void 0 ? void 0 : _d.destroy();
      (_e = me.calendarManagerStore) === null || _e === void 0 ? void 0 : _e.destroy();
      me.defaultCalendar.destroy();
      (_f = me.stm) === null || _f === void 0 ? void 0 : _f.destroy();
      superProto.doDestroy.call(this);
    }
    /**
     * This method loads the "raw" data into the project. The loading is basically happening by
     * assigning the individual data entries to the `data` property of the corresponding store.
     *
     * @param data
     */


    async loadInlineData(data) {
      this.isLoadingInlineData = true;

      if (data.calendarsData) {
        this.calendarManagerStore.data = data.calendarsData;
      }

      if (data.resourcesData) {
        this.resourceStore.data = data.resourcesData;
      }

      if (data.assignmentsData) {
        this.assignmentStore.data = data.assignmentsData;
      }

      if (data.eventsData) {
        this.eventStore.data = data.eventsData;
      }

      if (data.tasksData) {
        this.eventStore.data = data.tasksData;
      }

      if (data.dependenciesData) {
        this.dependencyStore.data = data.dependenciesData;
      }

      await this.commitLoad();
      this.isLoadingInlineData = false;
      return;
    } //endregion
    //region Join


    async commitLoad() {
      await this.commitAsync(); // Might have been destroyed during the async operation above

      if (!this.isDestroyed) this.trigger('load');
    }

    joinStoreRecords(store) {
      const fn = record => {
        record.setProject(this);
        record.joinProject();
      };

      if (store.rootNode) {
        store.rootNode.traverse(fn);
      } else {
        store.forEach(fn);
      }
    }

    unJoinStoreRecords(store) {
      const fn = record => {
        record.leaveProject();
        record.setProject(this);
      };

      if (store.rootNode) {
        store.rootNode.traverse(node => {
          // do not unjoin/leave project for the root node, which is the project itself
          if (node !== store.rootNode) fn(node);
        });
      } else {
        store.forEach(fn);
      }
    } //endregion
    //region EventStore


    resolveStoreAndModelClass(name, config) {
      // storeClass from supplied config or our properties
      const storeClass = (config === null || config === void 0 ? void 0 : config.storeClass) || this[`${name}StoreClass`]; // modelClass from supplied config

      let modelClass = config === null || config === void 0 ? void 0 : config.modelClass;

      if (!modelClass) {
        // or from storeClass.modelClass if customized
        // @ts-ignore
        if (this.getDefaultConfiguration()[`${name}ModelClass`] !== storeClass.getDefaultConfiguration().modelClass) {
          modelClass = storeClass.getDefaultConfiguration().modelClass;
        } // and if none of the above, use from our properties
        else {
          modelClass = this[`${name}ModelClass`];
        }
      }

      return {
        storeClass,
        modelClass
      };
    }

    get eventStore() {
      return this.$eventStore;
    }

    setEventStore(eventStore) {
      this.eventStore = eventStore;
    }

    set eventStore(eventStore) {
      const me = this;
      const {
        stm
      } = me;
      const oldStore = me.$eventStore;
      me.detachStore(oldStore);

      if (!(eventStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
        const {
          storeClass,
          modelClass
        } = me.resolveStoreAndModelClass('event', eventStore);
        eventStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign({
          modelClass,
          project: me,
          stm
        }, eventStore));
      } else {
        eventStore.project = me;
        stm.addStore(eventStore);
        me.joinStoreRecords(eventStore);
      }

      if (oldStore && stm.hasStore(oldStore)) {
        stm.removeStore(oldStore);
        me.unJoinStoreRecords(oldStore);
        const {
          assignmentsForRemoval
        } = oldStore; // remap the assignment

        assignmentsForRemoval.forEach(assignment => {
          const oldEvent = assignment.event;

          if (oldEvent) {
            const newEvent = eventStore.getById(oldEvent.id);

            if (newEvent) {
              assignment.event = newEvent; // keep the assignment

              assignmentsForRemoval.delete(assignment);
            }
          }
        });
        oldStore.afterEventRemoval();
      }

      eventStore.setProject(me);
      me.$eventStore = eventStore;
      me.attachStore(eventStore);
      me.trigger('eventStoreChange', {
        store: eventStore
      });
    } //endregion
    //region AssignmentStore


    get assignmentStore() {
      return this.$assignmentStore;
    }

    setAssignmentStore(assignmentStore) {
      this.assignmentStore = assignmentStore;
    }

    set assignmentStore(assignmentStore) {
      const me = this;
      const {
        stm
      } = me;
      const oldStore = me.$assignmentStore;
      me.detachStore(oldStore);

      if (oldStore && stm.hasStore(oldStore)) {
        stm.removeStore(oldStore);
        me.unJoinStoreRecords(oldStore);
      }

      if (!(assignmentStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
        const {
          storeClass,
          modelClass
        } = me.resolveStoreAndModelClass('assignment', assignmentStore);
        assignmentStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign({
          modelClass,
          project: me,
          stm
        }, assignmentStore));
      } else {
        assignmentStore.project = me;
        stm.addStore(assignmentStore);
        me.joinStoreRecords(assignmentStore);
      }

      assignmentStore.setProject(me);
      me.$assignmentStore = assignmentStore;
      me.attachStore(assignmentStore);
      me.trigger('assignmentStoreChange', {
        store: assignmentStore
      });
    } //endregion
    //region ResourceStore


    get resourceStore() {
      return this.$resourceStore;
    }

    setResourceStore(resourceStore) {
      this.resourceStore = resourceStore;
    }

    set resourceStore(resourceStore) {
      const me = this;
      const {
        stm
      } = me;
      const oldStore = me.$resourceStore;
      me.detachStore(oldStore);

      if (!(resourceStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
        const {
          storeClass,
          modelClass
        } = me.resolveStoreAndModelClass('resource', resourceStore);
        resourceStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign({
          modelClass,
          project: me,
          stm
        }, resourceStore));
      } else {
        resourceStore.project = me;
        stm.addStore(resourceStore);
        me.joinStoreRecords(resourceStore);
      }

      if (oldStore && stm.hasStore(oldStore)) {
        stm.removeStore(oldStore);
        me.unJoinStoreRecords(oldStore);
        const {
          assignmentsForRemoval
        } = oldStore; // remap the assignment

        assignmentsForRemoval.forEach(assignment => {
          const oldResource = assignment.resource;

          if (oldResource) {
            const newResource = resourceStore.getById(oldResource.id);

            if (newResource) {
              assignment.resource = newResource; // keep the assignment

              assignmentsForRemoval.delete(assignment);
            }
          }
        });
        oldStore.afterResourceRemoval();
      }

      resourceStore.setProject(me);
      me.$resourceStore = resourceStore;
      me.attachStore(resourceStore);
      me.trigger('resourceStoreChange', {
        store: resourceStore
      });
    } //endregion
    //region DependencyStore


    get dependencyStore() {
      return this.$dependencyStore;
    }

    setDependencyStore(dependencyStore) {
      this.dependencyStore = dependencyStore;
    }

    set dependencyStore(dependencyStore) {
      const me = this;
      const oldStore = me.$dependencyStore;
      me.detachStore(oldStore);

      if (!(dependencyStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
        const {
          storeClass,
          modelClass
        } = me.resolveStoreAndModelClass('dependency', dependencyStore);
        dependencyStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign({
          modelClass,
          project: me,
          stm: me.stm
        }, dependencyStore));
      } else {
        dependencyStore.project = me;
        me.stm.addStore(dependencyStore);
        me.joinStoreRecords(dependencyStore);
      }

      me.$dependencyStore = dependencyStore;
      me.attachStore(dependencyStore);
      me.trigger('dependencyStoreChange', {
        store: dependencyStore
      });
    } //endregion
    //region CalendarManagerStore


    get calendarManagerStore() {
      return this.$calendarManagerStore;
    }

    setCalendarManagerStore(calendarManagerStore) {
      this.calendarManagerStore = calendarManagerStore;
    }

    set calendarManagerStore(calendarManagerStore) {
      const me = this;
      const oldStore = me.$calendarManagerStore;
      me.detachStore(oldStore);

      if (!(calendarManagerStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"])) {
        // @ts-ignore
        const storeClass = (calendarManagerStore === null || calendarManagerStore === void 0 ? void 0 : calendarManagerStore.storeClass) || me.calendarManagerStoreClass; // @ts-ignore

        const modelClass = (calendarManagerStore === null || calendarManagerStore === void 0 ? void 0 : calendarManagerStore.modelClass) || storeClass.getDefaultConfiguration().modelClass || me.calendarModelClass;
        calendarManagerStore = new storeClass(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign({
          modelClass,
          project: me,
          stm: me.stm
        }, calendarManagerStore));
      } else {
        me.stm.addStore(calendarManagerStore);
      }

      calendarManagerStore.setProject(me);
      me.$calendarManagerStore = calendarManagerStore;
      me.attachStore(calendarManagerStore);
      me.trigger('calendarManagerStoreChange', {
        store: calendarManagerStore
      });
    } //endregion
    //region Calendar


    get calendar() {
      return this.$calendar || this.defaultCalendar;
    }

    set calendar(calendar) {
      this.$calendar = calendar;
    }

    get effectiveCalendar() {
      return this.calendar;
    } //endregion
    //region Add records


    async addEvent(event) {
      this.eventStore.add(event);
      return this.commitAsync();
    }

    async addAssignment(assignment) {
      this.assignmentStore.add(assignment);
      return this.commitAsync();
    }

    async addResource(resource) {
      this.resourceStore.add(resource);
      return this.commitAsync();
    }

    async addDependency(dependency) {
      this.dependencyStore.add(dependency);
      return this.commitAsync();
    } //endregion
    //region Auto commit
    // Buffer commitAsync using setTimeout. Not using `buffer` on purpose, for performance reasons and to better
    // mimic how graph does it


    bufferedCommitAsync() {
      if (!this.hasPendingAutoCommit) {
        this.setTimeout({
          fn: 'commitAsync',
          delay: 10
        });
      }
    }

    get hasPendingAutoCommit() {
      return this.hasTimeout('commitAsync');
    }

    unScheduleAutoCommit() {
      this.clearTimeout('commitAsync');
    } //endregion
    //region Commit


    async commitAsync() {
      if (this.isPerformingCommit) return this.ongoing;
      return this.ongoing = this.doCommitAsync();
    }

    async doCommitAsync() {
      const me = this;
      me.isPerformingCommit = true; // Cancel any outstanding commit

      me.unScheduleAutoCommit();
      await Object(_util_Functions_js__WEBPACK_IMPORTED_MODULE_16__["delay"])(0);

      if (!me.isDestroyed) {
        // Calculate all invalidated records, updates their data silently
        for (const record of me.$invalidated) {
          record.calculateInvalidated();
        }

        const {
          isInitialCommit,
          silenceInitialCommit
        } = me; // apply changes silently if this is initial commit and "silenceInitialCommit" option is enabled

        const silenceCommit = isInitialCommit && silenceInitialCommit; // Notify stores that care about commit (internal)

        me.assignmentStore.onCommitAsync();
        me.dependencyStore.onCommitAsync();
        me.isInitialCommitPerformed = true;
        me.hasLoadedDataToCommit = false;
        me.isPerformingCommit = false;
        const stores = [me.assignmentStore, me.dependencyStore, me.eventStore, me.resourceStore, me.calendarManagerStore];
        stores.forEach(store => {
          var _a;

          return (_a = store.suspendAutoCommit) === null || _a === void 0 ? void 0 : _a.call(store);
        });
        me.isWritingData = true; // "Real" project triggers refresh before data is written back to records

        me.trigger('refresh', {
          isInitialCommit
        }); // If we are not announcing changes, take a cheaper path

        if (silenceCommit) {
          for (const record of me.$invalidated) {
            record.finalizeInvalidated(true);
          }
        } else {
          // Two loops looks a bit weird, but needed since editing assignment might affect event etc.
          // And we do only want a single update in the end
          // 1. Start batches and perform all calculations
          for (const record of me.$invalidated) {
            record.beginBatch(true);
            record.finalizeInvalidated();
          } // 2. End batches, announcing changes (unless initial commit)


          for (const record of me.$invalidated) {
            record.endBatch(false, true);
          }
        }

        me.isWritingData = false;
        me.$invalidated.clear(); // Mimic real projects events

        me.trigger('dataReady');
        stores.forEach(store => {
          var _a;

          return (_a = store.resumeAutoCommit) === null || _a === void 0 ? void 0 : _a.call(store);
        });
        return true;
      }
    }

    async propagateAsync() {
      return this.commitAsync();
    } // Called when a record invalidates itself, queues it for calculation


    invalidate(record) {
      this.$invalidated.add(record);
      this.bufferedCommitAsync();
    } // this does not account for possible scheduling conflicts


    async isValidDependency(...args) {
      return true;
    } //endregion
    //region STM


    getStm() {
      return this.stm;
    }
    /**
     * State tracking manager instance the project relies on
     */


    set stm(stm) {
      stm = this.$stm = new _Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_17__["default"](_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].assign({
        disabled: true
      }, stm));
      stm.on({
        // Propagate on undo/redo
        restoringStop: async () => {
          // Disable STM meanwhile to not pick it up as a new STM transaction
          stm.disable();
          await this.commitAsync();

          if (!this.isDestroyed) {
            stm.enable();
            this.trigger('stateRestoringDone');
          }
        }
      });
    }

    get stm() {
      return this.$stm;
    } //endregion


    isEngineReady() {
      return !this.hasPendingAutoCommit && !this.isPerformingCommit && this.isInitialCommitPerformed;
    }

  } //region Config


  SchedulerCoreProjectMixin.applyConfigs = true;
  return SchedulerCoreProjectMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractAssignmentStoreMixin.js":
/*!****************************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractAssignmentStoreMixin.js ***!
  \****************************************************************/
/*! exports provided: AbstractAssignmentStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractAssignmentStoreMixin", function() { return AbstractAssignmentStoreMixin; });
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
/* harmony import */ var _util_Functions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/Functions.js */ "./lib/Engine/util/Functions.js");
var productName = 'taskboard';


 // Shared functionality for CoreAssignmentStore & ChronoAssignmentStore

class AbstractAssignmentStoreMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class AbstractAssignmentStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.assignmentsForRemoval = new Set();
      this.allAssignmentsForRemoval = false;
    }

    remove(records, silent) {
      this.assignmentsForRemoval = Object(_util_Functions_js__WEBPACK_IMPORTED_MODULE_2__["CIFromSetOrArrayOrValue"])(records).toSet();
      const res = superProto.remove.call(this, records);
      this.assignmentsForRemoval.clear();
      return res;
    }

    removeAll(silent) {
      this.allAssignmentsForRemoval = true;
      const res = superProto.removeAll.call(this, silent);
      this.allAssignmentsForRemoval = false;
      return res;
    }

  }

  return AbstractAssignmentStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractCalendarManagerStoreMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractCalendarManagerStoreMixin.js ***!
  \*********************************************************************/
/*! exports provided: AbstractCalendarManagerStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractCalendarManagerStoreMixin", function() { return AbstractCalendarManagerStoreMixin; });
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
var productName = 'taskboard';

 // Shared functionality for CoreCalendarManagerStoreMixin & ChronoCalendarManagerStoreMixin

class AbstractCalendarManagerStoreMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class AbstractCalendarManagerStoreMixin extends base {
    // special handling to destroy calendar models as part of destroying this store
    doDestroy() {
      const records = [];
      this.traverse(record => records.push(record));
      super.doDestroy();
      records.forEach(record => record.destroy());
    }

  }

  return AbstractCalendarManagerStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractDependencyStoreMixin.js":
/*!****************************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractDependencyStoreMixin.js ***!
  \****************************************************************/
/*! exports provided: AbstractDependencyStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractDependencyStoreMixin", function() { return AbstractDependencyStoreMixin; });
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
/* harmony import */ var _util_Functions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/Functions.js */ "./lib/Engine/util/Functions.js");
var productName = 'taskboard';


 // Shared functionality for CoreDependencyStore & ChronoDependencyStore

class AbstractDependencyStoreMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class AbstractDependencyStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.dependenciesForRemoval = new Set();
      this.allDependenciesForRemoval = false;
    }

    remove(records, silent) {
      this.dependenciesForRemoval = Object(_util_Functions_js__WEBPACK_IMPORTED_MODULE_2__["CIFromSetOrArrayOrValue"])(records).toSet();
      const res = superProto.remove.call(this, records);
      this.dependenciesForRemoval.clear();
      return res;
    }

    removeAll(silent) {
      this.allDependenciesForRemoval = true;
      const res = superProto.removeAll.call(this, silent);
      this.allDependenciesForRemoval = false;
      return res;
    }

  }

  return AbstractDependencyStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractEventStoreMixin.js":
/*!***********************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractEventStoreMixin.js ***!
  \***********************************************************/
/*! exports provided: AbstractEventStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractEventStoreMixin", function() { return AbstractEventStoreMixin; });
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
var productName = 'taskboard';

 // Shared functionality for CoreEventStore & ChronoEventStore

class AbstractEventStoreMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class AbstractEventStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.assignmentsForRemoval = new Set();
      this.dependenciesForRemoval = new Set();
    } // we need `onDataChange` for `syncDataOnLoad` option to work


    onDataChange(event) {
      var _a;

      super.onDataChange(event);
      if ((_a = event.removed) === null || _a === void 0 ? void 0 : _a.length) this.afterEventRemoval();
    } // it seems `onDataChange` is not triggered for `remove` with `silent` flag


    remove(records, silent) {
      const res = superProto.remove.call(this, records);
      this.afterEventRemoval();
      return res;
    } // it seems `onDataChange` is not triggered for `TreeStore#removeAll()`


    removeAll(silent) {
      const res = superProto.removeAll.call(this, silent);
      this.afterEventRemoval();
      return res;
    }

    afterEventRemoval() {
      const {
        assignmentsForRemoval,
        dependenciesForRemoval
      } = this; // Can be called from `set data` during construction

      if (!assignmentsForRemoval) return; // ORDER IS IMPORTANT!
      // First remove assignments

      const assignmentStore = this.getAssignmentStore();

      if (assignmentStore && !assignmentStore.allAssignmentsForRemoval && assignmentsForRemoval.size) {
        const toRemove = [...assignmentsForRemoval].filter(assignment => !assignmentStore.assignmentsForRemoval.has(assignment));
        toRemove.length > 0 && assignmentStore.remove(toRemove);
      }

      assignmentsForRemoval.clear(); // Then remove dependencies

      const dependencyStore = this.getDependencyStore();

      if (dependencyStore && !dependencyStore.allDependenciesForRemoval && dependenciesForRemoval.size) {
        const toRemove = [...dependenciesForRemoval].filter(dependency => !dependencyStore.dependenciesForRemoval.has(dependency));
        toRemove.length > 0 && dependencyStore.remove(toRemove);
      }

      dependenciesForRemoval.clear();
    }

    processRecord(eventRecord, isDataset = false) {
      var _a;

      if (!((_a = this.project) === null || _a === void 0 ? void 0 : _a.isRepopulatingStores)) {
        const existingRecord = this.getById(eventRecord.id);
        const isReplacing = existingRecord && existingRecord !== eventRecord;

        if (isReplacing) {
          // TODO: Type
          //@ts-ignore
          for (const assignment of existingRecord.assigned) {
            assignment.event = eventRecord;
          }
        }
      }

      return eventRecord;
    }

  }

  return AbstractEventStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/AbstractResourceStoreMixin.js":
/*!**************************************************************!*\
  !*** ./lib/Engine/quark/store/AbstractResourceStoreMixin.js ***!
  \**************************************************************/
/*! exports provided: AbstractResourceStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractResourceStoreMixin", function() { return AbstractResourceStoreMixin; });
/* harmony import */ var _ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/Mixin.js */ "./lib/ChronoGraph/class/Mixin.js");
/* harmony import */ var _mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
var productName = 'taskboard';

 // Shared functionality for CoreResourceStore & ChronoResourceStore

class AbstractResourceStoreMixin extends Object(_ChronoGraph_class_Mixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_mixin_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class AbstractResourceStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.assignmentsForRemoval = new Set();
    } // we need `onDataChange` for `syncDataOnLoad` option to work


    onDataChange(event) {
      var _a;

      super.onDataChange(event);
      if ((_a = event.removed) === null || _a === void 0 ? void 0 : _a.length) this.afterResourceRemoval();
    } // it seems `onDataChange` is not triggered for `remove` with `silent` flag


    remove(records, silent) {
      const res = superProto.remove.call(this, records);
      this.afterResourceRemoval();
      return res;
    } // it seems `onDataChange` is not triggered for `TreeStore#removeAll()`


    removeAll(silent) {
      const res = superProto.removeAll.call(this, silent);
      this.afterResourceRemoval();
      return res;
    }

    afterResourceRemoval() {
      // TODO: Ask nick, have tried making it get correct type by changing AbstractProjectMixin. But no luck
      const assignmentStore = this.getAssignmentStore();

      if (assignmentStore && !assignmentStore.allAssignmentsForRemoval) {
        const assignmentsForRemoval = [...this.assignmentsForRemoval].filter(assignment => !assignmentStore.assignmentsForRemoval.has(assignment));
        assignmentsForRemoval.length > 0 && assignmentStore.remove(assignmentsForRemoval);
      }

      this.assignmentsForRemoval.clear();
    }

    processRecord(resourceRecord, isDataset = false) {
      const existingRecord = this.getById(resourceRecord.id);
      const isReplacing = existingRecord && existingRecord !== resourceRecord;

      if (isReplacing) {
        // TODO: There is no ResourceMixin at the lowest level, cannot type correctly without it
        //@ts-ignore
        for (const assignment of existingRecord.assigned) {
          assignment.resource = resourceRecord;
        }
      }

      return resourceRecord;
    }

  }

  return AbstractResourceStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/CoreAssignmentStoreMixin.js":
/*!************************************************************!*\
  !*** ./lib/Engine/quark/store/CoreAssignmentStoreMixin.js ***!
  \************************************************************/
/*! exports provided: CoreAssignmentStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreAssignmentStoreMixin", function() { return CoreAssignmentStoreMixin; });
/* harmony import */ var _model_scheduler_core_CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../model/scheduler_core/CoreAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js");
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractAssignmentStoreMixin.js */ "./lib/Engine/quark/store/AbstractAssignmentStoreMixin.js");
var productName = 'taskboard';




const emptySet = new Set();
/**
 * A store mixin class, that represent collection of all assignments in the [[SchedulerCoreProjectMixin|project]].
 */

class CoreAssignmentStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_1__["Mixin"])([_AbstractAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractAssignmentStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["CorePartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class CoreAssignmentStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.skipInvalidateIndices = false;
    }

    static get defaultConfig() {
      return {
        modelClass: _model_scheduler_core_CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_0__["CoreAssignmentMixin"],
        storage: {
          extraKeys: [{
            property: 'event',
            unique: false
          }, {
            property: 'resource',
            unique: false
          }, {
            property: 'eventId',
            unique: false
          }]
        }
      };
    }

    set data(value) {
      this.allAssignmentsForRemoval = true;
      super.data = value;
      this.allAssignmentsForRemoval = false;
    }

    getEventsAssignments(event) {
      return this.storage.findItem('event', event) || emptySet;
    }

    getResourcesAssignments(resource) {
      return this.storage.findItem('resource', resource) || emptySet;
    }

    updateIndices() {
      this.storage.rebuildIndices();
    }

    invalidateIndices() {
      this.storage.invalidateIndices();
    } // Link events/resources to assignments, called when those stores are populated or joined to project


    linkAssignments(store, modelName) {
      const unresolved = this.count && this.storage.findItem(modelName, null);

      if (unresolved) {
        for (const assignment of unresolved) {
          const record = store.getById(assignment.getCurrentOrProposed(modelName));
          if (record) assignment.setChanged(modelName, record);
        }

        this.invalidateIndices();
      }
    } // Unlink events/resources from assignments, called when those stores are cleared


    unlinkAssignments(modelName) {
      // Invalidate links to events/resources, need to link to new records so set it back to the id (might be resource or resourceId)
      this.forEach(assignment => {
        var _a, _b, _c;

        return assignment.setChanged(modelName, (_c = (_b = (_a = assignment[modelName]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : assignment[modelName]) !== null && _c !== void 0 ? _c : assignment[modelName + 'Id']);
      });
      this.invalidateIndices();
    }

    onCommitAsync() {
      this.updateIndices();
    }

  }

  return CoreAssignmentStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/CoreCalendarManagerStoreMixin.js":
/*!*****************************************************************!*\
  !*** ./lib/Engine/quark/store/CoreCalendarManagerStoreMixin.js ***!
  \*****************************************************************/
/*! exports provided: CoreCalendarManagerStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreCalendarManagerStoreMixin", function() { return CoreCalendarManagerStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _model_scheduler_core_CoreCalendarMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/scheduler_core/CoreCalendarMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreCalendarMixin.js");
/* harmony import */ var _AbstractCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractCalendarManagerStoreMixin.js */ "./lib/Engine/quark/store/AbstractCalendarManagerStoreMixin.js");
var productName = 'taskboard';




/**
 * A store mixin class, that represent collection of all calendars in the [[SchedulerCoreProjectMixin|project]].
 */

class CoreCalendarManagerStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractCalendarManagerStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractCalendarManagerStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class CoreCalendarManagerStoreMixin extends base {
    static get defaultConfig() {
      return {
        tree: true,
        modelClass: _model_scheduler_core_CoreCalendarMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreCalendarMixin"]
      };
    }

  }

  return CoreCalendarManagerStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/CoreDependencyStoreMixin.js":
/*!************************************************************!*\
  !*** ./lib/Engine/quark/store/CoreDependencyStoreMixin.js ***!
  \************************************************************/
/*! exports provided: CoreDependencyStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreDependencyStoreMixin", function() { return CoreDependencyStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _model_scheduler_core_CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/scheduler_core/CoreDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js");
/* harmony import */ var _AbstractDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractDependencyStoreMixin.js */ "./lib/Engine/quark/store/AbstractDependencyStoreMixin.js");
var productName = 'taskboard';




const emptySet = new Set();
/**
 * A store mixin class, that represent collection of all dependencies in the [[SchedulerCoreProjectMixin|project]].
 */

class CoreDependencyStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractDependencyStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class CoreDependencyStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.dependenciesForRemoval = new Set();
      this.allDependenciesForRemoval = false;
    }

    static get defaultConfig() {
      return {
        modelClass: _model_scheduler_core_CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreDependencyMixin"],
        storage: {
          extraKeys: [{
            property: 'fromEvent',
            unique: false
          }, {
            property: 'toEvent',
            unique: false
          }]
        }
      };
    }

    getIncomingDepsForEvent(event) {
      return this.storage.findItem('toEvent', event) || emptySet;
    }

    getOutgoingDepsForEvent(event) {
      return this.storage.findItem('fromEvent', event) || emptySet;
    }

    set data(value) {
      this.allDependenciesForRemoval = true;
      super.data = value;
      this.allDependenciesForRemoval = false;
    }

    updateIndices() {
      this.storage.rebuildIndices();
    }

    invalidateIndices() {
      this.storage.invalidateIndices();
    }

    onCommitAsync() {
      this.updateIndices();
    }

  }

  return CoreDependencyStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/CoreEventStoreMixin.js":
/*!*******************************************************!*\
  !*** ./lib/Engine/quark/store/CoreEventStoreMixin.js ***!
  \*******************************************************/
/*! exports provided: CoreEventStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreEventStoreMixin", function() { return CoreEventStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _model_scheduler_core_SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/scheduler_core/SchedulerCoreEvent.js */ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _AbstractEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractEventStoreMixin.js */ "./lib/Engine/quark/store/AbstractEventStoreMixin.js");
var productName = 'taskboard';




/**
 * A store mixin class, that represent collection of all events in the [[SchedulerCoreProjectMixin|project]].
 */

class CoreEventStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractEventStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["CorePartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class CoreEventStoreMixin extends base {
    static get defaultConfig() {
      return {
        modelClass: _model_scheduler_core_SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_1__["SchedulerCoreEvent"]
      };
    }

    joinProject() {
      var _a;

      (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.linkAssignments(this, 'event');
    }

    afterLoadData() {
      var _a;

      this.afterEventRemoval();
      (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.linkAssignments(this, 'event');
    }

  }

  return CoreEventStoreMixin;
}) {} // /**
//  * The tree store version of [[EventStoreMixin]].
//  */
// export class EventTreeStoreMixin extends Mixin(
//     [ EventStoreMixin ],
//     (base : AnyConstructor<EventStoreMixin, typeof EventStoreMixin>) => {
//
//     const superProto : InstanceType<typeof base> = base.prototype
//
//
//         class EventTreeStoreMixin extends base {
//             rootNode            : SchedulerBasicProjectMixin
//
//             buildRootNode () : object {
//                 return this.getProject() || {}
//             }
//
//
//             static get defaultConfig () : object {
//                 return {
//                     tree        : true
//                 }
//             }
//         }
//
//         return EventTreeStoreMixin
//     }){}
//

/***/ }),

/***/ "./lib/Engine/quark/store/CoreResourceStoreMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Engine/quark/store/CoreResourceStoreMixin.js ***!
  \**********************************************************/
/*! exports provided: CoreResourceStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreResourceStoreMixin", function() { return CoreResourceStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/CorePartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js");
/* harmony import */ var _model_scheduler_core_CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model/scheduler_core/CoreResourceMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js");
/* harmony import */ var _AbstractResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractResourceStoreMixin.js */ "./lib/Engine/quark/store/AbstractResourceStoreMixin.js");
var productName = 'taskboard';




/**
 * A store mixin class, that represent collection of all resources in the [[SchedulerCoreProjectMixin|project]].
 */

class CoreResourceStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractResourceStoreMixin"], _mixin_CorePartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectStoreMixin"]], base => {
  const superProto = base.prototype;

  class CoreResourceStoreMixin extends base {
    static get defaultConfig() {
      return {
        modelClass: _model_scheduler_core_CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreResourceMixin"]
      };
    }

    joinProject() {
      var _a;

      (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.linkAssignments(this, 'resource');
    }

    afterLoadData() {
      var _a;

      (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.linkAssignments(this, 'resource');
    }

    clear(removing) {
      var _a;

      superProto.clear.call(this, removing);
      (_a = this.assignmentStore) === null || _a === void 0 ? void 0 : _a.unlinkAssignments('resource');
    }

  }

  return CoreResourceStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js":
/*!*************************************************************************!*\
  !*** ./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js ***!
  \*************************************************************************/
/*! exports provided: AbstractPartOfProjectStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractPartOfProjectStoreMixin", function() { return AbstractPartOfProjectStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../AbstractPartOfProjectGenericMixin.js */ "./lib/Engine/quark/AbstractPartOfProjectGenericMixin.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
var productName = 'taskboard';



/**
 * This an abstract mixin for every Store, that belongs to a project.
 *
 * The store with this mixin, supposes, that it will be "joining" the project, a reference to which is saved
 * and made available for all models.
 */

class AbstractPartOfProjectStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractPartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__["AbstractPartOfProjectGenericMixin"], _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"]], base => {
  const superProto = base.prototype;

  class AbstractPartOfProjectStoreMixin extends base {
    constructor() {
      super(...arguments);
      this.isLoadingData = false;
    } //region Async event triggering
    // NOTE: Tested in Scheduler (EventStore.t.js)


    construct(config = {}) {
      config.asyncEvents = {
        add: true,
        remove: true,
        removeAll: true,
        change: true,
        refresh: true,
        replace: true,
        move: true,
        update: true
      };
      return superProto.construct.call(this, config);
    } // Override for event triggering, to allow triggering events before and after some async operation.
    // The "before" events are prefix, the "after" are not.


    trigger(eventName, param) {
      const me = this,
            {
        asyncEvents,
        project
      } = me,
            asyncEvent = asyncEvents === null || asyncEvents === void 0 ? void 0 : asyncEvents[eventName],
            asyncAction = asyncEvent && (asyncEvent === true || asyncEvent[param.action]);

      if (!asyncAction) {
        // Trigger as usual
        return superProto.trigger.call(me, eventName, param);
      } // Trigger prefixed before event


      superProto.trigger.call(me, `${eventName}PreCommit`, Object.assign({}, param)); // Event that did not invalidate engine, for example "update"

      if (!project || project.isEngineReady() && !project.isWritingData) {
        // Trigger "original" event
        superProto.trigger.call(me, eventName, param);
      } else if (!me.eventsSuspended && project) {
        // Instead of making n auto-destroying listeners (which takes enormous amount of time), we make a single
        // one and queue all the events. When dataReady event is triggered we trigger those events
        // https://github.com/bryntum/support/issues/3154
        if (!project.dataReadyDetacher) {
          project.queuedDataReadyEvents = []; // Wait for commit without triggering one, otherwise we would affect commit scheduling

          project.dataReadyDetacher = project.on({
            dataReady() {
              // Trigger "original" event
              this.queuedDataReadyEvents.forEach(([superProto, scope, eventName, param]) => {
                superProto.trigger.call(scope, eventName, param);
              });
              project.queuedDataReadyEvents = null;
              project.dataReadyDetacher();
              project.dataReadyDetacher = null;
            },

            once: true
          });
        }

        project.queuedDataReadyEvents.push([superProto, me, eventName, param]);
      } // No way of handling other return values in this scenario, wont work for preventable events


      return true;
    } //endregion


    calculateProject() {
      // project is supposed to be provided for stores from outside
      return this.project;
    }

    setStoreData(data) {
      var _a; // Loading data sets hasLoadedDataToCommit flag.
      // So we treat the 1st commit after data loading as the initial one


      if (this.project) {
        this.project.hasLoadedDataToCommit = true;
      }

      this.isLoadingData = true;
      superProto.setStoreData.call(this, data);
      this.isLoadingData = false;
      (_a = this.project) === null || _a === void 0 ? void 0 : _a.trigger('storeRefresh', {
        store: this
      });
    } // Override to postpone auto commits to after project commit, makes sure records are unmodified after commit


    async doAutoCommit() {
      if (this.suspendCount <= 0 && this.project && !this.project.isEngineReady()) {
        // TODO: Ask nick about this, I could not get mixin order correct for this to work
        // @ts-ignore
        await this.project.commitAsync();
      }

      superProto.doAutoCommit.call(this);
    }

    async addAsync(records, silent) {
      const result = this.add(records, silent);
      await this.project.commitAsync();
      return result;
    }

    async insertAsync(index, records, silent) {
      const result = this.insert(index, records, silent);
      await this.project.commitAsync();
      return result;
    }

    async loadDataAsync(data) {
      this.data = data;
      await this.project.commitAsync();
    }

  }

  return AbstractPartOfProjectStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js":
/*!*********************************************************************!*\
  !*** ./lib/Engine/quark/store/mixin/CorePartOfProjectStoreMixin.js ***!
  \*********************************************************************/
/*! exports provided: CorePartOfProjectStoreMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CorePartOfProjectStoreMixin", function() { return CorePartOfProjectStoreMixin; });
/* harmony import */ var _ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../ChronoGraph/class/BetterMixin.js */ "./lib/ChronoGraph/class/BetterMixin.js");
/* harmony import */ var _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../CorePartOfProjectGenericMixin.js */ "./lib/Engine/quark/CorePartOfProjectGenericMixin.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AbstractPartOfProjectStoreMixin.js */ "./lib/Engine/quark/store/mixin/AbstractPartOfProjectStoreMixin.js");
var productName = 'taskboard';




/**
 * This a mixin for every Store, that belongs to a scheduler_core project.
 */

class CorePartOfProjectStoreMixin extends Object(_ChronoGraph_class_BetterMixin_js__WEBPACK_IMPORTED_MODULE_0__["Mixin"])([_AbstractPartOfProjectStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["AbstractPartOfProjectStoreMixin"], _CorePartOfProjectGenericMixin_js__WEBPACK_IMPORTED_MODULE_1__["CorePartOfProjectGenericMixin"], _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_2__["default"]], base => {
  const superProto = base.prototype;

  class CorePartOfProjectStoreMixin extends base {
    setProject(project) {
      const result = superProto.setProject.call(this, project);
      if (project) this.joinProject(project);
      return result;
    }

    joinProject(project) {}

    onCommitAsync() {}

  }

  return CorePartOfProjectStoreMixin;
}) {}

/***/ }),

/***/ "./lib/Engine/scheduling/Types.js":
/*!****************************************!*\
  !*** ./lib/Engine/scheduling/Types.js ***!
  \****************************************/
/*! exports provided: TimeUnit, ConstraintType, SchedulingMode, DependencyValidationResult, DependencyType, DependenciesCalendar, ProjectType, Direction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeUnit", function() { return TimeUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConstraintType", function() { return ConstraintType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SchedulingMode", function() { return SchedulingMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DependencyValidationResult", function() { return DependencyValidationResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DependencyType", function() { return DependencyType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DependenciesCalendar", function() { return DependenciesCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProjectType", function() { return ProjectType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Direction", function() { return Direction; });
var productName = 'taskboard';
/**
* The enumeration for the time units
*/

var TimeUnit;

(function (TimeUnit) {
  TimeUnit["Millisecond"] = "millisecond";
  TimeUnit["Second"] = "second";
  TimeUnit["Minute"] = "minute";
  TimeUnit["Hour"] = "hour";
  TimeUnit["Day"] = "day";
  TimeUnit["Week"] = "week";
  TimeUnit["Month"] = "month";
  TimeUnit["Quarter"] = "quarter";
  TimeUnit["Year"] = "year";
})(TimeUnit || (TimeUnit = {}));
/**
 * The enumeration for the supported constraint types
 */


var ConstraintType;

(function (ConstraintType) {
  /**
   * "Must start on" constraint.
   * Restricts an event to start on a [[HasDateConstraintMixin.constraintDate|specified date]].
   * The constraint cannot be used for a summary event.
   */
  ConstraintType["MustStartOn"] = "muststarton";
  /**
   * "Must finish on" constraint.
   * Restricts an event to finish on a [[HasDateConstraintMixin.constraintDate|specified date]].
   * The constraint cannot be used for a summary event.
   */

  ConstraintType["MustFinishOn"] = "mustfinishon";
  /**
   * "Start no earlier than" constraint.
   * Restricting an event to start on or after a [[HasDateConstraintMixin.constraintDate|specified date]].
   */

  ConstraintType["StartNoEarlierThan"] = "startnoearlierthan";
  /**
   * "Start no later than" constraint.
   * Restricting an event to start on or before a [[HasDateConstraintMixin.constraintDate|specified date]].
   *
   * The constraint cannot be used for a summary task.
   */

  ConstraintType["StartNoLaterThan"] = "startnolaterthan";
  /**
   * "Finish no earlier than" constraint.
   * Restricting an event to finish on or after a [[HasDateConstraintMixin.constraintDate|specified date]].
   *
   * The constraint cannot be used for a summary task.
   */

  ConstraintType["FinishNoEarlierThan"] = "finishnoearlierthan";
  /**
   * "Finish no later than" constraint.
   * Restricting an event to finish on or before a [[HasDateConstraintMixin.constraintDate|specified date]].
   */

  ConstraintType["FinishNoLaterThan"] = "finishnolaterthan";
})(ConstraintType || (ConstraintType = {}));
/**
 * The enumeration for the supported scheduling modes
 */


var SchedulingMode;

(function (SchedulingMode) {
  SchedulingMode["Normal"] = "Normal";
  SchedulingMode["FixedDuration"] = "FixedDuration";
  SchedulingMode["FixedEffort"] = "FixedEffort";
  SchedulingMode["FixedUnits"] = "FixedUnits";
})(SchedulingMode || (SchedulingMode = {}));
/**
 * The enumeration for the dependency validation result
 */


var DependencyValidationResult;

(function (DependencyValidationResult) {
  /**
   * Dependency has no errors
   */
  DependencyValidationResult[DependencyValidationResult["NoError"] = 0] = "NoError";
  /**
   * Indicates that the validated dependency builds a cycle
   */

  DependencyValidationResult[DependencyValidationResult["CyclicDependency"] = 1] = "CyclicDependency";
  /**
   * Indicates that a dependency with the same predecessor and successor as validated one's already exists
   */

  DependencyValidationResult[DependencyValidationResult["DuplicatingDependency"] = 2] = "DuplicatingDependency";
})(DependencyValidationResult || (DependencyValidationResult = {}));
/**
 * The enumeration for the supported dependency types
 */


var DependencyType;

(function (DependencyType) {
  /**
   * Start-to-Start (_SS_)
   *
   * With this dependency type, the succeeding event is delayed to start not earlier than the preceding event starts.
   */
  DependencyType[DependencyType["StartToStart"] = 0] = "StartToStart";
  /**
   * Start-to-Finish (_SF_)
   *
   * The finish of the succeeding event is constrained by the start of the preceding event.
   * So the successor cannot finish before the predecessor starts.
   */

  DependencyType[DependencyType["StartToEnd"] = 1] = "StartToEnd";
  /**
   * Finish-to-Start (_FS_)
   *
   * This type of dependency, restricts the dependent event to not start earlier than the preceding event finishes.
   */

  DependencyType[DependencyType["EndToStart"] = 2] = "EndToStart";
  /**
   * Finish-to-Finish (_FF_)
   *
   * The succeeding event cannot finish before the completion of the preceding event.
   */

  DependencyType[DependencyType["EndToEnd"] = 3] = "EndToEnd";
})(DependencyType || (DependencyType = {}));
/**
 * The enumeration for the supported sources of the calendar for the dependency.
 */


var DependenciesCalendar;

(function (DependenciesCalendar) {
  DependenciesCalendar["Project"] = "Project";
  DependenciesCalendar["FromEvent"] = "FromEvent";
  DependenciesCalendar["ToEvent"] = "ToEvent";
})(DependenciesCalendar || (DependenciesCalendar = {}));
/**
 * Engine provides with different project types, the enumeration describes the types currently available
 */


var ProjectType;

(function (ProjectType) {
  ProjectType[ProjectType["SchedulerBasic"] = 1] = "SchedulerBasic";
  ProjectType[ProjectType["SchedulerPro"] = 2] = "SchedulerPro";
  ProjectType[ProjectType["Gantt"] = 3] = "Gantt";
})(ProjectType || (ProjectType = {}));
/**
 * The enumeration for the scheduling direction
 */


var Direction;

(function (Direction) {
  /**
   * Forward (or As Soon As Possible (ASAP)) scheduling.
   */
  Direction["Forward"] = "Forward";
  /**
   * Backward (or As Late As Possible (ALAP)) scheduling.
   */

  Direction["Backward"] = "Backward";
  Direction["None"] = "None";
})(Direction || (Direction = {}));

/***/ }),

/***/ "./lib/Engine/util/BinarySearch.js":
/*!*****************************************!*\
  !*** ./lib/Engine/util/BinarySearch.js ***!
  \*****************************************/
/*! exports provided: binarySearch */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "binarySearch", function() { return binarySearch; });
var productName = 'taskboard'; // Generic binary search

const binarySearch = (value, array, comparator = (a, b) => a - b) => {
  let left = 0;
  let right = array.length;

  while (left < right) {
    // | 0 to make it integer, faster according to: https://jsperf.com/or-vs-floor/2
    const mid = (left + right) / 2 | 0;
    const compare = comparator(value, array[mid]);
    if (compare === 0) return {
      found: true,
      index: mid
    };else if (compare < 0) right = mid;else left = mid + 1;
  }

  return {
    found: false,
    index: right
  };
};

/***/ }),

/***/ "./lib/Engine/util/Constants.js":
/*!**************************************!*\
  !*** ./lib/Engine/util/Constants.js ***!
  \**************************************/
/*! exports provided: MIN_DATE, MAX_DATE, isDateFinite */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIN_DATE", function() { return MIN_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_DATE", function() { return MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDateFinite", function() { return isDateFinite; });
var productName = 'taskboard'; // http://ecma-international.org/ecma-262/5.1/#sec-15.9.1.1

/**
 * Minimal date representable with native Date class
 */

const MIN_DATE = new Date(-8640000000000000);
/**
 * Maximal date representable with native Date class
 */

const MAX_DATE = new Date(8640000000000000);
const isDateFinite = date => {
  if (!date) return false;
  const time = date.getTime();
  return time !== MIN_DATE.getTime() && time !== MAX_DATE.getTime();
};

/***/ }),

/***/ "./lib/Engine/util/Functions.js":
/*!**************************************!*\
  !*** ./lib/Engine/util/Functions.js ***!
  \**************************************/
/*! exports provided: isNotNumber, CIFromSetOrArrayOrValue, delay */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNotNumber", function() { return isNotNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CIFromSetOrArrayOrValue", function() { return CIFromSetOrArrayOrValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return delay; });
/* harmony import */ var _ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../ChronoGraph/collection/Iterator.js */ "./lib/ChronoGraph/collection/Iterator.js");
var productName = 'taskboard';

const isNotNumber = value => Number(value) !== value;
const CIFromSetOrArrayOrValue = value => {
  if (value instanceof Set || value instanceof Array) return Object(_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])(value);
  return Object(_ChronoGraph_collection_Iterator_js__WEBPACK_IMPORTED_MODULE_0__["CI"])([value]);
};
const delay = value => new Promise(resolve => setTimeout(resolve, value));

/***/ }),

/***/ "./lib/Engine/util/StripDuplicates.js":
/*!********************************************!*\
  !*** ./lib/Engine/util/StripDuplicates.js ***!
  \********************************************/
/*! exports provided: stripDuplicates */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stripDuplicates", function() { return stripDuplicates; });
var productName = 'taskboard';
const stripDuplicates = array => Array.from(new Set(array));

/***/ }),

/***/ "./lib/Engine/util/Types.js":
/*!**********************************!*\
  !*** ./lib/Engine/util/Types.js ***!
  \**********************************/
/*! exports provided: EdgeInclusion */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgeInclusion", function() { return EdgeInclusion; });
var productName = 'taskboard';
/**
* The date intervals in the scheduling engine are always inclusive on one end and opened on another.
* The "opened" end is not considered to be a part of the interval.
*
* Depending from the scheduling direction (forward/backward) this property may need to be inverted.
*
* This enum specifies what edge of the interval is inclusive.
*/

var EdgeInclusion;

(function (EdgeInclusion) {
  EdgeInclusion[EdgeInclusion["Left"] = 0] = "Left";
  EdgeInclusion[EdgeInclusion["Right"] = 1] = "Right";
})(EdgeInclusion || (EdgeInclusion = {}));

/***/ }),

/***/ "./lib/Engine/vendor/later/later.js":
/*!******************************************!*\
  !*** ./lib/Engine/vendor/later/later.js ***!
  \******************************************/
/*! exports provided: later, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "later", function() { return later; });
var productName = 'taskboard'; // @ts-nocheck

/**
 * The code just copy/pasted from pre-built later.js file and made exported
 *
 * @private
 */

const later = function () {
  "use strict";

  var later = {
    version: "1.2.0"
  };

  if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement) {
      "use strict";

      if (this == null) {
        throw new TypeError();
      }

      var t = Object(this);
      var len = t.length >>> 0;

      if (len === 0) {
        return -1;
      }

      var n = 0;

      if (arguments.length > 1) {
        n = Number(arguments[1]);

        if (n != n) {
          n = 0;
        } else if (n != 0 && n != Infinity && n != -Infinity) {
          n = (n > 0 || -1) * Math.floor(Math.abs(n));
        }
      }

      if (n >= len) {
        return -1;
      }

      var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);

      for (; k < len; k++) {
        if (k in t && t[k] === searchElement) {
          return k;
        }
      }

      return -1;
    };
  }

  if (!String.prototype.trim) {
    String.prototype.trim = function () {
      return this.replace(/^\s+|\s+$/g, "");
    };
  }

  later.array = {};

  later.array.sort = function (arr, zeroIsLast) {
    arr.sort(function (a, b) {
      return +a - +b;
    });

    if (zeroIsLast && arr[0] === 0) {
      arr.push(arr.shift());
    }
  };

  later.array.next = function (val, values, extent) {
    var cur,
        zeroIsLargest = extent[0] !== 0,
        nextIdx = 0;

    for (var i = values.length - 1; i > -1; --i) {
      cur = values[i];

      if (cur === val) {
        return cur;
      }

      if (cur > val || cur === 0 && zeroIsLargest && extent[1] > val) {
        nextIdx = i;
        continue;
      }

      break;
    }

    return values[nextIdx];
  };

  later.array.nextInvalid = function (val, values, extent) {
    var min = extent[0],
        max = extent[1],
        len = values.length,
        zeroVal = values[len - 1] === 0 && min !== 0 ? max : 0,
        next = val,
        i = values.indexOf(val),
        start = next;

    while (next === (values[i] || zeroVal)) {
      next++;

      if (next > max) {
        next = min;
      }

      i++;

      if (i === len) {
        i = 0;
      }

      if (next === start) {
        return undefined;
      }
    }

    return next;
  };

  later.array.prev = function (val, values, extent) {
    var cur,
        len = values.length,
        zeroIsLargest = extent[0] !== 0,
        prevIdx = len - 1;

    for (var i = 0; i < len; i++) {
      cur = values[i];

      if (cur === val) {
        return cur;
      }

      if (cur < val || cur === 0 && zeroIsLargest && extent[1] < val) {
        prevIdx = i;
        continue;
      }

      break;
    }

    return values[prevIdx];
  };

  later.array.prevInvalid = function (val, values, extent) {
    var min = extent[0],
        max = extent[1],
        len = values.length,
        zeroVal = values[len - 1] === 0 && min !== 0 ? max : 0,
        next = val,
        i = values.indexOf(val),
        start = next;

    while (next === (values[i] || zeroVal)) {
      next--;

      if (next < min) {
        next = max;
      }

      i--;

      if (i === -1) {
        i = len - 1;
      }

      if (next === start) {
        return undefined;
      }
    }

    return next;
  };

  later.day = later.D = {
    name: "day",
    range: 86400,
    val: function (d) {
      return d.D || (d.D = later.date.getDate.call(d));
    },
    isValid: function (d, val) {
      return later.D.val(d) === (val || later.D.extent(d)[1]);
    },
    extent: function (d) {
      if (d.DExtent) return d.DExtent;
      var month = later.M.val(d),
          max = later.DAYS_IN_MONTH[month - 1];

      if (month === 2 && later.dy.extent(d)[1] === 366) {
        max = max + 1;
      }

      return d.DExtent = [1, max];
    },
    start: function (d) {
      return d.DStart || (d.DStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d)));
    },
    end: function (d) {
      return d.DEnd || (d.DEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d)));
    },
    next: function (d, val) {
      val = val > later.D.extent(d)[1] ? 1 : val;
      var month = later.date.nextRollover(d, val, later.D, later.M),
          DMax = later.D.extent(month)[1];
      val = val > DMax ? 1 : val || DMax;
      return later.date.next(later.Y.val(month), later.M.val(month), val);
    },
    prev: function (d, val) {
      var month = later.date.prevRollover(d, val, later.D, later.M),
          DMax = later.D.extent(month)[1];
      return later.date.prev(later.Y.val(month), later.M.val(month), val > DMax ? DMax : val || DMax);
    }
  };
  later.dayOfWeekCount = later.dc = {
    name: "day of week count",
    range: 604800,
    val: function (d) {
      return d.dc || (d.dc = Math.floor((later.D.val(d) - 1) / 7) + 1);
    },
    isValid: function (d, val) {
      return later.dc.val(d) === val || val === 0 && later.D.val(d) > later.D.extent(d)[1] - 7;
    },
    extent: function (d) {
      return d.dcExtent || (d.dcExtent = [1, Math.ceil(later.D.extent(d)[1] / 7)]);
    },
    start: function (d) {
      return d.dcStart || (d.dcStart = later.date.next(later.Y.val(d), later.M.val(d), Math.max(1, (later.dc.val(d) - 1) * 7 + 1 || 1)));
    },
    end: function (d) {
      return d.dcEnd || (d.dcEnd = later.date.prev(later.Y.val(d), later.M.val(d), Math.min(later.dc.val(d) * 7, later.D.extent(d)[1])));
    },
    next: function (d, val) {
      val = val > later.dc.extent(d)[1] ? 1 : val;
      var month = later.date.nextRollover(d, val, later.dc, later.M),
          dcMax = later.dc.extent(month)[1];
      val = val > dcMax ? 1 : val;
      var next = later.date.next(later.Y.val(month), later.M.val(month), val === 0 ? later.D.extent(month)[1] - 6 : 1 + 7 * (val - 1));

      if (next.getTime() <= d.getTime()) {
        month = later.M.next(d, later.M.val(d) + 1);
        return later.date.next(later.Y.val(month), later.M.val(month), val === 0 ? later.D.extent(month)[1] - 6 : 1 + 7 * (val - 1));
      }

      return next;
    },
    prev: function (d, val) {
      var month = later.date.prevRollover(d, val, later.dc, later.M),
          dcMax = later.dc.extent(month)[1];
      val = val > dcMax ? dcMax : val || dcMax;
      return later.dc.end(later.date.prev(later.Y.val(month), later.M.val(month), 1 + 7 * (val - 1)));
    }
  };
  later.dayOfWeek = later.dw = later.d = {
    name: "day of week",
    range: 86400,
    val: function (d) {
      return d.dw || (d.dw = later.date.getDay.call(d) + 1);
    },
    isValid: function (d, val) {
      return later.dw.val(d) === (val || 7);
    },
    extent: function () {
      return [1, 7];
    },
    start: function (d) {
      return later.D.start(d);
    },
    end: function (d) {
      return later.D.end(d);
    },
    next: function (d, val) {
      val = val > 7 ? 1 : val || 7;
      return later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val - later.dw.val(d)) + (val <= later.dw.val(d) ? 7 : 0));
    },
    prev: function (d, val) {
      val = val > 7 ? 7 : val || 7;
      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d) + (val - later.dw.val(d)) + (val >= later.dw.val(d) ? -7 : 0));
    }
  };
  later.dayOfYear = later.dy = {
    name: "day of year",
    range: 86400,
    val: function (d) {
      return d.dy || (d.dy = Math.ceil(1 + (later.D.start(d).getTime() - later.Y.start(d).getTime()) / later.DAY));
    },
    isValid: function (d, val) {
      return later.dy.val(d) === (val || later.dy.extent(d)[1]);
    },
    extent: function (d) {
      var year = later.Y.val(d);
      return d.dyExtent || (d.dyExtent = [1, year % 4 ? 365 : 366]);
    },
    start: function (d) {
      return later.D.start(d);
    },
    end: function (d) {
      return later.D.end(d);
    },
    next: function (d, val) {
      val = val > later.dy.extent(d)[1] ? 1 : val;
      var year = later.date.nextRollover(d, val, later.dy, later.Y),
          dyMax = later.dy.extent(year)[1];
      val = val > dyMax ? 1 : val || dyMax;
      return later.date.next(later.Y.val(year), later.M.val(year), val);
    },
    prev: function (d, val) {
      var year = later.date.prevRollover(d, val, later.dy, later.Y),
          dyMax = later.dy.extent(year)[1];
      val = val > dyMax ? dyMax : val || dyMax;
      return later.date.prev(later.Y.val(year), later.M.val(year), val);
    }
  };
  later.hour = later.h = {
    name: "hour",
    range: 3600,
    val: function (d) {
      return d.h || (d.h = later.date.getHour.call(d));
    },
    isValid: function (d, val) {
      return later.h.val(d) === val;
    },
    extent: function () {
      return [0, 23];
    },
    start: function (d) {
      return d.hStart || (d.hStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d)));
    },
    end: function (d) {
      return d.hEnd || (d.hEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d)));
    },
    next: function (d, val) {
      val = val > 23 ? 0 : val;
      var next = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val <= later.h.val(d) ? 1 : 0), val);

      if (!later.date.isUTC && next.getTime() <= d.getTime()) {
        next = later.date.next(later.Y.val(next), later.M.val(next), later.D.val(next), val + 1);
      }

      return next;
    },
    prev: function (d, val) {
      val = val > 23 ? 23 : val;
      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d) + (val >= later.h.val(d) ? -1 : 0), val);
    }
  };
  later.minute = later.m = {
    name: "minute",
    range: 60,
    val: function (d) {
      return d.m || (d.m = later.date.getMin.call(d));
    },
    isValid: function (d, val) {
      return later.m.val(d) === val;
    },
    extent: function (d) {
      return [0, 59];
    },
    start: function (d) {
      return d.mStart || (d.mStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d), later.m.val(d)));
    },
    end: function (d) {
      return d.mEnd || (d.mEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d), later.m.val(d)));
    },
    next: function (d, val) {
      var m = later.m.val(d),
          s = later.s.val(d),
          inc = val > 59 ? 60 - m : val <= m ? 60 - m + val : val - m,
          next = new Date(d.getTime() + inc * later.MIN - s * later.SEC);

      if (!later.date.isUTC && next.getTime() <= d.getTime()) {
        next = new Date(d.getTime() + (inc + 120) * later.MIN - s * later.SEC);
      }

      return next;
    },
    prev: function (d, val) {
      val = val > 59 ? 59 : val;
      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d) + (val >= later.m.val(d) ? -1 : 0), val);
    }
  };
  later.month = later.M = {
    name: "month",
    range: 2629740,
    val: function (d) {
      return d.M || (d.M = later.date.getMonth.call(d) + 1);
    },
    isValid: function (d, val) {
      return later.M.val(d) === (val || 12);
    },
    extent: function () {
      return [1, 12];
    },
    start: function (d) {
      return d.MStart || (d.MStart = later.date.next(later.Y.val(d), later.M.val(d)));
    },
    end: function (d) {
      return d.MEnd || (d.MEnd = later.date.prev(later.Y.val(d), later.M.val(d)));
    },
    next: function (d, val) {
      val = val > 12 ? 1 : val || 12;
      return later.date.next(later.Y.val(d) + (val > later.M.val(d) ? 0 : 1), val);
    },
    prev: function (d, val) {
      val = val > 12 ? 12 : val || 12;
      return later.date.prev(later.Y.val(d) - (val >= later.M.val(d) ? 1 : 0), val);
    }
  };
  later.second = later.s = {
    name: "second",
    range: 1,
    val: function (d) {
      return d.s || (d.s = later.date.getSec.call(d));
    },
    isValid: function (d, val) {
      return later.s.val(d) === val;
    },
    extent: function () {
      return [0, 59];
    },
    start: function (d) {
      return d;
    },
    end: function (d) {
      return d;
    },
    next: function (d, val) {
      var s = later.s.val(d),
          inc = val > 59 ? 60 - s : val <= s ? 60 - s + val : val - s,
          next = new Date(d.getTime() + inc * later.SEC);

      if (!later.date.isUTC && next.getTime() <= d.getTime()) {
        next = new Date(d.getTime() + (inc + 7200) * later.SEC);
      }

      return next;
    },
    prev: function (d, val, cache) {
      val = val > 59 ? 59 : val;
      return later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d), later.h.val(d), later.m.val(d) + (val >= later.s.val(d) ? -1 : 0), val);
    }
  };
  later.time = later.t = {
    name: "time",
    range: 1,
    val: function (d) {
      return d.t || (d.t = later.h.val(d) * 3600 + later.m.val(d) * 60 + later.s.val(d));
    },
    isValid: function (d, val) {
      return later.t.val(d) === val;
    },
    extent: function () {
      return [0, 86399];
    },
    start: function (d) {
      return d;
    },
    end: function (d) {
      return d;
    },
    next: function (d, val) {
      val = val > 86399 ? 0 : val;
      var next = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val <= later.t.val(d) ? 1 : 0), 0, 0, val);

      if (!later.date.isUTC && next.getTime() < d.getTime()) {
        next = later.date.next(later.Y.val(next), later.M.val(next), later.D.val(next), later.h.val(next), later.m.val(next), val + 7200);
      }

      return next;
    },
    prev: function (d, val) {
      val = val > 86399 ? 86399 : val;
      return later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) + (val >= later.t.val(d) ? -1 : 0), 0, 0, val);
    }
  };
  later.weekOfMonth = later.wm = {
    name: "week of month",
    range: 604800,
    val: function (d) {
      return d.wm || (d.wm = (later.D.val(d) + (later.dw.val(later.M.start(d)) - 1) + (7 - later.dw.val(d))) / 7);
    },
    isValid: function (d, val) {
      return later.wm.val(d) === (val || later.wm.extent(d)[1]);
    },
    extent: function (d) {
      return d.wmExtent || (d.wmExtent = [1, (later.D.extent(d)[1] + (later.dw.val(later.M.start(d)) - 1) + (7 - later.dw.val(later.M.end(d)))) / 7]);
    },
    start: function (d) {
      return d.wmStart || (d.wmStart = later.date.next(later.Y.val(d), later.M.val(d), Math.max(later.D.val(d) - later.dw.val(d) + 1, 1)));
    },
    end: function (d) {
      return d.wmEnd || (d.wmEnd = later.date.prev(later.Y.val(d), later.M.val(d), Math.min(later.D.val(d) + (7 - later.dw.val(d)), later.D.extent(d)[1])));
    },
    next: function (d, val) {
      val = val > later.wm.extent(d)[1] ? 1 : val;
      var month = later.date.nextRollover(d, val, later.wm, later.M),
          wmMax = later.wm.extent(month)[1];
      val = val > wmMax ? 1 : val || wmMax;
      return later.date.next(later.Y.val(month), later.M.val(month), Math.max(1, (val - 1) * 7 - (later.dw.val(month) - 2)));
    },
    prev: function (d, val) {
      var month = later.date.prevRollover(d, val, later.wm, later.M),
          wmMax = later.wm.extent(month)[1];
      val = val > wmMax ? wmMax : val || wmMax;
      return later.wm.end(later.date.next(later.Y.val(month), later.M.val(month), Math.max(1, (val - 1) * 7 - (later.dw.val(month) - 2))));
    }
  };
  later.weekOfYear = later.wy = {
    name: "week of year (ISO)",
    range: 604800,
    val: function (d) {
      if (d.wy) return d.wy;
      var wThur = later.dw.next(later.wy.start(d), 5),
          YThur = later.dw.next(later.Y.prev(wThur, later.Y.val(wThur) - 1), 5);
      return d.wy = 1 + Math.ceil((wThur.getTime() - YThur.getTime()) / later.WEEK);
    },
    isValid: function (d, val) {
      return later.wy.val(d) === (val || later.wy.extent(d)[1]);
    },
    extent: function (d) {
      if (d.wyExtent) return d.wyExtent;
      var year = later.dw.next(later.wy.start(d), 5),
          dwFirst = later.dw.val(later.Y.start(year)),
          dwLast = later.dw.val(later.Y.end(year));
      return d.wyExtent = [1, dwFirst === 5 || dwLast === 5 ? 53 : 52];
    },
    start: function (d) {
      return d.wyStart || (d.wyStart = later.date.next(later.Y.val(d), later.M.val(d), later.D.val(d) - (later.dw.val(d) > 1 ? later.dw.val(d) - 2 : 6)));
    },
    end: function (d) {
      return d.wyEnd || (d.wyEnd = later.date.prev(later.Y.val(d), later.M.val(d), later.D.val(d) + (later.dw.val(d) > 1 ? 8 - later.dw.val(d) : 0)));
    },
    next: function (d, val) {
      val = val > later.wy.extent(d)[1] ? 1 : val;
      var wyThur = later.dw.next(later.wy.start(d), 5),
          year = later.date.nextRollover(wyThur, val, later.wy, later.Y);

      if (later.wy.val(year) !== 1) {
        year = later.dw.next(year, 2);
      }

      var wyMax = later.wy.extent(year)[1],
          wyStart = later.wy.start(year);
      val = val > wyMax ? 1 : val || wyMax;
      return later.date.next(later.Y.val(wyStart), later.M.val(wyStart), later.D.val(wyStart) + 7 * (val - 1));
    },
    prev: function (d, val) {
      var wyThur = later.dw.next(later.wy.start(d), 5),
          year = later.date.prevRollover(wyThur, val, later.wy, later.Y);

      if (later.wy.val(year) !== 1) {
        year = later.dw.next(year, 2);
      }

      var wyMax = later.wy.extent(year)[1],
          wyEnd = later.wy.end(year);
      val = val > wyMax ? wyMax : val || wyMax;
      return later.wy.end(later.date.next(later.Y.val(wyEnd), later.M.val(wyEnd), later.D.val(wyEnd) + 7 * (val - 1)));
    }
  };
  later.year = later.Y = {
    name: "year",
    range: 31556900,
    val: function (d) {
      return d.Y || (d.Y = later.date.getYear.call(d));
    },
    isValid: function (d, val) {
      return later.Y.val(d) === val;
    },
    extent: function () {
      return [1970, 2099];
    },
    start: function (d) {
      return d.YStart || (d.YStart = later.date.next(later.Y.val(d)));
    },
    end: function (d) {
      return d.YEnd || (d.YEnd = later.date.prev(later.Y.val(d)));
    },
    next: function (d, val) {
      return val > later.Y.val(d) && val <= later.Y.extent()[1] ? later.date.next(val) : later.NEVER;
    },
    prev: function (d, val) {
      return val < later.Y.val(d) && val >= later.Y.extent()[0] ? later.date.prev(val) : later.NEVER;
    }
  };
  later.fullDate = later.fd = {
    name: "full date",
    range: 1,
    val: function (d) {
      return d.fd || (d.fd = d.getTime());
    },
    isValid: function (d, val) {
      return later.fd.val(d) === val;
    },
    extent: function () {
      return [0, 3250368e7];
    },
    start: function (d) {
      return d;
    },
    end: function (d) {
      return d;
    },
    next: function (d, val) {
      return later.fd.val(d) < val ? new Date(val) : later.NEVER;
    },
    prev: function (d, val) {
      return later.fd.val(d) > val ? new Date(val) : later.NEVER;
    }
  };
  later.modifier = {};

  later.modifier.after = later.modifier.a = function (constraint, values) {
    var value = values[0];
    return {
      name: "after " + constraint.name,
      range: (constraint.extent(new Date())[1] - value) * constraint.range,
      val: constraint.val,
      isValid: function (d, val) {
        return this.val(d) >= value;
      },
      extent: constraint.extent,
      start: constraint.start,
      end: constraint.end,
      next: function (startDate, val) {
        if (val != value) val = constraint.extent(startDate)[0];
        return constraint.next(startDate, val);
      },
      prev: function (startDate, val) {
        val = val === value ? constraint.extent(startDate)[1] : value - 1;
        return constraint.prev(startDate, val);
      }
    };
  };

  later.modifier.before = later.modifier.b = function (constraint, values) {
    var value = values[values.length - 1];
    return {
      name: "before " + constraint.name,
      range: constraint.range * (value - 1),
      val: constraint.val,
      isValid: function (d, val) {
        return this.val(d) < value;
      },
      extent: constraint.extent,
      start: constraint.start,
      end: constraint.end,
      next: function (startDate, val) {
        val = val === value ? constraint.extent(startDate)[0] : value;
        return constraint.next(startDate, val);
      },
      prev: function (startDate, val) {
        val = val === value ? value - 1 : constraint.extent(startDate)[1];
        return constraint.prev(startDate, val);
      }
    };
  };

  later.compile = function (schedDef) {
    var constraints = [],
        constraintsLen = 0,
        tickConstraint;

    for (var key in schedDef) {
      var nameParts = key.split("_"),
          name = nameParts[0],
          mod = nameParts[1],
          vals = schedDef[key],
          constraint = mod ? later.modifier[mod](later[name], vals) : later[name];
      constraints.push({
        constraint: constraint,
        vals: vals
      });
      constraintsLen++;
    }

    constraints.sort(function (a, b) {
      var ra = a.constraint.range,
          rb = b.constraint.range;
      return rb < ra ? -1 : rb > ra ? 1 : 0;
    });
    tickConstraint = constraints[constraintsLen - 1].constraint;

    function compareFn(dir) {
      return dir === "next" ? function (a, b) {
        return a.getTime() > b.getTime();
      } : function (a, b) {
        return b.getTime() > a.getTime();
      };
    }

    return {
      start: function (dir, startDate) {
        var next = startDate,
            nextVal = later.array[dir],
            maxAttempts = 1e3,
            done;

        while (maxAttempts-- && !done && next) {
          done = true;

          for (var i = 0; i < constraintsLen; i++) {
            var constraint = constraints[i].constraint,
                curVal = constraint.val(next),
                extent = constraint.extent(next),
                newVal = nextVal(curVal, constraints[i].vals, extent);

            if (!constraint.isValid(next, newVal)) {
              next = constraint[dir](next, newVal);
              done = false;
              break;
            }
          }
        }

        if (next !== later.NEVER) {
          next = dir === "next" ? tickConstraint.start(next) : tickConstraint.end(next);
        }

        return next;
      },
      end: function (dir, startDate) {
        var result,
            nextVal = later.array[dir + "Invalid"],
            compare = compareFn(dir);

        for (var i = constraintsLen - 1; i >= 0; i--) {
          var constraint = constraints[i].constraint,
              curVal = constraint.val(startDate),
              extent = constraint.extent(startDate),
              newVal = nextVal(curVal, constraints[i].vals, extent),
              next;

          if (newVal !== undefined) {
            next = constraint[dir](startDate, newVal);

            if (next && (!result || compare(result, next))) {
              result = next;
            }
          }
        }

        return result;
      },
      tick: function (dir, date) {
        return new Date(dir === "next" ? tickConstraint.end(date).getTime() + later.SEC : tickConstraint.start(date).getTime() - later.SEC);
      },
      tickStart: function (date) {
        return tickConstraint.start(date);
      }
    };
  };

  later.schedule = function (sched) {
    if (!sched) throw new Error("Missing schedule definition.");
    if (!sched.schedules) throw new Error("Definition must include at least one schedule.");
    var schedules = [],
        schedulesLen = sched.schedules.length,
        exceptions = [],
        exceptionsLen = sched.exceptions ? sched.exceptions.length : 0;

    for (var i = 0; i < schedulesLen; i++) {
      schedules.push(later.compile(sched.schedules[i]));
    }

    for (var j = 0; j < exceptionsLen; j++) {
      exceptions.push(later.compile(sched.exceptions[j]));
    }

    function getInstances(dir, count, startDate, endDate, isRange) {
      var compare = compareFn(dir),
          loopCount = count,
          maxAttempts = 1e6,
          schedStarts = [],
          exceptStarts = [],
          next,
          end,
          results = [],
          isForward = dir === "next",
          lastResult,
          rStart = isForward ? 0 : 1,
          rEnd = isForward ? 1 : 0;
      startDate = startDate ? new Date(startDate) : new Date();
      if (!startDate || !startDate.getTime()) throw new Error("Invalid start date.");
      setNextStarts(dir, schedules, schedStarts, startDate);
      setRangeStarts(dir, exceptions, exceptStarts, startDate);

      while (maxAttempts-- && loopCount && (next = findNext(schedStarts, compare))) {
        if (endDate && compare(next, endDate)) {
          break;
        }

        if (exceptionsLen) {
          updateRangeStarts(dir, exceptions, exceptStarts, next);

          if (end = calcRangeOverlap(dir, exceptStarts, next)) {
            updateNextStarts(dir, schedules, schedStarts, end);
            continue;
          }
        }

        if (isRange) {
          var maxEndDate = calcMaxEndDate(exceptStarts, compare);
          end = calcEnd(dir, schedules, schedStarts, next, maxEndDate);
          var r = isForward ? [new Date(Math.max(startDate, next)), end ? new Date(endDate ? Math.min(end, endDate) : end) : undefined] : [end ? new Date(endDate ? Math.max(endDate, end.getTime() + later.SEC) : end.getTime() + later.SEC) : undefined, new Date(Math.min(startDate, next.getTime() + later.SEC))];

          if (lastResult && r[rStart].getTime() === lastResult[rEnd].getTime()) {
            lastResult[rEnd] = r[rEnd];
            loopCount++;
          } else {
            lastResult = r;
            results.push(lastResult);
          }

          if (!end) break;
          updateNextStarts(dir, schedules, schedStarts, end);
        } else {
          results.push(isForward ? new Date(Math.max(startDate, next)) : getStart(schedules, schedStarts, next, endDate));
          tickStarts(dir, schedules, schedStarts, next);
        }

        loopCount--;
      }

      for (var i = 0, len = results.length; i < len; i++) {
        var result = results[i];
        results[i] = Object.prototype.toString.call(result) === "[object Array]" ? [cleanDate(result[0]), cleanDate(result[1])] : cleanDate(result);
      }

      return results.length === 0 ? later.NEVER : count === 1 ? results[0] : results;
    }

    function cleanDate(d) {
      if (d instanceof Date && !isNaN(d.valueOf())) {
        return new Date(d);
      }

      return undefined;
    }

    function setNextStarts(dir, schedArr, startsArr, startDate) {
      for (var i = 0, len = schedArr.length; i < len; i++) {
        startsArr[i] = schedArr[i].start(dir, startDate);
      }
    }

    function updateNextStarts(dir, schedArr, startsArr, startDate) {
      var compare = compareFn(dir);

      for (var i = 0, len = schedArr.length; i < len; i++) {
        if (startsArr[i] && !compare(startsArr[i], startDate)) {
          startsArr[i] = schedArr[i].start(dir, startDate);
        }
      }
    }

    function setRangeStarts(dir, schedArr, rangesArr, startDate) {
      var compare = compareFn(dir);

      for (var i = 0, len = schedArr.length; i < len; i++) {
        var nextStart = schedArr[i].start(dir, startDate);

        if (!nextStart) {
          rangesArr[i] = later.NEVER;
        } else {
          rangesArr[i] = [nextStart, schedArr[i].end(dir, nextStart)];
        }
      }
    }

    function updateRangeStarts(dir, schedArr, rangesArr, startDate) {
      var compare = compareFn(dir);

      for (var i = 0, len = schedArr.length; i < len; i++) {
        if (rangesArr[i] && !compare(rangesArr[i][0], startDate)) {
          var nextStart = schedArr[i].start(dir, startDate);

          if (!nextStart) {
            rangesArr[i] = later.NEVER;
          } else {
            rangesArr[i] = [nextStart, schedArr[i].end(dir, nextStart)];
          }
        }
      }
    }

    function tickStarts(dir, schedArr, startsArr, startDate) {
      for (var i = 0, len = schedArr.length; i < len; i++) {
        if (startsArr[i] && startsArr[i].getTime() === startDate.getTime()) {
          startsArr[i] = schedArr[i].start(dir, schedArr[i].tick(dir, startDate));
        }
      }
    }

    function getStart(schedArr, startsArr, startDate, minEndDate) {
      var result;

      for (var i = 0, len = startsArr.length; i < len; i++) {
        if (startsArr[i] && startsArr[i].getTime() === startDate.getTime()) {
          var start = schedArr[i].tickStart(startDate);

          if (minEndDate && start < minEndDate) {
            return minEndDate;
          }

          if (!result || start > result) {
            result = start;
          }
        }
      }

      return result;
    }

    function calcRangeOverlap(dir, rangesArr, startDate) {
      var compare = compareFn(dir),
          result;

      for (var i = 0, len = rangesArr.length; i < len; i++) {
        var range = rangesArr[i];

        if (range && !compare(range[0], startDate) && (!range[1] || compare(range[1], startDate))) {
          if (!result || compare(range[1], result)) {
            result = range[1];
          }
        }
      }

      return result;
    }

    function calcMaxEndDate(exceptsArr, compare) {
      var result;

      for (var i = 0, len = exceptsArr.length; i < len; i++) {
        if (exceptsArr[i] && (!result || compare(result, exceptsArr[i][0]))) {
          result = exceptsArr[i][0];
        }
      }

      return result;
    }

    function calcEnd(dir, schedArr, startsArr, startDate, maxEndDate) {
      var compare = compareFn(dir),
          result;

      for (var i = 0, len = schedArr.length; i < len; i++) {
        var start = startsArr[i];

        if (start && start.getTime() === startDate.getTime()) {
          var end = schedArr[i].end(dir, start);

          if (maxEndDate && (!end || compare(end, maxEndDate))) {
            return maxEndDate;
          }

          if (!result || compare(end, result)) {
            result = end;
          }
        }
      }

      return result;
    }

    function compareFn(dir) {
      return dir === "next" ? function (a, b) {
        return !b || a.getTime() > b.getTime();
      } : function (a, b) {
        return !a || b.getTime() > a.getTime();
      };
    }

    function findNext(arr, compare) {
      var next = arr[0];

      for (var i = 1, len = arr.length; i < len; i++) {
        if (arr[i] && compare(next, arr[i])) {
          next = arr[i];
        }
      }

      return next;
    }

    return {
      isValid: function (d) {
        return getInstances("next", 1, d, d) !== later.NEVER;
      },
      next: function (count, startDate, endDate) {
        return getInstances("next", count || 1, startDate, endDate);
      },
      prev: function (count, startDate, endDate) {
        return getInstances("prev", count || 1, startDate, endDate);
      },
      nextRange: function (count, startDate, endDate) {
        return getInstances("next", count || 1, startDate, endDate, true);
      },
      prevRange: function (count, startDate, endDate) {
        return getInstances("prev", count || 1, startDate, endDate, true);
      }
    };
  };

  later.setTimeout = function (fn, sched) {
    var s = later.schedule(sched),
        t;

    if (fn) {
      scheduleTimeout();
    }

    function scheduleTimeout() {
      var now = Date.now(),
          next = s.next(2, now);

      if (!next[0]) {
        t = undefined;
        return;
      }

      var diff = next[0].getTime() - now;

      if (diff < 1e3) {
        diff = next[1] ? next[1].getTime() - now : 1e3;
      }

      if (diff < 2147483647) {
        t = setTimeout(fn, diff);
      } else {
        t = setTimeout(scheduleTimeout, 2147483647);
      }
    }

    return {
      isDone: function () {
        return !t;
      },
      clear: function () {
        clearTimeout(t);
      }
    };
  };

  later.setInterval = function (fn, sched) {
    if (!fn) {
      return;
    }

    var t = later.setTimeout(scheduleTimeout, sched),
        done = t.isDone();

    function scheduleTimeout() {
      if (!done) {
        fn();
        t = later.setTimeout(scheduleTimeout, sched);
      }
    }

    return {
      isDone: function () {
        return t.isDone();
      },
      clear: function () {
        done = true;
        t.clear();
      }
    };
  };

  later.date = {};

  later.date.timezone = function (useLocalTime) {
    later.date.build = useLocalTime ? function (Y, M, D, h, m, s) {
      return new Date(Y, M, D, h, m, s);
    } : function (Y, M, D, h, m, s) {
      return new Date(Date.UTC(Y, M, D, h, m, s));
    };
    var get = useLocalTime ? "get" : "getUTC",
        d = Date.prototype;
    later.date.getYear = d[get + "FullYear"];
    later.date.getMonth = d[get + "Month"];
    later.date.getDate = d[get + "Date"];
    later.date.getDay = d[get + "Day"];
    later.date.getHour = d[get + "Hours"];
    later.date.getMin = d[get + "Minutes"];
    later.date.getSec = d[get + "Seconds"];
    later.date.isUTC = !useLocalTime;
  };

  later.date.UTC = function () {
    later.date.timezone(false);
  };

  later.date.localTime = function () {
    later.date.timezone(true);
  };

  later.date.UTC();
  later.SEC = 1e3;
  later.MIN = later.SEC * 60;
  later.HOUR = later.MIN * 60;
  later.DAY = later.HOUR * 24;
  later.WEEK = later.DAY * 7;
  later.DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  later.NEVER = 0;

  later.date.next = function (Y, M, D, h, m, s) {
    return later.date.build(Y, M !== undefined ? M - 1 : 0, D !== undefined ? D : 1, h || 0, m || 0, s || 0);
  };

  later.date.nextRollover = function (d, val, constraint, period) {
    var cur = constraint.val(d),
        max = constraint.extent(d)[1];
    return (val || max) <= cur || val > max ? new Date(period.end(d).getTime() + later.SEC) : period.start(d);
  };

  later.date.prev = function (Y, M, D, h, m, s) {
    var len = arguments.length;
    M = len < 2 ? 11 : M - 1;
    D = len < 3 ? later.D.extent(later.date.next(Y, M + 1))[1] : D;
    h = len < 4 ? 23 : h;
    m = len < 5 ? 59 : m;
    s = len < 6 ? 59 : s;
    return later.date.build(Y, M, D, h, m, s);
  };

  later.date.prevRollover = function (d, val, constraint, period) {
    var cur = constraint.val(d);
    return val >= cur || !val ? period.start(period.prev(d, period.val(d) - 1)) : period.start(d);
  };

  later.parse = {};

  later.parse.cron = function (expr, hasSeconds) {
    var NAMES = {
      JAN: 1,
      FEB: 2,
      MAR: 3,
      APR: 4,
      MAY: 5,
      JUN: 6,
      JUL: 7,
      AUG: 8,
      SEP: 9,
      OCT: 10,
      NOV: 11,
      DEC: 12,
      SUN: 1,
      MON: 2,
      TUE: 3,
      WED: 4,
      THU: 5,
      FRI: 6,
      SAT: 7
    };
    var REPLACEMENTS = {
      "* * * * * *": "0/1 * * * * *",
      "@YEARLY": "0 0 1 1 *",
      "@ANNUALLY": "0 0 1 1 *",
      "@MONTHLY": "0 0 1 * *",
      "@WEEKLY": "0 0 * * 0",
      "@DAILY": "0 0 * * *",
      "@HOURLY": "0 * * * *"
    };
    var FIELDS = {
      s: [0, 0, 59],
      m: [1, 0, 59],
      h: [2, 0, 23],
      D: [3, 1, 31],
      M: [4, 1, 12],
      Y: [6, 1970, 2099],
      d: [5, 1, 7, 1]
    };

    function getValue(value, offset, max) {
      return isNaN(value) ? NAMES[value] || null : Math.min(+value + (offset || 0), max || 9999);
    }

    function cloneSchedule(sched) {
      var clone = {},
          field;

      for (field in sched) {
        if (field !== "dc" && field !== "d") {
          clone[field] = sched[field].slice(0);
        }
      }

      return clone;
    }

    function add(sched, name, min, max, inc) {
      var i = min;

      if (!sched[name]) {
        sched[name] = [];
      }

      while (i <= max) {
        if (sched[name].indexOf(i) < 0) {
          sched[name].push(i);
        }

        i += inc || 1;
      }

      sched[name].sort(function (a, b) {
        return a - b;
      });
    }

    function addHash(schedules, curSched, value, hash) {
      if (curSched.d && !curSched.dc || curSched.dc && curSched.dc.indexOf(hash) < 0) {
        schedules.push(cloneSchedule(curSched));
        curSched = schedules[schedules.length - 1];
      }

      add(curSched, "d", value, value);
      add(curSched, "dc", hash, hash);
    }

    function addWeekday(s, curSched, value) {
      var except1 = {},
          except2 = {};

      if (value === 1) {
        add(curSched, "D", 1, 3);
        add(curSched, "d", NAMES.MON, NAMES.FRI);
        add(except1, "D", 2, 2);
        add(except1, "d", NAMES.TUE, NAMES.FRI);
        add(except2, "D", 3, 3);
        add(except2, "d", NAMES.TUE, NAMES.FRI);
      } else {
        add(curSched, "D", value - 1, value + 1);
        add(curSched, "d", NAMES.MON, NAMES.FRI);
        add(except1, "D", value - 1, value - 1);
        add(except1, "d", NAMES.MON, NAMES.THU);
        add(except2, "D", value + 1, value + 1);
        add(except2, "d", NAMES.TUE, NAMES.FRI);
      }

      s.exceptions.push(except1);
      s.exceptions.push(except2);
    }

    function addRange(item, curSched, name, min, max, offset) {
      var incSplit = item.split("/"),
          inc = +incSplit[1],
          range = incSplit[0];

      if (range !== "*" && range !== "0") {
        var rangeSplit = range.split("-");
        min = getValue(rangeSplit[0], offset, max);
        max = getValue(rangeSplit[1], offset, max) || max;
      }

      add(curSched, name, min, max, inc);
    }

    function parse(item, s, name, min, max, offset) {
      var value,
          split,
          schedules = s.schedules,
          curSched = schedules[schedules.length - 1];

      if (item === "L") {
        item = min - 1;
      }

      if ((value = getValue(item, offset, max)) !== null) {
        add(curSched, name, value, value);
      } else if ((value = getValue(item.replace("W", ""), offset, max)) !== null) {
        addWeekday(s, curSched, value);
      } else if ((value = getValue(item.replace("L", ""), offset, max)) !== null) {
        addHash(schedules, curSched, value, min - 1);
      } else if ((split = item.split("#")).length === 2) {
        value = getValue(split[0], offset, max);
        addHash(schedules, curSched, value, getValue(split[1]));
      } else {
        addRange(item, curSched, name, min, max, offset);
      }
    }

    function isHash(item) {
      return item.indexOf("#") > -1 || item.indexOf("L") > 0;
    }

    function itemSorter(a, b) {
      return isHash(a) && !isHash(b) ? 1 : a - b;
    }

    function parseExpr(expr) {
      var schedule = {
        schedules: [{}],
        exceptions: []
      },
          components = expr.replace(/(\s)+/g, " ").split(" "),
          field,
          f,
          component,
          items;

      for (field in FIELDS) {
        f = FIELDS[field];
        component = components[f[0]];

        if (component && component !== "*" && component !== "?") {
          items = component.split(",").sort(itemSorter);
          var i,
              length = items.length;

          for (i = 0; i < length; i++) {
            parse(items[i], schedule, field, f[1], f[2], f[3]);
          }
        }
      }

      return schedule;
    }

    function prepareExpr(expr) {
      var prepared = expr.toUpperCase();
      return REPLACEMENTS[prepared] || prepared;
    }

    var e = prepareExpr(expr);
    return parseExpr(hasSeconds ? e : "0 " + e);
  };

  later.parse.recur = function () {
    var schedules = [],
        exceptions = [],
        cur,
        curArr = schedules,
        curName,
        values,
        every,
        modifier,
        applyMin,
        applyMax,
        i,
        last;

    function add(name, min, max) {
      name = modifier ? name + "_" + modifier : name;

      if (!cur) {
        curArr.push({});
        cur = curArr[0];
      }

      if (!cur[name]) {
        cur[name] = [];
      }

      curName = cur[name];

      if (every) {
        values = [];

        for (i = min; i <= max; i += every) {
          values.push(i);
        }

        last = {
          n: name,
          x: every,
          c: curName.length,
          m: max
        };
      }

      values = applyMin ? [min] : applyMax ? [max] : values;
      var length = values.length;

      for (i = 0; i < length; i += 1) {
        var val = values[i];

        if (curName.indexOf(val) < 0) {
          curName.push(val);
        }
      }

      values = every = modifier = applyMin = applyMax = 0;
    }

    return {
      schedules: schedules,
      exceptions: exceptions,
      on: function () {
        values = arguments[0] instanceof Array ? arguments[0] : arguments;
        return this;
      },
      every: function (x) {
        every = x || 1;
        return this;
      },
      after: function (x) {
        modifier = "a";
        values = [x];
        return this;
      },
      before: function (x) {
        modifier = "b";
        values = [x];
        return this;
      },
      first: function () {
        applyMin = 1;
        return this;
      },
      last: function () {
        applyMax = 1;
        return this;
      },
      time: function () {
        for (var i = 0, len = values.length; i < len; i++) {
          var split = values[i].split(":");
          if (split.length < 3) split.push(0);
          values[i] = +split[0] * 3600 + +split[1] * 60 + +split[2];
        }

        add("t");
        return this;
      },
      second: function () {
        add("s", 0, 59);
        return this;
      },
      minute: function () {
        add("m", 0, 59);
        return this;
      },
      hour: function () {
        add("h", 0, 23);
        return this;
      },
      dayOfMonth: function () {
        add("D", 1, applyMax ? 0 : 31);
        return this;
      },
      dayOfWeek: function () {
        add("d", 1, 7);
        return this;
      },
      onWeekend: function () {
        values = [1, 7];
        return this.dayOfWeek();
      },
      onWeekday: function () {
        values = [2, 3, 4, 5, 6];
        return this.dayOfWeek();
      },
      dayOfWeekCount: function () {
        add("dc", 1, applyMax ? 0 : 5);
        return this;
      },
      dayOfYear: function () {
        add("dy", 1, applyMax ? 0 : 366);
        return this;
      },
      weekOfMonth: function () {
        add("wm", 1, applyMax ? 0 : 5);
        return this;
      },
      weekOfYear: function () {
        add("wy", 1, applyMax ? 0 : 53);
        return this;
      },
      month: function () {
        add("M", 1, 12);
        return this;
      },
      year: function () {
        add("Y", 1970, 2450);
        return this;
      },
      fullDate: function () {
        for (var i = 0, len = values.length; i < len; i++) {
          values[i] = values[i].getTime();
        }

        add("fd");
        return this;
      },
      customModifier: function (id, vals) {
        var custom = later.modifier[id];
        if (!custom) throw new Error("Custom modifier " + id + " not recognized!");
        modifier = id;
        values = arguments[1] instanceof Array ? arguments[1] : [arguments[1]];
        return this;
      },
      customPeriod: function (id) {
        var custom = later[id];
        if (!custom) throw new Error("Custom time period " + id + " not recognized!");
        add(id, custom.extent(new Date())[0], custom.extent(new Date())[1]);
        return this;
      },
      startingOn: function (start) {
        return this.between(start, last.m);
      },
      between: function (start, end) {
        cur[last.n] = cur[last.n].splice(0, last.c);
        every = last.x;
        add(last.n, start, end);
        return this;
      },
      and: function () {
        cur = curArr[curArr.push({}) - 1];
        return this;
      },
      except: function () {
        curArr = exceptions;
        cur = null;
        return this;
      }
    };
  };

  later.parse.text = function (str) {
    var recur = later.parse.recur,
        pos = 0,
        input = "",
        error;
    var TOKENTYPES = {
      eof: /^$/,
      fullDate: /^(\d\d\d\d-\d\d-\d\dt\d\d:\d\d:\d\d)\b/,
      rank: /^((\d\d\d\d)|([2-5]?1(st)?|[2-5]?2(nd)?|[2-5]?3(rd)?|(0|[1-5]?[4-9]|[1-5]0|1[1-3])(th)?))\b/,
      time: /^((([0]?[1-9]|1[0-2]):[0-5]\d(\s)?(am|pm))|(([0]?\d|1\d|2[0-3]):[0-5]\d))\b/,
      dayName: /^((sun|mon|tue(s)?|wed(nes)?|thu(r(s)?)?|fri|sat(ur)?)(day)?)\b/,
      monthName: /^(jan(uary)?|feb(ruary)?|ma((r(ch)?)?|y)|apr(il)?|ju(ly|ne)|aug(ust)?|oct(ober)?|(sept|nov|dec)(ember)?)\b/,
      yearIndex: /^(\d\d\d\d)\b/,
      every: /^every\b/,
      after: /^after\b/,
      before: /^before\b/,
      second: /^(s|sec(ond)?(s)?)\b/,
      minute: /^(m|min(ute)?(s)?)\b/,
      hour: /^(h|hour(s)?)\b/,
      day: /^(day(s)?( of the month)?)\b/,
      dayInstance: /^day instance\b/,
      dayOfWeek: /^day(s)? of the week\b/,
      dayOfYear: /^day(s)? of the year\b/,
      weekOfYear: /^week(s)?( of the year)?\b/,
      weekOfMonth: /^week(s)? of the month\b/,
      weekday: /^weekday\b/,
      weekend: /^weekend\b/,
      month: /^month(s)?\b/,
      year: /^year(s)?\b/,
      between: /^between (the)?\b/,
      start: /^(start(ing)? (at|on( the)?)?)\b/,
      at: /^(at|@)\b/,
      and: /^(,|and\b)/,
      except: /^(except\b)/,
      also: /(also)\b/,
      first: /^(first)\b/,
      last: /^last\b/,
      "in": /^in\b/,
      of: /^of\b/,
      onthe: /^on the\b/,
      on: /^on\b/,
      through: /(-|^(to|through)\b)/
    };
    var NAMES = {
      jan: 1,
      feb: 2,
      mar: 3,
      apr: 4,
      may: 5,
      jun: 6,
      jul: 7,
      aug: 8,
      sep: 9,
      oct: 10,
      nov: 11,
      dec: 12,
      sun: 1,
      mon: 2,
      tue: 3,
      wed: 4,
      thu: 5,
      fri: 6,
      sat: 7,
      "1st": 1,
      fir: 1,
      "2nd": 2,
      sec: 2,
      "3rd": 3,
      thi: 3,
      "4th": 4,
      "for": 4
    };

    function t(start, end, text, type) {
      return {
        startPos: start,
        endPos: end,
        text: text,
        type: type
      };
    }

    function peek(expected) {
      var scanTokens = expected instanceof Array ? expected : [expected],
          whiteSpace = /\s+/,
          token,
          curInput,
          m,
          scanToken,
          start,
          len;
      scanTokens.push(whiteSpace);
      start = pos;

      while (!token || token.type === whiteSpace) {
        len = -1;
        curInput = input.substring(start);
        token = t(start, start, input.split(whiteSpace)[0]);
        var i,
            length = scanTokens.length;

        for (i = 0; i < length; i++) {
          scanToken = scanTokens[i];
          m = scanToken.exec(curInput);

          if (m && m.index === 0 && m[0].length > len) {
            len = m[0].length;
            token = t(start, start + len, curInput.substring(0, len), scanToken);
          }
        }

        if (token.type === whiteSpace) {
          start = token.endPos;
        }
      }

      return token;
    }

    function scan(expectedToken) {
      var token = peek(expectedToken);
      pos = token.endPos;
      return token;
    }

    function parseThroughExpr(tokenType) {
      var start = +parseTokenValue(tokenType),
          end = checkAndParse(TOKENTYPES.through) ? +parseTokenValue(tokenType) : start,
          nums = [];

      for (var i = start; i <= end; i++) {
        nums.push(i);
      }

      return nums;
    }

    function parseRanges(tokenType) {
      var nums = parseThroughExpr(tokenType);

      while (checkAndParse(TOKENTYPES.and)) {
        nums = nums.concat(parseThroughExpr(tokenType));
      }

      return nums;
    }

    function parseEvery(r) {
      var num, period, start, end;

      if (checkAndParse(TOKENTYPES.weekend)) {
        r.on(NAMES.sun, NAMES.sat).dayOfWeek();
      } else if (checkAndParse(TOKENTYPES.weekday)) {
        r.on(NAMES.mon, NAMES.tue, NAMES.wed, NAMES.thu, NAMES.fri).dayOfWeek();
      } else {
        num = parseTokenValue(TOKENTYPES.rank);
        r.every(num);
        period = parseTimePeriod(r);

        if (checkAndParse(TOKENTYPES.start)) {
          num = parseTokenValue(TOKENTYPES.rank);
          r.startingOn(num);
          parseToken(period.type);
        } else if (checkAndParse(TOKENTYPES.between)) {
          start = parseTokenValue(TOKENTYPES.rank);

          if (checkAndParse(TOKENTYPES.and)) {
            end = parseTokenValue(TOKENTYPES.rank);
            r.between(start, end);
          }
        }
      }
    }

    function parseOnThe(r) {
      if (checkAndParse(TOKENTYPES.first)) {
        r.first();
      } else if (checkAndParse(TOKENTYPES.last)) {
        r.last();
      } else {
        r.on(parseRanges(TOKENTYPES.rank));
      }

      parseTimePeriod(r);
    }

    function parseScheduleExpr(str) {
      pos = 0;
      input = str;
      error = -1;
      var r = recur();

      while (pos < input.length && error < 0) {
        var token = parseToken([TOKENTYPES.every, TOKENTYPES.after, TOKENTYPES.before, TOKENTYPES.onthe, TOKENTYPES.on, TOKENTYPES.of, TOKENTYPES["in"], TOKENTYPES.at, TOKENTYPES.and, TOKENTYPES.except, TOKENTYPES.also]);

        switch (token.type) {
          case TOKENTYPES.every:
            parseEvery(r);
            break;

          case TOKENTYPES.after:
            if (peek(TOKENTYPES.time).type !== undefined) {
              r.after(parseTokenValue(TOKENTYPES.time));
              r.time();
            } else if (peek(TOKENTYPES.fullDate).type !== undefined) {
              r.after(parseTokenValue(TOKENTYPES.fullDate));
              r.fullDate();
            } else {
              r.after(parseTokenValue(TOKENTYPES.rank));
              parseTimePeriod(r);
            }

            break;

          case TOKENTYPES.before:
            if (peek(TOKENTYPES.time).type !== undefined) {
              r.before(parseTokenValue(TOKENTYPES.time));
              r.time();
            } else if (peek(TOKENTYPES.fullDate).type !== undefined) {
              r.before(parseTokenValue(TOKENTYPES.fullDate));
              r.fullDate();
            } else {
              r.before(parseTokenValue(TOKENTYPES.rank));
              parseTimePeriod(r);
            }

            break;

          case TOKENTYPES.onthe:
            parseOnThe(r);
            break;

          case TOKENTYPES.on:
            r.on(parseRanges(TOKENTYPES.dayName)).dayOfWeek();
            break;

          case TOKENTYPES.of:
            r.on(parseRanges(TOKENTYPES.monthName)).month();
            break;

          case TOKENTYPES["in"]:
            r.on(parseRanges(TOKENTYPES.yearIndex)).year();
            break;

          case TOKENTYPES.at:
            r.on(parseTokenValue(TOKENTYPES.time)).time();

            while (checkAndParse(TOKENTYPES.and)) {
              r.on(parseTokenValue(TOKENTYPES.time)).time();
            }

            break;

          case TOKENTYPES.and:
            break;

          case TOKENTYPES.also:
            r.and();
            break;

          case TOKENTYPES.except:
            r.except();
            break;

          default:
            error = pos;
        }
      }

      return {
        schedules: r.schedules,
        exceptions: r.exceptions,
        error: error
      };
    }

    function parseTimePeriod(r) {
      var timePeriod = parseToken([TOKENTYPES.second, TOKENTYPES.minute, TOKENTYPES.hour, TOKENTYPES.dayOfYear, TOKENTYPES.dayOfWeek, TOKENTYPES.dayInstance, TOKENTYPES.day, TOKENTYPES.month, TOKENTYPES.year, TOKENTYPES.weekOfMonth, TOKENTYPES.weekOfYear]);

      switch (timePeriod.type) {
        case TOKENTYPES.second:
          r.second();
          break;

        case TOKENTYPES.minute:
          r.minute();
          break;

        case TOKENTYPES.hour:
          r.hour();
          break;

        case TOKENTYPES.dayOfYear:
          r.dayOfYear();
          break;

        case TOKENTYPES.dayOfWeek:
          r.dayOfWeek();
          break;

        case TOKENTYPES.dayInstance:
          r.dayOfWeekCount();
          break;

        case TOKENTYPES.day:
          r.dayOfMonth();
          break;

        case TOKENTYPES.weekOfMonth:
          r.weekOfMonth();
          break;

        case TOKENTYPES.weekOfYear:
          r.weekOfYear();
          break;

        case TOKENTYPES.month:
          r.month();
          break;

        case TOKENTYPES.year:
          r.year();
          break;

        default:
          error = pos;
      }

      return timePeriod;
    }

    function checkAndParse(tokenType) {
      var found = peek(tokenType).type === tokenType;

      if (found) {
        scan(tokenType);
      }

      return found;
    }

    function parseToken(tokenType) {
      var t = scan(tokenType);

      if (t.type) {
        t.text = convertString(t.text, tokenType);
      } else {
        error = pos;
      }

      return t;
    }

    function parseTokenValue(tokenType) {
      return parseToken(tokenType).text;
    }

    function convertString(str, tokenType) {
      var output = str;

      switch (tokenType) {
        case TOKENTYPES.time:
          var parts = str.split(/(:|am|pm)/),
              hour = parts[3] === "pm" && parts[0] < 12 ? parseInt(parts[0], 10) + 12 : parts[0],
              min = parts[2].trim();
          output = (hour.length === 1 ? "0" : "") + hour + ":" + min;
          break;

        case TOKENTYPES.rank:
          output = parseInt(/^\d+/.exec(str)[0], 10);
          break;

        case TOKENTYPES.monthName:
        case TOKENTYPES.dayName:
          output = NAMES[str.substring(0, 3)];
          break;

        case TOKENTYPES.fullDate:
          output = new Date(str.toUpperCase());
          break;
      }

      return output;
    }

    return parseScheduleExpr(str.toLowerCase());
  };

  return later;
}(); // Set the local time mode for "later" library

later.date.localTime();
/* harmony default export */ __webpack_exports__["default"] = (later);

/***/ }),

/***/ "./lib/Grid/data/GridRowModel.js":
/*!***************************************!*\
  !*** ./lib/Grid/data/GridRowModel.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GridRowModel; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
var productName = 'taskboard';

/**
 * @module Grid/data/GridRowModel
 */

/**
 * Model extended with some fields related to grid rendering. Used as default model type in the grids store if nothing
 * else is specified.
 *
 * Using this model is optional. If you use a custom model instead and need the functionality of any of the fields
 * below, you just have to remember to add fields with the same name to your model.
 *
 * @extends Core/data/Model
 */

class GridRowModel extends _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get fields() {
    return [
    /**
     * Icon for row (used automatically in tree, feel free to use it in renderer in other cases)
     * @field {String} iconCls
     * @category Styling
     */
    {
      name: 'iconCls',
      internal: true
    },
    /**
     * Start expanded or not (only valid for tree data)
     * @field {Boolean} expanded
     * @category Tree
     */
    {
      name: 'expanded',
      internal: true
    },
    /**
     * CSS class (or several classes divided by space) to append to row elements
     * @field {String} cls
     * @category Styling
     */
    {
      name: 'cls',
      internal: true
    },
    /**
     * Used by the default implementation of {@link Grid.view.GridBase#config-getRowHeight} to determine row
     * height. Set it to use another height than the default for a the records row.
     * @field {Number} rowHeight
     * @category Styling
     */
    {
      name: 'rowHeight',
      internal: true
    },
    /**
     * A link to use for this record when rendered into a {@link Grid.column.TreeColumn}.
     * @field {String} href
     * @category Tree
     */
    {
      name: 'href',
      internal: true
    },
    /**
     * The target to use if this tree node provides a value for the {@link #field-href} field.
     * @field {String} target
     * @category Tree
     */
    {
      name: 'target',
      internal: true
    }];
  }

}
GridRowModel.exposeProperties();
GridRowModel._$name = 'GridRowModel';

/***/ }),

/***/ "./lib/Scheduler/crud/AbstractCrudManager.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/crud/AbstractCrudManager.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AbstractCrudManager; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AbstractCrudManagerMixin.js */ "./lib/Scheduler/crud/AbstractCrudManagerMixin.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'taskboard';




/**
 * @module Scheduler/crud/AbstractCrudManager
 */

/**
 * This is an abstract class serving as the base for the {@link Scheduler.data.CrudManager} class.
 * It implements basic mechanisms to organize batch communication with a server.
 * Yet it does not contain methods related to _data transfer_ nor _encoding_.
 * These methods are to be provided in sub-classes by consuming the appropriate mixins.
 *
 * For example, this is how the class can be used to implement an JSON encoding system:
 *
 * ```javascript
 * // let's make new CrudManager using AJAX as a transport system and JSON for encoding
 * class MyCrudManager extends JsonEncode(AjaxTransport(AbstractCrudManager)) {
 *
 * }
 * ```
 *
 * ## Data transfer and encoding methods
 *
 * These are methods that must be provided by subclasses of this class:
 *
 * - [#sendRequest](#Scheduler/crud/AbstractCrudManagerMixin#function-sendRequest)
 * - [#cancelRequest](#Scheduler/crud/AbstractCrudManagerMixin#function-cancelRequest)
 * - [#encode](#Scheduler/crud/AbstractCrudManagerMixin#function-encode)
 * - [#decode](#Scheduler/crud/AbstractCrudManagerMixin#function-decode)
 *
 * @extends Core/Base
 * @mixes Scheduler/crud/AbstractCrudManagerMixin
 * @abstract
 */

class AbstractCrudManager extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  //region Default config

  /**
   * The server revision stamp.
   * The _revision stamp_ is a number which should be incremented after each server-side change.
   * This property reflects the current version of the data retrieved from the server and gets updated after each {@link Scheduler/crud/AbstractCrudManagerMixin#function-load} and {@link Scheduler/crud/AbstractCrudManagerMixin#function-sync} call.
   * @property {Number}
   * @readonly
   */
  get revision() {
    return this.crudRevision;
  }

  set revision(value) {
    this.crudRevision = value;
  }
  /**
   * Get or set data of {@link #property-crudStores} as a JSON string.
   *
   * Get a JSON string:
   * ```javascript
   *
   * const jsonString = scheduler.crudManager.json;
   *
   * // returned jsonString:
   * '{"eventsData":[...],"resourcesData":[...],...}'
   *
   * // object representation of the returned jsonString:
   * {
   *     resourcesData    : [...],
   *     eventsData       : [...],
   *     assignmentsData  : [...],
   *     dependenciesData : [...],
   *     timeRangesData   : [...],
   *     // data from other stores
   * }
   * ```
   *
   * Set a JSON string (to populate the CrudManager stores):
   *
   * ```javascript
   * scheduler.crudManager.json = '{"eventsData":[...],"resourcesData":[...],...}'
   * ```
   *
   * @property {String}
   */


  get json() {
    return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].safeJsonStringify(this);
  }

  set json(json) {
    if (typeof json === 'string') {
      json = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].safeJsonParse(json);
    }

    this.forEachCrudStore(store => {
      const dataName = `${store.storeId}Data`;

      if (json[dataName]) {
        store.data = json[dataName];
      }
    });
  }

  static get defaultConfig() {
    return {
      /**
       * Sets the list of stores controlled by the CRUD manager.
       *
       * When adding a store to the CrudManager, make sure the server response format is correct for `load` and `sync` requests.
       * Learn more in the [Working with data](#Scheduler/guides/data/crud_manager.md#loading-data) guide.
       *
       * Store can be provided by itself, its storeId or an object having the following structure:
       * @property {String} stores.storeId Unique store identifier. Under this name the store related requests/responses will be sent.
       * @property {Core.data.Store} stores.store The store itself.
       * @property {String} [stores.phantomIdField] Set this if the store model has a predefined field to keep phantom record identifier.
       * @property {String} [stores.idField] id field name, if it's not specified then class will try to get it from a store model.
       * @config {Core.data.Store[]|String[]|Object[]}
       */
      stores: null
      /**
       * Encodes request to the server.
       * @function encode
       * @param {Object} request The request to encode.
       * @returns {String} The encoded request.
       * @abstract
       */

      /**
       * Decodes response from the server.
       * @function decode
       * @param {String} response The response to decode.
       * @returns {Object} The decoded response.
       * @abstract
       */

    };
  } //endregion
  //region Init


  construct(config = {}) {
    if (config.stores) {
      config.crudStores = config.stores;
      delete config.stores;
    }

    super.construct(config);
  } //endregion
  //region inline data

  /**
   * Returns the data from all CrudManager `crudStores` in a format that can be consumed by `inlineData`.
   *
   * Used by JSON.stringify to correctly convert this CrudManager to json.
   *
   * The returned data is identical to what {@link Scheduler/crud/AbstractCrudManager#property-inlineData} contains.
   *
   * ```javascript
   *
   * const json = scheduler.crudManager.toJSON();
   *
   * // json:
   * {
   *     eventsData : [...],
   *     resourcesData : [...],
   *     dependenciesData : [...],
   *     assignmentsData : [...],
   *     timeRangesData : [...],
   *     resourceTimeRangesData : [...],
   *     // ... other stores data
   * }
   * ```
   *
   * Output can be consumed by `inlineData`.
   *
   * ```javascript
   * const json = scheduler.crudManager.toJSON();
   *
   * // Plug it back in later
   * scheduler.crudManager.inlineData = json;
   * ```
   *
   * @function toJSON
   * @returns {Object}
   * @category JSON
   */


  toJSON() {
    // Collect data from crudStores
    const result = {};
    this.forEachCrudStore((store, storeId) => result[`${storeId}Data`] = store.toJSON());
    return result;
  }
  /**
   * Get or set data of CrudManager stores. The returned data is identical to what
   * {@link Scheduler/crud/AbstractCrudManager#function-toJSON} returns:
   *
   * ```javascript
   *
   * const data = scheduler.crudManager.inlineData;
   *
   * // data:
   * {
   *     eventsData : [...],
   *     resourcesData : [...],
   *     dependenciesData : [...],
   *     assignmentsData : [...],
   *     timeRangesData : [...],
   *     resourceTimeRangesData : [...],
   *     ... other stores data
   * }
   *
   *
   * // Plug it back in later
   * scheduler.crudManager.inlineData = data;
   * ```
   *
   * @property {Object}
   */


  get inlineData() {
    return this.toJSON();
  }

  set inlineData(data) {
    this.json = data;
  } //endregion
  //region Store collection (add, remove, get & iterate)


  set stores(stores) {
    if (stores !== this.crudStores) {
      this.crudStores = stores;
    }
  }
  /**
   * A list of registered stores whose server communication will be collected into a single batch.
   * Each store is represented by a _store descriptor_, an object having following structure:
   * @member {Object[]} stores
   * @property {String} stores.storeId Unique store identifier.
   * @property {Core.data.Store} stores.store Store itself.
   * @property {String} [stores.phantomIdField] Set this if store model has a predefined field to keep phantom record identifier.
   * @property {String} [stores.idField] id field name, if it's not specified then class will try to get it from a store model.
   */


  get stores() {
    return this.crudStores;
  } //endregion

  /**
   * Returns true if the crud manager is currently loading data
   * @property {Boolean}
   * @readonly
   * @category CRUD
   */


  get isLoading() {
    return this.isCrudManagerLoading;
  }
  /**
   * DEPRECATED in favor of {@link #function-acceptChanges}
   */


  commit() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].deprecate('Scheduler', '5.0.0', 'commit is deprecated, in favor of acceptChanges');
    this.commitCrudStores();
  }
  /**
   * DEPRECATED in favor of {@link #function-revertChanges}
   */


  reject() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].deprecate('Scheduler', '5.0.0', 'reject is deprecated, in favor of revertChanges');
    this.revertChanges();
  }
  /**
   * Adds a store to the collection.
   *
   *```javascript
   * // append stores to the end of collection
   * crudManager.addStore([
   *     store1,
   *     // storeId
   *     'bar',
   *     // store descriptor
   *     {
   *         storeId : 'foo',
   *         store   : store3
   *     },
   *     {
   *         storeId         : 'bar',
   *         store           : store4,
   *         // to write all fields of modified records
   *         writeAllFields  : true
   *     }
   * ]);
   *```
   *
   * **Note:** Order in which stores are kept in the collection is very essential sometimes.
   * Exactly in this order the loaded data will be put into each store.
   *
   * When adding a store to the CrudManager, make sure the server response format is correct for `load` and `sync` requests.
   * Learn more in the [Working with data](#Scheduler/guides/data/crud_manager.md#loading-data) guide.
   *
   * @param {Core.data.Store|String|Object|Core.data.Store[]|String[]|Object[]} store
   * A store or list of stores. Each store might be specified by its instance, `storeId` or _descriptor_.
   * The _store descriptor_ is an object having following properties:
   * @param {String} store.storeId The store identifier that will be used as a key in requests.
   * @param {Core.data.Store} store.store The store itself.
   * @param {String} [store.idField] The idField of the store. If not specified will be taken from the store model.
   * @param {String} [store.phantomIdField] The field holding unique Ids of phantom records (if store has such model).
   * @param {Boolean} [store.writeAllFields] Set to true to write all fields from modified records
   * @param {Number} [position] The relative position of the store. If `fromStore` is specified the this position will be taken relative to it.
   * If not specified then store(s) will be appended to the end of collection.
   * Otherwise it will be just a position in stores collection.
   *
   * ```javascript
   * // insert stores store4, store5 to the start of collection
   * crudManager.addStore([ store4, store5 ], 0);
   * ```
   *
   * @param {String|Core.data.Store|Object} [fromStore] The store relative to which position should be calculated. Can be defined as a store identifier, instance or descriptor (the result of {@link Scheduler/crud/AbstractCrudManagerMixin#function-getStoreDescriptor} call).
   *
   * ```javascript
   * // insert store6 just before a store having storeId equal to 'foo'
   * crudManager.addStore(store6, 0, 'foo');
   *
   * // insert store7 just after store3 store
   * crudManager.addStore(store7, 1, store3);
   * ```
   */


  addStore(...args) {
    return this.addCrudStore(...args);
  }

  removeStore(...args) {
    return this.removeCrudStore(...args);
  }

  getStore(...args) {
    return this.getCrudStore(...args);
  }

  hasChanges(...args) {
    return this.crudStoreHasChanges(...args);
  }

  loadData(...args) {
    return this.loadCrudManagerData(...args);
  }

}
AbstractCrudManager._$name = 'AbstractCrudManager';

/***/ }),

/***/ "./lib/Scheduler/crud/AbstractCrudManagerMixin.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/crud/AbstractCrudManagerMixin.js ***!
  \********************************************************/
/*! exports provided: AbstractCrudManagerError, CrudManagerRequestError, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractCrudManagerError", function() { return AbstractCrudManagerError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrudManagerRequestError", function() { return CrudManagerRequestError; });
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _mixin_AbstractCrudManagerValidation_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixin/AbstractCrudManagerValidation.js */ "./lib/Scheduler/crud/mixin/AbstractCrudManagerValidation.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';










/**
 * @module Scheduler/crud/AbstractCrudManagerMixin
 */

class AbstractCrudManagerError extends Error {}
class CrudManagerRequestError extends AbstractCrudManagerError {
  constructor(cfg = {}) {
    var _cfg$request, _this$request;

    super(cfg.message || cfg.request && _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].capitalize((_cfg$request = cfg.request) === null || _cfg$request === void 0 ? void 0 : _cfg$request.type) + ' failed' || 'Crud Manager request failed');
    Object.assign(this, cfg);
    this.action = (_this$request = this.request) === null || _this$request === void 0 ? void 0 : _this$request.type;
  }

}

const storeSortFn = function (lhs, rhs, sortProperty) {
  // TODO: get rid of these StoreDescriptors. Just use Stores.
  if (lhs.store) {
    lhs = lhs.store;
  }

  if (rhs.store) {
    rhs = rhs.store;
  }

  lhs = lhs[sortProperty] || 0;
  rhs = rhs[sortProperty] || 0;
  return lhs < rhs ? -1 : lhs > rhs ? 1 : 0;
},
      // Sorter function to keep stores in loadPriority order
storeLoadSortFn = function (lhs, rhs) {
  return storeSortFn(lhs, rhs, 'loadPriority');
},
      // Sorter function to keep stores in syncPriority order
storeSyncSortFn = function (lhs, rhs) {
  return storeSortFn(lhs, rhs, 'syncPriority');
};
/**
 * An abstract mixin that supplies most of the CrudManager functionality.
 * It implements basic mechanisms of collecting stores to organize batch communication with a server.
 * It does not contain methods related to _data transfer_ nor _encoding_.
 * These methods are to be provided in sub-classes.
 * Out of the box there are mixins implementing {@link Scheduler/crud/transport/AjaxTransport support of AJAX for data transferring}
 * and {@link Scheduler/crud/encoder/JsonEncoder JSON for data encoding system}.
 * For example this is how we make a model that will implement CrudManager protocol and use AJAX/JSON to pass the dada to the server:
 *
 * ```javascript
 * class SystemSettings extends JsonEncode(AjaxTransport(AbstractCrudManagerMixin(Model))) {
 *     ...
 * }
 * ```
 *
 * ## Data transfer and encoding methods
 *
 * These are methods that must be provided by subclasses of this class:
 *
 * - {@link #function-sendRequest}
 * - {@link #function-cancelRequest}
 * - {@link #function-encode}
 * - {@link #function-decode}
 *
 * @mixin
 * @mixes Core/mixin/Delayable
 * @mixes Core/mixin/Events
 * @mixes Scheduler/crud/mixin/AbstractCrudManagerValidation
 * @abstract
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => {
  // Trigger $meta calculation to get up-to-date is "isXXX" flags
  // (kinky construction to avoid production minification faced in Angular https://github.com/bryntum/support/issues/2889)
  Target.$$meta = Target.$meta;
  const mixins = []; // These two mixins are mixed in the Scheduling Engine code ..but in its own way
  // so that Base.mixin() cannot understand that they are already there and applies them 2nd time

  if (!Target.isEvents) {
    mixins.push(_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_7__["default"]);
  }

  if (!Target.isDelayable) {
    mixins.push(_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_1__["default"]);
  }

  mixins.push(_mixin_AbstractCrudManagerValidation_js__WEBPACK_IMPORTED_MODULE_9__["default"]);
  return class AbstractCrudManagerMixin extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"]).mixin(...mixins) {
    /**
     * Fires before server response gets applied to the stores. Return `false` to prevent data applying.
     * This event can be used for server data preprocessing. To achieve it user can modify the `response` object.
     * @event beforeResponseApply
     * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
     * @param {String} requestType The request type (`sync` or `load`).
     * @param {Object} response The decoded server response object.
     */

    /**
     * Fires before loaded data get applied to the stores. Return `false` to prevent data applying.
     * This event can be used for server data preprocessing. To achieve it user can modify the `response` object.
     * @event beforeLoadApply
     * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
     * @param {Object} response The decoded server response object.
     * @param {Object} options Options provided to the {@link #function-load} method.
     */

    /**
     * Fires before sync response data get applied to the stores. Return `false` to prevent data applying.
     * This event can be used for server data preprocessing. To achieve it user can modify the `response` object.
     * @event beforeSyncApply
     * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
     * @param {Object} response The decoded server response object.
     */
    static get $name() {
      return 'AbstractCrudManagerMixin';
    } //region Default config


    static get defaultConfig() {
      return {
        /**
         * The server revision stamp.
         * The _revision stamp_ is a number which should be incremented after each server-side change.
         * This property reflects the current version of the data retrieved from the server and gets updated after each {@link #function-load} and {@link #function-sync} call.
         * @property {Number}
         * @readonly
         */
        crudRevision: null,

        /**
         * A list of registered stores whose server communication will be collected into a single batch.
         * Each store is represented by a _store descriptor_, an object having following structure:
         * @member {Object[]} crudStores
         * @property {String} crudStores.storeId Unique store identifier.
         * @property {Core.data.Store} crudStores.store Store itself.
         * @property {String} [crudStores.phantomIdField] Set this if store model has a predefined field to keep phantom record identifier.
         * @property {String} [crudStores.idField] id field name, if it's not specified then class will try to get it from a store model.
         */

        /**
         * Sets the list of stores controlled by the CRUD manager.
         *
         * When adding a store to the CrudManager, make sure the server response format is correct for `load` and `sync` requests.
         * Learn more in the [Working with data](#Scheduler/guides/data/crud_manager.md#loading-data) guide.
         *
         * Store can be provided by itself, its storeId or an object having the following structure:
         * @property {String} stores.storeId Unique store identifier. Under this name the store related requests/responses will be sent.
         * @property {Core.data.Store} stores.store The store itself.
         * @property {String} [stores.phantomIdField] Set this if the store model has a predefined field to keep phantom record identifier.
         * @property {String} [stores.idField] id field name, if it's not specified then class will try to get it from a store model.
         * @config {Core.data.Store[]|String[]|Object[]}
         */
        crudStores: [],

        /**
         * Name of a store property to retrieve store identifiers from.
         * Store identifier is used as a container name holding corresponding store data while transferring them to/from the server.
         * By default `storeId` property is used. And in case a container identifier has to differ this config can be used:
         *
         * ```javascript
         * class CatStore extends Store {
         *     // storeId is "meow" but for sending/receiving store data
         *     // we want have "cats" container in JSON, so we create a new property "storeIdForCrud"
         *     storeId          : 'meow',
         *     storeIdForCrud   : 'cats'
         * });
         *
         * class MyCrudManager extends CrudManager {
         *     ...
         *     crudStores           : ['meow'],
         *     // crud manager will get store identifier from "storeIdForCrud" property
         *     storeIdProperty  : 'storeIdForCrud'
         * });
         * ```
         * The `storeIdProperty` property can also be specified directly on a store:
         *
         * ```javascript
         * class CatStore extends Store {
         *     // storeId is "meow" but for sending/receiving store data
         *     // we want have "cats" container in JSON
         *     storeId          : 'meow',
         *     // so we create a new property "storeIdForCrud"..
         *     storeIdForCrud  : 'cats',
         *     // and point CrudManager to use it as the store identifier source
         *     storeIdProperty  : 'storeIdForCrud'
         * });
         *
         * class DogStore extends Store {
         *     // storeId is "dogs" and it will be used as a container name for the store data
         *     storeId          : 'dogs'
         * });
         *
         * class MyCrudManager extends CrudManager {
         *     ...
         *     crudStores           : ['meow', 'dogs']
         * });
         * ```
         * @config {String}
         */
        storeIdProperty: 'storeId',
        // TODO: no support for remote filtering yet
        // /**
        //  * The name of the 'filter' parameter to send in a load request.
        //  * @config {String}
        //  * @default
        //  */
        crudFilterParam: 'filter',

        /**
         * Sends request to the server.
         * @function sendRequest
         * @param {Object} request The request to send. An object having following properties:
         * @param {String} request.data {@link #function-encode Encoded} request.
         * @param {String} request.type Request type, can be either `load` or `sync`
         * @param {Function} request.success Callback to be started on successful request transferring
         * @param {Function} request.failure Callback to be started on request transfer failure
         * @param {Object} request.thisObj `this` reference for the above `success` and `failure` callbacks
         * @return {Promise} The request promise.
         * @abstract
         */

        /**
         * Cancels request to the server.
         * @function cancelRequest
         * @param {Promise} promise The request promise to cancel (a value returned by corresponding {@link #function-sendRequest} call).
         * @param {Function} reject Reject handle of the corresponding promise
         * @abstract
         */

        /**
         * Encodes request to the server.
         * @function encode
         * @param {Object} request The request to encode.
         * @returns {String} The encoded request.
         * @abstract
         */

        /**
         * Decodes response from the server.
         * @function decode
         * @param {String} response The response to decode.
         * @returns {Object} The decoded response.
         * @abstract
         */
        transport: {},

        /**
         * When `true` forces the CRUD manager to process responses depending on their `type` attribute.
         * So `load` request may be responded with `sync` response for example.
         * Can be used for smart server logic allowing the server to decide when it's better to respond with a complete data set (`load` response)
         * or it's enough to return just a delta (`sync` response).
         * @config {Boolean}
         * @default
         */
        trackResponseType: false,

        /**
         * When `true` the Crud Manager does not require
         * all updated and removed records to be mentioned in the *sync* response.
         * In this case response should include only server side changes.
         *
         * **Please note that added records should still be mentioned in response
         * to provide real identifier instead of the phantom one.**
         * @config {Boolean}
         * @default
         */
        supportShortSyncResponse: true,

        /**
         * Field name to be used to transfer a phantom record identifier.
         * @config {String}
         * @default
         */
        phantomIdField: '$PhantomId',

        /**
         * Field name to be used to transfer a phantom parent record identifier.
         * @config {String}
         * @default
         */
        phantomParentIdField: '$PhantomParentId',

        /**
         * `true` to automatically call {@link #function-load} method after creation.
         * @config {Boolean}
         * @default
         */
        autoLoad: false,

        /**
         * The timeout in milliseconds to wait before persisting changes to the server.
         * Used when {@link #config-autoSync} is set to `true`.
         * @config {Number}
         * @default
         */
        autoSyncTimeout: 100,

        /**
         * `true` to automatically persist store changes after edits are made in any of the stores monitored.
         * Please note that sync request will not be invoked immediately but only after {@link #config-autoSyncTimeout} interval.
         * @config {Boolean}
         * @default
         */
        autoSync: false,

        /**
         * `True` to reset identifiers (defined by `idField` config) of phantom records before submitting them to the server.
         * @config {Boolean}
         * @default
         */
        resetIdsBeforeSync: true,

        /**
         * @member {Object[]} syncApplySequence
         * An array of stores presenting an alternative sync responses apply order.
         * Each store is represented by a _store descriptor_, an object having following structure:
         * @property {String} syncApplySequence.storeId Unique store identifier.
         * @property {Core.data.Store} syncApplySequence.store Store itself.
         * @property {String} [syncApplySequence.phantomIdField] Set this if store model has a predefined field to keep phantom record identifier.
         * @property {String} [syncApplySequence.idField] id field name, if it's not specified then class will try to get it from a store model.
         */

        /**
         * An array of store identifiers sets an alternative sync responses apply order.
         * By default the order in which sync responses are applied to the stores is the same as they registered in.
         * But in case of some tricky dependencies between stores this order can be changed:
         *
         *```javascript
        * class MyCrudManager extends CrudManager {
        *     // register stores (they will be loaded in the same order: 'store1' then 'store2' and finally 'store3')
        *     crudStores : ['store1', 'store2', 'store3'],
        *     // but we apply changes from server to them in an opposite order
        *     syncApplySequence : ['store3', 'store2', 'store1']
        * });
        *```
        * @config {String[]}
        */
        syncApplySequence: [],
        orderedCrudStores: [],

        /**
         * `true` to write all fields from the record to the server.
         * If set to `false` it will only send the fields that
         * were modified.
         * Note that any fields that have {@link Core/data/field/DataField#config-persist} set to `false` will still be ignored and fields
         * having {@link Core/data/field/DataField#config-alwaysWrite} set to `true` will always be included.
         * @config {Boolean}
         * @default
         */
        writeAllFields: false,
        crudIgnoreUpdates: 0,
        autoSyncSuspendCounter: 0,
        // Flag that shows if crud manager performed successful load request
        crudLoaded: false,
        autoSyncTimerId: null,
        applyingLoadResponse: false,
        applyingSyncResponse: false,
        callOnFunctions: true
      };
    }

    get isCrudManager() {
      return true;
    } //endregion
    //region Init


    construct(config = {}) {
      this._requestId = 0;
      this.activeRequests = {};
      this.crudStoresIndex = {};
      super.construct(config);
    }

    afterConstruct() {
      super.afterConstruct();

      if (this.autoLoad) {
        this._autoLoadPromise = this.doAutoLoad();
      }
    } //endregion
    //region Load


    doAutoLoad() {
      return this.load().catch(error => {});
    } //endregion
    //region Store descriptors & index

    /**
     * Returns a registered store descriptor.
     * @param {String|Core.data.Store} storeId The store identifier or registered store instance.
     * @returns {Object} The descriptor of the store.
     */


    getStoreDescriptor(storeId) {
      if (!storeId) return null;
      if (storeId instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"]) return this.crudStores.find(storeDesc => storeDesc.store === storeId);
      if (typeof storeId === 'object') return this.crudStoresIndex[storeId.storeId];
      return this.crudStoresIndex[storeId] || this.getStoreDescriptor(_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStore(storeId));
    }

    fillStoreDescriptor(descriptor) {
      const {
        store
      } = descriptor,
            {
        storeIdProperty = this.storeIdProperty,
        modelClass
      } = store;

      if (!descriptor.storeId) {
        descriptor.storeId = store[storeIdProperty];
      }

      if (!descriptor.idField) {
        descriptor.idField = modelClass.idField;
      }

      if (!descriptor.phantomIdField) {
        descriptor.phantomIdField = modelClass.phantomIdField;
      }

      if (!descriptor.phantomParentIdField) {
        descriptor.phantomParentIdField = modelClass.phantomParentIdField;
      }

      if (!('writeAllFields' in descriptor)) {
        descriptor.writeAllFields = store.writeAllFields;
      }

      return descriptor;
    }

    updateCrudStoreIndex() {
      const crudStoresIndex = this.crudStoresIndex = {};
      this.crudStores.forEach(store => store.storeId && (crudStoresIndex[store.storeId] = store));
    } //endregion
    //region Store collection (add, remove, get & iterate)

    /**
     * Returns a registered store.
     * @param {String} storeId Store identifier.
     * @returns {Core.data.Store} Found store instance.
     */


    getCrudStore(storeId) {
      const storeDescriptor = this.getStoreDescriptor(storeId);
      return storeDescriptor === null || storeDescriptor === void 0 ? void 0 : storeDescriptor.store;
    }

    forEachCrudStore(fn, thisObj = this) {
      if (!fn) {
        throw new Error('Iterator function must be provided');
      }

      this.crudStores.every(store => fn.call(thisObj, store.store, store.storeId, store) !== false);
    }

    set crudStores(stores) {
      this._crudStores = [];
      this.addCrudStore(stores); // Ensure preconfigured stores stay stable at the start of the array when
      // addPrioritizedStore attempts to insert in order. Only featured gantt/scheduler stores
      // must participate in the ordering. If they were configured in, they must not move.

      for (const store of this._crudStores) {
        store.loadPriority = store.syncPriority = 0;
      }
    }

    get crudStores() {
      return this._crudStores;
    }

    get orderedCrudStores() {
      return this._orderedCrudStores;
    }

    set orderedCrudStores(stores) {
      return this._orderedCrudStores = stores;
    }

    set syncApplySequence(stores) {
      this._syncApplySequence = [];
      this.addStoreToApplySequence(stores);
    }

    get syncApplySequence() {
      return this._syncApplySequence;
    }

    internalAddCrudStore(store) {
      const me = this;
      let storeInfo; // if store instance provided

      if (store instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
        storeInfo = {
          store
        };
      } else if (typeof store === 'object') {
        // normalize sub-stores (if any)
        if (store.stores) {
          if (!Array.isArray(store.stores)) {
            store.stores = [store.stores];
          }

          store.stores.forEach((subStore, j) => {
            let subStoreInfo = subStore;

            if (typeof subStore === 'string') {
              subStoreInfo = {
                storeId: subStore
              };
            } // keep reference to the "master" store descriptor


            subStoreInfo.masterStoreInfo = store;
            store.stores[j] = subStoreInfo;
          });
        } else if (!store.store) {
          // not a store descriptor, assume it is a store config
          store = {
            storeId: store.id,
            store: new _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"](store)
          };
        }

        storeInfo = store;
      } // if it's a store identifier
      else {
        storeInfo = {
          store: _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"].getStore(store)
        };
      }

      me.fillStoreDescriptor(storeInfo); // store instance

      store = storeInfo.store; // if the store has "setCrudManager" hook - use it

      if (store.setCrudManager) {
        store.setCrudManager(me);
      } // otherwise decorate the store w/ "crudManager" property
      else {
        store.crudManager = me;
      } // Stores have a defaultConfig for pageSize. CrudManager does not support that.
      // TODO: PORT currently no support for paging.


      store.pageSize = null; // Prevent AjaxStores from performing their own CRUD operations

      if (store.load) {
        store.autoCommit = false;
        store.autoLoad = false;
      } // listen to store changes


      me.bindCrudStoreListeners(store);
      return storeInfo;
    }
    /**
     * Adds a store to the collection.
     *
     *```javascript
    * // append stores to the end of collection
    * crudManager.addCrudStore([
    *     store1,
    *     // storeId
    *     'bar',
    *     // store descriptor
    *     {
    *         storeId : 'foo',
    *         store   : store3
    *     },
    *     {
    *         storeId         : 'bar',
    *         store           : store4,
    *         // to write all fields of modified records
    *         writeAllFields  : true
    *     }
    * ]);
    *```
    *
    * **Note:** Order in which stores are kept in the collection is very essential sometimes.
    * Exactly in this order the loaded data will be put into each store.
     *
     * When adding a store to the CrudManager, make sure the server response format is correct for `load` and `sync` requests.
     * Learn more in the [Working with data](#Scheduler/guides/data/crud_manager.md#loading-data) guide.
     *
    * @param {Core.data.Store|String|Object|Core.data.Store[]|String[]|Object[]} store
    * A store or list of stores. Each store might be specified by its instance, `storeId` or _descriptor_.
    * The _store descriptor_ is an object having following properties:
    * @param {String} store.storeId The store identifier that will be used as a key in requests.
    * @param {Core.data.Store} store.store The store itself.
    * @param {String} [store.idField] The idField of the store. If not specified will be taken from the store model.
    * @param {String} [store.phantomIdField] The field holding unique Ids of phantom records (if store has such model).
    * @param {Boolean} [store.writeAllFields] Set to true to write all fields from modified records
    * @param {Number} [position] The relative position of the store. If `fromStore` is specified the this position will be taken relative to it.
    * If not specified then store(s) will be appended to the end of collection.
    * Otherwise it will be just a position in stores collection.
    *
    * ```javascript
    * // insert stores store4, store5 to the start of collection
    * crudManager.addCrudStore([ store4, store5 ], 0);
    * ```
    *
    * @param {String|Core.data.Store|Object} [fromStore] The store relative to which position should be calculated. Can be defined as a store identifier, instance or descriptor (the result of {@link #function-getStoreDescriptor} call).
    *
    * ```javascript
    * // insert store6 just before a store having storeId equal to 'foo'
    * crudManager.addCrudStore(store6, 0, 'foo');
    *
    * // insert store7 just after store3 store
    * crudManager.addCrudStore(store7, 1, store3);
    * ```
    */


    addCrudStore(store, position, fromStore) {
      if (!store) return;
      if (!Array.isArray(store)) store = [store];
      if (!store.length) return;
      const me = this,
            stores = store.map(me.internalAddCrudStore, me); // if no position specified then append stores to the end

      if (typeof position === 'undefined') {
        me.crudStores.push(...stores);
      } // if position specified
      else {
        // if specified the store relative to which we should insert new one(-s)
        if (fromStore) {
          if (fromStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"] || typeof fromStore !== 'object') fromStore = me.getStoreDescriptor(fromStore); // get its position

          position += me.crudStores.indexOf(fromStore);
        } // insert new store(-s)
        //me.crudStores.splice.apply(me.crudStores, [].concat([pos, 0], stores));


        me.crudStores.splice(position, 0, ...stores);
      }

      me.orderedCrudStores.push(...stores);
      me.updateCrudStoreIndex();
    } // Adds configured scheduler stores to the store collection ensuring correct order
    // unless they're already registered.


    addPrioritizedStore(store) {
      const me = this;

      if (!me.hasCrudStore(store)) {
        this.addCrudStore(store, _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].findInsertionIndex(store, me.crudStores, storeLoadSortFn));
      }

      if (!me.hasApplySequenceStore(store)) {
        this.addStoreToApplySequence(store, _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].findInsertionIndex(store, me.syncApplySequence, storeSyncSortFn));
      }
    }

    hasCrudStore(store) {
      var _this$crudStores;

      return (_this$crudStores = this.crudStores) === null || _this$crudStores === void 0 ? void 0 : _this$crudStores.some(s => s === store || s.store === store || s.storeId === store);
    }
    /**
     * Removes a store from collection. If the store was registered in alternative sync sequence list
     * it will be removed from there as well.
     *
     * ```javascript
     * // remove store having storeId equal to "foo"
     * crudManager.removeCrudStore("foo");
     *
     * // remove store3
     * crudManager.removeCrudStore(store3);
     * ```
     *
     * @param {Object|String|Core.data.Store} store The store to remove. Either the store descriptor, store identifier or store itself.
     */


    removeCrudStore(store) {
      const me = this,
            stores = me.crudStores,
            foundStore = stores.find(s => s === store || s.store === store || s.storeId === store);

      if (foundStore) {
        // unbind store listeners
        me.unbindCrudStoreListeners(foundStore.store);
        delete me.crudStoresIndex[foundStore.storeId];
        _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].remove(stores, foundStore);

        if (me.syncApplySequence) {
          me.removeStoreFromApplySequence(store);
        }
      } else {
        throw new Error('Store not found in stores collection');
      }
    } //endregion
    //region Store listeners


    bindCrudStoreListeners(store) {
      store.on({
        name: store.id,
        // When a tentatively added record gets confirmed as permanent, this signals a change
        addConfirmed: 'onCrudStoreChange',
        change: 'onCrudStoreChange',
        destroy: 'onCrudStoreDestroy',
        thisObj: this
      });
    }

    unbindCrudStoreListeners(store) {
      this.detachListeners(store.id);
    } //endregion
    //region Apply sequence

    /**
     * Adds a store to the alternative sync responses apply sequence.
     * By default the order in which sync responses are applied to the stores is the same as they registered in.
     * But this order can be changes either on construction step using {@link #config-syncApplySequence} option
     * or but calling this method.
     *
     * **Please note**, that if the sequence was not initialized before this method call then
     * you will have to do it yourself like this for example:
     *
     * ```javascript
     * // alternative sequence was not set for this crud manager
     * // so let's fill it with existing stores keeping the same order
     * crudManager.addStoreToApplySequence(crudManager.crudStores);
     *
     * // and now we can add our new store
     *
     * // we will load its data last
     * crudManager.addCrudStore(someNewStore);
     * // but changes to it will be applied first
     * crudManager.addStoreToApplySequence(someNewStore, 0);
     * ```
     * add registered stores to the sequence along with the store(s) you want to add
     *
     * @param {Core.data.Store|Object|Core.data.Store[]|Object[]} store The store to add or its _descriptor_ (or array of stores or descriptors).
     * Where _store descriptor_ is an object having following properties:
     * @param {String} store.storeId The store identifier that will be used as a key in requests.
     * @param {Core.data.Store} store.store The store itself.
     * @param {String} [store.idField] The idField of the store. If not specified will be taken from the store model.
     * @param {String} [store.phantomIdField] The field holding unique Ids of phantom records (if store has such model).
    * @param {Number} [position] The relative position of the store. If `fromStore` is specified the this position will be taken relative to it.
    * If not specified then store(s) will be appended to the end of collection.
    * Otherwise it will be just a position in stores collection.
    *
    * ```javascript
    * // insert stores store4, store5 to the start of sequence
    * crudManager.addStoreToApplySequence([ store4, store5 ], 0);
    * ```
    * @param {String|Core.data.Store|Object} [fromStore] The store relative to which position should be calculated. Can be defined as a store identifier, instance or its descriptor (the result of {@link #function-getStoreDescriptor} call).
    *
    * ```javascript
    * // insert store6 just before a store having storeId equal to 'foo'
    * crudManager.addStoreToApplySequence(store6, 0, 'foo');
    *
    * // insert store7 just after store3 store
    * crudManager.addStoreToApplySequence(store7, 1, store3);
    * ```
    */


    addStoreToApplySequence(store, position, fromStore) {
      if (!store) return;
      if (!Array.isArray(store)) store = [store];
      const me = this,
            // loop over list of stores to add
      data = store.reduce((collection, store) => {
        const s = me.getStoreDescriptor(store);
        if (s) collection.push(s);
        return collection;
      }, []); // if no position specified then append stores to the end

      if (typeof position === 'undefined') {
        me.syncApplySequence.push(...data); // if position specified
      } else {
        let pos = position; // if specified the store relative to which we should insert new one(-s)

        if (fromStore) {
          if (fromStore instanceof _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_0__["default"] || typeof fromStore !== 'object') fromStore = me.getStoreDescriptor(fromStore); // get its position

          pos += me.syncApplySequence.indexOf(fromStore);
        } // insert new store(-s)
        //me.syncApplySequence.splice.apply(me.syncApplySequence, [].concat([pos, 0], data));


        me.syncApplySequence.splice(pos, 0, ...data);
      }

      const sequenceKeys = me.syncApplySequence.map(({
        storeId
      }) => storeId);
      me.orderedCrudStores = [...me.syncApplySequence];
      me.crudStores.forEach(storeDesc => {
        if (!sequenceKeys.includes(storeDesc.storeId)) {
          me.orderedCrudStores.push(storeDesc);
        }
      });
    }
    /**
     * Removes a store from the alternative sync sequence.
     *
     * ```javascript
     * // remove store having storeId equal to "foo"
     * crudManager.removeStoreFromApplySequence("foo");
     * ```
     *
     * @param {Object|String|Core.data.Store} store The store to remove. Either the store descriptor, store identifier or store itself.
     */


    removeStoreFromApplySequence(store) {
      const index = this.syncApplySequence.findIndex(s => s === store || s.store === store || s.storeId === store);

      if (index > -1) {
        this.syncApplySequence.splice(index, 1); // ordered crud stores list starts with syncApplySequence, we can use same index

        this.orderedCrudStores.splice(index, 1);
      }
    }

    hasApplySequenceStore(store) {
      return this.syncApplySequence.some(s => s === store || s.store === store || s.storeId === store);
    } //endregion
    //region Events
    // onNodeRemove(oldParent) {
    //     var treeStore = oldParent && oldParent.getTreeStore();
    //     // "noderemove" event is fired too early and getRemovedRecords() don't not have the removed node yet
    //     // so we wait till tree store "endupdate" event and only then invoke "onCrudStoreChange" method
    //     treeStore && treeStore.on('endupdate', this.onCrudStoreChange, this, { once : true });
    // }
    // onStoreUpdate(store, record, operation, fields) {
    //     if ((!store.isTreeStore || record !== store.getRoot())) {
    //         // If only a single field was changed, make sure it's a persistable field to avoid full scan of the store
    //         // Collapsing/expanding a tree node will trigger this behavior otherwise
    //         var isSingleNonPersistField = fields && fields.length === 1 && record.getField(fields[0]) && !record.getField(fields[0]).persist;
    //
    //         if (!isSingleNonPersistField) {
    //             this.onCrudStoreChange();
    //         }
    //     }
    // }
    // onTreeStoreInsertOrAppend(parent, child) {
    //     if (!child.isRoot()) {
    //         this.onCrudStoreChange();
    //     }
    // }
    // Remove stores that are destroyed, to not try and apply response changes etc to them


    onCrudStoreDestroy({
      source: store
    }) {
      this.removeCrudStore(store);
    }

    onCrudStoreChange() {
      const me = this;

      if (me.crudIgnoreUpdates) {
        return;
      }
      /**
       * Fires when data in any of the registered data stores is changed.
       * ```javascript
       *     crudManager.on('hasChanges', function (crud) {
       *         // enable persist changes button when some store gets changed
       *         saveButton.enable();
       *     });
       * ```
       * @event hasChanges
       * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
       */


      if (me.crudStoreHasChanges()) {
        me.trigger('hasChanges');

        if (me.autoSync) {
          me.scheduleAutoSync();
        }
      } else {
        me.trigger('noChanges');
      }
    }
    /**
     * Suspends automatic sync upon store changes. Can be called multiple times (it uses an internal counter).
     */


    suspendAutoSync() {
      this.autoSyncSuspendCounter++;
    }
    /**
     * Resumes automatic sync upon store changes. Will trigger commit if the internal counter is 0.
     * @param {Boolean} [doSync=true] Pass `true` to trigger data syncing after resuming (if there are pending changes)
     * and `false` to not persist the changes.
     */


    resumeAutoSync(doSync = true) {
      const me = this;
      me.autoSyncSuspendCounter--;

      if (me.autoSyncSuspendCounter <= 0) {
        me.autoSyncSuspendCounter = 0; // if its told to trigger persisting and there are changes

        if (doSync && me.autoSync && me.crudStoreHasChanges()) {
          me.sync();
        }
      }
    }

    scheduleAutoSync() {
      const me = this; // add deferred call if it's not scheduled yet

      if (!me.autoSyncTimerId && !me.autoSyncSuspendCounter) {
        me.autoSyncTimerId = me.setTimeout(() => {
          me.autoSyncTimerId = null;
          me.sync().catch(error => {});
        }, me.autoSyncTimeout);
      }
    }

    async triggerFailedRequestEvents(request, response, responseText, fetchOptions) {
      const me = this,
            {
        options,
        type: requestType
      } = request;
      /**
       * Fires when a request fails.
       * @event requestFail
       * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager instance.
       * @param {String} requestType The request type (`sync` or `load`).
       * @param {Object} response The decoded server response object.
       * @param {String} responseText The raw server response text
       * @param {Object} responseOptions The response options.
       */

      me.trigger('requestFail', {
        requestType,
        response,
        responseText,
        responseOptions: fetchOptions
      });
      /**
       * Fires when a {@link #function-load load request} fails.
       * @event loadFail
       * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager instance.
       * @param {Object} response The decoded server response object.
       * @param {String} responseText The raw server response text
       * @param {Object} responseOptions The response options.
       * @params {Object} options Options provided to the {@link #function-load} method.
       */

      /**
       * Fires when a {@link #function-sync sync request} fails.
       * @event syncFail
       * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager instance.
       * @param {Object} response The decoded server response object.
       * @param {String} responseText The raw server response text
       * @param {Object} responseOptions The response options.
       */

      me.trigger(requestType + 'Fail', {
        response,
        responseOptions: fetchOptions,
        responseText,
        options
      });
    }

    async internalOnResponse(request, responseText, fetchOptions) {
      const me = this,
            response = responseText ? me.decode(responseText) : null,
            {
        options,
        type: requestType
      } = request;

      if (responseText && !response) {
        console.error('Failed to parse response: ' + responseText);
      }

      if (!response || (me.skipSuccessProperty ? response.success === false : !response.success)) {
        me.triggerFailedRequestEvents(request, response, responseText, fetchOptions);
      } else if (me.trigger('beforeResponseApply', {
        requestType,
        response
      }) !== false && me.trigger('before' + _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].capitalize(requestType) + 'Apply', {
        response,
        options
      }) !== false) {
        me.crudRevision = response.revision;
        await me.applyResponse(request, response, options);
        /**
         * Fires on successful request completion after data gets applied to the stores.
         * @event requestDone
         * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
         * @param {String} requestType The request type (`sync` or `load`).
         * @param {Object} response The decoded server response object.
         * @param {Object} responseOptions The server response options.
         */

        me.trigger('requestDone', {
          requestType,
          response,
          responseOptions: fetchOptions
        });
        /**
         * Fires on successful {@link #function-load load request} completion after data gets loaded to the stores.
         * @event load
         * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
         * @param {Object} response The decoded server response object.
         * @param {Object} responseOptions The server response options.
         * @params {Object} options Options provided to the {@link #load} method.
         */

        /**
         * Fires on successful {@link #function-sync sync request} completion.
         * @event sync
         * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
         * @param {Object} response The decoded server response object.
         * @param {Object} responseOptions The server response options.
         */

        me.trigger(requestType, {
          response,
          responseOptions: fetchOptions,
          options
        });

        if (requestType === 'load' || !me.crudStoreHasChanges()) {
          /**
           * Fires when registered stores get into state when they don't have any
           * not persisted change. This happens after {@link #function-load} or {@link #function-sync} request
           * completion. Or this may happen after a record update which turns its fields back to their original state.
           *
           * ```javascript
           * crudManager.on('nochanges', function (crud) {
           *     // disable persist changes button when there is no changes
           *     saveButton.disable();
           * });
           * ```
           *
           * @event noChanges
           * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
           */
          me.trigger('noChanges');

          if (requestType === 'load') {
            me.emitCrudStoreEvents(request.pack.stores, 'afterRequest');
          }
        }
      }

      return response;
    } //endregion
    //region Changes tracking


    suspendChangesTracking() {
      this.crudIgnoreUpdates++;
    }

    resumeChangesTracking(skipChangeCheck) {
      if (this.crudIgnoreUpdates && ! --this.crudIgnoreUpdates && !skipChangeCheck) {
        this.onCrudStoreChange();
      }
    }

    get isBatchingChanges() {
      return this.crudIgnoreUpdates > 0;
    }
    /**
     * Returns `true` if any of registered stores (or some particular store) has non persisted changes.
     *
     * ```javascript
     * // if we have any unsaved changes
     * if (crudManager.crudStoreHasChanges()) {
     *     // persist them
     *     crudManager.sync();
     * // otherwise
     * } else {
     *     alert("There are no unsaved changes...");
     * }
     * ```
     *
     * @param {String|Core.data.Store} [storeId] The store identifier or store instance to check changes for.
     * If not specified then will check changes for all of the registered stores.
     * @returns {Boolean} `true` if there are not persisted changes.
     */


    crudStoreHasChanges(storeId) {
      return storeId ? this.isCrudStoreDirty(this.getCrudStore(storeId)) : this.crudStores.some(this.isCrudStoreDirty);
    }

    isCrudStoreDirty(store) {
      return Boolean(store === null || store === void 0 ? void 0 : store.store.changes);
    } //endregion
    //region Load


    emitCrudStoreEvents(stores, eventName, eventParams) {
      const event = _objectSpread({
        action: 'read' + eventName
      }, eventParams);

      for (const store of this.crudStores) {
        if (stores.includes(store.storeId)) {
          store.store.trigger(eventName, event);
        }
      }
    }

    getLoadPackage(options) {
      const pack = {
        type: 'load',
        requestId: this.requestId
      },
            stores = this.crudStores,
            optionsCopy = Object.assign({}, options); // This is a special option which does not apply to a store.
      // It's used as options to the AjaxTransport#sendRequest method

      delete optionsCopy.request;
      pack.stores = stores.map(store => {
        var _store$store;

        const opts = optionsCopy === null || optionsCopy === void 0 ? void 0 : optionsCopy[store.storeId],
              pageSize = store.pageSize || ((_store$store = store.store) === null || _store$store === void 0 ? void 0 : _store$store.pageSize); // TODO: PORT currently no support for remote filters
        // if the store uses remote filtering
        // if (store.store.remoteFilter && filterParam) {
        //
        //     opts = opts || {};
        //
        //     var filters = [];
        //
        //     store.store.getFilters().each(function(f) {
        //         filters.push(f.serialize());
        //     });
        //
        //     // put filters info into the package
        //     opts[filterParam] = filters;
        // }
        // TODO: PORT currently no support for paging

        if (opts || pageSize) {
          const params = Object.assign({
            storeId: store.storeId,
            page: 1
          }, opts);

          if (pageSize) {
            params.pageSize = pageSize;
          }

          store.currentPage = params.page; // Remove from common request options

          if (opts) {
            delete optionsCopy[store.storeId];
          }

          return params;
        }

        return store.storeId;
      }); // Apply common request options

      Object.assign(pack, optionsCopy);
      return pack;
    }

    loadCrudStore(store, data, options) {
      const rows = data === null || data === void 0 ? void 0 : data.rows;

      if (options !== null && options !== void 0 && options.append || data !== null && data !== void 0 && data.append) {
        store.add(rows);
      } else {
        store.data = rows;
      }

      store.trigger('load', {
        data: rows
      });
    }

    loadDataToCrudStore(storeDesc, data, options) {
      const me = this,
            store = storeDesc.store,
            // nested stores list
      subStores = storeDesc.stores,
            idField = storeDesc.idField || 'id',
            //model && model.meta.idField || 'id',
      isTree = store.tree,
            rows = data === null || data === void 0 ? void 0 : data.rows;
      store.__loading = true;

      if (rows) {
        let subData;

        if (subStores) {
          subData = me.getSubStoresData(rows, subStores, idField, isTree);
        }

        me.loadCrudStore(store, data, options, storeDesc);

        if (subData) {
          // load sub-stores as well (if we have them)
          subData.forEach(sub => {
            me.loadDataToCrudStore(Object.assign({
              store: store.getById(sub.id).get(sub.storeDesc.storeId) // TODO: PORT have to check what this does

            }, sub.storeDesc), sub.data);
          });
        }
      }

      store.__loading = false;
    }
    /**
     * Loads data to the Crud Manager
     * @param {Object} response A simple object representing the data.
     * The object structure matches the decoded `load` response structure:
     *
     * ```js
     * // load static data into crudManager
     * crudManager.loadCrudManagerData({
     *     success   : true,
     *     resources : {
     *         rows : [
     *             { id : 1, name : 'John' },
     *             { id : 2, name : 'Abby' }
     *         ]
     *     }
     * });
     * ```
     * @param {Object} [options] Extra data loading options.
     */


    loadCrudManagerData(response, options = {}) {
      // we don't want to react to store changes during loading of them
      this.suspendChangesTracking(); // we load data to the stores in the order they're kept in this.stores array

      this.crudStores.forEach(storeDesc => {
        const storeId = storeDesc.storeId,
              data = response[storeId];

        if (data) {
          this.loadDataToCrudStore(storeDesc, data, options[storeId]);
        }
      });
      this.resumeChangesTracking(true);
    }
    /**
     * Returns true if the crud manager is currently loading data
     * @property {Boolean}
     * @readonly
     * @category CRUD
     */


    get isCrudManagerLoading() {
      return Boolean(this.activeRequests.load || this.applyingLoadResponse);
    }
    /**
     * Returns true if the crud manager is currently syncing data
     * @property {Boolean}
     * @readonly
     * @category CRUD
     */


    get isCrudManagerSyncing() {
      return Boolean(this.activeRequests.sync || this.applyingSyncResponse);
    }

    get isLoadingOrSyncing() {
      return Boolean(this.isCrudManagerLoading || this.isCrudManagerSyncing);
    }
    /**
     * Loads data to the stores registered in the crud manager. For example:
     *
     * ```javascript
     * crudManager.load(
     *     // here are request parameters
     *     {
     *         store1 : { append : true, page : 3, smth : 'foo' },
     *         store2 : { page : 2, bar : '!!!' }
     *     }
     * ).then(
     *     () => alert('OMG! It works!'),
     *     ({ response, cancelled }) => console.log(`Error: ${cancelled ? 'Cancelled' : response.message}`)
     * );
     * ```
     *
     * ** Note: ** If there is an incomplete load request in progress then system will try to cancel it by calling {@link #function-cancelRequest}.
     * @param {Object|String} [options] The request parameters or a URL.
     * @param {Object} [options.request] An object which contains options to merge
     * into the options which are passed to {@link Scheduler/crud/transport/AjaxTransport#function-sendRequest}.
     * ```javascript
     * {
     *     store1 : { page : 3, append : true, smth : 'foo' },
     *     store2 : { page : 2, bar : '!!!' },
     *     request : {
     *         params : {
     *             startDate : '2021-01-01'
     *         }
     *     }
     * },
     * ```
     *
     * Omitting request arg:
     * ```javascript
     * crudManager.load().then(
     *     () => alert('OMG! It works!'),
     *     ({ response, cancelled }) => console.log(`Error: ${cancelled ? 'Cancelled' : response.message}`)
     * );
     * ```
     *
     * When presented it should be an object where keys are store Ids and values are, in turn, objects
     * of parameters related to the corresponding store. These parameters will be transferred in each
     * store's entry in the `stores` property of the POST data.
     *
     * Additionally for flat stores `append: true` can be specified to add loaded records to the existing records, default is to remove corresponding store's existing records first.
     * **Please note** that for delta loading you can also use an {@link #config-trackResponseType alternative approach}.
     * @param {String} [options.request.type] The request type. Either `load` or `sync`.
     * @param {String} [options.request.url] The URL for the request. Overrides the URL defined in the `transport` object
     * @param {String} [options.request.data] The encoded _Crud Manager_ request data.
     * @param {Object} [options.request.params] An object specifying extra HTTP params to send with the request.
     * @param {Function} [options.request.success] A function to be started on successful request transferring.
     * @param {String} [options.request.success.rawResponse] `Response` object returned by the [fetch api](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
     * @param {Function} [options.request.failure] A function to be started on request transfer failure.
     * @param {String} [options.request.failure.rawResponse] `Response` object returned by the [fetch api](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
     * @param {Object} [options.request.thisObj] `this` reference for the above `success` and `failure` functions.
     * @returns {Promise} Promise, which is resolved if request was successful.
     * Both the resolve and reject functions are passed a `state` object. State object has following structure:
     *
     * ```
     * {
     *     cancelled       : Boolean, // **optional** flag, which is present when promise was rejected
     *     rawResponse     : String,  // raw response from ajax request, either response xml or text
     *     rawResponseText : String,  // raw response text as String from ajax request
     *     response        : Object,  // processed response in form of object
     *     options         : Object   // options, passed to load request
     * }
     * ```
     *
     * If promise was rejected by {@link #event-beforeLoad} event, `state` object will have the following structure:
     *
     * ```
     * {
     *     cancelled : true
     * }
     * ```
     *
     */


    load(options) {
      if (typeof options === 'string') {
        options = {
          request: {
            url: options
          }
        };
      }

      const me = this,
            pack = me.getLoadPackage(options);
      return new Promise((resolve, reject) => {
        /**
         * Fires before {@link #function-load load request} is sent. Return `false` to cancel load request.
         * @event beforeLoad
         * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
         * @param {Object} pack The data package which contains data for all stores managed by the crud manager.
         */
        if (me.trigger('beforeLoad', {
          pack
        }) !== false) {
          var _options;

          // if another load request is in progress let's cancel it
          const {
            load
          } = me.activeRequests;

          if (load) {
            me.cancelRequest(load.desc, load.reject);
            me.trigger('loadCanceled', {
              pack
            });
          } // TODO: refactor this


          const request = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_5__["default"].assign({
            id: pack.requestId,
            data: me.encode(pack),
            type: 'load',
            success: me.onCrudRequestSuccess,
            failure: me.onCrudRequestFailure,
            thisObj: me
          }, (_options = options) === null || _options === void 0 ? void 0 : _options.request);
          me.activeRequests.load = {
            type: 'load',
            options,
            pack,
            resolve,

            reject(...args) {
              // sendRequest will start a fetch promise, which we cannot reject from here. In fact what we
              // need to do, is to make fetch.then() to not call any real handlers. Which is what we do here.
              request.success = request.failure = null;
              reject(...args);
            },

            id: pack.requestId,
            desc: me.sendRequest(request)
          };
          me.emitCrudStoreEvents(pack.stores, 'loadStart');
          me.trigger('loadStart', {
            pack
          });
        } else {
          /**
           * Fired after {@link #function-load load request} was canceled by some {@link #event-beforeLoad}
           * listener or due to incomplete prior load request.
           * @event loadCanceled
           * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
           * @param {Object} pack The data package which contains data for all stores managed by the crud manager.
           */
          me.trigger('loadCanceled', {
            pack
          });
          reject({
            cancelled: true
          });
        }
      });
    }

    getActiveCrudManagerRequest(requestType) {
      let request = this.activeRequests[requestType];

      if (!request && this.trackResponseType) {
        request = Object.values(this.activeRequests)[0];
      }

      return request;
    }

    getSubStoresData(rows, subStores, idField, isTree) {
      if (!rows) return;
      const result = [];

      function processRow(row, subStores) {
        subStores.forEach(subStore => {
          const storeId = subStore.storeId; // if row contains data for this sub-store

          if (row[storeId]) {
            // keep them for the later loading
            result.push({
              id: row[idField],
              storeDesc: subStore,
              data: row[storeId]
            }); // and remove reference from the row

            delete row[storeId];
          }
        });
      } // if it's a TreeStore


      if (isTree) {
        // loop over nodes
        rows.forEach(row => {
          processRow(row, subStores); // also let's grab sub-stores from node children

          const childrenSubData = this.getSubStoresData(row.children, subStores, idField, true);

          if (childrenSubData) {
            result.push(...childrenSubData);
          }
        }); // if it's a "flat" store
      } else {
        rows.forEach(row => processRow(row, subStores));
      }

      return result;
    } //endregion
    //region Changes (prepare, process, get)


    prepareAdded(list, storeInfo) {
      const {
        store,
        stores
      } = storeInfo,
            {
        isTree
      } = store,
            phantomIdField = storeInfo.phantomIdField || this.phantomIdField,
            phantomParentIdField = storeInfo.phantomParentIdField || this.phantomParentIdField;
      return list.filter(record => record.isValid).map(record => {
        const cls = record.constructor,
              data = Object.assign(record.persistableData, {
          [phantomIdField]: record.id
        });

        if (isTree) {
          const {
            parent
          } = record;

          if (parent && !parent.isRoot && parent.isPhantom) {
            data[phantomParentIdField] = parent.id;
          }
        }

        if (this.resetIdsBeforeSync) delete _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].deletePath(data, cls.getFieldDataSource(cls.idField)); // if the store has embedded ones

        if (stores) {
          this.processSubStores(record, data, stores);
        }

        return data;
      });
    }

    prepareUpdated(list, storeInfo) {
      const {
        store,
        stores
      } = storeInfo,
            {
        isTree
      } = store,
            writeAllFields = storeInfo.writeAllFields || storeInfo.writeAllFields !== false && this.writeAllFields,
            phantomParentIdField = storeInfo.phantomParentIdField || this.phantomParentIdField; // TODO: root node included into store.modified
      // need to get rid of it since we don't persist it

      if (storeInfo.store.tree) {
        const rootNode = storeInfo.store.rootNode;
        list = list.filter(record => record !== rootNode);
      }

      return list.filter(record => record.isValid).reduce((data, record) => {
        let recordData; // write all fields

        if (writeAllFields) {
          recordData = record.persistableData;
        } else {
          recordData = record.modificationDataToWrite;
        }

        if (isTree) {
          const {
            parent
          } = record;

          if (parent && !parent.isRoot && parent.isPhantom) {
            recordData[phantomParentIdField] = parent.id;
          }
        } // if the store has embedded ones


        if (stores) {
          this.processSubStores(record, recordData, stores);
        } // recordData can be null


        if (!_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEmpty(recordData)) {
          data.push(recordData);
        }

        return data;
      }, []);
    }

    prepareRemoved(list) {
      return list.map(record => {
        const cls = record.constructor;
        return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setPath({}, cls.getFieldDataSource(cls.idField), record.id);
      });
    }

    processSubStores(record, data, stores) {
      stores.forEach(store => {
        const id = store.storeId,
              subStore = record.get(id); // if embedded store is assigned to the record

        if (subStore) {
          // let's collect its changes as well
          const changes = this.getCrudStoreChanges(Object.assign({
            store: subStore
          }, store));

          if (changes) {
            data[id] = Object.assign(changes, {
              $store: true
            });
          } else {
            delete data[id];
          }
        } else {
          delete data[id];
        }
      });
    }

    getCrudStoreChanges(storeDescriptor) {
      const {
        store
      } = storeDescriptor;
      let {
        added = [],
        modified: updated = [],
        removed = []
      } = store.changes || {},
          // sub-stores
      result;
      if (added.length) added = this.prepareAdded(added, storeDescriptor);
      if (updated.length) updated = this.prepareUpdated(updated, storeDescriptor);
      if (removed.length) removed = this.prepareRemoved(removed); // if this store has changes

      if (added.length || updated.length || removed.length) {
        result = {};
        if (added.length) result.added = added;
        if (updated.length) result.updated = updated;
        if (removed.length) result.removed = removed;
      }

      return result;
    }

    getChangeSetPackage() {
      const changes = this.changes;
      return changes ? Object.assign({
        type: 'sync',
        requestId: this.requestId,
        revision: this.crudRevision
      }, changes) : null;
    } //endregion
    //region Apply

    /**
     * Returns current changes as an object consisting of added/modified/removed arrays of records for every
     * managed store. Returns `null` if no changes exist. Format:
     *
     * ```javascript
     * {
     *     resources : {
     *         added    : [{ name : 'New guy' }],
     *         modified : [{ id : 2, name : 'Mike' }],
     *         removed  : [{ id : 3 }]
     *     },
     *     events : {
     *         modified : [{  id : 12, name : 'Cool task' }]
     *     },
     *     ...
     * }
     * ```
     *
     * @property {Object}
     * @readonly
     * @category CRUD
     */


    get changes() {
      const data = {};
      this.crudStores.forEach(store => {
        const changes = this.getCrudStoreChanges(store);

        if (changes) {
          data[store.storeId] = changes;
        }
      });
      return Object.keys(data).length > 0 ? data : null;
    }

    applyChangesToRecord(record, rawChanges, stores) {
      const me = this,
            modelClass = record.constructor,
            {
        fieldDataSourceMap
      } = modelClass,
            recProto = modelClass.prototype,
            changes = {},
            data = record.data,
            done = {
        [me.phantomIdField]: true
      };
      let hasChanges; // if this store has sub-stores assigned to some fields

      if (stores) {
        // then first we apply changes to that stores
        stores.forEach(store => {
          const name = store.storeId;

          if (Object.prototype.hasOwnProperty.call(rawChanges, name)) {
            // remember that we processed this field
            done[name] = true;
            const subStore = record.get(name);

            if (subStore) {
              me.applyChangesToStore(Object.assign({
                store: subStore
              }, store), rawChanges[name]);
            } else {
              console.log('Can\'t find store for the response sub-package');
            }
          }
        });
      }

      const rawChangesFiltered = {};

      for (const key in rawChanges) {
        if (Object.prototype.hasOwnProperty.call(rawChanges, key) && !done[key]) {
          rawChangesFiltered[key] = rawChanges[key];
        }
      }

      const rowChangesSimplePaths = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].pathifyKeys(rawChangesFiltered); // Collect the changes into a change set for field names.

      for (const dataSource in rowChangesSimplePaths) {
        const field = fieldDataSourceMap[dataSource],
              propName = field ? field.name : dataSource,
              value = modelClass.processField(propName, rowChangesSimplePaths[dataSource]),
              oldValue = dataSource in recProto ? record[propName] : _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, dataSource);

        if (!(field !== null && field !== void 0 && field.isEqual ? field.isEqual(oldValue, value) : _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].isEqual(oldValue, value))) {
          hasChanges = true;
          changes[propName] = value;
        }
      }

      if (hasChanges) {
        me.suspendChangesTracking(); // Set each field separately until https://app.assembla.com/spaces/bryntum/tickets/9123 is fixed.

        for (const fieldName in changes) {
          record[fieldName] = changes[fieldName];
        } // TODO: Re-enable record.set when https://app.assembla.com/spaces/bryntum/tickets/9123 is fixed.
        // Set fields one go
        // record.set(changes);


        me.resumeChangesTracking(true);
      }

      me.clearRecordChanges(record, changes);
    }

    clearRecordChanges(record, changes) {
      // Clear changes only for the passed record,
      // not descendant nodes.
      // TODO: they *might* also be genuinely new
      // so might have to stay.
      record.clearChanges(true, false);
    }

    applyRemovals(store, removedEntries, context) {
      const {
        removed: removedStash,
        modelClass
      } = store,
            dataSource = modelClass.getFieldDataSource(modelClass.idField);
      let applied = 0;
      removedEntries === null || removedEntries === void 0 ? void 0 : removedEntries.forEach(removedEntry => {
        const id = removedEntry[dataSource];
        let done = false; // just remove the record from the removed stash

        if (removedStash.includes(id)) {
          removedStash.remove(id);
          done = true; // number of removals applied

          applied++;
        } // if responded removed record isn`t found in store.removed
        // probably don't removed on the client side yet (server driven removal)


        if (!done) {
          const record = store.getById(id);

          if (record) {
            this.suspendChangesTracking();
            record.remove();
            removedStash.remove(record); // number of removals applied

            applied++;
            this.resumeChangesTracking(true);
          } else {
            console.log('Can\'t find record to remove from the response package');
          }
        }
      });
      return applied;
    }

    getRowsToApplyChangesTo({
      store,
      storeId
    }, storeResponse, storePack) {
      var _rows, _removed;

      const me = this,
            {
        modelClass
      } = store,
            idDataSource = modelClass.getFieldDataSource(modelClass.idField),
            // request data
      {
        updated: requestUpdated,
        removed: requestRemoved
      } = storePack || {};
      let rows, removed; // If the response contains the store section

      if (storeResponse) {
        var _storeResponse$rows, _storeResponse$remove;

        const respondedIds = {}; // responded record changes/removals

        rows = ((_storeResponse$rows = storeResponse.rows) === null || _storeResponse$rows === void 0 ? void 0 : _storeResponse$rows.slice()) || [];
        removed = ((_storeResponse$remove = storeResponse.removed) === null || _storeResponse$remove === void 0 ? void 0 : _storeResponse$remove.slice()) || []; // Collect hash w/ identifiers of responded records

        [...rows, ...removed].forEach(responseRecord => {
          const id = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(responseRecord, idDataSource);
          respondedIds[id] = true;
        }); // If it's told to support providing server changes only in response
        // CrudManager should collect other records to commit from current requested data

        if (me.supportShortSyncResponse) {
          // append records requested to update (if not there already)
          requestUpdated === null || requestUpdated === void 0 ? void 0 : requestUpdated.forEach(data => {
            const id = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, idDataSource); // if response doesn't include

            if (!respondedIds[id]) {
              rows.push({
                [idDataSource]: id
              });
            }
          }); // append records requested to remove (if not there already)

          requestRemoved === null || requestRemoved === void 0 ? void 0 : requestRemoved.forEach(data => {
            const id = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, idDataSource); // if response doesn't include

            if (!respondedIds[id]) {
              removed.push({
                [idDataSource]: id
              });
            }
          });
        }
      } // If there is no this store section we use records mentioned in the current request
      else if (requestUpdated || requestRemoved) {
        rows = requestUpdated;
        removed = requestRemoved;
      } // return nullish "rows"/"removed" if no entries


      rows = (_rows = rows) !== null && _rows !== void 0 && _rows.length ? rows : null;
      removed = (_removed = removed) !== null && _removed !== void 0 && _removed.length ? removed : null;
      return {
        rows,
        removed
      };
    }

    applyChangesToStore(storeDesc, storeResponse, storePack) {
      const me = this,
            phantomIdField = storeDesc.phantomIdField || me.phantomIdField,
            {
        store,
        stores
      } = storeDesc,
            {
        modelClass
      } = store,
            idDataSource = modelClass.getFieldDataSource(modelClass.idField),
            // collect records we need to process
      {
        rows,
        removed
      } = me.getRowsToApplyChangesTo(storeDesc, storeResponse, storePack); // process added/updated records

      rows === null || rows === void 0 ? void 0 : rows.forEach(data => {
        const phantomId = data[phantomIdField],
              id = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPath(data, idDataSource);
        let record = null; // if phantomId is provided then we will use it to find added record

        if (phantomId != null) {
          record = store.getById(phantomId);
        } // if id is provided then we will use it to find updated record
        else if (id != null) {
          record = store.getById(id);
        }

        if (record) {
          me.applyChangesToRecord(record, data, stores, store);
        } else {
          me.suspendChangesTracking(); // create new record in the store

          record = store.add(data)[0];
          me.resumeChangesTracking(true);
          record.clearChanges();
        }
      }); // process removed records

      if (removed && me.applyRemovals(store, removed)) {
        store.trigger('dataChanged', {
          source: store
        });
      }
    }

    applySyncResponse(response, request) {
      const me = this,
            stores = me.orderedCrudStores;
      me.applyingSyncResponse = true;

      for (const store of stores) {
        var _request$pack;

        me.applyChangesToStore(store, response[store.storeId], request === null || request === void 0 ? void 0 : (_request$pack = request.pack) === null || _request$pack === void 0 ? void 0 : _request$pack[store.storeId]);
      }

      me.applyingSyncResponse = false;
    }

    applyLoadResponse(response, options) {
      this.applyingLoadResponse = true;
      this.loadCrudManagerData(response, options);
      this.applyingLoadResponse = false;
    }

    async applyResponse(request, response, options) {
      const me = this,
            // in trackResponseType mode we check response type before deciding how to react on the response
      responseType = me.trackResponseType && response.type || request.type;

      switch (responseType) {
        case 'load':
          if (me.validateResponse) {
            me.validateLoadResponse(response);
          }

          me.applyLoadResponse(response, options);
          break;

        case 'sync':
          if (me.validateResponse) {
            me.validateSyncResponse(response, request);
          }

          me.applySyncResponse(response, request);
          break;
      }
    } //endregion

    /**
     * Generates unique request identifier.
     * @internal
     * @template
     * @return {Number} The request identifier.
     */


    get requestId() {
      return Number.parseInt(`${Date.now()}${this._requestId++}`);
    }
    /**
     * Persists changes made on the registered stores to the server. Usage:
     *
     * ```javascript
     * // persist and run a callback on request completion
     * crud.sync().then(
     *     () => console.log("Changes saved..."),
     *     ({ response, cancelled }) => console.log(`Error: ${cancelled ? 'Cancelled' : response.message}`)
     * );
     * ```
     *
     * ** Note: ** If there is an incomplete sync request in progress then system will queue the call and delay it until previous request completion.
     * In this case {@link #event-syncDelayed} event will be fired.
     *
     * ** Note: ** Please take a look at {@link #config-autoSync} config. This option allows to persist changes automatically after any data modification.
     * @returns {Promise} Promise, which is resolved if request was successful.
     * Both the resolve and reject functions are passed a `state` object. State object has following structure:
     *
     *     {
     *         cancelled       : Boolean, // **optional** flag, which is present when promise was rejected
     *         rawResponse     : String,  // raw response from ajax request, either response xml or text
     *         rawResponseText : String,  // raw response text as String from ajax request
     *         response        : Object,  // processed response in form of object
     *     }
     *
     * If promise was rejected by {@link #event-beforeSync} event, `state` object will have structure:
     *
     *     {
     *         cancelled : true
     *     }
     *
     */


    sync() {
      const me = this;

      if (me.activeRequests.sync) {
        // let's delay this call and start it only after server response

        /**
         * Fires after {@link #function-sync sync request} was delayed due to incomplete previous one.
         * @event syncDelayed
         * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
         * @param {Object} arguments The arguments of {@link #function-sync} call.
         */
        me.trigger('syncDelayed'); // Queue sync request after current one

        return me.activeSyncPromise = me.activeSyncPromise.finally(() => me.sync());
      } // Store current request promise. While this one is pending, all following sync requests will create chain
      // of sequential promises


      return me.activeSyncPromise = new Promise((resolve, reject) => {
        // get current changes set package
        const pack = me.getChangeSetPackage(); // if no data to persist we resolve immediately

        if (!pack) {
          resolve(null);
          return;
        }
        /**
         * Fires before {@link #function-sync sync request} is sent. Return `false` to cancel sync request.
         *
         * ```javascript
         * crudManager.on('beforesync', function() {
         *     // cannot persist changes before at least one record is added
         *     // to the `someStore` store
         *     if (!someStore.getCount()) return false;
         * });
         * ```
         * @event beforeSync
         * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
         * @param {Object} pack The data package which contains data for all stores managed by the crud manager.
         */


        if (me.trigger('beforeSync', {
          pack
        }) !== false) {
          me.trigger('syncStart', {
            pack
          }); // keep active request details

          me.activeRequests.sync = {
            type: 'sync',
            pack,
            resolve,
            reject,
            id: pack.requestId,
            desc: me.sendRequest({
              id: pack.requestId,
              data: me.encode(pack),
              type: 'sync',
              success: me.onCrudRequestSuccess,
              failure: me.onCrudRequestFailure,
              thisObj: me
            })
          };
        } else {
          /**
           * Fires after {@link #function-sync sync request} was canceled by some {@link #event-beforeSync} listener.
           * @event syncCanceled
           * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager.
           * @param {Object} pack The data package which contains data for all stores managed by the crud manager.
           */
          me.trigger('syncCanceled', {
            pack
          });
          reject({
            cancelled: true
          });
        }
      }).catch(error => {
        // If the request was not cancelled in beforeSync listener, forward the error so the user's `catch` handler can catch it
        if (error && !error.cancelled) {
          throw error;
        } // Pass the error object as a param to the next `then` chain


        return error;
      });
    }

    async onCrudRequestSuccess(rawResponse, fetchOptions, request) {
      var _request;

      const me = this,
            {
        type: requestType,
        id: requestId
      } = request;
      if (me.isDestroyed) return;
      let responseText = '';
      request = me.activeRequests[requestType]; // we throw exception below to let events trigger first in internalOnResponse() call

      try {
        responseText = await rawResponse.text();
      } catch (e) {} // since we break the method w/ promises chain ..need to check if the instance is not destroyed in the meantime


      if (me.isDestroyed) return; // This situation should never occur.
      // In the load() method, if a load is called while there is a load
      // ongoing, the ongoing Transport request is cancelled and loadCanceled triggered.
      // But having got here, it's too late to cancel a Transport request, so
      // the operation is unregistered below.
      // In the sync() method, if a sync is called while there is a sync
      // ongoing, it waits until completion, before syncing.
      // The activeRequest for any operation should NEVER be able to be
      // replaced while this operation is ongoing, so this must be fatal.

      if (((_request = request) === null || _request === void 0 ? void 0 : _request.id) !== requestId) {
        throw new Error(`Interleaved ${requestType} operation detected`);
      } // Reset the active request info before we enter async code which could allow
      // application code to run which could potentially call another request.
      // It is too late for this request to be canceled - the activeRequest represented
      // the Transport object and that has completed now.


      me.activeRequests[requestType] = null;
      const response = await me.internalOnResponse(request, responseText, fetchOptions); // since we break the method w/ promises chain ..need to check if the instance is not destroyed in the meantime

      if (me.isDestroyed) return;

      if (!response || (me.skipSuccessProperty ? (response === null || response === void 0 ? void 0 : response.success) === false : !(response !== null && response !== void 0 && response.success))) {
        request.reject(new CrudManagerRequestError({
          rawResponse,
          response,
          request
        }));
      } // Successful request type done flag (this.crudLoaded or this.crudSynced)..


      me['crud' + _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].capitalize(request.type) + 'ed'] = true;
      request.resolve({
        response,
        rawResponse,
        responseText,
        request
      });
    }

    async onCrudRequestFailure(rawResponse, fetchOptions, request) {
      var _fetchOptions$abortCo;

      if (this.isDestroyed) return;
      request = this.activeRequests[request.type];
      const signal = fetchOptions === null || fetchOptions === void 0 ? void 0 : (_fetchOptions$abortCo = fetchOptions.abortController) === null || _fetchOptions$abortCo === void 0 ? void 0 : _fetchOptions$abortCo.signal,
            wasAborted = Boolean(signal === null || signal === void 0 ? void 0 : signal.aborted);

      if (!wasAborted) {
        let responseText = '';

        try {
          responseText = await rawResponse.text();
        } catch (e) {} // since we break the method w/ promises chain ..need to check if the instance is not destroyed in the meantime


        if (this.isDestroyed) return;
        this.triggerFailedRequestEvents(request, null, responseText, fetchOptions); // since we break the method w/ promises chain ..need to check if the instance is not destroyed in the meantime

        if (this.isDestroyed) return;
        request.reject(new CrudManagerRequestError({
          rawResponse,
          request
        }));
      } // reset the active request info


      this.activeRequests[request.type] = null;
    }
    /**
     * DEPRECATED in favor of {@link #function-acceptChanges}
     * @deprecated
     */


    commitCrudStores() {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].deprecate('Scheduler', '5.0.0', 'commitCrudStores is deprecated, in favor of acceptChanges');
      this.acceptChanges();
    }
    /**
     * Commits all changes of all the registered stores.
     */


    acceptChanges() {
      this.crudStores.forEach(store => store.store.acceptChanges());
    }
    /**
     * Reverts all changes in all stores and re-inserts any records that were removed locally. Any new uncommitted
     * records will be removed.
     */


    revertChanges() {
      this.orderedCrudStores.forEach(store => store.store.revertChanges());
    }
    /**
     * DEPRECATED in favor of {@link #function-revertChanges}
     * @deprecated
     */


    rejectCrudStores() {
      _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].deprecate('Scheduler', '5.0.0', 'rejectCrudStores is deprecated, in favor of revertChanges');
      this.revertChanges();
    }
    /**
     * Removes all stores and cancels active requests.
     */


    doDestroy() {
      const me = this,
            {
        load,
        sync
      } = me.activeRequests;
      load && me.cancelRequest(load.desc, load.reject);
      sync && me.cancelRequest(sync.desc, sync.reject);

      while (me.crudStores.length > 0) {
        me.removeCrudStore(me.crudStores[0]);
      }

      super.doDestroy && super.doDestroy();
    } // set crudRevision(value) {
    //     debugger
    //     this._crudRevision = value;
    // }
    // get crudRevision() {
    //     return this._crudRevision;
    // }


  };
});

/***/ }),

/***/ "./lib/Scheduler/crud/encoder/JsonEncoder.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/crud/encoder/JsonEncoder.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
var productName = 'taskboard';


/**
 * @module Scheduler/crud/encoder/JsonEncoder
 */

/**
 * Implements data encoding functional that should be mixed to a {@link Scheduler.crud.AbstractCrudManager} sub-class.
 * Uses _JSON_ as an encoding system.
 *
 * @example
 * // create a new CrudManager using AJAX as a transport system and JSON for encoding
 * class MyCrudManager extends JsonEncode(AjaxTransport(AbstractCrudManager)) {}
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class JsonEncoder extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'JsonEncoder';
  }

  static get defaultConfig() {
    return {
      /**
       * Configuration of the JSON encoder used by the _Crud Manager_.
       *
       * @config {Object}
       * @property {Object} encoder.requestData Static data to send with the data request.
       *
       * ```js
       * new CrudManager({
       *     // add static "foo" property to all requests data
       *     encoder : {
       *         requestData : {
       *             foo : 'Bar'
       *         }
       *     },
       *     ...
       * });
       * ```
       *
       * The above snippet will result adding "foo" property to all requests data:
       *
       * ```json
       *     {
       *         "requestId"   : 756,
       *         "type"        : "load",
       *
       *         "foo"         : "Bar",
       *
       *         "stores"      : [
       *             ...
       * ```
       */
      encoder: {}
    };
  }
  /**
   * Encodes a request object to _JSON_ encoded string. If encoding fails (due to circular structure), it returns null.
   * Supposed to be overridden in case data provided by the _Crud Manager_ has to be transformed into format requested by server.
   * @param {Object} requestData The request to encode.
   * @returns {String} The encoded request.
   */


  encode(requestData) {
    var _this$encoder;

    requestData = Object.assign({}, (_this$encoder = this.encoder) === null || _this$encoder === void 0 ? void 0 : _this$encoder.requestData, requestData);
    return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].safeJsonStringify(requestData);
  }
  /**
   * Decodes (parses) a _JSON_ response string to an object. If parsing fails, it returns null.
   * Supposed to be overridden in case data provided by server has to be transformed into format requested by the _Crud Manager_.
   * @param {String} responseText The response text to decode.
   * @returns {Object} The decoded response.
   */


  decode(responseText) {
    return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].safeJsonParse(responseText);
  }

});

/***/ }),

/***/ "./lib/Scheduler/crud/mixin/AbstractCrudManagerValidation.js":
/*!*******************************************************************!*\
  !*** ./lib/Scheduler/crud/mixin/AbstractCrudManagerValidation.js ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var productName = 'taskboard';
/**
* @module Scheduler/crud/mixin/AbstractCrudManagerValidation
*/

/**
 * Mixin proving responses validation API to Crud Manager.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class AbstractCrudManagerValidation extends Target {
  static get $name() {
    return 'AbstractCrudManagerValidation';
  }

  static get configurable() {
    return {
      /**
       * Config enabling responses structure validation by the Crud Manager.
       * When the config is `true` the Crud Manager checks every parsed response structure for errors
       * and if found dumps them as warnings to the browser console.
       * The config is intended to help developers implementing backend integration.
       *
       * **Please note that this option is intended for development stage only and is recommended to be disabled in production.**
       * @config {Boolean}
       * @default
       */
      validateResponse: false,

      /**
       * When `true` treats parsed responses without `success` property as successful.
       * In this mode a parsed response is treated as invalid if it has explicitly set `success : false`.
       * @config {Boolean}
       * @default
       */
      skipSuccessProperty: true,
      crudLoadValidationWarningPrefix: 'CrudManager load response error(s):',
      crudSyncValidationWarningPrefix: 'CrudManager sync response error(s):',
      supportShortSyncResponseNote: 'Note: Please consider enabling "supportShortSyncResponse" option to allow less detailed sync responses (https://bryntum.com/docs/scheduler/api/Scheduler/crud/AbstractCrudManagerMixin#config-supportShortSyncResponse)',
      disableValidationNote: 'Note: To disable this validation please set the "validateResponse" config to false'
    };
  }

  get crudLoadValidationMandatoryStores() {
    return [];
  }

  getStoreLoadResponseWarnings(storeInfo, responded, expectedResponse) {
    const messages = [],
          {
      storeId
    } = storeInfo,
          mandatoryStores = this.crudLoadValidationMandatoryStores,
          result = {
      [storeId]: {}
    }; // if the store section is responded

    if (responded) {
      if (!responded.rows) {
        messages.push(`- "${storeId}" store section should have a "rows" property with an array of the store records.`);
        result[storeId].rows = ['...'];
      }
    } // if the store is mandatory
    else if (mandatoryStores !== null && mandatoryStores !== void 0 && mandatoryStores.includes(storeId)) {
      messages.push(`- No "${storeId}" store section found. It should contain the store data.`);
      result[storeId].rows = ['...'];
    } // extend expected response w/ this store part


    if (messages.length) {
      Object.assign(expectedResponse, result);
    }

    return messages;
  }

  getLoadResponseWarnings(response) {
    const messages = [],
          expectedResponse = {};

    if (!this.skipSuccessProperty) {
      expectedResponse.success = true;
    } // iterate stores to check properties validity


    this.forEachCrudStore((store, storeId, storeInfo) => {
      messages.push(...this.getStoreLoadResponseWarnings(storeInfo, response === null || response === void 0 ? void 0 : response[storeId], expectedResponse));
    });

    if (messages.length) {
      messages.push('Please adjust your response to look like this:\n' + JSON.stringify(expectedResponse, null, 4).replace(/"\.\.\."/g, '...'));
      messages.push(this.disableValidationNote);
    }

    return messages;
  }

  validateLoadResponse(response) {
    const messages = this.getLoadResponseWarnings(response);

    if (messages.length) {
      console.warn(this.crudLoadValidationWarningPrefix + '\n' + messages.join('\n'));
    }
  }

  getStoreSyncResponseWarnings(storeInfo, requested, responded, expectedResponse) {
    const messages = [],
          missingRows = [],
          missingRemoved = [],
          {
      storeId
    } = storeInfo,
          result = {
      [storeId]: {}
    },
          phantomIdField = storeInfo.phantomIdField || this.phantomIdField,
          {
      modelClass
    } = storeInfo.store,
          idField = modelClass.getFieldDataSource(modelClass.idField),
          respondedRows = (responded === null || responded === void 0 ? void 0 : responded.rows) || [],
          respondedRemoved = (responded === null || responded === void 0 ? void 0 : responded.removed) || [];
    let showSupportShortSyncResponseNote = false; // if added records were passed in the request they should be mentioned in the response

    if (requested !== null && requested !== void 0 && requested.added) {
      missingRows.push(...requested.added.filter(record => {
        return !respondedRows.find(row => row[phantomIdField] == record[phantomIdField]) && !respondedRemoved.find(row => row[phantomIdField] == record[phantomIdField] || row[idField] == record[phantomIdField]);
      }).map(record => ({
        [phantomIdField]: record[phantomIdField],
        [idField]: '...'
      })));

      if (missingRows.length) {
        const missingIds = missingRows.map(row => '#' + row[phantomIdField]).join(', ');
        messages.push(`- "${storeId}" store "rows" section should mention added record(s) ${missingIds} sent in the request. ` + 'It should contain the added records identifiers (both phantom and "real" ones assigned by the backend).');
      }
    } // if short responses are enabled


    if (this.supportShortSyncResponse) {
      // if the data is not object, will return error
      if (!missingRows.length && responded) {
        if (typeof responded !== 'object' || Array.isArray(responded)) {
          messages.push(`- "${storeId}" store section should be an Object.`);
          result[storeId]['...'] = '...';
        } // for request to edit records, if rows is present, it must be an array


        if (responded.rows && !Array.isArray(responded.rows)) {
          messages.push(`- "${storeId}" store "rows" section should be an array`);
          missingRows.push('...');
        } // removed if presented must be an array


        if (responded.removed && !Array.isArray(responded.removed)) {
          messages.push(`- "${storeId}" store "removed" section should be an array:`);
          missingRemoved.push('...');
        }
      }
    } // if short responses are disabled
    else {
      // if updated records were passed in the request they should be mentioned in the response
      if (requested !== null && requested !== void 0 && requested.updated) {
        const missingUpdatedRows = requested.updated.filter(record => !respondedRows.find(row => row[idField] == record[idField])).map(record => ({
          [idField]: record[idField]
        }));
        missingRows.push(...missingUpdatedRows);

        if (missingUpdatedRows.length) {
          const missingIds = missingUpdatedRows.map(row => '#' + row[idField]).join(', ');
          messages.push(`- "${storeId}" store "rows" section should mention updated record(s) ${missingIds} sent in the request. ` + `It should contain the updated record identifiers.`);
          showSupportShortSyncResponseNote = true;
        }
      }

      if (missingRows.length) {
        missingRows.push('...');
      } // if removed records were passed in the request they should be mentioned in the response


      if (requested !== null && requested !== void 0 && requested.removed) {
        missingRemoved.push(...requested.removed.filter(record => !respondedRows.find(row => row[idField] == record[idField])).map(record => ({
          [idField]: record[idField]
        })));

        if (missingRemoved.length) {
          const missingIds = missingRemoved.map(row => '#' + row[idField]).join(', ');
          messages.push(`- "${storeId}" store "removed" section should mention removed record(s) ${missingIds} sent in the request. ` + `It should contain the removed record identifiers.`);
          result[storeId].removed = missingRemoved;
          missingRemoved.push('...');
          showSupportShortSyncResponseNote = true;
        }
      }
    }

    if (missingRows.length) {
      result[storeId].rows = missingRows;
    } // get rid of store section if no rows/removed there


    if (!messages.length) {
      delete result[storeId];
    } // extend expected response w/ this store part


    Object.assign(expectedResponse, result);
    return {
      messages,
      showSupportShortSyncResponseNote
    };
  }

  getSyncResponseWarnings(response, requestDesc) {
    const messages = [],
          expectedResponse = {},
          request = requestDesc.pack;

    if (!this.skipSuccessProperty) {
      expectedResponse.success = true;
    }

    let showSupportShortSyncResponseNote = false; // iterate stores to check properties validity

    this.forEachCrudStore((store, storeId, storeInfo) => {
      const warnings = this.getStoreSyncResponseWarnings(storeInfo, request === null || request === void 0 ? void 0 : request[storeId], response[storeId], expectedResponse);
      showSupportShortSyncResponseNote = showSupportShortSyncResponseNote || warnings.showSupportShortSyncResponseNote;
      messages.push(...warnings.messages);
    });

    if (messages.length) {
      messages.push('Please adjust your response to look like this:\n' + JSON.stringify(expectedResponse, null, 4).replace(/"\.\.\.":\s*"\.\.\."/g, ',,,').replace(/"\.\.\."/g, '...'));

      if (showSupportShortSyncResponseNote) {
        messages.push(this.supportShortSyncResponseNote);
      }

      messages.push(this.disableValidationNote);
    }

    return messages;
  }

  validateSyncResponse(response, request) {
    const messages = this.getSyncResponseWarnings(response, request);

    if (messages.length) {
      console.warn(this.crudSyncValidationWarningPrefix + '\n' + messages.join('\n'));
    }
  }

});

/***/ }),

/***/ "./lib/Scheduler/crud/mixin/CrudManagerView.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/crud/mixin/CrudManagerView.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_mixin_LoadMaskable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/mixin/LoadMaskable.js */ "./lib/Core/mixin/LoadMaskable.js");
/* harmony import */ var _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/widget/Mask.js */ "./lib/Core/widget/Mask.js");
var productName = 'taskboard';
/**
* @module Scheduler/crud/mixin/CrudManagerView
*/



/**
 * Mixin to track Crud Manager requests to the server and mask the view during them. For masking it
 * uses the {@link Core.mixin.LoadMaskable#config-loadMask} and {@link Core.mixin.LoadMaskable#config-syncMask}
 * properties.
 *
 * @mixin
 * @extends Core/mixin/LoadMaskable
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class CrudManagerView extends Target.mixin(_Core_mixin_LoadMaskable_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'CrudManagerView';
  } //region Init


  afterConstruct() {
    super.afterConstruct();
    const {
      crudManager,
      project
    } = this;

    if (this.loadMask && (crudManager || project).isCrudManagerLoading) {
      // Show loadMask if crud manager is already loading
      this.onCrudManagerLoadStart();
    }
  } //endregion

  /**
   * Applies the {@link Scheduler.crud.mixin.CrudManagerView#config-syncMask} as the
   * {@link Core.widget.Widget#config-masked mask} for this widget.
   * @internal
   */


  applySyncMask() {
    const {
      syncMask
    } = this;

    if (syncMask) {
      this.masked = _Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_1__["default"].mergeConfigs(this.loadMaskDefaults, syncMask);
    }
  }
  /**
   * Hooks up crud manager listeners
   * @private
   * @category Store
   */


  bindCrudManager(crudManager) {
    this.detachListeners('crudManager');
    crudManager === null || crudManager === void 0 ? void 0 : crudManager.on({
      name: 'crudManager',
      loadStart: 'onCrudManagerLoadStart',
      load: 'onCrudManagerLoad',
      loadCanceled: 'onCrudManagerLoadCanceled',
      syncStart: 'onCrudManagerSyncStart',
      sync: 'onCrudManagerSync',
      syncCanceled: 'onCrudManagerSyncCanceled',
      requestFail: 'onCrudManagerRequestFail',
      thisObj: this
    });
  }

  onCrudManagerLoadStart() {
    var _this$toggleEmptyText;

    // Show loadMask before crud manager starts loading
    this.applyLoadMask();
    (_this$toggleEmptyText = this.toggleEmptyText) === null || _this$toggleEmptyText === void 0 ? void 0 : _this$toggleEmptyText.call(this);
  }

  onCrudManagerSyncStart() {
    this.applySyncMask();
  }

  onCrudManagerRequestFinalize(successful = true, requestType, response) {
    const me = this;

    if (successful) {
      var _me$toggleEmptyText;

      me.masked = null;
      (_me$toggleEmptyText = me.toggleEmptyText) === null || _me$toggleEmptyText === void 0 ? void 0 : _me$toggleEmptyText.call(me);
    } else {
      // Do not remove. Assertion strings for Localization sanity check.
      // 'L{GridBase.loadFailedMessage}'
      // 'L{GridBase.syncFailedMessage}'
      me.applyMaskError(`<div class="b-grid-load-failure">
                    <div class="b-grid-load-fail">${me.L(`L{GridBase.${requestType}FailedMessage}`)}</div>
                    ${response && response.message ? `<div class="b-grid-load-fail">${me.L('L{CrudManagerView.serverResponseLabel}')} ${response.message}</div>` : ''}
                </div>`);
    }
  }

  onCrudManagerLoadCanceled() {
    this.onCrudManagerRequestFinalize(true, 'load');
  }

  onCrudManagerSyncCanceled() {
    this.onCrudManagerRequestFinalize(true, 'sync');
  }

  onCrudManagerLoad() {
    this.onCrudManagerRequestFinalize(true, 'load');
  }

  onCrudManagerSync() {
    this.onCrudManagerRequestFinalize(true, 'sync'); // Repaint rows to have "b-sch-dirty" class up-to-date on the event elements.
    // Needed when no new changes come from server, and there is nothing to apply back to the records.
    // TODO: when https://github.com/bryntum/support/issues/2720 is done, we can refresh specific rows (note, Calendar has many views)

    this.refresh();
  }

  onCrudManagerRequestFail({
    requestType,
    response
  }) {
    this.onCrudManagerRequestFinalize(false, requestType, response);
  }

  get widgetClass() {}

});

/***/ }),

/***/ "./lib/Scheduler/crud/transport/AjaxTransport.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/crud/transport/AjaxTransport.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
var productName = 'taskboard';



/**
 * @module Scheduler/crud/transport/AjaxTransport
 */

/**
 * Implements data transferring functional that can be used for {@link Scheduler.crud.AbstractCrudManager} super classing.
 * Uses the fetch API for transport, https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 *
 * @example
 * // create a new CrudManager using AJAX as a transport system and JSON for encoding
 * class MyCrudManager extends AjaxTransport(JsonEncode(AbstractCrudManager)) {}
 *
 * @abstract
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class AjaxTransport extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'AjaxTransport';
  }
  /**
   * Configuration of the AJAX requests used by _Crud Manager_ to communicate with a server-side.
   *
   * ```javascript
   * transport : {
   *     load : {
   *         url       : 'http://mycool-server.com/load.php',
   *         // HTTP request parameter used to pass serialized "load"-requests
   *         paramName : 'data',
   *         // pass extra HTTP request parameter
   *         params    : {
   *             foo : 'bar'
   *         }
   *     },
   *     sync : {
   *         url     : 'http://mycool-server.com/sync.php',
   *         // specify Content-Type for requests
   *         headers : {
   *             'Content-Type' : 'application/json'
   *         }
   *     }
   * }
   *```
   * Since the class uses Fetch API you can use
   * any its [Request interface](https://developer.mozilla.org/en-US/docs/Web/API/Request) options:
   *
   * ```javascript
   * transport : {
   *     load : {
   *         url         : 'http://mycool-server.com/load.php',
   *         // HTTP request parameter used to pass serialized "load"-requests
   *         paramName   : 'data',
   *         // pass few Fetch API options
   *         method      : 'GET',
   *         credentials : 'include',
   *         cache       : 'no-cache'
   *     },
   *     sync : {
   *         url         : 'http://mycool-server.com/sync.php',
   *         // specify Content-Type for requests
   *         headers     : {
   *             'Content-Type' : 'application/json'
   *         },
   *         credentials : 'include'
   *     }
   * }
   *```
   *
   * An object where you can set the following possible properties:
   * @config {Object} transport
   * @property {Object} transport.load Load requests configuration:
   * @property {String} transport.load.url URL to request for data loading.
   * @property {String} [transport.load.method='GET'] HTTP method to be used for load requests.
   * @property {String} [transport.load.paramName='data'] Name of the parameter that will contain a serialized `load` request.
   * The value is mandatory for requests using `GET` method (default for `load`) so if the value is not provided `data` string is used as default.
   * This value is optional for HTTP methods like `POST` and `PUT`, the request body will be used for data transferring in these cases.
   * @property {Object} [transport.load.params] An object containing extra HTTP parameters to pass to the server when sending a `load` request.
   *
   * ```javascript
   * transport : {
   *     load : {
   *         url       : 'http://mycool-server.com/load.php',
   *         // HTTP request parameter used to pass serialized "load"-requests
   *         paramName : 'data',
   *         // pass extra HTTP request parameter
   *         // so resulting URL will look like: http://mycool-server.com/load.php?userId=123456&data=...
   *         params    : {
   *             userId : '123456'
   *         }
   *     },
   *     ...
   * }
   * ```
   * @property {Object} [transport.load.headers] An object containing headers to pass to each server request.
   *
   * ```javascript
   * transport : {
   *     load : {
   *         url       : 'http://mycool-server.com/load.php',
   *         // HTTP request parameter used to pass serialized "load"-requests
   *         paramName : 'data',
   *         // specify Content-Type for "load" requests
   *         headers   : {
   *             'Content-Type' : 'application/json'
   *         }
   *     },
   *     ...
   * }
   * ```
   * @property {Object} [transport.load.fetchOptions] **DEPRECATED:** Any Fetch API options can be simply defined on the upper configuration level:
   * ```javascript
   * transport : {
   *     load : {
   *         url          : 'http://mycool-server.com/load.php',
   *         // HTTP request parameter used to pass serialized "load"-requests
   *         paramName    : 'data',
   *         // Fetch API options
   *         method       : 'GET',
   *         credentials  : 'include'
   *     },
   *     ...
   * }
   * ```
   * @property {Object} [transport.load.requestConfig] **DEPRECATED:** The config options can be defined on the upper configuration level.
   * @property {Object} transport.sync Sync requests (`sync` in further text) configuration:
   * @property {String} transport.sync.url URL to request for `sync`.
   * @property {String} [transport.sync.method='POST'] HTTP request method to be used for `sync`.
   * @property {String} [transport.sync.paramName=undefined] Name of the parameter in which `sync` data will be transferred.
   * This value is optional for requests using methods like `POST` and `PUT`, the request body will be used for data transferring in this case (default for `sync`).
   * And the value is mandatory for requests using `GET` method (if the value is not provided `data` string will be used as fallback).
   * @property {Object} [transport.sync.params] HTTP headers to pass with an HTTP request handling `sync`.
   *
   * ```javascript
   * transport : {
   *     sync : {
   *         url    : 'http://mycool-server.com/sync.php',
   *         // extra HTTP request parameter
   *         params : {
   *             userId : '123456'
   *         }
   *     },
   *     ...
   * }
   * ```
   * @property {Object} [transport.sync.headers] HTTP headers to pass with an HTTP request handling `sync`.
   *
   * ```javascript
   * transport : {
   *     sync : {
   *         url     : 'http://mycool-server.com/sync.php',
   *         // specify Content-Type for "sync" requests
   *         headers : {
   *             'Content-Type' : 'application/json'
   *         }
   *     },
   *     ...
   * }
   * ```
   * @property {Object} [transport.sync.fetchOptions] **DEPRECATED:** Any Fetch API options can be simply defined on the upper configuration level:
   * ```javascript
   * transport : {
   *     sync : {
   *         url         : 'http://mycool-server.com/sync.php',
   *         credentials : 'include'
   *     },
   *     ...
   * }
   * ```
   * @property {Object} [transport.sync.requestConfig] **DEPRECATED:** The config options can be defined on the upper configuration level.
   */


  static get defaultMethod() {
    return {
      load: 'GET',
      sync: 'POST'
    };
  }
  /**
   * Cancels a sent request.
   * @param {Promise} requestPromise The Promise object wrapping the Request to be cancelled.
   * The _requestPromise_ is the value returned from the corresponding {@link #function-sendRequest} call.
   */


  cancelRequest(requestPromise, reject) {
    var _requestPromise$abort;

    (_requestPromise$abort = requestPromise.abort) === null || _requestPromise$abort === void 0 ? void 0 : _requestPromise$abort.call(requestPromise); // TODO fix this

    reject({
      cancelled: true
    });
  }

  shouldUseBodyForRequestData(packCfg, method, paramName) {
    return !(method === 'HEAD' || method === 'GET') && !paramName;
  }
  /**
   * Sends a _Crud Manager_ request to the server.
   * @param {Object}   request The request configuration object having following properties:
   * @param {String}   request.type The request type. Either `load` or `sync`.
   * @param {String}   request.url The URL for the request. Overrides the URL defined in the `transport` object
   * @param {String}   request.data The encoded _Crud Manager_ request data.
   * @param {Object}   request.params An object specifying extra HTTP params to send with the request.
   * @param {Function} request.success A function to be started on successful request transferring.
   * @param {String}   request.success.rawResponse `Response` object returned by the [fetch api](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
   * @param {Function} request.failure A function to be started on request transfer failure.
   * @param {String}   request.failure.rawResponse `Response` object returned by the [fetch api](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
   * @param {Object}   request.thisObj `this` reference for the above `success` and `failure` functions.
   * @return {Promise} The fetch Promise object.
   * @fires beforesend
   */


  sendRequest(request) {
    const me = this,
          {
      data
    } = request,
          transportConfig = me.transport[request.type] || {},
          // clone parameters defined for this type of request
    requestConfig = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, transportConfig, transportConfig.requestConfig);

    if (request.url) {
      requestConfig.url = request.url;
    }

    requestConfig.method = requestConfig.method || AjaxTransport.defaultMethod[request.type];
    requestConfig.params = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign(requestConfig.params || {}, request.params);
    let {
      paramName
    } = requestConfig; // transfer package in the request body for some types of HTTP requests

    if (me.shouldUseBodyForRequestData(transportConfig, requestConfig.method, paramName)) {
      requestConfig.body = data; // for requests having body we set Content-Type to 'application/json' by default

      requestConfig.headers = requestConfig.headers || {};
      requestConfig.headers['Content-Type'] = requestConfig.headers['Content-Type'] || 'application/json';
    } else {
      // when we don't use body paramName is mandatory so fallback to 'data' as name
      paramName = paramName || 'data';
      requestConfig.params[paramName] = data;
    }

    if (!requestConfig.url) {
      throw new Error('Trying to request without URL specified');
    } // sanitize request config


    delete requestConfig.requestConfig;
    delete requestConfig.paramName;
    /**
     * Fires before a request is sent to the server.
     *
     * ```javascript
     * crudManager.on('beforeSend', function ({ params, type }) {
     *     // let's set "sync" request parameters
     *     if (type == 'sync') {
     *         // dynamically depending on "flag" value
     *         if (flag) {
     *             params.foo = 'bar';
     *         }
     *         else {
     *             params.foo = 'smth';
     *         }
     *     }
     * });
     * ```
     * @event beforeSend
     * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
     * @param {Object} params HTTP request params to be passed in the request URL.
     * @param {String} type CrudManager request type (`load`/`sync`)
     * @param {Object} requestConfig Configuration object for Ajax request call
     */

    me.trigger('beforeSend', {
      params: requestConfig.params,
      type: request.type,
      requestConfig,
      config: request
    }); // AjaxHelper.fetch call it "queryParams"

    requestConfig.queryParams = requestConfig.params;
    delete requestConfig.params;
    let responsePromise,
        cancelled = false;
    const fetchOptions = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_2__["default"].assign({}, requestConfig, requestConfig.fetchOptions),
          ajaxPromise = _Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].fetch(requestConfig.url, fetchOptions);
    ajaxPromise.catch(error => {
      var _fetchOptions$abortCo;

      ajaxPromise.done = true;
      const signal = (_fetchOptions$abortCo = fetchOptions.abortController) === null || _fetchOptions$abortCo === void 0 ? void 0 : _fetchOptions$abortCo.signal;

      if (signal) {
        cancelled = signal.aborted;

        if (!cancelled) {
          console.warn(error);
        }
      }

      return {
        error,
        cancelled
      };
    }).then(response => {
      ajaxPromise.done = true;
      const cb = response !== null && response !== void 0 && response.ok ? request.success : request.failure;
      responsePromise = cb === null || cb === void 0 ? void 0 : cb.call(request.thisObj || me, response, fetchOptions, request);
    }); // TODO: do we really need to wait for responsePromise completion?

    const result = Promise.all([ajaxPromise, responsePromise]);

    result.abort = () => {
      if (!ajaxPromise.done) {
        var _ajaxPromise$abort;

        (_ajaxPromise$abort = ajaxPromise.abort) === null || _ajaxPromise$abort === void 0 ? void 0 : _ajaxPromise$abort.call(ajaxPromise);
      }
    };

    return result;
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/AssignmentStore.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/data/AssignmentStore.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/AssignmentModel.js */ "./lib/Scheduler/model/AssignmentModel.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/PartOfBaseProject.js */ "./lib/Scheduler/data/mixin/PartOfBaseProject.js");
/* harmony import */ var _mixin_AssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mixin/AssignmentStoreMixin.js */ "./lib/Scheduler/data/mixin/AssignmentStoreMixin.js");
/* harmony import */ var _Engine_quark_store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Engine/quark/store/CoreAssignmentStoreMixin.js */ "./lib/Engine/quark/store/CoreAssignmentStoreMixin.js");
var productName = 'taskboard';






const EngineMixin = Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Engine_quark_store_CoreAssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_5__["CoreAssignmentStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @module Scheduler/data/AssignmentStore
 */

/**
 * A store representing a collection of assignments between events in the {@link Scheduler.data.EventStore} and resources
 * in the {@link Scheduler.data.ResourceStore}.
 *
 * This store only accepts a model class inheriting from {@link Scheduler.model.AssignmentModel}.
 *
 * An AssignmentStore is usually connected to a project, which binds it to other related stores (EventStore,
 * ResourceStore and DependencyStore). The project also handles references (event, resource) to related records for the
 * records in the store.
 *
 * Resolving the references happens async, records are not guaranteed to have up to date references until calculations
 * are finished. To be certain that references are resolved, call `await project.commitAsync()` after store actions. Or
 * use one of the `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * assignmentStore.data = [{ eventId, resourceId }, ...];
 *
 * // references (event, resource) not resolved yet
 *
 * await assignmentStore.project.commitAsync();
 *
 * // now they are
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await assignmentStore.loadDataAsync([{ eventId, resourceId }, ...]);
 *
 * // references (event, resource) are resolved
 * ```
 *
 * @mixes Scheduler/data/mixin/AssignmentStoreMixin
 * @mixes Scheduler/data/mixin/PartOfProject
 * @extends Core/data/AjaxStore
 */

class AssignmentStore extends Object(_mixin_AssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_4__["default"])(EngineMixin) {
  static get defaultConfig() {
    return {
      modelClass: _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_1__["default"]
    };
  }

}
AssignmentStore._$name = 'AssignmentStore';

/***/ }),

/***/ "./lib/Scheduler/data/CrudManager.js":
/*!*******************************************!*\
  !*** ./lib/Scheduler/data/CrudManager.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CrudManager; });
/* harmony import */ var _ResourceStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ResourceStore.js */ "./lib/Scheduler/data/ResourceStore.js");
/* harmony import */ var _EventStore_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./EventStore.js */ "./lib/Scheduler/data/EventStore.js");
/* harmony import */ var _AssignmentStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./AssignmentStore.js */ "./lib/Scheduler/data/AssignmentStore.js");
/* harmony import */ var _DependencyStore_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./DependencyStore.js */ "./lib/Scheduler/data/DependencyStore.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixin/ProjectCrudManager.js */ "./lib/Scheduler/data/mixin/ProjectCrudManager.js");
/* harmony import */ var _crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../crud/AbstractCrudManager.js */ "./lib/Scheduler/crud/AbstractCrudManager.js");
/* harmony import */ var _crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../crud/transport/AjaxTransport.js */ "./lib/Scheduler/crud/transport/AjaxTransport.js");
/* harmony import */ var _crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../crud/encoder/JsonEncoder.js */ "./lib/Scheduler/crud/encoder/JsonEncoder.js");
/* harmony import */ var _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../model/ProjectModel.js */ "./lib/Scheduler/model/ProjectModel.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';











/**
 * @module Scheduler/data/CrudManager
 */

/**
 * The Crud Manager (or "CM") is a class implementing centralized loading and saving of data in multiple stores.
 * Loading the stores and saving all changes is done using a single request. The stores managed by CRUD manager should
 * not be configured with their own CRUD URLs or use {@link Core/data/AjaxStore#config-autoLoad}/{@link Core/data/AjaxStore#config-autoCommit}.
 *
 * This class uses JSON as its data encoding format.
 *
 * ## Scheduler stores
 *
 * The class supports Scheduler specific stores (namely: resource, event, assignment and dependency stores).
 * For these stores, the CM has separate configs ({@link #config-resourceStore}, {@link #config-eventStore},
 * {@link #config-assignmentStore}) to register them.
 *
 * ```javascript
 * const crudManager = new CrudManager({
 *     autoLoad        : true,
 *     resourceStore   : resourceStore,
 *     eventStore      : eventStore,
 *     assignmentStore : assignmentStore,
 *     transport       : {
 *         load : {
 *             url : 'php/read.php'
 *         },
 *         sync : {
 *             url : 'php/save.php'
 *         }
 *     }
 * });
 * ```
 *
 * ## AJAX request configuration
 *
 * To configure AJAX request parameters please take a look at the
 * {@link Scheduler/crud/transport/AjaxTransport} docs.
 *
 * ```javascript
 * const crudManager = new CrudManager({
 *     autoLoad        : true,
 *     resourceStore,
 *     eventStore,
 *     assignmentStore,
 *     transport       : {
 *         load    : {
 *             url         : 'php/read.php',
 *             // use GET request
 *             method      : 'GET',
 *             // pass request JSON in "rq" parameter
 *             paramName   : 'rq',
 *             // extra HTTP request parameters
 *             params      : {
 *                 foo     : 'bar'
 *             },
 *             // pass some extra Fetch API option
 *             credentials : 'include'
 *         },
 *         sync : {
 *             url : 'php/save.php'
 *         }
 *     }
 * });
 * ```
 * ## Using inline data
 *
 * The CrudManager provides settable property {@link #property-inlineData} that can
 * be used to get data from all {@link #property-crudStores} at once and to set this
 * data as well. Populating the stores this way can be useful if you cannot or you do not want to use CrudManager for
 * server requests but you pull the data by other means and have it ready outside CrudManager. Also, the data from all
 * stores is available in a single assignment statement.
 *
 * ### Getting data
 * ```javascript
 * const data = scheduler.crudManager.inlineData;
 *
 * // use the data in your application
 * ```
 *
 * ### Setting data
 * ```javascript
 * const data = // your function to pull server data
 *
 * scheduler.crudManager.inlineData = data;
 * ```
 *
 * ## Load order
 *
 * The CM is aware of the proper load order for Scheduler specific stores so you don't need to worry about it.
 * If you provide any extra stores (using {@link #config-stores} config) they will be
 * added to the start of collection before the Scheduler specific stores.
 * If you need a different loading order, you should use {@link #function-addStore} method to
 * register your store:
 *
 * ```javascript
 * const crudManager = new CrudManager({
 *     resourceStore   : resourceStore,
 *     eventStore      : eventStore,
 *     assignmentStore : assignmentStore,
 *     // extra user defined stores will get to the start of collection
 *     // so they will be loaded first
 *     stores          : [ store1, store2 ],
 *     transport       : {
 *         load : {
 *             url : 'php/read.php'
 *         },
 *         sync : {
 *             url : 'php/save.php'
 *         }
 *     }
 * });
 *
 * // append store3 to the end so it will be loaded last
 * crudManager.addStore(store3);
 *
 * // now when we registered all the stores let's load them
 * crudManager.load();
 * ```
 *
 * ## Assignment store
 *
 * The Crud Manager is designed to use {@link Scheduler/data/AssignmentStore} for assigning events to one or multiple resources.
 * However if server provides `resourceId` for any of the `events` then the Crud Manager enables backward compatible mode when
 * an event could have a single assignment only. This also disables multiple assignments in Scheduler UI.
 * In order to use multiple assignments server backend should be able to receive/send `assignments` for `load` and `sync` requests.
 *
 * ## Project
 *
 * The Crud Manager automatically consumes stores of the provided project (namely its {@link Scheduler/model/ProjectModel#property-eventStore},
 * {@link Scheduler/model/ProjectModel#property-resourceStore}, {@link Scheduler/model/ProjectModel#property-assignmentStore},
 * {@link Scheduler/model/ProjectModel#property-dependencyStore}, {@link Scheduler/model/ProjectModel#property-timeRangeStore} and
 * {@link Scheduler/model/ProjectModel#property-resourceTimeRangeStore}):
 *
 * ```javascript
 * const crudManager = new CrudManager({
 *     // crud manager will get stores from myAppProject project
 *     project   : myAppProject,
 *     transport : {
 *         load : {
 *             url : 'php/read.php'
 *         },
 *         sync : {
 *             url : 'php/save.php'
 *         }
 *     }
 * });
 * ```
 *
 * @mixes Scheduler/data/mixin/ProjectCrudManager
 * @mixes Scheduler/crud/encoder/JsonEncoder
 * @mixes Scheduler/crud/transport/AjaxTransport
 * @extends Scheduler/crud/AbstractCrudManager
 */

class CrudManager extends _crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_6__["default"].mixin(_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_5__["default"], _crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_7__["default"], _crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_8__["default"]) {
  //region Config
  static get defaultConfig() {
    return {
      projectClass: _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_9__["default"],
      resourceStoreClass: _ResourceStore_js__WEBPACK_IMPORTED_MODULE_0__["default"],
      eventStoreClass: _EventStore_js__WEBPACK_IMPORTED_MODULE_1__["default"],
      assignmentStoreClass: _AssignmentStore_js__WEBPACK_IMPORTED_MODULE_2__["default"],
      dependencyStoreClass: _DependencyStore_js__WEBPACK_IMPORTED_MODULE_3__["default"],

      /**
       * A store with resources (or its descriptor).
       * @config {Scheduler.data.ResourceStore|Object}
       */
      resourceStore: {},

      /**
       * A store with events (or its descriptor).
       *
       * ```
       * crudManager : {
       *      eventStore {
       *          storeClass : MyEventStore
       *      }
       * }
       * ```
       * @config {Scheduler.data.EventStore|Object}
       */
      eventStore: {},

      /**
       * A store with assignments (or its descriptor).
       * @config {Scheduler.data.AssignmentStore|Object}
       */
      assignmentStore: {},

      /**
       * A store with dependencies (or its descriptor).
       * @config {Scheduler.data.DependencyStore|Object}
       */
      dependencyStore: {},

      /**
       * A project that holds and links stores
       * @config {Scheduler.model.ProjectModel}
       */
      project: null
    };
  } //endregion


  buildProject() {
    return new this.projectClass(this.buildProjectConfig());
  }

  buildProjectConfig() {
    return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].cleanupProperties({
      eventStore: this.eventStore,
      resourceStore: this.resourceStore,
      assignmentStore: this.assignmentStore,
      dependencyStore: this.dependencyStore,
      resourceTimeRangeStore: this.resourceTimeRangeStore
    });
  } //region Stores


  set project(project) {
    const me = this;

    if (project !== me._project) {
      me.detachListeners('beforeDataReady');
      me.detachListeners('afterDataReady');
      me._project = project;

      if (project) {
        me.eventStore = project.eventStore;
        me.resourceStore = project.resourceStore;
        me.assignmentStore = project.assignmentStore;
        me.dependencyStore = project.dependencyStore;
        me.timeRangeStore = project.timeRangeStore;
        me.resourceTimeRangeStore = project.resourceTimeRangeStore; // When adding multiple events to the store it will trigger multiple change events each of which will
        // call crudManager.hasChanges, which will try to actually get the changeset package. It takes some time
        // and we better skip that part for the dataready event, suspending changes tracking.

        project.on({
          name: 'beforeDataReady',
          dataReady: () => me.suspendChangesTracking(),
          prio: 100,
          thisObj: me
        });
        project.on({
          name: 'afterDataReady',
          dataReady: () => me.resumeChangesTracking(),
          prio: -100,
          thisObj: me
        });
      }

      if (!me.eventStore) {
        me.eventStore = {};
      }

      if (!me.resourceStore) {
        me.resourceStore = {};
      }

      if (!me.assignmentStore) {
        me.assignmentStore = {};
      }

      if (!me.dependencyStore) {
        me.dependencyStore = {};
      }
    }
  }

  get project() {
    return this._project;
  }
  /**
   * Store for {@link Scheduler/feature/TimeRanges timeRanges} feature.
   * @property {Core.data.Store}
   * @deprecated Please use {@link #property-timeRangeStore} property
   * @readonly
   */


  get timeRangesStore() {
    return this.timeRangeStore;
  }
  /**
   * Store for {@link Scheduler/feature/TimeRanges timeRanges} feature.
   * @property {Core.data.Store}
   */


  get timeRangeStore() {
    var _this$_timeRangeStore;

    return (_this$_timeRangeStore = this._timeRangeStore) === null || _this$_timeRangeStore === void 0 ? void 0 : _this$_timeRangeStore.store;
  }

  set timeRangeStore(store) {
    var _this$project;

    this.setFeaturedStore('_timeRangeStore', store, (_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.timeRangeStoreClass);
  }
  /**
   * Store for {@link Scheduler/feature/ResourceTimeRanges resourceTimeRanges} feature.
   * @property {Core.data.Store}
   */


  get resourceTimeRangeStore() {
    var _this$_resourceTimeRa;

    return (_this$_resourceTimeRa = this._resourceTimeRangeStore) === null || _this$_resourceTimeRa === void 0 ? void 0 : _this$_resourceTimeRa.store;
  }

  set resourceTimeRangeStore(store) {
    var _this$project2;

    this.setFeaturedStore('_resourceTimeRangeStore', store, (_this$project2 = this.project) === null || _this$project2 === void 0 ? void 0 : _this$project2.resourceTimeRangeStoreClass);
  }
  /**
   * Get/set the resource store bound to the CRUD manager.
   * @property {Scheduler.data.ResourceStore}
   */


  get resourceStore() {
    var _this$_resourceStore;

    return (_this$_resourceStore = this._resourceStore) === null || _this$_resourceStore === void 0 ? void 0 : _this$_resourceStore.store;
  }

  set resourceStore(store) {
    const me = this;
    me.setFeaturedStore('_resourceStore', store, me.resourceStoreClass);
  }
  /**
   * Get/set the event store bound to the CRUD manager.
   * @property {Scheduler.data.EventStore}
   */


  get eventStore() {
    var _this$_eventStore;

    return (_this$_eventStore = this._eventStore) === null || _this$_eventStore === void 0 ? void 0 : _this$_eventStore.store;
  }

  set eventStore(store) {
    const me = this;
    me.setFeaturedStore('_eventStore', store, me.eventStoreClass);
  }
  /**
   * Get/set the assignment store bound to the CRUD manager.
   * @property {Scheduler.data.AssignmentStore}
   */


  get assignmentStore() {
    var _this$_assignmentStor;

    return (_this$_assignmentStor = this._assignmentStore) === null || _this$_assignmentStor === void 0 ? void 0 : _this$_assignmentStor.store;
  }

  set assignmentStore(store) {
    this.setFeaturedStore('_assignmentStore', store, this.assignmentStoreClass);
  }
  /**
   * Get/set the dependency store bound to the CRUD manager.
   * @property {Scheduler.data.DependencyStore}
   */


  get dependencyStore() {
    var _this$_dependencyStor;

    return (_this$_dependencyStor = this._dependencyStore) === null || _this$_dependencyStor === void 0 ? void 0 : _this$_dependencyStor.store;
  }

  set dependencyStore(store) {
    this.setFeaturedStore('_dependencyStore', store, this.dependencyStoreClass);
  }

  setFeaturedStore(property, store, storeClass) {
    var _me$property;

    const me = this,
          oldStore = (_me$property = me[property]) === null || _me$property === void 0 ? void 0 : _me$property.store; // if not the same store

    if (oldStore !== store) {
      var _store;

      // normalize store value (turn it into a storeClass instance if needed)
      store = _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_4__["default"].getStore(store, ((_store = store) === null || _store === void 0 ? void 0 : _store.storeClass) || storeClass);

      if (oldStore) {
        me.removeStore(oldStore);
      }

      me[property] = store && {
        store
      } || null; // Adds configured scheduler stores to the store collection ensuring correct order
      // unless they're already registered.

      me.addPrioritizedStore(me[property]);
    }

    return me[property];
  }

  getChangeSetPackage() {
    const pack = super.getChangeSetPackage(); // Remove assignments from changes if using single assignment mode (resourceId)

    if (pack && this.eventStore.usesSingleAssignment) {
      delete pack[this.assignmentStore.storeId]; // No other changes?

      if (!this.crudStores.some(storeInfo => pack[storeInfo.storeId])) {
        return null;
      }
    }

    return pack;
  } //endregion


  get crudLoadValidationMandatoryStores() {
    return [this._eventStore.storeId, this._resourceStore.storeId];
  }

}
;
CrudManager._$name = 'CrudManager';

/***/ }),

/***/ "./lib/Scheduler/data/DependencyStore.js":
/*!***********************************************!*\
  !*** ./lib/Scheduler/data/DependencyStore.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/DependencyModel.js */ "./lib/Scheduler/model/DependencyModel.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _mixin_DependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/DependencyStoreMixin.js */ "./lib/Scheduler/data/mixin/DependencyStoreMixin.js");
/* harmony import */ var _Engine_quark_store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Engine/quark/store/CoreDependencyStoreMixin.js */ "./lib/Engine/quark/store/CoreDependencyStoreMixin.js");
/* harmony import */ var _mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixin/PartOfBaseProject.js */ "./lib/Scheduler/data/mixin/PartOfBaseProject.js");
var productName = 'taskboard';






const EngineMixin = Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_Engine_quark_store_CoreDependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_4__["CoreDependencyStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @module Scheduler/data/DependencyStore
 */

/**
 * A store representing a collection of dependencies between events in the {@link Scheduler.data.EventStore}.
 *
 * This store only accepts a model class inheriting from {@link Scheduler.model.DependencyModel}.
 *
 * A DependencyStore is usually connected to a project, which binds it to other related stores (EventStore,
 * AssignmentStore and ResourceStore). The project also handles references (fromEvent, toEvent) to related records
 * for the records in the store.
 *
 * Resolving the references happens async, records are not guaranteed to have up to date references until calculations
 * are finished. To be certain that references are resolved, call `await project.commitAsync()` after store actions. Or
 * use one of the `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * dependencyStore.data = [{ from, to }, ...];
 *
 * // references (fromEvent, toEvent) not resolved yet
 *
 * await dependencyStore.project.commitAsync();
 *
 * // now they are
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await dependencyStore.loadDataAsync([{ from, to }, ...]);
 *
 * // references (fromEvent, toEvent) are resolved
 * ```
 *
 * @mixes Scheduler/data/mixin/PartOfProject
 * @mixes Scheduler/data/mixin/DependencyStoreMixin
 * @extends Core/data/AjaxStore
 */

class DependencyStore extends Object(_mixin_DependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_3__["default"])(EngineMixin.derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
  static get defaultConfig() {
    return {
      modelClass: _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_1__["default"]
    };
  }

}
DependencyStore._$name = 'DependencyStore';

/***/ }),

/***/ "./lib/Scheduler/data/EventStore.js":
/*!******************************************!*\
  !*** ./lib/Scheduler/data/EventStore.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/EventStoreMixin.js */ "./lib/Scheduler/data/mixin/EventStoreMixin.js");
/* harmony import */ var _mixin_SharedEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/SharedEventStoreMixin.js */ "./lib/Scheduler/data/mixin/SharedEventStoreMixin.js");
/* harmony import */ var _mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/RecurringEventsMixin.js */ "./lib/Scheduler/data/mixin/RecurringEventsMixin.js");
/* harmony import */ var _model_EventModel_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../model/EventModel.js */ "./lib/Scheduler/model/EventModel.js");
/* harmony import */ var _mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_quark_store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Engine/quark/store/CoreEventStoreMixin.js */ "./lib/Engine/quark/store/CoreEventStoreMixin.js");
/* harmony import */ var _mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./mixin/PartOfBaseProject.js */ "./lib/Scheduler/data/mixin/PartOfBaseProject.js");
var productName = 'taskboard';








const EngineMixin = Object(_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_5__["default"])(_Engine_quark_store_CoreEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_6__["CoreEventStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @module Scheduler/data/EventStore
 */

/**
 * A store holding all the {@link Scheduler.model.EventModel events} to be rendered into a {@link Scheduler.view.Scheduler Scheduler}.
 *
 * This store only accepts a model class inheriting from {@link Scheduler.model.EventModel}.
 *
 * An EventStore is usually connected to a project, which binds it to other related stores (AssignmentStore,
 * ResourceStore and DependencyStore). The project also handles normalization/calculation of the data on the records in
 * the store. For example if a record is added with a `startDate` and an `endDate`, it will calculate the `duration`.
 *
 * The calculations happens async, records are not guaranteed to have up to date data until they are finished. To be
 * certain that calculations have finished, call `await project.commitAsync()` after store actions. Or use one of the
 * `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * eventStore.data = [{ startDate, endDate }, ...];
 *
 * // duration of the record is not yet calculated
 *
 * await eventStore.project.commitAsync();
 *
 * // now it is
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await eventStore.loadDataAsync([{ startDate, endDate }, ...]);
 *
 * // duration is calculated
 * ```
 *
 * ## Using recurring events
 * When recurring events are in the database, **all recurring event definitions** which started before
 * the requested start date, and have not yet finished recurring MUST be loaded into the EventStore.
 *
 * Only the **base** recurring event **definitions** are stored in the EventStore. You do not
 * need to calculate the future occurrence dates of these events. This is all handled by the EventStore.
 *
 * When asked to yield a set of events for a certain date range for creating a UI through
 * {@link #function-getEvents}, the EventStore *automatically* interpolates any occurrences of
 * recurring events into the results. They do not occupy slots in the EventStore for every date
 * in their repetition range (that would be very inefficient, and *might* be infinite).
 *
 * @mixes Scheduler/data/mixin/PartOfProject
 * @mixes Scheduler/data/mixin/SharedEventStoreMixin
 * @mixes Scheduler/data/mixin/EventStoreMixin
 * @mixes Scheduler/data/mixin/RecurringEventsMixin
 * @extends Core/data/AjaxStore
 */

class EventStore extends EngineMixin.mixin(_mixin_SharedEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_2__["default"], _mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_3__["default"], _mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static get defaultConfig() {
    return {
      /**
       * Class used to represent records
       * @config {Scheduler.model.EventModel}
       * @default
       * @category Common
       */
      modelClass: _model_EventModel_js__WEBPACK_IMPORTED_MODULE_4__["default"]
    };
  }

}
EventStore._$name = 'EventStore';

/***/ }),

/***/ "./lib/Scheduler/data/ResourceStore.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/data/ResourceStore.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceStore; });
/* harmony import */ var _mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mixin/ResourceStoreMixin.js */ "./lib/Scheduler/data/mixin/ResourceStoreMixin.js");
/* harmony import */ var _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/ResourceModel.js */ "./lib/Scheduler/model/ResourceModel.js");
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_quark_store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Engine/quark/store/CoreResourceStoreMixin.js */ "./lib/Engine/quark/store/CoreResourceStoreMixin.js");
/* harmony import */ var _mixin_PartOfBaseProject_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixin/PartOfBaseProject.js */ "./lib/Scheduler/data/mixin/PartOfBaseProject.js");
var productName = 'taskboard';






const EngineMixin = Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__["default"])(_Engine_quark_store_CoreResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_4__["CoreResourceStoreMixin"].derive(_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_2__["default"]));
/**
 * @module Scheduler/data/ResourceStore
 */

/**
 * A store holding all the {@link Scheduler.model.ResourceModel resources} to be rendered into a
 * {@link Scheduler.view.Scheduler Scheduler}.
 *
 * This store only accepts a model class inheriting from {@link Scheduler.model.ResourceModel}.
 *
 * A ResourceStore is usually connected to a project, which binds it to other related stores (EventStore,
 * AssignmentStore and DependencyStore). The project also handles references (assignments, events) to related records
 * for the records in the store.
 *
 * Resolving the references happens async, records are not guaranteed to have up to date references until calculations
 * are finished. To be certain that references are resolved, call `await project.commitAsync()` after store actions. Or
 * use one of the `xxAsync` functions, such as `loadDataAsync()`.
 *
 * Using `commitAsync()`:
 *
 * ```javascript
 * resourceStore.data = [{ id }, ...];
 *
 * // references (assignments, events) not resolved yet
 *
 * await resourceStore.project.commitAsync();
 *
 * // now they are
 * ```
 *
 * Using `loadDataAsync()`:
 *
 * ```javascript
 * await resourceStore.loadDataAsync([{ id }, ...]);
 *
 * // references (assignments, events) are resolved
 * ```
 *
 * @mixes Scheduler/data/mixin/PartOfProject
 * @mixes Scheduler/data/mixin/ResourceStoreMixin
 * @extends Core/data/AjaxStore
 */

class ResourceStore extends Object(_mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_0__["default"])(EngineMixin) {
  static get defaultConfig() {
    return {
      modelClass: _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_1__["default"]
    };
  }

}
ResourceStore._$name = 'ResourceStore';

/***/ }),

/***/ "./lib/Scheduler/data/ResourceTimeRangeStore.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/data/ResourceTimeRangeStore.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceTimeRangeStore; });
/* harmony import */ var _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony import */ var _model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/ResourceTimeRangeModel.js */ "./lib/Scheduler/model/ResourceTimeRangeModel.js");
var productName = 'taskboard';


/**
 * @module Scheduler/data/ResourceTimeRangeStore
 */

/**
 * A class representing a collection of resource time ranges.
 * Contains a collection of {@link Scheduler.model.ResourceTimeRangeModel ResourceTimeRangeModel} records.
 * The class is used by the {@link Scheduler.feature.ResourceTimeRanges ResourceTimeRanges} feature.
 *
 * ## Recurring ranges support
 *
 * By default the class doesn't support recurrence. In order to add its support
 * please use {@link Scheduler.data.mixin.RecurringTimeSpansMixin RecurringTimeSpansMixin} mixin
 * (the store model in turn should be mixed with {@link Scheduler/model/mixin/RecurringTimeSpan RecurringTimeSpan} class):
 *
 * ```js
 * // Mix RecurringTimeSpan (which adds recurrence support) to ResourceTimeRangeModel
 * class MyResourceTimeRange extends RecurringTimeSpan(ResourceTimeRangeModel) {};
 *
 * // Mix RecurringTimeSpansMixin (which adds recurrence support) to ResourceTimeRangeStore
 * class MyResourceTimeRangeStore extends RecurringTimeSpansMixin(ResourceTimeRangeStore) {
 *     static get defaultConfig() {
 *         return {
 *             // use our new MyResourceTimeRange model
 *             modelClass : MyResourceTimeRange
 *         };
 *     }
 * };
 *
 * // Make new store that supports time ranges recurrence
 * const store = new MyResourceTimeRangeStore({
 *     data : [{        {
 *         id             : 1,
 *         resourceId     : 'r1',
 *         startDate      : '2019-01-01T11:00',
 *         endDate        : '2019-01-01T13:00',
 *         name           : 'Coffee break',
 *         // this time range should repeat every day
 *         recurrenceRule : 'FREQ=DAILY'
 *     }]
 * });
 * ```
 *
 * @extends Core/data/AjaxStore
 */

class ResourceTimeRangeStore extends _Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get defaultConfig() {
    return {
      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 500,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 500,

      /**
       * This store should be linked to a ResourceStore to link the time ranges to resources
       * @config {Scheduler.data.ResourceStore}
       */
      resourceStore: null,
      modelClass: _model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_1__["default"],
      storeId: 'resourceTimeRanges'
    };
  }

  set resourceStore(store) {
    this._resourceStore = store; // If store is assigned after configuration we need to init relations

    if (!this.isConfiguring) {
      this.initRelations(true);
    }
  }

  get resourceStore() {
    return this._resourceStore;
  } // Matching signature in EventStore to allow reusage of SchedulerStores#onInternalEventStoreChange()


  getResourcesForEvent(resourceTimeRange) {
    return [resourceTimeRange.resource];
  }

}
ResourceTimeRangeStore._$name = 'ResourceTimeRangeStore';

/***/ }),

/***/ "./lib/Scheduler/data/mixin/AssignmentStoreMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/AssignmentStoreMixin.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
var productName = 'taskboard';

/**
 * @module Scheduler/data/mixin/AssignmentStoreMixin
 */

/**
 * This is a mixin, containing functionality related to managing assignments.
 *
 * It is consumed by the regular {@link Scheduler.data.AssignmentStore} class and Scheduler Pros counterpart.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class AssignmentStoreMixin extends Target {
  static get $name() {
    return 'AssignmentStoreMixin';
  }
  /**
   * Add assignments to the store.
   *
   * NOTE: References (event, resource) on the assignments are determined async by a calculation engine. Thus they
   * cannot be directly accessed after using this function.
   *
   * For example:
   *
   * ```javascript
   * const [assignment] = assignmentStore.add({ eventId, resourceId });
   * // assignment.event is not yet available
   * ```
   *
   * To guarantee references are set up, wait for calculations for finish:
   *
   * ```javascript
   * const [assignment] = assignmentStore.add({ eventId, resourceId });
   * await assignmentStore.project.commitAsync();
   * // assignment.event is available (assuming EventStore is loaded and so on)
   * ```
   *
   * Alternatively use `addAsync()` instead:
   *
   * ```javascript
   * const [assignment] = await assignmentStore.addAsync({ eventId, resourceId });
   * // assignment.event is available (assuming EventStore is loaded and so on)
   * ```
   *
   * @param {Scheduler.model.AssignmentModel|Scheduler.model.AssignmentModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.AssignmentModel[]} Added records
   * @function add
   * @category CRUD
   */

  /**
   * Add assignments to the store and triggers calculations directly after. Await this function to have up to date
   * references on the added assignments.
   *
   * ```javascript
   * const [assignment] = await assignmentStore.addAsync({ eventId, resourceId });
   * // assignment.event is available (assuming EventStore is loaded and so on)
   * ```
   *
   * @param {Scheduler.model.AssignmentModel|Scheduler.model.AssignmentModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.AssignmentModel[]} Added records
   * @function addAsync
   * @category CRUD
   * @async
   */

  /**
   * Applies a new dataset to the AssignmentStore. Use it to plug externally fetched data into the store.
   *
   * NOTE: References (assignments, resources) on the assignments are determined async by a calculation engine. Thus
   * they cannot be directly accessed after assigning the new dataset.
   *
   * For example:
   *
   * ```javascript
   * assignmentStore.data = [{ eventId, resourceId }];
   * // assignmentStore.first.event is not yet available
   * ```
   *
   * To guarantee references are available, wait for calculations for finish:
   *
   * ```javascript
   * assignmentStore.data = [{ eventId, resourceId  }];
   * await assignmentStore.project.commitAsync();
   * // assignmentStore.first.event is available
   * ```
   *
   * Alternatively use `loadDataAsync()` instead:
   *
   * ```javascript
   * await assignmentStore.loadDataAsync([{ eventId, resourceId }]);
   * // assignmentStore.first.event is available
   * ```
   *
   * @member {Object[]} data
   * @category Records
   */

  /**
   * Applies a new dataset to the AssignmentStore and triggers calculations directly after. Use it to plug externally
   * fetched data into the store.
   *
   * ```javascript
   * await assignmentStore.loadDataAsync([{ eventId, resourceId }]);
   * // assignmentStore.first.event is available
   * ```
   *
   * @param {Object[]} data Array of AssignmentModel data objects
   * @function loadDataAsync
   * @category CRUD
   * @async
   */


  static get defaultConfig() {
    return {
      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 300,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 300,
      storeId: 'assignments'
    };
  }

  add(newAssignments, ...args) {
    if (!Array.isArray(newAssignments)) {
      newAssignments = [newAssignments];
    }

    for (let i = 0; i < newAssignments.length; i++) {
      var _assignment$event;

      let assignment = newAssignments[i];

      if (!(assignment instanceof _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
        newAssignments[i] = assignment = this.createRecord(assignment);
      }

      if (this.storage.findIndex('eventResourceKey', assignment.eventResourceKey, true) !== -1) {
        throw new Error(`Duplicate assignment Event: ${assignment.eventId} to resource: ${assignment.resourceId}`);
      }

      if ((_assignment$event = assignment.event) !== null && _assignment$event !== void 0 && _assignment$event.isCreating) {
        assignment.isCreating = true;
      }
    }

    return super.add(newAssignments, ...args);
  }

  includesAssignment(eventId, resourceId) {
    return this.storage.findIndex('eventResourceKey', `${eventId}-${resourceId}`, true) !== -1;
  }

  setStoreData(data) {
    super.setStoreData(data);
  } //region Init & destroy
  // This index fixes poor performance when you add large number of events to an event store with large number of
  // events - if cache is missing existing records are iterated n² times.
  // https://github.com/bryntum/support/issues/3154#issuecomment-881336588


  set storage(storage) {
    super.storage = storage; // This allows a map based, fast lookup of assignments by their eventResourceKey.
    // This is so that the test for duplicate assignment adding is fast.

    this.storage.addIndex({
      property: 'eventResourceKey'
    });
  }

  get storage() {
    // Micro optimization to avoid expensive super call
    return this._storage || super.storage;
  } //endregion
  //region Stores
  // To not have to do instanceof checks


  get isAssignmentStore() {
    return true;
  } //endregion
  //region Recurrence

  /**
   * Returns a "fake" assignment used to identify a certain occurrence of a recurring event.
   * If passed the original event, it returns `originalAssignment`.
   * @param {Scheduler.model.AssignmentModel} originalAssignment
   * @param {Scheduler.model.EventModel} occurrence
   * @returns {Object} Temporary assignment
   * @internal
   */


  getOccurrence(originalAssignment, occurrence) {
    // Pass along the original assignment for non occurrence related calls
    if (!originalAssignment || !(occurrence !== null && occurrence !== void 0 && occurrence.isOccurrence)) {
      return originalAssignment;
    } // Not for saving chars, needed in fn below


    const me = this;
    return {
      id: `${occurrence.id}:a${originalAssignment.id}`,
      event: occurrence,
      resource: originalAssignment.resource,
      eventId: occurrence.id,
      resourceId: originalAssignment.resource.id,
      isAssignment: true,
      // This field is required to distinguish this fake assignment when event is being removed from UI
      isOccurrenceAssignment: true,

      // Not being an actual record, instanceMeta is stored on the store instead
      instanceMeta(instanceOrId) {
        return me.occurrenceInstanceMeta(this, instanceOrId);
      }

    };
  } // Per fake assignment instance meta, stored on store since fakes are always generated on demand


  occurrenceInstanceMeta(occurrenceAssignment, instanceOrId) {
    const me = this,
          instanceId = instanceOrId.id || instanceOrId,
          {
      id
    } = occurrenceAssignment;
    let {
      occurrenceMeta
    } = me;

    if (!occurrenceMeta) {
      occurrenceMeta = me.occurrenceMeta = {};
    }

    if (!occurrenceMeta[id]) {
      occurrenceMeta[id] = {};
    }

    return occurrenceMeta[id][instanceId] || (occurrenceMeta[id][instanceId] = {});
  } //endregion
  //region Mapping

  /**
   * Maps over event assignments.
   *
   * @param {Scheduler.model.EventModel} event
   * @param {Function} [fn]
   * @param {Function} [filterFn]
   * @return {Scheduler.model.EventModel[]|Array}
   * @category Assignments
   */


  mapAssignmentsForEvent(event, fn, filterFn) {
    event = this.eventStore.getById(event);
    const fnSet = Boolean(fn),
          filterFnSet = Boolean(filterFn);

    if (fnSet || filterFnSet) {
      return event.assignments.reduce((result, assignment) => {
        const mapResult = fnSet ? fn(assignment) : assignment;

        if (!filterFnSet || filterFn(mapResult)) {
          result.push(mapResult);
        }

        return result;
      }, []);
    }

    return event.assignments;
  }
  /**
   * Maps over resource assignments.
   *
   * @param {Scheduler.model.ResourceModel|Number|String} resource
   * @param {Function} [fn]
   * @param {Function} [filterFn]
   * @return {Scheduler.model.ResourceModel[]|Array}
   * @category Assignments
   */


  mapAssignmentsForResource(resource, fn, filterFn) {
    resource = this.resourceStore.getById(resource);
    const fnSet = Boolean(fn),
          filterFnSet = Boolean(filterFn);

    if (fnSet || filterFnSet) {
      return resource.assignments.reduce((result, assignment) => {
        const mapResult = fnSet ? fn(assignment) : assignment;

        if (!filterFnSet || filterFn(mapResult)) {
          result.push(mapResult);
        }

        return result;
      }, []);
    }

    return resource.assignments;
  }
  /**
   * Returns all assignments for a given event.
   *
   * @param {Scheduler.model.TimeSpan} event
   * @return {Scheduler.model.AssignmentModel[]}
   * @category Assignments
   */


  getAssignmentsForEvent(event) {
    return event.assignments;
  }
  /**
   * Removes all assignments for given event
   *
   * @param {Scheduler.model.TimeSpan} event
   * @category Assignments
   */


  removeAssignmentsForEvent(event) {
    return this.remove(event.assignments);
  }
  /**
   * Returns all assignments for a given resource.
   *
   * @param {Scheduler.model.ResourceModel} resource
   * @return {Scheduler.model.AssignmentModel[]}
   * @category Assignments
   */


  getAssignmentsForResource(resource) {
    resource = this.resourceStore.getById(resource);
    return resource.assignments;
  }
  /**
   * Removes all assignments for given resource
   *
   * @param {Scheduler.model.ResourceModel|*} resource
   * @category Assignments
   */


  removeAssignmentsForResource(resource) {
    this.remove(this.getAssignmentsForResource(resource));
  }
  /**
   * Returns all resources assigned to an event.
   *
   * @param {Scheduler.model.EventModel} event
   * @return {Scheduler.model.ResourceModel[]}
   * @category Assignments
   */


  getResourcesForEvent(event) {
    return event.resources;
  }
  /**
   * Returns all events assigned to a resource
   *
   * @param {Scheduler.model.ResourceModel|String|Number} resource
   * @return {Scheduler.model.TimeSpan[]}
   * @category Assignments
   */


  getEventsForResource(resource) {
    resource = this.resourceStore.getById(resource);
    return resource && resource.events;
  }
  /**
   * Creates and adds assignment record(s) for a given event and resource(s).
   *
   * @param {Scheduler.model.TimeSpan} event
   * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]} resources The resource(s) to assign to the event
   * @param {Function} [assignmentSetupFn] A hook function which takes an assignment as its argument and must return an assignment.
   * @param {Boolean} [removeExistingAssignments] `true` to remove assignments for other resources
   * @return {Scheduler.model.AssignmentModel[]} An array with the created assignment(s)
   * @category Assign
   */


  assignEventToResource(event, resources, assignmentSetupFn = o => o, removeExistingAssignments = false) {
    var _me$eventStore;

    const me = this,
          toRemove = removeExistingAssignments ? new Set(event.assignments) : null;
    resources = Array.isArray(resources) ? resources : [resources]; // Use same code path as other single assignments if already assigned

    if ((_me$eventStore = me.eventStore) !== null && _me$eventStore !== void 0 && _me$eventStore.usesSingleAssignment && event.assignments.length) {
      if (!me.isEventAssignedToResource(event, resources[0])) {
        event.resource = resources[0];
      }

      return [];
    }

    let newAssignments = [];
    me.suspendAutoCommit(); // Assign

    resources.forEach(resource => {
      const existingAssignment = me.getAssignmentForEventAndResource(event, resource);

      if (!existingAssignment) {
        const assignment = assignmentSetupFn({
          event,
          resource
        });
        newAssignments.push(assignment);
      } else if (removeExistingAssignments) {
        toRemove.delete(existingAssignment);
      }
    });
    newAssignments = me.add(newAssignments);

    if (removeExistingAssignments) {
      me.remove(Array.from(toRemove));
    } // If true, will trigger a commit


    me.resumeAutoCommit();
    return newAssignments;
  }
  /**
   * Removes assignment record for a given event and resource.
   *
   * @param {Scheduler.model.TimeSpan|String|Number} event
   * @param {Scheduler.model.ResourceModel|String|Number} [resources] The resource to unassign the event from. If omitted, all resources of the events will be unassigned
   * @return {Scheduler.model.AssignmentModel|Scheduler.model.AssignmentModel[]}
   * @category Assign
   */


  unassignEventFromResource(event, resources) {
    const me = this,
          assignmentsToRemove = [];

    if (!resources) {
      return me.removeAssignmentsForEvent(event);
    }

    if (!Array.isArray(resources)) {
      resources = [resources];
    }

    for (let i = 0; i < resources.length; i++) {
      if (me.isEventAssignedToResource(event, resources[i])) {
        assignmentsToRemove.push(me.getAssignmentForEventAndResource(event, resources[i]));
      }
    }

    return me.remove(assignmentsToRemove);
  }
  /**
   * Checks whether an event is assigned to a resource.
   *
   * @param {Scheduler.model.EventModel|String|Number} event Event record or id
   * @param {Scheduler.model.ResourceModel|String|Number} resource Resource record or id
   * @return {Boolean}
   * @category Assignments
   */


  isEventAssignedToResource(event, resource) {
    return Boolean(this.getAssignmentForEventAndResource(event, resource));
  }
  /**
   * Returns an assignment record for a given event and resource
   *
   * @param {Scheduler.model.EventModel|String|Number} event The event or its id
   * @param {Scheduler.model.ResourceModel|String|Number} resource The resource or its id
   * @return {Scheduler.model.AssignmentModel}
   * @category Assignments
   */


  getAssignmentForEventAndResource(event, resource) {
    let assignments; // Note: In order to not evaluate conditions which do not have to be evaluated each condition
    // is assigned to a variable within the condition.

    if (!(event = this.eventStore.getById(event)) || !(assignments = event.assignments) || !(resource = this.resourceStore.getById(resource))) {
      return null;
    }

    return this.getOccurrence(assignments.find(a => a.resource === resource), event);
  } //endregion


});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/DependencyStoreMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/DependencyStoreMixin.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
var productName = 'taskboard';



/**
 * @module Scheduler/data/mixin/DependencyStoreMixin
 */

/**
 * This is a mixin, containing functionality related to managing dependencies.
 *
 * It is consumed by the regular {@link Scheduler.data.DependencyStore} class and Scheduler Pros counterpart.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class DependencyStoreMixin extends Target {
  static get $name() {
    return 'DependencyStoreMixin';
  }
  /**
   * Add dependencies to the store.
   *
   * NOTE: References (fromEvent, toEvent) on the dependencies are determined async by a calculation engine. Thus they
   * cannot be directly accessed after using this function.
   *
   * For example:
   *
   * ```javascript
   * const [dependency] = dependencyStore.add({ from, to });
   * // dependency.fromEvent is not yet available
   * ```
   *
   * To guarantee references are set up, wait for calculations for finish:
   *
   * ```javascript
   * const [dependency] = dependencyStore.add({ from, to });
   * await dependencyStore.project.commitAsync();
   * // dependency.fromEvent is available (assuming EventStore is loaded and so on)
   * ```
   *
   * Alternatively use `addAsync()` instead:
   *
   * ```javascript
   * const [dependency] = await dependencyStore.addAsync({ from, to });
   * // dependency.fromEvent is available (assuming EventStore is loaded and so on)
   * ```
   *
   * @param {Scheduler.model.DependencyModel|Scheduler.model.DependencyModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.DependencyModel[]} Added records
   * @function add
   * @category CRUD
   */

  /**
   * Add dependencies to the store and triggers calculations directly after. Await this function to have up to date
   * references on the added dependencies.
   *
   * ```javascript
   * const [dependency] = await dependencyStore.addAsync({ from, to });
   * // dependency.fromEvent is available (assuming EventStore is loaded and so on)
   * ```
   *
   * @param {Scheduler.model.DependencyModel|Scheduler.model.DependencyModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.DependencyModel[]} Added records
   * @function addAsync
   * @category CRUD
   * @async
   */

  /**
   * Applies a new dataset to the DependencyStore. Use it to plug externally fetched data into the store.
   *
   * NOTE: References (fromEvent, toEvent) on the dependencies are determined async by a calculation engine. Thus
   * they cannot be directly accessed after assigning the new dataset.
   *
   * For example:
   *
   * ```javascript
   * dependencyStore.data = [{ from, to }];
   * // dependencyStore.first.fromEvent is not yet available
   * ```
   *
   * To guarantee references are available, wait for calculations for finish:
   *
   * ```javascript
   * dependencyStore.data = [{ from, to }];
   * await dependencyStore.project.commitAsync();
   * // dependencyStore.first.fromEvent is available
   * ```
   *
   * Alternatively use `loadDataAsync()` instead:
   *
   * ```javascript
   * await dependencyStore.loadDataAsync([{ from, to }]);
   * // dependencyStore.first.fromEvent is available
   * ```
   *
   * @member {Object[]} data
   * @category Records
   */

  /**
   * Applies a new dataset to the DependencyStore and triggers calculations directly after. Use it to plug externally
   * fetched data into the store.
   *
   * ```javascript
   * await dependencyStore.loadDataAsync([{ from, to }]);
   * // dependencyStore.first.fromEvent is available
   * ```
   *
   * @param {Object[]} data Array of DependencyModel data objects
   * @function loadDataAsync
   * @category CRUD
   * @async
   */


  static get defaultConfig() {
    return {
      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 400,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 400,
      storeId: 'dependencies'
    };
  } // TODO: document


  reduceEventDependencies(event, reduceFn, result, flat = true, depsGetterFn) {
    depsGetterFn = depsGetterFn || (event => this.getEventDependencies(event));

    event = Array.isArray(event) ? event : [event];
    event.reduce((result, event) => {
      if (event.children && !flat) {
        event.traverse(evt => {
          result = depsGetterFn(evt).reduce(reduceFn, result);
        });
      } else {
        result = depsGetterFn(event).reduce(reduceFn, result);
      }
    }, result);
    return result;
  } // TODO: document


  mapEventDependencies(event, fn, filterFn, flat, depsGetterFn) {
    return this.reduceEventDependencies(event, (result, dependency) => {
      filterFn(dependency) && result.push(dependency);
      return result;
    }, [], flat, depsGetterFn);
  } // TODO: document


  mapEventPredecessors(event, fn, filterFn, flat) {
    return this.reduceEventPredecessors(event, (result, dependency) => {
      filterFn(dependency) && result.push(dependency);
      return result;
    }, [], flat);
  } // TODO: document


  mapEventSuccessors(event, fn, filterFn, flat) {
    return this.reduceEventSuccessors(event, (result, dependency) => {
      filterFn(dependency) && result.push(dependency);
      return result;
    }, [], flat);
  }
  /**
   * Returns all dependencies for a certain event (both incoming and outgoing)
   *
   * @param {Scheduler.model.EventModel} event
   * @return {Scheduler.model.DependencyModel[]}
   */


  getEventDependencies(event) {
    return [].concat(event.predecessors || [], event.successors || []);
  }
  /**
   * Returns all incoming dependencies of the given event
   *
   * @param {Scheduler.model.EventModel} event
   * @return {Scheduler.model.DependencyModel[]}
   * @deprecated 5.0.0
   */


  getEventPredecessors(event) {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].deprecate('scheduler', '5.0.0', 'Superfluous, will be removed in favour of `event.predecessors`');
    return event.predecessors;
  }
  /**
   * Returns all outgoing dependencies of a event
   *
   * @param {Scheduler.model.EventModel} event
   * @return {Scheduler.model.DependencyModel[]}
   * @deprecated 5.0.0
   */


  getEventSuccessors(event) {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].deprecate('scheduler', '5.0.0', 'Superfluous, will be removed in favour of `event.successors`');
    return event.successors;
  } // TODO: document


  removeEventDependencies(event) {
    this.remove(this.getEventDependencies(event));
  } // TODO: document


  removeEventPredecessors(event) {
    this.remove(event.predecessors);
  } // TODO: document


  removeEventSuccessors(event, flat) {
    this.remove(event.successors);
  }

  getBySourceTargetId(key) {
    //TODO: in original code this uses a keymap
    return this.records.find(r => key == this.constructor.makeDependencySourceTargetCompositeKey(r.from, r.to));
  }
  /**
   * Returns dependency model instance linking tasks with given ids. The dependency can be forward (from 1st
   * task to 2nd) or backward (from 2nd to 1st).
   *
   * @param {Scheduler.model.EventModel|String} sourceEvent 1st event
   * @param {Scheduler.model.EventModel|String} targetEvent 2nd event
   * @return {Scheduler.model.DependencyModel}
   */


  getDependencyForSourceAndTargetEvents(sourceEvent, targetEvent) {
    sourceEvent = _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_1__["default"].asId(sourceEvent);
    targetEvent = _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_1__["default"].asId(targetEvent);
    return this.getBySourceTargetId(this.constructor.makeDependencySourceTargetCompositeKey(sourceEvent, targetEvent));
  }
  /**
   * Returns a dependency model instance linking given events if such dependency exists in the store.
   * The dependency can be forward (from 1st event to 2nd) or backward (from 2nd to 1st).
   *
   * @param {Scheduler.model.EventModel|String} sourceEvent
   * @param {Scheduler.model.EventModel|String} targetEvent
   * @return {Scheduler.model.DependencyModel}
   */


  getEventsLinkingDependency(sourceEvent, targetEvent) {
    return this.getDependencyForSourceAndTargetEvents(sourceEvent, targetEvent) || this.getDependencyForSourceAndTargetEvents(targetEvent, sourceEvent);
  }
  /**
   * Validation method used to validate a dependency. Override and return `true` to indicate that an
   * existing dependency between two tasks is valid. For a new dependency being created please see
   * {@link #function-isValidDependencyToCreate}.
   *
   * @param {Scheduler.model.DependencyModel|Number|String} dependencyOrFromId The dependency model or from event id
   * @param {Number|String} [toId] To event id if the first parameter is not a dependency model instance
   * @param {Number} [type] Dependency {@link Scheduler.model.DependencyBaseModel#property-Type-static}  if the first parameter is not a dependency model instance.
   * @return {Boolean}
   */


  isValidDependency(dependencyOrFromId, toId, type) {
    if (arguments.length === 1) {
      toId = dependencyOrFromId.to || dependencyOrFromId.toEvent;
      dependencyOrFromId = dependencyOrFromId.from || dependencyOrFromId.fromEvent;
    } // This condition is supposed to map all model instances to be validated by project. Lowest common ancestor
    // for scheduler event, scheduler pro event and gantt task is TimeSpan


    if (dependencyOrFromId instanceof _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_2__["default"] && toId instanceof _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
      // Not asserting dependency type here. Default value should normally suffice.
      return this.project.isValidDependency(dependencyOrFromId, toId, type);
    }

    return dependencyOrFromId != null && toId != null && dependencyOrFromId !== toId;
  }
  /**
   * Validation method used to validate a dependency while creating. Override and return `true` to indicate that
   * a new dependency is valid to be created.
   *
   * @param {Number|String} fromId `From` event id
   * @param {Number|String} toId `To` event id
   * @param {Number} type Dependency {@link Scheduler.model.DependencyBaseModel#property-Type-static}
   * @return {Boolean}
   */


  isValidDependencyToCreate(fromId, toId, type) {
    return this.isValidDependency(fromId, toId, type);
  }
  /**
   * Returns all dependencies highlighted with the given CSS class
   *
   * @param {String} cls
   * @return {Scheduler.model.DependencyBaseModel[]}
   */


  getHighlightedDependencies(cls) {
    return this.records.reduce((result, dep) => {
      if (dep.isHighlightedWith(cls)) result.push(dep);
      return result;
    }, []);
  }

  static makeDependencySourceTargetCompositeKey(from, to) {
    return `source(${from})-target(${to})`;
  } //region Product neutral


  getTimeSpanDependencies(record) {
    return this.getEventDependencies(record);
  } //endregion


});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/EventStoreMixin.js":
/*!*****************************************************!*\
  !*** ./lib/Scheduler/data/mixin/EventStoreMixin.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/util/DayTime.js */ "./lib/Core/util/DayTime.js");
/* harmony import */ var _util_EventDayIndex_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/EventDayIndex.js */ "./lib/Scheduler/data/util/EventDayIndex.js");
/* harmony import */ var _Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../Core/helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony import */ var _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
var productName = 'taskboard';








/**
 * @module Scheduler/data/mixin/EventStoreMixin
 */

const {
  MIDNIGHT
} = _Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_4__["default"],
      returnTrue = () => true,
      notRecurring = event => !event.isRecurring;
/**
 * This is a mixin, containing functionality related to managing events.
 *
 * It is consumed by the regular {@link Scheduler.data.EventStore} class and the Gantt `TaskStore` classes
 * to allow data sharing between a Gantt chart and a Scheduler.
 *
 * @mixin
 */


/* harmony default export */ __webpack_exports__["default"] = (Target => class EventStoreMixin extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'EventStoreMixin';
  } //region Init & destroy


  construct(config) {
    super.construct(config);
    this.autoTree = true;
    this.dayIndices = null;
  } //endregion
  //region Indices
  // Override to syncIndices on initial load


  afterLoadData() {
    this.syncIndices('splice', this.storage.allValues); // Babel cannot transpile ?. version of this correctly for some reason

    super.afterLoadData && super.afterLoadData();
  }
  /**
   * Responds to mutations of the underlying storage Collection.
   *
   * Maintain indices for fast finding of events by date.
   * @param {Object} event
   * @private
   */


  onDataChange({
    action,
    added,
    removed,
    replaced
  }) {
    // Indices must be synced before responding to change
    this.syncIndices(action, added, removed, replaced);
    super.onDataChange(...arguments);
  }

  onDataReplaced(action, data) {
    // Indices must be synced before responding to change
    this.syncIndices('clear');
    this.syncIndices('splice', this.storage.values);
    super.onDataReplaced(action, data);
  }

  onModelChange(record, toSet, wasSet, silent, fromRelationUpdate) {
    // Ensure by-date indices are up to date.
    if ('startDate' in wasSet || 'endDate' in wasSet) {
      this.syncIndices('reschedule', [record], null, null, wasSet);
    }

    super.onModelChange(...arguments);
  } //endregion
  //region Events records, iteration etc.


  set filtersFunction(filtersFunction) {
    super.filtersFunction = filtersFunction;
  }

  get filtersFunction() {
    // Generate the real filterFn.
    const result = super.filtersFunction; // We always filter *in* records which are being created by the UI.

    if (result && result !== _Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].returnTrue) {
      return r => r.meta.isCreating || result(r);
    }

    return result;
  }
  /**
   * Returns events between the supplied start and end date
   *
   * @param {Date} startDate The start date
   * @param {Date} endDate The end date
   * @param {Boolean} allowPartial false to only include events that start and end inside of the span
   * @param {Boolean} onlyAssigned true to only include events that are assigned to a resource
   * @return {Scheduler.model.EventModel[]} the events
   * @category Events
   * @deprecated 4.0.0 Use {@link #function-getEvents}
   */


  getEventsInTimeSpan(startDate, endDate, allowPartial = true, onlyAssigned = false) {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].deprecate('Scheduler', '5.0.0', '`getEventsInTimeSpan` method deprecated, in favor of `getEvents`');
    return this.getEvents({
      startDate,
      endDate,
      allowPartial,
      onlyAssigned
    });
  }
  /**
   * Returns all events that starts on the specified day.
   *
   * @param {Date} startDate Start date
   * @returns {Scheduler.model.EventModel[]} Events starting on specified day
   * @category Events
   * @deprecated 4.0.0 Use {@link #function-getEvents}
   */


  getEventsByStartDate(startDate) {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].deprecate('Scheduler', '5.0.0', '`getEventsByStartDate` method deprecated, in favor of `getEvents`');
    return this.getEvents({
      startDate,
      startOnly: true
    });
  }
  /**
   * Returns an array of events for the date range specified by the `startDate` and `endDate` options.
   *
   * By default, for any date, this includes any event which *intersects* that date.
   *
   * To only include events that are fully contained *within* the date range, pass the `allowPartial`
   * option as `false`
   *
   * By default, any occurrences of recurring events are included in the resulting array. If that is not
   * required, pass the `includeOccurrences` option as `false`. **Note that if
   * `includeOccurrences` is `true`, the start date and end date options are mandatory. The method
   * must know what range of occurrences needs to be generated and returned.**
   *
   * example:
   *
   * ```javascript
   *  visibleEvents = eventStore.getEvents({
   *      resourceRecord : myResource,
   *      startDate      : scheduler.timeAxis.startDate,
   *      endDate        : scheduler.timeAxis.endDate
   *  });
   * ```
   *
   * @param {Object} options An options object determining which events to return
   * @param {Date} [options.date] If only one date is required, pass this option instead of the
   * `startDate` and `endDate` options.
   * @param {Date} options.startDate The start date for the range of events to include.
   * @param {Date} [options.endDate] The end date for the range of events to include.
   * @param {Scheduler.model.ResourceModel} options.resourceRecord Pass a resource to only return events assigned to
   *   this resource. Not supported when using the `dateMap` option (see below)
   * @param {Function} [options.filter] A function to filter out events which are not required.
   * @param {Boolean} [options.includeOccurrences=true] Occurrences of recurring events are included by default.
   * @param {Boolean} [options.allowPartial=true] Events which start before or after the range, but *intersect* the
   *   range are included by default.
   * @param {Boolean} [options.startOnly] Pass `true` to only include events which *start on* each date in the range.
   * @param {Boolean} [options.onlyAssigned] Pass `true` to only include events that are assigned to a resource
   * @param {Boolean|Map} [options.dateMap] Populates the passed `Map`, or if passed as `true`, creates and
   * returns a new `Map`. The keys are `YYYY-MM-DD` date strings and the entries are arrays of {@link Scheduler.model.EventModel EventModel}s.
   * @returns {Scheduler.model.EventModel[]|Map} Events which match the passed configuration.
   * @category Events
   */


  getEvents({
    filter,
    date,
    startDate,
    // Events which intersect the startDate/endDate
    endDate,
    // will be returned
    startOnly,
    // Only events which start on each date will be returned
    includeOccurrences,
    // Interpolate occurrences into the returned event set
    allowPartial,
    // Include events which *intersect* the date range
    onlyAssigned = false,
    // Only include events that are assigned to a resource
    dateMap = false,
    // Return a Map keyed by date each value being an array of events
    dayTime = null,
    // Private option. Select which date index to look up events in depending on the date
    // we are examining in the date iteration process. Some callers may want to use
    // different indices depending on the stage through the date iteration.
    // See Calendar package for usage.
    getDateIndex
  }) {
    const me = this,
          options = arguments[0],
          {
      lastDateRange,
      added,
      filtersFunction
    } = me,
          passedFilter = filter; // Add filtering for only assigned events if requested.

    if (onlyAssigned) {
      options.filter = passedFilter ? e => passedFilter(e) && e.resources.length : e => e.resources.length;
    } // Note that we cannot use defaulting in the argument block because we pass
    // the incoming options object down into implementations.


    if (!('startDate' in options)) {
      startDate = options.startDate = date;
    }

    if (!('includeOccurrences' in options)) {
      includeOccurrences = options.includeOccurrences = true;
    }

    if (!('allowPartial' in options)) {
      allowPartial = options.allowPartial = !startOnly;
    } // We can't use me.filtersFunction if reapplyFilterOnAdd is false because there may be newly
    // added events which may not be subject to the filter. Records which are still in
    // the added bag must be tested for presence using indexOf so as to be always in sync
    // with the store being refiltered. Parens help readability.
    // eslint-disable-next-line no-extra-parens


    options.storeFilterFn = me.isFiltered ? me.reapplyFilterOnAdd ? filtersFunction : eventRecord => added.includes(eventRecord) ? me.indexOf(eventRecord) > -1 : filtersFunction(eventRecord) : null; // Default to a one day range if only startDate passed

    if (!endDate) {
      if (startDate) {
        endDate = options.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(startDate);
        endDate.setDate(endDate.getDate() + 1);
      } // If no dates passed, the dateFilter will include all.
      else {
        // We need to know what occurrences to generate.
        if (includeOccurrences) {
          throw new Error('getEvents MUST be passed startDate and endDate if recurring occurrences are requested');
        }

        options.dateFilter = returnTrue;
      }
    }

    if (!options.dateFilter) {
      // Must start in the date range
      if (startOnly) {
        options.dateFilter = e => {
          // Avoid hitting getter twice. Use batched value if present.
          const eventStartDate = e.hasBatchedChange('startDate') ? e.get('startDate') : e.startDate;
          return eventStartDate && !(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(eventStartDate) - startDate);
        };
      } // Any intersection with our date range
      else if (allowPartial) {
        options.dateFilter = e => {
          // Avoid hitting getter twice. Use batched value if present.
          const eventStartDate = e.hasBatchedChange('startDate') ? e.get('startDate') : e.startDate,
                eventEndDate = e.hasBatchedChange('endDate') ? e.get('endDate') : e.endDate || eventStartDate,
                isMilestone = !(eventStartDate - eventEndDate);
          return eventStartDate && (isMilestone ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].betweenLesserEqual(eventStartDate, startDate, endDate) : _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].intersectSpans(eventStartDate, eventEndDate, startDate, endDate));
        };
      } // Must be wholly contained with the our range
      else {
        options.dateFilter = e => {
          // Avoid hitting getter twice. Use batched value if present.
          const eventStartDate = e.hasBatchedChange('startDate') ? e.get('startDate') : e.startDate,
                eventEndDate = e.hasBatchedChange('endDate') ? e.get('endDate') : e.endDate || eventStartDate;
          return eventStartDate && eventStartDate >= startDate && eventEndDate <= endDate;
        };
      }
    }

    const newDateRange = {
      startDate,
      endDate
    },
          dateRangeChange = !lastDateRange || lastDateRange.startDate - newDateRange.startDate || lastDateRange.endDate - newDateRange.endDate;

    if (dateRangeChange) {
      // Ensure the listeners are present
      me.processConfiguredListeners();
      /**
       * Fired when a range of events is requested from the {@link #function-getEvents} method.
       * @event loadDateRange
       * @param {Scheduler.data.EventStore} source This EventStore
       * @param {Object} old The old date range
       * @param {Date} old.startDate the old start date.
       * @param {Date} old.endDate the old end date.
       * @param {Object} new The new date range
       * @param {Date} new.startDate the new start date.
       * @param {Date} new.endDate the new end date.
       */

      me.trigger('loadDateRange', {
        old: lastDateRange || {},
        new: _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__["default"].clone(newDateRange)
      }); // Dates are mutable, so we must keep our own copy.

      me.lastDateRange = _Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_7__["default"].clone(newDateRange);
    }

    return dateMap ? me.getEventsAsMap(options) : me.getEventsAsArray(options);
  }
  /**
   * Internal implementation for {@link #function-getEvents} to use when not using dateMap.
   * @private
   */


  getEventsAsArray({
    filter,
    date,
    resourceRecord,
    startDate = date,
    // Events which intersect the startDate/endDate
    endDate,
    // will be returned
    startOnly,
    // Only events which start on each date will be returned
    includeOccurrences = true,
    // Interpolate occurrences into the returned event set
    dayTime = null,
    // Injected by the getEvents master method
    dateFilter,
    storeFilterFn,
    // Private option. Select which date index to look up events in depending on the date
    // we are examining in the date iteration process. Some callers may want to use
    // different indices depending on the stage through the date iteration.
    // See Calendar package for usage.
    getDateIndex
  }) {
    const me = this,
          events = [];

    if (me.count) {
      let candidateEvents = resourceRecord ? me.getEventsForResource(resourceRecord) : null; // If there *was* a resourceRecord, candidateEvents will already be set up using me.getEventsForResource.
      // If no resourceRecord specified, we are gathering by date, so use the indices.

      if (!resourceRecord) {
        const dateIndex = me.useDayIndex(dayTime),
              eventSet = new Set(),
              indexName = startOnly ? 'startDate' : 'date'; // Add all recurring events which started on or before our date range.

        me.recurringEvents.forEach(e => {
          if (dateIndex.dayTime.startOfDay(e.startDate) <= startDate) {
            eventSet.add(e);
          }
        }); // Iterate the date range, using the indices to find qualified events.

        for (const date = new Date(startDate); date < endDate; date.setDate(date.getDate() + 1)) {
          const coincidingEvents = dateIndex.get(getDateIndex ? getDateIndex(date) : indexName, date);
          coincidingEvents === null || coincidingEvents === void 0 ? void 0 : coincidingEvents.forEach(e => eventSet.add(e));
        } // We gathered all events which *coincide* with each date.
        // We also added in all recurring events which started on or before our date range.
        // All these were made unique by the Set.
        // Return it to array form.


        candidateEvents = [...eventSet];
      } // Events found from the date indices won't be filtered.
      // On the other side, when using getEventForResource we will get all events for
      // the resource even if the EventStore is filtered, handle this by excluding "invisible" events here


      if (storeFilterFn) {
        candidateEvents = candidateEvents.filter(storeFilterFn);
      } // Go through candidates.
      // For a recurring event, and we are including recurrences, add date-qualifying occurrences.
      // For a non-recurring event, add it if it's date-qualified.


      for (let i = 0, {
        length
      } = candidateEvents; i < length; i++) {
        const e = candidateEvents[i]; // For recurring events, add date-qualifying occurrences, not the base

        if (includeOccurrences && e.isRecurring) {
          events.push.apply(events, e.getOccurrencesForDateRange(startDate, endDate).filter(dateFilter));
        } // For ordinary events, add if it's date-qualified
        else if (dateFilter(e)) {
          events.push(e);
        }
      }
    }

    return filter ? events.filter(filter) : events;
  }
  /**
   * Internal implementation for {@link #function-getEvents} to use when using dateMap.
   * @private
   */


  getEventsAsMap({
    filter: passedFilter,
    date,
    resourceRecord,
    // Not supported yet. Will add if ever requested.
    startDate = date,
    // Events which intersect the startDate/endDate
    endDate,
    // will be returned
    startOnly,
    // Only events which start on each date will be returned
    includeOccurrences = true,
    // Interpolate occurrences into the returned event set
    dateMap,
    // Return a Map keyed by date each value being an array of events
    dayTime = null,
    storeFilterFn,
    // Private option. Select which date index to look up events in depending on the date
    // we are examining in the date iteration process. Some callers may want to use
    // different indices depending on the stage through the date iteration.
    // See Calendar package for usage.
    getDateIndex
  }) {
    var _dateMap;

    const me = this; // Convert `true` to a Map.

    if ((_dateMap = dateMap) !== null && _dateMap !== void 0 && _dateMap.clear) {
      dateMap.clear();
    } else {
      dateMap = new Map();
    }

    if (me.count) {
      const dateIndex = me.useDayIndex(dayTime),
            indexName = startOnly ? 'startDate' : 'date',
            recurringEvents = [],
            filter = e => (!passedFilter || passedFilter(e)) && (!storeFilterFn || storeFilterFn(e)),
            baseEventFilter = e => notRecurring(e) && filter(e);

      dayTime = dateIndex.dayTime; // dayTime=null becomes DayTime instance for midnight
      // We can't yet do this for just a resource.

      if (resourceRecord) {
        throw new Error('Querying for events for a resource and returning a date-keyed Map is not supported');
      } else {
        // Add all recurring events which started before the end of our date range.
        me.recurringEvents.forEach(e => {
          if (dayTime.startOfDay(e.startDate) < endDate) {
            recurringEvents.push(e);
          }
        }); // Iterate the date range, using the indices to find qualified events.

        for (const date = new Date(startDate); date < endDate; date.setDate(date.getDate() + 1)) {
          var _coincidingEvents;

          let [coincidingEvents, key] = dateIndex.get(getDateIndex ? getDateIndex(date) : indexName, date, true); // The index entry may be there, but it could be empty.

          if ((_coincidingEvents = coincidingEvents) !== null && _coincidingEvents !== void 0 && _coincidingEvents.size) {
            // Convert Set which index holds into an Array.
            // A recurring event doesn't go into the Map, its occurrences do.
            // Then filter by the passed filter and this Store's filter function
            // because events found from the date indices won't be filtered.
            coincidingEvents = [...coincidingEvents].filter(baseEventFilter); // Only create the entry for the day if there are events found

            if (coincidingEvents.length) {
              (dateMap.get(key) || dateMap.set(key, []).get(key)).push(...coincidingEvents);
            }
          }
        }
      } // Go through matching recurring events.


      for (let i = 0, {
        length
      } = recurringEvents; i < length; i++) {
        const e = recurringEvents[i]; // For each recurring event, add occurrences if we are including occurrences else, add the base.
        // Then filter by the passed filter and this Store's filter function
        // because events found from the date indices won't be filtered.

        const occurrences = (includeOccurrences ? e.getOccurrencesForDateRange(startDate, endDate) : [e]).filter(filter); // Add occurrences to dateMap

        for (let bucket, i = 0, {
          length
        } = occurrences; i < length; i++) {
          const occurrence = occurrences[i],
                date = dayTime.startOfDay(occurrence.startDate),
                indexName = getDateIndex ? getDateIndex(date) : startOnly ? 'startDate' : 'date',
                lastInteresctingDate = indexName === 'startDate' ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(date, 1, 'day') : occurrence.endDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(occurrence.startDate, occurrence.duration, occurrence.durationUnit); // Loop through covered dates, adding to dateMap if required

          for (; date < lastInteresctingDate; date.setDate(date.getDate() + 1)) {
            const key = dayTime.dateKey(date);
            (bucket = dateMap.get(key)) || dateMap.set(key, bucket = []);
            bucket.push(occurrence);
          }
        }
      }
    }

    return dateMap;
  }
  /**
   * Calls the supplied iterator function once for every scheduled event, providing these arguments
   * - event : the event record
   * - startDate : the event start date
   * - endDate : the event end date
   *
   * Returning false cancels the iteration.
   *
   * @param {Function} fn iterator function
   * @param {Object} thisObj `this` reference for the function
   * @category Events
   */


  forEachScheduledEvent(fn, thisObj = this) {
    this.forEach(event => {
      const {
        startDate,
        endDate
      } = event;

      if (startDate && endDate) {
        return fn.call(thisObj, event, startDate, endDate);
      }
    });
  }
  /**
   * Returns an object defining the earliest start date and the latest end date of all the events in the store.
   *
   * @return {Object} An object with 'start' and 'end' Date properties (or null values if data is missing).
   * @category Events
   */


  getTotalTimeSpan() {
    let earliest = new Date(9999, 0, 1),
        latest = new Date(0);
    this.forEach(event => {
      if (event.startDate) {
        earliest = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].min(event.startDate, earliest);
      }

      if (event.endDate) {
        latest = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].max(event.endDate, latest);
      }
    }); // TODO: this will fail in programs designed to work with events in the past (after Jan 1, 1970)

    earliest = earliest < new Date(9999, 0, 1) ? earliest : null;
    latest = latest > new Date(0) ? latest : null; // keep last calculated value to be able to track total timespan changes

    return this.lastTotalTimeSpan = {
      startDate: earliest || null,
      endDate: latest || earliest || null
    };
  }
  /**
   * Checks if given event record is persistable. By default it always is, override EventModels `isPersistable` if you
   * need custom logic.
   *
   * @param {Scheduler.model.EventModel} event
   * @return {Boolean}
   * @category Events
   */


  isEventPersistable(event) {
    return event.isPersistable;
  } //endregion
  //region Resource

  /**
   * Checks if a date range is allocated or not for a given resource.
   * @param {Date} start The start date
   * @param {Date} end The end date
   * @param {Scheduler.model.EventModel|null} excludeEvent An event to exclude from the check (or null)
   * @param {Scheduler.model.ResourceModel} resource The resource
   * @return {Boolean} True if the timespan is available for the resource
   * @category Resource
   */


  isDateRangeAvailable(start, end, excludeEvent, resource) {
    // NOTE: Also exists in TaskStore.js
    // This should be a collection of unique event records
    const allEvents = new Set(this.getEventsForResource(resource)); // In private mode we can pass an AssignmentModel. In this case, we assume that multi-assignment is used.
    // So we need to make sure that other resources are available for this time too.
    // No matter if the event retrieved from the assignment belongs to the target resource or not.
    // We gather all events from from the resources the event is assigned to except of the one from the assignment record.
    // Note, events from the target resource are added above.

    if (excludeEvent !== null && excludeEvent !== void 0 && excludeEvent.isAssignment) {
      const currentEvent = excludeEvent.event,
            resources = currentEvent.resources;
      resources.forEach(resource => {
        // Ignore events for the resource which is passed as an AssignmentModel to excludeEvent
        if (resource.id !== excludeEvent.resourceId) {
          this.getEventsForResource(resource).forEach(event => allEvents.add(event));
        }
      });
    }

    if (excludeEvent) {
      const eventToRemove = excludeEvent.isAssignment ? excludeEvent.event : excludeEvent;
      allEvents.delete(eventToRemove);
    }

    return !Array.from(allEvents).some(event => event.isScheduled && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].intersectSpans(start, end, event.startDate, event.endDate));
  }
  /**
   * Filters the events associated with a resource, based on the function provided. An array will be returned for those
   * events where the passed function returns true.
   * @param {Scheduler.model.ResourceModel} resource
   * @param {Function} fn The function
   * @param {Object} [thisObj] `this` reference for the function
   * @return {Scheduler.model.EventModel[]} the events in the time span
   * @private
   * @category Resource
   */


  filterEventsForResource(resource, fn, thisObj = this) {
    return resource.getEvents(this).filter(fn.bind(thisObj));
  }
  /**
   * Returns all resources assigned to an event.
   *
   * @param {Scheduler.model.EventModel|String|Number} event
   * @return {Scheduler.model.ResourceModel[]}
   * @category Resource
   */


  getResourcesForEvent(event) {
    // If we are sent an occurrence, use its parent
    if (event.isOccurrence) {
      event = event.recurringTimeSpan;
    }

    return this.assignmentStore.getResourcesForEvent(event);
  }
  /**
   * Returns all events assigned to a resource.
   *
   * @param {Scheduler.model.ResourceModel|String|Number} resource Resource or resource id.
   *   *NOTE:* this does not include occurrences of recurring events. Use the {@link #function-getEvents} API
   *   to include occurrences of recurring events.
   * @return {Scheduler.model.EventModel[]}
   * @category Resource
   */


  getEventsForResource(resource) {
    return this.assignmentStore.getEventsForResource(resource);
  } //endregion
  //region Assignment

  /**
   * Returns all assignments for a given event.
   *
   * @param {Scheduler.model.EventModel|String|Number} event
   * @return {Scheduler.model.AssignmentModel[]}
   * @category Assignment
   */


  getAssignmentsForEvent(event) {
    return this.assignmentStore.getAssignmentsForEvent(event) || [];
  }
  /**
   * Returns all assignments for a given resource.
   *
   * @param {Scheduler.model.ResourceModel|String|Number} resource
   * @return {Scheduler.model.AssignmentModel[]}
   * @category Assignment
   */


  getAssignmentsForResource(resource) {
    return this.assignmentStore.getAssignmentsForResource(resource) || [];
  }
  /**
   * Creates and adds assignment record for a given event and a resource.
   *
   * @param {Scheduler.model.EventModel|String|Number} event
   * @param {Scheduler.model.ResourceModel|String|Number|Scheduler.model.ResourceModel[]|String[]|Number[]} resource The resource(s) to assign to the event
   * @param {Boolean} [removeExistingAssignments] `true` to first remove existing assignments
   * @return {Scheduler.model.AssignmentModel[]} An array with the created assignment(s)
   * @category Assignment
   */


  assignEventToResource(event, resource, removeExistingAssignments = false) {
    return this.assignmentStore.assignEventToResource(event, resource, undefined, removeExistingAssignments);
  }
  /**
   * Removes assignment record for a given event and a resource.
   *
   * @param {Scheduler.model.EventModel|String|Number} event
   * @param {Scheduler.model.ResourceModel|String|Number} resource
   * @category Assignment
   */


  unassignEventFromResource(event, resource) {
    this.assignmentStore.unassignEventFromResource(event, resource);
  }
  /**
   * Reassigns an event from an old resource to a new resource
   *
   * @param {Scheduler.model.EventModel}    event    An event or id of the event to reassign
   * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]} oldResource A resource or id to unassign from
   * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]} newResource A resource or id to assign to
   * @category Assignment
   */


  reassignEventFromResourceToResource(event, oldResource, newResource) {
    const me = this,
          newResourceId = _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_1__["default"].asId(newResource),
          assignment = me.assignmentStore.getAssignmentForEventAndResource(event, oldResource);

    if (assignment) {
      assignment.resourceId = newResourceId;
    } else {
      me.assignmentStore.assignEventToResource(event, newResource);
    }
  }
  /**
   * Checks whether an event is assigned to a resource.
   *
   * @param {Scheduler.model.EventModel|String|Number} event
   * @param {Scheduler.model.ResourceModel|String|Number} resource
   * @return {Boolean}
   * @category Assignment
   */


  isEventAssignedToResource(event, resource) {
    return this.assignmentStore.isEventAssignedToResource(event, resource);
  }
  /**
   * Removes all assignments for given event
   *
   * @param {Scheduler.model.EventModel|String|Number} event
   * @category Assignment
   */


  removeAssignmentsForEvent(event) {
    this.assignmentStore.removeAssignmentsForEvent(event);
  }
  /**
   * Removes all assignments for given resource
   *
   * @param {Scheduler.model.ResourceModel|String|Number} resource
   * @category Assignment
   */


  removeAssignmentsForResource(resource) {
    this.assignmentStore.removeAssignmentsForResource(resource);
  } //endregion
  //region Indexing

  /**
   * Invalidates associated day indices.
   * @internal
   */


  invalidateDayIndices() {
    var _this$dayIndices;

    (_this$dayIndices = this.dayIndices) === null || _this$dayIndices === void 0 ? void 0 : _this$dayIndices.forEach(dayIndex => dayIndex.invalidate());
  }
  /**
   * Registers a `DayTime` instance, creating an `EventDayIndex` for each distinct `startShift`. This index is
   * maintained until all instances with a matching `startShift` are {@link #function-unregisterDayIndex unregistered}.
   * @param {Core.util.DayTime} dayTime The instance to register.
   * @internal
   * @category Indexing
   */


  registerDayIndex(dayTime) {
    const me = this,
          dayIndices = me.dayIndices || (me.dayIndices = []);
    let dayIndex, i;

    for (i = 0; !dayIndex && i < dayIndices.length; ++i) {
      if (dayIndices[i].matches(dayTime)) {
        (dayIndex = dayIndices[i]).register(dayTime);
      }
    }

    !dayIndex && dayIndices.push(dayIndex = new _util_EventDayIndex_js__WEBPACK_IMPORTED_MODULE_5__["default"](me, dayTime));
    return dayIndex;
  }

  syncIndices(...args) {
    var _this$dayIndices2;

    (_this$dayIndices2 = this.dayIndices) === null || _this$dayIndices2 === void 0 ? void 0 : _this$dayIndices2.forEach(dayIndex => dayIndex.sync(...args));
  }
  /**
   * Removes a registered `DayTime` instance. If this is the last instance registered to an `EventDayIndex`, that
   * index is removed.
   * @param {Core.util.DayTime} dayTime The instance to unregister.
   * @internal
   * @category Indexing
   */


  unregisterDayIndex(dayTime) {
    const me = this,
          {
      dayIndices
    } = me;

    for (let i = dayIndices === null || dayIndices === void 0 ? void 0 : dayIndices.length; i-- > 0;) {
      if (dayIndices[i].matches(dayTime)) {
        if (dayIndices[i].unregister(dayTime)) {
          dayIndices.splice(i, 1);
        }

        break;
      }
    }
  }
  /**
   * Returns the `EventDayIndex` to use for the given `DayTime` instance. This may be the primary instance or a
   * child instance created by {@link #function-registerDayIndex}.
   * @param {Core.util.DayTime} dayTime The `DayTime` of the desired index.
   * @return {Scheduler.data.util.EventDayIndex}
   * @private
   * @category Indexing
   */


  useDayIndex(dayTime) {
    const me = this,
          {
      dayIndices
    } = me;
    dayTime = dayTime || MIDNIGHT;

    for (let i = 0; dayIndices && i < dayIndices.length; ++i) {
      if (dayIndices[i].matches(dayTime)) {
        return dayIndices[i];
      }
    }

    if (dayTime.startShift) {
      throw new Error(`No day index registered for ${dayTime} on ${me.id}`);
    }

    return me.registerDayIndex(MIDNIGHT);
  } //endregion


});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/PartOfBaseProject.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/data/mixin/PartOfBaseProject.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var productName = 'taskboard'; // Private class that leverages the differences between a core and a basic project

/* harmony default export */ __webpack_exports__["default"] = (Target => class PartOfBaseProject extends Target {
  static get $name() {
    return 'PartOfBaseProject';
  }

  get assignmentStore() {
    return this.project.assignmentStore;
  }

  get calendarManagerStore() {
    return this.project.calendarManagerStore;
  }

  get dependencyStore() {
    return this.project.dependencyStore;
  }

  get eventStore() {
    return this.project.eventStore;
  }

  get resourceStore() {
    return this.project.resourceStore;
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/PartOfProject.js":
/*!***************************************************!*\
  !*** ./lib/Scheduler/data/mixin/PartOfProject.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';

/**
 * @module Scheduler/data/mixin/PartOfProject
 */

/**
 * This is a mixin, included in all models and stores of the Scheduler project. It provides a common API for accessing
 * all stores of the project.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class PartOfProject extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  /**
   * Returns the project this entity belongs to.
   *
   * @member {Scheduler.model.ProjectModel} project
   * @readonly
   * @category Project
   */

  /**
   * Returns the event store of the project this entity belongs to.
   *
   * @member {Scheduler.data.EventStore} eventStore
   * @readonly
   * @category Project
   */

  /**
   * Returns the dependency store of the project this entity belongs to.
   *
   * @member {Scheduler.data.DependencyStore} dependencyStore
   * @readonly
   * @category Project
   */

  /**
   * Returns the assignment store of the project this entity belongs to.
   *
   * @member {Scheduler.data.AssignmentStore} assignmentStore
   * @readonly
   * @category Project
   */

  /**
   * Returns the resource store of the project this entity belongs to.
   *
   * @member {Scheduler.data.ResourceStore} resourceStore
   * @readonly
   * @category Project
   */
  static get $name() {
    return 'PartOfProject';
  } // Only called when this is mixed into a Store class.
  // When a record has its isCreating status cleared.


  onIsCreatingToggle(record, isCreating) {
    var _this$project;

    // Base Store class has its say first
    super.onIsCreatingToggle(record, isCreating); // If the owning project is a CrudManager that is autosyncing, sync immediately
    // now that we have a definite new record. May be a chained store with no project.

    if (!record.isCreating && (_this$project = this.project) !== null && _this$project !== void 0 && _this$project.autoSync) {
      this.project.sync();
    }
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/ProjectCrudManager.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/ProjectCrudManager.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Scheduler_crud_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Scheduler/crud/AbstractCrudManagerMixin.js */ "./lib/Scheduler/crud/AbstractCrudManagerMixin.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../crud/transport/AjaxTransport.js */ "./lib/Scheduler/crud/transport/AjaxTransport.js");
/* harmony import */ var _crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../crud/encoder/JsonEncoder.js */ "./lib/Scheduler/crud/encoder/JsonEncoder.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
var productName = 'taskboard';






/**
 * @module Scheduler/data/mixin/ProjectCrudManager
 */

/**
 * This mixin provides Crud Manager functionality supporting loading of scheduling engine projects.
 *
 * @mixin
 * @mixes Scheduler/crud/AbstractCrudManagerMixin
 * @mixes Scheduler/crud/transport/AjaxTransport
 * @mixes Scheduler/crud/encoder/JsonEncoder
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class ProjectCrudManager extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_2__["default"]).mixin(_Scheduler_crud_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_0__["default"], _crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_3__["default"], _crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_4__["default"]) {
  //region Config
  static get defaultConfig() {
    return {
      /**
       * A project that holds and links stores
       * @config {Scheduler.model.ProjectModel}
       */
      project: null
    };
  }

  startConfigure(config) {
    // process the project first which ingests any configured data sources,
    this.getConfig('project');
    super.startConfigure(config);
    this._changesToClear = new Map();
  }

  async doAutoLoad() {
    const {
      project
    } = this; // Delay autoLoad to after projects initial commit if configured with a project

    if (project) {
      await project.commitAsync();
    }

    return super.doAutoLoad();
  }

  loadCrudManagerData(response, options = {}) {
    const me = this,
          {
      project
    } = me; // we don't want reacting on store changes during loading of them

    me.suspendChangesTracking();
    super.loadCrudManagerData(...arguments); // if there is the project data provided

    if (response !== null && response !== void 0 && response.project) {
      me.applyingProjectResponse = true;
      Object.assign(project, response.project);
      me.applyingProjectResponse = false;
    }

    me.resumeChangesTracking();
  }

  async sync() {
    const {
      project
    } = this; // Suspend Crud Manager autoSync to not react on changes during commitAsync() call

    this.suspendAutoSync(); // Make sure data is in a calculated state before syncing

    if (project) {
      await project.commitAsync();
    } // resume autoSync silently


    this.resumeAutoSync(false);
    return super.sync();
  }

  async applyResponse(request, response, options) {
    var _me$project;

    const me = this;

    if (me.isDestroyed || (_me$project = me.project) !== null && _me$project !== void 0 && _me$project.isDestroyed) {
      return;
    }

    me.trigger('startApplyResponse'); // clear "added"/"modified" collections on the stores
    // TODO: need to snapshot their state to be able to revert in case of an exception

    me.clearCrudStoresChanges({
      clearRemovedCollection: false
    });
    await super.applyResponse(request, response, options); // clear "removed" collection on the stores

    me.clearCrudStoresChanges({
      removeAddedRecords: false,
      clearAddedCollection: false,
      clearModifiedCollection: false,
      clearRemovedCollection: true
    }); // if there is the project data provided

    if (response !== null && response !== void 0 && response.project) {
      me.applyingProjectResponse = true;
      Object.assign(me, response.project);
      me.applyingProjectResponse = false;
    } // if we have a project


    if (me.project) {
      let requestType = request.type; // response can force its type

      if (me.trackResponseType) {
        requestType = response.type || requestType;
      } // Make a boolean flag indicating what has triggered the propagation ("propagatingLoadChanges" or  "propagatingSyncChanges")


      const propagationFlag = `propagating${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(requestType)}Changes`;
      me[propagationFlag] = true; // Wait till calculation gets done

      await me.project.commitAsync();
      me[propagationFlag] = false; // Accept changes came from the server

      this.commitRespondedChanges();
    }
  }

  commitRespondedChanges() {
    // We silently accept changes came from the server
    this._changesToClear.forEach((changes, record) => {
      Object.entries(changes).forEach(([key, value]) => {
        const field = record.getFieldDefinition(key),
              oldValue = record[key]; // If the field value matches the one responded from the server
        // we silently accept it

        if (field !== null && field !== void 0 && field.isEqual ? field.isEqual(oldValue, value) : _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].isEqual(oldValue, value)) {
          delete record.meta.modified[key];
        }
      });
    });

    this._changesToClear.clear();
  }

  clearRecordChanges(record, changes) {
    super.clearRecordChanges(record, changes);

    if (this.project) {
      // The changes get into graph first but not into a store
      // so record.clearChanges() call (made in above super.clearRecordChanges())
      // does not really clear anything.
      // We need to cleanup the changes after the next propagation is done.
      // So here we just store record changes in a map.
      this._changesToClear.set(record, changes);
    }
  }

  clearCrudStoresChanges(flags = {
    removeAddedRecords: true,
    clearAddedCollection: true,
    clearModifiedCollection: true,
    clearRemovedCollection: true
  }) {
    const {
      removeAddedRecords,
      clearAddedCollection,
      clearModifiedCollection,
      clearRemovedCollection
    } = flags; // TODO: Change when https://app.assembla.com/spaces/bryntum/tickets/8975 is fixed
    // this.crudStores.forEach(store => store.store.clearChanges());

    this.forEachCrudStore(store => {
      if (removeAddedRecords) {
        // remove phantom records
        store.remove(this.added, true);
      }

      if (clearModifiedCollection) {
        store.modified.forEach(r => r.clearChanges(false));
        store.modified.clear();
      }

      if (clearAddedCollection) {
        store.added.clear();
      }

      if (clearRemovedCollection) {
        store.removed.clear();
      }
    });
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/RecurringEventsMixin.js":
/*!**********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/RecurringEventsMixin.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _RecurringTimeSpansMixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./RecurringTimeSpansMixin.js */ "./lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js");
var productName = 'taskboard';


/**
 * @module Scheduler/data/mixin/RecurringEventsMixin
 */

/**
 * This mixin class provides recurring events functionality to the {@link Scheduler.data.EventStore event store}.
 * @extends Scheduler/data/mixin/RecurringTimeSpansMixin
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class RecurringEventsMixin extends Object(_RecurringTimeSpansMixin_js__WEBPACK_IMPORTED_MODULE_1__["default"])(Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'RecurringEventsMixin';
  }
  /**
   * Returns all the recurring events.
   *
   * **An alias for ** {@link Scheduler.data.mixin.RecurringTimeSpansMixin#function-getRecurringTimeSpans} method.
   *
   * @return {Scheduler.model.EventModel[]} Array of recurring events.
   * @category Recurrence
   */


  getRecurringEvents() {
    return this.getRecurringTimeSpans();
  }

  isEventPersistable(event) {
    // occurrences are not persistable
    return super.isEventPersistable(event) && (!event.supportsRecurring || !event.isOccurrence);
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js":
/*!*************************************************************!*\
  !*** ./lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';

/**
 * @module Scheduler/data/mixin/RecurringTimeSpansMixin
 */

const emptyArray = Object.freeze([]);
/**
 * This mixin class provides recurring timespans functionality to a store of {@link Scheduler.model.TimeSpan TimeSpan} models.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class RecurringTimeSpansMixin extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'RecurringTimeSpansMixin';
  }

  construct(...args) {
    const me = this; // We store all generated occurrences keyed by `_generated_${recurringTimeSpan.id}:${occurrenceStartDate}`
    // So that when asked to generate an occurrence for a date, an already generated one can be returned.

    me.globalOccurrences = new Map(); // All recurring events added to the store are accessible through this Set. It's used
    // to generate occurrences.

    me.recurringEvents = new Set();
    super.construct(...args);
  } // Override to refreshRecurringEventsCache on initial load


  afterLoadData() {
    // All cached occurrences are now potentially invalid.
    // A store reload might imply any number of changes which invalidate any occurrence.
    this.globalOccurrences.clear(); // Clear and rebuild the recurring events cache

    this.refreshRecurringEventsCache('clear');
    this.refreshRecurringEventsCache('splice', this.storage.allValues);
    super.afterLoadData && super.afterLoadData();
  }
  /**
   * Responds to mutations of the underlying storage Collection.
   *
   * Maintain indices for fast finding of events by date.
   * @param {Object} event
   * @private
   */


  onDataChange({
    action,
    added,
    removed,
    replaced
  }) {
    // Recurring events cache must be refreshed before responding to change
    this.refreshRecurringEventsCache(action, added, removed, replaced);
    super.onDataChange(...arguments);
  }

  refreshRecurringEventsCache(action, added = emptyArray, removed = emptyArray, replaced) {
    const me = this,
          {
      recurringEvents
    } = me,
          replacedCount = replaced === null || replaced === void 0 ? void 0 : replaced.length;

    switch (action) {
      case 'clear':
        recurringEvents.clear();
        break;
      // Add and remove

      case 'splice':
        // Handle replacement of records by instances with same ID
        if (replacedCount) {
          added = added.slice();
          removed = removed.slice();

          for (let i = 0; i < replacedCount; i++) {
            removed.push(replaced[i][0]);
            added.push(replaced[i][1]);
          }
        }

        const addedCount = added.length,
              removedCount = removed.length; // Track the recurring events we contain

        if (removedCount && recurringEvents.size) {
          for (let i = 0; i < removedCount; i++) {
            const outgoingEvent = removed[i];

            if (outgoingEvent.isRecurring) {
              recurringEvents.delete(outgoingEvent);
            }
          }
        } // Track the recurring events we contain


        if (addedCount) {
          for (let i = 0; i < addedCount; i++) {
            const newEvent = added[i]; // Allow easy access to recurring events

            if (newEvent.isRecurring) {
              recurringEvents.add(newEvent);
            }
          }
        }

        break;
    }
  }

  getById(id) {
    let result = super.getById(id); // If the id is not found in the Store, then it could be one of our generated occurrences

    if (!result) {
      result = this.globalOccurrences.get(this.modelClass.asId(id));
    }

    return result;
  }

  onModelChange(record, toSet, wasSet, silent, fromRelationUpdate) {
    const isRecurrenceRelatedFieldChange = this.isRecurrenceRelatedFieldChange(record, wasSet); // If this is the base of a recurring sequence, then any reactors to events from
    // the super call must regenerate occurrences, so must be done at top.
    // If silent is true, occurrences won't be recalculated. Do not remove occurrences from cache in such case.

    if (isRecurrenceRelatedFieldChange && !silent) {
      record.removeOccurrences();
    }

    super.onModelChange(...arguments); // If this is the base of a recurring sequence, then the EventStore must
    // trigger a refresh event so that UIs refresh themselves.
    // This could be at the tail end of the creation of an exception
    // or a new recurring base.

    if (isRecurrenceRelatedFieldChange && !silent) {
      const event = {
        action: 'batch',
        records: this.storage.values
      };
      this.trigger('refresh', event);
      this.trigger('change', event);
    }
  }
  /**
   * The method restricts which field modifications should trigger timespan occurrences building.
   * By default any field change of a recurring timespan causes the rebuilding.
   * @param  {Scheduler.model.TimeSpan} timeSpan The modified timespan.
   * @param  {Object} wasSet Object containing the change set.
   * @return {Boolean} `True` if the fields modification should trigger the timespan occurrences rebuilding.
   * @internal
   * @category Recurrence
   */


  isRecurrenceRelatedFieldChange(timeSpan, wasSet) {
    return timeSpan.isRecurring || 'recurrenceRule' in wasSet;
  }
  /**
   * Builds occurrences for the provided timespan across the provided date range.
   * @private
   * @category Recurrence
   */


  getOccurrencesForTimeSpan(timeSpan, startDate, endDate) {
    const result = [];

    if (timeSpan.isRecurring) {
      timeSpan.recurrence.forEachOccurrence(startDate, endDate, r => result.push(r));
    }

    return result;
  }

  set data(data) {
    // All cached occurrences are now invalid with a new dataset
    this.globalOccurrences.clear();
    super.data = data;
  }
  /**
   * Returns all the recurring timespans.
   * @return {Scheduler.model.TimeSpan[]} Array of recurring events.
   * @category Recurrence
   */


  getRecurringTimeSpans() {
    return [...this.recurringEvents];
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/ResourceStoreMixin.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/ResourceStoreMixin.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';

/**
 * @module Scheduler/data/mixin/ResourceStoreMixin
 */

/**
 * This is a mixin for the ResourceStore functionality. It is consumed by the {@link Scheduler.data.ResourceStore}.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class ResourceStoreMixin extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'ResourceStoreMixin';
  }

  get isResourceStore() {
    return true;
  }
  /**
   * Add resources to the store.
   *
   * NOTE: References (events, assignments) on the resources are determined async by a calculation engine. Thus they
   * cannot be directly accessed after using this function.
   *
   * For example:
   *
   * ```javascript
   * const [resource] = resourceStore.add({ id });
   * // resource.events is not yet available
   * ```
   *
   * To guarantee references are set up, wait for calculations for finish:
   *
   * ```javascript
   * const [resource] = resourceStore.add({ id });
   * await resourceStore.project.commitAsync();
   * // resource.events is available (assuming EventStore is loaded and so on)
   * ```
   *
   * Alternatively use `addAsync()` instead:
   *
   * ```javascript
   * const [resource] = await resourceStore.addAsync({ id });
   * // resource.events is available (assuming EventStore is loaded and so on)
   * ```
   *
   * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.ResourceModel[]} Added records
   * @function add
   * @category CRUD
   */

  /**
   * Add resources to the store and triggers calculations directly after. Await this function to have up to date
   * references on the added resources.
   *
   * ```javascript
   * const [resource] = await resourceStore.addAsync({ id });
   * // resource.events is available (assuming EventStore is loaded and so on)
   * ```
   *
   * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.ResourceModel[]} Added records
   * @function addAsync
   * @category CRUD
   * @async
   */

  /**
   * Applies a new dataset to the ResourceStore. Use it to plug externally fetched data into the store.
   *
   * NOTE: References (events, assignments) on the resources are determined async by a calculation engine. Thus
   * they cannot be directly accessed after assigning the new dataset.
   *
   * For example:
   *
   * ```javascript
   * resourceStore.data = [{ id }];
   * // resourceStore.first.events is not yet available
   * ```
   *
   * To guarantee references are available, wait for calculations for finish:
   *
   * ```javascript
   * resourceStore.data = [{ id }];
   * await resourceStore.project.commitAsync();
   * // resourceStore.first.events is available
   * ```
   *
   * Alternatively use `loadDataAsync()` instead:
   *
   * ```javascript
   * await resourceStore.loadDataAsync([{ id }]);
   * // resourceStore.first.events is available
   * ```
   *
   * @member {Object[]} data
   * @category Records
   */

  /**
   * Applies a new dataset to the ResourceStore and triggers calculations directly after. Use it to plug externally
   * fetched data into the store.
   *
   * ```javascript
   * await resourceStore.loadDataAsync([{ id }]);
   * // resourceStore.first.events is available
   * ```
   *
   * @param {Object[]} data Array of ResourceModel data objects
   * @function loadDataAsync
   * @category CRUD
   * @async
   */


  static get defaultConfig() {
    return {
      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 200,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 100,
      storeId: 'resources',
      autoTree: true
    };
  }

  construct(config) {
    super.construct(config);

    if (!this.modelClass.isResourceModel) {
      throw new Error('Model for ResourceStore must subclass ResourceModel');
    }
  }

  removeAll() {
    const result = super.removeAll(...arguments); // Removing all resources removes all assignments

    result && this.assignmentStore.removeAll();
    return result;
  } // Apply id changes also to assignments (used to be handled automatically by relations earlier, but engine does not
  // care about ids so needed now)
  // problems:
  // 1. orientation/HorizontalRendering listens to assignment store changes and is trying to refresh view
  // When we update resource id on assignment, listener will be invoked and view will try to refresh. And it will
  // fail, because row is not updated yet. Flag is raised on resource store to make HorizontalRendering to skip
  // refreshing view in this particular case of resource id changing


  onRecordIdChange({
    record,
    oldValue,
    value
  }) {
    super.onRecordIdChange({
      record,
      oldValue,
      value
    });

    if (record.isFieldModified('id')) {
      this.isChangingId = true;
      record.updateAssignmentResourceIds();
      this.isChangingId = false;
    }
  }

});

/***/ }),

/***/ "./lib/Scheduler/data/mixin/SharedEventStoreMixin.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/data/mixin/SharedEventStoreMixin.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var productName = 'taskboard';
/* eslint-disable no-unused-expressions */

/**
 * @module Scheduler/data/mixin/SharedEventStoreMixin
 */

/**
 * This is a mixin, containing functionality related to managing events.
 *
 * It is consumed by the regular {@link Scheduler.data.EventStore} class and Scheduler Pros counterpart.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class SharedEventStoreMixin extends Target {
  static get $name() {
    return 'SharedEventStoreMixin';
  }
  /**
   * Add events to the store.
   *
   * NOTE: Dates, durations and references (assignments, resources) on the events are determined async by a calculation
   * engine. Thus they cannot be directly accessed after using this function.
   *
   * For example:
   *
   * ```javascript
   * eventStore.add({ startDate, duration });
   * // endDate is not yet calculated
   * ```
   *
   * To guarantee data is in a calculated state, wait for calculations for finish:
   *
   * ```javascript
   * eventStore.add({ startDate, duration });
   * await eventStore.project.commitAsync();
   * // endDate is calculated
   * ```
   *
   * Alternatively use `addAsync()` instead:
   *
   * ```javascript
   * await eventStore.addAsync({ startDate, duration });
   * // endDate is calculated
   * ```
   *
   * @param {Scheduler.model.EventModel|Scheduler.model.EventModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.EventModel[]} Added records
   * @function add
   * @category CRUD
   */

  /**
   * Add events to the store and triggers calculations directly after. Await this function to have up to date data on
   * the added events.
   *
   * ```javascript
   * await eventStore.addAsync({ startDate, duration });
   * // endDate is calculated
   * ```
   *
   * @param {Scheduler.model.EventModel|Scheduler.model.EventModel[]|Object|Object[]} records
   * Array of records/data or a single record/data to add to store
   * @param {Boolean} [silent] Specify `true` to suppress events
   * @returns {Scheduler.model.EventModel[]} Added records
   * @function addAsync
   * @category CRUD
   * @async
   */

  /**
   * Applies a new dataset to the EventStore. Use it to plug externally fetched data into the store.
   *
   * NOTE: Dates, durations and relations (assignments, resources) on the events are determined async by a calculation
   * engine. Thus they cannot be directly accessed after assigning the new dataset.
   *
   * For example:
   *
   * ```javascript
   * eventStore.data = [{ startDate, duration }];
   * // eventStore.first.endDate is not yet calculated
   * ```
   *
   * To guarantee data is in a calculated state, wait for calculations for finish:
   *
   * ```javascript
   * eventStore.data = [{ startDate, duration }];
   * await eventStore.project.commitAsync();
   * // eventStore.first.endDate is calculated
   * ```
   *
   * Alternatively use `loadDataAsync()` instead:
   *
   * ```javascript
   * await eventStore.loadDataAsync([{ startDate, duration }]);
   * // eventStore.first.endDate is calculated
   * ```
   *
   * @member {Object[]} data
   * @category Records
   */

  /**
   * Applies a new dataset to the EventStore and triggers calculations directly after. Use it to plug externally
   * fetched data into the store.
   *
   * ```javascript
   * await eventStore.loadDataAsync([{ startDate, duration }]);
   * // eventStore.first.endDate is calculated
   * ```
   *
   * @param {Object[]} data Array of EventModel data objects
   * @function loadDataAsync
   * @category CRUD
   * @async
   */


  static get defaultConfig() {
    return {
      /**
       * CrudManager must load stores in the correct order. Lowest first.
       * @private
       */
      loadPriority: 100,

      /**
       * CrudManager must sync stores in the correct order. Lowest first.
       * @private
       */
      syncPriority: 200,
      storeId: 'events',

      /**
       * Configure with `true` to also remove the event when removing the last assignment from the linked
       * AssignmentStore. This config has not effect when using EventStore in legacy `resourceId`-mode.
       * @config {Boolean}
       * @default
       * @category Common
       */
      removeUnassignedEvent: true,

      /**
       * Configure with `true` to force single-resource mode, an event can only be assigned to a single resource.
       * If not provided, the mode will be inferred from
       *
       * 1. presence of an assignment store (i.e. multi-assignment)
       * 2. presence of `resourceId` in the event store data (i.e. single assignment mode)
       * @config {Boolean}
       * @category Common
       */
      singleAssignment: null
    };
  }
  /**
   * Class used to represent records. Defaults to class EventModel.
   * @member {Scheduler.model.EventModel} modelClass
   * @typings {typeof EventModel}
   * @category Records
   */


  construct(config) {
    super.construct(config, true);

    if (this.singleAssignment) {
      this.usesSingleAssignment = true;
    }

    if (!this.modelClass.isEventModel) {
      throw new Error('The model for the EventStore must subclass EventModel');
    }
  }
  /**
   * Appends a new record to the store
   * @param {Scheduler.model.EventModel} record The record to append to the store
   * @category CRUD
   */


  append(record) {
    return this.add(record);
  } //region Project


  get project() {
    return super.project;
  }

  set project(project) {
    super.project = project;
    this.detachListeners('project');

    if (project) {
      var _project$assignmentSt;

      // Project already has AssignmentStore instance? Attach to it.
      if ((_project$assignmentSt = project.assignmentStore) !== null && _project$assignmentSt !== void 0 && _project$assignmentSt.isAssignmentStore) {
        this.attachToAssignmentStore(project.assignmentStore);
      } // Accessing assignmentStore would trigger `assignmentStoreChange` event on the project, so we set up
      // the listener after


      project.on({
        name: 'project',
        assignmentStoreChange: 'onProjectAssignmentStoreChange',
        thisObj: this,
        prio: 200 // Before UI updates

      });
    }
  } //endregion
  //region Single assignment


  processRecords(eventRecords) {
    var _this$stm;

    const {
      assignmentStore
    } = this,
          assignmentsToAdd = []; // Same as on `joinRecordsToStore`, when adding a number of event records CoreEventMixin#joinProject method
    // will clear/rebuild cache in a loop. We raise this flag to skip invalidating assignment store indices for the time
    // we are joining records to the store. When they're added and indices are read, we will invalidate them.

    if (assignmentStore) {
      assignmentStore.skipInvalidateIndices = true;
    }

    eventRecords = super.processRecords(eventRecords, assignmentStore && !((_this$stm = this.stm) !== null && _this$stm !== void 0 && _this$stm.isRestoring) && (eventRecord => {
      // AssignmentStore found, add an assignment to it if this is not a dataset operation
      const resourceId = eventRecord.get('resourceId');

      if (!eventRecord.reassignedFromReplace && resourceId != null) {
        // Check if the event is already assigned to the resource, though it's not in the event store.
        // It could happen when you remove an event, so both event and assignment records are removed,
        // then you "undo" the action and the assignment is restored before the event is restored.
        if (!assignmentStore.includesAssignment(eventRecord.id, resourceId)) {
          // Cannot use `event.assign(resourceId)` since event is not part of store yet
          // Using a bit shorter generated id to not look so ugly in DOM
          assignmentsToAdd.push({
            id: assignmentStore.modelClass.generateId(''),
            resourceId,
            eventId: eventRecord.id
          });
        }
      } // clear flag


      eventRecord.reassignedFromReplace = false;
    }) || undefined);

    if (assignmentStore) {
      assignmentStore.storage.invalidateIndices();
      assignmentStore.skipInvalidateIndices = false;
      assignmentStore.add(assignmentsToAdd);
    }

    return eventRecords;
  }

  joinRecordsToStore(records) {
    const {
      assignmentStore
    } = this;

    if (assignmentStore) {
      // When adding a number of event records CoreEventMixin#joinProject method will clear/rebuild cache in a loop.
      // We raise this flag to skip invalidating assignment store indices for the time we are joining records to
      // the store. When they're added and indices are read, we will invalidate them.
      assignmentStore.skipInvalidateIndices = true;
      super.joinRecordsToStore(records);
      assignmentStore.storage.invalidateIndices();
      assignmentStore.skipInvalidateIndices = false;
    } else {
      super.joinRecordsToStore(records);
    }
  }

  processRecord(eventRecord, isDataset = false) {
    eventRecord = super.processRecord(eventRecord, isDataset);
    const resourceId = eventRecord.get('resourceId');

    if (resourceId != null) {
      const me = this,
            {
        assignmentStore
      } = me,
            existingRecord = me.getById(eventRecord.id),
            isReplacing = existingRecord && existingRecord !== eventRecord && !isDataset; // Replacing an existing event, repoint the resource of its assignment
      // (already repointed to the new event by engine in EventStoreMixin)

      if (isReplacing) {
        // Have to look assignment up on store, removed by engine in super call above
        const assignment = assignmentStore.find(e => e.eventId === eventRecord.id);

        if (assignment) {
          assignment.resource = resourceId;
          eventRecord.reassignedFromReplace = true;
        }
      } // No AssignmentStore assigned yet, need to process when that happens. Or if it is a dataset operation,
      // processing will happen at the end of it to not add individual assignment (bad for performance)
      else {
        me.$processResourceIds = true;
      } // Flag that we have been loaded using resourceId, checked by CrudManager to exclude the internal
      // AssignmentStore from sync


      me.usesSingleAssignment = true;
    }

    return eventRecord;
  }

  processResourceIds() {
    const {
      assignmentStore
    } = this;

    if (this.$processResourceIds && assignmentStore !== null && assignmentStore !== void 0 && assignmentStore.isAssignmentStore) {
      const assignments = []; // resourceIds used during initialization, convert into assignments

      this.forEach(eventRecord => {
        const {
          resourceId,
          id: eventId
        } = eventRecord;

        if (resourceId != null) {
          // Using a bit shorter generated id to not look so ugly in DOM
          assignments.push({
            id: assignmentStore.modelClass.generateId(''),
            resourceId,
            eventId
          });
        }
      }); // Disable as much as possible, since we are in full control of this store when using single assignment mode

      assignmentStore.useRawData = {
        disableDefaultValue: true,
        disableDuplicateIdCheck: true,
        disableTypeConversion: true
      }; // Flag that throws in AssignmentStore if data is loaded some other way when using single assignment

      assignmentStore.usesSingleAssignment = false;
      assignmentStore.data = assignments;
      assignmentStore.usesSingleAssignment = true;
      this.$processResourceIds = false;
    }
  }

  loadData() {
    super.loadData(...arguments);
    this.processResourceIds();
  } // Optionally remove unassigned events


  onBeforeRemoveAssignment({
    records
  }) {
    var _me$stm;

    const me = this;

    if (me.removeUnassignedEvent && !me.isRemoving && !me.isSettingData && !((_me$stm = me.stm) !== null && _me$stm !== void 0 && _me$stm.isRestoring) && !me.usesSingleAssignment) {
      const toRemove = new Set(); // Collect all events that are unassigned after the remove

      records.forEach(assignmentRecord => {
        const {
          event
        } = assignmentRecord; // Assignment might not have an event or the event might already be removed

        if (event && !event.isRemoved && event.assignments.every(a => records.includes(a))) {
          toRemove.add(event);
        }
      }); // And remove them

      if (toRemove.size) {
        me.remove([...toRemove]);
      }
    }
  }

  onProjectAssignmentStoreChange({
    store
  }) {
    this.attachToAssignmentStore(store);
  }

  attachToAssignmentStore(assignmentStore) {
    const me = this;
    me.detachListeners('assignmentStore');

    if (assignmentStore) {
      me.processResourceIds();
      assignmentStore.on({
        name: 'assignmentStore',

        // Adding an assignment in single assignment mode should set events resourceId if needed
        addPreCommit({
          records
        }) {
          if (me.usesSingleAssignment && !me.isSettingData && !me.isAssigning) {
            records.forEach(assignment => {
              const {
                event
              } = assignment;

              if (event !== null && event !== void 0 && event.isEvent && event.resourceId !== assignment.resourceId) {
                event.meta.isAssigning = true;
                event.set('resourceId', assignment.resourceId);
                event.meta.isAssigning = false;
              }
            });
          }
        },

        // Called both for remove and removeAll
        beforeRemove: 'onBeforeRemoveAssignment',

        // Removing an assignment in single assignment mode should set events resourceId to null
        removePreCommit({
          records
        }) {
          if (me.usesSingleAssignment) {
            records.forEach(assignment => {
              var _me$getById;

              // With engine link to event is already broken when we get here, hence the lookup
              (_me$getById = me.getById(assignment.eventId)) === null || _me$getById === void 0 ? void 0 : _me$getById.set('resourceId', null);
            });
          }
        },

        removeAllPreCommit() {
          if (me.usesSingleAssignment && !me.isSettingData) {
            me.allRecords.forEach(eventRecord => eventRecord.set('resourceId', null));
          }
        },

        // Keep events resourceId in sync with assignment on changes in single assignment mode
        update({
          record,
          changes
        }) {
          if (me.usesSingleAssignment && 'resourceId' in changes) {
            const {
              event
            } = record;
            event.meta.isAssigning = true;
            event.set('resourceId', changes.resourceId.value);
            event.meta.isAssigning = false;
          }
        },

        thisObj: me
      });
    }
  }

  set data(data) {
    this.isSettingData = true; // When using single assignment, remove all assignments when loading a new set of events

    if (this.usesSingleAssignment && !this.syncDataOnLoad) {
      this.assignmentStore.removeAll(true);
    }

    super.data = data;
    this.isSettingData = false;
  } // Override trigger to decorate update/change events with a flag if resourceId was the only thing changed, in which
  // case the change most likely can be ignored since the assignment will also change


  trigger(eventName, params) {
    const {
      changes
    } = params || {};

    if (changes && 'resourceId' in changes && Object.keys(changes).length === 1) {
      params.isAssign = true;
    }

    return super.trigger(...arguments);
  } //endregion


});

/***/ }),

/***/ "./lib/Scheduler/data/util/EventDayIndex.js":
/*!**************************************************!*\
  !*** ./lib/Scheduler/data/util/EventDayIndex.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventDayIndex; });
/* harmony import */ var _Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/util/DayTime.js */ "./lib/Core/util/DayTime.js");
var productName = 'taskboard';

/**
 * @module Scheduler/data/util/EventDayIndex
 */

const // Maps an index name that can be requested to its storage property on the EventDayIndex instance:
indexNameMap = {
  date: '_dateIndex',
  startDate: '_startDateIndex'
},
      indexProps = Object.values(indexNameMap),
      emptyArray = Object.freeze([]),
      {
  MILLIS_PER_DAY
} = _Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_0__["default"];
/**
 * This utility class is used by event stores to index events by their day (a "YYYY-MM-DD" value, also known as a
 * "date key"). This key is produced by a {@link Core.util.DayTime} instance. If two `DayTime` instances have a common
 * `startShift`, they can share an index.
 *
 * @internal
 */

class EventDayIndex {
  constructor(store, dayTime) {
    /**
     * The `DayTime` definition for this index. This is set to the initial DayTime instance but can be used for
     * any other {@link #function-register registered} `DayTime` instances since they all posses the same value for
     * `startShift`.
     *
     * This defaults to {@link Core.util.DayTime#property-MIDNIGHT-static}.
     * @member {Core.util.DayTime} dayTime
     * @readonly
     */
    this.dayTime = dayTime || _Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_0__["default"].MIDNIGHT;
    /**
     * The owning store instance of this index.
     * @member {Scheduler.data.EventStore} store
     * @private
     * @readonly
     */

    this.store = store;
    /**
     * The `DayTime` instances {@link #function-register registered} with this index instance. As instances are
     * {@link #function-unregister unregistered} they are removed from this array. Once this array is empty, this
     * index can be discarded.
     * @member {Core.util.DayTime[]} users
     * @private
     */

    this.users = [this.dayTime];
  }
  /**
   * Adds an event record to the specified index (either "startDate" or "date") for a given `date`.
   * @param {String} indexName The index to which the event record is to be added (either "startDate" or "date").
   * @param {Date|Number} date A date for which the event record overlaps. The {@link Core.util.DayTime#function-dateKey}
   * method is used to convert this date to a "YYYY-MM-DD" key for the index.
   * @param {Scheduler.model.EventModel} eventRecord The event record.
   * @private
   */


  add(indexName, date, eventRecord) {
    const index = this[indexNameMap[indexName]],
          key = this.dayTime.dateKey(date),
          entry = index[key] || (index[key] = new Set());
    entry.add(eventRecord);
  }
  /**
   * Adds an event record to all indexes for all dates which the event overlaps.
   * @param {Scheduler.model.EventModel} eventRecord The event record.
   * @private
   */


  addEvent(eventRecord) {
    var _this$dayTime$startOf;

    let dateMS = (_this$dayTime$startOf = this.dayTime.startOfDay(eventRecord.startDate)) === null || _this$dayTime$startOf === void 0 ? void 0 : _this$dayTime$startOf.getTime(),
        endDateMS;

    if (dateMS) {
      var _eventRecord$endDate$, _eventRecord$endDate;

      endDateMS = (_eventRecord$endDate$ = (_eventRecord$endDate = eventRecord.endDate) === null || _eventRecord$endDate === void 0 ? void 0 : _eventRecord$endDate.getTime()) !== null && _eventRecord$endDate$ !== void 0 ? _eventRecord$endDate$ : dateMS;
      this.add('startDate', dateMS, eventRecord);

      do {
        this.add('date', dateMS, eventRecord);
        dateMS += MILLIS_PER_DAY;
      } while (dateMS < endDateMS);
    }
  }
  /**
   * Clear this index.
   */


  clear() {
    indexProps.forEach(name => this[name] = Object.create(null));
  }
  /**
   * Returns an object that has properties named by the {@link Core.util.DayTime#function-dateKey} method, or the
   * array of event records if a `date` is specified, or the event record array and the date key in a 2-element array
   * if `returnKey` is `true`.
   * @param {String} indexName The name of the desired index (either 'date' or 'startDate').
   * @param {Number|Date} date The date as a `Date` or the millisecond UTC epoch. When passed, this method will return
   * the array of event records for this date.
   * @param {Boolean} [returnKey] Specify `true` to return the date key along with the event record array.
   * @returns {Object|Scheduler.model.EventModel[]}
   */


  get(indexName, date, returnKey) {
    // Date indices are created on first usage and after that kept up to date on changes
    !this.initialized && this.initialize();
    let ret = this[indexNameMap[indexName]],
        key;

    if (date) {
      key = this.dayTime.dateKey(date);
      ret = returnKey ? [ret[key], key] : ret[key];
    }

    return ret;
  }
  /**
   * Called when this index is first used. Once called, further store changes will be used to maintain this index.
   * @private
   */


  initialize() {
    this.initialized = true;
    this.clear();
    this.sync('splice', this.store.storage.allValues);
  }

  invalidate() {
    this.initialized = false;
    indexProps.forEach(name => this[name] = null);
  }
  /**
   * Returns `true` if the given `dayTime` matches this index.
   * @param {Core.util.DayTime} dayTime
   * @returns {Boolean}
   */


  matches(dayTime) {
    return this.dayTime.startShift === dayTime.startShift;
  }
  /**
   * Removes an event record from the specified index (either "startDate" or "date") for a given `date`.
   * @param {String} indexName The index to which the event record is to be removed (either "startDate" or "date").
   * @param {Date|Number} date A date for which the event record overlaps. The {@link Core.util.DayTime#function-dateKey}
   * method is used to convert this date to a "YYYY-MM-DD" key for the index.
   * @param {Scheduler.model.EventModel} eventRecord The event record.
   * @private
   */


  remove(indexName, date, eventRecord) {
    const index = this[indexNameMap[indexName]],
          key = this.dayTime.dateKey(date),
          entry = index[key];

    if (entry) {
      entry.delete(eventRecord);
    }
  }
  /**
   * Removes an event record from all indexes for all dates which the event overlaps.
   * @param {Scheduler.model.EventModel} eventRecord The event record.
   * @param {Date} startDate The start date for the event. This may be different from the `startDate` of the given
   * `eventRecord` when the event is rescheduled.
   * @param {Date} endDate The end date for the event. This may be different from the `endDate` of the given
   * `eventRecord` when the event is rescheduled.
   * @private
   */


  removeEvent(eventRecord, startDate, endDate) {
    var _this$dayTime$startOf2;

    let dateMS = (_this$dayTime$startOf2 = this.dayTime.startOfDay(startDate)) === null || _this$dayTime$startOf2 === void 0 ? void 0 : _this$dayTime$startOf2.getTime(),
        endDateMS;

    if (dateMS) {
      var _endDate$getTime;

      endDateMS = (_endDate$getTime = endDate === null || endDate === void 0 ? void 0 : endDate.getTime()) !== null && _endDate$getTime !== void 0 ? _endDate$getTime : dateMS;
      this.remove('startDate', dateMS, eventRecord);

      do {
        this.remove('date', dateMS, eventRecord);
        dateMS += MILLIS_PER_DAY;
      } while (dateMS < endDateMS);
    }
  } // TODO: Improve Collection indices to handle this
  // Keeps date & startDate indices up to date, used by Calendar and recurrence
  // The indices are initialized lazily on first access, and then kept up to date on changes


  sync(action, added, removed, replaced, wasSet) {
    var _wasSet$startDate, _wasSet$endDate;

    added = added || emptyArray;
    removed = removed || emptyArray;
    const me = this,
          addedCount = added.length,
          removedCount = removed.length,
          replacedCount = replaced === null || replaced === void 0 ? void 0 : replaced.length;
    let i, newEvent, outgoingEvent;

    if (!me.initialized) {
      return;
    }

    switch (action) {
      case 'clear':
        me.clear();
        break;
      // Add and remove

      case 'splice':
        // Handle replacement of records by instances with same ID
        if (replacedCount) {
          added = added.slice();
          removed = removed.slice();

          for (i = 0; i < replacedCount; i++) {
            removed.push(replaced[i][0]);
            added.push(replaced[i][1]);
          }
        } // Remove entries from indices


        if (removedCount) {
          for (i = 0; i < removedCount; i++) {
            outgoingEvent = removed[i];
            me.removeEvent(outgoingEvent, outgoingEvent.startDate, outgoingEvent.endDate);
          }
        } // Add entries to indices


        if (addedCount) {
          for (i = 0; i < addedCount; i++) {
            newEvent = added[i]; // Can only be date-indexed if it's scheduled

            if (newEvent.isScheduled) {
              me.addEvent(newEvent);
            }
          }
        }

        break;
      // invoked when the start or end changes so that the event can be re-indexed.

      case 'reschedule':
        outgoingEvent = added[0];
        me.removeEvent(outgoingEvent, ((_wasSet$startDate = wasSet.startDate) === null || _wasSet$startDate === void 0 ? void 0 : _wasSet$startDate.oldValue) || outgoingEvent.startDate, ((_wasSet$endDate = wasSet.endDate) === null || _wasSet$endDate === void 0 ? void 0 : _wasSet$endDate.oldValue) || outgoingEvent.endDate); // Now process as as splice with an add and no removes.

        me.sync('splice', added);
        break;
    }
  }
  /**
   * This method registers a `dayTime` instance with this index in the `users` array.
   * @param {Core.util.DayTime} dayTime The instance to register.
   */


  register(dayTime) {
    this.users.push(dayTime);
  }
  /**
   * This method unregisters a `dayTime` instance, removing it from the `users` array. This method returns `true` if
   * this was the last registered instance and this index is no longer needed.
   * @param {Core.util.DayTime} dayTime The instance to register.
   * @returns {Boolean}
   */


  unregister(dayTime) {
    const {
      users
    } = this,
          i = users.indexOf(dayTime);

    if (i > -1) {
      users.splice(i, 1);
    }

    return !users.length;
  }

}
; // To avoid shape changes:

const proto = EventDayIndex.prototype;
indexProps.forEach(name => proto[name] = null);
proto.initialized = false;
EventDayIndex._$name = 'EventDayIndex';

/***/ }),

/***/ "./lib/Scheduler/data/util/ModelPersistencyManager.js":
/*!************************************************************!*\
  !*** ./lib/Scheduler/data/util/ModelPersistencyManager.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ModelPersistencyManager; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';

/**
 * @module Scheduler/data/util/ModelPersistencyManager
 */

/**
 * This class manages model persistency, it listens to model stores' beforesync event and removes all non persistable
 * records from sync operation. The logic has meaning only for CRUD-less sync operations.
 *
 * @private
 */

class ModelPersistencyManager extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  // region Event attachers
  set eventStore(newEventStore) {
    const me = this;
    me.eventStoreDetacher && me.eventStoreDetacher();
    me._eventStore = newEventStore;

    if (newEventStore && newEventStore.autoCommit) {
      me.eventStoreDetacher = newEventStore.on({
        beforecommit: me.onEventStoreBeforeSync,
        thisObj: me,
        detachable: true,
        // Just in case
        prio: 100
      });
    }
  }

  get eventStore() {
    return this._eventStore;
  }

  set resourceStore(newResourceStore) {
    const me = this;
    me.resourceStoreDetacher && me.resourceStoreDetacher();
    me._resourceStore = newResourceStore;

    if (newResourceStore && newResourceStore.autoCommit) {
      me.resourceStoreDetacher = newResourceStore.on({
        beforecommit: me.onResourceStoreBeforeSync,
        thisObj: me,
        detachable: true,
        // Just in case
        prio: 100
      });
    }
  }

  get resourceStore() {
    return this._resourceStore;
  }

  set assignmentStore(newAssignmentStore) {
    const me = this;
    me.assignmentStoreDetacher && me.assignmentStoreDetacher();
    me._assignmentStore = newAssignmentStore;

    if (newAssignmentStore && newAssignmentStore.autoSync) {
      me.assignmentStoreDetacher = newAssignmentStore.on({
        beforecommit: me.onAssignmentStoreBeforeSync,
        thisObj: me,
        detachable: true,
        // Just in case
        prio: 100
      });
    }
  }

  get assignmentStore() {
    return this._assignmentStore;
  }

  set dependencyStore(newDependencyStore) {
    const me = this;
    me.dependencyStoreDetacher && me.dependencyStoreDetacher();
    me._dependencyStore = newDependencyStore;

    if (newDependencyStore && newDependencyStore.autoSync) {
      me.dependencyStoreDetacher = newDependencyStore.on({
        beforecommit: me.onDependencyStoreBeforeSync,
        thisObj: me,
        detachable: true,
        // Just in case
        prio: 100
      });
    }
  }

  get dependencyStore() {
    return this._dependencyStore;
  } // endregion
  // region Event handlers


  onEventStoreBeforeSync({
    changes
  }) {
    const me = this;
    me.removeNonPersistableRecordsToCreate(changes);
    return me.shallContinueSync(changes);
  }

  onResourceStoreBeforeSync({
    changes
  }) {
    const me = this;
    me.removeNonPersistableRecordsToCreate(changes);
    return me.shallContinueSync(changes);
  }

  onAssignmentStoreBeforeSync({
    changes
  }) {
    const me = this;
    me.removeNonPersistableRecordsToCreate(changes);
    return me.shallContinueSync(changes);
  }

  onDependencyStoreBeforeSync({
    changes
  }) {
    const me = this;
    me.removeNonPersistableRecordsToCreate(changes);
    return me.shallContinueSync(changes);
  } // endregion
  // region Management rules


  removeNonPersistableRecordsToCreate(changes) {
    let recordsToCreate = changes.added || [],
        r,
        i; // We remove from the array we iterate thus we iterate from end to start

    for (i = recordsToCreate.length - 1; i >= 0; --i) {
      r = recordsToCreate[i];

      if (!r.isPersistable) {
        recordsToCreate.splice(recordsToCreate.indexOf(r), 1);
      }
    } // Prevent empty create request


    if (recordsToCreate.length === 0) {
      changes.added.length = 0;
    }
  }

  shallContinueSync(options) {
    return Boolean(options.added && options.added.length > 0 || options.modified && options.modified.length > 0 || options.removed && options.removed.length > 0);
  } // endregion


}
ModelPersistencyManager._$name = 'ModelPersistencyManager';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js":
/*!**************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AbstractRecurrenceIterator; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'taskboard';


/**
 * @module Scheduler/data/util/recurrence/AbstractRecurrenceIterator
 * @private
 */

const frequencyToUnitRe = /ly$/i,
      frequencyToUnit = frequency => {
  const result = frequency.replace(frequencyToUnitRe, '');
  return result === 'DAI' ? 'DAY' : result;
},
      fn = (date, counter, isFirst, timeSpan) => timeSpan.buildOccurrence(date, isFirst),
      captureLastOccurrence = date => lastOccurrenceDate = date;

let lastOccurrenceDate;
class AbstractRecurrenceIterator extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static processIterationConfig(config) {
    var _endDate;

    const {
      recurrence
    } = config,
          {
      frequency,
      interval,
      timeSpan,
      endDate: until,
      count
    } = recurrence; // Force the correction of the event to be in sync with its recurrence rule
    // before performing iteration. For example, if the event's configured startDate
    // is 1st January 2020, and the rule dictates that the event will take place
    // monthly, every Monday, then the first event is not until Monday 6th January, 2020.

    if (!config.syncingStartDate && !timeSpan.meta.isSyncedWithRule) {
      // Do not generate occurrences outside of the specified range
      const intervalEndDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(timeSpan.startDate, interval, frequencyToUnit(frequency)),
            endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].min(intervalEndDate, config.endDate || intervalEndDate);
      this.forEachDate({
        syncingStartDate: true,
        startDate: timeSpan.startDate,
        endDate,
        recurrence,
        fn
      });
    } // Capture the start after its been synced with its recurrence rule


    const timeSpanStart = timeSpan.startDate; // Extract the endDate from the config, defaulting to the recurrence UNTIL date

    let {
      startDate = timeSpanStart,
      endDate = until
    } = config; // No point in starting the iteration before the event starts

    if (startDate < timeSpanStart) {
      startDate = timeSpanStart;
    } // The recurrence's stop date overrides the configured endDate.


    if (until) {
      if (!endDate || endDate > until) {
        endDate = until;
      }
    } // If we are limiting using count and we are not starting from the
    // first occurrence, then we have to calculate a stop date.
    // This is because for date ranges in the future we cannot calculate how many
    // preceding occurrences there may have been.
    else if (count && startDate > timeSpanStart) {
      // Iterate the occurrences from the start to capture the last one
      this.forEachDate({
        recurrence,
        fn: captureLastOccurrence
      }); // The date of the last occurrence in the count sequence overrides the configured endDate.

      if (!endDate || endDate > lastOccurrenceDate) {
        endDate = lastOccurrenceDate;
      }
    } // Preserve the requested start of requested visits.


    const earliestVisibleDate = startDate; // Unless we are only asked for events which *start* within the time range. we must make
    // a best attempt to include any occurrences which span the start date.
    // So if we are asking for events from the 1st of the month, and there's an event
    // which runs every 2 months from the 15th to the 5th, we must include it. Start the
    // iteration <interval> full frequency quanta before the requested start.
    // This will only cause <interval> extra iterations.
    // We cannot step back to before the event's starting date though.

    if (!config.startOnly) {
      startDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].max(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(startDate, -interval, frequencyToUnit(frequency)), timeSpanStart));
    }

    return Object.assign({
      extraArgs: [],
      // Only check start date for time spans with 0 duration
      startOnly: !Boolean(timeSpan.durationMS)
    }, config, {
      startDate,
      endDate,
      timeSpan,
      timeSpanStart,
      earliestVisibleDate,
      endDateMS: (_endDate = endDate) === null || _endDate === void 0 ? void 0 : _endDate.getTime(),
      timeSpanStartMS: timeSpanStart.getTime(),
      earliestVisibleDateMS: earliestVisibleDate.getTime(),
      durationMS: timeSpan.durationMS,
      spansStart: startDate <= timeSpanStart && endDate > timeSpanStart
    });
  }

  static get frequency() {
    return 'NONE';
  }

  static get MAX_OCCURRENCES_COUNT() {
    return 1000000;
  }

  static getOccurrenceIndex(event) {
    if (event.isOccurrence) {
      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].diff(event.recurringTimeSpan.startDate, event.startDate, frequencyToUnit(event.recurringTimeSpan.recurrence.frequency));
    }
  }
  /**
   * Returns Nth occurrence of a week day in the provided period of time.
   * @param  {Date} startDate Period start date.
   * @param  {Date} endDate   Period end date.
   * @param  {Integer} day    Week day (0 - Sunday, 1 - Monday, 2 - Tuesday, etc.)
   * @param  {Integer} index  Index to find.
   * @return {Date}           Returns the found date or null if there is no `index`th entry.
   * @private
   */


  static getNthDayInPeriod(startDate, endDate, day, index) {
    let result, sign, borderDate;

    if (index) {
      if (index > 0) {
        sign = 1;
        borderDate = startDate;
      } else {
        sign = -1;
        borderDate = endDate;
      } // delta between requested day and border day


      const delta = day - borderDate.getDay(); // if the requested day goes after (before, depending on borderDate used (start/end))
      // we adjust index +/-1

      if (sign * delta < 0) {
        index += sign;
      } // measure "index" weeks forward (or backward) ..take delta into account
      // result = new Date(borderDate.getTime() + ((index - sign) * 7 + delta) * 24*60*60*1000);
      // Per https://github.com/bryntum/support/issues/3413 - don't do that ^^ because DST makes days/week
      // alternatingly shorter or longer depending on going in/out of DST:


      result = new Date(borderDate);
      result.setDate(borderDate.getDate() + (index - sign) * 7 + delta); // if resulting date is outside of the provided range there is no "index"-th entry
      // of the day

      if (result < startDate || result > endDate) {
        result = null;
      }
    }

    return result;
  }

  static buildDate(year, month, date) {
    const dt = new Date(year, month, date);

    if (dt.getFullYear() === year && dt.getMonth() === month && dt.getDate() === date) {
      return dt;
    }
  }

  static isValidPosition(position) {
    return Boolean(position);
  }

  static forEachDateAtPositions(dates, positions, fn, scope) {
    const datesLength = dates.length,
          processed = {};

    for (let i = 0; i < positions.length; i++) {
      const index = positions[i];

      if (this.isValidPosition(index)) {
        const date = index > 0 ? dates[index - 1] : dates[datesLength + index];

        if (date && !processed[date.getTime()]) {
          // remember that we've returned the date
          processed[date.getTime()] = true; // return false if it's time to stop recurring

          if (fn.call(scope, date) === false) {
            return false;
          }
        }
      }
    }
  }

  static isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan) {
    return (startOnly ? occurrenceDate >= earliestVisibleDate : occurrenceDate.valueOf() + durationMS > earliestVisibleDate) && !timeSpan.hasException(occurrenceDate);
  } // Slightly faster version of ^, used by Daily & Weekly iterators


  static isInViewMS(startOnly, occurenceDate, occurrenceDateMS, earliestVisibleDateMS, durationMS, timeSpan) {
    return (startOnly ? occurrenceDateMS >= earliestVisibleDateMS : occurrenceDateMS + durationMS > earliestVisibleDateMS) && !timeSpan.hasException(occurenceDate);
  }

}
AbstractRecurrenceIterator._$name = 'AbstractRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/DailyRecurrenceIterator.js":
/*!***********************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/DailyRecurrenceIterator.js ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DailyRecurrenceIterator; });
/* harmony import */ var _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
var productName = 'taskboard';
/**
* @module Scheduler/data/util/recurrence/DailyRecurrenceIterator
*/



/**
 * A class which provides iteration to call a function for dates specified by a
 * {@link Scheduler.model.RecurrenceModel RecurrenceModel} over a specified date range.
 * @private
 */

class DailyRecurrenceIterator extends _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get frequency() {
    return 'DAILY';
  }
  /**
   * Iterates over the passed date range, calling the passed callback on each date on which
   * starts a recurring event which matches the passed recurrence rule and overlaps the start and end dates
   * and is not an {@link Scheduler.model.mixin.RecurringTimeSpan#field-exceptionDates exceptionDate}
   * in the recurring event.
   * @param {Object} config An object which describes how to iterate.
   * @param {Date} config.startDate The point in time to begin iteration.
   * @param {Date} config.endDate The point in time to end iteration.
   * @param {Boolean} [config.startOnly] By default, all occurrences which intersect the date range
   * will be visited. Pass `true` to only visit occurrences which *start* in the date range.
   * @param {Scheduler.model.RecurrenceModel} config.recurrence The point in time to end iteration.
   * @param {Function} config.fn The function to call for each date which matches the recurrence in the date range.
   * @param {Date} config.fn.date The occurrence date.
   * @param {Number} config.fn.counter A counter of how many dates have been visited in this iteration.
   * @param {Boolean} config.fn.isFirst A flag which is `true` if the date is the first occurrence in the specified recurrence rule.
   * @param {Array} [config.extraArgs] Extra arguments to pass to the callback after the `isFirst` argument.
   */


  static forEachDate(config) {
    const {
      startOnly,
      startDate,
      endDate,
      endDateMS,
      timeSpan,
      timeSpanStart,
      earliestVisibleDateMS,
      durationMS,
      spansStart,
      recurrence,
      fn,
      extraArgs,
      scope = this
    } = this.processIterationConfig(config),
          {
      interval
    } = recurrence,
          delay = startDate - timeSpanStart,
          // recurrence interval duration in ms (86400000 is a single day duration in ms)
    intervalDuration = interval * 86400000,
          delayInIntervals = Math.floor(delay / intervalDuration);
    let {
      count
    } = recurrence,
        counter = 0,
        occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(timeSpanStart, delayInIntervals * interval, 'day'),
        occurenceDateMS = occurrenceDate.getTime();

    if (!endDate && !count) {
      count = this.MAX_OCCURRENCES_COUNT;
    }

    while (!endDateMS || occurenceDateMS <= endDateMS) {
      const inView = this.isInViewMS(startOnly, occurrenceDate, occurenceDateMS, earliestVisibleDateMS, durationMS, timeSpan);
      counter++;

      if (inView && (endDateMS && occurenceDateMS > endDateMS || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
        break;
      } // shift to the next day


      occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].add(occurrenceDate, interval, 'day');
      occurenceDateMS = occurrenceDate.getTime();
    }
  }

}
DailyRecurrenceIterator._$name = 'DailyRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/MonthlyRecurrenceIterator.js":
/*!*************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/MonthlyRecurrenceIterator.js ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MonthlyRecurrenceIterator; });
/* harmony import */ var _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
var productName = 'taskboard';
/**
* @module Scheduler/data/util/recurrence/MonthlyRecurrenceIterator
*/




/**
 * A class which provides iteration to call a function for dates specified by a
 * {@link Scheduler.model.RecurrenceModel RecurrenceModel} over a specified date range.
 * @private
 */

class MonthlyRecurrenceIterator extends _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get frequency() {
    return 'MONTHLY';
  }

  static getNthDayOfMonth(date, dayNum) {
    const daysInMonth = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].daysInMonth(date);
    let result = null;

    if (dayNum && Math.abs(dayNum) <= daysInMonth) {
      result = new Date(date.getFullYear(), date.getMonth(), dayNum < 0 ? daysInMonth + dayNum + 1 : dayNum);
    }

    return result;
  }

  static isValidPosition(position) {
    return position && Math.abs(position) > 0 && Math.abs(position) <= 31;
  }
  /**
   * Iterates over the passed date range, calling the passed callback on each date on which
   * starts an event which matches the passed recurrence rule and overlaps the start and end dates.
   * @param {Object} config An object which describes how to iterate.
   * @param {Date} config.startDate The point in time to begin iteration.
   * @param {Date} config.endDate The point in time to end iteration.
   * @param {Boolean} [config.startOnly] By default, all occurrences which intersect the date range
   * will be visited. Pass `true` to only visit occurrences which *start* in the date range.
   * @param {Scheduler.model.RecurrenceModel} config.recurrence The point in time to end iteration.
   * @param {Function} config.fn The function to call for each date which matches the recurrence in the date range.
   * @param {Date} config.fn.date The occurrence date.
   * @param {Number} config.fn.counter A counter of how many dates have been visited in this iteration.
   * @param {Boolean} config.fn.isFirst A flag which is `true` if the date is the first occurrence in the specified recurrence rule.
   * @param {Array} [config.extraArgs] Extra arguments to pass to the callback after the `isFirst` argument.
   */


  static forEachDate(config) {
    const {
      startOnly,
      startDate,
      endDate,
      timeSpan,
      timeSpanStart,
      earliestVisibleDate,
      durationMS,
      spansStart,
      recurrence,
      fn,
      extraArgs,
      scope = this
    } = this.processIterationConfig(config),
          {
      interval,
      days,
      count,
      positions
    } = recurrence,
          weekDays = _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__["default"].decode(days),
          hasPositions = positions && positions.length,
          processedDate = {};
    let {
      monthDays
    } = recurrence,
        counter = 0,
        weekDayPosition,
        monthStartDate,
        monthEndDate,
        dates,
        occurrenceDate,
        i; // if the recurrence is limited w/ "Count" or not every interval should match
    // we need to 1st count passed occurrences so we always start iteration from the event start date

    monthStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(count || interval > 1 ? timeSpanStart : startDate, 'month');
    monthEndDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(monthStartDate, 'month', 1) - 1); // If no month days nor week days are provided let's use event start date month day

    if (!(monthDays && monthDays.length) && !(weekDays && weekDays.length)) {
      monthDays = [timeSpanStart.getDate()];
    }

    if (weekDays && weekDays.length) {
      // Collect hash of positions indexed by week days
      weekDays.forEach(day => {
        if (day[1]) {
          weekDayPosition = weekDayPosition || {};
          weekDayPosition[day[0]] = day[1];
        }
      });
    }

    while ((!endDate || endDate >= monthStartDate) && (!count || counter < count)) {
      dates = [];

      if (weekDays && weekDays.length) {
        weekDays.forEach(day => {
          const weekDay = day[0];
          let from = 1,
              till = 53; // if position provided

          if (day[1]) {
            from = till = day[1];
          }

          for (i = from; i <= till; i++) {
            if (occurrenceDate = this.getNthDayInPeriod(monthStartDate, monthEndDate, weekDay, i)) {
              occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyTimeValues(occurrenceDate, timeSpanStart);

              if (!processedDate[occurrenceDate.getTime()]) {
                // remember we processed the date
                processedDate[occurrenceDate.getTime()] = true;
                dates.push(occurrenceDate);
              }
            }
          }
        });
        dates.sort((a, b) => a - b);

        if (!hasPositions) {
          for (i = 0; i < dates.length; i++) {
            occurrenceDate = dates[i];

            if (occurrenceDate >= timeSpanStart) {
              const inView = this.isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan);
              counter++;

              if (inView && (endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
                return false;
              }
            }
          }
        }
      } else {
        const sortedMonthDates = [];

        for (i = 0; i < monthDays.length; i++) {
          // check if the date wasn't iterated over yet
          if ((occurrenceDate = this.getNthDayOfMonth(monthStartDate, monthDays[i])) && !processedDate[occurrenceDate.getTime()]) {
            processedDate[occurrenceDate.getTime()] = true;
            sortedMonthDates.push(occurrenceDate);
          }
        } // it's important to sort the dates to iterate over them in the proper order


        sortedMonthDates.sort((a, b) => a - b);

        for (i = 0; i < sortedMonthDates.length; i++) {
          occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyTimeValues(sortedMonthDates[i], timeSpanStart);

          if (hasPositions) {
            dates.push(occurrenceDate);
          } else if (occurrenceDate >= timeSpanStart) {
            const inView = this.isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan);
            counter++;

            if (inView && ( // eslint-disable-next-line no-labels
            endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
              return;
            }
          }
        }
      }

      if (hasPositions && dates.length) {
        this.forEachDateAtPositions(dates, positions, occurrenceDate => {
          if (occurrenceDate >= timeSpanStart) {
            const inView = startOnly ? occurrenceDate >= earliestVisibleDate : occurrenceDate.valueOf() + durationMS > earliestVisibleDate && !timeSpan.hasException(occurrenceDate);
            counter++; // Ignore dates outside of the [startDate, endDate] range

            if (inView && (!endDate || occurrenceDate <= endDate) && ( // return false if it's time to stop recurring
            fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
              return false;
            }
          }
        });
      } // get next month start


      monthStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(monthStartDate, 'month', interval);
      monthEndDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(monthStartDate, 'month', 1) - 1);
    }
  }

}
MonthlyRecurrenceIterator._$name = 'MonthlyRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js":
/*!************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceDayRuleEncoder; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../Core/Base.js */ "./lib/Core/Base.js");
var productName = 'taskboard';

const dayParseRegExp = /^([+-]?[0-9])?(SU|MO|TU|WE|TH|FR|SA)$/;
const days = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
class RecurrenceDayRuleEncoder extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static decodeDay(rawDay) {
    let parsedDay, result;

    if (parsedDay = dayParseRegExp.exec(rawDay)) {
      result = [days.indexOf(parsedDay[2])]; // optional position number

      if (parsedDay[1]) {
        parsedDay[1] = parseInt(parsedDay[1], 10);
        result.push(parsedDay[1]);
      }
    }

    return result;
  }

  static encodeDay(day) {
    let position; // support decodeDay() result format

    if (Array.isArray(day)) {
      [day, position] = day;
    }

    return (position ? position.toString() : '') + days[day];
  } // Turns days values provided as an array of strings (like [`-1MO`, `SU`, `+3FR`])
  // into an array of [ dayIndex, position ] elements, where:
  //
  // - `dayIndex` - zero-based week day index value (0 - Sunday, 1 - Monday, 2 - Tuesday, etc.)
  // - `position` - (optional) 1-based position of the day (integer value (can be both positive and negative))


  static decode(rawDays) {
    let result = [],
        parsedDay;

    if (rawDays) {
      for (let i = 0; i < rawDays.length; i++) {
        if (parsedDay = this.decodeDay(rawDays[i])) {
          result.push(parsedDay);
        }
      }
    }

    return result;
  }

  static encode(days) {
    let result = [],
        day;

    if (days) {
      for (let i = 0; i < days.length; i++) {
        if (day = this.encodeDay(days[i])) {
          result.push(day);
        }
      }
    }

    return result;
  }

}
;
RecurrenceDayRuleEncoder._$name = 'RecurrenceDayRuleEncoder';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/WeeklyRecurrenceIterator.js":
/*!************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/WeeklyRecurrenceIterator.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WeeklyRecurrenceIterator; });
/* harmony import */ var _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
var productName = 'taskboard';
/**
* @module Scheduler/data/util/recurrence/WeeklyRecurrenceIterator
*/




/**
 * A class which provides iteration to call a function for dates specified by a
 * {@link Scheduler.model.RecurrenceModel RecurrenceModel} over a specified date range.
 * @private
 */

class WeeklyRecurrenceIterator extends _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get frequency() {
    return 'WEEKLY';
  }
  /**
   * Iterates over the passed date range, calling the passed callback on each date on which
   * starts an event which matches the passed recurrence rule and overlaps the start and end dates.
   * @param {Object} config An object which describes how to iterate.
   * @param {Date} config.startDate The point in time to begin iteration.
   * @param {Date} config.endDate The point in time to end iteration.
   * @param {Boolean} [config.startOnly] By default, all occurrences which intersect the date range
   * will be visited. Pass `true` to only visit occurrences which *start* in the date range.
   * @param {Scheduler.model.RecurrenceModel} config.recurrence The point in time to end iteration.
   * @param {Function} config.fn The function to call for each date which matches the recurrence in the date range.
   * @param {Date} config.fn.date The occurrence date.
   * @param {Number} config.fn.counter A counter of how many dates have been visited in this iteration.
   * @param {Boolean} config.fn.isFirst A flag which is `true` if the date is the first occurrence in the specified recurrence rule.
   * @param {Array} [config.extraArgs] Extra arguments to pass to the callback after the `isFirst` argument.
   */


  static forEachDate(config) {
    var _weekDays;

    const {
      startOnly,
      startDate,
      endDateMS,
      timeSpan,
      timeSpanStart,
      timeSpanStartMS,
      earliestVisibleDateMS,
      durationMS,
      spansStart,
      recurrence,
      fn,
      extraArgs,
      scope = this
    } = this.processIterationConfig(config),
          {
      interval,
      days
    } = recurrence,
          {
      weekStartDay
    } = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"],
          startHours = timeSpanStart.getHours(),
          startMinutes = timeSpanStart.getMinutes(),
          startSeconds = timeSpanStart.getSeconds(),
          startMS = timeSpanStart.getMilliseconds();
    let counter = 0,
        {
      count
    } = recurrence,
        weekDays = _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__["default"].decode(days),
        weekStartDate,
        occurrenceDate; // "Days" might be skipped then we use the event start day

    if (!((_weekDays = weekDays) !== null && _weekDays !== void 0 && _weekDays.length)) {
      weekDays = [[timeSpanStart.getDay()]];
    } // If week start day is not zero (Sunday)
    // we need to normalize weekDays array since its values are used
    // to calculate real dates as: date = week_start_date + weekDay_entry
    // which does not work when week starts on non-Sunday


    if (weekStartDay > 0) {
      for (let i = 0; i < weekDays.length; i++) {
        if (weekStartDay > weekDays[i][0]) {
          weekDays[i][0] = 7 - weekStartDay - weekDays[i][0];
        } else {
          weekDays[i][0] -= weekStartDay;
        }
      }
    } // days could be provided in any order so it's important to sort them


    weekDays.sort((a, b) => a[0] - b[0]); // if the recurrence is limited w/ "Count" or not every interval should match
    // we need to 1st count passed occurrences so we always start iteration from the event start date

    weekStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(count || interval > 1 ? timeSpanStart : startDate, 'week', 0);

    if (!endDateMS && !count) {
      count = this.MAX_OCCURRENCES_COUNT;
    }

    while (!endDateMS || weekStartDate.getTime() <= endDateMS) {
      for (let i = 0; i < weekDays.length; i++) {
        // Faster than chaining multiple DateHelper calls
        occurrenceDate = new Date(weekStartDate.getFullYear(), weekStartDate.getMonth(), weekStartDate.getDate() + weekDays[i][0], startHours, startMinutes, startSeconds, startMS);
        const occurrenceDateMS = occurrenceDate.getTime();

        if (occurrenceDateMS >= timeSpanStartMS) {
          const inView = this.isInViewMS(startOnly, occurrenceDate, occurrenceDateMS, earliestVisibleDateMS, durationMS, timeSpan);
          counter++;

          if (inView && (endDateMS && occurrenceDateMS > endDateMS || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
            return;
          }
        }
      } // get next week start


      weekStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(weekStartDate, 'week', interval);
    }
  }

}
WeeklyRecurrenceIterator._$name = 'WeeklyRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/data/util/recurrence/YearlyRecurrenceIterator.js":
/*!************************************************************************!*\
  !*** ./lib/Scheduler/data/util/recurrence/YearlyRecurrenceIterator.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return YearlyRecurrenceIterator; });
/* harmony import */ var _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
var productName = 'taskboard';
/**
* @module Scheduler/data/util/recurrence/YearlyRecurrenceIterator
*/




/**
 * A class which provides iteration to call a function for dates specified by a
 * {@link Scheduler.model.RecurrenceModel RecurrenceModel} over a specified date range.
 * @private
 */

class YearlyRecurrenceIterator extends _AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get frequency() {
    return 'YEARLY';
  }
  /**
   * Iterates over the passed date range, calling the passed callback on each date on which
   * starts an event which matches the passed recurrence rule and overlaps the start and end dates.
   * @param {Object} config An object which describes how to iterate.
   * @param {Date} config.startDate The point in time to begin iteration.
   * @param {Date} config.endDate The point in time to end iteration.
   * @param {Boolean} [config.startOnly] By default, all occurrences which intersect the date range
   * will be visited. Pass `true` to only visit occurrences which *start* in the date range.
   * @param {Scheduler.model.RecurrenceModel} config.recurrence The point in time to end iteration.
   * @param {Function} config.fn The function to call for each date which matches the recurrence in the date range.
   * @param {Date} config.fn.date The occurrence date.
   * @param {Number} config.fn.counter A counter of how many dates have been visited in this iteration.
   * @param {Boolean} config.fn.isFirst A flag which is `true` if the date is the first occurrence in the specified recurrence rule.
   * @param {Array} [config.extraArgs] Extra arguments to pass to the callback after the `isFirst` argument.
   */


  static forEachDate(config) {
    const {
      startOnly,
      startDate,
      endDate,
      timeSpan,
      timeSpanStart,
      earliestVisibleDate,
      durationMS,
      spansStart,
      recurrence,
      fn,
      extraArgs,
      scope = this
    } = this.processIterationConfig(config),
          {
      interval,
      days,
      count,
      positions
    } = recurrence,
          weekDays = _RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__["default"].decode(days),
          hasPositions = positions && positions.length,
          processedDate = {};
    let {
      months
    } = recurrence,
        counter = 0,
        i,
        occurrenceDate,
        dates,
        yearStartDate,
        yearEndDate,
        weekDayPosition; // if the recurrence is limited w/ "Count" or not every interval should match
    // we need to 1st count passed occurrences so we always start iteration from the event start date

    yearStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].startOf(count || interval > 1 ? timeSpanStart : startDate, 'year');
    yearEndDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(yearStartDate, 'year', 1) - 1);
    months && months.sort((a, b) => a - b); // if no months provided let's use the event month

    if (!(months && months.length) && !(weekDays && weekDays.length)) {
      months = [timeSpanStart.getMonth() + 1];
    }

    if (weekDays && weekDays.length) {
      // Collect hash of positions indexed by week days
      weekDays.forEach(day => {
        if (day[1]) {
          weekDayPosition = weekDayPosition || {};
          weekDayPosition[day[0]] = day[1];
        }
      });
    }

    while ((!endDate || endDate >= yearStartDate) && (!count || counter < count)) {
      dates = [];

      if (weekDays && weekDays.length) {
        weekDays.forEach(day => {
          const weekDay = day[0];
          let from = 1,
              till = 53; // if position provided

          if (day[1]) {
            from = till = day[1];
          }

          for (i = from; i <= till; i++) {
            if (occurrenceDate = this.getNthDayInPeriod(yearStartDate, yearEndDate, weekDay, i)) {
              occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyTimeValues(occurrenceDate, timeSpanStart);

              if (!processedDate[occurrenceDate.getTime()]) {
                // remember we processed the date
                processedDate[occurrenceDate.getTime()] = true;
                dates.push(occurrenceDate);
              }
            }
          }
        });
        dates.sort((a, b) => a - b);

        if (!hasPositions) {
          for (i = 0; i < dates.length; i++) {
            occurrenceDate = dates[i];

            if (occurrenceDate >= timeSpanStart) {
              const inView = this.isInView(startOnly, occurrenceDate, earliestVisibleDate, durationMS, timeSpan);
              counter++;

              if (inView && (endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
                return;
              }
            }
          }
        }
      } else {
        for (i = 0; i < months.length; i++) {
          if (occurrenceDate = this.buildDate(yearStartDate.getFullYear(), months[i] - 1, timeSpanStart.getDate())) {
            occurrenceDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].copyTimeValues(occurrenceDate, timeSpanStart); // check if the date wasn't iterated over yet

            if (!processedDate[occurrenceDate.getTime()]) {
              processedDate[occurrenceDate.getTime()] = true;

              if (hasPositions) {
                dates.push(occurrenceDate);
              } else if (occurrenceDate >= timeSpanStart) {
                const inView = startOnly ? occurrenceDate >= earliestVisibleDate : occurrenceDate.valueOf() + durationMS > earliestVisibleDate && !timeSpan.hasException(occurrenceDate);
                counter++;

                if (inView && (endDate && occurrenceDate > endDate || fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count)) {
                  return;
                }
              }
            }
          }
        }
      }

      if (hasPositions && dates.length) {
        this.forEachDateAtPositions(dates, positions, occurrenceDate => {
          if (occurrenceDate >= timeSpanStart) {
            const inView = startOnly ? occurrenceDate >= earliestVisibleDate : occurrenceDate.valueOf() + durationMS > earliestVisibleDate && !timeSpan.hasException(occurrenceDate);
            counter++; // Ignore dates outside of the [startDate, endDate] range

            if (inView && (!endDate || occurrenceDate <= endDate)) {
              // return false if it's time to stop recurring
              if (fn.apply(scope, [occurrenceDate, counter, counter === 1 && spansStart, timeSpan, ...extraArgs]) === false || count && counter >= count) {
                return false;
              }
            }
          }
        });
      } // get next month start


      yearStartDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(yearStartDate, 'year', interval);
      yearEndDate = new Date(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getNext(yearStartDate, 'year', 1) - 1);
    }
  }

}
YearlyRecurrenceIterator._$name = 'YearlyRecurrenceIterator';

/***/ }),

/***/ "./lib/Scheduler/model/AssignmentModel.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/model/AssignmentModel.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AssignmentModel; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _mixin_AssignmentModelMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/AssignmentModelMixin.js */ "./lib/Scheduler/model/mixin/AssignmentModelMixin.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/CoreAssignmentMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreAssignmentMixin.js");
var productName = 'taskboard';




const EngineMixin = _Engine_quark_model_scheduler_core_CoreAssignmentMixin_js__WEBPACK_IMPORTED_MODULE_3__["CoreAssignmentMixin"];
/**
 * @module Scheduler/model/AssignmentModel
 */

/**
 * This model represent a single assignment of a resource to an event in scheduler, usually added to a
 * {@link Scheduler.data.AssignmentStore}.
 *
 * It is a subclass of {@link Core.data.Model} class. Please refer to the documentation for that class to become
 * familiar with the base interface of this class.
 *
 * ## Fields and references
 *
 * An Assignment has the following fields:
 * - `id` - The id of the assignment
 * - `resourceId` - The id of the resource assigned (optionally replaced with `resource` for load)
 * - `eventId` - The id of the event to which the resource is assigned (optionally replaced with `event` for load)
 *
 * The data source for these fields can be customized by subclassing this class:
 *
 * ```javascript
 * class MyAssignment extends AssignmentModel {
 *   static get fields() {
 *       return [
 *          { name : 'resourceId', dataSource : 'linkedResource' }
 *       ];
 *   }
 * }
 * ```
 *
 * After load and project normalization, these references are accessible (assuming their respective stores are loaded):
 * - `event` - The linked event record
 * - `resource` - The linked resource record
 *
 * ## Async resolving of references
 *
 * As described above, an assignment links an event to a resource. It holds references to an event record and a resource
 * record. These references are populated async, using the calculation engine of the project that the assignment via
 * its store is a part of. Because of this asyncness, references cannot be used immediately after modifications:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * // assignment.resource is not yet available
 * ```
 *
 * To make sure references are updated, wait for calculations to finish:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * await assignment.project.commitAsync();
 * // assignment.resource is available
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await assignment.setAsync({ resourceId : 2});
 * // assignment.resource is available
 * ```
 *
 * @extends Core/data/Model
 * @mixes Scheduler/model/mixin/AssignmentModelMixin
 * @uninherit Core/data/mixin/TreeNode
 */

class AssignmentModel extends Object(_mixin_AssignmentModelMixin_js__WEBPACK_IMPORTED_MODULE_2__["default"])(Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(EngineMixin.derive(_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"]))) {
  // NOTE: Leave field defs at top to be picked up by jsdoc

  /**
   * Id for event to assign. Can be used as an alternative to `eventId`, but please note that after
   * load it will be populated with the actual event and not its id. This field is not persistable.
   * @field {Scheduler.model.EventModel} event
   * @accepts {String|Number|Scheduler.model.EventModel}
   * @category Common
   */

  /**
   * Id for resource to assign to. Can be used as an alternative to `resourceId`, but please note that after
   * load it will be populated with the actual resource and not its id. This field is not persistable.
   * @field {Scheduler.model.ResourceModel} resource
   * @accepts {String|Number|Scheduler.model.ResourceModel}
   * @category Common
   */
  static get $name() {
    return 'AssignmentModel';
  }

}
AssignmentModel.exposeProperties();
AssignmentModel._$name = 'AssignmentModel';

/***/ }),

/***/ "./lib/Scheduler/model/DependencyBaseModel.js":
/*!****************************************************!*\
  !*** ./lib/Scheduler/model/DependencyBaseModel.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyBaseModel; });
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/data/Duration.js */ "./lib/Core/data/Duration.js");
var productName = 'taskboard';




/**
 * @module Scheduler/model/DependencyBaseModel
 */

const canonicalDependencyTypes = ['SS', 'SF', 'FS', 'FF'];
/**
 * Base class used for both Scheduler and Gantt. Not intended to be used directly
 *
 * @extends Core/data/Model
 */

class DependencyBaseModel extends _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
  static get $name() {
    return 'DependencyBaseModel';
  }
  /**
   * Set value for the specified field(s), triggering engine calculations immediately. See
   * {@link Core.data.Model#function-set Model#set()} for arguments.
   **
   * ```javascript
   * dependency.set('from', 2);
   * // dependency.fromEvent is not yet up to date
   *
   * await dependency.setAsync('from', 2);
   * // dependency.fromEvent is up to date
   * ```
   *
   * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
   * @param {*} value Value to set
   * @param {Boolean} [silent=false] Set to true to not trigger events
   * automatically.
   * @function setAsync
   * @category Editing
   * @async
   */
  //region Fields

  /**
   * An enumerable object, containing names for the dependency types integer constants.
   * - 0 StartToStart
   * - 1 StartToEnd
   * - 2 EndToStart
   * - 3 EndToEnd
   * @property {Object}
   * @readonly
   * @category Dependency
   */


  static get Type() {
    return {
      StartToStart: 0,
      StartToEnd: 1,
      EndToStart: 2,
      EndToEnd: 3
    };
  }

  static get fields() {
    return [// 3 mandatory fields

    /**
     * From event, id of source event
     * @field {String|Number} from
     * @category Dependency
     */
    {
      name: 'from'
    },
    /**
     * To event, id of target event
     * @field {String|Number} to
     * @category Dependency
     */
    {
      name: 'to'
    },
    /**
     * Dependency type, see static property {@link #property-Type-static}
     * @field {Number} type=2
     * @category Dependency
     */
    {
      name: 'type',
      type: 'int',
      defaultValue: 2
    },
    /**
     * CSS class to apply to lines drawn for the dependency
     * @field {String} cls
     * @category Styling
     */
    {
      name: 'cls',
      defaultValue: ''
    },
    /**
     * Bidirectional, drawn with arrows in both directions
     * @field {Boolean} bidirectional
     * @category Dependency
     */
    {
      name: 'bidirectional',
      type: 'boolean'
    },
    /**
     * Start side on source (top, left, bottom, right)
     * @field {String} fromSide
     * @category Dependency
     */
    {
      name: 'fromSide',
      type: 'string'
    },
    /**
     * End side on target (top, left, bottom, right)
     * @field {String} toSide
     * @category Dependency
     */
    {
      name: 'toSide',
      type: 'string'
    },
    /**
     * The magnitude of this dependency's lag (the number of units).
     * @field {Number} lag
     * @category Dependency
     */
    {
      name: 'lag',
      type: 'number',
      allowNull: true,
      defaultValue: 0
    },
    /**
     * The units of this dependency's lag, defaults to "d" (days). Valid values are:
     *
     * - "ms" (milliseconds)
     * - "s" (seconds)
     * - "m" (minutes)
     * - "h" (hours)
     * - "d" (days)
     * - "w" (weeks)
     * - "M" (months)
     * - "y" (years)
     *
     * This field is readonly after creation, to change `lagUnit` use {@link #function-setLag setLag()}.
     * @field {String} lagUnit
     * @category Dependency
     * @readonly
     */
    {
      name: 'lagUnit',
      type: 'string',
      defaultValue: 'd'
    }];
  } // fromEvent/toEvent defined in CoreDependencyMixin in engine

  /**
   * Gets/sets the source event of the dependency.
   *
   * Accepts multiple formats but always returns an {@link Scheduler.model.EventModel}.
   *
   * **NOTE:** This is not a proper field but rather an alias, it will be serialized but cannot be remapped. If you
   * need to remap, consider using {@link #field-from} instead.
   *
   * @field {Scheduler.model.EventModel} fromEvent
   * @accepts {String|Number|Scheduler.model.EventModel}
   * @category Dependency
   */

  /**
   * Gets/sets the target event of the dependency.
   *
   * Accepts multiple formats but always returns an {@link Scheduler.model.EventModel}.
   *
   * **NOTE:** This is not a proper field but rather an alias, it will be serialized but cannot be remapped. If you
   * need to remap, consider using {@link #field-to} instead.
   *
   * @field {Scheduler.model.EventModel} toEvent
   * @accepts {String|Number|Scheduler.model.EventModel}
   * @category Dependency
   */

  /**
   * Gets/sets the source event of the dependency
   *
   * @property {Scheduler.model.EventModel}
   * @deprecated 4.0.0 Deprecated in favor of fromEvent
   * @category Dependency
   */


  get sourceEvent() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].deprecate('scheduler', '5.0.0', 'Deprecated in favor of fromEvent');
    return this.fromEvent;
  }

  set sourceEvent(event) {
    this.fromEvent = event;
  }
  /**
   * Gets/sets the target event of the dependency
   *
   * @property {Scheduler.model.EventModel}
   * @deprecated 4.0.0 Deprecated in favor of toEvent
   * @category Dependency
   */


  get targetEvent() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].deprecate('scheduler', '5.0.0', 'Deprecated in favor of toEvent');
    return this.toEvent;
  }

  set targetEvent(event) {
    this.targetEvent = event;
  } //endregion
  //region Init


  construct(data) {
    const from = data[this.fieldMap.from.dataSource],
          to = data[this.fieldMap.to.dataSource]; // Engine expects fromEvent and toEvent, not from and to. We need to support both

    if (from != null) {
      data.fromEvent = from;
    }

    if (to != null) {
      data.toEvent = to;
    }

    super.construct(...arguments);
  } //endregion


  get eventStore() {
    var _this$unjoinedStores$;

    return this.eventStore || ((_this$unjoinedStores$ = this.unjoinedStores[0]) === null || _this$unjoinedStores$ === void 0 ? void 0 : _this$unjoinedStores$.eventStore);
  }

  set from(value) {
    const {
      fromEvent
    } = this; // When assigning a new id to an event, it will update the eventId of the assignment. But the assignments
    // event is still the same so we need to announce here

    if (fromEvent !== null && fromEvent !== void 0 && fromEvent.isModel && fromEvent.id === value) {
      this.set('from', value);
    } else {
      this.fromEvent = value;
    }
  }

  get from() {
    return this.get('from');
  }

  set to(value) {
    const {
      toEvent
    } = this; // When assigning a new id to an event, it will update the eventId of the assignment. But the assignments
    // event is still the same so we need to announce here

    if (toEvent !== null && toEvent !== void 0 && toEvent.isModel && toEvent.id === value) {
      this.set('to', value);
    } else {
      this.toEvent = value;
    }
  }

  get to() {
    return this.get('to');
  }
  /**
   * Alias to dependency type, but when set resets {@link #field-fromSide} & {@link #field-toSide} to null as well.
   *
   * @property {Number}
   * @category Dependency
   */


  get hardType() {
    return this.getHardType();
  }

  set hardType(type) {
    this.setHardType(type);
  }
  /**
   * Returns dependency hard type, see {@link #property-hardType}.
   *
   * @return {Number}
   * @category Dependency
   */


  getHardType() {
    return this.get('type');
  }
  /**
   * Sets dependency {@link #field-type} and resets {@link #field-fromSide} and {@link #field-toSide} to null.
   *
   * @param {Number} type
   * @category Dependency
   */


  setHardType(type) {
    let result;

    if (type !== this.hardType) {
      result = this.set({
        type,
        fromSide: null,
        toSide: null
      });
    }

    return result;
  }

  get lag() {
    return this.get('lag');
  }

  set lag(lag) {
    if (typeof lag === 'number') {
      this.set({
        lag
      });
    } else {
      this.setLag(lag);
    }
  }
  /**
   * Sets lag and lagUnit in one go. Only allowed way to change lagUnit, the lagUnit field is readonly after creation
   * @param {Number|String|Object} lag The lag value. May be just a numeric magnitude, or a full string descriptor eg '1d'
   * @param {String} [lagUnit] Unit for numeric lag value, see {@link #field-lagUnit} for valid values
   * @category Dependency
   */


  setLag(lag, lagUnit) {
    // Either they're only setting the magnitude
    // or, if it's a string, parse the full duration.
    if (arguments.length === 1) {
      if (typeof lag === 'number') {
        this.lag = lag;
      } else {
        lag = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].parseDuration(lag);
        this.set({
          lag: lag.magnitude,
          lagUnit: lag.unit
        });
      }

      return;
    } // Must be a number


    lag = parseFloat(lag);
    this.set({
      lag,
      lagUnit
    });
  }

  getLag() {
    if (this.lag) {
      return `${this.lag < 0 ? '-' : '+'}${Math.abs(this.lag)}${_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getShortNameOfUnit(this.lagUnit)}`;
    }

    return '';
  }
  /**
   * Property which encapsulates the lag's magnitude and units. An object which contains two properties:
   * @property {Core.data.Duration}
   * @property {Number} fullLag.magnitude The magnitude of the duration
   * @property {String} fullLag.unit The unit in which the duration is measured, eg `'d'` for days
   * @category Dependency
   */


  get fullLag() {
    return new _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
      unit: this.lagUnit,
      magnitude: this.lag
    });
  }

  set fullLag(lag) {
    if (typeof lag === 'string') {
      this.setLag(lag);
    } else {
      this.setLag(lag.magnitude, lag.unit);
    }
  }
  /**
   * Returns true if the linked events have been persisted (e.g. neither of them are 'phantoms')
   *
   * @property {Boolean}
   * @readonly
   * @category Editing
   */


  get isPersistable() {
    const me = this,
          {
      stores,
      unjoinedStores
    } = me,
          store = stores[0];
    let result;

    if (store) {
      const {
        fromEvent,
        toEvent
      } = me,
            crudManager = store.crudManager; // if crud manager is used it can deal with phantom source/target since it persists all records in one batch
      // if no crud manager used we have to wait till source/target are persisted

      result = fromEvent && (crudManager || !fromEvent.hasGeneratedId) && toEvent && (crudManager || !toEvent.hasGeneratedId);
    } else {
      result = Boolean(unjoinedStores[0]);
    }

    return result && super.isPersistable;
  }
  /**
   * Returns the source event of the dependency
   *
   * @return {Scheduler.model.EventModel} The source event of this dependency
   * @category Dependency
   * @deprecated 5.0 Deprecated in favor of `toEvent`
   */


  getSourceEvent() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].deprecate('scheduler', '5.0.0', 'Deprecated in favor of fromEvent');
    return this.fromEvent;
  }
  /**
   * Returns the target event of the dependency
   *
   * @return {Scheduler.model.EventModel} The target event of this dependency
   * @category Dependency
   * @deprecated 5.0 Deprecated in favor of `toEvent`
   */


  getTargetEvent() {
    _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].deprecate('scheduler', '5.0.0', 'Deprecated in favor of toEvent');
    return this.toEvent;
  }

  getDateRange() {
    const {
      fromEvent,
      toEvent
    } = this;

    if (fromEvent !== null && fromEvent !== void 0 && fromEvent.isScheduled && toEvent !== null && toEvent !== void 0 && toEvent.isScheduled) {
      const Type = DependencyBaseModel.Type;
      let sourceDate, targetDate;

      switch (this.type) {
        case Type.StartToStart:
          sourceDate = fromEvent.startDateMS;
          targetDate = toEvent.startDateMS;
          break;

        case Type.StartToEnd:
          sourceDate = fromEvent.startDateMS;
          targetDate = toEvent.endDateMS;
          break;

        case Type.EndToEnd:
          sourceDate = fromEvent.endDateMS;
          targetDate = toEvent.endDateMS;
          break;

        case Type.EndToStart:
          sourceDate = fromEvent.endDateMS;
          targetDate = toEvent.startDateMS;
          break;

        default:
          throw new Error('Invalid dependency type: ' + this.type);
      }

      return {
        start: Math.min(sourceDate, targetDate),
        end: Math.max(sourceDate, targetDate)
      };
    }

    return null;
  }
  /**
   * Applies given CSS class to dependency, the value doesn't persist
   *
   * @param {String} cls
   * @category Dependency
   */


  highlight(cls) {
    const h = this.highlighted ? this.highlighted.split(' ') : [];
    if (!h.includes(cls)) this.highlighted = h.concat(cls).join(' ');
  }
  /**
   * Removes given CSS class from dependency if applied, the value doesn't persist
   *
   * @param {String} cls
   * @category Dependency
   */


  unhighlight(cls) {
    const {
      highlighted
    } = this;

    if (highlighted) {
      const h = highlighted.split(' '),
            idx = h.findIndex(i => i === cls);

      if (idx >= 0) {
        h.splice(idx, 1);
        this.highlighted = h.join(' ');
      }
    }
  }
  /**
   * Checks if the given CSS class is applied to dependency.
   *
   * @param {String} cls
   * @return {Boolean}
   * @category Dependency
   */


  isHighlightedWith(cls) {
    return this.highlighted && this.highlighted.split(' ').includes(cls);
  }

  getConnectorString(raw) {
    const rawValue = canonicalDependencyTypes[this.type];

    if (raw) {
      return rawValue;
    } // FS => empty string; it's the default


    if (this.type === DependencyBaseModel.Type.EndToStart) {
      return '';
    }

    return rawValue;
  } // getConnectorStringFromType(type, raw) {
  //     const rawValue = canonicalDependencyTypes[type];
  //
  //     if (raw) {
  //         return rawValue;
  //     }
  //
  //     // FS => empty string; it's the default
  //     if (type === DependencyBaseModel.Type.EndToStart) {
  //         return '';
  //     }
  //
  //     const locale = LocaleManager.locale;
  //
  //     // See if there is a local version of SS, SF or FF
  //     if (locale) {
  //         const localized = locale.Scheduler && locale.Scheduler[rawValue];
  //         if (localized) {
  //             return localized;
  //         }
  //     }
  //
  //     return rawValue;
  // }
  // getConnectorString(raw) {
  //     return this.getConnectorStringFromType(this.type);
  // }
  // * getConnectorStringGenerator(raw) {
  //     return this.getConnectorStringFromType(yield this.$.type);
  // }


  toString() {
    return `${this.from}${this.getConnectorString()}${this.getLag()}`;
  }
  /**
   * Returns `true` if the dependency is valid. Has valid type and both source and target ids set and not links to itself.
   *
   * @property {Boolean}
   * @typings ignore
   * @category Editing
   */


  get isValid() {
    const {
      from,
      to,
      type
    } = this;
    return typeof type === 'number' && from && from !== '' && to != null && to !== '' && from !== to;
  }

  get fromEventName() {
    var _this$fromEvent;

    return ((_this$fromEvent = this.fromEvent) === null || _this$fromEvent === void 0 ? void 0 : _this$fromEvent.name) || '';
  }

  get toEventName() {
    var _this$toEvent;

    return ((_this$toEvent = this.toEvent) === null || _this$toEvent === void 0 ? void 0 : _this$toEvent.name) || '';
  }

}
DependencyBaseModel.exposeProperties();
DependencyBaseModel._$name = 'DependencyBaseModel';

/***/ }),

/***/ "./lib/Scheduler/model/DependencyModel.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/model/DependencyModel.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DependencyModel; });
/* harmony import */ var _DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DependencyBaseModel.js */ "./lib/Scheduler/model/DependencyBaseModel.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/CoreDependencyMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreDependencyMixin.js");
var productName = 'taskboard';



const EngineMixin = _Engine_quark_model_scheduler_core_CoreDependencyMixin_js__WEBPACK_IMPORTED_MODULE_2__["CoreDependencyMixin"];
/**
 * @module Scheduler/model/DependencyModel
 */

/**
 * This model represents a dependency between two events, usually added to a {@link Scheduler.data.DependencyStore}.
 *
 * It is a subclass of the {@link Scheduler.model.DependencyBaseModel} class, which in its turn subclasses
 * {@link Core.data.Model}. Please refer to documentation of those classes to become familiar with the base interface of
 * this class.
 *
 * ## Fields and references
 *
 * A Dependency has a few predefined fields, see Fields below.  The name of any fields data source can be customized in
 * the subclass, see the example below. Please also refer to {@link Core.data.Model} for details.
 *
 * ```javascript
 * class MyDependency extends DependencyModel {
 *   static get fields() {
 *     return [
 *       { name: 'to', dataSource: 'targetId' },
 *       { name: 'from', dataSource: 'sourceId' }
 *     ]);
 *   }
 * }
 * ```
 *
 * After load and project normalization, these references are accessible (assuming their respective stores are loaded):
 * - `fromEvent` - The event on the start side of the dependency
 * - `toEvent` - The event on the end side of the dependency
 *
 * ## Async resolving of references
 *
 * As described above, a dependency has links to events. These references are populated async, using the calculation
 * engine of the project that the resource via its store is a part of. Because of this asyncness, references cannot be
 * used immediately after modifications:
 *
 * ```javascript
 * dependency.from = 2;
 * // dependency.fromEvent is not yet up to date
 * ```
 *
 * To make sure references are updated, wait for calculations to finish:
 *
 * ```javascript
 * dependency.from = 2;
 * await dependency.project.commitAsync();
 * // dependency.fromEvent is up to date
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await dependency.setAsync({ from : 2});
 * // dependency.fromEvent is up to date
 * ```
 *
 * @extends Scheduler/model/DependencyBaseModel
 * @uninherit Core/data/mixin/TreeNode
 */

class DependencyModel extends Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(EngineMixin.derive(_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_0__["default"])) {
  static get $name() {
    return 'DependencyModel';
  } // Determines the type of dependency based on fromSide and toSide


  getTypeFromSides(fromSide, toSide, rtl) {
    const types = _DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_0__["default"].Type,
          startSide = rtl ? 'right' : 'left',
          endSide = rtl ? 'left' : 'right';

    if (fromSide === startSide) {
      return toSide === startSide ? types.StartToStart : types.StartToEnd;
    }

    return toSide === endSide ? types.EndToEnd : types.EndToStart;
  }

}
DependencyModel.exposeProperties();
DependencyModel._$name = 'DependencyModel';

/***/ }),

/***/ "./lib/Scheduler/model/EventModel.js":
/*!*******************************************!*\
  !*** ./lib/Scheduler/model/EventModel.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EventModel; });
/* harmony import */ var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/RecurringTimeSpan.js */ "./lib/Scheduler/model/mixin/RecurringTimeSpan.js");
/* harmony import */ var _mixin_EventModelMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/EventModelMixin.js */ "./lib/Scheduler/model/mixin/EventModelMixin.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/SchedulerCoreEvent.js */ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreEvent.js");
var productName = 'taskboard';





const EngineMixin = _Engine_quark_model_scheduler_core_SchedulerCoreEvent_js__WEBPACK_IMPORTED_MODULE_4__["SchedulerCoreEvent"];
/**
 * @module Scheduler/model/EventModel
 */

/**
 * This class represent a single event in your schedule, usually added to a {@link Scheduler.data.EventStore}.
 *
 * It is a subclass of the {@link Scheduler.model.TimeSpan}, which is in turn subclass of {@link Core.data.Model}.
 * Please refer to documentation of that class to become familiar with the base interface of the event.
 *
 * ## Async date calculations
 *
 * A record created from an {@link Scheduler/model/EventModel} is normally part of an {@link Scheduler.data.EventStore},
 * which in turn is part of a project. When dates or the duration of an event is changed, the project performs async calculations
 * to normalize the other fields.
 * For example if {@link #field-duration} is changed, it will calculate {@link #field-endDate}.
 *
 * As a result of this being an async operation, the values of other fields are not guaranteed to be up to date
 * immediately after a change. To ensure data is up to date, await the calculations to finish.
 *
 * For example, {@link #field-endDate} is not up to date after this operation:
 *
 * ```javascript
 * eventRecord.duration = 5;
 * // endDate not yet calculated
 * ```
 *
 * But if calculations are awaited it is up to date:
 *
 * ```javascript
 * eventRecord.duration = 5;
 * await eventRecord.project.commitAsync();
 * // endDate is calculated
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await eventRecord.setAsync({ duration : 5});
 * // endDate is calculated
 * ```
 *
 * ## Subclassing the Event model class
 * The Event model has a few predefined fields as seen below. If you want to add new fields or change the options for the existing fields,
 * you can do that by subclassing this class (see example below).
 *
 * ```
 * class MyEvent extends EventModel {
 *
 *     static get fields() {
 *         return [
 *            // Add new field
 *            { name: 'myField', type : 'number', defaultValue : 0 }
 *         ];
 *     },
 *
 *     myCheckMethod() {
 *         return this.myField > 0
 *     },
 *
 *     ...
 * });
 * ```
 * If you in your data want to use other names for the {@link #field-startDate}, {@link #field-endDate}, {@link #field-resourceId} and name fields you can configure
 * them as seen below:
 * ```
 * class MyEvent extends EventModel {
 *
 *     static get fields() {
 *         return [
 *            { name: 'startDate', dataSource : 'taskStart' },
 *            { name: 'endDate', dataSource : 'taskEnd', format: 'YYYY-MM-DD' },
 *            { name: 'resourceId', dataSource : 'userId' },
 *            { name: 'name', dataSource : 'taskTitle' },
 *         ];
 *     },
 *     ...
 * });
 * ```
 *
 * Please refer to {@link Core.data.Model} for additional details.
 *
 * @extends Scheduler/model/TimeSpan
 * @mixes Scheduler/model/mixin/RecurringTimeSpan
 * @mixes Scheduler/model/mixin/EventModelMixin
 */

class EventModel extends EngineMixin.derive(_TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__["default"]).mixin(_mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_1__["default"], _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_3__["default"], _mixin_EventModelMixin_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  static get $name() {
    return 'EventModel';
  }

}
EventModel.exposeProperties();
EventModel._$name = 'EventModel';

/***/ }),

/***/ "./lib/Scheduler/model/ProjectModel.js":
/*!*********************************************!*\
  !*** ./lib/Scheduler/model/ProjectModel.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProjectModel; });
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _mixin_ProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/ProjectModelMixin.js */ "./lib/Scheduler/model/mixin/ProjectModelMixin.js");
/* harmony import */ var _data_util_ModelPersistencyManager_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/util/ModelPersistencyManager.js */ "./lib/Scheduler/data/util/ModelPersistencyManager.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_SchedulerCoreProjectMixin_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/SchedulerCoreProjectMixin.js */ "./lib/Engine/quark/model/scheduler_core/SchedulerCoreProjectMixin.js");
var productName = 'taskboard';





const EngineMixin = _Engine_quark_model_scheduler_core_SchedulerCoreProjectMixin_js__WEBPACK_IMPORTED_MODULE_4__["SchedulerCoreProjectMixin"];
/**
 * @module Scheduler/model/ProjectModel
 */

/**
 * This class represents a global project of your Scheduler - a central place for all data.
 *
 * It holds and links the stores usually used by Scheduler:
 *
 * - {@link Scheduler.data.EventStore}
 * - {@link Scheduler.data.ResourceStore}
 * - {@link Scheduler.data.AssignmentStore}
 * - {@link Scheduler.data.DependencyStore}
 * - {@link #config-timeRangeStore TimeRangeStore}
 * - {@link Scheduler.data.ResourceTimeRangeStore}
 *
 * The project uses a calculation engine to normalize dates and durations. It is also responsible for
 * handling references between models, for example to link an event via an assignment to a resource. These operations
 * are asynchronous, a fact that is hidden when working in the Scheduler UI but which you must know about when performing
 * more advanced operations on the data level.
 *
 * When there is a change to data that requires something else to be recalculated, the project schedules a calculation (a
 * commit) which happens moments later. It is also possible to trigger these calculations directly. This snippet illustrate
 * the process:
 *
 1. Something changes which requires the project to recalculate, for example adding a new task:
 *
 * ```javascript
 * const [event] = project.eventStore.add({ startDate, endDate });
 * ```
 *
 * 2. A recalculation is scheduled, thus:
 *
 * ```javascript
 * event.duration; // <- Not yet calculated
 * ```
 *
 * 3. Calculate now instead of waiting for the scheduled calculation
 *
 * ```javascript
 * await project.commitAsync();
 *
 * event.duration; // <- Now available
 * ```
 *
 * ## Using inline data
 *
 * The project provides settable property {@link Scheduler.crud.AbstractCrudManager#property-inlineData} that can
 * be used to get data from all its stores at once and to set this data as well. Populating the stores this way can
 * be useful if you cannot or you do not want to use CrudManager for server requests but you pull the data by other
 * means and have it ready outside of ProjectModel. Also, the data from all stores is available in a single
 * assignment statement.
 *
 * ### Getting data
 * ```javascript
 * const data = scheduler.project.inlineData;
 *
 * // use the data in your application
 * ```
 *
 * ### Setting data
 * ```javascript
 * const data = // your function to pull server data
 *
 * scheduler.project = data;
 * ```
 *
 * ## Monitoring data changes
 *
 * While it is possible to listen for data changes on the projects individual stores, it is sometimes more convenient
 * to have a centralized place to handle all data changes. By listening for the {@link #event-change change event} your
 * code gets notified when data in any of the stores changes. Useful for example to keep an external data model up to
 * date:
 *
 * ```javascript
 * const scheduler = new Scheduler({
 *     project: {
 *         listeners : {
 *             change({ store, action, records }) {
 *                 const { $name } = store.constructor;
 *
 *                 if (action === 'add') {
 *                     externalDataModel.add($name, records);
 *                 }
 *
 *                 if (action === 'remove') {
 *                     externalDataModel.remove($name, records);
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * ## Built in StateTrackingManager
 *
 * The project also has a built in {@link Core.data.stm.StateTrackingManager StateTrackingManager} (STM for short), that
 * handles undo/redo for the project stores (additional stores can also be added). You can enable it to track all
 * project store changes:
 *
 * ```javascript
 * // Turn on auto recording when you create your Scheduler:
 * const scheduler = new Scheduler({
 *    project : {
 *        stm : {
 *            autoRecord : true
 *        }
 *    }
 * });
 *
 * // Undo a transaction
 * project.stm.undo();
 *
 * // Redo
 * project.stm.redo();
 * ```
 *
 * Check out the `undoredo` demo to see it in action.
 *
 * @extends Core/data/Model
 * @mixes Scheduler/model/mixin/ProjectModelMixin
 * @uninherit Core/data/mixin/TreeNode
 */

class ProjectModel extends Object(_mixin_ProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_2__["default"])(EngineMixin) {
  static get $name() {
    return 'ProjectModel';
  } //region Events

  /**
   * Fired when the engine has finished its calculations and the results has been written back to the records.
   *
   * ```javascript
   * scheduler.project.on({
   *     dataReady() {
   *        console.log('Calculations finished');
   *     }
   * });
   *
   * scheduler.eventStore.first.duration = 10;
   *
   * // At some point a bit later it will log 'Calculations finished'
   * ```
   *
   * @event dataReady
   * @param {Scheduler.model.ProjectModel} source The project
   */
  //endregion

  /**
   * Silences propagations caused by the project loading.
   *
   * Applying the loaded data to the project occurs in two basic stages:
   *
   * 1. Data gets into the engine graph which triggers changes propagation
   * 2. The changes caused by the propagation get written to related stores
   *
   * Setting this flag to `true` makes the component perform step 2 silently without triggering events causing reactions on those changes
   * (like sending changes back to the server if `autoSync` is enabled) and keeping stores in unmodified state.
   *
   * This is safe if the loaded data is consistent so propagation doesn't really do any adjustments.
   * By default the system treats the data as consistent so this option is `true`.
   *
   * ```js
   * new Scheduler({
   *     project : {
   *         // We want scheduling engine to recalculate the data properly
   *         // so then we could save it back to the server
   *         silenceInitialCommit : false
   *     }
   *     ...
   * })
   * ```
   *
   * @config {Boolean} silenceInitialCommit
   * @default true
   */


  construct(...args) {
    super.construct(...args);

    if (_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isTestEnv) {
      _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].global.bryntum.testProject = this;
    } // Moved here from EventStore, since project is now the container instead of it


    this.modelPersistencyManager = this.createModelPersistencyManager();
  }
  /**
   * Creates and returns model persistency manager
   *
   * @return {Scheduler.data.util.ModelPersistencyManager}
   * @internal
   */


  createModelPersistencyManager() {
    return new _data_util_ModelPersistencyManager_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
      eventStore: this,
      resourceStore: this.resourceStore,
      assignmentStore: this.assignmentStore,
      dependencyStore: this.dependencyStore
    });
  }

  doDestroy() {
    this.modelPersistencyManager.destroy();
    super.doDestroy();
  } // To comply with TaskBoards expectations


  get taskStore() {
    return this.eventStore;
  }

}
ProjectModel.applyConfigs = true;
ProjectModel.initClass();
ProjectModel._$name = 'ProjectModel';

/***/ }),

/***/ "./lib/Scheduler/model/RecurrenceModel.js":
/*!************************************************!*\
  !*** ./lib/Scheduler/model/RecurrenceModel.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecurrenceModel; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../data/util/recurrence/RecurrenceDayRuleEncoder.js */ "./lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js");
/* harmony import */ var _data_util_recurrence_DailyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../data/util/recurrence/DailyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/DailyRecurrenceIterator.js");
/* harmony import */ var _data_util_recurrence_WeeklyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../data/util/recurrence/WeeklyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/WeeklyRecurrenceIterator.js");
/* harmony import */ var _data_util_recurrence_MonthlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../data/util/recurrence/MonthlyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/MonthlyRecurrenceIterator.js");
/* harmony import */ var _data_util_recurrence_YearlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../data/util/recurrence/YearlyRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/YearlyRecurrenceIterator.js");
var productName = 'taskboard';







/**
 * @module Scheduler/model/RecurrenceModel
 */

const recurrenceIterators = {};
[_data_util_recurrence_DailyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_3__["default"], _data_util_recurrence_WeeklyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_4__["default"], _data_util_recurrence_MonthlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_5__["default"], _data_util_recurrence_YearlyRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_6__["default"]].forEach(it => {
  recurrenceIterators[it.frequency] = it;
});

function convertStringOfIntegerItemsValue(value) {
  if (value) {
    if (typeof value == 'string') {
      value = value.split(',').map(item => parseInt(item, 10));
    }
  } else {
    value = null;
  }

  return value;
}

function convertStringOfItemsValue(value) {
  if (value) {
    if (typeof value == 'string') {
      value = value.split(',');
    }
  } else {
    value = null;
  }

  return value;
}

function isEqualAsString(value1, value2) {
  return String(value1) === String(value2);
}

function convertInteger(value) {
  if (this.defaultValue && value === undefined) {
    return this.defaultValue;
  }

  if (this.allowNull && value == null) {
    return null;
  }

  value = parseInt(value);
  return isNaN(value) ? undefined : value;
}
/**
 * This class represents a timespan recurrence settings.
 * It is a subclass of {@link Core.data.Model} class.
 * Please refer to the documentation for that class to become familiar with the base interface of this class.
 *
 * The data source for these fields can be customized by subclassing this class.
 *
 * @extends Core/data/Model
 */


class RecurrenceModel extends _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'RecurrenceModel';
  }
  /**
   * Indicates that this is a `RecurrenceModel` class instance
   * (allows to avoid using `instanceof`).
   * @property {Boolean}
   * @readonly
   */


  get isRecurrenceModel() {
    return true;
  } //region Fields


  static get fields() {
    return [
    /**
     * Field defines the recurrence frequency. Supported values are: `DAILY`, `WEEKLY`, `MONTHLY`, `YEARLY`.
     * @field {String} frequency
     */
    {
      name: 'frequency',
      defaultValue: 'DAILY'
    },
    /**
     * Field defines how often the recurrence repeats.
     * For example, if the recurrence is weekly its interval is 2, then the timespan repeats every two weeks.
     * @field {Number} interval
     */
    {
      name: 'interval',
      defaultValue: 1,
      convert: convertInteger
    },
    /**
     * End date of the recurrence. Specifies when the recurrence ends.
     * The value is optional, the recurrence can as well be stopped using {@link #field-count} field value.
     * @field {Date} endDate
     */
    {
      name: 'endDate',
      type: 'date'
    },
    /**
     * Specifies the number of occurrences after which the recurrence ends.
     * The value includes the associated timespan itself so values less than 2 make no sense.
     * The field is optional, the recurrence as well can be stopped using {@link #field-endDate} field value.
     * @field {Number} count
     */
    {
      name: 'count',
      allowNull: true,
      convert: convertInteger
    },
    /**
     * Specifies days of the week on which the timespan should occur.
     * An array of string values `SU`, `MO`, `TU`, `WE`, `TH`, `FR`, `SA`
     * corresponding to Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, and Saturday days of the week.
     * Each value can also be preceded by a positive (+n) or negative (-n) integer.
     * If present, this indicates the nth occurrence of a specific day within the monthly or yearly recurrence.
     *
     * **Not applicable** for daily {@link #field-frequency}.
     * @field {String[]} days
     */
    {
      name: 'days',
      convert: convertStringOfItemsValue,
      isEqual: isEqualAsString
    },
    /**
     * Specifies days of the month on which the timespan should occur.
     * An array of integer values (-31..-1 - +1..+31, negative values mean counting backwards from the month end).
     * **Applicable only** for monthly {@link #field-frequency}.
     * @field {Number[]} monthDays
     */
    {
      name: 'monthDays',
      convert: convertStringOfIntegerItemsValue,
      isEqual: isEqualAsString
    },
    /**
     * Specifies months of the year on which the timespan should occur.
     * An array of integer values (1 - 12).
     * **Applicable only** for yearly {@link #field-frequency}.
     * @field {Number[]} months
     */
    {
      name: 'months',
      convert: convertStringOfIntegerItemsValue,
      isEqual: isEqualAsString
    },
    /**
     * The positions to include in the recurrence. The values operate on a set of recurrence instances **in one interval** of the recurrence rule.
     * An array of integer values (valid values are 1 to 366 or -366 to -1, negative values mean counting backwards from the end of the built list of occurrences).
     * **Not applicable** for daily {@link #field-frequency}.
     * @field {Number} positions
     */
    {
      name: 'positions',
      convert: convertStringOfIntegerItemsValue,
      isEqual: isEqualAsString
    }];
  }

  get dateFormat() {
    return this._dateFormat || 'YYYYMMDDTHHmmss';
  }

  set dateFormat(format) {
    this._dateFormat = format;
  }

  get recurrenceIterator() {
    return recurrenceIterators[this.frequency];
  }
  /**
   * The timespan this recurrence is associated with.
   * @property {Scheduler.model.TimeSpan}
   */


  get timeSpan() {
    return this._timeSpan;
  }

  set timeSpan(value) {
    this._timeSpan = value;
  }
  /**
   * The recurrence rule. A string in [RFC-5545](https://tools.ietf.org/html/rfc5545#section-3.3.10) described format ("RRULE" expression).
   * @property {String}
   */


  get rule() {
    const me = this,
          result = [];

    if (me.frequency) {
      result.push(`FREQ=${me.frequency}`);

      if (me.interval > 1) {
        result.push(`INTERVAL=${me.interval}`);
      }

      if (me.days && me.days.length) {
        result.push('BYDAY=' + me.days.join(','));
      }

      if (me.monthDays && me.monthDays.length) {
        result.push('BYMONTHDAY=' + me.monthDays.join(','));
      }

      if (me.months && me.months.length) {
        result.push('BYMONTH=' + me.months.join(','));
      }

      if (me.count) {
        result.push(`COUNT=${me.count}`);
      }

      if (me.endDate) {
        result.push('UNTIL=' + _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].format(me.endDate, me.dateFormat));
      }

      if (me.positions && me.positions.length) {
        result.push('BYSETPOS=' + me.positions.join(','));
      }
    }

    return result.join(';');
  }

  set rule(rule) {
    const me = this,
          values = {
      frequency: null,
      interval: null,
      count: null,
      endDate: null,
      days: null,
      monthDays: null,
      months: null,
      positions: null
    };
    me.beginBatch();

    if (rule) {
      const parts = rule.split(';');

      for (let i = 0, len = parts.length; i < len; i++) {
        const part = parts[i].split('='),
              value = part[1];

        switch (part[0]) {
          case 'FREQ':
            values.frequency = value;
            break;

          case 'INTERVAL':
            values.interval = value;
            break;

          case 'COUNT':
            values.count = value;
            values.until = null;
            break;

          case 'UNTIL':
            if (value) {
              values.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].parse(value, me.dateFormat);
            } else {
              values.endDate = null;
            }

            values.count = null;
            break;

          case 'BYDAY':
            values.days = value;
            break;

          case 'BYMONTHDAY':
            values.monthDays = value;
            break;

          case 'BYMONTH':
            values.months = value;
            break;

          case 'BYSETPOS':
            values.positions = value;
            break;
        }
      }
    }

    me.set(values);

    if (rule) {
      me.sanitize();
    }

    me.endBatch();
  }

  construct(data = {}) {
    const me = this,
          {
      rule,
      timeSpan
    } = data;
    me._suspendedTimeSpanNotifying = 0;
    delete data.timeSpan;
    delete data.rule;
    super.construct(...arguments);

    if (rule) {
      me.suspendTimeSpanNotifying();
      me.rule = rule;
      me.resumeTimeSpanNotifying();
    }

    me.timeSpan = timeSpan;
  }
  /**
   * Iterate occurrences for the owning timespan across the specified date range. This method can be called even
   * if the timespan is not yet a member of a store, however, the occurrences returned will not be cached across
   * subsequent calls to this method.
   * @param {Date} startDate The start date of the iteration.
   * @param {Date} endDate The end date of the iteration.
   * @param {Function} fn The function to call for each occurrence.
   * @param {Scheduler.model.TimeSpan} fn.occurrence The occurrence.
   * @param {Boolean} fn.first A flag which is `true` for the first occurrence of this recurrence.
   * @param {Number} fn.counter A counter of how many dates have been visited in this iteration.
   * @param {Date} fn.date The occurrence date.
   * @internal
   */


  forEachOccurrence(startDate, endDate, fn) {
    if (this.timeSpan.startDate) {
      this.recurrenceIterator.forEachDate({
        recurrence: this,
        startDate,
        endDate,

        fn(date, counter, first, timeSpan) {
          fn(timeSpan.buildOccurrence(date, first), first, counter, date);
        }

      });
    }
  }
  /**
   * Cleans up fields that do not makes sense for the current {@link #field-frequency} value.
   * @private
   */


  sanitize() {
    var _me$timeSpan, _me$monthDays;

    const me = this,
          timeSpanStartDate = (_me$timeSpan = me.timeSpan) === null || _me$timeSpan === void 0 ? void 0 : _me$timeSpan.startDate,
          values = {};
    me.isSanitizing = true;

    switch (me.frequency) {
      case 'DAILY':
        values.positions = null;
        values.days = null;
        values.monthDays = null;
        values.months = null;
        break;

      case 'WEEKLY':
        values.positions = null;
        values.monthDays = null;
        values.months = null;
        const {
          days
        } = me;

        if (timeSpanStartDate && (days === null || days === void 0 ? void 0 : days.length) == 1 && days[0] == _data_util_recurrence_RecurrenceDayRuleEncoder_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeDay(timeSpanStartDate.getDay())) {
          values.days = null;
        }

        break;

      case 'MONTHLY':
        if ((_me$monthDays = me.monthDays) !== null && _me$monthDays !== void 0 && _me$monthDays.length) {
          values.positions = null;
          values.days = null;
        }

        values.months = null;
        const {
          monthDays
        } = me;

        if (timeSpanStartDate && (monthDays === null || monthDays === void 0 ? void 0 : monthDays.length) == 1 && monthDays[0] == timeSpanStartDate.getDate()) {
          values.monthDays = null;
        }

        break;

      case 'YEARLY':
        values.monthDays = null;
        const {
          months
        } = me;

        if (timeSpanStartDate && (months === null || months === void 0 ? void 0 : months.length) == 1 && months[0] == timeSpanStartDate.getMonth() + 1) {
          values.months = null;
        }

        break;
    }

    me.set(values);
    me.isSanitizing = false;
  }

  copy(...args) {
    const result = super.copy(...args);
    result.dateFormat = this.dateFormat;
    result.timeSpan = this.timeSpan;
    return result;
  }

  afterChange(toSet, wasSet, silent) {
    const result = super.afterChange(toSet, wasSet, silent),
          {
      timeSpan
    } = this;

    if (!this.isSanitizing) {
      // cleanup data to match the chosen frequency
      this.sanitize();
    }

    if (timeSpan) {
      timeSpan.sanitizeRecurrenceData(this);

      if (!this.isTimeSpanNotifyingSuspended) {
        timeSpan.onRecurrenceChanged();
      }
    }

    return result;
  }

  set(field, value, ...args) {
    const values = typeof field === 'object' ? field : {
      [field]: value
    }; // reset "endDate" field if "count" is being set

    if (values.count) {
      values.endDate = null;
    } // reset "count" field if "endDate" is being set
    else if (values.endDate) {
      values.count = null;
    }

    super.set(values, undefined, ...args);
  }

  get isTimeSpanNotifyingSuspended() {
    return Boolean(this._suspendedTimeSpanNotifying);
  }

  suspendTimeSpanNotifying() {
    this._suspendedTimeSpanNotifying++;
  }

  resumeTimeSpanNotifying() {
    if (this._suspendedTimeSpanNotifying) this._suspendedTimeSpanNotifying--;
  }

}
RecurrenceModel._$name = 'RecurrenceModel';

/***/ }),

/***/ "./lib/Scheduler/model/ResourceModel.js":
/*!**********************************************!*\
  !*** ./lib/Scheduler/model/ResourceModel.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceModel; });
/* harmony import */ var _Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Grid/data/GridRowModel.js */ "./lib/Grid/data/GridRowModel.js");
/* harmony import */ var _data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony import */ var _mixin_ResourceModelMixin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/ResourceModelMixin.js */ "./lib/Scheduler/model/mixin/ResourceModelMixin.js");
/* harmony import */ var _Engine_quark_model_scheduler_core_CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Engine/quark/model/scheduler_core/CoreResourceMixin.js */ "./lib/Engine/quark/model/scheduler_core/CoreResourceMixin.js");
var productName = 'taskboard';




const EngineMixin = _Engine_quark_model_scheduler_core_CoreResourceMixin_js__WEBPACK_IMPORTED_MODULE_3__["CoreResourceMixin"];
/**
 * @module Scheduler/model/ResourceModel
 */

/**
 * This class represent a single Resource in scheduler, usually added to a {@link Scheduler.data.ResourceStore}.
 *
 * It is a subclass of  {@link Core.data.Model}. Please refer to the documentation for that class to become familiar
 * with the base interface of the resource.
 *
 * ## Fields and references
 *
 * A resource has a few predefined fields, see Fields below. If you want to add more fields with meta data describing
 * your resources then you should subclass this class:
 *
 * ```javascript
 * class MyResource extends ResourceModel {
 *   static get fields() {
 *     return [
 *       // "id" and "name" fields are already provided by the superclass
 *       { name: 'company', type : 'string' }
 *     ];
 *   }
 * });
 * ```
 *
 * If you want to use other names in your data for the id and name fields you can configure them as seen below:
 *
 * ```javascript
 * class MyResource extends ResourceModel {
 *   static get fields() {
 *     return [
 *        { name: 'name', dataSource: 'userName' }
 *     ];
 *   },
 * });
 * ```
 *
 * After load and project normalization, these references are accessible (assuming their respective stores are loaded):
 * - `assignments` - The linked assignment records
 * - `events` - The linked (through assignments) event records
 *
 * ## Async resolving of references
 *
 * As described above, a resource has links to assignments and events. These references are populated async, using the
 * calculation engine of the project that the resource via its store is a part of. Because of this asyncness, references
 * cannot be used immediately after assignment modifications:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * // resource.assignments is not yet up to date
 * ```
 *
 * To make sure references are updated, wait for calculations to finish:
 *
 * ```javascript
 * assignment.resourceId = 2;
 * await assignment.project.commitAsync();
 * // resource.assignments is up to date
 * ```
 *
 * As an alternative, you can also use `setAsync()` to trigger calculations directly after the change:
 *
 * ```javascript
 * await assignment.setAsync({ resourceId : 2});
 * // resource.assignments is up to date
 * ```
 *
 * @extends Grid/data/GridRowModel
 * @mixes Scheduler/model/mixin/ResourceModelMixin
 */

class ResourceModel extends Object(_mixin_ResourceModelMixin_js__WEBPACK_IMPORTED_MODULE_2__["default"])(Object(_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(EngineMixin.derive(_Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_0__["default"]))) {
  static get $name() {
    return 'ResourceModel';
  }

}
ResourceModel.exposeProperties();
ResourceModel._$name = 'ResourceModel';

/***/ }),

/***/ "./lib/Scheduler/model/ResourceTimeRangeModel.js":
/*!*******************************************************!*\
  !*** ./lib/Scheduler/model/ResourceTimeRangeModel.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceTimeRangeModel; });
/* harmony import */ var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module Scheduler/model/ResourceTimeRangeModel
 */

/**
 * This class represent a single resource time range in your schedule.
 * To style the rendered elements, use {@link Scheduler.model.TimeSpan#field-cls cls} or {@link #field-timeRangeColor} field.
 * The class is used by the {@link Scheduler.feature.ResourceTimeRanges ResourceTimeRanges} feature.
 *
 * ## Recurring ranges support
 *
 * By default the class doesn't support recurrence.
 * In order to add its support please use {@link Scheduler/model/mixin/RecurringTimeSpan RecurringTimeSpan} mixin
 * (the store containing the model should in turn be mixed with {@link Scheduler.data.mixin.RecurringTimeSpansMixin RecurringTimeSpansMixin} class):
 *
 * ```js
 * // Mix RecurringTimeSpan (which adds recurrence support) to ResourceTimeRangeModel
 * class MyResourceTimeRange extends RecurringTimeSpan(ResourceTimeRangeModel) {};
 *
 * // Mix RecurringTimeSpansMixin (which adds recurrence support) to ResourceTimeRangeStore
 * class MyResourceTimeRangeStore extends RecurringTimeSpansMixin(ResourceTimeRangeStore) {
 *     static get defaultConfig() {
 *         return {
 *             // use our new MyResourceTimeRange model
 *             modelClass : MyResourceTimeRange
 *         };
 *     }
 * };
 *
 * // Make new store that supports time ranges recurrence
 * const store = new MyResourceTimeRangeStore({
 *     data : [{        {
 *         id             : 1,
 *         resourceId     : 'r1',
 *         startDate      : '2019-01-01T11:00',
 *         endDate        : '2019-01-01T13:00',
 *         name           : 'Coffee break',
 *         // this time range should repeat every day
 *         recurrenceRule : 'FREQ=DAILY'
 *     }]
 * });
 * ```
 *
 * @extends Scheduler/model/TimeSpan
 */

class ResourceTimeRangeModel extends _TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ResourceTimeRangeModel';
  } //region Fields


  static get fields() {
    return [
    /**
     * Id of the resource this time range is associated with
     * @field {String|Number} resourceId
     */
    'resourceId',
    /**
     * Controls this time ranges primary color, defaults to using current themes default time range color.
     * @field {String} timeRangeColor
     */
    'timeRangeColor'];
  }

  static get relationConfig() {
    return [
    /**
     * The associated resource, retrieved using a relation to a ResourceStore determined by the value assigned
     * to `resourceId`. The relation also lets you access all time ranges on a resource through
     * `ResourceModel#timeRanges`.
     * @member {Scheduler.model.ResourceModel} resource
     */
    {
      relationName: 'resource',
      fieldName: 'resourceId',
      store: 'resourceStore',
      collectionName: 'timeRanges',
      nullFieldOnRemove: true
    }];
  }

  get domId() {
    return `${this.constructor.domIdPrefix}-${this.id}`;
  } //endregion
  // Used internally to differentiate between Event and ResourceTimeRange


  get isResourceTimeRange() {
    return true;
  } // To match EventModel API


  get resources() {
    return this.resource ? [this.resource] : [];
  }

}

_defineProperty(ResourceTimeRangeModel, "domIdPrefix", 'resourcetimerange');

ResourceTimeRangeModel._$name = 'ResourceTimeRangeModel';

/***/ }),

/***/ "./lib/Scheduler/model/TimeSpan.js":
/*!*****************************************!*\
  !*** ./lib/Scheduler/model/TimeSpan.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TimeSpan; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/data/Duration.js */ "./lib/Core/data/Duration.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';






/**
 * @module Scheduler/model/TimeSpan
 */

/**
 * This class represent a simple date range. It is being used in various subclasses and plugins which operate on date ranges.
 *
 * Its a subclass of  {@link Core.data.Model}.
 * Please refer to documentation of those classes to become familiar with the base interface of this class.
 *
 * A TimeSpan has the following fields:
 *
 * - {@link #field-startDate}    - start date of the task in the ISO 8601 format
 * - {@link #field-endDate}      - end date of the task in the ISO 8601 format (not inclusive)
 * - {@link #field-duration}     - duration, time between start date and end date
 * - {@link #field-durationUnit} - unit used to express the duration
 * - {@link #field-name}         - an optional name of the range
 * - {@link #field-cls}          - an optional CSS class to be associated with the range.
 *
 * The data source of any field can be customized in the subclass. Please refer to {@link Core.data.Model} for details. To specify
 * another date format:
 *
 * ```javascript
 * class MyTimeSpan extends TimeSpan {
 *   static get fields() {
 *      { name: 'startDate', type: 'date', dateFormat: 'DD/MM/YY' }
 *   }
 * }
 * ```
 *
 * @extends Core/data/Model
 */

class TimeSpan extends _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'TimeSpan';
  } //region Field definitions


  static get fields() {
    return [
    /**
     * The start date of a time span (or Event / Task).
     *
     * Uses {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat} to convert a
     * supplied string to a Date. To specify another format, either change that setting or subclass TimeSpan and
     * change the dateFormat for this field.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} startDate
     * @accepts {String|Date}
     * @category Scheduling
     */
    {
      name: 'startDate',
      type: 'date'
    },
    /**
     * The end date of a time span (or Event / Task).
     *
     * Uses {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat} to convert a
     * supplied string to a Date. To specify another format, either change that setting or subclass TimeSpan and
     * change the dateFormat for this field.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} endDate
     * @accepts {String|Date}
     * @category Scheduling
     */
    {
      name: 'endDate',
      type: 'date'
    },
    /**
     * The numeric part of the timespan's duration (the number of units).
     * @field {Number} duration
     * @category Scheduling
     */
    {
      name: 'duration',
      type: 'number',
      allowNull: true,
      internal: true
    },
    /**
     * The unit part of the TimeSpan duration, defaults to "d" (days). Valid values are:
     *
     * - "ms" (milliseconds)
     * - "s" (seconds)
     * - "m" (minutes)
     * - "h" (hours)
     * - "d" (days)
     * - "w" (weeks)
     * - "M" (months)
     * - "y" (years)
     *
     * This field is readonly after creation, to change durationUnit use #setDuration().
     * @field {String} durationUnit
     * @category Scheduling
     */
    {
      name: 'durationUnit',
      type: 'string',
      defaultValue: 'd',
      internal: true
    }, {
      name: 'fullDuration',
      persist: false,
      column: {
        type: 'duration'
      },
      internal: true // TODO: remove this when durationcolumn is in Scheduler

    },
    /**
     * An encapsulation of the CSS classes to add to the rendered time span element.
     *
     * Always returns a {@link Core.helper.util.DomClassList}, but may still be treated as a string. For
     * granular control of adding and removing individual classes, it is recommended to use the
     * {@link Core.helper.util.DomClassList} API.
     *
     * @field {Core.helper.util.DomClassList} cls
     * @accepts {Core.helper.util.DomClassList|String|String[]|Object}
     *
     * @category Styling
     */
    {
      name: 'cls',
      defaultValue: '',
      internal: true
    },
    /**
     * CSS class specifying an icon to apply to the rendered time span element.
     * **Note**: In case event is a milestone, using `iconCls` with dependency feature might slightly decrease
     * performance because feature will refer to the DOM to get exact size of the element.
     * @field {String} iconCls
     * @category Styling
     */
    {
      name: 'iconCls',
      internal: true
    },
    /**
     * A CSS style string (applied to `style.cssText`) or object (applied to `style`)
     * ```
     * record.style = 'color: red;font-weight: 800';
     * ```
     *
     * @field {String} style
     * @category Styling
     */
    {
      name: 'style',
      type: 'object',
      internal: true
    },
    /**
     * The name of the time span (or Event / Task)
     * @field {String} name
     * @category Common
     */
    {
      name: 'name',
      type: 'string',
      defaultValue: ''
    }];
  } //endregion
  //region Init


  afterConstruct() {
    super.afterConstruct(); // This should probably be a property setter of some mandatory config, then we would not need an afterConfigure implementation.

    this.normalize();
  }
  /**
   * Returns the event store this event is part of.
   *
   * @property {Scheduler.data.EventStore}
   * @readonly
   */


  get eventStore() {
    const me = this; // If we are an occurrence, return our base recurring event's store

    if (me.isOccurrence) {
      return me.recurringTimeSpan.eventStore;
    }

    if (!me._eventStore) {
      var _me$stores;

      me._eventStore = (_me$stores = me.stores) === null || _me$stores === void 0 ? void 0 : _me$stores.find(s => s.isEventStore);
    }

    return me._eventStore;
  }

  normalize() {
    const me = this,
          {
      startDate,
      endDate,
      duration,
      durationUnit
    } = me,
          hasDuration = duration != null; // need to calculate duration (checking first since seemed most likely to happen)

    if (startDate && endDate && !hasDuration) {
      me.setData('duration', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(startDate, endDate, durationUnit, true));
    } // need to calculate endDate?
    else if (startDate && !endDate && hasDuration) {
      me.setData('endDate', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(startDate, duration, durationUnit));
    } // need to calculate startDate
    else if (!startDate && endDate && hasDuration) {
      me.setData('startDate', _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(endDate, -duration, durationUnit));
    }
  } //endregion
  //region Getters & Setters


  set internalCls(cls) {
    const me = this;

    if (me._cls) {
      me._cls.value = cls;
    } else {
      me._cls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"](cls);
    }

    me.set('cls', me._cls.value);
  }

  get internalCls() {
    const {
      cls
    } = this; // `cls` getter can be overriden so return `cls` value if it is DomClassList or assign it to `this._cls`

    if (cls !== null && cls !== void 0 && cls.isDomClassList) {
      return cls;
    }

    this.internalCls = cls;
    return this._cls;
  }

  get cls() {
    if (!this._cls) {
      this._cls = new _Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_1__["default"](super.get('cls'));
    }

    return this._cls;
  }

  set cls(cls) {
    this.internalCls = cls;
  }

  get startDate() {
    return this.get('startDate');
  }

  set startDate(date) {
    this.setStartDate(date);
  }

  get endDate() {
    return this.get('endDate');
  }

  set endDate(date) {
    this.setEndDate(date);
  }

  get duration() {
    return this.get('duration');
  }

  set duration(duration) {
    this.setDuration(duration, this.durationUnit);
  }

  get durationUnit() {
    return this.get('durationUnit');
  }
  /**
   * Sets duration and durationUnit in one go. Only allowed way to change durationUnit, the durationUnit field is
   * readonly after creation
   * @param {Number} duration Duration value
   * @param {String} durationUnit Unit for specified duration value, see {@link #field-durationUnit} for valid values
   */


  setDuration(duration, durationUnit = this.durationUnit) {
    // Must be a number
    duration = parseFloat(duration);
    const toSet = {
      duration,
      durationUnit
    };

    if (this.startDate) {
      toSet.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(this.startDate, duration, durationUnit);
    } else if (this.endDate) {
      toSet.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(this.endDate, -duration, durationUnit);
    }

    this.set(toSet);
  }
  /**
   * Returns duration of the event in given unit. This is a wrapper for {@link Core.helper.DateHelper#function-getDurationInUnit-static}
   * @param {String} unit
   * @param {Boolean} [doNotRound]
   * @private
   * @returns {Number}
   */


  getDurationInUnit(unit, doNotRound) {
    if (this.starDate && this.endDate) {
      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getDurationInUnit(this.startDate, this.endDate, unit, doNotRound);
    } else {
      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].as(unit, this.duration, this.durationUnit);
    }
  }
  /**
   * Property which encapsulates the duration's magnitude and units.
   * @property {Core.data.Duration}
   */


  get fullDuration() {
    // Used for formatting during export
    return new _Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_5__["default"]({
      unit: this.durationUnit,
      magnitude: this.duration
    });
  }

  set fullDuration(duration) {
    if (typeof duration === 'string') {
      duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseDuration(duration, true, this.durationUnit);
    }

    this.setDuration(duration.magnitude, duration.unit);
  }
  /**
   * Sets the range start date
   *
   * @param {Date} date The new start date
   * @param {Boolean} keepDuration Pass `true` to keep the duration of the task ("move" the event), `false` to change the duration ("resize" the event).
   * Defaults to `true`
   */


  setStartDate(date, keepDuration = true) {
    const me = this,
          toSet = {
      startDate: date
    };

    if (date) {
      let calcEndDate;

      if (keepDuration) {
        calcEndDate = me.duration != null;
      } else {
        if (me.endDate) {
          toSet.duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(date, me.endDate, me.durationUnit, true);
          if (toSet.duration < 0) throw new Error('Negative duration');
        } else {
          calcEndDate = this.duration != null;
        }
      }

      if (calcEndDate) {
        // Use hours to set end date in order to correctly process DST crossings
        toSet.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(date, me.getDurationInUnit('h'), 'h');
      }
    } else {
      toSet.duration = null;
    }

    me.set(toSet);
  }
  /**
   * Sets the range end date
   *
   * @param {Date} date The new end date
   * @param {Boolean} keepDuration Pass `true` to keep the duration of the task ("move" the event), `false` to change the duration ("resize" the event).
   * Defaults to `false`
   */


  setEndDate(date, keepDuration = false) {
    const me = this,
          toSet = {
      endDate: date
    };

    if (date) {
      let calcStartDate;

      if (keepDuration === true) {
        calcStartDate = me.duration != null;
      } else {
        if (me.startDate) {
          toSet.duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(me.startDate, date, me.durationUnit, true);
          if (toSet.duration < 0) throw new Error('Negative duration');
        } else {
          calcStartDate = this.duration != null;
        }
      }

      if (calcStartDate) {
        toSet.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(date, -me.duration, me.durationUnit);
      }
    }

    me.set(toSet);
  }
  /**
   * Sets the event start and end dates
   *
   * @param {Date} start The new start date
   * @param {Date} end The new end date
   * @param {Boolean} [silent] Pass `true` to not trigger events
   */


  setStartEndDate(start, end, silent) {
    this.set({
      startDate: start,
      endDate: end
    }, null, silent);
  }
  /**
   * Returns an array of dates in this range. If the range starts/ends not at the beginning of day, the whole day will be included.
   * @readonly
   * @property {Date[]}
   */


  get dates() {
    const dates = [],
          startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].startOf(this.startDate, 'day'),
          endDate = this.endDate;

    for (let date = startDate; date < endDate; date = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(date, 1, 'day')) {
      dates.push(date);
    }

    return dates;
  }

  get startDateMS() {
    var _ref;

    return (_ref = this.batching && this.hasBatchedChange('startDate') ? this.get('startDate') : this.startDate) === null || _ref === void 0 ? void 0 : _ref.getTime();
  }

  get endDateMS() {
    var _ref2;

    return (_ref2 = this.batching && this.hasBatchedChange('endDate') ? this.get('endDate') : this.endDate) === null || _ref2 === void 0 ? void 0 : _ref2.getTime();
  }
  /**
   * Returns the duration of this Event in milliseconds.
   * @readonly
   * @property {Number}
   */


  get durationMS() {
    const {
      endDateMS,
      startDateMS
    } = this;

    if (endDateMS && startDateMS) {
      return endDateMS - startDateMS;
    } else {
      return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].asMilliseconds(this.duration || 0, this.durationUnit);
    }
  }
  /**
   * Returns true if record is a milestone.
   * @readonly
   * @property {Boolean}
   */


  get isMilestone() {
    return this.duration === 0;
  }

  inSetNormalize(field) {
    if (typeof field !== 'string') {
      // If user is updating multiple properties in one go using an object, we help out
      // by filling out missing schedule related data
      let {
        startDate,
        endDate,
        duration,
        durationUnit = this.durationUnit
      } = field; // Conversion is usually handled in inSet, but we are normalizing prior to that and have to handle it here

      if (typeof startDate === 'string') {
        startDate = this.getFieldDefinition('startDate').convert(startDate);
      }

      if (typeof endDate === 'string') {
        endDate = this.getFieldDefinition('endDate').convert(endDate);
      }

      if ('duration' in field) {
        if (startDate && !endDate) {
          endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(startDate, duration, durationUnit, true, true);
        }

        if (!startDate && endDate) {
          startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(endDate, -duration, durationUnit, true, true);
        }
      } else if (startDate && endDate) {
        // Calculate duration in hours and covert to target duration unit in order to avoid extra DST conversion
        duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].as(durationUnit, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].diff(startDate, endDate, 'h', true), 'h');
      }

      startDate && (field.startDate = startDate);
      endDate && (field.endDate = endDate);
      duration != null && (field.duration = duration);
      return field;
    }
  }

  inSet(field, value, silent, fromRelationUpdate, skipAccessors) {
    if (!skipAccessors) {
      field = this.inSetNormalize(field) || field;
    }

    return super.inSet(field, value, silent, fromRelationUpdate, skipAccessors);
  } //endregion
  //region Iteration

  /**
   * Iterates over the {@link #property-dates}
   * @param {Function} func The function to call for each date
   * @param {Object} thisObj `this` reference for the function
   */


  forEachDate(func, thisObj) {
    return this.dates.forEach(func.bind(thisObj));
  } //endregion

  /**
   * Checks if the range record has both start and end dates set and start <= end
   *
   * @property {Boolean}
   */


  get isScheduled() {
    const {
      startDateMS,
      endDateMS
    } = this;
    return endDateMS - startDateMS >= 0;
  } // Simple check if end date is greater than start date


  get isValid() {
    const {
      startDate,
      endDate
    } = this;
    return !startDate || !endDate || endDate - startDate >= 0;
  }
  /**
   * Shift the dates for the date range by the passed amount and unit
   * @param {String} unit The unit to shift by, see {@link Core.helper.DateHelper} for more information on valid formats.
   * @param {Number} amount The amount to shift
   */


  shift(amount, unit = this.durationUnit) {
    // TODO REMOVE FOR 2.0
    if (typeof amount === 'string') {
      const u = amount;
      amount = unit;
      unit = u;
    }

    return this.setStartDate(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(this.startDate, amount, unit, true), true);
  }
  /**
   * Returns the WBS code of this model (e.g '2.1.3'). Only relevant when part of a tree store, as in the Gantt chart.
   * @property {String}
   */


  get wbsCode() {
    return this._wbsCode || this.indexPath.join('.');
  }

  set wbsCode(value) {
    // wbsCode needs to be writable to interop w/TaskModel and Baselines which copy this field value
    this._wbsCode = value;
  }

  fullCopy() {
    //NOT PORTED
    return this.copy.apply(this, arguments);
  }

  intersects(timeSpan) {
    return this.intersectsRange(timeSpan.startDate, timeSpan.endDate);
  }

  intersectsRange(start, end) {
    const myStart = this.startDate,
          myEnd = this.endDate;
    return myStart && myEnd && _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].intersectSpans(myStart, myEnd, start, end);
  }
  /**
   * Splits this event into two pieces at the desired position.
   *
   * @param {Number} splitPoint A number greater than 0 and less than 1, indicating how this event will be split. 0.5 means cut it in half
   * @return {Scheduler.model.TimeSpan} The newly created split section of the timespan
   */


  split(splitPoint = 0.5) {
    const me = this,
          clone = me.copy(),
          {
      eventStore,
      assignmentStore
    } = me,
          ownNewDuration = me.duration * splitPoint,
          cloneDuration = me.duration - ownNewDuration;

    if (splitPoint <= 0 || splitPoint >= 1) {
      throw new Error('Split point must be > 0 and < 1');
    }

    clone.startDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(me.startDate, ownNewDuration, me.durationUnit);
    clone.duration = cloneDuration;
    me.duration = ownNewDuration;

    if (eventStore) {
      eventStore.add(clone);

      if (assignmentStore && !eventStore.usesSingleAssignment) {
        assignmentStore.add(me.assignments.map(assignment => {
          const clonedData = Object.assign({}, assignment.data, {
            eventId: clone.id,
            // From engine
            event: null,
            resource: null
          });
          delete clonedData.id;
          return clonedData;
        }));
      }
    }

    return clone;
  }

  toICSString(icsEventConfig = {}) {
    if (!this.isScheduled) {
      return '';
    }

    const nowAsUTC = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].toUTC(new Date()),
          startAsUTC = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].toUTC(this.startDate),
          endAsUTC = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].toUTC(this.endDate),
          fullDateFormat = 'YYYYMMDDTHHmmss',
          // To allow testing using a fixed timestamp value
    timestamp = icsEventConfig.DTSTAMP || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(nowAsUTC, fullDateFormat) + 'Z';
    delete icsEventConfig.DTSTAMP;
    let startEnd = {};

    if (this.allDay) {
      const dateFormat = 'YYYYMMDD';
      startEnd = {
        'DTSTART;VALUE=DATE': _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(startAsUTC, dateFormat),
        'DTEND;VALUE=DATE': _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(endAsUTC, dateFormat)
      };
    } else {
      startEnd = {
        DTSTART: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(startAsUTC, fullDateFormat) + 'Z',
        DTEND: _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(endAsUTC, fullDateFormat) + 'Z'
      };
    }

    const version = _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].scheduler && _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getVersion('scheduler') || _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].calendar && _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getVersion('calendar') || '',
          icsWrapConfig = {
      BEGIN: 'VCALENDAR',
      VERSION: '2.0',
      CALSCALE: 'GREGORIAN',
      PRODID: `-//Bryntum AB//Bryntum Scheduler ${version} //EN`,
      END: 'VCALENDAR'
    },
          eventConfig = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      BEGIN: 'VEVENT',
      UID: this.id + '@bryntum.com',
      CLASS: 'PUBLIC',
      SUMMARY: this.name,
      DTSTAMP: timestamp
    }, startEnd), this.recurrenceRule ? {
      RRULE: this.recurrenceRule
    } : {}), icsEventConfig), {}, {
      END: 'VEVENT'
    }),
          icsItems = Object.keys(icsWrapConfig).map(key => `${key}:${icsWrapConfig[key]}`),
          eventItems = Object.keys(eventConfig).map(key => `${key}:${eventConfig[key]}`); // Inject event details before the closing VCALENDAR entry


    icsItems.splice(icsItems.length - 1, 0, ...eventItems);
    return icsItems.join('\n');
  }
  /**
   * Triggers a download of this time span in ICS format (for import in Outlook etc.)
   *
   * ```javascript
   * timeSpan.downloadAsICS({
   *      LOCATION : timeSpan.location
   *  });
   * ```
   * @param {Object} [icsEventConfig] A config object with properties to be added in to `BEGIN:VEVENT` section of the
   * exported event.
   */


  exportToICS(icsEventConfig) {
    if (this.isScheduled) {
      const blob = new Blob([this.toICSString(icsEventConfig)], {
        type: 'text/calendar'
      });
      _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].downloadBlob(blob, (this.name || 'Event') + '.ics');
    }
  }
  /**
   * Defines if the given event field should be manually editable in UI.
   * You can override this method to provide your own logic.
   *
   * By default the method defines all the event fields as editable.
   *
   * @param {String} fieldName Name of the field
   * @returns {Boolean} Returns `true` if the field is editable, `false` if it is not and `undefined` if the model has no such field.
   */


  isEditable(fieldName) {
    // return undefined for unknown fields
    return this.getFieldDefinition(fieldName) ? true : undefined;
  }

  isFieldModified(fieldName) {
    if (fieldName === 'fullDuration') {
      return super.isFieldModified('duration') || super.isFieldModified('durationUnit');
    }

    return super.isFieldModified(fieldName);
  }

}
TimeSpan._$name = 'TimeSpan';

/***/ }),

/***/ "./lib/Scheduler/model/mixin/AssignmentModelMixin.js":
/*!***********************************************************!*\
  !*** ./lib/Scheduler/model/mixin/AssignmentModelMixin.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var productName = 'taskboard';
/**
* @module Scheduler/model/mixin/AssignmentModelMixin
*/

/**
 * Mixin that holds configuration shared between assignments in Scheduler and Scheduler Pro.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class AssignmentModelMixin extends Target {
  static get $name() {
    return 'AssignmentModelMixin';
  }
  /**
   * Set value for the specified field(s), triggering engine calculations immediately. See
   * {@link Core.data.Model#function-set Model#set()} for arguments.
   *
   * ```javascript
   * assignment.set('resourceId', 2);
   * // assignment.resource is not yet resolved
   *
   * await assignment.setAsync('resourceId', 2);
   * // assignment.resource is resolved
   * ```
   *
   * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
   * @param {*} value Value to set
   * @param {Boolean} [silent=false] Set to true to not trigger events
   * automatically.
   * @function setAsync
   * @category Editing
   * @async
   */
  //region Fields


  static get fields() {
    return [
    /**
     * Id for the resource to assign to
     * @field {String|Number} resourceId
     * @category Common
     */
    'resourceId',
    /**
     * Id for the event to assign
     * @field {String|Number} eventId
     * @category Common
     */
    'eventId',
    /**
     * Specify `false` to opt out of drawing dependencies from/to this assignment
     * @field {Boolean} drawDependencies
     * @category Common
     */
    {
      name: 'drawDependencies',
      type: 'boolean'
    }, 'event', 'resource'];
  } //endregion


  construct(data, ...args) {
    data = data || {};
    const eventId = data[this.fieldMap.eventId.dataSource],
          resourceId = data[this.fieldMap.resourceId.dataSource]; // Engine expects event and resource, not eventId and resourceId. We need to support both

    if (eventId != null) {
      data.event = eventId;
    }

    if (resourceId != null) {
      data.resource = resourceId;
    }

    super.construct(data, ...args);
  } //region Event & resource

  /**
   * A key made up from the event id and the id of the resource assigned to.
   * @property eventResourceKey
   * @readonly
   * @internal
   */


  get eventResourceKey() {
    const me = this;
    let eventKey, resourceKey;

    if (me.event) {
      eventKey = me.event.isModel ? me.event.id : me.event;
    } else {
      eventKey = me.internalId;
    }

    if (me.resource) {
      resourceKey = me.resource.isModel ? me.resource.id : me.resource;
    } else {
      resourceKey = me.internalId;
    }

    return `${eventKey}-${resourceKey}`;
  }

  set(field, value, ...args) {
    const toSet = this.fieldToKeys(field, value); // If resource was set, store its id as resourceId and announce it

    if ('resource' in toSet) {
      var _toSet$resource;

      if ((_toSet$resource = toSet.resource) !== null && _toSet$resource !== void 0 && _toSet$resource.id) {
        toSet.resourceId = toSet.resource.id;
      }
    } // Same for event


    if ('event' in toSet) {
      var _toSet$event;

      if ((_toSet$event = toSet.event) !== null && _toSet$event !== void 0 && _toSet$event.id) {
        toSet.eventId = toSet.event.id;
      }
    }

    super.set(toSet, null, ...args);
  } // Settings resourceId relays to `resource`. Underlying data will be updated in `afterChange()` above


  set resourceId(value) {
    const {
      resource
    } = this; // When assigning a new id to a resource, it will update the resourceId of the assignment. But the assignments
    // resource is still the same so we need to announce here

    if (resource !== null && resource !== void 0 && resource.isModel && resource.id === value) {
      this.set('resourceId', value);
    } else {
      this.resource = value;
    }
  }

  get resourceId() {
    var _this$resource;

    // If assigned using `resource` and not `resourceId` there will be no resourceId
    return this.get('resourceId') || ((_this$resource = this.resource) === null || _this$resource === void 0 ? void 0 : _this$resource.id);
  } // Same for event as for resourceId


  set eventId(value) {
    const {
      event
    } = this; // When assigning a new id to an event, it will update the eventId of the assignment. But the assignments
    // event is still the same so we need to announce here

    if (event !== null && event !== void 0 && event.isModel && event.id === value) {
      this.set('eventId', value);
    } else {
      this.event = value;
    }
  }

  get eventId() {
    var _this$event;

    // If assigned using `event` and not `eventId` there will be no eventId
    return this.get('eventId') || ((_this$event = this.event) === null || _this$event === void 0 ? void 0 : _this$event.id);
  }
  /**
   * Convenience property to get the name of the associated event.
   * @property {String}
   * @readonly
   */


  get eventName() {
    var _this$event2;

    return (_this$event2 = this.event) === null || _this$event2 === void 0 ? void 0 : _this$event2.name;
  }
  /**
   * Convenience property to get the name of the associated resource.
   * @property {String}
   * @readonly
   */


  get resourceName() {
    var _this$resource2;

    return (_this$resource2 = this.resource) === null || _this$resource2 === void 0 ? void 0 : _this$resource2.name;
  } // TODO : Deprecate in favor of `get resource`

  /**
   * Returns the resource associated with this assignment.
   *
   * @return {Scheduler.model.ResourceModel} Instance of resource
   */


  getResource() {
    return this.resource;
  } //endregion
  // Convenience getter to not have to check `instanceof AssignmentModel`


  get isAssignment() {
    return true;
  }
  /**
   * Returns true if the Assignment can be persisted (e.g. task and resource are not 'phantoms')
   *
   * @property {Boolean}
   */


  get isPersistable() {
    var _this$event3;

    const {
      event,
      resource,
      unjoinedStores,
      assignmentStore
    } = this,
          crudManager = assignmentStore === null || assignmentStore === void 0 ? void 0 : assignmentStore.crudManager;
    let result;

    if (assignmentStore) {
      // If the owning event is not persistable, this assignment is also not persistable.
      // if crud manager is used it can deal with phantom event/resource since it persists all records in one batch
      // if no crud manager used we have to wait till event/resource are persisted
      result = this.isValid && event.isPersistable && (crudManager || !event.hasGeneratedId && !resource.hasGeneratedId);
    } // if we remove the record
    else {
      result = !this.isPhantom && Boolean(unjoinedStores[0]);
    } // Records not yet fully created cannot be persisted


    return result && super.isPersistable && !((_this$event3 = this.event) !== null && _this$event3 !== void 0 && _this$event3.meta.isCreating);
  }

  get isValid() {
    return this.resource != null && this.event != null;
  }
  /**
   * Returns a textual representation of this assignment (e.g. Mike 50%).
   * @return {String}
   */


  toString() {
    if (this.resourceName) {
      return `${this.resourceName} ${Math.round(this.units)}%`;
    }

    return '';
  }

});

/***/ }),

/***/ "./lib/Scheduler/model/mixin/EventModelMixin.js":
/*!******************************************************!*\
  !*** ./lib/Scheduler/model/mixin/EventModelMixin.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
var productName = 'taskboard';


const oneDayMS = 1000 * 60 * 60 * 24;
/**
 * @module Scheduler/model/mixin/EventModelMixin
 */

/**
 * Mixin that holds configuration shared between events in Scheduler and Scheduler Pro.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class EventModelMixin extends Target {
  static get $name() {
    return 'EventModelMixin';
  } // Flag checked by EventStore to make sure it uses a valid subclass


  static get isEventModel() {
    return true;
  }
  /**
   * Set value for the specified field(s), triggering engine calculations immediately. See
   * {@link Core.data.Model#function-set Model#set()} for arguments.
   *
   * ```javascript
   * eventRecord.set('duration', 4);
   * // eventRecord.endDate is not yet calculated
   *
   * await eventRecord.setAsync('duration', 4);
   * // eventRecord.endDate is calculated
   * ```
   *
   * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
   * @param {*} value Value to set
   * @param {Boolean} [silent=false] Set to true to not trigger events. If event is recurring, occurrences won't be updated
   * automatically.
   * @function setAsync
   * @category Editing
   * @async
   */
  //region Fields


  static get fields() {
    return [// TODO: below startDate/endDate/duration fields docs copy-paste should be cleaned up after supporting @localdoc & @inheritdoc combination

    /**
     * The start date of a time span (or Event / Task).
     *
     * Uses {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat} to convert a
     * supplied string to a Date. To specify another format, either change that setting or subclass TimeSpan and
     * change the dateFormat for this field.
     *
     * UI fields representing this data field are disabled for summary tasks. See {@link #function-isEditable} for details.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} startDate
     * @accepts {String|Date}
     * @category Scheduling
     */

    /**
     * The end date of a time span (or Event / Task).
     *
     * Uses {@link Core/helper/DateHelper#property-defaultFormat-static DateHelper.defaultFormat} to convert a
     * supplied string to a Date. To specify another format, either change that setting or subclass TimeSpan and
     * change the dateFormat for this field.
     *
     * UI fields representing this data field are disabled for summary tasks. See {@link #function-isEditable} for details.
     *
     * Note that the field always returns a `Date`.
     *
     * @field {Date} endDate
     * @accepts {String|Date}
     * @category Scheduling
     */

    /**
     * The numeric part of the timespan's duration (the number of units).
     *
     * UI fields representing this data field are disabled for summary tasks. See {@link #function-isEditable} for details.
     *
     * @field {Number} duration
     * @category Scheduling
     */

    /**
     * Property which encapsulates the duration's magnitude and units.
     * @member {Core.data.Duration} fullDuration
     */

    /**
     * The unique identifier of a task (mandatory)
     * @field {String|Number} id
     * @category Common
     */

    /**
     * Id of the resource this event is associated with (only usable for single assignments). We recommend
     * using assignments in an AssignmentStore over this approach. Internally any Event using `resourceId`
     * will have an assignment in AssignmentStore generated.
     * @field {String|Number} resourceId
     * @category Common
     */
    {
      name: 'resourceId',
      internal: true
    },
    /**
     * The array of {@link Scheduler.model.ResourceModel resources} which are assigned to this event.
     * @field {String|Number} resources
     * @category Common
     */
    {
      name: 'resources',
      column: {
        type: 'resourceassignment'
      },
      persist: false,
      internal: true // TODO: remove this when resourcecolumn is in Scheduler

    },
    /**
     * Specify false to prevent the event from being dragged (if EventDrag feature is used)
     * @field {Boolean} draggable
     * @default true
     * @category Interaction
     */
    {
      name: 'draggable',
      type: 'boolean',
      persist: false,
      defaultValue: true,
      internal: true
    },
    /**
     * Specify `false` to prevent the event from being resized (if EventResize feature is used). You can also
     * specify `'start'` or `'end'` to only allow resizing in one direction
     * @field {Boolean|String} resizable
     * @default true
     * @category Interaction
     */
    {
      name: 'resizable',
      persist: false,
      defaultValue: true,
      internal: true
    }, // true, false, 'start' or 'end'

    /**
     * A field marking event as all day(s) spanning event.
     * For example, a holiday day may be represented by a `startDate`, and the `allDay` flag.
     * @field {Boolean} allDay
     * @category Scheduling
     */
    {
      name: 'allDay',
      type: 'boolean',
      defaultValue: false
    },
    /**
     * Controls this events appearance, see Schedulers
     * {@link Scheduler.view.mixin.TimelineEventRendering#config-eventStyle eventStyle config} for
     * available options.
     * @field {String} eventStyle
     * @category Styling
     */
    {
      name: 'eventStyle',
      internal: true
    },
    /**
     * Controls the primary color of the event, see Schedulers
     * {@link Scheduler.view.mixin.TimelineEventRendering#config-eventColor eventColor config} for
     * available colors.
     * @field {String} eventColor
     * @category Styling
     */
    {
      name: 'eventColor',
      internal: true
    },
    /**
     * Width (in px) to use for this milestone when using Scheduler#milestoneLayoutMode 'data'.
     * @field {Number} milestoneWidth
     * @category Styling
     */
    {
      name: 'milestoneWidth',
      internal: true
    }, {
      name: '$highlight',
      persist: false,
      internal: true
    },
    /**
     * Set this field to false to opt out of {@link Scheduler.feature.StickyEvents sticky event content}
     * (keeping event text in view while scrolling).
     * @field {Boolean} stickyContents
     * @category Styling
     */
    {
      name: 'stickyContents',
      internal: true
    }];
  } //endregion
  //region Id change


  updateAssignmentEventIds() {
    this.assigned.forEach(assignment => {
      assignment.eventId = this.id;
    });
  }

  syncId(value) {
    super.syncId(value);
    this.updateAssignmentEventIds();
  } //endregion
  //region Resources

  /**
   * Returns all resources assigned to an event.
   *
   * @property {Scheduler.model.ResourceModel[]}
   * @readonly
   */


  get resources() {
    // Only include valid resources, to not have nulls in the result
    return this.assignments.reduce((resources, assignment) => {
      assignment.resource && resources.push(assignment.resource);
      return resources;
    }, []);
  }

  set resources(resources) {
    if (!Array.isArray(resources)) {
      resources = [resources];
    }

    const me = this,
          newResourceIds = resources.map(me.constructor.asId),
          existingResourceIds = me.assignments.map(a => a.resource.id),
          {
      onlyInA: toAdd,
      onlyInB: toRemove
    } = _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].delta(newResourceIds, existingResourceIds); // Add first, remove after. Otherwise event might get removed with its last assignment

    me.assignmentStore.add(toAdd.map(resourceId => ({
      resource: resourceId,
      event: me
    })));
    me.assignmentStore.remove(toRemove.map(resourceId => me.assignments.find(a => a.resource.id === resourceId)));
  }
  /**
   * Iterate over all associated resources
   * @private
   */


  forEachResource(fn, thisObj = this) {
    for (const resource of this.resources) {
      if (fn.call(thisObj, resource) === false) return;
    }
  }
  /**
   * Returns either the resource associated with this event (when called w/o `resourceId`) or resource
   * with specified id.
   *
   * @param {String} [resourceId] To retrieve a specific resource
   * @return {Scheduler.model.ResourceModel}
   */


  getResource(resourceId) {
    if (resourceId == null) {
      return this.resource;
    }

    return this.resourceStore ? this.resourceStore.getById(resourceId) : null;
  } //endregion
  //region Dates


  get startDate() {
    let dt;

    if (this.isOccurrence) {
      dt = this.get('startDate');
    } else {
      var _this$_startDate;

      // Micro optimization to avoid expensive super call. super will be hit in Scheduler Pro
      dt = (_this$_startDate = this._startDate) !== null && _this$_startDate !== void 0 ? _this$_startDate : super.startDate;
    }

    if (this.allDay) {
      dt = this.constructor.getAllDayStartDate(dt);
    }

    return dt;
  }

  set startDate(startDate) {
    if (this.batching) {
      this._startDate = startDate;
      this.set({
        startDate
      });
    } else {
      super.startDate = startDate;
    }
  }

  get endDate() {
    let dt;

    if (this.isOccurrence) {
      dt = this.get('endDate');
    } else {
      var _this$_endDate;

      // Micro optimization to avoid expensive super call. super will be hit in Scheduler Pro
      dt = (_this$_endDate = this._endDate) !== null && _this$_endDate !== void 0 ? _this$_endDate : super.endDate;
    }

    if (this.allDay) {
      dt = this.constructor.getAllDayEndDate(dt);
    }

    return dt;
  }

  set endDate(endDate) {
    if (this.batching) {
      this._endDate = endDate;
      this.set({
        endDate
      });
    } else {
      super.endDate = endDate;
    }
  }
  /**
   * Shift the dates for the date range by the passed amount and unit
   * @param {String} unit The unit to shift by, see {@link Core.helper.DateHelper} for more information on valid formats.
   * @param {Number} amount The amount to shift
   * @returns {Promise} A promise which is resolved when shift calculations are done
   * @async
   * @method shift
   */
  //endregion
  //region Is
  // Used internally to differentiate between Event and ResourceTimeRange


  get isEvent() {
    return true;
  }
  /**
   * Returns true if event can be drag and dropped
   * @property {Boolean}
   */


  get isDraggable() {
    return this.draggable;
  }
  /**
   * Returns true if event can be resized, but can additionally return 'start' or 'end' indicating how this event can be resized.
   * @property {Boolean|String}
   * @readonly
   */


  get isResizable() {
    return !this.isMilestone && this.resizable;
  }
  /**
   * Returns false if the event is not persistable. By default it always is, override this getter if you need
   * custom logic.
   *
   * @property {Boolean}
   * @readonly
   */


  get isPersistable() {
    // Records not yet fully created cannot be persisted
    return super.isPersistable && !this.meta.isCreating;
  }

  endBatch() {
    const {
      isPersistable: wasPersistable,
      meta: {
        batchChanges
      }
    } = this; // Remove cached values
    // https://github.com/bryntum/support/issues/3358

    if (batchChanges) {
      if ('endDate' in batchChanges) {
        delete this._endDate;
      }

      if ('startDate' in batchChanges) {
        delete this._startDate;
      }
    }

    super.endBatch(...arguments); // If this event newly persistable, its assignments are eligible for syncing.

    if (this.isPersistable && !wasPersistable) {
      this.assignments.forEach(assignment => {
        assignment.stores.forEach(s => {
          s.updateModifiedBagForRecord(assignment);
        });
      });
    }
  }

  get isCreating() {
    return super.isCreating;
  }

  set isCreating(value) {
    super.isCreating = value;
    this.assignments.forEach(record => record.isCreating = value);
  } //endregion
  //region Single assignment compatibility


  get usesSingleAssignment() {
    return !this.eventStore || this.eventStore.usesSingleAssignment;
  }
  /**
   * Override persistable getter to prevent sending resourceId when using multiple resource assignment mode
   * https://github.com/bryntum/support/issues/1345
   * @private
   */


  get persistableData() {
    const data = super.persistableData;

    if (!this.usesSingleAssignment) {
      delete data.resourceId;
    }

    return data;
  }
  /**
   * Returns the first assigned resource, or assigns a resource
   * @member {Scheduler.model.ResourceModel} resource
   */


  get resource() {
    const {
      resources
    } = this;
    return resources.length ? resources[0] : null;
  }

  set resource(resourceRecord) {
    // Use the resourceId setter for single assignment
    this.resourceId = this.constructor.asId(resourceRecord);
  }

  get resourceId() {
    var _this$resource;

    return this.usesSingleAssignment ? this.get('resourceId') : (_this$resource = this.resource) === null || _this$resource === void 0 ? void 0 : _this$resource.id;
  }

  set resourceId(resourceId) {
    this.applyResourceId(resourceId);
  }

  applyResourceId(resourceId, fromApplyValue = false) {
    const me = this,
          {
      assignments,
      assignmentStore,
      eventStore
    } = me; // When part of an EventStore, resourceIds are changed to be AssignmentModels

    if (eventStore) {
      if (resourceId != null) {
        if (!me.skipEnforcingSingleAssignment) {
          eventStore.usesSingleAssignment = true;
        } // Reassign if already assigned, only single assignment allowed


        if (assignments !== null && assignments !== void 0 && assignments.length && resourceId !== assignments[0].resourceId) {
          //assignments[0].set('resourceId', resourceId, Boolean(me.eventStore.eventsSuspended));
          // Silent reassign if events are suspended on event store, wont be expecting UI update then
          const eventsSuspended = Boolean(eventStore.eventsSuspended);
          eventsSuspended && assignmentStore.suspendEvents();
          assignments[0].resource = resourceId;
          eventsSuspended && assignmentStore.resumeEvents();
        } // Otherwise assign
        else {
          assignmentStore.assignEventToResource(me, resourceId);
        }
      } else {
        // Setting resourceId to null removes all assignments
        assignmentStore.remove(me.assignments);
      }
    } // Not part of an EventStore, edge case. Set to data unless we are in such operation already
    else if (!fromApplyValue) {
      me.set({
        resourceId
      });
    }
  } // Special handling of setting resourceId, creates assignment


  applyValue(useProp, mapping, value, skipAccessors, field) {
    if (field && field.name === 'resourceId' && !this.meta.isAssigning) {
      const {
        eventStore
      } = this;
      eventStore && (eventStore.isAssigning = true);
      this.applyResourceId(value, true);
      eventStore && (eventStore.isAssigning = false);
    }

    super.applyValue(useProp, mapping, value, skipAccessors, field);
  } //endregion
  //region Assignment

  /**
   * Returns all assignments for the event. Event must be part of the store for this method to work.
   * @property {Scheduler.model.AssignmentModel[]}
   * @readonly
   */


  get assignments() {
    return [...(this.assigned || [])];
  }
  /**
   * Assigns this event to the specified resource.
   *
   * *Note:* The event must be part of an EventStore for this to work. If the EventStore uses single assignment
   * (loaded using resourceId) existing assignments will always be removed.
   *
   * @param {Scheduler.model.ResourceModel|String|Number|Scheduler.model.ResourceModel[]|String[]|Number[]} resource A new resource for this event, either as a full
   *        Resource record or an id (or an array of such).
   * @param {Boolean} [removeExistingAssignments] `true` to first remove existing assignments
   */


  assign(resource, removeExistingAssignments = false) {
    const {
      eventStore
    } = this;

    if (eventStore && !eventStore.usesSingleAssignment) {
      eventStore.assignEventToResource(this, resource, removeExistingAssignments);
    } else {
      // Remember what resource to assign,  directly in single assignment mode or for later when we are joined to
      // an EventStore
      this.resourceId = this.constructor.asId(resource);

      if (!eventStore) {
        // Prevent flagging EventStore as using single assignment when that happens, we cannot know that here
        this.meta.skipEnforcingSingleAssignment = true;
      }
    }
  }
  /**
   * Unassigns this event from the specified resource
   *
   * @param {Scheduler.model.ResourceModel|String|Number} [resource] The resource to unassign from.
   */


  unassign(resource, removingResource = false) {
    var _me$eventStore;

    const me = this;
    resource = me.constructor.asId(resource); // If unassigned is caused by removing the resource the UI should be able to find out to not do extra redraws etc.

    me.meta.removingResource = removingResource;
    (_me$eventStore = me.eventStore) === null || _me$eventStore === void 0 ? void 0 : _me$eventStore.unassignEventFromResource(me, resource);
    me.meta.removingResource = null;
  }
  /**
   * Reassigns an event from an old resource to a new resource
   *
   * @param {Scheduler.model.ResourceModel|String|Number} oldResourceId A resource to unassign from or its id
   * @param {Scheduler.model.ResourceModel|String|Number} newResourceId A resource to assign to or its id
   */


  reassign(oldResourceId, newResourceId) {
    this.eventStore && this.eventStore.reassignEventFromResourceToResource(this, oldResourceId, newResourceId);
  }
  /**
   * Returns true if this event is assigned to a certain resource.
   *
   * @param {Scheduler.model.ResourceModel|String|Number} resource The resource to query for
   * @return {Boolean}
   */


  isAssignedTo(resource) {
    const resourceId = this.constructor.asId(resource);
    return this.assignments.some(assignment => assignment.resourceId === resourceId);
  } //endregion
  //region Dependencies

  /**
   * Returns all predecessor dependencies of this event
   *
   * @readonly
   * @property {Scheduler.model.DependencyBaseModel[]}
   */


  get predecessors() {
    return [...this.incomingDeps];
  }
  /**
   * Returns all successor dependencies of this event
   *
   * @readonly
   * @property {Scheduler.model.DependencyBaseModel[]}
   */


  get successors() {
    return [...this.outgoingDeps];
  }

  get dependencies() {
    return [...this.incomingDeps, ...this.outgoingDeps];
  } //endregion


  normalize() {// Normalization handled by SchedulingEngine
  }

  inSetNormalize() {// Normalization handled by SchedulingEngine
  }
  /**
   * The "main" event this model is an occurrence of.
   * Returns `null` for non-occurrences.
   * @property {Scheduler.model.EventModel}
   * @alias #Scheduler.model.mixin.RecurringTimeSpan#property-recurringTimeSpan
   * @readonly
   */


  get recurringEvent() {
    return this.recurringTimeSpan;
  }
  /**
   * Flag which indicates that this event is an interday event. This means that it spans
   * an entire day or multiple days.
   *
   * This is essentially used by the Calendar package to determine if an event should
   * go into the all day zone of a DayView.
   *
   * @property {Boolean}
   * @readonly
   */


  get isInterDay() {
    const {
      durationMS
    } = this; // A full day (86400000 or more) marks as it as interDay,
    // which means it belongs in the all day row of a Calendar DayView

    if (durationMS >= oneDayMS) {
      return true;
    } // Working out whether it crosses midnight is a little more difficult


    const {
      endDate,
      startDate
    } = this,
          eventStartMidnight = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(startDate); // If either is null or NaN, we have to answer falsy

    if (startDate && endDate) {
      eventStartMidnight.setDate(eventStartMidnight.getDate() + 1); // If the endDate is past midnight, it's interDay and goes in the all day row of a Calendar DayView

      return (endDate || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(startDate, durationMS)) > eventStartMidnight;
    }
  } //region All day statics


  static getAllDayStartDate(dt) {
    if (dt && dt.isEvent) {
      dt = dt.get('startDate');
    }

    if (dt) {
      dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(dt, true);
    }

    return dt;
  }

  static getAllDayEndDate(dt) {
    if (dt && dt.isEvent) {
      dt = dt.get('endDate');
    }

    if (dt && (dt.getHours() > 0 || dt.getMinutes() > 0 || dt.getSeconds() > 0 || dt.getMilliseconds() > 0)) {
      dt = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].getNext(dt, 'd', 1);
    }

    return dt;
  }

  static getAllDayDisplayStartDate(dt) {
    if (dt && dt.isEvent) {
      dt = dt.get('startDate');
    }

    return _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(dt, true);
  }

  static getAllDayDisplayEndDate(startDate, endDate) {
    if (startDate && startDate.isEvent) {
      endDate = startDate.get('endDate');
      startDate = startDate.get('startDate');
    }

    if (endDate) {
      startDate = this.constructor.getAllDayDisplayStartDate(startDate); // If date falls on start of the day - subtract one day to show end date correctly
      // e.g. event starts on 2017-01-01 00:00 and ends on 2017-01-02 00:00, editor should show
      // 2017-01-01 for both start and end

      if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(endDate, true).valueOf() === endDate.valueOf()) {
        endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].add(endDate, _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].DAY, -1);
      } else if (startDate.valueOf() !== endDate.valueOf()) {
        endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clearTime(endDate, true);
      }
    }

    return endDate;
  }
  /**
   * Defines if the given event field should be manually editable in UI.
   * You can override this method to provide your own logic.
   *
   * By default the method defines {@link #field-endDate}, {@link #field-duration} and {@link #property-fullDuration} fields
   * editable for leaf events only (in case the event is part of a tree store) and all other fields as editable.
   *
   * @param {String} fieldName Name of the field
   * @returns {Boolean} Returns `true` if the field is editable, `false` if it is not and `undefined` if the event has no such field.
   */


  isEditable(fieldName) {
    switch (fieldName) {
      // end/duration is allowed to edit for leafs
      case 'endDate':
      case 'duration':
      case 'fullDuration':
        return this.isLeaf;
    }

    return super.isEditable(fieldName);
  } //endregion


});

/***/ }),

/***/ "./lib/Scheduler/model/mixin/ProjectModelMixin.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/model/mixin/ProjectModelMixin.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony import */ var _EventModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../EventModel.js */ "./lib/Scheduler/model/EventModel.js");
/* harmony import */ var _DependencyModel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../DependencyModel.js */ "./lib/Scheduler/model/DependencyModel.js");
/* harmony import */ var _ResourceModel_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../ResourceModel.js */ "./lib/Scheduler/model/ResourceModel.js");
/* harmony import */ var _AssignmentModel_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../AssignmentModel.js */ "./lib/Scheduler/model/AssignmentModel.js");
/* harmony import */ var _ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../ResourceTimeRangeModel.js */ "./lib/Scheduler/model/ResourceTimeRangeModel.js");
/* harmony import */ var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _data_EventStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../data/EventStore.js */ "./lib/Scheduler/data/EventStore.js");
/* harmony import */ var _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../data/DependencyStore.js */ "./lib/Scheduler/data/DependencyStore.js");
/* harmony import */ var _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../data/ResourceStore.js */ "./lib/Scheduler/data/ResourceStore.js");
/* harmony import */ var _data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../data/AssignmentStore.js */ "./lib/Scheduler/data/AssignmentStore.js");
/* harmony import */ var _data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../data/ResourceTimeRangeStore.js */ "./lib/Scheduler/data/ResourceTimeRangeStore.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';














/**
 * @module Scheduler/model/mixin/ProjectModelMixin
 */

/**
 * Mixin that holds configuration shared between projects in Scheduler and Scheduler Pro.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class ProjectModelMixin extends (Target || _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'ProjectModelMixin';
  } //region Config


  static get defaultConfig() {
    return {
      /**
       * Configuration options to provide to the STM manager
       *
       * @config {Object|Core.data.stm.StateTrackingManager}
       * @category Advanced
       */
      stm: {},

      /**
       * The constructor of the event model class, to be used in the project. Will be set as the
       * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-eventStore}
       *
       * @config {Scheduler.model.EventModel}
       * @typings {typeof EventModel}
       * @category Models & Stores
       */
      eventModelClass: _EventModel_js__WEBPACK_IMPORTED_MODULE_1__["default"],

      /**
       * The constructor of the dependency model class, to be used in the project. Will be set as the
       * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-dependencyStore}
       *
       * @config {Scheduler.model.DependencyModel}
       * @typings {typeof DependencyModel}
       * @category Models & Stores
       */
      dependencyModelClass: _DependencyModel_js__WEBPACK_IMPORTED_MODULE_2__["default"],
      timeRangeModelClass: _TimeSpan_js__WEBPACK_IMPORTED_MODULE_6__["default"],
      resourceTimeRangeModelClass: _ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_5__["default"],

      /**
       * The constructor of the resource model class, to be used in the project. Will be set as the
       * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-resourceStore}
       *
       * @config {Scheduler.model.ResourceModel}
       * @typings {typeof ResourceModel}
       * @category Models & Stores
       */
      resourceModelClass: _ResourceModel_js__WEBPACK_IMPORTED_MODULE_3__["default"],

      /**
       * The constructor of the assignment model class, to be used in the project. Will be set as the
       * {@link Core.data.Store#config-modelClass modelClass} property of the {@link #property-assignmentStore}
       *
       * @config {Scheduler.model.AssignmentModel}
       * @typings {typeof AssignmentModel}
       * @category Models & Stores
       */
      assignmentModelClass: _AssignmentModel_js__WEBPACK_IMPORTED_MODULE_4__["default"],

      /**
       * The constructor to create an event store instance with. Should be a class, subclassing the
       * {@link Scheduler.data.EventStore}
       * @config {Scheduler.data.EventStore|Object}
       * @typings {typeof EventStore|object}
       * @category Models & Stores
       */
      eventStoreClass: _data_EventStore_js__WEBPACK_IMPORTED_MODULE_9__["default"],

      /**
       * The constructor to create a dependency store instance with. Should be a class, subclassing the
       * {@link Scheduler.data.DependencyStore}
       * @config {Scheduler.data.DependencyStore|Object}
       * @typings {typeof DependencyStore|object}
       * @category Models & Stores
       */
      dependencyStoreClass: _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_10__["default"],

      /**
       * The constructor to create a resource store instance with. Should be a class, subclassing the
       * {@link Scheduler.data.ResourceStore}
       * @config {Scheduler.data.ResourceStore|Object}
       * @typings {typeof ResourceStore|object}
       * @category Models & Stores
       */
      resourceStoreClass: _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_11__["default"],

      /**
       * The constructor to create an assignment store instance with. Should be a class, subclassing the
       * {@link Scheduler.data.AssignmentStore}
       * @config {Scheduler.data.AssignmentStore|Object}
       * @typings {typeof AssignmentStore|object}
       * @category Models & Stores
       */
      assignmentStoreClass: _data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_12__["default"],

      /**
       * The constructor to create a time range store instance with. Should be a class subclassing the {@link Core.data.Store}
       * @config {Core.data.Store|Object}
       * @typings {typeof Store|object}
       * @category Models & Stores
       */
      timeRangeStoreClass: _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_7__["default"],

      /**
       * The constructor to create a resource time range store instance with. Should be a class subclassing the {@link Scheduler.data.ResourceTimeRangeStore}
       * @config {Scheduler.data.ResourceTimeRangeStore|Object}
       * @typings {typeof ResourceTimeRangeStore|object}
       * @category Models & Stores
       */
      resourceTimeRangeStoreClass: _data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_13__["default"],

      /**
       * The initial data, to fill the {@link #property-eventStore eventStore} with.
       * Should be an array of {@link Scheduler.model.EventModel EventModels} or it's configuration objects.
       *
       * @config {Scheduler.model.EventModel[]} eventsData
       * @category Inline data
       */

      /**
       * The initial data, to fill the {@link #property-dependencyStore dependencyStore} with.
       * Should be an array of {@link Scheduler.model.DependencyModel DependencyModels} or it's configuration
       * objects.
       *
       * @config {Scheduler.model.DependencyModel[]} [dependenciesData]
       * @category Inline data
       */

      /**
       * The initial data, to fill the {@link #property-resourceStore resourceStore} with.
       * Should be an array of {@link Scheduler.model.ResourceModel ResourceModels} or it's configuration objects.
       *
       * @config {Scheduler.model.ResourceModel[]} [resourcesData]
       * @category Inline data
       */

      /**
       * The initial data, to fill the {@link #property-assignmentStore assignmentStore} with.
       * Should be an array of {@link Scheduler.model.AssignmentModel AssignmentModels} or it's configuration objects.
       *
       * @config {Scheduler.model.AssignmentModel[]} [assignmentsData]
       * @category Inline data
       */

      /**
       * The initial data, to fill the {@link #property-timeRangeStore timeRangeStore} with.
       * Should be an array of {@link Scheduler.model.TimeSpan TimeSpan} or it's configuration objects.
       *
       * @config {Scheduler.model.TimeSpan[]} [timeRangesData]
       * @category Inline data
       */

      /**
       * The initial data, to fill the {@link #property-resourceTimeRangeStore resourceTimeRangeStore} with.
       * Should be an array of {@link Scheduler.model.ResourceTimeRangeModel ResourceTimeRangeModel} or it's configuration objects.
       *
       * @config {Scheduler.model.ResourceTimeRangeModel[]} [resourceTimeRangesData]
       * @category Inline data
       */
      eventStore: {},
      assignmentStore: {},
      dependencyStore: {},
      resourceStore: {},
      timeRangesData: null
    };
  }

  static get configurable() {
    return {
      /**
       * Project data as a JSON string, used to populate its stores.
       *
       * ```javascript
       * const project = new ProjectModel({
       *     json : '{"eventsData":[...],"resourcesData":[...],...}'
       * }
       * ```
       *
       * @config {String}
       */
      json: null,
      timeRangeStore: {
        value: {},
        $config: 'nullify'
      },
      resourceTimeRangeStore: {
        value: {},
        $config: 'nullify'
      }
    };
  } //endregion
  //region Properties

  /**
   * State tracking manager instance the project relies on
   * @member {Core.data.stm.StateTrackingManager} stm
   */

  /**
   * The {@link Scheduler.data.EventStore store} holding the events information.
   *
   * See also {@link Scheduler.model.EventModel}
   *
   * @member {Scheduler.data.EventStore} eventStore
   * @category Models & Stores
   */

  /**
   * An {@link Scheduler.data.EventStore} instance or a config object.
   * @config {Scheduler.data.EventStore|Object} eventStore
   * @category Models & Stores
   */

  /**
   * The {@link Scheduler.data.DependencyStore store} holding the dependencies information.
   *
   * See also {@link Scheduler.model.DependencyModel}
   *
   * @member {Scheduler.data.DependencyStore} dependencyStore
   * @category Models & Stores
   */

  /**
   * A {@link Scheduler.data.DependencyStore} instance or a config object.
   * @config {Scheduler.data.DependencyStore|Object} dependencyStore
   * @category Models & Stores
   */

  /**
   * The {@link Scheduler.data.ResourceStore store} holding the resources that can be assigned to the events in the event store.
   *
   * See also {@link Scheduler.model.ResourceModel}
   *
   * @member {Scheduler.data.ResourceStore} resourceStore
   * @category Models & Stores
   */

  /**
   * A {@link Scheduler.data.ResourceStore} instance or a config object.
   * @config {Scheduler.data.ResourceStore|Object} resourceStore
   * @category Models & Stores
   */

  /**
   * The {@link Scheduler.data.AssignmentStore store} holding the assignments information.
   *
   * See also {@link Scheduler.model.AssignmentModel}
   *
   * @member {Scheduler.data.AssignmentStore} assignmentStore
   * @category Models & Stores
   */

  /**
   * A {@link Scheduler.data.AssignmentStore} instance or a config object.
   * @config {Scheduler.data.AssignmentStore|Object} assignmentStore
   * @category Models & Stores
   */

  /**
   * Returns current Project changes as an object consisting of added/modified/removed arrays of records for every
   * managed store. Returns `null` if no changes exist. Format:
   *
   * ```javascript
   * {
   *     resources : {
   *         added    : [{ name : 'New guy' }],
   *         modified : [{ id : 2, name : 'Mike' }],
   *         removed  : [{ id : 3 }]
   *     },
   *     events : {
   *         modified : [{  id : 12, name : 'Cool task' }]
   *     },
   *     ...
   * }
   * ```
   *
   * @member {Object} changes
   * @readonly
   * @category Models & Stores
   */

  /**
   * The {@link Core.data.Store store} holding the time ranges information.
   *
   * See also {@link Scheduler.model.TimeSpan}
   *
   * @member {Core.data.Store} timeRangeStore
   * @category Models & Stores
   */

  /**
   * A {@link Core.data.Store} instance or a config object.
   * @config {Core.data.Store|Object} timeRangeStore
   * @category Models & Stores
   */

  /**
   * The {@link Scheduler.data.ResourceTimeRangeStore store} holding the resource time ranges information.
   *
   * See also {@link Scheduler.model.ResourceTimeRangeModel}
   *
   * @member {Scheduler.data.ResourceTimeRangeStore} resourceTimeRangeStore
   * @category Models & Stores
   */

  /**
   * A {@link Scheduler.data.ResourceTimeRangeStore} instance or a config object.
   * @config {Scheduler.data.ResourceTimeRangeStore|Object} resourceTimeRangeStore
   * @category Models & Stores
   */

  /**
   * Get or set data of project stores. The returned data is identical to what
   * {@link #function-toJSON} returns:
   *
   * ```javascript
   *
   * const data = scheduler.project.inlineData;
   *
   * // data:
   * {
   *     eventsData             : [...],
   *     resourcesData          : [...],
   *     dependenciesData       : [...],
   *     assignmentsData        : [...],
   *     resourceTimeRangesData : [...],
   *     timeRangesData         : [...]
   * }
   *
   *
   * // Plug it back in later
   * scheduler.project.inlineData = data;
   * ```
   *
   * @property {Object}
   */


  get inlineData() {
    return _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].safeJsonParse(super.json);
  }

  set inlineData(inlineData) {
    this.json = inlineData;
  } //endregion
  //region Functions

  /**
   * Accepts a "data package" consisting of data for the projects stores, which is then loaded into the stores.
   *
   * The package can hold data for `EventStore`, `AssignmentStore`, `ResourceStore`, `DependencyStore`,
   * `TimeRangeStore` and `ResourceTimeRangeStore`. It uses the same format as when creating a project with inline
   * data:
   *
   * ```javascript
   * await project.loadInlineData({
   *     eventsData             : [...],
   *     resourcesData          : [...],
   *     assignmentsData        : [...],
   *     dependenciesData       : [...],
   *     resourceTimeRangesData : [...],
   *     timeRangesData         : [...]
   * });
   * ```
   *
   * After populating the stores it commits the project, starting its calculations. By awaiting `loadInlineData()` you
   * can be sure that project calculations are finished.
   *
   * @function loadInlineData
   * @param {Object} dataPackage A data package as described above
   * @fires load
   * @async
   */

  /**
   * Project changes (CRUD operations to records in its stores) are automatically committed on a buffer to the
   * underlying graph based calculation engine. The engine performs it calculations async.
   *
   * By calling this function, the commit happens right away. And by awaiting it you are sure that project
   * calculations are finished and that references between records are up to date.
   *
   * The returned promise is resolved with an object. If that object has `rejectedWith` set, there has been a conflict and the calculation failed.
   *
   * ```javascript
   * // Move an event in time
   * eventStore.first.shift(1);
   *
   * // Trigger calculations directly and wait for them to finish
   * const result = await project.commitAsync();
   *
   * if (result.rejectedWith) {
   *     // there was a conflict during the scheduling
   * }
   * ```
   *
   * @async
   * @returns {Promise}
   * @function commitAsync
   */
  //endregion
  //region Init


  construct(config = {}) {
    super.construct(...arguments); // These stores are not handled by engine, but still held on project

    const me = this;

    if (config.timeRangesData) {
      me.timeRangeStore.data = config.timeRangesData;
    }

    if (config.resourceTimeRangesData) {
      me.resourceTimeRangeStore.data = config.resourceTimeRangesData;
    }
  }

  afterConstruct() {
    super.afterConstruct();
    const me = this;
    !me.timeRangeStore.stm && me.stm.addStore(me.timeRangeStore);
    !me.resourceTimeRangeStore.stm && me.stm.addStore(me.resourceTimeRangeStore);
  } //endregion
  //region Attaching stores
  // Attach to a store, relaying its change events


  attachStore(store) {
    store === null || store === void 0 ? void 0 : store.on({
      name: store.$$name,
      change: 'relayStoreChange',
      thisObj: this
    });
  } // Detach a store, stop relaying its change events


  detachStore(store) {
    store && this.detachListeners(store.$$name);
  }

  relayStoreChange(event) {
    /**
     * Fired when data in any of the projects stores changes.
     *
     * Basically a relayed version of each stores own change event, decorated with which store it originates from.
     * See the {@link Core.data.Store#event-change store change event} documentation for more information.
     *
     * @event change
     * @param {Scheduler.model.ProjectModel} source This project
     * @param {Core.data.Store} store Affected store
     * @param {String} action Name of action which triggered the change. May be one of:
     * * `'remove'`
     * * `'removeAll'`
     * * `'add'`
     * * `'updatemultiple'`
     * * `'clearchanges'`
     * * `'filter'`
     * * `'update'`
     * * `'dataset'`
     * * `'replace'`
     * @param {Core.data.Model} record Changed record, for actions that affects exactly one record (`'update'`)
     * @param {Core.data.Model[]} records Changed records, passed for all actions except `'removeAll'`
     * @param {Object} changes Passed for the `'update'` action, info on which record fields changed
     */
    return this.trigger('change', _objectSpread(_objectSpread({
      store: event.source
    }, event), {}, {
      source: this
    }));
  }

  updateTimeRangeStore(store, oldStore) {
    this.detachStore(oldStore);
    this.attachStore(store);
  }

  setTimeRangeStore(store) {
    this.timeRangeStore = store;
  }

  changeTimeRangeStore(store) {
    // If it's not being nullified, upgrade a config object to be a full store
    if (store && !store.isStore) {
      store = this.timeRangeStoreClass.new({
        modelClass: this.timeRangeModelClass,
        storeId: 'timeRanges'
      }, store);
    }

    return store;
  }

  updateResourceTimeRangeStore(store, oldStore) {
    this.detachStore(oldStore);
    this.attachStore(store);
  }

  changeResourceTimeRangeStore(store) {
    // If it's not being nullified, upgrade a config object to be a full store
    if (store && !store.isStore) {
      store = this.resourceTimeRangeStoreClass.new({
        modelClass: this.resourceTimeRangeModelClass,
        storeId: 'resourceTimeRanges'
      }, store);
    }

    return store;
  }

  setResourceTimeRangeStore(store) {
    this.resourceTimeRangeStore = store;
  } //endregion
  //region Inline data


  async loadInlineData(data) {
    // Flag reset in super
    this.isLoadingInlineData = true; // Stores not handled by engine

    if (data.resourceTimeRangesData) {
      this.resourceTimeRangeStore.data = data.resourceTimeRangesData;
    }

    if (data.timeRangesData) {
      this.timeRangeStore.data = data.timeRangesData;
    }

    return super.loadInlineData(data);
  } //endregion
  //region JSON

  /**
   * Returns the data from the records of the projects stores, in a format that can be consumed by `loadInlineData()`.
   *
   * Used by JSON.stringify to correctly convert this record to json.
   *
   *
   * ```javascript
   * const project = new ProjectModel({
   *     eventsData             : [...],
   *     resourcesData          : [...],
   *     assignmentsData        : [...],
   *     dependenciesData       : [...],
   *     resourceTimeRangesData : [...],
   *     timeRangesData         : [...]
   * });
   *
   * const json = project.toJSON();
   *
   * // json:
   * {
   *     eventsData             : [...],
   *     resourcesData          : [...],
   *     dependenciesData       : [...],
   *     assignmentsData        : [...],
   *     resourceTimeRangesData : [...],
   *     timeRangesData         : [...]
   * }
   * ```
   *
   * Output can be consumed by `loadInlineData()`:
   *
   * ```javascript
   * const json = project.toJSON();
   *
   * // Plug it back in later
   * project.loadInlineData(json);
   * ```
   *
   * @returns {Object}
   * @category JSON
   */


  toJSON() {
    const me = this,
          result = {
      eventsData: me.eventStore.toJSON(),
      resourcesData: me.resourceStore.toJSON(),
      dependenciesData: me.dependencyStore.toJSON(),
      timeRangesData: me.timeRangeStore.toJSON(),
      resourceTimeRangesData: me.resourceTimeRangeStore.toJSON()
    };

    if (!me.eventStore.usesSingleAssignment) {
      result.assignmentsData = me.assignmentStore.toJSON();
    }

    return result;
  }
  /**
   * Get or set project data (records from its stores) as a JSON string.
   *
   * Get a JSON string:
   *
   * ```javascript
   * const project = new ProjectModel({
   *     eventsData             : [...],
   *     resourcesData          : [...],
   *     assignmentsData        : [...],
   *     dependenciesData       : [...],
   *     resourceTimeRangesData : [...],
   *     timeRangesData         : [...]
   * });
   *
   * const jsonString = project.json;
   *
   * // jsonString:
   * '{"eventsData":[...],"resourcesData":[...],...}'
   * ```
   *
   * Set a JSON string (to populate the project stores):
   *
   * ```javascript
   * project.json = '{"eventsData":[...],"resourcesData":[...],...}'
   * ```
   *
   * @property {String}
   */


  get json() {
    return super.json;
  }

  changeJson(json) {
    if (typeof json === 'string') {
      json = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].safeJsonParse(json);
    }

    return json;
  }

  updateJson(json) {
    json && this.loadInlineData(json);
  } //endregion


  afterChange(toSet, wasSet) {
    super.afterChange(...arguments);

    if (wasSet.calendar) {
      this.trigger('calendarChange');
    }
  }

  doDestroy() {
    this.timeRangeStore.destroy();
    this.resourceTimeRangeStore.destroy();
    super.doDestroy();
  }

});

/***/ }),

/***/ "./lib/Scheduler/model/mixin/RecurringTimeSpan.js":
/*!********************************************************!*\
  !*** ./lib/Scheduler/model/mixin/RecurringTimeSpan.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony import */ var _RecurrenceModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../RecurrenceModel.js */ "./lib/Scheduler/model/RecurrenceModel.js");
/* harmony import */ var _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony import */ var _data_util_recurrence_AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../data/util/recurrence/AbstractRecurrenceIterator.js */ "./lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js");
var productName = 'taskboard';





function convertExceptionDatesValue(value) {
  const result = {},
        {
    dateFormat
  } = this;

  if (value) {
    value = typeof value == 'string' ? value.split(',') : Array.isArray(value) ? value : [value];
    value.forEach(item => {
      if (typeof item == 'string') {
        item = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parse(item, dateFormat);
      } // If we've got a valid date out of the incoming item, add an exception key


      if (!isNaN(item)) {
        result[_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(item)] = 1;
      }
    });
  }

  return result;
}

function serializeExceptionDatesValue(value) {
  const result = [],
        {
    dateFormat
  } = this;

  for (const date in value) {
    if (value[date]) {
      result.push(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].format(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseKey(date), dateFormat));
    }
  }

  return result;
}

const emptyArray = [];
/**
 * @module Scheduler/model/mixin/RecurringTimeSpan
 */

/**
 * This mixin class provides recurrence related fields and methods to a {@link Scheduler.model.TimeSpan timespan model}.
 *
 * The mixin introduces two types of timespans: __recurring timespan__ and its __occurrences__.
 * __Recurring timespan__ is a timespan having {@link #field-recurrenceRule recurrence rule} specified and its __occurrences__ are "fake" dynamically generated timespans.
 * Their set depends on the scheduler visible timespan and changes upon the timespan change.
 *
 * There are few methods allowing to distinguish a recurring event and an occurrence: {@link #property-isRecurring}, {@link #property-isOccurrence}
 * and {@link #property-recurringTimeSpan} (returns the event this record is an occurrence of).
 *
 * The {@link #field-recurrenceRule recurrence rule} defined for the event is parsed and
 * represented with {@link Scheduler.model.RecurrenceModel RecurrenceModel} class (can be changed by setting {@link #property-recurrenceModel} property) instance.
 * See: {@link #property-recurrence} property.
 * @mixin
 * @mixinbase TimeSpan
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class RecurringTimeSpan extends (Target || _TimeSpan_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
  static get $name() {
    return 'RecurringTimeSpan';
  }
  /**
   * Returns `true` if this timespan supports recurring.
   * @property {Boolean}
   */


  get supportsRecurring() {
    return true;
  }

  static get fields() {
    return [
    /**
     * The timespan recurrence rule. A string in [RFC-5545](https://tools.ietf.org/html/rfc5545#section-3.3.10) described format ("RRULE" expression).
     * @field {String} recurrenceRule
     * @category Scheduling
     */
    {
      name: 'recurrenceRule',
      internal: true
    },
    /**
     * A string (either a single date or multiple dates separated by comma) or an array of strings containing the timespan exception dates. The dates that must be skipped when generating occurrences for a repeating timespan.
     * This is used to modify only individual occurrences of the timespan so the further regenerations
     * won't create another copy of this occurrence again.
     *
     * ```javascript
     * {
     *     id: 7,
     *     startDate: '2021-10-12T14:00:00',
     *     endDate: '2021-10-12T15:00:00',
     *     name: 'Lunch',
     *     resourceId: 'hotel',
     *     recurrenceRule: 'FREQ=DAILY;COUNT=5',
     *     exceptionDates: ['2021-10-14']
     * }
     * ```
     *
     * Use {@link #function-addExceptionDate} method to add an individual entry to the dates array:
     *
     * ```javascript
     * // Break the link between the occurrence and its base.
     * // This also adds the occurrence date as an exception date
     * // so that the base timespan knows that this date should be skipped when regenerating its occurrences.
     * occurrence.recurringTimeSpan = null;
     *
     * // now the occurrence is an individual record that can be changed & persisted freely
     * occurrence.setStartEndDate(new Date(2018, 6, 2), new Date(2018, 6, 3));
     * ```
     * **Note:** The dates in this field get automatically removed when the event changes its {@link Scheduler.model.TimeSpan#field-startDate start date}.
     *
     * @field {String|String[]} exceptionDates
     * @category Scheduling
     */
    {
      name: 'exceptionDates',
      convert: convertExceptionDatesValue,
      serialize: serializeExceptionDatesValue,
      internal: true
    }];
  }
  /**
   * Override of {@link Core/data/Model}'s method. If an {@link #property-isOccurrence}
   * is passed, it is detached from its parent recurring event. If it still has a recurrence
   * then the recurring event is changed to stop at the occurrence date. If it has no recurrence
   * an exception is added at the occurrence date.
   */


  remove() {
    if (this.isOccurrence) {
      const me = this,
            {
        recurringTimeSpan
      } = me;
      me.cancelBatch();
      recurringTimeSpan.beginBatch();
      me.detachFromRecurringEvent();
      recurringTimeSpan.endBatch();
    } else {
      return super.remove(...arguments);
    }
  }

  get eventStore() {
    var _this$firstStore;

    let result = this.isOccurrence ? this.recurringEvent.eventStore : super.eventStore; // Recurrence methods are called on `eventStore`, but in case we have a regular
    // store with recurrence mixin, we won't event store and should return own
    // store instead

    if (!result && (_this$firstStore = this.firstStore) !== null && _this$firstStore !== void 0 && _this$firstStore.isRecurringTimeSpansMixin) {
      result = this.firstStore;
    }

    return result;
  }
  /**
   * Name of the class representing the recurrence model, defaults to {@link Scheduler.model.RecurrenceModel}
   * @property {String}
   */


  get recurrenceModel() {
    return this._recurrenceModel || _RecurrenceModel_js__WEBPACK_IMPORTED_MODULE_1__["default"];
  }

  set recurrenceModel(model) {
    this._recurrenceModel = model;
  }
  /**
   * Sets a recurrence for the timespan with a given frequency, interval, and end.
   * @param {Object|String|Scheduler.model.RecurrenceModel} recurrence A data object for an instance of {@link Scheduler.model.RecurrenceModel RecurrenceModel}.
   * May also be the frequency string: `DAILY`, `WEEKLY`, `MONTHLY`, or `YEARLY`.
   *
   * ```javascript
   * // repeat the event every other week till Jan 2 2039
   * event.setRecurrence({
   *     frequency : "WEEKLY",
   *     interval  : 2,
   *     endDate   : new Date(2039, 0, 2)
   * });
   * ```
   *
   * Also a {@link Scheduler.model.RecurrenceModel recurrence model} can be provided as the only argument for this method:
   *
   * ```javascript
   * const recurrence = new RecurrenceModel({ frequency : 'DAILY', interval : 5 });
   *
   * event.setRecurrence(recurrence);
   * ```
   *
   * or
   *
   * ```javascript
   * event.setRecurrence("WEEKLY", 2, new Date(2039, 0, 2));
   * ```
   * @param {Number} [interval] The interval between occurrences (instances of this recurrence). For example, a daily recurrence with an interval of 2 occurs every other day. Must be greater than 0.
   * @param {Number|Date} [recurrenceEnd] The end of the recurrence. The value can be specified by a date or by a maximum count of occurrences (has to greater than 1, since 1 means the event itself).
   */


  setRecurrence(recurrence, interval, recurrenceEnd) {
    const me = this;
    let recurrenceRule;

    if (recurrence) {
      if (!recurrence.isRecurrenceModel) {
        if (typeof recurrence === 'string') {
          recurrence = {
            frequency: recurrence
          };

          if (interval) {
            recurrence.interval = interval;
          } // If the recurrence is limited


          if (recurrenceEnd) {
            if (recurrenceEnd instanceof Date) {
              recurrence.endDate = recurrenceEnd;
            } else {
              recurrence.count = recurrenceEnd;
            }
          }
        }

        recurrence = new me.recurrenceModel(recurrence);
      } // The RecurrenceModel has a reference to its owning recurring event.
      // It uses this to remove the owning event's exceptions after its new endDate
      // whenever its endDate is changed.


      recurrence.timeSpan = me;
      recurrenceRule = recurrence.rule;
    }

    me.recurrence = recurrence;
    me.recurrenceRule = recurrenceRule;
  }
  /**
   * The recurrence model used for the timespan.
   * @property {Scheduler.model.RecurrenceModel}
   */


  get recurrence() {
    const me = this,
          rule = me.recurrenceRule;

    if (!me._recurrence && rule) {
      me._recurrence = new me.recurrenceModel({
        rule,
        timeSpan: me,
        id: `${me.id}-recurrence`
      });
    }

    return me._recurrence;
  }

  set recurrence(recurrence) {
    const me = this;
    me._recurrence = recurrence;

    if (recurrence) {
      // bind recurrence instance to the model
      recurrence.timeSpan = me;
      me.recurrenceRule = recurrence.rule;
    } else {
      // If this is being done to an occurrence, it's a signal that we are being
      // mutated into an exception. Apply the change immediately, directly to the data.
      if (me.isOccurrence) {
        me.setData('recurrenceRule', null);
      } else {
        me.recurrenceRule = null;
      }
    }
  }
  /**
   * Indicates if the timespan is recurring.
   * @property {Boolean}
   * @readonly
   */


  get isRecurring() {
    // MUST evaluate in this order so that if it is an occurrence,
    // the recurrence getter does not refresh the rule
    return Boolean(!this.isOccurrence && this.recurrence);
  }
  /**
   * Indicates if the timespan is an occurrence of another recurring timespan.
   * @property {Boolean}
   * @readonly
   */


  get isOccurrence() {
    return Boolean(this.recurringTimeSpan);
  }
  /**
   * The "main" timespan this model is an occurrence of. For non-occurrences returns `null`.
   * @property {Scheduler.model.TimeSpan}
   * @readonly
   * @internal
   */


  get recurringTimeSpan() {
    return this._recurringTimeSpan;
  }

  get isPersistable() {
    return super.isPersistable && (!this.supportsRecurring || !this.isOccurrence);
  }

  set recurringTimeSpan(recurringTimeSpan) {
    this._recurringTimeSpan = recurringTimeSpan;
  }
  /**
   * Returns the occurrences of this event over the specified time range. If the first
   * occurrence is in the time range `*this*` record is included in that position.
   * @param {Date} startDate The start date of the range for which to include occurrences.
   * @param {Date} [endDate] The end date of the range for which to include occurrences.
   * Defaults to the startDate.
   * @returns {Scheduler.model.TimeSpan[]} The array of occurrences which occur over the specified range.
   */


  getOccurrencesForDateRange(startDate, endDate = startDate) {
    return this.eventStore.getOccurrencesForTimeSpan(this, startDate, endDate);
  }
  /**
   * Array of this recurring timespan's cached occurrences. __Not including the owning recurring
   * event__.
   *
   * Empty if the timespan is not recurring.
   *
   * __Note that this is an internal accessor and is cleared whenever changes are made to the
   * owning recurring event__.
   * @property {Scheduler.model.TimeSpan[]}
   * @readonly
   * @internal
   */


  get occurrences() {
    if (this.isRecurring) {
      const result = []; // The occurrencesMap contains entries for each occurrence date.

      this.occurrenceMap.forEach(occurrence => {
        if (occurrence !== this) {
          result.push(occurrence);
        }
      });
      return result;
    }

    return emptyArray;
  }
  /**
   * A Map, keyed by each date an occurrence intersects, of occurrences of this event.
   * @property {Map}
   * @readonly
   * @internal
   */


  get occurrenceMap() {
    return this._occurrencesMap || (this._occurrencesMap = new Map());
  }
  /**
   * Removes an occurrence from this recurring timespan's cached occurrences.
   * @param dateOrTimeSpan occurrence date or occurrence TimeSpan
   * @internal
   */


  removeOccurrence(dateOrTimeSpan) {
    var _this$eventStore;

    const date = dateOrTimeSpan.isTimeSpan ? dateOrTimeSpan.occurrenceDate : dateOrTimeSpan; // Clear the occurrences *is* we are in an EventStore.

    (_this$eventStore = this.eventStore) === null || _this$eventStore === void 0 ? void 0 : _this$eventStore.globalOccurrences.delete(this.createRecurrenceKey(date)); // Remove occurrence from its by-startDate cache

    this.occurrenceMap.delete(_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(date));
  }
  /**
   * Removes all cached occurrences on or after the passed date from this recurring timespan's cached occurrences.
   * @internal
   */


  removeOccurrencesFrom(date) {
    this.occurrenceMap.forEach((occurrence, dateKey) => {
      if (_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseKey(dateKey) >= date) {
        this.removeOccurrence(occurrence);
      }
    });
  }
  /**
   * Removes this recurring timespan's cached occurrences.
   * @internal
   */


  removeOccurrences() {
    // This recurring event must also be removed from the occurrenceMap if it's there
    // So insert it as the first element. Can also be found from the store's global occurrence
    // Map using [...this.eventStore.globalOccurrences.keys()].filter(e => e.startsWith(`_generated:${this.id}`))
    [this, ...this.occurrences].forEach(occurrence => this.removeOccurrence(occurrence));
  }
  /**
   * The method is triggered when the timespan recurrence settings get changed.
   * It updates the {@link #field-recurrenceRule} field in this case.
   * @internal
   */


  onRecurrenceChanged() {
    var _this$recurrence;

    this.recurrenceRule = ((_this$recurrence = this.recurrence) === null || _this$recurrence === void 0 ? void 0 : _this$recurrence.rule) || null;
  }

  sanitizeRecurrenceData(recurrence = this.recurrence) {
    // Remove all exceptionsDates that our owning timeSpan had that are
    // now after our end date and therefore redundant.
    if (recurrence.endDate) {
      const endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clearTime(recurrence.endDate),
            {
        exceptionDates
      } = this; // Clear any now-invalid cached occurrences

      this.removeOccurrencesFrom(endDate); // If we had any exceptions on or after this date, remove them.

      if (exceptionDates) {
        for (const dateKey in exceptionDates) {
          const exceptionDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].parseKey(dateKey);

          if (exceptionDate >= endDate) {
            delete exceptionDates[dateKey];
          }
        }
      }
    }
  }
  /**
   * The original {@lScheduler.model.TimeSpan#field-startDate startDate} of this event before any modifications
   * took place. Used by {@link #function-removeOccurrence} and {@link #function-detachFromRecurringEvent}
   * @internal
   * @readonly
   */


  get occurrenceDate() {
    var _this$meta$modified;

    return ((_this$meta$modified = this.meta.modified) === null || _this$meta$modified === void 0 ? void 0 : _this$meta$modified.startDate) || this.startDate;
  }
  /**
   * If this event is an {@link #property-isOccurrence occurrence} of a recurring event, then this
   * property yields its zero-based occurrence index in the sequence.
   * @property {Number}
   * @readonly
   */


  get occurrenceIndex() {
    return _data_util_recurrence_AbstractRecurrenceIterator_js__WEBPACK_IMPORTED_MODULE_3__["default"].getOccurrenceIndex(this);
  }
  /**
   * Builds an occurrence of this recurring event by cloning the timespan data.
   * The method is used internally by the __RecurringTimeSpans__ mixin.
   * Override it if you need to customize the generated occurrences.
   *
   * If the date requested is the start date of the event sequence, `this`
   * record is returned. All runs of recurring events begin with the base record.
   * @param  {Date} occurrenceDate The occurrence start date.
   * @param  {Boolean} isFirst `true` if this is the first occurrence.
   * @return {Scheduler.model.TimeSpan} The occurrence.
   * @internal
   */


  buildOccurrence(occurrenceDate, isFirst) {
    var _me$eventStore;

    const me = this,
          {
      occurrenceMap,
      recurrence,
      meta
    } = me,
          globalOccurrences = (_me$eventStore = me.eventStore) === null || _me$eventStore === void 0 ? void 0 : _me$eventStore.globalOccurrences,
          occurrenceKey = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(occurrenceDate),
          id = me.createRecurrenceKey(occurrenceDate, occurrenceKey),
          onStartDate = !(occurrenceDate - me.startDate),
          {
      fieldMap
    } = me.constructor; // An occurrence has a unique ID which identifies it by its base recurring event and its time.

    let occurrence = globalOccurrences === null || globalOccurrences === void 0 ? void 0 : globalOccurrences.get(id),
        {
      duration
    } = me; // If there's no duration, or it's an all day event (which makes the event ceil and floor its
    // start and end dates, but does *NOT* as of 27/5/2020 adjust its duration) then
    // we calculate the duration of the occurrence.

    if (me.endDate && (me.allDay || !duration)) {
      duration = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].as(me.durationUnit, me.endDate.getTime() - me.startDate.getTime());
    } // Don't let NaN in record data


    const occurrenceEndDate = duration !== undefined ? _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(occurrenceDate, duration, me.durationUnit) : undefined;

    if (!occurrence) {
      // If this is the first occurrence (start times may not match), or it's right on the start
      // then this recurring event *IS* the occurrence
      if (isFirst || onStartDate) {
        occurrence = me; // We are the first occurrence.
        // But if our start time is not as the rule requires, adjust ourself *silently*

        if (!onStartDate) {
          me.setStartEndDate(occurrenceDate, occurrenceEndDate, true); // Since we've changed the event start date the recurrence "Days"/"MonthDays"/"Months"
          // might get redundant in case the event start date matches the fields values
          // Calling recurrence sanitize() will clean the fields in this case.

          recurrence.suspendTimeSpanNotifying();
          recurrence.sanitize();
          recurrence.resumeTimeSpanNotifying();
        } // Either way, because of adjustment above, or initial correctness, we are in sync
        // with our recurrence rule. A RecurrenceIterator is now able to calculate a correct
        // UNTIL date from a COUNT value. See AbstractRecurrenceIterator#processIterationConfig


        meta.isSyncedWithRule = true;
      } // Generate an occurrence which references this as its parent
      else {
        occurrence = me.copy({
          [fieldMap.id.dataSource]: id,
          [fieldMap.startDate.dataSource]: occurrenceDate,
          [fieldMap.endDate.dataSource]: occurrenceEndDate,
          [fieldMap.duration.dataSource]: duration
        });
        occurrence.recurringTimeSpan = me;
      }

      globalOccurrences === null || globalOccurrences === void 0 ? void 0 : globalOccurrences.set(id, occurrence); // A recurring timespan keeps a by-startDate index of occurrences.
      // And itself will be among those.

      occurrenceMap.set(occurrenceKey, occurrence);
    }

    return occurrence;
  }

  createRecurrenceKey(date = this.startDate, dateKey = null) {
    return `_generated:${this.id}:${dateKey || _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(date)}`;
  }

  afterChange(toSet, wasSet, silent, ...args) {
    const me = this,
          {
      eventStore
    } = me; // reset cached recurrence instance in case "recurrenceRule" is changed

    if ('recurrenceRule' in wasSet) {
      me._recurrence = null; // If we are a recurring event, we must be in the recurringEvents cache.
      // If we are *not* a recurring event, we must *not* be in there.
      // An event not yet in a store (eg dragging to create) won't have an eventStore.
      // eslint-disable-next-line no-unused-expressions

      eventStore === null || eventStore === void 0 ? void 0 : eventStore.recurringEvents[wasSet.recurrenceRule.value ? 'add' : 'delete'](me);
    } // Any change to an occurrence adds it to an event store, at which point
    // it ceases to be an occurrence.
    //
    // If it has a recurrenceRule it becomes the start of a new recurring event series,
    // and the old owning recurring event stops on the day before.
    //
    // If it has no recurrenceRule, it becomes an exception to its owning recurring event.


    if (me.isOccurrence) {
      var _wasSet$startDate, _wasSet$resourceRecor;

      const {
        recurringTimeSpan,
        resource,
        occurrenceIndex,
        recurrence
      } = me,
            startDate = ((_wasSet$startDate = wasSet.startDate) === null || _wasSet$startDate === void 0 ? void 0 : _wasSet$startDate.value) || me.startDate,
            count = recurrence && recurringTimeSpan.recurrence.count,
            // resourceRecords is a temporary property of occurrence events to handle cases
      // if only resources has been updated. (change only resources won't mark record as dirty)
      newResource = ((_wasSet$resourceRecor = wasSet.resourceRecords) === null || _wasSet$resourceRecor === void 0 ? void 0 : _wasSet$resourceRecor.value) || me.data.newResource;
      recurringTimeSpan.beginBatch();
      me.detachFromRecurringEvent();
      me.clearChanges(); // Must silently set our own ID, not be the key generated from our parent id and occurrence date.
      // Must not result in the id field being in the modified state.

      me.setData('id', me.generateId(recurringTimeSpan.eventStore));

      if (newResource) {
        // clear resourceId to avoid auto-adding to assignmentStore, it is handled manually bellow
        delete me.data.resourceId;
      } // The impending changes to the former parent recurring event trigger a full refresh.


      recurringTimeSpan.eventStore.add(me, silent);
      me.startDate = startDate; // Ensure that the original count is honoured.
      // If we are the 8th occurrence of 10, OUR repeat count must be 3.

      if (count) {
        me.recurrence.count = count - occurrenceIndex;
      }

      me.assign(newResource || resource); // remove data after apply

      delete me.data.resourceRecords;
      delete wasSet.resourceRecords; // Any change to a recurring events triggers a store refresh event.

      recurringTimeSpan.endBatch();
    } else {
      // Setting a newException date must mark the exceptionDates as modified
      if ('newExceptionDate' in wasSet) {
        me.meta.modified.exceptionDates = true;
        delete me.meta.modified.newExceptionDate; // Remove any occurrence on that date from our by-startDate cache
        // and from the global occurrences cache

        me.removeOccurrence(wasSet.newExceptionDate.value);
      }
    }

    return super.afterChange(toSet, wasSet, silent, ...args);
  }
  /**
   * Detaches an occurrence from its owning recurring event so that it can be added to the eventStore
   * either as an exception, or as the start of a new recurring sequence.
   * @internal
   */


  detachFromRecurringEvent() {
    const me = this,
          // For access further down, breaking the link involves engine if trying to get the occurrenceDate later,
    // resulting in the wrong date
    {
      recurringTimeSpan,
      occurrenceDate,
      startDate
    } = me; // Break the link

    me.recurringTimeSpan = null; // The occurrenceDate is injected into the data when an occurrence is created.
    // the recurringTimeSpan's afterChange will remove any cache occurrence
    // for this date; see above

    recurringTimeSpan.addExceptionDate(occurrenceDate); // If we still have a recurrenceRule, we're being promoted to be a new recurring event.
    // The recurrence setter applies the rule immediately to occurrences, so this will
    // always be correct.

    if (me.recurrenceRule) {
      // The RecurrenceModel removes occurrences and exceptions after this date
      recurringTimeSpan.recurrence.endDate = _Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].add(startDate, -1, 'minute');
    }
  }
  /**
   * The setter used by Model#inSet when {@link #function-addExceptionDate} is called.
   * Adding an exception must trigger change processing in a recurring event, so it must
   * be changed through a {@link Core.data.Model#function-set} call. Also, the change must be batchable
   * with other changes.
   * @private
   * @readonly
   */


  set newExceptionDate(date) {
    if (date) {
      const exceptionDates = this.exceptionDates || (this.exceptionDates = {});
      exceptionDates[_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(date)] = 1;
    }
  }
  /**
   * Adds an exception date that should be skipped when generating occurrences for the timespan.
   * The methods adds an entry to the array kept in {@link #field-exceptionDates} field.
   * @param {Date} date Exception date.
   * @internal
   */


  addExceptionDate(newExceptionDate) {
    return this.set({
      newExceptionDate
    });
  }
  /**
   * Does this recurring event have an exception on the passed date.
   * @param {Date} date The date to find an exception for.
   * @returns {Boolean} `true` if the event has an exception starting on the passed date.
   */


  hasException(date) {
    var _this$exceptionDates;

    return (_this$exceptionDates = this.exceptionDates) === null || _this$exceptionDates === void 0 ? void 0 : _this$exceptionDates[_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].makeKey(date)];
  }

});

/***/ }),

/***/ "./lib/Scheduler/model/mixin/ResourceModelMixin.js":
/*!*********************************************************!*\
  !*** ./lib/Scheduler/model/mixin/ResourceModelMixin.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var productName = 'taskboard';
/**
* @module Scheduler/model/mixin/ResourceModelMixin
*/

/**
 * Mixin that holds configuration shared between resources in Scheduler and Scheduler Pro.
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => class ResourceModelMixin extends Target {
  static get $name() {
    return 'ResourceModelMixin';
  } // Flag checked by ResourceStore to make sure it uses a valid subclass


  static get isResourceModel() {
    return true;
  }
  /**
   * Set value for the specified field(s), triggering engine calculations immediately. See
   * {@link Core.data.Model#function-set Model#set()} for arguments.
   *
   * This does not matter much on the resource itself, but is of importance when manipulating its references:
   *
   * ```javascript
   * assignment.set('resourceId', 2);
   * // resource.assignments is not yet up to date
   *
   * await assignment.setAsync('resourceId', 2);
   * // resource.assignments is up to date
   * ```
   *
   * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
   * @param {*} value Value to set
   * @param {Boolean} [silent=false] Set to true to not trigger events
   * automatically.
   * @function setAsync
   * @category Editing
   * @async
   */
  //region Fields


  static get fields() {
    return [
    /**
     * Unique identifier
     * @field {String|Number} id
     * @category Common
     */

    /**
     * Get or set resource name
     * @field {String} name
     * @category Common
     */
    {
      name: 'name',
      type: 'string',
      persist: true
    },
    /**
     * Controls the primary color used for events assigned to this resource. Can be overridden per event using
     * EventModels {@link Scheduler/model/mixin/EventModelMixin#field-eventColor eventColor config}. See Schedulers
     * {@link Scheduler.view.mixin.TimelineEventRendering#config-eventColor eventColor config} for available
     * colors.
     * @field {String} eventColor
     * @category Styling
     */
    'eventColor',
    /**
     * Controls the style used for events assigned to this resource. Can be overridden per event using
     * EventModels {@link Scheduler/model/mixin/EventModelMixin#field-eventStyle eventStyle config}. See Schedulers
     * {@link Scheduler.view.mixin.TimelineEventRendering#config-eventStyle eventStyle config} for available
     * options.
     * @field {String} eventStyle
     * @category Styling
     */
    'eventStyle',
    /**
     * Fully qualified image URL, used by `ResourceInfoColumn` and vertical modes `ResourceHeader` to display a miniature image
     * for the resource.
     * @field {String} imageUrl
     * @category Styling
     */
    'imageUrl',
    /**
     * Image name relative to {@link Scheduler/view/mixin/SchedulerEventRendering#config-resourceImagePath},
     * used by `ResourceInfoColumn` and vertical modes `ResourceHeader` to display a miniature image
     * for the resource.
     * @field {String} image
     * @category Styling
     */
    'image',
    /**
     * Margin from rows edge to topmost event bar for this resource, in px.
     * @field {Number} resourceMargin
     * @category Layout
     */
    {
      name: 'resourceMargin',
      type: 'number'
    },
    /**
     * Margin between stacked event bars for this resource, in px.
     * @field {Number} barMargin
     * @category Layout
     */
    {
      name: 'barMargin',
      type: 'number'
    },
    /**
     * Base height of this resource, in px. When unset, Schedulers configured rowHeight is used.
     *
     * This value is used in horizontal mode to determine row height. When stacking, it is used as input for
     * calculating the actual row height:
     *
     * ```javascript
     * row.height = (resource.rowHeight - resourceMargin * 2) * overlap count - barMargin * (overlap count - 1)
     * ```
     *
     * When packing or overlapping, it is used as the actual row height.
     *
     * @field {Number} rowHeight
     * @category Layout
     */

    /**
     * Specify this to use a resource specific event layout in horizontal mode, see
     * {@link Scheduler.view.mixin.SchedulerEventRendering#config-eventLayout} for options.
     *
     * When unset (the default) Schedulers setting is used.
     *
     * @field {String} eventLayout
     * @category Layout
     */
    'eventLayout'];
  } //endregion
  //region Id change


  updateAssignmentResourceIds() {
    this.assigned.forEach(assignment => {
      assignment.resourceId = this.id;
    });
  }

  syncId(value) {
    super.syncId(value);
    this.updateAssignmentResourceIds();
  } //endregion
  //region Getters

  /**
   * Get associated events
   *
   * @property {Scheduler.model.EventModel[]}
   * @readonly
   */


  get events() {
    return this.assignments.reduce((events, assignment) => {
      if (assignment.event) {
        events.push(assignment.event);
      }

      return events;
    }, []);
  }
  /**
   * Returns all assignments for the resource
   *
   * @property {Scheduler.model.AssignmentModel[]}
   */


  get assignments() {
    return this.assigned ? [...this.assigned] : [];
  }

  set assignments(assignments) {
    // Engine does not allow assigning to `assigned`, handle it here
    assignments.forEach(assignment => {
      assignment.resource = this;
    });
  }
  /**
   * Returns an array of events, associated with this resource
   *
   * @return {Scheduler.model.EventModel[]}
   */


  getEvents() {
    // TODO: Deprecate in favor of .events
    return this.events;
  }
  /**
   * Returns true if the Resource can be persisted.
   * In a flat store, a resource is always considered persistable. In a tree store, a resource is considered
   * persistable if its parent node is persistable.
   *
   * @property {Boolean}
   * @readonly
   */


  get isPersistable() {
    return super.isPersistable && (!this.parent || this.parent.isPersistable);
  } //endregion

  /**
   * Unassigns this Resource from all its Events
   */


  unassignAll() {
    this.assignments && this.assignmentStore.remove(this.assignments);
  }
  /**
   * Returns the initials (first letter of the first & last space-separated word in the name) or an empty string
   * if this resource has no name. You can override this method in a ResourceModel subclass to provide your own implementation
   *
   * @property {String}
   * @readonly
   */


  get initials() {
    const {
      name = ''
    } = this;

    if (!name) {
      return '';
    }

    const names = name.split(' '),
          firstInitial = names[0][0],
          lastInitial = names.length > 1 ? names[names.length - 1][0] : '';
    return firstInitial + lastInitial;
  }

  isWorkingTime(date) {
    var _this$project;

    const calendar = this.effectiveCalendar || ((_this$project = this.project) === null || _this$project === void 0 ? void 0 : _this$project.calendar);
    return !calendar || calendar.isWorkingTime(date);
  }

});

/***/ }),

/***/ "./lib/Scheduler/widget/ProjectCombo.js":
/*!**********************************************!*\
  !*** ./lib/Scheduler/widget/ProjectCombo.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProjectCombo; });
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
var productName = 'taskboard';

/**
 * @module Scheduler/widget/ProjectCombo
 */

/**
 * Combo that allows picking a dataset to use for a {@link Scheduler.model.ProjectModel}. Each item holds a title and
 * a load url to reconfigure the project with.
 *
 * @extends Core/widget/Combo
 * @classType projectcombo
 */

class ProjectCombo extends _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static get $name() {
    return 'ProjectCombo';
  }

  static get type() {
    return 'projectcombo';
  }

  static get configurable() {
    return {
      /**
       * Project to reconfigure when picking an item.
       * @config {Scheduler.model.ProjectModel}
       * @category Common
       */
      project: null,

      /**
       * Field used as projects title.
       * @config {String}
       * @default
       * @category Common
       */
      displayField: 'title',

      /**
       * Field used as projects load url.
       * @config {String}
       * @default
       * @category Common
       */
      valueField: 'url',
      highlightExternalChange: false,
      editable: false
    };
  }

  updateProject(project) {
    if (project.transport.load.url) {
      this.value = project.transport.load.url;
    }
  }

  onChange({
    value,
    userAction
  }) {
    if (userAction && this.project) {
      this.project.transport.load.url = value;
      this.project.load();
    }
  }

} // Register this widget type with its Factory

ProjectCombo.initClass();
ProjectCombo._$name = 'ProjectCombo';

/***/ }),

/***/ "./lib/TaskBoard/customElements/TaskBoardTag.js":
/*!******************************************************!*\
  !*** ./lib/TaskBoard/customElements/TaskBoardTag.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskBoardTag; });
/* harmony import */ var _view_TaskBoard_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../view/TaskBoard.js */ "./lib/TaskBoard/view/TaskBoard.js");
/* harmony import */ var _Core_customElements_WidgetTag_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/customElements/WidgetTag.js */ "./lib/Core/customElements/WidgetTag.js");
var productName = 'taskboard';

 //TODO: If we want to improve on this, add settings as attributes, replace data-field with field etc.

/**
 * @module TaskBoard/customElements/TaskBoardTag
 */

const keyCaseMap = {
  resourceavatars: 'resourceAvatars',
  taskmenu: 'taskMenu',
  todolist: 'todoList'
};
/**
 * Import this file to be able to use the tag &lt;bryntum-taskboard&gt; to create a taskboard.
 *
 * This is more of a proof of concept than a ready to use class. Example:
 *
 * ```html
 * <bryntum-taskboard data-column-field="status">
 *   <column>todo</column>
 *   <column>doing</column>
 *   <column>done</column>
 *   <data>
 *      <task data-id="1" data-name="Cook Hamburgers" data-status="todo"></task>
 *      <task data-id="2" data-name="Make Pasta" data-status="doing"></task>
 *      <task data-id="3" data-name="Bake Pizza" data-status="done"></task>
 *   </data>
 * </bryntum-taskboard>
 * ```
 *
 * To get styling correct, supply the path to the theme you want to use and to the folder that holds Font Awesome:
 *
 * ```html
 * <bryntum-taskboard stylesheet="resources/taskboard.stockholm.css" fa-path="resources/fonts">
 * </bryntum-taskboard>
 * ```
 *
 * Any entries in the tags dataset (attributes starting with `data-`) will be applied as configs of the TaskBoard:
 *
 * ```html
 * <bryntum-taskboard data-column-field="status">
 * </bryntum-taskboard>
 * ```
 *
 * NOTE: Remember to call {@link #function-destroy} before removing this web component from the DOM to avoid memory
 * leaks.
 *
 * @demo TaskBoard/webcomponents
 * @extends Core/customElements/WidgetTag
 */

class TaskBoardTag extends _Core_customElements_WidgetTag_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  createInstance(config) {
    const columns = [],
          swimlanes = [],
          tasks = [],
          resources = [],
          assignments = [],
          headerItems = {},
          bodyItems = {},
          footerItems = {}; // Create columns, data and configure features

    for (const tag of this.children) {
      switch (tag.tagName) {
        case 'COLUMN':
          {
            columns.push(this.convertDatasetToConfigs(tag.dataset, {
              text: tag.innerHTML
            }));
            break;
          }

        case 'SWIMLANE':
          {
            swimlanes.push(this.convertDatasetToConfigs(tag.dataset, {
              text: tag.innerHTML
            }));
            break;
          }

        case 'DATA':
          {
            Array.from(tag.children || []).forEach(dataNode => {
              const cfg = Object.assign({}, dataNode.dataset);

              switch (dataNode.tagName) {
                case 'TASK':
                  tasks.push(cfg);
                  break;

                case 'RESOURCE':
                  resources.push(cfg);
                  break;

                case 'ASSIGNMENT':
                  assignments.push(cfg);
                  break;

                default:
                  console.warn('Unknown data type: ' + dataNode.tagName);
              }
            });
            break;
          }

        case 'HEADERITEMS':
        case 'BODYITEMS':
        case 'FOOTERITEMS':
          {
            const target = tag.tagName === 'HEADERITEMS' ? headerItems : tag.tagName === 'BODYITEMS' ? bodyItems : footerItems;

            for (const item of tag.children) {
              const itemKey = keyCaseMap[item.tagName.toLowerCase()] || item.tagName.toLowerCase();
              target[itemKey] = this.convertDatasetToConfigs(item.dataset, {});
            }

            break;
          }
      }
    }

    return new _view_TaskBoard_js__WEBPACK_IMPORTED_MODULE_0__["default"](Object.assign(config, {
      columns,
      swimlanes,
      headerItems,
      bodyItems,
      footerItems,
      project: {
        tasksData: tasks,
        resourcesData: resources,
        assignmentsData: assignments
      }
    }));
  }

} // Try-catch to make trial work

try {
  window.customElements && window.customElements.define('bryntum-taskboard', TaskBoardTag);
} catch (error) {}

TaskBoardTag._$name = 'TaskBoardTag';

/***/ }),

/***/ "./lib/TaskBoard/feature/ColumnDrag.js":
/*!*********************************************!*\
  !*** ./lib/TaskBoard/feature/ColumnDrag.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnDrag; });
/* harmony import */ var _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskBoardFeature.js */ "./lib/TaskBoard/feature/TaskBoardFeature.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/mixin/Draggable.js */ "./lib/Core/mixin/Draggable.js");
/* harmony import */ var _Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/mixin/Droppable.js */ "./lib/Core/mixin/Droppable.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';










/**
 * @module TaskBoard/feature/ColumnDrag
 */

/**
 * This feature allows users to drag columns on the TaskBoard to change the column order. Drag is initiated upon
 * mouse down in the column header. Try it out below!
 *
 * {@inlineexample TaskBoard/feature/ColumnDrag.js}
 *
 * Works just as well when using swimlanes:
 *
 * {@inlineexample TaskBoard/feature/ColumnDragSwimlanes.js}
 *
 * ## Drag events
 *
 * The different stages of a drag operation trigger different events, in order of appearance:
 *
 * | Event                           | Description                                                                    |
 * |---------------------------------|--------------------------------------------------------------------------------|
 * | {@link #event-beforeColumnDrag} | Preventable event fired before a drag starts                                   |
 * | {@link #event-columnDragStart}  | Fired when dragging starts                                                     |
 * | {@link #event-columnDrag}       | Fired when movement during a drag will lead to changes                         |
 * | {@link #event-beforeColumnDrop} | Preventable event fired before finalizing a valid drop. Allows async listeners |
 * | {@link #event-columnDrop}       | Fired after finalizing a valid drop                                            |
 * | {@link #event-columnDragAbort}  | Fired when a drag is aborted (ESC, drop out of bounds or by a listener)        |
 * | {@link #event-columnDragEnd}    | Fired when a started drag ends, no matter the outcome                          |
 *
 * This feature is **disabled** by default.
 *
 * @extends TaskBoard/feature/TaskBoardFeature
 * @uninherit Core/Base
 * @uninherit Core/localization/Localizable
 * @classtype columnDrag
 * @feature
 */

class ColumnDrag extends _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  initialCompose() {
    const me = this; // Cannot use configurable since bodyElement is not available yet when feature is pulled in

    me.draggable = ColumnZone.new({
      dragRootElement: me.disabled ? null : me.client.bodyWrapElement,
      dropRootElement: me.client.bodyWrapElement,
      owner: me,
      listeners: {
        beforeDragStart: 'onBeforeDragStart',
        dragStart: 'onDragStart',
        thisObj: me
      }
    }, me.draggable);
  }

  doDisable(disable) {
    super.doDisable(disable);

    if (this.draggable) {
      this.draggable.dragRootElement = disable ? null : this.client.bodyWrapElement;
    }
  }

  populateColumnHeaderMenu({
    items,
    columnRecord
  }) {
    const {
      client
    } = this,
          {
      columns
    } = client;

    if (!client.readOnly) {
      items.moveColumnLeft = {
        text: 'L{TaskBoard.moveColumnLeft}',
        icon: 'b-fw-icon b-icon-left',
        disabled: columnRecord === columns.first,
        weight: 200,

        onItem() {
          columns.move(columnRecord, columns.getPrev(columnRecord));
        }

      };
      items.moveColumnRight = {
        text: 'L{TaskBoard.moveColumnRight}',
        icon: 'b-fw-icon b-icon-right',
        disabled: columnRecord === columns.last,
        weight: 300,

        onItem() {
          const beforeIndex = Math.min(columns.indexOf(columnRecord) + 2, columns.count);
          columns.move(columnRecord, columns.getAt(beforeIndex));
        }

      };
    }
  }

  onBeforeDragStart({
    drag,
    event
  }) {
    /**
     * Fires on the owning TaskBoard before column dragging starts. Return `false` to prevent the action
     * @event beforeColumnDrag
     * @preventable
     * @on-owner
     * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
     * @param {TaskBoard.model.ColumnModel} columnRecord Column to be dragged
     */
    return this.client.trigger('beforeColumnDrag', {
      drag,
      event,
      columnRecord: drag.columnRecord
    });
  }

  onDragStart({
    drag,
    event
  }) {
    /**
     * Fires on the owning TaskBoard when column dragging starts
     * @event columnDragStart
     * @on-owner
     * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
     * @param {TaskBoard.model.ColumnModel} columnRecord Column to be dragged
     */
    return this.client.trigger('columnDragStart', {
      drag,
      event,
      columnRecord: drag.columnRecord
    });
  }

}

_defineProperty(ColumnDrag, "$name", 'ColumnDrag');

_defineProperty(ColumnDrag, "type", 'columnDrag');

_defineProperty(ColumnDrag, "pluginConfig", {
  after: ['initialCompose', 'populateColumnHeaderMenu']
});

ColumnDrag.initClass();

class ColumnZone extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_7__["default"], _Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_8__["default"], _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_9__["default"]) {
  static get configurable() {
    return {
      dragSelector: '.b-taskboard-column-header, .b-taskboard-column-header *',
      dragItemSelector: '.b-taskboard-column-header',
      // Column has multiple parts (header + one element per swimlane), going to add cls manually to them
      draggingItemCls: null,
      dragProxy: {
        type: 'default',

        async open(drag) {
          const {
            owner
          } = this,
                {
            itemElement,
            startEvent,
            columnRecord
          } = drag,
                taskBoard = owner.owner.client,
                headerBounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(itemElement, owner.dragRootElement),
                // Offset from cursor
          proxyOffset = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].getClientPoint(startEvent).getDelta(headerBounds),
                // Drag proxy, positioned over column being dragged
          proxy = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement({
            className: 'b-taskboard-column-drag-proxy',
            parent: owner.dragRootElement,
            style: {
              // Using fixed top, only draggable horizontally
              top: headerBounds.y,
              // Offset from cursor to be positioned over original column
              left: _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].getClientPoint(startEvent).translate(proxyOffset[0], 0).x,
              // Need a fixed width on the proxy, since columns width might be flexed etc
              width: itemElement.getBoundingClientRect().width
            },
            // Dont want it being removed while dragging
            retainElement: true
          }),
                // A column consists of multiple elements, a header and one "column" per swimlane (at least one)
          elements = [itemElement, ...taskBoard.getColumnElements(columnRecord)]; // Things we want to access later on drag

          Object.assign(drag, {
            proxy,
            elements,
            proxyOffset
          }); // Clone all dragged column elements and put them in the proxy

          elements.forEach((element, i) => {
            const columnClone = element.cloneNode(true),
                  bounds = element.getBoundingClientRect(); // Store size, used to size drop indicator later

            element.originalWidth = bounds.width;
            element.originalHeight = bounds.height; // Mimic element structure, swimlane > column (not fully mimicking it for now, should suffice)

            if (element.matches('.b-taskboard-column')) {
              const swimlane = element.closest('.b-taskboard-swimlane'),
                    header = _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__["default"].getChild(swimlane, 'header'),
                    body = _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__["default"].getChild(swimlane, 'body'),
                    swimlaneClone = swimlane.cloneNode(),
                    headerClone = header === null || header === void 0 ? void 0 : header.cloneNode(true),
                    bodyClone = body.cloneNode();
              let height = swimlane.getBoundingClientRect().height; // Last swimlane has bottom padding that we do not want in proxy

              if (i === elements.length - 1) {
                const paddingBottom = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getStyleValue(element.parentElement, 'padding-bottom');
                height -= parseFloat(paddingBottom);
              } // Use fixed height on the swimlanes in the drag proxy, to have it exactly match the board.
              // Otherwise it would shrinkwrap


              swimlaneClone.style.flex = `0 0 ${height}px`;
              headerClone && swimlaneClone.appendChild(headerClone);
              bodyClone.appendChild(columnClone);
              swimlaneClone.appendChild(bodyClone);
              proxy.appendChild(swimlaneClone);
            } // Column header
            else {
              proxy.appendChild(columnClone);
            } // Hide original column after measuring it above


            element.classList.add('b-drag-original');
          });
        },

        dragMove({
          proxy,
          event,
          proxyOffset
        }) {
          // Move along x-axis only
          const position = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].getClientPoint(event).translate(proxyOffset[0], 0);
          proxy.style.left = `${position.x}px`;
        }

      }
    };
  }

  setupDragContext(event) {
    const result = super.setupDragContext(event),
          {
      client
    } = this.owner;
    result.scrollManager = client.scrollManager;
    result.monitoringConfig = {
      scrollables: [{
        element: client.bodyElement,
        direction: 'horizontal'
      }]
    };
    return result;
  } // Populate the drag context early, to have something to take decisions on in beforeDragStart listeners


  startDrag(drag) {
    drag.columnRecord = this.owner.client.resolveColumnRecord(drag.itemElement);
    return super.startDrag(drag);
  }

  dragStart(drag) {
    // Even though the size of other columns should not be affected, we might decide to animate in the future.
    // Suspending responsiveness to not have it kick in if we do...
    this.owner.client.suspendResponsiveness();
    drag.wasStarted = true;
  }

  dragEnter(drag) {
    // Only accept columns
    if (!drag.itemElement.matches(this.dragItemSelector)) {
      return false;
    } // Create drop indicators on first enter


    if (!drag.dropIndicators) {
      // Need one indicator for each part of the column
      drag.dropIndicators = drag.elements.map((element, i) => _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement({
        className: 'b-taskboard-column-drop-indicator',
        elementData: {
          dropIndicator: true,
          // Tag along the element, to be able to return the drop indicator to its position for
          // invalid drop targets. NOTE: Currently not used
          element
        },
        // Use same size as dragged column had originally
        style: {
          width: element.originalWidth,
          height: element.originalHeight
        }
      }));
      this.insertDropIndicators(drag, drag.columnRecord);
    }
  }

  insertDropIndicators(drag, beforeColumnRecord) {
    // Figure out insertion index among headers, will use same index within swimlanes
    const {
      client
    } = this.owner,
          insertAt = client.columns.indexOf(beforeColumnRecord); // Insert all drop indicators

    drag.dropIndicators.forEach((dropIndicator, i) => {
      // Header
      if (i === 0) {
        // Insert at correct place among column headers
        const headerContainer = _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__["default"].getChild(client.bodyElement, 'header'),
              actualHeaders = [...headerContainer.children];
        _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].remove(actualHeaders, dropIndicator);
        headerContainer.insertBefore(dropIndicator, actualHeaders[insertAt]);
      } // Column
      else {
        var _client$swimlanes$get, _client$swimlanes;

        // Insert it at correct place within corresponding swimlane
        const // Get corresponding swimlane (default if swimlanes not used)
        swimlaneRecord = (_client$swimlanes$get = (_client$swimlanes = client.swimlanes) === null || _client$swimlanes === void 0 ? void 0 : _client$swimlanes.getAt(i - 1)) !== null && _client$swimlanes$get !== void 0 ? _client$swimlanes$get : {
          id: 'default'
        },
              // no-sanity
        swimlaneBody = _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_4__["default"].getChild(client.getSwimlaneElement(swimlaneRecord), 'body'),
              actualColumns = [...swimlaneBody.children];
        _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].remove(actualColumns, dropIndicator);
        swimlaneBody.insertBefore(dropIndicator, actualColumns[insertAt]);
      }
    });
  }

  updateValidity(drag, valid) {
    drag.proxy.classList.toggle('b-invalid', !valid);
    drag.dropIndicators.forEach(dropIndicator => dropIndicator.classList.toggle('b-invalid', !valid));
    drag.invalid = !valid;
  }

  dragMove(drag) {
    var _overElement$elementD;

    const {
      client
    } = this.owner,
          documentRoot = client.documentRoot,
          proxyBounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(drag.proxy, undefined, true),
          // Check element under proxy top center, should get a column header (or a gap)
    overElement = documentRoot.elementFromPoint(proxyBounds.center.x, proxyBounds.y),
          columnHeaderElement = overElement === null || overElement === void 0 ? void 0 : overElement.closest('.b-taskboard-column-header');

    if (drag.invalid) {
      drag.valid = false;
    } // If we are over the drop indicator or something not a column header, we do nothing


    if (!(overElement !== null && overElement !== void 0 && (_overElement$elementD = overElement.elementData) !== null && _overElement$elementD !== void 0 && _overElement$elementD.dropIndicator) && columnHeaderElement) {
      const targetBounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(columnHeaderElement); // Column that we are going to insert the dragged column before or after

      let beforeColumn = client.resolveColumnRecord(columnHeaderElement); // If beyond center, insert before next column

      if (proxyBounds.center.x > targetBounds.center.x) {
        beforeColumn = client.columns.getNext(beforeColumn);
      }

      this.insertDropIndicators(drag, beforeColumn); // Only trigger if order will change

      const shouldTrigger = drag.beforeColumn !== beforeColumn;
      drag.beforeColumn = beforeColumn;

      if (shouldTrigger) {
        /**
         * Fires on the owning TaskBoard when a column is dragged, if the drag leads to a change compared to
         * the last columnDrag event.
         *
         * Returning `false` from a listener will flag the drag as invalid (by default turning the drop
         * indicator red)
         *
         * ```javascript
         * const taskBoard = new TaskBoard({
         *    listeners : {
         *        // Do not allow moving beyond last column
         *        columnDrag({ columnRecord, beforeColumn }) {
         *           return beforeColumn === null;
         *        }
         *    }
         * });
         * ```
         *
         * @event columnDrag
         * @on-owner
         * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
         * @param {TaskBoard.model.ColumnModel} columnRecord Column being dragged
         * @param {TaskBoard.model.ColumnModel} beforeColumn Insert before this column on drop, `null` if last
         */
        const result = client.trigger('columnDrag', {
          drag,
          columnRecord: drag.columnRecord,
          beforeColumn
        });
        this.updateValidity(drag, result !== false);
      }
    }
  }

  async dragDrop(drag) {
    // Data part
    const {
      client
    } = this.owner,
          {
      columns
    } = client,
          {
      columnRecord,
      beforeColumn,
      elements,
      dropIndicators,
      proxy
    } = drag;
    /**
     * Fires on the owning TaskBoard when dropping a column, before the operation completes. Handles async
     * listeners, returning `false` from one will abort the operation
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *    listeners : {
     *        async beforeColumnDrop({ columnRecord, beforeColumn }) {
     *            // Show confirmation dialog
     *            const result = await MessageDialog.confirm({
     *                title   : 'Verify drop',
     *                message : `Please confirm moving ${columnRecord.text} before ${beforeColumn.text}?`
     *            });
     *
     *            // Returning false will abort the drop (if user pressed Cancel)
     *            return result === MessageDialog.okButton;
     *        }
     *    }
     * });
     * ```
     *
     * @event beforeColumnDrop
     * @preventable
     * @async
     * @on-owner
     * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
     * @param {TaskBoard.model.ColumnModel} columnRecord Dropped column
     * @param {TaskBoard.model.ColumnModel} beforeColumn Dropped before this column
     */

    if (drag.invalid || (await client.trigger('beforeColumnDrop', {
      drag,
      columnRecord,
      beforeColumn
    })) === false) {
      drag.valid = false;
    } else {
      drag.finalizer = new Promise(resolve => {
        function commit() {
          // Remove proxy & dropIndicator
          proxy.remove();
          dropIndicators.forEach(dropIndicator => dropIndicator.remove()); // Restore original elements

          elements.forEach(element => element.classList.remove('b-drag-original')); // Update data

          client.suspendDomTransition();
          beforeColumn !== undefined && columns.move(columnRecord, beforeColumn);
          client.resumeDomTransition();
          /**
           * Fires on the owning TaskBoard when a column is successfully dropped (after the drop transition
           * has finished)
           * @event columnDrop
           * @on-owner
           * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
           * @param {TaskBoard.model.ColumnModel} columnRecord Dropped column
           * @param {TaskBoard.model.ColumnModel} beforeColumn Dropped before this column (`null` if last)
           * @param {TaskBoard.model.SwimlaneModel} targetSwimlane Dropped in this swimlane (if used)
           */

          client.trigger('columnDrop', {
            drag,
            columnRecord,
            beforeColumn
          });
          /**
           * Fires on the owning TaskBoard when a previously started drag operation ends, no matter the
           * outcome of it (whether valid, invalid or aborted)
           *
           * @event columnDragEnd
           * @on-owner
           * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
           * @param {TaskBoard.model.ColumnModel} columnRecord Affected column
           */

          client.trigger('columnDragEnd', {
            drag,
            columnRecord,
            beforeColumn
          });
          client.resumeResponsiveness();
          resolve();
        } // UI part
        // We are dropping, this cls by default has a transition


        proxy.classList.add('b-dropping'); // Move proxy to drop location, allowing it to transition there

        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].alignTo(proxy, _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(dropIndicators[0], undefined, true)); // Update record after the transition, to prevent too early redraw (which would ruin the transition)

        if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getPropertyTransitionDuration(proxy, 'transform')) {
          _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].onTransitionEnd({
            element: proxy,
            property: 'transform',
            handler: commit,
            thisObj: client
          });
        } // Or right away if no transition is used
        else {
          commit();
        }
      });
    }
  }

  dragLeave(drag) {// Doing nothing feels ok for now
  }

  doAbort(drag) {
    const {
      client
    } = this.owner,
          {
      dropIndicators,
      proxy,
      columnRecord,
      elements
    } = drag;

    if (proxy) {
      function finalizeAbort() {
        // Remove proxy & dropIndicator
        proxy.remove();
        dropIndicators.forEach(dropIndicator => dropIndicator.remove()); // Restore original elements

        elements.forEach(element => element.classList.remove('b-drag-original'));
        client.trigger('columnDragAbortFinalized');
      } // Emulate a drop on abort, to get transitions


      proxy.classList.add('b-dropping'); // Move drop indicators to where column originated

      dropIndicators.forEach((dropIndicator, i) => {
        const original = drag.elements[i];
        dropIndicator.classList.remove('b-invalid'); // Looks better if not invalid on return to origin

        original.parentElement.insertBefore(dropIndicator, original);
      }); // Move proxy to original location, allowing it to transition there

      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].alignTo(proxy, _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"].from(dropIndicators[0], undefined, true)); // Finalize after transition

      if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getPropertyTransitionDuration(proxy, 'transform')) {
        _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].onTransitionEnd({
          element: proxy,
          property: 'transform',
          handler: finalizeAbort,
          thisObj: client // For timer cleanup

        });
      } // Or right away if no transition is used
      else {
        finalizeAbort();
      }
    }
    /**
     * Fires on the owning TaskBoard when a drag operation is aborted (invalid drop or aborted using ESC)
     *
     * @event columnDragAbort
     * @on-owner
     * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
     * @param {TaskBoard.model.ColumnModel} columnRecord Dragged column
     */


    client.trigger('columnDragAbort', {
      drag,
      columnRecord
    });

    if (drag.wasStarted) {
      // Documented in dragDrop()
      client.trigger('columnDragEnd', {
        drag,
        columnRecord
      });
    }
  }

  dragEnd(drag) {
    // Move back to original location when drag was aborted
    if (!drag.valid || drag.aborted) {
      this.doAbort(drag);
    }
  }

}

ColumnDrag._$name = 'ColumnDrag';

/***/ }),

/***/ "./lib/TaskBoard/feature/ColumnHeaderMenu.js":
/*!***************************************************!*\
  !*** ./lib/TaskBoard/feature/ColumnHeaderMenu.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnHeaderMenu; });
/* harmony import */ var _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskBoardFeature.js */ "./lib/TaskBoard/feature/TaskBoardFeature.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/feature/base/ContextMenuBase.js */ "./lib/Core/feature/base/ContextMenuBase.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



/**
 * @module TaskBoard/feature/ColumnHeaderMenu
 */

/**
 * Adds a menu button (`···`) to column headers, clicking it displays a menu. Items are populated by other features
 * and/or application code.
 *
 * {@inlineexample TaskBoard/feature/ColumnHeaderMenu.js}
 *
 * ## Default items
 *
 * These are the default items provided by TaskBoard features:
 *
 * | Reference         | Weight | Feature                              | Description                   |
 * |-------------------|--------|--------------------------------------|-------------------------------|
 * | `addTask `        | 100    | *This feature*                       | Add a new task to this column |
 * | `moveColumnLeft`  | 200    | {@link TaskBoard.feature.ColumnDrag} | Move column one step left     |
 * | `moveColumnRight` | 300    | {@link TaskBoard.feature.ColumnDrag} | Move column one step right    |
 *
 * Default items in the menu can be changed or removed and new items can be added. This is handled using the
 * {@link #config-items} config of the feature.
 *
 * ## Add items
 *
 * Add menu items for all column headers by adding a key (used as menu item {@link Core/widget/Widget#config-ref}) with
 * a {@link Core/widget/MenuItem#configs config object for a menu item} as the value to the {@link #config-items} config:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     features : {
 *         columnHeaderMenu : {
 *             items : {
 *                 flagTasks : {
 *                     text : 'Flag task',
 *                     icon : 'b-fa-fw b-fa-flag',
 *                     onItem({ columnRecord }) {
 *                         columnRecord.tasks.forEach(taskRecord => taskRecord.flagged = true);
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * {@inlineexample TaskBoard/feature/ColumnHeaderMenuAdd.js}
 *
 * ## Remove items
 *
 * To remove default items, configure them as `null` in the {@link #config-items} config:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     features : {
 *         columnHeaderMenu : {
 *             items : {
 *                 moveColumnLeft  : null,
 *                 moveColumnRight : null
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * {@inlineexample TaskBoard/feature/ColumnHeaderMenuRemove.js}
 *
 * ## Customize items
 *
 * To customize default items, supply a new config object for them in the {@link #config-items} config. It will merge
 * with the default config object:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     features : {
 *         columnHeaderMenu : {
 *             items : {
 *                 // Change the text of the "Add new task" item
 *                 addTask : {
 *                     text : 'New card'
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * {@inlineexample TaskBoard/feature/ColumnHeaderMenuCustomize.js}
 *
 * ## Manipulating items at runtime
 *
 * Manipulate items for all columns or specific columns at runtime by supplying a {@link #config-processItems} function:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     features : {
 *         columnHeaderMenu : {
 *             // Process items before menu is shown
 *             processItems({ columnRecord, items }) {
 *                  // Push an extra item for the done column
 *                  if (columnRecord.id === 'done') {
 *                      items.archive = {
 *                          text : 'Archive',
 *                          icon : 'b-fa-fw b-fa-archive',
 *                          onItem({ columnRecord }) {
 *                              columnRecord.tasks.forEach(taskRecord => taskRecord.archived = true);
 *                          }
 *                      };
 *                  }
 *
 *                  // Do not show "Add new task" for the todo column
 *                  if (columnRecord.id === 'todo') {
 *                      items.addTask = null;
 *                  }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * {@inlineexample TaskBoard/feature/ColumnHeaderMenuProcessItems.js}
 *
 * This feature is **enabled** by default.
 *
 * @extends TaskBoard/feature/TaskBoardFeature
 * @uninherit Core/Base
 * @uninherit Core/localization/Localizable
 * @classtype columnHeaderMenu
 * @feature
 */

class ColumnHeaderMenu extends _Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_2__["default"] {
  static get pluginConfig() {
    const config = super.pluginConfig;
    config.chain.push(...['populateColumnHeaderMenu', 'populateColumnHeader', 'onColumnHeaderClick']);
    return config;
  } //region Events

  /**
   * This event fires on the owning TaskBoard before the menu is shown for a column header.
   * Allows manipulation of the items to show in the same way as in the {@link #config-processItems}.
   *
   * Returning `false` from a listener prevents the menu from being shown.
   *
   * @event columnHeaderMenuBeforeShow
   * @on-owner
   * @preventable
   * @param {TaskBoard.view.TaskBoard} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} items Menu item configs
   * @param {TaskBoard.model.ColumnModel} columnRecord The column
   * @on-owner
   */

  /**
   * This event fires on the owning TaskBoard after the context menu is shown for a column header.
   * @event cellMenuShow
   * @on-owner
   * @param {TaskBoard.view.TaskBoard} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} items Menu item configs
   * @param {TaskBoard.model.ColumnModel} columnRecord The column
   * @on-owner
   */

  /**
   * This event fires on the owning TaskBoard when an item is selected in the column header menu.
   * @event cellMenuItem
   * @on-owner
   * @param {TaskBoard.view.TaskBoard} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Core.widget.MenuItem} item Selected menu item
   * @param {TaskBoard.model.ColumnModel} columnRecord The column
   * @on-owner
   */

  /**
   * This event fires on the owning TaskBoard when a check item is toggled in the column header menu.
   * @event cellMenuToggleItem
   * @on-owner
   * @param {TaskBoard.view.TaskBoard} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Core.widget.MenuItem} item Selected menu item
   * @param {TaskBoard.model.ColumnModel} columnRecord The column
   * @param {Boolean} checked Checked or not
   * @on-owner
   */
  //endregion
  //region Type assertions


  changeItems(items) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertObject(items, 'features.columnHeaderMenu.items');
    return items;
  }

  changeProcessItems(fn) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertFunction(fn, 'features.columnHeaderMenu.processItems');
    return fn;
  } //endregion
  // Inject a "button" into column headers


  populateColumnHeader({
    columnRecord,
    columnHeaderConfig
  }) {
    if (!this.disabled) {
      columnHeaderConfig.children.padder.children.menu = {
        tag: 'i',
        class: 'b-column-header-button b-fw-icon b-icon-menu-horizontal'
      };
    }
  } // Populate menu events with taskboard specifics


  getDataFromEvent(event) {
    return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign(super.getDataFromEvent(event), event.taskBoardData);
  } // Add default menu items


  populateColumnHeaderMenu({
    items,
    columnRecord
  }) {
    const {
      client
    } = this;

    if (!client.readOnly) {
      items.addTask = {
        text: 'L{TaskBoard.addTask}',
        icon: 'b-fw-icon b-icon-add',
        weight: 100,

        onItem() {
          client.addTask(columnRecord);
        }

      };
    }
  } // Detect "button" click


  onColumnHeaderClick(args) {
    const {
      event
    } = args;

    if (event.target.matches('.b-column-header-button')) {
      this.showContextMenu(event, {
        target: event.target,
        align: 't90-b90'
      });
    }
  }

  doDisable(disable) {
    super.doDisable(disable);
    !this.isConfiguring && this.client.recompose();
  }

  get showMenu() {
    return true;
  }

} // Register this feature type with its Factory

_defineProperty(ColumnHeaderMenu, "$name", 'ColumnHeaderMenu');

_defineProperty(ColumnHeaderMenu, "type", 'columnHeaderMenu');

_defineProperty(ColumnHeaderMenu, "configurable", {
  /**
   * A function called before displaying the menu that allows manipulations of its items.
   * Returning `false` from this function prevents the menu from being shown.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *   features         : {
   *       columnHeaderMenu : {
   *           processItems({ columnRecord, items }) {
   *              // Push an extra item for the todo column
   *              if (columnRecord.id === 'todo') {
   *                  items.finishAll = {
   *                      text : 'Finish all',
   *                      icon : 'b-fa-fw b-fa-check'
   *                      onItem({ columnRecord }) {
   *                          columnRecord.tasks.forEach(taskRecord => taskRecord.status = 'done');
   *                      }
   *                  };
   *               }
   *           }
   *       }
   *   }
   * });
   * ```
   *
   * @param {Object} context An object with information about the menu being shown
   * @param {TaskBoard.model.ColumnModel} context.columnRecord The column for which the menu will be shown
   * @param {Object} context.items An object containing the {@link Core.widget.MenuItem menu item} configs keyed by their id
   * @param {Event} context.event The DOM event object that triggered the show
   * @config {Function}
   * @preventable
   */
  processItems: null,

  /**
   * This is a preconfigured set of items used to create the default context menu.
   *
   * The `items` provided by this feature are listed in the intro section of this class. You can configure
   * existing items by passing a configuration object to the keyed items.
   *
   * To remove existing items, set corresponding keys to `null`:
   *
   * ```javascript
   * const scheduler = new Scheduler({
   *     features : {
   *         columnHeaderMenu : {
   *             items : {
   *                 addTask : null
   *             }
   *         }
   *     }
   * });
   * ```
   *
   * See the class description for more examples.
   *
   * @config {Object} items
   */
  items: null,
  menu: {
    anchor: true
  },
  type: 'columnHeader',
  triggerEvent: false
  /**
   * @hideconfigs type, triggerEvent
   */

});

_TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_0__["default"].register(ColumnHeaderMenu.type, ColumnHeaderMenu);
ColumnHeaderMenu._$name = 'ColumnHeaderMenu';

/***/ }),

/***/ "./lib/TaskBoard/feature/ColumnToolbars.js":
/*!*************************************************!*\
  !*** ./lib/TaskBoard/feature/ColumnToolbars.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnToolbars; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_widget_Toolbar_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/Toolbar.js */ "./lib/Core/widget/Toolbar.js");
/* harmony import */ var _Core_widget_Menu_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/Menu.js */ "./lib/Core/widget/Menu.js");
/* harmony import */ var _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TaskBoardFeature.js */ "./lib/TaskBoard/feature/TaskBoardFeature.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';





/**
 * @module TaskBoard/feature/ColumnToolbars
 */

/**
 * Adds toolbars to the top and/or bottom of each column. By default it adds a bottom toolbar containing a single button
 * for adding events to that column/swimlane:
 *
 * {@inlineexample TaskBoard/feature/ColumnToolbars.js}
 *
 * To add, remove or modify toolbar items for all columns, see {@link #config-topItems} and {@link #config-bottomItems}:
 *
 * {@inlineexample TaskBoard/feature/ColumnToolbarsAdd.js}
 *
 * To have per column/swimlane control over the items, see {@link #config-processItems}:
 *
 * {@inlineexample TaskBoard/feature/ColumnToolbarsProcess.js}
 *
 * In handlers for buttons etc, you can access which column/swimlane the action was taken in on the supplied `source`
 * param, using its `columnRecord` and `swimlaneRecord` properties:
 *
 * ```javascript
 * new TaskBoard({
 *    features : {
 *        columnToolbars : {
 *            topItems : {
 *                clearButton : {
 *                    icon    : 'b-fa-trash',
 *                    onClick({ source }) {
 *                        if (source.columnRecord) {
 *                            ...
 *                        }
 *                    }
 *                }
 *            }
 *        }
 *    }
 * });
 * ```
 *
 * This feature is **enabled** by default.
 *
 * @extends TaskBoard/feature/TaskBoardFeature
 * @uninherit Core/Base
 * @uninherit Core/localization/Localizable
 * @classtype columnToolbars
 * @feature
 */

class ColumnToolbars extends _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_4__["default"] {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "columnMap", new Map());
  }

  doDestroy() {
    for (const [, toolbar] of this.columnMap) {
      toolbar.destroy();
    }

    super.doDestroy();
  } //region Type assertions


  changeTopItems(items) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertObject(items, 'features.columnToolbars.topItems');
    return items;
  }

  changeBottomItems(items) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertObject(items, 'features.columnToolbars.bottomItems');
    return items;
  }

  changeProcessItems(fn) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertFunction(fn, 'features.columnToolbars.processItems');
    return fn;
  } //endregion
  //region Toolbars
  // removeToolbar(location) {
  //     const columnMap = this.columnMap;
  //
  //     for (const [key, toolbar] of columnMap) {
  //         if (key.startsWith(location)) {
  //             toolbar.destroy();
  //             columnMap.delete(toolbar);
  //         }
  //     }
  // }
  //
  // changeTopItems(items, old) {
  //     if (old && !items) {
  //         this.removeToolbar('top');
  //     }
  //
  //     return items;
  // }
  //
  // changeBottomItems(items, old) {
  //     if (old && !items) {
  //         this.removeToolbar('items');
  //     }
  //
  //     return items;
  // }
  // Creates or retrieves a toolbar instance for the requested column/swimlane intersection


  getToolbar(location, columnRecord, swimlaneRecord) {
    var _swimlaneRecord$id;

    const me = this,
          {
      columnMap,
      client,
      namedItems
    } = me,
          items = me[`${location}Items`],
          key = `${location}_._${columnRecord.id}_._${(_swimlaneRecord$id = swimlaneRecord === null || swimlaneRecord === void 0 ? void 0 : swimlaneRecord.id) !== null && _swimlaneRecord$id !== void 0 ? _swimlaneRecord$id : 'default'}`;
    let toolbar = columnMap.get(key);

    if (!toolbar) {
      var _me$processItems;

      const clonedItems = {}; // items allows configuring out using falsy value, only iterate the truthy ones

      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getTruthyKeys(items).map(ref => {
        const // Could match a named item, to either be used as is or use reconfigured
        namedItem = namedItems[ref],
              // Item config or a truthy value to include a named item as is
        item = items[ref];
        clonedItems[ref] = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge( // Default listeners + decorate with records
        {
          listeners: {
            click: 'onClick',
            change: 'onChange',
            thisObj: me
          },
          columnRecord,
          swimlaneRecord
        }, // Merge with any matched named item
        namedItem, // And any supplied config
        item);
      }); // Allow client code to alter items before adding them to the toolbar

      if (((_me$processItems = me.processItems) === null || _me$processItems === void 0 ? void 0 : _me$processItems.call(me, {
        items: clonedItems,
        location,
        columnRecord,
        swimlaneRecord
      })) === false) {
        return null;
      } // Create toolbar using the processed items


      toolbar = client.add({
        type: 'toolbar',
        cls: `b-taskboard-column-${location[0]}bar`,
        overflow: null,
        monitorResize: false,
        contentElMutationObserver: false,
        items: clonedItems,
        dataset: {
          role: `${location}-toolbar`,
          domTransition: true
        }
      });
      columnMap.set(key, toolbar);
    }

    return toolbar.element;
  }

  populateColumn({
    columnConfig,
    columnRecord,
    swimlaneRecord
  }) {
    const me = this;

    if (!me.disabled) {
      // Add top toolbar, if it has items
      if (_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getTruthyKeys(me.topItems).length) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].merge(columnConfig, {
          children: {
            'tbar > body': me.getToolbar('top', columnRecord, swimlaneRecord)
          }
        });
      } // Add bottom toolbar, if it has items


      if (_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].getTruthyKeys(me.bottomItems).length) {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].merge(columnConfig, {
          children: {
            bbar: me.getToolbar('bottom', columnRecord, swimlaneRecord)
          }
        });
      }
    }
  }

  removeColumnToolbar(location, columnId, swimlaneId) {
    const {
      columnMap,
      client
    } = this,
          key = `${location}_._${columnId}_._${swimlaneId}`,
          toolbar = columnMap.get(key);

    if (toolbar) {
      client.remove(toolbar); // Toolbar gets removed during a compose, which leads to a race condition with syncOverflowVisibility.
      // Postpone destroy til after compose to avoid this

      client.setTimeout(() => toolbar.destroy(), 0);
      columnMap.delete(key);
    }
  }

  removeColumnToolbars(columnId, swimlaneId) {
    this.removeColumnToolbar('top', columnId, swimlaneId);
    this.removeColumnToolbar('bottom', columnId, swimlaneId);
  }

  onRemoveColumnElement({
    columnId,
    swimlaneRecord
  }) {
    var _swimlaneRecord$id2;

    this.removeColumnToolbars(columnId, (_swimlaneRecord$id2 = swimlaneRecord.id) !== null && _swimlaneRecord$id2 !== void 0 ? _swimlaneRecord$id2 : 'default');
  }

  onRemoveSwimlaneElement({
    swimlaneId
  }) {
    for (const column of this.client.columns) {
      this.removeColumnToolbars(column.id, swimlaneId);
    }
  } //endregion
  //region Predefined items events


  onAddClick({
    source
  }) {
    this.client.addTask(source.columnRecord, source.swimlaneRecord);
  } //endregion
  //region Generic events


  onChange({
    source
  }) {
    this.trigger('itemChange', {
      item: source,
      columnRecord: source.columnRecord,
      swimlaneRecord: source.swimlaneRecord
    });
  }

  onClick({
    source
  }) {
    this.trigger('itemClick', {
      item: source,
      columnRecord: source.columnRecord,
      swimlaneRecord: source.swimlaneRecord
    });
  } //endregion


}

_defineProperty(ColumnToolbars, "$name", 'ColumnToolbars');

_defineProperty(ColumnToolbars, "type", 'columnToolbars');

_defineProperty(ColumnToolbars, "configurable", {
  /**
   * Items to add to the top toolbar, in object format.
   *
   * ```javascript
   * new TaskBoard({
   *    features : {
   *        columnToolbars : {
   *            topItems : {
   *                clearButton : {
   *                    icon    : 'b-fa-trash',
   *                    onClick : ...
   *                }
   *            }
   *        }
   *    }
   * });
   * ```
   *
   * @config {Object}
   */
  topItems: null,

  /**
   * Items to add to the bottom toolbar, in object format.
   *
   * ```javascript
   * new TaskBoard({
   *    features : {
   *        columnToolbars : {
   *            bottomItems : {
   *                clearButton : {
   *                    icon    : 'b-fa-trash',
   *                    onClick : ...
   *                }
   *            }
   *        }
   *    }
   * });
   * ```
   *
   * @config {Object}
   */
  bottomItems: {
    addTask: true
  },
  // Predefined items that can be used in topItems and/or bottomItems
  // TODO: Document and make public?
  namedItems: {
    addTask: {
      type: 'button',
      icon: 'b-icon-add',
      tooltip: 'L{TaskBoard.addTask}',
      ariaLabel: 'L{TaskBoard.addTask}',
      listeners: {
        click: 'onAddClick'
      }
    }
  },

  /**
   * A function called before displaying the toolbar that allows manipulations of its items.
   * Returning `false` from this function prevents the menu being shown.
   *
   * ```javascript
   * features         : {
   *    columnToolbars : {
   *         processItems({ items, location, columnRecord, swimlaneRecord }) {
   *             // Add or hide existing items here as needed
   *             items.myAction = {
   *                 text   : 'Cool action',
   *                 icon   : 'b-fa-ban',
   *                 onClick : () => console.log(`Clicked button for ${columnRecord.text}`)
   *             };
   *
   *            if (columnRecord.id === 'done') {
   *                items.addTask = false
   *            }
   *         }
   *     }
   * },
   * ```
   *
   * @param {Object} context An object with information about the toolbar being shown
   * @param {Object} context.items An object containing the toolbar item configs keyed by ref
   * @param {String} context.location Toolbar location, "top" or "bottom"
   * @param {TaskBoard.model.ColumnModel} context.columnRecord Record representing toolbars column
   * @param {TaskBoard.model.SwimlaneModel} context.swimlaneRecord Record representing toolbars swimlane
   * @config {Function}
   * @preventable
   */
  processItems: null
});

_defineProperty(ColumnToolbars, "pluginConfig", {
  chain: ['populateColumn', 'onRemoveColumnElement', 'onRemoveSwimlaneElement']
});

ColumnToolbars.initClass();
ColumnToolbars._$name = 'ColumnToolbars';

/***/ }),

/***/ "./lib/TaskBoard/feature/SimpleTaskEdit.js":
/*!*************************************************!*\
  !*** ./lib/TaskBoard/feature/SimpleTaskEdit.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SimpleTaskEdit; });
/* harmony import */ var _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskBoardFeature.js */ "./lib/TaskBoard/feature/TaskBoardFeature.js");
/* harmony import */ var _view_item_TaskItem_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../view/item/TaskItem.js */ "./lib/TaskBoard/view/item/TaskItem.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/widget/Editor.js */ "./lib/Core/widget/Editor.js");
/* harmony import */ var _Core_widget_mixin_KeyMap_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/widget/mixin/KeyMap.js */ "./lib/Core/widget/mixin/KeyMap.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';






/**
 * @module TaskBoard/feature/SimpleTaskEdit
 */

/**
 * This feature allows inline editing of tasks. Double clicking an item starts editing it:
 *
 * {@inlineexample TaskBoard/feature/SimpleTaskEdit.js}
 *
 * Each {@link TaskBoard.view.item.TaskItem task item} can define an
 * {@link TaskBoard.view.item.TaskItem#config-editor}. To prevent an item from being edited inline, configure it with
 * `editor : null`:
 *
 * {@inlineexample TaskBoard/feature/SimpleTaskEditCustom.js}
 *
 * ## Keyboard shortcuts
 *
 * Hitting `[Enter]` in an editor accepts the change and starts editing the next item on that card/the first item on the
 * next card. By default it adds a new task when `[Enter]` is pressed on the last item of the last card in a column,
 * configurable using the {@link #config-addNewAtEnd} config.
 *
 * `[Shift]` + `[Enter]` moves to previous item. `[CTRL/CMD]` + `[Enter]` accepts the edit, closing the editor.
 *
 * You can reconfigure the keys used to trigger these actions, {@link #config-keyMap} for more details.
 *
 * This feature is **disabled** by default.
 *
 * @extends TaskBoard/feature/TaskBoardFeature
 * @uninherit Core/Base
 * @uninherit Core/localization/Localizable
 * @classtype simpleTaskEdit
 * @feature
 */

class SimpleTaskEdit extends _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_Core_widget_mixin_KeyMap_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {
  //region Type assertions
  changeAddNewAtEnd(addNewAtEnd) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assertBoolean(addNewAtEnd, 'features.simpleTaskEdit.addNewAtEnd');
    return addNewAtEnd;
  } //endregion

  /**
   * Starts inline editing of the supplied task, optionally for a specific item on its card.
   * @on-owner
   * @param {TaskBoard.model.TaskModel} taskRecord Task record to edit
   * @param {HTMLElement} [element] Card element or card item element to edit. Resolves element from the passed record
   * if left out.
   * @returns {Boolean} Returns `true` if editing started, `false` if it did not.
   */


  editTask(taskRecord, element) {
    const me = this,
          taskBoard = me.client; // Get element from record if none supplied

    if (!element) {
      element = taskBoard.getTaskElement(taskRecord);
    }

    const // Get a task item from the element, will yield first task item when given the card element
    taskItem = taskBoard.resolveTaskItem(element),
          itemElement = taskItem.element,
          itemEditorConfig = _view_item_TaskItem_js__WEBPACK_IMPORTED_MODULE_1__["default"].getEditorConfig(taskItem); // Allow disabling editing for an item using `editor : null`

    if (!itemEditorConfig || me.disabled || taskRecord.readOnly) {
      return false;
    }

    const editor = me.editor = _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_4__["default"].new({
      owner: taskBoard,
      appendTo: taskBoard.bodyElement,
      scrollAction: 'realign',
      cls: 'b-simple-task-editor',
      completeKey: null,
      cancelKey: null,
      inputField: _objectSpread({
        autoSelect: true,
        name: taskItem.config.field
      }, itemEditorConfig),
      align: {
        align: 'c-c'
      },
      listeners: {
        finishEdit: 'onEditorFinishEdit',
        keyDown: 'onEditorKeyDown',
        thisObj: me
      }
    }, me.editorConfig); // Store active element, to be able to navigate to next/prev later if requested

    me.currentElement = itemElement; // Add editing cls, will be cleared by recompose

    itemElement.classList.add('b-editing'); // Match editor color to item color

    const color = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getStyleValue(itemElement, 'color');
    editor.element.style.color = color;
    editor.inputField.element.style.color = color; // Dont want a recompose removing editor element

    editor.element.retainElement = true; // Scrolling card into view

    taskBoard.getTaskElement(taskRecord).scrollIntoView({
      block: 'nearest'
    }); // And then item being edited. Two steps since first one wont do anything if card is already in view while item
    // is not

    itemElement.scrollIntoView({
      block: 'nearest'
    }); // me.relayEvents(editor, ['beforestart', 'start', 'beforecomplete', 'complete', 'beforecancel', 'cancel']);

    editor.startEdit({
      target: taskItem.element,
      record: taskRecord,
      field: taskItem.config.field
    });
    return true;
  } // Edit previous task item


  async editPrevious(event) {
    const me = this,
          {
      client,
      editor
    } = me,
          taskRecord = editor.record,
          cardElement = client.getTaskElement(taskRecord),
          itemElements = Array.from(cardElement.querySelectorAll('.b-taskboard-taskitem.b-editable')),
          index = itemElements.indexOf(me.currentElement) - 1;

    if (await me.complete(event)) {
      // More items on the card, edit prev item
      if (index >= 0) {
        me.editTask(taskRecord, itemElements[index]);
      } // No more items
      else {
        const prevTaskRecord = client.getPreviousTask(taskRecord, false); // Edit last item of prev card

        if (prevTaskRecord) {
          const prevCardElement = client.getTaskElement(prevTaskRecord),
                prevItemElements = Array.from(prevCardElement.querySelectorAll('.b-taskboard-taskitem.b-editable'));
          me.editTask(prevTaskRecord, prevItemElements[prevItemElements.length - 1]);
        }
      }
    }
  } // Edit next task item


  async editNext(event) {
    const me = this,
          {
      client,
      editor
    } = me,
          taskRecord = editor.record,
          cardElement = client.getTaskElement(taskRecord),
          itemElements = Array.from(cardElement.querySelectorAll('.b-taskboard-taskitem.b-editable')),
          index = itemElements.indexOf(me.currentElement) + 1;

    if (await me.complete(event)) {
      // More items on the card, edit next item
      if (index < itemElements.length) {
        me.editTask(taskRecord, itemElements[index]);
      } // No more items
      else {
        const nextTaskRecord = client.getNextTask(taskRecord, false); // Edit next card

        if (nextTaskRecord) {
          me.editTask(nextTaskRecord);
        } // Or add a new card
        else if (me.addNewAtEnd) {
          client.addTask(client.getColumn(taskRecord), client.getSwimlane(taskRecord));
        }
      }
    }
  }

  complete(event) {
    return this.editor.completeEdit(null, event);
  }

  cancel(event) {
    this.editor.cancelEdit(event);
  } // Start editing when activating task (enter/dblclick)


  onActivateTask({
    taskRecord,
    event
  }) {
    if (this.editTask(taskRecord, event.target)) {
      // Block other actions (TaskEdit)
      event.preventDefault();
    }
  }

  onEditorFinishEdit() {
    // Have to store editor before the timeout, might get replaced by new
    const {
      editor
    } = this; // Destroy editor a little later, to be able to catch any key event that made it finish

    this.client.setTimeout(() => {
      // Dont retain the element if we did not start editing something else
      if (this.editor === editor) {
        this.currentElement = null;
      }

      editor.destroy();
    }, 0);
  }

  onEditorKeyDown({
    event
  }) {
    this.performKeyMapAction(event);
  }

}

_defineProperty(SimpleTaskEdit, "$name", 'SimpleTaskEdit');

_defineProperty(SimpleTaskEdit, "type", 'simpleTaskEdit');

_defineProperty(SimpleTaskEdit, "configurable", {
  /**
   * Pressing `Enter` in last item on last task in a column adds a new task.
   * @config {Boolean}
   * @default
   */
  addNewAtEnd: true,

  /**
   * A configuration object for the {@link Core.widget.Editor} used by this feature. Useful when you want to
   * validate the value being set by the end user (see {@link Core.widget.Editor#event-beforeComplete}).
   *
   * @config {Object}
   */
  editorConfig: {},

  /**
   * The feature has the following default key mappings during editing:
   *
   * | Keys        | Action       |
   * |-------------|--------------|
   * | Enter       | editNext     |
   * | Escape      | cancel       |
   * | Shift+Enter | editPrevious |
   * | Ctrl+Enter  | complete     |
   *
   * You can supply your own key map if you want to change any mapping, or set it to `null` to disable all keyboard
   * shortcuts.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *    features : {
   *        simpleTaskEdit : {
   *            keyMap : {
   *                Enter : 'complete'
   *            }
   *        }
   *    }
   * });
   * ```
   *
   * @config {Object}
   */
  keyMap: {
    Enter: 'editNext',
    Escape: 'cancel',
    'Ctrl+Enter': 'complete',
    'Shift+Enter': 'editPrevious'
  }
});

_defineProperty(SimpleTaskEdit, "pluginConfig", {
  assign: ['editTask'],
  before: ['onActivateTask']
});

SimpleTaskEdit.initClass();
SimpleTaskEdit._$name = 'SimpleTaskEdit';

/***/ }),

/***/ "./lib/TaskBoard/feature/SwimlaneDrag.js":
/*!***********************************************!*\
  !*** ./lib/TaskBoard/feature/SwimlaneDrag.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SwimlaneDrag; });
/* harmony import */ var _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskBoardFeature.js */ "./lib/TaskBoard/feature/TaskBoardFeature.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/mixin/Draggable.js */ "./lib/Core/mixin/Draggable.js");
/* harmony import */ var _Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/mixin/Droppable.js */ "./lib/Core/mixin/Droppable.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';







/**
 * @module TaskBoard/feature/SwimlaneDrag
 */

/**
 * This feature allows users to drag drop swimlanes on the TaskBoard changing their order (by grabbing their header).
 *
 * {@inlineexample TaskBoard/feature/SwimlaneDrag.js}
 *
 * This feature is **disabled** by default.
 *
 * @extends TaskBoard/feature/TaskBoardFeature
 * @uninherit Core/Base
 * @uninherit Core/localization/Localizable
 * @classtype swimlaneDrag
 * @feature
 */

class SwimlaneDrag extends _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  initialCompose() {
    const me = this; // Cannot use configurable since bodyElement is not available yet when feature is pulled in

    me.draggable = SwimlaneZone.new({
      dragRootElement: me.disabled ? null : me.client.bodyWrapElement,
      dropRootElement: me.client.bodyWrapElement,
      owner: me
    }, me.draggable);
  }

  doDisable(disable) {
    super.doDisable(disable);

    if (this.draggable) {
      this.draggable.dragRootElement = disable ? null : this.client.bodyWrapElement;
    }
  }

}

_defineProperty(SwimlaneDrag, "$name", 'SwimlaneDrag');

_defineProperty(SwimlaneDrag, "type", 'swimlaneDrag');

_defineProperty(SwimlaneDrag, "pluginConfig", {
  after: ['initialCompose']
});

SwimlaneDrag.initClass();

class SwimlaneZone extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_5__["default"], _Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_6__["default"]) {
  static get configurable() {
    return {
      dragSelector: '.b-taskboard-swimlane-header, .b-taskboard-swimlane-header *',
      dragItemSelector: '.b-taskboard-swimlane-header',
      draggingItemCls: null,
      dragProxy: {
        type: 'default',

        async open(drag) {
          const {
            owner
          } = this,
                {
            itemElement,
            startEvent
          } = drag,
                taskBoard = owner.owner.client,
                swimlaneRecord = taskBoard.resolveSwimlaneRecord(itemElement),
                swimlaneElement = taskBoard.getSwimlaneElement(swimlaneRecord),
                padding = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getStyleValue(swimlaneElement.syncIdMap.body, ['padding-left', 'padding-right']),
                bounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(swimlaneElement, owner.dragRootElement).deflate(0, parseFloat(padding['padding-right']), 0, parseFloat(padding['padding-left'])),
                // Offset from cursor
          proxyOffset = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getClientPoint(startEvent).getDelta(bounds),
                // Drag proxy, positioned over column being dragged
          proxy = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement({
            className: 'b-taskboard-swimlane-drag-proxy',
            parent: owner.dragRootElement,
            style: {
              // Using fixed top, only draggable horizontally
              top: _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getClientPoint(startEvent).translate(0, proxyOffset[1]).y,
              // Offset from cursor to be positioned over original column
              left: bounds.x,
              // Need a fixed height on the proxy, since columns width might be flexed etc
              width: bounds.width
            },
            // Dont want it being removed while dragging
            retainElement: true
          }); // Things we want to access later on drag

          Object.assign(drag, {
            proxy,
            swimlaneRecord,
            swimlaneElement,
            proxyOffset,
            // Used to size dropIndicator
            bounds
          }); // Clone all dragged column elements and put them in the proxy

          const swimlaneClone = swimlaneElement.cloneNode(true);
          proxy.appendChild(swimlaneClone);
        },

        dragMove({
          proxy,
          event,
          proxyOffset
        }) {
          // Move along y-axis only
          const position = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getClientPoint(event).translate(0, proxyOffset[1]);
          proxy.style.top = `${position.y}px`;
        }

      }
    };
  }

  setupDragContext(event) {
    const result = super.setupDragContext(event),
          {
      client
    } = this.owner;
    result.scrollManager = client.scrollManager;
    result.monitoringConfig = {
      scrollables: [{
        element: client.bodyElement,
        direction: 'vertical'
      }]
    };
    return result;
  }

  dragStart(drag) {// Trigger something...
  }

  dragEnter(drag) {
    // Only accept swimlanes
    if (!drag.itemElement.matches(this.dragItemSelector)) {
      return false;
    } // Create drop indicators on first enter


    if (!drag.dropIndicator) {
      const {
        bounds
      } = drag; // Need one indicator for each part of the column

      drag.dropIndicator = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].createElement({
        className: 'b-taskboard-swimlane-drop-indicator',
        elementData: {
          dropIndicator: true
        },
        // Use same size as dragged column had originally
        style: {
          width: bounds.width,
          height: bounds.height
        }
      });
      this.insertDropIndicator(drag.dropIndicator, drag.swimlaneRecord);
      drag.swimlaneElement.classList.add('b-drag-original');
    }
  }

  insertDropIndicator(dropIndicator, beforeSwimlaneRecord) {
    const {
      client
    } = this.owner;
    client.bodyElement.insertBefore(dropIndicator, beforeSwimlaneRecord && client.getSwimlaneElement(beforeSwimlaneRecord));
  }

  async dragMove(drag) {
    var _overElement$elementD;

    const {
      client
    } = this.owner,
          {
      documentRoot
    } = client,
          taskBoardBounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(client.element, undefined, true),
          proxyBounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(drag.proxy, undefined, true),
          // Check element under proxy left center, should get a swimlane (or a gap)
    overElement = proxyBounds.center.y > taskBoardBounds.bottom ? documentRoot.elementFromPoint(proxyBounds.x, proxyBounds.y) : documentRoot.elementFromPoint(proxyBounds.x, proxyBounds.center.y),
          swimlaneElement = overElement === null || overElement === void 0 ? void 0 : overElement.closest('.b-taskboard-swimlane'); // If we are over the drop indicator or something not a column header, we do nothing

    if (!(overElement !== null && overElement !== void 0 && (_overElement$elementD = overElement.elementData) !== null && _overElement$elementD !== void 0 && _overElement$elementD.dropIndicator) && swimlaneElement) {
      const targetBounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(swimlaneElement, undefined, true); // Column that we are going to insert the dragged column before or after

      let beforeSwimlane = client.resolveSwimlaneRecord(swimlaneElement); // If beyond center, insert before next column

      if (proxyBounds.center.y > targetBounds.center.y) {
        beforeSwimlane = client.swimlanes.getNext(beforeSwimlane);
      }

      this.insertDropIndicator(drag.dropIndicator, beforeSwimlane);
      drag.beforeSwimlane = beforeSwimlane;
    }
  }

  async dragDrop(drag) {
    // Data part
    const {
      client
    } = this.owner,
          {
      swimlanes
    } = client,
          {
      swimlaneRecord,
      beforeSwimlane,
      swimlaneElement,
      dropIndicator,
      proxy
    } = drag;

    function commit() {
      // Remove proxy & dropIndicator
      proxy.remove();
      dropIndicator.remove(); // Restore original element

      swimlaneElement.classList.remove('b-drag-original'); // Update data

      beforeSwimlane !== undefined && swimlanes.move(swimlaneRecord, beforeSwimlane);
      client.trigger('dropSwimlane', {
        beforeSwimlane,
        drag
      });
    } // UI part
    // We are dropping, this cls by default has a transition


    proxy.classList.add('b-dropping'); // Move proxy to drop location, allowing it to transition there

    _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].alignTo(proxy, _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_4__["default"].from(dropIndicator, undefined, true)); // Update record after the transition, to prevent too early redraw (which would ruin the transition)

    if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].getPropertyTransitionDuration(proxy, 'transform')) {
      _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].onTransitionEnd({
        element: proxy,
        property: 'transform',
        handler: commit,
        thisObj: client
      });
    } // Or right away if no transition is used
    else {
      commit();
    }
  }

  dragLeave(drag) {// Doing nothing feels ok for now
  }

}

SwimlaneDrag._$name = 'SwimlaneDrag';

/***/ }),

/***/ "./lib/TaskBoard/feature/TaskBoardFeature.js":
/*!***************************************************!*\
  !*** ./lib/TaskBoard/feature/TaskBoardFeature.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskBoardFeature; });
/* harmony import */ var _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony import */ var _Core_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module TaskBoard/feature/TaskBoardFeature
 */

/**
 * The abstract base class for TaskBoard features.
 *
 * @extends Core/mixin/InstancePlugin
 * @abstract
 */

class TaskBoardFeature extends _Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_Core_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  // This makes all feature config changes after initialization recompose TaskBoard
  onConfigChange(args) {
    if (!this.isConfiguring && !this.isDestroying) {
      this.client.recompose();
    }

    super.onConfigChange(args);
  }

}

_defineProperty(TaskBoardFeature, "factoryable", {});

_defineProperty(TaskBoardFeature, "configurable", {});

TaskBoardFeature._$name = 'TaskBoardFeature';

/***/ }),

/***/ "./lib/TaskBoard/feature/TaskDrag.js":
/*!*******************************************!*\
  !*** ./lib/TaskBoard/feature/TaskDrag.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskDrag; });
/* harmony import */ var _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskBoardFeature.js */ "./lib/TaskBoard/feature/TaskBoardFeature.js");
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_AsyncHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/AsyncHelper.js */ "./lib/Core/helper/AsyncHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/mixin/Draggable.js */ "./lib/Core/mixin/Draggable.js");
/* harmony import */ var _Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/mixin/Droppable.js */ "./lib/Core/mixin/Droppable.js");
/* harmony import */ var _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';









/**
 * @module TaskBoard/feature/TaskDrag
 */

const cardSelector = '.b-taskboard-card, .b-taskboard-card-drop-indicator',
      // Index of the specified card/drop indicator (other drop indicators excluded)
indexOf = (element, ignoreOriginal = false) => _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].children(element.parentElement, `.b-taskboard-card${ignoreOriginal ? ':not(.b-drag-original)' : ''}, .b-first-drop-indicator`).indexOf(element),
      // Check if any drop indicator has moved in a way that will lead to task changes
hasChanged = dropIndicators => dropIndicators.some((dropIndicator, i) => {
  return (// Moved to another parent is a change (another column or another swimlane)
    dropIndicator.parentElement !== dropIndicator.elementData.initialParent || // Or if first drop indicator has changed index (the others follow it, no need to check)
    i === 0 && indexOf(dropIndicator, true) !== dropIndicator.elementData.initialIndex
  );
});
/**
 * This feature allows cards on the TaskBoard to be dragged across swimlanes and columns but also vertically in the
 * same column to change the order:
 *
 * {@inlineexample TaskBoard/feature/TaskDrag.js}
 *
 * When a task is dropped, its {@link TaskBoard.view.TaskBoard#config-columnField},
 * {@link TaskBoard.view.TaskBoard#config-swimlaneField} and/or {@link TaskBoard.model.TaskModel#field-weight} fields
 * are updated to reflect the new location.
 *
 * ## Drag events
 *
 * The different stages of a drag operation trigger different events, in order of appearance:
 *
 * | Event                         | Description                                                                    |
 * |-------------------------------|--------------------------------------------------------------------------------|
 * | {@link #event-beforeTaskDrag} | Preventable event fired before a drag starts                                   |
 * | {@link #event-taskDragStart}  | Fired when dragging starts                                                     |
 * | {@link #event-taskDrag}       | Fired when movement during a drag will lead to changes                         |
 * | {@link #event-beforeTaskDrop} | Preventable event fired before finalizing a valid drop. Allows async listeners |
 * | {@link #event-taskDrop}       | Fired after finalizing a valid drop                                            |
 * | {@link #event-taskDragAbort}  | Fired when a drag is aborted (ESC, drop out of bounds or by a listener)        |
 * | {@link #event-taskDragEnd}    | Fired when a started drag ends, no matter the outcome                          |
 *
 * The {@link #event-beforeTaskDrop} is useful for example to request user confirmation for a drop:
 *
 * {@inlineexample TaskBoard/feature/TaskDragEvents.js}
 *
 * This feature is **enabled** by default.
 *
 * @extends TaskBoard/feature/TaskBoardFeature
 * @uninherit Core/Base
 * @uninherit Core/localization/Localizable
 * @classtype taskDrag
 * @feature
 */


class TaskDrag extends _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  initialCompose() {
    const me = this; // Cannot use configurable since bodyElement is not available yet when feature is pulled in

    me.draggable = TaskZone.new({
      dragRootElement: me.disabled ? null : me.client.bodyWrapElement,
      dropRootElement: me.client.bodyWrapElement,
      owner: me,
      listeners: {
        beforeDragStart: 'onBeforeDragStart',
        dragStart: 'onDragStart',
        thisObj: me
      }
    }, me.draggable);
  }

  doDestroy() {
    var _this$draggable;

    super.doDestroy();
    (_this$draggable = this.draggable) === null || _this$draggable === void 0 ? void 0 : _this$draggable.destroy();
  }

  doDisable(disable) {
    super.doDisable(disable);

    if (this.draggable) {
      this.draggable.dragRootElement = disable ? null : this.client.bodyWrapElement;
    }
  }

  onBeforeDragStart({
    drag,
    event
  }) {
    /**
     * Fires on the owning TaskBoard before task dragging starts. Return `false` to prevent the action
     * @event beforeTaskDrag
     * @preventable
     * @on-owner
     * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
     * @param {TaskBoard.model.TaskModel[]} taskRecords Tasks to be dragged
     */
    return this.client.trigger('beforeTaskDrag', {
      drag,
      event,
      taskRecords: drag.taskRecords
    });
  }

  onDragStart({
    drag,
    event
  }) {
    /**
     * Fires on the owning TaskBoard when task dragging starts
     * @event taskDragStart
     * @on-owner
     * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
     * @param {TaskBoard.model.TaskModel[]} taskRecords Tasks to be dragged
     */
    return this.client.trigger('taskDragStart', {
      drag,
      event,
      taskRecords: drag.taskRecords
    });
  }

}

_defineProperty(TaskDrag, "$name", 'TaskDrag');

_defineProperty(TaskDrag, "type", 'taskDrag');

_defineProperty(TaskDrag, "pluginConfig", {
  after: ['initialCompose']
});

TaskDrag.initClass();

class TaskZone extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_6__["default"], _Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_7__["default"], _Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_8__["default"]) {
  static get configurable() {
    return {
      dragSelector: '.b-taskboard-card:not(.b-readonly)',
      dragItemSelector: '.b-taskboard-card:not(.b-readonly)',
      // Accept drops on anything within the TaskBoard
      dropTargetSelector: '.b-taskboardbase',
      // We are going to allow dragging multiple cards, will need to add cls manually to all of them
      draggingItemCls: null,
      dragProxy: {
        type: 'default',

        async open(drag) {
          const {
            itemElement,
            startEvent
          } = drag,
                taskBoard = this.owner.owner.client,
                columnEl = itemElement.closest('.b-taskboard-column'),
                taskRecord = taskBoard.resolveTaskRecord(itemElement),
                proxy = drag.proxy = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement({
            // Add column classes too to get exact same styles applied
            className: 'b-taskboard-drag-proxy ' + columnEl.className,
            parent: this.owner.dragRootElement,
            // Dont want it being removed while dragging
            retainElement: true
          }),
                cardClones = [];
          let taskRecords; // If we have selected tasks, drag them only if drag starts from one of the selected

          if (taskBoard.selectedTasks.includes(taskRecord)) {
            taskRecords = taskBoard.selectedTasks.filter(t => !t.readOnly).sort((a, b) => a.parentIndex - b.parentIndex);
          } // Otherwise (no selection or dragging an unselected) only drag one
          else {
            taskRecords = [taskRecord];
          }

          const taskElements = taskRecords.map(r => taskBoard.getTaskElement(r));
          Object.assign(drag, {
            taskElements,
            // Store heights, cannot measure later when original tasks are hidden
            taskHeights: new Map(),
            // Offset from cursor, ignoring page scroll = client coords
            proxyOffset: _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getClientPoint(startEvent).getDelta(_Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(itemElement, null, true))
          }); // Clone all dragged cards and put them in the proxy

          taskElements.forEach(taskElement => {
            var _elementData$swimlane;

            const {
              elementData
            } = taskElement,
                  cardClone = taskElement.cloneNode(true),
                  bounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(taskElement, itemElement); // Cards get their width from the column, need to apply the width to the proxy card

            cardClone.style.width = bounds.width + 'px';
            cardClone.style.height = bounds.height + 'px';
            drag.taskHeights.set(taskElement, bounds.height); // Position cards in the proxy to overlap their originals

            cardClone.style.left = bounds.x + 'px';
            cardClone.style.top = bounds.y + 'px';
            cardClone.taskElement = taskElement;
            cardClone.taskRecord = elementData.taskRecord;
            cardClone.originalColor = ((_elementData$swimlane = elementData.swimlaneRecord) === null || _elementData$swimlane === void 0 ? void 0 : _elementData$swimlane.color) || elementData.columnRecord.color;
            proxy.appendChild(cardClone);
            cardClones.push(cardClone);
          }); // Hide original card after measuring it above (cannot be done in the same loop, others will get
          // wrong bounds)

          taskElements.forEach(taskElement => taskElement.classList.add('b-drag-original'));
          await _Core_helper_AsyncHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].animationFrame(); // Now reposition the cards to their desired position within the proxy, transitioning them there

          cardClones.forEach((cardClone, i) => {
            if (i > 0) {
              cardClone.style.top = 30 + i * 20 + 'px';
              cardClone.style.left = 40 + i * 5 + 'px';
            } else {
              cardClone.style.top = 0;
              cardClone.style.left = 0;
            }
          });
        },

        dragMove({
          proxy,
          event,
          proxyOffset
        }) {
          const {
            dragRootElement
          } = this.owner,
                // Parent coords relative to screen (client)
          parentBounds = dragRootElement.getBoundingClientRect(),
                // Place proxy in client coords
          position = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].getClientPoint(event).translate(proxyOffset[0] - parentBounds.left + dragRootElement.scrollLeft, proxyOffset[1] - parentBounds.top + dragRootElement.scrollTop);
          proxy.style.top = position.y + 'px';
          proxy.style.left = position.x + 'px'; // Experimental, tilt proxy based on drag amount and direction
          // let delta = 0;
          //
          // if (proxy.lastClientX != null) {
          //     delta = event.clientX - proxy.lastClientX;
          // }
          //
          // proxy.lastClientX = event.clientX;
          //
          // proxy.style.transform = `rotate(${-delta / 10}deg)`;
          // proxy.style.transformOrigin = `${-proxyOffset[0]}px ${-proxyOffset[1]}px`;
        }

      }
    };
  }

  configureListeners(drag) {
    const listeners = super.configureListeners(drag); // Listen to the events on the root element

    listeners.element = this.owner.client.rootElement;
    return listeners;
  }

  setupDragContext(event) {
    const result = super.setupDragContext(event),
          {
      client
    } = this.owner;
    result.scrollManager = client.scrollManager;
    result.monitoringConfig = {
      scrollables: [{
        element: '.b-taskboard-column-body',
        direction: 'vertical'
      }, {
        element: client.bodyElement,
        direction: 'both'
      }]
    };
    return result;
  } // Populate the drag context early, to have something to take decisions on in beforeDragStart listeners


  startDrag(drag) {
    const {
      itemElement
    } = drag,
          taskBoard = this.owner.client,
          taskRecord = taskBoard.resolveTaskRecord(itemElement); // If we have selected tasks, drag them only if drag starts from one of the selected

    if (taskBoard.isSelected(taskRecord)) {
      drag.taskRecords = taskBoard.selectedTasks.slice().sort((a, b) => a.parentIndex - b.parentIndex);
    } // Otherwise (no selection or dragging an unselected) only drag one
    else {
      drag.taskRecords = [taskRecord];
    }

    drag.initiatedFrom = taskRecord;
    return super.startDrag(drag);
  }

  dragStart(drag) {
    const {
      client
    } = this.owner,
          // Insert dropIndicators next to task that drag was initiated on initially
    nextSibling = drag.itemElement; // Flag to determine if `taskDragEnd` should be triggered on later abort

    drag.wasStarted = true; // Initially positioned after task drag is initiated from

    drag.position = 'after';
    drag.targetTaskRecord = drag.initiatedFrom; // Populate drop indicator with placeholders

    drag.dropIndicators = drag.taskElements.map((taskElement, i) => {
      return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement({
        className: {
          'b-taskboard-card-drop-indicator': 1,
          'b-first-drop-indicator': i === 0
        },
        style: {
          height: drag.taskHeights.get(taskElement)
        },
        elementData: {
          dropIndicator: true,
          // To be able to detect if it has actually moved on drop
          initialParent: taskElement.parentElement,
          initialIndex: indexOf(taskElement),
          // Tag along the taskElement, to be able to return the drop indicator to its position for
          // invalid drop targets
          taskElement
        },
        retainElement: true,
        nextSibling
      });
    });
    client.element.classList.add('b-dragging-task');
  }

  dragEnter(drag) {
    // Only accept tasks
    if (!drag.itemElement.matches(this.dragItemSelector)) {
      return false;
    }
  } // Finds the first visible direct child in a parent element


  getFirstVisibleChild(parentElement) {
    for (const element of parentElement.children) {
      if (element.offsetParent) {
        return element;
      }
    }
  } // Convenience shortcut to not have to pass custom card selector on each call


  getCardAt(x, y) {
    return this.owner.client.getCardAt(x, y, cardSelector);
  }

  updateValidity(drag, valid) {
    drag.proxy.classList.toggle('b-invalid', !valid);
    drag.dropIndicators.forEach(dropIndicator => dropIndicator.classList.toggle('b-invalid', !valid));
    drag.invalid = !valid;
  }

  dragMove(drag) {
    var _overElement$closest;

    const me = this,
          {
      client
    } = me.owner,
          {
      event,
      dropIndicators
    } = drag,
          {
      clientX,
      clientY
    } = event,
          overElement = client.documentRoot.elementFromPoint(clientX, clientY),
          columnElement = overElement === null || overElement === void 0 ? void 0 : (_overElement$closest = overElement.closest('.b-taskboard-column')) === null || _overElement$closest === void 0 ? void 0 : _overElement$closest.syncIdMap.body;

    if (drag.invalid) {
      drag.valid = false;
    }

    if (!overElement) {
      return;
    } // Over something in a column or the column itself


    if (columnElement) {
      var _cardElement;

      const targetSwimlane = client.resolveSwimlaneRecord(overElement),
            targetColumn = client.resolveColumnRecord(overElement),
            tasksPerRow = targetColumn.tasksPerRow || (targetSwimlane === null || targetSwimlane === void 0 ? void 0 : targetSwimlane.tasksPerRow) || client.tasksPerRow;
      let cardElement = overElement.closest(cardSelector),
          // Should only trigger drag event when move actually affected something
      shouldTrigger = targetSwimlane !== drag.targetSwimlane || targetColumn !== drag.targetColumn; // Only resolve swimlane/column when over a column, that way target sticks even if mouse is moved outside

      drag.targetSwimlane = targetSwimlane;
      drag.targetColumn = targetColumn; // Might be over gap between cards, check if there is card above or below the gap

      if (!cardElement) {
        var _topCard$getBoundingC;

        const {
          cardGap
        } = client,
              columnRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(columnElement),
              topCard = me.getFirstVisibleChild(columnElement),
              top = (_topCard$getBoundingC = topCard === null || topCard === void 0 ? void 0 : topCard.getBoundingClientRect().top) !== null && _topCard$getBoundingC !== void 0 ? _topCard$getBoundingC : null;

        if (tasksPerRow === 1) {
          // Above top card, use it
          if (top !== null && clientY < top) {
            cardElement = topCard;
          } else {
            const centerX = columnRect.center.x,
                  // Check column center, one gap up
            cardAbove = me.getCardAt(centerX, clientY - cardGap),
                  // And one gap down
            cardBelow = me.getCardAt(centerX, clientY + cardGap); // Pick one of them

            cardElement = cardAbove || cardBelow;
          }
        } else {
          // Determine which "inner column" mouse is over
          const columnContentWidth = client.getColumnWidth(drag.targetColumn),
                // Can calculate padding, avoids reading it from DOM
          columnPadding = (columnRect.width - columnContentWidth) / 2,
                // Width of an "inner column", ignoring gap between cards which does not matter in this case.
          // An approximate center fits our purpose
          innerColumnWidth = columnContentWidth / tasksPerRow,
                // "Inner column" index
          index = Math.floor((clientX - columnRect.left) / innerColumnWidth),
                // That columns center
          centerX = columnRect.left + columnPadding + innerColumnWidth * (index + 0.5); // Above top row, use card below us

          if (top !== null && clientY < top) {
            cardElement = me.getCardAt(centerX, top);
          } else {
            const centerX = columnRect.center.x,
                  // Check column center, one gap left
            cardBefore = me.getCardAt(centerX - cardGap, clientY),
                  // And one gap right
            cardAfter = me.getCardAt(centerX + cardGap, clientY); // Pick one of them

            cardElement = cardBefore || cardAfter;
          }
        }
      } // If we are over the drop indicator, we do nothing


      if (!((_cardElement = cardElement) !== null && _cardElement !== void 0 && _cardElement.elementData.dropIndicator)) {
        var _insertBefore, _insertBefore$element;

        let insertBefore = false; // If we found a card, we should either go above or below it

        if (cardElement) {
          const cardRect = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(cardElement),
                targetTaskRecord = client.resolveTaskRecord(cardElement); // Insert before

          if ( // If above center with single task per row
          tasksPerRow === 1 && clientY < cardRect.center.y || // Or left of center in multiple tasks per row
          tasksPerRow > 1 && clientX < cardRect.center.x) {
            if (drag.position !== 'before') {
              shouldTrigger = true;
            }

            insertBefore = cardElement;
            drag.position = 'before';
          } // Insert after
          else {
            if (drag.position !== 'after') {
              shouldTrigger = true;
            }

            insertBefore = cardElement.nextElementSibling;
            drag.position = 'after';
          }

          if (targetTaskRecord !== drag.targetTaskRecord) {
            shouldTrigger = true;
          }

          drag.targetTaskRecord = targetTaskRecord;
        } // No card, either empty column or below cards. Either way we append the card to the column
        else {
          if (drag.position !== 'last') {
            shouldTrigger = true;
          }

          drag.position = 'last';
          drag.targetTaskRecord = null;
        }

        if (!((_insertBefore = insertBefore) !== null && _insertBefore !== void 0 && (_insertBefore$element = _insertBefore.elementData) !== null && _insertBefore$element !== void 0 && _insertBefore$element.dropIndicator)) {
          if (insertBefore === false) {
            dropIndicators.forEach(dropIndicator => {
              columnElement === null || columnElement === void 0 ? void 0 : columnElement.appendChild(dropIndicator);
            });
          } else {
            dropIndicators.forEach(dropIndicator => {
              var _insertBefore2;

              (((_insertBefore2 = insertBefore) === null || _insertBefore2 === void 0 ? void 0 : _insertBefore2.parentElement) || columnElement).insertBefore(dropIndicator, insertBefore);
            });
          }

          drag.lastCardElement = cardElement;
        }
      } // Update dragged cards dataset/color cls in case it is used for styling (as we do in demos)


      for (const card of drag.proxy.children) {
        if (!card.taskRecord.eventColor) {
          var _drag$targetSwimlane;

          const color = ((_drag$targetSwimlane = drag.targetSwimlane) === null || _drag$targetSwimlane === void 0 ? void 0 : _drag$targetSwimlane.color) || drag.targetColumn.color;

          if (card.originalColor) {
            card.classList.remove(`b-taskboard-color-${card.originalColor}`);
          }

          if (color) {
            card.originalColor = color;
            card.classList.add(`b-taskboard-color-${color}`);
          }
        }

        if (drag.targetSwimlane) {
          card.dataset.lane = drag.targetSwimlane.id;
        }

        card.dataset.column = drag.targetColumn.id;
      }

      if (shouldTrigger) {
        const {
          taskRecords,
          targetTaskRecord,
          position
        } = drag,

        /**
         * Fires on the owning TaskBoard when tasks are dragged, if the drag leads to any changes compared to
         * the last taskDrag event (moved to a new column or changed order within a column).
         *
         * Returning `false` from a listener will flag the drag as invalid (by default turning the drop
         * indicator red)
         *
         * @event taskDrag
         * @on-owner
         * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
         * @param {TaskBoard.model.TaskModel[]} taskRecords Dragged tasks
         * @param {TaskBoard.model.ColumnModel} targetColumn Currently over this column
         * @param {TaskBoard.model.SwimlaneModel} targetSwimlane Currently over this swimlane (if used)
         */
        result = client.trigger('taskDrag', {
          drag,
          taskRecords,
          targetSwimlane,
          targetColumn,
          targetTaskRecord,
          position
        });
        me.updateValidity(drag, result !== false);
      }
    }
  }

  async dragDrop(drag) {
    const me = this,
          {
      client
    } = me.owner,
          {
      dropIndicators,
      taskRecords,
      targetSwimlane,
      targetColumn,
      targetTaskRecord
    } = drag,
          event = {
      drag,
      event: drag.event,
      taskRecords,
      targetSwimlane,
      targetColumn,
      targetTaskRecord
    },
          // Check that drop will lead to changes for at least one dragged task
    changed = hasChanged(dropIndicators);
    /**
     * Fires on the owning TaskBoard when tasks are dropped, before the operation completes. Handles async
     * listeners, returning `false` from one will abort the operation
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *    listeners : {
     *        async beforeTaskDrop({ taskRecords, targetColumn }) {
     *            // Show confirmation dialog
     *            const result = await MessageDialog.confirm({
     *                title   : 'Verify drop',
     *                message : `Please confirm moving ${taskRecords.map(t => `"${t.name}"`).join(', ')} to ${targetColumn.text}?`
     *            });
     *
     *            // Returning false will abort the drop (if user pressed Cancel)
     *            return result === MessageDialog.okButton;
     *        }
     *    }
     * });
     * ```
     *
     * @event beforeTaskDrop
     * @preventable
     * @async
     * @on-owner
     * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
     * @param {TaskBoard.model.TaskModel[]} taskRecords Dropped tasks
     * @param {TaskBoard.model.ColumnModel} targetColumn Dropped on this column
     * @param {TaskBoard.model.SwimlaneModel} targetSwimlane Dropped in this swimlane (if used)
     */

    if (!changed || !targetColumn || drag.invalid || (await client.trigger('beforeTaskDrop', event)) === false) {
      drag.valid = false;
    } else {
      drag.finalizer = new Promise(resolve => {
        // Data part
        const {
          columnField,
          swimlaneField
        } = client,
              {
          taskStore
        } = client.project,
              {
          proxy
        } = drag,
              columnRecords = targetColumn.tasks,
              swimlaneRecords = targetSwimlane ? columnRecords === null || columnRecords === void 0 ? void 0 : columnRecords.filter(task => task[swimlaneField] === targetSwimlane.id) : columnRecords,
              invalid = !columnRecords;
        let moveBefore;

        if (!invalid) {
          // Dropped relative to another card?
          if (drag.targetTaskRecord) {
            // If before it, move to before it in store too
            if (drag.position === 'before') {
              moveBefore = targetTaskRecord;
            } // If after, move to before the next record
            else if (drag.position === 'after') {
              var _swimlaneRecords;

              const index = swimlaneRecords.indexOf(targetTaskRecord);
              moveBefore = (_swimlaneRecords = swimlaneRecords[index + 1]) !== null && _swimlaneRecords !== void 0 ? _swimlaneRecords : null;
            }
          } // Dropped below all cards or in empty column, move to last in store which guarantees it is last in that column
          else if (swimlaneRecords.length) {
            moveBefore = null;
          }
        }

        function commit() {
          // Remove proxy & dropIndicators
          proxy.remove();
          dropIndicators.forEach(dropIndicator => {
            const {
              taskElement
            } = dropIndicator.elementData; // Move original element to the new destination

            dropIndicator.parentElement.insertBefore(taskElement, dropIndicator); // Make it available for syncing

            dropIndicator.parentElement.syncIdMap[taskElement.elementData.taskId] = taskElement; // And unflag it

            taskElement.classList.remove('b-drag-original');
            dropIndicator.remove();
          });
          client.suspendDomTransition(); // Update data

          if (!invalid) {
            let newWeight; // Determine new weight

            if (moveBefore) {
              const // Successors, that might need to have their weight updated
              below = swimlaneRecords.slice(swimlaneRecords.indexOf(moveBefore)),
                    // Predecessor, we want to squeeze in after it weight-wise
              above = swimlaneRecords[swimlaneRecords.indexOf(moveBefore) - 1];
              let weightDiff; // We have a predecessor, put us between the card we "replace" and it to update as few
              // weights as possible

              if (above) {
                // Between tasks, down to 1 sized gaps
                weightDiff = Math.max(1, Math.round((moveBefore.weight - above.weight) / 2));
                newWeight = above.weight + weightDiff;
              } // First in column, put us between old first task and 0 in weight
              else {
                newWeight = Math.max(1, Math.round(moveBefore.weight / 2));
              } // Update weight for successors that have colliding weights.
              // New weight will be between current and next, to try and avoid having to change
              // multiple weights while also leaving gaps for future drops


              while (((_below$ = below[0]) === null || _below$ === void 0 ? void 0 : _below$.weight) === newWeight) {
                var _below$;

                // Place halfway between this and next task
                weightDiff = below[1] ? Math.max(1, Math.round((below[1].weight - newWeight) / 2)) : 50;
                newWeight = below[0].weight = newWeight + weightDiff;
                below.shift();
              }
            } // Last, add 100 to current lasts weight
            else {
              newWeight = swimlaneRecords.length ? swimlaneRecords[swimlaneRecords.length - 1].weight + 100 : 100;
            }

            taskRecords.forEach((taskRecord, i) => {
              const toSet = {
                [columnField]: targetColumn.id,
                weight: newWeight
              };

              if (targetSwimlane) {
                toSet[swimlaneField] = targetSwimlane.id;
              }

              if (moveBefore !== undefined) {
                taskStore.move(taskRecord, moveBefore);
              }

              taskRecord.set(toSet);
            });
          }

          client.resumeDomTransition();
          /**
           * Fires on the owning TaskBoard when tasks are successfully dropped (after the drop transition has
           * finished)
           * @event taskDrop
           * @on-owner
           * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
           * @param {TaskBoard.model.TaskModel[]} taskRecords Dropped tasks
           * @param {TaskBoard.model.ColumnModel} targetColumn Dropped on this column
           * @param {TaskBoard.model.SwimlaneModel} targetSwimlane Dropped in this swimlane (if used)
           */

          client.trigger('taskDrop', {
            drag,
            event,
            taskRecords,
            targetSwimlane,
            targetColumn,
            moveBefore
          });
          /**
           * Fires on the owning TaskBoard when a previously started drag operation ends, no matter the
           * outcome of it (whether valid, invalid or aborted)
           *
           * @event taskDragEnd
           * @on-owner
           * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
           * @param {TaskBoard.model.TaskModel[]} taskRecords Affected tasks
           */

          client.trigger('taskDragEnd', {
            drag,
            taskRecords
          });
          client.element.classList.remove('b-dragging-task');
          resolve();
        } // UI part


        const cardClones = Array.from(proxy.children); // Ugly "hack" to force the transforms used in the proxy to go away

        proxy.classList.add('b-pre-dropping');
        cardClones[0].offsetWidth; // We are dropping, this cls by default has a transition

        proxy.classList.add('b-dropping'); // Move proxy cards to drop locations, allowing them to transition there

        cardClones.forEach((cardClone, i) => {
          const dropClone = dropIndicators[i];
          _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].alignTo(cardClone, // Ignore page scroll when trying to align element in float root to element in taskboard
          _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(dropClone, undefined, true));
        }); // Update record after the transition, to prevent too early redraw (which would ruin the transition)

        if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getPropertyTransitionDuration(cardClones[0], 'transform')) {
          _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].onTransitionEnd({
            element: cardClones[0],
            property: 'transform',
            handler: commit,
            thisObj: client // For timer cleanup

          });
        } // Or right away if no transition is used
        else {
          commit();
        }
      });
    }
  }

  dragLeave(drag) {
    // Move drop indicator to dragged cards origin, to indicate what will happen on invalid drop
    drag.dropIndicators.forEach(dropIndicator => {
      const {
        taskElement
      } = dropIndicator.elementData;
      taskElement.parentElement.insertBefore(dropIndicator, taskElement);
    });
  }

  doAbort(drag) {
    const {
      client
    } = this.owner,
          {
      dropIndicators,
      proxy,
      taskRecords
    } = drag;

    if (proxy) {
      const cardClones = Array.from(proxy.children);

      function finalizeAbort() {
        // Remove proxy & dropIndicators
        proxy.remove();
        dropIndicators.forEach(dropIndicator => {
          dropIndicator.elementData.taskElement.classList.remove('b-drag-original');
          dropIndicator.remove();
        });
        client.element.classList.remove('b-dragging-task');
        client.trigger('taskDragAbortFinalized');
      } // Emulate drop to enable transitions


      proxy.classList.add('b-dropping'); // Move drop indicators to where each task originated

      dropIndicators.forEach(dropIndicator => {
        const {
          taskElement
        } = dropIndicator.elementData;
        dropIndicator.classList.remove('b-invalid'); // Looks better this way when returning to origin

        taskElement.parentElement.insertBefore(dropIndicator, taskElement);
      }); // Move proxy cards to original locations, allowing them to transition there

      cardClones.forEach((cardClone, i) => {
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].alignTo(cardClone, // Ignore page scroll when trying to align element in float root to element in taskboard
        _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(dropIndicators[i], undefined, true));
      }); // Finalize after transition

      if (_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getPropertyTransitionDuration(cardClones[0], 'transform')) {
        _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].onTransitionEnd({
          element: cardClones[0],
          property: 'transform',
          handler: finalizeAbort,
          thisObj: client // For timer cleanup

        });
      } // Or right away if no transition is used
      else {
        finalizeAbort();
      }
    }
    /**
     * Fires on the owning TaskBoard when a drag operation is aborted (invalid drop or aborted using ESC)
     *
     * @event taskDragAbort
     * @on-owner
     * @param {TaskBoard.view.TaskBoard} source Owning TaskBoard
     * @param {TaskBoard.model.TaskModel[]} taskRecords Dragged tasks
     */


    client.trigger('taskDragAbort', {
      drag,
      taskRecords
    });

    if (drag.wasStarted) {
      // Documented in dragDrop()
      client.trigger('taskDragEnd', {
        drag,
        taskRecords
      });
    }
  }

  dragEnd(drag) {
    // Move all cards back to their original location when drag was aborted
    if (!drag.valid || drag.aborted) {
      this.doAbort(drag);
    }
  }

}

TaskDrag._$name = 'TaskDrag';

/***/ }),

/***/ "./lib/TaskBoard/feature/TaskDragSelect.js":
/*!*************************************************!*\
  !*** ./lib/TaskBoard/feature/TaskDragSelect.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskDragSelect; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TaskBoardFeature.js */ "./lib/TaskBoard/feature/TaskBoardFeature.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';





/**
 * @module TaskBoard/feature/TaskDragSelect
 */

/**
 * Enables users to click and drag to select cards on the TaskBoard (marquee selection).
 *
 * {@inlineexample TaskBoard/feature/TaskDragSelect.js}
 *
 * This feature is **enabled** by default.
 *
 * @extends Core/mixin/InstancePlugin
 * @uninherit Core/Base
 * @uninherit Core/localization/Localizable
 * @classtype taskDragSelect
 * @feature
 */

class TaskDragSelect extends _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_4__["default"] {
  //region Type assertions
  changeDragThreshold(threshold) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertNumber(threshold, 'features.taskDragSelect.dragThreshold');
    return threshold;
  } //endregion


  initializeDragSelect(event) {
    const me = this,
          {
      client
    } = me;
    me.bounds = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(client.bodyElement,
    /* ignorePageScroll = */
    true);
    me.element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement({
      tag: 'div',
      className: 'b-dragselect-rect'
    }, true)[0];
    client.floatRoot.appendChild(me.element);
    client.element.classList.add('b-dragselecting'); // Since the dragselect element is in the floatRoot, we want to use viewport-based coordinates, so we pass
    // ignorePageScroll=true when calling Rectangle.from():

    me.cardRectangles = Array.from(client.element.querySelectorAll('.b-taskboard-card')).map(el => ({
      rectangle: _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"].from(el,
      /* ignorePageScroll = */
      true),
      record: client.resolveTaskRecord(el)
    }));

    if (!event.ctrlKey) {
      client.deselectAll();
    } // No key processing during drag selection


    client.navigateable = false;
    me.state = 'selecting';
  } // Select cards intersected by the selection marquee


  updateSelection() {
    const {
      cardRectangles,
      rectangle,
      client
    } = this;

    for (let i = 0, len = cardRectangles.length; i < len; i++) {
      const cardData = cardRectangles[i],
            shouldSelect = rectangle.intersect(cardData.rectangle, true);

      if (shouldSelect && !cardData.selected) {
        cardData.selected = true;
        client.selectTask(cardData.record, true);
      } else if (!shouldSelect && cardData.selected) {
        cardData.selected = false;
        client.deselectTask(cardData.record);
      }
    }
  } //region Listeners


  onColumnMouseDown({
    event
  }) {
    const me = this;

    if (!me.disabled && event.button === 0) {
      me.state = 'considering';
      me.startX = event.clientX;
      me.startY = event.clientY;
      me.mouseUpDetacher = _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].on({
        element: document,
        mouseup: 'onMouseUp',
        thisObj: me
      });
    }
  }

  onMouseMove({
    event
  }) {
    const me = this,
          {
      startX,
      startY
    } = me,
          {
      clientX,
      clientY
    } = event;

    if (me.state === 'considering') {
      const deltaX = Math.abs(clientX - startX),
            deltaY = Math.abs(clientY - startY);

      if (deltaX > me.dragThreshold || deltaY > me.dragThreshold) {
        me.initializeDragSelect(event);
      }
    }

    if (me.state === 'selecting') {
      const {
        element,
        bounds
      } = me,
            x = Math.max(clientX, bounds.left),
            y = Math.max(clientY, bounds.top),
            left = Math.min(startX, x),
            top = Math.min(startY, y),
            width = Math.abs(startX - x),
            height = Math.abs(startY - y),
            rect = new _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_3__["default"](left, top, width, height).constrainTo(bounds);
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].setTranslateXY(element, rect.left, rect.top);
      element.style.width = rect.width + 'px';
      element.style.height = rect.height + 'px';
      me.rectangle = rect;
      me.updateSelection();
    }
  }

  onMouseUp() {
    var _me$mouseUpDetacher;

    const me = this,
          {
      client,
      state
    } = me; // Cards are selected during mouse move, no need to change selection here

    if (state === 'selecting') {
      var _me$element;

      (_me$element = me.element) === null || _me$element === void 0 ? void 0 : _me$element.remove();
      client.element.classList.remove('b-dragselecting'); // Navigator will react to the 'click' event which clears selection, bypass this with a short timeout

      client.setTimeout(() => client.navigateable = true, 100);
    }

    if (state === 'selecting' || state === 'considering') {
      me.state = 'idle';
      me.startX = me.startY = me.rectangle = me.bounds = null;
    }

    (_me$mouseUpDetacher = me.mouseUpDetacher) === null || _me$mouseUpDetacher === void 0 ? void 0 : _me$mouseUpDetacher.call(me);
  } //endregion


}

_defineProperty(TaskDragSelect, "$name", 'TaskDragSelect');

_defineProperty(TaskDragSelect, "type", 'taskDragSelect');

_defineProperty(TaskDragSelect, "configurable", {
  /**
   * The amount of pixels to move pointer/mouse before it counts as a drag select operation.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *    features : {
   *        taskDragSelect : {
   *            dragThreshold : 10
   *        }
   *    }
   * });
   * ```
   *
   * @config {Number}
   * @default
   */
  dragThreshold: 5
});

_defineProperty(TaskDragSelect, "properties", {
  state: 'idle'
});

_defineProperty(TaskDragSelect, "pluginConfig", {
  chain: ['onColumnMouseDown', 'onMouseMove']
});

TaskDragSelect.initClass();
TaskDragSelect._$name = 'TaskDragSelect';

/***/ }),

/***/ "./lib/TaskBoard/feature/TaskEdit.js":
/*!*******************************************!*\
  !*** ./lib/TaskBoard/feature/TaskEdit.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskEdit; });
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TaskBoardFeature.js */ "./lib/TaskBoard/feature/TaskBoardFeature.js");
/* harmony import */ var _widget_TaskEditor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../widget/TaskEditor.js */ "./lib/TaskBoard/widget/TaskEditor.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';





/**
 * @module TaskBoard/feature/TaskEdit
 */

/**
 * This features allows the user to edit tasks in a popup editor that can either be shown centered on screen (the
 * default, double click a task to show the editor):
 *
 * {@inlineexample TaskBoard/feature/TaskEdit.js}
 *
 * Or anchored to a task:
 *
 * {@inlineexample TaskBoard/feature/TaskEditAnchored.js}
 *
 * ## Default items
 *
 * By default it displays the following items:
 *
 * | Ref           | Type                                                   | Weight | Comment                                                                   |
 * |---------------|--------------------------------------------------------|--------|---------------------------------------------------------------------------|
 * | `name`        | {@link Core.widget.TextField text}                     | 100    | Task {@link TaskBoard.model.TaskModel#field-name}                         |
 * | `description` | {@link Core.widget.TextAreaField textarea}             | 200    | Task {@link TaskBoard.model.TaskModel#field-description}                  |
 * | `resources`*  | {@link TaskBoard.widget.ResourcesCombo resourcescombo} | 300    | Assigned resources                                                        |
 * | `color`       | {@link TaskBoard.widget.TaskColorCombo taskcolorcombo} | 400    | Task {@link TaskBoard.model.TaskModel#field-eventColor}                   |
 * | `column`      | {@link TaskBoard.widget.ColumnCombo columncombo}       | 500    | Bound to configured {@link TaskBoard.view.TaskBoard#config-columnField}   |
 * | `swimlane`*   | {@link TaskBoard.widget.SwimlaneCombo swimlanecombo}   | 600    | Bound to configured {@link TaskBoard.view.TaskBoard#config-swimlaneField} |
 * <sup>*</sup> Only shown when using resources / swimlanes respectively
 *
 * You can modify or remove the default items and add new custom items to the editor either at config time by using the
 * {@link #config-items items config} or at runtime by using the {@link #config-processItems processItems config}.
 *
 * ## Customize when configuring
 *
 * The {@link #config-items items config} accepts an object keyed by item ref (as listed in the table above). This
 * object will be merged with default items and the end result will determine which items are shown and how they are
 * configured.
 *
 * ### To remove a default item
 *
 * Set a ref to `null` to remove the item from the editor:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *    features : {
 *        taskEdit : {
 *            items : {
 *                // Remove the color field
 *                color : null
 *            }
 *        }
 *    }
 * });
 * ```
 *
 * {@inlineexample TaskBoard/feature/TaskEditRemove.js}
 *
 * ### To modify a default item
 *
 * Supply an object with the configs you want to change for a ref to modify the corresponding field:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *    features : {
 *        taskEdit : {
 *            items : {
 *                // Change label of the description field and move it to the bottom
 *                description : {
 *                    label : 'Comment',
 *                    weight : 700
 *                }
 *            }
 *        }
 *    }
 * });
 * ```
 *
 *  {@inlineexample TaskBoard/feature/TaskEditModify.js}
 *
 * ### To add a custom item
 *
 * Supply a config object for the new item, using a ref that is not used by any default item:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *    features : {
 *        taskEdit : {
 *            items : {
 *                // Change label of the description field and move it to the bottom
 *                deadline : {
 *                    type   : 'date',
 *                    label  : 'Deadline',
 *                    weight : 300,
 *                    name   : 'deadline' // Bound field. If it matches the ref (key) for the field, it can be left out
 *                }
 *            }
 *        }
 *    }
 * });
 * ```
 *
 *  {@inlineexample TaskBoard/feature/TaskEditAdd.js}
 *
 * ## Customize at runtime
 *
 * By supplying a function to {@link #config-processItems} you gain runtime control over which items are shown and how
 * they are configured:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *    features : {
 *        taskEdit : {
 *            processItems({ taskRecord, items }) {
 *                // Hide description for tasks that are done
 *                if (taskRecord.status === 'done') {
 *                    items.description = null;
 *                }
 *
 *                // Modify the label for the name field
 *                items.name.label = 'Title';
 *
 *                // Add a custom item for high prio tasks
 *                if (taskRecord.prio === 'high') {
 *                    items.severity = { type : 'number', name : 'severity', label : 'Severity' }
 *                }
 *            }
 *        }
 *    }
 * });
 * ```
 *
 * You can also use `processItems` to prevent the editor from being shown for certain tasks, by returning `false` from
 * the function.
 *
 * {@inlineexample TaskBoard/feature/TaskEditProcessItems.js}
 *
 * ## Customizing other aspects of the editor
 *
 * By supplying an {@link #config-editorConfig} you can customize other aspects of the editor, such as its size, how
 * it is anchored, its title etc.
 *
 * {@inlineexample TaskBoard/feature/TaskEditEditorConfig.js}
 *
 * This feature is **enabled** by default.
 *
 * @extends TaskBoard/feature/TaskBoardFeature
 * @uninherit Core/Base
 * @uninherit Core/localization/Localizable
 * @classtype taskEdit
 * @feature
 */

class TaskEdit extends _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_3__["default"] {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "editor", null);
  }

  doDestroy() {
    var _this$editor;

    (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.destroy();
  } //region Type assertions


  changeEditorConfig(editorConfig) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertObject(editorConfig, 'features.taskEdit.editorConfig');
    return editorConfig;
  }

  changeEditorType(editorType) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertString(editorType, 'features.taskEdit.editorType');
    return editorType;
  }

  changeItems(items) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertObject(items, 'features.taskEdit.items');
    return items;
  }

  changeProcessItems(processItems) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertFunction(processItems, 'features.taskEdit.processItems');
    return processItems;
  } //endregion

  /**
   * Edit the supplied task in the task editor.
   *
   * ```javascript
   * taskBoard.editTask(taskStore.first);
   * ```
   *
   * @param {TaskBoard.model.TaskModel} taskRecord Task to edit
   * @param {HTMLElement} [element] Optionally an element to align to, by default it tries to resolve one from the
   * supplied task when the editor is configured to not be centered.
   * @on-owner
   */


  editTask(taskRecord, element = null) {
    var _client$swimlanes, _me$processItems;

    const me = this,
          {
      client
    } = me,
          columnRecord = client.getColumn(taskRecord),
          swimlaneRecord = client.swimlaneField && ((_client$swimlanes = client.swimlanes) === null || _client$swimlanes === void 0 ? void 0 : _client$swimlanes.getById(taskRecord[client.swimlaneField]));

    if (me.disabled || taskRecord.readOnly) {
      return;
    }

    if (me.isEditing) {
      me.cancelEdit();
    } // TODO : Ask Don about combinedItems


    const editorClass = _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_0__["default"].resolveType(me.editorType),
          // Combine items defined on the feature with those defined on the editor
    combinedItems = editorClass.mergeConfigs(editorClass.$meta.config.items, me.items),
          // Allow user supplied fn to process the items, returning false will abort edit
    processResult = (_me$processItems = me.processItems) === null || _me$processItems === void 0 ? void 0 : _me$processItems.call(me, {
      items: combinedItems,
      taskRecord,
      columnRecord,
      swimlaneRecord
    });

    if (processResult === false) {
      return;
    }

    const editor = me.editor = editorClass.new({
      items: combinedItems,
      owner: client,
      record: taskRecord
    }, me.editorConfig);

    if (editor.centered || !_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].isHoverableDevice) {
      editor.show();
    } else {
      editor.showBy(element !== null && element !== void 0 ? element : client.getTaskElement(taskRecord));
    }

    editor.on({
      hide: me.onEditorHide,
      thisObj: me
    });
  }

  cancelEdit() {}

  onActivateTask({
    taskRecord,
    event
  }) {
    if (!event.defaultPrevented) {
      this.editTask(taskRecord);
    }
  }

  populateTaskMenu({
    items,
    taskRecord
  }) {
    if (!this.client.readOnly && !this.disabled) {
      items.editTask = {
        text: 'L{TaskBoard.editTask}',
        icon: 'b-fw-icon b-icon-edit',
        weight: 100,
        onItem: () => this.editTask(taskRecord),
        disabled: taskRecord.readOnly
      };
    }
  }

  onEditorHide() {
    this.client.getTaskElement(this.editor.record).focus();
  }

}

_defineProperty(TaskEdit, "$name", 'TaskEdit');

_defineProperty(TaskEdit, "type", 'taskEdit');

_defineProperty(TaskEdit, "configurable", {
  /**
   * Type of widget to use as the editor. Should point to a subclass of {@link TaskBoard.widget.TaskEditor} or
   * a widget mimicking its API.
   * @config {String}
   * @default
   * @category Customization
   */
  editorType: 'taskboardtaskeditor',

  /**
   * Config object merged with the default configuration of the editor (by default a
   * {@link TaskBoard.widget.TaskEditor}).
   *
   * Can be used to configure any aspect of the editor:
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *     features : {
   *         taskEdit : {
   *             editorConfig : {
   *                 modal    : false,
   *                 centered : false
   *             }
   *         }
   *     }
   * });
   * ```
   * To customize the items in the editor, using {@link #config-items} is preferable.
   * @config {Object}
   * @category Customization
   */
  editorConfig: {},

  /**
   * Items definition passed on to the configured editor (by default a {@link TaskBoard.widget.TaskEditor}).
   *
   * Can be used to add new items or modify and remove predefined items.
   *
   * @config {Object}
   * @category Customization
   */
  items: {},

  /**
   * A function called before displaying the editor that allows manipulation of its items.
   * Returning `false` from this function prevents the editor from being shown.
   *
   * ```javascript
   * features         : {
   *    taskEdit : {
   *         processItems({ items, taskRecord, columnRecord, swimlaneRecord }) {
   *             // Manipulate existing items here as needed
   *             items.name.label = taskRecord.type === 'task' ? 'Task' : 'Issue';
   *
   *            // Remove column field when editing tasks that are done
   *            if (columnRecord.id === 'done') {
   *                items.column = false
   *            }
   *         }
   *     }
   * },
   * ```
   *
   * @param {Object} context An object with information about the editor being shown
   * @param {Object} context.items An object containing the editor item configs keyed by ref
   * @param {TaskBoard.model.TaskModel} context.taskRecord Record representing task being edited
   * @param {TaskBoard.model.ColumnModel} context.columnRecord Record representing tasks column
   * @param {TaskBoard.model.SwimlaneModel} context.swimlaneRecord Record representing tasks swimlane
   * @config {Function}
   * @preventable
   */
  processItems: null // /**
  //  * The event that shall trigger showing the editor. Defaults to `eventdblclick`, set to `` or null to disable editing of existing events.
  //  * @config {String}
  //  * @default
  //  * @category Editor
  //  */
  // triggerEvent : 'eventdblclick',
  // /**
  //  * Specify `true` to put the editor in read only mode.
  //  * @config {Boolean}
  //  * @default false
  //  */
  // readOnly : null,

});

_defineProperty(TaskEdit, "pluginConfig", {
  assign: ['editTask'],
  chain: ['onActivateTask', 'populateTaskMenu']
});

TaskEdit.initClass();
TaskEdit._$name = 'TaskEdit';

/***/ }),

/***/ "./lib/TaskBoard/feature/TaskMenu.js":
/*!*******************************************!*\
  !*** ./lib/TaskBoard/feature/TaskMenu.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskMenu; });
/* harmony import */ var _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskBoardFeature.js */ "./lib/TaskBoard/feature/TaskBoardFeature.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/feature/base/ContextMenuBase.js */ "./lib/Core/feature/base/ContextMenuBase.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';




/**
 * @module TaskBoard/feature/TaskMenu
 */

/**
 * Displays a context menu for tasks. Items are populated by other features and/or application code.
 *
 * {@inlineexample TaskBoard/feature/TaskMenu.js}
 *
 * You can optionally also use a {@link TaskBoard/view/item/TaskMenuItem} button to display the menu.
 *
 * ## Default items
 *
 * These are the default items provided by TaskBoard features:
 *
 * | Reference    | Weight | Feature                            | Description                                      |
 * |--------------|--------|------------------------------------|--------------------------------------------------|
 * | `editTask`   | 100    | {@link TaskBoard.feature.TaskEdit} | Open task editor. Hidden when read-only          |
 * | `resources`  | 200    | *This feature*                     | Assign/unassign resources. Hidden when read-only |
 * | `column`     | 300    | *This feature*                     | Move to column. Hidden when read-only            |
 * | `swimlane`   | 400    | *This feature*                     | Move to swimlane. Hidden when read-only          |
 * | `removeTask` | 500    | *This feature*                     | Remove task. Hidden when read-only               |
 *
 * Default items in the menu can be changed or removed and new items can be added. This is handled using the
 * {@link #config-items} config of the feature.
 *
 * ## Add items
 *
 * Add menu items for all tasks by adding a key (used as menu item {@link Core/widget/Widget#config-ref}) with a
 * {@link Core/widget/MenuItem#configs config object for a menu item} as the value to the {@link #config-items} config:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     features : {
 *         taskMenu : {
 *             items : {
 *                 flagTask : {
 *                     text : 'Flag task',
 *                     icon : 'b-fa-fw b-fa-flag',
 *                     onItem({ taskRecord }) {
 *                         taskRecord.flagged = true;
 *                     }
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * {@inlineexample TaskBoard/feature/TaskMenuAdd.js}
 *
 * ## Remove items
 *
 * To remove default items, configure them as `null` in the {@link #config-items} config:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     features : {
 *         taskMenu : {
 *             items : {
 *                 removeTask : null,
 *                 resources : null
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * {@inlineexample TaskBoard/feature/TaskMenuRemove.js}
 *
 * ## Customize items
 *
 * To customize default items, supply a new config object for them in the {@link #config-items} config. It will merge
 * with the default config object:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     features : {
 *         taskMenu : {
 *             items : {
 *                 removeTask : {
 *                     text : 'Delete card'
 *                 }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * {@inlineexample TaskBoard/feature/TaskMenuCustomize.js}
 *
 * ## Manipulating items at runtime
 *
 * Manipulate items for all tasks or specific tasks at runtime by supplying a {@link #config-processItems} function:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     features : {
 *         taskMenu : {
 *             // Process items before menu is shown
 *             processItems({ taskRecord, items }) {
 *                  // Push an extra item for done tasks
 *                  if (taskRecord.status === 'done') {
 *                      items.archive = {
 *                          text : 'Archive',
 *                          icon : 'b-fa-fw b-fa-archive'
 *                          onItem({ taskRecord }) {
 *                              taskRecord.archived = true;
 *                          }
 *                      };
 *                  }
 *
 *                  // Do not show menu for low prio tasks
 *                  if (taskRecord.prio === 'low') {
 *                      return false;
 *                  }
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * {@inlineexample TaskBoard/feature/TaskMenuProcessItems.js}
 *
 * This feature is **enabled** by default.
 *
 * @extends TaskBoard/feature/TaskBoardFeature
 * @uninherit Core/Base
 * @uninherit Core/localization/Localizable
 * @classtype taskMenu
 * @feature
 */

class TaskMenu extends _Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_3__["default"] {
  static get pluginConfig() {
    const config = super.pluginConfig;
    config.chain.push('populateTaskMenu');
    return config;
  } //region Type assertions


  changeItems(items) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertObject(items, 'features.taskMenu.items');
    return items;
  }

  changeProcessItems(processItems) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertFunction(processItems, 'features.taskMenu.processItems');
    return processItems;
  } //endregion
  //region Events

  /**
   * This event fires on the owning TaskBoard before the context menu is shown for a task.
   * Allows manipulation of the items to show in the same way as in the {@link #config-processItems}.
   *
   * Returning `false` from a listener prevents the menu from being shown.
   *
   * @event taskMenuBeforeShow
   * @on-owner
   * @preventable
   * @param {TaskBoard.view.TaskBoard} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} items Menu item configs
   * @param {TaskBoard.model.TaskModel} taskRecord The task
   * @on-owner
   */

  /**
   * This event fires on the owning TaskBoard after the context menu is shown for a task.
   * @event cellMenuShow
   * @on-owner
   * @param {TaskBoard.view.TaskBoard} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} items Menu item configs
   * @param {TaskBoard.model.TaskModel} taskRecord The task
   * @on-owner
   */

  /**
   * This event fires on the owning TaskBoard when an item is selected in the task context menu.
   * @event cellMenuItem
   * @on-owner
   * @param {TaskBoard.view.TaskBoard} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} item Selected menu item
   * @param {TaskBoard.model.TaskModel} taskRecord The task
   * @on-owner
   */

  /**
   * This event fires on the owning TaskBoard when a check item is toggled in the task context menu.
   * @event cellMenuToggleItem
   * @on-owner
   * @param {TaskBoard.view.TaskBoard} source The grid
   * @param {Core.widget.Menu} menu The menu
   * @param {Object} item Selected menu item
   * @param {TaskBoard.model.TaskModel} taskRecord The task
   * @param {Boolean} checked Checked or not
   * @on-owner
   */
  //endregion


  updateTriggerEvent(triggerEvent) {
    this.detachListeners('triggerEvent');

    if (triggerEvent) {
      this.client.on({
        name: 'triggerEvent',
        [triggerEvent]: 'onTriggerEvent',
        thisObj: this
      });
    }
  }

  doDisable(disable) {
    super.doDisable(disable);
    !this.isConfiguring && this.client.recompose();
  }

  onTriggerEvent({
    event
  }) {
    this.internalShowContextMenu(event);
  } // MAKE PUBLIC


  showMenuFor(taskRecord) {
    const targetElement = this.client.getTaskElement(taskRecord),
          buttonElement = targetElement.querySelector('.b-taskboard-task-menu'),
          eventParams = {
      taskRecord,
      columnRecord: this.client.columns.getColumn(taskRecord),
      targetElement
    };
    let alignSpec = null; // TODO : Call something on the button instead?

    if (buttonElement) {
      eventParams.targetElement = buttonElement;
      alignSpec = {
        align: 't90-b90',
        anchor: true,
        target: buttonElement
      };
    }

    this.showContextMenu(eventParams, alignSpec);
  }

  showContextMenu(eventParams, ...args) {
    if (!this.client.isSelected(eventParams.taskRecord)) {
      this.client.selectTask(eventParams.taskRecord);
    }

    super.showContextMenu(eventParams, ...args);
  }

  getDataFromEvent(event) {
    return _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign(super.getDataFromEvent(event), event.taskBoardData);
  }

  populateTaskMenu({
    items,
    taskRecord
  }) {
    const {
      client,
      disabled
    } = this;

    if (!client.readOnly && !disabled) {
      var _client$swimlanes;

      const {
        columnField,
        swimlaneField,
        selectedTasks
      } = client,
            {
        resourceStore
      } = client.project,
            isSelected = selectedTasks.includes(taskRecord);
      items.column = {
        text: `L{TaskBoard.changeColumn} ${columnField}`,
        icon: 'b-fw-icon b-icon-move-left-right',
        weight: 300,
        disabled: taskRecord.readOnly,
        menu: client.columns.map(col => ({
          ref: col.id,
          text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeHtml(col.text),
          isColumn: true,
          checked: taskRecord[columnField] === col.id,
          // Close menu when task is moved to a new column, looks weird to keep it open
          closeParent: true
        })),

        onItem({
          item
        }) {
          if (item.isColumn) {
            taskRecord[columnField] = item.ref;
            item.parent.items.forEach(sibling => {
              if (sibling !== item) {
                sibling.checked = false;
              }
            });
          }
        }

      };

      if ((_client$swimlanes = client.swimlanes) !== null && _client$swimlanes !== void 0 && _client$swimlanes.count && swimlaneField) {
        items.swimlane = {
          text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].xss`L{TaskBoard.changeSwimlane} ${swimlaneField}`,
          icon: 'b-fw-icon b-icon-move-up-down',
          weight: 400,
          disabled: taskRecord.readOnly,
          menu: client.swimlanes.map(lane => ({
            ref: lane.id,
            text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeHtml(lane.text),
            isSwimlane: true,
            checked: taskRecord[swimlaneField] === lane.id,
            // Close menu when task is moved to a new swimlane, looks weird to keep it open
            closeParent: true
          })),

          onItem({
            item
          }) {
            if (item.isSwimlane) {
              taskRecord[swimlaneField] = item.ref;
              item.parent.items.forEach(sibling => {
                if (sibling !== item) {
                  sibling.checked = false;
                }
              });
            }
          }

        };
      }

      if (resourceStore.count) {
        items.resources = {
          text: 'L{TaskBoard.resources}',
          icon: 'b-fw-icon b-icon-user',
          weight: 200,
          disabled: taskRecord.readOnly,
          menu: resourceStore.map(resource => ({
            ref: resource.id,
            text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeHtml(resource.name),
            resource,
            checked: taskRecord.resources.includes(resource)
          })),

          onItem({
            item
          }) {
            if (item.resource) {
              taskRecord[item.checked ? 'assign' : 'unassign'](item.resource);
            }
          }

        };
      }

      items.removeTask = {
        text: isSelected && selectedTasks.length > 1 ? 'L{TaskBoard.removeTasks}' : 'L{TaskBoard.removeTask}',
        icon: 'b-fw-icon b-icon-trash',
        cls: 'b-separator',
        weight: 500,
        disabled: taskRecord.readOnly,
        onItem: () => client.project.taskStore.remove(isSelected ? selectedTasks : taskRecord)
      };
    }
  }

  get showMenu() {
    return true;
  }

} // Register this feature type with its Factory

_defineProperty(TaskMenu, "$name", 'TaskMenu');

_defineProperty(TaskMenu, "type", 'taskMenu');

_defineProperty(TaskMenu, "configurable", {
  /**
   * A function called before displaying the menu that allows manipulations of its items.
   * Returning `false` from this function prevents the menu from being shown.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *   features         : {
   *       taskMenu : {
   *           processItems({ taskRecord, items }) {
   *              // Add a custom menu item for tasks with progress greater than 90
   *              if (taskRecord.progress > 90) {
   *                  items.close = {
   *                      text : 'Close',
   *                      icon : 'b-fa-fw b-fa-check',
   *                      onItem({ taskRecord }) {
   *                          taskRecord.done = true;
   *                      }
   *                  }
   *              }
   *           }
   *       }
   *   }
   * });
   * ```
   *
   * @param {Object} context An object with information about the menu being shown
   * @param {TaskBoard.model.TaskModel} context.taskRecord The task for which the menu will be shown
   * @param {Object} context.items An object containing the {@link Core.widget.MenuItem menu item} configs keyed by their id
   * @param {Event} context.event The DOM event object that triggered the show
   * @config {Function}
   * @preventable
   */
  processItems: null,

  /**
   * This is a preconfigured set of items used to create the default context menu.
   *
   * The `items` provided by this feature are listed in the intro section of this class. You can configure
   * existing items by passing a configuration object to the keyed items.
   *
   * To remove existing items, set corresponding keys to `null`:
   *
   * ```javascript
   * const scheduler = new Scheduler({
   *     features : {
   *         taskMenu : {
   *             items : {
   *                 editTask : null
   *             }
   *         }
   *     }
   * });
   * ```
   *
   * See the feature config in the above example for details.
   *
   * @config {Object} items
   */
  items: null,
  type: 'task',

  /**
   * The mouse / touch gesture which should show this context menu (e.g. 'taskClick' or 'taskContextMenu').
   * Set to `false` to never trigger it from UI.
   * @default
   * @config {String|Boolean}
   */
  triggerEvent: 'taskContextMenu'
  /**
   * @hideconfigs type
   */

});

_TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_0__["default"].register(TaskMenu.type, TaskMenu);
TaskMenu._$name = 'TaskMenu';

/***/ }),

/***/ "./lib/TaskBoard/feature/TaskTooltip.js":
/*!**********************************************!*\
  !*** ./lib/TaskBoard/feature/TaskTooltip.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskTooltip; });
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony import */ var _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TaskBoardFeature.js */ "./lib/TaskBoard/feature/TaskBoardFeature.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';




/**
 * @module TaskBoard/feature/TaskTooltip
 */

/**
 * Displays a tooltip when hovering a task. By default the tooltip displays:
 *
 * * task name
 * * task column
 * * task swimlane (if using swimlanes)
 * * names of assigned resources (if any)
 *
 * {@inlineexample TaskBoard/feature/TaskTooltip.js}
 *
 * To customize the contents, supply your own {@link #config-template}:
 *
 * {@inlineexample TaskBoard/feature/TaskTooltipTemplate.js}
 *
 * This feature is **disabled** by default.
 *
 * @extends TaskBoard/feature/TaskBoardFeature
 * @uninherit Core/Base
 * @uninherit Core/localization/Localizable
 * @classtype taskTooltip
 * @feature
 */

class TaskTooltip extends _TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_3__["default"] {
  //region Type assertions
  changeTemplate(template) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertFunction(template, 'features.taskTooltip.template');
    return template;
  } //endregion


  doDisable(disable) {
    super.doDisable(disable);

    if (this._tooltip) {
      this.tooltip.disabled = disable;
    }
  }

  changeTooltip(tooltip, oldTooltip) {
    const me = this,
          {
      client
    } = me;
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertObject(tooltip, 'features.taskTooltip.tooltip');
    oldTooltip === null || oldTooltip === void 0 ? void 0 : oldTooltip.destroy();

    if (tooltip) {
      return new _Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_2__["default"](_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assign({
        axisLock: 'flexible',
        cls: 'b-taskboard-tooltip',
        forSelector: '.b-taskboardbase:not(.b-draghelper-active) .b-taskboard-card',
        scrollAction: 'realign',
        forElement: client.element,
        showOnHover: true,
        hoverDelay: 0,
        hideDelay: 100,
        anchorToTarget: true,
        allowOver: Boolean(me.config.items || me.config.tools),
        getHtml: me.getTipHtml.bind(me),
        disabled: me.disabled,
        textContent: false
      }, tooltip));
    }
  }

  getTipHtml({
    tip,
    activeTarget
  }) {
    const {
      client
    } = this,
          taskRecord = client.resolveTaskRecord(activeTarget),
          columnRecord = client.resolveColumnRecord(activeTarget),
          swimlaneRecord = client.resolveSwimlaneRecord(activeTarget);

    if (this.template) {
      return this.template({
        tip,
        taskRecord,
        columnRecord,
        swimlaneRecord,
        activeTarget
      });
    }

    const children = [{
      class: 'b-taskboard-tooltip-title',
      text: taskRecord.name
    }, {
      class: 'b-taskboard-tooltip-label',
      text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(client.columnField)
    }, {
      class: 'b-taskboard-tooltip-value',
      text: columnRecord.text
    }];

    if (swimlaneRecord) {
      children.push({
        class: 'b-taskboard-tooltip-label',
        text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(client.swimlaneField)
      }, {
        class: 'b-taskboard-tooltip-value',
        text: swimlaneRecord.text
      });
    }

    if (taskRecord.resources.length) {
      children.push({
        class: 'b-taskboard-tooltip-label',
        text: this.L('L{TaskBoard.resources}')
      }, {
        class: 'b-taskboard-tooltip-value',
        text: taskRecord.resources.map(resourceRecord => resourceRecord.name).join(', ')
      });
    }

    return {
      children
    };
  }

  render() {
    // Element is now available, pull in tooltip to have it correctly wired up
    this.getConfig('tooltip');
  }

}

_defineProperty(TaskTooltip, "$name", 'TaskTooltip');

_defineProperty(TaskTooltip, "type", 'taskTooltip');

_defineProperty(TaskTooltip, "configurable", {
  /**
   * Tooltip config object used to override the defaults, see {@link Core.widget.Tooltip#configs} for available
   * configs.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *     features : {
   *         taskTooltip : {
   *             tooltip : {
   *                 hoverDelay : 100,
   *                 hideDelay  : 500
   *             }
   *         }
   *     }
   * });
   * ```
   *
   * @config {Object}
   */
  tooltip: {
    value: {},
    // Lazy, pulled in on render to have element available
    $config: ['lazy', 'nullify']
  },

  /**
   * Function used to populate the tooltip, supply your own to override the default contents of the tooltip.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *     features : {
   *         taskTooltip : {
   *             template({ taskRecord }) {
   *                 return `<b>${taskRecord.name}</b>`
   *             }
   *         }
   *     }
   * });
   * ```
   *
   * @param {Object} tipData
   * @param {TaskBoard.model.TaskModel} tipData.taskRecord Hovered task
   * @param {TaskBoard.model.ColumnModel} tipData.columnRecord The task's column
   * @param {TaskBoard.model.SwimlaneModel} tipData.swimlaneRecord The task's swimlane (if used)
   * @returns {String|Object} Return a HTML string or a DOM config object
   * @config {Function}
   */
  template: null
});

_defineProperty(TaskTooltip, "pluginConfig", {
  chain: ['render']
});

TaskTooltip.initClass();
TaskTooltip._$name = 'TaskTooltip';

/***/ }),

/***/ "./lib/TaskBoard/localization/En.js":
/*!******************************************!*\
  !*** ./lib/TaskBoard/localization/En.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony import */ var _Core_localization_En_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/localization/En.js */ "./lib/Core/localization/En.js");
/* harmony import */ var _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/localization/LocaleHelper.js */ "./lib/Core/localization/LocaleHelper.js");
var productName = 'taskboard';
 //<umd>



const locale = _Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].mergeLocales(_Core_localization_En_js__WEBPACK_IMPORTED_MODULE_1__["default"], {
  //region Grid
  GridBase: {
    loadFailedMessage: 'Data loading failed!',
    syncFailedMessage: 'Data synchronization failed!'
  },
  //endregion
  //region Scheduler
  CrudManagerView: {
    serverResponseLabel: 'Server response:'
  },
  //endregion
  //region TaskBoard
  TaskBoard: {
    // Entity names, used in translations below
    task: 'task',
    tasks: 'tasks',
    swimlane: 'swimlane',
    swimlanes: 'swimlanes',
    Swimlanes: 'Swimlanes',
    column: 'column',
    columns: 'columns',
    Columns: 'Columns',
    // UI strings, uses the entity names above by default
    addTask: 'Add L{TaskBoard.task}',
    cancel: 'Cancel',
    collapse: text => `Collapse ${text}`,
    color: 'Color',
    changeColumn: 'Change L{TaskBoard.column}',
    changeSwimlane: 'Change L{TaskBoard.swimlane}',
    description: 'Description',
    editTask: 'Edit L{TaskBoard.task}',
    expand: text => `Expand ${text}`,
    filterColumns: 'Filter L{TaskBoard.columns}',
    filterSwimlanes: 'Filter L{TaskBoard.swimlanes}',
    filterTasks: 'Filter L{TaskBoard.tasks}',
    name: 'Name',
    moveColumnLeft: 'Move L{TaskBoard.column} left',
    moveColumnRight: 'Move L{TaskBoard.column} right',
    newTaskName: 'New L{TaskBoard.task}',
    removeTask: 'Remove L{TaskBoard.task}',
    removeTasks: 'Remove L{TaskBoard.tasks}',
    resources: 'Resources',
    save: 'Save',
    scrollToColumn: 'Scroll to L{TaskBoard.column}',
    scrollToSwimlane: 'Scroll to L{TaskBoard.swimlane}',
    zoom: 'Zoom'
  },
  TodoListField: {
    add: 'Add',
    newTodo: 'New todo'
  },
  UndoRedo: {
    UndoLastAction: 'Undo',
    RedoLastAction: 'Redo'
  } //endregion

});
/* harmony default export */ __webpack_exports__["default"] = (locale); //</umd>

_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerLocale('En', {
  desc: 'English',
  locale: locale
});

/***/ }),

/***/ "./lib/TaskBoard/model/ColumnModel.js":
/*!********************************************!*\
  !*** ./lib/TaskBoard/model/ColumnModel.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnModel; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module TaskBoard/model/ColumnModel
 */

/**
 * Represents a single column on a TaskBoard.
 *
 * When creating a TaskBoard, you supply an initial set of columns. These columns are either defined as plain strings,
 * ColumnModel data objects or ColumnModel records (or a mix thereof). When using strings, the string will be used as is
 * as the column's id and capitalized as its text.
 *
 * ```javascript
 * const doneColumn = new ColumnModel({
 *     id   : 'done',
 *     text : 'Done'
 * });
 *
 * const taskBoard = new TaskBoard({
 *     columns : [
 *         // String, equal to passing { id : 'todo', text : 'Todo' }
 *         'todo',
 *         // Data object, in this case with a fixed width and not collapsible from the UI
 *         { id : 'doing', text : 'Doing', width : 200, collapsible : false }
 *         // Record, not commonly used since it is easier to supply the data object directly
 *         doneColumn
 *     ]
 * });
 * ```
 *
 * @extends Core/data/Model
 * @uninherit Core/data/mixin/TreeNode
 */

class ColumnModel extends _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * Get the tasks in this column in visual order.
   * @property {TaskBoard.model.TaskModel[]}
   * @readonly
   */
  get tasks() {
    return this.taskBoard.getColumnTasks(this, true);
  }

  get taskBoard() {
    return this.firstStore.taskBoard;
  }
  /**
   * Collapse this column.
   *
   * Uses a transition by default, await the call to be certain that it has finished.
   *
   * @async
   * @category Expand/collapse
   * @returns {Promise} A promise which is resolved when the column is collapsed
   */


  async collapse() {
    return this.taskBoard.collapse(this);
  }
  /**
   * Expand this column.
   *
   * Uses a transition by default, await the call to be certain that it has finished.
   *
   * @async
   * @category Expand/collapse
   * @returns {Promise} A promise which is resolved when the column is expanded
   */


  async expand() {
    return this.taskBoard.expand(this);
  }

}

_defineProperty(ColumnModel, "fields", [
/**
 * This column's unique id, used to match a task to a column (which field on a task to match is specified using
 * then {@link TaskBoard.view.TaskBoardBase#config-columnField} config on TaskBoard).
 * @field {String|Number} id
 */

/**
 * Text displayed in the column header.
 * @field {String} text
 */
'text',
/**
 * Color, applied as a `b-taskboard-color-{color}` (`b-taskboard-color-red`) CSS class to the column.
 *
 * By default it does not visually affect the UI, but it applies a color to the column that applications can
 * leverage using `currentColor` to style it in the desired way.
 *
 * For example:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     columns : [
 *         { id : 'todo', text : 'Todo', color : 'orange' }
 *     ]
 * });
 * ```
 *
 * Will result in:
 *
 * ```html
 * <div class="b-taskboard-column b-taskboard-color-orange">
 * ```
 *
 * Which can the be used for example like:
 *
 * ```css
 * .b-taskboard-column-header {
 *     border-left : 5px solid currentColor; // where currentColor is the color defined by b-taskboard-color-orange
 * }
 * ```
 *
 * Predefined colors (actual color might vary by theme):
 * <div class="b-colorbox b-inline b-taskboard-color-red"></div>red,
 * <div class="b-colorbox b-inline b-taskboard-color-pink"></div>pink,
 * <div class="b-colorbox b-inline b-taskboard-color-purple"></div>purple,
 * <div class="b-colorbox b-inline b-taskboard-color-deep-purple"></div>deep-purple,
 * <div class="b-colorbox b-inline b-taskboard-color-indigo"></div>indigo,
 * <div class="b-colorbox b-inline b-taskboard-color-blue"></div>blue,
 * <div class="b-colorbox b-inline b-taskboard-color-light-blue"></div>light-blue,
 * <div class="b-colorbox b-inline b-taskboard-color-cyan"></div>cyan,
 * <div class="b-colorbox b-inline b-taskboard-color-teal"></div>teal,
 * <div class="b-colorbox b-inline b-taskboard-color-green"></div>green,
 * <div class="b-colorbox b-inline b-taskboard-color-light-green"></div>light-green,
 * <div class="b-colorbox b-inline b-taskboard-color-lime"></div>lime,
 * <div class="b-colorbox b-inline b-taskboard-color-yellow"></div>yellow,
 * <div class="b-colorbox b-inline b-taskboard-color-amber"></div>amber,
 * <div class="b-colorbox b-inline b-taskboard-color-orange"></div>orange,
 * <div class="b-colorbox b-inline b-taskboard-color-deep-orange"></div>deep-orange
 *
 * @field {String} color
 */
{
  name: 'color',
  type: 'string'
},
/**
 * Number of tasks per row to display in this column. Leave blank to use the setting from the
 * {@link TaskBoard.view.TaskBoardBase#config-tasksPerRow} config on TaskBoard.
 * @field {Number} tasksPerRow
 */
'tasksPerRow',
/**
 * Allow collapsing this column
 * @field {Boolean} collapsible=true
 */
{
  name: 'collapsible',
  type: 'boolean',
  defaultValue: true
},
/**
 * Collapsed (`true`) or expanded (`false`)
 *
 * To expand or collapse, use {@link #function-expand} and  {@link #function-collapse} functions.
 *
 * @field {Boolean} collapsed
 * @readonly
 */
{
  name: 'collapsed',
  type: 'boolean'
},
/**
 * Set to `true` to hide the column, `false` to show it again.
 * @field {Boolean} hidden
 */
{
  name: 'hidden',
  type: 'boolean'
},
/**
 * Column width in px.
 * @field {Number} width
 */
{
  name: 'width',
  type: 'number'
},
/**
 * Column flex, affects width.
 * @field {Number} flex
 */
{
  name: 'flex',
  type: 'number'
},
/**
 * Column min-width in px. To override the default min-width specified in CSS.
 * @field {Number} minWidth
 */
{
  name: 'minWidth',
  type: 'number'
}]);

ColumnModel._$name = 'ColumnModel';

/***/ }),

/***/ "./lib/TaskBoard/model/ProjectModel.js":
/*!*********************************************!*\
  !*** ./lib/TaskBoard/model/ProjectModel.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProjectModel; });
/* harmony import */ var _Scheduler_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/model/ProjectModel.js */ "./lib/Scheduler/model/ProjectModel.js");
/* harmony import */ var _Scheduler_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Scheduler/data/mixin/ProjectCrudManager.js */ "./lib/Scheduler/data/mixin/ProjectCrudManager.js");
/* harmony import */ var _store_TaskStore_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../store/TaskStore.js */ "./lib/TaskBoard/store/TaskStore.js");
/* harmony import */ var _TaskModel_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TaskModel.js */ "./lib/TaskBoard/model/TaskModel.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';




/**
 * @module TaskBoard/model/ProjectModel
 */

/**
 * This class represents a global project of your TaskBoard - a central place for all data.
 *
 * It holds and links the stores usually used by TaskBoard:
 *
 * - {@link TaskBoard.store.TaskStore}
 * - {@link Scheduler.data.ResourceStore}
 * - {@link Scheduler.data.AssignmentStore}
 *
 * ## Loading remote data
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     project : {
 *         // TODO configs
 *     }
 * });
 * ```
 *
 * ## Loading inline data
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     project : {
 *         // TODO configs
 *     }
 * });
 * ```
 *
 * ## Getting modifications
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     project : {
 *         // TODO configs
 *     }
 * });
 * ```
 *
 * ## Built in StateTrackingManager
 *
 * The project also has a built in {@link Core.data.stm.StateTrackingManager StateTrackingManager} (STM for short), that
 * handles undo/redo for the project stores (additional stores can also be added). You can enable it to track all
 * project store changes:
 *
 * ```javascript
 * // Turn on auto recording when you create your TaskBoard:
 * const taskBoard = new TaskBoard({
 *     project : {
 *         stm : {
 *             autoRecord : true
 *         }
 *     }
 * });
 *
 * // Undo a transaction
 * project.stm.undo();
 *
 * // Redo
 * project.stm.redo();
 * ```
 *
 * @extends Scheduler/model/ProjectModel
 * @mixes Scheduler/data/mixin/ProjectCrudManager
 *
 * @typings Scheduler/model/ProjectModel -> Scheduler/model/SchedulerProjectModel
 */

class ProjectModel extends _Scheduler_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_Scheduler_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  construct(config) {
    if (config.tasksData) {
      config.eventsData = config.tasksData;
    }

    if (config.taskStore) {
      config.eventStore = config.taskStore;
    }

    if (config.taskModelClass) {
      config.eventModelClass = config.taskModelClass;
    }

    if (config.taskStoreClass) {
      config.eventStoreClass = config.taskStoreClass;
    }

    super.construct(config);
    const me = this;
    me.addPrioritizedStore(me.assignmentStore);
    me.addPrioritizedStore(me.resourceStore);
    me.addPrioritizedStore(me.taskStore);
  }

  get taskStore() {
    return this.eventStore;
  }

  set taskStore(store) {
    this.eventStore = store;
  }

  get tasksData() {
    return this.eventsData;
  }

  set tasksData(data) {
    this.eventsData = data;
  }
  /**
   * Returns the data from the records of the projects stores, in a format that can be consumed by `loadInlineData()`.
   *
   * Used by JSON.stringify to correctly convert this project to json.
   *
   * ```javascript
   * const project = new ProjectModel({
   *     tasksData       : [...],
   *     resourcesData   : [...],
   *     assignmentsData : [...]
   * });
   *
   * const json = project.toJSON();
   *
   * // Result:
   * {
   *     taskData : [...],
   *     resourcesData : [...],
   *     assignmentsData : [...]
   * }
   * ```
   *
   * Output can be consumed by `loadInlineData()`:
   *
   * ```javascript
   * const json = project.toJSON();
   *
   * // Plug it back in later
   * project.loadInlineData(json);
   * ```
   *
   * @returns {Object}
   * @category JSON
   */


  toJSON() {
    const {
      taskStore,
      assignmentStore,
      resourceStore
    } = this,
          result = {
      tasksData: taskStore.toJSON()
    };

    if (assignmentStore !== null && assignmentStore !== void 0 && assignmentStore.count) {
      result.assignmentsData = assignmentStore.toJSON();
    }

    if (resourceStore !== null && resourceStore !== void 0 && resourceStore.count) {
      result.rescouresData = resourceStore.toJSON();
    }

    return result;
  }

}

_defineProperty(ProjectModel, "configurable", {
  /**
   * The initial data, to fill the {@link #property-taskStore} with.
   * Should be an array of {@link Scheduler.model.EventModel} instances or its configuration objects.
   *
   * @config {TaskBoard.model.TaskModel[]} tasksData
   * @category Inline data
   */

  /**
   * The {@link TaskBoard.store.TaskStore store} holding the tasks information.
   *
   * See also {@link TaskBoard.model.TaskModel}
   *
   * @member {TaskBoard.store.TaskStore} taskStore
   * @category Models & Stores
   */

  /**
   * An {@link TaskBoard.store.TaskStore} instance or a config object.
   * @config {Object|TaskBoard.store.TaskStore} taskStore
   * @category Models & Stores
   */

  /**
   * @config {Object} timeRangeStore
   * @hide
   */

  /**
   * @member {Object} timeRangeStore
   * @hide
   */

  /**
   * @config {Object} timeRangesData
   * @hide
   */

  /**
   * @config {Object} timeRangeStoreClass
   * @hide
   */

  /**
   * @config {Object} resourceTimeRangeStore
   * @hide
   */

  /**
   * @member {Object} resourceTimeRangeStore
   * @hide
   */

  /**
   * @config {Object} resourceTimeRangesData
   * @hide
   */

  /**
   * @config {Object} resourceTimeRangeStoreClass
   * @hide
   */
  eventStoreClass: _store_TaskStore_js__WEBPACK_IMPORTED_MODULE_2__["default"],
  eventModelClass: _TaskModel_js__WEBPACK_IMPORTED_MODULE_3__["default"],
  taskStoreClass: _store_TaskStore_js__WEBPACK_IMPORTED_MODULE_2__["default"],
  taskModelClass: _TaskModel_js__WEBPACK_IMPORTED_MODULE_3__["default"]
});

ProjectModel._$name = 'ProjectModel';

/***/ }),

/***/ "./lib/TaskBoard/model/SwimlaneModel.js":
/*!**********************************************!*\
  !*** ./lib/TaskBoard/model/SwimlaneModel.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SwimlaneModel; });
/* harmony import */ var _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/data/Model.js */ "./lib/Core/data/Model.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module TaskBoard/model/SwimlaneModel
 */

/**
 * Represents a single swimlane on a TaskBoard.
 *
 * When creating a TaskBoard, you can optionally supply an initial set of swimlanes. These are either defined as plain
 * strings, SwimlaneModel data objects or SwimlaneModel records (or a mix thereof). When using strings, the string will
 * be used as is as the swimlane's id and capitalized as its text.
 *
 * ```javascript
 * const highPrio = new SwimlaneModel({
 *     id   : 'high',
 *     text : 'High prio'
 * });
 *
 * const taskBoard = new TaskBoard({
 *     swimlanes : [
 *         // String, equal to passing { id : 'low', text : 'Low' }
 *         'low',
 *         // Data object, in this case with a fixed height and not collapsible from the UI
 *         { id : 'medium', text : 'Medium', height : 200, collapsible : false }
 *         // Record, not commonly used since it is easier to supply the data object directly
 *         highPrio
 *     ]
 * });
 * ```
 *
 * @extends Core/data/Model
 * @uninherit Core/data/mixin/TreeNode
 */

class SwimlaneModel extends _Core_data_Model_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  get taskBoard() {
    return this.firstStore.taskBoard;
  }
  /**
   * Collapse this swimlane.
   *
   * Uses a transition by default, await the call to be certain that it has finished.
   *
   * @async
   * @category Expand/collapse
   * @returns {Promise} A promise which is resolved when the column is collapsed
   */


  async collapse() {
    this.taskBoard.collapse(this);
  }
  /**
   * Expand this swimlane.
   *
   * Uses a transition by default, await the call to be certain that it has finished.
   *
   * @async
   * @category Expand/collapse
   * @returns {Promise} A promise which is resolved when the column is expanded
   */


  expand() {
    this.taskBoard.expand(this);
  }
  /**
   * Get tasks in this swimlane.
   * @property {TaskBoard.model.TaskModel[]}
   * @readonly
   */


  get tasks() {
    return [...(this.taskBoard.getSwimlaneTasks(this) || [])];
  }

}

_defineProperty(SwimlaneModel, "fields", [
/**
 * The swimlane's unique id, used to match a task to a swimlane (which field on a task to match is specified using
 * then {@link TaskBoard.view.TaskBoardBase#config-swimlaneField} config on TaskBoard).
 * @field {String|Number} id
 */

/**
 * Text displayed in the swimlane header.
 * @field {String} text
 */
{
  name: 'text',
  type: 'string'
},
/**
 * Color, applied as a `b-taskboard-color-{color}` (`b-taskboard-color-red`) CSS class to the swimlane.
 *
 * By default it does not visually affect the UI, but it applies a color to the swimlane that applications can
 * leverage using `currentColor` to style it in the desired way.
 *
 * For example:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     swimlanes : [
 *         { id : 'high', text : 'High', color : 'red' }
 *     ]
 * });
 * ```
 *
 * Will result in:
 *
 * ```html
 * <div class="b-taskboard-swimlane b-taskboard-color-red">
 * ```
 *
 * Which can the be used for example like:
 *
 * ```css
 * .b-taskboard-swimlane-header {
 *     border-left : 5px solid currentColor; // where currentColor is the color defined by b-red
 * }
 * ```
 *
 * Predefined colors (actual color might vary by theme):
 * <div class="b-colorbox b-inline b-taskboard-color-red"></div>red,
 * <div class="b-colorbox b-inline b-taskboard-color-pink"></div>pink,
 * <div class="b-colorbox b-inline b-taskboard-color-purple"></div>purple,
 * <div class="b-colorbox b-inline b-taskboard-color-deep-purple"></div>deep-purple,
 * <div class="b-colorbox b-inline b-taskboard-color-indigo"></div>indigo,
 * <div class="b-colorbox b-inline b-taskboard-color-blue"></div>blue,
 * <div class="b-colorbox b-inline b-taskboard-color-light-blue"></div>light-blue,
 * <div class="b-colorbox b-inline b-taskboard-color-cyan"></div>cyan,
 * <div class="b-colorbox b-inline b-taskboard-color-teal"></div>teal,
 * <div class="b-colorbox b-inline b-taskboard-color-green"></div>green,
 * <div class="b-colorbox b-inline b-taskboard-color-light-green"></div>light-green,
 * <div class="b-colorbox b-inline b-taskboard-color-lime"></div>lime,
 * <div class="b-colorbox b-inline b-taskboard-color-yellow"></div>yellow,
 * <div class="b-colorbox b-inline b-taskboard-color-amber"></div>amber,
 * <div class="b-colorbox b-inline b-taskboard-color-orange"></div>orange,
 * <div class="b-colorbox b-inline b-taskboard-color-deep-orange"></div>deep-orange
 *
 * @field {String} color
 */
{
  name: 'color',
  type: 'string'
},
/**
 * Allow collapsing this swimlane
 * @field {Boolean} collapsible=true
 */
{
  name: 'collapsible',
  type: 'boolean',
  defaultValue: true
},
/**
 * Collapsed (true) or expanded (False).
 *
 * To expand or collapse, use TaskBoards {@link TaskBoard.view.mixin.ExpandCollapse#function-expand} and
 * {@link TaskBoard.view.mixin.ExpandCollapse#function-collapse} functions.
 *
 * @field {Boolean} collapsed
 * @readonly
 */
{
  name: 'collapsed',
  type: 'boolean'
},
/**
* Set to `true` to hide the swimlane, `false` to show it again.
* @field {Boolean} hidden
*/
{
  name: 'hidden',
  type: 'boolean'
},
/**
 * Swimlane height in px.
 * @field {Number} height
 */
{
  name: 'height',
  type: 'number'
},
/**
 * Swimlane flex, affects height.
 * @field {Number} flex
 */
{
  name: 'flex',
  type: 'number'
},
/**
 * Number of tasks per row to display in this swimlane. Leave blank to use the setting from the
 * {@link TaskBoard.view.TaskBoardBase#config-tasksPerRow} config on TaskBoard.
 * @field {Number} tasksPerRow
 */
'tasksPerRow']);

SwimlaneModel._$name = 'SwimlaneModel';

/***/ }),

/***/ "./lib/TaskBoard/model/TaskModel.js":
/*!******************************************!*\
  !*** ./lib/TaskBoard/model/TaskModel.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskModel; });
/* harmony import */ var _Scheduler_model_EventModel_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/model/EventModel.js */ "./lib/Scheduler/model/EventModel.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module TaskBoard/model/TaskModel
 */

/**
 * Represents a single task on your TaskBoard, usually added to a {@link TaskBoard/store/TaskStore}.
 *
 * ## Customizing Task fields
 *
 * The TaskModel has a few predefined fields as seen under Fields below. If you want to add new fields or change
 * existing fields, you can do that by subclassing this class:
 *
 * ```javascript
 * class MyTask extends TaskModel {
 *
 *     static get fields() {
 *         return [
 *            // Add a new field
 *            { name: 'myField', type : 'number', defaultValue : 0 }
 *         ];
 *     }
 *
 *     ...
 * }
 *
 * // Instances of your class now has getters / setters defined for your field
 * const task = new MyTask();
 * console.log(task.myField); // => 0
 * ```
 *
 *
 * If you want to use other names for any predefined field in your data, you can reconfigure them as seen below:
 *
 * ```javascript
 * class MyTask extends TaskModel {
 *
 *     static get fields() {
 *         return [
 *            // Remap status -> state
 *            { name: 'status', dataSource : 'state' }
 *         ];
 *     }
 *
 *     ...
 * }
 * ```
 *
 * ## Configuring the Project to use a custom task model
 *
 * Here's how you configure the {@link TaskBoard/model/ProjectModel Project} to use a certain Model class:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     // Configure the project to use our custom task model and to load data remotely
 *     project : {
 *         taskModelClass : MyTask,
 *
 *         autoLoad  : true
 *         transport : {
 *             load : {
 *                 url : 'data/data.json'
 *             }
 *         }
 *     }
 * });
 * ```
 *
 * ## Read-only tasks
 *
 * A task can be flagged as read-only using the {@link #field-readOnly} field. This protects it from being edited in the
 * UI, but has no effect on the data layer.
 *
 * {@inlineexample TaskBoard/model/TaskModelReadOnly.js}
 *
 * Please refer to {@link Core/data/Model} for additional details.
 *
 * @extends Scheduler/model/EventModel
 */

class TaskModel extends _Scheduler_model_EventModel_js__WEBPACK_IMPORTED_MODULE_0__["default"] {}

_defineProperty(TaskModel, "fields", [
/**
 * Task status, for example for linking to a column on the TaskBoard.
 *
 * @field {String} status
 */
'status',
/**
 * Task priority, for example for linking to a swimlane on the TaskBoard.
 *
 * @field {String|Number} prio
 */
'prio',
/**
 * Task description, by default shown in tasks body.
 *
 * @field {String} description
 */
'description',
/**
 * Color, applied as a `b-taskboard-color-{color}` (`b-taskboard-color-red`) CSS class to the tasks card.
 *
 * By default it does not visually affect the UI, but it applies a color to the task that applications can
 * leverage using `currentColor` to style it in the desired way.
 *
 * For example:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     project {
 *         tasksData : [
 *             { id : 1, name : 'Important task', eventColor : 'red' }
 *         ]
 *     }
 * });
 * ```
 *
 * Will result in:
 *
 * ```html
 * <div class="b-taskboard-card b-taskboard-color-red">
 * ```
 *
 * Which can the be used for example like:
 *
 * ```css
 * .b-taskboard-card {
 *     // currentColor is the color defined by b-red
 *     border-left : 5px solid currentColor;
 * }
 * ```
 *
 * Predefined colors (actual color might vary by theme):
 * <div class="b-colorbox b-inline b-taskboard-color-red"></div>red,
 * <div class="b-colorbox b-inline b-taskboard-color-pink"></div>pink,
 * <div class="b-colorbox b-inline b-taskboard-color-purple"></div>purple,
 * <div class="b-colorbox b-inline b-taskboard-color-deep-purple"></div>deep-purple,
 * <div class="b-colorbox b-inline b-taskboard-color-indigo"></div>indigo,
 * <div class="b-colorbox b-inline b-taskboard-color-blue"></div>blue,
 * <div class="b-colorbox b-inline b-taskboard-color-light-blue"></div>light-blue,
 * <div class="b-colorbox b-inline b-taskboard-color-cyan"></div>cyan,
 * <div class="b-colorbox b-inline b-taskboard-color-teal"></div>teal,
 * <div class="b-colorbox b-inline b-taskboard-color-green"></div>green,
 * <div class="b-colorbox b-inline b-taskboard-color-light-green"></div>light-green,
 * <div class="b-colorbox b-inline b-taskboard-color-lime"></div>lime,
 * <div class="b-colorbox b-inline b-taskboard-color-yellow"></div>yellow,
 * <div class="b-colorbox b-inline b-taskboard-color-amber"></div>amber,
 * <div class="b-colorbox b-inline b-taskboard-color-orange"></div>orange,
 * <div class="b-colorbox b-inline b-taskboard-color-deep-orange"></div>deep-orange
 *
 * @field {String} eventColor
 */
'eventColor',
/**
 * Task weight, used by default to determine its index in a column. Higher weights are displayed further down.
 *
 * The weight is applied as a default sorter to the {@link TaskBoard/store/TaskStore}.
 *
 * When no weights are defined, task order is determined by store order.
 *
 * @field {Number} weight
 */
{
  name: 'weight',
  type: 'number'
},
/**
 * Set to `true` to make the task read-only, preventing it from being edited in the UI.
 *
 * See the class description above for a live demo.
 *
 * @field {Boolean} readOnly
 */
{
  name: 'readOnly',
  type: 'boolean'
}]);

TaskModel._$name = 'TaskModel';

/***/ }),

/***/ "./lib/TaskBoard/store/TaskStore.js":
/*!******************************************!*\
  !*** ./lib/TaskBoard/store/TaskStore.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskStore; });
/* harmony import */ var _Scheduler_data_EventStore_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/data/EventStore.js */ "./lib/Scheduler/data/EventStore.js");
/* harmony import */ var _model_TaskModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/TaskModel.js */ "./lib/TaskBoard/model/TaskModel.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module TaskBoard/data/TaskStore
 */

/**
 * Store that holds the tasks of a TaskBoard. By default configured to use {@link TaskBoard.model.TaskModel} for its
 * records.
 *
 * Loaded and handled as a part of a {@link TaskBoard.model.ProjectModel project}. For example using inline data:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     project : {
 *         // Data to load into the TaskStore
 *         tasksData : [
 *             { id : 1, name : 'Some task', status : 'todo', prio : 'low' }
 *         ]
 *     }
 * }
 * ```
 *
 * When loaded using the {@link Scheduler.data.mixin.ProjectCrudManager CrudManager} functionality of the project, it
 * is populated from the `'tasks'` property in the
 * response:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     project : {
 *         transport : {
 *             load : {
 *                 url : 'load.php'
 *             }
 *         },
 *
 *         autoLoad : true
 *     }
 * }
 * ```
 *
 * Expected response format to populate the TaskStore:
 *
 * ```json
 * {
 *     "success"     : true,
 *     "tasks"       : {
 *         "rows" : [
 *             {
 *                 "id"     : 1,
 *                 "name"   : "Important task",
 *                 "status" : "todo",
 *                 "prio"   : "high"
 *             },
 *             ...
 *         ]
 *     }
 * }
 * ```
 *
 * @extends Scheduler/data/EventStore
 */

class TaskStore extends _Scheduler_data_EventStore_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  afterLoadData() {
    const {
      records
    } = this;

    if (this.autoAssignWeight && !records.some(r => r.weight != null)) {
      for (let i = 0; i < records.length; i++) {
        records[i].setData('weight', (i + 1) * 100);
      }
    }
  }

}

_defineProperty(TaskStore, "configurable", {
  autoAssignWeight: true,
  storeId: 'tasks',

  /**
   * Class used to represent records, defaults to {@link TaskBoard.model.TaskModel}
   * @config {TaskBoard.model.TaskModel}
   * @typings {typeof TaskModel}
   * @category Common
   */
  modelClass: _model_TaskModel_js__WEBPACK_IMPORTED_MODULE_1__["default"],

  /**
   * Configure with `true` to also remove the event when removing the last assignment from the linked
   * AssignmentStore.
   *
   * Defaults to `false` for TaskBoard since it is unexpected that a tasks disappears when unassigning the last
   * resource from it.
   *
   * @config {Boolean}
   * @default
   * @category Common
   */
  removeUnassignedEvent: false,

  /**
   * Initial sorters, format is `[{ field: 'name', ascending: false }, ...]`.
   *
   * By default the TaskStore is sorted by `weight`, tasks with higher weights are displayed further down.
   *
   * @config {Object[]|String[]}
   * @category Common
   */
  sorters: [{
    field: 'weight',
    ascending: true
  }]
});

TaskStore._$name = 'TaskStore';

/***/ }),

/***/ "./lib/TaskBoard/view/TaskBoard.js":
/*!*****************************************!*\
  !*** ./lib/TaskBoard/view/TaskBoard.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskBoard; });
/* harmony import */ var _TaskBoardBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskBoardBase.js */ "./lib/TaskBoard/view/TaskBoardBase.js");
/* harmony import */ var _feature_ColumnHeaderMenu_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../feature/ColumnHeaderMenu.js */ "./lib/TaskBoard/feature/ColumnHeaderMenu.js");
/* harmony import */ var _feature_ColumnToolbars_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../feature/ColumnToolbars.js */ "./lib/TaskBoard/feature/ColumnToolbars.js");
/* harmony import */ var _feature_TaskDrag_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../feature/TaskDrag.js */ "./lib/TaskBoard/feature/TaskDrag.js");
/* harmony import */ var _feature_TaskDragSelect_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../feature/TaskDragSelect.js */ "./lib/TaskBoard/feature/TaskDragSelect.js");
/* harmony import */ var _feature_TaskEdit_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../feature/TaskEdit.js */ "./lib/TaskBoard/feature/TaskEdit.js");
/* harmony import */ var _feature_TaskMenu_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../feature/TaskMenu.js */ "./lib/TaskBoard/feature/TaskMenu.js");
/* harmony import */ var _item_ImageItem_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./item/ImageItem.js */ "./lib/TaskBoard/view/item/ImageItem.js");
/* harmony import */ var _item_ProgressItem_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./item/ProgressItem.js */ "./lib/TaskBoard/view/item/ProgressItem.js");
/* harmony import */ var _item_RatingItem_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./item/RatingItem.js */ "./lib/TaskBoard/view/item/RatingItem.js");
/* harmony import */ var _item_ResourceAvatarsItem_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./item/ResourceAvatarsItem.js */ "./lib/TaskBoard/view/item/ResourceAvatarsItem.js");
/* harmony import */ var _item_SeparatorItem_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./item/SeparatorItem.js */ "./lib/TaskBoard/view/item/SeparatorItem.js");
/* harmony import */ var _item_TagsItem_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./item/TagsItem.js */ "./lib/TaskBoard/view/item/TagsItem.js");
/* harmony import */ var _item_TaskMenuItem_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./item/TaskMenuItem.js */ "./lib/TaskBoard/view/item/TaskMenuItem.js");
/* harmony import */ var _item_TemplateItem_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./item/TemplateItem.js */ "./lib/TaskBoard/view/item/TemplateItem.js");
/* harmony import */ var _item_TodoListItem_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./item/TodoListItem.js */ "./lib/TaskBoard/view/item/TodoListItem.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';
















/**
 * @module TaskBoard/view/TaskBoard
 */

/**
 * A kanban board widget that allows you to visualize and mange tasks.
 *
 * {@inlineexample TaskBoard/view/TaskBoardBasic.js}
 *
 * ## Datalayer
 *
 * TaskBoards datalayer is based on Schedulers. It consumes a {@link TaskBoard.model.ProjectModel project} that holds
 * stores that in turn holds records. The stores used by default are:
 *
 * * {@link TaskBoard.store.TaskStore} - Store holding tasks, which are instances of {@link TaskBoard.model.TaskModel}
 * * {@link Scheduler.store.ResourceStore} - Holds resources, see {@link Scheduler.model.ResourceModel}
 * * {@link Scheduler.store.AssignmentStore} - Holds assignments, links between resources and tasks, see {@link Scheduler.model.AssignmentModel}
 *
 * Data can be supplied inline or loaded using the projects {@link Scheduler.data.mixin.ProjectCrudManager CrudManager}
 * capabilities. Example using inline data:
 *
 * ```javascript
 * new TaskBoard({
 *     project : {
 *         tasksData : [
 *             { id : 1, name : 'Try TaskBoard' }
 *         ]
 *     }
 * });
 * ```
 *
 * And using CrudManager to load remote data:
 *
 * ```javascript
 * new TaskBoard({
 *     project : {
 *         transport : {
 *             load : {
 *                 url : 'data/load.php'
 *             }
 *         },
 *
 *         autoLoad : true
 *     }
 * });
 * ```
 *
 * ## Columns
 *
 * The tasks are displayed in columns. Which column a task belongs to is determined by the tasks value for the
 * configured {@link #config-columnField}. Columns can be defined as strings or as {@link TaskBoard.model.ColumnModel}
 * data objects, supplied to the {@link #config-columns columns config}. This snippet illustrates it:
 *
 * ```javascript
 * new TaskBoard({
 *     // The "status" field of tasks will be used to determine which column the task belongs to
 *     columnField : 'status',
 *
 *     // Columns as strings or objects
 *     columns : [
 *         'todo', // Will be displayed as Todo
 *         { id : 'done', text : 'Done!' }
 *     ],
 *
 *    // TaskBoard data
 *     project : {
 *         tasksData : [
 *             // Since we use the "status" field to determine column, this task will belong to the "done" column
 *             { id : 1, name : 'Create mockup', status : 'done' },
 *
 *             // And this one to "todo"
 *             { id : 2, name : 'Write docs', status : 'todo' }
 *         ]
 *     }
 * });
 * ```
 *
 * The supplied columns are loaded into an internal store, named {@link #property-columns}. You can use it at runtime
 * to access, add, remove and filter columns.
 *
 * A tasks location within a column is by default determined by its {@link TaskBoard.model.TaskModel#field-weight}. The
 * store is sorted by weight, higher weights go further down. If no weights are specified, the sorter does nothing and
 * the tasks are displayed in load order.
 *
 * ## Swimlanes
 *
 * The TaskBoard can optionally be divided into horizontal swimlanes.
 *
 * {@inlineexample TaskBoard/view/TaskBoardSwimlanes.js}
 *
 * They are defined and populated in a very similar manner to columns:
 *
 * ```javascript
 * new TaskBoard({
 *     // The "prio" field of tasks will be used to determine which swimlane the task belongs to
 *     swimlaneField : 'prio',
 *
 *     // Swimlanes as strings or objects
 *     columns : [
 *         'low', // Will be displayed as Low
 *         { id : 'high', text : 'High!' }
 *     ],
 *
 *     // TaskBoard data
 *     project : {
 *         tasksData : [
 *             // Since we use the "prio" field to determine swimlane, this task will belong to the "high" lane
 *             { id : 1, name : 'Create mockup', status : 'done', prio : 'high' },
 *
 *             // And this one to "low"
 *             { id : 2, name : 'Write docs', status : 'todo', prio : 'low' }
 *         ]
 *     }
 * });
 * ```
 *
 * ## Customizing task content
 *
 * Task contents can be easily customized using {@link TaskBoard/view/mixin/TaskItems task items}, lightweight
 * "widgets" that can be added to a tasks header, body and footer.
 *
 * For more control over what gets rendered into a task, you can supply a {@link #config-taskRenderer} function. It is
 * called prior to updating the DOM for each task, allowing you to directly manipulate what ends up there.
 *
 * For more information see:
 *
 * * [Styling guide](#TaskBoard/guides/customization/styling.md)
 * * [Customize task contents guide](#TaskBoard/guides/customization/taskcontents.md)
 *
 * ## Find out more
 *
 * * {@link TaskBoard.view.mixin.ExpandCollapse Expanding and collapsing columns and swimlanes}
 * * {@link TaskBoard.view.mixin.ResponsiveCards Responsive behaviour for cards}
 * * {@link TaskBoard.view.mixin.TaskBoardDom Resolving elements <-> records}
 * * {@link TaskBoard.view.mixin.TaskBoardDomEvents Handling card events}
 * * {@link TaskBoard.view.mixin.TaskBoardScroll Scrolling to tasks, columns and swimlanes}
 * * {@link TaskBoard.view.mixin.TaskItems Add content to task cards}
 * * {@link TaskBoard.view.mixin.TaskNavigation Keyboard navigation}
 * * {@link TaskBoard.view.mixin.TaskSelection Selection tasks using mouse and keyboard}
 *
 * @extends TaskBoard/view/TaskBoardBase
 *
 * @classType taskboard
 */

class TaskBoard extends _TaskBoardBase_js__WEBPACK_IMPORTED_MODULE_0__["default"] {}

_defineProperty(TaskBoard, "$name", 'TaskBoard');

_defineProperty(TaskBoard, "type", 'taskboard');

_defineProperty(TaskBoard, "configurable", {
  //region Hidden members

  /**
   * @hideconfigs crudManager, crudManagerClass, contentElementCls, htmlCls, defaults, hideWhenEmpty, itemCls, items, layout, layoutStyle, lazyItems, namedItems, textContent, content, html, defaultBindProperty, monitorResize, ripple, tooltip, tag, textAlign, preventTooltipOnTouch
   */

  /**
   * @hideproperties $name, isSettingValues, isValid, items, layout, record, values, content, contentElement, focusElement, html, overflowElement, layoutStyle, tooltip, scrollable
   */

  /**
   * @hidefunctions attachTooltip, isOfTypeName, mixin, optionalL, callback, resolveCallback, add, getWidgetById, insert, processWidgetConfig, remove, removeAll, construct, doDestroy, updateLocalization, compose, eachAncestor, eachWidget, query, queryAll, L
   */

  /**
   * @event beforeSetRecord
   * @hide
   */
  //endregion
  features: {
    columnHeaderMenu: true,
    columnToolbars: true,
    taskDrag: true,
    taskDragSelect: true,
    taskEdit: true,
    taskMenu: true
  }
});

TaskBoard.initClass();
TaskBoard._$name = 'TaskBoard';

/***/ }),

/***/ "./lib/TaskBoard/view/TaskBoardBase.js":
/*!*********************************************!*\
  !*** ./lib/TaskBoard/view/TaskBoardBase.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskBoardBase; });
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony import */ var _Core_mixin_Featureable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/mixin/Featureable.js */ "./lib/Core/mixin/Featureable.js");
/* harmony import */ var _Core_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/mixin/Pluggable.js */ "./lib/Core/mixin/Pluggable.js");
/* harmony import */ var _Core_mixin_State_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/mixin/State.js */ "./lib/Core/mixin/State.js");
/* harmony import */ var _Core_util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/util/ScrollManager.js */ "./lib/Core/util/ScrollManager.js");
/* harmony import */ var _Core_widget_mixin_Responsive_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Core/widget/mixin/Responsive.js */ "./lib/Core/widget/mixin/Responsive.js");
/* harmony import */ var _Core_widget_mixin_Styleable_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../Core/widget/mixin/Styleable.js */ "./lib/Core/widget/mixin/Styleable.js");
/* harmony import */ var _Core_widget_Panel_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Core/widget/Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony import */ var _Core_widget_mixin_KeyMap_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../Core/widget/mixin/KeyMap.js */ "./lib/Core/widget/mixin/KeyMap.js");
/* harmony import */ var _Scheduler_crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../Scheduler/crud/mixin/CrudManagerView.js */ "./lib/Scheduler/crud/mixin/CrudManagerView.js");
/* harmony import */ var _feature_TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../feature/TaskBoardFeature.js */ "./lib/TaskBoard/feature/TaskBoardFeature.js");
/* harmony import */ var _mixin_ExpandCollapse_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./mixin/ExpandCollapse.js */ "./lib/TaskBoard/view/mixin/ExpandCollapse.js");
/* harmony import */ var _mixin_ResponsiveCards_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./mixin/ResponsiveCards.js */ "./lib/TaskBoard/view/mixin/ResponsiveCards.js");
/* harmony import */ var _mixin_TaskBoardColumns_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./mixin/TaskBoardColumns.js */ "./lib/TaskBoard/view/mixin/TaskBoardColumns.js");
/* harmony import */ var _mixin_TaskBoardDom_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./mixin/TaskBoardDom.js */ "./lib/TaskBoard/view/mixin/TaskBoardDom.js");
/* harmony import */ var _mixin_TaskBoardDomEvents_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./mixin/TaskBoardDomEvents.js */ "./lib/TaskBoard/view/mixin/TaskBoardDomEvents.js");
/* harmony import */ var _mixin_TaskBoardScroll_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./mixin/TaskBoardScroll.js */ "./lib/TaskBoard/view/mixin/TaskBoardScroll.js");
/* harmony import */ var _mixin_TaskBoardStores_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./mixin/TaskBoardStores.js */ "./lib/TaskBoard/view/mixin/TaskBoardStores.js");
/* harmony import */ var _mixin_TaskBoardSwimlanes_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./mixin/TaskBoardSwimlanes.js */ "./lib/TaskBoard/view/mixin/TaskBoardSwimlanes.js");
/* harmony import */ var _mixin_TaskItems_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./mixin/TaskItems.js */ "./lib/TaskBoard/view/mixin/TaskItems.js");
/* harmony import */ var _mixin_TaskNavigation_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./mixin/TaskNavigation.js */ "./lib/TaskBoard/view/mixin/TaskNavigation.js");
/* harmony import */ var _mixin_TaskSelection_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./mixin/TaskSelection.js */ "./lib/TaskBoard/view/mixin/TaskSelection.js");
/* harmony import */ var _localization_En_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../localization/En.js */ "./lib/TaskBoard/localization/En.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

























/**
 * @module TaskBoard/view/TaskBoardBase
 */

/**
 * A thin base class for {@link TaskBoard.view.TaskBoard}. Does not include any features by default, allowing smaller
 * custom built bundles if used in place of {@link TaskBoard.view.TaskBoard}.
 *
 * **NOTE:** In most scenarios you probably want to use TaskBoard instead of TaskBoardBase.
 *
 * @extends Core/widget/Panel
 *
 * @mixes Core/mixin/Pluggable
 * @mixes Core/mixin/State
 * @mixes Core/widget/mixin/Responsive
 * @mixes Core/widget/mixin/Styleable
 * @mixes Scheduler/crud/mixin/CrudManagerView
 * @mixes TaskBoard/view/mixin/ExpandCollapse
 * @mixes TaskBoard/view/mixin/ResponsiveCards
 * @mixes TaskBoard/view/mixin/TaskBoardColumns
 * @mixes TaskBoard/view/mixin/TaskBoardDom
 * @mixes TaskBoard/view/mixin/TaskBoardDomEvents
 * @mixes TaskBoard/view/mixin/TaskBoardScroll
 * @mixes TaskBoard/view/mixin/TaskBoardStores
 * @mixes TaskBoard/view/mixin/TaskBoardSwimlanes
 * @mixes TaskBoard/view/mixin/TaskItems
 * @mixes TaskBoard/view/mixin/TaskNavigation
 * @mixes TaskBoard/view/mixin/TaskSelection
 *
 * @features TaskBoard/feature/ColumnDrag
 * @features TaskBoard/feature/ColumnHeaderMenu
 * @features TaskBoard/feature/ColumnToolbars
 * @features TaskBoard/feature/SimpleTaskEdit
 * @features TaskBoard/feature/SwimlaneDrag
 * @features TaskBoard/feature/TaskDrag
 * @features TaskBoard/feature/TaskDragSelect
 * @features TaskBoard/feature/TaskEdit
 * @features TaskBoard/feature/TaskMenu
 * @features TaskBoard/feature/TaskTooltip
 */

class TaskBoardBase extends _Core_widget_Panel_js__WEBPACK_IMPORTED_MODULE_9__["default"].mixin(_Core_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_4__["default"], _Core_mixin_State_js__WEBPACK_IMPORTED_MODULE_5__["default"], _Core_mixin_Featureable_js__WEBPACK_IMPORTED_MODULE_3__["default"], _Core_widget_mixin_Styleable_js__WEBPACK_IMPORTED_MODULE_8__["default"], _Core_widget_mixin_KeyMap_js__WEBPACK_IMPORTED_MODULE_10__["default"], _Scheduler_crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_11__["default"], _mixin_ExpandCollapse_js__WEBPACK_IMPORTED_MODULE_13__["default"], _Core_widget_mixin_Responsive_js__WEBPACK_IMPORTED_MODULE_7__["default"], _mixin_ResponsiveCards_js__WEBPACK_IMPORTED_MODULE_14__["default"], _mixin_TaskBoardColumns_js__WEBPACK_IMPORTED_MODULE_15__["default"], _mixin_TaskBoardDom_js__WEBPACK_IMPORTED_MODULE_16__["default"], _mixin_TaskBoardDomEvents_js__WEBPACK_IMPORTED_MODULE_17__["default"], _mixin_TaskBoardScroll_js__WEBPACK_IMPORTED_MODULE_18__["default"], _mixin_TaskBoardStores_js__WEBPACK_IMPORTED_MODULE_19__["default"], _mixin_TaskBoardSwimlanes_js__WEBPACK_IMPORTED_MODULE_20__["default"], _mixin_TaskItems_js__WEBPACK_IMPORTED_MODULE_21__["default"], _mixin_TaskNavigation_js__WEBPACK_IMPORTED_MODULE_22__["default"], _mixin_TaskSelection_js__WEBPACK_IMPORTED_MODULE_23__["default"]) {
  //region Config
  // Do not remove. Assertion strings for Localization sanity check.
  // 'L{TaskBoard.task}'
  // 'L{TaskBoard.tasks}'
  // 'L{TaskBoard.column}'
  // 'L{TaskBoard.columns}'
  // 'L{TaskBoard.swimlane}'
  // 'L{TaskBoard.swimlanes}'
  static getLKey() {
    return 'a5cbca1a-5809-11ec-a6ac-d094663d5c88';
  }

  onPaintOverride() {// Internal procedure used for paint method overrides
    // Not used in onPaint() because it may be chained on instance and Override won't be applied
  }

  onPaint() {
    if (this.onPaintOverride()) {
      return;
    }

    super.onPaint();
  } //endregion
  //region Type assertions


  changeResourceImagePath(resourceImagePath) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertString(resourceImagePath, 'resourceImagePath');
    return resourceImagePath;
  }

  changeUseDomTransition(useDomTransition) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertBoolean(useDomTransition, 'useDomTransition');
    return useDomTransition;
  }

  changeStickyHeaders(stickyHeaders) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertBoolean(stickyHeaders, 'stickyHeaders');
    return stickyHeaders;
  }

  changeScrollManager(scrollManager, oldScrollManager) {
    oldScrollManager === null || oldScrollManager === void 0 ? void 0 : oldScrollManager.destroy();

    if (scrollManager) {
      return _Core_util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_6__["default"].new({
        element: this.element
      }, scrollManager);
    } else {
      return null;
    }
  }

  changeShowCountInHeader(showCountInHeader) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertBoolean(showCountInHeader, 'showCountInHeader');
    return showCountInHeader;
  }

  changeTasksPerRow(tasksPerRow) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertNumber(tasksPerRow, 'tasksPerRow');
    return tasksPerRow;
  }

  changeSwimlaneRenderer(swimlaneRenderer) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertFunction(swimlaneRenderer, 'swimlaneRenderer');
    return swimlaneRenderer;
  }

  changeTaskRenderer(taskRenderer) {
    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertFunction(taskRenderer, 'taskRenderer');
    return taskRenderer;
  } //endregion
  //region Render
  // Creates a DOM config for a single card, calling any configured taskRenderer() in the process


  renderCard(taskRecord, columnRecord, swimlaneRecord) {
    var _me$taskRenderer;

    const me = this,
          {
      id,
      eventColor
    } = taskRecord,
          color = eventColor || (swimlaneRecord === null || swimlaneRecord === void 0 ? void 0 : swimlaneRecord.color) || columnRecord.color,
          cardSize = me.getCardSize(columnRecord, swimlaneRecord),
          cardConfig = {
      id: `${me.id}-card-${id}`,
      class: {
        'b-taskboard-card': true,
        [`b-taskboard-color-${color}`]: color,
        'b-readonly': taskRecord.readOnly
      },
      tabIndex: 0,
      dataset: {
        task: id,
        column: columnRecord.id,
        lane: swimlaneRecord === null || swimlaneRecord === void 0 ? void 0 : swimlaneRecord.id,
        domTransition: true
      },
      elementData: {
        elementType: 'task',
        taskId: taskRecord.id,
        taskRecord,
        columnRecord,
        swimlaneRecord
      },
      children: {
        header: {
          tag: 'header',
          class: {
            'b-taskboard-card-header': 1
          },
          children: {},
          syncOptions: {
            syncIdField: 'role'
          }
        },
        body: {
          tag: 'section',
          class: {
            'b-taskboard-card-body': 1
          },
          children: {},
          syncOptions: {
            syncIdField: 'role'
          }
        },
        footer: {
          tag: 'footer',
          class: {
            'b-taskboard-card-footer': 1
          },
          children: {},
          syncOptions: {
            syncIdField: 'role'
          }
        }
      }
    },
          {
      children
    } = cardConfig,
          {
      header,
      body,
      footer
    } = children; // Chained by features

    me.populateCard({
      taskRecord,
      columnRecord,
      swimlaneRecord,
      cardConfig,
      cardSize
    }); // Supplied by app

    (_me$taskRenderer = me.taskRenderer) === null || _me$taskRenderer === void 0 ? void 0 : _me$taskRenderer.call(me, {
      taskRecord,
      columnRecord,
      swimlaneRecord,
      cardConfig,
      cardSize
    }); // TODO: headerRenderer, bodyRenderer, footerRenderer?
    // Remove unused parts of the card

    if (header.html == null && header.text == null && (!header.children || Object.keys(header.children).length === 0)) {
      children.header = null;
    }

    if (body.html == null && body.text == null && (!body.children || Object.keys(body.children).length === 0)) {
      children.body = null;
    }

    if (footer.html == null && footer.text == null && (!footer.children || Object.keys(footer.children).length === 0)) {
      children.footer = null;
    }

    return cardConfig;
  }

  renderColumnHeader(columnRecord) {
    var _me$getColumnTasks$le, _me$getColumnTasks, _me$columnHeaderRende;

    const me = this,
          {
      text,
      id,
      width,
      flex,
      minWidth,
      color
    } = columnRecord,
          columnHeaderConfig = {
      id: `${me.id}-column-header-${id}`,
      class: {
        'b-taskboard-column-header': 1,
        'b-fixed-width': width && !flex,
        [`b-taskboard-color-${color}`]: color,
        'b-last': columnRecord === this.columns.last
      },
      style: {
        width,
        flex,
        minWidth
      },
      children: {
        padder: {
          class: {
            'b-taskboard-column-header-padder': 1
          },
          children: {
            title: {
              class: {
                'b-taskboard-column-title': 1
              },
              children: [_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].encodeHtml(text), me.showCountInHeader && {
                tag: 'span',
                class: {
                  'b-taskboard-column-count': 1
                },
                html: `(${(_me$getColumnTasks$le = (_me$getColumnTasks = me.getColumnTasks(columnRecord)) === null || _me$getColumnTasks === void 0 ? void 0 : _me$getColumnTasks.length) !== null && _me$getColumnTasks$le !== void 0 ? _me$getColumnTasks$le : 0})`
              }]
            }
          }
        }
      },
      dataset: {
        column: id,
        domTransition: true
      },
      elementData: {
        elementType: 'columnHeader',
        columnId: id
      }
    }; // Chained by features

    me.populateColumnHeader({
      columnRecord,
      columnHeaderConfig
    }); // Supplied by app

    (_me$columnHeaderRende = me.columnHeaderRenderer) === null || _me$columnHeaderRende === void 0 ? void 0 : _me$columnHeaderRende.call(me, {
      columnRecord,
      columnHeaderConfig
    });
    return columnHeaderConfig;
  }

  renderColumn(swimlaneRecord, columnRecord) {
    var _swimlaneRecord$id, _me$columnRenderer;

    const me = this,
          {
      columnField,
      swimlaneField
    } = me,
          {
      width,
      flex,
      id,
      minWidth,
      color
    } = columnRecord,
          {
      taskStore
    } = me.project,
          perRow = me.getTasksPerRow(columnRecord, swimlaneRecord),
          domId = `${me.id}-column-${(_swimlaneRecord$id = swimlaneRecord === null || swimlaneRecord === void 0 ? void 0 : swimlaneRecord.id) !== null && _swimlaneRecord$id !== void 0 ? _swimlaneRecord$id : 'default'}-${id}`,
          columnConfig = {
      id: domId,
      class: {
        'b-taskboard-column': 1,
        'b-fixed-width': width && !flex,
        [`b-${perRow}-task${perRow > 1 ? 's' : ''}-per-row`]: 1,
        'b-inline': perRow > 1,
        [`b-taskboard-color-${color}`]: color,
        'b-last': columnRecord === this.columns.last
      },
      style: {
        width,
        flex,
        minWidth
      },
      dataset: {
        column: id,
        lane: swimlaneRecord === null || swimlaneRecord === void 0 ? void 0 : swimlaneRecord.id,
        domTransition: true
      },
      elementData: {
        elementType: 'column',
        columnId: id,
        laneId: swimlaneRecord === null || swimlaneRecord === void 0 ? void 0 : swimlaneRecord.id
      },
      // Cards
      children: {
        body: {
          id: `${domId}-body`,
          class: {
            'b-taskboard-column-body': 1
          },
          style: {
            'grid-template-columns': `repeat(${perRow}, 1fr)`
          },
          dataset: {
            role: 'body',
            domTransition: true
          },
          children: taskStore.query(r => r[columnField] === id && (!swimlaneField || !swimlaneRecord || r[swimlaneField] === swimlaneRecord.id) // Might have no lanes
          ).map(taskRecord => me.renderCard(taskRecord, columnRecord, swimlaneRecord)),
          syncOptions: {
            syncIdField: 'task'
          }
        }
      },
      syncOptions: {
        syncIdField: 'role'
      }
    }; // Chained by features

    me.populateColumn({
      columnRecord,
      swimlaneRecord,
      columnConfig
    }); // Supplied by app

    (_me$columnRenderer = me.columnRenderer) === null || _me$columnRenderer === void 0 ? void 0 : _me$columnRenderer.call(me, {
      columnRecord,
      swimlaneRecord,
      columnConfig
    });
    return columnConfig;
  }

  renderSwimlane(swimlaneRecord) {
    var _me$getSwimlaneTasks$, _me$getSwimlaneTasks, _me$swimlaneRenderer;

    const me = this,
          {
      showCountInHeader,
      columns
    } = me,
          {
      id = 'default',
      text,
      height,
      flex,
      color
    } = swimlaneRecord || {},
          domId = `${me.id}-swimlane-${id}`,
          swimlaneConfig = {
      id: domId,
      class: {
        'b-taskboard-swimlane': 1,
        'b-fixed-height': height && !flex,
        'b-last': !swimlaneRecord || swimlaneRecord === me.swimlanes.last,
        [`b-taskboard-color-${color}`]: color
      },
      style: {
        height,
        flex
      },
      dataset: {
        lane: id,
        domTransition: true
      },
      elementData: {
        elementType: 'swimlane',
        laneId: id
      },
      children: {
        // If a lane is defined, it has a header
        header: swimlaneRecord && {
          id: `${domId}-header`,
          tag: 'header',
          class: {
            'b-taskboard-swimlane-header': 1
          },
          dataset: {
            role: 'header'
          },
          children: {
            title: {
              class: {
                'b-taskboard-swimlane-title': 1
              },
              children: {
                text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].encodeHtml(text),
                count: showCountInHeader && {
                  tag: 'span',
                  class: {
                    'b-taskboard-swimlane-count': 1
                  },
                  text: `(${(_me$getSwimlaneTasks$ = (_me$getSwimlaneTasks = me.getSwimlaneTasks(swimlaneRecord)) === null || _me$getSwimlaneTasks === void 0 ? void 0 : _me$getSwimlaneTasks.size) !== null && _me$getSwimlaneTasks$ !== void 0 ? _me$getSwimlaneTasks$ : 0})`
                }
              }
            }
          }
        },
        // Lane or no lane, there is always a body to contain columns
        body: {
          id: `${domId}-body`,
          class: {
            'b-taskboard-swimlane-body': 1
          },
          dataset: {
            role: 'body',
            domTransition: true
          },
          // Columns within the lane
          children: columns.map(column => !column.hidden && me.renderColumn(swimlaneRecord, column)),
          syncOptions: {
            syncIdField: 'column',
            releaseThreshold: 0
          }
        }
      },
      syncOptions: {
        syncIdField: 'role'
      }
    };
    me.populateSwimlane({
      swimlaneRecord,
      swimlaneConfig
    }); // Supplied by app

    (_me$swimlaneRenderer = me.swimlaneRenderer) === null || _me$swimlaneRenderer === void 0 ? void 0 : _me$swimlaneRenderer.call(me, {
      swimlaneRecord,
      swimlaneConfig
    });
    return swimlaneConfig;
  } // Creates a DOM config for the entire TaskBoard, rendered to panels body


  get bodyConfig() {
    var _swimlanes;

    const me = this,
          // Pull in configs that affect rendering, even if not used here to prime them
    // TODO: Ask Don about a better way
    {
      /* eslint-disable no-unused-vars */
      stickyHeaders,
      showCountInHeader,
      columns,
      columnField,
      swimlaneField,
      tasksPerRow,
      headerItems,
      bodyItems,
      footerItems,
      selectedTasks,
      showCollapseInHeader
      /* eslint-enable no-unused-vars */

    } = me; // On first compose, supply a minimal body to have element ready when features inject their contents on next
    // compose. Allows us to avoid using hacks to pull features in early

    if (!me.rendered) {
      // Queue up another recompose after the minimal bootstrap, to render columns while loading
      me.setTimeout(() => me.recompose(), 0);
      return {
        // Required by panel, it expects a bodyElement reference
        reference: 'bodyElement',
        // Listeners are only set up on first sync, has to go here
        listeners: _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assign({
          thisObj: me
        }, me.domListeners)
      };
    } // We get here on second compose, features are now pulled in and we have an outer element ready


    const bodyConfig = {
      reference: 'bodyElement',
      class: {
        'b-taskboard-body': 1,
        'b-sticky-headers': stickyHeaders
      },
      children: [// Column headers
      {
        tag: 'header',
        id: `${me.id}-column-headers`,
        class: {
          'b-taskboard-column-headers': 1
        },
        children: columns.map(column => !column.hidden && me.renderColumnHeader(column)),
        dataset: {
          lane: 'header',
          domTransition: true
        },
        syncOptions: {
          syncIdField: 'column'
        }
      }],
      syncOptions: {
        syncIdField: 'lane',
        releaseThreshold: 0,
        ignoreRefs: 'children' // References in "children" should not be hoisted to the panel

      }
    };
    let {
      swimlanes
    } = me; // There is always a swimlane

    if (!((_swimlanes = swimlanes) !== null && _swimlanes !== void 0 && _swimlanes.count)) {
      swimlanes = [null];
    } // Swimlanes


    for (const lane of swimlanes) {
      if (!(lane !== null && lane !== void 0 && lane.hidden)) {
        bodyConfig.children.push(me.renderSwimlane(lane));
      }
    }

    me.populateBody({
      bodyConfig
    });
    me.isComposed = true;
    return bodyConfig;
  } // For chaining, to decorate dom config


  populateCard(args) {
    var _super$populateCard;

    (_super$populateCard = super.populateCard) === null || _super$populateCard === void 0 ? void 0 : _super$populateCard.call(this, args);
  }

  populateColumn(args) {
    var _super$populateColumn;

    (_super$populateColumn = super.populateColumn) === null || _super$populateColumn === void 0 ? void 0 : _super$populateColumn.call(this, args);
  }

  populateColumnHeader(args) {
    var _super$populateColumn2;

    (_super$populateColumn2 = super.populateColumnHeader) === null || _super$populateColumn2 === void 0 ? void 0 : _super$populateColumn2.call(this, args);
  }

  populateSwimlane(args) {
    var _super$populateSwimla;

    (_super$populateSwimla = super.populateSwimlane) === null || _super$populateSwimla === void 0 ? void 0 : _super$populateSwimla.call(this, args);
  }

  populateBody(args) {
    var _super$populateBody;

    (_super$populateBody = super.populateBody) === null || _super$populateBody === void 0 ? void 0 : _super$populateBody.call(this, args);
  }

  afterRecompose() {
    super.afterRecompose();
    const me = this;

    if (!me.isInitiallyComposed && me.isComposed) {
      me.isInitiallyComposed = true;
      me.initialCompose();
    }

    me.transitionRecompose = null;
  } // For chaining, replaces render() since we don't do full compose on render


  initialCompose() {
    this.trigger('initialCompose');
  } // For chaining, to react to element changes


  onRenderColumn() {}

  onRemoveColumnElement() {}

  onRenderSwimlane() {}

  onRemoveSwimlaneElement() {} //endregion
  //region Transition - experimental
  // Prevent dom transitions until resumed


  suspendDomTransition() {
    this.domTransitionSuspended++;
  } // Resume dom transitions


  resumeDomTransition() {
    this.domTransitionSuspended--;
  } // Recompose transitioning dom


  recomposeWithDomTransition(options) {
    const me = this;

    if (me.useDomTransition && !me.domTransitionSuspended) {
      me.transitionRecompose = _objectSpread({
        selector: '[data-dom-transition]',
        duration: 300,
        element: me.bodyElement
      }, options);
    }

    me.recompose();
  } //endregion
  // Expected by CrudManagerView


  refresh() {
    this.recompose();
  }

}

_defineProperty(TaskBoardBase, "$name", 'TaskBoardBase');

_defineProperty(TaskBoardBase, "type", 'taskboardbase');

_defineProperty(TaskBoardBase, "featureable", {
  factory: _feature_TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_12__["default"]
});

_defineProperty(TaskBoardBase, "configurable", {
  /**
   * An object containing Feature configuration objects (or `true` if no configuration is required)
   * keyed by the Feature class name in all lowercase.
   * @config {Object}
   * @category Common
   */
  features: true,

  /**
   * An empty function by default, but provided so that you can override it. This function is called each time
   * a task is rendered into the task board. It allows you to manipulate the DOM config object used for the card
   * before it is synced to DOM, thus giving you control over styling and contents.
   *
   * NOTE: The function is intended for formatting, you should not update records in it since updating records
   * triggers another round of rendering.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *    taskRenderer({ taskRecord, cardConfig }) {
   *        // Add an icon to all tasks header
   *        cardConfig.children.header.children.icon = {
   *            tag   : 'i',
   *            class : 'b-fa b-fa-beer'
   *        }
   *    }
   * });
   * ```
   *
   * For more information, see the [Customize task contents guide](#TaskBoard/guides/customization/taskcontents.md).
   *
   * @config {Function}
   * @param {Object} detail An object containing the information needed to render a task.
   * @param {Core.data.Model} detail.taskRecord The task record.
   * @param {Core.data.Model} detail.columnRecord The column the task will be displayed in.
   * @param {Core.data.Model} detail.swimlaneRecord The swimlane the task will be displayed in.
   * @param {DomConfig} detail.cardConfig DOM config object for the cards element
   * @category Task content
   */
  taskRenderer: null,

  /**
   * An empty function by default, but provided so that you can override it. This function is called each time
   * a swimlane is rendered into the task board. It allows you to manipulate the DOM config object used for the
   * swimlane before it is synced to DOM, thus giving you control over styling and contents.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *    swimlaneRenderer({ swimlaneRecord, swimlaneConfig }) {
   *        // Add an icon to all swimlane headers
   *        swimlaneConfig.children.header.children.icon = {
   *            tag   : 'i',
   *            class : 'b-fa b-fa-dog'
   *        }
   *    }
   * });
   * ```
   *
   * @config {Function}
   * @param {Object} detail An object containing the information needed to render a swimlane.
   * @param {Core.data.Model} detail.swimlaneRecord The swimlane.
   * @param {DomConfig} detail.swimlaneConfig DOM config object for the swimlane
   * @category Advanced
   */
  swimlaneRenderer: null,

  /**
   * Controls how many cards are rendered to a row in each column. Can be controlled on a per column basis by
   * setting {@link TaskBoard.model.ColumnModel#field-tasksPerRow}
   *
   * ```javascript
   * new TaskBoard({
   *   tasksPerRow : 3
   * });
   * ```
   *
   * @config {Number}
   * @category Common
   */
  tasksPerRow: 1,

  /**
   * Show task count for a column in its header, appended after the title
   *
   * ```javascript
   * new TaskBoard({
   *   showCountInHeader : false
   * });
   * ```
   *
   * @config {Boolean}
   * @default
   * @category Common
   */
  showCountInHeader: true,

  /**
   * Makes column and swimlane headers sticky
   *
   * ```javascript
   * new TaskBoard({
   *   stickyHeaders : true
   * });
   * ```
   *
   * @config {Boolean}
   * @default
   * @category Common
   */
  stickyHeaders: false,

  /**
   * Experimental, animate actions that cannot be animated using CSS transitions. Currently includes:
   * * Programmatically moving tasks
   * * Moving tasks using the task editor
   * * Adding tasks
   * * Removing tasks
   * * Sorting tasks
   * * Hiding/showing/filtering columns
   * * Hiding/showing/filtering swimlanes
   *
   * ```javascript
   * new TaskBoard({
   *   useDomTransition : true
   * });
   * ```
   * **NOTE**: This flag is not supported for Lightning Web Components
   * @config {Boolean}
   * @category Experimental
   */
  useDomTransition: false,

  /**
   * Path to load resource images from. Used by the for example the resource picker in the task editor and by the
   * ResourceAvatars task item. Set this to display miniature images for each resource using their `image` field.
   *
   * **NOTE**: The path should end with a `/`:
   *
   * ```javascript
   * new TaskBoard({
   *   resourceImagePath : 'images/resources/'
   * });
   * ```
   *
   * @config {String}
   * @category Common
   */
  resourceImagePath: null,

  /**
   * CSS variable prefix, appended to the keys used in {@link #config-css}.
   *
   * Normally you do not need to change this value.
   *
   * @default
   * @config {String}
   * @category CSS
   */
  cssVarPrefix: 'taskboard',

  /**
   * Configuration values for the {@link Core.util.ScrollManager} class. It is used to manage column/body scrolling
   * during task, column or swimlane drag.
   * ```javascript
   * new TaskBoard({
   *     scrollManager : {
   *         zoneWidth   : 100, // increase zone size
   *         scrollSpeed : 3    // and scroll speed
   *     }
   * })
   * ```
   * @config {Object}
   * @category Scrolling
   */
  scrollManager: {
    value: {},
    $config: ['nullify', 'lazy']
  },

  /**
   * TaskBoard has the following default key mappings:
   *
   * | Keys             | Action               |
   * |------------------|----------------------|
   * | ArrowDown        | navigateDown         |
   * | ArrowLeft        | navigateLeft         |
   * | ArrowUp          | navigateUp           |
   * | ArrowRight       | navigateRight        |
   * | Enter            | activate             |
   * | ' ' (space)      | keyboardSelect       |
   * | Ctrl+' '         | keyboardToggleSelect |
   * | Shift+ArrowDown  | selectDown           |
   * | Shift+ArrowLeft  | selectLeft           |
   * | Shift+ArrowUp    | selectUp             |
   * | Shift+ArrowRight | selectRight          |
   *
   * You can supply your own key map if you want to change any mapping, or set it to `null` to disable all keyboard
   * shortcuts.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *     keyMap : {
   *         'Ctrl+Enter' : 'keyboardSelect',
   *         ' '          : null
   *     }
   * });
   * ```
   *
   * @config {Object} keyMap
   */
  contentElMutationObserver: false,
  textContent: false,
  // We can scroll in both axes.
  // Scrollable also syncs the b-horizontal-overflow and b-vertical-overflow classes
  // to allow styles to depend upon overflow state.
  scrollable: true
});

_defineProperty(TaskBoardBase, "properties", {
  isInitiallyComposed: false,
  domTransitionSuspended: 0
});

TaskBoardBase.initClass();
_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].setVersion('taskboard', '4.3.6');
TaskBoardBase._$name = 'TaskBoardBase';

/***/ }),

/***/ "./lib/TaskBoard/view/item/ImageItem.js":
/*!**********************************************!*\
  !*** ./lib/TaskBoard/view/item/ImageItem.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ImageItem; });
/* harmony import */ var _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskItem.js */ "./lib/TaskBoard/view/item/TaskItem.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module TaskBoard/view/item/ImageItem
 */

/**
 * Item displaying an image.
 *
 * Loaded from the configured {@link #config-field}, optionally prepended with a {@link #config-baseUrl}.
 *
 * {@inlineexample TaskBoard/view/item/ImageItem.js}
 *
 * @extends TaskBoard/view/item/TaskItem
 * @classType image
 */

class ImageItem extends _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * Url prepended to this items value.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *    bodyItems : {
   *        picture : { type : 'image', baseUrl : 'images/' }
   *    },
   *
   *    project : {
   *        tasksData : [
   *            { id : 1, name : 'Task #1', picture : 'photo.jpg' },
   *            { id : 2, name : 'Task #2', picture : 'image.jpg' }
   *        ]
   *    }
   * });
   *
   * // Card for task #1 will render image "images/photo.jpg"
   * // Card for task #2 will render image "images/image.jpg"
   * ```
   *
   * @config {String} baseUrl
   * @category Common
   */

  /**
   * Widget type or config to use as the editor for this item. Used in the in the inline task editor.
   *
   * ImageItems are un-editable by default.
   *
   * @config {String|Object} editor
   * @default null
   * @category Common
   */
  static render({
    domConfig,
    value,
    config
  }) {
    Object.assign(domConfig, {
      tag: 'img',
      src: (config.baseUrl || '') + value,
      draggable: false
    });
  }

}

_defineProperty(ImageItem, "$name", 'ImageItem');

_defineProperty(ImageItem, "type", 'image');

_defineProperty(ImageItem, "defaultEditor", null);

ImageItem.initClass();
ImageItem._$name = 'ImageItem';

/***/ }),

/***/ "./lib/TaskBoard/view/item/ProgressItem.js":
/*!*************************************************!*\
  !*** ./lib/TaskBoard/view/item/ProgressItem.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProgressItem; });
/* harmony import */ var _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskItem.js */ "./lib/TaskBoard/view/item/TaskItem.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module TaskBoard/view/item/ProgressItem
 */

/**
 * Item displaying a progress bar.
 *
 * Progress is determined by the value of the configured {@link #config-field}. A max value (defaults to 100) can be
 * configured using the {@link #config-max} config.
 *
 * {@inlineexample TaskBoard/view/item/ProgressItem.js}
 *
 * @extends TaskBoard/view/item/TaskItem
 * @classType progress
 */

class ProgressItem extends _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * Widget type or config to use as the editor for this item. Used in the in the inline task editor.
   *
   * ProgressItems are un-editable by default.
   *
   * @config {String|Object} editor
   * @default null
   * @category Common
   */
  static render({
    domConfig,
    value,
    config
  }) {
    const percent = Math.round(100 * value / (config.max || 100)) + '%';
    domConfig.children = [{
      class: 'b-taskboard-progress-outline',
      dataset: {
        percent
      },
      children: [{
        class: 'b-taskboard-progress-progress',
        style: {
          width: percent
        },
        dataset: {
          percent
        }
      }]
    }];
    domConfig.dataset.percent = domConfig.dataset.btip = percent;
  }

}

_defineProperty(ProgressItem, "$name", 'ProgressItem');

_defineProperty(ProgressItem, "type", 'progress');

_defineProperty(ProgressItem, "configurable", {
  /**
   * Max value, at which the bar is full.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *    bodyItems : {
   *        progress : { type : 'progress', max : 10 }
   *    },
   *
   *    project : {
   *        tasksData : [
   *            { id : 1, name : 'Task #1', progress : 9 }
   *        ]
   *    }
   * });
   *
   * // Task #1 bar is 9/10 filled
   * ```
   *
   * @config {Number} max
   * @default 100
   * @category Common
   */
});

_defineProperty(ProgressItem, "defaultEditor", null);

ProgressItem.initClass();
ProgressItem._$name = 'ProgressItem';

/***/ }),

/***/ "./lib/TaskBoard/view/item/RatingItem.js":
/*!***********************************************!*\
  !*** ./lib/TaskBoard/view/item/RatingItem.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RatingItem; });
/* harmony import */ var _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskItem.js */ "./lib/TaskBoard/view/item/TaskItem.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module TaskBoard/view/item/RatingItem
 */

/**
 * Item displaying a star rating.
 *
 * Rating is determined by the value of the configured {@link #config-field}. A max rating can be configured using the
 * {@link #config-max} config.
 *
 * {@inlineexample TaskBoard/view/item/RatingItem.js}
 *
 * @extends TaskBoard/view/item/TaskItem
 * @classType rating
 */

class RatingItem extends _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * Max rating.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *    bodyItems : {
   *       grade : { type : 'ratingitem', max : 5 }
   *    },
   *
   *    project : {
   *        tasksData : [
   *            { id : 1, name : 'Task #1', grade : 3 }
   *        ]
   *    }
   * });
   *
   * // Card for task #1 will render 3 full stars and 2 faded,
   * // for a total of 5 stars
   * ```
   *
   * @config {Number} max
   * @category Common
   */

  /**
   * Widget type or config to use as the editor for this item. Used in the in the inline task editor.
   *
   * RatingItems are un-editable by default.
   *
   * @config {String|Object} editor
   * @default null
   * @category Common
   */
  static render({
    domConfig,
    value,
    config
  }) {
    const {
      max = value
    } = config;
    domConfig.children = [];

    for (let i = 0; i < max; i++) {
      domConfig.children.push({
        tag: 'i',
        class: {
          'b-icon b-icon-star': 1,
          'b-filled': i < value
        }
      });
    }
  }

}

_defineProperty(RatingItem, "$name", 'RatingItem');

_defineProperty(RatingItem, "type", 'rating');

_defineProperty(RatingItem, "defaultEditor", null);

RatingItem.initClass();
RatingItem._$name = 'RatingItem';

/***/ }),

/***/ "./lib/TaskBoard/view/item/ResourceAvatarsItem.js":
/*!********************************************************!*\
  !*** ./lib/TaskBoard/view/item/ResourceAvatarsItem.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourceAvatarsItem; });
/* harmony import */ var _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskItem.js */ "./lib/TaskBoard/view/item/TaskItem.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/widget/util/AvatarRendering.js */ "./lib/Core/widget/util/AvatarRendering.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';




/**
 * @module TaskBoard/view/item/ResourceAvatarsItem
 */

/**
 * Item displaying avatars or initials for a tasks assigned resources.
 *
 * {@inlineexample TaskBoard/view/item/ResourceAvatarsItem.js}
 *
 * @extends TaskBoard/view/item/TaskItem
 * @classType resourceAvatars
 */

class ResourceAvatarsItem extends _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * Maximum avatars to display by default. The last avatar will render an overflow indicator if the task has more
   * resources assigned.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *     headerItems : {
   *         resources : {
   *             type       : 'resourceAvatars',
   *             maxAvatars : 5
   *         }
   *     }
   * });
   * ```
   *
   * Overridden by card size based settings, see {@link TaskBoard.view.mixin.ResponsiveCards}.
   *
   * @config {Number} maxAvatars
   * @default 7
   * @category Common
   */

  /**
   * Specify `true` to slightly overlap avatars for tasks that have multiple resources assigned. By default they are
   * displayed side by side.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *     headerItems : {
   *         resources : {
   *             overlap : true
   *         }
   *     }
   * });
   * ```
   *
   * @config {Boolean} overlap
   */

  /**
   * Widget type or config to use as the editor for this item. Used in the in the inline task editor.
   *
   * Defaults to use a {@link TaskBoard.widget.ResourcesCombo}.
   *
   * @config {String|Object} editor
   * @default resourcescombo
   * @category Common
   */
  static render({
    taskBoard,
    domConfig,
    config,
    taskRecord,
    cardSize
  }) {
    var _ref, _cardSize$maxAvatars;

    const maxAvatars = (_ref = (_cardSize$maxAvatars = cardSize === null || cardSize === void 0 ? void 0 : cardSize.maxAvatars) !== null && _cardSize$maxAvatars !== void 0 ? _cardSize$maxAvatars : config.maxAvatars) !== null && _ref !== void 0 ? _ref : 7,
          {
      resourceImagePath
    } = taskBoard,
          {
      resources
    } = taskRecord,
          hasOverflow = resources.length > maxAvatars,
          overflowCount = resources.length - maxAvatars + 1,
          lastResource = resources[maxAvatars];
    let {
      avatarRendering
    } = taskBoard;

    if (!avatarRendering) {
      avatarRendering = taskBoard.avatarRendering = new _Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
        element: taskBoard.element
      });
    }

    if (!taskBoard.project.resourceStore.count) {
      return false;
    }

    _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge(domConfig, {
      class: {
        'b-overlap': config.overlap
      },
      children: [// "Normal" avatars
      ...resources.slice(0, maxAvatars - (hasOverflow ? 1 : 0)) // -1 for the overflow indicator
      .map((resource, i) => ({
        class: {
          'b-taskboard-resource-avatar-wrap': 1
        },
        dataset: {
          resourceId: resource.id
        },
        children: [avatarRendering.getResourceAvatar({
          imageUrl: resource.image === false ? null : resource.imageUrl || resource.image && resourceImagePath + resource.image,
          initials: resource.initials,
          dataset: {
            btip: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeHtml(resource.name)
          },
          alt: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeHtml(resource.name)
        })]
      })), // Overflow indicating avatar
      hasOverflow && {
        class: {
          'b-taskboard-resource-avatar-overflow': 1
        },
        dataset: {
          resourceId: '$overflow',
          btip: resources.slice(-overflowCount).map(r => _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].encodeHtml(r.name)).join(', '),
          count: overflowCount
        },
        children: [avatarRendering.getResourceAvatar({
          imageUrl: lastResource.image === false ? null : lastResource.imageUrl || lastResource.image && resourceImagePath + lastResource.image,
          initials: lastResource.initials
        })]
      }],
      syncOptions: {
        syncIdField: 'resourceId'
      }
    });
  }

  static onClick({
    source: taskBoard,
    taskRecord,
    event
  }) {
    const element = event.target.closest('.b-resource-avatar, .b-taskboard-resource-avatar-overflow');

    if (element) {
      if (element.matches('.b-resource-avatar')) {
        const resourceRecord = taskBoard.project.resourceStore.getById(element.dataset.resourceId);
        taskBoard.trigger('resourceAvatarClick', {
          resourceRecord,
          taskRecord,
          element,
          event
        });
      } else {
        taskBoard.trigger('resourceAvatarOverflowClick', {
          taskRecord,
          element,
          event
        });
      }

      return false;
    }
  }

}

_defineProperty(ResourceAvatarsItem, "$name", 'ResourceAvatarsItem');

_defineProperty(ResourceAvatarsItem, "type", 'resourceAvatars');

_defineProperty(ResourceAvatarsItem, "defaultEditor", {
  type: 'resourcescombo',
  pickerWidth: '13em'
});

ResourceAvatarsItem.initClass();
ResourceAvatarsItem._$name = 'ResourceAvatarsItem';

/***/ }),

/***/ "./lib/TaskBoard/view/item/SeparatorItem.js":
/*!**************************************************!*\
  !*** ./lib/TaskBoard/view/item/SeparatorItem.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SeparatorItem; });
/* harmony import */ var _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskItem.js */ "./lib/TaskBoard/view/item/TaskItem.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module TaskBoard/view/item/SeparatorItem
 */

/**
 * Item displaying a horizontal divider.
 *
 * {@inlineexample TaskBoard/view/item/SeparatorItem.js}
 *
 * @extends TaskBoard/view/item/TaskItem
 * @classType separator
 */

class SeparatorItem extends _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * @hideconfigs editor
   */
  static render({
    domConfig
  }) {
    domConfig.tag = 'hr';
  }

}

_defineProperty(SeparatorItem, "$name", 'SeparatorItem');

_defineProperty(SeparatorItem, "type", 'separator');

_defineProperty(SeparatorItem, "defaultEditor", null);

SeparatorItem.initClass();
SeparatorItem._$name = 'SeparatorItem';

/***/ }),

/***/ "./lib/TaskBoard/view/item/TagsItem.js":
/*!*********************************************!*\
  !*** ./lib/TaskBoard/view/item/TagsItem.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TagsItem; });
/* harmony import */ var _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskItem.js */ "./lib/TaskBoard/view/item/TaskItem.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _widget_TagCombo_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../widget/TagCombo.js */ "./lib/TaskBoard/widget/TagCombo.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



/**
 * @module TaskBoard/view/item/TagsItem
 */

/**
 * Item displaying tags, either from string split into tags, an array of strings or by plucking a value from an array of
 * objects.
 *
 * Using a string, split into tags using the configured {@link #config-separator}:
 *
 * {@inlineexample TaskBoard/view/item/TagsItem.js}
 *
 * Using an array of strings, each entry is turned into a tag:
 *
 * {@inlineexample TaskBoard/view/item/TagsItemStringArray.js}
 *
 * Using an array of objects, gives you the most control over the tags. Requires configuring a
 * {@link #config-textProperty} and optionally a {@link #config-clsProperty}:
 *
 * {@inlineexample TaskBoard/view/item/TagsItemObjectArray.js}
 *
 * @extends TaskBoard/view/item/TaskItem
 * @classType tags
 */

class TagsItem extends _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * Property used to determine the text for the tag. It is plucked from an array of objects that is used as the value
   * for this item.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *    bodyItems : {
   *       tags : { type : 'TagsItem', textProperty : 'title' }
   *    },
   *
   *    project : {
   *        tasksData : [{
   *            id : 1,
   *            name : 'Issue #1',
   *            tags : [
   *                { title : 'bug', color : 'orange' },
   *                { title : 'important', color : 'red' }
   *            ]
   *        }]
   *    }
   * });
   *
   * // Card for Issue #1 will render 2 tags, 'bug' and 'important'
   * ```
   *
   * @config {String} textProperty
   * @category Common
   */

  /**
   * Property used to add a CSS class to each tag. It is plucked from an array of objects that is used as the value
   * for this item.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *    bodyItems : {
   *       tags : { type : 'TagsItem', clsProperty : 'color' }
   *    },
   *
   *    project : {
   *        tasksData : [{
   *            id : 1,
   *            name : 'Issue #1',
   *            tags : [
   *                { title : 'bug', color : 'orange' },
   *                { title : 'important', color : 'red' }
   *            ]
   *        }]
   *    }
   * });
   *
   * // Card for Issue #1 will render 2 tags, one with cls 'orange' and one with cls 'red'
   * ```
   *
   * @config {String} clsProperty
   * @category Common
   */

  /**
   * Property used to split a value string into tags.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *    bodyItems : {
   *       tags : { type : 'TagsItem', separator : ';' }
   *    },
   *
   *    project : {
   *        tasksData : [{
   *            id : 1,
   *            name : 'Issue #1',
   *            tags : 'bug;important'
   *        }]
   *    }
   * });
   *
   * // Card for Issue #1 will render 2 tags, 'bug' and 'important'
   * ```
   *
   * @config {String} separator
   * @default ,
   * @category Common
   */

  /**
   * Widget type or config to use as the editor for this item. Used in the in the inline task editor.
   *
   * Defaults to use a {@link TaskBoard.widget.TagCombo}.
   *
   * @config {String|Object} editor
   * @default tagcombo
   * @category Common
   */
  static render({
    domConfig,
    value,
    config
  }) {
    let tags;

    if (value) {
      if (typeof value === 'string') {
        tags = value.split(config.separator || ',').map(str => ({
          text: str
        }));
      } else if (Array.isArray(value)) {
        tags = value.map(entry => {
          if (typeof entry === 'string') {
            return {
              text: entry
            };
          } else {
            return {
              text: config.textProperty && entry[config.textProperty],
              cls: config.clsProperty && entry[config.clsProperty]
            };
          }
        });
      }

      if (tags) {
        domConfig.children = tags.map(tag => {
          const cls = 'cls' in tag ? tag.cls : _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].makeValidId(tag.text, '-').toLowerCase();
          return {
            class: {
              'b-taskboard-tags-tag': 1,
              [cls]: Boolean(cls)
            },
            text: tag.text
          };
        });
      }
    }
  }

}

_defineProperty(TagsItem, "$name", 'TagsItem');

_defineProperty(TagsItem, "type", 'tags');

_defineProperty(TagsItem, "defaultEditor", {
  type: 'tagcombo',
  pickerWidth: '10em'
});

TagsItem.initClass();
TagsItem._$name = 'TagsItem';

/***/ }),

/***/ "./lib/TaskBoard/view/item/TaskItem.js":
/*!*********************************************!*\
  !*** ./lib/TaskBoard/view/item/TaskItem.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskItem; });
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module TaskBoard/view/item/TaskItem
 */

/**
 * Abstract base class for task items, lightweight "widgets" that can be added to tasks using the
 * {@link TaskBoard/view/TaskBoard#config-headerItems}, {@link TaskBoard/view/TaskBoard#config-bodyItems} and
 * {@link TaskBoard/view/TaskBoard#config-footerItems} configs.
 *
 * @abstract
 */

class TaskItem extends _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_Core_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  static getEditorConfig({
    config,
    item
  }) {
    const editor = config.editor !== null && (config.editor || item.defaultEditor);

    if (typeof editor === 'string') {
      return {
        type: editor
      };
    }

    return editor;
  }

}

_defineProperty(TaskItem, "factoryable", {});

_defineProperty(TaskItem, "configurable", {
  /**
   * Task field whose value item will act on (usually display it). Defaults to use the key in the items object.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *    features : {
   *        taskItems : {
   *            items : {
   *                // Will use "prio" as its field
   *                prio  : { type : 'textitem' },
   *                // Will use "status" as its field
   *                state : { type : 'textitem', field : 'status' }
   *            }
   *        }
   *    }
   * });
   * ```
   *
   * @config {String} field
   * @category Common
   */

  /**
   * Style definition in string or object form.
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *    features : {
   *        taskItems : {
   *            items : {
   *                prio  : { type : 'textitem', style : { color : 'red' } }
   *            }
   *        }
   *    }
   * });
   * ```
   *
   * @config {String|Object} style
   * @category Common
   */

  /**
   * Specify `true` to hide the task item.
   *
   * @config {Boolean} hidden
   * @category Common
   */

  /**
   * Flex order, can be used to re-order task items.
   *
   * @config {Number} order
   * @default 1
   * @category Common
   */

  /**
   * CSS class to add.
   *
   * @config {String} cls
   * @category Common
   */

  /**
   * Widget type or config to use as the editor for this item. Used in the in the inline task editor.
   * Set to `null` to not use an editor for this item.
   *
   * @config {String|Object} editor
   * @default text
   * @category Common
   */
});

_defineProperty(TaskItem, "defaultEditor", {
  type: 'text'
});

TaskItem._$name = 'TaskItem';

/***/ }),

/***/ "./lib/TaskBoard/view/item/TaskMenuItem.js":
/*!*************************************************!*\
  !*** ./lib/TaskBoard/view/item/TaskMenuItem.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskMenuItem; });
/* harmony import */ var _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskItem.js */ "./lib/TaskBoard/view/item/TaskItem.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module TaskBoard/view/item/TaskMenuItem
 */

/**
 * Item that adds a `···` button hooked up to display the {@link TaskBoard/feature/TaskMenu} on click.
 *
 * Requires the {@link TaskBoard/feature/TaskMenu} to work as intended.
 *
 * {@inlineexample TaskBoard/view/item/TaskMenuItem.js}
 *
 * @extends TaskBoard/view/item/TaskItem
 * @classType taskMenu
 */

class TaskMenuItem extends _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * @hideconfigs editor
   */
  static render({
    taskBoard,
    domConfig
  }) {
    if (!taskBoard.features.taskMenu || taskBoard.features.taskMenu.disabled) {
      return false;
    }

    domConfig.tag = 'i';
    domConfig.class['b-icon b-icon-menu-horizontal'] = 1;
  }

  static onClick({
    source: taskBoard,
    event
  }) {
    var _taskBoard$features$t;

    (_taskBoard$features$t = taskBoard.features.taskMenu) === null || _taskBoard$features$t === void 0 ? void 0 : _taskBoard$features$t.showContextMenu(event, {
      target: event.target,
      align: 't90-b90',
      anchor: true
    });
  }

}

_defineProperty(TaskMenuItem, "$name", 'TaskMenuItem');

_defineProperty(TaskMenuItem, "type", 'taskMenu');

_defineProperty(TaskMenuItem, "defaultEditor", null);

TaskMenuItem.initClass();
TaskMenuItem._$name = 'TaskMenuItem';

/***/ }),

/***/ "./lib/TaskBoard/view/item/TemplateItem.js":
/*!*************************************************!*\
  !*** ./lib/TaskBoard/view/item/TemplateItem.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TemplateItem; });
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _TaskItem_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TaskItem.js */ "./lib/TaskBoard/view/item/TaskItem.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module TaskBoard/view/item/TemplateItem
 */

/**
 * Item displaying content generated by a template function, see {@link #config-template}
 *
 * {@inlineexample TaskBoard/view/item/TemplateItem.js}
 *
 * @extends TaskBoard/view/item/TaskItem
 * @classType template
 */

class TemplateItem extends _TaskItem_js__WEBPACK_IMPORTED_MODULE_1__["default"] {
  /**
   * Template function used to generate task content.
   *
   * Return a HTML string or a DomConfig object from the function:
   *
   * ```javascript
   * const taskBoard = new TaskBoard({
   *    bodyItems : {
   *        prio : {
   *          type     : 'template',
   *          template : taskRecord => `<i class="b-fa b-fa-tarffic-light"></i> ${taskRecord.prio}`
   *        }
   *    }
   * });
   * ```
   *
   * @config {Function} template
   * @param {TaskBoard.model.TaskModel} taskRecord Task record
   * @param {Object} config Item config
   * @param {Object} value Value of the configured field
   * @returns {String|DomConfig|DomConfig[]} HTML string or DomConfig or DomConfig array
   * @category Common
   */

  /**
   * Widget type or config to use as the editor for this item. Used in the in the inline task editor.
   *
   * TemplateItems are un-editable by default.
   *
   * @config {String|Object} editor
   * @default null
   * @category Common
   */
  static render({
    domConfig,
    value,
    config,
    taskRecord
  }) {
    const html = config.template({
      taskRecord,
      config,
      value
    });

    if (typeof html === 'string') {
      domConfig.html = html;
    } else if (_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(html)) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].merge(domConfig, html);
    } else if (Array.isArray(html)) {
      domConfig.children = html;
    }
  }

}

_defineProperty(TemplateItem, "$name", 'TemplateItem');

_defineProperty(TemplateItem, "type", 'template');

_defineProperty(TemplateItem, "defaultEditor", null);

TemplateItem.initClass();
TemplateItem._$name = 'TemplateItem';

/***/ }),

/***/ "./lib/TaskBoard/view/item/TextItem.js":
/*!*********************************************!*\
  !*** ./lib/TaskBoard/view/item/TextItem.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextItem; });
/* harmony import */ var _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskItem.js */ "./lib/TaskBoard/view/item/TaskItem.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module TaskBoard/view/item/TextItem
 */

/**
 * Item that displays the value of the configured {@link #config-field} in a XSS safe way.
 *
 * {@inlineexample TaskBoard/view/item/TextItem.js}
 *
 * @extends TaskBoard/view/item/TaskItem
 * @classType text
 */

class TextItem extends _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  static render({
    domConfig,
    value,
    taskRecord,
    config
  }) {
    // Special handling when bound to id
    if (config.field === 'id' && taskRecord.hasGeneratedId) {
      domConfig.class['b-generated-id'] = 1;
      domConfig.text = '✻';
    } else {
      domConfig.text = taskRecord.getFieldDefinition(config.field).print(value);
    }
  }

}

_defineProperty(TextItem, "$name", 'TextItem');

_defineProperty(TextItem, "type", 'text');

TextItem.initClass();
TextItem._$name = 'TextItem';

/***/ }),

/***/ "./lib/TaskBoard/view/item/TodoListItem.js":
/*!*************************************************!*\
  !*** ./lib/TaskBoard/view/item/TodoListItem.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TodoListItem; });
/* harmony import */ var _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TaskItem.js */ "./lib/TaskBoard/view/item/TaskItem.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module TaskBoard/view/item/TodoListItem
 */

/**
 * Item displaying a list of todo items with associated checkboxes. It allows users to toggle the checkbox for each item
 * on the card to indicate if that item is completed or not. By adding a {@link TaskBoard/widget/TodoListField} to the
 * task editor users can also add, edit and remove todo items.
 *
 * {@inlineexample TaskBoard/view/item/TodoListItem.js}
 *
 * It consumes an array of objects representing todo items. For this item to work as indented, that array has to be
 * supplied by a task field using `type : 'array'`. It is also important to configure the {@link #config-textField} and
 * {@link #config-checkedField} to match properties of the objects in that array. This snippet illustrates a possible
 * setup:
 *
 * ```javascript
 * // Custom task model with a todo field of array type
 * class MyTask extends TaskModel {
 *     static fields = [
 *        { name : 'todo', type : 'array' }
 *     ];
 * }
 *
 * const taskBoard = new TaskBoard({
 *    project : {
 *        // Use the custom task model defined above
 *        taskModelClass : MyTask,
 *
 *        tasksData : [
 *            {
 *              id : 1,
 *              name : 'Order software',
 *              // The custom field, accepts an array
 *              todo : [
 *                  { title : 'Sketchup Pro', done : false },
 *                  { title : 'AutoCAD LT', done : true },
 *                  { title : 'Inventor', done : false }
 *              ]
 *            }
 *        ]
 *    },
 *
 *    bodyItems : {
 *        todo : {
 *            // Add a todo list item to card body
 *            type         : 'todoList',
 *            // Map text to the "title" field
 *            textField    : 'text',
 *            // Map checkbox to the "done" field
 *            checkedField : 'done'
 *        }
 *    }
 * });
 * ```
 *
 * @extends TaskBoard/view/item/TaskItem
 * @classType todoList
 */

class TodoListItem extends _TaskItem_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  /**
   * Name of a property on a todo item to display as its text.
   *
   * @config {String} textField
   * @category Common
   * @default text
   */

  /**
   * Name of a property on a todo item to use for the checkbox. The property is expected to be a boolean.
   *
   * @config {String} checkedField
   * @category Common
   * @default checked
   */

  /**
   * Name of a property on a todo item whose value will be added as a CSS class to the todo item.
   *
   * @config {String} clsField
   * @category Common
   * @default cls
   */
  // private for now:
  // checkedIcon
  // uncheckedIcon

  /**
   * @hideconfigs editor
   */
  static render({
    domConfig,
    value,
    config,
    taskRecord
  }) {
    if (value) {
      const {
        textField = 'text',
        checkedField = 'checked',
        clsField = 'cls',
        checkedIcon = 'b-icon b-icon-checked',
        uncheckedIcon = 'b-icon b-icon-unchecked'
      } = config;

      if (this.firstRender !== false) {
        const dataField = taskRecord.getFieldDefinition(config.field);

        if (!dataField.isArrayDataField) {
          throw new Error('TodoListItem has to be mapped to a field with `type : "array"`');
        }
      }

      domConfig.children = value.map((todo, index) => ({
        class: {
          'b-taskboard-todolist-todo': 1,
          [todo[clsField]]: todo[clsField],
          'b-checked': todo[checkedField]
        },
        children: {
          icon: {
            tag: 'i',
            class: todo[checkedField] ? checkedIcon : uncheckedIcon
          },
          text: {
            tag: 'span',
            text: todo[textField]
          }
        },
        elementData: {
          index
        }
      }));
      this.firstRender = false;
    }
  }

  static onClick({
    source: taskBoard,
    taskRecord,
    event,
    config
  }) {
    const element = event.target.closest('.b-taskboard-todolist-todo');

    if (element && !taskRecord.readOnly) {
      const {
        checkedField = 'checked',
        field
      } = config,
            {
        index
      } = element.elementData,
            // array fields has to be assigned a new array to detect a change, hence the slice
      clone = taskRecord[field].slice(),
            todo = clone[index]; // Toggle the mapped fields value

      todo[checkedField] = !todo[checkedField]; // Assign the cloned array to the task record

      taskRecord[field] = clone;
      taskBoard.trigger('todoToggle', {
        taskRecord,
        todo,
        checked: todo[checkedField],
        element,
        event
      }); // Dont want the click to select the task, feels a bit awkward when it does

      event.preventDefault();
    }
  } // Prevent editor from opening when dbl clicking a todo item


  static onDblClick({
    event
  }) {
    event.preventDefault();
  }

}

_defineProperty(TodoListItem, "$name", 'TodoListItem');

_defineProperty(TodoListItem, "type", 'todoList');

_defineProperty(TodoListItem, "defaultEditor", null);

TodoListItem.initClass();
TodoListItem._$name = 'TodoListItem';

/***/ }),

/***/ "./lib/TaskBoard/view/mixin/ExpandCollapse.js":
/*!****************************************************!*\
  !*** ./lib/TaskBoard/view/mixin/ExpandCollapse.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony import */ var _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';






/**
 * @module TaskBoard/view/mixin/ExpandCollapse
 */

/**
 * Mixin that handles expanding and collapsing swimlanes and columns on the TaskBoard.
 *
 * {@inlineexample TaskBoard/view/mixin/ExpandCollapse.js}
 *
 * Users can expand and collapse using the UI. To do it programmatically, see:
 *
 * * {@link #function-collapse collapse()}
 * * {@link #function-expand expand()}
 * * {@link #function-toggleCollapse toggleCollapse()}
 *
 * Each of them accepts a column or a swimlane to expand/collapse. For example
 *
 * ```javascript
 * taskBoard.collapse(taskBoard.columns.todo);
 * taskBoard.expand(taskBoard.swimlanes.high);
 * ```
 *
 * For convenience, the functions are also callable directly on columns/swimlanes:
 *
 * ```javascript
 * taskBoard.columns.todo.expand();
 * taskBoard.swimlanes.high.collapse();
 * ```
 *
 * Expanding/collapsing is by default transitioned, `await` the calls to be certain that the UI is up to date:
 *
 * ```javascript
 * await taskBoard.collapse(taskBoard.columns.todo);
 * await taskBoard.columns.todo.expand();
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class ExpandCollapse extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    //region Config
    get widgetClass() {} //endregion
    //region Type assertions


    changeShowCollapseInHeader(showCollapseInHeader) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_4__["default"].assertBoolean(showCollapseInHeader, 'showCollapseInHeader');
      return showCollapseInHeader;
    } //endregion
    //region Toggling

    /**
     * Collapse a swimlane or column.
     *
     * Await the call to be certain that the collapse transition has ended.
     *
     * ```javascript
     * await taskBoard.collapse(taskBoard.columns.first);
     * ```
     *
     * @param {Core.data.Model} record Swimlane or column
     * @async
     * @category Expand & collapse
     */


    async collapse(record) {
      await this.toggleCollapse(record, true);
    }
    /**
     * Expand a swimlane or column.
     *
     * Await the call to be certain that the expand transition has ended.
     *
     * ```javascript
     * await taskBoard.expand(taskBoard.columns.first);
     * ```
     *
     * @param {Core.data.Model} record Swimlane or column
     * @async
     * @category Expand & collapse
     */


    async expand(record) {
      await this.toggleCollapse(record, false);
    }
    /**
     * Expand or collapse a swimlane or column.
     *
     * Await the call to be certain that the expand/collapse transition has ended.
     *
     * ```javascript
     * // Toggle
     * await taskBoard.toggleCollapse(taskBoard.columns.first);
     * // Force collapse
     * await taskBoard.toggleCollapse(taskBoard.columns.first, true);
     * // Force expand
     * await taskBoard.toggleCollapse(taskBoard.columns.first, false);
     * ```
     *
     * @param {TaskBoard.model.SwimlaneModel|TaskBoard.model.ColumnModel} record Swimlane or column
     * @param {Boolean} [collapse] Specify to force a certain state, leave out to toggle
     * @category Expand & collapse
     */


    async toggleCollapse(record, collapse = !record.collapsed) {
      if (record.isSwimlaneModel) {
        await this.toggleSwimlaneCollapse(record, collapse);
      } else {
        await this.toggleColumnCollapse(record, collapse);
      }
    }

    async toggleSwimlaneCollapse(swimlaneRecord, collapse = !swimlaneRecord.collapsed) {
      return new Promise(resolve => {
        const me = this,
              swimlaneElement = me.getSwimlaneElement(swimlaneRecord),
              swimlaneBody = _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_1__["default"].getChild(swimlaneElement, 'body'); // Set a height on collapse, to transition down from -> 0

        if (collapse) {
          swimlaneBody.style.height = `${swimlaneBody.getBoundingClientRect().height}px`;
        }

        _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].onTransitionEnd({
          element: swimlaneBody,
          property: 'height',

          handler() {
            // Remove that height on expand, after it has transitioned from 0 to it
            if (!collapse) {
              swimlaneBody.style.height = '';
            }

            swimlaneElement.classList.remove(collapse ? 'b-collapsing' : 'b-expanding'); // Make sure UI is up to date when promise is resolved

            me.recompose.flush();
            resolve();
          },

          thisObj: me
        });
        swimlaneElement.classList.add(collapse ? 'b-collapsing' : 'b-expanding');
        me.suspendDomTransition(); // This will trigger the recompose

        swimlaneRecord.collapsed = collapse;
        me.resumeDomTransition();
      });
    }

    async toggleColumnCollapse(columnRecord, collapse = !columnRecord.collapsed) {
      return new Promise(resolve => {
        const me = this,
              {
          documentRoot
        } = me,
              columnElements = me.getColumnElements(columnRecord),
              headerElement = _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_1__["default"].getChild(me.bodyElement, 'header.' + columnRecord.id),
              // For columns that already has a width specified we wont need to measure and apply current width
        hasFixedWidth = columnRecord.width && !columnRecord.flex,
              cardElements = documentRoot.querySelectorAll(`.b-taskboard-card[data-column="${columnRecord.id}"]`); // Fix card widths on collapse, to not have their contents reflow during the collapse

        cardElements.forEach(card => {
          if (collapse) {
            card.style.width = `${card.getBoundingClientRect().width}px`;
          }
        });
        columnElements.unshift(headerElement);
        columnElements.forEach(element => {
          // Set a width on collapse, to transition down from -> 0
          if (collapse) {
            if (!hasFixedWidth) {
              element.style.width = `${element.getBoundingClientRect().width}px`;
            }

            element.classList.add('b-collapsing');
          } // Add cls to keep flex away a bit longer on expand
          else {
            element.classList.add('b-expanding');
          }
        });
        _Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].onTransitionEnd({
          element: headerElement,
          property: 'width',

          handler() {
            // Unfix card widths when fully expanded again
            cardElements.forEach(card => {
              if (!collapse) {
                card.style.width = null;
              }
            }); // Remove that width on expand, after it has transitioned from 0 to it

            columnElements.forEach(element => {
              if (!collapse) {
                // Restore width and flex from css
                if (!hasFixedWidth) {
                  element.style.width = '';
                }

                element.classList.remove('b-expanding');
              } else {
                element.classList.remove('b-collapsing');
              }
            }); // Make sure UI is up to date when promise is resolved

            me.recompose.flush();
            resolve();
          },

          thisObj: me
        }); // Force browser to reevaluate, for transition to trigger

        headerElement.offsetWidth;
        me.suspendDomTransition(); // This will trigger the recompose

        columnRecord.collapsed = collapse;
        me.resumeDomTransition();
      });
    } //endregion
    //region Rendering
    // Inject expander icon + expand/collapsed state cls in column headers


    populateColumnHeader(args) {
      var _super$populateColumn;

      (_super$populateColumn = super.populateColumnHeader) === null || _super$populateColumn === void 0 ? void 0 : _super$populateColumn.call(this, args);
      const {
        showCollapseInHeader,
        collapseTitle,
        hasSwimlanes
      } = this,
            {
        columnRecord,
        columnHeaderConfig
      } = args,
            {
        text,
        collapsed,
        collapsible
      } = columnRecord;
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge(columnHeaderConfig, {
        class: {
          'b-collapsed': collapsed,
          'b-rotate-title': collapsed && !collapseTitle && !hasSwimlanes
        },
        children: {
          padder: {
            children: {
              expander: showCollapseInHeader && collapsible && {
                tag: 'i',
                class: {
                  'b-taskboard-column-expander': 1,
                  'b-fw-icon': 1,
                  'b-icon-expand-column': 1
                },
                dataset: {
                  btip: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].xss`${this.L(collapsed ? 'L{TaskBoard.expand}' : 'L{TaskBoard.collapse}', text)}`
                }
              }
            }
          }
        }
      });
    } // Inject expand/collapsed state cls in columns


    populateColumn(args) {
      var _super$populateColumn2;

      (_super$populateColumn2 = super.populateColumn) === null || _super$populateColumn2 === void 0 ? void 0 : _super$populateColumn2.call(this, args);
      const {
        columnRecord,
        columnConfig
      } = args,
            {
        collapsed
      } = columnRecord;
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge(columnConfig, {
        class: {
          'b-collapsed': collapsed
        }
      });
    } // Inject expander icon + expand/collapsed state cls in swimlanes


    populateSwimlane(args) {
      var _super$populateColumn3;

      (_super$populateColumn3 = super.populateColumn) === null || _super$populateColumn3 === void 0 ? void 0 : _super$populateColumn3.call(this, args);
      const {
        swimlaneRecord,
        swimlaneConfig
      } = args;

      if (swimlaneRecord) {
        const {
          showCollapseInHeader
        } = this,
              {
          text,
          collapsed,
          collapsible
        } = swimlaneRecord;
        _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge(swimlaneConfig, {
          class: {
            'b-collapsed': collapsed,
            'b-collapsible': collapsible
          },
          children: {
            header: {
              children: {
                title: {
                  children: {
                    // Before text
                    'expander > text': showCollapseInHeader && collapsible && {
                      tag: 'i',
                      class: {
                        'b-taskboard-swimlane-expander': 1,
                        'b-icon': 1,
                        'b-icon-expand-row': 1
                      },
                      dataset: {
                        btip: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].xss`${collapsed ? 'Expand' : 'Collapse'} ${text}`
                      }
                    }
                  }
                }
              }
            }
          }
        });
      }
    } //endregion
    //region Listeners


    onColumnHeaderClick({
      event,
      columnRecord
    }) {
      if (event.target.matches('.b-taskboard-column-expander')) {
        this.toggleCollapse(columnRecord);
      }
    }

    onSwimlaneHeaderClick({
      swimlaneRecord
    }) {
      this.toggleCollapse(swimlaneRecord);
    } //endregion


  }, _defineProperty(_class, "$name", 'ExpandCollapse'), _defineProperty(_class, "configurable", {
    /**
     * Show an icon to expand/collapse columns and swimlanes in their headers.
     *
     * Programmatic expand/collapse works independently of this setting, it only affects the UI.
     *
     * @config {Boolean}
     * @default
     * @category Common
     */
    showCollapseInHeader: true,

    /**
     * Specify `true` to hide the column title instead of rotating it on collapse.
     *
     * Used by default with swimlanes, since the title will overlap the swimlane header otherwise.
     *
     * @config {Boolean}
     * @default
     * @category Misc
     */
    collapseTitle: false
  }), _temp;
});

/***/ }),

/***/ "./lib/TaskBoard/view/mixin/ResponsiveCards.js":
/*!*****************************************************!*\
  !*** ./lib/TaskBoard/view/mixin/ResponsiveCards.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



/**
 * @module TaskBoard/view/mixin/ResponsiveCards
 */

/**
 * An object that describes a card size level.
 *
 * @typedef {Object} CardSize
 * @property {String} name Level name, applied to the columns element as CSS class `b-[name]-cards`
 * @property {Number} maxWidth Express in px. This level applies above the previous levels maxWidth and up to this value
 * @property {Number} maxAvatars Max number of resource avatars to render, when that feature is used
 * @property {Object} headerItems A config object for items in a cards header, merges with
 * {@link TaskBoard.view.TaskBoard#config-headerItems} to determine items for this card size
 * @property {Object} bodyItems A config object for items in a cards header, merges with
 * {@link TaskBoard.view.TaskBoard#config-bodyItems} to determine items for this card size
 * @property {Object} footerItems A config object for items in a cards header, merges with
 * {@link TaskBoard.view.TaskBoard#config-footerItems} to determine items for this card size
 */

/**
 * Mixin that allows responsive card behaviours.
 *
 * {@inlineexample TaskBoard/view/mixin/ResponsiveCards.js}
 *
 * It monitors column sizes using a ResizeObserver. When a columns width changes, it calculates the width of the cards
 * in that column based on the columns width and the configured number of tasks per row (see
 * {@link TaskBoard.view.TaskBoard#config-tasksPerRow}).
 *
 * The card width is then used to pick a {@link #config-cardSizes}, which applies CSS and might also affect task items.
 *
 * By default the following levels are defined:
 *
 * | Width | Name   | Cls            | Avatars | Items                       |
 * |-------|--------|----------------|---------|-----------------------------|
 * | < 50  | micro  | b-micro-cards  | 1       | Only resource avatars shown |
 * | < 75  | tiny   | b-tiny-cards   | 1       |                             |
 * | < 175 | small  | b-small-cards  | 1       |                             |
 * | < 300 | medium | b-medium-cards | 3       |                             |
 * | > 300 | large  | b-large-cards  | 7       |                             |
 *
 * If for example cards in a column are above 50px and below 75px wide, that column will have the `b-tiny-cards` CSS
 * class applied to its element. Use it to style the cards in a suitable way for your application, perhaps by applying
 * a smaller font size, hiding images etc.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class ResponsiveCards extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    constructor(...args) {
      super(...args);

      _defineProperty(this, "responsivenessSuspended", 0);
    }

    get widgetClass() {} //endregion
    //region Type assertions


    changeCardSizes(cardSizes) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertArray(cardSizes, 'cardSizes');
      return cardSizes;
    } //endregion
    //region Suspend/resume responsiveness


    suspendResponsiveness() {
      this.responsivenessSuspended++;
    }

    resumeResponsiveness() {
      this.responsivenessSuspended--;
    } //endregion
    //region Calculate card size
    // Get a card size entity, very similar to a responsive level in Grid


    getCardSize(columnRecord, swimlaneRecord) {
      const me = this,
            {
        cardSizes
      } = me,
            perRow = me.getTasksPerRow(columnRecord, swimlaneRecord),
            columnWidth = me.getColumnWidth(columnRecord),
            // Three cards on a row shares the column width with 2 gaps.
      // Column padding is not measured and thus not part of calc
      // |               |
      // | █ gap █ gap █ |
      // |               |
      cardWidth = (columnWidth - me.cardGap * (perRow - 1)) / perRow; // TODO: Cache until next resize

      return (cardSizes === null || cardSizes === void 0 ? void 0 : cardSizes.find(size => cardWidth < size.maxWidth)) || (cardSizes === null || cardSizes === void 0 ? void 0 : cardSizes[cardSizes.length - 1]);
    } // Get the last reported width for a column, set by the ResizeObserver


    getColumnWidth(columnRecord) {
      return columnRecord.instanceMeta(this).width;
    } // Number of tasks per row to render for the requested column / swimlane intersection.
    // Prio order is columns config, swimlanes config and lastly taskboards config


    getTasksPerRow(columnRecord, swimlaneRecord) {
      return columnRecord.tasksPerRow || (swimlaneRecord === null || swimlaneRecord === void 0 ? void 0 : swimlaneRecord.tasksPerRow) || this.tasksPerRow;
    } //endregion
    //region ResizeObserver
    // ResizeObserver callback for column size changes


    onChildResize(entries) {
      const me = this;

      if (me.recompose.suspended || me.responsivenessSuspended) {
        return;
      } // If any columns width changed enough for it to change card size level (medium -> large etc) we need to
      // recompose to allow UI to react


      let shouldRecompose = false;

      for (const entry of entries) {
        const {
          target,
          contentRect
        } = entry; // Only care about width

        if (target.observedWidth !== contentRect.width) {
          const columnRecord = me.resolveColumnRecord(target),
                // We are observing the headers, but need to calculate card size per column / swimlane intersection
          columnElements = columnRecord && me.columns.includes(columnRecord) && me.getColumnElements(columnRecord); // Bail out when collapsing or hiding the column or if we did not get any record, which can happen
          // during recompose when switching column set

          if (!columnRecord || columnRecord.collapsed || columnRecord.hidden || !columnElements) {
            return;
          } // Cache width on element and column record (for easy lookup later)


          columnRecord.instanceMeta(me).width = target.observedWidth = contentRect.width;

          for (const columnElement of columnElements) {
            const swimlaneRecord = me.resolveSwimlaneRecord(columnElement),
                  cardSize = me.getCardSize(columnRecord, swimlaneRecord); // Was the size change enough to take us to a new card size level?

            if (cardSize && columnElement.elementData.cardSize !== cardSize.name) {
              shouldRecompose = true;
            }
          }
        }
      }

      if (shouldRecompose) {
        me.recompose.now();
        me.scrollable.syncOverflowState();
      }
    } // ResizeObserver used to monitor column size, observing set up in domSyncCallback


    changeResizeObserver(observer, oldObserver) {
      oldObserver === null || oldObserver === void 0 ? void 0 : oldObserver.disconnect();
      return this.isDestroying ? null : new ResizeObserver(this.onChildResize.bind(this));
    } //endregion
    //region Rendering


    populateColumn(args) {
      var _super$populateColumn;

      (_super$populateColumn = super.populateColumn) === null || _super$populateColumn === void 0 ? void 0 : _super$populateColumn.call(this, args);
      const {
        columnRecord,
        swimlaneRecord,
        columnConfig
      } = args,
            // Tag cardSize along with args, to be reachable from renderer
      cardSize = args.cardSize = this.getCardSize(columnRecord, swimlaneRecord);
      cardSize && _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge(columnConfig, {
        class: {
          [`b-${cardSize.name}-cards`]: cardSize
        },
        elementData: {
          cardSize: cardSize.name
        }
      });
    } //endregion


  }, _defineProperty(_class, "$name", 'ResponsiveCards'), _defineProperty(_class, "configurable", {
    /**
     * An array of {@link CardSize} objects to use as responsive levels based on card widths.
     *
     * By default the following levels are defined:
     *
     * | Width | Name   | Cls            | Avatars | Items                       |
     * |-------|--------|----------------|---------|-----------------------------|
     * | < 50  | micro  | b-micro-cards  | 1       | Only resource avatars shown |
     * | < 75  | tiny   | b-tiny-cards   | 1       | Body text hidden            |
     * | < 175 | small  | b-small-cards  | 2       | Body text hidden            |
     * | < 300 | medium | b-medium-cards | 3       |                             |
     * | > 300 | large  | b-large-cards  | 7       |                             |
     *
     * @config {CardSize}
     * @category Common
     */
    cardSizes: [{
      maxWidth: 50,
      name: 'micro',
      maxAvatars: 1,
      headerItems: {
        text: null
      },
      bodyItems: {
        text: null
      }
    }, {
      maxWidth: 75,
      name: 'tiny',
      maxAvatars: 1,
      bodyItems: {
        text: null
      }
    }, {
      maxWidth: 175,
      name: 'small',
      maxAvatars: 2,
      bodyItems: {
        text: null
      }
    }, {
      maxWidth: 250,
      name: 'medium',
      maxAvatars: 3
    }, {
      name: 'large',
      maxAvatars: 7
    }],
    resizeObserver: {
      value: true,
      $config: ['nullify']
    }
  }), _temp;
});

/***/ }),

/***/ "./lib/TaskBoard/view/mixin/TaskBoardColumns.js":
/*!******************************************************!*\
  !*** ./lib/TaskBoard/view/mixin/TaskBoardColumns.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _model_ColumnModel_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../model/ColumnModel.js */ "./lib/TaskBoard/model/ColumnModel.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';





/**
 * @module TaskBoard/view/mixin/TaskBoardColumns
 */

const transitionChangeActions = {
  remove: 1,
  move: 1,
  update: 1,
  filter: 1
};
/**
 * Mixin that handles swimlanes for the TaskBoard.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class TaskBoardColumns extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    //region Config
    get widgetClass() {} //endregion
    //region Type assertions


    changeAutoGenerateColumns(autoGenerateColumns) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertBoolean(autoGenerateColumns, 'autoGenerateColumns');
      return autoGenerateColumns;
    }

    changeColumnField(columnField) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertString(columnField, 'columnField');
      return columnField;
    } //endregion
    //region Config - columnField


    updateColumnField(field, old) {
      if (old) {
        const {
          storage
        } = this.project.taskStore;
        storage.removeIndex(old);
        storage.addIndex({
          property: field,
          unique: false
        });
      }

      this.shouldAutoGenerateColumns = field && this.autoGenerateColumns;
    } //endregion
    //region Config - columns


    changeColumns(columns) {
      return _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(columns, {
        objectify: true,
        modelClass: _model_ColumnModel_js__WEBPACK_IMPORTED_MODULE_4__["default"]
      }, column => {
        if (typeof column === 'string') {
          return {
            id: column,
            text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].capitalize(column)
          };
        }

        return column;
      });
    }

    updateColumns(columns) {
      this.detachListeners('columns');

      if (columns) {
        // Link to us to be able to retrieve tasks in visual order
        // $store is the store instance of an objectified store
        (columns.$store || columns).taskBoard = this;
        columns.on({
          change: 'onColumnsChange',
          thisObj: this
        });
      }
    }

    get columns() {
      const me = this,
            {
        taskStore
      } = me.project; // If there are no columns defined but we have a column field configured and we have tasks loaded, generate
      // columns from the tasks

      if (me.shouldAutoGenerateColumns && taskStore.count) {
        me.columns = taskStore.getDistinctValues(me.columnField).sort();
        me.shouldAutoGenerateColumns = false;
      }

      return me._columns;
    }

    onColumnsChange({
      action
    }) {
      if (transitionChangeActions[action]) {
        const options = {};

        if (action === 'update' || action === 'remove') {
          options.addTransition = {
            width: 1,
            opacity: 1
          };
          options.removeTransition = {
            width: 1,
            opacity: 1
          };
        }

        this.recomposeWithDomTransition(options);
      } else {
        this.recompose();
      }
    } //endregion
    //region Data
    // TODO: Move to datalayer


    getColumnTasks(columnRecord, inVisualOrder = false) {
      const me = this,
            {
        taskStore
      } = me.project,
            set = taskStore.storage.findItem(me.columnField, columnRecord.id),
            tasks = set ? [...set] : [];

      if (inVisualOrder && set && me.swimlanes) {
        const {
          swimlaneField
        } = me,
              swimlanes = me.swimlanes.map(r => r.id);
        tasks.sort((a, b) => {
          // First sort by swimlane
          const swimlaneDelta = swimlanes.indexOf(a[swimlaneField]) - swimlanes.indexOf(b[swimlaneField]);

          if (swimlaneDelta !== 0) {
            return swimlaneDelta;
          } // And within a swimlane sort by weight order


          if (a.weight != null || b.weight != null) {
            return a.weight - b.weight;
          } // Fall back to store order


          return taskStore.indexOf(a) - taskStore.indexOf(b);
        }); // Only include tasks for available swimlanes, if used

        if (swimlanes.length && swimlaneField) {
          return tasks.filter(task => swimlanes.includes(task[swimlaneField]));
        }
      }

      return tasks;
    }

    getColumn(taskRecord) {
      return this.columns.getById(taskRecord[this.columnField]);
    } // Next task in the same column as supplied task


    getNextTask(taskRecord, wrap = true) {
      const columnRecord = this.getColumn(taskRecord),
            columnTasks = columnRecord.tasks;
      let nextTaskIndex = columnTasks.indexOf(taskRecord) + 1;

      if (nextTaskIndex === columnTasks.length) {
        if (wrap) {
          nextTaskIndex = 0;
        } else {
          return null;
        }
      }

      return columnTasks[nextTaskIndex];
    } // Prev task in the same column as supplied task


    getPreviousTask(taskRecord, wrap = true) {
      const columnRecord = this.getColumn(taskRecord),
            columnTasks = columnRecord.tasks;
      let prevTaskIndex = columnTasks.indexOf(taskRecord) - 1;

      if (prevTaskIndex < 0) {
        if (wrap) {
          prevTaskIndex = columnTasks.length - 1;
        } else {
          return null;
        }
      }

      return columnTasks[prevTaskIndex];
    } //endregion


  }, _defineProperty(_class, "$name", 'TaskBoardColumns'), _defineProperty(_class, "configurable", {
    /**
     * Store containing the TaskBoard columns.
     *
     * @member {Core.data.Store} columns
     * @category Common
     */

    /**
     * Store containing the TaskBoard columns. A tasks {@link #config-columnField} is matched against the `id` of a
     * column to determine in which column it is displayed.
     *
     * Accepts an array of column records/objects/strings, a store instance, a store id or a store config object
     * used to create a new store.
     *
     * When supplying an array, a store configured with {Core.data.mixin.StoreProxy#config-objectify} is
     * automatically created. Using that config allows for a nicer interaction syntax with the columns:
     *
     * ```javascript
     * // Without objectify:
     * taskBoard.columns.getById('done').text = 'Finished';
     *
     * // With objectify:
     * taskBoard.columns.done.text = 'Finished';
     * ```
     *
     * When supplying strings, the raw string will be used as the columns `id` and a capitalized version of it is
     * used as the columns text:
     *
     * ```javascript
     * taskBoard = new TaskBoard({
     *    columns : [
     *        'doing',
     *        'done'
     *    ]
     * });
     * ```
     *
     * Is equivalent to:
     *
     * ```javascript
     * taskBoard = new TaskBoard({
     *    columns : [
     *        { id : 'doing', text : 'Doing' },
     *        { id : 'done', text : 'Done' }
     *    ]
     * });
     * ```
     *
     * @config {TaskBoard.model.ColumnModel[]|Object[]|String[]|Core.data.Store|String|Object}
     * @category Common
     */
    columns: {},

    /**
     * Set to `true` to auto generate columns when {@link #config-columns} is undefined.
     *
     * A column will be created for each distinct value of {@link #config-columnField} on the tasks. The columns
     * will be sorted in alphabetical order. The following snippet will yield two columns, Q1 and Q2:
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *    columnField : 'quarter',
     *
     *    autoGenerateColumns : true,
     *
     *    project : {
     *        tasksData : [
     *            { id : 1, name : 'Inform tenants', quarter : 'Q1' },
     *            { id : 2, name : 'Renovate roofs', quarter : 'Q2' }
     *        ]
     *    }
     * });
     * ```
     *
     * @config {Boolean}
     * @category Advanced
     */
    autoGenerateColumns: false,

    /**
     * Field on a task record used to determine which column the task belongs to.
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *    columnField : 'status',
     *
     *    columns : [
     *        'todo',
     *        'done'
     *    ],
     *
     *    project : {
     *        tasksData : [
     *            // Linked using the status field, to the done column
     *            { id : 1, name : 'Fun task', status : 'done' }
     *        ]
     *    }
     * });
     * ```
     *
     * @config {String}
     * @category Common
     */
    columnField: null
  }), _defineProperty(_class, "properties", {
    shouldAutoGenerateColumns: false
  }), _temp;
});

/***/ }),

/***/ "./lib/TaskBoard/view/mixin/TaskBoardDom.js":
/*!**************************************************!*\
  !*** ./lib/TaskBoard/view/mixin/TaskBoardDom.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



/**
 * @module TaskBoard/view/mixin/TaskBoardDom
 */

/**
 * Mixin that handles resolving elements from records and vice versa.
 *
 * ```javascript
 * // Resolve task record from an element
 * const task = taskBoard.resolveTaskRecord(someElement);
 *
 * // Get tasks element
 * const element = taskBoard.getTaskElement(taskBoard.taskStore.first);
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class TaskBoardDom extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    //region Config
    get widgetClass() {} //endregion
    //region Resolve record from element

    /**
     * Retrieves a task record corresponding to the supplied element. Has to be a `.b-taskboard-card` element or
     * descendant thereof.
     *
     * ```javascript
     * const taskRecord = taskBoard.resolveTaskRecord(taskElement);
     * ```
     *
     * @param {HTMLElement} element
     * @returns {TaskBoard.model.TaskModel}
     * @category DOM
     */


    resolveTaskRecord(element) {
      var _element$elementData;

      element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(element, '.b-taskboard-card'); // If element is a drop indicator, it wont have elementData

      return element && this.project.taskStore.getById((_element$elementData = element.elementData) === null || _element$elementData === void 0 ? void 0 : _element$elementData.taskId);
    }
    /**
     * Retrieves a column record resolved from the supplied element. Has to be a `.b-taskboard-column` element or
     * descendant thereof (such as a card).
     *
     * ```javascript
     * const columnRecord = taskBoard.resolveColumnRecord(taskElement);
     * ```
     *
     * @param {HTMLElement} element
     * @returns {TaskBoard.model.ColumnModel}
     * @category DOM
     */


    resolveColumnRecord(element) {
      var _element$elementData2;

      element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(element, '.b-taskboard-column, .b-taskboard-column-header'); // Headers are b-taskboard-column but withouth elementData, for now

      return element && this.columns.getById((_element$elementData2 = element.elementData) === null || _element$elementData2 === void 0 ? void 0 : _element$elementData2.columnId);
    }
    /**
     * Retrieves a swimlane record resolved from the supplied element. Has to be a `.b-taskboard-swimlane` element or
     * descendant thereof.
     *
     * ```javascript
     * const swimlaneRecord = taskBoard.resolveSwimlaneRecord(taskElement);
     * ```
     *
     * @param {HTMLElement} element
     * @returns {TaskBoard.model.SwimlaneModel}
     * @category DOM
     */


    resolveSwimlaneRecord(element) {
      var _this$swimlanes;

      element = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].up(element, '.b-taskboard-swimlane');
      return element && ((_this$swimlanes = this.swimlanes) === null || _this$swimlanes === void 0 ? void 0 : _this$swimlanes.getById(element.elementData.laneId));
    } //endregion
    //region Get element from record

    /**
     * Retrieves the task element (card) corresponding to the supplied task record.
     *
     * ```javascript
     * const cardElement = taskBoard.getTaskElement(taskRecord);
     * ```
     *
     * @param {TaskBoard.model.TaskModel} taskRecord
     * @returns {HTMLElement}
     * @category DOM
     */


    getTaskElement(taskRecord) {
      return _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__["default"].getChild(this.getTaskColumnElement(taskRecord), `body.${taskRecord.id}`);
    }
    /**
     * Retrieves the element for the column that holds the supplied task record.
     *
     * ```javascript
     * const columnElement = taskBoard.getColumnElement(taskRecord);
     * ```
     *
     * @param {TaskBoard.model.TaskModel} taskRecord
     * @returns {HTMLElement}
     * @category DOM
     */


    getTaskColumnElement(taskRecord) {
      return _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__["default"].getChild(this.getTaskSwimlaneElement(taskRecord), `body.${taskRecord[this.columnField]}`);
    }
    /**
     * Retrieves the element for the swimlane that holds the supplied task record.
     *
     * ```javascript
     * const swimlaneElement = taskBoard.getTaskSwimlaneElement(taskRecord);
     * ```
     *
     * @param {TaskBoard.model.TaskModel} taskRecord
     * @returns {HTMLElement}
     * @category DOM
     */


    getTaskSwimlaneElement(taskRecord) {
      var _this$swimlanes2;

      // When not using swimlanes, we still create one called 'default'
      const lane = (_this$swimlanes2 = this.swimlanes) !== null && _this$swimlanes2 !== void 0 && _this$swimlanes2.count ? taskRecord[this.swimlaneField] : 'default';
      return _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__["default"].getChild(this.bodyElement, lane);
    }
    /**
     * Retrieves the element for the supplied swimlane.
     *
     * ```javascript
     * const swimlaneElement = taskBoard.getSwimlaneElement(taskBoard.swimlanes.first);
     * ```
     *
     * @param {TaskBoard.model.SwimlaneModel} swimlaneRecord
     * @returns {HTMLElement}
     * @category DOM
     */


    getSwimlaneElement(swimlaneRecord) {
      // Get a swimlane element, does not query DOM and is thus cheap
      return _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__["default"].getChild(this.bodyElement, swimlaneRecord.id);
    }
    /**
     * Retrieves the element for the supplied swimlane / column intersection.
     *
     * ```javascript
     * const element = taskBoard.getSwimlaneColumnElement(taskBoard.swimlanes.first, taskBoard.columns.last);
     * ```
     *
     * @param {TaskBoard.model.SwimlaneModel} swimlaneRecord
     * @param {TaskBoard.model.ColumnModel} columnRecord
     * @returns {HTMLElement}
     * @category DOM
     */


    getSwimlaneColumnElement(swimlaneRecord, columnRecord) {
      // Called with a swimlaneRecord (public API)
      if (swimlaneRecord) {
        // Get the column element for specified column / swimlane intersection, does not query DOM and is thus cheap
        return _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__["default"].getChild(this.getSwimlaneElement(swimlaneRecord), `body.${columnRecord.id}`);
      } // Called without, happens internally when not using swimlanes - to have simpler code paths
      else {
        return this.getColumnElement(columnRecord);
      }
    }
    /**
     * Retrieves the element for the supplied column.
     *
     * Only applicable when not using swimlanes. If you are using swimlanes, see {@link #function-getColumnElements}.
     *
     * @param {TaskBoard.model.ColumnModel} columnRecord
     * @returns {HTMLElement}
     * @category DOM
     */


    getColumnElement(columnRecord) {
      var _this$getColumnElemen;

      return (_this$getColumnElemen = this.getColumnElements(columnRecord)) === null || _this$getColumnElemen === void 0 ? void 0 : _this$getColumnElemen[0];
    }
    /**
     * Retrieves the elements for the supplied column. When using swimlanes, a column has one element per swimlane.
     *
     * @param {TaskBoard.model.ColumnModel} columnRecord
     * @returns {HTMLElement}
     * @category DOM
     */


    getColumnElements(columnRecord) {
      var _this$swimlanes3;

      // A column can span multiple swimlanes, it will have one element per swimlane.
      // If we have multiple swimlanes, iterate them and retrieve column elements.
      // This approach avoids querying DOM and is thus cheap
      if ((_this$swimlanes3 = this.swimlanes) !== null && _this$swimlanes3 !== void 0 && _this$swimlanes3.count) {
        return this.swimlanes.reduce((result, lane) => {
          if (!lane.hidden) {
            result.push(this.getSwimlaneColumnElement(lane, columnRecord));
          }

          return result;
        }, []);
      } // No swimlanes, still return as array for consistency


      return [this.getSwimlaneColumnElement({
        id: 'default'
      }, columnRecord)]; // no-sanity
    }
    /**
     * Retrieves the header element for the supplied column.
     *
     * @param {TaskBoard.model.ColumnModel} columnRecord
     * @returns {HTMLElement}
     * @category DOM
     */


    getColumnHeaderElement(columnRecord) {
      return _Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_2__["default"].getChild(this.bodyElement, `header.${columnRecord.id}`);
    } //endregion
    //region Position based

    /**
     * Get the card element at (x, y)
     * @param {Number} x
     * @param {Number} y
     * @param {String} cardSelector
     * @returns {HTMLElement}
     * @internal
     */


    getCardAt(x, y, cardSelector = '.b-taskboard-card') {
      var _this$documentRoot$el;

      return (_this$documentRoot$el = this.documentRoot.elementFromPoint(x, y)) === null || _this$documentRoot$el === void 0 ? void 0 : _this$documentRoot$el.closest(cardSelector);
    } //endregion
    //region Cached measurements
    // TODO: Reset on CSS var change somehow? Or perhaps not likely to be needed


    cacheCSSVar(name, defaultValue) {
      const me = this;
      let size = me[`_${name}`];

      if (size == null) {
        const value = me.css[name];
        size = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].measureSize(value || defaultValue, me.element);

        if (value) {
          me[`_${name}`] = size;
        }
      }

      return size;
    } // Cached card gap


    get cardGap() {
      return this.cacheCSSVar('cardGap', '1em');
    } //endregion


  }, _defineProperty(_class, "$name", 'TaskBoardDom'), _temp;
});

/***/ }),

/***/ "./lib/TaskBoard/view/mixin/TaskBoardDomEvents.js":
/*!********************************************************!*\
  !*** ./lib/TaskBoard/view/mixin/TaskBoardDomEvents.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module TaskBoard/view/mixin/TaskBoardDomEvents
 */

/**
 * Mixin that handles dom events (click etc) for the TaskBoard and its columns and cards.
 *
 * {@inlineexample TaskBoard/view/mixin/TaskBoardDomEvents.js}
 *
 * Snippet showing two ways to add listeners:
 *
 * ```javascript
 * // Listener defined as part of config
 * const taskBoard = new TaskBoard({
 *     listeners : {
 *        taskClick({ taskRecord }) {
 *            Toast.show(`Clicked on ${taskRecord.name}`);
 *        }
 *     }
 * });
 *
 * // Listener added at runtime
 * taskBoard.on('taskDblClick', ({ taskRecord }) => { ... });
 * ```
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class TaskBoardDomEvents extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    //region Config
    get widgetClass() {} //endregion
    //region Events

    /**
     * Triggered when a card is clicked.
     *
     * ```javascript
     * taskBoard.on('taskClick', ({ taskRecord }) => {
     *    Toast.show(`Clicked on ${taskRecord.name}`);
     * });
     * ```
     *
     * @event taskClick
     * @param {TaskBoard.view.TaskBoard} source This TaskBoard
     * @param {Core.data.Model} taskRecord Task record
     * @param {TaskBoard.model.ColumnModel} columnRecord Column record for the tasks column
     * @param {TaskBoard.model.SwimlaneModel} swimlaneRecord Swimlane record for the tasks swimlane (if used)
     * @param {MouseEvent} event Browser event
     */

    /**
     * Triggered when a card is double clicked
     *
     * ```javascript
     * taskBoard.on('taskDblClick', ({ taskRecord }) => {
     *    Toast.show(`Double clicked on ${taskRecord.name}`);
     * });
     * ```
     *
     * @event taskDblClick
     * @param {TaskBoard.view.TaskBoard} source This TaskBoard
     * @param {Core.data.Model} taskRecord Task record
     * @param {TaskBoard.model.ColumnModel} columnRecord Column record for the tasks column
     * @param {TaskBoard.model.SwimlaneModel} swimlaneRecord Swimlane record for the tasks swimlane (if used)
     * @param {MouseEvent} event Browser event
     */

    /**
     * Triggered when the mouse enters a card
     *
     * ```javascript
     * taskBoard.on('taskMouseEnter', ({ taskRecord }) => {
     *    Toast.show(`Mouse entered ${taskRecord.name}`);
     * });
     * ```
     *
     * @event taskMouseEnter
     * @param {TaskBoard.view.TaskBoard} source This TaskBoard
     * @param {Core.data.Model} taskRecord Task record
     * @param {TaskBoard.model.ColumnModel} columnRecord Column record for the tasks column
     * @param {TaskBoard.model.SwimlaneModel} swimlaneRecord Swimlane record for the tasks swimlane (if used)
     * @param {MouseEvent} event Browser event
     */

    /**
     * Triggered when the mouse leaves a card
     *
     * ```javascript
     * taskBoard.on('taskMouseLeave', ({ taskRecord }) => {
     *    Toast.show(`Mouse left ${taskRecord.name}`);
     * });
     * ```
     *
     * @event taskMouseLeave
     * @param {TaskBoard.view.TaskBoard} source This TaskBoard
     * @param {Core.data.Model} taskRecord Task record
     * @param {TaskBoard.model.ColumnModel} columnRecord Column record for the tasks column
     * @param {TaskBoard.model.SwimlaneModel} swimlaneRecord Swimlane record for the tasks swimlane (if used)
     * @param {MouseEvent} event Browser event
     */

    /**
     * Triggered when a task is "activated" by pressing `Enter` or double clicking it.
     *
     * By default this leads to the task editor being shown.
     *
     * ```javascript
     * taskBoard.on('activateTask', ({ taskRecord }) => {
     *    Toast.show(`Activated ${taskRecord.name}`);
     * });
     * ```
     *
     * @event activateTask
     * @param {TaskBoard.view.TaskBoard} source This TaskBoard
     * @param {Core.data.Model} taskRecord Task record
     * @param {MouseEvent} event Browser event
     */

    /**
     * Triggered when a task is rendered.
     *
     * This happens on initial render, when a task is added or when the task element is updated.
     *
     * Listening to this event allows you to manipulate the tasks element directly after it has been updated. Please
     * note that we strongly recommend using a `taskRenderer` to manipulate the DomConfig used to update the task for
     * most scenarios.
     *
     * If you listen for this event and manipulate the element in some way, you should also listen for
     * `removeTaskElement` and revert/clean up the changes there.
     *
     * @event renderTask
     * @param {TaskBoard.view.TaskBoard} source TaskBoard instance
     * @param {TaskBoard.model.TaskModel} taskRecord Task being rendered
     * @param {Boolean} isRefresh `true` if the element was updated, `false` if it was added
     * @param {HTMLElement} element Tasks element
     */

    /**
     * Triggered when a tasks element is removed.
     *
     * This happens when a task is removed or when it is move to another swimlane / column (in which case a `renderTask`
     * event is triggered for the new element).
     *
     * If you used listener for `renderTask` to alter the element of tasks, you should also listen for this event to
     * clean that modification up.
     *
     * @event removeTaskElement
     * @param {TaskBoard.view.TaskBoard} source TaskBoard instance
     * @param {String|Number} taskId Id of the task (not the record itself since it might be removed)
     * @param {HTMLElement} element Tasks element
     */
    //endregion
    //region Triggering
    // Sets the domListeners up, all relayed to triggerDomEvent()


    changeDomListeners(domListeners) {
      if (domListeners) {
        for (const eventName in this.domEvents) {
          domListeners[eventName] = 'triggerDomEvent';
        }
      }

      return domListeners;
    } // Resolve records from the passed event


    resolveEvent(event) {
      const {
        target
      } = event,
            taskRecord = this.resolveTaskRecord(target),
            columnRecord = this.resolveColumnRecord(target),
            swimlaneRecord = this.resolveSwimlaneRecord(target);
      return {
        taskRecord,
        columnRecord,
        swimlaneRecord,
        event
      };
    } // "Re-trigger" a dom event as one of ours, populated with records and prefixed with either 'task'  or 'column'
    // depending on event target


    triggerDomEvent(event) {
      const me = this,
            args = me.resolveEvent(event),
            name = me.domEvents[event.type]; // Bail out for fields on a card

      if (event.target.closest('.b-widget') !== me.element) {
        return;
      } // Decorate the event for easy access later


      event.taskBoardData = args;
      let result; // Trigger taskDblClick or columnDblClick, depending on what was resolved

      if (args.taskRecord) {
        const eventName = `task${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(name)}`;
        result = me.trigger(eventName, args);

        if (eventName === me.activateTaskEvent && !event.defaultPrevented) {
          me.trigger('activateTask', {
            taskRecord: args.taskRecord,
            event
          });
        }
      } else if (args.columnRecord) {
        if (event.target.closest('.b-taskboard-column-header')) {
          result = me.trigger(`columnHeader${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(name)}`, args);
        } else {
          result = me.trigger(`column${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(name)}`, args);
        }
      } else if (args.swimlaneRecord) {
        if (event.target.closest('.b-taskboard-swimlane-header')) {
          result = me.trigger(`swimlaneHeader${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(name)}`, args);
        } else {
          result = me.trigger(`swimlane${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].capitalize(name)}`, args);
        }
      } // Allow returning false from taskClick, onTaskClick etc to prevent triggering 'click'


      if (result === false) {
        return;
      }

      me.trigger(name, args); // Conjure up mouseEnter and mouseLeave events from mouseOver/mouseOut

      if ((name === 'mouseOver' || name === 'mouseOut') && args.taskRecord) {
        const cardElement = event.target.closest('.b-taskboard-card');

        if (name === 'mouseOver' && cardElement !== me.$hoveredCardElement) {
          me.$hoveredCardElement = cardElement;
          me.trigger('taskMouseEnter', args);
        }

        if (name === 'mouseOut' && !cardElement.contains(event.relatedTarget)) {
          me.$hoveredCardElement = null;
          me.trigger('taskMouseLeave', args);
        }
      }
    } // Called as DomSync syncs elements


    domSyncCallback({
      action,
      domConfig,
      lastDomConfig,
      targetElement: element,
      syncId
    }) {
      var _domConfig$elementDat;

      const me = this,
            {
        elementType
      } = (_domConfig$elementDat = domConfig === null || domConfig === void 0 ? void 0 : domConfig.elementData) !== null && _domConfig$elementDat !== void 0 ? _domConfig$elementDat : {},
            isRefresh = action === 'reuseOwnElement'; // Safeguard from other non dom synced elements being cleaned up

      if (domConfig) {
        var _domConfig$class;

        // Card element synced
        if (elementType === 'task') {
          const {
            taskId
          } = domConfig.elementData,
                taskRecord = me.project.taskStore.getById(taskId);

          if (action === 'newElement' || action === 'reuseOwnElement') {
            me.trigger('renderTask', {
              taskRecord,
              element,
              isRefresh
            });
          } else if (action === 'removeElement') {
            me.trigger('removeTaskElement', {
              taskId,
              element
            });
          }
        } // Column
        else if (elementType === 'column') {
          var _me$swimlanes;

          const {
            columnId,
            laneId
          } = domConfig.elementData,
                columnRecord = me.columns.getById(columnId),
                swimlaneRecord = laneId != null && ((_me$swimlanes = me.swimlanes) === null || _me$swimlanes === void 0 ? void 0 : _me$swimlanes.getById(laneId));

          if (action === 'newElement' || action === 'reuseOwnElement') {
            me.trigger('renderColumn', {
              columnRecord,
              swimlaneRecord,
              element,
              isRefresh
            });
          } else if (action === 'removeElement') {
            me.trigger('removeColumnElement', {
              columnId,
              swimlaneRecord,
              element
            });
          }
        } // Swimlane
        else if (elementType === 'swimlane') {
          var _me$swimlanes2;

          const {
            laneId
          } = domConfig.elementData,
                swimlaneRecord = laneId != null && laneId !== 'default' && ((_me$swimlanes2 = me.swimlanes) === null || _me$swimlanes2 === void 0 ? void 0 : _me$swimlanes2.getById(laneId)); // Using swimlanes is optional

          if (laneId !== 'default') {
            if (action === 'newElement' || action === 'reuseOwnElement') {
              me.trigger('renderSwimlane', {
                swimlaneRecord,
                element,
                isRefresh
              });
            } else if (action === 'removeElement') {
              me.trigger('removeSwimlaneElement', {
                swimlaneId: laneId,
                element
              });
            }
          }
        } // Column header padder, for resize monitoring
        else if ((_domConfig$class = domConfig.class) !== null && _domConfig$class !== void 0 && _domConfig$class['b-taskboard-column-header-padder'] && me.resizeObserver) {
          if (action === 'newElement') {
            if (!element.isResizeObserved) {
              me.resizeObserver.observe(element);
              element.isResizeObserved = true;
            }
          }

          if (action === 'removeElement') {
            if (element.isResizeObserved) {
              me.resizeObserver.unobserve(element);
              delete element.isResizeObserved;
            }
          }
        }
      }
    } //endregion
    //region Chainable handlers


    onClick() {}

    onMouseMove() {}

    onMouseUp() {}

    onTaskMouseDown() {}

    onTaskClick() {}

    onTaskDblClick() {}

    onTaskContextMenu() {}

    onColumnMouseDown() {}

    onColumnHeaderClick(...args) {
      super.onColumnHeaderClick(...args);
    }

    onSwimlaneHeaderClick(...args) {
      super.onSwimlaneHeaderClick(...args);
    }

    onActivateTask() {} //endregion


  }, _defineProperty(_class, "$name", 'TaskBoardDomEvents'), _defineProperty(_class, "configurable", {
    /**
     * The name of the event that should activate a task and trigger editing (if an editing feature is active).
     * Available options are: 'taskClick', 'taskDblClick' or null (disable)
     * @default
     * @config {String}
     */
    activateTaskEvent: 'taskDblClick',
    domEvents: {
      click: 'click',
      dblclick: 'dblClick',
      mouseup: 'mouseUp',
      mousedown: 'mouseDown',
      mousemove: 'mouseMove',
      mouseover: 'mouseOver',
      mouseout: 'mouseOut',
      keydown: 'keyDown',
      contextmenu: 'contextMenu'
    },
    domListeners: {}
  }), _defineProperty(_class, "properties", {
    $hoveredCardElement: null
  }), _temp;
});

/***/ }),

/***/ "./lib/TaskBoard/view/mixin/TaskBoardScroll.js":
/*!*****************************************************!*\
  !*** ./lib/TaskBoard/view/mixin/TaskBoardScroll.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



/**
 * @module TaskBoard/view/mixin/TaskBoardScroll
 */

/**
 * Mixin that handles scrolling to tasks, columns and swimlanes.
 *
 * {@inlineexample TaskBoard/view/mixin/TaskBoardScroll.js}
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class TaskBoardScroll extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    //region Config
    get widgetClass() {} //endregion
    //region Type assertions


    changeScrollOptions(scrollOptions) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertObject(scrollOptions, 'scrollOptions');
      return scrollOptions;
    } //endregion
    //region Scroll to

    /**
     * Scroll specified swimlane into view.
     *
     * ```javascript
     * taskBoard.scrollToSwimlane('high');
     * taskBoard.scrollToSwimlane(taskBoard.swimlanes.last);
     * ```
     *
     * @param {TaskBoard.model.SwimlaneModel|Number|String} swimlaneOrId Swimlane or its id
     * @param {Object} [options] Scroll options, see {@link #config-scrollOptions}
     * @category Scrolling
     * @async
     */


    scrollToSwimlane(swimlaneOrId, options = this.scrollOptions) {
      const swimlane = this.swimlanes.getById(swimlaneOrId),
            swimlaneElement = swimlane && this.getSwimlaneElement(swimlane);

      if (swimlaneElement) {
        var _options, _options2;

        options = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({
          x: false,
          animate: ((_options = options) === null || _options === void 0 ? void 0 : _options.animate) || ((_options2 = options) === null || _options2 === void 0 ? void 0 : _options2.behavior) === 'smooth'
        }, options);
        return _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_2__["default"].scrollIntoView(swimlaneElement, options);
      }
    }
    /**
     * Scroll specified column into view.
     *
     * ```javascript
     * taskBoard.scrollToColumn('backlog');
     * taskBoard.scrollToColumn(taskBoard.columns.first);
     * ```
     *
     * @param {TaskBoard.model.ColumnModel|Number|String} columnOrId Column or its id
     * @param {Object} [options] Scroll options, see {@link #config-scrollOptions}
     * @category Scrolling
     * @async
     */


    scrollToColumn(columnOrId, options = this.scrollOptions) {
      const column = this.columns.getById(columnOrId),
            columnElement = column && this.getColumnHeaderElement(column);

      if (columnElement) {
        var _options3, _options4;

        // Only scroll in the X axis.
        options = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({
          animate: ((_options3 = options) === null || _options3 === void 0 ? void 0 : _options3.animate) || ((_options4 = options) === null || _options4 === void 0 ? void 0 : _options4.behavior) === 'smooth',
          y: false
        }, options);
        return _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_2__["default"].scrollIntoView(columnElement, options);
      }
    }
    /**
     * Scroll to the intersection between specified swimlane and column.
     *
     * ```javascript
     * taskBoard.scrollToIntersection('high', 'done');
     * taskBoard.scrollToIntersection(taskBoard.swimlanes.low, taskBoard.columns.todo);
     * ```
     *
     * @param {TaskBoard.model.SwimlaneModel|Number|String} swimlaneOrId Swimlane or its id
     * @param {TaskBoard.model.ColumnModel|Number|String} columnOrId Column or its id
     * @param {Object} [options] Scroll options, see {@link #config-scrollOptions}
     * @category Scrolling
     * @async
     */


    scrollToIntersection(swimlaneOrId, columnOrId, options = this.scrollOptions) {
      const swimlane = this.swimlanes.getById(swimlaneOrId),
            column = this.columns.getById(columnOrId),
            target = swimlane && column && this.getSwimlaneColumnElement(swimlane, column);

      if (target) {
        var _options5, _options6;

        options = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({
          animate: ((_options5 = options) === null || _options5 === void 0 ? void 0 : _options5.animate) || ((_options6 = options) === null || _options6 === void 0 ? void 0 : _options6.behavior) === 'smooth',
          edgeOffset: 10,
          highlight: true
        }, options);
        return _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_2__["default"].scrollIntoView(target, options);
      }
    }
    /**
     * Scroll the specified task into view.
     *
     * ```javascript
     * taskBoard.scrollToTask(10);
     * taskBoard.scrollToTask(taskStore.first);
     * ```
     *
     * @param {TaskBoard.model.TaskModel|Number|String} taskOrId
     * @param {Object} [options] Scroll options, see {@link #config-scrollOptions}
     * @category Scrolling
     * @async
     */


    scrollToTask(taskOrId, options = this.scrollOptions) {
      const me = this,
            task = me.project.taskStore.getById(taskOrId),
            taskElement = task && me.getTaskElement(task);

      if (taskElement) {
        var _options7, _options8;

        options = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({
          animate: ((_options7 = options) === null || _options7 === void 0 ? void 0 : _options7.animate) || ((_options8 = options) === null || _options8 === void 0 ? void 0 : _options8.behavior) === 'smooth',
          edgeOffset: 10,
          highlight: true
        }, options);
        return _Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_2__["default"].scrollIntoView(taskElement, options);
      }
    } //endregion


  }, _defineProperty(_class, "$name", 'TaskBoardScroll'), _defineProperty(_class, "configurable", {
    /**
     * Default scroll options, see the options for {@link Core.helper.util.Scroller#function-scrollIntoView}
     *
     * Defaults to:
     *
     * ```javascript
     * scrollOptions : {
     *     animate : true
     * }
     * ```
     *
     * Can be overridden per call for all scroll functions.
     *
     * @config {Object}
     * @category Advanced
     */
    scrollOptions: {
      animate: true,
      block: 'nearest'
    },
    testConfig: {
      scrollOptions: {
        animate: false,
        block: 'nearest'
      }
    }
  }), _temp;
});

/***/ }),

/***/ "./lib/TaskBoard/view/mixin/TaskBoardStores.js":
/*!*****************************************************!*\
  !*** ./lib/TaskBoard/view/mixin/TaskBoardStores.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../model/ProjectModel.js */ "./lib/TaskBoard/model/ProjectModel.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



/**
 * @module TaskBoard/view/mixin/TaskBoardStores
 */

/**
 * Mixin that handles TaskBoards stores, managed by a {@link TaskBoard.model.ProjectModel project}.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class TaskBoardStores extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    //region Config
    get widgetClass() {} //endregion
    //region Type assertions


    changeNewTaskDefaults(newTaskDefaults) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assertObject(newTaskDefaults, 'newTaskDefaults');
      return newTaskDefaults;
    } //endregion
    //region Project


    changeProject(project) {
      if (project && !project.isModel) {
        project = this.projectModelClass.new(project);
      }

      this.attachToProject(project);
      return project;
    }

    attachToProject(project) {
      const me = this; // Enable masking with CrudManagerView

      me.bindCrudManager(project);

      if (project) {
        const {
          taskStore
        } = project; // Set up indices for the configured columnField & optional swimlaneField, for faster lookups

        if (taskStore) {
          taskStore.storage.addIndex({
            property: me.columnField,
            unique: false
          });

          if (me.swimlaneField) {
            taskStore.storage.addIndex({
              property: me.swimlaneField,
              unique: false
            });
          }
        } // Setup store listeners, mostly just recompose


        me.attachToProjectStore(project.taskStore, {
          change: 'onTaskStoreChange',
          changePreCommit: 'onTaskStoreEarlyChange',
          refresh: 'onTaskStoreRefresh'
        });
        me.attachToProjectStore(project.assignmentStore);
        me.attachToProjectStore(project.resourceStore);
      }
    } // Most store changes leads to a recompose, with exception of some TaskStore changes that are transitioned


    attachToProjectStore(store, listenersConfig = {}) {
      this.detachListeners(store.$name);
      store === null || store === void 0 ? void 0 : store.on(_objectSpread({
        name: store.$name,
        change: 'recompose',
        refresh: 'recompose',
        thisObj: this
      }, listenersConfig));
    } //endregion
    //region Listeners


    onTaskStoreEarlyChange({
      action
    }) {
      if (action === 'add') {
        this.recomposeWithDomTransition({
          addTransition: {
            height: 1,
            opacity: 1
          }
        });
      }
    }

    onTaskStoreChange({
      action,
      changes
    }) {
      const {
        columnField,
        swimlaneField
      } = this; // Task removal and column/swimlane changes are transitioned

      if (action === 'remove' || action === 'filter' || action === 'update' && (changes[columnField] || swimlaneField && changes[swimlaneField])) {
        this.recomposeWithDomTransition({
          removeTransition: {
            height: 1,
            opacity: 1
          }
        });
      } else {
        this.recompose();
      }
    }

    onTaskStoreRefresh({
      action
    }) {
      if (action === 'sort') {
        this.recomposeWithDomTransition();
      } else {
        this.recompose();
      }
    } //endregion
    //region Utility

    /**
     * Add a new task to the specified column / swimlane intersection (swimlane is optional), scroll it into view and
     * start editing it (if an editing feature is enabled).
     *
     * By default the task is created using the data defined in the {@link #config-newTaskDefaults} combined with values
     * for the `columnField`, the `swimlaneField` and a generated `weight` to place it last. To override these or to
     * supply your own values for any field, pass the `taskData` argument.
     *
     * @param {TaskBoard.model.ColumnModel} columnRecord Column to add the task to
     * @param {TaskBoard.model.ColumnModel} [swimlaneRecord] Swimlane to add the task to
     * @param {Object} [taskData] Data for the new task
     * @async
     */


    async addTask(columnRecord, swimlaneRecord = null, taskData = {}) {
      var _me$project$taskStore;

      const me = this,
            {
        swimlaneField,
        swimlanes
      } = me,
            columnBody = me.getColumnElement(columnRecord).syncIdMap.body,
            lastCard = columnBody.lastElementChild,
            data = _objectSpread(_objectSpread({
        [me.columnField]: columnRecord.id,
        name: me.L('L{TaskBoard.newTaskName}'),
        weight: ((_me$project$taskStore = me.project.taskStore.max('weight')) !== null && _me$project$taskStore !== void 0 ? _me$project$taskStore : 0) + 100
      }, me.newTaskDefaults), taskData);

      let suspended = false;

      if (swimlaneField) {
        if (swimlaneRecord) {
          data[swimlaneField] = swimlaneRecord.id;
        } else if (swimlanes !== null && swimlanes !== void 0 && swimlanes.count) {
          data[swimlaneField] = swimlanes.first.id;
        }
      } // If add is likely to cause a scroll, opt out of add transition and only animated the scroll


      if (lastCard && lastCard.offsetTop + lastCard.offsetHeight > columnBody.clientHeight - 100) {
        me.suspendDomTransition();
        suspended = true;
      }

      const [taskRecord] = me.project.taskStore.add(data); // To have new tasks element available when trying to scroll to it

      me.recompose.now(); // Await transition used when adding tasks, to be certain task is at correct pos

      if (me.useDomTransition && !me.domTransitionSuspended) {
        await me.await('transitionedRecompose', false);
      } // Await scroll to make sure inline editing works as expected


      await me.scrollToTask(taskRecord, _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].assign({}, me.scrollOptions, {
        highlight: false,
        block: 'start'
      }));
      suspended && me.resumeDomTransition();

      if (me.features.simpleTaskEdit) {
        me.editTask(taskRecord);
      }

      return taskRecord;
    } //endregion


  }, _defineProperty(_class, "$name", 'TaskBoardStores'), _defineProperty(_class, "configurable", {
    projectModelClass: _model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_2__["default"],

    /**
     * A {@link TaskBoard.model.ProjectModel#configs project config object} or an instance that holds all stores and
     * data used by the TaskBoard.
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *     project : {
     *         // Use a custom task model
     *         taskModelClass : MyTaskModel,
     *
     *         // Supply inline data
     *         tasksData : [
     *             { id : 1, name: 'Task 1', ... },
     *             ...
     *         ]
     * });
     * ```
     *
     * Project has built in crud manager functionality to handle syncing with a backend:
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *     project : {
     *         transport : {
     *             load : {
     *                 url : 'data/data.json'
     *             }
     *     },
     *     autoLoad : true
     * });
     *
     * Also has built in state tracking manager functionality to handle undo/redo:
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *     stm : {
     *         autoRecord : true,
     *         disabled   : false
     *     }
     * });
     *
     * @config {Object|TaskBoard.model.ProjectModel}
     * @category Common
     */
    project: {},

    /**
     * Default values to apply to task records created by task boards features (such as the column header menu and
     * the column toolbar)
     *
     * @config {Object}
     */
    newTaskDefaults: {},
    loadMaskDefaults: {
      useTransition: true,
      showDelay: 100
    },

    /**
     * TaskBoard does not use a sync mask by default. If you want one, see
     * {@link Core.mixin.LoadMaskable#config-syncMask} for configuration options.
     *
     * @config {String|Object|null}
     * @default null
     * @category Masking
     */
    syncMask: null
  }), _temp;
});

/***/ }),

/***/ "./lib/TaskBoard/view/mixin/TaskBoardSwimlanes.js":
/*!********************************************************!*\
  !*** ./lib/TaskBoard/view/mixin/TaskBoardSwimlanes.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _model_SwimlaneModel_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../model/SwimlaneModel.js */ "./lib/TaskBoard/model/SwimlaneModel.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';





/**
 * @module TaskBoard/view/mixin/TaskBoardSwimlanes
 */

/**
 * Mixin that handles swimlanes for the TaskBoard.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class TaskBoardSwimlanes extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    //region Config
    get widgetClass() {} //endregion
    //region Type assertions


    changeAutoGenerateSwimlanes(autoGenerateSwimlanes) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertBoolean(autoGenerateSwimlanes, 'autoGenerateSwimlanes');
      return autoGenerateSwimlanes;
    }

    changeSwimlaneField(swimlaneField) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertString(swimlaneField, 'swimlaneField');
      return swimlaneField;
    } //endregion
    //region Config - swimlaneField


    updateSwimlaneField(field, old) {
      if (old) {
        const {
          storage
        } = this.project.taskStore;
        storage.removeIndex(old);
        storage.addIndex({
          property: field,
          unique: false
        });
      }

      this.shouldAutoGenerateSwimlanes = field && this.autoGenerateSwimlanes;
    } //endregion
    //region Config - swimlanes


    changeSwimlanes(swimlanes) {
      return _Core_data_Store_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(swimlanes, {
        objectify: true,
        modelClass: _model_SwimlaneModel_js__WEBPACK_IMPORTED_MODULE_4__["default"]
      }, lane => {
        if (typeof lane === 'string') {
          return {
            id: lane,
            text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].capitalize(lane)
          };
        }

        return lane;
      });
    }

    updateSwimlanes(swimlanes) {
      this.detachListeners('swimlanes');

      if (swimlanes) {
        // Link to us to be able to retrieve tasks in visual order
        // $store is the store instance of an objectified store
        (swimlanes.$store || swimlanes).taskBoard = this;
        swimlanes.on({
          change: 'onSwimlanesChange',
          thisObj: this
        });
      }
    }

    get swimlanes() {
      const me = this,
            {
        taskStore
      } = me.project; // If there are no swimlanes defined but we have a swimlane field configured and we have tasks loaded, generate
      // swimlanes from the tasks

      if (me.shouldAutoGenerateSwimlanes && taskStore.count) {
        me.swimlanes = taskStore.getDistinctValues(me.swimlaneField).sort();
        me.shouldAutoGenerateSwimlanes = false;
      }

      return me._swimlanes;
    }

    onSwimlanesChange({
      action,
      changes
    }) {
      if (action === 'remove' || action === 'update' || action === 'filter') {
        const options = {};

        if (action === 'update') {
          options.addTransition = {
            height: 1,
            opacity: 1
          };
          options.removeTransition = {
            height: 1,
            opacity: 1
          };
        }

        this.recomposeWithDomTransition(options);
        return;
      }

      this.recompose();
    } //endregion
    //region Data


    get hasSwimlanes() {
      var _this$swimlanes;

      return Boolean(this.swimlaneField && ((_this$swimlanes = this.swimlanes) === null || _this$swimlanes === void 0 ? void 0 : _this$swimlanes.count));
    }

    getSwimlaneTasks(swimlaneRecord) {
      return this.project.taskStore.storage.findItem(this.swimlaneField, swimlaneRecord.id);
    }

    getSwimlane(taskRecord) {
      var _this$swimlanes2;

      return this.swimlaneField && ((_this$swimlanes2 = this.swimlanes) === null || _this$swimlanes2 === void 0 ? void 0 : _this$swimlanes2.getById(taskRecord[this.swimlaneField]));
    } //endregion


  }, _defineProperty(_class, "$name", 'TaskBoardSwimlanes'), _defineProperty(_class, "configurable", {
    /**
     * Store containing the TaskBoard swimlanes.
     *
     * @member {Core.data.Store} swimlanes
     * @category Common
     */

    /**
     * Store containing the TaskBoard swimlanes. A tasks {@link #config-swimlaneField} is matched against the `id`
     * of a swimlane to determine in which swimlane it is displayed.
     *
     * Accepts an array of swimlane records/objects, a store instance, a store id or a store config object used to
     * create a new store.
     *
     * When supplying an array, a store configured with {@link Core.data.mixin.StoreProxy#config-objectify} is
     * automatically created. Using that config allows for a nicer interaction syntax with the swimlanes:
     *
     * ```javascript
     * // Without objectify:
     * taskBoard.swimlanes.getById('highprio').text = 'Important!';
     *
     * // With objectify:
     * taskBoard.swimlanes.done.text = 'Finished';
     * ```
     *
     * When supplying strings, the raw string will be used as the swimlanes `id` and a capitalized version of it is
     * used as the swimlanes text:
     *
     * ```javascript
     * taskBoard = new TaskBoard({
     *    swimlanes : [
     *        'high',
     *        'low'
     *    ]
     * });
     * ```
     *
     * Is equivalent to:
     *
     * ```javascript
     * taskBoard = new TaskBoard({
     *    swimlanes : [
     *        { id : 'high', text : 'High' },
     *        { id : 'low', text : 'Low' }
     *    ]
     * });
     * ```
     *
     * @config {TaskBoard.model.SwimlaneModel[]|Object[]|Core.data.Store|String|Object}
     * @category Common
     */
    swimlanes: {},

    /**
     * Set to `true` to auto generate swimlanes when {@link #config-swimlanes} is undefined.
     *
     * A swimlane will be created for each distinct value of {@link #config-swimlaneField} on the tasks. The
     * swimlanes will be sorted in alphabetical order. The following snippet will yield two swimlanes, Q1 and Q2:
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *    swimlaneField : 'quarter',
     *
     *    autoGenerateSwimlanes : true,
     *
     *    project : {
     *        tasksData : [
     *            { id : 1, name : 'Inform tenants', quarter : 'Q1' },
     *            { id : 2, name : 'Renovate roofs', quarter : 'Q2' }
     *        ]
     *    }
     * });
     * ```
     *
     * @config {Boolean}
     * @category Advanced
     */
    autoGenerateSwimlanes: false,

    /**
     * Field on a task record used to determine which swimlane the task belongs to.
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *    swimlaneField : 'prio',
     *
     *    swimlanes : [
     *        'high',
     *        'low'
     *    ],
     *
     *    project : {
     *        tasksData : [
     *            // Linked using the prio field, to the high swimlane
     *            { id : 1, name : 'Fun task', prio : 'high' }
     *        ]
     *    }
     * });
     * ```
     *
     * @config {String}
     * @category Common
     */
    swimlaneField: null
  }), _defineProperty(_class, "properties", {
    shouldAutoGenerateSwimlanes: false
  }), _temp;
});

/***/ }),

/***/ "./lib/TaskBoard/view/mixin/TaskItems.js":
/*!***********************************************!*\
  !*** ./lib/TaskBoard/view/mixin/TaskItems.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _item_TaskItem_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../item/TaskItem.js */ "./lib/TaskBoard/view/item/TaskItem.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _item_TextItem_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../item/TextItem.js */ "./lib/TaskBoard/view/item/TextItem.js");
/* harmony import */ var _item_ResourceAvatarsItem_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../item/ResourceAvatarsItem.js */ "./lib/TaskBoard/view/item/ResourceAvatarsItem.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



 // Items used by default



/**
 * @module TaskBoard/view/mixin/TaskItems
 */

const fieldLess = {
  resourceAvatars: 1,
  separator: 1,
  taskMenu: 1
},
      taskItemSelector = '.b-taskboard-taskitem',
      afterRe = /\s*<\s*/,
      beforeRe = /\s*>\s*/;
/**
 * Mixin that allows adding multiple predefined items (sort of like task widgets) to tasks:
 *
 * {@inlineexample TaskBoard/view/mixin/TaskItems.js}
 *
 * You can pick from the following item types:
 *
 * * {@link TaskBoard/view/item/ImageItem image}
 * * {@link TaskBoard/view/item/ProgressItem progress}
 * * {@link TaskBoard/view/item/RatingItem rating}
 * * {@link TaskBoard/view/item/ResourceAvatarsItem resourceAvatars}
 * * {@link TaskBoard/view/item/SeparatorItem separator}
 * * {@link TaskBoard/view/item/TagsItem tags}
 * * {@link TaskBoard/view/item/TemplateItem template}
 * * {@link TaskBoard/view/item/TextItem text}
 * * {@link TaskBoard/view/item/TodoListItem todoList}
 *
 * All of which are included in this demo:
 *
 * {@inlineexample TaskBoard/view/mixin/TaskItemsAll.js}
 *
 * ## Configuring which items to use
 *
 * Task cards are divided into three sections, header, body and footer. Each section can hold items. The following items
 * are defined by default:
 *
 * | Section     | Key             | Type                                                            | Bound to           |
 * |-------------|-----------------|-----------------------------------------------------------------|--------------------|
 * | headerItems | text            | {@link TaskBoard/view/item/TextItem text}                       | name               |
 * | bodyItems   | text            | {@link TaskBoard/view/item/TextItem text}                       | description        |
 * | footerItems | resourceAvatars | {@link TaskBoard/view/item/ResourceAvatarsItem resourceAvatars} | assigned resources |
 *
 * Add items to tasks by supplying the {@link #config-bodyItems bodyItems config} (the other sections work the same):
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     bodyItems : {
 *         // Will use "prio" as its field
 *         prio  : { type : 'text' },
 *         // Will use "status" as its field
 *         state : { type : 'text', field : 'status' }
 *     }
 * });
 * ```
 *
 * The items you supply are merged with the predefined items (as listed in the table above).
 *
 * The only always required config for new items is `type`, which determines what kind of task item to use. Which other
 * configs you can use depends on the item type.
 *
 * By default the key in the `items` object will be used to link the item to a field on a task. You can override the
 * default by using the `field` config.
 *
 * To rearrange items, specify the {@link TaskBoard/view/item/TaskItem#config-order} config of each item. Applied as
 * flex order.
 *
 * You can also add items to a tasks header and footer, using {@link #config-headerItems} and
 * {@link #config-footerItems}.
 *
 * ## Manipulating items per task
 *
 * You can manipulate which items are shown for a task by supplying a {@link #config-processItems} function. It will be
 * called during rendering for each task and in it you can manipulate the passed `bodyItems` object. Set a property of
 * it to `null` to remove that item for that task:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     bodyItems : {
 *         progress  : { type : 'progress' }
 *     },
 *
 *     processItems({ taskRecord, bodyItems }) {
 *         if (taskRecord.status === 'done') {
 *             bodyItems.progress = null;
 *         }
 *     }
 * });
 * ```
 *
 * {@inlineexample TaskBoard/view/mixin/TaskItemsProcessItems.js}
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class TaskItems extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    //region Config
    get widgetClass() {} //endregion
    //region Type assertions


    changeProcessItems(processItems) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertFunction(processItems, 'processItems');
      return processItems;
    } //endregion
    // region Configuring items
    // TODO: Discuss with Don. Cant the merge on the config be active always?


    mergeItems(items, old) {
      if (old && items) {
        items = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].mergeItems(old, items);
      }

      return items;
    } // Needed to allow reconfiguring on the fly (for responsive)


    changeHeaderItems(items, old) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertObject(items, 'headerItems');
      return this.mergeItems(items, old);
    } // Needed to allow reconfiguring on the fly (for responsive)


    changeBodyItems(items, old) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertObject(items, 'bodyItems');
      return this.mergeItems(items, old);
    } // Needed to allow reconfiguring on the fly (for responsive)


    changeFooterItems(items, old) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].assertObject(items, 'footerItems');
      return this.mergeItems(items, old);
    } //endregion
    //region Rendering
    // Render items to header, body or footer of the supplied task


    renderItems(taskRecord, items, target, cardSize) {
      for (const key in items) {
        const config = items[key];

        if (config && !config.hidden) {
          // Defaults to use the key as the field, but allows overriding it using the field config
          if (!('field' in config)) {
            if (key.includes('>')) {
              [config.field] = key.split(beforeRe);
            } else if (key.includes('<')) {
              [, config.field] = key.split(afterRe);
            } else {
              config.field = key;
            }
          }

          const {
            field
          } = config,
                value = taskRecord[field]; // Most fields render nothing if they have no value, some are excluded from that logic (separator etc)

          if (value != null || fieldLess[config.type]) {
            const // TaskItem implements factoryable, we are not using instances but rather static items to avoid
            // creating one instance per card. Thus we only use the lookup functionality of factoryable
            item = _item_TaskItem_js__WEBPACK_IMPORTED_MODULE_1__["default"].resolveType(config.type),
                  typeCls = `b-taskboard-${_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].hyphenate(config.type)}`,
                  // Base DomConfig, shared by all task items
            domConfig = {
              class: {
                'b-taskboard-taskitem': 1,
                [typeCls]: 1,
                [config.cls]: config.cls,
                'b-editable': !taskRecord.readOnly && item.getEditorConfig({
                  config,
                  item
                })
              },
              dataset: {
                role: `item-${field}`,
                field,
                ref: key
              },
              elementData: {
                item,
                taskRecord,
                config
              },
              style: {
                order: config.order,
                style: config.style
              }
            },
                  // Call items (static) renderer, further populating the DomConfig from above
            result = item.render({
              taskBoard: this,
              domConfig,
              value,
              config,
              taskRecord,
              cardSize
            }); // Returning false from an items renderer prevents it from being shown

            if (result !== false) {
              target.children[key] = domConfig;
            }
          }
        }
      }
    } // Hook into card rendering


    populateCard(args) {
      var _super$populateCard;

      (_super$populateCard = super.populateCard) === null || _super$populateCard === void 0 ? void 0 : _super$populateCard.call(this, args);
      const me = this,
            {
        processItems
      } = me,
            {
        taskRecord,
        cardConfig,
        cardSize
      } = args,
            {
        headerItems: sizeHeaderItems,
        bodyItems: sizeBodyItems,
        footerItems: sizeFooterItems
      } = cardSize || {},
            {
        header,
        body,
        footer
      } = cardConfig.children;
      let {
        headerItems,
        bodyItems,
        footerItems
      } = me; // Items are shared between all cards, clone before processing to only affect the set for this card

      if (sizeHeaderItems || processItems) {
        headerItems = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(headerItems);
      }

      if (sizeBodyItems || processItems) {
        bodyItems = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(bodyItems);
      }

      if (sizeFooterItems || processItems) {
        footerItems = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].clone(footerItems);
      } // Apply any card size specific items


      sizeHeaderItems && _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(headerItems, sizeHeaderItems);
      sizeBodyItems && _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(bodyItems, sizeBodyItems);
      sizeFooterItems && _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(footerItems, sizeFooterItems); // Allow app a shot at processing the items before they are shown. Can be used to add or remove items and
      // manipulate configs

      processItems === null || processItems === void 0 ? void 0 : processItems({
        headerItems,
        bodyItems,
        footerItems,
        taskRecord,
        cardSize
      }); // Render items into card header, body and footer

      me.renderItems(taskRecord, headerItems, header, cardSize);
      me.renderItems(taskRecord, bodyItems, body, cardSize);
      me.renderItems(taskRecord, footerItems, footer, cardSize);
    } //endregion
    //region Listeners


    resolveTaskItem(element) {
      // First look up, if inside an item. Then looks down, in case given a card or similar
      const taskItemElement = element.closest(taskItemSelector) || element.querySelector(`:scope > * > ${taskItemSelector}, :scope > ${taskItemSelector}`);

      if (taskItemElement) {
        return _objectSpread(_objectSpread({}, taskItemElement.elementData), {}, {
          element: taskItemElement
        });
      }

      return null;
    } // Relay clicks to items


    onTaskClick(args) {
      const taskItem = this.resolveTaskItem(args.event.target);

      if (taskItem) {
        var _item$onClick;

        const {
          config,
          item
        } = taskItem;
        (_item$onClick = item.onClick) === null || _item$onClick === void 0 ? void 0 : _item$onClick.call(item, _objectSpread({
          config
        }, args));
      }

      super.onTaskClick(args);
    } // Relay double clicks to items


    onTaskDblClick(args) {
      const taskItem = this.resolveTaskItem(args.event.target);

      if (taskItem) {
        var _item$onDblClick;

        const {
          config,
          item
        } = taskItem;
        (_item$onDblClick = item.onDblClick) === null || _item$onDblClick === void 0 ? void 0 : _item$onDblClick.call(item, _objectSpread({
          config
        }, args));
      }

      super.onTaskDblClick(args);
    } //endregion


  }, _defineProperty(_class, "$name", 'TaskItems'), _defineProperty(_class, "configurable", {
    /**
     * Items in card header.
     *
     * As an object keyed by field names, values are {@link TaskBoard/view/item/TaskItem#configs TaskItem configs}.
     *
     * Reassigning this property merges the supplied object with the configured items:
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *    headerItems : {
     *        status : { type : 'text' }
     *    }
     * });
     *
     * taskBoard.headerItems = {
     *     status : { hidden : true },
     *     tags   : { type : 'tags' }
     * };
     *
     * // Results in:
     * //
     * // headerItems = {
     * //     status : { type : 'text', hidden: true }
     * //     tags   : { type : 'tags' }
     * // }
     * }
     * ```
     *
     * @member {Object} headerItems
     */

    /**
     * Items to add to each cards header.
     *
     * Supplied keys are used to bind to a field on the {@link TaskBoard/model/TaskModel task record}, supplied
     * values are used to configure the {@link TaskBoard/view/item/TaskItem#configs items}.
     *
     * You are always required to supply a `type`, see the docs for each item type for more information on available
     * configs.
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *    headerItems : {
     *        status : { type : 'text' }
     *    }
     * });
     * ```
     *
     * For more information, see the {@link #class-description class description} above.
     *
     * @config {Object}
     * @category Task content
     */
    headerItems: {
      value: {
        text: {
          type: 'text',
          field: 'name'
        }
      },
      $config: {
        merge: 'items'
      }
    },

    /**
     * Items in card body.
     *
     * As an object keyed by field names, values are {@link TaskBoard/view/item/TaskItem#configs TaskItem configs}.
     *
     * Reassigning this property merges the supplied object with the configured items:
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *    bodyItems : {
     *        status : { type : 'text' }
     *    }
     * });
     *
     * taskBoard.bodyItems = {
     *     status : { hidden : true },
     *     tags   : { type : 'tags' }
     * };
     *
     * // Results in:
     * //
     * // bodyItems = {
     * //     status : { type : 'text', hidden: true }
     * //     tags   : { type : 'tags' }
     * // }
     * }
     * ```
     *
     * @member {Object} bodyItems
     */

    /**
     * Items to add to each cards body.
     *
     * Supplied keys are used to bind to a field on the {@link TaskBoard/model/TaskModel task record}, supplied
     * values are used to configure the {@link TaskBoard/view/item/TaskItem#configs items}.
     *
     * You are always required to supply a `type`, see the docs for each item type for more information on available
     * configs.
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *    bodyItems : {
     *        status : { type : 'text' }
     *    }
     * });
     * ```
     *
     * For more information, see the {@link #class-description class description} above.
     *
     * @config {Object}
     * @category Task content
     */
    bodyItems: {
      value: {
        text: {
          type: 'text',
          field: 'description'
        }
      },
      $config: {
        merge: 'items'
      }
    },

    /**
     * Items in card footer.
     *
     * As an object keyed by field names, values are {@link TaskBoard/view/item/TaskItem#configs TaskItem configs}.
     *
     * Reassigning this property merges the supplied object with the configured items:
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *    footerItems : {
     *        status : { type : 'text' }
     *    }
     * });
     *
     * taskBoard.footerItems = {
     *     status : { hidden : true },
     *     tags   : { type : 'tags' }
     * };
     *
     * // Results in:
     * //
     * // footerItems = {
     * //     status : { type : 'text', hidden: true }
     * //     tags   : { type : 'tags' }
     * // }
     * }
     * ```
     *
     * @member {Object} footerItems
     */

    /**
     * Items to add to each cards footer.
     *
     * Supplied keys are used to bind to a field on the {@link TaskBoard/model/TaskModel task record}, supplied
     * values are used to configure the {@link TaskBoard/view/item/TaskItem#configs items}.
     *
     * You are always required to supply a `type`, see the docs for each item type for more information on available
     * configs.
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *    footerItems : {
     *        status : { type : 'text' }
     *    }
     * });
     * ```
     *
     * For more information, see the {@link #class-description class description} above.
     *
     * @config {Object}
     * @category Task content
     */
    footerItems: {
      value: {
        resourceAvatars: {
          type: 'resourceAvatars',
          field: 'resources'
        }
      },
      $config: {
        merge: 'items'
      }
    },

    /**
     * A function called on each render before adding items to a tasks card, allowing runtime manipulation of them.
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *     processItems({ bodyItems, taskRecord }) {
     *        // Remove the progress item for done tasks
     *        if (taskRecord.status === 'done') {
     *            bodyItems.progress = null;
     *        }
     *     }
     * });
     * ```
     *
     * NOTE: The function is only intended for manipulating the passed items, you should not update the passed
     * `taskRecord` in it since updating records triggers another round of rendering.
     *
     * @param {Object} context
     * @param {Object} context.headerItems Item config objects for the task header, keyed by ref
     * @param {Object} context.bodyItems Item config objects for the task body, keyed by ref
     * @param {Object} context.footerItems Item config objects for the task footer, keyed by ref
     * @param {TaskBoard.model.TaskModel} context.taskRecord Record representing task to be rendered
     * @config {Function}
     * @category Task content
     */
    processItems: null
  }), _temp;
});

/***/ }),

/***/ "./lib/TaskBoard/view/mixin/TaskNavigation.js":
/*!****************************************************!*\
  !*** ./lib/TaskBoard/view/mixin/TaskNavigation.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



/**
 * @module TaskBoard/view/mixin/TaskNavigation
 */

/**
 * Mixin that handles keyboard navigation for the TaskBoard.
 *
 * Default key mappings:
 *
 * | Key   | Action                                                            |
 * |-------|-------------------------------------------------------------------|
 * | Up    | Focus card above current                                          |
 * | Down  | Focus card below current                                          |
 * | Left  | Focus card to the left                                            |
 * | Right | Focus card to the right                                           |
 * | Space | Select or deselect focused card (hold `CTRL` to extend selection) |
 * | Shift | Holding `SHIFT` while navigating extends the selection            |
 *
 * If you prefer for selection to always move with the arrow keys, see {@link #config-selectOnNavigation}.
 *
 * See {@link TaskBoard.view.mixin.TaskSelection} for more info on selecting cards using the keyboard.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class TaskNavigation extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    //region Config
    get widgetClass() {} //endregion
    //region Listeners


    onTaskKeyDown(args) {
      if (this.navigateable && this.performKeyMapAction(args.event, args)) {
        // Prevent default for keys handled by the keyMap, letting others through
        args.event.preventDefault();
      }
    } //endregion
    //region Utility


    getTaskNear(x, y) {
      var _documentRoot$element;

      const {
        documentRoot
      } = this,
            gap = _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].measureSize(this.css.cardGap || '1em', this.bodyElement.querySelector('.b-taskboard-swimlane-body .b-taskboard-column'));
      let task = (_documentRoot$element = documentRoot.elementFromPoint(x, y)) === null || _documentRoot$element === void 0 ? void 0 : _documentRoot$element.closest('.b-taskboard-card'); // Nothing there, might have hit a gap, look up

      if (!task) {
        var _documentRoot$element2;

        task = (_documentRoot$element2 = documentRoot.elementFromPoint(x, y - gap)) === null || _documentRoot$element2 === void 0 ? void 0 : _documentRoot$element2.closest('.b-taskboard-card');
      } // Still nothing, look down


      if (!task) {
        var _documentRoot$element3;

        task = (_documentRoot$element3 = documentRoot.elementFromPoint(x, y + gap)) === null || _documentRoot$element3 === void 0 ? void 0 : _documentRoot$element3.closest('.b-taskboard-card');
      }

      return task;
    } //endregion
    //region Navigation


    focusAndOptionallySelect(taskElement, forceSelect) {
      if (taskElement) {
        const me = this,
              currentlyFocusedTask = me.resolveTaskRecord(document.activeElement); // If a task is focused but not selected and we navigate away from it holding SPACE we want that task to
        // become selected in addition to the newly focused task

        if (forceSelect && currentlyFocusedTask && !me.isSelected(currentlyFocusedTask)) {
          me.selectTask(currentlyFocusedTask, true);
        } // When configured with `selectOnNavigation : true` we should move the selection. If user holds SHIFT we
        // should always extend it


        if (me.selectOnNavigation || forceSelect) {
          const taskToFocus = me.resolveTaskRecord(taskElement); // Newly focused task is not selected, always select it (optionally extending the selection)

          if (!me.isSelected(taskToFocus)) {
            me.selectTask(taskToFocus, forceSelect);
          } // Newly focused task already selected, deselect current if SHIFT is pressed (to allow extending and
          // shrinking selection holding SHIFT)
          else if (forceSelect) {
            me.deselectTask(currentlyFocusedTask);
          }
        } // Always move focus


        taskElement.focus();
      }
    } // Find task at same Y in next column


    navigateRight({
      taskRecord,
      swimlaneRecord,
      columnRecord
    }, select = false) {
      const me = this,
            taskElement = me.getTaskElement(taskRecord);
      let found = null,
          nextColumnRecord = columnRecord;

      do {
        nextColumnRecord = me.columns.getNext(nextColumnRecord, true);

        if (!nextColumnRecord.hidden) {
          const nextColumnElement = me.getSwimlaneColumnElement(swimlaneRecord, nextColumnRecord),
                x = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(nextColumnElement, null, true).center.x,
                y = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(taskElement, null, true).center.y;
          found = me.getTaskNear(x, y);
        }
      } while (!found && nextColumnRecord !== columnRecord);

      me.focusAndOptionallySelect(found, select);
    } // Find task at same Y in prev column


    navigateLeft({
      taskRecord,
      swimlaneRecord,
      columnRecord
    }, select = false) {
      const me = this,
            taskElement = me.getTaskElement(taskRecord);
      let found = null,
          prevColumnRecord = columnRecord;

      do {
        prevColumnRecord = me.columns.getPrev(prevColumnRecord, true);

        if (!prevColumnRecord.hidden) {
          const prevColumnElement = me.getSwimlaneColumnElement(swimlaneRecord, prevColumnRecord),
                x = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(prevColumnElement, null, true).center.x,
                y = _Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(taskElement, null, true).center.y;
          found = me.getTaskNear(x, y);
        }
      } while (!found && prevColumnRecord !== columnRecord);

      me.focusAndOptionallySelect(found, select);
    } // Find next task in same column (might be in next swimlane)


    navigateDown({
      taskRecord
    }, select = false) {
      const nextTask = this.getNextTask(taskRecord, true);
      this.focusAndOptionallySelect(this.getTaskElement(nextTask), select);
    } // Find prev task in same column (might be in prev swimlane)


    navigateUp({
      taskRecord
    }, select = false) {
      const prevTask = this.getPreviousTask(taskRecord, true);
      this.focusAndOptionallySelect(this.getTaskElement(prevTask), select);
    } // Activate (show editor)


    activate({
      taskRecord,
      event
    }) {
      this.trigger('activateTask', {
        taskRecord,
        event
      });
    } //endregion


  }, _defineProperty(_class, "$name", 'TaskNavigation'), _defineProperty(_class, "configurable", {
    keyMap: {
      ArrowDown: 'navigateDown',
      ArrowLeft: 'navigateLeft',
      ArrowUp: 'navigateUp',
      ArrowRight: 'navigateRight',
      Enter: 'activate'
    },
    navigateable: true,

    /**
     * Configure with `true` to change the default behaviour of keyboard navigation from moving focus to selecting
     * tasks:
     *
     * ```javascript
     * const taskBoard = new TaskBoard({
     *     selectOnNavigation : true
     * });
     * ```
     *
     * @config {Boolean|String}
     * @default
     */
    selectOnNavigation: false
  }), _temp;
});

/***/ }),

/***/ "./lib/TaskBoard/view/mixin/TaskSelection.js":
/*!***************************************************!*\
  !*** ./lib/TaskBoard/view/mixin/TaskSelection.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';




/**
 * @module TaskBoard/view/mixin/TaskSelection
 */

/**
 * Mixin that handles card selection for the TaskBoard.
 *
 * By default tasks can be selected using mouse clicks and the keyboard. To enable marquee selection, see
 * {@link TaskBoard.feature.TaskDragSelect}.
 *
 * ## Mouse selection
 *
 * Select and deselect cards using the mouse, using a modifier key to do multi selection:
 *
 * * Click on a card to focus and select it, deselecting any previously selected card.
 * * `CMD`/`CTRL` + click on a card to add or remove it from the selection.
 *
 * ## Keyboard selection
 *
 * Similar to mouse selection, keyboard selection uses single selection unless user presses a modifier key:
 *
 * * Press `SPACE` to select or deselect the focused card (deselecting all others).
 * * Press `CMD`/`CTRL` + `SPACE` to select or deselect the focused card, preserving any other selection.
 * * Hold `SHIFT` when keyboard navigating to extend selection.
 *
 * See {@link TaskBoard.view.mixin.TaskNavigation} for more info on keyboard navigation.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class TaskSelection extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    //region Config
    get widgetClass() {} //endregion
    //region Type assertions


    changeSelectedTasks(selectedTasks) {
      _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].assertArray(selectedTasks, 'selectedTasks');
      return selectedTasks;
    } //endregion
    //region Programmatic selection


    toggleTaskSelection(taskRecord, add = false, forceSelect = null) {
      const me = this; // Toggle

      if (forceSelect == null) {
        if (me.isSelected(taskRecord)) {
          // Clicked on a selected task without modifier key, select only it
          if (!add) {
            me.selectTask(taskRecord, add);
          } // Using modifier key, deselect instead
          else {
            me.deselectTask(taskRecord);
          }
        } else {
          me.selectTask(taskRecord, add);
        }
      } // Force select
      else if (forceSelect) {
        me.selectTask(taskRecord, add);
      } // Force deselect
      else {
        me.deselectTask(taskRecord);
      }
    }
    /**
     * Select the supplied task, deselecting any previously selected by default.
     * @param {TaskBoard.model.TaskModel} taskRecord Task to select
     * @param {Boolean} [add] Specify `true` to add to selection instead of replacing it
     * @category Selection
     */


    selectTask(taskRecord, add = false) {
      const {
        selectedTasks
      } = this,
            event = {
        action: 'select',
        select: [taskRecord]
      };

      if (!add) {
        event.deselect = selectedTasks.slice();
        selectedTasks.length = 0;
      }

      _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].include(selectedTasks, taskRecord);
      this.triggerSelectionChange(event);
      this.recompose();
    }
    /**
     * Deselect the supplied task.
     * @param {TaskBoard.model.TaskModel} taskRecord
     * @category Selection
     */


    deselectTask(taskRecord) {
      _Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].remove(this.selectedTasks, taskRecord);
      this.triggerSelectionChange({
        action: 'deselect',
        deselect: [taskRecord]
      });
      this.recompose();
    }
    /**
     * Deselect all tasks.
     * @category Selection
     */


    deselectAll() {
      const {
        selectedTasks
      } = this;

      if (selectedTasks.length) {
        const deselect = selectedTasks.slice();
        selectedTasks.length = 0;
        this.triggerSelectionChange({
          action: 'deselect',
          deselect
        });
        this.recompose();
      }
    }
    /**
     * Check if the supplied task is selected or not
     * @param {TaskBoard.model.TaskModel} taskRecord
     * @returns {Boolean} Returns `true` if it is selected, `false` if not
     * @category Selection
     */


    isSelected(taskRecord) {
      return this.selectedTasks.includes(taskRecord);
    }

    triggerSelectionChange(event) {
      /**
       * Triggered when task selection changes.
       *
       * @event selectionChange
       * @param {TaskBoard.view.TaskBoard} source TaskBoard instance
       * @param {String} action Either 'select' or 'deselect', depending on operation
       * @param {TaskBoard.model.TaskModel[]} selection All currently selected tasks
       * @param {TaskBoard.model.TaskModel[]} select Tasks selected by the operation
       * @param {TaskBoard.model.TaskModel[]} deselect Tasks deselected by the operation
       */
      this.trigger('selectionChange', Object.assign({
        selection: this.selectedTasks,
        select: [],
        deselect: []
      }, event));
    } //endregion
    //region Listeners


    onTaskClick(bryntumEvent) {
      super.onTaskClick(bryntumEvent);
      const {
        event,
        taskRecord
      } = bryntumEvent;

      if (!event.defaultPrevented) {
        this.toggleTaskSelection(taskRecord, event.ctrlKey);
      }
    }

    keyboardSelect({
      taskRecord
    }) {
      if (taskRecord) {
        this.toggleTaskSelection(taskRecord, false);
      }
    }

    keyboardToggleSelect({
      taskRecord
    }) {
      if (taskRecord) {
        this.toggleTaskSelection(taskRecord, true);
      }
    }

    onClick(event) {
      super.onClick(event);

      if (!event.taskRecord && this.navigateable) {
        this.deselectAll();
      }
    }

    selectUp(event) {
      this.navigateUp(event, true);
    }

    selectDown(event) {
      this.navigateDown(event, true);
    }

    selectLeft(event) {
      this.navigateLeft(event, true);
    }

    selectRight(event) {
      this.navigateRight(event, true);
    } //endregion
    //region Rendering


    populateCard(args) {
      var _super$populateCard;

      (_super$populateCard = super.populateCard) === null || _super$populateCard === void 0 ? void 0 : _super$populateCard.call(this, args);
      const {
        taskRecord,
        cardConfig
      } = args,
            isSelected = this.isSelected(taskRecord);
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(cardConfig, {
        class: {
          'b-selected': isSelected
        }
      });
    }

    populateBody(args) {
      var _super$populateBody;

      (_super$populateBody = super.populateBody) === null || _super$populateBody === void 0 ? void 0 : _super$populateBody.call(this, args);
      const {
        bodyConfig
      } = args,
            hasSelection = Boolean(this.selectedTasks.length);
      _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].merge(bodyConfig, {
        class: {
          'b-has-selection': hasSelection
        }
      });
    } //endregion


  }, _defineProperty(_class, "$name", 'TaskSelection'), _defineProperty(_class, "configurable", {
    /**
     * Selected tasks.
     * @member {TaskBoard.model.TaskModel[]} selectedTasks
     * @category Common
     */

    /**
     * Initially selected tasks.
     * @config {TaskBoard.model.TaskModel[]}
     * @category Common
     */
    selectedTasks: [],
    keyMap: {
      ' ': 'keyboardSelect',
      'Ctrl+ ': 'keyboardToggleSelect',
      'Shift+ArrowDown': 'selectDown',
      'Shift+ArrowLeft': 'selectLeft',
      'Shift+ArrowUp': 'selectUp',
      'Shift+ArrowRight': 'selectRight'
    }
  }), _temp;
});

/***/ }),

/***/ "./lib/TaskBoard/widget/ColumnCombo.js":
/*!*********************************************!*\
  !*** ./lib/TaskBoard/widget/ColumnCombo.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnCombo; });
/* harmony import */ var _base_ColorBoxCombo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base/ColorBoxCombo.js */ "./lib/TaskBoard/widget/base/ColorBoxCombo.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module TaskBoard/widget/ColumnCombo
 */

/**
 * A combo populated with the {@link TaskBoard.view.TaskBoard#property-columns} of a {@link TaskBoard.view.TaskBoard}.
 * If a column has a {@link TaskBoard.model.ColumnModel#field-color} defined, that color will be displayed in the combo
 * and its picker.
 *
 * Used in {@link TaskBoard.widget.TaskEditor} to pick which column a task belongs to ("Status" below):
 *
 * {@inlineexample TaskBoard/widget/ColumnCombo.js}
 *
 * @classtype columncombo
 * @extends TaskBoard/widget/base/ColorBoxCombo
 */

class ColumnCombo extends _base_ColorBoxCombo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  changeStore() {
    return this.taskBoard.columns.chain();
  }

}

_defineProperty(ColumnCombo, "$name", 'ColumnCombo');

_defineProperty(ColumnCombo, "type", 'columncombo');

ColumnCombo.initClass();
ColumnCombo._$name = 'ColumnCombo';

/***/ }),

/***/ "./lib/TaskBoard/widget/ColumnFilterField.js":
/*!***************************************************!*\
  !*** ./lib/TaskBoard/widget/ColumnFilterField.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnFilterField; });
/* harmony import */ var _Core_widget_FilterField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/FilterField.js */ "./lib/Core/widget/FilterField.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module TaskBoard/widget/ColumnFilterField
 */

/**
 * A field that filters the columns of a linked {@link TaskBoard.view.TaskBoard} when typing into it.
 *
 * {@inlineexample TaskBoard/widget/ColumnFilterField.js}
 *
 * When used within a TaskBoard, it connects to it automatically:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     tbar : [
 *         { type : 'columnfilterfield' }
 *     ]
 * });
 * ```
 *
 * When used outside of a TaskBoard, it will query globally to find one but if there are multiple on page it might have
 * to be linked to one manually (see {@link TaskBoard/widget/mixin/TaskBoardLinked#config-taskBoard}:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({});
 *
 * const picker = new ColumnFilterField({
 *    taskBoard // Link it to the taskBoard instance created above
 * });
 * ```
 *
 * @classtype columnfilterfield
 * @extends Core/widget/FilterField
 * @mixes TaskBoard/widget/mixin/TaskBoardLinked
 */

class ColumnFilterField extends _Core_widget_FilterField_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {}

_defineProperty(ColumnFilterField, "$name", 'ColumnFilterField');

_defineProperty(ColumnFilterField, "type", 'columnfilterfield');

_defineProperty(ColumnFilterField, "configurable", {
  /**
   * @hideconfigs store, filterFunction
   */
  store: 'this.taskBoard.columns',

  /**
   * The ColumnModel field name to filter by, defaults to `'text'`.
   * @config {String}
   * @default
   * @category Common
   */
  field: 'text',

  /**
   * Label, defaults to a localized version of `'Filter columns'`.
   *
   * Content is determined by the `TaskBoard.filterColumns` key in the applied locale.
   *
   * @config {String}
   * @category Label
   */
  label: 'L{TaskBoard.filterColumns}',
  width: '20em',
  triggers: {
    filter: {
      cls: 'b-icon b-icon-filter',
      align: 'start'
    }
  }
});

ColumnFilterField.initClass();
ColumnFilterField._$name = 'ColumnFilterField';

/***/ }),

/***/ "./lib/TaskBoard/widget/ColumnPickerButton.js":
/*!****************************************************!*\
  !*** ./lib/TaskBoard/widget/ColumnPickerButton.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnPickerButton; });
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _Core_widget_Menu_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/Menu.js */ "./lib/Core/widget/Menu.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';




/**
 * @module TaskBoard/widget/ColumnPickerButton
 */

/**
 * A button with a menu allowing the user to toggle which columns are shown on the {@link TaskBoard.view.TaskBoard}.
 *
 * {@inlineexample TaskBoard/widget/ColumnPickerButton.js}
 *
 * Click to display a menu populated with the columns held in {@link TaskBoard.view.TaskBoard#property-columns}.
 *
 * When used within a TaskBoard, it connects to it automatically:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     tbar : [
 *         { type : 'columnpickerbutton' }
 *     ]
 * });
 * ```
 *
 * When used outside of a TaskBoard, it will query globally to find one but if there are multiple on page it might have
 * to be linked to one manually (see {@link TaskBoard/widget/mixin/TaskBoardLinked#config-taskBoard}:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({});
 *
 * const picker = new ColumnPickerButton({
 *    taskBoard // Link it to the taskBoard instance created above
 * });
 * ```
 *
 * @classtype columnpickerbutton
 * @extends Core/widget/Button
 * @mixes TaskBoard/widget/mixin/TaskBoardLinked
 */

class ColumnPickerButton extends _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  onToggleColumn({
    item
  }) {
    item.column.hidden = !item.checked;
  }

  changeMenu(menu) {
    const menuInstance = super.changeMenu(menu); // Nullified on destroy

    if (menuInstance) {
      menuInstance.on({
        beforeShow: 'onMenuBeforeShow',
        thisObj: this
      });
    }

    return menuInstance;
  } // Populate menu before each show to make sure it is up to date


  onMenuBeforeShow({
    source: menu
  }) {
    menu.items = this.taskBoard.columns.map(column => ({
      ref: column.id,
      text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].encodeHtml(column.text),
      checked: !column.hidden,
      column,
      onItem: 'up.onToggleColumn'
    }));
  }

}

_defineProperty(ColumnPickerButton, "$name", 'ColumnPickerButton');

_defineProperty(ColumnPickerButton, "type", 'columnpickerbutton');

_defineProperty(ColumnPickerButton, "configurable", {
  text: 'L{TaskBoard.Columns}',
  icon: 'b-icon-picker',
  pressedIcon: 'b-icon-picker-rotated',
  iconAlign: 'end',
  menuIcon: null,
  // items null needed to not be considered an object holding menu items
  menu: {
    items: null
  }
});

ColumnPickerButton.initClass();
ColumnPickerButton._$name = 'ColumnPickerButton';

/***/ }),

/***/ "./lib/TaskBoard/widget/ColumnScrollButton.js":
/*!****************************************************!*\
  !*** ./lib/TaskBoard/widget/ColumnScrollButton.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColumnScrollButton; });
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _Core_widget_Menu_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/Menu.js */ "./lib/Core/widget/Menu.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';




/**
 * @module TaskBoard/widget/ColumnScrollButton
 */

/**
 * A button with a menu allowing the user to pick a column to scroll to.
 *
 * {@inlineexample TaskBoard/widget/ColumnScrollButton.js}
 *
 * When used within a TaskBoard, it connects to it automatically:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     tbar : [
 *         { type : 'columnscrollbutton' }
 *     ]
 * });
 * ```
 *
 * When used outside of a TaskBoard, it will query globally to find one but if there are multiple on page it might have
 * to be linked to one manually (see {@link TaskBoard/widget/mixin/TaskBoardLinked#config-taskBoard}:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({});
 *
 * const picker = new ColumnScrollButton({
 *    taskBoard // Link it to the taskBoard instance created above
 * });
 * ```
 *
 * @classtype columnScrollButton
 * @extends Core/widget/Button
 * @mixes TaskBoard/widget/mixin/TaskBoardLinked
 */

class ColumnScrollButton extends _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  onClickColumn({
    item
  }) {
    this.setTimeout(() => {
      var _this$taskBoard;

      return (_this$taskBoard = this.taskBoard) === null || _this$taskBoard === void 0 ? void 0 : _this$taskBoard.scrollToColumn(item.column);
    }, 100);
  }

  changeMenu(menu) {
    // Nullified on destroy
    if (menu) {
      menu = this.taskBoard.columns.map(column => ({
        ref: column.id,
        text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].encodeHtml(column.text),
        column,
        onItem: 'up.onClickColumn'
      }));
    }

    return super.changeMenu(menu);
  }

}

_defineProperty(ColumnScrollButton, "$name", 'ColumnScrollButton');

_defineProperty(ColumnScrollButton, "type", 'columnscrollbutton');

_defineProperty(ColumnScrollButton, "configurable", {
  text: 'L{TaskBoard.scrollToColumn}',
  icon: 'b-icon-picker',
  pressedIcon: 'b-icon-picker-rotated',
  iconAlign: 'end',
  menuIcon: null,
  menu: []
});

ColumnScrollButton.initClass();
ColumnScrollButton._$name = 'ColumnScrollButton';

/***/ }),

/***/ "./lib/TaskBoard/widget/ProjectCombo.js":
/*!**********************************************!*\
  !*** ./lib/TaskBoard/widget/ProjectCombo.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProjectCombo; });
/* harmony import */ var _Scheduler_widget_ProjectCombo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Scheduler/widget/ProjectCombo.js */ "./lib/Scheduler/widget/ProjectCombo.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module TaskBoard/widget/ProjectCombo
 */

/**
 * Combo that allows picking a dataset to use for a {@link TaskBoard.model.ProjectModel}. Each item holds a title and
 * a load url to reconfigure the project with.
 *
 * {@inlineexample TaskBoard/widget/ProjectCombo.js}
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     tbar : [
 *         {
 *             type : 'taskboardprojectcombo',
 *             items : [
 *                 { title : 'Important project', url : 'data/load.php?id=1' },
 *                 { title : 'Another project', url : 'data/load.php?id=2' }
 *             ]
 *         }
 *     ],
 *
 *     project : {
 *         transport : {
 *             load : {
 *                 url : 'data/load.php?id=1'
 *             }
 *         },
 *
 *         autoLoad : true
 *     }
 * });
 * ```
 *
 * @extends Scheduler/widget/ProjectCombo
 * @mixes TaskBoard/widget/mixin/TaskBoardLinked
 * @classType taskboardprojectcombo
 * @typings Scheduler/widget/ProjectCombo -> Scheduler/widget/SchedulerProjectCombo
 */

class ProjectCombo extends _Scheduler_widget_ProjectCombo_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  updateTaskBoard(taskBoard) {
    if (taskBoard) {
      this.project = taskBoard.project;
    }
  }

  afterConfigure() {
    // Force linking to project if TaskBoard is auto detected
    if (!this._taskBoard) {
      this.updateTaskBoard(this.taskBoard);
    }
  }

} // Register this widget type with its Factory

_defineProperty(ProjectCombo, "$name", 'ProjectCombo');

_defineProperty(ProjectCombo, "type", 'taskboardprojectcombo');

_defineProperty(ProjectCombo, "configurable", {
  /**
   * Project to reconfigure when picking an item. Resolved automatically if a TaskBoard is configured or detected.
   * @config {TaskBoard.model.ProjectModel}
   * @category Common
   */
  project: null
});

ProjectCombo.initClass();
ProjectCombo._$name = 'ProjectCombo';

/***/ }),

/***/ "./lib/TaskBoard/widget/ResourcesCombo.js":
/*!************************************************!*\
  !*** ./lib/TaskBoard/widget/ResourcesCombo.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ResourcesCombo; });
/* harmony import */ var _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
/* harmony import */ var _Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/widget/util/AvatarRendering.js */ "./lib/Core/widget/util/AvatarRendering.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';





/**
 * @module TaskBoard/widget/ResourcesCombo
 */

/**
 * A combo populated with the resources of a {@link TaskBoard.view.TaskBoard taskboard´s}
 * {@link Scheduler.data.ResourceStore resource store}.
 *
 * Used in {@link TaskBoard.widget.TaskEditor} to assign resources to a task. Double click a task to try it:
 *
 * {@inlineexample TaskBoard/widget/ResourcesCombo.js}
 *
 * @classtype resourcescombo
 * @extends Core/widget/Combo
 * @mixes TaskBoard/widget/mixin/TaskBoardLinked
 */

class ResourcesCombo extends _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_2__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  changeStore() {
    return this.taskBoard.project.resourceStore.chain();
  }

  changeAvatarRendering(value, old) {
    old === null || old === void 0 ? void 0 : old.destroy();

    if (value) {
      return new _Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_4__["default"]({
        element: this.element
      });
    }
  }

}

_defineProperty(ResourcesCombo, "$name", 'ResourcesCombo');

_defineProperty(ResourcesCombo, "type", 'resourcescombo');

_defineProperty(ResourcesCombo, "configurable", {
  displayField: 'name',
  valueField: 'id',
  multiSelect: true,
  editable: false,

  listItemTpl(resourceRecord) {
    const {
      avatarRendering,
      taskBoard
    } = this.owner; // TODO: Discuss with nige, improve list, switch to grid or just implement html string here?

    return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(avatarRendering.getResourceAvatar({
      initials: resourceRecord.initials,
      color: resourceRecord.color,
      iconCls: resourceRecord.iconCls,
      imageUrl: resourceRecord.image === false ? null : resourceRecord.imageUrl || (taskBoard.resourceImagePath || '') + (resourceRecord.image || '')
    })).outerHTML + _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].encodeHtml(resourceRecord.name);
  },

  picker: {
    cls: 'b-resources-picker'
  },
  chipView: {
    scrollable: null,

    itemTpl(resourceRecord) {
      const {
        avatarRendering,
        taskBoard
      } = this.owner; // TODO: Discuss with nige, improve list, switch to grid or just implement html string here?

      return _Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(avatarRendering.getResourceAvatar({
        initials: resourceRecord.initials,
        color: resourceRecord.color,
        iconCls: resourceRecord.iconCls,
        imageUrl: resourceRecord.image === false ? null : resourceRecord.imageUrl || (taskBoard.resourceImagePath || '') + (resourceRecord.image || ''),
        dataset: {
          btip: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].encodeHtml(resourceRecord.name)
        }
      })).outerHTML;
    }

  },
  avatarRendering: {
    value: true,
    $config: 'nullify'
  }
});

ResourcesCombo.initClass();
ResourcesCombo._$name = 'ResourcesCombo';

/***/ }),

/***/ "./lib/TaskBoard/widget/SwimlaneCombo.js":
/*!***********************************************!*\
  !*** ./lib/TaskBoard/widget/SwimlaneCombo.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SwimlaneCombo; });
/* harmony import */ var _base_ColorBoxCombo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base/ColorBoxCombo.js */ "./lib/TaskBoard/widget/base/ColorBoxCombo.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module TaskBoard/widget/SwimlaneCombo
 */

/**
 * A combo populated with the {@link TaskBoard.view.TaskBoard#property-swimlanes} of a {@link TaskBoard.view.TaskBoard}.
 * If a swimlane has a {@link TaskBoard.model.SwimlaneModel#field-color} defined, that color will be displayed in the
 * combo and its picker.
 *
 * Used in {@link TaskBoard.widget.TaskEditor} to pick which swimlane a task belongs to ("Prio" below):
 *
 * {@inlineexample TaskBoard/widget/ColumnCombo.js}
 *
 * @classtype swimlanecombo
 * @extends TaskBoard/widget/base/ColorBoxCombo
 */

class SwimlaneCombo extends _base_ColorBoxCombo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {
  changeStore() {
    return this.taskBoard.swimlanes.chain();
  }

}

_defineProperty(SwimlaneCombo, "$name", 'SwimlaneCombo');

_defineProperty(SwimlaneCombo, "type", 'swimlanecombo');

SwimlaneCombo.initClass();
SwimlaneCombo._$name = 'SwimlaneCombo';

/***/ }),

/***/ "./lib/TaskBoard/widget/SwimlaneFilterField.js":
/*!*****************************************************!*\
  !*** ./lib/TaskBoard/widget/SwimlaneFilterField.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SwimlaneFilterField; });
/* harmony import */ var _Core_widget_FilterField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/FilterField.js */ "./lib/Core/widget/FilterField.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module TaskBoard/widget/SwimlaneFilterField
 */

/**
 * A field that filters the swimlanes of a linked {@link TaskBoard.view.TaskBoard} when typing into it.
 *
 * {@inlineexample TaskBoard/widget/SwimlaneFilterField.js}
 *
 * When used within a TaskBoard, it connects to it automatically:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     tbar : [
 *         { type : 'swimlanefilterfield' }
 *     ]
 * });
 * ```
 *
 * When used outside of a TaskBoard, it will query globally to find one but if there are multiple on page it might have
 * to be linked to one manually (see {@link TaskBoard/widget/mixin/TaskBoardLinked#config-taskBoard}:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({});
 *
 * const picker = new SwimlaneFilterField({
 *    taskBoard // Link it to the taskBoard instance created above
 * });
 * ```
 *
 * @classtype swimlanefilterfield
 * @extends Core/widget/FilterField
 * @mixes TaskBoard/widget/mixin/TaskBoardLinked
 */

class SwimlaneFilterField extends _Core_widget_FilterField_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {}

_defineProperty(SwimlaneFilterField, "$name", 'SwimlaneFilterField');

_defineProperty(SwimlaneFilterField, "type", 'swimlanefilterfield');

_defineProperty(SwimlaneFilterField, "configurable", {
  store: 'this.taskBoard.swimlanes',
  field: 'text',
  label: 'L{TaskBoard.filterSwimlanes}',
  width: '20em',
  triggers: {
    filter: {
      cls: 'b-icon b-icon-filter',
      align: 'start'
    }
  }
});

SwimlaneFilterField.initClass();
SwimlaneFilterField._$name = 'SwimlaneFilterField';

/***/ }),

/***/ "./lib/TaskBoard/widget/SwimlanePickerButton.js":
/*!******************************************************!*\
  !*** ./lib/TaskBoard/widget/SwimlanePickerButton.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SwimlanePickerButton; });
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _Core_widget_Menu_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/Menu.js */ "./lib/Core/widget/Menu.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';




/**
 * @module TaskBoard/widget/SwimlanePickerButton
 */

/**
 * A button with a menu allowing the user to toggle which swimlanes are shown on the {@link TaskBoard.view.TaskBoard}.
 *
 * {@inlineexample TaskBoard/widget/SwimlanePickerButton.js}
 *
 * Click to display a menu populated with the swimlanes held in {@link TaskBoard.view.TaskBoard#property-swimlanes}.
 *
 * When used within a TaskBoard, it connects to it automatically:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     tbar : [
 *         { type : 'swimlanepickerbutton' }
 *     ]
 * });
 * ```
 *
 * When used outside of a TaskBoard, it will query globally to find one but if there are multiple on page it might have
 * to be linked to one manually (see {@link TaskBoard/widget/mixin/TaskBoardLinked#config-taskBoard}:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({});
 *
 * const picker = new SwimlanePickerButton({
 *    taskBoard // Link it to the taskBoard instance created above
 * });
 * ```
 *
 * @classtype swimlanepickerbutton
 * @extends Core/widget/Button
 * @mixes TaskBoard/widget/mixin/TaskBoardLinked
 */

class SwimlanePickerButton extends _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  onToggleSwimlane({
    item
  }) {
    item.swimlane.hidden = !item.checked;
  }

  changeMenu(menu) {
    const menuInstance = super.changeMenu(menu); // Nullified on destroy

    if (menuInstance) {
      menuInstance.on({
        beforeShow: 'onMenuBeforeShow',
        thisObj: this
      });
    }

    return menuInstance;
  } // Populate menu before each show to make sure it is up to date


  onMenuBeforeShow({
    source: menu
  }) {
    menu.items = this.taskBoard.swimlanes.map(swimlane => ({
      ref: swimlane.id,
      text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].encodeHtml(swimlane.text),
      checked: !swimlane.hidden,
      swimlane,
      onItem: 'up.onToggleSwimlane'
    }));
  }

}

_defineProperty(SwimlanePickerButton, "$name", 'SwimlanePickerButton');

_defineProperty(SwimlanePickerButton, "type", 'swimlanepickerbutton');

_defineProperty(SwimlanePickerButton, "configurable", {
  text: 'L{TaskBoard.Swimlanes}',
  icon: 'b-icon-picker',
  pressedIcon: 'b-icon-picker-rotated',
  iconAlign: 'end',
  menuIcon: null,
  // items null needed to not be considered an object holding menu items
  menu: {
    items: null
  }
});

SwimlanePickerButton.initClass();
SwimlanePickerButton._$name = 'SwimlanePickerButton';

/***/ }),

/***/ "./lib/TaskBoard/widget/SwimlaneScrollButton.js":
/*!******************************************************!*\
  !*** ./lib/TaskBoard/widget/SwimlaneScrollButton.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SwimlaneScrollButton; });
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony import */ var _Core_widget_Menu_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/Menu.js */ "./lib/Core/widget/Menu.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';




/**
 * @module TaskBoard/widget/SwimlaneScrollButton
 */

/**
 * A button with a menu allowing the user to pick a swimlane to scroll to.
 *
 * {@inlineexample TaskBoard/widget/SwimlaneScrollButton.js}
 *
 * When used within a TaskBoard, it connects to it automatically:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     tbar : [
 *         { type : 'swimlanescrollbutton' }
 *     ]
 * });
 * ```
 *
 * When used outside of a TaskBoard, it will query globally to find one but if there are multiple on page it might have
 * to be linked to one manually (see {@link TaskBoard/widget/mixin/TaskBoardLinked#config-taskBoard}:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({});
 *
 * const picker = new SwimlaneScrollButton({
 *    taskBoard // Link it to the taskBoard instance created above
 * });
 * ```
 *
 * @classtype swimlaneScrollButton
 * @extends Core/widget/Button
 * @mixes TaskBoard/widget/mixin/TaskBoardLinked
 */

class SwimlaneScrollButton extends _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
  onClickSwimlane({
    item
  }) {
    this.setTimeout(() => {
      var _this$taskBoard;

      return (_this$taskBoard = this.taskBoard) === null || _this$taskBoard === void 0 ? void 0 : _this$taskBoard.scrollToSwimlane(item.swimlane);
    }, 100);
  }

  changeMenu(menu) {
    // Nullified on destroy
    if (menu) {
      menu = this.taskBoard.swimlanes.map(swimlane => ({
        ref: swimlane.id,
        text: _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].encodeHtml(swimlane.text),
        swimlane,
        onItem: 'up.onClickSwimlane'
      }));
    }

    return super.changeMenu(menu);
  }

}

_defineProperty(SwimlaneScrollButton, "$name", 'SwimlaneScrollButton');

_defineProperty(SwimlaneScrollButton, "type", 'swimlanescrollbutton');

_defineProperty(SwimlaneScrollButton, "configurable", {
  text: 'L{TaskBoard.scrollToSwimlane}',
  icon: 'b-icon-picker',
  pressedIcon: 'b-icon-picker-rotated',
  iconAlign: 'end',
  menuIcon: null,
  menu: []
});

SwimlaneScrollButton.initClass();
SwimlaneScrollButton._$name = 'SwimlaneScrollButton';

/***/ }),

/***/ "./lib/TaskBoard/widget/TagCombo.js":
/*!******************************************!*\
  !*** ./lib/TaskBoard/widget/TagCombo.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TagCombo; });
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module TaskBoard/widget/TagCombo
 */

/**
 * A combo for picking tags. Works well to edit fields displayed by a {@link TaskBoard/view/item/TagsItem}, if data
 * uses strings to represent tags:
 *
 * {@inlineexample TaskBoard/widget/TagCombo.js}
 *
 * Consumes and outputs and array of strings, or if configured with a {@link #config-separator} a single string.
 *
 * If not seeded with any items/store, it tries to extract tags from the task store by collecting distinct values for
 * the field it is linked to (by {@link #config-name}).
 *
 * @classtype tagcombo
 * @extends Core/widget/Combo
 * @mixes TaskBoard/widget/mixin/TaskBoardLinked
 */

class TagCombo extends _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  afterConfigure() {
    var _me$store;

    const me = this; // Populate with tags from the task store

    if (!((_me$store = me.store) !== null && _me$store !== void 0 && _me$store.count) && me.taskBoard && me.name) {
      const {
        name,
        separator
      } = me,
            tags = [];
      me.taskBoard.project.taskStore.forEach(task => {
        const taskTags = task[name];

        if (taskTags) {
          if (typeof taskTags === 'string') {
            tags.push(...taskTags.split(separator));
          } else {
            tags.push(...taskTags);
          }
        }
      });
      me.items = [...new Set(tags)].sort();
    }
  }

  changeValue(value, old) {
    this.$expectsString = false;

    if (this.separator && typeof value === 'string') {
      value = value.split(this.separator);
      this.$expectsString = true;
    }

    super.changeValue(value, old);
  }

  get value() {
    const value = super.value;

    if (this.$expectsString) {
      return value.join(this.separator);
    }

    return value;
  }

  set value(value) {
    super.value = value;
  }

}

_defineProperty(TagCombo, "$name", 'TagCombo');

_defineProperty(TagCombo, "type", 'tagcombo');

_defineProperty(TagCombo, "configurable", {
  multiSelect: true,
  editable: false,

  /**
   * Separator used to split a string into tags. Required if data format uses a single string to represent tags.
   * @config {String}
   * @default
   */
  separator: ',',
  picker: {
    cls: 'b-tag-picker'
  },
  chipView: {
    closable: false
  }
});

TagCombo.initClass();
TagCombo._$name = 'TagCombo';

/***/ }),

/***/ "./lib/TaskBoard/widget/TaskColorCombo.js":
/*!************************************************!*\
  !*** ./lib/TaskBoard/widget/TaskColorCombo.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskColorCombo; });
/* harmony import */ var _base_ColorBoxCombo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base/ColorBoxCombo.js */ "./lib/TaskBoard/widget/base/ColorBoxCombo.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';

/**
 * @module TaskBoard/widget/TaskColorCombo
 */

/**
 * A combo populated with predefined colors usable by a task, see {@link TaskBoard.model.TaskModel#field-eventColor}.
 *
 * Used in {@link TaskBoard.widget.TaskEditor} to pick a color for a task. Double click a task to try it:
 *
 * {@inlineexample TaskBoard/widget/TaskColorCombo.js}
 *
 * @classtype taskcolorcombo
 * @extends TaskBoard/widget/base/ColorBoxCombo
 */

class TaskColorCombo extends _base_ColorBoxCombo_js__WEBPACK_IMPORTED_MODULE_0__["default"] {}

_defineProperty(TaskColorCombo, "$name", 'TaskColorCombo');

_defineProperty(TaskColorCombo, "type", 'taskcolorcombo');

_defineProperty(TaskColorCombo, "configurable", {
  valueField: 'color',
  clearable: true,
  placeholder: 'None',
  showBoxForNoColor: true,
  items: [{
    color: 'red',
    text: 'Red'
  }, {
    color: 'pink',
    text: 'Pink'
  }, {
    color: 'purple',
    text: 'Purple'
  }, {
    color: 'deep-purple',
    text: 'Deep purple'
  }, {
    color: 'indigo',
    text: 'Indigo'
  }, {
    color: 'blue',
    text: 'Blue'
  }, {
    color: 'light-blue',
    text: 'Light blue'
  }, {
    color: 'cyan',
    text: 'Cyan'
  }, {
    color: 'teal',
    text: 'Teal'
  }, {
    color: 'green',
    text: 'Green'
  }, {
    color: 'light-green',
    text: 'Light green'
  }, {
    color: 'lime',
    text: 'Lime'
  }, {
    color: 'yellow',
    text: 'Yellow'
  }, {
    color: 'amber',
    text: 'Amber'
  }, {
    color: 'orange',
    text: 'Orange'
  }, {
    color: 'deep-orange',
    text: 'Deep orange'
  }]
});

TaskColorCombo.initClass();
TaskColorCombo._$name = 'TaskColorCombo';

/***/ }),

/***/ "./lib/TaskBoard/widget/TaskEditor.js":
/*!********************************************!*\
  !*** ./lib/TaskBoard/widget/TaskEditor.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskEditor; });
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony import */ var _Core_widget_TextAreaField_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/TextAreaField.js */ "./lib/Core/widget/TextAreaField.js");
/* harmony import */ var _Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
/* harmony import */ var _ColumnCombo_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ColumnCombo.js */ "./lib/TaskBoard/widget/ColumnCombo.js");
/* harmony import */ var _ResourcesCombo_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ResourcesCombo.js */ "./lib/TaskBoard/widget/ResourcesCombo.js");
/* harmony import */ var _SwimlaneCombo_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./SwimlaneCombo.js */ "./lib/TaskBoard/widget/SwimlaneCombo.js");
/* harmony import */ var _TaskColorCombo_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./TaskColorCombo.js */ "./lib/TaskBoard/widget/TaskColorCombo.js");
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';









/**
 * @module TaskBoard/widget/TaskEditor
 */

/**
 * Popup used to edit tasks. Normally displayed using the {@link TaskBoard.feature.TaskEdit TaskEdit feature}.
 *
 * By default the editor live updates the task being edited. If you prefer to use buttons to save/cancel the edit,
 * set {@link #config-autoUpdateRecord} to `false`.
 *
 * ## Items
 *
 * By default it displays the following items:
 *
 * | Ref         | Type                                                   | Weight | Comment                                                                   |
 * |-------------|--------------------------------------------------------|--------|---------------------------------------------------------------------------|
 * | name        | {@link Core.widget.TextField text}                     | 100    | Task {@link TaskBoard.model.TaskModel#field-name}                         |
 * | description | {@link Core.widget.TextAreaField textarea}             | 200    | Task {@link TaskBoard.model.TaskModel#field-description}                  |
 * | resources   | {@link TaskBoard.widget.ResourcesCombo resourcescombo} | 300    | Assigned resources                                                        |
 * | color       | {@link TaskBoard.widget.TaskColorCombo taskcolorcombo} | 400    | Task {@link TaskBoard.model.TaskModel#field-eventColor}                   |
 * | column      | {@link TaskBoard.widget.ColumnCombo columncombo}       | 500    | Bound to configured {@link TaskBoard.view.TaskBoard#config-columnField}   |
 * | swimlane    | {@link TaskBoard.widget.SwimlaneCombo swimlanecombo}   | 600    | Bound to configured {@link TaskBoard.view.TaskBoard#config-swimlaneField} |
 *
 * If configured with `autoUpdateRecord: false` it also displays a bottom toolbar with the following items:
 *
 * | Ref          | Type                              | Weight | Comment          |
 * |--------------|-----------------------------------|--------|------------------|
 * | saveButton   | {@link Core.widget.Button button} | 100    | Save             |
 * | cancelButton | {@link Core.widget.Button button} | 200    | Cancel           |
 *
 * ## Customization
 *
 * Popup and its items can be customized through the feature (see {@link TaskBoard.feature.TaskEdit} fore more info):
 *
 * {@inlineexample TaskBoard/widget/TaskEditorCustomized.js}
 *
 * Or by subclassing and instructing the feature to display the new editor:
 *
 * {@inlineexample TaskBoard/widget/TaskEditorSubclassed.js}
 *
 * @classtype taskboardtaskeditor
 * @extends Core/widget/Popup
 */

class TaskEditor extends _Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_4__["default"]) {
  changeItems(items, old) {
    const {
      taskBoard
    } = this,
          {
      column,
      swimlane
    } = items;

    if (taskBoard) {
      // Hook column field up to correct record field
      if (column) {
        if (!column.name) {
          column.name = taskBoard.columnField;
        }

        if (!column.label) {
          column.label = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].capitalize(taskBoard.columnField);
        }
      }

      if (swimlane) {
        // Take the swimlane field out if not using swimlanes
        if (!taskBoard.swimlaneField || !taskBoard.swimlanes) {
          items.swimlane = null;
        } // Otherwise hook it up with correct record field
        else {
          if (!swimlane.name) {
            swimlane.name = taskBoard.swimlaneField;
          }

          if (!swimlane.label) {
            swimlane.label = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].capitalize(taskBoard.swimlaneField);
          }
        }
      } // Remove resources field if there are no resources


      if (!taskBoard.project.resourceStore.count) {
        items.resources = null;
      }
    } else {
      items.column = items.swimlane = items.resources = null;
    }

    return super.changeItems(items, old);
  }

  processItemsObject(items, namedItems, result) {
    // Use ref as name if not explicitly set
    for (const ref in items) {
      const item = items[ref];

      if (item && !('name' in item)) {
        item.name = ref;
      }
    }

    return super.processItemsObject(items, namedItems, result);
  }

  updateAutoUpdateRecord(autoUpdate) {
    this.bbar.hidden = autoUpdate;
  }

  updateRecord(record) {
    super.updateRecord(record); // Tag along task id, mainly for tests

    this.element.dataset.taskId = record.id;
  }

  onSaveClick() {
    const me = this,
          {
      record
    } = me,
          _me$values = me.values,
          {
      resources
    } = _me$values,
          values = _objectWithoutProperties(_me$values, ["resources"]);

    if (me.isValid) {
      // Close first to avoid focus restoring issues if the edit element gets removed by the operations below
      me.close();
      record.set(values);

      if (resources) {
        // Does not work when passed through set, handle it separately
        record.resources = resources;
      }
    }
  }

  onCancelClick() {
    this.close();
  }

  onInternalKeyDown(event) {
    const me = this;

    if (me.saveAndCloseOnEnter && !me.readOnly && event.key === 'Enter') {
      // Need to prevent this key events from being fired on whatever receives focus after the editor is hidden
      event.preventDefault();

      if (me.autoUpdateRecord) {
        if (me.isValid) {
          // Blur to get a change event before closing, to be sure record is up to date
          event.target.blur();
          me.close();
        }
      } else {
        me.onSaveClick();
      }
    }

    super.onInternalKeyDown(event);
  }

}

_defineProperty(TaskEditor, "$name", 'TaskEditor');

_defineProperty(TaskEditor, "type", 'taskboardtaskeditor');

_defineProperty(TaskEditor, "configurable", {
  /**
   * Center the editor in browser viewport space. Defaults to true for desktop browsers using a pointer device
   * @config {Boolean}
   * @default
   * @category Common
   */
  centered: true,

  /**
   * Show an opaque mask below the editor when shown.
   *
   * Clicking the mask closes the editor.
   *
   * @config {Boolean}
   * @default true
   * @category Common
   */
  modal: {
    closeOnMaskTap: true
  },

  /**
   * Shows a tool used to close the editor in the header.
   * @config {Boolean}
   * @default
   * @category Common
   */
  closable: true,

  /**
   * By default the editor automatically updates the edited task when a field is changed. Set this to `false`
   * to show Save / Cancel buttons and take manual control of the updating.
   *
   * @config {Boolean}
   * @default
   * @category Common
   */
  autoUpdateRecord: true,

  /**
   * True to save and close the editor if ENTER is pressed.
   * (The save part only applies when configured with `autoUpdateRecord : false`)
   *
   * @config {Boolean}
   * @default
   * @category Common
   */
  saveAndCloseOnEnter: true,
  autoShow: false,
  anchor: true,
  closeAction: 'destroy',
  scrollAction: 'realign',
  title: 'L{TaskBoard.editTask}',
  defaults: {
    labelWidth: '30%'
  },
  width: '30em',
  items: {
    name: {
      type: 'text',
      label: 'L{TaskBoard.name}',
      weight: 100
    },
    description: {
      type: 'textarea',
      label: 'L{TaskBoard.description}',
      height: '5em',
      weight: 200
    },
    resources: {
      type: 'resourcescombo',
      label: 'L{TaskBoard.resources}',
      weight: 300
    },
    color: {
      type: 'taskcolorcombo',
      label: 'L{TaskBoard.color}',
      name: 'eventColor',
      weight: 400
    },
    column: {
      type: 'columncombo',
      weight: 500
    },
    swimlane: {
      type: 'swimlanecombo',
      weight: 600
    }
  },
  bbar: {
    hidden: true,
    items: {
      saveButton: {
        text: 'L{TaskBoard.save}',
        onClick: 'up.onSaveClick',
        weight: 100
      },
      cancelButton: {
        text: 'L{TaskBoard.cancel}',
        onClick: 'up.onCancelClick',
        weight: 200
      }
    }
  }
});

TaskEditor.initClass();
TaskEditor._$name = 'TaskEditor';

/***/ }),

/***/ "./lib/TaskBoard/widget/TaskFilterField.js":
/*!*************************************************!*\
  !*** ./lib/TaskBoard/widget/TaskFilterField.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TaskFilterField; });
/* harmony import */ var _Core_widget_FilterField_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/FilterField.js */ "./lib/Core/widget/FilterField.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module TaskBoard/widget/TaskFilterField
 */

/**
 * A field that filters the tasks of a linked {@link TaskBoard.view.TaskBoard} when typing into it.
 *
 * {@inlineexample TaskBoard/widget/TaskFilterField.js}
 *
 * When used within a TaskBoard, it connects to it automatically:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     tbar : [
 *         { type : 'taskfilterfield' }
 *     ]
 * });
 * ```
 *
 * When used outside of a TaskBoard, it will query globally to find one but if there are multiple on page it might have
 * to be linked to one manually (see {@link TaskBoard/widget/mixin/TaskBoardLinked#config-taskBoard}:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({});
 *
 * const picker = new TaskFilterField({
 *    taskBoard // Link it to the taskBoard instance created above
 * });
 * ```
 *
 * @classtype taskfilterfield
 * @extends Core/widget/FilterField
 * @mixes TaskBoard/widget/mixin/TaskBoardLinked
 */

class TaskFilterField extends _Core_widget_FilterField_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {}

_defineProperty(TaskFilterField, "$name", 'TaskFilterField');

_defineProperty(TaskFilterField, "type", 'taskfilterfield');

_defineProperty(TaskFilterField, "configurable", {
  store: 'this.taskBoard.project.taskStore',
  field: 'name',
  label: 'L{TaskBoard.filterTasks}',
  width: '20em',
  triggers: {
    filter: {
      cls: 'b-icon b-icon-filter',
      align: 'start'
    }
  }
});

TaskFilterField.initClass();
TaskFilterField._$name = 'TaskFilterField';

/***/ }),

/***/ "./lib/TaskBoard/widget/TodoListField.js":
/*!***********************************************!*\
  !*** ./lib/TaskBoard/widget/TodoListField.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TodoListField; });
/* harmony import */ var _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Core/widget/Editor.js */ "./lib/Core/widget/Editor.js");
/* harmony import */ var _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Core/widget/Field.js */ "./lib/Core/widget/Field.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony import */ var _Core_widget_List_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Core/widget/List.js */ "./lib/Core/widget/List.js");
/* harmony import */ var _Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Core/widget/Button.js */ "./lib/Core/widget/Button.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';







/**
 * @module TaskBoard/widget/TodoListField
 */

/**
 * A field that displays, and also lets users edit, a list of todo items. Each item has a checkbox to mark if the item
 * is completed or not and a button to edit its text/remove it. Designed to be used in the task editor, to work in
 * tandem with the {@link TaskBoard.view.item.TodoListItem}.
 *
 * {@inlineexample TaskBoard/widget/TodoListField.js}
 *
 * To hook it up, add it to the task editors items and link it to a field on your task model declared with
 * `type : 'array'`. The fields data is expected to be an array of objects. Configure {@link #config-textField} and
 * {@link #config-checkedField} to match the names used by the objects in your array.
 *
 * This snippet illustrates basic usage:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *    features : {
 *        taskEdit : {
 *            items : {
 *                todo : {
 *                    type         : 'todolist',
 *                    label        : 'Todo',
 *                    field        : 'todo',
 *                    // "title" property will be used as the todo item text
 *                    textField    : 'title',
 *                    // "done" property will drive the checkbox
 *                    checkedField : 'done'
 *                }
 *            }
 *        }
 *    },
 *
 *    project : {
 *        taskStore : {
 *            fields : [ { name : 'todo', type : 'array' } ]
 *        }
 *
 *        tasksData : [
 *            {
 *                id   : 1,
 *                name : 'Important task',
 *                todo : [
 *                    { title : 'Fix this', done : true },
 *                    { title : 'Fix that', done : false }
 *                ]
 *            }
 *        ]
 *    }
 * });
 * ```
 *
 * @classtype todolistfield
 * @extends Core/widget/Field
 */

class TodoListField extends _Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_3__["default"] {
  compose() {
    const {
      editableItems
    } = this;
    return {
      class: {
        'b-editable': editableItems
      }
    };
  }

  changeList(list) {
    return _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].create(_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].assign({
      // List does not support remapping out of the box
      itemTpl: record => _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_1__["default"].xss`<div class="b-todo-text">${record[this.textField]}</div><i class='b-todo-edit b-icon b-icon-edit' data-noselect></i>`
    }, list));
  }

  updateList(list) {
    // Detect click on edit icon
    list.on({
      item: 'onItemClick',
      thisObj: this
    }); // Detect check/uncheck

    list.selected.on({
      change: 'onSelectionChange',
      thisObj: this
    });
  }

  changeAddButton(button) {
    return _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_4__["default"].create(button);
  }

  updateAddButton(button) {
    button.on({
      click: 'onAddClick',
      thisObj: this
    });
  }

  get childItems() {
    return [this.list, this.addButton];
  }

  get inputElement() {
    return this.list.element;
  }

  get innerElements() {
    return super.innerElements.concat(this.addButton.element);
  }

  changeValue(value) {
    value = value || [];
    let autoUpdate = false; // Auto update original array if we are used in an auto updating container

    this.eachAncestor(a => {
      if (a.autoUpdateRecord) {
        autoUpdate = true;
        return false;
      }
    }); // Original value (or a clone thereof if we are not live updating) is kept up to date on later modifications

    this.originalValue = autoUpdate ? value : _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clone(value);

    if (value) {
      // Clone original value as our value, to not pollute the original value
      value = _Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].clone(value);
      value.forEach((v, i) => {
        // id required by list
        v.id = i + 1; // map back to original value

        v.originalIndex = i;
      });
    }

    return value;
  }

  updateValue(value) {
    if (value) {
      const me = this; // Populate the list with our value clone

      me.list.items = value; // Selection is used to check/uncheck items. Set flag to prevent updating original at this stage

      me.isSettingValue = true;
      me.list.selected.values = value.filter(v => v[me.checkedField]);
      me.isSettingValue = false;
    }
  }

  get value() {
    // Always return a new array, required to flag array data field as modified / for UI to update
    return this.originalValue.slice();
  }

  set value(value) {
    super.value = value;
  } // Cant be invalid currently


  get isValid() {
    return true;
  } // Edit a todo item, using overlaid editor


  editItem(record, element) {
    const me = this,
          // Always creating a new editor, destroyed when editing finishes
    editor = new _Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
      appendTo: me.element,
      owner: me,
      cls: 'b-todo-editor',
      inputField: {
        type: 'text',
        triggers: {
          remove: {
            cls: 'b-todo-remove b-icon-trash',

            handler() {
              me.removeItem(record);
              editor.cancelEdit();
            }

          }
        }
      },
      // Above modal
      style: 'z-index : 20000',
      listeners: {
        complete({
          value
        }) {
          me.originalValue[record.originalIndex][me.textField] = value;
          me.triggerFieldChange({
            value: me.value,
            userAction: true
          });
        },

        finishEdit() {
          editor.destroy();
        },

        thisObj: me
      }
    }); // Start editing using configured field mapping

    editor.startEdit({
      target: element,
      record,
      field: me.textField
    });
  } // Remove a todo item, updating both the list and the original value


  removeItem(record) {
    const me = this,
          {
      originalIndex
    } = record; // Move following items up one notch to match position in originalValue after the splice below

    me.list.store.forEach(r => {
      if (r.parentIndex > record.parentIndex) {
        r.originalIndex--;
      }
    });
    me.list.store.remove(record);
    me.originalValue.splice(originalIndex, 1);
    me.triggerFieldChange({
      value: me.value,
      userAction: true
    });
  } // Lists selection model is used to check/uncheck todo items. React on changes here


  onSelectionChange() {
    const me = this,
          {
      list
    } = me;

    if (!me.isSettingValue) {
      me.originalValue.forEach((v, i) => {
        const listRecord = list.store.getAt(i); // Selection might change as a reaction to an item being removed = no listRecord

        if (listRecord) {
          v[me.checkedField] = list.selected.includes(listRecord);
        }
      });
      me.triggerFieldChange({
        value: me.value,
        userAction: true
      });
    }
  } // Clicked on a list item, react if it is on the edit icon


  onItemClick({
    record,
    event
  }) {
    if (event.target.matches('.b-todo-edit')) {
      this.editItem(record, event.target.closest('.b-list-item'));
    }
  } // Clicked the add button, add to original value and then plug it back in to not have to care about syncing it with
  // lists store


  onAddClick() {
    const me = this;
    me.originalValue.push({
      [me.textField]: me.L('L{newTodo}'),
      [me.checkedField]: false
    });
    me.value = me.originalValue;
    me.triggerFieldChange({
      value: me.value,
      userAction: true
    });
  }

}

_defineProperty(TodoListField, "$name", 'TodoListField');

_defineProperty(TodoListField, "type", 'todolistfield');

_defineProperty(TodoListField, "alias", 'todolist');

_defineProperty(TodoListField, "configurable", {
  /**
   * Name of a property on a todo item to display as its text.
   *
   * @config {String}
   * @category Common
   * @default
   */
  textField: 'text',

  /**
   * Name of a property on a todo item to use for the checkbox. The property is expected to be a boolean.
   *
   * @config {String}
   * @category Common
   * @default
   */
  checkedField: 'checked',

  /**
   * Configure as `false` to hide the per item edit button and the add item button. Users can still check/uncheck
   * items.
   *
   * @config {Boolean}
   * @default
   */
  editableItems: true,
  list: {
    type: 'list',
    multiSelect: true,
    store: {
      fields: []
    },

    itemIconTpl() {
      return `<i class="b-todo-checkbox b-icon"></i>`;
    }

  },
  addButton: {
    type: 'button',
    cls: 'b-todo-add',
    icon: 'b-icon-add',
    text: 'L{TodoListField.add}'
  }
});

TodoListField.initClass();
TodoListField._$name = 'TodoListField';

/***/ }),

/***/ "./lib/TaskBoard/widget/UndoRedo.js":
/*!******************************************!*\
  !*** ./lib/TaskBoard/widget/UndoRedo.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UndoRedo; });
/* harmony import */ var _Core_widget_base_UndoRedoBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/base/UndoRedoBase.js */ "./lib/Core/widget/base/UndoRedoBase.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



/**
 * @module TaskBoard/widget/UndoRedo
 */

/**
 * A widget encapsulating undo/redo functionality for the {@link TaskBoard.model.ProjectModel project} of a TaskBoard.
 *
 * To make use of this, the project must be configured with a
 * {@link Scheduler.model.mixin.ProjectModelMixin#config-stm State Tracking Manager}.
 *
 * If inserted into a TaskBoard (such as into a `tbar`, or `bbar`), the project of the that TaskBoard will be used.
 *
 * If this widget is to be used "standalone" (rendered into the DOM outside of a TaskBoard), this must be configured
 * with a reference the TaskBoard.
 *
 * There are three child widgets encapsulated which may be referenced through the {@link Core.widget.Container#property-widgetMap}:
 *
 * - `undoBtn` - The button which operates the undo operation
 * - `transactionsCombo` - A combobox into which is pushed the list of transactions,
 * - `redoBtn` - The button which operates the redo operation
 *
 * The transactionsCombo may be configured away if only the buttons are required:
 *
 * ```javascript
 * {
 *     type      : 'undoredo',
 *     items     : {
 *         transactionsCombo : null
 *     }
 * }
 * ```
 *
 * The example below illustrated how to embed an `undoredo` widget in the top toolbar of a TaskBoard:
 *
 * {@inlineexample TaskBoard/widget/UndoRedo.js}
 *
 * @extends Core/widget/base/UndoRedoBase
 * @classType taskboardundoredo
 * @demo TaskBoard/undo-redo
 */

class UndoRedo extends _Core_widget_base_UndoRedoBase_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  construct() {
    super.construct(...arguments);
    this.stm = this.taskBoard.project.stm;
  }

}

_defineProperty(UndoRedo, "$name", 'UndoRedo');

_defineProperty(UndoRedo, "type", 'taskboardundoredo');

UndoRedo.initClass();
UndoRedo._$name = 'UndoRedo';

/***/ }),

/***/ "./lib/TaskBoard/widget/ZoomSlider.js":
/*!********************************************!*\
  !*** ./lib/TaskBoard/widget/ZoomSlider.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ZoomSlider; });
/* harmony import */ var _Core_widget_Slider_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Core/widget/Slider.js */ "./lib/Core/widget/Slider.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module TaskBoard/widget/ZoomSlider
 */

/**
 * A slider that controls the {@link TaskBoard/view/TaskBoardBase#config-tasksPerRow} config of TaskBoard.
 *
 * {@inlineexample TaskBoard/widget/ZoomSlider.js}
 *
 * When used within a TaskBoard, it connects to it automatically:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({
 *     tbar : [
 *         { type : 'zoomslider' }
 *     ]
 * });
 * ```
 *
 * When used outside of a TaskBoard, it will query globally to find one but if there are multiple on page it might have
 * to be linked to one manually (see {@link TaskBoard/widget/mixin/TaskBoardLinked#config-taskBoard}:
 *
 * ```javascript
 * const taskBoard = new TaskBoard({});
 *
 * const picker = new ZoomSlider({
 *    taskBoard // Link it to the taskBoard instance created above
 * });
 * ```
 *
 * @classtype zoomslider
 * @extends Core/widget/Slider
 * @mixes TaskBoard/widget/mixin/TaskBoardLinked
 */

class ZoomSlider extends _Core_widget_Slider_js__WEBPACK_IMPORTED_MODULE_0__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
  calculateValue(input) {
    return this.max - input + 1;
  }

  afterConstruct() {
    this.value = this.calculateValue(this.taskBoard.tasksPerRow);
  }

  onInput({
    value
  }) {
    this.taskBoard.tasksPerRow = this.calculateValue(value);
  }

  updateValue(value) {
    super.updateValue(value);
    this.onInput({
      value
    });
  }

  getTooltipHtml(value) {
    const tasksPerRow = this.calculateValue(value);
    return `${tasksPerRow} card${tasksPerRow === 1 ? '' : 's'} per row`;
  }

}

_defineProperty(ZoomSlider, "$name", 'ZoomSlider');

_defineProperty(ZoomSlider, "type", 'zoomslider');

_defineProperty(ZoomSlider, "configurable", {
  text: 'L{TaskBoard.zoom}',
  max: 10,
  min: 1,
  // Override default to avoid hitting updater, value set in afterConstruct
  value: null,
  showValue: false
});

ZoomSlider.initClass();
ZoomSlider._$name = 'ZoomSlider';

/***/ }),

/***/ "./lib/TaskBoard/widget/base/ColorBoxCombo.js":
/*!****************************************************!*\
  !*** ./lib/TaskBoard/widget/base/ColorBoxCombo.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ColorBoxCombo; });
/* harmony import */ var _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony import */ var _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony import */ var _mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';



/**
 * @module TaskBoard/widget/base/ColorBoxCombo
 */

/**
 * Abstract base class with functionality shared between {@link TaskBoard.widget.ColumnCombo},
 * {@link TaskBoard.widget.SwimlaneCombo} and {@link TaskBoard.widget.TaskColorCombo}.
 *
 * @extends Core/widget/Combo
 * @mixes TaskBoard/widget/mixin/TaskBoardLinked
 * @abstract
 */

class ColorBoxCombo extends _Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_1__["default"].mixin(_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_2__["default"]) {
  afterConstruct() {
    if (!this.showBoxForNoColor && !this.value) {
      this.element.classList.add('b-colorless');
    }
  }

  syncInputFieldValue(...args) {
    const me = this,
          {
      color
    } = me.record || {};
    me.colorBox.className = color ? `b-colorbox b-taskboard-color-${color}` : 'b-colorbox';

    if (!me.showBoxForNoColor) {
      me.element.classList.toggle('b-colorless', !color);
    }

    super.syncInputFieldValue(...args);
  }

  get innerElements() {
    return [{
      reference: 'colorBox',
      className: 'b-colorbox'
    }, ...super.innerElements];
  }

}

_defineProperty(ColorBoxCombo, "$name", 'ColorBoxCombo');

_defineProperty(ColorBoxCombo, "type", 'colorboxcombo');

_defineProperty(ColorBoxCombo, "configurable", {
  displayField: 'text',
  valueField: 'id',
  editable: false,
  showBoxForNoColor: false,

  listItemTpl(item) {
    let html = _Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_0__["default"].encodeHtml(item.text);

    if (item.color) {
      html = `<div class="b-colorbox b-taskboard-color-${item.color}"></div>` + html;
    }

    return html;
  },

  picker: {
    cls: 'b-colorbox-picker'
  }
});

ColorBoxCombo._$name = 'ColorBoxCombo';

/***/ }),

/***/ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js":
/*!*******************************************************!*\
  !*** ./lib/TaskBoard/widget/mixin/TaskBoardLinked.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../Core/Base.js */ "./lib/Core/Base.js");
/* harmony import */ var _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var productName = 'taskboard';


/**
 * @module TaskBoard/widget/mixin/TaskBoardLinked
 */

/**
 * Mixin that simplifies linking a widget to a {@link TaskBoard.view.TaskBoard}.
 *
 * @mixin
 */

/* harmony default export */ __webpack_exports__["default"] = (Target => {
  var _class, _temp;

  return _temp = _class = class TaskBoardLinked extends (Target || _Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    get taskBoard() {
      return this._taskBoard || this.up(widget => widget.isTaskBoardBase) || _Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_1__["default"].query(widget => widget.isTaskBoardBase);
    }

    changeTaskBoard(taskBoard) {
      if (taskBoard && !taskBoard.isTaskBoard) {
        throw new Error(`The taskBoard config only accepts an instance of TaskBoard or a subclass thereof`);
      }

      return taskBoard;
    }

  }, _defineProperty(_class, "$name", 'TaskBoardLinked'), _defineProperty(_class, "configurable", {
    /**
     * Auto detected when used within a TaskBoard. If you add the widget elsewhere, it will try to find an instance
     * of TaskBoard on page. If that fails you have to supply this config to connect it to a TaskBoard manually.
     *
     * ```javascript
     * const taskBoard = new TaskBoard({});
     *
     * const picker = new ColumnPickerButton({
     *    taskBoard // Link it to the taskBoard instance created above
     * });
     * ```
     *
     * @config {TaskBoard.view.TaskBoard}
     * @category Common
     */
    taskBoard: null
  }), _temp;
});

/***/ }),

/***/ "./webpack/webpack.core.entry.js":
/*!***************************************!*\
  !*** ./webpack/webpack.core.entry.js ***!
  \***************************************/
/*! exports provided: Base, Config, GlobalEvents, AjaxStore, DomDataStore, Duration, Model, Store, ArrayDataField, BooleanDataField, DataField, DateDataField, IntegerDataField, ModelDataField, NumberDataField, ObjectDataField, StringDataField, StoreChained, StoreCRUD, StoreFilter, StoreGroup, StoreProxy, StoreRelation, StoreSearch, StoreSort, StoreState, StoreSum, StoreSync, StoreTree, TreeNode, ActionBase, ModelStm, StateBase, StateTrackingManager, StoreStm, Transaction, ContextMenuBase, AjaxHelper, ArrayHelper, AsyncHelper, BrowserHelper, CSSHelper, DateHelper, DomHelper, DomSync, DragHelper, EventHelper, FunctionHelper, IdHelper, ObjectHelper, ResizeHelper, ResizeMonitor, StringHelper, TemplateHelper, VersionHelper, WidgetHelper, XMLHelper, DataGenerator, DemoBot, DomClassList, Formatter, Fullscreen, NumberFormat, Objects, Point, Promissory, RandomGenerator, Rectangle, Scroller, LocaleHelper, LocaleManager, Localizable, Delayable, Draggable, Droppable, Events, Factoryable, Featureable, Finalizable, Hoverable, Identifiable, InstancePlugin, LoadMaskable, Override, Pluggable, State, Animator, Bag, ClickRepeater, Collection, CollectionFilter, CollectionSorter, ScrollManager, DragContext, DragProxy, DragTipProxy, DynamicObject, DayTime, Month, Parser, UndoRedoBase, BooleanCombo, Button, ButtonGroup, CalendarPanel, Checkbox, ChipView, Combo, Container, DateField, DatePicker, DateTimeField, DisplayField, DurationField, Editor, Field, FileField, FilePicker, FilterField, Label, List, Mask, Menu, MenuItem, MessageDialog, NumberField, PagingToolbar, Panel, PanelCollapser, PanelCollapserOverlay, CollapseTool, PasswordField, PickerField, Popup, Renderable, Ripple, Slider, SlideToggle, Splitter, Tab, TabBar, TabPanel, TextAreaField, TextField, TimeField, TimePicker, Toast, Tool, Toolbar, Tooltip, Widget, Layout, Badge, Responsive, Rotatable, Styleable, Toolable, Histogram, Scale, AvatarRendering, TrialButton, TrialPanel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _lib_Core_Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../lib/Core/Base.js */ "./lib/Core/Base.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Base", function() { return _lib_Core_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _lib_Core_Config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../lib/Core/Config.js */ "./lib/Core/Config.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return _lib_Core_Config_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _lib_Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../lib/Core/GlobalEvents.js */ "./lib/Core/GlobalEvents.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GlobalEvents", function() { return _lib_Core_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _lib_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../lib/Core/data/AjaxStore.js */ "./lib/Core/data/AjaxStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxStore", function() { return _lib_Core_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _lib_Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../lib/Core/data/DomDataStore.js */ "./lib/Core/data/DomDataStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomDataStore", function() { return _lib_Core_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _lib_Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../lib/Core/data/Duration.js */ "./lib/Core/data/Duration.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Duration", function() { return _lib_Core_data_Duration_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _lib_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../lib/Core/data/Model.js */ "./lib/Core/data/Model.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Model", function() { return _lib_Core_data_Model_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _lib_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../lib/Core/data/Store.js */ "./lib/Core/data/Store.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return _lib_Core_data_Store_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _lib_Core_data_field_ArrayDataField_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../lib/Core/data/field/ArrayDataField.js */ "./lib/Core/data/field/ArrayDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayDataField", function() { return _lib_Core_data_field_ArrayDataField_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _lib_Core_data_field_BooleanDataField_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../lib/Core/data/field/BooleanDataField.js */ "./lib/Core/data/field/BooleanDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanDataField", function() { return _lib_Core_data_field_BooleanDataField_js__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _lib_Core_data_field_DataField_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../lib/Core/data/field/DataField.js */ "./lib/Core/data/field/DataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataField", function() { return _lib_Core_data_field_DataField_js__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _lib_Core_data_field_DateDataField_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../lib/Core/data/field/DateDataField.js */ "./lib/Core/data/field/DateDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateDataField", function() { return _lib_Core_data_field_DateDataField_js__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony import */ var _lib_Core_data_field_IntegerDataField_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../lib/Core/data/field/IntegerDataField.js */ "./lib/Core/data/field/IntegerDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntegerDataField", function() { return _lib_Core_data_field_IntegerDataField_js__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony import */ var _lib_Core_data_field_ModelDataField_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../lib/Core/data/field/ModelDataField.js */ "./lib/Core/data/field/ModelDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelDataField", function() { return _lib_Core_data_field_ModelDataField_js__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var _lib_Core_data_field_NumberDataField_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../lib/Core/data/field/NumberDataField.js */ "./lib/Core/data/field/NumberDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberDataField", function() { return _lib_Core_data_field_NumberDataField_js__WEBPACK_IMPORTED_MODULE_14__["default"]; });

/* harmony import */ var _lib_Core_data_field_ObjectDataField_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../lib/Core/data/field/ObjectDataField.js */ "./lib/Core/data/field/ObjectDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectDataField", function() { return _lib_Core_data_field_ObjectDataField_js__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/* harmony import */ var _lib_Core_data_field_StringDataField_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../lib/Core/data/field/StringDataField.js */ "./lib/Core/data/field/StringDataField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringDataField", function() { return _lib_Core_data_field_StringDataField_js__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreChained_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreChained.js */ "./lib/Core/data/mixin/StoreChained.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreChained", function() { return _lib_Core_data_mixin_StoreChained_js__WEBPACK_IMPORTED_MODULE_17__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreCRUD_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreCRUD.js */ "./lib/Core/data/mixin/StoreCRUD.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreCRUD", function() { return _lib_Core_data_mixin_StoreCRUD_js__WEBPACK_IMPORTED_MODULE_18__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreFilter_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreFilter.js */ "./lib/Core/data/mixin/StoreFilter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreFilter", function() { return _lib_Core_data_mixin_StoreFilter_js__WEBPACK_IMPORTED_MODULE_19__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreGroup_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreGroup.js */ "./lib/Core/data/mixin/StoreGroup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreGroup", function() { return _lib_Core_data_mixin_StoreGroup_js__WEBPACK_IMPORTED_MODULE_20__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreProxy_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreProxy.js */ "./lib/Core/data/mixin/StoreProxy.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreProxy", function() { return _lib_Core_data_mixin_StoreProxy_js__WEBPACK_IMPORTED_MODULE_21__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreRelation_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreRelation.js */ "./lib/Core/data/mixin/StoreRelation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreRelation", function() { return _lib_Core_data_mixin_StoreRelation_js__WEBPACK_IMPORTED_MODULE_22__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreSearch_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreSearch.js */ "./lib/Core/data/mixin/StoreSearch.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSearch", function() { return _lib_Core_data_mixin_StoreSearch_js__WEBPACK_IMPORTED_MODULE_23__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreSort_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreSort.js */ "./lib/Core/data/mixin/StoreSort.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSort", function() { return _lib_Core_data_mixin_StoreSort_js__WEBPACK_IMPORTED_MODULE_24__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreState_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreState.js */ "./lib/Core/data/mixin/StoreState.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreState", function() { return _lib_Core_data_mixin_StoreState_js__WEBPACK_IMPORTED_MODULE_25__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreSum_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreSum.js */ "./lib/Core/data/mixin/StoreSum.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSum", function() { return _lib_Core_data_mixin_StoreSum_js__WEBPACK_IMPORTED_MODULE_26__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreSync_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreSync.js */ "./lib/Core/data/mixin/StoreSync.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSync", function() { return _lib_Core_data_mixin_StoreSync_js__WEBPACK_IMPORTED_MODULE_27__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_StoreTree_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../lib/Core/data/mixin/StoreTree.js */ "./lib/Core/data/mixin/StoreTree.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreTree", function() { return _lib_Core_data_mixin_StoreTree_js__WEBPACK_IMPORTED_MODULE_28__["default"]; });

/* harmony import */ var _lib_Core_data_mixin_TreeNode_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../lib/Core/data/mixin/TreeNode.js */ "./lib/Core/data/mixin/TreeNode.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TreeNode", function() { return _lib_Core_data_mixin_TreeNode_js__WEBPACK_IMPORTED_MODULE_29__["default"]; });

/* harmony import */ var _lib_Core_data_stm_action_ActionBase_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../lib/Core/data/stm/action/ActionBase.js */ "./lib/Core/data/stm/action/ActionBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ActionBase", function() { return _lib_Core_data_stm_action_ActionBase_js__WEBPACK_IMPORTED_MODULE_30__["default"]; });

/* harmony import */ var _lib_Core_data_stm_mixin_ModelStm_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../lib/Core/data/stm/mixin/ModelStm.js */ "./lib/Core/data/stm/mixin/ModelStm.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelStm", function() { return _lib_Core_data_stm_mixin_ModelStm_js__WEBPACK_IMPORTED_MODULE_31__["default"]; });

/* harmony import */ var _lib_Core_data_stm_state_StateBase_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../lib/Core/data/stm/state/StateBase.js */ "./lib/Core/data/stm/state/StateBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateBase", function() { return _lib_Core_data_stm_state_StateBase_js__WEBPACK_IMPORTED_MODULE_32__["default"]; });

/* harmony import */ var _lib_Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../lib/Core/data/stm/StateTrackingManager.js */ "./lib/Core/data/stm/StateTrackingManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateTrackingManager", function() { return _lib_Core_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_33__["default"]; });

/* harmony import */ var _lib_Core_data_stm_mixin_StoreStm_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../lib/Core/data/stm/mixin/StoreStm.js */ "./lib/Core/data/stm/mixin/StoreStm.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreStm", function() { return _lib_Core_data_stm_mixin_StoreStm_js__WEBPACK_IMPORTED_MODULE_34__["default"]; });

/* harmony import */ var _lib_Core_data_stm_Transaction_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../lib/Core/data/stm/Transaction.js */ "./lib/Core/data/stm/Transaction.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Transaction", function() { return _lib_Core_data_stm_Transaction_js__WEBPACK_IMPORTED_MODULE_35__["default"]; });

/* harmony import */ var _lib_Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../lib/Core/feature/base/ContextMenuBase.js */ "./lib/Core/feature/base/ContextMenuBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContextMenuBase", function() { return _lib_Core_feature_base_ContextMenuBase_js__WEBPACK_IMPORTED_MODULE_36__["default"]; });

/* harmony import */ var _lib_Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../lib/Core/helper/AjaxHelper.js */ "./lib/Core/helper/AjaxHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxHelper", function() { return _lib_Core_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_37__["default"]; });

/* harmony import */ var _lib_Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../lib/Core/helper/ArrayHelper.js */ "./lib/Core/helper/ArrayHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayHelper", function() { return _lib_Core_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_38__["default"]; });

/* harmony import */ var _lib_Core_helper_AsyncHelper_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../lib/Core/helper/AsyncHelper.js */ "./lib/Core/helper/AsyncHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AsyncHelper", function() { return _lib_Core_helper_AsyncHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"]; });

/* harmony import */ var _lib_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../lib/Core/helper/BrowserHelper.js */ "./lib/Core/helper/BrowserHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BrowserHelper", function() { return _lib_Core_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_40__["default"]; });

/* harmony import */ var _lib_Core_helper_CSSHelper_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../lib/Core/helper/CSSHelper.js */ "./lib/Core/helper/CSSHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CSSHelper", function() { return _lib_Core_helper_CSSHelper_js__WEBPACK_IMPORTED_MODULE_41__["default"]; });

/* harmony import */ var _lib_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../lib/Core/helper/DateHelper.js */ "./lib/Core/helper/DateHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateHelper", function() { return _lib_Core_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_42__["default"]; });

/* harmony import */ var _lib_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../lib/Core/helper/DomHelper.js */ "./lib/Core/helper/DomHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomHelper", function() { return _lib_Core_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_43__["default"]; });

/* harmony import */ var _lib_Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../lib/Core/helper/DomSync.js */ "./lib/Core/helper/DomSync.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomSync", function() { return _lib_Core_helper_DomSync_js__WEBPACK_IMPORTED_MODULE_44__["default"]; });

/* harmony import */ var _lib_Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../lib/Core/helper/DragHelper.js */ "./lib/Core/helper/DragHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragHelper", function() { return _lib_Core_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_45__["default"]; });

/* harmony import */ var _lib_Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../lib/Core/helper/EventHelper.js */ "./lib/Core/helper/EventHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventHelper", function() { return _lib_Core_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_46__["default"]; });

/* harmony import */ var _lib_Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../lib/Core/helper/FunctionHelper.js */ "./lib/Core/helper/FunctionHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FunctionHelper", function() { return _lib_Core_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_47__["default"]; });

/* harmony import */ var _lib_Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../lib/Core/helper/IdHelper.js */ "./lib/Core/helper/IdHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IdHelper", function() { return _lib_Core_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_48__["default"]; });

/* harmony import */ var _lib_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../lib/Core/helper/ObjectHelper.js */ "./lib/Core/helper/ObjectHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectHelper", function() { return _lib_Core_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_49__["default"]; });

/* harmony import */ var _lib_Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../lib/Core/helper/ResizeHelper.js */ "./lib/Core/helper/ResizeHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeHelper", function() { return _lib_Core_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_50__["default"]; });

/* harmony import */ var _lib_Core_helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../lib/Core/helper/ResizeMonitor.js */ "./lib/Core/helper/ResizeMonitor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeMonitor", function() { return _lib_Core_helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_51__["default"]; });

/* harmony import */ var _lib_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../lib/Core/helper/StringHelper.js */ "./lib/Core/helper/StringHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringHelper", function() { return _lib_Core_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_52__["default"]; });

/* harmony import */ var _lib_Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../lib/Core/helper/TemplateHelper.js */ "./lib/Core/helper/TemplateHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateHelper", function() { return _lib_Core_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_53__["default"]; });

/* harmony import */ var _lib_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ../lib/Core/helper/VersionHelper.js */ "./lib/Core/helper/VersionHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VersionHelper", function() { return _lib_Core_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_54__["default"]; });

/* harmony import */ var _lib_Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../lib/Core/helper/WidgetHelper.js */ "./lib/Core/helper/WidgetHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetHelper", function() { return _lib_Core_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_55__["default"]; });

/* harmony import */ var _lib_Core_helper_XMLHelper_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../lib/Core/helper/XMLHelper.js */ "./lib/Core/helper/XMLHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "XMLHelper", function() { return _lib_Core_helper_XMLHelper_js__WEBPACK_IMPORTED_MODULE_56__["default"]; });

/* harmony import */ var _lib_Core_helper_util_DataGenerator_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../lib/Core/helper/util/DataGenerator.js */ "./lib/Core/helper/util/DataGenerator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataGenerator", function() { return _lib_Core_helper_util_DataGenerator_js__WEBPACK_IMPORTED_MODULE_57__["default"]; });

/* harmony import */ var _lib_Core_helper_util_DemoBot_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../lib/Core/helper/util/DemoBot.js */ "./lib/Core/helper/util/DemoBot.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DemoBot", function() { return _lib_Core_helper_util_DemoBot_js__WEBPACK_IMPORTED_MODULE_58__["default"]; });

/* harmony import */ var _lib_Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../lib/Core/helper/util/DomClassList.js */ "./lib/Core/helper/util/DomClassList.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomClassList", function() { return _lib_Core_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_59__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Formatter_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../lib/Core/helper/util/Formatter.js */ "./lib/Core/helper/util/Formatter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Formatter", function() { return _lib_Core_helper_util_Formatter_js__WEBPACK_IMPORTED_MODULE_60__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../lib/Core/helper/util/Fullscreen.js */ "./lib/Core/helper/util/Fullscreen.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Fullscreen", function() { return _lib_Core_helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_61__["default"]; });

/* harmony import */ var _lib_Core_helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../lib/Core/helper/util/NumberFormat.js */ "./lib/Core/helper/util/NumberFormat.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberFormat", function() { return _lib_Core_helper_util_NumberFormat_js__WEBPACK_IMPORTED_MODULE_62__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../lib/Core/helper/util/Objects.js */ "./lib/Core/helper/util/Objects.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Objects", function() { return _lib_Core_helper_util_Objects_js__WEBPACK_IMPORTED_MODULE_63__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Point_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../lib/Core/helper/util/Point.js */ "./lib/Core/helper/util/Point.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Point", function() { return _lib_Core_helper_util_Point_js__WEBPACK_IMPORTED_MODULE_64__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../lib/Core/helper/util/Promissory.js */ "./lib/Core/helper/util/Promissory.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Promissory", function() { return _lib_Core_helper_util_Promissory_js__WEBPACK_IMPORTED_MODULE_65__["default"]; });

/* harmony import */ var _lib_Core_helper_util_RandomGenerator_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ../lib/Core/helper/util/RandomGenerator.js */ "./lib/Core/helper/util/RandomGenerator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RandomGenerator", function() { return _lib_Core_helper_util_RandomGenerator_js__WEBPACK_IMPORTED_MODULE_66__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ../lib/Core/helper/util/Rectangle.js */ "./lib/Core/helper/util/Rectangle.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rectangle", function() { return _lib_Core_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_67__["default"]; });

/* harmony import */ var _lib_Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ../lib/Core/helper/util/Scroller.js */ "./lib/Core/helper/util/Scroller.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scroller", function() { return _lib_Core_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_68__["default"]; });

/* harmony import */ var _lib_Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ../lib/Core/localization/LocaleHelper.js */ "./lib/Core/localization/LocaleHelper.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleHelper", function() { return _lib_Core_localization_LocaleHelper_js__WEBPACK_IMPORTED_MODULE_69__["default"]; });

/* harmony import */ var _lib_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ../lib/Core/localization/LocaleManager.js */ "./lib/Core/localization/LocaleManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleManager", function() { return _lib_Core_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_70__["default"]; });

/* harmony import */ var _lib_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ../lib/Core/localization/Localizable.js */ "./lib/Core/localization/Localizable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Localizable", function() { return _lib_Core_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_71__["default"]; });

/* harmony import */ var _lib_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ../lib/Core/mixin/Delayable.js */ "./lib/Core/mixin/Delayable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Delayable", function() { return _lib_Core_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_72__["default"]; });

/* harmony import */ var _lib_Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ../lib/Core/mixin/Draggable.js */ "./lib/Core/mixin/Draggable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Draggable", function() { return _lib_Core_mixin_Draggable_js__WEBPACK_IMPORTED_MODULE_73__["default"]; });

/* harmony import */ var _lib_Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ../lib/Core/mixin/Droppable.js */ "./lib/Core/mixin/Droppable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Droppable", function() { return _lib_Core_mixin_Droppable_js__WEBPACK_IMPORTED_MODULE_74__["default"]; });

/* harmony import */ var _lib_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ../lib/Core/mixin/Events.js */ "./lib/Core/mixin/Events.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Events", function() { return _lib_Core_mixin_Events_js__WEBPACK_IMPORTED_MODULE_75__["default"]; });

/* harmony import */ var _lib_Core_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ../lib/Core/mixin/Factoryable.js */ "./lib/Core/mixin/Factoryable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Factoryable", function() { return _lib_Core_mixin_Factoryable_js__WEBPACK_IMPORTED_MODULE_76__["default"]; });

/* harmony import */ var _lib_Core_mixin_Featureable_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ../lib/Core/mixin/Featureable.js */ "./lib/Core/mixin/Featureable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Featureable", function() { return _lib_Core_mixin_Featureable_js__WEBPACK_IMPORTED_MODULE_77__["default"]; });

/* harmony import */ var _lib_Core_mixin_Finalizable_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ../lib/Core/mixin/Finalizable.js */ "./lib/Core/mixin/Finalizable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Finalizable", function() { return _lib_Core_mixin_Finalizable_js__WEBPACK_IMPORTED_MODULE_78__["default"]; });

/* harmony import */ var _lib_Core_mixin_Hoverable_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ../lib/Core/mixin/Hoverable.js */ "./lib/Core/mixin/Hoverable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hoverable", function() { return _lib_Core_mixin_Hoverable_js__WEBPACK_IMPORTED_MODULE_79__["default"]; });

/* harmony import */ var _lib_Core_mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ../lib/Core/mixin/Identifiable.js */ "./lib/Core/mixin/Identifiable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Identifiable", function() { return _lib_Core_mixin_Identifiable_js__WEBPACK_IMPORTED_MODULE_80__["default"]; });

/* harmony import */ var _lib_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ../lib/Core/mixin/InstancePlugin.js */ "./lib/Core/mixin/InstancePlugin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InstancePlugin", function() { return _lib_Core_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_81__["default"]; });

/* harmony import */ var _lib_Core_mixin_LoadMaskable_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ../lib/Core/mixin/LoadMaskable.js */ "./lib/Core/mixin/LoadMaskable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoadMaskable", function() { return _lib_Core_mixin_LoadMaskable_js__WEBPACK_IMPORTED_MODULE_82__["default"]; });

/* harmony import */ var _lib_Core_mixin_Override_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ../lib/Core/mixin/Override.js */ "./lib/Core/mixin/Override.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Override", function() { return _lib_Core_mixin_Override_js__WEBPACK_IMPORTED_MODULE_83__["default"]; });

/* harmony import */ var _lib_Core_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ../lib/Core/mixin/Pluggable.js */ "./lib/Core/mixin/Pluggable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pluggable", function() { return _lib_Core_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_84__["default"]; });

/* harmony import */ var _lib_Core_mixin_State_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ../lib/Core/mixin/State.js */ "./lib/Core/mixin/State.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "State", function() { return _lib_Core_mixin_State_js__WEBPACK_IMPORTED_MODULE_85__["default"]; });

/* harmony import */ var _lib_Core_util_Animator_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ../lib/Core/util/Animator.js */ "./lib/Core/util/Animator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Animator", function() { return _lib_Core_util_Animator_js__WEBPACK_IMPORTED_MODULE_86__["default"]; });

/* harmony import */ var _lib_Core_util_Bag_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ../lib/Core/util/Bag.js */ "./lib/Core/util/Bag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Bag", function() { return _lib_Core_util_Bag_js__WEBPACK_IMPORTED_MODULE_87__["default"]; });

/* harmony import */ var _lib_Core_util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ../lib/Core/util/ClickRepeater.js */ "./lib/Core/util/ClickRepeater.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ClickRepeater", function() { return _lib_Core_util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_88__["default"]; });

/* harmony import */ var _lib_Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! ../lib/Core/util/Collection.js */ "./lib/Core/util/Collection.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Collection", function() { return _lib_Core_util_Collection_js__WEBPACK_IMPORTED_MODULE_89__["default"]; });

/* harmony import */ var _lib_Core_util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(/*! ../lib/Core/util/CollectionFilter.js */ "./lib/Core/util/CollectionFilter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionFilter", function() { return _lib_Core_util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_90__["default"]; });

/* harmony import */ var _lib_Core_util_CollectionSorter_js__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(/*! ../lib/Core/util/CollectionSorter.js */ "./lib/Core/util/CollectionSorter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionSorter", function() { return _lib_Core_util_CollectionSorter_js__WEBPACK_IMPORTED_MODULE_91__["default"]; });

/* harmony import */ var _lib_Core_util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(/*! ../lib/Core/util/ScrollManager.js */ "./lib/Core/util/ScrollManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScrollManager", function() { return _lib_Core_util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_92__["default"]; });

/* harmony import */ var _lib_Core_util_drag_DragContext_js__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(/*! ../lib/Core/util/drag/DragContext.js */ "./lib/Core/util/drag/DragContext.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragContext", function() { return _lib_Core_util_drag_DragContext_js__WEBPACK_IMPORTED_MODULE_93__["default"]; });

/* harmony import */ var _lib_Core_util_drag_DragProxy_js__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(/*! ../lib/Core/util/drag/DragProxy.js */ "./lib/Core/util/drag/DragProxy.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragProxy", function() { return _lib_Core_util_drag_DragProxy_js__WEBPACK_IMPORTED_MODULE_94__["default"]; });

/* harmony import */ var _lib_Core_util_drag_DragTipProxy_js__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(/*! ../lib/Core/util/drag/DragTipProxy.js */ "./lib/Core/util/drag/DragTipProxy.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragTipProxy", function() { return _lib_Core_util_drag_DragTipProxy_js__WEBPACK_IMPORTED_MODULE_95__["default"]; });

/* harmony import */ var _lib_Core_util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(/*! ../lib/Core/util/DynamicObject.js */ "./lib/Core/util/DynamicObject.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DynamicObject", function() { return _lib_Core_util_DynamicObject_js__WEBPACK_IMPORTED_MODULE_96__["default"]; });

/* harmony import */ var _lib_Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(/*! ../lib/Core/util/DayTime.js */ "./lib/Core/util/DayTime.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DayTime", function() { return _lib_Core_util_DayTime_js__WEBPACK_IMPORTED_MODULE_97__["default"]; });

/* harmony import */ var _lib_Core_util_Month_js__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(/*! ../lib/Core/util/Month.js */ "./lib/Core/util/Month.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Month", function() { return _lib_Core_util_Month_js__WEBPACK_IMPORTED_MODULE_98__["default"]; });

/* harmony import */ var _lib_Core_util_Parser_js__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(/*! ../lib/Core/util/Parser.js */ "./lib/Core/util/Parser.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Parser", function() { return _lib_Core_util_Parser_js__WEBPACK_IMPORTED_MODULE_99__["default"]; });

/* harmony import */ var _lib_Core_widget_base_UndoRedoBase_js__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(/*! ../lib/Core/widget/base/UndoRedoBase.js */ "./lib/Core/widget/base/UndoRedoBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UndoRedoBase", function() { return _lib_Core_widget_base_UndoRedoBase_js__WEBPACK_IMPORTED_MODULE_100__["default"]; });

/* harmony import */ var _lib_Core_widget_BooleanCombo_js__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(/*! ../lib/Core/widget/BooleanCombo.js */ "./lib/Core/widget/BooleanCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanCombo", function() { return _lib_Core_widget_BooleanCombo_js__WEBPACK_IMPORTED_MODULE_101__["default"]; });

/* harmony import */ var _lib_Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(/*! ../lib/Core/widget/Button.js */ "./lib/Core/widget/Button.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return _lib_Core_widget_Button_js__WEBPACK_IMPORTED_MODULE_102__["default"]; });

/* harmony import */ var _lib_Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(/*! ../lib/Core/widget/ButtonGroup.js */ "./lib/Core/widget/ButtonGroup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return _lib_Core_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_103__["default"]; });

/* harmony import */ var _lib_Core_widget_CalendarPanel_js__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(/*! ../lib/Core/widget/CalendarPanel.js */ "./lib/Core/widget/CalendarPanel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarPanel", function() { return _lib_Core_widget_CalendarPanel_js__WEBPACK_IMPORTED_MODULE_104__["default"]; });

/* harmony import */ var _lib_Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(/*! ../lib/Core/widget/Checkbox.js */ "./lib/Core/widget/Checkbox.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return _lib_Core_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_105__["default"]; });

/* harmony import */ var _lib_Core_widget_ChipView_js__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(/*! ../lib/Core/widget/ChipView.js */ "./lib/Core/widget/ChipView.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChipView", function() { return _lib_Core_widget_ChipView_js__WEBPACK_IMPORTED_MODULE_106__["default"]; });

/* harmony import */ var _lib_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(/*! ../lib/Core/widget/Combo.js */ "./lib/Core/widget/Combo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Combo", function() { return _lib_Core_widget_Combo_js__WEBPACK_IMPORTED_MODULE_107__["default"]; });

/* harmony import */ var _lib_Core_widget_Container_js__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(/*! ../lib/Core/widget/Container.js */ "./lib/Core/widget/Container.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return _lib_Core_widget_Container_js__WEBPACK_IMPORTED_MODULE_108__["default"]; });

/* harmony import */ var _lib_Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_109__ = __webpack_require__(/*! ../lib/Core/widget/DateField.js */ "./lib/Core/widget/DateField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateField", function() { return _lib_Core_widget_DateField_js__WEBPACK_IMPORTED_MODULE_109__["default"]; });

/* harmony import */ var _lib_Core_widget_DatePicker_js__WEBPACK_IMPORTED_MODULE_110__ = __webpack_require__(/*! ../lib/Core/widget/DatePicker.js */ "./lib/Core/widget/DatePicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DatePicker", function() { return _lib_Core_widget_DatePicker_js__WEBPACK_IMPORTED_MODULE_110__["default"]; });

/* harmony import */ var _lib_Core_widget_DateTimeField_js__WEBPACK_IMPORTED_MODULE_111__ = __webpack_require__(/*! ../lib/Core/widget/DateTimeField.js */ "./lib/Core/widget/DateTimeField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateTimeField", function() { return _lib_Core_widget_DateTimeField_js__WEBPACK_IMPORTED_MODULE_111__["default"]; });

/* harmony import */ var _lib_Core_widget_DisplayField_js__WEBPACK_IMPORTED_MODULE_112__ = __webpack_require__(/*! ../lib/Core/widget/DisplayField.js */ "./lib/Core/widget/DisplayField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DisplayField", function() { return _lib_Core_widget_DisplayField_js__WEBPACK_IMPORTED_MODULE_112__["default"]; });

/* harmony import */ var _lib_Core_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_113__ = __webpack_require__(/*! ../lib/Core/widget/DurationField.js */ "./lib/Core/widget/DurationField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DurationField", function() { return _lib_Core_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_113__["default"]; });

/* harmony import */ var _lib_Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_114__ = __webpack_require__(/*! ../lib/Core/widget/Editor.js */ "./lib/Core/widget/Editor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Editor", function() { return _lib_Core_widget_Editor_js__WEBPACK_IMPORTED_MODULE_114__["default"]; });

/* harmony import */ var _lib_Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_115__ = __webpack_require__(/*! ../lib/Core/widget/Field.js */ "./lib/Core/widget/Field.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return _lib_Core_widget_Field_js__WEBPACK_IMPORTED_MODULE_115__["default"]; });

/* harmony import */ var _lib_Core_widget_FileField_js__WEBPACK_IMPORTED_MODULE_116__ = __webpack_require__(/*! ../lib/Core/widget/FileField.js */ "./lib/Core/widget/FileField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileField", function() { return _lib_Core_widget_FileField_js__WEBPACK_IMPORTED_MODULE_116__["default"]; });

/* harmony import */ var _lib_Core_widget_FilePicker_js__WEBPACK_IMPORTED_MODULE_117__ = __webpack_require__(/*! ../lib/Core/widget/FilePicker.js */ "./lib/Core/widget/FilePicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilePicker", function() { return _lib_Core_widget_FilePicker_js__WEBPACK_IMPORTED_MODULE_117__["default"]; });

/* harmony import */ var _lib_Core_widget_FilterField_js__WEBPACK_IMPORTED_MODULE_118__ = __webpack_require__(/*! ../lib/Core/widget/FilterField.js */ "./lib/Core/widget/FilterField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilterField", function() { return _lib_Core_widget_FilterField_js__WEBPACK_IMPORTED_MODULE_118__["default"]; });

/* harmony import */ var _lib_Core_widget_Label_js__WEBPACK_IMPORTED_MODULE_119__ = __webpack_require__(/*! ../lib/Core/widget/Label.js */ "./lib/Core/widget/Label.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return _lib_Core_widget_Label_js__WEBPACK_IMPORTED_MODULE_119__["default"]; });

/* harmony import */ var _lib_Core_widget_List_js__WEBPACK_IMPORTED_MODULE_120__ = __webpack_require__(/*! ../lib/Core/widget/List.js */ "./lib/Core/widget/List.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "List", function() { return _lib_Core_widget_List_js__WEBPACK_IMPORTED_MODULE_120__["default"]; });

/* harmony import */ var _lib_Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_121__ = __webpack_require__(/*! ../lib/Core/widget/Mask.js */ "./lib/Core/widget/Mask.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mask", function() { return _lib_Core_widget_Mask_js__WEBPACK_IMPORTED_MODULE_121__["default"]; });

/* harmony import */ var _lib_Core_widget_Menu_js__WEBPACK_IMPORTED_MODULE_122__ = __webpack_require__(/*! ../lib/Core/widget/Menu.js */ "./lib/Core/widget/Menu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return _lib_Core_widget_Menu_js__WEBPACK_IMPORTED_MODULE_122__["default"]; });

/* harmony import */ var _lib_Core_widget_MenuItem_js__WEBPACK_IMPORTED_MODULE_123__ = __webpack_require__(/*! ../lib/Core/widget/MenuItem.js */ "./lib/Core/widget/MenuItem.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return _lib_Core_widget_MenuItem_js__WEBPACK_IMPORTED_MODULE_123__["default"]; });

/* harmony import */ var _lib_Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_124__ = __webpack_require__(/*! ../lib/Core/widget/MessageDialog.js */ "./lib/Core/widget/MessageDialog.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MessageDialog", function() { return _lib_Core_widget_MessageDialog_js__WEBPACK_IMPORTED_MODULE_124__["default"]; });

/* harmony import */ var _lib_Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_125__ = __webpack_require__(/*! ../lib/Core/widget/NumberField.js */ "./lib/Core/widget/NumberField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberField", function() { return _lib_Core_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_125__["default"]; });

/* harmony import */ var _lib_Core_widget_PagingToolbar_js__WEBPACK_IMPORTED_MODULE_126__ = __webpack_require__(/*! ../lib/Core/widget/PagingToolbar.js */ "./lib/Core/widget/PagingToolbar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PagingToolbar", function() { return _lib_Core_widget_PagingToolbar_js__WEBPACK_IMPORTED_MODULE_126__["default"]; });

/* harmony import */ var _lib_Core_widget_Panel_js__WEBPACK_IMPORTED_MODULE_127__ = __webpack_require__(/*! ../lib/Core/widget/Panel.js */ "./lib/Core/widget/Panel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return _lib_Core_widget_Panel_js__WEBPACK_IMPORTED_MODULE_127__["default"]; });

/* harmony import */ var _lib_Core_widget_panel_PanelCollapser_js__WEBPACK_IMPORTED_MODULE_128__ = __webpack_require__(/*! ../lib/Core/widget/panel/PanelCollapser.js */ "./lib/Core/widget/panel/PanelCollapser.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelCollapser", function() { return _lib_Core_widget_panel_PanelCollapser_js__WEBPACK_IMPORTED_MODULE_128__["default"]; });

/* harmony import */ var _lib_Core_widget_panel_PanelCollapserOverlay_js__WEBPACK_IMPORTED_MODULE_129__ = __webpack_require__(/*! ../lib/Core/widget/panel/PanelCollapserOverlay.js */ "./lib/Core/widget/panel/PanelCollapserOverlay.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelCollapserOverlay", function() { return _lib_Core_widget_panel_PanelCollapserOverlay_js__WEBPACK_IMPORTED_MODULE_129__["default"]; });

/* harmony import */ var _lib_Core_widget_panel_CollapseTool_js__WEBPACK_IMPORTED_MODULE_130__ = __webpack_require__(/*! ../lib/Core/widget/panel/CollapseTool.js */ "./lib/Core/widget/panel/CollapseTool.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollapseTool", function() { return _lib_Core_widget_panel_CollapseTool_js__WEBPACK_IMPORTED_MODULE_130__["default"]; });

/* harmony import */ var _lib_Core_widget_PasswordField_js__WEBPACK_IMPORTED_MODULE_131__ = __webpack_require__(/*! ../lib/Core/widget/PasswordField.js */ "./lib/Core/widget/PasswordField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PasswordField", function() { return _lib_Core_widget_PasswordField_js__WEBPACK_IMPORTED_MODULE_131__["default"]; });

/* harmony import */ var _lib_Core_widget_PickerField_js__WEBPACK_IMPORTED_MODULE_132__ = __webpack_require__(/*! ../lib/Core/widget/PickerField.js */ "./lib/Core/widget/PickerField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PickerField", function() { return _lib_Core_widget_PickerField_js__WEBPACK_IMPORTED_MODULE_132__["default"]; });

/* harmony import */ var _lib_Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_133__ = __webpack_require__(/*! ../lib/Core/widget/Popup.js */ "./lib/Core/widget/Popup.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Popup", function() { return _lib_Core_widget_Popup_js__WEBPACK_IMPORTED_MODULE_133__["default"]; });

/* harmony import */ var _lib_Core_widget_Renderable_js__WEBPACK_IMPORTED_MODULE_134__ = __webpack_require__(/*! ../lib/Core/widget/Renderable.js */ "./lib/Core/widget/Renderable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Renderable", function() { return _lib_Core_widget_Renderable_js__WEBPACK_IMPORTED_MODULE_134__["default"]; });

/* harmony import */ var _lib_Core_widget_Ripple_js__WEBPACK_IMPORTED_MODULE_135__ = __webpack_require__(/*! ../lib/Core/widget/Ripple.js */ "./lib/Core/widget/Ripple.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return _lib_Core_widget_Ripple_js__WEBPACK_IMPORTED_MODULE_135__["default"]; });

/* harmony import */ var _lib_Core_widget_Slider_js__WEBPACK_IMPORTED_MODULE_136__ = __webpack_require__(/*! ../lib/Core/widget/Slider.js */ "./lib/Core/widget/Slider.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return _lib_Core_widget_Slider_js__WEBPACK_IMPORTED_MODULE_136__["default"]; });

/* harmony import */ var _lib_Core_widget_SlideToggle_js__WEBPACK_IMPORTED_MODULE_137__ = __webpack_require__(/*! ../lib/Core/widget/SlideToggle.js */ "./lib/Core/widget/SlideToggle.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SlideToggle", function() { return _lib_Core_widget_SlideToggle_js__WEBPACK_IMPORTED_MODULE_137__["default"]; });

/* harmony import */ var _lib_Core_widget_Splitter_js__WEBPACK_IMPORTED_MODULE_138__ = __webpack_require__(/*! ../lib/Core/widget/Splitter.js */ "./lib/Core/widget/Splitter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Splitter", function() { return _lib_Core_widget_Splitter_js__WEBPACK_IMPORTED_MODULE_138__["default"]; });

/* harmony import */ var _lib_Core_widget_Tab_js__WEBPACK_IMPORTED_MODULE_139__ = __webpack_require__(/*! ../lib/Core/widget/Tab.js */ "./lib/Core/widget/Tab.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return _lib_Core_widget_Tab_js__WEBPACK_IMPORTED_MODULE_139__["default"]; });

/* harmony import */ var _lib_Core_widget_TabBar_js__WEBPACK_IMPORTED_MODULE_140__ = __webpack_require__(/*! ../lib/Core/widget/TabBar.js */ "./lib/Core/widget/TabBar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabBar", function() { return _lib_Core_widget_TabBar_js__WEBPACK_IMPORTED_MODULE_140__["default"]; });

/* harmony import */ var _lib_Core_widget_TabPanel_js__WEBPACK_IMPORTED_MODULE_141__ = __webpack_require__(/*! ../lib/Core/widget/TabPanel.js */ "./lib/Core/widget/TabPanel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabPanel", function() { return _lib_Core_widget_TabPanel_js__WEBPACK_IMPORTED_MODULE_141__["default"]; });

/* harmony import */ var _lib_Core_widget_TextAreaField_js__WEBPACK_IMPORTED_MODULE_142__ = __webpack_require__(/*! ../lib/Core/widget/TextAreaField.js */ "./lib/Core/widget/TextAreaField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextAreaField", function() { return _lib_Core_widget_TextAreaField_js__WEBPACK_IMPORTED_MODULE_142__["default"]; });

/* harmony import */ var _lib_Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_143__ = __webpack_require__(/*! ../lib/Core/widget/TextField.js */ "./lib/Core/widget/TextField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextField", function() { return _lib_Core_widget_TextField_js__WEBPACK_IMPORTED_MODULE_143__["default"]; });

/* harmony import */ var _lib_Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_144__ = __webpack_require__(/*! ../lib/Core/widget/TimeField.js */ "./lib/Core/widget/TimeField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeField", function() { return _lib_Core_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_144__["default"]; });

/* harmony import */ var _lib_Core_widget_TimePicker_js__WEBPACK_IMPORTED_MODULE_145__ = __webpack_require__(/*! ../lib/Core/widget/TimePicker.js */ "./lib/Core/widget/TimePicker.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimePicker", function() { return _lib_Core_widget_TimePicker_js__WEBPACK_IMPORTED_MODULE_145__["default"]; });

/* harmony import */ var _lib_Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_146__ = __webpack_require__(/*! ../lib/Core/widget/Toast.js */ "./lib/Core/widget/Toast.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toast", function() { return _lib_Core_widget_Toast_js__WEBPACK_IMPORTED_MODULE_146__["default"]; });

/* harmony import */ var _lib_Core_widget_Tool_js__WEBPACK_IMPORTED_MODULE_147__ = __webpack_require__(/*! ../lib/Core/widget/Tool.js */ "./lib/Core/widget/Tool.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tool", function() { return _lib_Core_widget_Tool_js__WEBPACK_IMPORTED_MODULE_147__["default"]; });

/* harmony import */ var _lib_Core_widget_Toolbar_js__WEBPACK_IMPORTED_MODULE_148__ = __webpack_require__(/*! ../lib/Core/widget/Toolbar.js */ "./lib/Core/widget/Toolbar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toolbar", function() { return _lib_Core_widget_Toolbar_js__WEBPACK_IMPORTED_MODULE_148__["default"]; });

/* harmony import */ var _lib_Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_149__ = __webpack_require__(/*! ../lib/Core/widget/Tooltip.js */ "./lib/Core/widget/Tooltip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return _lib_Core_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_149__["default"]; });

/* harmony import */ var _lib_Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_150__ = __webpack_require__(/*! ../lib/Core/widget/Widget.js */ "./lib/Core/widget/Widget.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Widget", function() { return _lib_Core_widget_Widget_js__WEBPACK_IMPORTED_MODULE_150__["default"]; });

/* harmony import */ var _lib_Core_widget_layout_Layout_js__WEBPACK_IMPORTED_MODULE_151__ = __webpack_require__(/*! ../lib/Core/widget/layout/Layout.js */ "./lib/Core/widget/layout/Layout.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Layout", function() { return _lib_Core_widget_layout_Layout_js__WEBPACK_IMPORTED_MODULE_151__["default"]; });

/* harmony import */ var _lib_Core_widget_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_152__ = __webpack_require__(/*! ../lib/Core/widget/mixin/Badge.js */ "./lib/Core/widget/mixin/Badge.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return _lib_Core_widget_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_152__["default"]; });

/* harmony import */ var _lib_Core_widget_mixin_Responsive_js__WEBPACK_IMPORTED_MODULE_153__ = __webpack_require__(/*! ../lib/Core/widget/mixin/Responsive.js */ "./lib/Core/widget/mixin/Responsive.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Responsive", function() { return _lib_Core_widget_mixin_Responsive_js__WEBPACK_IMPORTED_MODULE_153__["default"]; });

/* harmony import */ var _lib_Core_widget_mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_154__ = __webpack_require__(/*! ../lib/Core/widget/mixin/Rotatable.js */ "./lib/Core/widget/mixin/Rotatable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rotatable", function() { return _lib_Core_widget_mixin_Rotatable_js__WEBPACK_IMPORTED_MODULE_154__["default"]; });

/* harmony import */ var _lib_Core_widget_mixin_Styleable_js__WEBPACK_IMPORTED_MODULE_155__ = __webpack_require__(/*! ../lib/Core/widget/mixin/Styleable.js */ "./lib/Core/widget/mixin/Styleable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Styleable", function() { return _lib_Core_widget_mixin_Styleable_js__WEBPACK_IMPORTED_MODULE_155__["default"]; });

/* harmony import */ var _lib_Core_widget_mixin_Toolable_js__WEBPACK_IMPORTED_MODULE_156__ = __webpack_require__(/*! ../lib/Core/widget/mixin/Toolable.js */ "./lib/Core/widget/mixin/Toolable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toolable", function() { return _lib_Core_widget_mixin_Toolable_js__WEBPACK_IMPORTED_MODULE_156__["default"]; });

/* harmony import */ var _lib_Core_widget_graph_Histogram_js__WEBPACK_IMPORTED_MODULE_157__ = __webpack_require__(/*! ../lib/Core/widget/graph/Histogram.js */ "./lib/Core/widget/graph/Histogram.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Histogram", function() { return _lib_Core_widget_graph_Histogram_js__WEBPACK_IMPORTED_MODULE_157__["default"]; });

/* harmony import */ var _lib_Core_widget_graph_Scale_js__WEBPACK_IMPORTED_MODULE_158__ = __webpack_require__(/*! ../lib/Core/widget/graph/Scale.js */ "./lib/Core/widget/graph/Scale.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scale", function() { return _lib_Core_widget_graph_Scale_js__WEBPACK_IMPORTED_MODULE_158__["default"]; });

/* harmony import */ var _lib_Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_159__ = __webpack_require__(/*! ../lib/Core/widget/util/AvatarRendering.js */ "./lib/Core/widget/util/AvatarRendering.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AvatarRendering", function() { return _lib_Core_widget_util_AvatarRendering_js__WEBPACK_IMPORTED_MODULE_159__["default"]; });

/* harmony import */ var _lib_Core_widget_trial_TrialButton_js__WEBPACK_IMPORTED_MODULE_160__ = __webpack_require__(/*! ../lib/Core/widget/trial/TrialButton.js */ "./lib/Core/widget/trial/TrialButton.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TrialButton", function() { return _lib_Core_widget_trial_TrialButton_js__WEBPACK_IMPORTED_MODULE_160__["default"]; });

/* harmony import */ var _lib_Core_widget_trial_TrialPanel_js__WEBPACK_IMPORTED_MODULE_161__ = __webpack_require__(/*! ../lib/Core/widget/trial/TrialPanel.js */ "./lib/Core/widget/trial/TrialPanel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TrialPanel", function() { return _lib_Core_widget_trial_TrialPanel_js__WEBPACK_IMPORTED_MODULE_161__["default"]; });

var productName = 'taskboard';

if (window && !window.bryntum) {
  window.bryntum = {};
} //region Core
// core




 // data





 // data field









 // data mixin













 // data stm






 // feature

 // helper




















 // helper util












 // localization



 // mixin














 // util














 // widget



















































 // widget layout

 // widget mixin





 // widget graph


 // widget util

 // widget trial


 //endregion

/***/ }),

/***/ "./webpack/webpack.core.entry.wc.js":
/*!******************************************!*\
  !*** ./webpack/webpack.core.entry.wc.js ***!
  \******************************************/
/*! exports provided: WidgetTag */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _lib_Core_customElements_WidgetTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../lib/Core/customElements/WidgetTag.js */ "./lib/Core/customElements/WidgetTag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetTag", function() { return _lib_Core_customElements_WidgetTag_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

var productName = 'taskboard'; // region WebComponents

 // endregion

/***/ }),

/***/ "./webpack/webpack.entry.js":
/*!**********************************!*\
  !*** ./webpack/webpack.entry.js ***!
  \**********************************/
/*! exports provided: Base, Config, GlobalEvents, AjaxStore, DomDataStore, Duration, Model, Store, ArrayDataField, BooleanDataField, DataField, DateDataField, IntegerDataField, ModelDataField, NumberDataField, ObjectDataField, StringDataField, StoreChained, StoreCRUD, StoreFilter, StoreGroup, StoreProxy, StoreRelation, StoreSearch, StoreSort, StoreState, StoreSum, StoreSync, StoreTree, TreeNode, ActionBase, ModelStm, StateBase, StateTrackingManager, StoreStm, Transaction, ContextMenuBase, AjaxHelper, ArrayHelper, AsyncHelper, BrowserHelper, CSSHelper, DateHelper, DomHelper, DomSync, DragHelper, EventHelper, FunctionHelper, IdHelper, ObjectHelper, ResizeHelper, ResizeMonitor, StringHelper, TemplateHelper, VersionHelper, WidgetHelper, XMLHelper, DataGenerator, DemoBot, DomClassList, Formatter, Fullscreen, NumberFormat, Objects, Point, Promissory, RandomGenerator, Rectangle, Scroller, LocaleHelper, LocaleManager, Localizable, Delayable, Draggable, Droppable, Events, Factoryable, Featureable, Finalizable, Hoverable, Identifiable, InstancePlugin, LoadMaskable, Override, Pluggable, State, Animator, Bag, ClickRepeater, Collection, CollectionFilter, CollectionSorter, ScrollManager, DragContext, DragProxy, DragTipProxy, DynamicObject, DayTime, Month, Parser, UndoRedoBase, BooleanCombo, Button, ButtonGroup, CalendarPanel, Checkbox, ChipView, Combo, Container, DateField, DatePicker, DateTimeField, DisplayField, DurationField, Editor, Field, FileField, FilePicker, FilterField, Label, List, Mask, Menu, MenuItem, MessageDialog, NumberField, PagingToolbar, Panel, PanelCollapser, PanelCollapserOverlay, CollapseTool, PasswordField, PickerField, Popup, Renderable, Ripple, Slider, SlideToggle, Splitter, Tab, TabBar, TabPanel, TextAreaField, TextField, TimeField, TimePicker, Toast, Tool, Toolbar, Tooltip, Widget, Layout, Badge, Responsive, Rotatable, Styleable, Toolable, Histogram, Scale, AvatarRendering, TrialButton, TrialPanel, GridRowModel, AbstractCrudManager, AbstractCrudManagerMixin, AbstractCrudManagerValidation, AjaxTransport, JsonEncoder, CrudManagerView, AssignmentStore, CrudManager, DependencyStore, EventStore, ResourceStore, ResourceTimeRangeStore, AssignmentModel, DependencyBaseModel, DependencyModel, EventModel, RecurrenceModel, ResourceModel, ResourceTimeRangeModel, SchedulerProjectModel, TimeSpan, AssignmentModelMixin, EventModelMixin, ProjectModelMixin, RecurringTimeSpan, ResourceModelMixin, AssignmentStoreMixin, DependencyStoreMixin, EventStoreMixin, PartOfProject, ProjectCrudManager, RecurringEventsMixin, RecurringTimeSpansMixin, ResourceStoreMixin, SharedEventStoreMixin, SchedulerProjectCombo, ColumnDrag, ColumnHeaderMenu, ColumnToolbars, SimpleTaskEdit, SwimlaneDrag, TaskBoardFeature, TaskDrag, TaskDragSelect, TaskEdit, TaskMenu, TaskTooltip, ColumnModel, ProjectModel, SwimlaneModel, TaskModel, TaskStore, ExpandCollapse, ResponsiveCards, TaskBoardColumns, TaskBoardDom, TaskBoardDomEvents, TaskBoardScroll, TaskBoardStores, TaskBoardSwimlanes, TaskItems, TaskNavigation, TaskSelection, ImageItem, ProgressItem, RatingItem, ResourceAvatarsItem, SeparatorItem, TagsItem, TaskItem, TemplateItem, TextItem, TodoListItem, TaskBoard, TaskBoardBase, ColorBoxCombo, TaskBoardLinked, ColumnCombo, ColumnFilterField, ColumnPickerButton, ColumnScrollButton, ProjectCombo, ResourcesCombo, SwimlaneCombo, SwimlaneFilterField, SwimlanePickerButton, SwimlaneScrollButton, TagCombo, TaskColorCombo, TaskEditor, TaskFilterField, TodoListField, UndoRedo, ZoomSlider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./webpack.core.entry.js */ "./webpack/webpack.core.entry.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Base", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Base"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Config"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GlobalEvents", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["GlobalEvents"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxStore", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["AjaxStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomDataStore", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DomDataStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Duration", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Duration"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Model", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Model"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Store"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ArrayDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["BooleanDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DateDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntegerDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["IntegerDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ModelDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["NumberDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ObjectDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringDataField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StringDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreChained", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreChained"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreCRUD", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreCRUD"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreFilter", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreFilter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreGroup", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreProxy", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreProxy"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreRelation", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreRelation"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSearch", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreSearch"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSort", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreSort"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreState", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreState"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSum", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreSum"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSync", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreSync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreTree", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreTree"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TreeNode", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TreeNode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ActionBase", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ActionBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelStm", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ModelStm"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateBase", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StateBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateTrackingManager", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StateTrackingManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreStm", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreStm"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Transaction", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Transaction"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContextMenuBase", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ContextMenuBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["AjaxHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ArrayHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AsyncHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["AsyncHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BrowserHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["BrowserHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CSSHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["CSSHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DateHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DomHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomSync", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DomSync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DragHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["EventHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FunctionHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["FunctionHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IdHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["IdHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ObjectHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResizeHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeMonitor", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResizeMonitor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["StringHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TemplateHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VersionHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["VersionHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["WidgetHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "XMLHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["XMLHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataGenerator", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DataGenerator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DemoBot", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DemoBot"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomClassList", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DomClassList"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Formatter", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Formatter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Fullscreen", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Fullscreen"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberFormat", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["NumberFormat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Objects", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Objects"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Point", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Point"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Promissory", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Promissory"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RandomGenerator", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["RandomGenerator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rectangle", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Rectangle"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scroller", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Scroller"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleHelper", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["LocaleHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleManager", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["LocaleManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Localizable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Localizable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Delayable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Delayable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Draggable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Draggable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Droppable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Droppable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Events", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Events"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Factoryable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Factoryable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Featureable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Featureable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Finalizable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Finalizable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hoverable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Hoverable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Identifiable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Identifiable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InstancePlugin", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["InstancePlugin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoadMaskable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["LoadMaskable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Override", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Override"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pluggable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Pluggable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "State", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["State"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Animator", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Animator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Bag", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Bag"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ClickRepeater", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ClickRepeater"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Collection", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Collection"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionFilter", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["CollectionFilter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionSorter", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["CollectionSorter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScrollManager", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ScrollManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragContext", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DragContext"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragProxy", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DragProxy"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragTipProxy", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DragTipProxy"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DynamicObject", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DynamicObject"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DayTime", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DayTime"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Month", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Month"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Parser", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Parser"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UndoRedoBase", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["UndoRedoBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanCombo", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["BooleanCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Button"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ButtonGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarPanel", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["CalendarPanel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Checkbox"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChipView", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["ChipView"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Combo", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Combo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Container"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DateField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DatePicker", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DatePicker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateTimeField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DateTimeField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DisplayField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DisplayField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DurationField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["DurationField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Editor", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Editor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Field"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["FileField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilePicker", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["FilePicker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilterField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["FilterField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Label"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "List", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["List"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mask", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Mask"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Menu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["MenuItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MessageDialog", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["MessageDialog"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["NumberField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PagingToolbar", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["PagingToolbar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Panel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelCollapser", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["PanelCollapser"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelCollapserOverlay", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["PanelCollapserOverlay"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollapseTool", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["CollapseTool"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PasswordField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["PasswordField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PickerField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["PickerField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Popup", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Popup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Renderable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Renderable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Ripple"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Slider"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SlideToggle", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["SlideToggle"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Splitter", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Splitter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Tab"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabBar", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TabBar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabPanel", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TabPanel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextAreaField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TextAreaField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TextField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeField", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TimeField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimePicker", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TimePicker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toast", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Toast"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tool", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Tool"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toolbar", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Toolbar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Tooltip"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Widget", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Widget"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Layout", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Layout"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Badge"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Responsive", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Responsive"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rotatable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Rotatable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Styleable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Styleable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toolable", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Toolable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Histogram", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Histogram"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scale", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["Scale"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AvatarRendering", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["AvatarRendering"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TrialButton", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TrialButton"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TrialPanel", function() { return _webpack_core_entry_js__WEBPACK_IMPORTED_MODULE_0__["TrialPanel"]; });

/* harmony import */ var _lib_Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../lib/Grid/data/GridRowModel.js */ "./lib/Grid/data/GridRowModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridRowModel", function() { return _lib_Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../lib/Scheduler/crud/AbstractCrudManager.js */ "./lib/Scheduler/crud/AbstractCrudManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractCrudManager", function() { return _lib_Scheduler_crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../lib/Scheduler/crud/AbstractCrudManagerMixin.js */ "./lib/Scheduler/crud/AbstractCrudManagerMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractCrudManagerMixin", function() { return _lib_Scheduler_crud_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_mixin_AbstractCrudManagerValidation_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../lib/Scheduler/crud/mixin/AbstractCrudManagerValidation.js */ "./lib/Scheduler/crud/mixin/AbstractCrudManagerValidation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractCrudManagerValidation", function() { return _lib_Scheduler_crud_mixin_AbstractCrudManagerValidation_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../lib/Scheduler/crud/transport/AjaxTransport.js */ "./lib/Scheduler/crud/transport/AjaxTransport.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxTransport", function() { return _lib_Scheduler_crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../lib/Scheduler/crud/encoder/JsonEncoder.js */ "./lib/Scheduler/crud/encoder/JsonEncoder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonEncoder", function() { return _lib_Scheduler_crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _lib_Scheduler_crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../lib/Scheduler/crud/mixin/CrudManagerView.js */ "./lib/Scheduler/crud/mixin/CrudManagerView.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CrudManagerView", function() { return _lib_Scheduler_crud_mixin_CrudManagerView_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _lib_Scheduler_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../lib/Scheduler/data/AssignmentStore.js */ "./lib/Scheduler/data/AssignmentStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentStore", function() { return _lib_Scheduler_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _lib_Scheduler_data_CrudManager_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../lib/Scheduler/data/CrudManager.js */ "./lib/Scheduler/data/CrudManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CrudManager", function() { return _lib_Scheduler_data_CrudManager_js__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _lib_Scheduler_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../lib/Scheduler/data/DependencyStore.js */ "./lib/Scheduler/data/DependencyStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyStore", function() { return _lib_Scheduler_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _lib_Scheduler_data_EventStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../lib/Scheduler/data/EventStore.js */ "./lib/Scheduler/data/EventStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventStore", function() { return _lib_Scheduler_data_EventStore_js__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony import */ var _lib_Scheduler_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../lib/Scheduler/data/ResourceStore.js */ "./lib/Scheduler/data/ResourceStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceStore", function() { return _lib_Scheduler_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony import */ var _lib_Scheduler_data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../lib/Scheduler/data/ResourceTimeRangeStore.js */ "./lib/Scheduler/data/ResourceTimeRangeStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRangeStore", function() { return _lib_Scheduler_data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var _lib_Scheduler_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../lib/Scheduler/model/AssignmentModel.js */ "./lib/Scheduler/model/AssignmentModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentModel", function() { return _lib_Scheduler_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_14__["default"]; });

/* harmony import */ var _lib_Scheduler_model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../lib/Scheduler/model/DependencyBaseModel.js */ "./lib/Scheduler/model/DependencyBaseModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyBaseModel", function() { return _lib_Scheduler_model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/* harmony import */ var _lib_Scheduler_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../lib/Scheduler/model/DependencyModel.js */ "./lib/Scheduler/model/DependencyModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyModel", function() { return _lib_Scheduler_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony import */ var _lib_Scheduler_model_EventModel_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../lib/Scheduler/model/EventModel.js */ "./lib/Scheduler/model/EventModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventModel", function() { return _lib_Scheduler_model_EventModel_js__WEBPACK_IMPORTED_MODULE_17__["default"]; });

/* harmony import */ var _lib_Scheduler_model_RecurrenceModel_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../lib/Scheduler/model/RecurrenceModel.js */ "./lib/Scheduler/model/RecurrenceModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceModel", function() { return _lib_Scheduler_model_RecurrenceModel_js__WEBPACK_IMPORTED_MODULE_18__["default"]; });

/* harmony import */ var _lib_Scheduler_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../lib/Scheduler/model/ResourceModel.js */ "./lib/Scheduler/model/ResourceModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceModel", function() { return _lib_Scheduler_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_19__["default"]; });

/* harmony import */ var _lib_Scheduler_model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../lib/Scheduler/model/ResourceTimeRangeModel.js */ "./lib/Scheduler/model/ResourceTimeRangeModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRangeModel", function() { return _lib_Scheduler_model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_20__["default"]; });

/* harmony import */ var _lib_Scheduler_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../lib/Scheduler/model/ProjectModel.js */ "./lib/Scheduler/model/ProjectModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProjectModel", function() { return _lib_Scheduler_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_21__["default"]; });

/* harmony import */ var _lib_Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../lib/Scheduler/model/TimeSpan.js */ "./lib/Scheduler/model/TimeSpan.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeSpan", function() { return _lib_Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_22__["default"]; });

/* harmony import */ var _lib_Scheduler_model_mixin_AssignmentModelMixin_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../lib/Scheduler/model/mixin/AssignmentModelMixin.js */ "./lib/Scheduler/model/mixin/AssignmentModelMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentModelMixin", function() { return _lib_Scheduler_model_mixin_AssignmentModelMixin_js__WEBPACK_IMPORTED_MODULE_23__["default"]; });

/* harmony import */ var _lib_Scheduler_model_mixin_EventModelMixin_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../lib/Scheduler/model/mixin/EventModelMixin.js */ "./lib/Scheduler/model/mixin/EventModelMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventModelMixin", function() { return _lib_Scheduler_model_mixin_EventModelMixin_js__WEBPACK_IMPORTED_MODULE_24__["default"]; });

/* harmony import */ var _lib_Scheduler_model_mixin_ProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../lib/Scheduler/model/mixin/ProjectModelMixin.js */ "./lib/Scheduler/model/mixin/ProjectModelMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectModelMixin", function() { return _lib_Scheduler_model_mixin_ProjectModelMixin_js__WEBPACK_IMPORTED_MODULE_25__["default"]; });

/* harmony import */ var _lib_Scheduler_model_mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../lib/Scheduler/model/mixin/RecurringTimeSpan.js */ "./lib/Scheduler/model/mixin/RecurringTimeSpan.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringTimeSpan", function() { return _lib_Scheduler_model_mixin_RecurringTimeSpan_js__WEBPACK_IMPORTED_MODULE_26__["default"]; });

/* harmony import */ var _lib_Scheduler_model_mixin_ResourceModelMixin_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../lib/Scheduler/model/mixin/ResourceModelMixin.js */ "./lib/Scheduler/model/mixin/ResourceModelMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceModelMixin", function() { return _lib_Scheduler_model_mixin_ResourceModelMixin_js__WEBPACK_IMPORTED_MODULE_27__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_AssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/AssignmentStoreMixin.js */ "./lib/Scheduler/data/mixin/AssignmentStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentStoreMixin", function() { return _lib_Scheduler_data_mixin_AssignmentStoreMixin_js__WEBPACK_IMPORTED_MODULE_28__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_DependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/DependencyStoreMixin.js */ "./lib/Scheduler/data/mixin/DependencyStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyStoreMixin", function() { return _lib_Scheduler_data_mixin_DependencyStoreMixin_js__WEBPACK_IMPORTED_MODULE_29__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/EventStoreMixin.js */ "./lib/Scheduler/data/mixin/EventStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventStoreMixin", function() { return _lib_Scheduler_data_mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_30__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/PartOfProject.js */ "./lib/Scheduler/data/mixin/PartOfProject.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PartOfProject", function() { return _lib_Scheduler_data_mixin_PartOfProject_js__WEBPACK_IMPORTED_MODULE_31__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/ProjectCrudManager.js */ "./lib/Scheduler/data/mixin/ProjectCrudManager.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectCrudManager", function() { return _lib_Scheduler_data_mixin_ProjectCrudManager_js__WEBPACK_IMPORTED_MODULE_32__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/RecurringEventsMixin.js */ "./lib/Scheduler/data/mixin/RecurringEventsMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringEventsMixin", function() { return _lib_Scheduler_data_mixin_RecurringEventsMixin_js__WEBPACK_IMPORTED_MODULE_33__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_RecurringTimeSpansMixin_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js */ "./lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringTimeSpansMixin", function() { return _lib_Scheduler_data_mixin_RecurringTimeSpansMixin_js__WEBPACK_IMPORTED_MODULE_34__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/ResourceStoreMixin.js */ "./lib/Scheduler/data/mixin/ResourceStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceStoreMixin", function() { return _lib_Scheduler_data_mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_35__["default"]; });

/* harmony import */ var _lib_Scheduler_data_mixin_SharedEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../lib/Scheduler/data/mixin/SharedEventStoreMixin.js */ "./lib/Scheduler/data/mixin/SharedEventStoreMixin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SharedEventStoreMixin", function() { return _lib_Scheduler_data_mixin_SharedEventStoreMixin_js__WEBPACK_IMPORTED_MODULE_36__["default"]; });

/* harmony import */ var _lib_Scheduler_widget_ProjectCombo_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../lib/Scheduler/widget/ProjectCombo.js */ "./lib/Scheduler/widget/ProjectCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProjectCombo", function() { return _lib_Scheduler_widget_ProjectCombo_js__WEBPACK_IMPORTED_MODULE_37__["default"]; });

/* harmony import */ var _lib_TaskBoard_feature_ColumnDrag_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../lib/TaskBoard/feature/ColumnDrag.js */ "./lib/TaskBoard/feature/ColumnDrag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnDrag", function() { return _lib_TaskBoard_feature_ColumnDrag_js__WEBPACK_IMPORTED_MODULE_38__["default"]; });

/* harmony import */ var _lib_TaskBoard_feature_ColumnHeaderMenu_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../lib/TaskBoard/feature/ColumnHeaderMenu.js */ "./lib/TaskBoard/feature/ColumnHeaderMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnHeaderMenu", function() { return _lib_TaskBoard_feature_ColumnHeaderMenu_js__WEBPACK_IMPORTED_MODULE_39__["default"]; });

/* harmony import */ var _lib_TaskBoard_feature_ColumnToolbars_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../lib/TaskBoard/feature/ColumnToolbars.js */ "./lib/TaskBoard/feature/ColumnToolbars.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnToolbars", function() { return _lib_TaskBoard_feature_ColumnToolbars_js__WEBPACK_IMPORTED_MODULE_40__["default"]; });

/* harmony import */ var _lib_TaskBoard_feature_SimpleTaskEdit_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../lib/TaskBoard/feature/SimpleTaskEdit.js */ "./lib/TaskBoard/feature/SimpleTaskEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SimpleTaskEdit", function() { return _lib_TaskBoard_feature_SimpleTaskEdit_js__WEBPACK_IMPORTED_MODULE_41__["default"]; });

/* harmony import */ var _lib_TaskBoard_feature_SwimlaneDrag_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../lib/TaskBoard/feature/SwimlaneDrag.js */ "./lib/TaskBoard/feature/SwimlaneDrag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SwimlaneDrag", function() { return _lib_TaskBoard_feature_SwimlaneDrag_js__WEBPACK_IMPORTED_MODULE_42__["default"]; });

/* harmony import */ var _lib_TaskBoard_feature_TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../lib/TaskBoard/feature/TaskBoardFeature.js */ "./lib/TaskBoard/feature/TaskBoardFeature.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardFeature", function() { return _lib_TaskBoard_feature_TaskBoardFeature_js__WEBPACK_IMPORTED_MODULE_43__["default"]; });

/* harmony import */ var _lib_TaskBoard_feature_TaskDrag_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../lib/TaskBoard/feature/TaskDrag.js */ "./lib/TaskBoard/feature/TaskDrag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskDrag", function() { return _lib_TaskBoard_feature_TaskDrag_js__WEBPACK_IMPORTED_MODULE_44__["default"]; });

/* harmony import */ var _lib_TaskBoard_feature_TaskDragSelect_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../lib/TaskBoard/feature/TaskDragSelect.js */ "./lib/TaskBoard/feature/TaskDragSelect.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskDragSelect", function() { return _lib_TaskBoard_feature_TaskDragSelect_js__WEBPACK_IMPORTED_MODULE_45__["default"]; });

/* harmony import */ var _lib_TaskBoard_feature_TaskEdit_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../lib/TaskBoard/feature/TaskEdit.js */ "./lib/TaskBoard/feature/TaskEdit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskEdit", function() { return _lib_TaskBoard_feature_TaskEdit_js__WEBPACK_IMPORTED_MODULE_46__["default"]; });

/* harmony import */ var _lib_TaskBoard_feature_TaskMenu_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../lib/TaskBoard/feature/TaskMenu.js */ "./lib/TaskBoard/feature/TaskMenu.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskMenu", function() { return _lib_TaskBoard_feature_TaskMenu_js__WEBPACK_IMPORTED_MODULE_47__["default"]; });

/* harmony import */ var _lib_TaskBoard_feature_TaskTooltip_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../lib/TaskBoard/feature/TaskTooltip.js */ "./lib/TaskBoard/feature/TaskTooltip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskTooltip", function() { return _lib_TaskBoard_feature_TaskTooltip_js__WEBPACK_IMPORTED_MODULE_48__["default"]; });

/* harmony import */ var _lib_TaskBoard_model_ColumnModel_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../lib/TaskBoard/model/ColumnModel.js */ "./lib/TaskBoard/model/ColumnModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnModel", function() { return _lib_TaskBoard_model_ColumnModel_js__WEBPACK_IMPORTED_MODULE_49__["default"]; });

/* harmony import */ var _lib_TaskBoard_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../lib/TaskBoard/model/ProjectModel.js */ "./lib/TaskBoard/model/ProjectModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectModel", function() { return _lib_TaskBoard_model_ProjectModel_js__WEBPACK_IMPORTED_MODULE_50__["default"]; });

/* harmony import */ var _lib_TaskBoard_model_SwimlaneModel_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../lib/TaskBoard/model/SwimlaneModel.js */ "./lib/TaskBoard/model/SwimlaneModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SwimlaneModel", function() { return _lib_TaskBoard_model_SwimlaneModel_js__WEBPACK_IMPORTED_MODULE_51__["default"]; });

/* harmony import */ var _lib_TaskBoard_model_TaskModel_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../lib/TaskBoard/model/TaskModel.js */ "./lib/TaskBoard/model/TaskModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskModel", function() { return _lib_TaskBoard_model_TaskModel_js__WEBPACK_IMPORTED_MODULE_52__["default"]; });

/* harmony import */ var _lib_TaskBoard_store_TaskStore_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../lib/TaskBoard/store/TaskStore.js */ "./lib/TaskBoard/store/TaskStore.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskStore", function() { return _lib_TaskBoard_store_TaskStore_js__WEBPACK_IMPORTED_MODULE_53__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_mixin_ExpandCollapse_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ../lib/TaskBoard/view/mixin/ExpandCollapse.js */ "./lib/TaskBoard/view/mixin/ExpandCollapse.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpandCollapse", function() { return _lib_TaskBoard_view_mixin_ExpandCollapse_js__WEBPACK_IMPORTED_MODULE_54__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_mixin_ResponsiveCards_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../lib/TaskBoard/view/mixin/ResponsiveCards.js */ "./lib/TaskBoard/view/mixin/ResponsiveCards.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResponsiveCards", function() { return _lib_TaskBoard_view_mixin_ResponsiveCards_js__WEBPACK_IMPORTED_MODULE_55__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_mixin_TaskBoardColumns_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../lib/TaskBoard/view/mixin/TaskBoardColumns.js */ "./lib/TaskBoard/view/mixin/TaskBoardColumns.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardColumns", function() { return _lib_TaskBoard_view_mixin_TaskBoardColumns_js__WEBPACK_IMPORTED_MODULE_56__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_mixin_TaskBoardDom_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../lib/TaskBoard/view/mixin/TaskBoardDom.js */ "./lib/TaskBoard/view/mixin/TaskBoardDom.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardDom", function() { return _lib_TaskBoard_view_mixin_TaskBoardDom_js__WEBPACK_IMPORTED_MODULE_57__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_mixin_TaskBoardDomEvents_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../lib/TaskBoard/view/mixin/TaskBoardDomEvents.js */ "./lib/TaskBoard/view/mixin/TaskBoardDomEvents.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardDomEvents", function() { return _lib_TaskBoard_view_mixin_TaskBoardDomEvents_js__WEBPACK_IMPORTED_MODULE_58__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_mixin_TaskBoardScroll_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../lib/TaskBoard/view/mixin/TaskBoardScroll.js */ "./lib/TaskBoard/view/mixin/TaskBoardScroll.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardScroll", function() { return _lib_TaskBoard_view_mixin_TaskBoardScroll_js__WEBPACK_IMPORTED_MODULE_59__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_mixin_TaskBoardStores_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../lib/TaskBoard/view/mixin/TaskBoardStores.js */ "./lib/TaskBoard/view/mixin/TaskBoardStores.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardStores", function() { return _lib_TaskBoard_view_mixin_TaskBoardStores_js__WEBPACK_IMPORTED_MODULE_60__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_mixin_TaskBoardSwimlanes_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../lib/TaskBoard/view/mixin/TaskBoardSwimlanes.js */ "./lib/TaskBoard/view/mixin/TaskBoardSwimlanes.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardSwimlanes", function() { return _lib_TaskBoard_view_mixin_TaskBoardSwimlanes_js__WEBPACK_IMPORTED_MODULE_61__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_mixin_TaskItems_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../lib/TaskBoard/view/mixin/TaskItems.js */ "./lib/TaskBoard/view/mixin/TaskItems.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskItems", function() { return _lib_TaskBoard_view_mixin_TaskItems_js__WEBPACK_IMPORTED_MODULE_62__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_mixin_TaskNavigation_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../lib/TaskBoard/view/mixin/TaskNavigation.js */ "./lib/TaskBoard/view/mixin/TaskNavigation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskNavigation", function() { return _lib_TaskBoard_view_mixin_TaskNavigation_js__WEBPACK_IMPORTED_MODULE_63__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_mixin_TaskSelection_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../lib/TaskBoard/view/mixin/TaskSelection.js */ "./lib/TaskBoard/view/mixin/TaskSelection.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskSelection", function() { return _lib_TaskBoard_view_mixin_TaskSelection_js__WEBPACK_IMPORTED_MODULE_64__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_item_ImageItem_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../lib/TaskBoard/view/item/ImageItem.js */ "./lib/TaskBoard/view/item/ImageItem.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImageItem", function() { return _lib_TaskBoard_view_item_ImageItem_js__WEBPACK_IMPORTED_MODULE_65__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_item_ProgressItem_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ../lib/TaskBoard/view/item/ProgressItem.js */ "./lib/TaskBoard/view/item/ProgressItem.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProgressItem", function() { return _lib_TaskBoard_view_item_ProgressItem_js__WEBPACK_IMPORTED_MODULE_66__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_item_RatingItem_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ../lib/TaskBoard/view/item/RatingItem.js */ "./lib/TaskBoard/view/item/RatingItem.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingItem", function() { return _lib_TaskBoard_view_item_RatingItem_js__WEBPACK_IMPORTED_MODULE_67__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_item_ResourceAvatarsItem_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ../lib/TaskBoard/view/item/ResourceAvatarsItem.js */ "./lib/TaskBoard/view/item/ResourceAvatarsItem.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceAvatarsItem", function() { return _lib_TaskBoard_view_item_ResourceAvatarsItem_js__WEBPACK_IMPORTED_MODULE_68__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_item_SeparatorItem_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ../lib/TaskBoard/view/item/SeparatorItem.js */ "./lib/TaskBoard/view/item/SeparatorItem.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SeparatorItem", function() { return _lib_TaskBoard_view_item_SeparatorItem_js__WEBPACK_IMPORTED_MODULE_69__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_item_TagsItem_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ../lib/TaskBoard/view/item/TagsItem.js */ "./lib/TaskBoard/view/item/TagsItem.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TagsItem", function() { return _lib_TaskBoard_view_item_TagsItem_js__WEBPACK_IMPORTED_MODULE_70__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_item_TaskItem_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ../lib/TaskBoard/view/item/TaskItem.js */ "./lib/TaskBoard/view/item/TaskItem.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskItem", function() { return _lib_TaskBoard_view_item_TaskItem_js__WEBPACK_IMPORTED_MODULE_71__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_item_TemplateItem_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ../lib/TaskBoard/view/item/TemplateItem.js */ "./lib/TaskBoard/view/item/TemplateItem.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateItem", function() { return _lib_TaskBoard_view_item_TemplateItem_js__WEBPACK_IMPORTED_MODULE_72__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_item_TextItem_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ../lib/TaskBoard/view/item/TextItem.js */ "./lib/TaskBoard/view/item/TextItem.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextItem", function() { return _lib_TaskBoard_view_item_TextItem_js__WEBPACK_IMPORTED_MODULE_73__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_item_TodoListItem_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ../lib/TaskBoard/view/item/TodoListItem.js */ "./lib/TaskBoard/view/item/TodoListItem.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TodoListItem", function() { return _lib_TaskBoard_view_item_TodoListItem_js__WEBPACK_IMPORTED_MODULE_74__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_TaskBoard_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ../lib/TaskBoard/view/TaskBoard.js */ "./lib/TaskBoard/view/TaskBoard.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoard", function() { return _lib_TaskBoard_view_TaskBoard_js__WEBPACK_IMPORTED_MODULE_75__["default"]; });

/* harmony import */ var _lib_TaskBoard_view_TaskBoardBase_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ../lib/TaskBoard/view/TaskBoardBase.js */ "./lib/TaskBoard/view/TaskBoardBase.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardBase", function() { return _lib_TaskBoard_view_TaskBoardBase_js__WEBPACK_IMPORTED_MODULE_76__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_base_ColorBoxCombo_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ../lib/TaskBoard/widget/base/ColorBoxCombo.js */ "./lib/TaskBoard/widget/base/ColorBoxCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColorBoxCombo", function() { return _lib_TaskBoard_widget_base_ColorBoxCombo_js__WEBPACK_IMPORTED_MODULE_77__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ../lib/TaskBoard/widget/mixin/TaskBoardLinked.js */ "./lib/TaskBoard/widget/mixin/TaskBoardLinked.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardLinked", function() { return _lib_TaskBoard_widget_mixin_TaskBoardLinked_js__WEBPACK_IMPORTED_MODULE_78__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_ColumnCombo_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ../lib/TaskBoard/widget/ColumnCombo.js */ "./lib/TaskBoard/widget/ColumnCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnCombo", function() { return _lib_TaskBoard_widget_ColumnCombo_js__WEBPACK_IMPORTED_MODULE_79__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_ColumnFilterField_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ../lib/TaskBoard/widget/ColumnFilterField.js */ "./lib/TaskBoard/widget/ColumnFilterField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnFilterField", function() { return _lib_TaskBoard_widget_ColumnFilterField_js__WEBPACK_IMPORTED_MODULE_80__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_ColumnPickerButton_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ../lib/TaskBoard/widget/ColumnPickerButton.js */ "./lib/TaskBoard/widget/ColumnPickerButton.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnPickerButton", function() { return _lib_TaskBoard_widget_ColumnPickerButton_js__WEBPACK_IMPORTED_MODULE_81__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_ColumnScrollButton_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ../lib/TaskBoard/widget/ColumnScrollButton.js */ "./lib/TaskBoard/widget/ColumnScrollButton.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnScrollButton", function() { return _lib_TaskBoard_widget_ColumnScrollButton_js__WEBPACK_IMPORTED_MODULE_82__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_ProjectCombo_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ../lib/TaskBoard/widget/ProjectCombo.js */ "./lib/TaskBoard/widget/ProjectCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectCombo", function() { return _lib_TaskBoard_widget_ProjectCombo_js__WEBPACK_IMPORTED_MODULE_83__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_ResourcesCombo_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ../lib/TaskBoard/widget/ResourcesCombo.js */ "./lib/TaskBoard/widget/ResourcesCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourcesCombo", function() { return _lib_TaskBoard_widget_ResourcesCombo_js__WEBPACK_IMPORTED_MODULE_84__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_SwimlaneCombo_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ../lib/TaskBoard/widget/SwimlaneCombo.js */ "./lib/TaskBoard/widget/SwimlaneCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SwimlaneCombo", function() { return _lib_TaskBoard_widget_SwimlaneCombo_js__WEBPACK_IMPORTED_MODULE_85__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_SwimlaneFilterField_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ../lib/TaskBoard/widget/SwimlaneFilterField.js */ "./lib/TaskBoard/widget/SwimlaneFilterField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SwimlaneFilterField", function() { return _lib_TaskBoard_widget_SwimlaneFilterField_js__WEBPACK_IMPORTED_MODULE_86__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_SwimlanePickerButton_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ../lib/TaskBoard/widget/SwimlanePickerButton.js */ "./lib/TaskBoard/widget/SwimlanePickerButton.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SwimlanePickerButton", function() { return _lib_TaskBoard_widget_SwimlanePickerButton_js__WEBPACK_IMPORTED_MODULE_87__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_SwimlaneScrollButton_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ../lib/TaskBoard/widget/SwimlaneScrollButton.js */ "./lib/TaskBoard/widget/SwimlaneScrollButton.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SwimlaneScrollButton", function() { return _lib_TaskBoard_widget_SwimlaneScrollButton_js__WEBPACK_IMPORTED_MODULE_88__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_TagCombo_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! ../lib/TaskBoard/widget/TagCombo.js */ "./lib/TaskBoard/widget/TagCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TagCombo", function() { return _lib_TaskBoard_widget_TagCombo_js__WEBPACK_IMPORTED_MODULE_89__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_TaskColorCombo_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(/*! ../lib/TaskBoard/widget/TaskColorCombo.js */ "./lib/TaskBoard/widget/TaskColorCombo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskColorCombo", function() { return _lib_TaskBoard_widget_TaskColorCombo_js__WEBPACK_IMPORTED_MODULE_90__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_TaskEditor_js__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(/*! ../lib/TaskBoard/widget/TaskEditor.js */ "./lib/TaskBoard/widget/TaskEditor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskEditor", function() { return _lib_TaskBoard_widget_TaskEditor_js__WEBPACK_IMPORTED_MODULE_91__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_TaskFilterField_js__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(/*! ../lib/TaskBoard/widget/TaskFilterField.js */ "./lib/TaskBoard/widget/TaskFilterField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskFilterField", function() { return _lib_TaskBoard_widget_TaskFilterField_js__WEBPACK_IMPORTED_MODULE_92__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_TodoListField_js__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(/*! ../lib/TaskBoard/widget/TodoListField.js */ "./lib/TaskBoard/widget/TodoListField.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TodoListField", function() { return _lib_TaskBoard_widget_TodoListField_js__WEBPACK_IMPORTED_MODULE_93__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_UndoRedo_js__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(/*! ../lib/TaskBoard/widget/UndoRedo.js */ "./lib/TaskBoard/widget/UndoRedo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UndoRedo", function() { return _lib_TaskBoard_widget_UndoRedo_js__WEBPACK_IMPORTED_MODULE_94__["default"]; });

/* harmony import */ var _lib_TaskBoard_widget_ZoomSlider_js__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(/*! ../lib/TaskBoard/widget/ZoomSlider.js */ "./lib/TaskBoard/widget/ZoomSlider.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ZoomSlider", function() { return _lib_TaskBoard_widget_ZoomSlider_js__WEBPACK_IMPORTED_MODULE_95__["default"]; });

var productName = 'taskboard'; //region Core
// File is symlinked with "grunt symlink" task

 //endregion
//region Grid

 //endregion
//region Scheduler
// crud





 // crud mixin

 // data






 // model









 // model mixin





 // data mixin









 // widget

 //endregion
//region TaskBoard
// feature











 // model




 // store

 // view/mixins











 // view/items










 // view


 // widget base

 // widget mixin


















 //endregion

/***/ }),

/***/ "./webpack/webpack.entry.umd.js":
/*!**************************************!*\
  !*** ./webpack/webpack.entry.umd.js ***!
  \**************************************/
/*! exports provided: Base, Config, GlobalEvents, AjaxStore, DomDataStore, Duration, Model, Store, ArrayDataField, BooleanDataField, DataField, DateDataField, IntegerDataField, ModelDataField, NumberDataField, ObjectDataField, StringDataField, StoreChained, StoreCRUD, StoreFilter, StoreGroup, StoreProxy, StoreRelation, StoreSearch, StoreSort, StoreState, StoreSum, StoreSync, StoreTree, TreeNode, ActionBase, ModelStm, StateBase, StateTrackingManager, StoreStm, Transaction, ContextMenuBase, AjaxHelper, ArrayHelper, AsyncHelper, BrowserHelper, CSSHelper, DateHelper, DomHelper, DomSync, DragHelper, EventHelper, FunctionHelper, IdHelper, ObjectHelper, ResizeHelper, ResizeMonitor, StringHelper, TemplateHelper, VersionHelper, WidgetHelper, XMLHelper, DataGenerator, DemoBot, DomClassList, Formatter, Fullscreen, NumberFormat, Objects, Point, Promissory, RandomGenerator, Rectangle, Scroller, LocaleHelper, LocaleManager, Localizable, Delayable, Draggable, Droppable, Events, Factoryable, Featureable, Finalizable, Hoverable, Identifiable, InstancePlugin, LoadMaskable, Override, Pluggable, State, Animator, Bag, ClickRepeater, Collection, CollectionFilter, CollectionSorter, ScrollManager, DragContext, DragProxy, DragTipProxy, DynamicObject, DayTime, Month, Parser, UndoRedoBase, BooleanCombo, Button, ButtonGroup, CalendarPanel, Checkbox, ChipView, Combo, Container, DateField, DatePicker, DateTimeField, DisplayField, DurationField, Editor, Field, FileField, FilePicker, FilterField, Label, List, Mask, Menu, MenuItem, MessageDialog, NumberField, PagingToolbar, Panel, PanelCollapser, PanelCollapserOverlay, CollapseTool, PasswordField, PickerField, Popup, Renderable, Ripple, Slider, SlideToggle, Splitter, Tab, TabBar, TabPanel, TextAreaField, TextField, TimeField, TimePicker, Toast, Tool, Toolbar, Tooltip, Widget, Layout, Badge, Responsive, Rotatable, Styleable, Toolable, Histogram, Scale, AvatarRendering, TrialButton, TrialPanel, GridRowModel, AbstractCrudManager, AbstractCrudManagerMixin, AbstractCrudManagerValidation, AjaxTransport, JsonEncoder, CrudManagerView, AssignmentStore, CrudManager, DependencyStore, EventStore, ResourceStore, ResourceTimeRangeStore, AssignmentModel, DependencyBaseModel, DependencyModel, EventModel, RecurrenceModel, ResourceModel, ResourceTimeRangeModel, SchedulerProjectModel, TimeSpan, AssignmentModelMixin, EventModelMixin, ProjectModelMixin, RecurringTimeSpan, ResourceModelMixin, AssignmentStoreMixin, DependencyStoreMixin, EventStoreMixin, PartOfProject, ProjectCrudManager, RecurringEventsMixin, RecurringTimeSpansMixin, ResourceStoreMixin, SharedEventStoreMixin, SchedulerProjectCombo, ColumnDrag, ColumnHeaderMenu, ColumnToolbars, SimpleTaskEdit, SwimlaneDrag, TaskBoardFeature, TaskDrag, TaskDragSelect, TaskEdit, TaskMenu, TaskTooltip, ColumnModel, ProjectModel, SwimlaneModel, TaskModel, TaskStore, ExpandCollapse, ResponsiveCards, TaskBoardColumns, TaskBoardDom, TaskBoardDomEvents, TaskBoardScroll, TaskBoardStores, TaskBoardSwimlanes, TaskItems, TaskNavigation, TaskSelection, ImageItem, ProgressItem, RatingItem, ResourceAvatarsItem, SeparatorItem, TagsItem, TaskItem, TemplateItem, TextItem, TodoListItem, TaskBoard, TaskBoardBase, ColorBoxCombo, TaskBoardLinked, ColumnCombo, ColumnFilterField, ColumnPickerButton, ColumnScrollButton, ProjectCombo, ResourcesCombo, SwimlaneCombo, SwimlaneFilterField, SwimlanePickerButton, SwimlaneScrollButton, TagCombo, TaskColorCombo, TaskEditor, TaskFilterField, TodoListField, UndoRedo, ZoomSlider, WidgetTag, TaskBoardTag */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./webpack.entry.js */ "./webpack/webpack.entry.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Base", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Base"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Config"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GlobalEvents", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["GlobalEvents"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["AjaxStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomDataStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DomDataStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Duration", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Duration"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Model", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Model"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Store"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ArrayDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["BooleanDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DateDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntegerDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["IntegerDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ModelDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["NumberDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ObjectDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringDataField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StringDataField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreChained", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreChained"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreCRUD", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreCRUD"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreFilter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreFilter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreGroup", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreProxy", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreProxy"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreRelation", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreRelation"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSearch", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreSearch"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSort", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreSort"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreState", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreState"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSum", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreSum"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreSync", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreSync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreTree", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreTree"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TreeNode", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TreeNode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ActionBase", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ActionBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelStm", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ModelStm"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateBase", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StateBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateTrackingManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StateTrackingManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StoreStm", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StoreStm"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Transaction", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Transaction"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContextMenuBase", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ContextMenuBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["AjaxHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ArrayHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AsyncHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["AsyncHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BrowserHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["BrowserHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CSSHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["CSSHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DateHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DomHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomSync", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DomSync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DragHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["EventHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FunctionHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["FunctionHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IdHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["IdHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ObjectHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResizeHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResizeMonitor", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResizeMonitor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["StringHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TemplateHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VersionHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["VersionHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["WidgetHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "XMLHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["XMLHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataGenerator", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DataGenerator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DemoBot", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DemoBot"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomClassList", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DomClassList"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Formatter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Formatter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Fullscreen", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Fullscreen"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberFormat", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["NumberFormat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Objects", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Objects"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Point", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Point"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Promissory", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Promissory"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RandomGenerator", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["RandomGenerator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rectangle", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Rectangle"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scroller", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Scroller"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleHelper", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["LocaleHelper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["LocaleManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Localizable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Localizable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Delayable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Delayable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Draggable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Draggable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Droppable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Droppable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Events", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Events"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Factoryable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Factoryable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Featureable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Featureable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Finalizable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Finalizable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hoverable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Hoverable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Identifiable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Identifiable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InstancePlugin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["InstancePlugin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoadMaskable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["LoadMaskable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Override", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Override"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pluggable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Pluggable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "State", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["State"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Animator", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Animator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Bag", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Bag"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ClickRepeater", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ClickRepeater"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Collection", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Collection"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionFilter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["CollectionFilter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollectionSorter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["CollectionSorter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScrollManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ScrollManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragContext", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DragContext"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragProxy", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DragProxy"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragTipProxy", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DragTipProxy"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DynamicObject", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DynamicObject"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DayTime", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DayTime"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Month", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Month"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Parser", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Parser"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UndoRedoBase", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["UndoRedoBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BooleanCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["BooleanCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Button"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ButtonGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarPanel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["CalendarPanel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Checkbox"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChipView", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ChipView"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Combo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Combo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Container"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DateField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DatePicker", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DatePicker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateTimeField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DateTimeField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DisplayField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DisplayField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DurationField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DurationField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Editor", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Editor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Field"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["FileField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilePicker", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["FilePicker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilterField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["FilterField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Label"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "List", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["List"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mask", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Mask"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Menu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["MenuItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MessageDialog", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["MessageDialog"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumberField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["NumberField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PagingToolbar", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["PagingToolbar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Panel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelCollapser", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["PanelCollapser"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelCollapserOverlay", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["PanelCollapserOverlay"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollapseTool", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["CollapseTool"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PasswordField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["PasswordField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PickerField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["PickerField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Popup", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Popup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Renderable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Renderable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Ripple"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Slider"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SlideToggle", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["SlideToggle"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Splitter", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Splitter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Tab"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabBar", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TabBar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabPanel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TabPanel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextAreaField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TextAreaField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TextField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TimeField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimePicker", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TimePicker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toast", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Toast"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tool", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Tool"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toolbar", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Toolbar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Tooltip"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Widget", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Widget"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Layout", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Layout"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Badge"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Responsive", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Responsive"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rotatable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Rotatable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Styleable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Styleable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toolable", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Toolable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Histogram", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Histogram"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scale", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["Scale"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AvatarRendering", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["AvatarRendering"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TrialButton", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TrialButton"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TrialPanel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TrialPanel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridRowModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["GridRowModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractCrudManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["AbstractCrudManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractCrudManagerMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["AbstractCrudManagerMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractCrudManagerValidation", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["AbstractCrudManagerValidation"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AjaxTransport", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["AjaxTransport"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonEncoder", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["JsonEncoder"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CrudManagerView", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["CrudManagerView"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["AssignmentStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CrudManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["CrudManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DependencyStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["EventStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResourceStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRangeStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResourceTimeRangeStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["AssignmentModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyBaseModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DependencyBaseModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DependencyModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["EventModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurrenceModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["RecurrenceModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResourceModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceTimeRangeModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResourceTimeRangeModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProjectModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["SchedulerProjectModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeSpan", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TimeSpan"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentModelMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["AssignmentModelMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventModelMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["EventModelMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectModelMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ProjectModelMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringTimeSpan", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["RecurringTimeSpan"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceModelMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResourceModelMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AssignmentStoreMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["AssignmentStoreMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DependencyStoreMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["DependencyStoreMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventStoreMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["EventStoreMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PartOfProject", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["PartOfProject"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectCrudManager", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ProjectCrudManager"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringEventsMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["RecurringEventsMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RecurringTimeSpansMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["RecurringTimeSpansMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceStoreMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResourceStoreMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SharedEventStoreMixin", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["SharedEventStoreMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SchedulerProjectCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["SchedulerProjectCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnDrag", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ColumnDrag"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnHeaderMenu", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ColumnHeaderMenu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnToolbars", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ColumnToolbars"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SimpleTaskEdit", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["SimpleTaskEdit"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SwimlaneDrag", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["SwimlaneDrag"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardFeature", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskBoardFeature"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskDrag", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskDrag"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskDragSelect", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskDragSelect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskEdit", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskEdit"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskMenu", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskMenu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskTooltip", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskTooltip"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ColumnModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ProjectModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SwimlaneModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["SwimlaneModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskModel", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskModel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskStore", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskStore"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpandCollapse", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ExpandCollapse"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResponsiveCards", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResponsiveCards"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardColumns", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskBoardColumns"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardDom", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskBoardDom"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardDomEvents", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskBoardDomEvents"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardScroll", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskBoardScroll"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardStores", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskBoardStores"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardSwimlanes", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskBoardSwimlanes"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskItems", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskItems"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskNavigation", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskNavigation"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskSelection", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskSelection"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImageItem", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ImageItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProgressItem", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ProgressItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingItem", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["RatingItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourceAvatarsItem", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResourceAvatarsItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SeparatorItem", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["SeparatorItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TagsItem", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TagsItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskItem", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TemplateItem", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TemplateItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextItem", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TextItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TodoListItem", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TodoListItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoard", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskBoard"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardBase", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskBoardBase"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColorBoxCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ColorBoxCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardLinked", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskBoardLinked"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ColumnCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnFilterField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ColumnFilterField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnPickerButton", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ColumnPickerButton"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnScrollButton", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ColumnScrollButton"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProjectCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ProjectCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResourcesCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ResourcesCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SwimlaneCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["SwimlaneCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SwimlaneFilterField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["SwimlaneFilterField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SwimlanePickerButton", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["SwimlanePickerButton"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SwimlaneScrollButton", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["SwimlaneScrollButton"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TagCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TagCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskColorCombo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskColorCombo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskEditor", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskEditor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskFilterField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TaskFilterField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TodoListField", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["TodoListField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UndoRedo", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["UndoRedo"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ZoomSlider", function() { return _webpack_entry_js__WEBPACK_IMPORTED_MODULE_0__["ZoomSlider"]; });

/* harmony import */ var _webpack_entry_wc_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./webpack.entry.wc.js */ "./webpack/webpack.entry.wc.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetTag", function() { return _webpack_entry_wc_js__WEBPACK_IMPORTED_MODULE_1__["WidgetTag"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardTag", function() { return _webpack_entry_wc_js__WEBPACK_IMPORTED_MODULE_1__["TaskBoardTag"]; });

var productName = 'taskboard'; // Export library

 // Export WebComponents

 // UMD inject anchor. Do not edit ot remove this last line.

/***/ }),

/***/ "./webpack/webpack.entry.wc.js":
/*!*************************************!*\
  !*** ./webpack/webpack.entry.wc.js ***!
  \*************************************/
/*! exports provided: WidgetTag, TaskBoardTag */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _webpack_core_entry_wc_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./webpack.core.entry.wc.js */ "./webpack/webpack.core.entry.wc.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WidgetTag", function() { return _webpack_core_entry_wc_js__WEBPACK_IMPORTED_MODULE_0__["WidgetTag"]; });

/* harmony import */ var _lib_TaskBoard_customElements_TaskBoardTag_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../lib/TaskBoard/customElements/TaskBoardTag.js */ "./lib/TaskBoard/customElements/TaskBoardTag.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TaskBoardTag", function() { return _lib_TaskBoard_customElements_TaskBoardTag_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

var productName = 'taskboard'; // File is symlinked with "grunt symlink" task

 // region WebComponents

 // endregion

/***/ })

/******/ });
});
//# sourceMappingURL=taskboard.umd.js.map